const townsFromUK = [
    {
        LOCATION_CODE: 'AB000100',
        LOCATION_NAME: 'Ab Kettleby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9264363,
        LOCATION_LATITUDE_DEG: 52.7997805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB000200',
        LOCATION_NAME: 'Abberd',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9870923,
        LOCATION_LATITUDE_DEG: 51.4424603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB000300',
        LOCATION_NAME: 'Abberley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.365868,
        LOCATION_LATITUDE_DEG: 52.3077455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB000400',
        LOCATION_NAME: 'Abberton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0067574,
        LOCATION_LATITUDE_DEG: 52.1792318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB000500',
        LOCATION_NAME: 'Abberton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9114342,
        LOCATION_LATITUDE_DEG: 51.8338592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB000600',
        LOCATION_NAME: 'Abbess Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2788351,
        LOCATION_LATITUDE_DEG: 51.7777635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001100',
        LOCATION_NAME: 'Abbey Gate',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0036158,
        LOCATION_LATITUDE_DEG: 50.7696133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001200',
        LOCATION_NAME: 'Abbey Hey',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.155981,
        LOCATION_LATITUDE_DEG: 53.4696603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001300',
        LOCATION_NAME: 'Abbey Hulton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1409855,
        LOCATION_LATITUDE_DEG: 53.0351189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001400',
        LOCATION_NAME: 'Abbey Slip',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5337608,
        LOCATION_LATITUDE_DEG: 50.1197747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB991098',
        LOCATION_NAME: 'Abbey St. Bathans',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 2.3877,
        LOCATION_LATITUDE_DEG: 55.8513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001600',
        LOCATION_NAME: 'Abbey Village',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5408764,
        LOCATION_LATITUDE_DEG: 53.6964837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014600',
        LOCATION_NAME: 'Abbey Wood',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1072809,
        LOCATION_LATITUDE_DEG: 51.4892906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001700',
        LOCATION_NAME: 'Abbeycwmhir',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3885923,
        LOCATION_LATITUDE_DEG: 52.330767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001800',
        LOCATION_NAME: 'Abbeydale',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2075999,
        LOCATION_LATITUDE_DEG: 51.8406992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001900',
        LOCATION_NAME: 'Abbeydore',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8950305,
        LOCATION_LATITUDE_DEG: 51.9699226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014800',
        LOCATION_NAME: 'Abbeyhill',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1737639,
        LOCATION_LATITUDE_DEG: 55.9550633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002500',
        LOCATION_NAME: 'Abbeymead',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1959029,
        LOCATION_LATITUDE_DEG: 51.8448016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002800',
        LOCATION_NAME: 'Abbeystead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6701582,
        LOCATION_LATITUDE_DEG: 53.9829163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001500',
        LOCATION_NAME: 'Abbeytown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2886428,
        LOCATION_LATITUDE_DEG: 54.8414414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003100',
        LOCATION_NAME: 'Abbots Bickington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.294388,
        LOCATION_LATITUDE_DEG: 50.8953323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003200',
        LOCATION_NAME: 'Abbots Bromley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8805522,
        LOCATION_LATITUDE_DEG: 52.8183946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003300',
        LOCATION_NAME: 'Abbots Langley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4159736,
        LOCATION_LATITUDE_DEG: 51.7053673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014500',
        LOCATION_NAME: 'Abbots Leigh',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6609185,
        LOCATION_LATITUDE_DEG: 51.4626752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003400',
        LOCATION_NAME: 'Abbots Lench',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9814454,
        LOCATION_LATITUDE_DEG: 52.1640349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003500',
        LOCATION_NAME: 'Abbots Morton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9589303,
        LOCATION_LATITUDE_DEG: 52.1936292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003600',
        LOCATION_NAME: 'Abbots Ripton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1892481,
        LOCATION_LATITUDE_DEG: 52.3849296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003700',
        LOCATION_NAME: 'Abbots Salford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8996398,
        LOCATION_LATITUDE_DEG: 52.1504255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003800',
        LOCATION_NAME: 'Abbots Worthy',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2818276,
        LOCATION_LATITUDE_DEG: 51.0828156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003900',
        LOCATION_NAME: 'Abbotsbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5993039,
        LOCATION_LATITUDE_DEG: 50.6658959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004000',
        LOCATION_NAME: 'Abbotsham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2438503,
        LOCATION_LATITUDE_DEG: 51.0155496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004100',
        LOCATION_NAME: 'Abbotsinch',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4296942,
        LOCATION_LATITUDE_DEG: 55.8642173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004200',
        LOCATION_NAME: 'Abbotskerswell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6120093,
        LOCATION_LATITUDE_DEG: 50.5072918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004300',
        LOCATION_NAME: 'Abbotsley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2045305,
        LOCATION_LATITUDE_DEG: 52.1935077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004400',
        LOCATION_NAME: 'Abbotstone',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.192823,
        LOCATION_LATITUDE_DEG: 51.1087202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004500',
        LOCATION_NAME: 'Abbotts Ann',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5297997,
        LOCATION_LATITUDE_DEG: 51.1894304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004600',
        LOCATION_NAME: 'Abbotts Ann Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5354572,
        LOCATION_LATITUDE_DEG: 51.1747313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004700',
        LOCATION_NAME: 'Abbotts Barton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3054342,
        LOCATION_LATITUDE_DEG: 51.0739199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004800',
        LOCATION_NAME: 'Abcott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8948922,
        LOCATION_LATITUDE_DEG: 52.4016615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB004900',
        LOCATION_NAME: 'Abdon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6271417,
        LOCATION_LATITUDE_DEG: 52.4730669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005000',
        LOCATION_NAME: 'Aber Cywarch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.67622,
        LOCATION_LATITUDE_DEG: 52.7277071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005100',
        LOCATION_NAME: 'Aberaeron',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2580584,
        LOCATION_LATITUDE_DEG: 52.2419639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005200',
        LOCATION_NAME: 'Aberaman',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4297192,
        LOCATION_LATITUDE_DEG: 51.7027064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005300',
        LOCATION_NAME: 'Aberangell',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7040913,
        LOCATION_LATITUDE_DEG: 52.6713992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005400',
        LOCATION_NAME: 'Aberarad',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4604145,
        LOCATION_LATITUDE_DEG: 52.0310834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005500',
        LOCATION_NAME: 'Aberargie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3560747,
        LOCATION_LATITUDE_DEG: 56.3273537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005600',
        LOCATION_NAME: 'Aberarth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2277302,
        LOCATION_LATITUDE_DEG: 52.2509669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005700',
        LOCATION_NAME: 'Aberavon',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8040632,
        LOCATION_LATITUDE_DEG: 51.5970983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005800',
        LOCATION_NAME: 'Aberbechan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2655496,
        LOCATION_LATITUDE_DEG: 52.532483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB005900',
        LOCATION_NAME: 'Aberbeeg',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1447064,
        LOCATION_LATITUDE_DEG: 51.7103975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006000',
        LOCATION_NAME: 'Abercairny',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7485937,
        LOCATION_LATITUDE_DEG: 56.3667582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006100',
        LOCATION_NAME: 'Abercamlais',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5062775,
        LOCATION_LATITUDE_DEG: 51.9496255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006200',
        LOCATION_NAME: 'Abercanaid',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3631649,
        LOCATION_LATITUDE_DEG: 51.7232006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006300',
        LOCATION_NAME: 'Abercarn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1337114,
        LOCATION_LATITUDE_DEG: 51.6480952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006400',
        LOCATION_NAME: 'Abercastle',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.124623,
        LOCATION_LATITUDE_DEG: 51.9585431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006500',
        LOCATION_NAME: 'Abercegir',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7653103,
        LOCATION_LATITUDE_DEG: 52.5996919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006600',
        LOCATION_NAME: 'Aberchalder',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7375708,
        LOCATION_LATITUDE_DEG: 57.091346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006700',
        LOCATION_NAME: 'Aberchirder',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6199226,
        LOCATION_LATITUDE_DEG: 57.5625664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006800',
        LOCATION_NAME: 'Abercrave',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7163207,
        LOCATION_LATITUDE_DEG: 51.8000763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB006900',
        LOCATION_NAME: 'Abercregan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6703405,
        LOCATION_LATITUDE_DEG: 51.6626056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007000',
        LOCATION_NAME: 'Abercrombie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7770965,
        LOCATION_LATITUDE_DEG: 56.2159372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007100',
        LOCATION_NAME: 'Abercwmboi',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.410821,
        LOCATION_LATITUDE_DEG: 51.6898053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007200',
        LOCATION_NAME: 'Abercych',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5516145,
        LOCATION_LATITUDE_DEG: 52.0322454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007300',
        LOCATION_NAME: 'Abercynon',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3287145,
        LOCATION_LATITUDE_DEG: 51.6465002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007400',
        LOCATION_NAME: 'Aberdalgie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4900155,
        LOCATION_LATITUDE_DEG: 56.3655621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007500',
        LOCATION_NAME: 'Aberdare',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4438063,
        LOCATION_LATITUDE_DEG: 51.7133075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007600',
        LOCATION_NAME: 'Aberdaron',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7087311,
        LOCATION_LATITUDE_DEG: 52.8081185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007700',
        LOCATION_NAME: 'Aberdeen',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0994423,
        LOCATION_LATITUDE_DEG: 57.1500214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007800',
        LOCATION_NAME: 'Aberdeen Airport',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2111595,
        LOCATION_LATITUDE_DEG: 57.2039223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB007900',
        LOCATION_NAME: 'Aberdesach',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3470897,
        LOCATION_LATITUDE_DEG: 53.0356444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008000',
        LOCATION_NAME: 'Aberdour',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.29945,
        LOCATION_LATITUDE_DEG: 56.0532209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008100',
        LOCATION_NAME: 'Aberdovey',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0431231,
        LOCATION_LATITUDE_DEG: 52.5436888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008200',
        LOCATION_NAME: 'Aberdulais',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.773649,
        LOCATION_LATITUDE_DEG: 51.6811005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008300',
        LOCATION_NAME: 'Aberedw',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3416738,
        LOCATION_LATITUDE_DEG: 52.1162383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008400',
        LOCATION_NAME: 'Abereiddy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2047159,
        LOCATION_LATITUDE_DEG: 51.9338464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008500',
        LOCATION_NAME: 'Abererch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3850882,
        LOCATION_LATITUDE_DEG: 52.9026279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008600',
        LOCATION_NAME: 'Aberfan',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3446583,
        LOCATION_LATITUDE_DEG: 51.6923979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008700',
        LOCATION_NAME: 'Aberfeldy',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8633602,
        LOCATION_LATITUDE_DEG: 56.6197833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008800',
        LOCATION_NAME: 'Aberffraw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4631021,
        LOCATION_LATITUDE_DEG: 53.1936583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB008900',
        LOCATION_NAME: 'Aberffrwd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9305728,
        LOCATION_LATITUDE_DEG: 52.3913778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009000',
        LOCATION_NAME: 'Aberford',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3414105,
        LOCATION_LATITUDE_DEG: 53.8294836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009100',
        LOCATION_NAME: 'Aberfoyle',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3762413,
        LOCATION_LATITUDE_DEG: 56.1771484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009200',
        LOCATION_NAME: 'Abergarwed',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.716341,
        LOCATION_LATITUDE_DEG: 51.704309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009300',
        LOCATION_NAME: 'Abergavenny',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0196022,
        LOCATION_LATITUDE_DEG: 51.8245126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009400',
        LOCATION_NAME: 'Abergeirw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8504341,
        LOCATION_LATITUDE_DEG: 52.8428187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009500',
        LOCATION_NAME: 'Abergele',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5814622,
        LOCATION_LATITUDE_DEG: 53.2859566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009600',
        LOCATION_NAME: 'Abergorlech',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0597929,
        LOCATION_LATITUDE_DEG: 51.9825373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009700',
        LOCATION_NAME: 'Abergwesyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6744692,
        LOCATION_LATITUDE_DEG: 52.1607473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009800',
        LOCATION_NAME: 'Abergwili',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2704421,
        LOCATION_LATITUDE_DEG: 51.8655244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB009900',
        LOCATION_NAME: 'Abergwynfi',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5998781,
        LOCATION_LATITUDE_DEG: 51.6529029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010000',
        LOCATION_NAME: 'Abergwyngregyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0159941,
        LOCATION_LATITUDE_DEG: 53.2348576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010100',
        LOCATION_NAME: 'Abergynolwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9522694,
        LOCATION_LATITUDE_DEG: 52.6443974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010200',
        LOCATION_NAME: 'Aberhafesp',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3686117,
        LOCATION_LATITUDE_DEG: 52.5219848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010300',
        LOCATION_NAME: 'Aberhosan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7569912,
        LOCATION_LATITUDE_DEG: 52.5611861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010400',
        LOCATION_NAME: 'Aberkenfig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5955618,
        LOCATION_LATITUDE_DEG: 51.5397918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010500',
        LOCATION_NAME: 'Aberlady',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8634463,
        LOCATION_LATITUDE_DEG: 56.0081123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010600',
        LOCATION_NAME: 'Aberlash',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0068651,
        LOCATION_LATITUDE_DEG: 51.794315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010700',
        LOCATION_NAME: 'Aberlemno',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7799458,
        LOCATION_LATITUDE_DEG: 56.6892798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010800',
        LOCATION_NAME: 'Aberllefenni',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8184535,
        LOCATION_LATITUDE_DEG: 52.6732961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB010900',
        LOCATION_NAME: 'Aberlour',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2317979,
        LOCATION_LATITUDE_DEG: 57.4668621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011000',
        LOCATION_NAME: 'Abermagwr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9690023,
        LOCATION_LATITUDE_DEG: 52.3449718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011100',
        LOCATION_NAME: 'Abermeurig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0998649,
        LOCATION_LATITUDE_DEG: 52.1856577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011200',
        LOCATION_NAME: 'Abermule',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2352945,
        LOCATION_LATITUDE_DEG: 52.5424775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011300',
        LOCATION_NAME: 'Abernant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4150101,
        LOCATION_LATITUDE_DEG: 51.8808298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011400',
        LOCATION_NAME: 'Abernethy',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3115379,
        LOCATION_LATITUDE_DEG: 56.3341504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011500',
        LOCATION_NAME: 'Abernyte',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2035128,
        LOCATION_LATITUDE_DEG: 56.467268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011600',
        LOCATION_NAME: 'Aberporth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5383182,
        LOCATION_LATITUDE_DEG: 52.1297554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011700',
        LOCATION_NAME: 'Abersoch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5057805,
        LOCATION_LATITUDE_DEG: 52.8235238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011800',
        LOCATION_NAME: 'Abersychan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0573349,
        LOCATION_LATITUDE_DEG: 51.7235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB011900',
        LOCATION_NAME: 'Aberthaw',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3819182,
        LOCATION_LATITUDE_DEG: 51.3862741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012000',
        LOCATION_NAME: 'Aberthin',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4281173,
        LOCATION_LATITUDE_DEG: 51.4666773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012100',
        LOCATION_NAME: 'Abertillery',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1325591,
        LOCATION_LATITUDE_DEG: 51.7300021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB990169',
        LOCATION_NAME: 'Abertridwr',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.43224,
        LOCATION_LATITUDE_DEG: 52.7610442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012200',
        LOCATION_NAME: 'Abertridwr',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2670697,
        LOCATION_LATITUDE_DEG: 51.5953919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012300',
        LOCATION_NAME: 'Abertysswg',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.25946,
        LOCATION_LATITUDE_DEG: 51.7419027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012400',
        LOCATION_NAME: 'Aberuthven',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6517057,
        LOCATION_LATITUDE_DEG: 56.3185526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012500',
        LOCATION_NAME: 'Aberyscir',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4562878,
        LOCATION_LATITUDE_DEG: 51.9581319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012600',
        LOCATION_NAME: 'Aberystwyth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0825455,
        LOCATION_LATITUDE_DEG: 52.4157752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012700',
        LOCATION_NAME: 'Abingdon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2835329,
        LOCATION_LATITUDE_DEG: 51.6696726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012800',
        LOCATION_NAME: 'Abinger Common',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3943427,
        LOCATION_LATITUDE_DEG: 51.1956173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB012900',
        LOCATION_NAME: 'Abinger Hammer',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4291738,
        LOCATION_LATITUDE_DEG: 51.214824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013000',
        LOCATION_NAME: 'Abington',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6909628,
        LOCATION_LATITUDE_DEG: 55.4919695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013100',
        LOCATION_NAME: 'Abington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8646305,
        LOCATION_LATITUDE_DEG: 52.2483203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013300',
        LOCATION_NAME: 'Abington Pigotts',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.092039,
        LOCATION_LATITUDE_DEG: 52.0829025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013400',
        LOCATION_NAME: 'Abingworth',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4323449,
        LOCATION_LATITUDE_DEG: 50.9404908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013500',
        LOCATION_NAME: 'Ablington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8464021,
        LOCATION_LATITUDE_DEG: 51.7678926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013600',
        LOCATION_NAME: 'ABOYNE',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7795751,
        LOCATION_LATITUDE_DEG: 57.0758172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013700',
        LOCATION_NAME: 'Abram',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5912264,
        LOCATION_LATITUDE_DEG: 53.5092653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013800',
        LOCATION_NAME: 'Abriachan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3997126,
        LOCATION_LATITUDE_DEG: 57.3847671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013900',
        LOCATION_NAME: 'Abridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1194385,
        LOCATION_LATITUDE_DEG: 51.6499524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014000',
        LOCATION_NAME: 'Abronhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9443319,
        LOCATION_LATITUDE_DEG: 55.9595226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014100',
        LOCATION_NAME: 'Abson',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4251746,
        LOCATION_LATITUDE_DEG: 51.4715726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014200',
        LOCATION_NAME: 'Abthorpe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0512265,
        LOCATION_LATITUDE_DEG: 52.1121147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014300',
        LOCATION_NAME: 'Abwell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4574261,
        LOCATION_LATITUDE_DEG: 51.7041935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB014400',
        LOCATION_NAME: 'Aby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1177422,
        LOCATION_LATITUDE_DEG: 53.2835084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000100',
        LOCATION_NAME: 'Acarsaid Mhor',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2930611,
        LOCATION_LATITUDE_DEG: 57.0615678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000200',
        LOCATION_NAME: 'Acaster Malbis',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1052981,
        LOCATION_LATITUDE_DEG: 53.9016848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000300',
        LOCATION_NAME: 'Acaster Selby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1272564,
        LOCATION_LATITUDE_DEG: 53.8654851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000400',
        LOCATION_NAME: 'Accrington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3627574,
        LOCATION_LATITUDE_DEG: 53.7525918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000500',
        LOCATION_NAME: 'Achachork',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.198271,
        LOCATION_LATITUDE_DEG: 57.4334876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000600',
        LOCATION_NAME: 'Achahoish',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5556202,
        LOCATION_LATITUDE_DEG: 55.9398384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000700',
        LOCATION_NAME: 'Achanalt',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9165684,
        LOCATION_LATITUDE_DEG: 57.6105001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000800',
        LOCATION_NAME: 'Achany',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4221041,
        LOCATION_LATITUDE_DEG: 57.9837279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC000900',
        LOCATION_NAME: 'Achaphubil',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.141364,
        LOCATION_LATITUDE_DEG: 56.8324191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001000',
        LOCATION_NAME: 'Acharacle',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8016028,
        LOCATION_LATITUDE_DEG: 56.7487156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001100',
        LOCATION_NAME: 'Acharn',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0259462,
        LOCATION_LATITUDE_DEG: 56.5698799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001200',
        LOCATION_NAME: 'Achateny',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.041136,
        LOCATION_LATITUDE_DEG: 56.756622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001300',
        LOCATION_NAME: 'Achfary',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.914461,
        LOCATION_LATITUDE_DEG: 58.3117661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001400',
        LOCATION_NAME: 'Achgarve',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5624111,
        LOCATION_LATITUDE_DEG: 57.8816339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001700',
        LOCATION_NAME: 'Achiltibuie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3455041,
        LOCATION_LATITUDE_DEG: 58.0231395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001800',
        LOCATION_NAME: 'Achilty',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.62505,
        LOCATION_LATITUDE_DEG: 57.5696919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001900',
        LOCATION_NAME: 'Achintraid',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.597717,
        LOCATION_LATITUDE_DEG: 57.3870785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002000',
        LOCATION_NAME: 'Achlunachan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.062553,
        LOCATION_LATITUDE_DEG: 57.802614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002200',
        LOCATION_NAME: 'Achmore',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5635445,
        LOCATION_LATITUDE_DEG: 57.3424306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002100',
        LOCATION_NAME: 'Achmore',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3473867,
        LOCATION_LATITUDE_DEG: 57.9100274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002300',
        LOCATION_NAME: 'Achnacarry',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9988037,
        LOCATION_LATITUDE_DEG: 56.9448345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002400',
        LOCATION_NAME: 'Achnacloich',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3162071,
        LOCATION_LATITUDE_DEG: 56.4521866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002500',
        LOCATION_NAME: 'Achnagarron',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2097084,
        LOCATION_LATITUDE_DEG: 57.7030013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002600',
        LOCATION_NAME: 'Achnahanaid',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1408232,
        LOCATION_LATITUDE_DEG: 57.3613829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002700',
        LOCATION_NAME: 'Achnairn',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4498951,
        LOCATION_LATITUDE_DEG: 58.0814351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002800',
        LOCATION_NAME: 'Achnamara',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5657613,
        LOCATION_LATITUDE_DEG: 56.0244412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC002900',
        LOCATION_NAME: 'Achnasheen',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0695332,
        LOCATION_LATITUDE_DEG: 57.5811939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003000',
        LOCATION_NAME: 'Achriesgill',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9907401,
        LOCATION_LATITUDE_DEG: 58.4441838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003100',
        LOCATION_NAME: 'Achrimsdale',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8522241,
        LOCATION_LATITUDE_DEG: 58.0342314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003200',
        LOCATION_NAME: 'Achurch',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4947547,
        LOCATION_LATITUDE_DEG: 52.4330333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003300',
        LOCATION_NAME: 'Achuvoldrach',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4555472,
        LOCATION_LATITUDE_DEG: 58.4962798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003400',
        LOCATION_NAME: 'Achvarasdal',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7432057,
        LOCATION_LATITUDE_DEG: 58.5592777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003500',
        LOCATION_NAME: 'Ackenthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7602389,
        LOCATION_LATITUDE_DEG: 54.2291407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003600',
        LOCATION_NAME: 'Ackergill',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1078907,
        LOCATION_LATITUDE_DEG: 58.461361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003800',
        LOCATION_NAME: 'Acklam',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2609656,
        LOCATION_LATITUDE_DEG: 54.5538514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003700',
        LOCATION_NAME: 'Acklam',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.803914,
        LOCATION_LATITUDE_DEG: 54.0449938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC003900',
        LOCATION_NAME: 'Ackleton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.338631,
        LOCATION_LATITUDE_DEG: 52.5863709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004000',
        LOCATION_NAME: 'Acklington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.638944,
        LOCATION_LATITUDE_DEG: 55.310932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004100',
        LOCATION_NAME: 'Ackton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3750906,
        LOCATION_LATITUDE_DEG: 53.6920746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004200',
        LOCATION_NAME: 'Ackworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3330543,
        LOCATION_LATITUDE_DEG: 53.6560702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004300',
        LOCATION_NAME: 'Ackworth Moor Top',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3448411,
        LOCATION_LATITUDE_DEG: 53.6405656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004600',
        LOCATION_NAME: 'Acle',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5495752,
        LOCATION_LATITUDE_DEG: 52.6364249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC007200',
        LOCATION_NAME: 'Acocks Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8228752,
        LOCATION_LATITUDE_DEG: 52.4472188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004700',
        LOCATION_NAME: 'Acol',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3145663,
        LOCATION_LATITUDE_DEG: 51.3564054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004900',
        LOCATION_NAME: 'Acomb',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1073869,
        LOCATION_LATITUDE_DEG: 54.9925056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004800',
        LOCATION_NAME: 'Acomb',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1278701,
        LOCATION_LATITUDE_DEG: 53.9521901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005000',
        LOCATION_NAME: 'Aconbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7127486,
        LOCATION_LATITUDE_DEG: 51.9895195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005100',
        LOCATION_NAME: 'Acre',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3235146,
        LOCATION_LATITUDE_DEG: 53.7203881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005200',
        LOCATION_NAME: 'Acrefair',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0746175,
        LOCATION_LATITUDE_DEG: 52.9801177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005300',
        LOCATION_NAME: 'Acresford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.552509,
        LOCATION_LATITUDE_DEG: 52.7130769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005400',
        LOCATION_NAME: 'Acrise',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1217718,
        LOCATION_LATITUDE_DEG: 51.1367669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005500',
        LOCATION_NAME: 'Acthorpe Top',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0318315,
        LOCATION_LATITUDE_DEG: 53.3757231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005600',
        LOCATION_NAME: 'Acton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0099199,
        LOCATION_LATITUDE_DEG: 52.4581721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005900',
        LOCATION_NAME: 'Acton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5489348,
        LOCATION_LATITUDE_DEG: 53.0734211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005800',
        LOCATION_NAME: 'Acton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2621675,
        LOCATION_LATITUDE_DEG: 52.969114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC007100',
        LOCATION_NAME: 'Acton',
        COUNTY_NAME: 'London',
        POSTCODE: 'W3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2737943,
        LOCATION_LATITUDE_DEG: 51.5110968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005700',
        LOCATION_NAME: 'Acton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7609997,
        LOCATION_LATITUDE_DEG: 52.0707839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006000',
        LOCATION_NAME: 'Acton Beauchamp',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4734791,
        LOCATION_LATITUDE_DEG: 52.1481332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006100',
        LOCATION_NAME: 'Acton Bridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6119877,
        LOCATION_LATITUDE_DEG: 53.2772427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006200',
        LOCATION_NAME: 'Acton Burnell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6929286,
        LOCATION_LATITUDE_DEG: 52.6135811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006300',
        LOCATION_NAME: 'Acton Gate',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1107585,
        LOCATION_LATITUDE_DEG: 52.7744932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006400',
        LOCATION_NAME: 'Acton Hill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0800987,
        LOCATION_LATITUDE_DEG: 52.7736908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006500',
        LOCATION_NAME: 'Acton Pigott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6729532,
        LOCATION_LATITUDE_DEG: 52.6228851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006600',
        LOCATION_NAME: 'Acton Reynald',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6775381,
        LOCATION_LATITUDE_DEG: 52.8019021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006700',
        LOCATION_NAME: 'Acton Round',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5352936,
        LOCATION_LATITUDE_DEG: 52.5566764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006800',
        LOCATION_NAME: 'Acton Scott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8042717,
        LOCATION_LATITUDE_DEG: 52.498969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC006900',
        LOCATION_NAME: 'Acton Trussell',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0955781,
        LOCATION_LATITUDE_DEG: 52.7611914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC007000',
        LOCATION_NAME: 'Acton Turville',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2760774,
        LOCATION_LATITUDE_DEG: 51.5248765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000100',
        LOCATION_NAME: 'Adabrock',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2291974,
        LOCATION_LATITUDE_DEG: 58.4826949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000200',
        LOCATION_NAME: 'Adamsdown',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.163895,
        LOCATION_LATITUDE_DEG: 51.4819811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000500',
        LOCATION_NAME: 'Adbaston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3537027,
        LOCATION_LATITUDE_DEG: 52.8463018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000600',
        LOCATION_NAME: 'Adber',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5721147,
        LOCATION_LATITUDE_DEG: 50.9792271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000700',
        LOCATION_NAME: 'Adbury',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3020314,
        LOCATION_LATITUDE_DEG: 51.362146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000800',
        LOCATION_NAME: 'Adcote',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8634354,
        LOCATION_LATITUDE_DEG: 52.7698028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000900',
        LOCATION_NAME: 'Adderbury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.30912,
        LOCATION_LATITUDE_DEG: 52.0184059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001000',
        LOCATION_NAME: 'Adderley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.503206,
        LOCATION_LATITUDE_DEG: 52.9538097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001100',
        LOCATION_NAME: 'Addiewell',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6115261,
        LOCATION_LATITUDE_DEG: 55.8456035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001200',
        LOCATION_NAME: 'Addingham',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8811545,
        LOCATION_LATITUDE_DEG: 53.9438001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001300',
        LOCATION_NAME: 'Addington',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9114406,
        LOCATION_LATITUDE_DEG: 51.9506949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001400',
        LOCATION_NAME: 'Addington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.375461,
        LOCATION_LATITUDE_DEG: 51.3063172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001500',
        LOCATION_NAME: 'Addiscombe',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0715985,
        LOCATION_LATITUDE_DEG: 51.3760352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001600',
        LOCATION_NAME: 'Addlehole',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7614902,
        LOCATION_LATITUDE_DEG: 50.2904688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001700',
        LOCATION_NAME: 'Addlestone',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4913631,
        LOCATION_LATITUDE_DEG: 51.3702317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001800',
        LOCATION_NAME: 'Addlestonemoor',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5192564,
        LOCATION_LATITUDE_DEG: 51.375435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD001900',
        LOCATION_NAME: 'Addlethorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3187792,
        LOCATION_LATITUDE_DEG: 53.1948025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004900',
        LOCATION_NAME: 'Adel',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5888955,
        LOCATION_LATITUDE_DEG: 53.8512616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002000',
        LOCATION_NAME: 'Adeney',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4420923,
        LOCATION_LATITUDE_DEG: 52.7618896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002100',
        LOCATION_NAME: 'Adfa',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3878481,
        LOCATION_LATITUDE_DEG: 52.5990883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002200',
        LOCATION_NAME: 'Adforton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8781133,
        LOCATION_LATITUDE_DEG: 52.3339559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002300',
        LOCATION_NAME: 'Adgestone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1593857,
        LOCATION_LATITUDE_DEG: 50.6730754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002400',
        LOCATION_NAME: 'Adisham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.193107,
        LOCATION_LATITUDE_DEG: 51.2436995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002500',
        LOCATION_NAME: 'Adlestrop',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6479969,
        LOCATION_LATITUDE_DEG: 51.9421086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002600',
        LOCATION_NAME: 'Adleymoor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9092523,
        LOCATION_LATITUDE_DEG: 52.3643633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002700',
        LOCATION_NAME: 'Adlingfleet',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7212357,
        LOCATION_LATITUDE_DEG: 53.6788597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002800',
        LOCATION_NAME: 'Adlington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6030061,
        LOCATION_LATITUDE_DEG: 53.6123791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD002900',
        LOCATION_NAME: 'Adlington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1278416,
        LOCATION_LATITUDE_DEG: 53.3205469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003100',
        LOCATION_NAME: 'Admaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5420065,
        LOCATION_LATITUDE_DEG: 52.7133928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003000',
        LOCATION_NAME: 'Admaston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.925257,
        LOCATION_LATITUDE_DEG: 52.8059883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003200',
        LOCATION_NAME: 'Admington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.704208,
        LOCATION_LATITUDE_DEG: 52.1155248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003300',
        LOCATION_NAME: 'Adpar',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3797924,
        LOCATION_LATITUDE_DEG: 53.0129361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003500',
        LOCATION_NAME: 'Adsborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0303949,
        LOCATION_LATITUDE_DEG: 51.0557395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003600',
        LOCATION_NAME: 'Adsborough Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0332036,
        LOCATION_LATITUDE_DEG: 51.051137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003700',
        LOCATION_NAME: 'Adsdean',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8684073,
        LOCATION_LATITUDE_DEG: 50.8766925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003800',
        LOCATION_NAME: 'Adsett',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.403139,
        LOCATION_LATITUDE_DEG: 51.8278995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003900',
        LOCATION_NAME: 'Adstock',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9285917,
        LOCATION_LATITUDE_DEG: 51.9643945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004000',
        LOCATION_NAME: 'Adstone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1299342,
        LOCATION_LATITUDE_DEG: 52.1585169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004100',
        LOCATION_NAME: 'Advent',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6647712,
        LOCATION_LATITUDE_DEG: 50.6012116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004200',
        LOCATION_NAME: 'Adversane',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4691341,
        LOCATION_LATITUDE_DEG: 50.9983965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004300',
        LOCATION_NAME: 'Advie',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'PH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4513165,
        LOCATION_LATITUDE_DEG: 57.3936629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004400',
        LOCATION_NAME: 'Adwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.99458,
        LOCATION_LATITUDE_DEG: 51.6892716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004700',
        LOCATION_NAME: 'Adwick le Street',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004800',
        LOCATION_NAME: 'Adwick upon Dearne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004500',
        LOCATION_NAME: 'Adwick-le-Street',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1938691,
        LOCATION_LATITUDE_DEG: 53.5627744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD004600',
        LOCATION_NAME: 'Adwick-upon-Dearne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2973891,
        LOCATION_LATITUDE_DEG: 53.5037452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AE000100',
        LOCATION_NAME: 'Ae',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5978312,
        LOCATION_LATITUDE_DEG: 55.1864437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AF000100',
        LOCATION_NAME: 'Affetside',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.370406,
        LOCATION_LATITUDE_DEG: 53.6184759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AF000200',
        LOCATION_NAME: 'Affleck',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2278329,
        LOCATION_LATITUDE_DEG: 57.3012344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AF000300',
        LOCATION_NAME: 'Affpuddle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2750378,
        LOCATION_LATITUDE_DEG: 50.7401954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AF000400',
        LOCATION_NAME: 'Afonwen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3156362,
        LOCATION_LATITUDE_DEG: 52.9135256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AF000500',
        LOCATION_NAME: 'Afonwen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3033326,
        LOCATION_LATITUDE_DEG: 53.2300555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000100',
        LOCATION_NAME: 'Agbrigg',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4738626,
        LOCATION_LATITUDE_DEG: 53.6672712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000150',
        LOCATION_NAME: 'Agden',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7289874,
        LOCATION_LATITUDE_DEG: 52.992521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000200',
        LOCATION_NAME: 'Aggborough',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2351863,
        LOCATION_LATITUDE_DEG: 52.3801517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000300',
        LOCATION_NAME: 'Agglethorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8663085,
        LOCATION_LATITUDE_DEG: 54.2736285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000800',
        LOCATION_NAME: 'Aghadowey',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6656611,
        LOCATION_LATITUDE_DEG: 55.0166524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000900',
        LOCATION_NAME: 'Aghadulla',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.414272,
        LOCATION_LATITUDE_DEG: 54.5504345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001000',
        LOCATION_NAME: 'Aghagallon',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2989302,
        LOCATION_LATITUDE_DEG: 54.4999044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001150',
        LOCATION_NAME: 'Aghalane',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4803683,
        LOCATION_LATITUDE_DEG: 54.1210238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001200',
        LOCATION_NAME: 'Aghaleag',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3917356,
        LOCATION_LATITUDE_DEG: 54.6112374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001300',
        LOCATION_NAME: 'Aghalee',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2679221,
        LOCATION_LATITUDE_DEG: 54.5249075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001700',
        LOCATION_NAME: 'Aghanloo',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9322805,
        LOCATION_LATITUDE_DEG: 55.0999695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG990957',
        LOCATION_NAME: 'Aghnablaney',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002800',
        LOCATION_NAME: 'Aghnamoyle',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3412824,
        LOCATION_LATITUDE_DEG: 54.6099968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002850',
        LOCATION_NAME: 'Aghyaran',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7425259,
        LOCATION_LATITUDE_DEG: 54.6731913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG003000',
        LOCATION_NAME: 'Aglionby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8562221,
        LOCATION_LATITUDE_DEG: 54.9003017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG003300',
        LOCATION_NAME: 'Agneash',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.410792,
        LOCATION_LATITUDE_DEG: 54.2447668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000700',
        LOCATION_NAME: 'Ahmor',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2565513,
        LOCATION_LATITUDE_DEG: 57.6292245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000800',
        LOCATION_NAME: 'Ahoghill',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3666236,
        LOCATION_LATITUDE_DEG: 54.8514367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000051',
        LOCATION_NAME: 'Aigas',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.564912,
        LOCATION_LATITUDE_DEG: 57.4394965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000100',
        LOCATION_NAME: 'Aigburth',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9187118,
        LOCATION_LATITUDE_DEG: 53.3672605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000200',
        LOCATION_NAME: 'Aignish',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2783295,
        LOCATION_LATITUDE_DEG: 58.2095717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000300',
        LOCATION_NAME: 'Aike',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4035539,
        LOCATION_LATITUDE_DEG: 53.8982786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000400',
        LOCATION_NAME: 'Aiketgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8051206,
        LOCATION_LATITUDE_DEG: 54.8067921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000500',
        LOCATION_NAME: 'Aikshaw',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3631087,
        LOCATION_LATITUDE_DEG: 54.8037041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000600',
        LOCATION_NAME: 'Aikton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1304447,
        LOCATION_LATITUDE_DEG: 54.8705028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000700',
        LOCATION_NAME: 'Ailby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1563171,
        LOCATION_LATITUDE_DEG: 53.2701117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000900',
        LOCATION_NAME: 'Ailsa Hospital',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5907505,
        LOCATION_LATITUDE_DEG: 55.4342754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001000',
        LOCATION_NAME: 'Ailsworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3513053,
        LOCATION_LATITUDE_DEG: 52.5754495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001100',
        LOCATION_NAME: 'Ainderby Miers',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6053764,
        LOCATION_LATITUDE_DEG: 54.3297373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001200',
        LOCATION_NAME: 'Ainderby Quernhow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4670991,
        LOCATION_LATITUDE_DEG: 54.2229268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001300',
        LOCATION_NAME: 'Ainderby Steeple',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4865441,
        LOCATION_LATITUDE_DEG: 54.3234298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001400',
        LOCATION_NAME: 'Aingers Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0752594,
        LOCATION_LATITUDE_DEG: 51.8418567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001500',
        LOCATION_NAME: 'Ainley Top',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8268978,
        LOCATION_LATITUDE_DEG: 53.6707739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001600',
        LOCATION_NAME: 'Ainsdale',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'PR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0390519,
        LOCATION_LATITUDE_DEG: 53.6017824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001700',
        LOCATION_NAME: 'Ainstable',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7297842,
        LOCATION_LATITUDE_DEG: 54.8087964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001800',
        LOCATION_NAME: 'Ainsworth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3564644,
        LOCATION_LATITUDE_DEG: 53.5877746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI001900',
        LOCATION_NAME: 'Ainthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9114045,
        LOCATION_LATITUDE_DEG: 54.4633398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002000',
        LOCATION_NAME: 'Aintree',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9394776,
        LOCATION_LATITUDE_DEG: 53.4809653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002100',
        LOCATION_NAME: 'Aird',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1587585,
        LOCATION_LATITUDE_DEG: 58.243871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002200',
        LOCATION_NAME: 'Airdrie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9723524,
        LOCATION_LATITUDE_DEG: 55.8665114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002300',
        LOCATION_NAME: 'Airds Bay',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2496068,
        LOCATION_LATITUDE_DEG: 56.4386834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002400',
        LOCATION_NAME: 'Airidhantuim',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4500345,
        LOCATION_LATITUDE_DEG: 58.4086889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002500',
        LOCATION_NAME: 'Airlie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1032174,
        LOCATION_LATITUDE_DEG: 56.6431761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002600',
        LOCATION_NAME: 'Airmyn',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.901232,
        LOCATION_LATITUDE_DEG: 53.7187625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002700',
        LOCATION_NAME: 'Airntully',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4634394,
        LOCATION_LATITUDE_DEG: 56.5025686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002800',
        LOCATION_NAME: 'Airth',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7702882,
        LOCATION_LATITUDE_DEG: 56.0693289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI002900',
        LOCATION_NAME: 'Airton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1493326,
        LOCATION_LATITUDE_DEG: 54.0287097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003000',
        LOCATION_NAME: 'Aisby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6862939,
        LOCATION_LATITUDE_DEG: 53.4257345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003100',
        LOCATION_NAME: 'Aisby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4933736,
        LOCATION_LATITUDE_DEG: 52.937188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003200',
        LOCATION_NAME: 'Aisgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3380717,
        LOCATION_LATITUDE_DEG: 54.3799465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI990357',
        LOCATION_NAME: 'Aish',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003300',
        LOCATION_NAME: 'Aish',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.841387,
        LOCATION_LATITUDE_DEG: 50.4293834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003400',
        LOCATION_NAME: 'Aisholt',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1487085,
        LOCATION_LATITUDE_DEG: 51.1162422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003500',
        LOCATION_NAME: 'Aiskew',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5829578,
        LOCATION_LATITUDE_DEG: 54.2913267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003700',
        LOCATION_NAME: 'Aislaby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3853042,
        LOCATION_LATITUDE_DEG: 54.5036475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003600',
        LOCATION_NAME: 'Aislaby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8105889,
        LOCATION_LATITUDE_DEG: 54.2613195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003800',
        LOCATION_NAME: 'Aislaby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6726384,
        LOCATION_LATITUDE_DEG: 54.4662386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI003900',
        LOCATION_NAME: 'Aisthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5755307,
        LOCATION_LATITUDE_DEG: 53.3089193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI004000',
        LOCATION_NAME: 'Aith',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3741894,
        LOCATION_LATITUDE_DEG: 60.2839235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AK000100',
        LOCATION_NAME: 'Akebar',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7094597,
        LOCATION_LATITUDE_DEG: 54.3103305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AK000200',
        LOCATION_NAME: 'Akeld',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0681343,
        LOCATION_LATITUDE_DEG: 55.5611655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AK000300',
        LOCATION_NAME: 'Akeley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9678863,
        LOCATION_LATITUDE_DEG: 52.0332023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AK000400',
        LOCATION_NAME: 'Akenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1362359,
        LOCATION_LATITUDE_DEG: 52.0952814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000100',
        LOCATION_NAME: 'Albaston',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2294097,
        LOCATION_LATITUDE_DEG: 50.5105951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000200',
        LOCATION_NAME: 'Alberbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9509193,
        LOCATION_LATITUDE_DEG: 52.7224979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000300',
        LOCATION_NAME: 'Albert Village',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5460025,
        LOCATION_LATITUDE_DEG: 52.7579787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL025400',
        LOCATION_NAME: 'Albertbridge',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8962277,
        LOCATION_LATITUDE_DEG: 54.6022966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000400',
        LOCATION_NAME: 'Albourne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2015123,
        LOCATION_LATITUDE_DEG: 50.9364886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000500',
        LOCATION_NAME: 'Albrightlee',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.716502,
        LOCATION_LATITUDE_DEG: 52.744591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000600',
        LOCATION_NAME: 'Albrighton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7457357,
        LOCATION_LATITUDE_DEG: 52.7603965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000650',
        LOCATION_NAME: 'Albrighton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2714367,
        LOCATION_LATITUDE_DEG: 52.6366319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000700',
        LOCATION_NAME: 'Alburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3362588,
        LOCATION_LATITUDE_DEG: 52.4361077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000800',
        LOCATION_NAME: 'Albury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0497922,
        LOCATION_LATITUDE_DEG: 51.7389739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001000',
        LOCATION_NAME: 'Albury',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4985504,
        LOCATION_LATITUDE_DEG: 51.2193233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL000900',
        LOCATION_NAME: 'Albury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0816646,
        LOCATION_LATITUDE_DEG: 51.9013753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL990368',
        LOCATION_NAME: 'Alby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001100',
        LOCATION_NAME: 'Alby Hill',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2578985,
        LOCATION_LATITUDE_DEG: 52.8600507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001200',
        LOCATION_NAME: 'Alcaig',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.395305,
        LOCATION_LATITUDE_DEG: 57.5837854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001300',
        LOCATION_NAME: 'Alcaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7998941,
        LOCATION_LATITUDE_DEG: 52.4793708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001400',
        LOCATION_NAME: 'Alcester',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8668168,
        LOCATION_LATITUDE_DEG: 52.2167321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL025700',
        LOCATION_NAME: 'Alcester Lanes End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8917441,
        LOCATION_LATITUDE_DEG: 52.4221538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001500',
        LOCATION_NAME: 'Alciston',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1401461,
        LOCATION_LATITUDE_DEG: 50.8311801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001600',
        LOCATION_NAME: 'Alcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.465708,
        LOCATION_LATITUDE_DEG: 51.1964561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001700',
        LOCATION_NAME: 'Alconbury',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2582718,
        LOCATION_LATITUDE_DEG: 52.3682255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001800',
        LOCATION_NAME: 'Alconbury Weston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2672156,
        LOCATION_LATITUDE_DEG: 52.3769266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL001900',
        LOCATION_NAME: 'Aldbar',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6968862,
        LOCATION_LATITUDE_DEG: 56.7104825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002000',
        LOCATION_NAME: 'Aldborough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3807553,
        LOCATION_LATITUDE_DEG: 54.0925114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002100',
        LOCATION_NAME: 'Aldborough',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.244309,
        LOCATION_LATITUDE_DEG: 52.8621501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002200',
        LOCATION_NAME: 'Aldbourne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6196076,
        LOCATION_LATITUDE_DEG: 51.4783629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002300',
        LOCATION_NAME: 'Aldbrough',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1087523,
        LOCATION_LATITUDE_DEG: 53.8293636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024800',
        LOCATION_NAME: 'Aldbrough St John',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.689237,
        LOCATION_LATITUDE_DEG: 54.496964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002400',
        LOCATION_NAME: 'Aldbrough St. John',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6925907,
        LOCATION_LATITUDE_DEG: 54.4986443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002500',
        LOCATION_NAME: 'Aldburgh',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6463694,
        LOCATION_LATITUDE_DEG: 54.2104001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002600',
        LOCATION_NAME: 'Aldbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6004281,
        LOCATION_LATITUDE_DEG: 51.8020795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002700',
        LOCATION_NAME: 'Aldcliffe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8150217,
        LOCATION_LATITUDE_DEG: 54.0348225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002800',
        LOCATION_NAME: 'Aldclune',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8004874,
        LOCATION_LATITUDE_DEG: 56.7517953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL002900',
        LOCATION_NAME: 'Aldeburgh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6020441,
        LOCATION_LATITUDE_DEG: 52.1543803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003000',
        LOCATION_NAME: 'Aldeby',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6079437,
        LOCATION_LATITUDE_DEG: 52.4836156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003100',
        LOCATION_NAME: 'Aldenham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3537086,
        LOCATION_LATITUDE_DEG: 51.6705623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003200',
        LOCATION_NAME: 'Alder Forest',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3755344,
        LOCATION_LATITUDE_DEG: 53.4960598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003300',
        LOCATION_NAME: 'Alderbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7354483,
        LOCATION_LATITUDE_DEG: 51.0443246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003400',
        LOCATION_NAME: 'Alderford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1477626,
        LOCATION_LATITUDE_DEG: 52.7236415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003500',
        LOCATION_NAME: 'Aldergrove',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2090686,
        LOCATION_LATITUDE_DEG: 54.6491908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003600',
        LOCATION_NAME: 'Alderholt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8363226,
        LOCATION_LATITUDE_DEG: 50.9111115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003700',
        LOCATION_NAME: 'Alderley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3334219,
        LOCATION_LATITUDE_DEG: 51.6153802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003800',
        LOCATION_NAME: 'Alderley Edge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2240369,
        LOCATION_LATITUDE_DEG: 53.3009422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL003900',
        LOCATION_NAME: 'Aldermans Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4720308,
        LOCATION_LATITUDE_DEG: 52.4490502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004000',
        LOCATION_NAME: 'Aldermaston',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1517971,
        LOCATION_LATITUDE_DEG: 51.3834481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004100',
        LOCATION_NAME: 'Aldermaston Wharf',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1348253,
        LOCATION_LATITUDE_DEG: 51.4001498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004200',
        LOCATION_NAME: 'Alderminster',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6636137,
        LOCATION_LATITUDE_DEG: 52.1356201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004300',
        LOCATION_NAME: 'Aldern Bridge',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2975227,
        LOCATION_LATITUDE_DEG: 51.3648439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004400',
        LOCATION_NAME: 'Alderney',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.201977,
        LOCATION_LATITUDE_DEG: 49.7220172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004500',
        LOCATION_NAME: 'Aldershot',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7646974,
        LOCATION_LATITUDE_DEG: 51.2464299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004600',
        LOCATION_NAME: 'Aldersley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1511328,
        LOCATION_LATITUDE_DEG: 52.60893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004900',
        LOCATION_NAME: 'Alderton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7489777,
        LOCATION_LATITUDE_DEG: 52.8094026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005000',
        LOCATION_NAME: 'Alderton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2324622,
        LOCATION_LATITUDE_DEG: 51.5432707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005100',
        LOCATION_NAME: 'Alderton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0010342,
        LOCATION_LATITUDE_DEG: 51.9965136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004700',
        LOCATION_NAME: 'Alderton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9178103,
        LOCATION_LATITUDE_DEG: 52.1151109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL004800',
        LOCATION_NAME: 'Alderton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4147422,
        LOCATION_LATITUDE_DEG: 52.0242695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005200',
        LOCATION_NAME: 'Alderwasley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5271442,
        LOCATION_LATITUDE_DEG: 53.0782159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005300',
        LOCATION_NAME: 'Aldfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5926955,
        LOCATION_LATITUDE_DEG: 54.1202105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005400',
        LOCATION_NAME: 'Aldford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8685573,
        LOCATION_LATITUDE_DEG: 53.1283366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL025600',
        LOCATION_NAME: 'Aldgate',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0750171,
        LOCATION_LATITUDE_DEG: 51.5122654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005500',
        LOCATION_NAME: 'Aldham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7959152,
        LOCATION_LATITUDE_DEG: 51.9020718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005600',
        LOCATION_NAME: 'Aldham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.993033,
        LOCATION_LATITUDE_DEG: 52.0691811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005700',
        LOCATION_NAME: 'Aldingbourne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6878429,
        LOCATION_LATITUDE_DEG: 50.840688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005800',
        LOCATION_NAME: 'Aldingham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0971562,
        LOCATION_LATITUDE_DEG: 54.1297334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006000',
        LOCATION_NAME: 'Aldington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9062761,
        LOCATION_LATITUDE_DEG: 52.0946204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL005900',
        LOCATION_NAME: 'Aldington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9463106,
        LOCATION_LATITUDE_DEG: 51.09119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006100',
        LOCATION_NAME: 'Aldochlay',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6391645,
        LOCATION_LATITUDE_DEG: 56.0884468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006200',
        LOCATION_NAME: 'Aldon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8295896,
        LOCATION_LATITUDE_DEG: 52.4100682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006300',
        LOCATION_NAME: 'Aldoth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3333639,
        LOCATION_LATITUDE_DEG: 54.8256065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006400',
        LOCATION_NAME: 'Aldreth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1204187,
        LOCATION_LATITUDE_DEG: 52.3373237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006500',
        LOCATION_NAME: 'Aldridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9164127,
        LOCATION_LATITUDE_DEG: 52.6056703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006600',
        LOCATION_NAME: 'Aldringham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5778805,
        LOCATION_LATITUDE_DEG: 52.1927821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006700',
        LOCATION_NAME: 'Aldrington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1913686,
        LOCATION_LATITUDE_DEG: 50.8309809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006800',
        LOCATION_NAME: 'Aldsworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7728182,
        LOCATION_LATITUDE_DEG: 51.7885901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL006900',
        LOCATION_NAME: 'Aldsworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9086097,
        LOCATION_LATITUDE_DEG: 50.8729921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007000',
        LOCATION_NAME: 'Aldwark',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2877842,
        LOCATION_LATITUDE_DEG: 54.0657048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007100',
        LOCATION_NAME: 'Aldwarke',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3404539,
        LOCATION_LATITUDE_DEG: 53.4483445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007300',
        LOCATION_NAME: 'Aldwick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7234637,
        LOCATION_LATITUDE_DEG: 51.344662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007200',
        LOCATION_NAME: 'Aldwick',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7265867,
        LOCATION_LATITUDE_DEG: 50.7782851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007400',
        LOCATION_NAME: 'Aldwincle',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5217987,
        LOCATION_LATITUDE_DEG: 52.4254347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007500',
        LOCATION_NAME: 'Aldworth',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1992876,
        LOCATION_LATITUDE_DEG: 51.5089618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007600',
        LOCATION_NAME: 'Alexandra Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2489233,
        LOCATION_LATITUDE_DEG: 53.451344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007700',
        LOCATION_NAME: 'Alexandria',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5895994,
        LOCATION_LATITUDE_DEG: 55.9924321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007800',
        LOCATION_NAME: 'Aley Green',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.453853,
        LOCATION_LATITUDE_DEG: 51.8554859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL007900',
        LOCATION_NAME: 'Alfington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2551553,
        LOCATION_LATITUDE_DEG: 50.774013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008000',
        LOCATION_NAME: 'Alfold',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5171395,
        LOCATION_LATITUDE_DEG: 51.0953127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008100',
        LOCATION_NAME: 'Alfold Crossways',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5134964,
        LOCATION_LATITUDE_DEG: 51.1078127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008300',
        LOCATION_NAME: 'Alford',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7023425,
        LOCATION_LATITUDE_DEG: 57.2332304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008200',
        LOCATION_NAME: 'Alford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5610054,
        LOCATION_LATITUDE_DEG: 51.088136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008400',
        LOCATION_NAME: 'Alford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1771721,
        LOCATION_LATITUDE_DEG: 53.2599047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008500',
        LOCATION_NAME: 'Alfreton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3826674,
        LOCATION_LATITUDE_DEG: 53.0973147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008600',
        LOCATION_NAME: 'Alfrick',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3668266,
        LOCATION_LATITUDE_DEG: 52.1751371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008700',
        LOCATION_NAME: 'Alfrick Pound',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3735431,
        LOCATION_LATITUDE_DEG: 52.1668348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008800',
        LOCATION_NAME: 'Alfriston',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1582367,
        LOCATION_LATITUDE_DEG: 50.8070734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL008900',
        LOCATION_NAME: 'Algarkirk',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0796693,
        LOCATION_LATITUDE_DEG: 52.8988781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009000',
        LOCATION_NAME: 'Alhampton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5316935,
        LOCATION_LATITUDE_DEG: 51.1109359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009100',
        LOCATION_NAME: 'Alkborough',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6646717,
        LOCATION_LATITUDE_DEG: 53.682962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009200',
        LOCATION_NAME: 'Alkerton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4489307,
        LOCATION_LATITUDE_DEG: 52.0823189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009300',
        LOCATION_NAME: 'Alkham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.225682,
        LOCATION_LATITUDE_DEG: 51.1352938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009500',
        LOCATION_NAME: 'Alkington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7023641,
        LOCATION_LATITUDE_DEG: 52.944016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009400',
        LOCATION_NAME: 'Alkington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.430923,
        LOCATION_LATITUDE_DEG: 51.6748889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009600',
        LOCATION_NAME: 'Alkmonton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7222406,
        LOCATION_LATITUDE_DEG: 52.9436001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009700',
        LOCATION_NAME: 'All Cannings',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8935158,
        LOCATION_LATITUDE_DEG: 51.3554536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009800',
        LOCATION_NAME: 'All Saints',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9823003,
        LOCATION_LATITUDE_DEG: 50.8069125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL009900',
        LOCATION_NAME: 'All Saints South Elmham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4394665,
        LOCATION_LATITUDE_DEG: 52.3916076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010000',
        LOCATION_NAME: 'All Stretton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7959525,
        LOCATION_LATITUDE_DEG: 52.5546805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010100',
        LOCATION_NAME: 'Allaleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6711491,
        LOCATION_LATITUDE_DEG: 50.3708781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010200',
        LOCATION_NAME: 'Allandale',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9367648,
        LOCATION_LATITUDE_DEG: 55.9841243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010300',
        LOCATION_NAME: 'Allanfearn',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1486074,
        LOCATION_LATITUDE_DEG: 57.5001762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010500',
        LOCATION_NAME: 'Allanton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.832926,
        LOCATION_LATITUDE_DEG: 55.8003068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010400',
        LOCATION_NAME: 'Allanton',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2154045,
        LOCATION_LATITUDE_DEG: 55.7834857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010600',
        LOCATION_NAME: 'Allasdale',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5004673,
        LOCATION_LATITUDE_DEG: 57.0004639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010700',
        LOCATION_NAME: 'Allastone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5157314,
        LOCATION_LATITUDE_DEG: 51.7443991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010900',
        LOCATION_NAME: 'Allendale',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2648008,
        LOCATION_LATITUDE_DEG: 54.8961004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011000',
        LOCATION_NAME: 'Allendale Cottages',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8191594,
        LOCATION_LATITUDE_DEG: 54.8920932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011100',
        LOCATION_NAME: 'Allendale Town',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2518946,
        LOCATION_LATITUDE_DEG: 54.8969996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011200',
        LOCATION_NAME: 'Allenheads',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2165999,
        LOCATION_LATITUDE_DEG: 54.8030857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011300',
        LOCATION_NAME: 'Allens Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1113429,
        LOCATION_LATITUDE_DEG: 51.8304731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011400',
        LOCATION_NAME: 'Allensford',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8789236,
        LOCATION_LATITUDE_DEG: 54.8457923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011500',
        LOCATION_NAME: 'Allensmore',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7765022,
        LOCATION_LATITUDE_DEG: 52.0200217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011600',
        LOCATION_NAME: 'Allenton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4480899,
        LOCATION_LATITUDE_DEG: 52.889096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011700',
        LOCATION_NAME: 'Allenwood',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.795866,
        LOCATION_LATITUDE_DEG: 54.8948071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011900',
        LOCATION_NAME: 'Aller',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8554743,
        LOCATION_LATITUDE_DEG: 51.0589314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012000',
        LOCATION_NAME: 'Allerby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4154505,
        LOCATION_LATITUDE_DEG: 54.7430979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL025300',
        LOCATION_NAME: 'Allerdene',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5936197,
        LOCATION_LATITUDE_DEG: 54.9225548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012100',
        LOCATION_NAME: 'Allerford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5697584,
        LOCATION_LATITUDE_DEG: 51.2120593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012200',
        LOCATION_NAME: 'Allerston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6513645,
        LOCATION_LATITUDE_DEG: 54.2311119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012300',
        LOCATION_NAME: 'Allerthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8075949,
        LOCATION_LATITUDE_DEG: 53.9157816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012500',
        LOCATION_NAME: 'Allerton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8900972,
        LOCATION_LATITUDE_DEG: 53.3645556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012400',
        LOCATION_NAME: 'Allerton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8237865,
        LOCATION_LATITUDE_DEG: 53.803188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012600',
        LOCATION_NAME: 'Allerton Bywater',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3611004,
        LOCATION_LATITUDE_DEG: 53.7457748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012700',
        LOCATION_NAME: 'Allerton Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.37509,
        LOCATION_LATITUDE_DEG: 54.0187021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012800',
        LOCATION_NAME: 'Allerwash',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2016097,
        LOCATION_LATITUDE_DEG: 54.9982097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL012900',
        LOCATION_NAME: 'Allesley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5631108,
        LOCATION_LATITUDE_DEG: 52.4233474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013000',
        LOCATION_NAME: 'Allestree',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4908547,
        LOCATION_LATITUDE_DEG: 52.9524988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013100',
        LOCATION_NAME: 'Allet',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0990188,
        LOCATION_LATITUDE_DEG: 50.2966846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013200',
        LOCATION_NAME: 'Allexton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7903494,
        LOCATION_LATITUDE_DEG: 52.5972571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013300',
        LOCATION_NAME: 'Allgreave',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0399732,
        LOCATION_LATITUDE_DEG: 53.199228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013400',
        LOCATION_NAME: 'Allhallows',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6430884,
        LOCATION_LATITUDE_DEG: 51.4678287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024900',
        LOCATION_NAME: 'Allhallows On Sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013500',
        LOCATION_NAME: 'Allhallows-On-Sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6503287,
        LOCATION_LATITUDE_DEG: 51.4732329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013600',
        LOCATION_NAME: 'Alligin Shuas',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6262719,
        LOCATION_LATITUDE_DEG: 57.5577032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013900',
        LOCATION_NAME: 'Allington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1533102,
        LOCATION_LATITUDE_DEG: 51.4727647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014100',
        LOCATION_NAME: 'Allington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.901373,
        LOCATION_LATITUDE_DEG: 51.3684549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014200',
        LOCATION_NAME: 'Allington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7074951,
        LOCATION_LATITUDE_DEG: 51.1516272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014000',
        LOCATION_NAME: 'Allington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7244227,
        LOCATION_LATITUDE_DEG: 52.9520937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013800',
        LOCATION_NAME: 'Allington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5098368,
        LOCATION_LATITUDE_DEG: 51.2945182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014300',
        LOCATION_NAME: 'Allithwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9397425,
        LOCATION_LATITUDE_DEG: 54.1819331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014400',
        LOCATION_NAME: 'Alloa',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7939819,
        LOCATION_LATITUDE_DEG: 56.1162329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014500',
        LOCATION_NAME: 'Alloa Park',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7759161,
        LOCATION_LATITUDE_DEG: 56.1113354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014600',
        LOCATION_NAME: 'Allonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.428825,
        LOCATION_LATITUDE_DEG: 54.7717042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014700',
        LOCATION_NAME: 'Allostock',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.381609,
        LOCATION_LATITUDE_DEG: 53.2369389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014800',
        LOCATION_NAME: 'Alloway',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6291657,
        LOCATION_LATITUDE_DEG: 55.430381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL014900',
        LOCATION_NAME: 'Allowenshay',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8665911,
        LOCATION_LATITUDE_DEG: 50.9158257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015000',
        LOCATION_NAME: 'Allscott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5717784,
        LOCATION_LATITUDE_DEG: 52.7133879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL025000',
        LOCATION_NAME: 'Allt Yr Yn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015200',
        LOCATION_NAME: 'Alltami',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0966597,
        LOCATION_LATITUDE_DEG: 53.182042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015300',
        LOCATION_NAME: 'Alltwalis',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2626422,
        LOCATION_LATITUDE_DEG: 51.9621394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015400',
        LOCATION_NAME: 'Alltwen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.844354,
        LOCATION_LATITUDE_DEG: 51.7143117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015500',
        LOCATION_NAME: 'Alltyblaca',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1550746,
        LOCATION_LATITUDE_DEG: 52.0901444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015600',
        LOCATION_NAME: 'Alltyblacca',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1550919,
        LOCATION_LATITUDE_DEG: 52.0895955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015100',
        LOCATION_NAME: 'Allt-Yr-Yn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0061661,
        LOCATION_LATITUDE_DEG: 51.5903914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015700',
        LOCATION_NAME: 'Almeley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9749661,
        LOCATION_LATITUDE_DEG: 52.1592431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015800',
        LOCATION_NAME: 'Almer',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1221878,
        LOCATION_LATITUDE_DEG: 50.7883019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL015900',
        LOCATION_NAME: 'Almholme',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1088448,
        LOCATION_LATITUDE_DEG: 53.5669537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016000',
        LOCATION_NAME: 'Almington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4430298,
        LOCATION_LATITUDE_DEG: 52.9067058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016100',
        LOCATION_NAME: 'Almodington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8263064,
        LOCATION_LATITUDE_DEG: 50.7739798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016200',
        LOCATION_NAME: 'Almondbank',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5150797,
        LOCATION_LATITUDE_DEG: 56.4157618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016300',
        LOCATION_NAME: 'Almondbury',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7446644,
        LOCATION_LATITUDE_DEG: 53.6313707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016400',
        LOCATION_NAME: 'Almondsbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5719047,
        LOCATION_LATITUDE_DEG: 51.5523767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016500',
        LOCATION_NAME: 'Alne',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2424606,
        LOCATION_LATITUDE_DEG: 54.0824078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016600',
        LOCATION_NAME: 'Alness',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2661854,
        LOCATION_LATITUDE_DEG: 57.6939957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016700',
        LOCATION_NAME: 'Alnham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0064575,
        LOCATION_LATITUDE_DEG: 55.3920401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016800',
        LOCATION_NAME: 'Alnmouth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6112629,
        LOCATION_LATITUDE_DEG: 55.3895352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL016900',
        LOCATION_NAME: 'Alnwick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.707335,
        LOCATION_LATITUDE_DEG: 55.4124403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017000',
        LOCATION_NAME: 'Alphamstone',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7358959,
        LOCATION_LATITUDE_DEG: 51.985781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017100',
        LOCATION_NAME: 'Alpheton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7506777,
        LOCATION_LATITUDE_DEG: 52.1226877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017200',
        LOCATION_NAME: 'Alphington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5324004,
        LOCATION_LATITUDE_DEG: 50.6991047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017300',
        LOCATION_NAME: 'Alpington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3877149,
        LOCATION_LATITUDE_DEG: 52.5610237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017400',
        LOCATION_NAME: 'Alport',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6687274,
        LOCATION_LATITUDE_DEG: 53.1782232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017500',
        LOCATION_NAME: 'Alpraham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6176512,
        LOCATION_LATITUDE_DEG: 53.1310352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017700',
        LOCATION_NAME: 'Alresford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1603064,
        LOCATION_LATITUDE_DEG: 51.0993181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017600',
        LOCATION_NAME: 'Alresford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0050703,
        LOCATION_LATITUDE_DEG: 51.8550598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017800',
        LOCATION_NAME: 'Alrewas',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7484666,
        LOCATION_LATITUDE_DEG: 52.7324809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL017900',
        LOCATION_NAME: 'Alsager',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3032925,
        LOCATION_LATITUDE_DEG: 53.095823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018000',
        LOCATION_NAME: 'Alsagers Bank',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2899528,
        LOCATION_LATITUDE_DEG: 53.0310193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL025100',
        LOCATION_NAME: 'Alsop en le Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018100',
        LOCATION_NAME: 'Alsop-en-le-Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7597377,
        LOCATION_LATITUDE_DEG: 53.0926136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL990693',
        LOCATION_NAME: 'Alston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018200',
        LOCATION_NAME: 'Alston',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2775251,
        LOCATION_LATITUDE_DEG: 50.5536057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018300',
        LOCATION_NAME: 'Alston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9835212,
        LOCATION_LATITUDE_DEG: 50.8184143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018400',
        LOCATION_NAME: 'Alston',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4399299,
        LOCATION_LATITUDE_DEG: 54.812395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018500',
        LOCATION_NAME: 'Alston Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7244781,
        LOCATION_LATITUDE_DEG: 50.5284906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018600',
        LOCATION_NAME: 'Alston Sutton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8371754,
        LOCATION_LATITUDE_DEG: 51.2586508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018700',
        LOCATION_NAME: 'Alstone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0241637,
        LOCATION_LATITUDE_DEG: 51.9917185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018800',
        LOCATION_NAME: 'Alstone Fields',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0337837,
        LOCATION_LATITUDE_DEG: 52.0010136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL018900',
        LOCATION_NAME: 'Alstonefield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8041911,
        LOCATION_LATITUDE_DEG: 53.0972171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019000',
        LOCATION_NAME: 'Alswear',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8170223,
        LOCATION_LATITUDE_DEG: 50.9843389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019300',
        LOCATION_NAME: 'Altamount',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3333479,
        LOCATION_LATITUDE_DEG: 56.5843761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019400',
        LOCATION_NAME: 'Altamuskin',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0823092,
        LOCATION_LATITUDE_DEG: 54.5166086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019500',
        LOCATION_NAME: 'Altandhu',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4081546,
        LOCATION_LATITUDE_DEG: 58.054747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019600',
        LOCATION_NAME: 'Altarnun',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5101076,
        LOCATION_LATITUDE_DEG: 50.6022111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019700',
        LOCATION_NAME: 'Altens',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0816893,
        LOCATION_LATITUDE_DEG: 57.1124178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019800',
        LOCATION_NAME: 'Altham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3501972,
        LOCATION_LATITUDE_DEG: 53.790689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019900',
        LOCATION_NAME: 'Altham West',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3697453,
        LOCATION_LATITUDE_DEG: 53.7641933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020000',
        LOCATION_NAME: 'Althorne',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7625555,
        LOCATION_LATITUDE_DEG: 51.6571477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020100',
        LOCATION_NAME: 'Althorp',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9989602,
        LOCATION_LATITUDE_DEG: 52.2786329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020200',
        LOCATION_NAME: 'Althorpe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7391079,
        LOCATION_LATITUDE_DEG: 53.5772474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020300',
        LOCATION_NAME: 'Altnabreac',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7052925,
        LOCATION_LATITUDE_DEG: 58.3867636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020400',
        LOCATION_NAME: 'Altnagelvin',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2554261,
        LOCATION_LATITUDE_DEG: 54.9856555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020500',
        LOCATION_NAME: 'Altnaharra',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4389119,
        LOCATION_LATITUDE_DEG: 58.2809604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020600',
        LOCATION_NAME: 'Altnamachin',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6322724,
        LOCATION_LATITUDE_DEG: 54.1665678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020800',
        LOCATION_NAME: 'Altofts',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4363519,
        LOCATION_LATITUDE_DEG: 53.707076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020900',
        LOCATION_NAME: 'Alton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8922562,
        LOCATION_LATITUDE_DEG: 52.9762049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021000',
        LOCATION_NAME: 'Alton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4576061,
        LOCATION_LATITUDE_DEG: 53.1741228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021100',
        LOCATION_NAME: 'Alton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9737487,
        LOCATION_LATITUDE_DEG: 51.1503238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021200',
        LOCATION_NAME: 'Alton Barnes',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8490156,
        LOCATION_LATITUDE_DEG: 51.3569514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021300',
        LOCATION_NAME: 'Alton Pancras',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4253527,
        LOCATION_LATITUDE_DEG: 50.8188074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021400',
        LOCATION_NAME: 'Alton Priors',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8411788,
        LOCATION_LATITUDE_DEG: 51.3595489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021500',
        LOCATION_NAME: 'Altrincham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3701859,
        LOCATION_LATITUDE_DEG: 53.3994563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021600',
        LOCATION_NAME: 'Altvaid',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5107725,
        LOCATION_LATITUDE_DEG: 57.3917893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021700',
        LOCATION_NAME: 'Alum Bay',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5642437,
        LOCATION_LATITUDE_DEG: 50.6672787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021800',
        LOCATION_NAME: 'Alum Rock',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8178647,
        LOCATION_LATITUDE_DEG: 52.4882553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL021900',
        LOCATION_NAME: 'Alva',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7992394,
        LOCATION_LATITUDE_DEG: 56.15304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022000',
        LOCATION_NAME: 'Alvah',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5396164,
        LOCATION_LATITUDE_DEG: 57.6314709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022100',
        LOCATION_NAME: 'Alvanley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7543853,
        LOCATION_LATITUDE_DEG: 53.2618451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022200',
        LOCATION_NAME: 'Alvaston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.49879,
        LOCATION_LATITUDE_DEG: 53.0861293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022300',
        LOCATION_NAME: 'Alvaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4253258,
        LOCATION_LATITUDE_DEG: 52.8985899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022400',
        LOCATION_NAME: 'Alvechurch',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9618395,
        LOCATION_LATITUDE_DEG: 52.3500522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022500',
        LOCATION_NAME: 'Alvecote',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6296197,
        LOCATION_LATITUDE_DEG: 52.6367685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022600',
        LOCATION_NAME: 'Alvediston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0333293,
        LOCATION_LATITUDE_DEG: 51.0096176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022700',
        LOCATION_NAME: 'Alveley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3529878,
        LOCATION_LATITUDE_DEG: 52.4568588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022800',
        LOCATION_NAME: 'Alverdiscott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1053033,
        LOCATION_LATITUDE_DEG: 51.0057437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL022900',
        LOCATION_NAME: 'Alverley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1587324,
        LOCATION_LATITUDE_DEG: 53.4858502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023000',
        LOCATION_NAME: 'Alverstoke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1415382,
        LOCATION_LATITUDE_DEG: 50.785486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023100',
        LOCATION_NAME: 'Alverstone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.187511,
        LOCATION_LATITUDE_DEG: 50.6655761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023200',
        LOCATION_NAME: 'Alverstone Garden Village',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1803315,
        LOCATION_LATITUDE_DEG: 50.6674775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023300',
        LOCATION_NAME: 'Alverthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5248835,
        LOCATION_LATITUDE_DEG: 53.6892745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023500',
        LOCATION_NAME: 'Alverton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5507654,
        LOCATION_LATITUDE_DEG: 50.1184725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023400',
        LOCATION_NAME: 'Alverton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8177258,
        LOCATION_LATITUDE_DEG: 52.9719931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023600',
        LOCATION_NAME: 'Alves',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4474351,
        LOCATION_LATITUDE_DEG: 57.6426844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023700',
        LOCATION_NAME: 'Alvescot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6066387,
        LOCATION_LATITUDE_DEG: 51.7382811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023900',
        LOCATION_NAME: 'Alveston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5303622,
        LOCATION_LATITUDE_DEG: 51.5883799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL023800',
        LOCATION_NAME: 'Alveston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6611471,
        LOCATION_LATITUDE_DEG: 52.2026268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024000',
        LOCATION_NAME: 'Alvie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8782298,
        LOCATION_LATITUDE_DEG: 57.1606399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024100',
        LOCATION_NAME: 'Alvingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0497501,
        LOCATION_LATITUDE_DEG: 53.4010268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024200',
        LOCATION_NAME: 'Alvington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5740705,
        LOCATION_LATITUDE_DEG: 51.7047965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024300',
        LOCATION_NAME: 'Alwalton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3282088,
        LOCATION_LATITUDE_DEG: 52.5478442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024400',
        LOCATION_NAME: 'Alway',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9440802,
        LOCATION_LATITUDE_DEG: 51.5851879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024500',
        LOCATION_NAME: 'Alweston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4799554,
        LOCATION_LATITUDE_DEG: 50.9253218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024600',
        LOCATION_NAME: 'Alwinton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1219086,
        LOCATION_LATITUDE_DEG: 55.3476392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL025200',
        LOCATION_NAME: 'Alwoodley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5391973,
        LOCATION_LATITUDE_DEG: 53.8608791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL024700',
        LOCATION_NAME: 'Alyth',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2283008,
        LOCATION_LATITUDE_DEG: 56.6219757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000100',
        LOCATION_NAME: 'Amalveor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5265618,
        LOCATION_LATITUDE_DEG: 50.1818795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000200',
        LOCATION_NAME: 'Ambaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3643991,
        LOCATION_LATITUDE_DEG: 52.8903949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000300',
        LOCATION_NAME: 'Amber Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1633133,
        LOCATION_LATITUDE_DEG: 53.0066882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000400',
        LOCATION_NAME: 'Ambergate',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.479928,
        LOCATION_LATITUDE_DEG: 53.0604071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000500',
        LOCATION_NAME: 'Amberley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2167709,
        LOCATION_LATITUDE_DEG: 51.7098926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000600',
        LOCATION_NAME: 'Amberley',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5324493,
        LOCATION_LATITUDE_DEG: 50.9078935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000650',
        LOCATION_NAME: 'Ambersham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6955773,
        LOCATION_LATITUDE_DEG: 50.977329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000700',
        LOCATION_NAME: 'Amberstone',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2665111,
        LOCATION_LATITUDE_DEG: 50.8765831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000800',
        LOCATION_NAME: 'Amble',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5839486,
        LOCATION_LATITUDE_DEG: 55.3325321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM000900',
        LOCATION_NAME: 'Amblecote',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1502024,
        LOCATION_LATITUDE_DEG: 52.466362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001000',
        LOCATION_NAME: 'Ambleside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9608949,
        LOCATION_LATITUDE_DEG: 54.4282621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001100',
        LOCATION_NAME: 'Ambleston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9048266,
        LOCATION_LATITUDE_DEG: 51.8942331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001200',
        LOCATION_NAME: 'Ambrosden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1195953,
        LOCATION_LATITUDE_DEG: 51.8705891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001300',
        LOCATION_NAME: 'Amcotts',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7058136,
        LOCATION_LATITUDE_DEG: 53.6168524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001400',
        LOCATION_NAME: 'Amersham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6060835,
        LOCATION_LATITUDE_DEG: 51.6764639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001500',
        LOCATION_NAME: 'Amerton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0082266,
        LOCATION_LATITUDE_DEG: 52.8459922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001600',
        LOCATION_NAME: 'Amesbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7775681,
        LOCATION_LATITUDE_DEG: 51.1710356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001700',
        LOCATION_NAME: 'Amhuinnsuidh',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0001005,
        LOCATION_LATITUDE_DEG: 57.9657476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001800',
        LOCATION_NAME: 'Amington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6483902,
        LOCATION_LATITUDE_DEG: 52.6328698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001900',
        LOCATION_NAME: 'Amisfield',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5663094,
        LOCATION_LATITUDE_DEG: 55.1293375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002000',
        LOCATION_NAME: 'Amlwch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3472967,
        LOCATION_LATITUDE_DEG: 53.4091775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002100',
        LOCATION_NAME: 'Amlwch Port',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3310909,
        LOCATION_LATITUDE_DEG: 53.4116801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002200',
        LOCATION_NAME: 'Ammanford',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9869551,
        LOCATION_LATITUDE_DEG: 51.7924139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002300',
        LOCATION_NAME: 'Amotherby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8521085,
        LOCATION_LATITUDE_DEG: 54.1512115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002400',
        LOCATION_NAME: 'Ampfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4215055,
        LOCATION_LATITUDE_DEG: 51.0088109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002500',
        LOCATION_NAME: 'Ampleforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1062531,
        LOCATION_LATITUDE_DEG: 54.200818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002600',
        LOCATION_NAME: 'Ampleforth College',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0854982,
        LOCATION_LATITUDE_DEG: 54.2020195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002700',
        LOCATION_NAME: 'Ampney Crucis',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9039676,
        LOCATION_LATITUDE_DEG: 51.713785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002800',
        LOCATION_NAME: 'Ampney Knowle',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8768651,
        LOCATION_LATITUDE_DEG: 51.7364919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003700',
        LOCATION_NAME: 'Ampney St Mary',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003800',
        LOCATION_NAME: 'Ampney St Peter',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM002900',
        LOCATION_NAME: 'Ampney St. Mary',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8746307,
        LOCATION_LATITUDE_DEG: 51.7169856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003000',
        LOCATION_NAME: 'Ampney St. Peter',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8822314,
        LOCATION_LATITUDE_DEG: 51.7112834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003100',
        LOCATION_NAME: 'Amport',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.57075,
        LOCATION_LATITUDE_DEG: 51.1964315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003200',
        LOCATION_NAME: 'Ampthill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4936492,
        LOCATION_LATITUDE_DEG: 52.0268971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003300',
        LOCATION_NAME: 'Ampton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7384819,
        LOCATION_LATITUDE_DEG: 52.3081125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003400',
        LOCATION_NAME: 'Amroth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6592683,
        LOCATION_LATITUDE_DEG: 51.7316149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003500',
        LOCATION_NAME: 'Amulree',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7868119,
        LOCATION_LATITUDE_DEG: 56.5106761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM003600',
        LOCATION_NAME: 'Amwell Hill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0172845,
        LOCATION_LATITUDE_DEG: 51.7962717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000100',
        LOCATION_NAME: 'An Cnoc',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2653361,
        LOCATION_LATITUDE_DEG: 58.2046738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000600',
        LOCATION_NAME: 'Ancaster',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5343786,
        LOCATION_LATITUDE_DEG: 52.9823866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000700',
        LOCATION_NAME: 'Anchor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1028666,
        LOCATION_LATITUDE_DEG: 52.4290728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000800',
        LOCATION_NAME: 'Anchorage Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0488962,
        LOCATION_LATITUDE_DEG: 50.8237916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009900',
        LOCATION_NAME: 'Ancoats',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN010000',
        LOCATION_NAME: 'Ancoats',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009700',
        LOCATION_NAME: 'Ancoats',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009600',
        LOCATION_NAME: 'Ancoats',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2306979,
        LOCATION_LATITUDE_DEG: 53.4841384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000900',
        LOCATION_NAME: 'Ancroft',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9996658,
        LOCATION_LATITUDE_DEG: 55.6998698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001000',
        LOCATION_NAME: 'Ancrum',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5883528,
        LOCATION_LATITUDE_DEG: 55.5135634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001100',
        LOCATION_NAME: 'Ancton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6065451,
        LOCATION_LATITUDE_DEG: 50.7959802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001200',
        LOCATION_NAME: 'Anderby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2825578,
        LOCATION_LATITUDE_DEG: 53.2542013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001300',
        LOCATION_NAME: 'Anderby Creek',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3254121,
        LOCATION_LATITUDE_DEG: 53.2592085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001400',
        LOCATION_NAME: 'Anderson',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1659805,
        LOCATION_LATITUDE_DEG: 50.7746045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN010200',
        LOCATION_NAME: 'Andersonstown',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9941576,
        LOCATION_LATITUDE_DEG: 54.5793293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001500',
        LOCATION_NAME: 'Anderston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2811742,
        LOCATION_LATITUDE_DEG: 55.8657125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001600',
        LOCATION_NAME: 'Anderton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5880749,
        LOCATION_LATITUDE_DEG: 53.6159773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001700',
        LOCATION_NAME: 'Anderton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5272084,
        LOCATION_LATITUDE_DEG: 53.2718402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001800',
        LOCATION_NAME: 'Andover',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4769011,
        LOCATION_LATITUDE_DEG: 51.2088377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN001900',
        LOCATION_NAME: 'Andover Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4346778,
        LOCATION_LATITUDE_DEG: 51.2125353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002000',
        LOCATION_NAME: 'Andoversford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9643644,
        LOCATION_LATITUDE_DEG: 51.8745069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002100',
        LOCATION_NAME: 'Andreas',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4496205,
        LOCATION_LATITUDE_DEG: 54.3672394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN990265',
        LOCATION_NAME: 'Andreas Village',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4444773,
        LOCATION_LATITUDE_DEG: 54.3680091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002200',
        LOCATION_NAME: 'Andwell',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0116036,
        LOCATION_LATITUDE_DEG: 51.2651338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002300',
        LOCATION_NAME: 'Anelog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7384746,
        LOCATION_LATITUDE_DEG: 52.8145221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009800',
        LOCATION_NAME: 'Anerley',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0616297,
        LOCATION_LATITUDE_DEG: 51.4211544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002400',
        LOCATION_NAME: 'Anfield',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9518544,
        LOCATION_LATITUDE_DEG: 53.4319623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002500',
        LOCATION_NAME: 'Angarrack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3864902,
        LOCATION_LATITUDE_DEG: 50.1936819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002600',
        LOCATION_NAME: 'Angersleigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1410928,
        LOCATION_LATITUDE_DEG: 50.9635337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002700',
        LOCATION_NAME: 'Angerton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2024323,
        LOCATION_LATITUDE_DEG: 54.9019078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002800',
        LOCATION_NAME: 'Angle',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0892387,
        LOCATION_LATITUDE_DEG: 51.6841197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003000',
        LOCATION_NAME: 'Anglezarke',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5766726,
        LOCATION_LATITUDE_DEG: 53.6545793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003100',
        LOCATION_NAME: 'Angmering',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.474601,
        LOCATION_LATITUDE_DEG: 50.8275808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN010100',
        LOCATION_NAME: 'Angmering on Sea',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4755022,
        LOCATION_LATITUDE_DEG: 50.8326114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003200',
        LOCATION_NAME: 'Angram',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1729409,
        LOCATION_LATITUDE_DEG: 54.3932478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003300',
        LOCATION_NAME: 'Angram',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2080119,
        LOCATION_LATITUDE_DEG: 53.9307939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003400',
        LOCATION_NAME: 'Anick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0718109,
        LOCATION_LATITUDE_DEG: 54.9842006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003500',
        LOCATION_NAME: 'Anlaby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4309317,
        LOCATION_LATITUDE_DEG: 53.7455669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003600',
        LOCATION_NAME: 'Anlaby Common',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.418058,
        LOCATION_LATITUDE_DEG: 53.74146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003700',
        LOCATION_NAME: 'Anlaby Park',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4034653,
        LOCATION_LATITUDE_DEG: 53.7391627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003800',
        LOCATION_NAME: 'Anmer',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5857509,
        LOCATION_LATITUDE_DEG: 52.8339572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003900',
        LOCATION_NAME: 'Anna Valley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4995866,
        LOCATION_LATITUDE_DEG: 51.1936307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004200',
        LOCATION_NAME: 'Annaclone',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1822174,
        LOCATION_LATITUDE_DEG: 54.2998801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005000',
        LOCATION_NAME: 'Annahilt',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9989006,
        LOCATION_LATITUDE_DEG: 54.433191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005100',
        LOCATION_NAME: 'Annalong',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9027125,
        LOCATION_LATITUDE_DEG: 54.1270592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005400',
        LOCATION_NAME: 'Annan',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2599851,
        LOCATION_LATITUDE_DEG: 54.9872233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005500',
        LOCATION_NAME: 'Annan Water',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.459214,
        LOCATION_LATITUDE_DEG: 55.3701578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005600',
        LOCATION_NAME: 'Annandale',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5280171,
        LOCATION_LATITUDE_DEG: 55.6037926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005700',
        LOCATION_NAME: 'Annat',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5156863,
        LOCATION_LATITUDE_DEG: 57.5323959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005800',
        LOCATION_NAME: 'Annbank',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5184208,
        LOCATION_LATITUDE_DEG: 55.4782804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006000',
        LOCATION_NAME: 'Annesley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.240612,
        LOCATION_LATITUDE_DEG: 53.0768134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006100',
        LOCATION_NAME: 'Annesley Woodhouse',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2559598,
        LOCATION_LATITUDE_DEG: 53.0759124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006300',
        LOCATION_NAME: 'Annfield Muir',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0955343,
        LOCATION_LATITUDE_DEG: 56.2529397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006400',
        LOCATION_NAME: 'Annfield Plain',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7305716,
        LOCATION_LATITUDE_DEG: 54.8557905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN010300',
        LOCATION_NAME: 'Anniesland',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3223534,
        LOCATION_LATITUDE_DEG: 55.89038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006500',
        LOCATION_NAME: 'Annishader',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2826441,
        LOCATION_LATITUDE_DEG: 57.4779988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006600',
        LOCATION_NAME: 'Annitsford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5909776,
        LOCATION_LATITUDE_DEG: 55.0583083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006800',
        LOCATION_NAME: 'Annscroft',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8149892,
        LOCATION_LATITUDE_DEG: 52.6616884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006900',
        LOCATION_NAME: 'Ansdell',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9880197,
        LOCATION_LATITUDE_DEG: 53.7450953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007000',
        LOCATION_NAME: 'Ansford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5242559,
        LOCATION_LATITUDE_DEG: 51.0950335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007100',
        LOCATION_NAME: 'Ansley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5554764,
        LOCATION_LATITUDE_DEG: 52.5184627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007200',
        LOCATION_NAME: 'Ansley Common',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5448123,
        LOCATION_LATITUDE_DEG: 52.5377618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007300',
        LOCATION_NAME: 'Anslow',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6851198,
        LOCATION_LATITUDE_DEG: 52.8249867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007500',
        LOCATION_NAME: 'Anstey',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1851059,
        LOCATION_LATITUDE_DEG: 52.6724692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007400',
        LOCATION_NAME: 'Anstey',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.045536,
        LOCATION_LATITUDE_DEG: 51.9761849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007600',
        LOCATION_NAME: 'Anston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2227379,
        LOCATION_LATITUDE_DEG: 53.3484336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007700',
        LOCATION_NAME: 'Anstruther',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7011993,
        LOCATION_LATITUDE_DEG: 56.2234355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007800',
        LOCATION_NAME: 'Anstruther Easter',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.691524,
        LOCATION_LATITUDE_DEG: 56.2271381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008000',
        LOCATION_NAME: 'Ansty',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3265252,
        LOCATION_LATITUDE_DEG: 50.8311052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN007900',
        LOCATION_NAME: 'Ansty',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.061934,
        LOCATION_LATITUDE_DEG: 51.0371253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008200',
        LOCATION_NAME: 'Ansty',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4155966,
        LOCATION_LATITUDE_DEG: 52.4456469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008100',
        LOCATION_NAME: 'Ansty',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1603955,
        LOCATION_LATITUDE_DEG: 50.993996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008300',
        LOCATION_NAME: 'Anthill Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0752397,
        LOCATION_LATITUDE_DEG: 50.906197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008400',
        LOCATION_NAME: 'Anthorn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2528979,
        LOCATION_LATITUDE_DEG: 54.9127139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008500',
        LOCATION_NAME: 'Antingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3472931,
        LOCATION_LATITUDE_DEG: 52.8458509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008600',
        LOCATION_NAME: 'Antons Gowt',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0690475,
        LOCATION_LATITUDE_DEG: 53.0105894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008700',
        LOCATION_NAME: 'Antony',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2501482,
        LOCATION_LATITUDE_DEG: 50.3692823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008800',
        LOCATION_NAME: 'Antony Estate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2240331,
        LOCATION_LATITUDE_DEG: 50.3843845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN008900',
        LOCATION_NAME: 'Antony Passage',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2326021,
        LOCATION_LATITUDE_DEG: 50.3933867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009000',
        LOCATION_NAME: 'Antrim',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2228226,
        LOCATION_LATITUDE_DEG: 54.7166206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009100',
        LOCATION_NAME: 'Antrobus',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5356044,
        LOCATION_LATITUDE_DEG: 53.312446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009200',
        LOCATION_NAME: 'Anvil Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0197839,
        LOCATION_LATITUDE_DEG: 51.2056013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009300',
        LOCATION_NAME: 'Anwick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3374899,
        LOCATION_LATITUDE_DEG: 53.0397945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009400',
        LOCATION_NAME: 'Anwick Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3146807,
        LOCATION_LATITUDE_DEG: 53.0179934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN009500',
        LOCATION_NAME: 'Anwoth',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2104771,
        LOCATION_LATITUDE_DEG: 54.8783168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000100',
        LOCATION_NAME: 'Apethorpe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4935695,
        LOCATION_LATITUDE_DEG: 52.5496507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000200',
        LOCATION_NAME: 'Apley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5146041,
        LOCATION_LATITUDE_DEG: 52.7159874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000400',
        LOCATION_NAME: 'Apley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4280941,
        LOCATION_LATITUDE_DEG: 52.5810734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000300',
        LOCATION_NAME: 'Apley',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3353945,
        LOCATION_LATITUDE_DEG: 53.2615115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000500',
        LOCATION_NAME: 'Apperknowle',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4245934,
        LOCATION_LATITUDE_DEG: 53.2996299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000600',
        LOCATION_NAME: 'Apperley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1998425,
        LOCATION_LATITUDE_DEG: 51.9541096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000700',
        LOCATION_NAME: 'Apperley Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7115046,
        LOCATION_LATITUDE_DEG: 53.8362928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000800',
        LOCATION_NAME: 'Appersett',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2184214,
        LOCATION_LATITUDE_DEG: 54.3113365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP000900',
        LOCATION_NAME: 'Appin',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.357205,
        LOCATION_LATITUDE_DEG: 56.5622937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001000',
        LOCATION_NAME: 'Appleby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5646729,
        LOCATION_LATITUDE_DEG: 53.6216527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP003200',
        LOCATION_NAME: 'Appleby in Westmorland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001100',
        LOCATION_NAME: 'Appleby Magna',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5314916,
        LOCATION_LATITUDE_DEG: 52.6849716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001200',
        LOCATION_NAME: 'Appleby-in-Westmorland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.487734,
        LOCATION_LATITUDE_DEG: 54.5780717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001300',
        LOCATION_NAME: 'Applecross',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8131882,
        LOCATION_LATITUDE_DEG: 57.4324891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001400',
        LOCATION_NAME: 'Appledore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1897671,
        LOCATION_LATITUDE_DEG: 51.0525275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001500',
        LOCATION_NAME: 'Appledore',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7912225,
        LOCATION_LATITUDE_DEG: 51.02899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001600',
        LOCATION_NAME: 'Appleford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2387897,
        LOCATION_LATITUDE_DEG: 51.6384751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001700',
        LOCATION_NAME: 'Appleshaw',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5628215,
        LOCATION_LATITUDE_DEG: 51.2356386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001800',
        LOCATION_NAME: 'Applethwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1469264,
        LOCATION_LATITUDE_DEG: 54.6156856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP001900',
        LOCATION_NAME: 'Appleton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7302,
        LOCATION_LATITUDE_DEG: 53.37526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002050',
        LOCATION_NAME: 'Appleton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5234944,
        LOCATION_LATITUDE_DEG: 53.3507964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002000',
        LOCATION_NAME: 'Appleton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3598137,
        LOCATION_LATITUDE_DEG: 51.7090769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP003300',
        LOCATION_NAME: 'Appleton le Moors',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP003400',
        LOCATION_NAME: 'Appleton le Street',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002100',
        LOCATION_NAME: 'Appleton Roebuck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1568953,
        LOCATION_LATITUDE_DEG: 53.873185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002200',
        LOCATION_NAME: 'Appleton Thorn',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5437242,
        LOCATION_LATITUDE_DEG: 53.3501486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002300',
        LOCATION_NAME: 'Appleton Wiske',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3979302,
        LOCATION_LATITUDE_DEG: 54.4358413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002400',
        LOCATION_NAME: 'Appleton-le-Moors',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8744323,
        LOCATION_LATITUDE_DEG: 54.281618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002500',
        LOCATION_NAME: 'Appleton-le-Street',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8743619,
        LOCATION_LATITUDE_DEG: 54.1528059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002600',
        LOCATION_NAME: 'Appletree',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3020425,
        LOCATION_LATITUDE_DEG: 52.1434219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002700',
        LOCATION_NAME: 'Appletreehall',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.761489,
        LOCATION_LATITUDE_DEG: 55.4487583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002800',
        LOCATION_NAME: 'Appletreewick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9236765,
        LOCATION_LATITUDE_DEG: 54.0374073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP002900',
        LOCATION_NAME: 'Appley Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7202988,
        LOCATION_LATITUDE_DEG: 53.5775795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP003000',
        LOCATION_NAME: 'Apse Heath',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.201883,
        LOCATION_LATITUDE_DEG: 50.6458796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP991048',
        LOCATION_NAME: 'Apsley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4678,
        LOCATION_LATITUDE_DEG: 51.73641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AP003100',
        LOCATION_NAME: 'Apuldram',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8053602,
        LOCATION_LATITUDE_DEG: 50.821687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000100',
        LOCATION_NAME: 'Arabella',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.00584,
        LOCATION_LATITUDE_DEG: 57.7574977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000400',
        LOCATION_NAME: 'Arbirlot',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6482705,
        LOCATION_LATITUDE_DEG: 56.5556629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000500',
        LOCATION_NAME: 'Arborfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9185042,
        LOCATION_LATITUDE_DEG: 51.4009431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000600',
        LOCATION_NAME: 'Arborfield Cross',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9050563,
        LOCATION_LATITUDE_DEG: 51.3969423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990950',
        LOCATION_NAME: 'Arborfield Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020400',
        LOCATION_NAME: 'Arbourthorne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4465871,
        LOCATION_LATITUDE_DEG: 53.3697108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000700',
        LOCATION_NAME: 'Arbroath',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5778166,
        LOCATION_LATITUDE_DEG: 56.5617697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000800',
        LOCATION_NAME: 'Arbury',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.511281,
        LOCATION_LATITUDE_DEG: 52.5032554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000900',
        LOCATION_NAME: 'Arbuthnott',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3317744,
        LOCATION_LATITUDE_DEG: 56.8714939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001000',
        LOCATION_NAME: 'Archdeacon Newton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6072438,
        LOCATION_LATITUDE_DEG: 54.5482536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001100',
        LOCATION_NAME: 'Archenfield',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0750749,
        LOCATION_LATITUDE_DEG: 52.072536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001300',
        LOCATION_NAME: 'Archiestown',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2814273,
        LOCATION_LATITUDE_DEG: 57.4813628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001400',
        LOCATION_NAME: 'Arclid',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3195238,
        LOCATION_LATITUDE_DEG: 53.1537935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001600',
        LOCATION_NAME: 'Ardachu',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2429646,
        LOCATION_LATITUDE_DEG: 58.0019307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002000',
        LOCATION_NAME: 'Ardallie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9923681,
        LOCATION_LATITUDE_DEG: 57.4472469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002400',
        LOCATION_NAME: 'Ardbeg',
        COUNTY_NAME: 'Isle of Bute',
        POSTCODE: 'PA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9615829,
        LOCATION_LATITUDE_DEG: 56.0062406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002500',
        LOCATION_NAME: 'Ardboe',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5489554,
        LOCATION_LATITUDE_DEG: 54.6332447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002600',
        LOCATION_NAME: 'Ardbrecknish',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1341582,
        LOCATION_LATITUDE_DEG: 56.3421767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002800',
        LOCATION_NAME: 'Ardcharnich',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0770579,
        LOCATION_LATITUDE_DEG: 57.8497231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002900',
        LOCATION_NAME: 'Ardchattan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2905479,
        LOCATION_LATITUDE_DEG: 56.4631826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003000',
        LOCATION_NAME: 'Ardchung',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2531494,
        LOCATION_LATITUDE_DEG: 57.4089028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003200',
        LOCATION_NAME: 'Arddleen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0973647,
        LOCATION_LATITUDE_DEG: 52.7351962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003500',
        LOCATION_NAME: 'Ardeer',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7358368,
        LOCATION_LATITUDE_DEG: 55.6303005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003600',
        LOCATION_NAME: 'Ardeley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0952869,
        LOCATION_LATITUDE_DEG: 51.9272874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003700',
        LOCATION_NAME: 'Ardelve',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5345478,
        LOCATION_LATITUDE_DEG: 57.2862734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003800',
        LOCATION_NAME: 'Arden',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6324941,
        LOCATION_LATITUDE_DEG: 56.0267343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003900',
        LOCATION_NAME: 'Ardendrain',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4833494,
        LOCATION_LATITUDE_DEG: 57.4058737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004000',
        LOCATION_NAME: 'Ardens Grafton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8300983,
        LOCATION_LATITUDE_DEG: 52.187229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004200',
        LOCATION_NAME: 'Ardentallen',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5054884,
        LOCATION_LATITUDE_DEG: 56.356973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004300',
        LOCATION_NAME: 'Ardentinny',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9098727,
        LOCATION_LATITUDE_DEG: 56.0468399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004400',
        LOCATION_NAME: 'Ardeonaig',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1631295,
        LOCATION_LATITUDE_DEG: 56.495282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004500',
        LOCATION_NAME: 'Ardersier',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0362575,
        LOCATION_LATITUDE_DEG: 57.5694793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004600',
        LOCATION_NAME: 'Ardessie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2829904,
        LOCATION_LATITUDE_DEG: 57.8536286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004700',
        LOCATION_NAME: 'Ardfenaig',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2988844,
        LOCATION_LATITUDE_DEG: 56.3167811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004800',
        LOCATION_NAME: 'Ardfern',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5384636,
        LOCATION_LATITUDE_DEG: 56.1796582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005200',
        LOCATION_NAME: 'Ardgay',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3614984,
        LOCATION_LATITUDE_DEG: 57.881319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005400',
        LOCATION_NAME: 'Ardglass',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6129576,
        LOCATION_LATITUDE_DEG: 54.2691745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005500',
        LOCATION_NAME: 'Ardgour',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2432335,
        LOCATION_LATITUDE_DEG: 56.7231141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005600',
        LOCATION_NAME: 'Ardgowan',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8666668,
        LOCATION_LATITUDE_DEG: 55.9171286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005800',
        LOCATION_NAME: 'Ardhasaig',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8465677,
        LOCATION_LATITUDE_DEG: 57.9226447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005900',
        LOCATION_NAME: 'Ardinashaig',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6982783,
        LOCATION_LATITUDE_DEG: 57.8779372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006000',
        LOCATION_NAME: 'Ardindrean',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.104149,
        LOCATION_LATITUDE_DEG: 57.8483257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006100',
        LOCATION_NAME: 'Ardingly',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0764669,
        LOCATION_LATITUDE_DEG: 51.0480038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006200',
        LOCATION_NAME: 'Ardington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3764361,
        LOCATION_LATITUDE_DEG: 51.5927687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006300',
        LOCATION_NAME: 'Ardington Wick',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3727231,
        LOCATION_LATITUDE_DEG: 51.5887653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006500',
        LOCATION_NAME: 'Ardivachair',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4213353,
        LOCATION_LATITUDE_DEG: 57.3871947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006600',
        LOCATION_NAME: 'Ardkeen',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5331482,
        LOCATION_LATITUDE_DEG: 54.4426918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006700',
        LOCATION_NAME: 'Ardleigh',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9871434,
        LOCATION_LATITUDE_DEG: 51.9255684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006800',
        LOCATION_NAME: 'Ardler',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1969339,
        LOCATION_LATITUDE_DEG: 56.5640723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006900',
        LOCATION_NAME: 'Ardley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2104523,
        LOCATION_LATITUDE_DEG: 51.9413991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007200',
        LOCATION_NAME: 'Ardlui',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7196982,
        LOCATION_LATITUDE_DEG: 56.3042665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007300',
        LOCATION_NAME: 'Ardlussa',
        COUNTY_NAME: 'Isle of Jura',
        POSTCODE: 'PA60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7739906,
        LOCATION_LATITUDE_DEG: 56.0256488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007400',
        LOCATION_NAME: 'Ardmaddy',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1154526,
        LOCATION_LATITUDE_DEG: 56.5000868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007500',
        LOCATION_NAME: 'Ardmair',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.191702,
        LOCATION_LATITUDE_DEG: 57.9351351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007600',
        LOCATION_NAME: 'Ardmhor',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.418103,
        LOCATION_LATITUDE_DEG: 57.009557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007700',
        LOCATION_NAME: 'Ardmoney',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3490393,
        LOCATION_LATITUDE_DEG: 54.2998909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007900',
        LOCATION_NAME: 'Ardmore',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8822775,
        LOCATION_LATITUDE_DEG: 55.0166566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008100',
        LOCATION_NAME: 'Ardnakille',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6857034,
        LOCATION_LATITUDE_DEG: 57.8642429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008200',
        LOCATION_NAME: 'Ardnamonie',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.343362,
        LOCATION_LATITUDE_DEG: 57.3753979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008500',
        LOCATION_NAME: 'Ardnarff',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5078264,
        LOCATION_LATITUDE_DEG: 57.3628784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008600',
        LOCATION_NAME: 'Ardnastruban',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2594974,
        LOCATION_LATITUDE_DEG: 57.4926041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008700',
        LOCATION_NAME: 'Ardoch',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6205112,
        LOCATION_LATITUDE_DEG: 55.9522258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008800',
        LOCATION_NAME: 'Ardoe',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1638022,
        LOCATION_LATITUDE_DEG: 57.1036138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR021000',
        LOCATION_NAME: 'Ardoyne',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9587557,
        LOCATION_LATITUDE_DEG: 54.614378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009000',
        LOCATION_NAME: 'Ardpeaton',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8636594,
        LOCATION_LATITUDE_DEG: 56.0288362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009400',
        LOCATION_NAME: 'Ardrishaig',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4490901,
        LOCATION_LATITUDE_DEG: 56.0170439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009500',
        LOCATION_NAME: 'Ardroil',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0238818,
        LOCATION_LATITUDE_DEG: 58.1792766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009600',
        LOCATION_NAME: 'Ardross',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3232865,
        LOCATION_LATITUDE_DEG: 57.7376048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009700',
        LOCATION_NAME: 'Ardrossan',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8106924,
        LOCATION_LATITUDE_DEG: 55.6432972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010000',
        LOCATION_NAME: 'Ardslave',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8649899,
        LOCATION_LATITUDE_DEG: 57.8017368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010100',
        LOCATION_NAME: 'Ardsley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4188265,
        LOCATION_LATITUDE_DEG: 53.5460549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010300',
        LOCATION_NAME: 'Ardstraw',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4657542,
        LOCATION_LATITUDE_DEG: 54.7332254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010350',
        LOCATION_NAME: 'Ardtalnaig',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1116727,
        LOCATION_LATITUDE_DEG: 56.524532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010400',
        LOCATION_NAME: 'Ardtaraig',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1130676,
        LOCATION_LATITUDE_DEG: 55.9971392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010500',
        LOCATION_NAME: 'Ardtoe',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8812879,
        LOCATION_LATITUDE_DEG: 56.7681189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010600',
        LOCATION_NAME: 'Ardtornish',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7346275,
        LOCATION_LATITUDE_DEG: 56.5612014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010700',
        LOCATION_NAME: 'Ardtun',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2113674,
        LOCATION_LATITUDE_DEG: 56.3312784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010800',
        LOCATION_NAME: 'Arduaine',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5537363,
        LOCATION_LATITUDE_DEG: 56.2354649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010900',
        LOCATION_NAME: 'Ardvannie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2107002,
        LOCATION_LATITUDE_DEG: 57.8549114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011000',
        LOCATION_NAME: 'Ardvasar',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9079207,
        LOCATION_LATITUDE_DEG: 57.0580529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011100',
        LOCATION_NAME: 'Ardveenish',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4162414,
        LOCATION_LATITUDE_DEG: 57.0042553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011200',
        LOCATION_NAME: 'Ardvey',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9199272,
        LOCATION_LATITUDE_DEG: 57.7787291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011300',
        LOCATION_NAME: 'Ardvorlich',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2153446,
        LOCATION_LATITUDE_DEG: 56.3791658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011400',
        LOCATION_NAME: 'Ardvourlie',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7611351,
        LOCATION_LATITUDE_DEG: 57.9944531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011500',
        LOCATION_NAME: 'Ardwell',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9399089,
        LOCATION_LATITUDE_DEG: 54.7706174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020700',
        LOCATION_NAME: 'Ardwick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020800',
        LOCATION_NAME: 'Ardwick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020600',
        LOCATION_NAME: 'Ardwick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2237042,
        LOCATION_LATITUDE_DEG: 53.4697056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011700',
        LOCATION_NAME: 'Areley Kings',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2932134,
        LOCATION_LATITUDE_DEG: 52.3321527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011800',
        LOCATION_NAME: 'Arenig',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7438204,
        LOCATION_LATITUDE_DEG: 52.9168237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011900',
        LOCATION_NAME: 'Arford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8130811,
        LOCATION_LATITUDE_DEG: 51.1241166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012000',
        LOCATION_NAME: 'Argal',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1234258,
        LOCATION_LATITUDE_DEG: 50.1466732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012100',
        LOCATION_NAME: 'Argaty',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0383337,
        LOCATION_LATITUDE_DEG: 56.202345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012200',
        LOCATION_NAME: 'Argoed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1901305,
        LOCATION_LATITUDE_DEG: 51.6900004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012300',
        LOCATION_NAME: 'Argoed',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0316807,
        LOCATION_LATITUDE_DEG: 52.4552689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012400',
        LOCATION_NAME: 'Argoed Mill',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4700739,
        LOCATION_LATITUDE_DEG: 52.2534657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012500',
        LOCATION_NAME: 'Argos Hill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2438262,
        LOCATION_LATITUDE_DEG: 51.0312908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012700',
        LOCATION_NAME: 'Arinagour',
        COUNTY_NAME: 'Isle of Coll',
        POSTCODE: 'PA78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5260668,
        LOCATION_LATITUDE_DEG: 56.6241104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012800',
        LOCATION_NAME: 'Arisaig',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8411639,
        LOCATION_LATITUDE_DEG: 56.911132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012900',
        LOCATION_NAME: 'Arivegaig',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8321153,
        LOCATION_LATITUDE_DEG: 56.7452174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013000',
        LOCATION_NAME: 'Arivruaich',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6696055,
        LOCATION_LATITUDE_DEG: 58.0608605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013100',
        LOCATION_NAME: 'Arkendale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4066392,
        LOCATION_LATITUDE_DEG: 54.0435003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013200',
        LOCATION_NAME: 'Arkengarthdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0016955,
        LOCATION_LATITUDE_DEG: 54.4247491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013300',
        LOCATION_NAME: 'Arkesden',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.158521,
        LOCATION_LATITUDE_DEG: 51.9887816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013400',
        LOCATION_NAME: 'Arkholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6382675,
        LOCATION_LATITUDE_DEG: 54.1433331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013500',
        LOCATION_NAME: 'Arkle Town',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9861925,
        LOCATION_LATITUDE_DEG: 54.4131447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013600',
        LOCATION_NAME: 'Arkleby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3350107,
        LOCATION_LATITUDE_DEG: 54.740999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013700',
        LOCATION_NAME: 'Arkley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2302166,
        LOCATION_LATITUDE_DEG: 51.6472543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013900',
        LOCATION_NAME: 'Arksey',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1244595,
        LOCATION_LATITUDE_DEG: 53.5552565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014000',
        LOCATION_NAME: 'Arkwright Town',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.354965,
        LOCATION_LATITUDE_DEG: 53.2337278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014100',
        LOCATION_NAME: 'Arlecdon',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4693349,
        LOCATION_LATITUDE_DEG: 54.5562826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014200',
        LOCATION_NAME: 'Arlescot',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5178364,
        LOCATION_LATITUDE_DEG: 52.6037767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014300',
        LOCATION_NAME: 'Arlescote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4294648,
        LOCATION_LATITUDE_DEG: 52.1335239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014400',
        LOCATION_NAME: 'Arlesey',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2637298,
        LOCATION_LATITUDE_DEG: 52.0067903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR991121',
        LOCATION_NAME: 'Arlesford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.993112,
        LOCATION_LATITUDE_DEG: 51.842462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014600',
        LOCATION_NAME: 'Arleston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.503042,
        LOCATION_LATITUDE_DEG: 52.6941895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014700',
        LOCATION_NAME: 'Arley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4917831,
        LOCATION_LATITUDE_DEG: 53.323845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014900',
        LOCATION_NAME: 'Arley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3406433,
        LOCATION_LATITUDE_DEG: 52.4211553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014800',
        LOCATION_NAME: 'Arley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.568739,
        LOCATION_LATITUDE_DEG: 52.5036586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015000',
        LOCATION_NAME: 'Arlingham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4231566,
        LOCATION_LATITUDE_DEG: 51.7958982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015200',
        LOCATION_NAME: 'Arlington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.980753,
        LOCATION_LATITUDE_DEG: 51.1479543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015100',
        LOCATION_NAME: 'Arlington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1935811,
        LOCATION_LATITUDE_DEG: 50.8451729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015400',
        LOCATION_NAME: 'Armadale',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0863876,
        LOCATION_LATITUDE_DEG: 58.5531828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015300',
        LOCATION_NAME: 'Armadale',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.699279,
        LOCATION_LATITUDE_DEG: 55.8955161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015500',
        LOCATION_NAME: 'Armagh',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6541743,
        LOCATION_LATITUDE_DEG: 54.3513908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015600',
        LOCATION_NAME: 'Armathwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.769965,
        LOCATION_LATITUDE_DEG: 54.8064989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015700',
        LOCATION_NAME: 'Arminghall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3259037,
        LOCATION_LATITUDE_DEG: 52.588926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015800',
        LOCATION_NAME: 'Armitage',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8754888,
        LOCATION_LATITUDE_DEG: 52.7414841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR015900',
        LOCATION_NAME: 'Armitage Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7984,
        LOCATION_LATITUDE_DEG: 53.6185646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR021200',
        LOCATION_NAME: 'Armley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5870966,
        LOCATION_LATITUDE_DEG: 53.7992269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016000',
        LOCATION_NAME: 'Armoy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3338198,
        LOCATION_LATITUDE_DEG: 55.1285586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016100',
        LOCATION_NAME: 'Armscote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.645032,
        LOCATION_LATITUDE_DEG: 52.089016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016200',
        LOCATION_NAME: 'Armston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4381984,
        LOCATION_LATITUDE_DEG: 52.4610379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016300',
        LOCATION_NAME: 'Armstrong',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5453169,
        LOCATION_LATITUDE_DEG: 54.9079948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016400',
        LOCATION_NAME: 'Armthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0524595,
        LOCATION_LATITUDE_DEG: 53.5350472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016500',
        LOCATION_NAME: 'Arncliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1035661,
        LOCATION_LATITUDE_DEG: 54.1416185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016600',
        LOCATION_NAME: 'Arncott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1118359,
        LOCATION_LATITUDE_DEG: 51.8507929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016700',
        LOCATION_NAME: 'Arncroach',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7858352,
        LOCATION_LATITUDE_DEG: 56.2371333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016800',
        LOCATION_NAME: 'Arne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0382858,
        LOCATION_LATITUDE_DEG: 50.6917945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR016900',
        LOCATION_NAME: 'Arnesby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0899395,
        LOCATION_LATITUDE_DEG: 52.5264532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017000',
        LOCATION_NAME: 'Arnisdale',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5619676,
        LOCATION_LATITUDE_DEG: 57.1344558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017100',
        LOCATION_NAME: 'Arnish',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0100399,
        LOCATION_LATITUDE_DEG: 57.4585924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017200',
        LOCATION_NAME: 'Arniston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0590712,
        LOCATION_LATITUDE_DEG: 55.8475009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017300',
        LOCATION_NAME: 'Arnol',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5954063,
        LOCATION_LATITUDE_DEG: 58.3434858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017500',
        LOCATION_NAME: 'Arnold',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1263823,
        LOCATION_LATITUDE_DEG: 53.0062998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017400',
        LOCATION_NAME: 'Arnold',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2872813,
        LOCATION_LATITUDE_DEG: 53.8567687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020900',
        LOCATION_NAME: 'Arnos Grove',
        COUNTY_NAME: 'London',
        POSTCODE: 'N11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1297714,
        LOCATION_LATITUDE_DEG: 51.6199311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR021100',
        LOCATION_NAME: 'Arnos Vale',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5629864,
        LOCATION_LATITUDE_DEG: 51.4444816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017600',
        LOCATION_NAME: 'Arnprior',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2323806,
        LOCATION_LATITUDE_DEG: 56.1267381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017700',
        LOCATION_NAME: 'Arnside',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.834085,
        LOCATION_LATITUDE_DEG: 54.1974346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017800',
        LOCATION_NAME: 'Aros',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0507465,
        LOCATION_LATITUDE_DEG: 56.6025087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR017900',
        LOCATION_NAME: 'Arpinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1314872,
        LOCATION_LATITUDE_DEG: 51.1072881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018000',
        LOCATION_NAME: 'Arrad Foot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0610739,
        LOCATION_LATITUDE_DEG: 54.219245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018100',
        LOCATION_NAME: 'Arradoul',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9742668,
        LOCATION_LATITUDE_DEG: 57.6550753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018200',
        LOCATION_NAME: 'Arram',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4252769,
        LOCATION_LATITUDE_DEG: 53.8840738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018300',
        LOCATION_NAME: 'Arrathorne',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6914328,
        LOCATION_LATITUDE_DEG: 54.3344373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018400',
        LOCATION_NAME: 'Arreton',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.234116,
        LOCATION_LATITUDE_DEG: 50.671378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018500',
        LOCATION_NAME: 'Arrina',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8214942,
        LOCATION_LATITUDE_DEG: 57.5315005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018600',
        LOCATION_NAME: 'Arrington',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0631207,
        LOCATION_LATITUDE_DEG: 52.1344992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018700',
        LOCATION_NAME: 'Arrochar',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7471697,
        LOCATION_LATITUDE_DEG: 56.195653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018800',
        LOCATION_NAME: 'Arrow',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8827559,
        LOCATION_LATITUDE_DEG: 52.2065347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR018900',
        LOCATION_NAME: 'Arscott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8349187,
        LOCATION_LATITUDE_DEG: 52.6645886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019000',
        LOCATION_NAME: 'Artafallie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2893271,
        LOCATION_LATITUDE_DEG: 57.5118814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019200',
        LOCATION_NAME: 'Arthington',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5843933,
        LOCATION_LATITUDE_DEG: 53.8974944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019300',
        LOCATION_NAME: 'Arthingworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8905858,
        LOCATION_LATITUDE_DEG: 52.4250373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990515',
        LOCATION_NAME: 'Arthog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019500',
        LOCATION_NAME: 'Arthrath',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.056696,
        LOCATION_LATITUDE_DEG: 57.4193401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020500',
        LOCATION_NAME: 'Arthurs Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6421983,
        LOCATION_LATITUDE_DEG: 54.9767754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019700',
        LOCATION_NAME: 'Articlave',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7656719,
        LOCATION_LATITUDE_DEG: 55.1332588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019800',
        LOCATION_NAME: 'Artigarvan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3990296,
        LOCATION_LATITUDE_DEG: 54.8499418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019900',
        LOCATION_NAME: 'Artington',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5774681,
        LOCATION_LATITUDE_DEG: 51.2195269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020000',
        LOCATION_NAME: 'Arundel',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.557968,
        LOCATION_LATITUDE_DEG: 50.8549848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020300',
        LOCATION_NAME: 'Arvalee',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2348921,
        LOCATION_LATITUDE_DEG: 54.5940728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000100',
        LOCATION_NAME: 'Asby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4517365,
        LOCATION_LATITUDE_DEG: 54.569385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000200',
        LOCATION_NAME: 'Ascog',
        COUNTY_NAME: 'Isle of Bute',
        POSTCODE: 'PA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0221576,
        LOCATION_LATITUDE_DEG: 55.8222173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000300',
        LOCATION_NAME: 'Ascot',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6732825,
        LOCATION_LATITUDE_DEG: 51.4103394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000400',
        LOCATION_NAME: 'Ascott',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5316551,
        LOCATION_LATITUDE_DEG: 52.0097086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000500',
        LOCATION_NAME: 'Ascott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1123181,
        LOCATION_LATITUDE_DEG: 51.6784761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS026000',
        LOCATION_NAME: 'Ascott under Wychwood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000600',
        LOCATION_NAME: 'Ascott-under-Wychwood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5662901,
        LOCATION_LATITUDE_DEG: 51.8694778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000700',
        LOCATION_NAME: 'Asenby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3933724,
        LOCATION_LATITUDE_DEG: 54.1699142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000800',
        LOCATION_NAME: 'Asfordby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9498495,
        LOCATION_LATITUDE_DEG: 52.7638734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS000900',
        LOCATION_NAME: 'Asfordby Hill',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9257857,
        LOCATION_LATITUDE_DEG: 52.7653752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001000',
        LOCATION_NAME: 'Asfordby Valley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9390372,
        LOCATION_LATITUDE_DEG: 52.7714734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001100',
        LOCATION_NAME: 'Asgarby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3366774,
        LOCATION_LATITUDE_DEG: 52.992687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001200',
        LOCATION_NAME: 'Asgarby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0039283,
        LOCATION_LATITUDE_DEG: 53.1819007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001400',
        LOCATION_NAME: 'Ash',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6303765,
        LOCATION_LATITUDE_DEG: 50.3355761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001300',
        LOCATION_NAME: 'Ash',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7444646,
        LOCATION_LATITUDE_DEG: 50.980828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001600',
        LOCATION_NAME: 'Ash',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7238551,
        LOCATION_LATITUDE_DEG: 51.2512258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001700',
        LOCATION_NAME: 'Ash',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2986572,
        LOCATION_LATITUDE_DEG: 51.3553228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001500',
        LOCATION_NAME: 'Ash',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2796252,
        LOCATION_LATITUDE_DEG: 51.2784048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001800',
        LOCATION_NAME: 'Ash Bank',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1000872,
        LOCATION_LATITUDE_DEG: 53.0209109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002100',
        LOCATION_NAME: 'Ash Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.509982,
        LOCATION_LATITUDE_DEG: 52.4610549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002000',
        LOCATION_NAME: 'Ash Green',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7061596,
        LOCATION_LATITUDE_DEG: 51.2373256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002200',
        LOCATION_NAME: 'Ash Magna',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6406584,
        LOCATION_LATITUDE_DEG: 52.9531123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002300',
        LOCATION_NAME: 'Ash Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7354919,
        LOCATION_LATITUDE_DEG: 50.9970374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002400',
        LOCATION_NAME: 'Ash Parva',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6315623,
        LOCATION_LATITUDE_DEG: 52.9500143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002500',
        LOCATION_NAME: 'Ash Priors',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2096433,
        LOCATION_LATITUDE_DEG: 51.0568368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002600',
        LOCATION_NAME: 'Ash Thomas',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4154054,
        LOCATION_LATITUDE_DEG: 50.8888225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002700',
        LOCATION_NAME: 'Ash Vale',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7151679,
        LOCATION_LATITUDE_DEG: 51.2662306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002800',
        LOCATION_NAME: 'Ashaig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8473079,
        LOCATION_LATITUDE_DEG: 57.2438717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003000',
        LOCATION_NAME: 'Ashampstead',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1833822,
        LOCATION_LATITUDE_DEG: 51.4885556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003100',
        LOCATION_NAME: 'Ashampstead Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.167309,
        LOCATION_LATITUDE_DEG: 51.4686496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003200',
        LOCATION_NAME: 'Ashbocking',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1944743,
        LOCATION_LATITUDE_DEG: 52.1468856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003300',
        LOCATION_NAME: 'Ashbourne',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7279161,
        LOCATION_LATITUDE_DEG: 53.0139082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003500',
        LOCATION_NAME: 'Ashbrittle',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3474525,
        LOCATION_LATITUDE_DEG: 50.983433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003600',
        LOCATION_NAME: 'Ashbrook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.512391,
        LOCATION_LATITUDE_DEG: 53.1588286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003700',
        LOCATION_NAME: 'Ashbrooke',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.395197,
        LOCATION_LATITUDE_DEG: 54.8963847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003800',
        LOCATION_NAME: 'Ashburnham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4042132,
        LOCATION_LATITUDE_DEG: 50.9051744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003900',
        LOCATION_NAME: 'Ashburton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7507805,
        LOCATION_LATITUDE_DEG: 50.5177899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004000',
        LOCATION_NAME: 'Ashburton Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7445737,
        LOCATION_LATITUDE_DEG: 50.5357918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004100',
        LOCATION_NAME: 'Ashbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.117551,
        LOCATION_LATITUDE_DEG: 50.7612171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004200',
        LOCATION_NAME: 'Ashbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6170638,
        LOCATION_LATITUDE_DEG: 51.5636667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004300',
        LOCATION_NAME: 'Ashby',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6717611,
        LOCATION_LATITUDE_DEG: 52.5435135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS026100',
        LOCATION_NAME: 'Ashby by Partney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS026200',
        LOCATION_NAME: 'Ashby cum Fenby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005000',
        LOCATION_NAME: 'Ashby de la Launde',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4245794,
        LOCATION_LATITUDE_DEG: 53.0815027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS026300',
        LOCATION_NAME: 'Ashby de la Zouch',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004400',
        LOCATION_NAME: 'Ashby Folville',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9545527,
        LOCATION_LATITUDE_DEG: 52.701769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004500',
        LOCATION_NAME: 'Ashby Magna',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1734762,
        LOCATION_LATITUDE_DEG: 52.5110527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004600',
        LOCATION_NAME: 'Ashby Parva',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2232756,
        LOCATION_LATITUDE_DEG: 52.4907552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004700',
        LOCATION_NAME: 'Ashby Puerorum',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0126896,
        LOCATION_LATITUDE_DEG: 53.22321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025100',
        LOCATION_NAME: 'Ashby St Ledgers',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025200',
        LOCATION_NAME: 'Ashby St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004800',
        LOCATION_NAME: 'Ashby St. Ledgers',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1606588,
        LOCATION_LATITUDE_DEG: 52.3079375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS004900',
        LOCATION_NAME: 'Ashby St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4414647,
        LOCATION_LATITUDE_DEG: 52.5684849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005100',
        LOCATION_NAME: 'Ashby-by-Partney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.140947,
        LOCATION_LATITUDE_DEG: 53.1792044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005200',
        LOCATION_NAME: 'Ashby-cum-Fenby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1129753,
        LOCATION_LATITUDE_DEG: 53.4862201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005300',
        LOCATION_NAME: 'Ashby-de-la-Zouch',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4720308,
        LOCATION_LATITUDE_DEG: 52.7462813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005400',
        LOCATION_NAME: 'Ashchurch',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1032078,
        LOCATION_LATITUDE_DEG: 51.9974125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005500',
        LOCATION_NAME: 'Ashcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5349796,
        LOCATION_LATITUDE_DEG: 50.6054026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005600',
        LOCATION_NAME: 'Ashcott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8088408,
        LOCATION_LATITUDE_DEG: 51.1287458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005700',
        LOCATION_NAME: 'Ashdon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3157977,
        LOCATION_LATITUDE_DEG: 52.0555913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005800',
        LOCATION_NAME: 'Ashe',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2343395,
        LOCATION_LATITUDE_DEG: 51.2434295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS005900',
        LOCATION_NAME: 'Ashe Warren',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2293158,
        LOCATION_LATITUDE_DEG: 51.2585318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006000',
        LOCATION_NAME: 'Asheldham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8538239,
        LOCATION_LATITUDE_DEG: 51.6762455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006100',
        LOCATION_NAME: 'Ashen',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5452527,
        LOCATION_LATITUDE_DEG: 52.0521875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006200',
        LOCATION_NAME: 'Ashendon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9770637,
        LOCATION_LATITUDE_DEG: 51.8217859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006300',
        LOCATION_NAME: 'Asheridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6418463,
        LOCATION_LATITUDE_DEG: 51.7313701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006400',
        LOCATION_NAME: 'Ashey',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.181618,
        LOCATION_LATITUDE_DEG: 50.6984797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006700',
        LOCATION_NAME: 'Ashfield',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9573544,
        LOCATION_LATITUDE_DEG: 56.2126499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006600',
        LOCATION_NAME: 'Ashfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4765489,
        LOCATION_LATITUDE_DEG: 50.9705068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006500',
        LOCATION_NAME: 'Ashfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.236732,
        LOCATION_LATITUDE_DEG: 52.2199953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006800',
        LOCATION_NAME: 'Ashfield Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3177313,
        LOCATION_LATITUDE_DEG: 52.3132989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007400',
        LOCATION_NAME: 'Ashford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0958536,
        LOCATION_LATITUDE_DEG: 51.097756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007300',
        LOCATION_NAME: 'Ashford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8414707,
        LOCATION_LATITUDE_DEG: 50.3225743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007000',
        LOCATION_NAME: 'Ashford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.715207,
        LOCATION_LATITUDE_DEG: 53.2164248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007200',
        LOCATION_NAME: 'Ashford',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4541397,
        LOCATION_LATITUDE_DEG: 51.4323404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007100',
        LOCATION_NAME: 'Ashford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8772542,
        LOCATION_LATITUDE_DEG: 51.1478917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007600',
        LOCATION_NAME: 'Ashford Bowdler',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7064289,
        LOCATION_LATITUDE_DEG: 52.3303507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007700',
        LOCATION_NAME: 'Ashford Carbonel',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6964944,
        LOCATION_LATITUDE_DEG: 52.3332509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007800',
        LOCATION_NAME: 'Ashford Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2023371,
        LOCATION_LATITUDE_DEG: 51.3531463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS026400',
        LOCATION_NAME: 'Ashford in the Water',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007900',
        LOCATION_NAME: 'Ashford-in-the-Water',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7045938,
        LOCATION_LATITUDE_DEG: 53.2221255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008000',
        LOCATION_NAME: 'Ashgate',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4790018,
        LOCATION_LATITUDE_DEG: 53.2396296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008100',
        LOCATION_NAME: 'Ashgill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9269606,
        LOCATION_LATITUDE_DEG: 55.7266956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008200',
        LOCATION_NAME: 'Ashiesteel',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9064858,
        LOCATION_LATITUDE_DEG: 55.6059746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008400',
        LOCATION_NAME: 'Ashill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2957857,
        LOCATION_LATITUDE_DEG: 50.8937284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008300',
        LOCATION_NAME: 'Ashill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9706002,
        LOCATION_LATITUDE_DEG: 50.9497229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008500',
        LOCATION_NAME: 'Ashill',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7829628,
        LOCATION_LATITUDE_DEG: 52.6022388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008600',
        LOCATION_NAME: 'Ashingdon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6988183,
        LOCATION_LATITUDE_DEG: 51.5952367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008900',
        LOCATION_NAME: 'Ashington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6248959,
        LOCATION_LATITUDE_DEG: 50.9897218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008800',
        LOCATION_NAME: 'Ashington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9966097,
        LOCATION_LATITUDE_DEG: 50.7789945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS008700',
        LOCATION_NAME: 'Ashington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.576414,
        LOCATION_LATITUDE_DEG: 55.1830178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009000',
        LOCATION_NAME: 'Ashington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3884172,
        LOCATION_LATITUDE_DEG: 50.9329942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009100',
        LOCATION_NAME: 'Ashington End',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2940235,
        LOCATION_LATITUDE_DEG: 53.1762009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009200',
        LOCATION_NAME: 'Ashkirk',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8338862,
        LOCATION_LATITUDE_DEG: 55.4912616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009300',
        LOCATION_NAME: 'Ashland',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.728297,
        LOCATION_LATITUDE_DEG: 52.0148986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009400',
        LOCATION_NAME: 'Ashleworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2728685,
        LOCATION_LATITUDE_DEG: 51.9299098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009600',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4960413,
        LOCATION_LATITUDE_DEG: 50.8887252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009800',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3531034,
        LOCATION_LATITUDE_DEG: 52.9243046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009900',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3401968,
        LOCATION_LATITUDE_DEG: 53.354651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010100',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0982436,
        LOCATION_LATITUDE_DEG: 51.6519796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010250',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4598134,
        LOCATION_LATITUDE_DEG: 51.0845469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010200',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4586143,
        LOCATION_LATITUDE_DEG: 51.079622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010000',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8297068,
        LOCATION_LATITUDE_DEG: 52.5105531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009500',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4852804,
        LOCATION_LATITUDE_DEG: 52.2261995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS009700',
        LOCATION_NAME: 'Ashley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3045767,
        LOCATION_LATITUDE_DEG: 51.1897921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010300',
        LOCATION_NAME: 'Ashley Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5771462,
        LOCATION_LATITUDE_DEG: 51.4786748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010400',
        LOCATION_NAME: 'Ashley Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5857196,
        LOCATION_LATITUDE_DEG: 51.7371738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010600',
        LOCATION_NAME: 'Ashley Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3822714,
        LOCATION_LATITUDE_DEG: 52.9221106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010500',
        LOCATION_NAME: 'Ashley Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8364266,
        LOCATION_LATITUDE_DEG: 50.8408007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS026600',
        LOCATION_NAME: 'Ashley Hill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5811043,
        LOCATION_LATITUDE_DEG: 51.472828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS026500',
        LOCATION_NAME: 'Ashley Hill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.580676,
        LOCATION_LATITUDE_DEG: 51.4708517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010700',
        LOCATION_NAME: 'Ashley Park',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4171482,
        LOCATION_LATITUDE_DEG: 51.3736323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010800',
        LOCATION_NAME: 'Ashley Warren',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2942346,
        LOCATION_LATITUDE_DEG: 51.2955427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS010900',
        LOCATION_NAME: 'Ashmanhaugh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4290898,
        LOCATION_LATITUDE_DEG: 52.7374376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011000',
        LOCATION_NAME: 'Ashmansworth',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3862116,
        LOCATION_LATITUDE_DEG: 51.3125449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011100',
        LOCATION_NAME: 'Ashmead Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.336518,
        LOCATION_LATITUDE_DEG: 51.6960863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011200',
        LOCATION_NAME: 'Ashmore',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1155651,
        LOCATION_LATITUDE_DEG: 50.9620176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011300',
        LOCATION_NAME: 'Ashmore Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2758278,
        LOCATION_LATITUDE_DEG: 51.4205483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011400',
        LOCATION_NAME: 'Ashmore Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.05858,
        LOCATION_LATITUDE_DEG: 52.6130758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011500',
        LOCATION_NAME: 'Ashorne',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.552976,
        LOCATION_LATITUDE_DEG: 52.2167339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011600',
        LOCATION_NAME: 'Ashorne Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5475703,
        LOCATION_LATITUDE_DEG: 52.2243291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011700',
        LOCATION_NAME: 'Ashover',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.478707,
        LOCATION_LATITUDE_DEG: 53.1627187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011800',
        LOCATION_NAME: 'Ashover Hay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.46513,
        LOCATION_LATITUDE_DEG: 53.1418194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS011900',
        LOCATION_NAME: 'Ashow',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5492708,
        LOCATION_LATITUDE_DEG: 52.3310454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012000',
        LOCATION_NAME: 'Ashperton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5192252,
        LOCATION_LATITUDE_DEG: 52.0724288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012100',
        LOCATION_NAME: 'Ashprington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6654704,
        LOCATION_LATITUDE_DEG: 50.3994825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012200',
        LOCATION_NAME: 'Ashreigney',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9498029,
        LOCATION_LATITUDE_DEG: 50.905529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012300',
        LOCATION_NAME: 'Ashridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1406001,
        LOCATION_LATITUDE_DEG: 51.0199431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS990453',
        LOCATION_NAME: 'Ashtead',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.302847,
        LOCATION_LATITUDE_DEG: 51.2723106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012600',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3511952,
        LOCATION_LATITUDE_DEG: 50.108566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012700',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2774379,
        LOCATION_LATITUDE_DEG: 50.4928976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012900',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8396737,
        LOCATION_LATITUDE_DEG: 51.2431557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013000',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7414226,
        LOCATION_LATITUDE_DEG: 53.2171379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013200',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7089282,
        LOCATION_LATITUDE_DEG: 52.2718463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012800',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6100485,
        LOCATION_LATITUDE_DEG: 51.4318722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS012500',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8812569,
        LOCATION_LATITUDE_DEG: 52.1417186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013300',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4460151,
        LOCATION_LATITUDE_DEG: 52.481939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013100',
        LOCATION_NAME: 'Ashton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3708826,
        LOCATION_LATITUDE_DEG: 52.6373591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013400',
        LOCATION_NAME: 'Ashton Common',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1459472,
        LOCATION_LATITUDE_DEG: 51.3221558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013500',
        LOCATION_NAME: 'Ashton Gate',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6167453,
        LOCATION_LATITUDE_DEG: 51.4398676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS991107',
        LOCATION_NAME: 'Ashton Hayes',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.74,
        LOCATION_LATITUDE_DEG: 53.219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025600',
        LOCATION_NAME: 'Ashton in Makerfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013600',
        LOCATION_NAME: 'Ashton Keynes',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9311559,
        LOCATION_LATITUDE_DEG: 51.6451844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025700',
        LOCATION_NAME: 'Ashton on Ribble',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025800',
        LOCATION_NAME: 'Ashton under Hill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025900',
        LOCATION_NAME: 'Ashton under Lyne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013700',
        LOCATION_NAME: 'Ashton Vale',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6308438,
        LOCATION_LATITUDE_DEG: 51.4448735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013800',
        LOCATION_NAME: 'Ashton With Stodday',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8177756,
        LOCATION_LATITUDE_DEG: 54.0125201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS013900',
        LOCATION_NAME: 'Ashton-in-Makerfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6366813,
        LOCATION_LATITUDE_DEG: 53.487268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014000',
        LOCATION_NAME: 'Ashton-on-Ribble',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7311924,
        LOCATION_LATITUDE_DEG: 53.7665969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014100',
        LOCATION_NAME: 'Ashton-under-Hill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0041119,
        LOCATION_LATITUDE_DEG: 52.041517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014200',
        LOCATION_NAME: 'Ashton-under-Lyne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0961778,
        LOCATION_LATITUDE_DEG: 53.4873608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014500',
        LOCATION_NAME: 'Ashurst',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5225424,
        LOCATION_LATITUDE_DEG: 50.8912018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014600',
        LOCATION_NAME: 'Ashurst',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3238736,
        LOCATION_LATITUDE_DEG: 50.9316897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014400',
        LOCATION_NAME: 'Ashurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1601479,
        LOCATION_LATITUDE_DEG: 51.1302066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014700',
        LOCATION_NAME: 'Ashurst Wood',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0274184,
        LOCATION_LATITUDE_DEG: 51.110206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014800',
        LOCATION_NAME: 'Ashwater',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2821267,
        LOCATION_LATITUDE_DEG: 50.7328173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015000',
        LOCATION_NAME: 'Ashwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.55336,
        LOCATION_LATITUDE_DEG: 50.558792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014900',
        LOCATION_NAME: 'Ashwell',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9074895,
        LOCATION_LATITUDE_DEG: 50.9375224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS990109',
        LOCATION_NAME: 'Ashwell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7187519,
        LOCATION_LATITUDE_DEG: 52.7174825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015200',
        LOCATION_NAME: 'Ashwell',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7175757,
        LOCATION_LATITUDE_DEG: 52.71417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015100',
        LOCATION_NAME: 'Ashwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1533463,
        LOCATION_LATITUDE_DEG: 52.0400933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015300',
        LOCATION_NAME: 'Ashwellthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1581185,
        LOCATION_LATITUDE_DEG: 52.5341242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015400',
        LOCATION_NAME: 'Ashwick',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6146582,
        LOCATION_LATITUDE_DEG: 51.0697417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015500',
        LOCATION_NAME: 'Ashwicke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3077405,
        LOCATION_LATITUDE_DEG: 51.4401687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015600',
        LOCATION_NAME: 'Ashwicken',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.518699,
        LOCATION_LATITUDE_DEG: 52.7406507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015700',
        LOCATION_NAME: 'Askam-in-Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2026941,
        LOCATION_LATITUDE_DEG: 54.1885386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015900',
        LOCATION_NAME: 'Aske',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7257571,
        LOCATION_LATITUDE_DEG: 54.4253456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016100',
        LOCATION_NAME: 'Askern',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1506204,
        LOCATION_LATITUDE_DEG: 53.6156577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016200',
        LOCATION_NAME: 'Askernish',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4034185,
        LOCATION_LATITUDE_DEG: 57.1826093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016300',
        LOCATION_NAME: 'Askerswell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6673073,
        LOCATION_LATITUDE_DEG: 50.7321979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016400',
        LOCATION_NAME: 'Askerton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7027547,
        LOCATION_LATITUDE_DEG: 55.0156163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016500',
        LOCATION_NAME: 'Askett',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.819465,
        LOCATION_LATITUDE_DEG: 51.7393768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016600',
        LOCATION_NAME: 'Askham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.754341,
        LOCATION_LATITUDE_DEG: 54.6056722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016700',
        LOCATION_NAME: 'Askham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8900626,
        LOCATION_LATITUDE_DEG: 53.2667251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016800',
        LOCATION_NAME: 'Askham Bryan',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1592478,
        LOCATION_LATITUDE_DEG: 53.9287904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016900',
        LOCATION_NAME: 'Askham Richard',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1823792,
        LOCATION_LATITUDE_DEG: 53.9243927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017200',
        LOCATION_NAME: 'Askrigg',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0797257,
        LOCATION_LATITUDE_DEG: 54.3146358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017300',
        LOCATION_NAME: 'Askwith',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7406664,
        LOCATION_LATITUDE_DEG: 53.9300957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017400',
        LOCATION_NAME: 'Aslackby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3875433,
        LOCATION_LATITUDE_DEG: 52.8595793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017500',
        LOCATION_NAME: 'Aslackby Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3027744,
        LOCATION_LATITUDE_DEG: 52.8546753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017600',
        LOCATION_NAME: 'Aslacton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1753583,
        LOCATION_LATITUDE_DEG: 52.4744155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017700',
        LOCATION_NAME: 'Aslockton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8958381,
        LOCATION_LATITUDE_DEG: 52.951688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017800',
        LOCATION_NAME: 'Aspall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1774182,
        LOCATION_LATITUDE_DEG: 52.2445994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017900',
        LOCATION_NAME: 'Aspall Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1774467,
        LOCATION_LATITUDE_DEG: 52.249096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018000',
        LOCATION_NAME: 'Aspatria',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3238926,
        LOCATION_LATITUDE_DEG: 54.7644997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018100',
        LOCATION_NAME: 'Aspenden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0190333,
        LOCATION_LATITUDE_DEG: 51.9355792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018200',
        LOCATION_NAME: 'Aspley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7980906,
        LOCATION_LATITUDE_DEG: 53.6263668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018300',
        LOCATION_NAME: 'Aspley Guise',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6267466,
        LOCATION_LATITUDE_DEG: 52.0134977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018400',
        LOCATION_NAME: 'Aspley Heath',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6449962,
        LOCATION_LATITUDE_DEG: 52.0099952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018500',
        LOCATION_NAME: 'Aspull',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5818527,
        LOCATION_LATITUDE_DEG: 53.5702693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018600',
        LOCATION_NAME: 'Asselby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9105482,
        LOCATION_LATITUDE_DEG: 53.743569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018700',
        LOCATION_NAME: 'Asserby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2408184,
        LOCATION_LATITUDE_DEG: 53.2749102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018800',
        LOCATION_NAME: 'Assington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8182497,
        LOCATION_LATITUDE_DEG: 52.0071782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS018900',
        LOCATION_NAME: 'Assington Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.591238,
        LOCATION_LATITUDE_DEG: 52.1345937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019000',
        LOCATION_NAME: 'Astbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2308965,
        LOCATION_LATITUDE_DEG: 53.1508248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019100',
        LOCATION_NAME: 'Astcote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0097005,
        LOCATION_LATITUDE_DEG: 52.1729178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019300',
        LOCATION_NAME: 'Asterby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1011352,
        LOCATION_LATITUDE_DEG: 53.2975173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019400',
        LOCATION_NAME: 'Asterley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9248109,
        LOCATION_LATITUDE_DEG: 52.6572859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019500',
        LOCATION_NAME: 'Asterton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8873476,
        LOCATION_LATITUDE_DEG: 52.514973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019600',
        LOCATION_NAME: 'Asthall',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5820728,
        LOCATION_LATITUDE_DEG: 51.798093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019700',
        LOCATION_NAME: 'Asthall Leigh',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5534693,
        LOCATION_LATITUDE_DEG: 51.8116919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020100',
        LOCATION_NAME: 'Astley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6973558,
        LOCATION_LATITUDE_DEG: 52.7647006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019900',
        LOCATION_NAME: 'Astley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4402611,
        LOCATION_LATITUDE_DEG: 53.4908677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019800',
        LOCATION_NAME: 'Astley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3124581,
        LOCATION_LATITUDE_DEG: 52.3055521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020000',
        LOCATION_NAME: 'Astley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5412049,
        LOCATION_LATITUDE_DEG: 52.4990595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020200',
        LOCATION_NAME: 'Astley Abbots',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4294396,
        LOCATION_LATITUDE_DEG: 52.5616751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020300',
        LOCATION_NAME: 'Astley Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4317589,
        LOCATION_LATITUDE_DEG: 53.6079775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020400',
        LOCATION_NAME: 'Astley Cross',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2912115,
        LOCATION_LATITUDE_DEG: 52.324551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020500',
        LOCATION_NAME: 'Astmoor',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6938954,
        LOCATION_LATITUDE_DEG: 53.3438502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020600',
        LOCATION_NAME: 'Astmoor Bridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6864983,
        LOCATION_LATITUDE_DEG: 53.3378518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020700',
        LOCATION_NAME: 'Astol',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3854877,
        LOCATION_LATITUDE_DEG: 52.6018808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020800',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0350773,
        LOCATION_LATITUDE_DEG: 53.1952065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021200',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7915813,
        LOCATION_LATITUDE_DEG: 52.3434598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021100',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6603111,
        LOCATION_LATITUDE_DEG: 53.2994508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021900',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.579979,
        LOCATION_LATITUDE_DEG: 53.0163205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021000',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5736301,
        LOCATION_LATITUDE_DEG: 52.68299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021500',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3667175,
        LOCATION_LATITUDE_DEG: 52.9668147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021300',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1589911,
        LOCATION_LATITUDE_DEG: 52.8087913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021800',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1308337,
        LOCATION_LATITUDE_DEG: 52.8788973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021700',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8697238,
        LOCATION_LATITUDE_DEG: 52.5034646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021400',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5062609,
        LOCATION_LATITUDE_DEG: 51.7241801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021950',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5058134,
        LOCATION_LATITUDE_DEG: 51.7293668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS021600',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2964246,
        LOCATION_LATITUDE_DEG: 53.3624385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS020900',
        LOCATION_NAME: 'Aston',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1475614,
        LOCATION_LATITUDE_DEG: 51.8881839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022000',
        LOCATION_NAME: 'Aston Abbotts',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7691866,
        LOCATION_LATITUDE_DEG: 51.8725888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022100',
        LOCATION_NAME: 'Aston Botterell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5412171,
        LOCATION_LATITUDE_DEG: 52.4553651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024000',
        LOCATION_NAME: 'Aston by Budworth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4775804,
        LOCATION_LATITUDE_DEG: 53.3051499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022200',
        LOCATION_NAME: 'Aston Cantlow',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7957248,
        LOCATION_LATITUDE_DEG: 52.2340378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022300',
        LOCATION_NAME: 'Aston Clinton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7194045,
        LOCATION_LATITUDE_DEG: 51.7987774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022400',
        LOCATION_NAME: 'Aston Crews',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4765841,
        LOCATION_LATITUDE_DEG: 51.9060082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022500',
        LOCATION_NAME: 'Aston Cross',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0842792,
        LOCATION_LATITUDE_DEG: 52.0020133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022600',
        LOCATION_NAME: 'Aston End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1496126,
        LOCATION_LATITUDE_DEG: 51.9015798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022700',
        LOCATION_NAME: 'Aston Eyre',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5108394,
        LOCATION_LATITUDE_DEG: 52.5430732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022800',
        LOCATION_NAME: 'Aston Fields',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0468678,
        LOCATION_LATITUDE_DEG: 52.3228506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS022900',
        LOCATION_NAME: 'Aston Flamville',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3179308,
        LOCATION_LATITUDE_DEG: 52.5306569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023000',
        LOCATION_NAME: 'Aston Ingham',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4585516,
        LOCATION_LATITUDE_DEG: 51.9097126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023100',
        LOCATION_NAME: 'Aston Juxta Mondrum',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5328722,
        LOCATION_LATITUDE_DEG: 53.104825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024100',
        LOCATION_NAME: 'Aston le Walls',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2758494,
        LOCATION_LATITUDE_DEG: 52.1526243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023200',
        LOCATION_NAME: 'Aston Magna',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7118405,
        LOCATION_LATITUDE_DEG: 52.0190092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023300',
        LOCATION_NAME: 'Aston Munslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7203128,
        LOCATION_LATITUDE_DEG: 52.4756652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025300',
        LOCATION_NAME: 'Aston on Carrant',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025400',
        LOCATION_NAME: 'Aston on Clun',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025500',
        LOCATION_NAME: 'Aston on Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023400',
        LOCATION_NAME: 'Aston Rogers',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9723183,
        LOCATION_LATITUDE_DEG: 52.6512862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023500',
        LOCATION_NAME: 'Aston Rowant',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9484111,
        LOCATION_LATITUDE_DEG: 51.6842721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023600',
        LOCATION_NAME: 'Aston Sandford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9060876,
        LOCATION_LATITUDE_DEG: 51.7619769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023700',
        LOCATION_NAME: 'Aston Somerville',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9338424,
        LOCATION_LATITUDE_DEG: 52.0426225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024200',
        LOCATION_NAME: 'Aston sub Edge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8001591,
        LOCATION_LATITUDE_DEG: 52.0714697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023800',
        LOCATION_NAME: 'Aston Tirrold',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1965997,
        LOCATION_LATITUDE_DEG: 51.5691672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS023900',
        LOCATION_NAME: 'Aston Upthorpe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2012518,
        LOCATION_LATITUDE_DEG: 51.5729668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024300',
        LOCATION_NAME: 'Aston-on-Carrant',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0772989,
        LOCATION_LATITUDE_DEG: 52.0093194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024400',
        LOCATION_NAME: 'Aston-on-Clun',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9002091,
        LOCATION_LATITUDE_DEG: 52.428874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024500',
        LOCATION_NAME: 'Aston-on-Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3835473,
        LOCATION_LATITUDE_DEG: 52.8608899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024600',
        LOCATION_NAME: 'Astrope',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7085465,
        LOCATION_LATITUDE_DEG: 51.8249799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024700',
        LOCATION_NAME: 'Astwood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.60896,
        LOCATION_LATITUDE_DEG: 52.1156122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024800',
        LOCATION_NAME: 'Astwood Bank',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B96',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9360255,
        LOCATION_LATITUDE_DEG: 52.2597417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS024900',
        LOCATION_NAME: 'Aswarby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4120142,
        LOCATION_LATITUDE_DEG: 52.9456862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS025000',
        LOCATION_NAME: 'Aswardby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0643398,
        LOCATION_LATITUDE_DEG: 53.2118027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000100',
        LOCATION_NAME: 'Atch Lench',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9504873,
        LOCATION_LATITUDE_DEG: 52.1549266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000200',
        LOCATION_NAME: 'Atcham',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6785107,
        LOCATION_LATITUDE_DEG: 52.6793882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000600',
        LOCATION_NAME: 'Athelhampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3223448,
        LOCATION_LATITUDE_DEG: 50.7539965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000700',
        LOCATION_NAME: 'Athelington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2373694,
        LOCATION_LATITUDE_DEG: 52.2935025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000800',
        LOCATION_NAME: 'Athelney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9314886,
        LOCATION_LATITUDE_DEG: 51.0564347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000900',
        LOCATION_NAME: 'Athelstaneford',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7440264,
        LOCATION_LATITUDE_DEG: 55.9869106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001100',
        LOCATION_NAME: 'Atherfield',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3507712,
        LOCATION_LATITUDE_DEG: 50.6175739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001200',
        LOCATION_NAME: 'Atherfield Green',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3436495,
        LOCATION_LATITUDE_DEG: 50.6132708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001300',
        LOCATION_NAME: 'Atherington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0077998,
        LOCATION_LATITUDE_DEG: 50.9894447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001350',
        LOCATION_NAME: 'Athersley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4886505,
        LOCATION_LATITUDE_DEG: 53.6022882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001400',
        LOCATION_NAME: 'Atherstone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.544924,
        LOCATION_LATITUDE_DEG: 52.5768639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001500',
        LOCATION_NAME: 'Atherstone on Stour',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7001227,
        LOCATION_LATITUDE_DEG: 52.1562283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001600',
        LOCATION_NAME: 'Atherton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4950553,
        LOCATION_LATITUDE_DEG: 53.5232674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002500',
        LOCATION_NAME: 'Atlantic Wharf',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1631982,
        LOCATION_LATITUDE_DEG: 51.4732739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002600',
        LOCATION_NAME: 'Atlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6553769,
        LOCATION_LATITUDE_DEG: 53.0365103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002800',
        LOCATION_NAME: 'Attenborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2313143,
        LOCATION_LATITUDE_DEG: 52.9062947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002900',
        LOCATION_NAME: 'Atterby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5227871,
        LOCATION_LATITUDE_DEG: 53.4243363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT004200',
        LOCATION_NAME: 'Attercliffe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4392916,
        LOCATION_LATITUDE_DEG: 53.3895711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003000',
        LOCATION_NAME: 'Atterley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5281422,
        LOCATION_LATITUDE_DEG: 52.5753738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003100',
        LOCATION_NAME: 'Atterton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4758176,
        LOCATION_LATITUDE_DEG: 52.5811636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003300',
        LOCATION_NAME: 'Attingham',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6773227,
        LOCATION_LATITUDE_DEG: 52.6857875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003500',
        LOCATION_NAME: 'Attleborough',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4564998,
        LOCATION_LATITUDE_DEG: 52.5152533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003400',
        LOCATION_NAME: 'Attleborough',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0208814,
        LOCATION_LATITUDE_DEG: 52.5179221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003600',
        LOCATION_NAME: 'Attlebridge',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1527274,
        LOCATION_LATITUDE_DEG: 52.7068431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003900',
        LOCATION_NAME: 'Atwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1862587,
        LOCATION_LATITUDE_DEG: 53.94008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT004000',
        LOCATION_NAME: 'Atworth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1955448,
        LOCATION_LATITUDE_DEG: 51.3921549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000100',
        LOCATION_NAME: 'Auberrow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7425928,
        LOCATION_LATITUDE_DEG: 52.1215332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000200',
        LOCATION_NAME: 'Aubourn',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6153148,
        LOCATION_LATITUDE_DEG: 53.1532119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000300',
        LOCATION_NAME: 'Auchaleek',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6272402,
        LOCATION_LATITUDE_DEG: 55.4436851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000400',
        LOCATION_NAME: 'Auchattie',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5049362,
        LOCATION_LATITUDE_DEG: 57.0409098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000500',
        LOCATION_NAME: 'Auchenblae',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4473553,
        LOCATION_LATITUDE_DEG: 56.8985994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000600',
        LOCATION_NAME: 'Auchenbowie',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9397094,
        LOCATION_LATITUDE_DEG: 56.0691371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000700',
        LOCATION_NAME: 'Auchencairn',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8707017,
        LOCATION_LATITUDE_DEG: 54.8420114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000800',
        LOCATION_NAME: 'Auchencrow',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2341071,
        LOCATION_LATITUDE_DEG: 55.8388865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU000900',
        LOCATION_NAME: 'Auchendinny',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1909171,
        LOCATION_LATITUDE_DEG: 55.8464033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001000',
        LOCATION_NAME: 'Auchengate',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6407182,
        LOCATION_LATITUDE_DEG: 55.5752919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001100',
        LOCATION_NAME: 'Auchengray',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6005462,
        LOCATION_LATITUDE_DEG: 55.771197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001200',
        LOCATION_NAME: 'Auchenheath',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8929182,
        LOCATION_LATITUDE_DEG: 55.671895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001300',
        LOCATION_NAME: 'Auchenmalg',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7494216,
        LOCATION_LATITUDE_DEG: 54.8326206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001400',
        LOCATION_NAME: 'Auchentiber',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6018108,
        LOCATION_LATITUDE_DEG: 55.690104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001500',
        LOCATION_NAME: 'Auchincruive',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5604909,
        LOCATION_LATITUDE_DEG: 55.4789805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001600',
        LOCATION_NAME: 'Auchindoun',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0716773,
        LOCATION_LATITUDE_DEG: 57.446861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001700',
        LOCATION_NAME: 'Auchindrean',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0421786,
        LOCATION_LATITUDE_DEG: 57.7776131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001800',
        LOCATION_NAME: 'Auchinleck',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.423623,
        LOCATION_LATITUDE_DEG: 55.0077335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU001900',
        LOCATION_NAME: 'Auchinloch',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1412957,
        LOCATION_LATITUDE_DEG: 55.9116216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002000',
        LOCATION_NAME: 'Auchleuchries',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9747921,
        LOCATION_LATITUDE_DEG: 57.4171403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002100',
        LOCATION_NAME: 'Auchleven',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6229238,
        LOCATION_LATITUDE_DEG: 57.3101401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002200',
        LOCATION_NAME: 'Auchmacoy',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0129862,
        LOCATION_LATITUDE_DEG: 57.3683426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002300',
        LOCATION_NAME: 'Auchmillan',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3542586,
        LOCATION_LATITUDE_DEG: 55.5380817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002400',
        LOCATION_NAME: 'Auchmithie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5247825,
        LOCATION_LATITUDE_DEG: 56.5886725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002500',
        LOCATION_NAME: 'Auchmuirbridge',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2590586,
        LOCATION_LATITUDE_DEG: 56.1964422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002600',
        LOCATION_NAME: 'Auchnagatt',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1149707,
        LOCATION_LATITUDE_DEG: 57.4661502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002700',
        LOCATION_NAME: 'Auchnarrow',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.298109,
        LOCATION_LATITUDE_DEG: 57.287446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002800',
        LOCATION_NAME: 'Auchterarder',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.715759,
        LOCATION_LATITUDE_DEG: 56.2925546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU002900',
        LOCATION_NAME: 'Auchterawe',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7200078,
        LOCATION_LATITUDE_DEG: 57.1362475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003000',
        LOCATION_NAME: 'Auchterderran',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2612224,
        LOCATION_LATITUDE_DEG: 56.1469325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003100',
        LOCATION_NAME: 'Auchterforfar',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8466878,
        LOCATION_LATITUDE_DEG: 56.6387787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003200',
        LOCATION_NAME: 'Auchterhouse',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0856844,
        LOCATION_LATITUDE_DEG: 56.5249729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003300',
        LOCATION_NAME: 'Auchterless',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4791124,
        LOCATION_LATITUDE_DEG: 57.4626514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003400',
        LOCATION_NAME: 'Auchtermuchty',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2315011,
        LOCATION_LATITUDE_DEG: 56.292144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003500',
        LOCATION_NAME: 'Auchterneed',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5283644,
        LOCATION_LATITUDE_DEG: 57.601188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003600',
        LOCATION_NAME: 'Auchtertool',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2589921,
        LOCATION_LATITUDE_DEG: 56.1028321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003700',
        LOCATION_NAME: 'Auchtubh',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3347459,
        LOCATION_LATITUDE_DEG: 56.3560678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003800',
        LOCATION_NAME: 'Auckengill',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0846409,
        LOCATION_LATITUDE_DEG: 58.5596707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU003900',
        LOCATION_NAME: 'Auckland Park',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6520112,
        LOCATION_LATITUDE_DEG: 54.6544655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004000',
        LOCATION_NAME: 'Auckley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.019377,
        LOCATION_LATITUDE_DEG: 53.5019497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004100',
        LOCATION_NAME: 'Audenshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.112011,
        LOCATION_LATITUDE_DEG: 53.472856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004200',
        LOCATION_NAME: 'Audleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.309256,
        LOCATION_LATITUDE_DEG: 53.5260381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004300',
        LOCATION_NAME: 'Audlem',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5069304,
        LOCATION_LATITUDE_DEG: 52.9884157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004400',
        LOCATION_NAME: 'Audley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3003683,
        LOCATION_LATITUDE_DEG: 53.0555187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004500',
        LOCATION_NAME: 'Audley Brow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5428962,
        LOCATION_LATITUDE_DEG: 52.9124049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004600',
        LOCATION_NAME: 'Audley End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.232104,
        LOCATION_LATITUDE_DEG: 52.0175913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004700',
        LOCATION_NAME: 'Audnam',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1588188,
        LOCATION_LATITUDE_DEG: 52.4716645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004900',
        LOCATION_NAME: 'Aughafatten',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1275992,
        LOCATION_LATITUDE_DEG: 54.8871382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU990772',
        LOCATION_NAME: 'Aughamullan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005600',
        LOCATION_NAME: 'Augher',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1270134,
        LOCATION_LATITUDE_DEG: 54.4318021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005700',
        LOCATION_NAME: 'Aughertree',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1581498,
        LOCATION_LATITUDE_DEG: 54.7353929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006000',
        LOCATION_NAME: 'Aughnacloy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9733039,
        LOCATION_LATITUDE_DEG: 54.4119032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006800',
        LOCATION_NAME: 'Aughton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9181914,
        LOCATION_LATITUDE_DEG: 53.5420724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006900',
        LOCATION_NAME: 'Aughton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6827305,
        LOCATION_LATITUDE_DEG: 54.102523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006600',
        LOCATION_NAME: 'Aughton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3223546,
        LOCATION_LATITUDE_DEG: 53.3649349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006700',
        LOCATION_NAME: 'Aughton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9284957,
        LOCATION_LATITUDE_DEG: 53.8391812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007000',
        LOCATION_NAME: 'Aughton Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8971292,
        LOCATION_LATITUDE_DEG: 53.545972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007100',
        LOCATION_NAME: 'Auldearn',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8080371,
        LOCATION_LATITUDE_DEG: 57.5772837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007200',
        LOCATION_NAME: 'Aulden',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7853703,
        LOCATION_LATITUDE_DEG: 52.1891434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007300',
        LOCATION_NAME: 'Auldgirth',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7051469,
        LOCATION_LATITUDE_DEG: 55.160443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007400',
        LOCATION_NAME: 'Auldhame',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6500281,
        LOCATION_LATITUDE_DEG: 56.0502177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008700',
        LOCATION_NAME: 'Auldhouse',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1921453,
        LOCATION_LATITUDE_DEG: 55.7272547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007500',
        LOCATION_NAME: 'Aultbea',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5848085,
        LOCATION_LATITUDE_DEG: 57.841129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007600',
        LOCATION_NAME: 'Aultgrishan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8012437,
        LOCATION_LATITUDE_DEG: 57.8045288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007700',
        LOCATION_NAME: 'Aunby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4875213,
        LOCATION_LATITUDE_DEG: 52.7197665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007800',
        LOCATION_NAME: 'Aunsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4439489,
        LOCATION_LATITUDE_DEG: 52.9363892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU007900',
        LOCATION_NAME: 'Ausewell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7761801,
        LOCATION_LATITUDE_DEG: 50.5276952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008000',
        LOCATION_NAME: 'Aust',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6144072,
        LOCATION_LATITUDE_DEG: 51.5978798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008100',
        LOCATION_NAME: 'Austerfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0049364,
        LOCATION_LATITUDE_DEG: 53.4431443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008200',
        LOCATION_NAME: 'Austerlands',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0663332,
        LOCATION_LATITUDE_DEG: 53.5446618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008300',
        LOCATION_NAME: 'Austerson',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5172037,
        LOCATION_LATITUDE_DEG: 53.0427178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008400',
        LOCATION_NAME: 'Austrey',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5639801,
        LOCATION_LATITUDE_DEG: 52.655372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008500',
        LOCATION_NAME: 'Austwick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.355735,
        LOCATION_LATITUDE_DEG: 54.1108191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU008600',
        LOCATION_NAME: 'Authorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1009258,
        LOCATION_LATITUDE_DEG: 53.3077143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000100',
        LOCATION_NAME: 'Avebury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8517503,
        LOCATION_LATITUDE_DEG: 51.4263604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000200',
        LOCATION_NAME: 'Avebury Trusloe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8625778,
        LOCATION_LATITUDE_DEG: 51.4229564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000300',
        LOCATION_NAME: 'Aveley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2534347,
        LOCATION_LATITUDE_DEG: 51.4988402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000400',
        LOCATION_NAME: 'Avenbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4984113,
        LOCATION_LATITUDE_DEG: 52.163541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000500',
        LOCATION_NAME: 'Avening',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1725691,
        LOCATION_LATITUDE_DEG: 51.6803904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000600',
        LOCATION_NAME: 'Averham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8594401,
        LOCATION_LATITUDE_DEG: 53.0823026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000700',
        LOCATION_NAME: 'Aveton Gifford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.834651,
        LOCATION_LATITUDE_DEG: 50.3136779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000800',
        LOCATION_NAME: 'Aviemore',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8276664,
        LOCATION_LATITUDE_DEG: 57.194347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001000',
        LOCATION_NAME: 'Avington',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4658855,
        LOCATION_LATITUDE_DEG: 51.4095541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV000900',
        LOCATION_NAME: 'Avington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2419859,
        LOCATION_LATITUDE_DEG: 51.0840209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001100',
        LOCATION_NAME: 'Avishays',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9205979,
        LOCATION_LATITUDE_DEG: 50.877621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001300',
        LOCATION_NAME: 'Avoch',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1742676,
        LOCATION_LATITUDE_DEG: 57.5672863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001400',
        LOCATION_NAME: 'Avochie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.772257,
        LOCATION_LATITUDE_DEG: 57.50706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001600',
        LOCATION_NAME: 'Avon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0591006,
        LOCATION_LATITUDE_DEG: 51.4882632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001500',
        LOCATION_NAME: 'Avon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.791975,
        LOCATION_LATITUDE_DEG: 50.7880995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001700',
        LOCATION_NAME: 'Avon Dassett',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4023831,
        LOCATION_LATITUDE_DEG: 52.1449171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001800',
        LOCATION_NAME: 'Avon Tyrrell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.738883,
        LOCATION_LATITUDE_DEG: 50.8008986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001900',
        LOCATION_NAME: 'Avonbridge',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7414506,
        LOCATION_LATITUDE_DEG: 55.9346152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV002000',
        LOCATION_NAME: 'Avoncliff',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2764121,
        LOCATION_LATITUDE_DEG: 51.3370555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV002100',
        LOCATION_NAME: 'Avonmouth',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.684785,
        LOCATION_LATITUDE_DEG: 51.5153702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV002200',
        LOCATION_NAME: 'Avonwick',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8103109,
        LOCATION_LATITUDE_DEG: 50.4098843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AW000100',
        LOCATION_NAME: 'Awbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.526424,
        LOCATION_LATITUDE_DEG: 51.0103174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AW000200',
        LOCATION_NAME: 'Awliscombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2272586,
        LOCATION_LATITUDE_DEG: 50.8072189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AW000300',
        LOCATION_NAME: 'Awre',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4238275,
        LOCATION_LATITUDE_DEG: 51.7699985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AW000400',
        LOCATION_NAME: 'Awsworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2821085,
        LOCATION_LATITUDE_DEG: 52.9883001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX990551',
        LOCATION_NAME: 'Axbridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8117963,
        LOCATION_LATITUDE_DEG: 51.2873555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX000200',
        LOCATION_NAME: 'Axford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6615258,
        LOCATION_LATITUDE_DEG: 51.4282586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX000300',
        LOCATION_NAME: 'Axford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1274783,
        LOCATION_LATITUDE_DEG: 51.1860247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX000400',
        LOCATION_NAME: 'Axmansford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1829104,
        LOCATION_LATITUDE_DEG: 51.3415464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX000500',
        LOCATION_NAME: 'Axminster',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9967453,
        LOCATION_LATITUDE_DEG: 50.7820119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX000600',
        LOCATION_NAME: 'Axmouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0461004,
        LOCATION_LATITUDE_DEG: 50.7133065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX000700',
        LOCATION_NAME: 'Axton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3426075,
        LOCATION_LATITUDE_DEG: 53.3091586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AX000800',
        LOCATION_NAME: 'Axton Hill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9863747,
        LOCATION_LATITUDE_DEG: 51.6491108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000100',
        LOCATION_NAME: 'Aychley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5834052,
        LOCATION_LATITUDE_DEG: 52.9044092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000200',
        LOCATION_NAME: 'Aycliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5593005,
        LOCATION_LATITUDE_DEG: 54.5968571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000300',
        LOCATION_NAME: 'Aydon',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9832758,
        LOCATION_LATITUDE_DEG: 54.9892086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000400',
        LOCATION_NAME: 'Aydon Castle',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9978584,
        LOCATION_LATITUDE_DEG: 54.9931012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000500',
        LOCATION_NAME: 'Aykley Heads',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5832013,
        LOCATION_LATITUDE_DEG: 54.787581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000600',
        LOCATION_NAME: 'Aylburton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5526769,
        LOCATION_LATITUDE_DEG: 51.7140982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000700',
        LOCATION_NAME: 'Ayle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4219023,
        LOCATION_LATITUDE_DEG: 54.8400957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000800',
        LOCATION_NAME: 'Aylesbeare',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3613596,
        LOCATION_LATITUDE_DEG: 50.7165091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY000900',
        LOCATION_NAME: 'Aylesbury',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8152478,
        LOCATION_LATITUDE_DEG: 51.8152853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001000',
        LOCATION_NAME: 'Aylesby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1845053,
        LOCATION_LATITUDE_DEG: 53.5514415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001100',
        LOCATION_NAME: 'Aylesford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4832435,
        LOCATION_LATITUDE_DEG: 51.3031177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001200',
        LOCATION_NAME: 'Aylesham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2031149,
        LOCATION_LATITUDE_DEG: 51.2252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001300',
        LOCATION_NAME: 'Aylesmore',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5505288,
        LOCATION_LATITUDE_DEG: 52.0747205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001400',
        LOCATION_NAME: 'Aylestone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1501921,
        LOCATION_LATITUDE_DEG: 52.6049621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001500',
        LOCATION_NAME: 'Aylmerton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.244038,
        LOCATION_LATITUDE_DEG: 52.9100612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001600',
        LOCATION_NAME: 'Aylsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2538068,
        LOCATION_LATITUDE_DEG: 52.796051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001700',
        LOCATION_NAME: 'Aylton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4976761,
        LOCATION_LATITUDE_DEG: 52.0359253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001800',
        LOCATION_NAME: 'Aymestrey',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8422918,
        LOCATION_LATITUDE_DEG: 52.2794493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY001900',
        LOCATION_NAME: 'Aynho',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2507449,
        LOCATION_LATITUDE_DEG: 51.9943015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY003000',
        LOCATION_NAME: 'Ayot St Lawrence',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY003100',
        LOCATION_NAME: 'Ayot St Peter',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002000',
        LOCATION_NAME: 'Ayot St. Lawrence',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2666375,
        LOCATION_LATITUDE_DEG: 51.8355734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002100',
        LOCATION_NAME: 'Ayot St. Peter',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2317731,
        LOCATION_LATITUDE_DEG: 51.8202788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002200',
        LOCATION_NAME: 'Ayr',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4858544,
        LOCATION_LATITUDE_DEG: 50.211083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002300',
        LOCATION_NAME: 'Ayr',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6318752,
        LOCATION_LATITUDE_DEG: 55.4634776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002400',
        LOCATION_NAME: 'Aysgarth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.99304,
        LOCATION_LATITUDE_DEG: 54.2902319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002500',
        LOCATION_NAME: 'Ayside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9270648,
        LOCATION_LATITUDE_DEG: 54.2447459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002600',
        LOCATION_NAME: 'Ayston',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7293344,
        LOCATION_LATITUDE_DEG: 52.5998551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002700',
        LOCATION_NAME: 'Aythorpe Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2989351,
        LOCATION_LATITUDE_DEG: 51.8157663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002800',
        LOCATION_NAME: 'Ayton',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1212959,
        LOCATION_LATITUDE_DEG: 55.8422934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AY002900',
        LOCATION_NAME: 'Aytounhill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1407438,
        LOCATION_LATITUDE_DEG: 56.3612527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AZ000100',
        LOCATION_NAME: 'Azerley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6013323,
        LOCATION_LATITUDE_DEG: 54.1673215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000100',
        LOCATION_NAME: 'Babbacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5202252,
        LOCATION_LATITUDE_DEG: 50.4807872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000200',
        LOCATION_NAME: 'Babbington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2680695,
        LOCATION_LATITUDE_DEG: 52.9823977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000300',
        LOCATION_NAME: 'Babbinswood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9908024,
        LOCATION_LATITUDE_DEG: 52.8637059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000400',
        LOCATION_NAME: 'Babcary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6201211,
        LOCATION_LATITUDE_DEG: 51.0548321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000500',
        LOCATION_NAME: 'Babdown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2213929,
        LOCATION_LATITUDE_DEG: 51.6455804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000600',
        LOCATION_NAME: 'Babel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7028361,
        LOCATION_LATITUDE_DEG: 52.0062353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000700',
        LOCATION_NAME: 'Babell',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2655155,
        LOCATION_LATITUDE_DEG: 53.2549531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000800',
        LOCATION_NAME: 'Babeny',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8756282,
        LOCATION_LATITUDE_DEG: 50.5605947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA000900',
        LOCATION_NAME: 'Babingley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4863425,
        LOCATION_LATITUDE_DEG: 52.8083573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001000',
        LOCATION_NAME: 'Babington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4245257,
        LOCATION_LATITUDE_DEG: 51.2570524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001100',
        LOCATION_NAME: 'Babraham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2117188,
        LOCATION_LATITUDE_DEG: 52.1307964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001200',
        LOCATION_NAME: 'Babthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9417511,
        LOCATION_LATITUDE_DEG: 53.7896771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001300',
        LOCATION_NAME: 'Babworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9743614,
        LOCATION_LATITUDE_DEG: 53.3177261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001400',
        LOCATION_NAME: 'Bache',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7797775,
        LOCATION_LATITUDE_DEG: 52.4326697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001500',
        LOCATION_NAME: 'Back',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2909587,
        LOCATION_LATITUDE_DEG: 58.2831751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001600',
        LOCATION_NAME: 'Back of Avon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.161271,
        LOCATION_LATITUDE_DEG: 51.9930133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001700',
        LOCATION_NAME: 'Back of the Hill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.260303,
        LOCATION_LATITUDE_DEG: 54.9744211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001800',
        LOCATION_NAME: 'Backbarrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9855306,
        LOCATION_LATITUDE_DEG: 54.2533427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA001900',
        LOCATION_NAME: 'Backdamgate',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7846311,
        LOCATION_LATITUDE_DEG: 55.4213549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002000',
        LOCATION_NAME: 'Backford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9001174,
        LOCATION_LATITUDE_DEG: 53.2394464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002100',
        LOCATION_NAME: 'Backmuir of Liff',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0715242,
        LOCATION_LATITUDE_DEG: 56.5013648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002200',
        LOCATION_NAME: 'Backwell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7379013,
        LOCATION_LATITUDE_DEG: 51.4138709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002300',
        LOCATION_NAME: 'Backworth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5278793,
        LOCATION_LATITUDE_DEG: 55.0437004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002400',
        LOCATION_NAME: 'Baclaw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8322132,
        LOCATION_LATITUDE_DEG: 53.2564547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002500',
        LOCATION_NAME: 'Bacon End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3299183,
        LOCATION_LATITUDE_DEG: 51.8430729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002600',
        LOCATION_NAME: 'Baconsthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1551558,
        LOCATION_LATITUDE_DEG: 52.8893604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002700',
        LOCATION_NAME: 'Bacton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9152125,
        LOCATION_LATITUDE_DEG: 51.9858273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002900',
        LOCATION_NAME: 'Bacton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0019615,
        LOCATION_LATITUDE_DEG: 52.2623995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA002800',
        LOCATION_NAME: 'Bacton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4786579,
        LOCATION_LATITUDE_DEG: 52.8503457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003000',
        LOCATION_NAME: 'Bacup',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1990807,
        LOCATION_LATITUDE_DEG: 53.7032834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003100',
        LOCATION_NAME: 'Badachro',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7233313,
        LOCATION_LATITUDE_DEG: 57.6974178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003200',
        LOCATION_NAME: 'Badbea',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5624089,
        LOCATION_LATITUDE_DEG: 58.1551377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003300',
        LOCATION_NAME: 'Badbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.717271,
        LOCATION_LATITUDE_DEG: 51.5211647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003400',
        LOCATION_NAME: 'Badbury Wick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7260598,
        LOCATION_LATITUDE_DEG: 51.533865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003500',
        LOCATION_NAME: 'Badby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1816382,
        LOCATION_LATITUDE_DEG: 52.2242294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003600',
        LOCATION_NAME: 'Badcall',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0217351,
        LOCATION_LATITUDE_DEG: 58.4555813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003700',
        LOCATION_NAME: 'Badcaul',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3404706,
        LOCATION_LATITUDE_DEG: 57.8730284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003800',
        LOCATION_NAME: 'Baddeley Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1343931,
        LOCATION_LATITUDE_DEG: 53.0590224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA003900',
        LOCATION_NAME: 'Baddesley Ensor',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5994701,
        LOCATION_LATITUDE_DEG: 52.5818621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004000',
        LOCATION_NAME: 'Baddidarach',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2369753,
        LOCATION_LATITUDE_DEG: 58.1559573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004100',
        LOCATION_NAME: 'Baddiley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5930586,
        LOCATION_LATITUDE_DEG: 53.0406197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004200',
        LOCATION_NAME: 'Baddington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5432163,
        LOCATION_LATITUDE_DEG: 53.0389248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004300',
        LOCATION_NAME: 'Badenscallie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3154107,
        LOCATION_LATITUDE_DEG: 58.0002405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990452',
        LOCATION_NAME: 'Badersfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004400',
        LOCATION_NAME: 'Badgall',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4959527,
        LOCATION_LATITUDE_DEG: 50.6512171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004500',
        LOCATION_NAME: 'Badgemore',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9278782,
        LOCATION_LATITUDE_DEG: 51.5391603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004600',
        LOCATION_NAME: 'Badger',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3429005,
        LOCATION_LATITUDE_DEG: 52.5924724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004700',
        LOCATION_NAME: 'Badgers Dene',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.319126,
        LOCATION_LATITUDE_DEG: 51.4797327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004800',
        LOCATION_NAME: 'Badgers Mount',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1470257,
        LOCATION_LATITUDE_DEG: 51.3385219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA004900',
        LOCATION_NAME: 'Badgeworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1387744,
        LOCATION_LATITUDE_DEG: 51.8728029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005000',
        LOCATION_NAME: 'Badgworth',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8662723,
        LOCATION_LATITUDE_DEG: 51.266353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005100',
        LOCATION_NAME: 'Badingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3800813,
        LOCATION_LATITUDE_DEG: 52.2628921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005200',
        LOCATION_NAME: 'Badlesmere',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.880791,
        LOCATION_LATITUDE_DEG: 51.2498035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005300',
        LOCATION_NAME: 'Badlesmere Lees',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8814782,
        LOCATION_LATITUDE_DEG: 51.249103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005400',
        LOCATION_NAME: 'Badley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0114722,
        LOCATION_LATITUDE_DEG: 52.1621921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005500',
        LOCATION_NAME: 'Badluarach',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3863109,
        LOCATION_LATITUDE_DEG: 57.8945301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005600',
        LOCATION_NAME: 'Badminton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2842291,
        LOCATION_LATITUDE_DEG: 51.5421765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005700',
        LOCATION_NAME: 'Badralloch',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2639983,
        LOCATION_LATITUDE_DEG: 57.8731225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005800',
        LOCATION_NAME: 'Badsey',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8974326,
        LOCATION_LATITUDE_DEG: 52.0868263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA005900',
        LOCATION_NAME: 'Badshot Lea',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.761741,
        LOCATION_LATITUDE_DEG: 51.2295271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006000',
        LOCATION_NAME: 'Badsworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2961135,
        LOCATION_LATITUDE_DEG: 53.6270655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006100',
        LOCATION_NAME: 'Badwell Ash',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.917725,
        LOCATION_LATITUDE_DEG: 52.2828072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006200',
        LOCATION_NAME: 'Baffins',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0587127,
        LOCATION_LATITUDE_DEG: 50.8058926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006300',
        LOCATION_NAME: 'Bag Enderby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0218114,
        LOCATION_LATITUDE_DEG: 53.229508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006400',
        LOCATION_NAME: 'Bagber',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.400038,
        LOCATION_LATITUDE_DEG: 50.9399225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006500',
        LOCATION_NAME: 'Bagber Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3359372,
        LOCATION_LATITUDE_DEG: 50.9275157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006600',
        LOCATION_NAME: 'Bagborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1840263,
        LOCATION_LATITUDE_DEG: 51.0931453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006700',
        LOCATION_NAME: 'Bagby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2876197,
        LOCATION_LATITUDE_DEG: 54.2180176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006900',
        LOCATION_NAME: 'Bagendon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9850026,
        LOCATION_LATITUDE_DEG: 51.758793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007100',
        LOCATION_NAME: 'Baggrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2765345,
        LOCATION_LATITUDE_DEG: 54.7651961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007200',
        LOCATION_NAME: 'Bagillt',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1675772,
        LOCATION_LATITUDE_DEG: 53.2682513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007300',
        LOCATION_NAME: 'Baginton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.492005,
        LOCATION_LATITUDE_DEG: 52.3718403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007400',
        LOCATION_NAME: 'Baglan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8069821,
        LOCATION_LATITUDE_DEG: 51.6196987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007500',
        LOCATION_NAME: 'Bagley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8846384,
        LOCATION_LATITUDE_DEG: 52.8402064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007600',
        LOCATION_NAME: 'Bagley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7796676,
        LOCATION_LATITUDE_DEG: 51.2100445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007700',
        LOCATION_NAME: 'Bagley Green',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2378162,
        LOCATION_LATITUDE_DEG: 50.9664339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007800',
        LOCATION_NAME: 'Bagley Marsh',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8963056,
        LOCATION_LATITUDE_DEG: 52.84581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007900',
        LOCATION_NAME: 'Bagnall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1077029,
        LOCATION_LATITUDE_DEG: 53.0556153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008000',
        LOCATION_NAME: 'Bagnor',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3482283,
        LOCATION_LATITUDE_DEG: 51.4198491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008100',
        LOCATION_NAME: 'Bagnum',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.75289,
        LOCATION_LATITUDE_DEG: 50.8252028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008200',
        LOCATION_NAME: 'Bagpath',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.279805,
        LOCATION_LATITUDE_DEG: 51.6507882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008300',
        LOCATION_NAME: 'Bagshot',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6899032,
        LOCATION_LATITUDE_DEG: 51.3611358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008400',
        LOCATION_NAME: 'Bagstone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4468104,
        LOCATION_LATITUDE_DEG: 51.5784763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008600',
        LOCATION_NAME: 'Bagthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2968681,
        LOCATION_LATITUDE_DEG: 53.0592054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008500',
        LOCATION_NAME: 'Bagthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6673052,
        LOCATION_LATITUDE_DEG: 52.8574582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103200',
        LOCATION_NAME: 'Baguley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2808678,
        LOCATION_LATITUDE_DEG: 53.4014977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008700',
        LOCATION_NAME: 'Bagworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3381755,
        LOCATION_LATITUDE_DEG: 52.6676686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008800',
        LOCATION_NAME: 'Baildon',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7895519,
        LOCATION_LATITUDE_DEG: 53.8468913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA008900',
        LOCATION_NAME: 'Baildon Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7906604,
        LOCATION_LATITUDE_DEG: 53.8440886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009000',
        LOCATION_NAME: 'Bailey Lane End',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5186325,
        LOCATION_LATITUDE_DEG: 51.8724072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009200',
        LOCATION_NAME: 'Bailiff Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7779444,
        LOCATION_LATITUDE_DEG: 53.7191808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009400',
        LOCATION_NAME: 'Baillieston',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6944462,
        LOCATION_LATITUDE_DEG: 55.7617132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009300',
        LOCATION_NAME: 'Baillieston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1234136,
        LOCATION_LATITUDE_DEG: 55.8497149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009500',
        LOCATION_NAME: 'Bailrigg',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7844399,
        LOCATION_LATITUDE_DEG: 54.0172188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009600',
        LOCATION_NAME: 'Bainbridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1018767,
        LOCATION_LATITUDE_DEG: 54.3076353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009700',
        LOCATION_NAME: 'Bainsford',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7901924,
        LOCATION_LATITUDE_DEG: 56.0162233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009800',
        LOCATION_NAME: 'Bainshole',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.650266,
        LOCATION_LATITUDE_DEG: 57.4031482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010100',
        LOCATION_NAME: 'Bainton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1554377,
        LOCATION_LATITUDE_DEG: 51.9384995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010000',
        LOCATION_NAME: 'Bainton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5313819,
        LOCATION_LATITUDE_DEG: 53.9586853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009900',
        LOCATION_NAME: 'Bainton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3826962,
        LOCATION_LATITUDE_DEG: 52.6404522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010200',
        LOCATION_NAME: 'Baintown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0442246,
        LOCATION_LATITUDE_DEG: 56.2211415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010300',
        LOCATION_NAME: 'Baker Street',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3547782,
        LOCATION_LATITUDE_DEG: 51.5074346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010400',
        LOCATION_NAME: 'Bakers Hill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.576563,
        LOCATION_LATITUDE_DEG: 50.7060081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010500',
        LOCATION_NAME: 'Bakers Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6086459,
        LOCATION_LATITUDE_DEG: 51.7985015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010600',
        LOCATION_NAME: 'Bakewell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6742428,
        LOCATION_LATITUDE_DEG: 53.212625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010700',
        LOCATION_NAME: 'Bala',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5938339,
        LOCATION_LATITUDE_DEG: 52.9120255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010800',
        LOCATION_NAME: 'Balado',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4532794,
        LOCATION_LATITUDE_DEG: 56.2067405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA010900',
        LOCATION_NAME: 'Balallan',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5907207,
        LOCATION_LATITUDE_DEG: 58.0937609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011000',
        LOCATION_NAME: 'Balavil',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9913431,
        LOCATION_LATITUDE_DEG: 57.0989386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011100',
        LOCATION_NAME: 'Balbeggie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3474073,
        LOCATION_LATITUDE_DEG: 56.4512683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011200',
        LOCATION_NAME: 'Balblair',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8818661,
        LOCATION_LATITUDE_DEG: 57.5668783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011400',
        LOCATION_NAME: 'Balby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1688264,
        LOCATION_LATITUDE_DEG: 53.5030463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011500',
        LOCATION_NAME: 'Balchladich',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3468236,
        LOCATION_LATITUDE_DEG: 58.2173585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011600',
        LOCATION_NAME: 'Balchraggan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4440083,
        LOCATION_LATITUDE_DEG: 57.4581755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011700',
        LOCATION_NAME: 'Balcombe',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1270177,
        LOCATION_LATITUDE_DEG: 51.0572976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011800',
        LOCATION_NAME: 'Balcomie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6062834,
        LOCATION_LATITUDE_DEG: 56.2808426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011900',
        LOCATION_NAME: 'Balcurvie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0588269,
        LOCATION_LATITUDE_DEG: 56.1985344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012000',
        LOCATION_NAME: 'Baldersby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4531784,
        LOCATION_LATITUDE_DEG: 54.2026223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102400',
        LOCATION_NAME: 'Baldersby St James',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012100',
        LOCATION_NAME: 'Baldersby-St-James',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.440194,
        LOCATION_LATITUDE_DEG: 54.186617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012200',
        LOCATION_NAME: 'Baldersdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0459887,
        LOCATION_LATITUDE_DEG: 54.5689613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990433',
        LOCATION_NAME: 'Baldersfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012300',
        LOCATION_NAME: 'Balderstone',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5646504,
        LOCATION_LATITUDE_DEG: 53.7886934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012500',
        LOCATION_NAME: 'Balderton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.939324,
        LOCATION_LATITUDE_DEG: 53.1526396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012400',
        LOCATION_NAME: 'Balderton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7622186,
        LOCATION_LATITUDE_DEG: 53.047499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012600',
        LOCATION_NAME: 'Baldhu',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1238084,
        LOCATION_LATITUDE_DEG: 50.2473835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012700',
        LOCATION_NAME: 'Baldinnie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9240051,
        LOCATION_LATITUDE_DEG: 56.2909472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012800',
        LOCATION_NAME: 'Baldock',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1789534,
        LOCATION_LATITUDE_DEG: 51.9930908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA012900',
        LOCATION_NAME: 'Baldovan',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.986109,
        LOCATION_LATITUDE_DEG: 56.4987655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013000',
        LOCATION_NAME: 'Baldovie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8889919,
        LOCATION_LATITUDE_DEG: 56.4870626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013200',
        LOCATION_NAME: 'Baldrine',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4102031,
        LOCATION_LATITUDE_DEG: 54.2072866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013300',
        LOCATION_NAME: 'Baldslow',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5620057,
        LOCATION_LATITUDE_DEG: 50.8879728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990537',
        LOCATION_NAME: 'Baldwin',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013500',
        LOCATION_NAME: 'Baldwinholme',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0296539,
        LOCATION_LATITUDE_DEG: 54.8600023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013600',
        LOCATION_NAME: 'Baldwins Gate',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3072284,
        LOCATION_LATITUDE_DEG: 52.9563208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013400',
        LOCATION_NAME: "Baldwin'S Gate",
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3023299,
        LOCATION_LATITUDE_DEG: 52.9605138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013700',
        LOCATION_NAME: 'Baldwins Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0348882,
        LOCATION_LATITUDE_DEG: 51.1261375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014000',
        LOCATION_NAME: 'Bale',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9887227,
        LOCATION_LATITUDE_DEG: 52.8905567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014100',
        LOCATION_NAME: 'Baleloch',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4896678,
        LOCATION_LATITUDE_DEG: 57.628327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014200',
        LOCATION_NAME: 'Balemartin',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8935077,
        LOCATION_LATITUDE_DEG: 56.4641921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014300',
        LOCATION_NAME: 'Balemartine',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8955925,
        LOCATION_LATITUDE_DEG: 56.466998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014400',
        LOCATION_NAME: 'Balemore',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4595053,
        LOCATION_LATITUDE_DEG: 57.5776206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014500',
        LOCATION_NAME: 'Balephetrish',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.857535,
        LOCATION_LATITUDE_DEG: 56.5213037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014600',
        LOCATION_NAME: 'Balephuil',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9394027,
        LOCATION_LATITUDE_DEG: 56.4549019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014700',
        LOCATION_NAME: 'Balerno',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3361309,
        LOCATION_LATITUDE_DEG: 55.8845082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014800',
        LOCATION_NAME: 'Baleshare',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3666246,
        LOCATION_LATITUDE_DEG: 57.5226143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA014900',
        LOCATION_NAME: 'Balevullin',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9484299,
        LOCATION_LATITUDE_DEG: 56.5128047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015000',
        LOCATION_NAME: 'Balfarg',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1526365,
        LOCATION_LATITUDE_DEG: 56.2209428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015100',
        LOCATION_NAME: 'Balfour',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9074671,
        LOCATION_LATITUDE_DEG: 59.0337179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015200',
        LOCATION_NAME: 'Balfron',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3309863,
        LOCATION_LATITUDE_DEG: 56.0685408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015300',
        LOCATION_NAME: 'Balfron Station',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3762649,
        LOCATION_LATITUDE_DEG: 56.0747421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015400',
        LOCATION_NAME: 'Balgarva',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3825611,
        LOCATION_LATITUDE_DEG: 57.3925976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015500',
        LOCATION_NAME: 'Balgavies',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7553687,
        LOCATION_LATITUDE_DEG: 56.6515771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015600',
        LOCATION_NAME: 'Balgonar',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5733749,
        LOCATION_LATITUDE_DEG: 56.1257378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015700',
        LOCATION_NAME: 'Balgowan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2461876,
        LOCATION_LATITUDE_DEG: 57.0201274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015900',
        LOCATION_NAME: 'Balgrochan',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2037051,
        LOCATION_LATITUDE_DEG: 55.9792269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104200',
        LOCATION_NAME: 'Balham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1380108,
        LOCATION_LATITUDE_DEG: 51.4505881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016000',
        LOCATION_NAME: 'Balhary',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1972884,
        LOCATION_LATITUDE_DEG: 56.6056815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016100',
        LOCATION_NAME: 'Balinoe',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9214454,
        LOCATION_LATITUDE_DEG: 56.4747016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016200',
        LOCATION_NAME: 'Balintore',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9094123,
        LOCATION_LATITUDE_DEG: 57.7571008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016300',
        LOCATION_NAME: 'Balintore',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1642047,
        LOCATION_LATITUDE_DEG: 56.7180898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016400',
        LOCATION_NAME: 'Balivanich',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3778612,
        LOCATION_LATITUDE_DEG: 57.4736046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016500',
        LOCATION_NAME: 'Balk',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2710635,
        LOCATION_LATITUDE_DEG: 54.2210197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016600',
        LOCATION_NAME: 'Balkholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.802042,
        LOCATION_LATITUDE_DEG: 53.7430639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016700',
        LOCATION_NAME: 'Ball Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3974479,
        LOCATION_LATITUDE_DEG: 51.3650497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016800',
        LOCATION_NAME: 'Balla',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2999472,
        LOCATION_LATITUDE_DEG: 57.0861699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016950',
        LOCATION_NAME: 'Ballabeg',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6810375,
        LOCATION_LATITUDE_DEG: 54.1015298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017000',
        LOCATION_NAME: 'Ballachulish',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1313144,
        LOCATION_LATITUDE_DEG: 56.6729014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017100',
        LOCATION_NAME: 'Ballagh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3323544,
        LOCATION_LATITUDE_DEG: 54.2165826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017600',
        LOCATION_NAME: 'Ballantrae',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.003309,
        LOCATION_LATITUDE_DEG: 55.0994474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017700',
        LOCATION_NAME: 'Ballasalla',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.626199,
        LOCATION_LATITUDE_DEG: 54.1024161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017800',
        LOCATION_NAME: 'BALLATER',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0386895,
        LOCATION_LATITUDE_DEG: 57.049418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017900',
        LOCATION_NAME: 'Ballaugh',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5415423,
        LOCATION_LATITUDE_DEG: 54.3103669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018000',
        LOCATION_NAME: 'Ballechin',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7390711,
        LOCATION_LATITUDE_DEG: 56.6619857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018100',
        LOCATION_NAME: 'Ballee',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3438289,
        LOCATION_LATITUDE_DEG: 54.8265266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018200',
        LOCATION_NAME: 'Ballencrieff',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8275169,
        LOCATION_LATITUDE_DEG: 55.9938101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018400',
        LOCATION_NAME: 'Ballidon',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6952221,
        LOCATION_LATITUDE_DEG: 53.0883125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020100',
        LOCATION_NAME: 'Ballinamallard',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5727748,
        LOCATION_LATITUDE_DEG: 54.4262989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020900',
        LOCATION_NAME: 'Ballinaskeagh',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2322426,
        LOCATION_LATITUDE_DEG: 54.2831717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021800',
        LOCATION_NAME: 'Ballindalloch',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3536132,
        LOCATION_LATITUDE_DEG: 57.3985603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022000',
        LOCATION_NAME: 'Ballindean',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2028647,
        LOCATION_LATITUDE_DEG: 56.4503629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990195',
        LOCATION_NAME: 'Ballinderry',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2570493,
        LOCATION_LATITUDE_DEG: 54.5452356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022300',
        LOCATION_NAME: 'Ballinderry Lower',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2656177,
        LOCATION_LATITUDE_DEG: 54.5332024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022400',
        LOCATION_NAME: 'Ballinderry Upper',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2081186,
        LOCATION_LATITUDE_DEG: 54.5467076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023500',
        LOCATION_NAME: 'Ballinger',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6776033,
        LOCATION_LATITUDE_DEG: 51.712012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023600',
        LOCATION_NAME: 'Ballingham',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6202758,
        LOCATION_LATITUDE_DEG: 51.9831191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023800',
        LOCATION_NAME: 'Ballingry',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.327527,
        LOCATION_LATITUDE_DEG: 56.1636357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024900',
        LOCATION_NAME: 'Ballinluig',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6676667,
        LOCATION_LATITUDE_DEG: 56.65359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025400',
        LOCATION_NAME: 'Ballinshoe',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.970404,
        LOCATION_LATITUDE_DEG: 56.6673835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026300',
        LOCATION_NAME: 'Ballintoy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.348919,
        LOCATION_LATITUDE_DEG: 55.2332728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026600',
        LOCATION_NAME: 'Ballintuim',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4645018,
        LOCATION_LATITUDE_DEG: 56.6778917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027200',
        LOCATION_NAME: 'Balloch',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5826111,
        LOCATION_LATITUDE_DEG: 56.0028354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027100',
        LOCATION_NAME: 'Balloch',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1190049,
        LOCATION_LATITUDE_DEG: 57.4971814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027300',
        LOCATION_NAME: 'Ballogie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7016446,
        LOCATION_LATITUDE_DEG: 57.0497196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027800',
        LOCATION_NAME: 'Balls Cross',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5913139,
        LOCATION_LATITUDE_DEG: 51.0270052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027900',
        LOCATION_NAME: 'Ballumbie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8990095,
        LOCATION_LATITUDE_DEG: 56.4958592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028000',
        LOCATION_NAME: 'Ballure',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6321278,
        LOCATION_LATITUDE_DEG: 55.850025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029300',
        LOCATION_NAME: 'Ballybogy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5656479,
        LOCATION_LATITUDE_DEG: 55.1166583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030700',
        LOCATION_NAME: 'Ballycarry',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7655642,
        LOCATION_LATITUDE_DEG: 54.7666226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030800',
        LOCATION_NAME: 'Ballycassidy',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6490911,
        LOCATION_LATITUDE_DEG: 54.3998952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031000',
        LOCATION_NAME: 'Ballycastle',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2624151,
        LOCATION_LATITUDE_DEG: 55.2014723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031100',
        LOCATION_NAME: 'Ballyclare',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0117923,
        LOCATION_LATITUDE_DEG: 54.7486252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034900',
        LOCATION_NAME: 'Ballyeaston',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9988901,
        LOCATION_LATITUDE_DEG: 54.766628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036200',
        LOCATION_NAME: 'Ballygally',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8991817,
        LOCATION_LATITUDE_DEG: 54.8726319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036700',
        LOCATION_NAME: 'Ballygarvey',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1819219,
        LOCATION_LATITUDE_DEG: 54.9345367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036800',
        LOCATION_NAME: 'Ballygawley',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.02962,
        LOCATION_LATITUDE_DEG: 54.4626974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037700',
        LOCATION_NAME: 'Ballygowan',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7988875,
        LOCATION_LATITUDE_DEG: 54.4998908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037900',
        LOCATION_NAME: 'Ballygown',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1720851,
        LOCATION_LATITUDE_DEG: 56.5121018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038100',
        LOCATION_NAME: 'Ballygrant',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1583154,
        LOCATION_LATITUDE_DEG: 55.8190326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038700',
        LOCATION_NAME: 'Ballyhalbert',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.468046,
        LOCATION_LATITUDE_DEG: 54.4982974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040000',
        LOCATION_NAME: 'Ballyhornan',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5594584,
        LOCATION_LATITUDE_DEG: 54.3005731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040500',
        LOCATION_NAME: 'Ballykelly',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0157095,
        LOCATION_LATITUDE_DEG: 55.0499578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040800',
        LOCATION_NAME: 'Ballykinler',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7988829,
        LOCATION_LATITUDE_DEG: 54.2498705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990767',
        LOCATION_NAME: 'Ballylifford',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043600',
        LOCATION_NAME: 'Ballymagorry',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.425648,
        LOCATION_LATITUDE_DEG: 54.8672492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044200',
        LOCATION_NAME: 'Ballymarlagh',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1204079,
        LOCATION_LATITUDE_DEG: 54.8482263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044300',
        LOCATION_NAME: 'Ballymartin',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9647128,
        LOCATION_LATITUDE_DEG: 54.0737569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044400',
        LOCATION_NAME: 'Ballymena',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2837199,
        LOCATION_LATITUDE_DEG: 54.8665392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044700',
        LOCATION_NAME: 'Ballymoney',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5145459,
        LOCATION_LATITUDE_DEG: 55.0729527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104800',
        LOCATION_NAME: 'Ballynafeigh',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9168287,
        LOCATION_LATITUDE_DEG: 54.5762927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047700',
        LOCATION_NAME: 'Ballynagard',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2755879,
        LOCATION_LATITUDE_DEG: 55.0486106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048400',
        LOCATION_NAME: 'Ballynahatty',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3355004,
        LOCATION_LATITUDE_DEG: 54.5461494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048600',
        LOCATION_NAME: 'Ballynahinch',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9006018,
        LOCATION_LATITUDE_DEG: 54.40759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049600',
        LOCATION_NAME: 'Ballynamore',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1861188,
        LOCATION_LATITUDE_DEG: 54.9743552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049700',
        LOCATION_NAME: 'Ballynamullan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2470513,
        LOCATION_LATITUDE_DEG: 54.6018252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051500',
        LOCATION_NAME: 'Ballynure',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.960393,
        LOCATION_LATITUDE_DEG: 54.7716167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051700',
        LOCATION_NAME: 'Ballypatrick',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2213086,
        LOCATION_LATITUDE_DEG: 55.1743707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052400',
        LOCATION_NAME: 'Ballyreagh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5157603,
        LOCATION_LATITUDE_DEG: 54.3831953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052800',
        LOCATION_NAME: 'Ballyronan',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5330491,
        LOCATION_LATITUDE_DEG: 54.7166153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052900',
        LOCATION_NAME: 'Ballyroney',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1336186,
        LOCATION_LATITUDE_DEG: 54.2770807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053700',
        LOCATION_NAME: 'Ballysillan',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9602924,
        LOCATION_LATITUDE_DEG: 54.6308153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054300',
        LOCATION_NAME: 'Ballyvelton',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6173627,
        LOCATION_LATITUDE_DEG: 55.1373694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054700',
        LOCATION_NAME: 'Ballyvoy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1867048,
        LOCATION_LATITUDE_DEG: 55.1983688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054800',
        LOCATION_NAME: 'Ballywalter',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4922487,
        LOCATION_LATITUDE_DEG: 54.5503012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054900',
        LOCATION_NAME: 'Ballyward',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.032214,
        LOCATION_LATITUDE_DEG: 54.2665767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055200',
        LOCATION_NAME: 'Balmacara',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6277907,
        LOCATION_LATITUDE_DEG: 57.2826705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055300',
        LOCATION_NAME: 'Balmaclellan',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.111754,
        LOCATION_LATITUDE_DEG: 55.0878351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055400',
        LOCATION_NAME: 'Balmaghie',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0045732,
        LOCATION_LATITUDE_DEG: 54.9480239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055500',
        LOCATION_NAME: 'Balmaha',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5354106,
        LOCATION_LATITUDE_DEG: 56.0840421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055600',
        LOCATION_NAME: 'Balmalcolm',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0979677,
        LOCATION_LATITUDE_DEG: 56.2629465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055700',
        LOCATION_NAME: 'Balmaqueen',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3058376,
        LOCATION_LATITUDE_DEG: 57.5924069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055800',
        LOCATION_NAME: 'Balmeanach',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1121587,
        LOCATION_LATITUDE_DEG: 57.3351816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055900',
        LOCATION_NAME: 'Balmedie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0550592,
        LOCATION_LATITUDE_DEG: 57.2494299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056000',
        LOCATION_NAME: 'Balmerino',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0412187,
        LOCATION_LATITUDE_DEG: 56.411056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056100',
        LOCATION_NAME: 'Balmerlawn',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5646045,
        LOCATION_LATITUDE_DEG: 50.8269995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104900',
        LOCATION_NAME: 'Balmoral',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9611922,
        LOCATION_LATITUDE_DEG: 54.575845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104950',
        LOCATION_NAME: 'Balmoral',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2166185,
        LOCATION_LATITUDE_DEG: 57.0396219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056200',
        LOCATION_NAME: 'Balmore',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2378032,
        LOCATION_LATITUDE_DEG: 55.9345245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056300',
        LOCATION_NAME: 'Balmullo',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9286468,
        LOCATION_LATITUDE_DEG: 56.3770496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056400',
        LOCATION_NAME: 'Balnabeen',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3346146,
        LOCATION_LATITUDE_DEG: 57.5980872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056500',
        LOCATION_NAME: 'Balnabodach',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4155567,
        LOCATION_LATITUDE_DEG: 56.9892538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056600',
        LOCATION_NAME: 'Balnabruach',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8370511,
        LOCATION_LATITUDE_DEG: 57.8330081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056700',
        LOCATION_NAME: 'Balnabruich',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4542428,
        LOCATION_LATITUDE_DEG: 58.2478454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056900',
        LOCATION_NAME: 'Balnagown',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0816933,
        LOCATION_LATITUDE_DEG: 57.7485012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057000',
        LOCATION_NAME: 'Balnaguard',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7169822,
        LOCATION_LATITUDE_DEG: 56.646692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057100',
        LOCATION_NAME: 'Balnaha',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3314592,
        LOCATION_LATITUDE_DEG: 56.3202581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057200',
        LOCATION_NAME: 'Balnain',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5808847,
        LOCATION_LATITUDE_DEG: 57.338267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057300',
        LOCATION_NAME: 'Balnakeil',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7666832,
        LOCATION_LATITUDE_DEG: 58.5761932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057400',
        LOCATION_NAME: 'Balnald',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5152664,
        LOCATION_LATITUDE_DEG: 56.7167957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057500',
        LOCATION_NAME: 'Balnamoon',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7386794,
        LOCATION_LATITUDE_DEG: 56.7639899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057600',
        LOCATION_NAME: 'Balnamore',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.548937,
        LOCATION_LATITUDE_DEG: 55.0666591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057800',
        LOCATION_NAME: 'Balne',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1113317,
        LOCATION_LATITUDE_DEG: 53.6643656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105800',
        LOCATION_NAME: 'Balornock',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2228719,
        LOCATION_LATITUDE_DEG: 55.8860239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA057900',
        LOCATION_NAME: 'Balquhidder',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3702736,
        LOCATION_LATITUDE_DEG: 56.3582694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058000',
        LOCATION_NAME: 'Balquhidder Station',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3063544,
        LOCATION_LATITUDE_DEG: 56.3585679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058100',
        LOCATION_NAME: 'Balranald',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4822688,
        LOCATION_LATITUDE_DEG: 57.6041211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058400',
        LOCATION_NAME: 'Balsall Common',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6469284,
        LOCATION_LATITUDE_DEG: 52.3918526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058600',
        LOCATION_NAME: 'Balscote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4296691,
        LOCATION_LATITUDE_DEG: 52.0740179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058700',
        LOCATION_NAME: 'Balsham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3177563,
        LOCATION_LATITUDE_DEG: 52.1316999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058800',
        LOCATION_NAME: 'Baltasound',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8591978,
        LOCATION_LATITUDE_DEG: 60.7589607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058900',
        LOCATION_NAME: 'Balterley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3564401,
        LOCATION_LATITUDE_DEG: 53.0497181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059200',
        LOCATION_NAME: 'Baltonsborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6487383,
        LOCATION_LATITUDE_DEG: 51.1104351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059600',
        LOCATION_NAME: 'Balvaird',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4435077,
        LOCATION_LATITUDE_DEG: 57.534584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059700',
        LOCATION_NAME: 'Balvicar',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6142733,
        LOCATION_LATITUDE_DEG: 56.2911696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059800',
        LOCATION_NAME: 'Balvoolich',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7511365,
        LOCATION_LATITUDE_DEG: 58.5705869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059900',
        LOCATION_NAME: 'Bamber Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6591516,
        LOCATION_LATITUDE_DEG: 53.7277854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060000',
        LOCATION_NAME: 'Bamburgh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7154962,
        LOCATION_LATITUDE_DEG: 55.6064602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060100',
        LOCATION_NAME: 'Bamford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6879495,
        LOCATION_LATITUDE_DEG: 53.3480396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060200',
        LOCATION_NAME: 'Bamfurlong',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6140197,
        LOCATION_LATITUDE_DEG: 53.5107685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060300',
        LOCATION_NAME: 'Bamfurlong',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1441916,
        LOCATION_LATITUDE_DEG: 51.8951054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060600',
        LOCATION_NAME: 'Bampton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4858412,
        LOCATION_LATITUDE_DEG: 50.9908384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060500',
        LOCATION_NAME: 'Bampton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7499996,
        LOCATION_LATITUDE_DEG: 54.5564714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060400',
        LOCATION_NAME: 'Bampton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5443532,
        LOCATION_LATITUDE_DEG: 51.7258807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060700',
        LOCATION_NAME: 'Bampton Grange',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7389089,
        LOCATION_LATITUDE_DEG: 54.5554701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061000',
        LOCATION_NAME: 'Banavie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0957834,
        LOCATION_LATITUDE_DEG: 56.8470254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061100',
        LOCATION_NAME: 'Banbridge',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2763338,
        LOCATION_LATITUDE_DEG: 54.3531877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061200',
        LOCATION_NAME: 'Banbury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3388702,
        LOCATION_LATITUDE_DEG: 52.0596153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102500',
        LOCATION_NAME: 'Banc y Darren',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061400',
        LOCATION_NAME: 'Bancffosfelen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1932869,
        LOCATION_LATITUDE_DEG: 51.7875215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061500',
        LOCATION_NAME: 'Banchory',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5033985,
        LOCATION_LATITUDE_DEG: 57.0515176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061600',
        LOCATION_NAME: 'Banchory Devenick',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1368472,
        LOCATION_LATITUDE_DEG: 57.1137083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061700',
        LOCATION_NAME: 'Bancroft',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7881587,
        LOCATION_LATITUDE_DEG: 52.0545017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061800',
        LOCATION_NAME: 'Bancroft Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.795151,
        LOCATION_LATITUDE_DEG: 52.0543036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061900',
        LOCATION_NAME: 'Bancycapel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2778256,
        LOCATION_LATITUDE_DEG: 51.8118243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA061300',
        LOCATION_NAME: 'Banc-y-Darren',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9485879,
        LOCATION_LATITUDE_DEG: 52.4262786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062000',
        LOCATION_NAME: 'Bancyfelin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4361208,
        LOCATION_LATITUDE_DEG: 51.8334283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062100',
        LOCATION_NAME: 'Bancyffordd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3184127,
        LOCATION_LATITUDE_DEG: 52.0142418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062200',
        LOCATION_NAME: 'Bandley',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6554457,
        LOCATION_LATITUDE_DEG: 57.2391349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062400',
        LOCATION_NAME: 'Bandrake Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.054359,
        LOCATION_LATITUDE_DEG: 54.2759515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062500',
        LOCATION_NAME: 'Baneswell',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9955846,
        LOCATION_LATITUDE_DEG: 51.5844835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062600',
        LOCATION_NAME: 'Banff',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5216927,
        LOCATION_LATITUDE_DEG: 57.6627729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062700',
        LOCATION_NAME: 'Bangley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7326276,
        LOCATION_LATITUDE_DEG: 52.6147665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062800',
        LOCATION_NAME: 'Bangor',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6727569,
        LOCATION_LATITUDE_DEG: 54.6579037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062900',
        LOCATION_NAME: 'Bangor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1327953,
        LOCATION_LATITUDE_DEG: 53.227555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063100',
        LOCATION_NAME: 'Bangor Isycoed',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9105181,
        LOCATION_LATITUDE_DEG: 53.0039821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990901',
        LOCATION_NAME: 'Bangor on Dee',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063200',
        LOCATION_NAME: 'Bangor Teifi',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.363437,
        LOCATION_LATITUDE_DEG: 52.0413437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990900',
        LOCATION_NAME: 'Bangor-on-Dee',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063300',
        LOCATION_NAME: 'Banham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.03886,
        LOCATION_LATITUDE_DEG: 52.4522171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063400',
        LOCATION_NAME: 'Bank',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5937857,
        LOCATION_LATITUDE_DEG: 50.8612982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063500',
        LOCATION_NAME: 'Bank End',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2256801,
        LOCATION_LATITUDE_DEG: 54.2841477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063600',
        LOCATION_NAME: 'Bank Newton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1382156,
        LOCATION_LATITUDE_DEG: 53.9728042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063700',
        LOCATION_NAME: 'Bank Street',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5330019,
        LOCATION_LATITUDE_DEG: 52.2598508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063800',
        LOCATION_NAME: 'Bank Top',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8179013,
        LOCATION_LATITUDE_DEG: 53.7735873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063900',
        LOCATION_NAME: 'Bankend',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5217711,
        LOCATION_LATITUDE_DEG: 55.0021254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064000',
        LOCATION_NAME: 'Bankfoot',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5131066,
        LOCATION_LATITUDE_DEG: 56.5003739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105200',
        LOCATION_NAME: 'Bankfoot',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7558325,
        LOCATION_LATITUDE_DEG: 53.7715443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064100',
        LOCATION_NAME: 'Bankhead',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1773554,
        LOCATION_LATITUDE_DEG: 57.182925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064200',
        LOCATION_NAME: 'Banknock',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9567117,
        LOCATION_LATITUDE_DEG: 55.9905231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064300',
        LOCATION_NAME: 'Banks',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'PR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.923315,
        LOCATION_LATITUDE_DEG: 53.6809858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064400',
        LOCATION_NAME: 'Banks',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.678443,
        LOCATION_LATITUDE_DEG: 54.9754096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064500',
        LOCATION_NAME: 'Banks Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0090934,
        LOCATION_LATITUDE_DEG: 52.3022426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064600',
        LOCATION_NAME: 'Banks Head',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0208488,
        LOCATION_LATITUDE_DEG: 52.5023788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064700',
        LOCATION_NAME: 'Bankshill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2676742,
        LOCATION_LATITUDE_DEG: 55.1254311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064900',
        LOCATION_NAME: 'Bannerdown',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2972548,
        LOCATION_LATITUDE_DEG: 51.4119588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065000',
        LOCATION_NAME: 'Banningham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2888468,
        LOCATION_LATITUDE_DEG: 52.8167519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065100',
        LOCATION_NAME: 'Bannister Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4622266,
        LOCATION_LATITUDE_DEG: 51.8579685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065200',
        LOCATION_NAME: 'Bannockburn',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9134119,
        LOCATION_LATITUDE_DEG: 56.0919355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065600',
        LOCATION_NAME: 'Banstead',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1945672,
        LOCATION_LATITUDE_DEG: 51.3238258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065800',
        LOCATION_NAME: 'Bantham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8676549,
        LOCATION_LATITUDE_DEG: 50.2779719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065900',
        LOCATION_NAME: 'Banton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0043856,
        LOCATION_LATITUDE_DEG: 55.9896223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066100',
        LOCATION_NAME: 'Banwell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8628923,
        LOCATION_LATITUDE_DEG: 51.3269641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066200',
        LOCATION_NAME: 'Banwen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6548226,
        LOCATION_LATITUDE_DEG: 51.7724145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066300',
        LOCATION_NAME: 'Bapchild',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7685623,
        LOCATION_LATITUDE_DEG: 51.3342162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066400',
        LOCATION_NAME: 'Baptist Mills',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5745421,
        LOCATION_LATITUDE_DEG: 51.4662687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066500',
        LOCATION_NAME: 'Bapton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.012366,
        LOCATION_LATITUDE_DEG: 51.1411377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066600',
        LOCATION_NAME: 'Bar Hill',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0261716,
        LOCATION_LATITUDE_DEG: 52.2542129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066700',
        LOCATION_NAME: 'Bar Moor',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7748381,
        LOCATION_LATITUDE_DEG: 54.9717009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066800',
        LOCATION_NAME: 'Barassie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6555657,
        LOCATION_LATITUDE_DEG: 55.5528919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066900',
        LOCATION_NAME: 'Barbadoes',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6841428,
        LOCATION_LATITUDE_DEG: 51.7021929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067000',
        LOCATION_NAME: 'Barbaraville',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1022115,
        LOCATION_LATITUDE_DEG: 57.7223999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067100',
        LOCATION_NAME: 'Barbeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3315233,
        LOCATION_LATITUDE_DEG: 54.2318239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067200',
        LOCATION_NAME: 'Barber Booth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8296371,
        LOCATION_LATITUDE_DEG: 53.3588439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067300',
        LOCATION_NAME: 'Barbican',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1327205,
        LOCATION_LATITUDE_DEG: 50.3679875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104500',
        LOCATION_NAME: 'Barbican',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1110655,
        LOCATION_LATITUDE_DEG: 51.512267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067400',
        LOCATION_NAME: 'Barbon',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5697661,
        LOCATION_LATITUDE_DEG: 54.2366364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067500',
        LOCATION_NAME: 'Barbreck',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.496676,
        LOCATION_LATITUDE_DEG: 56.2005586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067600',
        LOCATION_NAME: 'Barbridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5733384,
        LOCATION_LATITUDE_DEG: 53.104628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067700',
        LOCATION_NAME: 'Barbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8405329,
        LOCATION_LATITUDE_DEG: 51.2130595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067800',
        LOCATION_NAME: 'Barby',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2042944,
        LOCATION_LATITUDE_DEG: 52.3270407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA067900',
        LOCATION_NAME: 'Barcaldine',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.319971,
        LOCATION_LATITUDE_DEG: 56.5201922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068000',
        LOCATION_NAME: 'Barcelona',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5044288,
        LOCATION_LATITUDE_DEG: 50.3569844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068100',
        LOCATION_NAME: 'Barcheston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6079191,
        LOCATION_LATITUDE_DEG: 52.0582188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068200',
        LOCATION_NAME: 'Barclose',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8700555,
        LOCATION_LATITUDE_DEG: 54.95741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068300',
        LOCATION_NAME: 'Barcombe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0156164,
        LOCATION_LATITUDE_DEG: 50.9112828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068400',
        LOCATION_NAME: 'Barcombe Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0217715,
        LOCATION_LATITUDE_DEG: 50.9242904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068500',
        LOCATION_NAME: 'Barden',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9224724,
        LOCATION_LATITUDE_DEG: 54.0115102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068600',
        LOCATION_NAME: 'Barden',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7678211,
        LOCATION_LATITUDE_DEG: 54.3385363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068700',
        LOCATION_NAME: 'Barden Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7876668,
        LOCATION_LATITUDE_DEG: 54.352936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068800',
        LOCATION_NAME: 'Bardfield End Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.369927,
        LOCATION_LATITUDE_DEG: 51.948678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA068900',
        LOCATION_NAME: 'Bardfield Saling',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4524071,
        LOCATION_LATITUDE_DEG: 51.9110757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069000',
        LOCATION_NAME: 'Bardney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3251226,
        LOCATION_LATITUDE_DEG: 53.2097056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069100',
        LOCATION_NAME: 'Bardney Dairies',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3026275,
        LOCATION_LATITUDE_DEG: 53.2400106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069200',
        LOCATION_NAME: 'Bardon Mill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3419067,
        LOCATION_LATITUDE_DEG: 54.9763089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069300',
        LOCATION_NAME: 'Bardowie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2667766,
        LOCATION_LATITUDE_DEG: 55.9335272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069400',
        LOCATION_NAME: 'Bardrainney',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6618122,
        LOCATION_LATITUDE_DEG: 55.9211265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069500',
        LOCATION_NAME: 'Bardsea',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0715902,
        LOCATION_LATITUDE_DEG: 54.161533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069600',
        LOCATION_NAME: 'Bardsey',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4434492,
        LOCATION_LATITUDE_DEG: 53.8831886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069700',
        LOCATION_NAME: 'Bardsey Island',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7869167,
        LOCATION_LATITUDE_DEG: 52.7622214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069800',
        LOCATION_NAME: 'Bardsley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1062518,
        LOCATION_LATITUDE_DEG: 53.5137004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA069900',
        LOCATION_NAME: 'Bardwell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8491475,
        LOCATION_LATITUDE_DEG: 52.3250102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070000',
        LOCATION_NAME: 'Bare',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8332944,
        LOCATION_LATITUDE_DEG: 54.0742215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070200',
        LOCATION_NAME: 'Barepot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5315929,
        LOCATION_LATITUDE_DEG: 54.6521856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070400',
        LOCATION_NAME: 'Barford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6059026,
        LOCATION_LATITUDE_DEG: 52.2440317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070300',
        LOCATION_NAME: 'Barford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1257608,
        LOCATION_LATITUDE_DEG: 52.6258359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101600',
        LOCATION_NAME: 'Barford St John',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101700',
        LOCATION_NAME: 'Barford St Martin',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101800',
        LOCATION_NAME: 'Barford St Michael',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070500',
        LOCATION_NAME: 'Barford St. John',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3621485,
        LOCATION_LATITUDE_DEG: 51.9953081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070600',
        LOCATION_NAME: 'Barford St. Martin',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9181037,
        LOCATION_LATITUDE_DEG: 51.0815303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070700',
        LOCATION_NAME: 'Barford St. Michael',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3634957,
        LOCATION_LATITUDE_DEG: 51.9907026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070800',
        LOCATION_NAME: 'Barfrestone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2408857,
        LOCATION_LATITUDE_DEG: 51.2050965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070900',
        LOCATION_NAME: 'Bargate',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4618806,
        LOCATION_LATITUDE_DEG: 53.0117074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071000',
        LOCATION_NAME: 'Bargeddie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0710179,
        LOCATION_LATITUDE_DEG: 55.8517137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071100',
        LOCATION_NAME: 'Bargoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2279248,
        LOCATION_LATITUDE_DEG: 51.6831007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071200',
        LOCATION_NAME: 'Bargrennan',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5837909,
        LOCATION_LATITUDE_DEG: 55.0569393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071500',
        LOCATION_NAME: 'Barham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3294022,
        LOCATION_LATITUDE_DEG: 52.3651252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071400',
        LOCATION_NAME: 'Barham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1071038,
        LOCATION_LATITUDE_DEG: 52.1175871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071300',
        LOCATION_NAME: 'Barham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1589314,
        LOCATION_LATITUDE_DEG: 51.2065932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071600',
        LOCATION_NAME: 'Barham Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.136811,
        LOCATION_LATITUDE_DEG: 52.1219809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071700',
        LOCATION_NAME: 'Barholm',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3884464,
        LOCATION_LATITUDE_DEG: 52.6846617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071800',
        LOCATION_NAME: 'Barkby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0582865,
        LOCATION_LATITUDE_DEG: 52.6807722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105100',
        LOCATION_NAME: 'Barkerend',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7373816,
        LOCATION_LATITUDE_DEG: 53.7981399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA071900',
        LOCATION_NAME: 'Barkers Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.704847,
        LOCATION_LATITUDE_DEG: 52.8458063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072000',
        LOCATION_NAME: 'Barkestone',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8402585,
        LOCATION_LATITUDE_DEG: 52.9046941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072100',
        LOCATION_NAME: 'Barkham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8739122,
        LOCATION_LATITUDE_DEG: 51.3977443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072200',
        LOCATION_NAME: 'Barking',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0830684,
        LOCATION_LATITUDE_DEG: 51.5358436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072300',
        LOCATION_NAME: 'Barking',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0272472,
        LOCATION_LATITUDE_DEG: 52.136684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072400',
        LOCATION_NAME: 'Barkingside',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.082424,
        LOCATION_LATITUDE_DEG: 51.5880458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072500',
        LOCATION_NAME: 'Barkisland',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9172022,
        LOCATION_LATITUDE_DEG: 53.6750773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072600',
        LOCATION_NAME: 'Barkla Shop',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1763191,
        LOCATION_LATITUDE_DEG: 50.309891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072700',
        LOCATION_NAME: 'Barkston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6112148,
        LOCATION_LATITUDE_DEG: 52.9634929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072800',
        LOCATION_NAME: 'Barkston Ash',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2529025,
        LOCATION_LATITUDE_DEG: 53.8180791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072900',
        LOCATION_NAME: 'Barkston Heath',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5735882,
        LOCATION_LATITUDE_DEG: 52.9588845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073000',
        LOCATION_NAME: 'Barkway',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.017024,
        LOCATION_LATITUDE_DEG: 52.0014888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073100',
        LOCATION_NAME: 'Barlanark',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1295924,
        LOCATION_LATITUDE_DEG: 55.8575178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073200',
        LOCATION_NAME: 'Barlaston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1643166,
        LOCATION_LATITUDE_DEG: 52.9422108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073300',
        LOCATION_NAME: 'Barlavington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6159295,
        LOCATION_LATITUDE_DEG: 50.9354992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073400',
        LOCATION_NAME: 'Barlborough',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2826533,
        LOCATION_LATITUDE_DEG: 53.2884324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073500',
        LOCATION_NAME: 'Barlby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0402953,
        LOCATION_LATITUDE_DEG: 53.7995766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073600',
        LOCATION_NAME: 'Barlestone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3675914,
        LOCATION_LATITUDE_DEG: 52.6471681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073800',
        LOCATION_NAME: 'Barley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2718455,
        LOCATION_LATITUDE_DEG: 53.8607996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073700',
        LOCATION_NAME: 'Barley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0400288,
        LOCATION_LATITUDE_DEG: 52.0257876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA073900',
        LOCATION_NAME: 'Barleycorn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7077098,
        LOCATION_LATITUDE_DEG: 52.8045042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990110',
        LOCATION_NAME: 'Barleythorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7450131,
        LOCATION_LATITUDE_DEG: 52.6800271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074000',
        LOCATION_NAME: 'Barleythorpe',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.743122,
        LOCATION_LATITUDE_DEG: 52.6773637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074100',
        LOCATION_NAME: 'Barling',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7848842,
        LOCATION_LATITUDE_DEG: 51.5703333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074200',
        LOCATION_NAME: 'Barling Magna',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7809668,
        LOCATION_LATITUDE_DEG: 51.5692929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074300',
        LOCATION_NAME: 'Barlings',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3880673,
        LOCATION_LATITUDE_DEG: 53.259619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074500',
        LOCATION_NAME: 'Barlow',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7545538,
        LOCATION_LATITUDE_DEG: 54.9443942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074600',
        LOCATION_NAME: 'Barlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4829088,
        LOCATION_LATITUDE_DEG: 53.2673266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074700',
        LOCATION_NAME: 'Barlow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0219671,
        LOCATION_LATITUDE_DEG: 53.7512721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074800',
        LOCATION_NAME: 'Barmby Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8140574,
        LOCATION_LATITUDE_DEG: 53.931685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102600',
        LOCATION_NAME: 'Barmby on the Marsh',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074900',
        LOCATION_NAME: 'Barmby-on-the-Marsh',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9581947,
        LOCATION_LATITUDE_DEG: 53.747921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075000',
        LOCATION_NAME: 'Barming',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4821385,
        LOCATION_LATITUDE_DEG: 51.2664159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075200',
        LOCATION_NAME: 'Barmoor',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.663434,
        LOCATION_LATITUDE_DEG: 55.1502167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075300',
        LOCATION_NAME: 'Barmouth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0541539,
        LOCATION_LATITUDE_DEG: 52.7225074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075400',
        LOCATION_NAME: 'Barmpton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5102375,
        LOCATION_LATITUDE_DEG: 54.5562587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075500',
        LOCATION_NAME: 'Barmston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2236059,
        LOCATION_LATITUDE_DEG: 54.0149861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105700',
        LOCATION_NAME: 'Barmulloch',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2018394,
        LOCATION_LATITUDE_DEG: 55.8919208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075900',
        LOCATION_NAME: 'Barnack',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4058679,
        LOCATION_LATITUDE_DEG: 52.6316577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076000',
        LOCATION_NAME: 'Barnacle',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.431424,
        LOCATION_LATITUDE_DEG: 52.4586534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076100',
        LOCATION_NAME: 'Barnacre',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7354869,
        LOCATION_LATITUDE_DEG: 53.9002038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076400',
        LOCATION_NAME: 'Barnard Castle',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9155214,
        LOCATION_LATITUDE_DEG: 54.5481606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076500',
        LOCATION_NAME: 'Barnard Gate',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.414468,
        LOCATION_LATITUDE_DEG: 51.7920905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076600',
        LOCATION_NAME: 'Barnardiston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.500587,
        LOCATION_LATITUDE_DEG: 52.1109918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076800',
        LOCATION_NAME: 'Barnbarroch',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8039125,
        LOCATION_LATITUDE_DEG: 54.8891174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076900',
        LOCATION_NAME: 'Barnburgh',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2690356,
        LOCATION_LATITUDE_DEG: 53.5233525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077000',
        LOCATION_NAME: 'Barnby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7201603,
        LOCATION_LATITUDE_DEG: 53.062599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077100',
        LOCATION_NAME: 'Barnby',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6375195,
        LOCATION_LATITUDE_DEG: 52.4476076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077200',
        LOCATION_NAME: 'Barnby Dun',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0670591,
        LOCATION_LATITUDE_DEG: 53.5772519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077300',
        LOCATION_NAME: 'Barnby Moor',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.003895,
        LOCATION_LATITUDE_DEG: 53.3524354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077400',
        LOCATION_NAME: 'Barncoose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2511288,
        LOCATION_LATITUDE_DEG: 50.2278822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077500',
        LOCATION_NAME: 'Barnehurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1627141,
        LOCATION_LATITUDE_DEG: 51.4639344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104300',
        LOCATION_NAME: 'Barnes',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2533692,
        LOCATION_LATITUDE_DEG: 51.4749645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103300',
        LOCATION_NAME: 'Barnes Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2152842,
        LOCATION_LATITUDE_DEG: 53.5147494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077700',
        LOCATION_NAME: 'Barnet',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1980332,
        LOCATION_LATITUDE_DEG: 51.6524575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077800',
        LOCATION_NAME: 'Barnetby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.399286,
        LOCATION_LATITUDE_DEG: 53.5736501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077900',
        LOCATION_NAME: 'Barney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.963803,
        LOCATION_LATITUDE_DEG: 52.8559534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078000',
        LOCATION_NAME: 'Barngates',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9999958,
        LOCATION_LATITUDE_DEG: 54.40186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078100',
        LOCATION_NAME: 'Barnham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6358527,
        LOCATION_LATITUDE_DEG: 50.8304861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078200',
        LOCATION_NAME: 'Barnham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7490874,
        LOCATION_LATITUDE_DEG: 52.3795109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078300',
        LOCATION_NAME: 'Barnham Broom',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0787535,
        LOCATION_LATITUDE_DEG: 52.6232363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078400',
        LOCATION_NAME: 'Barnhead',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5473814,
        LOCATION_LATITUDE_DEG: 56.7077786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078600',
        LOCATION_NAME: 'Barningham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8694215,
        LOCATION_LATITUDE_DEG: 54.4885565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078500',
        LOCATION_NAME: 'Barningham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8904674,
        LOCATION_LATITUDE_DEG: 52.3531107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078700',
        LOCATION_NAME: 'Barningham Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1457726,
        LOCATION_LATITUDE_DEG: 52.8577525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102700',
        LOCATION_NAME: 'Barnoldby le Beck',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078800',
        LOCATION_NAME: 'Barnoldby-le-Beck',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1328193,
        LOCATION_LATITUDE_DEG: 53.5066714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA078900',
        LOCATION_NAME: 'Barnoldswick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1866166,
        LOCATION_LATITUDE_DEG: 53.9161992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079000',
        LOCATION_NAME: 'Barns Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3924699,
        LOCATION_LATITUDE_DEG: 51.0321014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079100',
        LOCATION_NAME: 'Barns of Claverhouse',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9559148,
        LOCATION_LATITUDE_DEG: 56.4990644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079200',
        LOCATION_NAME: 'Barns of Wedderburn',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9173986,
        LOCATION_LATITUDE_DEG: 56.5005679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104600',
        LOCATION_NAME: 'Barnsbury',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1120954,
        LOCATION_LATITUDE_DEG: 51.532672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990111',
        LOCATION_NAME: 'Barnsdale',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6658706,
        LOCATION_LATITUDE_DEG: 52.6706029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079300',
        LOCATION_NAME: 'Barnsdale',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6576067,
        LOCATION_LATITUDE_DEG: 52.6733599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079600',
        LOCATION_NAME: 'Barnsley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3625898,
        LOCATION_LATITUDE_DEG: 52.532768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079500',
        LOCATION_NAME: 'Barnsley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0029112,
        LOCATION_LATITUDE_DEG: 50.8318048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079400',
        LOCATION_NAME: 'Barnsley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8891868,
        LOCATION_LATITUDE_DEG: 51.7437878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079700',
        LOCATION_NAME: 'Barnsley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4775331,
        LOCATION_LATITUDE_DEG: 53.5515577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079800',
        LOCATION_NAME: 'Barnsole',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2686065,
        LOCATION_LATITUDE_DEG: 51.261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA079900',
        LOCATION_NAME: 'Barnstaple',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0590017,
        LOCATION_LATITUDE_DEG: 51.0849465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080000',
        LOCATION_NAME: 'Barnstaple Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6941741,
        LOCATION_LATITUDE_DEG: 50.7976213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080100',
        LOCATION_NAME: 'Barnston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.080827,
        LOCATION_LATITUDE_DEG: 53.3414584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080200',
        LOCATION_NAME: 'Barnston',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.386495,
        LOCATION_LATITUDE_DEG: 51.8541697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080300',
        LOCATION_NAME: 'Barnstone',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9088606,
        LOCATION_LATITUDE_DEG: 52.9109902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080400',
        LOCATION_NAME: 'Barnt Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9867374,
        LOCATION_LATITUDE_DEG: 52.3634455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105600',
        LOCATION_NAME: 'Barnton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3059417,
        LOCATION_LATITUDE_DEG: 55.963475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080500',
        LOCATION_NAME: 'Barnton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5466312,
        LOCATION_LATITUDE_DEG: 53.2696401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080700',
        LOCATION_NAME: 'Barnwell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4550739,
        LOCATION_LATITUDE_DEG: 52.4516382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080800',
        LOCATION_NAME: 'Barnwood',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2004992,
        LOCATION_LATITUDE_DEG: 51.8631015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080900',
        LOCATION_NAME: 'Barnyards',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4495415,
        LOCATION_LATITUDE_DEG: 57.4882826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081100',
        LOCATION_NAME: 'Barons Cross',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7631976,
        LOCATION_LATITUDE_DEG: 52.2262445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081200',
        LOCATION_NAME: 'Baronscourt',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4276717,
        LOCATION_LATITUDE_DEG: 54.695012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081300',
        LOCATION_NAME: 'Barr',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7123029,
        LOCATION_LATITUDE_DEG: 55.2103526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081500',
        LOCATION_NAME: 'Barrack Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7200493,
        LOCATION_LATITUDE_DEG: 51.9861211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081900',
        LOCATION_NAME: 'Barrapoll',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9473906,
        LOCATION_LATITUDE_DEG: 56.4771684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082000',
        LOCATION_NAME: 'Barras',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2421958,
        LOCATION_LATITUDE_DEG: 54.5037629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082100',
        LOCATION_NAME: 'Barrasford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1309427,
        LOCATION_LATITUDE_DEG: 55.0547099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082200',
        LOCATION_NAME: 'Barrasford Park',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1216729,
        LOCATION_LATITUDE_DEG: 55.0851139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082500',
        LOCATION_NAME: 'Barrhead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3901531,
        LOCATION_LATITUDE_DEG: 55.8000113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082600',
        LOCATION_NAME: 'Barrhill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7706437,
        LOCATION_LATITUDE_DEG: 55.1036435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082800',
        LOCATION_NAME: 'Barrington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8656603,
        LOCATION_LATITUDE_DEG: 50.9584262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082900',
        LOCATION_NAME: 'Barrington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0406345,
        LOCATION_LATITUDE_DEG: 52.1309054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083200',
        LOCATION_NAME: 'Barripper',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3152613,
        LOCATION_LATITUDE_DEG: 50.1964764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083300',
        LOCATION_NAME: 'Barrmill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6002002,
        LOCATION_LATITUDE_DEG: 55.7291079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083400',
        LOCATION_NAME: 'Barrock',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2796522,
        LOCATION_LATITUDE_DEG: 58.6229767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084200',
        LOCATION_NAME: 'Barrow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5011351,
        LOCATION_LATITUDE_DEG: 52.5986788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084100',
        LOCATION_NAME: 'Barrow',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.399268,
        LOCATION_LATITUDE_DEG: 53.8407934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083900',
        LOCATION_NAME: 'Barrow',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1472283,
        LOCATION_LATITUDE_DEG: 52.752078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990112',
        LOCATION_NAME: 'Barrow',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6835626,
        LOCATION_LATITUDE_DEG: 52.7300535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083800',
        LOCATION_NAME: 'Barrow',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6818516,
        LOCATION_LATITUDE_DEG: 52.727364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084000',
        LOCATION_NAME: 'Barrow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.584461,
        LOCATION_LATITUDE_DEG: 52.2411022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084300',
        LOCATION_NAME: 'Barrow Gurney',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6772803,
        LOCATION_LATITUDE_DEG: 51.4096686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084400',
        LOCATION_NAME: 'Barrow Haven',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3907258,
        LOCATION_LATITUDE_DEG: 53.6927557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084500',
        LOCATION_NAME: 'Barrow Hill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.372972,
        LOCATION_LATITUDE_DEG: 53.2739282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102800',
        LOCATION_NAME: 'Barrow in Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084600',
        LOCATION_NAME: 'Barrow Mere',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4040173,
        LOCATION_LATITUDE_DEG: 53.6817588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102900',
        LOCATION_NAME: 'Barrow on Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103000',
        LOCATION_NAME: 'Barrow upon Humber',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084700',
        LOCATION_NAME: 'Barrow upon Soar',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1472283,
        LOCATION_LATITUDE_DEG: 52.752078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085100',
        LOCATION_NAME: 'Barroway Drove',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3248894,
        LOCATION_LATITUDE_DEG: 52.6094413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085200',
        LOCATION_NAME: 'Barrowby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6927568,
        LOCATION_LATITUDE_DEG: 52.9175839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085300',
        LOCATION_NAME: 'Barrowby Stenwith',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6728135,
        LOCATION_LATITUDE_DEG: 52.9762895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990113',
        LOCATION_NAME: 'Barrowden',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6040732,
        LOCATION_LATITUDE_DEG: 52.5926184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085400',
        LOCATION_NAME: 'Barrowden',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6027881,
        LOCATION_LATITUDE_DEG: 52.5898518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085500',
        LOCATION_NAME: 'Barrowford',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2204401,
        LOCATION_LATITUDE_DEG: 53.8506936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084800',
        LOCATION_NAME: 'Barrow-in-Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2260703,
        LOCATION_LATITUDE_DEG: 54.1155359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA084900',
        LOCATION_NAME: 'Barrow-on-Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4707579,
        LOCATION_LATITUDE_DEG: 52.8549273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085600',
        LOCATION_NAME: 'Barrows Green',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7279899,
        LOCATION_LATITUDE_DEG: 54.2866419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085000',
        LOCATION_NAME: 'Barrow-upon-Humber',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3795303,
        LOCATION_LATITUDE_DEG: 53.6746512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085700',
        LOCATION_NAME: 'Barrs Court',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4887344,
        LOCATION_LATITUDE_DEG: 51.4461635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085900',
        LOCATION_NAME: 'Barry',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2658216,
        LOCATION_LATITUDE_DEG: 51.4058689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA085800',
        LOCATION_NAME: 'Barry',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7524561,
        LOCATION_LATITUDE_DEG: 56.4994661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086100',
        LOCATION_NAME: 'Barry Island',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2711448,
        LOCATION_LATITUDE_DEG: 51.3919708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086200',
        LOCATION_NAME: 'Barsby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9664016,
        LOCATION_LATITUDE_DEG: 52.6951655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086300',
        LOCATION_NAME: 'Barsham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5241741,
        LOCATION_LATITUDE_DEG: 52.4504137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086400',
        LOCATION_NAME: 'Barstable',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4854457,
        LOCATION_LATITUDE_DEG: 51.5735441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086500',
        LOCATION_NAME: 'Barston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6971454,
        LOCATION_LATITUDE_DEG: 52.4006504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086600',
        LOCATION_NAME: 'Bartestree',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6295674,
        LOCATION_LATITUDE_DEG: 52.0641312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086700',
        LOCATION_NAME: 'Barthol Chapel',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.308499,
        LOCATION_LATITUDE_DEG: 57.3946472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086800',
        LOCATION_NAME: 'Barthomley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3471306,
        LOCATION_LATITUDE_DEG: 53.0683193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086900',
        LOCATION_NAME: 'Barthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8133979,
        LOCATION_LATITUDE_DEG: 54.0278913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087000',
        LOCATION_NAME: 'Bartington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5940876,
        LOCATION_LATITUDE_DEG: 53.2843454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087100',
        LOCATION_NAME: 'Bartle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7547744,
        LOCATION_LATITUDE_DEG: 53.796394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087300',
        LOCATION_NAME: 'Bartley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5642351,
        LOCATION_LATITUDE_DEG: 50.9139026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087400',
        LOCATION_NAME: 'Bartley Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.990541,
        LOCATION_LATITUDE_DEG: 52.4339544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087500',
        LOCATION_NAME: 'Bartlow',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3124659,
        LOCATION_LATITUDE_DEG: 52.0825921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087700',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5378813,
        LOCATION_LATITUDE_DEG: 50.4909891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088100',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9776041,
        LOCATION_LATITUDE_DEG: 53.5751782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087800',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8241553,
        LOCATION_LATITUDE_DEG: 53.0825319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088300',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7346944,
        LOCATION_LATITUDE_DEG: 53.8254999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088400',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8547895,
        LOCATION_LATITUDE_DEG: 51.9271062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087600',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8498056,
        LOCATION_LATITUDE_DEG: 52.1562261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087900',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6436645,
        LOCATION_LATITUDE_DEG: 54.4743502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088000',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2817251,
        LOCATION_LATITUDE_DEG: 50.698384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088200',
        LOCATION_NAME: 'Barton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0572181,
        LOCATION_LATITUDE_DEG: 52.1819039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088500',
        LOCATION_NAME: 'Barton Bendish',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5302295,
        LOCATION_LATITUDE_DEG: 52.6214454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088600',
        LOCATION_NAME: 'Barton Hartshorn',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0682158,
        LOCATION_LATITUDE_DEG: 51.9723981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088700',
        LOCATION_NAME: 'Barton Hill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5603494,
        LOCATION_LATITUDE_DEG: 51.4547728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101900',
        LOCATION_NAME: 'Barton in Fabis',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089600',
        LOCATION_NAME: 'Barton in the Beans',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4102837,
        LOCATION_LATITUDE_DEG: 52.6536729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102000',
        LOCATION_NAME: 'Barton le Clay',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102100',
        LOCATION_NAME: 'Barton le Street',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089700',
        LOCATION_NAME: 'Barton le Willows',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.913528,
        LOCATION_LATITUDE_DEG: 54.0577199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088800',
        LOCATION_NAME: 'Barton Mills',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5208094,
        LOCATION_LATITUDE_DEG: 52.3349145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA088900',
        LOCATION_NAME: 'Barton Moss',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.392116,
        LOCATION_LATITUDE_DEG: 53.4664579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089800',
        LOCATION_NAME: 'Barton on Sea',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6655458,
        LOCATION_LATITUDE_DEG: 50.7382954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102200',
        LOCATION_NAME: 'Barton on the Heath',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089000',
        LOCATION_NAME: 'Barton Seagrave',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.696208,
        LOCATION_LATITUDE_DEG: 52.3843353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101500',
        LOCATION_NAME: 'Barton St David',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089100',
        LOCATION_NAME: 'Barton St. David',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6548999,
        LOCATION_LATITUDE_DEG: 51.0844372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089200',
        LOCATION_NAME: 'Barton Stacey',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3776133,
        LOCATION_LATITUDE_DEG: 51.1673252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089300',
        LOCATION_NAME: 'Barton Turf',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4883309,
        LOCATION_LATITUDE_DEG: 52.7486429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089900',
        LOCATION_NAME: 'Barton under Needwood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7206873,
        LOCATION_LATITUDE_DEG: 52.7639849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA102300',
        LOCATION_NAME: 'Barton upon Humber',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089400',
        LOCATION_NAME: 'Barton Upon Irwell',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3648417,
        LOCATION_LATITUDE_DEG: 53.476262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA089500',
        LOCATION_NAME: 'Barton Vale',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4267517,
        LOCATION_LATITUDE_DEG: 53.6755597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090000',
        LOCATION_NAME: 'Barton-in-Fabis',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2247897,
        LOCATION_LATITUDE_DEG: 52.8886038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090100',
        LOCATION_NAME: 'Barton-le-Clay',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4256378,
        LOCATION_LATITUDE_DEG: 51.9655958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090200',
        LOCATION_NAME: 'Barton-le-Street',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8962726,
        LOCATION_LATITUDE_DEG: 54.1587078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090300',
        LOCATION_NAME: 'Barton-on-the-Heath',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.625545,
        LOCATION_LATITUDE_DEG: 51.9913056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090400',
        LOCATION_NAME: 'Barton-upon-Humber',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4383827,
        LOCATION_LATITUDE_DEG: 53.6828591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090500',
        LOCATION_NAME: 'Barugh Green',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.53004,
        LOCATION_LATITUDE_DEG: 53.5647563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090600',
        LOCATION_NAME: 'Barvas',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5191143,
        LOCATION_LATITUDE_DEG: 58.3609321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090700',
        LOCATION_NAME: 'Barvennan',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5147294,
        LOCATION_LATITUDE_DEG: 54.9133293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090800',
        LOCATION_NAME: 'Barway',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2701708,
        LOCATION_LATITUDE_DEG: 52.3580207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA090900',
        LOCATION_NAME: 'Barwell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3446074,
        LOCATION_LATITUDE_DEG: 52.5678598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990673',
        LOCATION_NAME: 'Barwick',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091000',
        LOCATION_NAME: 'Barwick',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6236643,
        LOCATION_LATITUDE_DEG: 50.920119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091100',
        LOCATION_NAME: 'Barwick in Elmet',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3924198,
        LOCATION_LATITUDE_DEG: 53.8316854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091200',
        LOCATION_NAME: 'Baschurch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8525652,
        LOCATION_LATITUDE_DEG: 52.7931047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091300',
        LOCATION_NAME: 'Bascote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4050962,
        LOCATION_LATITUDE_DEG: 52.2702369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091400',
        LOCATION_NAME: 'Bascote Heath',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4175688,
        LOCATION_LATITUDE_DEG: 52.2635375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091600',
        LOCATION_NAME: 'Basford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9014243,
        LOCATION_LATITUDE_DEG: 52.4624744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091650',
        LOCATION_NAME: 'Basford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4243047,
        LOCATION_LATITUDE_DEG: 53.0659924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091500',
        LOCATION_NAME: 'Basford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.011834,
        LOCATION_LATITUDE_DEG: 53.0606979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091700',
        LOCATION_NAME: 'Bashall Eaves',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4680614,
        LOCATION_LATITUDE_DEG: 53.8886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091800',
        LOCATION_NAME: 'Bashley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6581775,
        LOCATION_LATITUDE_DEG: 50.7730976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091950',
        LOCATION_NAME: 'Basildon SS13',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.461765,
        LOCATION_LATITUDE_DEG: 51.5768587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091900',
        LOCATION_NAME: 'Basildon SS14',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4618028,
        LOCATION_LATITUDE_DEG: 51.568745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091925',
        LOCATION_NAME: 'Basildon SS15',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.461765,
        LOCATION_LATITUDE_DEG: 51.5768587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA091938',
        LOCATION_NAME: 'Basildon SS16',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4579444,
        LOCATION_LATITUDE_DEG: 51.559292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092000',
        LOCATION_NAME: 'Basingstoke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0826247,
        LOCATION_LATITUDE_DEG: 51.2619348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092100',
        LOCATION_NAME: 'Baslow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6215491,
        LOCATION_LATITUDE_DEG: 53.24753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092200',
        LOCATION_NAME: 'Bason Bridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.943167,
        LOCATION_LATITUDE_DEG: 51.2075459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092300',
        LOCATION_NAME: 'Bassaleg',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0521353,
        LOCATION_LATITUDE_DEG: 51.5760856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092400',
        LOCATION_NAME: 'Bassendean',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5833974,
        LOCATION_LATITUDE_DEG: 55.7029773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092500',
        LOCATION_NAME: 'Bassenthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1931554,
        LOCATION_LATITUDE_DEG: 54.6801889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092600',
        LOCATION_NAME: 'Bassenthwaite Lake',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2143882,
        LOCATION_LATITUDE_DEG: 54.6592867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092700',
        LOCATION_NAME: 'Basset Down',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8274688,
        LOCATION_LATITUDE_DEG: 51.5217652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092800',
        LOCATION_NAME: 'Bassett',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4034525,
        LOCATION_LATITUDE_DEG: 50.9481045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA092900',
        LOCATION_NAME: 'Bassetts Pole',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7906764,
        LOCATION_LATITUDE_DEG: 52.5903653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093000',
        LOCATION_NAME: 'Bassingbourn',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0529811,
        LOCATION_LATITUDE_DEG: 52.0777942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093100',
        LOCATION_NAME: 'Bassingfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0781673,
        LOCATION_LATITUDE_DEG: 52.9298934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093200',
        LOCATION_NAME: 'Bassingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6373762,
        LOCATION_LATITUDE_DEG: 53.1291015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093300',
        LOCATION_NAME: 'Bassingthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5640504,
        LOCATION_LATITUDE_DEG: 52.8453734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093400',
        LOCATION_NAME: 'Basted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3184284,
        LOCATION_LATITUDE_DEG: 51.2834187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093500',
        LOCATION_NAME: 'Baston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3517629,
        LOCATION_LATITUDE_DEG: 52.7118605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990808',
        LOCATION_NAME: 'Batchcote',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093600',
        LOCATION_NAME: 'Batchcott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7417983,
        LOCATION_LATITUDE_DEG: 52.3355557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093700',
        LOCATION_NAME: 'Batchmere',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.818702,
        LOCATION_LATITUDE_DEG: 50.7779863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093800',
        LOCATION_NAME: 'Batchworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4609944,
        LOCATION_LATITUDE_DEG: 51.6326639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA093900',
        LOCATION_NAME: 'Batchworth Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4470417,
        LOCATION_LATITUDE_DEG: 51.6142602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094100',
        LOCATION_NAME: 'Batcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5429976,
        LOCATION_LATITUDE_DEG: 50.832709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094000',
        LOCATION_NAME: 'Batcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.448647,
        LOCATION_LATITUDE_DEG: 51.1495408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105000',
        LOCATION_NAME: 'Batemans Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8934611,
        LOCATION_LATITUDE_DEG: 52.387099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094200',
        LOCATION_NAME: 'Bath',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3590783,
        LOCATION_LATITUDE_DEG: 51.3810577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094300',
        LOCATION_NAME: 'Bath Side',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2869409,
        LOCATION_LATITUDE_DEG: 51.9444674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094400',
        LOCATION_NAME: 'Bathampton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3219579,
        LOCATION_LATITUDE_DEG: 51.3952571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094500',
        LOCATION_NAME: 'Bathealton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3104984,
        LOCATION_LATITUDE_DEG: 51.0084334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094600',
        LOCATION_NAME: 'Batheaston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3068404,
        LOCATION_LATITUDE_DEG: 51.4024648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094700',
        LOCATION_NAME: 'Batherton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5064971,
        LOCATION_LATITUDE_DEG: 53.0443192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094800',
        LOCATION_NAME: 'Bathford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3009169,
        LOCATION_LATITUDE_DEG: 51.400259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA094900',
        LOCATION_NAME: 'Bathgate',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6404254,
        LOCATION_LATITUDE_DEG: 55.9025155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095000',
        LOCATION_NAME: 'Bathingbourne',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2233929,
        LOCATION_LATITUDE_DEG: 50.6487771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095100',
        LOCATION_NAME: 'Bathley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.839284,
        LOCATION_LATITUDE_DEG: 53.1233115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095200',
        LOCATION_NAME: 'Bathpool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4213907,
        LOCATION_LATITUDE_DEG: 50.5466988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095300',
        LOCATION_NAME: 'Bathpool',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0616964,
        LOCATION_LATITUDE_DEG: 51.0298368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095400',
        LOCATION_NAME: 'Bathwick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3515226,
        LOCATION_LATITUDE_DEG: 51.3833647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095500',
        LOCATION_NAME: 'Batley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6451861,
        LOCATION_LATITUDE_DEG: 53.7278774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095600',
        LOCATION_NAME: 'Batley Carr',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.634136,
        LOCATION_LATITUDE_DEG: 53.7033756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095700',
        LOCATION_NAME: 'Batsford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7263538,
        LOCATION_LATITUDE_DEG: 52.0027148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095800',
        LOCATION_NAME: 'Battersby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0808395,
        LOCATION_LATITUDE_DEG: 54.4598396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104100',
        LOCATION_NAME: 'Battersea',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.165306,
        LOCATION_LATITUDE_DEG: 51.4745368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096000',
        LOCATION_NAME: 'Battisborough Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9647395,
        LOCATION_LATITUDE_DEG: 50.3083764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096100',
        LOCATION_NAME: 'Battisford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0035339,
        LOCATION_LATITUDE_DEG: 52.1487859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096200',
        LOCATION_NAME: 'Battisford Tye',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9599868,
        LOCATION_LATITUDE_DEG: 52.1484935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096400',
        LOCATION_NAME: 'Battle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4429041,
        LOCATION_LATITUDE_DEG: 51.9683323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096300',
        LOCATION_NAME: 'Battle',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.485523,
        LOCATION_LATITUDE_DEG: 50.9167836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096600',
        LOCATION_NAME: 'Battledown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.058351,
        LOCATION_LATITUDE_DEG: 51.8929043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105900',
        LOCATION_NAME: 'Battlefield',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2666376,
        LOCATION_LATITUDE_DEG: 55.829928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096700',
        LOCATION_NAME: 'Battlefield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7158567,
        LOCATION_LATITUDE_DEG: 52.7458986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096800',
        LOCATION_NAME: 'Battlehill',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7683524,
        LOCATION_LATITUDE_DEG: 57.4435583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096900',
        LOCATION_NAME: 'Battlesbridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5683653,
        LOCATION_LATITUDE_DEG: 51.5995415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097000',
        LOCATION_NAME: 'Battlesden',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.593993,
        LOCATION_LATITUDE_DEG: 51.9476914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097100',
        LOCATION_NAME: 'Baucott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6784139,
        LOCATION_LATITUDE_DEG: 52.480966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097200',
        LOCATION_NAME: 'Baugh',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8315471,
        LOCATION_LATITUDE_DEG: 56.4920064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097300',
        LOCATION_NAME: 'Baughton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1768063,
        LOCATION_LATITUDE_DEG: 52.0764249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097400',
        LOCATION_NAME: 'Baughurst',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1630475,
        LOCATION_LATITUDE_DEG: 51.3473415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097500',
        LOCATION_NAME: 'Baulking',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5410563,
        LOCATION_LATITUDE_DEG: 51.6123759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097600',
        LOCATION_NAME: 'Baumber',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1684262,
        LOCATION_LATITUDE_DEG: 53.2506113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097700',
        LOCATION_NAME: 'Baunton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9682093,
        LOCATION_LATITUDE_DEG: 51.7369928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098000',
        LOCATION_NAME: 'Baverstock',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9601944,
        LOCATION_LATITUDE_DEG: 51.0811296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098100',
        LOCATION_NAME: 'Bawburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1844436,
        LOCATION_LATITUDE_DEG: 52.634831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098200',
        LOCATION_NAME: 'Bawdeswell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0331632,
        LOCATION_LATITUDE_DEG: 52.7464444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098300',
        LOCATION_NAME: 'Bawdrip',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9405887,
        LOCATION_LATITUDE_DEG: 51.1526449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098400',
        LOCATION_NAME: 'Bawdsey',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4204556,
        LOCATION_LATITUDE_DEG: 52.0087661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099000',
        LOCATION_NAME: 'Bawsey',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4756895,
        LOCATION_LATITUDE_DEG: 52.7454506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099100',
        LOCATION_NAME: 'Bawtry',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0188713,
        LOCATION_LATITUDE_DEG: 53.4304399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099200',
        LOCATION_NAME: 'Baxenden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3502979,
        LOCATION_LATITUDE_DEG: 53.7389833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099300',
        LOCATION_NAME: 'Baxterley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5863996,
        LOCATION_LATITUDE_DEG: 52.5685646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099400',
        LOCATION_NAME: 'Baxworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4491395,
        LOCATION_LATITUDE_DEG: 50.9742397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099500',
        LOCATION_NAME: 'Bay Horse',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7675885,
        LOCATION_LATITUDE_DEG: 53.9691107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099700',
        LOCATION_NAME: 'Baycliff',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0879308,
        LOCATION_LATITUDE_DEG: 54.1427343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099800',
        LOCATION_NAME: 'Baydon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5957536,
        LOCATION_LATITUDE_DEG: 51.5001621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099900',
        LOCATION_NAME: 'Bayfield',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6909528,
        LOCATION_LATITUDE_DEG: 51.641886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099950',
        LOCATION_NAME: 'Bayfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0649766,
        LOCATION_LATITUDE_DEG: 52.925073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100000',
        LOCATION_NAME: 'Bayford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3785434,
        LOCATION_LATITUDE_DEG: 51.0659275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100100',
        LOCATION_NAME: 'Bayford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1004396,
        LOCATION_LATITUDE_DEG: 51.7592708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100200',
        LOCATION_NAME: 'Bayfordbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0934475,
        LOCATION_LATITUDE_DEG: 51.7769732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100300',
        LOCATION_NAME: 'Bayhead',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4423947,
        LOCATION_LATITUDE_DEG: 57.5881178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100400',
        LOCATION_NAME: 'Bayherivagh',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4245857,
        LOCATION_LATITUDE_DEG: 57.0000586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100500',
        LOCATION_NAME: 'Bayles',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4519574,
        LOCATION_LATITUDE_DEG: 54.7996873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100600',
        LOCATION_NAME: 'Baylham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0727136,
        LOCATION_LATITUDE_DEG: 52.1214844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100700',
        LOCATION_NAME: 'Baymore',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.219135,
        LOCATION_LATITUDE_DEG: 57.4877062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100800',
        LOCATION_NAME: 'Baynards Green',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.207362,
        LOCATION_LATITUDE_DEG: 51.9541111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA100900',
        LOCATION_NAME: 'Baysdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0424509,
        LOCATION_LATITUDE_DEG: 54.4520362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101000',
        LOCATION_NAME: 'Baysham',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6096601,
        LOCATION_LATITUDE_DEG: 51.9488164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101100',
        LOCATION_NAME: 'Bayston Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7704905,
        LOCATION_LATITUDE_DEG: 52.6740878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104400',
        LOCATION_NAME: 'Bayswater',
        COUNTY_NAME: 'London',
        POSTCODE: 'W2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.17578,
        LOCATION_LATITUDE_DEG: 51.5051074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101200',
        LOCATION_NAME: 'Baythorne End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5155464,
        LOCATION_LATITUDE_DEG: 52.056783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101300',
        LOCATION_NAME: 'Bayton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4484263,
        LOCATION_LATITUDE_DEG: 52.3558521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA101400',
        LOCATION_NAME: 'Bayworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2747162,
        LOCATION_LATITUDE_DEG: 51.7073775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000100',
        LOCATION_NAME: 'Beach',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4250783,
        LOCATION_LATITUDE_DEG: 51.434865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000200',
        LOCATION_NAME: 'Beach Hay',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4167896,
        LOCATION_LATITUDE_DEG: 52.363053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000300',
        LOCATION_NAME: 'Beachampton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8750871,
        LOCATION_LATITUDE_DEG: 52.0263011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000400',
        LOCATION_NAME: 'Beachamwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5885521,
        LOCATION_LATITUDE_DEG: 52.617136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000500',
        LOCATION_NAME: 'Beachley',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6514393,
        LOCATION_LATITUDE_DEG: 51.6197836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000600',
        LOCATION_NAME: 'Beachy Head',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2444483,
        LOCATION_LATITUDE_DEG: 50.7359686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000800',
        LOCATION_NAME: 'Beacon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2859508,
        LOCATION_LATITUDE_DEG: 50.203779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000700',
        LOCATION_NAME: 'Beacon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1647499,
        LOCATION_LATITUDE_DEG: 50.8393205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE000900',
        LOCATION_NAME: 'Beacon End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8433422,
        LOCATION_LATITUDE_DEG: 51.8810657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001000',
        LOCATION_NAME: 'Beacon Heath',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4867536,
        LOCATION_LATITUDE_DEG: 50.7505137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001100',
        LOCATION_NAME: 'Beacon Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0390145,
        LOCATION_LATITUDE_DEG: 50.7509998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001200',
        LOCATION_NAME: 'Beacon Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.744529,
        LOCATION_LATITUDE_DEG: 51.1239763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047000',
        LOCATION_NAME: 'Beacon Lough',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5882054,
        LOCATION_LATITUDE_DEG: 54.9377972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001300',
        LOCATION_NAME: 'Beacon Park',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1580211,
        LOCATION_LATITUDE_DEG: 50.3936883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001400',
        LOCATION_NAME: 'Beacons Bottom',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.864899,
        LOCATION_LATITUDE_DEG: 51.6504828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001500',
        LOCATION_NAME: 'Beaconsfield',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6437197,
        LOCATION_LATITUDE_DEG: 51.6096649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001600',
        LOCATION_NAME: 'Beadlam',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9946435,
        LOCATION_LATITUDE_DEG: 54.2530172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001700',
        LOCATION_NAME: 'Beadlow',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3893692,
        LOCATION_LATITUDE_DEG: 52.0338986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001800',
        LOCATION_NAME: 'Beadnell',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6314278,
        LOCATION_LATITUDE_DEG: 55.5586533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001900',
        LOCATION_NAME: 'Beaford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0555559,
        LOCATION_LATITUDE_DEG: 50.9152364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002100',
        LOCATION_NAME: 'Beal',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.191381,
        LOCATION_LATITUDE_DEG: 53.7215663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002800',
        LOCATION_NAME: 'Beals Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3177381,
        LOCATION_LATITUDE_DEG: 50.5677082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002900',
        LOCATION_NAME: 'Beambridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2709087,
        LOCATION_LATITUDE_DEG: 50.9661325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003000',
        LOCATION_NAME: 'Beambridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9010045,
        LOCATION_LATITUDE_DEG: 52.426764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003100',
        LOCATION_NAME: 'Beamhurst',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9182926,
        LOCATION_LATITUDE_DEG: 52.9280017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003200',
        LOCATION_NAME: 'Beaminster',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.736912,
        LOCATION_LATITUDE_DEG: 50.8086126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003300',
        LOCATION_NAME: 'Beamish',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6487338,
        LOCATION_LATITUDE_DEG: 54.875992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003400',
        LOCATION_NAME: 'Beamond End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6753561,
        LOCATION_LATITUDE_DEG: 51.6625624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003500',
        LOCATION_NAME: 'Beamsley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8803263,
        LOCATION_LATITUDE_DEG: 53.9669994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003600',
        LOCATION_NAME: 'Bean',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2853006,
        LOCATION_LATITUDE_DEG: 51.4263331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003700',
        LOCATION_NAME: 'Beanacre',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1375115,
        LOCATION_LATITUDE_DEG: 51.3952589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003800',
        LOCATION_NAME: 'Beanhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7366546,
        LOCATION_LATITUDE_DEG: 52.0162025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE003900',
        LOCATION_NAME: 'Beanley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8714231,
        LOCATION_LATITUDE_DEG: 55.4586442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004000',
        LOCATION_NAME: 'Beansburn',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4839685,
        LOCATION_LATITUDE_DEG: 55.6160917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004100',
        LOCATION_NAME: 'Beare',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4352478,
        LOCATION_LATITUDE_DEG: 50.799215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004200',
        LOCATION_NAME: 'Beare Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3149727,
        LOCATION_LATITUDE_DEG: 51.1779164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004300',
        LOCATION_NAME: 'Bearley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7310427,
        LOCATION_LATITUDE_DEG: 52.2433311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004400',
        LOCATION_NAME: 'Bearpark',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6284301,
        LOCATION_LATITUDE_DEG: 54.7821826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004500',
        LOCATION_NAME: 'Bearsbridge',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3420196,
        LOCATION_LATITUDE_DEG: 54.9105031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004600',
        LOCATION_NAME: 'Bearsden',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3323719,
        LOCATION_LATITUDE_DEG: 55.9195205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004700',
        LOCATION_NAME: 'Bearsted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5812142,
        LOCATION_LATITUDE_DEG: 51.2741125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004800',
        LOCATION_NAME: 'Bearstone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4118427,
        LOCATION_LATITUDE_DEG: 52.9533073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE004900',
        LOCATION_NAME: 'Bearwood',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9046905,
        LOCATION_LATITUDE_DEG: 52.2005446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005000',
        LOCATION_NAME: 'Beattock',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4493544,
        LOCATION_LATITUDE_DEG: 55.3050511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005100',
        LOCATION_NAME: 'Beauchamp Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.295005,
        LOCATION_LATITUDE_DEG: 51.7592634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047100',
        LOCATION_NAME: 'Beauchief',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4924668,
        LOCATION_LATITUDE_DEG: 53.3364367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005300',
        LOCATION_NAME: 'Beaufort',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1996674,
        LOCATION_LATITUDE_DEG: 51.7967084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005500',
        LOCATION_NAME: 'Beaulieu',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4504458,
        LOCATION_LATITUDE_DEG: 50.8177938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005600',
        LOCATION_NAME: 'Beauly',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4585541,
        LOCATION_LATITUDE_DEG: 57.4835777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005700',
        LOCATION_NAME: 'Beaumaris',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL58',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0917319,
        LOCATION_LATITUDE_DEG: 53.263359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005800',
        LOCATION_NAME: 'Beaumont',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0169413,
        LOCATION_LATITUDE_DEG: 54.9238064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005900',
        LOCATION_NAME: 'Beaumont',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1665548,
        LOCATION_LATITUDE_DEG: 51.8804594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006100',
        LOCATION_NAME: 'Beaumont Leys',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1704233,
        LOCATION_LATITUDE_DEG: 52.6698679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006200',
        LOCATION_NAME: 'Beaumontcote',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.436407,
        LOCATION_LATITUDE_DEG: 53.6462522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006400',
        LOCATION_NAME: 'Beausale',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6462531,
        LOCATION_LATITUDE_DEG: 52.3347473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006500',
        LOCATION_NAME: 'Beauworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1770659,
        LOCATION_LATITUDE_DEG: 51.030611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006600',
        LOCATION_NAME: 'Beaworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1820331,
        LOCATION_LATITUDE_DEG: 50.7721262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006700',
        LOCATION_NAME: 'Beazley End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5347412,
        LOCATION_LATITUDE_DEG: 51.9313746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006800',
        LOCATION_NAME: 'Bebington',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0150732,
        LOCATION_LATITUDE_DEG: 53.3520598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006900',
        LOCATION_NAME: 'Bebside',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5607505,
        LOCATION_LATITUDE_DEG: 55.1263078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007000',
        LOCATION_NAME: 'Beccles',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5711222,
        LOCATION_LATITUDE_DEG: 52.4578105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007100',
        LOCATION_NAME: 'Beck Foot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5908419,
        LOCATION_LATITUDE_DEG: 54.3627503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007200',
        LOCATION_NAME: 'Beck Row',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4879268,
        LOCATION_LATITUDE_DEG: 52.36922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007300',
        LOCATION_NAME: 'Beckbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3474201,
        LOCATION_LATITUDE_DEG: 52.611376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007400',
        LOCATION_NAME: 'Beckenham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0160252,
        LOCATION_LATITUDE_DEG: 51.4066306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007500',
        LOCATION_NAME: 'Beckermet',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5145175,
        LOCATION_LATITUDE_DEG: 54.4470666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007600',
        LOCATION_NAME: 'Beckermonds',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1901843,
        LOCATION_LATITUDE_DEG: 54.2182293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007700',
        LOCATION_NAME: 'Beckfoot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4100955,
        LOCATION_LATITUDE_DEG: 54.8353098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007800',
        LOCATION_NAME: 'Beckford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0323846,
        LOCATION_LATITUDE_DEG: 52.0204181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE007900',
        LOCATION_NAME: 'Beckhampton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8690933,
        LOCATION_LATITUDE_DEG: 51.4180539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008000',
        LOCATION_NAME: 'Beckhole',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7351608,
        LOCATION_LATITUDE_DEG: 54.4118619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008100',
        LOCATION_NAME: 'Beckingham',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8249447,
        LOCATION_LATITUDE_DEG: 53.4019348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008200',
        LOCATION_NAME: 'Beckingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6925381,
        LOCATION_LATITUDE_DEG: 53.0743013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008300',
        LOCATION_NAME: 'Beckington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2832163,
        LOCATION_LATITUDE_DEG: 51.2646469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008400',
        LOCATION_NAME: 'Beckjay',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8847391,
        LOCATION_LATITUDE_DEG: 52.3842586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008500',
        LOCATION_NAME: 'Beckley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.683778,
        LOCATION_LATITUDE_DEG: 50.7647967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008600',
        LOCATION_NAME: 'Beckley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1838465,
        LOCATION_LATITUDE_DEG: 51.7966868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008700',
        LOCATION_NAME: 'Beckley',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6449308,
        LOCATION_LATITUDE_DEG: 50.9852868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008800',
        LOCATION_NAME: 'Becknell',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8119486,
        LOCATION_LATITUDE_DEG: 52.2643493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE008900',
        LOCATION_NAME: 'Beckrivig',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9061037,
        LOCATION_LATITUDE_DEG: 57.8170374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009000',
        LOCATION_NAME: 'Beckside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1759248,
        LOCATION_LATITUDE_DEG: 54.2298466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009100',
        LOCATION_NAME: 'Beckwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.561552,
        LOCATION_LATITUDE_DEG: 53.9668973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009200',
        LOCATION_NAME: 'Beckwithshaw',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5914534,
        LOCATION_LATITUDE_DEG: 53.9741038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009500',
        LOCATION_NAME: 'Bedale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5931875,
        LOCATION_LATITUDE_DEG: 54.2885304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009600',
        LOCATION_NAME: 'Bedburn',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8414974,
        LOCATION_LATITUDE_DEG: 54.6788678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009700',
        LOCATION_NAME: 'Bedchester',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2103702,
        LOCATION_LATITUDE_DEG: 50.9564174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009800',
        LOCATION_NAME: 'Beddau',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3547229,
        LOCATION_LATITUDE_DEG: 51.5553924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009900',
        LOCATION_NAME: 'Beddgelert',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0981867,
        LOCATION_LATITUDE_DEG: 53.01164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010000',
        LOCATION_NAME: 'Beddingham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0541117,
        LOCATION_LATITUDE_DEG: 50.8510761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010100',
        LOCATION_NAME: 'Beddington',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1300903,
        LOCATION_LATITUDE_DEG: 51.3710296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010200',
        LOCATION_NAME: 'Bedersaig',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9982088,
        LOCATION_LATITUDE_DEG: 58.018559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010300',
        LOCATION_NAME: 'Bedfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2517921,
        LOCATION_LATITUDE_DEG: 52.2528984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010400',
        LOCATION_NAME: 'Bedfont',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.429238,
        LOCATION_LATITUDE_DEG: 51.454043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010500',
        LOCATION_NAME: 'Bedford',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4663647,
        LOCATION_LATITUDE_DEG: 52.1353082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010600',
        LOCATION_NAME: 'Bedhampton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0013777,
        LOCATION_LATITUDE_DEG: 50.856096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010700',
        LOCATION_NAME: 'Bedingfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1955502,
        LOCATION_LATITUDE_DEG: 52.2731988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010900',
        LOCATION_NAME: 'Bedlington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5913858,
        LOCATION_LATITUDE_DEG: 55.1304136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011000',
        LOCATION_NAME: 'Bedlinog',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3099447,
        LOCATION_LATITUDE_DEG: 51.7014052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011100',
        LOCATION_NAME: 'Bedminster',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5986529,
        LOCATION_LATITUDE_DEG: 51.4328661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011200',
        LOCATION_NAME: 'Bedminster Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6209429,
        LOCATION_LATITUDE_DEG: 51.4204661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011300',
        LOCATION_NAME: 'Bedmond',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4088433,
        LOCATION_LATITUDE_DEG: 51.7204691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011400',
        LOCATION_NAME: 'Bednall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0661986,
        LOCATION_LATITUDE_DEG: 52.7578849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011500',
        LOCATION_NAME: 'Bednall Head',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0451664,
        LOCATION_LATITUDE_DEG: 52.7545862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011600',
        LOCATION_NAME: 'Bedrule',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6324141,
        LOCATION_LATITUDE_DEG: 55.4553616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011700',
        LOCATION_NAME: 'Bedstone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9259287,
        LOCATION_LATITUDE_DEG: 52.3744661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011800',
        LOCATION_NAME: 'Bedwas',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.197499,
        LOCATION_LATITUDE_DEG: 51.5924892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE011900',
        LOCATION_NAME: 'Bedwellty',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2073619,
        LOCATION_LATITUDE_DEG: 51.6959396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012000',
        LOCATION_NAME: 'Bedworth',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.467346,
        LOCATION_LATITUDE_DEG: 52.4787539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012100',
        LOCATION_NAME: 'Bedwyn Common',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6356614,
        LOCATION_LATITUDE_DEG: 51.3847554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012200',
        LOCATION_NAME: 'Beeby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0188213,
        LOCATION_LATITUDE_DEG: 52.6686648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012300',
        LOCATION_NAME: 'Beech',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2227737,
        LOCATION_LATITUDE_DEG: 52.9420077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012400',
        LOCATION_NAME: 'Beech',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0078611,
        LOCATION_LATITUDE_DEG: 51.1439181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012500',
        LOCATION_NAME: 'Beech Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9972751,
        LOCATION_LATITUDE_DEG: 51.3734416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012600',
        LOCATION_NAME: 'Beechdale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1983981,
        LOCATION_LATITUDE_DEG: 52.9638954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012700',
        LOCATION_NAME: 'Beechgrove',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0072647,
        LOCATION_LATITUDE_DEG: 52.2169508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012800',
        LOCATION_NAME: 'Beechingstoke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8745209,
        LOCATION_LATITUDE_DEG: 51.3319457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048600',
        LOCATION_NAME: 'Beechmount',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9636911,
        LOCATION_LATITUDE_DEG: 54.5934291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE012900',
        LOCATION_NAME: 'Beechwood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6998948,
        LOCATION_LATITUDE_DEG: 53.3157487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013000',
        LOCATION_NAME: 'Beedon',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2955558,
        LOCATION_LATITUDE_DEG: 51.4938603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013100',
        LOCATION_NAME: 'Beedon Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3208175,
        LOCATION_LATITUDE_DEG: 51.4836587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013200',
        LOCATION_NAME: 'Beedon Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2818266,
        LOCATION_LATITUDE_DEG: 51.4828599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013300',
        LOCATION_NAME: 'Beeford',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2726151,
        LOCATION_LATITUDE_DEG: 53.9723868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013400',
        LOCATION_NAME: 'Beeleigh',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.664791,
        LOCATION_LATITUDE_DEG: 51.7395577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013500',
        LOCATION_NAME: 'Beeley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6038393,
        LOCATION_LATITUDE_DEG: 53.2030263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013600',
        LOCATION_NAME: 'Beelsby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1765332,
        LOCATION_LATITUDE_DEG: 53.5005314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013700',
        LOCATION_NAME: 'Beenham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1462665,
        LOCATION_LATITUDE_DEG: 51.4157464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013900',
        LOCATION_NAME: 'Beer',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0945689,
        LOCATION_LATITUDE_DEG: 50.6990017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014000',
        LOCATION_NAME: 'Beer Hackett',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5704374,
        LOCATION_LATITUDE_DEG: 50.9039151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014100',
        LOCATION_NAME: 'Beercrocombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9724543,
        LOCATION_LATITUDE_DEG: 50.9764814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014200',
        LOCATION_NAME: 'Beesands',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6558423,
        LOCATION_LATITUDE_DEG: 50.2526685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014300',
        LOCATION_NAME: 'Beesby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0917288,
        LOCATION_LATITUDE_DEG: 53.4504313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014400',
        LOCATION_NAME: 'Beeson',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6679774,
        LOCATION_LATITUDE_DEG: 50.2550676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014900',
        LOCATION_NAME: 'Beeston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6847594,
        LOCATION_LATITUDE_DEG: 53.1230355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015100',
        LOCATION_NAME: 'Beeston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5530673,
        LOCATION_LATITUDE_DEG: 53.7807851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014800',
        LOCATION_NAME: 'Beeston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2114332,
        LOCATION_LATITUDE_DEG: 52.9250896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014600',
        LOCATION_NAME: 'Beeston',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2949373,
        LOCATION_LATITUDE_DEG: 52.1203013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014500',
        LOCATION_NAME: 'Beeston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8261672,
        LOCATION_LATITUDE_DEG: 52.7062427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE014700',
        LOCATION_NAME: 'Beeston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4492983,
        LOCATION_LATITUDE_DEG: 52.7452432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015000',
        LOCATION_NAME: 'Beeston Castle',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6926474,
        LOCATION_LATITUDE_DEG: 53.128429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015200',
        LOCATION_NAME: 'Beeston Park Side',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5523636,
        LOCATION_LATITUDE_DEG: 53.7584804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015300',
        LOCATION_NAME: 'Beeston Regis',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2305759,
        LOCATION_LATITUDE_DEG: 52.9336605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015400',
        LOCATION_NAME: 'Beeston Saint Lawrence',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4470459,
        LOCATION_LATITUDE_DEG: 52.7446881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015500',
        LOCATION_NAME: 'Beeswing',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.72213,
        LOCATION_LATITUDE_DEG: 55.0094223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015700',
        LOCATION_NAME: 'Beetham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0282049,
        LOCATION_LATITUDE_DEG: 50.9032182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015600',
        LOCATION_NAME: 'Beetham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7715179,
        LOCATION_LATITUDE_DEG: 54.2095368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015800',
        LOCATION_NAME: 'Beetley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9223823,
        LOCATION_LATITUDE_DEG: 52.7166436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE015900',
        LOCATION_NAME: 'Begbroke',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3171959,
        LOCATION_LATITUDE_DEG: 51.8217886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016000',
        LOCATION_NAME: 'Begelly',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7252977,
        LOCATION_LATITUDE_DEG: 51.7329165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016100',
        LOCATION_NAME: 'Beggearnhuish',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3627291,
        LOCATION_LATITUDE_DEG: 51.145853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016200',
        LOCATION_NAME: 'Beguildy',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1835726,
        LOCATION_LATITUDE_DEG: 52.4090684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016300',
        LOCATION_NAME: 'Begwary',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3468562,
        LOCATION_LATITUDE_DEG: 52.2063159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016650',
        LOCATION_NAME: 'Beighton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3391301,
        LOCATION_LATITUDE_DEG: 53.3424375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016600',
        LOCATION_NAME: 'Beighton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5252464,
        LOCATION_LATITUDE_DEG: 52.6196293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016700',
        LOCATION_NAME: 'Beith',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6312205,
        LOCATION_LATITUDE_DEG: 55.7507052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016900',
        LOCATION_NAME: 'Bekesbourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1466168,
        LOCATION_LATITUDE_DEG: 51.2553049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017100',
        LOCATION_NAME: 'Belan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1745735,
        LOCATION_LATITUDE_DEG: 52.6311927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017200',
        LOCATION_NAME: 'Belaugh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.389464,
        LOCATION_LATITUDE_DEG: 52.7149395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017300',
        LOCATION_NAME: 'Belbroughton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1185547,
        LOCATION_LATITUDE_DEG: 52.3908548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017400',
        LOCATION_NAME: 'Belby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8206994,
        LOCATION_LATITUDE_DEG: 53.7515644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017500',
        LOCATION_NAME: 'Belchalwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2967311,
        LOCATION_LATITUDE_DEG: 50.8848131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017600',
        LOCATION_NAME: 'Belchamp Otten',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6332557,
        LOCATION_LATITUDE_DEG: 52.0445865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046000',
        LOCATION_NAME: 'Belchamp St Paul',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017700',
        LOCATION_NAME: 'Belchamp St. Paul',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6134507,
        LOCATION_LATITUDE_DEG: 52.0498844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017800',
        LOCATION_NAME: 'Belchamp Walter',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6521723,
        LOCATION_LATITUDE_DEG: 52.0329825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017900',
        LOCATION_NAME: 'Belchford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0582118,
        LOCATION_LATITUDE_DEG: 53.259809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018200',
        LOCATION_NAME: 'Belcoo',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.8757986,
        LOCATION_LATITUDE_DEG: 54.2983943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018600',
        LOCATION_NAME: 'Beley Bridge',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7376879,
        LOCATION_LATITUDE_DEG: 56.2807405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018700',
        LOCATION_NAME: 'Belfast BT 1',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9338812,
        LOCATION_LATITUDE_DEG: 54.6002586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018800',
        LOCATION_NAME: 'Belfast BT 2',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9438333,
        LOCATION_LATITUDE_DEG: 54.5977575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018900',
        LOCATION_NAME: 'Belfast BT 3',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9234836,
        LOCATION_LATITUDE_DEG: 54.6145564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019000',
        LOCATION_NAME: 'Belfast BT 4',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8969906,
        LOCATION_LATITUDE_DEG: 54.6002302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019100',
        LOCATION_NAME: 'Belfast BT 5',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8841075,
        LOCATION_LATITUDE_DEG: 54.5874588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019200',
        LOCATION_NAME: 'Belfast BT 6',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9083509,
        LOCATION_LATITUDE_DEG: 54.5794365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019300',
        LOCATION_NAME: 'Belfast BT 7',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9325767,
        LOCATION_LATITUDE_DEG: 54.5894713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019400',
        LOCATION_NAME: 'Belfast BT 8',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9032187,
        LOCATION_LATITUDE_DEG: 54.5476531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019500',
        LOCATION_NAME: 'Belfast BT 9',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9322576,
        LOCATION_LATITUDE_DEG: 54.5840758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019600',
        LOCATION_NAME: 'Belfast BT10',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.968316,
        LOCATION_LATITUDE_DEG: 54.5787235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019700',
        LOCATION_NAME: 'Belfast BT11',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9746509,
        LOCATION_LATITUDE_DEG: 54.5777867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019800',
        LOCATION_NAME: 'Belfast BT12',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9593425,
        LOCATION_LATITUDE_DEG: 54.596342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE019900',
        LOCATION_NAME: 'Belfast BT13',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9647704,
        LOCATION_LATITUDE_DEG: 54.6135962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020000',
        LOCATION_NAME: 'Belfast BT14',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9985328,
        LOCATION_LATITUDE_DEG: 54.6352956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020100',
        LOCATION_NAME: 'Belfast BT15',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9195546,
        LOCATION_LATITUDE_DEG: 54.6471547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048500',
        LOCATION_NAME: 'Belfast BT16',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7945989,
        LOCATION_LATITUDE_DEG: 54.5995211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990346',
        LOCATION_NAME: 'Belfast BT18',
        COUNTY_NAME: 'County Down',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020200',
        LOCATION_NAME: 'Belford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.827399,
        LOCATION_LATITUDE_DEG: 55.5985631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990546',
        LOCATION_NAME: 'Belgrave',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990465',
        LOCATION_NAME: 'Belgrave',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020400',
        LOCATION_NAME: 'Belgrave',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9302435,
        LOCATION_LATITUDE_DEG: 53.1428395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020500',
        LOCATION_NAME: 'Belhaven',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5342103,
        LOCATION_LATITUDE_DEG: 56.0013063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020600',
        LOCATION_NAME: 'Belhelvie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0871801,
        LOCATION_LATITUDE_DEG: 57.2495285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020700',
        LOCATION_NAME: 'Belhus',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2631214,
        LOCATION_LATITUDE_DEG: 51.5105348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020800',
        LOCATION_NAME: 'Bell Busk',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1487147,
        LOCATION_LATITUDE_DEG: 54.0053129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020900',
        LOCATION_NAME: 'Bell Common',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0865022,
        LOCATION_LATITUDE_DEG: 51.6914544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021000',
        LOCATION_NAME: 'Bell Lake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3241347,
        LOCATION_LATITUDE_DEG: 50.233786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021300',
        LOCATION_NAME: 'Belladrum',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4653399,
        LOCATION_LATITUDE_DEG: 57.4334767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021400',
        LOCATION_NAME: 'Bellaghy',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5156479,
        LOCATION_LATITUDE_DEG: 54.7999298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021700',
        LOCATION_NAME: 'Bellamour',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9204395,
        LOCATION_LATITUDE_DEG: 52.7792922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022200',
        LOCATION_NAME: 'Bellanaleck',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6323686,
        LOCATION_LATITUDE_DEG: 54.283191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022500',
        LOCATION_NAME: 'Bellanoch',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5440408,
        LOCATION_LATITUDE_DEG: 56.0745517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022700',
        LOCATION_NAME: 'Bellasize',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7539752,
        LOCATION_LATITUDE_DEG: 53.7387621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023100',
        LOCATION_NAME: 'Belle Isle',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5290852,
        LOCATION_LATITUDE_DEG: 53.7605756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023300',
        LOCATION_NAME: 'Belle Vue',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.941738,
        LOCATION_LATITUDE_DEG: 52.9589275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023200',
        LOCATION_NAME: 'Belle Vue',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9872594,
        LOCATION_LATITUDE_DEG: 54.8951104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048100',
        LOCATION_NAME: 'Belle Vue',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1904378,
        LOCATION_LATITUDE_DEG: 53.4663382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023400',
        LOCATION_NAME: 'Belleau',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1029822,
        LOCATION_LATITUDE_DEG: 53.2854151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023500',
        LOCATION_NAME: 'Belleek',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -8.0949325,
        LOCATION_LATITUDE_DEG: 54.480315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023600',
        LOCATION_NAME: 'Belleeks',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4822637,
        LOCATION_LATITUDE_DEG: 54.1665695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023700',
        LOCATION_NAME: 'Bellerby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8235372,
        LOCATION_LATITUDE_DEG: 54.3309367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023800',
        LOCATION_NAME: 'Bellever',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8997187,
        LOCATION_LATITUDE_DEG: 50.5799029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048900',
        LOCATION_NAME: 'Bellevue',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1884385,
        LOCATION_LATITUDE_DEG: 55.9650594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024100',
        LOCATION_NAME: 'Bellfield',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8736146,
        LOCATION_LATITUDE_DEG: 55.5920899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024300',
        LOCATION_NAME: 'Bellingdon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6384362,
        LOCATION_LATITUDE_DEG: 51.7402694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024400',
        LOCATION_NAME: 'Bellingham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2521508,
        LOCATION_LATITUDE_DEG: 55.1448216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047800',
        LOCATION_NAME: 'Bellingham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0128724,
        LOCATION_LATITUDE_DEG: 51.4269392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024600',
        LOCATION_NAME: 'Bellochantuy',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.704565,
        LOCATION_LATITUDE_DEG: 55.5284023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024700',
        LOCATION_NAME: 'Bells Mill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1722699,
        LOCATION_LATITUDE_DEG: 52.4701621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024800',
        LOCATION_NAME: 'Bells Yew Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.298679,
        LOCATION_LATITUDE_DEG: 51.101696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024900',
        LOCATION_NAME: 'Bellsbank',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3965481,
        LOCATION_LATITUDE_DEG: 55.3118615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025000',
        LOCATION_NAME: 'Bellshill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0242754,
        LOCATION_LATITUDE_DEG: 55.8187056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025100',
        LOCATION_NAME: 'Bellshill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8037649,
        LOCATION_LATITUDE_DEG: 55.5702564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025200',
        LOCATION_NAME: 'Bellsmyre',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.547186,
        LOCATION_LATITUDE_DEG: 55.956227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025300',
        LOCATION_NAME: 'Bellsquarry',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5264912,
        LOCATION_LATITUDE_DEG: 55.8691108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025400',
        LOCATION_NAME: 'Belmesthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.45799,
        LOCATION_LATITUDE_DEG: 52.6791579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047600',
        LOCATION_NAME: 'Belmont',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8778633,
        LOCATION_LATITUDE_DEG: 54.6028961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025800',
        LOCATION_NAME: 'Belmont',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4921737,
        LOCATION_LATITUDE_DEG: 53.6376789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025500',
        LOCATION_NAME: 'Belmont',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5184583,
        LOCATION_LATITUDE_DEG: 54.7874762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025700',
        LOCATION_NAME: 'Belmont',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3137448,
        LOCATION_LATITUDE_DEG: 51.6012513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025600',
        LOCATION_NAME: 'Belmont',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1986296,
        LOCATION_LATITUDE_DEG: 51.3443312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026000',
        LOCATION_NAME: 'Belowda',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8633738,
        LOCATION_LATITUDE_DEG: 50.4199999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026100',
        LOCATION_NAME: 'Belper',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4770755,
        LOCATION_LATITUDE_DEG: 53.0236064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026200',
        LOCATION_NAME: 'Belph',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.182522,
        LOCATION_LATITUDE_DEG: 53.2736288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026300',
        LOCATION_NAME: 'Belsay',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8399994,
        LOCATION_LATITUDE_DEG: 55.1021091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026400',
        LOCATION_NAME: 'Belsize',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5020343,
        LOCATION_LATITUDE_DEG: 51.6962713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026500',
        LOCATION_NAME: 'Belstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1100031,
        LOCATION_LATITUDE_DEG: 52.0284794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026600',
        LOCATION_NAME: 'Belston',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5591873,
        LOCATION_LATITUDE_DEG: 55.4522813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026700',
        LOCATION_NAME: 'Belstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9551087,
        LOCATION_LATITUDE_DEG: 50.7250173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026900',
        LOCATION_NAME: 'Beltany',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3635194,
        LOCATION_LATITUDE_DEG: 54.6835828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027000',
        LOCATION_NAME: 'Belthorn',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4298264,
        LOCATION_LATITUDE_DEG: 53.718283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027100',
        LOCATION_NAME: 'Beltinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1617698,
        LOCATION_LATITUDE_DEG: 51.3717155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027200',
        LOCATION_NAME: 'Beltoft',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7776303,
        LOCATION_LATITUDE_DEG: 53.5509471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027300',
        LOCATION_NAME: 'Belton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3379729,
        LOCATION_LATITUDE_DEG: 52.7817786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027400',
        LOCATION_NAME: 'Belton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8145223,
        LOCATION_LATITUDE_DEG: 53.5564517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027550',
        LOCATION_NAME: 'Belton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6149178,
        LOCATION_LATITUDE_DEG: 52.9492045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027500',
        LOCATION_NAME: 'Belton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6603473,
        LOCATION_LATITUDE_DEG: 52.5666175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990114',
        LOCATION_NAME: 'Belton In Rutland',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7953143,
        LOCATION_LATITUDE_DEG: 52.6062811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027600',
        LOCATION_NAME: 'Belton in Rutland',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7937295,
        LOCATION_LATITUDE_DEG: 52.6037564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027900',
        LOCATION_NAME: 'Beltrim',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2454825,
        LOCATION_LATITUDE_DEG: 54.7040823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028100',
        LOCATION_NAME: 'Belvedere',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1531244,
        LOCATION_LATITUDE_DEG: 51.4905352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028400',
        LOCATION_NAME: 'Belvoir',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7804941,
        LOCATION_LATITUDE_DEG: 52.8972894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028500',
        LOCATION_NAME: 'Bembridge',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0835209,
        LOCATION_LATITUDE_DEG: 50.6876765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028600',
        LOCATION_NAME: 'Bemersyde',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6401947,
        LOCATION_LATITUDE_DEG: 55.5948748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028700',
        LOCATION_NAME: 'Bempton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1787558,
        LOCATION_LATITUDE_DEG: 54.1312929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028800',
        LOCATION_NAME: 'Ben Rhydding',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7970625,
        LOCATION_LATITUDE_DEG: 53.9251975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028900',
        LOCATION_NAME: 'Benacre',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6925696,
        LOCATION_LATITUDE_DEG: 52.3996066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029000',
        LOCATION_NAME: 'Benbecula',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.348964,
        LOCATION_LATITUDE_DEG: 57.4334989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029100',
        LOCATION_NAME: 'Benbecula Airport',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3488423,
        LOCATION_LATITUDE_DEG: 57.4858043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029200',
        LOCATION_NAME: 'Benburb',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7322811,
        LOCATION_LATITUDE_DEG: 54.4165971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047200',
        LOCATION_NAME: 'Benchill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2685024,
        LOCATION_LATITUDE_DEG: 53.3870618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029300',
        LOCATION_NAME: 'Bend Hagg House',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.73186,
        LOCATION_LATITUDE_DEG: 54.4137467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE902510',
        LOCATION_NAME: 'Benderloch',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4042504,
        LOCATION_LATITUDE_DEG: 56.491646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029400',
        LOCATION_NAME: 'Bendish',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3087838,
        LOCATION_LATITUDE_DEG: 51.8795778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029500',
        LOCATION_NAME: 'Bendooragh',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6519566,
        LOCATION_LATITUDE_DEG: 55.1250565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029600',
        LOCATION_NAME: 'Benenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5829732,
        LOCATION_LATITUDE_DEG: 51.0661911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048300',
        LOCATION_NAME: 'Benfield Heights',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048400',
        LOCATION_NAME: 'Benfield Heights',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029700',
        LOCATION_NAME: 'Benfleet',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.561441,
        LOCATION_LATITUDE_DEG: 51.5532367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029800',
        LOCATION_NAME: 'Benhall Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4834095,
        LOCATION_LATITUDE_DEG: 52.1972854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE029900',
        LOCATION_NAME: 'Benham Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2891304,
        LOCATION_LATITUDE_DEG: 51.4030488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030000',
        LOCATION_NAME: 'Benham Valence',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3697329,
        LOCATION_LATITUDE_DEG: 51.407152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030100',
        LOCATION_NAME: 'Benholm',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.321807,
        LOCATION_LATITUDE_DEG: 56.8150879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030200',
        LOCATION_NAME: 'Beningbrough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1925553,
        LOCATION_LATITUDE_DEG: 54.012599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030400',
        LOCATION_NAME: 'Benington',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1124496,
        LOCATION_LATITUDE_DEG: 51.8957825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030300',
        LOCATION_NAME: 'Benington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.082321,
        LOCATION_LATITUDE_DEG: 52.998584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030500',
        LOCATION_NAME: 'Benllech',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2243723,
        LOCATION_LATITUDE_DEG: 53.3221639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030600',
        LOCATION_NAME: 'Benmore',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.985582,
        LOCATION_LATITUDE_DEG: 56.0267437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030900',
        LOCATION_NAME: 'Benningholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.286101,
        LOCATION_LATITUDE_DEG: 53.8346721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031000',
        LOCATION_NAME: 'Benniworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1884144,
        LOCATION_LATITUDE_DEG: 53.3207144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031100',
        LOCATION_NAME: 'Benover',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4412657,
        LOCATION_LATITUDE_DEG: 51.2075062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046900',
        LOCATION_NAME: 'Bensham',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6149847,
        LOCATION_LATITUDE_DEG: 54.954952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031200',
        LOCATION_NAME: 'Benson',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.108638,
        LOCATION_LATITUDE_DEG: 51.6205633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031300',
        LOCATION_NAME: 'Bentangaval',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.507111,
        LOCATION_LATITUDE_DEG: 56.9544534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031400',
        LOCATION_NAME: 'Benthal',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8959875,
        LOCATION_LATITUDE_DEG: 52.7198957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031500',
        LOCATION_NAME: 'Benthall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4900345,
        LOCATION_LATITUDE_DEG: 52.6161766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031600',
        LOCATION_NAME: 'Bentham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5086928,
        LOCATION_LATITUDE_DEG: 54.1178293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031700',
        LOCATION_NAME: 'Bentham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1254784,
        LOCATION_LATITUDE_DEG: 51.8504998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031800',
        LOCATION_NAME: 'Bentlawnt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9862448,
        LOCATION_LATITUDE_DEG: 52.6052803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032000',
        LOCATION_NAME: 'Bentley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0226168,
        LOCATION_LATITUDE_DEG: 52.5905751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE031900',
        LOCATION_NAME: 'Bentley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5815902,
        LOCATION_LATITUDE_DEG: 52.5591611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032100',
        LOCATION_NAME: 'Bentley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1459097,
        LOCATION_LATITUDE_DEG: 53.5441566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032200',
        LOCATION_NAME: 'Bentley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8734767,
        LOCATION_LATITUDE_DEG: 51.1916249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032300',
        LOCATION_NAME: 'Bentley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0709277,
        LOCATION_LATITUDE_DEG: 51.9904767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032400',
        LOCATION_NAME: 'Bentley Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7598307,
        LOCATION_LATITUDE_DEG: 52.38595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032500',
        LOCATION_NAME: 'Benton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5661667,
        LOCATION_LATITUDE_DEG: 55.0128997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047500',
        LOCATION_NAME: 'Benton Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5852554,
        LOCATION_LATITUDE_DEG: 55.0090298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032600',
        LOCATION_NAME: 'Bentpath',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0815168,
        LOCATION_LATITUDE_DEG: 55.2002402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032700',
        LOCATION_NAME: 'Bents',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6433276,
        LOCATION_LATITUDE_DEG: 55.8406082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046800',
        LOCATION_NAME: 'Bents Green',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5254244,
        LOCATION_LATITUDE_DEG: 53.353572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032800',
        LOCATION_NAME: 'Bentworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0496731,
        LOCATION_LATITUDE_DEG: 51.1561185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE032900',
        LOCATION_NAME: 'Benvie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0905655,
        LOCATION_LATITUDE_DEG: 56.4707646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033000',
        LOCATION_NAME: 'Benwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6684239,
        LOCATION_LATITUDE_DEG: 54.9740996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033100',
        LOCATION_NAME: 'Benwick',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0239908,
        LOCATION_LATITUDE_DEG: 52.4953347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033200',
        LOCATION_NAME: 'Beoley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9013612,
        LOCATION_LATITUDE_DEG: 52.3237449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033300',
        LOCATION_NAME: 'Bepton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7809338,
        LOCATION_LATITUDE_DEG: 50.9563963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033400',
        LOCATION_NAME: 'Beragh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.156216,
        LOCATION_LATITUDE_DEG: 54.5517124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033500',
        LOCATION_NAME: 'Berden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.137002,
        LOCATION_LATITUDE_DEG: 51.9470855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033600',
        LOCATION_NAME: 'Bere Aller',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8522762,
        LOCATION_LATITUDE_DEG: 51.0697378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033700',
        LOCATION_NAME: 'Bere Alston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1888345,
        LOCATION_LATITUDE_DEG: 50.4799987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033800',
        LOCATION_NAME: 'Bere Ferrers',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1725534,
        LOCATION_LATITUDE_DEG: 50.4495939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE033900',
        LOCATION_NAME: 'Bere Heath',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2027369,
        LOCATION_LATITUDE_DEG: 50.7300008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034000',
        LOCATION_NAME: 'Bere Regis',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2157066,
        LOCATION_LATITUDE_DEG: 50.7523988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034100',
        LOCATION_NAME: 'Berea',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2089885,
        LOCATION_LATITUDE_DEG: 51.9219462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034200',
        LOCATION_NAME: 'Berepper',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.26971,
        LOCATION_LATITUDE_DEG: 50.0614697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034300',
        LOCATION_NAME: 'Bergh Apton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4037262,
        LOCATION_LATITUDE_DEG: 52.5602222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034400',
        LOCATION_NAME: 'Berinsfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1733843,
        LOCATION_LATITUDE_DEG: 51.6588685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034500',
        LOCATION_NAME: 'Berkeley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4569003,
        LOCATION_LATITUDE_DEG: 51.690788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034600',
        LOCATION_NAME: 'Berkeley Alford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1792823,
        LOCATION_LATITUDE_DEG: 52.2026354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034700',
        LOCATION_NAME: 'Berkeley Beverborne',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1741823,
        LOCATION_LATITUDE_DEG: 52.2082357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034800',
        LOCATION_NAME: 'Berkeley Heath',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4302213,
        LOCATION_LATITUDE_DEG: 51.6908888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE034900',
        LOCATION_NAME: 'Berkhamsted',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5638256,
        LOCATION_LATITUDE_DEG: 51.7602715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035000',
        LOCATION_NAME: 'Berkley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2674804,
        LOCATION_LATITUDE_DEG: 51.242948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035100',
        LOCATION_NAME: 'Berkswell',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6380415,
        LOCATION_LATITUDE_DEG: 52.4092506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047700',
        LOCATION_NAME: 'Bermondsey',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0794741,
        LOCATION_LATITUDE_DEG: 51.500197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035200',
        LOCATION_NAME: 'Bernera',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8344743,
        LOCATION_LATITUDE_DEG: 58.2246739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035300',
        LOCATION_NAME: 'Berneray',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2134329,
        LOCATION_LATITUDE_DEG: 57.6739233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035400',
        LOCATION_NAME: 'Berners Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3214753,
        LOCATION_LATITUDE_DEG: 51.7644634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035500',
        LOCATION_NAME: 'Berney Arms',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6340047,
        LOCATION_LATITUDE_DEG: 52.5890194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035600',
        LOCATION_NAME: 'Bernisdale',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3329404,
        LOCATION_LATITUDE_DEG: 57.4685967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035700',
        LOCATION_NAME: 'Berrick Salome',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1022642,
        LOCATION_LATITUDE_DEG: 51.6404692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035800',
        LOCATION_NAME: 'Berriedale',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.494143,
        LOCATION_LATITUDE_DEG: 58.1897353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE035900',
        LOCATION_NAME: 'Berrier',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9292949,
        LOCATION_LATITUDE_DEG: 54.6576836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036000',
        LOCATION_NAME: 'Berriew',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2006545,
        LOCATION_LATITUDE_DEG: 52.5992908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036100',
        LOCATION_NAME: 'Berrington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6969939,
        LOCATION_LATITUDE_DEG: 52.6574871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036200',
        LOCATION_NAME: 'Berrington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6232986,
        LOCATION_LATITUDE_DEG: 52.3019471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036300',
        LOCATION_NAME: 'Berrington Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6168121,
        LOCATION_LATITUDE_DEG: 52.2953545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036400',
        LOCATION_NAME: 'Berrow',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0068053,
        LOCATION_LATITUDE_DEG: 51.2639607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036500',
        LOCATION_NAME: 'Berrow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3011671,
        LOCATION_LATITUDE_DEG: 52.0071165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036600',
        LOCATION_NAME: 'Berrow Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3687916,
        LOCATION_LATITUDE_DEG: 52.2217428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036700',
        LOCATION_NAME: 'Berry Brow',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7929931,
        LOCATION_LATITUDE_DEG: 53.6204701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036800',
        LOCATION_NAME: 'Berry Head',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5000456,
        LOCATION_LATITUDE_DEG: 50.3972452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE036900',
        LOCATION_NAME: 'Berry Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6217449,
        LOCATION_LATITUDE_DEG: 51.8124068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037000',
        LOCATION_NAME: 'Berry Pomeroy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6461718,
        LOCATION_LATITUDE_DEG: 50.4350802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037100',
        LOCATION_NAME: 'Berrycroft',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.457328,
        LOCATION_LATITUDE_DEG: 51.6915867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990321',
        LOCATION_NAME: 'Berrylands',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2885613,
        LOCATION_LATITUDE_DEG: 51.3946499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037200',
        LOCATION_NAME: 'Berrynarbor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0654977,
        LOCATION_LATITUDE_DEG: 51.1995631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037300',
        LOCATION_NAME: 'Berrys Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0639904,
        LOCATION_LATITUDE_DEG: 51.3140222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037400',
        LOCATION_NAME: 'Bersham',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0338247,
        LOCATION_LATITUDE_DEG: 53.0353312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037500',
        LOCATION_NAME: 'Bersted',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.68448,
        LOCATION_LATITUDE_DEG: 50.7859844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037600',
        LOCATION_NAME: 'Berthengam',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3231857,
        LOCATION_LATITUDE_DEG: 53.3082608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037700',
        LOCATION_NAME: 'Berwick',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1561136,
        LOCATION_LATITUDE_DEG: 50.8247786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037800',
        LOCATION_NAME: 'Berwick Bassett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8583258,
        LOCATION_LATITUDE_DEG: 51.4583642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE037900',
        LOCATION_NAME: 'Berwick Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7301124,
        LOCATION_LATITUDE_DEG: 55.0736058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046100',
        LOCATION_NAME: 'Berwick St James',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046200',
        LOCATION_NAME: 'Berwick St John',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046300',
        LOCATION_NAME: 'Berwick St Leonard',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038000',
        LOCATION_NAME: 'Berwick St. James',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8973113,
        LOCATION_LATITUDE_DEG: 51.154331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038100',
        LOCATION_NAME: 'Berwick St. John',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0766802,
        LOCATION_LATITUDE_DEG: 51.0009187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038200',
        LOCATION_NAME: 'Berwick St. Leonard',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1086293,
        LOCATION_LATITUDE_DEG: 51.0960325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046400',
        LOCATION_NAME: 'Berwick upon Tweed',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038300',
        LOCATION_NAME: 'Berwick-upon-Tweed',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0037142,
        LOCATION_LATITUDE_DEG: 55.770384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038400',
        LOCATION_NAME: 'Berwyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1950195,
        LOCATION_LATITUDE_DEG: 52.9794269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038500',
        LOCATION_NAME: 'Bescar',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.919688,
        LOCATION_LATITUDE_DEG: 53.6124771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038600',
        LOCATION_NAME: 'Bescot',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9959124,
        LOCATION_LATITUDE_DEG: 52.5715705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038900',
        LOCATION_NAME: 'Besford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.66656,
        LOCATION_LATITUDE_DEG: 52.8203053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE038700',
        LOCATION_NAME: 'Besford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.124343,
        LOCATION_LATITUDE_DEG: 52.1019292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039000',
        LOCATION_NAME: 'Besford Bridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1068643,
        LOCATION_LATITUDE_DEG: 52.1136264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039100',
        LOCATION_NAME: 'Besford Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.679205,
        LOCATION_LATITUDE_DEG: 52.8289006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039200',
        LOCATION_NAME: 'Beslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6211854,
        LOCATION_LATITUDE_DEG: 52.6750902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039300',
        LOCATION_NAME: 'Bessacarr',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0658762,
        LOCATION_LATITUDE_DEG: 53.5075452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039400',
        LOCATION_NAME: 'Bessbrook',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4156547,
        LOCATION_LATITUDE_DEG: 54.1998762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039500',
        LOCATION_NAME: 'Besselsleigh',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3341613,
        LOCATION_LATITUDE_DEG: 51.7122795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039600',
        LOCATION_NAME: 'Bessemer Park',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.594133,
        LOCATION_LATITUDE_DEG: 54.6991703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039700',
        LOCATION_NAME: 'Bessingby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.228516,
        LOCATION_LATITUDE_DEG: 54.0757949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039800',
        LOCATION_NAME: 'Bessingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2215383,
        LOCATION_LATITUDE_DEG: 52.8865605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040000',
        LOCATION_NAME: 'Besthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7644686,
        LOCATION_LATITUDE_DEG: 53.1732115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE039900',
        LOCATION_NAME: 'Besthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0352435,
        LOCATION_LATITUDE_DEG: 52.5254243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040100',
        LOCATION_NAME: 'Bestwood',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1525669,
        LOCATION_LATITUDE_DEG: 53.0019041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040200',
        LOCATION_NAME: 'Bestwood Village',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1767839,
        LOCATION_LATITUDE_DEG: 53.0231029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048000',
        LOCATION_NAME: 'Beswick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1967524,
        LOCATION_LATITUDE_DEG: 53.4798752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE047900',
        LOCATION_NAME: 'Beswick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1967435,
        LOCATION_LATITUDE_DEG: 53.4779335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040300',
        LOCATION_NAME: 'Beswick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4585702,
        LOCATION_LATITUDE_DEG: 53.9175796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990807',
        LOCATION_NAME: 'Betchcott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040500',
        LOCATION_NAME: 'Betchton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3101499,
        LOCATION_LATITUDE_DEG: 53.1293294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040600',
        LOCATION_NAME: 'Betchworth',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2647542,
        LOCATION_LATITUDE_DEG: 51.2330159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040700',
        LOCATION_NAME: 'Bethania',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0936567,
        LOCATION_LATITUDE_DEG: 52.2521627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040800',
        LOCATION_NAME: 'Bethania',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0474717,
        LOCATION_LATITUDE_DEG: 53.0347339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040900',
        LOCATION_NAME: 'Bethel',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2085391,
        LOCATION_LATITUDE_DEG: 53.1640507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990150',
        LOCATION_NAME: 'Bethel',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4998283,
        LOCATION_LATITUDE_DEG: 52.9501853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041100',
        LOCATION_NAME: 'Bethersden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.754416,
        LOCATION_LATITUDE_DEG: 51.128192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE902635',
        LOCATION_NAME: 'Bethesda',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7673821,
        LOCATION_LATITUDE_DEG: 51.8267617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041200',
        LOCATION_NAME: 'Bethesda',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0586732,
        LOCATION_LATITUDE_DEG: 53.1801516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041300',
        LOCATION_NAME: 'Bethesda Bach',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2889562,
        LOCATION_LATITUDE_DEG: 53.087745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990563',
        LOCATION_NAME: 'Bethlehem',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041400',
        LOCATION_NAME: 'Bethlehem',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9120851,
        LOCATION_LATITUDE_DEG: 51.9094245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048200',
        LOCATION_NAME: 'Bethnel Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'E2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0562987,
        LOCATION_LATITUDE_DEG: 51.5304295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041500',
        LOCATION_NAME: 'Betley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3669742,
        LOCATION_LATITUDE_DEG: 53.0340161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041600',
        LOCATION_NAME: 'Betteshanger',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3135183,
        LOCATION_LATITUDE_DEG: 51.2245971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041700',
        LOCATION_NAME: 'Bettiscombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.853512,
        LOCATION_LATITUDE_DEG: 50.7957123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041800',
        LOCATION_NAME: 'Bettisfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8040083,
        LOCATION_LATITUDE_DEG: 52.9138108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE041900',
        LOCATION_NAME: 'Betton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4572301,
        LOCATION_LATITUDE_DEG: 52.9292089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042000',
        LOCATION_NAME: 'Betton Moss',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4790964,
        LOCATION_LATITUDE_DEG: 52.9234139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042100',
        LOCATION_NAME: 'Betton Strange',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7259179,
        LOCATION_LATITUDE_DEG: 52.6781903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042200',
        LOCATION_NAME: 'Betton Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4851872,
        LOCATION_LATITUDE_DEG: 52.9333146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042600',
        LOCATION_NAME: 'Bettws',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0503607,
        LOCATION_LATITUDE_DEG: 52.1463664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042400',
        LOCATION_NAME: 'Bettws',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9813715,
        LOCATION_LATITUDE_DEG: 51.7871212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042500',
        LOCATION_NAME: 'Bettws',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5880915,
        LOCATION_LATITUDE_DEG: 51.5687884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042800',
        LOCATION_NAME: 'Bettws',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.305189,
        LOCATION_LATITUDE_DEG: 52.5525802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042300',
        LOCATION_NAME: 'Bettws',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0285997,
        LOCATION_LATITUDE_DEG: 51.6126877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042700',
        LOCATION_NAME: 'Bettws',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0253635,
        LOCATION_LATITUDE_DEG: 51.8730749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE042900',
        LOCATION_NAME: 'Bettws Cedewain',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2947416,
        LOCATION_LATITUDE_DEG: 52.5614796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043000',
        LOCATION_NAME: 'Bettws Newydd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9264369,
        LOCATION_LATITUDE_DEG: 51.7502063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043100',
        LOCATION_NAME: 'Bettyhill',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2217631,
        LOCATION_LATITUDE_DEG: 58.5251787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043200',
        LOCATION_NAME: 'Betws Garmon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1912805,
        LOCATION_LATITUDE_DEG: 53.0963461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043300',
        LOCATION_NAME: 'Betws Gwerfil Goch',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4431932,
        LOCATION_LATITUDE_DEG: 53.0062984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046500',
        LOCATION_NAME: 'Betws y Coed',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043400',
        LOCATION_NAME: 'Betws yn Rhos',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6376212,
        LOCATION_LATITUDE_DEG: 53.2471582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043500',
        LOCATION_NAME: 'Betws-y-Coed',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8049948,
        LOCATION_LATITUDE_DEG: 53.0934368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043600',
        LOCATION_NAME: 'Beulah',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4967985,
        LOCATION_LATITUDE_DEG: 52.0868522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043700',
        LOCATION_NAME: 'Beulah',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5758004,
        LOCATION_LATITUDE_DEG: 52.1495447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043800',
        LOCATION_NAME: 'Beveley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4691982,
        LOCATION_LATITUDE_DEG: 52.6968906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE043900',
        LOCATION_NAME: 'Bevendean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1130474,
        LOCATION_LATITUDE_DEG: 50.8364771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044000',
        LOCATION_NAME: 'Bevercotes',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9511709,
        LOCATION_LATITUDE_DEG: 53.2452251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044100',
        LOCATION_NAME: 'Bevere',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2256115,
        LOCATION_LATITUDE_DEG: 52.2310408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044200',
        LOCATION_NAME: 'Beverley',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4313459,
        LOCATION_LATITUDE_DEG: 53.8422691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044300',
        LOCATION_NAME: 'Beverstone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2075701,
        LOCATION_LATITUDE_DEG: 51.6413792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044400',
        LOCATION_NAME: 'Bevington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4996161,
        LOCATION_LATITUDE_DEG: 51.6714875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044500',
        LOCATION_NAME: 'Bewaldeth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2278439,
        LOCATION_LATITUDE_DEG: 54.7023942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044600',
        LOCATION_NAME: 'Bewbush',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2240268,
        LOCATION_LATITUDE_DEG: 51.1034048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044700',
        LOCATION_NAME: 'Bewcastle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.682295,
        LOCATION_LATITUDE_DEG: 55.0643185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044800',
        LOCATION_NAME: 'Bewdley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3148568,
        LOCATION_LATITUDE_DEG: 52.3748503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE044900',
        LOCATION_NAME: 'Bewdley Bank',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7417715,
        LOCATION_LATITUDE_DEG: 52.0949317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045000',
        LOCATION_NAME: 'Bewerley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7604748,
        LOCATION_LATITUDE_DEG: 54.0803115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045100',
        LOCATION_NAME: 'Bewholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2247193,
        LOCATION_LATITUDE_DEG: 53.9328782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045200',
        LOCATION_NAME: 'Bewley Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0079974,
        LOCATION_LATITUDE_DEG: 50.8454207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045300',
        LOCATION_NAME: 'Bewsey',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6209826,
        LOCATION_LATITUDE_DEG: 53.4020563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE046600',
        LOCATION_NAME: 'Bexhill on Sea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045400',
        LOCATION_NAME: 'Bexhill-on-Sea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4675168,
        LOCATION_LATITUDE_DEG: 50.8445748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045500',
        LOCATION_NAME: 'Bexley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1502242,
        LOCATION_LATITUDE_DEG: 51.4408337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045600',
        LOCATION_NAME: 'Bexley Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6973827,
        LOCATION_LATITUDE_DEG: 51.0197098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045700',
        LOCATION_NAME: 'Bexleyheath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1412874,
        LOCATION_LATITUDE_DEG: 51.4568358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045800',
        LOCATION_NAME: 'Bexwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4088797,
        LOCATION_LATITUDE_DEG: 52.6047406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE045900',
        LOCATION_NAME: 'Beyton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8316671,
        LOCATION_LATITUDE_DEG: 52.2301026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000100',
        LOCATION_NAME: 'Bibstone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4334282,
        LOCATION_LATITUDE_DEG: 51.6160878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000200',
        LOCATION_NAME: 'Bibury',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8284072,
        LOCATION_LATITUDE_DEG: 51.7587856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000300',
        LOCATION_NAME: 'Bicester',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1527139,
        LOCATION_LATITUDE_DEG: 51.9015944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000400',
        LOCATION_NAME: 'Bickenhall',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0249741,
        LOCATION_LATITUDE_DEG: 50.9549243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000500',
        LOCATION_NAME: 'Bickenhill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7244857,
        LOCATION_LATITUDE_DEG: 52.4385519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000600',
        LOCATION_NAME: 'Bicker',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1795523,
        LOCATION_LATITUDE_DEG: 52.9239822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000700',
        LOCATION_NAME: 'Bickershaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5699284,
        LOCATION_LATITUDE_DEG: 53.5145647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000800',
        LOCATION_NAME: 'Bickerstaffe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8365715,
        LOCATION_LATITUDE_DEG: 53.5313712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001100',
        LOCATION_NAME: 'Bickerton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6634853,
        LOCATION_LATITUDE_DEG: 50.2360623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI000900',
        LOCATION_NAME: 'Bickerton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.73542,
        LOCATION_LATITUDE_DEG: 53.0615275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001000',
        LOCATION_NAME: 'Bickerton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3105119,
        LOCATION_LATITUDE_DEG: 53.9472916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001300',
        LOCATION_NAME: 'Bickington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0966555,
        LOCATION_LATITUDE_DEG: 51.0728541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001200',
        LOCATION_NAME: 'Bickington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6820715,
        LOCATION_LATITUDE_DEG: 50.5327899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001400',
        LOCATION_NAME: 'Bickleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0809113,
        LOCATION_LATITUDE_DEG: 50.4409877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001500',
        LOCATION_NAME: 'Bickleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4992512,
        LOCATION_LATITUDE_DEG: 50.8527256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001600',
        LOCATION_NAME: 'Bickleton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1396251,
        LOCATION_LATITUDE_DEG: 51.0569824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001700',
        LOCATION_NAME: 'Bickley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5345795,
        LOCATION_LATITUDE_DEG: 52.3349576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001800',
        LOCATION_NAME: 'Bickley Moss',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6806506,
        LOCATION_LATITUDE_DEG: 53.0360243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI001900',
        LOCATION_NAME: 'Bickley Town',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6975928,
        LOCATION_LATITUDE_DEG: 53.031323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002000',
        LOCATION_NAME: 'Bickleywood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.717303,
        LOCATION_LATITUDE_DEG: 53.0220177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002100',
        LOCATION_NAME: 'Bickmarsh',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.845961,
        LOCATION_LATITUDE_DEG: 52.1477241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002200',
        LOCATION_NAME: 'Bicknacre',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5870907,
        LOCATION_LATITUDE_DEG: 51.69385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002300',
        LOCATION_NAME: 'Bicknoller',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2694952,
        LOCATION_LATITUDE_DEG: 51.1465515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002400',
        LOCATION_NAME: 'Bicknor',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6703906,
        LOCATION_LATITUDE_DEG: 51.2945087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002500',
        LOCATION_NAME: 'Bickton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7822127,
        LOCATION_LATITUDE_DEG: 50.9134064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002700',
        LOCATION_NAME: 'Bicton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3780253,
        LOCATION_LATITUDE_DEG: 50.497398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002900',
        LOCATION_NAME: 'Bicton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3171374,
        LOCATION_LATITUDE_DEG: 50.664203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002800',
        LOCATION_NAME: 'Bicton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8176724,
        LOCATION_LATITUDE_DEG: 52.7261978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI002600',
        LOCATION_NAME: 'Bicton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.779029,
        LOCATION_LATITUDE_DEG: 52.2707482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003000',
        LOCATION_NAME: 'Bicton Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8054227,
        LOCATION_LATITUDE_DEG: 52.7115905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003100',
        LOCATION_NAME: 'Bidborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2382924,
        LOCATION_LATITUDE_DEG: 51.1691038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003200',
        LOCATION_NAME: 'Biddenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6401042,
        LOCATION_LATITUDE_DEG: 51.1142973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003300',
        LOCATION_NAME: 'Biddenham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5045643,
        LOCATION_LATITUDE_DEG: 52.137912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003400',
        LOCATION_NAME: 'Biddesden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5733551,
        LOCATION_LATITUDE_DEG: 51.2568379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003500',
        LOCATION_NAME: 'Biddestone',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1971888,
        LOCATION_LATITUDE_DEG: 51.4602624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003600',
        LOCATION_NAME: 'Biddisham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8876047,
        LOCATION_LATITUDE_DEG: 51.276859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003700',
        LOCATION_NAME: 'Biddlesden',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0755102,
        LOCATION_LATITUDE_DEG: 52.0551101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003800',
        LOCATION_NAME: 'Biddlestone',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0622484,
        LOCATION_LATITUDE_DEG: 55.3683445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI003900',
        LOCATION_NAME: 'Biddulph',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1741717,
        LOCATION_LATITUDE_DEG: 53.116921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004000',
        LOCATION_NAME: 'Biddulph Moor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1393666,
        LOCATION_LATITUDE_DEG: 53.120428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004100',
        LOCATION_NAME: 'Bideford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2144093,
        LOCATION_LATITUDE_DEG: 51.0198443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034300',
        LOCATION_NAME: 'Bidford on Avon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004200',
        LOCATION_NAME: 'Bidford-on-Avon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8509567,
        LOCATION_LATITUDE_DEG: 52.1661272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004400',
        LOCATION_NAME: 'Bidwell',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5254302,
        LOCATION_LATITUDE_DEG: 51.908886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004500',
        LOCATION_NAME: 'Biel',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5903276,
        LOCATION_LATITUDE_DEG: 55.9733108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004600',
        LOCATION_NAME: 'Bielby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8002134,
        LOCATION_LATITUDE_DEG: 53.8837775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004700',
        LOCATION_NAME: 'Bieldside',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1954159,
        LOCATION_LATITUDE_DEG: 57.1128132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004800',
        LOCATION_NAME: 'Bierley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7297825,
        LOCATION_LATITUDE_DEG: 53.7661849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI004900',
        LOCATION_NAME: 'Bierton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7801868,
        LOCATION_LATITUDE_DEG: 51.8332805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005000',
        LOCATION_NAME: 'Big Sand',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.773226,
        LOCATION_LATITUDE_DEG: 57.7474157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005100',
        LOCATION_NAME: 'Bigbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8715616,
        LOCATION_LATITUDE_DEG: 50.3002712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005200',
        LOCATION_NAME: 'Bigbury on Sea',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8915544,
        LOCATION_LATITUDE_DEG: 50.282074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005300',
        LOCATION_NAME: 'Bigby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4016641,
        LOCATION_LATITUDE_DEG: 53.5494438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005400',
        LOCATION_NAME: 'Biggar',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5225158,
        LOCATION_LATITUDE_DEG: 55.6241848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005700',
        LOCATION_NAME: 'Biggin',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7685674,
        LOCATION_LATITUDE_DEG: 53.1309198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005600',
        LOCATION_NAME: 'Biggin',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.612793,
        LOCATION_LATITUDE_DEG: 53.0317134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005500',
        LOCATION_NAME: 'Biggin',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1740819,
        LOCATION_LATITUDE_DEG: 53.8068831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005800',
        LOCATION_NAME: 'Biggin Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0367484,
        LOCATION_LATITUDE_DEG: 51.3107218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI005900',
        LOCATION_NAME: 'Biggin Hill Airport',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0251005,
        LOCATION_LATITUDE_DEG: 51.3170218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006000',
        LOCATION_NAME: 'Biggleswade',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2648881,
        LOCATION_LATITUDE_DEG: 52.0867972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006100',
        LOCATION_NAME: 'Bighton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1187428,
        LOCATION_LATITUDE_DEG: 51.106018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006200',
        LOCATION_NAME: 'Biglands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1573827,
        LOCATION_LATITUDE_DEG: 54.8702041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006300',
        LOCATION_NAME: 'Bignall End',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2908422,
        LOCATION_LATITUDE_DEG: 53.056819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006400',
        LOCATION_NAME: 'Bignor',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5992631,
        LOCATION_LATITUDE_DEG: 50.9202985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006500',
        LOCATION_NAME: 'Bigrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.541102,
        LOCATION_LATITUDE_DEG: 54.5018783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006600',
        LOCATION_NAME: 'Bigton',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3213122,
        LOCATION_LATITUDE_DEG: 59.9732893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006700',
        LOCATION_NAME: 'Bilberry',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7857388,
        LOCATION_LATITUDE_DEG: 50.405495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006900',
        LOCATION_NAME: 'Bilborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2271719,
        LOCATION_LATITUDE_DEG: 52.9644007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007000',
        LOCATION_NAME: 'Bilbrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3849124,
        LOCATION_LATITUDE_DEG: 51.1594516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007100',
        LOCATION_NAME: 'Bilbrook',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1826878,
        LOCATION_LATITUDE_DEG: 52.6286024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007200',
        LOCATION_NAME: 'Bilbrough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1873394,
        LOCATION_LATITUDE_DEG: 53.9120933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007300',
        LOCATION_NAME: 'Bilbster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2338533,
        LOCATION_LATITUDE_DEG: 58.4599596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007400',
        LOCATION_NAME: 'Bilby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0433565,
        LOCATION_LATITUDE_DEG: 53.3408285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007500',
        LOCATION_NAME: 'Bildershaw',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6826716,
        LOCATION_LATITUDE_DEG: 54.6108599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007600',
        LOCATION_NAME: 'Bildeston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9093359,
        LOCATION_LATITUDE_DEG: 52.1080838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007700',
        LOCATION_NAME: 'Bill Quay',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5337268,
        LOCATION_LATITUDE_DEG: 54.9565908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007800',
        LOCATION_NAME: 'Billacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0791134,
        LOCATION_LATITUDE_DEG: 50.3661789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI007900',
        LOCATION_NAME: 'Billericay',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4187654,
        LOCATION_LATITUDE_DEG: 51.6217437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008000',
        LOCATION_NAME: 'Billesdon',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9360549,
        LOCATION_LATITUDE_DEG: 52.615757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI035000',
        LOCATION_NAME: 'Billesley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8779684,
        LOCATION_LATITUDE_DEG: 52.4365441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008100',
        LOCATION_NAME: 'Billesley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7868822,
        LOCATION_LATITUDE_DEG: 52.209035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008200',
        LOCATION_NAME: 'Billingbear',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8053814,
        LOCATION_LATITUDE_DEG: 51.4379482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008300',
        LOCATION_NAME: 'Billingborough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3399766,
        LOCATION_LATITUDE_DEG: 52.8937835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008400',
        LOCATION_NAME: 'Billingborough Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2962785,
        LOCATION_LATITUDE_DEG: 52.889676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008500',
        LOCATION_NAME: 'Billinge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7117757,
        LOCATION_LATITUDE_DEG: 53.4936675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008700',
        LOCATION_NAME: 'Billingford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9863506,
        LOCATION_LATITUDE_DEG: 52.7426507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008600',
        LOCATION_NAME: 'Billingford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1816908,
        LOCATION_LATITUDE_DEG: 52.3627115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008800',
        LOCATION_NAME: 'Billingham',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3111086,
        LOCATION_LATITUDE_DEG: 50.6326808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI008900',
        LOCATION_NAME: 'Billingham',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2901857,
        LOCATION_LATITUDE_DEG: 54.594257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009000',
        LOCATION_NAME: 'Billinghay',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2756601,
        LOCATION_LATITUDE_DEG: 53.0792939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009100',
        LOCATION_NAME: 'Billingley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3379838,
        LOCATION_LATITUDE_DEG: 53.5364564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034600',
        LOCATION_NAME: 'Billingsgate',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0842054,
        LOCATION_LATITUDE_DEG: 51.5096998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009200',
        LOCATION_NAME: 'Billingshurst',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4524313,
        LOCATION_LATITUDE_DEG: 51.0188985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009300',
        LOCATION_NAME: 'Billingsley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4229325,
        LOCATION_LATITUDE_DEG: 52.4556673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009400',
        LOCATION_NAME: 'Billington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4238563,
        LOCATION_LATITUDE_DEG: 53.8147937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009500',
        LOCATION_NAME: 'Billington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1647104,
        LOCATION_LATITUDE_DEG: 52.7831964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009700',
        LOCATION_NAME: 'Billockby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5950283,
        LOCATION_LATITUDE_DEG: 52.6627317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009800',
        LOCATION_NAME: 'Billy Row',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7494294,
        LOCATION_LATITUDE_DEG: 54.7312724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009900',
        LOCATION_NAME: 'Bilsborrow',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7433681,
        LOCATION_LATITUDE_DEG: 53.8536995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010000',
        LOCATION_NAME: 'Bilsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2040174,
        LOCATION_LATITUDE_DEG: 53.2655077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010100',
        LOCATION_NAME: 'Bilsington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9124487,
        LOCATION_LATITUDE_DEG: 51.0728875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010200',
        LOCATION_NAME: 'Bilsthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0233749,
        LOCATION_LATITUDE_DEG: 53.1349163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010300',
        LOCATION_NAME: 'Bilston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1809574,
        LOCATION_LATITUDE_DEG: 55.8693075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010400',
        LOCATION_NAME: 'Bilston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0713091,
        LOCATION_LATITUDE_DEG: 52.5656691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010500',
        LOCATION_NAME: 'Bilstone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4636127,
        LOCATION_LATITUDE_DEG: 52.6426697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010600',
        LOCATION_NAME: 'Bilting',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9392668,
        LOCATION_LATITUDE_DEG: 51.2040999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010900',
        LOCATION_NAME: 'Bilton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6254181,
        LOCATION_LATITUDE_DEG: 55.3935425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010700',
        LOCATION_NAME: 'Bilton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2872821,
        LOCATION_LATITUDE_DEG: 52.3609376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI010800',
        LOCATION_NAME: 'Bilton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2315692,
        LOCATION_LATITUDE_DEG: 53.7797679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034200',
        LOCATION_NAME: 'Bilton in Ainsty',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011000',
        LOCATION_NAME: 'Bilton-in-Ainsty',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2776309,
        LOCATION_LATITUDE_DEG: 53.9479973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011100',
        LOCATION_NAME: 'Binbrook',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1788967,
        LOCATION_LATITUDE_DEG: 53.4288295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011200',
        LOCATION_NAME: 'Binchester',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.675419,
        LOCATION_LATITUDE_DEG: 54.6757685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011300',
        LOCATION_NAME: 'Binchester Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6251383,
        LOCATION_LATITUDE_DEG: 54.6840719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011400',
        LOCATION_NAME: 'Bincombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4446293,
        LOCATION_LATITUDE_DEG: 50.6597892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011500',
        LOCATION_NAME: 'Bincombe Down',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4614618,
        LOCATION_LATITUDE_DEG: 50.6707952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011600',
        LOCATION_NAME: 'Binderton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7893863,
        LOCATION_LATITUDE_DEG: 50.8902898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011700',
        LOCATION_NAME: 'Binegar',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5384695,
        LOCATION_LATITUDE_DEG: 51.2402525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011800',
        LOCATION_NAME: 'Binfield',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2748254,
        LOCATION_LATITUDE_DEG: 50.7233802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI011900',
        LOCATION_NAME: 'Binfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7865536,
        LOCATION_LATITUDE_DEG: 51.4311449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012000',
        LOCATION_NAME: 'Binfield Heath',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9234291,
        LOCATION_LATITUDE_DEG: 51.5003514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012100',
        LOCATION_NAME: 'Bingfield',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0335435,
        LOCATION_LATITUDE_DEG: 55.0473073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012300',
        LOCATION_NAME: 'Bingham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9550942,
        LOCATION_LATITUDE_DEG: 52.9494906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012400',
        LOCATION_NAME: 'Binghams Melcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3239317,
        LOCATION_LATITUDE_DEG: 50.8175052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012600',
        LOCATION_NAME: 'Bingley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.835443,
        LOCATION_LATITUDE_DEG: 53.8473944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012700',
        LOCATION_NAME: 'Binham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9501631,
        LOCATION_LATITUDE_DEG: 52.9176659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012800',
        LOCATION_NAME: 'Binley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4555888,
        LOCATION_LATITUDE_DEG: 52.4028509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012900',
        LOCATION_NAME: 'Binley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3958732,
        LOCATION_LATITUDE_DEG: 51.2761378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013000',
        LOCATION_NAME: 'Binley Woods',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4189828,
        LOCATION_LATITUDE_DEG: 52.394045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013100',
        LOCATION_NAME: 'Binnegar',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1572255,
        LOCATION_LATITUDE_DEG: 50.6888887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013200',
        LOCATION_NAME: 'Binniehill',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8270088,
        LOCATION_LATITUDE_DEG: 55.9297179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013300',
        LOCATION_NAME: 'Binsey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2880182,
        LOCATION_LATITUDE_DEG: 51.764488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013400',
        LOCATION_NAME: 'Binstead',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1841814,
        LOCATION_LATITUDE_DEG: 50.7245799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013500',
        LOCATION_NAME: 'Binsted',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8974237,
        LOCATION_LATITUDE_DEG: 51.1639197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013600',
        LOCATION_NAME: 'Binsted',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6057296,
        LOCATION_LATITUDE_DEG: 50.8476865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013700',
        LOCATION_NAME: 'Binton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7923297,
        LOCATION_LATITUDE_DEG: 52.1864312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI990300',
        LOCATION_NAME: 'Bintree',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.988256,
        LOCATION_LATITUDE_DEG: 52.7730738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014000',
        LOCATION_NAME: 'Birch',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8207256,
        LOCATION_LATITUDE_DEG: 51.8436625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014100',
        LOCATION_NAME: 'Birch Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1253032,
        LOCATION_LATITUDE_DEG: 51.7845723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI990261',
        LOCATION_NAME: 'Birch Vale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9658721,
        LOCATION_LATITUDE_DEG: 53.3791783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014200',
        LOCATION_NAME: 'Birch Vale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9643393,
        LOCATION_LATITUDE_DEG: 53.3783508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014300',
        LOCATION_NAME: 'Bircham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6269973,
        LOCATION_LATITUDE_DEG: 52.8611632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014400',
        LOCATION_NAME: 'Bircham Newton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6304318,
        LOCATION_LATITUDE_DEG: 52.873965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014500',
        LOCATION_NAME: 'Bircham Tofts',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6445108,
        LOCATION_LATITUDE_DEG: 52.8615656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014600',
        LOCATION_NAME: 'Birchanger',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.193189,
        LOCATION_LATITUDE_DEG: 51.8825762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014700',
        LOCATION_NAME: 'Bircher',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7675437,
        LOCATION_LATITUDE_DEG: 52.2863518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014800',
        LOCATION_NAME: 'Birches Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8320366,
        LOCATION_LATITUDE_DEG: 52.5145659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI014900',
        LOCATION_NAME: 'Birchetts Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3806276,
        LOCATION_LATITUDE_DEG: 51.0566915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI035200',
        LOCATION_NAME: 'Birchfields',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9043264,
        LOCATION_LATITUDE_DEG: 52.5067164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI035300',
        LOCATION_NAME: 'Birchfields',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9032116,
        LOCATION_LATITUDE_DEG: 52.5111031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015000',
        LOCATION_NAME: 'Birchgrove',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8726955,
        LOCATION_LATITUDE_DEG: 51.6707044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015100',
        LOCATION_NAME: 'Birchgrove',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'CF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2060071,
        LOCATION_LATITUDE_DEG: 51.5162864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015200',
        LOCATION_NAME: 'Birchill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9850189,
        LOCATION_LATITUDE_DEG: 50.8248143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015300',
        LOCATION_NAME: 'Birchills',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9901529,
        LOCATION_LATITUDE_DEG: 52.591368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015400',
        LOCATION_NAME: 'Birchington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3087668,
        LOCATION_LATITUDE_DEG: 51.37341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015500',
        LOCATION_NAME: 'Birchley Heath',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5763163,
        LOCATION_LATITUDE_DEG: 52.5476609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015600',
        LOCATION_NAME: 'Birchmoor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.629937,
        LOCATION_LATITUDE_DEG: 52.6131686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015700',
        LOCATION_NAME: 'Birchover',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6420833,
        LOCATION_LATITUDE_DEG: 53.1558239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015800',
        LOCATION_NAME: 'Birchwood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0778551,
        LOCATION_LATITUDE_DEG: 50.9215223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI015900',
        LOCATION_NAME: 'Birchwood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5206708,
        LOCATION_LATITUDE_DEG: 53.4223581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016000',
        LOCATION_NAME: 'Bircotes',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0473644,
        LOCATION_LATITUDE_DEG: 53.42044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016100',
        LOCATION_NAME: 'Bird End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9748588,
        LOCATION_LATITUDE_DEG: 52.5385623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016200',
        LOCATION_NAME: 'Bird in Hand',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2304992,
        LOCATION_LATITUDE_DEG: 51.7623986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016300',
        LOCATION_NAME: 'Birdbrook',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4904626,
        LOCATION_LATITUDE_DEG: 52.0422875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016400',
        LOCATION_NAME: 'Birdham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8300436,
        LOCATION_LATITUDE_DEG: 50.7958817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016700',
        LOCATION_NAME: 'Birdholme',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4257535,
        LOCATION_LATITUDE_DEG: 53.2198227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016800',
        LOCATION_NAME: 'Birdingbury',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3673018,
        LOCATION_LATITUDE_DEG: 52.3100344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016900',
        LOCATION_NAME: 'Birdlip',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1075207,
        LOCATION_LATITUDE_DEG: 51.8273992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017000',
        LOCATION_NAME: 'Birdsall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7487237,
        LOCATION_LATITUDE_DEG: 54.0821961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017100',
        LOCATION_NAME: 'Birdsedge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6949852,
        LOCATION_LATITUDE_DEG: 53.5659648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017200',
        LOCATION_NAME: 'Birdsgreen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3409744,
        LOCATION_LATITUDE_DEG: 52.4640599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017300',
        LOCATION_NAME: 'Birdston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1558996,
        LOCATION_LATITUDE_DEG: 55.9524249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017400',
        LOCATION_NAME: 'Birdwell',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4783306,
        LOCATION_LATITUDE_DEG: 53.5112521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017500',
        LOCATION_NAME: 'Birdwood',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3742141,
        LOCATION_LATITUDE_DEG: 51.8662111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017600',
        LOCATION_NAME: 'Birgham',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3342765,
        LOCATION_LATITUDE_DEG: 55.6444728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017900',
        LOCATION_NAME: 'Birkby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4614255,
        LOCATION_LATITUDE_DEG: 54.7232989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017800',
        LOCATION_NAME: 'Birkby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3167434,
        LOCATION_LATITUDE_DEG: 54.3565558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI017700',
        LOCATION_NAME: 'Birkby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7956266,
        LOCATION_LATITUDE_DEG: 53.6574745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018000',
        LOCATION_NAME: 'Birkby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4891736,
        LOCATION_LATITUDE_DEG: 54.4164426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018100',
        LOCATION_NAME: 'Birkdale',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'PR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0080422,
        LOCATION_LATITUDE_DEG: 53.6317856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018200',
        LOCATION_NAME: 'Birkenhead',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0244026,
        LOCATION_LATITUDE_DEG: 53.3889653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018400',
        LOCATION_NAME: 'Birkenshaw',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.091111,
        LOCATION_LATITUDE_DEG: 55.835213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018300',
        LOCATION_NAME: 'Birkenshaw',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6916306,
        LOCATION_LATITUDE_DEG: 53.7466763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018500',
        LOCATION_NAME: 'Birkhall',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0740075,
        LOCATION_LATITUDE_DEG: 57.029021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018600',
        LOCATION_NAME: 'Birkhill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0721217,
        LOCATION_LATITUDE_DEG: 56.3969547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018700',
        LOCATION_NAME: 'Birkhill',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0533831,
        LOCATION_LATITUDE_DEG: 56.4957691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018800',
        LOCATION_NAME: 'Birkin',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1966598,
        LOCATION_LATITUDE_DEG: 53.73247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI018900',
        LOCATION_NAME: 'Birley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7981803,
        LOCATION_LATITUDE_DEG: 52.1757408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019000',
        LOCATION_NAME: 'Birley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4007031,
        LOCATION_LATITUDE_DEG: 53.3403443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034400',
        LOCATION_NAME: 'Birley Carr',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5003188,
        LOCATION_LATITUDE_DEG: 53.429172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019200',
        LOCATION_NAME: 'Birling',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6072968,
        LOCATION_LATITUDE_DEG: 55.3516344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019100',
        LOCATION_NAME: 'Birling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4112009,
        LOCATION_LATITUDE_DEG: 51.3185206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019300',
        LOCATION_NAME: 'Birling Gap',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.203742,
        LOCATION_LATITUDE_DEG: 50.7426641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019400',
        LOCATION_NAME: 'Birlingham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0976776,
        LOCATION_LATITUDE_DEG: 52.0868215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019500',
        LOCATION_NAME: 'Birmingham B 1',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9112482,
        LOCATION_LATITUDE_DEG: 52.4792183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019600',
        LOCATION_NAME: 'Birmingham B 2',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8998215,
        LOCATION_LATITUDE_DEG: 52.4790474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019700',
        LOCATION_NAME: 'Birmingham B 3',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9042901,
        LOCATION_LATITUDE_DEG: 52.4827374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019800',
        LOCATION_NAME: 'Birmingham B 4',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8910622,
        LOCATION_LATITUDE_DEG: 52.4840206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019900',
        LOCATION_NAME: 'Birmingham B 5',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9017245,
        LOCATION_LATITUDE_DEG: 52.4642677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020000',
        LOCATION_NAME: 'Birmingham B 6',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8810395,
        LOCATION_LATITUDE_DEG: 52.5088531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020100',
        LOCATION_NAME: 'Birmingham B 7',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.870452,
        LOCATION_LATITUDE_DEG: 52.4963265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020200',
        LOCATION_NAME: 'Birmingham B 8',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8423265,
        LOCATION_LATITUDE_DEG: 52.4931006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020300',
        LOCATION_NAME: 'Birmingham B 9',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8498446,
        LOCATION_LATITUDE_DEG: 52.478473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020400',
        LOCATION_NAME: 'Birmingham B10',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8512781,
        LOCATION_LATITUDE_DEG: 52.4682071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020500',
        LOCATION_NAME: 'Birmingham B11',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.85617,
        LOCATION_LATITUDE_DEG: 52.4533869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020600',
        LOCATION_NAME: 'Birmingham B12',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8869966,
        LOCATION_LATITUDE_DEG: 52.4613594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020700',
        LOCATION_NAME: 'Birmingham B13',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.880748,
        LOCATION_LATITUDE_DEG: 52.4368617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020800',
        LOCATION_NAME: 'Birmingham B14',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8901138,
        LOCATION_LATITUDE_DEG: 52.415382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI020900',
        LOCATION_NAME: 'Birmingham B15',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9283439,
        LOCATION_LATITUDE_DEG: 52.4615985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021000',
        LOCATION_NAME: 'Birmingham B16',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9361503,
        LOCATION_LATITUDE_DEG: 52.478578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021100',
        LOCATION_NAME: 'Birmingham B17',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9603892,
        LOCATION_LATITUDE_DEG: 52.4613528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021200',
        LOCATION_NAME: 'Birmingham B18',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9278971,
        LOCATION_LATITUDE_DEG: 52.4917901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021300',
        LOCATION_NAME: 'Birmingham B19',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9053927,
        LOCATION_LATITUDE_DEG: 52.4973396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021400',
        LOCATION_NAME: 'Birmingham B20',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.926027,
        LOCATION_LATITUDE_DEG: 52.5177908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021500',
        LOCATION_NAME: 'Birmingham B21',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9462149,
        LOCATION_LATITUDE_DEG: 52.5089366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021600',
        LOCATION_NAME: 'Birmingham B23',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.857904,
        LOCATION_LATITUDE_DEG: 52.527331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021700',
        LOCATION_NAME: 'Birmingham B24',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8245826,
        LOCATION_LATITUDE_DEG: 52.5174502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021800',
        LOCATION_NAME: 'Birmingham B25',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8218893,
        LOCATION_LATITUDE_DEG: 52.4654602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI021900',
        LOCATION_NAME: 'Birmingham B26',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7823789,
        LOCATION_LATITUDE_DEG: 52.4592802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022000',
        LOCATION_NAME: 'Birmingham B27',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8232722,
        LOCATION_LATITUDE_DEG: 52.4436409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022100',
        LOCATION_NAME: 'Birmingham B28',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8449183,
        LOCATION_LATITUDE_DEG: 52.4262915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022200',
        LOCATION_NAME: 'Birmingham B29',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9483615,
        LOCATION_LATITUDE_DEG: 52.4376298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022300',
        LOCATION_NAME: 'Birmingham B30',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9304361,
        LOCATION_LATITUDE_DEG: 52.4230101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022400',
        LOCATION_NAME: 'Birmingham B31',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.975698,
        LOCATION_LATITUDE_DEG: 52.4072936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022500',
        LOCATION_NAME: 'Birmingham B32',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0036337,
        LOCATION_LATITUDE_DEG: 52.4363823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022600',
        LOCATION_NAME: 'Birmingham B33',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7869343,
        LOCATION_LATITUDE_DEG: 52.4791227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022700',
        LOCATION_NAME: 'Birmingham B34',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7842652,
        LOCATION_LATITUDE_DEG: 52.4949331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022800',
        LOCATION_NAME: 'Birmingham B35',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7889155,
        LOCATION_LATITUDE_DEG: 52.5174459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI022900',
        LOCATION_NAME: 'Birmingham B36',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.776793,
        LOCATION_LATITUDE_DEG: 52.5043867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023000',
        LOCATION_NAME: 'Birmingham B37',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7365683,
        LOCATION_LATITUDE_DEG: 52.4724219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023100',
        LOCATION_NAME: 'Birmingham B38',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.926885,
        LOCATION_LATITUDE_DEG: 52.3914941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023200',
        LOCATION_NAME: 'Birmingham B40',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7174245,
        LOCATION_LATITUDE_DEG: 52.4522377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023300',
        LOCATION_NAME: 'Birmingham B42',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9121153,
        LOCATION_LATITUDE_DEG: 52.5317892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023400',
        LOCATION_NAME: 'Birmingham B43',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9345402,
        LOCATION_LATITUDE_DEG: 52.5513859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023500',
        LOCATION_NAME: 'Birmingham B44',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8856435,
        LOCATION_LATITUDE_DEG: 52.5460981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023600',
        LOCATION_NAME: 'Birmingham B45',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.007582,
        LOCATION_LATITUDE_DEG: 52.3834424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034700',
        LOCATION_NAME: 'Birmingham B46',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.680915,
        LOCATION_LATITUDE_DEG: 52.5068194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023700',
        LOCATION_NAME: 'Birmingham B47',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8810018,
        LOCATION_LATITUDE_DEG: 52.3808293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023800',
        LOCATION_NAME: 'Birmingham B48',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9377075,
        LOCATION_LATITUDE_DEG: 52.366379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI023900',
        LOCATION_NAME: 'Birmingham International Airport',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7323561,
        LOCATION_LATITUDE_DEG: 52.4532165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI035100',
        LOCATION_NAME: 'Birmingham University',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.926125,
        LOCATION_LATITUDE_DEG: 52.4505741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024000',
        LOCATION_NAME: 'Birnam',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5697491,
        LOCATION_LATITUDE_DEG: 56.5585761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024100',
        LOCATION_NAME: 'Birnie',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3192747,
        LOCATION_LATITUDE_DEG: 57.6070794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024400',
        LOCATION_NAME: 'Birsay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3276776,
        LOCATION_LATITUDE_DEG: 59.1362317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024500',
        LOCATION_NAME: 'Birse',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7301054,
        LOCATION_LATITUDE_DEG: 57.0618208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024600',
        LOCATION_NAME: 'Birstall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6610426,
        LOCATION_LATITUDE_DEG: 53.7315639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024700',
        LOCATION_NAME: 'Birstall',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1191185,
        LOCATION_LATITUDE_DEG: 52.674173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024800',
        LOCATION_NAME: 'Birstwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.633999,
        LOCATION_LATITUDE_DEG: 54.031005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024900',
        LOCATION_NAME: 'Birthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3587678,
        LOCATION_LATITUDE_DEG: 52.8902773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025000',
        LOCATION_NAME: 'Birtle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2552396,
        LOCATION_LATITUDE_DEG: 53.6154778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025300',
        LOCATION_NAME: 'Birtley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.775159,
        LOCATION_LATITUDE_DEG: 52.5114722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025200',
        LOCATION_NAME: 'Birtley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1883062,
        LOCATION_LATITUDE_DEG: 55.0984199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025100',
        LOCATION_NAME: 'Birtley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5759019,
        LOCATION_LATITUDE_DEG: 54.8979945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025400',
        LOCATION_NAME: 'Birts Street',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3151257,
        LOCATION_LATITUDE_DEG: 52.0258188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025500',
        LOCATION_NAME: 'Birtsmorton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2901853,
        LOCATION_LATITUDE_DEG: 52.0190222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI990115',
        LOCATION_NAME: 'Bisbrooke',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6921463,
        LOCATION_LATITUDE_DEG: 52.5895956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025600',
        LOCATION_NAME: 'Bisbrooke',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6907073,
        LOCATION_LATITUDE_DEG: 52.5868553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025700',
        LOCATION_NAME: 'Biscathorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1575255,
        LOCATION_LATITUDE_DEG: 53.3472233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025800',
        LOCATION_NAME: 'Bisham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7728391,
        LOCATION_LATITUDE_DEG: 51.5573535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI025900',
        LOCATION_NAME: 'Bishampton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0160674,
        LOCATION_LATITUDE_DEG: 52.1597284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026000',
        LOCATION_NAME: 'Bishmill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7951783,
        LOCATION_LATITUDE_DEG: 51.0131433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026100',
        LOCATION_NAME: 'Bishop Auckland',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6752473,
        LOCATION_LATITUDE_DEG: 54.6564714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026200',
        LOCATION_NAME: 'Bishop Burton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4960954,
        LOCATION_LATITUDE_DEG: 53.8454716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026300',
        LOCATION_NAME: 'Bishop Kinkell',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4244332,
        LOCATION_LATITUDE_DEG: 57.547282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026400',
        LOCATION_NAME: 'Bishop Middleham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4851125,
        LOCATION_LATITUDE_DEG: 54.6773653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026500',
        LOCATION_NAME: 'Bishop Monkton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4966373,
        LOCATION_LATITUDE_DEG: 54.0921081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026600',
        LOCATION_NAME: 'Bishop Monkton Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5290583,
        LOCATION_LATITUDE_DEG: 54.0904147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026700',
        LOCATION_NAME: 'Bishop Norton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5189873,
        LOCATION_LATITUDE_DEG: 53.4219338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026800',
        LOCATION_NAME: 'Bishop Sutton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5931403,
        LOCATION_LATITUDE_DEG: 51.3348547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI026900',
        LOCATION_NAME: 'Bishop Thornton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5992843,
        LOCATION_LATITUDE_DEG: 54.065312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027000',
        LOCATION_NAME: 'Bishop Wilton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.783832,
        LOCATION_LATITUDE_DEG: 53.9851932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027500',
        LOCATION_NAME: 'Bishopbridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4476835,
        LOCATION_LATITUDE_DEG: 53.4060319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027600',
        LOCATION_NAME: 'Bishopbriggs',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2228562,
        LOCATION_LATITUDE_DEG: 55.9067245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027700',
        LOCATION_NAME: 'Bishopdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0307781,
        LOCATION_LATITUDE_DEG: 54.2540323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027800',
        LOCATION_NAME: 'Bishopdown',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7814754,
        LOCATION_LATITUDE_DEG: 51.0767233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027900',
        LOCATION_NAME: 'Bishopmill',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.315999,
        LOCATION_LATITUDE_DEG: 57.6590793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033900',
        LOCATION_NAME: 'Bishops Cannings',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.948018,
        LOCATION_LATITUDE_DEG: 51.3842131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027200',
        LOCATION_NAME: "Bishop's Cannings",
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9510246,
        LOCATION_LATITUDE_DEG: 51.3814357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028000',
        LOCATION_NAME: 'Bishops Castle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9966821,
        LOCATION_LATITUDE_DEG: 52.4911748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028100',
        LOCATION_NAME: 'Bishops Caundle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4383379,
        LOCATION_LATITUDE_DEG: 50.915224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028200',
        LOCATION_NAME: 'Bishops Cleeve',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0609533,
        LOCATION_LATITUDE_DEG: 51.9472138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028300',
        LOCATION_NAME: 'Bishops Down',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4706441,
        LOCATION_LATITUDE_DEG: 50.9093154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028400',
        LOCATION_NAME: 'Bishops Frome',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4934188,
        LOCATION_LATITUDE_DEG: 52.132532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028500',
        LOCATION_NAME: 'Bishops Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2812195,
        LOCATION_LATITUDE_DEG: 51.3610489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027100',
        LOCATION_NAME: "Bishop's Green",
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3672158,
        LOCATION_LATITUDE_DEG: 51.8360682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028600',
        LOCATION_NAME: 'Bishops Hull',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1314131,
        LOCATION_LATITUDE_DEG: 51.0141363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028700',
        LOCATION_NAME: 'Bishops Itchington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4313729,
        LOCATION_LATITUDE_DEG: 52.2154285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028800',
        LOCATION_NAME: 'Bishops Lydeard',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1860189,
        LOCATION_LATITUDE_DEG: 51.0571418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI028900',
        LOCATION_NAME: 'Bishops Moat',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0434438,
        LOCATION_LATITUDE_DEG: 52.4989718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029000',
        LOCATION_NAME: 'Bishops Nympton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7708769,
        LOCATION_LATITUDE_DEG: 50.9983951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029100',
        LOCATION_NAME: 'Bishops Offley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3256127,
        LOCATION_LATITUDE_DEG: 52.8609287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034000',
        LOCATION_NAME: 'Bishops Stortford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027300',
        LOCATION_NAME: "Bishop's Stortford",
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1604237,
        LOCATION_LATITUDE_DEG: 51.8708705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034100',
        LOCATION_NAME: 'Bishops Sutton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1324489,
        LOCATION_LATITUDE_DEG: 51.0858405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI027400',
        LOCATION_NAME: "Bishop's Sutton",
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1386238,
        LOCATION_LATITUDE_DEG: 51.0831971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029200',
        LOCATION_NAME: 'Bishops Tachbrook',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5417199,
        LOCATION_LATITUDE_DEG: 52.2493298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029300',
        LOCATION_NAME: 'Bishops Tawton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0481186,
        LOCATION_LATITUDE_DEG: 51.0509681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029500',
        LOCATION_NAME: 'Bishops Waltham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2138005,
        LOCATION_LATITUDE_DEG: 50.9499317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030900',
        LOCATION_NAME: 'Bishops Wood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2448045,
        LOCATION_LATITUDE_DEG: 52.6787577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029600',
        LOCATION_NAME: 'Bishopsbourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1378217,
        LOCATION_LATITUDE_DEG: 51.2288956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI034500',
        LOCATION_NAME: 'Bishopsgate',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0803415,
        LOCATION_LATITUDE_DEG: 51.5179557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029800',
        LOCATION_NAME: 'Bishopsteignton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5411503,
        LOCATION_LATITUDE_DEG: 50.5519924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029900',
        LOCATION_NAME: 'Bishopstoke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3267861,
        LOCATION_LATITUDE_DEG: 50.9659085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030000',
        LOCATION_NAME: 'Bishopston',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0571472,
        LOCATION_LATITUDE_DEG: 51.5843006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI035400',
        LOCATION_NAME: 'Bishopston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5898478,
        LOCATION_LATITUDE_DEG: 51.4764084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030100',
        LOCATION_NAME: 'Bishopstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8437481,
        LOCATION_LATITUDE_DEG: 52.0826285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030300',
        LOCATION_NAME: 'Bishopstone',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9020468,
        LOCATION_LATITUDE_DEG: 51.0316237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030500',
        LOCATION_NAME: 'Bishopstone',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6457879,
        LOCATION_LATITUDE_DEG: 51.5509696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030400',
        LOCATION_NAME: 'Bishopstone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8370664,
        LOCATION_LATITUDE_DEG: 51.7877792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030200',
        LOCATION_NAME: 'Bishopstone',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1037636,
        LOCATION_LATITUDE_DEG: 50.787075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030700',
        LOCATION_NAME: 'Bishopstrow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1525352,
        LOCATION_LATITUDE_DEG: 51.1923441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030800',
        LOCATION_NAME: 'Bishopswood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0502696,
        LOCATION_LATITUDE_DEG: 50.9078245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031000',
        LOCATION_NAME: 'Bishopswood',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5904502,
        LOCATION_LATITUDE_DEG: 51.8755127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031100',
        LOCATION_NAME: 'Bishopsworth',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6174533,
        LOCATION_LATITUDE_DEG: 51.4144684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031200',
        LOCATION_NAME: 'Bishopthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0985828,
        LOCATION_LATITUDE_DEG: 53.9208894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031300',
        LOCATION_NAME: 'Bishopton',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5065166,
        LOCATION_LATITUDE_DEG: 55.9103273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031400',
        LOCATION_NAME: 'Bishopton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7294428,
        LOCATION_LATITUDE_DEG: 52.2053297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031500',
        LOCATION_NAME: 'Bishopton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4360267,
        LOCATION_LATITUDE_DEG: 54.5852544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031600',
        LOCATION_NAME: 'Bishton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8786967,
        LOCATION_LATITUDE_DEG: 51.5818827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031700',
        LOCATION_NAME: 'Bisley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1380715,
        LOCATION_LATITUDE_DEG: 51.7522925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031800',
        LOCATION_NAME: 'Bisley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.636413,
        LOCATION_LATITUDE_DEG: 51.3251367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031900',
        LOCATION_NAME: 'Bispham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0517934,
        LOCATION_LATITUDE_DEG: 53.8496036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI031950',
        LOCATION_NAME: 'Bispham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7670036,
        LOCATION_LATITUDE_DEG: 53.6142992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032000',
        LOCATION_NAME: 'Bissoe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1179511,
        LOCATION_LATITUDE_DEG: 50.2298801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032100',
        LOCATION_NAME: 'Bissoepool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1779253,
        LOCATION_LATITUDE_DEG: 50.2296844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032200',
        LOCATION_NAME: 'Bissom',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0941217,
        LOCATION_LATITUDE_DEG: 50.1698697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032300',
        LOCATION_NAME: 'Bisterne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.78917,
        LOCATION_LATITUDE_DEG: 50.8123952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032400',
        LOCATION_NAME: 'Bisterne Close',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6824662,
        LOCATION_LATITUDE_DEG: 50.8245018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032500',
        LOCATION_NAME: 'Bitchfield',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.532299,
        LOCATION_LATITUDE_DEG: 52.8462799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032600',
        LOCATION_NAME: 'Bittadon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.077374,
        LOCATION_LATITUDE_DEG: 51.1529603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032700',
        LOCATION_NAME: 'Bittaford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8879382,
        LOCATION_LATITUDE_DEG: 50.3938802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032800',
        LOCATION_NAME: 'Bittams',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2354331,
        LOCATION_LATITUDE_DEG: 50.528803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI032900',
        LOCATION_NAME: 'Bittering',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8720857,
        LOCATION_LATITUDE_DEG: 52.7193484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033000',
        LOCATION_NAME: 'Bitterley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6425355,
        LOCATION_LATITUDE_DEG: 52.3926567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033100',
        LOCATION_NAME: 'Bitterne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3557719,
        LOCATION_LATITUDE_DEG: 50.9142065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033200',
        LOCATION_NAME: 'Bitterne Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3786508,
        LOCATION_LATITUDE_DEG: 50.9311034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033300',
        LOCATION_NAME: 'Bittesby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2600446,
        LOCATION_LATITUDE_DEG: 52.4633519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033400',
        LOCATION_NAME: 'Bitteswell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2101969,
        LOCATION_LATITUDE_DEG: 52.4676511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033500',
        LOCATION_NAME: 'Bitton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.45815,
        LOCATION_LATITUDE_DEG: 51.4242639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033600',
        LOCATION_NAME: 'Bix',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9495717,
        LOCATION_LATITUDE_DEG: 51.5602557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033700',
        LOCATION_NAME: 'Bixley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3343653,
        LOCATION_LATITUDE_DEG: 52.5988249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI033800',
        LOCATION_NAME: 'Bixter',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4032463,
        LOCATION_LATITUDE_DEG: 60.2545221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000100',
        LOCATION_NAME: 'Blaby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1605178,
        LOCATION_LATITUDE_DEG: 52.5754641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000200',
        LOCATION_NAME: 'Black Bourton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5887578,
        LOCATION_LATITUDE_DEG: 51.7327886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000500',
        LOCATION_NAME: 'Black Callerton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.725074,
        LOCATION_LATITUDE_DEG: 55.0226013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000600',
        LOCATION_NAME: 'Black Carr',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0886425,
        LOCATION_LATITUDE_DEG: 52.518726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000700',
        LOCATION_NAME: 'Black Corner',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.144169,
        LOCATION_LATITUDE_DEG: 51.1444094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000800',
        LOCATION_NAME: 'Black Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9428527,
        LOCATION_LATITUDE_DEG: 50.408497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000900',
        LOCATION_NAME: 'Black Dog',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6976118,
        LOCATION_LATITUDE_DEG: 50.8744278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001000',
        LOCATION_NAME: 'Black Dyke',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5427488,
        LOCATION_LATITUDE_DEG: 57.5381863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001100',
        LOCATION_NAME: 'Black Heddon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8772512,
        LOCATION_LATITUDE_DEG: 55.0783096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001200',
        LOCATION_NAME: 'Black Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6583712,
        LOCATION_LATITUDE_DEG: 52.2306362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001300',
        LOCATION_NAME: 'Black Hill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1079903,
        LOCATION_LATITUDE_DEG: 51.0564961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001400',
        LOCATION_NAME: 'Black Notley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5670167,
        LOCATION_LATITUDE_DEG: 51.8539645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001500',
        LOCATION_NAME: 'Black Park',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6526572,
        LOCATION_LATITUDE_DEG: 52.9808185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001600',
        LOCATION_NAME: 'Black Point',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL58',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0512267,
        LOCATION_LATITUDE_DEG: 53.3109623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001700',
        LOCATION_NAME: 'Black Rock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2741297,
        LOCATION_LATITUDE_DEG: 50.1672786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001900',
        LOCATION_NAME: 'Black Torrington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1785709,
        LOCATION_LATITUDE_DEG: 50.8273296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002000',
        LOCATION_NAME: 'Blackawton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6767234,
        LOCATION_LATITUDE_DEG: 50.3446765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002100',
        LOCATION_NAME: 'Blackbank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0194797,
        LOCATION_LATITUDE_DEG: 54.9976196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002200',
        LOCATION_NAME: 'Blackbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5006107,
        LOCATION_LATITUDE_DEG: 54.4497661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002300',
        LOCATION_NAME: 'Blackbird Leys',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.199323,
        LOCATION_LATITUDE_DEG: 51.7203765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002400',
        LOCATION_NAME: 'Blackborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2875169,
        LOCATION_LATITUDE_DEG: 50.8749237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002500',
        LOCATION_NAME: 'Blackborough End',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4655164,
        LOCATION_LATITUDE_DEG: 52.7059502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002600',
        LOCATION_NAME: 'Blackboys',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1733544,
        LOCATION_LATITUDE_DEG: 50.9652895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002800',
        LOCATION_NAME: 'Blackbridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0159759,
        LOCATION_LATITUDE_DEG: 51.7131184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002700',
        LOCATION_NAME: 'Blackbridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8763457,
        LOCATION_LATITUDE_DEG: 52.3321527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL002900',
        LOCATION_NAME: 'Blackbrook',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3483367,
        LOCATION_LATITUDE_DEG: 52.9476127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003000',
        LOCATION_NAME: 'Blackbrook',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.506196,
        LOCATION_LATITUDE_DEG: 53.0262032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003300',
        LOCATION_NAME: 'Blackburn',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6224659,
        LOCATION_LATITUDE_DEG: 55.8739134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003200',
        LOCATION_NAME: 'Blackburn',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4809289,
        LOCATION_LATITUDE_DEG: 53.748787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003100',
        LOCATION_NAME: 'Blackburn',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.286171,
        LOCATION_LATITUDE_DEG: 57.2047261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003400',
        LOCATION_NAME: 'Blackbushe Airport',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8359798,
        LOCATION_LATITUDE_DEG: 51.3215346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003500',
        LOCATION_NAME: 'Blackcraig',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4373303,
        LOCATION_LATITUDE_DEG: 54.9495278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003600',
        LOCATION_NAME: 'Blackdog',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0727169,
        LOCATION_LATITUDE_DEG: 57.2189203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003700',
        LOCATION_NAME: 'Blackdown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8559526,
        LOCATION_LATITUDE_DEG: 50.8221091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL991034',
        LOCATION_NAME: 'Blackdown',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5318275,
        LOCATION_LATITUDE_DEG: 52.317817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003800',
        LOCATION_NAME: 'Blackdyke',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3339991,
        LOCATION_LATITUDE_DEG: 54.8595033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL003900',
        LOCATION_NAME: 'Blacker Hill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4441618,
        LOCATION_LATITUDE_DEG: 53.5131567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004000',
        LOCATION_NAME: 'Blackerne',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8989709,
        LOCATION_LATITUDE_DEG: 54.9596254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004100',
        LOCATION_NAME: 'Blackfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.366306,
        LOCATION_LATITUDE_DEG: 50.8151907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004700',
        LOCATION_NAME: 'Blackford',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7772912,
        LOCATION_LATITUDE_DEG: 56.261751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004200',
        LOCATION_NAME: 'Blackford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5388476,
        LOCATION_LATITUDE_DEG: 51.1958586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004300',
        LOCATION_NAME: 'Blackford',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9418189,
        LOCATION_LATITUDE_DEG: 54.9506109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004600',
        LOCATION_NAME: 'Blackford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8403927,
        LOCATION_LATITUDE_DEG: 51.2228531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004500',
        LOCATION_NAME: 'Blackford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5962429,
        LOCATION_LATITUDE_DEG: 52.4408675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004400',
        LOCATION_NAME: 'Blackford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4882413,
        LOCATION_LATITUDE_DEG: 51.0330281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030600',
        LOCATION_NAME: 'Blackford Hill',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1865503,
        LOCATION_LATITUDE_DEG: 55.9237665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004800',
        LOCATION_NAME: 'Blackfordby',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5112596,
        LOCATION_LATITUDE_DEG: 52.758479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL004900',
        LOCATION_NAME: 'Blackfort',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.299031,
        LOCATION_LATITUDE_DEG: 54.5332119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005000',
        LOCATION_NAME: 'Blackgang',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.308467,
        LOCATION_LATITUDE_DEG: 50.5871735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030500',
        LOCATION_NAME: 'Blackhall',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2498116,
        LOCATION_LATITUDE_DEG: 55.9583325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005100',
        LOCATION_NAME: 'Blackhall',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.543023,
        LOCATION_LATITUDE_DEG: 57.0532119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005200',
        LOCATION_NAME: 'Blackhall',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4711431,
        LOCATION_LATITUDE_DEG: 51.6801928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005300',
        LOCATION_NAME: 'Blackhall Colliery',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2880388,
        LOCATION_LATITUDE_DEG: 54.7464731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005400',
        LOCATION_NAME: 'Blackhall Mill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.811338,
        LOCATION_LATITUDE_DEG: 54.9074946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005500',
        LOCATION_NAME: 'Blackhall Rocks',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2751777,
        LOCATION_LATITUDE_DEG: 54.7410672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005600',
        LOCATION_NAME: 'Blackham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1421128,
        LOCATION_LATITUDE_DEG: 51.1405043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005700',
        LOCATION_NAME: 'Blackhaugh',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9163459,
        LOCATION_LATITUDE_DEG: 55.6366808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005800',
        LOCATION_NAME: 'Blackheath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0617086,
        LOCATION_LATITUDE_DEG: 52.4744073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006000',
        LOCATION_NAME: 'Blackheath',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5170228,
        LOCATION_LATITUDE_DEG: 51.2051241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030100',
        LOCATION_NAME: 'Blackheath',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0207718,
        LOCATION_LATITUDE_DEG: 51.4714409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL005900',
        LOCATION_NAME: 'Blackheath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9102939,
        LOCATION_LATITUDE_DEG: 51.8591626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006100',
        LOCATION_NAME: 'Blackhill',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7012644,
        LOCATION_LATITUDE_DEG: 55.0873589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006200',
        LOCATION_NAME: 'Blackhills',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8769688,
        LOCATION_LATITUDE_DEG: 57.5924243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006300',
        LOCATION_NAME: 'Blackland',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9774494,
        LOCATION_LATITUDE_DEG: 51.4165601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029900',
        LOCATION_NAME: 'Blackley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2131369,
        LOCATION_LATITUDE_DEG: 53.5196435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006400',
        LOCATION_NAME: 'Blackley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8382988,
        LOCATION_LATITUDE_DEG: 53.6741787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006700',
        LOCATION_NAME: 'Blacklunans',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3907999,
        LOCATION_LATITUDE_DEG: 56.7279966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006800',
        LOCATION_NAME: 'Blackmanston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1174254,
        LOCATION_LATITUDE_DEG: 50.6257901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006900',
        LOCATION_NAME: 'Blackmill',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5381775,
        LOCATION_LATITUDE_DEG: 51.5692914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007000',
        LOCATION_NAME: 'Blackminster',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8943204,
        LOCATION_LATITUDE_DEG: 52.1005268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007150',
        LOCATION_NAME: 'Blackmoor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1885256,
        LOCATION_LATITUDE_DEG: 50.9548763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007100',
        LOCATION_NAME: 'Blackmoor',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8866756,
        LOCATION_LATITUDE_DEG: 51.0958185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007200',
        LOCATION_NAME: 'Blackmoor Gate',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9361531,
        LOCATION_LATITUDE_DEG: 51.1715554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007400',
        LOCATION_NAME: 'Blackmore',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.012184,
        LOCATION_LATITUDE_DEG: 52.676595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007300',
        LOCATION_NAME: 'Blackmore',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3193694,
        LOCATION_LATITUDE_DEG: 51.6922573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007500',
        LOCATION_NAME: 'Blackmore End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.527672,
        LOCATION_LATITUDE_DEG: 51.9497754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007600',
        LOCATION_NAME: 'Blackness',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5204556,
        LOCATION_LATITUDE_DEG: 56.0033257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007700',
        LOCATION_NAME: 'Blacknest',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8576118,
        LOCATION_LATITUDE_DEG: 51.1670181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007800',
        LOCATION_NAME: 'Blackney',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8074839,
        LOCATION_LATITUDE_DEG: 50.7903109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL007900',
        LOCATION_NAME: 'Blacko',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2143381,
        LOCATION_LATITUDE_DEG: 53.8703994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008000',
        LOCATION_NAME: 'Blackpill',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9951339,
        LOCATION_LATITUDE_DEG: 51.5949946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008200',
        LOCATION_NAME: 'Blackpool',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6110386,
        LOCATION_LATITUDE_DEG: 50.3193759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008300',
        LOCATION_NAME: 'Blackpool',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0537975,
        LOCATION_LATITUDE_DEG: 53.8161993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008500',
        LOCATION_NAME: 'Blackpool Airport',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0313886,
        LOCATION_LATITUDE_DEG: 53.7727952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008600',
        LOCATION_NAME: 'Blackridge',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7656044,
        LOCATION_LATITUDE_DEG: 55.8841123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008900',
        LOCATION_NAME: 'Blackrock',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1398845,
        LOCATION_LATITUDE_DEG: 51.8070061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009000',
        LOCATION_NAME: 'Blackrod',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5790107,
        LOCATION_LATITUDE_DEG: 53.5921725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009100',
        LOCATION_NAME: 'Blacksboat',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3710204,
        LOCATION_LATITUDE_DEG: 57.4381656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009200',
        LOCATION_NAME: 'Blacksessiagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3440093,
        LOCATION_LATITUDE_DEG: 54.5679506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009300',
        LOCATION_NAME: 'Blackshaw Head',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0649331,
        LOCATION_LATITUDE_DEG: 53.7439811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009400',
        LOCATION_NAME: 'Blackshaw Moor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.987159,
        LOCATION_LATITUDE_DEG: 53.1345243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009500',
        LOCATION_NAME: 'Blackshiels',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9318378,
        LOCATION_LATITUDE_DEG: 55.8332982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL990986',
        LOCATION_NAME: 'Blackskull',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009700',
        LOCATION_NAME: 'Blackstone',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2361241,
        LOCATION_LATITUDE_DEG: 50.9298932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009800',
        LOCATION_NAME: 'Blackthorn',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0970963,
        LOCATION_LATITUDE_DEG: 51.8682874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009900',
        LOCATION_NAME: 'Blackthorpe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7888354,
        LOCATION_LATITUDE_DEG: 52.2324003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010000',
        LOCATION_NAME: 'Blacktoft',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7169652,
        LOCATION_LATITUDE_DEG: 53.7077613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010400',
        LOCATION_NAME: 'Blackwater',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1784496,
        LOCATION_LATITUDE_DEG: 50.2714879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010300',
        LOCATION_NAME: 'Blackwater',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2816875,
        LOCATION_LATITUDE_DEG: 50.6748827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010200',
        LOCATION_NAME: 'Blackwater',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7735165,
        LOCATION_LATITUDE_DEG: 51.3312393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010700',
        LOCATION_NAME: 'Blackwaterfoot',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3316755,
        LOCATION_LATITUDE_DEG: 55.5018953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010800',
        LOCATION_NAME: 'Blackwatertown',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7046049,
        LOCATION_LATITUDE_DEG: 54.411508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010900',
        LOCATION_NAME: 'Blackweir',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1874968,
        LOCATION_LATITUDE_DEG: 51.4917806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL990926',
        LOCATION_NAME: 'Blackwell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011300',
        LOCATION_NAME: 'Blackwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6440786,
        LOCATION_LATITUDE_DEG: 50.3245711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011000',
        LOCATION_NAME: 'Blackwell',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9311566,
        LOCATION_LATITUDE_DEG: 54.8683023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011400',
        LOCATION_NAME: 'Blackwell',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0136691,
        LOCATION_LATITUDE_DEG: 52.3485471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011200',
        LOCATION_NAME: 'Blackwell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8080454,
        LOCATION_LATITUDE_DEG: 53.2445331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011100',
        LOCATION_NAME: 'Blackwell',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6467623,
        LOCATION_LATITUDE_DEG: 52.0880232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL990577',
        LOCATION_NAME: 'Blackwood',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9268205,
        LOCATION_LATITUDE_DEG: 55.636188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011500',
        LOCATION_NAME: 'Blackwood',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1968348,
        LOCATION_LATITUDE_DEG: 51.6698966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030300',
        LOCATION_NAME: 'Blackwood (cumbernauld)',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0457126,
        LOCATION_LATITUDE_DEG: 55.9845573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011700',
        LOCATION_NAME: 'Blacon',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9270226,
        LOCATION_LATITUDE_DEG: 53.203639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011800',
        LOCATION_NAME: 'Bladbean',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1213291,
        LOCATION_LATITUDE_DEG: 51.1801928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011900',
        LOCATION_NAME: 'Bladon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.349905,
        LOCATION_LATITUDE_DEG: 51.8286911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029400',
        LOCATION_NAME: 'Blaen Cil Llech',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4422492,
        LOCATION_LATITUDE_DEG: 52.0613564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012000',
        LOCATION_NAME: 'Blaen y Pant',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0094828,
        LOCATION_LATITUDE_DEG: 51.5999851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012200',
        LOCATION_NAME: 'Blaenannerch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5556585,
        LOCATION_LATITUDE_DEG: 52.1153504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012300',
        LOCATION_NAME: 'Blaenau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.021775,
        LOCATION_LATITUDE_DEG: 51.8037184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012400',
        LOCATION_NAME: 'Blaenau Ffestiniog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9261657,
        LOCATION_LATITUDE_DEG: 52.9881341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012500',
        LOCATION_NAME: 'Blaenavon',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0843827,
        LOCATION_LATITUDE_DEG: 51.7719029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012600',
        LOCATION_NAME: 'Blaencelyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4182143,
        LOCATION_LATITUDE_DEG: 52.1662582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012100',
        LOCATION_NAME: 'Blaen-Cil-Llech',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4335115,
        LOCATION_LATITUDE_DEG: 52.057643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012700',
        LOCATION_NAME: 'Blaenclydach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4681289,
        LOCATION_LATITUDE_DEG: 51.6247944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012800',
        LOCATION_NAME: 'Blaencwm',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5586375,
        LOCATION_LATITUDE_DEG: 51.6767046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL012900',
        LOCATION_NAME: 'Blaencwrt',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1850005,
        LOCATION_LATITUDE_DEG: 52.1169506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013000',
        LOCATION_NAME: 'Blaenffos',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6370785,
        LOCATION_LATITUDE_DEG: 52.0027418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013100',
        LOCATION_NAME: 'Blaengarw',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5859153,
        LOCATION_LATITUDE_DEG: 51.6239997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013200',
        LOCATION_NAME: 'Blaengwrach',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6394171,
        LOCATION_LATITUDE_DEG: 51.7345091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013300',
        LOCATION_NAME: 'Blaengwynfi',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5994496,
        LOCATION_LATITUDE_DEG: 51.6551031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013400',
        LOCATION_NAME: 'Blaengwynlais',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2348094,
        LOCATION_LATITUDE_DEG: 51.5483882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013500',
        LOCATION_NAME: 'Blaenllechau',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4470194,
        LOCATION_LATITUDE_DEG: 51.6661003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013600',
        LOCATION_NAME: 'Blaenpennal',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.009215,
        LOCATION_LATITUDE_DEG: 52.2596646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013700',
        LOCATION_NAME: 'Blaenplwyf',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0896982,
        LOCATION_LATITUDE_DEG: 52.3595706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013800',
        LOCATION_NAME: 'Blaenporth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5384477,
        LOCATION_LATITUDE_DEG: 52.109157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL013900',
        LOCATION_NAME: 'Blaenrhondda',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5509457,
        LOCATION_LATITUDE_DEG: 51.6857005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014000',
        LOCATION_NAME: 'Blaenwaun',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5641218,
        LOCATION_LATITUDE_DEG: 51.9146387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014100',
        LOCATION_NAME: 'Blaenycoed',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4020332,
        LOCATION_LATITUDE_DEG: 51.916531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014200',
        LOCATION_NAME: 'Blaenymaes',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9761739,
        LOCATION_LATITUDE_DEG: 51.6535037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014300',
        LOCATION_NAME: 'Blagdon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6158135,
        LOCATION_LATITUDE_DEG: 50.4397873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014400',
        LOCATION_NAME: 'Blagdon',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7171451,
        LOCATION_LATITUDE_DEG: 51.3271557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014500',
        LOCATION_NAME: 'Blagdon Barton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6110658,
        LOCATION_LATITUDE_DEG: 50.4293832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014600',
        LOCATION_NAME: 'Blagdon Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1231408,
        LOCATION_LATITUDE_DEG: 50.9579248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014700',
        LOCATION_NAME: 'Blagill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4056154,
        LOCATION_LATITUDE_DEG: 54.820091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014800',
        LOCATION_NAME: 'Blagrove',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8356728,
        LOCATION_LATITUDE_DEG: 51.5452653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL014900',
        LOCATION_NAME: 'Blaich',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2134651,
        LOCATION_LATITUDE_DEG: 56.8434205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015000',
        LOCATION_NAME: 'Blaina',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1566389,
        LOCATION_LATITUDE_DEG: 51.7605041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015075',
        LOCATION_NAME: 'Blainslie',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7192889,
        LOCATION_LATITUDE_DEG: 55.6848768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015100',
        LOCATION_NAME: 'Blair Atholl',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8469929,
        LOCATION_LATITUDE_DEG: 56.7638039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015200',
        LOCATION_NAME: 'Blair Castle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8561735,
        LOCATION_LATITUDE_DEG: 56.7741009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015300',
        LOCATION_NAME: 'Blair Drummond',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0437762,
        LOCATION_LATITUDE_DEG: 56.1673471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015400',
        LOCATION_NAME: 'Blairadam',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3916636,
        LOCATION_LATITUDE_DEG: 56.1535393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015500',
        LOCATION_NAME: 'Blairdaff',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5042828,
        LOCATION_LATITUDE_DEG: 57.249131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030700',
        LOCATION_NAME: 'Blairdardie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3577898,
        LOCATION_LATITUDE_DEG: 55.9023624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030800',
        LOCATION_NAME: 'Blairdardie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3528676,
        LOCATION_LATITUDE_DEG: 55.9043082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015600',
        LOCATION_NAME: 'Blairforge',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3840741,
        LOCATION_LATITUDE_DEG: 56.1520339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015700',
        LOCATION_NAME: 'Blairgowrie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3374422,
        LOCATION_LATITUDE_DEG: 56.5928777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015800',
        LOCATION_NAME: 'Blairhall',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6037546,
        LOCATION_LATITUDE_DEG: 56.0863349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015900',
        LOCATION_NAME: 'Blairingone',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6341262,
        LOCATION_LATITUDE_DEG: 56.1529344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016000',
        LOCATION_NAME: 'Blairlogie',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8863611,
        LOCATION_LATITUDE_DEG: 56.1489366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016100',
        LOCATION_NAME: 'Blairmore',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8967487,
        LOCATION_LATITUDE_DEG: 56.0003378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016200',
        LOCATION_NAME: 'Blairmore',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8890685,
        LOCATION_LATITUDE_DEG: 57.5383764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016300',
        LOCATION_NAME: 'Blairs',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.187501,
        LOCATION_LATITUDE_DEG: 57.0889094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016500',
        LOCATION_NAME: 'Blaisdon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4323833,
        LOCATION_LATITUDE_DEG: 51.8508062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029500',
        LOCATION_NAME: 'Blaize Bailey',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016600',
        LOCATION_NAME: 'Blaize-Bailey',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4785377,
        LOCATION_LATITUDE_DEG: 51.8066023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016700',
        LOCATION_NAME: 'Blakebrook',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2631472,
        LOCATION_LATITUDE_DEG: 52.3876543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016800',
        LOCATION_NAME: 'Blakedown',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1771543,
        LOCATION_LATITUDE_DEG: 52.4032523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016900',
        LOCATION_NAME: 'Blakelands',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7411453,
        LOCATION_LATITUDE_DEG: 52.0727036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017000',
        LOCATION_NAME: 'Blakelaw',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6695351,
        LOCATION_LATITUDE_DEG: 54.9948004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017100',
        LOCATION_NAME: 'Blakeley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6129989,
        LOCATION_LATITUDE_DEG: 52.8202973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017200',
        LOCATION_NAME: 'Blakeley Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1652656,
        LOCATION_LATITUDE_DEG: 52.6085875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017300',
        LOCATION_NAME: 'Blakelow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4726362,
        LOCATION_LATITUDE_DEG: 53.0595261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017400',
        LOCATION_NAME: 'Blakemere',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9294966,
        LOCATION_LATITUDE_DEG: 52.0651327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017500',
        LOCATION_NAME: 'Blakeney',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4753704,
        LOCATION_LATITUDE_DEG: 51.7605934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017600',
        LOCATION_NAME: 'Blakeney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0242543,
        LOCATION_LATITUDE_DEG: 52.9514617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017700',
        LOCATION_NAME: 'Blakeney Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4868042,
        LOCATION_LATITUDE_DEG: 51.7619943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017900',
        LOCATION_NAME: 'Blakenhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4072952,
        LOCATION_LATITUDE_DEG: 53.0238158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL017800',
        LOCATION_NAME: 'Blakenhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1320496,
        LOCATION_LATITUDE_DEG: 52.5691683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018000',
        LOCATION_NAME: 'Blakenhall Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9862479,
        LOCATION_LATITUDE_DEG: 52.6151753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018100',
        LOCATION_NAME: 'Blakeshall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2493822,
        LOCATION_LATITUDE_DEG: 52.4275599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018200',
        LOCATION_NAME: 'Blakesley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0856558,
        LOCATION_LATITUDE_DEG: 52.1468164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018300',
        LOCATION_NAME: 'Blakeway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8246806,
        LOCATION_LATITUDE_DEG: 51.2043491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018500',
        LOCATION_NAME: 'Blanchland',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0538439,
        LOCATION_LATITUDE_DEG: 54.8478899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018600',
        LOCATION_NAME: 'Blandford Camp',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1208484,
        LOCATION_LATITUDE_DEG: 50.8686067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018700',
        LOCATION_NAME: 'Blandford Forum',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1559863,
        LOCATION_LATITUDE_DEG: 50.8615051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029300',
        LOCATION_NAME: 'Blandford St Mary',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018800',
        LOCATION_NAME: 'Blandford St. Mary',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1605506,
        LOCATION_LATITUDE_DEG: 50.8499063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018900',
        LOCATION_NAME: 'Blandy',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3649897,
        LOCATION_LATITUDE_DEG: 58.5072812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019000',
        LOCATION_NAME: 'Blanefield',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3146281,
        LOCATION_LATITUDE_DEG: 55.9878268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019100',
        LOCATION_NAME: 'Blaney East',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7453733,
        LOCATION_LATITUDE_DEG: 54.4211311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019200',
        LOCATION_NAME: 'Blankney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4041902,
        LOCATION_LATITUDE_DEG: 53.1281012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019300',
        LOCATION_NAME: 'Blankney Dales',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2723394,
        LOCATION_LATITUDE_DEG: 53.1577027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019400',
        LOCATION_NAME: 'Blankney Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3182547,
        LOCATION_LATITUDE_DEG: 53.1468065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019500',
        LOCATION_NAME: 'Blantyre',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.093614,
        LOCATION_LATITUDE_DEG: 55.7947055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019600',
        LOCATION_NAME: 'Blarmachfoldach',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1163094,
        LOCATION_LATITUDE_DEG: 56.7768157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019800',
        LOCATION_NAME: 'Blashaval',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2013385,
        LOCATION_LATITUDE_DEG: 57.6306229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019900',
        LOCATION_NAME: 'Blashford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7865811,
        LOCATION_LATITUDE_DEG: 50.8634018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020000',
        LOCATION_NAME: 'Blaston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8150672,
        LOCATION_LATITUDE_DEG: 52.5507519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020100',
        LOCATION_NAME: 'Blatchbridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3156271,
        LOCATION_LATITUDE_DEG: 51.2103456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020200',
        LOCATION_NAME: 'Blatherwycke',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5662682,
        LOCATION_LATITUDE_DEG: 52.5498522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020300',
        LOCATION_NAME: 'Blawith',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0933992,
        LOCATION_LATITUDE_DEG: 54.2856533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020400',
        LOCATION_NAME: 'Blaxhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4618465,
        LOCATION_LATITUDE_DEG: 52.1605803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020500',
        LOCATION_NAME: 'Blaxton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9870009,
        LOCATION_LATITUDE_DEG: 53.4957464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029700',
        LOCATION_NAME: 'Blaydon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7186716,
        LOCATION_LATITUDE_DEG: 54.9673689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020600',
        LOCATION_NAME: 'Blaydon Burn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.740233,
        LOCATION_LATITUDE_DEG: 54.9546998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029600',
        LOCATION_NAME: 'Blaydon on Tyne',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020700',
        LOCATION_NAME: 'Blaydon-on-Tyne',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.718348,
        LOCATION_LATITUDE_DEG: 54.9577967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020900',
        LOCATION_NAME: 'Bleadney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7384642,
        LOCATION_LATITUDE_DEG: 51.202146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021000',
        LOCATION_NAME: 'Bleadon',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9456401,
        LOCATION_LATITUDE_DEG: 51.3065585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021100',
        LOCATION_NAME: 'Bleak Hall',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7476452,
        LOCATION_LATITUDE_DEG: 52.0177046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021200',
        LOCATION_NAME: 'Bleak Hey Nook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9930968,
        LOCATION_LATITUDE_DEG: 53.5797655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021300',
        LOCATION_NAME: 'Blean',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0449522,
        LOCATION_LATITUDE_DEG: 51.3061044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021400',
        LOCATION_NAME: 'Bleasby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9327888,
        LOCATION_LATITUDE_DEG: 53.0386056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021500',
        LOCATION_NAME: 'Bleasby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2966431,
        LOCATION_LATITUDE_DEG: 53.3472227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021600',
        LOCATION_NAME: 'Bleasby Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3059906,
        LOCATION_LATITUDE_DEG: 53.3354249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021700',
        LOCATION_NAME: 'Bleasdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6489404,
        LOCATION_LATITUDE_DEG: 53.9022039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021800',
        LOCATION_NAME: 'Bleatarn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4125292,
        LOCATION_LATITUDE_DEG: 54.5189679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL990084',
        LOCATION_NAME: 'Bleathwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6542215,
        LOCATION_LATITUDE_DEG: 52.3231705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL021900',
        LOCATION_NAME: 'Blebo Craigs',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9224649,
        LOCATION_LATITUDE_DEG: 56.3256077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL990862',
        LOCATION_NAME: 'Blebocraigs',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022000',
        LOCATION_NAME: 'Bleddfa',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1634816,
        LOCATION_LATITUDE_DEG: 52.3070596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022100',
        LOCATION_NAME: 'Bledington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6451376,
        LOCATION_LATITUDE_DEG: 51.9024997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022200',
        LOCATION_NAME: 'Bledlow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8747962,
        LOCATION_LATITUDE_DEG: 51.7119707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022300',
        LOCATION_NAME: 'Bledlow Ridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8446222,
        LOCATION_LATITUDE_DEG: 51.6701679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022400',
        LOCATION_NAME: 'Blencarn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5610457,
        LOCATION_LATITUDE_DEG: 54.6739787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022500',
        LOCATION_NAME: 'Blencogo',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2448759,
        LOCATION_LATITUDE_DEG: 54.8226005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022600',
        LOCATION_NAME: 'Blencow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8436594,
        LOCATION_LATITUDE_DEG: 54.684789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022700',
        LOCATION_NAME: 'Blendworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9946098,
        LOCATION_LATITUDE_DEG: 50.9131031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022800',
        LOCATION_NAME: 'Blennerhasset',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2768657,
        LOCATION_LATITUDE_DEG: 54.7618939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023100',
        LOCATION_NAME: 'Bletchingdon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2703252,
        LOCATION_LATITUDE_DEG: 51.8541937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023200',
        LOCATION_NAME: 'Bletchingley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1003431,
        LOCATION_LATITUDE_DEG: 51.2401217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023300',
        LOCATION_NAME: 'Bletchley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5638856,
        LOCATION_LATITUDE_DEG: 52.8990102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023400',
        LOCATION_NAME: 'Bletchley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7329473,
        LOCATION_LATITUDE_DEG: 51.9937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023500',
        LOCATION_NAME: 'Bletsoe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5025454,
        LOCATION_LATITUDE_DEG: 52.2133132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023600',
        LOCATION_NAME: 'Blewbury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.229065,
        LOCATION_LATITUDE_DEG: 51.5701673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023700',
        LOCATION_NAME: 'Blickling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2329286,
        LOCATION_LATITUDE_DEG: 52.8088456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023800',
        LOCATION_NAME: 'Blicks Hill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0894966,
        LOCATION_LATITUDE_DEG: 51.5853804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023900',
        LOCATION_NAME: 'Blidworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1211981,
        LOCATION_LATITUDE_DEG: 53.0949072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024000',
        LOCATION_NAME: 'Blindbothel',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3513139,
        LOCATION_LATITUDE_DEG: 54.6365877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024100',
        LOCATION_NAME: 'Blindcrake',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.320229,
        LOCATION_LATITUDE_DEG: 54.6996883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024200',
        LOCATION_NAME: 'Blindley Heath',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0498823,
        LOCATION_LATITUDE_DEG: 51.1936108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024300',
        LOCATION_NAME: 'Blindmoor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0489065,
        LOCATION_LATITUDE_DEG: 50.9269214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024400',
        LOCATION_NAME: 'Blisland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6781336,
        LOCATION_LATITUDE_DEG: 50.5265993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024500',
        LOCATION_NAME: 'Bliss Gate',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3709036,
        LOCATION_LATITUDE_DEG: 52.3503575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024600',
        LOCATION_NAME: 'Blissford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7515898,
        LOCATION_LATITUDE_DEG: 50.9203062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024700',
        LOCATION_NAME: 'Blisworth',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9388972,
        LOCATION_LATITUDE_DEG: 52.1743164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024800',
        LOCATION_NAME: 'Blithbury',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8776822,
        LOCATION_LATITUDE_DEG: 52.778186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024900',
        LOCATION_NAME: 'Blitterlees',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3876226,
        LOCATION_LATITUDE_DEG: 54.8552082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025000',
        LOCATION_NAME: 'Blo Norton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9577011,
        LOCATION_LATITUDE_DEG: 52.3747137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025100',
        LOCATION_NAME: 'Blockley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7586401,
        LOCATION_LATITUDE_DEG: 52.0132158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025200',
        LOCATION_NAME: 'Blofield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4535417,
        LOCATION_LATITUDE_DEG: 52.6332305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029800',
        LOCATION_NAME: 'Bloomfield',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.888162,
        LOCATION_LATITUDE_DEG: 54.5942453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025300',
        LOCATION_NAME: 'Bloomfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0718601,
        LOCATION_LATITUDE_DEG: 52.5326631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025400',
        LOCATION_NAME: 'Bloomsbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3353183,
        LOCATION_LATITUDE_DEG: 52.7304935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025500',
        LOCATION_NAME: 'Blore',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7947613,
        LOCATION_LATITUDE_DEG: 53.041813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025600',
        LOCATION_NAME: 'Blore Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4431424,
        LOCATION_LATITUDE_DEG: 52.9119108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025700',
        LOCATION_NAME: 'Blowinghouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2371271,
        LOCATION_LATITUDE_DEG: 50.229884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025800',
        LOCATION_NAME: 'Bloxham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3731135,
        LOCATION_LATITUDE_DEG: 52.018512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL025900',
        LOCATION_NAME: 'Bloxham Grove',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.333551,
        LOCATION_LATITUDE_DEG: 52.0269091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026000',
        LOCATION_NAME: 'Bloxholm',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4099552,
        LOCATION_LATITUDE_DEG: 53.0686937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026100',
        LOCATION_NAME: 'Bloxwich',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0029099,
        LOCATION_LATITUDE_DEG: 52.6155717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026200',
        LOCATION_NAME: 'Bloxworth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1653246,
        LOCATION_LATITUDE_DEG: 50.7494952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026300',
        LOCATION_NAME: 'Blubberhouses',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7438575,
        LOCATION_LATITUDE_DEG: 53.9935006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026400',
        LOCATION_NAME: 'Blucher',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7231373,
        LOCATION_LATITUDE_DEG: 54.9881038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026600',
        LOCATION_NAME: 'Blue Anchor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9372821,
        LOCATION_LATITUDE_DEG: 50.3823953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026700',
        LOCATION_NAME: 'Blue Anchor',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0938588,
        LOCATION_LATITUDE_DEG: 51.6348074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026500',
        LOCATION_NAME: 'Blue Anchor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4022746,
        LOCATION_LATITUDE_DEG: 51.1787518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026900',
        LOCATION_NAME: 'Blue Bell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5940321,
        LOCATION_LATITUDE_DEG: 52.6884908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027000',
        LOCATION_NAME: 'Blue Bell Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5027207,
        LOCATION_LATITUDE_DEG: 51.3314228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027100',
        LOCATION_NAME: 'Blue Bridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7949512,
        LOCATION_LATITUDE_DEG: 52.0563068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027200',
        LOCATION_NAME: 'Blue Hills',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1908279,
        LOCATION_LATITUDE_DEG: 50.3175905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027300',
        LOCATION_NAME: 'Blue Town',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7570653,
        LOCATION_LATITUDE_DEG: 51.4385235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030200',
        LOCATION_NAME: 'Blundellsands',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0397743,
        LOCATION_LATITUDE_DEG: 53.4889628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027500',
        LOCATION_NAME: 'Blundeston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7070886,
        LOCATION_LATITUDE_DEG: 52.518716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027600',
        LOCATION_NAME: 'Blunham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3201889,
        LOCATION_LATITUDE_DEG: 52.1465083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027700',
        LOCATION_NAME: 'Blunsdon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7995022,
        LOCATION_LATITUDE_DEG: 51.6074725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027800',
        LOCATION_NAME: 'Bluntisham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0100892,
        LOCATION_LATITUDE_DEG: 52.3544234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027900',
        LOCATION_NAME: 'Blunts',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3339749,
        LOCATION_LATITUDE_DEG: 50.4428956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028000',
        LOCATION_NAME: 'Blyborough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5831518,
        LOCATION_LATITUDE_DEG: 53.4372317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028100',
        LOCATION_NAME: 'Blyborough Grange',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5667689,
        LOCATION_LATITUDE_DEG: 53.4368385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028200',
        LOCATION_NAME: 'Blyford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5607679,
        LOCATION_LATITUDE_DEG: 52.3348027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028300',
        LOCATION_NAME: 'Blymhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2825835,
        LOCATION_LATITUDE_DEG: 52.7082891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028400',
        LOCATION_NAME: 'Blymhill Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3154365,
        LOCATION_LATITUDE_DEG: 52.7131871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028500',
        LOCATION_NAME: 'Blymhill Lawn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2660262,
        LOCATION_LATITUDE_DEG: 52.6996873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028600',
        LOCATION_NAME: 'Blyth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5072292,
        LOCATION_LATITUDE_DEG: 55.1270108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028700',
        LOCATION_NAME: 'Blyth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0605969,
        LOCATION_LATITUDE_DEG: 53.3772312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028800',
        LOCATION_NAME: 'Blyth Bridge',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3798612,
        LOCATION_LATITUDE_DEG: 55.6940943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL028900',
        LOCATION_NAME: 'Blythburgh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5977886,
        LOCATION_LATITUDE_DEG: 52.3197994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029000',
        LOCATION_NAME: 'Blythe Bridge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0612602,
        LOCATION_LATITUDE_DEG: 52.9663037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029100',
        LOCATION_NAME: 'Blyton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7159514,
        LOCATION_LATITUDE_DEG: 53.443534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL029200',
        LOCATION_NAME: 'Blyton Carr',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7683017,
        LOCATION_LATITUDE_DEG: 53.440642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000200',
        LOCATION_NAME: 'Boarhills',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7036755,
        LOCATION_LATITUDE_DEG: 56.3171414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000300',
        LOCATION_NAME: 'Boarhunt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1416905,
        LOCATION_LATITUDE_DEG: 50.8701002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000400',
        LOCATION_NAME: 'Boars Head',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1872898,
        LOCATION_LATITUDE_DEG: 51.0702123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000500',
        LOCATION_NAME: 'Boars Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2902358,
        LOCATION_LATITUDE_DEG: 51.7154754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000600',
        LOCATION_NAME: 'Boarstall',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.09556,
        LOCATION_LATITUDE_DEG: 51.8195826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000700',
        LOCATION_NAME: 'Boasley Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1251527,
        LOCATION_LATITUDE_DEG: 50.7227155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000800',
        LOCATION_NAME: 'Boat of Garten',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7560957,
        LOCATION_LATITUDE_DEG: 57.2491482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000900',
        LOCATION_NAME: 'Bobbing',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7139907,
        LOCATION_LATITUDE_DEG: 51.3550223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001000',
        LOCATION_NAME: 'Bobbington',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2813956,
        LOCATION_LATITUDE_DEG: 52.511869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001050',
        LOCATION_NAME: 'Bobbingworth',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2186633,
        LOCATION_LATITUDE_DEG: 51.7265617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001100',
        LOCATION_NAME: 'Bobblestock',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7346414,
        LOCATION_LATITUDE_DEG: 52.0750326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001300',
        LOCATION_NAME: 'Bocaddon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5619941,
        LOCATION_LATITUDE_DEG: 50.3939894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001400',
        LOCATION_NAME: 'Bockhampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3712419,
        LOCATION_LATITUDE_DEG: 50.7178942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001500',
        LOCATION_NAME: 'Bockhampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7514933,
        LOCATION_LATITUDE_DEG: 50.767299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001600',
        LOCATION_NAME: 'Bocking',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5574718,
        LOCATION_LATITUDE_DEG: 51.883871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001700',
        LOCATION_NAME: 'Bockleton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5974955,
        LOCATION_LATITUDE_DEG: 52.2493457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001800',
        LOCATION_NAME: 'Boconnoc',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6082101,
        LOCATION_LATITUDE_DEG: 50.4157934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001900',
        LOCATION_NAME: 'Boddam',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7801786,
        LOCATION_LATITUDE_DEG: 57.4716438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002000',
        LOCATION_NAME: 'Bodden',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5146531,
        LOCATION_LATITUDE_DEG: 51.193542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002100',
        LOCATION_NAME: 'Boddington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.154121,
        LOCATION_LATITUDE_DEG: 51.9256112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002200',
        LOCATION_NAME: 'Bodedern',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5017666,
        LOCATION_LATITUDE_DEG: 53.2946719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002300',
        LOCATION_NAME: 'Bodelva',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7391524,
        LOCATION_LATITUDE_DEG: 50.3611894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002400',
        LOCATION_NAME: 'Bodelwyddan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4954999,
        LOCATION_LATITUDE_DEG: 53.2663512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002500',
        LOCATION_NAME: 'Bodenham',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6863602,
        LOCATION_LATITUDE_DEG: 52.1562401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002700',
        LOCATION_NAME: 'Bodenham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7632205,
        LOCATION_LATITUDE_DEG: 51.0339161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002800',
        LOCATION_NAME: 'Bodenham Moor',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6656157,
        LOCATION_LATITUDE_DEG: 52.1513416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003000',
        LOCATION_NAME: 'Bodfari',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.359669,
        LOCATION_LATITUDE_DEG: 53.2196443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003100',
        LOCATION_NAME: 'Bodffordd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3607315,
        LOCATION_LATITUDE_DEG: 53.2663641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003200',
        LOCATION_NAME: 'Bodham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1638242,
        LOCATION_LATITUDE_DEG: 52.9156622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003300',
        LOCATION_NAME: 'Bodiam',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5396267,
        LOCATION_LATITUDE_DEG: 51.0055882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003400',
        LOCATION_NAME: 'Bodicote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3290915,
        LOCATION_LATITUDE_DEG: 52.0356058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003500',
        LOCATION_NAME: 'Bodicote Chase',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3255638,
        LOCATION_LATITUDE_DEG: 52.0481653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003600',
        LOCATION_NAME: 'Bodieve',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8327296,
        LOCATION_LATITUDE_DEG: 50.5260058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003700',
        LOCATION_NAME: 'Bodinnick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6287637,
        LOCATION_LATITUDE_DEG: 50.3391884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003800',
        LOCATION_NAME: 'Bodle Street',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3436089,
        LOCATION_LATITUDE_DEG: 50.9079814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO003900',
        LOCATION_NAME: 'Bodle Street Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3481982,
        LOCATION_LATITUDE_DEG: 50.9058833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004000',
        LOCATION_NAME: 'Bodmin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7170985,
        LOCATION_LATITUDE_DEG: 50.4705956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004100',
        LOCATION_NAME: 'Bodney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.699671,
        LOCATION_LATITUDE_DEG: 52.5564305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004200',
        LOCATION_NAME: 'Bodorgan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4142937,
        LOCATION_LATITUDE_DEG: 53.2006557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004300',
        LOCATION_NAME: 'Bodrean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0205137,
        LOCATION_LATITUDE_DEG: 50.2905837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004400',
        LOCATION_NAME: 'Bodsham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0184462,
        LOCATION_LATITUDE_DEG: 51.1717942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004500',
        LOCATION_NAME: 'Boduan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4938202,
        LOCATION_LATITUDE_DEG: 52.9119315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004600',
        LOCATION_NAME: 'Bodwen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7704867,
        LOCATION_LATITUDE_DEG: 50.4101956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004800',
        LOCATION_NAME: 'Bodymoor Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7159375,
        LOCATION_LATITUDE_DEG: 52.5597665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005100',
        LOCATION_NAME: 'Bogach',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4148383,
        LOCATION_LATITUDE_DEG: 56.9957565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005200',
        LOCATION_NAME: 'Bogallan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2758667,
        LOCATION_LATITUDE_DEG: 57.5233851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005300',
        LOCATION_NAME: 'Bogend',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.54064,
        LOCATION_LATITUDE_DEG: 55.555887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005500',
        LOCATION_NAME: 'Boghall',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6071828,
        LOCATION_LATITUDE_DEG: 55.8998174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005600',
        LOCATION_NAME: 'Boghead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9397518,
        LOCATION_LATITUDE_DEG: 55.6550929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005700',
        LOCATION_NAME: 'Bogindollo',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8582903,
        LOCATION_LATITUDE_DEG: 56.687983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005800',
        LOCATION_NAME: 'Bogmoor',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0768703,
        LOCATION_LATITUDE_DEG: 57.651683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005900',
        LOCATION_NAME: 'Bognor Regis',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.672866,
        LOCATION_LATITUDE_DEG: 50.7922836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006000',
        LOCATION_NAME: 'Bograxie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.481523,
        LOCATION_LATITUDE_DEG: 57.267934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006100',
        LOCATION_NAME: 'Bogroy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8307533,
        LOCATION_LATITUDE_DEG: 57.2760823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006200',
        LOCATION_NAME: 'Bogside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8644154,
        LOCATION_LATITUDE_DEG: 55.7644033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006300',
        LOCATION_NAME: 'Boharm',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1071894,
        LOCATION_LATITUDE_DEG: 57.5135681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007400',
        LOCATION_NAME: 'Bohetherick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2373409,
        LOCATION_LATITUDE_DEG: 50.4855977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007450',
        LOCATION_NAME: 'Boho',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.8085794,
        LOCATION_LATITUDE_DEG: 54.3463435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007700',
        LOCATION_NAME: 'Bohortha',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9932383,
        LOCATION_LATITUDE_DEG: 50.1503745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007800',
        LOCATION_NAME: 'Bokiddick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7417769,
        LOCATION_LATITUDE_DEG: 50.4261966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008000',
        LOCATION_NAME: 'Bolam',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8547938,
        LOCATION_LATITUDE_DEG: 55.1372131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007900',
        LOCATION_NAME: 'Bolam',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6920783,
        LOCATION_LATITUDE_DEG: 54.5975642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO990549',
        LOCATION_NAME: 'Bolas Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008100',
        LOCATION_NAME: 'Bolbeck Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7348529,
        LOCATION_LATITUDE_DEG: 52.0630056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008200',
        LOCATION_NAME: 'Bolberry',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8359145,
        LOCATION_LATITUDE_DEG: 50.2377651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008300',
        LOCATION_NAME: 'Bold',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6867863,
        LOCATION_LATITUDE_DEG: 53.3959605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008400',
        LOCATION_NAME: 'Bold Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6995503,
        LOCATION_LATITUDE_DEG: 53.3974596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008500',
        LOCATION_NAME: 'Boldon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4377856,
        LOCATION_LATITUDE_DEG: 54.9455889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008600',
        LOCATION_NAME: 'Boldon Colliery',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.46831,
        LOCATION_LATITUDE_DEG: 54.9502919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008700',
        LOCATION_NAME: 'Boldre',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5337662,
        LOCATION_LATITUDE_DEG: 50.7823978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008800',
        LOCATION_NAME: 'Boldron',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9466446,
        LOCATION_LATITUDE_DEG: 54.5241626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO008900',
        LOCATION_NAME: 'Bole',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8080882,
        LOCATION_LATITUDE_DEG: 53.3742308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009000',
        LOCATION_NAME: 'Bolehall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6821856,
        LOCATION_LATITUDE_DEG: 52.6308704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009100',
        LOCATION_NAME: 'Bolehill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.568017,
        LOCATION_LATITUDE_DEG: 53.0920183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009200',
        LOCATION_NAME: 'Boleside',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7934866,
        LOCATION_LATITUDE_DEG: 55.596477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009400',
        LOCATION_NAME: 'Bolham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4923396,
        LOCATION_LATITUDE_DEG: 50.9228331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009500',
        LOCATION_NAME: 'Bolham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9417496,
        LOCATION_LATITUDE_DEG: 53.3354306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009600',
        LOCATION_NAME: 'Bolingey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1429994,
        LOCATION_LATITUDE_DEG: 50.3367892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009800',
        LOCATION_NAME: 'Bollington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4111505,
        LOCATION_LATITUDE_DEG: 53.375149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009900',
        LOCATION_NAME: 'Bollow',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3753285,
        LOCATION_LATITUDE_DEG: 51.8186038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010000',
        LOCATION_NAME: 'Bolney',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2012969,
        LOCATION_LATITUDE_DEG: 50.9947949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010100',
        LOCATION_NAME: 'Bolnhurst',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4075926,
        LOCATION_LATITUDE_DEG: 52.216719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010200',
        LOCATION_NAME: 'Bolsover',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2878233,
        LOCATION_LATITUDE_DEG: 53.2283201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010250',
        LOCATION_NAME: 'Bolster Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.870942,
        LOCATION_LATITUDE_DEG: 53.6384322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010300',
        LOCATION_NAME: 'Bolsterstone',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5916407,
        LOCATION_LATITUDE_DEG: 53.4667541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010400',
        LOCATION_NAME: 'Bolstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6529092,
        LOCATION_LATITUDE_DEG: 51.9900193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010500',
        LOCATION_NAME: 'Boltby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2441518,
        LOCATION_LATITUDE_DEG: 54.2726281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010600',
        LOCATION_NAME: 'Bolter End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8491769,
        LOCATION_LATITUDE_DEG: 51.6279649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010800',
        LOCATION_NAME: 'Bolton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5571492,
        LOCATION_LATITUDE_DEG: 54.6045742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010900',
        LOCATION_NAME: 'Bolton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4268653,
        LOCATION_LATITUDE_DEG: 53.578375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010700',
        LOCATION_NAME: 'Bolton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8319377,
        LOCATION_LATITUDE_DEG: 55.4165481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO010950',
        LOCATION_NAME: 'Bolton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8246048,
        LOCATION_LATITUDE_DEG: 53.9607344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011000',
        LOCATION_NAME: 'Bolton Abbey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8898317,
        LOCATION_LATITUDE_DEG: 53.9814084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011400',
        LOCATION_NAME: 'Bolton by Bowland',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3271454,
        LOCATION_LATITUDE_DEG: 53.9399078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011500',
        LOCATION_NAME: 'Bolton le Sands',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7918749,
        LOCATION_LATITUDE_DEG: 54.1080656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011100',
        LOCATION_NAME: 'Bolton Low Houses',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1853773,
        LOCATION_LATITUDE_DEG: 54.7885018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011200',
        LOCATION_NAME: 'Bolton New Houses',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1680977,
        LOCATION_LATITUDE_DEG: 54.7868987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011600',
        LOCATION_NAME: 'Bolton on Swale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6127417,
        LOCATION_LATITUDE_DEG: 54.3871421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011300',
        LOCATION_NAME: 'Bolton Percy',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1911343,
        LOCATION_LATITUDE_DEG: 53.8661843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041100',
        LOCATION_NAME: 'Bolton upon Dearne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011800',
        LOCATION_NAME: 'Boltongate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1980384,
        LOCATION_LATITUDE_DEG: 54.755894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011700',
        LOCATION_NAME: 'Bolton-upon-Dearne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3130178,
        LOCATION_LATITUDE_DEG: 53.5144888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO011900',
        LOCATION_NAME: 'Bolventor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5623629,
        LOCATION_LATITUDE_DEG: 50.5603044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012000',
        LOCATION_NAME: 'Bomere Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7796411,
        LOCATION_LATITUDE_DEG: 52.7725948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012100',
        LOCATION_NAME: 'Bonar Bridge',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3411537,
        LOCATION_LATITUDE_DEG: 57.8935218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012200',
        LOCATION_NAME: 'Bonawe',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2290337,
        LOCATION_LATITUDE_DEG: 56.4511875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012300',
        LOCATION_NAME: 'Bonby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.483267,
        LOCATION_LATITUDE_DEG: 53.6247482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012400',
        LOCATION_NAME: 'Boncath',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6162117,
        LOCATION_LATITUDE_DEG: 52.0137483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012500',
        LOCATION_NAME: 'Bonchester Bridge',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6541291,
        LOCATION_LATITUDE_DEG: 55.4000506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012600',
        LOCATION_NAME: 'Bonchurch',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1849421,
        LOCATION_LATITUDE_DEG: 50.5997759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012700',
        LOCATION_NAME: 'Bondleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9144765,
        LOCATION_LATITUDE_DEG: 50.825622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012800',
        LOCATION_NAME: 'Bonehill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7150906,
        LOCATION_LATITUDE_DEG: 52.6198684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO000100',
        LOCATION_NAME: "Bo'ness",
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6138804,
        LOCATION_LATITUDE_DEG: 56.0140282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO012900',
        LOCATION_NAME: 'Bonhill',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5591588,
        LOCATION_LATITUDE_DEG: 55.9793327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013000',
        LOCATION_NAME: 'Boningale',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2802783,
        LOCATION_LATITUDE_DEG: 52.6210752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013100',
        LOCATION_NAME: 'Bonjedward',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5451018,
        LOCATION_LATITUDE_DEG: 55.5044623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013200',
        LOCATION_NAME: 'Bonkle',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8568388,
        LOCATION_LATITUDE_DEG: 55.791805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013300',
        LOCATION_NAME: 'Bonnie View',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2075955,
        LOCATION_LATITUDE_DEG: 51.6633926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013400',
        LOCATION_NAME: 'Bonningate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7997091,
        LOCATION_LATITUDE_DEG: 54.3494488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013500',
        LOCATION_NAME: 'Bonnington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9367933,
        LOCATION_LATITUDE_DEG: 51.0836935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013600',
        LOCATION_NAME: 'Bonnybank',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0369395,
        LOCATION_LATITUDE_DEG: 56.2201335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013700',
        LOCATION_NAME: 'Bonnybridge',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.885353,
        LOCATION_LATITUDE_DEG: 56.0013238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013800',
        LOCATION_NAME: 'Bonnykelly',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2299172,
        LOCATION_LATITUDE_DEG: 57.5710651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO013900',
        LOCATION_NAME: 'Bonnyrigg',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1056621,
        LOCATION_LATITUDE_DEG: 55.876603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014000',
        LOCATION_NAME: 'Bonnyton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5120025,
        LOCATION_LATITUDE_DEG: 55.6125989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014100',
        LOCATION_NAME: 'Bonsall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5828667,
        LOCATION_LATITUDE_DEG: 53.1208217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014200',
        LOCATION_NAME: 'Bonsdale',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6720992,
        LOCATION_LATITUDE_DEG: 53.4349364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014300',
        LOCATION_NAME: 'Bont Dolgadfan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6437286,
        LOCATION_LATITUDE_DEG: 52.5878913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014400',
        LOCATION_NAME: 'Bontddu',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9657073,
        LOCATION_LATITUDE_DEG: 52.751109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014500',
        LOCATION_NAME: 'Bontgoch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.941069,
        LOCATION_LATITUDE_DEG: 52.4593683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014600',
        LOCATION_NAME: 'Bonthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2211985,
        LOCATION_LATITUDE_DEG: 53.2324048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014700',
        LOCATION_NAME: 'Bontnewydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2670105,
        LOCATION_LATITUDE_DEG: 53.11435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014800',
        LOCATION_NAME: 'Bontnewydd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0256307,
        LOCATION_LATITUDE_DEG: 52.2725674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO014900',
        LOCATION_NAME: 'Bontnewydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8207406,
        LOCATION_LATITUDE_DEG: 52.763809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015000',
        LOCATION_NAME: 'Bontuchel',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3689733,
        LOCATION_LATITUDE_DEG: 53.10924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015100',
        LOCATION_NAME: 'Bonvilston',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3517576,
        LOCATION_LATITUDE_DEG: 51.4562782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015200',
        LOCATION_NAME: 'Bonymaen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9095757,
        LOCATION_LATITUDE_DEG: 51.6407199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015300',
        LOCATION_NAME: 'Boode',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1424092,
        LOCATION_LATITUDE_DEG: 51.1206572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015400',
        LOCATION_NAME: 'Booker',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7814719,
        LOCATION_LATITUDE_DEG: 51.6159598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015500',
        LOCATION_NAME: 'Bookham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3651447,
        LOCATION_LATITUDE_DEG: 51.2828295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015700',
        LOCATION_NAME: 'Booley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.636044,
        LOCATION_LATITUDE_DEG: 52.8261997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016100',
        LOCATION_NAME: 'Boosbeck',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9796588,
        LOCATION_LATITUDE_DEG: 54.5423504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016200',
        LOCATION_NAME: 'Boot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2687743,
        LOCATION_LATITUDE_DEG: 54.3985622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016400',
        LOCATION_NAME: 'Boothby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7018428,
        LOCATION_LATITUDE_DEG: 54.9580119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016500',
        LOCATION_NAME: 'Boothby Graffoe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5245136,
        LOCATION_LATITUDE_DEG: 53.1183069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016600',
        LOCATION_NAME: 'Boothby Pagnell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5566757,
        LOCATION_LATITUDE_DEG: 52.865784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016700',
        LOCATION_NAME: 'Boothfold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2454339,
        LOCATION_LATITUDE_DEG: 53.6946846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016800',
        LOCATION_NAME: 'Boothorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5262183,
        LOCATION_LATITUDE_DEG: 52.7538825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016900',
        LOCATION_NAME: 'Boothstown',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4218783,
        LOCATION_LATITUDE_DEG: 53.5037621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017000',
        LOCATION_NAME: 'Boothtown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8631056,
        LOCATION_LATITUDE_DEG: 53.7367832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017100',
        LOCATION_NAME: 'Bootle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3702008,
        LOCATION_LATITUDE_DEG: 54.2813516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017200',
        LOCATION_NAME: 'Bootle',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9894238,
        LOCATION_LATITUDE_DEG: 53.4518664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO042400',
        LOCATION_NAME: 'Bootle 10',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9889611,
        LOCATION_LATITUDE_DEG: 53.4488047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041600',
        LOCATION_NAME: 'Bootle 20',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041700',
        LOCATION_NAME: 'Bootle 21',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017300',
        LOCATION_NAME: 'Bootle Station',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3920471,
        LOCATION_LATITUDE_DEG: 54.2909535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017400',
        LOCATION_NAME: 'Booton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1271998,
        LOCATION_LATITUDE_DEG: 52.7606484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017500',
        LOCATION_NAME: 'Booze',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9715216,
        LOCATION_LATITUDE_DEG: 54.4138522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017600',
        LOCATION_NAME: 'Boquhan',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3498556,
        LOCATION_LATITUDE_DEG: 56.0596348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017700',
        LOCATION_NAME: 'Boraston',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5658121,
        LOCATION_LATITUDE_DEG: 52.326756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO990186',
        LOCATION_NAME: 'BORDE HILL',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1271991,
        LOCATION_LATITUDE_DEG: 51.0209639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017800',
        LOCATION_NAME: 'Bordean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.010806,
        LOCATION_LATITUDE_DEG: 51.0174054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO017900',
        LOCATION_NAME: 'Borden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7022981,
        LOCATION_LATITUDE_DEG: 51.3338128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018000',
        LOCATION_NAME: 'Bordesley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8796473,
        LOCATION_LATITUDE_DEG: 52.4790555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018100',
        LOCATION_NAME: 'Bordesley Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8532388,
        LOCATION_LATITUDE_DEG: 52.4762565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018200',
        LOCATION_NAME: 'Bordley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0895477,
        LOCATION_LATITUDE_DEG: 54.0799144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018300',
        LOCATION_NAME: 'Bordon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8608679,
        LOCATION_LATITUDE_DEG: 51.1132151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018400',
        LOCATION_NAME: 'Boreham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1593233,
        LOCATION_LATITUDE_DEG: 51.1977398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018500',
        LOCATION_NAME: 'Boreham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.542636,
        LOCATION_LATITUDE_DEG: 51.75716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018600',
        LOCATION_NAME: 'Boreham Street',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3689938,
        LOCATION_LATITUDE_DEG: 50.876679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018700',
        LOCATION_NAME: 'Borehamwood',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2695677,
        LOCATION_LATITUDE_DEG: 51.6574636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018800',
        LOCATION_NAME: 'Boreland',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3017381,
        LOCATION_LATITUDE_DEG: 55.2077416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO018900',
        LOCATION_NAME: 'Boresford',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9588599,
        LOCATION_LATITUDE_DEG: 52.2784524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019000',
        LOCATION_NAME: 'Boreton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7201254,
        LOCATION_LATITUDE_DEG: 52.6542828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019100',
        LOCATION_NAME: 'Borgue',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1324307,
        LOCATION_LATITUDE_DEG: 54.8116077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019300',
        LOCATION_NAME: 'Borley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6955892,
        LOCATION_LATITUDE_DEG: 52.0543828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019400',
        LOCATION_NAME: 'Borness',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1494413,
        LOCATION_LATITUDE_DEG: 54.7887076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019500',
        LOCATION_NAME: 'Bornish',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4087185,
        LOCATION_LATITUDE_DEG: 57.2396875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041400',
        LOCATION_NAME: 'Borough',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.093817,
        LOCATION_LATITUDE_DEG: 51.5024906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019700',
        LOCATION_NAME: 'Borough Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3064367,
        LOCATION_LATITUDE_DEG: 51.291121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019800',
        LOCATION_NAME: 'Boroughbridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3940369,
        LOCATION_LATITUDE_DEG: 54.0940082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019900',
        LOCATION_NAME: 'Borras',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9501271,
        LOCATION_LATITUDE_DEG: 53.0735734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020000',
        LOCATION_NAME: 'Borreraig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.693488,
        LOCATION_LATITUDE_DEG: 57.4851033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020400',
        LOCATION_NAME: 'Borrisdale',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9804062,
        LOCATION_LATITUDE_DEG: 57.7396323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020900',
        LOCATION_NAME: 'Borrowash',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3799141,
        LOCATION_LATITUDE_DEG: 52.9062912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021100',
        LOCATION_NAME: 'Borrowby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3430097,
        LOCATION_LATITUDE_DEG: 54.2978267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021000',
        LOCATION_NAME: 'Borrowby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8093228,
        LOCATION_LATITUDE_DEG: 54.5296479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021200',
        LOCATION_NAME: 'Borrowdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1633734,
        LOCATION_LATITUDE_DEG: 54.5390729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021300',
        LOCATION_NAME: 'Borrowfield',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2791621,
        LOCATION_LATITUDE_DEG: 57.030413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021400',
        LOCATION_NAME: 'Borsam',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.909409,
        LOCATION_LATITUDE_DEG: 57.7665324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO990655',
        LOCATION_NAME: 'Borstal',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021500',
        LOCATION_NAME: 'Borth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0497842,
        LOCATION_LATITUDE_DEG: 52.4849878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041000',
        LOCATION_NAME: 'Borth y Gest',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021700',
        LOCATION_NAME: 'Borthwick',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0090224,
        LOCATION_LATITUDE_DEG: 55.8263988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021800',
        LOCATION_NAME: 'Borthwickshiels',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.892309,
        LOCATION_LATITUDE_DEG: 55.4302599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021900',
        LOCATION_NAME: 'Borthwood',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1878412,
        LOCATION_LATITUDE_DEG: 50.6562786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO021600',
        LOCATION_NAME: 'Borth-y-Gest',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1353976,
        LOCATION_LATITUDE_DEG: 52.9155275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022000',
        LOCATION_NAME: 'Borve',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1794851,
        LOCATION_LATITUDE_DEG: 57.7123254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022100',
        LOCATION_NAME: 'Borve',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0039749,
        LOCATION_LATITUDE_DEG: 57.8428444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022200',
        LOCATION_NAME: 'Borve',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2560389,
        LOCATION_LATITUDE_DEG: 57.4552914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022300',
        LOCATION_NAME: 'Borwick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.72601,
        LOCATION_LATITUDE_DEG: 54.1512314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022400',
        LOCATION_NAME: 'Bosavern',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6764678,
        LOCATION_LATITUDE_DEG: 50.1132779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022500',
        LOCATION_NAME: 'Bosbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4435743,
        LOCATION_LATITUDE_DEG: 52.0878258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022600',
        LOCATION_NAME: 'Boscastle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6917914,
        LOCATION_LATITUDE_DEG: 50.683522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022700',
        LOCATION_NAME: 'Boscombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8415218,
        LOCATION_LATITUDE_DEG: 50.7202932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022800',
        LOCATION_NAME: 'Boscombe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7079188,
        LOCATION_LATITUDE_DEG: 51.1479321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022900',
        LOCATION_NAME: 'Boscombe Down',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7557801,
        LOCATION_LATITUDE_DEG: 51.168537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO022925',
        LOCATION_NAME: 'Boscoppa',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.763545,
        LOCATION_LATITUDE_DEG: 50.3436361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023000',
        LOCATION_NAME: 'Boscundle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7388826,
        LOCATION_LATITUDE_DEG: 50.3425827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023100',
        LOCATION_NAME: 'Bosham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8463031,
        LOCATION_LATITUDE_DEG: 50.8328918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023200',
        LOCATION_NAME: 'Bosham Hoe',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8454498,
        LOCATION_LATITUDE_DEG: 50.808186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023300',
        LOCATION_NAME: 'Bosherston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9383919,
        LOCATION_LATITUDE_DEG: 51.6128129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023400',
        LOCATION_NAME: 'Bosleake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2568361,
        LOCATION_LATITUDE_DEG: 50.2140826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023500',
        LOCATION_NAME: 'Bosley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.123981,
        LOCATION_LATITUDE_DEG: 53.1902343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023600',
        LOCATION_NAME: 'Bosoughan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9894488,
        LOCATION_LATITUDE_DEG: 50.4086934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023700',
        LOCATION_NAME: 'Bossall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9037865,
        LOCATION_LATITUDE_DEG: 54.0388982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023800',
        LOCATION_NAME: 'Bossiney',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7379636,
        LOCATION_LATITUDE_DEG: 50.6662174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO023900',
        LOCATION_NAME: 'Bossingham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0789368,
        LOCATION_LATITUDE_DEG: 51.1991018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024000',
        LOCATION_NAME: 'Bossington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5788996,
        LOCATION_LATITUDE_DEG: 51.2197608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024100',
        LOCATION_NAME: 'Bossington Green',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5783486,
        LOCATION_LATITUDE_DEG: 51.2195614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024200',
        LOCATION_NAME: 'Bostock',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4867945,
        LOCATION_LATITUDE_DEG: 53.2152675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024500',
        LOCATION_NAME: 'Boston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0224106,
        LOCATION_LATITUDE_DEG: 52.977084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024600',
        LOCATION_NAME: 'Boston Spa',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3600372,
        LOCATION_LATITUDE_DEG: 53.9063871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024700',
        LOCATION_NAME: 'Boston West',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0713636,
        LOCATION_LATITUDE_DEG: 52.9930844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024800',
        LOCATION_NAME: 'Boswell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0776325,
        LOCATION_LATITUDE_DEG: 53.3940203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024900',
        LOCATION_NAME: 'Boswinger',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8179643,
        LOCATION_LATITUDE_DEG: 50.2345796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025000',
        LOCATION_NAME: 'Botallack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6827194,
        LOCATION_LATITUDE_DEG: 50.1352774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025100',
        LOCATION_NAME: 'Botany Bay',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9753223,
        LOCATION_LATITUDE_DEG: 53.339032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025200',
        LOCATION_NAME: 'Botcheston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2823661,
        LOCATION_LATITUDE_DEG: 52.639364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025300',
        LOCATION_NAME: 'Botera',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3869804,
        LOCATION_LATITUDE_DEG: 54.596058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025400',
        LOCATION_NAME: 'Botesdale',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0061148,
        LOCATION_LATITUDE_DEG: 52.3419121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025500',
        LOCATION_NAME: 'Bothal',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6238744,
        LOCATION_LATITUDE_DEG: 55.1733146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025600',
        LOCATION_NAME: 'Bothamsall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9882171,
        LOCATION_LATITUDE_DEG: 53.2530252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025700',
        LOCATION_NAME: 'Bothel',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2698533,
        LOCATION_LATITUDE_DEG: 54.7374923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025800',
        LOCATION_NAME: 'Bothenhampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7542693,
        LOCATION_LATITUDE_DEG: 50.7228988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO025900',
        LOCATION_NAME: 'Bothenwood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9702126,
        LOCATION_LATITUDE_DEG: 50.8209998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026000',
        LOCATION_NAME: 'Bothkennar',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7594214,
        LOCATION_LATITUDE_DEG: 56.0325287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026100',
        LOCATION_NAME: 'Bothwell',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0648829,
        LOCATION_LATITUDE_DEG: 55.8023101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026200',
        LOCATION_NAME: 'Botley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3009757,
        LOCATION_LATITUDE_DEG: 51.7493869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026300',
        LOCATION_NAME: 'Botley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2684131,
        LOCATION_LATITUDE_DEG: 50.9137998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026400',
        LOCATION_NAME: 'Botolph Claydon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9343454,
        LOCATION_LATITUDE_DEG: 51.9138925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026500',
        LOCATION_NAME: 'Botolphs',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3047765,
        LOCATION_LATITUDE_DEG: 50.8712875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026600',
        LOCATION_NAME: 'Botriphnie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0354713,
        LOCATION_LATITUDE_DEG: 57.4818607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026700',
        LOCATION_NAME: 'Bottesford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8004002,
        LOCATION_LATITUDE_DEG: 52.9414935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026800',
        LOCATION_NAME: 'Bottesford',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6432396,
        LOCATION_LATITUDE_DEG: 53.554847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO026900',
        LOCATION_NAME: 'Bottesford Moor',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7117896,
        LOCATION_LATITUDE_DEG: 53.5516494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027000',
        LOCATION_NAME: 'Bottisham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2600587,
        LOCATION_LATITUDE_DEG: 52.2228062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027200',
        LOCATION_NAME: 'Bottlesford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8300686,
        LOCATION_LATITUDE_DEG: 51.3342457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027300',
        LOCATION_NAME: 'Bottlesford Corner',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8291962,
        LOCATION_LATITUDE_DEG: 51.3333452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027400',
        LOCATION_NAME: 'Bottom Boat',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4628778,
        LOCATION_LATITUDE_DEG: 53.7180749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027500',
        LOCATION_NAME: 'Bottom Woodbeck',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8596727,
        LOCATION_LATITUDE_DEG: 53.2952252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027600',
        LOCATION_NAME: 'Bottomhouse',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9381576,
        LOCATION_LATITUDE_DEG: 53.0715156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027700',
        LOCATION_NAME: 'Bottreaux Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6807663,
        LOCATION_LATITUDE_DEG: 51.0220408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027800',
        LOCATION_NAME: 'Botus Fleming',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2410875,
        LOCATION_LATITUDE_DEG: 50.4303747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027900',
        LOCATION_NAME: 'Botwnnog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5834412,
        LOCATION_LATITUDE_DEG: 52.8488278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028000',
        LOCATION_NAME: 'Bough Beech',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1309368,
        LOCATION_LATITUDE_DEG: 51.2008087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028100',
        LOCATION_NAME: 'Boughrood',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2710913,
        LOCATION_LATITUDE_DEG: 52.0447324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028200',
        LOCATION_NAME: 'Boughspring',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6507922,
        LOCATION_LATITUDE_DEG: 51.6724917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028300',
        LOCATION_NAME: 'Boughton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9850381,
        LOCATION_LATITUDE_DEG: 53.2087211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028600',
        LOCATION_NAME: 'Boughton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8946607,
        LOCATION_LATITUDE_DEG: 52.284932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028500',
        LOCATION_NAME: 'Boughton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3258619,
        LOCATION_LATITUDE_DEG: 52.9956912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028400',
        LOCATION_NAME: 'Boughton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5121525,
        LOCATION_LATITUDE_DEG: 52.5883401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028700',
        LOCATION_NAME: 'Boughton Aluph',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9106959,
        LOCATION_LATITUDE_DEG: 51.1960981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028800',
        LOCATION_NAME: 'Boughton Lees',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8960679,
        LOCATION_LATITUDE_DEG: 51.1884014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO028900',
        LOCATION_NAME: 'Boughton Malherbe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6959431,
        LOCATION_LATITUDE_DEG: 51.2132013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029000',
        LOCATION_NAME: 'Boughton Monchelsea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5342176,
        LOCATION_LATITUDE_DEG: 51.2287087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040700',
        LOCATION_NAME: 'Boughton under Blean',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029100',
        LOCATION_NAME: 'Boughton-under-Blean',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9532816,
        LOCATION_LATITUDE_DEG: 51.2910119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029300',
        LOCATION_NAME: 'Bould',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6461807,
        LOCATION_LATITUDE_DEG: 51.8862993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029400',
        LOCATION_NAME: 'Bouldnor',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4664119,
        LOCATION_LATITUDE_DEG: 50.7035847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029500',
        LOCATION_NAME: 'Bouldon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6711282,
        LOCATION_LATITUDE_DEG: 52.4618653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029600',
        LOCATION_NAME: 'Boulge',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2999633,
        LOCATION_LATITUDE_DEG: 52.1238831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029700',
        LOCATION_NAME: 'Boulmer',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5796426,
        LOCATION_LATITUDE_DEG: 55.4220434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029800',
        LOCATION_NAME: 'Boulston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9372659,
        LOCATION_LATITUDE_DEG: 51.7770258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029900',
        LOCATION_NAME: 'Boultham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5545023,
        LOCATION_LATITUDE_DEG: 53.2137162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030000',
        LOCATION_NAME: 'Boulton Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4286633,
        LOCATION_LATITUDE_DEG: 52.8923936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030100',
        LOCATION_NAME: 'Boundary',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4866725,
        LOCATION_LATITUDE_DEG: 52.7673838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO042000',
        LOCATION_NAME: 'Bounds Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'N11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1345779,
        LOCATION_LATITUDE_DEG: 51.6101778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030200',
        LOCATION_NAME: 'Bourn',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0610306,
        LOCATION_LATITUDE_DEG: 52.1900042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO042300',
        LOCATION_NAME: 'Bournbrook',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.927412,
        LOCATION_LATITUDE_DEG: 52.446493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030400',
        LOCATION_NAME: 'Bourne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1787969,
        LOCATION_LATITUDE_DEG: 51.7190925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030300',
        LOCATION_NAME: 'Bourne',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3755355,
        LOCATION_LATITUDE_DEG: 52.7677656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030500',
        LOCATION_NAME: 'Bourne End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7082415,
        LOCATION_LATITUDE_DEG: 51.5744571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030600',
        LOCATION_NAME: 'Bourne End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5964001,
        LOCATION_LATITUDE_DEG: 52.0909055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030700',
        LOCATION_NAME: 'Bournemouth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8744461,
        LOCATION_LATITUDE_DEG: 50.720693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030800',
        LOCATION_NAME: 'Bournes Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1299563,
        LOCATION_LATITUDE_DEG: 51.7364936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031000',
        LOCATION_NAME: 'Bournheath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0791513,
        LOCATION_LATITUDE_DEG: 52.3646516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031100',
        LOCATION_NAME: 'Bournstream',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3614169,
        LOCATION_LATITUDE_DEG: 51.6464829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031200',
        LOCATION_NAME: 'Bournville',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9324795,
        LOCATION_LATITUDE_DEG: 52.4235508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031300',
        LOCATION_NAME: 'Bourton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8866501,
        LOCATION_LATITUDE_DEG: 51.376167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031800',
        LOCATION_NAME: 'Bourton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5975889,
        LOCATION_LATITUDE_DEG: 52.5630767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031700',
        LOCATION_NAME: 'Bourton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.324451,
        LOCATION_LATITUDE_DEG: 51.0743279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031400',
        LOCATION_NAME: 'Bourton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9346882,
        LOCATION_LATITUDE_DEG: 51.3792515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031600',
        LOCATION_NAME: 'Bourton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6651705,
        LOCATION_LATITUDE_DEG: 51.5828687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031900',
        LOCATION_NAME: 'Bourton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3600623,
        LOCATION_LATITUDE_DEG: 52.3278343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO031500',
        LOCATION_NAME: 'Bourton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9719526,
        LOCATION_LATITUDE_DEG: 51.9912988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032100',
        LOCATION_NAME: 'Bourton on the Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7442742,
        LOCATION_LATITUDE_DEG: 51.9898069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040800',
        LOCATION_NAME: 'Bourton on the Water',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032000',
        LOCATION_NAME: 'Bourton Westwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5830578,
        LOCATION_LATITUDE_DEG: 52.5787755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032200',
        LOCATION_NAME: 'Bourton-on-the-Water',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.764343,
        LOCATION_LATITUDE_DEG: 51.8900931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032300',
        LOCATION_NAME: 'Bourtreehill North',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6322141,
        LOCATION_LATITUDE_DEG: 55.6219969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032400',
        LOCATION_NAME: 'Bourtreehill South',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6241229,
        LOCATION_LATITUDE_DEG: 55.6166956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032500',
        LOCATION_NAME: 'Boustead Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1029194,
        LOCATION_LATITUDE_DEG: 54.9212141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032600',
        LOCATION_NAME: 'Bouth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0286761,
        LOCATION_LATITUDE_DEG: 54.2629419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032700',
        LOCATION_NAME: 'Bouthwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8111383,
        LOCATION_LATITUDE_DEG: 54.1367151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032800',
        LOCATION_NAME: 'Boverton',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4627042,
        LOCATION_LATITUDE_DEG: 51.4054745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO032900',
        LOCATION_NAME: 'Bovey Tracey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6771437,
        LOCATION_LATITUDE_DEG: 50.5884033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033000',
        LOCATION_NAME: 'Bovingdon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5284727,
        LOCATION_LATITUDE_DEG: 51.7212729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033050',
        LOCATION_NAME: 'Bovinger',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2022824,
        LOCATION_LATITUDE_DEG: 51.723885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033100',
        LOCATION_NAME: 'Bovington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2422421,
        LOCATION_LATITUDE_DEG: 50.6965946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033200',
        LOCATION_NAME: 'Bovisand',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1138142,
        LOCATION_LATITUDE_DEG: 50.3349778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033400',
        LOCATION_NAME: 'Bow',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8154778,
        LOCATION_LATITUDE_DEG: 50.7995198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033300',
        LOCATION_NAME: 'Bow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0361347,
        LOCATION_LATITUDE_DEG: 54.8952067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041800',
        LOCATION_NAME: 'Bow',
        COUNTY_NAME: 'London',
        POSTCODE: 'E3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0236073,
        LOCATION_LATITUDE_DEG: 51.5288219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033500',
        LOCATION_NAME: 'Bow Brickhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6791817,
        LOCATION_LATITUDE_DEG: 52.0021016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033700',
        LOCATION_NAME: 'Bow of Fife',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0981164,
        LOCATION_LATITUDE_DEG: 56.3036426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033600',
        LOCATION_NAME: 'Bow Street',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.026862,
        LOCATION_LATITUDE_DEG: 52.4416794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033800',
        LOCATION_NAME: 'Bowbridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2063037,
        LOCATION_LATITUDE_DEG: 51.7348917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO033900',
        LOCATION_NAME: 'Bowbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8150576,
        LOCATION_LATITUDE_DEG: 52.7050962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034000',
        LOCATION_NAME: 'Bowburn',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5272643,
        LOCATION_LATITUDE_DEG: 54.7391751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034100',
        LOCATION_NAME: 'Bowcombe',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3364499,
        LOCATION_LATITUDE_DEG: 50.6788768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034200',
        LOCATION_NAME: 'Bowcott',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3225189,
        LOCATION_LATITUDE_DEG: 51.6564877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034300',
        LOCATION_NAME: 'Bowd',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2647757,
        LOCATION_LATITUDE_DEG: 50.7031074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034400',
        LOCATION_NAME: 'Bowd Corner',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2662251,
        LOCATION_LATITUDE_DEG: 50.7017065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034600',
        LOCATION_NAME: 'Bowden',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6231002,
        LOCATION_LATITUDE_DEG: 50.3286708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034500',
        LOCATION_NAME: 'Bowden',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7076188,
        LOCATION_LATITUDE_DEG: 55.5661695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034700',
        LOCATION_NAME: 'Bowden Hill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0938417,
        LOCATION_LATITUDE_DEG: 51.410059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034800',
        LOCATION_NAME: 'Bowdens',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8362809,
        LOCATION_LATITUDE_DEG: 51.0550322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO034900',
        LOCATION_NAME: 'Bowderdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4957889,
        LOCATION_LATITUDE_DEG: 54.4359557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035000',
        LOCATION_NAME: 'Bowdon',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3636264,
        LOCATION_LATITUDE_DEG: 53.376355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035100',
        LOCATION_NAME: 'Bower',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3126574,
        LOCATION_LATITUDE_DEG: 58.5478687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035200',
        LOCATION_NAME: 'Bower Ashton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6282636,
        LOCATION_LATITUDE_DEG: 51.4424683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035300',
        LOCATION_NAME: 'Bower Hinton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7750755,
        LOCATION_LATITUDE_DEG: 50.9582261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035400',
        LOCATION_NAME: 'Bowerchalke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9764668,
        LOCATION_LATITUDE_DEG: 51.004224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035500',
        LOCATION_NAME: 'Bowerhill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1269356,
        LOCATION_LATITUDE_DEG: 51.3603522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035600',
        LOCATION_NAME: 'Bowermadden',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3029227,
        LOCATION_LATITUDE_DEG: 58.5573732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035700',
        LOCATION_NAME: 'Bowers Gifford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5219112,
        LOCATION_LATITUDE_DEG: 51.5655432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035800',
        LOCATION_NAME: 'Bowertower',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3338731,
        LOCATION_LATITUDE_DEG: 58.5381729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO035900',
        LOCATION_NAME: 'Bowes',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0063804,
        LOCATION_LATITUDE_DEG: 54.5167592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041900',
        LOCATION_NAME: 'Bowes Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'N11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1205877,
        LOCATION_LATITUDE_DEG: 51.6075713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036000',
        LOCATION_NAME: 'Bowglass',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7606745,
        LOCATION_LATITUDE_DEG: 58.0052572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036100',
        LOCATION_NAME: 'Bowgreave',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7665589,
        LOCATION_LATITUDE_DEG: 53.8897079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036200',
        LOCATION_NAME: 'Bowhill',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9047886,
        LOCATION_LATITUDE_DEG: 55.5425675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036300',
        LOCATION_NAME: 'Bowithick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5698831,
        LOCATION_LATITUDE_DEG: 50.6162086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036400',
        LOCATION_NAME: 'Bowker Vale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2476639,
        LOCATION_LATITUDE_DEG: 53.5247639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036500',
        LOCATION_NAME: 'Bowland Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8950587,
        LOCATION_LATITUDE_DEG: 54.2983444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036600',
        LOCATION_NAME: 'Bowlhead Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6897953,
        LOCATION_LATITUDE_DEG: 51.1365154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036700',
        LOCATION_NAME: 'Bowling',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.480488,
        LOCATION_LATITUDE_DEG: 55.9315292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036800',
        LOCATION_NAME: 'Bowling Bank',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8965185,
        LOCATION_LATITUDE_DEG: 53.0325254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO036900',
        LOCATION_NAME: 'Bowling Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.76918,
        LOCATION_LATITUDE_DEG: 50.3877903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037000',
        LOCATION_NAME: 'Bowlish',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5546476,
        LOCATION_LATITUDE_DEG: 51.1928466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037100',
        LOCATION_NAME: 'Bowmanstead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0780879,
        LOCATION_LATITUDE_DEG: 54.3605594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037200',
        LOCATION_NAME: 'Bowmore',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2856106,
        LOCATION_LATITUDE_DEG: 55.7552237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041200',
        LOCATION_NAME: 'Bowness on Solway',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041300',
        LOCATION_NAME: 'Bowness on Windermere',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037300',
        LOCATION_NAME: 'Bowness-on-Solway',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2133718,
        LOCATION_LATITUDE_DEG: 54.9529139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037400',
        LOCATION_NAME: 'Bowness-on-Windermere',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9189398,
        LOCATION_LATITUDE_DEG: 54.3638534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037500',
        LOCATION_NAME: 'Bowood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7832773,
        LOCATION_LATITUDE_DEG: 50.7869054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037600',
        LOCATION_NAME: 'Bowriefauld',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7882945,
        LOCATION_LATITUDE_DEG: 56.6191702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO041500',
        LOCATION_NAME: 'Bowring Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.872759,
        LOCATION_LATITUDE_DEG: 53.4111705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037700',
        LOCATION_NAME: 'Bowringsleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7971912,
        LOCATION_LATITUDE_DEG: 50.2858744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037800',
        LOCATION_NAME: 'Bowscar',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.751695,
        LOCATION_LATITUDE_DEG: 54.7031814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO037900',
        LOCATION_NAME: 'Bowsden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0103509,
        LOCATION_LATITUDE_DEG: 55.669469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038000',
        LOCATION_NAME: 'Bowsey Wood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3432732,
        LOCATION_LATITUDE_DEG: 53.0149197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038100',
        LOCATION_NAME: 'Bowston',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7750772,
        LOCATION_LATITUDE_DEG: 54.3626517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038200',
        LOCATION_NAME: 'Bowthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2183575,
        LOCATION_LATITUDE_DEG: 52.6358296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038400',
        LOCATION_NAME: 'Box',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1457844,
        LOCATION_LATITUDE_DEG: 51.6846122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038500',
        LOCATION_NAME: 'Box',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.24929,
        LOCATION_LATITUDE_DEG: 51.4160634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038300',
        LOCATION_NAME: 'Box',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2076532,
        LOCATION_LATITUDE_DEG: 51.700692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038600',
        LOCATION_NAME: 'Box End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5269389,
        LOCATION_LATITUDE_DEG: 52.130811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038700',
        LOCATION_NAME: 'Box Hill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2361752,
        LOCATION_LATITUDE_DEG: 51.4246605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO991115',
        LOCATION_NAME: 'Box Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.30967,
        LOCATION_LATITUDE_DEG: 51.25406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038800',
        LOCATION_NAME: 'Boxford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3825164,
        LOCATION_LATITUDE_DEG: 51.4412576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO038900',
        LOCATION_NAME: 'Boxford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8608287,
        LOCATION_LATITUDE_DEG: 52.0273779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039000',
        LOCATION_NAME: 'Boxgrove',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7111511,
        LOCATION_LATITUDE_DEG: 50.8587918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039100',
        LOCATION_NAME: 'Boxley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.544701,
        LOCATION_LATITUDE_DEG: 51.3018156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039300',
        LOCATION_NAME: 'Boxted',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.669713,
        LOCATION_LATITUDE_DEG: 52.1287949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039200',
        LOCATION_NAME: 'Boxted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9125487,
        LOCATION_LATITUDE_DEG: 51.9481718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039400',
        LOCATION_NAME: 'Boxworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0223763,
        LOCATION_LATITUDE_DEG: 52.2624104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039600',
        LOCATION_NAME: 'Boylestone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7289489,
        LOCATION_LATITUDE_DEG: 52.9204025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039700',
        LOCATION_NAME: 'Boyndie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6011621,
        LOCATION_LATITUDE_DEG: 57.6636779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039800',
        LOCATION_NAME: 'Boyndlie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1532305,
        LOCATION_LATITUDE_DEG: 57.6525713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039900',
        LOCATION_NAME: 'Boynton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2632219,
        LOCATION_LATITUDE_DEG: 54.0972924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040000',
        LOCATION_NAME: 'Boys Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.463646,
        LOCATION_LATITUDE_DEG: 50.8893149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040100',
        LOCATION_NAME: 'Boysack',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6177404,
        LOCATION_LATITUDE_DEG: 56.6320747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040300',
        LOCATION_NAME: 'Boyton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3829981,
        LOCATION_LATITUDE_DEG: 50.701213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040400',
        LOCATION_NAME: 'Boyton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0683276,
        LOCATION_LATITUDE_DEG: 51.1557321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040200',
        LOCATION_NAME: 'Boyton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4643288,
        LOCATION_LATITUDE_DEG: 52.0697776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040500',
        LOCATION_NAME: 'Boyton End',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5075056,
        LOCATION_LATITUDE_DEG: 52.0689881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040600',
        LOCATION_NAME: 'Bozeat',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6716493,
        LOCATION_LATITUDE_DEG: 52.2227205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000100',
        LOCATION_NAME: 'Braaid',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5699242,
        LOCATION_LATITUDE_DEG: 54.1592252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000200',
        LOCATION_NAME: 'Brabling Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3611257,
        LOCATION_LATITUDE_DEG: 52.2320944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000300',
        LOCATION_NAME: 'Brabourne Lees',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9731584,
        LOCATION_LATITUDE_DEG: 51.1257908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000400',
        LOCATION_NAME: 'Braceborough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4012994,
        LOCATION_LATITUDE_DEG: 52.7062628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000500',
        LOCATION_NAME: 'Bracebridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5505416,
        LOCATION_LATITUDE_DEG: 53.1997145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000600',
        LOCATION_NAME: 'Bracebridge Heath',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5317604,
        LOCATION_LATITUDE_DEG: 53.1946115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000700',
        LOCATION_NAME: 'Braceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4875931,
        LOCATION_LATITUDE_DEG: 52.9057803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000800',
        LOCATION_NAME: 'Bracewell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.209628,
        LOCATION_LATITUDE_DEG: 53.9322063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR000900',
        LOCATION_NAME: 'Brackenber',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.42823,
        LOCATION_LATITUDE_DEG: 54.5709717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001000',
        LOCATION_NAME: 'Brackenborough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0153839,
        LOCATION_LATITUDE_DEG: 53.3886228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001100',
        LOCATION_NAME: 'Brackenburgh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.811967,
        LOCATION_LATITUDE_DEG: 54.7376928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001200',
        LOCATION_NAME: 'Brackenfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.443262,
        LOCATION_LATITUDE_DEG: 53.1263191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001300',
        LOCATION_NAME: 'Brackenhill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8681505,
        LOCATION_LATITUDE_DEG: 55.0168136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001400',
        LOCATION_NAME: 'Brackenholme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9629125,
        LOCATION_LATITUDE_DEG: 53.7632711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001500',
        LOCATION_NAME: 'Brackenthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1011169,
        LOCATION_LATITUDE_DEG: 54.8077033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001700',
        LOCATION_NAME: 'Brackla',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5535313,
        LOCATION_LATITUDE_DEG: 51.5082862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001800',
        LOCATION_NAME: 'Bracklesham Bay',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8537984,
        LOCATION_LATITUDE_DEG: 50.7616796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001900',
        LOCATION_NAME: 'Brackley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1454281,
        LOCATION_LATITUDE_DEG: 52.028806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002000',
        LOCATION_NAME: 'Brackley Hatch',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0508763,
        LOCATION_LATITUDE_DEG: 52.0715134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002200',
        LOCATION_NAME: 'Brackmills Industrial Estate',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8624503,
        LOCATION_LATITUDE_DEG: 52.2207214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002400',
        LOCATION_NAME: 'Bracknell',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.744958,
        LOCATION_LATITUDE_DEG: 51.4165428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002500',
        LOCATION_NAME: 'Bracky',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1629515,
        LOCATION_LATITUDE_DEG: 54.5951098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002600',
        LOCATION_NAME: 'Braco',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8774532,
        LOCATION_LATITUDE_DEG: 56.2646487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002700',
        LOCATION_NAME: 'Bracon Ash',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2204713,
        LOCATION_LATITUDE_DEG: 52.5539217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002800',
        LOCATION_NAME: 'Bradbourne',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6870501,
        LOCATION_LATITUDE_DEG: 53.070311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002900',
        LOCATION_NAME: 'Bradbury',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5081054,
        LOCATION_LATITUDE_DEG: 54.6485649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003000',
        LOCATION_NAME: 'Bradden',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.054691,
        LOCATION_LATITUDE_DEG: 52.1299194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003100',
        LOCATION_NAME: 'Braddock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5877688,
        LOCATION_LATITUDE_DEG: 50.4289974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003300',
        LOCATION_NAME: 'Bradeley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1908556,
        LOCATION_LATITUDE_DEG: 53.0613186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003400',
        LOCATION_NAME: 'Braden Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8358273,
        LOCATION_LATITUDE_DEG: 52.9249104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003500',
        LOCATION_NAME: 'Bradenham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8090479,
        LOCATION_LATITUDE_DEG: 51.6650644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003600',
        LOCATION_NAME: 'Bradenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8433224,
        LOCATION_LATITUDE_DEG: 52.6403405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003700',
        LOCATION_NAME: 'Bradenstoke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9954745,
        LOCATION_LATITUDE_DEG: 51.5135649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990665',
        LOCATION_NAME: 'Bradfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004100',
        LOCATION_NAME: 'Bradfield',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3435284,
        LOCATION_LATITUDE_DEG: 50.8780248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004000',
        LOCATION_NAME: 'Bradfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1190063,
        LOCATION_LATITUDE_DEG: 51.9340638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003900',
        LOCATION_NAME: 'Bradfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3725075,
        LOCATION_LATITUDE_DEG: 52.8491482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004200',
        LOCATION_NAME: 'Bradfield Combust',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7683509,
        LOCATION_LATITUDE_DEG: 52.1823993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004300',
        LOCATION_NAME: 'Bradfield Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4767947,
        LOCATION_LATITUDE_DEG: 53.1266301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004400',
        LOCATION_NAME: 'Bradfield Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1064453,
        LOCATION_LATITUDE_DEG: 51.9249694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990666',
        LOCATION_NAME: 'Bradfield Southend',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091600',
        LOCATION_NAME: 'Bradfield St Clare',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091700',
        LOCATION_NAME: 'Bradfield St George',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004500',
        LOCATION_NAME: 'Bradfield St. Clare',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7918701,
        LOCATION_LATITUDE_DEG: 52.1838954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004600',
        LOCATION_NAME: 'Bradfield St. George',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8020376,
        LOCATION_LATITUDE_DEG: 52.2061934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004800',
        LOCATION_NAME: 'Bradford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2436441,
        LOCATION_LATITUDE_DEG: 50.8421249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094700',
        LOCATION_NAME: 'Bradford',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1940002,
        LOCATION_LATITUDE_DEG: 53.4811023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004700',
        LOCATION_NAME: 'Bradford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'BD99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7577837,
        LOCATION_LATITUDE_DEG: 55.5836627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR004900',
        LOCATION_NAME: 'Bradford Abbas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5864273,
        LOCATION_LATITUDE_DEG: 50.9279205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005000',
        LOCATION_NAME: 'Bradford BD 1',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7548037,
        LOCATION_LATITUDE_DEG: 53.7970622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005100',
        LOCATION_NAME: 'Bradford BD 2',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7357987,
        LOCATION_LATITUDE_DEG: 53.8156561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005200',
        LOCATION_NAME: 'Bradford BD 3',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7260926,
        LOCATION_LATITUDE_DEG: 53.7992832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005300',
        LOCATION_NAME: 'Bradford BD 4',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.703224,
        LOCATION_LATITUDE_DEG: 53.7779338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005400',
        LOCATION_NAME: 'Bradford BD 5',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7589117,
        LOCATION_LATITUDE_DEG: 53.7770429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005500',
        LOCATION_NAME: 'Bradford BD 6',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7844188,
        LOCATION_LATITUDE_DEG: 53.7630236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005600',
        LOCATION_NAME: 'Bradford BD 7',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7839067,
        LOCATION_LATITUDE_DEG: 53.7859448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005700',
        LOCATION_NAME: 'Bradford BD 8',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7881452,
        LOCATION_LATITUDE_DEG: 53.8003168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005800',
        LOCATION_NAME: 'Bradford BD 9',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7968086,
        LOCATION_LATITUDE_DEG: 53.8143277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR005900',
        LOCATION_NAME: 'Bradford BD10',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7222322,
        LOCATION_LATITUDE_DEG: 53.8365788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006000',
        LOCATION_NAME: 'Bradford BD12',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7578151,
        LOCATION_LATITUDE_DEG: 53.7592693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006100',
        LOCATION_NAME: 'Bradford Leigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2340678,
        LOCATION_LATITUDE_DEG: 51.3612573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095900',
        LOCATION_NAME: 'Bradford Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.716073,
        LOCATION_LATITUDE_DEG: 53.7989903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091900',
        LOCATION_NAME: 'Bradford on Avon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006300',
        LOCATION_NAME: 'Bradford on Tone',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1791504,
        LOCATION_LATITUDE_DEG: 50.9968371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006200',
        LOCATION_NAME: 'Bradford Peverell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4826915,
        LOCATION_LATITUDE_DEG: 50.7343044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006400',
        LOCATION_NAME: 'Bradford-on-Avon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2480126,
        LOCATION_LATITUDE_DEG: 51.3500596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006500',
        LOCATION_NAME: 'Bradiford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0697966,
        LOCATION_LATITUDE_DEG: 51.0967543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006600',
        LOCATION_NAME: 'Brading',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1398951,
        LOCATION_LATITUDE_DEG: 50.677781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006700',
        LOCATION_NAME: 'Bradle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0891222,
        LOCATION_LATITUDE_DEG: 50.6275869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006900',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.006854,
        LOCATION_LATITUDE_DEG: 53.0780337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007200',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1773683,
        LOCATION_LATITUDE_DEG: 52.7599915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007000',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0704658,
        LOCATION_LATITUDE_DEG: 52.5550693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007500',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9948514,
        LOCATION_LATITUDE_DEG: 53.9322003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007100',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7501703,
        LOCATION_LATITUDE_DEG: 53.6798703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007400',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6648696,
        LOCATION_LATITUDE_DEG: 53.0087037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR006800',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0965693,
        LOCATION_LATITUDE_DEG: 51.1735233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007300',
        LOCATION_NAME: 'Bradley',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1223785,
        LOCATION_LATITUDE_DEG: 53.5422374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007600',
        LOCATION_NAME: 'Bradley Brook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5751852,
        LOCATION_LATITUDE_DEG: 53.3289469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007700',
        LOCATION_NAME: 'Bradley Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7288078,
        LOCATION_LATITUDE_DEG: 53.0013237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007800',
        LOCATION_NAME: 'Bradley Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7599728,
        LOCATION_LATITUDE_DEG: 51.2747533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR007900',
        LOCATION_NAME: 'Bradley Fold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3765353,
        LOCATION_LATITUDE_DEG: 53.5732672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008000',
        LOCATION_NAME: 'Bradley Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3672313,
        LOCATION_LATITUDE_DEG: 51.6397835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008100',
        LOCATION_NAME: 'Bradley Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B96',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0170658,
        LOCATION_LATITUDE_DEG: 52.2472418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008200',
        LOCATION_NAME: 'Bradley In The Moors',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9101753,
        LOCATION_LATITUDE_DEG: 52.9683083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008300',
        LOCATION_NAME: 'Bradley Stoke',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5421394,
        LOCATION_LATITUDE_DEG: 51.5347757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008400',
        LOCATION_NAME: 'Bradley Valley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6186654,
        LOCATION_LATITUDE_DEG: 50.5286968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008500',
        LOCATION_NAME: 'Bradlow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4253536,
        LOCATION_LATITUDE_DEG: 52.0459287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008700',
        LOCATION_NAME: 'Bradmore',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.164746,
        LOCATION_LATITUDE_DEG: 52.576374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008600',
        LOCATION_NAME: 'Bradmore',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1299487,
        LOCATION_LATITUDE_DEG: 52.8747846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008800',
        LOCATION_NAME: 'Bradninch',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4209889,
        LOCATION_LATITUDE_DEG: 50.8260212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR008900',
        LOCATION_NAME: 'Bradnocks Marsh',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.680433,
        LOCATION_LATITUDE_DEG: 52.4147495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009000',
        LOCATION_NAME: 'Bradnop',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9820333,
        LOCATION_LATITUDE_DEG: 53.0945179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009100',
        LOCATION_NAME: 'Bradpole',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7390144,
        LOCATION_LATITUDE_DEG: 50.7430078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009200',
        LOCATION_NAME: 'Bradshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3935481,
        LOCATION_LATITUDE_DEG: 53.6048731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009300',
        LOCATION_NAME: 'Bradshaw',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8788744,
        LOCATION_LATITUDE_DEG: 53.7681811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009400',
        LOCATION_NAME: 'Bradstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2877141,
        LOCATION_LATITUDE_DEG: 50.6042114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009500',
        LOCATION_NAME: 'Bradville',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7796524,
        LOCATION_LATITUDE_DEG: 52.0578039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009600',
        LOCATION_NAME: 'Bradwall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3648894,
        LOCATION_LATITUDE_DEG: 53.1632555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009700',
        LOCATION_NAME: 'Bradway',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.517256,
        LOCATION_LATITUDE_DEG: 53.3198365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009800',
        LOCATION_NAME: 'Bradwell',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2349687,
        LOCATION_LATITUDE_DEG: 53.0365167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010100',
        LOCATION_NAME: 'Bradwell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7385572,
        LOCATION_LATITUDE_DEG: 53.3269364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR009900',
        LOCATION_NAME: 'Bradwell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7706804,
        LOCATION_LATITUDE_DEG: 52.0371006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010200',
        LOCATION_NAME: 'Bradwell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6229689,
        LOCATION_LATITUDE_DEG: 51.8747653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010000',
        LOCATION_NAME: 'Bradwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7006599,
        LOCATION_LATITUDE_DEG: 52.5732161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010300',
        LOCATION_NAME: 'Bradwell Abbey',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7938586,
        LOCATION_LATITUDE_DEG: 52.0465032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010400',
        LOCATION_NAME: 'Bradwell Common',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7692505,
        LOCATION_LATITUDE_DEG: 52.0435061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010500',
        LOCATION_NAME: 'Bradwell Grove',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.658632,
        LOCATION_LATITUDE_DEG: 51.7732882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092700',
        LOCATION_NAME: 'Bradwell on Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010600',
        LOCATION_NAME: 'Bradwell Waterside',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8888183,
        LOCATION_LATITUDE_DEG: 51.733649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010700',
        LOCATION_NAME: 'Bradwell-on-Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9019331,
        LOCATION_LATITUDE_DEG: 51.7235483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010800',
        LOCATION_NAME: 'Bradworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.382131,
        LOCATION_LATITUDE_DEG: 50.8995377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010900',
        LOCATION_NAME: 'Brae',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2243987,
        LOCATION_LATITUDE_DEG: 57.6460947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR010950',
        LOCATION_NAME: 'Brae',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3482038,
        LOCATION_LATITUDE_DEG: 60.3936499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011100',
        LOCATION_NAME: 'Brae of Kinkell',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3687183,
        LOCATION_LATITUDE_DEG: 57.5644891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011000',
        LOCATION_NAME: 'Brae Tongue',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4077878,
        LOCATION_LATITUDE_DEG: 58.4813791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011200',
        LOCATION_NAME: 'Braegrum',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6134302,
        LOCATION_LATITUDE_DEG: 56.4082669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011300',
        LOCATION_NAME: 'Braehead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8808754,
        LOCATION_LATITUDE_DEG: 55.5905856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011400',
        LOCATION_NAME: 'BRAEMAR',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3957016,
        LOCATION_LATITUDE_DEG: 57.0040771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011600',
        LOCATION_NAME: 'Braemore',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.035147,
        LOCATION_LATITUDE_DEG: 57.7714178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011500',
        LOCATION_NAME: 'Braemore',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5730207,
        LOCATION_LATITUDE_DEG: 58.2507417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011700',
        LOCATION_NAME: 'Braeside',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8190411,
        LOCATION_LATITUDE_DEG: 55.9387255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011800',
        LOCATION_NAME: 'Braeval',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3610055,
        LOCATION_LATITUDE_DEG: 56.1733507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012000',
        LOCATION_NAME: 'Brafferton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5476614,
        LOCATION_LATITUDE_DEG: 54.582757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR011900',
        LOCATION_NAME: 'Brafferton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3297796,
        LOCATION_LATITUDE_DEG: 54.124409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012100',
        LOCATION_NAME: 'Brafield on the Green',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8010057,
        LOCATION_LATITUDE_DEG: 52.2206167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012200',
        LOCATION_NAME: 'Bragar',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6230821,
        LOCATION_LATITUDE_DEG: 58.334688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012300',
        LOCATION_NAME: 'Bragbury End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1565366,
        LOCATION_LATITUDE_DEG: 51.8737832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012400',
        LOCATION_NAME: 'Bragenham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6835132,
        LOCATION_LATITUDE_DEG: 51.9497966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012500',
        LOCATION_NAME: 'Braggington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7976743,
        LOCATION_LATITUDE_DEG: 52.1466262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012600',
        LOCATION_NAME: 'Braichmelyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0522315,
        LOCATION_LATITUDE_DEG: 53.1734472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096500',
        LOCATION_NAME: 'Braid Hills',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2001917,
        LOCATION_LATITUDE_DEG: 55.9177121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012700',
        LOCATION_NAME: 'Braidwood',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8279893,
        LOCATION_LATITUDE_DEG: 55.7081926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012800',
        LOCATION_NAME: 'Brailes',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5479404,
        LOCATION_LATITUDE_DEG: 52.0507118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR012900',
        LOCATION_NAME: 'Brailsford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6215477,
        LOCATION_LATITUDE_DEG: 52.9703021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013000',
        LOCATION_NAME: 'Braintree',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5502935,
        LOCATION_LATITUDE_DEG: 51.8769665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013100',
        LOCATION_NAME: 'Braiseworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1291626,
        LOCATION_LATITUDE_DEG: 52.3024032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013200',
        LOCATION_NAME: 'Braishfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4651683,
        LOCATION_LATITUDE_DEG: 51.0238129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013300',
        LOCATION_NAME: 'Braiswick',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8860974,
        LOCATION_LATITUDE_DEG: 51.903464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013400',
        LOCATION_NAME: 'Braithwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1897458,
        LOCATION_LATITUDE_DEG: 54.6022841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013700',
        LOCATION_NAME: 'Braithwaite',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9354968,
        LOCATION_LATITUDE_DEG: 53.8690903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013500',
        LOCATION_NAME: 'Braithwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7822086,
        LOCATION_LATITUDE_DEG: 54.0518139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013600',
        LOCATION_NAME: 'Braithwaite',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0653518,
        LOCATION_LATITUDE_DEG: 53.6046571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013800',
        LOCATION_NAME: 'Braithwell',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2001126,
        LOCATION_LATITUDE_DEG: 53.4462467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR013900',
        LOCATION_NAME: 'Bramber',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3157659,
        LOCATION_LATITUDE_DEG: 50.881889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014000',
        LOCATION_NAME: 'Bramblecombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3109434,
        LOCATION_LATITUDE_DEG: 50.8071079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014100',
        LOCATION_NAME: 'Brambridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3232463,
        LOCATION_LATITUDE_DEG: 50.9919151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014200',
        LOCATION_NAME: 'Bramcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3981721,
        LOCATION_LATITUDE_DEG: 52.4911537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014300',
        LOCATION_NAME: 'Bramcote',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2454883,
        LOCATION_LATITUDE_DEG: 52.9343911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014400',
        LOCATION_NAME: 'Bramdean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1249023,
        LOCATION_LATITUDE_DEG: 51.0476163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014500',
        LOCATION_NAME: 'Bramerton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3874566,
        LOCATION_LATITUDE_DEG: 52.5942225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014700',
        LOCATION_NAME: 'Bramfield',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.125009,
        LOCATION_LATITUDE_DEG: 51.8241735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014600',
        LOCATION_NAME: 'Bramfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5210082,
        LOCATION_LATITUDE_DEG: 52.3093959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014800',
        LOCATION_NAME: 'Bramford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0972431,
        LOCATION_LATITUDE_DEG: 52.0773791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR014900',
        LOCATION_NAME: 'Bramhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1631059,
        LOCATION_LATITUDE_DEG: 53.3591506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015000',
        LOCATION_NAME: 'Bramham',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3538969,
        LOCATION_LATITUDE_DEG: 53.881086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015100',
        LOCATION_NAME: 'Bramhope',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6106007,
        LOCATION_LATITUDE_DEG: 53.8828943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096800',
        LOCATION_NAME: 'Bramley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6342137,
        LOCATION_LATITUDE_DEG: 53.8079014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015200',
        LOCATION_NAME: 'Bramley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2632428,
        LOCATION_LATITUDE_DEG: 53.4250413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015300',
        LOCATION_NAME: 'Bramley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0591738,
        LOCATION_LATITUDE_DEG: 51.3300421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015400',
        LOCATION_NAME: 'Bramley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5570894,
        LOCATION_LATITUDE_DEG: 51.1943202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015500',
        LOCATION_NAME: 'Bramley Green',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0456489,
        LOCATION_LATITUDE_DEG: 51.3232419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015600',
        LOCATION_NAME: 'Bramling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1929264,
        LOCATION_LATITUDE_DEG: 51.2656995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015700',
        LOCATION_NAME: 'Brampford Speke',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5218081,
        LOCATION_LATITUDE_DEG: 50.7752184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016350',
        LOCATION_NAME: 'Brampton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016200',
        LOCATION_NAME: 'Brampton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.736705,
        LOCATION_LATITUDE_DEG: 54.9419067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016300',
        LOCATION_NAME: 'Brampton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3712385,
        LOCATION_LATITUDE_DEG: 53.5051543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015800',
        LOCATION_NAME: 'Brampton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7304344,
        LOCATION_LATITUDE_DEG: 53.3046271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016000',
        LOCATION_NAME: 'Brampton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.21845,
        LOCATION_LATITUDE_DEG: 52.3199185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016100',
        LOCATION_NAME: 'Brampton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2917398,
        LOCATION_LATITUDE_DEG: 52.7729402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR015900',
        LOCATION_NAME: 'Brampton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5790231,
        LOCATION_LATITUDE_DEG: 52.376602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016400',
        LOCATION_NAME: 'Brampton Abbotts',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5767352,
        LOCATION_LATITUDE_DEG: 51.9356112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016500',
        LOCATION_NAME: 'Brampton Ash',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8359907,
        LOCATION_LATITUDE_DEG: 52.4796484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016600',
        LOCATION_NAME: 'Brampton Bierlow',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2670939,
        LOCATION_LATITUDE_DEG: 53.3866425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016700',
        LOCATION_NAME: 'Brampton Bryan',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9246428,
        LOCATION_LATITUDE_DEG: 52.3459552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092800',
        LOCATION_NAME: 'Brampton en le Morthen',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016800',
        LOCATION_NAME: 'Brampton-en-le-Morthen',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2678321,
        LOCATION_LATITUDE_DEG: 53.3821791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR016900',
        LOCATION_NAME: 'Bramshall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9085279,
        LOCATION_LATITUDE_DEG: 52.8950989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017000',
        LOCATION_NAME: 'Bramshaw',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6164951,
        LOCATION_LATITUDE_DEG: 50.9425051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017100',
        LOCATION_NAME: 'Bramshill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9293825,
        LOCATION_LATITUDE_DEG: 51.3457358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017200',
        LOCATION_NAME: 'Bramshott',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7966641,
        LOCATION_LATITUDE_DEG: 51.0893147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017300',
        LOCATION_NAME: 'Bramshott Chase',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.756377,
        LOCATION_LATITUDE_DEG: 51.0968164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017400',
        LOCATION_NAME: 'Bramwith Woodhouse',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0325212,
        LOCATION_LATITUDE_DEG: 53.6073538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017500',
        LOCATION_NAME: 'Bran End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4045738,
        LOCATION_LATITUDE_DEG: 51.9014775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017600',
        LOCATION_NAME: 'Branahuie',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3123228,
        LOCATION_LATITUDE_DEG: 58.2078686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017700',
        LOCATION_NAME: 'Brancaster',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6385805,
        LOCATION_LATITUDE_DEG: 52.9625715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017800',
        LOCATION_NAME: 'Brancaster Staithe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6702065,
        LOCATION_LATITUDE_DEG: 52.9614691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR017900',
        LOCATION_NAME: 'Brancepeth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6549597,
        LOCATION_LATITUDE_DEG: 54.7363791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018000',
        LOCATION_NAME: 'Brancote',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0525861,
        LOCATION_LATITUDE_DEG: 52.8002912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018100',
        LOCATION_NAME: 'Brand Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3784238,
        LOCATION_LATITUDE_DEG: 51.9524122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018200',
        LOCATION_NAME: 'Brand Top',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9359265,
        LOCATION_LATITUDE_DEG: 53.2169276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018300',
        LOCATION_NAME: 'Branderburgh',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2793001,
        LOCATION_LATITUDE_DEG: 57.7226871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018400',
        LOCATION_NAME: 'Brandesburton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2994689,
        LOCATION_LATITUDE_DEG: 53.9120783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018500',
        LOCATION_NAME: 'Brandeston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2921038,
        LOCATION_LATITUDE_DEG: 52.196793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018600',
        LOCATION_NAME: 'Brandhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8531088,
        LOCATION_LATITUDE_DEG: 52.4059626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018700',
        LOCATION_NAME: 'Brandis Corner',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2561151,
        LOCATION_LATITUDE_DEG: 50.8126238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018800',
        LOCATION_NAME: 'Brandiston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.157312,
        LOCATION_LATITUDE_DEG: 52.7520431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR018900',
        LOCATION_NAME: 'Brandlingill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3561496,
        LOCATION_LATITUDE_DEG: 54.623581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019400',
        LOCATION_NAME: 'Brandon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6251029,
        LOCATION_LATITUDE_DEG: 54.7501764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019100',
        LOCATION_NAME: 'Brandon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3994854,
        LOCATION_LATITUDE_DEG: 52.3838414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019000',
        LOCATION_NAME: 'Brandon',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6532964,
        LOCATION_LATITUDE_DEG: 53.0224001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019200',
        LOCATION_NAME: 'Brandon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6252186,
        LOCATION_LATITUDE_DEG: 52.448719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019500',
        LOCATION_NAME: 'Brandon Bank',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.393297,
        LOCATION_LATITUDE_DEG: 52.475729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019600',
        LOCATION_NAME: 'Brandon Creek',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3693923,
        LOCATION_LATITUDE_DEG: 52.5006354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019700',
        LOCATION_NAME: 'Brandon Parva',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0642639,
        LOCATION_LATITUDE_DEG: 52.6301331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019800',
        LOCATION_NAME: 'Brandsby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.098741,
        LOCATION_LATITUDE_DEG: 54.143009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990820',
        LOCATION_NAME: 'Brandside',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019900',
        LOCATION_NAME: 'Brandy Wharf',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4745636,
        LOCATION_LATITUDE_DEG: 53.458739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020000',
        LOCATION_NAME: 'Branksome',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.930207,
        LOCATION_LATITUDE_DEG: 50.7322966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020100',
        LOCATION_NAME: 'Branksome Park',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9157043,
        LOCATION_LATITUDE_DEG: 50.7195879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020300',
        LOCATION_NAME: 'Bransby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6615616,
        LOCATION_LATITUDE_DEG: 53.301123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020400',
        LOCATION_NAME: 'Branscombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1346412,
        LOCATION_LATITUDE_DEG: 50.6893996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020500',
        LOCATION_NAME: 'Bransford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3006396,
        LOCATION_LATITUDE_DEG: 52.1717367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020600',
        LOCATION_NAME: 'Bransgore',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7375572,
        LOCATION_LATITUDE_DEG: 50.7816942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020700',
        LOCATION_NAME: 'Bransholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3228325,
        LOCATION_LATITUDE_DEG: 53.7826618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990535',
        LOCATION_NAME: 'Branston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020800',
        LOCATION_NAME: 'Branston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6517579,
        LOCATION_LATITUDE_DEG: 52.7873849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020900',
        LOCATION_NAME: 'Branston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4704367,
        LOCATION_LATITUDE_DEG: 53.1934084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021000',
        LOCATION_NAME: 'Branston Booths',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4107845,
        LOCATION_LATITUDE_DEG: 53.2082087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021100',
        LOCATION_NAME: 'Branstone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2145348,
        LOCATION_LATITUDE_DEG: 50.649779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021200',
        LOCATION_NAME: 'Bransty',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5853124,
        LOCATION_LATITUDE_DEG: 54.552679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021300',
        LOCATION_NAME: 'Brant Broughton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.631106,
        LOCATION_LATITUDE_DEG: 53.0770989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021400',
        LOCATION_NAME: 'Brantham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0720268,
        LOCATION_LATITUDE_DEG: 51.9688692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021500',
        LOCATION_NAME: 'Branthill',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8303768,
        LOCATION_LATITUDE_DEG: 52.9284692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021600',
        LOCATION_NAME: 'Branthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4573613,
        LOCATION_LATITUDE_DEG: 54.6103872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021700',
        LOCATION_NAME: 'Brantingham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5741767,
        LOCATION_LATITUDE_DEG: 53.7518697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021800',
        LOCATION_NAME: 'Branton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.926636,
        LOCATION_LATITUDE_DEG: 55.4403482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR021900',
        LOCATION_NAME: 'Branton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0319885,
        LOCATION_LATITUDE_DEG: 53.5076441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022000',
        LOCATION_NAME: 'Branxholme',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8442156,
        LOCATION_LATITUDE_DEG: 55.3961542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022100',
        LOCATION_NAME: 'Branxton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1678225,
        LOCATION_LATITUDE_DEG: 55.6317652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022200',
        LOCATION_NAME: 'Brassey Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7069508,
        LOCATION_LATITUDE_DEG: 53.142037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022300',
        LOCATION_NAME: 'Brasside',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.553529,
        LOCATION_LATITUDE_DEG: 54.8043812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022400',
        LOCATION_NAME: 'Brassington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6537055,
        LOCATION_LATITUDE_DEG: 53.0850164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022500',
        LOCATION_NAME: 'Brasswell',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5583223,
        LOCATION_LATITUDE_DEG: 55.0672324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022600',
        LOCATION_NAME: 'Brasted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1123945,
        LOCATION_LATITUDE_DEG: 51.2761209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022700',
        LOCATION_NAME: 'Brasted Chart',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1033606,
        LOCATION_LATITUDE_DEG: 51.2579175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022800',
        LOCATION_NAME: 'Bratoft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2062035,
        LOCATION_LATITUDE_DEG: 53.1613964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR022900',
        LOCATION_NAME: 'Brattleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.57609,
        LOCATION_LATITUDE_DEG: 53.3160195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023100',
        LOCATION_NAME: 'Bratton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5062463,
        LOCATION_LATITUDE_DEG: 51.2052586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023000',
        LOCATION_NAME: 'Bratton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1225579,
        LOCATION_LATITUDE_DEG: 51.2700512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023200',
        LOCATION_NAME: 'Bratton Clovelly',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1755268,
        LOCATION_LATITUDE_DEG: 50.7034183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023300',
        LOCATION_NAME: 'Bratton Fleming',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9379109,
        LOCATION_LATITUDE_DEG: 51.1223553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023400',
        LOCATION_NAME: 'Bratton Seymour',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4588579,
        LOCATION_LATITUDE_DEG: 51.0660356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023500',
        LOCATION_NAME: 'Braughing',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0284822,
        LOCATION_LATITUDE_DEG: 51.9061803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023600',
        LOCATION_NAME: 'Brauncewell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4384144,
        LOCATION_LATITUDE_DEG: 53.0590007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023700',
        LOCATION_NAME: 'Braunston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2082755,
        LOCATION_LATITUDE_DEG: 52.290634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023800',
        LOCATION_NAME: 'Braunston',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7681332,
        LOCATION_LATITUDE_DEG: 52.6501579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990116',
        LOCATION_NAME: 'Braunston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7640597,
        LOCATION_LATITUDE_DEG: 52.6535861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR023900',
        LOCATION_NAME: 'Braunstone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2017661,
        LOCATION_LATITUDE_DEG: 52.6267016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024000',
        LOCATION_NAME: 'Braunton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.163503,
        LOCATION_LATITUDE_DEG: 51.1111573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024100',
        LOCATION_NAME: 'Brawby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8702751,
        LOCATION_LATITUDE_DEG: 54.1932092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024200',
        LOCATION_NAME: 'Brawdy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1126859,
        LOCATION_LATITUDE_DEG: 51.8730379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024300',
        LOCATION_NAME: 'Bray',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6993083,
        LOCATION_LATITUDE_DEG: 51.5056521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024500',
        LOCATION_NAME: 'Bray Shop',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3561368,
        LOCATION_LATITUDE_DEG: 50.546104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024600',
        LOCATION_NAME: 'Braybrooke',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.873994,
        LOCATION_LATITUDE_DEG: 52.4533475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024700',
        LOCATION_NAME: 'Braydon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9237736,
        LOCATION_LATITUDE_DEG: 51.5912708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024800',
        LOCATION_NAME: 'Brayford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.872183,
        LOCATION_LATITUDE_DEG: 51.0958504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024900',
        LOCATION_NAME: 'Braystones',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5308002,
        LOCATION_LATITUDE_DEG: 54.4394724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025100',
        LOCATION_NAME: 'Brayton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2927229,
        LOCATION_LATITUDE_DEG: 54.7731951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025000',
        LOCATION_NAME: 'Brayton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0818136,
        LOCATION_LATITUDE_DEG: 53.7660746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025200',
        LOCATION_NAME: 'Brayton Domain',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3381136,
        LOCATION_LATITUDE_DEG: 54.7535935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025300',
        LOCATION_NAME: 'Brazacott',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.455247,
        LOCATION_LATITUDE_DEG: 50.6930204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025400',
        LOCATION_NAME: 'Braziers End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6474508,
        LOCATION_LATITUDE_DEG: 51.7507781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025500',
        LOCATION_NAME: 'Brea',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2745323,
        LOCATION_LATITUDE_DEG: 50.2130809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025600',
        LOCATION_NAME: 'Breachwood Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3262745,
        LOCATION_LATITUDE_DEG: 51.8843783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025700',
        LOCATION_NAME: 'Breaclete',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8401263,
        LOCATION_LATITUDE_DEG: 58.2279772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990191',
        LOCATION_NAME: 'Breaden Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8241711,
        LOCATION_LATITUDE_DEG: 52.9260797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025800',
        LOCATION_NAME: 'Breadsall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4487972,
        LOCATION_LATITUDE_DEG: 52.9540013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR025900',
        LOCATION_NAME: 'Breadstone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4183269,
        LOCATION_LATITUDE_DEG: 51.7048877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026000',
        LOCATION_NAME: 'Bready',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3272275,
        LOCATION_LATITUDE_DEG: 54.8636436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026100',
        LOCATION_NAME: 'Breage',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3310566,
        LOCATION_LATITUDE_DEG: 50.1082734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990455',
        LOCATION_NAME: 'Breakachy Farm',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026300',
        LOCATION_NAME: 'Breakish',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8500766,
        LOCATION_LATITUDE_DEG: 57.2457651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026400',
        LOCATION_NAME: 'Bream',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5745504,
        LOCATION_LATITUDE_DEG: 51.7460956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026500',
        LOCATION_NAME: 'Breamore',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7738597,
        LOCATION_LATITUDE_DEG: 50.9608126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026600',
        LOCATION_NAME: 'Brean',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0092519,
        LOCATION_LATITUDE_DEG: 51.2879604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026700',
        LOCATION_NAME: 'Breandrum',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6305799,
        LOCATION_LATITUDE_DEG: 54.3469023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027100',
        LOCATION_NAME: 'Brearley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9602999,
        LOCATION_LATITUDE_DEG: 53.7279826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027200',
        LOCATION_NAME: 'Brearton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5066107,
        LOCATION_LATITUDE_DEG: 54.0441048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027300',
        LOCATION_NAME: 'Breasclete',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7494461,
        LOCATION_LATITUDE_DEG: 58.2177768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027400',
        LOCATION_NAME: 'Breaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3149567,
        LOCATION_LATITUDE_DEG: 52.8970967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027500',
        LOCATION_NAME: 'Brechfa',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1477178,
        LOCATION_LATITUDE_DEG: 51.9505328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027600',
        LOCATION_NAME: 'Brechin',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.657297,
        LOCATION_LATITUDE_DEG: 56.7326837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027700',
        LOCATION_NAME: 'Breckenbrough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4152306,
        LOCATION_LATITUDE_DEG: 54.2472249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027800',
        LOCATION_NAME: 'Breckles',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8730998,
        LOCATION_LATITUDE_DEG: 52.5081231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027900',
        LOCATION_NAME: 'Brecklet',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.644329,
        LOCATION_LATITUDE_DEG: 55.342499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028000',
        LOCATION_NAME: 'Brecknock',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3883793,
        LOCATION_LATITUDE_DEG: 51.9461111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028100',
        LOCATION_NAME: 'Brecon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3900468,
        LOCATION_LATITUDE_DEG: 51.9487442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028200',
        LOCATION_NAME: 'Bredbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1190541,
        LOCATION_LATITUDE_DEG: 53.421357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028300',
        LOCATION_NAME: 'Brede',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5990333,
        LOCATION_LATITUDE_DEG: 50.9353776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028400',
        LOCATION_NAME: 'Bredenbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.571929,
        LOCATION_LATITUDE_DEG: 52.2035437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028500',
        LOCATION_NAME: 'Bredfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3159483,
        LOCATION_LATITUDE_DEG: 52.1271852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028600',
        LOCATION_NAME: 'Bredgar',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6972656,
        LOCATION_LATITUDE_DEG: 51.3102182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028700',
        LOCATION_NAME: 'Bredhurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5776569,
        LOCATION_LATITUDE_DEG: 51.3304174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028800',
        LOCATION_NAME: 'Bredicot',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1365316,
        LOCATION_LATITUDE_DEG: 52.1916332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR028900',
        LOCATION_NAME: 'Bredon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1066214,
        LOCATION_LATITUDE_DEG: 52.0301213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029000',
        LOCATION_NAME: 'Bredons Hardwick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1282875,
        LOCATION_LATITUDE_DEG: 52.0161176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029100',
        LOCATION_NAME: 'Bredons Norton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1018261,
        LOCATION_LATITUDE_DEG: 52.0497185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029200',
        LOCATION_NAME: 'Bredward',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0498289,
        LOCATION_LATITUDE_DEG: 52.1899461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029300',
        LOCATION_NAME: 'Bredwardine',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9752024,
        LOCATION_LATITUDE_DEG: 52.0944368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092600',
        LOCATION_NAME: 'Breedon on the Hill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029600',
        LOCATION_NAME: 'Breedon-on-the-Hill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4007502,
        LOCATION_LATITUDE_DEG: 52.8014871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029800',
        LOCATION_NAME: 'Breich',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6520481,
        LOCATION_LATITUDE_DEG: 55.8293022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029900',
        LOCATION_NAME: 'Breightmet',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.386326,
        LOCATION_LATITUDE_DEG: 53.5819737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030000',
        LOCATION_NAME: 'Breighton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9237282,
        LOCATION_LATITUDE_DEG: 53.7980747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030100',
        LOCATION_NAME: 'Breinton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7687602,
        LOCATION_LATITUDE_DEG: 52.0547092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030200',
        LOCATION_NAME: 'Bremhill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.030199,
        LOCATION_LATITUDE_DEG: 51.4563596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030300',
        LOCATION_NAME: 'Bremhill Bridge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.84217,
        LOCATION_LATITUDE_DEG: 51.5806774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030400',
        LOCATION_NAME: 'Brenchley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3995809,
        LOCATION_LATITUDE_DEG: 51.1510008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030500',
        LOCATION_NAME: 'Brendon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.76235,
        LOCATION_LATITUDE_DEG: 51.2187603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030600',
        LOCATION_NAME: 'Brendon Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4003377,
        LOCATION_LATITUDE_DEG: 51.0949453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030700',
        LOCATION_NAME: 'Brent Eleigh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8373619,
        LOCATION_LATITUDE_DEG: 52.0983894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030800',
        LOCATION_NAME: 'Brent Knoll',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9551794,
        LOCATION_LATITUDE_DEG: 51.2511554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR030900',
        LOCATION_NAME: 'Brent Pelham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0872887,
        LOCATION_LATITUDE_DEG: 51.9561796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031000',
        LOCATION_NAME: 'Brentfields',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5128339,
        LOCATION_LATITUDE_DEG: 50.332685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031100',
        LOCATION_NAME: 'Brentford',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.306691,
        LOCATION_LATITUDE_DEG: 51.4860442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031200',
        LOCATION_NAME: 'Brentingby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8561251,
        LOCATION_LATITUDE_DEG: 52.7594732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031300',
        LOCATION_NAME: 'Brentor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1655153,
        LOCATION_LATITUDE_DEG: 50.5995048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031400',
        LOCATION_NAME: 'Brentry',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.609647,
        LOCATION_LATITUDE_DEG: 51.5086716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031500',
        LOCATION_NAME: 'Brentwood',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3042504,
        LOCATION_LATITUDE_DEG: 51.6199469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031600',
        LOCATION_NAME: 'Brenzett',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8553714,
        LOCATION_LATITUDE_DEG: 51.0094838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031800',
        LOCATION_NAME: 'Brereton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3318699,
        LOCATION_LATITUDE_DEG: 53.1664356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031700',
        LOCATION_NAME: 'Brereton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9190681,
        LOCATION_LATITUDE_DEG: 52.743284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR031900',
        LOCATION_NAME: 'Brereton Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3364573,
        LOCATION_LATITUDE_DEG: 53.1753319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032000',
        LOCATION_NAME: 'Brereton Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3077071,
        LOCATION_LATITUDE_DEG: 53.1807317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032100',
        LOCATION_NAME: 'Bressay',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1056253,
        LOCATION_LATITUDE_DEG: 60.1535011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032200',
        LOCATION_NAME: 'Bressingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0508243,
        LOCATION_LATITUDE_DEG: 52.3857103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032300',
        LOCATION_NAME: 'Bretby',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.561665,
        LOCATION_LATITUDE_DEG: 52.8053912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032400',
        LOCATION_NAME: 'Bretford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3688687,
        LOCATION_LATITUDE_DEG: 52.3906412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032500',
        LOCATION_NAME: 'Bretforton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8653121,
        LOCATION_LATITUDE_DEG: 52.0946257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032600',
        LOCATION_NAME: 'Bretherdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6545984,
        LOCATION_LATITUDE_DEG: 54.4375546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032700',
        LOCATION_NAME: 'Bretherton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7989398,
        LOCATION_LATITUDE_DEG: 53.681089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032800',
        LOCATION_NAME: 'Brettabister',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1272402,
        LOCATION_LATITUDE_DEG: 60.2996201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR032900',
        LOCATION_NAME: 'Brettell Lane',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.131865,
        LOCATION_LATITUDE_DEG: 52.4829633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033000',
        LOCATION_NAME: 'Brettenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8392192,
        LOCATION_LATITUDE_DEG: 52.4149194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033100',
        LOCATION_NAME: 'Brettenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.862514,
        LOCATION_LATITUDE_DEG: 52.1453878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033300',
        LOCATION_NAME: 'Bretton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9673043,
        LOCATION_LATITUDE_DEG: 53.1665395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033400',
        LOCATION_NAME: 'Bretton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5656988,
        LOCATION_LATITUDE_DEG: 53.6185668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033200',
        LOCATION_NAME: 'Bretton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.282093,
        LOCATION_LATITUDE_DEG: 52.5910465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033500',
        LOCATION_NAME: 'Brevig',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4522758,
        LOCATION_LATITUDE_DEG: 56.9613542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033600',
        LOCATION_NAME: 'Brewood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1724743,
        LOCATION_LATITUDE_DEG: 52.6765834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033700',
        LOCATION_NAME: 'Briantspuddle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2600425,
        LOCATION_LATITUDE_DEG: 50.7376936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033800',
        LOCATION_NAME: 'Brick Kiln Turn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6848315,
        LOCATION_LATITUDE_DEG: 52.3820613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034000',
        LOCATION_NAME: 'Brickendon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0836975,
        LOCATION_LATITUDE_DEG: 51.7545652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034200',
        LOCATION_NAME: 'Bricket Wood',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3671984,
        LOCATION_LATITUDE_DEG: 51.705266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034300',
        LOCATION_NAME: 'Bricklehampton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0289385,
        LOCATION_LATITUDE_DEG: 52.0780196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034400',
        LOCATION_NAME: 'Brickpool',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3287595,
        LOCATION_LATITUDE_DEG: 53.4141804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034500',
        LOCATION_NAME: 'Brickyard',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6281564,
        LOCATION_LATITUDE_DEG: 52.3798585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034600',
        LOCATION_NAME: 'Bride',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3927223,
        LOCATION_LATITUDE_DEG: 54.3825055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034800',
        LOCATION_NAME: 'Bridekirk',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3679909,
        LOCATION_LATITUDE_DEG: 54.6892892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034900',
        LOCATION_NAME: 'Bridell',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6586186,
        LOCATION_LATITUDE_DEG: 52.0472455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035000',
        LOCATION_NAME: 'Bridens Camp',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4837051,
        LOCATION_LATITUDE_DEG: 51.7899756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035100',
        LOCATION_NAME: 'Bridestowe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1021968,
        LOCATION_LATITUDE_DEG: 50.6847145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035300',
        LOCATION_NAME: 'Bridford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6715328,
        LOCATION_LATITUDE_DEG: 50.6661073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035900',
        LOCATION_NAME: 'Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2584351,
        LOCATION_LATITUDE_DEG: 50.2580875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035800',
        LOCATION_NAME: 'Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9354939,
        LOCATION_LATITUDE_DEG: 50.4376964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036000',
        LOCATION_NAME: 'Bridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0607552,
        LOCATION_LATITUDE_DEG: 52.7983043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035600',
        LOCATION_NAME: 'Bridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9049922,
        LOCATION_LATITUDE_DEG: 50.846211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035700',
        LOCATION_NAME: 'Bridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7873843,
        LOCATION_LATITUDE_DEG: 50.9442218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035500',
        LOCATION_NAME: 'Bridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3013282,
        LOCATION_LATITUDE_DEG: 50.9186167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035400',
        LOCATION_NAME: 'Bridge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1278834,
        LOCATION_LATITUDE_DEG: 51.2448056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036100',
        LOCATION_NAME: 'Bridge Ball',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8026377,
        LOCATION_LATITUDE_DEG: 51.2081633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR093600',
        LOCATION_NAME: 'Bridge End',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9138616,
        LOCATION_LATITUDE_DEG: 54.6007106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036300',
        LOCATION_NAME: 'Bridge End',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8355817,
        LOCATION_LATITUDE_DEG: 50.3064761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036400',
        LOCATION_NAME: 'Bridge End',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3254156,
        LOCATION_LATITUDE_DEG: 60.0753991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036200',
        LOCATION_NAME: 'Bridge End',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.299967,
        LOCATION_LATITUDE_DEG: 52.9112813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036600',
        LOCATION_NAME: 'Bridge Hewick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4853742,
        LOCATION_LATITUDE_DEG: 54.1274129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036700',
        LOCATION_NAME: 'Bridge Moor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.261126,
        LOCATION_LATITUDE_DEG: 50.2561856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037500',
        LOCATION_NAME: 'Bridge of Alford',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.726955,
        LOCATION_LATITUDE_DEG: 57.2438356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037600',
        LOCATION_NAME: 'Bridge of Allan',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9444463,
        LOCATION_LATITUDE_DEG: 56.154543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036800',
        LOCATION_NAME: 'Bridge Of Balgie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3178186,
        LOCATION_LATITUDE_DEG: 56.5913928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037700',
        LOCATION_NAME: 'Bridge of Cally',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4028202,
        LOCATION_LATITUDE_DEG: 56.6464863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037800',
        LOCATION_NAME: 'Bridge of Canny',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5685377,
        LOCATION_LATITUDE_DEG: 57.0646167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038000',
        LOCATION_NAME: 'Bridge of Dee',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.976634,
        LOCATION_LATITUDE_DEG: 54.9200219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037900',
        LOCATION_NAME: 'Bridge of Dee',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1152993,
        LOCATION_LATITUDE_DEG: 57.1144128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038100',
        LOCATION_NAME: 'Bridge of Don',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1082244,
        LOCATION_LATITUDE_DEG: 57.185618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036900',
        LOCATION_NAME: 'Bridge Of Dun',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5519027,
        LOCATION_LATITUDE_DEG: 56.7186843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038200',
        LOCATION_NAME: 'Bridge of Earn',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4053125,
        LOCATION_LATITUDE_DEG: 56.3494504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038300',
        LOCATION_NAME: 'Bridge of Gairn',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0675218,
        LOCATION_LATITUDE_DEG: 57.0591218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038400',
        LOCATION_NAME: 'Bridge of Gaur',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4432331,
        LOCATION_LATITUDE_DEG: 56.6767958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038500',
        LOCATION_NAME: 'Bridge of Marnoch',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6604026,
        LOCATION_LATITUDE_DEG: 57.535365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038600',
        LOCATION_NAME: 'Bridge of Muchalls',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1800678,
        LOCATION_LATITUDE_DEG: 57.0125093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038700',
        LOCATION_NAME: 'Bridge of Orchy',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7639935,
        LOCATION_LATITUDE_DEG: 56.517588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038800',
        LOCATION_NAME: 'Bridge of Tilt',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8336009,
        LOCATION_LATITUDE_DEG: 56.7696989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR038900',
        LOCATION_NAME: 'Bridge of Urr',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9109194,
        LOCATION_LATITUDE_DEG: 54.9895243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039000',
        LOCATION_NAME: 'Bridge of Walls',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5224877,
        LOCATION_LATITUDE_DEG: 60.2445159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039100',
        LOCATION_NAME: 'Bridge of Weir',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5729652,
        LOCATION_LATITUDE_DEG: 55.8552184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037000',
        LOCATION_NAME: 'Bridge Reeve',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.89799,
        LOCATION_LATITUDE_DEG: 50.9012292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037100',
        LOCATION_NAME: 'Bridge Sollars',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8546678,
        LOCATION_LATITUDE_DEG: 52.0789351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037200',
        LOCATION_NAME: 'Bridge Street',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7435538,
        LOCATION_LATITUDE_DEG: 52.1082923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037400',
        LOCATION_NAME: 'Bridge Trafford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8244875,
        LOCATION_LATITUDE_DEG: 53.2349411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039300',
        LOCATION_NAME: 'Bridgefoot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4635331,
        LOCATION_LATITUDE_DEG: 54.6485867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039200',
        LOCATION_NAME: 'Bridgefoot',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0121458,
        LOCATION_LATITUDE_DEG: 56.5058613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039400',
        LOCATION_NAME: 'Bridgehampton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6166551,
        LOCATION_LATITUDE_DEG: 51.0130314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039500',
        LOCATION_NAME: 'Bridgehill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8587627,
        LOCATION_LATITUDE_DEG: 54.8612919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039700',
        LOCATION_NAME: 'Bridgemary',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1655829,
        LOCATION_LATITUDE_DEG: 50.8278952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039800',
        LOCATION_NAME: 'Bridgemead',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8090713,
        LOCATION_LATITUDE_DEG: 51.560674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039900',
        LOCATION_NAME: 'Bridgemere',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4228577,
        LOCATION_LATITUDE_DEG: 53.0066171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040550',
        LOCATION_NAME: 'Bridgend',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.24843,
        LOCATION_LATITUDE_DEG: 55.7813076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040400',
        LOCATION_NAME: 'Bridgend',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0301073,
        LOCATION_LATITUDE_DEG: 50.314881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040500',
        LOCATION_NAME: 'Bridgend',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5797123,
        LOCATION_LATITUDE_DEG: 51.5068843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040200',
        LOCATION_NAME: 'Bridgend',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5327171,
        LOCATION_LATITUDE_DEG: 55.9642154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040100',
        LOCATION_NAME: 'Bridgend',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.040405,
        LOCATION_LATITUDE_DEG: 57.3719511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040000',
        LOCATION_NAME: 'Bridgend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2990534,
        LOCATION_LATITUDE_DEG: 51.7397908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040600',
        LOCATION_NAME: 'Bridgerule',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4466957,
        LOCATION_LATITUDE_DEG: 50.7988231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040700',
        LOCATION_NAME: 'Bridges',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7461107,
        LOCATION_LATITUDE_DEG: 50.3888953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040800',
        LOCATION_NAME: 'Bridges',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.894783,
        LOCATION_LATITUDE_DEG: 52.5624805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040900',
        LOCATION_NAME: 'Bridges Stone',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3642059,
        LOCATION_LATITUDE_DEG: 52.165839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041000',
        LOCATION_NAME: 'Bridgeton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2240965,
        LOCATION_LATITUDE_DEG: 55.8487177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041600',
        LOCATION_NAME: 'Bridgetown',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5369944,
        LOCATION_LATITUDE_DEG: 51.088048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041500',
        LOCATION_NAME: 'Bridgetown',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6957398,
        LOCATION_LATITUDE_DEG: 52.1858261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041700',
        LOCATION_NAME: 'Bridgeyate',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4547288,
        LOCATION_LATITUDE_DEG: 51.4563721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041800',
        LOCATION_NAME: 'Bridgham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.885244,
        LOCATION_LATITUDE_DEG: 52.4363164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041900',
        LOCATION_NAME: 'Bridgnorth',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4227209,
        LOCATION_LATITUDE_DEG: 52.5349691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042000',
        LOCATION_NAME: 'Bridgtown',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.027483,
        LOCATION_LATITUDE_DEG: 52.6759774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042100',
        LOCATION_NAME: 'Bridgwater',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9935824,
        LOCATION_LATITUDE_DEG: 51.1312432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042200',
        LOCATION_NAME: 'Bridlington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1905396,
        LOCATION_LATITUDE_DEG: 54.082889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042300',
        LOCATION_NAME: 'Bridport',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7506336,
        LOCATION_LATITUDE_DEG: 50.7330044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042400',
        LOCATION_NAME: 'Bridstow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6042051,
        LOCATION_LATITUDE_DEG: 51.9197105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042500',
        LOCATION_NAME: 'Briercliffe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1933354,
        LOCATION_LATITUDE_DEG: 53.8114945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042600',
        LOCATION_NAME: 'Brierfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2328017,
        LOCATION_LATITUDE_DEG: 53.8235955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042900',
        LOCATION_NAME: 'Brierley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7357042,
        LOCATION_LATITUDE_DEG: 52.1999388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042800',
        LOCATION_NAME: 'Brierley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5442254,
        LOCATION_LATITUDE_DEG: 51.8336078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042700',
        LOCATION_NAME: 'Brierley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3841001,
        LOCATION_LATITUDE_DEG: 53.595665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043000',
        LOCATION_NAME: 'Brierley Hill',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9653009,
        LOCATION_LATITUDE_DEG: 52.3063549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043100',
        LOCATION_NAME: 'Brierley Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1201066,
        LOCATION_LATITUDE_DEG: 52.4806652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043200',
        LOCATION_NAME: 'Brierlow Bar',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8708116,
        LOCATION_LATITUDE_DEG: 53.2245342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043300',
        LOCATION_NAME: 'Brierton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2605021,
        LOCATION_LATITUDE_DEG: 54.6614625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043400',
        LOCATION_NAME: 'Briestfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.654676,
        LOCATION_LATITUDE_DEG: 53.6500674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043500',
        LOCATION_NAME: "Brig O'Turk",
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3607738,
        LOCATION_LATITUDE_DEG: 56.2296582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043600',
        LOCATION_NAME: 'Brigg',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4892911,
        LOCATION_LATITUDE_DEG: 53.5534418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043700',
        LOCATION_NAME: 'Briggate',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4334471,
        LOCATION_LATITUDE_DEG: 52.7937454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043800',
        LOCATION_NAME: 'Briggington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6285374,
        LOCATION_LATITUDE_DEG: 51.9200874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR043900',
        LOCATION_NAME: 'Briggswath',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6572163,
        LOCATION_LATITUDE_DEG: 54.4645401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044100',
        LOCATION_NAME: 'Brigham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4160582,
        LOCATION_LATITUDE_DEG: 54.6593892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044000',
        LOCATION_NAME: 'Brigham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3481765,
        LOCATION_LATITUDE_DEG: 53.9734854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044200',
        LOCATION_NAME: 'Brighouse',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7811526,
        LOCATION_LATITUDE_DEG: 53.7025747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044300',
        LOCATION_NAME: 'Brighstone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4019316,
        LOCATION_LATITUDE_DEG: 50.6443798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044400',
        LOCATION_NAME: 'Brighthampton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4436189,
        LOCATION_LATITUDE_DEG: 51.7292866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044500',
        LOCATION_NAME: 'Brightholmlee',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5661917,
        LOCATION_LATITUDE_DEG: 53.4508517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044600',
        LOCATION_NAME: 'Brightling',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3996226,
        LOCATION_LATITUDE_DEG: 50.9624861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044700',
        LOCATION_NAME: 'Brightlingsea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0278949,
        LOCATION_LATITUDE_DEG: 51.8103538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044800',
        LOCATION_NAME: 'Brighton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1440612,
        LOCATION_LATITUDE_DEG: 50.8230782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR044900',
        LOCATION_NAME: 'Brighton 5',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2620474,
        LOCATION_LATITUDE_DEG: 50.9213327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045000',
        LOCATION_NAME: 'Brighton 6',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1528898,
        LOCATION_LATITUDE_DEG: 50.9267171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045100',
        LOCATION_NAME: 'Brighton 7',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0163795,
        LOCATION_LATITUDE_DEG: 50.8751602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094900',
        LOCATION_NAME: 'Brighton le Sands',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0390114,
        LOCATION_LATITUDE_DEG: 53.4842677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045200',
        LOCATION_NAME: 'Brighton Marina',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0960255,
        LOCATION_LATITUDE_DEG: 50.8114746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045300',
        LOCATION_NAME: 'Brighton Marina Village',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0973311,
        LOCATION_LATITUDE_DEG: 50.8177741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045400',
        LOCATION_NAME: 'Brightons',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7192195,
        LOCATION_LATITUDE_DEG: 55.9814189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045500',
        LOCATION_NAME: 'Brightside',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4291993,
        LOCATION_LATITUDE_DEG: 53.4009403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045600',
        LOCATION_NAME: 'Brightwalton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3862533,
        LOCATION_LATITUDE_DEG: 51.5102599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045700',
        LOCATION_NAME: 'Brightwell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2807785,
        LOCATION_LATITUDE_DEG: 52.0429762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045800',
        LOCATION_NAME: 'Brightwell Baldwin',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0562063,
        LOCATION_LATITUDE_DEG: 51.6479676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092900',
        LOCATION_NAME: 'Brightwell cum Sotwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR045900',
        LOCATION_NAME: 'Brightwell-cum-Sotwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1616435,
        LOCATION_LATITUDE_DEG: 51.6165654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046000',
        LOCATION_NAME: 'Brighty',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9020028,
        LOCATION_LATITUDE_DEG: 56.5384643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046100',
        LOCATION_NAME: 'Brignall',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8939718,
        LOCATION_LATITUDE_DEG: 54.5052532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046200',
        LOCATION_NAME: 'Brigsley',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1087305,
        LOCATION_LATITUDE_DEG: 53.4996304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046300',
        LOCATION_NAME: 'Brigsteer',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7986898,
        LOCATION_LATITUDE_DEG: 54.3000457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046400',
        LOCATION_NAME: 'Brigstock',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6070532,
        LOCATION_LATITUDE_DEG: 52.4580398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046500',
        LOCATION_NAME: 'Brill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0501332,
        LOCATION_LATITUDE_DEG: 51.818685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046600',
        LOCATION_NAME: 'Brilley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0792091,
        LOCATION_LATITUDE_DEG: 52.1368447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046700',
        LOCATION_NAME: 'Brimfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6952854,
        LOCATION_LATITUDE_DEG: 52.3057533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046800',
        LOCATION_NAME: 'Brimington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3923364,
        LOCATION_LATITUDE_DEG: 53.2568307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR046900',
        LOCATION_NAME: 'Brimley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6955878,
        LOCATION_LATITUDE_DEG: 50.5803018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047000',
        LOCATION_NAME: 'Brimpsfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0878573,
        LOCATION_LATITUDE_DEG: 51.8127945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047100',
        LOCATION_NAME: 'Brimpton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1965448,
        LOCATION_LATITUDE_DEG: 51.3788444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047200',
        LOCATION_NAME: 'Brimpton Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1844853,
        LOCATION_LATITUDE_DEG: 51.363644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047300',
        LOCATION_NAME: 'Brimscombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1910193,
        LOCATION_LATITUDE_DEG: 51.7198916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047400',
        LOCATION_NAME: 'Brimsdown',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'EN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0271998,
        LOCATION_LATITUDE_DEG: 51.6520585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047500',
        LOCATION_NAME: 'Brimslade',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6975656,
        LOCATION_LATITUDE_DEG: 51.3687536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047600',
        LOCATION_NAME: 'Brimsmore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6549668,
        LOCATION_LATITUDE_DEG: 50.9495182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047700',
        LOCATION_NAME: 'Brimstage',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0432751,
        LOCATION_LATITUDE_DEG: 53.3372526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047800',
        LOCATION_NAME: 'Brind',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.871451,
        LOCATION_LATITUDE_DEG: 53.7696726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR047900',
        LOCATION_NAME: 'Brindle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6078261,
        LOCATION_LATITUDE_DEG: 53.7131885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048000',
        LOCATION_NAME: 'Brindley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6041827,
        LOCATION_LATITUDE_DEG: 53.0766237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048100',
        LOCATION_NAME: 'Brindley Ford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1808079,
        LOCATION_LATITUDE_DEG: 53.0888261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048200',
        LOCATION_NAME: 'Brineton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2861387,
        LOCATION_LATITUDE_DEG: 52.7199864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048300',
        LOCATION_NAME: 'Bringhurst',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7591774,
        LOCATION_LATITUDE_DEG: 52.520948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048400',
        LOCATION_NAME: 'Bringsty',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4355847,
        LOCATION_LATITUDE_DEG: 52.1936416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048500',
        LOCATION_NAME: 'Brington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4077529,
        LOCATION_LATITUDE_DEG: 52.3680324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048600',
        LOCATION_NAME: 'Briningham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0264196,
        LOCATION_LATITUDE_DEG: 52.8679533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048700',
        LOCATION_NAME: 'Brinkhill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0568463,
        LOCATION_LATITUDE_DEG: 53.2414065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048800',
        LOCATION_NAME: 'Brinkley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9292982,
        LOCATION_LATITUDE_DEG: 53.0669035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR048900',
        LOCATION_NAME: 'Brinkley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3828832,
        LOCATION_LATITUDE_DEG: 52.1665998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049000',
        LOCATION_NAME: 'Brinklow',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3581296,
        LOCATION_LATITUDE_DEG: 52.4126479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049100',
        LOCATION_NAME: 'Brinklow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7152463,
        LOCATION_LATITUDE_DEG: 52.0415988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049200',
        LOCATION_NAME: 'Brinkworth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9804666,
        LOCATION_LATITUDE_DEG: 51.5584717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049500',
        LOCATION_NAME: 'Brinscall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5664646,
        LOCATION_LATITUDE_DEG: 53.6877807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049600',
        LOCATION_NAME: 'Brinsford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1174387,
        LOCATION_LATITUDE_DEG: 52.6454798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049700',
        LOCATION_NAME: 'Brinsley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3113188,
        LOCATION_LATITUDE_DEG: 53.0336046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049800',
        LOCATION_NAME: 'Brinsop',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8187659,
        LOCATION_LATITUDE_DEG: 52.0988371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049900',
        LOCATION_NAME: 'Brinsworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3752605,
        LOCATION_LATITUDE_DEG: 53.4038437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050000',
        LOCATION_NAME: 'Brinton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0287501,
        LOCATION_LATITUDE_DEG: 52.8800625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050100',
        LOCATION_NAME: 'Brisco',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9017271,
        LOCATION_LATITUDE_DEG: 54.8582064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050400',
        LOCATION_NAME: 'Brisley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8885426,
        LOCATION_LATITUDE_DEG: 52.7556515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096100',
        LOCATION_NAME: 'Brislington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5472777,
        LOCATION_LATITUDE_DEG: 51.4377485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050500',
        LOCATION_NAME: 'Bristol BS 1',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5972756,
        LOCATION_LATITUDE_DEG: 51.4508136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050600',
        LOCATION_NAME: 'Bristol BS 2',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5847746,
        LOCATION_LATITUDE_DEG: 51.4603099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050700',
        LOCATION_NAME: 'Bristol BS 3',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6116902,
        LOCATION_LATITUDE_DEG: 51.4373761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050800',
        LOCATION_NAME: 'Bristol BS 4',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5592983,
        LOCATION_LATITUDE_DEG: 51.4335461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050900',
        LOCATION_NAME: 'Bristol BS 5',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5494652,
        LOCATION_LATITUDE_DEG: 51.4641587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051000',
        LOCATION_NAME: 'Bristol BS 6',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6020851,
        LOCATION_LATITUDE_DEG: 51.4717779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051100',
        LOCATION_NAME: 'Bristol BS 7',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5775922,
        LOCATION_LATITUDE_DEG: 51.4877551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990167',
        LOCATION_NAME: 'Bristol BS 8',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.65492,
        LOCATION_LATITUDE_DEG: 51.4599931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051300',
        LOCATION_NAME: 'Bristol BS 9',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6329244,
        LOCATION_LATITUDE_DEG: 51.4839804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051400',
        LOCATION_NAME: 'Bristol BS10',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6287465,
        LOCATION_LATITUDE_DEG: 51.5174195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051500',
        LOCATION_NAME: 'Bristol BS11',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6793179,
        LOCATION_LATITUDE_DEG: 51.5053752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095400',
        LOCATION_NAME: 'Bristol BS12',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094000',
        LOCATION_NAME: 'Bristol BS12',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6233309,
        LOCATION_LATITUDE_DEG: 51.4278994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051600',
        LOCATION_NAME: 'Bristol BS13',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6121685,
        LOCATION_LATITUDE_DEG: 51.4182641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051700',
        LOCATION_NAME: 'Bristol BS14',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5629063,
        LOCATION_LATITUDE_DEG: 51.4204085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051800',
        LOCATION_NAME: 'Bristol BS15',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5068176,
        LOCATION_LATITUDE_DEG: 51.4546837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR051900',
        LOCATION_NAME: 'Bristol BS16',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4914606,
        LOCATION_LATITUDE_DEG: 51.4896315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095600',
        LOCATION_NAME: 'Bristol BS17',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095200',
        LOCATION_NAME: 'Bristol BS17',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.414253,
        LOCATION_LATITUDE_DEG: 51.5454764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052000',
        LOCATION_NAME: 'Bristol BS30',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4434328,
        LOCATION_LATITUDE_DEG: 51.4507949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052100',
        LOCATION_NAME: 'Bristol BS34',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5682331,
        LOCATION_LATITUDE_DEG: 51.520489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095300',
        LOCATION_NAME: 'Bristol BS35',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5762977,
        LOCATION_LATITUDE_DEG: 51.611193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052200',
        LOCATION_NAME: 'Bristol International Airport',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7114602,
        LOCATION_LATITUDE_DEG: 51.3836657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052300',
        LOCATION_NAME: 'Briston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0609652,
        LOCATION_LATITUDE_DEG: 52.8532525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052400',
        LOCATION_NAME: 'Britannia',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0860562,
        LOCATION_LATITUDE_DEG: 52.9230125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052500',
        LOCATION_NAME: 'Britannia',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1780323,
        LOCATION_LATITUDE_DEG: 53.6911811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052600',
        LOCATION_NAME: 'Britford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7721371,
        LOCATION_LATITUDE_DEG: 51.0538178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052800',
        LOCATION_NAME: 'Brithdir',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8225703,
        LOCATION_LATITUDE_DEG: 52.7526041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052700',
        LOCATION_NAME: 'Brithdir',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2373039,
        LOCATION_LATITUDE_DEG: 51.7098005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR052900',
        LOCATION_NAME: 'Brithem Bottom',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4034329,
        LOCATION_LATITUDE_DEG: 50.8836247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053000',
        LOCATION_NAME: 'British',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.075982,
        LOCATION_LATITUDE_DEG: 51.7240052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053100',
        LOCATION_NAME: 'Briton Ferry',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8154551,
        LOCATION_LATITUDE_DEG: 51.6328961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053400',
        LOCATION_NAME: 'Britwell Salome',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0306817,
        LOCATION_LATITUDE_DEG: 51.6335694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053500',
        LOCATION_NAME: 'Brixham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5146479,
        LOCATION_LATITUDE_DEG: 50.393575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094600',
        LOCATION_NAME: 'Brixton',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053600',
        LOCATION_NAME: 'Brixton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0314286,
        LOCATION_LATITUDE_DEG: 50.3504795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094500',
        LOCATION_NAME: 'Brixton',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1159531,
        LOCATION_LATITUDE_DEG: 51.4619184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053700',
        LOCATION_NAME: 'Brixton Deverill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1962398,
        LOCATION_LATITUDE_DEG: 51.1476376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053800',
        LOCATION_NAME: 'Brixworth',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9028508,
        LOCATION_LATITUDE_DEG: 52.3326373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053900',
        LOCATION_NAME: 'Brize Norton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5648912,
        LOCATION_LATITUDE_DEG: 51.7659917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054000',
        LOCATION_NAME: 'Broad Blunsdon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7797849,
        LOCATION_LATITUDE_DEG: 51.6142713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054100',
        LOCATION_NAME: 'Broad Campden',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.769397,
        LOCATION_LATITUDE_DEG: 52.0382163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054200',
        LOCATION_NAME: 'Broad Chalke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.945192,
        LOCATION_LATITUDE_DEG: 51.0300242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054300',
        LOCATION_NAME: 'Broad Common',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.173448,
        LOCATION_LATITUDE_DEG: 52.3052446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094800',
        LOCATION_NAME: 'Broad Green',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8944675,
        LOCATION_LATITUDE_DEG: 53.4088703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054500',
        LOCATION_NAME: 'Broad Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1037898,
        LOCATION_LATITUDE_DEG: 51.3847091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054400',
        LOCATION_NAME: 'Broad Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7282101,
        LOCATION_LATITUDE_DEG: 51.874871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054600',
        LOCATION_NAME: 'Broad Haven',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1008935,
        LOCATION_LATITUDE_DEG: 51.782328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054700',
        LOCATION_NAME: 'Broad Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2656669,
        LOCATION_LATITUDE_DEG: 52.8135003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054800',
        LOCATION_NAME: 'Broad Hill',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3392442,
        LOCATION_LATITUDE_DEG: 52.3615202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR054900',
        LOCATION_NAME: 'Broad Hinton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8482124,
        LOCATION_LATITUDE_DEG: 51.486867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055000',
        LOCATION_NAME: 'Broad Marston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7966946,
        LOCATION_LATITUDE_DEG: 52.1146235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055100',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.064571,
        LOCATION_LATITUDE_DEG: 51.8843284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055500',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3632046,
        LOCATION_LATITUDE_DEG: 54.3397609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055600',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7548746,
        LOCATION_LATITUDE_DEG: 51.8875124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055200',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7438843,
        LOCATION_LATITUDE_DEG: 52.7508958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055800',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3016555,
        LOCATION_LATITUDE_DEG: 50.9142181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055300',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2842907,
        LOCATION_LATITUDE_DEG: 50.9760882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055400',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6008001,
        LOCATION_LATITUDE_DEG: 50.9496857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055700',
        LOCATION_NAME: 'Broad Oak',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1119353,
        LOCATION_LATITUDE_DEG: 51.310612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR055900',
        LOCATION_NAME: 'Broad Street Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6954499,
        LOCATION_LATITUDE_DEG: 51.7539598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056000',
        LOCATION_NAME: 'Broad Town',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8686049,
        LOCATION_LATITUDE_DEG: 51.4980693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056100',
        LOCATION_NAME: 'Broadbottom',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0150711,
        LOCATION_LATITUDE_DEG: 53.4409497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056200',
        LOCATION_NAME: 'Broadbridge',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8471291,
        LOCATION_LATITUDE_DEG: 50.8402929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056300',
        LOCATION_NAME: 'Broadbridge Heath',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3584269,
        LOCATION_LATITUDE_DEG: 51.0691059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056400',
        LOCATION_NAME: 'Broadbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1514104,
        LOCATION_LATITUDE_DEG: 50.7394231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056500',
        LOCATION_NAME: 'Broadclyst',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.439585,
        LOCATION_LATITUDE_DEG: 50.7616108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056600',
        LOCATION_NAME: 'Broadclyst Station',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4279419,
        LOCATION_LATITUDE_DEG: 50.7476151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056700',
        LOCATION_NAME: 'Broadfield',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7067391,
        LOCATION_LATITUDE_DEG: 51.6999131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056800',
        LOCATION_NAME: 'Broadfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8713939,
        LOCATION_LATITUDE_DEG: 54.7902911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR056900',
        LOCATION_NAME: 'Broadfield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.207734,
        LOCATION_LATITUDE_DEG: 51.0925072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057200',
        LOCATION_NAME: 'Broadford',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9083049,
        LOCATION_LATITUDE_DEG: 57.241573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057300',
        LOCATION_NAME: 'Broadford Bridge',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4381231,
        LOCATION_LATITUDE_DEG: 50.983002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057400',
        LOCATION_NAME: 'Broadgreen',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8947006,
        LOCATION_LATITUDE_DEG: 53.4063604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990484',
        LOCATION_NAME: 'Broadheath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057500',
        LOCATION_NAME: 'Broadheath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3510178,
        LOCATION_LATITUDE_DEG: 53.4006559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057600',
        LOCATION_NAME: 'Broadhembury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2747381,
        LOCATION_LATITUDE_DEG: 50.834816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057700',
        LOCATION_NAME: 'Broadhempston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6820718,
        LOCATION_LATITUDE_DEG: 50.482788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057800',
        LOCATION_NAME: 'Broadholme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6620663,
        LOCATION_LATITUDE_DEG: 53.2571202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057900',
        LOCATION_NAME: 'Broadland Row',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.623568,
        LOCATION_LATITUDE_DEG: 50.943581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058000',
        LOCATION_NAME: 'Broadley',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0135888,
        LOCATION_LATITUDE_DEG: 57.6419822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058100',
        LOCATION_NAME: 'Broadley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.177899,
        LOCATION_LATITUDE_DEG: 53.6415788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058200',
        LOCATION_NAME: 'Broadley Common',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'EN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0618398,
        LOCATION_LATITUDE_DEG: 51.7454644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058300',
        LOCATION_NAME: 'Broadmayne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3809131,
        LOCATION_LATITUDE_DEG: 50.6770942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096000',
        LOCATION_NAME: 'Broadmead',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5894658,
        LOCATION_LATITUDE_DEG: 51.4579394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058400',
        LOCATION_NAME: 'Broadmoor',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7509127,
        LOCATION_LATITUDE_DEG: 51.7189174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058600',
        LOCATION_NAME: 'Broadoak',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7986535,
        LOCATION_LATITUDE_DEG: 50.7642087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058500',
        LOCATION_NAME: 'Broadoak',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4354625,
        LOCATION_LATITUDE_DEG: 51.8163014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058700',
        LOCATION_NAME: 'Broadpark',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7550793,
        LOCATION_LATITUDE_DEG: 50.5153955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058800',
        LOCATION_NAME: 'Broadsands',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5496598,
        LOCATION_LATITUDE_DEG: 50.403179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR058900',
        LOCATION_NAME: 'Broadshard',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7907849,
        LOCATION_LATITUDE_DEG: 50.8929174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059000',
        LOCATION_NAME: 'Broadstairs',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4412374,
        LOCATION_LATITUDE_DEG: 51.3585067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059200',
        LOCATION_NAME: 'Broadstone',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.718717,
        LOCATION_LATITUDE_DEG: 51.7240986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059300',
        LOCATION_NAME: 'Broadstone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6733382,
        LOCATION_LATITUDE_DEG: 52.5034728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059100',
        LOCATION_NAME: 'Broadstone',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9949802,
        LOCATION_LATITUDE_DEG: 50.7614929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059400',
        LOCATION_NAME: 'Broadstreet Common',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9317919,
        LOCATION_LATITUDE_DEG: 51.5581822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059500',
        LOCATION_NAME: 'Broadward',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.89776,
        LOCATION_LATITUDE_DEG: 52.3821643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059600',
        LOCATION_NAME: 'Broadwas',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3478273,
        LOCATION_LATITUDE_DEG: 52.1937351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059700',
        LOCATION_NAME: 'Broadwater',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3711532,
        LOCATION_LATITUDE_DEG: 50.8273786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059800',
        LOCATION_NAME: 'Broadwaters',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2328027,
        LOCATION_LATITUDE_DEG: 52.3990558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR059900',
        LOCATION_NAME: 'Broadwath',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8027407,
        LOCATION_LATITUDE_DEG: 54.8892075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990573',
        LOCATION_NAME: 'Broadway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095700',
        LOCATION_NAME: 'Broadway',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.959401,
        LOCATION_LATITUDE_DEG: 54.58945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095750',
        LOCATION_NAME: 'Broadway',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0785963,
        LOCATION_LATITUDE_DEG: 51.7822309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060000',
        LOCATION_NAME: 'Broadway',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4637537,
        LOCATION_LATITUDE_DEG: 51.7657212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060300',
        LOCATION_NAME: 'Broadway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9653951,
        LOCATION_LATITUDE_DEG: 50.932822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060100',
        LOCATION_NAME: 'Broadway',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8545833,
        LOCATION_LATITUDE_DEG: 52.0358165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060400',
        LOCATION_NAME: 'Broadwell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.597191,
        LOCATION_LATITUDE_DEG: 51.796501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060500',
        LOCATION_NAME: 'Broadwell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.701403,
        LOCATION_LATITUDE_DEG: 51.9449087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060600',
        LOCATION_NAME: 'Broadwell',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3341409,
        LOCATION_LATITUDE_DEG: 52.2880389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060700',
        LOCATION_NAME: 'Broadwey',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4697106,
        LOCATION_LATITUDE_DEG: 50.6492939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060800',
        LOCATION_NAME: 'Broadwindsor',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7973515,
        LOCATION_LATITUDE_DEG: 50.8194124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060900',
        LOCATION_NAME: 'Broadwoodkelly',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9654909,
        LOCATION_LATITUDE_DEG: 50.8328237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061000',
        LOCATION_NAME: 'Broadwoodwidger',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2492282,
        LOCATION_LATITUDE_DEG: 50.6795132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061100',
        LOCATION_NAME: 'Broallan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5097487,
        LOCATION_LATITUDE_DEG: 57.4745794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061200',
        LOCATION_NAME: 'Brobury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9519702,
        LOCATION_LATITUDE_DEG: 52.0928373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061300',
        LOCATION_NAME: 'Brocastle',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5363312,
        LOCATION_LATITUDE_DEG: 51.4840871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061400',
        LOCATION_NAME: 'Brock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7417508,
        LOCATION_LATITUDE_DEG: 53.8593996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR991007',
        LOCATION_NAME: 'Brockagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061500',
        LOCATION_NAME: 'Brockagh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6066746,
        LOCATION_LATITUDE_DEG: 54.5507026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061600',
        LOCATION_NAME: 'Brockdish',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2503868,
        LOCATION_LATITUDE_DEG: 52.3698081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061700',
        LOCATION_NAME: 'Brockenhurst',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5705635,
        LOCATION_LATITUDE_DEG: 50.8166969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061800',
        LOCATION_NAME: 'Brockford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1036524,
        LOCATION_LATITUDE_DEG: 52.2596958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR061900',
        LOCATION_NAME: 'Brockford Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1102695,
        LOCATION_LATITUDE_DEG: 52.2465962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062000',
        LOCATION_NAME: 'Brockhall',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0695673,
        LOCATION_LATITUDE_DEG: 52.2566324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990216',
        LOCATION_NAME: 'Brockhall Village',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4532116,
        LOCATION_LATITUDE_DEG: 53.8254283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062100',
        LOCATION_NAME: 'Brockham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2870285,
        LOCATION_LATITUDE_DEG: 51.2346212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062300',
        LOCATION_NAME: 'Brockhampton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4711179,
        LOCATION_LATITUDE_DEG: 52.186141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062200',
        LOCATION_NAME: 'Brockhampton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9533268,
        LOCATION_LATITUDE_DEG: 51.8995006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062400',
        LOCATION_NAME: 'Brockhill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2381292,
        LOCATION_LATITUDE_DEG: 50.7316966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062500',
        LOCATION_NAME: 'Brockhill Village',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1903926,
        LOCATION_LATITUDE_DEG: 52.1622373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062600',
        LOCATION_NAME: 'Brockholes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7822008,
        LOCATION_LATITUDE_DEG: 53.5992631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062700',
        LOCATION_NAME: 'Brockhurst',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2600898,
        LOCATION_LATITUDE_DEG: 52.7043846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062800',
        LOCATION_NAME: 'Brockhurst',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5048099,
        LOCATION_LATITUDE_DEG: 53.1757218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR062900',
        LOCATION_NAME: 'Brockington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9734503,
        LOCATION_LATITUDE_DEG: 50.8950081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063000',
        LOCATION_NAME: 'Brocklebank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0815084,
        LOCATION_LATITUDE_DEG: 54.7784976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063100',
        LOCATION_NAME: 'Brocklesby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2773651,
        LOCATION_LATITUDE_DEG: 53.5868446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990802',
        LOCATION_NAME: 'Brocklesby Park',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063200',
        LOCATION_NAME: 'Brockley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7584604,
        LOCATION_LATITUDE_DEG: 51.3978674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094400',
        LOCATION_NAME: 'Brockley',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0355307,
        LOCATION_LATITUDE_DEG: 51.4588174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063300',
        LOCATION_NAME: 'Brockley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6671878,
        LOCATION_LATITUDE_DEG: 52.1598991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063400',
        LOCATION_NAME: 'Brockmanton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6600251,
        LOCATION_LATITUDE_DEG: 52.2279455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063500',
        LOCATION_NAME: 'Brockmoor',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1308754,
        LOCATION_LATITUDE_DEG: 52.4869654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063600',
        LOCATION_NAME: 'Brockton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9918715,
        LOCATION_LATITUDE_DEG: 52.46657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063700',
        LOCATION_NAME: 'Brockton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6220606,
        LOCATION_LATITUDE_DEG: 52.5397718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063800',
        LOCATION_NAME: 'Brockton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4126254,
        LOCATION_LATITUDE_DEG: 52.6281776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR991102',
        LOCATION_NAME: 'Brockton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.626324,
        LOCATION_LATITUDE_DEG: 52.540551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR063900',
        LOCATION_NAME: 'Brockweir',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6687627,
        LOCATION_LATITUDE_DEG: 51.7063909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064000',
        LOCATION_NAME: 'Brockweir Common',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6602471,
        LOCATION_LATITUDE_DEG: 51.7139926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064100',
        LOCATION_NAME: 'Brockworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1582175,
        LOCATION_LATITUDE_DEG: 51.8456047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064200',
        LOCATION_NAME: 'Brocton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0448152,
        LOCATION_LATITUDE_DEG: 52.7733857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064300',
        LOCATION_NAME: 'Brodder',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4460864,
        LOCATION_LATITUDE_DEG: 52.8988097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064400',
        LOCATION_NAME: 'Brodick',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1500449,
        LOCATION_LATITUDE_DEG: 55.5774948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064500',
        LOCATION_NAME: 'Brodie',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7078321,
        LOCATION_LATITUDE_DEG: 57.5983827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064600',
        LOCATION_NAME: 'Brodsworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2344024,
        LOCATION_LATITUDE_DEG: 53.5599573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064700',
        LOCATION_NAME: 'Brogaig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2278526,
        LOCATION_LATITUDE_DEG: 57.6303095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064800',
        LOCATION_NAME: 'Brogbeach',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9266418,
        LOCATION_LATITUDE_DEG: 52.6312874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR064900',
        LOCATION_NAME: 'Brogborough',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5964607,
        LOCATION_LATITUDE_DEG: 52.0335983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065000',
        LOCATION_NAME: 'Brogyntyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0843234,
        LOCATION_LATITUDE_DEG: 52.8709086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065100',
        LOCATION_NAME: 'Broken Cross',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1587446,
        LOCATION_LATITUDE_DEG: 53.2611412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065200',
        LOCATION_NAME: 'Brokenborough',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1191611,
        LOCATION_LATITUDE_DEG: 51.6021788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065300',
        LOCATION_NAME: 'Broker',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1610973,
        LOCATION_LATITUDE_DEG: 58.2521763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065400',
        LOCATION_NAME: 'Brokerswood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2348197,
        LOCATION_LATITUDE_DEG: 51.2666514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065600',
        LOCATION_NAME: 'Brome',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1355027,
        LOCATION_LATITUDE_DEG: 52.3437093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065700',
        LOCATION_NAME: 'Bromeswell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3619031,
        LOCATION_LATITUDE_DEG: 52.1062818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065800',
        LOCATION_NAME: 'Bromfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2816475,
        LOCATION_LATITUDE_DEG: 54.8103982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR065900',
        LOCATION_NAME: 'Bromfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7630298,
        LOCATION_LATITUDE_DEG: 52.3879572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095800',
        LOCATION_NAME: 'Bromford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8312848,
        LOCATION_LATITUDE_DEG: 52.5030564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066100',
        LOCATION_NAME: 'Bromham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0526871,
        LOCATION_LATITUDE_DEG: 51.3850581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066000',
        LOCATION_NAME: 'Bromham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5271998,
        LOCATION_LATITUDE_DEG: 52.1446084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066300',
        LOCATION_NAME: 'Bromley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3923323,
        LOCATION_LATITUDE_DEG: 52.5547729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066200',
        LOCATION_NAME: 'Bromley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0159386,
        LOCATION_LATITUDE_DEG: 51.4052306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066400',
        LOCATION_NAME: 'Bromley Cross',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4094314,
        LOCATION_LATITUDE_DEG: 53.6124787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066500',
        LOCATION_NAME: 'Bromley Hayes',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8319353,
        LOCATION_LATITUDE_DEG: 52.7300842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066600',
        LOCATION_NAME: 'Bromley Hurst',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8743451,
        LOCATION_LATITUDE_DEG: 52.7991934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066700',
        LOCATION_NAME: 'Bromlow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0053958,
        LOCATION_LATITUDE_DEG: 52.6089855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066800',
        LOCATION_NAME: 'Brompton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6712427,
        LOCATION_LATITUDE_DEG: 52.6655837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067050',
        LOCATION_NAME: 'Brompton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4178184,
        LOCATION_LATITUDE_DEG: 54.3598442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR066900',
        LOCATION_NAME: 'Brompton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5527562,
        LOCATION_LATITUDE_DEG: 54.2270105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067000',
        LOCATION_NAME: 'Brompton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5375823,
        LOCATION_LATITUDE_DEG: 51.3909275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091800',
        LOCATION_NAME: 'Brompton by Sawdon',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067300',
        LOCATION_NAME: 'Brompton on Swale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6640313,
        LOCATION_LATITUDE_DEG: 54.3920415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067100',
        LOCATION_NAME: 'Brompton Ralph',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3048788,
        LOCATION_LATITUDE_DEG: 51.0809405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067200',
        LOCATION_NAME: 'Brompton Regis',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4930627,
        LOCATION_LATITUDE_DEG: 51.0719429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067400',
        LOCATION_NAME: 'Brompton-by-Sawdon',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5493556,
        LOCATION_LATITUDE_DEG: 54.2251088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067500',
        LOCATION_NAME: 'Bromsash',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5107881,
        LOCATION_LATITUDE_DEG: 51.9147128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067600',
        LOCATION_NAME: 'Bromsberrow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3710781,
        LOCATION_LATITUDE_DEG: 52.0039228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067700',
        LOCATION_NAME: 'Bromsberrow Heath',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3886864,
        LOCATION_LATITUDE_DEG: 51.9948203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067800',
        LOCATION_NAME: 'Bromsgrove',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0620846,
        LOCATION_LATITUDE_DEG: 52.3334443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR067900',
        LOCATION_NAME: 'Bromstead Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2920708,
        LOCATION_LATITUDE_DEG: 52.7612929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068000',
        LOCATION_NAME: 'Bromyard',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5058594,
        LOCATION_LATITUDE_DEG: 52.1898366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068100',
        LOCATION_NAME: 'Bromyard Downs',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4833954,
        LOCATION_LATITUDE_DEG: 52.201341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068200',
        LOCATION_NAME: 'Bron y Nant',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7589118,
        LOCATION_LATITUDE_DEG: 53.2966607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068300',
        LOCATION_NAME: 'Bronant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9926734,
        LOCATION_LATITUDE_DEG: 52.2842613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068400',
        LOCATION_NAME: 'Broncroft',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6700581,
        LOCATION_LATITUDE_DEG: 52.4747647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094300',
        LOCATION_NAME: 'Brondesbury',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2025124,
        LOCATION_LATITUDE_DEG: 51.545748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068500',
        LOCATION_NAME: 'Brongest',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4493425,
        LOCATION_LATITUDE_DEG: 52.0800508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068600',
        LOCATION_NAME: 'Bronington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7680351,
        LOCATION_LATITUDE_DEG: 52.9502177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068700',
        LOCATION_NAME: 'Bronllys',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2475055,
        LOCATION_LATITUDE_DEG: 52.0063269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068800',
        LOCATION_NAME: 'Bronwydd Arms',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2994571,
        LOCATION_LATITUDE_DEG: 51.891231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR068900',
        LOCATION_NAME: 'Bronwylfa',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0793497,
        LOCATION_LATITUDE_DEG: 53.0265295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069000',
        LOCATION_NAME: 'Bronygarth',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0868873,
        LOCATION_LATITUDE_DEG: 52.9241198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069200',
        LOCATION_NAME: 'Brook',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5097549,
        LOCATION_LATITUDE_DEG: 51.7559153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069400',
        LOCATION_NAME: 'Brook',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5123319,
        LOCATION_LATITUDE_DEG: 51.0572224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069100',
        LOCATION_NAME: 'Brook',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4475197,
        LOCATION_LATITUDE_DEG: 50.6528793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069500',
        LOCATION_NAME: 'Brook',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6714807,
        LOCATION_LATITUDE_DEG: 51.1316141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069300',
        LOCATION_NAME: 'Brook',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9548074,
        LOCATION_LATITUDE_DEG: 51.1600978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069600',
        LOCATION_NAME: 'Brook Street',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1382902,
        LOCATION_LATITUDE_DEG: 51.0239024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990117',
        LOCATION_NAME: 'Brooke',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7621775,
        LOCATION_LATITUDE_DEG: 52.6013808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069800',
        LOCATION_NAME: 'Brooke',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7449949,
        LOCATION_LATITUDE_DEG: 52.6424613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR069900',
        LOCATION_NAME: 'Brooke',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3714777,
        LOCATION_LATITUDE_DEG: 52.5406194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070000',
        LOCATION_NAME: 'Brookeborough',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4018456,
        LOCATION_LATITUDE_DEG: 54.3200875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070100',
        LOCATION_NAME: 'Brookenby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.19227,
        LOCATION_LATITUDE_DEG: 53.4418267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070200',
        LOCATION_NAME: 'Brookfield',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5367393,
        LOCATION_LATITUDE_DEG: 55.8462175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070300',
        LOCATION_NAME: 'Brookfoot',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7931983,
        LOCATION_LATITUDE_DEG: 53.7052749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070400',
        LOCATION_NAME: 'Brookhampton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6354413,
        LOCATION_LATITUDE_DEG: 52.5064696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070500',
        LOCATION_NAME: 'Brookheath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.813494,
        LOCATION_LATITUDE_DEG: 50.9530135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070700',
        LOCATION_NAME: 'Brookhouse',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7011646,
        LOCATION_LATITUDE_DEG: 54.0746237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070600',
        LOCATION_NAME: 'Brookhouse',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2280443,
        LOCATION_LATITUDE_DEG: 53.3923297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070800',
        LOCATION_NAME: 'Brookhouse Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2822806,
        LOCATION_LATITUDE_DEG: 53.1486284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR070900',
        LOCATION_NAME: 'Brooking',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7014785,
        LOCATION_LATITUDE_DEG: 50.4370818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071000',
        LOCATION_NAME: 'Brookland',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8395987,
        LOCATION_LATITUDE_DEG: 50.9991818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071100',
        LOCATION_NAME: 'Brooklands',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'M33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3241226,
        LOCATION_LATITUDE_DEG: 53.4164548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990518',
        LOCATION_NAME: 'Brooklands',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7019811,
        LOCATION_LATITUDE_DEG: 52.0172732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR093800',
        LOCATION_NAME: 'Brooklands Estate',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.620244,
        LOCATION_LATITUDE_DEG: 53.4774209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071300',
        LOCATION_NAME: 'Brookmans Park',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.201093,
        LOCATION_LATITUDE_DEG: 51.7215635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071400',
        LOCATION_NAME: 'Brooks',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.264651,
        LOCATION_LATITUDE_DEG: 52.5827818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071500',
        LOCATION_NAME: 'Brooks Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3911088,
        LOCATION_LATITUDE_DEG: 51.0125028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071600',
        LOCATION_NAME: 'Brooksby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0044942,
        LOCATION_LATITUDE_DEG: 52.738073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071700',
        LOCATION_NAME: 'Brooksend',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2950692,
        LOCATION_LATITUDE_DEG: 51.363613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071800',
        LOCATION_NAME: 'Brookside',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4429434,
        LOCATION_LATITUDE_DEG: 52.6484863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071900',
        LOCATION_NAME: 'Brookthorpe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2339314,
        LOCATION_LATITUDE_DEG: 51.8068038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072000',
        LOCATION_NAME: 'Brookvale',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6778315,
        LOCATION_LATITUDE_DEG: 53.3160469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072200',
        LOCATION_NAME: 'Brookville',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5588553,
        LOCATION_LATITUDE_DEG: 52.5348283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072300',
        LOCATION_NAME: 'Brookwood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6343155,
        LOCATION_LATITUDE_DEG: 51.3039329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072400',
        LOCATION_NAME: 'Broom',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8649003,
        LOCATION_LATITUDE_DEG: 52.177734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072500',
        LOCATION_NAME: 'Broom',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2908011,
        LOCATION_LATITUDE_DEG: 52.0707014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990529',
        LOCATION_NAME: 'Broom of Moy',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072600',
        LOCATION_NAME: 'Broome',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8802357,
        LOCATION_LATITUDE_DEG: 52.4230631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072700',
        LOCATION_NAME: 'Broome',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4620235,
        LOCATION_LATITUDE_DEG: 52.4706107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072800',
        LOCATION_NAME: 'Broome Manor',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7554643,
        LOCATION_LATITUDE_DEG: 51.5356655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072900',
        LOCATION_NAME: 'Broomedge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4427379,
        LOCATION_LATITUDE_DEG: 53.3696512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073000',
        LOCATION_NAME: 'Broomfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1051595,
        LOCATION_LATITUDE_DEG: 51.0816413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073300',
        LOCATION_NAME: 'Broomfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4742808,
        LOCATION_LATITUDE_DEG: 51.7644567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073400',
        LOCATION_NAME: 'Broomfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6365509,
        LOCATION_LATITUDE_DEG: 51.2430065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073200',
        LOCATION_NAME: 'Broomfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1572106,
        LOCATION_LATITUDE_DEG: 51.358309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073500',
        LOCATION_NAME: 'Broomfields',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8507497,
        LOCATION_LATITUDE_DEG: 52.7524972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073600',
        LOCATION_NAME: 'Broomfleet',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6653433,
        LOCATION_LATITUDE_DEG: 53.7330611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073800',
        LOCATION_NAME: 'Broomhall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0863527,
        LOCATION_LATITUDE_DEG: 52.8754125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073850',
        LOCATION_NAME: 'Broomhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5562666,
        LOCATION_LATITUDE_DEG: 53.0237699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073700',
        LOCATION_NAME: 'Broomhall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2033814,
        LOCATION_LATITUDE_DEG: 52.1634295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073900',
        LOCATION_NAME: 'Broomhaugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9657286,
        LOCATION_LATITUDE_DEG: 54.9463986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096600',
        LOCATION_NAME: 'Broomhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3158242,
        LOCATION_LATITUDE_DEG: 55.8769032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096200',
        LOCATION_NAME: 'Broomhill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5379348,
        LOCATION_LATITUDE_DEG: 51.4422431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074000',
        LOCATION_NAME: 'Broomhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0281467,
        LOCATION_LATITUDE_DEG: 52.6959815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR093100',
        LOCATION_NAME: 'Broomhill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5029776,
        LOCATION_LATITUDE_DEG: 53.3780048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074100',
        LOCATION_NAME: 'Broomhills',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4343527,
        LOCATION_LATITUDE_DEG: 51.5914438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074200',
        LOCATION_NAME: 'Broomlands',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6371222,
        LOCATION_LATITUDE_DEG: 55.6103936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074300',
        LOCATION_NAME: 'Broomley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9384536,
        LOCATION_LATITUDE_DEG: 54.9350998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074400',
        LOCATION_NAME: 'Broompark',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6182372,
        LOCATION_LATITUDE_DEG: 54.769775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074500',
        LOCATION_NAME: 'Broomsgreen',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4150413,
        LOCATION_LATITUDE_DEG: 51.9937233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074600',
        LOCATION_NAME: 'Broomsgrove',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7428679,
        LOCATION_LATITUDE_DEG: 51.3603547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074700',
        LOCATION_NAME: 'Broomsthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7447581,
        LOCATION_LATITUDE_DEG: 52.8216614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074800',
        LOCATION_NAME: 'Brora',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8516371,
        LOCATION_LATITUDE_DEG: 58.0127211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR074900',
        LOCATION_NAME: 'Broseley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4834051,
        LOCATION_LATITUDE_DEG: 52.6137763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075000',
        LOCATION_NAME: 'Broseley Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.483793,
        LOCATION_LATITUDE_DEG: 52.6194839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075300',
        LOCATION_NAME: 'Brotherlee',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1160533,
        LOCATION_LATITUDE_DEG: 54.7343787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075400',
        LOCATION_NAME: 'Brothertoft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1016245,
        LOCATION_LATITUDE_DEG: 52.997285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075500',
        LOCATION_NAME: 'Brotherton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.269389,
        LOCATION_LATITUDE_DEG: 53.7269755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075600',
        LOCATION_NAME: 'Brotton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9351278,
        LOCATION_LATITUDE_DEG: 54.568752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075700',
        LOCATION_NAME: 'Brough',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3410581,
        LOCATION_LATITUDE_DEG: 58.6434795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076000',
        LOCATION_NAME: 'Brough',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3172839,
        LOCATION_LATITUDE_DEG: 54.5254659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075800',
        LOCATION_NAME: 'Brough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7502179,
        LOCATION_LATITUDE_DEG: 53.1152083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075900',
        LOCATION_NAME: 'Brough',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5715022,
        LOCATION_LATITUDE_DEG: 53.7296597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076100',
        LOCATION_NAME: 'Brough Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6682605,
        LOCATION_LATITUDE_DEG: 54.3718387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076200',
        LOCATION_NAME: 'Brough Sowerby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.319154,
        LOCATION_LATITUDE_DEG: 54.5096602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076400',
        LOCATION_NAME: 'Broughall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.64695,
        LOCATION_LATITUDE_DEG: 52.9677147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076500',
        LOCATION_NAME: 'Brougham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7242048,
        LOCATION_LATITUDE_DEG: 54.6445766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076600',
        LOCATION_NAME: 'Broughshane',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2228215,
        LOCATION_LATITUDE_DEG: 54.8919383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077100',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5506121,
        LOCATION_LATITUDE_DEG: 51.4277809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077200',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4093907,
        LOCATION_LATITUDE_DEG: 55.6143835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096300',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1874126,
        LOCATION_LATITUDE_DEG: 55.959291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077300',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9838203,
        LOCATION_LATITUDE_DEG: 53.1691373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077700',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7221173,
        LOCATION_LATITUDE_DEG: 53.8098002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077900',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3491527,
        LOCATION_LATITUDE_DEG: 52.9029101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076700',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0873007,
        LOCATION_LATITUDE_DEG: 53.956007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077800',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5594548,
        LOCATION_LATITUDE_DEG: 51.0945245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077600',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3815616,
        LOCATION_LATITUDE_DEG: 52.0421152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077000',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8255093,
        LOCATION_LATITUDE_DEG: 54.1474043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077500',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7749472,
        LOCATION_LATITUDE_DEG: 52.3725353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096350',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7735565,
        LOCATION_LATITUDE_DEG: 51.8160718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR077400',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6914386,
        LOCATION_LATITUDE_DEG: 52.0499064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076800',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5479311,
        LOCATION_LATITUDE_DEG: 53.5657477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076900',
        LOCATION_NAME: 'Broughton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1181589,
        LOCATION_LATITUDE_DEG: 52.3836301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078000',
        LOCATION_NAME: 'Broughton Astley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2181007,
        LOCATION_LATITUDE_DEG: 52.527558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078100',
        LOCATION_NAME: 'Broughton Beck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0979251,
        LOCATION_LATITUDE_DEG: 54.2299443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078200',
        LOCATION_NAME: 'Broughton Cross',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4327306,
        LOCATION_LATITUDE_DEG: 54.6590853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078300',
        LOCATION_NAME: 'Broughton Gifford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1734398,
        LOCATION_LATITUDE_DEG: 51.3699598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078400',
        LOCATION_NAME: 'Broughton Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0637369,
        LOCATION_LATITUDE_DEG: 52.2473427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078500',
        LOCATION_NAME: 'Broughton Hackett',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.109806,
        LOCATION_LATITUDE_DEG: 52.1874351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR093000',
        LOCATION_NAME: 'Broughton in Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078600',
        LOCATION_NAME: 'Broughton Mills',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1950772,
        LOCATION_LATITUDE_DEG: 54.3048506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078700',
        LOCATION_NAME: 'Broughton Moor',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4682077,
        LOCATION_LATITUDE_DEG: 54.6870916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078800',
        LOCATION_NAME: 'Broughton Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2604539,
        LOCATION_LATITUDE_DEG: 53.5144618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR078900',
        LOCATION_NAME: 'Broughton Vale',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5429769,
        LOCATION_LATITUDE_DEG: 53.5565443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079000',
        LOCATION_NAME: 'Broughton-in-Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2125175,
        LOCATION_LATITUDE_DEG: 54.2769458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079100',
        LOCATION_NAME: 'Broughty Ferry',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8796798,
        LOCATION_LATITUDE_DEG: 56.4692568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079200',
        LOCATION_NAME: 'Brown Candover',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1728936,
        LOCATION_LATITUDE_DEG: 51.1495274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079300',
        LOCATION_NAME: 'Brown Edge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1375184,
        LOCATION_LATITUDE_DEG: 53.0751201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079400',
        LOCATION_NAME: 'Brown Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7996097,
        LOCATION_LATITUDE_DEG: 52.8607059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079500',
        LOCATION_NAME: 'Brown Knowl',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7505622,
        LOCATION_LATITUDE_DEG: 53.0775257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079600',
        LOCATION_NAME: 'Brown Lees',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1850492,
        LOCATION_LATITUDE_DEG: 53.1028261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079700',
        LOCATION_NAME: 'Brown Moss',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6553317,
        LOCATION_LATITUDE_DEG: 52.9518186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079800',
        LOCATION_NAME: 'Browney',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6087312,
        LOCATION_LATITUDE_DEG: 54.7431772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR079900',
        LOCATION_NAME: 'Brownhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8858979,
        LOCATION_LATITUDE_DEG: 52.7941012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080000',
        LOCATION_NAME: 'Brownhills',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4886781,
        LOCATION_LATITUDE_DEG: 52.9209115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080100',
        LOCATION_NAME: 'Brownhills',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9319436,
        LOCATION_LATITUDE_DEG: 52.6470738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080200',
        LOCATION_NAME: 'Brownhills West',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9487223,
        LOCATION_LATITUDE_DEG: 52.6587792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080300',
        LOCATION_NAME: 'Brownieside',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7365747,
        LOCATION_LATITUDE_DEG: 55.507351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR093700',
        LOCATION_NAME: 'Brownley Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2542604,
        LOCATION_LATITUDE_DEG: 53.3968378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080400',
        LOCATION_NAME: 'Brownlow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2500657,
        LOCATION_LATITUDE_DEG: 53.1478284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080500',
        LOCATION_NAME: 'Brownlow Fold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4483163,
        LOCATION_LATITUDE_DEG: 53.5899738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080700',
        LOCATION_NAME: 'Browns Wood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6801426,
        LOCATION_LATITUDE_DEG: 52.0145037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080900',
        LOCATION_NAME: 'Brownsbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7318104,
        LOCATION_LATITUDE_DEG: 52.910915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081000',
        LOCATION_NAME: 'Brownsburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9624598,
        LOCATION_LATITUDE_DEG: 55.8548145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081200',
        LOCATION_NAME: 'Brownshill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1667037,
        LOCATION_LATITUDE_DEG: 51.72179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081300',
        LOCATION_NAME: 'Brownsover',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2438926,
        LOCATION_LATITUDE_DEG: 52.3913465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081400',
        LOCATION_NAME: 'Brownston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8279732,
        LOCATION_LATITUDE_DEG: 50.3596764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081800',
        LOCATION_NAME: 'Browston Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6748045,
        LOCATION_LATITUDE_DEG: 52.5566156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081900',
        LOCATION_NAME: 'Broxa',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5460314,
        LOCATION_LATITUDE_DEG: 54.3109159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082000',
        LOCATION_NAME: 'Broxbourne',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0212788,
        LOCATION_LATITUDE_DEG: 51.7467677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082100',
        LOCATION_NAME: 'Broxburn',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4750646,
        LOCATION_LATITUDE_DEG: 55.9338152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082200',
        LOCATION_NAME: 'Broxhill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8681949,
        LOCATION_LATITUDE_DEG: 50.9135081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082300',
        LOCATION_NAME: 'Broxholme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6349275,
        LOCATION_LATITUDE_DEG: 53.2920194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082400',
        LOCATION_NAME: 'Broxted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2933367,
        LOCATION_LATITUDE_DEG: 51.9191767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082500',
        LOCATION_NAME: 'Broxton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7705302,
        LOCATION_LATITUDE_DEG: 53.0846263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082600',
        LOCATION_NAME: 'Broxtowe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2226407,
        LOCATION_LATITUDE_DEG: 52.9771016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082700',
        LOCATION_NAME: 'Broxwood',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.926416,
        LOCATION_LATITUDE_DEG: 52.1770425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082800',
        LOCATION_NAME: 'Broyle Side',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0765923,
        LOCATION_LATITUDE_DEG: 50.8974864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR082900',
        LOCATION_NAME: 'Brucklay',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1580787,
        LOCATION_LATITUDE_DEG: 57.541961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083100',
        LOCATION_NAME: 'Brue',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5484427,
        LOCATION_LATITUDE_DEG: 58.3548903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083200',
        LOCATION_NAME: 'Bruera',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8407481,
        LOCATION_LATITUDE_DEG: 53.1394324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083300',
        LOCATION_NAME: 'Bruern',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6141967,
        LOCATION_LATITUDE_DEG: 51.8812982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083400',
        LOCATION_NAME: 'Bruernish',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4019343,
        LOCATION_LATITUDE_DEG: 56.9953616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083600',
        LOCATION_NAME: 'Bruichdhu',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3793042,
        LOCATION_LATITUDE_DEG: 55.7415245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083700',
        LOCATION_NAME: 'Bruichladdich',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.359588,
        LOCATION_LATITUDE_DEG: 55.7667311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083900',
        LOCATION_NAME: 'Bruisyard',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4097885,
        LOCATION_LATITUDE_DEG: 52.2453956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084000',
        LOCATION_NAME: 'Brumstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5101185,
        LOCATION_LATITUDE_DEG: 52.7830443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084100',
        LOCATION_NAME: 'Brunant',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.056494,
        LOCATION_LATITUDE_DEG: 52.6786898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084200',
        LOCATION_NAME: 'Brundall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4404956,
        LOCATION_LATITUDE_DEG: 52.6222318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084300',
        LOCATION_NAME: 'Brundish',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3293957,
        LOCATION_LATITUDE_DEG: 52.2769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084400',
        LOCATION_NAME: 'Brundish Street',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3142052,
        LOCATION_LATITUDE_DEG: 52.2891023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084500',
        LOCATION_NAME: 'Brundon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7281843,
        LOCATION_LATITUDE_DEG: 52.0426864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084600',
        LOCATION_NAME: 'Brunslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9333147,
        LOCATION_LATITUDE_DEG: 52.4578663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084700',
        LOCATION_NAME: 'Brunstock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.916357,
        LOCATION_LATITUDE_DEG: 54.9372071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR095000',
        LOCATION_NAME: 'Brunswick Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'N11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1402469,
        LOCATION_LATITUDE_DEG: 51.6213206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084800',
        LOCATION_NAME: 'Brunswick Village',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6366356,
        LOCATION_LATITUDE_DEG: 55.0477044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR084900',
        LOCATION_NAME: 'Bruntingthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1111959,
        LOCATION_LATITUDE_DEG: 52.5031566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085100',
        LOCATION_NAME: 'Brunton',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0971206,
        LOCATION_LATITUDE_DEG: 56.3754577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085000',
        LOCATION_NAME: 'Brunton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6741458,
        LOCATION_LATITUDE_DEG: 55.5160526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085200',
        LOCATION_NAME: 'Brunton Bridge',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6678385,
        LOCATION_LATITUDE_DEG: 55.0223058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085300',
        LOCATION_NAME: 'Brunton Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6160292,
        LOCATION_LATITUDE_DEG: 55.0189988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR096400',
        LOCATION_NAME: 'Bruntsfield',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2068511,
        LOCATION_LATITUDE_DEG: 55.9373547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085500',
        LOCATION_NAME: 'Brushford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.532091,
        LOCATION_LATITUDE_DEG: 51.0204425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085600',
        LOCATION_NAME: 'Brusselton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6878101,
        LOCATION_LATITUDE_DEG: 54.6192679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085700',
        LOCATION_NAME: 'Brusta',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.17284,
        LOCATION_LATITUDE_DEG: 57.7245305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085800',
        LOCATION_NAME: 'Bruton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4510372,
        LOCATION_LATITUDE_DEG: 51.1116345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085900',
        LOCATION_NAME: 'Bryansford',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9322028,
        LOCATION_LATITUDE_DEG: 54.216571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086000',
        LOCATION_NAME: 'Bryanston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1808206,
        LOCATION_LATITUDE_DEG: 50.8601113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086100',
        LOCATION_NAME: 'Brydekirk',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.275203,
        LOCATION_LATITUDE_DEG: 55.0220189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086200',
        LOCATION_NAME: 'Bryher',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3566444,
        LOCATION_LATITUDE_DEG: 49.9538651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086300',
        LOCATION_NAME: 'Brymbo',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0585911,
        LOCATION_LATITUDE_DEG: 53.0764159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086400',
        LOCATION_NAME: 'Brympton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.676766,
        LOCATION_LATITUDE_DEG: 50.9457246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086500',
        LOCATION_NAME: 'Bryn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1042617,
        LOCATION_LATITUDE_DEG: 51.6856064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086600',
        LOCATION_NAME: 'Bryn',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7111517,
        LOCATION_LATITUDE_DEG: 51.6166022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086700',
        LOCATION_NAME: 'Bryn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0397488,
        LOCATION_LATITUDE_DEG: 52.4603683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086800',
        LOCATION_NAME: 'Bryn Cain',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.159467,
        LOCATION_LATITUDE_DEG: 52.7740042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092400',
        LOCATION_NAME: 'Bryn Eden',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9097663,
        LOCATION_LATITUDE_DEG: 52.8459611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR086900',
        LOCATION_NAME: 'Bryn Gates',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6053526,
        LOCATION_LATITUDE_DEG: 53.5089699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092500',
        LOCATION_NAME: 'Bryn Henllan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9023893,
        LOCATION_LATITUDE_DEG: 52.0193359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087000',
        LOCATION_NAME: 'Bryn Mawr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6012444,
        LOCATION_LATITUDE_DEG: 52.8745274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087100',
        LOCATION_NAME: 'Bryn Newydd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4011659,
        LOCATION_LATITUDE_DEG: 53.3270594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087200',
        LOCATION_NAME: 'Bryn Pydew',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7869739,
        LOCATION_LATITUDE_DEG: 53.2962615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087300',
        LOCATION_NAME: 'Bryn Saith Marchog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3781189,
        LOCATION_LATITUDE_DEG: 53.0396354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092000',
        LOCATION_NAME: 'Bryn y Baal',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1110226,
        LOCATION_LATITUDE_DEG: 53.1772339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092100',
        LOCATION_NAME: 'Bryn y Cochin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9425321,
        LOCATION_LATITUDE_DEG: 52.9170272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092300',
        LOCATION_NAME: 'Bryn y gwenin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9733523,
        LOCATION_LATITUDE_DEG: 51.8372599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR092200',
        LOCATION_NAME: 'Bryn y Maen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7454784,
        LOCATION_LATITUDE_DEG: 53.2734276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088000',
        LOCATION_NAME: 'Brynamman',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8657124,
        LOCATION_LATITUDE_DEG: 51.8121174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088100',
        LOCATION_NAME: 'Brynberian',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7611532,
        LOCATION_LATITUDE_DEG: 51.9812427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088200',
        LOCATION_NAME: 'Bryncae',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4518336,
        LOCATION_LATITUDE_DEG: 51.5324857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088300',
        LOCATION_NAME: 'Bryncethin',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5659894,
        LOCATION_LATITUDE_DEG: 51.5462877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088400',
        LOCATION_NAME: 'Bryncir',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2641401,
        LOCATION_LATITUDE_DEG: 52.9774371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088500',
        LOCATION_NAME: 'Bryncoch',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5708472,
        LOCATION_LATITUDE_DEG: 51.5415913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088600',
        LOCATION_NAME: 'Bryncroes',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6335245,
        LOCATION_LATITUDE_DEG: 52.8509283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088700',
        LOCATION_NAME: 'Bryncrug',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0539503,
        LOCATION_LATITUDE_DEG: 52.6096942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088800',
        LOCATION_NAME: 'Brynderi',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8799583,
        LOCATION_LATITUDE_DEG: 51.849209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR088900',
        LOCATION_NAME: 'Bryndioddef',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4621083,
        LOCATION_LATITUDE_DEG: 52.0462473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089000',
        LOCATION_NAME: 'Bryndu',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6723514,
        LOCATION_LATITUDE_DEG: 51.5462946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087400',
        LOCATION_NAME: 'Bryn-Eden',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9062631,
        LOCATION_LATITUDE_DEG: 52.8409191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089100',
        LOCATION_NAME: 'Bryneglwys',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2753323,
        LOCATION_LATITUDE_DEG: 53.0181251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089200',
        LOCATION_NAME: 'Brynford',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2315752,
        LOCATION_LATITUDE_DEG: 53.2612512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089300',
        LOCATION_NAME: 'Bryngwran',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4701801,
        LOCATION_LATITUDE_DEG: 53.2682642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089500',
        LOCATION_NAME: 'Bryngwyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1349961,
        LOCATION_LATITUDE_DEG: 51.8814401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089600',
        LOCATION_NAME: 'Bryngwyn',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1879858,
        LOCATION_LATITUDE_DEG: 52.1372378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089400',
        LOCATION_NAME: 'Bryngwyn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8827593,
        LOCATION_LATITUDE_DEG: 51.7786076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087500',
        LOCATION_NAME: 'Bryn-Henllan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9014229,
        LOCATION_LATITUDE_DEG: 52.0181455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089700',
        LOCATION_NAME: 'Brynhoffnant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4383074,
        LOCATION_LATITUDE_DEG: 52.1346549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089800',
        LOCATION_NAME: 'Brynhyfryd',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9449715,
        LOCATION_LATITUDE_DEG: 51.6420005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR089900',
        LOCATION_NAME: 'Bryning',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9215011,
        LOCATION_LATITUDE_DEG: 53.7857989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090000',
        LOCATION_NAME: 'Brynithel',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.140907,
        LOCATION_LATITUDE_DEG: 51.7061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090100',
        LOCATION_NAME: 'Brynllugan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.425492,
        LOCATION_LATITUDE_DEG: 52.6100874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090300',
        LOCATION_NAME: 'Brynmawr',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1711944,
        LOCATION_LATITUDE_DEG: 51.798812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090200',
        LOCATION_NAME: 'Brynmawr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.113695,
        LOCATION_LATITUDE_DEG: 52.7621969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090400',
        LOCATION_NAME: 'Brynmenyn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5775499,
        LOCATION_LATITUDE_DEG: 51.5514928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090500',
        LOCATION_NAME: 'Brynmill',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9686777,
        LOCATION_LATITUDE_DEG: 51.6123044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090600',
        LOCATION_NAME: 'Brynna',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4619143,
        LOCATION_LATITUDE_DEG: 51.5383859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090700',
        LOCATION_NAME: 'Brynore',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9479408,
        LOCATION_LATITUDE_DEG: 52.9154108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090800',
        LOCATION_NAME: 'Brynrefail',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1552039,
        LOCATION_LATITUDE_DEG: 53.1417484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR090900',
        LOCATION_NAME: 'Brynsadler',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.399091,
        LOCATION_LATITUDE_DEG: 51.5165883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091000',
        LOCATION_NAME: 'Brynsiencyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2671812,
        LOCATION_LATITUDE_DEG: 53.1797543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091400',
        LOCATION_NAME: 'Brynteg',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2592835,
        LOCATION_LATITUDE_DEG: 53.3186662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091100',
        LOCATION_NAME: 'Brynteg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.210516,
        LOCATION_LATITUDE_DEG: 52.0722461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091300',
        LOCATION_NAME: 'Brynteg',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3554157,
        LOCATION_LATITUDE_DEG: 51.5461846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091200',
        LOCATION_NAME: 'Brynteg',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0286827,
        LOCATION_LATITUDE_DEG: 53.0624283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR091500',
        LOCATION_NAME: 'Bryntirion',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6011437,
        LOCATION_LATITUDE_DEG: 51.5052896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087600',
        LOCATION_NAME: 'Bryn-y-Baal',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1086466,
        LOCATION_LATITUDE_DEG: 53.1721405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087700',
        LOCATION_NAME: 'Bryn-y-Cochin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9429919,
        LOCATION_LATITUDE_DEG: 52.9149108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087900',
        LOCATION_NAME: 'Bryn-y-gwenin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9742589,
        LOCATION_LATITUDE_DEG: 51.8355528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR087800',
        LOCATION_NAME: 'Bryn-y-Maen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7454008,
        LOCATION_LATITUDE_DEG: 53.2711541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000100',
        LOCATION_NAME: 'Bualadubh',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3525645,
        LOCATION_LATITUDE_DEG: 57.3929975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000200',
        LOCATION_NAME: 'Bualnaluib',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.591819,
        LOCATION_LATITUDE_DEG: 57.8519262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000300',
        LOCATION_NAME: 'Bubbenhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4662559,
        LOCATION_LATITUDE_DEG: 52.3472436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000400',
        LOCATION_NAME: 'Bubwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9167766,
        LOCATION_LATITUDE_DEG: 53.8185801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000500',
        LOCATION_NAME: 'Buchanhaven',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7867975,
        LOCATION_LATITUDE_DEG: 57.5147496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000600',
        LOCATION_NAME: 'Buchanty',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7287257,
        LOCATION_LATITUDE_DEG: 56.4346712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000700',
        LOCATION_NAME: 'Buchany',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0819367,
        LOCATION_LATITUDE_DEG: 56.2000456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000800',
        LOCATION_NAME: 'Buchlyvie',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2924674,
        LOCATION_LATITUDE_DEG: 56.11504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU000900',
        LOCATION_NAME: 'Buckabank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9781579,
        LOCATION_LATITUDE_DEG: 54.8328981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001100',
        LOCATION_NAME: 'Buckden',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0890524,
        LOCATION_LATITUDE_DEG: 54.1912285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001000',
        LOCATION_NAME: 'Buckden',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2473962,
        LOCATION_LATITUDE_DEG: 52.2937163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001200',
        LOCATION_NAME: 'Buckenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4803205,
        LOCATION_LATITUDE_DEG: 52.6005222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001300',
        LOCATION_NAME: 'Buckenhill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.502971,
        LOCATION_LATITUDE_DEG: 52.2048378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001400',
        LOCATION_NAME: 'Buckerell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2442214,
        LOCATION_LATITUDE_DEG: 50.7960126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001500',
        LOCATION_NAME: 'Buckeridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4105881,
        LOCATION_LATITUDE_DEG: 52.3642526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001600',
        LOCATION_NAME: 'Buckfast',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7772576,
        LOCATION_LATITUDE_DEG: 50.4928956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001700',
        LOCATION_NAME: 'Buckfastleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7786766,
        LOCATION_LATITUDE_DEG: 50.4799933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001800',
        LOCATION_NAME: 'Buckhaven',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0307993,
        LOCATION_LATITUDE_DEG: 56.1764319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU001900',
        LOCATION_NAME: 'Buckholt',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7217163,
        LOCATION_LATITUDE_DEG: 51.850511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002000',
        LOCATION_NAME: 'Buckhorn Weston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3476678,
        LOCATION_LATITUDE_DEG: 51.0197262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002100',
        LOCATION_NAME: 'Buckhurst Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.037015,
        LOCATION_LATITUDE_DEG: 51.6257528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002200',
        LOCATION_NAME: 'Buckie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9633705,
        LOCATION_LATITUDE_DEG: 57.6764775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002300',
        LOCATION_NAME: 'Buckingham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9865224,
        LOCATION_LATITUDE_DEG: 51.9995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003100',
        LOCATION_NAME: 'Buckland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1624123,
        LOCATION_LATITUDE_DEG: 51.1211523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002500',
        LOCATION_NAME: 'Buckland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8804549,
        LOCATION_LATITUDE_DEG: 52.0221153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002700',
        LOCATION_NAME: 'Buckland',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5047096,
        LOCATION_LATITUDE_DEG: 51.6779803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002400',
        LOCATION_NAME: 'Buckland',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7138724,
        LOCATION_LATITUDE_DEG: 51.803582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003000',
        LOCATION_NAME: 'Buckland',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.250514,
        LOCATION_LATITUDE_DEG: 51.2432187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002600',
        LOCATION_NAME: 'Buckland',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0252272,
        LOCATION_LATITUDE_DEG: 51.9836883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU002900',
        LOCATION_NAME: 'Buckland',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8470798,
        LOCATION_LATITUDE_DEG: 51.31311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003200',
        LOCATION_NAME: 'Buckland Abbey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1295199,
        LOCATION_LATITUDE_DEG: 50.4807936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003300',
        LOCATION_NAME: 'Buckland Brewer',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2513476,
        LOCATION_LATITUDE_DEG: 50.964837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003400',
        LOCATION_NAME: 'Buckland Common',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6655659,
        LOCATION_LATITUDE_DEG: 51.7535751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003500',
        LOCATION_NAME: 'Buckland Dinham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3504226,
        LOCATION_LATITUDE_DEG: 51.2561466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044800',
        LOCATION_NAME: 'Buckland End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7874284,
        LOCATION_LATITUDE_DEG: 52.4988229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003600',
        LOCATION_NAME: 'Buckland Filleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1835523,
        LOCATION_LATITUDE_DEG: 50.8616327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003700',
        LOCATION_NAME: 'Buckland Marsh',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5556393,
        LOCATION_LATITUDE_DEG: 51.6823834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003800',
        LOCATION_NAME: 'Buckland Monachorum',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1295259,
        LOCATION_LATITUDE_DEG: 50.4962923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU003900',
        LOCATION_NAME: 'Buckland Newton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.435543,
        LOCATION_LATITUDE_DEG: 50.8459124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004000',
        LOCATION_NAME: 'Buckland Ripers',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4963135,
        LOCATION_LATITUDE_DEG: 50.6419886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043400',
        LOCATION_NAME: 'Buckland St Mary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004100',
        LOCATION_NAME: 'Buckland St. Mary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0379434,
        LOCATION_LATITUDE_DEG: 50.9145271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004200',
        LOCATION_NAME: 'Buckland tout Saints',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.741485,
        LOCATION_LATITUDE_DEG: 50.2997744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004300',
        LOCATION_NAME: 'Buckleaze',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7645639,
        LOCATION_LATITUDE_DEG: 51.3423518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004400',
        LOCATION_NAME: 'Bucklebury',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.205358,
        LOCATION_LATITUDE_DEG: 51.4333471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004500',
        LOCATION_NAME: 'Bucklerheads',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8756349,
        LOCATION_LATITUDE_DEG: 56.5149674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004600',
        LOCATION_NAME: 'Bucklers Hard',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4203393,
        LOCATION_LATITUDE_DEG: 50.7966929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004700',
        LOCATION_NAME: 'Bucklesham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2705431,
        LOCATION_LATITUDE_DEG: 52.0286708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004800',
        LOCATION_NAME: 'Buckley',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.079591,
        LOCATION_LATITUDE_DEG: 53.168038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU004900',
        LOCATION_NAME: 'Bucklow Hill',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4037712,
        LOCATION_LATITUDE_DEG: 53.3451485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005000',
        LOCATION_NAME: 'Buckminster',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6932616,
        LOCATION_LATITUDE_DEG: 52.7964708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005100',
        LOCATION_NAME: 'Bucknall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1421292,
        LOCATION_LATITUDE_DEG: 53.024617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005200',
        LOCATION_NAME: 'Bucknall',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2482667,
        LOCATION_LATITUDE_DEG: 53.2037092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005400',
        LOCATION_NAME: 'Bucknell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9478161,
        LOCATION_LATITUDE_DEG: 52.3585575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005300',
        LOCATION_NAME: 'Bucknell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1860336,
        LOCATION_LATITUDE_DEG: 51.9255956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005500',
        LOCATION_NAME: 'Bucknowle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1436286,
        LOCATION_LATITUDE_DEG: 50.6454842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005600',
        LOCATION_NAME: 'Buckover',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.484924,
        LOCATION_LATITUDE_DEG: 51.6106798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005700',
        LOCATION_NAME: 'Buckpool',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9781204,
        LOCATION_LATITUDE_DEG: 57.6755828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005800',
        LOCATION_NAME: 'Bucks Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3594641,
        LOCATION_LATITUDE_DEG: 50.980359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU005900',
        LOCATION_NAME: 'Bucks Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4546527,
        LOCATION_LATITUDE_DEG: 51.0850059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006000',
        LOCATION_NAME: 'Bucks Hill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4745524,
        LOCATION_LATITUDE_DEG: 51.6902701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006100',
        LOCATION_NAME: 'Bucks Horn Oak',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8457375,
        LOCATION_LATITUDE_DEG: 51.1682236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006200',
        LOCATION_NAME: 'Bucks Mills',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3482213,
        LOCATION_LATITUDE_DEG: 50.9862794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006300',
        LOCATION_NAME: 'Bucksburn',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1850922,
        LOCATION_LATITUDE_DEG: 57.1751247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006400',
        LOCATION_NAME: 'Buckshaft',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5006223,
        LOCATION_LATITUDE_DEG: 51.8164017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990397',
        LOCATION_NAME: 'Buckshaw Village',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6700485,
        LOCATION_LATITUDE_DEG: 53.6494277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006500',
        LOCATION_NAME: 'Buckshead',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0379131,
        LOCATION_LATITUDE_DEG: 50.2775795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006700',
        LOCATION_NAME: 'Buckton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9041149,
        LOCATION_LATITUDE_DEG: 52.3544582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006600',
        LOCATION_NAME: 'Buckton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1906129,
        LOCATION_LATITUDE_DEG: 54.1346003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006800',
        LOCATION_NAME: 'Buckworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3117247,
        LOCATION_LATITUDE_DEG: 52.3772291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU006900',
        LOCATION_NAME: 'Budbrooke',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6305932,
        LOCATION_LATITUDE_DEG: 52.2764356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007000',
        LOCATION_NAME: 'Budby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0736841,
        LOCATION_LATITUDE_DEG: 53.224322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007100',
        LOCATION_NAME: 'Bude',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5349231,
        LOCATION_LATITUDE_DEG: 50.8247338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007200',
        LOCATION_NAME: 'Budlake',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4406203,
        LOCATION_LATITUDE_DEG: 50.7916207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007300',
        LOCATION_NAME: 'Budle',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7534055,
        LOCATION_LATITUDE_DEG: 55.6088608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007400',
        LOCATION_NAME: 'Budleigh Salterton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.322675,
        LOCATION_LATITUDE_DEG: 50.6296022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007500',
        LOCATION_NAME: 'Budna',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3297606,
        LOCATION_LATITUDE_DEG: 52.1161058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007600',
        LOCATION_NAME: 'Budock Water',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1028712,
        LOCATION_LATITUDE_DEG: 50.1468738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007700',
        LOCATION_NAME: 'Budworth Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5057885,
        LOCATION_LATITUDE_DEG: 53.3019502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007800',
        LOCATION_NAME: 'Buerton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4692182,
        LOCATION_LATITUDE_DEG: 52.9880131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU007900',
        LOCATION_NAME: 'Bufflers Holt',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0260442,
        LOCATION_LATITUDE_DEG: 52.0110015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008000',
        LOCATION_NAME: 'Bufton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4071971,
        LOCATION_LATITUDE_DEG: 52.6468694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008100',
        LOCATION_NAME: 'Bugbrooke',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0092069,
        LOCATION_LATITUDE_DEG: 52.2109219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008200',
        LOCATION_NAME: 'Bugford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6378825,
        LOCATION_LATITUDE_DEG: 50.3482794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008300',
        LOCATION_NAME: 'Buglawton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1972194,
        LOCATION_LATITUDE_DEG: 53.1672291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008400',
        LOCATION_NAME: 'Bugle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7925746,
        LOCATION_LATITUDE_DEG: 50.3955881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008500',
        LOCATION_NAME: 'Bugley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3014277,
        LOCATION_LATITUDE_DEG: 51.022022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008600',
        LOCATION_NAME: 'Bugthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8210329,
        LOCATION_LATITUDE_DEG: 54.0105902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008700',
        LOCATION_NAME: 'Buildwas',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5346179,
        LOCATION_LATITUDE_DEG: 52.6381823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008800',
        LOCATION_NAME: 'Builth Road',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4257751,
        LOCATION_LATITUDE_DEG: 52.1682513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU008900',
        LOCATION_NAME: 'Builth Wells',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4044169,
        LOCATION_LATITUDE_DEG: 52.1494441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009000',
        LOCATION_NAME: 'Bulbarrow',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2522287,
        LOCATION_LATITUDE_DEG: 50.7262977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009100',
        LOCATION_NAME: 'Bulbourne',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6450399,
        LOCATION_LATITUDE_DEG: 51.8138788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009200',
        LOCATION_NAME: 'Bulby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.437068,
        LOCATION_LATITUDE_DEG: 52.8224779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU991003',
        LOCATION_NAME: 'Bulcamp',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009300',
        LOCATION_NAME: 'Bulcote',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0215299,
        LOCATION_LATITUDE_DEG: 52.9935977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009400',
        LOCATION_NAME: 'Buldoo',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7253028,
        LOCATION_LATITUDE_DEG: 58.5790773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009500',
        LOCATION_NAME: 'Bulford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7587221,
        LOCATION_LATITUDE_DEG: 51.1886335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009550',
        LOCATION_NAME: 'Bulford Barracks',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7328928,
        LOCATION_LATITUDE_DEG: 51.1908526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009700',
        LOCATION_NAME: 'Bulk',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7747787,
        LOCATION_LATITUDE_DEG: 54.0583248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009800',
        LOCATION_NAME: 'Bulkeley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7006536,
        LOCATION_LATITUDE_DEG: 53.0867303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009900',
        LOCATION_NAME: 'Bulkington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0818385,
        LOCATION_LATITUDE_DEG: 51.3235491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010000',
        LOCATION_NAME: 'Bulkington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4237437,
        LOCATION_LATITUDE_DEG: 52.4764546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010100',
        LOCATION_NAME: 'Bulkworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2832647,
        LOCATION_LATITUDE_DEG: 50.9040327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010200',
        LOCATION_NAME: 'Bull Bay',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3695001,
        LOCATION_LATITUDE_DEG: 53.4195829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010300',
        LOCATION_NAME: 'Bull Hill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8491966,
        LOCATION_LATITUDE_DEG: 50.9243132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010400',
        LOCATION_NAME: 'Bull Pitch',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3458109,
        LOCATION_LATITUDE_DEG: 51.6793877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010600',
        LOCATION_NAME: 'Bullbridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4666531,
        LOCATION_LATITUDE_DEG: 53.067109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010700',
        LOCATION_NAME: 'Bullens Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2546085,
        LOCATION_LATITUDE_DEG: 51.7426683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010800',
        LOCATION_NAME: 'Bullgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4018714,
        LOCATION_LATITUDE_DEG: 54.7313998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010900',
        LOCATION_NAME: 'Bullingham',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6951775,
        LOCATION_LATITUDE_DEG: 52.0380278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011000',
        LOCATION_NAME: 'Bullinghope',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7124902,
        LOCATION_LATITUDE_DEG: 52.0301285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011100',
        LOCATION_NAME: 'Bullington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3587621,
        LOCATION_LATITUDE_DEG: 53.2864165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011200',
        LOCATION_NAME: 'Bullo Pill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4552868,
        LOCATION_LATITUDE_DEG: 51.7865973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011300',
        LOCATION_NAME: 'Bullocks Mill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9968563,
        LOCATION_LATITUDE_DEG: 52.2071483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011600',
        LOCATION_NAME: 'Bulmer',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9331857,
        LOCATION_LATITUDE_DEG: 54.0991018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011500',
        LOCATION_NAME: 'Bulmer',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6855723,
        LOCATION_LATITUDE_DEG: 52.0296801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011700',
        LOCATION_NAME: 'Bulphan',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3617814,
        LOCATION_LATITUDE_DEG: 51.5472369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011800',
        LOCATION_NAME: 'Bulthy',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0152882,
        LOCATION_LATITUDE_DEG: 52.7185926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011900',
        LOCATION_NAME: 'Bulverhythe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5135393,
        LOCATION_LATITUDE_DEG: 50.8480717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012000',
        LOCATION_NAME: 'Bulverton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2563466,
        LOCATION_LATITUDE_DEG: 50.6919018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012100',
        LOCATION_NAME: 'Bulwardine',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2992865,
        LOCATION_LATITUDE_DEG: 52.5184695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012200',
        LOCATION_NAME: 'Bulwark',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6743549,
        LOCATION_LATITUDE_DEG: 51.6307869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012300',
        LOCATION_NAME: 'Bulwell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.196621,
        LOCATION_LATITUDE_DEG: 52.9995038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012400',
        LOCATION_NAME: 'Bulwell Forest',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1844225,
        LOCATION_LATITUDE_DEG: 53.003898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012500',
        LOCATION_NAME: 'Bulwick',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5802289,
        LOCATION_LATITUDE_DEG: 52.5368478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012600',
        LOCATION_NAME: "Bumble'S Green",
        COUNTY_NAME: 'Essex',
        POSTCODE: 'EN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0393653,
        LOCATION_LATITUDE_DEG: 51.7257652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012700',
        LOCATION_NAME: 'Bumpers Farm',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1511965,
        LOCATION_LATITUDE_DEG: 51.4736667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012900',
        LOCATION_NAME: 'Bunanuisg',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2723926,
        LOCATION_LATITUDE_DEG: 55.7602273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013000',
        LOCATION_NAME: 'Bunavoneader',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8472388,
        LOCATION_LATITUDE_DEG: 57.9352509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013500',
        LOCATION_NAME: 'Bunbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6445122,
        LOCATION_LATITUDE_DEG: 53.1180279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013600',
        LOCATION_NAME: 'Bunbury Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6681354,
        LOCATION_LATITUDE_DEG: 53.1169267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013700',
        LOCATION_NAME: 'BUNCHREW',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2983464,
        LOCATION_LATITUDE_DEG: 57.4821783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014000',
        LOCATION_NAME: 'Bundalloch',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4959564,
        LOCATION_LATITUDE_DEG: 57.2886751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014300',
        LOCATION_NAME: 'Bunessan',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2305024,
        LOCATION_LATITUDE_DEG: 56.3170794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014400',
        LOCATION_NAME: 'Bungay',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4418003,
        LOCATION_LATITUDE_DEG: 52.4542096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014600',
        LOCATION_NAME: 'Bunkers Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3131067,
        LOCATION_LATITUDE_DEG: 51.8549908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014900',
        LOCATION_NAME: 'Bunloit',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4870868,
        LOCATION_LATITUDE_DEG: 57.2946626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015100',
        LOCATION_NAME: 'Bunnahabhain',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1248625,
        LOCATION_LATITUDE_DEG: 55.881441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015400',
        LOCATION_NAME: 'Bunny',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.133496,
        LOCATION_LATITUDE_DEG: 52.8600838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015900',
        LOCATION_NAME: 'Buntingford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0159996,
        LOCATION_LATITUDE_DEG: 51.9449798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016000',
        LOCATION_NAME: 'Buntingsdale',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5163843,
        LOCATION_LATITUDE_DEG: 52.8866036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016100',
        LOCATION_NAME: 'Bunwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1188008,
        LOCATION_LATITUDE_DEG: 52.5011238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016200',
        LOCATION_NAME: 'Bunyions Lye',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8181345,
        LOCATION_LATITUDE_DEG: 52.5187715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016400',
        LOCATION_NAME: 'Burbage',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9341198,
        LOCATION_LATITUDE_DEG: 53.2523377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016300',
        LOCATION_NAME: 'Burbage',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6698866,
        LOCATION_LATITUDE_DEG: 51.3519524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016500',
        LOCATION_NAME: 'Burbage',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3468483,
        LOCATION_LATITUDE_DEG: 52.5272596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016600',
        LOCATION_NAME: 'Burchetts Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7898976,
        LOCATION_LATITUDE_DEG: 51.5234206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016700',
        LOCATION_NAME: 'Burcombe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8955364,
        LOCATION_LATITUDE_DEG: 51.0790302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017000',
        LOCATION_NAME: 'Burcot',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5595031,
        LOCATION_LATITUDE_DEG: 52.6946917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016900',
        LOCATION_NAME: 'Burcot',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0281711,
        LOCATION_LATITUDE_DEG: 52.3422507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU016800',
        LOCATION_NAME: 'Burcot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1897969,
        LOCATION_LATITUDE_DEG: 51.6603767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017100',
        LOCATION_NAME: 'Burcote',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3730306,
        LOCATION_LATITUDE_DEG: 52.552174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017200',
        LOCATION_NAME: 'Burcott',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7034365,
        LOCATION_LATITUDE_DEG: 52.0737303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017400',
        LOCATION_NAME: 'Burcott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6797644,
        LOCATION_LATITUDE_DEG: 51.203545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017300',
        LOCATION_NAME: 'Burcott',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7208887,
        LOCATION_LATITUDE_DEG: 51.9035921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017500',
        LOCATION_NAME: 'Burderop',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7615711,
        LOCATION_LATITUDE_DEG: 51.5176661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017600',
        LOCATION_NAME: 'Burdiehouse',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1695579,
        LOCATION_LATITUDE_DEG: 55.8947046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017700',
        LOCATION_NAME: 'Burdrop',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4777081,
        LOCATION_LATITUDE_DEG: 52.0376082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017800',
        LOCATION_NAME: 'Bures',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7766418,
        LOCATION_LATITUDE_DEG: 51.9723787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU017900',
        LOCATION_NAME: 'Bures Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7849826,
        LOCATION_LATITUDE_DEG: 51.9821743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018050',
        LOCATION_NAME: 'Burford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5909297,
        LOCATION_LATITUDE_DEG: 52.314162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018000',
        LOCATION_NAME: 'Burford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.635357,
        LOCATION_LATITUDE_DEG: 51.8069927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018100',
        LOCATION_NAME: 'Burgate',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0574992,
        LOCATION_LATITUDE_DEG: 52.3383079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018200',
        LOCATION_NAME: 'Burgedin',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1321418,
        LOCATION_LATITUDE_DEG: 52.7247992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018300',
        LOCATION_NAME: 'Burgess Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.132393,
        LOCATION_LATITUDE_DEG: 50.9569897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990951',
        LOCATION_NAME: 'Burgess Springs',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018400',
        LOCATION_NAME: 'Burgh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2600814,
        LOCATION_LATITUDE_DEG: 52.1158815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018500',
        LOCATION_NAME: 'Burgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2884624,
        LOCATION_LATITUDE_DEG: 52.7788417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043900',
        LOCATION_NAME: 'Burgh by Sands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0593513,
        LOCATION_LATITUDE_DEG: 54.9253676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018600',
        LOCATION_NAME: 'Burgh Castle',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6624754,
        LOCATION_LATITUDE_DEG: 52.5868188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018700',
        LOCATION_NAME: 'Burgh Heath',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2178387,
        LOCATION_LATITUDE_DEG: 51.3052235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018800',
        LOCATION_NAME: 'Burgh Island',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8960523,
        LOCATION_LATITUDE_DEG: 50.2772691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019000',
        LOCATION_NAME: 'Burgh le Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2456121,
        LOCATION_LATITUDE_DEG: 53.1616937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044000',
        LOCATION_NAME: 'Burgh on Bain',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043500',
        LOCATION_NAME: 'Burgh St Peter',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU018900',
        LOCATION_NAME: 'Burgh St. Peter',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6332513,
        LOCATION_LATITUDE_DEG: 52.4837127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019100',
        LOCATION_NAME: 'Burgh-by-Sands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0544231,
        LOCATION_LATITUDE_DEG: 54.9201256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019300',
        LOCATION_NAME: 'Burghclere',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3253895,
        LOCATION_LATITUDE_DEG: 51.3464464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019400',
        LOCATION_NAME: 'Burghead',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4870755,
        LOCATION_LATITUDE_DEG: 57.7011906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019500',
        LOCATION_NAME: 'Burghfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.040763,
        LOCATION_LATITUDE_DEG: 51.4108476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019600',
        LOCATION_NAME: 'Burghfield Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0553189,
        LOCATION_LATITUDE_DEG: 51.398142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019700',
        LOCATION_NAME: 'Burghfield Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0510857,
        LOCATION_LATITUDE_DEG: 51.4005448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019800',
        LOCATION_NAME: 'Burghill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7611367,
        LOCATION_LATITUDE_DEG: 52.0953298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019200',
        LOCATION_NAME: 'Burgh-on-Bain',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1707031,
        LOCATION_LATITUDE_DEG: 53.359492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU019900',
        LOCATION_NAME: 'Burghwallis',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1929326,
        LOCATION_LATITUDE_DEG: 53.600857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990190',
        LOCATION_NAME: 'Burgie',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5211118,
        LOCATION_LATITUDE_DEG: 57.6211367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020000',
        LOCATION_NAME: 'Burgoyne Heights',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3350168,
        LOCATION_LATITUDE_DEG: 51.1529874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020100',
        LOCATION_NAME: 'Burham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4844261,
        LOCATION_LATITUDE_DEG: 51.3295189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020200',
        LOCATION_NAME: 'Buriton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9463488,
        LOCATION_LATITUDE_DEG: 50.9744012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020400',
        LOCATION_NAME: 'Burkham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0647058,
        LOCATION_LATITUDE_DEG: 51.1779224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020500',
        LOCATION_NAME: 'Burland',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5723393,
        LOCATION_LATITUDE_DEG: 53.0766283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020600',
        LOCATION_NAME: 'Burland',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8399987,
        LOCATION_LATITUDE_DEG: 53.7634662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020700',
        LOCATION_NAME: 'Burlawn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8238715,
        LOCATION_LATITUDE_DEG: 50.4955984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020800',
        LOCATION_NAME: 'Burleigh',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1977034,
        LOCATION_LATITUDE_DEG: 51.7121922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020900',
        LOCATION_NAME: 'Burlescombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3183786,
        LOCATION_LATITUDE_DEG: 50.9434275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021000',
        LOCATION_NAME: 'Burleston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3177173,
        LOCATION_LATITUDE_DEG: 50.7468952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021100',
        LOCATION_NAME: 'Burlestone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6495801,
        LOCATION_LATITUDE_DEG: 50.3235757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU045000',
        LOCATION_NAME: 'Burley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021300',
        LOCATION_NAME: 'Burley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7740942,
        LOCATION_LATITUDE_DEG: 52.4256668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021400',
        LOCATION_NAME: 'Burley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.700392,
        LOCATION_LATITUDE_DEG: 50.8257003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044900',
        LOCATION_NAME: 'Burley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5712118,
        LOCATION_LATITUDE_DEG: 53.808358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990118',
        LOCATION_NAME: 'Burley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7010681,
        LOCATION_LATITUDE_DEG: 52.654315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021200',
        LOCATION_NAME: 'Burley',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6942762,
        LOCATION_LATITUDE_DEG: 52.6842624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021500',
        LOCATION_NAME: 'Burley Gate',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5878913,
        LOCATION_LATITUDE_DEG: 52.1222351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021700',
        LOCATION_NAME: 'Burley in Wharfedale',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7503635,
        LOCATION_LATITUDE_DEG: 53.9105925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021600',
        LOCATION_NAME: 'Burley Street',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7124631,
        LOCATION_LATITUDE_DEG: 50.8369996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021800',
        LOCATION_NAME: 'Burleydam',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5884937,
        LOCATION_LATITUDE_DEG: 52.9803173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU021900',
        LOCATION_NAME: 'Burleyfields',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1469564,
        LOCATION_LATITUDE_DEG: 52.8037901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022000',
        LOCATION_NAME: 'Burlingjobb',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0962359,
        LOCATION_LATITUDE_DEG: 52.2178484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022100',
        LOCATION_NAME: 'Burlington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3311769,
        LOCATION_LATITUDE_DEG: 52.6979858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022200',
        LOCATION_NAME: 'Burlington Pool',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2946835,
        LOCATION_LATITUDE_DEG: 52.7135911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022300',
        LOCATION_NAME: 'Burlton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8055403,
        LOCATION_LATITUDE_DEG: 52.8288028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022400',
        LOCATION_NAME: 'Burmantofts',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5097601,
        LOCATION_LATITUDE_DEG: 53.8007784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022500',
        LOCATION_NAME: 'Burmarsh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.998416,
        LOCATION_LATITUDE_DEG: 51.0482858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022600',
        LOCATION_NAME: 'Burmington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6104065,
        LOCATION_LATITUDE_DEG: 52.0372134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022700',
        LOCATION_NAME: 'Burn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0989871,
        LOCATION_LATITUDE_DEG: 53.7498712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022800',
        LOCATION_NAME: 'Burn Banks',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7610315,
        LOCATION_LATITUDE_DEG: 54.5376712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU022900',
        LOCATION_NAME: 'Burn Bridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5432537,
        LOCATION_LATITUDE_DEG: 53.9589009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044500',
        LOCATION_NAME: 'Burnage',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2019806,
        LOCATION_LATITUDE_DEG: 53.4320421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023000',
        LOCATION_NAME: 'Burnaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5720408,
        LOCATION_LATITUDE_DEG: 52.8893915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023100',
        LOCATION_NAME: 'Burnbank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0752604,
        LOCATION_LATITUDE_DEG: 55.7832062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023200',
        LOCATION_NAME: 'Burnby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7272179,
        LOCATION_LATITUDE_DEG: 53.9064794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023500',
        LOCATION_NAME: 'Burncross',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4749539,
        LOCATION_LATITUDE_DEG: 53.4586482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023600',
        LOCATION_NAME: 'Burnden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4138971,
        LOCATION_LATITUDE_DEG: 53.5682715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023700',
        LOCATION_NAME: 'Burnedge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1214309,
        LOCATION_LATITUDE_DEG: 53.589871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023800',
        LOCATION_NAME: 'Burneside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7626908,
        LOCATION_LATITUDE_DEG: 54.3545511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023900',
        LOCATION_NAME: 'Burneston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5267539,
        LOCATION_LATITUDE_DEG: 54.2591296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990082',
        LOCATION_NAME: 'Burnett',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4809364,
        LOCATION_LATITUDE_DEG: 51.3874194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024000',
        LOCATION_NAME: 'Burnfoot',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8975001,
        LOCATION_LATITUDE_DEG: 55.6669977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024300',
        LOCATION_NAME: 'Burngate',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2206356,
        LOCATION_LATITUDE_DEG: 50.6336899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044400',
        LOCATION_NAME: 'Burngreave',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4581772,
        LOCATION_LATITUDE_DEG: 53.3921305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024500',
        LOCATION_NAME: 'Burnham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6573156,
        LOCATION_LATITUDE_DEG: 51.5355574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024400',
        LOCATION_NAME: 'Burnham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3967913,
        LOCATION_LATITUDE_DEG: 53.6391563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024600',
        LOCATION_NAME: 'Burnham Deepdale',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6865187,
        LOCATION_LATITUDE_DEG: 52.9653729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024700',
        LOCATION_NAME: 'Burnham Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1674085,
        LOCATION_LATITUDE_DEG: 51.832576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024800',
        LOCATION_NAME: 'Burnham Market',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7276585,
        LOCATION_LATITUDE_DEG: 52.9452712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024900',
        LOCATION_NAME: 'Burnham Norton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7153687,
        LOCATION_LATITUDE_DEG: 52.9610748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043700',
        LOCATION_NAME: 'Burnham on Crouch',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043800',
        LOCATION_NAME: 'Burnham on Sea',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025000',
        LOCATION_NAME: 'Burnham Overy Staithe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7447202,
        LOCATION_LATITUDE_DEG: 52.9633679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025100',
        LOCATION_NAME: 'Burnham Overy Town',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7438401,
        LOCATION_LATITUDE_DEG: 52.9527674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025200',
        LOCATION_NAME: 'Burnham Thorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7581631,
        LOCATION_LATITUDE_DEG: 52.9377678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025300',
        LOCATION_NAME: 'Burnham Warren',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4222659,
        LOCATION_LATITUDE_DEG: 53.6359526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025400',
        LOCATION_NAME: 'Burnham-on-Crouch',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8162321,
        LOCATION_LATITUDE_DEG: 51.6344464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025500',
        LOCATION_NAME: 'Burnham-on-Sea',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9936733,
        LOCATION_LATITUDE_DEG: 51.2379567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025600',
        LOCATION_NAME: 'Burnhaven',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7917126,
        LOCATION_LATITUDE_DEG: 57.4871512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025700',
        LOCATION_NAME: 'Burnhead',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.790946,
        LOCATION_LATITUDE_DEG: 55.2399469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025800',
        LOCATION_NAME: 'Burnhervie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4457798,
        LOCATION_LATITUDE_DEG: 57.2659367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU025900',
        LOCATION_NAME: 'Burnhill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8841609,
        LOCATION_LATITUDE_DEG: 54.958216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026000',
        LOCATION_NAME: 'Burnhill Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3096648,
        LOCATION_LATITUDE_DEG: 52.6025798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026100',
        LOCATION_NAME: 'Burnhope',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7072021,
        LOCATION_LATITUDE_DEG: 54.8280819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026200',
        LOCATION_NAME: 'Burnhouse',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5725696,
        LOCATION_LATITUDE_DEG: 55.7193071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026300',
        LOCATION_NAME: 'Burniston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4423398,
        LOCATION_LATITUDE_DEG: 54.3214153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026400',
        LOCATION_NAME: 'Burnley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2419174,
        LOCATION_LATITUDE_DEG: 53.7892933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026500',
        LOCATION_NAME: 'Burnmouth',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0741956,
        LOCATION_LATITUDE_DEG: 55.8405875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026600',
        LOCATION_NAME: 'Burnopfield',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.740171,
        LOCATION_LATITUDE_DEG: 54.906195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026700',
        LOCATION_NAME: 'Burnsall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.950741,
        LOCATION_LATITUDE_DEG: 54.0464101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026800',
        LOCATION_NAME: 'Burnside',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.454036,
        LOCATION_LATITUDE_DEG: 58.4130918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027000',
        LOCATION_NAME: 'Burnside',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3522304,
        LOCATION_LATITUDE_DEG: 56.2556492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU026900',
        LOCATION_NAME: 'Burnside',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8141143,
        LOCATION_LATITUDE_DEG: 56.6405774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027100',
        LOCATION_NAME: 'Burnside Of Duntrune',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.906428,
        LOCATION_LATITUDE_DEG: 56.5017626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027200',
        LOCATION_NAME: 'Burnswark',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2660892,
        LOCATION_LATITUDE_DEG: 55.0981336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027300',
        LOCATION_NAME: 'Burnt Fen',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3650892,
        LOCATION_LATITUDE_DEG: 52.4619258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027400',
        LOCATION_NAME: 'Burnt Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2156147,
        LOCATION_LATITUDE_DEG: 51.4888566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027500',
        LOCATION_NAME: 'Burnt Houses',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8122254,
        LOCATION_LATITUDE_DEG: 54.6056655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027600',
        LOCATION_NAME: 'Burnt Norton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.786108,
        LOCATION_LATITUDE_DEG: 52.0714181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044700',
        LOCATION_NAME: 'Burnt Oak',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2737098,
        LOCATION_LATITUDE_DEG: 51.6089521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027700',
        LOCATION_NAME: 'Burnt Oak',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1636044,
        LOCATION_LATITUDE_DEG: 51.0257974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027800',
        LOCATION_NAME: 'Burnt Yates',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6167764,
        LOCATION_LATITUDE_DEG: 54.0459085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU027900',
        LOCATION_NAME: 'Burntisland',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2290389,
        LOCATION_LATITUDE_DEG: 56.060026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028000',
        LOCATION_NAME: 'Burntwood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9324376,
        LOCATION_LATITUDE_DEG: 52.6813827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028200',
        LOCATION_NAME: 'Burpham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5442261,
        LOCATION_LATITUDE_DEG: 51.2577273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028100',
        LOCATION_NAME: 'Burpham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5231928,
        LOCATION_LATITUDE_DEG: 50.8699927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028300',
        LOCATION_NAME: 'Burradon',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0306746,
        LOCATION_LATITUDE_DEG: 55.3481365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028350',
        LOCATION_NAME: 'Burradon',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5708665,
        LOCATION_LATITUDE_DEG: 55.0487575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028400',
        LOCATION_NAME: 'Burras',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2513666,
        LOCATION_LATITUDE_DEG: 50.1676758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028600',
        LOCATION_NAME: 'Burraton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2308277,
        LOCATION_LATITUDE_DEG: 50.4469886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028500',
        LOCATION_NAME: 'Burraton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9518046,
        LOCATION_LATITUDE_DEG: 50.3584821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028700',
        LOCATION_NAME: 'Burraton Coombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2331333,
        LOCATION_LATITUDE_DEG: 50.4049896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028800',
        LOCATION_NAME: 'Burravoe',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3347268,
        LOCATION_LATITUDE_DEG: 60.5888475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU028900',
        LOCATION_NAME: 'Burray',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9011248,
        LOCATION_LATITUDE_DEG: 58.859097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029000',
        LOCATION_NAME: 'Burray Village',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9143604,
        LOCATION_LATITUDE_DEG: 58.844893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029100',
        LOCATION_NAME: 'Burrells',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4947091,
        LOCATION_LATITUDE_DEG: 54.5586653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029200',
        LOCATION_NAME: 'Burrelton',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2996913,
        LOCATION_LATITUDE_DEG: 56.5198725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029300',
        LOCATION_NAME: 'Burren',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2656315,
        LOCATION_LATITUDE_DEG: 54.1165603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029500',
        LOCATION_NAME: 'Burridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9733404,
        LOCATION_LATITUDE_DEG: 50.8518127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029400',
        LOCATION_NAME: 'Burridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2629103,
        LOCATION_LATITUDE_DEG: 50.890202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029600',
        LOCATION_NAME: 'Burrill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6281197,
        LOCATION_LATITUDE_DEG: 54.2788278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029700',
        LOCATION_NAME: 'Burringham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7367713,
        LOCATION_LATITUDE_DEG: 53.5745527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030000',
        LOCATION_NAME: 'Burrington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9487955,
        LOCATION_LATITUDE_DEG: 50.932835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029800',
        LOCATION_NAME: 'Burrington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8174693,
        LOCATION_LATITUDE_DEG: 52.3445604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU029900',
        LOCATION_NAME: 'Burrington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7476724,
        LOCATION_LATITUDE_DEG: 51.3304631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030200',
        LOCATION_NAME: 'Burrough Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3962001,
        LOCATION_LATITUDE_DEG: 52.1730031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030300',
        LOCATION_NAME: 'Burrough on the Hill',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8796667,
        LOCATION_LATITUDE_DEG: 52.6881647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030500',
        LOCATION_NAME: 'Burrow',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3068445,
        LOCATION_LATITUDE_DEG: 50.6997022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990065',
        LOCATION_NAME: 'Burrow',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5954267,
        LOCATION_LATITUDE_DEG: 54.1740419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030600',
        LOCATION_NAME: 'Burrowbridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9170497,
        LOCATION_LATITUDE_DEG: 51.0652365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030700',
        LOCATION_NAME: 'Burrowhill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6068543,
        LOCATION_LATITUDE_DEG: 51.3579382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030800',
        LOCATION_NAME: 'Burry',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2292341,
        LOCATION_LATITUDE_DEG: 51.5889998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030900',
        LOCATION_NAME: 'Burry Green',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2217243,
        LOCATION_LATITUDE_DEG: 51.6002047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031000',
        LOCATION_NAME: 'Burry Port',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2478952,
        LOCATION_LATITUDE_DEG: 51.683808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031100',
        LOCATION_NAME: 'Burscough',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8431688,
        LOCATION_LATITUDE_DEG: 53.5998799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031200',
        LOCATION_NAME: 'Bursledon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3123992,
        LOCATION_LATITUDE_DEG: 50.8840016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031300',
        LOCATION_NAME: 'Burslem',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1942919,
        LOCATION_LATITUDE_DEG: 53.0456163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031400',
        LOCATION_NAME: 'Burstall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0589965,
        LOCATION_LATITUDE_DEG: 52.0596787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031500',
        LOCATION_NAME: 'Burstock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8214853,
        LOCATION_LATITUDE_DEG: 50.8225097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031700',
        LOCATION_NAME: 'Burston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0901708,
        LOCATION_LATITUDE_DEG: 52.8698009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031600',
        LOCATION_NAME: 'Burston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1428087,
        LOCATION_LATITUDE_DEG: 52.4046154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031800',
        LOCATION_NAME: 'Burstow',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1209363,
        LOCATION_LATITUDE_DEG: 51.1563153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031900',
        LOCATION_NAME: 'Burstwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1373505,
        LOCATION_LATITUDE_DEG: 53.7307541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032000',
        LOCATION_NAME: 'Burtersett',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1678871,
        LOCATION_LATITUDE_DEG: 54.2984384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032100',
        LOCATION_NAME: 'Burthorpe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.59541,
        LOCATION_LATITUDE_DEG: 52.2452058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032200',
        LOCATION_NAME: 'Burthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9106465,
        LOCATION_LATITUDE_DEG: 54.8378003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032300',
        LOCATION_NAME: 'Burtle',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8579408,
        LOCATION_LATITUDE_DEG: 51.1845497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032400',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9185826,
        LOCATION_LATITUDE_DEG: 51.7104169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032800',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0242424,
        LOCATION_LATITUDE_DEG: 53.2606504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032900',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9606352,
        LOCATION_LATITUDE_DEG: 53.1117343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032600',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7323529,
        LOCATION_LATITUDE_DEG: 53.1692316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033050',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7199,
        LOCATION_LATITUDE_DEG: 54.1821083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033000',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4410592,
        LOCATION_LATITUDE_DEG: 50.7181996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032700',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2657931,
        LOCATION_LATITUDE_DEG: 51.5139743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033075',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7709116,
        LOCATION_LATITUDE_DEG: 50.7491715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU032500',
        LOCATION_NAME: 'Burton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5571828,
        LOCATION_LATITUDE_DEG: 53.2605181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033100',
        LOCATION_NAME: 'Burton Agnes',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3152481,
        LOCATION_LATITUDE_DEG: 54.0502873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033200',
        LOCATION_NAME: 'Burton Bradstock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7234845,
        LOCATION_LATITUDE_DEG: 50.703802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033300',
        LOCATION_NAME: 'Burton Coggles',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5534617,
        LOCATION_LATITUDE_DEG: 52.8208067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033400',
        LOCATION_NAME: 'Burton Constable',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1881028,
        LOCATION_LATITUDE_DEG: 53.8144689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033500',
        LOCATION_NAME: 'Burton Dassett',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4200533,
        LOCATION_LATITUDE_DEG: 52.1640226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033600',
        LOCATION_NAME: 'Burton End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2149465,
        LOCATION_LATITUDE_DEG: 51.8926729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033700',
        LOCATION_NAME: 'Burton Fleming',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3426664,
        LOCATION_LATITUDE_DEG: 54.132502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033800',
        LOCATION_NAME: 'Burton Gorse',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3632757,
        LOCATION_LATITUDE_DEG: 52.9670895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU033900',
        LOCATION_NAME: 'Burton Green',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6074009,
        LOCATION_LATITUDE_DEG: 52.3745457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034000',
        LOCATION_NAME: 'Burton Hastings',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.393286,
        LOCATION_LATITUDE_DEG: 52.5047593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990952',
        LOCATION_NAME: 'Burton in Kendal',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034900',
        LOCATION_NAME: 'Burton in Lonsdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.533514,
        LOCATION_LATITUDE_DEG: 54.1443282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034100',
        LOCATION_NAME: 'Burton Joyce',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0361023,
        LOCATION_LATITUDE_DEG: 52.9875941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034200',
        LOCATION_NAME: 'Burton Latimer',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6742757,
        LOCATION_LATITUDE_DEG: 52.3659369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034300',
        LOCATION_NAME: 'Burton Lazars',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8633628,
        LOCATION_LATITUDE_DEG: 52.7444737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034400',
        LOCATION_NAME: 'Burton Leonard',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4995044,
        LOCATION_LATITUDE_DEG: 54.0686057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044200',
        LOCATION_NAME: 'Burton on the Wolds',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044100',
        LOCATION_NAME: 'Burton on Trent',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034500',
        LOCATION_NAME: 'Burton Overy',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9982649,
        LOCATION_LATITUDE_DEG: 52.5773586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034600',
        LOCATION_NAME: 'Burton Pedwardine',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3360137,
        LOCATION_LATITUDE_DEG: 52.9649846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034700',
        LOCATION_NAME: 'Burton Pidsea',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1004523,
        LOCATION_LATITUDE_DEG: 53.7625588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU034800',
        LOCATION_NAME: 'Burton Salmon',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2556327,
        LOCATION_LATITUDE_DEG: 53.740276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU044300',
        LOCATION_NAME: 'Burton upon Stather',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6845867,
        LOCATION_LATITUDE_DEG: 53.6508457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990953',
        LOCATION_NAME: 'Burton-in-Kendal',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035100',
        LOCATION_NAME: 'Burton-on-the-Wolds',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.128052,
        LOCATION_LATITUDE_DEG: 52.7840719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035000',
        LOCATION_NAME: 'Burton-on-Trent',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6293352,
        LOCATION_LATITUDE_DEG: 52.8013872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035500',
        LOCATION_NAME: 'Burtons Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6556532,
        LOCATION_LATITUDE_DEG: 51.9100715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035200',
        LOCATION_NAME: 'Burton-upon-Stather',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.67983,
        LOCATION_LATITUDE_DEG: 53.6485908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035600',
        LOCATION_NAME: 'Burtonwood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6516628,
        LOCATION_LATITUDE_DEG: 53.4301566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035800',
        LOCATION_NAME: 'Burwardsley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7255056,
        LOCATION_LATITUDE_DEG: 53.1056318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035900',
        LOCATION_NAME: 'Burwarton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5610882,
        LOCATION_LATITUDE_DEG: 52.4624654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036000',
        LOCATION_NAME: 'Burwash',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3875241,
        LOCATION_LATITUDE_DEG: 50.9970858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036100',
        LOCATION_NAME: 'Burwash Common',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.337195,
        LOCATION_LATITUDE_DEG: 50.98579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036200',
        LOCATION_NAME: 'Burwash Weald',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.352243,
        LOCATION_LATITUDE_DEG: 50.9840846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036300',
        LOCATION_NAME: 'Burwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0362205,
        LOCATION_LATITUDE_DEG: 53.2928141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036400',
        LOCATION_NAME: 'Burwell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3290382,
        LOCATION_LATITUDE_DEG: 52.2758106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036500',
        LOCATION_NAME: 'Burwen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3793651,
        LOCATION_LATITUDE_DEG: 53.4126788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036600',
        LOCATION_NAME: 'Burwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7602868,
        LOCATION_LATITUDE_DEG: 52.4805671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037000',
        LOCATION_NAME: 'Bury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5055186,
        LOCATION_LATITUDE_DEG: 51.0365363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036800',
        LOCATION_NAME: 'Bury',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2957158,
        LOCATION_LATITUDE_DEG: 53.5923719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036700',
        LOCATION_NAME: 'Bury',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5617543,
        LOCATION_LATITUDE_DEG: 50.9087889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU036900',
        LOCATION_NAME: 'Bury',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1055579,
        LOCATION_LATITUDE_DEG: 52.4359352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990460',
        LOCATION_NAME: 'Bury Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037100',
        LOCATION_NAME: 'Bury Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1087487,
        LOCATION_LATITUDE_DEG: 51.8721771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043600',
        LOCATION_NAME: 'Bury St Edmunds',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037200',
        LOCATION_NAME: 'Bury St. Edmunds',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7129251,
        LOCATION_LATITUDE_DEG: 52.2465013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037300',
        LOCATION_NAME: 'Buryas Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5761703,
        LOCATION_LATITUDE_DEG: 50.0999753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037400',
        LOCATION_NAME: 'Burythorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7902807,
        LOCATION_LATITUDE_DEG: 54.0741983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037500',
        LOCATION_NAME: 'Busbridge',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5991868,
        LOCATION_LATITUDE_DEG: 51.1763231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037600',
        LOCATION_NAME: 'Buscot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6656443,
        LOCATION_LATITUDE_DEG: 51.6755812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037700',
        LOCATION_NAME: 'Buscot Park',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6495534,
        LOCATION_LATITUDE_DEG: 51.665283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037800',
        LOCATION_NAME: 'Buscot Wick',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6607484,
        LOCATION_LATITUDE_DEG: 51.6784806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038000',
        LOCATION_NAME: 'Bush',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6540738,
        LOCATION_LATITUDE_DEG: 54.474996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU037900',
        LOCATION_NAME: 'Bush',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5075462,
        LOCATION_LATITUDE_DEG: 50.8428305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038100',
        LOCATION_NAME: 'Bush Bank',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8002016,
        LOCATION_LATITUDE_DEG: 52.156341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038200',
        LOCATION_NAME: 'Bushbury',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1141417,
        LOCATION_LATITUDE_DEG: 52.6224756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038300',
        LOCATION_NAME: 'Bushby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0341119,
        LOCATION_LATITUDE_DEG: 52.631864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038400',
        LOCATION_NAME: 'Bushey',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3646032,
        LOCATION_LATITUDE_DEG: 51.6443558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038500',
        LOCATION_NAME: 'Bushey Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3543941,
        LOCATION_LATITUDE_DEG: 51.636479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038800',
        LOCATION_NAME: 'Bushfield',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2741919,
        LOCATION_LATITUDE_DEG: 52.5467452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038900',
        LOCATION_NAME: 'Bushley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1819402,
        LOCATION_LATITUDE_DEG: 52.0075138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039000',
        LOCATION_NAME: 'Bushmills',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5253468,
        LOCATION_LATITUDE_DEG: 55.2100755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039100',
        LOCATION_NAME: 'Bushmoor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8299079,
        LOCATION_LATITUDE_DEG: 52.4841722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039200',
        LOCATION_NAME: 'Bushton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9100073,
        LOCATION_LATITUDE_DEG: 51.5002666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039400',
        LOCATION_NAME: 'Busk',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1330362,
        LOCATION_LATITUDE_DEG: 53.5470693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039500',
        LOCATION_NAME: 'Buslingthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3756719,
        LOCATION_LATITUDE_DEG: 53.3520199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039700',
        LOCATION_NAME: 'Bussage',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1644954,
        LOCATION_LATITUDE_DEG: 51.727692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043300',
        LOCATION_NAME: 'Busss Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039600',
        LOCATION_NAME: "Buss's Green",
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3479131,
        LOCATION_LATITUDE_DEG: 51.0887992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039800',
        LOCATION_NAME: 'Busvannah',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0901145,
        LOCATION_LATITUDE_DEG: 50.1726755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039900',
        LOCATION_NAME: 'Busveal',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2005306,
        LOCATION_LATITUDE_DEG: 50.2308807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040000',
        LOCATION_NAME: 'Butcombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.696983,
        LOCATION_LATITUDE_DEG: 51.3511626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040100',
        LOCATION_NAME: 'Butetown',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1675967,
        LOCATION_LATITUDE_DEG: 51.469579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040200',
        LOCATION_NAME: 'Butleigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6819659,
        LOCATION_LATITUDE_DEG: 51.099535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040300',
        LOCATION_NAME: 'Butleigh Wootton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7112836,
        LOCATION_LATITUDE_DEG: 51.1112405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040500',
        LOCATION_NAME: 'Butlers Cross',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.779927,
        LOCATION_LATITUDE_DEG: 51.7499349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040600',
        LOCATION_NAME: 'Butlers Marston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5337069,
        LOCATION_LATITUDE_DEG: 52.1472267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040800',
        LOCATION_NAME: 'Butley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4589865,
        LOCATION_LATITUDE_DEG: 52.106376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040900',
        LOCATION_NAME: 'Butlocks Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3361478,
        LOCATION_LATITUDE_DEG: 50.8776008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041000',
        LOCATION_NAME: 'Butterbank',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1795678,
        LOCATION_LATITUDE_DEG: 52.8046982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041100',
        LOCATION_NAME: 'Buttercrambe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8803901,
        LOCATION_LATITUDE_DEG: 54.0132971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041200',
        LOCATION_NAME: 'Butterknowle',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8326258,
        LOCATION_LATITUDE_DEG: 54.625963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041300',
        LOCATION_NAME: 'Butterleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4556732,
        LOCATION_LATITUDE_DEG: 50.8641243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041400',
        LOCATION_NAME: 'Butterley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4002441,
        LOCATION_LATITUDE_DEG: 53.0610121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041600',
        LOCATION_NAME: 'Buttermere',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2734829,
        LOCATION_LATITUDE_DEG: 54.5414783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041500',
        LOCATION_NAME: 'Buttermere',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5152419,
        LOCATION_LATITUDE_DEG: 51.3328444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041700',
        LOCATION_NAME: 'Butterrow Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.208603,
        LOCATION_LATITUDE_DEG: 51.730994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041800',
        LOCATION_NAME: 'Buttershaw',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7943679,
        LOCATION_LATITUDE_DEG: 53.7636793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU041900',
        LOCATION_NAME: 'Butterstone',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5229128,
        LOCATION_LATITUDE_DEG: 56.5949775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990067',
        LOCATION_NAME: 'Butterton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2604414,
        LOCATION_LATITUDE_DEG: 52.9941198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990258',
        LOCATION_NAME: 'Butterton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8889671,
        LOCATION_LATITUDE_DEG: 53.1087617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042000',
        LOCATION_NAME: 'Butterton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8872703,
        LOCATION_LATITUDE_DEG: 53.1063238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042100',
        LOCATION_NAME: 'Butterton Moor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9156894,
        LOCATION_LATITUDE_DEG: 53.1037222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042400',
        LOCATION_NAME: 'Butterwick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7566978,
        LOCATION_LATITUDE_DEG: 54.5682761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042200',
        LOCATION_NAME: 'Butterwick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4833729,
        LOCATION_LATITUDE_DEG: 54.1274982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042300',
        LOCATION_NAME: 'Butterwick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0682179,
        LOCATION_LATITUDE_DEG: 52.9844793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042600',
        LOCATION_NAME: 'Buttington',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1090897,
        LOCATION_LATITUDE_DEG: 52.6718886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042700',
        LOCATION_NAME: 'Buttons',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3410174,
        LOCATION_LATITUDE_DEG: 51.0353918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042800',
        LOCATION_NAME: 'Buxhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9329304,
        LOCATION_LATITUDE_DEG: 52.1803896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042900',
        LOCATION_NAME: 'Buxted',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1359777,
        LOCATION_LATITUDE_DEG: 50.9894912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043000',
        LOCATION_NAME: 'Buxton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9116071,
        LOCATION_LATITUDE_DEG: 53.258634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043100',
        LOCATION_NAME: 'Buxton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3015552,
        LOCATION_LATITUDE_DEG: 52.7523395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU043200',
        LOCATION_NAME: 'Buxworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9651694,
        LOCATION_LATITUDE_DEG: 53.337439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000400',
        LOCATION_NAME: 'Bwlch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2366498,
        LOCATION_LATITUDE_DEG: 53.3145701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000300',
        LOCATION_NAME: 'Bwlch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2377214,
        LOCATION_LATITUDE_DEG: 51.8903213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000500',
        LOCATION_NAME: 'Bwlch Derwin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2949483,
        LOCATION_LATITUDE_DEG: 52.9965391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001500',
        LOCATION_NAME: 'Bwlch y Cibau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001600',
        LOCATION_NAME: 'Bwlch y Ffridd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001700',
        LOCATION_NAME: 'Bwlch y Plain',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001800',
        LOCATION_NAME: 'Bwlch y Sarnau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001000',
        LOCATION_NAME: 'Bwlchgwyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0967262,
        LOCATION_LATITUDE_DEG: 53.0719349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001100',
        LOCATION_NAME: 'Bwlchllan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0791371,
        LOCATION_LATITUDE_DEG: 52.2064388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001200',
        LOCATION_NAME: 'Bwlchnewydd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3717308,
        LOCATION_LATITUDE_DEG: 51.8976294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001300',
        LOCATION_NAME: 'Bwlchtocyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5142208,
        LOCATION_LATITUDE_DEG: 52.8077247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000600',
        LOCATION_NAME: 'Bwlch-y-Cibau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2175556,
        LOCATION_LATITUDE_DEG: 52.7480043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000700',
        LOCATION_NAME: 'Bwlch-y-Ffridd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3730175,
        LOCATION_LATITUDE_DEG: 52.5502843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW001400',
        LOCATION_NAME: 'Bwlchygroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5636545,
        LOCATION_LATITUDE_DEG: 51.9944434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000800',
        LOCATION_NAME: 'Bwlch-y-Plain',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.112075,
        LOCATION_LATITUDE_DEG: 52.3688599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000900',
        LOCATION_NAME: 'Bwlch-y-Sarnau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4252574,
        LOCATION_LATITUDE_DEG: 52.3604622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000100',
        LOCATION_NAME: 'Byers Green',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6532126,
        LOCATION_LATITUDE_DEG: 54.7008727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000200',
        LOCATION_NAME: 'Byfield',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2441566,
        LOCATION_LATITUDE_DEG: 52.1751205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000300',
        LOCATION_NAME: 'Byfleet',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4723522,
        LOCATION_LATITUDE_DEG: 51.3383284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000400',
        LOCATION_NAME: 'Byford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.879097,
        LOCATION_LATITUDE_DEG: 52.0833323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000500',
        LOCATION_NAME: 'Bygrave',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1646141,
        LOCATION_LATITUDE_DEG: 52.0038934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000600',
        LOCATION_NAME: 'Byker',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5716769,
        LOCATION_LATITUDE_DEG: 54.9771946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000700',
        LOCATION_NAME: 'Bylaugh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.387602,
        LOCATION_LATITUDE_DEG: 52.7172865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000800',
        LOCATION_NAME: 'Bylchau',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5311021,
        LOCATION_LATITUDE_DEG: 53.1542424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY000900',
        LOCATION_NAME: 'Byley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4181033,
        LOCATION_LATITUDE_DEG: 53.2207334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001000',
        LOCATION_NAME: 'Bynea',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0770842,
        LOCATION_LATITUDE_DEG: 51.6836081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001100',
        LOCATION_NAME: 'Byram',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2611337,
        LOCATION_LATITUDE_DEG: 53.7231674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001300',
        LOCATION_NAME: 'Byrness Village',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3811024,
        LOCATION_LATITUDE_DEG: 55.3212419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001400',
        LOCATION_NAME: 'Bystock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3758413,
        LOCATION_LATITUDE_DEG: 50.6469032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001500',
        LOCATION_NAME: 'Bythorn',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4466122,
        LOCATION_LATITUDE_DEG: 52.3704289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001600',
        LOCATION_NAME: 'Byton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9230899,
        LOCATION_LATITUDE_DEG: 52.2699527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001700',
        LOCATION_NAME: 'Bywell',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9236941,
        LOCATION_LATITUDE_DEG: 54.948096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001800',
        LOCATION_NAME: 'Byworth',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5943495,
        LOCATION_LATITUDE_DEG: 50.9818028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000100',
        LOCATION_NAME: 'Cabin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9783568,
        LOCATION_LATITUDE_DEG: 52.4977746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000200',
        LOCATION_NAME: 'Cabourne',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2808342,
        LOCATION_LATITUDE_DEG: 53.5013401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000300',
        LOCATION_NAME: 'Cabra',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1102301,
        LOCATION_LATITUDE_DEG: 54.2069684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000400',
        LOCATION_NAME: 'Cabrach',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0131488,
        LOCATION_LATITUDE_DEG: 57.3279432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990763',
        LOCATION_NAME: 'Cabragh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000600',
        LOCATION_NAME: 'Cabus',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7780044,
        LOCATION_LATITUDE_DEG: 53.9234064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000800',
        LOCATION_NAME: 'Cadboll Wood',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.225311,
        LOCATION_LATITUDE_DEG: 57.7004005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000900',
        LOCATION_NAME: 'Cadbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5454997,
        LOCATION_LATITUDE_DEG: 50.8342238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001000',
        LOCATION_NAME: 'Cadbury Heath',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4797431,
        LOCATION_LATITUDE_DEG: 51.450589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001100',
        LOCATION_NAME: 'Cadder',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2122147,
        LOCATION_LATITUDE_DEG: 55.9213245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001200',
        LOCATION_NAME: 'Caddington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4547355,
        LOCATION_LATITUDE_DEG: 51.8661809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001300',
        LOCATION_NAME: 'Cade Street',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2853663,
        LOCATION_LATITUDE_DEG: 50.9657861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001400',
        LOCATION_NAME: 'Cadeby',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3717435,
        LOCATION_LATITUDE_DEG: 52.6173673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001500',
        LOCATION_NAME: 'Cadeby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2206473,
        LOCATION_LATITUDE_DEG: 53.4991523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001600',
        LOCATION_NAME: 'Cadeleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5405549,
        LOCATION_LATITUDE_DEG: 50.8613257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001700',
        LOCATION_NAME: 'Cadgwith',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1795825,
        LOCATION_LATITUDE_DEG: 49.986753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001800',
        LOCATION_NAME: 'Cadham',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1708487,
        LOCATION_LATITUDE_DEG: 56.2083349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA001900',
        LOCATION_NAME: 'Cadhay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2919373,
        LOCATION_LATITUDE_DEG: 50.7581145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002000',
        LOCATION_NAME: 'Cadishead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4346527,
        LOCATION_LATITUDE_DEG: 53.4273588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002100',
        LOCATION_NAME: 'Cadle',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9886443,
        LOCATION_LATITUDE_DEG: 51.6530053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002200',
        LOCATION_NAME: 'Cadleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9502047,
        LOCATION_LATITUDE_DEG: 50.3890836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002300',
        LOCATION_NAME: 'Cadleigh Park',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9439062,
        LOCATION_LATITUDE_DEG: 50.3843857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002400',
        LOCATION_NAME: 'Cadley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6979992,
        LOCATION_LATITUDE_DEG: 51.3945548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002500',
        LOCATION_NAME: 'Cadmore End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8620509,
        LOCATION_LATITUDE_DEG: 51.6256623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002600',
        LOCATION_NAME: 'Cadnam',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5774131,
        LOCATION_LATITUDE_DEG: 50.9197068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002700',
        LOCATION_NAME: 'Cadney',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4681383,
        LOCATION_LATITUDE_DEG: 53.5179396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002800',
        LOCATION_NAME: 'Cadole',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1889003,
        LOCATION_LATITUDE_DEG: 53.1551386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA002900',
        LOCATION_NAME: 'Cadoxton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7939538,
        LOCATION_LATITUDE_DEG: 51.6736065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003000',
        LOCATION_NAME: 'Cadoxton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'CF63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2320084,
        LOCATION_LATITUDE_DEG: 51.4162746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003100',
        LOCATION_NAME: 'Cadwell Park',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.05766,
        LOCATION_LATITUDE_DEG: 53.3100161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003200',
        LOCATION_NAME: 'Cadzow',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0416415,
        LOCATION_LATITUDE_DEG: 55.7601034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003300',
        LOCATION_NAME: 'Cae Capel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6020146,
        LOCATION_LATITUDE_DEG: 52.3866668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003400',
        LOCATION_NAME: 'Cae Clyd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9278483,
        LOCATION_LATITUDE_DEG: 52.9767324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003500',
        LOCATION_NAME: 'Caeathro',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2406748,
        LOCATION_LATITUDE_DEG: 53.1312501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003600',
        LOCATION_NAME: 'Caego',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0240451,
        LOCATION_LATITUDE_DEG: 53.0525248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003700',
        LOCATION_NAME: 'Caegoody Lane',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.928227,
        LOCATION_LATITUDE_DEG: 52.9172118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003800',
        LOCATION_NAME: 'Caehelig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5634369,
        LOCATION_LATITUDE_DEG: 51.5399906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA003900',
        LOCATION_NAME: 'Caehopkin',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7005056,
        LOCATION_LATITUDE_DEG: 51.7957108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004000',
        LOCATION_NAME: 'Caenby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4951489,
        LOCATION_LATITUDE_DEG: 53.3903308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004100',
        LOCATION_NAME: 'Caenby Cliff',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5349776,
        LOCATION_LATITUDE_DEG: 53.3937302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004200',
        LOCATION_NAME: 'Caenby Corner',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5453066,
        LOCATION_LATITUDE_DEG: 53.3925259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004350',
        LOCATION_NAME: 'Caerau',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6513312,
        LOCATION_LATITUDE_DEG: 51.6353464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004300',
        LOCATION_NAME: 'Caerau',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2465104,
        LOCATION_LATITUDE_DEG: 51.47088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004400',
        LOCATION_NAME: 'Caerbryn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.031806,
        LOCATION_LATITUDE_DEG: 51.8045167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004500',
        LOCATION_NAME: 'Caergeiliog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5323738,
        LOCATION_LATITUDE_DEG: 53.274962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004600',
        LOCATION_NAME: 'Caergwrle',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0324193,
        LOCATION_LATITUDE_DEG: 53.1088318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004700',
        LOCATION_NAME: 'Caerhays',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8565775,
        LOCATION_LATITUDE_DEG: 50.24418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004800',
        LOCATION_NAME: 'Caerhowel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1741359,
        LOCATION_LATITUDE_DEG: 52.5750822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA004900',
        LOCATION_NAME: 'Caerhun',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1358384,
        LOCATION_LATITUDE_DEG: 53.1986823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990355',
        LOCATION_NAME: 'Caerhun',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8459066,
        LOCATION_LATITUDE_DEG: 53.2541215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005000',
        LOCATION_NAME: 'Caerlan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7295307,
        LOCATION_LATITUDE_DEG: 51.7973197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005100',
        LOCATION_NAME: 'Caerlaverock',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5218103,
        LOCATION_LATITUDE_DEG: 54.976724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005200',
        LOCATION_NAME: 'Caerleon',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9578822,
        LOCATION_LATITUDE_DEG: 51.6147878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005300',
        LOCATION_NAME: 'Caernarfon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2696481,
        LOCATION_LATITUDE_DEG: 53.1445488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005400',
        LOCATION_NAME: 'Caerphilly',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2167526,
        LOCATION_LATITUDE_DEG: 51.5781904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005500',
        LOCATION_NAME: 'Caersws',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.427488,
        LOCATION_LATITUDE_DEG: 52.5160831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005600',
        LOCATION_NAME: 'Caerwedros',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3747606,
        LOCATION_LATITUDE_DEG: 52.1766564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005700',
        LOCATION_NAME: 'Caerwent',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7667554,
        LOCATION_LATITUDE_DEG: 51.6107871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005800',
        LOCATION_NAME: 'Caerwnon Park',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4053007,
        LOCATION_LATITUDE_DEG: 52.1640459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA005900',
        LOCATION_NAME: 'Caerwys',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3060638,
        LOCATION_LATITUDE_DEG: 53.2459478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007900',
        LOCATION_NAME: 'Caigenhouse',
        COUNTY_NAME: 'Isle of Jura',
        POSTCODE: 'PA60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9524611,
        LOCATION_LATITUDE_DEG: 55.8375309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008100',
        LOCATION_NAME: 'Cainscross',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2375964,
        LOCATION_LATITUDE_DEG: 51.742395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008200',
        LOCATION_NAME: 'Caio',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9328621,
        LOCATION_LATITUDE_DEG: 52.0406438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008300',
        LOCATION_NAME: 'Cairnbaan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4755276,
        LOCATION_LATITUDE_DEG: 56.060748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008400',
        LOCATION_NAME: 'Cairnbulg',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9382248,
        LOCATION_LATITUDE_DEG: 57.6764459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008500',
        LOCATION_NAME: 'Cairndow',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9349805,
        LOCATION_LATITUDE_DEG: 56.2554602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008600',
        LOCATION_NAME: 'Cairness',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9324974,
        LOCATION_LATITUDE_DEG: 57.6363682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008700',
        LOCATION_NAME: 'Cairneyhill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5318582,
        LOCATION_LATITUDE_DEG: 56.0600268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008800',
        LOCATION_NAME: 'Cairnie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8514779,
        LOCATION_LATITUDE_DEG: 57.4885644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008900',
        LOCATION_NAME: 'Cairnryan',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0259169,
        LOCATION_LATITUDE_DEG: 54.9740409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087700',
        LOCATION_NAME: 'Caister on Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009100',
        LOCATION_NAME: 'Caister-on-Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7269101,
        LOCATION_LATITUDE_DEG: 52.6486222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009200',
        LOCATION_NAME: 'Caistor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3164025,
        LOCATION_LATITUDE_DEG: 53.4976388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087300',
        LOCATION_NAME: 'Caistor St Edmund',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009300',
        LOCATION_NAME: 'Caistor St. Edmund',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2984197,
        LOCATION_LATITUDE_DEG: 52.5848113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009400',
        LOCATION_NAME: 'Caistron',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.010981,
        LOCATION_LATITUDE_DEG: 55.3069357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009500',
        LOCATION_NAME: 'Calbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3873636,
        LOCATION_LATITUDE_DEG: 58.069259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009600',
        LOCATION_NAME: 'Calbourne',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3982105,
        LOCATION_LATITUDE_DEG: 50.6787803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009700',
        LOCATION_NAME: 'Calceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0827675,
        LOCATION_LATITUDE_DEG: 53.2591102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009800',
        LOCATION_NAME: 'Calcethorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.139481,
        LOCATION_LATITUDE_DEG: 53.3796257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009900',
        LOCATION_NAME: 'Calcot',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2329502,
        LOCATION_LATITUDE_DEG: 51.6528867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010000',
        LOCATION_NAME: 'Calcot',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.869731,
        LOCATION_LATITUDE_DEG: 51.7897895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010100',
        LOCATION_NAME: 'Calcot',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0487154,
        LOCATION_LATITUDE_DEG: 51.4392491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010200',
        LOCATION_NAME: 'Calcott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.814432,
        LOCATION_LATITUDE_DEG: 52.718398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010400',
        LOCATION_NAME: 'Calcutt',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.839574,
        LOCATION_LATITUDE_DEG: 51.6374785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010300',
        LOCATION_NAME: 'Calcutt',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4667502,
        LOCATION_LATITUDE_DEG: 53.9985053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010500',
        LOCATION_NAME: 'Caldbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0507202,
        LOCATION_LATITUDE_DEG: 54.7484963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011000',
        LOCATION_NAME: 'Caldecote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4817978,
        LOCATION_LATITUDE_DEG: 52.5496586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010800',
        LOCATION_NAME: 'Caldecote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9955855,
        LOCATION_LATITUDE_DEG: 52.15352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010700',
        LOCATION_NAME: 'Caldecote',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3179035,
        LOCATION_LATITUDE_DEG: 52.4813376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010600',
        LOCATION_NAME: 'Caldecote',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1981404,
        LOCATION_LATITUDE_DEG: 52.0285928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA010900',
        LOCATION_NAME: 'Caldecote',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0283008,
        LOCATION_LATITUDE_DEG: 52.1916109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011200',
        LOCATION_NAME: 'Caldecott',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7198432,
        LOCATION_LATITUDE_DEG: 52.534349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011100',
        LOCATION_NAME: 'Caldecott',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5482364,
        LOCATION_LATITUDE_DEG: 52.3092271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011300',
        LOCATION_NAME: 'Caldecotte',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7092818,
        LOCATION_LATITUDE_DEG: 52.0087029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011400',
        LOCATION_NAME: 'Calder Grove',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5337663,
        LOCATION_LATITUDE_DEG: 53.6446686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011500',
        LOCATION_NAME: 'Calder Vale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7223436,
        LOCATION_LATITUDE_DEG: 53.9033039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011600',
        LOCATION_NAME: 'Calderbank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.963898,
        LOCATION_LATITUDE_DEG: 55.8434129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011700',
        LOCATION_NAME: 'Calderbridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4761817,
        LOCATION_LATITUDE_DEG: 54.4400443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011800',
        LOCATION_NAME: 'Calderbrook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0846903,
        LOCATION_LATITUDE_DEG: 53.660073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA011900',
        LOCATION_NAME: 'Caldercruix',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8798468,
        LOCATION_LATITUDE_DEG: 55.8895119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089800',
        LOCATION_NAME: 'Calderstones',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8976875,
        LOCATION_LATITUDE_DEG: 53.3853015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012000',
        LOCATION_NAME: 'Calderwood',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1604302,
        LOCATION_LATITUDE_DEG: 55.7713029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012100',
        LOCATION_NAME: 'Caldewgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9431641,
        LOCATION_LATITUDE_DEG: 54.8940047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012200',
        LOCATION_NAME: 'Caldey Island',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6873354,
        LOCATION_LATITUDE_DEG: 51.6370104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012300',
        LOCATION_NAME: 'Caldhame',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.86028,
        LOCATION_LATITUDE_DEG: 56.6212721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012400',
        LOCATION_NAME: 'Caldicot',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7479232,
        LOCATION_LATITUDE_DEG: 51.5906844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012600',
        LOCATION_NAME: 'Caldwell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.751707,
        LOCATION_LATITUDE_DEG: 54.5159562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012500',
        LOCATION_NAME: 'Caldwell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6220321,
        LOCATION_LATITUDE_DEG: 52.7522845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012700',
        LOCATION_NAME: 'Caldy',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1315661,
        LOCATION_LATITUDE_DEG: 52.4388721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA012900',
        LOCATION_NAME: 'Caledon',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8725962,
        LOCATION_LATITUDE_DEG: 54.3598932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013000',
        LOCATION_NAME: 'Calenick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0556042,
        LOCATION_LATITUDE_DEG: 50.2464814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013100',
        LOCATION_NAME: 'Calf Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0980413,
        LOCATION_LATITUDE_DEG: 52.6766773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013200',
        LOCATION_NAME: 'Calgary',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'PA75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2731269,
        LOCATION_LATITUDE_DEG: 56.5838042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013400',
        LOCATION_NAME: 'California',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7529693,
        LOCATION_LATITUDE_DEG: 55.9677231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990324',
        LOCATION_NAME: 'California',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0188802,
        LOCATION_LATITUDE_DEG: 51.5091719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013300',
        LOCATION_NAME: 'California',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7235492,
        LOCATION_LATITUDE_DEG: 52.6715322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013500',
        LOCATION_NAME: 'Calke',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4473528,
        LOCATION_LATITUDE_DEG: 52.7938824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013600',
        LOCATION_NAME: 'Calkill',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3715215,
        LOCATION_LATITUDE_DEG: 54.6346587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013800',
        LOCATION_NAME: 'Callaly',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9169947,
        LOCATION_LATITUDE_DEG: 55.3793409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014000',
        LOCATION_NAME: 'Callander',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2148679,
        LOCATION_LATITUDE_DEG: 56.2441495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014100',
        LOCATION_NAME: 'Callands',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6207925,
        LOCATION_LATITUDE_DEG: 53.4096626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014200',
        LOCATION_NAME: 'Callanish',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7354561,
        LOCATION_LATITUDE_DEG: 58.200071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014300',
        LOCATION_NAME: 'Callaughton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5640082,
        LOCATION_LATITUDE_DEG: 52.5733743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014400',
        LOCATION_NAME: 'Callendar Park',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7683105,
        LOCATION_LATITUDE_DEG: 55.993127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014500',
        LOCATION_NAME: 'Callerton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7233446,
        LOCATION_LATITUDE_DEG: 55.0125047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014600',
        LOCATION_NAME: 'Callestick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1247418,
        LOCATION_LATITUDE_DEG: 50.3104892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014700',
        LOCATION_NAME: 'Callington',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3117197,
        LOCATION_LATITUDE_DEG: 50.5010011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014800',
        LOCATION_NAME: 'Callow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7357497,
        LOCATION_LATITUDE_DEG: 52.0048262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015000',
        LOCATION_NAME: 'Callow End',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2414027,
        LOCATION_LATITUDE_DEG: 52.1429291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990322',
        LOCATION_NAME: 'Callow Hill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3782787,
        LOCATION_LATITUDE_DEG: 52.3611865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015100',
        LOCATION_NAME: 'Callow Hill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9728652,
        LOCATION_LATITUDE_DEG: 52.2798425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015200',
        LOCATION_NAME: 'Callow Marsh',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4995821,
        LOCATION_LATITUDE_DEG: 52.1192344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015300',
        LOCATION_NAME: 'Calmore',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5171752,
        LOCATION_LATITUDE_DEG: 50.9317044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015400',
        LOCATION_NAME: 'Calmsden',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9334767,
        LOCATION_LATITUDE_DEG: 51.7776945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015500',
        LOCATION_NAME: 'Calne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0013668,
        LOCATION_LATITUDE_DEG: 51.4347633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015600',
        LOCATION_NAME: 'Calow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3834637,
        LOCATION_LATITUDE_DEG: 53.2337258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015700',
        LOCATION_NAME: 'Calrossie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9985682,
        LOCATION_LATITUDE_DEG: 57.7835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015800',
        LOCATION_NAME: 'Calshot',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3194599,
        LOCATION_LATITUDE_DEG: 50.8091889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA015900',
        LOCATION_NAME: 'Calstock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2041083,
        LOCATION_LATITUDE_DEG: 50.4967925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016000',
        LOCATION_NAME: 'Calstone',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.963381,
        LOCATION_LATITUDE_DEG: 51.4204593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091000',
        LOCATION_NAME: 'Calthorpe',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9166812,
        LOCATION_LATITUDE_DEG: 52.4640364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016100',
        LOCATION_NAME: 'Calthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2373423,
        LOCATION_LATITUDE_DEG: 52.839252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090900',
        LOCATION_NAME: 'Calthorpe Fields',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9174541,
        LOCATION_LATITUDE_DEG: 52.4679301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016200',
        LOCATION_NAME: 'Calthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8245689,
        LOCATION_LATITUDE_DEG: 54.7531928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016300',
        LOCATION_NAME: 'Calton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1369807,
        LOCATION_LATITUDE_DEG: 54.0286165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016400',
        LOCATION_NAME: 'Calton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8467659,
        LOCATION_LATITUDE_DEG: 53.0488138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016500',
        LOCATION_NAME: 'Calton Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8277523,
        LOCATION_LATITUDE_DEG: 53.0355093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017000',
        LOCATION_NAME: 'Calveley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6113114,
        LOCATION_LATITUDE_DEG: 53.1256289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017100',
        LOCATION_NAME: 'Calver',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6414485,
        LOCATION_LATITUDE_DEG: 53.2696347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017200',
        LOCATION_NAME: 'Calverhall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5922236,
        LOCATION_LATITUDE_DEG: 52.9317145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017300',
        LOCATION_NAME: 'Calverleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5332263,
        LOCATION_LATITUDE_DEG: 50.9186247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017400',
        LOCATION_NAME: 'Calverley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6844035,
        LOCATION_LATITUDE_DEG: 53.8266872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017600',
        LOCATION_NAME: 'Calvert',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9999451,
        LOCATION_LATITUDE_DEG: 51.9161947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017800',
        LOCATION_NAME: 'Calverton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0812348,
        LOCATION_LATITUDE_DEG: 53.0365003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017700',
        LOCATION_NAME: 'Calverton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8484875,
        LOCATION_LATITUDE_DEG: 52.0409081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017900',
        LOCATION_NAME: 'Calvine',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9554445,
        LOCATION_LATITUDE_DEG: 56.7694024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018000',
        LOCATION_NAME: 'Calvington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4368961,
        LOCATION_LATITUDE_DEG: 52.7994987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018100',
        LOCATION_NAME: 'Calvo',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3338502,
        LOCATION_LATITUDE_DEG: 54.8715132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018200',
        LOCATION_NAME: 'Calwich',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8056975,
        LOCATION_LATITUDE_DEG: 52.9882048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018350',
        LOCATION_NAME: 'Cam',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6042654,
        LOCATION_LATITUDE_DEG: 54.234858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018300',
        LOCATION_NAME: 'Cam',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3564358,
        LOCATION_LATITUDE_DEG: 51.6987882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018500',
        LOCATION_NAME: 'Camault Muir',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4927778,
        LOCATION_LATITUDE_DEG: 57.4284701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018600',
        LOCATION_NAME: 'Camb',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0746456,
        LOCATION_LATITUDE_DEG: 60.6118515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018700',
        LOCATION_NAME: 'Camber',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7986413,
        LOCATION_LATITUDE_DEG: 50.9349801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018800',
        LOCATION_NAME: 'Camberley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7428786,
        LOCATION_LATITUDE_DEG: 51.3397368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089600',
        LOCATION_NAME: 'Camberwell',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0904722,
        LOCATION_LATITUDE_DEG: 51.4752934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018900',
        LOCATION_NAME: 'Camblesforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0171335,
        LOCATION_LATITUDE_DEG: 53.7276711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019000',
        LOCATION_NAME: 'Cambo',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9590878,
        LOCATION_LATITUDE_DEG: 55.1663207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019100',
        LOCATION_NAME: 'Cambois',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5300994,
        LOCATION_LATITUDE_DEG: 55.1441138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019200',
        LOCATION_NAME: 'Camborne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2943639,
        LOCATION_LATITUDE_DEG: 50.2141842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019300',
        LOCATION_NAME: 'Cambourne',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0773616,
        LOCATION_LATITUDE_DEG: 52.2269167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019500',
        LOCATION_NAME: 'Cambridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3625676,
        LOCATION_LATITUDE_DEG: 51.7326971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019400',
        LOCATION_NAME: 'Cambridge',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1223004,
        LOCATION_LATITUDE_DEG: 52.2039076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019600',
        LOCATION_NAME: 'Cambrose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2516296,
        LOCATION_LATITUDE_DEG: 50.2609864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019700',
        LOCATION_NAME: 'Cambus',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8425865,
        LOCATION_LATITUDE_DEG: 56.1244417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019800',
        LOCATION_NAME: "Cambus O'May",
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9677934,
        LOCATION_LATITUDE_DEG: 57.0726183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA019900',
        LOCATION_NAME: 'Cambusbarron',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9662398,
        LOCATION_LATITUDE_DEG: 56.1089368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020000',
        LOCATION_NAME: 'Cambuskenneth',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9174636,
        LOCATION_LATITUDE_DEG: 56.1236344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020100',
        LOCATION_NAME: 'Cambuslang',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1651453,
        LOCATION_LATITUDE_DEG: 55.8149126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020200',
        LOCATION_NAME: 'Cambusmore',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1691483,
        LOCATION_LATITUDE_DEG: 56.2243504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020300',
        LOCATION_NAME: 'Cambusnethan',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9010445,
        LOCATION_LATITUDE_DEG: 55.781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090200',
        LOCATION_NAME: 'Camden Town',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0909853,
        LOCATION_LATITUDE_DEG: 51.4750769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020400',
        LOCATION_NAME: 'Came',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.414356,
        LOCATION_LATITUDE_DEG: 50.6765934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020500',
        LOCATION_NAME: 'Cameley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5602514,
        LOCATION_LATITUDE_DEG: 51.3137575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020600',
        LOCATION_NAME: 'Camelford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6781117,
        LOCATION_LATITUDE_DEG: 50.6223155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020700',
        LOCATION_NAME: 'Camelon',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8146969,
        LOCATION_LATITUDE_DEG: 56.0043253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020800',
        LOCATION_NAME: 'Camels Head',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1756292,
        LOCATION_LATITUDE_DEG: 50.3940888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA020900',
        LOCATION_NAME: 'Camelsdale',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7359071,
        LOCATION_LATITUDE_DEG: 51.0817125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021000',
        LOCATION_NAME: 'Cameron',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8318125,
        LOCATION_LATITUDE_DEG: 56.3000473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021100',
        LOCATION_NAME: 'Cameron Bridge',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0485312,
        LOCATION_LATITUDE_DEG: 56.1833369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021200',
        LOCATION_NAME: 'Camers Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3272349,
        LOCATION_LATITUDE_DEG: 52.0133232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021300',
        LOCATION_NAME: 'Camerton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4936087,
        LOCATION_LATITUDE_DEG: 54.6634914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021500',
        LOCATION_NAME: 'Camerton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4577113,
        LOCATION_LATITUDE_DEG: 51.3183578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021400',
        LOCATION_NAME: 'Camerton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1483625,
        LOCATION_LATITUDE_DEG: 53.7199564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021600',
        LOCATION_NAME: 'Camlough',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4156567,
        LOCATION_LATITUDE_DEG: 54.1665607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021700',
        LOCATION_NAME: 'Cammachmore',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1538954,
        LOCATION_LATITUDE_DEG: 57.043504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021800',
        LOCATION_NAME: 'Cammeringham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5761942,
        LOCATION_LATITUDE_DEG: 53.3273218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022000',
        LOCATION_NAME: 'Camowen',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2430374,
        LOCATION_LATITUDE_DEG: 54.5630824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022200',
        LOCATION_NAME: 'Camp Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8745488,
        LOCATION_LATITUDE_DEG: 52.4595577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022300',
        LOCATION_NAME: 'Camp Hill',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.309843,
        LOCATION_LATITUDE_DEG: 50.7103807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022400',
        LOCATION_NAME: 'Campbell Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7419462,
        LOCATION_LATITUDE_DEG: 52.0442069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022500',
        LOCATION_NAME: 'Campbellton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0831017,
        LOCATION_LATITUDE_DEG: 57.8628257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022600',
        LOCATION_NAME: 'Campbeltown',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6050045,
        LOCATION_LATITUDE_DEG: 55.4234884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022700',
        LOCATION_NAME: 'Camperdown',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5710707,
        LOCATION_LATITUDE_DEG: 55.0399058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022900',
        LOCATION_NAME: 'Cample',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7315747,
        LOCATION_LATITUDE_DEG: 55.2286517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023000',
        LOCATION_NAME: 'Campmuir',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2715996,
        LOCATION_LATITUDE_DEG: 56.5251683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023200',
        LOCATION_NAME: 'Camps Heath',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6991836,
        LOCATION_LATITUDE_DEG: 52.4866147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023300',
        LOCATION_NAME: 'Campsall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1773398,
        LOCATION_LATITUDE_DEG: 53.6208605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023400',
        LOCATION_NAME: 'Campsea Ashe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4028945,
        LOCATION_LATITUDE_DEG: 52.1518809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023425',
        LOCATION_NAME: 'Campsie',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2166621,
        LOCATION_LATITUDE_DEG: 55.0083076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023450',
        LOCATION_NAME: 'Campsie Glen',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2644215,
        LOCATION_LATITUDE_DEG: 55.9842563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023500',
        LOCATION_NAME: 'Campton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3525373,
        LOCATION_LATITUDE_DEG: 52.028794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023600',
        LOCATION_NAME: 'Camptown',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5043168,
        LOCATION_LATITUDE_DEG: 55.4191559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023700',
        LOCATION_NAME: 'Camrose',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0088785,
        LOCATION_LATITUDE_DEG: 51.8407325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023900',
        LOCATION_NAME: 'Camserney',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9288603,
        LOCATION_LATITUDE_DEG: 56.6220922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024000',
        LOCATION_NAME: 'Camusbane',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5970712,
        LOCATION_LATITUDE_DEG: 57.1451597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024100',
        LOCATION_NAME: 'Camuscross',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8036169,
        LOCATION_LATITUDE_DEG: 57.1384571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024200',
        LOCATION_NAME: 'Camusluinie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4098687,
        LOCATION_LATITUDE_DEG: 57.3005715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024300',
        LOCATION_NAME: 'Camusnagaul',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2613389,
        LOCATION_LATITUDE_DEG: 57.8510231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024400',
        LOCATION_NAME: 'Camusterrach',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8122902,
        LOCATION_LATITUDE_DEG: 57.4084895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024500',
        LOCATION_NAME: 'Camusvrachan',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2491295,
        LOCATION_LATITUDE_DEG: 56.6021902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024600',
        LOCATION_NAME: 'Canada',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5876958,
        LOCATION_LATITUDE_DEG: 50.9604118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024700',
        LOCATION_NAME: 'Canal Foot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0529277,
        LOCATION_LATITUDE_DEG: 54.1890419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990108',
        LOCATION_NAME: 'Canary Wharf',
        COUNTY_NAME: 'London',
        POSTCODE: 'E 98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089900',
        LOCATION_NAME: 'Canary Wharf',
        COUNTY_NAME: 'London',
        POSTCODE: 'E14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0210254,
        LOCATION_LATITUDE_DEG: 51.5062312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024800',
        LOCATION_NAME: 'Canaston Bridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.805268,
        LOCATION_LATITUDE_DEG: 51.8015242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA024900',
        LOCATION_NAME: 'Cancourt',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8471766,
        LOCATION_LATITUDE_DEG: 51.529571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025000',
        LOCATION_NAME: 'Candlesby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1785782,
        LOCATION_LATITUDE_DEG: 53.1837012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025100',
        LOCATION_NAME: 'Candy',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1094498,
        LOCATION_LATITUDE_DEG: 52.8482083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025200',
        LOCATION_NAME: 'Cane End',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0221775,
        LOCATION_LATITUDE_DEG: 51.5101551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025300',
        LOCATION_NAME: 'Caneheath',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2105925,
        LOCATION_LATITUDE_DEG: 50.8440782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025400',
        LOCATION_NAME: 'Canewdon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7463051,
        LOCATION_LATITUDE_DEG: 51.6170441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025500',
        LOCATION_NAME: 'Canford Cliffs',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9236986,
        LOCATION_LATITUDE_DEG: 50.7084952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025600',
        LOCATION_NAME: 'Canford Magna',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9486066,
        LOCATION_LATITUDE_DEG: 50.7661943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025800',
        LOCATION_NAME: 'Canisbay',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1220484,
        LOCATION_LATITUDE_DEG: 58.6322809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025900',
        LOCATION_NAME: 'Canklow',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.358725,
        LOCATION_LATITUDE_DEG: 53.4150471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026000',
        LOCATION_NAME: 'Canley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5666502,
        LOCATION_LATITUDE_DEG: 52.3938514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026100',
        LOCATION_NAME: 'Cann',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1815546,
        LOCATION_LATITUDE_DEG: 50.9868182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026200',
        LOCATION_NAME: 'Cann Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1651407,
        LOCATION_LATITUDE_DEG: 50.9869235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026300',
        LOCATION_NAME: 'Cannards Grave',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.533865,
        LOCATION_LATITUDE_DEG: 51.1741388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026400',
        LOCATION_NAME: 'Cannich',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7564535,
        LOCATION_LATITUDE_DEG: 57.3450667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090000',
        LOCATION_NAME: 'Canning Town',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0355372,
        LOCATION_LATITUDE_DEG: 51.5100207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026600',
        LOCATION_NAME: 'Cannington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0582741,
        LOCATION_LATITUDE_DEG: 51.1512436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026700',
        LOCATION_NAME: 'Cannock',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0276088,
        LOCATION_LATITUDE_DEG: 52.6877822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026800',
        LOCATION_NAME: 'Cannock Wood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9294665,
        LOCATION_LATITUDE_DEG: 52.707481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026900',
        LOCATION_NAME: 'Cannop',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5739231,
        LOCATION_LATITUDE_DEG: 51.8006004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027000',
        LOCATION_NAME: 'Canon Bridge',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8290952,
        LOCATION_LATITUDE_DEG: 52.0653332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027100',
        LOCATION_NAME: 'Canon Frome',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5088854,
        LOCATION_LATITUDE_DEG: 52.0883262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027200',
        LOCATION_NAME: 'Canon Pyon',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7850269,
        LOCATION_LATITUDE_DEG: 52.1347369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027300',
        LOCATION_NAME: 'Canonbie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9512759,
        LOCATION_LATITUDE_DEG: 55.078521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090100',
        LOCATION_NAME: 'Canonbury',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0973338,
        LOCATION_LATITUDE_DEG: 51.547084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091400',
        LOCATION_NAME: 'Canongate',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.181144,
        LOCATION_LATITUDE_DEG: 55.9517666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089000',
        LOCATION_NAME: 'Canonmills',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1981832,
        LOCATION_LATITUDE_DEG: 55.9630869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027400',
        LOCATION_NAME: 'Canons Ashby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1557837,
        LOCATION_LATITUDE_DEG: 52.1507201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090600',
        LOCATION_NAME: 'Canons Park',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2931065,
        LOCATION_LATITUDE_DEG: 51.6147666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027500',
        LOCATION_NAME: 'Canonstown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4546061,
        LOCATION_LATITUDE_DEG: 50.1645737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027600',
        LOCATION_NAME: 'Canterbury',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0822252,
        LOCATION_LATITUDE_DEG: 51.2768011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027700',
        LOCATION_NAME: 'Cantern Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4293007,
        LOCATION_LATITUDE_DEG: 52.5504728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027900',
        LOCATION_NAME: 'Cantley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0529614,
        LOCATION_LATITUDE_DEG: 53.5125498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA027800',
        LOCATION_NAME: 'Cantley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5153626,
        LOCATION_LATITUDE_DEG: 52.5780234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028000',
        LOCATION_NAME: 'Cantlop',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7118543,
        LOCATION_LATITUDE_DEG: 52.6447844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028100',
        LOCATION_NAME: 'Canton',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2036305,
        LOCATION_LATITUDE_DEG: 51.4851772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028200',
        LOCATION_NAME: 'Cantsdam',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3725068,
        LOCATION_LATITUDE_DEG: 56.1238284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028300',
        LOCATION_NAME: 'Cantsfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5818647,
        LOCATION_LATITUDE_DEG: 54.1509266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028400',
        LOCATION_NAME: 'Canty Bay',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6694012,
        LOCATION_LATITUDE_DEG: 56.057213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028500',
        LOCATION_NAME: 'Canvey Island',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5940326,
        LOCATION_LATITUDE_DEG: 51.5225325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028600',
        LOCATION_NAME: 'Canwell',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7848468,
        LOCATION_LATITUDE_DEG: 52.6020699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028700',
        LOCATION_NAME: 'Canwick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5203153,
        LOCATION_LATITUDE_DEG: 53.2135123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028800',
        LOCATION_NAME: 'Canworthy Water',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5164245,
        LOCATION_LATITUDE_DEG: 50.6964197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA028900',
        LOCATION_NAME: 'Caol',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1037492,
        LOCATION_LATITUDE_DEG: 56.8382243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029000',
        LOCATION_NAME: 'Caolis',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5457122,
        LOCATION_LATITUDE_DEG: 56.9449565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029100',
        LOCATION_NAME: 'Cape Castle',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2989156,
        LOCATION_LATITUDE_DEG: 55.1499657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029200',
        LOCATION_NAME: 'Cape Cornwall',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7077799,
        LOCATION_LATITUDE_DEG: 50.1260748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990789',
        LOCATION_NAME: 'Capel',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029300',
        LOCATION_NAME: 'Capel',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3184399,
        LOCATION_LATITUDE_DEG: 51.1530173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA088900',
        LOCATION_NAME: 'Capel',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0491948,
        LOCATION_LATITUDE_DEG: 52.0237649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029400',
        LOCATION_NAME: 'Capel Bangor',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9808671,
        LOCATION_LATITUDE_DEG: 52.4040792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029500',
        LOCATION_NAME: 'Capel Betws Lleucu',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0394083,
        LOCATION_LATITUDE_DEG: 52.2041557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029600',
        LOCATION_NAME: 'Capel Celyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7247167,
        LOCATION_LATITUDE_DEG: 52.9676254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029700',
        LOCATION_NAME: 'Capel Coch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3138025,
        LOCATION_LATITUDE_DEG: 53.3135655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029800',
        LOCATION_NAME: 'Capel Curig',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9109489,
        LOCATION_LATITUDE_DEG: 53.1047391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029900',
        LOCATION_NAME: 'Capel Cynon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3638586,
        LOCATION_LATITUDE_DEG: 52.1197494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030050',
        LOCATION_NAME: 'Capel Dewi',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2581562,
        LOCATION_LATITUDE_DEG: 52.0587519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030000',
        LOCATION_NAME: 'Capel Dewi',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2115358,
        LOCATION_LATITUDE_DEG: 51.8593261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030100',
        LOCATION_NAME: 'Capel Garmon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7712372,
        LOCATION_LATITUDE_DEG: 53.0861396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030200',
        LOCATION_NAME: 'Capel Gwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4836499,
        LOCATION_LATITUDE_DEG: 53.2501616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030300',
        LOCATION_NAME: 'Capel Gwynfe',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8568334,
        LOCATION_LATITUDE_DEG: 51.8809202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030400',
        LOCATION_NAME: 'Capel Hendre',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0389916,
        LOCATION_LATITUDE_DEG: 51.7821156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030500',
        LOCATION_NAME: 'Capel Isaac',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0495462,
        LOCATION_LATITUDE_DEG: 51.9217333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030600',
        LOCATION_NAME: 'Capel Iwan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4910523,
        LOCATION_LATITUDE_DEG: 51.9983405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087800',
        LOCATION_NAME: 'Capel le Ferne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030700',
        LOCATION_NAME: 'Capel Llanilltern',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3009586,
        LOCATION_LATITUDE_DEG: 51.5114856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030800',
        LOCATION_NAME: 'Capel Madog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9835576,
        LOCATION_LATITUDE_DEG: 52.4230801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA030900',
        LOCATION_NAME: 'Capel Mawr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3732245,
        LOCATION_LATITUDE_DEG: 53.2189617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031000',
        LOCATION_NAME: 'Capel Seion',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0178039,
        LOCATION_LATITUDE_DEG: 52.3944797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087400',
        LOCATION_NAME: 'Capel St Andrew',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087500',
        LOCATION_NAME: 'Capel St Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031100',
        LOCATION_NAME: 'Capel St. Andrew',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4659011,
        LOCATION_LATITUDE_DEG: 52.0785741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031200',
        LOCATION_NAME: 'Capel St. Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0391468,
        LOCATION_LATITUDE_DEG: 52.0026711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031300',
        LOCATION_NAME: 'Capel Uchaf',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3388411,
        LOCATION_LATITUDE_DEG: 53.0224354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031400',
        LOCATION_NAME: 'Capel y Ffin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0858674,
        LOCATION_LATITUDE_DEG: 51.9772108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031500',
        LOCATION_NAME: 'Capel y Graig',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1755358,
        LOCATION_LATITUDE_DEG: 53.2019561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031600',
        LOCATION_NAME: 'Capel-le-Ferne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2105474,
        LOCATION_LATITUDE_DEG: 51.10059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031700',
        LOCATION_NAME: 'Capeltor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2358303,
        LOCATION_LATITUDE_DEG: 50.5377997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031800',
        LOCATION_NAME: 'Capelulo',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8950247,
        LOCATION_LATITUDE_DEG: 53.277564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA031900',
        LOCATION_NAME: 'Capenhurst',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9467484,
        LOCATION_LATITUDE_DEG: 53.2609493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032000',
        LOCATION_NAME: 'Capernwray',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7194776,
        LOCATION_LATITUDE_DEG: 54.1392257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032100',
        LOCATION_NAME: 'Capesthorne',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.235782,
        LOCATION_LATITUDE_DEG: 53.2509361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032200',
        LOCATION_NAME: 'Capheaton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.945057,
        LOCATION_LATITUDE_DEG: 55.1175158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032400',
        LOCATION_NAME: 'Cappagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9522999,
        LOCATION_LATITUDE_DEG: 54.5392036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033700',
        LOCATION_NAME: 'Caprington',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.510386,
        LOCATION_LATITUDE_DEG: 55.5892954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033800',
        LOCATION_NAME: 'Capton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6270857,
        LOCATION_LATITUDE_DEG: 50.3634796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033900',
        LOCATION_NAME: 'Caputh',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4823013,
        LOCATION_LATITUDE_DEG: 56.5428725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034000',
        LOCATION_NAME: 'Car Colston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9315023,
        LOCATION_LATITUDE_DEG: 52.9765946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034100',
        LOCATION_NAME: 'Caradon Town',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4068489,
        LOCATION_LATITUDE_DEG: 50.513699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034300',
        LOCATION_NAME: 'Carbean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8040824,
        LOCATION_LATITUDE_DEG: 50.3711921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034400',
        LOCATION_NAME: 'Carberry Tower',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0185598,
        LOCATION_LATITUDE_DEG: 55.9170115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034500',
        LOCATION_NAME: 'Carbis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8155891,
        LOCATION_LATITUDE_DEG: 50.399693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034600',
        LOCATION_NAME: 'Carbis Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4652574,
        LOCATION_LATITUDE_DEG: 50.1934799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034700',
        LOCATION_NAME: 'Carbis Moor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7721842,
        LOCATION_LATITUDE_DEG: 50.3678911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034800',
        LOCATION_NAME: 'Carbost',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3524293,
        LOCATION_LATITUDE_DEG: 57.3019823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034900',
        LOCATION_NAME: 'Carbostbeg',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3696602,
        LOCATION_LATITUDE_DEG: 57.3121775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035000',
        LOCATION_NAME: 'Carbostmore',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3208521,
        LOCATION_LATITUDE_DEG: 57.293179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035100',
        LOCATION_NAME: 'Carbrook',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4143608,
        LOCATION_LATITUDE_DEG: 53.4025405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035200',
        LOCATION_NAME: 'Carbrooke',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8772149,
        LOCATION_LATITUDE_DEG: 52.5832296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035300',
        LOCATION_NAME: 'Carburton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0822341,
        LOCATION_LATITUDE_DEG: 53.2518262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035500',
        LOCATION_NAME: 'Carcary',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5774822,
        LOCATION_LATITUDE_DEG: 56.6892776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035600',
        LOCATION_NAME: 'Carclaze',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7796788,
        LOCATION_LATITUDE_DEG: 50.3514918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035700',
        LOCATION_NAME: 'Carclew',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0982017,
        LOCATION_LATITUDE_DEG: 50.2008721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035800',
        LOCATION_NAME: 'Carcroft',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1829617,
        LOCATION_LATITUDE_DEG: 53.5818573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035900',
        LOCATION_NAME: 'Cardenden',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2503099,
        LOCATION_LATITUDE_DEG: 56.1425322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036000',
        LOCATION_NAME: 'Cardeston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8955107,
        LOCATION_LATITUDE_DEG: 52.705289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036100',
        LOCATION_NAME: 'Cardew',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0248908,
        LOCATION_LATITUDE_DEG: 54.8356045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036200',
        LOCATION_NAME: 'Cardewlees',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0147378,
        LOCATION_LATITUDE_DEG: 54.851104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036300',
        LOCATION_NAME: 'Cardiff',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1741081,
        LOCATION_LATITUDE_DEG: 51.4814746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036400',
        LOCATION_NAME: 'Cardiff Wales Airport',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3542166,
        LOCATION_LATITUDE_DEG: 51.3914719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036500',
        LOCATION_NAME: 'Cardigan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6574564,
        LOCATION_LATITUDE_DEG: 52.0829509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036600',
        LOCATION_NAME: 'Cardington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.728165,
        LOCATION_LATITUDE_DEG: 52.5525724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036700',
        LOCATION_NAME: 'Cardington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.411138,
        LOCATION_LATITUDE_DEG: 52.1169069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA036800',
        LOCATION_NAME: 'Cardington Moor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7387766,
        LOCATION_LATITUDE_DEG: 52.5467793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037000',
        LOCATION_NAME: 'Cardinham',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6467379,
        LOCATION_LATITUDE_DEG: 50.4880957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091900',
        LOCATION_NAME: 'Cardonald',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.358141,
        LOCATION_LATITUDE_DEG: 55.8453939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037100',
        LOCATION_NAME: 'Cardrona',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1108525,
        LOCATION_LATITUDE_DEG: 55.6392799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037200',
        LOCATION_NAME: 'Cardross',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6515204,
        LOCATION_LATITUDE_DEG: 55.962628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037300',
        LOCATION_NAME: 'Cardurnock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2912688,
        LOCATION_LATITUDE_DEG: 54.9168153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037400',
        LOCATION_NAME: 'Careby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4869946,
        LOCATION_LATITUDE_DEG: 52.7362681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037500',
        LOCATION_NAME: 'Careston',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7617958,
        LOCATION_LATITUDE_DEG: 56.7356829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037600',
        LOCATION_NAME: 'Carew',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8266287,
        LOCATION_LATITUDE_DEG: 51.6972137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037700',
        LOCATION_NAME: 'Carew Cheriton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8284379,
        LOCATION_LATITUDE_DEG: 51.6900193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037800',
        LOCATION_NAME: 'Carew Newton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8289375,
        LOCATION_LATITUDE_DEG: 51.7052174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA037900',
        LOCATION_NAME: 'Carey',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6331779,
        LOCATION_LATITUDE_DEG: 51.9748228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038000',
        LOCATION_NAME: 'Carfin',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.958476,
        LOCATION_LATITUDE_DEG: 55.8061095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038200',
        LOCATION_NAME: 'Cargan',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1656094,
        LOCATION_LATITUDE_DEG: 54.983241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038300',
        LOCATION_NAME: 'Cargate Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5341728,
        LOCATION_LATITUDE_DEG: 52.6599317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038400',
        LOCATION_NAME: 'Cargenbridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6394385,
        LOCATION_LATITUDE_DEG: 55.0561271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038500',
        LOCATION_NAME: 'Cargenwyn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2846312,
        LOCATION_LATITUDE_DEG: 50.1700769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038600',
        LOCATION_NAME: 'Cargill',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3803383,
        LOCATION_LATITUDE_DEG: 56.5158666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038700',
        LOCATION_NAME: 'Cargo',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.986067,
        LOCATION_LATITUDE_DEG: 54.9248068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038800',
        LOCATION_NAME: 'Cargo Fleet',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1936258,
        LOCATION_LATITUDE_DEG: 54.5826509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038900',
        LOCATION_NAME: 'Cargreen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2050733,
        LOCATION_LATITUDE_DEG: 50.4417946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039100',
        LOCATION_NAME: 'Carham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3209719,
        LOCATION_LATITUDE_DEG: 55.6380741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039200',
        LOCATION_NAME: 'Carhampton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4167885,
        LOCATION_LATITUDE_DEG: 51.172848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039300',
        LOCATION_NAME: 'Carharrack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1805995,
        LOCATION_LATITUDE_DEG: 50.2289813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039500',
        LOCATION_NAME: 'Carinish',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3147347,
        LOCATION_LATITUDE_DEG: 57.5201089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039600',
        LOCATION_NAME: 'Carisbrooke',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3314071,
        LOCATION_LATITUDE_DEG: 50.692078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039700',
        LOCATION_NAME: 'Carishader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9355914,
        LOCATION_LATITUDE_DEG: 58.1908722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039800',
        LOCATION_NAME: 'Cark in Cartmel',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.973795,
        LOCATION_LATITUDE_DEG: 54.1839368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039900',
        LOCATION_NAME: 'Carkeel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.234355,
        LOCATION_LATITUDE_DEG: 50.4201865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040000',
        LOCATION_NAME: 'Carland Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0254719,
        LOCATION_LATITUDE_DEG: 50.3458919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040200',
        LOCATION_NAME: 'Carlby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4463968,
        LOCATION_LATITUDE_DEG: 52.7127608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040300',
        LOCATION_NAME: 'Carlecotes',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7304889,
        LOCATION_LATITUDE_DEG: 53.5299575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040400',
        LOCATION_NAME: 'Carleen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3322351,
        LOCATION_LATITUDE_DEG: 50.1161752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990841',
        LOCATION_NAME: 'Carleton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040800',
        LOCATION_NAME: 'Carleton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5134151,
        LOCATION_LATITUDE_DEG: 54.4698676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040900',
        LOCATION_NAME: 'Carleton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8886757,
        LOCATION_LATITUDE_DEG: 54.8655018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040700',
        LOCATION_NAME: 'Carleton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7300316,
        LOCATION_LATITUDE_DEG: 54.6635782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040600',
        LOCATION_NAME: 'Carleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0412752,
        LOCATION_LATITUDE_DEG: 53.9431058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040500',
        LOCATION_NAME: 'Carleton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3067313,
        LOCATION_LATITUDE_DEG: 53.6767671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041000',
        LOCATION_NAME: 'Carleton Forehoe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0888603,
        LOCATION_LATITUDE_DEG: 52.6066305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041100',
        LOCATION_NAME: 'Carleton Rode',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1146656,
        LOCATION_LATITUDE_DEG: 52.4889195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087600',
        LOCATION_NAME: 'Carleton St Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041200',
        LOCATION_NAME: 'Carleton St. Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4537244,
        LOCATION_LATITUDE_DEG: 52.5663196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041300',
        LOCATION_NAME: 'Carlin How',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9050449,
        LOCATION_LATITUDE_DEG: 54.5633511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041400',
        LOCATION_NAME: 'Carlingcott',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.433891,
        LOCATION_LATITUDE_DEG: 51.3216589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041600',
        LOCATION_NAME: 'Carlisle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9321624,
        LOCATION_LATITUDE_DEG: 54.8950063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041700',
        LOCATION_NAME: 'Carlisle Airport',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8103622,
        LOCATION_LATITUDE_DEG: 54.9372049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041800',
        LOCATION_NAME: 'Carloggas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9956774,
        LOCATION_LATITUDE_DEG: 50.4475958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041900',
        LOCATION_NAME: 'Carlops',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.337886,
        LOCATION_LATITUDE_DEG: 55.788599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042100',
        LOCATION_NAME: 'Carloway',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7644793,
        LOCATION_LATITUDE_DEG: 58.2817201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990840',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043075',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9039599,
        LOCATION_LATITUDE_DEG: 54.2565686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042400',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4887662,
        LOCATION_LATITUDE_DEG: 53.7402746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042900',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4473991,
        LOCATION_LATITUDE_DEG: 53.5865621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042600',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.407442,
        LOCATION_LATITUDE_DEG: 52.6429686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043000',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3878221,
        LOCATION_LATITUDE_DEG: 54.5903591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042700',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0863066,
        LOCATION_LATITUDE_DEG: 52.966593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042800',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0631467,
        LOCATION_LATITUDE_DEG: 54.270324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042200',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0183299,
        LOCATION_LATITUDE_DEG: 53.7101513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042500',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.603055,
        LOCATION_LATITUDE_DEG: 52.1881182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043050',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4027729,
        LOCATION_LATITUDE_DEG: 52.1541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042300',
        LOCATION_NAME: 'Carlton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4954282,
        LOCATION_LATITUDE_DEG: 52.2244921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043100',
        LOCATION_NAME: 'Carlton Colville',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6959832,
        LOCATION_LATITUDE_DEG: 52.4511092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043200',
        LOCATION_NAME: 'Carlton Curlieu',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9753914,
        LOCATION_LATITUDE_DEG: 52.5683604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043300',
        LOCATION_NAME: 'Carlton Forest',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0916332,
        LOCATION_LATITUDE_DEG: 53.331029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043400',
        LOCATION_NAME: 'Carlton Husthwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2377441,
        LOCATION_LATITUDE_DEG: 54.1837173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087900',
        LOCATION_NAME: 'Carlton in Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA088000',
        LOCATION_NAME: 'Carlton in Lindrick',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA088100',
        LOCATION_NAME: 'Carlton le Moorland',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043500',
        LOCATION_NAME: 'Carlton Miniott',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3940207,
        LOCATION_LATITUDE_DEG: 54.223022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA088200',
        LOCATION_NAME: 'Carlton on Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043600',
        LOCATION_NAME: 'Carlton Scroop',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5872715,
        LOCATION_LATITUDE_DEG: 52.9935913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043700',
        LOCATION_NAME: 'Carlton-in-Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2151128,
        LOCATION_LATITUDE_DEG: 54.4331382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043800',
        LOCATION_NAME: 'Carlton-in-Lindrick',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1136253,
        LOCATION_LATITUDE_DEG: 53.3553685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA043900',
        LOCATION_NAME: 'Carlton-le-Moorland',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6453335,
        LOCATION_LATITUDE_DEG: 53.1123077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044000',
        LOCATION_NAME: 'Carlton-on-Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8050502,
        LOCATION_LATITUDE_DEG: 53.165615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044100',
        LOCATION_NAME: 'Carluddon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7783863,
        LOCATION_LATITUDE_DEG: 50.3649901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044200',
        LOCATION_NAME: 'Carluke',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8329566,
        LOCATION_LATITUDE_DEG: 55.7336979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044300',
        LOCATION_NAME: 'Carlyon Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7420762,
        LOCATION_LATITUDE_DEG: 50.3340869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044400',
        LOCATION_NAME: 'Carmarthen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3093582,
        LOCATION_LATITUDE_DEG: 51.8561236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044600',
        LOCATION_NAME: 'Carmel',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4196781,
        LOCATION_LATITUDE_DEG: 53.3128668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044500',
        LOCATION_NAME: 'Carmel',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2482269,
        LOCATION_LATITUDE_DEG: 53.0711401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044800',
        LOCATION_NAME: 'Carmel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.051457,
        LOCATION_LATITUDE_DEG: 51.8296176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044700',
        LOCATION_NAME: 'Carmel',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7479061,
        LOCATION_LATITUDE_DEG: 53.1453411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA044900',
        LOCATION_NAME: 'Carmichael',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6894449,
        LOCATION_LATITUDE_DEG: 55.6338898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045000',
        LOCATION_NAME: 'Carminnow Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6929725,
        LOCATION_LATITUDE_DEG: 50.4587962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045100',
        LOCATION_NAME: 'Carmunnock',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2329452,
        LOCATION_LATITUDE_DEG: 55.7907072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091600',
        LOCATION_NAME: 'Carmyle',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1539439,
        LOCATION_LATITUDE_DEG: 55.8317558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045200',
        LOCATION_NAME: 'Carmyllie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7334617,
        LOCATION_LATITUDE_DEG: 56.5733666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045300',
        LOCATION_NAME: 'Carn Brea',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2384655,
        LOCATION_LATITUDE_DEG: 50.2250062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045400',
        LOCATION_NAME: 'Carn Brea Village',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2476274,
        LOCATION_LATITUDE_DEG: 50.222384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045500',
        LOCATION_NAME: 'Carn Entral',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2720258,
        LOCATION_LATITUDE_DEG: 50.2108753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045600',
        LOCATION_NAME: 'Carn Grey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7673802,
        LOCATION_LATITUDE_DEG: 50.3580917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045800',
        LOCATION_NAME: 'Carnaby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2476197,
        LOCATION_LATITUDE_DEG: 54.07229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046000',
        LOCATION_NAME: 'Carnan',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.348969,
        LOCATION_LATITUDE_DEG: 57.366897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046100',
        LOCATION_NAME: 'Carnanton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.978403,
        LOCATION_LATITUDE_DEG: 50.4374957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046400',
        LOCATION_NAME: 'Carnbee',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7573518,
        LOCATION_LATITUDE_DEG: 56.2491361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046500',
        LOCATION_NAME: 'Carnbo',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5248496,
        LOCATION_LATITUDE_DEG: 56.2115404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046600',
        LOCATION_NAME: 'Carnbroe',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9999576,
        LOCATION_LATITUDE_DEG: 55.8491145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046800',
        LOCATION_NAME: 'Carne Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7380713,
        LOCATION_LATITUDE_DEG: 50.3731888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046900',
        LOCATION_NAME: 'Carnebone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2180316,
        LOCATION_LATITUDE_DEG: 50.1368722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047000',
        LOCATION_NAME: 'Carneddi',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0522441,
        LOCATION_LATITUDE_DEG: 53.1815484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047500',
        LOCATION_NAME: 'Carnforth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7660823,
        LOCATION_LATITUDE_DEG: 54.128727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047600',
        LOCATION_NAME: 'Carnhedryn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1977183,
        LOCATION_LATITUDE_DEG: 51.9054411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047700',
        LOCATION_NAME: 'Carnhell Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3384253,
        LOCATION_LATITUDE_DEG: 50.1885786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047900',
        LOCATION_NAME: 'Carnish',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0515071,
        LOCATION_LATITUDE_DEG: 58.1793713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048100',
        LOCATION_NAME: 'Carnkie',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.240727,
        LOCATION_LATITUDE_DEG: 50.2134808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048000',
        LOCATION_NAME: 'Carnkie',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1938317,
        LOCATION_LATITUDE_DEG: 50.1631736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048200',
        LOCATION_NAME: 'Carnlough',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9981908,
        LOCATION_LATITUDE_DEG: 54.9952363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048400',
        LOCATION_NAME: 'Carnmenellis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2296226,
        LOCATION_LATITUDE_DEG: 50.1802762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048600',
        LOCATION_NAME: 'Carno',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5291652,
        LOCATION_LATITUDE_DEG: 52.5552847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048700',
        LOCATION_NAME: 'Carnoch',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9178314,
        LOCATION_LATITUDE_DEG: 57.5148879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048800',
        LOCATION_NAME: 'Carnock',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5387735,
        LOCATION_LATITUDE_DEG: 56.08443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048900',
        LOCATION_NAME: 'Carnon Crease',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0948108,
        LOCATION_LATITUDE_DEG: 50.2229779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049000',
        LOCATION_NAME: 'Carnon Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.086161,
        LOCATION_LATITUDE_DEG: 50.2212829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049100',
        LOCATION_NAME: 'Carnousie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5603946,
        LOCATION_LATITUDE_DEG: 57.5407626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049200',
        LOCATION_NAME: 'Carnoustie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6992745,
        LOCATION_LATITUDE_DEG: 56.5025622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049400',
        LOCATION_NAME: 'Carnteel',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9323122,
        LOCATION_LATITUDE_DEG: 54.4331967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049500',
        LOCATION_NAME: 'Carnwath',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6236441,
        LOCATION_LATITUDE_DEG: 55.7004953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049600',
        LOCATION_NAME: 'Caros',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4255333,
        LOCATION_LATITUDE_DEG: 58.0901619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049700',
        LOCATION_NAME: 'Caroy',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4854719,
        LOCATION_LATITUDE_DEG: 57.4025894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049750',
        LOCATION_NAME: 'Carpenders Park',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3860669,
        LOCATION_LATITUDE_DEG: 51.6301649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049800',
        LOCATION_NAME: 'Carperby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9918393,
        LOCATION_LATITUDE_DEG: 54.3019345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049900',
        LOCATION_NAME: 'Carr Bank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8079553,
        LOCATION_LATITUDE_DEG: 54.2049384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050000',
        LOCATION_NAME: 'Carr Gate',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5315466,
        LOCATION_LATITUDE_DEG: 53.7138774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA088700',
        LOCATION_NAME: 'Carr Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5877757,
        LOCATION_LATITUDE_DEG: 54.9477538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050100',
        LOCATION_NAME: 'Carr Houses',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0116827,
        LOCATION_LATITUDE_DEG: 53.5265747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050200',
        LOCATION_NAME: 'Carr Mill',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7207954,
        LOCATION_LATITUDE_DEG: 53.4681636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050500',
        LOCATION_NAME: 'Carradale',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4670336,
        LOCATION_LATITUDE_DEG: 55.5909981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050600',
        LOCATION_NAME: 'Carradale East',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4613194,
        LOCATION_LATITUDE_DEG: 55.5921039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051100',
        LOCATION_NAME: 'Carrbridge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8120867,
        LOCATION_LATITUDE_DEG: 57.2817533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051200',
        LOCATION_NAME: 'Carrbrook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.016949,
        LOCATION_LATITUDE_DEG: 53.5061593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051300',
        LOCATION_NAME: 'Carreghofa',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1118455,
        LOCATION_LATITUDE_DEG: 52.788504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051400',
        LOCATION_NAME: 'Carreglefn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4313697,
        LOCATION_LATITUDE_DEG: 53.3750785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051700',
        LOCATION_NAME: 'Carrick Castle',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9083328,
        LOCATION_LATITUDE_DEG: 56.1125482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052500',
        LOCATION_NAME: 'Carrickfergus',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8123707,
        LOCATION_LATITUDE_DEG: 54.7190181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052700',
        LOCATION_NAME: 'Carrickmore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0490102,
        LOCATION_LATITUDE_DEG: 54.5999192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053000',
        LOCATION_NAME: 'Carriden',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5740848,
        LOCATION_LATITUDE_DEG: 56.0150279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054750',
        LOCATION_NAME: 'Carrigans',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3451962,
        LOCATION_LATITUDE_DEG: 54.6841157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055500',
        LOCATION_NAME: 'Carrigreich',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7351438,
        LOCATION_LATITUDE_DEG: 57.8888449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056100',
        LOCATION_NAME: 'Carrington',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0874141,
        LOCATION_LATITUDE_DEG: 55.8333964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056200',
        LOCATION_NAME: 'Carrington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3972307,
        LOCATION_LATITUDE_DEG: 53.4317591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056300',
        LOCATION_NAME: 'Carrington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1543539,
        LOCATION_LATITUDE_DEG: 52.9707018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056000',
        LOCATION_NAME: 'Carrington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0425861,
        LOCATION_LATITUDE_DEG: 53.0760921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056400',
        LOCATION_NAME: 'Carroch',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0385188,
        LOCATION_LATITUDE_DEG: 56.7112845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056500',
        LOCATION_NAME: 'Carrog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3328006,
        LOCATION_LATITUDE_DEG: 52.9830239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056800',
        LOCATION_NAME: 'Carron',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7915648,
        LOCATION_LATITUDE_DEG: 56.0247234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056600',
        LOCATION_NAME: 'Carron',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2984521,
        LOCATION_LATITUDE_DEG: 57.4562654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056900',
        LOCATION_NAME: 'Carronbridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7787461,
        LOCATION_LATITUDE_DEG: 55.2619491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057000',
        LOCATION_NAME: 'Carronshore',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7767774,
        LOCATION_LATITUDE_DEG: 56.0277234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057100',
        LOCATION_NAME: 'Carrowdore',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5488673,
        LOCATION_LATITUDE_DEG: 54.5666027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058800',
        LOCATION_NAME: 'Carrshield',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3101368,
        LOCATION_LATITUDE_DEG: 54.8235631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058900',
        LOCATION_NAME: 'Carrutherstown',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4048253,
        LOCATION_LATITUDE_DEG: 55.0339299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059000',
        LOCATION_NAME: 'Carrville',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5252922,
        LOCATION_LATITUDE_DEG: 54.7895792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059100',
        LOCATION_NAME: 'Carryduff',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8921862,
        LOCATION_LATITUDE_DEG: 54.5207012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059200',
        LOCATION_NAME: 'Carse',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5852066,
        LOCATION_LATITUDE_DEG: 55.7883921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059300',
        LOCATION_NAME: 'Carse Gray',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8750488,
        LOCATION_LATITUDE_DEG: 56.6727803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059400',
        LOCATION_NAME: 'Carsethorn',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5771389,
        LOCATION_LATITUDE_DEG: 54.922313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059500',
        LOCATION_NAME: 'Carshalton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1619544,
        LOCATION_LATITUDE_DEG: 51.3647347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059600',
        LOCATION_NAME: 'Carsie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3447453,
        LOCATION_LATITUDE_DEG: 56.5650775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059700',
        LOCATION_NAME: 'Carsington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6250439,
        LOCATION_LATITUDE_DEG: 53.077315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059800',
        LOCATION_NAME: 'Carsluith',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3567108,
        LOCATION_LATITUDE_DEG: 54.8650214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA059900',
        LOCATION_NAME: 'Carsphairn',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2582882,
        LOCATION_LATITUDE_DEG: 55.2119562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060000',
        LOCATION_NAME: 'Carstairs',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.688962,
        LOCATION_LATITUDE_DEG: 55.6964955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060100',
        LOCATION_NAME: 'Carstairs Junction',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6615833,
        LOCATION_LATITUDE_DEG: 55.6876927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060200',
        LOCATION_NAME: 'Carswell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.526539,
        LOCATION_LATITUDE_DEG: 51.6735742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060300',
        LOCATION_NAME: 'Carswell Marsh',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5307498,
        LOCATION_LATITUDE_DEG: 51.6873762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060400',
        LOCATION_NAME: 'Carters Corner',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2792031,
        LOCATION_LATITUDE_DEG: 50.8805814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060500',
        LOCATION_NAME: 'Carterton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5928977,
        LOCATION_LATITUDE_DEG: 51.7587904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060600',
        LOCATION_NAME: 'Carterway Heads',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9346899,
        LOCATION_LATITUDE_DEG: 54.8591904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060700',
        LOCATION_NAME: 'Carthew',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8046678,
        LOCATION_LATITUDE_DEG: 50.3703863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060800',
        LOCATION_NAME: 'Carthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5254751,
        LOCATION_LATITUDE_DEG: 54.2488239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA060900',
        LOCATION_NAME: 'Cartington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9415098,
        LOCATION_LATITUDE_DEG: 55.3342419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061000',
        LOCATION_NAME: 'Cartland',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8028443,
        LOCATION_LATITUDE_DEG: 55.6951995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061100',
        LOCATION_NAME: 'Cartmel',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9509113,
        LOCATION_LATITUDE_DEG: 54.199841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061200',
        LOCATION_NAME: 'Cartmel Fell',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8946085,
        LOCATION_LATITUDE_DEG: 54.2832469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061400',
        LOCATION_NAME: 'Carty',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4583257,
        LOCATION_LATITUDE_DEG: 54.9342262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061600',
        LOCATION_NAME: 'Carveor Moor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7376818,
        LOCATION_LATITUDE_DEG: 50.3551876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061700',
        LOCATION_NAME: 'Carway',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2274302,
        LOCATION_LATITUDE_DEG: 51.7364158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061800',
        LOCATION_NAME: 'Carwinley',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9314612,
        LOCATION_LATITUDE_DEG: 55.0469212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061900',
        LOCATION_NAME: 'Carwynnen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2913288,
        LOCATION_LATITUDE_DEG: 50.1851733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062000',
        LOCATION_NAME: 'Cary Fitzpaine',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6477618,
        LOCATION_LATITUDE_DEG: 51.0395284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062100',
        LOCATION_NAME: 'Cascob',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1144949,
        LOCATION_LATITUDE_DEG: 52.2904568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062200',
        LOCATION_NAME: 'Casewick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4064294,
        LOCATION_LATITUDE_DEG: 52.668657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063100',
        LOCATION_NAME: 'Cashes Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2444007,
        LOCATION_LATITUDE_DEG: 51.7470929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063400',
        LOCATION_NAME: 'Cashmoor',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0338788,
        LOCATION_LATITUDE_DEG: 50.9224091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063500',
        LOCATION_NAME: 'Cassacawn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6714645,
        LOCATION_LATITUDE_DEG: 50.5277062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063600',
        LOCATION_NAME: 'Cassington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3420498,
        LOCATION_LATITUDE_DEG: 51.7920853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063700',
        LOCATION_NAME: 'Cassop',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4624196,
        LOCATION_LATITUDE_DEG: 54.7396689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063800',
        LOCATION_NAME: 'Castallack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5619774,
        LOCATION_LATITUDE_DEG: 50.0719702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063900',
        LOCATION_NAME: 'Castel',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6003959,
        LOCATION_LATITUDE_DEG: 49.4671882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064000',
        LOCATION_NAME: 'Casterton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5762685,
        LOCATION_LATITUDE_DEG: 54.2110332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064100',
        LOCATION_NAME: 'Casthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7072927,
        LOCATION_LATITUDE_DEG: 52.9119888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064200',
        LOCATION_NAME: 'Castle Acre',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6898279,
        LOCATION_LATITUDE_DEG: 52.7033458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990154',
        LOCATION_NAME: 'Castle An Dinas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA088400',
        LOCATION_NAME: 'Castle an Dinas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.884796,
        LOCATION_LATITUDE_DEG: 50.422628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064300',
        LOCATION_NAME: 'Castle Ashby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7408789,
        LOCATION_LATITUDE_DEG: 52.2267165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064400',
        LOCATION_NAME: 'Castle Bolton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9475521,
        LOCATION_LATITUDE_DEG: 54.3222368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089100',
        LOCATION_NAME: 'Castle Bromwich',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.783133,
        LOCATION_LATITUDE_DEG: 52.5065024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064500',
        LOCATION_NAME: 'Castle Bytham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5341761,
        LOCATION_LATITUDE_DEG: 52.7534678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064600',
        LOCATION_NAME: 'Castle Caereinion',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2358013,
        LOCATION_LATITUDE_DEG: 52.640793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064700',
        LOCATION_NAME: 'Castle Camps',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3816616,
        LOCATION_LATITUDE_DEG: 52.0628938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064800',
        LOCATION_NAME: 'Castle Carlton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1005779,
        LOCATION_LATITUDE_DEG: 53.3321142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA064900',
        LOCATION_NAME: 'Castle Carrock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7133713,
        LOCATION_LATITUDE_DEG: 54.8911042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065000',
        LOCATION_NAME: 'Castle Cary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5135076,
        LOCATION_LATITUDE_DEG: 51.0878327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065200',
        LOCATION_NAME: 'Castle Combe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2183249,
        LOCATION_LATITUDE_DEG: 51.4941718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065300',
        LOCATION_NAME: 'Castle Dene',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5380184,
        LOCATION_LATITUDE_DEG: 54.8478859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065400',
        LOCATION_NAME: 'Castle Donington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3361346,
        LOCATION_LATITUDE_DEG: 52.8440916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065500',
        LOCATION_NAME: 'Castle Douglas',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.930658,
        LOCATION_LATITUDE_DEG: 54.938919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065700',
        LOCATION_NAME: 'Castle Eaton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7849276,
        LOCATION_LATITUDE_DEG: 51.6599798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065800',
        LOCATION_NAME: 'Castle Eden',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3341214,
        LOCATION_LATITUDE_DEG: 54.7369741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065900',
        LOCATION_NAME: 'Castle Fraser',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.457533,
        LOCATION_LATITUDE_DEG: 57.2041289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066000',
        LOCATION_NAME: 'Castle Frome',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4897399,
        LOCATION_LATITUDE_DEG: 52.1088274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066100',
        LOCATION_NAME: 'Castle Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6114676,
        LOCATION_LATITUDE_DEG: 51.3393319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066200',
        LOCATION_NAME: 'Castle Gresley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5851279,
        LOCATION_LATITUDE_DEG: 52.7593807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066300',
        LOCATION_NAME: 'Castle Hedingham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6002456,
        LOCATION_LATITUDE_DEG: 51.9892787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066400',
        LOCATION_NAME: 'Castle Hill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2166004,
        LOCATION_LATITUDE_DEG: 51.0304974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066500',
        LOCATION_NAME: 'Castle Hills',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4377376,
        LOCATION_LATITUDE_DEG: 54.3381329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066600',
        LOCATION_NAME: 'Castle Horneck',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5454539,
        LOCATION_LATITUDE_DEG: 50.1164755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066700',
        LOCATION_NAME: 'Castle Howard',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9031703,
        LOCATION_LATITUDE_DEG: 54.1220058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066800',
        LOCATION_NAME: 'Castle Huntly',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1316492,
        LOCATION_LATITUDE_DEG: 56.4514639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090700',
        LOCATION_NAME: 'Castle Junction',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA066900',
        LOCATION_NAME: 'Castle Kennedy',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9492132,
        LOCATION_LATITUDE_DEG: 54.8966317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067100',
        LOCATION_NAME: 'Castle Morris',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0527089,
        LOCATION_LATITUDE_DEG: 51.9389873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067200',
        LOCATION_NAME: 'Castle Rising',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.473122,
        LOCATION_LATITUDE_DEG: 52.7937596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067400',
        LOCATION_NAME: 'Castle Stuart',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0990513,
        LOCATION_LATITUDE_DEG: 57.5208789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067500',
        LOCATION_NAME: 'Castle Tump',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4202603,
        LOCATION_LATITUDE_DEG: 51.961514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990366',
        LOCATION_NAME: 'Castle upon Alun',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091100',
        LOCATION_NAME: 'Castle Vale',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7907688,
        LOCATION_LATITUDE_DEG: 52.5213423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067600',
        LOCATION_NAME: 'Castle-an-Dinas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8848956,
        LOCATION_LATITUDE_DEG: 50.4163911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068000',
        LOCATION_NAME: 'Castlebay',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4850879,
        LOCATION_LATITUDE_DEG: 56.9552529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068700',
        LOCATION_NAME: 'Castlebythe',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8782249,
        LOCATION_LATITUDE_DEG: 51.9247403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068800',
        LOCATION_NAME: 'Castlecary',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9542216,
        LOCATION_LATITUDE_DEG: 55.9742229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068900',
        LOCATION_NAME: 'Castlecaulfield',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8322883,
        LOCATION_LATITUDE_DEG: 54.4999044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069600',
        LOCATION_NAME: 'Castlecroft',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1859515,
        LOCATION_LATITUDE_DEG: 52.5793725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069700',
        LOCATION_NAME: 'Castledawson',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.565653,
        LOCATION_LATITUDE_DEG: 54.7832368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069800',
        LOCATION_NAME: 'Castlederg',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5814612,
        LOCATION_LATITUDE_DEG: 54.7110328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070100',
        LOCATION_NAME: 'Castledore',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6661783,
        LOCATION_LATITUDE_DEG: 50.3586852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070200',
        LOCATION_NAME: 'Castlefields',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6971629,
        LOCATION_LATITUDE_DEG: 53.3369539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070400',
        LOCATION_NAME: 'Castleford',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3547053,
        LOCATION_LATITUDE_DEG: 53.7256765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071000',
        LOCATION_NAME: 'Castlehead',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4341494,
        LOCATION_LATITUDE_DEG: 55.8373152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071100',
        LOCATION_NAME: 'Castlehill',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3840698,
        LOCATION_LATITUDE_DEG: 58.5977757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071700',
        LOCATION_NAME: 'Castlelevington',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3198244,
        LOCATION_LATITUDE_DEG: 54.4903449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072200',
        LOCATION_NAME: 'Castlemartin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0132747,
        LOCATION_LATITUDE_DEG: 51.6446091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091800',
        LOCATION_NAME: 'Castlemilk',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2315332,
        LOCATION_LATITUDE_DEG: 55.8050696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072400',
        LOCATION_NAME: 'Castlemilk',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.329031,
        LOCATION_LATITUDE_DEG: 55.0838285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072600',
        LOCATION_NAME: 'Castlemorton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2992431,
        LOCATION_LATITUDE_DEG: 52.0332244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073000',
        LOCATION_NAME: 'Castlepark',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6631205,
        LOCATION_LATITUDE_DEG: 55.6344995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073700',
        LOCATION_NAME: 'Castlerigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1090419,
        LOCATION_LATITUDE_DEG: 54.5899813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073800',
        LOCATION_NAME: 'Castlerock',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7822647,
        LOCATION_LATITUDE_DEG: 55.1499733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073900',
        LOCATION_NAME: 'Castleroe',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.674561,
        LOCATION_LATITUDE_DEG: 55.1110624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074200',
        LOCATION_NAME: 'Castleside',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.877589,
        LOCATION_LATITUDE_DEG: 54.8338916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074500',
        LOCATION_NAME: 'Castlethorpe',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8350502,
        LOCATION_LATITUDE_DEG: 52.0922108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074400',
        LOCATION_NAME: 'Castlethorpe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5160318,
        LOCATION_LATITUDE_DEG: 53.5559433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074900',
        LOCATION_NAME: 'Castleton',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3986888,
        LOCATION_LATITUDE_DEG: 56.0094437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074800',
        LOCATION_NAME: 'Castleton',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0774219,
        LOCATION_LATITUDE_DEG: 51.544984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074700',
        LOCATION_NAME: 'Castleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1745705,
        LOCATION_LATITUDE_DEG: 53.5938325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074600',
        LOCATION_NAME: 'Castleton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7737901,
        LOCATION_LATITUDE_DEG: 53.3429382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075000',
        LOCATION_NAME: 'Castleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.936136,
        LOCATION_LATITUDE_DEG: 54.462841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075900',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3451826,
        LOCATION_LATITUDE_DEG: 54.6657368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076250',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6548346,
        LOCATION_LATITUDE_DEG: 54.075514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075800',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3900909,
        LOCATION_LATITUDE_DEG: 58.5933808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076200',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8381389,
        LOCATION_LATITUDE_DEG: 53.0537279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076100',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4440265,
        LOCATION_LATITUDE_DEG: 50.56728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076000',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4409727,
        LOCATION_LATITUDE_DEG: 54.9161877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990365',
        LOCATION_NAME: 'Castle-upon-Alun',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076800',
        LOCATION_NAME: 'Castleward',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6044661,
        LOCATION_LATITUDE_DEG: 54.3119703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077000',
        LOCATION_NAME: 'Castlewellan',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9519967,
        LOCATION_LATITUDE_DEG: 54.2588743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077100',
        LOCATION_NAME: 'Castley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5908191,
        LOCATION_LATITUDE_DEG: 53.9080964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077200',
        LOCATION_NAME: 'Caston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.884164,
        LOCATION_LATITUDE_DEG: 52.5431278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077300',
        LOCATION_NAME: 'Castor',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3444074,
        LOCATION_LATITUDE_DEG: 52.5728445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077400',
        LOCATION_NAME: 'Caswell',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0172845,
        LOCATION_LATITUDE_DEG: 51.5711965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077500',
        LOCATION_NAME: 'Caswell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.046872,
        LOCATION_LATITUDE_DEG: 52.1526148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077600',
        LOCATION_NAME: 'Caswell Bay',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0293421,
        LOCATION_LATITUDE_DEG: 51.5693967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077700',
        LOCATION_NAME: 'Catbrook',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7049511,
        LOCATION_LATITUDE_DEG: 51.7196948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077800',
        LOCATION_NAME: 'Catchgate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7462786,
        LOCATION_LATITUDE_DEG: 54.8650904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA077900',
        LOCATION_NAME: 'Catcleugh',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3980197,
        LOCATION_LATITUDE_DEG: 55.3234436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078000',
        LOCATION_NAME: 'Catcliffe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3600227,
        LOCATION_LATITUDE_DEG: 53.3917436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078100',
        LOCATION_NAME: 'Catcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7263649,
        LOCATION_LATITUDE_DEG: 51.0525294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078200',
        LOCATION_NAME: 'Catcott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8632858,
        LOCATION_LATITUDE_DEG: 51.1489422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078300',
        LOCATION_NAME: 'Caterham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0764348,
        LOCATION_LATITUDE_DEG: 51.2815261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078400',
        LOCATION_NAME: 'Catesby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2301224,
        LOCATION_LATITUDE_DEG: 52.2298067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078500',
        LOCATION_NAME: 'Catfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5360395,
        LOCATION_LATITUDE_DEG: 52.7399335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089700',
        LOCATION_NAME: 'Catford',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0302979,
        LOCATION_LATITUDE_DEG: 51.4723462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078600',
        LOCATION_NAME: 'Catforth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.789686,
        LOCATION_LATITUDE_DEG: 53.8119993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078700',
        LOCATION_NAME: 'Catfoss',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2610177,
        LOCATION_LATITUDE_DEG: 53.9084799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091200',
        LOCATION_NAME: 'Cathay',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5889919,
        LOCATION_LATITUDE_DEG: 51.4479599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078900',
        LOCATION_NAME: 'Cathays',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1846034,
        LOCATION_LATITUDE_DEG: 51.4979791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091700',
        LOCATION_NAME: 'Cathcart',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2617547,
        LOCATION_LATITUDE_DEG: 55.8192676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079000',
        LOCATION_NAME: 'Cathedine',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2449593,
        LOCATION_LATITUDE_DEG: 51.9187238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA088500',
        LOCATION_NAME: 'Catherine de Barnes',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079100',
        LOCATION_NAME: 'Catherine Wheel',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9481882,
        LOCATION_LATITUDE_DEG: 50.9412282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079200',
        LOCATION_NAME: 'Catherine-de-Barnes',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.732782,
        LOCATION_LATITUDE_DEG: 52.4217486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079300',
        LOCATION_NAME: 'Catherington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0106624,
        LOCATION_LATITUDE_DEG: 50.9142026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079400',
        LOCATION_NAME: 'Cathiron',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3136738,
        LOCATION_LATITUDE_DEG: 52.4007455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079500',
        LOCATION_NAME: 'Catisfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2268284,
        LOCATION_LATITUDE_DEG: 50.8562964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079600',
        LOCATION_NAME: 'Catley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4626079,
        LOCATION_LATITUDE_DEG: 52.0934264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079700',
        LOCATION_NAME: 'Catlodge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2505447,
        LOCATION_LATITUDE_DEG: 57.0074313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079800',
        LOCATION_NAME: 'Catlowdy',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.846686,
        LOCATION_LATITUDE_DEG: 55.0826274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079900',
        LOCATION_NAME: 'Catmore',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3469197,
        LOCATION_LATITUDE_DEG: 51.5186624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080100',
        LOCATION_NAME: 'Caton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7188626,
        LOCATION_LATITUDE_DEG: 50.5323964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080000',
        LOCATION_NAME: 'Caton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.715821,
        LOCATION_LATITUDE_DEG: 54.0745194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080200',
        LOCATION_NAME: 'Catrine',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3269072,
        LOCATION_LATITUDE_DEG: 55.5038795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080300',
        LOCATION_NAME: 'Catsfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.453537,
        LOCATION_LATITUDE_DEG: 50.896277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080400',
        LOCATION_NAME: 'Catsgore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7078761,
        LOCATION_LATITUDE_DEG: 51.0284327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080500',
        LOCATION_NAME: 'Catsham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6414625,
        LOCATION_LATITUDE_DEG: 51.0998362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080600',
        LOCATION_NAME: 'Catshill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0636498,
        LOCATION_LATITUDE_DEG: 52.3604531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080700',
        LOCATION_NAME: 'Catstree',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3735934,
        LOCATION_LATITUDE_DEG: 52.5680772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080800',
        LOCATION_NAME: 'Cattal',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3156798,
        LOCATION_LATITUDE_DEG: 53.9815961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA080900',
        LOCATION_NAME: 'Cattawade',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0601889,
        LOCATION_LATITUDE_DEG: 51.9590675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081000',
        LOCATION_NAME: 'Cattedown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1204158,
        LOCATION_LATITUDE_DEG: 50.3651811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081100',
        LOCATION_NAME: 'Catterall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7617188,
        LOCATION_LATITUDE_DEG: 53.879608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081200',
        LOCATION_NAME: 'Catterick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6286989,
        LOCATION_LATITUDE_DEG: 54.3766401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081300',
        LOCATION_NAME: 'Catterick Bridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6495223,
        LOCATION_LATITUDE_DEG: 54.3884409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081400',
        LOCATION_NAME: 'Catterick Garrison',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7202151,
        LOCATION_LATITUDE_DEG: 54.376743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081500',
        LOCATION_NAME: 'Catterlen',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8112196,
        LOCATION_LATITUDE_DEG: 54.6893876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081600',
        LOCATION_NAME: 'Catterline',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2161781,
        LOCATION_LATITUDE_DEG: 56.8950981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081700',
        LOCATION_NAME: 'Catterton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2233146,
        LOCATION_LATITUDE_DEG: 53.9064884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081800',
        LOCATION_NAME: 'Catthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1865898,
        LOCATION_LATITUDE_DEG: 52.3985458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA081900',
        LOCATION_NAME: 'Cattistock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.579559,
        LOCATION_LATITUDE_DEG: 50.7942112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082100',
        LOCATION_NAME: 'Catton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2644833,
        LOCATION_LATITUDE_DEG: 54.9119009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082000',
        LOCATION_NAME: 'Catton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4327564,
        LOCATION_LATITUDE_DEG: 54.1970179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090500',
        LOCATION_NAME: 'Catton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2962988,
        LOCATION_LATITUDE_DEG: 52.6638888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082200',
        LOCATION_NAME: 'Catwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2830277,
        LOCATION_LATITUDE_DEG: 53.8926774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082300',
        LOCATION_NAME: 'Catworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4059229,
        LOCATION_LATITUDE_DEG: 52.3462289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082400',
        LOCATION_NAME: 'Caudle Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0801177,
        LOCATION_LATITUDE_DEG: 51.7923971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082500',
        LOCATION_NAME: 'Caughall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8871226,
        LOCATION_LATITUDE_DEG: 53.2335474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082600',
        LOCATION_NAME: 'Caulcott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2605832,
        LOCATION_LATITUDE_DEG: 51.9151982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082700',
        LOCATION_NAME: 'Cauldcots',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5633661,
        LOCATION_LATITUDE_DEG: 56.6175703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082800',
        LOCATION_NAME: 'Cauldhame',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1804109,
        LOCATION_LATITUDE_DEG: 56.1226423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA082900',
        LOCATION_NAME: 'Cauldon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8723737,
        LOCATION_LATITUDE_DEG: 53.041517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083000',
        LOCATION_NAME: 'Cauldon Low',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8916376,
        LOCATION_LATITUDE_DEG: 53.027008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083100',
        LOCATION_NAME: 'Caulkerbush',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6720302,
        LOCATION_LATITUDE_DEG: 54.897611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083200',
        LOCATION_NAME: 'Caulside',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.870814,
        LOCATION_LATITUDE_DEG: 55.1158276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083300',
        LOCATION_NAME: 'Caundle Marsh',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4587552,
        LOCATION_LATITUDE_DEG: 50.9154153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083400',
        LOCATION_NAME: 'Caunsall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2207657,
        LOCATION_LATITUDE_DEG: 52.4258545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083500',
        LOCATION_NAME: 'Caunton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8863875,
        LOCATION_LATITUDE_DEG: 53.1316101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083800',
        LOCATION_NAME: 'Causeway Foot',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8955348,
        LOCATION_LATITUDE_DEG: 53.7740846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084000',
        LOCATION_NAME: 'Causewayhead',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9223327,
        LOCATION_LATITUDE_DEG: 56.1383431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083900',
        LOCATION_NAME: 'Causewayhead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3612066,
        LOCATION_LATITUDE_DEG: 54.8642079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084100',
        LOCATION_NAME: 'Causey Park',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7202419,
        LOCATION_LATITUDE_DEG: 55.2489293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084200',
        LOCATION_NAME: 'Causey Park Bridge',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.70205,
        LOCATION_LATITUDE_DEG: 55.2434222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084300',
        LOCATION_NAME: 'Cautley',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4718499,
        LOCATION_LATITUDE_DEG: 54.3519488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084550',
        LOCATION_NAME: 'Cavancarragh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5428985,
        LOCATION_LATITUDE_DEG: 54.3407027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA090800',
        LOCATION_NAME: 'Cavehill',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9508089,
        LOCATION_LATITUDE_DEG: 54.6481167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084600',
        LOCATION_NAME: 'Cavendish',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6348146,
        LOCATION_LATITUDE_DEG: 52.0861847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084700',
        LOCATION_NAME: 'Cavenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5855835,
        LOCATION_LATITUDE_DEG: 52.29691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990336',
        LOCATION_NAME: 'Cavers',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7603072,
        LOCATION_LATITUDE_DEG: 55.4547239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084800',
        LOCATION_NAME: 'Caversfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1579191,
        LOCATION_LATITUDE_DEG: 51.9232937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084900',
        LOCATION_NAME: 'Caversham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9676072,
        LOCATION_LATITUDE_DEG: 51.4709553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085000',
        LOCATION_NAME: 'Caversta',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4707516,
        LOCATION_LATITUDE_DEG: 58.0919626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085100',
        LOCATION_NAME: 'Caverswall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0729783,
        LOCATION_LATITUDE_DEG: 52.9835134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085300',
        LOCATION_NAME: 'Caw',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8036943,
        LOCATION_LATITUDE_DEG: 57.8955405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085400',
        LOCATION_NAME: 'Cawburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4285152,
        LOCATION_LATITUDE_DEG: 55.0011092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085500',
        LOCATION_NAME: 'Cawdor',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9300413,
        LOCATION_LATITUDE_DEG: 57.5257786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085600',
        LOCATION_NAME: 'Cawkwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0745038,
        LOCATION_LATITUDE_DEG: 53.3000123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085700',
        LOCATION_NAME: 'Cawood',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1280277,
        LOCATION_LATITUDE_DEG: 53.8327789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085800',
        LOCATION_NAME: 'Cawood Common',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1539509,
        LOCATION_LATITUDE_DEG: 53.8087743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085900',
        LOCATION_NAME: 'Cawsand',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2011469,
        LOCATION_LATITUDE_DEG: 50.3303792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086000',
        LOCATION_NAME: 'Cawston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3075059,
        LOCATION_LATITUDE_DEG: 52.3543413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086100',
        LOCATION_NAME: 'Cawston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1644209,
        LOCATION_LATITUDE_DEG: 52.7703456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086300',
        LOCATION_NAME: 'Cawthorne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5685642,
        LOCATION_LATITUDE_DEG: 53.5673645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086200',
        LOCATION_NAME: 'Cawthorne',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8111045,
        LOCATION_LATITUDE_DEG: 54.2914194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086400',
        LOCATION_NAME: 'Cawthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.380586,
        LOCATION_LATITUDE_DEG: 52.7838665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086500',
        LOCATION_NAME: 'Cawton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0138348,
        LOCATION_LATITUDE_DEG: 54.1821103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086600',
        LOCATION_NAME: 'Caxton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0907342,
        LOCATION_LATITUDE_DEG: 52.2050119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086700',
        LOCATION_NAME: 'Caynham',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.677775,
        LOCATION_LATITUDE_DEG: 52.3501557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086850',
        LOCATION_NAME: 'Caynton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4377686,
        LOCATION_LATITUDE_DEG: 52.7918444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086800',
        LOCATION_NAME: 'Caynton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.328503,
        LOCATION_LATITUDE_DEG: 52.6236755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA086900',
        LOCATION_NAME: 'Caythorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.972414,
        LOCATION_LATITUDE_DEG: 53.0018953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087000',
        LOCATION_NAME: 'Caythorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6006312,
        LOCATION_LATITUDE_DEG: 53.0255953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087100',
        LOCATION_NAME: 'Cayton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3817241,
        LOCATION_LATITUDE_DEG: 54.2351099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA087200',
        LOCATION_NAME: 'Cayton Bay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3629378,
        LOCATION_LATITUDE_DEG: 54.2441064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000200',
        LOCATION_NAME: 'Cefn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0794632,
        LOCATION_LATITUDE_DEG: 52.6856937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000300',
        LOCATION_NAME: 'Cefn Brynich',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3429035,
        LOCATION_LATITUDE_DEG: 51.9348226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000400',
        LOCATION_NAME: 'Cefn Bychan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1038102,
        LOCATION_LATITUDE_DEG: 51.6356008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000500',
        LOCATION_NAME: 'Cefn Canol',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.140021,
        LOCATION_LATITUDE_DEG: 52.872311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000600',
        LOCATION_NAME: 'Cefn Coch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3232688,
        LOCATION_LATITUDE_DEG: 52.8289075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000700',
        LOCATION_NAME: 'Cefn Coed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.405597,
        LOCATION_LATITUDE_DEG: 51.7626106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000800',
        LOCATION_NAME: 'Cefn Cribwr',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6524651,
        LOCATION_LATITUDE_DEG: 51.5312878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000900',
        LOCATION_NAME: 'Cefn Ddwysarn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.538138,
        LOCATION_LATITUDE_DEG: 52.9356874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001000',
        LOCATION_NAME: 'Cefn Einion',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0491262,
        LOCATION_LATITUDE_DEG: 52.4690702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001100',
        LOCATION_NAME: 'Cefn Fforest',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2088939,
        LOCATION_LATITUDE_DEG: 51.6698001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001200',
        LOCATION_NAME: 'Cefn Golau',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2528988,
        LOCATION_LATITUDE_DEG: 51.7681054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001300',
        LOCATION_NAME: 'Cefn Gorwydd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6029844,
        LOCATION_LATITUDE_DEG: 52.0948371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001400',
        LOCATION_NAME: 'Cefn Hengoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2332536,
        LOCATION_LATITUDE_DEG: 51.6539984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001500',
        LOCATION_NAME: 'Cefn Mawr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3097693,
        LOCATION_LATITUDE_DEG: 52.5364797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001550',
        LOCATION_NAME: 'Cefn Mawr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0749631,
        LOCATION_LATITUDE_DEG: 52.9730389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001600',
        LOCATION_NAME: 'Cefn Meiriadog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4766921,
        LOCATION_LATITUDE_DEG: 53.2301463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001700',
        LOCATION_NAME: 'Cefn Pennar',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.393091,
        LOCATION_LATITUDE_DEG: 51.6966986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001800',
        LOCATION_NAME: 'Cefn Stylle',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0649805,
        LOCATION_LATITUDE_DEG: 51.642406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE004400',
        LOCATION_NAME: 'Cefn y Bedd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002000',
        LOCATION_NAME: 'Cefneithin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0974772,
        LOCATION_LATITUDE_DEG: 51.8032193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002100',
        LOCATION_NAME: 'Cefniwrch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2837586,
        LOCATION_LATITUDE_DEG: 53.2882663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002200',
        LOCATION_NAME: 'Cefnllys',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3003831,
        LOCATION_LATITUDE_DEG: 52.2767588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE001900',
        LOCATION_NAME: 'Cefn-y-Bedd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0298832,
        LOCATION_LATITUDE_DEG: 53.0977326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002300',
        LOCATION_NAME: 'Cefnypant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6252065,
        LOCATION_LATITUDE_DEG: 51.893711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002400',
        LOCATION_NAME: 'Ceidio',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5416948,
        LOCATION_LATITUDE_DEG: 52.9107275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002500',
        LOCATION_NAME: 'Ceinws',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8220496,
        LOCATION_LATITUDE_DEG: 52.6359963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002700',
        LOCATION_NAME: 'Cellan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0368213,
        LOCATION_LATITUDE_DEG: 52.1203507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002800',
        LOCATION_NAME: 'Cellardyke',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6963932,
        LOCATION_LATITUDE_DEG: 56.2252328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002900',
        LOCATION_NAME: 'Cemaes Bay',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4552563,
        LOCATION_LATITUDE_DEG: 53.4091816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003000',
        LOCATION_NAME: 'Cemlyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5036607,
        LOCATION_LATITUDE_DEG: 53.4082749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003100',
        LOCATION_NAME: 'Cemmaes',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7164152,
        LOCATION_LATITUDE_DEG: 52.6389947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003200',
        LOCATION_NAME: 'Cemmaes Road',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7414439,
        LOCATION_LATITUDE_DEG: 52.6245931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003300',
        LOCATION_NAME: 'Cenarth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5239428,
        LOCATION_LATITUDE_DEG: 52.0447495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003400',
        LOCATION_NAME: 'Cennin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2864438,
        LOCATION_LATITUDE_DEG: 52.9780352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003500',
        LOCATION_NAME: 'Central Park',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4202919,
        LOCATION_LATITUDE_DEG: 52.6880833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003600',
        LOCATION_NAME: 'Central Treviscoe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8952992,
        LOCATION_LATITUDE_DEG: 50.3567924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003700',
        LOCATION_NAME: 'Ceres',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9689458,
        LOCATION_LATITUDE_DEG: 56.2924458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003800',
        LOCATION_NAME: 'Cerne Abbas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4733677,
        LOCATION_LATITUDE_DEG: 50.8075063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE003900',
        LOCATION_NAME: 'Cerney Wick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8888368,
        LOCATION_LATITUDE_DEG: 51.6620844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE004000',
        LOCATION_NAME: 'Cerrigceinwen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3553243,
        LOCATION_LATITUDE_DEG: 53.2356645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE004100',
        LOCATION_NAME: 'Cerrigydrudion',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5604848,
        LOCATION_LATITUDE_DEG: 53.0252356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE004200',
        LOCATION_NAME: 'Cessford',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.419904,
        LOCATION_LATITUDE_DEG: 55.5058631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE004300',
        LOCATION_NAME: 'Ceunant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1953247,
        LOCATION_LATITUDE_DEG: 53.1276443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000100',
        LOCATION_NAME: 'Chaceley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.207341,
        LOCATION_LATITUDE_DEG: 51.9738157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000200',
        LOCATION_NAME: 'Chacewater',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1539849,
        LOCATION_LATITUDE_DEG: 50.2568872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000300',
        LOCATION_NAME: 'Chackmore',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0042377,
        LOCATION_LATITUDE_DEG: 52.0158997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000400',
        LOCATION_NAME: 'Chacombe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2824705,
        LOCATION_LATITUDE_DEG: 52.0899115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH056300',
        LOCATION_NAME: 'Chad Valley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9344583,
        LOCATION_LATITUDE_DEG: 52.467725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000500',
        LOCATION_NAME: 'Chadbury',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9693718,
        LOCATION_LATITUDE_DEG: 52.1160267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000600',
        LOCATION_NAME: 'Chadderton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1613008,
        LOCATION_LATITUDE_DEG: 53.5494707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000700',
        LOCATION_NAME: 'Chaddesden',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4304828,
        LOCATION_LATITUDE_DEG: 52.9304949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000800',
        LOCATION_NAME: 'Chaddesley Corbett',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1574859,
        LOCATION_LATITUDE_DEG: 52.3621545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH000900',
        LOCATION_NAME: 'Chaddlehanger',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1672242,
        LOCATION_LATITUDE_DEG: 50.5804033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001000',
        LOCATION_NAME: 'Chaddlewood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0375138,
        LOCATION_LATITUDE_DEG: 50.3881803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001100',
        LOCATION_NAME: 'Chaddleworth',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4073158,
        LOCATION_LATITUDE_DEG: 51.4974638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001200',
        LOCATION_NAME: 'Chadlington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5235447,
        LOCATION_LATITUDE_DEG: 51.8952004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001300',
        LOCATION_NAME: 'Chadshunt',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4918935,
        LOCATION_LATITUDE_DEG: 52.1726261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001400',
        LOCATION_NAME: 'Chadsmoor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0177442,
        LOCATION_LATITUDE_DEG: 52.6980784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001600',
        LOCATION_NAME: 'Chadwell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3331068,
        LOCATION_LATITUDE_DEG: 52.7259864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001500',
        LOCATION_NAME: 'Chadwell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8409157,
        LOCATION_LATITUDE_DEG: 52.8142787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001700',
        LOCATION_NAME: 'Chadwell Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1336134,
        LOCATION_LATITUDE_DEG: 51.5715489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053600',
        LOCATION_NAME: 'Chadwell St Mary',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001800',
        LOCATION_NAME: 'Chadwell St. Mary',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3704687,
        LOCATION_LATITUDE_DEG: 51.481233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH001900',
        LOCATION_NAME: 'Chadwich',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0446621,
        LOCATION_LATITUDE_DEG: 52.3910497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002000',
        LOCATION_NAME: 'Chadwick End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6985057,
        LOCATION_LATITUDE_DEG: 52.3563453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002100',
        LOCATION_NAME: 'Chaffcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9185846,
        LOCATION_LATITUDE_DEG: 50.8851196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002200',
        LOCATION_NAME: 'Chafford Hundred',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3123268,
        LOCATION_LATITUDE_DEG: 51.4888342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002300',
        LOCATION_NAME: 'Chagford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8386413,
        LOCATION_LATITUDE_DEG: 50.6725129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002400',
        LOCATION_NAME: 'Chaigley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4799845,
        LOCATION_LATITUDE_DEG: 53.8733975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002500',
        LOCATION_NAME: 'Chailey',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0174592,
        LOCATION_LATITUDE_DEG: 50.9571905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002600',
        LOCATION_NAME: 'Chailey Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0219212,
        LOCATION_LATITUDE_DEG: 50.9570862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002700',
        LOCATION_NAME: 'Chain Bar',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.728585,
        LOCATION_LATITUDE_DEG: 53.7377766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002800',
        LOCATION_NAME: 'Chain Bridge',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9464372,
        LOCATION_LATITUDE_DEG: 51.7443008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH002900',
        LOCATION_NAME: 'Chain Bridge',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0977158,
        LOCATION_LATITUDE_DEG: 52.5799444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003000',
        LOCATION_NAME: 'Chalbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9743218,
        LOCATION_LATITUDE_DEG: 50.8617055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003100',
        LOCATION_NAME: 'Chaldon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1123231,
        LOCATION_LATITUDE_DEG: 51.2796191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003200',
        LOCATION_NAME: 'Chaldon Herring',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2948071,
        LOCATION_LATITUDE_DEG: 50.649391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003300',
        LOCATION_NAME: 'Chale',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.31525,
        LOCATION_LATITUDE_DEG: 50.5977726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003400',
        LOCATION_NAME: 'Chale Green',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3142593,
        LOCATION_LATITUDE_DEG: 50.615377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003500',
        LOCATION_NAME: 'Chalfont Common',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5507312,
        LOCATION_LATITUDE_DEG: 51.6205593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053700',
        LOCATION_NAME: 'Chalfont St Giles',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053800',
        LOCATION_NAME: 'Chalfont St Peter',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003600',
        LOCATION_NAME: 'Chalfont St. Giles',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5686606,
        LOCATION_LATITUDE_DEG: 51.6315618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003700',
        LOCATION_NAME: 'Chalfont St. Peter',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5428919,
        LOCATION_LATITUDE_DEG: 51.6095627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003800',
        LOCATION_NAME: 'Chalford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1473453,
        LOCATION_LATITUDE_DEG: 51.7259882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH003900',
        LOCATION_NAME: 'Chalford Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1470962,
        LOCATION_LATITUDE_DEG: 51.7250893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004000',
        LOCATION_NAME: 'Chalgrave',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5321883,
        LOCATION_LATITUDE_DEG: 51.9383941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004100',
        LOCATION_NAME: 'Chalgrove',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.079995,
        LOCATION_LATITUDE_DEG: 51.6674723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004200',
        LOCATION_NAME: 'Chalk',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4132253,
        LOCATION_LATITUDE_DEG: 51.428625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH056100',
        LOCATION_NAME: 'Chalk Farm',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1492539,
        LOCATION_LATITUDE_DEG: 51.5440924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004300',
        LOCATION_NAME: 'Chalkhouse Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9802951,
        LOCATION_LATITUDE_DEG: 51.5018578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004400',
        LOCATION_NAME: 'Challaborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8974523,
        LOCATION_LATITUDE_DEG: 50.2884724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004500',
        LOCATION_NAME: 'Challacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8658089,
        LOCATION_LATITUDE_DEG: 51.152858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004600',
        LOCATION_NAME: 'Challoch',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0820904,
        LOCATION_LATITUDE_DEG: 54.9166287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004700',
        LOCATION_NAME: 'Challock',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8780269,
        LOCATION_LATITUDE_DEG: 51.220007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004800',
        LOCATION_NAME: 'Challymead',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1508994,
        LOCATION_LATITUDE_DEG: 51.3704586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH004900',
        LOCATION_NAME: 'Chalmington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5752099,
        LOCATION_LATITUDE_DEG: 50.805205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005100',
        LOCATION_NAME: 'Chalton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9589539,
        LOCATION_LATITUDE_DEG: 50.9388004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005000',
        LOCATION_NAME: 'Chalton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4991336,
        LOCATION_LATITUDE_DEG: 51.9252887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005200',
        LOCATION_NAME: 'Chalvey',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6065572,
        LOCATION_LATITUDE_DEG: 51.5048476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005300',
        LOCATION_NAME: 'Chalvington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1607318,
        LOCATION_LATITUDE_DEG: 50.8638835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005400',
        LOCATION_NAME: 'Chance Inn',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0116266,
        LOCATION_LATITUDE_DEG: 56.2810429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005500',
        LOCATION_NAME: "Chandler'S Cross",
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4571357,
        LOCATION_LATITUDE_DEG: 51.6722635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053400',
        LOCATION_NAME: 'Chandlers Ford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005600',
        LOCATION_NAME: "Chandler's Ford",
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3809842,
        LOCATION_LATITUDE_DEG: 50.9847348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005700',
        LOCATION_NAME: 'Chantmarle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5849608,
        LOCATION_LATITUDE_DEG: 50.8177116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005800',
        LOCATION_NAME: 'Chantry',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.400888,
        LOCATION_LATITUDE_DEG: 51.2219463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006000',
        LOCATION_NAME: 'Chapel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0376023,
        LOCATION_LATITUDE_DEG: 50.4043952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH005900',
        LOCATION_NAME: 'Chapel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3659323,
        LOCATION_LATITUDE_DEG: 50.6320092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006100',
        LOCATION_NAME: 'Chapel',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2031241,
        LOCATION_LATITUDE_DEG: 56.1340324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006300',
        LOCATION_NAME: 'Chapel Allerton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8447353,
        LOCATION_LATITUDE_DEG: 51.2480565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH056700',
        LOCATION_NAME: 'Chapel Allerton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5385114,
        LOCATION_LATITUDE_DEG: 53.8278597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006400',
        LOCATION_NAME: 'Chapel Amble',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8276368,
        LOCATION_LATITUDE_DEG: 50.5442029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006500',
        LOCATION_NAME: 'Chapel Brampton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9298974,
        LOCATION_LATITUDE_DEG: 52.2896265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006600',
        LOCATION_NAME: 'Chapel Chorlton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2788468,
        LOCATION_LATITUDE_DEG: 52.9368098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006700',
        LOCATION_NAME: 'Chapel Cleeve',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3779311,
        LOCATION_LATITUDE_DEG: 51.1771524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006800',
        LOCATION_NAME: 'Chapel Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2997774,
        LOCATION_LATITUDE_DEG: 50.9610867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054000',
        LOCATION_NAME: 'Chapel en le Frith',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006900',
        LOCATION_NAME: 'Chapel Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8241014,
        LOCATION_LATITUDE_DEG: 51.3998451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007000',
        LOCATION_NAME: 'Chapel Haddlesey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1164074,
        LOCATION_LATITUDE_DEG: 53.72777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007100',
        LOCATION_NAME: 'Chapel Hill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9513908,
        LOCATION_LATITUDE_DEG: 51.6450127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007200',
        LOCATION_NAME: 'Chapel Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1997342,
        LOCATION_LATITUDE_DEG: 53.0738984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007300',
        LOCATION_NAME: 'Chapel House',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8003608,
        LOCATION_LATITUDE_DEG: 53.5530774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007400',
        LOCATION_NAME: 'Chapel Lawn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0052366,
        LOCATION_LATITUDE_DEG: 52.3804629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008100',
        LOCATION_NAME: 'Chapel le Dale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4000145,
        LOCATION_LATITUDE_DEG: 54.1894288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054100',
        LOCATION_NAME: 'Chapel of Ease',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1887776,
        LOCATION_LATITUDE_DEG: 51.5044657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008200',
        LOCATION_NAME: 'Chapel of Garioch',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4698864,
        LOCATION_LATITUDE_DEG: 57.307337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007500',
        LOCATION_NAME: 'Chapel Of Stoneywood',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.220935,
        LOCATION_LATITUDE_DEG: 57.1915255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007600',
        LOCATION_NAME: 'Chapel Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7085374,
        LOCATION_LATITUDE_DEG: 55.001299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007700',
        LOCATION_NAME: 'Chapel Row',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1782141,
        LOCATION_LATITUDE_DEG: 51.4210467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053900',
        LOCATION_NAME: 'Chapel St Leonards',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007800',
        LOCATION_NAME: 'Chapel St. Leonards',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3381818,
        LOCATION_LATITUDE_DEG: 53.2228019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH007900',
        LOCATION_NAME: 'Chapel Stile',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0465111,
        LOCATION_LATITUDE_DEG: 54.4388673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008000',
        LOCATION_NAME: 'Chapel Town',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9793749,
        LOCATION_LATITUDE_DEG: 50.362791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008300',
        LOCATION_NAME: 'Chapel-en-le-Frith',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9064256,
        LOCATION_LATITUDE_DEG: 53.324642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008500',
        LOCATION_NAME: 'Chapelgate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0937639,
        LOCATION_LATITUDE_DEG: 52.7983649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008600',
        LOCATION_NAME: 'Chapelhall',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9473536,
        LOCATION_LATITUDE_DEG: 55.8435141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008700',
        LOCATION_NAME: 'Chapelhill',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6076705,
        LOCATION_LATITUDE_DEG: 56.4538673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008800',
        LOCATION_NAME: 'Chapelknowe',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0769511,
        LOCATION_LATITUDE_DEG: 55.0507272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008400',
        LOCATION_NAME: 'Chapel-of-Ease',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1306875,
        LOCATION_LATITUDE_DEG: 51.6537987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009000',
        LOCATION_NAME: 'Chapels',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1699891,
        LOCATION_LATITUDE_DEG: 54.2456441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009100',
        LOCATION_NAME: 'Chapelthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5191865,
        LOCATION_LATITUDE_DEG: 53.6389656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH990560',
        LOCATION_NAME: 'Chapelton',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009400',
        LOCATION_NAME: 'Chapelton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0972372,
        LOCATION_LATITUDE_DEG: 55.7109984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009300',
        LOCATION_NAME: 'Chapelton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0254408,
        LOCATION_LATITUDE_DEG: 51.0175445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009200',
        LOCATION_NAME: 'Chapelton',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6110838,
        LOCATION_LATITUDE_DEG: 56.6206696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009600',
        LOCATION_NAME: 'Chapeltown',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2578355,
        LOCATION_LATITUDE_DEG: 57.2742433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH056600',
        LOCATION_NAME: 'Chapeltown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5310503,
        LOCATION_LATITUDE_DEG: 53.817017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009500',
        LOCATION_NAME: 'Chapeltown',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4676023,
        LOCATION_LATITUDE_DEG: 53.463551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009700',
        LOCATION_NAME: 'Chapmans Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0469629,
        LOCATION_LATITUDE_DEG: 52.3987542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009800',
        LOCATION_NAME: 'Chapmans Well',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3283483,
        LOCATION_LATITUDE_DEG: 50.7154149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH009900',
        LOCATION_NAME: 'Chapmanslade',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.245629,
        LOCATION_LATITUDE_DEG: 51.2291468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010000',
        LOCATION_NAME: 'Chapmore End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0745361,
        LOCATION_LATITUDE_DEG: 51.8281781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010100',
        LOCATION_NAME: 'Chappel',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.755365,
        LOCATION_LATITUDE_DEG: 51.9208736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010200',
        LOCATION_NAME: 'Charborough Park',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.107037,
        LOCATION_LATITUDE_DEG: 50.7830016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010300',
        LOCATION_NAME: 'Charcott',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1809059,
        LOCATION_LATITUDE_DEG: 51.2021092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010400',
        LOCATION_NAME: 'Chard',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9592044,
        LOCATION_LATITUDE_DEG: 50.8733169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010500',
        LOCATION_NAME: 'Chard Common',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9278945,
        LOCATION_LATITUDE_DEG: 50.850618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010600',
        LOCATION_NAME: 'Chard Junction',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9335533,
        LOCATION_LATITUDE_DEG: 50.8380176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010700',
        LOCATION_NAME: 'Chardstock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9780483,
        LOCATION_LATITUDE_DEG: 50.8337138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010800',
        LOCATION_NAME: 'Charfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4054889,
        LOCATION_LATITUDE_DEG: 51.6270863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH010900',
        LOCATION_NAME: 'Charing',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7964556,
        LOCATION_LATITUDE_DEG: 51.2104002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055500',
        LOCATION_NAME: 'Charing Cross',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1246241,
        LOCATION_LATITUDE_DEG: 51.5092199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011000',
        LOCATION_NAME: 'Charing Heath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7600384,
        LOCATION_LATITUDE_DEG: 51.2085038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011100',
        LOCATION_NAME: 'Charingworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7078676,
        LOCATION_LATITUDE_DEG: 52.0539142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011200',
        LOCATION_NAME: 'Charisworth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1958772,
        LOCATION_LATITUDE_DEG: 50.8146067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011300',
        LOCATION_NAME: 'Charlbury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4809607,
        LOCATION_LATITUDE_DEG: 51.8723964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011400',
        LOCATION_NAME: 'Charlcombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3503584,
        LOCATION_LATITUDE_DEG: 51.402163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011500',
        LOCATION_NAME: 'Charlcot',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6785071,
        LOCATION_LATITUDE_DEG: 54.260232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011600',
        LOCATION_NAME: 'Charlcutt',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0187934,
        LOCATION_LATITUDE_DEG: 51.478169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011700',
        LOCATION_NAME: 'Charlecote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6133635,
        LOCATION_LATITUDE_DEG: 52.2080277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011900',
        LOCATION_NAME: 'Charlemont',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6822716,
        LOCATION_LATITUDE_DEG: 54.4498986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH011800',
        LOCATION_NAME: 'Charlemont',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9755334,
        LOCATION_LATITUDE_DEG: 52.5452068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012000',
        LOCATION_NAME: 'Charles Tye',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9559905,
        LOCATION_LATITUDE_DEG: 52.1309917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012100',
        LOCATION_NAME: 'Charlesfield',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6574143,
        LOCATION_LATITUDE_DEG: 55.5559706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012200',
        LOCATION_NAME: 'Charleston',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2632953,
        LOCATION_LATITUDE_DEG: 57.5040835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012300',
        LOCATION_NAME: 'Charleston',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0070296,
        LOCATION_LATITUDE_DEG: 56.5990734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012700',
        LOCATION_NAME: 'Charlestown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7606955,
        LOCATION_LATITUDE_DEG: 50.3349865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012400',
        LOCATION_NAME: 'Charlestown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4998512,
        LOCATION_LATITUDE_DEG: 56.037827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012600',
        LOCATION_NAME: 'Charlestown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4925761,
        LOCATION_LATITUDE_DEG: 50.6118928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012900',
        LOCATION_NAME: 'Charlestown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0399657,
        LOCATION_LATITUDE_DEG: 53.7364862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012800',
        LOCATION_NAME: 'Charlestown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7595991,
        LOCATION_LATITUDE_DEG: 53.8452889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013000',
        LOCATION_NAME: 'Charlesworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9919013,
        LOCATION_LATITUDE_DEG: 53.4326531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013200',
        LOCATION_NAME: 'Charlottetown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.141241,
        LOCATION_LATITUDE_DEG: 56.2830432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013400',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5975055,
        LOCATION_LATITUDE_DEG: 52.6968888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013900',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2982855,
        LOCATION_LATITUDE_DEG: 55.1579284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013700',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1395528,
        LOCATION_LATITUDE_DEG: 51.0020206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013500',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0545078,
        LOCATION_LATITUDE_DEG: 51.5986746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014200',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9862437,
        LOCATION_LATITUDE_DEG: 52.1085219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013300',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8322584,
        LOCATION_LATITUDE_DEG: 51.3006428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013800',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4977021,
        LOCATION_LATITUDE_DEG: 51.2208356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055175',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4115779,
        LOCATION_LATITUDE_DEG: 51.5938134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055150',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4097622,
        LOCATION_LATITUDE_DEG: 51.5924285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013600',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2302057,
        LOCATION_LATITUDE_DEG: 52.019814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014100',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.736181,
        LOCATION_LATITUDE_DEG: 50.9084961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014000',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2861973,
        LOCATION_LATITUDE_DEG: 51.9377853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055100',
        LOCATION_NAME: 'Charlton',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0362194,
        LOCATION_LATITUDE_DEG: 51.4839448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014300',
        LOCATION_NAME: 'Charlton Abbotts',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9555801,
        LOCATION_LATITUDE_DEG: 51.9139064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014400',
        LOCATION_NAME: 'Charlton Adam',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.659973,
        LOCATION_LATITUDE_DEG: 51.0566284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014500',
        LOCATION_NAME: 'Charlton All Saints',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7474929,
        LOCATION_LATITUDE_DEG: 51.0147185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014650',
        LOCATION_NAME: 'Charlton Down',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.458956,
        LOCATION_LATITUDE_DEG: 50.753404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014600',
        LOCATION_NAME: 'Charlton Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4992482,
        LOCATION_LATITUDE_DEG: 51.2446376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014700',
        LOCATION_NAME: 'Charlton Horethorne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4771346,
        LOCATION_LATITUDE_DEG: 51.0070294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014800',
        LOCATION_NAME: 'Charlton Kings',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0400198,
        LOCATION_LATITUDE_DEG: 51.8875078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH014900',
        LOCATION_NAME: 'Charlton Mackrell',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6691317,
        LOCATION_LATITUDE_DEG: 51.0574307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015000',
        LOCATION_NAME: 'Charlton Marshall',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1374005,
        LOCATION_LATITUDE_DEG: 50.8329021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015100',
        LOCATION_NAME: 'Charlton Musgrove',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3826631,
        LOCATION_LATITUDE_DEG: 51.0843322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015200',
        LOCATION_NAME: 'Charlton on Otmoor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1822652,
        LOCATION_LATITUDE_DEG: 51.8391911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015300',
        LOCATION_NAME: 'Charltons',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9987411,
        LOCATION_LATITUDE_DEG: 54.530771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015400',
        LOCATION_NAME: 'Charlwood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2242174,
        LOCATION_LATITUDE_DEG: 51.1558157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015500',
        LOCATION_NAME: 'Charlynch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0885168,
        LOCATION_LATITUDE_DEG: 51.1317471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015600',
        LOCATION_NAME: 'Charminster',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4516442,
        LOCATION_LATITUDE_DEG: 50.7317037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015650',
        LOCATION_NAME: 'Charminster',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8439844,
        LOCATION_LATITUDE_DEG: 50.75092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015700',
        LOCATION_NAME: 'Charmouth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8976701,
        LOCATION_LATITUDE_DEG: 50.7370017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015800',
        LOCATION_NAME: 'Charmy Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3525233,
        LOCATION_LATITUDE_DEG: 51.4275608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH015900',
        LOCATION_NAME: 'Charndon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0225242,
        LOCATION_LATITUDE_DEG: 51.9176972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016000',
        LOCATION_NAME: 'Charney Bassett',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4516243,
        LOCATION_LATITUDE_DEG: 51.6480787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016100',
        LOCATION_NAME: 'Charnock Richard',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6657001,
        LOCATION_LATITUDE_DEG: 53.6336845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016200',
        LOCATION_NAME: 'Charsfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2957246,
        LOCATION_LATITUDE_DEG: 52.1596857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016300',
        LOCATION_NAME: 'Chart Sutton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5726421,
        LOCATION_LATITUDE_DEG: 51.2218073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016400',
        LOCATION_NAME: 'Charter Alley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1432061,
        LOCATION_LATITUDE_DEG: 51.3147424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016500',
        LOCATION_NAME: 'Charterhouse',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7204212,
        LOCATION_LATITUDE_DEG: 51.2980524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016600',
        LOCATION_NAME: 'Chartershall',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9425948,
        LOCATION_LATITUDE_DEG: 56.0894395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016700',
        LOCATION_NAME: 'Chartham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0228755,
        LOCATION_LATITUDE_DEG: 51.2532072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016800',
        LOCATION_NAME: 'Chartham Hatch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0171175,
        LOCATION_LATITUDE_DEG: 51.2699077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH016900',
        LOCATION_NAME: 'Chartley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9836481,
        LOCATION_LATITUDE_DEG: 52.852896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017000',
        LOCATION_NAME: 'Chartridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6451682,
        LOCATION_LATITUDE_DEG: 51.7224697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017100',
        LOCATION_NAME: 'Charvil',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.883729,
        LOCATION_LATITUDE_DEG: 51.4757534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017200',
        LOCATION_NAME: 'Charwelton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2212076,
        LOCATION_LATITUDE_DEG: 52.197828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017300',
        LOCATION_NAME: 'Chase Terrace',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9324215,
        LOCATION_LATITUDE_DEG: 52.6822818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH056000',
        LOCATION_NAME: 'Chasegate',
        COUNTY_NAME: 'London',
        POSTCODE: 'N14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1290868,
        LOCATION_LATITUDE_DEG: 51.6411356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017400',
        LOCATION_NAME: 'Chasetown',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9232194,
        LOCATION_LATITUDE_DEG: 52.6739778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017500',
        LOCATION_NAME: 'Chastleton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6397827,
        LOCATION_LATITUDE_DEG: 51.95951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017600',
        LOCATION_NAME: 'Chatburn',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3511256,
        LOCATION_LATITUDE_DEG: 53.8927024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017700',
        LOCATION_NAME: 'Chatcull',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3053803,
        LOCATION_LATITUDE_DEG: 52.907409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017800',
        LOCATION_NAME: 'Chatham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5294804,
        LOCATION_LATITUDE_DEG: 51.3806241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH017900',
        LOCATION_NAME: 'Chathill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7048873,
        LOCATION_LATITUDE_DEG: 55.5351549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018000',
        LOCATION_NAME: 'Chatley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2174395,
        LOCATION_LATITUDE_DEG: 52.2488411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018100',
        LOCATION_NAME: 'Chatsworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6085597,
        LOCATION_LATITUDE_DEG: 53.2272248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018200',
        LOCATION_NAME: 'Chattenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5312611,
        LOCATION_LATITUDE_DEG: 51.4178232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018300',
        LOCATION_NAME: 'Chatteris',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0516183,
        LOCATION_LATITUDE_DEG: 52.4541297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018400',
        LOCATION_NAME: 'Chatterley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2291119,
        LOCATION_LATITUDE_DEG: 53.0571156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018500',
        LOCATION_NAME: 'Chattis Hill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5306593,
        LOCATION_LATITUDE_DEG: 51.1146292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018600',
        LOCATION_NAME: 'Chattisham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0504388,
        LOCATION_LATITUDE_DEG: 52.0381783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018700',
        LOCATION_NAME: 'Chatton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9151344,
        LOCATION_LATITUDE_DEG: 55.5477563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018800',
        LOCATION_NAME: 'Chatwall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7166004,
        LOCATION_LATITUDE_DEG: 52.5724772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH018900',
        LOCATION_NAME: 'Chavel',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8558378,
        LOCATION_LATITUDE_DEG: 52.7126938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019000',
        LOCATION_NAME: 'Chavenage',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1963967,
        LOCATION_LATITUDE_DEG: 51.6577824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019100',
        LOCATION_NAME: 'Chavey Down',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7061634,
        LOCATION_LATITUDE_DEG: 51.4177397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019200',
        LOCATION_NAME: 'Chawleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8317705,
        LOCATION_LATITUDE_DEG: 50.896333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019300',
        LOCATION_NAME: 'Chawston',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3131526,
        LOCATION_LATITUDE_DEG: 52.1911093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019400',
        LOCATION_NAME: 'Chawton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9891273,
        LOCATION_LATITUDE_DEG: 51.129719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019500',
        LOCATION_NAME: 'Chaxhill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3691969,
        LOCATION_LATITUDE_DEG: 51.8281997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019600',
        LOCATION_NAME: 'Chazey Heath',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9952941,
        LOCATION_LATITUDE_DEG: 51.4966545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019800',
        LOCATION_NAME: 'Cheadle',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2024391,
        LOCATION_LATITUDE_DEG: 53.3954536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019700',
        LOCATION_NAME: 'Cheadle',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9859212,
        LOCATION_LATITUDE_DEG: 52.988111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH990892',
        LOCATION_NAME: 'Cheadle Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH019900',
        LOCATION_NAME: 'Cheadle Hulme',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1914064,
        LOCATION_LATITUDE_DEG: 53.3768542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020000',
        LOCATION_NAME: 'Cheam',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2147434,
        LOCATION_LATITUDE_DEG: 51.357232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020100',
        LOCATION_NAME: 'Chearsley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9601405,
        LOCATION_LATITUDE_DEG: 51.7897865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020200',
        LOCATION_NAME: 'Chebbard',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3348417,
        LOCATION_LATITUDE_DEG: 50.782705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020300',
        LOCATION_NAME: 'Chebsey',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2084163,
        LOCATION_LATITUDE_DEG: 52.8561036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020400',
        LOCATION_NAME: 'Checkendon',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0429205,
        LOCATION_LATITUDE_DEG: 51.541558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020600',
        LOCATION_NAME: 'Checkley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5910246,
        LOCATION_LATITUDE_DEG: 52.043227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020500',
        LOCATION_NAME: 'Checkley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3984275,
        LOCATION_LATITUDE_DEG: 53.0113135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020700',
        LOCATION_NAME: 'Checkley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9564427,
        LOCATION_LATITUDE_DEG: 52.9387023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020800',
        LOCATION_NAME: 'Chedburgh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6185818,
        LOCATION_LATITUDE_DEG: 52.1890944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH020900',
        LOCATION_NAME: 'Cheddar',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7846734,
        LOCATION_LATITUDE_DEG: 51.2804539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021000',
        LOCATION_NAME: 'Cheddington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6624653,
        LOCATION_LATITUDE_DEG: 51.84718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021100',
        LOCATION_NAME: 'Cheddleton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0417588,
        LOCATION_LATITUDE_DEG: 53.064521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021200',
        LOCATION_NAME: 'Cheddon Fitzpaine',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0781238,
        LOCATION_LATITUDE_DEG: 51.0432397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021300',
        LOCATION_NAME: 'Chedglow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.08046,
        LOCATION_LATITUDE_DEG: 51.6341794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021400',
        LOCATION_NAME: 'Chedgrave',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4857212,
        LOCATION_LATITUDE_DEG: 52.5411207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021500',
        LOCATION_NAME: 'Chedington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7261032,
        LOCATION_LATITUDE_DEG: 50.8466158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021600',
        LOCATION_NAME: 'Chediston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4635285,
        LOCATION_LATITUDE_DEG: 52.3476006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021700',
        LOCATION_NAME: 'Chedworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9161044,
        LOCATION_LATITUDE_DEG: 51.7964948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021800',
        LOCATION_NAME: 'Chedzoy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9436372,
        LOCATION_LATITUDE_DEG: 51.1324393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022000',
        LOCATION_NAME: 'Cheesden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2744614,
        LOCATION_LATITUDE_DEG: 53.6467899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022100',
        LOCATION_NAME: 'Cheesebay',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0992294,
        LOCATION_LATITUDE_DEG: 57.643818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022200',
        LOCATION_NAME: 'Cheeseburn Grange',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8529536,
        LOCATION_LATITUDE_DEG: 55.0360072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054900',
        LOCATION_NAME: 'Cheetham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054800',
        LOCATION_NAME: 'Cheetham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054400',
        LOCATION_NAME: 'Cheetham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2363986,
        LOCATION_LATITUDE_DEG: 53.5010635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054500',
        LOCATION_NAME: 'Cheetham Hill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2362325,
        LOCATION_LATITUDE_DEG: 53.5010189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022300',
        LOCATION_NAME: 'Cheldon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7984782,
        LOCATION_LATITUDE_DEG: 50.9067266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022400',
        LOCATION_NAME: 'Chelfham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.981587,
        LOCATION_LATITUDE_DEG: 51.1036527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022500',
        LOCATION_NAME: 'Chelford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2879558,
        LOCATION_LATITUDE_DEG: 53.2726399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022600',
        LOCATION_NAME: 'Chellaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4367975,
        LOCATION_LATITUDE_DEG: 52.8680951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022700',
        LOCATION_NAME: 'Chellington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5997558,
        LOCATION_LATITUDE_DEG: 52.1916129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH056500',
        LOCATION_NAME: 'Chellow Grange',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8086269,
        LOCATION_LATITUDE_DEG: 53.8074975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH056400',
        LOCATION_NAME: 'Chellowdean',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8069105,
        LOCATION_LATITUDE_DEG: 53.8075397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022800',
        LOCATION_NAME: 'Chelmarsh',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4130613,
        LOCATION_LATITUDE_DEG: 52.489167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH022900',
        LOCATION_NAME: 'Chelmick',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7841633,
        LOCATION_LATITUDE_DEG: 52.5172751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023000',
        LOCATION_NAME: 'Chelmondiston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2132066,
        LOCATION_LATITUDE_DEG: 51.9888723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023100',
        LOCATION_NAME: 'Chelmorton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8283124,
        LOCATION_LATITUDE_DEG: 53.2284271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023200',
        LOCATION_NAME: 'Chelmscote',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7155229,
        LOCATION_LATITUDE_DEG: 51.9382893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023300',
        LOCATION_NAME: 'Chelmsford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4761747,
        LOCATION_LATITUDE_DEG: 51.7320561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023400',
        LOCATION_NAME: 'Chelmsley Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7244286,
        LOCATION_LATITUDE_DEG: 52.4830576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055200',
        LOCATION_NAME: 'Chelsea',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1799071,
        LOCATION_LATITUDE_DEG: 51.4821841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023500',
        LOCATION_NAME: 'Chelsfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1084348,
        LOCATION_LATITUDE_DEG: 51.3568245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023600',
        LOCATION_NAME: 'Chelsham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0151064,
        LOCATION_LATITUDE_DEG: 51.3162263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023700',
        LOCATION_NAME: 'Chelston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5462584,
        LOCATION_LATITUDE_DEG: 50.4659897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023800',
        LOCATION_NAME: 'Chelston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2093249,
        LOCATION_LATITUDE_DEG: 50.9821297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH023900',
        LOCATION_NAME: 'Chelsworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8941524,
        LOCATION_LATITUDE_DEG: 52.0946873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024000',
        LOCATION_NAME: 'Cheltenham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0725326,
        LOCATION_LATITUDE_DEG: 51.9001079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024100',
        LOCATION_NAME: 'Chelveston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5458295,
        LOCATION_LATITUDE_DEG: 52.3146286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024200',
        LOCATION_NAME: 'Chelvey',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7697836,
        LOCATION_LATITUDE_DEG: 51.4112648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024300',
        LOCATION_NAME: 'Chelwood',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5262371,
        LOCATION_LATITUDE_DEG: 51.3546619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024400',
        LOCATION_NAME: 'Chelwood Gate',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0244037,
        LOCATION_LATITUDE_DEG: 51.0483952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024500',
        LOCATION_NAME: 'Chelworth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0391279,
        LOCATION_LATITUDE_DEG: 51.6464839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024600',
        LOCATION_NAME: 'Chelynch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5009421,
        LOCATION_LATITUDE_DEG: 51.1922435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024700',
        LOCATION_NAME: 'Cheney Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3914881,
        LOCATION_LATITUDE_DEG: 52.7744925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024800',
        LOCATION_NAME: 'Cheney Longville',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8524237,
        LOCATION_LATITUDE_DEG: 52.4588725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH024900',
        LOCATION_NAME: 'Chenies',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5282885,
        LOCATION_LATITUDE_DEG: 51.6738691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025000',
        LOCATION_NAME: 'Chenson',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8425754,
        LOCATION_LATITUDE_DEG: 50.8717252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025100',
        LOCATION_NAME: 'Chepstow',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6767038,
        LOCATION_LATITUDE_DEG: 51.6390914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025200',
        LOCATION_NAME: 'Chequerbent',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4893636,
        LOCATION_LATITUDE_DEG: 53.5516707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025300',
        LOCATION_NAME: 'Chequers',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.15831,
        LOCATION_LATITUDE_DEG: 51.4445663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025400',
        LOCATION_NAME: 'Cherhill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.949491,
        LOCATION_LATITUDE_DEG: 51.4299594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025500',
        LOCATION_NAME: 'Cherington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1366265,
        LOCATION_LATITUDE_DEG: 51.6862826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025600',
        LOCATION_NAME: 'Cherington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5747351,
        LOCATION_LATITUDE_DEG: 52.0258144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025700',
        LOCATION_NAME: 'Cheriton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2391858,
        LOCATION_LATITUDE_DEG: 51.6146048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025800',
        LOCATION_NAME: 'Cheriton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1683696,
        LOCATION_LATITUDE_DEG: 51.0519177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH025900',
        LOCATION_NAME: 'Cheriton Bishop',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7339066,
        LOCATION_LATITUDE_DEG: 50.7215108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026000',
        LOCATION_NAME: 'Cheriton Fitzpaine',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6015229,
        LOCATION_LATITUDE_DEG: 50.8431191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026100',
        LOCATION_NAME: 'Cherrington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4949716,
        LOCATION_LATITUDE_DEG: 52.7760928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026200',
        LOCATION_NAME: 'Cherry Burton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4920245,
        LOCATION_LATITUDE_DEG: 53.8656747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026300',
        LOCATION_NAME: 'Cherry Hinton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1731491,
        LOCATION_LATITUDE_DEG: 52.1835028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026400',
        LOCATION_NAME: 'Cherry Orchard',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2263293,
        LOCATION_LATITUDE_DEG: 50.9997264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026500',
        LOCATION_NAME: 'Cherry Tree',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5182157,
        LOCATION_LATITUDE_DEG: 53.7309858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026600',
        LOCATION_NAME: 'Cherry Willingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4542848,
        LOCATION_LATITUDE_DEG: 53.2387114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054600',
        LOCATION_NAME: 'Cherryvalley',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8490978,
        LOCATION_LATITUDE_DEG: 54.5888486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026800',
        LOCATION_NAME: 'Chertsey',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5061674,
        LOCATION_LATITUDE_DEG: 51.3877336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026900',
        LOCATION_NAME: 'Cheselbourne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.336597,
        LOCATION_LATITUDE_DEG: 50.7960016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027000',
        LOCATION_NAME: 'Chesham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6124128,
        LOCATION_LATITUDE_DEG: 51.7031666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027100',
        LOCATION_NAME: 'Chesham Bois',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6106744,
        LOCATION_LATITUDE_DEG: 51.6833708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027200',
        LOCATION_NAME: 'Cheshunt',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0328756,
        LOCATION_LATITUDE_DEG: 51.7022653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027300',
        LOCATION_NAME: 'Chesil',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4472882,
        LOCATION_LATITUDE_DEG: 50.5597845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027400',
        LOCATION_NAME: 'Cheslyn Hay',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0348218,
        LOCATION_LATITUDE_DEG: 52.659981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027500',
        LOCATION_NAME: 'Chessell',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.432482,
        LOCATION_LATITUDE_DEG: 50.676281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027600',
        LOCATION_NAME: 'Chessington',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2981266,
        LOCATION_LATITUDE_DEG: 51.3631319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027700',
        LOCATION_NAME: 'Chester',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.890827,
        LOCATION_LATITUDE_DEG: 53.1918412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027800',
        LOCATION_NAME: 'Chester Le Street',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5727527,
        LOCATION_LATITUDE_DEG: 54.859589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH027900',
        LOCATION_NAME: 'Chester Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5912586,
        LOCATION_LATITUDE_DEG: 54.8367884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028000',
        LOCATION_NAME: 'Chesterblade',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4844109,
        LOCATION_LATITUDE_DEG: 51.1689402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028100',
        LOCATION_NAME: 'Chesterfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4271397,
        LOCATION_LATITUDE_DEG: 53.2349236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028200',
        LOCATION_NAME: 'Chesters',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5900069,
        LOCATION_LATITUDE_DEG: 55.387948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028800',
        LOCATION_NAME: 'Chesterton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3163111,
        LOCATION_LATITUDE_DEG: 52.5719753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028700',
        LOCATION_NAME: 'Chesterton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2522032,
        LOCATION_LATITUDE_DEG: 53.0404192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028400',
        LOCATION_NAME: 'Chesterton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4863786,
        LOCATION_LATITUDE_DEG: 52.2235302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028300',
        LOCATION_NAME: 'Chesterton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1841735,
        LOCATION_LATITUDE_DEG: 51.8869977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028500',
        LOCATION_NAME: 'Chesterton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3396911,
        LOCATION_LATITUDE_DEG: 52.544544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028600',
        LOCATION_NAME: 'Chesterton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1421441,
        LOCATION_LATITUDE_DEG: 52.2242057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH028900',
        LOCATION_NAME: 'Chesterwood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2657024,
        LOCATION_LATITUDE_DEG: 54.980903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029000',
        LOCATION_NAME: 'Chestfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0670379,
        LOCATION_LATITUDE_DEG: 51.3566135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029100',
        LOCATION_NAME: 'Cheswardine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4166187,
        LOCATION_LATITUDE_DEG: 52.864699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029200',
        LOCATION_NAME: 'Cheswell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4173749,
        LOCATION_LATITUDE_DEG: 52.7498957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029300',
        LOCATION_NAME: 'Cheswick Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B90',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8124791,
        LOCATION_LATITUDE_DEG: 52.3761459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029400',
        LOCATION_NAME: 'Chetnole',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5651615,
        LOCATION_LATITUDE_DEG: 50.8699182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029500',
        LOCATION_NAME: 'Chettiscombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4722215,
        LOCATION_LATITUDE_DEG: 50.9220272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029600',
        LOCATION_NAME: 'Chettisham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2773669,
        LOCATION_LATITUDE_DEG: 52.4222268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029700',
        LOCATION_NAME: 'Chettle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0557376,
        LOCATION_LATITUDE_DEG: 50.9133084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029800',
        LOCATION_NAME: 'Chetton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4853861,
        LOCATION_LATITUDE_DEG: 52.5096708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH029900',
        LOCATION_NAME: 'Chetwode',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0654038,
        LOCATION_LATITUDE_DEG: 51.9605962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030000',
        LOCATION_NAME: 'Chetwynd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4223769,
        LOCATION_LATITUDE_DEG: 52.7890952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030100',
        LOCATION_NAME: 'Chetwynd Aston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3661496,
        LOCATION_LATITUDE_DEG: 52.754794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030200',
        LOCATION_NAME: 'Cheveley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4659768,
        LOCATION_LATITUDE_DEG: 52.2201023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030300',
        LOCATION_NAME: 'Chevening',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1411011,
        LOCATION_LATITUDE_DEG: 51.2924184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030400',
        LOCATION_NAME: 'Chevinedge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8501003,
        LOCATION_LATITUDE_DEG: 53.6974761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030500',
        LOCATION_NAME: 'Chevington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6142357,
        LOCATION_LATITUDE_DEG: 52.206297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030600',
        LOCATION_NAME: 'Chevithorne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4567561,
        LOCATION_LATITUDE_DEG: 50.9289307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030700',
        LOCATION_NAME: 'Chew Magna',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6094948,
        LOCATION_LATITUDE_DEG: 51.3653645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030800',
        LOCATION_NAME: 'Chew Stoke',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6321691,
        LOCATION_LATITUDE_DEG: 51.3521597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH030900',
        LOCATION_NAME: 'Chewton Keynsham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.500142,
        LOCATION_LATITUDE_DEG: 51.3956663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031000',
        LOCATION_NAME: 'Chewton Mendip',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5733533,
        LOCATION_LATITUDE_DEG: 51.2746558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031100',
        LOCATION_NAME: 'Chichacott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9793967,
        LOCATION_LATITUDE_DEG: 50.7502154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031200',
        LOCATION_NAME: 'Chicheley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6810616,
        LOCATION_LATITUDE_DEG: 52.1046072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031300',
        LOCATION_NAME: 'Chichester',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7777557,
        LOCATION_LATITUDE_DEG: 50.8407921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031400',
        LOCATION_NAME: 'Chickenley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5961212,
        LOCATION_LATITUDE_DEG: 53.6895718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031500',
        LOCATION_NAME: 'Chickerell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5031382,
        LOCATION_LATITUDE_DEG: 50.6227933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031600',
        LOCATION_NAME: 'Chicklade',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1287465,
        LOCATION_LATITUDE_DEG: 51.1092319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031700',
        LOCATION_NAME: 'Chicksands',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.360262,
        LOCATION_LATITUDE_DEG: 52.0415993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031800',
        LOCATION_NAME: 'Chicksgrove',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0399522,
        LOCATION_LATITUDE_DEG: 51.0690247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH031900',
        LOCATION_NAME: 'Chickward',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0464282,
        LOCATION_LATITUDE_DEG: 52.1728469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032000',
        LOCATION_NAME: 'Chidden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0613503,
        LOCATION_LATITUDE_DEG: 50.9553083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032100',
        LOCATION_NAME: 'Chiddingfold',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6280508,
        LOCATION_LATITUDE_DEG: 51.1091142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032200',
        LOCATION_NAME: 'Chiddingly',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1966144,
        LOCATION_LATITUDE_DEG: 50.9066853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032300',
        LOCATION_NAME: 'Chiddingstone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1500575,
        LOCATION_LATITUDE_DEG: 51.1856091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032400',
        LOCATION_NAME: 'Chiddingstone Causeway',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1781455,
        LOCATION_LATITUDE_DEG: 51.1973127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032500',
        LOCATION_NAME: 'Chiddingstone Hoath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1444026,
        LOCATION_LATITUDE_DEG: 51.1609065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032600',
        LOCATION_NAME: 'Chideock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8172176,
        LOCATION_LATITUDE_DEG: 50.7317023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032700',
        LOCATION_NAME: 'Chidham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8722548,
        LOCATION_LATITUDE_DEG: 50.8285856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032800',
        LOCATION_NAME: 'Chidlow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7437092,
        LOCATION_LATITUDE_DEG: 53.0012225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH032900',
        LOCATION_NAME: 'Chieveley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3146158,
        LOCATION_LATITUDE_DEG: 51.4611589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033000',
        LOCATION_NAME: 'Chignal Smealey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4174677,
        LOCATION_LATITUDE_DEG: 51.778159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053500',
        LOCATION_NAME: 'Chignal St James',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033100',
        LOCATION_NAME: 'Chignal St. James',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4131652,
        LOCATION_LATITUDE_DEG: 51.7597559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033200',
        LOCATION_NAME: 'Chigwell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0772596,
        LOCATION_LATITUDE_DEG: 51.6191476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033300',
        LOCATION_NAME: 'Chigwell Row',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1150989,
        LOCATION_LATITUDE_DEG: 51.6191553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033400',
        LOCATION_NAME: 'Chilbolton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4348327,
        LOCATION_LATITUDE_DEG: 51.1589283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033500',
        LOCATION_NAME: 'Chilbolton Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4140405,
        LOCATION_LATITUDE_DEG: 51.1271251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033600',
        LOCATION_NAME: 'Chilbridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0178039,
        LOCATION_LATITUDE_DEG: 50.8201029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033700',
        LOCATION_NAME: 'Chilcomb',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2764555,
        LOCATION_LATITUDE_DEG: 51.0519174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH033800',
        LOCATION_NAME: 'Chilcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6693636,
        LOCATION_LATITUDE_DEG: 50.7143963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034000',
        LOCATION_NAME: 'Chilcompton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5035398,
        LOCATION_LATITUDE_DEG: 51.2611547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034100',
        LOCATION_NAME: 'Chilcote',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5938547,
        LOCATION_LATITUDE_DEG: 51.2122501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034200',
        LOCATION_NAME: 'Chilcote',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5788428,
        LOCATION_LATITUDE_DEG: 52.6995794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034300',
        LOCATION_NAME: 'Child Okeford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2360048,
        LOCATION_LATITUDE_DEG: 50.9122108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034400',
        LOCATION_NAME: 'Childer Thornton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.951796,
        LOCATION_LATITUDE_DEG: 53.2924466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034500',
        LOCATION_NAME: 'Childhay',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8379892,
        LOCATION_LATITUDE_DEG: 50.831512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034600',
        LOCATION_NAME: 'Childrey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4781611,
        LOCATION_LATITUDE_DEG: 51.5840657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034700',
        LOCATION_NAME: 'Childs Ercall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4938092,
        LOCATION_LATITUDE_DEG: 52.8214014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034800',
        LOCATION_NAME: 'Childswickham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8912948,
        LOCATION_LATITUDE_DEG: 52.0478151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH034900',
        LOCATION_NAME: 'Childwall',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8807296,
        LOCATION_LATITUDE_DEG: 53.3949571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035000',
        LOCATION_NAME: 'Childwick Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3406841,
        LOCATION_LATITUDE_DEG: 51.782675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035100',
        LOCATION_NAME: 'Childwickbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.347152,
        LOCATION_LATITUDE_DEG: 51.7790701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035200',
        LOCATION_NAME: 'Chilfrome',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5849217,
        LOCATION_LATITUDE_DEG: 50.7873042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035300',
        LOCATION_NAME: 'Chilgrove',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8219487,
        LOCATION_LATITUDE_DEG: 50.9230007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035400',
        LOCATION_NAME: 'Chilham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9607297,
        LOCATION_LATITUDE_DEG: 51.2440022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035500',
        LOCATION_NAME: 'Chilla',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.194818,
        LOCATION_LATITUDE_DEG: 50.7940227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035600',
        LOCATION_NAME: 'Chillaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2155169,
        LOCATION_LATITUDE_DEG: 50.6148095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035700',
        LOCATION_NAME: 'Chillenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2529046,
        LOCATION_LATITUDE_DEG: 51.2354033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035800',
        LOCATION_NAME: 'Chillerton',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3079545,
        LOCATION_LATITUDE_DEG: 50.6519812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH035900',
        LOCATION_NAME: 'Chillesford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4860642,
        LOCATION_LATITUDE_DEG: 52.1163813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036000',
        LOCATION_NAME: 'Chillingham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9102655,
        LOCATION_LATITUDE_DEG: 55.5280546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036100',
        LOCATION_NAME: 'Chillington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6925788,
        LOCATION_LATITUDE_DEG: 50.2726661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036200',
        LOCATION_NAME: 'Chilmark',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0436878,
        LOCATION_LATITUDE_DEG: 51.0950316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036300',
        LOCATION_NAME: 'Chilson',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.536947,
        LOCATION_LATITUDE_DEG: 51.8723963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036400',
        LOCATION_NAME: 'Chilstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8777492,
        LOCATION_LATITUDE_DEG: 52.0503331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036600',
        LOCATION_NAME: 'Chilsworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3748493,
        LOCATION_LATITUDE_DEG: 50.8313327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036500',
        LOCATION_NAME: 'Chilsworthy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2230707,
        LOCATION_LATITUDE_DEG: 50.5251988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036700',
        LOCATION_NAME: 'Chilsworthy Beam',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2329916,
        LOCATION_LATITUDE_DEG: 50.5279054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036800',
        LOCATION_NAME: 'Chiltern Green',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3508002,
        LOCATION_LATITUDE_DEG: 51.8598775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH036900',
        LOCATION_NAME: 'Chilthorne Domer',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6744669,
        LOCATION_LATITUDE_DEG: 50.9698224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037300',
        LOCATION_NAME: 'Chilton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6173661,
        LOCATION_LATITUDE_DEG: 50.820217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037400',
        LOCATION_NAME: 'Chilton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5579299,
        LOCATION_LATITUDE_DEG: 54.6590661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037100',
        LOCATION_NAME: 'Chilton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5221719,
        LOCATION_LATITUDE_DEG: 51.4339514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037200',
        LOCATION_NAME: 'Chilton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2942132,
        LOCATION_LATITUDE_DEG: 51.5667643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037000',
        LOCATION_NAME: 'Chilton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0021398,
        LOCATION_LATITUDE_DEG: 51.7980817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037500',
        LOCATION_NAME: 'Chilton Candover',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1561443,
        LOCATION_LATITUDE_DEG: 51.1545249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037600',
        LOCATION_NAME: 'Chilton Cantelo',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6238615,
        LOCATION_LATITUDE_DEG: 50.9880276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037700',
        LOCATION_NAME: 'Chilton Foliat',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5380797,
        LOCATION_LATITUDE_DEG: 51.4315512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037800',
        LOCATION_NAME: 'Chilton Moor',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4987176,
        LOCATION_LATITUDE_DEG: 54.836882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH037900',
        LOCATION_NAME: 'Chilton Polden',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8901894,
        LOCATION_LATITUDE_DEG: 51.1545412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038000',
        LOCATION_NAME: 'Chilton Trinity',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0057959,
        LOCATION_LATITUDE_DEG: 51.1460408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038100',
        LOCATION_NAME: 'Chilwell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2422077,
        LOCATION_LATITUDE_DEG: 52.9151934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038200',
        LOCATION_NAME: 'Chilworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4208855,
        LOCATION_LATITUDE_DEG: 50.9670065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038300',
        LOCATION_NAME: 'Chilworth',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5310374,
        LOCATION_LATITUDE_DEG: 51.2146183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038400',
        LOCATION_NAME: 'Chilworthy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9658947,
        LOCATION_LATITUDE_DEG: 50.9047217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038500',
        LOCATION_NAME: 'Chimney',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4814982,
        LOCATION_LATITUDE_DEG: 51.7054775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038600',
        LOCATION_NAME: 'Chineham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0602022,
        LOCATION_LATITUDE_DEG: 51.2832325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055900',
        LOCATION_NAME: 'Chingford',
        COUNTY_NAME: 'London',
        POSTCODE: 'E4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 6.8213855,
        LOCATION_LATITUDE_DEG: 51.6325114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038700',
        LOCATION_NAME: 'Chinley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.938416,
        LOCATION_LATITUDE_DEG: 53.3398465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038800',
        LOCATION_NAME: 'Chinnor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9097956,
        LOCATION_LATITUDE_DEG: 51.7024718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH038900',
        LOCATION_NAME: 'Chipnall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4055693,
        LOCATION_LATITUDE_DEG: 52.8794007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039000',
        LOCATION_NAME: 'Chippenham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1181012,
        LOCATION_LATITUDE_DEG: 51.4606655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039100',
        LOCATION_NAME: 'Chippenham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4378986,
        LOCATION_LATITUDE_DEG: 52.3017073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039200',
        LOCATION_NAME: 'Chipperfield',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4892337,
        LOCATION_LATITUDE_DEG: 51.7034636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039400',
        LOCATION_NAME: 'Chipping',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5742442,
        LOCATION_LATITUDE_DEG: 53.8842019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039300',
        LOCATION_NAME: 'Chipping',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0263467,
        LOCATION_LATITUDE_DEG: 51.9694891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039500',
        LOCATION_NAME: 'Chipping Campden',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7769765,
        LOCATION_LATITUDE_DEG: 52.0504146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039600',
        LOCATION_NAME: 'Chipping Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6363324,
        LOCATION_LATITUDE_DEG: 51.8063621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039700',
        LOCATION_NAME: 'Chipping Norton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5446367,
        LOCATION_LATITUDE_DEG: 51.9409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039800',
        LOCATION_NAME: 'Chipping Ongar',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2461842,
        LOCATION_LATITUDE_DEG: 51.7088615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH039900',
        LOCATION_NAME: 'Chipping Sodbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3923801,
        LOCATION_LATITUDE_DEG: 51.5377731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040000',
        LOCATION_NAME: 'Chipping Warden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2705205,
        LOCATION_LATITUDE_DEG: 52.1352195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040100',
        LOCATION_NAME: 'Chippinghurst',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1333042,
        LOCATION_LATITUDE_DEG: 51.7058799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040200',
        LOCATION_NAME: 'Chipstable',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3629477,
        LOCATION_LATITUDE_DEG: 51.0352373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040300',
        LOCATION_NAME: 'Chipstead',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1705737,
        LOCATION_LATITUDE_DEG: 51.3092253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040400',
        LOCATION_NAME: 'Chipstead',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1642034,
        LOCATION_LATITUDE_DEG: 51.2898169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040500',
        LOCATION_NAME: 'Chirbury',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0899686,
        LOCATION_LATITUDE_DEG: 52.5774874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040600',
        LOCATION_NAME: 'Chirk',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0549184,
        LOCATION_LATITUDE_DEG: 52.9309172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040700',
        LOCATION_NAME: 'Chirk Bank',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0540134,
        LOCATION_LATITUDE_DEG: 52.9255128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040800',
        LOCATION_NAME: 'Chirnside',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2076743,
        LOCATION_LATITUDE_DEG: 55.8021901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041000',
        LOCATION_NAME: 'Chirton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8940959,
        LOCATION_LATITUDE_DEG: 51.3156521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH040900',
        LOCATION_NAME: 'Chirton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4683549,
        LOCATION_LATITUDE_DEG: 55.0083955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041100',
        LOCATION_NAME: 'Chisbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6014602,
        LOCATION_LATITUDE_DEG: 51.3942483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041200',
        LOCATION_NAME: 'Chiselborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7517794,
        LOCATION_LATITUDE_DEG: 50.9300218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041300',
        LOCATION_NAME: 'Chiseldon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7341631,
        LOCATION_LATITUDE_DEG: 51.5140641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041400',
        LOCATION_NAME: 'Chiselhampton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1419371,
        LOCATION_LATITUDE_DEG: 51.684874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041500',
        LOCATION_NAME: 'Chislehurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0706102,
        LOCATION_LATITUDE_DEG: 51.416329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041600',
        LOCATION_NAME: 'Chislet',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1924138,
        LOCATION_LATITUDE_DEG: 51.3358092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041700',
        LOCATION_NAME: 'Chiswell Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3582092,
        LOCATION_LATITUDE_DEG: 51.7268679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055400',
        LOCATION_NAME: 'Chiswick',
        COUNTY_NAME: 'London',
        POSTCODE: 'W4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2586869,
        LOCATION_LATITUDE_DEG: 51.4945324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041800',
        LOCATION_NAME: 'Chisworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0141627,
        LOCATION_LATITUDE_DEG: 53.4257485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH041900',
        LOCATION_NAME: 'Chithurst',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7987584,
        LOCATION_LATITUDE_DEG: 51.0007041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042000',
        LOCATION_NAME: 'Chittering',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1949664,
        LOCATION_LATITUDE_DEG: 52.3079128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042100',
        LOCATION_NAME: 'Chitterne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0117082,
        LOCATION_LATITUDE_DEG: 51.1970383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042200',
        LOCATION_NAME: 'Chittlehamholt',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9214675,
        LOCATION_LATITUDE_DEG: 50.9732411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042300',
        LOCATION_NAME: 'Chittlehampton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9421522,
        LOCATION_LATITUDE_DEG: 51.0121413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042400',
        LOCATION_NAME: 'Chittoe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0647792,
        LOCATION_LATITUDE_DEG: 51.3990627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042500',
        LOCATION_NAME: 'Chivelstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.706384,
        LOCATION_LATITUDE_DEG: 50.2371672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042600',
        LOCATION_NAME: 'Chivenor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1354581,
        LOCATION_LATITUDE_DEG: 51.0926498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042700',
        LOCATION_NAME: 'Chivery',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.693352,
        LOCATION_LATITUDE_DEG: 51.7647774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042800',
        LOCATION_NAME: 'Chobham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6019753,
        LOCATION_LATITUDE_DEG: 51.3450376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH042900',
        LOCATION_NAME: 'Cholderton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6772346,
        LOCATION_LATITUDE_DEG: 51.1787336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043000',
        LOCATION_NAME: 'Cholesbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6455967,
        LOCATION_LATITUDE_DEG: 51.7536704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043100',
        LOCATION_NAME: 'Chollerford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1266524,
        LOCATION_LATITUDE_DEG: 55.0297121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043200',
        LOCATION_NAME: 'Chollerton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1062203,
        LOCATION_LATITUDE_DEG: 55.0420081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043300',
        LOCATION_NAME: 'Cholmondeley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6936837,
        LOCATION_LATITUDE_DEG: 53.0572291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043400',
        LOCATION_NAME: 'Cholmondeston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5584892,
        LOCATION_LATITUDE_DEG: 53.1311296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043500',
        LOCATION_NAME: 'Cholsey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1518217,
        LOCATION_LATITUDE_DEG: 51.5746614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043600',
        LOCATION_NAME: 'Cholstrey',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7825764,
        LOCATION_LATITUDE_DEG: 52.2291478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043700',
        LOCATION_NAME: 'Chop Gate',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1389021,
        LOCATION_LATITUDE_DEG: 54.3904364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043800',
        LOCATION_NAME: 'Choppington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.601225,
        LOCATION_LATITUDE_DEG: 55.1504155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH043900',
        LOCATION_NAME: 'Chopwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8138114,
        LOCATION_LATITUDE_DEG: 54.9190921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044100',
        LOCATION_NAME: 'Chorley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.634277,
        LOCATION_LATITUDE_DEG: 53.0551242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044200',
        LOCATION_NAME: 'Chorley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6309967,
        LOCATION_LATITUDE_DEG: 53.6524805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044300',
        LOCATION_NAME: 'Chorley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4443331,
        LOCATION_LATITUDE_DEG: 52.4469664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044000',
        LOCATION_NAME: 'Chorley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8956069,
        LOCATION_LATITUDE_DEG: 52.697782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044400',
        LOCATION_NAME: 'Chorleywood',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5184548,
        LOCATION_LATITUDE_DEG: 51.6538621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044500',
        LOCATION_NAME: 'Chorlton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4070452,
        LOCATION_LATITUDE_DEG: 53.0495198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054700',
        LOCATION_NAME: 'Chorlton cum Hardy',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2657597,
        LOCATION_LATITUDE_DEG: 53.4391988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044600',
        LOCATION_NAME: 'Chorlton Lane',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.811845,
        LOCATION_LATITUDE_DEG: 53.0218235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055700',
        LOCATION_NAME: 'Chorlton on Medlock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055800',
        LOCATION_NAME: 'Chorlton on Medlock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055600',
        LOCATION_NAME: 'Chorlton on Medlock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2376077,
        LOCATION_LATITUDE_DEG: 53.4719081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044700',
        LOCATION_NAME: 'Choulton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9163085,
        LOCATION_LATITUDE_DEG: 52.4880752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH054300',
        LOCATION_NAME: 'Chowdene',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5989011,
        LOCATION_LATITUDE_DEG: 54.9296814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044800',
        LOCATION_NAME: 'Chrishall',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1078123,
        LOCATION_LATITUDE_DEG: 52.0336951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045200',
        LOCATION_NAME: 'Christchurch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9437308,
        LOCATION_LATITUDE_DEG: 51.598284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045000',
        LOCATION_NAME: 'Christchurch',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6379157,
        LOCATION_LATITUDE_DEG: 51.8141006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH044900',
        LOCATION_NAME: 'Christchurch',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7746452,
        LOCATION_LATITUDE_DEG: 50.7332959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045100',
        LOCATION_NAME: 'Christchurch',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2031551,
        LOCATION_LATITUDE_DEG: 52.5468426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045300',
        LOCATION_NAME: 'Christian Malford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0505798,
        LOCATION_LATITUDE_DEG: 51.5071694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045400',
        LOCATION_NAME: 'Christleton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8358687,
        LOCATION_LATITUDE_DEG: 53.1830425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045500',
        LOCATION_NAME: 'Christmas Common',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.967303,
        LOCATION_LATITUDE_DEG: 51.6334697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045600',
        LOCATION_NAME: 'Christon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8897836,
        LOCATION_LATITUDE_DEG: 51.3109621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045700',
        LOCATION_NAME: 'Christon Bank',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6611739,
        LOCATION_LATITUDE_DEG: 55.5013514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045800',
        LOCATION_NAME: 'Christow',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6494802,
        LOCATION_LATITUDE_DEG: 50.6543059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH045900',
        LOCATION_NAME: 'Chryston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0996895,
        LOCATION_LATITUDE_DEG: 55.9066217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046000',
        LOCATION_NAME: 'Chuck Hatch',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1055955,
        LOCATION_LATITUDE_DEG: 51.0681961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046100',
        LOCATION_NAME: 'Chudleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5990824,
        LOCATION_LATITUDE_DEG: 50.6042974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046200',
        LOCATION_NAME: 'Chudleigh Knighton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6313162,
        LOCATION_LATITUDE_DEG: 50.5832977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046300',
        LOCATION_NAME: 'Chulmleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8682569,
        LOCATION_LATITUDE_DEG: 50.9135366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046400',
        LOCATION_NAME: 'Chunal',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9461029,
        LOCATION_LATITUDE_DEG: 53.4260518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046500',
        LOCATION_NAME: 'Church',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3851977,
        LOCATION_LATITUDE_DEG: 53.7550926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046600',
        LOCATION_NAME: 'Church Aston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3839982,
        LOCATION_LATITUDE_DEG: 52.7572909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046700',
        LOCATION_NAME: 'Church Brampton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9418167,
        LOCATION_LATITUDE_DEG: 52.2866318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046800',
        LOCATION_NAME: 'Church Broughton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6921357,
        LOCATION_LATITUDE_DEG: 52.8990955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH046900',
        LOCATION_NAME: 'Church Cove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1935933,
        LOCATION_LATITUDE_DEG: 49.9688591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047000',
        LOCATION_NAME: 'Church Crookham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8362863,
        LOCATION_LATITUDE_DEG: 51.2606265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047100',
        LOCATION_NAME: 'Church Eaton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2241163,
        LOCATION_LATITUDE_DEG: 52.7551923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047300',
        LOCATION_NAME: 'Church End',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1563497,
        LOCATION_LATITUDE_DEG: 52.0228185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047200',
        LOCATION_NAME: 'Church End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2625874,
        LOCATION_LATITUDE_DEG: 52.0234909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047400',
        LOCATION_NAME: 'Church Enstone',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4481172,
        LOCATION_LATITUDE_DEG: 51.9209026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047500',
        LOCATION_NAME: 'Church Fenton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2191997,
        LOCATION_LATITUDE_DEG: 53.8258829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047600',
        LOCATION_NAME: 'Church Gresley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5579611,
        LOCATION_LATITUDE_DEG: 52.7653872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047700',
        LOCATION_NAME: 'Church Hanborough',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3800561,
        LOCATION_LATITUDE_DEG: 51.8111933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047800',
        LOCATION_NAME: 'Church Hougham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2569709,
        LOCATION_LATITUDE_DEG: 51.11279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH047900',
        LOCATION_NAME: 'Church Knowle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0843294,
        LOCATION_LATITUDE_DEG: 50.6357839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048000',
        LOCATION_NAME: 'Church Laneham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7783246,
        LOCATION_LATITUDE_DEG: 53.2795226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048100',
        LOCATION_NAME: 'Church Langton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9319705,
        LOCATION_LATITUDE_DEG: 52.5328567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048200',
        LOCATION_NAME: 'Church Lawford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3394101,
        LOCATION_LATITUDE_DEG: 52.3822442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048300',
        LOCATION_NAME: 'Church Lawton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2677792,
        LOCATION_LATITUDE_DEG: 53.0963218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048400',
        LOCATION_NAME: 'Church Leigh',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9625894,
        LOCATION_LATITUDE_DEG: 52.920499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048500',
        LOCATION_NAME: 'Church Lench',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9614328,
        LOCATION_LATITUDE_DEG: 52.1592286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048600',
        LOCATION_NAME: 'Church Minshull',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4983677,
        LOCATION_LATITUDE_DEG: 53.1413305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048700',
        LOCATION_NAME: 'Church Moor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8667843,
        LOCATION_LATITUDE_DEG: 52.4915684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048800',
        LOCATION_NAME: 'Church Preen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6766564,
        LOCATION_LATITUDE_DEG: 52.5784755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH048900',
        LOCATION_NAME: 'Church Pulverbatch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8426697,
        LOCATION_LATITUDE_DEG: 52.6200822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049000',
        LOCATION_NAME: 'Church Stoke',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0732163,
        LOCATION_LATITUDE_DEG: 52.5393824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049100',
        LOCATION_NAME: 'Church Stowe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0606713,
        LOCATION_LATITUDE_DEG: 52.2130242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049200',
        LOCATION_NAME: 'Church Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4702485,
        LOCATION_LATITUDE_DEG: 51.4393273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049300',
        LOCATION_NAME: 'Church Stretton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7993536,
        LOCATION_LATITUDE_DEG: 52.5372778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049600',
        LOCATION_NAME: 'Church Village',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3258447,
        LOCATION_LATITUDE_DEG: 51.5703898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049700',
        LOCATION_NAME: 'Church Warsop',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1488227,
        LOCATION_LATITUDE_DEG: 53.2124219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049800',
        LOCATION_NAME: 'Church Westcote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.684052,
        LOCATION_LATITUDE_DEG: 51.8837994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049900',
        LOCATION_NAME: 'Churcham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3361615,
        LOCATION_LATITUDE_DEG: 51.8665058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050000',
        LOCATION_NAME: 'Churchbridge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0207067,
        LOCATION_LATITUDE_DEG: 52.6722836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050100',
        LOCATION_NAME: 'Churchdown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1841489,
        LOCATION_LATITUDE_DEG: 51.8817056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050200',
        LOCATION_NAME: 'Churchend',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5086166,
        LOCATION_LATITUDE_DEG: 51.9254769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050300',
        LOCATION_NAME: 'Churchfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9805552,
        LOCATION_LATITUDE_DEG: 52.528062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050400',
        LOCATION_NAME: 'Churchill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9964191,
        LOCATION_LATITUDE_DEG: 50.8127107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050800',
        LOCATION_NAME: 'Churchill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8023657,
        LOCATION_LATITUDE_DEG: 51.332961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050500',
        LOCATION_NAME: 'Churchill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1717904,
        LOCATION_LATITUDE_DEG: 52.4150565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050600',
        LOCATION_NAME: 'Churchill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1112247,
        LOCATION_LATITUDE_DEG: 52.1814364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050700',
        LOCATION_NAME: 'Churchill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5891409,
        LOCATION_LATITUDE_DEG: 51.9154997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051100',
        LOCATION_NAME: 'Churchinford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1192861,
        LOCATION_LATITUDE_DEG: 50.9071202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051200',
        LOCATION_NAME: 'Churchover',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.249365,
        LOCATION_LATITUDE_DEG: 52.4213494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051300',
        LOCATION_NAME: 'Churchstanton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1436525,
        LOCATION_LATITUDE_DEG: 50.9239273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051400',
        LOCATION_NAME: 'Churchstow',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8056377,
        LOCATION_LATITUDE_DEG: 50.2953773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051600',
        LOCATION_NAME: 'Churchtown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2030247,
        LOCATION_LATITUDE_DEG: 50.3104891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051700',
        LOCATION_NAME: 'Churchtown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.686175,
        LOCATION_LATITUDE_DEG: 50.5633061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051500',
        LOCATION_NAME: 'Churchtown',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'PR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.977342,
        LOCATION_LATITUDE_DEG: 53.6593866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051800',
        LOCATION_NAME: 'Churchtown',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7908242,
        LOCATION_LATITUDE_DEG: 53.8813075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052100',
        LOCATION_NAME: 'Churston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5421737,
        LOCATION_LATITUDE_DEG: 50.3975758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052200',
        LOCATION_NAME: 'Churston Ferrers',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.547427,
        LOCATION_LATITUDE_DEG: 50.3907959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052300',
        LOCATION_NAME: 'Churt',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7777997,
        LOCATION_LATITUDE_DEG: 51.136416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052400',
        LOCATION_NAME: 'Churton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8694124,
        LOCATION_LATITUDE_DEG: 53.1018268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052500',
        LOCATION_NAME: 'Churton Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8343137,
        LOCATION_LATITUDE_DEG: 53.1368345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052600',
        LOCATION_NAME: 'Churwell',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5875477,
        LOCATION_LATITUDE_DEG: 53.7609797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052700',
        LOCATION_NAME: 'Chute Cadley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5474497,
        LOCATION_LATITUDE_DEG: 51.2780448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052800',
        LOCATION_NAME: 'Chute Forest',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5604584,
        LOCATION_LATITUDE_DEG: 51.2626356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH052900',
        LOCATION_NAME: 'Chute Standen',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5566175,
        LOCATION_LATITUDE_DEG: 51.2819379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053000',
        LOCATION_NAME: 'Chwilog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3298338,
        LOCATION_LATITUDE_DEG: 52.9197314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053100',
        LOCATION_NAME: 'Chyandour',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5280635,
        LOCATION_LATITUDE_DEG: 50.1250768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053200',
        LOCATION_NAME: 'Chyanvounder',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2735635,
        LOCATION_LATITUDE_DEG: 50.0556657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH053300',
        LOCATION_NAME: 'Chyknell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3258613,
        LOCATION_LATITUDE_DEG: 52.5384672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI053301',
        LOCATION_NAME: 'Ciffig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6126255,
        LOCATION_LATITUDE_DEG: 51.7988507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000100',
        LOCATION_NAME: 'Cilan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5242991,
        LOCATION_LATITUDE_DEG: 52.7852173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000200',
        LOCATION_NAME: 'Cilcain',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.231125,
        LOCATION_LATITUDE_DEG: 53.177141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000300',
        LOCATION_NAME: 'Cilcennin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1654603,
        LOCATION_LATITUDE_DEG: 52.2191577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000400',
        LOCATION_NAME: 'Cilfrew',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7777477,
        LOCATION_LATITUDE_DEG: 51.6886018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000500',
        LOCATION_NAME: 'Cilfynydd',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.31907,
        LOCATION_LATITUDE_DEG: 51.6219955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000600',
        LOCATION_NAME: 'Cilgerran',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6308366,
        LOCATION_LATITUDE_DEG: 52.054552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000700',
        LOCATION_NAME: 'Cilgwyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8034177,
        LOCATION_LATITUDE_DEG: 51.9888421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000800',
        LOCATION_NAME: 'Cilgwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2474603,
        LOCATION_LATITUDE_DEG: 53.0624413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI000900',
        LOCATION_NAME: 'Ciliau Aeron',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1950313,
        LOCATION_LATITUDE_DEG: 52.1997348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001000',
        LOCATION_NAME: 'Cilibion',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1498903,
        LOCATION_LATITUDE_DEG: 51.5993034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001100',
        LOCATION_NAME: 'Cilmaengwyn',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8202005,
        LOCATION_LATITUDE_DEG: 51.740508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001200',
        LOCATION_NAME: 'Cilmery',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4559304,
        LOCATION_LATITUDE_DEG: 52.1521465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001300',
        LOCATION_NAME: 'Cilonen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0940925,
        LOCATION_LATITUDE_DEG: 51.6198018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001400',
        LOCATION_NAME: 'Cilrhedyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5051739,
        LOCATION_LATITUDE_DEG: 51.9853415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001500',
        LOCATION_NAME: 'Cilybebyll',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8163389,
        LOCATION_LATITUDE_DEG: 51.7244069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001600',
        LOCATION_NAME: 'Cilycwm',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8185622,
        LOCATION_LATITUDE_DEG: 52.04464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001700',
        LOCATION_NAME: 'Cimla',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7800586,
        LOCATION_LATITUDE_DEG: 51.6504984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001800',
        LOCATION_NAME: 'Cinderford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4977608,
        LOCATION_LATITUDE_DEG: 51.8240032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI001900',
        LOCATION_NAME: 'Cippenham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6445503,
        LOCATION_LATITUDE_DEG: 51.5162554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI002000',
        LOCATION_NAME: 'Cippyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7187521,
        LOCATION_LATITUDE_DEG: 52.0965543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI002100',
        LOCATION_NAME: 'Cirencester',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9650844,
        LOCATION_LATITUDE_DEG: 51.7136842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI002200',
        LOCATION_NAME: 'City',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4653356,
        LOCATION_LATITUDE_DEG: 51.4935843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000100',
        LOCATION_NAME: 'Clabby',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.382352,
        LOCATION_LATITUDE_DEG: 54.3998998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000200',
        LOCATION_NAME: 'Clachaig',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0184487,
        LOCATION_LATITUDE_DEG: 55.9889388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000300',
        LOCATION_NAME: 'Clachaig',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3165641,
        LOCATION_LATITUDE_DEG: 56.4624764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000400',
        LOCATION_NAME: 'Clachan',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2007207,
        LOCATION_LATITUDE_DEG: 57.6220147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000500',
        LOCATION_NAME: 'Clachan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5782441,
        LOCATION_LATITUDE_DEG: 56.3137711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000600',
        LOCATION_NAME: 'Clachan Of Campsie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2276264,
        LOCATION_LATITUDE_DEG: 55.9851246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000700',
        LOCATION_NAME: 'Clachan Sands',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2219394,
        LOCATION_LATITUDE_DEG: 57.6567247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000800',
        LOCATION_NAME: 'Clachan Seil',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.588682,
        LOCATION_LATITUDE_DEG: 56.3089728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL000900',
        LOCATION_NAME: 'CLACHNAHARRY',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2575076,
        LOCATION_LATITUDE_DEG: 57.4895751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001000',
        LOCATION_NAME: 'Clack',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9818893,
        LOCATION_LATITUDE_DEG: 51.4995713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001100',
        LOCATION_NAME: 'Clackmannan',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7513662,
        LOCATION_LATITUDE_DEG: 56.1073362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043500',
        LOCATION_NAME: 'Clacton on Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001200',
        LOCATION_NAME: 'Clacton-on-Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.157964,
        LOCATION_LATITUDE_DEG: 51.7904504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001300',
        LOCATION_NAME: 'Claddach Kirkibost',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3864191,
        LOCATION_LATITUDE_DEG: 57.567212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001400',
        LOCATION_NAME: 'Claddach Kyles',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4015732,
        LOCATION_LATITUDE_DEG: 57.5781197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001500',
        LOCATION_NAME: 'Claddach Vallay',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4729214,
        LOCATION_LATITUDE_DEG: 51.6237632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001800',
        LOCATION_NAME: 'Cladich',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0810348,
        LOCATION_LATITUDE_DEG: 56.3510708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001900',
        LOCATION_NAME: 'Clady',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5323551,
        LOCATION_LATITUDE_DEG: 54.7832427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002000',
        LOCATION_NAME: 'Claerwen Valley',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6010126,
        LOCATION_LATITUDE_DEG: 52.2589561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002500',
        LOCATION_NAME: 'Claines',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2171451,
        LOCATION_LATITUDE_DEG: 52.227541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002700',
        LOCATION_NAME: 'Clampits',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2424306,
        LOCATION_LATITUDE_DEG: 50.4989928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002800',
        LOCATION_NAME: 'Clanabogan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3657384,
        LOCATION_LATITUDE_DEG: 54.5499207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002900',
        LOCATION_NAME: 'Clandown',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4537727,
        LOCATION_LATITUDE_DEG: 51.3002525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003100',
        LOCATION_NAME: 'Clanfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5874789,
        LOCATION_LATITUDE_DEG: 51.7157799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003200',
        LOCATION_NAME: 'Clanfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0064078,
        LOCATION_LATITUDE_DEG: 50.9463008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003300',
        LOCATION_NAME: 'Clanville',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5436078,
        LOCATION_LATITUDE_DEG: 51.2374358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003700',
        LOCATION_NAME: 'Clapham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5615462,
        LOCATION_LATITUDE_DEG: 50.6701066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003400',
        LOCATION_NAME: 'Clapham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3918878,
        LOCATION_LATITUDE_DEG: 54.1177269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003600',
        LOCATION_NAME: 'Clapham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4926988,
        LOCATION_LATITUDE_DEG: 52.162112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003500',
        LOCATION_NAME: 'Clapham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4459286,
        LOCATION_LATITUDE_DEG: 50.8459823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044400',
        LOCATION_NAME: 'Clapham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1929505,
        LOCATION_LATITUDE_DEG: 51.4590296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003800',
        LOCATION_NAME: 'Clapham Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0231027,
        LOCATION_LATITUDE_DEG: 51.3385151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003900',
        LOCATION_NAME: 'Clappersgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9762755,
        LOCATION_LATITUDE_DEG: 54.4228625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004000',
        LOCATION_NAME: 'Clapton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5132464,
        LOCATION_LATITUDE_DEG: 51.2781542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004100',
        LOCATION_NAME: 'Clapton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4968316,
        LOCATION_LATITUDE_DEG: 51.6773893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004300',
        LOCATION_NAME: 'Clapton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7634448,
        LOCATION_LATITUDE_DEG: 51.8590961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044600',
        LOCATION_NAME: 'Clapton',
        COUNTY_NAME: 'London',
        POSTCODE: 'E5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0401699,
        LOCATION_LATITUDE_DEG: 51.555784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004200',
        LOCATION_NAME: 'Clapton in Gordano',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7558486,
        LOCATION_LATITUDE_DEG: 51.4626683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043300',
        LOCATION_NAME: 'Clapton On The Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7646788,
        LOCATION_LATITUDE_DEG: 51.861967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990711',
        LOCATION_NAME: 'Clapton-on-the-Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004400',
        LOCATION_NAME: 'Clapworthy Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.892977,
        LOCATION_LATITUDE_DEG: 50.998144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004800',
        LOCATION_NAME: 'Clara Vale',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.790563,
        LOCATION_LATITUDE_DEG: 54.9791974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004900',
        LOCATION_NAME: 'Clarach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0571265,
        LOCATION_LATITUDE_DEG: 52.4358781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005000',
        LOCATION_NAME: 'Clarbeston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8354666,
        LOCATION_LATITUDE_DEG: 51.8552347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005050',
        LOCATION_NAME: 'Clarbeston Road',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8521789,
        LOCATION_LATITUDE_DEG: 51.8849712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005100',
        LOCATION_NAME: 'Clarborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9027215,
        LOCATION_LATITUDE_DEG: 53.3462349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005300',
        LOCATION_NAME: 'Clare',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6914631,
        LOCATION_LATITUDE_DEG: 54.6654266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990199',
        LOCATION_NAME: 'CLARE',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4742015,
        LOCATION_LATITUDE_DEG: 54.3326408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005200',
        LOCATION_NAME: 'Clare',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0268924,
        LOCATION_LATITUDE_DEG: 51.6809738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005400',
        LOCATION_NAME: 'Clare',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5823262,
        LOCATION_LATITUDE_DEG: 52.0767881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005500',
        LOCATION_NAME: 'Clarebrand',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9269137,
        LOCATION_LATITUDE_DEG: 54.9729209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005700',
        LOCATION_NAME: 'Claredon',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4636126,
        LOCATION_LATITUDE_DEG: 58.5944783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006000',
        LOCATION_NAME: 'Claregate',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1877742,
        LOCATION_LATITUDE_DEG: 52.5845304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006100',
        LOCATION_NAME: 'Claremont',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3484382,
        LOCATION_LATITUDE_DEG: 51.3495344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006300',
        LOCATION_NAME: 'Clarencefield',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4220488,
        LOCATION_LATITUDE_DEG: 55.0059206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006400',
        LOCATION_NAME: 'Clarendon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7556754,
        LOCATION_LATITUDE_DEG: 51.0556192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006500',
        LOCATION_NAME: 'Clarendon Park',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7274699,
        LOCATION_LATITUDE_DEG: 51.0595228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006600',
        LOCATION_NAME: 'Clareview',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7323714,
        LOCATION_LATITUDE_DEG: 54.4999124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007000',
        LOCATION_NAME: 'Clarkston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2715004,
        LOCATION_LATITUDE_DEG: 55.7854075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007100',
        LOCATION_NAME: 'Clase',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.942773,
        LOCATION_LATITUDE_DEG: 51.6636032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007400',
        LOCATION_NAME: 'Clashmore',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1128087,
        LOCATION_LATITUDE_DEG: 57.8781179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007600',
        LOCATION_NAME: 'Clashnessie',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3152127,
        LOCATION_LATITUDE_DEG: 58.2223638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007700',
        LOCATION_NAME: 'Clatford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7694719,
        LOCATION_LATITUDE_DEG: 51.4086559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007800',
        LOCATION_NAME: 'Clatford Bottom',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7598742,
        LOCATION_LATITUDE_DEG: 51.404455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007900',
        LOCATION_NAME: 'Clathy',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6270358,
        LOCATION_LATITUDE_DEG: 56.3620599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008000',
        LOCATION_NAME: 'Clatt',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7649681,
        LOCATION_LATITUDE_DEG: 57.3220422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008100',
        LOCATION_NAME: 'Clatter',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4754854,
        LOCATION_LATITUDE_DEG: 52.5417861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008200',
        LOCATION_NAME: 'Clatworthy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3483246,
        LOCATION_LATITUDE_DEG: 51.0700418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008300',
        LOCATION_NAME: 'Claudy',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1584313,
        LOCATION_LATITUDE_DEG: 54.9148503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008400',
        LOCATION_NAME: 'Claughton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6714292,
        LOCATION_LATITUDE_DEG: 54.0903259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008450',
        LOCATION_NAME: 'Claughton-on-Brock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7408961,
        LOCATION_LATITUDE_DEG: 53.8755764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008500',
        LOCATION_NAME: 'Clavelshay',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.043693,
        LOCATION_LATITUDE_DEG: 51.0753352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008600',
        LOCATION_NAME: 'Claverdon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7129483,
        LOCATION_LATITUDE_DEG: 52.2826348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008700',
        LOCATION_NAME: 'Claverham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7966643,
        LOCATION_LATITUDE_DEG: 51.38997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008800',
        LOCATION_NAME: 'Clavering',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1433961,
        LOCATION_LATITUDE_DEG: 51.9645872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL008900',
        LOCATION_NAME: 'Claverley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.305212,
        LOCATION_LATITUDE_DEG: 52.5376681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009000',
        LOCATION_NAME: 'Claverton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3026652,
        LOCATION_LATITUDE_DEG: 51.3732584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009100',
        LOCATION_NAME: 'Claverton Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3208165,
        LOCATION_LATITUDE_DEG: 51.3697569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009200',
        LOCATION_NAME: 'Clawddcoch',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3513163,
        LOCATION_LATITUDE_DEG: 51.4895847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009300',
        LOCATION_NAME: 'Clawddnewydd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3677576,
        LOCATION_LATITUDE_DEG: 53.0629154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009400',
        LOCATION_NAME: 'Clawthorpe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7191441,
        LOCATION_LATITUDE_DEG: 54.1915329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009500',
        LOCATION_NAME: 'Clawton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.332133,
        LOCATION_LATITUDE_DEG: 50.7662248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009600',
        LOCATION_NAME: 'Claxby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3242821,
        LOCATION_LATITUDE_DEG: 53.4381327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009700',
        LOCATION_NAME: 'Claxby Pluckacre',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0448979,
        LOCATION_LATITUDE_DEG: 53.1667014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009900',
        LOCATION_NAME: 'Claxton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.269359,
        LOCATION_LATITUDE_DEG: 54.6439627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL009800',
        LOCATION_NAME: 'Claxton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9403378,
        LOCATION_LATITUDE_DEG: 54.033302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010000',
        LOCATION_NAME: 'Claxton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4539443,
        LOCATION_LATITUDE_DEG: 52.5781237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010100',
        LOCATION_NAME: 'Clay Coton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.127471,
        LOCATION_LATITUDE_DEG: 52.3865433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010200',
        LOCATION_NAME: 'Clay Cross',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4143503,
        LOCATION_LATITUDE_DEG: 53.1663213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010300',
        LOCATION_NAME: 'Clay Hill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5414443,
        LOCATION_LATITUDE_DEG: 51.4688722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010400',
        LOCATION_NAME: 'Claybrooke Magna',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2757532,
        LOCATION_LATITUDE_DEG: 52.4937495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010500',
        LOCATION_NAME: 'Claybrooke Parva',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2736489,
        LOCATION_LATITUDE_DEG: 52.4873528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010600',
        LOCATION_NAME: 'Claydon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0948823,
        LOCATION_LATITUDE_DEG: 51.9800114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010700',
        LOCATION_NAME: 'Claydon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3314811,
        LOCATION_LATITUDE_DEG: 52.1480253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010800',
        LOCATION_NAME: 'Claydon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1133544,
        LOCATION_LATITUDE_DEG: 52.1051801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL010900',
        LOCATION_NAME: 'Claydon Pike',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7192497,
        LOCATION_LATITUDE_DEG: 51.6984809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011000',
        LOCATION_NAME: 'Clayford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9205017,
        LOCATION_LATITUDE_DEG: 50.8231979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011200',
        LOCATION_NAME: 'Claygate',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9478402,
        LOCATION_LATITUDE_DEG: 55.1028231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011100',
        LOCATION_NAME: 'Claygate',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3386119,
        LOCATION_LATITUDE_DEG: 51.3595311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011300',
        LOCATION_NAME: 'Clayhall',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0534171,
        LOCATION_LATITUDE_DEG: 51.5918619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011400',
        LOCATION_NAME: 'Clayhanger',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3947949,
        LOCATION_LATITUDE_DEG: 50.9975372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011500',
        LOCATION_NAME: 'Clayhanger',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.93911,
        LOCATION_LATITUDE_DEG: 52.6384736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011600',
        LOCATION_NAME: 'Clayhidon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1910115,
        LOCATION_LATITUDE_DEG: 50.9340305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011700',
        LOCATION_NAME: 'Claylake',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1569846,
        LOCATION_LATITUDE_DEG: 52.7745698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011800',
        LOCATION_NAME: 'Claypits',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3409671,
        LOCATION_LATITUDE_DEG: 51.7527963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL011900',
        LOCATION_NAME: 'Claypole',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7377792,
        LOCATION_LATITUDE_DEG: 53.0311937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012000',
        LOCATION_NAME: 'Claythorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1288735,
        LOCATION_LATITUDE_DEG: 53.2883094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012500',
        LOCATION_NAME: 'Clayton',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9220079,
        LOCATION_LATITUDE_DEG: 56.3549495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012300',
        LOCATION_NAME: 'Clayton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.221225,
        LOCATION_LATITUDE_DEG: 52.9885084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044500',
        LOCATION_NAME: 'Clayton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1785492,
        LOCATION_LATITUDE_DEG: 53.4873291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012100',
        LOCATION_NAME: 'Clayton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8205965,
        LOCATION_LATITUDE_DEG: 53.782086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012200',
        LOCATION_NAME: 'Clayton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.317762,
        LOCATION_LATITUDE_DEG: 53.5646599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012400',
        LOCATION_NAME: 'Clayton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1503798,
        LOCATION_LATITUDE_DEG: 50.9099838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044100',
        LOCATION_NAME: 'Clayton Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1675611,
        LOCATION_LATITUDE_DEG: 53.4987706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012600',
        LOCATION_NAME: 'Clayton Brook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6406345,
        LOCATION_LATITUDE_DEG: 53.7102848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012700',
        LOCATION_NAME: 'Clayton Heights',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8131984,
        LOCATION_LATITUDE_DEG: 53.7732834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012900',
        LOCATION_NAME: 'Clayton le Dale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3890416,
        LOCATION_LATITUDE_DEG: 53.7721865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013000',
        LOCATION_NAME: 'Clayton le Moors',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3812537,
        LOCATION_LATITUDE_DEG: 53.773488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043100',
        LOCATION_NAME: 'Clayton le Woods',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL012800',
        LOCATION_NAME: 'Clayton West',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6079539,
        LOCATION_LATITUDE_DEG: 53.5944593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013100',
        LOCATION_NAME: 'Clayton-le-Woods',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.664746,
        LOCATION_LATITUDE_DEG: 53.697083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013200',
        LOCATION_NAME: 'Clayworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9076727,
        LOCATION_LATITUDE_DEG: 53.3870326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013300',
        LOCATION_NAME: 'Cleadon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3985709,
        LOCATION_LATITUDE_DEG: 54.9545955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013600',
        LOCATION_NAME: 'Clearbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0828161,
        LOCATION_LATITUDE_DEG: 50.4708898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013700',
        LOCATION_NAME: 'Clearwell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6205438,
        LOCATION_LATITUDE_DEG: 51.7693046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013800',
        LOCATION_NAME: 'Cleasby',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.613295,
        LOCATION_LATITUDE_DEG: 54.5116561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013900',
        LOCATION_NAME: 'Cleat',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9417172,
        LOCATION_LATITUDE_DEG: 58.7442832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014000',
        LOCATION_NAME: 'Cleatham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5956095,
        LOCATION_LATITUDE_DEG: 53.4977397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014100',
        LOCATION_NAME: 'Cleatlam',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8145187,
        LOCATION_LATITUDE_DEG: 54.5643609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014200',
        LOCATION_NAME: 'Cleator',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5212206,
        LOCATION_LATITUDE_DEG: 54.5067774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014300',
        LOCATION_NAME: 'Cleator Moor',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.513937,
        LOCATION_LATITUDE_DEG: 54.5211792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014400',
        LOCATION_NAME: 'Cleckheaton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7119012,
        LOCATION_LATITUDE_DEG: 53.7230763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014500',
        LOCATION_NAME: 'Clee Downton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6148003,
        LOCATION_LATITUDE_DEG: 52.4231946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014600',
        LOCATION_NAME: 'Clee Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5990022,
        LOCATION_LATITUDE_DEG: 52.3741565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042500',
        LOCATION_NAME: 'Clee St Margaret',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014700',
        LOCATION_NAME: 'Clee St. Margaret',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6397184,
        LOCATION_LATITUDE_DEG: 52.4549633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014800',
        LOCATION_NAME: 'Clee Stanton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6266494,
        LOCATION_LATITUDE_DEG: 52.4093578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL014900',
        LOCATION_NAME: 'Cleers',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8465925,
        LOCATION_LATITUDE_DEG: 50.3885922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015000',
        LOCATION_NAME: 'Cleethorpes',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0278533,
        LOCATION_LATITUDE_DEG: 53.5572409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042600',
        LOCATION_NAME: 'Cleeton St Mary',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015100',
        LOCATION_NAME: 'Cleeton St. Mary',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5716385,
        LOCATION_LATITUDE_DEG: 52.4041609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015200',
        LOCATION_NAME: 'Cleeve',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9259065,
        LOCATION_LATITUDE_DEG: 50.3786854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015300',
        LOCATION_NAME: 'Cleeve',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7804944,
        LOCATION_LATITUDE_DEG: 51.3874619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015400',
        LOCATION_NAME: 'Cleeve Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0243395,
        LOCATION_LATITUDE_DEG: 51.9399077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015500',
        LOCATION_NAME: 'Cleeve Prior',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8737187,
        LOCATION_LATITUDE_DEG: 52.1419306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015700',
        LOCATION_NAME: 'Cleghorn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7523601,
        LOCATION_LATITUDE_DEG: 55.6953912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015800',
        LOCATION_NAME: 'Clehonger',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.800188,
        LOCATION_LATITUDE_DEG: 52.0348258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015900',
        LOCATION_NAME: 'Cleish',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.457325,
        LOCATION_LATITUDE_DEG: 56.1667386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016000',
        LOCATION_NAME: 'Cleland',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.915562,
        LOCATION_LATITUDE_DEG: 55.8009075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016100',
        LOCATION_NAME: 'Clemenstone',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5386335,
        LOCATION_LATITUDE_DEG: 51.4467798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016300',
        LOCATION_NAME: 'Clench',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7310055,
        LOCATION_LATITUDE_DEG: 51.3648514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016400',
        LOCATION_NAME: 'Clench Common',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7477708,
        LOCATION_LATITUDE_DEG: 51.3882517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016500',
        LOCATION_NAME: 'Clenchwarton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3565586,
        LOCATION_LATITUDE_DEG: 52.7566554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016600',
        LOCATION_NAME: 'Clennell',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1104713,
        LOCATION_LATITUDE_DEG: 55.3577421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016700',
        LOCATION_NAME: 'Clent',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1055394,
        LOCATION_LATITUDE_DEG: 52.4116547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016800',
        LOCATION_NAME: 'Clentry',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4009678,
        LOCATION_LATITUDE_DEG: 56.1353352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016900',
        LOCATION_NAME: 'Cleobury Mortimer',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4777181,
        LOCATION_LATITUDE_DEG: 52.3799598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017000',
        LOCATION_NAME: 'Cleobury North',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5555362,
        LOCATION_LATITUDE_DEG: 52.4774708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017200',
        LOCATION_NAME: 'Clerkenwater',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7226779,
        LOCATION_LATITUDE_DEG: 50.4860012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044700',
        LOCATION_NAME: 'Clerkenwell',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1072026,
        LOCATION_LATITUDE_DEG: 51.5293015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017300',
        LOCATION_NAME: 'Clevancy',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9256098,
        LOCATION_LATITUDE_DEG: 51.4745679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017400',
        LOCATION_NAME: 'Clevedon',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.851961,
        LOCATION_LATITUDE_DEG: 51.4356694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017500',
        LOCATION_NAME: 'Cleveley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4335983,
        LOCATION_LATITUDE_DEG: 51.9121025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017600',
        LOCATION_NAME: 'Cleveleys',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.040123,
        LOCATION_LATITUDE_DEG: 53.8792534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017700',
        LOCATION_NAME: 'Clevelode',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2485911,
        LOCATION_LATITUDE_DEG: 52.1163261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017800',
        LOCATION_NAME: 'Cleverton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0318037,
        LOCATION_LATITUDE_DEG: 51.5697725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017900',
        LOCATION_NAME: 'Clewer',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8005358,
        LOCATION_LATITUDE_DEG: 51.255049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018000',
        LOCATION_NAME: 'Cley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.048402,
        LOCATION_LATITUDE_DEG: 52.9456639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018100',
        LOCATION_NAME: 'Cliasmol',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9505245,
        LOCATION_LATITUDE_DEG: 57.9538536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018200',
        LOCATION_NAME: 'Cliburn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.63826,
        LOCATION_LATITUDE_DEG: 54.6172782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018300',
        LOCATION_NAME: 'Cliddesden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0964472,
        LOCATION_LATITUDE_DEG: 51.2368345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018400',
        LOCATION_NAME: 'Clieves Hills',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9281358,
        LOCATION_LATITUDE_DEG: 53.5640744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018600',
        LOCATION_NAME: 'Cliff',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9693537,
        LOCATION_LATITUDE_DEG: 58.217479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018800',
        LOCATION_NAME: 'Cliff',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6326619,
        LOCATION_LATITUDE_DEG: 50.3684902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018700',
        LOCATION_NAME: 'Cliff',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6884745,
        LOCATION_LATITUDE_DEG: 52.5796662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018900',
        LOCATION_NAME: 'Cliffburn',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5718406,
        LOCATION_LATITUDE_DEG: 56.5636662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019000',
        LOCATION_NAME: 'Cliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9955781,
        LOCATION_LATITUDE_DEG: 53.7797752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019100',
        LOCATION_NAME: 'Cliffe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4999828,
        LOCATION_LATITUDE_DEG: 51.4617315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019200',
        LOCATION_NAME: 'Cliffe Common',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9929182,
        LOCATION_LATITUDE_DEG: 53.7976779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990785',
        LOCATION_NAME: 'Cliffe Cum Lund',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019300',
        LOCATION_NAME: 'Cliffe Woods',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4972016,
        LOCATION_LATITUDE_DEG: 51.4345285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990786',
        LOCATION_NAME: 'Cliffe-Cum-Lund',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019500',
        LOCATION_NAME: 'Clifford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0937075,
        LOCATION_LATITUDE_DEG: 52.0987381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019600',
        LOCATION_NAME: 'Clifford',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3456171,
        LOCATION_LATITUDE_DEG: 53.8929876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019700',
        LOCATION_NAME: 'Clifford Chambers',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7146762,
        LOCATION_LATITUDE_DEG: 52.1710284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019800',
        LOCATION_NAME: 'Cliffords Mesne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4384979,
        LOCATION_LATITUDE_DEG: 51.9107242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020000',
        LOCATION_NAME: 'Cliffsend',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3584659,
        LOCATION_LATITUDE_DEG: 51.3303604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020100',
        LOCATION_NAME: 'Clifftown',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7029648,
        LOCATION_LATITUDE_DEG: 51.5371346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021375',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020500',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8082775,
        LOCATION_LATITUDE_DEG: 53.7661918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020400',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7272967,
        LOCATION_LATITUDE_DEG: 53.3186503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020900',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7223081,
        LOCATION_LATITUDE_DEG: 54.6328766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020300',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6134418,
        LOCATION_LATITUDE_DEG: 51.4585718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021350',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3146443,
        LOCATION_LATITUDE_DEG: 53.5226197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021000',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.758097,
        LOCATION_LATITUDE_DEG: 53.7022787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021300',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7500085,
        LOCATION_LATITUDE_DEG: 53.0010107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021100',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6802736,
        LOCATION_LATITUDE_DEG: 55.1383182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020800',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2861911,
        LOCATION_LATITUDE_DEG: 51.9820048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021200',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2157829,
        LOCATION_LATITUDE_DEG: 53.4604466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020600',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1781584,
        LOCATION_LATITUDE_DEG: 52.8996904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020200',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0984223,
        LOCATION_LATITUDE_DEG: 53.9664901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL020700',
        LOCATION_NAME: 'Clifton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2989184,
        LOCATION_LATITUDE_DEG: 52.0394975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021400',
        LOCATION_NAME: 'Clifton Campville',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6239689,
        LOCATION_LATITUDE_DEG: 52.695973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044000',
        LOCATION_NAME: 'Clifton Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6206689,
        LOCATION_LATITUDE_DEG: 51.4586327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021500',
        LOCATION_NAME: 'Clifton Dykes',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7093619,
        LOCATION_LATITUDE_DEG: 54.6385796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021600',
        LOCATION_NAME: 'Clifton Hampden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2080094,
        LOCATION_LATITUDE_DEG: 51.6565712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021700',
        LOCATION_NAME: 'Clifton Maybank',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6008175,
        LOCATION_LATITUDE_DEG: 50.9204187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043200',
        LOCATION_NAME: 'Clifton on Teme',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4214587,
        LOCATION_LATITUDE_DEG: 52.2578649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021800',
        LOCATION_NAME: 'Clifton Reynes',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6760626,
        LOCATION_LATITUDE_DEG: 52.1501143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL021900',
        LOCATION_NAME: 'Clifton upon Dunsmore',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2198587,
        LOCATION_LATITUDE_DEG: 52.3824417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043800',
        LOCATION_NAME: 'Clifton Wood',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.156331,
        LOCATION_LATITUDE_DEG: 51.9854194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022000',
        LOCATION_NAME: 'Clifton-on-Teme',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4215781,
        LOCATION_LATITUDE_DEG: 52.2519122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022200',
        LOCATION_NAME: 'Cliftonville',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.875161,
        LOCATION_LATITUDE_DEG: 52.2374242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022100',
        LOCATION_NAME: 'Cliftonville',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4184342,
        LOCATION_LATITUDE_DEG: 51.3828081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022300',
        LOCATION_NAME: 'Climping',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5795235,
        LOCATION_LATITUDE_DEG: 50.8156842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022400',
        LOCATION_NAME: 'Clint',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6092024,
        LOCATION_LATITUDE_DEG: 54.0343067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022500',
        LOCATION_NAME: 'Clint Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9902552,
        LOCATION_LATITUDE_DEG: 52.6583421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022600',
        LOCATION_NAME: 'Clintmains',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6146032,
        LOCATION_LATITUDE_DEG: 55.5851744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022700',
        LOCATION_NAME: 'Clippesby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5946592,
        LOCATION_LATITUDE_DEG: 52.6737263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990119',
        LOCATION_NAME: 'Clipsham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5659679,
        LOCATION_LATITUDE_DEG: 52.7375371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022800',
        LOCATION_NAME: 'Clipsham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5643851,
        LOCATION_LATITUDE_DEG: 52.7356658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990064',
        LOCATION_NAME: 'Clipston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0576041,
        LOCATION_LATITUDE_DEG: 52.9032096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL022900',
        LOCATION_NAME: 'Clipston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9523701,
        LOCATION_LATITUDE_DEG: 52.4277408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023000',
        LOCATION_NAME: 'Clipstone Village',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0978891,
        LOCATION_LATITUDE_DEG: 53.1752952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023100',
        LOCATION_NAME: 'Clitheroe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3892732,
        LOCATION_LATITUDE_DEG: 53.8726023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023200',
        LOCATION_NAME: 'Clitters',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2828304,
        LOCATION_LATITUDE_DEG: 50.5243028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023300',
        LOCATION_NAME: 'Clive',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7208415,
        LOCATION_LATITUDE_DEG: 52.8136046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023400',
        LOCATION_NAME: 'Cliviger',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1971319,
        LOCATION_LATITUDE_DEG: 53.7627856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023500',
        LOCATION_NAME: 'Clixby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3375641,
        LOCATION_LATITUDE_DEG: 53.5240437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023600',
        LOCATION_NAME: 'Clocaenog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3700862,
        LOCATION_LATITUDE_DEG: 53.0770312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023700',
        LOCATION_NAME: 'Clochan',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.001487,
        LOCATION_LATITUDE_DEG: 57.6344781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023800',
        LOCATION_NAME: 'Clock Face',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7083291,
        LOCATION_LATITUDE_DEG: 53.4152616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL023900',
        LOCATION_NAME: 'Clocksbriggs',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8085849,
        LOCATION_LATITUDE_DEG: 56.6572809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024000',
        LOCATION_NAME: 'Cloddiau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1785666,
        LOCATION_LATITUDE_DEG: 52.6741941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024100',
        LOCATION_NAME: 'Cloford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3920346,
        LOCATION_LATITUDE_DEG: 51.1912382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026100',
        LOCATION_NAME: 'Clogher',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1519322,
        LOCATION_LATITUDE_DEG: 54.4175905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026600',
        LOCATION_NAME: 'Clogherney',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1730098,
        LOCATION_LATITUDE_DEG: 54.5583825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027000',
        LOCATION_NAME: 'Cloghmills',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.332048,
        LOCATION_LATITUDE_DEG: 54.9982069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027800',
        LOCATION_NAME: 'Clola',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9994161,
        LOCATION_LATITUDE_DEG: 57.4851491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035800',
        LOCATION_NAME: 'Clophill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4176526,
        LOCATION_LATITUDE_DEG: 52.0285986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990931',
        LOCATION_NAME: 'Clopton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036000',
        LOCATION_NAME: 'Clopton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5043104,
        LOCATION_LATITUDE_DEG: 52.4080312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035900',
        LOCATION_NAME: 'Clopton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2422646,
        LOCATION_LATITUDE_DEG: 52.1284806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036100',
        LOCATION_NAME: 'Close House',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6322452,
        LOCATION_LATITUDE_DEG: 54.6443677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036200',
        LOCATION_NAME: 'Closeburn',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7336489,
        LOCATION_LATITUDE_DEG: 55.2123443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036300',
        LOCATION_NAME: 'Closworth',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6174734,
        LOCATION_LATITUDE_DEG: 50.8888185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036400',
        LOCATION_NAME: 'Clothall',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1483617,
        LOCATION_LATITUDE_DEG: 51.9704912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036500',
        LOCATION_NAME: 'Clothall Common',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1610643,
        LOCATION_LATITUDE_DEG: 51.9859872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036600',
        LOCATION_NAME: 'Clotherholme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5612624,
        LOCATION_LATITUDE_DEG: 54.1539151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036700',
        LOCATION_NAME: 'Clotton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7109583,
        LOCATION_LATITUDE_DEG: 53.1710334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036800',
        LOCATION_NAME: 'Clouds Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2493375,
        LOCATION_LATITUDE_DEG: 50.7154935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036900',
        LOCATION_NAME: 'Clough',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2822358,
        LOCATION_LATITUDE_DEG: 54.9666439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037000',
        LOCATION_NAME: 'Clough',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8406841,
        LOCATION_LATITUDE_DEG: 54.2903786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037050',
        LOCATION_NAME: 'Cloughey',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4811215,
        LOCATION_LATITUDE_DEG: 54.4274849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037100',
        LOCATION_NAME: 'Cloughfold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2830261,
        LOCATION_LATITUDE_DEG: 53.703483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990705',
        LOCATION_NAME: 'Cloughmills',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037200',
        LOCATION_NAME: 'Cloughoge',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3466847,
        LOCATION_LATITUDE_DEG: 54.1495608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037300',
        LOCATION_NAME: 'Cloughton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.446727,
        LOCATION_LATITUDE_DEG: 54.3376166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037400',
        LOCATION_NAME: 'Cloughton Newlands',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4450837,
        LOCATION_LATITUDE_DEG: 54.3469173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043700',
        LOCATION_NAME: 'Clousden Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5569182,
        LOCATION_LATITUDE_DEG: 55.0261765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037500',
        LOCATION_NAME: 'Clova',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1026808,
        LOCATION_LATITUDE_DEG: 56.8442007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037600',
        LOCATION_NAME: 'Clovelly',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3985271,
        LOCATION_LATITUDE_DEG: 50.9984434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037700',
        LOCATION_NAME: 'Clovenfords',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8730513,
        LOCATION_LATITUDE_DEG: 55.6194725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037900',
        LOCATION_NAME: 'Clowance Wood',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3202421,
        LOCATION_LATITUDE_DEG: 50.1573759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038000',
        LOCATION_NAME: 'Clowbridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2693147,
        LOCATION_LATITUDE_DEG: 53.7507886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038100',
        LOCATION_NAME: 'Clowne',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2627749,
        LOCATION_LATITUDE_DEG: 53.2788267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038200',
        LOCATION_NAME: 'Clows Top',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4193671,
        LOCATION_LATITUDE_DEG: 52.3436498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038300',
        LOCATION_NAME: 'Cloyfin',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6156471,
        LOCATION_LATITUDE_DEG: 55.1499676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038500',
        LOCATION_NAME: 'Clubmoor',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9317284,
        LOCATION_LATITUDE_DEG: 53.4333616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038600',
        LOCATION_NAME: 'Clubworthy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4450066,
        LOCATION_LATITUDE_DEG: 50.7104169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038700',
        LOCATION_NAME: 'Cluddley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5497884,
        LOCATION_LATITUDE_DEG: 52.6905924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038800',
        LOCATION_NAME: 'Cluer',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8032853,
        LOCATION_LATITUDE_DEG: 57.816231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038900',
        LOCATION_NAME: 'Clumber Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0632404,
        LOCATION_LATITUDE_DEG: 53.2642287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039000',
        LOCATION_NAME: 'Clun',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.027806,
        LOCATION_LATITUDE_DEG: 52.4209643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039100',
        LOCATION_NAME: 'Clunas',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8662378,
        LOCATION_LATITUDE_DEG: 57.5003297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039200',
        LOCATION_NAME: 'Clunbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9257871,
        LOCATION_LATITUDE_DEG: 52.4196672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039300',
        LOCATION_NAME: 'Clungunford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.883416,
        LOCATION_LATITUDE_DEG: 52.4033663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039400',
        LOCATION_NAME: 'Clunie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4486517,
        LOCATION_LATITUDE_DEG: 56.5770748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039500',
        LOCATION_NAME: 'Clunton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9782472,
        LOCATION_LATITUDE_DEG: 52.4257636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039700',
        LOCATION_NAME: 'Cluny',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2132154,
        LOCATION_LATITUDE_DEG: 56.1463348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039600',
        LOCATION_NAME: 'Cluny',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5150376,
        LOCATION_LATITUDE_DEG: 57.2038254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039800',
        LOCATION_NAME: 'Cluny Castle',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5209826,
        LOCATION_LATITUDE_DEG: 57.2016267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL039900',
        LOCATION_NAME: 'Clutton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7970117,
        LOCATION_LATITUDE_DEG: 53.0850273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040000',
        LOCATION_NAME: 'Clutton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5410016,
        LOCATION_LATITUDE_DEG: 51.33026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043000',
        LOCATION_NAME: 'Clwt y Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1336866,
        LOCATION_LATITUDE_DEG: 53.1463082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040100',
        LOCATION_NAME: 'Clwt-y-Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1336538,
        LOCATION_LATITUDE_DEG: 53.1459491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040200',
        LOCATION_NAME: 'Clwydyfagwyr',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4039111,
        LOCATION_LATITUDE_DEG: 51.7475049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040300',
        LOCATION_NAME: 'Clydach',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.910299,
        LOCATION_LATITUDE_DEG: 51.6971057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040400',
        LOCATION_NAME: 'Clydach',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.123359,
        LOCATION_LATITUDE_DEG: 51.8098089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040500',
        LOCATION_NAME: 'Clydach Vale',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4677308,
        LOCATION_LATITUDE_DEG: 51.624098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040700',
        LOCATION_NAME: 'Clydebank',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4011497,
        LOCATION_LATITUDE_DEG: 55.9044186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040800',
        LOCATION_NAME: 'Clydey',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.548117,
        LOCATION_LATITUDE_DEG: 51.9907425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040900',
        LOCATION_NAME: 'Clyffe Pypard',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8951772,
        LOCATION_LATITUDE_DEG: 51.4895621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041100',
        LOCATION_NAME: 'Clynder',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8140774,
        LOCATION_LATITUDE_DEG: 56.0230378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041200',
        LOCATION_NAME: 'Clynderwen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7290024,
        LOCATION_LATITUDE_DEG: 51.8394867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041300',
        LOCATION_NAME: 'Clyne',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7273483,
        LOCATION_LATITUDE_DEG: 51.6927083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041400',
        LOCATION_NAME: 'Clyne Common',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0256867,
        LOCATION_LATITUDE_DEG: 51.589102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041500',
        LOCATION_NAME: 'Clyne Valley',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9945764,
        LOCATION_LATITUDE_DEG: 51.6027026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041600',
        LOCATION_NAME: 'Clynnogfawr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.36325,
        LOCATION_LATITUDE_DEG: 53.0209905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041700',
        LOCATION_NAME: 'Clyro',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1484897,
        LOCATION_LATITUDE_DEG: 52.0862397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041800',
        LOCATION_NAME: 'Clyst Honiton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.432041,
        LOCATION_LATITUDE_DEG: 50.7328143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041900',
        LOCATION_NAME: 'Clyst Hydon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3671062,
        LOCATION_LATITUDE_DEG: 50.803919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042700',
        LOCATION_NAME: 'Clyst St George',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042800',
        LOCATION_NAME: 'Clyst St Lawrence',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042900',
        LOCATION_NAME: 'Clyst St Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042000',
        LOCATION_NAME: 'Clyst St. George',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4356292,
        LOCATION_LATITUDE_DEG: 50.6907039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042100',
        LOCATION_NAME: 'Clyst St. Lawrence',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3745208,
        LOCATION_LATITUDE_DEG: 50.7920136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042200',
        LOCATION_NAME: 'Clyst St. Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4544595,
        LOCATION_LATITUDE_DEG: 50.7094125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042300',
        LOCATION_NAME: 'Clytha',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9129347,
        LOCATION_LATITUDE_DEG: 51.7861465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CN000200',
        LOCATION_NAME: 'Cnwch Coch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9470171,
        LOCATION_LATITUDE_DEG: 52.3595714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000100',
        LOCATION_NAME: 'Coa',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5657601,
        LOCATION_LATITUDE_DEG: 54.3999057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000300',
        LOCATION_NAME: 'Coads Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4074054,
        LOCATION_LATITUDE_DEG: 50.5631538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000400',
        LOCATION_NAME: 'Coagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6153629,
        LOCATION_LATITUDE_DEG: 54.6489197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000500',
        LOCATION_NAME: 'Coal Aston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4560147,
        LOCATION_LATITUDE_DEG: 53.311635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000600',
        LOCATION_NAME: 'Coal Pool',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9727537,
        LOCATION_LATITUDE_DEG: 52.604375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000800',
        LOCATION_NAME: 'Coalbrookdale',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4902642,
        LOCATION_LATITUDE_DEG: 52.6393811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000900',
        LOCATION_NAME: 'Coalburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8872296,
        LOCATION_LATITUDE_DEG: 55.5893824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001000',
        LOCATION_NAME: 'Coalburns',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8002897,
        LOCATION_LATITUDE_DEG: 54.9430938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001100',
        LOCATION_NAME: 'Coalcleugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.307932,
        LOCATION_LATITUDE_DEG: 54.8017919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001200',
        LOCATION_NAME: 'Coaledge',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3579694,
        LOCATION_LATITUDE_DEG: 56.0838282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001300',
        LOCATION_NAME: 'Coaley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3345028,
        LOCATION_LATITUDE_DEG: 51.7151916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001400',
        LOCATION_NAME: 'Coalhall',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4550057,
        LOCATION_LATITUDE_DEG: 55.4478811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001500',
        LOCATION_NAME: 'Coalhaugh',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9984912,
        LOCATION_LATITUDE_DEG: 57.339063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001600',
        LOCATION_NAME: 'Coalisland',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7213797,
        LOCATION_LATITUDE_DEG: 54.5418081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001700',
        LOCATION_NAME: 'Coalmoor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.505404,
        LOCATION_LATITUDE_DEG: 52.6590883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001800',
        LOCATION_NAME: 'Coalpit Heath',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4678167,
        LOCATION_LATITUDE_DEG: 51.5256714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO001900',
        LOCATION_NAME: 'Coalport',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4398254,
        LOCATION_LATITUDE_DEG: 52.6161758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002000',
        LOCATION_NAME: 'Coalsnaughton',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.738045,
        LOCATION_LATITUDE_DEG: 56.1418372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002100',
        LOCATION_NAME: 'Coaltown Of Balgonie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1259376,
        LOCATION_LATITUDE_DEG: 56.1844354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002200',
        LOCATION_NAME: 'Coaltown of Burnturk',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0762262,
        LOCATION_LATITUDE_DEG: 56.255742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002300',
        LOCATION_NAME: 'Coaltown of Wemyss',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0894064,
        LOCATION_LATITUDE_DEG: 56.1502291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002400',
        LOCATION_NAME: 'Coalville',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3675527,
        LOCATION_LATITUDE_DEG: 52.7235811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002500',
        LOCATION_NAME: 'Coalway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5965898,
        LOCATION_LATITUDE_DEG: 51.7927004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002700',
        LOCATION_NAME: 'Coanwood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4999028,
        LOCATION_LATITUDE_DEG: 54.9268077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002900',
        LOCATION_NAME: 'Coast',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6693533,
        LOCATION_LATITUDE_DEG: 57.822022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003000',
        LOCATION_NAME: 'Coat',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7791979,
        LOCATION_LATITUDE_DEG: 50.979927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003100',
        LOCATION_NAME: 'Coatbridge',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0230327,
        LOCATION_LATITUDE_DEG: 55.8621114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003200',
        LOCATION_NAME: 'Coatdyke',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9868593,
        LOCATION_LATITUDE_DEG: 55.8623143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003300',
        LOCATION_NAME: 'Coate',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9418629,
        LOCATION_LATITUDE_DEG: 51.3533562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003400',
        LOCATION_NAME: 'Coate',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7402977,
        LOCATION_LATITUDE_DEG: 51.5453717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003600',
        LOCATION_NAME: 'Coates',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0325206,
        LOCATION_LATITUDE_DEG: 51.7047916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003700',
        LOCATION_NAME: 'Coates',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7673512,
        LOCATION_LATITUDE_DEG: 53.3246222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003500',
        LOCATION_NAME: 'Coates',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0728017,
        LOCATION_LATITUDE_DEG: 52.5613428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003800',
        LOCATION_NAME: 'Coatham',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0751909,
        LOCATION_LATITUDE_DEG: 54.6171544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO003900',
        LOCATION_NAME: 'Coatham Mundeville',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5556045,
        LOCATION_LATITUDE_DEG: 54.5794609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004000',
        LOCATION_NAME: 'Cobairdy',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7082102,
        LOCATION_LATITUDE_DEG: 57.4819574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004100',
        LOCATION_NAME: 'Coberley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0541918,
        LOCATION_LATITUDE_DEG: 51.8422996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004400',
        LOCATION_NAME: 'Cobham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4096366,
        LOCATION_LATITUDE_DEG: 51.3287339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004300',
        LOCATION_NAME: 'Cobham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.402566,
        LOCATION_LATITUDE_DEG: 51.3897274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004500',
        LOCATION_NAME: 'Cobnash',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8056778,
        LOCATION_LATITUDE_DEG: 52.2385504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004600',
        LOCATION_NAME: 'Cobridge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.180221,
        LOCATION_LATITUDE_DEG: 53.034113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078600',
        LOCATION_NAME: 'Cochrane Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9881975,
        LOCATION_LATITUDE_DEG: 55.4203565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078700',
        LOCATION_NAME: 'Cochrane Park Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5706625,
        LOCATION_LATITUDE_DEG: 50.5814952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004700',
        LOCATION_NAME: 'Cock Clarks',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6254727,
        LOCATION_LATITUDE_DEG: 51.6943471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004800',
        LOCATION_NAME: 'Cockayne Hatley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1562455,
        LOCATION_LATITUDE_DEG: 52.1301021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004900',
        LOCATION_NAME: 'Cockburnspath',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3587005,
        LOCATION_LATITUDE_DEG: 55.9327055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005000',
        LOCATION_NAME: 'Cockenzie',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9561914,
        LOCATION_LATITUDE_DEG: 55.9706115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005100',
        LOCATION_NAME: 'Cockerham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.815421,
        LOCATION_LATITUDE_DEG: 53.9631146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005200',
        LOCATION_NAME: 'Cockermouth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3659108,
        LOCATION_LATITUDE_DEG: 54.6633897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005300',
        LOCATION_NAME: 'Cockernhoe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3646428,
        LOCATION_LATITUDE_DEG: 51.8982811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005400',
        LOCATION_NAME: 'Cockett',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9785709,
        LOCATION_LATITUDE_DEG: 51.6282005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005500',
        LOCATION_NAME: 'Cockfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8039854,
        LOCATION_LATITUDE_DEG: 54.6127619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005600',
        LOCATION_NAME: 'Cockfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7856855,
        LOCATION_LATITUDE_DEG: 52.1565917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005700',
        LOCATION_NAME: 'Cockfosters',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1470362,
        LOCATION_LATITUDE_DEG: 51.6493614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005800',
        LOCATION_NAME: 'Cocking',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7480907,
        LOCATION_LATITUDE_DEG: 50.9491955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO005900',
        LOCATION_NAME: 'Cocking Causeway',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7442857,
        LOCATION_LATITUDE_DEG: 50.9657033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006000',
        LOCATION_NAME: 'Cockington Village',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.55816,
        LOCATION_LATITUDE_DEG: 50.4627908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006100',
        LOCATION_NAME: 'Cocklake',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8059504,
        LOCATION_LATITUDE_DEG: 51.2409557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006200',
        LOCATION_NAME: 'Cocklakes',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8455654,
        LOCATION_LATITUDE_DEG: 54.8501978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006300',
        LOCATION_NAME: 'Cockley Cley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6471192,
        LOCATION_LATITUDE_DEG: 52.6060382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006400',
        LOCATION_NAME: 'Cocknowle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0934226,
        LOCATION_LATITUDE_DEG: 50.635687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006500',
        LOCATION_NAME: 'Cockpole Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8484276,
        LOCATION_LATITUDE_DEG: 51.5239558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006600',
        LOCATION_NAME: 'Cocks',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1368166,
        LOCATION_LATITUDE_DEG: 50.3297858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006700',
        LOCATION_NAME: 'Cocksbarrow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8211869,
        LOCATION_LATITUDE_DEG: 50.3756902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006800',
        LOCATION_NAME: 'Cockshutford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6166582,
        LOCATION_LATITUDE_DEG: 52.4614695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO006900',
        LOCATION_NAME: 'Cockshutt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8380372,
        LOCATION_LATITUDE_DEG: 52.8575099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007000',
        LOCATION_NAME: 'Cockthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.948597,
        LOCATION_LATITUDE_DEG: 52.9403686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007100',
        LOCATION_NAME: 'Cockwells',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4711557,
        LOCATION_LATITUDE_DEG: 50.1532737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007200',
        LOCATION_NAME: 'Cockwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4479927,
        LOCATION_LATITUDE_DEG: 50.6166982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990153',
        LOCATION_NAME: 'Codda',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007300',
        LOCATION_NAME: 'Coddenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.118588,
        LOCATION_LATITUDE_DEG: 52.1451856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007400',
        LOCATION_NAME: 'Coddington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8181745,
        LOCATION_LATITUDE_DEG: 53.0923277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007500',
        LOCATION_NAME: 'Coddington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4110108,
        LOCATION_LATITUDE_DEG: 52.0816316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007600',
        LOCATION_NAME: 'Coddington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7515765,
        LOCATION_LATITUDE_DEG: 53.0812019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007700',
        LOCATION_NAME: 'Codford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0486008,
        LOCATION_LATITUDE_DEG: 51.1495367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076500',
        LOCATION_NAME: 'Codford St Mary',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007800',
        LOCATION_NAME: 'Codford St. Mary',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0401129,
        LOCATION_LATITUDE_DEG: 51.1558351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO007900',
        LOCATION_NAME: 'Codicote',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2346336,
        LOCATION_LATITUDE_DEG: 51.8491803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008000',
        LOCATION_NAME: 'Codmore Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4955699,
        LOCATION_LATITUDE_DEG: 50.9703011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008100',
        LOCATION_NAME: 'Codnor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3731752,
        LOCATION_LATITUDE_DEG: 53.0413097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008200',
        LOCATION_NAME: 'Codrington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3910814,
        LOCATION_LATITUDE_DEG: 51.5073737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008300',
        LOCATION_NAME: 'Codsall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1909378,
        LOCATION_LATITUDE_DEG: 52.6263776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008400',
        LOCATION_NAME: 'Codsall Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2276438,
        LOCATION_LATITUDE_DEG: 52.6443753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008500',
        LOCATION_NAME: 'Coed Eva',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0436861,
        LOCATION_LATITUDE_DEG: 51.6387951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008600',
        LOCATION_NAME: 'Coed Morgan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9337003,
        LOCATION_LATITUDE_DEG: 51.7975027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008800',
        LOCATION_NAME: 'Coed y Bryn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3967955,
        LOCATION_LATITUDE_DEG: 52.0727496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077300',
        LOCATION_NAME: 'Coed y Dinas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077400',
        LOCATION_NAME: 'Coed y Go',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008900',
        LOCATION_NAME: 'Coed y Parc',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0680811,
        LOCATION_LATITUDE_DEG: 53.175349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077500',
        LOCATION_NAME: 'Coed yr Allt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009000',
        LOCATION_NAME: 'Coed yr Eos',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0542813,
        LOCATION_LATITUDE_DEG: 51.7273043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008700',
        LOCATION_NAME: 'Coed Ystumgwern',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.096128,
        LOCATION_LATITUDE_DEG: 52.7926131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009400',
        LOCATION_NAME: 'Coedana',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.370508,
        LOCATION_LATITUDE_DEG: 53.3140073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009500',
        LOCATION_NAME: 'Coedcae',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0427831,
        LOCATION_LATITUDE_DEG: 51.6976956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009600',
        LOCATION_NAME: 'Coedkernew',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0459643,
        LOCATION_LATITUDE_DEG: 51.5442795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009700',
        LOCATION_NAME: 'Coedpenmaen',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3267063,
        LOCATION_LATITUDE_DEG: 51.6093914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009800',
        LOCATION_NAME: 'Coedpoeth',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0659534,
        LOCATION_LATITUDE_DEG: 53.0535322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009900',
        LOCATION_NAME: 'Coedway',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9765762,
        LOCATION_LATITUDE_DEG: 52.7268927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009100',
        LOCATION_NAME: 'Coed-y-Dinas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.147922,
        LOCATION_LATITUDE_DEG: 52.6421895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009200',
        LOCATION_NAME: 'Coed-y-Go',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.082539,
        LOCATION_LATITUDE_DEG: 52.8410123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010000',
        LOCATION_NAME: 'Coedypaen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9660152,
        LOCATION_LATITUDE_DEG: 51.6773814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO009300',
        LOCATION_NAME: 'Coed-yr-Allt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.00924,
        LOCATION_LATITUDE_DEG: 52.9450158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010100',
        LOCATION_NAME: 'Coelbren',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6663258,
        LOCATION_LATITUDE_DEG: 51.7915149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010200',
        LOCATION_NAME: 'Coffee Hall',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7508184,
        LOCATION_LATITUDE_DEG: 52.0188983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010300',
        LOCATION_NAME: 'Coffinswell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.564348,
        LOCATION_LATITUDE_DEG: 50.506395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010400',
        LOCATION_NAME: 'Cogan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1987016,
        LOCATION_LATITUDE_DEG: 51.4328704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010500',
        LOCATION_NAME: 'Cogenhoe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7822504,
        LOCATION_LATITUDE_DEG: 52.2372215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010600',
        LOCATION_NAME: 'Coggeshall',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.687152,
        LOCATION_LATITUDE_DEG: 51.8703659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010700',
        LOCATION_NAME: 'Coggins Mill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2777094,
        LOCATION_LATITUDE_DEG: 51.0249953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010900',
        LOCATION_NAME: 'Coilleag',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2990618,
        LOCATION_LATITUDE_DEG: 57.0739674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011000',
        LOCATION_NAME: 'Coity',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5537786,
        LOCATION_LATITUDE_DEG: 51.521485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011100',
        LOCATION_NAME: 'Cokers Frome',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4279524,
        LOCATION_LATITUDE_DEG: 50.7194986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011200',
        LOCATION_NAME: 'Colan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0012891,
        LOCATION_LATITUDE_DEG: 50.4116001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011300',
        LOCATION_NAME: 'Colaton Raleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3053515,
        LOCATION_LATITUDE_DEG: 50.6801026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011500',
        LOCATION_NAME: 'Colbost',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6444336,
        LOCATION_LATITUDE_DEG: 57.4442991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011600',
        LOCATION_NAME: 'Colburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6874484,
        LOCATION_LATITUDE_DEG: 54.3791434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011850',
        LOCATION_NAME: 'Colby',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7031628,
        LOCATION_LATITUDE_DEG: 54.0975637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011700',
        LOCATION_NAME: 'Colby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5173587,
        LOCATION_LATITUDE_DEG: 54.5776701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011800',
        LOCATION_NAME: 'Colby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2998187,
        LOCATION_LATITUDE_DEG: 52.8359471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011900',
        LOCATION_NAME: 'Colchester',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9009736,
        LOCATION_LATITUDE_DEG: 51.8892642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012000',
        LOCATION_NAME: 'Colcot',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2792132,
        LOCATION_LATITUDE_DEG: 51.4173696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012100',
        LOCATION_NAME: 'Cold Ash',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2630615,
        LOCATION_LATITUDE_DEG: 51.4237511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012200',
        LOCATION_NAME: 'Cold Ashby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0357621,
        LOCATION_LATITUDE_DEG: 52.3809394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012300',
        LOCATION_NAME: 'Cold Ashton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.360865,
        LOCATION_LATITUDE_DEG: 51.4510691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012400',
        LOCATION_NAME: 'Cold Aston',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8125623,
        LOCATION_LATITUDE_DEG: 51.8759006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012500',
        LOCATION_NAME: 'Cold Blow',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7213817,
        LOCATION_LATITUDE_DEG: 51.7822251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012600',
        LOCATION_NAME: 'Cold Brayfield',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6398705,
        LOCATION_LATITUDE_DEG: 52.1606099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012700',
        LOCATION_NAME: 'Cold Cotes',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4317468,
        LOCATION_LATITUDE_DEG: 54.1355228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012800',
        LOCATION_NAME: 'Cold Hanworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4517841,
        LOCATION_LATITUDE_DEG: 53.3349246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013000',
        LOCATION_NAME: 'Cold Harbour',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8806639,
        LOCATION_LATITUDE_DEG: 51.7350014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013100',
        LOCATION_NAME: 'Cold Harbour',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5025471,
        LOCATION_LATITUDE_DEG: 51.3995536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO012900',
        LOCATION_NAME: 'Cold Harbour',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.586346,
        LOCATION_LATITUDE_DEG: 52.9018807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013200',
        LOCATION_NAME: 'Cold Hatton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5471932,
        LOCATION_LATITUDE_DEG: 52.7894933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013300',
        LOCATION_NAME: 'Cold Hesledon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3619493,
        LOCATION_LATITUDE_DEG: 54.8164765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013400',
        LOCATION_NAME: 'Cold Hiendley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4364298,
        LOCATION_LATITUDE_DEG: 53.6229631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013500',
        LOCATION_NAME: 'Cold Higham',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0302758,
        LOCATION_LATITUDE_DEG: 52.175022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013600',
        LOCATION_NAME: 'Cold Inn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7467496,
        LOCATION_LATITUDE_DEG: 51.7152191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013700',
        LOCATION_NAME: 'Cold Kirby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1822818,
        LOCATION_LATITUDE_DEG: 54.253618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013800',
        LOCATION_NAME: 'Cold Newton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9401137,
        LOCATION_LATITUDE_DEG: 52.6507601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO013900',
        LOCATION_NAME: 'Cold Norton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6714918,
        LOCATION_LATITUDE_DEG: 51.6716503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014000',
        LOCATION_NAME: 'Cold Overton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7982785,
        LOCATION_LATITUDE_DEG: 52.6851647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014100',
        LOCATION_NAME: 'Cold Weston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6603575,
        LOCATION_LATITUDE_DEG: 52.443467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014200',
        LOCATION_NAME: 'Coldbackie',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3769444,
        LOCATION_LATITUDE_DEG: 58.5060809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014300',
        LOCATION_NAME: 'Coldbrook',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0028459,
        LOCATION_LATITUDE_DEG: 51.8044688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014400',
        LOCATION_NAME: 'Coldean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1083165,
        LOCATION_LATITUDE_DEG: 50.8631861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014500',
        LOCATION_NAME: 'Colden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0512229,
        LOCATION_LATITUDE_DEG: 53.7549814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014600',
        LOCATION_NAME: 'Colden Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3202948,
        LOCATION_LATITUDE_DEG: 50.9969073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014700',
        LOCATION_NAME: 'Coldfair Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5617072,
        LOCATION_LATITUDE_DEG: 52.1918867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014800',
        LOCATION_NAME: 'Coldham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1180295,
        LOCATION_LATITUDE_DEG: 52.6038443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990205',
        LOCATION_NAME: 'Coldharbour',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5112715,
        LOCATION_LATITUDE_DEG: 50.9535363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015000',
        LOCATION_NAME: 'Coldharbour',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4908373,
        LOCATION_LATITUDE_DEG: 50.6308863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO014900',
        LOCATION_NAME: 'Coldharbour',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3564003,
        LOCATION_LATITUDE_DEG: 51.1802146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015100',
        LOCATION_NAME: 'Coldingham',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1559356,
        LOCATION_LATITUDE_DEG: 55.8860968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015200',
        LOCATION_NAME: 'Coldmeece',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.214657,
        LOCATION_LATITUDE_DEG: 52.8927015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015300',
        LOCATION_NAME: 'Coldred',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2472939,
        LOCATION_LATITUDE_DEG: 51.1760953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015400',
        LOCATION_NAME: 'Coldridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8512426,
        LOCATION_LATITUDE_DEG: 50.8533293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015500',
        LOCATION_NAME: 'Coldrife',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8950265,
        LOCATION_LATITUDE_DEG: 55.2472276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015600',
        LOCATION_NAME: 'Coldstream',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2476809,
        LOCATION_LATITUDE_DEG: 55.6527747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015700',
        LOCATION_NAME: 'Coldvreath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8339854,
        LOCATION_LATITUDE_DEG: 50.3897909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015800',
        LOCATION_NAME: 'Coldwaltham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5410989,
        LOCATION_LATITUDE_DEG: 50.9378979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO015900',
        LOCATION_NAME: 'Cole',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.473689,
        LOCATION_LATITUDE_DEG: 51.1011309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016000',
        LOCATION_NAME: 'Cole Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1408547,
        LOCATION_LATITUDE_DEG: 51.7875712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016100',
        LOCATION_NAME: 'Cole Henley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3249338,
        LOCATION_LATITUDE_DEG: 51.2552373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016200',
        LOCATION_NAME: 'Colebatch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0033488,
        LOCATION_LATITUDE_DEG: 52.4766694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016300',
        LOCATION_NAME: 'Colebrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4104172,
        LOCATION_LATITUDE_DEG: 50.845118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016400',
        LOCATION_NAME: 'Colebrooke',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7416872,
        LOCATION_LATITUDE_DEG: 50.7838165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016500',
        LOCATION_NAME: 'Coleby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6397083,
        LOCATION_LATITUDE_DEG: 53.6662565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016600',
        LOCATION_NAME: 'Coleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5418117,
        LOCATION_LATITUDE_DEG: 53.1331031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016900',
        LOCATION_NAME: 'Coleford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7426264,
        LOCATION_LATITUDE_DEG: 50.7957201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016700',
        LOCATION_NAME: 'Coleford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6148723,
        LOCATION_LATITUDE_DEG: 51.7935054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO016800',
        LOCATION_NAME: 'Coleford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4472817,
        LOCATION_LATITUDE_DEG: 51.2419494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017000',
        LOCATION_NAME: 'Colehill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9619871,
        LOCATION_LATITUDE_DEG: 50.8094047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017100',
        LOCATION_NAME: 'Colemans Hatch',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0728892,
        LOCATION_LATITUDE_DEG: 51.0819037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017200',
        LOCATION_NAME: 'Colemere',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8429204,
        LOCATION_LATITUDE_DEG: 52.8872075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017300',
        LOCATION_NAME: 'Colemore',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9912004,
        LOCATION_LATITUDE_DEG: 51.0647145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017400',
        LOCATION_NAME: 'Colenden',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4462605,
        LOCATION_LATITUDE_DEG: 56.4516654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017500',
        LOCATION_NAME: 'Coleorton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4034356,
        LOCATION_LATITUDE_DEG: 52.7515754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017600',
        LOCATION_NAME: 'Coleraine',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6736542,
        LOCATION_LATITUDE_DEG: 55.1341666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017700',
        LOCATION_NAME: 'Colerne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2602392,
        LOCATION_LATITUDE_DEG: 51.4371633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017800',
        LOCATION_NAME: 'Coles Hill',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6491744,
        LOCATION_LATITUDE_DEG: 54.3442932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO017900',
        LOCATION_NAME: 'Colesbourne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0095905,
        LOCATION_LATITUDE_DEG: 51.8181952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018000',
        LOCATION_NAME: 'Colesbrook',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2768248,
        LOCATION_LATITUDE_DEG: 51.049827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018100',
        LOCATION_NAME: 'Colesden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3509878,
        LOCATION_LATITUDE_DEG: 52.1888116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018300',
        LOCATION_NAME: 'Coleshill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7040408,
        LOCATION_LATITUDE_DEG: 52.4970613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018350',
        LOCATION_NAME: 'Coleshill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6586972,
        LOCATION_LATITUDE_DEG: 51.6415433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018200',
        LOCATION_NAME: 'Coleshill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6299781,
        LOCATION_LATITUDE_DEG: 51.6472665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018400',
        LOCATION_NAME: 'Colestocks',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2727334,
        LOCATION_LATITUDE_DEG: 50.810716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018500',
        LOCATION_NAME: 'Colesty',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0269978,
        LOCATION_LATITUDE_DEG: 52.4475681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018600',
        LOCATION_NAME: 'Colethrop',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2553798,
        LOCATION_LATITUDE_DEG: 51.7956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018700',
        LOCATION_NAME: 'Colfin',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.027129,
        LOCATION_LATITUDE_DEG: 54.855924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018900',
        LOCATION_NAME: 'Colgate',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2427192,
        LOCATION_LATITUDE_DEG: 51.0810044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019000',
        LOCATION_NAME: 'Colhook Common',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6210743,
        LOCATION_LATITUDE_DEG: 51.0353017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079000',
        LOCATION_NAME: 'Colindale',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2551724,
        LOCATION_LATITUDE_DEG: 51.5910241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019100',
        LOCATION_NAME: 'Colinsburgh',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8448488,
        LOCATION_LATITUDE_DEG: 56.220633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019200',
        LOCATION_NAME: 'Colinton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2513378,
        LOCATION_LATITUDE_DEG: 55.9083063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019300',
        LOCATION_NAME: 'Colintraive',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.151483,
        LOCATION_LATITUDE_DEG: 55.923732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019400',
        LOCATION_NAME: 'Colkirk',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8493668,
        LOCATION_LATITUDE_DEG: 52.8008569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019500',
        LOCATION_NAME: 'Coll',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3234728,
        LOCATION_LATITUDE_DEG: 58.2764746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019600',
        LOCATION_NAME: 'Collace',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2902042,
        LOCATION_LATITUDE_DEG: 56.475563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019700',
        LOCATION_NAME: 'Collaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7981887,
        LOCATION_LATITUDE_DEG: 50.2385711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019800',
        LOCATION_NAME: 'Collaton Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.005415,
        LOCATION_LATITUDE_DEG: 50.3296752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990770',
        LOCATION_NAME: 'Collegeland',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020000',
        LOCATION_NAME: 'Collessie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1524601,
        LOCATION_LATITUDE_DEG: 56.3058447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020100',
        LOCATION_NAME: 'Colleton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8961857,
        LOCATION_LATITUDE_DEG: 50.919832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020200',
        LOCATION_NAME: 'Collier Row',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.163675,
        LOCATION_LATITUDE_DEG: 51.5985464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020300',
        LOCATION_NAME: 'Collier Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4566863,
        LOCATION_LATITUDE_DEG: 51.187305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020400',
        LOCATION_NAME: 'Colliers End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0083442,
        LOCATION_LATITUDE_DEG: 51.867779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020500',
        LOCATION_NAME: 'Colliers Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5205357,
        LOCATION_LATITUDE_DEG: 51.1229999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079100',
        LOCATION_NAME: 'Colliers Wood',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1788752,
        LOCATION_LATITUDE_DEG: 51.417675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020700',
        LOCATION_NAME: 'Colliery Row',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4925549,
        LOCATION_LATITUDE_DEG: 54.8390853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020800',
        LOCATION_NAME: 'Collieston',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9329258,
        LOCATION_LATITUDE_DEG: 57.3490372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990155',
        LOCATION_NAME: 'Colliford Lake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5879941,
        LOCATION_LATITUDE_DEG: 50.5316796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020900',
        LOCATION_NAME: 'Collin',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5208293,
        LOCATION_LATITUDE_DEG: 55.068129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021000',
        LOCATION_NAME: 'Collingbourne Ducis',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6512777,
        LOCATION_LATITUDE_DEG: 51.2814397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021100',
        LOCATION_NAME: 'Collingbourne Kingston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6570389,
        LOCATION_LATITUDE_DEG: 51.3011421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021200',
        LOCATION_NAME: 'Collingham',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4173055,
        LOCATION_LATITUDE_DEG: 53.9075955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021300',
        LOCATION_NAME: 'Collingham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7577863,
        LOCATION_LATITUDE_DEG: 53.1476088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021400',
        LOCATION_NAME: 'Collington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5125084,
        LOCATION_LATITUDE_DEG: 52.2400434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021500',
        LOCATION_NAME: 'Collingtree',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9016047,
        LOCATION_LATITUDE_DEG: 52.1926242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021600',
        LOCATION_NAME: 'Collins Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6626064,
        LOCATION_LATITUDE_DEG: 53.4427629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022000',
        LOCATION_NAME: 'Collipriest',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4846436,
        LOCATION_LATITUDE_DEG: 50.8889247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022200',
        LOCATION_NAME: 'Collone',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.557859,
        LOCATION_LATITUDE_DEG: 54.2885835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078500',
        LOCATION_NAME: 'Collyhurst',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2225912,
        LOCATION_LATITUDE_DEG: 53.4930984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022500',
        LOCATION_NAME: 'Collyweston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5280918,
        LOCATION_LATITUDE_DEG: 52.6133591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022700',
        LOCATION_NAME: 'Colmonell',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9063303,
        LOCATION_LATITUDE_DEG: 55.1329554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022800',
        LOCATION_NAME: 'Colmworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3766031,
        LOCATION_LATITUDE_DEG: 52.2162158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022900',
        LOCATION_NAME: 'Coln Rogers',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8748628,
        LOCATION_LATITUDE_DEG: 51.7849933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076700',
        LOCATION_NAME: 'Coln St Aldwyns',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076800',
        LOCATION_NAME: 'Coln St Dennis',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023000',
        LOCATION_NAME: 'Coln St. Aldwyns',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7901868,
        LOCATION_LATITUDE_DEG: 51.7483917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023100',
        LOCATION_NAME: 'Coln St. Dennis',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8752356,
        LOCATION_LATITUDE_DEG: 51.7969981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023200',
        LOCATION_NAME: 'Colnbrook',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5197649,
        LOCATION_LATITUDE_DEG: 51.4825424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023300',
        LOCATION_NAME: 'Colne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.166234,
        LOCATION_LATITUDE_DEG: 53.8563002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023400',
        LOCATION_NAME: 'Colne',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0144707,
        LOCATION_LATITUDE_DEG: 52.3629277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023500',
        LOCATION_NAME: 'Colne Engaine',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6927481,
        LOCATION_LATITUDE_DEG: 51.9408698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023600',
        LOCATION_NAME: 'Colnebridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.731411,
        LOCATION_LATITUDE_DEG: 53.6773757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023700',
        LOCATION_NAME: 'Colney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2229519,
        LOCATION_LATITUDE_DEG: 52.6249292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023800',
        LOCATION_NAME: 'Colney Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2515528,
        LOCATION_LATITUDE_DEG: 51.7377665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO023900',
        LOCATION_NAME: 'Colney Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3283988,
        LOCATION_LATITUDE_DEG: 51.7066628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024000',
        LOCATION_NAME: 'Colpy',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5950845,
        LOCATION_LATITUDE_DEG: 57.3811497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024100',
        LOCATION_NAME: 'Colsterworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6190569,
        LOCATION_LATITUDE_DEG: 52.8069774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO080100',
        LOCATION_NAME: 'Colston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2318771,
        LOCATION_LATITUDE_DEG: 55.8963504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024200',
        LOCATION_NAME: 'Colston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9695992,
        LOCATION_LATITUDE_DEG: 50.8084128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024300',
        LOCATION_NAME: 'Colston Bassett',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9603452,
        LOCATION_LATITUDE_DEG: 52.891888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024400',
        LOCATION_NAME: 'Colthouse',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9884546,
        LOCATION_LATITUDE_DEG: 54.3761579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024500',
        LOCATION_NAME: 'Colthrop',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2264033,
        LOCATION_LATITUDE_DEG: 51.3943512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024600',
        LOCATION_NAME: 'Coltishall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3636842,
        LOCATION_LATITUDE_DEG: 52.7275385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024700',
        LOCATION_NAME: 'Colton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0504207,
        LOCATION_LATITUDE_DEG: 54.2660443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025000',
        LOCATION_NAME: 'Colton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9222732,
        LOCATION_LATITUDE_DEG: 52.7819906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024900',
        LOCATION_NAME: 'Colton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4447503,
        LOCATION_LATITUDE_DEG: 53.7929802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO024800',
        LOCATION_NAME: 'Colton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1180368,
        LOCATION_LATITUDE_DEG: 52.6450355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025100',
        LOCATION_NAME: 'Colvend',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7675388,
        LOCATION_LATITUDE_DEG: 54.8718183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025200',
        LOCATION_NAME: 'Colveston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6471998,
        LOCATION_LATITUDE_DEG: 52.5243315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025300',
        LOCATION_NAME: 'Colwall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3804225,
        LOCATION_LATITUDE_DEG: 52.0784254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025400',
        LOCATION_NAME: 'Colwall Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3657651,
        LOCATION_LATITUDE_DEG: 52.0688237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025500',
        LOCATION_NAME: 'Colwell',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0770151,
        LOCATION_LATITUDE_DEG: 55.0740153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025600',
        LOCATION_NAME: 'Colwich',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9789719,
        LOCATION_LATITUDE_DEG: 52.786986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025700',
        LOCATION_NAME: 'Colwick',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0930691,
        LOCATION_LATITUDE_DEG: 52.9536984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025800',
        LOCATION_NAME: 'Colwick Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1024582,
        LOCATION_LATITUDE_DEG: 52.949598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO025900',
        LOCATION_NAME: 'Colwinston',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5250962,
        LOCATION_LATITUDE_DEG: 51.4689812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026000',
        LOCATION_NAME: 'Colworth',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7025599,
        LOCATION_LATITUDE_DEG: 50.8170904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026100',
        LOCATION_NAME: 'Colwyn Bay',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7051058,
        LOCATION_LATITUDE_DEG: 53.289755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026200',
        LOCATION_NAME: 'Colyford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0631432,
        LOCATION_LATITUDE_DEG: 50.7265084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026300',
        LOCATION_NAME: 'Colyton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0697957,
        LOCATION_LATITUDE_DEG: 50.7380049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026400',
        LOCATION_NAME: 'Colyton Hill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0871111,
        LOCATION_LATITUDE_DEG: 50.7323044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026600',
        LOCATION_NAME: 'Combe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0442124,
        LOCATION_LATITUDE_DEG: 50.3505792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026500',
        LOCATION_NAME: 'Combe',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.466137,
        LOCATION_LATITUDE_DEG: 51.3459493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026700',
        LOCATION_NAME: 'Combe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4016318,
        LOCATION_LATITUDE_DEG: 51.8393965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026800',
        LOCATION_NAME: 'Combe Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3435242,
        LOCATION_LATITUDE_DEG: 51.3592609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO026900',
        LOCATION_NAME: 'Combe Florey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2106976,
        LOCATION_LATITUDE_DEG: 51.0726366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027000',
        LOCATION_NAME: 'Combe Hay',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3807628,
        LOCATION_LATITUDE_DEG: 51.3376531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027100',
        LOCATION_NAME: 'Combe Martin',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0277098,
        LOCATION_LATITUDE_DEG: 51.2016633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027200',
        LOCATION_NAME: 'Combe Raleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1914562,
        LOCATION_LATITUDE_DEG: 50.8143176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076900',
        LOCATION_NAME: 'Combe St Nicholas',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027300',
        LOCATION_NAME: 'Combe St. Nicholas',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9913513,
        LOCATION_LATITUDE_DEG: 50.8958204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027400',
        LOCATION_NAME: 'Combeinteignhead',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5498583,
        LOCATION_LATITUDE_DEG: 50.5333929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027500',
        LOCATION_NAME: 'Comber',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.753581,
        LOCATION_LATITUDE_DEG: 54.5532943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027600',
        LOCATION_NAME: 'Comberbach',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5330336,
        LOCATION_LATITUDE_DEG: 53.291646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027700',
        LOCATION_NAME: 'Comberford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7149191,
        LOCATION_LATITUDE_DEG: 52.6621786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027800',
        LOCATION_NAME: 'Comberton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7386075,
        LOCATION_LATITUDE_DEG: 52.3052566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO027900',
        LOCATION_NAME: 'Comberton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0207404,
        LOCATION_LATITUDE_DEG: 52.1866082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028000',
        LOCATION_NAME: 'Combpyne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0040496,
        LOCATION_LATITUDE_DEG: 50.7256023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028100',
        LOCATION_NAME: 'Combridge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8587376,
        LOCATION_LATITUDE_DEG: 52.9372058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028200',
        LOCATION_NAME: 'Combrook',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5506566,
        LOCATION_LATITUDE_DEG: 52.1622275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028300',
        LOCATION_NAME: 'Combs',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9378079,
        LOCATION_LATITUDE_DEG: 53.3035366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028400',
        LOCATION_NAME: 'Combs',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.989213,
        LOCATION_LATITUDE_DEG: 52.1691898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028500',
        LOCATION_NAME: 'Combwich',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.061104,
        LOCATION_LATITUDE_DEG: 51.1717497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079900',
        LOCATION_NAME: 'Comely Bank',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2221315,
        LOCATION_LATITUDE_DEG: 55.9599131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028600',
        LOCATION_NAME: 'Comers',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5399874,
        LOCATION_LATITUDE_DEG: 57.1575238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028700',
        LOCATION_NAME: 'Comford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1755263,
        LOCATION_LATITUDE_DEG: 50.2144821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028800',
        LOCATION_NAME: 'Comins Coch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0381928,
        LOCATION_LATITUDE_DEG: 52.4196777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO028900',
        LOCATION_NAME: 'Comley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7602702,
        LOCATION_LATITUDE_DEG: 52.5632768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029000',
        LOCATION_NAME: 'Commins',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3340244,
        LOCATION_LATITUDE_DEG: 52.8403137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029100',
        LOCATION_NAME: 'Commins Coch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7056941,
        LOCATION_LATITUDE_DEG: 52.6137926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029200',
        LOCATION_NAME: 'Common End',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5410345,
        LOCATION_LATITUDE_DEG: 54.5886855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029300',
        LOCATION_NAME: 'Commondale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9754907,
        LOCATION_LATITUDE_DEG: 54.4859398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029400',
        LOCATION_NAME: 'Commonmoor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4696109,
        LOCATION_LATITUDE_DEG: 50.5006355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029600',
        LOCATION_NAME: 'Compstall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0532054,
        LOCATION_LATITUDE_DEG: 53.4145545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030200',
        LOCATION_NAME: 'Compton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5932542,
        LOCATION_LATITUDE_DEG: 50.471787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029800',
        LOCATION_NAME: 'Compton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.170321,
        LOCATION_LATITUDE_DEG: 52.5868764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030000',
        LOCATION_NAME: 'Compton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3983277,
        LOCATION_LATITUDE_DEG: 53.8986927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030300',
        LOCATION_NAME: 'Compton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3384836,
        LOCATION_LATITUDE_DEG: 51.019711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030100',
        LOCATION_NAME: 'Compton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2516935,
        LOCATION_LATITUDE_DEG: 51.5155577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029900',
        LOCATION_NAME: 'Compton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8955063,
        LOCATION_LATITUDE_DEG: 50.9270024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029700',
        LOCATION_NAME: 'Compton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6330213,
        LOCATION_LATITUDE_DEG: 51.2151257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030400',
        LOCATION_NAME: 'Compton Abbas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1797617,
        LOCATION_LATITUDE_DEG: 50.965318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030500',
        LOCATION_NAME: 'Compton Abdale',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.912017,
        LOCATION_LATITUDE_DEG: 51.8475035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030600',
        LOCATION_NAME: 'Compton Bassett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9652455,
        LOCATION_LATITUDE_DEG: 51.4463586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030700',
        LOCATION_NAME: 'Compton Beauchamp',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5959437,
        LOCATION_LATITUDE_DEG: 51.581266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030800',
        LOCATION_NAME: 'Compton Bishop',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8629999,
        LOCATION_LATITUDE_DEG: 51.2944535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO030900',
        LOCATION_NAME: 'Compton Chamberlayne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9582511,
        LOCATION_LATITUDE_DEG: 51.0669287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031000',
        LOCATION_NAME: 'Compton Dando',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5075738,
        LOCATION_LATITUDE_DEG: 51.3787639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031100',
        LOCATION_NAME: 'Compton Dundon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7291433,
        LOCATION_LATITUDE_DEG: 51.0922356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031200',
        LOCATION_NAME: 'Compton Durville',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8258897,
        LOCATION_LATITUDE_DEG: 50.952122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031300',
        LOCATION_NAME: 'Compton Martin',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6535308,
        LOCATION_LATITUDE_DEG: 51.3101536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031400',
        LOCATION_NAME: 'Compton Pauncefoot',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5051889,
        LOCATION_LATITUDE_DEG: 51.0320298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031500',
        LOCATION_NAME: 'Compton Scorpion',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6889592,
        LOCATION_LATITUDE_DEG: 52.0631183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031600',
        LOCATION_NAME: 'Compton Valence',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5771198,
        LOCATION_LATITUDE_DEG: 50.7366993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031700',
        LOCATION_NAME: 'Compton Verney',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5471978,
        LOCATION_LATITUDE_DEG: 52.1731301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031800',
        LOCATION_NAME: 'Compton Wynyates',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5182954,
        LOCATION_LATITUDE_DEG: 52.0746202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO031900',
        LOCATION_NAME: 'Comrie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9824422,
        LOCATION_LATITUDE_DEG: 56.3760633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032000',
        LOCATION_NAME: 'Comrie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5761961,
        LOCATION_LATITUDE_DEG: 56.0861326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032100',
        LOCATION_NAME: 'Conder Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8233819,
        LOCATION_LATITUDE_DEG: 53.9973175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032200',
        LOCATION_NAME: 'Conderton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.051607,
        LOCATION_LATITUDE_DEG: 52.0318217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032300',
        LOCATION_NAME: 'Condicote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7788596,
        LOCATION_LATITUDE_DEG: 51.952507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032400',
        LOCATION_NAME: 'Condorrat',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0141678,
        LOCATION_LATITUDE_DEG: 55.9338189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032500',
        LOCATION_NAME: 'Condover',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7480891,
        LOCATION_LATITUDE_DEG: 52.6502885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032600',
        LOCATION_NAME: 'Coney Hall',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0031453,
        LOCATION_LATITUDE_DEG: 51.3678286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032700',
        LOCATION_NAME: 'Coney Weston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8695222,
        LOCATION_LATITUDE_DEG: 52.3658085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032800',
        LOCATION_NAME: 'Coneyhurst',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4259298,
        LOCATION_LATITUDE_DEG: 51.0048016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO032900',
        LOCATION_NAME: 'Coneysthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9104727,
        LOCATION_LATITUDE_DEG: 54.1318072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033000',
        LOCATION_NAME: 'Coneythorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.399661,
        LOCATION_LATITUDE_DEG: 54.0243015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033100',
        LOCATION_NAME: 'Conford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8178345,
        LOCATION_LATITUDE_DEG: 51.0924177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033400',
        LOCATION_NAME: 'Congdons Shop',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4342514,
        LOCATION_LATITUDE_DEG: 50.5801097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033500',
        LOCATION_NAME: 'Congerstone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4554954,
        LOCATION_LATITUDE_DEG: 52.645267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033600',
        LOCATION_NAME: 'Congham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5402411,
        LOCATION_LATITUDE_DEG: 52.7818553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077600',
        LOCATION_NAME: 'Congl Y Wal',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033800',
        LOCATION_NAME: 'Congleton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2085273,
        LOCATION_LATITUDE_DEG: 53.1637307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033700',
        LOCATION_NAME: 'Congl-Y-Wal',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9285492,
        LOCATION_LATITUDE_DEG: 52.9814326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033900',
        LOCATION_NAME: 'Congresbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8083049,
        LOCATION_LATITUDE_DEG: 51.3702678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034000',
        LOCATION_NAME: 'Conholt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5283437,
        LOCATION_LATITUDE_DEG: 51.2913419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034100',
        LOCATION_NAME: 'Conicavel',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6820374,
        LOCATION_LATITUDE_DEG: 57.5605779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034300',
        LOCATION_NAME: 'Coningsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.172772,
        LOCATION_LATITUDE_DEG: 53.1055954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034400',
        LOCATION_NAME: 'Coningsby Moorside',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1480458,
        LOCATION_LATITUDE_DEG: 53.1014009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034500',
        LOCATION_NAME: 'Conington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2690118,
        LOCATION_LATITUDE_DEG: 52.4579362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034600',
        LOCATION_NAME: 'Conington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0640426,
        LOCATION_LATITUDE_DEG: 52.2772195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034700',
        LOCATION_NAME: 'Conisbrough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2273008,
        LOCATION_LATITUDE_DEG: 53.4831488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034800',
        LOCATION_NAME: 'Conisholme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1112007,
        LOCATION_LATITUDE_DEG: 53.4379262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034900',
        LOCATION_NAME: 'Conista',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3227421,
        LOCATION_LATITUDE_DEG: 57.6754131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035000',
        LOCATION_NAME: 'Coniston',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0743334,
        LOCATION_LATITUDE_DEG: 54.3688535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035100',
        LOCATION_NAME: 'Coniston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2436199,
        LOCATION_LATITUDE_DEG: 53.7990674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035200',
        LOCATION_NAME: 'Coniston Cold',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1470163,
        LOCATION_LATITUDE_DEG: 53.9910049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035300',
        LOCATION_NAME: 'Conistone',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0290907,
        LOCATION_LATITUDE_DEG: 54.1028201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035400',
        LOCATION_NAME: 'Conlig',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6821735,
        LOCATION_LATITUDE_DEG: 54.6166053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076600',
        LOCATION_NAME: 'Connahs Quay',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035600',
        LOCATION_NAME: "Connah's Quay",
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0597582,
        LOCATION_LATITUDE_DEG: 53.2156133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035700',
        LOCATION_NAME: 'Connel',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3847192,
        LOCATION_LATITUDE_DEG: 56.4546872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035800',
        LOCATION_NAME: 'Connel Park',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1993973,
        LOCATION_LATITUDE_DEG: 55.3887694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035900',
        LOCATION_NAME: 'Conniburrow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7568762,
        LOCATION_LATITUDE_DEG: 52.0501024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036200',
        LOCATION_NAME: 'Connor',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1989133,
        LOCATION_LATITUDE_DEG: 54.7999337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036300',
        LOCATION_NAME: 'Connor Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3749808,
        LOCATION_LATITUDE_DEG: 50.2031765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036400',
        LOCATION_NAME: 'Conock',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9024802,
        LOCATION_LATITUDE_DEG: 51.3138518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036500',
        LOCATION_NAME: 'Conon Bridge',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4345137,
        LOCATION_LATITUDE_DEG: 57.5655831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036600',
        LOCATION_NAME: 'Cononley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0181054,
        LOCATION_LATITUDE_DEG: 53.9186979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036700',
        LOCATION_NAME: 'Conordan',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1485789,
        LOCATION_LATITUDE_DEG: 57.3666852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036800',
        LOCATION_NAME: 'Consett',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8408164,
        LOCATION_LATITUDE_DEG: 54.8606855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036900',
        LOCATION_NAME: 'Constable Burton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7483183,
        LOCATION_LATITUDE_DEG: 54.3130334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037000',
        LOCATION_NAME: 'Constantine',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1767075,
        LOCATION_LATITUDE_DEG: 50.1182714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037100',
        LOCATION_NAME: 'Constantine Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.01083,
        LOCATION_LATITUDE_DEG: 50.5295037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037200',
        LOCATION_NAME: 'Contin',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5775737,
        LOCATION_LATITUDE_DEG: 57.5681896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037400',
        LOCATION_NAME: 'Conwy',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8271768,
        LOCATION_LATITUDE_DEG: 53.2814553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037500',
        LOCATION_NAME: 'Conyer',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8185014,
        LOCATION_LATITUDE_DEG: 51.3456176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037600',
        LOCATION_NAME: 'Cooden',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4216247,
        LOCATION_LATITUDE_DEG: 50.8390692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037700',
        LOCATION_NAME: 'Cookbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.262708,
        LOCATION_LATITUDE_DEG: 50.8312325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037800',
        LOCATION_NAME: 'Cookham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7056513,
        LOCATION_LATITUDE_DEG: 51.5594553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037900',
        LOCATION_NAME: 'Cookham Dean',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7439971,
        LOCATION_LATITUDE_DEG: 51.557453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038000',
        LOCATION_NAME: 'Cookham Rise',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7217528,
        LOCATION_LATITUDE_DEG: 51.5527523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038100',
        LOCATION_NAME: 'Cookhill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9190307,
        LOCATION_LATITUDE_DEG: 52.2261395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038200',
        LOCATION_NAME: 'Cookley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2309585,
        LOCATION_LATITUDE_DEG: 52.4202605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038300',
        LOCATION_NAME: 'Cookley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4597761,
        LOCATION_LATITUDE_DEG: 52.3227035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038400',
        LOCATION_NAME: 'Cookley Green',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9958857,
        LOCATION_LATITUDE_DEG: 51.6053638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038500',
        LOCATION_NAME: 'Cookney',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2125308,
        LOCATION_LATITUDE_DEG: 57.0304091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078200',
        LOCATION_NAME: 'Cookridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6165372,
        LOCATION_LATITUDE_DEG: 53.8593084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038600',
        LOCATION_NAME: 'Cooksbridge',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0061812,
        LOCATION_LATITUDE_DEG: 50.9045875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038700',
        LOCATION_NAME: 'Cooksmill Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3723442,
        LOCATION_LATITUDE_DEG: 51.7308623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038800',
        LOCATION_NAME: 'Cookstown',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7420718,
        LOCATION_LATITUDE_DEG: 54.6426922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990793',
        LOCATION_NAME: 'Coolacrim',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040600',
        LOCATION_NAME: 'Coole Pilate',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5136888,
        LOCATION_LATITUDE_DEG: 53.0168231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041200',
        LOCATION_NAME: 'Coolham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4036368,
        LOCATION_LATITUDE_DEG: 50.992699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041300',
        LOCATION_NAME: 'Cooling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5254526,
        LOCATION_LATITUDE_DEG: 51.4541337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042600',
        LOCATION_NAME: 'Coombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.880647,
        LOCATION_LATITUDE_DEG: 50.3256871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042400',
        LOCATION_NAME: 'Coombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6458311,
        LOCATION_LATITUDE_DEG: 50.6430064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042500',
        LOCATION_NAME: 'Coombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.33623,
        LOCATION_LATITUDE_DEG: 51.6454876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042700',
        LOCATION_NAME: 'Coombe Bissett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8454389,
        LOCATION_LATITUDE_DEG: 51.0362211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042800',
        LOCATION_NAME: 'Coombe Dingle',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6405558,
        LOCATION_LATITUDE_DEG: 51.4930755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042900',
        LOCATION_NAME: 'Coombe Fishacre',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6292706,
        LOCATION_LATITUDE_DEG: 50.4690846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043000',
        LOCATION_NAME: 'Coombe Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3199982,
        LOCATION_LATITUDE_DEG: 52.0284223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043100',
        LOCATION_NAME: 'Coombe Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1623513,
        LOCATION_LATITUDE_DEG: 51.941309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043200',
        LOCATION_NAME: 'Coombe Keynes',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2169694,
        LOCATION_LATITUDE_DEG: 50.6574854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043300',
        LOCATION_NAME: 'Coombelake',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2918379,
        LOCATION_LATITUDE_DEG: 50.7617132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043400',
        LOCATION_NAME: 'Coombes',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.306024,
        LOCATION_LATITUDE_DEG: 50.8611871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043700',
        LOCATION_NAME: 'Coopers Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1007966,
        LOCATION_LATITUDE_DEG: 50.9870892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043800',
        LOCATION_NAME: 'Coopers Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1552872,
        LOCATION_LATITUDE_DEG: 51.829405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043900',
        LOCATION_NAME: 'Coopersale',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.131707,
        LOCATION_LATITUDE_DEG: 51.6997171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044200',
        LOCATION_NAME: 'Coosebean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0695132,
        LOCATION_LATITUDE_DEG: 50.2659795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044500',
        LOCATION_NAME: 'Cootham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4554667,
        LOCATION_LATITUDE_DEG: 50.9128903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044600',
        LOCATION_NAME: 'Copcut',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1672247,
        LOCATION_LATITUDE_DEG: 52.2496422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044700',
        LOCATION_NAME: 'Copdock',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0911895,
        LOCATION_LATITUDE_DEG: 52.0309809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044800',
        LOCATION_NAME: 'Copelaw',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.558844,
        LOCATION_LATITUDE_DEG: 54.5975565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044900',
        LOCATION_NAME: 'Copford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7954822,
        LOCATION_LATITUDE_DEG: 51.8663021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045000',
        LOCATION_NAME: 'Copford Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8014119,
        LOCATION_LATITUDE_DEG: 51.8679689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045100',
        LOCATION_NAME: 'Copgrove',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4760097,
        LOCATION_LATITUDE_DEG: 54.0654045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045200',
        LOCATION_NAME: 'Cople',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.387692,
        LOCATION_LATITUDE_DEG: 52.1230092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045400',
        LOCATION_NAME: 'Copley',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0355826,
        LOCATION_LATITUDE_DEG: 51.5830938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045300',
        LOCATION_NAME: 'Copley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8655362,
        LOCATION_LATITUDE_DEG: 53.6972787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045500',
        LOCATION_NAME: 'Copley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8610458,
        LOCATION_LATITUDE_DEG: 54.6228712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045600',
        LOCATION_NAME: 'Coplow Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7578402,
        LOCATION_LATITUDE_DEG: 53.3079368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045700',
        LOCATION_NAME: 'Copmanthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1400045,
        LOCATION_LATITUDE_DEG: 53.9149907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045800',
        LOCATION_NAME: 'Copmere End',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2904739,
        LOCATION_LATITUDE_DEG: 52.8597972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045900',
        LOCATION_NAME: 'Copnor',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0693893,
        LOCATION_LATITUDE_DEG: 50.8078939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046000',
        LOCATION_NAME: 'Coppenhall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.134707,
        LOCATION_LATITUDE_DEG: 52.7715915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046200',
        LOCATION_NAME: 'Copperhouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4083014,
        LOCATION_LATITUDE_DEG: 50.1903801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046300',
        LOCATION_NAME: 'Coppingford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2858297,
        LOCATION_LATITUDE_DEG: 52.4054334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046400',
        LOCATION_NAME: 'Copplestone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7437282,
        LOCATION_LATITUDE_DEG: 50.8089254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046500',
        LOCATION_NAME: 'Coppull',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.66016,
        LOCATION_LATITUDE_DEG: 53.6217772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046600',
        LOCATION_NAME: 'Copsale',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3263978,
        LOCATION_LATITUDE_DEG: 51.0111979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046700',
        LOCATION_NAME: 'Copster Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4933562,
        LOCATION_LATITUDE_DEG: 53.7984914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046800',
        LOCATION_NAME: 'Copt Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B91',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7441786,
        LOCATION_LATITUDE_DEG: 52.3990532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046900',
        LOCATION_NAME: 'Copt Hewick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4778526,
        LOCATION_LATITUDE_DEG: 54.136513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047000',
        LOCATION_NAME: 'Copt Oak',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2866314,
        LOCATION_LATITUDE_DEG: 52.7123778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047100',
        LOCATION_NAME: 'Copthorne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1162574,
        LOCATION_LATITUDE_DEG: 51.139511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047200',
        LOCATION_NAME: 'Coptiviney',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8791347,
        LOCATION_LATITUDE_DEG: 52.926414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047300',
        LOCATION_NAME: 'Copythorne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5474991,
        LOCATION_LATITUDE_DEG: 50.9277068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048100',
        LOCATION_NAME: 'Corbet',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1989322,
        LOCATION_LATITUDE_DEG: 54.3331772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048200',
        LOCATION_NAME: 'Corbridge',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0151868,
        LOCATION_LATITUDE_DEG: 54.9747034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048300',
        LOCATION_NAME: 'Corbriggs',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3963449,
        LOCATION_LATITUDE_DEG: 53.207424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048400',
        LOCATION_NAME: 'Corby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6779444,
        LOCATION_LATITUDE_DEG: 52.4889485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048500',
        LOCATION_NAME: 'Corby Glen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5179836,
        LOCATION_LATITUDE_DEG: 52.8126724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048600',
        LOCATION_NAME: 'Corby Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8078924,
        LOCATION_LATITUDE_DEG: 54.9051085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049500',
        LOCATION_NAME: 'Corehouse',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7797325,
        LOCATION_LATITUDE_DEG: 55.6526919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049600',
        LOCATION_NAME: 'Coreley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5600322,
        LOCATION_LATITUDE_DEG: 52.359458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049650',
        LOCATION_NAME: 'Corfannan',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4604791,
        LOCATION_LATITUDE_DEG: 54.3304022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049675',
        LOCATION_NAME: 'Corfannanogie',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049700',
        LOCATION_NAME: 'Corfe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.092614,
        LOCATION_LATITUDE_DEG: 50.9690337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049800',
        LOCATION_NAME: 'Corfe Castle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0528749,
        LOCATION_LATITUDE_DEG: 50.6335899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049900',
        LOCATION_NAME: 'Corfe Mullen',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0311454,
        LOCATION_LATITUDE_DEG: 50.7707972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050000',
        LOCATION_NAME: 'Corfton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7423684,
        LOCATION_LATITUDE_DEG: 52.4606664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050100',
        LOCATION_NAME: 'Corfton Bache',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7464343,
        LOCATION_LATITUDE_DEG: 52.4634641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050200',
        LOCATION_NAME: 'Corgarff',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1895439,
        LOCATION_LATITUDE_DEG: 57.1619334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050500',
        LOCATION_NAME: 'Corhampton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1297382,
        LOCATION_LATITUDE_DEG: 50.9791042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO080200',
        LOCATION_NAME: 'Corkerhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3342335,
        LOCATION_LATITUDE_DEG: 55.8380927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050800',
        LOCATION_NAME: 'Corkey',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2822078,
        LOCATION_LATITUDE_DEG: 55.033259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051000',
        LOCATION_NAME: 'Corlea',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5331136,
        LOCATION_LATITUDE_DEG: 54.4499477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051100',
        LOCATION_NAME: 'Corley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5559307,
        LOCATION_LATITUDE_DEG: 52.4631514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051400',
        LOCATION_NAME: 'Cormiston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5717463,
        LOCATION_LATITUDE_DEG: 55.6203822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051900',
        LOCATION_NAME: 'Cornaigbeg',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8983491,
        LOCATION_LATITUDE_DEG: 56.5168094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052000',
        LOCATION_NAME: 'Cornaigmore',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9209464,
        LOCATION_LATITUDE_DEG: 56.5206114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052200',
        LOCATION_NAME: 'Cornard Tye',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7761484,
        LOCATION_LATITUDE_DEG: 52.0354852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079400',
        LOCATION_NAME: 'Cornbrook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2754109,
        LOCATION_LATITUDE_DEG: 53.4649051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052300',
        LOCATION_NAME: 'Corney',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3628814,
        LOCATION_LATITUDE_DEG: 54.309058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052400',
        LOCATION_NAME: 'Cornhill',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6926328,
        LOCATION_LATITUDE_DEG: 57.6123717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077200',
        LOCATION_NAME: 'Cornhill on Tweed',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052500',
        LOCATION_NAME: 'Cornhill-on-Tweed',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2230938,
        LOCATION_LATITUDE_DEG: 55.6471695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052600',
        LOCATION_NAME: 'Cornholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1408529,
        LOCATION_LATITUDE_DEG: 53.7326796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052700',
        LOCATION_NAME: 'Cornish Hall End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4522294,
        LOCATION_LATITUDE_DEG: 52.0016828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052800',
        LOCATION_NAME: 'Cornriggs',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2397857,
        LOCATION_LATITUDE_DEG: 54.766984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052900',
        LOCATION_NAME: 'Cornsay',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7743903,
        LOCATION_LATITUDE_DEG: 54.7865861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053000',
        LOCATION_NAME: 'Cornsay Colliery',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7347852,
        LOCATION_LATITUDE_DEG: 54.7857781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053100',
        LOCATION_NAME: 'Cornton',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9399672,
        LOCATION_LATITUDE_DEG: 56.1366025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053200',
        LOCATION_NAME: 'Corntown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9632983,
        LOCATION_LATITUDE_DEG: 50.4110814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053300',
        LOCATION_NAME: 'Corntown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5573824,
        LOCATION_LATITUDE_DEG: 51.4842861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053400',
        LOCATION_NAME: 'Cornwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6068313,
        LOCATION_LATITUDE_DEG: 51.9411061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053500',
        LOCATION_NAME: 'Cornwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9583362,
        LOCATION_LATITUDE_DEG: 50.4197825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053600',
        LOCATION_NAME: 'Cornworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6490107,
        LOCATION_LATITUDE_DEG: 50.3882846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053700',
        LOCATION_NAME: 'Coronation',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6462489,
        LOCATION_LATITUDE_DEG: 54.6450655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053800',
        LOCATION_NAME: 'Corpach',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1257437,
        LOCATION_LATITUDE_DEG: 56.8439231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO053900',
        LOCATION_NAME: 'Corpusty',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1375974,
        LOCATION_LATITUDE_DEG: 52.8202477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054000',
        LOCATION_NAME: 'Corradinna',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4206488,
        LOCATION_LATITUDE_DEG: 54.5743972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054200',
        LOCATION_NAME: 'Corran',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2455855,
        LOCATION_LATITUDE_DEG: 56.7244104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054300',
        LOCATION_NAME: 'Corranny',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2657439,
        LOCATION_LATITUDE_DEG: 54.2498875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054700',
        LOCATION_NAME: 'Corrie',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'TA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1395331,
        LOCATION_LATITUDE_DEG: 55.640802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054800',
        LOCATION_NAME: 'Corrie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2414758,
        LOCATION_LATITUDE_DEG: 55.1606362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055300',
        LOCATION_NAME: 'Corringham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.69045,
        LOCATION_LATITUDE_DEG: 53.4085368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055200',
        LOCATION_NAME: 'Corringham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4626823,
        LOCATION_LATITUDE_DEG: 51.5249333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055400',
        LOCATION_NAME: 'Corris',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8405395,
        LOCATION_LATITUDE_DEG: 52.6542969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056000',
        LOCATION_NAME: 'Corsback',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.309778,
        LOCATION_LATITUDE_DEG: 58.6304798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056100',
        LOCATION_NAME: 'Corscombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6852282,
        LOCATION_LATITUDE_DEG: 50.8463143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056200',
        LOCATION_NAME: 'Corse',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6609529,
        LOCATION_LATITUDE_DEG: 57.450357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056250',
        LOCATION_NAME: 'Corse',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3057528,
        LOCATION_LATITUDE_DEG: 51.9573531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056300',
        LOCATION_NAME: 'Corse Lawn',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2434792,
        LOCATION_LATITUDE_DEG: 51.9768127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056400',
        LOCATION_NAME: 'Corsenside',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2075957,
        LOCATION_LATITUDE_DEG: 55.1884296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056500',
        LOCATION_NAME: 'Corsham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1844012,
        LOCATION_LATITUDE_DEG: 51.4305626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056600',
        LOCATION_NAME: 'Corsley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.246147,
        LOCATION_LATITUDE_DEG: 51.2188398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056700',
        LOCATION_NAME: 'Corsley Heath',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2581115,
        LOCATION_LATITUDE_DEG: 51.207339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056800',
        LOCATION_NAME: 'Corsock',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9443167,
        LOCATION_LATITUDE_DEG: 55.0665336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO056900',
        LOCATION_NAME: 'Corston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4386859,
        LOCATION_LATITUDE_DEG: 51.3864611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057000',
        LOCATION_NAME: 'Corston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1082308,
        LOCATION_LATITUDE_DEG: 51.5539722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078100',
        LOCATION_NAME: 'Corstorphine',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2851762,
        LOCATION_LATITUDE_DEG: 55.9441023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057100',
        LOCATION_NAME: 'Cortachy',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9889715,
        LOCATION_LATITUDE_DEG: 56.7251834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057200',
        LOCATION_NAME: 'Corton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0954004,
        LOCATION_LATITUDE_DEG: 51.163636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057300',
        LOCATION_NAME: 'Corton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7493336,
        LOCATION_LATITUDE_DEG: 52.513812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057400',
        LOCATION_NAME: 'Corton Denham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5200151,
        LOCATION_LATITUDE_DEG: 51.0008299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057600',
        LOCATION_NAME: 'Corwen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3834279,
        LOCATION_LATITUDE_DEG: 52.9789929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057700',
        LOCATION_NAME: 'Coryates',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5236663,
        LOCATION_LATITUDE_DEG: 50.6659905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057900',
        LOCATION_NAME: 'Coryton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1830952,
        LOCATION_LATITUDE_DEG: 50.6309114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057800',
        LOCATION_NAME: 'Coryton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.508517,
        LOCATION_LATITUDE_DEG: 51.5133392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058000',
        LOCATION_NAME: 'Cosaig',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6102824,
        LOCATION_LATITUDE_DEG: 57.2122603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058100',
        LOCATION_NAME: 'Cosby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.19272,
        LOCATION_LATITUDE_DEG: 52.547357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990806',
        LOCATION_NAME: 'Cosbystown',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058200',
        LOCATION_NAME: 'Coscote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2536139,
        LOCATION_LATITUDE_DEG: 51.5902625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058300',
        LOCATION_NAME: 'Coseley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1117009,
        LOCATION_LATITUDE_DEG: 52.5515671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058400',
        LOCATION_NAME: 'Cosford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2995561,
        LOCATION_LATITUDE_DEG: 52.6446829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058500',
        LOCATION_NAME: 'Cosford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2649059,
        LOCATION_LATITUDE_DEG: 52.4074476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058600',
        LOCATION_NAME: 'Cosgrove',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8467081,
        LOCATION_LATITUDE_DEG: 52.0749078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058700',
        LOCATION_NAME: 'Cosham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0617842,
        LOCATION_LATITUDE_DEG: 50.8459936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058800',
        LOCATION_NAME: 'Cosheston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8905273,
        LOCATION_LATITUDE_DEG: 51.6955139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO058900',
        LOCATION_NAME: 'Coshquin',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3621447,
        LOCATION_LATITUDE_DEG: 55.0162499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059000',
        LOCATION_NAME: 'Coskills',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4068506,
        LOCATION_LATITUDE_DEG: 53.5769427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059100',
        LOCATION_NAME: 'Cosmore',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3298403,
        LOCATION_LATITUDE_DEG: 50.7715042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059200',
        LOCATION_NAME: 'Cossall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2775778,
        LOCATION_LATITUDE_DEG: 52.9741037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059400',
        LOCATION_NAME: 'Cossington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.91763,
        LOCATION_LATITUDE_DEG: 51.1580433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059300',
        LOCATION_NAME: 'Cossington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1042623,
        LOCATION_LATITUDE_DEG: 52.7163731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059600',
        LOCATION_NAME: 'Costessey',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2117503,
        LOCATION_LATITUDE_DEG: 52.6588371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059700',
        LOCATION_NAME: 'Costhorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1190789,
        LOCATION_LATITUDE_DEG: 53.3685343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059800',
        LOCATION_NAME: 'Costock',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1438332,
        LOCATION_LATITUDE_DEG: 52.8314873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059900',
        LOCATION_NAME: 'Coston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7441299,
        LOCATION_LATITUDE_DEG: 52.7906724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060000',
        LOCATION_NAME: 'Coston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0499312,
        LOCATION_LATITUDE_DEG: 52.6151323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060100',
        LOCATION_NAME: 'Costow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8255767,
        LOCATION_LATITUDE_DEG: 51.5340641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060200',
        LOCATION_NAME: 'Coswarth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9989492,
        LOCATION_LATITUDE_DEG: 50.397293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060300',
        LOCATION_NAME: 'Cote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.488895,
        LOCATION_LATITUDE_DEG: 51.7220826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060400',
        LOCATION_NAME: 'Cotebrook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6417702,
        LOCATION_LATITUDE_DEG: 53.1837337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060500',
        LOCATION_NAME: 'Cotehill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8272063,
        LOCATION_LATITUDE_DEG: 54.8444013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060600',
        LOCATION_NAME: 'Cotes',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.174325,
        LOCATION_LATITUDE_DEG: 52.7797817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060800',
        LOCATION_NAME: 'Cotes de Val',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1882682,
        LOCATION_LATITUDE_DEG: 52.4848558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060700',
        LOCATION_NAME: 'Cotes Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2578766,
        LOCATION_LATITUDE_DEG: 52.9162063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060900',
        LOCATION_NAME: 'Cotesbach',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2093462,
        LOCATION_LATITUDE_DEG: 52.4362479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO060950',
        LOCATION_NAME: 'Cotford St. Luke',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1862109,
        LOCATION_LATITUDE_DEG: 51.0389638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061000',
        LOCATION_NAME: 'Cotgrave',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0393269,
        LOCATION_LATITUDE_DEG: 52.9113886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061100',
        LOCATION_NAME: 'Cothall',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2107117,
        LOCATION_LATITUDE_DEG: 57.2328246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079600',
        LOCATION_NAME: 'Cotham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6014407,
        LOCATION_LATITUDE_DEG: 51.4665745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061200',
        LOCATION_NAME: 'Cotham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8132061,
        LOCATION_LATITUDE_DEG: 53.0178998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061300',
        LOCATION_NAME: 'Cothelstone',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1677216,
        LOCATION_LATITUDE_DEG: 51.0780383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061400',
        LOCATION_NAME: 'Cotheridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3110005,
        LOCATION_LATITUDE_DEG: 52.191635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061500',
        LOCATION_NAME: 'Cotherstone',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9816678,
        LOCATION_LATITUDE_DEG: 54.5724649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061600',
        LOCATION_NAME: 'Cothill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.328932,
        LOCATION_LATITUDE_DEG: 51.691981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061700',
        LOCATION_NAME: 'Cotleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1247746,
        LOCATION_LATITUDE_DEG: 50.8131178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061800',
        LOCATION_NAME: 'Cotmore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6768832,
        LOCATION_LATITUDE_DEG: 50.2601656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO061900',
        LOCATION_NAME: 'Cotness',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7886411,
        LOCATION_LATITUDE_DEG: 53.7075636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062300',
        LOCATION_NAME: 'Coton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6912492,
        LOCATION_LATITUDE_DEG: 52.9059074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062000',
        LOCATION_NAME: 'Coton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4668997,
        LOCATION_LATITUDE_DEG: 52.5156693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062200',
        LOCATION_NAME: 'Coton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0097751,
        LOCATION_LATITUDE_DEG: 52.3386352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062100',
        LOCATION_NAME: 'Coton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0656111,
        LOCATION_LATITUDE_DEG: 52.2102107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062400',
        LOCATION_NAME: 'Coton Clanford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.188911,
        LOCATION_LATITUDE_DEG: 52.8073988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077700',
        LOCATION_NAME: 'Coton in the Clay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077800',
        LOCATION_NAME: 'Coton in the Elms',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062500',
        LOCATION_NAME: 'Coton-in-the-Clay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7472592,
        LOCATION_LATITUDE_DEG: 52.8591912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062600',
        LOCATION_NAME: 'Coton-in-the-Elms',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6409497,
        LOCATION_LATITUDE_DEG: 52.7330044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062700',
        LOCATION_NAME: 'Cott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7070526,
        LOCATION_LATITUDE_DEG: 50.4420823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063000',
        LOCATION_NAME: 'Cottam',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7588023,
        LOCATION_LATITUDE_DEG: 53.7856983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062900',
        LOCATION_NAME: 'Cottam',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7743175,
        LOCATION_LATITUDE_DEG: 53.3084215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO062800',
        LOCATION_NAME: 'Cottam',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4797813,
        LOCATION_LATITUDE_DEG: 54.0683915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063100',
        LOCATION_NAME: 'Cottenham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.126337,
        LOCATION_LATITUDE_DEG: 52.2847171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079200',
        LOCATION_NAME: 'Cottenham Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2358633,
        LOCATION_LATITUDE_DEG: 51.4158037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063200',
        LOCATION_NAME: 'Cotterdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2562117,
        LOCATION_LATITUDE_DEG: 54.3419481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063300',
        LOCATION_NAME: 'Cottered',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0805553,
        LOCATION_LATITUDE_DEG: 51.9462841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063400',
        LOCATION_NAME: 'Cotteridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9400464,
        LOCATION_LATITUDE_DEG: 52.4180523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063500',
        LOCATION_NAME: 'Cotterstock',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4564862,
        LOCATION_LATITUDE_DEG: 52.5021459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063600',
        LOCATION_NAME: 'Cottesbrooke',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9592476,
        LOCATION_LATITUDE_DEG: 52.3555367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063700',
        LOCATION_NAME: 'Cottesmore',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6659807,
        LOCATION_LATITUDE_DEG: 52.7111641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990120',
        LOCATION_NAME: 'Cottesmore',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6633038,
        LOCATION_LATITUDE_DEG: 52.7159173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063900',
        LOCATION_NAME: 'Cottingham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7539992,
        LOCATION_LATITUDE_DEG: 52.5023441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO063800',
        LOCATION_NAME: 'Cottingham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4120907,
        LOCATION_LATITUDE_DEG: 53.7818635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064000',
        LOCATION_NAME: 'Cottingley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8285969,
        LOCATION_LATITUDE_DEG: 53.8300901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064100',
        LOCATION_NAME: 'Cottingley Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.828423,
        LOCATION_LATITUDE_DEG: 53.8391867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064200',
        LOCATION_NAME: 'Cottisford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1387889,
        LOCATION_LATITUDE_DEG: 51.9760017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064300',
        LOCATION_NAME: 'Cotton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9007029,
        LOCATION_LATITUDE_DEG: 53.0144117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064400',
        LOCATION_NAME: 'Cotton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0344515,
        LOCATION_LATITUDE_DEG: 52.2611994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064500',
        LOCATION_NAME: 'Cotton Edmunds',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8016222,
        LOCATION_LATITUDE_DEG: 53.1892383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064600',
        LOCATION_NAME: 'Cotton End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4161837,
        LOCATION_LATITUDE_DEG: 52.0953031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990888',
        LOCATION_NAME: 'Cottonfields',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064700',
        LOCATION_NAME: 'Cottonworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4558482,
        LOCATION_LATITUDE_DEG: 51.1547292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064800',
        LOCATION_NAME: 'Cotwall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5861288,
        LOCATION_LATITUDE_DEG: 52.7523916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO064900',
        LOCATION_NAME: 'Cotwalton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.108088,
        LOCATION_LATITUDE_DEG: 52.9112046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065000',
        LOCATION_NAME: 'Couchs Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6049068,
        LOCATION_LATITUDE_DEG: 50.4022926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065100',
        LOCATION_NAME: 'Coughton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5831091,
        LOCATION_LATITUDE_DEG: 51.8875087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065200',
        LOCATION_NAME: 'Coughton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8825913,
        LOCATION_LATITUDE_DEG: 52.2412324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065400',
        LOCATION_NAME: 'Coulby Newham',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2218742,
        LOCATION_LATITUDE_DEG: 54.5286462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065500',
        LOCATION_NAME: 'Coulderton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5659282,
        LOCATION_LATITUDE_DEG: 54.4660704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065600',
        LOCATION_NAME: 'Coull',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8034139,
        LOCATION_LATITUDE_DEG: 57.113222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065700',
        LOCATION_NAME: 'Coulport',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8743989,
        LOCATION_LATITUDE_DEG: 56.0454424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065800',
        LOCATION_NAME: 'Coulsdon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1392045,
        LOCATION_LATITUDE_DEG: 51.3195235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065900',
        LOCATION_NAME: 'Coulsdon North',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1293139,
        LOCATION_LATITUDE_DEG: 51.3287285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066000',
        LOCATION_NAME: 'Coulston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0665403,
        LOCATION_LATITUDE_DEG: 51.2850516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066100',
        LOCATION_NAME: 'Coulter',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5484478,
        LOCATION_LATITUDE_DEG: 55.5897795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066200',
        LOCATION_NAME: 'Coultings',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1041839,
        LOCATION_LATITUDE_DEG: 51.1671511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066300',
        LOCATION_NAME: 'Coulton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0292283,
        LOCATION_LATITUDE_DEG: 54.161507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066500',
        LOCATION_NAME: 'Cound',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6569804,
        LOCATION_LATITUDE_DEG: 52.642485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066600',
        LOCATION_NAME: 'Cound Moor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6606762,
        LOCATION_LATITUDE_DEG: 52.6189802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066700',
        LOCATION_NAME: 'Coundon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6336997,
        LOCATION_LATITUDE_DEG: 54.66357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066800',
        LOCATION_NAME: 'Coundon Gate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6477696,
        LOCATION_LATITUDE_DEG: 54.6609694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066900',
        LOCATION_NAME: 'Coundon Grange',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6461307,
        LOCATION_LATITUDE_DEG: 54.6479682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067000',
        LOCATION_NAME: 'Countersett',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1240998,
        LOCATION_LATITUDE_DEG: 54.2862404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067100',
        LOCATION_NAME: 'Countess Wear',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4861089,
        LOCATION_LATITUDE_DEG: 50.6970058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067200',
        LOCATION_NAME: 'Countesthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1359164,
        LOCATION_LATITUDE_DEG: 52.5536544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067300',
        LOCATION_NAME: 'Counthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5109695,
        LOCATION_LATITUDE_DEG: 52.7699656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067400',
        LOCATION_NAME: 'Countisbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7940581,
        LOCATION_LATITUDE_DEG: 51.2316613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067500',
        LOCATION_NAME: 'Coupar Angus',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2662126,
        LOCATION_LATITUDE_DEG: 56.5454684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067600',
        LOCATION_NAME: 'Coupland Beck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4474772,
        LOCATION_LATITUDE_DEG: 54.5641701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067700',
        LOCATION_NAME: 'Courance',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.489858,
        LOCATION_LATITUDE_DEG: 55.1968436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077900',
        LOCATION_NAME: 'Court at Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067800',
        LOCATION_NAME: 'Court Colman',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.614739,
        LOCATION_LATITUDE_DEG: 51.5233865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO067900',
        LOCATION_NAME: 'Court-at-Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9871493,
        LOCATION_LATITUDE_DEG: 51.0789892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068000',
        LOCATION_NAME: 'Courteenhall',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.880306,
        LOCATION_LATITUDE_DEG: 52.1697194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068500',
        LOCATION_NAME: 'Courtsend',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9252334,
        LOCATION_LATITUDE_DEG: 51.6034362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068600',
        LOCATION_NAME: 'Courtway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1370268,
        LOCATION_LATITUDE_DEG: 51.0990439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068800',
        LOCATION_NAME: 'Cousland',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9908709,
        LOCATION_LATITUDE_DEG: 55.9055102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068900',
        LOCATION_NAME: 'Cousley Wood',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3581203,
        LOCATION_LATITUDE_DEG: 51.0757942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069400',
        LOCATION_NAME: 'Cove',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6951805,
        LOCATION_LATITUDE_DEG: 57.8522281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069100',
        LOCATION_NAME: 'Cove',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8507089,
        LOCATION_LATITUDE_DEG: 55.9997394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069300',
        LOCATION_NAME: 'Cove',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4940305,
        LOCATION_LATITUDE_DEG: 50.9658297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069000',
        LOCATION_NAME: 'Cove',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.358674,
        LOCATION_LATITUDE_DEG: 55.9385015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069200',
        LOCATION_NAME: 'Cove',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0816952,
        LOCATION_LATITUDE_DEG: 57.1001095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069500',
        LOCATION_NAME: 'Cove Bay',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0841468,
        LOCATION_LATITUDE_DEG: 57.1111134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069600',
        LOCATION_NAME: 'Cove Hithe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6946463,
        LOCATION_LATITUDE_DEG: 52.3739662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069700',
        LOCATION_NAME: 'Coven',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.134254,
        LOCATION_LATITUDE_DEG: 52.6579771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069800',
        LOCATION_NAME: 'Coven Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1272536,
        LOCATION_LATITUDE_DEG: 52.6403809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO069900',
        LOCATION_NAME: 'Coveney',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1901902,
        LOCATION_LATITUDE_DEG: 52.4164283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077000',
        LOCATION_NAME: 'Covenham St Bartholomew',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO077100',
        LOCATION_NAME: 'Covenham St Mary',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070000',
        LOCATION_NAME: 'Covenham St. Bartholomew',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0121779,
        LOCATION_LATITUDE_DEG: 53.4353291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070100',
        LOCATION_NAME: 'Covenham St. Mary',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0164847,
        LOCATION_LATITUDE_DEG: 53.4280276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079300',
        LOCATION_NAME: 'Covent Garden',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1238493,
        LOCATION_LATITUDE_DEG: 51.5126431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070200',
        LOCATION_NAME: 'Coventry',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5083654,
        LOCATION_LATITUDE_DEG: 52.4079463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070300',
        LOCATION_NAME: 'Coventry Walsgrave Triangle',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4406467,
        LOCATION_LATITUDE_DEG: 52.425448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070400',
        LOCATION_NAME: 'Coverack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0964682,
        LOCATION_LATITUDE_DEG: 50.0238579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070500',
        LOCATION_NAME: 'Coverack Bridges',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2630333,
        LOCATION_LATITUDE_DEG: 50.1240717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070600',
        LOCATION_NAME: 'Coverham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8402225,
        LOCATION_LATITUDE_DEG: 54.2717362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070700',
        LOCATION_NAME: 'Covingham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7280372,
        LOCATION_LATITUDE_DEG: 51.5649745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070800',
        LOCATION_NAME: 'Covington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4498524,
        LOCATION_LATITUDE_DEG: 52.3240276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO070900',
        LOCATION_NAME: 'Cow Ark',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4975305,
        LOCATION_LATITUDE_DEG: 53.9035021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071000',
        LOCATION_NAME: 'Cow Brow',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6900946,
        LOCATION_LATITUDE_DEG: 54.2281426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071100',
        LOCATION_NAME: 'Cow Roast',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6116067,
        LOCATION_LATITUDE_DEG: 51.7828778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071200',
        LOCATION_NAME: 'Cowan Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5580638,
        LOCATION_LATITUDE_DEG: 54.1824364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071300',
        LOCATION_NAME: 'Cowan Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7828025,
        LOCATION_LATITUDE_DEG: 54.3690556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071400',
        LOCATION_NAME: 'Cowbeech',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3033644,
        LOCATION_LATITUDE_DEG: 50.9071816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071500',
        LOCATION_NAME: 'Cowbit',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1306703,
        LOCATION_LATITUDE_DEG: 52.7450603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071700',
        LOCATION_NAME: 'Cowbridge',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4461208,
        LOCATION_LATITUDE_DEG: 51.4613844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071600',
        LOCATION_NAME: 'Cowbridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0015747,
        LOCATION_LATITUDE_DEG: 53.0040883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071800',
        LOCATION_NAME: 'Cowcliffe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7978236,
        LOCATION_LATITUDE_DEG: 53.6600851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990527',
        LOCATION_NAME: 'Cowden',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO071900',
        LOCATION_NAME: 'Cowden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0950592,
        LOCATION_LATITUDE_DEG: 51.1443071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072000',
        LOCATION_NAME: 'Cowdenbeath',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3395812,
        LOCATION_LATITUDE_DEG: 56.1069268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072100',
        LOCATION_NAME: 'Cowers Lane',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5430159,
        LOCATION_LATITUDE_DEG: 53.0188076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072200',
        LOCATION_NAME: 'Cowes',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3083705,
        LOCATION_LATITUDE_DEG: 50.7574906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072300',
        LOCATION_NAME: 'Cowesby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2841242,
        LOCATION_LATITUDE_DEG: 54.3021296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072400',
        LOCATION_NAME: 'Cowfold',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2709863,
        LOCATION_LATITUDE_DEG: 50.9884002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072500',
        LOCATION_NAME: 'Cowgate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6664558,
        LOCATION_LATITUDE_DEG: 54.9909994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072600',
        LOCATION_NAME: 'Cowgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3752874,
        LOCATION_LATITUDE_DEG: 54.2768399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072700',
        LOCATION_NAME: 'Cowgrove',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0255866,
        LOCATION_LATITUDE_DEG: 50.7984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072800',
        LOCATION_NAME: 'Cowhill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5688254,
        LOCATION_LATITUDE_DEG: 51.6211841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO072900',
        LOCATION_NAME: 'Cowie',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8671923,
        LOCATION_LATITUDE_DEG: 56.0823347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073000',
        LOCATION_NAME: 'Cowie',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1985466,
        LOCATION_LATITUDE_DEG: 56.9725011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO080000',
        LOCATION_NAME: 'Cowlairs',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2332527,
        LOCATION_LATITUDE_DEG: 55.8821507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073100',
        LOCATION_NAME: 'Cowlease',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2022426,
        LOCATION_LATITUDE_DEG: 50.5995718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073200',
        LOCATION_NAME: 'Cowlersley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8322996,
        LOCATION_LATITUDE_DEG: 53.6332694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073600',
        LOCATION_NAME: 'Cowley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5512018,
        LOCATION_LATITUDE_DEG: 50.7504116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073300',
        LOCATION_NAME: 'Cowley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0523924,
        LOCATION_LATITUDE_DEG: 51.830395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073400',
        LOCATION_NAME: 'Cowley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.206553,
        LOCATION_LATITUDE_DEG: 51.7324753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073500',
        LOCATION_NAME: 'Cowley',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4803767,
        LOCATION_LATITUDE_DEG: 51.529154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073800',
        LOCATION_NAME: 'Cowling',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0394375,
        LOCATION_LATITUDE_DEG: 53.8847328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073700',
        LOCATION_NAME: 'Cowling',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6362424,
        LOCATION_LATITUDE_DEG: 54.2826277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO073900',
        LOCATION_NAME: 'Cowlinge',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5071894,
        LOCATION_LATITUDE_DEG: 52.162502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074000',
        LOCATION_NAME: 'Cowmes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7249647,
        LOCATION_LATITUDE_DEG: 53.6419704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074100',
        LOCATION_NAME: 'Cowpen',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5367789,
        LOCATION_LATITUDE_DEG: 55.126911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074200',
        LOCATION_NAME: 'Cowpen Bewley',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2560071,
        LOCATION_LATITUDE_DEG: 54.6155602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074300',
        LOCATION_NAME: 'Cowplain',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0178301,
        LOCATION_LATITUDE_DEG: 50.8926962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074400',
        LOCATION_NAME: 'Cowshill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2241572,
        LOCATION_LATITUDE_DEG: 54.7601833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074500',
        LOCATION_NAME: 'Cowstrandburn',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5490355,
        LOCATION_LATITUDE_DEG: 56.1002353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074600',
        LOCATION_NAME: 'Cowthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3491389,
        LOCATION_LATITUDE_DEG: 53.9659974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074700',
        LOCATION_NAME: 'Cox Bank',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5123041,
        LOCATION_LATITUDE_DEG: 52.9729113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074800',
        LOCATION_NAME: 'Cox Green',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4897872,
        LOCATION_LATITUDE_DEG: 54.8905903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990860',
        LOCATION_NAME: 'Coxall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO074900',
        LOCATION_NAME: 'Coxbench',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4465979,
        LOCATION_LATITUDE_DEG: 52.9875073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075000',
        LOCATION_NAME: 'Coxbridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6517552,
        LOCATION_LATITUDE_DEG: 51.1258416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075100',
        LOCATION_NAME: 'Coxford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7392492,
        LOCATION_LATITUDE_DEG: 52.8289564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075200',
        LOCATION_NAME: 'Coxheath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4960849,
        LOCATION_LATITUDE_DEG: 51.2322091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075300',
        LOCATION_NAME: 'Coxhill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7550973,
        LOCATION_LATITUDE_DEG: 51.8017219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075400',
        LOCATION_NAME: 'Coxhoe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5009846,
        LOCATION_LATITUDE_DEG: 54.7148748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075500',
        LOCATION_NAME: 'Coxley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6743506,
        LOCATION_LATITUDE_DEG: 51.189646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075600',
        LOCATION_NAME: 'Coxley Wick',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6741622,
        LOCATION_LATITUDE_DEG: 51.1914457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078300',
        LOCATION_NAME: 'Coxlodge',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6397973,
        LOCATION_LATITUDE_DEG: 55.0110908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075700',
        LOCATION_NAME: 'Coxpark',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2545138,
        LOCATION_LATITUDE_DEG: 50.5234965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075800',
        LOCATION_NAME: 'Coxside',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.12152,
        LOCATION_LATITUDE_DEG: 50.3640815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO075900',
        LOCATION_NAME: 'Coxtie Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2598378,
        LOCATION_LATITUDE_DEG: 51.6400485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076000',
        LOCATION_NAME: 'Coxwold',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1796273,
        LOCATION_LATITUDE_DEG: 54.1870119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076100',
        LOCATION_NAME: 'Coychurch',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5154262,
        LOCATION_LATITUDE_DEG: 51.4995847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076200',
        LOCATION_NAME: 'Coylton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5163204,
        LOCATION_LATITUDE_DEG: 55.4450799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076300',
        LOCATION_NAME: 'Coynach',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9253544,
        LOCATION_LATITUDE_DEG: 57.1384278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO076400',
        LOCATION_NAME: 'Coytrahen',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6005344,
        LOCATION_LATITUDE_DEG: 51.5577915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000300',
        LOCATION_NAME: 'Crabbs Cross',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9405971,
        LOCATION_LATITUDE_DEG: 52.2817369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000400',
        LOCATION_NAME: 'Crabley Creek',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.631675,
        LOCATION_LATITUDE_DEG: 53.7361605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000500',
        LOCATION_NAME: 'Crabtree',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0981824,
        LOCATION_LATITUDE_DEG: 50.3887835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000600',
        LOCATION_NAME: 'Crabtree Green',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9905034,
        LOCATION_LATITUDE_DEG: 52.9959255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000700',
        LOCATION_NAME: 'Crackenedge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6278009,
        LOCATION_LATITUDE_DEG: 53.693369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000800',
        LOCATION_NAME: 'Crackenthorpe',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5226888,
        LOCATION_LATITUDE_DEG: 54.5915695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000900',
        LOCATION_NAME: 'Crackington Haven',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6319367,
        LOCATION_LATITUDE_DEG: 50.7411212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001000',
        LOCATION_NAME: 'Crackley Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3598111,
        LOCATION_LATITUDE_DEG: 52.6958974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001100',
        LOCATION_NAME: 'Cracoe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0323281,
        LOCATION_LATITUDE_DEG: 54.0372115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001300',
        LOCATION_NAME: 'Craddock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2995148,
        LOCATION_LATITUDE_DEG: 50.902528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001400',
        LOCATION_NAME: 'Cradle End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.117694,
        LOCATION_LATITUDE_DEG: 51.8751731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001500',
        LOCATION_NAME: 'Cradlehall',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1537054,
        LOCATION_LATITUDE_DEG: 57.4750715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001650',
        LOCATION_NAME: 'Cradley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3891813,
        LOCATION_LATITUDE_DEG: 52.1290646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001600',
        LOCATION_NAME: 'Cradley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0911738,
        LOCATION_LATITUDE_DEG: 52.4612614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001700',
        LOCATION_NAME: 'Cradley Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0778117,
        LOCATION_LATITUDE_DEG: 52.4715657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001800',
        LOCATION_NAME: 'Cradoc',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4304371,
        LOCATION_LATITUDE_DEG: 51.9645278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001900',
        LOCATION_NAME: 'Crafthole',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2970705,
        LOCATION_LATITUDE_DEG: 50.3640827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002000',
        LOCATION_NAME: 'Crafton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7094359,
        LOCATION_LATITUDE_DEG: 51.8679828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002100',
        LOCATION_NAME: 'Cragg Vale',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.991621,
        LOCATION_LATITUDE_DEG: 53.7094802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002200',
        LOCATION_NAME: 'Craggan',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2883656,
        LOCATION_LATITUDE_DEG: 56.3782706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002300',
        LOCATION_NAME: 'Craghead',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6684251,
        LOCATION_LATITUDE_DEG: 54.8524911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002400',
        LOCATION_NAME: 'Cragside',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8971682,
        LOCATION_LATITUDE_DEG: 55.3194384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002500',
        LOCATION_NAME: 'Crai',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6040414,
        LOCATION_LATITUDE_DEG: 51.9063201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002600',
        LOCATION_NAME: 'Craibstone',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8434875,
        LOCATION_LATITUDE_DEG: 57.6223706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002700',
        LOCATION_NAME: 'Craichie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8102043,
        LOCATION_LATITUDE_DEG: 56.6148783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002800',
        LOCATION_NAME: 'Craig',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.616685,
        LOCATION_LATITUDE_DEG: 57.336606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050500',
        LOCATION_NAME: 'Craig Cefn Parc',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR002900',
        LOCATION_NAME: 'Craig Dunain',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2762139,
        LOCATION_LATITUDE_DEG: 57.4632766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003100',
        LOCATION_NAME: 'Craigahullier',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6312388,
        LOCATION_LATITUDE_DEG: 55.194676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003200',
        LOCATION_NAME: 'Craigavad',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7858789,
        LOCATION_LATITUDE_DEG: 54.6597142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003300',
        LOCATION_NAME: 'Craigavon',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3758418,
        LOCATION_LATITUDE_DEG: 54.4472905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003000',
        LOCATION_NAME: 'Craig-Cefn-Parc',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9144215,
        LOCATION_LATITUDE_DEG: 51.708712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003400',
        LOCATION_NAME: 'Craigdarroch',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.979421,
        LOCATION_LATITUDE_DEG: 55.1962437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003500',
        LOCATION_NAME: 'Craigellachie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1859792,
        LOCATION_LATITUDE_DEG: 57.4900679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003600',
        LOCATION_NAME: 'Craigend',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4302731,
        LOCATION_LATITUDE_DEG: 56.3664545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003700',
        LOCATION_NAME: 'Craigendoran',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7030348,
        LOCATION_LATITUDE_DEG: 55.9946347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003800',
        LOCATION_NAME: 'Craigenquarroch',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0487976,
        LOCATION_LATITUDE_DEG: 54.8543294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052700',
        LOCATION_NAME: 'Craigentinny',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1359095,
        LOCATION_LATITUDE_DEG: 55.9615018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR003900',
        LOCATION_NAME: 'Craigesk',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0746425,
        LOCATION_LATITUDE_DEG: 55.8717014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004000',
        LOCATION_NAME: 'Craighouse',
        COUNTY_NAME: 'Isle of Jura',
        POSTCODE: 'PA60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9498058,
        LOCATION_LATITUDE_DEG: 55.833731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004200',
        LOCATION_NAME: 'Craigie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6144575,
        LOCATION_LATITUDE_DEG: 55.4613788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004100',
        LOCATION_NAME: 'Craigie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.488521,
        LOCATION_LATITUDE_DEG: 55.5595818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004300',
        LOCATION_NAME: 'Craigiebuckler',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.186195,
        LOCATION_LATITUDE_DEG: 57.1444154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004400',
        LOCATION_NAME: 'Craigiehall',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3328636,
        LOCATION_LATITUDE_DEG: 55.96502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052400',
        LOCATION_NAME: 'Craigleith',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2282608,
        LOCATION_LATITUDE_DEG: 55.9627459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004500',
        LOCATION_NAME: 'Craigllwyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1039164,
        LOCATION_LATITUDE_DEG: 52.9063768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004600',
        LOCATION_NAME: 'Craiglockhart',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.24129,
        LOCATION_LATITUDE_DEG: 55.9213129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004700',
        LOCATION_NAME: 'Craigmill',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9049278,
        LOCATION_LATITUDE_DEG: 56.1343437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004800',
        LOCATION_NAME: 'Craigmillar',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1396745,
        LOCATION_LATITUDE_DEG: 55.9326115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR004900',
        LOCATION_NAME: 'Craigmorrick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0202078,
        LOCATION_LATITUDE_DEG: 50.5075073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005000',
        LOCATION_NAME: 'Craigneuk',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9443028,
        LOCATION_LATITUDE_DEG: 55.8659152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005100',
        LOCATION_NAME: 'Craignish',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6057279,
        LOCATION_LATITUDE_DEG: 56.1310605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005200',
        LOCATION_NAME: 'Craignure',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6980702,
        LOCATION_LATITUDE_DEG: 56.4674893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005300',
        LOCATION_NAME: 'Craigo',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.508831,
        LOCATION_LATITUDE_DEG: 56.7695868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005400',
        LOCATION_NAME: 'Craigrothie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0034214,
        LOCATION_LATITUDE_DEG: 56.2872471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005500',
        LOCATION_NAME: 'Craigston',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5057852,
        LOCATION_LATITUDE_DEG: 56.9872586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005600',
        LOCATION_NAME: 'Craigstrome',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2358571,
        LOCATION_LATITUDE_DEG: 57.4158972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR053300',
        LOCATION_NAME: 'Craigton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3319637,
        LOCATION_LATITUDE_DEG: 55.8506031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005700',
        LOCATION_NAME: 'Craigton',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3179779,
        LOCATION_LATITUDE_DEG: 57.9335223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005800',
        LOCATION_NAME: 'Craigton',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0958085,
        LOCATION_LATITUDE_DEG: 56.6418848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR005900',
        LOCATION_NAME: 'Craigton Point',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2339498,
        LOCATION_LATITUDE_DEG: 57.5027824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006000',
        LOCATION_NAME: 'Craigywarren',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2327156,
        LOCATION_LATITUDE_DEG: 54.9516396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006100',
        LOCATION_NAME: 'Crail',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6250808,
        LOCATION_LATITUDE_DEG: 56.2607383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006200',
        LOCATION_NAME: 'Crakehall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3515137,
        LOCATION_LATITUDE_DEG: 54.1594491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006300',
        LOCATION_NAME: 'Crambe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8787123,
        LOCATION_LATITUDE_DEG: 54.0751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006400',
        LOCATION_NAME: 'Crambeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.869786,
        LOCATION_LATITUDE_DEG: 54.0958982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006500',
        LOCATION_NAME: 'Cramlington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5840538,
        LOCATION_LATITUDE_DEG: 55.0858126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052500',
        LOCATION_NAME: 'Cramond',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2991551,
        LOCATION_LATITUDE_DEG: 55.9770626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006600',
        LOCATION_NAME: 'Cramond Bridge',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3286105,
        LOCATION_LATITUDE_DEG: 55.9662163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052600',
        LOCATION_NAME: 'Cramond Bridge',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3134062,
        LOCATION_LATITUDE_DEG: 55.9728856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006700',
        LOCATION_NAME: 'Crampmoor',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4598585,
        LOCATION_LATITUDE_DEG: 50.996017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006800',
        LOCATION_NAME: 'Cranage',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3714409,
        LOCATION_LATITUDE_DEG: 53.2134353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR006900',
        LOCATION_NAME: 'Cranborne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9210941,
        LOCATION_LATITUDE_DEG: 50.9181065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990393',
        LOCATION_NAME: 'Cranbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4157165,
        LOCATION_LATITUDE_DEG: 50.7352262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007000',
        LOCATION_NAME: 'Cranbrook',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5373337,
        LOCATION_LATITUDE_DEG: 51.0962002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007100',
        LOCATION_NAME: 'Crane Moor',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5384691,
        LOCATION_LATITUDE_DEG: 53.5089554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051100',
        LOCATION_NAME: 'Cranes Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7727014,
        LOCATION_LATITUDE_DEG: 52.4577874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007200',
        LOCATION_NAME: 'Cranfield',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6071686,
        LOCATION_LATITUDE_DEG: 52.068103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007600',
        LOCATION_NAME: 'Cranford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3561116,
        LOCATION_LATITUDE_DEG: 50.9687423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007400',
        LOCATION_NAME: 'Cranford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6371645,
        LOCATION_LATITUDE_DEG: 52.3833365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007300',
        LOCATION_NAME: 'Cranford',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4088528,
        LOCATION_LATITUDE_DEG: 51.4822499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007700',
        LOCATION_NAME: 'Cranham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1449472,
        LOCATION_LATITUDE_DEG: 51.8137001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007800',
        LOCATION_NAME: 'Cranham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2692534,
        LOCATION_LATITUDE_DEG: 51.5654418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007900',
        LOCATION_NAME: 'Cranhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1762676,
        LOCATION_LATITUDE_DEG: 55.8657163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008000',
        LOCATION_NAME: 'Crank',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7462725,
        LOCATION_LATITUDE_DEG: 53.4913715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008100',
        LOCATION_NAME: 'Cranleigh',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4838624,
        LOCATION_LATITUDE_DEG: 51.1402144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008200',
        LOCATION_NAME: 'Cranley',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7655722,
        LOCATION_LATITUDE_DEG: 54.3165767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008300',
        LOCATION_NAME: 'Cranmer',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8018301,
        LOCATION_LATITUDE_DEG: 52.8581621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008400',
        LOCATION_NAME: 'Cranmore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4712184,
        LOCATION_LATITUDE_DEG: 51.1882392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008500',
        LOCATION_NAME: 'Cranmore',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4370968,
        LOCATION_LATITUDE_DEG: 50.7081866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008700',
        LOCATION_NAME: 'Cranny',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3475502,
        LOCATION_LATITUDE_DEG: 54.5169034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008800',
        LOCATION_NAME: 'Cranoe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8778625,
        LOCATION_LATITUDE_DEG: 52.5477493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009000',
        LOCATION_NAME: 'Cransford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4000286,
        LOCATION_LATITUDE_DEG: 52.2296927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009050',
        LOCATION_NAME: 'Cransley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7775056,
        LOCATION_LATITUDE_DEG: 52.377777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009100',
        LOCATION_NAME: 'Cranswick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4384015,
        LOCATION_LATITUDE_DEG: 53.9564877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009200',
        LOCATION_NAME: 'Crantock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1092658,
        LOCATION_LATITUDE_DEG: 50.400494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009300',
        LOCATION_NAME: 'Cranwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4602337,
        LOCATION_LATITUDE_DEG: 53.0363939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009400',
        LOCATION_NAME: 'Cranwell Village',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4548795,
        LOCATION_LATITUDE_DEG: 53.029698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009500',
        LOCATION_NAME: 'Cranwich',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6268881,
        LOCATION_LATITUDE_DEG: 52.521232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009600',
        LOCATION_NAME: 'Cranworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9286695,
        LOCATION_LATITUDE_DEG: 52.6024375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990826',
        LOCATION_NAME: 'Craob Haven',
        COUNTY_NAME: 'Argyll',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009700',
        LOCATION_NAME: 'Craobh Haven',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.552515,
        LOCATION_LATITUDE_DEG: 56.2088656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009800',
        LOCATION_NAME: 'Crapnell',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5791507,
        LOCATION_LATITUDE_DEG: 51.2077463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR009900',
        LOCATION_NAME: 'Crapstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1116099,
        LOCATION_LATITUDE_DEG: 50.4910958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010000',
        LOCATION_NAME: 'Crarae Furnace',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.236077,
        LOCATION_LATITUDE_DEG: 56.1403528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010100',
        LOCATION_NAME: 'Craster',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5911343,
        LOCATION_LATITUDE_DEG: 55.472048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010200',
        LOCATION_NAME: 'Craswall',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0329377,
        LOCATION_LATITUDE_DEG: 52.0063268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010300',
        LOCATION_NAME: 'Cratfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3964421,
        LOCATION_LATITUDE_DEG: 52.3240037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010400',
        LOCATION_NAME: 'Crathes',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.413536,
        LOCATION_LATITUDE_DEG: 57.0592135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010500',
        LOCATION_NAME: 'CRATHIE',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2120891,
        LOCATION_LATITUDE_DEG: 57.0397197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010600',
        LOCATION_NAME: 'Crathorne',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3197853,
        LOCATION_LATITUDE_DEG: 54.4601443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010900',
        LOCATION_NAME: 'Craven Arms',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8324188,
        LOCATION_LATITUDE_DEG: 52.4400703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011000',
        LOCATION_NAME: 'Crawcrook',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7868415,
        LOCATION_LATITUDE_DEG: 54.9649012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011100',
        LOCATION_NAME: 'Crawford',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6527527,
        LOCATION_LATITUDE_DEG: 55.4701745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011200',
        LOCATION_NAME: 'Crawfordjohn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7738918,
        LOCATION_LATITUDE_DEG: 55.4952721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011300',
        LOCATION_NAME: 'Crawfordsburn',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7321688,
        LOCATION_LATITUDE_DEG: 54.6499156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011400',
        LOCATION_NAME: 'Crawick',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9331804,
        LOCATION_LATITUDE_DEG: 55.3774674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011600',
        LOCATION_NAME: 'Crawley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5053452,
        LOCATION_LATITUDE_DEG: 51.8053937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011700',
        LOCATION_NAME: 'Crawley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3928892,
        LOCATION_LATITUDE_DEG: 51.1107215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011500',
        LOCATION_NAME: 'Crawley',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.183046,
        LOCATION_LATITUDE_DEG: 51.1131092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011800',
        LOCATION_NAME: 'Crawley Down',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0768817,
        LOCATION_LATITUDE_DEG: 51.1244074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR011900',
        LOCATION_NAME: 'Crawleyside',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0116394,
        LOCATION_LATITUDE_DEG: 54.755986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012000',
        LOCATION_NAME: 'Crawshawbooth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.288041,
        LOCATION_LATITUDE_DEG: 53.7212876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012100',
        LOCATION_NAME: 'Crawthorne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3177333,
        LOCATION_LATITUDE_DEG: 50.7701978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990152',
        LOCATION_NAME: 'Cray',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6042087,
        LOCATION_LATITUDE_DEG: 51.9163177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012200',
        LOCATION_NAME: 'Cray',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0887978,
        LOCATION_LATITUDE_DEG: 54.2083336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012300',
        LOCATION_NAME: 'Crayford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1819789,
        LOCATION_LATITUDE_DEG: 51.4500323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012400',
        LOCATION_NAME: 'Crayke',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1382259,
        LOCATION_LATITUDE_DEG: 54.1290058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012500',
        LOCATION_NAME: 'Craymere Beck',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0571514,
        LOCATION_LATITUDE_DEG: 52.8334563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012600',
        LOCATION_NAME: 'Crays Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4721057,
        LOCATION_LATITUDE_DEG: 51.6019421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012800',
        LOCATION_NAME: 'Crays Pond',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0816587,
        LOCATION_LATITUDE_DEG: 51.5199613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR012900',
        LOCATION_NAME: 'Crazelowman',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4004326,
        LOCATION_LATITUDE_DEG: 50.9253298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013000',
        LOCATION_NAME: 'Crazies Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8486784,
        LOCATION_LATITUDE_DEG: 51.5191561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013100',
        LOCATION_NAME: 'Creacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6807787,
        LOCATION_LATITUDE_DEG: 50.9616363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013200',
        LOCATION_NAME: 'Creagan',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3221594,
        LOCATION_LATITUDE_DEG: 56.3258617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013300',
        LOCATION_NAME: 'Creagh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3990554,
        LOCATION_LATITUDE_DEG: 54.3665952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013500',
        LOCATION_NAME: 'Creagorry',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3363682,
        LOCATION_LATITUDE_DEG: 57.4158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013600',
        LOCATION_NAME: 'Creamore',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7187648,
        LOCATION_LATITUDE_DEG: 52.8676061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013700',
        LOCATION_NAME: 'Creaton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9630667,
        LOCATION_LATITUDE_DEG: 52.3404374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013800',
        LOCATION_NAME: 'Crebilly',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1234125,
        LOCATION_LATITUDE_DEG: 54.8834307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013900',
        LOCATION_NAME: 'Creca',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2095295,
        LOCATION_LATITUDE_DEG: 55.0220243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014200',
        LOCATION_NAME: 'Credenhill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8035632,
        LOCATION_LATITUDE_DEG: 52.0856338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014300',
        LOCATION_NAME: 'Crediton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6563632,
        LOCATION_LATITUDE_DEG: 50.7931185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014500',
        LOCATION_NAME: 'Creebridge',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4799873,
        LOCATION_LATITUDE_DEG: 54.9604329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014600',
        LOCATION_NAME: 'Creech',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1245291,
        LOCATION_LATITUDE_DEG: 50.6440852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014700',
        LOCATION_NAME: 'Creech Heathfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0304739,
        LOCATION_LATITUDE_DEG: 51.037437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049900',
        LOCATION_NAME: 'Creech St Michael',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014800',
        LOCATION_NAME: 'Creech St. Michael',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0374728,
        LOCATION_LATITUDE_DEG: 51.0276351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014900',
        LOCATION_NAME: 'Creed',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8984784,
        LOCATION_LATITUDE_DEG: 50.2877824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015000',
        LOCATION_NAME: 'Creedy Bridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6350566,
        LOCATION_LATITUDE_DEG: 50.7978174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015100',
        LOCATION_NAME: 'Creedy Park',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6513596,
        LOCATION_LATITUDE_DEG: 50.7989189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015200',
        LOCATION_NAME: 'Creegbrawse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1650244,
        LOCATION_LATITUDE_DEG: 50.2453856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015500',
        LOCATION_NAME: 'Creekmoor',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0067469,
        LOCATION_LATITUDE_DEG: 50.742696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050000',
        LOCATION_NAME: 'Creeting St Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050100',
        LOCATION_NAME: 'Creeting St Peter',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015700',
        LOCATION_NAME: 'Creeting St. Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0644112,
        LOCATION_LATITUDE_DEG: 52.1686889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015800',
        LOCATION_NAME: 'Creeting St. Peter',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0402326,
        LOCATION_LATITUDE_DEG: 52.1817905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015900',
        LOCATION_NAME: 'Creeton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5008775,
        LOCATION_LATITUDE_DEG: 52.767267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016000',
        LOCATION_NAME: 'Creetown',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3780188,
        LOCATION_LATITUDE_DEG: 54.8989207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052100',
        LOCATION_NAME: 'Cregagh',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8957038,
        LOCATION_LATITUDE_DEG: 54.5788284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016900',
        LOCATION_NAME: 'Creggan',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3490211,
        LOCATION_LATITUDE_DEG: 54.9999618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016950',
        LOCATION_NAME: 'Creggan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0305088,
        LOCATION_LATITUDE_DEG: 54.6511231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990252',
        LOCATION_NAME: 'Cregneash',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7688324,
        LOCATION_LATITUDE_DEG: 54.0710722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017300',
        LOCATION_NAME: 'Cregrina',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.280664,
        LOCATION_LATITUDE_DEG: 52.1601417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017400',
        LOCATION_NAME: 'Creigiau',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3231815,
        LOCATION_LATITUDE_DEG: 51.5238812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017500',
        LOCATION_NAME: 'Cremyll',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1738257,
        LOCATION_LATITUDE_DEG: 50.35958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017600',
        LOCATION_NAME: 'Crendell',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8765778,
        LOCATION_LATITUDE_DEG: 50.9175104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017700',
        LOCATION_NAME: 'Crepigill',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2915428,
        LOCATION_LATITUDE_DEG: 57.4543916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017800',
        LOCATION_NAME: 'Crerag',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.537043,
        LOCATION_LATITUDE_DEG: 57.4353784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017900',
        LOCATION_NAME: 'Creslow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8199581,
        LOCATION_LATITUDE_DEG: 51.8870921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018000',
        LOCATION_NAME: 'Cressage',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6035237,
        LOCATION_LATITUDE_DEG: 52.6331851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018100',
        LOCATION_NAME: 'Cressbrook',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7405862,
        LOCATION_LATITUDE_DEG: 53.2523344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018200',
        LOCATION_NAME: 'Cresselly',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8021556,
        LOCATION_LATITUDE_DEG: 51.7223199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018300',
        LOCATION_NAME: 'Cressing',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5864858,
        LOCATION_LATITUDE_DEG: 51.8568657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018400',
        LOCATION_NAME: 'Cressington',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9093622,
        LOCATION_LATITUDE_DEG: 53.3573532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018600',
        LOCATION_NAME: 'Cresswell',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0403814,
        LOCATION_LATITUDE_DEG: 52.9481073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018500',
        LOCATION_NAME: 'Cresswell',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.538163,
        LOCATION_LATITUDE_DEG: 55.2352193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018700',
        LOCATION_NAME: 'Cresswell Quay',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8231848,
        LOCATION_LATITUDE_DEG: 51.7251173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018800',
        LOCATION_NAME: 'Creswell',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1477631,
        LOCATION_LATITUDE_DEG: 52.8316956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR018900',
        LOCATION_NAME: 'Creswell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2098485,
        LOCATION_LATITUDE_DEG: 53.263825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019000',
        LOCATION_NAME: 'Cretingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2600241,
        LOCATION_LATITUDE_DEG: 52.1954897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019300',
        LOCATION_NAME: 'Crew Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.996607,
        LOCATION_LATITUDE_DEG: 52.7331007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019400',
        LOCATION_NAME: 'Crewe',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4401942,
        LOCATION_LATITUDE_DEG: 53.0976251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019550',
        LOCATION_NAME: 'Crewe by Farndon',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8601939,
        LOCATION_LATITUDE_DEG: 53.0732775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019500',
        LOCATION_NAME: 'Crewe Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4078963,
        LOCATION_LATITUDE_DEG: 53.0938294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019600',
        LOCATION_NAME: 'Crewkerne',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7928877,
        LOCATION_LATITUDE_DEG: 50.881922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019700',
        LOCATION_NAME: 'Crianlarich',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.615641,
        LOCATION_LATITUDE_DEG: 56.3925683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019800',
        LOCATION_NAME: 'Cribyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1589413,
        LOCATION_LATITUDE_DEG: 52.1372516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019900',
        LOCATION_NAME: 'Criccieth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2329578,
        LOCATION_LATITUDE_DEG: 52.9193263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020000',
        LOCATION_NAME: 'Crich',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4773199,
        LOCATION_LATITUDE_DEG: 53.0860088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020100',
        LOCATION_NAME: 'Crick',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7378539,
        LOCATION_LATITUDE_DEG: 51.6080857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020200',
        LOCATION_NAME: 'Crick',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1368087,
        LOCATION_LATITUDE_DEG: 52.3470405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020300',
        LOCATION_NAME: 'Crickadarn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3278771,
        LOCATION_LATITUDE_DEG: 52.0707411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020400',
        LOCATION_NAME: 'Cricket Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8550839,
        LOCATION_LATITUDE_DEG: 51.3595391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020500',
        LOCATION_NAME: 'Cricket Malherbie',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9091002,
        LOCATION_LATITUDE_DEG: 50.8960222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050200',
        LOCATION_NAME: 'Cricket St Thomas',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020600',
        LOCATION_NAME: 'Cricket St. Thomas',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8916173,
        LOCATION_LATITUDE_DEG: 50.8719191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020700',
        LOCATION_NAME: 'Crickham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8102714,
        LOCATION_LATITUDE_DEG: 51.2471491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020800',
        LOCATION_NAME: 'Crickheath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0499922,
        LOCATION_LATITUDE_DEG: 52.7998026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR020900',
        LOCATION_NAME: 'Crickhowell',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1358753,
        LOCATION_LATITUDE_DEG: 51.8633194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021000',
        LOCATION_NAME: 'Cricklade',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8560006,
        LOCATION_LATITUDE_DEG: 51.6389745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021100',
        LOCATION_NAME: 'Crickleaze',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0340083,
        LOCATION_LATITUDE_DEG: 50.8955223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051200',
        LOCATION_NAME: 'Cricklewood',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2200736,
        LOCATION_LATITUDE_DEG: 51.5681035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021200',
        LOCATION_NAME: 'Crickmerry',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4885149,
        LOCATION_LATITUDE_DEG: 52.858806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021300',
        LOCATION_NAME: 'Cridling Stubbs',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.21228,
        LOCATION_LATITUDE_DEG: 53.6851636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021400',
        LOCATION_NAME: 'Crieff',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8416707,
        LOCATION_LATITUDE_DEG: 56.3735614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021500',
        LOCATION_NAME: 'Criftins',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9382293,
        LOCATION_LATITUDE_DEG: 52.9182121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021600',
        LOCATION_NAME: 'Criggan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7943806,
        LOCATION_LATITUDE_DEG: 50.4104964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021700',
        LOCATION_NAME: 'Criggion',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0388792,
        LOCATION_LATITUDE_DEG: 52.7280985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021800',
        LOCATION_NAME: 'Crigglestone',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5239305,
        LOCATION_LATITUDE_DEG: 53.6421668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR021900',
        LOCATION_NAME: 'Crimond',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9104912,
        LOCATION_LATITUDE_DEG: 57.6009599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022000',
        LOCATION_NAME: 'Crimplesham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4433985,
        LOCATION_LATITUDE_DEG: 52.6060387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022100',
        LOCATION_NAME: 'Crimscote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6575747,
        LOCATION_LATITUDE_DEG: 52.1228256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022200',
        LOCATION_NAME: 'Crinan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5593122,
        LOCATION_LATITUDE_DEG: 56.0891557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022300',
        LOCATION_NAME: 'Cringleford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2454379,
        LOCATION_LATITUDE_DEG: 52.6054261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022600',
        LOCATION_NAME: 'Crinow',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7181992,
        LOCATION_LATITUDE_DEG: 51.7939286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022800',
        LOCATION_NAME: 'Cripplestyle',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8725287,
        LOCATION_LATITUDE_DEG: 50.9102124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022700',
        LOCATION_NAME: "Cripp'S Corner",
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5318632,
        LOCATION_LATITUDE_DEG: 50.9619866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023000',
        LOCATION_NAME: 'Croachy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2319236,
        LOCATION_LATITUDE_DEG: 57.3168592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023350',
        LOCATION_NAME: 'Crockanboy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0708069,
        LOCATION_LATITUDE_DEG: 54.7293625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023500',
        LOCATION_NAME: 'Crockenhill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1627394,
        LOCATION_LATITUDE_DEG: 51.3828256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023600',
        LOCATION_NAME: 'Crockerhill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7057853,
        LOCATION_LATITUDE_DEG: 50.8585886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023700',
        LOCATION_NAME: 'Crockernwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7641144,
        LOCATION_LATITUDE_DEG: 50.7177116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023800',
        LOCATION_NAME: 'Crockerton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1949831,
        LOCATION_LATITUDE_DEG: 51.1785397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023900',
        LOCATION_NAME: 'Crocketford',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8276663,
        LOCATION_LATITUDE_DEG: 55.0326825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024100',
        LOCATION_NAME: 'Crockett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3102407,
        LOCATION_LATITUDE_DEG: 50.5281967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024200',
        LOCATION_NAME: 'Crockey Hill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0486456,
        LOCATION_LATITUDE_DEG: 53.9115869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024400',
        LOCATION_NAME: 'Crockham Heath',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.375826,
        LOCATION_LATITUDE_DEG: 51.3799455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024500',
        LOCATION_NAME: 'Crockham Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.06607,
        LOCATION_LATITUDE_DEG: 51.2360155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024600',
        LOCATION_NAME: 'Crockleford Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9700615,
        LOCATION_LATITUDE_DEG: 51.8986659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024700',
        LOCATION_NAME: 'Crockway',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5645577,
        LOCATION_LATITUDE_DEG: 50.7728078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024800',
        LOCATION_NAME: 'Croes Bychan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8799585,
        LOCATION_LATITUDE_DEG: 51.7710031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050600',
        LOCATION_NAME: 'Croes Y Mwyalch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025000',
        LOCATION_NAME: 'Croesau Bach',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1161192,
        LOCATION_LATITUDE_DEG: 52.8442078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025100',
        LOCATION_NAME: 'Croesbychan',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4834184,
        LOCATION_LATITUDE_DEG: 51.7404041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025200',
        LOCATION_NAME: 'Croesgoch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1580764,
        LOCATION_LATITUDE_DEG: 51.9280379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025300',
        LOCATION_NAME: 'Croesor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0400273,
        LOCATION_LATITUDE_DEG: 52.9819362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025400',
        LOCATION_NAME: 'Croespenmaen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1634878,
        LOCATION_LATITUDE_DEG: 51.6801955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025600',
        LOCATION_NAME: 'Croesyceiliog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3035875,
        LOCATION_LATITUDE_DEG: 51.8253255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025500',
        LOCATION_NAME: 'Croesyceiliog',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0107078,
        LOCATION_LATITUDE_DEG: 51.6583907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024900',
        LOCATION_NAME: 'Croes-Y-Mwyalch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.007808,
        LOCATION_LATITUDE_DEG: 51.6260872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025800',
        LOCATION_NAME: 'Croft',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8046682,
        LOCATION_LATITUDE_DEG: 52.2855562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025700',
        LOCATION_NAME: 'Croft',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5544132,
        LOCATION_LATITUDE_DEG: 53.4374618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026000',
        LOCATION_NAME: 'Croft',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2449222,
        LOCATION_LATITUDE_DEG: 52.5564588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR025900',
        LOCATION_NAME: 'Croft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2551149,
        LOCATION_LATITUDE_DEG: 53.13149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026100',
        LOCATION_NAME: 'Croft Ends',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4969307,
        LOCATION_LATITUDE_DEG: 54.5963697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026200',
        LOCATION_NAME: 'Croft Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3042622,
        LOCATION_LATITUDE_DEG: 53.1214936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026400',
        LOCATION_NAME: 'Croft on Tees',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5568461,
        LOCATION_LATITUDE_DEG: 54.4835186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026500',
        LOCATION_NAME: 'Croftamie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4452115,
        LOCATION_LATITUDE_DEG: 56.04224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR053100',
        LOCATION_NAME: 'Croftfoot',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2268152,
        LOCATION_LATITUDE_DEG: 55.8169122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026600',
        LOCATION_NAME: 'Crofthandy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1766179,
        LOCATION_LATITUDE_DEG: 50.2382853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026700',
        LOCATION_NAME: 'Croftinloan',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6962712,
        LOCATION_LATITUDE_DEG: 56.6892926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026900',
        LOCATION_NAME: 'Crofton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0666913,
        LOCATION_LATITUDE_DEG: 57.8083207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027000',
        LOCATION_NAME: 'Crofton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0852908,
        LOCATION_LATITUDE_DEG: 54.8425036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR026800',
        LOCATION_NAME: 'Crofton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6223158,
        LOCATION_LATITUDE_DEG: 51.36135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027200',
        LOCATION_NAME: 'Crofton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4280163,
        LOCATION_LATITUDE_DEG: 53.656966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027100',
        LOCATION_NAME: 'Crofton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4303697,
        LOCATION_LATITUDE_DEG: 52.9476834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990202',
        LOCATION_NAME: 'Crofton Hackett',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9960776,
        LOCATION_LATITUDE_DEG: 52.3736062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027300',
        LOCATION_NAME: 'Crofts Bank',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3618204,
        LOCATION_LATITUDE_DEG: 53.4576628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027400',
        LOCATION_NAME: 'Crofty',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1246628,
        LOCATION_LATITUDE_DEG: 51.6380043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027500',
        LOCATION_NAME: 'Croggan',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7143881,
        LOCATION_LATITUDE_DEG: 56.3817799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027900',
        LOCATION_NAME: 'Croglin',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6636383,
        LOCATION_LATITUDE_DEG: 54.8174987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028000',
        LOCATION_NAME: 'Croir',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8542665,
        LOCATION_LATITUDE_DEG: 58.2542773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028200',
        LOCATION_NAME: 'Cromarty',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0332657,
        LOCATION_LATITUDE_DEG: 57.6809965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028300',
        LOCATION_NAME: 'Crombie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5261993,
        LOCATION_LATITUDE_DEG: 56.0493306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028400',
        LOCATION_NAME: 'Cromdale',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'PH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5366823,
        LOCATION_LATITUDE_DEG: 57.3382543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028600',
        LOCATION_NAME: 'Cromer',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1100973,
        LOCATION_LATITUDE_DEG: 51.9403862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028500',
        LOCATION_NAME: 'Cromer',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2993214,
        LOCATION_LATITUDE_DEG: 52.9303577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028700',
        LOCATION_NAME: 'Cromer Hyde',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2457358,
        LOCATION_LATITUDE_DEG: 51.7966745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028800',
        LOCATION_NAME: 'Cromford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5594019,
        LOCATION_LATITUDE_DEG: 53.1079173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028900',
        LOCATION_NAME: 'Cromhall',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4382479,
        LOCATION_LATITUDE_DEG: 51.6140826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029000',
        LOCATION_NAME: 'Cromkill',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2683113,
        LOCATION_LATITUDE_DEG: 54.8220313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029100',
        LOCATION_NAME: 'Cromlix',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9222188,
        LOCATION_LATITUDE_DEG: 56.2443512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029200',
        LOCATION_NAME: 'Cromore',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4120483,
        LOCATION_LATITUDE_DEG: 58.1037624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029300',
        LOCATION_NAME: 'Crompton Fold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0744781,
        LOCATION_LATITUDE_DEG: 53.5846687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029400',
        LOCATION_NAME: 'Cromwell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8052789,
        LOCATION_LATITUDE_DEG: 53.1439141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029500',
        LOCATION_NAME: 'Cronberry',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2088383,
        LOCATION_LATITUDE_DEG: 55.4778775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029600',
        LOCATION_NAME: 'Crondall',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8618751,
        LOCATION_LATITUDE_DEG: 51.2326302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050300',
        LOCATION_NAME: 'Cronk Y Voddy',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029800',
        LOCATION_NAME: 'Cronkhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6868102,
        LOCATION_LATITUDE_DEG: 52.6699899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029700',
        LOCATION_NAME: 'Cronk-Y-Voddy',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6031468,
        LOCATION_LATITUDE_DEG: 54.2412765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR029900',
        LOCATION_NAME: 'Cronton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.76106,
        LOCATION_LATITUDE_DEG: 53.388561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030000',
        LOCATION_NAME: 'Crook',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8228984,
        LOCATION_LATITUDE_DEG: 54.3487536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030100',
        LOCATION_NAME: 'Crook',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7475794,
        LOCATION_LATITUDE_DEG: 54.7140751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030200',
        LOCATION_NAME: 'Crook O Lune',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7294764,
        LOCATION_LATITUDE_DEG: 54.073125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030300',
        LOCATION_NAME: 'Crook of Devon',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5468504,
        LOCATION_LATITUDE_DEG: 56.1864369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030400',
        LOCATION_NAME: 'Crookdake',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2528004,
        LOCATION_LATITUDE_DEG: 54.7823955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030500',
        LOCATION_NAME: 'Crookedholm',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4607691,
        LOCATION_LATITUDE_DEG: 55.6047925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050700',
        LOCATION_NAME: 'Crookes',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5048754,
        LOCATION_LATITUDE_DEG: 53.3893667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030700',
        LOCATION_NAME: 'Crookhall',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8170976,
        LOCATION_LATITUDE_DEG: 54.8446904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030900',
        LOCATION_NAME: 'Crookham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1330059,
        LOCATION_LATITUDE_DEG: 55.6372715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030800',
        LOCATION_NAME: 'Crookham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2163813,
        LOCATION_LATITUDE_DEG: 51.3751477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031000',
        LOCATION_NAME: 'Crookham Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2469178,
        LOCATION_LATITUDE_DEG: 51.3662472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031100',
        LOCATION_NAME: 'Crookham Village',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8637755,
        LOCATION_LATITUDE_DEG: 51.2671288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031300',
        LOCATION_NAME: 'Crooklands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7114879,
        LOCATION_LATITUDE_DEG: 54.2428404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR053200',
        LOCATION_NAME: 'Crookston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3659949,
        LOCATION_LATITUDE_DEG: 55.8426543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031800',
        LOCATION_NAME: 'Cropredy',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3182628,
        LOCATION_LATITUDE_DEG: 52.1158133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031900',
        LOCATION_NAME: 'Cropston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1810655,
        LOCATION_LATITUDE_DEG: 52.6923743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032000',
        LOCATION_NAME: 'Cropthorne',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0035626,
        LOCATION_LATITUDE_DEG: 52.1013204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032100',
        LOCATION_NAME: 'Cropton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8391148,
        LOCATION_LATITUDE_DEG: 54.2909192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032200',
        LOCATION_NAME: 'Cropwell Bishop',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9825056,
        LOCATION_LATITUDE_DEG: 52.91239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032300',
        LOCATION_NAME: 'Cropwell Butler',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9810584,
        LOCATION_LATITUDE_DEG: 52.9258907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032400',
        LOCATION_NAME: 'Crosbie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8393902,
        LOCATION_LATITUDE_DEG: 55.7103056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051650',
        LOCATION_NAME: 'Crosby',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.563185,
        LOCATION_LATITUDE_DEG: 54.1815504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032500',
        LOCATION_NAME: 'Crosby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4384123,
        LOCATION_LATITUDE_DEG: 54.7320953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051600',
        LOCATION_NAME: 'Crosby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0293143,
        LOCATION_LATITUDE_DEG: 53.4927482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032600',
        LOCATION_NAME: 'Crosby Garrett',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4184588,
        LOCATION_LATITUDE_DEG: 54.4808562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032700',
        LOCATION_NAME: 'Crosby Moor',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8397584,
        LOCATION_LATITUDE_DEG: 54.9298063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050400',
        LOCATION_NAME: 'Crosby on Eden',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032800',
        LOCATION_NAME: 'Crosby Ravensworth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5865219,
        LOCATION_LATITUDE_DEG: 54.5260689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR032900',
        LOCATION_NAME: 'Crosby Villa',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4093263,
        LOCATION_LATITUDE_DEG: 54.7372008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033000',
        LOCATION_NAME: 'Crosby-on-Eden',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8395899,
        LOCATION_LATITUDE_DEG: 54.9307062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033100',
        LOCATION_NAME: 'Croscombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5855775,
        LOCATION_LATITUDE_DEG: 51.1963471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033200',
        LOCATION_NAME: 'Crosemere',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8353257,
        LOCATION_LATITUDE_DEG: 52.8594081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033300',
        LOCATION_NAME: 'Crosland Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.826041,
        LOCATION_LATITUDE_DEG: 53.6288737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033400',
        LOCATION_NAME: 'Crosland Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8205868,
        LOCATION_LATITUDE_DEG: 53.6347717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033950',
        LOCATION_NAME: 'Cross',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2474557,
        LOCATION_LATITUDE_DEG: 54.9536718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033500',
        LOCATION_NAME: 'Cross',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2825399,
        LOCATION_LATITUDE_DEG: 58.473296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033900',
        LOCATION_NAME: 'Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.843499,
        LOCATION_LATITUDE_DEG: 51.2885613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034000',
        LOCATION_NAME: 'Cross Ash',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8614882,
        LOCATION_LATITUDE_DEG: 51.8727164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034200',
        LOCATION_NAME: 'Cross Common',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2024245,
        LOCATION_LATITUDE_DEG: 49.9663571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034300',
        LOCATION_NAME: 'Cross Gates',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.45826,
        LOCATION_LATITUDE_DEG: 53.8084853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034400',
        LOCATION_NAME: 'Cross Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1249643,
        LOCATION_LATITUDE_DEG: 52.6512801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034500',
        LOCATION_NAME: 'Cross Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5144179,
        LOCATION_LATITUDE_DEG: 53.7879789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR991110',
        LOCATION_NAME: 'Cross Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.513475,
        LOCATION_LATITUDE_DEG: 53.783644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034800',
        LOCATION_NAME: 'Cross Hands',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0864143,
        LOCATION_LATITUDE_DEG: 51.7939191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034900',
        LOCATION_NAME: 'Cross Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2403418,
        LOCATION_LATITUDE_DEG: 53.0184177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035000',
        LOCATION_NAME: 'Cross Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7498875,
        LOCATION_LATITUDE_DEG: 52.7328944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990245',
        LOCATION_NAME: 'Cross Hills',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.985614,
        LOCATION_LATITUDE_DEG: 53.9070668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035100',
        LOCATION_NAME: 'Cross Hills',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.98038,
        LOCATION_LATITUDE_DEG: 53.9010975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035200',
        LOCATION_NAME: 'Cross Houses',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6780746,
        LOCATION_LATITUDE_DEG: 52.6626857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036200',
        LOCATION_NAME: 'Cross in Hand',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2252672,
        LOCATION_LATITUDE_DEG: 50.9728926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035500',
        LOCATION_NAME: 'Cross Inn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4686404,
        LOCATION_LATITUDE_DEG: 51.7814212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035300',
        LOCATION_NAME: 'Cross Inn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.35484,
        LOCATION_LATITUDE_DEG: 52.1894577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035550',
        LOCATION_NAME: 'Cross Inn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1368602,
        LOCATION_LATITUDE_DEG: 52.2550484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035400',
        LOCATION_NAME: 'Cross Inn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3642105,
        LOCATION_LATITUDE_DEG: 51.5373864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990282',
        LOCATION_NAME: 'Cross Island',
        COUNTY_NAME: 'County Down',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6374425,
        LOCATION_LATITUDE_DEG: 53.9074717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035700',
        LOCATION_NAME: 'Cross Keys',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.125648,
        LOCATION_LATITUDE_DEG: 51.6201875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035600',
        LOCATION_NAME: 'Cross Keys',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6562313,
        LOCATION_LATITUDE_DEG: 52.099629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036000',
        LOCATION_NAME: 'Cross Lanes',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9294603,
        LOCATION_LATITUDE_DEG: 53.0164223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036100',
        LOCATION_NAME: 'Cross Roads',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.930534,
        LOCATION_LATITUDE_DEG: 53.8350914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051000',
        LOCATION_NAME: 'Crossacres',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2482552,
        LOCATION_LATITUDE_DEG: 53.3858111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036700',
        LOCATION_NAME: 'Crossapol',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8784804,
        LOCATION_LATITUDE_DEG: 56.4889079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036800',
        LOCATION_NAME: 'Crossbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4379769,
        LOCATION_LATITUDE_DEG: 58.134063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037000',
        LOCATION_NAME: 'Crossbush',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5301275,
        LOCATION_LATITUDE_DEG: 50.8442852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037100',
        LOCATION_NAME: 'Crosscanonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4455786,
        LOCATION_LATITUDE_DEG: 54.7374931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037200',
        LOCATION_NAME: 'Crosscombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1869161,
        LOCATION_LATITUDE_DEG: 50.3212877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037300',
        LOCATION_NAME: 'Crosscrake',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7326708,
        LOCATION_LATITUDE_DEG: 54.2716476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037600',
        LOCATION_NAME: 'Crossens',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'PR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9472694,
        LOCATION_LATITUDE_DEG: 53.6694899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037800',
        LOCATION_NAME: 'Crossflatts',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8442098,
        LOCATION_LATITUDE_DEG: 53.8608895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037900',
        LOCATION_NAME: 'Crossford',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8669146,
        LOCATION_LATITUDE_DEG: 55.6975944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038000',
        LOCATION_NAME: 'Crossford',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.498066,
        LOCATION_LATITUDE_DEG: 56.0634252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038100',
        LOCATION_NAME: 'Crossgar',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7756835,
        LOCATION_LATITUDE_DEG: 54.4106929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038200',
        LOCATION_NAME: 'Crossgate Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5995347,
        LOCATION_LATITUDE_DEG: 54.7777766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038500',
        LOCATION_NAME: 'Crossgates',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3738271,
        LOCATION_LATITUDE_DEG: 56.084129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038400',
        LOCATION_NAME: 'Crossgates',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3362095,
        LOCATION_LATITUDE_DEG: 52.2752527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038300',
        LOCATION_NAME: 'Crossgates',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4169238,
        LOCATION_LATITUDE_DEG: 54.2440096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038600',
        LOCATION_NAME: 'Crosshands',
        COUNTY_NAME: 'Carmarthenshire',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.621781,
        LOCATION_LATITUDE_DEG: 51.8748278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038900',
        LOCATION_NAME: 'Crosshill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6396771,
        LOCATION_LATITUDE_DEG: 55.3246654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR053000',
        LOCATION_NAME: 'Crosshill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2568211,
        LOCATION_LATITUDE_DEG: 55.8338748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038800',
        LOCATION_NAME: 'Crosshill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3228687,
        LOCATION_LATITUDE_DEG: 56.1499364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039000',
        LOCATION_NAME: 'Crosshouse',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5512127,
        LOCATION_LATITUDE_DEG: 55.6122925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039200',
        LOCATION_NAME: 'Crosslee',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5414527,
        LOCATION_LATITUDE_DEG: 55.862121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039300',
        LOCATION_NAME: 'Crossmaglen',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5989789,
        LOCATION_LATITUDE_DEG: 54.0831609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039400',
        LOCATION_NAME: 'Crossmichael',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9842593,
        LOCATION_LATITUDE_DEG: 54.9804304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039600',
        LOCATION_NAME: 'Crossmoor',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8418485,
        LOCATION_LATITUDE_DEG: 53.8379022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052900',
        LOCATION_NAME: 'Crossmyloof',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2843253,
        LOCATION_LATITUDE_DEG: 55.8344366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039900',
        LOCATION_NAME: 'Crossnacreevy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8498904,
        LOCATION_LATITUDE_DEG: 54.5609943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040200',
        LOCATION_NAME: 'Crosspipes',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8412396,
        LOCATION_LATITUDE_DEG: 52.4960685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050800',
        LOCATION_NAME: 'Crosspool',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5173184,
        LOCATION_LATITUDE_DEG: 53.3781535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990246',
        LOCATION_NAME: 'Crossroads',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8701816,
        LOCATION_LATITUDE_DEG: 57.5804865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040300',
        LOCATION_NAME: 'Crossroads',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4105329,
        LOCATION_LATITUDE_DEG: 57.0381103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040400',
        LOCATION_NAME: 'Crossway',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3925712,
        LOCATION_LATITUDE_DEG: 52.2115493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040500',
        LOCATION_NAME: 'Crossway Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2377927,
        LOCATION_LATITUDE_DEG: 52.3155445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040700',
        LOCATION_NAME: 'Crossways',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9618712,
        LOCATION_LATITUDE_DEG: 51.7172213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040600',
        LOCATION_NAME: 'Crossways',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8007275,
        LOCATION_LATITUDE_DEG: 52.5341755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040800',
        LOCATION_NAME: 'Crossways',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3255699,
        LOCATION_LATITUDE_DEG: 50.6956902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041000',
        LOCATION_NAME: 'Crosswell',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.731886,
        LOCATION_LATITUDE_DEG: 51.9950483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041100',
        LOCATION_NAME: 'Crosswood',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9581191,
        LOCATION_LATITUDE_DEG: 52.3352699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041200',
        LOCATION_NAME: 'Crosthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8533218,
        LOCATION_LATITUDE_DEG: 54.3140444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041300',
        LOCATION_NAME: 'Croston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7737587,
        LOCATION_LATITUDE_DEG: 53.6620888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041400',
        LOCATION_NAME: 'Crostwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3413777,
        LOCATION_LATITUDE_DEG: 52.6968322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041500',
        LOCATION_NAME: 'Crostwight',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4607983,
        LOCATION_LATITUDE_DEG: 52.8167506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041600',
        LOCATION_NAME: 'Crouch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3207229,
        LOCATION_LATITUDE_DEG: 51.2760157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051800',
        LOCATION_NAME: 'Crouch End',
        COUNTY_NAME: 'London',
        POSTCODE: 'N8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1337244,
        LOCATION_LATITUDE_DEG: 51.5883731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051700',
        LOCATION_NAME: 'Crouch Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'N4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.118663,
        LOCATION_LATITUDE_DEG: 51.5727177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041700',
        LOCATION_NAME: 'Croughton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8738122,
        LOCATION_LATITUDE_DEG: 53.2421414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041800',
        LOCATION_NAME: 'Croughton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.203176,
        LOCATION_LATITUDE_DEG: 51.9973073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR041900',
        LOCATION_NAME: 'Crovie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3219094,
        LOCATION_LATITUDE_DEG: 57.6787735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042000',
        LOCATION_NAME: 'Crow',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7637841,
        LOCATION_LATITUDE_DEG: 50.8358017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042100',
        LOCATION_NAME: 'Crow Edge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7155815,
        LOCATION_LATITUDE_DEG: 53.5345615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042400',
        LOCATION_NAME: 'Crowborough',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1659459,
        LOCATION_LATITUDE_DEG: 51.0542938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042500',
        LOCATION_NAME: 'Crowcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2293706,
        LOCATION_LATITUDE_DEG: 51.1227427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042600',
        LOCATION_NAME: 'Crowcombe Heathfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2314207,
        LOCATION_LATITUDE_DEG: 51.1009477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042700',
        LOCATION_NAME: 'Crowden',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8913369,
        LOCATION_LATITUDE_DEG: 53.4893548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042800',
        LOCATION_NAME: 'Crowdicote',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8492936,
        LOCATION_LATITUDE_DEG: 53.1837307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042900',
        LOCATION_NAME: 'Crowell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.915185,
        LOCATION_LATITUDE_DEG: 51.6828729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043100',
        LOCATION_NAME: 'Crowfield',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1023499,
        LOCATION_LATITUDE_DEG: 52.0696147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043000',
        LOCATION_NAME: 'Crowfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1424079,
        LOCATION_LATITUDE_DEG: 52.1775908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043200',
        LOCATION_NAME: 'Crowhill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1038209,
        LOCATION_LATITUDE_DEG: 53.4940606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043300',
        LOCATION_NAME: 'Crowhurst',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0081938,
        LOCATION_LATITUDE_DEG: 51.2090168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043400',
        LOCATION_NAME: 'Crowhurst',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.500855,
        LOCATION_LATITUDE_DEG: 50.8879773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043500',
        LOCATION_NAME: 'Crowland',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1668449,
        LOCATION_LATITUDE_DEG: 52.6753536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043600',
        LOCATION_NAME: 'Crowlas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4773473,
        LOCATION_LATITUDE_DEG: 50.1459712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043700',
        LOCATION_NAME: 'Crowle',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.113093,
        LOCATION_LATITUDE_DEG: 52.2029332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043800',
        LOCATION_NAME: 'Crowle',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8305192,
        LOCATION_LATITUDE_DEG: 53.6070515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR991008',
        LOCATION_NAME: 'Crowley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043900',
        LOCATION_NAME: 'Crowlista',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0363936,
        LOCATION_LATITUDE_DEG: 58.1932782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044000',
        LOCATION_NAME: 'Crowmarsh Gifford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1101759,
        LOCATION_LATITUDE_DEG: 51.5980665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044100',
        LOCATION_NAME: 'Crown Corner',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3069807,
        LOCATION_LATITUDE_DEG: 52.2830985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044200',
        LOCATION_NAME: 'Crown East',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2712508,
        LOCATION_LATITUDE_DEG: 52.1894672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044300',
        LOCATION_NAME: 'Crownhill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1321255,
        LOCATION_LATITUDE_DEG: 50.4161866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044400',
        LOCATION_NAME: 'Crownhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8029519,
        LOCATION_LATITUDE_DEG: 52.028207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044500',
        LOCATION_NAME: 'Crownland',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9537159,
        LOCATION_LATITUDE_DEG: 52.3324056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044600',
        LOCATION_NAME: 'Crowntown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3067816,
        LOCATION_LATITUDE_DEG: 50.1305705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049800',
        LOCATION_NAME: 'Crows Nest',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044700',
        LOCATION_NAME: 'Crows Nest',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9316228,
        LOCATION_LATITUDE_DEG: 52.6076826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042200',
        LOCATION_NAME: "Crow's Nest",
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4483422,
        LOCATION_LATITUDE_DEG: 50.4971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044800',
        LOCATION_NAME: 'Crowsley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9468834,
        LOCATION_LATITUDE_DEG: 51.509854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR044900',
        LOCATION_NAME: 'Crowther',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5527316,
        LOCATION_LATITUDE_DEG: 54.9018929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045000',
        LOCATION_NAME: 'Crowthorne',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7903993,
        LOCATION_LATITUDE_DEG: 51.3699416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045100',
        LOCATION_NAME: 'Crowton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6311667,
        LOCATION_LATITUDE_DEG: 53.2657435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045200',
        LOCATION_NAME: 'Croxall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7140064,
        LOCATION_LATITUDE_DEG: 52.7226839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045300',
        LOCATION_NAME: 'Croxby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2087977,
        LOCATION_LATITUDE_DEG: 53.4670342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045400',
        LOCATION_NAME: 'Croxby Top',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2309445,
        LOCATION_LATITUDE_DEG: 53.4714371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045500',
        LOCATION_NAME: 'Croxdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5838472,
        LOCATION_LATITUDE_DEG: 54.7261705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045600',
        LOCATION_NAME: 'Croxden',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9012865,
        LOCATION_LATITUDE_DEG: 52.9546091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045700',
        LOCATION_NAME: 'Croxley Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4407486,
        LOCATION_LATITUDE_DEG: 51.6465608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051500',
        LOCATION_NAME: 'Croxteth',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2987251,
        LOCATION_LATITUDE_DEG: 53.3307487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051400',
        LOCATION_NAME: 'Croxteth',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.901849,
        LOCATION_LATITUDE_DEG: 53.4605066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045800',
        LOCATION_NAME: 'Croxton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3142076,
        LOCATION_LATITUDE_DEG: 52.884002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR045900',
        LOCATION_NAME: 'Croxton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3457899,
        LOCATION_LATITUDE_DEG: 53.5955511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046000',
        LOCATION_NAME: 'Croxton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1773177,
        LOCATION_LATITUDE_DEG: 52.2245103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046150',
        LOCATION_NAME: 'Croxton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7570322,
        LOCATION_LATITUDE_DEG: 52.4442248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046100',
        LOCATION_NAME: 'Croxton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9452786,
        LOCATION_LATITUDE_DEG: 52.8406579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046200',
        LOCATION_NAME: 'Croxton Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6711587,
        LOCATION_LATITUDE_DEG: 53.0673285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046300',
        LOCATION_NAME: 'Croxton Kerrial',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7597488,
        LOCATION_LATITUDE_DEG: 52.8557791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046500',
        LOCATION_NAME: 'Croy',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.767119,
        LOCATION_LATITUDE_DEG: 55.3760738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046400',
        LOCATION_NAME: 'Croy',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0404027,
        LOCATION_LATITUDE_DEG: 55.9586253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046600',
        LOCATION_NAME: 'Croy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0095859,
        LOCATION_LATITUDE_DEG: 57.5212751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046700',
        LOCATION_NAME: 'Croyde',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2231332,
        LOCATION_LATITUDE_DEG: 51.130258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046900',
        LOCATION_NAME: 'Croydon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0988001,
        LOCATION_LATITUDE_DEG: 51.371929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR046800',
        LOCATION_NAME: 'Croydon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0657636,
        LOCATION_LATITUDE_DEG: 52.1332027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047000',
        LOCATION_NAME: 'Croyle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3236286,
        LOCATION_LATITUDE_DEG: 50.8791246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047100',
        LOCATION_NAME: 'Cruard',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8033055,
        LOCATION_LATITUDE_DEG: 57.1315605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047300',
        LOCATION_NAME: 'Cruckmeole',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.84125,
        LOCATION_LATITUDE_DEG: 52.6800892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047400',
        LOCATION_NAME: 'Cruckton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8403792,
        LOCATION_LATITUDE_DEG: 52.6855889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047500',
        LOCATION_NAME: 'Cruden Bay',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8460066,
        LOCATION_LATITUDE_DEG: 57.416941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047600',
        LOCATION_NAME: 'Crudgington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5427453,
        LOCATION_LATITUDE_DEG: 52.7585948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047700',
        LOCATION_NAME: 'Crudie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3343997,
        LOCATION_LATITUDE_DEG: 57.6073677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047800',
        LOCATION_NAME: 'Crudwell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0655041,
        LOCATION_LATITUDE_DEG: 51.6343775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047900',
        LOCATION_NAME: 'Crugmeer',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9632313,
        LOCATION_LATITUDE_DEG: 50.5501128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048000',
        LOCATION_NAME: 'Crugybar',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9540958,
        LOCATION_LATITUDE_DEG: 52.022937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048100',
        LOCATION_NAME: 'Crulivig',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8150543,
        LOCATION_LATITUDE_DEG: 58.1995704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048300',
        LOCATION_NAME: 'Crumlin',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2259317,
        LOCATION_LATITUDE_DEG: 54.6247097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048200',
        LOCATION_NAME: 'Crumlin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1356228,
        LOCATION_LATITUDE_DEG: 51.678301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048500',
        LOCATION_NAME: 'Crumplehorn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5227132,
        LOCATION_LATITUDE_DEG: 50.3355836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR050900',
        LOCATION_NAME: 'Crumpsall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2417258,
        LOCATION_LATITUDE_DEG: 53.5178092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048700',
        LOCATION_NAME: 'Crundale',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9441342,
        LOCATION_LATITUDE_DEG: 51.8241307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048600',
        LOCATION_NAME: 'Crundale',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9759097,
        LOCATION_LATITUDE_DEG: 51.2032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049000',
        LOCATION_NAME: 'Crux Easton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3832321,
        LOCATION_LATITUDE_DEG: 51.3057396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049100',
        LOCATION_NAME: 'Cruxton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5632976,
        LOCATION_LATITUDE_DEG: 50.7659067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049200',
        LOCATION_NAME: 'Crwbin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2144995,
        LOCATION_LATITUDE_DEG: 51.796621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049300',
        LOCATION_NAME: 'Cryers Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7359604,
        LOCATION_LATITUDE_DEG: 51.6609642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049400',
        LOCATION_NAME: 'Crymlyn Burrows',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8659547,
        LOCATION_LATITUDE_DEG: 51.6207006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049500',
        LOCATION_NAME: 'Crymych',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6475906,
        LOCATION_LATITUDE_DEG: 51.9702441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049600',
        LOCATION_NAME: 'Crynallt',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7817512,
        LOCATION_LATITUDE_DEG: 51.646102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR049700',
        LOCATION_NAME: 'Crynant',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7467526,
        LOCATION_LATITUDE_DEG: 51.7280072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR051300',
        LOCATION_NAME: 'Crystal Palace',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0787136,
        LOCATION_LATITUDE_DEG: 51.4209411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000100',
        LOCATION_NAME: 'Cuan Ferry',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6184005,
        LOCATION_LATITUDE_DEG: 56.2749708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000200',
        LOCATION_NAME: 'Cubbington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5067283,
        LOCATION_LATITUDE_DEG: 52.3121375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000300',
        LOCATION_NAME: 'Cubeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0696949,
        LOCATION_LATITUDE_DEG: 54.3011417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000400',
        LOCATION_NAME: 'Cubert',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1155154,
        LOCATION_LATITUDE_DEG: 50.3783927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000600',
        LOCATION_NAME: 'Cubley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7536336,
        LOCATION_LATITUDE_DEG: 52.9401001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000500',
        LOCATION_NAME: 'Cubley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6307201,
        LOCATION_LATITUDE_DEG: 53.5153528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000700',
        LOCATION_NAME: 'Cublington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7775167,
        LOCATION_LATITUDE_DEG: 51.8921892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000800',
        LOCATION_NAME: 'Cuckfield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1378704,
        LOCATION_LATITUDE_DEG: 51.0083986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU000900',
        LOCATION_NAME: 'Cucklington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3469516,
        LOCATION_LATITUDE_DEG: 51.0460246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001000',
        LOCATION_NAME: 'Cuckmere Haven',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1446827,
        LOCATION_LATITUDE_DEG: 50.7615666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001100',
        LOCATION_NAME: 'Cuckney',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1534841,
        LOCATION_LATITUDE_DEG: 53.2350204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001200',
        LOCATION_NAME: 'Cuckoo Bridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2115212,
        LOCATION_LATITUDE_DEG: 52.7683641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001300',
        LOCATION_NAME: 'Cuddesdon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1322108,
        LOCATION_LATITUDE_DEG: 51.7221751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001550',
        LOCATION_NAME: 'Cuddington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.788131,
        LOCATION_LATITUDE_DEG: 53.0173619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001500',
        LOCATION_NAME: 'Cuddington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6000949,
        LOCATION_LATITUDE_DEG: 53.239842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001400',
        LOCATION_NAME: 'Cuddington',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9296377,
        LOCATION_LATITUDE_DEG: 51.7931817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001600',
        LOCATION_NAME: 'Cuddy Hill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7703645,
        LOCATION_LATITUDE_DEG: 53.8310023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001700',
        LOCATION_NAME: 'Cuddy Point',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.697575,
        LOCATION_LATITUDE_DEG: 57.8751385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001800',
        LOCATION_NAME: 'Cudham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0744371,
        LOCATION_LATITUDE_DEG: 51.3181277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU001900',
        LOCATION_NAME: 'Cudlipptown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0907358,
        LOCATION_LATITUDE_DEG: 50.5915076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002000',
        LOCATION_NAME: 'Cudworth',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8795135,
        LOCATION_LATITUDE_DEG: 50.8896205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002100',
        LOCATION_NAME: 'Cudworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4123227,
        LOCATION_LATITUDE_DEG: 53.5753559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002200',
        LOCATION_NAME: 'Cuerdley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6796006,
        LOCATION_LATITUDE_DEG: 53.3763589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002400',
        LOCATION_NAME: 'Cuffley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1117782,
        LOCATION_LATITUDE_DEG: 51.7073644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002700',
        LOCATION_NAME: 'Culbokie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3374739,
        LOCATION_LATITUDE_DEG: 57.6016919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002800',
        LOCATION_NAME: 'Culburnie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5127491,
        LOCATION_LATITUDE_DEG: 57.4390738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002900',
        LOCATION_NAME: 'Culcheth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5207777,
        LOCATION_LATITUDE_DEG: 53.4532641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003000',
        LOCATION_NAME: 'Culconich',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5894501,
        LOCATION_LATITUDE_DEG: 57.8486308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003200',
        LOCATION_NAME: 'Culduie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8016379,
        LOCATION_LATITUDE_DEG: 57.3955845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003300',
        LOCATION_NAME: 'Culduthel',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2195117,
        LOCATION_LATITUDE_DEG: 57.4439693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003400',
        LOCATION_NAME: 'Culeaze',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2140262,
        LOCATION_LATITUDE_DEG: 50.7290003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003500',
        LOCATION_NAME: 'Culford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6947117,
        LOCATION_LATITUDE_DEG: 52.2965106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003600',
        LOCATION_NAME: 'Culgaith',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.603518,
        LOCATION_LATITUDE_DEG: 54.6609759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003700',
        LOCATION_NAME: 'Culham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2645643,
        LOCATION_LATITUDE_DEG: 51.6514716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003800',
        LOCATION_NAME: 'Culkein',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3407427,
        LOCATION_LATITUDE_DEG: 58.2423645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003900',
        LOCATION_NAME: 'Culkerton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1007954,
        LOCATION_LATITUDE_DEG: 51.6618869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004000',
        LOCATION_NAME: 'Culky',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6307888,
        LOCATION_LATITUDE_DEG: 54.3181936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004700',
        LOCATION_NAME: 'Cullen',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8169142,
        LOCATION_LATITUDE_DEG: 57.6894829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005000',
        LOCATION_NAME: 'Cullercoats',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4291285,
        LOCATION_LATITUDE_DEG: 55.0309018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005100',
        LOCATION_NAME: 'Cullingworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8975343,
        LOCATION_LATITUDE_DEG: 53.8253866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005200',
        LOCATION_NAME: 'Cullion',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3657381,
        LOCATION_LATITUDE_DEG: 54.8999539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005300',
        LOCATION_NAME: 'Cullion',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3026285,
        LOCATION_LATITUDE_DEG: 54.9516497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005400',
        LOCATION_NAME: 'Cullipool',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.650963,
        LOCATION_LATITUDE_DEG: 56.2562718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005500',
        LOCATION_NAME: 'Cullisse',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9702177,
        LOCATION_LATITUDE_DEG: 57.7512996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005600',
        LOCATION_NAME: 'Cullivoe',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0068705,
        LOCATION_LATITUDE_DEG: 60.7049629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005700',
        LOCATION_NAME: 'CULLODEN',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1424047,
        LOCATION_LATITUDE_DEG: 57.483774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005800',
        LOCATION_NAME: 'Culloden Moor',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0747902,
        LOCATION_LATITUDE_DEG: 57.4821728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU005900',
        LOCATION_NAME: 'Cullompton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3896672,
        LOCATION_LATITUDE_DEG: 50.8577247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006000',
        LOCATION_NAME: 'Cullybackey',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3489243,
        LOCATION_LATITUDE_DEG: 54.8832358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006100',
        LOCATION_NAME: 'Cullyhanna',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5822662,
        LOCATION_LATITUDE_DEG: 54.1331695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006200',
        LOCATION_NAME: 'Culm Davy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2453219,
        LOCATION_LATITUDE_DEG: 50.9275279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006300',
        LOCATION_NAME: 'Culmhead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1198161,
        LOCATION_LATITUDE_DEG: 50.9351307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006400',
        LOCATION_NAME: 'Culmington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7466978,
        LOCATION_LATITUDE_DEG: 52.4346634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006500',
        LOCATION_NAME: 'Culmore',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2560496,
        LOCATION_LATITUDE_DEG: 55.049161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006600',
        LOCATION_NAME: 'Culmstock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2756032,
        LOCATION_LATITUDE_DEG: 50.9144298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006800',
        LOCATION_NAME: 'Culnacnock',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1576594,
        LOCATION_LATITUDE_DEG: 57.5834912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006900',
        LOCATION_NAME: 'Culnady',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.658056,
        LOCATION_LATITUDE_DEG: 54.8769442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007000',
        LOCATION_NAME: 'Culpho',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2247747,
        LOCATION_LATITUDE_DEG: 52.0957779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007100',
        LOCATION_NAME: 'Culrain',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4096483,
        LOCATION_LATITUDE_DEG: 57.918921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007300',
        LOCATION_NAME: 'Culross',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6280117,
        LOCATION_LATITUDE_DEG: 56.055129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007400',
        LOCATION_NAME: 'Culroy',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6582885,
        LOCATION_LATITUDE_DEG: 55.3941777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007500',
        LOCATION_NAME: 'Culsalmond',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5814264,
        LOCATION_LATITUDE_DEG: 57.383145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007600',
        LOCATION_NAME: 'Cultra',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8155695,
        LOCATION_LATITUDE_DEG: 54.649913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007700',
        LOCATION_NAME: 'Cults',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0507334,
        LOCATION_LATITUDE_DEG: 56.266843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007800',
        LOCATION_NAME: 'Cults',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1713019,
        LOCATION_LATITUDE_DEG: 57.1189128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007900',
        LOCATION_NAME: 'Culver Down',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1004621,
        LOCATION_LATITUDE_DEG: 50.6657731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008000',
        LOCATION_NAME: 'Culverhill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2260267,
        LOCATION_LATITUDE_DEG: 50.5693991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008100',
        LOCATION_NAME: 'Culverthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4758171,
        LOCATION_LATITUDE_DEG: 52.9501901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008200',
        LOCATION_NAME: 'Culworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2036687,
        LOCATION_LATITUDE_DEG: 52.1172171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008300',
        LOCATION_NAME: 'Culzean',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7878256,
        LOCATION_LATITUDE_DEG: 55.3503759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU990052',
        LOCATION_NAME: 'Cumbernauld',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9900905,
        LOCATION_LATITUDE_DEG: 55.9517007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008400',
        LOCATION_NAME: 'Cumbernauld',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9885583,
        LOCATION_LATITUDE_DEG: 55.9471236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU990053',
        LOCATION_NAME: 'Cumbernauld',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0691755,
        LOCATION_LATITUDE_DEG: 51.5036129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008500',
        LOCATION_NAME: 'Cumbernauld Village',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9866773,
        LOCATION_LATITUDE_DEG: 55.962622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008700',
        LOCATION_NAME: 'Cumberworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6771545,
        LOCATION_LATITUDE_DEG: 53.5774604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008600',
        LOCATION_NAME: 'Cumberworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2577514,
        LOCATION_LATITUDE_DEG: 53.2387044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008800',
        LOCATION_NAME: 'Cumdivock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0214544,
        LOCATION_LATITUDE_DEG: 54.8283981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU008900',
        LOCATION_NAME: 'Cuminestown',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3330143,
        LOCATION_LATITUDE_DEG: 57.5418634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009100',
        LOCATION_NAME: 'Cummersdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9499144,
        LOCATION_LATITUDE_DEG: 54.8694064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009200',
        LOCATION_NAME: 'Cummertrees',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3456273,
        LOCATION_LATITUDE_DEG: 54.9854162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009300',
        LOCATION_NAME: 'Cummingston',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4487742,
        LOCATION_LATITUDE_DEG: 57.703189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009400',
        LOCATION_NAME: 'Cumnock',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2630343,
        LOCATION_LATITUDE_DEG: 55.453372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009500',
        LOCATION_NAME: 'Cumnor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3317409,
        LOCATION_LATITUDE_DEG: 51.7340811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009600',
        LOCATION_NAME: 'Cumrew',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7027665,
        LOCATION_LATITUDE_DEG: 54.8453021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009700',
        LOCATION_NAME: 'Cumwhinton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8532651,
        LOCATION_LATITUDE_DEG: 54.8674005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009800',
        LOCATION_NAME: 'Cumwhitton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7703655,
        LOCATION_LATITUDE_DEG: 54.8627057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009900',
        LOCATION_NAME: 'Cundall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3511167,
        LOCATION_LATITUDE_DEG: 54.1476178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010000',
        LOCATION_NAME: 'Cunninghamhead',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5792628,
        LOCATION_LATITUDE_DEG: 55.6435018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010100',
        LOCATION_NAME: 'Cunningsburgh',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2256781,
        LOCATION_LATITUDE_DEG: 60.0490971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010200',
        LOCATION_NAME: 'Cunsey',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9532843,
        LOCATION_LATITUDE_DEG: 54.3374483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010300',
        LOCATION_NAME: 'Cupar',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.010316,
        LOCATION_LATITUDE_DEG: 56.319549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010400',
        LOCATION_NAME: 'Cupar Muir',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0345054,
        LOCATION_LATITUDE_DEG: 56.3069489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010600',
        LOCATION_NAME: 'Curbar',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6227238,
        LOCATION_LATITUDE_DEG: 53.2673295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010700',
        LOCATION_NAME: 'Curborough',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.815783,
        LOCATION_LATITUDE_DEG: 52.7076825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010800',
        LOCATION_NAME: 'Curbridge',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5209089,
        LOCATION_LATITUDE_DEG: 51.7766923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010900',
        LOCATION_NAME: 'Curdridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2447162,
        LOCATION_LATITUDE_DEG: 50.9232001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011000',
        LOCATION_NAME: 'Curdworth',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7369963,
        LOCATION_LATITUDE_DEG: 52.5339662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011100',
        LOCATION_NAME: 'Curland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0337293,
        LOCATION_LATITUDE_DEG: 50.9516274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013000',
        LOCATION_NAME: 'Currian Vale',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8597935,
        LOCATION_LATITUDE_DEG: 50.373892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013100',
        LOCATION_NAME: 'Curridge',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.292511,
        LOCATION_LATITUDE_DEG: 51.4420529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013200',
        LOCATION_NAME: 'Currie',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3069983,
        LOCATION_LATITUDE_DEG: 55.8964049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013400',
        LOCATION_NAME: 'Curry Mallet',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9546826,
        LOCATION_LATITUDE_DEG: 50.9893269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013500',
        LOCATION_NAME: 'Curry Rivel',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8663397,
        LOCATION_LATITUDE_DEG: 51.0217355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013700',
        LOCATION_NAME: "Curteis' Corner",
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6500343,
        LOCATION_LATITUDE_DEG: 51.1234994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013800',
        LOCATION_NAME: 'Curthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0524489,
        LOCATION_LATITUDE_DEG: 54.8294906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013900',
        LOCATION_NAME: 'Curtisden Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4828276,
        LOCATION_LATITUDE_DEG: 51.144801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014000',
        LOCATION_NAME: 'Curtisknowle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7743126,
        LOCATION_LATITUDE_DEG: 50.3712837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014100',
        LOCATION_NAME: 'Cury',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.242988,
        LOCATION_LATITUDE_DEG: 50.04616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014200',
        LOCATION_NAME: 'Cury Cross Lanes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2230094,
        LOCATION_LATITUDE_DEG: 50.0482646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014300',
        LOCATION_NAME: 'Cusgarne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1412061,
        LOCATION_LATITUDE_DEG: 50.2232793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014400',
        LOCATION_NAME: 'Cushendall',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0665868,
        LOCATION_LATITUDE_DEG: 55.0791553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014500',
        LOCATION_NAME: 'Cushendun',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0514998,
        LOCATION_LATITUDE_DEG: 55.1303629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014900',
        LOCATION_NAME: 'Cushnie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3507467,
        LOCATION_LATITUDE_DEG: 57.6485665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015000',
        LOCATION_NAME: 'Cushuish',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1465179,
        LOCATION_LATITUDE_DEG: 51.0704418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015100',
        LOCATION_NAME: 'Cusop',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1097725,
        LOCATION_LATITUDE_DEG: 52.0671339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016900',
        LOCATION_NAME: 'Custom House',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015200',
        LOCATION_NAME: 'Cusworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1704435,
        LOCATION_LATITUDE_DEG: 53.530656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015400',
        LOCATION_NAME: 'Cutcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5257164,
        LOCATION_LATITUDE_DEG: 51.1419515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015500',
        LOCATION_NAME: 'Cutiau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0224172,
        LOCATION_LATITUDE_DEG: 52.7350126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015600',
        LOCATION_NAME: 'Cutler Heights',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7185884,
        LOCATION_LATITUDE_DEG: 53.7770809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015700',
        LOCATION_NAME: 'Cutmere',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3597464,
        LOCATION_LATITUDE_DEG: 50.4183934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015800',
        LOCATION_NAME: 'Cutmill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8648075,
        LOCATION_LATITUDE_DEG: 50.8504944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015900',
        LOCATION_NAME: 'Cutnall Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.175947,
        LOCATION_LATITUDE_DEG: 52.3140434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016000',
        LOCATION_NAME: 'Cutsdean',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8708381,
        LOCATION_LATITUDE_DEG: 51.9705105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016100',
        LOCATION_NAME: 'Cutsyke',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3653739,
        LOCATION_LATITUDE_DEG: 53.7147755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016200',
        LOCATION_NAME: 'Cutthorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4838864,
        LOCATION_LATITUDE_DEG: 53.2571273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016300',
        LOCATION_NAME: 'Cuttifords Door',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9612018,
        LOCATION_LATITUDE_DEG: 50.885424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016400',
        LOCATION_NAME: 'Cutts Heath',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4744346,
        LOCATION_LATITUDE_DEG: 51.6047786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016500',
        LOCATION_NAME: 'Cuttybridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.990369,
        LOCATION_LATITUDE_DEG: 51.8307348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016600',
        LOCATION_NAME: 'Cuxham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0363053,
        LOCATION_LATITUDE_DEG: 51.6518706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016700',
        LOCATION_NAME: 'Cuxton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4573268,
        LOCATION_LATITUDE_DEG: 51.3707192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU016800',
        LOCATION_NAME: 'Cuxwold',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2328498,
        LOCATION_LATITUDE_DEG: 53.493034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000100',
        LOCATION_NAME: 'Cwm',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.179753,
        LOCATION_LATITUDE_DEG: 51.7404997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000200',
        LOCATION_NAME: 'Cwm Bach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4192171,
        LOCATION_LATITUDE_DEG: 52.174481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000300',
        LOCATION_NAME: 'Cwm Bargoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3209041,
        LOCATION_LATITUDE_DEG: 51.7507064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000400',
        LOCATION_NAME: 'Cwm Cewydd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6695687,
        LOCATION_LATITUDE_DEG: 52.7048003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000500',
        LOCATION_NAME: 'Cwm Cou',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.489769,
        LOCATION_LATITUDE_DEG: 52.049749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000600',
        LOCATION_NAME: 'Cwm Cynfal',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9220318,
        LOCATION_LATITUDE_DEG: 52.9497257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000700',
        LOCATION_NAME: 'Cwm Dyserth',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4079337,
        LOCATION_LATITUDE_DEG: 53.2899568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000800',
        LOCATION_NAME: 'Cwm Golau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2752736,
        LOCATION_LATITUDE_DEG: 52.6435936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW000900',
        LOCATION_NAME: 'Cwm Head',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8498107,
        LOCATION_LATITUDE_DEG: 52.4928693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001000',
        LOCATION_NAME: 'Cwm Irfon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.671154,
        LOCATION_LATITUDE_DEG: 52.1327469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001050',
        LOCATION_NAME: 'Cwm Miles',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6911575,
        LOCATION_LATITUDE_DEG: 51.905307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001100',
        LOCATION_NAME: 'Cwm Penmachno',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.843567,
        LOCATION_LATITUDE_DEG: 53.0128307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001200',
        LOCATION_NAME: 'Cwm Prysor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8941355,
        LOCATION_LATITUDE_DEG: 52.9075262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001300',
        LOCATION_NAME: 'Cwm Teigl',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9154303,
        LOCATION_LATITUDE_DEG: 52.9701265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW008200',
        LOCATION_NAME: 'Cwm y Glo',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.161679,
        LOCATION_LATITUDE_DEG: 53.1396617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW008300',
        LOCATION_NAME: 'Cwm yr Allt',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001600',
        LOCATION_NAME: 'Cwmafan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7581127,
        LOCATION_LATITUDE_DEG: 51.6149999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001700',
        LOCATION_NAME: 'Cwmaman',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4527821,
        LOCATION_LATITUDE_DEG: 51.685301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001800',
        LOCATION_NAME: 'Cwmann',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0586933,
        LOCATION_LATITUDE_DEG: 52.1010495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001900',
        LOCATION_NAME: 'Cwmavon',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7581127,
        LOCATION_LATITUDE_DEG: 51.6149999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002000',
        LOCATION_NAME: 'Cwmavon',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0583145,
        LOCATION_LATITUDE_DEG: 51.7487062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002300',
        LOCATION_NAME: 'Cwmbach',
        COUNTY_NAME: 'Carmarthenshire',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5368796,
        LOCATION_LATITUDE_DEG: 51.9040318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002100',
        LOCATION_NAME: 'Cwmbach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1915947,
        LOCATION_LATITUDE_DEG: 51.7053151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002200',
        LOCATION_NAME: 'Cwmbach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4118833,
        LOCATION_LATITUDE_DEG: 51.7072027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002400',
        LOCATION_NAME: 'Cwmbelan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.550886,
        LOCATION_LATITUDE_DEG: 52.4218689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002500',
        LOCATION_NAME: 'Cwmbran',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0242625,
        LOCATION_LATITUDE_DEG: 51.6477969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002600',
        LOCATION_NAME: 'Cwmbwrla',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.95327,
        LOCATION_LATITUDE_DEG: 51.6353064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002700',
        LOCATION_NAME: 'Cwmcarn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1308375,
        LOCATION_LATITUDE_DEG: 51.6394899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002800',
        LOCATION_NAME: 'Cwmcarvan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7575194,
        LOCATION_LATITUDE_DEG: 51.7637988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW002900',
        LOCATION_NAME: 'Cwmcrawnon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2401909,
        LOCATION_LATITUDE_DEG: 51.8702152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003000',
        LOCATION_NAME: 'Cwmcych',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5105059,
        LOCATION_LATITUDE_DEG: 51.993943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003100',
        LOCATION_NAME: 'Cwmdale',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.798136,
        LOCATION_LATITUDE_DEG: 52.5530744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003200',
        LOCATION_NAME: 'Cwmdare',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.474013,
        LOCATION_LATITUDE_DEG: 51.7189036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003300',
        LOCATION_NAME: 'Cwmdauddwr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5378128,
        LOCATION_LATITUDE_DEG: 52.3009623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003700',
        LOCATION_NAME: 'Cwmdu',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9867721,
        LOCATION_LATITUDE_DEG: 51.9530359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003500',
        LOCATION_NAME: 'Cwmdu',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9590682,
        LOCATION_LATITUDE_DEG: 51.6357044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003600',
        LOCATION_NAME: 'Cwmdu',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6213359,
        LOCATION_LATITUDE_DEG: 51.6079937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003400',
        LOCATION_NAME: 'Cwmdu',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1923839,
        LOCATION_LATITUDE_DEG: 51.9059236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003800',
        LOCATION_NAME: 'Cwmduad',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3639805,
        LOCATION_LATITUDE_DEG: 51.955435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW990505',
        LOCATION_NAME: 'Cwmdyfran',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW003900',
        LOCATION_NAME: 'Cwmerfyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9098992,
        LOCATION_LATITUDE_DEG: 52.4272786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004000',
        LOCATION_NAME: 'Cwmfelin',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6481492,
        LOCATION_LATITUDE_DEG: 51.5969993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004100',
        LOCATION_NAME: 'Cwmfelin Boeth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6238784,
        LOCATION_LATITUDE_DEG: 51.8402253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004200',
        LOCATION_NAME: 'Cwmfelin Mynach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5740231,
        LOCATION_LATITUDE_DEG: 51.8932324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004300',
        LOCATION_NAME: 'Cwmfelinfach',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.17593,
        LOCATION_LATITUDE_DEG: 51.6176892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004400',
        LOCATION_NAME: 'Cwmffrwd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2865848,
        LOCATION_LATITUDE_DEG: 51.8289221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004500',
        LOCATION_NAME: 'Cwmfields',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0343824,
        LOCATION_LATITUDE_DEG: 51.6941998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004600',
        LOCATION_NAME: 'Cwmgelli',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1925024,
        LOCATION_LATITUDE_DEG: 51.6739964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004700',
        LOCATION_NAME: 'Cwmgiedd',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7574283,
        LOCATION_LATITUDE_DEG: 51.7859165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004800',
        LOCATION_NAME: 'Cwmgilla Lane',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0747716,
        LOCATION_LATITUDE_DEG: 52.3413581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW004900',
        LOCATION_NAME: 'Cwmgors',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8786459,
        LOCATION_LATITUDE_DEG: 51.7770179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005000',
        LOCATION_NAME: 'Cwmgwdi',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4153775,
        LOCATION_LATITUDE_DEG: 51.9199272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005100',
        LOCATION_NAME: 'Cwmgwili',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0640348,
        LOCATION_LATITUDE_DEG: 51.7777124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005200',
        LOCATION_NAME: 'Cwmgwrach',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6449169,
        LOCATION_LATITUDE_DEG: 51.7320042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005300',
        LOCATION_NAME: 'Cwmifor',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9494796,
        LOCATION_LATITUDE_DEG: 51.9130287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005400',
        LOCATION_NAME: 'Cwmisfael',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1876144,
        LOCATION_LATITUDE_DEG: 51.8204269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005500',
        LOCATION_NAME: 'Cwmllecoediog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7323235,
        LOCATION_LATITUDE_DEG: 52.6734986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005600',
        LOCATION_NAME: 'Cwmllinau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.703858,
        LOCATION_LATITUDE_DEG: 52.6482937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005700',
        LOCATION_NAME: 'Cwmllynfell',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8168953,
        LOCATION_LATITUDE_DEG: 51.7989157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005800',
        LOCATION_NAME: 'Cwmnant',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1527858,
        LOCATION_LATITUDE_DEG: 51.7008043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW005900',
        LOCATION_NAME: 'Cwmnantygroes',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1259935,
        LOCATION_LATITUDE_DEG: 51.7257038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006000',
        LOCATION_NAME: 'Cwmnyscoy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.03608,
        LOCATION_LATITUDE_DEG: 51.6905968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006100',
        LOCATION_NAME: 'Cwmoody',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0002823,
        LOCATION_LATITUDE_DEG: 51.7089011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006200',
        LOCATION_NAME: 'Cwmorgan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4847815,
        LOCATION_LATITUDE_DEG: 51.9861425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006300',
        LOCATION_NAME: 'Cwmparc',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.517532,
        LOCATION_LATITUDE_DEG: 51.6526021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006400',
        LOCATION_NAME: 'Cwmpengraig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4058005,
        LOCATION_LATITUDE_DEG: 52.0032433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006500',
        LOCATION_NAME: 'Cwmpenmaen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1890013,
        LOCATION_LATITUDE_DEG: 51.6711992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006600',
        LOCATION_NAME: 'Cwmpennar',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3818103,
        LOCATION_LATITUDE_DEG: 51.6879019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006700',
        LOCATION_NAME: 'Cwmrheidol',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8899769,
        LOCATION_LATITUDE_DEG: 52.3879695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006800',
        LOCATION_NAME: 'Cwmrhydyceirw',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9243722,
        LOCATION_LATITUDE_DEG: 51.6795098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW006900',
        LOCATION_NAME: 'Cwmsychpant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2246663,
        LOCATION_LATITUDE_DEG: 52.0920797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007000',
        LOCATION_NAME: 'Cwmsymlog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.914551,
        LOCATION_LATITUDE_DEG: 52.4361778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007100',
        LOCATION_NAME: 'Cwmtaf',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.41882,
        LOCATION_LATITUDE_DEG: 51.7785127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007200',
        LOCATION_NAME: 'Cwmtillery',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1325162,
        LOCATION_LATITUDE_DEG: 51.7474031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007300',
        LOCATION_NAME: 'Cwmtirmynach',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6196,
        LOCATION_LATITUDE_DEG: 52.9727278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007400',
        LOCATION_NAME: 'Cwmwysg Trecastle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6690566,
        LOCATION_LATITUDE_DEG: 51.9411261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001400',
        LOCATION_NAME: 'Cwm-y-Glo',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1603469,
        LOCATION_LATITUDE_DEG: 53.1384451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007500',
        LOCATION_NAME: 'Cwmyglyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6108007,
        LOCATION_LATITUDE_DEG: 52.8694204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007600',
        LOCATION_NAME: 'Cwmyoy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0189098,
        LOCATION_LATITUDE_DEG: 51.9031202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW001500',
        LOCATION_NAME: 'Cwm-yr-Allt',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2329051,
        LOCATION_LATITUDE_DEG: 51.6661962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007700',
        LOCATION_NAME: 'Cwmystradllyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1403177,
        LOCATION_LATITUDE_DEG: 52.9724303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007800',
        LOCATION_NAME: 'Cwmystwyth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7779283,
        LOCATION_LATITUDE_DEG: 52.3503672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW008400',
        LOCATION_NAME: 'Cwrt Y Cadno',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9104517,
        LOCATION_LATITUDE_DEG: 52.0841481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW007900',
        LOCATION_NAME: 'Cwrt y Gollen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1133708,
        LOCATION_LATITUDE_DEG: 51.8424744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW008100',
        LOCATION_NAME: 'Cwrtnewydd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2056713,
        LOCATION_LATITUDE_DEG: 52.108067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CW008000',
        LOCATION_NAME: 'Cwrt-Y-Cadno',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9087087,
        LOCATION_LATITUDE_DEG: 52.0802465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000100',
        LOCATION_NAME: 'Cyffredin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2038873,
        LOCATION_LATITUDE_DEG: 51.9330414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000200',
        LOCATION_NAME: 'Cyffylliog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4047014,
        LOCATION_LATITUDE_DEG: 53.1084372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000300',
        LOCATION_NAME: 'Cyfronydd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2678778,
        LOCATION_LATITUDE_DEG: 52.6602889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000400',
        LOCATION_NAME: 'Cymau',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0518094,
        LOCATION_LATITUDE_DEG: 53.0946369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000500',
        LOCATION_NAME: 'Cymdda',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5819444,
        LOCATION_LATITUDE_DEG: 51.5342926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000600',
        LOCATION_NAME: 'Cymdu',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2542493,
        LOCATION_LATITUDE_DEG: 52.8534112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000750',
        LOCATION_NAME: 'Cymmer',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6480642,
        LOCATION_LATITUDE_DEG: 51.6536574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000700',
        LOCATION_NAME: 'Cymmer',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4057846,
        LOCATION_LATITUDE_DEG: 51.6079943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000800',
        LOCATION_NAME: 'Cyncoed',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1530938,
        LOCATION_LATITUDE_DEG: 51.5082842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY000900',
        LOCATION_NAME: 'Cynghordy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7363547,
        LOCATION_LATITUDE_DEG: 52.041339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY001000',
        LOCATION_NAME: 'Cynheidre',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1864168,
        LOCATION_LATITUDE_DEG: 51.7438146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY001100',
        LOCATION_NAME: 'Cynllwyd Isaf',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6545092,
        LOCATION_LATITUDE_DEG: 52.8454146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY001200',
        LOCATION_NAME: 'Cynllwyd Uchaf',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6237069,
        LOCATION_LATITUDE_DEG: 52.8171123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY001300',
        LOCATION_NAME: 'Cynonville',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.700344,
        LOCATION_LATITUDE_DEG: 51.6408971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY001400',
        LOCATION_NAME: 'Cynwyd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4044659,
        LOCATION_LATITUDE_DEG: 52.9589211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CY001500',
        LOCATION_NAME: 'Cynwyl Elfed',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3659869,
        LOCATION_LATITUDE_DEG: 51.9219382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000100',
        LOCATION_NAME: 'Daccombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5487571,
        LOCATION_LATITUDE_DEG: 50.5014856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000200',
        LOCATION_NAME: 'Dacre',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8378354,
        LOCATION_LATITUDE_DEG: 54.630982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000300',
        LOCATION_NAME: 'Dacre',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7063107,
        LOCATION_LATITUDE_DEG: 54.0440122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000400',
        LOCATION_NAME: 'Dacre Banks',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6996762,
        LOCATION_LATITUDE_DEG: 54.0533081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000500',
        LOCATION_NAME: 'Daddry Shield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1640681,
        LOCATION_LATITUDE_DEG: 54.7358781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000600',
        LOCATION_NAME: 'Dadford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0279253,
        LOCATION_LATITUDE_DEG: 52.0385057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000700',
        LOCATION_NAME: 'Dadlington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.403247,
        LOCATION_LATITUDE_DEG: 52.5786623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000800',
        LOCATION_NAME: 'Dadnor',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6309066,
        LOCATION_LATITUDE_DEG: 51.9323121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA000900',
        LOCATION_NAME: 'Dafen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1376093,
        LOCATION_LATITUDE_DEG: 51.6935121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001000',
        LOCATION_NAME: 'Daffy Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8984749,
        LOCATION_LATITUDE_DEG: 52.6500385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001100',
        LOCATION_NAME: 'Dagenham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1497496,
        LOCATION_LATITUDE_DEG: 51.5397398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001200',
        LOCATION_NAME: 'Daglingworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0093866,
        LOCATION_LATITUDE_DEG: 51.744595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001300',
        LOCATION_NAME: 'Dagnall',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5604969,
        LOCATION_LATITUDE_DEG: 51.8361833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001400',
        LOCATION_NAME: 'Dagworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9874201,
        LOCATION_LATITUDE_DEG: 52.2126966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001500',
        LOCATION_NAME: 'Dailly',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.723991,
        LOCATION_LATITUDE_DEG: 55.2780595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001700',
        LOCATION_NAME: 'Dainton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6320666,
        LOCATION_LATITUDE_DEG: 50.4888879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001800',
        LOCATION_NAME: 'Dairsie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9506207,
        LOCATION_LATITUDE_DEG: 56.3444537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001900',
        LOCATION_NAME: 'Daisy Bank',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7562866,
        LOCATION_LATITUDE_DEG: 54.0530222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA019100',
        LOCATION_NAME: 'Daisy Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7988341,
        LOCATION_LATITUDE_DEG: 53.8068882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002000',
        LOCATION_NAME: 'Daisy Nook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.158055,
        LOCATION_LATITUDE_DEG: 53.4966621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002100',
        LOCATION_NAME: 'Dalavich',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2801634,
        LOCATION_LATITUDE_DEG: 56.2635627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002200',
        LOCATION_NAME: 'Dalbeattie',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8217159,
        LOCATION_LATITUDE_DEG: 54.9332209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002300',
        LOCATION_NAME: 'Dalbeg',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2242611,
        LOCATION_LATITUDE_DEG: 57.1899494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002400',
        LOCATION_NAME: 'Dalbury Lees',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6120009,
        LOCATION_LATITUDE_DEG: 52.9055227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002750',
        LOCATION_NAME: 'Dalby',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7284163,
        LOCATION_LATITUDE_DEG: 54.1694486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002600',
        LOCATION_NAME: 'Dalby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0202834,
        LOCATION_LATITUDE_DEG: 54.1323105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002700',
        LOCATION_NAME: 'Dalby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6743641,
        LOCATION_LATITUDE_DEG: 54.2914231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002500',
        LOCATION_NAME: 'Dalby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1116695,
        LOCATION_LATITUDE_DEG: 53.2081048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002800',
        LOCATION_NAME: 'Dalby Bar',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1060814,
        LOCATION_LATITUDE_DEG: 53.2160085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA002900',
        LOCATION_NAME: 'Dalcattaig',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6380666,
        LOCATION_LATITUDE_DEG: 57.2184589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003000',
        LOCATION_NAME: 'Dalchalm',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8453148,
        LOCATION_LATITUDE_DEG: 58.0280243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003100',
        LOCATION_NAME: 'Dalcharn',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3624931,
        LOCATION_LATITUDE_DEG: 58.4956819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003200',
        LOCATION_NAME: 'Dalchreichart',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8278399,
        LOCATION_LATITUDE_DEG: 57.1732493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003300',
        LOCATION_NAME: 'Dalcross',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0888878,
        LOCATION_LATITUDE_DEG: 57.5259809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003400',
        LOCATION_NAME: 'Dalderby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1298545,
        LOCATION_LATITUDE_DEG: 53.1770034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003500',
        LOCATION_NAME: 'Dale',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1754404,
        LOCATION_LATITUDE_DEG: 51.7078248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003600',
        LOCATION_NAME: 'Dale Abbey',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3503348,
        LOCATION_LATITUDE_DEG: 52.9451968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003700',
        LOCATION_NAME: 'Dalemain',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8125918,
        LOCATION_LATITUDE_DEG: 54.6345785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003800',
        LOCATION_NAME: 'Dalgarven',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7114461,
        LOCATION_LATITUDE_DEG: 55.6763043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA003900',
        LOCATION_NAME: 'Dalgety Bay',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3569967,
        LOCATION_LATITUDE_DEG: 56.0383217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004100',
        LOCATION_NAME: 'Dalginross',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9805818,
        LOCATION_LATITUDE_DEG: 56.3673664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004200',
        LOCATION_NAME: 'Dalguise',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6415558,
        LOCATION_LATITUDE_DEG: 56.6079812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004300',
        LOCATION_NAME: 'Dalham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5221649,
        LOCATION_LATITUDE_DEG: 52.2252997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004400',
        LOCATION_NAME: 'Daliburgh',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3720657,
        LOCATION_LATITUDE_DEG: 57.1680731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004500',
        LOCATION_NAME: 'Dalintober',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6005259,
        LOCATION_LATITUDE_DEG: 55.4310846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004600',
        LOCATION_NAME: 'Dalkeith',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0666187,
        LOCATION_LATITUDE_DEG: 55.8956034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004800',
        LOCATION_NAME: 'Dallas',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4652221,
        LOCATION_LATITUDE_DEG: 57.5534772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004900',
        LOCATION_NAME: 'Dalleagles',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2452072,
        LOCATION_LATITUDE_DEG: 55.3689696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005000',
        LOCATION_NAME: 'Dallicott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3346751,
        LOCATION_LATITUDE_DEG: 52.5495734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005100',
        LOCATION_NAME: 'Dallinghoo',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3138657,
        LOCATION_LATITUDE_DEG: 52.1455851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005300',
        LOCATION_NAME: 'Dallington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9284705,
        LOCATION_LATITUDE_DEG: 52.2521271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005200',
        LOCATION_NAME: 'Dallington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3594901,
        LOCATION_LATITUDE_DEG: 50.9465826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005400',
        LOCATION_NAME: 'Dalmahoy',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3649995,
        LOCATION_LATITUDE_DEG: 55.908411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005500',
        LOCATION_NAME: 'Dalmally',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.983837,
        LOCATION_LATITUDE_DEG: 56.4013759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005600',
        LOCATION_NAME: 'Dalmarnock',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2182801,
        LOCATION_LATITUDE_DEG: 55.8428184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005700',
        LOCATION_NAME: 'Dalmellington',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3956295,
        LOCATION_LATITUDE_DEG: 55.3240693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005800',
        LOCATION_NAME: 'Dalmeny',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3704715,
        LOCATION_LATITUDE_DEG: 55.9823205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA005900',
        LOCATION_NAME: 'Dalmore',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2389574,
        LOCATION_LATITUDE_DEG: 57.6897986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006000',
        LOCATION_NAME: 'Dalmuir',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4240681,
        LOCATION_LATITUDE_DEG: 55.9078256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006100',
        LOCATION_NAME: 'Dalnaspidal',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2195532,
        LOCATION_LATITUDE_DEG: 56.8285117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006200',
        LOCATION_NAME: 'Dalqueich',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4848611,
        LOCATION_LATITUDE_DEG: 56.2241409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006400',
        LOCATION_NAME: 'Dalry',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7188341,
        LOCATION_LATITUDE_DEG: 55.707102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006500',
        LOCATION_NAME: 'Dalry',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1649927,
        LOCATION_LATITUDE_DEG: 55.1055259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006300',
        LOCATION_NAME: 'Dalry',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2226714,
        LOCATION_LATITUDE_DEG: 55.9440105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006600',
        LOCATION_NAME: 'Dalrymple',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5909597,
        LOCATION_LATITUDE_DEG: 55.3971698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006700',
        LOCATION_NAME: 'Dalscote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9994434,
        LOCATION_LATITUDE_DEG: 52.1816162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006800',
        LOCATION_NAME: 'Dalserf',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9116656,
        LOCATION_LATITUDE_DEG: 55.7344036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA006900',
        LOCATION_NAME: 'Dalston',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9828283,
        LOCATION_LATITUDE_DEG: 54.8412012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018900',
        LOCATION_NAME: 'Dalston',
        COUNTY_NAME: 'London',
        POSTCODE: 'E8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0758669,
        LOCATION_LATITUDE_DEG: 51.5468147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007000',
        LOCATION_NAME: 'Dalswinton',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6694077,
        LOCATION_LATITUDE_DEG: 55.1512394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007100',
        LOCATION_NAME: 'Dalswinton Village',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6678424,
        LOCATION_LATITUDE_DEG: 55.1513417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007300',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.386527,
        LOCATION_LATITUDE_DEG: 55.0528259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007600',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.763261,
        LOCATION_LATITUDE_DEG: 53.5668762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007400',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8256044,
        LOCATION_LATITUDE_DEG: 55.042307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA990345',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8240777,
        LOCATION_LATITUDE_DEG: 54.4744238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007800',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8219017,
        LOCATION_LATITUDE_DEG: 54.4708524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007500',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7564119,
        LOCATION_LATITUDE_DEG: 53.6477736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007200',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3366039,
        LOCATION_LATITUDE_DEG: 54.1800148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007700',
        LOCATION_NAME: 'Dalton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3090137,
        LOCATION_LATITUDE_DEG: 53.4444451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018600',
        LOCATION_NAME: 'Dalton in Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018700',
        LOCATION_NAME: 'Dalton le Dale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA007900',
        LOCATION_NAME: 'Dalton Magna',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2971842,
        LOCATION_LATITUDE_DEG: 53.4331479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008100',
        LOCATION_NAME: 'Dalton on Tees',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5419541,
        LOCATION_LATITUDE_DEG: 54.4665475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008000',
        LOCATION_NAME: 'Dalton Piercy',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2786276,
        LOCATION_LATITUDE_DEG: 54.6736606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008300',
        LOCATION_NAME: 'Dalton-in-Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1835225,
        LOCATION_LATITUDE_DEG: 54.1548397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008400',
        LOCATION_NAME: 'Dalton-le-Dale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3643999,
        LOCATION_LATITUDE_DEG: 54.826924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA990923',
        LOCATION_NAME: 'Dalvey',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008500',
        LOCATION_NAME: 'Dalwhinnie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2400262,
        LOCATION_LATITUDE_DEG: 56.9349232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008600',
        LOCATION_NAME: 'Dalwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0654092,
        LOCATION_LATITUDE_DEG: 50.7995097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008800',
        LOCATION_NAME: 'Damerham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8531507,
        LOCATION_LATITUDE_DEG: 50.9429166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008900',
        LOCATION_NAME: 'Damery',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4278379,
        LOCATION_LATITUDE_DEG: 51.6467902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009000',
        LOCATION_NAME: 'Damgate',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5489235,
        LOCATION_LATITUDE_DEG: 52.6331251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA019000',
        LOCATION_NAME: 'Damson Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7653683,
        LOCATION_LATITUDE_DEG: 52.441778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009100',
        LOCATION_NAME: 'Dan y Parc',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.125284,
        LOCATION_LATITUDE_DEG: 51.8463176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009200',
        LOCATION_NAME: 'Danbury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5825315,
        LOCATION_LATITUDE_DEG: 51.7159504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009300',
        LOCATION_NAME: 'Danby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9080455,
        LOCATION_LATITUDE_DEG: 54.4695386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA991141',
        LOCATION_NAME: 'Danby Head',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.90889,
        LOCATION_LATITUDE_DEG: 54.46806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009400',
        LOCATION_NAME: 'Danby Wiske',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4818759,
        LOCATION_LATITUDE_DEG: 54.3816361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009500',
        LOCATION_NAME: 'Dancers End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6895466,
        LOCATION_LATITUDE_DEG: 51.7785747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009600',
        LOCATION_NAME: 'Dancing Green',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5277698,
        LOCATION_LATITUDE_DEG: 51.8848115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009700',
        LOCATION_NAME: 'Danderhall',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1043723,
        LOCATION_LATITUDE_DEG: 55.9128122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009800',
        LOCATION_NAME: 'Dane Bank',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1389396,
        LOCATION_LATITUDE_DEG: 53.4553611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA009900',
        LOCATION_NAME: 'Dane End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0608699,
        LOCATION_LATITUDE_DEG: 51.8749789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010000',
        LOCATION_NAME: 'Dane Hills',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1709326,
        LOCATION_LATITUDE_DEG: 52.6382681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010100',
        LOCATION_NAME: 'Danehill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 3.5089623,
        LOCATION_LATITUDE_DEG: 51.0302991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010200',
        LOCATION_NAME: 'Danescombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2286337,
        LOCATION_LATITUDE_DEG: 50.5055006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010300',
        LOCATION_NAME: 'Danesfield',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8194674,
        LOCATION_LATITUDE_DEG: 51.5567617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010400',
        LOCATION_NAME: 'Danesford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4024954,
        LOCATION_LATITUDE_DEG: 52.5208698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010500',
        LOCATION_NAME: 'Danesmoor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4025064,
        LOCATION_LATITUDE_DEG: 53.1606167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010600',
        LOCATION_NAME: 'Danestone',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1372029,
        LOCATION_LATITUDE_DEG: 57.1831191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010700',
        LOCATION_NAME: 'Danethorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7435116,
        LOCATION_LATITUDE_DEG: 53.1069023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010800',
        LOCATION_NAME: 'Daneway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0854832,
        LOCATION_LATITUDE_DEG: 51.7310941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010900',
        LOCATION_NAME: 'Danford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2905769,
        LOCATION_LATITUDE_DEG: 52.5409686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011100',
        LOCATION_NAME: 'Danrhelyg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4800077,
        LOCATION_LATITUDE_DEG: 52.0278483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011200',
        LOCATION_NAME: 'Danthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1115354,
        LOCATION_LATITUDE_DEG: 53.7752577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011300',
        LOCATION_NAME: 'Danygraig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6733464,
        LOCATION_LATITUDE_DEG: 51.4880845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011400',
        LOCATION_NAME: 'Danzey Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.817063,
        LOCATION_LATITUDE_DEG: 52.3227453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011500',
        LOCATION_NAME: 'Dapple Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9348624,
        LOCATION_LATITUDE_DEG: 52.8312932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011600',
        LOCATION_NAME: 'Darcy Lever',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4001652,
        LOCATION_LATITUDE_DEG: 53.56937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011800',
        LOCATION_NAME: 'Dardy',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1520582,
        LOCATION_LATITUDE_DEG: 51.8600147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011900',
        LOCATION_NAME: 'Darenth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2434786,
        LOCATION_LATITUDE_DEG: 51.4190286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012000',
        LOCATION_NAME: 'Daresbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6311365,
        LOCATION_LATITUDE_DEG: 53.3410522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012100',
        LOCATION_NAME: 'Darfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3742447,
        LOCATION_LATITUDE_DEG: 53.5334513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012200',
        LOCATION_NAME: 'Darfoulds',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1637471,
        LOCATION_LATITUDE_DEG: 53.2973312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012300',
        LOCATION_NAME: 'Dargate',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9859472,
        LOCATION_LATITUDE_DEG: 51.3144076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012400',
        LOCATION_NAME: 'Darite',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4573502,
        LOCATION_LATITUDE_DEG: 50.4972969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012500',
        LOCATION_NAME: 'Darkley',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6822799,
        LOCATION_LATITUDE_DEG: 54.2165749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012600',
        LOCATION_NAME: 'Darlaston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0333919,
        LOCATION_LATITUDE_DEG: 52.5686708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012700',
        LOCATION_NAME: 'Darley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.688978,
        LOCATION_LATITUDE_DEG: 54.0314114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012800',
        LOCATION_NAME: 'Darley Abbey',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.488679,
        LOCATION_LATITUDE_DEG: 52.9426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA012900',
        LOCATION_NAME: 'Darley Bridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.596667,
        LOCATION_LATITUDE_DEG: 53.1504196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013000',
        LOCATION_NAME: 'Darley Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5968367,
        LOCATION_LATITUDE_DEG: 53.1658201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013100',
        LOCATION_NAME: 'Darley Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7523697,
        LOCATION_LATITUDE_DEG: 52.971204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013200',
        LOCATION_NAME: 'Darley Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5544823,
        LOCATION_LATITUDE_DEG: 53.1719263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013300',
        LOCATION_NAME: 'Darlingscott',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6604421,
        LOCATION_LATITUDE_DEG: 52.0761224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013400',
        LOCATION_NAME: 'Darlington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5524351,
        LOCATION_LATITUDE_DEG: 54.5255574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013500',
        LOCATION_NAME: 'Darliston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.624672,
        LOCATION_LATITUDE_DEG: 52.8974115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013600',
        LOCATION_NAME: 'Darlton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8395821,
        LOCATION_LATITUDE_DEG: 53.253622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013700',
        LOCATION_NAME: 'Darmsden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0625887,
        LOCATION_LATITUDE_DEG: 52.1342866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013800',
        LOCATION_NAME: 'Darnall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4103046,
        LOCATION_LATITUDE_DEG: 53.3847388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA013900',
        LOCATION_NAME: 'Darnhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5267792,
        LOCATION_LATITUDE_DEG: 53.1685381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014000',
        LOCATION_NAME: 'Darnick',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7428326,
        LOCATION_LATITUDE_DEG: 55.6001733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014100',
        LOCATION_NAME: 'Darowen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7270281,
        LOCATION_LATITUDE_DEG: 52.6010926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA990383',
        LOCATION_NAME: 'Darragh Cross',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014300',
        LOCATION_NAME: 'Darran Park',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.447425,
        LOCATION_LATITUDE_DEG: 51.6574981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014400',
        LOCATION_NAME: 'Darrington',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2664961,
        LOCATION_LATITUDE_DEG: 53.6745678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014500',
        LOCATION_NAME: 'Darsham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5488276,
        LOCATION_LATITUDE_DEG: 52.2731915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014600',
        LOCATION_NAME: 'Darshill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5625512,
        LOCATION_LATITUDE_DEG: 51.1919456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014700',
        LOCATION_NAME: 'Dartford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2213591,
        LOCATION_LATITUDE_DEG: 51.4434373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014800',
        LOCATION_NAME: 'Dartington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7050652,
        LOCATION_LATITUDE_DEG: 50.449883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014900',
        LOCATION_NAME: 'Dartington Hall',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6922252,
        LOCATION_LATITUDE_DEG: 50.4520853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015000',
        LOCATION_NAME: 'Dartmeet',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8751719,
        LOCATION_LATITUDE_DEG: 50.5426932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015100',
        LOCATION_NAME: 'Dartmouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5920749,
        LOCATION_LATITUDE_DEG: 50.3488797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015200',
        LOCATION_NAME: 'Darton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5211246,
        LOCATION_LATITUDE_DEG: 53.5853607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015300',
        LOCATION_NAME: 'Darvel',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2805593,
        LOCATION_LATITUDE_DEG: 55.6096888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015400',
        LOCATION_NAME: 'Darwen',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4657876,
        LOCATION_LATITUDE_DEG: 53.6947856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015500',
        LOCATION_NAME: 'Datchet',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5769587,
        LOCATION_LATITUDE_DEG: 51.4835472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015600',
        LOCATION_NAME: 'Datchworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1550558,
        LOCATION_LATITUDE_DEG: 51.8538763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015700',
        LOCATION_NAME: 'Daubhill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4470647,
        LOCATION_LATITUDE_DEG: 53.5615719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015800',
        LOCATION_NAME: 'Dauntsey',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0093724,
        LOCATION_LATITUDE_DEG: 51.5354703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA015900',
        LOCATION_NAME: 'Dauntsey Lock',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9973911,
        LOCATION_LATITUDE_DEG: 51.5181691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016000',
        LOCATION_NAME: 'Davenham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5098153,
        LOCATION_LATITUDE_DEG: 53.2355425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016100',
        LOCATION_NAME: 'Davenport',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3050403,
        LOCATION_LATITUDE_DEG: 53.1887306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016200',
        LOCATION_NAME: 'Daventry',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1588759,
        LOCATION_LATITUDE_DEG: 52.2580308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016300',
        LOCATION_NAME: 'Davids Well',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3885125,
        LOCATION_LATITUDE_DEG: 52.3928657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016400',
        LOCATION_NAME: 'Davidsons Mains',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2704669,
        LOCATION_LATITUDE_DEG: 55.9673146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016500',
        LOCATION_NAME: 'Davidstow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.613101,
        LOCATION_LATITUDE_DEG: 50.6523178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016700',
        LOCATION_NAME: 'Daviot',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1315659,
        LOCATION_LATITUDE_DEG: 57.4251695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016800',
        LOCATION_NAME: 'Daviot',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4170203,
        LOCATION_LATITUDE_DEG: 57.3445372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016900',
        LOCATION_NAME: 'Davy Lamp',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4674275,
        LOCATION_LATITUDE_DEG: 54.7202685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017000',
        LOCATION_NAME: 'Davyhulme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3732447,
        LOCATION_LATITUDE_DEG: 53.4550566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017100',
        LOCATION_NAME: 'Dawdon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3300831,
        LOCATION_LATITUDE_DEG: 54.8272788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017200',
        LOCATION_NAME: 'Dawley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4659329,
        LOCATION_LATITUDE_DEG: 52.6695805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017300',
        LOCATION_NAME: 'Dawley Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4654556,
        LOCATION_LATITUDE_DEG: 52.6719829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017400',
        LOCATION_NAME: 'Dawlish',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4704265,
        LOCATION_LATITUDE_DEG: 50.5798996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017500',
        LOCATION_NAME: 'Dawlish Warren',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4440843,
        LOCATION_LATITUDE_DEG: 50.5970938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017900',
        LOCATION_NAME: 'Daws Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6142871,
        LOCATION_LATITUDE_DEG: 51.5652385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018000',
        LOCATION_NAME: 'Daws House',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3812411,
        LOCATION_LATITUDE_DEG: 50.6212086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018100',
        LOCATION_NAME: 'Dawsmere',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1459524,
        LOCATION_LATITUDE_DEG: 52.8485708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018200',
        LOCATION_NAME: 'Daybrook',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1366604,
        LOCATION_LATITUDE_DEG: 52.9984003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018300',
        LOCATION_NAME: 'Dayhills',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0618713,
        LOCATION_LATITUDE_DEG: 52.8936975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018400',
        LOCATION_NAME: 'Daylesford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6455155,
        LOCATION_LATITUDE_DEG: 51.9302049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA018500',
        LOCATION_NAME: 'Daywell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0522368,
        LOCATION_LATITUDE_DEG: 52.8964165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DD000100',
        LOCATION_NAME: 'Ddol',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2750657,
        LOCATION_LATITUDE_DEG: 53.227745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000100',
        LOCATION_NAME: 'Deaf Hill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'TS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4040493,
        LOCATION_LATITUDE_DEG: 54.7201713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000200',
        LOCATION_NAME: 'Deal',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4044623,
        LOCATION_LATITUDE_DEG: 51.2225959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000300',
        LOCATION_NAME: 'Dean',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4353175,
        LOCATION_LATITUDE_DEG: 54.6145876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000400',
        LOCATION_NAME: 'Dean',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4679172,
        LOCATION_LATITUDE_DEG: 51.1943407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000500',
        LOCATION_NAME: 'Dean',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5018144,
        LOCATION_LATITUDE_DEG: 51.8993007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000600',
        LOCATION_NAME: 'Dean Prior',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7887757,
        LOCATION_LATITUDE_DEG: 50.4569914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE990937',
        LOCATION_NAME: 'Dean Row',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000700',
        LOCATION_NAME: 'Deancombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8058888,
        LOCATION_LATITUDE_DEG: 50.4597853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000800',
        LOCATION_NAME: 'Deane',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2156044,
        LOCATION_LATITUDE_DEG: 51.2481347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE000900',
        LOCATION_NAME: 'Deans',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5564144,
        LOCATION_LATITUDE_DEG: 55.9019165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001100',
        LOCATION_NAME: 'Deanscales',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3988207,
        LOCATION_LATITUDE_DEG: 54.6224844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001200',
        LOCATION_NAME: 'Deanshanger',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8901994,
        LOCATION_LATITUDE_DEG: 52.0506062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001300',
        LOCATION_NAME: 'Deanston',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0715249,
        LOCATION_LATITUDE_DEG: 56.1902441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001400',
        LOCATION_NAME: 'Dearham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4405413,
        LOCATION_LATITUDE_DEG: 54.7097963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE019300',
        LOCATION_NAME: 'Dearnley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.116928,
        LOCATION_LATITUDE_DEG: 53.6444315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001500',
        LOCATION_NAME: 'Debach',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2792549,
        LOCATION_LATITUDE_DEG: 52.1411834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001600',
        LOCATION_NAME: 'Debden',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2648465,
        LOCATION_LATITUDE_DEG: 51.9769813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001700',
        LOCATION_NAME: 'Debden Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3008035,
        LOCATION_LATITUDE_DEG: 51.9644844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE990384',
        LOCATION_NAME: 'Debdon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001800',
        LOCATION_NAME: 'Debenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1831665,
        LOCATION_LATITUDE_DEG: 52.224197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001900',
        LOCATION_NAME: 'Dechmont',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5326835,
        LOCATION_LATITUDE_DEG: 55.9220127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002000',
        LOCATION_NAME: 'Decker Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3676258,
        LOCATION_LATITUDE_DEG: 52.683682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018900',
        LOCATION_NAME: 'Deckham',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5962798,
        LOCATION_LATITUDE_DEG: 54.9545498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002100',
        LOCATION_NAME: 'Deddington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3191147,
        LOCATION_LATITUDE_DEG: 51.9802036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002200',
        LOCATION_NAME: 'Dedham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9951265,
        LOCATION_LATITUDE_DEG: 51.9584752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002300',
        LOCATION_NAME: 'Dedridge',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5118967,
        LOCATION_LATITUDE_DEG: 55.8777118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002500',
        LOCATION_NAME: 'Deene',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6052321,
        LOCATION_LATITUDE_DEG: 52.5235497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002600',
        LOCATION_NAME: 'Deenethorpe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5893124,
        LOCATION_LATITUDE_DEG: 52.5161497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002700',
        LOCATION_NAME: 'Deepcar',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5653629,
        LOCATION_LATITUDE_DEG: 53.4774489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002800',
        LOCATION_NAME: 'Deepcut',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7064307,
        LOCATION_LATITUDE_DEG: 51.3037356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002900',
        LOCATION_NAME: 'Deepdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9272718,
        LOCATION_LATITUDE_DEG: 54.5210692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003000',
        LOCATION_NAME: 'Deepdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4248906,
        LOCATION_LATITUDE_DEG: 54.2507348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003200',
        LOCATION_NAME: 'Deepdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1652182,
        LOCATION_LATITUDE_DEG: 54.1998309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003100',
        LOCATION_NAME: 'Deepdale',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4223845,
        LOCATION_LATITUDE_DEG: 53.6542583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003300',
        LOCATION_NAME: 'Deepdean',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5581287,
        LOCATION_LATITUDE_DEG: 51.886308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003400',
        LOCATION_NAME: 'Deeping Gate',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2957274,
        LOCATION_LATITUDE_DEG: 52.6703536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018700',
        LOCATION_NAME: 'Deeping St James',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018800',
        LOCATION_NAME: 'Deeping St Nicholas',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003500',
        LOCATION_NAME: 'Deeping St. James',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2870507,
        LOCATION_LATITUDE_DEG: 52.6709568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003600',
        LOCATION_NAME: 'Deeping St. Nicholas',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2009281,
        LOCATION_LATITUDE_DEG: 52.7275611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003700',
        LOCATION_NAME: 'Deerfold',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9119053,
        LOCATION_LATITUDE_DEG: 52.2991544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003800',
        LOCATION_NAME: 'Deerhurst',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1872434,
        LOCATION_LATITUDE_DEG: 51.965514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE003900',
        LOCATION_NAME: 'Deerness',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7726174,
        LOCATION_LATITUDE_DEG: 58.9438031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004000',
        LOCATION_NAME: 'Deerpark',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4064539,
        LOCATION_LATITUDE_DEG: 54.713146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004100',
        LOCATION_NAME: 'Deerstones',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8642884,
        LOCATION_LATITUDE_DEG: 53.9717014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004200',
        LOCATION_NAME: 'Deeside',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0421428,
        LOCATION_LATITUDE_DEG: 53.2044409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004300',
        LOCATION_NAME: 'Defford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1176747,
        LOCATION_LATITUDE_DEG: 52.0869291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004400',
        LOCATION_NAME: 'Defynnog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5627121,
        LOCATION_LATITUDE_DEG: 51.9391238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004500',
        LOCATION_NAME: 'Deganwy',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.834487,
        LOCATION_LATITUDE_DEG: 53.2969606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004700',
        LOCATION_NAME: 'Deighton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7550106,
        LOCATION_LATITUDE_DEG: 53.6702708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004600',
        LOCATION_NAME: 'Deighton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4127438,
        LOCATION_LATITUDE_DEG: 54.4102439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004750',
        LOCATION_NAME: 'Deighton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0449424,
        LOCATION_LATITUDE_DEG: 53.8863787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004800',
        LOCATION_NAME: 'Deiniolen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1268397,
        LOCATION_LATITUDE_DEG: 53.1445514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE004900',
        LOCATION_NAME: 'Deiraclete',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8051814,
        LOCATION_LATITUDE_DEG: 57.8883407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005000',
        LOCATION_NAME: 'Delabole',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7308245,
        LOCATION_LATITUDE_DEG: 50.6227103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005100',
        LOCATION_NAME: 'Delamere',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6541547,
        LOCATION_LATITUDE_DEG: 53.2127403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005200',
        LOCATION_NAME: 'Delaware',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2221212,
        LOCATION_LATITUDE_DEG: 50.5164016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005500',
        LOCATION_NAME: 'Delny',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1258139,
        LOCATION_LATITUDE_DEG: 57.7225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005600',
        LOCATION_NAME: 'Delph',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0221682,
        LOCATION_LATITUDE_DEG: 53.5674662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005800',
        LOCATION_NAME: 'Dembleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.449441,
        LOCATION_LATITUDE_DEG: 52.9263818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005900',
        LOCATION_NAME: 'Den Cross',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.072192,
        LOCATION_LATITUDE_DEG: 51.1822117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006000',
        LOCATION_NAME: 'Den of Lindores',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2082442,
        LOCATION_LATITUDE_DEG: 56.3406552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006100',
        LOCATION_NAME: 'Denaby Main',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2483062,
        LOCATION_LATITUDE_DEG: 53.4893508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006200',
        LOCATION_NAME: 'Denbigh',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4192468,
        LOCATION_LATITUDE_DEG: 53.1830498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006300',
        LOCATION_NAME: 'Denbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6600786,
        LOCATION_LATITUDE_DEG: 50.5076955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006400',
        LOCATION_NAME: 'Denby',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4100981,
        LOCATION_LATITUDE_DEG: 53.0126036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006500',
        LOCATION_NAME: 'Denby Dale',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6562245,
        LOCATION_LATITUDE_DEG: 53.5712623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006600',
        LOCATION_NAME: 'Denby Village',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3981779,
        LOCATION_LATITUDE_DEG: 53.0165087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006700',
        LOCATION_NAME: 'Denchworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4488075,
        LOCATION_LATITUDE_DEG: 51.6240738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006800',
        LOCATION_NAME: 'Dendron',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.153118,
        LOCATION_LATITUDE_DEG: 54.1271338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE006900',
        LOCATION_NAME: 'Denecroft',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5022268,
        LOCATION_LATITUDE_DEG: 51.8263042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007000',
        LOCATION_NAME: 'Denford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5422501,
        LOCATION_LATITUDE_DEG: 52.3775371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007100',
        LOCATION_NAME: 'Denford Ash',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.509594,
        LOCATION_LATITUDE_DEG: 52.3760328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007200',
        LOCATION_NAME: 'Denford Park',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4800386,
        LOCATION_LATITUDE_DEG: 51.4206518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007300',
        LOCATION_NAME: 'Dengie',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8749408,
        LOCATION_LATITUDE_DEG: 51.6898431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007400',
        LOCATION_NAME: 'Denham',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5008406,
        LOCATION_LATITUDE_DEG: 51.5667568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007500',
        LOCATION_NAME: 'Denham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5701824,
        LOCATION_LATITUDE_DEG: 52.2270063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007600',
        LOCATION_NAME: 'Denham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.219154,
        LOCATION_LATITUDE_DEG: 52.3256987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007700',
        LOCATION_NAME: 'Denhead',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8607179,
        LOCATION_LATITUDE_DEG: 56.3126454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007800',
        LOCATION_NAME: 'Denhead Of Gray',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0588542,
        LOCATION_LATITUDE_DEG: 56.4740672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE007900',
        LOCATION_NAME: 'Denholm',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6815144,
        LOCATION_LATITUDE_DEG: 55.4579559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008000',
        LOCATION_NAME: 'Denholme',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8930052,
        LOCATION_LATITUDE_DEG: 53.8020832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008100',
        LOCATION_NAME: 'Denholme Clough',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8897342,
        LOCATION_LATITUDE_DEG: 53.7928845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008200',
        LOCATION_NAME: 'Denmead',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.066174,
        LOCATION_LATITUDE_DEG: 50.9035976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008300',
        LOCATION_NAME: 'Denmore',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1010869,
        LOCATION_LATITUDE_DEG: 57.1954255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008400',
        LOCATION_NAME: 'Denner Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.76187,
        LOCATION_LATITUDE_DEG: 51.6928676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008500',
        LOCATION_NAME: 'Dennington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.34276,
        LOCATION_LATITUDE_DEG: 52.2535933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008600',
        LOCATION_NAME: 'Dennistoun',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2337042,
        LOCATION_LATITUDE_DEG: 55.8655139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008700',
        LOCATION_NAME: 'Denny',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9042146,
        LOCATION_LATITUDE_DEG: 56.0228288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008800',
        LOCATION_NAME: 'Dennyloanhead',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9088546,
        LOCATION_LATITUDE_DEG: 55.9991287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE008900',
        LOCATION_NAME: 'Denshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0386656,
        LOCATION_LATITUDE_DEG: 53.5917692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009000',
        LOCATION_NAME: 'Densole',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1599386,
        LOCATION_LATITUDE_DEG: 51.1298936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009100',
        LOCATION_NAME: 'Denston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5769888,
        LOCATION_LATITUDE_DEG: 52.1454917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009200',
        LOCATION_NAME: 'Denstone',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8541512,
        LOCATION_LATITUDE_DEG: 52.9647016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009300',
        LOCATION_NAME: 'Denstroude',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0040821,
        LOCATION_LATITUDE_DEG: 51.3079074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009400',
        LOCATION_NAME: 'Dent',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4529058,
        LOCATION_LATITUDE_DEG: 54.2775441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009900',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.111996,
        LOCATION_LATITUDE_DEG: 53.455713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009700',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7812106,
        LOCATION_LATITUDE_DEG: 53.9363967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010000',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6666254,
        LOCATION_LATITUDE_DEG: 54.5620575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010200',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1394137,
        LOCATION_LATITUDE_DEG: 51.7164729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010100',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7750114,
        LOCATION_LATITUDE_DEG: 52.213417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009800',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7128317,
        LOCATION_LATITUDE_DEG: 52.8841858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009500',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1700044,
        LOCATION_LATITUDE_DEG: 51.178496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE009600',
        LOCATION_NAME: 'Denton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3548196,
        LOCATION_LATITUDE_DEG: 52.4458094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010300',
        LOCATION_NAME: 'Denton Burn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7038947,
        LOCATION_LATITUDE_DEG: 54.984203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010400',
        LOCATION_NAME: 'Dentons Green',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.765017,
        LOCATION_LATITUDE_DEG: 53.4607688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010500',
        LOCATION_NAME: 'Denver',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3828122,
        LOCATION_LATITUDE_DEG: 52.5879389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010600',
        LOCATION_NAME: 'Denwick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6762325,
        LOCATION_LATITUDE_DEG: 55.4219417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010700',
        LOCATION_NAME: 'Deopham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0261723,
        LOCATION_LATITUDE_DEG: 52.5663284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010800',
        LOCATION_NAME: 'Deopham Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0157248,
        LOCATION_LATITUDE_DEG: 52.5543272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE010900',
        LOCATION_NAME: 'Depden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6072498,
        LOCATION_LATITUDE_DEG: 52.1804957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011000',
        LOCATION_NAME: 'Deppers Bridge',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4131286,
        LOCATION_LATITUDE_DEG: 52.2302291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE019200',
        LOCATION_NAME: 'Deptford',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0265256,
        LOCATION_LATITUDE_DEG: 51.4826705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011100',
        LOCATION_NAME: 'Derby',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4715341,
        LOCATION_LATITUDE_DEG: 52.9193926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011200',
        LOCATION_NAME: 'Derbyhaven',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6173334,
        LOCATION_LATITUDE_DEG: 54.0777749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011300',
        LOCATION_NAME: 'Dereham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9421368,
        LOCATION_LATITUDE_DEG: 52.6818432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011400',
        LOCATION_NAME: 'Deri',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2626619,
        LOCATION_LATITUDE_DEG: 51.7071027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011500',
        LOCATION_NAME: 'Deriside',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.047571,
        LOCATION_LATITUDE_DEG: 51.8766111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011600',
        LOCATION_NAME: 'Deritend',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8819418,
        LOCATION_LATITUDE_DEG: 52.4745623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012000',
        LOCATION_NAME: 'Deroran',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1600198,
        LOCATION_LATITUDE_DEG: 54.5653736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012500',
        LOCATION_NAME: 'Derreens East',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7069825,
        LOCATION_LATITUDE_DEG: 54.3069947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012700',
        LOCATION_NAME: 'Derriaghy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0170818,
        LOCATION_LATITUDE_DEG: 54.5394586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012800',
        LOCATION_NAME: 'Derriford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1166171,
        LOCATION_LATITUDE_DEG: 50.4115855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012900',
        LOCATION_NAME: 'Derrington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1631741,
        LOCATION_LATITUDE_DEG: 52.8005952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013300',
        LOCATION_NAME: 'Derriton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3613285,
        LOCATION_LATITUDE_DEG: 50.8029309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013400',
        LOCATION_NAME: 'Derry Hill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0606135,
        LOCATION_LATITUDE_DEG: 51.4342621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013500',
        LOCATION_NAME: 'Derry Keighan',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4922178,
        LOCATION_LATITUDE_DEG: 55.1391226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013700',
        LOCATION_NAME: 'Derryadd',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4266388,
        LOCATION_LATITUDE_DEG: 54.4881982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014500',
        LOCATION_NAME: 'Derrygonnelly',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7990959,
        LOCATION_LATITUDE_DEG: 54.4332034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014550',
        LOCATION_NAME: 'Derryharney',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5470955,
        LOCATION_LATITUDE_DEG: 54.2819796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014575',
        LOCATION_NAME: 'Derryhowlaght West',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6968267,
        LOCATION_LATITUDE_DEG: 54.2894712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014650',
        LOCATION_NAME: 'Derrylester',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6997528,
        LOCATION_LATITUDE_DEG: 54.266268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014700',
        LOCATION_NAME: 'Derrylin',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5738658,
        LOCATION_LATITUDE_DEG: 54.1995802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015150',
        LOCATION_NAME: 'Derrynawilt East',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2544042,
        LOCATION_LATITUDE_DEG: 54.2333909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015175',
        LOCATION_NAME: 'Derrynawilt West',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2638088,
        LOCATION_LATITUDE_DEG: 54.2329254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015200',
        LOCATION_NAME: 'Derrynoose',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7636826,
        LOCATION_LATITUDE_DEG: 54.235333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015400',
        LOCATION_NAME: 'Derrythorpe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7472256,
        LOCATION_LATITUDE_DEG: 53.5678483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015500',
        LOCATION_NAME: 'Derrytrasna',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4656546,
        LOCATION_LATITUDE_DEG: 54.499905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015600',
        LOCATION_NAME: 'Dersingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5133451,
        LOCATION_LATITUDE_DEG: 52.8452613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015700',
        LOCATION_NAME: 'Dervaghroy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2806734,
        LOCATION_LATITUDE_DEG: 54.5416853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015800',
        LOCATION_NAME: 'Dervaig',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1874744,
        LOCATION_LATITUDE_DEG: 56.588809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015900',
        LOCATION_NAME: 'Dervock',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4656444,
        LOCATION_LATITUDE_DEG: 55.1166561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016000',
        LOCATION_NAME: 'Derwen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3872767,
        LOCATION_LATITUDE_DEG: 53.0456338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016100',
        LOCATION_NAME: 'Derwen Fawr',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9964852,
        LOCATION_LATITUDE_DEG: 51.6067083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016200',
        LOCATION_NAME: 'Derwenlas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8836753,
        LOCATION_LATITUDE_DEG: 52.5748932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016300',
        LOCATION_NAME: 'Derwent Haugh',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6841657,
        LOCATION_LATITUDE_DEG: 54.9630961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016400',
        LOCATION_NAME: 'Derwydd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0154029,
        LOCATION_LATITUDE_DEG: 51.8410242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016500',
        LOCATION_NAME: 'Desborough',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8190162,
        LOCATION_LATITUDE_DEG: 52.4398455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016600',
        LOCATION_NAME: 'Desertmartin',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6714547,
        LOCATION_LATITUDE_DEG: 54.7660284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016700',
        LOCATION_NAME: 'Desford',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2927751,
        LOCATION_LATITUDE_DEG: 52.6253647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016800',
        LOCATION_NAME: 'Deskford',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8277289,
        LOCATION_LATITUDE_DEG: 57.6406759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE016900',
        LOCATION_NAME: 'Dess',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7110684,
        LOCATION_LATITUDE_DEG: 57.0882189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017000',
        LOCATION_NAME: 'Detchant',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8633929,
        LOCATION_LATITUDE_DEG: 55.6220628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017100',
        LOCATION_NAME: 'Dethick',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5098861,
        LOCATION_LATITUDE_DEG: 53.1176129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017200',
        LOCATION_NAME: 'Detling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5712418,
        LOCATION_LATITUDE_DEG: 51.293518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017300',
        LOCATION_NAME: 'Deuddwr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1237002,
        LOCATION_LATITUDE_DEG: 52.7530036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017400',
        LOCATION_NAME: 'Deuxhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4448045,
        LOCATION_LATITUDE_DEG: 52.4820659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017500',
        LOCATION_NAME: 'Devauden',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7472767,
        LOCATION_LATITUDE_DEG: 51.6875913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017600',
        LOCATION_NAME: 'Devils Bridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8589285,
        LOCATION_LATITUDE_DEG: 52.3737954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017700',
        LOCATION_NAME: 'Deviock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3687383,
        LOCATION_LATITUDE_DEG: 50.3722878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017800',
        LOCATION_NAME: 'Devizes',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9937959,
        LOCATION_LATITUDE_DEG: 51.3512572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE017900',
        LOCATION_NAME: 'Devon Consuls',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2218237,
        LOCATION_LATITUDE_DEG: 50.539804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018000',
        LOCATION_NAME: 'Devonport',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1788932,
        LOCATION_LATITUDE_DEG: 50.3811822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018100',
        LOCATION_NAME: 'Devonside',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7378215,
        LOCATION_LATITUDE_DEG: 56.1479426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018200',
        LOCATION_NAME: 'Devoran',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0916301,
        LOCATION_LATITUDE_DEG: 50.2108809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018300',
        LOCATION_NAME: 'Dewartown',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9929753,
        LOCATION_LATITUDE_DEG: 55.8664023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018400',
        LOCATION_NAME: 'Dewlish',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3153361,
        LOCATION_LATITUDE_DEG: 50.7828044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018500',
        LOCATION_NAME: 'Dewsbury',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6275592,
        LOCATION_LATITUDE_DEG: 53.6915704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE018600',
        LOCATION_NAME: 'Dewsbury Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6537752,
        LOCATION_LATITUDE_DEG: 53.6916761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DH990253',
        LOCATION_NAME: 'Dhoon',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3754756,
        LOCATION_LATITUDE_DEG: 54.2534431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000100',
        LOCATION_NAME: 'Dial Post',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3550491,
        LOCATION_LATITUDE_DEG: 50.9629919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000300',
        LOCATION_NAME: 'Dibden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4172739,
        LOCATION_LATITUDE_DEG: 50.8696969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000400',
        LOCATION_NAME: 'Dibden Purlieu',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4174909,
        LOCATION_LATITUDE_DEG: 50.850002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI990650',
        LOCATION_NAME: 'Dickens Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B90',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5557223,
        LOCATION_LATITUDE_DEG: 49.7662045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000500',
        LOCATION_NAME: 'Dickleburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1874094,
        LOCATION_LATITUDE_DEG: 52.3968091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000600',
        LOCATION_NAME: 'Didbrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9210775,
        LOCATION_LATITUDE_DEG: 51.9797085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000700',
        LOCATION_NAME: 'Didcot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2387158,
        LOCATION_LATITUDE_DEG: 51.6057689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000800',
        LOCATION_NAME: 'Diddies',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5047379,
        LOCATION_LATITUDE_DEG: 50.8291281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000900',
        LOCATION_NAME: 'Diddington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2569959,
        LOCATION_LATITUDE_DEG: 52.2763234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001000',
        LOCATION_NAME: 'Diddlebury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7304662,
        LOCATION_LATITUDE_DEG: 52.466369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001100',
        LOCATION_NAME: 'Didley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7953943,
        LOCATION_LATITUDE_DEG: 51.9873269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001200',
        LOCATION_NAME: 'Didling',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8071465,
        LOCATION_LATITUDE_DEG: 50.9603993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001300',
        LOCATION_NAME: 'Didlington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6182465,
        LOCATION_LATITUDE_DEG: 52.5457327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001400',
        LOCATION_NAME: 'Didmarton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2600717,
        LOCATION_LATITUDE_DEG: 51.5848746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI008200',
        LOCATION_NAME: 'Didsbury',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2369199,
        LOCATION_LATITUDE_DEG: 53.4187362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001500',
        LOCATION_NAME: 'Didworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8528925,
        LOCATION_LATITUDE_DEG: 50.4441865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI008300',
        LOCATION_NAME: 'Digbeth',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8904234,
        LOCATION_LATITUDE_DEG: 52.4743637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001600',
        LOCATION_NAME: 'Digby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3910907,
        LOCATION_LATITUDE_DEG: 53.0794002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001700',
        LOCATION_NAME: 'Digg',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2413709,
        LOCATION_LATITUDE_DEG: 57.6401091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001800',
        LOCATION_NAME: 'Diggle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9945635,
        LOCATION_LATITUDE_DEG: 53.568466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI001900',
        LOCATION_NAME: 'Diglake',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6815094,
        LOCATION_LATITUDE_DEG: 52.9296088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002000',
        LOCATION_NAME: 'Digswell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1854497,
        LOCATION_LATITUDE_DEG: 51.8246721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002100',
        LOCATION_NAME: 'Digswell Water',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1829384,
        LOCATION_LATITUDE_DEG: 51.8174748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002200',
        LOCATION_NAME: 'Dihewyd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2138604,
        LOCATION_LATITUDE_DEG: 52.1801556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002300',
        LOCATION_NAME: 'Dilham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.457395,
        LOCATION_LATITUDE_DEG: 52.7733414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002400',
        LOCATION_NAME: 'Dilhorne',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0391091,
        LOCATION_LATITUDE_DEG: 52.9897146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002500',
        LOCATION_NAME: 'Dillington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8878828,
        LOCATION_LATITUDE_DEG: 50.9334281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002600',
        LOCATION_NAME: 'Dilston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.031866,
        LOCATION_LATITUDE_DEG: 54.9650029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002700',
        LOCATION_NAME: 'Dilton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1986217,
        LOCATION_LATITUDE_DEG: 51.2328422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002800',
        LOCATION_NAME: 'Dilton Marsh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2138599,
        LOCATION_LATITUDE_DEG: 51.2476447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI002900',
        LOCATION_NAME: 'Dilwyn',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8550053,
        LOCATION_LATITUDE_DEG: 52.1866452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003000',
        LOCATION_NAME: 'Dimmingsdale',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2036678,
        LOCATION_LATITUDE_DEG: 52.5645713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003100',
        LOCATION_NAME: 'Dimson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2203008,
        LOCATION_LATITUDE_DEG: 50.5206011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003300',
        LOCATION_NAME: 'Dinas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5724915,
        LOCATION_LATITUDE_DEG: 52.8937333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003200',
        LOCATION_NAME: 'Dinas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2734021,
        LOCATION_LATITUDE_DEG: 53.1026464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003400',
        LOCATION_NAME: 'Dinas Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9061764,
        LOCATION_LATITUDE_DEG: 52.0080443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003500',
        LOCATION_NAME: 'Dinas Dinlle',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3349459,
        LOCATION_LATITUDE_DEG: 53.0847471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003600',
        LOCATION_NAME: 'Dinas Mawddwy',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.692772,
        LOCATION_LATITUDE_DEG: 52.7195053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003700',
        LOCATION_NAME: 'Dinas Powys',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2178691,
        LOCATION_LATITUDE_DEG: 51.4340757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003800',
        LOCATION_NAME: 'Dinchope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6776139,
        LOCATION_LATITUDE_DEG: 52.678791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI003900',
        LOCATION_NAME: 'Dinckley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.472868,
        LOCATION_LATITUDE_DEG: 53.8155993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004000',
        LOCATION_NAME: 'Dinder',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6077317,
        LOCATION_LATITUDE_DEG: 51.1961442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004100',
        LOCATION_NAME: 'Dinedor',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6790873,
        LOCATION_LATITUDE_DEG: 52.0269268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004200',
        LOCATION_NAME: 'Dingestow',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7856507,
        LOCATION_LATITUDE_DEG: 51.7872998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004300',
        LOCATION_NAME: 'Dingle',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9603987,
        LOCATION_LATITUDE_DEG: 53.3802556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004500',
        LOCATION_NAME: 'Dingley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8696109,
        LOCATION_LATITUDE_DEG: 52.4802442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004600',
        LOCATION_NAME: 'Dingwall',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4266032,
        LOCATION_LATITUDE_DEG: 57.597486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004700',
        LOCATION_NAME: 'Dinhams Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7763494,
        LOCATION_LATITUDE_DEG: 50.5308013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI990211',
        LOCATION_NAME: 'Dinkley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.47398,
        LOCATION_LATITUDE_DEG: 53.8172219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004800',
        LOCATION_NAME: 'Dinnet',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8914678,
        LOCATION_LATITUDE_DEG: 57.0768233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004900',
        LOCATION_NAME: 'Dinnington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8510233,
        LOCATION_LATITUDE_DEG: 50.9125227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005000',
        LOCATION_NAME: 'Dinnington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6736669,
        LOCATION_LATITUDE_DEG: 55.0539026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005100',
        LOCATION_NAME: 'Dinnington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2078525,
        LOCATION_LATITUDE_DEG: 53.3701363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005200',
        LOCATION_NAME: 'Dinorwic',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1135879,
        LOCATION_LATITUDE_DEG: 53.1308143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005300',
        LOCATION_NAME: 'Dinsdale Park',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4718352,
        LOCATION_LATITUDE_DEG: 54.5027531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005500',
        LOCATION_NAME: 'Dinton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9770982,
        LOCATION_LATITUDE_DEG: 51.082627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005400',
        LOCATION_NAME: 'Dinton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8926761,
        LOCATION_LATITUDE_DEG: 51.7894852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI990920',
        LOCATION_NAME: 'Dinwoodie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005600',
        LOCATION_NAME: 'Dippen',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0931553,
        LOCATION_LATITUDE_DEG: 55.4548846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005700',
        LOCATION_NAME: 'Dippenhall',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.823839,
        LOCATION_LATITUDE_DEG: 51.2024232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005800',
        LOCATION_NAME: 'Dipple',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8320957,
        LOCATION_LATITUDE_DEG: 55.2846699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI005900',
        LOCATION_NAME: 'Dipple',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1243538,
        LOCATION_LATITUDE_DEG: 57.6101765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006000',
        LOCATION_NAME: 'Diptford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.787846,
        LOCATION_LATITUDE_DEG: 50.39718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006100',
        LOCATION_NAME: 'Dipton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7595137,
        LOCATION_LATITUDE_DEG: 54.8771875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006200',
        LOCATION_NAME: 'Dirleton',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7799469,
        LOCATION_LATITUDE_DEG: 56.0456191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006300',
        LOCATION_NAME: 'Discoyd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0607577,
        LOCATION_LATITUDE_DEG: 52.276556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006400',
        LOCATION_NAME: 'Diseworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3312028,
        LOCATION_LATITUDE_DEG: 52.8161839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006500',
        LOCATION_NAME: 'Dishforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4181364,
        LOCATION_LATITUDE_DEG: 54.1541176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006600',
        LOCATION_NAME: 'Disley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0356292,
        LOCATION_LATITUDE_DEG: 53.3587444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006700',
        LOCATION_NAME: 'Diss',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1080859,
        LOCATION_LATITUDE_DEG: 52.3772104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006800',
        LOCATION_NAME: 'Disserth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4123424,
        LOCATION_LATITUDE_DEG: 52.2155496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006850',
        LOCATION_NAME: 'Dissington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8119453,
        LOCATION_LATITUDE_DEG: 55.0414599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006900',
        LOCATION_NAME: 'Distington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5383179,
        LOCATION_LATITUDE_DEG: 54.5962797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007000',
        LOCATION_NAME: 'Ditcham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9252965,
        LOCATION_LATITUDE_DEG: 50.9632011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007100',
        LOCATION_NAME: 'Ditcheat',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5324583,
        LOCATION_LATITUDE_DEG: 51.1240355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007200',
        LOCATION_NAME: 'Ditchingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4456203,
        LOCATION_LATITUDE_DEG: 52.4669164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007300',
        LOCATION_NAME: 'Ditchling',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1132828,
        LOCATION_LATITUDE_DEG: 50.9203902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007400',
        LOCATION_NAME: 'Ditherington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7347064,
        LOCATION_LATITUDE_DEG: 52.7249966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007500',
        LOCATION_NAME: 'Ditteridge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2624599,
        LOCATION_LATITUDE_DEG: 51.422959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007600',
        LOCATION_NAME: 'Dittisham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6019273,
        LOCATION_LATITUDE_DEG: 50.3834827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007700',
        LOCATION_NAME: 'Ditton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4535569,
        LOCATION_LATITUDE_DEG: 51.2948122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007800',
        LOCATION_NAME: 'Ditton Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3185335,
        LOCATION_LATITUDE_DEG: 51.3837341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI007900',
        LOCATION_NAME: 'Ditton Priors',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.576177,
        LOCATION_LATITUDE_DEG: 52.4985732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI008000',
        LOCATION_NAME: 'Dixton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6972022,
        LOCATION_LATITUDE_DEG: 51.8192043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI008100',
        LOCATION_NAME: 'Dizzard',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5965598,
        LOCATION_LATITUDE_DEG: 50.7561277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000100',
        LOCATION_NAME: 'Doagh',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0579993,
        LOCATION_LATITUDE_DEG: 54.7347262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000300',
        LOCATION_NAME: 'Dobcross',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0141305,
        LOCATION_LATITUDE_DEG: 53.5553678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000400',
        LOCATION_NAME: 'Dobshill',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.038047,
        LOCATION_LATITUDE_DEG: 53.1644426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000500',
        LOCATION_NAME: 'Dobwalls',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5147979,
        LOCATION_LATITUDE_DEG: 50.4572977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000600',
        LOCATION_NAME: 'Doccombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7306147,
        LOCATION_LATITUDE_DEG: 50.6679072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000700',
        LOCATION_NAME: 'Dochgarroch',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3022756,
        LOCATION_LATITUDE_DEG: 57.4353758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000800',
        LOCATION_NAME: 'Dock Acres',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.738769,
        LOCATION_LATITUDE_DEG: 54.1574279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000900',
        LOCATION_NAME: 'Dockenfield',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8236898,
        LOCATION_LATITUDE_DEG: 51.1571219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000950',
        LOCATION_NAME: 'Docker',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6751187,
        LOCATION_LATITUDE_DEG: 54.3501111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001000',
        LOCATION_NAME: 'Docking',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6252987,
        LOCATION_LATITUDE_DEG: 52.9016691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001100',
        LOCATION_NAME: 'Docklow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6403214,
        LOCATION_LATITUDE_DEG: 52.2130472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001200',
        LOCATION_NAME: 'Dockray',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.939194,
        LOCATION_LATITUDE_DEG: 54.5860793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001300',
        LOCATION_NAME: 'Docks',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1541994,
        LOCATION_LATITUDE_DEG: 51.4704761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO991116',
        LOCATION_NAME: 'Docks',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.15382,
        LOCATION_LATITUDE_DEG: 51.46533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001400',
        LOCATION_NAME: 'Doddinghurst',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.300943,
        LOCATION_LATITUDE_DEG: 51.6673559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001500',
        LOCATION_NAME: 'Doddings',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2084283,
        LOCATION_LATITUDE_DEG: 50.7416016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001700',
        LOCATION_NAME: 'Doddington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4380108,
        LOCATION_LATITUDE_DEG: 53.0223222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002000',
        LOCATION_NAME: 'Doddington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0014914,
        LOCATION_LATITUDE_DEG: 55.5865619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001800',
        LOCATION_NAME: 'Doddington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.650235,
        LOCATION_LATITUDE_DEG: 53.2205121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001900',
        LOCATION_NAME: 'Doddington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0619369,
        LOCATION_LATITUDE_DEG: 52.496332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO001600',
        LOCATION_NAME: 'Doddington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7738596,
        LOCATION_LATITUDE_DEG: 51.2809118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002100',
        LOCATION_NAME: 'Doddiscombsleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6168995,
        LOCATION_LATITUDE_DEG: 50.6676068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002200',
        LOCATION_NAME: 'Dodds Cross',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5012472,
        LOCATION_LATITUDE_DEG: 50.9548208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002300',
        LOCATION_NAME: 'Doddycross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3859473,
        LOCATION_LATITUDE_DEG: 50.4348965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002400',
        LOCATION_NAME: 'Dodford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0993543,
        LOCATION_LATITUDE_DEG: 52.3549528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002500',
        LOCATION_NAME: 'Dodford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0994635,
        LOCATION_LATITUDE_DEG: 52.2397261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002600',
        LOCATION_NAME: 'Dodington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3608761,
        LOCATION_LATITUDE_DEG: 51.5181717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002700',
        LOCATION_NAME: 'Dodleston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9546426,
        LOCATION_LATITUDE_DEG: 53.1420351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002800',
        LOCATION_NAME: 'Dodwell',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7584478,
        LOCATION_LATITUDE_DEG: 52.1813315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO002900',
        LOCATION_NAME: 'Dodworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5250779,
        LOCATION_LATITUDE_DEG: 53.5426585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003000',
        LOCATION_NAME: 'Doe Lea',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3118383,
        LOCATION_LATITUDE_DEG: 53.1919165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003100',
        LOCATION_NAME: 'Dog Village',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4392012,
        LOCATION_LATITUDE_DEG: 50.7588094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003200',
        LOCATION_NAME: 'Dogdean',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9830089,
        LOCATION_LATITUDE_DEG: 50.8102011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003300',
        LOCATION_NAME: 'Dogdyke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2048761,
        LOCATION_LATITUDE_DEG: 53.0855928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003400',
        LOCATION_NAME: 'Dogmersfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8727719,
        LOCATION_LATITUDE_DEG: 51.2697339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003500',
        LOCATION_NAME: 'Dogsthorpe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2345758,
        LOCATION_LATITUDE_DEG: 52.5977479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024300',
        LOCATION_NAME: 'Dol y Bont',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024400',
        LOCATION_NAME: 'Dol y Gaer',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3683407,
        LOCATION_LATITUDE_DEG: 51.824533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003800',
        LOCATION_NAME: 'Dolanog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3836084,
        LOCATION_LATITUDE_DEG: 52.7044007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003900',
        LOCATION_NAME: 'Dolau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4333812,
        LOCATION_LATITUDE_DEG: 52.2869626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004000',
        LOCATION_NAME: 'Dolbeare',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7424752,
        LOCATION_LATITUDE_DEG: 50.5182923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004100',
        LOCATION_NAME: 'Doldowlod',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4630011,
        LOCATION_LATITUDE_DEG: 52.247358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004200',
        LOCATION_NAME: 'Dolfor',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3163881,
        LOCATION_LATITUDE_DEG: 52.4737799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004300',
        LOCATION_NAME: 'Dolgarrog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8393312,
        LOCATION_LATITUDE_DEG: 53.1850539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004400',
        LOCATION_NAME: 'Dolgellau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8841792,
        LOCATION_LATITUDE_DEG: 52.7434046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004600',
        LOCATION_NAME: 'Dollar',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6656131,
        LOCATION_LATITUDE_DEG: 56.1635409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004700',
        LOCATION_NAME: 'Dollarfield',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6668007,
        LOCATION_LATITUDE_DEG: 56.1556344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004800',
        LOCATION_NAME: 'Dollingstown',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2764361,
        LOCATION_LATITUDE_DEG: 54.4257925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005000',
        LOCATION_NAME: 'Dolphinholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7350332,
        LOCATION_LATITUDE_DEG: 53.9749144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005100',
        LOCATION_NAME: 'Dolphinton',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4228755,
        LOCATION_LATITUDE_DEG: 55.7064909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005200',
        LOCATION_NAME: 'Dolton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0278837,
        LOCATION_LATITUDE_DEG: 50.8894293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005400',
        LOCATION_NAME: 'Dolwen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6690217,
        LOCATION_LATITUDE_DEG: 53.2555517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005300',
        LOCATION_NAME: 'Dolwen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5154951,
        LOCATION_LATITUDE_DEG: 52.6546923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005500',
        LOCATION_NAME: 'Dolwyd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7765533,
        LOCATION_LATITUDE_DEG: 53.2798558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005600',
        LOCATION_NAME: 'Dolwyddelan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8877196,
        LOCATION_LATITUDE_DEG: 53.0536338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003600',
        LOCATION_NAME: 'Dol-y-Bont',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0247892,
        LOCATION_LATITUDE_DEG: 52.4750861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005700',
        LOCATION_NAME: 'Dolycannau',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1652924,
        LOCATION_LATITUDE_DEG: 52.1350454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005800',
        LOCATION_NAME: 'Dolydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2760662,
        LOCATION_LATITUDE_DEG: 53.0860411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO003700',
        LOCATION_NAME: 'Dol-y-Gaer',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3758117,
        LOCATION_LATITUDE_DEG: 51.8211096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO005900',
        LOCATION_NAME: 'Domgay',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0550896,
        LOCATION_LATITUDE_DEG: 52.763398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006400',
        LOCATION_NAME: 'Donagh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3823598,
        LOCATION_LATITUDE_DEG: 54.2165764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006500',
        LOCATION_NAME: 'Donaghadee',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5457405,
        LOCATION_LATITUDE_DEG: 54.6476088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006600',
        LOCATION_NAME: 'Donaghanie',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.239171,
        LOCATION_LATITUDE_DEG: 54.5731236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006700',
        LOCATION_NAME: 'Donaghcloney',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2656356,
        LOCATION_LATITUDE_DEG: 54.4165942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006800',
        LOCATION_NAME: 'Donaghey',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7322998,
        LOCATION_LATITUDE_DEG: 54.583248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006900',
        LOCATION_NAME: 'Donaghmore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8156828,
        LOCATION_LATITUDE_DEG: 54.5332144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007500',
        LOCATION_NAME: 'Donaldsons Lodge',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1972759,
        LOCATION_LATITUDE_DEG: 55.6639731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007900',
        LOCATION_NAME: 'Doncaster',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.132188,
        LOCATION_LATITUDE_DEG: 53.522851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008050',
        LOCATION_NAME: 'Donemana',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3001574,
        LOCATION_LATITUDE_DEG: 54.8678194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023900',
        LOCATION_NAME: 'Donhead St Andrew',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024000',
        LOCATION_NAME: 'Donhead St Mary',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008200',
        LOCATION_NAME: 'Donhead St. Andrew',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1191779,
        LOCATION_LATITUDE_DEG: 51.0215226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008300',
        LOCATION_NAME: 'Donhead St. Mary',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1301002,
        LOCATION_LATITUDE_DEG: 51.0163219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008400',
        LOCATION_NAME: 'Donibristle',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.34014,
        LOCATION_LATITUDE_DEG: 56.0841309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008500',
        LOCATION_NAME: 'Doniford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3028147,
        LOCATION_LATITUDE_DEG: 51.1766551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008600',
        LOCATION_NAME: 'Donington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2035805,
        LOCATION_LATITUDE_DEG: 52.9045756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008700',
        LOCATION_NAME: 'Donington le Heath',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3964562,
        LOCATION_LATITUDE_DEG: 52.709778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024500',
        LOCATION_NAME: 'Donington on Bain',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008800',
        LOCATION_NAME: 'Donington-on-Bain',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1461303,
        LOCATION_LATITUDE_DEG: 53.3272755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008900',
        LOCATION_NAME: 'Donisthorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5374867,
        LOCATION_LATITUDE_DEG: 52.7224775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009000',
        LOCATION_NAME: 'Donkey Town',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.645652,
        LOCATION_LATITUDE_DEG: 51.3316382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009100',
        LOCATION_NAME: 'Donkleywood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3989097,
        LOCATION_LATITUDE_DEG: 55.1702225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009200',
        LOCATION_NAME: 'Donna Nook',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1570884,
        LOCATION_LATITUDE_DEG: 53.4704282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009300',
        LOCATION_NAME: 'Donnington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4352685,
        LOCATION_LATITUDE_DEG: 52.7136888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009600',
        LOCATION_NAME: 'Donnington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4242575,
        LOCATION_LATITUDE_DEG: 52.0056225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009500',
        LOCATION_NAME: 'Donnington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7199917,
        LOCATION_LATITUDE_DEG: 51.9506103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009700',
        LOCATION_NAME: 'Donnington',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3289204,
        LOCATION_LATITUDE_DEG: 51.4153517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009400',
        LOCATION_NAME: 'Donnington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7867143,
        LOCATION_LATITUDE_DEG: 50.8124827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009800',
        LOCATION_NAME: 'Donnington Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4333831,
        LOCATION_LATITUDE_DEG: 52.705685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010300',
        LOCATION_NAME: 'Donyatt',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9395675,
        LOCATION_LATITUDE_DEG: 50.9210262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010900',
        LOCATION_NAME: 'Doogary',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2806669,
        LOCATION_LATITUDE_DEG: 54.5725932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012600',
        LOCATION_NAME: 'Doonfoot',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6553103,
        LOCATION_LATITUDE_DEG: 55.4380778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013100',
        LOCATION_NAME: 'Dorcan',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7252658,
        LOCATION_LATITUDE_DEG: 51.5579719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013200',
        LOCATION_NAME: 'Dorchester',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4398972,
        LOCATION_LATITUDE_DEG: 50.7105953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024600',
        LOCATION_NAME: 'Dorchester on Thames',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013300',
        LOCATION_NAME: 'Dorchester-on-Thames',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1643989,
        LOCATION_LATITUDE_DEG: 51.6450734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013400',
        LOCATION_NAME: 'Dordon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6130878,
        LOCATION_LATITUDE_DEG: 52.6009681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013500',
        LOCATION_NAME: 'Dore',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5377094,
        LOCATION_LATITUDE_DEG: 53.3263363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013600',
        LOCATION_NAME: 'Dores',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3324987,
        LOCATION_LATITUDE_DEG: 57.3805664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013700',
        LOCATION_NAME: 'Dorking',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3281817,
        LOCATION_LATITUDE_DEG: 51.2324193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013800',
        LOCATION_NAME: 'Dorlangoch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3678044,
        LOCATION_LATITUDE_DEG: 51.9399224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013900',
        LOCATION_NAME: 'Dormans Park',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0066437,
        LOCATION_LATITUDE_DEG: 51.1474074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014000',
        LOCATION_NAME: 'Dormansland',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0078038,
        LOCATION_LATITUDE_DEG: 51.1597071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014100',
        LOCATION_NAME: 'Dormanstown',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0905125,
        LOCATION_LATITUDE_DEG: 54.6058555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014200',
        LOCATION_NAME: 'Dormington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6073137,
        LOCATION_LATITUDE_DEG: 52.0594283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014300',
        LOCATION_NAME: 'Dormston',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0177268,
        LOCATION_LATITUDE_DEG: 52.2151335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014400',
        LOCATION_NAME: 'Dorn',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7029337,
        LOCATION_LATITUDE_DEG: 52.0039079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014500',
        LOCATION_NAME: 'Dorney',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6587599,
        LOCATION_LATITUDE_DEG: 51.5001503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014600',
        LOCATION_NAME: 'Dorney Reach',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6786494,
        LOCATION_LATITUDE_DEG: 51.5054482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014700',
        LOCATION_NAME: 'Dornie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5129503,
        LOCATION_LATITUDE_DEG: 57.2765667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014800',
        LOCATION_NAME: 'Dornoch',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0264775,
        LOCATION_LATITUDE_DEG: 57.8807116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO014900',
        LOCATION_NAME: 'Dornock',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2004759,
        LOCATION_LATITUDE_DEG: 54.9834211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015000',
        LOCATION_NAME: 'Dorridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7517904,
        LOCATION_LATITUDE_DEG: 52.3732468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015100',
        LOCATION_NAME: 'Dorrington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7721345,
        LOCATION_LATITUDE_DEG: 52.6221813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015200',
        LOCATION_NAME: 'Dorrington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3843401,
        LOCATION_LATITUDE_DEG: 53.0622976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015300',
        LOCATION_NAME: 'Dorsington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8065947,
        LOCATION_LATITUDE_DEG: 52.1455262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015400',
        LOCATION_NAME: 'Dorstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0018461,
        LOCATION_LATITUDE_DEG: 52.0703307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015500',
        LOCATION_NAME: 'Dorton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0120386,
        LOCATION_LATITUDE_DEG: 51.8222828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015600',
        LOCATION_NAME: 'Doseley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4878581,
        LOCATION_LATITUDE_DEG: 52.6555835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015700',
        LOCATION_NAME: 'Dosthill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6816687,
        LOCATION_LATITUDE_DEG: 52.6002732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015800',
        LOCATION_NAME: 'Dothan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4410219,
        LOCATION_LATITUDE_DEG: 53.2432643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO015900',
        LOCATION_NAME: 'Dottery',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7704592,
        LOCATION_LATITUDE_DEG: 50.7537048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016000',
        LOCATION_NAME: 'Dotton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2970179,
        LOCATION_LATITUDE_DEG: 50.6895046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016100',
        LOCATION_NAME: 'Doublebois',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5373428,
        LOCATION_LATITUDE_DEG: 50.4556926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016200',
        LOCATION_NAME: 'Doublewaters',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.142815,
        LOCATION_LATITUDE_DEG: 50.5097931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016500',
        LOCATION_NAME: 'Doughton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1778563,
        LOCATION_LATITUDE_DEG: 51.6194777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016400',
        LOCATION_NAME: 'Doughton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7940323,
        LOCATION_LATITUDE_DEG: 52.8267614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016800',
        LOCATION_NAME: 'Douglas',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4870742,
        LOCATION_LATITUDE_DEG: 54.152622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016600',
        LOCATION_NAME: 'Douglas',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8438565,
        LOCATION_LATITUDE_DEG: 55.5565799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016900',
        LOCATION_NAME: 'Douglas Bridge',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4157406,
        LOCATION_LATITUDE_DEG: 54.7499318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017000',
        LOCATION_NAME: 'Douglas Hall',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7351571,
        LOCATION_LATITUDE_DEG: 54.87491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017100',
        LOCATION_NAME: 'Douglas Water',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7885697,
        LOCATION_LATITUDE_DEG: 55.6076869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017200',
        LOCATION_NAME: 'Douglas West',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8663483,
        LOCATION_LATITUDE_DEG: 55.5583786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017300',
        LOCATION_NAME: 'Douglastown',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9485537,
        LOCATION_LATITUDE_DEG: 56.6147722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017400',
        LOCATION_NAME: 'Doulting',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5014131,
        LOCATION_LATITUDE_DEG: 51.1868457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017500',
        LOCATION_NAME: 'Dounby',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2324206,
        LOCATION_LATITUDE_DEG: 59.0691207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017600',
        LOCATION_NAME: 'Doune',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.628584,
        LOCATION_LATITUDE_DEG: 57.9687251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017700',
        LOCATION_NAME: 'Doune',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0521882,
        LOCATION_LATITUDE_DEG: 56.190351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017800',
        LOCATION_NAME: 'Dounie',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2018993,
        LOCATION_LATITUDE_DEG: 57.8499155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO017900',
        LOCATION_NAME: 'Dounreay',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7456378,
        LOCATION_LATITUDE_DEG: 58.5787848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018000',
        LOCATION_NAME: 'Dousland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0628243,
        LOCATION_LATITUDE_DEG: 50.5011909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018100',
        LOCATION_NAME: 'Dovaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9713244,
        LOCATION_LATITUDE_DEG: 52.7850982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018200',
        LOCATION_NAME: 'Dove Holes',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.886226,
        LOCATION_LATITUDE_DEG: 53.2980418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025100',
        LOCATION_NAME: 'Dovecot',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8852781,
        LOCATION_LATITUDE_DEG: 53.4170027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018400',
        LOCATION_NAME: 'Dovenby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4033882,
        LOCATION_LATITUDE_DEG: 54.6880934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018500',
        LOCATION_NAME: 'Dover',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3124406,
        LOCATION_LATITUDE_DEG: 51.1291868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018600',
        LOCATION_NAME: 'Dovercourt',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2626566,
        LOCATION_LATITUDE_DEG: 51.9311648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018700',
        LOCATION_NAME: 'Doverdale',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2036377,
        LOCATION_LATITUDE_DEG: 52.2931481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018800',
        LOCATION_NAME: 'Doveridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8229812,
        LOCATION_LATITUDE_DEG: 52.9039027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025800',
        LOCATION_NAME: 'Dowanhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2990889,
        LOCATION_LATITUDE_DEG: 55.8742958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018900',
        LOCATION_NAME: 'Dowbiggin',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4756608,
        LOCATION_LATITUDE_DEG: 54.3248431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019000',
        LOCATION_NAME: 'Dowlais',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3572778,
        LOCATION_LATITUDE_DEG: 51.7640058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019100',
        LOCATION_NAME: 'Dowland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0304991,
        LOCATION_LATITUDE_DEG: 50.8727258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019200',
        LOCATION_NAME: 'Dowlish Ford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9143856,
        LOCATION_LATITUDE_DEG: 50.9139233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019300',
        LOCATION_NAME: 'Dowlish Wake',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8861873,
        LOCATION_LATITUDE_DEG: 50.9086186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019400',
        LOCATION_NAME: 'Down Ampney',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8526235,
        LOCATION_LATITUDE_DEG: 51.6731859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019500',
        LOCATION_NAME: 'Down Hatherley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2038976,
        LOCATION_LATITUDE_DEG: 51.9016081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024100',
        LOCATION_NAME: 'Down St Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019600',
        LOCATION_NAME: 'Down St. Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7839311,
        LOCATION_LATITUDE_DEG: 50.8242196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019700',
        LOCATION_NAME: 'Down Thomas',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.10297,
        LOCATION_LATITUDE_DEG: 50.3328807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019800',
        LOCATION_NAME: 'Downash',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2737045,
        LOCATION_LATITUDE_DEG: 50.8470747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO019900',
        LOCATION_NAME: 'Downderry',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.364027,
        LOCATION_LATITUDE_DEG: 50.3609862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020000',
        LOCATION_NAME: 'Downe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0555845,
        LOCATION_LATITUDE_DEG: 51.3356208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020200',
        LOCATION_NAME: 'Downend',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6491631,
        LOCATION_LATITUDE_DEG: 50.4058896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024800',
        LOCATION_NAME: 'Downend',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5047986,
        LOCATION_LATITUDE_DEG: 51.4960765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020100',
        LOCATION_NAME: 'Downend',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2456493,
        LOCATION_LATITUDE_DEG: 50.686482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020300',
        LOCATION_NAME: 'Downes',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6317686,
        LOCATION_LATITUDE_DEG: 50.7853164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020400',
        LOCATION_NAME: 'Downes Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6230692,
        LOCATION_LATITUDE_DEG: 50.7791147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020500',
        LOCATION_NAME: 'Downfield',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0059716,
        LOCATION_LATITUDE_DEG: 56.4917682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020600',
        LOCATION_NAME: 'Downgate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4250266,
        LOCATION_LATITUDE_DEG: 50.5119003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020700',
        LOCATION_NAME: 'Downgate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2990164,
        LOCATION_LATITUDE_DEG: 50.5307038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020800',
        LOCATION_NAME: 'Downham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3278849,
        LOCATION_LATITUDE_DEG: 53.8943052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO020900',
        LOCATION_NAME: 'Downham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4923999,
        LOCATION_LATITUDE_DEG: 51.6383443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021000',
        LOCATION_NAME: 'Downham Market',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3813955,
        LOCATION_LATITUDE_DEG: 52.6037409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021100',
        LOCATION_NAME: 'Downhead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4386034,
        LOCATION_LATITUDE_DEG: 51.2107407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021200',
        LOCATION_NAME: 'Downhead Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7352437,
        LOCATION_LATITUDE_DEG: 52.0564005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021300',
        LOCATION_NAME: 'Downhill',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8423684,
        LOCATION_LATITUDE_DEG: 55.1625681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021400',
        LOCATION_NAME: 'Downholme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8283006,
        LOCATION_LATITUDE_DEG: 54.376244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021500',
        LOCATION_NAME: 'Downies',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1267784,
        LOCATION_LATITUDE_DEG: 57.0473078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021700',
        LOCATION_NAME: 'Downington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6968589,
        LOCATION_LATITUDE_DEG: 51.6947834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021800',
        LOCATION_NAME: 'Downinney',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5329504,
        LOCATION_LATITUDE_DEG: 50.6819207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021900',
        LOCATION_NAME: 'Downley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.774445,
        LOCATION_LATITUDE_DEG: 51.6483686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022000',
        LOCATION_NAME: 'Downpatrick',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7147708,
        LOCATION_LATITUDE_DEG: 54.3308806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022100',
        LOCATION_NAME: 'Downs',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2855407,
        LOCATION_LATITUDE_DEG: 51.4639746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022200',
        LOCATION_NAME: 'Downs Barn',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7446566,
        LOCATION_LATITUDE_DEG: 52.0526075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025400',
        LOCATION_NAME: 'Downs Park',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025300',
        LOCATION_NAME: 'Downs Park',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2128624,
        LOCATION_LATITUDE_DEG: 50.8657786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022400',
        LOCATION_NAME: 'Downside',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.536645,
        LOCATION_LATITUDE_DEG: 51.2016449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022500',
        LOCATION_NAME: 'Downside',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4103207,
        LOCATION_LATITUDE_DEG: 51.3110259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022600',
        LOCATION_NAME: 'Downswood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5666485,
        LOCATION_LATITUDE_DEG: 51.2572078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022800',
        LOCATION_NAME: 'Downton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7402756,
        LOCATION_LATITUDE_DEG: 50.9923184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022700',
        LOCATION_NAME: 'Downton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6161684,
        LOCATION_LATITUDE_DEG: 50.7363895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022900',
        LOCATION_NAME: 'Downton Castle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8155435,
        LOCATION_LATITUDE_DEG: 52.3675558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023000',
        LOCATION_NAME: 'Downton Hall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6947017,
        LOCATION_LATITUDE_DEG: 52.4089596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024200',
        LOCATION_NAME: 'Downton on the Rock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023100',
        LOCATION_NAME: 'Downton-on-the-Rock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8405215,
        LOCATION_LATITUDE_DEG: 52.3547568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023300',
        LOCATION_NAME: 'Dowsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3465089,
        LOCATION_LATITUDE_DEG: 52.8502752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023500',
        LOCATION_NAME: 'Doxey',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1429891,
        LOCATION_LATITUDE_DEG: 52.8108974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023600',
        LOCATION_NAME: 'Doxford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7104602,
        LOCATION_LATITUDE_DEG: 55.5034548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023700',
        LOCATION_NAME: 'Doxford Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4134079,
        LOCATION_LATITUDE_DEG: 54.8654849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023800',
        LOCATION_NAME: 'Doynton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4038095,
        LOCATION_LATITUDE_DEG: 51.4637706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000100',
        LOCATION_NAME: 'Draethen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1247044,
        LOCATION_LATITUDE_DEG: 51.5790906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000200',
        LOCATION_NAME: 'Draffan',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9178696,
        LOCATION_LATITUDE_DEG: 55.6867963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000300',
        LOCATION_NAME: 'Dragley Beck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0878239,
        LOCATION_LATITUDE_DEG: 54.1865385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000400',
        LOCATION_NAME: 'Dragonby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6325817,
        LOCATION_LATITUDE_DEG: 53.6156514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000500',
        LOCATION_NAME: 'Dragonville',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5352273,
        LOCATION_LATITUDE_DEG: 54.7681732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000600',
        LOCATION_NAME: 'Drakeholes',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9363273,
        LOCATION_LATITUDE_DEG: 53.4060356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000700',
        LOCATION_NAME: 'Drakelow',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6318114,
        LOCATION_LATITUDE_DEG: 52.7663856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000800',
        LOCATION_NAME: 'Drakemyre',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7204114,
        LOCATION_LATITUDE_DEG: 55.7165064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR000900',
        LOCATION_NAME: 'Drakes Broughton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1070015,
        LOCATION_LATITUDE_DEG: 52.1343249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001000',
        LOCATION_NAME: 'Drakewalls',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2194595,
        LOCATION_LATITUDE_DEG: 50.5153009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001200',
        LOCATION_NAME: 'Draperstown',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7874746,
        LOCATION_LATITUDE_DEG: 54.7921335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001400',
        LOCATION_NAME: 'Draughton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9406366,
        LOCATION_LATITUDE_DEG: 53.9664061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001300',
        LOCATION_NAME: 'Draughton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8819063,
        LOCATION_LATITUDE_DEG: 52.3832347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001500',
        LOCATION_NAME: 'Drax',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9755535,
        LOCATION_LATITUDE_DEG: 53.728869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001600',
        LOCATION_NAME: 'Draycot Cerne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1018966,
        LOCATION_LATITUDE_DEG: 51.5015697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001700',
        LOCATION_NAME: 'Draycote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.344782,
        LOCATION_LATITUDE_DEG: 52.3280383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001800',
        LOCATION_NAME: 'Draycott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.750481,
        LOCATION_LATITUDE_DEG: 51.2562529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002300',
        LOCATION_NAME: 'Draycott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6356618,
        LOCATION_LATITUDE_DEG: 50.989223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002200',
        LOCATION_NAME: 'Draycott',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2765622,
        LOCATION_LATITUDE_DEG: 52.5306716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002100',
        LOCATION_NAME: 'Draycott',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2136059,
        LOCATION_LATITUDE_DEG: 52.1307272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002500',
        LOCATION_NAME: 'Draycott',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0244901,
        LOCATION_LATITUDE_DEG: 52.9575065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002000',
        LOCATION_NAME: 'Draycott',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7373727,
        LOCATION_LATITUDE_DEG: 52.0193116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001900',
        LOCATION_NAME: 'Draycott',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3420187,
        LOCATION_LATITUDE_DEG: 52.8948941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002400',
        LOCATION_NAME: 'Draycott Foliat',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7318557,
        LOCATION_LATITUDE_DEG: 51.499563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022900',
        LOCATION_NAME: 'Draycott in the Clay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002600',
        LOCATION_NAME: 'Draycott-in-the-Clay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3382836,
        LOCATION_LATITUDE_DEG: 52.8951341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002700',
        LOCATION_NAME: 'Drayford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7313732,
        LOCATION_LATITUDE_DEG: 50.9089285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002800',
        LOCATION_NAME: 'Draynes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5102582,
        LOCATION_LATITUDE_DEG: 50.4952948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003100',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8472181,
        LOCATION_LATITUDE_DEG: 51.018629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003450',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7810491,
        LOCATION_LATITUDE_DEG: 50.939111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003300',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3735769,
        LOCATION_LATITUDE_DEG: 52.0719168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003475',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3061106,
        LOCATION_LATITUDE_DEG: 51.6430017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR002900',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.042523,
        LOCATION_LATITUDE_DEG: 50.8458911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003200',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7769314,
        LOCATION_LATITUDE_DEG: 52.5212497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003000',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7369903,
        LOCATION_LATITUDE_DEG: 50.8259856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003400',
        LOCATION_NAME: 'Drayton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2270707,
        LOCATION_LATITUDE_DEG: 52.677237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003500',
        LOCATION_NAME: 'Drayton Bassett',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7145617,
        LOCATION_LATITUDE_DEG: 52.5989724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003600',
        LOCATION_NAME: 'Drayton Beauchamp',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6826056,
        LOCATION_LATITUDE_DEG: 51.7958799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003700',
        LOCATION_NAME: 'Drayton Holloway',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6846567,
        LOCATION_LATITUDE_DEG: 51.7921799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003800',
        LOCATION_NAME: 'Drayton Parslow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7792021,
        LOCATION_LATITUDE_DEG: 51.9484988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022700',
        LOCATION_NAME: 'Drayton St Leonard',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR003900',
        LOCATION_NAME: 'Drayton St. Leonard',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1362721,
        LOCATION_LATITUDE_DEG: 51.6632685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022800',
        LOCATION_NAME: 'Dre Fach Felindre',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004100',
        LOCATION_NAME: 'Drebley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9190992,
        LOCATION_LATITUDE_DEG: 54.0275078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004200',
        LOCATION_NAME: 'Dredgeman Hill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9882658,
        LOCATION_LATITUDE_DEG: 51.7768278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004400',
        LOCATION_NAME: 'Dreenhill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0137049,
        LOCATION_LATITUDE_DEG: 51.7884291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004600',
        LOCATION_NAME: 'Drefach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1865679,
        LOCATION_LATITUDE_DEG: 52.0904725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004500',
        LOCATION_NAME: 'Drefach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1305292,
        LOCATION_LATITUDE_DEG: 51.7965723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004000',
        LOCATION_NAME: 'Dre-Fach Felindre',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3981624,
        LOCATION_LATITUDE_DEG: 52.0217281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004700',
        LOCATION_NAME: 'Dreghorn',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6164474,
        LOCATION_LATITUDE_DEG: 55.6094971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004800',
        LOCATION_NAME: 'Drellingore',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2034841,
        LOCATION_LATITUDE_DEG: 51.1250913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004900',
        LOCATION_NAME: 'Drem',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7846603,
        LOCATION_LATITUDE_DEG: 56.0065179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005000',
        LOCATION_NAME: 'Dresden',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1420106,
        LOCATION_LATITUDE_DEG: 52.9794144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005100',
        LOCATION_NAME: 'Drewsteignton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7864359,
        LOCATION_LATITUDE_DEG: 50.7026115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005200',
        LOCATION_NAME: 'Driby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0970066,
        LOCATION_LATITUDE_DEG: 53.2553088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005300',
        LOCATION_NAME: 'Driby Top',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1018979,
        LOCATION_LATITUDE_DEG: 53.251707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005400',
        LOCATION_NAME: 'Driffield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8927038,
        LOCATION_LATITUDE_DEG: 51.6960876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005500',
        LOCATION_NAME: 'Driffield',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4333639,
        LOCATION_LATITUDE_DEG: 54.007484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005600',
        LOCATION_NAME: 'Drigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4389458,
        LOCATION_LATITUDE_DEG: 54.3786581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005700',
        LOCATION_NAME: 'Drighlington',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.660098,
        LOCATION_LATITUDE_DEG: 53.756578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005900',
        LOCATION_NAME: 'Drimnin',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9834869,
        LOCATION_LATITUDE_DEG: 56.6155118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006100',
        LOCATION_NAME: 'Drimpton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8252724,
        LOCATION_LATITUDE_DEG: 50.8416127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006600',
        LOCATION_NAME: 'Drinan',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0600232,
        LOCATION_LATITUDE_DEG: 57.1664629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006800',
        LOCATION_NAME: 'Dringhoe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2552654,
        LOCATION_LATITUDE_DEG: 53.9755792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006900',
        LOCATION_NAME: 'Dringhouses',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1031464,
        LOCATION_LATITUDE_DEG: 53.9395941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007000',
        LOCATION_NAME: 'Drinishader',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7691522,
        LOCATION_LATITUDE_DEG: 57.8542371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007100',
        LOCATION_NAME: 'Drinkstone',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8679791,
        LOCATION_LATITUDE_DEG: 52.2207977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007200',
        LOCATION_NAME: 'Drinkstone Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8678985,
        LOCATION_LATITUDE_DEG: 52.2065978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007300',
        LOCATION_NAME: 'Drinsey Nook',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.691107,
        LOCATION_LATITUDE_DEG: 53.2571189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007400',
        LOCATION_NAME: 'Drip Bridge',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.983932,
        LOCATION_LATITUDE_DEG: 56.13674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008000',
        LOCATION_NAME: 'Drointon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9639659,
        LOCATION_LATITUDE_DEG: 52.8391992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008100',
        LOCATION_NAME: 'Droitwich',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1522709,
        LOCATION_LATITUDE_DEG: 52.2677441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008700',
        LOCATION_NAME: 'Dromara',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0181177,
        LOCATION_LATITUDE_DEG: 54.3779872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010500',
        LOCATION_NAME: 'Dromore',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7373732,
        LOCATION_LATITUDE_DEG: 54.3672171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010200',
        LOCATION_NAME: 'Dromore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4559473,
        LOCATION_LATITUDE_DEG: 54.5183124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010300',
        LOCATION_NAME: 'Dromore',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1556229,
        LOCATION_LATITUDE_DEG: 54.4148943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010700',
        LOCATION_NAME: 'Dron',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3909499,
        LOCATION_LATITUDE_DEG: 56.3274523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010800',
        LOCATION_NAME: 'Dronfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4643008,
        LOCATION_LATITUDE_DEG: 53.3008307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010900',
        LOCATION_NAME: 'Dronfield Woodhouse',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.505452,
        LOCATION_LATITUDE_DEG: 53.3032379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011000',
        LOCATION_NAME: 'Drongan',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4553919,
        LOCATION_LATITUDE_DEG: 55.4362769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011100',
        LOCATION_NAME: 'Dronley',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0659387,
        LOCATION_LATITUDE_DEG: 56.5078645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011200',
        LOCATION_NAME: 'Droomer',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8930823,
        LOCATION_LATITUDE_DEG: 54.373854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011300',
        LOCATION_NAME: 'Droop',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3498339,
        LOCATION_LATITUDE_DEG: 50.8735141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011400',
        LOCATION_NAME: 'Droxford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1364427,
        LOCATION_LATITUDE_DEG: 50.9602045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011500',
        LOCATION_NAME: 'Droylsden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1615051,
        LOCATION_LATITUDE_DEG: 53.4841621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011600',
        LOCATION_NAME: 'Druce',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3609387,
        LOCATION_LATITUDE_DEG: 50.7561049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011700',
        LOCATION_NAME: 'Druid',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4294433,
        LOCATION_LATITUDE_DEG: 52.979923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR023300',
        LOCATION_NAME: 'Druids Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9064659,
        LOCATION_LATITUDE_DEG: 52.4080773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011800',
        LOCATION_NAME: 'Druids Lodge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8599905,
        LOCATION_LATITUDE_DEG: 51.1488335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR011900',
        LOCATION_NAME: 'Druimarbin',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1488635,
        LOCATION_LATITUDE_DEG: 56.7895185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012100',
        LOCATION_NAME: 'Drum',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5348201,
        LOCATION_LATITUDE_DEG: 56.1874406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012200',
        LOCATION_NAME: 'Drumabest',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3384342,
        LOCATION_LATITUDE_DEG: 55.1201628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012400',
        LOCATION_NAME: 'Drumahoe',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2657188,
        LOCATION_LATITUDE_DEG: 54.9666505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012600',
        LOCATION_NAME: 'Drumalig',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9423045,
        LOCATION_LATITUDE_DEG: 54.4724908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012900',
        LOCATION_NAME: 'Drumaness',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8967989,
        LOCATION_LATITUDE_DEG: 54.3871868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013000',
        LOCATION_NAME: 'Drumard',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7157869,
        LOCATION_LATITUDE_DEG: 54.483208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013200',
        LOCATION_NAME: 'Drumbeg',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2011896,
        LOCATION_LATITUDE_DEG: 58.2447628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013400',
        LOCATION_NAME: 'Drumblade',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6866545,
        LOCATION_LATITUDE_DEG: 57.4505521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013500',
        LOCATION_NAME: 'Drumbo',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9488928,
        LOCATION_LATITUDE_DEG: 54.5166024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013900',
        LOCATION_NAME: 'Drumboy',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7657905,
        LOCATION_LATITUDE_DEG: 54.3498966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014000',
        LOCATION_NAME: 'Drumbuie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6917379,
        LOCATION_LATITUDE_DEG: 57.3153797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014100',
        LOCATION_NAME: 'Drumburgh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1472328,
        LOCATION_LATITUDE_DEG: 54.9271134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014400',
        LOCATION_NAME: 'Drumcard',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6972978,
        LOCATION_LATITUDE_DEG: 54.2520794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR023600',
        LOCATION_NAME: 'Drumchapel',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3719623,
        LOCATION_LATITUDE_DEG: 55.9083283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014500',
        LOCATION_NAME: 'Drumchardine',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3864922,
        LOCATION_LATITUDE_DEG: 57.4703765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014600',
        LOCATION_NAME: 'Drumclay',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6305787,
        LOCATION_LATITUDE_DEG: 54.3468934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014800',
        LOCATION_NAME: 'Drumclog',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1604408,
        LOCATION_LATITUDE_DEG: 55.6243944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014900',
        LOCATION_NAME: 'Drumclune',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9599977,
        LOCATION_LATITUDE_DEG: 56.7060827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015350',
        LOCATION_NAME: 'Drumcose',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.718197,
        LOCATION_LATITUDE_DEG: 54.4013047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015700',
        LOCATION_NAME: 'Drumduff',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6203537,
        LOCATION_LATITUDE_DEG: 54.488102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016000',
        LOCATION_NAME: 'Drumfearn',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8480938,
        LOCATION_LATITUDE_DEG: 57.1739588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016300',
        LOCATION_NAME: 'Drumgask',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3577383,
        LOCATION_LATITUDE_DEG: 54.4439965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016400',
        LOCATION_NAME: 'Drumgley',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9436756,
        LOCATION_LATITUDE_DEG: 56.6419808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016500',
        LOCATION_NAME: 'Drumgor',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3784407,
        LOCATION_LATITUDE_DEG: 54.4497962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016700',
        LOCATION_NAME: 'Drumguish',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9887046,
        LOCATION_LATITUDE_DEG: 57.0706374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990200',
        LOCATION_NAME: 'DRUMHILLERY',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7857675,
        LOCATION_LATITUDE_DEG: 54.2711873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017400',
        LOCATION_NAME: 'Drumlea',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1799198,
        LOCATION_LATITUDE_DEG: 54.6686146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017500',
        LOCATION_NAME: 'Drumlemble',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6925946,
        LOCATION_LATITUDE_DEG: 55.4155847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017800',
        LOCATION_NAME: 'Drumlithie',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3494563,
        LOCATION_LATITUDE_DEG: 56.9184976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018100',
        LOCATION_NAME: 'Drummore',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.892717,
        LOCATION_LATITUDE_DEG: 54.6901105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018200',
        LOCATION_NAME: 'Drummuir',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0414636,
        LOCATION_LATITUDE_DEG: 57.484345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018300',
        LOCATION_NAME: 'Drumnadrochit',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4786455,
        LOCATION_LATITUDE_DEG: 57.3374653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018500',
        LOCATION_NAME: 'Drumnakilly',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1720307,
        LOCATION_LATITUDE_DEG: 54.6041081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018700',
        LOCATION_NAME: 'Drumoak',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3423868,
        LOCATION_LATITUDE_DEG: 57.0792115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019000',
        LOCATION_NAME: 'Drumore',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6260162,
        LOCATION_LATITUDE_DEG: 55.4394858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019100',
        LOCATION_NAME: 'Drumoyne',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3228847,
        LOCATION_LATITUDE_DEG: 55.8583164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019200',
        LOCATION_NAME: 'Drumpark',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7627645,
        LOCATION_LATITUDE_DEG: 55.1024386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019300',
        LOCATION_NAME: 'Drumquin',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4990502,
        LOCATION_LATITUDE_DEG: 54.6166222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019400',
        LOCATION_NAME: 'Drumragh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2976195,
        LOCATION_LATITUDE_DEG: 54.5673859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019850',
        LOCATION_NAME: 'Drumshane',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.692402,
        LOCATION_LATITUDE_DEG: 54.4738361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019900',
        LOCATION_NAME: 'Drumshanly',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3173637,
        LOCATION_LATITUDE_DEG: 54.5637813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR023000',
        LOCATION_NAME: 'Drumsheugh',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2138429,
        LOCATION_LATITUDE_DEG: 55.9515297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR023050',
        LOCATION_NAME: 'Drumskinny',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7043313,
        LOCATION_LATITUDE_DEG: 54.5729663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020000',
        LOCATION_NAME: 'Drumsleet',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6559396,
        LOCATION_LATITUDE_DEG: 55.0530275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020200',
        LOCATION_NAME: 'Drumsturdy',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8267238,
        LOCATION_LATITUDE_DEG: 56.509462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020300',
        LOCATION_NAME: 'Drumsurn',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8822816,
        LOCATION_LATITUDE_DEG: 54.9832543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020400',
        LOCATION_NAME: 'Drumuie',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.240797,
        LOCATION_LATITUDE_DEG: 57.4383934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020500',
        LOCATION_NAME: 'Drumvaich',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1391929,
        LOCATION_LATITUDE_DEG: 56.2128465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020600',
        LOCATION_NAME: 'Drumwhindle',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1227135,
        LOCATION_LATITUDE_DEG: 57.4184486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020700',
        LOCATION_NAME: 'Drumwhisker',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3216842,
        LOCATION_LATITUDE_DEG: 54.5205948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021000',
        LOCATION_NAME: 'Drury',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0546343,
        LOCATION_LATITUDE_DEG: 53.1722444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021100',
        LOCATION_NAME: 'Drws y Nant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7546162,
        LOCATION_LATITUDE_DEG: 52.788211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021200',
        LOCATION_NAME: 'Dry Doddington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7327573,
        LOCATION_LATITUDE_DEG: 53.0101918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021300',
        LOCATION_NAME: 'Dry Drayton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0222867,
        LOCATION_LATITUDE_DEG: 52.238713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021500',
        LOCATION_NAME: 'Dry Sandford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3229336,
        LOCATION_LATITUDE_DEG: 51.7002825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021600',
        LOCATION_NAME: 'Drybeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5125008,
        LOCATION_LATITUDE_DEG: 54.5320676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021700',
        LOCATION_NAME: 'Drybridge',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6036173,
        LOCATION_LATITUDE_DEG: 55.5953958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021800',
        LOCATION_NAME: 'Drybridge',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9460887,
        LOCATION_LATITUDE_DEG: 57.6490813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021900',
        LOCATION_NAME: 'Drybrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5150937,
        LOCATION_LATITUDE_DEG: 51.8551041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022000',
        LOCATION_NAME: 'Dryfeholm',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3936738,
        LOCATION_LATITUDE_DEG: 55.1395324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022100',
        LOCATION_NAME: 'Drym',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3297324,
        LOCATION_LATITUDE_DEG: 50.153478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022200',
        LOCATION_NAME: 'Drymen',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4479104,
        LOCATION_LATITUDE_DEG: 56.0668427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022300',
        LOCATION_NAME: 'Drymere',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6362986,
        LOCATION_LATITUDE_DEG: 52.6253365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022400',
        LOCATION_NAME: 'Drynoch',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3094907,
        LOCATION_LATITUDE_DEG: 57.3022762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022500',
        LOCATION_NAME: 'Dryslwyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1019246,
        LOCATION_LATITUDE_DEG: 51.8629282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR022600',
        LOCATION_NAME: 'Dryton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6217305,
        LOCATION_LATITUDE_DEG: 52.6488879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002500',
        LOCATION_NAME: 'Dubmire',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5016224,
        LOCATION_LATITUDE_DEG: 54.8399857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002700',
        LOCATION_NAME: 'Duck End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4079201,
        LOCATION_LATITUDE_DEG: 51.9096743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002800',
        LOCATION_NAME: 'Duckington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7590795,
        LOCATION_LATITUDE_DEG: 53.0618285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002900',
        LOCATION_NAME: 'Ducklington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4827324,
        LOCATION_LATITUDE_DEG: 51.7672865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003000',
        LOCATION_NAME: 'Duckmanton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.33667,
        LOCATION_LATITUDE_DEG: 53.2463303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003100',
        LOCATION_NAME: 'Dudbridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2422279,
        LOCATION_LATITUDE_DEG: 51.7389955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003200',
        LOCATION_NAME: 'Dudbridge Mill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2477028,
        LOCATION_LATITUDE_DEG: 51.7389931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003300',
        LOCATION_NAME: 'Duddenhoe End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1271359,
        LOCATION_LATITUDE_DEG: 52.0091919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003400',
        LOCATION_NAME: 'Duddingston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1460177,
        LOCATION_LATITUDE_DEG: 55.9414133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003500',
        LOCATION_NAME: 'Duddington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5399581,
        LOCATION_LATITUDE_DEG: 52.59635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003600',
        LOCATION_NAME: 'Duddlestone',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0879435,
        LOCATION_LATITUDE_DEG: 50.9843306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003700',
        LOCATION_NAME: 'Duddleswell',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0968888,
        LOCATION_LATITUDE_DEG: 51.033796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003800',
        LOCATION_NAME: 'Duddo',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1004117,
        LOCATION_LATITUDE_DEG: 55.676869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU003900',
        LOCATION_NAME: 'Duddon',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7255892,
        LOCATION_LATITUDE_DEG: 53.1771394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004000',
        LOCATION_NAME: 'Duddon Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2292457,
        LOCATION_LATITUDE_DEG: 54.2826462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004100',
        LOCATION_NAME: 'Dudgrove',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7164535,
        LOCATION_LATITUDE_DEG: 51.6804807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004200',
        LOCATION_NAME: 'Dudleston Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9382253,
        LOCATION_LATITUDE_DEG: 52.9242179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004400',
        LOCATION_NAME: 'Dudley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0822994,
        LOCATION_LATITUDE_DEG: 52.5094687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004300',
        LOCATION_NAME: 'Dudley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5932586,
        LOCATION_LATITUDE_DEG: 55.0557096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004500',
        LOCATION_NAME: 'Dudley Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7218942,
        LOCATION_LATITUDE_DEG: 53.7751829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004600',
        LOCATION_NAME: 'Dudley Port',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0505127,
        LOCATION_LATITUDE_DEG: 52.520968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004700',
        LOCATION_NAME: 'Dudswell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5991526,
        LOCATION_LATITUDE_DEG: 51.775374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004800',
        LOCATION_NAME: 'Duffield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4868503,
        LOCATION_LATITUDE_DEG: 52.9877058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU004900',
        LOCATION_NAME: 'Duffryn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0134612,
        LOCATION_LATITUDE_DEG: 51.5626851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005000',
        LOCATION_NAME: 'Duffryn Rhondda',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6817365,
        LOCATION_LATITUDE_DEG: 51.6473973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005100',
        LOCATION_NAME: 'Dufftown',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.125316,
        LOCATION_LATITUDE_DEG: 57.4434557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005200',
        LOCATION_NAME: 'Duffus',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3946369,
        LOCATION_LATITUDE_DEG: 57.6993857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005300',
        LOCATION_NAME: 'Dufton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4825698,
        LOCATION_LATITUDE_DEG: 54.6202727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005400',
        LOCATION_NAME: 'Duggleby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6562457,
        LOCATION_LATITUDE_DEG: 54.0915994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005600',
        LOCATION_NAME: 'Duirinish',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6797765,
        LOCATION_LATITUDE_DEG: 57.3185719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005700',
        LOCATION_NAME: 'Duisdale Beag',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8058013,
        LOCATION_LATITUDE_DEG: 57.1471582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005800',
        LOCATION_NAME: 'Duisdalemore',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8016453,
        LOCATION_LATITUDE_DEG: 57.1527607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005900',
        LOCATION_NAME: 'Dukesmead',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2805887,
        LOCATION_LATITUDE_DEG: 52.6098537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006000',
        LOCATION_NAME: 'Dukestown',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2431196,
        LOCATION_LATITUDE_DEG: 51.7846117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006100',
        LOCATION_NAME: 'Dukinfield',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0900892,
        LOCATION_LATITUDE_DEG: 53.4734588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006200',
        LOCATION_NAME: 'Dulas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2893633,
        LOCATION_LATITUDE_DEG: 53.3789757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006250',
        LOCATION_NAME: 'Dulas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9133949,
        LOCATION_LATITUDE_DEG: 51.9594767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006300',
        LOCATION_NAME: 'Dulcote',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6230662,
        LOCATION_LATITUDE_DEG: 51.1986446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006600',
        LOCATION_NAME: 'Dulford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3206801,
        LOCATION_LATITUDE_DEG: 50.8447201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006700',
        LOCATION_NAME: 'Dull',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9458451,
        LOCATION_LATITUDE_DEG: 56.618889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006800',
        LOCATION_NAME: 'Dullatur',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.005801,
        LOCATION_LATITUDE_DEG: 55.9677229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006900',
        LOCATION_NAME: 'Dullingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3853083,
        LOCATION_LATITUDE_DEG: 52.1947001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007000',
        LOCATION_NAME: 'Dulnain Bridge',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'PH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6619721,
        LOCATION_LATITUDE_DEG: 57.3036494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007200',
        LOCATION_NAME: 'Duloe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4852397,
        LOCATION_LATITUDE_DEG: 50.398786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007100',
        LOCATION_NAME: 'Duloe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.303148,
        LOCATION_LATITUDE_DEG: 52.232115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007300',
        LOCATION_NAME: 'Dulverton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5473258,
        LOCATION_LATITUDE_DEG: 51.0394438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU030000',
        LOCATION_NAME: 'Dulwich',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.085836,
        LOCATION_LATITUDE_DEG: 51.4518702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007400',
        LOCATION_NAME: 'Dumbarton',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5496964,
        LOCATION_LATITUDE_DEG: 55.9493254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007500',
        LOCATION_NAME: 'Dumbleton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9734016,
        LOCATION_LATITUDE_DEG: 52.0200149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU030300',
        LOCATION_NAME: 'Dumbreck',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3039703,
        LOCATION_LATITUDE_DEG: 55.8446858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007600',
        LOCATION_NAME: 'Dumcrieff',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4170705,
        LOCATION_LATITUDE_DEG: 55.317851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007700',
        LOCATION_NAME: 'Dumfries',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.607265,
        LOCATION_LATITUDE_DEG: 55.0687354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007800',
        LOCATION_NAME: 'Dumgoyne',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3707339,
        LOCATION_LATITUDE_DEG: 56.0218339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU007900',
        LOCATION_NAME: 'Dummer',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1645641,
        LOCATION_LATITUDE_DEG: 51.2085265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008000',
        LOCATION_NAME: 'Dun',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5446359,
        LOCATION_LATITUDE_DEG: 56.7291836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008200',
        LOCATION_NAME: 'Dunach',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4492789,
        LOCATION_LATITUDE_DEG: 56.3715803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008300',
        LOCATION_NAME: 'Dunadry',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1322015,
        LOCATION_LATITUDE_DEG: 54.683218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008500',
        LOCATION_NAME: 'Dunalastair',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1069204,
        LOCATION_LATITUDE_DEG: 56.7038005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008600',
        LOCATION_NAME: 'Dunamanagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3142228,
        LOCATION_LATITUDE_DEG: 54.8839441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008700',
        LOCATION_NAME: 'Dunball',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9885821,
        LOCATION_LATITUDE_DEG: 51.1641472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008800',
        LOCATION_NAME: 'Dunbar',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5127968,
        LOCATION_LATITUDE_DEG: 55.9997078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009000',
        LOCATION_NAME: 'Dunbeath',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4228536,
        LOCATION_LATITUDE_DEG: 58.248648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009100',
        LOCATION_NAME: 'Dunbeg',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4404084,
        LOCATION_LATITUDE_DEG: 56.4452871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009200',
        LOCATION_NAME: 'Dunblane',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9602749,
        LOCATION_LATITUDE_DEG: 56.1883465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009300',
        LOCATION_NAME: 'Dunbog',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1520415,
        LOCATION_LATITUDE_DEG: 56.3488554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009500',
        LOCATION_NAME: 'Dunbreen',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2939439,
        LOCATION_LATITUDE_DEG: 54.6736181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009600',
        LOCATION_NAME: 'Dunbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5421631,
        LOCATION_LATITUDE_DEG: 51.0305162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009800',
        LOCATION_NAME: 'Duncanston',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3590483,
        LOCATION_LATITUDE_DEG: 57.5801902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009900',
        LOCATION_NAME: 'Duncanstone',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7011369,
        LOCATION_LATITUDE_DEG: 57.3285413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010000',
        LOCATION_NAME: 'Dunchideock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5848568,
        LOCATION_LATITUDE_DEG: 50.6785075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010100',
        LOCATION_NAME: 'Dunchurch',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2875148,
        LOCATION_LATITUDE_DEG: 52.3373366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010300',
        LOCATION_NAME: 'Duncote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0153599,
        LOCATION_LATITUDE_DEG: 52.1504137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010400',
        LOCATION_NAME: 'Duncow',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6181273,
        LOCATION_LATITUDE_DEG: 55.1360397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010500',
        LOCATION_NAME: 'Duncrievie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3952428,
        LOCATION_LATITUDE_DEG: 56.2686513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010600',
        LOCATION_NAME: 'Duncton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6330436,
        LOCATION_LATITUDE_DEG: 50.9459988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010800',
        LOCATION_NAME: 'Dundee',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.966607,
        LOCATION_LATITUDE_DEG: 56.461458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011100',
        LOCATION_NAME: 'Dundonald',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8039808,
        LOCATION_LATITUDE_DEG: 54.5963031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011200',
        LOCATION_NAME: 'Dundonald',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.590544,
        LOCATION_LATITUDE_DEG: 55.5740887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011300',
        LOCATION_NAME: 'Dundonnell',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2102596,
        LOCATION_LATITUDE_DEG: 57.8390226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011500',
        LOCATION_NAME: 'Dundraw',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2210042,
        LOCATION_LATITUDE_DEG: 54.8373049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011600',
        LOCATION_NAME: 'Dundrennan',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9453584,
        LOCATION_LATITUDE_DEG: 54.809007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011700',
        LOCATION_NAME: 'Dundrod',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1156109,
        LOCATION_LATITUDE_DEG: 54.6166057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011800',
        LOCATION_NAME: 'Dundrum',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.849097,
        LOCATION_LATITUDE_DEG: 54.2625771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012100',
        LOCATION_NAME: 'Dundry',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6324073,
        LOCATION_LATITUDE_DEG: 51.396565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012200',
        LOCATION_NAME: 'Dunduff',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4662874,
        LOCATION_LATITUDE_DEG: 56.1115354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012300',
        LOCATION_NAME: 'Dunecht',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.412712,
        LOCATION_LATITUDE_DEG: 57.1736214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012500',
        LOCATION_NAME: 'Dunfermline',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4582126,
        LOCATION_LATITUDE_DEG: 56.0715323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012600',
        LOCATION_NAME: 'Dunfield',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0634347,
        LOCATION_LATITUDE_DEG: 52.2193444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012700',
        LOCATION_NAME: 'Dunfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7906998,
        LOCATION_LATITUDE_DEG: 51.6749803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012800',
        LOCATION_NAME: 'Dunford Bridge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7600839,
        LOCATION_LATITUDE_DEG: 53.5178578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012900',
        LOCATION_NAME: 'Dunganachy',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3503571,
        LOCATION_LATITUDE_DEG: 57.4755067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013000',
        LOCATION_NAME: 'Dungannon',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7686842,
        LOCATION_LATITUDE_DEG: 54.5056027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013400',
        LOCATION_NAME: 'Dungavel',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1007738,
        LOCATION_LATITUDE_DEG: 55.5955892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013600',
        LOCATION_NAME: 'Dungeness',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9788404,
        LOCATION_LATITUDE_DEG: 50.9159725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013700',
        LOCATION_NAME: 'Dungiven',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9224963,
        LOCATION_LATITUDE_DEG: 54.9309404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014000',
        LOCATION_NAME: 'Dungworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.580369,
        LOCATION_LATITUDE_DEG: 53.4074464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014100',
        LOCATION_NAME: 'Dunhallin',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5871785,
        LOCATION_LATITUDE_DEG: 57.535701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014200',
        LOCATION_NAME: 'Dunham Massey',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3944692,
        LOCATION_LATITUDE_DEG: 53.3952523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014400',
        LOCATION_NAME: 'Dunham on the Hill',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7895923,
        LOCATION_LATITUDE_DEG: 53.2489412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029500',
        LOCATION_NAME: 'Dunham on Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014300',
        LOCATION_NAME: 'Dunham Town',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3907757,
        LOCATION_LATITUDE_DEG: 53.3844499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014500',
        LOCATION_NAME: 'Dunham-on-Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.783102,
        LOCATION_LATITUDE_DEG: 53.2607816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014600',
        LOCATION_NAME: 'Dunhampstead',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.115778,
        LOCATION_LATITUDE_DEG: 52.2337352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014700',
        LOCATION_NAME: 'Dunhampton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2260438,
        LOCATION_LATITUDE_DEG: 52.2959486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015000',
        LOCATION_NAME: 'Dunholme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.462282,
        LOCATION_LATITUDE_DEG: 53.300716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015100',
        LOCATION_NAME: 'Dunino',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7453403,
        LOCATION_LATITUDE_DEG: 56.2863377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015200',
        LOCATION_NAME: 'Dunipace',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9135834,
        LOCATION_LATITUDE_DEG: 56.027627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015300',
        LOCATION_NAME: 'Dunira',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0401394,
        LOCATION_LATITUDE_DEG: 56.3897676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015500',
        LOCATION_NAME: 'Dunkeld',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5839509,
        LOCATION_LATITUDE_DEG: 56.5650818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015700',
        LOCATION_NAME: 'Dunkerton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4152698,
        LOCATION_LATITUDE_DEG: 51.3320592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015800',
        LOCATION_NAME: 'Dunkeswell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2198021,
        LOCATION_LATITUDE_DEG: 50.8626189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015900',
        LOCATION_NAME: 'Dunkeswell Abbey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2252247,
        LOCATION_LATITUDE_DEG: 50.859675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016100',
        LOCATION_NAME: 'Dunkirk',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9281604,
        LOCATION_LATITUDE_DEG: 53.2500466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016300',
        LOCATION_NAME: 'Dunkirk',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3017096,
        LOCATION_LATITUDE_DEG: 51.572977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016200',
        LOCATION_NAME: 'Dunkirk',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9810629,
        LOCATION_LATITUDE_DEG: 51.2911079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016400',
        LOCATION_NAME: 'Dunkirk Mills',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2243963,
        LOCATION_LATITUDE_DEG: 51.7034938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016600',
        LOCATION_NAME: 'Dunks Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3078351,
        LOCATION_LATITUDE_DEG: 51.2454826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017100',
        LOCATION_NAME: 'Dunley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3089794,
        LOCATION_LATITUDE_DEG: 52.3199473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017200',
        LOCATION_NAME: 'Dunley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3489368,
        LOCATION_LATITUDE_DEG: 51.278737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017300',
        LOCATION_NAME: 'Dunlop',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5332024,
        LOCATION_LATITUDE_DEG: 55.7122061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017400',
        LOCATION_NAME: 'Dunloy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4156346,
        LOCATION_LATITUDE_DEG: 54.9999553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017500',
        LOCATION_NAME: 'Dunlugas',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.498412,
        LOCATION_LATITUDE_DEG: 57.5834701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017900',
        LOCATION_NAME: 'Dunmere',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7538809,
        LOCATION_LATITUDE_DEG: 50.4724023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018100',
        LOCATION_NAME: 'Dunmore',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5246832,
        LOCATION_LATITUDE_DEG: 55.7975268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018200',
        LOCATION_NAME: 'Dunmore',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7807789,
        LOCATION_LATITUDE_DEG: 56.0839351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018500',
        LOCATION_NAME: 'Dunmow',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3650545,
        LOCATION_LATITUDE_DEG: 51.8712683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018600',
        LOCATION_NAME: 'Dunmullan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3103021,
        LOCATION_LATITUDE_DEG: 54.6626126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018700',
        LOCATION_NAME: 'Dunmurry',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0087987,
        LOCATION_LATITUDE_DEG: 54.5531005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018900',
        LOCATION_NAME: 'Dunnamona',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.357001,
        LOCATION_LATITUDE_DEG: 54.5408131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019000',
        LOCATION_NAME: 'Dunnamore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0533469,
        LOCATION_LATITUDE_DEG: 54.6732715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019100',
        LOCATION_NAME: 'Dunnet',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3435275,
        LOCATION_LATITUDE_DEG: 58.6229812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019200',
        LOCATION_NAME: 'Dunnikier Park',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1625761,
        LOCATION_LATITUDE_DEG: 56.1363346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019300',
        LOCATION_NAME: 'Dunning',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5860727,
        LOCATION_LATITUDE_DEG: 56.3124547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019400',
        LOCATION_NAME: 'Dunning Glen',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5943887,
        LOCATION_LATITUDE_DEG: 56.2349457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019700',
        LOCATION_NAME: 'Dunnington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9009009,
        LOCATION_LATITUDE_DEG: 52.1815282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019500',
        LOCATION_NAME: 'Dunnington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9779608,
        LOCATION_LATITUDE_DEG: 53.9648876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019600',
        LOCATION_NAME: 'Dunnington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2421029,
        LOCATION_LATITUDE_DEG: 53.9509793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019800',
        LOCATION_NAME: 'Dunnockshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2705417,
        LOCATION_LATITUDE_DEG: 53.748188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU019900',
        LOCATION_NAME: 'Dunnyvadden',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.121416,
        LOCATION_LATITUDE_DEG: 54.8599309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020000',
        LOCATION_NAME: 'Dunoon',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9218352,
        LOCATION_LATITUDE_DEG: 55.9471352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020200',
        LOCATION_NAME: 'Dunphail',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6382374,
        LOCATION_LATITUDE_DEG: 57.5207748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020400',
        LOCATION_NAME: 'Dunragit',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8827369,
        LOCATION_LATITUDE_DEG: 54.8787263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020500',
        LOCATION_NAME: 'Dunrobin Castle',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9448257,
        LOCATION_LATITUDE_DEG: 57.9829198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020600',
        LOCATION_NAME: 'Dunrossness',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2926547,
        LOCATION_LATITUDE_DEG: 59.9249854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020700',
        LOCATION_NAME: 'Duns',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3410653,
        LOCATION_LATITUDE_DEG: 55.778286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020800',
        LOCATION_NAME: 'Duns Tew',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3343856,
        LOCATION_LATITUDE_DEG: 51.9520022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021000',
        LOCATION_NAME: 'Dunsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3600302,
        LOCATION_LATITUDE_DEG: 52.8272738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029400',
        LOCATION_NAME: 'Dunsby St Andrews',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021100',
        LOCATION_NAME: 'Dunsby St. Andrews',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4482909,
        LOCATION_LATITUDE_DEG: 53.0482957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021200',
        LOCATION_NAME: 'Dunscore',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.777999,
        LOCATION_LATITUDE_DEG: 55.141542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021300',
        LOCATION_NAME: 'Dunscroft',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0045062,
        LOCATION_LATITUDE_DEG: 53.5741497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021400',
        LOCATION_NAME: 'Dunsdale',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0613016,
        LOCATION_LATITUDE_DEG: 54.5611498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021450',
        LOCATION_NAME: 'Dunsden',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.935525,
        LOCATION_LATITUDE_DEG: 51.4858214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021500',
        LOCATION_NAME: 'Dunseverick',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4489273,
        LOCATION_LATITUDE_DEG: 55.2332775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021600',
        LOCATION_NAME: 'Dunsfold',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5614008,
        LOCATION_LATITUDE_DEG: 51.1165153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021700',
        LOCATION_NAME: 'Dunsford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6821516,
        LOCATION_LATITUDE_DEG: 50.6884049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021800',
        LOCATION_NAME: 'Dunshalt',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2121404,
        LOCATION_LATITUDE_DEG: 56.2808418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022100',
        LOCATION_NAME: 'Dunsinnan',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3517069,
        LOCATION_LATITUDE_DEG: 56.4818639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022200',
        LOCATION_NAME: 'Dunsley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6766066,
        LOCATION_LATITUDE_DEG: 54.4886372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022300',
        LOCATION_NAME: 'Dunsmore',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7505516,
        LOCATION_LATITUDE_DEG: 51.7386733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022400',
        LOCATION_NAME: 'Dunsmouth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5479474,
        LOCATION_LATITUDE_DEG: 50.8534329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022500',
        LOCATION_NAME: 'Dunsop Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5192041,
        LOCATION_LATITUDE_DEG: 53.9450111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022600',
        LOCATION_NAME: 'Dunstable',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.499898,
        LOCATION_LATITUDE_DEG: 51.8726826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022700',
        LOCATION_NAME: 'Dunstall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.133257,
        LOCATION_LATITUDE_DEG: 52.5975241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022800',
        LOCATION_NAME: 'Dunstall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7226432,
        LOCATION_LATITUDE_DEG: 52.7803883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022900',
        LOCATION_NAME: 'Dunstan',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6084382,
        LOCATION_LATITUDE_DEG: 55.4708465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023000',
        LOCATION_NAME: 'Dunster',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.444669,
        LOCATION_LATITUDE_DEG: 51.182355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023300',
        LOCATION_NAME: 'Dunston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1070133,
        LOCATION_LATITUDE_DEG: 52.7585923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029800',
        LOCATION_NAME: 'Dunston',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6476085,
        LOCATION_LATITUDE_DEG: 54.9602725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023100',
        LOCATION_NAME: 'Dunston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4098063,
        LOCATION_LATITUDE_DEG: 53.1525059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023200',
        LOCATION_NAME: 'Dunston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2817043,
        LOCATION_LATITUDE_DEG: 52.576929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023400',
        LOCATION_NAME: 'Dunston Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1346293,
        LOCATION_LATITUDE_DEG: 52.7559929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029700',
        LOCATION_NAME: 'Dunston Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6594972,
        LOCATION_LATITUDE_DEG: 54.9470141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023500',
        LOCATION_NAME: 'Dunstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.688366,
        LOCATION_LATITUDE_DEG: 50.2515708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023600',
        LOCATION_NAME: 'Dunsville',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0198762,
        LOCATION_LATITUDE_DEG: 53.5639564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023700',
        LOCATION_NAME: 'Dunswell',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3695946,
        LOCATION_LATITUDE_DEG: 53.8008646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023800',
        LOCATION_NAME: 'Dunsyre',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4753855,
        LOCATION_LATITUDE_DEG: 55.7178962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU023900',
        LOCATION_NAME: 'Dunterton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2932957,
        LOCATION_LATITUDE_DEG: 50.5908065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024000',
        LOCATION_NAME: 'Duntisbourne Abbotts',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0443354,
        LOCATION_LATITUDE_DEG: 51.7690456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024100',
        LOCATION_NAME: 'Duntisbourne Leer',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0377957,
        LOCATION_LATITUDE_DEG: 51.7651903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024200',
        LOCATION_NAME: 'Duntisbourne Rouse',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0253708,
        LOCATION_LATITUDE_DEG: 51.7562914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024300',
        LOCATION_NAME: 'Duntish',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4353062,
        LOCATION_LATITUDE_DEG: 50.8525146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024400',
        LOCATION_NAME: 'Duntocher',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4061507,
        LOCATION_LATITUDE_DEG: 55.9252199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024500',
        LOCATION_NAME: 'Dunton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8002975,
        LOCATION_LATITUDE_DEG: 51.9115953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024600',
        LOCATION_NAME: 'Dunton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1942871,
        LOCATION_LATITUDE_DEG: 52.0825981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024800',
        LOCATION_NAME: 'Dunton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3914412,
        LOCATION_LATITUDE_DEG: 51.5747427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024700',
        LOCATION_NAME: 'Dunton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7907049,
        LOCATION_LATITUDE_DEG: 52.8364626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU024900',
        LOCATION_NAME: 'Dunton Bassett',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1941259,
        LOCATION_LATITUDE_DEG: 52.5100532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025000',
        LOCATION_NAME: 'Dunton Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1664462,
        LOCATION_LATITUDE_DEG: 51.2963232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025100',
        LOCATION_NAME: 'Dunton Wayletts',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3928551,
        LOCATION_LATITUDE_DEG: 51.5843466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025200',
        LOCATION_NAME: 'Dunure',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7554509,
        LOCATION_LATITUDE_DEG: 55.4055741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025300',
        LOCATION_NAME: 'Dunvant',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0323942,
        LOCATION_LATITUDE_DEG: 51.6255001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025400',
        LOCATION_NAME: 'Dunvegan',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5723009,
        LOCATION_LATITUDE_DEG: 57.4367941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025500',
        LOCATION_NAME: 'Dunwear',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9758881,
        LOCATION_LATITUDE_DEG: 51.1204383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025600',
        LOCATION_NAME: 'Dunwich',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6306585,
        LOCATION_LATITUDE_DEG: 52.2769888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025700',
        LOCATION_NAME: 'Dunwish',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3735105,
        LOCATION_LATITUDE_DEG: 54.6274055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025800',
        LOCATION_NAME: 'Dupath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2918298,
        LOCATION_LATITUDE_DEG: 50.4988938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU025900',
        LOCATION_NAME: 'Duporth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7705804,
        LOCATION_LATITUDE_DEG: 50.3212838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026000',
        LOCATION_NAME: 'Dupplin Castle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5293463,
        LOCATION_LATITUDE_DEG: 56.3575614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026100',
        LOCATION_NAME: 'Dura Den',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.94272,
        LOCATION_LATITUDE_DEG: 56.3206479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026200',
        LOCATION_NAME: 'Durdar',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9274017,
        LOCATION_LATITUDE_DEG: 54.8500049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU030200',
        LOCATION_NAME: 'Durdham Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6132919,
        LOCATION_LATITUDE_DEG: 51.4806855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU030100',
        LOCATION_NAME: 'Durdham Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6156043,
        LOCATION_LATITUDE_DEG: 51.4748642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026300',
        LOCATION_NAME: 'Durford Wood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8870948,
        LOCATION_LATITUDE_DEG: 51.0206095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026400',
        LOCATION_NAME: 'Durgates',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3279068,
        LOCATION_LATITUDE_DEG: 51.0663979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026500',
        LOCATION_NAME: 'Durham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5580581,
        LOCATION_LATITUDE_DEG: 54.7785763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029600',
        LOCATION_NAME: 'Durham City',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5600639,
        LOCATION_LATITUDE_DEG: 54.7828707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026600',
        LOCATION_NAME: 'Durine',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7458258,
        LOCATION_LATITUDE_DEG: 58.5688942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026700',
        LOCATION_NAME: 'Durisdeer',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7434391,
        LOCATION_LATITUDE_DEG: 55.3139612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026800',
        LOCATION_NAME: 'Durisdeer Mill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7434635,
        LOCATION_LATITUDE_DEG: 55.3137991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU026900',
        LOCATION_NAME: 'Durkar',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5238225,
        LOCATION_LATITUDE_DEG: 53.6490702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027000',
        LOCATION_NAME: 'Durleigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0340448,
        LOCATION_LATITUDE_DEG: 51.1183467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027200',
        LOCATION_NAME: 'Durley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6585099,
        LOCATION_LATITUDE_DEG: 51.3754538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027100',
        LOCATION_NAME: 'Durley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2655952,
        LOCATION_LATITUDE_DEG: 50.9464016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027300',
        LOCATION_NAME: 'Durnamuck',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3438874,
        LOCATION_LATITUDE_DEG: 57.8780265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027400',
        LOCATION_NAME: 'Durness',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7484952,
        LOCATION_LATITUDE_DEG: 58.569592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027500',
        LOCATION_NAME: 'Durno',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4714402,
        LOCATION_LATITUDE_DEG: 57.3431413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027600',
        LOCATION_NAME: 'Duror',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2736134,
        LOCATION_LATITUDE_DEG: 56.6484076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027700',
        LOCATION_NAME: 'Durrington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7707067,
        LOCATION_LATITUDE_DEG: 51.1988377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027800',
        LOCATION_NAME: 'Durris',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.374191,
        LOCATION_LATITUDE_DEG: 57.0558154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028300',
        LOCATION_NAME: 'Dursley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3492398,
        LOCATION_LATITUDE_DEG: 51.6794855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028400',
        LOCATION_NAME: 'Durston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0074704,
        LOCATION_LATITUDE_DEG: 51.0475394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028500',
        LOCATION_NAME: 'Durweston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2014103,
        LOCATION_LATITUDE_DEG: 50.8765087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028600',
        LOCATION_NAME: 'Duston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9365753,
        LOCATION_LATITUDE_DEG: 52.2477225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028700',
        LOCATION_NAME: 'Dutlas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1614079,
        LOCATION_LATITUDE_DEG: 52.3925639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028800',
        LOCATION_NAME: 'Duton Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3350653,
        LOCATION_LATITUDE_DEG: 51.9163773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028900',
        LOCATION_NAME: 'Dutson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3457407,
        LOCATION_LATITUDE_DEG: 50.6480155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029000',
        LOCATION_NAME: 'Dutton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6481859,
        LOCATION_LATITUDE_DEG: 53.312346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU991042',
        LOCATION_NAME: 'Dutton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.51498,
        LOCATION_LATITUDE_DEG: 53.82636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029200',
        LOCATION_NAME: 'Duxford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4669424,
        LOCATION_LATITUDE_DEG: 51.696483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029100',
        LOCATION_NAME: 'Duxford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1610138,
        LOCATION_LATITUDE_DEG: 52.0918972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029300',
        LOCATION_NAME: 'Duxmoor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8175808,
        LOCATION_LATITUDE_DEG: 52.3935628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DW000100',
        LOCATION_NAME: 'Dwr y Felin',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8180575,
        LOCATION_LATITUDE_DEG: 51.667606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DW000200',
        LOCATION_NAME: 'Dwrbach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9984674,
        LOCATION_LATITUDE_DEG: 51.9642457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DW000300',
        LOCATION_NAME: 'Dwygyfylchi',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9012931,
        LOCATION_LATITUDE_DEG: 53.2734631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DW000400',
        LOCATION_NAME: 'Dwyran',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3222751,
        LOCATION_LATITUDE_DEG: 53.165852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000100',
        LOCATION_NAME: 'Dyce',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1874721,
        LOCATION_LATITUDE_DEG: 57.2041216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000300',
        LOCATION_NAME: 'Dyffryn',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.658908,
        LOCATION_LATITUDE_DEG: 51.6303024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000200',
        LOCATION_NAME: 'Dyffryn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3026197,
        LOCATION_LATITUDE_DEG: 51.4352779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000400',
        LOCATION_NAME: 'Dyffryn Ardudwy',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0955264,
        LOCATION_LATITUDE_DEG: 52.787813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000500',
        LOCATION_NAME: 'Dyffryn Cellwen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6681445,
        LOCATION_LATITUDE_DEG: 51.7783144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000600',
        LOCATION_NAME: 'Dyffryn Paith',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0562611,
        LOCATION_LATITUDE_DEG: 52.3894734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000800',
        LOCATION_NAME: 'Dyke',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6910503,
        LOCATION_LATITUDE_DEG: 57.6056797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000700',
        LOCATION_NAME: 'Dyke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.360411,
        LOCATION_LATITUDE_DEG: 52.7887685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY000900',
        LOCATION_NAME: 'Dyke Neuk',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8147413,
        LOCATION_LATITUDE_DEG: 55.1680202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001000',
        LOCATION_NAME: 'Dykehead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8037271,
        LOCATION_LATITUDE_DEG: 55.8193072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001100',
        LOCATION_NAME: 'Dylife',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6750228,
        LOCATION_LATITUDE_DEG: 52.5323864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001200',
        LOCATION_NAME: 'Dymchurch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9985024,
        LOCATION_LATITUDE_DEG: 51.0248856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001300',
        LOCATION_NAME: 'Dymock',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4379907,
        LOCATION_LATITUDE_DEG: 51.9781203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001400',
        LOCATION_NAME: 'Dyrham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3799676,
        LOCATION_LATITUDE_DEG: 51.4809721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001500',
        LOCATION_NAME: 'Dysart',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1217426,
        LOCATION_LATITUDE_DEG: 56.1273305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001900',
        LOCATION_NAME: 'Dyserth',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4151881,
        LOCATION_LATITUDE_DEG: 53.299257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000200',
        LOCATION_NAME: 'Eachwick',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8146385,
        LOCATION_LATITUDE_DEG: 55.0344091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000300',
        LOCATION_NAME: 'Eagland Hill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8669391,
        LOCATION_LATITUDE_DEG: 53.9003064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000400',
        LOCATION_NAME: 'Eagle',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6853227,
        LOCATION_LATITUDE_DEG: 53.1949126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000500',
        LOCATION_NAME: 'Eagle Barnsdale',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6808873,
        LOCATION_LATITUDE_DEG: 53.1765138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA990999',
        LOCATION_NAME: 'Eagle Farm South',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000600',
        LOCATION_NAME: 'Eagle Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6731092,
        LOCATION_LATITUDE_DEG: 53.2016101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000700',
        LOCATION_NAME: 'Eaglescliffe',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3433382,
        LOCATION_LATITUDE_DEG: 54.5327551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000900',
        LOCATION_NAME: 'Eaglesfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4016222,
        LOCATION_LATITUDE_DEG: 54.6399888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA000800',
        LOCATION_NAME: 'Eaglesfield',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1993282,
        LOCATION_LATITUDE_DEG: 55.0581216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001000',
        LOCATION_NAME: 'Eaglesham',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2711714,
        LOCATION_LATITUDE_DEG: 55.7400028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001100',
        LOCATION_NAME: 'Eaglestone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7372528,
        LOCATION_LATITUDE_DEG: 52.0286002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001200',
        LOCATION_NAME: 'Eaglestone West',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7426438,
        LOCATION_LATITUDE_DEG: 52.026104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001300',
        LOCATION_NAME: 'Eagleton',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2137104,
        LOCATION_LATITUDE_DEG: 58.1954638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001400',
        LOCATION_NAME: 'Eairy',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6050835,
        LOCATION_LATITUDE_DEG: 54.1684677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001500',
        LOCATION_NAME: 'Eakring',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9907322,
        LOCATION_LATITUDE_DEG: 53.1531103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001600',
        LOCATION_NAME: 'Ealand',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8130289,
        LOCATION_LATITUDE_DEG: 53.5941496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042600',
        LOCATION_NAME: 'Ealing',
        COUNTY_NAME: 'London',
        POSTCODE: 'W5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3012634,
        LOCATION_LATITUDE_DEG: 51.5157968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001700',
        LOCATION_NAME: 'Eals',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4991298,
        LOCATION_LATITUDE_DEG: 54.8984015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001800',
        LOCATION_NAME: 'Eamont Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7384616,
        LOCATION_LATITUDE_DEG: 54.6487778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA001900',
        LOCATION_NAME: 'Earby',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1440552,
        LOCATION_LATITUDE_DEG: 53.9153049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002000',
        LOCATION_NAME: 'Eardington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4097318,
        LOCATION_LATITUDE_DEG: 52.5128699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002100',
        LOCATION_NAME: 'Eardisland',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8513717,
        LOCATION_LATITUDE_DEG: 52.2200486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002200',
        LOCATION_NAME: 'Eardisley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0042302,
        LOCATION_LATITUDE_DEG: 52.1362392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002300',
        LOCATION_NAME: 'Eardiston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.940354,
        LOCATION_LATITUDE_DEG: 52.8171033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002400',
        LOCATION_NAME: 'Eardiston',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4469399,
        LOCATION_LATITUDE_DEG: 52.3118543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002500',
        LOCATION_NAME: 'Earith',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0327926,
        LOCATION_LATITUDE_DEG: 52.3534234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002600',
        LOCATION_NAME: 'Earl Shilton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3142562,
        LOCATION_LATITUDE_DEG: 52.5753572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002700',
        LOCATION_NAME: 'Earl Soham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2670926,
        LOCATION_LATITUDE_DEG: 52.2197966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002800',
        LOCATION_NAME: 'Earl Sterndale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8655551,
        LOCATION_LATITUDE_DEG: 53.2001298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA002900',
        LOCATION_NAME: 'Earl Stonham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0845438,
        LOCATION_LATITUDE_DEG: 52.186288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003100',
        LOCATION_NAME: 'Earlestown',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6459427,
        LOCATION_LATITUDE_DEG: 53.4549633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003200',
        LOCATION_NAME: 'Earley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9317931,
        LOCATION_LATITUDE_DEG: 51.4328462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003300',
        LOCATION_NAME: 'Earlham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2429654,
        LOCATION_LATITUDE_DEG: 52.6303279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003400',
        LOCATION_NAME: 'Earlish',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3636535,
        LOCATION_LATITUDE_DEG: 57.5675019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003500',
        LOCATION_NAME: 'Earls Barton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7513361,
        LOCATION_LATITUDE_DEG: 52.2647284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003600',
        LOCATION_NAME: 'Earls Colne',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7044214,
        LOCATION_LATITUDE_DEG: 51.9268768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003700',
        LOCATION_NAME: 'Earls Common',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0614723,
        LOCATION_LATITUDE_DEG: 52.2304402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042500',
        LOCATION_NAME: 'Earls Court',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1922572,
        LOCATION_LATITUDE_DEG: 51.492232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003800',
        LOCATION_NAME: 'Earls Croome',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1925282,
        LOCATION_LATITUDE_DEG: 52.081085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003000',
        LOCATION_NAME: "Earl'S Green",
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9858084,
        LOCATION_LATITUDE_DEG: 52.2597963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA003900',
        LOCATION_NAME: 'Earlsdon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5312995,
        LOCATION_LATITUDE_DEG: 52.398347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004000',
        LOCATION_NAME: 'Earlsferry',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8315816,
        LOCATION_LATITUDE_DEG: 56.1896319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042400',
        LOCATION_NAME: 'Earlsfield',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1831673,
        LOCATION_LATITUDE_DEG: 51.4440029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004100',
        LOCATION_NAME: 'Earlsheaton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6101941,
        LOCATION_LATITUDE_DEG: 53.6875689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004200',
        LOCATION_NAME: 'Earlston',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6731279,
        LOCATION_LATITUDE_DEG: 55.6385797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004300',
        LOCATION_NAME: 'Earlswood',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7891033,
        LOCATION_LATITUDE_DEG: 51.6559881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004400',
        LOCATION_NAME: 'Earlswood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8307807,
        LOCATION_LATITUDE_DEG: 52.3579484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004500',
        LOCATION_NAME: 'Earlswood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1651268,
        LOCATION_LATITUDE_DEG: 51.2162154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004600',
        LOCATION_NAME: 'Earnley',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8439293,
        LOCATION_LATITUDE_DEG: 50.7656835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004700',
        LOCATION_NAME: 'Earsary',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4237477,
        LOCATION_LATITUDE_DEG: 56.9721567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004900',
        LOCATION_NAME: 'Earsdon',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6820471,
        LOCATION_LATITUDE_DEG: 55.2388243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA004800',
        LOCATION_NAME: 'Earsdon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4941396,
        LOCATION_LATITUDE_DEG: 55.0458027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005000',
        LOCATION_NAME: 'Earshader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8330765,
        LOCATION_LATITUDE_DEG: 58.2022708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005100',
        LOCATION_NAME: 'Earsham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4205333,
        LOCATION_LATITUDE_DEG: 52.4509143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005200',
        LOCATION_NAME: 'Earswick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0531678,
        LOCATION_LATITUDE_DEG: 54.0070964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005300',
        LOCATION_NAME: 'Eartham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6652071,
        LOCATION_LATITUDE_DEG: 50.8762903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005400',
        LOCATION_NAME: 'Earthcott Green',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4996365,
        LOCATION_LATITUDE_DEG: 51.565476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005500',
        LOCATION_NAME: 'Easby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1082498,
        LOCATION_LATITUDE_DEG: 54.47004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005600',
        LOCATION_NAME: 'Easdale',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6466337,
        LOCATION_LATITUDE_DEG: 56.2942753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005700',
        LOCATION_NAME: 'Easdale Island',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6571965,
        LOCATION_LATITUDE_DEG: 56.294476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005800',
        LOCATION_NAME: 'Easebourne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7244322,
        LOCATION_LATITUDE_DEG: 50.9953024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA005900',
        LOCATION_NAME: 'Easenhall',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.316494,
        LOCATION_LATITUDE_DEG: 52.4113446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006000',
        LOCATION_NAME: 'Eashing',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6476866,
        LOCATION_LATITUDE_DEG: 51.1862201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006200',
        LOCATION_NAME: 'Easington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8057804,
        LOCATION_LATITUDE_DEG: 55.6085595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006100',
        LOCATION_NAME: 'Easington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3571863,
        LOCATION_LATITUDE_DEG: 54.7831789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006300',
        LOCATION_NAME: 'Easington',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8480897,
        LOCATION_LATITUDE_DEG: 54.5519462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006400',
        LOCATION_NAME: 'Easington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1175491,
        LOCATION_LATITUDE_DEG: 53.650042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006500',
        LOCATION_NAME: 'Easington Colliery',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3366577,
        LOCATION_LATITUDE_DEG: 54.7870769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006600',
        LOCATION_NAME: 'Easington Lane',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4338188,
        LOCATION_LATITUDE_DEG: 54.8077824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006700',
        LOCATION_NAME: 'Easington Village',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.350602,
        LOCATION_LATITUDE_DEG: 54.7835752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006800',
        LOCATION_NAME: 'Easingwold',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1917218,
        LOCATION_LATITUDE_DEG: 54.1193095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007000',
        LOCATION_NAME: 'Easneye',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.003168,
        LOCATION_LATITUDE_DEG: 51.8018695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007100',
        LOCATION_NAME: 'Eassie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0543418,
        LOCATION_LATITUDE_DEG: 56.6139747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007200',
        LOCATION_NAME: 'East Aberthaw',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3871825,
        LOCATION_LATITUDE_DEG: 51.3906726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007300',
        LOCATION_NAME: 'East Allington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7271241,
        LOCATION_LATITUDE_DEG: 50.3235739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007400',
        LOCATION_NAME: 'East Almer',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1135006,
        LOCATION_LATITUDE_DEG: 50.7925017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007500',
        LOCATION_NAME: 'East Anstey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6118323,
        LOCATION_LATITUDE_DEG: 51.0241364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007600',
        LOCATION_NAME: 'East Anton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4671462,
        LOCATION_LATITUDE_DEG: 51.2266358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007700',
        LOCATION_NAME: 'East Appleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.636879,
        LOCATION_LATITUDE_DEG: 54.3569358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007800',
        LOCATION_NAME: 'East Ardsley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5378236,
        LOCATION_LATITUDE_DEG: 53.7204729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA007900',
        LOCATION_NAME: 'East Ashling',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8336813,
        LOCATION_LATITUDE_DEG: 50.8617896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008000',
        LOCATION_NAME: 'East Ayton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4776688,
        LOCATION_LATITUDE_DEG: 54.2504105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008100',
        LOCATION_NAME: 'East Barkwith',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2454241,
        LOCATION_LATITUDE_DEG: 53.3168194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008200',
        LOCATION_NAME: 'East Barnby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7223036,
        LOCATION_LATITUDE_DEG: 54.5031422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008300',
        LOCATION_NAME: 'East Barnet',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1594874,
        LOCATION_LATITUDE_DEG: 51.6435587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008400',
        LOCATION_NAME: 'East Barsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8479695,
        LOCATION_LATITUDE_DEG: 52.866156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008500',
        LOCATION_NAME: 'East Barton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7866045,
        LOCATION_LATITUDE_DEG: 52.255001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008600',
        LOCATION_NAME: 'East Beckham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2159111,
        LOCATION_LATITUDE_DEG: 52.911762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008700',
        LOCATION_NAME: 'East Bergholt',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0184311,
        LOCATION_LATITUDE_DEG: 51.9776771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008800',
        LOCATION_NAME: 'East Bexington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6312723,
        LOCATION_LATITUDE_DEG: 50.6690999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA008900',
        LOCATION_NAME: 'East Bierley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7043423,
        LOCATION_LATITUDE_DEG: 53.7591853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009000',
        LOCATION_NAME: 'East Bilney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8981215,
        LOCATION_LATITUDE_DEG: 52.7369446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009100',
        LOCATION_NAME: 'East Blackdene',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1909372,
        LOCATION_LATITUDE_DEG: 54.7420852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009200',
        LOCATION_NAME: 'East Blatchington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.105377,
        LOCATION_LATITUDE_DEG: 50.7787706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009300',
        LOCATION_NAME: 'East Boldon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4188972,
        LOCATION_LATITUDE_DEG: 54.9474953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009400',
        LOCATION_NAME: 'East Boldre',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4680969,
        LOCATION_LATITUDE_DEG: 50.8011924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009500',
        LOCATION_NAME: 'East Bower',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9714943,
        LOCATION_LATITUDE_DEG: 51.1337401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009600',
        LOCATION_NAME: 'East Brabourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0154575,
        LOCATION_LATITUDE_DEG: 51.134989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009700',
        LOCATION_NAME: 'East Brent',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9370394,
        LOCATION_LATITUDE_DEG: 51.2625524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009800',
        LOCATION_NAME: 'East Bridgford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9666023,
        LOCATION_LATITUDE_DEG: 52.9793953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA009900',
        LOCATION_NAME: 'East Buckland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8820793,
        LOCATION_LATITUDE_DEG: 51.0662446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010000',
        LOCATION_NAME: 'East Budleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3184057,
        LOCATION_LATITUDE_DEG: 50.6534046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010100',
        LOCATION_NAME: 'East Burton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.238781,
        LOCATION_LATITUDE_DEG: 50.6814922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010200',
        LOCATION_NAME: 'East Butsfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.823078,
        LOCATION_LATITUDE_DEG: 54.8019817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010300',
        LOCATION_NAME: 'East Butterwick',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.737298,
        LOCATION_LATITUDE_DEG: 53.5401445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010400',
        LOCATION_NAME: 'East Calder',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4617232,
        LOCATION_LATITUDE_DEG: 55.8954111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010500',
        LOCATION_NAME: 'East Carleton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2120922,
        LOCATION_LATITUDE_DEG: 52.5723276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010700',
        LOCATION_NAME: 'East Carlton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6647308,
        LOCATION_LATITUDE_DEG: 53.8832914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010600',
        LOCATION_NAME: 'East Carlton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7748394,
        LOCATION_LATITUDE_DEG: 52.4952426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010800',
        LOCATION_NAME: 'East Challow',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4500252,
        LOCATION_LATITUDE_DEG: 51.589072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA010900',
        LOCATION_NAME: 'East Charleton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.735507,
        LOCATION_LATITUDE_DEG: 50.2705667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011000',
        LOCATION_NAME: 'East Chelborough',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6464678,
        LOCATION_LATITUDE_DEG: 50.8489098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011100',
        LOCATION_NAME: 'East Chilla',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1984176,
        LOCATION_LATITUDE_DEG: 50.7957269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011200',
        LOCATION_NAME: 'East Chiltington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0503193,
        LOCATION_LATITUDE_DEG: 50.9192836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011300',
        LOCATION_NAME: 'East Chinnock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7153773,
        LOCATION_LATITUDE_DEG: 50.9162206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011400',
        LOCATION_NAME: 'East Chisenbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7984618,
        LOCATION_LATITUDE_DEG: 51.2741416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011500',
        LOCATION_NAME: 'East Cholderton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5725154,
        LOCATION_LATITUDE_DEG: 51.2036324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011600',
        LOCATION_NAME: 'East Clandon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4822887,
        LOCATION_LATITUDE_DEG: 51.2526236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011700',
        LOCATION_NAME: 'East Claydon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9274522,
        LOCATION_LATITUDE_DEG: 51.9236944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011800',
        LOCATION_NAME: 'East Cluden Village',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6574386,
        LOCATION_LATITUDE_DEG: 55.0976345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA011900',
        LOCATION_NAME: 'East Clyne',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8565506,
        LOCATION_LATITUDE_DEG: 58.0327307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012000',
        LOCATION_NAME: 'East Coker',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6587078,
        LOCATION_LATITUDE_DEG: 50.9150161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012100',
        LOCATION_NAME: 'East Compton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5523975,
        LOCATION_LATITUDE_DEG: 51.1710401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012200',
        LOCATION_NAME: 'East Cornworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6214728,
        LOCATION_LATITUDE_DEG: 50.3852807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012300',
        LOCATION_NAME: 'East Cottingwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9290616,
        LOCATION_LATITUDE_DEG: 53.8735798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012400',
        LOCATION_NAME: 'East Cowes',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.276846,
        LOCATION_LATITUDE_DEG: 50.7531893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012500',
        LOCATION_NAME: 'East Cowick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.995102,
        LOCATION_LATITUDE_DEG: 53.6846621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012600',
        LOCATION_NAME: 'East Cowton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5265052,
        LOCATION_LATITUDE_DEG: 54.4240459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012700',
        LOCATION_NAME: 'East Cramlington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.559615,
        LOCATION_LATITUDE_DEG: 55.0784111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012800',
        LOCATION_NAME: 'East Cranmore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4551174,
        LOCATION_LATITUDE_DEG: 51.1924397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA012900',
        LOCATION_NAME: 'East Creech',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0955007,
        LOCATION_LATITUDE_DEG: 50.6422868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013000',
        LOCATION_NAME: 'East Curthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.036979,
        LOCATION_LATITUDE_DEG: 54.8285002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013100',
        LOCATION_NAME: 'East Dean',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6069816,
        LOCATION_LATITUDE_DEG: 51.0392148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013200',
        LOCATION_NAME: 'East Dean',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.711723,
        LOCATION_LATITUDE_DEG: 50.9096947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013300',
        LOCATION_NAME: 'East Dean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2081579,
        LOCATION_LATITUDE_DEG: 50.7563698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013400',
        LOCATION_NAME: 'East Denton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6870829,
        LOCATION_LATITUDE_DEG: 54.9896971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042100',
        LOCATION_NAME: 'East Didsbury',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2369194,
        LOCATION_LATITUDE_DEG: 53.4186373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013500',
        LOCATION_NAME: 'East Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9979046,
        LOCATION_LATITUDE_DEG: 51.1583566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013600',
        LOCATION_NAME: 'East Drayton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8366564,
        LOCATION_LATITUDE_DEG: 53.2686253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042200',
        LOCATION_NAME: 'East Dulwich',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.061973,
        LOCATION_LATITUDE_DEG: 51.4531509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013700',
        LOCATION_NAME: 'East Ella',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3955481,
        LOCATION_LATITUDE_DEG: 53.746366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013800',
        LOCATION_NAME: 'East Elrington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2082519,
        LOCATION_LATITUDE_DEG: 54.9646041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014100',
        LOCATION_NAME: 'East End',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0118877,
        LOCATION_LATITUDE_DEG: 50.7809006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA013900',
        LOCATION_NAME: 'East End',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4217194,
        LOCATION_LATITUDE_DEG: 51.8282928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014000',
        LOCATION_NAME: 'East End',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4037794,
        LOCATION_LATITUDE_DEG: 51.3487421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014200',
        LOCATION_NAME: 'East End Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1205561,
        LOCATION_LATITUDE_DEG: 51.7801707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014300',
        LOCATION_NAME: 'East Ewell',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.22949,
        LOCATION_LATITUDE_DEG: 51.3432279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014400',
        LOCATION_NAME: 'East Farleigh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4859327,
        LOCATION_LATITUDE_DEG: 51.25171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014500',
        LOCATION_NAME: 'East Farndon',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.943068,
        LOCATION_LATITUDE_DEG: 52.4593439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014600',
        LOCATION_NAME: 'East Ferry',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7699218,
        LOCATION_LATITUDE_DEG: 53.4851418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA043000',
        LOCATION_NAME: 'East Finchley',
        COUNTY_NAME: 'London',
        POSTCODE: 'N2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1615259,
        LOCATION_LATITUDE_DEG: 51.5852865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014700',
        LOCATION_NAME: 'East Firsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4860419,
        LOCATION_LATITUDE_DEG: 53.3562224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014800',
        LOCATION_NAME: 'East Fortune',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7232041,
        LOCATION_LATITUDE_DEG: 56.0050155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA014900',
        LOCATION_NAME: 'East Garston',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4773656,
        LOCATION_LATITUDE_DEG: 51.4872575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015000',
        LOCATION_NAME: 'East Gerinish',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2741544,
        LOCATION_LATITUDE_DEG: 57.3458884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015100',
        LOCATION_NAME: 'East Gills',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.543888,
        LOCATION_LATITUDE_DEG: 58.6014808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015200',
        LOCATION_NAME: 'East Goscote',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0469229,
        LOCATION_LATITUDE_DEG: 52.7134716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015300',
        LOCATION_NAME: 'East Grafton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6280797,
        LOCATION_LATITUDE_DEG: 51.3431491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015400',
        LOCATION_NAME: 'East Grimstead',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6771449,
        LOCATION_LATITUDE_DEG: 51.0501226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015500',
        LOCATION_NAME: 'East Grinstead',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.010394,
        LOCATION_LATITUDE_DEG: 51.1267036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015600',
        LOCATION_NAME: 'East Guldeford',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7567305,
        LOCATION_LATITUDE_DEG: 50.9580797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015700',
        LOCATION_NAME: 'East Haddon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0206923,
        LOCATION_LATITUDE_DEG: 52.3069319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015800',
        LOCATION_NAME: 'East Hagbourne',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2400977,
        LOCATION_LATITUDE_DEG: 51.5904635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA015900',
        LOCATION_NAME: 'East Halton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2759414,
        LOCATION_LATITUDE_DEG: 53.6607528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042800',
        LOCATION_NAME: 'East Ham',
        COUNTY_NAME: 'London',
        POSTCODE: 'E6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0590522,
        LOCATION_LATITUDE_DEG: 51.5280744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016000',
        LOCATION_NAME: 'East Hanney',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3934576,
        LOCATION_LATITUDE_DEG: 51.6339714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016100',
        LOCATION_NAME: 'East Hanningfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5606653,
        LOCATION_LATITUDE_DEG: 51.6823499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016200',
        LOCATION_NAME: 'East Hardwick',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2997125,
        LOCATION_LATITUDE_DEG: 53.660869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016300',
        LOCATION_NAME: 'East Harling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9345794,
        LOCATION_LATITUDE_DEG: 52.4364146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016400',
        LOCATION_NAME: 'East Harlsey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3505009,
        LOCATION_LATITUDE_DEG: 54.3910408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016500',
        LOCATION_NAME: 'East Harnham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8030795,
        LOCATION_LATITUDE_DEG: 51.0555198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016600',
        LOCATION_NAME: 'East Harptree',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6212199,
        LOCATION_LATITUDE_DEG: 51.300752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016700',
        LOCATION_NAME: 'East Hartford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5727324,
        LOCATION_LATITUDE_DEG: 55.1043139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016800',
        LOCATION_NAME: 'East Harting',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8592743,
        LOCATION_LATITUDE_DEG: 50.9718025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA016900',
        LOCATION_NAME: 'East Hatley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1170037,
        LOCATION_LATITUDE_DEG: 52.139302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017000',
        LOCATION_NAME: 'East Hauxwell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7455174,
        LOCATION_LATITUDE_DEG: 54.3135309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017100',
        LOCATION_NAME: 'East Heckington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2069073,
        LOCATION_LATITUDE_DEG: 52.9773852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017300',
        LOCATION_NAME: 'East Hedley Hope',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7517827,
        LOCATION_LATITUDE_DEG: 54.7604241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017400',
        LOCATION_NAME: 'East Hendred',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3362343,
        LOCATION_LATITUDE_DEG: 51.5972693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017500',
        LOCATION_NAME: 'East Herrington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4368125,
        LOCATION_LATITUDE_DEG: 54.871087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017600',
        LOCATION_NAME: 'East Heslerton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5854311,
        LOCATION_LATITUDE_DEG: 54.1782092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017700',
        LOCATION_NAME: 'East Hewish',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8608777,
        LOCATION_LATITUDE_DEG: 51.3772675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA990087',
        LOCATION_NAME: 'East Hill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1574269,
        LOCATION_LATITUDE_DEG: 51.1098575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017800',
        LOCATION_NAME: 'East Hill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2513359,
        LOCATION_LATITUDE_DEG: 50.7409108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA017900',
        LOCATION_NAME: 'East Hoathly',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1642797,
        LOCATION_LATITUDE_DEG: 50.9238847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018000',
        LOCATION_NAME: 'East Holme',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1444273,
        LOCATION_LATITUDE_DEG: 50.6706929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018100',
        LOCATION_NAME: 'East Holton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0779198,
        LOCATION_LATITUDE_DEG: 50.7192956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018200',
        LOCATION_NAME: 'East Holywell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5106257,
        LOCATION_LATITUDE_DEG: 55.0493032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018300',
        LOCATION_NAME: 'East Horndon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.35164,
        LOCATION_LATITUDE_DEG: 51.5662475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018400',
        LOCATION_NAME: 'East Horrington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5995271,
        LOCATION_LATITUDE_DEG: 51.2179498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018500',
        LOCATION_NAME: 'East Horsley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4305734,
        LOCATION_LATITUDE_DEG: 51.2730226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018600',
        LOCATION_NAME: 'East Howdon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4781773,
        LOCATION_LATITUDE_DEG: 54.9974015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018700',
        LOCATION_NAME: 'East Howle',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.540627,
        LOCATION_LATITUDE_DEG: 54.7017746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018800',
        LOCATION_NAME: 'East Huntspill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9361078,
        LOCATION_LATITUDE_DEG: 51.2011455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA018900',
        LOCATION_NAME: 'East Hyde',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3623941,
        LOCATION_LATITUDE_DEG: 51.8425754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019000',
        LOCATION_NAME: 'East Ilsley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2892655,
        LOCATION_LATITUDE_DEG: 51.5268613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019100',
        LOCATION_NAME: 'East Isle',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3744573,
        LOCATION_LATITUDE_DEG: 60.2623189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019200',
        LOCATION_NAME: 'East Keal',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0638758,
        LOCATION_LATITUDE_DEG: 53.1553976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019300',
        LOCATION_NAME: 'East Keal Bank',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0654763,
        LOCATION_LATITUDE_DEG: 53.1501008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019400',
        LOCATION_NAME: 'East Keal Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0693738,
        LOCATION_LATITUDE_DEG: 53.1537017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019500',
        LOCATION_NAME: 'East Kennett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8299168,
        LOCATION_LATITUDE_DEG: 51.4062592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019600',
        LOCATION_NAME: 'East Keswick',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4515537,
        LOCATION_LATITUDE_DEG: 53.8951902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019700',
        LOCATION_NAME: 'East Kilbride',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3367633,
        LOCATION_LATITUDE_DEG: 57.1046649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019800',
        LOCATION_NAME: 'East Kilbride',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.175195,
        LOCATION_LATITUDE_DEG: 55.7604091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA019900',
        LOCATION_NAME: 'East Kirkby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.005215,
        LOCATION_LATITUDE_DEG: 53.1403006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020000',
        LOCATION_NAME: 'East Knapton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6480283,
        LOCATION_LATITUDE_DEG: 54.1712064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020100',
        LOCATION_NAME: 'East Knighton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2630734,
        LOCATION_LATITUDE_DEG: 50.6689925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020200',
        LOCATION_NAME: 'East Knowstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.665991,
        LOCATION_LATITUDE_DEG: 50.9965384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020300',
        LOCATION_NAME: 'East Knoyle',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1673957,
        LOCATION_LATITUDE_DEG: 51.071124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020400',
        LOCATION_NAME: 'East Lambrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.81038,
        LOCATION_LATITUDE_DEG: 50.9674297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020500',
        LOCATION_NAME: 'East Langdon',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3371788,
        LOCATION_LATITUDE_DEG: 51.1660873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020600',
        LOCATION_NAME: 'East Langton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9298356,
        LOCATION_LATITUDE_DEG: 52.5254555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020700',
        LOCATION_NAME: 'East Lavant',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7709897,
        LOCATION_LATITUDE_DEG: 50.8652924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020800',
        LOCATION_NAME: 'East Lavington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6576358,
        LOCATION_LATITUDE_DEG: 50.9393948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA020900',
        LOCATION_NAME: 'East Layton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7465005,
        LOCATION_LATITUDE_DEG: 54.4835527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021000',
        LOCATION_NAME: 'East Leake',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1806027,
        LOCATION_LATITUDE_DEG: 52.8299846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021100',
        LOCATION_NAME: 'East Lexham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7536549,
        LOCATION_LATITUDE_DEG: 52.7207478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021200',
        LOCATION_NAME: 'East Lilburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9338285,
        LOCATION_LATITUDE_DEG: 55.5064572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021300',
        LOCATION_NAME: 'East Linton',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6544733,
        LOCATION_LATITUDE_DEG: 55.9865109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021400',
        LOCATION_NAME: 'East Liss',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8781313,
        LOCATION_LATITUDE_DEG: 51.0434125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021500',
        LOCATION_NAME: 'East Lockinge',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3818232,
        LOCATION_LATITUDE_DEG: 51.579866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021600',
        LOCATION_NAME: 'East Loftus',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8744426,
        LOCATION_LATITUDE_DEG: 54.5529493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021700',
        LOCATION_NAME: 'East Looe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4501827,
        LOCATION_LATITUDE_DEG: 50.3556847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021800',
        LOCATION_NAME: 'East Lulworth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.197437,
        LOCATION_LATITUDE_DEG: 50.6388849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA021900',
        LOCATION_NAME: 'East Lutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.557359,
        LOCATION_LATITUDE_DEG: 54.1143033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022000',
        LOCATION_NAME: 'East Lydford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6075837,
        LOCATION_LATITUDE_DEG: 51.0803309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022100',
        LOCATION_NAME: 'East Lyng',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9504762,
        LOCATION_LATITUDE_DEG: 51.0554365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022200',
        LOCATION_NAME: 'East Mains',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1732785,
        LOCATION_LATITUDE_DEG: 55.7655035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022300',
        LOCATION_NAME: 'East Mains Of Ingliston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3662765,
        LOCATION_LATITUDE_DEG: 55.9397159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022400',
        LOCATION_NAME: 'East Malling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4406474,
        LOCATION_LATITUDE_DEG: 51.2870139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022500',
        LOCATION_NAME: 'East Marden',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8501525,
        LOCATION_LATITUDE_DEG: 50.9247028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022600',
        LOCATION_NAME: 'East Markham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8872773,
        LOCATION_LATITUDE_DEG: 53.2498243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022700',
        LOCATION_NAME: 'East Martin',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8945978,
        LOCATION_LATITUDE_DEG: 50.9768123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022800',
        LOCATION_NAME: 'East Marton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1401343,
        LOCATION_LATITUDE_DEG: 53.9539076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA022900',
        LOCATION_NAME: 'East Melbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1599245,
        LOCATION_LATITUDE_DEG: 50.9824161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023000',
        LOCATION_NAME: 'East Meon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.030477,
        LOCATION_LATITUDE_DEG: 50.9951045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023100',
        LOCATION_NAME: 'East Mersea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9817523,
        LOCATION_LATITUDE_DEG: 51.7919519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023200',
        LOCATION_NAME: 'East Mey',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.193485,
        LOCATION_LATITUDE_DEG: 58.648481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023300',
        LOCATION_NAME: 'East Midlands Airport',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3229621,
        LOCATION_LATITUDE_DEG: 52.826989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023400',
        LOCATION_NAME: 'East Mills',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.776587,
        LOCATION_LATITUDE_DEG: 50.9266071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023500',
        LOCATION_NAME: 'East Molesey',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3475326,
        LOCATION_LATITUDE_DEG: 51.3982395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023600',
        LOCATION_NAME: 'East Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4833059,
        LOCATION_LATITUDE_DEG: 53.6884731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023700',
        LOCATION_NAME: 'East Moors',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1434187,
        LOCATION_LATITUDE_DEG: 51.4746825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023800',
        LOCATION_NAME: 'East Morden',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.120281,
        LOCATION_LATITUDE_DEG: 50.758499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA023900',
        LOCATION_NAME: 'East Morton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8528803,
        LOCATION_LATITUDE_DEG: 53.8730895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024000',
        LOCATION_NAME: 'East Ness',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9344566,
        LOCATION_LATITUDE_DEG: 54.2004098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024100',
        LOCATION_NAME: 'East Newton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0772763,
        LOCATION_LATITUDE_DEG: 53.8227675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024200',
        LOCATION_NAME: 'East Norton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8433442,
        LOCATION_LATITUDE_DEG: 52.5961591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024300',
        LOCATION_NAME: 'East Nynehead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2047926,
        LOCATION_LATITUDE_DEG: 50.9991297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024400',
        LOCATION_NAME: 'East Oakley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1690512,
        LOCATION_LATITUDE_DEG: 51.2535331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024500',
        LOCATION_NAME: 'East Ogwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.634827,
        LOCATION_LATITUDE_DEG: 50.5173894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024600',
        LOCATION_NAME: 'East Orchard',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2378917,
        LOCATION_LATITUDE_DEG: 50.9586219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024700',
        LOCATION_NAME: 'East Ord',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0290352,
        LOCATION_LATITUDE_DEG: 55.7577821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024800',
        LOCATION_NAME: 'East Parley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8485993,
        LOCATION_LATITUDE_DEG: 50.7661973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA024900',
        LOCATION_NAME: 'East Peckham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3878486,
        LOCATION_LATITUDE_DEG: 51.2118111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025000',
        LOCATION_NAME: 'East Pennard',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5711445,
        LOCATION_LATITUDE_DEG: 51.1345368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025100',
        LOCATION_NAME: 'East Portholland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8608878,
        LOCATION_LATITUDE_DEG: 50.236274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025200',
        LOCATION_NAME: 'East Portlemouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7563499,
        LOCATION_LATITUDE_DEG: 50.2343537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025300',
        LOCATION_NAME: 'East Prawle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7090152,
        LOCATION_LATITUDE_DEG: 50.2142628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025400',
        LOCATION_NAME: 'East Preston',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4886125,
        LOCATION_LATITUDE_DEG: 50.8127789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025500',
        LOCATION_NAME: 'East Putford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3226587,
        LOCATION_LATITUDE_DEG: 50.9232419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025600',
        LOCATION_NAME: 'East Quantoxhead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2345098,
        LOCATION_LATITUDE_DEG: 51.1825492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025700',
        LOCATION_NAME: 'East Rainton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4785051,
        LOCATION_LATITUDE_DEG: 54.8248793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025800',
        LOCATION_NAME: 'East Ravendale',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1352691,
        LOCATION_LATITUDE_DEG: 53.4790358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA025900',
        LOCATION_NAME: 'East Raynham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8004854,
        LOCATION_LATITUDE_DEG: 52.7920566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026000',
        LOCATION_NAME: 'East Retford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.941008,
        LOCATION_LATITUDE_DEG: 53.3229277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026100',
        LOCATION_NAME: 'East Rigton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.442507,
        LOCATION_LATITUDE_DEG: 53.8899619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026200',
        LOCATION_NAME: 'East Rolstone',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8619058,
        LOCATION_LATITUDE_DEG: 51.351666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026300',
        LOCATION_NAME: 'East Rounton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.348999,
        LOCATION_LATITUDE_DEG: 54.4236422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026400',
        LOCATION_NAME: 'East Rudham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7128838,
        LOCATION_LATITUDE_DEG: 52.8204612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026500',
        LOCATION_NAME: 'East Runton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2725118,
        LOCATION_LATITUDE_DEG: 52.935462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026600',
        LOCATION_NAME: 'East Ruston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4775858,
        LOCATION_LATITUDE_DEG: 52.7964434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026700',
        LOCATION_NAME: 'East Saltoun',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8394654,
        LOCATION_LATITUDE_DEG: 55.9007043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026800',
        LOCATION_NAME: 'East Sands',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7775903,
        LOCATION_LATITUDE_DEG: 56.3326489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA026900',
        LOCATION_NAME: 'East Scrafton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8643047,
        LOCATION_LATITUDE_DEG: 54.2571327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042300',
        LOCATION_NAME: 'East Sheen',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2638491,
        LOCATION_LATITUDE_DEG: 51.4667382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027000',
        LOCATION_NAME: 'East Shefford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4406468,
        LOCATION_LATITUDE_DEG: 51.4686533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027100',
        LOCATION_NAME: 'East Sleekburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5482793,
        LOCATION_LATITUDE_DEG: 55.1446139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027200',
        LOCATION_NAME: 'East Somerton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6743835,
        LOCATION_LATITUDE_DEG: 52.7181365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027300',
        LOCATION_NAME: 'East Stockwith',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8077671,
        LOCATION_LATITUDE_DEG: 53.4411414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027500',
        LOCATION_NAME: 'East Stoke',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7357794,
        LOCATION_LATITUDE_DEG: 50.9550268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027600',
        LOCATION_NAME: 'East Stoke',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1819361,
        LOCATION_LATITUDE_DEG: 50.682791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027400',
        LOCATION_NAME: 'East Stoke',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.875734,
        LOCATION_LATITUDE_DEG: 53.0386015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027700',
        LOCATION_NAME: 'East Stour',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2861071,
        LOCATION_LATITUDE_DEG: 51.0048204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027800',
        LOCATION_NAME: 'East Stowell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7945801,
        LOCATION_LATITUDE_DEG: 51.3568506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042700',
        LOCATION_NAME: 'East Strand',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1284028,
        LOCATION_LATITUDE_DEG: 51.5081021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA027900',
        LOCATION_NAME: 'East Stratton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2252069,
        LOCATION_LATITUDE_DEG: 51.1567294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028000',
        LOCATION_NAME: 'East Studdal',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3208,
        LOCATION_LATITUDE_DEG: 51.1983915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028100',
        LOCATION_NAME: 'East Sutton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6236548,
        LOCATION_LATITUDE_DEG: 51.2108067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028200',
        LOCATION_NAME: 'East Tanfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5551665,
        LOCATION_LATITUDE_DEG: 54.1954198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028300',
        LOCATION_NAME: 'East Taphouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5610031,
        LOCATION_LATITUDE_DEG: 50.4418962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028400',
        LOCATION_NAME: 'East Tarbert',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7926386,
        LOCATION_LATITUDE_DEG: 57.9004395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041800',
        LOCATION_NAME: 'East The Water',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2357647,
        LOCATION_LATITUDE_DEG: 53.3540388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028500',
        LOCATION_NAME: 'East Thirston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6920303,
        LOCATION_LATITUDE_DEG: 55.292232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028600',
        LOCATION_NAME: 'East Tilbury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4183749,
        LOCATION_LATITUDE_DEG: 51.4803353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028700',
        LOCATION_NAME: 'East Tisted',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9995777,
        LOCATION_LATITUDE_DEG: 51.0846171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028800',
        LOCATION_NAME: 'East Torrington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2775209,
        LOCATION_LATITUDE_DEG: 53.333318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA028900',
        LOCATION_NAME: 'East Town',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4697522,
        LOCATION_LATITUDE_DEG: 50.6408006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029000',
        LOCATION_NAME: 'East Tuddenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0817402,
        LOCATION_LATITUDE_DEG: 52.6600348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029100',
        LOCATION_NAME: 'East Tytherley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5806983,
        LOCATION_LATITUDE_DEG: 51.0606173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029200',
        LOCATION_NAME: 'East Tytherton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.052226,
        LOCATION_LATITUDE_DEG: 51.4723677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029300',
        LOCATION_NAME: 'East Village',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6451526,
        LOCATION_LATITUDE_DEG: 50.833122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029400',
        LOCATION_NAME: 'East Wall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.695662,
        LOCATION_LATITUDE_DEG: 52.5343721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029500',
        LOCATION_NAME: 'East Wallhouses',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9202631,
        LOCATION_LATITUDE_DEG: 55.0091083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029600',
        LOCATION_NAME: 'East Walton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5824913,
        LOCATION_LATITUDE_DEG: 52.7186479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029700',
        LOCATION_NAME: 'East Wellow',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5680517,
        LOCATION_LATITUDE_DEG: 50.9826084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029800',
        LOCATION_NAME: 'East Wemyss',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0678465,
        LOCATION_LATITUDE_DEG: 56.1582352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA029900',
        LOCATION_NAME: 'East Whitburn',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6600868,
        LOCATION_LATITUDE_DEG: 55.8688102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030000',
        LOCATION_NAME: 'East Williamston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.755496,
        LOCATION_LATITUDE_DEG: 51.7114163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030100',
        LOCATION_NAME: 'East Winch',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.514111,
        LOCATION_LATITUDE_DEG: 52.7201543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030200',
        LOCATION_NAME: 'East Winterslow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6501935,
        LOCATION_LATITUDE_DEG: 51.103024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030300',
        LOCATION_NAME: 'East Wittering',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8733009,
        LOCATION_LATITUDE_DEG: 50.7691818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030400',
        LOCATION_NAME: 'East Witton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7779138,
        LOCATION_LATITUDE_DEG: 54.2696331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030500',
        LOCATION_NAME: 'East Woodburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1444218,
        LOCATION_LATITUDE_DEG: 55.1763255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030600',
        LOCATION_NAME: 'East Woodhay',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4149628,
        LOCATION_LATITUDE_DEG: 51.3501474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030700',
        LOCATION_NAME: 'East Woodlands',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2918215,
        LOCATION_LATITUDE_DEG: 51.1974394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030800',
        LOCATION_NAME: 'East Woodside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0639137,
        LOCATION_LATITUDE_DEG: 54.8309006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA030900',
        LOCATION_NAME: 'East Woodyates',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9629069,
        LOCATION_LATITUDE_DEG: 50.97412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031000',
        LOCATION_NAME: 'East Worldham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9299307,
        LOCATION_LATITUDE_DEG: 51.1363151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031100',
        LOCATION_NAME: 'East Worlington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7391182,
        LOCATION_LATITUDE_DEG: 50.9102345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031200',
        LOCATION_NAME: 'East Yell',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.037301,
        LOCATION_LATITUDE_DEG: 60.5505422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031400',
        LOCATION_NAME: 'Eastacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0192997,
        LOCATION_LATITUDE_DEG: 50.9861433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031500',
        LOCATION_NAME: 'Eastborough',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.617582,
        LOCATION_LATITUDE_DEG: 53.6911705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031600',
        LOCATION_NAME: 'Eastbourne',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2867551,
        LOCATION_LATITUDE_DEG: 50.768464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031700',
        LOCATION_NAME: 'Eastbridge',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5926928,
        LOCATION_LATITUDE_DEG: 52.2351876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031900',
        LOCATION_NAME: 'Eastburn',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9704121,
        LOCATION_LATITUDE_DEG: 53.8983988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031800',
        LOCATION_NAME: 'Eastburn',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4862588,
        LOCATION_LATITUDE_DEG: 53.9881868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032000',
        LOCATION_NAME: 'Eastbury',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4976502,
        LOCATION_LATITUDE_DEG: 51.4908623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032100',
        LOCATION_NAME: 'Eastby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9717382,
        LOCATION_LATITUDE_DEG: 53.9857073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042900',
        LOCATION_NAME: 'Eastcheap',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0923107,
        LOCATION_LATITUDE_DEG: 51.5144006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032200',
        LOCATION_NAME: 'Eastchurch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8592978,
        LOCATION_LATITUDE_DEG: 51.406317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032300',
        LOCATION_NAME: 'Eastcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1562544,
        LOCATION_LATITUDE_DEG: 51.7355893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032500',
        LOCATION_NAME: 'Eastcote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0055136,
        LOCATION_LATITUDE_DEG: 52.1803188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032400',
        LOCATION_NAME: 'Eastcote',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3965766,
        LOCATION_LATITUDE_DEG: 51.5767547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032600',
        LOCATION_NAME: 'Eastcott',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4873276,
        LOCATION_LATITUDE_DEG: 50.915135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032700',
        LOCATION_NAME: 'Eastcott',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.959976,
        LOCATION_LATITUDE_DEG: 51.3007471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032800',
        LOCATION_NAME: 'Eastcourt',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0338267,
        LOCATION_LATITUDE_DEG: 51.6318821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA032900',
        LOCATION_NAME: 'Eastdown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6522949,
        LOCATION_LATITUDE_DEG: 50.3325771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033000',
        LOCATION_NAME: 'Easter Balgedie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3357612,
        LOCATION_LATITUDE_DEG: 56.2166386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033100',
        LOCATION_NAME: 'Easter Compton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6195595,
        LOCATION_LATITUDE_DEG: 51.5403815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033200',
        LOCATION_NAME: 'Easter Howgate',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2127034,
        LOCATION_LATITUDE_DEG: 55.8643077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033300',
        LOCATION_NAME: 'Easter Kinkell',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3809397,
        LOCATION_LATITUDE_DEG: 57.5664879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033400',
        LOCATION_NAME: 'Eastergate',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6510933,
        LOCATION_LATITUDE_DEG: 50.8387849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA043400',
        LOCATION_NAME: 'Easterhouse',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1221903,
        LOCATION_LATITUDE_DEG: 55.8697708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033500',
        LOCATION_NAME: 'Eastern Docks',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3956453,
        LOCATION_LATITUDE_DEG: 50.8947059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033700',
        LOCATION_NAME: 'Eastern Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5325608,
        LOCATION_LATITUDE_DEG: 50.124571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033600',
        LOCATION_NAME: 'Eastern Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5956169,
        LOCATION_LATITUDE_DEG: 52.413348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033800',
        LOCATION_NAME: 'Easterton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9695338,
        LOCATION_LATITUDE_DEG: 51.2952464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA033900',
        LOCATION_NAME: 'Eastertown',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9396282,
        LOCATION_LATITUDE_DEG: 51.2826583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034000',
        LOCATION_NAME: 'Eastfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4112372,
        LOCATION_LATITUDE_DEG: 54.2402131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034100',
        LOCATION_NAME: 'Eastfield Hall',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6463213,
        LOCATION_LATITUDE_DEG: 55.3530387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034200',
        LOCATION_NAME: 'Eastgate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0734818,
        LOCATION_LATITUDE_DEG: 54.7435794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA990377',
        LOCATION_NAME: 'Eastham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034400',
        LOCATION_NAME: 'Easthampnett',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7003701,
        LOCATION_LATITUDE_DEG: 50.8524934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034500',
        LOCATION_NAME: 'Easthampstead',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7556359,
        LOCATION_LATITUDE_DEG: 51.4025464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034600',
        LOCATION_NAME: 'Easthampton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8695371,
        LOCATION_LATITUDE_DEG: 52.2618531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034700',
        LOCATION_NAME: 'Easthaven',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6774419,
        LOCATION_LATITUDE_DEG: 56.5146246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034800',
        LOCATION_NAME: 'Easthope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6393257,
        LOCATION_LATITUDE_DEG: 52.5527797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA034900',
        LOCATION_NAME: 'Easthope Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6600212,
        LOCATION_LATITUDE_DEG: 52.5606772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035000',
        LOCATION_NAME: 'Easthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7931595,
        LOCATION_LATITUDE_DEG: 52.9390915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035100',
        LOCATION_NAME: 'Easthorpe',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7778092,
        LOCATION_LATITUDE_DEG: 51.858662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035200',
        LOCATION_NAME: 'Easthouses',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0479364,
        LOCATION_LATITUDE_DEG: 55.8801004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035300',
        LOCATION_NAME: 'Eastington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.325675,
        LOCATION_LATITUDE_DEG: 51.7457988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035400',
        LOCATION_NAME: 'Eastington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8147012,
        LOCATION_LATITUDE_DEG: 51.8149923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035500',
        LOCATION_NAME: 'Eastleach',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6985591,
        LOCATION_LATITUDE_DEG: 51.7328877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035600',
        LOCATION_NAME: 'Eastleach Turville',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7130512,
        LOCATION_LATITUDE_DEG: 51.7449915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035700',
        LOCATION_NAME: 'Eastleaze',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8254661,
        LOCATION_LATITUDE_DEG: 51.5629746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035800',
        LOCATION_NAME: 'Eastleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1572652,
        LOCATION_LATITUDE_DEG: 51.0296474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA035900',
        LOCATION_NAME: 'Eastleigh',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3494617,
        LOCATION_LATITUDE_DEG: 50.9667925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036000',
        LOCATION_NAME: 'Eastling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8142088,
        LOCATION_LATITUDE_DEG: 51.2739125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036200',
        LOCATION_NAME: 'Eastmoor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5377334,
        LOCATION_LATITUDE_DEG: 53.2379299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036100',
        LOCATION_NAME: 'Eastmoor',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5586114,
        LOCATION_LATITUDE_DEG: 52.5970396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036300',
        LOCATION_NAME: 'Eastney',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.054127,
        LOCATION_LATITUDE_DEG: 50.790485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036400',
        LOCATION_NAME: 'Eastnor',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3909049,
        LOCATION_LATITUDE_DEG: 52.0321198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036500',
        LOCATION_NAME: 'Eastoft',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7832996,
        LOCATION_LATITUDE_DEG: 53.6358607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037000',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8910103,
        LOCATION_LATITUDE_DEG: 55.0383174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036900',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6974026,
        LOCATION_LATITUDE_DEG: 51.2254472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037500',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5637408,
        LOCATION_LATITUDE_DEG: 51.4636683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037200',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1578561,
        LOCATION_LATITUDE_DEG: 51.4339646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037100',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3995078,
        LOCATION_LATITUDE_DEG: 51.4469573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036800',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2703387,
        LOCATION_LATITUDE_DEG: 51.0852176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036600',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6189894,
        LOCATION_LATITUDE_DEG: 52.8301739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA036700',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3282554,
        LOCATION_LATITUDE_DEG: 52.3301294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037300',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2325305,
        LOCATION_LATITUDE_DEG: 54.1003964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037400',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1495156,
        LOCATION_LATITUDE_DEG: 52.6538351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037600',
        LOCATION_NAME: 'Easton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3394106,
        LOCATION_LATITUDE_DEG: 52.178785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037700',
        LOCATION_NAME: 'Easton Bavents',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6842922,
        LOCATION_LATITUDE_DEG: 52.340897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037800',
        LOCATION_NAME: 'Easton Grey',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1715676,
        LOCATION_LATITUDE_DEG: 51.5875732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041700',
        LOCATION_NAME: 'Easton in Gordano',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA037900',
        LOCATION_NAME: 'Easton Maudit',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6992136,
        LOCATION_LATITUDE_DEG: 52.2199163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038000',
        LOCATION_NAME: 'Easton Neston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.975083,
        LOCATION_LATITUDE_DEG: 52.1360163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038200',
        LOCATION_NAME: 'Easton on the Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.500649,
        LOCATION_LATITUDE_DEG: 52.6253603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038100',
        LOCATION_NAME: 'Easton Royal',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7014205,
        LOCATION_LATITUDE_DEG: 51.3481521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038300',
        LOCATION_NAME: 'Easton-in-Gordano',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6985463,
        LOCATION_LATITUDE_DEG: 51.4755775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA043300',
        LOCATION_NAME: 'Eastpark',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2821759,
        LOCATION_LATITUDE_DEG: 55.8866014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038400',
        LOCATION_NAME: 'Eastrea',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0909162,
        LOCATION_LATITUDE_DEG: 52.5570414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038500',
        LOCATION_NAME: 'Eastriggs',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1791081,
        LOCATION_LATITUDE_DEG: 54.9849154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038600',
        LOCATION_NAME: 'Eastrington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7925117,
        LOCATION_LATITUDE_DEG: 53.7591676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038700',
        LOCATION_NAME: 'Eastry',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3095894,
        LOCATION_LATITUDE_DEG: 51.2464971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA031300',
        LOCATION_NAME: 'East-The-Water',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1992466,
        LOCATION_LATITUDE_DEG: 51.0143473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038800',
        LOCATION_NAME: 'Eastville',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5570441,
        LOCATION_LATITUDE_DEG: 51.4717667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA038900',
        LOCATION_NAME: 'Eastville',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0939257,
        LOCATION_LATITUDE_DEG: 53.090789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039000',
        LOCATION_NAME: 'Eastwell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8484785,
        LOCATION_LATITUDE_DEG: 52.8492822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039100',
        LOCATION_NAME: 'Eastwick',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9219266,
        LOCATION_LATITUDE_DEG: 52.9343161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039200',
        LOCATION_NAME: 'Eastwick',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0800636,
        LOCATION_LATITUDE_DEG: 51.7857667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039500',
        LOCATION_NAME: 'Eastwood',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5288212,
        LOCATION_LATITUDE_DEG: 52.0559222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039400',
        LOCATION_NAME: 'Eastwood',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3068444,
        LOCATION_LATITUDE_DEG: 53.0178005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039300',
        LOCATION_NAME: 'Eastwood',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6640116,
        LOCATION_LATITUDE_DEG: 51.5653428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039600',
        LOCATION_NAME: 'Eastworth',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4935144,
        LOCATION_LATITUDE_DEG: 51.3852333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039700',
        LOCATION_NAME: 'Eathorpe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.42254,
        LOCATION_LATITUDE_DEG: 52.3185354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039800',
        LOCATION_NAME: 'Eaton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7373651,
        LOCATION_LATITUDE_DEG: 52.5056717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040300',
        LOCATION_NAME: 'Eaton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6374506,
        LOCATION_LATITUDE_DEG: 53.1659385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA039900',
        LOCATION_NAME: 'Eaton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1946747,
        LOCATION_LATITUDE_DEG: 53.1867325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040000',
        LOCATION_NAME: 'Eaton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3475319,
        LOCATION_LATITUDE_DEG: 51.724683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040100',
        LOCATION_NAME: 'Eaton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9328976,
        LOCATION_LATITUDE_DEG: 53.2941228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040350',
        LOCATION_NAME: 'Eaton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8186972,
        LOCATION_LATITUDE_DEG: 52.8521724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040200',
        LOCATION_NAME: 'Eaton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2697846,
        LOCATION_LATITUDE_DEG: 52.6143261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040400',
        LOCATION_NAME: 'Eaton Bishop',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8105469,
        LOCATION_LATITUDE_DEG: 52.0473257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040500',
        LOCATION_NAME: 'Eaton Bray',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5900261,
        LOCATION_LATITUDE_DEG: 51.8764861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040600',
        LOCATION_NAME: 'Eaton Constantine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.595662,
        LOCATION_LATITUDE_DEG: 52.6516831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040700',
        LOCATION_NAME: 'Eaton Ford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2830415,
        LOCATION_LATITUDE_DEG: 52.2294142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040800',
        LOCATION_NAME: 'Eaton Hall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8753974,
        LOCATION_LATITUDE_DEG: 53.1442353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA040900',
        LOCATION_NAME: 'Eaton Hastings',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.620361,
        LOCATION_LATITUDE_DEG: 51.6804792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041000',
        LOCATION_NAME: 'Eaton Mascott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6847669,
        LOCATION_LATITUDE_DEG: 52.6480819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041900',
        LOCATION_NAME: 'Eaton on Tern',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041100',
        LOCATION_NAME: 'Eaton Socon',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2870737,
        LOCATION_LATITUDE_DEG: 52.2190146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA042000',
        LOCATION_NAME: 'Eaton under Heywood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041200',
        LOCATION_NAME: 'Eaton-on-Tern',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5159225,
        LOCATION_LATITUDE_DEG: 52.7975721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041300',
        LOCATION_NAME: 'Eaton-under-Heywood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7412274,
        LOCATION_LATITUDE_DEG: 52.5057734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041400',
        LOCATION_NAME: 'Eau Withington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6629349,
        LOCATION_LATITUDE_DEG: 52.0820307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041500',
        LOCATION_NAME: 'Eaves',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7491904,
        LOCATION_LATITUDE_DEG: 53.8247001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA041600',
        LOCATION_NAME: 'Eavestone',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6607465,
        LOCATION_LATITUDE_DEG: 54.1101116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000100',
        LOCATION_NAME: 'Ebberley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0411049,
        LOCATION_LATITUDE_DEG: 50.9527364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000200',
        LOCATION_NAME: 'Ebberston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6218216,
        LOCATION_LATITUDE_DEG: 54.231308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000300',
        LOCATION_NAME: 'Ebbesbourne Wake',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0108356,
        LOCATION_LATITUDE_DEG: 51.0157193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000400',
        LOCATION_NAME: 'Ebbsfleet',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3509225,
        LOCATION_LATITUDE_DEG: 51.3114059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000500',
        LOCATION_NAME: 'Ebbw Vale',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2043132,
        LOCATION_LATITUDE_DEG: 51.7811038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000600',
        LOCATION_NAME: 'Ebchester',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8387675,
        LOCATION_LATITUDE_DEG: 54.8938913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000700',
        LOCATION_NAME: 'Ebernoe',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6147771,
        LOCATION_LATITUDE_DEG: 51.0403087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000800',
        LOCATION_NAME: 'Ebford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4429316,
        LOCATION_LATITUDE_DEG: 50.6818083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB000900',
        LOCATION_NAME: 'Ebley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2513048,
        LOCATION_LATITUDE_DEG: 51.7407928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB001000',
        LOCATION_NAME: 'Ebnal',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7514607,
        LOCATION_LATITUDE_DEG: 53.0322266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB001100',
        LOCATION_NAME: 'Ebnall',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7709752,
        LOCATION_LATITUDE_DEG: 52.2255466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB001150',
        LOCATION_NAME: 'Ebost',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4507655,
        LOCATION_LATITUDE_DEG: 57.3511832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EB001200',
        LOCATION_NAME: 'Ebrington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.730262,
        LOCATION_LATITUDE_DEG: 52.057816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000100',
        LOCATION_NAME: 'Ecchinswell',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2824886,
        LOCATION_LATITUDE_DEG: 51.3331428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000200',
        LOCATION_NAME: 'Ecclefechan',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2653398,
        LOCATION_LATITUDE_DEG: 55.0580286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000400',
        LOCATION_NAME: 'Eccles',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3738842,
        LOCATION_LATITUDE_DEG: 55.6671748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000300',
        LOCATION_NAME: 'Eccles',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.335267,
        LOCATION_LATITUDE_DEG: 53.4826593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000500',
        LOCATION_NAME: 'Eccles',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4816441,
        LOCATION_LATITUDE_DEG: 51.3184155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000600',
        LOCATION_NAME: 'Eccles',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9715579,
        LOCATION_LATITUDE_DEG: 52.4737246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC002300',
        LOCATION_NAME: 'Eccles on Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5654597,
        LOCATION_LATITUDE_DEG: 52.8091964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC002400',
        LOCATION_NAME: 'Ecclesall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5078709,
        LOCATION_LATITUDE_DEG: 53.3669407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000800',
        LOCATION_NAME: 'Ecclesfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4682841,
        LOCATION_LATITUDE_DEG: 53.442743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000900',
        LOCATION_NAME: 'Eccleshall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2498996,
        LOCATION_LATITUDE_DEG: 52.8585049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001000',
        LOCATION_NAME: 'Eccleshill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4470639,
        LOCATION_LATITUDE_DEG: 53.7102825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001100',
        LOCATION_NAME: 'Eccleshill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7398453,
        LOCATION_LATITUDE_DEG: 53.8195841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001200',
        LOCATION_NAME: 'Ecclesmachan',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5076457,
        LOCATION_LATITUDE_DEG: 55.947018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC000700',
        LOCATION_NAME: 'Eccles-on-Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5692543,
        LOCATION_LATITUDE_DEG: 52.8060508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001300',
        LOCATION_NAME: 'Eccleston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8797119,
        LOCATION_LATITUDE_DEG: 53.1563404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001400',
        LOCATION_NAME: 'Eccleston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7766564,
        LOCATION_LATITUDE_DEG: 53.4555606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001500',
        LOCATION_NAME: 'Eccleston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7255647,
        LOCATION_LATITUDE_DEG: 53.6477827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001600',
        LOCATION_NAME: 'Eccleston Lane Ends',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7903055,
        LOCATION_LATITUDE_DEG: 53.4362599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001700',
        LOCATION_NAME: 'Eccleston Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7799154,
        LOCATION_LATITUDE_DEG: 53.4295589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001800',
        LOCATION_NAME: 'Eccliffe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.285232,
        LOCATION_LATITUDE_DEG: 51.0248236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC002500',
        LOCATION_NAME: 'Eccup',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5652131,
        LOCATION_LATITUDE_DEG: 53.8772732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC001900',
        LOCATION_NAME: 'Echt',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4317232,
        LOCATION_LATITUDE_DEG: 57.1415199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC002000',
        LOCATION_NAME: 'Eckington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.114176,
        LOCATION_LATITUDE_DEG: 52.0715209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC002100',
        LOCATION_NAME: 'Eckington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3714508,
        LOCATION_LATITUDE_DEG: 53.3050344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EC002200',
        LOCATION_NAME: 'Ecton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7874123,
        LOCATION_LATITUDE_DEG: 52.2649246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000100',
        LOCATION_NAME: 'Edale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8138513,
        LOCATION_LATITUDE_DEG: 53.3639444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000200',
        LOCATION_NAME: 'Eday',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7847394,
        LOCATION_LATITUDE_DEG: 59.1819268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000300',
        LOCATION_NAME: 'Edburton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2451475,
        LOCATION_LATITUDE_DEG: 50.8882867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000400',
        LOCATION_NAME: 'Edderside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3978903,
        LOCATION_LATITUDE_DEG: 54.7961986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000500',
        LOCATION_NAME: 'Edderton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1743457,
        LOCATION_LATITUDE_DEG: 57.8343149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000600',
        LOCATION_NAME: 'Eddington',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5067492,
        LOCATION_LATITUDE_DEG: 51.4205514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000700',
        LOCATION_NAME: 'Eddis Bridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9376743,
        LOCATION_LATITUDE_DEG: 54.8535928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000800',
        LOCATION_NAME: 'Eddleston',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2050927,
        LOCATION_LATITUDE_DEG: 55.7117868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001000',
        LOCATION_NAME: 'Edenbridge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.06784,
        LOCATION_LATITUDE_DEG: 51.1924073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001200',
        LOCATION_NAME: 'Edenfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.30297,
        LOCATION_LATITUDE_DEG: 53.6685831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001300',
        LOCATION_NAME: 'Edenhall',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6738199,
        LOCATION_LATITUDE_DEG: 54.6847827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001400',
        LOCATION_NAME: 'Edenham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4263728,
        LOCATION_LATITUDE_DEG: 52.7836735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001600',
        LOCATION_NAME: 'Edenside',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8687048,
        LOCATION_LATITUDE_DEG: 56.3589467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001700',
        LOCATION_NAME: 'Edensor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6239056,
        LOCATION_LATITUDE_DEG: 53.226627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001800',
        LOCATION_NAME: 'Edenthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0661231,
        LOCATION_LATITUDE_DEG: 53.5525499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002000',
        LOCATION_NAME: 'Edentown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1414457,
        LOCATION_LATITUDE_DEG: 56.2774431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001900',
        LOCATION_NAME: 'Edentown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9462939,
        LOCATION_LATITUDE_DEG: 54.9071115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002100',
        LOCATION_NAME: 'Edergoole',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3049811,
        LOCATION_LATITUDE_DEG: 54.5548037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002200',
        LOCATION_NAME: 'Edern',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5612615,
        LOCATION_LATITUDE_DEG: 52.9254329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002250',
        LOCATION_NAME: 'Ederney',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6538066,
        LOCATION_LATITUDE_DEG: 54.5348345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002300',
        LOCATION_NAME: 'Edford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4725365,
        LOCATION_LATITUDE_DEG: 51.2387476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002400',
        LOCATION_NAME: 'Edgarley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6828682,
        LOCATION_LATITUDE_DEG: 51.1394417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009700',
        LOCATION_NAME: 'Edgbaston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9318826,
        LOCATION_LATITUDE_DEG: 52.4673009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002500',
        LOCATION_NAME: 'Edgcote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2730181,
        LOCATION_LATITUDE_DEG: 52.125416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002600',
        LOCATION_NAME: 'Edgcott',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.015512,
        LOCATION_LATITUDE_DEG: 51.8958957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002700',
        LOCATION_NAME: 'Edgcumbe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1931178,
        LOCATION_LATITUDE_DEG: 50.1524687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002800',
        LOCATION_NAME: 'Edge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8873927,
        LOCATION_LATITUDE_DEG: 52.6735939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002900',
        LOCATION_NAME: 'Edge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2175086,
        LOCATION_LATITUDE_DEG: 51.7852004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003000',
        LOCATION_NAME: 'Edge End',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5896208,
        LOCATION_LATITUDE_DEG: 51.8154047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003100',
        LOCATION_NAME: 'Edge Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7639148,
        LOCATION_LATITUDE_DEG: 53.0542277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009500',
        LOCATION_NAME: 'Edge Hill',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9518056,
        LOCATION_LATITUDE_DEG: 53.4075371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003200',
        LOCATION_NAME: 'Edgebold',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8015227,
        LOCATION_LATITUDE_DEG: 52.6756892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003300',
        LOCATION_NAME: 'Edgebolton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.631325,
        LOCATION_LATITUDE_DEG: 52.7934989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003400',
        LOCATION_NAME: 'Edgefield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1164325,
        LOCATION_LATITUDE_DEG: 52.8665585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003500',
        LOCATION_NAME: 'Edgehill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4717109,
        LOCATION_LATITUDE_DEG: 52.1134176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED990891',
        LOCATION_NAME: 'Edgeley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003600',
        LOCATION_NAME: 'Edgeley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6581016,
        LOCATION_LATITUDE_DEG: 52.955813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003700',
        LOCATION_NAME: 'Edgerley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9689782,
        LOCATION_LATITUDE_DEG: 52.7655981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003800',
        LOCATION_NAME: 'Edgerton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.801249,
        LOCATION_LATITUDE_DEG: 53.655776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED003900',
        LOCATION_NAME: 'Edgeworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0798631,
        LOCATION_LATITUDE_DEG: 51.7549902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004100',
        LOCATION_NAME: 'Edgmond',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4083507,
        LOCATION_LATITUDE_DEG: 52.7735905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004200',
        LOCATION_NAME: 'Edgton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9025364,
        LOCATION_LATITUDE_DEG: 52.4664671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004300',
        LOCATION_NAME: 'Edgware',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.277672,
        LOCATION_LATITUDE_DEG: 51.6103593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004400',
        LOCATION_NAME: 'Edinbane',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4276267,
        LOCATION_LATITUDE_DEG: 57.4718951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004500',
        LOCATION_NAME: 'Edinburgh Airport',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3446639,
        LOCATION_LATITUDE_DEG: 55.9509175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004600',
        LOCATION_NAME: 'Edinburgh EH 1',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1925758,
        LOCATION_LATITUDE_DEG: 55.9511083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004700',
        LOCATION_NAME: 'Edinburgh EH 2',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2003994,
        LOCATION_LATITUDE_DEG: 55.9523893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004800',
        LOCATION_NAME: 'Edinburgh EH 3',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2043939,
        LOCATION_LATITUDE_DEG: 55.9556843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004900',
        LOCATION_NAME: 'Edinburgh EH 4',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2744512,
        LOCATION_LATITUDE_DEG: 55.9651976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005000',
        LOCATION_NAME: 'Edinburgh EH 5',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.225562,
        LOCATION_LATITUDE_DEG: 55.9767109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005100',
        LOCATION_NAME: 'Edinburgh EH 6',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1709967,
        LOCATION_LATITUDE_DEG: 55.9732333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005200',
        LOCATION_NAME: 'Edinburgh EH 7',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1606191,
        LOCATION_LATITUDE_DEG: 55.9611548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005300',
        LOCATION_NAME: 'Edinburgh EH 8',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1595809,
        LOCATION_LATITUDE_DEG: 55.9494731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005400',
        LOCATION_NAME: 'Edinburgh EH 9',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1856239,
        LOCATION_LATITUDE_DEG: 55.9316925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005500',
        LOCATION_NAME: 'Edinburgh EH10',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2096766,
        LOCATION_LATITUDE_DEG: 55.9026566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005600',
        LOCATION_NAME: 'Edinburgh EH11',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2597034,
        LOCATION_LATITUDE_DEG: 55.9343992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005700',
        LOCATION_NAME: 'Edinburgh EH12',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3110488,
        LOCATION_LATITUDE_DEG: 55.9425087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005800',
        LOCATION_NAME: 'Edinburgh EH13',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2555019,
        LOCATION_LATITUDE_DEG: 55.8965543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED005900',
        LOCATION_NAME: 'Edinburgh EH14',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3334774,
        LOCATION_LATITUDE_DEG: 55.8770689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006000',
        LOCATION_NAME: 'Edinburgh EH15',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1152771,
        LOCATION_LATITUDE_DEG: 55.9437533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006100',
        LOCATION_NAME: 'Edinburgh EH16',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1477223,
        LOCATION_LATITUDE_DEG: 55.9243321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006200',
        LOCATION_NAME: 'Edinburgh EH17',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1395162,
        LOCATION_LATITUDE_DEG: 55.9010343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED990072',
        LOCATION_NAME: 'Edinburgh EH99',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1761215,
        LOCATION_LATITUDE_DEG: 55.956218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006300',
        LOCATION_NAME: 'Edinchip',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3023551,
        LOCATION_LATITUDE_DEG: 56.373868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006400',
        LOCATION_NAME: 'Edingale',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6839244,
        LOCATION_LATITUDE_DEG: 52.7073774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006500',
        LOCATION_NAME: 'Edingham',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8108618,
        LOCATION_LATITUDE_DEG: 54.9456259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006600',
        LOCATION_NAME: 'Edingley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0048924,
        LOCATION_LATITUDE_DEG: 53.0950076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006700',
        LOCATION_NAME: 'Edingthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.445201,
        LOCATION_LATITUDE_DEG: 52.8421476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006800',
        LOCATION_NAME: 'Edington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8663521,
        LOCATION_LATITUDE_DEG: 51.1500436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED006900',
        LOCATION_NAME: 'Edington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1047526,
        LOCATION_LATITUDE_DEG: 51.2763455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007000',
        LOCATION_NAME: 'Edingworth',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9260801,
        LOCATION_LATITUDE_DEG: 51.2735573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED990121',
        LOCATION_NAME: 'Edith Weston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.632396,
        LOCATION_LATITUDE_DEG: 52.6394168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007100',
        LOCATION_NAME: 'Edith Weston',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6299243,
        LOCATION_LATITUDE_DEG: 52.6371583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007200',
        LOCATION_NAME: 'Edlaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7272006,
        LOCATION_LATITUDE_DEG: 52.9808044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007300',
        LOCATION_NAME: 'Edlesborough',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.585555,
        LOCATION_LATITUDE_DEG: 51.8647871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007350',
        LOCATION_NAME: 'Edleston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5297585,
        LOCATION_LATITUDE_DEG: 53.0702536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007400',
        LOCATION_NAME: 'Edlingham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8132003,
        LOCATION_LATITUDE_DEG: 55.3731424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007550',
        LOCATION_NAME: 'Edlington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1888096,
        LOCATION_LATITUDE_DEG: 53.4815003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007500',
        LOCATION_NAME: 'Edlington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1523063,
        LOCATION_LATITUDE_DEG: 53.225313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007600',
        LOCATION_NAME: 'Edlington Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2165638,
        LOCATION_LATITUDE_DEG: 53.165503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007700',
        LOCATION_NAME: 'Edmondsham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9115635,
        LOCATION_LATITUDE_DEG: 50.9021094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007800',
        LOCATION_NAME: 'Edmondsley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6313205,
        LOCATION_LATITUDE_DEG: 54.8370874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009800',
        LOCATION_NAME: 'Edmondstone',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED007900',
        LOCATION_NAME: 'Edmondthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7271868,
        LOCATION_LATITUDE_DEG: 52.748674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008000',
        LOCATION_NAME: 'Edmonton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8705939,
        LOCATION_LATITUDE_DEG: 50.5181057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009600',
        LOCATION_NAME: 'Edmonton',
        COUNTY_NAME: 'London',
        POSTCODE: 'N18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0581926,
        LOCATION_LATITUDE_DEG: 51.6268089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008100',
        LOCATION_NAME: 'Edmundbyers',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9725579,
        LOCATION_LATITUDE_DEG: 54.8453912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008200',
        LOCATION_NAME: 'Ednam',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4150003,
        LOCATION_LATITUDE_DEG: 55.6281677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008300',
        LOCATION_NAME: 'Ednaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.644718,
        LOCATION_LATITUDE_DEG: 52.9687014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008400',
        LOCATION_NAME: 'Edney Common',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3902418,
        LOCATION_LATITUDE_DEG: 51.7137527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008500',
        LOCATION_NAME: 'Edstaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.713253,
        LOCATION_LATITUDE_DEG: 52.8812061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008600',
        LOCATION_NAME: 'Edvin Loach',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4953404,
        LOCATION_LATITUDE_DEG: 52.2227452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008700',
        LOCATION_NAME: 'Edwalton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1164036,
        LOCATION_LATITUDE_DEG: 52.9109889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008800',
        LOCATION_NAME: 'Edwardstone',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8337977,
        LOCATION_LATITUDE_DEG: 52.0437808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED008900',
        LOCATION_NAME: 'Edwardsville',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.317614,
        LOCATION_LATITUDE_DEG: 51.6609958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009000',
        LOCATION_NAME: 'Edwinsford',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9961029,
        LOCATION_LATITUDE_DEG: 51.9943361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009100',
        LOCATION_NAME: 'Edwinstowe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0630753,
        LOCATION_LATITUDE_DEG: 53.1949219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009200',
        LOCATION_NAME: 'Edworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2200376,
        LOCATION_LATITUDE_DEG: 52.0542942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009300',
        LOCATION_NAME: 'Edwyn Ralph',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5256812,
        LOCATION_LATITUDE_DEG: 52.2194399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED009400',
        LOCATION_NAME: 'Edzell',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6541415,
        LOCATION_LATITUDE_DEG: 56.8097904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000100',
        LOCATION_NAME: 'Efail Isaf',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3174247,
        LOCATION_LATITUDE_DEG: 51.5511858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000900',
        LOCATION_NAME: 'Efail Rhyd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2494194,
        LOCATION_LATITUDE_DEG: 52.8290065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000300',
        LOCATION_NAME: 'Efailnewydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4480073,
        LOCATION_LATITUDE_DEG: 52.8959248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000200',
        LOCATION_NAME: 'Efail-Rhyd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2451569,
        LOCATION_LATITUDE_DEG: 52.828413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000400',
        LOCATION_NAME: 'Efailwen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.711474,
        LOCATION_LATITUDE_DEG: 51.8947308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000500',
        LOCATION_NAME: 'Efenechtyd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3272502,
        LOCATION_LATITUDE_DEG: 53.0915333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000600',
        LOCATION_NAME: 'Effingham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3990717,
        LOCATION_LATITUDE_DEG: 51.2722272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000700',
        LOCATION_NAME: 'Effingham Junction',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.418048,
        LOCATION_LATITUDE_DEG: 51.2891234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000850',
        LOCATION_NAME: 'Efford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1100473,
        LOCATION_LATITUDE_DEG: 50.3860141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EF000800',
        LOCATION_NAME: 'Efford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5751904,
        LOCATION_LATITUDE_DEG: 50.7981196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000100',
        LOCATION_NAME: 'Egdon',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1204397,
        LOCATION_LATITUDE_DEG: 52.1597309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000200',
        LOCATION_NAME: 'Egerton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4381842,
        LOCATION_LATITUDE_DEG: 53.6270745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000300',
        LOCATION_NAME: 'Egerton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7302162,
        LOCATION_LATITUDE_DEG: 51.1941011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000400',
        LOCATION_NAME: 'Egford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3448264,
        LOCATION_LATITUDE_DEG: 51.232242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000500',
        LOCATION_NAME: 'Eggborough',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1484664,
        LOCATION_LATITUDE_DEG: 53.7038655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000600',
        LOCATION_NAME: 'Eggbuckland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1155151,
        LOCATION_LATITUDE_DEG: 50.3994888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000700',
        LOCATION_NAME: 'Eggesford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8654784,
        LOCATION_LATITUDE_DEG: 50.8828292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000800',
        LOCATION_NAME: 'Eggington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6080059,
        LOCATION_LATITUDE_DEG: 51.91669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG000900',
        LOCATION_NAME: 'Egginton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6035487,
        LOCATION_LATITUDE_DEG: 52.8507878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001000',
        LOCATION_NAME: 'Egglescliffe',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3521175,
        LOCATION_LATITUDE_DEG: 54.5190507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001100',
        LOCATION_NAME: 'Eggleston',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.002338,
        LOCATION_LATITUDE_DEG: 54.6075638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001200',
        LOCATION_NAME: 'Eggwood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8066808,
        LOCATION_LATITUDE_DEG: 50.9117222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001300',
        LOCATION_NAME: 'Egham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'TW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5466189,
        LOCATION_LATITUDE_DEG: 51.430241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001400',
        LOCATION_NAME: 'Egilsay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.923842,
        LOCATION_LATITUDE_DEG: 59.1510314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG990122',
        LOCATION_NAME: 'Egleton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7060439,
        LOCATION_LATITUDE_DEG: 52.6605555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001500',
        LOCATION_NAME: 'Egleton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7050471,
        LOCATION_LATITUDE_DEG: 52.6577573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001600',
        LOCATION_NAME: 'Eglingham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8330091,
        LOCATION_LATITUDE_DEG: 55.4696513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001700',
        LOCATION_NAME: 'Eglinton',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1851247,
        LOCATION_LATITUDE_DEG: 55.0315558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001800',
        LOCATION_NAME: 'Eglish',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.799005,
        LOCATION_LATITUDE_DEG: 54.4498888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001900',
        LOCATION_NAME: 'Egloshayle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8180363,
        LOCATION_LATITUDE_DEG: 50.5146047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002000',
        LOCATION_NAME: 'Egloskerry',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4433729,
        LOCATION_LATITUDE_DEG: 50.6520172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002100',
        LOCATION_NAME: 'Eglwys Cross',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7869004,
        LOCATION_LATITUDE_DEG: 52.9628159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002200',
        LOCATION_NAME: 'Eglwysbach',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7919286,
        LOCATION_LATITUDE_DEG: 53.2170567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002300',
        LOCATION_NAME: 'Eglwyseg',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1750513,
        LOCATION_LATITUDE_DEG: 52.9945236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002400',
        LOCATION_NAME: 'Eglwysfach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9362082,
        LOCATION_LATITUDE_DEG: 52.5427887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002500',
        LOCATION_NAME: 'Eglwyswrw',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7084315,
        LOCATION_LATITUDE_DEG: 52.0134437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002600',
        LOCATION_NAME: 'Egmanton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8980997,
        LOCATION_LATITUDE_DEG: 53.2113203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002700',
        LOCATION_NAME: 'Egmere',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.837336,
        LOCATION_LATITUDE_DEG: 52.8992636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002800',
        LOCATION_NAME: 'Egremont',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.526922,
        LOCATION_LATITUDE_DEG: 54.4852757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG002900',
        LOCATION_NAME: 'Egton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7533171,
        LOCATION_LATITUDE_DEG: 54.4473316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG003000',
        LOCATION_NAME: 'Egton Bridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7595754,
        LOCATION_LATITUDE_DEG: 54.436232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG003100',
        LOCATION_NAME: 'Egton Grange',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7677606,
        LOCATION_LATITUDE_DEG: 54.4291338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG003200',
        LOCATION_NAME: 'Egypt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.366035,
        LOCATION_LATITUDE_DEG: 50.5153996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000100',
        LOCATION_NAME: 'Eight Ash Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8238944,
        LOCATION_LATITUDE_DEG: 51.8958717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000900',
        LOCATION_NAME: 'Eighton Banks',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.573884,
        LOCATION_LATITUDE_DEG: 54.9222086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000300',
        LOCATION_NAME: 'Eilanreach',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6290127,
        LOCATION_LATITUDE_DEG: 57.1996622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000400',
        LOCATION_NAME: 'Eildon',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6785794,
        LOCATION_LATITUDE_DEG: 55.5853673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000800',
        LOCATION_NAME: 'Eilean Anabuich',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7438851,
        LOCATION_LATITUDE_DEG: 57.9565852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000500',
        LOCATION_NAME: 'Eilean Shona',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8611881,
        LOCATION_LATITUDE_DEG: 56.7967292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000600',
        LOCATION_NAME: 'Eilean-Anabuich',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7326818,
        LOCATION_LATITUDE_DEG: 57.9468467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000700',
        LOCATION_NAME: 'Eishken',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5263705,
        LOCATION_LATITUDE_DEG: 58.0155514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000100',
        LOCATION_NAME: 'Elberton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5784761,
        LOCATION_LATITUDE_DEG: 51.5950858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL990498',
        LOCATION_NAME: 'Elborough',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8970087,
        LOCATION_LATITUDE_DEG: 51.3282725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000200',
        LOCATION_NAME: 'Elbridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9411313,
        LOCATION_LATITUDE_DEG: 52.8098056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000300',
        LOCATION_NAME: 'Elburton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0716097,
        LOCATION_LATITUDE_DEG: 50.3572815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000400',
        LOCATION_NAME: 'Elcocks Brook',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9847983,
        LOCATION_LATITUDE_DEG: 52.2789455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000500',
        LOCATION_NAME: 'Elcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1724983,
        LOCATION_LATITUDE_DEG: 51.7606906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000600',
        LOCATION_NAME: 'Elcombe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8106512,
        LOCATION_LATITUDE_DEG: 51.5206691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000700',
        LOCATION_NAME: 'Elcot',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4303827,
        LOCATION_LATITUDE_DEG: 51.4245487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000800',
        LOCATION_NAME: 'Eldersfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2905477,
        LOCATION_LATITUDE_DEG: 51.9782166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL000900',
        LOCATION_NAME: 'Elderslie',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4635321,
        LOCATION_LATITUDE_DEG: 55.8316153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001000',
        LOCATION_NAME: 'Eldon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6375679,
        LOCATION_LATITUDE_DEG: 54.6435659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001100',
        LOCATION_NAME: 'Eldwick',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8104309,
        LOCATION_LATITUDE_DEG: 53.8586926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001200',
        LOCATION_NAME: 'Eleighwater',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9472961,
        LOCATION_LATITUDE_DEG: 50.9008179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001300',
        LOCATION_NAME: 'Elemore Vale',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4414238,
        LOCATION_LATITUDE_DEG: 54.8046809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001400',
        LOCATION_NAME: 'Elfield Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7880531,
        LOCATION_LATITUDE_DEG: 52.0265979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001500',
        LOCATION_NAME: 'Elford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7196164,
        LOCATION_LATITUDE_DEG: 52.6906815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001600',
        LOCATION_NAME: 'Elgin',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3138337,
        LOCATION_LATITUDE_DEG: 57.6464788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001700',
        LOCATION_NAME: 'Elgol',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0961061,
        LOCATION_LATITUDE_DEG: 57.1526616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001800',
        LOCATION_NAME: 'Elham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1122532,
        LOCATION_LATITUDE_DEG: 51.1514952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL001900',
        LOCATION_NAME: 'Elie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.819998,
        LOCATION_LATITUDE_DEG: 56.190536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002000',
        LOCATION_NAME: 'Elim',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4713779,
        LOCATION_LATITUDE_DEG: 53.3352668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002100',
        LOCATION_NAME: 'Eling Hermitage',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2485235,
        LOCATION_LATITUDE_DEG: 51.4620579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002200',
        LOCATION_NAME: 'Eliock',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.898835,
        LOCATION_LATITUDE_DEG: 55.3462587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002300',
        LOCATION_NAME: 'Elkesley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9665532,
        LOCATION_LATITUDE_DEG: 53.2730225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002400',
        LOCATION_NAME: 'Elkington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.081747,
        LOCATION_LATITUDE_DEG: 52.3833377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002500',
        LOCATION_NAME: 'Elkstone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0487546,
        LOCATION_LATITUDE_DEG: 51.8080964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002600',
        LOCATION_NAME: 'Ellacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5229684,
        LOCATION_LATITUDE_DEG: 50.4700837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002800',
        LOCATION_NAME: 'Elland',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8322647,
        LOCATION_LATITUDE_DEG: 53.6839777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002900',
        LOCATION_NAME: 'Ellastone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8253998,
        LOCATION_LATITUDE_DEG: 52.9865092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003000',
        LOCATION_NAME: 'Ellel',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7836578,
        LOCATION_LATITUDE_DEG: 53.9967201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003100',
        LOCATION_NAME: 'Ellenborough',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4812464,
        LOCATION_LATITUDE_DEG: 54.7076968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003200',
        LOCATION_NAME: 'Ellenbrook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4081006,
        LOCATION_LATITUDE_DEG: 53.5104622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003400',
        LOCATION_NAME: 'Ellenhall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2340047,
        LOCATION_LATITUDE_DEG: 52.8334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003500',
        LOCATION_NAME: 'Ellerbeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3337083,
        LOCATION_LATITUDE_DEG: 54.3637326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003600',
        LOCATION_NAME: 'Ellerburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7077988,
        LOCATION_LATITUDE_DEG: 54.2458161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003700',
        LOCATION_NAME: 'Ellerby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7654357,
        LOCATION_LATITUDE_DEG: 54.5197429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL990434',
        LOCATION_NAME: 'Ellerdine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003800',
        LOCATION_NAME: 'Ellerdine Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5647863,
        LOCATION_LATITUDE_DEG: 52.7944007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003900',
        LOCATION_NAME: 'Ellerker',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6023086,
        LOCATION_LATITUDE_DEG: 53.7538643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004100',
        LOCATION_NAME: 'Ellerton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4202214,
        LOCATION_LATITUDE_DEG: 52.8300998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004000',
        LOCATION_NAME: 'Ellerton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.604714,
        LOCATION_LATITUDE_DEG: 54.3763392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004200',
        LOCATION_NAME: 'Ellerton Abbey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8795544,
        LOCATION_LATITUDE_DEG: 54.3711468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004300',
        LOCATION_NAME: 'Ellesborough',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7884412,
        LOCATION_LATITUDE_DEG: 51.7522802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004400',
        LOCATION_NAME: 'Ellesmere',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8944178,
        LOCATION_LATITUDE_DEG: 52.9071139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004500',
        LOCATION_NAME: 'Ellesmere Port',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9002895,
        LOCATION_LATITUDE_DEG: 53.2783455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004600',
        LOCATION_NAME: 'Ellicombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4546383,
        LOCATION_LATITUDE_DEG: 51.1917557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004700',
        LOCATION_NAME: 'Ellingham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7950211,
        LOCATION_LATITUDE_DEG: 50.8734087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004800',
        LOCATION_NAME: 'Ellingham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.728966,
        LOCATION_LATITUDE_DEG: 55.5246514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL004900',
        LOCATION_NAME: 'Ellingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4762054,
        LOCATION_LATITUDE_DEG: 52.4784161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005000',
        LOCATION_NAME: 'Ellingstring',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7294107,
        LOCATION_LATITUDE_DEG: 54.2449239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005200',
        LOCATION_NAME: 'Ellington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5632506,
        LOCATION_LATITUDE_DEG: 55.2205191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005100',
        LOCATION_NAME: 'Ellington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2965488,
        LOCATION_LATITUDE_DEG: 52.3317266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005300',
        LOCATION_NAME: 'Elliot',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6364735,
        LOCATION_LATITUDE_DEG: 56.5439622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005400',
        LOCATION_NAME: 'Elliots Town',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.232597,
        LOCATION_LATITUDE_DEG: 51.7160999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005500',
        LOCATION_NAME: 'Ellis Laithe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4310603,
        LOCATION_LATITUDE_DEG: 53.6129594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005600',
        LOCATION_NAME: 'Ellisfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0883675,
        LOCATION_LATITUDE_DEG: 51.2107276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005700',
        LOCATION_NAME: 'Ellistown',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3657935,
        LOCATION_LATITUDE_DEG: 52.6988739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005800',
        LOCATION_NAME: 'Ellon',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0689991,
        LOCATION_LATITUDE_DEG: 57.3652429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL005900',
        LOCATION_NAME: 'Ellonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8911555,
        LOCATION_LATITUDE_DEG: 54.7085908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006000',
        LOCATION_NAME: 'Ellough',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5933535,
        LOCATION_LATITUDE_DEG: 52.4263084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006100',
        LOCATION_NAME: 'Elloughton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.565828,
        LOCATION_LATITUDE_DEG: 53.7413598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006200',
        LOCATION_NAME: 'Ellwood',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5928698,
        LOCATION_LATITUDE_DEG: 51.771102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006300',
        LOCATION_NAME: 'Elm',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1716545,
        LOCATION_LATITUDE_DEG: 52.6392475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006400',
        LOCATION_NAME: 'Elm Park',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.200501,
        LOCATION_LATITUDE_DEG: 51.5504457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006500',
        LOCATION_NAME: 'Elmbridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1451177,
        LOCATION_LATITUDE_DEG: 52.3077464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013400',
        LOCATION_NAME: 'Elmdon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.748624,
        LOCATION_LATITUDE_DEG: 52.4470663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006600',
        LOCATION_NAME: 'Elmdon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1307562,
        LOCATION_LATITUDE_DEG: 52.0353866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006700',
        LOCATION_NAME: 'Elmdon Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B91',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7634917,
        LOCATION_LATITUDE_DEG: 52.4240528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006800',
        LOCATION_NAME: 'Elmer',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6066816,
        LOCATION_LATITUDE_DEG: 50.795685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL006900',
        LOCATION_NAME: 'Elmesthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3092659,
        LOCATION_LATITUDE_DEG: 52.5604571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007000',
        LOCATION_NAME: 'Elmgate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2608328,
        LOCATION_LATITUDE_DEG: 50.3969881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007100',
        LOCATION_NAME: 'Elmhurst',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8318172,
        LOCATION_LATITUDE_DEG: 52.7068792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007200',
        LOCATION_NAME: 'Elmington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4339151,
        LOCATION_LATITUDE_DEG: 52.4896384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007300',
        LOCATION_NAME: 'Elmley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7694684,
        LOCATION_LATITUDE_DEG: 51.3616207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007400',
        LOCATION_NAME: 'Elmley Castle',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0246148,
        LOCATION_LATITUDE_DEG: 52.0706205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007500',
        LOCATION_NAME: 'Elmley Lovett',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1890601,
        LOCATION_LATITUDE_DEG: 52.3237516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007600',
        LOCATION_NAME: 'Elmore',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3078963,
        LOCATION_LATITUDE_DEG: 51.8345987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007700',
        LOCATION_NAME: 'Elms Green',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7287457,
        LOCATION_LATITUDE_DEG: 52.2039473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007800',
        LOCATION_NAME: 'Elmscott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5186881,
        LOCATION_LATITUDE_DEG: 50.9659416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL007900',
        LOCATION_NAME: 'Elmsett',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9999808,
        LOCATION_LATITUDE_DEG: 52.0789794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008000',
        LOCATION_NAME: 'Elmstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9891256,
        LOCATION_LATITUDE_DEG: 51.8730873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008100',
        LOCATION_NAME: 'Elmsted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.028282,
        LOCATION_LATITUDE_DEG: 51.1637945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008200',
        LOCATION_NAME: 'Elmstone Hardwicke',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1167622,
        LOCATION_LATITUDE_DEG: 51.9329107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008300',
        LOCATION_NAME: 'Elmswell',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4766954,
        LOCATION_LATITUDE_DEG: 54.012392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008400',
        LOCATION_NAME: 'Elmswell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9042471,
        LOCATION_LATITUDE_DEG: 52.2345978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008500',
        LOCATION_NAME: 'Elmton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.243351,
        LOCATION_LATITUDE_DEG: 53.2533262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008600',
        LOCATION_NAME: 'Elphin',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0293822,
        LOCATION_LATITUDE_DEG: 58.0529398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008800',
        LOCATION_NAME: 'Elphinstone',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9659708,
        LOCATION_LATITUDE_DEG: 55.9219104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008900',
        LOCATION_NAME: 'Elrick',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2978003,
        LOCATION_LATITUDE_DEG: 57.1502195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009000',
        LOCATION_NAME: 'Elrig',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6098725,
        LOCATION_LATITUDE_DEG: 54.7943187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009100',
        LOCATION_NAME: 'Elrington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2160821,
        LOCATION_LATITUDE_DEG: 54.9654083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009200',
        LOCATION_NAME: 'Elsdon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0992916,
        LOCATION_LATITUDE_DEG: 55.2334285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009300',
        LOCATION_NAME: 'Elsecar',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4163979,
        LOCATION_LATITUDE_DEG: 53.4965555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009400',
        LOCATION_NAME: 'Elsenham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2357538,
        LOCATION_LATITUDE_DEG: 51.9138817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009500',
        LOCATION_NAME: 'Elsfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2173101,
        LOCATION_LATITUDE_DEG: 51.7862854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009600',
        LOCATION_NAME: 'Elsham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4368297,
        LOCATION_LATITUDE_DEG: 53.5959482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009700',
        LOCATION_NAME: 'Elsham Wolds',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4022331,
        LOCATION_LATITUDE_DEG: 53.6068459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009800',
        LOCATION_NAME: 'Elsing',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.037444,
        LOCATION_LATITUDE_DEG: 52.7076426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL009900',
        LOCATION_NAME: 'Elslack',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1066903,
        LOCATION_LATITUDE_DEG: 53.9392992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010000',
        LOCATION_NAME: 'Elson',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9126393,
        LOCATION_LATITUDE_DEG: 52.9144106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010100',
        LOCATION_NAME: 'Elsrickle',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4965314,
        LOCATION_LATITUDE_DEG: 55.6733869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010200',
        LOCATION_NAME: 'Elstead',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7058602,
        LOCATION_LATITUDE_DEG: 51.1826242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010300',
        LOCATION_NAME: 'Elsted',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8374949,
        LOCATION_LATITUDE_DEG: 50.9695012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010400',
        LOCATION_NAME: 'Elsthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4290564,
        LOCATION_LATITUDE_DEG: 52.800568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010500',
        LOCATION_NAME: 'Elston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8657134,
        LOCATION_LATITUDE_DEG: 53.0219995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010600',
        LOCATION_NAME: 'Elstow',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4632897,
        LOCATION_LATITUDE_DEG: 52.1066095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010700',
        LOCATION_NAME: 'Elstree',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2979635,
        LOCATION_LATITUDE_DEG: 51.64286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010800',
        LOCATION_NAME: 'Elstronwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1362799,
        LOCATION_LATITUDE_DEG: 53.7727591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL010900',
        LOCATION_NAME: 'Elswick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8781514,
        LOCATION_LATITUDE_DEG: 53.8383071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013300',
        LOCATION_NAME: 'Elswick',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6465792,
        LOCATION_LATITUDE_DEG: 54.9672167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011000',
        LOCATION_NAME: 'Elsworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0706135,
        LOCATION_LATITUDE_DEG: 52.2552143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011100',
        LOCATION_NAME: 'Elterwater',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0368908,
        LOCATION_LATITUDE_DEG: 54.4334583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013500',
        LOCATION_NAME: 'Eltham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0521852,
        LOCATION_LATITUDE_DEG: 51.4561453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011200',
        LOCATION_NAME: 'Eltisley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1407263,
        LOCATION_LATITUDE_DEG: 52.2206122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL990076',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8169675,
        LOCATION_LATITUDE_DEG: 53.277534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011400',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8147414,
        LOCATION_LATITUDE_DEG: 53.2748432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011900',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7978251,
        LOCATION_LATITUDE_DEG: 52.3331047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011800',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4296426,
        LOCATION_LATITUDE_DEG: 51.8222036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011600',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6684447,
        LOCATION_LATITUDE_DEG: 53.1450223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011700',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3760468,
        LOCATION_LATITUDE_DEG: 54.5496551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011300',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8577366,
        LOCATION_LATITUDE_DEG: 52.9417887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL011500',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3936196,
        LOCATION_LATITUDE_DEG: 52.5306495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012100',
        LOCATION_NAME: 'Elvanfoot',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6587721,
        LOCATION_LATITUDE_DEG: 55.4390669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012200',
        LOCATION_NAME: 'Elvaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.390004,
        LOCATION_LATITUDE_DEG: 52.8887939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012300',
        LOCATION_NAME: 'Elveden',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6778184,
        LOCATION_LATITUDE_DEG: 52.3867152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012400',
        LOCATION_NAME: 'Elvetham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8705846,
        LOCATION_LATITUDE_DEG: 51.3016387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012500',
        LOCATION_NAME: 'Elvingston',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8616569,
        LOCATION_LATITUDE_DEG: 55.9594109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012600',
        LOCATION_NAME: 'Elvington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9332475,
        LOCATION_LATITUDE_DEG: 53.9200829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012700',
        LOCATION_NAME: 'Elvington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2598592,
        LOCATION_LATITUDE_DEG: 51.206899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012800',
        LOCATION_NAME: 'Elwick',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.29493,
        LOCATION_LATITUDE_DEG: 54.6833646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012900',
        LOCATION_NAME: 'Elworth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3893865,
        LOCATION_LATITUDE_DEG: 53.1494322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013000',
        LOCATION_NAME: 'Elworthy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3054087,
        LOCATION_LATITUDE_DEG: 51.1053433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013200',
        LOCATION_NAME: 'Ely',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2484136,
        LOCATION_LATITUDE_DEG: 51.4788815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013100',
        LOCATION_NAME: 'Ely',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2614013,
        LOCATION_LATITUDE_DEG: 52.3991248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013250',
        LOCATION_NAME: 'Ely Island',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7007915,
        LOCATION_LATITUDE_DEG: 54.4091792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000100',
        LOCATION_NAME: 'Emberton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7054764,
        LOCATION_LATITUDE_DEG: 52.1364132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000300',
        LOCATION_NAME: 'Embleton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2816911,
        LOCATION_LATITUDE_DEG: 54.6626921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000200',
        LOCATION_NAME: 'Embleton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6339029,
        LOCATION_LATITUDE_DEG: 55.4953508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000400',
        LOCATION_NAME: 'Embo',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9970428,
        LOCATION_LATITUDE_DEG: 57.9099134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000500',
        LOCATION_NAME: 'Emborough',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5540346,
        LOCATION_LATITUDE_DEG: 51.2598475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000600',
        LOCATION_NAME: 'Embridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6146771,
        LOCATION_LATITUDE_DEG: 50.3280775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000700',
        LOCATION_NAME: 'Embsay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.986489,
        LOCATION_LATITUDE_DEG: 53.9787076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000800',
        LOCATION_NAME: 'Emerson Valley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7710557,
        LOCATION_LATITUDE_DEG: 52.0032039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM000900',
        LOCATION_NAME: 'Emersons Green',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4679264,
        LOCATION_LATITUDE_DEG: 51.4941701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001000',
        LOCATION_NAME: 'Emery Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5941159,
        LOCATION_LATITUDE_DEG: 50.8740072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001300',
        LOCATION_NAME: 'Emley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6319365,
        LOCATION_LATITUDE_DEG: 53.6133682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001400',
        LOCATION_NAME: 'Emley Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6597148,
        LOCATION_LATITUDE_DEG: 53.6180709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001600',
        LOCATION_NAME: 'Emmer Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9594244,
        LOCATION_LATITUDE_DEG: 51.4850557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001700',
        LOCATION_NAME: 'Emmington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9260458,
        LOCATION_LATITUDE_DEG: 51.7184753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001800',
        LOCATION_NAME: 'Emmotland',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3357441,
        LOCATION_LATITUDE_DEG: 53.9494815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001900',
        LOCATION_NAME: 'Emneth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2098451,
        LOCATION_LATITUDE_DEG: 52.6420482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM002000',
        LOCATION_NAME: 'Emneth Hungate',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2393791,
        LOCATION_LATITUDE_DEG: 52.6431481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM990123',
        LOCATION_NAME: 'Empingham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6797726,
        LOCATION_LATITUDE_DEG: 52.722153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM002200',
        LOCATION_NAME: 'Empingham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5907758,
        LOCATION_LATITUDE_DEG: 52.6678635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM002300',
        LOCATION_NAME: 'Empshott',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9259469,
        LOCATION_LATITUDE_DEG: 51.0757168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM002400',
        LOCATION_NAME: 'Emstrey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6990091,
        LOCATION_LATITUDE_DEG: 52.690193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM002500',
        LOCATION_NAME: 'Emsworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9357046,
        LOCATION_LATITUDE_DEG: 50.8472952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000100',
        LOCATION_NAME: 'Enborne',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3707673,
        LOCATION_LATITUDE_DEG: 51.390449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000200',
        LOCATION_NAME: 'Enchmarsh',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7355,
        LOCATION_LATITUDE_DEG: 52.5642784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000300',
        LOCATION_NAME: 'Endale',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.715934,
        LOCATION_LATITUDE_DEG: 52.246349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000400',
        LOCATION_NAME: 'Enderby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2063607,
        LOCATION_LATITUDE_DEG: 52.5891589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000500',
        LOCATION_NAME: 'Endmoor',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7067804,
        LOCATION_LATITUDE_DEG: 54.2574385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000600',
        LOCATION_NAME: 'Endon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1105625,
        LOCATION_LATITUDE_DEG: 53.0768204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000700',
        LOCATION_NAME: 'Endon',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0452768,
        LOCATION_LATITUDE_DEG: 52.1007273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000800',
        LOCATION_NAME: 'Eneclate',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8938948,
        LOCATION_LATITUDE_DEG: 58.1486647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN000900',
        LOCATION_NAME: 'Energlyn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2330976,
        LOCATION_LATITUDE_DEG: 51.5906907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001000',
        LOCATION_NAME: 'Enfield',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'EN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0799308,
        LOCATION_LATITUDE_DEG: 51.6516557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001200',
        LOCATION_NAME: 'Enford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8002616,
        LOCATION_LATITUDE_DEG: 51.2624449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001300',
        LOCATION_NAME: 'Englefield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1002315,
        LOCATION_LATITUDE_DEG: 51.4420479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001400',
        LOCATION_NAME: 'Englefield Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'TW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5692213,
        LOCATION_LATITUDE_DEG: 51.4242418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001500',
        LOCATION_NAME: 'Englesea Brook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3749348,
        LOCATION_LATITUDE_DEG: 53.0593976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001600',
        LOCATION_NAME: 'English Bicknor',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6070432,
        LOCATION_LATITUDE_DEG: 51.8379043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001700',
        LOCATION_NAME: 'English Frankton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.813802,
        LOCATION_LATITUDE_DEG: 52.8626054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001800',
        LOCATION_NAME: 'Englishcombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4043749,
        LOCATION_LATITUDE_DEG: 51.3631584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001900',
        LOCATION_NAME: 'Engollan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0120868,
        LOCATION_LATITUDE_DEG: 50.4903008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002000',
        LOCATION_NAME: 'Enham Alamein',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4767041,
        LOCATION_LATITUDE_DEG: 51.2464276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002100',
        LOCATION_NAME: 'Enmore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0801683,
        LOCATION_LATITUDE_DEG: 51.1096467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002200',
        LOCATION_NAME: 'Ennerdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4358017,
        LOCATION_LATITUDE_DEG: 54.5288828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002400',
        LOCATION_NAME: 'Enniscaven',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8625898,
        LOCATION_LATITUDE_DEG: 50.3971956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN990156',
        LOCATION_NAME: 'Enniscraven',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8654009,
        LOCATION_LATITUDE_DEG: 50.3999332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN990165',
        LOCATION_NAME: 'Enniscraven',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8651383,
        LOCATION_LATITUDE_DEG: 50.4004794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002800',
        LOCATION_NAME: 'Enniskillen',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6344727,
        LOCATION_LATITUDE_DEG: 54.3471972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003000',
        LOCATION_NAME: 'Enochdhu',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5320067,
        LOCATION_LATITUDE_DEG: 56.7470984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003100',
        LOCATION_NAME: 'Ensdon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8736122,
        LOCATION_LATITUDE_DEG: 52.7486987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003200',
        LOCATION_NAME: 'Enslow',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3035814,
        LOCATION_LATITUDE_DEG: 51.8605908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003300',
        LOCATION_NAME: 'Enson',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0875294,
        LOCATION_LATITUDE_DEG: 52.8566948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003400',
        LOCATION_NAME: 'Enstone',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4522477,
        LOCATION_LATITUDE_DEG: 51.9148973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003500',
        LOCATION_NAME: 'Entercommon',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4776793,
        LOCATION_LATITUDE_DEG: 54.4477442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003600',
        LOCATION_NAME: 'Enterkinfoot',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7998588,
        LOCATION_LATITUDE_DEG: 55.3177538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003700',
        LOCATION_NAME: 'Enton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6373711,
        LOCATION_LATITUDE_DEG: 51.1502161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN003800',
        LOCATION_NAME: 'Enville',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2574326,
        LOCATION_LATITUDE_DEG: 52.4788637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EO000200',
        LOCATION_NAME: 'Eochar',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3503887,
        LOCATION_LATITUDE_DEG: 57.3925952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EO000300',
        LOCATION_NAME: 'Eoligarry',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4354951,
        LOCATION_LATITUDE_DEG: 57.0412669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EO000400',
        LOCATION_NAME: 'Eorodale',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2253045,
        LOCATION_LATITUDE_DEG: 58.4855933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EO000500',
        LOCATION_NAME: 'Eoropie',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.234807,
        LOCATION_LATITUDE_DEG: 58.4829322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000100',
        LOCATION_NAME: 'Epperstone',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0274797,
        LOCATION_LATITUDE_DEG: 53.0292042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000200',
        LOCATION_NAME: 'Epping',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1118645,
        LOCATION_LATITUDE_DEG: 51.6975574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000400',
        LOCATION_NAME: 'Epping Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1226927,
        LOCATION_LATITUDE_DEG: 51.7447625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000300',
        LOCATION_NAME: 'Epping Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.08062,
        LOCATION_LATITUDE_DEG: 51.7253655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000500',
        LOCATION_NAME: 'Epping Upland',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0921476,
        LOCATION_LATITUDE_DEG: 51.720664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000600',
        LOCATION_NAME: 'Eppleby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.725538,
        LOCATION_LATITUDE_DEG: 54.5134549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000700',
        LOCATION_NAME: 'Eppleworth',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4631765,
        LOCATION_LATITUDE_DEG: 53.7729639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000800',
        LOCATION_NAME: 'Epsom',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2687448,
        LOCATION_LATITUDE_DEG: 51.3304322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP000900',
        LOCATION_NAME: 'Epwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4826074,
        LOCATION_LATITUDE_DEG: 52.060316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EP001000',
        LOCATION_NAME: 'Epworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8222569,
        LOCATION_LATITUDE_DEG: 53.5258454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000100',
        LOCATION_NAME: 'Erbistock',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9617412,
        LOCATION_LATITUDE_DEG: 52.9683178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000200',
        LOCATION_NAME: 'Ercall Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4691135,
        LOCATION_LATITUDE_DEG: 52.8034934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000300',
        LOCATION_NAME: 'Erddig',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0066312,
        LOCATION_LATITUDE_DEG: 53.0262232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000400',
        LOCATION_NAME: 'Erdington',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8353228,
        LOCATION_LATITUDE_DEG: 52.5264655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000500',
        LOCATION_NAME: 'Eredine',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2780908,
        LOCATION_LATITUDE_DEG: 56.2338664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000600',
        LOCATION_NAME: 'Eridge Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2249233,
        LOCATION_LATITUDE_DEG: 51.0982034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000700',
        LOCATION_NAME: 'Eriskay',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3074684,
        LOCATION_LATITUDE_DEG: 57.0831688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000800',
        LOCATION_NAME: 'Eriswell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5310036,
        LOCATION_LATITUDE_DEG: 52.3743214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER000900',
        LOCATION_NAME: 'Erith',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.179627,
        LOCATION_LATITUDE_DEG: 51.4822387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001000',
        LOCATION_NAME: 'Erlestoke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.051826,
        LOCATION_LATITUDE_DEG: 51.2842496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001100',
        LOCATION_NAME: 'Ermington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9154266,
        LOCATION_LATITUDE_DEG: 50.3608771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001200',
        LOCATION_NAME: 'Erpingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2542306,
        LOCATION_LATITUDE_DEG: 52.8392485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001500',
        LOCATION_NAME: 'Errogie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3899203,
        LOCATION_LATITUDE_DEG: 57.2700535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001600',
        LOCATION_NAME: 'Errol',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2107883,
        LOCATION_LATITUDE_DEG: 56.3923537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001700',
        LOCATION_NAME: 'Erskine',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4608185,
        LOCATION_LATITUDE_DEG: 55.900121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001800',
        LOCATION_NAME: 'Erskine Hospital',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4732932,
        LOCATION_LATITUDE_DEG: 55.916123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001900',
        LOCATION_NAME: 'Ervie',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1275351,
        LOCATION_LATITUDE_DEG: 54.9641396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER002000',
        LOCATION_NAME: 'Erwarton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2338621,
        LOCATION_LATITUDE_DEG: 51.9659712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER002100',
        LOCATION_NAME: 'Erwood',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3161438,
        LOCATION_LATITUDE_DEG: 52.0771403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER002200',
        LOCATION_NAME: 'Eryholme',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.504477,
        LOCATION_LATITUDE_DEG: 54.4739496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER002300',
        LOCATION_NAME: 'Eryrys',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1893789,
        LOCATION_LATITUDE_DEG: 53.1118353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000100',
        LOCATION_NAME: 'Escomb',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7074504,
        LOCATION_LATITUDE_DEG: 54.6643727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000200',
        LOCATION_NAME: 'Escot Park',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3009387,
        LOCATION_LATITUDE_DEG: 50.7759127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000300',
        LOCATION_NAME: 'Escrick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0406404,
        LOCATION_LATITUDE_DEG: 53.8768876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000400',
        LOCATION_NAME: 'Esgair',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3649597,
        LOCATION_LATITUDE_DEG: 51.9328322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000500',
        LOCATION_NAME: 'Esh',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6931307,
        LOCATION_LATITUDE_DEG: 54.7908837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000600',
        LOCATION_NAME: 'Esh Winning',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7025095,
        LOCATION_LATITUDE_DEG: 54.7696783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000700',
        LOCATION_NAME: 'Esher',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3629994,
        LOCATION_LATITUDE_DEG: 51.3697314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000800',
        LOCATION_NAME: 'Esholt',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.723336,
        LOCATION_LATITUDE_DEG: 53.8581908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES000900',
        LOCATION_NAME: 'Eshott',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6771576,
        LOCATION_LATITUDE_DEG: 55.2735279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001000',
        LOCATION_NAME: 'Eshton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0979985,
        LOCATION_LATITUDE_DEG: 54.0009065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001100',
        LOCATION_NAME: 'Eskbank',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0751801,
        LOCATION_LATITUDE_DEG: 55.8871086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001200',
        LOCATION_NAME: 'Eskdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3219739,
        LOCATION_LATITUDE_DEG: 54.3876363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001300',
        LOCATION_NAME: 'Eskdale Green',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3228642,
        LOCATION_LATITUDE_DEG: 54.3894602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001400',
        LOCATION_NAME: 'Eskdalemuir',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1758342,
        LOCATION_LATITUDE_DEG: 55.2691467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001900',
        LOCATION_NAME: 'Eskermore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1806736,
        LOCATION_LATITUDE_DEG: 54.5560558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002000',
        LOCATION_NAME: 'Eskett',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4635031,
        LOCATION_LATITUDE_DEG: 54.5363801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002100',
        LOCATION_NAME: 'Eskham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0592347,
        LOCATION_LATITUDE_DEG: 53.4662299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002200',
        LOCATION_NAME: 'Eskmeals',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4139137,
        LOCATION_LATITUDE_DEG: 54.3259544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002300',
        LOCATION_NAME: 'Eskra',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2157357,
        LOCATION_LATITUDE_DEG: 54.4666049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002400',
        LOCATION_NAME: 'Eslington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9349475,
        LOCATION_LATITUDE_DEG: 55.4039482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002500',
        LOCATION_NAME: 'Espley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7294485,
        LOCATION_LATITUDE_DEG: 55.2067205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002600',
        LOCATION_NAME: 'Esprick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8939376,
        LOCATION_LATITUDE_DEG: 53.8145038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002700',
        LOCATION_NAME: 'Essendine',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4505245,
        LOCATION_LATITUDE_DEG: 52.7015664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002800',
        LOCATION_NAME: 'Essendon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1532178,
        LOCATION_LATITUDE_DEG: 51.762873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES003000',
        LOCATION_NAME: 'Essington',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0558665,
        LOCATION_LATITUDE_DEG: 52.6280737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES003100',
        LOCATION_NAME: 'Esslemont',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1160718,
        LOCATION_LATITUDE_DEG: 57.3558382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES003200',
        LOCATION_NAME: 'Estcourt',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.146463,
        LOCATION_LATITUDE_DEG: 51.6186848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES003300',
        LOCATION_NAME: 'Eston',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1510951,
        LOCATION_LATITUDE_DEG: 54.5658488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES003400',
        LOCATION_NAME: 'Estover',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0928168,
        LOCATION_LATITUDE_DEG: 50.4266875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000100',
        LOCATION_NAME: 'Etal',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1146244,
        LOCATION_LATITUDE_DEG: 55.6480736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000200',
        LOCATION_NAME: 'Etchilhampton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9366655,
        LOCATION_LATITUDE_DEG: 51.3417529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000300',
        LOCATION_NAME: 'Etchingham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4362186,
        LOCATION_LATITUDE_DEG: 51.0071887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000400',
        LOCATION_NAME: 'Etchinghill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0962663,
        LOCATION_LATITUDE_DEG: 51.1126889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000500',
        LOCATION_NAME: 'Etherley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7426893,
        LOCATION_LATITUDE_DEG: 54.6527686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000600',
        LOCATION_NAME: 'Etherley Dene',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7007541,
        LOCATION_LATITUDE_DEG: 54.6535711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000700',
        LOCATION_NAME: 'Etherley Grange',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7181534,
        LOCATION_LATITUDE_DEG: 54.6547722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000800',
        LOCATION_NAME: 'Etherley Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.703956,
        LOCATION_LATITUDE_DEG: 54.6523656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET000900',
        LOCATION_NAME: 'Ethie Castle',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5092322,
        LOCATION_LATITUDE_DEG: 56.6129697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001000',
        LOCATION_NAME: 'Etling Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.983445,
        LOCATION_LATITUDE_DEG: 52.6823389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001100',
        LOCATION_NAME: 'Etloe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4719207,
        LOCATION_LATITUDE_DEG: 51.749394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001200',
        LOCATION_NAME: 'Eton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6077947,
        LOCATION_LATITUDE_DEG: 51.4902485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001300',
        LOCATION_NAME: 'Eton College',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6083571,
        LOCATION_LATITUDE_DEG: 51.4916492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001400',
        LOCATION_NAME: 'Eton Wick',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.640618,
        LOCATION_LATITUDE_DEG: 51.4982508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001500',
        LOCATION_NAME: 'Etruria',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.200613,
        LOCATION_LATITUDE_DEG: 53.0190128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001600',
        LOCATION_NAME: 'Etsome',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7392941,
        LOCATION_LATITUDE_DEG: 51.0741313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001700',
        LOCATION_NAME: 'Etterby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9556181,
        LOCATION_LATITUDE_DEG: 54.9076047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001800',
        LOCATION_NAME: 'Ettiley Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3964751,
        LOCATION_LATITUDE_DEG: 53.1397265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET001900',
        LOCATION_NAME: 'Ettingshall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0990788,
        LOCATION_LATITUDE_DEG: 52.5663684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET002000',
        LOCATION_NAME: 'Ettingshall Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1184962,
        LOCATION_LATITUDE_DEG: 52.5608661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET002100',
        LOCATION_NAME: 'Ettington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6034336,
        LOCATION_LATITUDE_DEG: 52.1364221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET002200',
        LOCATION_NAME: 'Etton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5098131,
        LOCATION_LATITUDE_DEG: 53.8782759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET002300',
        LOCATION_NAME: 'Etton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3144359,
        LOCATION_LATITUDE_DEG: 52.6427557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET002400',
        LOCATION_NAME: 'Ettrick',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.147514,
        LOCATION_LATITUDE_DEG: 55.4190644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET002500',
        LOCATION_NAME: 'Ettrickbridge',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9662546,
        LOCATION_LATITUDE_DEG: 55.5083704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ET002600',
        LOCATION_NAME: 'Etwall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6002454,
        LOCATION_LATITUDE_DEG: 52.8837988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EU000100',
        LOCATION_NAME: 'Eudon George',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4577588,
        LOCATION_LATITUDE_DEG: 52.4971664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EU000200',
        LOCATION_NAME: 'Eunant',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5514963,
        LOCATION_LATITUDE_DEG: 52.790205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EU000300',
        LOCATION_NAME: 'Euston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7879925,
        LOCATION_LATITUDE_DEG: 52.378617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EU000400',
        LOCATION_NAME: 'Euxton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6732993,
        LOCATION_LATITUDE_DEG: 53.6606822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000100',
        LOCATION_NAME: 'Evancoyd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0826031,
        LOCATION_LATITUDE_DEG: 52.2604513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000200',
        LOCATION_NAME: 'Evanstown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4748329,
        LOCATION_LATITUDE_DEG: 51.5935946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000300',
        LOCATION_NAME: 'Evanton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3354508,
        LOCATION_LATITUDE_DEG: 57.6632964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000400',
        LOCATION_NAME: 'Evedon',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3655232,
        LOCATION_LATITUDE_DEG: 53.0132904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000500',
        LOCATION_NAME: 'Evelith',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3790282,
        LOCATION_LATITUDE_DEG: 52.6421806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000600',
        LOCATION_NAME: 'Evelix',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0806611,
        LOCATION_LATITUDE_DEG: 57.8898181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000700',
        LOCATION_NAME: 'Evenjobb',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0804448,
        LOCATION_LATITUDE_DEG: 52.2542488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000800',
        LOCATION_NAME: 'Evenley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1466415,
        LOCATION_LATITUDE_DEG: 52.0087088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV000900',
        LOCATION_NAME: 'Evenlode',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6764392,
        LOCATION_LATITUDE_DEG: 51.9605066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001000',
        LOCATION_NAME: 'Evenwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6716827,
        LOCATION_LATITUDE_DEG: 52.6093789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001100',
        LOCATION_NAME: 'Evenwood',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.759819,
        LOCATION_LATITUDE_DEG: 54.6209691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001200',
        LOCATION_NAME: 'Evenwood Gate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7476177,
        LOCATION_LATITUDE_DEG: 54.6128642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001300',
        LOCATION_NAME: 'Evercreech',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.503905,
        LOCATION_LATITUDE_DEG: 51.1476431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001400',
        LOCATION_NAME: 'Everdon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1294912,
        LOCATION_LATITUDE_DEG: 52.2119244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001500',
        LOCATION_NAME: 'Everingham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7779147,
        LOCATION_LATITUDE_DEG: 53.8730798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001600',
        LOCATION_NAME: 'Everleigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7104936,
        LOCATION_LATITUDE_DEG: 51.2824464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001700',
        LOCATION_NAME: 'Everley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1835207,
        LOCATION_LATITUDE_DEG: 50.9036085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001800',
        LOCATION_NAME: 'Eversholt',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5573262,
        LOCATION_LATITUDE_DEG: 51.9869945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV001900',
        LOCATION_NAME: 'Evershot',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6020918,
        LOCATION_LATITUDE_DEG: 50.8394071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002000',
        LOCATION_NAME: 'Eversley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.887163,
        LOCATION_LATITUDE_DEG: 51.3564398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002100',
        LOCATION_NAME: 'Eversley Centre',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8652923,
        LOCATION_LATITUDE_DEG: 51.3469401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002200',
        LOCATION_NAME: 'Eversley Cross',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8578788,
        LOCATION_LATITUDE_DEG: 51.348235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002300',
        LOCATION_NAME: 'Everthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6197684,
        LOCATION_LATITUDE_DEG: 53.7760647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002400',
        LOCATION_NAME: 'Everton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9734746,
        LOCATION_LATITUDE_DEG: 53.4215665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002700',
        LOCATION_NAME: 'Everton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5862303,
        LOCATION_LATITUDE_DEG: 50.745092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002500',
        LOCATION_NAME: 'Everton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9595969,
        LOCATION_LATITUDE_DEG: 53.4111402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002600',
        LOCATION_NAME: 'Everton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2439669,
        LOCATION_LATITUDE_DEG: 52.145209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002800',
        LOCATION_NAME: 'Evertown',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0053518,
        LOCATION_LATITUDE_DEG: 55.0753275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV002900',
        LOCATION_NAME: 'Evesbatch',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4582375,
        LOCATION_LATITUDE_DEG: 52.1299315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV003000',
        LOCATION_NAME: 'Evesham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.947726,
        LOCATION_LATITUDE_DEG: 52.0911214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV003100',
        LOCATION_NAME: 'Evie',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1205133,
        LOCATION_LATITUDE_DEG: 59.1161244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EV003200',
        LOCATION_NAME: 'Evington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0717209,
        LOCATION_LATITUDE_DEG: 52.6213664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000100',
        LOCATION_NAME: 'Ewanrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4980127,
        LOCATION_LATITUDE_DEG: 54.7051986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000200',
        LOCATION_NAME: 'Ewdness',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3958486,
        LOCATION_LATITUDE_DEG: 52.5799718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000300',
        LOCATION_NAME: 'Ewell',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2484233,
        LOCATION_LATITUDE_DEG: 51.3498351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000400',
        LOCATION_NAME: 'Ewell Minnis',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2336043,
        LOCATION_LATITUDE_DEG: 51.143891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000500',
        LOCATION_NAME: 'Ewelme',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0694564,
        LOCATION_LATITUDE_DEG: 51.6185687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000600',
        LOCATION_NAME: 'Ewen',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.992956,
        LOCATION_LATITUDE_DEG: 51.6763805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000700',
        LOCATION_NAME: 'Ewenny',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5718665,
        LOCATION_LATITUDE_DEG: 51.4815837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000800',
        LOCATION_NAME: 'Ewerby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3292246,
        LOCATION_LATITUDE_DEG: 53.0104931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW000900',
        LOCATION_NAME: 'Ewerby Thorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3089619,
        LOCATION_LATITUDE_DEG: 53.0143876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001000',
        LOCATION_NAME: 'Ewerby Waithe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2936774,
        LOCATION_LATITUDE_DEG: 53.0325924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001100',
        LOCATION_NAME: 'Ewes',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9928961,
        LOCATION_LATITUDE_DEG: 55.2098373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001200',
        LOCATION_NAME: 'Ewesley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9042704,
        LOCATION_LATITUDE_DEG: 55.2235278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001300',
        LOCATION_NAME: 'Ewhurst',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.439998,
        LOCATION_LATITUDE_DEG: 51.1534159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001400',
        LOCATION_NAME: 'Ewhurst Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5624215,
        LOCATION_LATITUDE_DEG: 50.9933876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001500',
        LOCATION_NAME: 'Ewloe',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0430788,
        LOCATION_LATITUDE_DEG: 53.1893379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001600',
        LOCATION_NAME: 'Ewloe Green',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0453219,
        LOCATION_LATITUDE_DEG: 53.1880146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001700',
        LOCATION_NAME: 'Ewood Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3255842,
        LOCATION_LATITUDE_DEG: 53.684183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001800',
        LOCATION_NAME: 'Ewshot',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8321711,
        LOCATION_LATITUDE_DEG: 51.2369241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EW001900',
        LOCATION_NAME: 'Ewyas Harold',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8895561,
        LOCATION_LATITUDE_DEG: 51.9515214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000100',
        LOCATION_NAME: 'Exbourne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9820901,
        LOCATION_LATITUDE_DEG: 50.7995235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000200',
        LOCATION_NAME: 'Exbury',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3951583,
        LOCATION_LATITUDE_DEG: 50.8004953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000300',
        LOCATION_NAME: 'Exceat',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.159485,
        LOCATION_LATITUDE_DEG: 50.7685702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000400',
        LOCATION_NAME: 'Exebridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.527857,
        LOCATION_LATITUDE_DEG: 51.0109375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000500',
        LOCATION_NAME: 'Exelby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5479215,
        LOCATION_LATITUDE_DEG: 54.2777269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000600',
        LOCATION_NAME: 'Exeter',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5295593,
        LOCATION_LATITUDE_DEG: 50.7232109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000700',
        LOCATION_NAME: 'Exeter Airport',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4293431,
        LOCATION_LATITUDE_DEG: 50.7331082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000800',
        LOCATION_NAME: 'Exford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6406737,
        LOCATION_LATITUDE_DEG: 51.1324536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX000900',
        LOCATION_NAME: 'Exhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8462483,
        LOCATION_LATITUDE_DEG: 52.195829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001000',
        LOCATION_NAME: 'Exhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5025939,
        LOCATION_LATITUDE_DEG: 52.4622558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001100',
        LOCATION_NAME: 'Exley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8485015,
        LOCATION_LATITUDE_DEG: 53.6997753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001200',
        LOCATION_NAME: 'Exminster',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4938483,
        LOCATION_LATITUDE_DEG: 50.6794039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001300',
        LOCATION_NAME: 'Exmouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4056459,
        LOCATION_LATITUDE_DEG: 50.6312031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001400',
        LOCATION_NAME: 'Exning',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3713552,
        LOCATION_LATITUDE_DEG: 52.2649135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001500',
        LOCATION_NAME: 'Exonia Park',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5568589,
        LOCATION_LATITUDE_DEG: 50.7098077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001600',
        LOCATION_NAME: 'Exton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5346594,
        LOCATION_LATITUDE_DEG: 51.0908488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001800',
        LOCATION_NAME: 'Exton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.439153,
        LOCATION_LATITUDE_DEG: 50.6675001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001900',
        LOCATION_NAME: 'Exton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1259859,
        LOCATION_LATITUDE_DEG: 50.9847061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX990124',
        LOCATION_NAME: 'Exton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6334298,
        LOCATION_LATITUDE_DEG: 52.6949056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX001700',
        LOCATION_NAME: 'Exton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6320538,
        LOCATION_LATITUDE_DEG: 52.6901603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EX002000',
        LOCATION_NAME: 'Exwick',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5527647,
        LOCATION_LATITUDE_DEG: 50.729515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000100',
        LOCATION_NAME: 'Eyam',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6711829,
        LOCATION_LATITUDE_DEG: 53.2836367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000200',
        LOCATION_NAME: 'Eydon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.206443,
        LOCATION_LATITUDE_DEG: 52.1485181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000400',
        LOCATION_NAME: 'Eye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7366124,
        LOCATION_LATITUDE_DEG: 52.2716499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000300',
        LOCATION_NAME: 'Eye',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1846257,
        LOCATION_LATITUDE_DEG: 52.6093477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000500',
        LOCATION_NAME: 'Eye',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1477368,
        LOCATION_LATITUDE_DEG: 52.3214007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000600',
        LOCATION_NAME: 'Eye Green',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.184982,
        LOCATION_LATITUDE_DEG: 52.6164478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000700',
        LOCATION_NAME: 'Eye Kettleby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9120498,
        LOCATION_LATITUDE_DEG: 52.7431771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000800',
        LOCATION_NAME: 'Eyemouth',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0890018,
        LOCATION_LATITUDE_DEG: 55.8694945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001000',
        LOCATION_NAME: 'Eyeworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1747686,
        LOCATION_LATITUDE_DEG: 52.0959034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001100',
        LOCATION_NAME: 'Eyke',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3840006,
        LOCATION_LATITUDE_DEG: 52.1150761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001200',
        LOCATION_NAME: 'Eynesbury',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2641165,
        LOCATION_LATITUDE_DEG: 52.2175101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001300',
        LOCATION_NAME: 'Eynesbury Hardwicke',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2319297,
        LOCATION_LATITUDE_DEG: 52.1937147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001400',
        LOCATION_NAME: 'Eynort',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3399932,
        LOCATION_LATITUDE_DEG: 57.2579793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001500',
        LOCATION_NAME: 'Eynsford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2128833,
        LOCATION_LATITUDE_DEG: 51.3672285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001600',
        LOCATION_NAME: 'Eynsham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3729833,
        LOCATION_LATITUDE_DEG: 51.7803846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001700',
        LOCATION_NAME: 'Eype',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7799579,
        LOCATION_LATITUDE_DEG: 50.7204004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001800',
        LOCATION_NAME: 'Eyre',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3200858,
        LOCATION_LATITUDE_DEG: 57.4925948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002100',
        LOCATION_NAME: 'Eythorne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2695128,
        LOCATION_LATITUDE_DEG: 51.1947905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002200',
        LOCATION_NAME: 'Eythrope',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8929366,
        LOCATION_LATITUDE_DEG: 51.8214827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002500',
        LOCATION_NAME: 'Eyton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9673964,
        LOCATION_LATITUDE_DEG: 52.996826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002600',
        LOCATION_NAME: 'Eyton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9232948,
        LOCATION_LATITUDE_DEG: 52.4826711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002300',
        LOCATION_NAME: 'Eyton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8284202,
        LOCATION_LATITUDE_DEG: 52.8001986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002400',
        LOCATION_NAME: 'Eyton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7696995,
        LOCATION_LATITUDE_DEG: 52.2474494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002700',
        LOCATION_NAME: 'Eyton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5153242,
        LOCATION_LATITUDE_DEG: 52.7280948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002800',
        LOCATION_NAME: 'Eyton on Severn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6299089,
        LOCATION_LATITUDE_DEG: 52.6511824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000100',
        LOCATION_NAME: 'Faberstown',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5993527,
        LOCATION_LATITUDE_DEG: 51.2519386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000200',
        LOCATION_NAME: 'Faccarry',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2069513,
        LOCATION_LATITUDE_DEG: 54.6413526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000300',
        LOCATION_NAME: 'Faccombe',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4398787,
        LOCATION_LATITUDE_DEG: 51.3207456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000400',
        LOCATION_NAME: 'Faceby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2352082,
        LOCATION_LATITUDE_DEG: 54.4212407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000500',
        LOCATION_NAME: 'Fachelich',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2264708,
        LOCATION_LATITUDE_DEG: 51.8821404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000600',
        LOCATION_NAME: 'Fachwen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1283693,
        LOCATION_LATITUDE_DEG: 53.1334462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000700',
        LOCATION_NAME: 'Facit',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1686205,
        LOCATION_LATITUDE_DEG: 53.6667801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000800',
        LOCATION_NAME: 'Faddiley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6136917,
        LOCATION_LATITUDE_DEG: 53.0713248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA000900',
        LOCATION_NAME: 'Fadmoor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.962244,
        LOCATION_LATITUDE_DEG: 54.294927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001000',
        LOCATION_NAME: 'Fagley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7203979,
        LOCATION_LATITUDE_DEG: 53.8107851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001500',
        LOCATION_NAME: 'Faifley',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3828296,
        LOCATION_LATITUDE_DEG: 55.9258262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001600',
        LOCATION_NAME: 'Failand',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6899849,
        LOCATION_LATITUDE_DEG: 51.4416717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001700',
        LOCATION_NAME: 'Failford',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4389229,
        LOCATION_LATITUDE_DEG: 55.5047823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001800',
        LOCATION_NAME: 'Failsworth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1624926,
        LOCATION_LATITUDE_DEG: 53.5098616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001900',
        LOCATION_NAME: 'Faintree',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1818136,
        LOCATION_LATITUDE_DEG: 52.2059237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990552',
        LOCATION_NAME: 'Fair Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002000',
        LOCATION_NAME: 'Fair Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4541176,
        LOCATION_LATITUDE_DEG: 52.7257553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002100',
        LOCATION_NAME: 'Fair Isle',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.624427,
        LOCATION_LATITUDE_DEG: 59.534553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002200',
        LOCATION_NAME: 'Fair Mile',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6774341,
        LOCATION_LATITUDE_DEG: 52.2134424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990378',
        LOCATION_NAME: 'Fair Oak',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002300',
        LOCATION_NAME: 'Fair Oak',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2953529,
        LOCATION_LATITUDE_DEG: 50.963106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002400',
        LOCATION_NAME: 'Fairbourne',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0499985,
        LOCATION_LATITUDE_DEG: 52.6958006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002500',
        LOCATION_NAME: 'Fairburn',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2833693,
        LOCATION_LATITUDE_DEG: 53.7427733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018600',
        LOCATION_NAME: 'Fairfield',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9374764,
        LOCATION_LATITUDE_DEG: 53.4140872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003000',
        LOCATION_NAME: 'Fairfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7387234,
        LOCATION_LATITUDE_DEG: 52.7952975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002700',
        LOCATION_NAME: 'Fairfield',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2666447,
        LOCATION_LATITUDE_DEG: 52.4120575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002600',
        LOCATION_NAME: 'Fairfield',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0756693,
        LOCATION_LATITUDE_DEG: 52.372656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002800',
        LOCATION_NAME: 'Fairfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8971302,
        LOCATION_LATITUDE_DEG: 53.2626319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003100',
        LOCATION_NAME: 'Fairfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.747969,
        LOCATION_LATITUDE_DEG: 51.3495475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA002900',
        LOCATION_NAME: 'Fairfield',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3521176,
        LOCATION_LATITUDE_DEG: 54.5707591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003200',
        LOCATION_NAME: 'Fairford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7740951,
        LOCATION_LATITUDE_DEG: 51.7070878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003300',
        LOCATION_NAME: 'Fairlie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.852805,
        LOCATION_LATITUDE_DEG: 55.758209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003400',
        LOCATION_NAME: 'Fairlight',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6540041,
        LOCATION_LATITUDE_DEG: 50.8784769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003500',
        LOCATION_NAME: 'Fairlight Cove',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6649459,
        LOCATION_LATITUDE_DEG: 50.8743774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003700',
        LOCATION_NAME: 'Fairmile',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2945117,
        LOCATION_LATITUDE_DEG: 50.7661087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003800',
        LOCATION_NAME: 'Fairmile',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.211722,
        LOCATION_LATITUDE_DEG: 50.8433044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003600',
        LOCATION_NAME: 'Fairmile',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9027016,
        LOCATION_LATITUDE_DEG: 51.540861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA019100',
        LOCATION_NAME: 'Fairmilehead',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2033807,
        LOCATION_LATITUDE_DEG: 55.9023588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA003900',
        LOCATION_NAME: 'Fairseat',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3284281,
        LOCATION_LATITUDE_DEG: 51.3288219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004000',
        LOCATION_NAME: 'Fairstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5655925,
        LOCATION_LATITUDE_DEG: 51.8207624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004100',
        LOCATION_NAME: 'Fairview',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2119011,
        LOCATION_LATITUDE_DEG: 51.6637979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004200',
        LOCATION_NAME: 'Fairwarp',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.089439,
        LOCATION_LATITUDE_DEG: 51.0184949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004400',
        LOCATION_NAME: 'Fairwater',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2402012,
        LOCATION_LATITUDE_DEG: 51.4893826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004300',
        LOCATION_NAME: 'Fairwater',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0422839,
        LOCATION_LATITUDE_DEG: 51.643196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018400',
        LOCATION_NAME: 'Fairways Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5284696,
        LOCATION_LATITUDE_DEG: 54.9547551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018900',
        LOCATION_NAME: 'Fairweather Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7996989,
        LOCATION_LATITUDE_DEG: 53.7975051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004500',
        LOCATION_NAME: 'Fairwood',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0588832,
        LOCATION_LATITUDE_DEG: 51.6028961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004700',
        LOCATION_NAME: 'Fairy Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6392285,
        LOCATION_LATITUDE_DEG: 50.4289923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004600',
        LOCATION_NAME: 'Fairy Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2743655,
        LOCATION_LATITUDE_DEG: 50.995144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005000',
        LOCATION_NAME: 'Fakenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8488727,
        LOCATION_LATITUDE_DEG: 52.8300526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005100',
        LOCATION_NAME: 'Fakenham Magna',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8001042,
        LOCATION_LATITUDE_DEG: 52.3582111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005200',
        LOCATION_NAME: 'Fala Dam',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9120649,
        LOCATION_LATITUDE_DEG: 55.8439964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005300',
        LOCATION_NAME: 'Fala Village',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8979802,
        LOCATION_LATITUDE_DEG: 55.8378724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005500',
        LOCATION_NAME: 'Falcutt',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1280289,
        LOCATION_LATITUDE_DEG: 52.0809125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005600',
        LOCATION_NAME: 'Faldingworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.396656,
        LOCATION_LATITUDE_DEG: 53.3478264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005700',
        LOCATION_NAME: 'Falfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4572295,
        LOCATION_LATITUDE_DEG: 51.6372825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005800',
        LOCATION_NAME: 'Falkenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3421366,
        LOCATION_LATITUDE_DEG: 52.0015713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005900',
        LOCATION_NAME: 'Falkirk',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7829961,
        LOCATION_LATITUDE_DEG: 56.0007255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006000',
        LOCATION_NAME: 'Falkland',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2058634,
        LOCATION_LATITUDE_DEG: 56.2533427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006100',
        LOCATION_NAME: 'Fallgate',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4664043,
        LOCATION_LATITUDE_DEG: 53.1548158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006200',
        LOCATION_NAME: 'Fallin',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8703802,
        LOCATION_LATITUDE_DEG: 56.1043325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006300',
        LOCATION_NAME: 'Fallings Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.118857,
        LOCATION_LATITUDE_DEG: 52.6015763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018500',
        LOCATION_NAME: 'Fallowfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2185541,
        LOCATION_LATITUDE_DEG: 53.4437982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018800',
        LOCATION_NAME: 'Falls',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018700',
        LOCATION_NAME: 'Falls',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9551007,
        LOCATION_LATITUDE_DEG: 54.598127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006500',
        LOCATION_NAME: 'Falmer',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0784532,
        LOCATION_LATITUDE_DEG: 50.8618797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006600',
        LOCATION_NAME: 'Falmouth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0699594,
        LOCATION_LATITUDE_DEG: 50.1554686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006700',
        LOCATION_NAME: 'Falstone',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4330383,
        LOCATION_LATITUDE_DEG: 55.181331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006800',
        LOCATION_NAME: 'Fanagmore',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1218534,
        LOCATION_LATITUDE_DEG: 58.3979752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006900',
        LOCATION_NAME: 'Fancott',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5146918,
        LOCATION_LATITUDE_DEG: 51.9390919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007000',
        LOCATION_NAME: 'Fangdale Beck',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1245996,
        LOCATION_LATITUDE_DEG: 54.343827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007100',
        LOCATION_NAME: 'Fangfoss',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8330535,
        LOCATION_LATITUDE_DEG: 53.9687903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007200',
        LOCATION_NAME: 'Fankerton',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9400374,
        LOCATION_LATITUDE_DEG: 56.0251285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007500',
        LOCATION_NAME: 'Far Arnside',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8444626,
        LOCATION_LATITUDE_DEG: 54.1793399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007600',
        LOCATION_NAME: 'Far Cotton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9041522,
        LOCATION_LATITUDE_DEG: 52.2193266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007700',
        LOCATION_NAME: 'Far Forest',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3978735,
        LOCATION_LATITUDE_DEG: 52.3680544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007800',
        LOCATION_NAME: 'Far Oakridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1042912,
        LOCATION_LATITUDE_DEG: 51.7296941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007900',
        LOCATION_NAME: 'Far Sawrey',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9559336,
        LOCATION_LATITUDE_DEG: 54.3508563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008100',
        LOCATION_NAME: 'Farcet',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2274002,
        LOCATION_LATITUDE_DEG: 52.5362434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008200',
        LOCATION_NAME: 'Fardell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9520043,
        LOCATION_LATITUDE_DEG: 50.3989841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008400',
        LOCATION_NAME: 'Fareham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1772864,
        LOCATION_LATITUDE_DEG: 50.8519915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008500',
        LOCATION_NAME: 'Fareham Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1851361,
        LOCATION_LATITUDE_DEG: 50.8678934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008600',
        LOCATION_NAME: 'Farewell',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8786768,
        LOCATION_LATITUDE_DEG: 52.7030794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008700',
        LOCATION_NAME: 'Farforth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0212814,
        LOCATION_LATITUDE_DEG: 53.2867151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008800',
        LOCATION_NAME: 'Farhill',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7672479,
        LOCATION_LATITUDE_DEG: 51.7366958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008900',
        LOCATION_NAME: 'Faringdon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5830187,
        LOCATION_LATITUDE_DEG: 51.657674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009000',
        LOCATION_NAME: 'Farington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7014281,
        LOCATION_LATITUDE_DEG: 53.7167852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009100',
        LOCATION_NAME: 'Farington Moss',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7176497,
        LOCATION_LATITUDE_DEG: 53.7126889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009200',
        LOCATION_NAME: 'Farlam',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6936808,
        LOCATION_LATITUDE_DEG: 54.9221086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009300',
        LOCATION_NAME: 'Farleaze',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1860997,
        LOCATION_LATITUDE_DEG: 51.5475708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009400',
        LOCATION_NAME: 'Farleigh',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0409738,
        LOCATION_LATITUDE_DEG: 51.3235244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA991033',
        LOCATION_NAME: 'Farleigh Common',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.03234,
        LOCATION_LATITUDE_DEG: 51.32436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009500',
        LOCATION_NAME: 'Farleigh Hungerford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2824626,
        LOCATION_LATITUDE_DEG: 51.31705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009600',
        LOCATION_NAME: 'Farleigh Wallop',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1047686,
        LOCATION_LATITUDE_DEG: 51.2155307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009700',
        LOCATION_NAME: 'Farleigh Wick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2771456,
        LOCATION_LATITUDE_DEG: 51.3753629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009800',
        LOCATION_NAME: 'Farlesthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2085897,
        LOCATION_LATITUDE_DEG: 53.2451017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA009900',
        LOCATION_NAME: 'Farleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6527295,
        LOCATION_LATITUDE_DEG: 54.0991299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990359',
        LOCATION_NAME: 'Farley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010100',
        LOCATION_NAME: 'Farley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9055352,
        LOCATION_LATITUDE_DEG: 52.6646905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010200',
        LOCATION_NAME: 'Farley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6762239,
        LOCATION_LATITUDE_DEG: 51.06352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010000',
        LOCATION_NAME: 'Farley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5603549,
        LOCATION_LATITUDE_DEG: 53.1536174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010300',
        LOCATION_NAME: 'Farley Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5348569,
        LOCATION_LATITUDE_DEG: 52.1508932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010400',
        LOCATION_NAME: 'Farley Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9131052,
        LOCATION_LATITUDE_DEG: 51.3721424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010500',
        LOCATION_NAME: 'Farleys End',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3303945,
        LOCATION_LATITUDE_DEG: 51.8346995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010700',
        LOCATION_NAME: 'Farlington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0603144,
        LOCATION_LATITUDE_DEG: 54.1003055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010600',
        LOCATION_NAME: 'Farlington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0308158,
        LOCATION_LATITUDE_DEG: 50.8445893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010800',
        LOCATION_NAME: 'Farlow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5278744,
        LOCATION_LATITUDE_DEG: 52.4226616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA010900',
        LOCATION_NAME: 'Farmborough',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4886746,
        LOCATION_LATITUDE_DEG: 51.3447616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011000',
        LOCATION_NAME: 'Farmcote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9101998,
        LOCATION_LATITUDE_DEG: 51.9580125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011300',
        LOCATION_NAME: 'Farmington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.808196,
        LOCATION_LATITUDE_DEG: 51.8367965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011400',
        LOCATION_NAME: 'Farmoor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3461971,
        LOCATION_LATITUDE_DEG: 51.7599882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011700',
        LOCATION_NAME: 'Farnborough',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3770417,
        LOCATION_LATITUDE_DEG: 51.5347611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011800',
        LOCATION_NAME: 'Farnborough',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3677639,
        LOCATION_LATITUDE_DEG: 52.1425246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011900',
        LOCATION_NAME: 'Farnborough',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7531231,
        LOCATION_LATITUDE_DEG: 51.2934321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012000',
        LOCATION_NAME: 'Farnborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0754084,
        LOCATION_LATITUDE_DEG: 51.3590244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012200',
        LOCATION_NAME: 'Farncombe',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8475956,
        LOCATION_LATITUDE_DEG: 52.0413196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012100',
        LOCATION_NAME: 'Farncombe',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6004163,
        LOCATION_LATITUDE_DEG: 51.1976165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012300',
        LOCATION_NAME: 'Farndish',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6407218,
        LOCATION_LATITUDE_DEG: 52.26312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012500',
        LOCATION_NAME: 'Farndon',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8763756,
        LOCATION_LATITUDE_DEG: 53.0850267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012400',
        LOCATION_NAME: 'Farndon',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8523764,
        LOCATION_LATITUDE_DEG: 53.0582028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012600',
        LOCATION_NAME: 'Farnell',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6070742,
        LOCATION_LATITUDE_DEG: 56.689676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013000',
        LOCATION_NAME: 'Farnham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0617031,
        LOCATION_LATITUDE_DEG: 50.9491171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013300',
        LOCATION_NAME: 'Farnham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4671992,
        LOCATION_LATITUDE_DEG: 54.0398018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013100',
        LOCATION_NAME: 'Farnham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7941136,
        LOCATION_LATITUDE_DEG: 51.2136231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012800',
        LOCATION_NAME: 'Farnham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1433508,
        LOCATION_LATITUDE_DEG: 51.9016795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012900',
        LOCATION_NAME: 'Farnham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4567915,
        LOCATION_LATITUDE_DEG: 52.188183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013400',
        LOCATION_NAME: 'Farnham Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6057902,
        LOCATION_LATITUDE_DEG: 51.5587519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013500',
        LOCATION_NAME: 'Farnham Royal',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6157721,
        LOCATION_LATITUDE_DEG: 51.5369541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013600',
        LOCATION_NAME: 'Farnhill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9980207,
        LOCATION_LATITUDE_DEG: 53.9112025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013700',
        LOCATION_NAME: 'Farningham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2207978,
        LOCATION_LATITUDE_DEG: 51.3814244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990553',
        LOCATION_NAME: 'Farnley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013800',
        LOCATION_NAME: 'Farnley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6140832,
        LOCATION_LATITUDE_DEG: 53.7838825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013900',
        LOCATION_NAME: 'Farnley Tyas',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7493388,
        LOCATION_LATITUDE_DEG: 53.6107681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014000',
        LOCATION_NAME: 'Farnsfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0339177,
        LOCATION_LATITUDE_DEG: 53.1021064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014100',
        LOCATION_NAME: 'Farnworth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3988737,
        LOCATION_LATITUDE_DEG: 53.5476648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014200',
        LOCATION_NAME: 'Farr',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1888291,
        LOCATION_LATITUDE_DEG: 57.3697655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014600',
        LOCATION_NAME: 'Farringdon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3874477,
        LOCATION_LATITUDE_DEG: 50.7100045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014700',
        LOCATION_NAME: 'Farringdon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4311005,
        LOCATION_LATITUDE_DEG: 54.8760845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014750',
        LOCATION_NAME: 'Farringdon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0226977,
        LOCATION_LATITUDE_DEG: 51.104832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014800',
        LOCATION_NAME: 'Farrington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2256209,
        LOCATION_LATITUDE_DEG: 50.93592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014900',
        LOCATION_NAME: 'Farrington Gurney',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5323817,
        LOCATION_LATITUDE_DEG: 51.2986536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015100',
        LOCATION_NAME: 'Farsley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6716526,
        LOCATION_LATITUDE_DEG: 53.8095828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015200',
        LOCATION_NAME: 'Farthinghoe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2188549,
        LOCATION_LATITUDE_DEG: 52.0531082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015300',
        LOCATION_NAME: 'Farthingstone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1022319,
        LOCATION_LATITUDE_DEG: 52.1896186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015400',
        LOCATION_NAME: 'Fartown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7849211,
        LOCATION_LATITUDE_DEG: 53.6646741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015500',
        LOCATION_NAME: 'Farway',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1569196,
        LOCATION_LATITUDE_DEG: 50.7541087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015600',
        LOCATION_NAME: 'Faslane',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8124849,
        LOCATION_LATITUDE_DEG: 56.0646877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015700',
        LOCATION_NAME: 'Fasnacloich',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2213158,
        LOCATION_LATITUDE_DEG: 56.5803937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015800',
        LOCATION_NAME: 'Fasnagrianach',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1268995,
        LOCATION_LATITUDE_DEG: 57.7646101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015900',
        LOCATION_NAME: 'Fatfield',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5130725,
        LOCATION_LATITUDE_DEG: 54.8848889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016000',
        LOCATION_NAME: 'Faucheldean',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4743091,
        LOCATION_LATITUDE_DEG: 55.9510162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016100',
        LOCATION_NAME: 'Faugh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7656255,
        LOCATION_LATITUDE_DEG: 54.8872001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016300',
        LOCATION_NAME: 'Fauldhouse',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7064385,
        LOCATION_LATITUDE_DEG: 55.828308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016400',
        LOCATION_NAME: 'Faulkbourne',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6073849,
        LOCATION_LATITUDE_DEG: 51.8231616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016500',
        LOCATION_NAME: 'Faulkland',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3770961,
        LOCATION_LATITUDE_DEG: 51.2879525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016600',
        LOCATION_NAME: 'Fauls',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6106267,
        LOCATION_LATITUDE_DEG: 52.8903101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016700',
        LOCATION_NAME: 'Faverdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5759044,
        LOCATION_LATITUDE_DEG: 54.5437527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016800',
        LOCATION_NAME: 'Faversham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8945089,
        LOCATION_LATITUDE_DEG: 51.3141143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016900',
        LOCATION_NAME: 'Fawdington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3328582,
        LOCATION_LATITUDE_DEG: 54.1509158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018300',
        LOCATION_NAME: 'Fawdon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6458886,
        LOCATION_LATITUDE_DEG: 55.0172919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017000',
        LOCATION_NAME: 'Fawkham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2850233,
        LOCATION_LATITUDE_DEG: 51.3662073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017100',
        LOCATION_NAME: 'Fawler',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5381268,
        LOCATION_LATITUDE_DEG: 51.5907736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017200',
        LOCATION_NAME: 'Fawler',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4640293,
        LOCATION_LATITUDE_DEG: 51.8534912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017500',
        LOCATION_NAME: 'Fawley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4335586,
        LOCATION_LATITUDE_DEG: 51.5282672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017400',
        LOCATION_NAME: 'Fawley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3505427,
        LOCATION_LATITUDE_DEG: 50.8298986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017300',
        LOCATION_NAME: 'Fawley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9088707,
        LOCATION_LATITUDE_DEG: 51.5759634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017750',
        LOCATION_NAME: 'Fawsley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1765715,
        LOCATION_LATITUDE_DEG: 52.2116059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017800',
        LOCATION_NAME: 'Faxfleet',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6917797,
        LOCATION_LATITUDE_DEG: 53.7068596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017900',
        LOCATION_NAME: 'Faygate',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2605718,
        LOCATION_LATITUDE_DEG: 51.1022095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018000',
        LOCATION_NAME: 'Fazakerley',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9216492,
        LOCATION_LATITUDE_DEG: 53.4684644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018100',
        LOCATION_NAME: 'Fazeley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6950552,
        LOCATION_LATITUDE_DEG: 52.6139745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000400',
        LOCATION_NAME: 'Fearby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7040368,
        LOCATION_LATITUDE_DEG: 54.2241281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000500',
        LOCATION_NAME: 'Fearn',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.950594,
        LOCATION_LATITUDE_DEG: 57.7713982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000600',
        LOCATION_NAME: 'Fearnan',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0799835,
        LOCATION_LATITUDE_DEG: 56.5764828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000700',
        LOCATION_NAME: 'Fearnhead',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5564849,
        LOCATION_LATITUDE_DEG: 53.4116607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000800',
        LOCATION_NAME: 'Featherstone',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0851801,
        LOCATION_LATITUDE_DEG: 52.6426753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000900',
        LOCATION_NAME: 'Featherstone',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3574456,
        LOCATION_LATITUDE_DEG: 53.6751712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001000',
        LOCATION_NAME: 'Featherstone Castle',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5089934,
        LOCATION_LATITUDE_DEG: 54.9435046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001100',
        LOCATION_NAME: 'Feckenham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B96',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9878115,
        LOCATION_LATITUDE_DEG: 52.2496431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001400',
        LOCATION_NAME: 'Feeny',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0220053,
        LOCATION_LATITUDE_DEG: 54.8938423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001500',
        LOCATION_NAME: 'Feering',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7179093,
        LOCATION_LATITUDE_DEG: 51.8493677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001700',
        LOCATION_NAME: 'Felbridge',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0317085,
        LOCATION_LATITUDE_DEG: 51.1162084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001800',
        LOCATION_NAME: 'Felbrigg',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2801009,
        LOCATION_LATITUDE_DEG: 52.909061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001900',
        LOCATION_NAME: 'Felcourt',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0210288,
        LOCATION_LATITUDE_DEG: 51.1581119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002000',
        LOCATION_NAME: 'Felden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4930637,
        LOCATION_LATITUDE_DEG: 51.732371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002100',
        LOCATION_NAME: 'Felhampton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8181178,
        LOCATION_LATITUDE_DEG: 52.4805679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002300',
        LOCATION_NAME: 'Felindre',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9697069,
        LOCATION_LATITUDE_DEG: 51.7044074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002200',
        LOCATION_NAME: 'Felindre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2220234,
        LOCATION_LATITUDE_DEG: 52.4229739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002500',
        LOCATION_NAME: 'Felinfach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1500621,
        LOCATION_LATITUDE_DEG: 52.1795553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002400',
        LOCATION_NAME: 'Felinfach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3242993,
        LOCATION_LATITUDE_DEG: 51.9892304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002600',
        LOCATION_NAME: 'Felinfoel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1446962,
        LOCATION_LATITUDE_DEG: 51.6980146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002700',
        LOCATION_NAME: 'Felingerrig',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8310327,
        LOCATION_LATITUDE_DEG: 52.5937932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE990197',
        LOCATION_NAME: 'Felingwm',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1703411,
        LOCATION_LATITUDE_DEG: 51.9078488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002800',
        LOCATION_NAME: 'Felinheli',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2085783,
        LOCATION_LATITUDE_DEG: 53.1834543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE002900',
        LOCATION_NAME: 'Felinwynt',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6021263,
        LOCATION_LATITUDE_DEG: 52.1230575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003000',
        LOCATION_NAME: 'Felixkirk',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2820183,
        LOCATION_LATITUDE_DEG: 54.2553229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003100',
        LOCATION_NAME: 'Felixstowe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3509508,
        LOCATION_LATITUDE_DEG: 51.960769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003200',
        LOCATION_NAME: 'Fellbeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6887046,
        LOCATION_LATITUDE_DEG: 54.0925156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003300',
        LOCATION_NAME: 'Felling',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5670571,
        LOCATION_LATITUDE_DEG: 54.9519957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003400',
        LOCATION_NAME: 'Felliscliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6446702,
        LOCATION_LATITUDE_DEG: 54.0079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003500',
        LOCATION_NAME: 'Fellside',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0829846,
        LOCATION_LATITUDE_DEG: 54.961303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003600',
        LOCATION_NAME: 'Felmersham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5489375,
        LOCATION_LATITUDE_DEG: 52.2092169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003700',
        LOCATION_NAME: 'Felmingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3408092,
        LOCATION_LATITUDE_DEG: 52.8142468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003800',
        LOCATION_NAME: 'Felpham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6832794,
        LOCATION_LATITUDE_DEG: 50.794884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE003900',
        LOCATION_NAME: 'Felsham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8454205,
        LOCATION_LATITUDE_DEG: 52.1771916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004000',
        LOCATION_NAME: 'Felsted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4349239,
        LOCATION_LATITUDE_DEG: 51.8561717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004100',
        LOCATION_NAME: 'Feltham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3033995,
        LOCATION_LATITUDE_DEG: 51.21027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004200',
        LOCATION_NAME: 'Feltham',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4074934,
        LOCATION_LATITUDE_DEG: 51.4468427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004300',
        LOCATION_NAME: 'Felthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2124507,
        LOCATION_LATITUDE_DEG: 52.7177406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004600',
        LOCATION_NAME: 'Felton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6874539,
        LOCATION_LATITUDE_DEG: 51.3861651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004500',
        LOCATION_NAME: 'Felton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6136125,
        LOCATION_LATITUDE_DEG: 52.1294322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004400',
        LOCATION_NAME: 'Felton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7085923,
        LOCATION_LATITUDE_DEG: 55.2973322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004700',
        LOCATION_NAME: 'Felton Butler',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8981978,
        LOCATION_LATITUDE_DEG: 52.7517967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004800',
        LOCATION_NAME: 'Feltwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5158424,
        LOCATION_LATITUDE_DEG: 52.4854248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE004900',
        LOCATION_NAME: 'Fen Ditton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1749997,
        LOCATION_LATITUDE_DEG: 52.2199085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005000',
        LOCATION_NAME: 'Fen Drayton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0367416,
        LOCATION_LATITUDE_DEG: 52.2955183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005200',
        LOCATION_NAME: 'Fenay Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7225127,
        LOCATION_LATITUDE_DEG: 53.6352677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005300',
        LOCATION_NAME: 'Fence',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2640122,
        LOCATION_LATITUDE_DEG: 53.8314951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005400',
        LOCATION_NAME: 'Fencehouses',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4991448,
        LOCATION_LATITUDE_DEG: 54.8438851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005500',
        LOCATION_NAME: 'Fencott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1642027,
        LOCATION_LATITUDE_DEG: 51.8409884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005600',
        LOCATION_NAME: 'Fendom',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9915591,
        LOCATION_LATITUDE_DEG: 57.8178091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005700',
        LOCATION_NAME: 'Fengate',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2194074,
        LOCATION_LATITUDE_DEG: 52.5730446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005800',
        LOCATION_NAME: 'Fenham',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6550755,
        LOCATION_LATITUDE_DEG: 54.9838317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005900',
        LOCATION_NAME: 'Feniscowles',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5360833,
        LOCATION_LATITUDE_DEG: 53.7233832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006100',
        LOCATION_NAME: 'Feniton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2781699,
        LOCATION_LATITUDE_DEG: 50.7852124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006200',
        LOCATION_NAME: 'Fenn Gate',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3968976,
        LOCATION_LATITUDE_DEG: 52.560476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006300',
        LOCATION_NAME: 'Fenn Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3358362,
        LOCATION_LATITUDE_DEG: 52.44656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006500',
        LOCATION_NAME: 'Fennifach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4278469,
        LOCATION_LATITUDE_DEG: 51.9485256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006550',
        LOCATION_NAME: 'Fennington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1225563,
        LOCATION_LATITUDE_DEG: 51.0724461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006700',
        LOCATION_NAME: 'Fenns Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7340883,
        LOCATION_LATITUDE_DEG: 52.9471148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006800',
        LOCATION_NAME: 'Fenny Bentley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7390343,
        LOCATION_LATITUDE_DEG: 53.048914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006900',
        LOCATION_NAME: 'Fenny Bridges',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.259203,
        LOCATION_LATITUDE_DEG: 50.7800133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007000',
        LOCATION_NAME: 'Fenny Compton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.390159,
        LOCATION_LATITUDE_DEG: 52.1667221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007100',
        LOCATION_NAME: 'Fenny Drayton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.483027,
        LOCATION_LATITUDE_DEG: 52.5680595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007200',
        LOCATION_NAME: 'Fenny Stratford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7146101,
        LOCATION_LATITUDE_DEG: 51.9981952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007300',
        LOCATION_NAME: 'Fenstanton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0656711,
        LOCATION_LATITUDE_DEG: 52.2967152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007900',
        LOCATION_NAME: 'Fenton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7760144,
        LOCATION_LATITUDE_DEG: 54.8964005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007700',
        LOCATION_NAME: 'Fenton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1503212,
        LOCATION_LATITUDE_DEG: 52.9963148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007500',
        LOCATION_NAME: 'Fenton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8121648,
        LOCATION_LATITUDE_DEG: 53.3379329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007400',
        LOCATION_NAME: 'Fenton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7294896,
        LOCATION_LATITUDE_DEG: 53.279318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007600',
        LOCATION_NAME: 'Fenton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.687821,
        LOCATION_LATITUDE_DEG: 53.0458026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE007800',
        LOCATION_NAME: 'Fenton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0600586,
        LOCATION_LATITUDE_DEG: 52.3965299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008000',
        LOCATION_NAME: 'Fenton Pitts',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7295718,
        LOCATION_LATITUDE_DEG: 50.4345982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008400',
        LOCATION_NAME: 'Fenwick',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4441894,
        LOCATION_LATITUDE_DEG: 55.6563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008100',
        LOCATION_NAME: 'Fenwick',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9105685,
        LOCATION_LATITUDE_DEG: 55.0509099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008300',
        LOCATION_NAME: 'Fenwick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8946874,
        LOCATION_LATITUDE_DEG: 55.6541657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008200',
        LOCATION_NAME: 'Fenwick',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0989301,
        LOCATION_LATITUDE_DEG: 53.6390572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008500',
        LOCATION_NAME: 'Feock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0484842,
        LOCATION_LATITUDE_DEG: 50.2052744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008700',
        LOCATION_NAME: 'Feorlig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.498463,
        LOCATION_LATITUDE_DEG: 57.4137923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008825',
        LOCATION_NAME: 'Fercarry',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1920085,
        LOCATION_LATITUDE_DEG: -2.9018462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008900',
        LOCATION_NAME: 'Ferguslie Park',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4414591,
        LOCATION_LATITUDE_DEG: 55.8507167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009100',
        LOCATION_NAME: 'Fern',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8452516,
        LOCATION_LATITUDE_DEG: 56.7443907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009200',
        LOCATION_NAME: 'Fernagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1883997,
        LOCATION_LATITUDE_DEG: 54.6243938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009300',
        LOCATION_NAME: 'Ferncliffe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8236913,
        LOCATION_LATITUDE_DEG: 53.8475935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009400',
        LOCATION_NAME: 'Ferndale',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4474623,
        LOCATION_LATITUDE_DEG: 51.6622999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009500',
        LOCATION_NAME: 'Ferndown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8889488,
        LOCATION_LATITUDE_DEG: 50.8006972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009600',
        LOCATION_NAME: 'Ferne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0955144,
        LOCATION_LATITUDE_DEG: 51.0039176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009700',
        LOCATION_NAME: 'Ferness',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7296438,
        LOCATION_LATITUDE_DEG: 57.4831736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE990462',
        LOCATION_NAME: 'Ferneylea',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009800',
        LOCATION_NAME: 'Fernham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5761282,
        LOCATION_LATITUDE_DEG: 51.6244766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009900',
        LOCATION_NAME: 'Fernhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.206674,
        LOCATION_LATITUDE_DEG: 55.8077116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010000',
        LOCATION_NAME: 'Fernhill Gate',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.460789,
        LOCATION_LATITUDE_DEG: 53.5656729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010100',
        LOCATION_NAME: 'Fernhill Heath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1933083,
        LOCATION_LATITUDE_DEG: 52.2277353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010200',
        LOCATION_NAME: 'Fernhurst',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7163448,
        LOCATION_LATITUDE_DEG: 51.0482048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010300',
        LOCATION_NAME: 'Ferniegair',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0077612,
        LOCATION_LATITUDE_DEG: 55.7671062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010400',
        LOCATION_NAME: 'Fernilea',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3705889,
        LOCATION_LATITUDE_DEG: 57.3132785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010500',
        LOCATION_NAME: 'Fernilee',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9742617,
        LOCATION_LATITUDE_DEG: 53.3035411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010700',
        LOCATION_NAME: 'Ferrensby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4354534,
        LOCATION_LATITUDE_DEG: 54.0406008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010800',
        LOCATION_NAME: 'Ferrindonald',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8658236,
        LOCATION_LATITUDE_DEG: 57.0980558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010900',
        LOCATION_NAME: 'Ferring',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4402769,
        LOCATION_LATITUDE_DEG: 50.8062784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011200',
        LOCATION_NAME: 'Ferry Nab',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9248835,
        LOCATION_LATITUDE_DEG: 54.3502533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011500',
        LOCATION_NAME: 'Ferrybridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2718479,
        LOCATION_LATITUDE_DEG: 53.7118704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011600',
        LOCATION_NAME: 'Ferryden',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4638736,
        LOCATION_LATITUDE_DEG: 56.7010823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011700',
        LOCATION_NAME: 'Ferryhill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5476469,
        LOCATION_LATITUDE_DEG: 54.6873666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011800',
        LOCATION_NAME: 'Ferryside',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3678341,
        LOCATION_LATITUDE_DEG: 51.7673157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011900',
        LOCATION_NAME: 'Fersfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0363183,
        LOCATION_LATITUDE_DEG: 52.4035152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012000',
        LOCATION_NAME: 'Ferwig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6518742,
        LOCATION_LATITUDE_DEG: 52.1143577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012100',
        LOCATION_NAME: 'Feshie Bridge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8956167,
        LOCATION_LATITUDE_DEG: 57.1151692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012200',
        LOCATION_NAME: 'Fetcham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3513129,
        LOCATION_LATITUDE_DEG: 51.28903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012500',
        LOCATION_NAME: 'Fetlar',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8558765,
        LOCATION_LATITUDE_DEG: 60.601646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012600',
        LOCATION_NAME: 'Fetterangus',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0220061,
        LOCATION_LATITUDE_DEG: 57.5476548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012700',
        LOCATION_NAME: 'Fettercairn',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5742673,
        LOCATION_LATITUDE_DEG: 56.8511987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012800',
        LOCATION_NAME: 'Fevig',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6673534,
        LOCATION_LATITUDE_DEG: 58.3415878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012900',
        LOCATION_NAME: 'Fewcott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2139632,
        LOCATION_LATITUDE_DEG: 51.947798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE013100',
        LOCATION_NAME: 'Fewston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7097376,
        LOCATION_LATITUDE_DEG: 53.9840028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000100',
        LOCATION_NAME: 'Ffair Rhos',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8496581,
        LOCATION_LATITUDE_DEG: 52.2953652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000200',
        LOCATION_NAME: 'Ffairfach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9924857,
        LOCATION_LATITUDE_DEG: 51.8747257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000300',
        LOCATION_NAME: 'Ffarmers',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9710848,
        LOCATION_LATITUDE_DEG: 52.0840488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000400',
        LOCATION_NAME: 'Ffawyddog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1466449,
        LOCATION_LATITUDE_DEG: 51.8533143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000500',
        LOCATION_NAME: 'Ffestiniog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9322571,
        LOCATION_LATITUDE_DEG: 52.9600262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000600',
        LOCATION_NAME: 'Fforddlas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1604614,
        LOCATION_LATITUDE_DEG: 52.0424299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000700',
        LOCATION_NAME: 'Fforest',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0532951,
        LOCATION_LATITUDE_DEG: 51.722213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000800',
        LOCATION_NAME: 'Fforestfach',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9832595,
        LOCATION_LATITUDE_DEG: 51.6468999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF000900',
        LOCATION_NAME: 'Ffostrasol',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3758086,
        LOCATION_LATITUDE_DEG: 52.1021517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF001000',
        LOCATION_NAME: 'Ffosyffin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2711546,
        LOCATION_LATITUDE_DEG: 52.2230158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF001100',
        LOCATION_NAME: 'Ffriddgate',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8419336,
        LOCATION_LATITUDE_DEG: 52.606195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF001200',
        LOCATION_NAME: 'Ffrith',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0689259,
        LOCATION_LATITUDE_DEG: 53.0916344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF001300',
        LOCATION_NAME: 'Ffrwdgrech',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4120555,
        LOCATION_LATITUDE_DEG: 51.9350205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF001400',
        LOCATION_NAME: 'Ffynnon Gynydd',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2207657,
        LOCATION_LATITUDE_DEG: 52.0624396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF001500',
        LOCATION_NAME: 'Ffynnonddrain',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3203393,
        LOCATION_LATITUDE_DEG: 51.8705312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FF001600',
        LOCATION_NAME: 'Ffynnongroyw',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2983293,
        LOCATION_LATITUDE_DEG: 53.3300569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000200',
        LOCATION_NAME: 'Fiddington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.11797,
        LOCATION_LATITUDE_DEG: 51.1569476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000100',
        LOCATION_NAME: 'Fiddington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1167942,
        LOCATION_LATITUDE_DEG: 51.9788138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000300',
        LOCATION_NAME: 'Fiddleford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2776277,
        LOCATION_LATITUDE_DEG: 50.9167149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000400',
        LOCATION_NAME: 'Fiddlers Hamlet',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1324659,
        LOCATION_LATITUDE_DEG: 51.6884613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000600',
        LOCATION_NAME: 'Field',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9593223,
        LOCATION_LATITUDE_DEG: 52.8989031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000700',
        LOCATION_NAME: 'Field Assarts',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5416854,
        LOCATION_LATITUDE_DEG: 51.8220953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000800',
        LOCATION_NAME: 'Field Aston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3601851,
        LOCATION_LATITUDE_DEG: 52.7538952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000900',
        LOCATION_NAME: 'Field Broughton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9410265,
        LOCATION_LATITUDE_DEG: 54.2256445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001000',
        LOCATION_NAME: 'Field Common',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3800423,
        LOCATION_LATITUDE_DEG: 51.3851403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001100',
        LOCATION_NAME: 'Field Dalling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9852065,
        LOCATION_LATITUDE_DEG: 52.9105663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001300',
        LOCATION_NAME: 'Fifehead Magdalen',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.311621,
        LOCATION_LATITUDE_DEG: 50.9919217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001400',
        LOCATION_NAME: 'Fifehead Neville',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.325903,
        LOCATION_LATITUDE_DEG: 50.8967146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013800',
        LOCATION_NAME: 'Fifehead St Quintin',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001500',
        LOCATION_NAME: 'Fifehead St. Quintin',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3214417,
        LOCATION_LATITUDE_DEG: 50.8911151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001700',
        LOCATION_NAME: 'Fifield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6534211,
        LOCATION_LATITUDE_DEG: 51.8668982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001600',
        LOCATION_NAME: 'Fifield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6926003,
        LOCATION_LATITUDE_DEG: 51.4842461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001800',
        LOCATION_NAME: 'Fifield Bavant',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9756007,
        LOCATION_LATITUDE_DEG: 51.0251242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001900',
        LOCATION_NAME: 'Figheldean',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.780346,
        LOCATION_LATITUDE_DEG: 51.2216354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002000',
        LOCATION_NAME: 'Figyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2291722,
        LOCATION_LATITUDE_DEG: 52.6689957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002100',
        LOCATION_NAME: 'Filands',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.085194,
        LOCATION_LATITUDE_DEG: 51.5925775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002200',
        LOCATION_NAME: 'Filby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6447057,
        LOCATION_LATITUDE_DEG: 52.6591255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002300',
        LOCATION_NAME: 'Filchampstead',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3401194,
        LOCATION_LATITUDE_DEG: 51.747482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002400',
        LOCATION_NAME: 'Filching',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2228936,
        LOCATION_LATITUDE_DEG: 50.8033763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002500',
        LOCATION_NAME: 'Filey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2901964,
        LOCATION_LATITUDE_DEG: 54.2100055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002600',
        LOCATION_NAME: 'Filford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7915878,
        LOCATION_LATITUDE_DEG: 50.7724053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002700',
        LOCATION_NAME: 'Filgrave',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7266324,
        LOCATION_LATITUDE_DEG: 52.1268152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002800',
        LOCATION_NAME: 'Filham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9012051,
        LOCATION_LATITUDE_DEG: 50.3860811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI002900',
        LOCATION_NAME: 'Filkins',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6516905,
        LOCATION_LATITUDE_DEG: 51.7391876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003000',
        LOCATION_NAME: 'Filleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8867277,
        LOCATION_LATITUDE_DEG: 51.0415434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003100',
        LOCATION_NAME: 'Fillingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5648341,
        LOCATION_LATITUDE_DEG: 53.3606304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003200',
        LOCATION_NAME: 'Fillongley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5855388,
        LOCATION_LATITUDE_DEG: 52.4829583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014200',
        LOCATION_NAME: 'Filton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5622121,
        LOCATION_LATITUDE_DEG: 51.5290339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014100',
        LOCATION_NAME: 'Filton Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5792162,
        LOCATION_LATITUDE_DEG: 51.5090596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014700',
        LOCATION_NAME: 'Filwood Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5820512,
        LOCATION_LATITUDE_DEG: 51.4238851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003300',
        LOCATION_NAME: 'Fimber',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6347998,
        LOCATION_LATITUDE_DEG: 54.0330976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003400',
        LOCATION_NAME: 'Finaghy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.983002,
        LOCATION_LATITUDE_DEG: 54.5661061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003600',
        LOCATION_NAME: 'Finavon',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8239311,
        LOCATION_LATITUDE_DEG: 56.7063828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003700',
        LOCATION_NAME: 'Fincastle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8387044,
        LOCATION_LATITUDE_DEG: 56.7334981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003800',
        LOCATION_NAME: 'Fincham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4942102,
        LOCATION_LATITUDE_DEG: 52.6288465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003900',
        LOCATION_NAME: 'Finchampstead',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8562593,
        LOCATION_LATITUDE_DEG: 51.3619427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004000',
        LOCATION_NAME: 'Finchdean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9502962,
        LOCATION_LATITUDE_DEG: 50.908594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004100',
        LOCATION_NAME: 'Finchfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.173172,
        LOCATION_LATITUDE_DEG: 52.5798684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004200',
        LOCATION_NAME: 'Finchingfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4516151,
        LOCATION_LATITUDE_DEG: 51.9669797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014300',
        LOCATION_NAME: 'Finchley',
        COUNTY_NAME: 'London',
        POSTCODE: 'N3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1944903,
        LOCATION_LATITUDE_DEG: 51.6029847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004300',
        LOCATION_NAME: 'Findern',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5419781,
        LOCATION_LATITUDE_DEG: 52.8702915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004400',
        LOCATION_NAME: 'Findhorn',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6083642,
        LOCATION_LATITUDE_DEG: 57.6591859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004500',
        LOCATION_NAME: 'Findo Gask',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6139758,
        LOCATION_LATITUDE_DEG: 56.3625632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004600',
        LOCATION_NAME: 'Findochty',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9041742,
        LOCATION_LATITUDE_DEG: 57.6966786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004700',
        LOCATION_NAME: 'Findon',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1051787,
        LOCATION_LATITUDE_DEG: 57.0686114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004800',
        LOCATION_NAME: 'Findon',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4056513,
        LOCATION_LATITUDE_DEG: 50.8676905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI004900',
        LOCATION_NAME: 'Finedon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6489653,
        LOCATION_LATITUDE_DEG: 52.3385309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005000',
        LOCATION_NAME: 'Fineshade',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5650811,
        LOCATION_LATITUDE_DEG: 52.5681538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005100',
        LOCATION_NAME: 'Fingest',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8794011,
        LOCATION_LATITUDE_DEG: 51.6122682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005200',
        LOCATION_NAME: 'Finghall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7205655,
        LOCATION_LATITUDE_DEG: 54.3024381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005300',
        LOCATION_NAME: 'Fingland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1602988,
        LOCATION_LATITUDE_DEG: 54.9028118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005400',
        LOCATION_NAME: 'Finglesham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3467249,
        LOCATION_LATITUDE_DEG: 51.2359941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005500',
        LOCATION_NAME: 'Fingringhoe',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9459857,
        LOCATION_LATITUDE_DEG: 51.8442596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005600',
        LOCATION_NAME: 'Finkley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4446676,
        LOCATION_LATITUDE_DEG: 51.2319361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005700',
        LOCATION_NAME: 'Finkley Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4500426,
        LOCATION_LATITUDE_DEG: 51.2208371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005800',
        LOCATION_NAME: 'Finlaystone',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6180089,
        LOCATION_LATITUDE_DEG: 55.9270279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI005900',
        LOCATION_NAME: 'Finmere',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.073639,
        LOCATION_LATITUDE_DEG: 51.990407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006100',
        LOCATION_NAME: 'Finnieston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2901695,
        LOCATION_LATITUDE_DEG: 55.8659139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006200',
        LOCATION_NAME: 'Finningham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0284573,
        LOCATION_LATITUDE_DEG: 52.2840016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006300',
        LOCATION_NAME: 'Finningley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9888526,
        LOCATION_LATITUDE_DEG: 53.4863496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006500',
        LOCATION_NAME: 'Finsbay',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.92303,
        LOCATION_LATITUDE_DEG: 57.7749283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014400',
        LOCATION_NAME: 'Finsbury Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'N4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0975098,
        LOCATION_LATITUDE_DEG: 51.5660272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006600',
        LOCATION_NAME: 'Finstall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0313598,
        LOCATION_LATITUDE_DEG: 52.3258499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006700',
        LOCATION_NAME: 'Finsthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9706705,
        LOCATION_LATITUDE_DEG: 54.2827486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006800',
        LOCATION_NAME: 'Finstock',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4752917,
        LOCATION_LATITUDE_DEG: 51.8439924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006900',
        LOCATION_NAME: 'Finstown',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.113601,
        LOCATION_LATITUDE_DEG: 59.0069157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007000',
        LOCATION_NAME: 'Fintona',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3185423,
        LOCATION_LATITUDE_DEG: 54.4998069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007200',
        LOCATION_NAME: 'Fintray',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2634894,
        LOCATION_LATITUDE_DEG: 57.2369295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007300',
        LOCATION_NAME: 'Fintry',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2234562,
        LOCATION_LATITUDE_DEG: 56.0557308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007500',
        LOCATION_NAME: 'Finvoy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4989419,
        LOCATION_LATITUDE_DEG: 54.9999562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007600',
        LOCATION_NAME: 'Finzean',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6493731,
        LOCATION_LATITUDE_DEG: 57.0216105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007700',
        LOCATION_NAME: 'Fionnphort',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3639012,
        LOCATION_LATITUDE_DEG: 56.3249833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007800',
        LOCATION_NAME: 'Fir Tree',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7813354,
        LOCATION_LATITUDE_DEG: 54.7041734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007900',
        LOCATION_NAME: 'Firbank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5768031,
        LOCATION_LATITUDE_DEG: 54.3417495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008000',
        LOCATION_NAME: 'Firbeck',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1542884,
        LOCATION_LATITUDE_DEG: 53.3894388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008100',
        LOCATION_NAME: 'Firby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5886417,
        LOCATION_LATITUDE_DEG: 54.2729291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008200',
        LOCATION_NAME: 'Firby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8605735,
        LOCATION_LATITUDE_DEG: 54.0883054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008300',
        LOCATION_NAME: 'Firgrove',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1203078,
        LOCATION_LATITUDE_DEG: 53.6146737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014900',
        LOCATION_NAME: 'Firhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2697388,
        LOCATION_LATITUDE_DEG: 55.8836854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008500',
        LOCATION_NAME: 'Firle',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0962811,
        LOCATION_LATITUDE_DEG: 50.8465752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008700',
        LOCATION_NAME: 'Firsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1818943,
        LOCATION_LATITUDE_DEG: 53.1528975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008800',
        LOCATION_NAME: 'Firsdown',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6976063,
        LOCATION_LATITUDE_DEG: 51.0981291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008900',
        LOCATION_NAME: 'Firswood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2796284,
        LOCATION_LATITUDE_DEG: 53.4510603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014000',
        LOCATION_NAME: 'Firth Park',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4489977,
        LOCATION_LATITUDE_DEG: 53.4181767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009000',
        LOCATION_NAME: 'Fishbourne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8141597,
        LOCATION_LATITUDE_DEG: 50.8352857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009100',
        LOCATION_NAME: 'Fishburn',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.434766,
        LOCATION_LATITUDE_DEG: 54.682965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009200',
        LOCATION_NAME: 'Fishcross',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7681518,
        LOCATION_LATITUDE_DEG: 56.1384353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009400',
        LOCATION_NAME: 'Fisherford',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5504366,
        LOCATION_LATITUDE_DEG: 57.4120507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009500',
        LOCATION_NAME: 'Fisherie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3083795,
        LOCATION_LATITUDE_DEG: 57.604065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009600',
        LOCATION_NAME: 'Fishermead',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7495786,
        LOCATION_LATITUDE_DEG: 52.0366987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009700',
        LOCATION_NAME: 'Fisherrow',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0627718,
        LOCATION_LATITUDE_DEG: 55.9450081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013700',
        LOCATION_NAME: 'Fishers Brook',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009300',
        LOCATION_NAME: "Fisher's Brook",
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0086935,
        LOCATION_LATITUDE_DEG: 51.4532608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009800',
        LOCATION_NAME: 'Fishers Pond',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3079539,
        LOCATION_LATITUDE_DEG: 50.9853322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009900',
        LOCATION_NAME: 'Fishersgate',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2175362,
        LOCATION_LATITUDE_DEG: 50.8311768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010100',
        LOCATION_NAME: 'Fisherton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7359781,
        LOCATION_LATITUDE_DEG: 55.4166739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010200',
        LOCATION_NAME: 'Fisherton de la Mere',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9952531,
        LOCATION_LATITUDE_DEG: 51.1467319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI990466',
        LOCATION_NAME: 'Fisherwick',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010300',
        LOCATION_NAME: 'Fisherwick Wood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7455213,
        LOCATION_LATITUDE_DEG: 52.6837811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010400',
        LOCATION_NAME: 'Fishguard',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9739045,
        LOCATION_LATITUDE_DEG: 51.9928426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010500',
        LOCATION_NAME: 'Fishlake',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.009213,
        LOCATION_LATITUDE_DEG: 53.6105612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010600',
        LOCATION_NAME: 'Fishley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5503133,
        LOCATION_LATITUDE_DEG: 52.6497248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010700',
        LOCATION_NAME: 'Fishmore',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7140104,
        LOCATION_LATITUDE_DEG: 52.3782561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010800',
        LOCATION_NAME: 'Fishponds',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5319459,
        LOCATION_LATITUDE_DEG: 51.4828722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010900',
        LOCATION_NAME: 'Fishpool',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2965733,
        LOCATION_LATITUDE_DEG: 53.5853671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011000',
        LOCATION_NAME: 'Fishtoft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0268128,
        LOCATION_LATITUDE_DEG: 52.9615801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI990524',
        LOCATION_NAME: 'Fishwick Mains',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011100',
        LOCATION_NAME: 'Fiskerton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9041036,
        LOCATION_LATITUDE_DEG: 53.0510035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011200',
        LOCATION_NAME: 'Fiskerton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4261633,
        LOCATION_LATITUDE_DEG: 53.2352146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011300',
        LOCATION_NAME: 'Fitling',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0966066,
        LOCATION_LATITUDE_DEG: 53.7935601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011400',
        LOCATION_NAME: 'Fittleton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7879917,
        LOCATION_LATITUDE_DEG: 51.2469376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011500',
        LOCATION_NAME: 'Fittleworth',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5626551,
        LOCATION_LATITUDE_DEG: 50.9644995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011600',
        LOCATION_NAME: 'Fitton End',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1149705,
        LOCATION_LATITUDE_DEG: 52.6932561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011700',
        LOCATION_NAME: 'Fitzhead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2554808,
        LOCATION_LATITUDE_DEG: 51.0473417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011800',
        LOCATION_NAME: 'Fitzwilliam',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3740086,
        LOCATION_LATITUDE_DEG: 53.6322626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI011900',
        LOCATION_NAME: 'Five Acres',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6206913,
        LOCATION_LATITUDE_DEG: 51.8054074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012000',
        LOCATION_NAME: 'Five Ash Down',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0928943,
        LOCATION_LATITUDE_DEG: 50.9976917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012100',
        LOCATION_NAME: 'Five Ashes',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2215947,
        LOCATION_LATITUDE_DEG: 51.0045878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012200',
        LOCATION_NAME: 'Five Bells',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3377321,
        LOCATION_LATITUDE_DEG: 51.1704512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012400',
        LOCATION_NAME: 'Five Bridges',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3818439,
        LOCATION_LATITUDE_DEG: 50.8757247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012300',
        LOCATION_NAME: 'Five Bridges',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5010663,
        LOCATION_LATITUDE_DEG: 52.1200284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012500',
        LOCATION_NAME: 'Five Lane Ends',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7348853,
        LOCATION_LATITUDE_DEG: 53.8231868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012600',
        LOCATION_NAME: 'Five Lanes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5095551,
        LOCATION_LATITUDE_DEG: 50.5966098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012700',
        LOCATION_NAME: 'Five Oak Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3585374,
        LOCATION_LATITUDE_DEG: 51.1830025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012800',
        LOCATION_NAME: 'Five Oaks',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4337794,
        LOCATION_LATITUDE_DEG: 51.0443006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012850',
        LOCATION_NAME: 'Five Points',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI012900',
        LOCATION_NAME: 'Five Roads',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.186808,
        LOCATION_LATITUDE_DEG: 51.7261168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014600',
        LOCATION_NAME: 'Five Ways',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9129882,
        LOCATION_LATITUDE_DEG: 52.4705433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013100',
        LOCATION_NAME: 'Fivehead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9224883,
        LOCATION_LATITUDE_DEG: 51.0013311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013400',
        LOCATION_NAME: 'Fivemiletown',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3261413,
        LOCATION_LATITUDE_DEG: 54.3774941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013500',
        LOCATION_NAME: 'Fivepenny',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2488233,
        LOCATION_LATITUDE_DEG: 58.5009945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013600',
        LOCATION_NAME: 'Fixby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7914895,
        LOCATION_LATITUDE_DEG: 53.6739716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000100',
        LOCATION_NAME: 'Flackwell Heath',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7080296,
        LOCATION_LATITUDE_DEG: 51.600759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000200',
        LOCATION_NAME: 'Fladbury',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0070836,
        LOCATION_LATITUDE_DEG: 52.1151223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000300',
        LOCATION_NAME: 'Flagg',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7954473,
        LOCATION_LATITUDE_DEG: 53.2118249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000400',
        LOCATION_NAME: 'Flaggoners Green',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5195006,
        LOCATION_LATITUDE_DEG: 52.1853355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000600',
        LOCATION_NAME: 'Flakebridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4577053,
        LOCATION_LATITUDE_DEG: 54.5921742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000700',
        LOCATION_NAME: 'Flamborough',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1231884,
        LOCATION_LATITUDE_DEG: 54.1163968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000800',
        LOCATION_NAME: 'Flamstead',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4357245,
        LOCATION_LATITUDE_DEG: 51.8191762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000900',
        LOCATION_NAME: 'Flanderwell',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2825879,
        LOCATION_LATITUDE_DEG: 53.4274425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001000',
        LOCATION_NAME: 'Flansham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6364753,
        LOCATION_LATITUDE_DEG: 50.802288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001100',
        LOCATION_NAME: 'Flanshaw',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5280855,
        LOCATION_LATITUDE_DEG: 53.6765044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001200',
        LOCATION_NAME: 'Flasby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0826465,
        LOCATION_LATITUDE_DEG: 54.0071113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL990821',
        LOCATION_NAME: 'Flash',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001300',
        LOCATION_NAME: 'Flashbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3776862,
        LOCATION_LATITUDE_DEG: 52.8242011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001400',
        LOCATION_NAME: 'Flaunden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5292469,
        LOCATION_LATITUDE_DEG: 51.6969659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001500',
        LOCATION_NAME: 'Flawborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8331373,
        LOCATION_LATITUDE_DEG: 52.9770903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001600',
        LOCATION_NAME: 'Flawith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2631414,
        LOCATION_LATITUDE_DEG: 54.0826082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001700',
        LOCATION_NAME: 'Flax Bourton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7038665,
        LOCATION_LATITUDE_DEG: 51.4207709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001800',
        LOCATION_NAME: 'Flaxby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3960803,
        LOCATION_LATITUDE_DEG: 54.0154026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL001900',
        LOCATION_NAME: 'Flaxley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4529475,
        LOCATION_LATITUDE_DEG: 51.8353075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002000',
        LOCATION_NAME: 'Flaxpool',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2247456,
        LOCATION_LATITUDE_DEG: 51.1083476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002100',
        LOCATION_NAME: 'Flaxton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9617081,
        LOCATION_LATITUDE_DEG: 54.051997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002200',
        LOCATION_NAME: 'Fleckney',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0426414,
        LOCATION_LATITUDE_DEG: 52.5348555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002300',
        LOCATION_NAME: 'Flecknoe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2445945,
        LOCATION_LATITUDE_DEG: 52.2666308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002400',
        LOCATION_NAME: 'Fledborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7914983,
        LOCATION_LATITUDE_DEG: 53.2395148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002700',
        LOCATION_NAME: 'Fleet',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5181237,
        LOCATION_LATITUDE_DEG: 50.6226916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002500',
        LOCATION_NAME: 'Fleet',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8406407,
        LOCATION_LATITUDE_DEG: 51.2761291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002600',
        LOCATION_NAME: 'Fleet',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0610083,
        LOCATION_LATITUDE_DEG: 52.7927609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002800',
        LOCATION_NAME: 'Fleet Hargate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0708657,
        LOCATION_LATITUDE_DEG: 52.8041621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL002900',
        LOCATION_NAME: 'Fleet Marston',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8958743,
        LOCATION_LATITUDE_DEG: 51.841986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL007400',
        LOCATION_NAME: 'Fleet Street',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.059667,
        LOCATION_LATITUDE_DEG: 52.2397845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003000',
        LOCATION_NAME: 'Fleetwood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0072522,
        LOCATION_LATITUDE_DEG: 53.9238149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL990474',
        LOCATION_NAME: 'Fleggborough',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003100',
        LOCATION_NAME: 'Fleggburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6212934,
        LOCATION_LATITUDE_DEG: 52.6674273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003200',
        LOCATION_NAME: 'Flemingston',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4137867,
        LOCATION_LATITUDE_DEG: 51.4208777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003300',
        LOCATION_NAME: 'Flemington',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1348926,
        LOCATION_LATITUDE_DEG: 55.8102104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003400',
        LOCATION_NAME: 'Flempton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6585149,
        LOCATION_LATITUDE_DEG: 52.2971066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003500',
        LOCATION_NAME: 'Flesherin',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1737074,
        LOCATION_LATITUDE_DEG: 58.2501726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003600',
        LOCATION_NAME: 'Fletchers Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6761722,
        LOCATION_LATITUDE_DEG: 50.4610012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003700',
        LOCATION_NAME: 'Fletchertown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2336742,
        LOCATION_LATITUDE_DEG: 54.7747986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003800',
        LOCATION_NAME: 'Fletching',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0359194,
        LOCATION_LATITUDE_DEG: 50.9920969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004000',
        LOCATION_NAME: 'Flete',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9260009,
        LOCATION_LATITUDE_DEG: 50.3462831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL003900',
        LOCATION_NAME: 'Flete',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3742309,
        LOCATION_LATITUDE_DEG: 51.3606108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004100',
        LOCATION_NAME: 'Fleur de Lis',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.218995,
        LOCATION_LATITUDE_DEG: 51.6597947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004200',
        LOCATION_NAME: 'Flexbury',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5403056,
        LOCATION_LATITUDE_DEG: 50.8349343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004300',
        LOCATION_NAME: 'Flexcombe',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9129941,
        LOCATION_LATITUDE_DEG: 51.038112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004400',
        LOCATION_NAME: 'Flexford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6654163,
        LOCATION_LATITUDE_DEG: 51.2427228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004500',
        LOCATION_NAME: 'Flichity',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2045166,
        LOCATION_LATITUDE_DEG: 57.3373648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004600',
        LOCATION_NAME: 'Flimby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5148235,
        LOCATION_LATITUDE_DEG: 54.6872909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004700',
        LOCATION_NAME: 'Flimwell',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4478369,
        LOCATION_LATITUDE_DEG: 51.0547899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004800',
        LOCATION_NAME: 'Flint',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1351752,
        LOCATION_LATITUDE_DEG: 53.2480483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL004900',
        LOCATION_NAME: 'Flint Cross',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0523291,
        LOCATION_LATITUDE_DEG: 52.0693031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005000',
        LOCATION_NAME: 'Flint Mountain',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1378376,
        LOCATION_LATITUDE_DEG: 53.221843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005100',
        LOCATION_NAME: 'Flintham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8963754,
        LOCATION_LATITUDE_DEG: 53.0059969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005200',
        LOCATION_NAME: 'Flinton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1446113,
        LOCATION_LATITUDE_DEG: 53.8078612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL990516',
        LOCATION_NAME: 'Flitch Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005300',
        LOCATION_NAME: 'Flitcham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.566825,
        LOCATION_LATITUDE_DEG: 52.8101592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005400',
        LOCATION_NAME: 'Flitton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4561467,
        LOCATION_LATITUDE_DEG: 52.0101981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005500',
        LOCATION_NAME: 'Flitwick',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.492729,
        LOCATION_LATITUDE_DEG: 52.0031003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005600',
        LOCATION_NAME: 'Flixborough',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6827761,
        LOCATION_LATITUDE_DEG: 53.6244583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005700',
        LOCATION_NAME: 'Flixton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3832666,
        LOCATION_LATITUDE_DEG: 53.4423586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005800',
        LOCATION_NAME: 'Flixton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3985399,
        LOCATION_LATITUDE_DEG: 54.2011026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL005900',
        LOCATION_NAME: 'Flixton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3987216,
        LOCATION_LATITUDE_DEG: 52.4319074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL990349',
        LOCATION_NAME: 'Flixton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7062253,
        LOCATION_LATITUDE_DEG: 52.5026945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006000',
        LOCATION_NAME: 'Flockton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.632237,
        LOCATION_LATITUDE_DEG: 53.6309702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006100',
        LOCATION_NAME: 'Flockton Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6708598,
        LOCATION_LATITUDE_DEG: 53.6255632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006200',
        LOCATION_NAME: 'Flodabay',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.885185,
        LOCATION_LATITUDE_DEG: 57.7944356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006300',
        LOCATION_NAME: 'Flodigarry',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2573499,
        LOCATION_LATITUDE_DEG: 57.6628118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006400',
        LOCATION_NAME: 'Floodgates',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0450612,
        LOCATION_LATITUDE_DEG: 52.2062456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006500',
        LOCATION_NAME: 'Flookburgh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9680843,
        LOCATION_LATITUDE_DEG: 54.1743378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL007500',
        LOCATION_NAME: 'Floore',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006600',
        LOCATION_NAME: 'Flordon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2259335,
        LOCATION_LATITUDE_DEG: 52.5288217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006700',
        LOCATION_NAME: 'Flore',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.058265,
        LOCATION_LATITUDE_DEG: 52.236824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL901850',
        LOCATION_NAME: 'Florence Court',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL901900',
        LOCATION_NAME: 'Florence Court Demesne',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7121777,
        LOCATION_LATITUDE_DEG: 54.2581609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006800',
        LOCATION_NAME: 'Flotta',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.125394,
        LOCATION_LATITUDE_DEG: 58.8266001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL006900',
        LOCATION_NAME: 'Flotterton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0030571,
        LOCATION_LATITUDE_DEG: 55.3160397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL007000',
        LOCATION_NAME: 'Flowton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0385962,
        LOCATION_LATITUDE_DEG: 52.0800852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL007100',
        LOCATION_NAME: 'Flush',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6802774,
        LOCATION_LATITUDE_DEG: 53.7079752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL007200',
        LOCATION_NAME: 'Flushing',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0709404,
        LOCATION_LATITUDE_DEG: 50.1648714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL007300',
        LOCATION_NAME: 'Flyford Flavell',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.030359,
        LOCATION_LATITUDE_DEG: 52.1927333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000100',
        LOCATION_NAME: 'Fobbing',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4756549,
        LOCATION_LATITUDE_DEG: 51.528042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000200',
        LOCATION_NAME: 'Fobdown',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1872265,
        LOCATION_LATITUDE_DEG: 51.0979165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000300',
        LOCATION_NAME: 'Fochabers',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0937621,
        LOCATION_LATITUDE_DEG: 57.613778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000400',
        LOCATION_NAME: 'Fochriw',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.297732,
        LOCATION_LATITUDE_DEG: 51.739409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000500',
        LOCATION_NAME: 'Fodderty',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4888863,
        LOCATION_LATITUDE_DEG: 57.6030953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000600',
        LOCATION_NAME: 'Foel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4925809,
        LOCATION_LATITUDE_DEG: 52.6916955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000700',
        LOCATION_NAME: 'Foelgastell',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1098698,
        LOCATION_LATITUDE_DEG: 51.8126206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000800',
        LOCATION_NAME: 'Foggathorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8536685,
        LOCATION_LATITUDE_DEG: 53.8291765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001100',
        LOCATION_NAME: 'Foindle',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0975266,
        LOCATION_LATITUDE_DEG: 58.3870792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001200',
        LOCATION_NAME: 'Folda',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3223542,
        LOCATION_LATITUDE_DEG: 56.7594903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001300',
        LOCATION_NAME: 'Fole',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9337123,
        LOCATION_LATITUDE_DEG: 52.9334055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001400',
        LOCATION_NAME: 'Folke',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4850542,
        LOCATION_LATITUDE_DEG: 50.9189154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001500',
        LOCATION_NAME: 'Folkestone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1756982,
        LOCATION_LATITUDE_DEG: 51.0780809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001600',
        LOCATION_NAME: 'Folkingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4063356,
        LOCATION_LATITUDE_DEG: 52.8895765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001700',
        LOCATION_NAME: 'Folkington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2142912,
        LOCATION_LATITUDE_DEG: 50.8132725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001800',
        LOCATION_NAME: 'Folksworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.310173,
        LOCATION_LATITUDE_DEG: 52.4947424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001900',
        LOCATION_NAME: 'Folkton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.386209,
        LOCATION_LATITUDE_DEG: 54.2000031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002000',
        LOCATION_NAME: 'Follifoot',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.479302,
        LOCATION_LATITUDE_DEG: 53.9682948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002100',
        LOCATION_NAME: 'Folly Gate',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0214379,
        LOCATION_LATITUDE_DEG: 50.7621226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002200',
        LOCATION_NAME: 'Fonaby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3268201,
        LOCATION_LATITUDE_DEG: 53.5118374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002300',
        LOCATION_NAME: 'Fonmon',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3684474,
        LOCATION_LATITUDE_DEG: 51.3991757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002400',
        LOCATION_NAME: 'Fonthill Bishop',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0908616,
        LOCATION_LATITUDE_DEG: 51.0956339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002500',
        LOCATION_NAME: 'Fonthill Gifford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1070796,
        LOCATION_LATITUDE_DEG: 51.086726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002600',
        LOCATION_NAME: 'Fontmell Magna',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1819218,
        LOCATION_LATITUDE_DEG: 50.9495133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002700',
        LOCATION_NAME: 'Fontmell Parva',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2427267,
        LOCATION_LATITUDE_DEG: 50.930013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002900',
        LOCATION_NAME: 'Fontwell',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6453367,
        LOCATION_LATITUDE_DEG: 50.8560857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003000',
        LOCATION_NAME: 'Foodieash',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0033172,
        LOCATION_LATITUDE_DEG: 56.3381526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003100',
        LOCATION_NAME: 'Foolow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.712754,
        LOCATION_LATITUDE_DEG: 53.2875378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003200',
        LOCATION_NAME: 'Footherley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8367421,
        LOCATION_LATITUDE_DEG: 52.6246748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003300',
        LOCATION_NAME: 'Forbes',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.747857,
        LOCATION_LATITUDE_DEG: 57.2473336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003400',
        LOCATION_NAME: 'Forcett',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7275954,
        LOCATION_LATITUDE_DEG: 54.5060535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004200',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4335819,
        LOCATION_LATITUDE_DEG: 56.1775564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004100',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1683288,
        LOCATION_LATITUDE_DEG: 50.3842852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004000',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7002271,
        LOCATION_LATITUDE_DEG: 50.2505703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023400',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9966867,
        LOCATION_LATITUDE_DEG: 53.4816076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004300',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.867001,
        LOCATION_LATITUDE_DEG: 52.7171981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003900',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2292064,
        LOCATION_LATITUDE_DEG: 51.4721643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003800',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0832353,
        LOCATION_LATITUDE_DEG: 55.6313665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003700',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9041441,
        LOCATION_LATITUDE_DEG: 53.0827217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003600',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7737651,
        LOCATION_LATITUDE_DEG: 51.0945241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO003500',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.872479,
        LOCATION_LATITUDE_DEG: 51.7771804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004400',
        LOCATION_NAME: 'Ford',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.579088,
        LOCATION_LATITUDE_DEG: 50.8220827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004500',
        LOCATION_NAME: 'Ford Bridge',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7164286,
        LOCATION_LATITUDE_DEG: 52.1915424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004600',
        LOCATION_NAME: 'Ford End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4329774,
        LOCATION_LATITUDE_DEG: 51.8246704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004700',
        LOCATION_NAME: 'Ford Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1661277,
        LOCATION_LATITUDE_DEG: 53.0536152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004800',
        LOCATION_NAME: 'Ford Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8816482,
        LOCATION_LATITUDE_DEG: 52.6960963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO004900',
        LOCATION_NAME: 'Ford Street',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2047714,
        LOCATION_LATITUDE_DEG: 50.9581275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005000',
        LOCATION_NAME: 'Forda',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2057077,
        LOCATION_LATITUDE_DEG: 51.1302553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005100',
        LOCATION_NAME: 'Fordbridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7471365,
        LOCATION_LATITUDE_DEG: 52.4832611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005200',
        LOCATION_NAME: 'Fordcombe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.182781,
        LOCATION_LATITUDE_DEG: 51.1406065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005300',
        LOCATION_NAME: 'Forde Abbey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9053637,
        LOCATION_LATITUDE_DEG: 50.8419181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005400',
        LOCATION_NAME: 'Fordel Mains',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9963987,
        LOCATION_LATITUDE_DEG: 55.8890025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005500',
        LOCATION_NAME: 'Fordell',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3573253,
        LOCATION_LATITUDE_DEG: 56.0824244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005600',
        LOCATION_NAME: 'Forden',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1404902,
        LOCATION_LATITUDE_DEG: 52.601387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005750',
        LOCATION_NAME: 'Forder',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2348615,
        LOCATION_LATITUDE_DEG: 50.4010344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005700',
        LOCATION_NAME: 'Forder',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2106234,
        LOCATION_LATITUDE_DEG: 50.3304782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005800',
        LOCATION_NAME: 'Fordgate',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9665753,
        LOCATION_LATITUDE_DEG: 51.0891377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006000',
        LOCATION_NAME: 'Fordham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3849331,
        LOCATION_LATITUDE_DEG: 52.570441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO005900',
        LOCATION_NAME: 'Fordham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3922579,
        LOCATION_LATITUDE_DEG: 52.3109148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006100',
        LOCATION_NAME: 'Fordham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8037273,
        LOCATION_LATITUDE_DEG: 51.91777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006200',
        LOCATION_NAME: 'Fordham Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8194997,
        LOCATION_LATITUDE_DEG: 51.902768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006300',
        LOCATION_NAME: 'Fordhouses',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1348616,
        LOCATION_LATITUDE_DEG: 52.6247735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006400',
        LOCATION_NAME: 'Fordingbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7870536,
        LOCATION_LATITUDE_DEG: 50.9281106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006500',
        LOCATION_NAME: 'Fordington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1272806,
        LOCATION_LATITUDE_DEG: 53.2227082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006600',
        LOCATION_NAME: 'Fordon',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.391304,
        LOCATION_LATITUDE_DEG: 54.1612004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006700',
        LOCATION_NAME: 'Fordoun',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4105573,
        LOCATION_LATITUDE_DEG: 56.8742967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006800',
        LOCATION_NAME: 'Fordscroft',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8162895,
        LOCATION_LATITUDE_DEG: 50.8901157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007000',
        LOCATION_NAME: 'Fordton Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.644903,
        LOCATION_LATITUDE_DEG: 50.7767131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007100',
        LOCATION_NAME: 'Fordwells',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5514891,
        LOCATION_LATITUDE_DEG: 51.821189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007200',
        LOCATION_NAME: 'Fordwich',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1278395,
        LOCATION_LATITUDE_DEG: 51.2948052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007300',
        LOCATION_NAME: 'Fordyce',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7438463,
        LOCATION_LATITUDE_DEG: 57.6618775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007500',
        LOCATION_NAME: 'Forehill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6175307,
        LOCATION_LATITUDE_DEG: 55.4530784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007700',
        LOCATION_NAME: 'Forest',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.601993,
        LOCATION_LATITUDE_DEG: 49.430801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007800',
        LOCATION_NAME: 'Forest',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1167072,
        LOCATION_LATITUDE_DEG: 51.3881593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007900',
        LOCATION_NAME: 'Forest Coal Pit',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.035628,
        LOCATION_LATITUDE_DEG: 51.8791178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008000',
        LOCATION_NAME: 'Forest Corner',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7463828,
        LOCATION_LATITUDE_DEG: 50.8494984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008100',
        LOCATION_NAME: 'Forest Deer',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2484291,
        LOCATION_LATITUDE_DEG: 51.0653322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008200',
        LOCATION_NAME: 'Forest Fields',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.163453,
        LOCATION_LATITUDE_DEG: 52.9684016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023500',
        LOCATION_NAME: 'Forest Gate',
        COUNTY_NAME: 'London',
        POSTCODE: 'E7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0248048,
        LOCATION_LATITUDE_DEG: 51.5514067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008500',
        LOCATION_NAME: 'Forest Green',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5797392,
        LOCATION_LATITUDE_DEG: 51.8718073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008300',
        LOCATION_NAME: 'Forest Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2257976,
        LOCATION_LATITUDE_DEG: 51.700092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008400',
        LOCATION_NAME: 'Forest Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.393071,
        LOCATION_LATITUDE_DEG: 51.1585186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022900',
        LOCATION_NAME: 'Forest Hall',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.569156,
        LOCATION_LATITUDE_DEG: 55.0229042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008600',
        LOCATION_NAME: 'Forest Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6521761,
        LOCATION_LATITUDE_DEG: 54.9107085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008700',
        LOCATION_NAME: 'Forest Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1517859,
        LOCATION_LATITUDE_DEG: 51.7662817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023300',
        LOCATION_NAME: 'Forest Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0439411,
        LOCATION_LATITUDE_DEG: 51.447644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008800',
        LOCATION_NAME: 'Forest Holme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2421207,
        LOCATION_LATITUDE_DEG: 53.7243826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009300',
        LOCATION_NAME: 'Forest in Teesdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2088668,
        LOCATION_LATITUDE_DEG: 54.6610227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO008900',
        LOCATION_NAME: 'Forest Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4800757,
        LOCATION_LATITUDE_DEG: 53.9930984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009000',
        LOCATION_NAME: 'Forest Row',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'RH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0347935,
        LOCATION_LATITUDE_DEG: 51.0978996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009100',
        LOCATION_NAME: 'Forest Town',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1580047,
        LOCATION_LATITUDE_DEG: 53.1535114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009400',
        LOCATION_NAME: 'Forestburn Gate',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8949594,
        LOCATION_LATITUDE_DEG: 55.2607258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009500',
        LOCATION_NAME: 'Forestmill',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6851304,
        LOCATION_LATITUDE_DEG: 56.1259443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009600',
        LOCATION_NAME: 'Forfar',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8871093,
        LOCATION_LATITUDE_DEG: 56.6442747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009700',
        LOCATION_NAME: 'Forgandenny',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4764354,
        LOCATION_LATITUDE_DEG: 56.347653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009800',
        LOCATION_NAME: 'Forge',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.825757,
        LOCATION_LATITUDE_DEG: 52.5833899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO009900',
        LOCATION_NAME: 'Forge Side',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0921691,
        LOCATION_LATITUDE_DEG: 51.7696097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010000',
        LOCATION_NAME: 'Forgue',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6512442,
        LOCATION_LATITUDE_DEG: 57.4957581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010100',
        LOCATION_NAME: 'Forkhill',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4489686,
        LOCATION_LATITUDE_DEG: 54.0831624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010200',
        LOCATION_NAME: 'Formby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0550696,
        LOCATION_LATITUDE_DEG: 53.5573765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022400',
        LOCATION_NAME: 'Forncett St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022500',
        LOCATION_NAME: 'Forncett St Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010400',
        LOCATION_NAME: 'Forncett St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1904182,
        LOCATION_LATITUDE_DEG: 52.4995186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010500',
        LOCATION_NAME: 'Forncett St. Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1876737,
        LOCATION_LATITUDE_DEG: 52.4905171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010600',
        LOCATION_NAME: 'Forneth',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.471518,
        LOCATION_LATITUDE_DEG: 56.5927835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010700',
        LOCATION_NAME: 'Fornham All Saints',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6935797,
        LOCATION_LATITUDE_DEG: 52.2752032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022600',
        LOCATION_NAME: 'Fornham St Genevieve',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022700',
        LOCATION_NAME: 'Fornham St Martin',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010800',
        LOCATION_NAME: 'Fornham St. Genevieve',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6336864,
        LOCATION_LATITUDE_DEG: 52.2977082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010900',
        LOCATION_NAME: 'Fornham St. Martin',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7156921,
        LOCATION_LATITUDE_DEG: 52.2690032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011000',
        LOCATION_NAME: 'Forrabury',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7155671,
        LOCATION_LATITUDE_DEG: 50.6828172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011100',
        LOCATION_NAME: 'Forres',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6092987,
        LOCATION_LATITUDE_DEG: 57.6113834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011200',
        LOCATION_NAME: 'Forsbrook',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0489069,
        LOCATION_LATITUDE_DEG: 52.9716046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011300',
        LOCATION_NAME: 'Forsinard',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8937535,
        LOCATION_LATITUDE_DEG: 58.3688598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011400',
        LOCATION_NAME: 'Forss',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6525013,
        LOCATION_LATITUDE_DEG: 58.5964833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011500',
        LOCATION_NAME: 'Forston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4748126,
        LOCATION_LATITUDE_DEG: 50.7610032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011600',
        LOCATION_NAME: 'Fort Augustus',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6815509,
        LOCATION_LATITUDE_DEG: 57.1432509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011700',
        LOCATION_NAME: 'Fort George',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0630723,
        LOCATION_LATITUDE_DEG: 57.583188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023600',
        LOCATION_NAME: 'Fort William',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9392333,
        LOCATION_LATITUDE_DEG: 54.6315751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011800',
        LOCATION_NAME: 'Fort William',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1083977,
        LOCATION_LATITUDE_DEG: 56.8189242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO011900',
        LOCATION_NAME: 'Forteviot',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.533261,
        LOCATION_LATITUDE_DEG: 56.3405555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012000',
        LOCATION_NAME: 'Forth',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6878872,
        LOCATION_LATITUDE_DEG: 55.7642046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012200',
        LOCATION_NAME: 'Forthampton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2080068,
        LOCATION_LATITUDE_DEG: 51.9981193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012300',
        LOCATION_NAME: 'Fortingall',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0574334,
        LOCATION_LATITUDE_DEG: 56.5977892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012700',
        LOCATION_NAME: 'Forton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9432395,
        LOCATION_LATITUDE_DEG: 50.8584185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012400',
        LOCATION_NAME: 'Forton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7800502,
        LOCATION_LATITUDE_DEG: 53.954711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012500',
        LOCATION_NAME: 'Forton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3653151,
        LOCATION_LATITUDE_DEG: 52.787891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012600',
        LOCATION_NAME: 'Forton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4017951,
        LOCATION_LATITUDE_DEG: 51.1866337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012800',
        LOCATION_NAME: 'Fortrie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5584322,
        LOCATION_LATITUDE_DEG: 57.4954573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012900',
        LOCATION_NAME: 'Fortrose',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1310143,
        LOCATION_LATITUDE_DEG: 57.5811883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013000',
        LOCATION_NAME: 'Fortuneswell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4386144,
        LOCATION_LATITUDE_DEG: 50.5577849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013100',
        LOCATION_NAME: 'Forty Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6623506,
        LOCATION_LATITUDE_DEG: 51.6126575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013200',
        LOCATION_NAME: 'Forward Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0702241,
        LOCATION_LATITUDE_DEG: 52.1967898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013300',
        LOCATION_NAME: 'Fosbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5410969,
        LOCATION_LATITUDE_DEG: 51.319846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013400',
        LOCATION_NAME: 'Foscot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6377601,
        LOCATION_LATITUDE_DEG: 51.8944024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013500',
        LOCATION_NAME: 'Foscote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0331852,
        LOCATION_LATITUDE_DEG: 52.1204115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013600',
        LOCATION_NAME: 'Fosdyke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0413554,
        LOCATION_LATITUDE_DEG: 52.8723739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013700',
        LOCATION_NAME: 'Fosdyke Bridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0416914,
        LOCATION_LATITUDE_DEG: 52.8721727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013800',
        LOCATION_NAME: 'Fossebridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8836701,
        LOCATION_LATITUDE_DEG: 51.7992907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013900',
        LOCATION_NAME: 'Fossoway',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5652925,
        LOCATION_LATITUDE_DEG: 56.2000444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014000',
        LOCATION_NAME: 'Foster Street',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1572981,
        LOCATION_LATITUDE_DEG: 51.75966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014100',
        LOCATION_NAME: 'Fosterhouses',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0135136,
        LOCATION_LATITUDE_DEG: 53.62516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014200',
        LOCATION_NAME: 'Fosters Booth',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0257767,
        LOCATION_LATITUDE_DEG: 52.1801192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014300',
        LOCATION_NAME: 'Fosterville',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6046625,
        LOCATION_LATITUDE_DEG: 50.5742956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014400',
        LOCATION_NAME: 'Foston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7191929,
        LOCATION_LATITUDE_DEG: 52.8832945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014500',
        LOCATION_NAME: 'Foston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1102506,
        LOCATION_LATITUDE_DEG: 52.5499578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014600',
        LOCATION_NAME: 'Foston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9347716,
        LOCATION_LATITUDE_DEG: 54.0772005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014700',
        LOCATION_NAME: 'Foston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7216785,
        LOCATION_LATITUDE_DEG: 52.9759889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022800',
        LOCATION_NAME: 'Foston on the Wolds',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014800',
        LOCATION_NAME: 'Foston-on-the-Wolds',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3251742,
        LOCATION_LATITUDE_DEG: 53.9903647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO014900',
        LOCATION_NAME: 'Fotherby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0200958,
        LOCATION_LATITUDE_DEG: 53.406027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015000',
        LOCATION_NAME: 'Fotheringhay',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4369102,
        LOCATION_LATITUDE_DEG: 52.5260499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015100',
        LOCATION_NAME: 'Foula',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.077136,
        LOCATION_LATITUDE_DEG: 60.1389144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015200',
        LOCATION_NAME: 'Foulby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3965403,
        LOCATION_LATITUDE_DEG: 53.6547709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015300',
        LOCATION_NAME: 'Foulden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1143424,
        LOCATION_LATITUDE_DEG: 55.7965882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015400',
        LOCATION_NAME: 'Foulden',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6031965,
        LOCATION_LATITUDE_DEG: 52.5586374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015600',
        LOCATION_NAME: 'Foulness',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9016853,
        LOCATION_LATITUDE_DEG: 51.5995415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015700',
        LOCATION_NAME: 'Foulness Island',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9069849,
        LOCATION_LATITUDE_DEG: 51.5970356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015800',
        LOCATION_NAME: 'Foulridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1671648,
        LOCATION_LATITUDE_DEG: 53.8762003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015900',
        LOCATION_NAME: 'Foulsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0118637,
        LOCATION_LATITUDE_DEG: 52.780346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023000',
        LOCATION_NAME: 'Fountain Bridge',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.208346,
        LOCATION_LATITUDE_DEG: 55.9452572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016100',
        LOCATION_NAME: 'Fountainhall',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9070178,
        LOCATION_LATITUDE_DEG: 55.7334911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016200',
        LOCATION_NAME: 'Fountains',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5793536,
        LOCATION_LATITUDE_DEG: 54.1035087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016400',
        LOCATION_NAME: 'Four Ashes',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1205303,
        LOCATION_LATITUDE_DEG: 52.6731771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016500',
        LOCATION_NAME: 'Four Ashes',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7335645,
        LOCATION_LATITUDE_DEG: 51.651469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016600',
        LOCATION_NAME: 'Four Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.113323,
        LOCATION_LATITUDE_DEG: 50.1846779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016700',
        LOCATION_NAME: 'Four Crosses',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0779872,
        LOCATION_LATITUDE_DEG: 52.7578964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016800',
        LOCATION_NAME: 'Four Crosses',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0667064,
        LOCATION_LATITUDE_DEG: 52.6827858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016900',
        LOCATION_NAME: 'Four Elms',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1006304,
        LOCATION_LATITUDE_DEG: 51.2153159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017000',
        LOCATION_NAME: 'Four Gotes',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1482045,
        LOCATION_LATITUDE_DEG: 52.7271529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023700',
        LOCATION_NAME: 'Four Lane Ends',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7914517,
        LOCATION_LATITUDE_DEG: 53.7980124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017100',
        LOCATION_NAME: 'Four Lanes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2373333,
        LOCATION_LATITUDE_DEG: 50.2018793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017200',
        LOCATION_NAME: 'Four Marks',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0484867,
        LOCATION_LATITUDE_DEG: 51.104622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017300',
        LOCATION_NAME: 'Four Mile Bridge',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5844991,
        LOCATION_LATITUDE_DEG: 53.2723682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017500',
        LOCATION_NAME: 'Four Oaks',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4440087,
        LOCATION_LATITUDE_DEG: 51.953514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017600',
        LOCATION_NAME: 'Four Oaks',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8285424,
        LOCATION_LATITUDE_DEG: 52.5792685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017700',
        LOCATION_NAME: 'Four Roads',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2495986,
        LOCATION_LATITUDE_DEG: 51.7610139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017900',
        LOCATION_NAME: 'Four Throws',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5347607,
        LOCATION_LATITUDE_DEG: 51.0394885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018000',
        LOCATION_NAME: 'Four Winds',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6582728,
        LOCATION_LATITUDE_DEG: 50.511204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018300',
        LOCATION_NAME: 'Fourlanesend',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2054242,
        LOCATION_LATITUDE_DEG: 50.338682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018400',
        LOCATION_NAME: 'Fourstones',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1741889,
        LOCATION_LATITUDE_DEG: 55.0055047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018500',
        LOCATION_NAME: 'Fovant',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9904964,
        LOCATION_LATITUDE_DEG: 51.0556223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018600',
        LOCATION_NAME: 'Foveran',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0407195,
        LOCATION_LATITUDE_DEG: 57.3067346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018700',
        LOCATION_NAME: 'Fowey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6385441,
        LOCATION_LATITUDE_DEG: 50.3355842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018800',
        LOCATION_NAME: 'Fowley Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0408056,
        LOCATION_LATITUDE_DEG: 50.7294129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018900',
        LOCATION_NAME: 'Fowlis',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1015552,
        LOCATION_LATITUDE_DEG: 56.4886659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019000',
        LOCATION_NAME: 'Fowlis Easter',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1046816,
        LOCATION_LATITUDE_DEG: 56.4911721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019100',
        LOCATION_NAME: 'Fowlis Wester',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7377531,
        LOCATION_LATITUDE_DEG: 56.3964593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019200',
        LOCATION_NAME: 'Fowlmere',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0761252,
        LOCATION_LATITUDE_DEG: 52.0930996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019300',
        LOCATION_NAME: 'Fownhope',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6106925,
        LOCATION_LATITUDE_DEG: 52.0055229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019400',
        LOCATION_NAME: 'Fox Amport',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5820515,
        LOCATION_LATITUDE_DEG: 51.1923356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019500',
        LOCATION_NAME: 'Fox Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5754757,
        LOCATION_LATITUDE_DEG: 51.0011987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019550',
        LOCATION_NAME: 'Fox Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1177785,
        LOCATION_LATITUDE_DEG: 50.9965279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019600',
        LOCATION_NAME: 'Fox Lane',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7733767,
        LOCATION_LATITUDE_DEG: 51.3117315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019700',
        LOCATION_NAME: 'Fox Milne',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7117539,
        LOCATION_LATITUDE_DEG: 52.0454004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019800',
        LOCATION_NAME: 'Foxbar',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4676973,
        LOCATION_LATITUDE_DEG: 55.8197111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO019900',
        LOCATION_NAME: 'Foxcombe Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2870188,
        LOCATION_LATITUDE_DEG: 51.7110767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020000',
        LOCATION_NAME: 'Foxcote',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9794038,
        LOCATION_LATITUDE_DEG: 51.8665976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020100',
        LOCATION_NAME: 'Foxcotte',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5068556,
        LOCATION_LATITUDE_DEG: 51.2219357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020200',
        LOCATION_NAME: 'Foxdale',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6373287,
        LOCATION_LATITUDE_DEG: 54.1663538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020300',
        LOCATION_NAME: 'Foxearth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6773103,
        LOCATION_LATITUDE_DEG: 52.0692892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020400',
        LOCATION_NAME: 'Foxfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2134274,
        LOCATION_LATITUDE_DEG: 54.2582486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO990678',
        LOCATION_NAME: 'Foxhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020700',
        LOCATION_NAME: 'Foxham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0418625,
        LOCATION_LATITUDE_DEG: 51.4923712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020800',
        LOCATION_NAME: 'Foxhill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6678585,
        LOCATION_LATITUDE_DEG: 51.5269703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020900',
        LOCATION_NAME: 'Foxhole',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8613745,
        LOCATION_LATITUDE_DEG: 50.3573898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021000',
        LOCATION_NAME: 'Foxholes',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4506604,
        LOCATION_LATITUDE_DEG: 54.1431997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021100',
        LOCATION_NAME: 'Foxhunt Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2028107,
        LOCATION_LATITUDE_DEG: 50.9402898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021300',
        LOCATION_NAME: 'Foxley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.150035,
        LOCATION_LATITUDE_DEG: 51.5716772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021400',
        LOCATION_NAME: 'Foxley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0645676,
        LOCATION_LATITUDE_DEG: 52.1599229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021200',
        LOCATION_NAME: 'Foxley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0210597,
        LOCATION_LATITUDE_DEG: 52.7544434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021500',
        LOCATION_NAME: 'Foxt',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9470401,
        LOCATION_LATITUDE_DEG: 53.0342108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021600',
        LOCATION_NAME: 'Foxton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5959059,
        LOCATION_LATITUDE_DEG: 55.399937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021800',
        LOCATION_NAME: 'Foxton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9659728,
        LOCATION_LATITUDE_DEG: 52.5051506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021700',
        LOCATION_NAME: 'Foxton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0600287,
        LOCATION_LATITUDE_DEG: 52.1144976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO021900',
        LOCATION_NAME: 'Foxup',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1990618,
        LOCATION_LATITUDE_DEG: 54.1857308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022000',
        LOCATION_NAME: 'Foy',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5801461,
        LOCATION_LATITUDE_DEG: 51.9553138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022100',
        LOCATION_NAME: 'Foyers',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.489501,
        LOCATION_LATITUDE_DEG: 57.252257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000100',
        LOCATION_NAME: 'Fraddam',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3747023,
        LOCATION_LATITUDE_DEG: 50.1626786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000200',
        LOCATION_NAME: 'Fraddon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9375799,
        LOCATION_LATITUDE_DEG: 50.3853926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000300',
        LOCATION_NAME: 'Fradley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7634114,
        LOCATION_LATITUDE_DEG: 52.7186841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000400',
        LOCATION_NAME: 'Fradley Park',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7836058,
        LOCATION_LATITUDE_DEG: 52.7099837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000500',
        LOCATION_NAME: 'Fradswell',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0150385,
        LOCATION_LATITUDE_DEG: 52.8776019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000600',
        LOCATION_NAME: 'Fraisthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2407534,
        LOCATION_LATITUDE_DEG: 54.0372908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000700',
        LOCATION_NAME: 'Framfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1292023,
        LOCATION_LATITUDE_DEG: 50.9628919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000800',
        LOCATION_NAME: 'Framilode',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3639357,
        LOCATION_LATITUDE_DEG: 51.7894153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR000900',
        LOCATION_NAME: 'Framingham Earl',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3604099,
        LOCATION_LATITUDE_DEG: 52.5747284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001000',
        LOCATION_NAME: 'Framingham Pigot',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3533654,
        LOCATION_LATITUDE_DEG: 52.5826279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001100',
        LOCATION_NAME: 'Framlingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3438367,
        LOCATION_LATITUDE_DEG: 52.2199927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001200',
        LOCATION_NAME: 'Frampton',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4787345,
        LOCATION_LATITUDE_DEG: 51.4178729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001300',
        LOCATION_NAME: 'Frampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5307113,
        LOCATION_LATITUDE_DEG: 50.7536032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001400',
        LOCATION_NAME: 'Frampton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0264637,
        LOCATION_LATITUDE_DEG: 52.9335774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001500',
        LOCATION_NAME: 'Frampton Cotterell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4799697,
        LOCATION_LATITUDE_DEG: 51.5352803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001600',
        LOCATION_NAME: 'Frampton Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0843499,
        LOCATION_LATITUDE_DEG: 52.9639816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001700',
        LOCATION_NAME: 'Frampton Mansell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1114268,
        LOCATION_LATITUDE_DEG: 51.7223859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001900',
        LOCATION_NAME: 'Frampton on Severn',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3665171,
        LOCATION_LATITUDE_DEG: 51.7661986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR001800',
        LOCATION_NAME: 'Frampton West',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0639448,
        LOCATION_LATITUDE_DEG: 52.9543805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002000',
        LOCATION_NAME: 'Framsden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2152591,
        LOCATION_LATITUDE_DEG: 52.1911873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002100',
        LOCATION_NAME: 'Framwellgate Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.588707,
        LOCATION_LATITUDE_DEG: 54.7936844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002200',
        LOCATION_NAME: 'France Lynch',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1403011,
        LOCATION_LATITUDE_DEG: 51.7283888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002300',
        LOCATION_NAME: 'Franche',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2640006,
        LOCATION_LATITUDE_DEG: 52.4001591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002600',
        LOCATION_NAME: 'Frankleigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2529139,
        LOCATION_LATITUDE_DEG: 51.3612541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR990323',
        LOCATION_NAME: 'Frankley Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002700',
        LOCATION_NAME: 'Franksbridge',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2800058,
        LOCATION_LATITUDE_DEG: 52.1932485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002900',
        LOCATION_NAME: 'Frankton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9319411,
        LOCATION_LATITUDE_DEG: 52.8664122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002800',
        LOCATION_NAME: 'Frankton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3759209,
        LOCATION_LATITUDE_DEG: 52.3282428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003000',
        LOCATION_NAME: 'Frant',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2714934,
        LOCATION_LATITUDE_DEG: 51.0955985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003100',
        LOCATION_NAME: 'Fraserburgh',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0048982,
        LOCATION_LATITUDE_DEG: 57.6901694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003200',
        LOCATION_NAME: 'Frating',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0245256,
        LOCATION_LATITUDE_DEG: 51.8620626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003300',
        LOCATION_NAME: 'Fratton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0756993,
        LOCATION_LATITUDE_DEG: 50.7995888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003400',
        LOCATION_NAME: 'Freasley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6447937,
        LOCATION_LATITUDE_DEG: 52.5970665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003500',
        LOCATION_NAME: 'Freathy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2509254,
        LOCATION_LATITUDE_DEG: 50.3458788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003600',
        LOCATION_NAME: 'Freathy Cliff',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2258328,
        LOCATION_LATITUDE_DEG: 50.3395793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003700',
        LOCATION_NAME: 'Frecheville',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4125062,
        LOCATION_LATITUDE_DEG: 53.3482331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003800',
        LOCATION_NAME: 'Freckenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4469055,
        LOCATION_LATITUDE_DEG: 52.3195166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR003900',
        LOCATION_NAME: 'Freckleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8641066,
        LOCATION_LATITUDE_DEG: 53.7547904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004000',
        LOCATION_NAME: 'Free Heath',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3577143,
        LOCATION_LATITUDE_DEG: 51.0840955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004100',
        LOCATION_NAME: 'Freeby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8107547,
        LOCATION_LATITUDE_DEG: 52.7715785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004200',
        LOCATION_NAME: 'Freefolk',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3023242,
        LOCATION_LATITUDE_DEG: 51.234034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004300',
        LOCATION_NAME: 'Freeland',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4020977,
        LOCATION_LATITUDE_DEG: 51.814086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004500',
        LOCATION_NAME: 'Freethorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5576848,
        LOCATION_LATITUDE_DEG: 52.5926258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004650',
        LOCATION_NAME: 'Freiston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6020653,
        LOCATION_LATITUDE_DEG: 53.0172146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004600',
        LOCATION_NAME: 'Freiston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0493459,
        LOCATION_LATITUDE_DEG: 52.9735844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004700',
        LOCATION_NAME: 'Freiston Shore',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0803687,
        LOCATION_LATITUDE_DEG: 52.9613828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004900',
        LOCATION_NAME: 'Fremington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1224914,
        LOCATION_LATITUDE_DEG: 51.0705528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004800',
        LOCATION_NAME: 'Fremington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9287918,
        LOCATION_LATITUDE_DEG: 54.3853422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005000',
        LOCATION_NAME: 'French Walls',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9528495,
        LOCATION_LATITUDE_DEG: 52.4918656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005100',
        LOCATION_NAME: 'Frenchay',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5153406,
        LOCATION_LATITUDE_DEG: 51.4995737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005200',
        LOCATION_NAME: 'Frenchbeer',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8732107,
        LOCATION_LATITUDE_DEG: 50.6566083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005600',
        LOCATION_NAME: 'Frensham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7947587,
        LOCATION_LATITUDE_DEG: 51.1653172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005700',
        LOCATION_NAME: 'Freshbrook',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8341727,
        LOCATION_LATITUDE_DEG: 51.5492738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005800',
        LOCATION_NAME: 'Freshfield',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0687891,
        LOCATION_LATITUDE_DEG: 53.5625767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005900',
        LOCATION_NAME: 'Freshford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3107267,
        LOCATION_LATITUDE_DEG: 51.3415558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006100',
        LOCATION_NAME: 'Freshwater',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5148788,
        LOCATION_LATITUDE_DEG: 50.6813839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006200',
        LOCATION_NAME: 'Freshwater East',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8641594,
        LOCATION_LATITUDE_DEG: 51.649513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006300',
        LOCATION_NAME: 'Fressingfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3187144,
        LOCATION_LATITUDE_DEG: 52.3470028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006400',
        LOCATION_NAME: 'Freston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.161594,
        LOCATION_LATITUDE_DEG: 52.0071721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006500',
        LOCATION_NAME: 'Freswick',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0864918,
        LOCATION_LATITUDE_DEG: 58.5905738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006600',
        LOCATION_NAME: 'Frettenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3253511,
        LOCATION_LATITUDE_DEG: 52.7076362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006700',
        LOCATION_NAME: 'Freuchie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1545937,
        LOCATION_LATITUDE_DEG: 56.2479457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006800',
        LOCATION_NAME: 'Freystrop',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9595054,
        LOCATION_LATITUDE_DEG: 51.7632271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006900',
        LOCATION_NAME: 'Friar Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9837601,
        LOCATION_LATITUDE_DEG: 52.5521671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007000',
        LOCATION_NAME: 'Friar Waddon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5071613,
        LOCATION_LATITUDE_DEG: 50.668195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR990756',
        LOCATION_NAME: 'Friars Cliff',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007100',
        LOCATION_NAME: 'Friars Gate',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1367598,
        LOCATION_LATITUDE_DEG: 51.0772005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007500',
        LOCATION_NAME: 'Frickley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2940338,
        LOCATION_LATITUDE_DEG: 53.5722532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007600',
        LOCATION_NAME: 'Friday Bridge',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1655472,
        LOCATION_LATITUDE_DEG: 52.6203493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007700',
        LOCATION_NAME: 'Friday Street',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.30708,
        LOCATION_LATITUDE_DEG: 50.8041698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007800',
        LOCATION_NAME: 'Fridaythorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6639254,
        LOCATION_LATITUDE_DEG: 54.0200935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007900',
        LOCATION_NAME: 'Friden',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7481723,
        LOCATION_LATITUDE_DEG: 53.1397247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR015600',
        LOCATION_NAME: 'Friern Barnet',
        COUNTY_NAME: 'London',
        POSTCODE: 'N20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR015500',
        LOCATION_NAME: 'Friern Barnet',
        COUNTY_NAME: 'London',
        POSTCODE: 'N12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR015400',
        LOCATION_NAME: 'Friern Barnet',
        COUNTY_NAME: 'London',
        POSTCODE: 'N11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1454828,
        LOCATION_LATITUDE_DEG: 51.616574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008000',
        LOCATION_NAME: 'Friesthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3893819,
        LOCATION_LATITUDE_DEG: 53.3363192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008200',
        LOCATION_NAME: 'Frieth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0085938,
        LOCATION_LATITUDE_DEG: 51.3057447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008100',
        LOCATION_NAME: 'Frieth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8445529,
        LOCATION_LATITUDE_DEG: 51.6063639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008300',
        LOCATION_NAME: 'Frieze Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1143056,
        LOCATION_LATITUDE_DEG: 51.0213337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008400',
        LOCATION_NAME: 'Friggle Street',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2864177,
        LOCATION_LATITUDE_DEG: 51.210043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008500',
        LOCATION_NAME: 'Frilford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3608366,
        LOCATION_LATITUDE_DEG: 51.6703794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008600',
        LOCATION_NAME: 'Frilford Heath',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3548172,
        LOCATION_LATITUDE_DEG: 51.6807777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008700',
        LOCATION_NAME: 'Frilsham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2151445,
        LOCATION_LATITUDE_DEG: 51.4541504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008800',
        LOCATION_NAME: 'Frimley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7363073,
        LOCATION_LATITUDE_DEG: 51.3129292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR008900',
        LOCATION_NAME: 'Frimley Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7237686,
        LOCATION_LATITUDE_DEG: 51.3014347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009000',
        LOCATION_NAME: 'Frindsbury',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.50111,
        LOCATION_LATITUDE_DEG: 51.3991236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009100',
        LOCATION_NAME: 'Fring',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5810946,
        LOCATION_LATITUDE_DEG: 52.8818648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009200',
        LOCATION_NAME: 'Fringford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1213876,
        LOCATION_LATITUDE_DEG: 51.9529974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009300',
        LOCATION_NAME: 'Frinsted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7121859,
        LOCATION_LATITUDE_DEG: 51.2831132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR015300',
        LOCATION_NAME: 'Frinton on Sea',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'CO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009400',
        LOCATION_NAME: 'Frinton-on-Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2465352,
        LOCATION_LATITUDE_DEG: 51.8374566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009500',
        LOCATION_NAME: 'Friockheim',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6670618,
        LOCATION_LATITUDE_DEG: 56.6369776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009600',
        LOCATION_NAME: 'Friog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0493296,
        LOCATION_LATITUDE_DEG: 52.689104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009700',
        LOCATION_NAME: 'Frisby on the Wreake',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9695551,
        LOCATION_LATITUDE_DEG: 52.752277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009800',
        LOCATION_NAME: 'Friskney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1813964,
        LOCATION_LATITUDE_DEG: 53.07519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR009900',
        LOCATION_NAME: 'Friskney Eaudyke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2017373,
        LOCATION_LATITUDE_DEG: 53.0787897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010000',
        LOCATION_NAME: 'Friston',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2007958,
        LOCATION_LATITUDE_DEG: 50.7635701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010100',
        LOCATION_NAME: 'Friston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5301431,
        LOCATION_LATITUDE_DEG: 52.1897868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010200',
        LOCATION_NAME: 'Fritchley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4664606,
        LOCATION_LATITUDE_DEG: 53.07181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010300',
        LOCATION_NAME: 'Frith Bank',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0409219,
        LOCATION_LATITUDE_DEG: 53.0051839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010400',
        LOCATION_NAME: 'Fritham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6698111,
        LOCATION_LATITUDE_DEG: 50.9256075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010500',
        LOCATION_NAME: 'Frithelstock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1879057,
        LOCATION_LATITUDE_DEG: 50.9536394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010600',
        LOCATION_NAME: 'Frithelstockstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2067146,
        LOCATION_LATITUDE_DEG: 50.947268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010700',
        LOCATION_NAME: 'Frithsden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5268993,
        LOCATION_LATITUDE_DEG: 51.7776742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010800',
        LOCATION_NAME: 'Frithville',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0384119,
        LOCATION_LATITUDE_DEG: 53.0371887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR010900',
        LOCATION_NAME: 'Frittenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5951419,
        LOCATION_LATITUDE_DEG: 51.1410032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011100',
        LOCATION_NAME: 'Fritton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.278486,
        LOCATION_LATITUDE_DEG: 52.4867199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011000',
        LOCATION_NAME: 'Fritton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6385124,
        LOCATION_LATITUDE_DEG: 52.5445144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011200',
        LOCATION_NAME: 'Fritwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2315047,
        LOCATION_LATITUDE_DEG: 51.9592977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011300',
        LOCATION_NAME: 'Frizinghall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7779047,
        LOCATION_LATITUDE_DEG: 53.8215843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011400',
        LOCATION_NAME: 'Frizington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4938317,
        LOCATION_LATITUDE_DEG: 54.5401801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011500',
        LOCATION_NAME: 'Frobost',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3792789,
        LOCATION_LATITUDE_DEG: 57.2000749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011600',
        LOCATION_NAME: 'Frocester',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3104634,
        LOCATION_LATITUDE_DEG: 51.7265967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011700',
        LOCATION_NAME: 'Frochas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1903008,
        LOCATION_LATITUDE_DEG: 52.6650946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011800',
        LOCATION_NAME: 'Frodesley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7185057,
        LOCATION_LATITUDE_DEG: 52.6077824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR011900',
        LOCATION_NAME: 'Frodsham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7244167,
        LOCATION_LATITUDE_DEG: 53.2957525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012000',
        LOCATION_NAME: 'Frog Pool',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2925002,
        LOCATION_LATITUDE_DEG: 52.2885467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012100',
        LOCATION_NAME: 'Froggatt',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6305393,
        LOCATION_LATITUDE_DEG: 53.2826367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012200',
        LOCATION_NAME: 'Froghall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9618002,
        LOCATION_LATITUDE_DEG: 53.0228169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012300',
        LOCATION_NAME: 'Frogham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7548643,
        LOCATION_LATITUDE_DEG: 50.9145123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012400',
        LOCATION_NAME: 'Frogham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2314808,
        LOCATION_LATITUDE_DEG: 51.207399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012500',
        LOCATION_NAME: 'Frogholt',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1117907,
        LOCATION_LATITUDE_DEG: 51.1033885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012600',
        LOCATION_NAME: 'Frogmore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7175946,
        LOCATION_LATITUDE_DEG: 50.2700683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012800',
        LOCATION_NAME: 'Frogmore',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7935867,
        LOCATION_LATITUDE_DEG: 51.3339389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012700',
        LOCATION_NAME: 'Frogmore',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3357738,
        LOCATION_LATITUDE_DEG: 51.7202661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR012900',
        LOCATION_NAME: 'Frogpool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1405552,
        LOCATION_LATITUDE_DEG: 50.2165762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013000',
        LOCATION_NAME: 'Frogwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5452476,
        LOCATION_LATITUDE_DEG: 50.9151294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013100',
        LOCATION_NAME: 'Frolesworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.25299,
        LOCATION_LATITUDE_DEG: 52.5087581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013200',
        LOCATION_NAME: 'Frome',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3208048,
        LOCATION_LATITUDE_DEG: 51.2281465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR015200',
        LOCATION_NAME: 'Frome St Quintin',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013300',
        LOCATION_NAME: 'Frome St. Quintin',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5706582,
        LOCATION_LATITUDE_DEG: 50.8207054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013400',
        LOCATION_NAME: 'Frome Vauchurch',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5653575,
        LOCATION_LATITUDE_DEG: 50.7662025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013500',
        LOCATION_NAME: 'Frome Whitfield',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4331561,
        LOCATION_LATITUDE_DEG: 50.721494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013600',
        LOCATION_NAME: 'Fromes Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.466271,
        LOCATION_LATITUDE_DEG: 52.1157292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013800',
        LOCATION_NAME: 'Fron',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2139965,
        LOCATION_LATITUDE_DEG: 52.5701846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013700',
        LOCATION_NAME: 'Fron',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1399411,
        LOCATION_LATITUDE_DEG: 52.6228904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR013900',
        LOCATION_NAME: 'Fron Bache',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1682515,
        LOCATION_LATITUDE_DEG: 52.9645255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014000',
        LOCATION_NAME: 'Fron Goch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6317732,
        LOCATION_LATITUDE_DEG: 52.9423956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014100',
        LOCATION_NAME: 'Froncysyllte',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0845324,
        LOCATION_LATITUDE_DEG: 52.9632241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014300',
        LOCATION_NAME: 'Frostenden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6420915,
        LOCATION_LATITUDE_DEG: 52.3785052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014400',
        LOCATION_NAME: 'Frosterley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9581177,
        LOCATION_LATITUDE_DEG: 54.7276773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014500',
        LOCATION_NAME: 'Frostrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4913441,
        LOCATION_LATITUDE_DEG: 54.3079451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014600',
        LOCATION_NAME: 'Froxfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5705042,
        LOCATION_LATITUDE_DEG: 51.4103528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014700',
        LOCATION_NAME: 'Froyle',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9151918,
        LOCATION_LATITUDE_DEG: 51.1662263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014800',
        LOCATION_NAME: 'Fruix',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4088728,
        LOCATION_LATITUDE_DEG: 56.1697357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014900',
        LOCATION_NAME: 'Fryern Hill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3737419,
        LOCATION_LATITUDE_DEG: 50.9861081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR015000',
        LOCATION_NAME: 'Fryerning',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3719082,
        LOCATION_LATITUDE_DEG: 51.6760529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR015100',
        LOCATION_NAME: 'Fryton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9474066,
        LOCATION_LATITUDE_DEG: 54.1638129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR990934',
        LOCATION_NAME: 'Fryup',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000100',
        LOCATION_NAME: 'Fucheswen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9253231,
        LOCATION_LATITUDE_DEG: 52.9906294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000300',
        LOCATION_NAME: 'Fuge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6396833,
        LOCATION_LATITUDE_DEG: 50.3209723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000500',
        LOCATION_NAME: 'Fulbeck',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5846464,
        LOCATION_LATITUDE_DEG: 53.0414999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000600',
        LOCATION_NAME: 'Fulbeck Heath',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5656033,
        LOCATION_LATITUDE_DEG: 53.0367942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000700',
        LOCATION_NAME: 'Fulbourn',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2238232,
        LOCATION_LATITUDE_DEG: 52.1825042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000800',
        LOCATION_NAME: 'Fulbrook',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6238358,
        LOCATION_LATITUDE_DEG: 51.8143928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000900',
        LOCATION_NAME: 'Fulford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0684072,
        LOCATION_LATITUDE_DEG: 52.9377016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001000',
        LOCATION_NAME: 'Fulford',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0717642,
        LOCATION_LATITUDE_DEG: 53.937387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004900',
        LOCATION_NAME: 'Fulham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU005000',
        LOCATION_NAME: 'Fulham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.198953,
        LOCATION_LATITUDE_DEG: 51.4824512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001100',
        LOCATION_NAME: 'Fulking',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2250844,
        LOCATION_LATITUDE_DEG: 50.8878844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001200',
        LOCATION_NAME: 'Full Sutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8607235,
        LOCATION_LATITUDE_DEG: 53.9878885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001300',
        LOCATION_NAME: 'Fullers Slade',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8306543,
        LOCATION_LATITUDE_DEG: 52.0487085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001400',
        LOCATION_NAME: 'Fullerton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4600732,
        LOCATION_LATITUDE_DEG: 51.1517271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001500',
        LOCATION_NAME: 'Fulletby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0547725,
        LOCATION_LATITUDE_DEG: 53.2401069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001600',
        LOCATION_NAME: 'Fullwood',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4764498,
        LOCATION_LATITUDE_DEG: 55.7202049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004800',
        LOCATION_NAME: 'Fullwood',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5421217,
        LOCATION_LATITUDE_DEG: 53.3658184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001700',
        LOCATION_NAME: 'Fulmer',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5588136,
        LOCATION_LATITUDE_DEG: 51.5610531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001800',
        LOCATION_NAME: 'Fulmodestone',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9590162,
        LOCATION_LATITUDE_DEG: 52.8384543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU001900',
        LOCATION_NAME: 'Fulnetby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3502629,
        LOCATION_LATITUDE_DEG: 53.3006216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002000',
        LOCATION_NAME: 'Fulscot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2102029,
        LOCATION_LATITUDE_DEG: 51.5935665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002100',
        LOCATION_NAME: 'Fulstow',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0021404,
        LOCATION_LATITUDE_DEG: 53.4536327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002200',
        LOCATION_NAME: 'Fulwell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4489081,
        LOCATION_LATITUDE_DEG: 51.9061955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002300',
        LOCATION_NAME: 'Fulwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0900007,
        LOCATION_LATITUDE_DEG: 52.0074036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002400',
        LOCATION_NAME: 'Fulwood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6919543,
        LOCATION_LATITUDE_DEG: 53.7784978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004700',
        LOCATION_NAME: 'Fulwood',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5424561,
        LOCATION_LATITUDE_DEG: 53.3654601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU005100',
        LOCATION_NAME: 'Fulwood Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9413265,
        LOCATION_LATITUDE_DEG: 53.3703746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002500',
        LOCATION_NAME: 'Fundenhall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1839188,
        LOCATION_LATITUDE_DEG: 52.5319213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002600',
        LOCATION_NAME: 'Funtington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8619092,
        LOCATION_LATITUDE_DEG: 50.8685888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002700',
        LOCATION_NAME: 'Funtley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2012763,
        LOCATION_LATITUDE_DEG: 50.8706941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002900',
        LOCATION_NAME: 'Furland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8107894,
        LOCATION_LATITUDE_DEG: 50.9009194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003000',
        LOCATION_NAME: 'Furley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0321559,
        LOCATION_LATITUDE_DEG: 50.8342191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003500',
        LOCATION_NAME: 'Furnace',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1837669,
        LOCATION_LATITUDE_DEG: 56.1521513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003400',
        LOCATION_NAME: 'Furnace',
        COUNTY_NAME: 'Carmarthenshire',
        POSTCODE: 'SA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2579935,
        LOCATION_LATITUDE_DEG: 51.6861146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003300',
        LOCATION_NAME: 'Furnace',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1654906,
        LOCATION_LATITUDE_DEG: 51.6952137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003200',
        LOCATION_NAME: 'Furnace',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9397386,
        LOCATION_LATITUDE_DEG: 52.537893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003600',
        LOCATION_NAME: 'Furnace End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6333968,
        LOCATION_LATITUDE_DEG: 52.5189634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003700',
        LOCATION_NAME: 'Furners Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0124933,
        LOCATION_LATITUDE_DEG: 51.0191984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003800',
        LOCATION_NAME: 'Furness Abbey',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1971271,
        LOCATION_LATITUDE_DEG: 54.1348393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003900',
        LOCATION_NAME: 'Furness Vale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9883117,
        LOCATION_LATITUDE_DEG: 53.3482402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004000',
        LOCATION_NAME: 'Furneux Pelham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0836983,
        LOCATION_LATITUDE_DEG: 51.9314848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004200',
        LOCATION_NAME: 'Furze Hill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7589872,
        LOCATION_LATITUDE_DEG: 50.8985036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004300',
        LOCATION_NAME: 'Furzehill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8226681,
        LOCATION_LATITUDE_DEG: 51.1885609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004400',
        LOCATION_NAME: 'Furzehill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.974957,
        LOCATION_LATITUDE_DEG: 50.8166031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004500',
        LOCATION_NAME: 'Furzey Lodge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4776132,
        LOCATION_LATITUDE_DEG: 50.8196004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004600',
        LOCATION_NAME: 'Furzton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7612462,
        LOCATION_LATITUDE_DEG: 52.0081009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000400',
        LOCATION_NAME: 'Fyfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7878241,
        LOCATION_LATITUDE_DEG: 51.4170537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000300',
        LOCATION_NAME: 'Fyfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7475894,
        LOCATION_LATITUDE_DEG: 51.342847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000100',
        LOCATION_NAME: 'Fyfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7027286,
        LOCATION_LATITUDE_DEG: 51.7330872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000600',
        LOCATION_NAME: 'Fyfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5779821,
        LOCATION_LATITUDE_DEG: 51.2179331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000200',
        LOCATION_NAME: 'Fyfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3881149,
        LOCATION_LATITUDE_DEG: 51.6862793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000500',
        LOCATION_NAME: 'Fyfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2743512,
        LOCATION_LATITUDE_DEG: 51.7387635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000700',
        LOCATION_NAME: 'Fyfield Wick',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3853192,
        LOCATION_LATITUDE_DEG: 51.6715802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000800',
        LOCATION_NAME: 'Fylingdales',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6120952,
        LOCATION_LATITUDE_DEG: 54.4153284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY000900',
        LOCATION_NAME: 'Fylingthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5459004,
        LOCATION_LATITUDE_DEG: 54.4318265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FY001000',
        LOCATION_NAME: 'Fyvie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3905534,
        LOCATION_LATITUDE_DEG: 57.4325468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000100',
        LOCATION_NAME: 'Gabalfa',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1931982,
        LOCATION_LATITUDE_DEG: 51.5026852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000200',
        LOCATION_NAME: 'Gabroc Hill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4646366,
        LOCATION_LATITUDE_DEG: 55.7281014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000400',
        LOCATION_NAME: 'Gaddesby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9788867,
        LOCATION_LATITUDE_DEG: 52.7099741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000500',
        LOCATION_NAME: 'Gaddesden Row',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4759903,
        LOCATION_LATITUDE_DEG: 51.8041744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000600',
        LOCATION_NAME: 'Gadfa',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3244401,
        LOCATION_LATITUDE_DEG: 53.3694766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000700',
        LOCATION_NAME: 'Gadlas',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9318719,
        LOCATION_LATITUDE_DEG: 52.9297162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000800',
        LOCATION_NAME: 'Gadlys',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4492188,
        LOCATION_LATITUDE_DEG: 51.7146078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000900',
        LOCATION_NAME: 'Gaerwen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2761561,
        LOCATION_LATITUDE_DEG: 53.2214585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001000',
        LOCATION_NAME: 'Gagie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9003085,
        LOCATION_LATITUDE_DEG: 56.5321689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001100',
        LOCATION_NAME: 'Gagingwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4062126,
        LOCATION_LATITUDE_DEG: 51.922596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001200',
        LOCATION_NAME: 'Gailey',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1298647,
        LOCATION_LATITUDE_DEG: 52.6935852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001400',
        LOCATION_NAME: 'Gaineys Well',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2056997,
        LOCATION_LATITUDE_DEG: 51.7453956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001500',
        LOCATION_NAME: 'Gainfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4962298,
        LOCATION_LATITUDE_DEG: 51.6691767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001600',
        LOCATION_NAME: 'Gainford',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7348549,
        LOCATION_LATITUDE_DEG: 54.5465603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001700',
        LOCATION_NAME: 'Gains Cross',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2233287,
        LOCATION_LATITUDE_DEG: 50.8882143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001800',
        LOCATION_NAME: 'Gainsborough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7726794,
        LOCATION_LATITUDE_DEG: 53.400537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001900',
        LOCATION_NAME: 'Gainsford End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5152095,
        LOCATION_LATITUDE_DEG: 51.9907846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002100',
        LOCATION_NAME: 'Gairloch',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6852933,
        LOCATION_LATITUDE_DEG: 57.7210195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002200',
        LOCATION_NAME: 'Gairlochy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.996456,
        LOCATION_LATITUDE_DEG: 56.9133291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002300',
        LOCATION_NAME: 'Gairney Bank',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4061567,
        LOCATION_LATITUDE_DEG: 56.1778366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002400',
        LOCATION_NAME: 'Gairsay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9698488,
        LOCATION_LATITUDE_DEG: 59.0825234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002500',
        LOCATION_NAME: 'Gaisgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5545637,
        LOCATION_LATITUDE_DEG: 54.4426571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002600',
        LOCATION_NAME: 'Gaitle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9946771,
        LOCATION_LATITUDE_DEG: 55.0068216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002700',
        LOCATION_NAME: 'Gaitsgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9522037,
        LOCATION_LATITUDE_DEG: 54.8117941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002800',
        LOCATION_NAME: 'Galashiels',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8035926,
        LOCATION_LATITUDE_DEG: 55.6164784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003100',
        LOCATION_NAME: 'Galbally',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8822956,
        LOCATION_LATITUDE_DEG: 54.5332104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003200',
        LOCATION_NAME: 'Galemire',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5392409,
        LOCATION_LATITUDE_DEG: 54.5246801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003300',
        LOCATION_NAME: 'Galgate',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7869082,
        LOCATION_LATITUDE_DEG: 53.9927167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003400',
        LOCATION_NAME: 'Galgorm',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3156263,
        LOCATION_LATITUDE_DEG: 54.8666312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003500',
        LOCATION_NAME: 'Galhampton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5212471,
        LOCATION_LATITUDE_DEG: 51.0662327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003700',
        LOCATION_NAME: 'Gallatown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1375561,
        LOCATION_LATITUDE_DEG: 56.13433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003800',
        LOCATION_NAME: 'Galley Common',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5315111,
        LOCATION_LATITUDE_DEG: 52.5267589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003900',
        LOCATION_NAME: 'Galleywood',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4676285,
        LOCATION_LATITUDE_DEG: 51.6977525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004000',
        LOCATION_NAME: 'Gallowfauld',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9125109,
        LOCATION_LATITUDE_DEG: 56.5689739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023700',
        LOCATION_NAME: 'Gallowgate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6195352,
        LOCATION_LATITUDE_DEG: 54.9741453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004100',
        LOCATION_NAME: 'Gallowhill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8323391,
        LOCATION_LATITUDE_DEG: 55.1310192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004300',
        LOCATION_NAME: 'Gallowstree Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9987892,
        LOCATION_LATITUDE_DEG: 51.5133571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023500',
        LOCATION_NAME: 'Gallt Y Foel',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1203867,
        LOCATION_LATITUDE_DEG: 53.1413666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004500',
        LOCATION_NAME: 'Galltegfa',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3371205,
        LOCATION_LATITUDE_DEG: 53.1083344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004400',
        LOCATION_NAME: 'Gallt-Y-Foel',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1209006,
        LOCATION_LATITUDE_DEG: 53.1393523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004600',
        LOCATION_NAME: 'Galmington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1248053,
        LOCATION_LATITUDE_DEG: 51.004433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004800',
        LOCATION_NAME: 'Galmpton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8392488,
        LOCATION_LATITUDE_DEG: 50.2489655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004900',
        LOCATION_NAME: 'Galmpton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5634151,
        LOCATION_LATITUDE_DEG: 50.3947826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005000',
        LOCATION_NAME: 'Galmpton Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8279918,
        LOCATION_LATITUDE_DEG: 50.2480727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005100',
        LOCATION_NAME: 'Galon Uchaf',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3711232,
        LOCATION_LATITUDE_DEG: 51.7632066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005200',
        LOCATION_NAME: 'Galphay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6132324,
        LOCATION_LATITUDE_DEG: 54.1495181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005300',
        LOCATION_NAME: 'Galston',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3784878,
        LOCATION_LATITUDE_DEG: 55.6003939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005400',
        LOCATION_NAME: 'Galton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3140772,
        LOCATION_LATITUDE_DEG: 50.6667887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005600',
        LOCATION_NAME: 'Gamblesby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.606809,
        LOCATION_LATITUDE_DEG: 54.7485907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005700',
        LOCATION_NAME: 'Gamelsby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1530908,
        LOCATION_LATITUDE_DEG: 54.8607087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005800',
        LOCATION_NAME: 'Gamesley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9845197,
        LOCATION_LATITUDE_DEG: 53.4481503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005900',
        LOCATION_NAME: 'Gamlingay',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.191306,
        LOCATION_LATITUDE_DEG: 52.1552041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006000',
        LOCATION_NAME: 'Gammaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1581545,
        LOCATION_LATITUDE_DEG: 51.0076483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006100',
        LOCATION_NAME: 'Gammersgill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9145967,
        LOCATION_LATITUDE_DEG: 54.2426267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006200',
        LOCATION_NAME: 'Gamrie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.347272,
        LOCATION_LATITUDE_DEG: 57.6531756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006400',
        LOCATION_NAME: 'Gamston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.10252,
        LOCATION_LATITUDE_DEG: 52.9271939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006300',
        LOCATION_NAME: 'Gamston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9366482,
        LOCATION_LATITUDE_DEG: 53.2766253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA990837',
        LOCATION_NAME: 'Ganarew',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006500',
        LOCATION_NAME: 'Ganarew',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6808098,
        LOCATION_LATITUDE_DEG: 51.8435072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006600',
        LOCATION_NAME: 'Ganllwyd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8891379,
        LOCATION_LATITUDE_DEG: 52.8008107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006700',
        LOCATION_NAME: 'Ganstead',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2568684,
        LOCATION_LATITUDE_DEG: 53.7908639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006800',
        LOCATION_NAME: 'Ganthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9456662,
        LOCATION_LATITUDE_DEG: 54.1238058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA006900',
        LOCATION_NAME: 'Ganton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4872198,
        LOCATION_LATITUDE_DEG: 54.1853038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007100',
        LOCATION_NAME: 'Gappah',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6050698,
        LOCATION_LATITUDE_DEG: 50.5842021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007200',
        LOCATION_NAME: 'Gara Bridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7860872,
        LOCATION_LATITUDE_DEG: 50.36648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007400',
        LOCATION_NAME: 'Garboldisham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9486778,
        LOCATION_LATITUDE_DEG: 52.3952122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007500',
        LOCATION_NAME: 'Garden City',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0013627,
        LOCATION_LATITUDE_DEG: 53.2176467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007600',
        LOCATION_NAME: 'Garden Village',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0294797,
        LOCATION_LATITUDE_DEG: 51.6599061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007700',
        LOCATION_NAME: 'Garden Village',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3117433,
        LOCATION_LATITUDE_DEG: 53.7601654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007800',
        LOCATION_NAME: 'Gardenstown',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3318162,
        LOCATION_LATITUDE_DEG: 57.6709773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007900',
        LOCATION_NAME: 'Garderhouse',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4025982,
        LOCATION_LATITUDE_DEG: 60.2127172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008000',
        LOCATION_NAME: 'Garelochhead',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.827066,
        LOCATION_LATITUDE_DEG: 56.081444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008100',
        LOCATION_NAME: 'Garenin',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7949802,
        LOCATION_LATITUDE_DEG: 58.2976979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008200',
        LOCATION_NAME: 'Garford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3825387,
        LOCATION_LATITUDE_DEG: 51.6622765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008300',
        LOCATION_NAME: 'Garforth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3867707,
        LOCATION_LATITUDE_DEG: 53.7918797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008400',
        LOCATION_NAME: 'Gargrave',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1020617,
        LOCATION_LATITUDE_DEG: 53.9841032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008500',
        LOCATION_NAME: 'Gargunnock',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0810895,
        LOCATION_LATITUDE_DEG: 56.1245447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008600',
        LOCATION_NAME: 'Garguston',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3823289,
        LOCATION_LATITUDE_DEG: 57.5165849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008800',
        LOCATION_NAME: 'Garker',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7510921,
        LOCATION_LATITUDE_DEG: 50.359486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008900',
        LOCATION_NAME: 'Garlands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8917587,
        LOCATION_LATITUDE_DEG: 54.878808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009000',
        LOCATION_NAME: 'Garlieston',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3735313,
        LOCATION_LATITUDE_DEG: 54.7889164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009100',
        LOCATION_NAME: 'Garlinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3684201,
        LOCATION_LATITUDE_DEG: 51.3662118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009200',
        LOCATION_NAME: 'Garlinge Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0308925,
        LOCATION_LATITUDE_DEG: 51.2330024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009300',
        LOCATION_NAME: 'Garmond',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3233889,
        LOCATION_LATITUDE_DEG: 57.5604574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009400',
        LOCATION_NAME: 'Garmondsway',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4723671,
        LOCATION_LATITUDE_DEG: 54.7033661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009500',
        LOCATION_NAME: 'Garmouth',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1072182,
        LOCATION_LATITUDE_DEG: 57.6642862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009600',
        LOCATION_NAME: 'Garmston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5811151,
        LOCATION_LATITUDE_DEG: 52.6505865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009700',
        LOCATION_NAME: 'Garnant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9054181,
        LOCATION_LATITUDE_DEG: 51.8013182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009900',
        LOCATION_NAME: 'Garndiffaith',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0646794,
        LOCATION_LATITUDE_DEG: 51.7335053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010000',
        LOCATION_NAME: 'Garndolbenmaen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2382495,
        LOCATION_LATITUDE_DEG: 52.9734316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010100',
        LOCATION_NAME: 'Garnethill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2726766,
        LOCATION_LATITUDE_DEG: 55.8710202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010200',
        LOCATION_NAME: 'Garnett Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7334686,
        LOCATION_LATITUDE_DEG: 54.3865512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010300',
        LOCATION_NAME: 'Garnfadryn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5539767,
        LOCATION_LATITUDE_DEG: 52.8780269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010400',
        LOCATION_NAME: 'Garnkirk',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.115771,
        LOCATION_LATITUDE_DEG: 55.8931158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010500',
        LOCATION_NAME: 'Garnlydan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2090877,
        LOCATION_LATITUDE_DEG: 51.8035092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010600',
        LOCATION_NAME: 'Garnswllt',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.992464,
        LOCATION_LATITUDE_DEG: 51.7624178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010700',
        LOCATION_NAME: 'Garos',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2243334,
        LOCATION_LATITUDE_DEG: 57.5559042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010800',
        LOCATION_NAME: 'Garrabost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2414401,
        LOCATION_LATITUDE_DEG: 58.216866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011500',
        LOCATION_NAME: 'Garras',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2095131,
        LOCATION_LATITUDE_DEG: 50.0704662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011800',
        LOCATION_NAME: 'Garreg',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0655418,
        LOCATION_LATITUDE_DEG: 52.9549336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023900',
        LOCATION_NAME: 'Garretts Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7809857,
        LOCATION_LATITUDE_DEG: 52.4790129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011900',
        LOCATION_NAME: 'Garrigill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3963143,
        LOCATION_LATITUDE_DEG: 54.7682903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012100',
        LOCATION_NAME: 'Garrison',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -8.0824321,
        LOCATION_LATITUDE_DEG: 54.4166092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012000',
        LOCATION_NAME: 'Garrison',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3162825,
        LOCATION_LATITUDE_DEG: 49.9107582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012200',
        LOCATION_NAME: 'Garriston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7599409,
        LOCATION_LATITUDE_DEG: 54.3287327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012400',
        LOCATION_NAME: 'Garrowby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7872661,
        LOCATION_LATITUDE_DEG: 54.0055888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012800',
        LOCATION_NAME: 'Garryheillie',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3738818,
        LOCATION_LATITUDE_DEG: 57.1741784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013200',
        LOCATION_NAME: 'Garrymore',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4589825,
        LOCATION_LATITUDE_DEG: 57.3775895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013300',
        LOCATION_NAME: 'Garrynamonie',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3801419,
        LOCATION_LATITUDE_DEG: 57.1230748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013600',
        LOCATION_NAME: 'Garsdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3871604,
        LOCATION_LATITUDE_DEG: 54.3014394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013700',
        LOCATION_NAME: 'Garsdale Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3283628,
        LOCATION_LATITUDE_DEG: 54.322943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013800',
        LOCATION_NAME: 'Garsdon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0446652,
        LOCATION_LATITUDE_DEG: 51.588976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013900',
        LOCATION_NAME: 'Garshall Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0451121,
        LOCATION_LATITUDE_DEG: 52.9027044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014000',
        LOCATION_NAME: 'Garsington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1595352,
        LOCATION_LATITUDE_DEG: 51.7157733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014100',
        LOCATION_NAME: 'Garstang',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.773883,
        LOCATION_LATITUDE_DEG: 53.9023086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014200',
        LOCATION_NAME: 'Garston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8955869,
        LOCATION_LATITUDE_DEG: 53.3525578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014250',
        LOCATION_NAME: 'Garston',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3912133,
        LOCATION_LATITUDE_DEG: 51.6827731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014300',
        LOCATION_NAME: 'Gartcosh',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0826271,
        LOCATION_LATITUDE_DEG: 55.8877129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014550',
        LOCATION_NAME: 'Garth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.532282,
        LOCATION_LATITUDE_DEG: 52.1367556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014500',
        LOCATION_NAME: 'Garth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1663834,
        LOCATION_LATITUDE_DEG: 52.6904988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014400',
        LOCATION_NAME: 'Garth',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1043061,
        LOCATION_LATITUDE_DEG: 52.9772204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014600',
        LOCATION_NAME: 'Garth Row',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7283347,
        LOCATION_LATITUDE_DEG: 54.3714548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014700',
        LOCATION_NAME: 'Garthamlock',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1377034,
        LOCATION_LATITUDE_DEG: 55.8757131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014800',
        LOCATION_NAME: 'Garthbrengy',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.390328,
        LOCATION_LATITUDE_DEG: 51.9912301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA014900',
        LOCATION_NAME: 'Garthdee',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1275797,
        LOCATION_LATITUDE_DEG: 57.1223159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015000',
        LOCATION_NAME: 'Garthmyl',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1901053,
        LOCATION_LATITUDE_DEG: 52.5821878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015100',
        LOCATION_NAME: 'Garthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7659934,
        LOCATION_LATITUDE_DEG: 52.7790785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015200',
        LOCATION_NAME: 'Garthorpe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7153268,
        LOCATION_LATITUDE_DEG: 53.6620573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015300',
        LOCATION_NAME: 'Gartly',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7958737,
        LOCATION_LATITUDE_DEG: 57.378846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015400',
        LOCATION_NAME: 'Gartmore',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3790648,
        LOCATION_LATITUDE_DEG: 56.1446457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015500',
        LOCATION_NAME: 'Gartnatra',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2631965,
        LOCATION_LATITUDE_DEG: 55.7632278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015600',
        LOCATION_NAME: 'Gartness',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9433445,
        LOCATION_LATITUDE_DEG: 55.8544079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015700',
        LOCATION_NAME: 'Gartocharn',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.523151,
        LOCATION_LATITUDE_DEG: 56.0428364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015800',
        LOCATION_NAME: 'Garton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0788699,
        LOCATION_LATITUDE_DEG: 53.7995616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023400',
        LOCATION_NAME: 'Garton on the Wolds',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA015900',
        LOCATION_NAME: 'Garton-on-the-Wolds',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5025281,
        LOCATION_LATITUDE_DEG: 54.0223895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016000',
        LOCATION_NAME: 'Gartree',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9606512,
        LOCATION_LATITUDE_DEG: 52.4952495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016100',
        LOCATION_NAME: 'Gartymore',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6757612,
        LOCATION_LATITUDE_DEG: 58.1093341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016200',
        LOCATION_NAME: 'Garvagh',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6941684,
        LOCATION_LATITUDE_DEG: 54.9827486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016300',
        LOCATION_NAME: 'Garvaghy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.131321,
        LOCATION_LATITUDE_DEG: 54.4924032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016400',
        LOCATION_NAME: 'Garvald',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6575466,
        LOCATION_LATITUDE_DEG: 55.9286065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016500',
        LOCATION_NAME: 'Garvary',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5662492,
        LOCATION_LATITUDE_DEG: 54.3630565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016600',
        LOCATION_NAME: 'Garve',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6856359,
        LOCATION_LATITUDE_DEG: 57.6150904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016700',
        LOCATION_NAME: 'Garvestone',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9910511,
        LOCATION_LATITUDE_DEG: 52.6260336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016800',
        LOCATION_NAME: 'Garvetagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6914786,
        LOCATION_LATITUDE_DEG: 54.6654259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA016900',
        LOCATION_NAME: 'Garway',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7780944,
        LOCATION_LATITUDE_DEG: 51.900013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017000',
        LOCATION_NAME: 'Garway Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8038681,
        LOCATION_LATITUDE_DEG: 51.9294147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017100',
        LOCATION_NAME: 'Garwick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.242712,
        LOCATION_LATITUDE_DEG: 52.9837823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017200',
        LOCATION_NAME: 'Garynahine',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7054422,
        LOCATION_LATITUDE_DEG: 58.1842073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017300',
        LOCATION_NAME: 'Garyvard',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4783552,
        LOCATION_LATITUDE_DEG: 58.0905618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017400',
        LOCATION_NAME: 'Gasstown',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5741412,
        LOCATION_LATITUDE_DEG: 55.0680266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017500',
        LOCATION_NAME: 'Gastard',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1665481,
        LOCATION_LATITUDE_DEG: 51.4147623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017600',
        LOCATION_NAME: 'Gasthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9051252,
        LOCATION_LATITUDE_DEG: 52.3900135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017700',
        LOCATION_NAME: 'Gatacre',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3076094,
        LOCATION_LATITUDE_DEG: 52.5093673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017800',
        LOCATION_NAME: 'Gatcombe',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3068257,
        LOCATION_LATITUDE_DEG: 50.6642782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA017900',
        LOCATION_NAME: 'Gate Burton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7418094,
        LOCATION_LATITUDE_DEG: 53.3358272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018000',
        LOCATION_NAME: 'Gate Helmsley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9433978,
        LOCATION_LATITUDE_DEG: 53.9896955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023800',
        LOCATION_NAME: 'Gateacre',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.861761,
        LOCATION_LATITUDE_DEG: 53.3858899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018100',
        LOCATION_NAME: 'Gatebeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6937326,
        LOCATION_LATITUDE_DEG: 54.2639411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018200',
        LOCATION_NAME: 'Gateford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1195969,
        LOCATION_LATITUDE_DEG: 53.3266357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018300',
        LOCATION_NAME: 'Gateforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1475615,
        LOCATION_LATITUDE_DEG: 53.7508737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018400',
        LOCATION_NAME: 'Gatehead',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5518495,
        LOCATION_LATITUDE_DEG: 55.5956936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018500',
        LOCATION_NAME: 'Gatehouse of Fleet',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1857964,
        LOCATION_LATITUDE_DEG: 54.8806155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018600',
        LOCATION_NAME: 'Gatelawbridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7272811,
        LOCATION_LATITUDE_DEG: 55.2500507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018700',
        LOCATION_NAME: 'Gateley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9070475,
        LOCATION_LATITUDE_DEG: 52.7817484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018800',
        LOCATION_NAME: 'Gatenby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4985594,
        LOCATION_LATITUDE_DEG: 54.2837248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023600',
        LOCATION_NAME: 'Gateshead Fell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5954281,
        LOCATION_LATITUDE_DEG: 54.9444991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA018900',
        LOCATION_NAME: 'Gateshead NE 8',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6080135,
        LOCATION_LATITUDE_DEG: 54.9555768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019000',
        LOCATION_NAME: 'Gateshead NE 9',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5824864,
        LOCATION_LATITUDE_DEG: 54.9262918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019100',
        LOCATION_NAME: 'Gateshead NE10',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5433737,
        LOCATION_LATITUDE_DEG: 54.9473704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019200',
        LOCATION_NAME: 'Gateshead NE11',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6313757,
        LOCATION_LATITUDE_DEG: 54.9283732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019300',
        LOCATION_NAME: 'Gatesheath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7872403,
        LOCATION_LATITUDE_DEG: 53.136238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019400',
        LOCATION_NAME: 'Gateside',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6061187,
        LOCATION_LATITUDE_DEG: 55.7481121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019500',
        LOCATION_NAME: 'Gateside',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3208231,
        LOCATION_LATITUDE_DEG: 56.2671493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019700',
        LOCATION_NAME: 'Gathurst',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6943051,
        LOCATION_LATITUDE_DEG: 53.5601766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019800',
        LOCATION_NAME: 'Gatley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2331206,
        LOCATION_LATITUDE_DEG: 53.3926558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019900',
        LOCATION_NAME: 'Gatsford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5565331,
        LOCATION_LATITUDE_DEG: 51.9371112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020100',
        LOCATION_NAME: 'Gatton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1651197,
        LOCATION_LATITUDE_DEG: 51.2495197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020200',
        LOCATION_NAME: 'Gattonside',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7257628,
        LOCATION_LATITUDE_DEG: 55.6066739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020300',
        LOCATION_NAME: 'Gatwick',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.181732,
        LOCATION_LATITUDE_DEG: 51.1662164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020400',
        LOCATION_NAME: 'Gaulby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9732574,
        LOCATION_LATITUDE_DEG: 52.6028592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020500',
        LOCATION_NAME: 'Gauldry',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0131975,
        LOCATION_LATITUDE_DEG: 56.4020597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020600',
        LOCATION_NAME: 'Gaunts',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9727002,
        LOCATION_LATITUDE_DEG: 50.8402016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020700',
        LOCATION_NAME: 'Gaunts Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9684628,
        LOCATION_LATITUDE_DEG: 50.8472065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020800',
        LOCATION_NAME: 'Gaunts Earthcott',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5273396,
        LOCATION_LATITUDE_DEG: 51.555481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020900',
        LOCATION_NAME: 'Gautby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2389125,
        LOCATION_LATITUDE_DEG: 53.2357145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021000',
        LOCATION_NAME: 'Gavinton',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3667037,
        LOCATION_LATITUDE_DEG: 55.7629807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021100',
        LOCATION_NAME: 'Gawber',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5116695,
        LOCATION_LATITUDE_DEG: 53.5602599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021200',
        LOCATION_NAME: 'Gawcott',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0085672,
        LOCATION_LATITUDE_DEG: 51.9809031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021300',
        LOCATION_NAME: 'Gawleys Gate',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2480282,
        LOCATION_LATITUDE_DEG: 54.5035959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021400',
        LOCATION_NAME: 'Gawsworth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1628494,
        LOCATION_LATITUDE_DEG: 53.2247357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021500',
        LOCATION_NAME: 'Gawthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5857487,
        LOCATION_LATITUDE_DEG: 53.6955772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021600',
        LOCATION_NAME: 'Gawthrop',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4722693,
        LOCATION_LATITUDE_DEG: 54.2811371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021700',
        LOCATION_NAME: 'Gawthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1183762,
        LOCATION_LATITUDE_DEG: 54.2537476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA024000',
        LOCATION_NAME: 'Gay Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8778052,
        LOCATION_LATITUDE_DEG: 52.3997973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021900',
        LOCATION_NAME: 'Gaydon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4652162,
        LOCATION_LATITUDE_DEG: 52.1850244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022000',
        LOCATION_NAME: 'Gayhurst',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7627554,
        LOCATION_LATITUDE_DEG: 52.1139094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022100',
        LOCATION_NAME: 'Gayle',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1985621,
        LOCATION_LATITUDE_DEG: 54.2988412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022200',
        LOCATION_NAME: 'Gayles',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.809131,
        LOCATION_LATITUDE_DEG: 54.4627527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022550',
        LOCATION_NAME: 'Gayton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022400',
        LOCATION_NAME: 'Gayton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0255454,
        LOCATION_LATITUDE_DEG: 52.8533978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022300',
        LOCATION_NAME: 'Gayton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9677923,
        LOCATION_LATITUDE_DEG: 52.1865229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022500',
        LOCATION_NAME: 'Gayton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5613245,
        LOCATION_LATITUDE_DEG: 52.7433525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022800',
        LOCATION_NAME: 'Gayton le Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1451198,
        LOCATION_LATITUDE_DEG: 53.3370131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022900',
        LOCATION_NAME: 'Gayton le Wold',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1402434,
        LOCATION_LATITUDE_DEG: 53.3559193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022600',
        LOCATION_NAME: 'Gayton Thorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5843172,
        LOCATION_LATITUDE_DEG: 52.7367471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA022700',
        LOCATION_NAME: 'Gayton Top',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.129775,
        LOCATION_LATITUDE_DEG: 53.3248169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023000',
        LOCATION_NAME: 'Gaywood',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4239527,
        LOCATION_LATITUDE_DEG: 52.7568525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023100',
        LOCATION_NAME: 'Gaza',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8424584,
        LOCATION_LATITUDE_DEG: 57.8231089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023300',
        LOCATION_NAME: 'Gazeley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5196875,
        LOCATION_LATITUDE_DEG: 52.2480074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000200',
        LOCATION_NAME: 'Gearradubh',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2413291,
        LOCATION_LATITUDE_DEG: 57.5012099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000400',
        LOCATION_NAME: 'Gedding',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8544563,
        LOCATION_LATITUDE_DEG: 52.185095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000500',
        LOCATION_NAME: 'Geddington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6841154,
        LOCATION_LATITUDE_DEG: 52.4376391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000600',
        LOCATION_NAME: 'Gedgrave',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5110196,
        LOCATION_LATITUDE_DEG: 52.0832734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000700',
        LOCATION_NAME: 'Gedintailor',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1165616,
        LOCATION_LATITUDE_DEG: 57.3413779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000800',
        LOCATION_NAME: 'Gedling',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.081754,
        LOCATION_LATITUDE_DEG: 52.9663961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000900',
        LOCATION_NAME: 'Gedney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0846818,
        LOCATION_LATITUDE_DEG: 52.7967624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001000',
        LOCATION_NAME: 'Gedney Broadgate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0849105,
        LOCATION_LATITUDE_DEG: 52.7838636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001100',
        LOCATION_NAME: 'Gedney Drove End',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1729025,
        LOCATION_LATITUDE_DEG: 52.8409676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001200',
        LOCATION_NAME: 'Gedney Dyke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0995092,
        LOCATION_LATITUDE_DEG: 52.8147639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001300',
        LOCATION_NAME: 'Gedney Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.053001,
        LOCATION_LATITUDE_DEG: 52.7663641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001400',
        LOCATION_NAME: 'Gedney Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0185229,
        LOCATION_LATITUDE_DEG: 52.6838556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001500',
        LOCATION_NAME: 'Gee Cross',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0661379,
        LOCATION_LATITUDE_DEG: 53.438658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001700',
        LOCATION_NAME: 'Geilston',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6454406,
        LOCATION_LATITUDE_DEG: 55.9604305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001800',
        LOCATION_NAME: 'Geise',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5346927,
        LOCATION_LATITUDE_DEG: 58.5628809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001900',
        LOCATION_NAME: 'Geldeston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5198258,
        LOCATION_LATITUDE_DEG: 52.4721144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002000',
        LOCATION_NAME: 'Gelli',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4825367,
        LOCATION_LATITUDE_DEG: 51.6425994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002100',
        LOCATION_NAME: 'Gellideg',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4006087,
        LOCATION_LATITUDE_DEG: 51.7508087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002200',
        LOCATION_NAME: 'Gellifor',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3102062,
        LOCATION_LATITUDE_DEG: 53.1533444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002300',
        LOCATION_NAME: 'Gelligaer',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2495249,
        LOCATION_LATITUDE_DEG: 51.6637004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002400',
        LOCATION_NAME: 'Gelligroes',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1925996,
        LOCATION_LATITUDE_DEG: 51.6429975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002500',
        LOCATION_NAME: 'Gelligron',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8595347,
        LOCATION_LATITUDE_DEG: 51.7272115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002600',
        LOCATION_NAME: 'Gellihaf',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2067993,
        LOCATION_LATITUDE_DEG: 51.6502984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002700',
        LOCATION_NAME: 'Gellilydan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9554904,
        LOCATION_LATITUDE_DEG: 52.9383267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002800',
        LOCATION_NAME: 'Gellinudd',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8284556,
        LOCATION_LATITUDE_DEG: 51.7182115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE002900',
        LOCATION_NAME: 'Gelliswick',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0573762,
        LOCATION_LATITUDE_DEG: 51.7129201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003000',
        LOCATION_NAME: 'Gelly',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7888746,
        LOCATION_LATITUDE_DEG: 51.8391158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003100',
        LOCATION_NAME: 'Gellyburn',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4707309,
        LOCATION_LATITUDE_DEG: 56.5347697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003200',
        LOCATION_NAME: 'Gellyhill',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4868067,
        LOCATION_LATITUDE_DEG: 57.6587705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003300',
        LOCATION_NAME: 'Gellywen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5062136,
        LOCATION_LATITUDE_DEG: 51.8844348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003500',
        LOCATION_NAME: 'Gelston',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9182866,
        LOCATION_LATITUDE_DEG: 54.9073207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003400',
        LOCATION_NAME: 'Gelston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.638265,
        LOCATION_LATITUDE_DEG: 52.9963891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003600',
        LOCATION_NAME: 'Gembling',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3102339,
        LOCATION_LATITUDE_DEG: 53.9953876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003700',
        LOCATION_NAME: 'Gendros',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9644776,
        LOCATION_LATITUDE_DEG: 51.6388067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003800',
        LOCATION_NAME: 'Gentleshaw',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.924603,
        LOCATION_LATITUDE_DEG: 52.7036839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE003900',
        LOCATION_NAME: 'Geocrab',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.854312,
        LOCATION_LATITUDE_DEG: 57.8149319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004000',
        LOCATION_NAME: 'George Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5554555,
        LOCATION_LATITUDE_DEG: 51.5199494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004100',
        LOCATION_NAME: 'George Nympton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8514477,
        LOCATION_LATITUDE_DEG: 50.9918391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004200',
        LOCATION_NAME: 'Georgeham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.190882,
        LOCATION_LATITUDE_DEG: 51.1362546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004300',
        LOCATION_NAME: 'Georgetown',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4814039,
        LOCATION_LATITUDE_DEG: 55.8747181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004600',
        LOCATION_NAME: 'Georgetown',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5664011,
        LOCATION_LATITUDE_DEG: 55.053925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004500',
        LOCATION_NAME: 'Georgetown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3837156,
        LOCATION_LATITUDE_DEG: 51.7475106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004400',
        LOCATION_NAME: 'Georgetown',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2376838,
        LOCATION_LATITUDE_DEG: 51.767709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004800',
        LOCATION_NAME: 'Gerlan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0563694,
        LOCATION_LATITUDE_DEG: 53.1820527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004900',
        LOCATION_NAME: 'Germansweek',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.20998,
        LOCATION_LATITUDE_DEG: 50.7273174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE005000',
        LOCATION_NAME: 'Germoe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3813756,
        LOCATION_LATITUDE_DEG: 50.1127736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE005100',
        LOCATION_NAME: 'Gernick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3062382,
        LOCATION_LATITUDE_DEG: 50.1784785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE005200',
        LOCATION_NAME: 'Gerrans',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9748752,
        LOCATION_LATITUDE_DEG: 50.1786736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE005300',
        LOCATION_NAME: 'Gerrards Cross',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5568712,
        LOCATION_LATITUDE_DEG: 51.5827564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE005400',
        LOCATION_NAME: 'Geshader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9039432,
        LOCATION_LATITUDE_DEG: 58.1800743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE005500',
        LOCATION_NAME: 'Gestingthorpe',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6402121,
        LOCATION_LATITUDE_DEG: 52.0143818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE005600',
        LOCATION_NAME: 'Geuffordd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1639443,
        LOCATION_LATITUDE_DEG: 52.7222975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000100',
        LOCATION_NAME: 'Gib Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.923352,
        LOCATION_LATITUDE_DEG: 52.4965614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000200',
        LOCATION_NAME: 'Gibbet Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5472602,
        LOCATION_LATITUDE_DEG: 52.369844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000300',
        LOCATION_NAME: 'Gibraltar',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8976374,
        LOCATION_LATITUDE_DEG: 51.7917799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000400',
        LOCATION_NAME: 'Gidcott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2612272,
        LOCATION_LATITUDE_DEG: 50.8608276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000500',
        LOCATION_NAME: 'Gidea Park',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2067287,
        LOCATION_LATITUDE_DEG: 51.5807461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000600',
        LOCATION_NAME: 'Gidleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8765088,
        LOCATION_LATITUDE_DEG: 50.6797077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000700',
        LOCATION_NAME: 'Giffard Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7438511,
        LOCATION_LATITUDE_DEG: 52.0704035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000800',
        LOCATION_NAME: 'Giffnock',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2917159,
        LOCATION_LATITUDE_DEG: 55.8053107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI000900',
        LOCATION_NAME: 'Gifford',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7438065,
        LOCATION_LATITUDE_DEG: 55.9036017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001000',
        LOCATION_NAME: 'Giffordtown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1465345,
        LOCATION_LATITUDE_DEG: 56.2866427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001100',
        LOCATION_NAME: 'Gigg Mill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2258033,
        LOCATION_LATITUDE_DEG: 51.6895891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001200',
        LOCATION_NAME: 'Giggleswick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2911354,
        LOCATION_LATITUDE_DEG: 54.0654204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001300',
        LOCATION_NAME: 'Gight',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2838009,
        LOCATION_LATITUDE_DEG: 57.4564505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001400',
        LOCATION_NAME: 'Gilberdyke',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.739293,
        LOCATION_LATITUDE_DEG: 53.7520662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001500',
        LOCATION_NAME: 'Gilberts Coombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2378315,
        LOCATION_LATITUDE_DEG: 50.2433779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001600',
        LOCATION_NAME: 'Gilcrux',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3726924,
        LOCATION_LATITUDE_DEG: 54.7301966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001700',
        LOCATION_NAME: 'Gildersome',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6306047,
        LOCATION_LATITUDE_DEG: 53.7588819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001800',
        LOCATION_NAME: 'Gildingwells',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1621135,
        LOCATION_LATITUDE_DEG: 53.3631355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001900',
        LOCATION_NAME: 'Gilesgate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.557623,
        LOCATION_LATITUDE_DEG: 54.7799768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002000',
        LOCATION_NAME: 'Gilesgate Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5433129,
        LOCATION_LATITUDE_DEG: 54.7817752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002100',
        LOCATION_NAME: 'Gileston',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4123534,
        LOCATION_LATITUDE_DEG: 51.398178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002200',
        LOCATION_NAME: 'Gilfach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2265058,
        LOCATION_LATITUDE_DEG: 51.6777019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002300',
        LOCATION_NAME: 'Gilfach Goch',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4731716,
        LOCATION_LATITUDE_DEG: 51.5908905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002400',
        LOCATION_NAME: 'Gilfachrheda',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3280348,
        LOCATION_LATITUDE_DEG: 52.2015373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002500',
        LOCATION_NAME: 'Gilford',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3655498,
        LOCATION_LATITUDE_DEG: 54.3803873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002600',
        LOCATION_NAME: 'Gilgarran',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4980393,
        LOCATION_LATITUDE_DEG: 54.5929826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI990467',
        LOCATION_NAME: 'Gill Way',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002700',
        LOCATION_NAME: 'Gillamoor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9520776,
        LOCATION_LATITUDE_DEG: 54.3007267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002800',
        LOCATION_NAME: 'Gillan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.095227,
        LOCATION_LATITUDE_DEG: 50.0822638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI002900',
        LOCATION_NAME: 'Gillen',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5678551,
        LOCATION_LATITUDE_DEG: 57.5454077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003000',
        LOCATION_NAME: 'Gilling East',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0575362,
        LOCATION_LATITUDE_DEG: 54.185013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003100',
        LOCATION_NAME: 'Gilling West',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7179285,
        LOCATION_LATITUDE_DEG: 54.4407512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003300',
        LOCATION_NAME: 'Gillingham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2774772,
        LOCATION_LATITUDE_DEG: 51.037226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003400',
        LOCATION_NAME: 'Gillingham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5478148,
        LOCATION_LATITUDE_DEG: 51.3867208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003200',
        LOCATION_NAME: 'Gillingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5506122,
        LOCATION_LATITUDE_DEG: 52.4699159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006800',
        LOCATION_NAME: 'Gillmoss',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9223582,
        LOCATION_LATITUDE_DEG: 53.4587768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003500',
        LOCATION_NAME: 'Gillock',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3495283,
        LOCATION_LATITUDE_DEG: 58.517267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003600',
        LOCATION_NAME: 'Gillow Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1764608,
        LOCATION_LATITUDE_DEG: 53.1249277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003700',
        LOCATION_NAME: 'Gills',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1679963,
        LOCATION_LATITUDE_DEG: 58.638681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003800',
        LOCATION_NAME: 'Gills Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5086603,
        LOCATION_LATITUDE_DEG: 51.0628903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI990768',
        LOCATION_NAME: 'Gillygooley',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI003900',
        LOCATION_NAME: 'Gillygooly',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3578308,
        LOCATION_LATITUDE_DEG: 54.6117837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004000',
        LOCATION_NAME: 'Gilmerton',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8051457,
        LOCATION_LATITUDE_DEG: 56.3912637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI007200',
        LOCATION_NAME: 'Gilmerton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1279226,
        LOCATION_LATITUDE_DEG: 55.9099658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004100',
        LOCATION_NAME: 'Gilmilnscroft',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.287404,
        LOCATION_LATITUDE_DEG: 55.5021789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004200',
        LOCATION_NAME: 'Gilmonby',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0081253,
        LOCATION_LATITUDE_DEG: 54.5124538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004300',
        LOCATION_NAME: 'Gilmorton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1566505,
        LOCATION_LATITUDE_DEG: 52.4854528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004400',
        LOCATION_NAME: 'Gilnahirk',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8396813,
        LOCATION_LATITUDE_DEG: 54.5895079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI007300',
        LOCATION_NAME: 'Gilshochill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2905893,
        LOCATION_LATITUDE_DEG: 55.8977437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004500',
        LOCATION_NAME: 'Gilsland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5735553,
        LOCATION_LATITUDE_DEG: 54.9986156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004600',
        LOCATION_NAME: 'Gilstead',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8183881,
        LOCATION_LATITUDE_DEG: 53.8470912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004650',
        LOCATION_NAME: 'Gilston',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1028502,
        LOCATION_LATITUDE_DEG: 51.7905595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004700',
        LOCATION_NAME: 'Giltbrook',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2803989,
        LOCATION_LATITUDE_DEG: 53.0060009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004800',
        LOCATION_NAME: 'Gilwern',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0923475,
        LOCATION_LATITUDE_DEG: 51.8250104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI004900',
        LOCATION_NAME: 'Gimingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3967903,
        LOCATION_LATITUDE_DEG: 52.8792531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005000',
        LOCATION_NAME: 'Ginge',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3533394,
        LOCATION_LATITUDE_DEG: 51.5762684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005100',
        LOCATION_NAME: 'Gipping',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0341317,
        LOCATION_LATITUDE_DEG: 52.2311929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005200',
        LOCATION_NAME: 'Gipsey Bridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0896058,
        LOCATION_LATITUDE_DEG: 53.0294891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006700',
        LOCATION_NAME: 'Gipsy Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0837299,
        LOCATION_LATITUDE_DEG: 51.4248186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005300',
        LOCATION_NAME: 'Gipsyville',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3848453,
        LOCATION_LATITUDE_DEG: 53.7351643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005400',
        LOCATION_NAME: 'Girdle Toll',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6369527,
        LOCATION_LATITUDE_DEG: 55.6248977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI007100',
        LOCATION_NAME: 'Girlington',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7814104,
        LOCATION_LATITUDE_DEG: 53.8076937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005500',
        LOCATION_NAME: 'Girlsta',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2270151,
        LOCATION_LATITUDE_DEG: 60.2383109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005600',
        LOCATION_NAME: 'Girsby',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4507951,
        LOCATION_LATITUDE_DEG: 54.4697449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005700',
        LOCATION_NAME: 'Girton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7664164,
        LOCATION_LATITUDE_DEG: 53.1851172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005800',
        LOCATION_NAME: 'Girton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0834914,
        LOCATION_LATITUDE_DEG: 52.2416141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI005900',
        LOCATION_NAME: 'Girvan',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8512408,
        LOCATION_LATITUDE_DEG: 55.2379577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006000',
        LOCATION_NAME: 'Gisburn',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2582525,
        LOCATION_LATITUDE_DEG: 53.9351049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006100',
        LOCATION_NAME: 'Gisla',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8793964,
        LOCATION_LATITUDE_DEG: 58.1280691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006200',
        LOCATION_NAME: 'Gisleham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6992553,
        LOCATION_LATITUDE_DEG: 52.4364065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006300',
        LOCATION_NAME: 'Gislingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0439399,
        LOCATION_LATITUDE_DEG: 52.3021048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006400',
        LOCATION_NAME: 'Gissing',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1563907,
        LOCATION_LATITUDE_DEG: 52.4253095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006500',
        LOCATION_NAME: 'Gittisham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2266899,
        LOCATION_LATITUDE_DEG: 50.7779135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI006600',
        LOCATION_NAME: 'Givendale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4626378,
        LOCATION_LATITUDE_DEG: 54.1187114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000200',
        LOCATION_NAME: 'Gladestry',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1237804,
        LOCATION_LATITUDE_DEG: 52.1885456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000400',
        LOCATION_NAME: 'Gladsmuir',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8632854,
        LOCATION_LATITUDE_DEG: 55.9498112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000500',
        LOCATION_NAME: 'Glaik',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1248896,
        LOCATION_LATITUDE_DEG: 54.8910319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000600',
        LOCATION_NAME: 'Glais',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8782261,
        LOCATION_LATITUDE_DEG: 51.6904104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000700',
        LOCATION_NAME: 'Glaisdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8046452,
        LOCATION_LATITUDE_DEG: 54.4384391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000800',
        LOCATION_NAME: 'Glamis',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0038348,
        LOCATION_LATITUDE_DEG: 56.6069794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000900',
        LOCATION_NAME: 'Glan Conwy',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.748995,
        LOCATION_LATITUDE_DEG: 53.0565367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001000',
        LOCATION_NAME: 'Glan Conwy Corner',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7924034,
        LOCATION_LATITUDE_DEG: 53.2714546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL028100',
        LOCATION_NAME: 'Glan y Llyn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL028200',
        LOCATION_NAME: 'Glan y Nant',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001100',
        LOCATION_NAME: 'Glan y Nant',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.226803,
        LOCATION_LATITUDE_DEG: 51.6688949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL028300',
        LOCATION_NAME: 'Glan yr Afon',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3258598,
        LOCATION_LATITUDE_DEG: 53.3252859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001600',
        LOCATION_NAME: 'Glanamman',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9257721,
        LOCATION_LATITUDE_DEG: 51.8023985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001700',
        LOCATION_NAME: 'Glandford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0415088,
        LOCATION_LATITUDE_DEG: 52.9314596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001900',
        LOCATION_NAME: 'Glanduar',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.141077,
        LOCATION_LATITUDE_DEG: 51.7025013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002000',
        LOCATION_NAME: 'Glandwr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6304133,
        LOCATION_LATITUDE_DEG: 51.926837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002050',
        LOCATION_NAME: 'Glandy Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7302278,
        LOCATION_LATITUDE_DEG: 51.8343045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002100',
        LOCATION_NAME: 'Glandyfi',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9230631,
        LOCATION_LATITUDE_DEG: 52.5551875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002300',
        LOCATION_NAME: 'Glangrwyney',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1035257,
        LOCATION_LATITUDE_DEG: 51.8400133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002400',
        LOCATION_NAME: 'Glangwili',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2795936,
        LOCATION_LATITUDE_DEG: 51.8718317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002800',
        LOCATION_NAME: 'Glanmule',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.235028,
        LOCATION_LATITUDE_DEG: 52.5040776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002900',
        LOCATION_NAME: 'Glanrafon',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6206081,
        LOCATION_LATITUDE_DEG: 52.9578695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003000',
        LOCATION_NAME: 'Glanrhyd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7076069,
        LOCATION_LATITUDE_DEG: 52.0480451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003200',
        LOCATION_NAME: 'Glanton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8873365,
        LOCATION_LATITUDE_DEG: 55.4241425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003300',
        LOCATION_NAME: 'Glanvilles Wootton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4582354,
        LOCATION_LATITUDE_DEG: 50.8726173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003400',
        LOCATION_NAME: 'Glanwern',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0396815,
        LOCATION_LATITUDE_DEG: 52.4789847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003600',
        LOCATION_NAME: 'Glanwydden',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7748293,
        LOCATION_LATITUDE_DEG: 53.3066656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001200',
        LOCATION_NAME: 'Glan-y-Llyn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2679069,
        LOCATION_LATITUDE_DEG: 51.5455892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001300',
        LOCATION_NAME: 'Glan-y-Nant',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5705465,
        LOCATION_LATITUDE_DEG: 52.4494754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003700',
        LOCATION_NAME: 'Glanypwll',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9455379,
        LOCATION_LATITUDE_DEG: 52.9951288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003800',
        LOCATION_NAME: 'Glanyrafon',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7897474,
        LOCATION_LATITUDE_DEG: 51.7580088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001400',
        LOCATION_NAME: 'Glan-yr-Afon',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6218786,
        LOCATION_LATITUDE_DEG: 52.9540219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003900',
        LOCATION_NAME: 'Glapthorn',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4975641,
        LOCATION_LATITUDE_DEG: 52.5026477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004000',
        LOCATION_NAME: 'Glapwell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2817972,
        LOCATION_LATITUDE_DEG: 53.1891231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004100',
        LOCATION_NAME: 'Glarryford',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.353529,
        LOCATION_LATITUDE_DEG: 54.9506858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004200',
        LOCATION_NAME: 'Glas Pwll',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8603145,
        LOCATION_LATITUDE_DEG: 52.5645261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004300',
        LOCATION_NAME: 'Glasbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1999302,
        LOCATION_LATITUDE_DEG: 52.0449301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004400',
        LOCATION_NAME: 'Glascoed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9649605,
        LOCATION_LATITUDE_DEG: 51.7100958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004500',
        LOCATION_NAME: 'Glascote',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6673233,
        LOCATION_LATITUDE_DEG: 52.6226749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004600',
        LOCATION_NAME: 'Glascwm',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2331334,
        LOCATION_LATITUDE_DEG: 52.1697481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004700',
        LOCATION_NAME: 'Glasfryn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6142525,
        LOCATION_LATITUDE_DEG: 53.0382295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004800',
        LOCATION_NAME: 'Glasfynydd Trecastle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6691357,
        LOCATION_LATITUDE_DEG: 51.9252258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL004900',
        LOCATION_NAME: 'Glasgow Airport',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'PA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4334427,
        LOCATION_LATITUDE_DEG: 55.8640893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005000',
        LOCATION_NAME: 'Glasgow G 1',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2482927,
        LOCATION_LATITUDE_DEG: 55.8582281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005100',
        LOCATION_NAME: 'Glasgow G 2',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2617881,
        LOCATION_LATITUDE_DEG: 55.8621964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005200',
        LOCATION_NAME: 'Glasgow G 3',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2817756,
        LOCATION_LATITUDE_DEG: 55.8647935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005300',
        LOCATION_NAME: 'Glasgow G 4',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2497584,
        LOCATION_LATITUDE_DEG: 55.8683763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005400',
        LOCATION_NAME: 'Glasgow G 5',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2519063,
        LOCATION_LATITUDE_DEG: 55.8488679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005500',
        LOCATION_NAME: 'Glasgow G11',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.314526,
        LOCATION_LATITUDE_DEG: 55.8733592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005600',
        LOCATION_NAME: 'Glasgow G12',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3017455,
        LOCATION_LATITUDE_DEG: 55.882983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005700',
        LOCATION_NAME: 'Glasgow G13',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3473536,
        LOCATION_LATITUDE_DEG: 55.8935551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005800',
        LOCATION_NAME: 'Glasgow G14',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3514852,
        LOCATION_LATITUDE_DEG: 55.880146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL005900',
        LOCATION_NAME: 'Glasgow G15',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3678885,
        LOCATION_LATITUDE_DEG: 55.911328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006000',
        LOCATION_NAME: 'Glasgow G20',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2877322,
        LOCATION_LATITUDE_DEG: 55.8891588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006100',
        LOCATION_NAME: 'Glasgow G21',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2195269,
        LOCATION_LATITUDE_DEG: 55.8817788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006200',
        LOCATION_NAME: 'Glasgow G22',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2511783,
        LOCATION_LATITUDE_DEG: 55.89208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006300',
        LOCATION_NAME: 'Glasgow G23',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2778407,
        LOCATION_LATITUDE_DEG: 55.9114181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006400',
        LOCATION_NAME: 'Glasgow G31',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.24888,
        LOCATION_LATITUDE_DEG: 55.8612016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006500',
        LOCATION_NAME: 'Glasgow G32',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1641883,
        LOCATION_LATITUDE_DEG: 55.8448247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006600',
        LOCATION_NAME: 'Glasgow G33',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1610441,
        LOCATION_LATITUDE_DEG: 55.8817141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006700',
        LOCATION_NAME: 'Glasgow G34',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1140211,
        LOCATION_LATITUDE_DEG: 55.8703518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006800',
        LOCATION_NAME: 'Glasgow G40',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2222223,
        LOCATION_LATITUDE_DEG: 55.8472325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL006900',
        LOCATION_NAME: 'Glasgow G41',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2908306,
        LOCATION_LATITUDE_DEG: 55.8380459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007000',
        LOCATION_NAME: 'Glasgow G42',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2539635,
        LOCATION_LATITUDE_DEG: 55.831689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007100',
        LOCATION_NAME: 'Glasgow G43',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3013052,
        LOCATION_LATITUDE_DEG: 55.819055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007200',
        LOCATION_NAME: 'Glasgow G44',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2557729,
        LOCATION_LATITUDE_DEG: 55.8121866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007300',
        LOCATION_NAME: 'Glasgow G45',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2365319,
        LOCATION_LATITUDE_DEG: 55.8017878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007400',
        LOCATION_NAME: 'Glasgow G51',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3201236,
        LOCATION_LATITUDE_DEG: 55.8586472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007500',
        LOCATION_NAME: 'Glasgow G52',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3491705,
        LOCATION_LATITUDE_DEG: 55.8481813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007600',
        LOCATION_NAME: 'Glasgow G53',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3544956,
        LOCATION_LATITUDE_DEG: 55.8210412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007700',
        LOCATION_NAME: 'Glasgow Prestwick Intnl Airpor',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6033303,
        LOCATION_LATITUDE_DEG: 55.5097836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007800',
        LOCATION_NAME: 'Glasinfryn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1150796,
        LOCATION_LATITUDE_DEG: 53.1964541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008000',
        LOCATION_NAME: 'Glasmullagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4038315,
        LOCATION_LATITUDE_DEG: 54.6590771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008100',
        LOCATION_NAME: 'Glasnakille',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.073614,
        LOCATION_LATITUDE_DEG: 57.1422611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008200',
        LOCATION_NAME: 'Glass',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9614433,
        LOCATION_LATITUDE_DEG: 57.4405535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008300',
        LOCATION_NAME: 'Glassard',
        COUNTY_NAME: 'Isle of Colonsay',
        POSTCODE: 'PA61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1807735,
        LOCATION_LATITUDE_DEG: 56.0769597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008400',
        LOCATION_NAME: 'Glassel',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5686526,
        LOCATION_LATITUDE_DEG: 57.0829173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008500',
        LOCATION_NAME: 'Glassford',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0274865,
        LOCATION_LATITUDE_DEG: 55.7001977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008600',
        LOCATION_NAME: 'Glasshoughton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3309551,
        LOCATION_LATITUDE_DEG: 53.7140758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008700',
        LOCATION_NAME: 'Glasshouses',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7372975,
        LOCATION_LATITUDE_DEG: 54.0759127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008800',
        LOCATION_NAME: 'Glassingall',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9368351,
        LOCATION_LATITUDE_DEG: 56.2157501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL008900',
        LOCATION_NAME: 'Glasson',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1658797,
        LOCATION_LATITUDE_DEG: 54.9340095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009100',
        LOCATION_NAME: 'Glasson Dock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8455975,
        LOCATION_LATITUDE_DEG: 53.9974149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009200',
        LOCATION_NAME: 'Glassonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6576797,
        LOCATION_LATITUDE_DEG: 54.7428879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990125',
        LOCATION_NAME: 'Glaston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7010582,
        LOCATION_LATITUDE_DEG: 52.6576417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009400',
        LOCATION_NAME: 'Glaston',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6770773,
        LOCATION_LATITUDE_DEG: 52.5938521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009500',
        LOCATION_NAME: 'Glastonbury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7159273,
        LOCATION_LATITUDE_DEG: 51.1482462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009600',
        LOCATION_NAME: 'Glatton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3009955,
        LOCATION_LATITUDE_DEG: 52.4599377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009700',
        LOCATION_NAME: 'Glazebrook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4589768,
        LOCATION_LATITUDE_DEG: 53.4274565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009800',
        LOCATION_NAME: 'Glazebury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.493649,
        LOCATION_LATITUDE_DEG: 53.4710619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009900',
        LOCATION_NAME: 'Glazeley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4405263,
        LOCATION_LATITUDE_DEG: 52.4901648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010000',
        LOCATION_NAME: 'Gleadless',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4304441,
        LOCATION_LATITUDE_DEG: 53.3471334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010100',
        LOCATION_NAME: 'Gleaston',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1395926,
        LOCATION_LATITUDE_DEG: 54.1278379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL028500',
        LOCATION_NAME: 'Glebe Farm',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7938645,
        LOCATION_LATITUDE_DEG: 52.4897803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010200',
        LOCATION_NAME: 'Gledstone',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1745285,
        LOCATION_LATITUDE_DEG: 53.9568018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010300',
        LOCATION_NAME: 'Glemsford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6770493,
        LOCATION_LATITUDE_DEG: 52.1019883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010400',
        LOCATION_NAME: 'Glen',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4752958,
        LOCATION_LATITUDE_DEG: 56.9556562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990254',
        LOCATION_NAME: 'Glen Auldyn',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4079176,
        LOCATION_LATITUDE_DEG: -1.7938568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010700',
        LOCATION_NAME: 'Glen Caladh',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2021781,
        LOCATION_LATITUDE_DEG: 55.9357302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990663',
        LOCATION_NAME: 'Glen Clova',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010800',
        LOCATION_NAME: 'Glen Kyles',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0384107,
        LOCATION_LATITUDE_DEG: 57.7814333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010900',
        LOCATION_NAME: 'Glen Massan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0522485,
        LOCATION_LATITUDE_DEG: 56.0465443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011000',
        LOCATION_NAME: 'Glen Maye',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6978712,
        LOCATION_LATITUDE_DEG: 54.1863489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL028400',
        LOCATION_NAME: 'Glen Mona',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 2.7912768,
        LOCATION_LATITUDE_DEG: 48.5831551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011100',
        LOCATION_NAME: 'Glen Parva',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.161316,
        LOCATION_LATITUDE_DEG: 52.5823569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011200',
        LOCATION_NAME: 'Glen Tanar',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8403693,
        LOCATION_LATITUDE_DEG: 57.056916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011300',
        LOCATION_NAME: 'Glen Village',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7845135,
        LOCATION_LATITUDE_DEG: 55.9863237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011400',
        LOCATION_NAME: 'Glen Vine',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.545758,
        LOCATION_LATITUDE_DEG: 54.1758422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011800',
        LOCATION_NAME: 'Glenallachie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2280045,
        LOCATION_LATITUDE_DEG: 57.4576631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011900',
        LOCATION_NAME: 'Glenalmond',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6571301,
        LOCATION_LATITUDE_DEG: 56.441067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012100',
        LOCATION_NAME: 'Glenancross',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8410938,
        LOCATION_LATITUDE_DEG: 56.9574369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012150',
        LOCATION_NAME: 'Glenanne',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.482222,
        LOCATION_LATITUDE_DEG: 54.2283093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012300',
        LOCATION_NAME: 'Glenariffe',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0655965,
        LOCATION_LATITUDE_DEG: 55.0499549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012400',
        LOCATION_NAME: 'Glenarm',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9445932,
        LOCATION_LATITUDE_DEG: 54.969942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012500',
        LOCATION_NAME: 'Glenavy',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2186208,
        LOCATION_LATITUDE_DEG: 54.5920132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012700',
        LOCATION_NAME: 'Glenbarr',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6959641,
        LOCATION_LATITUDE_DEG: 55.5679985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013000',
        LOCATION_NAME: 'Glenbervie',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.384119,
        LOCATION_LATITUDE_DEG: 56.9169944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013100',
        LOCATION_NAME: 'Glenboig',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0444637,
        LOCATION_LATITUDE_DEG: 55.893413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013200',
        LOCATION_NAME: 'Glenborrodale',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9069052,
        LOCATION_LATITUDE_DEG: 56.6779093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013600',
        LOCATION_NAME: 'Glenbuchat',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0335015,
        LOCATION_LATITUDE_DEG: 57.2227398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013700',
        LOCATION_NAME: 'Glenbuck',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9813118,
        LOCATION_LATITUDE_DEG: 55.5433787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013800',
        LOCATION_NAME: 'Glenburn',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4203547,
        LOCATION_LATITUDE_DEG: 55.822513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013900',
        LOCATION_NAME: 'Glencaple',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5713597,
        LOCATION_LATITUDE_DEG: 55.003023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014000',
        LOCATION_NAME: 'Glencarse',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3013784,
        LOCATION_LATITUDE_DEG: 56.3797543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990662',
        LOCATION_NAME: 'Glenclova',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014100',
        LOCATION_NAME: 'Glencoe',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1010205,
        LOCATION_LATITUDE_DEG: 56.6826051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014300',
        LOCATION_NAME: 'Glenconon',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3248475,
        LOCATION_LATITUDE_DEG: 57.5907042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014500',
        LOCATION_NAME: 'Glencraig',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3182999,
        LOCATION_LATITUDE_DEG: 56.1406304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014600',
        LOCATION_NAME: 'Glencraigs',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6451275,
        LOCATION_LATITUDE_DEG: 55.4485938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014800',
        LOCATION_NAME: 'Glencruitten',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4393753,
        LOCATION_LATITUDE_DEG: 56.4160847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015000',
        LOCATION_NAME: 'Glendale',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7288931,
        LOCATION_LATITUDE_DEG: 57.439497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015200',
        LOCATION_NAME: 'Glendaruel',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2130521,
        LOCATION_LATITUDE_DEG: 56.0091376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015300',
        LOCATION_NAME: 'Glendaveny',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.877846,
        LOCATION_LATITUDE_DEG: 57.5203505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015500',
        LOCATION_NAME: 'Glendevon',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6277203,
        LOCATION_LATITUDE_DEG: 56.222649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015700',
        LOCATION_NAME: 'Glendoick',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2806758,
        LOCATION_LATITUDE_DEG: 56.3902588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015800',
        LOCATION_NAME: 'Glendon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7567825,
        LOCATION_LATITUDE_DEG: 52.4245423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016200',
        LOCATION_NAME: 'Gleneagles Village',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7528878,
        LOCATION_LATITUDE_DEG: 56.2835509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016600',
        LOCATION_NAME: 'Glenegedale',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2469343,
        LOCATION_LATITUDE_DEG: 55.6843191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016700',
        LOCATION_NAME: 'Glenelg',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6204836,
        LOCATION_LATITUDE_DEG: 57.2123619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016800',
        LOCATION_NAME: 'Glenesk',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8110768,
        LOCATION_LATITUDE_DEG: 56.8991043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016900',
        LOCATION_NAME: 'Glenetive',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9840201,
        LOCATION_LATITUDE_DEG: 56.6164968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017000',
        LOCATION_NAME: 'Glenfarg',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4000328,
        LOCATION_LATITUDE_DEG: 56.278644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017300',
        LOCATION_NAME: 'Glenfield',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2029018,
        LOCATION_LATITUDE_DEG: 52.6487642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017400',
        LOCATION_NAME: 'Glenfinnan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4404785,
        LOCATION_LATITUDE_DEG: 56.8721249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017500',
        LOCATION_NAME: 'Glenforsa',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9017286,
        LOCATION_LATITUDE_DEG: 56.5173021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017600',
        LOCATION_NAME: 'Glengarnock',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6762674,
        LOCATION_LATITUDE_DEG: 55.739106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017900',
        LOCATION_NAME: 'Glengolly',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5448131,
        LOCATION_LATITUDE_DEG: 58.5732793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018100',
        LOCATION_NAME: 'Glenhordial',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2503562,
        LOCATION_LATITUDE_DEG: 54.6363236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018300',
        LOCATION_NAME: 'Glenisla',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2824032,
        LOCATION_LATITUDE_DEG: 56.7296891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018500',
        LOCATION_NAME: 'Glenkindie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9347845,
        LOCATION_LATITUDE_DEG: 57.2122377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018600',
        LOCATION_NAME: 'Glenlean',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0678405,
        LOCATION_LATITUDE_DEG: 56.0078396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018700',
        LOCATION_NAME: 'Glenlivet',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3350762,
        LOCATION_LATITUDE_DEG: 57.3478504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018800',
        LOCATION_NAME: 'Glenlochar',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.989273,
        LOCATION_LATITUDE_DEG: 54.9639253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018900',
        LOCATION_NAME: 'Glenlochay',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5121874,
        LOCATION_LATITUDE_DEG: 56.4848804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019000',
        LOCATION_NAME: 'Glenlomond',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3352692,
        LOCATION_LATITUDE_DEG: 56.2312468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019100',
        LOCATION_NAME: 'Glenlonan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.405284,
        LOCATION_LATITUDE_DEG: 56.4050856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019200',
        LOCATION_NAME: 'Glenluce',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8100822,
        LOCATION_LATITUDE_DEG: 54.8782271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019300',
        LOCATION_NAME: 'Glenlyon',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2794434,
        LOCATION_LATITUDE_DEG: 56.5903856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019400',
        LOCATION_NAME: 'Glenmacoffer',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.17964,
        LOCATION_LATITUDE_DEG: 54.6933134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019600',
        LOCATION_NAME: 'Glenmavis',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9945515,
        LOCATION_LATITUDE_DEG: 55.8864124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011500',
        LOCATION_NAME: 'Glen-Mona',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3776999,
        LOCATION_LATITUDE_DEG: 54.2694118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019800',
        LOCATION_NAME: 'Glenmore',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.940702,
        LOCATION_LATITUDE_DEG: 56.6830123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020100',
        LOCATION_NAME: 'Glenmoriston',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7302828,
        LOCATION_LATITUDE_DEG: 57.1998498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020200',
        LOCATION_NAME: 'Glenmoy',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9766706,
        LOCATION_LATITUDE_DEG: 56.7707903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020300',
        LOCATION_NAME: 'Glenmuick',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0569019,
        LOCATION_LATITUDE_DEG: 57.0353211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020800',
        LOCATION_NAME: 'Gleno',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.832182,
        LOCATION_LATITUDE_DEG: 54.799917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020900',
        LOCATION_NAME: 'Glenogil',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9040767,
        LOCATION_LATITUDE_DEG: 56.7589921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021000',
        LOCATION_NAME: 'Glenogilvy',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.005309,
        LOCATION_LATITUDE_DEG: 56.5796698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021100',
        LOCATION_NAME: 'Glenogle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2829596,
        LOCATION_LATITUDE_DEG: 56.4002739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021500',
        LOCATION_NAME: 'Glenprosen',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0935173,
        LOCATION_LATITUDE_DEG: 56.7756341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021600',
        LOCATION_NAME: 'Glenquiech',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9415921,
        LOCATION_LATITUDE_DEG: 56.7441855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021700',
        LOCATION_NAME: 'Glenramskill',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5705293,
        LOCATION_LATITUDE_DEG: 55.4111823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021800',
        LOCATION_NAME: 'Glenridding',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9567261,
        LOCATION_LATITUDE_DEG: 54.5443712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021900',
        LOCATION_NAME: 'Glenrinnes',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1829994,
        LOCATION_LATITUDE_DEG: 57.4035575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022100',
        LOCATION_NAME: 'Glenross',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7157824,
        LOCATION_LATITUDE_DEG: 54.4499075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022200',
        LOCATION_NAME: 'Glenrothes',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1715876,
        LOCATION_LATITUDE_DEG: 56.1971401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022300',
        LOCATION_NAME: 'Glensburgh',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7439672,
        LOCATION_LATITUDE_DEG: 56.018728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022400',
        LOCATION_NAME: 'Glenshee',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6492952,
        LOCATION_LATITUDE_DEG: 56.4901389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022500',
        LOCATION_NAME: 'Glenshesk',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2213086,
        LOCATION_LATITUDE_DEG: 55.1743707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022600',
        LOCATION_NAME: 'Glenshiel',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4058541,
        LOCATION_LATITUDE_DEG: 57.2095614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022700',
        LOCATION_NAME: 'Glenstriven',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0727984,
        LOCATION_LATITUDE_DEG: 55.958933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022900',
        LOCATION_NAME: 'Glentham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4913342,
        LOCATION_LATITUDE_DEG: 53.3995339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023100',
        LOCATION_NAME: 'Glentress',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1380522,
        LOCATION_LATITUDE_DEG: 55.6457798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023200',
        LOCATION_NAME: 'Glentrool',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5723744,
        LOCATION_LATITUDE_DEG: 55.0718442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023400',
        LOCATION_NAME: 'Glentworth',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0559548,
        LOCATION_LATITUDE_DEG: 52.846907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023300',
        LOCATION_NAME: 'Glentworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.573307,
        LOCATION_LATITUDE_DEG: 53.3832261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023500',
        LOCATION_NAME: 'Glenuig',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8171367,
        LOCATION_LATITUDE_DEG: 56.8278248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023800',
        LOCATION_NAME: 'Glenwherry',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1202001,
        LOCATION_LATITUDE_DEG: 54.8454268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023900',
        LOCATION_NAME: 'Glenwherry',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0693706,
        LOCATION_LATITUDE_DEG: 54.8233336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024000',
        LOCATION_NAME: 'Glespin',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8877335,
        LOCATION_LATITUDE_DEG: 55.5340796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024100',
        LOCATION_NAME: 'Glewstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6427729,
        LOCATION_LATITUDE_DEG: 51.8954167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024200',
        LOCATION_NAME: 'Gliffaes',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2123571,
        LOCATION_LATITUDE_DEG: 51.874516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024500',
        LOCATION_NAME: 'Glingerbank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9687645,
        LOCATION_LATITUDE_DEG: 55.0340205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024900',
        LOCATION_NAME: 'Glinton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2940335,
        LOCATION_LATITUDE_DEG: 52.6386511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025000',
        LOCATION_NAME: 'Glogue',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5898404,
        LOCATION_LATITUDE_DEG: 51.9599358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025100',
        LOCATION_NAME: 'Glooston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8925927,
        LOCATION_LATITUDE_DEG: 52.5549552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025200',
        LOCATION_NAME: 'Glororum',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.736031,
        LOCATION_LATITUDE_DEG: 55.5956596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025300',
        LOCATION_NAME: 'Glossop',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9474064,
        LOCATION_LATITUDE_DEG: 53.4430517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025400',
        LOCATION_NAME: 'Gloucester',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2444432,
        LOCATION_LATITUDE_DEG: 51.8649068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025500',
        LOCATION_NAME: 'Gloucestershire Airport',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1653886,
        LOCATION_LATITUDE_DEG: 51.8929104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025800',
        LOCATION_NAME: 'Gloweth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0791066,
        LOCATION_LATITUDE_DEG: 50.2610831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025900',
        LOCATION_NAME: 'Glue Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3107325,
        LOCATION_LATITUDE_DEG: 50.9143112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026000',
        LOCATION_NAME: 'Glusburn',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9977017,
        LOCATION_LATITUDE_DEG: 53.8989957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026100',
        LOCATION_NAME: 'Glutton Bridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8750302,
        LOCATION_LATITUDE_DEG: 53.1956272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026200',
        LOCATION_NAME: 'Gluvian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9444042,
        LOCATION_LATITUDE_DEG: 50.4443983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026300',
        LOCATION_NAME: 'Glympton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3802879,
        LOCATION_LATITUDE_DEG: 51.8904958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026400',
        LOCATION_NAME: 'Glyn Ceiriog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1874296,
        LOCATION_LATITUDE_DEG: 52.9313212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026500',
        LOCATION_NAME: 'Glynarthen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4633661,
        LOCATION_LATITUDE_DEG: 52.1088528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026600',
        LOCATION_NAME: 'Glyncoch',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3338098,
        LOCATION_LATITUDE_DEG: 51.623097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026700',
        LOCATION_NAME: 'Glyncorrwg',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6249923,
        LOCATION_LATITUDE_DEG: 51.6787999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026800',
        LOCATION_NAME: 'Glynde',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0701498,
        LOCATION_LATITUDE_DEG: 50.8615773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL026900',
        LOCATION_NAME: 'Glyndebourne',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0636563,
        LOCATION_LATITUDE_DEG: 50.877379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027000',
        LOCATION_NAME: 'Glyndyfrdwy',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2681679,
        LOCATION_LATITUDE_DEG: 52.9741197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027100',
        LOCATION_NAME: 'Glynfach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4025123,
        LOCATION_LATITUDE_DEG: 51.6067924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027200',
        LOCATION_NAME: 'Glyngarth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL59',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1251954,
        LOCATION_LATITUDE_DEG: 53.2353607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027300',
        LOCATION_NAME: 'Glynllan',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5285138,
        LOCATION_LATITUDE_DEG: 51.5715941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027700',
        LOCATION_NAME: 'Glynn',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8155739,
        LOCATION_LATITUDE_DEG: 54.8166216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027400',
        LOCATION_NAME: 'Glynn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.653467,
        LOCATION_LATITUDE_DEG: 50.4576982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027800',
        LOCATION_NAME: 'Glynneath',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6188411,
        LOCATION_LATITUDE_DEG: 51.7460087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027900',
        LOCATION_NAME: 'Glynogwr',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5069168,
        LOCATION_LATITUDE_DEG: 51.5739958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL028000',
        LOCATION_NAME: 'Glyntaff',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3215825,
        LOCATION_LATITUDE_DEG: 51.5955911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GN000100',
        LOCATION_NAME: 'Gnaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9957138,
        LOCATION_LATITUDE_DEG: 50.3325768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GN000500',
        LOCATION_NAME: 'Gnosall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.25338,
        LOCATION_LATITUDE_DEG: 52.7852968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000100',
        LOCATION_NAME: 'Goadby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8917308,
        LOCATION_LATITUDE_DEG: 52.580959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000200',
        LOCATION_NAME: 'Goadby Marwood',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8417077,
        LOCATION_LATITUDE_DEG: 52.8285821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000300',
        LOCATION_NAME: 'Goadsbarrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1290657,
        LOCATION_LATITUDE_DEG: 54.1054285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000400',
        LOCATION_NAME: 'Goatacre',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9704554,
        LOCATION_LATITUDE_DEG: 51.4903696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000500',
        LOCATION_NAME: 'Goathill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4591405,
        LOCATION_LATITUDE_DEG: 50.9531233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000600',
        LOCATION_NAME: 'Goathland',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7183161,
        LOCATION_LATITUDE_DEG: 54.4000258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000700',
        LOCATION_NAME: 'Goathurst',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.054911,
        LOCATION_LATITUDE_DEG: 51.1009379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001000',
        LOCATION_NAME: 'Gobowen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0361001,
        LOCATION_LATITUDE_DEG: 52.8943106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001100',
        LOCATION_NAME: 'Godalming',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6159857,
        LOCATION_LATITUDE_DEG: 51.1839157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001200',
        LOCATION_NAME: 'Goddards Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1662316,
        LOCATION_LATITUDE_DEG: 50.9648924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001300',
        LOCATION_NAME: 'Godden Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2278094,
        LOCATION_LATITUDE_DEG: 51.2706169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001400',
        LOCATION_NAME: 'Godington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0648489,
        LOCATION_LATITUDE_DEG: 51.9445949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001500',
        LOCATION_NAME: 'Godmanchester',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1734106,
        LOCATION_LATITUDE_DEG: 52.3189248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001600',
        LOCATION_NAME: 'Godmanstone',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4736799,
        LOCATION_LATITUDE_DEG: 50.7709998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001700',
        LOCATION_NAME: 'Godmersham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.953035,
        LOCATION_LATITUDE_DEG: 51.2145026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001800',
        LOCATION_NAME: 'Godney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7328409,
        LOCATION_LATITUDE_DEG: 51.1788442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO001900',
        LOCATION_NAME: 'Godolphin Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3463363,
        LOCATION_LATITUDE_DEG: 50.1331701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002000',
        LOCATION_NAME: 'Godreaman',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4269238,
        LOCATION_LATITUDE_DEG: 51.6939004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002100',
        LOCATION_NAME: 'Godrergraig',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8009492,
        LOCATION_LATITUDE_DEG: 51.7518123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO990716',
        LOCATION_NAME: 'Gods Blessing Green',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002300',
        LOCATION_NAME: 'Godshill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7496719,
        LOCATION_LATITUDE_DEG: 50.9330098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002200',
        LOCATION_NAME: 'Godshill',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2549137,
        LOCATION_LATITUDE_DEG: 50.6342778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002400',
        LOCATION_NAME: 'Godshill Green',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7390954,
        LOCATION_LATITUDE_DEG: 50.9588156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002500',
        LOCATION_NAME: 'Godshill Wood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7511064,
        LOCATION_LATITUDE_DEG: 50.9469076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002600',
        LOCATION_NAME: 'Godstone',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0666579,
        LOCATION_LATITUDE_DEG: 51.2476196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002700',
        LOCATION_NAME: 'Goffs Oak',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0865836,
        LOCATION_LATITUDE_DEG: 51.707874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002800',
        LOCATION_NAME: 'Gogar',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3300536,
        LOCATION_LATITUDE_DEG: 55.9368141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO002900',
        LOCATION_NAME: 'Goginan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9280712,
        LOCATION_LATITUDE_DEG: 52.4118764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003000',
        LOCATION_NAME: 'Golan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1958948,
        LOCATION_LATITUDE_DEG: 52.9595287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003200',
        LOCATION_NAME: 'Golant',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6415441,
        LOCATION_LATITUDE_DEG: 50.3627921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003300',
        LOCATION_NAME: 'Golberdon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3593594,
        LOCATION_LATITUDE_DEG: 50.5162008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003400',
        LOCATION_NAME: 'Golborne',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5959428,
        LOCATION_LATITUDE_DEG: 53.4756657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003500',
        LOCATION_NAME: 'Golborne Dale',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5980763,
        LOCATION_LATITUDE_DEG: 53.4623593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003600',
        LOCATION_NAME: 'Golcar',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8467578,
        LOCATION_LATITUDE_DEG: 53.6376666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003700',
        LOCATION_NAME: 'Goldcliff',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.913345,
        LOCATION_LATITUDE_DEG: 51.542581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004100',
        LOCATION_NAME: 'Golden Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.185451,
        LOCATION_LATITUDE_DEG: 50.8906773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004200',
        LOCATION_NAME: 'Golden Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3446751,
        LOCATION_LATITUDE_DEG: 51.2096084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004300',
        LOCATION_NAME: 'Golden Grove',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0471191,
        LOCATION_LATITUDE_DEG: 51.8562236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO990783',
        LOCATION_NAME: 'Golden Hill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004400',
        LOCATION_NAME: 'Golden Hill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.910758,
        LOCATION_LATITUDE_DEG: 51.6810179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004500',
        LOCATION_NAME: 'Golden Pot',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9855565,
        LOCATION_LATITUDE_DEG: 51.1837291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO021000',
        LOCATION_NAME: 'Goldenacre',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2040632,
        LOCATION_LATITUDE_DEG: 55.9672173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004600',
        LOCATION_NAME: 'Goldenbank',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0889129,
        LOCATION_LATITUDE_DEG: 50.1390681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004700',
        LOCATION_NAME: 'Goldenhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1927525,
        LOCATION_LATITUDE_DEG: 53.0717171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO021300',
        LOCATION_NAME: 'Golders Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1953574,
        LOCATION_LATITUDE_DEG: 51.5741922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004800',
        LOCATION_NAME: 'Goldhanger',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7537874,
        LOCATION_LATITUDE_DEG: 51.7478574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004900',
        LOCATION_NAME: 'Golding',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6726319,
        LOCATION_LATITUDE_DEG: 52.6269868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005000',
        LOCATION_NAME: 'Golds Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0236506,
        LOCATION_LATITUDE_DEG: 52.5363688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005100',
        LOCATION_NAME: 'Goldsborough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4170116,
        LOCATION_LATITUDE_DEG: 53.9997036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005200',
        LOCATION_NAME: 'Goldsborough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7081106,
        LOCATION_LATITUDE_DEG: 54.5202407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005300',
        LOCATION_NAME: 'Goldsithney',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4351662,
        LOCATION_LATITUDE_DEG: 50.1247702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005400',
        LOCATION_NAME: 'Goldstone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4352518,
        LOCATION_LATITUDE_DEG: 52.8517038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005500',
        LOCATION_NAME: 'Goldthorn Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1341143,
        LOCATION_LATITUDE_DEG: 52.5639693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005600',
        LOCATION_NAME: 'Goldthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3027344,
        LOCATION_LATITUDE_DEG: 53.5308533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005800',
        LOCATION_NAME: 'Golfa',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2032742,
        LOCATION_LATITUDE_DEG: 52.6549923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005900',
        LOCATION_NAME: 'Golford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5761445,
        LOCATION_LATITUDE_DEG: 51.098994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006000',
        LOCATION_NAME: 'Gollanfield',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9882396,
        LOCATION_LATITUDE_DEG: 57.5546811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006100',
        LOCATION_NAME: 'Golspie',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9658914,
        LOCATION_LATITUDE_DEG: 57.9759198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006200',
        LOCATION_NAME: 'Goltho',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3231329,
        LOCATION_LATITUDE_DEG: 53.274817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006300',
        LOCATION_NAME: 'Gomeldon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7312489,
        LOCATION_LATITUDE_DEG: 51.1191292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006400',
        LOCATION_NAME: 'Gomersal',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6867057,
        LOCATION_LATITUDE_DEG: 53.7359755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006500',
        LOCATION_NAME: 'Gometra',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2855846,
        LOCATION_LATITUDE_DEG: 56.4885961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006600',
        LOCATION_NAME: 'Gomshall',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4457371,
        LOCATION_LATITUDE_DEG: 51.2192183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006700',
        LOCATION_NAME: 'Gonalston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.987184,
        LOCATION_LATITUDE_DEG: 53.0196975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006800',
        LOCATION_NAME: 'Gonerby Hill Foot',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6537456,
        LOCATION_LATITUDE_DEG: 52.9245838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO006900',
        LOCATION_NAME: 'Gonerby Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6339129,
        LOCATION_LATITUDE_DEG: 52.9576871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007000',
        LOCATION_NAME: 'Gonsal',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7691275,
        LOCATION_LATITUDE_DEG: 52.6326843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007100',
        LOCATION_NAME: 'Gonvena',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8301779,
        LOCATION_LATITUDE_DEG: 50.5178005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007200',
        LOCATION_NAME: 'Good Easter',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3565473,
        LOCATION_LATITUDE_DEG: 51.784667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007300',
        LOCATION_NAME: 'Gooderstone',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.601552,
        LOCATION_LATITUDE_DEG: 52.5879377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007400',
        LOCATION_NAME: 'Goodleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9940759,
        LOCATION_LATITUDE_DEG: 51.0884468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007500',
        LOCATION_NAME: 'Goodmanham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6458067,
        LOCATION_LATITUDE_DEG: 53.8765792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO990533',
        LOCATION_NAME: 'Goodmayes',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007600',
        LOCATION_NAME: 'Goodnestone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9374439,
        LOCATION_LATITUDE_DEG: 51.3155092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007700',
        LOCATION_NAME: 'Goodnestone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.233584,
        LOCATION_LATITUDE_DEG: 51.2474001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007800',
        LOCATION_NAME: 'Goodrich',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6180235,
        LOCATION_LATITUDE_DEG: 51.8691126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO007900',
        LOCATION_NAME: 'Goodrington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5600215,
        LOCATION_LATITUDE_DEG: 50.4152824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008000',
        LOCATION_NAME: 'Goodshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2846401,
        LOCATION_LATITUDE_DEG: 53.729386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008100',
        LOCATION_NAME: 'Goodwick',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9921361,
        LOCATION_LATITUDE_DEG: 52.0029492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008200',
        LOCATION_NAME: 'Goodworth Clatford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4820869,
        LOCATION_LATITUDE_DEG: 51.1779336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008300',
        LOCATION_NAME: 'Goodyers End',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.508459,
        LOCATION_LATITUDE_DEG: 52.4669557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008500',
        LOCATION_NAME: 'Goole',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8698654,
        LOCATION_LATITUDE_DEG: 53.7032602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008600',
        LOCATION_NAME: 'Goole Fields',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8604428,
        LOCATION_LATITUDE_DEG: 53.6740623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008700',
        LOCATION_NAME: 'Goon Gumpas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1589208,
        LOCATION_LATITUDE_DEG: 50.2383813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008800',
        LOCATION_NAME: 'Goonabarn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8685966,
        LOCATION_LATITUDE_DEG: 50.356591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008900',
        LOCATION_NAME: 'Goonamarris',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8743886,
        LOCATION_LATITUDE_DEG: 50.3595876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009000',
        LOCATION_NAME: 'Goonbell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1918873,
        LOCATION_LATITUDE_DEG: 50.3027885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009100',
        LOCATION_NAME: 'Goonhavern',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1102108,
        LOCATION_LATITUDE_DEG: 50.3411893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009200',
        LOCATION_NAME: 'Goonhilly Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.179821,
        LOCATION_LATITUDE_DEG: 50.046164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009300',
        LOCATION_NAME: 'Goonlaze',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1918259,
        LOCATION_LATITUDE_DEG: 50.3108874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009400',
        LOCATION_NAME: 'Goonown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1953359,
        LOCATION_LATITUDE_DEG: 50.3049879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009500',
        LOCATION_NAME: 'Goose Butts',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5424456,
        LOCATION_LATITUDE_DEG: 54.526473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009600',
        LOCATION_NAME: 'Goose Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6554513,
        LOCATION_LATITUDE_DEG: 53.5256691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009700',
        LOCATION_NAME: 'Goose Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4392641,
        LOCATION_LATITUDE_DEG: 50.9544972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009800',
        LOCATION_NAME: 'Gooseham',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.518637,
        LOCATION_LATITUDE_DEG: 50.9194378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO009900',
        LOCATION_NAME: 'Goosey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.484607,
        LOCATION_LATITUDE_DEG: 51.6241735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010000',
        LOCATION_NAME: 'Goosnargh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6706109,
        LOCATION_LATITUDE_DEG: 53.8238976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010100',
        LOCATION_NAME: 'Goostrey',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3411069,
        LOCATION_LATITUDE_DEG: 53.2276402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010200',
        LOCATION_NAME: 'Gopsall',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4707819,
        LOCATION_LATITUDE_DEG: 52.6524211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010300',
        LOCATION_NAME: 'Gorad',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5564916,
        LOCATION_LATITUDE_DEG: 53.2934658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010400',
        LOCATION_NAME: 'Gorbals',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.248546,
        LOCATION_LATITUDE_DEG: 55.8507181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010500',
        LOCATION_NAME: 'Gordon',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5610545,
        LOCATION_LATITUDE_DEG: 55.6807773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010600',
        LOCATION_NAME: 'Gordonstown',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4788055,
        LOCATION_LATITUDE_DEG: 57.4353508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010700',
        LOCATION_NAME: 'Gore Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2309317,
        LOCATION_LATITUDE_DEG: 50.9880171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010800',
        LOCATION_NAME: 'Gore End',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3998391,
        LOCATION_LATITUDE_DEG: 51.3678497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO010900',
        LOCATION_NAME: 'Gorebridge',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0450526,
        LOCATION_LATITUDE_DEG: 55.8393981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011000',
        LOCATION_NAME: 'Gorefield',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.096928,
        LOCATION_LATITUDE_DEG: 52.6867516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011300',
        LOCATION_NAME: 'Gorgie',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2340655,
        LOCATION_LATITUDE_DEG: 55.9357101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011400',
        LOCATION_NAME: 'Goring',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.131956,
        LOCATION_LATITUDE_DEG: 51.5227543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020800',
        LOCATION_NAME: 'Goring by Sea',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.423488,
        LOCATION_LATITUDE_DEG: 50.8146152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011500',
        LOCATION_NAME: 'Goring Heath',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.066899,
        LOCATION_LATITUDE_DEG: 51.5114546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011600',
        LOCATION_NAME: 'Goring-by-Sea',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4209685,
        LOCATION_LATITUDE_DEG: 50.8072328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011700',
        LOCATION_NAME: 'Gorleston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7317943,
        LOCATION_LATITUDE_DEG: 52.5740188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011800',
        LOCATION_NAME: 'Gorley Lynch',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7524803,
        LOCATION_LATITUDE_DEG: 50.9080051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012000',
        LOCATION_NAME: 'Gornal Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1281452,
        LOCATION_LATITUDE_DEG: 52.5154698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012100',
        LOCATION_NAME: 'Gorran',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7988811,
        LOCATION_LATITUDE_DEG: 50.2327741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012200',
        LOCATION_NAME: 'Gorran Churchtown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8066979,
        LOCATION_LATITUDE_DEG: 50.2459811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012300',
        LOCATION_NAME: 'Gorran Haven',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7869227,
        LOCATION_LATITUDE_DEG: 50.2400789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012400',
        LOCATION_NAME: 'Gorse Hill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2972314,
        LOCATION_LATITUDE_DEG: 53.4529596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012500',
        LOCATION_NAME: 'Gorsedd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2709582,
        LOCATION_LATITUDE_DEG: 53.2797538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012600',
        LOCATION_NAME: 'Gorseinon',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.040416,
        LOCATION_LATITUDE_DEG: 51.6690069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012700',
        LOCATION_NAME: 'Gorsey Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3235627,
        LOCATION_LATITUDE_DEG: 52.7049836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012800',
        LOCATION_NAME: 'Gorsgoch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.216799,
        LOCATION_LATITUDE_DEG: 52.1327514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO012900',
        LOCATION_NAME: 'Gorslas',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0737329,
        LOCATION_LATITUDE_DEG: 51.8039194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013000',
        LOCATION_NAME: 'Gorsley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4589049,
        LOCATION_LATITUDE_DEG: 51.9301139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013100',
        LOCATION_NAME: 'Gorstan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7020167,
        LOCATION_LATITUDE_DEG: 57.6238996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013200',
        LOCATION_NAME: 'Gorstley Rough',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6009149,
        LOCATION_LATITUDE_DEG: 52.3689588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013300',
        LOCATION_NAME: 'Gorsty Hill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8511198,
        LOCATION_LATITUDE_DEG: 52.8587914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013400',
        LOCATION_NAME: 'Gorsty Knoll',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5973408,
        LOCATION_LATITUDE_DEG: 51.7782011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013600',
        LOCATION_NAME: 'Gortaclare',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1919283,
        LOCATION_LATITUDE_DEG: 54.5672181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014950',
        LOCATION_NAME: 'Gorthleck',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4193308,
        LOCATION_LATITUDE_DEG: 57.2495299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015000',
        LOCATION_NAME: 'Gortin',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2352247,
        LOCATION_LATITUDE_DEG: 54.7221313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015500',
        LOCATION_NAME: 'Gortnagarn',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3001269,
        LOCATION_LATITUDE_DEG: 54.6394961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015800',
        LOCATION_NAME: 'Gortnalee',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -8.0491108,
        LOCATION_LATITUDE_DEG: 54.4499121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016000',
        LOCATION_NAME: 'Gorton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1785339,
        LOCATION_LATITUDE_DEG: 53.4621585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016400',
        LOCATION_NAME: 'Gosbeck',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1623828,
        LOCATION_LATITUDE_DEG: 52.1559906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016500',
        LOCATION_NAME: 'Gosberton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1600875,
        LOCATION_LATITUDE_DEG: 52.8689772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016600',
        LOCATION_NAME: 'Gosberton Clough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2314787,
        LOCATION_LATITUDE_DEG: 52.8512697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016650',
        LOCATION_NAME: 'Gosberton Risegate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2058656,
        LOCATION_LATITUDE_DEG: 52.8362919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016700',
        LOCATION_NAME: 'Gosfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5946793,
        LOCATION_LATITUDE_DEG: 51.934574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016800',
        LOCATION_NAME: 'Gosford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2884479,
        LOCATION_LATITUDE_DEG: 50.7658161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016900',
        LOCATION_NAME: 'Gosford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2705476,
        LOCATION_LATITUDE_DEG: 51.8170844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017000',
        LOCATION_NAME: 'Gosforth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4334808,
        LOCATION_LATITUDE_DEG: 54.4184636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020900',
        LOCATION_NAME: 'Gosforth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6192742,
        LOCATION_LATITUDE_DEG: 55.0149378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017100',
        LOCATION_NAME: 'Goshen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2016209,
        LOCATION_LATITUDE_DEG: 50.310087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017200',
        LOCATION_NAME: 'Gosmore',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.272339,
        LOCATION_LATITUDE_DEG: 51.9288866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO021200',
        LOCATION_NAME: 'Gospel Oak',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1512799,
        LOCATION_LATITUDE_DEG: 51.5560227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017300',
        LOCATION_NAME: 'Gosport',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1213292,
        LOCATION_LATITUDE_DEG: 50.7948869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017400',
        LOCATION_NAME: 'Goss Moor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9003431,
        LOCATION_LATITUDE_DEG: 50.3995974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO021500',
        LOCATION_NAME: 'Gosta Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8883127,
        LOCATION_LATITUDE_DEG: 52.488055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017500',
        LOCATION_NAME: 'Gotham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2036804,
        LOCATION_LATITUDE_DEG: 52.8659875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017600',
        LOCATION_NAME: 'Gotherington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0540339,
        LOCATION_LATITUDE_DEG: 51.9649131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017700',
        LOCATION_NAME: 'Gothers',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8579824,
        LOCATION_LATITUDE_DEG: 50.3900939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017900',
        LOCATION_NAME: 'Gott',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2222466,
        LOCATION_LATITUDE_DEG: 60.1903107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018000',
        LOCATION_NAME: 'Goudhurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4605746,
        LOCATION_LATITUDE_DEG: 51.1124943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018200',
        LOCATION_NAME: 'Goulceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.118716,
        LOCATION_LATITUDE_DEG: 53.293615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018400',
        LOCATION_NAME: 'Gourdon',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2812316,
        LOCATION_LATITUDE_DEG: 56.8285909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018500',
        LOCATION_NAME: 'Gourock',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8147605,
        LOCATION_LATITUDE_DEG: 55.959635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018600',
        LOCATION_NAME: 'Govan',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3110836,
        LOCATION_LATITUDE_DEG: 55.8633206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO021600',
        LOCATION_NAME: 'Govanhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2583666,
        LOCATION_LATITUDE_DEG: 55.8406957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018700',
        LOCATION_NAME: 'Gover Valley',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.82306,
        LOCATION_LATITUDE_DEG: 50.3465867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO990542',
        LOCATION_NAME: 'Governors Hill',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018800',
        LOCATION_NAME: 'Goveton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7507239,
        LOCATION_LATITUDE_DEG: 50.3031707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018900',
        LOCATION_NAME: 'Govig',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0569028,
        LOCATION_LATITUDE_DEG: 57.9719543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019000',
        LOCATION_NAME: 'Govilon',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0630619,
        LOCATION_LATITUDE_DEG: 51.8182108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019100',
        LOCATION_NAME: 'Gowanbank',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6439902,
        LOCATION_LATITUDE_DEG: 56.5967741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019200',
        LOCATION_NAME: 'Gowdall',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0617348,
        LOCATION_LATITUDE_DEG: 53.693464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019300',
        LOCATION_NAME: 'Gowerton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0383137,
        LOCATION_LATITUDE_DEG: 51.6473059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019400',
        LOCATION_NAME: 'Gowkhall',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5248985,
        LOCATION_LATITUDE_DEG: 56.0847279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019500',
        LOCATION_NAME: 'Gowkshill',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0531438,
        LOCATION_LATITUDE_DEG: 55.8574998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020300',
        LOCATION_NAME: 'Gowthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8360415,
        LOCATION_LATITUDE_DEG: 53.9802897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020400',
        LOCATION_NAME: 'Goxhill',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1972438,
        LOCATION_LATITUDE_DEG: 53.8856749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020600',
        LOCATION_NAME: 'Goytre',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7471461,
        LOCATION_LATITUDE_DEG: 51.5919969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020500',
        LOCATION_NAME: 'Goytre',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.956471,
        LOCATION_LATITUDE_DEG: 51.7227996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020700',
        LOCATION_NAME: 'Gozzards Ford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.328025,
        LOCATION_LATITUDE_DEG: 51.6828756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000100',
        LOCATION_NAME: 'Graby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3703948,
        LOCATION_LATITUDE_DEG: 52.8525747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000300',
        LOCATION_NAME: 'Gracehill',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3322218,
        LOCATION_LATITUDE_DEG: 54.8499273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000400',
        LOCATION_NAME: 'Graemsay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2937411,
        LOCATION_LATITUDE_DEG: 58.9286115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000500',
        LOCATION_NAME: 'Graffham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6790347,
        LOCATION_LATITUDE_DEG: 50.9492982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000800',
        LOCATION_NAME: 'Grafham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2959966,
        LOCATION_LATITUDE_DEG: 52.3075205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001000',
        LOCATION_NAME: 'Grafton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8407717,
        LOCATION_LATITUDE_DEG: 52.7652993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000900',
        LOCATION_NAME: 'Grafton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7332169,
        LOCATION_LATITUDE_DEG: 52.0299294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001100',
        LOCATION_NAME: 'Grafton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6093277,
        LOCATION_LATITUDE_DEG: 51.7035801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001200',
        LOCATION_NAME: 'Grafton Flyford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0567413,
        LOCATION_LATITUDE_DEG: 52.2065344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001300',
        LOCATION_NAME: 'Grafton Regis',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8963892,
        LOCATION_LATITUDE_DEG: 52.111909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001400',
        LOCATION_NAME: 'Grafton Underwood',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6424121,
        LOCATION_LATITUDE_DEG: 52.4115412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001500',
        LOCATION_NAME: 'Grafty Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6815546,
        LOCATION_LATITUDE_DEG: 51.2081081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054400',
        LOCATION_NAME: 'Grahame Park Estate',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.24178,
        LOCATION_LATITUDE_DEG: 51.6013285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001600',
        LOCATION_NAME: 'Graianrhyd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.168885,
        LOCATION_LATITUDE_DEG: 53.0966375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001900',
        LOCATION_NAME: 'Graig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2447963,
        LOCATION_LATITUDE_DEG: 51.693113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001800',
        LOCATION_NAME: 'Graig',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7928323,
        LOCATION_LATITUDE_DEG: 53.2286506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR001700',
        LOCATION_NAME: 'Graig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3421206,
        LOCATION_LATITUDE_DEG: 51.5952951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002000',
        LOCATION_NAME: 'Graig Penllyn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4728062,
        LOCATION_LATITUDE_DEG: 51.4848843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002100',
        LOCATION_NAME: 'Graigadwywynt',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3196129,
        LOCATION_LATITUDE_DEG: 53.0713351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002200',
        LOCATION_NAME: 'Graigfechan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2718781,
        LOCATION_LATITUDE_DEG: 53.0755501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003100',
        LOCATION_NAME: 'Graigwen',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3482193,
        LOCATION_LATITUDE_DEG: 51.6066912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003200',
        LOCATION_NAME: 'Grainsby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0726815,
        LOCATION_LATITUDE_DEG: 53.4762354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003300',
        LOCATION_NAME: 'Grainthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0815084,
        LOCATION_LATITUDE_DEG: 53.4518265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003400',
        LOCATION_NAME: 'Graiselound',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8363251,
        LOCATION_LATITUDE_DEG: 53.479343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003500',
        LOCATION_NAME: 'Grampound',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9002385,
        LOCATION_LATITUDE_DEG: 50.2984802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003600',
        LOCATION_NAME: 'Grampound Road',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9289036,
        LOCATION_LATITUDE_DEG: 50.3162848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003700',
        LOCATION_NAME: 'Gramsdale',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3070833,
        LOCATION_LATITUDE_DEG: 57.479509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004000',
        LOCATION_NAME: 'Granborough',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8840057,
        LOCATION_LATITUDE_DEG: 51.917994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004100',
        LOCATION_NAME: 'Granby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.884096,
        LOCATION_LATITUDE_DEG: 52.9185912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004200',
        LOCATION_NAME: 'Grand View',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9334128,
        LOCATION_LATITUDE_DEG: 53.6966794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004300',
        LOCATION_NAME: 'Grandborough',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2789422,
        LOCATION_LATITUDE_DEG: 52.2985315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004400',
        LOCATION_NAME: 'Grandholm',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1234848,
        LOCATION_LATITUDE_DEG: 57.1773206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004500',
        LOCATION_NAME: 'Grandtully',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7729371,
        LOCATION_LATITUDE_DEG: 56.6561881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005700',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.49389,
        LOCATION_LATITUDE_DEG: 54.4799715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055900',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1883543,
        LOCATION_LATITUDE_DEG: 55.9356473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004900',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1525783,
        LOCATION_LATITUDE_DEG: 54.5465738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005800',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8701056,
        LOCATION_LATITUDE_DEG: 57.5520709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004800',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7755976,
        LOCATION_LATITUDE_DEG: 56.317341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004700',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9744997,
        LOCATION_LATITUDE_DEG: 50.822206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006200',
        LOCATION_NAME: 'Grange Court',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3954456,
        LOCATION_LATITUDE_DEG: 51.8426006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053300',
        LOCATION_NAME: 'Grange de Lings',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990508',
        LOCATION_NAME: 'Grange Farm',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8060996,
        LOCATION_LATITUDE_DEG: 52.0167559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006300',
        LOCATION_NAME: 'Grange Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0921165,
        LOCATION_LATITUDE_DEG: 51.6126511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006400',
        LOCATION_NAME: 'Grange Mill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6372682,
        LOCATION_LATITUDE_DEG: 53.1149136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006500',
        LOCATION_NAME: 'Grange Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6668194,
        LOCATION_LATITUDE_DEG: 53.6393686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006800',
        LOCATION_NAME: 'Grange of Lindores',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2057502,
        LOCATION_LATITUDE_DEG: 56.3354496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053400',
        LOCATION_NAME: 'Grange over Sands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006600',
        LOCATION_NAME: 'Grange Park',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8411655,
        LOCATION_LATITUDE_DEG: 51.5541664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054300',
        LOCATION_NAME: 'Grange Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6218511,
        LOCATION_LATITUDE_DEG: 55.0170039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054350',
        LOCATION_NAME: 'Grange Park',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8822872,
        LOCATION_LATITUDE_DEG: 52.1863642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006700',
        LOCATION_NAME: 'Grange Villa',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6363495,
        LOCATION_LATITUDE_DEG: 54.8613868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006900',
        LOCATION_NAME: 'Grange-de-Lings',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5191183,
        LOCATION_LATITUDE_DEG: 53.2829236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007600',
        LOCATION_NAME: 'Grangemouth',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7170465,
        LOCATION_LATITUDE_DEG: 56.0188272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007000',
        LOCATION_NAME: 'Grange-over-Sands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9079376,
        LOCATION_LATITUDE_DEG: 54.1928377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007700',
        LOCATION_NAME: 'Grangetown',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1880978,
        LOCATION_LATITUDE_DEG: 51.4727814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007800',
        LOCATION_NAME: 'Grangetown',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1528148,
        LOCATION_LATITUDE_DEG: 54.5776533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007900',
        LOCATION_NAME: 'Grangewood',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5977594,
        LOCATION_LATITUDE_DEG: 52.7266801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008000',
        LOCATION_NAME: 'Granham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7404608,
        LOCATION_LATITUDE_DEG: 51.4075521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008300',
        LOCATION_NAME: 'Gransmoor',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2829836,
        LOCATION_LATITUDE_DEG: 54.01949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990506',
        LOCATION_NAME: 'Granston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008400',
        LOCATION_NAME: 'Grantchester',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0949015,
        LOCATION_LATITUDE_DEG: 52.180602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008500',
        LOCATION_NAME: 'Grantham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6387345,
        LOCATION_LATITUDE_DEG: 52.9150891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008600',
        LOCATION_NAME: 'Grantley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6435347,
        LOCATION_LATITUDE_DEG: 54.1246144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055800',
        LOCATION_NAME: 'Granton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2280849,
        LOCATION_LATITUDE_DEG: 55.9769194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053500',
        LOCATION_NAME: 'Grantown on Spey',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'PH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008700',
        LOCATION_NAME: 'Grantown-on-Spey',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'PH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6086469,
        LOCATION_LATITUDE_DEG: 57.3294568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008800',
        LOCATION_NAME: 'Grantshouse',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3040891,
        LOCATION_LATITUDE_DEG: 55.8824953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009000',
        LOCATION_NAME: 'Grappenhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5452018,
        LOCATION_LATITUDE_DEG: 53.3717533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009100',
        LOCATION_NAME: 'Grasby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3589716,
        LOCATION_LATITUDE_DEG: 53.5295449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009200',
        LOCATION_NAME: 'Grasmere',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0236681,
        LOCATION_LATITUDE_DEG: 54.4590625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009300',
        LOCATION_NAME: 'Grasscroft',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0269811,
        LOCATION_LATITUDE_DEG: 53.5368654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009400',
        LOCATION_NAME: 'Grassendale',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9066034,
        LOCATION_LATITUDE_DEG: 53.3583541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009500',
        LOCATION_NAME: 'Grassendale Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9117131,
        LOCATION_LATITUDE_DEG: 53.3562565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009600',
        LOCATION_NAME: 'Grassington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9969586,
        LOCATION_LATITUDE_DEG: 54.0713186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055700',
        LOCATION_NAME: 'Grassmarket',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1982296,
        LOCATION_LATITUDE_DEG: 55.947998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009700',
        LOCATION_NAME: 'Grassmoor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3908426,
        LOCATION_LATITUDE_DEG: 53.1952234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009800',
        LOCATION_NAME: 'Grassthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8079139,
        LOCATION_LATITUDE_DEG: 53.2010122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR009900',
        LOCATION_NAME: 'Grasswell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4751257,
        LOCATION_LATITUDE_DEG: 54.8513871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010000',
        LOCATION_NAME: 'Grateley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6061569,
        LOCATION_LATITUDE_DEG: 51.1767354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010100',
        LOCATION_NAME: 'Gratwich',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9564108,
        LOCATION_LATITUDE_DEG: 52.8815955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010300',
        LOCATION_NAME: 'Graveley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2089113,
        LOCATION_LATITUDE_DEG: 51.9355824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010200',
        LOCATION_NAME: 'Graveley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.171388,
        LOCATION_LATITUDE_DEG: 52.2601188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055300',
        LOCATION_NAME: 'Gravelly Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.850602,
        LOCATION_LATITUDE_DEG: 52.5156967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010400',
        LOCATION_NAME: 'Graveney',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9485999,
        LOCATION_LATITUDE_DEG: 51.3274084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010500',
        LOCATION_NAME: 'Gravenhurst',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3753539,
        LOCATION_LATITUDE_DEG: 52.0122768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010600',
        LOCATION_NAME: 'Gravesend',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3703084,
        LOCATION_LATITUDE_DEG: 51.4420302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010700',
        LOCATION_NAME: 'Gravir',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4182749,
        LOCATION_LATITUDE_DEG: 58.0485535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010800',
        LOCATION_NAME: 'Grayingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5922741,
        LOCATION_LATITUDE_DEG: 53.4541335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR010900',
        LOCATION_NAME: 'Grayrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.648305,
        LOCATION_LATITUDE_DEG: 54.3680551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011000',
        LOCATION_NAME: 'Grays',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.325657,
        LOCATION_LATITUDE_DEG: 51.4767341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011100',
        LOCATION_NAME: 'Grayshott',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.752734,
        LOCATION_LATITUDE_DEG: 51.1101151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011200',
        LOCATION_NAME: 'Grayson Green',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5437798,
        LOCATION_LATITUDE_DEG: 54.6133879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011300',
        LOCATION_NAME: 'Grayswood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6900343,
        LOCATION_LATITUDE_DEG: 51.1038174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011400',
        LOCATION_NAME: 'Graythorp',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1989917,
        LOCATION_LATITUDE_DEG: 54.6364622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR991046',
        LOCATION_NAME: 'Graythwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9686766,
        LOCATION_LATITUDE_DEG: 54.3135485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011500',
        LOCATION_NAME: 'Grazeley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9920581,
        LOCATION_LATITUDE_DEG: 51.3970484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011700',
        LOCATION_NAME: 'Grealine',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1517298,
        LOCATION_LATITUDE_DEG: 57.5751067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011800',
        LOCATION_NAME: 'Grean',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.480995,
        LOCATION_LATITUDE_DEG: 57.0056591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011900',
        LOCATION_NAME: 'Greasbrough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3662117,
        LOCATION_LATITUDE_DEG: 53.4529428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012100',
        LOCATION_NAME: 'Greasley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2664415,
        LOCATION_LATITUDE_DEG: 53.0187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012200',
        LOCATION_NAME: 'Great Abington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2394233,
        LOCATION_LATITUDE_DEG: 52.1158931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012300',
        LOCATION_NAME: 'Great Addington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5917781,
        LOCATION_LATITUDE_DEG: 52.3651354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012400',
        LOCATION_NAME: 'Great Alne',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8246963,
        LOCATION_LATITUDE_DEG: 52.2328346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012500',
        LOCATION_NAME: 'Great Altcar',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.019593,
        LOCATION_LATITUDE_DEG: 53.5493777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012600',
        LOCATION_NAME: 'Great Amwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0145399,
        LOCATION_LATITUDE_DEG: 51.7900739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012700',
        LOCATION_NAME: 'Great Asby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4936291,
        LOCATION_LATITUDE_DEG: 54.5127679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012800',
        LOCATION_NAME: 'Great Ashfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9261301,
        LOCATION_LATITUDE_DEG: 52.2706007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR012900',
        LOCATION_NAME: 'Great Ashley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2686114,
        LOCATION_LATITUDE_DEG: 51.3558595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013000',
        LOCATION_NAME: 'Great Ayton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.139641,
        LOCATION_LATITUDE_DEG: 54.4890441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013100',
        LOCATION_NAME: 'Great Baddow',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4900495,
        LOCATION_LATITUDE_DEG: 51.7217523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013200',
        LOCATION_NAME: 'Great Bardfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4369793,
        LOCATION_LATITUDE_DEG: 51.9470747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013300',
        LOCATION_NAME: 'Great Barford',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3457897,
        LOCATION_LATITUDE_DEG: 52.155413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013500',
        LOCATION_NAME: 'Great Barrington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6986983,
        LOCATION_LATITUDE_DEG: 51.820795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013600',
        LOCATION_NAME: 'Great Barrow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7923943,
        LOCATION_LATITUDE_DEG: 53.2099414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013700',
        LOCATION_NAME: 'Great Barton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7724358,
        LOCATION_LATITUDE_DEG: 52.2682052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013800',
        LOCATION_NAME: 'Great Barugh',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8508456,
        LOCATION_LATITUDE_DEG: 54.2012144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR013900',
        LOCATION_NAME: 'Great Bavington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0238808,
        LOCATION_LATITUDE_DEG: 55.1177145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014000',
        LOCATION_NAME: 'Great Bealings',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.258549,
        LOCATION_LATITUDE_DEG: 52.0932831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014100',
        LOCATION_NAME: 'Great Bedwyn',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5999702,
        LOCATION_LATITUDE_DEG: 51.3788477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014200',
        LOCATION_NAME: 'Great Bentley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0647094,
        LOCATION_LATITUDE_DEG: 51.8543565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014300',
        LOCATION_NAME: 'Great Billing',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8125455,
        LOCATION_LATITUDE_DEG: 52.2589218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014400',
        LOCATION_NAME: 'Great Billington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6293709,
        LOCATION_LATITUDE_DEG: 51.8912852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990810',
        LOCATION_NAME: 'Great Bircham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014500',
        LOCATION_NAME: 'Great Blakenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0937179,
        LOCATION_LATITUDE_DEG: 52.1141886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014600',
        LOCATION_NAME: 'Great Bolas',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5279128,
        LOCATION_LATITUDE_DEG: 52.793096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014700',
        LOCATION_NAME: 'Great Bookham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3711549,
        LOCATION_LATITUDE_DEG: 51.2771214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014800',
        LOCATION_NAME: 'Great Boughton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8607256,
        LOCATION_LATITUDE_DEG: 53.1859401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR014900',
        LOCATION_NAME: 'Great Boulsdon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4203114,
        LOCATION_LATITUDE_DEG: 51.9156102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015000',
        LOCATION_NAME: 'Great Bourton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3319357,
        LOCATION_LATITUDE_DEG: 52.1059197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015100',
        LOCATION_NAME: 'Great Bowden',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9031176,
        LOCATION_LATITUDE_DEG: 52.4919517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015200',
        LOCATION_NAME: 'Great Bradley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4420793,
        LOCATION_LATITUDE_DEG: 52.1499018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015300',
        LOCATION_NAME: 'Great Braxted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7002417,
        LOCATION_LATITUDE_DEG: 51.7946574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015400',
        LOCATION_NAME: 'Great Bricett',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9806406,
        LOCATION_LATITUDE_DEG: 52.1144863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015500',
        LOCATION_NAME: 'Great Brickhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6840639,
        LOCATION_LATITUDE_DEG: 51.9627968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015600',
        LOCATION_NAME: 'Great Bridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0340113,
        LOCATION_LATITUDE_DEG: 52.5300637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015700',
        LOCATION_NAME: 'Great Bridgeford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1735797,
        LOCATION_LATITUDE_DEG: 52.8395992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015800',
        LOCATION_NAME: 'Great Brington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0226715,
        LOCATION_LATITUDE_DEG: 52.2803331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR015900',
        LOCATION_NAME: 'Great Bromley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0287269,
        LOCATION_LATITUDE_DEG: 51.8938684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016000',
        LOCATION_NAME: 'Great Broughton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4352899,
        LOCATION_LATITUDE_DEG: 54.6687897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016100',
        LOCATION_NAME: 'Great Broughton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1583431,
        LOCATION_LATITUDE_DEG: 54.4489441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016200',
        LOCATION_NAME: 'Great Budworth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5034235,
        LOCATION_LATITUDE_DEG: 53.2935456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016300',
        LOCATION_NAME: 'Great Burdon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5053811,
        LOCATION_LATITUDE_DEG: 54.5422536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016400',
        LOCATION_NAME: 'Great Burstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4298526,
        LOCATION_LATITUDE_DEG: 51.6061436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016500',
        LOCATION_NAME: 'Great Busby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1947803,
        LOCATION_LATITUDE_DEG: 54.4439432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990659',
        LOCATION_NAME: 'Great Cambourne',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0684349,
        LOCATION_LATITUDE_DEG: 52.2115912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016600',
        LOCATION_NAME: 'Great Canfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3123941,
        LOCATION_LATITUDE_DEG: 51.8368714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016700',
        LOCATION_NAME: 'Great Carlton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1205852,
        LOCATION_LATITUDE_DEG: 53.3439167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990126',
        LOCATION_NAME: 'Great Casterton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5225327,
        LOCATION_LATITUDE_DEG: 52.6753405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016800',
        LOCATION_NAME: 'Great Casterton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5160367,
        LOCATION_LATITUDE_DEG: 52.6653597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR016900',
        LOCATION_NAME: 'Great Chalfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1997177,
        LOCATION_LATITUDE_DEG: 51.3667525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017000',
        LOCATION_NAME: 'Great Chart',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8317422,
        LOCATION_LATITUDE_DEG: 51.1419959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017100',
        LOCATION_NAME: 'Great Chatwell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3069891,
        LOCATION_LATITUDE_DEG: 52.7266862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017200',
        LOCATION_NAME: 'Great Chesterford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1987661,
        LOCATION_LATITUDE_DEG: 52.0638954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017300',
        LOCATION_NAME: 'Great Cheverell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0248681,
        LOCATION_LATITUDE_DEG: 51.2879455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017400',
        LOCATION_NAME: 'Great Chishill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0736443,
        LOCATION_LATITUDE_DEG: 52.0291935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017500',
        LOCATION_NAME: 'Great Clacton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1509926,
        LOCATION_LATITUDE_DEG: 51.8042564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017600',
        LOCATION_NAME: 'Great Clifton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4865502,
        LOCATION_LATITUDE_DEG: 54.6510929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017700',
        LOCATION_NAME: 'Great Coates',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1372498,
        LOCATION_LATITUDE_DEG: 53.5703415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017800',
        LOCATION_NAME: 'Great Comberton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0645046,
        LOCATION_LATITUDE_DEG: 52.0795251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR017900',
        LOCATION_NAME: 'Great Corby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8228179,
        LOCATION_LATITUDE_DEG: 54.8813078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018000',
        LOCATION_NAME: 'Great Cornard',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7616774,
        LOCATION_LATITUDE_DEG: 52.0299793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018100',
        LOCATION_NAME: 'Great Coxwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6098157,
        LOCATION_LATITUDE_DEG: 51.6417777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018200',
        LOCATION_NAME: 'Great Cransley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7789317,
        LOCATION_LATITUDE_DEG: 52.3825394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018300',
        LOCATION_NAME: 'Great Cressingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7332059,
        LOCATION_LATITUDE_DEG: 52.5817329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054900',
        LOCATION_NAME: 'Great Crosby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0222633,
        LOCATION_LATITUDE_DEG: 53.4941752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018400',
        LOCATION_NAME: 'Great Cumberwell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2577397,
        LOCATION_LATITUDE_DEG: 51.3662615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018500',
        LOCATION_NAME: 'Great Dalby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9012155,
        LOCATION_LATITUDE_DEG: 52.7209681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018600',
        LOCATION_NAME: 'Great Doddington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7070758,
        LOCATION_LATITUDE_DEG: 52.2738284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018700',
        LOCATION_NAME: 'Great Doward',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6590832,
        LOCATION_LATITUDE_DEG: 51.8479112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018800',
        LOCATION_NAME: 'Great Driffield',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4384291,
        LOCATION_LATITUDE_DEG: 54.0054913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR018900',
        LOCATION_NAME: 'Great Dunham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7722839,
        LOCATION_LATITUDE_DEG: 52.6966426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053700',
        LOCATION_NAME: 'Great Dunmow',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3632295,
        LOCATION_LATITUDE_DEG: 51.8769171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019000',
        LOCATION_NAME: 'Great Durnford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8061609,
        LOCATION_LATITUDE_DEG: 51.1411306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019100',
        LOCATION_NAME: 'Great Easton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7485071,
        LOCATION_LATITUDE_DEG: 52.5281457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019200',
        LOCATION_NAME: 'Great Easton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.336794,
        LOCATION_LATITUDE_DEG: 51.9045793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019300',
        LOCATION_NAME: 'Great Eccleston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8688721,
        LOCATION_LATITUDE_DEG: 53.8548071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019400',
        LOCATION_NAME: 'Great Edstone',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9159192,
        LOCATION_LATITUDE_DEG: 54.246717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019500',
        LOCATION_NAME: 'Great Ellingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9777218,
        LOCATION_LATITUDE_DEG: 52.5333264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019600',
        LOCATION_NAME: 'Great Elm',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3622247,
        LOCATION_LATITUDE_DEG: 51.2406428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019700',
        LOCATION_NAME: 'Great Everdon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1317803,
        LOCATION_LATITUDE_DEG: 52.1996227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019800',
        LOCATION_NAME: 'Great Eversden',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0048983,
        LOCATION_LATITUDE_DEG: 52.1623055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR019900',
        LOCATION_NAME: 'Great Fencote',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5632114,
        LOCATION_LATITUDE_DEG: 54.3380321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020000',
        LOCATION_NAME: 'Great Finborough',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9445492,
        LOCATION_LATITUDE_DEG: 52.1801899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020100',
        LOCATION_NAME: 'Great Fransham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8072264,
        LOCATION_LATITUDE_DEG: 52.6824464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990845',
        LOCATION_NAME: 'Great Fryup Dale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990846',
        LOCATION_NAME: 'Great Fryupdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020200',
        LOCATION_NAME: 'Great Gaddesden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5066898,
        LOCATION_LATITUDE_DEG: 51.7899731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990105',
        LOCATION_NAME: 'Great Gate',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9171162,
        LOCATION_LATITUDE_DEG: 52.9597007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020300',
        LOCATION_NAME: 'Great Gidding',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3570751,
        LOCATION_LATITUDE_DEG: 52.4328368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020400',
        LOCATION_NAME: 'Great Glemham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4257127,
        LOCATION_LATITUDE_DEG: 52.2036901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020500',
        LOCATION_NAME: 'Great Glen',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0327583,
        LOCATION_LATITUDE_DEG: 52.5712616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020600',
        LOCATION_NAME: 'Great Gonerby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.665253,
        LOCATION_LATITUDE_DEG: 52.9349904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020700',
        LOCATION_NAME: 'Great Gransden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1440011,
        LOCATION_LATITUDE_DEG: 52.1849091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020800',
        LOCATION_NAME: 'Great Habton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8371016,
        LOCATION_LATITUDE_DEG: 54.1774144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR020900',
        LOCATION_NAME: 'Great Hale',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2909104,
        LOCATION_LATITUDE_DEG: 52.9712858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021000',
        LOCATION_NAME: 'Great Hale Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3008735,
        LOCATION_LATITUDE_DEG: 52.9625812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021100',
        LOCATION_NAME: 'Great Hallingbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1962757,
        LOCATION_LATITUDE_DEG: 51.8549715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021200',
        LOCATION_NAME: 'Great Hampden',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7776499,
        LOCATION_LATITUDE_DEG: 51.7054697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021300',
        LOCATION_NAME: 'Great Harrowden',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.708622,
        LOCATION_LATITUDE_DEG: 52.3285338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021400',
        LOCATION_NAME: 'Great Harwood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4042771,
        LOCATION_LATITUDE_DEG: 53.789593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021500',
        LOCATION_NAME: 'Great Haseley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0717199,
        LOCATION_LATITUDE_DEG: 51.7114794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021600',
        LOCATION_NAME: 'Great Hatfield',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2002441,
        LOCATION_LATITUDE_DEG: 53.8689711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021700',
        LOCATION_NAME: 'Great Haywood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0017505,
        LOCATION_LATITUDE_DEG: 52.8028921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021800',
        LOCATION_NAME: 'Great Heck',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1024533,
        LOCATION_LATITUDE_DEG: 53.6818649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR021900',
        LOCATION_NAME: 'Great Henny',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7209098,
        LOCATION_LATITUDE_DEG: 52.006977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022000',
        LOCATION_NAME: 'Great Hinton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1329807,
        LOCATION_LATITUDE_DEG: 51.3298511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022100',
        LOCATION_NAME: 'Great Hockham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8790055,
        LOCATION_LATITUDE_DEG: 52.4963233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022200',
        LOCATION_NAME: 'Great Holland',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2112198,
        LOCATION_LATITUDE_DEG: 51.8276596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022300',
        LOCATION_NAME: 'Great Holm',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7930486,
        LOCATION_LATITUDE_DEG: 52.033807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022400',
        LOCATION_NAME: 'Great Horkesley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8774216,
        LOCATION_LATITUDE_DEG: 51.937874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022500',
        LOCATION_NAME: 'Great Hormead',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0393649,
        LOCATION_LATITUDE_DEG: 51.9502838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022600',
        LOCATION_NAME: 'Great Horton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7944179,
        LOCATION_LATITUDE_DEG: 53.7782866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022700',
        LOCATION_NAME: 'Great Horwood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.879349,
        LOCATION_LATITUDE_DEG: 51.9730003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022800',
        LOCATION_NAME: 'Great Houghton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3494588,
        LOCATION_LATITUDE_DEG: 53.5537523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR022900',
        LOCATION_NAME: 'Great Houghton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8406721,
        LOCATION_LATITUDE_DEG: 52.2238185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023000',
        LOCATION_NAME: 'Great Howarth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1340736,
        LOCATION_LATITUDE_DEG: 53.636476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023100',
        LOCATION_NAME: 'Great Hucklow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7322581,
        LOCATION_LATITUDE_DEG: 53.2969325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023200',
        LOCATION_NAME: 'Great Humby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5039847,
        LOCATION_LATITUDE_DEG: 52.8784838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023300',
        LOCATION_NAME: 'Great Kelk',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3170723,
        LOCATION_LATITUDE_DEG: 54.0077908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023400',
        LOCATION_NAME: 'Great Kimble',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8036445,
        LOCATION_LATITUDE_DEG: 51.7460781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023500',
        LOCATION_NAME: 'Great Kingshill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7249277,
        LOCATION_LATITUDE_DEG: 51.6748646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023600',
        LOCATION_NAME: 'Great Langdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0657663,
        LOCATION_LATITUDE_DEG: 54.4487662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023700',
        LOCATION_NAME: 'Great Langton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5463311,
        LOCATION_LATITUDE_DEG: 54.362337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023800',
        LOCATION_NAME: 'Great Leighs',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5072296,
        LOCATION_LATITUDE_DEG: 51.826168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR023900',
        LOCATION_NAME: 'Great Lever',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4135541,
        LOCATION_LATITUDE_DEG: 53.5640746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024000',
        LOCATION_NAME: 'Great Linford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7513464,
        LOCATION_LATITUDE_DEG: 52.0690084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024100',
        LOCATION_NAME: 'Great Livermere',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7679041,
        LOCATION_LATITUDE_DEG: 52.3065089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024200',
        LOCATION_NAME: 'Great Longstone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7000336,
        LOCATION_LATITUDE_DEG: 53.2423324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024300',
        LOCATION_NAME: 'Great Lumley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.539651,
        LOCATION_LATITUDE_DEG: 54.8371879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024400',
        LOCATION_NAME: 'Great Lyth',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8000065,
        LOCATION_LATITUDE_DEG: 52.6590842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024500',
        LOCATION_NAME: 'Great Malgraves',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4092888,
        LOCATION_LATITUDE_DEG: 51.5388414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055200',
        LOCATION_NAME: 'Great Malvern',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3256654,
        LOCATION_LATITUDE_DEG: 52.1081898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024600',
        LOCATION_NAME: 'Great Maplestead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6322945,
        LOCATION_LATITUDE_DEG: 51.9800759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024700',
        LOCATION_NAME: 'Great Massingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6659358,
        LOCATION_LATITUDE_DEG: 52.7730526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024800',
        LOCATION_NAME: 'Great Meadow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1762883,
        LOCATION_LATITUDE_DEG: 52.207837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR024900',
        LOCATION_NAME: 'Great Melton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1454764,
        LOCATION_LATITUDE_DEG: 52.6161303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025000',
        LOCATION_NAME: 'Great Milton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0879562,
        LOCATION_LATITUDE_DEG: 51.7203742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025100',
        LOCATION_NAME: 'Great Missenden',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7062144,
        LOCATION_LATITUDE_DEG: 51.7036705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025200',
        LOCATION_NAME: 'Great Mongeham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.359522,
        LOCATION_LATITUDE_DEG: 51.2129925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025300',
        LOCATION_NAME: 'Great Moor',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2418078,
        LOCATION_LATITUDE_DEG: 52.5833715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025400',
        LOCATION_NAME: 'Great Morton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9732287,
        LOCATION_LATITUDE_DEG: 53.3111266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025500',
        LOCATION_NAME: 'Great Moulton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1900185,
        LOCATION_LATITUDE_DEG: 52.4657187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025600',
        LOCATION_NAME: 'Great Munden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0267293,
        LOCATION_LATITUDE_DEG: 51.8977844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025700',
        LOCATION_NAME: 'Great Musgrave',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3632104,
        LOCATION_LATITUDE_DEG: 54.51696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025800',
        LOCATION_NAME: 'Great Ness',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8930536,
        LOCATION_LATITUDE_DEG: 52.7640002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025850',
        LOCATION_NAME: 'Great Notley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5311755,
        LOCATION_LATITUDE_DEG: 51.8651657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR025900',
        LOCATION_NAME: 'Great Oak',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8960472,
        LOCATION_LATITUDE_DEG: 51.7827065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026000',
        LOCATION_NAME: 'Great Oakley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7212476,
        LOCATION_LATITUDE_DEG: 52.4631421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026100',
        LOCATION_NAME: 'Great Oakley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1903143,
        LOCATION_LATITUDE_DEG: 51.9033665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026200',
        LOCATION_NAME: 'Great Offley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.334126,
        LOCATION_LATITUDE_DEG: 51.9270886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026300',
        LOCATION_NAME: 'Great Orton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0465736,
        LOCATION_LATITUDE_DEG: 54.8786065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026400',
        LOCATION_NAME: 'Great Ouseburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3148311,
        LOCATION_LATITUDE_DEG: 54.0500056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026500',
        LOCATION_NAME: 'Great Oxendon',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9249894,
        LOCATION_LATITUDE_DEG: 52.4431402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026600',
        LOCATION_NAME: 'Great Packington',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6485266,
        LOCATION_LATITUDE_DEG: 52.4496524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026700',
        LOCATION_NAME: 'Great Parndon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0815115,
        LOCATION_LATITUDE_DEG: 51.7551633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026800',
        LOCATION_NAME: 'Great Paxton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2268351,
        LOCATION_LATITUDE_DEG: 52.2599217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR026900',
        LOCATION_NAME: 'Great Plumpton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9344162,
        LOCATION_LATITUDE_DEG: 53.7924949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027000',
        LOCATION_NAME: 'Great Plumstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4013617,
        LOCATION_LATITUDE_DEG: 52.6396259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027100',
        LOCATION_NAME: 'Great Ponton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6255778,
        LOCATION_LATITUDE_DEG: 52.8631759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027200',
        LOCATION_NAME: 'Great Preston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3821091,
        LOCATION_LATITUDE_DEG: 53.7526718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027300',
        LOCATION_NAME: 'Great Raveley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1577687,
        LOCATION_LATITUDE_DEG: 52.414927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027400',
        LOCATION_NAME: 'Great Rissington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7111064,
        LOCATION_LATITUDE_DEG: 51.8545012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027500',
        LOCATION_NAME: 'Great Rollright',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5302695,
        LOCATION_LATITUDE_DEG: 51.9806056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027600',
        LOCATION_NAME: 'Great Ryburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9108423,
        LOCATION_LATITUDE_DEG: 52.8072512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027700',
        LOCATION_NAME: 'Great Ryle',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9693421,
        LOCATION_LATITUDE_DEG: 55.4079427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027800',
        LOCATION_NAME: 'Great Saling',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4733587,
        LOCATION_LATITUDE_DEG: 51.9022728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR027900',
        LOCATION_NAME: 'Great Salkeld',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6984232,
        LOCATION_LATITUDE_DEG: 54.7208826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028000',
        LOCATION_NAME: 'Great Sampford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3928428,
        LOCATION_LATITUDE_DEG: 51.9919865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028100',
        LOCATION_NAME: 'Great Sankey',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6414271,
        LOCATION_LATITUDE_DEG: 53.3891558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028200',
        LOCATION_NAME: 'Great Saredon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0694589,
        LOCATION_LATITUDE_DEG: 52.6739823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028300',
        LOCATION_NAME: 'Great Saxham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6204812,
        LOCATION_LATITUDE_DEG: 52.2342998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028400',
        LOCATION_NAME: 'Great Shefford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4479103,
        LOCATION_LATITUDE_DEG: 51.4740563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028500',
        LOCATION_NAME: 'Great Shelford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1376341,
        LOCATION_LATITUDE_DEG: 52.1501043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028600',
        LOCATION_NAME: 'Great Shoddesden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6052527,
        LOCATION_LATITUDE_DEG: 51.2390358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028700',
        LOCATION_NAME: 'Great Smeaton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.462149,
        LOCATION_LATITUDE_DEG: 54.4335467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028800',
        LOCATION_NAME: 'Great Snoring',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8925692,
        LOCATION_LATITUDE_DEG: 52.8737559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR028900',
        LOCATION_NAME: 'Great Somerford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0525946,
        LOCATION_LATITUDE_DEG: 51.5423741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029000',
        LOCATION_NAME: 'Great Stainton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4760911,
        LOCATION_LATITUDE_DEG: 54.5913575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029100',
        LOCATION_NAME: 'Great Stambridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7420352,
        LOCATION_LATITUDE_DEG: 51.5922377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029200',
        LOCATION_NAME: 'Great Staughton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3546568,
        LOCATION_LATITUDE_DEG: 52.2677164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029300',
        LOCATION_NAME: 'Great Steeping',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1545015,
        LOCATION_LATITUDE_DEG: 53.156094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029400',
        LOCATION_NAME: 'Great Stonar',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3474367,
        LOCATION_LATITUDE_DEG: 51.2870002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029500',
        LOCATION_NAME: 'Great Stretton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0151512,
        LOCATION_LATITUDE_DEG: 52.5996635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029600',
        LOCATION_NAME: 'Great Strickland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6865569,
        LOCATION_LATITUDE_DEG: 54.5983729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029700',
        LOCATION_NAME: 'Great Stukeley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2089979,
        LOCATION_LATITUDE_DEG: 52.3559248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029800',
        LOCATION_NAME: 'Great Sturton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1774131,
        LOCATION_LATITUDE_DEG: 53.273011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR029900',
        LOCATION_NAME: 'Great Sutton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9328923,
        LOCATION_LATITUDE_DEG: 53.2732492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030000',
        LOCATION_NAME: 'Great Sutton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7101907,
        LOCATION_LATITUDE_DEG: 52.4432682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030100',
        LOCATION_NAME: 'Great Swinburne',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0985379,
        LOCATION_LATITUDE_DEG: 55.0747098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030200',
        LOCATION_NAME: 'Great Tew',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.424492,
        LOCATION_LATITUDE_DEG: 51.9602012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030300',
        LOCATION_NAME: 'Great Tey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7507945,
        LOCATION_LATITUDE_DEG: 51.8984677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030400',
        LOCATION_NAME: 'Great Thurlow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4520282,
        LOCATION_LATITUDE_DEG: 52.1244953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030500',
        LOCATION_NAME: 'Great Tosson',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9530288,
        LOCATION_LATITUDE_DEG: 55.2990367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030600',
        LOCATION_NAME: 'Great Totham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7083976,
        LOCATION_LATITUDE_DEG: 51.7845578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990224',
        LOCATION_NAME: 'Great Totham North',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6967759,
        LOCATION_LATITUDE_DEG: 51.7730425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030700',
        LOCATION_NAME: 'Great Urswick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1201427,
        LOCATION_LATITUDE_DEG: 54.1625384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030800',
        LOCATION_NAME: 'Great Wakering',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8055855,
        LOCATION_LATITUDE_DEG: 51.5523358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR030900',
        LOCATION_NAME: 'Great Waldingfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7763176,
        LOCATION_LATITUDE_DEG: 52.0553855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031000',
        LOCATION_NAME: 'Great Walsingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8902933,
        LOCATION_LATITUDE_DEG: 52.8998656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031100',
        LOCATION_NAME: 'Great Waltham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4582187,
        LOCATION_LATITUDE_DEG: 51.7937636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990938',
        LOCATION_NAME: 'Great Warford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031200',
        LOCATION_NAME: 'Great Warley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2861755,
        LOCATION_LATITUDE_DEG: 51.5926439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031300',
        LOCATION_NAME: 'Great Washbourne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0180965,
        LOCATION_LATITUDE_DEG: 52.0078148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031400',
        LOCATION_NAME: 'Great Wenham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0176117,
        LOCATION_LATITUDE_DEG: 52.0044755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031500',
        LOCATION_NAME: 'Great Whelnetham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7439231,
        LOCATION_LATITUDE_DEG: 52.1951033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031600',
        LOCATION_NAME: 'Great Whittington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9930529,
        LOCATION_LATITUDE_DEG: 55.03171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031700',
        LOCATION_NAME: 'Great Wigborough',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8551058,
        LOCATION_LATITUDE_DEG: 51.798354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031800',
        LOCATION_NAME: 'Great Wilbraham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2675378,
        LOCATION_LATITUDE_DEG: 52.1937047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR031900',
        LOCATION_NAME: 'Great Wishford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8849319,
        LOCATION_LATITUDE_DEG: 51.1180325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032000',
        LOCATION_NAME: 'Great Witchingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1167827,
        LOCATION_LATITUDE_DEG: 52.7362429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032100',
        LOCATION_NAME: 'Great Witcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1249073,
        LOCATION_LATITUDE_DEG: 51.833002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032200',
        LOCATION_NAME: 'Great Witley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3588818,
        LOCATION_LATITUDE_DEG: 52.2927514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032300',
        LOCATION_NAME: 'Great Wolford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6370135,
        LOCATION_LATITUDE_DEG: 52.0086147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032400',
        LOCATION_NAME: 'Great Wratting',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4642089,
        LOCATION_LATITUDE_DEG: 52.1063889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032500',
        LOCATION_NAME: 'Great Wymondley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2343071,
        LOCATION_LATITUDE_DEG: 51.9427827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032600',
        LOCATION_NAME: 'Great Wyrley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0090642,
        LOCATION_LATITUDE_DEG: 52.6607769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032700',
        LOCATION_NAME: 'Great Wytheford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6321455,
        LOCATION_LATITUDE_DEG: 52.7661988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032800',
        LOCATION_NAME: 'Great Yarmouth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7323234,
        LOCATION_LATITUDE_DEG: 52.6073227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR032900',
        LOCATION_NAME: 'Great Yeldham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5647993,
        LOCATION_LATITUDE_DEG: 52.0154822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033100',
        LOCATION_NAME: 'Greatfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8874762,
        LOCATION_LATITUDE_DEG: 51.5691743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033200',
        LOCATION_NAME: 'Greatford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3911451,
        LOCATION_LATITUDE_DEG: 52.6937619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033500',
        LOCATION_NAME: 'Greatham',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2367306,
        LOCATION_LATITUDE_DEG: 54.6409573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033300',
        LOCATION_NAME: 'Greatham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8906659,
        LOCATION_LATITUDE_DEG: 51.0711153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033400',
        LOCATION_NAME: 'Greatham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.515951,
        LOCATION_LATITUDE_DEG: 50.9323915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033600',
        LOCATION_NAME: 'Greatstone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9655188,
        LOCATION_LATITUDE_DEG: 50.9720772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033700',
        LOCATION_NAME: 'Greatworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1946923,
        LOCATION_LATITUDE_DEG: 52.0763154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033800',
        LOCATION_NAME: 'Gredington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8252162,
        LOCATION_LATITUDE_DEG: 52.9419138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033850',
        LOCATION_NAME: 'Greeba',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6015152,
        LOCATION_LATITUDE_DEG: 54.1972993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033900',
        LOCATION_NAME: 'Green Crize',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7044691,
        LOCATION_LATITUDE_DEG: 52.0299249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034000',
        LOCATION_NAME: 'Green End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0668767,
        LOCATION_LATITUDE_DEG: 51.883981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034100',
        LOCATION_NAME: 'Green Fairfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8690114,
        LOCATION_LATITUDE_DEG: 53.264636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990451',
        LOCATION_NAME: 'Green Hammerton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3003329,
        LOCATION_LATITUDE_DEG: 53.9991619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034300',
        LOCATION_NAME: 'Green Moor',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5735437,
        LOCATION_LATITUDE_DEG: 53.488149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034400',
        LOCATION_NAME: 'Green Ore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6038004,
        LOCATION_LATITUDE_DEG: 51.2490526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034500',
        LOCATION_NAME: 'Green Rocks',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5489672,
        LOCATION_LATITUDE_DEG: 50.0994704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034600',
        LOCATION_NAME: 'Green Street',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1586459,
        LOCATION_LATITUDE_DEG: 51.8352993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034700',
        LOCATION_NAME: 'Green Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1123371,
        LOCATION_LATITUDE_DEG: 51.8783721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034800',
        LOCATION_NAME: 'Green Street Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0913399,
        LOCATION_LATITUDE_DEG: 51.3530298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR034900',
        LOCATION_NAME: 'Green Tye',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1003491,
        LOCATION_LATITUDE_DEG: 51.8465703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035600',
        LOCATION_NAME: 'Greenbank',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2089208,
        LOCATION_LATITUDE_DEG: 50.2513782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035700',
        LOCATION_NAME: 'Greenbank',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1269224,
        LOCATION_LATITUDE_DEG: 50.3760816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035800',
        LOCATION_NAME: 'Greenbank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5840453,
        LOCATION_LATITUDE_DEG: 54.5223756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035500',
        LOCATION_NAME: 'Greenbank',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5571395,
        LOCATION_LATITUDE_DEG: 51.4677735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035900',
        LOCATION_NAME: 'Greenburn',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6956067,
        LOCATION_LATITUDE_DEG: 55.8289071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990380',
        LOCATION_NAME: 'Greencastle',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036100',
        LOCATION_NAME: 'Greencroft',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7477552,
        LOCATION_LATITUDE_DEG: 54.8581911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036200',
        LOCATION_NAME: 'Greendown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0222032,
        LOCATION_LATITUDE_DEG: 50.8129104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR056000',
        LOCATION_NAME: 'Greenend',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1637119,
        LOCATION_LATITUDE_DEG: 55.9595799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR056100',
        LOCATION_NAME: 'Greenfield',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.160124,
        LOCATION_LATITUDE_DEG: 55.8530576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036300',
        LOCATION_NAME: 'Greenfield',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2085583,
        LOCATION_LATITUDE_DEG: 53.2888534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036600',
        LOCATION_NAME: 'Greenfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0033649,
        LOCATION_LATITUDE_DEG: 53.5352593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036500',
        LOCATION_NAME: 'Greenfield',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4642067,
        LOCATION_LATITUDE_DEG: 52.002498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036400',
        LOCATION_NAME: 'Greenfield',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1489841,
        LOCATION_LATITUDE_DEG: 53.2791099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036700',
        LOCATION_NAME: 'Greenford',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3537545,
        LOCATION_LATITUDE_DEG: 51.5279488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036800',
        LOCATION_NAME: 'Greengairs',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9357607,
        LOCATION_LATITUDE_DEG: 55.9149166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036900',
        LOCATION_NAME: 'Greengates',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7171172,
        LOCATION_LATITUDE_DEG: 53.8310835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037000',
        LOCATION_NAME: 'Greengill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3899178,
        LOCATION_LATITUDE_DEG: 54.7215961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037100',
        LOCATION_NAME: 'Greenhalgh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9085787,
        LOCATION_LATITUDE_DEG: 53.8151039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990390',
        LOCATION_NAME: 'Greenham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037200',
        LOCATION_NAME: 'Greenham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3124846,
        LOCATION_LATITUDE_DEG: 50.9732365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037300',
        LOCATION_NAME: 'Greenham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.301711,
        LOCATION_LATITUDE_DEG: 51.3860471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037400',
        LOCATION_NAME: 'Greenhaugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3196962,
        LOCATION_LATITUDE_DEG: 55.1777264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037500',
        LOCATION_NAME: 'Greenhead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5300514,
        LOCATION_LATITUDE_DEG: 54.982411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037600',
        LOCATION_NAME: 'Greenhead',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7730144,
        LOCATION_LATITUDE_DEG: 54.7017764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037700',
        LOCATION_NAME: 'Greenheys',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4294285,
        LOCATION_LATITUDE_DEG: 53.5361693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037800',
        LOCATION_NAME: 'Greenhill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4062741,
        LOCATION_LATITUDE_DEG: 55.1065366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR037900',
        LOCATION_NAME: 'Greenhill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4832039,
        LOCATION_LATITUDE_DEG: 53.3286388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038000',
        LOCATION_NAME: 'Greenhithe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2804806,
        LOCATION_LATITUDE_DEG: 51.4520334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038100',
        LOCATION_NAME: 'Greenholm',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3221852,
        LOCATION_LATITUDE_DEG: 55.607595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038200',
        LOCATION_NAME: 'Greenholme',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6206222,
        LOCATION_LATITUDE_DEG: 54.445257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038300',
        LOCATION_NAME: 'Greenhow Hill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8280861,
        LOCATION_LATITUDE_DEG: 54.0732093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038400',
        LOCATION_NAME: 'Greenisland',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8696776,
        LOCATION_LATITUDE_DEG: 54.6938143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038500',
        LOCATION_NAME: 'Greenland',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3001454,
        LOCATION_LATITUDE_DEG: 58.5895788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038600',
        LOCATION_NAME: 'Greenlaw',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4601255,
        LOCATION_LATITUDE_DEG: 55.706781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038700',
        LOCATION_NAME: 'Greenleys',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8220517,
        LOCATION_LATITUDE_DEG: 52.0525074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038800',
        LOCATION_NAME: 'Greenloaning',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8816764,
        LOCATION_LATITUDE_DEG: 56.2447498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR038900',
        LOCATION_NAME: 'Greenmeadow',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.044481,
        LOCATION_LATITUDE_DEG: 51.6494893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039000',
        LOCATION_NAME: 'Greenmount',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3362912,
        LOCATION_LATITUDE_DEG: 53.6253725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039100',
        LOCATION_NAME: 'Greenoak',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7655405,
        LOCATION_LATITUDE_DEG: 53.740464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039200',
        LOCATION_NAME: 'Greenock',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7578692,
        LOCATION_LATITUDE_DEG: 55.9488309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039300',
        LOCATION_NAME: 'Greenodd',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0524696,
        LOCATION_LATITUDE_DEG: 54.2337476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039600',
        LOCATION_NAME: 'Greenrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3840191,
        LOCATION_LATITUDE_DEG: 54.8628085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039700',
        LOCATION_NAME: 'Greens',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2880945,
        LOCATION_LATITUDE_DEG: 57.5064527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039800',
        LOCATION_NAME: 'Greens Norton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0225595,
        LOCATION_LATITUDE_DEG: 52.1427136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039900',
        LOCATION_NAME: 'Greenside',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7819828,
        LOCATION_LATITUDE_DEG: 54.9534967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR056200',
        LOCATION_NAME: 'Greenside',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6754074,
        LOCATION_LATITUDE_DEG: 53.8346994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040000',
        LOCATION_NAME: 'Greensplat',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8168912,
        LOCATION_LATITUDE_DEG: 50.3627858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040100',
        LOCATION_NAME: 'Greenspot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1745989,
        LOCATION_LATITUDE_DEG: 54.9027103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040200',
        LOCATION_NAME: 'Greenstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9391132,
        LOCATION_LATITUDE_DEG: 51.8898642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040300',
        LOCATION_NAME: 'Greenstead Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6513365,
        LOCATION_LATITUDE_DEG: 51.9209708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040400',
        LOCATION_NAME: 'Greensted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2289851,
        LOCATION_LATITUDE_DEG: 51.7032533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040500',
        LOCATION_NAME: 'Greenswood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6417819,
        LOCATION_LATITUDE_DEG: 50.3398771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040600',
        LOCATION_NAME: 'Greenway',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5869697,
        LOCATION_LATITUDE_DEG: 50.383382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040700',
        LOCATION_NAME: 'Greenway',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0708856,
        LOCATION_LATITUDE_DEG: 51.7326036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040800',
        LOCATION_NAME: 'Greenway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4428455,
        LOCATION_LATITUDE_DEG: 51.9979201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054500',
        LOCATION_NAME: 'Greenwich',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0010329,
        LOCATION_LATITUDE_DEG: 51.4883281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR040900',
        LOCATION_NAME: 'Greenwillows',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0131836,
        LOCATION_LATITUDE_DEG: 51.6377943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041100',
        LOCATION_NAME: 'Greet',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9622937,
        LOCATION_LATITUDE_DEG: 51.9706112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041000',
        LOCATION_NAME: 'Greet',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8518449,
        LOCATION_LATITUDE_DEG: 52.4528601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041200',
        LOCATION_NAME: 'Greete',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6200056,
        LOCATION_LATITUDE_DEG: 52.3339558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041300',
        LOCATION_NAME: 'Greetham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6315015,
        LOCATION_LATITUDE_DEG: 52.7210662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990127',
        LOCATION_NAME: 'Greetham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6289596,
        LOCATION_LATITUDE_DEG: 52.721846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041400',
        LOCATION_NAME: 'Greetham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0402137,
        LOCATION_LATITUDE_DEG: 53.2166077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041500',
        LOCATION_NAME: 'Greetland',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8532861,
        LOCATION_LATITUDE_DEG: 53.6873762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041600',
        LOCATION_NAME: 'Greinton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8359525,
        LOCATION_LATITUDE_DEG: 51.1231412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041700',
        LOCATION_NAME: 'Gremista',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1609709,
        LOCATION_LATITUDE_DEG: 60.173108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042000',
        LOCATION_NAME: 'Grendon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5982288,
        LOCATION_LATITUDE_DEG: 52.5852475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041900',
        LOCATION_NAME: 'Grendon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7125359,
        LOCATION_LATITUDE_DEG: 52.2346203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042100',
        LOCATION_NAME: 'Grendon Underwood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0156843,
        LOCATION_LATITUDE_DEG: 51.8826875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042200',
        LOCATION_NAME: 'Grenitote',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3246617,
        LOCATION_LATITUDE_DEG: 57.653421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042300',
        LOCATION_NAME: 'Grenofen',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1218993,
        LOCATION_LATITUDE_DEG: 50.5230935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042400',
        LOCATION_NAME: 'Grenoside',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5012819,
        LOCATION_LATITUDE_DEG: 53.4420493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042500',
        LOCATION_NAME: 'Gresford',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9648829,
        LOCATION_LATITUDE_DEG: 53.087228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042600',
        LOCATION_NAME: 'Gresham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2230312,
        LOCATION_LATITUDE_DEG: 52.8998584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042700',
        LOCATION_NAME: 'Gress',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2915205,
        LOCATION_LATITUDE_DEG: 58.296404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042800',
        LOCATION_NAME: 'Gressenhall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9088377,
        LOCATION_LATITUDE_DEG: 52.7107442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR042900',
        LOCATION_NAME: 'Gressingham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.654871,
        LOCATION_LATITUDE_DEG: 54.1234238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043000',
        LOCATION_NAME: 'Greta Bridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8639683,
        LOCATION_LATITUDE_DEG: 54.512854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043100',
        LOCATION_NAME: 'Gretna',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0660853,
        LOCATION_LATITUDE_DEG: 54.9923218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043200',
        LOCATION_NAME: 'Gretna Green',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0718596,
        LOCATION_LATITUDE_DEG: 55.0025171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043500',
        LOCATION_NAME: 'Gretton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7166842,
        LOCATION_LATITUDE_DEG: 52.5522738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043400',
        LOCATION_NAME: 'Gretton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9868681,
        LOCATION_LATITUDE_DEG: 51.9713089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043300',
        LOCATION_NAME: 'Gretton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6745076,
        LOCATION_LATITUDE_DEG: 52.5395506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043600',
        LOCATION_NAME: 'Grewelthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.647291,
        LOCATION_LATITUDE_DEG: 54.181424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043700',
        LOCATION_NAME: 'Greyabbey',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5616629,
        LOCATION_LATITUDE_DEG: 54.5379955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043800',
        LOCATION_NAME: 'Greylake',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8727814,
        LOCATION_LATITUDE_DEG: 51.097439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990464',
        LOCATION_NAME: 'Greylees',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4399014,
        LOCATION_LATITUDE_DEG: 52.9736046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043900',
        LOCATION_NAME: 'Greysouthen',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4392069,
        LOCATION_LATITUDE_DEG: 54.6479884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR043950',
        LOCATION_NAME: 'Greysteel',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.118974,
        LOCATION_LATITUDE_DEG: 55.0282525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044000',
        LOCATION_NAME: 'Greystoke',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8678046,
        LOCATION_LATITUDE_DEG: 54.6690871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990764',
        LOCATION_NAME: 'Greystone',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054200',
        LOCATION_NAME: 'Greystones',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7295131,
        LOCATION_LATITUDE_DEG: 53.694198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044200',
        LOCATION_NAME: 'Greytree',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5851685,
        LOCATION_LATITUDE_DEG: 51.9241139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044300',
        LOCATION_NAME: 'Greywell',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9703349,
        LOCATION_LATITUDE_DEG: 51.2567292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044400',
        LOCATION_NAME: 'Gribthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8414503,
        LOCATION_LATITUDE_DEG: 53.8104778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044500',
        LOCATION_NAME: 'Gribun',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1292575,
        LOCATION_LATITUDE_DEG: 56.4339904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044600',
        LOCATION_NAME: 'Griff',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4715193,
        LOCATION_LATITUDE_DEG: 52.4954601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044700',
        LOCATION_NAME: 'Griffiths Crossing',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2378567,
        LOCATION_LATITUDE_DEG: 53.1647531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044800',
        LOCATION_NAME: 'Griffithstown',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0264923,
        LOCATION_LATITUDE_DEG: 51.6837927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044900',
        LOCATION_NAME: 'Griffydam',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3863044,
        LOCATION_LATITUDE_DEG: 52.7664845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045000',
        LOCATION_NAME: 'Grimbister',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.096176,
        LOCATION_LATITUDE_DEG: 58.9972108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045100',
        LOCATION_NAME: 'Grimblethorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.140147,
        LOCATION_LATITUDE_DEG: 53.3588219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045200',
        LOCATION_NAME: 'Grimeford Village',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5769152,
        LOCATION_LATITUDE_DEG: 53.6113751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045300',
        LOCATION_NAME: 'Grimersta',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7321704,
        LOCATION_LATITUDE_DEG: 58.1669698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045400',
        LOCATION_NAME: 'Grimesthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4317725,
        LOCATION_LATITUDE_DEG: 53.3997389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045500',
        LOCATION_NAME: 'Grimethorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.376144,
        LOCATION_LATITUDE_DEG: 53.5756581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045600',
        LOCATION_NAME: 'Griminish',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3710268,
        LOCATION_LATITUDE_DEG: 57.4435024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045700',
        LOCATION_NAME: 'Grimley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2402563,
        LOCATION_LATITUDE_DEG: 52.2421432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045800',
        LOCATION_NAME: 'Grimoldby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0922991,
        LOCATION_LATITUDE_DEG: 53.370716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR045900',
        LOCATION_NAME: 'Grimpo',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9493682,
        LOCATION_LATITUDE_DEG: 52.8344108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046000',
        LOCATION_NAME: 'Grimsargh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6304493,
        LOCATION_LATITUDE_DEG: 53.8042943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046100',
        LOCATION_NAME: 'Grimsay Island',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.275064,
        LOCATION_LATITUDE_DEG: 57.4057977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046200',
        LOCATION_NAME: 'Grimsby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0842568,
        LOCATION_LATITUDE_DEG: 53.5651437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046300',
        LOCATION_NAME: 'Grimscote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0464342,
        LOCATION_LATITUDE_DEG: 52.1765204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046400',
        LOCATION_NAME: 'Grimscott',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4666103,
        LOCATION_LATITUDE_DEG: 50.8349331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046500',
        LOCATION_NAME: 'Grimshader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4118974,
        LOCATION_LATITUDE_DEG: 58.1449624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046600',
        LOCATION_NAME: 'Grimsthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4443455,
        LOCATION_LATITUDE_DEG: 52.7936752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990288',
        LOCATION_NAME: 'Grimston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2558698,
        LOCATION_LATITUDE_DEG: 53.869228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046900',
        LOCATION_NAME: 'Grimston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.016814,
        LOCATION_LATITUDE_DEG: 53.9547934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046700',
        LOCATION_NAME: 'Grimston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.983547,
        LOCATION_LATITUDE_DEG: 52.7896742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR046800',
        LOCATION_NAME: 'Grimston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0569824,
        LOCATION_LATITUDE_DEG: 53.7976625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047000',
        LOCATION_NAME: 'Grimston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5506464,
        LOCATION_LATITUDE_DEG: 52.7718566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047100',
        LOCATION_NAME: 'Grimstone',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5073223,
        LOCATION_LATITUDE_DEG: 50.7434994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047200',
        LOCATION_NAME: 'Grindale',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2655586,
        LOCATION_LATITUDE_DEG: 54.1244933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047300',
        LOCATION_NAME: 'Grindle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.366184,
        LOCATION_LATITUDE_DEG: 52.6244821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047400',
        LOCATION_NAME: 'Grindle Forge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3664864,
        LOCATION_LATITUDE_DEG: 52.6270795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047500',
        LOCATION_NAME: 'Grindleford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.634662,
        LOCATION_LATITUDE_DEG: 53.2952352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047600',
        LOCATION_NAME: 'Grindleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3665256,
        LOCATION_LATITUDE_DEG: 53.9048004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047700',
        LOCATION_NAME: 'Grindley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9453813,
        LOCATION_LATITUDE_DEG: 52.8596004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047800',
        LOCATION_NAME: 'Grindley Brook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7124045,
        LOCATION_LATITUDE_DEG: 52.9835142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR047900',
        LOCATION_NAME: 'Grindlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7282075,
        LOCATION_LATITUDE_DEG: 53.2944332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048000',
        LOCATION_NAME: 'Grindon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8726599,
        LOCATION_LATITUDE_DEG: 53.0861174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053900',
        LOCATION_NAME: 'Gringley on the Hill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048100',
        LOCATION_NAME: 'Gringley-on-the-Hill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.884056,
        LOCATION_LATITUDE_DEG: 53.4016838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048200',
        LOCATION_NAME: 'Grinkle',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8564243,
        LOCATION_LATITUDE_DEG: 54.5292844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048300',
        LOCATION_NAME: 'Grinsdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9819551,
        LOCATION_LATITUDE_DEG: 54.9136053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048400',
        LOCATION_NAME: 'Grinsdale Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9921737,
        LOCATION_LATITUDE_DEG: 54.9066107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048500',
        LOCATION_NAME: 'Grinshill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7114844,
        LOCATION_LATITUDE_DEG: 52.8058032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048600',
        LOCATION_NAME: 'Grinton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9281676,
        LOCATION_LATITUDE_DEG: 54.3812433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048700',
        LOCATION_NAME: 'Grisdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3442229,
        LOCATION_LATITUDE_DEG: 54.331141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048800',
        LOCATION_NAME: 'Gristhorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3311952,
        LOCATION_LATITUDE_DEG: 54.2232108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR048900',
        LOCATION_NAME: 'Griston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8661077,
        LOCATION_LATITUDE_DEG: 52.5569315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049000',
        LOCATION_NAME: 'Grittenham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9619271,
        LOCATION_LATITUDE_DEG: 51.5429732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049100',
        LOCATION_NAME: 'Grittleton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2041412,
        LOCATION_LATITUDE_DEG: 51.5181714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049200',
        LOCATION_NAME: 'Grizebeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1693818,
        LOCATION_LATITUDE_DEG: 54.2556456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049300',
        LOCATION_NAME: 'Grizedale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0215906,
        LOCATION_LATITUDE_DEG: 54.3402511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049400',
        LOCATION_NAME: 'Groby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2211346,
        LOCATION_LATITUDE_DEG: 52.6617694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049500',
        LOCATION_NAME: 'Groes',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4845959,
        LOCATION_LATITUDE_DEG: 53.1701427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054000',
        LOCATION_NAME: 'Groes Pluen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049700',
        LOCATION_NAME: 'Groesfaen',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3441315,
        LOCATION_LATITUDE_DEG: 51.5151716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049800',
        LOCATION_NAME: 'Groesfford',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3438019,
        LOCATION_LATITUDE_DEG: 51.9415207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049900',
        LOCATION_NAME: 'Groesffordd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5739523,
        LOCATION_LATITUDE_DEG: 52.9231351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050000',
        LOCATION_NAME: 'Groesffordd Marli',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5176851,
        LOCATION_LATITUDE_DEG: 53.2436479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050100',
        LOCATION_NAME: 'Groeslon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2645123,
        LOCATION_LATITUDE_DEG: 53.0753452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR049600',
        LOCATION_NAME: 'Groes-Pluen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1752089,
        LOCATION_LATITUDE_DEG: 52.6730946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050200',
        LOCATION_NAME: 'Groeswen',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2625007,
        LOCATION_LATITUDE_DEG: 51.5732917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050400',
        LOCATION_NAME: 'Grogarry',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3605647,
        LOCATION_LATITUDE_DEG: 57.3331913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050500',
        LOCATION_NAME: 'Gronant',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3641831,
        LOCATION_LATITUDE_DEG: 53.3375574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050600',
        LOCATION_NAME: 'Grondre',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.743146,
        LOCATION_LATITUDE_DEG: 51.8304329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050700',
        LOCATION_NAME: 'Gronwen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0733487,
        LOCATION_LATITUDE_DEG: 52.8296054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050800',
        LOCATION_NAME: 'Groombridge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1873726,
        LOCATION_LATITUDE_DEG: 51.110704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050900',
        LOCATION_NAME: 'Groomsport',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6155594,
        LOCATION_LATITUDE_DEG: 54.6666145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054100',
        LOCATION_NAME: 'Grose Clett',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8151362,
        LOCATION_LATITUDE_DEG: 57.8530639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051100',
        LOCATION_NAME: 'Grosebay',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7992554,
        LOCATION_LATITUDE_DEG: 57.8348364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051000',
        LOCATION_NAME: 'Grose-Clett',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8130937,
        LOCATION_LATITUDE_DEG: 57.8529346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051300',
        LOCATION_NAME: 'Grosmont',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8656557,
        LOCATION_LATITUDE_DEG: 51.9142205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051200',
        LOCATION_NAME: 'Grosmont',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7217566,
        LOCATION_LATITUDE_DEG: 54.4355321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051400',
        LOCATION_NAME: 'Groton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.857774,
        LOCATION_LATITUDE_DEG: 52.0377777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051500',
        LOCATION_NAME: 'Grotton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.049949,
        LOCATION_LATITUDE_DEG: 53.5375682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051700',
        LOCATION_NAME: 'GROUVILLE',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.049187,
        LOCATION_LATITUDE_DEG: 49.1847452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052000',
        LOCATION_NAME: 'Grove',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4203232,
        LOCATION_LATITUDE_DEG: 51.6088743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051900',
        LOCATION_NAME: 'Grove',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8906748,
        LOCATION_LATITUDE_DEG: 53.3085265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051800',
        LOCATION_NAME: 'Grove',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2126188,
        LOCATION_LATITUDE_DEG: 51.3132073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052100',
        LOCATION_NAME: 'Grove Ferry',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2017031,
        LOCATION_LATITUDE_DEG: 51.3162053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052200',
        LOCATION_NAME: 'Grove Moor',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8665143,
        LOCATION_LATITUDE_DEG: 53.3128304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052300',
        LOCATION_NAME: 'Grove Park',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2020911,
        LOCATION_LATITUDE_DEG: 51.6766953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052400',
        LOCATION_NAME: 'Grove Park',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6435616,
        LOCATION_LATITUDE_DEG: 52.2806385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052500',
        LOCATION_NAME: 'Grove Park',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3897239,
        LOCATION_LATITUDE_DEG: 51.6117677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR054600',
        LOCATION_NAME: 'Grove Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0214552,
        LOCATION_LATITUDE_DEG: 51.4331424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052600',
        LOCATION_NAME: 'Grove Town',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3095844,
        LOCATION_LATITUDE_DEG: 53.687472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052700',
        LOCATION_NAME: 'Grove Wick',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4149234,
        LOCATION_LATITUDE_DEG: 51.615475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052900',
        LOCATION_NAME: 'Grovesend',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0370434,
        LOCATION_LATITUDE_DEG: 51.6886084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR052800',
        LOCATION_NAME: 'Grovesend',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4996164,
        LOCATION_LATITUDE_DEG: 51.5991798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053000',
        LOCATION_NAME: 'Gruinart',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3307898,
        LOCATION_LATITUDE_DEG: 55.818036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053100',
        LOCATION_NAME: 'Gruline',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.988494,
        LOCATION_LATITUDE_DEG: 56.4919963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR053200',
        LOCATION_NAME: 'Grundisburgh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2479476,
        LOCATION_LATITUDE_DEG: 52.11198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000100',
        LOCATION_NAME: 'Guardbridge',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8887024,
        LOCATION_LATITUDE_DEG: 56.3592542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000200',
        LOCATION_NAME: 'Guards Mill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0605713,
        LOCATION_LATITUDE_DEG: 55.0132216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000300',
        LOCATION_NAME: 'Guarlford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.27076,
        LOCATION_LATITUDE_DEG: 52.1062247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000400',
        LOCATION_NAME: 'Guay',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6288267,
        LOCATION_LATITUDE_DEG: 56.624189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000600',
        LOCATION_NAME: 'Gubblecote',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.684987,
        LOCATION_LATITUDE_DEG: 51.8271827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000444',
        LOCATION_NAME: 'Guernsey',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5472861,
        LOCATION_LATITUDE_DEG: 54.9224604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000800',
        LOCATION_NAME: 'Guershader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3918346,
        LOCATION_LATITUDE_DEG: 58.2260747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000900',
        LOCATION_NAME: 'Guestling',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6310359,
        LOCATION_LATITUDE_DEG: 50.8904933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001000',
        LOCATION_NAME: 'Guestling Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6349024,
        LOCATION_LATITUDE_DEG: 50.8929787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001100',
        LOCATION_NAME: 'Guestwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0583199,
        LOCATION_LATITUDE_DEG: 52.8008501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001200',
        LOCATION_NAME: 'Guide',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4452042,
        LOCATION_LATITUDE_DEG: 53.7278903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001300',
        LOCATION_NAME: 'Guide Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1115346,
        LOCATION_LATITUDE_DEG: 53.4750588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001400',
        LOCATION_NAME: 'Guide Post',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6017374,
        LOCATION_LATITUDE_DEG: 55.1604198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001500',
        LOCATION_NAME: 'Guidepost',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6048689,
        LOCATION_LATITUDE_DEG: 55.1580394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001600',
        LOCATION_NAME: 'Guilden Morden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1313655,
        LOCATION_LATITUDE_DEG: 52.0803942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001700',
        LOCATION_NAME: 'Guilden Sutton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.824621,
        LOCATION_LATITUDE_DEG: 53.2091384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001800',
        LOCATION_NAME: 'Guildford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5692468,
        LOCATION_LATITUDE_DEG: 51.2357229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU001900',
        LOCATION_NAME: 'Guildtown',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4076257,
        LOCATION_LATITUDE_DEG: 56.4714657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002000',
        LOCATION_NAME: 'Guilsborough',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0104288,
        LOCATION_LATITUDE_DEG: 52.3514356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002100',
        LOCATION_NAME: 'Guilsfield',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1544765,
        LOCATION_LATITUDE_DEG: 52.6962978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002200',
        LOCATION_NAME: 'Guineaford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.073121,
        LOCATION_LATITUDE_DEG: 51.1180569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002300',
        LOCATION_NAME: 'Guisborough',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0542636,
        LOCATION_LATITUDE_DEG: 54.5344447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002400',
        LOCATION_NAME: 'Guiseley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7052704,
        LOCATION_LATITUDE_DEG: 53.8756942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002500',
        LOCATION_NAME: 'Guist',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.964584,
        LOCATION_LATITUDE_DEG: 52.7902527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002600',
        LOCATION_NAME: 'Guiting Power',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8636936,
        LOCATION_LATITUDE_DEG: 51.9213081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002700',
        LOCATION_NAME: 'Gulberwick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2049159,
        LOCATION_LATITUDE_DEG: 60.1306057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002800',
        LOCATION_NAME: 'Gullane',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8282144,
        LOCATION_LATITUDE_DEG: 56.0354199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU002900',
        LOCATION_NAME: 'Gulley Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7598343,
        LOCATION_LATITUDE_DEG: 52.5559788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003000',
        LOCATION_NAME: 'Gulval',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5201737,
        LOCATION_LATITUDE_DEG: 50.1323707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003100',
        LOCATION_NAME: 'Gulworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1929233,
        LOCATION_LATITUDE_DEG: 50.534802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003200',
        LOCATION_NAME: 'Gumfreston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.735374,
        LOCATION_LATITUDE_DEG: 51.6774106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003300',
        LOCATION_NAME: 'Gumley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0016619,
        LOCATION_LATITUDE_DEG: 52.5057538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003400',
        LOCATION_NAME: 'Gummows Shop',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0005973,
        LOCATION_LATITUDE_DEG: 50.3765945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003500',
        LOCATION_NAME: 'Gun Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5775896,
        LOCATION_LATITUDE_DEG: 52.5010561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003600',
        LOCATION_NAME: 'Gun Hill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2276036,
        LOCATION_LATITUDE_DEG: 50.9067815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003800',
        LOCATION_NAME: 'Gunby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6458112,
        LOCATION_LATITUDE_DEG: 52.7839715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003700',
        LOCATION_NAME: 'Gunby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1948387,
        LOCATION_LATITUDE_DEG: 53.1790955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU003900',
        LOCATION_NAME: 'Gundleton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1193337,
        LOCATION_LATITUDE_DEG: 51.0952214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004000',
        LOCATION_NAME: 'Gungrog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1300569,
        LOCATION_LATITUDE_DEG: 52.6681929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004100',
        LOCATION_NAME: 'Gunn',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9484793,
        LOCATION_LATITUDE_DEG: 51.0834506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004200',
        LOCATION_NAME: 'Gunnerside',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0745542,
        LOCATION_LATITUDE_DEG: 54.3792463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004300',
        LOCATION_NAME: 'Gunnerton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1482326,
        LOCATION_LATITUDE_DEG: 55.0691144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004400',
        LOCATION_NAME: 'Gunness',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7264363,
        LOCATION_LATITUDE_DEG: 53.5902476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004500',
        LOCATION_NAME: 'Gunnislake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2123797,
        LOCATION_LATITUDE_DEG: 50.5238014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004600',
        LOCATION_NAME: 'Guns Village',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0054833,
        LOCATION_LATITUDE_DEG: 52.5226689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004800',
        LOCATION_NAME: 'Gunstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6938722,
        LOCATION_LATITUDE_DEG: 50.7763179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004900',
        LOCATION_NAME: 'Gunstone Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6925754,
        LOCATION_LATITUDE_DEG: 50.7781176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU990703',
        LOCATION_NAME: 'Gunthorpe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005200',
        LOCATION_NAME: 'Gunthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9861978,
        LOCATION_LATITUDE_DEG: 52.9918003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005000',
        LOCATION_NAME: 'Gunthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7849063,
        LOCATION_LATITUDE_DEG: 53.4634402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU990128',
        LOCATION_NAME: 'Gunthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7157444,
        LOCATION_LATITUDE_DEG: 52.6429031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005300',
        LOCATION_NAME: 'Gunthorpe',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7143144,
        LOCATION_LATITUDE_DEG: 52.6412602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005100',
        LOCATION_NAME: 'Gunthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9942158,
        LOCATION_LATITUDE_DEG: 52.8729614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005400',
        LOCATION_NAME: 'Gunton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7475687,
        LOCATION_LATITUDE_DEG: 52.496209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005500',
        LOCATION_NAME: 'Gunwalloe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2598559,
        LOCATION_LATITUDE_DEG: 50.0342604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005600',
        LOCATION_NAME: 'Gurnard',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3152506,
        LOCATION_LATITUDE_DEG: 50.7494908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005700',
        LOCATION_NAME: 'Gurney Slade',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5399703,
        LOCATION_LATITUDE_DEG: 51.2399488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005900',
        LOCATION_NAME: 'Gurnos',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7773225,
        LOCATION_LATITUDE_DEG: 51.77041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU990260',
        LOCATION_NAME: 'Gurnos',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4098781,
        LOCATION_LATITUDE_DEG: -0.7157433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005800',
        LOCATION_NAME: 'Gurnos',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3818501,
        LOCATION_LATITUDE_DEG: 51.7628112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006100',
        LOCATION_NAME: 'Gussage All Saints',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0013367,
        LOCATION_LATITUDE_DEG: 50.8958115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU007400',
        LOCATION_NAME: 'Gussage St Andrew',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU007500',
        LOCATION_NAME: 'Gussage St Michael',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006200',
        LOCATION_NAME: 'Gussage St. Andrew',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0342095,
        LOCATION_LATITUDE_DEG: 50.9271126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006300',
        LOCATION_NAME: 'Gussage St. Michael',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0204377,
        LOCATION_LATITUDE_DEG: 50.9016105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006500',
        LOCATION_NAME: 'Gustard Wood',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2984619,
        LOCATION_LATITUDE_DEG: 51.8346803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006600',
        LOCATION_NAME: 'Guston',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3240093,
        LOCATION_LATITUDE_DEG: 51.1528873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006700',
        LOCATION_NAME: 'Gutch Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1486221,
        LOCATION_LATITUDE_DEG: 51.0301224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006800',
        LOCATION_NAME: 'Gutcher',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.004313,
        LOCATION_LATITUDE_DEG: 60.6697519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006850',
        LOCATION_NAME: 'Guthram',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2610226,
        LOCATION_LATITUDE_DEG: 52.7861934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006900',
        LOCATION_NAME: 'Guthrie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7062922,
        LOCATION_LATITUDE_DEG: 56.6439762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU007000',
        LOCATION_NAME: 'Guyhirn',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0612239,
        LOCATION_LATITUDE_DEG: 52.6082459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU991035',
        LOCATION_NAME: 'Guys Cliffe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5722687,
        LOCATION_LATITUDE_DEG: 52.2987708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU007100',
        LOCATION_NAME: 'Guys Head',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2072677,
        LOCATION_LATITUDE_DEG: 52.8090673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU007200',
        LOCATION_NAME: 'Guys Marsh',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.225175,
        LOCATION_LATITUDE_DEG: 50.9791429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU007300',
        LOCATION_NAME: 'Guyzance',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6661152,
        LOCATION_LATITUDE_DEG: 55.3288301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW003100',
        LOCATION_NAME: 'Gwaelod y Garth',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000100',
        LOCATION_NAME: 'Gwaelod-y-Garth',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2753827,
        LOCATION_LATITUDE_DEG: 51.5467851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW990342',
        LOCATION_NAME: 'Gwaen Cae Gurwen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000200',
        LOCATION_NAME: 'Gwaenysgor',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3881402,
        LOCATION_LATITUDE_DEG: 53.3185539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000300',
        LOCATION_NAME: 'Gwalchmai',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4161118,
        LOCATION_LATITUDE_DEG: 53.2587619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000500',
        LOCATION_NAME: 'Gwaun Cae Gurwen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8779259,
        LOCATION_LATITUDE_DEG: 51.7848175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000600',
        LOCATION_NAME: 'Gwaunfarren',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3738169,
        LOCATION_LATITUDE_DEG: 51.7555044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000700',
        LOCATION_NAME: 'Gwbert',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6853174,
        LOCATION_LATITUDE_DEG: 52.1163525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000900',
        LOCATION_NAME: 'Gweek',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2058276,
        LOCATION_LATITUDE_DEG: 50.0954633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001200',
        LOCATION_NAME: 'Gwehelog',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8805625,
        LOCATION_LATITUDE_DEG: 51.7350022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001300',
        LOCATION_NAME: 'Gwenddwr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3631043,
        LOCATION_LATITUDE_DEG: 52.0794391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001400',
        LOCATION_NAME: 'Gwennap',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1702887,
        LOCATION_LATITUDE_DEG: 50.2164787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW003200',
        LOCATION_NAME: 'Gwern y Brenin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001600',
        LOCATION_NAME: 'Gwernaffield',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1871554,
        LOCATION_LATITUDE_DEG: 53.1710423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001700',
        LOCATION_NAME: 'Gwernafon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5824553,
        LOCATION_LATITUDE_DEG: 52.5061813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001800',
        LOCATION_NAME: 'Gwernesney',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8467122,
        LOCATION_LATITUDE_DEG: 51.7100003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001900',
        LOCATION_NAME: 'Gwernogle',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1422265,
        LOCATION_LATITUDE_DEG: 51.9849333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001500',
        LOCATION_NAME: 'Gwern-y-Brenin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0328119,
        LOCATION_LATITUDE_DEG: 52.826009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002000',
        LOCATION_NAME: 'Gwernymynydd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1656002,
        LOCATION_LATITUDE_DEG: 53.1563399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002100',
        LOCATION_NAME: 'Gwersyllt',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0178289,
        LOCATION_LATITUDE_DEG: 53.0711345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002200',
        LOCATION_NAME: 'Gwespyr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3353344,
        LOCATION_LATITUDE_DEG: 53.3353574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002300',
        LOCATION_NAME: 'Gwinear',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3663478,
        LOCATION_LATITUDE_DEG: 50.1868812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002400',
        LOCATION_NAME: 'Gwithian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3844418,
        LOCATION_LATITUDE_DEG: 50.2205808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002500',
        LOCATION_NAME: 'Gwredog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3964416,
        LOCATION_LATITUDE_DEG: 53.348072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002600',
        LOCATION_NAME: 'Gwyddelwern',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3780605,
        LOCATION_LATITUDE_DEG: 53.0097324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002700',
        LOCATION_NAME: 'Gwyddgrug',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2364147,
        LOCATION_LATITUDE_DEG: 51.9976431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW990344',
        LOCATION_NAME: 'Gwyn Fryn Estate',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9995323,
        LOCATION_LATITUDE_DEG: 51.7980553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002800',
        LOCATION_NAME: 'Gwynfryn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1086725,
        LOCATION_LATITUDE_DEG: 53.0645329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW002900',
        LOCATION_NAME: 'Gwystre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3691954,
        LOCATION_LATITUDE_DEG: 52.2810613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW003000',
        LOCATION_NAME: 'Gwytherin',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6799161,
        LOCATION_LATITUDE_DEG: 53.1386415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GY000100',
        LOCATION_NAME: 'Gyfelia',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9986378,
        LOCATION_LATITUDE_DEG: 52.9997234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GY000200',
        LOCATION_NAME: 'Gyffin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8328096,
        LOCATION_LATITUDE_DEG: 53.2749582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GY000400',
        LOCATION_NAME: 'Gyrn Goch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3848633,
        LOCATION_LATITUDE_DEG: 53.0086351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'H 000100',
        LOCATION_NAME: 'H M Naval Base',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1040186,
        LOCATION_LATITUDE_DEG: 50.7999896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000100',
        LOCATION_NAME: 'Habberley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8890951,
        LOCATION_LATITUDE_DEG: 52.6262883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000300',
        LOCATION_NAME: 'Habertoft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.249363,
        LOCATION_LATITUDE_DEG: 53.1984986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000400',
        LOCATION_NAME: 'Habost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5285877,
        LOCATION_LATITUDE_DEG: 58.0844565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000500',
        LOCATION_NAME: 'Habrough',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2676991,
        LOCATION_LATITUDE_DEG: 53.6059447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000600',
        LOCATION_NAME: 'Haccombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5563288,
        LOCATION_LATITUDE_DEG: 50.5215956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000700',
        LOCATION_NAME: 'Haceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4685017,
        LOCATION_LATITUDE_DEG: 52.9115868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000800',
        LOCATION_NAME: 'Hacheston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3771208,
        LOCATION_LATITUDE_DEG: 52.1822891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001000',
        LOCATION_NAME: 'Hackbridge',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1507923,
        LOCATION_LATITUDE_DEG: 51.3743352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001100',
        LOCATION_NAME: 'Hackenthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.372639,
        LOCATION_LATITUDE_DEG: 53.3427352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001300',
        LOCATION_NAME: 'Hackford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0392677,
        LOCATION_LATITUDE_DEG: 52.5785306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001400',
        LOCATION_NAME: 'Hackforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6251869,
        LOCATION_LATITUDE_DEG: 54.3362361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001500',
        LOCATION_NAME: 'Hacklete',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8495689,
        LOCATION_LATITUDE_DEG: 58.2094714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001600',
        LOCATION_NAME: 'Hackleton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8213981,
        LOCATION_LATITUDE_DEG: 52.1875161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001700',
        LOCATION_NAME: 'Hacklett',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3085562,
        LOCATION_LATITUDE_DEG: 57.411497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001800',
        LOCATION_NAME: 'Hacklinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3574225,
        LOCATION_LATITUDE_DEG: 51.2356964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001900',
        LOCATION_NAME: 'Hackness',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5118534,
        LOCATION_LATITUDE_DEG: 54.3016177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070300',
        LOCATION_NAME: 'Hackney',
        COUNTY_NAME: 'London',
        POSTCODE: 'E8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0662577,
        LOCATION_LATITUDE_DEG: 51.5468726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070200',
        LOCATION_NAME: 'Hackney',
        COUNTY_NAME: 'London',
        POSTCODE: 'E2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0603358,
        LOCATION_LATITUDE_DEG: 51.5321332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070400',
        LOCATION_NAME: 'Hackney',
        COUNTY_NAME: 'London',
        POSTCODE: 'E9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.04172,
        LOCATION_LATITUDE_DEG: 51.5462317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070500',
        LOCATION_NAME: 'Hackney Wick',
        COUNTY_NAME: 'London',
        POSTCODE: 'E9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0290988,
        LOCATION_LATITUDE_DEG: 51.5488982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002000',
        LOCATION_NAME: 'Hackthorn',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5054915,
        LOCATION_LATITUDE_DEG: 53.3286238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002100',
        LOCATION_NAME: 'Hackthorn Cliff',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.528684,
        LOCATION_LATITUDE_DEG: 53.3145181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002200',
        LOCATION_NAME: 'Hackthorpe',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7104595,
        LOCATION_LATITUDE_DEG: 54.6028728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002300',
        LOCATION_NAME: 'Haconby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3588242,
        LOCATION_LATITUDE_DEG: 52.8143724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002400',
        LOCATION_NAME: 'Haddenham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9235928,
        LOCATION_LATITUDE_DEG: 51.7729834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002500',
        LOCATION_NAME: 'Haddenham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1500026,
        LOCATION_LATITUDE_DEG: 52.3576252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002700',
        LOCATION_NAME: 'Haddington',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7823608,
        LOCATION_LATITUDE_DEG: 55.9554107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002600',
        LOCATION_NAME: 'Haddington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6301523,
        LOCATION_LATITUDE_DEG: 53.1560088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002800',
        LOCATION_NAME: 'Haddiscoe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6050444,
        LOCATION_LATITUDE_DEG: 52.5155125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA002900',
        LOCATION_NAME: 'Haddon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4228466,
        LOCATION_LATITUDE_DEG: 50.9452202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003000',
        LOCATION_NAME: 'Haddon',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3269246,
        LOCATION_LATITUDE_DEG: 52.5199422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003050',
        LOCATION_NAME: 'Hade Edge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7793423,
        LOCATION_LATITUDE_DEG: 53.5474791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003100',
        LOCATION_NAME: 'Hademore',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7400512,
        LOCATION_LATITUDE_DEG: 52.6706787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003200',
        LOCATION_NAME: 'Haden Cross',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0500208,
        LOCATION_LATITUDE_DEG: 52.4641631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003300',
        LOCATION_NAME: 'Hadfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9700367,
        LOCATION_LATITUDE_DEG: 53.4645535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003400',
        LOCATION_NAME: 'Hadham Cross',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0711919,
        LOCATION_LATITUDE_DEG: 51.8465749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003500',
        LOCATION_NAME: 'Hadleigh',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6117866,
        LOCATION_LATITUDE_DEG: 51.5528368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003600',
        LOCATION_NAME: 'Hadleigh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.954497,
        LOCATION_LATITUDE_DEG: 52.0445827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003700',
        LOCATION_NAME: 'Hadley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4792801,
        LOCATION_LATITUDE_DEG: 52.7039889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003800',
        LOCATION_NAME: 'Hadley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2063367,
        LOCATION_LATITUDE_DEG: 52.2712405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003900',
        LOCATION_NAME: 'Hadley Heath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1934864,
        LOCATION_LATITUDE_DEG: 52.2552397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003925',
        LOCATION_NAME: 'Hadley Highstone',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2030695,
        LOCATION_LATITUDE_DEG: 51.6578137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA003950',
        LOCATION_NAME: 'Hadley Wood',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'EN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.174773,
        LOCATION_LATITUDE_DEG: 51.6685829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004000',
        LOCATION_NAME: 'Hadlow',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3407079,
        LOCATION_LATITUDE_DEG: 51.2237104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004100',
        LOCATION_NAME: 'Hadlow Down',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1861541,
        LOCATION_LATITUDE_DEG: 50.9951916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004200',
        LOCATION_NAME: 'Hadnall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7065924,
        LOCATION_LATITUDE_DEG: 52.7794987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004300',
        LOCATION_NAME: 'Hadspen',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4885486,
        LOCATION_LATITUDE_DEG: 51.0839377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004400',
        LOCATION_NAME: 'Hadstock',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2756059,
        LOCATION_LATITUDE_DEG: 52.0799912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004500',
        LOCATION_NAME: 'Hadston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5916836,
        LOCATION_LATITUDE_DEG: 55.2947326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004600',
        LOCATION_NAME: 'Hadzor',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1241773,
        LOCATION_LATITUDE_DEG: 52.2576437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004700',
        LOCATION_NAME: 'Hafodyrynys',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1180595,
        LOCATION_LATITUDE_DEG: 51.6828939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004800',
        LOCATION_NAME: 'Haggs',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9392229,
        LOCATION_LATITUDE_DEG: 55.9890289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA004900',
        LOCATION_NAME: 'Hagley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1243428,
        LOCATION_LATITUDE_DEG: 52.4266605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005000',
        LOCATION_NAME: 'Hagnaby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0017643,
        LOCATION_LATITUDE_DEG: 53.1457006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005100',
        LOCATION_NAME: 'Hagworthingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0140094,
        LOCATION_LATITUDE_DEG: 53.2063073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005300',
        LOCATION_NAME: 'Haigh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5938579,
        LOCATION_LATITUDE_DEG: 53.5755771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005200',
        LOCATION_NAME: 'Haigh',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5556929,
        LOCATION_LATITUDE_DEG: 53.6038684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005400',
        LOCATION_NAME: 'Hail Weston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2927565,
        LOCATION_LATITUDE_DEG: 52.2449141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005500',
        LOCATION_NAME: 'Haile',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4907718,
        LOCATION_LATITUDE_DEG: 54.4642703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005600',
        LOCATION_NAME: 'Hailes',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9288822,
        LOCATION_LATITUDE_DEG: 51.9706138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005800',
        LOCATION_NAME: 'Hailey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4848028,
        LOCATION_LATITUDE_DEG: 51.8081919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005700',
        LOCATION_NAME: 'Hailey',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0119267,
        LOCATION_LATITUDE_DEG: 51.7782665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA005900',
        LOCATION_NAME: 'Hailsham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2593518,
        LOCATION_LATITUDE_DEG: 50.8637783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006000',
        LOCATION_NAME: 'Hailstone Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3909373,
        LOCATION_LATITUDE_DEG: 54.3334296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006100',
        LOCATION_NAME: 'Hainault',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1137719,
        LOCATION_LATITUDE_DEG: 51.6017943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006200',
        LOCATION_NAME: 'Hainford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3005956,
        LOCATION_LATITUDE_DEG: 52.7208401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006300',
        LOCATION_NAME: 'Hainton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2218089,
        LOCATION_LATITUDE_DEG: 53.3431189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006400',
        LOCATION_NAME: 'Hainworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9113157,
        LOCATION_LATITUDE_DEG: 53.8465936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006500',
        LOCATION_NAME: 'Hainworth Shaw',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.896822,
        LOCATION_LATITUDE_DEG: 53.8493955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006600',
        LOCATION_NAME: 'Haisthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2774287,
        LOCATION_LATITUDE_DEG: 54.0644949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006700',
        LOCATION_NAME: 'Hakin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0483813,
        LOCATION_LATITUDE_DEG: 51.7120206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006800',
        LOCATION_NAME: 'Halam',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9889612,
        LOCATION_LATITUDE_DEG: 53.0814056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA006900',
        LOCATION_NAME: 'Halbeath',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4028492,
        LOCATION_LATITUDE_DEG: 56.0831287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007000',
        LOCATION_NAME: 'Halberton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4113944,
        LOCATION_LATITUDE_DEG: 50.9071289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007100',
        LOCATION_NAME: 'Hale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7607686,
        LOCATION_LATITUDE_DEG: 54.1995378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007300',
        LOCATION_NAME: 'Hale',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3434741,
        LOCATION_LATITUDE_DEG: 53.3791476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007200',
        LOCATION_NAME: 'Hale',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7227833,
        LOCATION_LATITUDE_DEG: 50.969615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007400',
        LOCATION_NAME: 'Hale Common',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2285652,
        LOCATION_LATITUDE_DEG: 50.6542798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007500',
        LOCATION_NAME: 'Hale Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7436772,
        LOCATION_LATITUDE_DEG: 50.9646175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007600',
        LOCATION_NAME: 'Hale Purlieu',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.718566,
        LOCATION_LATITUDE_DEG: 50.9651172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007700',
        LOCATION_NAME: 'Hale Village',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7929328,
        LOCATION_LATITUDE_DEG: 53.3298562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007800',
        LOCATION_NAME: 'Halebank',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7736975,
        LOCATION_LATITUDE_DEG: 53.3490501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA007900',
        LOCATION_NAME: 'Halebarns',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3080124,
        LOCATION_LATITUDE_DEG: 53.3672521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008000',
        LOCATION_NAME: 'Hales',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4264182,
        LOCATION_LATITUDE_DEG: 52.9020106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008100',
        LOCATION_NAME: 'Hales',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5109601,
        LOCATION_LATITUDE_DEG: 52.521115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008200',
        LOCATION_NAME: 'Hales Place',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0853164,
        LOCATION_LATITUDE_DEG: 51.2938114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008300',
        LOCATION_NAME: 'Halesowen',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0503265,
        LOCATION_LATITUDE_DEG: 52.4482578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008400',
        LOCATION_NAME: 'Halesworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5024774,
        LOCATION_LATITUDE_DEG: 52.3427001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008500',
        LOCATION_NAME: 'Halewood',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8389453,
        LOCATION_LATITUDE_DEG: 53.3596579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008700',
        LOCATION_NAME: 'Halford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8283651,
        LOCATION_LATITUDE_DEG: 52.4443697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008600',
        LOCATION_NAME: 'Halford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6197216,
        LOCATION_LATITUDE_DEG: 52.1078195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008800',
        LOCATION_NAME: 'Halfpennyburn',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9125069,
        LOCATION_LATITUDE_DEG: 56.6363818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA072100',
        LOCATION_NAME: 'Halfway',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.334876,
        LOCATION_LATITUDE_DEG: 55.8469434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA008900',
        LOCATION_NAME: 'Halfway',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7070031,
        LOCATION_LATITUDE_DEG: 51.979035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009200',
        LOCATION_NAME: 'Halfway',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4134608,
        LOCATION_LATITUDE_DEG: 51.4126488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009000',
        LOCATION_NAME: 'Halfway',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3514569,
        LOCATION_LATITUDE_DEG: 53.3220351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009300',
        LOCATION_NAME: 'Halfway Bridge',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0840663,
        LOCATION_LATITUDE_DEG: 53.1991498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009400',
        LOCATION_NAME: 'Halfway House',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1862276,
        LOCATION_LATITUDE_DEG: 50.1568778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009500',
        LOCATION_NAME: 'Halfway House',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9768124,
        LOCATION_LATITUDE_DEG: 52.697697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009600',
        LOCATION_NAME: 'Halfway Houses',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7785778,
        LOCATION_LATITUDE_DEG: 51.4216265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009700',
        LOCATION_NAME: 'Halghton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8391193,
        LOCATION_LATITUDE_DEG: 52.9628184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009800',
        LOCATION_NAME: 'Halifax',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8586954,
        LOCATION_LATITUDE_DEG: 53.7226831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009900',
        LOCATION_NAME: 'Halistra',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5982717,
        LOCATION_LATITUDE_DEG: 57.5397046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010000',
        LOCATION_NAME: 'Halket',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5128775,
        LOCATION_LATITUDE_DEG: 55.7396097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010100',
        LOCATION_NAME: 'Halkirk',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.493832,
        LOCATION_LATITUDE_DEG: 58.5141688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010200',
        LOCATION_NAME: 'Halkyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1855456,
        LOCATION_LATITUDE_DEG: 53.2309437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010300',
        LOCATION_NAME: 'Hall End',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4200304,
        LOCATION_LATITUDE_DEG: 51.5792766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA071700',
        LOCATION_NAME: 'Hall Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8427836,
        LOCATION_LATITUDE_DEG: 52.4310001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010400',
        LOCATION_NAME: 'Hall Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.517296,
        LOCATION_LATITUDE_DEG: 53.629663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010600',
        LOCATION_NAME: 'Halland',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1346309,
        LOCATION_LATITUDE_DEG: 50.9268862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010700',
        LOCATION_NAME: 'Hallaton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8344152,
        LOCATION_LATITUDE_DEG: 52.5620573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010800',
        LOCATION_NAME: 'Hallatrow',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5201788,
        LOCATION_LATITUDE_DEG: 51.3117571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010900',
        LOCATION_NAME: 'Hallbankgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.654676,
        LOCATION_LATITUDE_DEG: 54.9292094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011000',
        LOCATION_NAME: 'Halleaths',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4151039,
        LOCATION_LATITUDE_DEG: 55.1270348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011100',
        LOCATION_NAME: 'Hallegan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2954299,
        LOCATION_LATITUDE_DEG: 50.1832755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011200',
        LOCATION_NAME: 'Hallen',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6476165,
        LOCATION_LATITUDE_DEG: 51.5165795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011300',
        LOCATION_NAME: 'Hallew',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7923855,
        LOCATION_LATITUDE_DEG: 50.3997938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011400',
        LOCATION_NAME: 'Hallin',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.590139,
        LOCATION_LATITUDE_DEG: 57.5345047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011500',
        LOCATION_NAME: 'Hallin Park',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5918779,
        LOCATION_LATITUDE_DEG: 57.5337036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011600',
        LOCATION_NAME: 'Halling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.44805,
        LOCATION_LATITUDE_DEG: 51.3490208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011800',
        LOCATION_NAME: 'Hallington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0245447,
        LOCATION_LATITUDE_DEG: 55.0752145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011700',
        LOCATION_NAME: 'Hallington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.042956,
        LOCATION_LATITUDE_DEG: 53.350515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA011900',
        LOCATION_NAME: 'Halloughton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9674119,
        LOCATION_LATITUDE_DEG: 53.0591039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012000',
        LOCATION_NAME: 'Hallow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2520854,
        LOCATION_LATITUDE_DEG: 52.2204403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012100',
        LOCATION_NAME: 'Halls',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5561441,
        LOCATION_LATITUDE_DEG: 55.9463052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA010500',
        LOCATION_NAME: "Hall'S Green",
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1449687,
        LOCATION_LATITUDE_DEG: 51.940887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012200',
        LOCATION_NAME: 'Hallsands',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6578789,
        LOCATION_LATITUDE_DEG: 50.2365652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012300',
        LOCATION_NAME: 'Hallsenna',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.44294,
        LOCATION_LATITUDE_DEG: 54.3972627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012400',
        LOCATION_NAME: 'Hallthwaites',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2622667,
        LOCATION_LATITUDE_DEG: 54.2582505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012500',
        LOCATION_NAME: 'Hallwood Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4743277,
        LOCATION_LATITUDE_DEG: 51.9981212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012550',
        LOCATION_NAME: 'Hallwood Park',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6987678,
        LOCATION_LATITUDE_DEG: 53.3248711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012600',
        LOCATION_NAME: 'Hallworthy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5756551,
        LOCATION_LATITUDE_DEG: 50.6610141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012700',
        LOCATION_NAME: 'Hallyne',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2857319,
        LOCATION_LATITUDE_DEG: 55.6500819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012800',
        LOCATION_NAME: 'Halmer End',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2951814,
        LOCATION_LATITUDE_DEG: 53.0367152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA012900',
        LOCATION_NAME: 'Halmonds Frome',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4800121,
        LOCATION_LATITUDE_DEG: 52.1263292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013000',
        LOCATION_NAME: 'Halmore',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4367412,
        LOCATION_LATITUDE_DEG: 51.7203953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013100',
        LOCATION_NAME: 'Halmyre Mains',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3131448,
        LOCATION_LATITUDE_DEG: 55.7301899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013200',
        LOCATION_NAME: 'Halnaker',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7100193,
        LOCATION_LATITUDE_DEG: 50.8647873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013300',
        LOCATION_NAME: 'Halsall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9522005,
        LOCATION_LATITUDE_DEG: 53.5846785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013500',
        LOCATION_NAME: 'Halse',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2261599,
        LOCATION_LATITUDE_DEG: 51.0435339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013400',
        LOCATION_NAME: 'Halse',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1732958,
        LOCATION_LATITUDE_DEG: 52.0583094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013600',
        LOCATION_NAME: 'Halsetown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4926488,
        LOCATION_LATITUDE_DEG: 50.195079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013700',
        LOCATION_NAME: 'Halsham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0730034,
        LOCATION_LATITUDE_DEG: 53.7297544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013800',
        LOCATION_NAME: 'Halsinger',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1237518,
        LOCATION_LATITUDE_DEG: 51.1298571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA013900',
        LOCATION_NAME: 'Halsnead Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.795743,
        LOCATION_LATITUDE_DEG: 53.403357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014000',
        LOCATION_NAME: 'Halstead',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8940216,
        LOCATION_LATITUDE_DEG: 52.6435595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014200',
        LOCATION_NAME: 'Halstead',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1342804,
        LOCATION_LATITUDE_DEG: 51.3275212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014100',
        LOCATION_NAME: 'Halstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6406903,
        LOCATION_LATITUDE_DEG: 51.9447749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014300',
        LOCATION_NAME: 'Halstock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6532439,
        LOCATION_LATITUDE_DEG: 50.8692156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014400',
        LOCATION_NAME: 'Halstock Leigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6822711,
        LOCATION_LATITUDE_DEG: 50.8666123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014500',
        LOCATION_NAME: 'Haltham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1351061,
        LOCATION_LATITUDE_DEG: 53.1552998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014700',
        LOCATION_NAME: 'Halton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7630151,
        LOCATION_LATITUDE_DEG: 54.0767283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014900',
        LOCATION_NAME: 'Halton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7004653,
        LOCATION_LATITUDE_DEG: 53.3322508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014600',
        LOCATION_NAME: 'Halton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4777643,
        LOCATION_LATITUDE_DEG: 53.8008861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA014800',
        LOCATION_NAME: 'Halton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7337341,
        LOCATION_LATITUDE_DEG: 51.7811812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015000',
        LOCATION_NAME: 'Halton Brook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.706601,
        LOCATION_LATITUDE_DEG: 53.332754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015100',
        LOCATION_NAME: 'Halton Camp',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.727372,
        LOCATION_LATITUDE_DEG: 51.7738735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015200',
        LOCATION_NAME: 'Halton East',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9369246,
        LOCATION_LATITUDE_DEG: 53.9814064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015300',
        LOCATION_NAME: 'Halton Gill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.18247,
        LOCATION_LATITUDE_DEG: 54.183528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015400',
        LOCATION_NAME: 'Halton Holegate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1182006,
        LOCATION_LATITUDE_DEG: 53.1643973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068900',
        LOCATION_NAME: 'Halton Lea Gate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7303023,
        LOCATION_LATITUDE_DEG: 50.5118479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015500',
        LOCATION_NAME: 'Halton Lodge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7060049,
        LOCATION_LATITUDE_DEG: 53.3248464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015600',
        LOCATION_NAME: 'Halton Village',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7339579,
        LOCATION_LATITUDE_DEG: 51.7902752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015700',
        LOCATION_NAME: 'Halton West',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2340454,
        LOCATION_LATITUDE_DEG: 53.9866063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015800',
        LOCATION_NAME: 'Halton-Lea-Gate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5438959,
        LOCATION_LATITUDE_DEG: 54.9210017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA015900',
        LOCATION_NAME: 'Haltwhistle',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4557515,
        LOCATION_LATITUDE_DEG: 54.9708038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016000',
        LOCATION_NAME: 'Halvasso',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1626308,
        LOCATION_LATITUDE_DEG: 50.1532767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016100',
        LOCATION_NAME: 'Halvergate',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5799372,
        LOCATION_LATITUDE_DEG: 52.6059244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016200',
        LOCATION_NAME: 'Halwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7194231,
        LOCATION_LATITUDE_DEG: 50.3651821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016300',
        LOCATION_NAME: 'Halwill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2299511,
        LOCATION_LATITUDE_DEG: 50.7724248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016400',
        LOCATION_NAME: 'Halwill Junction',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2073338,
        LOCATION_LATITUDE_DEG: 50.7774247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016900',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.212222,
        LOCATION_LATITUDE_DEG: 50.9883323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016600',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0817121,
        LOCATION_LATITUDE_DEG: 50.806114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016700',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0132422,
        LOCATION_LATITUDE_DEG: 51.0217321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016800',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5611466,
        LOCATION_LATITUDE_DEG: 51.198841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017300',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4635,
        LOCATION_LATITUDE_DEG: 51.6824893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017100',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5244726,
        LOCATION_LATITUDE_DEG: 51.3647527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017200',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8083037,
        LOCATION_LATITUDE_DEG: 50.7528771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017000',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'TW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3092648,
        LOCATION_LATITUDE_DEG: 51.4351425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA016500',
        LOCATION_NAME: 'Ham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3337542,
        LOCATION_LATITUDE_DEG: 51.2434986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017600',
        LOCATION_NAME: 'Ham Green',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6789904,
        LOCATION_LATITUDE_DEG: 51.4755754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017400',
        LOCATION_NAME: 'Ham Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4586314,
        LOCATION_LATITUDE_DEG: 51.6816901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017500',
        LOCATION_NAME: 'Ham Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9810491,
        LOCATION_LATITUDE_DEG: 52.2707449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017700',
        LOCATION_NAME: 'Ham Spray',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5029501,
        LOCATION_LATITUDE_DEG: 51.3663451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017800',
        LOCATION_NAME: 'Hamar',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4264488,
        LOCATION_LATITUDE_DEG: 60.4598404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA017900',
        LOCATION_NAME: 'Hamble',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.31866,
        LOCATION_LATITUDE_DEG: 50.8582986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018000',
        LOCATION_NAME: 'Hambleden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8694765,
        LOCATION_LATITUDE_DEG: 51.5704556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018100',
        LOCATION_NAME: 'Hambledon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0795622,
        LOCATION_LATITUDE_DEG: 50.9308017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018200',
        LOCATION_NAME: 'Hambledon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6187663,
        LOCATION_LATITUDE_DEG: 51.1373169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018300',
        LOCATION_NAME: 'Hambleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.953843,
        LOCATION_LATITUDE_DEG: 53.875808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018400',
        LOCATION_NAME: 'Hambleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1608944,
        LOCATION_LATITUDE_DEG: 53.7713736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018500',
        LOCATION_NAME: 'Hambleton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.668926,
        LOCATION_LATITUDE_DEG: 52.6581573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990129',
        LOCATION_NAME: 'Hambleton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6660488,
        LOCATION_LATITUDE_DEG: 52.6594107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018600',
        LOCATION_NAME: 'Hambridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8626509,
        LOCATION_LATITUDE_DEG: 50.9889276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018800',
        LOCATION_NAME: 'Hambrook',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5172212,
        LOCATION_LATITUDE_DEG: 51.5078746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018700',
        LOCATION_NAME: 'Hambrook',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8816732,
        LOCATION_LATITUDE_DEG: 50.8551902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA018900',
        LOCATION_NAME: 'Hamerton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3303198,
        LOCATION_LATITUDE_DEG: 52.4023296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019000',
        LOCATION_NAME: 'Hamfields',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4804323,
        LOCATION_LATITUDE_DEG: 51.6899928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019100',
        LOCATION_NAME: 'Hamilton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0462103,
        LOCATION_LATITUDE_DEG: 55.775505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019200',
        LOCATION_NAME: 'Hamilton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0617629,
        LOCATION_LATITUDE_DEG: 52.652469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019300',
        LOCATION_NAME: 'Hamiltonsbawn',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5322709,
        LOCATION_LATITUDE_DEG: 54.3331865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990915',
        LOCATION_NAME: 'Hamley Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019400',
        LOCATION_NAME: 'Hammer',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7479729,
        LOCATION_LATITUDE_DEG: 51.0790453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070000',
        LOCATION_NAME: 'Hammersmith',
        COUNTY_NAME: 'London',
        POSTCODE: 'W6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2296819,
        LOCATION_LATITUDE_DEG: 51.4949615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019500',
        LOCATION_NAME: 'Hammerwich',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.899557,
        LOCATION_LATITUDE_DEG: 52.6660752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019600',
        LOCATION_NAME: 'Hammerwood',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0536966,
        LOCATION_LATITUDE_DEG: 51.1357048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019700',
        LOCATION_NAME: 'Hammond Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0718729,
        LOCATION_LATITUDE_DEG: 51.7198644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019800',
        LOCATION_NAME: 'Hammoon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2592321,
        LOCATION_LATITUDE_DEG: 50.9295189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019900',
        LOCATION_NAME: 'Hamnavoe',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3374096,
        LOCATION_LATITUDE_DEG: 60.1064057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA019950',
        LOCATION_NAME: 'Hamnish',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6806372,
        LOCATION_LATITUDE_DEG: 52.2305079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020000',
        LOCATION_NAME: 'Hamp Bridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9930933,
        LOCATION_LATITUDE_DEG: 51.1144388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020100',
        LOCATION_NAME: 'Hampden Park',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2732006,
        LOCATION_LATITUDE_DEG: 50.796074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020200',
        LOCATION_NAME: 'Hampden Row',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7710352,
        LOCATION_LATITUDE_DEG: 51.7038719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020300',
        LOCATION_NAME: 'Hamperley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8543653,
        LOCATION_LATITUDE_DEG: 52.4975749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020400',
        LOCATION_NAME: 'Hampeth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.724029,
        LOCATION_LATITUDE_DEG: 55.3471368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020500',
        LOCATION_NAME: 'Hampnett',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.858831,
        LOCATION_LATITUDE_DEG: 51.8441966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020600',
        LOCATION_NAME: 'Hampole',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2421911,
        LOCATION_LATITUDE_DEG: 53.5879555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020700',
        LOCATION_NAME: 'Hampreston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9221025,
        LOCATION_LATITUDE_DEG: 50.7911999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020800',
        LOCATION_NAME: 'Hampson',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7759783,
        LOCATION_LATITUDE_DEG: 53.9800144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069900',
        LOCATION_NAME: 'Hampstead',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1781835,
        LOCATION_LATITUDE_DEG: 51.5593575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA020900',
        LOCATION_NAME: 'Hampstead Norreys',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2386497,
        LOCATION_LATITUDE_DEG: 51.4835588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021000',
        LOCATION_NAME: 'Hampsthwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6046648,
        LOCATION_LATITUDE_DEG: 54.0233076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021400',
        LOCATION_NAME: 'Hampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5264656,
        LOCATION_LATITUDE_DEG: 50.7289975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021100',
        LOCATION_NAME: 'Hampton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3815454,
        LOCATION_LATITUDE_DEG: 52.476065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021200',
        LOCATION_NAME: 'Hampton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9651586,
        LOCATION_LATITUDE_DEG: 52.0872254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021300',
        LOCATION_NAME: 'Hampton',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3669623,
        LOCATION_LATITUDE_DEG: 51.4170384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021450',
        LOCATION_NAME: 'Hampton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2676979,
        LOCATION_LATITUDE_DEG: 52.5393579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021500',
        LOCATION_NAME: 'Hampton Beech',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0199586,
        LOCATION_LATITUDE_DEG: 52.6394849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021600',
        LOCATION_NAME: 'Hampton Bishop',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6440406,
        LOCATION_LATITUDE_DEG: 52.0378239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021700',
        LOCATION_NAME: 'Hampton Charles',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5779233,
        LOCATION_LATITUDE_DEG: 52.2459454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990704',
        LOCATION_NAME: 'Hampton Gardens',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021800',
        LOCATION_NAME: 'Hampton Gay',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2906315,
        LOCATION_LATITUDE_DEG: 51.8445884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021900',
        LOCATION_NAME: 'Hampton Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7242394,
        LOCATION_LATITUDE_DEG: 53.0391203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA021950',
        LOCATION_NAME: 'Hampton Hargate',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2618891,
        LOCATION_LATITUDE_DEG: 52.5419253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022000',
        LOCATION_NAME: 'Hampton Hill',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.357949,
        LOCATION_LATITUDE_DEG: 51.4281363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069200',
        LOCATION_NAME: 'Hampton in Arden',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022100',
        LOCATION_NAME: 'Hampton Loade',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3681257,
        LOCATION_LATITUDE_DEG: 52.4771684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022200',
        LOCATION_NAME: 'Hampton Lovett',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.166397,
        LOCATION_LATITUDE_DEG: 52.2868406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022300',
        LOCATION_NAME: 'Hampton Lucy',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6246037,
        LOCATION_LATITUDE_DEG: 52.2115347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022400',
        LOCATION_NAME: 'Hampton Magna',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6208233,
        LOCATION_LATITUDE_DEG: 52.2807385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022500',
        LOCATION_NAME: 'Hampton On The Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6291106,
        LOCATION_LATITUDE_DEG: 52.2749384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022600',
        LOCATION_NAME: 'Hampton Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.389643,
        LOCATION_LATITUDE_DEG: 50.9383022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022700',
        LOCATION_NAME: 'Hampton Poyle',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2698583,
        LOCATION_LATITUDE_DEG: 51.8354871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990556',
        LOCATION_NAME: 'Hampton Vale',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2705407,
        LOCATION_LATITUDE_DEG: 52.5244368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022800',
        LOCATION_NAME: 'Hampton Wick',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3115269,
        LOCATION_LATITUDE_DEG: 51.4120349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA022900',
        LOCATION_NAME: 'Hampton Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8544717,
        LOCATION_LATITUDE_DEG: 52.9349192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023000',
        LOCATION_NAME: 'Hampton-in-Arden',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7059089,
        LOCATION_LATITUDE_DEG: 52.42458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023100',
        LOCATION_NAME: 'Hamptworth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.653675,
        LOCATION_LATITUDE_DEG: 50.971517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023200',
        LOCATION_NAME: 'Hamsey',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.004262,
        LOCATION_LATITUDE_DEG: 50.8976807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023300',
        LOCATION_NAME: 'Hamsey Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.061116,
        LOCATION_LATITUDE_DEG: 51.3190299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023400',
        LOCATION_NAME: 'Hamstall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8418205,
        LOCATION_LATITUDE_DEG: 52.7690901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990688',
        LOCATION_NAME: 'Hamstall Ridware',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023500',
        LOCATION_NAME: 'Hamstead',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4332022,
        LOCATION_LATITUDE_DEG: 50.7198866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023600',
        LOCATION_NAME: 'Hamstead Marshall',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4081019,
        LOCATION_LATITUDE_DEG: 51.3877478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023700',
        LOCATION_NAME: 'Hamsterley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8139566,
        LOCATION_LATITUDE_DEG: 54.674173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023800',
        LOCATION_NAME: 'Hamsterley Mill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7795947,
        LOCATION_LATITUDE_DEG: 54.901896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA023900',
        LOCATION_NAME: 'Hamstreet',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8583943,
        LOCATION_LATITUDE_DEG: 51.0650924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024000',
        LOCATION_NAME: 'Hamswell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3900228,
        LOCATION_LATITUDE_DEG: 51.4373699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024100',
        LOCATION_NAME: 'Hamworthy',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0095772,
        LOCATION_LATITUDE_DEG: 50.7201936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024200',
        LOCATION_NAME: 'Hanbury',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0556115,
        LOCATION_LATITUDE_DEG: 52.2745457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024300',
        LOCATION_NAME: 'Hanbury',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7427266,
        LOCATION_LATITUDE_DEG: 52.8469904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024400',
        LOCATION_NAME: 'Hanby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4713824,
        LOCATION_LATITUDE_DEG: 52.8732762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024450',
        LOCATION_NAME: 'Hanch',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8498624,
        LOCATION_LATITUDE_DEG: 52.7237429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024500',
        LOCATION_NAME: 'Hanchurch',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2262482,
        LOCATION_LATITUDE_DEG: 52.969008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024600',
        LOCATION_NAME: 'Handbridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8865899,
        LOCATION_LATITUDE_DEG: 53.1816419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024700',
        LOCATION_NAME: 'Handcross',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1988956,
        LOCATION_LATITUDE_DEG: 51.0531031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024800',
        LOCATION_NAME: 'Handforth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2138059,
        LOCATION_LATITUDE_DEG: 53.3497483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA024900',
        LOCATION_NAME: 'Handley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7934318,
        LOCATION_LATITUDE_DEG: 53.1128312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025000',
        LOCATION_NAME: 'Handley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4445784,
        LOCATION_LATITUDE_DEG: 53.157521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025100',
        LOCATION_NAME: 'Handley Park',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.015169,
        LOCATION_LATITUDE_DEG: 52.1299107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025200',
        LOCATION_NAME: 'Handsacre',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8644833,
        LOCATION_LATITUDE_DEG: 52.7410855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA071500',
        LOCATION_NAME: 'Handsworth',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9481743,
        LOCATION_LATITUDE_DEG: 52.509378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA071300',
        LOCATION_NAME: 'Handsworth',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9391332,
        LOCATION_LATITUDE_DEG: 52.5045276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025300',
        LOCATION_NAME: 'Handsworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3771438,
        LOCATION_LATITUDE_DEG: 53.3727399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA071400',
        LOCATION_NAME: 'Handsworth Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9088751,
        LOCATION_LATITUDE_DEG: 52.5159627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025400',
        LOCATION_NAME: 'Handy Cross',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7679662,
        LOCATION_LATITUDE_DEG: 51.606862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025500',
        LOCATION_NAME: 'Hanford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2198315,
        LOCATION_LATITUDE_DEG: 50.900416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025600',
        LOCATION_NAME: 'Hangersley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7596541,
        LOCATION_LATITUDE_DEG: 50.8545988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025700',
        LOCATION_NAME: 'Hanghill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6836519,
        LOCATION_LATITUDE_DEG: 51.7768812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025800',
        LOCATION_NAME: 'Hanging Heaton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6151462,
        LOCATION_LATITUDE_DEG: 53.7041701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA025900',
        LOCATION_NAME: 'Hanging Houghton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8936926,
        LOCATION_LATITUDE_DEG: 52.356137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026000',
        LOCATION_NAME: 'Hanging Langford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9541327,
        LOCATION_LATITUDE_DEG: 51.132532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026100',
        LOCATION_NAME: 'Hanging Stone',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7632484,
        LOCATION_LATITUDE_DEG: 54.8542858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990671',
        LOCATION_NAME: 'Hangingwood',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026200',
        LOCATION_NAME: 'Hangleton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1947042,
        LOCATION_LATITUDE_DEG: 50.8534826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069800',
        LOCATION_NAME: 'Hanham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5119212,
        LOCATION_LATITUDE_DEG: 51.4502641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026300',
        LOCATION_NAME: 'Hankelow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4893339,
        LOCATION_LATITUDE_DEG: 53.0054182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026400',
        LOCATION_NAME: 'Hankerton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0441868,
        LOCATION_LATITUDE_DEG: 51.6166816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026500',
        LOCATION_NAME: 'Hankham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2990762,
        LOCATION_LATITUDE_DEG: 50.8264736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026600',
        LOCATION_NAME: 'Hanley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1701045,
        LOCATION_LATITUDE_DEG: 53.0253175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026700',
        LOCATION_NAME: 'Hanley Castle',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2329203,
        LOCATION_LATITUDE_DEG: 52.0773255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026800',
        LOCATION_NAME: 'Hanley Childe',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5131669,
        LOCATION_LATITUDE_DEG: 52.2793511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA026900',
        LOCATION_NAME: 'Hanley Swan',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2729573,
        LOCATION_LATITUDE_DEG: 52.0834258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027000',
        LOCATION_NAME: 'Hanley William',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4767214,
        LOCATION_LATITUDE_DEG: 52.2955535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027100',
        LOCATION_NAME: 'Hanlith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.150164,
        LOCATION_LATITUDE_DEG: 54.0476118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027200',
        LOCATION_NAME: 'Hanmer',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8110544,
        LOCATION_LATITUDE_DEG: 52.9510198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027300',
        LOCATION_NAME: 'Hannah',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2507662,
        LOCATION_LATITUDE_DEG: 53.2875091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027400',
        LOCATION_NAME: 'Hannahstown',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.035406,
        LOCATION_LATITUDE_DEG: 54.5882044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027500',
        LOCATION_NAME: 'Hannington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7487591,
        LOCATION_LATITUDE_DEG: 51.6377779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027600',
        LOCATION_NAME: 'Hannington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2263026,
        LOCATION_LATITUDE_DEG: 51.2954373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027700',
        LOCATION_NAME: 'Hannington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8088113,
        LOCATION_LATITUDE_DEG: 52.3304317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027800',
        LOCATION_NAME: 'Hannington Wick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7455316,
        LOCATION_LATITUDE_DEG: 51.6592806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA027900',
        LOCATION_NAME: 'Hanover',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1225907,
        LOCATION_LATITUDE_DEG: 50.8283832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028000',
        LOCATION_NAME: 'Hanslope',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8252417,
        LOCATION_LATITUDE_DEG: 52.1138113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028100',
        LOCATION_NAME: 'Hanthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3852062,
        LOCATION_LATITUDE_DEG: 52.8016697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028200',
        LOCATION_NAME: 'Hanwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3643084,
        LOCATION_LATITUDE_DEG: 52.090615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070100',
        LOCATION_NAME: 'Hanwell',
        COUNTY_NAME: 'London',
        POSTCODE: 'W7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3357757,
        LOCATION_LATITUDE_DEG: 51.5208152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028300',
        LOCATION_NAME: 'Hanwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8255285,
        LOCATION_LATITUDE_DEG: 52.6810899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028400',
        LOCATION_NAME: 'Hanworth',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3884643,
        LOCATION_LATITUDE_DEG: 51.429738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028500',
        LOCATION_NAME: 'Hanworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2743561,
        LOCATION_LATITUDE_DEG: 52.8664513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028600',
        LOCATION_NAME: 'Happisburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5329236,
        LOCATION_LATITUDE_DEG: 52.82405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028700',
        LOCATION_NAME: 'Happisburgh Common',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5181507,
        LOCATION_LATITUDE_DEG: 52.803144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028800',
        LOCATION_NAME: 'Hapsford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7897487,
        LOCATION_LATITUDE_DEG: 53.2639446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029000',
        LOCATION_NAME: 'Hapton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3145232,
        LOCATION_LATITUDE_DEG: 53.7827876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA028900',
        LOCATION_NAME: 'Hapton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2089322,
        LOCATION_LATITUDE_DEG: 52.5242204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029100',
        LOCATION_NAME: 'Harberton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7218464,
        LOCATION_LATITUDE_DEG: 50.4130805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029200',
        LOCATION_NAME: 'Harbertonford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7105326,
        LOCATION_LATITUDE_DEG: 50.3920823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029300',
        LOCATION_NAME: 'Harbledown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0585507,
        LOCATION_LATITUDE_DEG: 51.2814076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029400',
        LOCATION_NAME: 'Harborne',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9667631,
        LOCATION_LATITUDE_DEG: 52.4609592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029500',
        LOCATION_NAME: 'Harborough Magna',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2966517,
        LOCATION_LATITUDE_DEG: 52.4090433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029600',
        LOCATION_NAME: 'Harborough Parva',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2942864,
        LOCATION_LATITUDE_DEG: 52.4052439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029700',
        LOCATION_NAME: 'Harbottle',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1011221,
        LOCATION_LATITUDE_DEG: 55.3350408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029800',
        LOCATION_NAME: 'Harbourneford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8065007,
        LOCATION_LATITUDE_DEG: 50.4458876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA029900',
        LOCATION_NAME: 'Harbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7942537,
        LOCATION_LATITUDE_DEG: 50.8895057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030000',
        LOCATION_NAME: 'Harbury',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4553585,
        LOCATION_LATITUDE_DEG: 52.2351341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030200',
        LOCATION_NAME: 'Harby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8914698,
        LOCATION_LATITUDE_DEG: 52.8709818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030100',
        LOCATION_NAME: 'Harby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6815885,
        LOCATION_LATITUDE_DEG: 53.2273183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030300',
        LOCATION_NAME: 'Harcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1975892,
        LOCATION_LATITUDE_DEG: 50.7071088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030400',
        LOCATION_NAME: 'Harcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9458039,
        LOCATION_LATITUDE_DEG: 50.7533049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030500',
        LOCATION_NAME: 'Harcourt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0555586,
        LOCATION_LATITUDE_DEG: 50.2003741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030600',
        LOCATION_NAME: 'Hard Bank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7580536,
        LOCATION_LATITUDE_DEG: 54.9016009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030700',
        LOCATION_NAME: 'Harden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.871356,
        LOCATION_LATITUDE_DEG: 53.8401932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030800',
        LOCATION_NAME: 'Hardendale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6446988,
        LOCATION_LATITUDE_DEG: 54.5258627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA030900',
        LOCATION_NAME: 'Hardenhuish',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1319083,
        LOCATION_LATITUDE_DEG: 51.4662621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031000',
        LOCATION_NAME: 'Hardgate',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3994842,
        LOCATION_LATITUDE_DEG: 55.9238219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031100',
        LOCATION_NAME: 'Hardgate',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8546543,
        LOCATION_LATITUDE_DEG: 54.9820267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031200',
        LOCATION_NAME: 'Hardham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5233416,
        LOCATION_LATITUDE_DEG: 50.9479998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031300',
        LOCATION_NAME: 'Hardhorn',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9889661,
        LOCATION_LATITUDE_DEG: 53.8370044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031400',
        LOCATION_NAME: 'Hardingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0180521,
        LOCATION_LATITUDE_DEG: 52.5944356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031500',
        LOCATION_NAME: 'Hardingstone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8842748,
        LOCATION_LATITUDE_DEG: 52.2133227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031600',
        LOCATION_NAME: 'Hardington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3687797,
        LOCATION_LATITUDE_DEG: 51.2720526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031700',
        LOCATION_NAME: 'Hardington Mandeville',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6928385,
        LOCATION_LATITUDE_DEG: 50.904521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031800',
        LOCATION_NAME: 'Hardington Marsh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7005859,
        LOCATION_LATITUDE_DEG: 50.8862178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA031900',
        LOCATION_NAME: 'Hardington Moor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.691372,
        LOCATION_LATITUDE_DEG: 50.9044217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032000',
        LOCATION_NAME: 'Hardley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3922359,
        LOCATION_LATITUDE_DEG: 50.8386942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032050',
        LOCATION_NAME: 'Hardley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5187696,
        LOCATION_LATITUDE_DEG: 52.5523664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032100',
        LOCATION_NAME: 'Hardmead',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6331908,
        LOCATION_LATITUDE_DEG: 52.1190069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032200',
        LOCATION_NAME: 'Hardstoft',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3440199,
        LOCATION_LATITUDE_DEG: 53.1616215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032400',
        LOCATION_NAME: 'Hardway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3957192,
        LOCATION_LATITUDE_DEG: 51.1067357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032300',
        LOCATION_NAME: 'Hardway',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1351384,
        LOCATION_LATITUDE_DEG: 50.8116916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032600',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9304721,
        LOCATION_LATITUDE_DEG: 52.9012088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033300',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9299424,
        LOCATION_LATITUDE_DEG: 52.5080734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032900',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4471833,
        LOCATION_LATITUDE_DEG: 51.7504802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033200',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3507643,
        LOCATION_LATITUDE_DEG: 54.5838834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032800',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1622359,
        LOCATION_LATITUDE_DEG: 51.9617026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033500',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0333109,
        LOCATION_LATITUDE_DEG: 53.2728901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033100',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8304314,
        LOCATION_LATITUDE_DEG: 51.863187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032700',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.751605,
        LOCATION_LATITUDE_DEG: 52.3198332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033000',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.698134,
        LOCATION_LATITUDE_DEG: 53.2686228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA032500',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0135017,
        LOCATION_LATITUDE_DEG: 52.2129101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033400',
        LOCATION_NAME: 'Hardwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2691517,
        LOCATION_LATITUDE_DEG: 52.4598142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033700',
        LOCATION_NAME: 'Hardwicke',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0635908,
        LOCATION_LATITUDE_DEG: 52.0860382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990347',
        LOCATION_NAME: 'Hardwicke',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.133401,
        LOCATION_LATITUDE_DEG: 51.9469113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033600',
        LOCATION_NAME: 'Hardwicke',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1322299,
        LOCATION_LATITUDE_DEG: 51.9445118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033800',
        LOCATION_NAME: 'Hardys Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8053597,
        LOCATION_LATITUDE_DEG: 51.8501645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA033900',
        LOCATION_NAME: 'Hare Hatch',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8423958,
        LOCATION_LATITUDE_DEG: 51.494049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034000',
        LOCATION_NAME: 'Hare Law',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.74898,
        LOCATION_LATITUDE_DEG: 54.8716928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034200',
        LOCATION_NAME: 'Hare Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0226305,
        LOCATION_LATITUDE_DEG: 51.9480814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034300',
        LOCATION_NAME: 'Hare Warren',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3000258,
        LOCATION_LATITUDE_DEG: 51.2901367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034400',
        LOCATION_NAME: 'Hareby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1277115,
        LOCATION_LATITUDE_DEG: 53.1707029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034500',
        LOCATION_NAME: 'Harefield',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4800501,
        LOCATION_LATITUDE_DEG: 51.6038556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA072400',
        LOCATION_NAME: 'Harehills',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA072300',
        LOCATION_NAME: 'Harehills',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5169667,
        LOCATION_LATITUDE_DEG: 53.814534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034100',
        LOCATION_NAME: 'Harelaw',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7274729,
        LOCATION_LATITUDE_DEG: 55.7102051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034700',
        LOCATION_NAME: 'Harescombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2280254,
        LOCATION_LATITUDE_DEG: 51.7919965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034800',
        LOCATION_NAME: 'Haresfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2706851,
        LOCATION_LATITUDE_DEG: 51.7916992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034900',
        LOCATION_NAME: 'Hareshaw',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8972844,
        LOCATION_LATITUDE_DEG: 55.8224112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035000',
        LOCATION_NAME: 'Hareston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.015306,
        LOCATION_LATITUDE_DEG: 50.3654854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035200',
        LOCATION_NAME: 'Harewood',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1889268,
        LOCATION_LATITUDE_DEG: 50.4999936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035100',
        LOCATION_NAME: 'Harewood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.509988,
        LOCATION_LATITUDE_DEG: 53.8996947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035300',
        LOCATION_NAME: 'Harewood End',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6849163,
        LOCATION_LATITUDE_DEG: 51.9380169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035400',
        LOCATION_NAME: 'Harford',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9897613,
        LOCATION_LATITUDE_DEG: 52.0661447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035500',
        LOCATION_NAME: 'Harford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9173295,
        LOCATION_LATITUDE_DEG: 50.4181899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035600',
        LOCATION_NAME: 'Harford Bridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1102101,
        LOCATION_LATITUDE_DEG: 50.5707014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035700',
        LOCATION_NAME: 'Hargrave',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.77072,
        LOCATION_LATITUDE_DEG: 53.1537332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035900',
        LOCATION_NAME: 'Hargrave',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4784291,
        LOCATION_LATITUDE_DEG: 52.3239226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA035800',
        LOCATION_NAME: 'Hargrave',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5904041,
        LOCATION_LATITUDE_DEG: 52.2053029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036000',
        LOCATION_NAME: 'Harker',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9433446,
        LOCATION_LATITUDE_DEG: 54.9384118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036100',
        LOCATION_NAME: 'Harker Park',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9421643,
        LOCATION_LATITUDE_DEG: 54.9380075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036200',
        LOCATION_NAME: 'Harker Road Ends',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9641635,
        LOCATION_LATITUDE_DEG: 54.9401089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036300',
        LOCATION_NAME: 'Harkstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1861959,
        LOCATION_LATITUDE_DEG: 51.9679735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036400',
        LOCATION_NAME: 'Harlaston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6805143,
        LOCATION_LATITUDE_DEG: 52.695977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036500',
        LOCATION_NAME: 'Harlaxton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6850456,
        LOCATION_LATITUDE_DEG: 52.8843849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990461',
        LOCATION_NAME: 'Harle',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036600',
        LOCATION_NAME: 'Harlech',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1043036,
        LOCATION_LATITUDE_DEG: 52.860224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036700',
        LOCATION_NAME: 'Harlescott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7407261,
        LOCATION_LATITUDE_DEG: 52.736791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070700',
        LOCATION_NAME: 'Harlesden',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2451303,
        LOCATION_LATITUDE_DEG: 51.537256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036800',
        LOCATION_NAME: 'Harleston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6959991,
        LOCATION_LATITUDE_DEG: 50.2942674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA036900',
        LOCATION_NAME: 'Harleston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9462872,
        LOCATION_LATITUDE_DEG: 52.2015981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037000',
        LOCATION_NAME: 'Harleston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2997327,
        LOCATION_LATITUDE_DEG: 52.4007131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037100',
        LOCATION_NAME: 'Harlestone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9687169,
        LOCATION_LATITUDE_DEG: 52.2761247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037300',
        LOCATION_NAME: 'Harley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5960868,
        LOCATION_LATITUDE_DEG: 52.6089832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037200',
        LOCATION_NAME: 'Harley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4456272,
        LOCATION_LATITUDE_DEG: 53.4794526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037400',
        LOCATION_NAME: 'Harling Road',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9123661,
        LOCATION_LATITUDE_DEG: 52.4528207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037600',
        LOCATION_NAME: 'Harlington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2750294,
        LOCATION_LATITUDE_DEG: 53.5186514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037500',
        LOCATION_NAME: 'Harlington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4908019,
        LOCATION_LATITUDE_DEG: 51.9624924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037700',
        LOCATION_NAME: 'Harlington',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4336959,
        LOCATION_LATITUDE_DEG: 51.4886459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037900',
        LOCATION_NAME: 'Harlow',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0933768,
        LOCATION_LATITUDE_DEG: 51.7685686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069600',
        LOCATION_NAME: 'Harlow Green',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5905272,
        LOCATION_LATITUDE_DEG: 54.9243779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038000',
        LOCATION_NAME: 'Harlow Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8782908,
        LOCATION_LATITUDE_DEG: 55.0093072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038100',
        LOCATION_NAME: 'Harlthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8658316,
        LOCATION_LATITUDE_DEG: 53.8283752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038200',
        LOCATION_NAME: 'Harlton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0267695,
        LOCATION_LATITUDE_DEG: 52.152206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038300',
        LOCATION_NAME: 'Harmby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8032542,
        LOCATION_LATITUDE_DEG: 54.3014328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038400',
        LOCATION_NAME: 'Harmer Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1803927,
        LOCATION_LATITUDE_DEG: 51.8280743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038500',
        LOCATION_NAME: 'Harmer Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7649983,
        LOCATION_LATITUDE_DEG: 52.7981969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038600',
        LOCATION_NAME: 'Harmondsworth',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4746497,
        LOCATION_LATITUDE_DEG: 51.4882505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038700',
        LOCATION_NAME: 'Harmston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5457116,
        LOCATION_LATITUDE_DEG: 53.1482105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038800',
        LOCATION_NAME: 'Harnage',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6397064,
        LOCATION_LATITUDE_DEG: 52.6336875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA038900',
        LOCATION_NAME: 'Harnham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8078019,
        LOCATION_LATITUDE_DEG: 51.0626233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039000',
        LOCATION_NAME: 'Harnhill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9001608,
        LOCATION_LATITUDE_DEG: 51.7004824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039100',
        LOCATION_NAME: 'Harold Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2291721,
        LOCATION_LATITUDE_DEG: 51.6039489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039200',
        LOCATION_NAME: 'Harold Wood',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2342506,
        LOCATION_LATITUDE_DEG: 51.5929516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039400',
        LOCATION_NAME: 'Haroldston West',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0947301,
        LOCATION_LATITUDE_DEG: 51.7967298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039500',
        LOCATION_NAME: 'Haroldswick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8329995,
        LOCATION_LATITUDE_DEG: 60.789465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039600',
        LOCATION_NAME: 'Harome',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0076655,
        LOCATION_LATITUDE_DEG: 54.2298172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039700',
        LOCATION_NAME: 'Harpenden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3541559,
        LOCATION_LATITUDE_DEG: 51.8148792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039800',
        LOCATION_NAME: 'Harperley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7273988,
        LOCATION_LATITUDE_DEG: 54.8711879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039900',
        LOCATION_NAME: 'Harpford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2873245,
        LOCATION_LATITUDE_DEG: 50.7047043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040000',
        LOCATION_NAME: 'Harpham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3355285,
        LOCATION_LATITUDE_DEG: 54.0397909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040100',
        LOCATION_NAME: 'Harpley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6517509,
        LOCATION_LATITUDE_DEG: 52.8009526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040200',
        LOCATION_NAME: 'Harpole',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9885102,
        LOCATION_LATITUDE_DEG: 52.2418218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040300',
        LOCATION_NAME: 'Harpsden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9009673,
        LOCATION_LATITUDE_DEG: 51.5212583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040400',
        LOCATION_NAME: 'Harpswell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5931727,
        LOCATION_LATITUDE_DEG: 53.3991321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040500',
        LOCATION_NAME: 'Harpswood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4593225,
        LOCATION_LATITUDE_DEG: 52.518568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040600',
        LOCATION_NAME: 'Harpur Hill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9049088,
        LOCATION_LATITUDE_DEG: 53.2369364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069700',
        LOCATION_NAME: 'Harpurhey',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2097062,
        LOCATION_LATITUDE_DEG: 53.5091319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040700',
        LOCATION_NAME: 'Harraby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9036011,
        LOCATION_LATITUDE_DEG: 54.8793047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040800',
        LOCATION_NAME: 'Harracott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0516988,
        LOCATION_LATITUDE_DEG: 51.0215475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA040900',
        LOCATION_NAME: 'Harrapool',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8887286,
        LOCATION_LATITUDE_DEG: 57.2380716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041000',
        LOCATION_NAME: 'Harraton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5366704,
        LOCATION_LATITUDE_DEG: 54.8798853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041100',
        LOCATION_NAME: 'Harray',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1866373,
        LOCATION_LATITUDE_DEG: 59.0400229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041200',
        LOCATION_NAME: 'Harrietsham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6749833,
        LOCATION_LATITUDE_DEG: 51.2427096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA070600',
        LOCATION_NAME: 'Harringay',
        COUNTY_NAME: 'London',
        POSTCODE: 'N4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0914901,
        LOCATION_LATITUDE_DEG: 51.5788262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041500',
        LOCATION_NAME: 'Harrington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5630657,
        LOCATION_LATITUDE_DEG: 54.612682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041300',
        LOCATION_NAME: 'Harrington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8585279,
        LOCATION_LATITUDE_DEG: 52.4145447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041400',
        LOCATION_NAME: 'Harrington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0464834,
        LOCATION_LATITUDE_DEG: 53.2262095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041600',
        LOCATION_NAME: 'Harringworth',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6473554,
        LOCATION_LATITUDE_DEG: 52.5655527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041700',
        LOCATION_NAME: 'Harris Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2417349,
        LOCATION_LATITUDE_DEG: 50.2390854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041800',
        LOCATION_NAME: 'Harriseahead',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.208393,
        LOCATION_LATITUDE_DEG: 53.0989218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042100',
        LOCATION_NAME: 'Harrogate',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5373159,
        LOCATION_LATITUDE_DEG: 53.9927032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042200',
        LOCATION_NAME: 'Harrold',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6089757,
        LOCATION_LATITUDE_DEG: 52.2009209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042300',
        LOCATION_NAME: 'Harrow',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3322705,
        LOCATION_LATITUDE_DEG: 51.5784574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042400',
        LOCATION_NAME: 'Harrow Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5097255,
        LOCATION_LATITUDE_DEG: 51.8478079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042500',
        LOCATION_NAME: 'Harrow Weald',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3387934,
        LOCATION_LATITUDE_DEG: 51.6093607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042700',
        LOCATION_NAME: 'Harrowbarrow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2593263,
        LOCATION_LATITUDE_DEG: 50.5051966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042800',
        LOCATION_NAME: 'Harrowden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4323911,
        LOCATION_LATITUDE_DEG: 52.1140081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042900',
        LOCATION_NAME: 'Harston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7525045,
        LOCATION_LATITUDE_DEG: 52.8773805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043000',
        LOCATION_NAME: 'Harston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0827054,
        LOCATION_LATITUDE_DEG: 52.1378047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043100',
        LOCATION_NAME: 'Harswell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7497708,
        LOCATION_LATITUDE_DEG: 53.8598809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043200',
        LOCATION_NAME: 'Hart',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2721383,
        LOCATION_LATITUDE_DEG: 54.706967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043300',
        LOCATION_NAME: 'Hart Hill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3995975,
        LOCATION_LATITUDE_DEG: 51.887386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043400',
        LOCATION_NAME: 'Hart Village',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2721378,
        LOCATION_LATITUDE_DEG: 54.7078657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043600',
        LOCATION_NAME: 'Hartburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.860174,
        LOCATION_LATITUDE_DEG: 55.1688177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043500',
        LOCATION_NAME: 'Hartburn',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3405513,
        LOCATION_LATITUDE_DEG: 54.5541496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043700',
        LOCATION_NAME: 'Hartcliffe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5945527,
        LOCATION_LATITUDE_DEG: 51.4062685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA043900',
        LOCATION_NAME: 'Hartest',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.682052,
        LOCATION_LATITUDE_DEG: 52.1390916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044000',
        LOCATION_NAME: 'Hartfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1133903,
        LOCATION_LATITUDE_DEG: 51.1036014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044300',
        LOCATION_NAME: 'Hartford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5427183,
        LOCATION_LATITUDE_DEG: 53.2460414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044200',
        LOCATION_NAME: 'Hartford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5785978,
        LOCATION_LATITUDE_DEG: 55.1070125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044100',
        LOCATION_NAME: 'Hartford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1559984,
        LOCATION_LATITUDE_DEG: 52.3371246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044400',
        LOCATION_NAME: 'Hartford Bridge',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6211245,
        LOCATION_LATITUDE_DEG: 55.1139105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044500',
        LOCATION_NAME: 'Hartford End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4496128,
        LOCATION_LATITUDE_DEG: 51.8340653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044600',
        LOCATION_NAME: 'Hartfordbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.886888,
        LOCATION_LATITUDE_DEG: 51.3144393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044700',
        LOCATION_NAME: 'Hartforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7320042,
        LOCATION_LATITUDE_DEG: 54.453052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044800',
        LOCATION_NAME: 'Hartgrove',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2290315,
        LOCATION_LATITUDE_DEG: 50.9667156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA044900',
        LOCATION_NAME: 'Hartham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1972065,
        LOCATION_LATITUDE_DEG: 51.4476637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045000',
        LOCATION_NAME: 'Harthill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7476737,
        LOCATION_LATITUDE_DEG: 55.8605064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045200',
        LOCATION_NAME: 'Harthill',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7448374,
        LOCATION_LATITUDE_DEG: 53.0918292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045100',
        LOCATION_NAME: 'Harthill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.258632,
        LOCATION_LATITUDE_DEG: 53.3197324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045300',
        LOCATION_NAME: 'Hartington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.80694,
        LOCATION_LATITUDE_DEG: 53.1404188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045400',
        LOCATION_NAME: 'Hartlake',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6953679,
        LOCATION_LATITUDE_DEG: 51.1759433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045500',
        LOCATION_NAME: 'Hartland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4782425,
        LOCATION_LATITUDE_DEG: 50.9915436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045700',
        LOCATION_NAME: 'Hartlebury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3790718,
        LOCATION_LATITUDE_DEG: 52.5736791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045600',
        LOCATION_NAME: 'Hartlebury',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2352889,
        LOCATION_LATITUDE_DEG: 52.3358518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045800',
        LOCATION_NAME: 'Hartlepool',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2111342,
        LOCATION_LATITUDE_DEG: 54.6839626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046000',
        LOCATION_NAME: 'Hartley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1247248,
        LOCATION_LATITUDE_DEG: 50.3904874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA045900',
        LOCATION_NAME: 'Hartley',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3349045,
        LOCATION_LATITUDE_DEG: 54.4731621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046100',
        LOCATION_NAME: 'Hartley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3059192,
        LOCATION_LATITUDE_DEG: 51.3849242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046200',
        LOCATION_NAME: 'Hartley Mauditt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9318999,
        LOCATION_LATITUDE_DEG: 51.116017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046300',
        LOCATION_NAME: 'Hartley Wespall',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9994257,
        LOCATION_LATITUDE_DEG: 51.3156347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046400',
        LOCATION_NAME: 'Hartley Wintney',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8997388,
        LOCATION_LATITUDE_DEG: 51.3051359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046500',
        LOCATION_NAME: 'Hartlington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9417891,
        LOCATION_LATITUDE_DEG: 54.0473139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046600',
        LOCATION_NAME: 'Hartlip',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6415454,
        LOCATION_LATITUDE_DEG: 51.3463172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046700',
        LOCATION_NAME: 'Hartmoor',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0071929,
        LOCATION_LATITUDE_DEG: 51.3381547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046800',
        LOCATION_NAME: 'Hartmount Holdings',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0845921,
        LOCATION_LATITUDE_DEG: 57.7716997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047000',
        LOCATION_NAME: 'Harton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7618767,
        LOCATION_LATITUDE_DEG: 52.4924702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA046900',
        LOCATION_NAME: 'Harton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9222795,
        LOCATION_LATITUDE_DEG: 54.0489983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047100',
        LOCATION_NAME: 'Hartpury',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2921299,
        LOCATION_LATITUDE_DEG: 51.9237132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047200',
        LOCATION_NAME: 'Hartshead',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7205928,
        LOCATION_LATITUDE_DEG: 53.6991767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069100',
        LOCATION_NAME: 'Hartshill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2000184,
        LOCATION_LATITUDE_DEG: 53.0129274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047300',
        LOCATION_NAME: 'Hartshill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5185818,
        LOCATION_LATITUDE_DEG: 52.541659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047400',
        LOCATION_NAME: 'Hartshorne',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5240397,
        LOCATION_LATITUDE_DEG: 52.7878854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047500',
        LOCATION_NAME: 'Hartsop',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9117032,
        LOCATION_LATITUDE_DEG: 54.5095657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047800',
        LOCATION_NAME: 'Hartwell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8545183,
        LOCATION_LATITUDE_DEG: 51.8034806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047900',
        LOCATION_NAME: 'Hartwell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8521411,
        LOCATION_LATITUDE_DEG: 52.1458179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048000',
        LOCATION_NAME: 'Hartwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6710298,
        LOCATION_LATITUDE_DEG: 54.0517051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048100',
        LOCATION_NAME: 'Hartwood',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.835966,
        LOCATION_LATITUDE_DEG: 55.8120084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990299',
        LOCATION_NAME: 'Harvington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1861904,
        LOCATION_LATITUDE_DEG: 52.3741879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048200',
        LOCATION_NAME: 'Harvington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9243848,
        LOCATION_LATITUDE_DEG: 52.1427293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048300',
        LOCATION_NAME: 'Harwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.29147,
        LOCATION_LATITUDE_DEG: 51.5965671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048400',
        LOCATION_NAME: 'Harwell',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9681299,
        LOCATION_LATITUDE_DEG: 53.4160419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048500',
        LOCATION_NAME: 'Harwich',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2821789,
        LOCATION_LATITUDE_DEG: 51.9366665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048800',
        LOCATION_NAME: 'Harwood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3754962,
        LOCATION_LATITUDE_DEG: 53.5974699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048600',
        LOCATION_NAME: 'Harwood',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2673601,
        LOCATION_LATITUDE_DEG: 54.693677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048700',
        LOCATION_NAME: 'Harwood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9982398,
        LOCATION_LATITUDE_DEG: 55.2082247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048900',
        LOCATION_NAME: 'Harwood Dale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5191193,
        LOCATION_LATITUDE_DEG: 54.3488194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA048950',
        LOCATION_NAME: 'Harwood on Teviot',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8828449,
        LOCATION_LATITUDE_DEG: 55.3751214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049000',
        LOCATION_NAME: 'Harworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0755463,
        LOCATION_LATITUDE_DEG: 53.4172363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049100',
        LOCATION_NAME: 'Hasbury',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0681995,
        LOCATION_LATITUDE_DEG: 52.4442568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049200',
        LOCATION_NAME: 'Hascombe',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5710402,
        LOCATION_LATITUDE_DEG: 51.1491187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049300',
        LOCATION_NAME: 'Haselbech',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9536794,
        LOCATION_LATITUDE_DEG: 52.3898352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049400',
        LOCATION_NAME: 'Haselbury Plucknett',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7493918,
        LOCATION_LATITUDE_DEG: 50.8930196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049500',
        LOCATION_NAME: 'Haseley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.656444,
        LOCATION_LATITUDE_DEG: 52.3076416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049600',
        LOCATION_NAME: 'Haseley Knob',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6569671,
        LOCATION_LATITUDE_DEG: 52.336739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049700',
        LOCATION_NAME: 'Haselor',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8243118,
        LOCATION_LATITUDE_DEG: 52.2189333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049800',
        LOCATION_NAME: 'Hasfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2538957,
        LOCATION_LATITUDE_DEG: 51.9469109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA049900',
        LOCATION_NAME: 'Hasguard',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1141524,
        LOCATION_LATITUDE_DEG: 51.7432259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050000',
        LOCATION_NAME: 'Hasguard Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1156146,
        LOCATION_LATITUDE_DEG: 51.7537295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050100',
        LOCATION_NAME: 'Haskayne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9683444,
        LOCATION_LATITUDE_DEG: 53.5645737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050200',
        LOCATION_NAME: 'Hasketon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2833898,
        LOCATION_LATITUDE_DEG: 52.1077771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050300',
        LOCATION_NAME: 'Hasland',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4115074,
        LOCATION_LATITUDE_DEG: 53.219924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050400',
        LOCATION_NAME: 'Haslemere',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7102222,
        LOCATION_LATITUDE_DEG: 51.0919095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050500',
        LOCATION_NAME: 'Haslingden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3245872,
        LOCATION_LATITUDE_DEG: 53.6982808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050600',
        LOCATION_NAME: 'Haslingfield',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.053531,
        LOCATION_LATITUDE_DEG: 52.1495037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050700',
        LOCATION_NAME: 'Haslington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3926885,
        LOCATION_LATITUDE_DEG: 53.0999219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050800',
        LOCATION_NAME: 'Hassall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3548002,
        LOCATION_LATITUDE_DEG: 53.1134271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA050900',
        LOCATION_NAME: 'Hassall Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3292308,
        LOCATION_LATITUDE_DEG: 53.1226255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051000',
        LOCATION_NAME: 'Hassingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.498222,
        LOCATION_LATITUDE_DEG: 52.5960273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051100',
        LOCATION_NAME: 'Hassocks',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1595442,
        LOCATION_LATITUDE_DEG: 50.9257878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051200',
        LOCATION_NAME: 'Hassop',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6647198,
        LOCATION_LATITUDE_DEG: 53.2469311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051300',
        LOCATION_NAME: 'Haster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1575522,
        LOCATION_LATITUDE_DEG: 58.443657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051400',
        LOCATION_NAME: 'Hasthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.226884,
        LOCATION_LATITUDE_DEG: 53.2048017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051500',
        LOCATION_NAME: 'Hastingleigh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0003229,
        LOCATION_LATITUDE_DEG: 51.1641917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051700',
        LOCATION_NAME: 'Hastings',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9764305,
        LOCATION_LATITUDE_DEG: 50.9412293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051600',
        LOCATION_NAME: 'Hastings',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5820411,
        LOCATION_LATITUDE_DEG: 50.8552738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051800',
        LOCATION_NAME: 'Hastingwood',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.151559,
        LOCATION_LATITUDE_DEG: 51.7468595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA051900',
        LOCATION_NAME: 'Hastoe',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6694256,
        LOCATION_LATITUDE_DEG: 51.7750754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052000',
        LOCATION_NAME: 'Haswell',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4156517,
        LOCATION_LATITUDE_DEG: 54.7824769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052100',
        LOCATION_NAME: 'Haswell Plough',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4248339,
        LOCATION_LATITUDE_DEG: 54.774279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052200',
        LOCATION_NAME: 'Hatch',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3097182,
        LOCATION_LATITUDE_DEG: 52.1169082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052300',
        LOCATION_NAME: 'Hatch Beauchamp',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9903188,
        LOCATION_LATITUDE_DEG: 50.9778332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052400',
        LOCATION_NAME: 'Hatch End',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3721115,
        LOCATION_LATITUDE_DEG: 51.6074533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052500',
        LOCATION_NAME: 'Hatch Warren',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1211109,
        LOCATION_LATITUDE_DEG: 51.2371302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052600',
        LOCATION_NAME: 'Hatching Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3586549,
        LOCATION_LATITUDE_DEG: 51.8012729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052700',
        LOCATION_NAME: 'Hatcliffe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1687629,
        LOCATION_LATITUDE_DEG: 53.4866386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052800',
        LOCATION_NAME: 'Hateley Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9996755,
        LOCATION_LATITUDE_DEG: 52.5393562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053000',
        LOCATION_NAME: 'Hatfield',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5925279,
        LOCATION_LATITUDE_DEG: 52.2327454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053100',
        LOCATION_NAME: 'Hatfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9993333,
        LOCATION_LATITUDE_DEG: 53.5776575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA052900',
        LOCATION_NAME: 'Hatfield',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2231132,
        LOCATION_LATITUDE_DEG: 51.7622689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053200',
        LOCATION_NAME: 'Hatfield Broad Oak',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.24807,
        LOCATION_LATITUDE_DEG: 51.826769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053300',
        LOCATION_NAME: 'Hatfield Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2112726,
        LOCATION_LATITUDE_DEG: 51.8136707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053400',
        LOCATION_NAME: 'Hatfield Peverel',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5936462,
        LOCATION_LATITUDE_DEG: 51.7747619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053500',
        LOCATION_NAME: 'Hatfield Woodhouse',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9764208,
        LOCATION_LATITUDE_DEG: 53.5700561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053600',
        LOCATION_NAME: 'Hatford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5107317,
        LOCATION_LATITUDE_DEG: 51.6506778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053700',
        LOCATION_NAME: 'Hatherden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5064176,
        LOCATION_LATITUDE_DEG: 51.2508373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053800',
        LOCATION_NAME: 'Hatherleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0681978,
        LOCATION_LATITUDE_DEG: 50.8200294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA053900',
        LOCATION_NAME: 'Hathern',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2543858,
        LOCATION_LATITUDE_DEG: 52.7957849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054000',
        LOCATION_NAME: 'Hatherop',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.771923,
        LOCATION_LATITUDE_DEG: 51.7446889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054100',
        LOCATION_NAME: 'Hathersage',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6549698,
        LOCATION_LATITUDE_DEG: 53.3298344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054300',
        LOCATION_NAME: 'Hatherton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4631218,
        LOCATION_LATITUDE_DEG: 53.0267222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054200',
        LOCATION_NAME: 'Hatherton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0604002,
        LOCATION_LATITUDE_DEG: 52.690683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068800',
        LOCATION_NAME: 'Hatley St George',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054400',
        LOCATION_NAME: 'Hatley St. George',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1317437,
        LOCATION_LATITUDE_DEG: 52.1433044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054500',
        LOCATION_NAME: 'Hatston',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9804802,
        LOCATION_LATITUDE_DEG: 58.9884106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054600',
        LOCATION_NAME: 'Hatt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2571318,
        LOCATION_LATITUDE_DEG: 50.4354887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054700',
        LOCATION_NAME: 'Hattingley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0785522,
        LOCATION_LATITUDE_DEG: 51.1307186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055200',
        LOCATION_NAME: 'Hatton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7842081,
        LOCATION_LATITUDE_DEG: 52.5073756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054900',
        LOCATION_NAME: 'Hatton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.601513,
        LOCATION_LATITUDE_DEG: 53.3366473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA054800',
        LOCATION_NAME: 'Hatton',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9191475,
        LOCATION_LATITUDE_DEG: 57.4251394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055300',
        LOCATION_NAME: 'Hatton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6799864,
        LOCATION_LATITUDE_DEG: 52.8650975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055000',
        LOCATION_NAME: 'Hatton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6489949,
        LOCATION_LATITUDE_DEG: 52.3017394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055100',
        LOCATION_NAME: 'Hatton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.232812,
        LOCATION_LATITUDE_DEG: 53.2761108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055400',
        LOCATION_NAME: 'Hatton Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3519573,
        LOCATION_LATITUDE_DEG: 52.6448805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055500',
        LOCATION_NAME: 'Hatton Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8156026,
        LOCATION_LATITUDE_DEG: 53.1395354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055600',
        LOCATION_NAME: 'HAUGH',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2232178,
        LOCATION_LATITUDE_DEG: 57.4720766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055700',
        LOCATION_NAME: 'Haugh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.121339,
        LOCATION_LATITUDE_DEG: 53.260408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055800',
        LOCATION_NAME: 'Haugh of Urr',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8628268,
        LOCATION_LATITUDE_DEG: 54.9769219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA055900',
        LOCATION_NAME: 'Haugham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.008996,
        LOCATION_LATITUDE_DEG: 53.3148191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056000',
        LOCATION_NAME: 'Haughley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9669843,
        LOCATION_LATITUDE_DEG: 52.2208938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056100',
        LOCATION_NAME: 'Haughley Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9696288,
        LOCATION_LATITUDE_DEG: 52.2390049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056400',
        LOCATION_NAME: 'Haughton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8851353,
        LOCATION_LATITUDE_DEG: 52.9157155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056500',
        LOCATION_NAME: 'Haughton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6636965,
        LOCATION_LATITUDE_DEG: 52.7423898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056300',
        LOCATION_NAME: 'Haughton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6301313,
        LOCATION_LATITUDE_DEG: 53.1023271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056600',
        LOCATION_NAME: 'Haughton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4717548,
        LOCATION_LATITUDE_DEG: 52.5577738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056200',
        LOCATION_NAME: 'Haughton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.200007,
        LOCATION_LATITUDE_DEG: 52.7811912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056700',
        LOCATION_NAME: 'Haughton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9823122,
        LOCATION_LATITUDE_DEG: 53.2441196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056800',
        LOCATION_NAME: 'Haughton Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3778416,
        LOCATION_LATITUDE_DEG: 52.6742815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA056900',
        LOCATION_NAME: 'Haughton Village',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3794939,
        LOCATION_LATITUDE_DEG: 52.6737818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057100',
        LOCATION_NAME: 'Haultwick',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0547038,
        LOCATION_LATITUDE_DEG: 51.8895809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057200',
        LOCATION_NAME: 'Haun',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3004591,
        LOCATION_LATITUDE_DEG: 57.0861662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057300',
        LOCATION_NAME: 'Haunton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6478486,
        LOCATION_LATITUDE_DEG: 52.6947786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057400',
        LOCATION_NAME: 'Hauxton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1053181,
        LOCATION_LATITUDE_DEG: 52.1484015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057500',
        LOCATION_NAME: 'Hauxwell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7416891,
        LOCATION_LATITUDE_DEG: 54.3381416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057600',
        LOCATION_NAME: 'Havannah',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.193169,
        LOCATION_LATITUDE_DEG: 53.1747334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057700',
        LOCATION_NAME: 'Havant',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.981358,
        LOCATION_LATITUDE_DEG: 50.851489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057800',
        LOCATION_NAME: 'Haven Hills',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3917439,
        LOCATION_LATITUDE_DEG: 52.6211816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057900',
        LOCATION_NAME: 'Havens Head',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0451706,
        LOCATION_LATITUDE_DEG: 51.7168173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058000',
        LOCATION_NAME: 'Havenstreet',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2064653,
        LOCATION_LATITUDE_DEG: 50.7088865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058100',
        LOCATION_NAME: 'Havercroft',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4059313,
        LOCATION_LATITUDE_DEG: 53.620766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058200',
        LOCATION_NAME: 'Haverfordwest',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9704062,
        LOCATION_LATITUDE_DEG: 51.8007305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058300',
        LOCATION_NAME: 'Haverhill',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4442596,
        LOCATION_LATITUDE_DEG: 52.0791941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058400',
        LOCATION_NAME: 'Haverigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2869657,
        LOCATION_LATITUDE_DEG: 54.1969445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069300',
        LOCATION_NAME: 'Havering Atte Bower',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058500',
        LOCATION_NAME: 'Havering-Atte-Bower',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1850609,
        LOCATION_LATITUDE_DEG: 51.6153463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990717',
        LOCATION_NAME: 'Haveringland',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058600',
        LOCATION_NAME: 'Haversham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7906919,
        LOCATION_LATITUDE_DEG: 52.0779072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058700',
        LOCATION_NAME: 'Haverthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0118844,
        LOCATION_LATITUDE_DEG: 54.2456458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058800',
        LOCATION_NAME: 'Haverton Hill',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2429408,
        LOCATION_LATITUDE_DEG: 54.5969548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058900',
        LOCATION_NAME: 'Hawarden',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0252889,
        LOCATION_LATITUDE_DEG: 53.1846375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA058950',
        LOCATION_NAME: 'Hawerby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1016189,
        LOCATION_LATITUDE_DEG: 53.4613601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059000',
        LOCATION_NAME: 'Hawes',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1926988,
        LOCATION_LATITUDE_DEG: 54.3036415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059100',
        LOCATION_NAME: 'Hawford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2251359,
        LOCATION_LATITUDE_DEG: 52.2441422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059200',
        LOCATION_NAME: 'Hawick',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7854608,
        LOCATION_LATITUDE_DEG: 55.4225538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059300',
        LOCATION_NAME: 'Hawkchurch',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.931991,
        LOCATION_LATITUDE_DEG: 50.7995096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059400',
        LOCATION_NAME: 'Hawkedon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6264275,
        LOCATION_LATITUDE_DEG: 52.145192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059500',
        LOCATION_NAME: 'Hawkenbury',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5859489,
        LOCATION_LATITUDE_DEG: 51.1758016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059600',
        LOCATION_NAME: 'Hawkeridge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.199606,
        LOCATION_LATITUDE_DEG: 51.281546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059700',
        LOCATION_NAME: 'Hawkers Cove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9477946,
        LOCATION_LATITUDE_DEG: 50.5453051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059800',
        LOCATION_NAME: 'Hawkes End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5621706,
        LOCATION_LATITUDE_DEG: 52.4410475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA059900',
        LOCATION_NAME: 'Hawkesbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3351438,
        LOCATION_LATITUDE_DEG: 51.5804759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060000',
        LOCATION_NAME: 'Hawkesbury Common',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3581188,
        LOCATION_LATITUDE_DEG: 51.5947779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060100',
        LOCATION_NAME: 'Hawkesbury Upton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3174896,
        LOCATION_LATITUDE_DEG: 51.5801742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060200',
        LOCATION_NAME: 'Hawkhead',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3819902,
        LOCATION_LATITUDE_DEG: 55.8333118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060300',
        LOCATION_NAME: 'Hawkhurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5112829,
        LOCATION_LATITUDE_DEG: 51.0469937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060400',
        LOCATION_NAME: 'Hawkinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1655896,
        LOCATION_LATITUDE_DEG: 51.1169933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060500',
        LOCATION_NAME: 'Hawkley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.936283,
        LOCATION_LATITUDE_DEG: 51.0564123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060600',
        LOCATION_NAME: 'Hawkridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6259073,
        LOCATION_LATITUDE_DEG: 51.0636407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060700',
        LOCATION_NAME: 'Hawks Tor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6188641,
        LOCATION_LATITUDE_DEG: 50.5460029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060800',
        LOCATION_NAME: 'Hawksclough',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9879173,
        LOCATION_LATITUDE_DEG: 53.7326808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA060900',
        LOCATION_NAME: 'Hawkshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3645861,
        LOCATION_LATITUDE_DEG: 53.6308811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061000',
        LOCATION_NAME: 'Hawkshead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.996078,
        LOCATION_LATITUDE_DEG: 54.3730571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061100',
        LOCATION_NAME: 'Hawkshead Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0176876,
        LOCATION_LATITUDE_DEG: 54.3796543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061200',
        LOCATION_NAME: 'Hawksland',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8293596,
        LOCATION_LATITUDE_DEG: 55.6393879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA071800',
        LOCATION_NAME: 'Hawksley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9323016,
        LOCATION_LATITUDE_DEG: 52.3956602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061300',
        LOCATION_NAME: 'Hawkswick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0675096,
        LOCATION_LATITUDE_DEG: 54.130022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061500',
        LOCATION_NAME: 'Hawksworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7515469,
        LOCATION_LATITUDE_DEG: 53.8727966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061400',
        LOCATION_NAME: 'Hawksworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8791972,
        LOCATION_LATITUDE_DEG: 52.9826942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA072200',
        LOCATION_NAME: 'Hawksworth Estate',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6155073,
        LOCATION_LATITUDE_DEG: 53.8306481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061700',
        LOCATION_NAME: 'Hawkwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8771492,
        LOCATION_LATITUDE_DEG: 55.0400063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061600',
        LOCATION_NAME: 'Hawkwell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6749685,
        LOCATION_LATITUDE_DEG: 51.5914386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061800',
        LOCATION_NAME: 'Hawkwell Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5183293,
        LOCATION_LATITUDE_DEG: 51.8397045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA061900',
        LOCATION_NAME: 'Hawley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2260643,
        LOCATION_LATITUDE_DEG: 51.4203321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062000',
        LOCATION_NAME: 'Hawley Bottom',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0829091,
        LOCATION_LATITUDE_DEG: 50.797109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062100',
        LOCATION_NAME: 'Hawling',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9070644,
        LOCATION_LATITUDE_DEG: 51.9047064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062200',
        LOCATION_NAME: 'Hawnby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1663138,
        LOCATION_LATITUDE_DEG: 54.2971304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062300',
        LOCATION_NAME: 'Haworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9522416,
        LOCATION_LATITUDE_DEG: 53.8296906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062400',
        LOCATION_NAME: 'Hawridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.598454,
        LOCATION_LATITUDE_DEG: 51.732875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062500',
        LOCATION_NAME: 'Haws Bank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0759065,
        LOCATION_LATITUDE_DEG: 54.358952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062600',
        LOCATION_NAME: 'Hawsker',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5724763,
        LOCATION_LATITUDE_DEG: 54.4559372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062700',
        LOCATION_NAME: 'Hawstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7209106,
        LOCATION_LATITUDE_DEG: 52.197894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062800',
        LOCATION_NAME: 'Hawthorn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3015275,
        LOCATION_LATITUDE_DEG: 51.5829913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063000',
        LOCATION_NAME: 'Hawthorn',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2186121,
        LOCATION_LATITUDE_DEG: 51.4216641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063100',
        LOCATION_NAME: 'Hawthorn',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.347388,
        LOCATION_LATITUDE_DEG: 54.802576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA062900',
        LOCATION_NAME: 'Hawthorn',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.172038,
        LOCATION_LATITUDE_DEG: 51.3614164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063200',
        LOCATION_NAME: 'Hawthorn Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7432153,
        LOCATION_LATITUDE_DEG: 51.4580452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063300',
        LOCATION_NAME: 'Hawthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4467814,
        LOCATION_LATITUDE_DEG: 52.8343751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063400',
        LOCATION_NAME: 'Hawton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8243528,
        LOCATION_LATITUDE_DEG: 53.0509973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063500',
        LOCATION_NAME: 'Haxby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0733643,
        LOCATION_LATITUDE_DEG: 54.0163957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063600',
        LOCATION_NAME: 'Haxey',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8347522,
        LOCATION_LATITUDE_DEG: 53.4883447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063700',
        LOCATION_NAME: 'Haxey Carr',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8494722,
        LOCATION_LATITUDE_DEG: 53.4997428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063800',
        LOCATION_NAME: 'Haxey Junction',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8328255,
        LOCATION_LATITUDE_DEG: 53.488245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA063900',
        LOCATION_NAME: 'Haxton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7852759,
        LOCATION_LATITUDE_DEG: 51.2424362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069400',
        LOCATION_NAME: 'Hay A Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA071600',
        LOCATION_NAME: 'Hay Mills',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.825195,
        LOCATION_LATITUDE_DEG: 52.4634062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069000',
        LOCATION_NAME: 'Hay on Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1273259,
        LOCATION_LATITUDE_DEG: 52.0747094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064000',
        LOCATION_NAME: 'Hay Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0250491,
        LOCATION_LATITUDE_DEG: 51.9164827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064100',
        LOCATION_NAME: 'Hay-A-Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4263487,
        LOCATION_LATITUDE_DEG: 54.0197037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064300',
        LOCATION_NAME: 'Haybridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6694545,
        LOCATION_LATITUDE_DEG: 51.2122467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064400',
        LOCATION_NAME: 'Hayden',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1399816,
        LOCATION_LATITUDE_DEG: 51.9060086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064500',
        LOCATION_NAME: 'Haydock',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6823242,
        LOCATION_LATITUDE_DEG: 53.4742688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064700',
        LOCATION_NAME: 'Haydon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0614158,
        LOCATION_LATITUDE_DEG: 51.0069327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064900',
        LOCATION_NAME: 'Haydon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5918722,
        LOCATION_LATITUDE_DEG: 51.2329531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064600',
        LOCATION_NAME: 'Haydon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4695753,
        LOCATION_LATITUDE_DEG: 50.9402212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064800',
        LOCATION_NAME: 'Haydon',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4503318,
        LOCATION_LATITUDE_DEG: 51.2828556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065000',
        LOCATION_NAME: 'Haydon Bridge',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2469296,
        LOCATION_LATITUDE_DEG: 54.9750019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065100',
        LOCATION_NAME: 'Haydon Wick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8074913,
        LOCATION_LATITUDE_DEG: 51.59317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065200',
        LOCATION_NAME: 'Haye',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3280428,
        LOCATION_LATITUDE_DEG: 50.5053983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065300',
        LOCATION_NAME: 'Haye Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1894272,
        LOCATION_LATITUDE_DEG: 50.6016033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065400',
        LOCATION_NAME: 'Hayes',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4258891,
        LOCATION_LATITUDE_DEG: 51.51705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065500',
        LOCATION_NAME: 'Hayes',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0191209,
        LOCATION_LATITUDE_DEG: 51.3769259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065700',
        LOCATION_NAME: 'Hayesgate',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.712256,
        LOCATION_LATITUDE_DEG: 51.615087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065800',
        LOCATION_NAME: 'Hayfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9445099,
        LOCATION_LATITUDE_DEG: 53.3779477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065900',
        LOCATION_NAME: 'Hayle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4113334,
        LOCATION_LATITUDE_DEG: 50.1886805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066000',
        LOCATION_NAME: 'Hayley Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0805776,
        LOCATION_LATITUDE_DEG: 52.4381621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066100',
        LOCATION_NAME: 'Hayley Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7256666,
        LOCATION_LATITUDE_DEG: 51.430148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066200',
        LOCATION_NAME: 'Hayling Island',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.97369,
        LOCATION_LATITUDE_DEG: 50.7994914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA069500',
        LOCATION_NAME: 'Haymarket',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2172709,
        LOCATION_LATITUDE_DEG: 55.9464365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990949',
        LOCATION_NAME: 'Haymoor Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066300',
        LOCATION_NAME: 'Haynall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6660016,
        LOCATION_LATITUDE_DEG: 52.3014533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066400',
        LOCATION_NAME: 'Haynes',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3961162,
        LOCATION_LATITUDE_DEG: 52.0673978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA064200',
        LOCATION_NAME: 'Hay-on-Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1260947,
        LOCATION_LATITUDE_DEG: 52.0733364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066600',
        LOCATION_NAME: 'Hayscastle',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.073798,
        LOCATION_LATITUDE_DEG: 51.8945337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990877',
        LOCATION_NAME: 'Hayton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066800',
        LOCATION_NAME: 'Hayton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3847915,
        LOCATION_LATITUDE_DEG: 54.7607007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066700',
        LOCATION_NAME: 'Hayton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.904201,
        LOCATION_LATITUDE_DEG: 53.351229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066900',
        LOCATION_NAME: 'Hayton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7520389,
        LOCATION_LATITUDE_DEG: 53.9011845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067000',
        LOCATION_NAME: 'Haytons Bent',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7000322,
        LOCATION_LATITUDE_DEG: 52.4206168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990193',
        LOCATION_NAME: 'Haytor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7402397,
        LOCATION_LATITUDE_DEG: 50.583295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067100',
        LOCATION_NAME: 'Haytor Vale',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.72425,
        LOCATION_LATITUDE_DEG: 50.5825974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067200',
        LOCATION_NAME: 'Haywards Heath',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1097194,
        LOCATION_LATITUDE_DEG: 51.0036921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067300',
        LOCATION_NAME: 'Haywood',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7469501,
        LOCATION_LATITUDE_DEG: 52.0107264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067400',
        LOCATION_NAME: 'Hazel Grove',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1148413,
        LOCATION_LATITUDE_DEG: 53.3770513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067500',
        LOCATION_NAME: 'Hazel Slade',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9646012,
        LOCATION_LATITUDE_DEG: 52.7151387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067600',
        LOCATION_NAME: 'Hazelbank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8500847,
        LOCATION_LATITUDE_DEG: 55.6825967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067700',
        LOCATION_NAME: 'Hazelbury Bryan',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3619261,
        LOCATION_LATITUDE_DEG: 50.8785136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067800',
        LOCATION_NAME: 'Hazeleigh',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6364286,
        LOCATION_LATITUDE_DEG: 51.7025563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990509',
        LOCATION_NAME: 'Hazeley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA067900',
        LOCATION_NAME: 'Hazeley Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9230894,
        LOCATION_LATITUDE_DEG: 51.3195351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068000',
        LOCATION_NAME: 'Hazelwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7917433,
        LOCATION_LATITUDE_DEG: 50.3549782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068100',
        LOCATION_NAME: 'Hazelwood',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5097015,
        LOCATION_LATITUDE_DEG: 53.0103049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068200',
        LOCATION_NAME: 'Hazlehead',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1739952,
        LOCATION_LATITUDE_DEG: 57.1403182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068300',
        LOCATION_NAME: 'Hazlemere',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7109743,
        LOCATION_LATITUDE_DEG: 51.6512681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068400',
        LOCATION_NAME: 'Hazlerigg',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6383663,
        LOCATION_LATITUDE_DEG: 55.0415084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068500',
        LOCATION_NAME: 'Hazleton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8831091,
        LOCATION_LATITUDE_DEG: 51.8592039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990574',
        LOCATION_NAME: 'Hazlewood',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068600',
        LOCATION_NAME: 'Hazlewood',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8625654,
        LOCATION_LATITUDE_DEG: 53.9810028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000100',
        LOCATION_NAME: 'Heacham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4964557,
        LOCATION_LATITUDE_DEG: 52.9088726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000200',
        LOCATION_NAME: 'Headbourne Worthy',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3082314,
        LOCATION_LATITUDE_DEG: 51.0864192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000300',
        LOCATION_NAME: 'Headcorn',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6216925,
        LOCATION_LATITUDE_DEG: 51.1687001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE034000',
        LOCATION_NAME: 'Headingley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5775714,
        LOCATION_LATITUDE_DEG: 53.8238597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000500',
        LOCATION_NAME: 'Headington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.212332,
        LOCATION_LATITUDE_DEG: 51.7640862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000600',
        LOCATION_NAME: 'Headlam',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7215714,
        LOCATION_LATITUDE_DEG: 54.5651624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000700',
        LOCATION_NAME: 'Headlands',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8829514,
        LOCATION_LATITUDE_DEG: 52.1846411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000800',
        LOCATION_NAME: 'Headless Cross',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9446591,
        LOCATION_LATITUDE_DEG: 52.2925464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001050',
        LOCATION_NAME: 'Headley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2567346,
        LOCATION_LATITUDE_DEG: 51.3606354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000900',
        LOCATION_NAME: 'Headley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8203608,
        LOCATION_LATITUDE_DEG: 51.1194147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001000',
        LOCATION_NAME: 'Headley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2729172,
        LOCATION_LATITUDE_DEG: 51.2736266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001100',
        LOCATION_NAME: 'Headley Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7969253,
        LOCATION_LATITUDE_DEG: 51.1172154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033700',
        LOCATION_NAME: 'Headley Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9144087,
        LOCATION_LATITUDE_DEG: 52.3909732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001200',
        LOCATION_NAME: 'Headon',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8761736,
        LOCATION_LATITUDE_DEG: 53.2834248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001300',
        LOCATION_NAME: 'Headon Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8747558,
        LOCATION_LATITUDE_DEG: 53.2894259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001350',
        LOCATION_NAME: 'Headquarters Departments',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001400',
        LOCATION_NAME: 'Heads Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2672285,
        LOCATION_LATITUDE_DEG: 51.3718436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001500',
        LOCATION_NAME: 'Heads Nook',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7865526,
        LOCATION_LATITUDE_DEG: 54.887408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001600',
        LOCATION_NAME: 'Heage',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.448013,
        LOCATION_LATITUDE_DEG: 53.0506078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001800',
        LOCATION_NAME: 'Healaugh',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9727878,
        LOCATION_LATITUDE_DEG: 54.3866455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001700',
        LOCATION_NAME: 'Healaugh',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2433563,
        LOCATION_LATITUDE_DEG: 53.9245946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE001900',
        LOCATION_NAME: 'Heald Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2355346,
        LOCATION_LATITUDE_DEG: 53.3695476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002100',
        LOCATION_NAME: 'Healey',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.166909,
        LOCATION_LATITUDE_DEG: 53.6358774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002300',
        LOCATION_NAME: 'Healey',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9763606,
        LOCATION_LATITUDE_DEG: 54.9208951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002000',
        LOCATION_NAME: 'Healey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7225293,
        LOCATION_LATITUDE_DEG: 54.2206217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002200',
        LOCATION_NAME: 'Healey',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6504595,
        LOCATION_LATITUDE_DEG: 53.7134742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002400',
        LOCATION_NAME: 'Healing',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1610001,
        LOCATION_LATITUDE_DEG: 53.5799425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002500',
        LOCATION_NAME: 'Heamoor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5488895,
        LOCATION_LATITUDE_DEG: 50.1252692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002600',
        LOCATION_NAME: 'Heanish',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8160677,
        LOCATION_LATITUDE_DEG: 56.4946064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002700',
        LOCATION_NAME: 'Heanor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3498387,
        LOCATION_LATITUDE_DEG: 53.0129997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002800',
        LOCATION_NAME: 'Heanton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1386637,
        LOCATION_LATITUDE_DEG: 51.0940213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE002900',
        LOCATION_NAME: 'Heap',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2409383,
        LOCATION_LATITUDE_DEG: 53.5916677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003000',
        LOCATION_NAME: 'Heap Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2675848,
        LOCATION_LATITUDE_DEG: 53.5905684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003100',
        LOCATION_NAME: 'Heapey',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6019901,
        LOCATION_LATITUDE_DEG: 53.6790855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003200',
        LOCATION_NAME: 'Heapham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6797474,
        LOCATION_LATITUDE_DEG: 53.3868332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003300',
        LOCATION_NAME: 'Heasley Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8027649,
        LOCATION_LATITUDE_DEG: 51.0745464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003400',
        LOCATION_NAME: 'Heath',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1984331,
        LOCATION_LATITUDE_DEG: 51.5110852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003600',
        LOCATION_NAME: 'Heath',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4618907,
        LOCATION_LATITUDE_DEG: 53.6766658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003500',
        LOCATION_NAME: 'Heath',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.331578,
        LOCATION_LATITUDE_DEG: 53.1941236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004600',
        LOCATION_NAME: 'Heath and Reach',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6539797,
        LOCATION_LATITUDE_DEG: 51.9436895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003700',
        LOCATION_NAME: 'Heath Charnock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6076244,
        LOCATION_LATITUDE_DEG: 53.6244825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003800',
        LOCATION_NAME: 'Heath Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7124238,
        LOCATION_LATITUDE_DEG: 52.5314761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE003900',
        LOCATION_NAME: 'Heath End',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1859086,
        LOCATION_LATITUDE_DEG: 51.3692475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004000',
        LOCATION_NAME: 'Heath Hayes',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9808388,
        LOCATION_LATITUDE_DEG: 52.6893842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004100',
        LOCATION_NAME: 'Heath Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.350457,
        LOCATION_LATITUDE_DEG: 52.7178898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004300',
        LOCATION_NAME: 'Heath House',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.83119,
        LOCATION_LATITUDE_DEG: 51.2144473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004200',
        LOCATION_NAME: 'Heath House',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4299532,
        LOCATION_LATITUDE_DEG: 51.1092264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004400',
        LOCATION_NAME: 'Heath Park',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1977677,
        LOCATION_LATITUDE_DEG: 51.5727479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004500',
        LOCATION_NAME: 'Heath Town',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1010992,
        LOCATION_LATITUDE_DEG: 52.591577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004700',
        LOCATION_NAME: 'Heathcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5551312,
        LOCATION_LATITUDE_DEG: 52.2691352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004800',
        LOCATION_NAME: 'Heathencote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9617142,
        LOCATION_LATITUDE_DEG: 52.1202174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE004900',
        LOCATION_NAME: 'Heathend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4346904,
        LOCATION_LATITUDE_DEG: 51.6060836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005000',
        LOCATION_NAME: 'Heather',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4225247,
        LOCATION_LATITUDE_DEG: 52.6929782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005100',
        LOCATION_NAME: 'Heatherfield',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1882768,
        LOCATION_LATITUDE_DEG: 57.394086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005500',
        LOCATION_NAME: 'Heathfield',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.156713,
        LOCATION_LATITUDE_DEG: 50.5875067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005600',
        LOCATION_NAME: 'Heathfield',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.653818,
        LOCATION_LATITUDE_DEG: 50.5702978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005200',
        LOCATION_NAME: 'Heathfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2840811,
        LOCATION_LATITUDE_DEG: 54.7831021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005400',
        LOCATION_NAME: 'Heathfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1997474,
        LOCATION_LATITUDE_DEG: 51.0317386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005300',
        LOCATION_NAME: 'Heathfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2580131,
        LOCATION_LATITUDE_DEG: 50.9662913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005700',
        LOCATION_NAME: 'Heathhall',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5822171,
        LOCATION_LATITUDE_DEG: 55.0980327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE990648',
        LOCATION_NAME: 'Heathrow',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005800',
        LOCATION_NAME: 'Heathton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2738879,
        LOCATION_LATITUDE_DEG: 52.5273691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE005900',
        LOCATION_NAME: 'Heathwaen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.987738,
        LOCATION_LATITUDE_DEG: 52.7863023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033800',
        LOCATION_NAME: 'Heaton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7869961,
        LOCATION_LATITUDE_DEG: 53.817322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006000',
        LOCATION_NAME: 'Heaton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5762277,
        LOCATION_LATITUDE_DEG: 54.9886964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006100',
        LOCATION_NAME: 'Heaton Chapel',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1818441,
        LOCATION_LATITUDE_DEG: 53.4330543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006200',
        LOCATION_NAME: 'Heaton Mersey',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2107238,
        LOCATION_LATITUDE_DEG: 53.4132567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006300',
        LOCATION_NAME: 'Heaton Moor',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1839634,
        LOCATION_LATITUDE_DEG: 53.42185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006400',
        LOCATION_NAME: 'Heaton Norris',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1864394,
        LOCATION_LATITUDE_DEG: 53.413351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006500',
        LOCATION_NAME: 'Heaton With Oxcliffe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8500098,
        LOCATION_LATITUDE_DEG: 54.0492232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006600',
        LOCATION_NAME: 'Heaves',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7710659,
        LOCATION_LATITUDE_DEG: 54.2733408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006700',
        LOCATION_NAME: 'Heavitree',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5033536,
        LOCATION_LATITUDE_DEG: 50.7199091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006800',
        LOCATION_NAME: 'Hebburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5088544,
        LOCATION_LATITUDE_DEG: 54.9740004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE006900',
        LOCATION_NAME: 'Hebden',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9603925,
        LOCATION_LATITUDE_DEG: 54.06431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007000',
        LOCATION_NAME: 'Hebden Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0107808,
        LOCATION_LATITUDE_DEG: 53.7404835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE991029',
        LOCATION_NAME: 'Hebing End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.098199,
        LOCATION_LATITUDE_DEG: 51.881181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007250',
        LOCATION_NAME: 'Hebron',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6465303,
        LOCATION_LATITUDE_DEG: 51.9230938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007100',
        LOCATION_NAME: 'Hebron',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3006889,
        LOCATION_LATITUDE_DEG: 52.000038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007200',
        LOCATION_NAME: 'Hebron',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6950429,
        LOCATION_LATITUDE_DEG: 55.2012202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007300',
        LOCATION_NAME: 'Heck',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4166216,
        LOCATION_LATITUDE_DEG: 55.1074323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007400',
        LOCATION_NAME: 'Heckdyke',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7970245,
        LOCATION_LATITUDE_DEG: 53.455238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007500',
        LOCATION_NAME: 'Heckfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9595413,
        LOCATION_LATITUDE_DEG: 51.3386422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007600',
        LOCATION_NAME: 'Heckfield Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9631973,
        LOCATION_LATITUDE_DEG: 51.3452396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007700',
        LOCATION_NAME: 'Heckfordbridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.82661,
        LOCATION_LATITUDE_DEG: 51.8601611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007800',
        LOCATION_NAME: 'Heckingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5180034,
        LOCATION_LATITUDE_DEG: 52.5343176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE007900',
        LOCATION_NAME: 'Heckington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2980114,
        LOCATION_LATITUDE_DEG: 52.9819885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008000',
        LOCATION_NAME: 'Heckington Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2554636,
        LOCATION_LATITUDE_DEG: 52.9915859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008100',
        LOCATION_NAME: 'Heckmondwike',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6685519,
        LOCATION_LATITUDE_DEG: 53.7077726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008200',
        LOCATION_NAME: 'Heddington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0018975,
        LOCATION_LATITUDE_DEG: 51.3951597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008300',
        LOCATION_NAME: 'Heddon Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1502091,
        LOCATION_LATITUDE_DEG: 51.1356606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032900',
        LOCATION_NAME: 'Heddon on the Wall',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008400',
        LOCATION_NAME: 'Heddon-on-the-Wall',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7919544,
        LOCATION_LATITUDE_DEG: 54.9972013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008500',
        LOCATION_NAME: 'Hedenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4043827,
        LOCATION_LATITUDE_DEG: 52.4898169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008600',
        LOCATION_NAME: 'Hedge End',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3028851,
        LOCATION_LATITUDE_DEG: 50.9118073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008700',
        LOCATION_NAME: 'Hedgerley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6020098,
        LOCATION_LATITUDE_DEG: 51.5747595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008800',
        LOCATION_NAME: 'Hedley Hill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7695192,
        LOCATION_LATITUDE_DEG: 54.7707768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE008900',
        LOCATION_NAME: 'Hedley Hope',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7517827,
        LOCATION_LATITUDE_DEG: 54.7604241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009000',
        LOCATION_NAME: 'Hedley On The Hill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8739644,
        LOCATION_LATITUDE_DEG: 54.9277972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009100',
        LOCATION_NAME: 'Hednesford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9942416,
        LOCATION_LATITUDE_DEG: 52.7090842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009200',
        LOCATION_NAME: 'Hedon',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1970324,
        LOCATION_LATITUDE_DEG: 53.7412599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009250',
        LOCATION_NAME: 'Hedworth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4912225,
        LOCATION_LATITUDE_DEG: 54.9585415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009300',
        LOCATION_NAME: 'Heelands',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7738458,
        LOCATION_LATITUDE_DEG: 52.0525012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009400',
        LOCATION_NAME: 'Heeley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4719148,
        LOCATION_LATITUDE_DEG: 53.3575365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009600',
        LOCATION_NAME: 'Heighington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6152895,
        LOCATION_LATITUDE_DEG: 54.5952594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009500',
        LOCATION_NAME: 'Heighington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4580835,
        LOCATION_LATITUDE_DEG: 53.2114106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009700',
        LOCATION_NAME: 'Heightington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3505012,
        LOCATION_LATITUDE_DEG: 52.34195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009800',
        LOCATION_NAME: 'Heights',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4643879,
        LOCATION_LATITUDE_DEG: 54.5278668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010000',
        LOCATION_NAME: 'Heiton',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4554564,
        LOCATION_LATITUDE_DEG: 55.5679678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010100',
        LOCATION_NAME: 'Heldre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.050658,
        LOCATION_LATITUDE_DEG: 52.6863931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010500',
        LOCATION_NAME: 'Hele',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0987498,
        LOCATION_LATITUDE_DEG: 51.2076596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010300',
        LOCATION_NAME: 'Hele',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5367595,
        LOCATION_LATITUDE_DEG: 50.4824859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010200',
        LOCATION_NAME: 'Hele',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4292561,
        LOCATION_LATITUDE_DEG: 50.8126179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010400',
        LOCATION_NAME: 'Hele',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1593164,
        LOCATION_LATITUDE_DEG: 51.0153377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010600',
        LOCATION_NAME: 'Helens Bay',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.732168,
        LOCATION_LATITUDE_DEG: 54.6499066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010700',
        LOCATION_NAME: 'Helensburgh',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7315753,
        LOCATION_LATITUDE_DEG: 56.0049367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010800',
        LOCATION_NAME: 'Helensfield',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7488146,
        LOCATION_LATITUDE_DEG: 56.1170335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE010900',
        LOCATION_NAME: 'Helford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1348081,
        LOCATION_LATITUDE_DEG: 50.0918623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011000',
        LOCATION_NAME: 'Helford Passage',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1287104,
        LOCATION_LATITUDE_DEG: 50.0993685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011100',
        LOCATION_NAME: 'Helhoughton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7712887,
        LOCATION_LATITUDE_DEG: 52.8032557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011200',
        LOCATION_NAME: 'Helions Bumpstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4068365,
        LOCATION_LATITUDE_DEG: 52.0477855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011300',
        LOCATION_NAME: 'Hellaby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2444851,
        LOCATION_LATITUDE_DEG: 53.4227396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011400',
        LOCATION_NAME: 'Helland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7140982,
        LOCATION_LATITUDE_DEG: 50.5062987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE990157',
        LOCATION_NAME: 'Hellandbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011500',
        LOCATION_NAME: 'Hellandbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7289785,
        LOCATION_LATITUDE_DEG: 50.5091982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011600',
        LOCATION_NAME: 'Hellescott',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4304383,
        LOCATION_LATITUDE_DEG: 50.6706114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011700',
        LOCATION_NAME: 'Hellesdon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2796714,
        LOCATION_LATITUDE_DEG: 52.6613374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011800',
        LOCATION_NAME: 'Hellesveor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5005286,
        LOCATION_LATITUDE_DEG: 50.2071772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE011900',
        LOCATION_NAME: 'Hellidon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.241018,
        LOCATION_LATITUDE_DEG: 52.2177297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012000',
        LOCATION_NAME: 'Hellifield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2190843,
        LOCATION_LATITUDE_DEG: 54.0043154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012100',
        LOCATION_NAME: 'Hellingly',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2481553,
        LOCATION_LATITUDE_DEG: 50.8874802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012200',
        LOCATION_NAME: 'Hellington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4148313,
        LOCATION_LATITUDE_DEG: 52.5785218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012300',
        LOCATION_NAME: 'Helmdon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1422924,
        LOCATION_LATITUDE_DEG: 52.0898112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012400',
        LOCATION_NAME: 'Helmingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2050656,
        LOCATION_LATITUDE_DEG: 52.1727914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012500',
        LOCATION_NAME: 'Helmington Row',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7146529,
        LOCATION_LATITUDE_DEG: 54.711872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012600',
        LOCATION_NAME: 'Helmsdale',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6494193,
        LOCATION_LATITUDE_DEG: 58.1178354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012700',
        LOCATION_NAME: 'Helmshore',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.327037,
        LOCATION_LATITUDE_DEG: 53.6879815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012800',
        LOCATION_NAME: 'Helmsley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0610991,
        LOCATION_LATITUDE_DEG: 54.2462183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE012900',
        LOCATION_NAME: 'Helperby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3259566,
        LOCATION_LATITUDE_DEG: 54.1214124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013000',
        LOCATION_NAME: 'Helperthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5393195,
        LOCATION_LATITUDE_DEG: 54.1203963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013100',
        LOCATION_NAME: 'Helpringham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3043299,
        LOCATION_LATITUDE_DEG: 52.9518859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013200',
        LOCATION_NAME: 'Helpringham Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2545752,
        LOCATION_LATITUDE_DEG: 52.9178791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013300',
        LOCATION_NAME: 'Helpston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3412615,
        LOCATION_LATITUDE_DEG: 52.6350507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013400',
        LOCATION_NAME: 'Helsby',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7677395,
        LOCATION_LATITUDE_DEG: 53.272449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013500',
        LOCATION_NAME: 'Helsey',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2768407,
        LOCATION_LATITUDE_DEG: 53.2321008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013600',
        LOCATION_NAME: 'Helsington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7837674,
        LOCATION_LATITUDE_DEG: 54.3081434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013700',
        LOCATION_NAME: 'Helston',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2707624,
        LOCATION_LATITUDE_DEG: 50.1017658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013800',
        LOCATION_NAME: 'Helstone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7002454,
        LOCATION_LATITUDE_DEG: 50.5999084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE013900',
        LOCATION_NAME: 'Helton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7575667,
        LOCATION_LATITUDE_DEG: 54.5917745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014000',
        LOCATION_NAME: 'Hem Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1785864,
        LOCATION_LATITUDE_DEG: 52.9669135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE990400',
        LOCATION_NAME: 'Hembleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014100',
        LOCATION_NAME: 'Hemblington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4767698,
        LOCATION_LATITUDE_DEG: 52.6485257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014200',
        LOCATION_NAME: 'Hemel Hempstead',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4698874,
        LOCATION_LATITUDE_DEG: 51.7487712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014300',
        LOCATION_NAME: 'Hemerdon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0155094,
        LOCATION_LATITUDE_DEG: 50.399484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014400',
        LOCATION_NAME: 'Hemford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9937494,
        LOCATION_LATITUDE_DEG: 52.5929806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014500',
        LOCATION_NAME: 'Hemingbrough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9775065,
        LOCATION_LATITUDE_DEG: 53.7670732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014600',
        LOCATION_NAME: 'Hemingby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1456833,
        LOCATION_LATITUDE_DEG: 53.2527142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014700',
        LOCATION_NAME: 'Hemingfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4066146,
        LOCATION_LATITUDE_DEG: 53.5083556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014800',
        LOCATION_NAME: 'Hemingford Abbots',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1177973,
        LOCATION_LATITUDE_DEG: 52.322323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE014900',
        LOCATION_NAME: 'Hemingford Grey',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.098552,
        LOCATION_LATITUDE_DEG: 52.3173206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015000',
        LOCATION_NAME: 'Hemingstone',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1438663,
        LOCATION_LATITUDE_DEG: 52.1397826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015300',
        LOCATION_NAME: 'Hemington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3899541,
        LOCATION_LATITUDE_DEG: 51.2753473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015200',
        LOCATION_NAME: 'Hemington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3234912,
        LOCATION_LATITUDE_DEG: 52.8473917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015100',
        LOCATION_NAME: 'Hemington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3953972,
        LOCATION_LATITUDE_DEG: 52.4535411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015400',
        LOCATION_NAME: 'Hemley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3317826,
        LOCATION_LATITUDE_DEG: 52.0318736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015500',
        LOCATION_NAME: 'Hemlington',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2363618,
        LOCATION_LATITUDE_DEG: 54.5249455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015600',
        LOCATION_NAME: 'Hempholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3397958,
        LOCATION_LATITUDE_DEG: 53.9368797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015700',
        LOCATION_NAME: 'Hempmill Brook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4283862,
        LOCATION_LATITUDE_DEG: 52.9146081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015800',
        LOCATION_NAME: 'Hempnall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3003025,
        LOCATION_LATITUDE_DEG: 52.5002167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE015900',
        LOCATION_NAME: 'Hempnall Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.313383,
        LOCATION_LATITUDE_DEG: 52.4856209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016100',
        LOCATION_NAME: 'Hempstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3806221,
        LOCATION_LATITUDE_DEG: 52.0161843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016200',
        LOCATION_NAME: 'Hempstead',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5742524,
        LOCATION_LATITUDE_DEG: 51.3460172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016000',
        LOCATION_NAME: 'Hempstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1295641,
        LOCATION_LATITUDE_DEG: 52.8891567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016250',
        LOCATION_NAME: 'Hempstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5616858,
        LOCATION_LATITUDE_DEG: 52.7984527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016300',
        LOCATION_NAME: 'Hempsted',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2666967,
        LOCATION_LATITUDE_DEG: 51.8481064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016400',
        LOCATION_NAME: 'Hempton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3521468,
        LOCATION_LATITUDE_DEG: 51.9828087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016500',
        LOCATION_NAME: 'Hempton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.838777,
        LOCATION_LATITUDE_DEG: 52.8257529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016600',
        LOCATION_NAME: 'Hemsby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6937365,
        LOCATION_LATITUDE_DEG: 52.6968355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016700',
        LOCATION_NAME: 'Hemswell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.594799,
        LOCATION_LATITUDE_DEG: 53.4059301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016800',
        LOCATION_NAME: 'Hemswell Cliff',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5753288,
        LOCATION_LATITUDE_DEG: 53.3956301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016900',
        LOCATION_NAME: 'Hemsworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4510792,
        LOCATION_LATITUDE_DEG: 53.3406406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017000',
        LOCATION_NAME: 'Hemsworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.351973,
        LOCATION_LATITUDE_DEG: 53.6134653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017100',
        LOCATION_NAME: 'Hemyock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2270903,
        LOCATION_LATITUDE_DEG: 50.9123235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017300',
        LOCATION_NAME: 'Henbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6272427,
        LOCATION_LATITUDE_DEG: 51.5065735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017200',
        LOCATION_NAME: 'Henbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.180645,
        LOCATION_LATITUDE_DEG: 53.2601391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017400',
        LOCATION_NAME: 'Hendon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3720221,
        LOCATION_LATITUDE_DEG: 54.8944876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033500',
        LOCATION_NAME: 'Hendon',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2241963,
        LOCATION_LATITUDE_DEG: 51.5878435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017500',
        LOCATION_NAME: 'Hendra Croft',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0983395,
        LOCATION_LATITUDE_DEG: 50.3518887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017600',
        LOCATION_NAME: 'Hendra Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8782967,
        LOCATION_LATITUDE_DEG: 50.3769888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017700',
        LOCATION_NAME: 'Hendra Prazey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8842865,
        LOCATION_LATITUDE_DEG: 50.3831917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017900',
        LOCATION_NAME: 'Hendre',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5280071,
        LOCATION_LATITUDE_DEG: 51.5254838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE017800',
        LOCATION_NAME: 'Hendre',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2152908,
        LOCATION_LATITUDE_DEG: 53.1998428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018000',
        LOCATION_NAME: 'Hendreforgan',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4689304,
        LOCATION_LATITUDE_DEG: 51.5833895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018100',
        LOCATION_NAME: 'Hendrerwydd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3139047,
        LOCATION_LATITUDE_DEG: 53.1603433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018200',
        LOCATION_NAME: 'Hendy',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0563211,
        LOCATION_LATITUDE_DEG: 51.7123121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018300',
        LOCATION_NAME: 'Henfield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2706169,
        LOCATION_LATITUDE_DEG: 50.9319922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018400',
        LOCATION_NAME: 'Henfynyw',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2487838,
        LOCATION_LATITUDE_DEG: 52.2329591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018600',
        LOCATION_NAME: 'Hengoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2324998,
        LOCATION_LATITUDE_DEG: 51.6517941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018500',
        LOCATION_NAME: 'Hengoed',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0630393,
        LOCATION_LATITUDE_DEG: 52.8919148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018700',
        LOCATION_NAME: 'Hengrave',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6799365,
        LOCATION_LATITUDE_DEG: 52.2843097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018800',
        LOCATION_NAME: 'Hengrove',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5698435,
        LOCATION_LATITUDE_DEG: 51.4207706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE990670',
        LOCATION_NAME: 'Henham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.247863,
        LOCATION_LATITUDE_DEG: 51.9332838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE018900',
        LOCATION_NAME: 'Henham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2484934,
        LOCATION_LATITUDE_DEG: 51.9333796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019000',
        LOCATION_NAME: 'Henhull',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5397905,
        LOCATION_LATITUDE_DEG: 53.0763219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019100',
        LOCATION_NAME: 'Henlade',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0414023,
        LOCATION_LATITUDE_DEG: 51.0063304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019200',
        LOCATION_NAME: 'Henleaze',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6027461,
        LOCATION_LATITUDE_DEG: 51.4869721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019400',
        LOCATION_NAME: 'Henley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8116152,
        LOCATION_LATITUDE_DEG: 51.0872405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019800',
        LOCATION_NAME: 'Henley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7944767,
        LOCATION_LATITUDE_DEG: 50.8650121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019900',
        LOCATION_NAME: 'Henley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6730199,
        LOCATION_LATITUDE_DEG: 52.3831631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019500',
        LOCATION_NAME: 'Henley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4309473,
        LOCATION_LATITUDE_DEG: 50.8374126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019300',
        LOCATION_NAME: 'Henley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5277509,
        LOCATION_LATITUDE_DEG: 51.3281473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019700',
        LOCATION_NAME: 'Henley',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7254896,
        LOCATION_LATITUDE_DEG: 51.0212069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE019600',
        LOCATION_NAME: 'Henley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1519902,
        LOCATION_LATITUDE_DEG: 52.117582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020000',
        LOCATION_NAME: 'Henley Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7998315,
        LOCATION_LATITUDE_DEG: 52.4864743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033000',
        LOCATION_NAME: 'Henley in Arden',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033100',
        LOCATION_NAME: 'Henley on Thames',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020100',
        LOCATION_NAME: 'Henley-in-Arden',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7783863,
        LOCATION_LATITUDE_DEG: 52.2927381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020200',
        LOCATION_NAME: 'Henley-on-Thames',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9031223,
        LOCATION_LATITUDE_DEG: 51.5371598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020300',
        LOCATION_NAME: 'Henllan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3985105,
        LOCATION_LATITUDE_DEG: 52.0350406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020400',
        LOCATION_NAME: 'Henllan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4620025,
        LOCATION_LATITUDE_DEG: 53.2009458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020500',
        LOCATION_NAME: 'Henllan Amgoed',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6425498,
        LOCATION_LATITUDE_DEG: 51.8486304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020600',
        LOCATION_NAME: 'Henlle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9965365,
        LOCATION_LATITUDE_DEG: 52.8922126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020700',
        LOCATION_NAME: 'Henllys',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0571054,
        LOCATION_LATITUDE_DEG: 51.6384952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020800',
        LOCATION_NAME: 'Henlow',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2841911,
        LOCATION_LATITUDE_DEG: 52.0291942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE020900',
        LOCATION_NAME: 'Henlow Camp',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2818833,
        LOCATION_LATITUDE_DEG: 52.0159953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021000',
        LOCATION_NAME: 'Hennock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6497099,
        LOCATION_LATITUDE_DEG: 50.6136023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021100',
        LOCATION_NAME: 'Hennor',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6603223,
        LOCATION_LATITUDE_DEG: 52.220346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021200',
        LOCATION_NAME: 'Henryd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8436509,
        LOCATION_LATITUDE_DEG: 53.2560535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021300',
        LOCATION_NAME: 'Hensall',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1052295,
        LOCATION_LATITUDE_DEG: 53.7037661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021400',
        LOCATION_NAME: 'Henshaw',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3686993,
        LOCATION_LATITUDE_DEG: 54.9741096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021500',
        LOCATION_NAME: 'Hensingham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5555883,
        LOCATION_LATITUDE_DEG: 54.5355813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021600',
        LOCATION_NAME: 'Hensleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5149433,
        LOCATION_LATITUDE_DEG: 50.9011271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021700',
        LOCATION_NAME: 'Hensol',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3770191,
        LOCATION_LATITUDE_DEG: 51.5073798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021800',
        LOCATION_NAME: 'Henstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6684965,
        LOCATION_LATITUDE_DEG: 52.4145075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE021900',
        LOCATION_NAME: 'Henstridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3919458,
        LOCATION_LATITUDE_DEG: 50.9746195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022000',
        LOCATION_NAME: 'Hentland',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6598394,
        LOCATION_LATITUDE_DEG: 51.9343206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022100',
        LOCATION_NAME: 'Henton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7212011,
        LOCATION_LATITUDE_DEG: 51.2049516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022200',
        LOCATION_NAME: 'Henton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.898692,
        LOCATION_LATITUDE_DEG: 51.7204703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022300',
        LOCATION_NAME: 'Henwick',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2667201,
        LOCATION_LATITUDE_DEG: 51.4099521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022400',
        LOCATION_NAME: 'Henwood',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4472929,
        LOCATION_LATITUDE_DEG: 50.5338061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033200',
        LOCATION_NAME: 'Heol y Cyw',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022600',
        LOCATION_NAME: 'Heolgerrig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4020126,
        LOCATION_LATITUDE_DEG: 51.7442093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022500',
        LOCATION_NAME: 'Heol-y-Cyw',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5211873,
        LOCATION_LATITUDE_DEG: 51.5470931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022700',
        LOCATION_NAME: 'Hepple',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0263524,
        LOCATION_LATITUDE_DEG: 55.2992317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022800',
        LOCATION_NAME: 'Hepscott',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6503199,
        LOCATION_LATITUDE_DEG: 55.15142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE022900',
        LOCATION_NAME: 'Heptonstall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0192911,
        LOCATION_LATITUDE_DEG: 53.7488872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023000',
        LOCATION_NAME: 'Hepworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7546472,
        LOCATION_LATITUDE_DEG: 53.5581644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023100',
        LOCATION_NAME: 'Hepworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.914193,
        LOCATION_LATITUDE_DEG: 52.3353127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023300',
        LOCATION_NAME: 'Herbrandston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0839685,
        LOCATION_LATITUDE_DEG: 51.7266258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023400',
        LOCATION_NAME: 'Herbusta',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3571492,
        LOCATION_LATITUDE_DEG: 57.654515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023500',
        LOCATION_NAME: 'Hereford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7162069,
        LOCATION_LATITUDE_DEG: 52.0556248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023600',
        LOCATION_NAME: 'Heriot',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.965442,
        LOCATION_LATITUDE_DEG: 55.7652897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023700',
        LOCATION_NAME: 'Hermiston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.312646,
        LOCATION_LATITUDE_DEG: 55.9187128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023900',
        LOCATION_NAME: 'Hermitage',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5011406,
        LOCATION_LATITUDE_DEG: 50.8601108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023800',
        LOCATION_NAME: 'Hermitage',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2673204,
        LOCATION_LATITUDE_DEG: 51.4542543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024200',
        LOCATION_NAME: 'Hermon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.410359,
        LOCATION_LATITUDE_DEG: 53.1924536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024100',
        LOCATION_NAME: 'Hermon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.382005,
        LOCATION_LATITUDE_DEG: 51.9508355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024300',
        LOCATION_NAME: 'Herne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.13487,
        LOCATION_LATITUDE_DEG: 51.3497159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024400',
        LOCATION_NAME: 'Herne Bay',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1280193,
        LOCATION_LATITUDE_DEG: 51.3708141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024500',
        LOCATION_NAME: 'Herne Common',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1299814,
        LOCATION_LATITUDE_DEG: 51.342911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033600',
        LOCATION_NAME: 'Herne Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1011049,
        LOCATION_LATITUDE_DEG: 51.4578565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024600',
        LOCATION_NAME: 'Hernhill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9631933,
        LOCATION_LATITUDE_DEG: 51.3079066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024700',
        LOCATION_NAME: 'Hernis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1726825,
        LOCATION_LATITUDE_DEG: 50.1650763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024800',
        LOCATION_NAME: 'Hernstone',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5720375,
        LOCATION_LATITUDE_DEG: 51.4961865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024900',
        LOCATION_NAME: 'Herodsfoot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5138163,
        LOCATION_LATITUDE_DEG: 50.4161903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025000',
        LOCATION_NAME: 'Herongate',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3520219,
        LOCATION_LATITUDE_DEG: 51.5954437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025100',
        LOCATION_NAME: 'Herons Ghyll',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0923959,
        LOCATION_LATITUDE_DEG: 51.0163913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025200',
        LOCATION_NAME: 'Heronsford',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9494871,
        LOCATION_LATITUDE_DEG: 55.10935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025300',
        LOCATION_NAME: 'Heronsgate',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.518968,
        LOCATION_LATITUDE_DEG: 51.6416651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025400',
        LOCATION_NAME: 'Herriard',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0423253,
        LOCATION_LATITUDE_DEG: 51.2029315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025500',
        LOCATION_NAME: 'Herringfleet',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6524243,
        LOCATION_LATITUDE_DEG: 52.5205168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025550',
        LOCATION_NAME: 'Herringston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4382243,
        LOCATION_LATITUDE_DEG: 50.6861295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025600',
        LOCATION_NAME: 'Herringswell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5173422,
        LOCATION_LATITUDE_DEG: 52.3010112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025700',
        LOCATION_NAME: 'Herrington Burn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4826132,
        LOCATION_LATITUDE_DEG: 54.8663835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025800',
        LOCATION_NAME: 'Herrington Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4577239,
        LOCATION_LATITUDE_DEG: 54.8631833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE025900',
        LOCATION_NAME: 'Hersden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1634683,
        LOCATION_LATITUDE_DEG: 51.3138089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026100',
        LOCATION_NAME: 'Hersham',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4734369,
        LOCATION_LATITUDE_DEG: 50.841535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026000',
        LOCATION_NAME: 'Hersham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.397845,
        LOCATION_LATITUDE_DEG: 51.3651318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE990320',
        LOCATION_NAME: 'Hersham Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3986338,
        LOCATION_LATITUDE_DEG: 51.365997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026200',
        LOCATION_NAME: 'Herstmonceux',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3213503,
        LOCATION_LATITUDE_DEG: 50.8903825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026300',
        LOCATION_NAME: 'Hertburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5142214,
        LOCATION_LATITUDE_DEG: 54.9111909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026400',
        LOCATION_NAME: 'Hertford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0772498,
        LOCATION_LATITUDE_DEG: 51.7954692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026500',
        LOCATION_NAME: 'Hertford Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0439918,
        LOCATION_LATITUDE_DEG: 51.7857653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026600',
        LOCATION_NAME: 'Hertingfordbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1035066,
        LOCATION_LATITUDE_DEG: 51.7901671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026700',
        LOCATION_NAME: 'Heselton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7053279,
        LOCATION_LATITUDE_DEG: 54.3206391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026800',
        LOCATION_NAME: 'Hesket Newmarket',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0255162,
        LOCATION_LATITUDE_DEG: 54.7379893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE026900',
        LOCATION_NAME: 'Hesketh Bank',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8394051,
        LOCATION_LATITUDE_DEG: 53.7026926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027000',
        LOCATION_NAME: 'Hesketh Lane',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5857402,
        LOCATION_LATITUDE_DEG: 53.8673998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027100',
        LOCATION_NAME: 'Heskin',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7097568,
        LOCATION_LATITUDE_DEG: 53.603802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027200',
        LOCATION_NAME: 'Hesleden',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3145099,
        LOCATION_LATITUDE_DEG: 54.7365683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027300',
        LOCATION_NAME: 'Heslerton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6040847,
        LOCATION_LATITUDE_DEG: 54.170804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027400',
        LOCATION_NAME: 'Hesley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0684454,
        LOCATION_LATITUDE_DEG: 53.452943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027500',
        LOCATION_NAME: 'Hesleyside',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2898834,
        LOCATION_LATITUDE_DEG: 55.1486201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027600',
        LOCATION_NAME: 'Heslington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0442148,
        LOCATION_LATITUDE_DEG: 53.9455938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027700',
        LOCATION_NAME: 'Hessay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2019113,
        LOCATION_LATITUDE_DEG: 53.9734964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027800',
        LOCATION_NAME: 'Hessenford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.381249,
        LOCATION_LATITUDE_DEG: 50.3917867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE027900',
        LOCATION_NAME: 'Hessett',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.834818,
        LOCATION_LATITUDE_DEG: 52.2190991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028000',
        LOCATION_NAME: 'Hessle',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4362518,
        LOCATION_LATITUDE_DEG: 53.7264605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028100',
        LOCATION_NAME: 'Hest Bank',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8124762,
        LOCATION_LATITUDE_DEG: 54.0914248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028200',
        LOCATION_NAME: 'Heston',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3713467,
        LOCATION_LATITUDE_DEG: 51.4842441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028400',
        LOCATION_NAME: 'Hethe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1359661,
        LOCATION_LATITUDE_DEG: 51.9600021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028500',
        LOCATION_NAME: 'Hethel',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2056908,
        LOCATION_LATITUDE_DEG: 52.5560232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028600',
        LOCATION_NAME: 'Hethersett',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1855168,
        LOCATION_LATITUDE_DEG: 52.5979339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028700',
        LOCATION_NAME: 'Hethersgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8156958,
        LOCATION_LATITUDE_DEG: 54.9963165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028800',
        LOCATION_NAME: 'Hetherson Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7045078,
        LOCATION_LATITUDE_DEG: 53.0429248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE028900',
        LOCATION_NAME: 'Hethfelton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2096292,
        LOCATION_LATITUDE_DEG: 50.6930963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029000',
        LOCATION_NAME: 'Hett',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5624787,
        LOCATION_LATITUDE_DEG: 54.723372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029100',
        LOCATION_NAME: 'Hett Hills',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6297341,
        LOCATION_LATITUDE_DEG: 54.8538892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029200',
        LOCATION_NAME: 'Hetton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0590342,
        LOCATION_LATITUDE_DEG: 54.0247071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE033300',
        LOCATION_NAME: 'Hetton le Hole',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029300',
        LOCATION_NAME: 'Hetton-le-Hole',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.450701,
        LOCATION_LATITUDE_DEG: 54.8215841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029400',
        LOCATION_NAME: 'Heugh',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8716756,
        LOCATION_LATITUDE_DEG: 55.0535084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029500',
        LOCATION_NAME: 'Heveningham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.423205,
        LOCATION_LATITUDE_DEG: 52.3012009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029600',
        LOCATION_NAME: 'Hever',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1121553,
        LOCATION_LATITUDE_DEG: 51.1830078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029700',
        LOCATION_NAME: 'Heversham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7738386,
        LOCATION_LATITUDE_DEG: 54.243445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029800',
        LOCATION_NAME: 'Hevingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2641705,
        LOCATION_LATITUDE_DEG: 52.7434453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE029900',
        LOCATION_NAME: 'Hewas Water',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8521172,
        LOCATION_LATITUDE_DEG: 50.3136881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030000',
        LOCATION_NAME: 'Hewelsfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6307685,
        LOCATION_LATITUDE_DEG: 51.7156922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030100',
        LOCATION_NAME: 'Hewish',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8610106,
        LOCATION_LATITUDE_DEG: 51.3751622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030200',
        LOCATION_NAME: 'Hewish',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8146131,
        LOCATION_LATITUDE_DEG: 50.8698198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030300',
        LOCATION_NAME: 'Hewood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9101986,
        LOCATION_LATITUDE_DEG: 50.821015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030400',
        LOCATION_NAME: 'Heworth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0586044,
        LOCATION_LATITUDE_DEG: 53.9649892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030500',
        LOCATION_NAME: 'Hexham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0964069,
        LOCATION_LATITUDE_DEG: 54.9701006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030600',
        LOCATION_NAME: 'Hextable',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1835874,
        LOCATION_LATITUDE_DEG: 51.4107343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030700',
        LOCATION_NAME: 'Hexton',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3895854,
        LOCATION_LATITUDE_DEG: 51.9600902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030800',
        LOCATION_NAME: 'Hexworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8978166,
        LOCATION_LATITUDE_DEG: 50.537496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE030900',
        LOCATION_NAME: 'Heybridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6921735,
        LOCATION_LATITUDE_DEG: 51.7400575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031000',
        LOCATION_NAME: 'Heybridge Basin',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7109946,
        LOCATION_LATITUDE_DEG: 51.7318534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031100',
        LOCATION_NAME: 'Heybrook Bay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.111306,
        LOCATION_LATITUDE_DEG: 50.3208825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031200',
        LOCATION_NAME: 'Heydon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.087609,
        LOCATION_LATITUDE_DEG: 52.0400893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031300',
        LOCATION_NAME: 'Heydon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1360321,
        LOCATION_LATITUDE_DEG: 52.8028495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031400',
        LOCATION_NAME: 'Heydour',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4971518,
        LOCATION_LATITUDE_DEG: 52.9436825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031500',
        LOCATION_NAME: 'Heylipol',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.91508,
        LOCATION_LATITUDE_DEG: 56.4837994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031600',
        LOCATION_NAME: 'Heylor',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4707463,
        LOCATION_LATITUDE_DEG: 60.5099412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031700',
        LOCATION_NAME: 'Heynish',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8959679,
        LOCATION_LATITUDE_DEG: 56.4476017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031800',
        LOCATION_NAME: 'Heyope',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1165733,
        LOCATION_LATITUDE_DEG: 52.3631618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE031900',
        LOCATION_NAME: 'Heyrod',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0531849,
        LOCATION_LATITUDE_DEG: 53.4945613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032000',
        LOCATION_NAME: 'Heysham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8931688,
        LOCATION_LATITUDE_DEG: 54.0409193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032100',
        LOCATION_NAME: 'Heyshaw',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7359507,
        LOCATION_LATITUDE_DEG: 54.0521078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032200',
        LOCATION_NAME: 'Heyshott',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7227139,
        LOCATION_LATITUDE_DEG: 50.9550995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032300',
        LOCATION_NAME: 'Heyside',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1011796,
        LOCATION_LATITUDE_DEG: 53.5623645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032400',
        LOCATION_NAME: 'Heytesbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.107043,
        LOCATION_LATITUDE_DEG: 51.1821425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032500',
        LOCATION_NAME: 'Heythrop',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4896196,
        LOCATION_LATITUDE_DEG: 51.9467079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032600',
        LOCATION_NAME: 'Heywood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2197639,
        LOCATION_LATITUDE_DEG: 53.5934704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE032700',
        LOCATION_NAME: 'Heywood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.182642,
        LOCATION_LATITUDE_DEG: 51.2814478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000100',
        LOCATION_NAME: 'Hibaldstow',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5256481,
        LOCATION_LATITUDE_DEG: 53.5099421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000200',
        LOCATION_NAME: 'Hickleton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2704153,
        LOCATION_LATITUDE_DEG: 53.5422571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000300',
        LOCATION_NAME: 'Hickling',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9733619,
        LOCATION_LATITUDE_DEG: 52.8524867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000400',
        LOCATION_NAME: 'Hickling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5779271,
        LOCATION_LATITUDE_DEG: 52.760939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000500',
        LOCATION_NAME: 'Hickling Pastures',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0183805,
        LOCATION_LATITUDE_DEG: 52.8484799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000600',
        LOCATION_NAME: 'Hicks Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.130655,
        LOCATION_LATITUDE_DEG: 50.2274779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000700',
        LOCATION_NAME: 'Hickstead',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1929573,
        LOCATION_LATITUDE_DEG: 50.9676925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000800',
        LOCATION_NAME: 'Hidcote Bartrim',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7429442,
        LOCATION_LATITUDE_DEG: 52.0821218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI000900',
        LOCATION_NAME: 'Hidcote Boyce',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7458552,
        LOCATION_LATITUDE_DEG: 52.075816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001000',
        LOCATION_NAME: 'Higford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3629855,
        LOCATION_LATITUDE_DEG: 52.6021767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001100',
        LOCATION_NAME: 'Higginshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1022475,
        LOCATION_LATITUDE_DEG: 53.5606646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001200',
        LOCATION_NAME: 'High Bank Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6827983,
        LOCATION_LATITUDE_DEG: 54.7713932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001300',
        LOCATION_NAME: 'High Barnet',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2024192,
        LOCATION_LATITUDE_DEG: 51.650861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001400',
        LOCATION_NAME: 'High Beech',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0402658,
        LOCATION_LATITUDE_DEG: 51.664054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI990976',
        LOCATION_NAME: 'High Bentham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001500',
        LOCATION_NAME: 'High Bickington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9905691,
        LOCATION_LATITUDE_DEG: 50.9664351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001600',
        LOCATION_NAME: 'High Biggins',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6120151,
        LOCATION_LATITUDE_DEG: 54.1986325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001700',
        LOCATION_NAME: 'High Birstwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6518216,
        LOCATION_LATITUDE_DEG: 54.0177096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001800',
        LOCATION_NAME: 'High Blantyre',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1042698,
        LOCATION_LATITUDE_DEG: 55.784906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI001900',
        LOCATION_NAME: 'High Bonnybridge',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8747855,
        LOCATION_LATITUDE_DEG: 55.9934231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002000',
        LOCATION_NAME: 'High Borve',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4210589,
        LOCATION_LATITUDE_DEG: 58.4253889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002100',
        LOCATION_NAME: 'High Bray',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8705729,
        LOCATION_LATITUDE_DEG: 51.0920537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI990293',
        LOCATION_NAME: 'High Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9419353,
        LOCATION_LATITUDE_DEG: 54.7864834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002200',
        LOCATION_NAME: 'High Bullen',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0885193,
        LOCATION_LATITUDE_DEG: 50.9637437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002300',
        LOCATION_NAME: 'High Burnham',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8171612,
        LOCATION_LATITUDE_DEG: 53.5013423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002400',
        LOCATION_NAME: 'High Buston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6310869,
        LOCATION_LATITUDE_DEG: 55.373133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002500',
        LOCATION_NAME: 'High Callerton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7483639,
        LOCATION_LATITUDE_DEG: 55.0305065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002600',
        LOCATION_NAME: 'High Casterton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5733918,
        LOCATION_LATITUDE_DEG: 54.2026336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002700',
        LOCATION_NAME: 'High Catton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9060197,
        LOCATION_LATITUDE_DEG: 53.9741872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002800',
        LOCATION_NAME: 'High Cogges',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4540326,
        LOCATION_LATITUDE_DEG: 51.778388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI002900',
        LOCATION_NAME: 'High Coniscliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6535042,
        LOCATION_LATITUDE_DEG: 54.5335559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003100',
        LOCATION_NAME: 'High Cross',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3046886,
        LOCATION_LATITUDE_DEG: 52.4925564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003000',
        LOCATION_NAME: 'High Cross',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0211767,
        LOCATION_LATITUDE_DEG: 51.8484713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003200',
        LOCATION_NAME: 'High Easter',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3508028,
        LOCATION_LATITUDE_DEG: 51.8077702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003300',
        LOCATION_NAME: 'High Eggborough',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1291303,
        LOCATION_LATITUDE_DEG: 53.6908626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003400',
        LOCATION_NAME: 'High Eldwick',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7915932,
        LOCATION_LATITUDE_DEG: 53.8704908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003500',
        LOCATION_NAME: 'High Ellington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6986245,
        LOCATION_LATITUDE_DEG: 54.2448239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003600',
        LOCATION_NAME: 'High Ercall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6016935,
        LOCATION_LATITUDE_DEG: 52.753896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003700',
        LOCATION_NAME: 'High Etherley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7426893,
        LOCATION_LATITUDE_DEG: 54.6527686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003800',
        LOCATION_NAME: 'High Felling',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5732227,
        LOCATION_LATITUDE_DEG: 54.9492943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI003900',
        LOCATION_NAME: 'High Flatts',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6798039,
        LOCATION_LATITUDE_DEG: 53.5626619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004000',
        LOCATION_NAME: 'High Flatts',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5901242,
        LOCATION_LATITUDE_DEG: 54.8672882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004100',
        LOCATION_NAME: 'High Gardham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5585616,
        LOCATION_LATITUDE_DEG: 53.8516772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004200',
        LOCATION_NAME: 'High Garrett',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5809443,
        LOCATION_LATITUDE_DEG: 51.9117704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004300',
        LOCATION_NAME: 'High Green',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3336007,
        LOCATION_LATITUDE_DEG: 57.6717721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004400',
        LOCATION_NAME: 'High Green',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4971528,
        LOCATION_LATITUDE_DEG: 53.4729473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004500',
        LOCATION_NAME: 'High Grosvenor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3377951,
        LOCATION_LATITUDE_DEG: 52.5390721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004600',
        LOCATION_NAME: 'High Halden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7155573,
        LOCATION_LATITUDE_DEG: 51.1027904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004700',
        LOCATION_NAME: 'High Hall',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9972028,
        LOCATION_LATITUDE_DEG: 50.8228023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004800',
        LOCATION_NAME: 'High Halstow',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5625708,
        LOCATION_LATITUDE_DEG: 51.44803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI004900',
        LOCATION_NAME: 'High Ham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8181632,
        LOCATION_LATITUDE_DEG: 51.074739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005000',
        LOCATION_NAME: 'High Harrington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5401839,
        LOCATION_LATITUDE_DEG: 54.6161843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005100',
        LOCATION_NAME: 'High Hatton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5785146,
        LOCATION_LATITUDE_DEG: 52.8174045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005200',
        LOCATION_NAME: 'High Hauxley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5605027,
        LOCATION_LATITUDE_DEG: 55.3214322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005300',
        LOCATION_NAME: 'High Hawsker',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5678031,
        LOCATION_LATITUDE_DEG: 54.454129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005400',
        LOCATION_NAME: 'High Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4645818,
        LOCATION_LATITUDE_DEG: 52.841802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039200',
        LOCATION_NAME: 'High Heaton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5887288,
        LOCATION_LATITUDE_DEG: 54.998149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005500',
        LOCATION_NAME: 'High Hesket',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8152595,
        LOCATION_LATITUDE_DEG: 54.7917957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005600',
        LOCATION_NAME: 'High Hesleden',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2927205,
        LOCATION_LATITUDE_DEG: 54.7363712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005700',
        LOCATION_NAME: 'High Holbeck',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1815494,
        LOCATION_LATITUDE_DEG: 53.2515245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039400',
        LOCATION_NAME: 'High Holborn',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.118754,
        LOCATION_LATITUDE_DEG: 51.5180655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005800',
        LOCATION_NAME: 'High Hold',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6315328,
        LOCATION_LATITUDE_DEG: 54.8718877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI005900',
        LOCATION_NAME: 'High Hoyland',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5886834,
        LOCATION_LATITUDE_DEG: 53.585567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006000',
        LOCATION_NAME: 'High Humbleton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0410463,
        LOCATION_LATITUDE_DEG: 55.5558576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006100',
        LOCATION_NAME: 'High Hunsley',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5605432,
        LOCATION_LATITUDE_DEG: 53.8036684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006200',
        LOCATION_NAME: 'High Hurstwood',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1302457,
        LOCATION_LATITUDE_DEG: 51.0192959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006300',
        LOCATION_NAME: 'High Hutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8467285,
        LOCATION_LATITUDE_DEG: 54.1062057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006400',
        LOCATION_NAME: 'High Ingleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.663096,
        LOCATION_LATITUDE_DEG: 53.2909181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006500',
        LOCATION_NAME: 'High Ireby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1957995,
        LOCATION_LATITUDE_DEG: 54.7236932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006600',
        LOCATION_NAME: 'High Kelling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1299989,
        LOCATION_LATITUDE_DEG: 52.9143645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006700',
        LOCATION_NAME: 'High Kilburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2081141,
        LOCATION_LATITUDE_DEG: 54.2105192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006800',
        LOCATION_NAME: 'High Knells',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9041688,
        LOCATION_LATITUDE_DEG: 54.9464119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI006900',
        LOCATION_NAME: 'High Lane',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1814656,
        LOCATION_LATITUDE_DEG: 53.2131298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007000',
        LOCATION_NAME: 'High Lane',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0663374,
        LOCATION_LATITUDE_DEG: 53.3637475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007200',
        LOCATION_NAME: 'High Lanes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0137082,
        LOCATION_LATITUDE_DEG: 50.4266988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007100',
        LOCATION_NAME: 'High Lanes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9467991,
        LOCATION_LATITUDE_DEG: 50.5144011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007300',
        LOCATION_NAME: 'High Laver',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2116685,
        LOCATION_LATITUDE_DEG: 51.7553665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007400',
        LOCATION_NAME: 'High Laws',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3389614,
        LOCATION_LATITUDE_DEG: 54.8348029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007500',
        LOCATION_NAME: 'High Legh',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4523433,
        LOCATION_LATITUDE_DEG: 53.3512491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007600',
        LOCATION_NAME: 'High Leven',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3058305,
        LOCATION_LATITUDE_DEG: 54.5043499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007700',
        LOCATION_NAME: 'High Littleton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5084767,
        LOCATION_LATITUDE_DEG: 51.3227528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007800',
        LOCATION_NAME: 'High Lorton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2985214,
        LOCATION_LATITUDE_DEG: 54.6210848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI007900',
        LOCATION_NAME: 'High Marnham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7912841,
        LOCATION_LATITUDE_DEG: 53.2221161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008000',
        LOCATION_NAME: 'High Melton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2327414,
        LOCATION_LATITUDE_DEG: 53.5115554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008100',
        LOCATION_NAME: 'High Mickley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8797621,
        LOCATION_LATITUDE_DEG: 54.9461013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008200',
        LOCATION_NAME: 'High Moorsley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.474799,
        LOCATION_LATITUDE_DEG: 54.806978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008300',
        LOCATION_NAME: 'High Normanby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5607232,
        LOCATION_LATITUDE_DEG: 54.4378288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008400',
        LOCATION_NAME: 'High Offley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3209904,
        LOCATION_LATITUDE_DEG: 52.8323965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008500',
        LOCATION_NAME: 'High Ongar',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2650085,
        LOCATION_LATITUDE_DEG: 51.7115579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008600',
        LOCATION_NAME: 'High Peak',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5317928,
        LOCATION_LATITUDE_DEG: 53.0997118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008700',
        LOCATION_NAME: 'High Penn',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9812924,
        LOCATION_LATITUDE_DEG: 51.444258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008800',
        LOCATION_NAME: 'High Pit',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5676123,
        LOCATION_LATITUDE_DEG: 55.0820077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI008900',
        LOCATION_NAME: 'High Pittington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4879219,
        LOCATION_LATITUDE_DEG: 54.7892745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009000',
        LOCATION_NAME: 'High Post',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7867823,
        LOCATION_LATITUDE_DEG: 51.1210243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009100',
        LOCATION_NAME: 'High Rickleton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5581206,
        LOCATION_LATITUDE_DEG: 54.8754894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009200',
        LOCATION_NAME: 'High Risby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6074929,
        LOCATION_LATITUDE_DEG: 53.619956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009300',
        LOCATION_NAME: 'High Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3243475,
        LOCATION_LATITUDE_DEG: 51.8276689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009400',
        LOCATION_NAME: 'High Salvington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4049359,
        LOCATION_LATITUDE_DEG: 50.844089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009500',
        LOCATION_NAME: 'High Santon',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5795471,
        LOCATION_LATITUDE_DEG: 53.5952464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009600',
        LOCATION_NAME: 'High Scales',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2618053,
        LOCATION_LATITUDE_DEG: 54.7993978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009700',
        LOCATION_NAME: 'High Seaton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5202296,
        LOCATION_LATITUDE_DEG: 54.663394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009800',
        LOCATION_NAME: 'High Shields',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4406075,
        LOCATION_LATITUDE_DEG: 54.9931004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI009900',
        LOCATION_NAME: 'High Shincliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5433659,
        LOCATION_LATITUDE_DEG: 54.7549742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010000',
        LOCATION_NAME: 'High Southwick',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4048691,
        LOCATION_LATITUDE_DEG: 54.9246892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010100',
        LOCATION_NAME: 'High Spen',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7814947,
        LOCATION_LATITUDE_DEG: 54.9311982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010200',
        LOCATION_NAME: 'High Startforth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9313722,
        LOCATION_LATITUDE_DEG: 54.5369627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010300',
        LOCATION_NAME: 'High Stott Park',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9630428,
        LOCATION_LATITUDE_DEG: 54.2942523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010500',
        LOCATION_NAME: 'High Street',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8574354,
        LOCATION_LATITUDE_DEG: 50.3430835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010600',
        LOCATION_NAME: 'High Throston',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2479993,
        LOCATION_LATITUDE_DEG: 54.695369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010700',
        LOCATION_NAME: 'High Toynton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0776564,
        LOCATION_LATITUDE_DEG: 53.2104023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010800',
        LOCATION_NAME: 'High Valleyfield',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5977159,
        LOCATION_LATITUDE_DEG: 56.0608273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010900',
        LOCATION_NAME: 'High Warden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1399841,
        LOCATION_LATITUDE_DEG: 54.9987096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039100',
        LOCATION_NAME: 'High West Jesmond',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.611166,
        LOCATION_LATITUDE_DEG: 54.9865303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011000',
        LOCATION_NAME: 'High Westwood',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8198557,
        LOCATION_LATITUDE_DEG: 54.8967946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011100',
        LOCATION_NAME: 'High Wham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8239299,
        LOCATION_LATITUDE_DEG: 54.634471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011200',
        LOCATION_NAME: 'High Worsall',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4014441,
        LOCATION_LATITUDE_DEG: 54.4782471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011300',
        LOCATION_NAME: 'High Wray',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9669649,
        LOCATION_LATITUDE_DEG: 54.3907586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011400',
        LOCATION_NAME: 'High Wreay',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8760489,
        LOCATION_LATITUDE_DEG: 54.8278987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011500',
        LOCATION_NAME: 'High Wych',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1250713,
        LOCATION_LATITUDE_DEG: 51.8069686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011600',
        LOCATION_NAME: 'High Wycombe',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.749369,
        LOCATION_LATITUDE_DEG: 51.6287607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011900',
        LOCATION_NAME: 'Higham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2904646,
        LOCATION_LATITUDE_DEG: 53.8243956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012100',
        LOCATION_NAME: 'Higham',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5302448,
        LOCATION_LATITUDE_DEG: 53.5612602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012000',
        LOCATION_NAME: 'Higham',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4094416,
        LOCATION_LATITUDE_DEG: 53.1261202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011700',
        LOCATION_NAME: 'Higham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4612187,
        LOCATION_LATITUDE_DEG: 51.4151243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012150',
        LOCATION_NAME: 'Higham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5567515,
        LOCATION_LATITUDE_DEG: 52.2621484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI011800',
        LOCATION_NAME: 'Higham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.963512,
        LOCATION_LATITUDE_DEG: 51.9819783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012200',
        LOCATION_NAME: 'Higham Ferrers',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5917372,
        LOCATION_LATITUDE_DEG: 52.3054287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012300',
        LOCATION_NAME: 'Higham Gobian',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3929176,
        LOCATION_LATITUDE_DEG: 51.9816911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI990695',
        LOCATION_NAME: 'Higham Gobion',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038400',
        LOCATION_NAME: 'Higham on the Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012400',
        LOCATION_NAME: 'Higham Wood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3019628,
        LOCATION_LATITUDE_DEG: 51.213407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012500',
        LOCATION_NAME: 'Higham-on-the-Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4342031,
        LOCATION_LATITUDE_DEG: 52.5552579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012600',
        LOCATION_NAME: 'Highampton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1488049,
        LOCATION_LATITUDE_DEG: 50.8162245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039700',
        LOCATION_NAME: 'Highams Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'E4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0034362,
        LOCATION_LATITUDE_DEG: 51.6134342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012800',
        LOCATION_NAME: 'Highbridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9740602,
        LOCATION_LATITUDE_DEG: 51.2189481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012700',
        LOCATION_NAME: 'Highbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3352238,
        LOCATION_LATITUDE_DEG: 50.9884134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI012900',
        LOCATION_NAME: 'Highbrook',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.056993,
        LOCATION_LATITUDE_DEG: 51.0527004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013000',
        LOCATION_NAME: 'Highbury',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0615162,
        LOCATION_LATITUDE_DEG: 50.8366919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039900',
        LOCATION_NAME: 'Highbury',
        COUNTY_NAME: 'London',
        POSTCODE: 'N5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1039392,
        LOCATION_LATITUDE_DEG: 51.5543948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039800',
        LOCATION_NAME: 'Highbury',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1038481,
        LOCATION_LATITUDE_DEG: 51.5475672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013100',
        LOCATION_NAME: 'Highbury Vale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1837841,
        LOCATION_LATITUDE_DEG: 52.9927005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013200',
        LOCATION_NAME: 'Highclere',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3741398,
        LOCATION_LATITUDE_DEG: 51.3381468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013300',
        LOCATION_NAME: 'Highcliffe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7039537,
        LOCATION_LATITUDE_DEG: 50.7406926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013400',
        LOCATION_NAME: 'Higher Ansty',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3299412,
        LOCATION_LATITUDE_DEG: 50.8342074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013500',
        LOCATION_NAME: 'Higher Ashton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6181699,
        LOCATION_LATITUDE_DEG: 50.649807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013600',
        LOCATION_NAME: 'Higher Barnes',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7823145,
        LOCATION_LATITUDE_DEG: 52.9892153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013700',
        LOCATION_NAME: 'Higher Bartle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7482206,
        LOCATION_LATITUDE_DEG: 53.7949968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013800',
        LOCATION_NAME: 'Higher Batson',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7758963,
        LOCATION_LATITUDE_DEG: 50.242566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI013900',
        LOCATION_NAME: 'Higher Bebington',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0242041,
        LOCATION_LATITUDE_DEG: 53.3587604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039000',
        LOCATION_NAME: 'Higher Blackley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2029273,
        LOCATION_LATITUDE_DEG: 53.5327589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014000',
        LOCATION_NAME: 'Higher Bockhampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3915048,
        LOCATION_LATITUDE_DEG: 50.7286024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014100',
        LOCATION_NAME: 'Higher Boskerris',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4600562,
        LOCATION_LATITUDE_DEG: 50.1928793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014200',
        LOCATION_NAME: 'Higher Bospolvans',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9462974,
        LOCATION_LATITUDE_DEG: 50.430199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014300',
        LOCATION_NAME: 'Higher Brea',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.272033,
        LOCATION_LATITUDE_DEG: 50.2150767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014400',
        LOCATION_NAME: 'Higher Brill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1847308,
        LOCATION_LATITUDE_DEG: 50.1206696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014500',
        LOCATION_NAME: 'Higher Brimley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6951295,
        LOCATION_LATITUDE_DEG: 50.5817027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014600',
        LOCATION_NAME: 'Higher Burton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4336556,
        LOCATION_LATITUDE_DEG: 50.7310974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014700',
        LOCATION_NAME: 'Higher Came',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4290546,
        LOCATION_LATITUDE_DEG: 50.6834924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014800',
        LOCATION_NAME: 'Higher Carnkie',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2413318,
        LOCATION_LATITUDE_DEG: 50.2126812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI014900',
        LOCATION_NAME: 'Higher Charminster',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4550603,
        LOCATION_LATITUDE_DEG: 50.7391013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015000',
        LOCATION_NAME: 'Higher Chilfrome',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.593171,
        LOCATION_LATITUDE_DEG: 50.7889084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015100',
        LOCATION_NAME: 'Higher Chillington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8674951,
        LOCATION_LATITUDE_DEG: 50.8879207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015200',
        LOCATION_NAME: 'Higher Clatcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5256472,
        LOCATION_LATITUDE_DEG: 50.9682217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015300',
        LOCATION_NAME: 'Higher Clovelly',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4037569,
        LOCATION_LATITUDE_DEG: 50.9843487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015400',
        LOCATION_NAME: 'Higher Comeytrowe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1417109,
        LOCATION_LATITUDE_DEG: 50.9980364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015500',
        LOCATION_NAME: 'Higher Condurrow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2717263,
        LOCATION_LATITUDE_DEG: 50.2054764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015600',
        LOCATION_NAME: 'Higher Coombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8276928,
        LOCATION_LATITUDE_DEG: 50.4971966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038800',
        LOCATION_NAME: 'Higher Crumpsall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2415592,
        LOCATION_LATITUDE_DEG: 53.5177017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015700',
        LOCATION_NAME: 'Higher Dawlish Water',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4937624,
        LOCATION_LATITUDE_DEG: 50.5963954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015800',
        LOCATION_NAME: 'Higher Dean',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7898877,
        LOCATION_LATITUDE_DEG: 50.466293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI015900',
        LOCATION_NAME: 'Higher Dimson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2195292,
        LOCATION_LATITUDE_DEG: 50.5200941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016000',
        LOCATION_NAME: 'Higher Downgate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.304632,
        LOCATION_LATITUDE_DEG: 50.5300979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016100',
        LOCATION_NAME: 'Higher Durston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0159925,
        LOCATION_LATITUDE_DEG: 51.0477355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016200',
        LOCATION_NAME: 'Higher Eype',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7848236,
        LOCATION_LATITUDE_DEG: 50.7283992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016300',
        LOCATION_NAME: 'Higher Ferry',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9315208,
        LOCATION_LATITUDE_DEG: 53.1880418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016400',
        LOCATION_NAME: 'Higher Folds',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4819744,
        LOCATION_LATITUDE_DEG: 53.5031663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016500',
        LOCATION_NAME: 'Higher Fraddon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9310025,
        LOCATION_LATITUDE_DEG: 50.3909925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016600',
        LOCATION_NAME: 'Higher Halstock Leigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6912736,
        LOCATION_LATITUDE_DEG: 50.8651113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016700',
        LOCATION_NAME: 'Higher Hampt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2743343,
        LOCATION_LATITUDE_DEG: 50.5451045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016750',
        LOCATION_NAME: 'Higher Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6427749,
        LOCATION_LATITUDE_DEG: 52.917139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016800',
        LOCATION_NAME: 'Higher Holton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4423466,
        LOCATION_LATITUDE_DEG: 51.04233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI016900',
        LOCATION_NAME: 'Higher Kehelland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3426458,
        LOCATION_LATITUDE_DEG: 50.2174823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017000',
        LOCATION_NAME: 'Higher Kelly',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2085272,
        LOCATION_LATITUDE_DEG: 50.4965918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017100',
        LOCATION_NAME: 'Higher Kenneggy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4116742,
        LOCATION_LATITUDE_DEG: 50.1061729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017200',
        LOCATION_NAME: 'Higher Kingcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6393052,
        LOCATION_LATITUDE_DEG: 50.7957068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017300',
        LOCATION_NAME: 'Higher Kingston Russell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5624703,
        LOCATION_LATITUDE_DEG: 50.7098975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017400',
        LOCATION_NAME: 'Higher Kinnerton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0026608,
        LOCATION_LATITUDE_DEG: 53.1436363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017500',
        LOCATION_NAME: 'Higher Laity',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2353284,
        LOCATION_LATITUDE_DEG: 50.2488819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017600',
        LOCATION_NAME: 'Higher Melcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3592477,
        LOCATION_LATITUDE_DEG: 50.8204056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017700',
        LOCATION_NAME: 'Higher Metcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3220392,
        LOCATION_LATITUDE_DEG: 50.7208111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017800',
        LOCATION_NAME: 'Higher Metherell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2427295,
        LOCATION_LATITUDE_DEG: 50.5053018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI017900',
        LOCATION_NAME: 'Higher Ninnis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1922173,
        LOCATION_LATITUDE_DEG: 50.2338807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018000',
        LOCATION_NAME: 'Higher North Country',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2381232,
        LOCATION_LATITUDE_DEG: 50.2478863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018100',
        LOCATION_NAME: 'Higher Oborne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4900552,
        LOCATION_LATITUDE_DEG: 50.9656244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018150',
        LOCATION_NAME: 'Higher Odcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6975658,
        LOCATION_LATITUDE_DEG: 50.9391179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039500',
        LOCATION_NAME: 'Higher Openshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1629276,
        LOCATION_LATITUDE_DEG: 53.4738492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018200',
        LOCATION_NAME: 'Higher Pengegon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2823399,
        LOCATION_LATITUDE_DEG: 50.2144798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018300',
        LOCATION_NAME: 'Higher Pennance',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2009315,
        LOCATION_LATITUDE_DEG: 50.2169783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018400',
        LOCATION_NAME: 'Higher Penponds',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3106398,
        LOCATION_LATITUDE_DEG: 50.2003782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018500',
        LOCATION_NAME: 'Higher Penquite',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.684271,
        LOCATION_LATITUDE_DEG: 50.5544081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018600',
        LOCATION_NAME: 'Higher Penwartha',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1545217,
        LOCATION_LATITUDE_DEG: 50.3203905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018700',
        LOCATION_NAME: 'Higher Penwortham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7337631,
        LOCATION_LATITUDE_DEG: 53.7486925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018800',
        LOCATION_NAME: 'Higher Perthy',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9367384,
        LOCATION_LATITUDE_DEG: 52.8946143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI018900',
        LOCATION_NAME: 'Higher Poynton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0845249,
        LOCATION_LATITUDE_DEG: 53.3498469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019000',
        LOCATION_NAME: 'Higher Releath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2751385,
        LOCATION_LATITUDE_DEG: 50.1541772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019100',
        LOCATION_NAME: 'Higher Sandygate',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.600462,
        LOCATION_LATITUDE_DEG: 50.5607985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019200',
        LOCATION_NAME: 'Higher Slade',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1379779,
        LOCATION_LATITUDE_DEG: 51.1942582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038100',
        LOCATION_NAME: 'Higher St Budeaux',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019300',
        LOCATION_NAME: 'Higher St. Budeaux',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1685287,
        LOCATION_LATITUDE_DEG: 50.4117895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019400',
        LOCATION_NAME: 'Higher Stubbin',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3621859,
        LOCATION_LATITUDE_DEG: 53.473346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019500',
        LOCATION_NAME: 'Higher Tolcarne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9803813,
        LOCATION_LATITUDE_DEG: 50.4487985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019600',
        LOCATION_NAME: 'Higher Totnell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5316621,
        LOCATION_LATITUDE_DEG: 50.8737179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019700',
        LOCATION_NAME: 'Higher Town',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.280863,
        LOCATION_LATITUDE_DEG: 49.9607684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019800',
        LOCATION_NAME: 'Higher Tranmere',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0163012,
        LOCATION_LATITUDE_DEG: 53.3834607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI019900',
        LOCATION_NAME: 'Higher Treluswell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.118921,
        LOCATION_LATITUDE_DEG: 50.1845726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020000',
        LOCATION_NAME: 'Higher Tremar',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4647433,
        LOCATION_LATITUDE_DEG: 50.4978961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020100',
        LOCATION_NAME: 'Higher Trencreek',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0545127,
        LOCATION_LATITUDE_DEG: 50.4048967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020200',
        LOCATION_NAME: 'Higher Trenowin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5140554,
        LOCATION_LATITUDE_DEG: 50.1651816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020300',
        LOCATION_NAME: 'Higher Trevellas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1854229,
        LOCATION_LATITUDE_DEG: 50.320393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020400',
        LOCATION_NAME: 'Higher Trevethan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1932303,
        LOCATION_LATITUDE_DEG: 50.2265833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020500',
        LOCATION_NAME: 'Higher Trevurvas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3753487,
        LOCATION_LATITUDE_DEG: 50.1044736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020600',
        LOCATION_NAME: 'Higher Treween',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5191514,
        LOCATION_LATITUDE_DEG: 50.6093112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020700',
        LOCATION_NAME: 'Higher Vexford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2802152,
        LOCATION_LATITUDE_DEG: 51.1107482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020800',
        LOCATION_NAME: 'Higher Walton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6399626,
        LOCATION_LATITUDE_DEG: 53.7408879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI020900',
        LOCATION_NAME: 'Higher Walton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6048722,
        LOCATION_LATITUDE_DEG: 53.3617569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021000',
        LOCATION_NAME: 'Higher Waterston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3899443,
        LOCATION_LATITUDE_DEG: 50.7574055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021100',
        LOCATION_NAME: 'Higher Week',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7187827,
        LOCATION_LATITUDE_DEG: 50.4493843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021200',
        LOCATION_NAME: 'Higher Whitley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5846838,
        LOCATION_LATITUDE_DEG: 53.3185445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021300',
        LOCATION_NAME: 'Higher Wilcove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.211723,
        LOCATION_LATITUDE_DEG: 50.3834859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021400',
        LOCATION_NAME: 'Higher Woodsford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3314407,
        LOCATION_LATITUDE_DEG: 50.700899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021500',
        LOCATION_NAME: 'Higher Wrangway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2460221,
        LOCATION_LATITUDE_DEG: 50.9537284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021600',
        LOCATION_NAME: 'Higher Wraxall',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6136602,
        LOCATION_LATITUDE_DEG: 50.8074104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021700',
        LOCATION_NAME: 'Higher Wych',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7501045,
        LOCATION_LATITUDE_DEG: 52.9867167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021800',
        LOCATION_NAME: 'Highercombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5629471,
        LOCATION_LATITUDE_DEG: 51.0623412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI021900',
        LOCATION_NAME: 'Higherland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2991371,
        LOCATION_LATITUDE_DEG: 50.5328962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022200',
        LOCATION_NAME: 'Highfield',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0216415,
        LOCATION_LATITUDE_DEG: 53.0619315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039600',
        LOCATION_NAME: 'Highfield',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9041625,
        LOCATION_LATITUDE_DEG: 53.4169511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022300',
        LOCATION_NAME: 'Highfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9203016,
        LOCATION_LATITUDE_DEG: 53.8695935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022000',
        LOCATION_NAME: 'Highfield',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7747513,
        LOCATION_LATITUDE_DEG: 54.9229984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022100',
        LOCATION_NAME: 'Highfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.899711,
        LOCATION_LATITUDE_DEG: 53.8187753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038700',
        LOCATION_NAME: 'Highfield Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6149921,
        LOCATION_LATITUDE_DEG: 54.9933728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022400',
        LOCATION_NAME: 'Highfields',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7341235,
        LOCATION_LATITUDE_DEG: 52.8709106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022500',
        LOCATION_NAME: 'Highfields',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1819402,
        LOCATION_LATITUDE_DEG: 53.5549533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022600',
        LOCATION_NAME: 'Highfields Caldecote',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0171757,
        LOCATION_LATITUDE_DEG: 52.2061725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI040000',
        LOCATION_NAME: 'Highgate',
        COUNTY_NAME: 'London',
        POSTCODE: 'N6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1606795,
        LOCATION_LATITUDE_DEG: 51.5679969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI039300',
        LOCATION_NAME: 'Highgate',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1443646,
        LOCATION_LATITUDE_DEG: 51.5547174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022700',
        LOCATION_NAME: 'Highgate',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5183322,
        LOCATION_LATITUDE_DEG: 51.0327917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022800',
        LOCATION_NAME: 'Highleadon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3342809,
        LOCATION_LATITUDE_DEG: 51.9067142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI022900',
        LOCATION_NAME: 'Highleigh',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7998574,
        LOCATION_LATITUDE_DEG: 50.7726853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023000',
        LOCATION_NAME: 'Highley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.380791,
        LOCATION_LATITUDE_DEG: 52.4483659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023100',
        LOCATION_NAME: 'Highmoor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9864962,
        LOCATION_LATITUDE_DEG: 51.5574599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023200',
        LOCATION_NAME: 'Highmoor Cross',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.989691,
        LOCATION_LATITUDE_DEG: 51.5532609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023300',
        LOCATION_NAME: 'Highnam',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2971378,
        LOCATION_LATITUDE_DEG: 51.8804045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023400',
        LOCATION_NAME: 'Hightae',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4202358,
        LOCATION_LATITUDE_DEG: 55.0957328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI040100',
        LOCATION_NAME: 'Highters Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8798615,
        LOCATION_LATITUDE_DEG: 52.4112182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023600',
        LOCATION_NAME: 'Hightown',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0569095,
        LOCATION_LATITUDE_DEG: 53.5245743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023700',
        LOCATION_NAME: 'Hightown',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.767188,
        LOCATION_LATITUDE_DEG: 50.8396039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023750',
        LOCATION_NAME: 'Hightown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7245031,
        LOCATION_LATITUDE_DEG: 53.7150966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023500',
        LOCATION_NAME: 'Hightown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3674583,
        LOCATION_LATITUDE_DEG: 53.7192722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023800',
        LOCATION_NAME: 'Hightown Hill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7519915,
        LOCATION_LATITUDE_DEG: 50.8446989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI023900',
        LOCATION_NAME: 'Hightrees',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5932958,
        LOCATION_LATITUDE_DEG: 52.9013124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024000',
        LOCATION_NAME: 'Highway',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9387073,
        LOCATION_LATITUDE_DEG: 51.4686673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024100',
        LOCATION_NAME: 'Highweek',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6154753,
        LOCATION_LATITUDE_DEG: 50.5327977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024400',
        LOCATION_NAME: 'Highwood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8571258,
        LOCATION_LATITUDE_DEG: 52.8843945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024300',
        LOCATION_NAME: 'Highwood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.75619,
        LOCATION_LATITUDE_DEG: 50.8677041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024200',
        LOCATION_NAME: 'Highwood',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3775331,
        LOCATION_LATITUDE_DEG: 51.7110606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024500',
        LOCATION_NAME: 'Highwoods',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9085475,
        LOCATION_LATITUDE_DEG: 51.9000686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024600',
        LOCATION_NAME: 'Highworth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7084031,
        LOCATION_LATITUDE_DEG: 51.6343755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024700',
        LOCATION_NAME: 'Hilborough',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.697074,
        LOCATION_LATITUDE_DEG: 52.571338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024800',
        LOCATION_NAME: 'Hilcote',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3227849,
        LOCATION_LATITUDE_DEG: 53.1175137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI024900',
        LOCATION_NAME: 'Hilcott',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8389668,
        LOCATION_LATITUDE_DEG: 51.3226486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025000',
        LOCATION_NAME: 'Hilden',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0305041,
        LOCATION_LATITUDE_DEG: 54.5263912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025100',
        LOCATION_NAME: 'Hildenborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2510903,
        LOCATION_LATITUDE_DEG: 51.2127151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025200',
        LOCATION_NAME: 'Hildersham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2545122,
        LOCATION_LATITUDE_DEG: 52.1120981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025300',
        LOCATION_NAME: 'Hildersley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5660388,
        LOCATION_LATITUDE_DEG: 51.9133091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025400',
        LOCATION_NAME: 'Hilderstone',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0758134,
        LOCATION_LATITUDE_DEG: 52.9096024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025500',
        LOCATION_NAME: 'Hilfield',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5197208,
        LOCATION_LATITUDE_DEG: 50.8429148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025600',
        LOCATION_NAME: 'Hilgay',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3912721,
        LOCATION_LATITUDE_DEG: 52.5605378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025700',
        LOCATION_NAME: 'Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5126671,
        LOCATION_LATITUDE_DEG: 51.6527902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025900',
        LOCATION_NAME: 'Hill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0198991,
        LOCATION_LATITUDE_DEG: 52.1299299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI025800',
        LOCATION_NAME: 'Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3354118,
        LOCATION_LATITUDE_DEG: 52.2991325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026000',
        LOCATION_NAME: 'Hill Brow',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8749176,
        LOCATION_LATITUDE_DEG: 51.0306107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026100',
        LOCATION_NAME: 'Hill Chorlton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3026451,
        LOCATION_LATITUDE_DEG: 52.9502101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026200',
        LOCATION_NAME: 'Hill Deverill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.186516,
        LOCATION_LATITUDE_DEG: 51.1615388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI990575',
        LOCATION_NAME: 'Hill End',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026300',
        LOCATION_NAME: 'Hill Furze',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9970632,
        LOCATION_LATITUDE_DEG: 52.1308307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026400',
        LOCATION_NAME: 'Hill Head',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6394769,
        LOCATION_LATITUDE_DEG: 53.6988702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026500',
        LOCATION_NAME: 'Hill Mountain',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9315595,
        LOCATION_LATITUDE_DEG: 51.7373211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027200',
        LOCATION_NAME: 'Hill of Beath',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3679927,
        LOCATION_LATITUDE_DEG: 56.0977276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026600',
        LOCATION_NAME: 'Hill Ridware',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8794431,
        LOCATION_LATITUDE_DEG: 52.757986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026900',
        LOCATION_NAME: 'Hill Top',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6342999,
        LOCATION_LATITUDE_DEG: 52.5622743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026800',
        LOCATION_NAME: 'Hill Top',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0081395,
        LOCATION_LATITUDE_DEG: 52.5388704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027100',
        LOCATION_NAME: 'Hill Wootton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5566153,
        LOCATION_LATITUDE_DEG: 52.315743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027300',
        LOCATION_NAME: 'Hillam',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.22899,
        LOCATION_LATITUDE_DEG: 53.7535736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027400',
        LOCATION_NAME: 'Hillborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1734704,
        LOCATION_LATITUDE_DEG: 51.3684123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027500',
        LOCATION_NAME: 'Hillbutts',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0153159,
        LOCATION_LATITUDE_DEG: 50.8095988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027600',
        LOCATION_NAME: 'Hillcommon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2184238,
        LOCATION_LATITUDE_DEG: 51.0265359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027700',
        LOCATION_NAME: 'Hillend',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3692695,
        LOCATION_LATITUDE_DEG: 56.0417269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027800',
        LOCATION_NAME: 'Hillend Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4266923,
        LOCATION_LATITUDE_DEG: 51.9552145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027900',
        LOCATION_NAME: 'Hillersland',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6349577,
        LOCATION_LATITUDE_DEG: 51.8235044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028000',
        LOCATION_NAME: 'Hillesden',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0030803,
        LOCATION_LATITUDE_DEG: 51.957801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028100',
        LOCATION_NAME: 'Hillesley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3337097,
        LOCATION_LATITUDE_DEG: 51.6053799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028200',
        LOCATION_NAME: 'Hillfarrance',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1881265,
        LOCATION_LATITUDE_DEG: 51.0151382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028300',
        LOCATION_NAME: 'Hillfield',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6398764,
        LOCATION_LATITUDE_DEG: 50.3461735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028400',
        LOCATION_NAME: 'Hillfield',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5233629,
        LOCATION_LATITUDE_DEG: 52.4464779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028500',
        LOCATION_NAME: 'Hillfoot',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3304871,
        LOCATION_LATITUDE_DEG: 55.9209225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028600',
        LOCATION_NAME: 'Hillfoot',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6858681,
        LOCATION_LATITUDE_DEG: 53.7994813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028700',
        LOCATION_NAME: 'Hillgates',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.732436,
        LOCATION_LATITUDE_DEG: 51.9437195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028800',
        LOCATION_NAME: 'Hillgrove',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6075498,
        LOCATION_LATITUDE_DEG: 51.2421536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI028900',
        LOCATION_NAME: 'Hillhall',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0303984,
        LOCATION_LATITUDE_DEG: 54.5050941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029200',
        LOCATION_NAME: 'Hillhead',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8909911,
        LOCATION_LATITUDE_DEG: 50.3550914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI040300',
        LOCATION_NAME: 'Hillhead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2820917,
        LOCATION_LATITUDE_DEG: 55.8761762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029100',
        LOCATION_NAME: 'Hillhead',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0379866,
        LOCATION_LATITUDE_DEG: 57.5743847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029000',
        LOCATION_NAME: 'Hillhead',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5392608,
        LOCATION_LATITUDE_DEG: 50.3736791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029300',
        LOCATION_NAME: 'Hillhouse',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7797895,
        LOCATION_LATITUDE_DEG: 53.656071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029400',
        LOCATION_NAME: 'Hillingdon',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4510363,
        LOCATION_LATITUDE_DEG: 51.532952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI040400',
        LOCATION_NAME: 'Hillington',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3652689,
        LOCATION_LATITUDE_DEG: 55.8554234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029500',
        LOCATION_NAME: 'Hillington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5485168,
        LOCATION_LATITUDE_DEG: 52.7998614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029600',
        LOCATION_NAME: 'Hillmead',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8282724,
        LOCATION_LATITUDE_DEG: 51.5763685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029700',
        LOCATION_NAME: 'Hillmorton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.21553,
        LOCATION_LATITUDE_DEG: 52.3630366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029800',
        LOCATION_NAME: 'Hillsborough',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0863015,
        LOCATION_LATITUDE_DEG: 54.4740966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038900',
        LOCATION_NAME: 'Hillsborough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5048752,
        LOCATION_LATITUDE_DEG: 53.4088204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI029900',
        LOCATION_NAME: 'Hillsford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.802967,
        LOCATION_LATITUDE_DEG: 51.2136625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI040200',
        LOCATION_NAME: 'Hillside',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1744424,
        LOCATION_LATITUDE_DEG: 55.9589569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030200',
        LOCATION_NAME: 'Hillside',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.158686,
        LOCATION_LATITUDE_DEG: 51.8438172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030100',
        LOCATION_NAME: 'Hillside',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1253435,
        LOCATION_LATITUDE_DEG: 57.0715127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030300',
        LOCATION_NAME: 'Hillswick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4865841,
        LOCATION_LATITUDE_DEG: 60.4769402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030400',
        LOCATION_NAME: 'Hilltown',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1322173,
        LOCATION_LATITUDE_DEG: 54.1998731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030500',
        LOCATION_NAME: 'Hillway',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1044632,
        LOCATION_LATITUDE_DEG: 50.6778739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030600',
        LOCATION_NAME: 'Hillyfields',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4749509,
        LOCATION_LATITUDE_DEG: 50.9341033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030700',
        LOCATION_NAME: 'Hilmarton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9704502,
        LOCATION_LATITUDE_DEG: 51.4761614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030800',
        LOCATION_NAME: 'Hilperton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1826332,
        LOCATION_LATITUDE_DEG: 51.3334533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI030900',
        LOCATION_NAME: 'Hilperton Marsh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1939164,
        LOCATION_LATITUDE_DEG: 51.3367535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031000',
        LOCATION_NAME: 'Hilsea',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0650647,
        LOCATION_LATITUDE_DEG: 50.8296963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031100',
        LOCATION_NAME: 'Hilston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0526489,
        LOCATION_LATITUDE_DEG: 53.78336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031800',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0208811,
        LOCATION_LATITUDE_DEG: 57.8967141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032150',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8967305,
        LOCATION_LATITUDE_DEG: 57.7627364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031500',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4129134,
        LOCATION_LATITUDE_DEG: 54.5784669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031200',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3296168,
        LOCATION_LATITUDE_DEG: 52.5555755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031300',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3089363,
        LOCATION_LATITUDE_DEG: 50.8256041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031700',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1008505,
        LOCATION_LATITUDE_DEG: 57.3938437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032100',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8797029,
        LOCATION_LATITUDE_DEG: 52.6474729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031400',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7449269,
        LOCATION_LATITUDE_DEG: 54.5924652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031600',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6347148,
        LOCATION_LATITUDE_DEG: 52.8727976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032000',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2812324,
        LOCATION_LATITUDE_DEG: 54.4952449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI031900',
        LOCATION_NAME: 'Hilton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1106437,
        LOCATION_LATITUDE_DEG: 52.2787209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032200',
        LOCATION_NAME: 'Hilton Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3494886,
        LOCATION_LATITUDE_DEG: 52.7152853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032300',
        LOCATION_NAME: 'Himbleton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0780515,
        LOCATION_LATITUDE_DEG: 52.2238397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032400',
        LOCATION_NAME: 'Himley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1828607,
        LOCATION_LATITUDE_DEG: 52.5175648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032500',
        LOCATION_NAME: 'Hincaster',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7534975,
        LOCATION_LATITUDE_DEG: 54.2557444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032600',
        LOCATION_NAME: 'Hinchley Wood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3323377,
        LOCATION_LATITUDE_DEG: 51.3689302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032700',
        LOCATION_NAME: 'Hinckley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3723216,
        LOCATION_LATITUDE_DEG: 52.5407581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032800',
        LOCATION_NAME: 'Hinderclay',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.974322,
        LOCATION_LATITUDE_DEG: 52.3524132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI032900',
        LOCATION_NAME: 'Hinderwell',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7719075,
        LOCATION_LATITUDE_DEG: 54.5378399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033000',
        LOCATION_NAME: 'Hindford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9899282,
        LOCATION_LATITUDE_DEG: 52.8899123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033100',
        LOCATION_NAME: 'Hindhead',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7457305,
        LOCATION_LATITUDE_DEG: 51.1197172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033200',
        LOCATION_NAME: 'Hindley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5714599,
        LOCATION_LATITUDE_DEG: 53.5364739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033250',
        LOCATION_NAME: 'Hindley Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5467716,
        LOCATION_LATITUDE_DEG: 53.5270425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033300',
        LOCATION_NAME: 'Hindlip',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1806122,
        LOCATION_LATITUDE_DEG: 52.2238352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033400',
        LOCATION_NAME: 'Hindlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.854025,
        LOCATION_LATITUDE_DEG: 53.2183298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033500',
        LOCATION_NAME: 'Hindolveston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0157987,
        LOCATION_LATITUDE_DEG: 52.8230568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033600',
        LOCATION_NAME: 'Hindon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1282632,
        LOCATION_LATITUDE_DEG: 51.0946276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033700',
        LOCATION_NAME: 'Hindringham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9489495,
        LOCATION_LATITUDE_DEG: 52.8864613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033800',
        LOCATION_NAME: 'Hingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9910815,
        LOCATION_LATITUDE_DEG: 52.57903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI033900',
        LOCATION_NAME: 'Hinkshay',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4480954,
        LOCATION_LATITUDE_DEG: 52.6636884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034000',
        LOCATION_NAME: 'Hinnington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3740896,
        LOCATION_LATITUDE_DEG: 52.6540822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034100',
        LOCATION_NAME: 'Hinstock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4543039,
        LOCATION_LATITUDE_DEG: 52.8343976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034200',
        LOCATION_NAME: 'Hintlesham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0452642,
        LOCATION_LATITUDE_DEG: 52.0493758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034500',
        LOCATION_NAME: 'Hinton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8728159,
        LOCATION_LATITUDE_DEG: 52.6672916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034400',
        LOCATION_NAME: 'Hinton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4576205,
        LOCATION_LATITUDE_DEG: 51.7248929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034300',
        LOCATION_NAME: 'Hinton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3830471,
        LOCATION_LATITUDE_DEG: 51.4892713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034600',
        LOCATION_NAME: 'Hinton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7077008,
        LOCATION_LATITUDE_DEG: 50.7557935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034700',
        LOCATION_NAME: 'Hinton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2140528,
        LOCATION_LATITUDE_DEG: 52.1679192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034800',
        LOCATION_NAME: 'Hinton Ampner',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1474218,
        LOCATION_LATITUDE_DEG: 51.0442123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI034900',
        LOCATION_NAME: 'Hinton Blewett',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5811683,
        LOCATION_LATITUDE_DEG: 51.3099595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035000',
        LOCATION_NAME: 'Hinton Charterhouse',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3278347,
        LOCATION_LATITUDE_DEG: 51.3224534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038500',
        LOCATION_NAME: 'Hinton in the Hedges',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035100',
        LOCATION_NAME: 'Hinton Martell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9823252,
        LOCATION_LATITUDE_DEG: 50.8539096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038600',
        LOCATION_NAME: 'Hinton on the Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035200',
        LOCATION_NAME: 'Hinton Park',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8355873,
        LOCATION_LATITUDE_DEG: 50.8942152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035400',
        LOCATION_NAME: 'Hinton Parva',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9975996,
        LOCATION_LATITUDE_DEG: 50.8377046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035300',
        LOCATION_NAME: 'Hinton Parva',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6703083,
        LOCATION_LATITUDE_DEG: 51.5470664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038200',
        LOCATION_NAME: 'Hinton St George',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038300',
        LOCATION_NAME: 'Hinton St Mary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035500',
        LOCATION_NAME: 'Hinton St. George',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8223652,
        LOCATION_LATITUDE_DEG: 50.9097242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035600',
        LOCATION_NAME: 'Hinton St. Mary',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.30364,
        LOCATION_LATITUDE_DEG: 50.9437204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035700',
        LOCATION_NAME: 'Hinton Waldrist',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4524662,
        LOCATION_LATITUDE_DEG: 51.6861742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035800',
        LOCATION_NAME: 'Hinton-in-the-Hedges',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.184999,
        LOCATION_LATITUDE_DEG: 52.0276117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI035900',
        LOCATION_NAME: 'Hinton-on-the-Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9693213,
        LOCATION_LATITUDE_DEG: 52.0619242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036000',
        LOCATION_NAME: 'Hints',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.765583,
        LOCATION_LATITUDE_DEG: 52.6228741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036100',
        LOCATION_NAME: 'Hinwick',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6298139,
        LOCATION_LATITUDE_DEG: 52.2428249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036200',
        LOCATION_NAME: 'Hinwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9332385,
        LOCATION_LATITUDE_DEG: 52.6662917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036300',
        LOCATION_NAME: 'Hinxhill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9307059,
        LOCATION_LATITUDE_DEG: 51.1454931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036400',
        LOCATION_NAME: 'Hinxton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1827382,
        LOCATION_LATITUDE_DEG: 52.0858941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036500',
        LOCATION_NAME: 'Hinxworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1966979,
        LOCATION_LATITUDE_DEG: 52.0484986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036600',
        LOCATION_NAME: 'Hipperholme',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.808728,
        LOCATION_LATITUDE_DEG: 53.7251757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036700',
        LOCATION_NAME: 'Hipswell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.710261,
        LOCATION_LATITUDE_DEG: 54.3800452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036800',
        LOCATION_NAME: 'Hiraethog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4299763,
        LOCATION_LATITUDE_DEG: 53.065034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI036900',
        LOCATION_NAME: 'Hirn',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4429259,
        LOCATION_LATITUDE_DEG: 57.092921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037000',
        LOCATION_NAME: 'Hirnant',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4066911,
        LOCATION_LATITUDE_DEG: 52.7961102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037100',
        LOCATION_NAME: 'Hirst',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5595811,
        LOCATION_LATITUDE_DEG: 55.1798217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037200',
        LOCATION_NAME: 'Hirst Courtney',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0732548,
        LOCATION_LATITUDE_DEG: 53.7130699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037300',
        LOCATION_NAME: 'Hirwaun',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5100062,
        LOCATION_LATITUDE_DEG: 51.73931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037400',
        LOCATION_NAME: 'Hiscott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0705053,
        LOCATION_LATITUDE_DEG: 51.0163406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037500',
        LOCATION_NAME: 'Histon',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1103941,
        LOCATION_LATITUDE_DEG: 52.2510102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037600',
        LOCATION_NAME: 'Hitcham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8981704,
        LOCATION_LATITUDE_DEG: 52.1212839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037700',
        LOCATION_NAME: 'Hitchin',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2806565,
        LOCATION_LATITUDE_DEG: 51.9479922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037800',
        LOCATION_NAME: 'Hittisleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7940942,
        LOCATION_LATITUDE_DEG: 50.7407118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI037900',
        LOCATION_NAME: 'Hive',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7541789,
        LOCATION_LATITUDE_DEG: 53.7682685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI038000',
        LOCATION_NAME: 'Hixon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9980702,
        LOCATION_LATITUDE_DEG: 52.8304929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO990699',
        LOCATION_NAME: 'HO035000',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000100',
        LOCATION_NAME: 'Hoar Cross',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.814757,
        LOCATION_LATITUDE_DEG: 52.8065865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000200',
        LOCATION_NAME: 'Hoarwithy',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6543304,
        LOCATION_LATITUDE_DEG: 51.9456183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000300',
        LOCATION_NAME: 'Hoath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1642001,
        LOCATION_LATITUDE_DEG: 51.3336068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000400',
        LOCATION_NAME: 'Hobson',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7262781,
        LOCATION_LATITUDE_DEG: 54.8985881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000500',
        LOCATION_NAME: 'Hoby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0074145,
        LOCATION_LATITUDE_DEG: 52.7503701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000600',
        LOCATION_NAME: 'Hoccum',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3701979,
        LOCATION_LATITUDE_DEG: 52.5380671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000700',
        LOCATION_NAME: 'Hockering',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0656385,
        LOCATION_LATITUDE_DEG: 52.675338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000800',
        LOCATION_NAME: 'Hockerton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9304755,
        LOCATION_LATITUDE_DEG: 53.1007095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001000',
        LOCATION_NAME: 'Hockley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.918451,
        LOCATION_LATITUDE_DEG: 52.5020606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO000900',
        LOCATION_NAME: 'Hockley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6611778,
        LOCATION_LATITUDE_DEG: 52.5996679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001100',
        LOCATION_NAME: 'Hockley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.655708,
        LOCATION_LATITUDE_DEG: 51.600646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001200',
        LOCATION_NAME: 'Hockley Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.775905,
        LOCATION_LATITUDE_DEG: 52.3514463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001300',
        LOCATION_NAME: 'Hockliffe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5835848,
        LOCATION_LATITUDE_DEG: 51.9297885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001400',
        LOCATION_NAME: 'Hockwold',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5394236,
        LOCATION_LATITUDE_DEG: 52.4636246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001500',
        LOCATION_NAME: 'Hockworthy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3681056,
        LOCATION_LATITUDE_DEG: 50.9662305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001600',
        LOCATION_NAME: 'Hoddesdon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0099473,
        LOCATION_LATITUDE_DEG: 51.761964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001700',
        LOCATION_NAME: 'Hoddlesden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4031448,
        LOCATION_LATITUDE_DEG: 53.7062853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001800',
        LOCATION_NAME: 'Hoddom',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3219211,
        LOCATION_LATITUDE_DEG: 55.0440263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO001900',
        LOCATION_NAME: 'Hodge Lea',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8078536,
        LOCATION_LATITUDE_DEG: 52.0489027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002000',
        LOCATION_NAME: 'Hodgeston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8481697,
        LOCATION_LATITUDE_DEG: 51.6583123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002100',
        LOCATION_NAME: 'Hodnet',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5743147,
        LOCATION_LATITUDE_DEG: 52.8534053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002200',
        LOCATION_NAME: 'Hodsock',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0809733,
        LOCATION_LATITUDE_DEG: 53.3623316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002300',
        LOCATION_NAME: 'Hodsoll Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3345331,
        LOCATION_LATITUDE_DEG: 51.3413194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002400',
        LOCATION_NAME: 'Hodson',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7477569,
        LOCATION_LATITUDE_DEG: 51.5213691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002500',
        LOCATION_NAME: 'Hodthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1848873,
        LOCATION_LATITUDE_DEG: 53.2825271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002600',
        LOCATION_NAME: 'Hoe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9553547,
        LOCATION_LATITUDE_DEG: 52.7114457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002700',
        LOCATION_NAME: 'Hoe Benham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4113462,
        LOCATION_LATITUDE_DEG: 51.4272514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002800',
        LOCATION_NAME: 'Hoe Gate',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1101891,
        LOCATION_LATITUDE_DEG: 50.9099041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002900',
        LOCATION_NAME: 'Hoe Hill',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4240552,
        LOCATION_LATITUDE_DEG: 53.6950599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003000',
        LOCATION_NAME: 'Hoebeg',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1117315,
        LOCATION_LATITUDE_DEG: 57.6613185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003100',
        LOCATION_NAME: 'Hoff',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5043435,
        LOCATION_LATITUDE_DEG: 54.5523699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003200',
        LOCATION_NAME: 'Hogganfield',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1628671,
        LOCATION_LATITUDE_DEG: 55.874815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003300',
        LOCATION_NAME: 'Hoggeston',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8277914,
        LOCATION_LATITUDE_DEG: 51.9177893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003400',
        LOCATION_NAME: 'Hoghton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5866405,
        LOCATION_LATITUDE_DEG: 53.7348863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003500',
        LOCATION_NAME: 'Hognaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6495271,
        LOCATION_LATITUDE_DEG: 53.0516148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003600',
        LOCATION_NAME: 'Hogsthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3008228,
        LOCATION_LATITUDE_DEG: 53.2237991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003700',
        LOCATION_NAME: 'Holbeach',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0154285,
        LOCATION_LATITUDE_DEG: 52.803768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003800',
        LOCATION_NAME: 'Holbeach Bank',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0164937,
        LOCATION_LATITUDE_DEG: 52.8280643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO003900',
        LOCATION_NAME: 'Holbeach Clough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0083945,
        LOCATION_LATITUDE_DEG: 52.824672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004000',
        LOCATION_NAME: 'Holbeach Drove',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0338255,
        LOCATION_LATITUDE_DEG: 52.6923562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004100',
        LOCATION_NAME: 'Holbeach Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0272476,
        LOCATION_LATITUDE_DEG: 52.7672657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004200',
        LOCATION_NAME: 'Holbeach Hurn',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0671247,
        LOCATION_LATITUDE_DEG: 52.8225712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046600',
        LOCATION_NAME: 'Holbeach St Johns',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046700',
        LOCATION_NAME: 'Holbeach St Marks',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046800',
        LOCATION_NAME: 'Holbeach St Matthews',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004300',
        LOCATION_NAME: 'Holbeach St. Johns',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.001589,
        LOCATION_LATITUDE_DEG: 52.7458595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004400',
        LOCATION_NAME: 'Holbeach St. Marks',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0349592,
        LOCATION_LATITUDE_DEG: 52.8600752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004500',
        LOCATION_NAME: 'Holbeach St. Matthews',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0993095,
        LOCATION_LATITUDE_DEG: 52.8654109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004700',
        LOCATION_NAME: 'Holbeck',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5617642,
        LOCATION_LATITUDE_DEG: 53.7836847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004600',
        LOCATION_NAME: 'Holbeck',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1845672,
        LOCATION_LATITUDE_DEG: 53.254422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004800',
        LOCATION_NAME: 'Holbeck Woodhouse',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1766135,
        LOCATION_LATITUDE_DEG: 53.2525244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO004900',
        LOCATION_NAME: 'Holberrow Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B96',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.964608,
        LOCATION_LATITUDE_DEG: 52.2294348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005000',
        LOCATION_NAME: 'Holbeton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9477287,
        LOCATION_LATITUDE_DEG: 50.3344791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005100',
        LOCATION_NAME: 'Holborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4431148,
        LOCATION_LATITUDE_DEG: 51.337521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005400',
        LOCATION_NAME: 'Holbrook',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4566375,
        LOCATION_LATITUDE_DEG: 53.0007064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005300',
        LOCATION_NAME: 'Holbrook',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.337456,
        LOCATION_LATITUDE_DEG: 53.328332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005500',
        LOCATION_NAME: 'Holbrook',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1603531,
        LOCATION_LATITUDE_DEG: 51.9833685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005600',
        LOCATION_NAME: 'Holbrooks',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5085566,
        LOCATION_LATITUDE_DEG: 52.4436511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005700',
        LOCATION_NAME: 'Holburn Village',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9349436,
        LOCATION_LATITUDE_DEG: 55.6175655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005800',
        LOCATION_NAME: 'Holbury',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.388898,
        LOCATION_LATITUDE_DEG: 50.8299979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO005900',
        LOCATION_NAME: 'Holcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4786396,
        LOCATION_LATITUDE_DEG: 50.5651975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006000',
        LOCATION_NAME: 'Holcombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4710015,
        LOCATION_LATITUDE_DEG: 51.2441496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006100',
        LOCATION_NAME: 'Holcombe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3289996,
        LOCATION_LATITUDE_DEG: 53.6463738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006200',
        LOCATION_NAME: 'Holcombe Rogus',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3413153,
        LOCATION_LATITUDE_DEG: 50.9598319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006300',
        LOCATION_NAME: 'Holcot',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8371451,
        LOCATION_LATITUDE_DEG: 52.3195283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006400',
        LOCATION_NAME: 'Holden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3470695,
        LOCATION_LATITUDE_DEG: 53.9413081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006500',
        LOCATION_NAME: 'Holdenby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9782274,
        LOCATION_LATITUDE_DEG: 52.3049358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006600',
        LOCATION_NAME: 'Holdenhurst Village',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8170885,
        LOCATION_LATITUDE_DEG: 50.7551979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006700',
        LOCATION_NAME: 'Holdgate',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6452332,
        LOCATION_LATITUDE_DEG: 52.5019751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006800',
        LOCATION_NAME: 'Holdingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4211075,
        LOCATION_LATITUDE_DEG: 53.0106878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO006900',
        LOCATION_NAME: 'Holditch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9281975,
        LOCATION_LATITUDE_DEG: 50.8179142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007000',
        LOCATION_NAME: 'Hole in the Wall',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5619767,
        LOCATION_LATITUDE_DEG: 51.9547905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007100',
        LOCATION_NAME: 'Holes Hole',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2098213,
        LOCATION_LATITUDE_DEG: 50.4644898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007200',
        LOCATION_NAME: 'Holestone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5059339,
        LOCATION_LATITUDE_DEG: 53.1495204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007400',
        LOCATION_NAME: 'Holford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2043994,
        LOCATION_LATITUDE_DEG: 51.163752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007300',
        LOCATION_NAME: 'Holford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8845503,
        LOCATION_LATITUDE_DEG: 52.5186657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007500',
        LOCATION_NAME: 'Holker',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9793608,
        LOCATION_LATITUDE_DEG: 54.1866422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007600',
        LOCATION_NAME: 'Holkham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8177649,
        LOCATION_LATITUDE_DEG: 52.9583661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO990576',
        LOCATION_NAME: 'Hollacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007700',
        LOCATION_NAME: 'Hollacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3009614,
        LOCATION_LATITUDE_DEG: 50.8024287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007800',
        LOCATION_NAME: 'Holland Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1638575,
        LOCATION_LATITUDE_DEG: 53.0324931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO007900',
        LOCATION_NAME: 'Holland Moor',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7470924,
        LOCATION_LATITUDE_DEG: 53.5388678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047400',
        LOCATION_NAME: 'Holland on Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1966571,
        LOCATION_LATITUDE_DEG: 51.8077633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048600',
        LOCATION_NAME: 'Holland Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'W11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2032527,
        LOCATION_LATITUDE_DEG: 51.5115752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008000',
        LOCATION_NAME: 'Holland-on-Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1905135,
        LOCATION_LATITUDE_DEG: 51.8005001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008100',
        LOCATION_NAME: 'Hollesley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4311958,
        LOCATION_LATITUDE_DEG: 52.0471705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008200',
        LOCATION_NAME: 'Hollingbourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6446182,
        LOCATION_LATITUDE_DEG: 51.2672097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008300',
        LOCATION_NAME: 'Hollingbury',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1262552,
        LOCATION_LATITUDE_DEG: 50.8602826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008400',
        LOCATION_NAME: 'Hollingdon',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7341424,
        LOCATION_LATITUDE_DEG: 51.9383921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008500',
        LOCATION_NAME: 'Hollington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9111881,
        LOCATION_LATITUDE_DEG: 52.9464087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008600',
        LOCATION_NAME: 'Hollington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6589415,
        LOCATION_LATITUDE_DEG: 52.9552036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008700',
        LOCATION_NAME: 'Hollingwood',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3817638,
        LOCATION_LATITUDE_DEG: 53.2664315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008800',
        LOCATION_NAME: 'Hollingworth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9897565,
        LOCATION_LATITUDE_DEG: 53.4630555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO008900',
        LOCATION_NAME: 'Hollins',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2867771,
        LOCATION_LATITUDE_DEG: 53.5687696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009000',
        LOCATION_NAME: 'Hollinsclough',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9026499,
        LOCATION_LATITUDE_DEG: 53.195626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009100',
        LOCATION_NAME: 'Hollinwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7115781,
        LOCATION_LATITUDE_DEG: 52.921413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009200',
        LOCATION_NAME: 'Hollocombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9396816,
        LOCATION_LATITUDE_DEG: 50.8824289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009300',
        LOCATION_NAME: 'Hollow Meadows',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5499879,
        LOCATION_LATITUDE_DEG: 53.3852392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009500',
        LOCATION_NAME: 'Holloway',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5146552,
        LOCATION_LATITUDE_DEG: 53.1028166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO049000',
        LOCATION_NAME: 'Holloway',
        COUNTY_NAME: 'London',
        POSTCODE: 'N7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1263498,
        LOCATION_LATITUDE_DEG: 51.5563647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO049300',
        LOCATION_NAME: 'Holloway Head',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9020107,
        LOCATION_LATITUDE_DEG: 52.4746256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009600',
        LOCATION_NAME: 'Hollowell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.986329,
        LOCATION_LATITUDE_DEG: 52.3413316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009700',
        LOCATION_NAME: 'Holly Hall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0994722,
        LOCATION_LATITUDE_DEG: 52.4923636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009900',
        LOCATION_NAME: 'Hollybush',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5365832,
        LOCATION_LATITUDE_DEG: 55.4007735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009800',
        LOCATION_NAME: 'Hollybush',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2092699,
        LOCATION_LATITUDE_DEG: 51.7192019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010000',
        LOCATION_NAME: 'Hollybush',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0353843,
        LOCATION_LATITUDE_DEG: 51.6359909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010400',
        LOCATION_NAME: 'Hollyhurst',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7667246,
        LOCATION_LATITUDE_DEG: 52.5712822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010500',
        LOCATION_NAME: 'Hollym',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0406652,
        LOCATION_LATITUDE_DEG: 53.7053499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047300',
        LOCATION_NAME: 'Hollywood',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8086727,
        LOCATION_LATITUDE_DEG: 54.6458311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011000',
        LOCATION_NAME: 'Hollywood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0966595,
        LOCATION_LATITUDE_DEG: 52.8946992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010900',
        LOCATION_NAME: 'Hollywood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8761717,
        LOCATION_LATITUDE_DEG: 52.3899503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011100',
        LOCATION_NAME: 'Holm',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3310744,
        LOCATION_LATITUDE_DEG: 58.1985716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011200',
        LOCATION_NAME: 'Holmar',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.270461,
        LOCATION_LATITUDE_DEG: 57.36479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011300',
        LOCATION_NAME: 'Holmbridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8176301,
        LOCATION_LATITUDE_DEG: 53.5557599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046900',
        LOCATION_NAME: 'Holmbury St Mary',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011400',
        LOCATION_NAME: 'Holmbury St. Mary',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4089208,
        LOCATION_LATITUDE_DEG: 51.1871195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011600',
        LOCATION_NAME: 'Holmbush',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7567188,
        LOCATION_LATITUDE_DEG: 50.3388863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011500',
        LOCATION_NAME: 'Holmbush',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3044286,
        LOCATION_LATITUDE_DEG: 50.5265038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012300',
        LOCATION_NAME: 'Holme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7295876,
        LOCATION_LATITUDE_DEG: 54.2031374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011800',
        LOCATION_NAME: 'Holme',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.837161,
        LOCATION_LATITUDE_DEG: 53.5490641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011900',
        LOCATION_NAME: 'Holme',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1432364,
        LOCATION_LATITUDE_DEG: 53.5920613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO011700',
        LOCATION_NAME: 'Holme',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8018113,
        LOCATION_LATITUDE_DEG: 53.1229043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012000',
        LOCATION_NAME: 'Holme',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.246367,
        LOCATION_LATITUDE_DEG: 52.070696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012100',
        LOCATION_NAME: 'Holme',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2445898,
        LOCATION_LATITUDE_DEG: 52.4742386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012400',
        LOCATION_NAME: 'Holme Chapel',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1870853,
        LOCATION_LATITUDE_DEG: 53.7517901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012500',
        LOCATION_NAME: 'Holme Hale',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7926247,
        LOCATION_LATITUDE_DEG: 52.6354405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012600',
        LOCATION_NAME: 'Holme Lacy',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6443697,
        LOCATION_LATITUDE_DEG: 52.0191281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012700',
        LOCATION_NAME: 'Holme Next The Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5376932,
        LOCATION_LATITUDE_DEG: 52.9610734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047500',
        LOCATION_NAME: 'Holme on Spalding Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO990402',
        LOCATION_NAME: 'Holme on Swale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012800',
        LOCATION_NAME: 'Holme On The Wolds',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5284162,
        LOCATION_LATITUDE_DEG: 53.9043781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012900',
        LOCATION_NAME: 'Holme Pierrepont',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0618946,
        LOCATION_LATITUDE_DEG: 52.946192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013000',
        LOCATION_NAME: 'Holme Wood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7142178,
        LOCATION_LATITUDE_DEG: 53.772585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013200',
        LOCATION_NAME: 'Holmebridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1529257,
        LOCATION_LATITUDE_DEG: 50.6814926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013100',
        LOCATION_NAME: 'Holme-on-Spalding-Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7661591,
        LOCATION_LATITUDE_DEG: 53.8362731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013300',
        LOCATION_NAME: 'Holmer',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7134629,
        LOCATION_LATITUDE_DEG: 52.080234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013400',
        LOCATION_NAME: 'Holmer Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6925755,
        LOCATION_LATITUDE_DEG: 51.6646708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013500',
        LOCATION_NAME: 'Holmes Chapel',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3562519,
        LOCATION_LATITUDE_DEG: 53.2022353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013600',
        LOCATION_NAME: 'Holmesfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5168177,
        LOCATION_LATITUDE_DEG: 53.294834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013700',
        LOCATION_NAME: 'Holmesmarsh',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9663667,
        LOCATION_LATITUDE_DEG: 52.1881415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013800',
        LOCATION_NAME: 'Holmeswood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8606418,
        LOCATION_LATITUDE_DEG: 53.6445866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO013900',
        LOCATION_NAME: 'Holmewood',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3603822,
        LOCATION_LATITUDE_DEG: 53.1859209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014000',
        LOCATION_NAME: 'Holmfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8731778,
        LOCATION_LATITUDE_DEG: 53.7502779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014100',
        LOCATION_NAME: 'Holmfirth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7861414,
        LOCATION_LATITUDE_DEG: 53.5700638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014200',
        LOCATION_NAME: 'Holmhead',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2716923,
        LOCATION_LATITUDE_DEG: 55.4578769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014300',
        LOCATION_NAME: 'Holmpton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0699971,
        LOCATION_LATITUDE_DEG: 53.6873502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014400',
        LOCATION_NAME: 'Holmrook',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4189819,
        LOCATION_LATITUDE_DEG: 54.383362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014500',
        LOCATION_NAME: 'Holmsley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6935861,
        LOCATION_LATITUDE_DEG: 50.787298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014600',
        LOCATION_NAME: 'Holne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.822369,
        LOCATION_LATITUDE_DEG: 50.5101968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014700',
        LOCATION_NAME: 'Holne Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7693898,
        LOCATION_LATITUDE_DEG: 50.5196943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014800',
        LOCATION_NAME: 'Holnest',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4859671,
        LOCATION_LATITUDE_DEG: 50.8836122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO014900',
        LOCATION_NAME: 'Holnicote',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5563445,
        LOCATION_LATITUDE_DEG: 51.2036585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015000',
        LOCATION_NAME: 'Holsworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.350515,
        LOCATION_LATITUDE_DEG: 50.8106243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015100',
        LOCATION_NAME: 'Holsworthy Beacon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3306145,
        LOCATION_LATITUDE_DEG: 50.8483352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015400',
        LOCATION_NAME: 'Holt',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8803874,
        LOCATION_LATITUDE_DEG: 53.0789286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015500',
        LOCATION_NAME: 'Holt',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1951651,
        LOCATION_LATITUDE_DEG: 51.3569581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015200',
        LOCATION_NAME: 'Holt',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9580331,
        LOCATION_LATITUDE_DEG: 50.8340997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015300',
        LOCATION_NAME: 'Holt',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0923454,
        LOCATION_LATITUDE_DEG: 52.905458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015600',
        LOCATION_NAME: 'Holt End',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8899306,
        LOCATION_LATITUDE_DEG: 52.3235459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015700',
        LOCATION_NAME: 'Holt Heath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2693359,
        LOCATION_LATITUDE_DEG: 52.2647477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015800',
        LOCATION_NAME: 'Holt Pound',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8367847,
        LOCATION_LATITUDE_DEG: 51.18292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO015900',
        LOCATION_NAME: 'Holtby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9710939,
        LOCATION_LATITUDE_DEG: 53.9793915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016200',
        LOCATION_NAME: 'Holton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4485041,
        LOCATION_LATITUDE_DEG: 51.0388262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016100',
        LOCATION_NAME: 'Holton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1346191,
        LOCATION_LATITUDE_DEG: 51.7552848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016000',
        LOCATION_NAME: 'Holton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5289751,
        LOCATION_LATITUDE_DEG: 52.345302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047600',
        LOCATION_NAME: 'Holton cum Beckering',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016300',
        LOCATION_NAME: 'Holton Heath',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0829353,
        LOCATION_LATITUDE_DEG: 50.71949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047700',
        LOCATION_NAME: 'Holton le Clay',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047800',
        LOCATION_NAME: 'Holton le Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047000',
        LOCATION_NAME: 'Holton St Mary',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016400',
        LOCATION_NAME: 'Holton St. Mary',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0041298,
        LOCATION_LATITUDE_DEG: 51.9896733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016500',
        LOCATION_NAME: 'Holton-cum-Beckering',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3235522,
        LOCATION_LATITUDE_DEG: 53.3162169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016600',
        LOCATION_NAME: 'Holton-le-Clay',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0561823,
        LOCATION_LATITUDE_DEG: 53.5021947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016700',
        LOCATION_NAME: 'Holton-le-Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3727719,
        LOCATION_LATITUDE_DEG: 53.4647501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016800',
        LOCATION_NAME: 'Holverston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4008817,
        LOCATION_LATITUDE_DEG: 52.5734277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO016900',
        LOCATION_NAME: 'Holway',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2294172,
        LOCATION_LATITUDE_DEG: 53.2764493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017000',
        LOCATION_NAME: 'Holway Green',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0864041,
        LOCATION_LATITUDE_DEG: 51.0093292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017200',
        LOCATION_NAME: 'Holwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4176972,
        LOCATION_LATITUDE_DEG: 50.8948125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017400',
        LOCATION_NAME: 'Holwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6634844,
        LOCATION_LATITUDE_DEG: 51.7795877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017300',
        LOCATION_NAME: 'Holwell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.910693,
        LOCATION_LATITUDE_DEG: 52.8058768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017100',
        LOCATION_NAME: 'Holwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3034012,
        LOCATION_LATITUDE_DEG: 51.985795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017450',
        LOCATION_NAME: 'Holwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1593077,
        LOCATION_LATITUDE_DEG: 51.787385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017500',
        LOCATION_NAME: 'Holworth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3311791,
        LOCATION_LATITUDE_DEG: 50.6536913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017600',
        LOCATION_NAME: 'Holy City',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9957954,
        LOCATION_LATITUDE_DEG: 50.8401202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017700',
        LOCATION_NAME: 'Holy Cross',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.112953,
        LOCATION_LATITUDE_DEG: 52.4071523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017800',
        LOCATION_NAME: 'Holy Island',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7994256,
        LOCATION_LATITUDE_DEG: 55.671669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO017900',
        LOCATION_NAME: 'Holy Vale',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2902086,
        LOCATION_LATITUDE_DEG: 49.9259644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018000',
        LOCATION_NAME: 'Holybourne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9522701,
        LOCATION_LATITUDE_DEG: 51.165521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018300',
        LOCATION_NAME: 'Holyhead',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6322579,
        LOCATION_LATITUDE_DEG: 53.3093701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018400',
        LOCATION_NAME: 'Holymoorside',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4929846,
        LOCATION_LATITUDE_DEG: 53.2192287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018500',
        LOCATION_NAME: 'Holyport',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7089823,
        LOCATION_LATITUDE_DEG: 51.4927461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018600',
        LOCATION_NAME: 'Holystone',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0696245,
        LOCATION_LATITUDE_DEG: 55.3185362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018700',
        LOCATION_NAME: 'Holystone',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5267168,
        LOCATION_LATITUDE_DEG: 55.0267998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018800',
        LOCATION_NAME: 'Holytown',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9745128,
        LOCATION_LATITUDE_DEG: 55.82151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018900',
        LOCATION_NAME: 'Holywell',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2220256,
        LOCATION_LATITUDE_DEG: 53.2744485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019200',
        LOCATION_NAME: 'Holywell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5752606,
        LOCATION_LATITUDE_DEG: 50.835909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019000',
        LOCATION_NAME: 'Holywell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5007659,
        LOCATION_LATITUDE_DEG: 55.0655031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019250',
        LOCATION_NAME: 'Holywell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5204972,
        LOCATION_LATITUDE_DEG: 52.7329324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019100',
        LOCATION_NAME: 'Holywell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0355691,
        LOCATION_LATITUDE_DEG: 52.3190234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019300',
        LOCATION_NAME: 'Holywell Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1417282,
        LOCATION_LATITUDE_DEG: 50.3852262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019400',
        LOCATION_NAME: 'Holywell Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8709406,
        LOCATION_LATITUDE_DEG: 53.6735711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019500',
        LOCATION_NAME: 'Holywell Lake',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.272597,
        LOCATION_LATITUDE_DEG: 50.9768347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019600',
        LOCATION_NAME: 'Holywell Row',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5095374,
        LOCATION_LATITUDE_DEG: 52.365813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019800',
        LOCATION_NAME: 'Holywood',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8260733,
        LOCATION_LATITUDE_DEG: 54.6463163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019700',
        LOCATION_NAME: 'Holywood',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6537663,
        LOCATION_LATITUDE_DEG: 55.1085334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO019900',
        LOCATION_NAME: 'Hom Green',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6103777,
        LOCATION_LATITUDE_DEG: 51.8966142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020000',
        LOCATION_NAME: 'Home Meadow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1827806,
        LOCATION_LATITUDE_DEG: 52.1992403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020100',
        LOCATION_NAME: 'Homedowns',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1108757,
        LOCATION_LATITUDE_DEG: 51.9879192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020200',
        LOCATION_NAME: 'Homer',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5635421,
        LOCATION_LATITUDE_DEG: 52.6106799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020300',
        LOCATION_NAME: 'Homersfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3556299,
        LOCATION_LATITUDE_DEG: 52.4220125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048700',
        LOCATION_NAME: 'Homerton',
        COUNTY_NAME: 'London',
        POSTCODE: 'E9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0420564,
        LOCATION_LATITUDE_DEG: 51.549484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020400',
        LOCATION_NAME: 'Homington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8233292,
        LOCATION_LATITUDE_DEG: 51.0327184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020500',
        LOCATION_NAME: 'Honcray',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0981224,
        LOCATION_LATITUDE_DEG: 50.3612858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020600',
        LOCATION_NAME: 'Honey Bottom',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3454231,
        LOCATION_LATITUDE_DEG: 51.4289521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020700',
        LOCATION_NAME: 'Honey Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0383159,
        LOCATION_LATITUDE_DEG: 51.3110086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020800',
        LOCATION_NAME: 'Honeyborough',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9529739,
        LOCATION_LATITUDE_DEG: 51.7157994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO020900',
        LOCATION_NAME: 'Honeybourne',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8295893,
        LOCATION_LATITUDE_DEG: 52.0945255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021000',
        LOCATION_NAME: 'Honeychurch',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9440161,
        LOCATION_LATITUDE_DEG: 50.8082236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021100',
        LOCATION_NAME: 'Honeycombe Leaze',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.816164,
        LOCATION_LATITUDE_DEG: 51.7192826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021200',
        LOCATION_NAME: 'Honeydon',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3509229,
        LOCATION_LATITUDE_DEG: 52.220212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021300',
        LOCATION_NAME: 'Honeystreet',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8520751,
        LOCATION_LATITUDE_DEG: 51.35245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021400',
        LOCATION_NAME: 'Honicknowle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1571203,
        LOCATION_LATITUDE_DEG: 50.4094919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021500',
        LOCATION_NAME: 'Honiley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6495616,
        LOCATION_LATITUDE_DEG: 52.3488465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021600',
        LOCATION_NAME: 'Honing',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4514341,
        LOCATION_LATITUDE_DEG: 52.7971448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021700',
        LOCATION_NAME: 'Honingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1096148,
        LOCATION_LATITUDE_DEG: 52.6630386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021900',
        LOCATION_NAME: 'Honington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6116591,
        LOCATION_LATITUDE_DEG: 52.0794156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022000',
        LOCATION_NAME: 'Honington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5951112,
        LOCATION_LATITUDE_DEG: 52.9783906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO021800',
        LOCATION_NAME: 'Honington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8091546,
        LOCATION_LATITUDE_DEG: 52.3353134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022100',
        LOCATION_NAME: 'Honiton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1806779,
        LOCATION_LATITUDE_DEG: 50.8001178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022200',
        LOCATION_NAME: 'Honley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7877829,
        LOCATION_LATITUDE_DEG: 53.6041634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022300',
        LOCATION_NAME: 'Honnington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4095846,
        LOCATION_LATITUDE_DEG: 52.7312942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022600',
        LOCATION_NAME: 'Hoo',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4650882,
        LOCATION_LATITUDE_DEG: 52.7292914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022500',
        LOCATION_NAME: 'Hoo',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5498452,
        LOCATION_LATITUDE_DEG: 51.3865237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022400',
        LOCATION_NAME: 'Hoo',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.301896,
        LOCATION_LATITUDE_DEG: 52.1811913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022700',
        LOCATION_NAME: 'Hoo Meavy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0691075,
        LOCATION_LATITUDE_DEG: 50.4706936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022800',
        LOCATION_NAME: 'Hoo St Werburgh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5650578,
        LOCATION_LATITUDE_DEG: 51.4197235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO022900',
        LOCATION_NAME: 'Hoober',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3838768,
        LOCATION_LATITUDE_DEG: 53.4748531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023000',
        LOCATION_NAME: 'Hoobrook',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2379787,
        LOCATION_LATITUDE_DEG: 52.3693567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023100',
        LOCATION_NAME: 'Hood Green',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5307736,
        LOCATION_LATITUDE_DEG: 53.5216546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023200',
        LOCATION_NAME: 'Hooe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1044905,
        LOCATION_LATITUDE_DEG: 50.3513837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023300',
        LOCATION_NAME: 'Hooe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.399966,
        LOCATION_LATITUDE_DEG: 50.8582717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023400',
        LOCATION_NAME: 'Hoohill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0303867,
        LOCATION_LATITUDE_DEG: 53.8310015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023500',
        LOCATION_NAME: 'Hook',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9295531,
        LOCATION_LATITUDE_DEG: 51.7627277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023700',
        LOCATION_NAME: 'Hook',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8878342,
        LOCATION_LATITUDE_DEG: 51.5585726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023600',
        LOCATION_NAME: 'Hook',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9607802,
        LOCATION_LATITUDE_DEG: 51.2819336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023800',
        LOCATION_NAME: 'Hook',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8460698,
        LOCATION_LATITUDE_DEG: 53.72077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO023900',
        LOCATION_NAME: 'Hook Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.970591,
        LOCATION_LATITUDE_DEG: 51.2709317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024000',
        LOCATION_NAME: 'Hook End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3002997,
        LOCATION_LATITUDE_DEG: 51.6743568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024100',
        LOCATION_NAME: 'Hook Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3684188,
        LOCATION_LATITUDE_DEG: 51.0973892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024200',
        LOCATION_NAME: 'Hook Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3336169,
        LOCATION_LATITUDE_DEG: 53.8111836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024300',
        LOCATION_NAME: 'Hook Norton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4812158,
        LOCATION_LATITUDE_DEG: 51.9953082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024400',
        LOCATION_NAME: 'Hookagate',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7988269,
        LOCATION_LATITUDE_DEG: 52.6746735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024500',
        LOCATION_NAME: 'Hooke',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6586267,
        LOCATION_LATITUDE_DEG: 50.7983064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024600',
        LOCATION_NAME: 'Hookgate',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3768197,
        LOCATION_LATITUDE_DEG: 52.9127061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024700',
        LOCATION_NAME: 'Hooksway',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8313921,
        LOCATION_LATITUDE_DEG: 50.9356958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024800',
        LOCATION_NAME: 'Hookway',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6279717,
        LOCATION_LATITUDE_DEG: 50.7728133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO024900',
        LOCATION_NAME: 'Hookwood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1876304,
        LOCATION_LATITUDE_DEG: 51.1690152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025000',
        LOCATION_NAME: 'Hoole',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8687053,
        LOCATION_LATITUDE_DEG: 53.2023433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025100',
        LOCATION_NAME: 'Hoole Village',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8546121,
        LOCATION_LATITUDE_DEG: 53.2119388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025200',
        LOCATION_NAME: 'Hooley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.15426,
        LOCATION_LATITUDE_DEG: 51.2927264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025300',
        LOCATION_NAME: 'Hoopers Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7645726,
        LOCATION_LATITUDE_DEG: 50.4543994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025400',
        LOCATION_NAME: 'Hooton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9592345,
        LOCATION_LATITUDE_DEG: 53.299651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025500',
        LOCATION_NAME: 'Hooton Levitt',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2170199,
        LOCATION_LATITUDE_DEG: 53.4169441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025600',
        LOCATION_NAME: 'Hooton Pagnell',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2667859,
        LOCATION_LATITUDE_DEG: 53.5662551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025700',
        LOCATION_NAME: 'Hooton Roberts',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2701385,
        LOCATION_LATITUDE_DEG: 53.4679468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025800',
        LOCATION_NAME: 'Hoovers Lane',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5086184,
        LOCATION_LATITUDE_DEG: 51.8861098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO025900',
        LOCATION_NAME: 'Hop Pole',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2408011,
        LOCATION_LATITUDE_DEG: 52.7098611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026200',
        LOCATION_NAME: 'Hope',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1028718,
        LOCATION_LATITUDE_DEG: 52.6563919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026100',
        LOCATION_NAME: 'Hope',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0322113,
        LOCATION_LATITUDE_DEG: 53.1182376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026000',
        LOCATION_NAME: 'Hope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9707519,
        LOCATION_LATITUDE_DEG: 52.6065862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026300',
        LOCATION_NAME: 'Hope',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7416888,
        LOCATION_LATITUDE_DEG: 53.3479432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026400',
        LOCATION_NAME: 'Hope Bagot',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6036948,
        LOCATION_LATITUDE_DEG: 52.3627586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026500',
        LOCATION_NAME: 'Hope Bowdler',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7737695,
        LOCATION_LATITUDE_DEG: 52.5271709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026600',
        LOCATION_NAME: 'Hope Carr',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4933792,
        LOCATION_LATITUDE_DEG: 53.4906603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026700',
        LOCATION_NAME: 'Hope Cove',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.855195,
        LOCATION_LATITUDE_DEG: 50.2430719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026800',
        LOCATION_NAME: 'Hope Mansell',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5445991,
        LOCATION_LATITUDE_DEG: 51.8742052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047900',
        LOCATION_NAME: 'Hope under Dinmore',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027000',
        LOCATION_NAME: 'Hopeman',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4338185,
        LOCATION_LATITUDE_DEG: 57.7056863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027100',
        LOCATION_NAME: 'Hopesay',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8971726,
        LOCATION_LATITUDE_DEG: 52.4437688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027200',
        LOCATION_NAME: 'Hopesgate',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9825505,
        LOCATION_LATITUDE_DEG: 52.6117847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO026900',
        LOCATION_NAME: 'Hope-under-Dinmore',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7160356,
        LOCATION_LATITUDE_DEG: 52.1716373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027400',
        LOCATION_NAME: 'Hopkinstown',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9529685,
        LOCATION_LATITUDE_DEG: 51.7936131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027300',
        LOCATION_NAME: 'Hopkinstown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3547093,
        LOCATION_LATITUDE_DEG: 51.605897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027500',
        LOCATION_NAME: 'Hopperton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3544777,
        LOCATION_LATITUDE_DEG: 54.0022964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027600',
        LOCATION_NAME: 'Hopstone',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3153915,
        LOCATION_LATITUDE_DEG: 52.5445734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028000',
        LOCATION_NAME: 'Hopton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6036766,
        LOCATION_LATITUDE_DEG: 52.8362045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027900',
        LOCATION_NAME: 'Hopton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.084171,
        LOCATION_LATITUDE_DEG: 52.8327916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027700',
        LOCATION_NAME: 'Hopton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9287581,
        LOCATION_LATITUDE_DEG: 52.3726108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027800',
        LOCATION_NAME: 'Hopton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7274605,
        LOCATION_LATITUDE_DEG: 52.5389727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028100',
        LOCATION_NAME: 'Hopton Cangeford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6657707,
        LOCATION_LATITUDE_DEG: 52.4189625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028200',
        LOCATION_NAME: 'Hopton Castle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9345973,
        LOCATION_LATITUDE_DEG: 52.397461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028300',
        LOCATION_NAME: 'Hopton Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9133595,
        LOCATION_LATITUDE_DEG: 52.3883119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028400',
        LOCATION_NAME: 'Hopton Wafers',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5337189,
        LOCATION_LATITUDE_DEG: 52.3841619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028500',
        LOCATION_NAME: 'Hopwas',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7370696,
        LOCATION_LATITUDE_DEG: 52.642576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028600',
        LOCATION_NAME: 'Hopwood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9568229,
        LOCATION_LATITUDE_DEG: 52.3752528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028700',
        LOCATION_NAME: 'Horam',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2456768,
        LOCATION_LATITUDE_DEG: 50.934382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028800',
        LOCATION_NAME: 'Horbling',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3365582,
        LOCATION_LATITUDE_DEG: 52.9026821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO028900',
        LOCATION_NAME: 'Horbling Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2904137,
        LOCATION_LATITUDE_DEG: 52.9049761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029000',
        LOCATION_NAME: 'Horbury',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5537635,
        LOCATION_LATITUDE_DEG: 53.6592715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029200',
        LOCATION_NAME: 'Horden',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3120103,
        LOCATION_LATITUDE_DEG: 54.7630771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029100',
        LOCATION_NAME: 'Horden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5079364,
        LOCATION_LATITUDE_DEG: 51.1328955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029300',
        LOCATION_NAME: 'Horderley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8690802,
        LOCATION_LATITUDE_DEG: 52.4757718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029400',
        LOCATION_NAME: 'Hordle',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6207032,
        LOCATION_LATITUDE_DEG: 50.7609932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029500',
        LOCATION_NAME: 'Hordley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9206707,
        LOCATION_LATITUDE_DEG: 52.8709056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029650',
        LOCATION_NAME: 'Horeb',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3405036,
        LOCATION_LATITUDE_DEG: 52.0573963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029600',
        LOCATION_NAME: 'Horeb',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1618385,
        LOCATION_LATITUDE_DEG: 51.9315321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO049500',
        LOCATION_NAME: 'Horfield',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5809222,
        LOCATION_LATITUDE_DEG: 51.4924958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO049400',
        LOCATION_NAME: 'Horfield Common',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5920037,
        LOCATION_LATITUDE_DEG: 51.4872067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029700',
        LOCATION_NAME: 'Horgabost',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9797769,
        LOCATION_LATITUDE_DEG: 57.8595448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029800',
        LOCATION_NAME: 'Horham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2432936,
        LOCATION_LATITUDE_DEG: 52.3045025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO029900',
        LOCATION_NAME: 'Horkstow',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5068347,
        LOCATION_LATITUDE_DEG: 53.6515566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030000',
        LOCATION_NAME: 'Horley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3893856,
        LOCATION_LATITUDE_DEG: 52.0907206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030100',
        LOCATION_NAME: 'Horley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1575965,
        LOCATION_LATITUDE_DEG: 51.1738164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030200',
        LOCATION_NAME: 'Horn Ash',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8536894,
        LOCATION_LATITUDE_DEG: 50.8358141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030300',
        LOCATION_NAME: 'Horn Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5306909,
        LOCATION_LATITUDE_DEG: 51.6152561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030400',
        LOCATION_NAME: 'Hornblotton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5828896,
        LOCATION_LATITUDE_DEG: 51.1046395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030700',
        LOCATION_NAME: 'Hornby',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.635426,
        LOCATION_LATITUDE_DEG: 54.1117259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030600',
        LOCATION_NAME: 'Hornby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4406562,
        LOCATION_LATITUDE_DEG: 54.4437406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030800',
        LOCATION_NAME: 'Horncastle',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.113032,
        LOCATION_LATITUDE_DEG: 53.207704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO030900',
        LOCATION_NAME: 'Hornchurch',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2189017,
        LOCATION_LATITUDE_DEG: 51.5624477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031000',
        LOCATION_NAME: 'Horncliffe',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1086716,
        LOCATION_LATITUDE_DEG: 55.7421825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031100',
        LOCATION_NAME: 'Horndean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0023115,
        LOCATION_LATITUDE_DEG: 50.9102013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031200',
        LOCATION_NAME: 'Horndon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0909669,
        LOCATION_LATITUDE_DEG: 50.6015059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047200',
        LOCATION_NAME: 'Horndon on the Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031300',
        LOCATION_NAME: 'Horndon-on-the-Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4075275,
        LOCATION_LATITUDE_DEG: 51.5232365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031400',
        LOCATION_NAME: 'Horne',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0867339,
        LOCATION_LATITUDE_DEG: 51.182716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031500',
        LOCATION_NAME: 'Horner',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5761491,
        LOCATION_LATITUDE_DEG: 51.1962524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031600',
        LOCATION_NAME: 'Horney Common',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0724923,
        LOCATION_LATITUDE_DEG: 51.0122938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031700',
        LOCATION_NAME: 'Horning',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4690333,
        LOCATION_LATITUDE_DEG: 52.7037396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031800',
        LOCATION_NAME: 'Horninghold',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8108455,
        LOCATION_LATITUDE_DEG: 52.5650508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO031900',
        LOCATION_NAME: 'Horninglow',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6421948,
        LOCATION_LATITUDE_DEG: 52.8232917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032000',
        LOCATION_NAME: 'Horningsea',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.18737,
        LOCATION_LATITUDE_DEG: 52.2401119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032100',
        LOCATION_NAME: 'Horningsham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2700788,
        LOCATION_LATITUDE_DEG: 51.1728418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032200',
        LOCATION_NAME: 'Horningtoft',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8696887,
        LOCATION_LATITUDE_DEG: 52.7705531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032300',
        LOCATION_NAME: 'Horningtops',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4338743,
        LOCATION_LATITUDE_DEG: 50.4202929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032400',
        LOCATION_NAME: 'Horns Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3109178,
        LOCATION_LATITUDE_DEG: 50.98294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032500',
        LOCATION_NAME: 'Hornsby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.752668,
        LOCATION_LATITUDE_DEG: 54.8452997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032600',
        LOCATION_NAME: 'Hornsby Gate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.744547,
        LOCATION_LATITUDE_DEG: 54.8441004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032700',
        LOCATION_NAME: 'Hornsea',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1654388,
        LOCATION_LATITUDE_DEG: 53.9120738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO049100',
        LOCATION_NAME: 'Hornsey',
        COUNTY_NAME: 'London',
        POSTCODE: 'N8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.122394,
        LOCATION_LATITUDE_DEG: 51.5805929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048900',
        LOCATION_NAME: 'Hornsey Rise',
        COUNTY_NAME: 'London',
        POSTCODE: 'N19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1238536,
        LOCATION_LATITUDE_DEG: 51.5710921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032800',
        LOCATION_NAME: 'Hornton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4258699,
        LOCATION_LATITUDE_DEG: 52.1017209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO032900',
        LOCATION_NAME: 'Horrabridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.093038,
        LOCATION_LATITUDE_DEG: 50.5066962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033000',
        LOCATION_NAME: 'Horringer',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6750982,
        LOCATION_LATITUDE_DEG: 52.2259058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033100',
        LOCATION_NAME: 'Horringford',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2306356,
        LOCATION_LATITUDE_DEG: 50.6643757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033200',
        LOCATION_NAME: 'Horsaclete',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8393882,
        LOCATION_LATITUDE_DEG: 57.8726436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033400',
        LOCATION_NAME: 'Horsea Island',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0893228,
        LOCATION_LATITUDE_DEG: 50.8353923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033700',
        LOCATION_NAME: 'Horsebridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2580382,
        LOCATION_LATITUDE_DEG: 50.5512058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033600',
        LOCATION_NAME: 'Horsebridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5071194,
        LOCATION_LATITUDE_DEG: 51.0710232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033500',
        LOCATION_NAME: 'Horsebridge',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.234906,
        LOCATION_LATITUDE_DEG: 50.866174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033800',
        LOCATION_NAME: 'Horsebrook',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1713891,
        LOCATION_LATITUDE_DEG: 52.6940809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033900',
        LOCATION_NAME: 'Horsedowns',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3336439,
        LOCATION_LATITUDE_DEG: 50.1587731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034000',
        LOCATION_NAME: 'Horsehay',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4880712,
        LOCATION_LATITUDE_DEG: 52.6587833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034100',
        LOCATION_NAME: 'Horseheath',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3536736,
        LOCATION_LATITUDE_DEG: 52.0991964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034200',
        LOCATION_NAME: 'Horsehold',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0258193,
        LOCATION_LATITUDE_DEG: 53.7353844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034300',
        LOCATION_NAME: 'Horsehouse',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9271461,
        LOCATION_LATITUDE_DEG: 54.2275255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO049200',
        LOCATION_NAME: 'Horseley Fields',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1189873,
        LOCATION_LATITUDE_DEG: 52.5896993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034600',
        LOCATION_NAME: 'Horsell',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5604126,
        LOCATION_LATITUDE_DEG: 51.3268352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034700',
        LOCATION_NAME: 'Horsemans Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8241617,
        LOCATION_LATITUDE_DEG: 52.9655213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034800',
        LOCATION_NAME: 'Horsey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9634524,
        LOCATION_LATITUDE_DEG: 51.1477463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034900',
        LOCATION_NAME: 'Horsey',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6435455,
        LOCATION_LATITUDE_DEG: 52.7478389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO990700',
        LOCATION_NAME: 'Horsford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035100',
        LOCATION_NAME: 'Horsforth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6636522,
        LOCATION_LATITUDE_DEG: 53.8318894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035200',
        LOCATION_NAME: 'Horsham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.324744,
        LOCATION_LATITUDE_DEG: 51.0713081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO047100',
        LOCATION_NAME: 'Horsham St Faith',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035300',
        LOCATION_NAME: 'Horsham St. Faith',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2807929,
        LOCATION_LATITUDE_DEG: 52.6879394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035400',
        LOCATION_NAME: 'Horsington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.423536,
        LOCATION_LATITUDE_DEG: 51.0132255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035500',
        LOCATION_NAME: 'Horsington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2133313,
        LOCATION_LATITUDE_DEG: 53.202606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035600',
        LOCATION_NAME: 'Horsley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2325577,
        LOCATION_LATITUDE_DEG: 51.6806916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035700',
        LOCATION_NAME: 'Horsley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8468247,
        LOCATION_LATITUDE_DEG: 54.9894998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035800',
        LOCATION_NAME: 'Horsley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4328859,
        LOCATION_LATITUDE_DEG: 52.9959026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO035900',
        LOCATION_NAME: 'Horsley Cross',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0875751,
        LOCATION_LATITUDE_DEG: 51.9035635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036000',
        LOCATION_NAME: 'Horsley Woodhouse',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.411141,
        LOCATION_LATITUDE_DEG: 52.9995009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036100',
        LOCATION_NAME: 'Horsleycross Street',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0878959,
        LOCATION_LATITUDE_DEG: 51.9141692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036200',
        LOCATION_NAME: 'Horsleys Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8648761,
        LOCATION_LATITUDE_DEG: 51.6467686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036300',
        LOCATION_NAME: 'Horsmonden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4304163,
        LOCATION_LATITUDE_DEG: 51.1384997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036400',
        LOCATION_NAME: 'Horspath',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1724303,
        LOCATION_LATITUDE_DEG: 51.7381839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036500',
        LOCATION_NAME: 'Horstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3511971,
        LOCATION_LATITUDE_DEG: 52.7285401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036600',
        LOCATION_NAME: 'Horsted Keynes',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0263509,
        LOCATION_LATITUDE_DEG: 51.035997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036700',
        LOCATION_NAME: 'Hort Bridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9317994,
        LOCATION_LATITUDE_DEG: 50.9303249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037100',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2010809,
        LOCATION_LATITUDE_DEG: 51.5519998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037000',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9617992,
        LOCATION_LATITUDE_DEG: 50.9289215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037800',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7529034,
        LOCATION_LATITUDE_DEG: 52.8657043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037850',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3527875,
        LOCATION_LATITUDE_DEG: 51.5644806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037700',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2926152,
        LOCATION_LATITUDE_DEG: 54.1476264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037300',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.088483,
        LOCATION_LATITUDE_DEG: 53.1133206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037200',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9579753,
        LOCATION_LATITUDE_DEG: 50.866908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036900',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9544329,
        LOCATION_LATITUDE_DEG: 55.5715642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO036800',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9348329,
        LOCATION_LATITUDE_DEG: 51.3684513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037400',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8033261,
        LOCATION_LATITUDE_DEG: 52.1822178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037500',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6590823,
        LOCATION_LATITUDE_DEG: 51.8637867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037600',
        LOCATION_NAME: 'Horton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5412474,
        LOCATION_LATITUDE_DEG: 51.4728472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO037900',
        LOCATION_NAME: 'Horton Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9386992,
        LOCATION_LATITUDE_DEG: 50.9323202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048000',
        LOCATION_NAME: 'Horton cum Studley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038000',
        LOCATION_NAME: 'Horton Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2970555,
        LOCATION_LATITUDE_DEG: 50.9522072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048100',
        LOCATION_NAME: 'Horton in Ribblesdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038100',
        LOCATION_NAME: 'Horton Kirby',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2463767,
        LOCATION_LATITUDE_DEG: 51.3942301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038200',
        LOCATION_NAME: 'Horton-cum-Studley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1297484,
        LOCATION_LATITUDE_DEG: 51.8058846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038300',
        LOCATION_NAME: 'Horton-in-Ribblesdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2970901,
        LOCATION_LATITUDE_DEG: 54.1460425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038400',
        LOCATION_NAME: 'Horve',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4962887,
        LOCATION_LATITUDE_DEG: 56.9553539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038500',
        LOCATION_NAME: 'Horwich',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5463619,
        LOCATION_LATITUDE_DEG: 53.6006772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038700',
        LOCATION_NAME: 'Horwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1355297,
        LOCATION_LATITUDE_DEG: 51.028149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038600',
        LOCATION_NAME: 'Horwood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3995441,
        LOCATION_LATITUDE_DEG: 51.0433296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038800',
        LOCATION_NAME: 'Hose',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9054825,
        LOCATION_LATITUDE_DEG: 52.8567804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO038900',
        LOCATION_NAME: 'Hosh',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.854585,
        LOCATION_LATITUDE_DEG: 56.3903633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039100',
        LOCATION_NAME: 'Hospitalfield',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.611365,
        LOCATION_LATITUDE_DEG: 56.556362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039200',
        LOCATION_NAME: 'Hosta',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4872254,
        LOCATION_LATITUDE_DEG: 57.6227176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039300',
        LOCATION_NAME: 'Hotham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.642423,
        LOCATION_LATITUDE_DEG: 53.7973685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039400',
        LOCATION_NAME: 'Hothfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8188307,
        LOCATION_LATITUDE_DEG: 51.1704005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039500',
        LOCATION_NAME: 'Hoton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1485269,
        LOCATION_LATITUDE_DEG: 52.7971764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048500',
        LOCATION_NAME: 'Hotwells',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6186081,
        LOCATION_LATITUDE_DEG: 51.4510088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039600',
        LOCATION_NAME: 'Hough',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4268033,
        LOCATION_LATITUDE_DEG: 53.0530196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039700',
        LOCATION_NAME: 'Hough Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8986215,
        LOCATION_LATITUDE_DEG: 53.1830352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048200',
        LOCATION_NAME: 'Hough on the Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039900',
        LOCATION_NAME: 'Houghall',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5543002,
        LOCATION_LATITUDE_DEG: 54.7639846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040100',
        LOCATION_NAME: 'Hougham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6807261,
        LOCATION_LATITUDE_DEG: 52.988893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040000',
        LOCATION_NAME: 'Hougham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2485151,
        LOCATION_LATITUDE_DEG: 51.1083834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040200',
        LOCATION_NAME: 'Hougharry',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5163062,
        LOCATION_LATITUDE_DEG: 57.6085226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039800',
        LOCATION_NAME: 'Hough-on-the-Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6254294,
        LOCATION_LATITUDE_DEG: 53.0063922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040700',
        LOCATION_NAME: 'Houghton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.919854,
        LOCATION_LATITUDE_DEG: 51.7263242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040500',
        LOCATION_NAME: 'Houghton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9229069,
        LOCATION_LATITUDE_DEG: 54.9260128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040600',
        LOCATION_NAME: 'Houghton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5105934,
        LOCATION_LATITUDE_DEG: 51.0908229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040400',
        LOCATION_NAME: 'Houghton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5514448,
        LOCATION_LATITUDE_DEG: 50.8939921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040300',
        LOCATION_NAME: 'Houghton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1164966,
        LOCATION_LATITUDE_DEG: 52.3353233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040800',
        LOCATION_NAME: 'Houghton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6563207,
        LOCATION_LATITUDE_DEG: 52.8063001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO040900',
        LOCATION_NAME: 'Houghton Conquest',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4730081,
        LOCATION_LATITUDE_DEG: 52.062799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041000',
        LOCATION_NAME: 'Houghton Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5142573,
        LOCATION_LATITUDE_DEG: 51.1132222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041100',
        LOCATION_NAME: 'Houghton Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5629809,
        LOCATION_LATITUDE_DEG: 53.4227595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048300',
        LOCATION_NAME: 'Houghton le Side',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041300',
        LOCATION_NAME: 'Houghton le Spring',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4665408,
        LOCATION_LATITUDE_DEG: 54.8432789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048400',
        LOCATION_NAME: 'Houghton on the Hill',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041200',
        LOCATION_NAME: 'Houghton Regis',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.518693,
        LOCATION_LATITUDE_DEG: 51.9041881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041400',
        LOCATION_NAME: 'Houghton-le-Side',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6537307,
        LOCATION_LATITUDE_DEG: 54.5907646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041500',
        LOCATION_NAME: 'Houghton-on-the-Hill',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9929906,
        LOCATION_LATITUDE_DEG: 52.6252368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041600',
        LOCATION_NAME: 'Houlsyke',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.863748,
        LOCATION_LATITUDE_DEG: 54.461436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO990959',
        LOCATION_NAME: 'Houlton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041700',
        LOCATION_NAME: 'Hound Green',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9519517,
        LOCATION_LATITUDE_DEG: 51.3264339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041800',
        LOCATION_NAME: 'Houndmills',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1126159,
        LOCATION_LATITUDE_DEG: 51.2743336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO041900',
        LOCATION_NAME: 'Houndscroft',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2137437,
        LOCATION_LATITUDE_DEG: 51.7186925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042000',
        LOCATION_NAME: 'Houndstone',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6769699,
        LOCATION_LATITUDE_DEG: 50.9519199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042100',
        LOCATION_NAME: 'Hounslow',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.360235,
        LOCATION_LATITUDE_DEG: 51.4671457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042150',
        LOCATION_NAME: 'Houses Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7092691,
        LOCATION_LATITUDE_DEG: 53.6497719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042200',
        LOCATION_NAME: 'Houston',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5473672,
        LOCATION_LATITUDE_DEG: 55.8665203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042300',
        LOCATION_NAME: 'Houstry',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4447786,
        LOCATION_LATITUDE_DEG: 58.2962495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042400',
        LOCATION_NAME: 'Hove',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1695423,
        LOCATION_LATITUDE_DEG: 50.8272765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042500',
        LOCATION_NAME: 'Hove Edge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8000476,
        LOCATION_LATITUDE_DEG: 53.7145813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042600',
        LOCATION_NAME: 'Hoveringham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9582036,
        LOCATION_LATITUDE_DEG: 53.0121018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042700',
        LOCATION_NAME: 'Hoveton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4130481,
        LOCATION_LATITUDE_DEG: 52.7140374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042800',
        LOCATION_NAME: 'Hovingham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9769278,
        LOCATION_LATITUDE_DEG: 54.1736136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO042900',
        LOCATION_NAME: 'How Caple',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.578723,
        LOCATION_LATITUDE_DEG: 51.9691234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043000',
        LOCATION_NAME: 'How Mill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7533485,
        LOCATION_LATITUDE_DEG: 54.9002011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043100',
        LOCATION_NAME: 'Howbeg',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3781851,
        LOCATION_LATITUDE_DEG: 57.2965886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043300',
        LOCATION_NAME: 'Howden',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4961426,
        LOCATION_LATITUDE_DEG: 50.8923306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043200',
        LOCATION_NAME: 'Howden',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.863085,
        LOCATION_LATITUDE_DEG: 53.7462655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043400',
        LOCATION_NAME: 'Howden Dyke',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8496953,
        LOCATION_LATITUDE_DEG: 53.7317633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043500',
        LOCATION_NAME: 'Howden le Wear',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7515313,
        LOCATION_LATITUDE_DEG: 54.6948766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043700',
        LOCATION_NAME: 'Howe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.455099,
        LOCATION_LATITUDE_DEG: 54.2186216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043600',
        LOCATION_NAME: 'Howe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.356972,
        LOCATION_LATITUDE_DEG: 52.5504228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043900',
        LOCATION_NAME: 'Howe Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1363073,
        LOCATION_LATITUDE_DEG: 51.7673724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO043800',
        LOCATION_NAME: 'Howe Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5283675,
        LOCATION_LATITUDE_DEG: 51.6999501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044000',
        LOCATION_NAME: 'Howell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3073694,
        LOCATION_LATITUDE_DEG: 53.0009859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044100',
        LOCATION_NAME: 'Howes',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2708029,
        LOCATION_LATITUDE_DEG: 54.9917216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044300',
        LOCATION_NAME: 'Howey',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3892286,
        LOCATION_LATITUDE_DEG: 52.2179551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044400',
        LOCATION_NAME: 'Howey Road',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3853001,
        LOCATION_LATITUDE_DEG: 52.2248532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044600',
        LOCATION_NAME: 'Howgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5611186,
        LOCATION_LATITUDE_DEG: 54.5767784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044500',
        LOCATION_NAME: 'Howgate',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1998389,
        LOCATION_LATITUDE_DEG: 55.8109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044700',
        LOCATION_NAME: 'Howgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5658779,
        LOCATION_LATITUDE_DEG: 54.3583488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044900',
        LOCATION_NAME: 'Howick',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7228744,
        LOCATION_LATITUDE_DEG: 51.6560907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044800',
        LOCATION_NAME: 'Howick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5914289,
        LOCATION_LATITUDE_DEG: 55.4527458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045000',
        LOCATION_NAME: 'Howle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4537569,
        LOCATION_LATITUDE_DEG: 52.8103949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045100',
        LOCATION_NAME: 'Howle Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5709724,
        LOCATION_LATITUDE_DEG: 51.8827125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045400',
        LOCATION_NAME: 'Howley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0404086,
        LOCATION_LATITUDE_DEG: 50.8815161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045300',
        LOCATION_NAME: 'Howley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.580531,
        LOCATION_LATITUDE_DEG: 53.3919576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045200',
        LOCATION_NAME: 'Howley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3767458,
        LOCATION_LATITUDE_DEG: 51.6490874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045500',
        LOCATION_NAME: 'Howmore',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3862778,
        LOCATION_LATITUDE_DEG: 57.3026856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045700',
        LOCATION_NAME: 'Howsham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8758987,
        LOCATION_LATITUDE_DEG: 54.0575989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045600',
        LOCATION_NAME: 'Howsham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4212989,
        LOCATION_LATITUDE_DEG: 53.524037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045900',
        LOCATION_NAME: 'Howtown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8609656,
        LOCATION_LATITUDE_DEG: 54.5685768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046000',
        LOCATION_NAME: 'Howwood',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5573604,
        LOCATION_LATITUDE_DEG: 55.8084129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046100',
        LOCATION_NAME: 'Hoxne',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2016558,
        LOCATION_LATITUDE_DEG: 52.3513061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO048800',
        LOCATION_NAME: 'Hoxton',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0753559,
        LOCATION_LATITUDE_DEG: 51.531922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046200',
        LOCATION_NAME: 'Hoy',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3317712,
        LOCATION_LATITUDE_DEG: 58.9146078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046300',
        LOCATION_NAME: 'Hoylake',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1769474,
        LOCATION_LATITUDE_DEG: 53.3914606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046400',
        LOCATION_NAME: 'Hoyland',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4365317,
        LOCATION_LATITUDE_DEG: 53.5005536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO046500',
        LOCATION_NAME: 'Hoylandswaine',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.603117,
        LOCATION_LATITUDE_DEG: 53.5381606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000100',
        LOCATION_NAME: 'Hubberholme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1130015,
        LOCATION_LATITUDE_DEG: 54.1996305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000200',
        LOCATION_NAME: 'Hubberston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0506699,
        LOCATION_LATITUDE_DEG: 51.7161169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000300',
        LOCATION_NAME: 'Hubberts Bridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1080728,
        LOCATION_LATITUDE_DEG: 52.9742165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000400',
        LOCATION_NAME: 'Huby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5813409,
        LOCATION_LATITUDE_DEG: 53.9226977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000500',
        LOCATION_NAME: 'Huby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.134729,
        LOCATION_LATITUDE_DEG: 54.0816004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000600',
        LOCATION_NAME: 'Hucclecote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1901592,
        LOCATION_LATITUDE_DEG: 51.8564017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000700',
        LOCATION_NAME: 'Huccombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6750873,
        LOCATION_LATITUDE_DEG: 50.2485698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000800',
        LOCATION_NAME: 'Huckerby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.640705,
        LOCATION_LATITUDE_DEG: 53.4322367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU000900',
        LOCATION_NAME: 'Hucking',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6350691,
        LOCATION_LATITUDE_DEG: 51.2930157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001000',
        LOCATION_NAME: 'Hucknall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2009227,
        LOCATION_LATITUDE_DEG: 53.0377061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001100',
        LOCATION_NAME: 'Huddersfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7814812,
        LOCATION_LATITUDE_DEG: 53.6449724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001200',
        LOCATION_NAME: 'Huddington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0828942,
        LOCATION_LATITUDE_DEG: 52.2141346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001300',
        LOCATION_NAME: 'Huddlesford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7750204,
        LOCATION_LATITUDE_DEG: 52.6839756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001400',
        LOCATION_NAME: 'Hudswell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7743605,
        LOCATION_LATITUDE_DEG: 54.3971426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001500',
        LOCATION_NAME: 'Huggate',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6549671,
        LOCATION_LATITUDE_DEG: 53.9849886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001700',
        LOCATION_NAME: 'Hugglescote',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.366823,
        LOCATION_LATITUDE_DEG: 52.7105765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001800',
        LOCATION_NAME: 'Hughenden',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.731767,
        LOCATION_LATITUDE_DEG: 51.6495701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001900',
        LOCATION_NAME: 'Hughenden Valley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7346276,
        LOCATION_LATITUDE_DEG: 51.6641692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002000',
        LOCATION_NAME: 'Hughley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6411948,
        LOCATION_LATITUDE_DEG: 52.5767757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002100',
        LOCATION_NAME: 'Hugus',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.120517,
        LOCATION_LATITUDE_DEG: 50.2519795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002200',
        LOCATION_NAME: 'Huish',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7921212,
        LOCATION_LATITUDE_DEG: 51.3701555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002300',
        LOCATION_NAME: 'Huish Champflower',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3553173,
        LOCATION_LATITUDE_DEG: 51.0538442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002400',
        LOCATION_NAME: 'Huish Episcopi',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8102809,
        LOCATION_LATITUDE_DEG: 51.0378312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002600',
        LOCATION_NAME: 'Hulcote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9716117,
        LOCATION_LATITUDE_DEG: 52.142712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002500',
        LOCATION_NAME: 'Hulcote',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6223212,
        LOCATION_LATITUDE_DEG: 52.0380041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002700',
        LOCATION_NAME: 'Hulcott',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7623824,
        LOCATION_LATITUDE_DEG: 51.8420869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002800',
        LOCATION_NAME: 'Hull',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3390237,
        LOCATION_LATITUDE_DEG: 53.7447597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU002900',
        LOCATION_NAME: 'Hulland',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6337593,
        LOCATION_LATITUDE_DEG: 53.0196071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003000',
        LOCATION_NAME: 'Hulland Village',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6375292,
        LOCATION_LATITUDE_DEG: 53.0180723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003100',
        LOCATION_NAME: 'Hulland Ward',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.619992,
        LOCATION_LATITUDE_DEG: 53.0203101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003200',
        LOCATION_NAME: 'Hullavington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1501395,
        LOCATION_LATITUDE_DEG: 51.5376767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003300',
        LOCATION_NAME: 'Hullbridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.614862,
        LOCATION_LATITUDE_DEG: 51.6212434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU017300',
        LOCATION_NAME: 'Hulme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2527917,
        LOCATION_LATITUDE_DEG: 53.4662316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003400',
        LOCATION_NAME: 'Hulme',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0990606,
        LOCATION_LATITUDE_DEG: 53.008811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003500',
        LOCATION_NAME: 'Hulme End',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8448753,
        LOCATION_LATITUDE_DEG: 53.1307201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003600',
        LOCATION_NAME: 'Hulme Village',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0999489,
        LOCATION_LATITUDE_DEG: 53.0062121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003700',
        LOCATION_NAME: 'Hulme Walfield',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2247043,
        LOCATION_LATITUDE_DEG: 53.1821308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003800',
        LOCATION_NAME: 'Hulverstone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4372167,
        LOCATION_LATITUDE_DEG: 50.6543769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU003900',
        LOCATION_NAME: 'Humber',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5560162,
        LOCATION_LATITUDE_DEG: 50.5657004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004000',
        LOCATION_NAME: 'Humberston',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0243783,
        LOCATION_LATITUDE_DEG: 53.5329798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004100',
        LOCATION_NAME: 'Humberstone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0597535,
        LOCATION_LATITUDE_DEG: 52.6427607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004200',
        LOCATION_NAME: 'Humberton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3551874,
        LOCATION_LATITUDE_DEG: 54.1103097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004300',
        LOCATION_NAME: 'Humbie',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8642864,
        LOCATION_LATITUDE_DEG: 55.8544958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004400',
        LOCATION_NAME: 'Humbleton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1366419,
        LOCATION_LATITUDE_DEG: 53.7933619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004500',
        LOCATION_NAME: 'Hume',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4706875,
        LOCATION_LATITUDE_DEG: 55.6665722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004600',
        LOCATION_NAME: 'Hummer',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5841613,
        LOCATION_LATITUDE_DEG: 50.9742211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004700',
        LOCATION_NAME: 'Humshaugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1253694,
        LOCATION_LATITUDE_DEG: 55.0347103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004800',
        LOCATION_NAME: 'Huna',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0860281,
        LOCATION_LATITUDE_DEG: 58.6427764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU004900',
        LOCATION_NAME: 'Huncoat',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3360763,
        LOCATION_LATITUDE_DEG: 53.7675915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005000',
        LOCATION_NAME: 'Huncote',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2373564,
        LOCATION_LATITUDE_DEG: 52.5716592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005100',
        LOCATION_NAME: 'Hundalee',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5591539,
        LOCATION_LATITUDE_DEG: 55.4636535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005200',
        LOCATION_NAME: 'Hundall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4181524,
        LOCATION_LATITUDE_DEG: 53.2910313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005300',
        LOCATION_NAME: 'Hunderthwaite',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0205039,
        LOCATION_LATITUDE_DEG: 54.5844633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005400',
        LOCATION_NAME: 'Hundleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.080474,
        LOCATION_LATITUDE_DEG: 53.176302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005500',
        LOCATION_NAME: 'Hundleton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9479823,
        LOCATION_LATITUDE_DEG: 51.6671181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005600',
        LOCATION_NAME: 'Hundon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5381249,
        LOCATION_LATITUDE_DEG: 52.1093888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005700',
        LOCATION_NAME: 'Hundred Acres',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1549916,
        LOCATION_LATITUDE_DEG: 50.9001012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005800',
        LOCATION_NAME: 'Hundred End',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8802772,
        LOCATION_LATITUDE_DEG: 53.6916927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU005900',
        LOCATION_NAME: 'Hundred House',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2961323,
        LOCATION_LATITUDE_DEG: 52.1807444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006000',
        LOCATION_NAME: 'Hungarton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9807381,
        LOCATION_LATITUDE_DEG: 52.6584622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006100',
        LOCATION_NAME: 'Hunger Hill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4862322,
        LOCATION_LATITUDE_DEG: 53.5576705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006300',
        LOCATION_NAME: 'Hungerford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6827704,
        LOCATION_LATITUDE_DEG: 52.4988693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006200',
        LOCATION_NAME: 'Hungerford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7702908,
        LOCATION_LATITUDE_DEG: 50.9077087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006400',
        LOCATION_NAME: 'Hungerford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5142387,
        LOCATION_LATITUDE_DEG: 51.4141529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006500',
        LOCATION_NAME: 'Hungerford Park',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4872465,
        LOCATION_LATITUDE_DEG: 51.4050542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006600',
        LOCATION_NAME: 'Hungerton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7050802,
        LOCATION_LATITUDE_DEG: 52.8644832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006700',
        LOCATION_NAME: 'Hungladder',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3771045,
        LOCATION_LATITUDE_DEG: 57.6551111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006800',
        LOCATION_NAME: 'Hunmanby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3213036,
        LOCATION_LATITUDE_DEG: 54.1819009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU006900',
        LOCATION_NAME: 'Hunmanby Gap',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2685676,
        LOCATION_LATITUDE_DEG: 54.1782056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007000',
        LOCATION_NAME: 'Hunningham',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4441791,
        LOCATION_LATITUDE_DEG: 52.3070404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007100',
        LOCATION_NAME: 'Hunnington',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0507448,
        LOCATION_LATITUDE_DEG: 52.4281536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007300',
        LOCATION_NAME: 'Hunsdon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9456053,
        LOCATION_LATITUDE_DEG: 50.3801835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007200',
        LOCATION_NAME: 'Hunsdon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0573733,
        LOCATION_LATITUDE_DEG: 51.8084698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007400',
        LOCATION_NAME: 'Hunsingore',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3483865,
        LOCATION_LATITUDE_DEG: 53.9770946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007500',
        LOCATION_NAME: 'Hunslet',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5366676,
        LOCATION_LATITUDE_DEG: 53.7828802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007550',
        LOCATION_NAME: 'Hunslet Business Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5244896,
        LOCATION_LATITUDE_DEG: 53.7819696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007600',
        LOCATION_NAME: 'Hunsonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6500231,
        LOCATION_LATITUDE_DEG: 54.7119841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007700',
        LOCATION_NAME: 'Hunstanton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4907153,
        LOCATION_LATITUDE_DEG: 52.9381743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007800',
        LOCATION_NAME: 'Hunstanworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0780715,
        LOCATION_LATITUDE_DEG: 54.8358874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU007900',
        LOCATION_NAME: 'Hunsterson',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4490873,
        LOCATION_LATITUDE_DEG: 53.0164193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008000',
        LOCATION_NAME: 'Hunston',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7753323,
        LOCATION_LATITUDE_DEG: 50.8101872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008100',
        LOCATION_NAME: 'Hunston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8981511,
        LOCATION_LATITUDE_DEG: 52.2786036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008200',
        LOCATION_NAME: 'Hunstrete',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5056998,
        LOCATION_LATITUDE_DEG: 51.3586642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008300',
        LOCATION_NAME: 'Hunsworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.713929,
        LOCATION_LATITUDE_DEG: 53.7391808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008400',
        LOCATION_NAME: 'Hunt End',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9462775,
        LOCATION_LATITUDE_DEG: 52.2759402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU017100',
        LOCATION_NAME: 'Hunters Bar',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3476439,
        LOCATION_LATITUDE_DEG: 53.4111657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008500',
        LOCATION_NAME: 'Hunters Oak',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2375236,
        LOCATION_LATITUDE_DEG: 50.4837951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008600',
        LOCATION_NAME: 'Hunters Quay',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9088727,
        LOCATION_LATITUDE_DEG: 55.9710322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008700',
        LOCATION_NAME: 'Hunterston',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8787813,
        LOCATION_LATITUDE_DEG: 55.7256064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008800',
        LOCATION_NAME: 'Huntingdon',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1837614,
        LOCATION_LATITUDE_DEG: 52.3288232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU008900',
        LOCATION_NAME: 'Huntingfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4334367,
        LOCATION_LATITUDE_DEG: 52.3149003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009100',
        LOCATION_NAME: 'Huntingford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4109558,
        LOCATION_LATITUDE_DEG: 51.6420846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009000',
        LOCATION_NAME: 'Huntingford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2721987,
        LOCATION_LATITUDE_DEG: 51.0687326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU990882',
        LOCATION_NAME: 'Huntington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009550',
        LOCATION_NAME: 'Huntington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0980564,
        LOCATION_LATITUDE_DEG: 52.1741221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009200',
        LOCATION_NAME: 'Huntington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7487954,
        LOCATION_LATITUDE_DEG: 52.0732351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009400',
        LOCATION_NAME: 'Huntington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5110024,
        LOCATION_LATITUDE_DEG: 52.6674887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009300',
        LOCATION_NAME: 'Huntington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0401358,
        LOCATION_LATITUDE_DEG: 52.7145798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009500',
        LOCATION_NAME: 'Huntington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0672533,
        LOCATION_LATITUDE_DEG: 53.9872957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009600',
        LOCATION_NAME: 'Huntingtowerfield',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5358824,
        LOCATION_LATITUDE_DEG: 56.4234679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009700',
        LOCATION_NAME: 'Huntley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4037485,
        LOCATION_LATITUDE_DEG: 51.8717065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009800',
        LOCATION_NAME: 'Huntly',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7829255,
        LOCATION_LATITUDE_DEG: 57.4471521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010000',
        LOCATION_NAME: 'Hunton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7101766,
        LOCATION_LATITUDE_DEG: 54.3264392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU009900',
        LOCATION_NAME: 'Hunton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4605664,
        LOCATION_LATITUDE_DEG: 51.2174097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU017400',
        LOCATION_NAME: 'Hunts Cross',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8541254,
        LOCATION_LATITUDE_DEG: 53.3612584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010100',
        LOCATION_NAME: 'Hunts Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3894015,
        LOCATION_LATITUDE_DEG: 51.4299538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010200',
        LOCATION_NAME: 'Huntsham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4232755,
        LOCATION_LATITUDE_DEG: 50.9734319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010300',
        LOCATION_NAME: 'Huntshaw',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1067991,
        LOCATION_LATITUDE_DEG: 50.9739389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010400',
        LOCATION_NAME: 'Huntshieldford',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1708973,
        LOCATION_LATITUDE_DEG: 54.7383852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010500',
        LOCATION_NAME: 'Huntworth',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9801352,
        LOCATION_LATITUDE_DEG: 51.1050421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010600',
        LOCATION_NAME: 'Hunwick',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7038543,
        LOCATION_LATITUDE_DEG: 54.6876692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010700',
        LOCATION_NAME: 'Hunworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0702674,
        LOCATION_LATITUDE_DEG: 52.8774576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010900',
        LOCATION_NAME: 'Hurcott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.715375,
        LOCATION_LATITUDE_DEG: 51.0662311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU010800',
        LOCATION_NAME: 'Hurcott',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2171923,
        LOCATION_LATITUDE_DEG: 52.3960555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011000',
        LOCATION_NAME: 'Hurdcott',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7557811,
        LOCATION_LATITUDE_DEG: 51.1033282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011100',
        LOCATION_NAME: 'Hurdlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8232294,
        LOCATION_LATITUDE_DEG: 53.1967303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011200',
        LOCATION_NAME: 'Hurdsfield',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1143134,
        LOCATION_LATITUDE_DEG: 53.2640418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011400',
        LOCATION_NAME: 'Hurleston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5593073,
        LOCATION_LATITUDE_DEG: 53.0928277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011500',
        LOCATION_NAME: 'Hurlet',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3688012,
        LOCATION_LATITUDE_DEG: 55.8218181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011700',
        LOCATION_NAME: 'Hurley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6479838,
        LOCATION_LATITUDE_DEG: 52.5582623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011600',
        LOCATION_NAME: 'Hurley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8086123,
        LOCATION_LATITUDE_DEG: 51.5459595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011800',
        LOCATION_NAME: 'Hurlford',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4518784,
        LOCATION_LATITUDE_DEG: 55.600494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011900',
        LOCATION_NAME: 'Hurliness',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2407385,
        LOCATION_LATITUDE_DEG: 58.7847977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012000',
        LOCATION_NAME: 'Hurn',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8196626,
        LOCATION_LATITUDE_DEG: 50.7715973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012100',
        LOCATION_NAME: 'Hursey',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8051861,
        LOCATION_LATITUDE_DEG: 50.8209145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012200',
        LOCATION_NAME: 'Hursley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3891493,
        LOCATION_LATITUDE_DEG: 51.0248162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012300',
        LOCATION_NAME: 'Hurst',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7718398,
        LOCATION_LATITUDE_DEG: 50.9666295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012500',
        LOCATION_NAME: 'Hurst',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9295708,
        LOCATION_LATITUDE_DEG: 54.4160461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012400',
        LOCATION_NAME: 'Hurst',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8504477,
        LOCATION_LATITUDE_DEG: 51.4574459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012800',
        LOCATION_NAME: 'Hurst Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4779504,
        LOCATION_LATITUDE_DEG: 53.8363978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012700',
        LOCATION_NAME: 'Hurst Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0202731,
        LOCATION_LATITUDE_DEG: 52.47016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU990312',
        LOCATION_NAME: 'Hurst Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0014579,
        LOCATION_LATITUDE_DEG: 51.244028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012600',
        LOCATION_NAME: 'Hurst Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.468205,
        LOCATION_LATITUDE_DEG: 51.0177878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU012900',
        LOCATION_NAME: 'Hurst Park',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3597296,
        LOCATION_LATITUDE_DEG: 51.4081418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013000',
        LOCATION_NAME: 'Hurstbourne Priors',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3731628,
        LOCATION_LATITUDE_DEG: 51.2149289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013100',
        LOCATION_NAME: 'Hurstbourne Tarrant',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4515368,
        LOCATION_LATITUDE_DEG: 51.2758362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013200',
        LOCATION_NAME: 'Hurstead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1219274,
        LOCATION_LATITUDE_DEG: 53.6363722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013300',
        LOCATION_NAME: 'Hurstpierpoint',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1780506,
        LOCATION_LATITUDE_DEG: 50.9332916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013400',
        LOCATION_NAME: 'Hurtmore',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6396698,
        LOCATION_LATITUDE_DEG: 51.1999232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013500',
        LOCATION_NAME: 'Hurworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5291007,
        LOCATION_LATITUDE_DEG: 54.49073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013600',
        LOCATION_NAME: 'Hurworth Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5256007,
        LOCATION_LATITUDE_DEG: 54.5076498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013700',
        LOCATION_NAME: 'Hurworth Place',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5440967,
        LOCATION_LATITUDE_DEG: 54.4889539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013800',
        LOCATION_NAME: 'Husbands Bosworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0519982,
        LOCATION_LATITUDE_DEG: 52.4529481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU013900',
        LOCATION_NAME: 'Husborne Crawley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5999545,
        LOCATION_LATITUDE_DEG: 52.0108982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014000',
        LOCATION_NAME: 'Hushinish',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0938834,
        LOCATION_LATITUDE_DEG: 57.9959586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014100',
        LOCATION_NAME: 'Husthwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2053721,
        LOCATION_LATITUDE_DEG: 54.1688116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014200',
        LOCATION_NAME: 'Hutchesontown',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2433964,
        LOCATION_LATITUDE_DEG: 55.8448168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014300',
        LOCATION_NAME: 'Huthwaite',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2993343,
        LOCATION_LATITUDE_DEG: 53.1279146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014400',
        LOCATION_NAME: 'Huttoft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2669033,
        LOCATION_LATITUDE_DEG: 53.2624039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014500',
        LOCATION_NAME: 'Hutton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9315157,
        LOCATION_LATITUDE_DEG: 51.3239653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014800',
        LOCATION_NAME: 'Hutton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7690152,
        LOCATION_LATITUDE_DEG: 53.7323895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014600',
        LOCATION_NAME: 'Hutton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1464925,
        LOCATION_LATITUDE_DEG: 55.7772789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014900',
        LOCATION_NAME: 'Hutton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.438248,
        LOCATION_LATITUDE_DEG: 53.9650799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU014700',
        LOCATION_NAME: 'Hutton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3545457,
        LOCATION_LATITUDE_DEG: 51.6330512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015000',
        LOCATION_NAME: 'Hutton Bank',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.509243,
        LOCATION_LATITUDE_DEG: 54.1447168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015100',
        LOCATION_NAME: 'Hutton Bonville',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4812131,
        LOCATION_LATITUDE_DEG: 54.396338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015200',
        LOCATION_NAME: 'Hutton Buscel',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5060649,
        LOCATION_LATITUDE_DEG: 54.2437092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015300',
        LOCATION_NAME: 'Hutton Conyers',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5050464,
        LOCATION_LATITUDE_DEG: 54.1551174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015400',
        LOCATION_NAME: 'Hutton End',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8549384,
        LOCATION_LATITUDE_DEG: 54.7386917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015500',
        LOCATION_NAME: 'Hutton Henry',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3382776,
        LOCATION_LATITUDE_DEG: 54.7192729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016900',
        LOCATION_NAME: 'Hutton in the Forest',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU017000',
        LOCATION_NAME: 'Hutton le Hole',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015600',
        LOCATION_NAME: 'Hutton Magna',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8039343,
        LOCATION_LATITUDE_DEG: 54.5073518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015700',
        LOCATION_NAME: 'Hutton Mulgrave',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7107059,
        LOCATION_LATITUDE_DEG: 54.4795405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015900',
        LOCATION_NAME: 'Hutton Roof',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9749749,
        LOCATION_LATITUDE_DEG: 54.6974835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU015800',
        LOCATION_NAME: 'Hutton Roof',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6582672,
        LOCATION_LATITUDE_DEG: 54.1986314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016000',
        LOCATION_NAME: 'Hutton Rudby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2741491,
        LOCATION_LATITUDE_DEG: 54.4505401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016100',
        LOCATION_NAME: 'Hutton Sessay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2745475,
        LOCATION_LATITUDE_DEG: 54.1780121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016200',
        LOCATION_NAME: 'Hutton Wandesley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2280314,
        LOCATION_LATITUDE_DEG: 53.9478955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016300',
        LOCATION_NAME: 'Hutton-in-the-Forest',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8407683,
        LOCATION_LATITUDE_DEG: 54.7167883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016400',
        LOCATION_NAME: 'Hutton-le-Hole',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9170309,
        LOCATION_LATITUDE_DEG: 54.3015227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016500',
        LOCATION_NAME: 'Huttons Ambo',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8388972,
        LOCATION_LATITUDE_DEG: 54.100701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016600',
        LOCATION_NAME: 'Huxham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4847518,
        LOCATION_LATITUDE_DEG: 50.7755162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016700',
        LOCATION_NAME: 'Huxley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7352022,
        LOCATION_LATITUDE_DEG: 53.1477365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU016800',
        LOCATION_NAME: 'Huyton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8433494,
        LOCATION_LATITUDE_DEG: 53.4091613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000100',
        LOCATION_NAME: 'Hyde',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1946304,
        LOCATION_LATITUDE_DEG: 50.7194919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000300',
        LOCATION_NAME: 'Hyde',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0864904,
        LOCATION_LATITUDE_DEG: 53.4449557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000200',
        LOCATION_NAME: 'Hyde',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7594466,
        LOCATION_LATITUDE_DEG: 50.9087121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000400',
        LOCATION_NAME: 'Hyde Ash',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8068445,
        LOCATION_LATITUDE_DEG: 52.1938451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000500',
        LOCATION_NAME: 'Hyde End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6612584,
        LOCATION_LATITUDE_DEG: 51.7012694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000600',
        LOCATION_NAME: 'Hyde Heath',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6523667,
        LOCATION_LATITUDE_DEG: 51.6931731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000700',
        LOCATION_NAME: 'Hyde Lea',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1292478,
        LOCATION_LATITUDE_DEG: 52.7802914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001700',
        LOCATION_NAME: 'Hyde Park',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5610034,
        LOCATION_LATITUDE_DEG: 53.8158539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000800',
        LOCATION_NAME: 'Hyde Park',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1272452,
        LOCATION_LATITUDE_DEG: 53.5130522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY000900',
        LOCATION_NAME: 'Hydestile',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6073808,
        LOCATION_LATITUDE_DEG: 51.1546205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001600',
        LOCATION_NAME: 'Hyndland',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3057407,
        LOCATION_LATITUDE_DEG: 55.87916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001000',
        LOCATION_NAME: 'Hyssington',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0140508,
        LOCATION_LATITUDE_DEG: 52.5443817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001100',
        LOCATION_NAME: 'Hystfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4801276,
        LOCATION_LATITUDE_DEG: 51.6611916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001300',
        LOCATION_NAME: 'Hythe',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4001465,
        LOCATION_LATITUDE_DEG: 50.8597981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001200',
        LOCATION_NAME: 'Hythe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0850177,
        LOCATION_LATITUDE_DEG: 51.0699862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001400',
        LOCATION_NAME: 'Hythe Marina Village',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3987493,
        LOCATION_LATITUDE_DEG: 50.8712038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HY001500',
        LOCATION_NAME: 'Hythie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9880682,
        LOCATION_LATITUDE_DEG: 57.5516538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IA000100',
        LOCATION_NAME: 'Ianstown',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9321071,
        LOCATION_LATITUDE_DEG: 57.6860818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000100',
        LOCATION_NAME: 'Ibberton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2998021,
        LOCATION_LATITUDE_DEG: 50.8693095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000200',
        LOCATION_NAME: 'Ible',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6286135,
        LOCATION_LATITUDE_DEG: 53.1118213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000300',
        LOCATION_NAME: 'Ibrox',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3039679,
        LOCATION_LATITUDE_DEG: 55.8557149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000400',
        LOCATION_NAME: 'Ibsley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7882681,
        LOCATION_LATITUDE_DEG: 50.8831096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000500',
        LOCATION_NAME: 'Ibstock',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3994886,
        LOCATION_LATITUDE_DEG: 52.6883773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000600',
        LOCATION_NAME: 'Ibstone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9056175,
        LOCATION_LATITUDE_DEG: 51.6278661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000700',
        LOCATION_NAME: 'Ibstone Common',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9161763,
        LOCATION_LATITUDE_DEG: 51.6334675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000800',
        LOCATION_NAME: 'Ibthorpe',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4585564,
        LOCATION_LATITUDE_DEG: 51.2824428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB000900',
        LOCATION_NAME: 'Iburndale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6532454,
        LOCATION_LATITUDE_DEG: 54.4501318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IB001000',
        LOCATION_NAME: 'Ibworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1877829,
        LOCATION_LATITUDE_DEG: 51.2884407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000100',
        LOCATION_NAME: 'Ickburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6675809,
        LOCATION_LATITUDE_DEG: 52.5212296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000200',
        LOCATION_NAME: 'Ickenham',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4421657,
        LOCATION_LATITUDE_DEG: 51.5638521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000300',
        LOCATION_NAME: 'Ickford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0577602,
        LOCATION_LATITUDE_DEG: 51.7597835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000400',
        LOCATION_NAME: 'Ickham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1873508,
        LOCATION_LATITUDE_DEG: 51.2765027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000500',
        LOCATION_NAME: 'Ickleford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.278275,
        LOCATION_LATITUDE_DEG: 51.9698908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000600',
        LOCATION_NAME: 'Icklesham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6685006,
        LOCATION_LATITUDE_DEG: 50.9146766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000700',
        LOCATION_NAME: 'Ickleton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1790489,
        LOCATION_LATITUDE_DEG: 52.071897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000800',
        LOCATION_NAME: 'Icklingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6034977,
        LOCATION_LATITUDE_DEG: 52.3237129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000900',
        LOCATION_NAME: 'Ickwell',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3203162,
        LOCATION_LATITUDE_DEG: 52.0965028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC000950',
        LOCATION_NAME: 'Ickworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6599647,
        LOCATION_LATITUDE_DEG: 52.2199524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IC001000',
        LOCATION_NAME: 'Icomb',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6905245,
        LOCATION_LATITUDE_DEG: 51.9018994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000100',
        LOCATION_NAME: 'Idbury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6592924,
        LOCATION_LATITUDE_DEG: 51.8780025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000200',
        LOCATION_NAME: 'Iddenshall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6957071,
        LOCATION_LATITUDE_DEG: 53.164237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000300',
        LOCATION_NAME: 'Iddesleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0286765,
        LOCATION_LATITUDE_DEG: 50.8556318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000400',
        LOCATION_NAME: 'Ide',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5589676,
        LOCATION_LATITUDE_DEG: 50.7012079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000500',
        LOCATION_NAME: 'Ide Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1297114,
        LOCATION_LATITUDE_DEG: 51.2459193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000600',
        LOCATION_NAME: 'Ideford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5617367,
        LOCATION_LATITUDE_DEG: 50.5840986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000700',
        LOCATION_NAME: 'Ideford Combe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.593666,
        LOCATION_LATITUDE_DEG: 50.5677996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000800',
        LOCATION_NAME: 'Iden',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7327149,
        LOCATION_LATITUDE_DEG: 50.9815828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID000900',
        LOCATION_NAME: 'Iden Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4953129,
        LOCATION_LATITUDE_DEG: 51.1093022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001000',
        LOCATION_NAME: 'Ides Common',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6661835,
        LOCATION_LATITUDE_DEG: 50.888893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001100',
        LOCATION_NAME: 'Idle',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7336932,
        LOCATION_LATITUDE_DEG: 53.8338901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001200',
        LOCATION_NAME: 'Idle Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7406829,
        LOCATION_LATITUDE_DEG: 53.8290873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001300',
        LOCATION_NAME: 'Idless',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0592162,
        LOCATION_LATITUDE_DEG: 50.285981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001400',
        LOCATION_NAME: 'Idlicote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5815859,
        LOCATION_LATITUDE_DEG: 52.0945176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001500',
        LOCATION_NAME: 'Idmiston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7182497,
        LOCATION_LATITUDE_DEG: 51.1349265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001600',
        LOCATION_NAME: 'Idole',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2922985,
        LOCATION_LATITUDE_DEG: 51.8165255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001700',
        LOCATION_NAME: 'Idridgehay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5734592,
        LOCATION_LATITUDE_DEG: 53.037009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001800',
        LOCATION_NAME: 'Idrigill',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3749488,
        LOCATION_LATITUDE_DEG: 57.5878072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID001900',
        LOCATION_NAME: 'Idstone',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6280768,
        LOCATION_LATITUDE_DEG: 51.5560675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID002000',
        LOCATION_NAME: 'Idsworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9603101,
        LOCATION_LATITUDE_DEG: 50.9098978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ID002100',
        LOCATION_NAME: 'Idvies',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7636627,
        LOCATION_LATITUDE_DEG: 56.6196742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IF000100',
        LOCATION_NAME: 'Iffley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2325112,
        LOCATION_LATITUDE_DEG: 51.728682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IF000200',
        LOCATION_NAME: 'Ifield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.210395,
        LOCATION_LATITUDE_DEG: 51.1216077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IF000300',
        LOCATION_NAME: 'Ifold',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5403901,
        LOCATION_LATITUDE_DEG: 51.0686061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IF000500',
        LOCATION_NAME: 'Iford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2840642,
        LOCATION_LATITUDE_DEG: 51.3277566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IF000400',
        LOCATION_NAME: 'Iford',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0044845,
        LOCATION_LATITUDE_DEG: 50.8467773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IF000600',
        LOCATION_NAME: 'Ifton Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9992278,
        LOCATION_LATITUDE_DEG: 52.9297173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IG000100',
        LOCATION_NAME: 'Ightfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6058877,
        LOCATION_LATITUDE_DEG: 52.9406091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IG000200',
        LOCATION_NAME: 'Ightfield Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6113815,
        LOCATION_LATITUDE_DEG: 52.930215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IG000300',
        LOCATION_NAME: 'Ightham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.288192,
        LOCATION_LATITUDE_DEG: 51.2874136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IK000100',
        LOCATION_NAME: 'Iken',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5225138,
        LOCATION_LATITUDE_DEG: 52.148482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000100',
        LOCATION_NAME: 'Ilam',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7987912,
        LOCATION_LATITUDE_DEG: 53.0541095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000200',
        LOCATION_NAME: 'Ilchester',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6777176,
        LOCATION_LATITUDE_DEG: 51.0072253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000300',
        LOCATION_NAME: 'Ilderton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9734244,
        LOCATION_LATITUDE_DEG: 55.4913569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000500',
        LOCATION_NAME: 'Ilford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8978936,
        LOCATION_LATITUDE_DEG: 50.9529216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000400',
        LOCATION_NAME: 'Ilford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.071739,
        LOCATION_LATITUDE_DEG: 51.5572426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000600',
        LOCATION_NAME: 'Ilfracombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.126103,
        LOCATION_LATITUDE_DEG: 51.2077593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000700',
        LOCATION_NAME: 'Ilkeston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3038954,
        LOCATION_LATITUDE_DEG: 52.974998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000800',
        LOCATION_NAME: 'Ilketshall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4979647,
        LOCATION_LATITUDE_DEG: 52.4281106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL003100',
        LOCATION_NAME: 'Ilketshall St John',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL003200',
        LOCATION_NAME: 'Ilketshall St Lawrence',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL003300',
        LOCATION_NAME: 'Ilketshall St Margaret',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL000900',
        LOCATION_NAME: 'Ilketshall St. John',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4858825,
        LOCATION_LATITUDE_DEG: 52.4348095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001000',
        LOCATION_NAME: 'Ilketshall St. Lawrence',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4981676,
        LOCATION_LATITUDE_DEG: 52.3991034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001100',
        LOCATION_NAME: 'Ilketshall St. Margaret',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4549249,
        LOCATION_LATITUDE_DEG: 52.414805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001200',
        LOCATION_NAME: 'Ilkley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.821891,
        LOCATION_LATITUDE_DEG: 53.924302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001300',
        LOCATION_NAME: 'Illand',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4172465,
        LOCATION_LATITUDE_DEG: 50.5791057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001400',
        LOCATION_NAME: 'Illeray',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3494913,
        LOCATION_LATITUDE_DEG: 57.5514153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001500',
        LOCATION_NAME: 'Illey',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0254629,
        LOCATION_LATITUDE_DEG: 52.4320549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001600',
        LOCATION_NAME: 'Illington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8645347,
        LOCATION_LATITUDE_DEG: 52.4707184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001700',
        LOCATION_NAME: 'Illingworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8903667,
        LOCATION_LATITUDE_DEG: 53.7598862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001800',
        LOCATION_NAME: 'Illogan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2664654,
        LOCATION_LATITUDE_DEG: 50.2441863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL001900',
        LOCATION_NAME: 'Illogan Churchtown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2648311,
        LOCATION_LATITUDE_DEG: 50.247984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002000',
        LOCATION_NAME: 'Illogan Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2672376,
        LOCATION_LATITUDE_DEG: 50.239684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002100',
        LOCATION_NAME: 'Illogan Highway',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2539268,
        LOCATION_LATITUDE_DEG: 50.2279838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002200',
        LOCATION_NAME: 'Illston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9549675,
        LOCATION_LATITUDE_DEG: 52.587657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002300',
        LOCATION_NAME: 'Ilmer',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8836011,
        LOCATION_LATITUDE_DEG: 51.7429801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002400',
        LOCATION_NAME: 'Ilmington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6899177,
        LOCATION_LATITUDE_DEG: 52.0890168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002500',
        LOCATION_NAME: 'Ilminster',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9128184,
        LOCATION_LATITUDE_DEG: 50.9276239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002600',
        LOCATION_NAME: 'Ilsington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7131641,
        LOCATION_LATITUDE_DEG: 50.5722012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002700',
        LOCATION_NAME: 'Ilsom',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.151797,
        LOCATION_LATITUDE_DEG: 51.6370853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002800',
        LOCATION_NAME: 'Ilston',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0846378,
        LOCATION_LATITUDE_DEG: 51.5931959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL003000',
        LOCATION_NAME: 'Ilton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9223265,
        LOCATION_LATITUDE_DEG: 50.9536216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IL002900',
        LOCATION_NAME: 'Ilton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7092375,
        LOCATION_LATITUDE_DEG: 54.2000248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IM003001',
        LOCATION_NAME: 'Imeroo',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4135415,
        LOCATION_LATITUDE_DEG: 54.4075747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IM000100',
        LOCATION_NAME: 'Immingham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2096305,
        LOCATION_LATITUDE_DEG: 53.6153481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IM000200',
        LOCATION_NAME: 'Immingham Dock',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1747202,
        LOCATION_LATITUDE_DEG: 53.6198464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IM000300',
        LOCATION_NAME: 'Impington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1205132,
        LOCATION_LATITUDE_DEG: 52.2475105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IM000400',
        LOCATION_NAME: 'Impney',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1319101,
        LOCATION_LATITUDE_DEG: 52.2712392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000200',
        LOCATION_NAME: 'Ince',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8242592,
        LOCATION_LATITUDE_DEG: 53.2815473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000300',
        LOCATION_NAME: 'Ince',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.608573,
        LOCATION_LATITUDE_DEG: 53.5400664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000400',
        LOCATION_NAME: 'Ince Blundell',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0242938,
        LOCATION_LATITUDE_DEG: 53.5233749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000500',
        LOCATION_NAME: 'Ince Castle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2492318,
        LOCATION_LATITUDE_DEG: 50.3861846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN013400',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1551414,
        LOCATION_LATITUDE_DEG: 55.9590495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001300',
        LOCATION_NAME: 'Inchbare',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6437001,
        LOCATION_LATITUDE_DEG: 56.780689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001400',
        LOCATION_NAME: 'Inchbrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2279056,
        LOCATION_LATITUDE_DEG: 51.7048898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001500',
        LOCATION_NAME: 'Inches',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8186872,
        LOCATION_LATITUDE_DEG: 50.4404967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001800',
        LOCATION_NAME: 'Inchinnan',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4361298,
        LOCATION_LATITUDE_DEG: 55.8914254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001900',
        LOCATION_NAME: 'Inchmarlo',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5484499,
        LOCATION_LATITUDE_DEG: 57.0668175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002000',
        LOCATION_NAME: 'Inchree',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2236737,
        LOCATION_LATITUDE_DEG: 56.7204125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002100',
        LOCATION_NAME: 'Inchture',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1708872,
        LOCATION_LATITUDE_DEG: 56.4441629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002200',
        LOCATION_NAME: 'Indian Queens',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9308111,
        LOCATION_LATITUDE_DEG: 50.3919959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN991011',
        LOCATION_NAME: 'Ingarsby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.987951,
        LOCATION_LATITUDE_DEG: 52.641775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002300',
        LOCATION_NAME: 'Ingatestone',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3880211,
        LOCATION_LATITUDE_DEG: 51.6710493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002400',
        LOCATION_NAME: 'Ingbirchworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6612688,
        LOCATION_LATITUDE_DEG: 53.5485604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002500',
        LOCATION_NAME: 'Ingestre',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0293993,
        LOCATION_LATITUDE_DEG: 52.8200963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002600',
        LOCATION_NAME: 'Ingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5744173,
        LOCATION_LATITUDE_DEG: 53.3396266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002800',
        LOCATION_NAME: 'Ingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7201436,
        LOCATION_LATITUDE_DEG: 52.3005051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002700',
        LOCATION_NAME: 'Ingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5449652,
        LOCATION_LATITUDE_DEG: 52.7786428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002900',
        LOCATION_NAME: 'Ingleby',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4826044,
        LOCATION_LATITUDE_DEG: 52.8391921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003000',
        LOCATION_NAME: 'Ingleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6621555,
        LOCATION_LATITUDE_DEG: 53.2917256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003100',
        LOCATION_NAME: 'Ingleby Arncliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3120731,
        LOCATION_LATITUDE_DEG: 54.4011376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003200',
        LOCATION_NAME: 'Ingleby Barwick',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3051217,
        LOCATION_LATITUDE_DEG: 54.5215491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003300',
        LOCATION_NAME: 'Ingleby Cross',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3056687,
        LOCATION_LATITUDE_DEG: 54.3981348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003400',
        LOCATION_NAME: 'Ingleby Greenhow',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1023779,
        LOCATION_LATITUDE_DEG: 54.4492424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003500',
        LOCATION_NAME: 'Ingleigh Green',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9792906,
        LOCATION_LATITUDE_DEG: 50.8491315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003600',
        LOCATION_NAME: 'Inglemire',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.378652,
        LOCATION_LATITUDE_DEG: 53.7719673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003700',
        LOCATION_NAME: 'Inglesbatch',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4259187,
        LOCATION_LATITUDE_DEG: 51.3503573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003800',
        LOCATION_NAME: 'Inglesham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7033422,
        LOCATION_LATITUDE_DEG: 51.6835776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN003900',
        LOCATION_NAME: 'Inglestone Common',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3569231,
        LOCATION_LATITUDE_DEG: 51.5895839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004100',
        LOCATION_NAME: 'Ingleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4666678,
        LOCATION_LATITUDE_DEG: 54.1537292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004000',
        LOCATION_NAME: 'Ingleton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7298138,
        LOCATION_LATITUDE_DEG: 54.5794629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004200',
        LOCATION_NAME: 'Inglewhite',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6870752,
        LOCATION_LATITUDE_DEG: 53.8542058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004300',
        LOCATION_NAME: 'Inglewood',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8014144,
        LOCATION_LATITUDE_DEG: 56.1255344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004400',
        LOCATION_NAME: 'Inglewood Bank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7219604,
        LOCATION_LATITUDE_DEG: 54.7006838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004500',
        LOCATION_NAME: 'Inglismaldie',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.573252,
        LOCATION_LATITUDE_DEG: 56.7879868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004600',
        LOCATION_NAME: 'Ingliston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3681506,
        LOCATION_LATITUDE_DEG: 55.9429124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004700',
        LOCATION_NAME: 'Ingmanthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3631628,
        LOCATION_LATITUDE_DEG: 53.9520947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004800',
        LOCATION_NAME: 'Ingoe',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9402547,
        LOCATION_LATITUDE_DEG: 55.0678149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN004900',
        LOCATION_NAME: 'Ingol',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7435775,
        LOCATION_LATITUDE_DEG: 53.777991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005000',
        LOCATION_NAME: 'Ingoldisthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5109218,
        LOCATION_LATITUDE_DEG: 52.8642603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005100',
        LOCATION_NAME: 'Ingoldmells',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.335617,
        LOCATION_LATITUDE_DEG: 53.1932955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005200',
        LOCATION_NAME: 'Ingoldsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4998484,
        LOCATION_LATITUDE_DEG: 52.8583811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005300',
        LOCATION_NAME: 'Ingram',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9730004,
        LOCATION_LATITUDE_DEG: 55.4401515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005400',
        LOCATION_NAME: 'Ingrams Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7961853,
        LOCATION_LATITUDE_DEG: 50.9740023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005500',
        LOCATION_NAME: 'Ingrave',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3426243,
        LOCATION_LATITUDE_DEG: 51.6036454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005600',
        LOCATION_NAME: 'Ingrow',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9215785,
        LOCATION_LATITUDE_DEG: 53.853693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005700',
        LOCATION_NAME: 'Ings',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8519711,
        LOCATION_LATITUDE_DEG: 54.3803531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005800',
        LOCATION_NAME: 'Ingsdon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6659797,
        LOCATION_LATITUDE_DEG: 50.5394975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN005900',
        LOCATION_NAME: 'Ingst',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6027314,
        LOCATION_LATITUDE_DEG: 51.5873831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006000',
        LOCATION_NAME: 'Ingworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2545238,
        LOCATION_LATITUDE_DEG: 52.8189491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006400',
        LOCATION_NAME: 'Inkberrow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9790536,
        LOCATION_LATITUDE_DEG: 52.2132358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006500',
        LOCATION_NAME: 'Inkersall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.356009,
        LOCATION_LATITUDE_DEG: 53.2500233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006600',
        LOCATION_NAME: 'Inkpen',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.465347,
        LOCATION_LATITUDE_DEG: 51.374345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006700',
        LOCATION_NAME: 'Inkpen Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4482446,
        LOCATION_LATITUDE_DEG: 51.3746524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006800',
        LOCATION_NAME: 'Innellan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9523604,
        LOCATION_LATITUDE_DEG: 55.8956298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006900',
        LOCATION_NAME: 'Innerleith',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1579329,
        LOCATION_LATITUDE_DEG: 56.2874442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007000',
        LOCATION_NAME: 'Innerleithen',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0614854,
        LOCATION_LATITUDE_DEG: 55.6192808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007100',
        LOCATION_NAME: 'Innerleven',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0027719,
        LOCATION_LATITUDE_DEG: 56.1889373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007200',
        LOCATION_NAME: 'Innermessan',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9873145,
        LOCATION_LATITUDE_DEG: 54.9257318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007300',
        LOCATION_NAME: 'Innerwick',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4482568,
        LOCATION_LATITUDE_DEG: 55.9584086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007700',
        LOCATION_NAME: 'Innsworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1991609,
        LOCATION_LATITUDE_DEG: 51.8889107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007800',
        LOCATION_NAME: 'Insch',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6125769,
        LOCATION_LATITUDE_DEG: 57.3428479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007900',
        LOCATION_NAME: 'Insh',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9560992,
        LOCATION_LATITUDE_DEG: 57.0912352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008000',
        LOCATION_NAME: 'Inshes',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1986169,
        LOCATION_LATITUDE_DEG: 57.4501767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008100',
        LOCATION_NAME: 'Inshes Wood',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1975018,
        LOCATION_LATITUDE_DEG: 57.4818733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008200',
        LOCATION_NAME: 'Inskip',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8187392,
        LOCATION_LATITUDE_DEG: 53.8344035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008300',
        LOCATION_NAME: 'Instow',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1771,
        LOCATION_LATITUDE_DEG: 51.05325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008400',
        LOCATION_NAME: 'Intack',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4501753,
        LOCATION_LATITUDE_DEG: 53.7490862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008500',
        LOCATION_NAME: 'Intake',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.099636,
        LOCATION_LATITUDE_DEG: 53.5248488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008600',
        LOCATION_NAME: 'Interchange Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.700148,
        LOCATION_LATITUDE_DEG: 52.0865111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008700',
        LOCATION_NAME: 'Intwood',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2441218,
        LOCATION_LATITUDE_DEG: 52.589029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN990259',
        LOCATION_NAME: 'Inver',
        COUNTY_NAME: 'Highland',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564292,
        LOCATION_LATITUDE_DEG: 49.7661867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008800',
        LOCATION_NAME: 'Inver',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9144776,
        LOCATION_LATITUDE_DEG: 57.8201104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN008900',
        LOCATION_NAME: 'Inver',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5998544,
        LOCATION_LATITUDE_DEG: 56.5608792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009000',
        LOCATION_NAME: 'Inver',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2626766,
        LOCATION_LATITUDE_DEG: 57.0296238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009300',
        LOCATION_NAME: 'Inveraldie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9438117,
        LOCATION_LATITUDE_DEG: 56.5219711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009400',
        LOCATION_NAME: 'Inverallochy',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9310177,
        LOCATION_LATITUDE_DEG: 57.6746724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009600',
        LOCATION_NAME: 'Inveran',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4155567,
        LOCATION_LATITUDE_DEG: 57.9440247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009700',
        LOCATION_NAME: 'Inveraray',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0729208,
        LOCATION_LATITUDE_DEG: 56.2306586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009800',
        LOCATION_NAME: 'Inverarity',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8931666,
        LOCATION_LATITUDE_DEG: 56.5872737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN990565',
        LOCATION_NAME: 'Inverarnie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009900',
        LOCATION_NAME: 'Inverasdale',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6684661,
        LOCATION_LATITUDE_DEG: 57.8083272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010000',
        LOCATION_NAME: 'Inverawe',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2193906,
        LOCATION_LATITUDE_DEG: 56.4559874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010100',
        LOCATION_NAME: 'Inverbervie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.278238,
        LOCATION_LATITUDE_DEG: 56.8447878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010200',
        LOCATION_NAME: 'Inverboyndie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6641256,
        LOCATION_LATITUDE_DEG: 57.6380742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010300',
        LOCATION_NAME: 'Inverchaolain',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0488781,
        LOCATION_LATITUDE_DEG: 55.9315309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010400',
        LOCATION_NAME: 'Inverdruie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8149914,
        LOCATION_LATITUDE_DEG: 57.1755437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010500',
        LOCATION_NAME: 'Inveresk',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0460621,
        LOCATION_LATITUDE_DEG: 55.9370095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010600',
        LOCATION_NAME: 'Inverfarigaig',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4533147,
        LOCATION_LATITUDE_DEG: 57.28136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010700',
        LOCATION_NAME: 'Invergarry',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7994656,
        LOCATION_LATITUDE_DEG: 57.0691425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010800',
        LOCATION_NAME: 'Invergordon',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1679987,
        LOCATION_LATITUDE_DEG: 57.6893001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN010900',
        LOCATION_NAME: 'Invergowrie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0602993,
        LOCATION_LATITUDE_DEG: 56.4612593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011000',
        LOCATION_NAME: 'Inverinan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2375809,
        LOCATION_LATITUDE_DEG: 56.3092704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011100',
        LOCATION_NAME: 'Inverinate',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4590851,
        LOCATION_LATITUDE_DEG: 57.2436634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011200',
        LOCATION_NAME: 'Inverkeilor',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5464572,
        LOCATION_LATITUDE_DEG: 56.6349688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011300',
        LOCATION_NAME: 'Inverkeithing',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3961027,
        LOCATION_LATITUDE_DEG: 56.0312263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011400',
        LOCATION_NAME: 'Inverkeithny',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6186751,
        LOCATION_LATITUDE_DEG: 57.5116616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011500',
        LOCATION_NAME: 'Inverkip',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.873031,
        LOCATION_LATITUDE_DEG: 55.9077294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011600',
        LOCATION_NAME: 'Inverleith',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2141272,
        LOCATION_LATITUDE_DEG: 55.9693113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011700',
        LOCATION_NAME: 'Inverlochy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0928015,
        LOCATION_LATITUDE_DEG: 56.8234203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011800',
        LOCATION_NAME: 'Inverlussa',
        COUNTY_NAME: 'Isle of Jura',
        POSTCODE: 'PA60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7811676,
        LOCATION_LATITUDE_DEG: 56.0164446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN011900',
        LOCATION_NAME: 'Invermoriston',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6174805,
        LOCATION_LATITUDE_DEG: 57.215052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012000',
        LOCATION_NAME: 'Inverness',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2352811,
        LOCATION_LATITUDE_DEG: 57.4797804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012100',
        LOCATION_NAME: 'Inverquhomery',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9661816,
        LOCATION_LATITUDE_DEG: 57.5102537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012200',
        LOCATION_NAME: 'Inverroy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8633649,
        LOCATION_LATITUDE_DEG: 56.8902211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012300',
        LOCATION_NAME: 'Invershin',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3965492,
        LOCATION_LATITUDE_DEG: 57.9238238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012350',
        LOCATION_NAME: 'Inversnaid',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6686952,
        LOCATION_LATITUDE_DEG: 56.2485566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012400',
        LOCATION_NAME: 'Invertrossachs',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3184636,
        LOCATION_LATITUDE_DEG: 56.2117541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012500',
        LOCATION_NAME: 'Inverugie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.832699,
        LOCATION_LATITUDE_DEG: 57.5237484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012600',
        LOCATION_NAME: 'Inveruglas',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7101748,
        LOCATION_LATITUDE_DEG: 56.2501627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012700',
        LOCATION_NAME: 'Inverurie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3754481,
        LOCATION_LATITUDE_DEG: 57.2846374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012800',
        LOCATION_NAME: 'Inwardleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0388216,
        LOCATION_LATITUDE_DEG: 50.77542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN012900',
        LOCATION_NAME: 'Inwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7968423,
        LOCATION_LATITUDE_DEG: 52.5630812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN013000',
        LOCATION_NAME: 'Inworth',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7290275,
        LOCATION_LATITUDE_DEG: 51.8264623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IP000100',
        LOCATION_NAME: 'Iping',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7839899,
        LOCATION_LATITUDE_DEG: 50.9926009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IP000200',
        LOCATION_NAME: 'Ipplepen',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6365759,
        LOCATION_LATITUDE_DEG: 50.4875923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IP000300',
        LOCATION_NAME: 'Ipsden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0810998,
        LOCATION_LATITUDE_DEG: 51.5627622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IP000400',
        LOCATION_NAME: 'Ipsley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9050976,
        LOCATION_LATITUDE_DEG: 52.2988421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IP000700',
        LOCATION_NAME: 'Ipstone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9096272,
        LOCATION_LATITUDE_DEG: 51.6372018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IP000500',
        LOCATION_NAME: 'Ipstones',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9689849,
        LOCATION_LATITUDE_DEG: 53.0463193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IP000600',
        LOCATION_NAME: 'Ipswich',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1546478,
        LOCATION_LATITUDE_DEG: 52.0577755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000100',
        LOCATION_NAME: 'Irby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1183605,
        LOCATION_LATITUDE_DEG: 53.3515591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000200',
        LOCATION_NAME: 'Irby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1955645,
        LOCATION_LATITUDE_DEG: 53.5278374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002400',
        LOCATION_NAME: 'Irby in the Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000300',
        LOCATION_NAME: 'Irby-in-the-Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1941595,
        LOCATION_LATITUDE_DEG: 53.1481942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000400',
        LOCATION_NAME: 'Irchester',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6425245,
        LOCATION_LATITUDE_DEG: 52.2818261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000500',
        LOCATION_NAME: 'Ireby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1831943,
        LOCATION_LATITUDE_DEG: 54.7376948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000600',
        LOCATION_NAME: 'Ireby',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5300263,
        LOCATION_LATITUDE_DEG: 54.1733318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000700',
        LOCATION_NAME: 'Ireland',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3458635,
        LOCATION_LATITUDE_DEG: 52.0603004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002500',
        LOCATION_NAME: 'Ireland Wood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5998813,
        LOCATION_LATITUDE_DEG: 53.8471099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000800',
        LOCATION_NAME: 'Ireleth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.190252,
        LOCATION_LATITUDE_DEG: 54.1881408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR000900',
        LOCATION_NAME: 'Ireshopeburn',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2071114,
        LOCATION_LATITUDE_DEG: 54.7425799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001200',
        LOCATION_NAME: 'Irlam',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4170985,
        LOCATION_LATITUDE_DEG: 53.4484571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002600',
        LOCATION_NAME: 'Irlams o th Heights',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3090226,
        LOCATION_LATITUDE_DEG: 53.5005023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001300',
        LOCATION_NAME: 'Irnham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4790971,
        LOCATION_LATITUDE_DEG: 52.828176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001400',
        LOCATION_NAME: 'Iron Acton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4596458,
        LOCATION_LATITUDE_DEG: 51.5488774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001500',
        LOCATION_NAME: 'Ironbridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4837127,
        LOCATION_LATITUDE_DEG: 52.6282773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001600',
        LOCATION_NAME: 'Irongray',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7357528,
        LOCATION_LATITUDE_DEG: 55.0890382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001700',
        LOCATION_NAME: 'Ironville',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3485547,
        LOCATION_LATITUDE_DEG: 53.0626103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001800',
        LOCATION_NAME: 'Irstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5026801,
        LOCATION_LATITUDE_DEG: 52.7294378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001900',
        LOCATION_NAME: 'Irthington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7824461,
        LOCATION_LATITUDE_DEG: 54.9474089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002000',
        LOCATION_NAME: 'Irthlingborough',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6107634,
        LOCATION_LATITUDE_DEG: 52.3260297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002100',
        LOCATION_NAME: 'Irton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.449351,
        LOCATION_LATITUDE_DEG: 54.2429119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002200',
        LOCATION_NAME: 'Irvine',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6636012,
        LOCATION_LATITUDE_DEG: 55.6155925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002300',
        LOCATION_NAME: 'Irvinestown',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.631284,
        LOCATION_LATITUDE_DEG: 54.476312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000100',
        LOCATION_NAME: 'Isauld',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7592682,
        LOCATION_LATITUDE_DEG: 58.5617809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000150',
        LOCATION_NAME: 'Iscoyd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7589451,
        LOCATION_LATITUDE_DEG: 52.9751618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000200',
        LOCATION_NAME: 'Isel',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3059026,
        LOCATION_LATITUDE_DEG: 54.6923921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000300',
        LOCATION_NAME: 'Isfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0667585,
        LOCATION_LATITUDE_DEG: 50.934287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000400',
        LOCATION_NAME: 'Isham',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7005806,
        LOCATION_LATITUDE_DEG: 52.3555289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000500',
        LOCATION_NAME: 'Isington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8839985,
        LOCATION_LATITUDE_DEG: 51.1761223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000600',
        LOCATION_NAME: 'Island Flodda',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2683598,
        LOCATION_LATITUDE_DEG: 57.4770058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000800',
        LOCATION_NAME: 'Islandmagee',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7909465,
        LOCATION_LATITUDE_DEG: 54.7953228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001000',
        LOCATION_NAME: 'Islawrdref',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9519257,
        LOCATION_LATITUDE_DEG: 52.7236053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001100',
        LOCATION_NAME: 'Isle Abbotts',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9245943,
        LOCATION_LATITUDE_DEG: 50.9832285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001200',
        LOCATION_NAME: 'Isle Brewers',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9015459,
        LOCATION_LATITUDE_DEG: 50.9849285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001300',
        LOCATION_NAME: 'Isle Horrisdale',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7146468,
        LOCATION_LATITUDE_DEG: 57.7077167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001600',
        LOCATION_NAME: 'Isle of Canna',
        COUNTY_NAME: 'Highland',
        POSTCODE: 'PH44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5395934,
        LOCATION_LATITUDE_DEG: 57.0624543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001700',
        LOCATION_NAME: 'Isle of Coll',
        COUNTY_NAME: 'Isle of Coll',
        POSTCODE: 'PA78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.567029,
        LOCATION_LATITUDE_DEG: 56.6241133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001800',
        LOCATION_NAME: 'Isle of Colonsay',
        COUNTY_NAME: 'Isle of Colonsay',
        POSTCODE: 'PA61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2145797,
        LOCATION_LATITUDE_DEG: 56.0660578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS004100',
        LOCATION_NAME: 'Isle of Dogs',
        COUNTY_NAME: 'London',
        POSTCODE: 'E14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0134693,
        LOCATION_LATITUDE_DEG: 51.4884398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001900',
        LOCATION_NAME: 'Isle of Eigg',
        COUNTY_NAME: 'Isle of Eigg',
        POSTCODE: 'PH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1597596,
        LOCATION_LATITUDE_DEG: 56.9021425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002000',
        LOCATION_NAME: 'Isle of Ewe',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6214188,
        LOCATION_LATITUDE_DEG: 57.8328236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002100',
        LOCATION_NAME: 'Isle of Gigha',
        COUNTY_NAME: 'Isle of Gigha',
        POSTCODE: 'PA41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7527462,
        LOCATION_LATITUDE_DEG: 55.6804139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002200',
        LOCATION_NAME: 'Isle of Grain',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7138744,
        LOCATION_LATITUDE_DEG: 51.4533301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS990212',
        LOCATION_NAME: 'Isle of Harris',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8994226,
        LOCATION_LATITUDE_DEG: 58.0110093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002300',
        LOCATION_NAME: 'Isle of Iona',
        COUNTY_NAME: 'Isle of Iona',
        POSTCODE: 'PA76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4120257,
        LOCATION_LATITUDE_DEG: 56.3296806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002400',
        LOCATION_NAME: 'Isle of Lewis',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6655269,
        LOCATION_LATITUDE_DEG: 58.2502749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002500',
        LOCATION_NAME: 'Isle of Muck',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2441726,
        LOCATION_LATITUDE_DEG: 56.8363296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS990215',
        LOCATION_NAME: 'Isle of North Uist',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3100239,
        LOCATION_LATITUDE_DEG: 57.5975994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002600',
        LOCATION_NAME: 'Isle of Raasay',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0446901,
        LOCATION_LATITUDE_DEG: 57.4177884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002700',
        LOCATION_NAME: 'Isle of Rum',
        COUNTY_NAME: 'Isle of Rum',
        POSTCODE: 'PH43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2677233,
        LOCATION_LATITUDE_DEG: 57.0226202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS990213',
        LOCATION_NAME: 'Isle of Scalpay',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6917091,
        LOCATION_LATITUDE_DEG: 57.8706868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS990214',
        LOCATION_NAME: 'Isle of South Uist',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3278875,
        LOCATION_LATITUDE_DEG: 57.2612229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001400',
        LOCATION_NAME: 'Isle Of Walney',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2449872,
        LOCATION_LATITUDE_DEG: 54.1070357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS002900',
        LOCATION_NAME: 'Isle of Whithorn',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3657679,
        LOCATION_LATITUDE_DEG: 54.7007039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS001500',
        LOCATION_NAME: 'Isle Ornsay',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8043925,
        LOCATION_LATITUDE_DEG: 57.1445573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003000',
        LOCATION_NAME: 'Islebeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3099511,
        LOCATION_LATITUDE_DEG: 54.1895188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003100',
        LOCATION_NAME: 'Isleham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4126894,
        LOCATION_LATITUDE_DEG: 52.3423172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003200',
        LOCATION_NAME: 'Islesteps',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.619435,
        LOCATION_LATITUDE_DEG: 55.040027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003300',
        LOCATION_NAME: 'Isleworth',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3371256,
        LOCATION_LATITUDE_DEG: 51.4746445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003400',
        LOCATION_NAME: 'Isley Walton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3693958,
        LOCATION_LATITUDE_DEG: 52.8215896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003500',
        LOCATION_NAME: 'Islington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2364245,
        LOCATION_LATITUDE_DEG: 53.890491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS004200',
        LOCATION_NAME: 'Islington',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1036865,
        LOCATION_LATITUDE_DEG: 51.5403517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS991119',
        LOCATION_NAME: 'Islington',
        COUNTY_NAME: 'London',
        POSTCODE: 'N19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1027,
        LOCATION_LATITUDE_DEG: 51.544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003600',
        LOCATION_NAME: 'Islip',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2350069,
        LOCATION_LATITUDE_DEG: 51.8226855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003700',
        LOCATION_NAME: 'Islip',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5486648,
        LOCATION_LATITUDE_DEG: 52.3983334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003800',
        LOCATION_NAME: 'Islivig',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1101691,
        LOCATION_LATITUDE_DEG: 58.133972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS003900',
        LOCATION_NAME: 'Isombridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5762476,
        LOCATION_LATITUDE_DEG: 52.7199924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS004000',
        LOCATION_NAME: 'Istead Rise',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3571078,
        LOCATION_LATITUDE_DEG: 51.400329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000100',
        LOCATION_NAME: 'Itchen',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3782444,
        LOCATION_LATITUDE_DEG: 50.9050021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000200',
        LOCATION_NAME: 'Itchen Abbas',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2366739,
        LOCATION_LATITUDE_DEG: 51.0927189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000300',
        LOCATION_NAME: 'Itchen Stoke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2020992,
        LOCATION_LATITUDE_DEG: 51.0877216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000400',
        LOCATION_NAME: 'Itchenor',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8652744,
        LOCATION_LATITUDE_DEG: 50.8048909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000500',
        LOCATION_NAME: 'Itchingfield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3849696,
        LOCATION_LATITUDE_DEG: 51.046802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000600',
        LOCATION_NAME: 'Itchington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4917389,
        LOCATION_LATITUDE_DEG: 51.5783776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000700',
        LOCATION_NAME: 'Itteringham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1850718,
        LOCATION_LATITUDE_DEG: 52.8329502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IT000800',
        LOCATION_NAME: 'Itton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7341583,
        LOCATION_LATITUDE_DEG: 51.6502566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000100',
        LOCATION_NAME: 'Ivegill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9050069,
        LOCATION_LATITUDE_DEG: 54.7805987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000200',
        LOCATION_NAME: 'Iver',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.505503,
        LOCATION_LATITUDE_DEG: 51.520052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000300',
        LOCATION_NAME: 'Iver Heath',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5166321,
        LOCATION_LATITUDE_DEG: 51.5364528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000400',
        LOCATION_NAME: 'Iveston',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7891893,
        LOCATION_LATITUDE_DEG: 54.847584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000500',
        LOCATION_NAME: 'Ivinghoe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6283341,
        LOCATION_LATITUDE_DEG: 51.8355822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000600',
        LOCATION_NAME: 'Ivinghoe Aston',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6166807,
        LOCATION_LATITUDE_DEG: 51.8534848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000700',
        LOCATION_NAME: 'Ivington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7690561,
        LOCATION_LATITUDE_DEG: 52.2051481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000800',
        LOCATION_NAME: 'Ivy Hatch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2756685,
        LOCATION_LATITUDE_DEG: 51.2659183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV000900',
        LOCATION_NAME: 'Ivy Todd',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8051299,
        LOCATION_LATITUDE_DEG: 52.6497414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV001000',
        LOCATION_NAME: 'Ivybridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9197891,
        LOCATION_LATITUDE_DEG: 50.3884833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV001100',
        LOCATION_NAME: 'Ivychurch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8905231,
        LOCATION_LATITUDE_DEG: 51.0122801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IV001200',
        LOCATION_NAME: 'Ivyleaf Hill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4994494,
        LOCATION_LATITUDE_DEG: 50.8508302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IW000100',
        LOCATION_NAME: 'Iwade',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7312031,
        LOCATION_LATITUDE_DEG: 51.3770195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IW000200',
        LOCATION_NAME: 'Iwerne Courtney',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1998219,
        LOCATION_LATITUDE_DEG: 50.9139152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IW000300',
        LOCATION_NAME: 'Iwerne Minster',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1880583,
        LOCATION_LATITUDE_DEG: 50.9284141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IW000400',
        LOCATION_NAME: 'Iwerne Steepleton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1913281,
        LOCATION_LATITUDE_DEG: 50.8964102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IW000500',
        LOCATION_NAME: 'Iwood',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7851701,
        LOCATION_LATITUDE_DEG: 51.3633657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IX000100',
        LOCATION_NAME: 'Ixworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8337017,
        LOCATION_LATITUDE_DEG: 52.2974015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IX000200',
        LOCATION_NAME: 'Ixworth Thorpe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8110759,
        LOCATION_LATITUDE_DEG: 52.3237104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000200',
        LOCATION_NAME: 'Jackfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4673004,
        LOCATION_LATITUDE_DEG: 52.6216809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000300',
        LOCATION_NAME: 'Jacksdale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3348753,
        LOCATION_LATITUDE_DEG: 53.0593071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000400',
        LOCATION_NAME: 'Jackson Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7502388,
        LOCATION_LATITUDE_DEG: 53.5632612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000500',
        LOCATION_NAME: 'Jackton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2444912,
        LOCATION_LATITUDE_DEG: 55.7504077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000600',
        LOCATION_NAME: 'Jacobs Well',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5651172,
        LOCATION_LATITUDE_DEG: 51.2685256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA002100',
        LOCATION_NAME: 'Jacobs Wells',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7358379,
        LOCATION_LATITUDE_DEG: 54.0722871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000700',
        LOCATION_NAME: 'Jacobstow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5535296,
        LOCATION_LATITUDE_DEG: 50.7331235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000800',
        LOCATION_NAME: 'Jacobstowe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0050937,
        LOCATION_LATITUDE_DEG: 50.7961261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000900',
        LOCATION_NAME: 'Jameston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8103062,
        LOCATION_LATITUDE_DEG: 51.6557172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001200',
        LOCATION_NAME: 'Jamestown',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.566891,
        LOCATION_LATITUDE_DEG: 55.9934286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001100',
        LOCATION_NAME: 'Jamestown',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5470372,
        LOCATION_LATITUDE_DEG: 57.573285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001500',
        LOCATION_NAME: 'Janetstown',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3876854,
        LOCATION_LATITUDE_DEG: 58.2696433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001600',
        LOCATION_NAME: 'Jarrow',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4819037,
        LOCATION_LATITUDE_DEG: 54.9823996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001700',
        LOCATION_NAME: 'Jarvis Brook',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1882641,
        LOCATION_LATITUDE_DEG: 51.0481933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001800',
        LOCATION_NAME: 'Jaywick',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1205612,
        LOCATION_LATITUDE_DEG: 51.7779482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000100',
        LOCATION_NAME: 'Jedburgh',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5499827,
        LOCATION_LATITUDE_DEG: 55.4797632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000200',
        LOCATION_NAME: 'Jeffreyston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7694121,
        LOCATION_LATITUDE_DEG: 51.7228179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000300',
        LOCATION_NAME: 'Jemimaville',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1462703,
        LOCATION_LATITUDE_DEG: 57.6583901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000700',
        LOCATION_NAME: 'Jersey Marine',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8614278,
        LOCATION_LATITUDE_DEG: 51.6287046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000900',
        LOCATION_NAME: 'Jerusalem',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6358906,
        LOCATION_LATITUDE_DEG: 53.2236124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000950',
        LOCATION_NAME: 'Jervaulx',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7243461,
        LOCATION_LATITUDE_DEG: 54.2610286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE001200',
        LOCATION_NAME: 'Jesmond',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6034107,
        LOCATION_LATITUDE_DEG: 54.9900283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE001300',
        LOCATION_NAME: 'Jesmond Park East & West',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5862433,
        LOCATION_LATITUDE_DEG: 54.9920472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE001100',
        LOCATION_NAME: 'Jesmond Vale',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5907499,
        LOCATION_LATITUDE_DEG: 54.9838929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE001000',
        LOCATION_NAME: 'Jevington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2173147,
        LOCATION_LATITUDE_DEG: 50.7904758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000100',
        LOCATION_NAME: 'Jobs Water',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.159319,
        LOCATION_LATITUDE_DEG: 50.1393675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000300',
        LOCATION_NAME: "John O' Gaunt",
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.900045,
        LOCATION_LATITUDE_DEG: 52.6597637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000400',
        LOCATION_NAME: "John O' Groats",
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0614768,
        LOCATION_LATITUDE_DEG: 58.6371785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000500',
        LOCATION_NAME: 'Johnby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8775226,
        LOCATION_LATITUDE_DEG: 54.6889886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000600',
        LOCATION_NAME: 'Johnshaven',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3352383,
        LOCATION_LATITUDE_DEG: 56.7946843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000700',
        LOCATION_NAME: 'Johnston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9969425,
        LOCATION_LATITUDE_DEG: 51.7537236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000800',
        LOCATION_NAME: 'Johnstone',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.499335,
        LOCATION_LATITUDE_DEG: 55.8345154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO000900',
        LOCATION_NAME: 'Johnstonebridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4159048,
        LOCATION_LATITUDE_DEG: 55.2134444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001600',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3275862,
        LOCATION_LATITUDE_DEG: 51.8530302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001700',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0410423,
        LOCATION_LATITUDE_DEG: 53.0080267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002000',
        LOCATION_NAME: 'Jonesborough',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3797532,
        LOCATION_LATITUDE_DEG: 54.1006594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002100',
        LOCATION_NAME: 'Joppa',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.094839,
        LOCATION_LATITUDE_DEG: 55.9481153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002800',
        LOCATION_NAME: 'Jordanhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.326121,
        LOCATION_LATITUDE_DEG: 55.8827764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002200',
        LOCATION_NAME: 'Jordans',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5903434,
        LOCATION_LATITUDE_DEG: 51.6145577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002300',
        LOCATION_NAME: 'Jordanston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0291292,
        LOCATION_LATITUDE_DEG: 51.9527474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002400',
        LOCATION_NAME: 'Joyford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6112331,
        LOCATION_LATITUDE_DEG: 51.8150066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002500',
        LOCATION_NAME: 'Joyford Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6109429,
        LOCATION_LATITUDE_DEG: 51.8150081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002600',
        LOCATION_NAME: 'Joys Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5736373,
        LOCATION_LATITUDE_DEG: 51.8432064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000200',
        LOCATION_NAME: 'Jump',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4268424,
        LOCATION_LATITUDE_DEG: 53.5068542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000300',
        LOCATION_NAME: 'Juniper',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0916159,
        LOCATION_LATITUDE_DEG: 54.924296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000400',
        LOCATION_NAME: 'Juniper Green',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2874152,
        LOCATION_LATITUDE_DEG: 55.9020122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000500',
        LOCATION_NAME: 'Juniper Hill',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1570213,
        LOCATION_LATITUDE_DEG: 51.9874995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000600',
        LOCATION_NAME: 'Jurby East',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4927427,
        LOCATION_LATITUDE_DEG: 54.3633263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000700',
        LOCATION_NAME: 'Jurby West',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5348963,
        LOCATION_LATITUDE_DEG: 54.3515598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000800',
        LOCATION_NAME: 'Jury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5279517,
        LOCATION_LATITUDE_DEG: 51.0385385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000900',
        LOCATION_NAME: 'Jurys Gap',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8498548,
        LOCATION_LATITUDE_DEG: 50.9336776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU001000',
        LOCATION_NAME: 'Justicetown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9778706,
        LOCATION_LATITUDE_DEG: 54.9729125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU001100',
        LOCATION_NAME: 'Justinhaugh',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.878202,
        LOCATION_LATITUDE_DEG: 56.703083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KA000100',
        LOCATION_NAME: 'Kaber',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3129539,
        LOCATION_LATITUDE_DEG: 54.4987559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KA000200',
        LOCATION_NAME: 'Kaimes',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1682418,
        LOCATION_LATITUDE_DEG: 55.9004056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KA000300',
        LOCATION_NAME: 'Kallin',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2131478,
        LOCATION_LATITUDE_DEG: 57.478901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KA000400',
        LOCATION_NAME: 'Kames',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2439222,
        LOCATION_LATITUDE_DEG: 55.8928279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KA000600',
        LOCATION_NAME: 'Karslake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8436831,
        LOCATION_LATITUDE_DEG: 50.3634917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KA000700',
        LOCATION_NAME: 'Katesbridge',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1504251,
        LOCATION_LATITUDE_DEG: 54.3114782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000100',
        LOCATION_NAME: 'Kea',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.071339,
        LOCATION_LATITUDE_DEG: 50.2428814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000200',
        LOCATION_NAME: 'Keadby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7383566,
        LOCATION_LATITUDE_DEG: 53.593853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000400',
        LOCATION_NAME: 'Keady',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7066737,
        LOCATION_LATITUDE_DEG: 54.249284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000500',
        LOCATION_NAME: 'Keal Cotes',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0413888,
        LOCATION_LATITUDE_DEG: 53.1281991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000800',
        LOCATION_NAME: 'Kearby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4831535,
        LOCATION_LATITUDE_DEG: 53.9194568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000900',
        LOCATION_NAME: 'Kearsley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3808145,
        LOCATION_LATITUDE_DEG: 53.5418715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000950',
        LOCATION_NAME: 'Kearsney',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2690631,
        LOCATION_LATITUDE_DEG: 51.1467907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001000',
        LOCATION_NAME: 'Kearstwick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6031478,
        LOCATION_LATITUDE_DEG: 54.2129331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001100',
        LOCATION_NAME: 'Keddington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0217489,
        LOCATION_LATITUDE_DEG: 53.3781182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001200',
        LOCATION_NAME: 'Kedington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4885731,
        LOCATION_LATITUDE_DEG: 52.0898952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001300',
        LOCATION_NAME: 'Kedleston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5467086,
        LOCATION_LATITUDE_DEG: 52.966606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001700',
        LOCATION_NAME: 'Keelby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2439751,
        LOCATION_LATITUDE_DEG: 53.5758401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001800',
        LOCATION_NAME: 'Keele',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2853713,
        LOCATION_LATITUDE_DEG: 53.0034124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001900',
        LOCATION_NAME: 'Keeley Green',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5270212,
        LOCATION_LATITUDE_DEG: 52.1035025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002200',
        LOCATION_NAME: 'Keeran',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5990637,
        LOCATION_LATITUDE_DEG: 54.5499106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002300',
        LOCATION_NAME: 'Keeston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0460234,
        LOCATION_LATITUDE_DEG: 51.8336321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002400',
        LOCATION_NAME: 'Keevil',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1140527,
        LOCATION_LATITUDE_DEG: 51.3205545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002500',
        LOCATION_NAME: 'Kegworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2766766,
        LOCATION_LATITUDE_DEG: 52.835284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002600',
        LOCATION_NAME: 'Kehelland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3342728,
        LOCATION_LATITUDE_DEG: 50.221277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002700',
        LOCATION_NAME: 'Keig',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.644618,
        LOCATION_LATITUDE_DEG: 57.2605373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002800',
        LOCATION_NAME: 'Keighley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.906894,
        LOCATION_LATITUDE_DEG: 53.866294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002900',
        LOCATION_NAME: 'Keills',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1289956,
        LOCATION_LATITUDE_DEG: 55.8399361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003000',
        LOCATION_NAME: 'Keinton Mandeville',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6438117,
        LOCATION_LATITUDE_DEG: 51.0756314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003200',
        LOCATION_NAME: 'Keir',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9555646,
        LOCATION_LATITUDE_DEG: 56.1708416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003100',
        LOCATION_NAME: 'Keir',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7939486,
        LOCATION_LATITUDE_DEG: 55.2161464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003300',
        LOCATION_NAME: 'Keir Mill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.79352,
        LOCATION_LATITUDE_DEG: 55.2188492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003400',
        LOCATION_NAME: 'Keisby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4562701,
        LOCATION_LATITUDE_DEG: 52.8443804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003500',
        LOCATION_NAME: 'Keiss',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1232425,
        LOCATION_LATITUDE_DEG: 58.5379688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003600',
        LOCATION_NAME: 'Keistle',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2885436,
        LOCATION_LATITUDE_DEG: 57.5426015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003700',
        LOCATION_NAME: 'Keith',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9480067,
        LOCATION_LATITUDE_DEG: 57.5432718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003800',
        LOCATION_NAME: 'Keith Hall',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.352616,
        LOCATION_LATITUDE_DEG: 57.2807326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE003900',
        LOCATION_NAME: 'Kelbrook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1489408,
        LOCATION_LATITUDE_DEG: 53.8975999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004000',
        LOCATION_NAME: 'Kelby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.504235,
        LOCATION_LATITUDE_DEG: 52.9609899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004200',
        LOCATION_NAME: 'Keld',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6894217,
        LOCATION_LATITUDE_DEG: 54.5241689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004100',
        LOCATION_NAME: 'Keld',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1673337,
        LOCATION_LATITUDE_DEG: 54.404446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004300',
        LOCATION_NAME: 'Keld Houses',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8317814,
        LOCATION_LATITUDE_DEG: 54.066509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004400',
        LOCATION_NAME: 'Keldholme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9107181,
        LOCATION_LATITUDE_DEG: 54.2670208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE990947',
        LOCATION_NAME: 'Kelfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004500',
        LOCATION_NAME: 'Kelfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0987664,
        LOCATION_LATITUDE_DEG: 53.838082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004600',
        LOCATION_NAME: 'Kelham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8443047,
        LOCATION_LATITUDE_DEG: 53.0927025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004700',
        LOCATION_NAME: 'Kelhead',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3361794,
        LOCATION_LATITUDE_DEG: 55.0134193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004800',
        LOCATION_NAME: 'Kelk',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3197113,
        LOCATION_LATITUDE_DEG: 54.01199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE004900',
        LOCATION_NAME: 'Kellah',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5311658,
        LOCATION_LATITUDE_DEG: 54.9437064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005000',
        LOCATION_NAME: 'Kellas',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3867086,
        LOCATION_LATITUDE_DEG: 57.5730787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005100',
        LOCATION_NAME: 'Kellas',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8817088,
        LOCATION_LATITUDE_DEG: 56.5091648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005200',
        LOCATION_NAME: 'Kellaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6819739,
        LOCATION_LATITUDE_DEG: 50.2393672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005300',
        LOCATION_NAME: 'Kellaways',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0677013,
        LOCATION_LATITUDE_DEG: 51.4891668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005400',
        LOCATION_NAME: 'Kelleth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5229371,
        LOCATION_LATITUDE_DEG: 54.4416566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005500',
        LOCATION_NAME: 'Kelling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1155663,
        LOCATION_LATITUDE_DEG: 52.9406647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005600',
        LOCATION_NAME: 'Kellington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1651435,
        LOCATION_LATITUDE_DEG: 53.7185727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005700',
        LOCATION_NAME: 'Kelloe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4691574,
        LOCATION_LATITUDE_DEG: 54.7209682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005800',
        LOCATION_NAME: 'Kelloholm',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9916653,
        LOCATION_LATITUDE_DEG: 55.3805643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE005900',
        LOCATION_NAME: 'Kellow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4375502,
        LOCATION_LATITUDE_DEG: 50.3640825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006200',
        LOCATION_NAME: 'Kells',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.230116,
        LOCATION_LATITUDE_DEG: 54.8103358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006300',
        LOCATION_NAME: 'Kelly',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2677519,
        LOCATION_LATITUDE_DEG: 50.6103048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006400',
        LOCATION_NAME: 'Kelly Bray',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3123186,
        LOCATION_LATITUDE_DEG: 50.5198976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006800',
        LOCATION_NAME: 'Kellythorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4606287,
        LOCATION_LATITUDE_DEG: 53.9952867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007000',
        LOCATION_NAME: 'Kelmarsh',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9166024,
        LOCATION_LATITUDE_DEG: 52.4059377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007100',
        LOCATION_NAME: 'Kelmscott',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6370061,
        LOCATION_LATITUDE_DEG: 51.6918801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007200',
        LOCATION_NAME: 'Kelsale',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.489744,
        LOCATION_LATITUDE_DEG: 52.2341868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007300',
        LOCATION_NAME: 'Kelsall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.71108,
        LOCATION_LATITUDE_DEG: 53.2073438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007400',
        LOCATION_NAME: 'Kelshall',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.064467,
        LOCATION_LATITUDE_DEG: 52.0092955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007500',
        LOCATION_NAME: 'Kelsick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2511427,
        LOCATION_LATITUDE_DEG: 54.8400091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007600',
        LOCATION_NAME: 'Kelso',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4324261,
        LOCATION_LATITUDE_DEG: 55.5994678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007700',
        LOCATION_NAME: 'Kelstedge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4922286,
        LOCATION_LATITUDE_DEG: 53.1704186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007800',
        LOCATION_NAME: 'Kelstern',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1167493,
        LOCATION_LATITUDE_DEG: 53.394527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE007900',
        LOCATION_NAME: 'Kelston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4304063,
        LOCATION_LATITUDE_DEG: 51.4016625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008000',
        LOCATION_NAME: 'Kelston Mills',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4386367,
        LOCATION_LATITUDE_DEG: 51.4083676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008100',
        LOCATION_NAME: 'Keltie Bridge',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.178754,
        LOCATION_LATITUDE_DEG: 56.23725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008200',
        LOCATION_NAME: 'Keltneyburn',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9859091,
        LOCATION_LATITUDE_DEG: 56.6175909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008300',
        LOCATION_NAME: 'Kelton',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5821746,
        LOCATION_LATITUDE_DEG: 55.0219292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008400',
        LOCATION_NAME: 'Kelty',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3780059,
        LOCATION_LATITUDE_DEG: 56.1327358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008500',
        LOCATION_NAME: 'Kelvedon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7049953,
        LOCATION_LATITUDE_DEG: 51.8386655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008600',
        LOCATION_NAME: 'Kelvedon Common',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6927133,
        LOCATION_LATITUDE_DEG: 51.8289638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008700',
        LOCATION_NAME: 'Kelvedon Hatch',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2695271,
        LOCATION_LATITUDE_DEG: 51.6670501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023500',
        LOCATION_NAME: 'Kelvindale',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3097685,
        LOCATION_LATITUDE_DEG: 55.8942033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023600',
        LOCATION_NAME: 'Kelvinside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2949193,
        LOCATION_LATITUDE_DEG: 55.882751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008800',
        LOCATION_NAME: 'Kemback',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9428371,
        LOCATION_LATITUDE_DEG: 56.3247445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE008900',
        LOCATION_NAME: 'Kemberton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3997437,
        LOCATION_LATITUDE_DEG: 52.6365832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009000',
        LOCATION_NAME: 'Kemble',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0176595,
        LOCATION_LATITUDE_DEG: 51.6743831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009100',
        LOCATION_NAME: 'Kemble Wick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0187881,
        LOCATION_LATITUDE_DEG: 51.6753811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009200',
        LOCATION_NAME: 'Kembrey Park',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7632566,
        LOCATION_LATITUDE_DEG: 51.578971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009300',
        LOCATION_NAME: 'Kemerton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0784184,
        LOCATION_LATITUDE_DEG: 52.0329219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009400',
        LOCATION_NAME: 'Kemeys Commander',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9410623,
        LOCATION_LATITUDE_DEG: 51.7386968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009500',
        LOCATION_NAME: 'Kemeys Inferior',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8986698,
        LOCATION_LATITUDE_DEG: 51.6328904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009600',
        LOCATION_NAME: 'Kemnay',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4413594,
        LOCATION_LATITUDE_DEG: 57.2332323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009700',
        LOCATION_NAME: 'Kemp Town',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1189268,
        LOCATION_LATITUDE_DEG: 50.8177826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009800',
        LOCATION_NAME: 'Kempley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4782617,
        LOCATION_LATITUDE_DEG: 51.9640172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE009900',
        LOCATION_NAME: 'Kempsey',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2157183,
        LOCATION_LATITUDE_DEG: 52.138528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010000',
        LOCATION_NAME: 'Kempsford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7722954,
        LOCATION_LATITUDE_DEG: 51.6705848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010100',
        LOCATION_NAME: 'Kempshott',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1449206,
        LOCATION_LATITUDE_DEG: 51.2232323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010200',
        LOCATION_NAME: 'Kempston',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4968568,
        LOCATION_LATITUDE_DEG: 52.1142092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010300',
        LOCATION_NAME: 'Kempston Hardwick',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4945902,
        LOCATION_LATITUDE_DEG: 52.0874011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010400',
        LOCATION_NAME: 'Kempton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9403496,
        LOCATION_LATITUDE_DEG: 52.4391715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010500',
        LOCATION_NAME: 'Kemsing',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2173702,
        LOCATION_LATITUDE_DEG: 51.3066214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010600',
        LOCATION_NAME: 'Kemsley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7402231,
        LOCATION_LATITUDE_DEG: 51.3627226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010700',
        LOCATION_NAME: 'Kenardington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.812991,
        LOCATION_LATITUDE_DEG: 51.0588903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010800',
        LOCATION_NAME: 'Kenchester',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8207606,
        LOCATION_LATITUDE_DEG: 52.0810284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE010900',
        LOCATION_NAME: 'Kencot',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6303018,
        LOCATION_LATITUDE_DEG: 51.7386816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011000',
        LOCATION_NAME: 'Kendal',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.746135,
        LOCATION_LATITUDE_DEG: 54.3266466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011100',
        LOCATION_NAME: 'Kendebig',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8142843,
        LOCATION_LATITUDE_DEG: 57.8787374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011200',
        LOCATION_NAME: 'Kendleshire',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4828334,
        LOCATION_LATITUDE_DEG: 51.5115732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011300',
        LOCATION_NAME: 'Kendray',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4550906,
        LOCATION_LATITUDE_DEG: 53.5394565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011400',
        LOCATION_NAME: 'Kenfig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.72616,
        LOCATION_LATITUDE_DEG: 51.5159899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011500',
        LOCATION_NAME: 'Kenfig Hill',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6767733,
        LOCATION_LATITUDE_DEG: 51.5327865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011600',
        LOCATION_NAME: 'Kenilworth',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5795776,
        LOCATION_LATITUDE_DEG: 52.3496432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011800',
        LOCATION_NAME: 'Kenley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6593164,
        LOCATION_LATITUDE_DEG: 52.5923835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011700',
        LOCATION_NAME: 'Kenley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0996968,
        LOCATION_LATITUDE_DEG: 51.3256253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012000',
        LOCATION_NAME: 'Kenmore',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9976074,
        LOCATION_LATITUDE_DEG: 56.5850862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012200',
        LOCATION_NAME: 'Kenn',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5258899,
        LOCATION_LATITUDE_DEG: 50.6582026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012100',
        LOCATION_NAME: 'Kenn',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8408408,
        LOCATION_LATITUDE_DEG: 51.4161723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012300',
        LOCATION_NAME: 'Kennards House',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4222452,
        LOCATION_LATITUDE_DEG: 50.6217122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012400',
        LOCATION_NAME: 'Kennerleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.67486,
        LOCATION_LATITUDE_DEG: 50.8512275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012500',
        LOCATION_NAME: 'Kennet',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7277296,
        LOCATION_LATITUDE_DEG: 56.1006322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012600',
        LOCATION_NAME: 'Kennethmont',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7670836,
        LOCATION_LATITUDE_DEG: 57.349449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012700',
        LOCATION_NAME: 'Kennett',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.48997,
        LOCATION_LATITUDE_DEG: 52.2830113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012800',
        LOCATION_NAME: 'Kennford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5361006,
        LOCATION_LATITUDE_DEG: 50.6615044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE012900',
        LOCATION_NAME: 'Kenninghall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9986946,
        LOCATION_LATITUDE_DEG: 52.434616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013000',
        LOCATION_NAME: 'Kennington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2436256,
        LOCATION_LATITUDE_DEG: 51.7160749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023100',
        LOCATION_NAME: 'Kennington',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1120952,
        LOCATION_LATITUDE_DEG: 51.4887563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013100',
        LOCATION_NAME: 'Kennington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8925576,
        LOCATION_LATITUDE_DEG: 51.1686983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013200',
        LOCATION_NAME: 'Kennoway',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0472932,
        LOCATION_LATITUDE_DEG: 56.21124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013300',
        LOCATION_NAME: 'Kenny Hill',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4524931,
        LOCATION_LATITUDE_DEG: 52.3897192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013400',
        LOCATION_NAME: 'Kennythorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7935555,
        LOCATION_LATITUDE_DEG: 54.0825013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013500',
        LOCATION_NAME: 'Kenovay',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8846253,
        LOCATION_LATITUDE_DEG: 56.5111065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023400',
        LOCATION_NAME: 'Kensal Rise',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2202388,
        LOCATION_LATITUDE_DEG: 51.5350463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013600',
        LOCATION_NAME: 'Kensaleyre',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.30165,
        LOCATION_LATITUDE_DEG: 57.4829994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023300',
        LOCATION_NAME: 'Kensington',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9555787,
        LOCATION_LATITUDE_DEG: 53.4114265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023200',
        LOCATION_NAME: 'Kensington',
        COUNTY_NAME: 'London',
        POSTCODE: 'W8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1932042,
        LOCATION_LATITUDE_DEG: 51.5021665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013700',
        LOCATION_NAME: 'Kensworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5027266,
        LOCATION_LATITUDE_DEG: 51.851379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013800',
        LOCATION_NAME: 'Kent International Airport',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3623251,
        LOCATION_LATITUDE_DEG: 51.345606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE013900',
        LOCATION_NAME: 'Kentallen',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2540427,
        LOCATION_LATITUDE_DEG: 56.6654098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014000',
        LOCATION_NAME: 'Kentangaval',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4700953,
        LOCATION_LATITUDE_DEG: 56.9729594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014100',
        LOCATION_NAME: 'Kentchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8565023,
        LOCATION_LATITUDE_DEG: 51.9291155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014200',
        LOCATION_NAME: 'Kentford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5022071,
        LOCATION_LATITUDE_DEG: 52.2722122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014300',
        LOCATION_NAME: 'Kentisbeare',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3239567,
        LOCATION_LATITUDE_DEG: 50.865621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014400',
        LOCATION_NAME: 'Kentisbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.971108,
        LOCATION_LATITUDE_DEG: 51.1776541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023000',
        LOCATION_NAME: 'Kentish Town',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1489176,
        LOCATION_LATITUDE_DEG: 51.5587734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014500',
        LOCATION_NAME: 'Kentmere',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8377517,
        LOCATION_LATITUDE_DEG: 54.4291608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014800',
        LOCATION_NAME: 'Kenton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4713745,
        LOCATION_LATITUDE_DEG: 50.639305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022800',
        LOCATION_NAME: 'Kenton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6491581,
        LOCATION_LATITUDE_DEG: 55.0046923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014600',
        LOCATION_NAME: 'Kenton',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3146288,
        LOCATION_LATITUDE_DEG: 51.5820545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014700',
        LOCATION_NAME: 'Kenton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2112715,
        LOCATION_LATITUDE_DEG: 52.2478921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022850',
        LOCATION_NAME: 'Kenton Bank Foot',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6795317,
        LOCATION_LATITUDE_DEG: 55.0154259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022900',
        LOCATION_NAME: 'Kenton Lane Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6417623,
        LOCATION_LATITUDE_DEG: 55.0134602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE014900',
        LOCATION_NAME: 'Kentra',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8442923,
        LOCATION_LATITUDE_DEG: 56.7556243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015000',
        LOCATION_NAME: 'Kents Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6965448,
        LOCATION_LATITUDE_DEG: 52.026799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015200',
        LOCATION_NAME: 'Kenwick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0089975,
        LOCATION_LATITUDE_DEG: 53.3410557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015300',
        LOCATION_NAME: 'Kenwick Park',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8700103,
        LOCATION_LATITUDE_DEG: 52.8616045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015400',
        LOCATION_NAME: 'Kenwyn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0656102,
        LOCATION_LATITUDE_DEG: 50.2661815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015500',
        LOCATION_NAME: 'Kenyon',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.55765,
        LOCATION_LATITUDE_DEG: 53.4558575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015600',
        LOCATION_NAME: 'Keose',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4787303,
        LOCATION_LATITUDE_DEG: 58.1058579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015700',
        LOCATION_NAME: 'Keose Glebe',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4742543,
        LOCATION_LATITUDE_DEG: 58.1075625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015800',
        LOCATION_NAME: 'Kepnal',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7516956,
        LOCATION_LATITUDE_DEG: 51.3402479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE023700',
        LOCATION_NAME: 'Keppochhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2331717,
        LOCATION_LATITUDE_DEG: 55.8804624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015900',
        LOCATION_NAME: 'Kepwick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2771611,
        LOCATION_LATITUDE_DEG: 54.3118316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016000',
        LOCATION_NAME: 'Kerdiston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0817481,
        LOCATION_LATITUDE_DEG: 52.778352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016100',
        LOCATION_NAME: 'Keresley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5321276,
        LOCATION_LATITUDE_DEG: 52.4520545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016200',
        LOCATION_NAME: 'Kergilliack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1099114,
        LOCATION_LATITUDE_DEG: 50.1541708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016300',
        LOCATION_NAME: 'Kermincham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2990591,
        LOCATION_LATITUDE_DEG: 53.2132344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016400',
        LOCATION_NAME: 'Kernborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6922894,
        LOCATION_LATITUDE_DEG: 50.2581702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016500',
        LOCATION_NAME: 'Kerne Bridge',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6079102,
        LOCATION_LATITUDE_DEG: 51.8667105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016600',
        LOCATION_NAME: 'Kernick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.117324,
        LOCATION_LATITUDE_DEG: 50.1602698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016700',
        LOCATION_NAME: 'Kerrera',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5278303,
        LOCATION_LATITUDE_DEG: 56.4018818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016800',
        LOCATION_NAME: 'Kerridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0963642,
        LOCATION_LATITUDE_DEG: 53.2900382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE016900',
        LOCATION_NAME: 'Kerrow Moor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7844767,
        LOCATION_LATITUDE_DEG: 50.38469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017000',
        LOCATION_NAME: 'Kerry',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2563403,
        LOCATION_LATITUDE_DEG: 52.5011738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017300',
        LOCATION_NAME: 'Kerrys Gate',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8834619,
        LOCATION_LATITUDE_DEG: 51.9938838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017400',
        LOCATION_NAME: 'Kersall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.931691,
        LOCATION_LATITUDE_DEG: 53.1511119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017500',
        LOCATION_NAME: 'Kersbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3174426,
        LOCATION_LATITUDE_DEG: 50.6392045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017600',
        LOCATION_NAME: 'Kersemill',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9081212,
        LOCATION_LATITUDE_DEG: 56.1104327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017700',
        LOCATION_NAME: 'Kersey',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9203178,
        LOCATION_LATITUDE_DEG: 52.0561838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017800',
        LOCATION_NAME: 'Kershader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5156433,
        LOCATION_LATITUDE_DEG: 58.0888566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017900',
        LOCATION_NAME: 'Kersoe',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.008256,
        LOCATION_LATITUDE_DEG: 52.0578187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018000',
        LOCATION_NAME: 'Kerswell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3073202,
        LOCATION_LATITUDE_DEG: 50.8460218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018100',
        LOCATION_NAME: 'Kerswell Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2018095,
        LOCATION_LATITUDE_DEG: 52.1165323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018200',
        LOCATION_NAME: 'Kesgrave',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2365353,
        LOCATION_LATITUDE_DEG: 52.064575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018300',
        LOCATION_NAME: 'Kesh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7221835,
        LOCATION_LATITUDE_DEG: 54.5251089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018600',
        LOCATION_NAME: 'Kessingland',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7255739,
        LOCATION_LATITUDE_DEG: 52.4195034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018700',
        LOCATION_NAME: 'Kestle Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0242898,
        LOCATION_LATITUDE_DEG: 50.3931908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018800',
        LOCATION_NAME: 'Keston',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0290447,
        LOCATION_LATITUDE_DEG: 51.3618245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018900',
        LOCATION_NAME: 'Keswick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1348947,
        LOCATION_LATITUDE_DEG: 54.6001772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019000',
        LOCATION_NAME: 'Keswick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2672285,
        LOCATION_LATITUDE_DEG: 52.5917212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019100',
        LOCATION_NAME: 'Ketford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4630133,
        LOCATION_LATITUDE_DEG: 51.9703185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019200',
        LOCATION_NAME: 'Ketley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4793113,
        LOCATION_LATITUDE_DEG: 52.6946834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019300',
        LOCATION_NAME: 'Ketley Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4528309,
        LOCATION_LATITUDE_DEG: 52.685482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019400',
        LOCATION_NAME: 'Ketsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0527691,
        LOCATION_LATITUDE_DEG: 53.2680107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019500',
        LOCATION_NAME: 'Kettering',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7262897,
        LOCATION_LATITUDE_DEG: 52.3955343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019600',
        LOCATION_NAME: 'Kettering Venture Park',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7244292,
        LOCATION_LATITUDE_DEG: 52.380534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019700',
        LOCATION_NAME: 'Ketteringham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1948287,
        LOCATION_LATITUDE_DEG: 52.5779309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019800',
        LOCATION_NAME: 'Kettins',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2388152,
        LOCATION_LATITUDE_DEG: 56.5378729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE019900',
        LOCATION_NAME: 'Kettlebaston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8722817,
        LOCATION_LATITUDE_DEG: 52.1158916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020000',
        LOCATION_NAME: 'Kettlebridge',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1169734,
        LOCATION_LATITUDE_DEG: 56.2563425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020100',
        LOCATION_NAME: 'Kettlebrook',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6851246,
        LOCATION_LATITUDE_DEG: 52.6269672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020200',
        LOCATION_NAME: 'Kettleburgh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.31711,
        LOCATION_LATITUDE_DEG: 52.1944908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020300',
        LOCATION_NAME: 'Kettlehill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0899272,
        LOCATION_LATITUDE_DEG: 56.2561433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020400',
        LOCATION_NAME: 'Kettleholm',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3408915,
        LOCATION_LATITUDE_DEG: 55.0791326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020500',
        LOCATION_NAME: 'Kettleness',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7146393,
        LOCATION_LATITUDE_DEG: 54.5283461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020600',
        LOCATION_NAME: 'Kettleshulme',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0176684,
        LOCATION_LATITUDE_DEG: 53.3140425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020700',
        LOCATION_NAME: 'Kettlesing',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6623616,
        LOCATION_LATITUDE_DEG: 54.0053981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020800',
        LOCATION_NAME: 'Kettlesing Bottom',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6528757,
        LOCATION_LATITUDE_DEG: 54.0121037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE020900',
        LOCATION_NAME: 'Kettlestone',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9235048,
        LOCATION_LATITUDE_DEG: 52.8468534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021000',
        LOCATION_NAME: 'Kettlethorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7299251,
        LOCATION_LATITUDE_DEG: 53.2727237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021100',
        LOCATION_NAME: 'Kettlewell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0458709,
        LOCATION_LATITUDE_DEG: 54.1460227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE990130',
        LOCATION_NAME: 'Ketton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5517128,
        LOCATION_LATITUDE_DEG: 52.6334766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021200',
        LOCATION_NAME: 'Ketton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5501491,
        LOCATION_LATITUDE_DEG: 52.6311557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021300',
        LOCATION_NAME: 'Kew',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'TW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2852224,
        LOCATION_LATITUDE_DEG: 51.4823417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021400',
        LOCATION_NAME: 'Kewstoke',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9587434,
        LOCATION_LATITUDE_DEG: 51.3638635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021600',
        LOCATION_NAME: 'Kexby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9314175,
        LOCATION_LATITUDE_DEG: 53.949992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021500',
        LOCATION_NAME: 'Kexby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6909298,
        LOCATION_LATITUDE_DEG: 53.3620262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021700',
        LOCATION_NAME: 'Key Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7016566,
        LOCATION_LATITUDE_DEG: 51.3495148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021800',
        LOCATION_NAME: 'Keybridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6985668,
        LOCATION_LATITUDE_DEG: 50.5325053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022000',
        LOCATION_NAME: 'Keyham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1753288,
        LOCATION_LATITUDE_DEG: 50.3859895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE021900',
        LOCATION_NAME: 'Keyham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0095309,
        LOCATION_LATITUDE_DEG: 52.6530689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022100',
        LOCATION_NAME: 'Keyhaven',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5668969,
        LOCATION_LATITUDE_DEG: 50.7218899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022200',
        LOCATION_NAME: 'Keyingham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1116094,
        LOCATION_LATITUDE_DEG: 53.7093581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022300',
        LOCATION_NAME: 'Keymer',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1303144,
        LOCATION_LATITUDE_DEG: 50.9214917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022400',
        LOCATION_NAME: 'Keynsham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4973699,
        LOCATION_LATITUDE_DEG: 51.4157679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022500',
        LOCATION_NAME: 'Keysoe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4231407,
        LOCATION_LATITUDE_DEG: 52.251422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022600',
        LOCATION_NAME: 'Keyston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.465924,
        LOCATION_LATITUDE_DEG: 52.3672283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE990597',
        LOCATION_NAME: 'Keythorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE022700',
        LOCATION_NAME: 'Keyworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0885016,
        LOCATION_LATITUDE_DEG: 52.8713899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000100',
        LOCATION_NAME: 'Kibblesworth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.619628,
        LOCATION_LATITUDE_DEG: 54.90479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000200',
        LOCATION_NAME: 'Kibworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.997392,
        LOCATION_LATITUDE_DEG: 52.5444522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990436',
        LOCATION_NAME: 'Kibworth Beauchamp',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9944624,
        LOCATION_LATITUDE_DEG: 52.5364791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990435',
        LOCATION_NAME: 'Kibworth Harcourt',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0013233,
        LOCATION_LATITUDE_DEG: 52.5349907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082500',
        LOCATION_NAME: 'Kidbrooke',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0336452,
        LOCATION_LATITUDE_DEG: 51.4736826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000300',
        LOCATION_NAME: 'Kiddemore Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2121508,
        LOCATION_LATITUDE_DEG: 52.677481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000400',
        LOCATION_NAME: 'Kidderminster',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.245473,
        LOCATION_LATITUDE_DEG: 52.3857592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000500',
        LOCATION_NAME: 'Kiddington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3970275,
        LOCATION_LATITUDE_DEG: 51.9025961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000600',
        LOCATION_NAME: 'Kidlington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2805217,
        LOCATION_LATITUDE_DEG: 51.8166872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000700',
        LOCATION_NAME: 'Kidmore End',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9937663,
        LOCATION_LATITUDE_DEG: 51.508458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000800',
        LOCATION_NAME: 'Kidnal',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7764153,
        LOCATION_LATITUDE_DEG: 53.0374246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI000900',
        LOCATION_NAME: 'Kidsgrove',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2390043,
        LOCATION_LATITUDE_DEG: 53.0866198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001000',
        LOCATION_NAME: 'Kidwelly',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.305946,
        LOCATION_LATITUDE_DEG: 51.735917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001100',
        LOCATION_NAME: 'Kielder',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5874664,
        LOCATION_LATITUDE_DEG: 55.2345354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001200',
        LOCATION_NAME: 'Kilaulay',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4048035,
        LOCATION_LATITUDE_DEG: 57.3905984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001300',
        LOCATION_NAME: 'Kilbagie',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7179124,
        LOCATION_LATITUDE_DEG: 56.0903351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001700',
        LOCATION_NAME: 'Kilbarchan',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5514161,
        LOCATION_LATITUDE_DEG: 55.8361156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002900',
        LOCATION_NAME: 'Kilberry',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6484668,
        LOCATION_LATITUDE_DEG: 55.8161241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003000',
        LOCATION_NAME: 'Kilbirnie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6849616,
        LOCATION_LATITUDE_DEG: 55.7564102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004100',
        LOCATION_NAME: 'Kilbucho',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4408206,
        LOCATION_LATITUDE_DEG: 55.6023797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004300',
        LOCATION_NAME: 'Kilburn',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4372871,
        LOCATION_LATITUDE_DEG: 53.0058039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004200',
        LOCATION_NAME: 'Kilburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2137632,
        LOCATION_LATITUDE_DEG: 54.2102146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082300',
        LOCATION_NAME: 'Kilburn',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2042768,
        LOCATION_LATITUDE_DEG: 51.5346411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004400',
        LOCATION_NAME: 'Kilby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0823317,
        LOCATION_LATITUDE_DEG: 52.5519565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005000',
        LOCATION_NAME: 'Kilchattan Bay',
        COUNTY_NAME: 'Isle of Bute',
        POSTCODE: 'PA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0233329,
        LOCATION_LATITUDE_DEG: 55.7509104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005100',
        LOCATION_NAME: 'Kilchoan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1022117,
        LOCATION_LATITUDE_DEG: 56.6980171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005200',
        LOCATION_NAME: 'Kilchoman',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.440034,
        LOCATION_LATITUDE_DEG: 55.7819281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005400',
        LOCATION_NAME: 'Kilchrenan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1750333,
        LOCATION_LATITUDE_DEG: 56.3567789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005600',
        LOCATION_NAME: 'Kilclief',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5488732,
        LOCATION_LATITUDE_DEG: 54.3331819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007000',
        LOCATION_NAME: 'Kilconquhar',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8241408,
        LOCATION_LATITUDE_DEG: 56.2101335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007100',
        LOCATION_NAME: 'Kilcoo',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0244146,
        LOCATION_LATITUDE_DEG: 54.2346702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007700',
        LOCATION_NAME: 'Kilcot',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4406026,
        LOCATION_LATITUDE_DEG: 51.926713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008100',
        LOCATION_NAME: 'Kilcreggan',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8227867,
        LOCATION_LATITUDE_DEG: 55.9842364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009100',
        LOCATION_NAME: 'Kildale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0616727,
        LOCATION_LATITUDE_DEG: 54.4762399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009500',
        LOCATION_NAME: 'Kildary',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0722489,
        LOCATION_LATITUDE_DEG: 57.7491054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009700',
        LOCATION_NAME: 'Kildean',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9556188,
        LOCATION_LATITUDE_DEG: 56.1313406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010000',
        LOCATION_NAME: 'Kildonan',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1065224,
        LOCATION_LATITUDE_DEG: 55.4427852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009900',
        LOCATION_NAME: 'Kildonan',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8613584,
        LOCATION_LATITUDE_DEG: 58.1762827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010500',
        LOCATION_NAME: 'Kildrochat',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9921895,
        LOCATION_LATITUDE_DEG: 54.8671219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010700',
        LOCATION_NAME: 'Kildrummy',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.87865,
        LOCATION_LATITUDE_DEG: 57.2386348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010800',
        LOCATION_NAME: 'Kildwick',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9830711,
        LOCATION_LATITUDE_DEG: 53.9084957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010900',
        LOCATION_NAME: 'Kilerivagh',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.288952,
        LOCATION_LATITUDE_DEG: 57.4164007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011500',
        LOCATION_NAME: 'Kilfinan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3100961,
        LOCATION_LATITUDE_DEG: 55.9571341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012300',
        LOCATION_NAME: 'Kilgetty',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7127066,
        LOCATION_LATITUDE_DEG: 51.7326234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013200',
        LOCATION_NAME: 'Kilhallon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7098693,
        LOCATION_LATITUDE_DEG: 50.3603915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013300',
        LOCATION_NAME: 'Kilham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3751548,
        LOCATION_LATITUDE_DEG: 54.0638951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013800',
        LOCATION_NAME: 'Kilkeel',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.001323,
        LOCATION_LATITUDE_DEG: 54.0714544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014000',
        LOCATION_NAME: 'Kilkenneth',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.96671,
        LOCATION_LATITUDE_DEG: 56.494203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014200',
        LOCATION_NAME: 'Kilkenzie',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6799238,
        LOCATION_LATITUDE_DEG: 55.4633881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014400',
        LOCATION_NAME: 'Kilkerran',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6704016,
        LOCATION_LATITUDE_DEG: 55.2959659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014500',
        LOCATION_NAME: 'Kilkhampton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4827316,
        LOCATION_LATITUDE_DEG: 50.874233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990079',
        LOCATION_NAME: 'KILLADEAS',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6832133,
        LOCATION_LATITUDE_DEG: 54.4352082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016200',
        LOCATION_NAME: 'Killaloo',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1823314,
        LOCATION_LATITUDE_DEG: 54.9166478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016300',
        LOCATION_NAME: 'Killamarsh',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3169255,
        LOCATION_LATITUDE_DEG: 53.3247372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016700',
        LOCATION_NAME: 'Killard',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6044668,
        LOCATION_LATITUDE_DEG: 54.3119793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017800',
        LOCATION_NAME: 'Killay',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0194743,
        LOCATION_LATITUDE_DEG: 51.6169994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018300',
        LOCATION_NAME: 'Killearn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3669935,
        LOCATION_LATITUDE_DEG: 56.0425345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018350',
        LOCATION_NAME: 'Killeavy',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3834024,
        LOCATION_LATITUDE_DEG: 54.1220106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018800',
        LOCATION_NAME: 'Killeen',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.36475,
        LOCATION_LATITUDE_DEG: 54.1211602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019500',
        LOCATION_NAME: 'Killen',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6323652,
        LOCATION_LATITUDE_DEG: 54.6666308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019600',
        LOCATION_NAME: 'Killen',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2122874,
        LOCATION_LATITUDE_DEG: 57.5935848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020100',
        LOCATION_NAME: 'Killerby',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7008174,
        LOCATION_LATITUDE_DEG: 54.5731571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020500',
        LOCATION_NAME: 'Killerton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4513521,
        LOCATION_LATITUDE_DEG: 50.7922161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020700',
        LOCATION_NAME: 'Killeter',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6823751,
        LOCATION_LATITUDE_DEG: 54.6666288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020800',
        LOCATION_NAME: 'Killiechonate',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8847611,
        LOCATION_LATITUDE_DEG: 56.8876252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020900',
        LOCATION_NAME: 'Killiechronan',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9995186,
        LOCATION_LATITUDE_DEG: 56.4988001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021000',
        LOCATION_NAME: 'Killiecrankie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7706616,
        LOCATION_LATITUDE_DEG: 56.7474956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021100',
        LOCATION_NAME: 'Killigarth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5066639,
        LOCATION_LATITUDE_DEG: 50.3366865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021200',
        LOCATION_NAME: 'Killilan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4103257,
        LOCATION_LATITUDE_DEG: 57.3169757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021500',
        LOCATION_NAME: 'Killin',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3167084,
        LOCATION_LATITUDE_DEG: 56.4677766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021800',
        LOCATION_NAME: 'Killinchy',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6655705,
        LOCATION_LATITUDE_DEG: 54.4665964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022200',
        LOCATION_NAME: 'Killingbeck',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4829604,
        LOCATION_LATITUDE_DEG: 53.7981849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022300',
        LOCATION_NAME: 'Killinghall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5649895,
        LOCATION_LATITUDE_DEG: 54.0218043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022400',
        LOCATION_NAME: 'Killington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5946285,
        LOCATION_LATITUDE_DEG: 54.2945459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022500',
        LOCATION_NAME: 'Killingworth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5663245,
        LOCATION_LATITUDE_DEG: 55.0345056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022900',
        LOCATION_NAME: 'Killiow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0799197,
        LOCATION_LATITUDE_DEG: 50.2375799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023100',
        LOCATION_NAME: 'Killivose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2994388,
        LOCATION_LATITUDE_DEG: 50.201174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024100',
        LOCATION_NAME: 'Killough',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6486704,
        LOCATION_LATITUDE_DEG: 54.2528617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024200',
        LOCATION_NAME: 'Killowen',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1636216,
        LOCATION_LATITUDE_DEG: 54.0723607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025100',
        LOCATION_NAME: 'Killyblane',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2823531,
        LOCATION_LATITUDE_DEG: 54.3665885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025200',
        LOCATION_NAME: 'Killyclogher',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2688196,
        LOCATION_LATITUDE_DEG: 54.6056743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025300',
        LOCATION_NAME: 'Killycolpy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5822647,
        LOCATION_LATITUDE_DEG: 54.5832121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025600',
        LOCATION_NAME: 'Killylea',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7822823,
        LOCATION_LATITUDE_DEG: 54.3498899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025700',
        LOCATION_NAME: 'Killyleagh',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6622676,
        LOCATION_LATITUDE_DEG: 54.4033879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025750',
        LOCATION_NAME: 'Killyman',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7030331,
        LOCATION_LATITUDE_DEG: 54.510717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025800',
        LOCATION_NAME: 'Killynure',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3680493,
        LOCATION_LATITUDE_DEG: 54.6147141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026300',
        LOCATION_NAME: 'Kilmacolm',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6253495,
        LOCATION_LATITUDE_DEG: 55.893521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026900',
        LOCATION_NAME: 'Kilmahog',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2443397,
        LOCATION_LATITUDE_DEG: 56.2479505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027600',
        LOCATION_NAME: 'Kilmaluag',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3257463,
        LOCATION_LATITUDE_DEG: 57.6827216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027900',
        LOCATION_NAME: 'Kilmany',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9897748,
        LOCATION_LATITUDE_DEG: 56.3849514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028100',
        LOCATION_NAME: 'Kilmarnock',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4979236,
        LOCATION_LATITUDE_DEG: 55.609992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028200',
        LOCATION_NAME: 'Kilmartin',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4839387,
        LOCATION_LATITUDE_DEG: 56.1330571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028400',
        LOCATION_NAME: 'Kilmaurs',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5256876,
        LOCATION_LATITUDE_DEG: 55.6376949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029100',
        LOCATION_NAME: 'Kilmelford',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4735272,
        LOCATION_LATITUDE_DEG: 56.2607728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029200',
        LOCATION_NAME: 'Kilmersdon',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.436553,
        LOCATION_LATITUDE_DEG: 51.2694544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029400',
        LOCATION_NAME: 'Kilmeston',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.158059,
        LOCATION_LATITUDE_DEG: 51.0327149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029600',
        LOCATION_NAME: 'Kilmichael Glassary',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.441979,
        LOCATION_LATITUDE_DEG: 56.0862546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029800',
        LOCATION_NAME: 'Kilmington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0354876,
        LOCATION_LATITUDE_DEG: 50.7768087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029900',
        LOCATION_NAME: 'Kilmington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3253461,
        LOCATION_LATITUDE_DEG: 51.1266386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030000',
        LOCATION_NAME: 'Kilmington Common',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3253333,
        LOCATION_LATITUDE_DEG: 51.1207392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030200',
        LOCATION_NAME: 'Kilmorack',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5122942,
        LOCATION_LATITUDE_DEG: 57.4642742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030600',
        LOCATION_NAME: 'Kilmore',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.548951,
        LOCATION_LATITUDE_DEG: 54.3998933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030900',
        LOCATION_NAME: 'Kilmore',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.869175,
        LOCATION_LATITUDE_DEG: 57.0918553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030500',
        LOCATION_NAME: 'Kilmore',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4391164,
        LOCATION_LATITUDE_DEG: 56.373877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031300',
        LOCATION_NAME: 'Kilmory',
        COUNTY_NAME: 'Highland',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0429089,
        LOCATION_LATITUDE_DEG: 56.757122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031450',
        LOCATION_NAME: 'Kilmory',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6755258,
        LOCATION_LATITUDE_DEG: 55.9142473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031400',
        LOCATION_NAME: 'Kilmory',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2217724,
        LOCATION_LATITUDE_DEG: 55.4478859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031900',
        LOCATION_NAME: 'Kilmuir',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5712511,
        LOCATION_LATITUDE_DEG: 57.4315967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031800',
        LOCATION_NAME: 'Kilmuir',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0871492,
        LOCATION_LATITUDE_DEG: 57.7308981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032000',
        LOCATION_NAME: 'Kilmun',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9271972,
        LOCATION_LATITUDE_DEG: 55.9901337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032900',
        LOCATION_NAME: 'Kiln Farm',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8209921,
        LOCATION_LATITUDE_DEG: 52.0451053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033000',
        LOCATION_NAME: 'Kiln Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8252631,
        LOCATION_LATITUDE_DEG: 51.4986539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033100',
        LOCATION_NAME: 'Kiln Pit Hill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9381305,
        LOCATION_LATITUDE_DEG: 54.8913941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033700',
        LOCATION_NAME: 'Kilncadzow',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.776494,
        LOCATION_LATITUDE_DEG: 55.7190956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033800',
        LOCATION_NAME: 'Kilndown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.428449,
        LOCATION_LATITUDE_DEG: 51.0912009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033900',
        LOCATION_NAME: 'Kilnhurst',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3043425,
        LOCATION_LATITUDE_DEG: 53.4704522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034000',
        LOCATION_NAME: 'Kilninver',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5146069,
        LOCATION_LATITUDE_DEG: 56.3379756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034100',
        LOCATION_NAME: 'Kilnsea',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1410046,
        LOCATION_LATITUDE_DEG: 53.6198461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034200',
        LOCATION_NAME: 'Kilnsey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0384997,
        LOCATION_LATITUDE_DEG: 54.1057208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034300',
        LOCATION_NAME: 'Kilnwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4809491,
        LOCATION_LATITUDE_DEG: 53.9307832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034400',
        LOCATION_NAME: 'Kilnwick Percy',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7438605,
        LOCATION_LATITUDE_DEG: 53.9408867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034700',
        LOCATION_NAME: 'Kilpeck',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8062618,
        LOCATION_LATITUDE_DEG: 51.9688194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034800',
        LOCATION_NAME: 'Kilpheder',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3901488,
        LOCATION_LATITUDE_DEG: 57.1525707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035000',
        LOCATION_NAME: 'Kilpin',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8288297,
        LOCATION_LATITUDE_DEG: 53.7324691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035200',
        LOCATION_NAME: 'Kilquhanity',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9280668,
        LOCATION_LATITUDE_DEG: 55.0139283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035600',
        LOCATION_NAME: 'Kilraughts',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4156453,
        LOCATION_LATITUDE_DEG: 55.0499567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035700',
        LOCATION_NAME: 'Kilrea',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5723571,
        LOCATION_LATITUDE_DEG: 54.9735516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035900',
        LOCATION_NAME: 'Kilrenny',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6855856,
        LOCATION_LATITUDE_DEG: 56.2342339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036300',
        LOCATION_NAME: 'Kilroot',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7647637,
        LOCATION_LATITUDE_DEG: 54.7282158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036800',
        LOCATION_NAME: 'Kilry',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2318309,
        LOCATION_LATITUDE_DEG: 56.6667881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036900',
        LOCATION_NAME: 'Kilsall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2986806,
        LOCATION_LATITUDE_DEG: 52.6506819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037400',
        LOCATION_NAME: 'Kilsby',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1751142,
        LOCATION_LATITUDE_DEG: 52.3336381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038100',
        LOCATION_NAME: 'Kilspindie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2648164,
        LOCATION_LATITUDE_DEG: 56.417164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038200',
        LOCATION_NAME: 'Kilsyth',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0566421,
        LOCATION_LATITUDE_DEG: 55.9784253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038500',
        LOCATION_NAME: 'Kiltamnagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.331958,
        LOCATION_LATITUDE_DEG: 54.5361082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038600',
        LOCATION_NAME: 'KILTARLITY',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4940441,
        LOCATION_LATITUDE_DEG: 57.4377738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038900',
        LOCATION_NAME: 'Kiltearn',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3200168,
        LOCATION_LATITUDE_DEG: 57.6581975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040900',
        LOCATION_NAME: 'Kilvaxter',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3787403,
        LOCATION_LATITUDE_DEG: 57.6446116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041000',
        LOCATION_NAME: 'Kilve',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2185589,
        LOCATION_LATITUDE_DEG: 51.1794518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041100',
        LOCATION_NAME: 'Kilverstone',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7746881,
        LOCATION_LATITUDE_DEG: 52.4148606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041300',
        LOCATION_NAME: 'Kilvington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8089298,
        LOCATION_LATITUDE_DEG: 52.9771919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041400',
        LOCATION_NAME: 'Kilwaughter',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.876378,
        LOCATION_LATITUDE_DEG: 54.8338235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041500',
        LOCATION_NAME: 'Kilwhipnach',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6711345,
        LOCATION_LATITUDE_DEG: 55.3875881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041600',
        LOCATION_NAME: 'Kilwinning',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7008924,
        LOCATION_LATITUDE_DEG: 55.6536039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041900',
        LOCATION_NAME: 'Kilworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1428217,
        LOCATION_LATITUDE_DEG: 50.5719048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042100',
        LOCATION_NAME: 'Kimberley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2690006,
        LOCATION_LATITUDE_DEG: 52.9996021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042000',
        LOCATION_NAME: 'Kimberley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0577919,
        LOCATION_LATITUDE_DEG: 52.595628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042200',
        LOCATION_NAME: 'Kimberworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3939951,
        LOCATION_LATITUDE_DEG: 53.4362493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042300',
        LOCATION_NAME: 'Kimblesworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5972965,
        LOCATION_LATITUDE_DEG: 54.8230846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042400',
        LOCATION_NAME: 'Kimblewick',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8354246,
        LOCATION_LATITUDE_DEG: 51.7586272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042600',
        LOCATION_NAME: 'Kimbolton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6926717,
        LOCATION_LATITUDE_DEG: 52.2510465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042500',
        LOCATION_NAME: 'Kimbolton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.388096,
        LOCATION_LATITUDE_DEG: 52.2970247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042700',
        LOCATION_NAME: 'Kimbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5222626,
        LOCATION_LATITUDE_DEG: 51.0296181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042800',
        LOCATION_NAME: 'Kimcote',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.136482,
        LOCATION_LATITUDE_DEG: 52.4729533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI042900',
        LOCATION_NAME: 'Kimmeridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1153234,
        LOCATION_LATITUDE_DEG: 50.6161867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043000',
        LOCATION_NAME: 'Kimpton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5966633,
        LOCATION_LATITUDE_DEG: 51.2186375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043100',
        LOCATION_NAME: 'Kimpton',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2891955,
        LOCATION_LATITUDE_DEG: 51.8512817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043200',
        LOCATION_NAME: 'Kimpton Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6161636,
        LOCATION_LATITUDE_DEG: 51.2242337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990077',
        LOCATION_NAME: 'Kinallen',
        COUNTY_NAME: 'County Down',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0720017,
        LOCATION_LATITUDE_DEG: 54.382161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043700',
        LOCATION_NAME: 'Kinawley',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6323794,
        LOCATION_LATITUDE_DEG: 54.2165742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043800',
        LOCATION_NAME: 'Kinbrace',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9392819,
        LOCATION_LATITUDE_DEG: 58.2592474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043900',
        LOCATION_NAME: 'Kinbuck',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9480036,
        LOCATION_LATITUDE_DEG: 56.2222523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044000',
        LOCATION_NAME: 'Kincaldrum',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9325009,
        LOCATION_LATITUDE_DEG: 56.5882699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044100',
        LOCATION_NAME: 'Kincaple',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8710466,
        LOCATION_LATITUDE_DEG: 56.3537455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044200',
        LOCATION_NAME: 'Kincardine',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7172836,
        LOCATION_LATITUDE_DEG: 56.0675345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044300',
        LOCATION_NAME: 'Kincardine Castle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6990936,
        LOCATION_LATITUDE_DEG: 56.2844536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044400',
        LOCATION_NAME: "Kincardine O'Neil",
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6772601,
        LOCATION_LATITUDE_DEG: 57.086717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044800',
        LOCATION_NAME: 'Kincraig',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9309478,
        LOCATION_LATITUDE_DEG: 57.1275342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044900',
        LOCATION_NAME: 'Kindallachan',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6384874,
        LOCATION_LATITUDE_DEG: 56.6296876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045000',
        LOCATION_NAME: 'Kinderton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3987733,
        LOCATION_LATITUDE_DEG: 53.1683341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045200',
        LOCATION_NAME: 'Kinellar',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3157092,
        LOCATION_LATITUDE_DEG: 57.2073236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045300',
        LOCATION_NAME: 'Kineton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5097255,
        LOCATION_LATITUDE_DEG: 52.15622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045400',
        LOCATION_NAME: 'Kinfauns',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3507416,
        LOCATION_LATITUDE_DEG: 56.3851572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045500',
        LOCATION_NAME: 'King Cross',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8789953,
        LOCATION_LATITUDE_DEG: 53.715577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045600',
        LOCATION_NAME: 'King Edward',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4764191,
        LOCATION_LATITUDE_DEG: 57.6104697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083200',
        LOCATION_NAME: 'King George V Dock',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0561263,
        LOCATION_LATITUDE_DEG: 51.5050566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045700',
        LOCATION_NAME: 'King Harry',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0514983,
        LOCATION_LATITUDE_DEG: 50.203081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045800',
        LOCATION_NAME: 'King Stag',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3970994,
        LOCATION_LATITUDE_DEG: 50.8923752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045900',
        LOCATION_NAME: 'King Sterndale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8573339,
        LOCATION_LATITUDE_DEG: 53.245735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046200',
        LOCATION_NAME: 'Kingairloch',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5278367,
        LOCATION_LATITUDE_DEG: 56.6209008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046300',
        LOCATION_NAME: 'Kingarrow',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2917129,
        LOCATION_LATITUDE_DEG: 54.6621052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046500',
        LOCATION_NAME: 'Kingarth',
        COUNTY_NAME: 'Isle of Bute',
        POSTCODE: 'PA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0388523,
        LOCATION_LATITUDE_DEG: 55.7633121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046600',
        LOCATION_NAME: 'Kingcoed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8270058,
        LOCATION_LATITUDE_DEG: 51.7429988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046700',
        LOCATION_NAME: 'Kingennie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8394991,
        LOCATION_LATITUDE_DEG: 56.5073636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046800',
        LOCATION_NAME: 'Kingerby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4078359,
        LOCATION_LATITUDE_DEG: 53.4211329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046900',
        LOCATION_NAME: 'Kingfield',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5508536,
        LOCATION_LATITUDE_DEG: 51.3040269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047000',
        LOCATION_NAME: 'Kingham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6230927,
        LOCATION_LATITUDE_DEG: 51.9121065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047100',
        LOCATION_NAME: 'Kingheriot',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1809296,
        LOCATION_LATITUDE_DEG: 51.8903348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047200',
        LOCATION_NAME: 'Kingholm Quay',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6020224,
        LOCATION_LATITUDE_DEG: 55.0449314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047300',
        LOCATION_NAME: 'Kinghorn',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1712194,
        LOCATION_LATITUDE_DEG: 56.0728277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047400',
        LOCATION_NAME: 'Kinglassie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2392259,
        LOCATION_LATITUDE_DEG: 56.1737366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047500',
        LOCATION_NAME: 'Kingmoor',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.961176,
        LOCATION_LATITUDE_DEG: 54.916306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047600',
        LOCATION_NAME: 'Kingoldrum',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0858601,
        LOCATION_LATITUDE_DEG: 56.6832869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047700',
        LOCATION_NAME: 'Kingoodie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0747026,
        LOCATION_LATITUDE_DEG: 56.4511613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047800',
        LOCATION_NAME: 'Kings Ash',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7150513,
        LOCATION_LATITUDE_DEG: 51.7411771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI047900',
        LOCATION_NAME: 'Kings Bromley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8223242,
        LOCATION_LATITUDE_DEG: 52.7481324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI991010',
        LOCATION_NAME: 'Kings Bromley Lane',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048000',
        LOCATION_NAME: 'Kings Caple',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.641615,
        LOCATION_LATITUDE_DEG: 51.9508406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048050',
        LOCATION_NAME: 'Kings Cliffe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5137451,
        LOCATION_LATITUDE_DEG: 52.5624042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048100',
        LOCATION_NAME: 'Kings Coughton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8799798,
        LOCATION_LATITUDE_DEG: 52.2265468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083300',
        LOCATION_NAME: 'Kings Cross',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082700',
        LOCATION_NAME: 'Kings Cross',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1235089,
        LOCATION_LATITUDE_DEG: 51.5314432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048200',
        LOCATION_NAME: 'Kings Delph',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1765043,
        LOCATION_LATITUDE_DEG: 52.5438417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048300',
        LOCATION_NAME: 'Kings Heanton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.071402,
        LOCATION_LATITUDE_DEG: 51.1128527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083800',
        LOCATION_NAME: 'Kings Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8983989,
        LOCATION_LATITUDE_DEG: 52.4253516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048500',
        LOCATION_NAME: 'Kings Hill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5289483,
        LOCATION_LATITUDE_DEG: 50.8169297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048400',
        LOCATION_NAME: 'Kings Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3893519,
        LOCATION_LATITUDE_DEG: 51.2715135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048600',
        LOCATION_NAME: 'Kings Langley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4488649,
        LOCATION_LATITUDE_DEG: 51.7136661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080400',
        LOCATION_NAME: 'Kings Lynn',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3958463,
        LOCATION_LATITUDE_DEG: 52.757073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046000',
        LOCATION_NAME: "King's Lynn",
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3970753,
        LOCATION_LATITUDE_DEG: 52.7516526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048700',
        LOCATION_NAME: 'Kings Meaburn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5898157,
        LOCATION_LATITUDE_DEG: 54.5894545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048800',
        LOCATION_NAME: 'Kings Moss',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.74309,
        LOCATION_LATITUDE_DEG: 53.5050647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080500',
        LOCATION_NAME: 'Kings Newnham',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3401613,
        LOCATION_LATITUDE_DEG: 52.3959241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046100',
        LOCATION_NAME: "King's Newnham",
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3359223,
        LOCATION_LATITUDE_DEG: 52.3904427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084100',
        LOCATION_NAME: 'Kings Norton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9215833,
        LOCATION_LATITUDE_DEG: 52.4059844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI048900',
        LOCATION_NAME: 'Kings Nympton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.875514,
        LOCATION_LATITUDE_DEG: 50.9567191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084600',
        LOCATION_NAME: 'Kings Park',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2452746,
        LOCATION_LATITUDE_DEG: 55.8133855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049000',
        LOCATION_NAME: 'Kings Pyon',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8209181,
        LOCATION_LATITUDE_DEG: 52.1500393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049100',
        LOCATION_NAME: 'Kings Ripton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1479166,
        LOCATION_LATITUDE_DEG: 52.3724282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049200',
        LOCATION_NAME: 'Kings Somborne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4878591,
        LOCATION_LATITUDE_DEG: 51.0830273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990572',
        LOCATION_NAME: 'kings stag',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049300',
        LOCATION_NAME: 'Kings Stanley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2704638,
        LOCATION_LATITUDE_DEG: 51.7280084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049400',
        LOCATION_NAME: 'Kings Sutton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2745614,
        LOCATION_LATITUDE_DEG: 52.0222086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049500',
        LOCATION_NAME: 'Kings Walden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3201998,
        LOCATION_LATITUDE_DEG: 51.8999752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049600',
        LOCATION_NAME: 'Kings Worthy',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.296368,
        LOCATION_LATITUDE_DEG: 51.0881201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049700',
        LOCATION_NAME: 'Kingsand',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.200246,
        LOCATION_LATITUDE_DEG: 50.3327801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049800',
        LOCATION_NAME: 'Kingsbarns',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6562389,
        LOCATION_LATITUDE_DEG: 56.2993408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI049900',
        LOCATION_NAME: 'Kingsbridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7758667,
        LOCATION_LATITUDE_DEG: 50.2832698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050000',
        LOCATION_NAME: 'Kingsburgh',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3506452,
        LOCATION_LATITUDE_DEG: 57.5133996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082400',
        LOCATION_NAME: 'Kingsbury',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1615331,
        LOCATION_LATITUDE_DEG: 53.373829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050100',
        LOCATION_NAME: 'Kingsbury',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.680426,
        LOCATION_LATITUDE_DEG: 52.5640635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050200',
        LOCATION_NAME: 'Kingsbury Episcopi',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8054941,
        LOCATION_LATITUDE_DEG: 50.9863318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050300',
        LOCATION_NAME: 'Kingsclere',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2418184,
        LOCATION_LATITUDE_DEG: 51.3244422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050500',
        LOCATION_NAME: 'Kingscote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2646074,
        LOCATION_LATITUDE_DEG: 51.6648873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050400',
        LOCATION_NAME: 'Kingscote',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0510223,
        LOCATION_LATITUDE_DEG: 51.0789991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050600',
        LOCATION_NAME: 'Kingscott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0804911,
        LOCATION_LATITUDE_DEG: 50.9431366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050700',
        LOCATION_NAME: 'Kingscourt',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.224896,
        LOCATION_LATITUDE_DEG: 51.7283922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050900',
        LOCATION_NAME: 'Kingsdon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6902635,
        LOCATION_LATITUDE_DEG: 51.031335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051300',
        LOCATION_NAME: 'Kingsdown',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.598145,
        LOCATION_LATITUDE_DEG: 51.4622749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051000',
        LOCATION_NAME: 'Kingsdown',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2745436,
        LOCATION_LATITUDE_DEG: 51.4015647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051100',
        LOCATION_NAME: 'Kingsdown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7683664,
        LOCATION_LATITUDE_DEG: 51.2995089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051200',
        LOCATION_NAME: 'Kingsdown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3997454,
        LOCATION_LATITUDE_DEG: 51.1836889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051400',
        LOCATION_NAME: 'Kingseat',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4057404,
        LOCATION_LATITUDE_DEG: 56.0985258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051500',
        LOCATION_NAME: 'Kingsey',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9240181,
        LOCATION_LATITUDE_DEG: 51.7538783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051600',
        LOCATION_NAME: 'Kingsfold',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3301475,
        LOCATION_LATITUDE_DEG: 51.1155097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051700',
        LOCATION_NAME: 'Kingsford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8711015,
        LOCATION_LATITUDE_DEG: 51.8582644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051800',
        LOCATION_NAME: 'Kingsgate',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4350251,
        LOCATION_LATITUDE_DEG: 51.3828082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI051900',
        LOCATION_NAME: 'Kingsham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7871915,
        LOCATION_LATITUDE_DEG: 50.8263923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052000',
        LOCATION_NAME: 'Kingshurst',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7557823,
        LOCATION_LATITUDE_DEG: 52.4910565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052100',
        LOCATION_NAME: 'Kingside Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3091278,
        LOCATION_LATITUDE_DEG: 54.8488084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052200',
        LOCATION_NAME: 'Kingskerswell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5777103,
        LOCATION_LATITUDE_DEG: 50.4980925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052300',
        LOCATION_NAME: 'Kingskettle',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1134259,
        LOCATION_LATITUDE_DEG: 56.2620446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052500',
        LOCATION_NAME: 'Kingsland',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6296885,
        LOCATION_LATITUDE_DEG: 53.299571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052600',
        LOCATION_NAME: 'Kingsland',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8102264,
        LOCATION_LATITUDE_DEG: 52.2478526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052700',
        LOCATION_NAME: 'Kingsland',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.771913,
        LOCATION_LATITUDE_DEG: 52.7035957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052800',
        LOCATION_NAME: 'Kingsley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6726112,
        LOCATION_LATITUDE_DEG: 53.2685465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052900',
        LOCATION_NAME: 'Kingsley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9844945,
        LOCATION_LATITUDE_DEG: 53.0199092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053000',
        LOCATION_NAME: 'Kingsley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8687842,
        LOCATION_LATITUDE_DEG: 51.1389233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053100',
        LOCATION_NAME: 'Kingsley Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7218741,
        LOCATION_LATITUDE_DEG: 51.0671071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053200',
        LOCATION_NAME: 'Kingsley Holt',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.970381,
        LOCATION_LATITUDE_DEG: 53.0119142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053300',
        LOCATION_NAME: 'Kingsley Moor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0081698,
        LOCATION_LATITUDE_DEG: 53.018013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053400',
        LOCATION_NAME: 'Kingsmead',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.800859,
        LOCATION_LATITUDE_DEG: 52.0028996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053500',
        LOCATION_NAME: 'Kingsmuir',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8498816,
        LOCATION_LATITUDE_DEG: 56.6328806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053600',
        LOCATION_NAME: 'Kingsnorth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.860086,
        LOCATION_LATITUDE_DEG: 51.1181964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053700',
        LOCATION_NAME: 'Kingstanding',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8977013,
        LOCATION_LATITUDE_DEG: 52.5550641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053800',
        LOCATION_NAME: 'Kingsteignton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.595865,
        LOCATION_LATITUDE_DEG: 50.5496993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI053900',
        LOCATION_NAME: 'Kingsthorne',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7307615,
        LOCATION_LATITUDE_DEG: 51.9839241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054000',
        LOCATION_NAME: 'Kingsthorpe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8961642,
        LOCATION_LATITUDE_DEG: 52.2663242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054200',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3171335,
        LOCATION_LATITUDE_DEG: 50.5550998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055100',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9162883,
        LOCATION_LATITUDE_DEG: 50.3134761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054400',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1073385,
        LOCATION_LATITUDE_DEG: 57.6742844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054900',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7346129,
        LOCATION_LATITUDE_DEG: 56.0315197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990351',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.353742,
        LOCATION_LATITUDE_DEG: 50.8846813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055000',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3525666,
        LOCATION_LATITUDE_DEG: 50.8834168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054600',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7887198,
        LOCATION_LATITUDE_DEG: 50.8177995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054500',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5038729,
        LOCATION_LATITUDE_DEG: 53.5465548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054300',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3152514,
        LOCATION_LATITUDE_DEG: 50.6161743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054700',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7132455,
        LOCATION_LATITUDE_DEG: 52.0411993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054800',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4337563,
        LOCATION_LATITUDE_DEG: 50.812379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083400',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2830639,
        LOCATION_LATITUDE_DEG: 51.4224405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI054100',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0318074,
        LOCATION_LATITUDE_DEG: 52.1788098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056100',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0190269,
        LOCATION_LATITUDE_DEG: 50.8569822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055200',
        LOCATION_NAME: 'Kingston',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1526466,
        LOCATION_LATITUDE_DEG: 51.2170991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055300',
        LOCATION_NAME: 'Kingston Bagpuize',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4112221,
        LOCATION_LATITUDE_DEG: 51.6815775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055400',
        LOCATION_NAME: 'Kingston Blount',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9299296,
        LOCATION_LATITUDE_DEG: 51.6888713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055500',
        LOCATION_NAME: 'Kingston Bridge',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8425688,
        LOCATION_LATITUDE_DEG: 51.3998648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055600',
        LOCATION_NAME: 'Kingston Deverill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2189856,
        LOCATION_LATITUDE_DEG: 51.1320392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055700',
        LOCATION_NAME: 'Kingston Gorse',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4600153,
        LOCATION_LATITUDE_DEG: 50.8038783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055800',
        LOCATION_NAME: 'Kingston Lacy',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.033615,
        LOCATION_LATITUDE_DEG: 50.8129046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI055900',
        LOCATION_NAME: 'Kingston Lisle',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5300742,
        LOCATION_LATITUDE_DEG: 51.5862724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056000',
        LOCATION_NAME: 'Kingston Maurward',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3960431,
        LOCATION_LATITUDE_DEG: 50.7172999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080800',
        LOCATION_NAME: 'Kingston on Soar',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081800',
        LOCATION_NAME: 'Kingston Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.665885,
        LOCATION_LATITUDE_DEG: 55.0126661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056200',
        LOCATION_NAME: 'Kingston Seymour',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8589623,
        LOCATION_LATITUDE_DEG: 51.3977674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080600',
        LOCATION_NAME: 'Kingston St Mary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056300',
        LOCATION_NAME: 'Kingston St. Mary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1114742,
        LOCATION_LATITUDE_DEG: 51.0609413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056400',
        LOCATION_NAME: 'Kingston Stert',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9491846,
        LOCATION_LATITUDE_DEG: 51.7039728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083600',
        LOCATION_NAME: 'Kingston Upon Hull',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2901033,
        LOCATION_LATITUDE_DEG: 53.7602811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056600',
        LOCATION_NAME: 'Kingston upon Thames',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2991549,
        LOCATION_LATITUDE_DEG: 51.4121347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082600',
        LOCATION_NAME: 'Kingston Vale',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2575741,
        LOCATION_LATITUDE_DEG: 51.4349071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056500',
        LOCATION_NAME: 'Kingston Warren',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.539745,
        LOCATION_LATITUDE_DEG: 51.562067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056800',
        LOCATION_NAME: 'Kingstone',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8850855,
        LOCATION_LATITUDE_DEG: 50.9180253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057000',
        LOCATION_NAME: 'Kingstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8403702,
        LOCATION_LATITUDE_DEG: 52.0154292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056900',
        LOCATION_NAME: 'Kingstone',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9110313,
        LOCATION_LATITUDE_DEG: 52.8631938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057100',
        LOCATION_NAME: 'Kingstone Winslow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6236504,
        LOCATION_LATITUDE_DEG: 51.5662688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI056700',
        LOCATION_NAME: 'Kingston-on-Soar',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2577904,
        LOCATION_LATITUDE_DEG: 52.8432321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057200',
        LOCATION_NAME: 'Kingstown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9445104,
        LOCATION_LATITUDE_DEG: 54.9262064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990267',
        LOCATION_NAME: 'Kingsway',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3176426,
        LOCATION_LATITUDE_DEG: 53.7778084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081900',
        LOCATION_NAME: 'Kingsway',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2219871,
        LOCATION_LATITUDE_DEG: 53.4062334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082900',
        LOCATION_NAME: 'Kingsway',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2092883,
        LOCATION_LATITUDE_DEG: 53.4304024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057300',
        LOCATION_NAME: 'Kingsway',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5142883,
        LOCATION_LATITUDE_DEG: 52.9230004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082800',
        LOCATION_NAME: 'Kingsway',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1191694,
        LOCATION_LATITUDE_DEG: 51.5160306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057400',
        LOCATION_NAME: 'Kingswear',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.567773,
        LOCATION_LATITUDE_DEG: 50.3485713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057500',
        LOCATION_NAME: 'Kingswells',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.215779,
        LOCATION_LATITUDE_DEG: 57.1473238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057600',
        LOCATION_NAME: 'Kingswinford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1545515,
        LOCATION_LATITUDE_DEG: 52.4933654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058500',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1234584,
        LOCATION_LATITUDE_DEG: 52.6138858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058100',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0324949,
        LOCATION_LATITUDE_DEG: 52.1793449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058200',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6996057,
        LOCATION_LATITUDE_DEG: 53.2576482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082000',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5048783,
        LOCATION_LATITUDE_DEG: 51.4576417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058000',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3664825,
        LOCATION_LATITUDE_DEG: 51.6239863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057700',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7304409,
        LOCATION_LATITUDE_DEG: 52.3377476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057800',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9964644,
        LOCATION_LATITUDE_DEG: 51.8648913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI057900',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3379516,
        LOCATION_LATITUDE_DEG: 53.8018685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058300',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.209329,
        LOCATION_LATITUDE_DEG: 51.2938245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058400',
        LOCATION_NAME: 'Kingswood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6371462,
        LOCATION_LATITUDE_DEG: 51.2246073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058600',
        LOCATION_NAME: 'Kingthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3062301,
        LOCATION_LATITUDE_DEG: 53.2611187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058700',
        LOCATION_NAME: 'Kington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0349229,
        LOCATION_LATITUDE_DEG: 52.2045456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058800',
        LOCATION_NAME: 'Kington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5481921,
        LOCATION_LATITUDE_DEG: 51.6112827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI058900',
        LOCATION_NAME: 'Kington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0145017,
        LOCATION_LATITUDE_DEG: 52.2006308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059000',
        LOCATION_NAME: 'Kington Langley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1061087,
        LOCATION_LATITUDE_DEG: 51.4912696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059100',
        LOCATION_NAME: 'Kington Magna',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3331356,
        LOCATION_LATITUDE_DEG: 51.0054242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080300',
        LOCATION_NAME: 'Kington St Michael',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059200',
        LOCATION_NAME: 'Kington St. Michael',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1416061,
        LOCATION_LATITUDE_DEG: 51.4968704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059300',
        LOCATION_NAME: 'Kingussie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0523031,
        LOCATION_LATITUDE_DEG: 57.0798383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059400',
        LOCATION_NAME: 'Kingweston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6744707,
        LOCATION_LATITUDE_DEG: 51.0752337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059500',
        LOCATION_NAME: 'Kingwood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9989956,
        LOCATION_LATITUDE_DEG: 51.5361555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059600',
        LOCATION_NAME: 'Kinharrachie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1251561,
        LOCATION_LATITUDE_DEG: 57.3730424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059700',
        LOCATION_NAME: 'Kininmonth',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9669616,
        LOCATION_LATITUDE_DEG: 57.5706591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059800',
        LOCATION_NAME: 'Kinkell',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3268122,
        LOCATION_LATITUDE_DEG: 57.6142902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI059900',
        LOCATION_NAME: 'Kinlet',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4143745,
        LOCATION_LATITUDE_DEG: 52.4188609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060000',
        LOCATION_NAME: 'Kinley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4888025,
        LOCATION_LATITUDE_DEG: 52.728288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060100',
        LOCATION_NAME: 'Kinloch',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5497567,
        LOCATION_LATITUDE_DEG: 58.1055594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060200',
        LOCATION_NAME: 'Kinloch',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3852039,
        LOCATION_LATITUDE_DEG: 56.5872779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060300',
        LOCATION_NAME: 'Kinloch Laggan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4014514,
        LOCATION_LATITUDE_DEG: 56.9743292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060400',
        LOCATION_NAME: 'Kinloch Rannoch',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1788126,
        LOCATION_LATITUDE_DEG: 56.6970994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060500',
        LOCATION_NAME: 'Kinlochard',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4944095,
        LOCATION_LATITUDE_DEG: 56.1890487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060600',
        LOCATION_NAME: 'Kinlochbervie',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0497938,
        LOCATION_LATITUDE_DEG: 58.4593836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060700',
        LOCATION_NAME: 'Kinlocheil',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.31577,
        LOCATION_LATITUDE_DEG: 56.8603246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060800',
        LOCATION_NAME: 'Kinlochewe',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3021153,
        LOCATION_LATITUDE_DEG: 57.6047024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI060900',
        LOCATION_NAME: 'Kinlochleven',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9640294,
        LOCATION_LATITUDE_DEG: 56.7131091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061000',
        LOCATION_NAME: 'Kinlochmoidart',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7563696,
        LOCATION_LATITUDE_DEG: 56.790527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061100',
        LOCATION_NAME: 'Kinlochroag',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8128854,
        LOCATION_LATITUDE_DEG: 58.1157667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061200',
        LOCATION_NAME: 'Kinloss',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5703698,
        LOCATION_LATITUDE_DEG: 57.6364825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061500',
        LOCATION_NAME: 'Kinmel',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.526047,
        LOCATION_LATITUDE_DEG: 53.2604527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061600',
        LOCATION_NAME: 'Kinmel Bay',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5184187,
        LOCATION_LATITUDE_DEG: 53.3100618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990919',
        LOCATION_NAME: 'Kinmount',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061700',
        LOCATION_NAME: 'Kinmuck',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3010105,
        LOCATION_LATITUDE_DEG: 57.2686306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061900',
        LOCATION_NAME: 'Kinnaird',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'PH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2278929,
        LOCATION_LATITUDE_DEG: 56.4445646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990251',
        LOCATION_NAME: 'Kinnaird',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6099418,
        LOCATION_LATITUDE_DEG: 56.7165629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062000',
        LOCATION_NAME: 'Kinneff',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2358013,
        LOCATION_LATITUDE_DEG: 56.8645962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062400',
        LOCATION_NAME: 'Kinnell',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3073561,
        LOCATION_LATITUDE_DEG: 56.4669802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062300',
        LOCATION_NAME: 'Kinnell',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6417855,
        LOCATION_LATITUDE_DEG: 56.6415761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062500',
        LOCATION_NAME: 'Kinnerley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9816559,
        LOCATION_LATITUDE_DEG: 52.7816056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062600',
        LOCATION_NAME: 'Kinnermit',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4704224,
        LOCATION_LATITUDE_DEG: 57.5310591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062700',
        LOCATION_NAME: 'Kinnersley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9577302,
        LOCATION_LATITUDE_DEG: 52.1402407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062800',
        LOCATION_NAME: 'Kinnerton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1083381,
        LOCATION_LATITUDE_DEG: 52.2611567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062900',
        LOCATION_NAME: 'Kinnesswood',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3279381,
        LOCATION_LATITUDE_DEG: 56.2105403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063000',
        LOCATION_NAME: 'Kinnettles',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9330974,
        LOCATION_LATITUDE_DEG: 56.6091744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084500',
        LOCATION_NAME: 'Kinning Park',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2820876,
        LOCATION_LATITUDE_DEG: 55.8493993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063100',
        LOCATION_NAME: 'Kinninvie',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9218551,
        LOCATION_LATITUDE_DEG: 54.5913605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063200',
        LOCATION_NAME: 'Kinniside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.461837,
        LOCATION_LATITUDE_DEG: 54.5204719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063400',
        LOCATION_NAME: 'Kinnoir',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7454497,
        LOCATION_LATITUDE_DEG: 57.4783559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063500',
        LOCATION_NAME: 'Kinnordy',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0321157,
        LOCATION_LATITUDE_DEG: 56.6844806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063600',
        LOCATION_NAME: 'Kinoulton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9866907,
        LOCATION_LATITUDE_DEG: 52.8719853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063700',
        LOCATION_NAME: 'Kinross',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4220297,
        LOCATION_LATITUDE_DEG: 56.2049381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063800',
        LOCATION_NAME: 'Kinrossie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3179265,
        LOCATION_LATITUDE_DEG: 56.4766647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064400',
        LOCATION_NAME: 'Kinsbourne Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3883759,
        LOCATION_LATITUDE_DEG: 51.8260817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064600',
        LOCATION_NAME: 'Kinsham',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9344896,
        LOCATION_LATITUDE_DEG: 52.279556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064500',
        LOCATION_NAME: 'Kinsham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0969587,
        LOCATION_LATITUDE_DEG: 52.0177211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064700',
        LOCATION_NAME: 'Kinsley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3684129,
        LOCATION_LATITUDE_DEG: 53.6261654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064800',
        LOCATION_NAME: 'Kinson',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9023342,
        LOCATION_LATITUDE_DEG: 50.7654722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064900',
        LOCATION_NAME: 'Kintbury',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4473329,
        LOCATION_LATITUDE_DEG: 51.3990545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065000',
        LOCATION_NAME: 'Kintbury Holt',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4260418,
        LOCATION_LATITUDE_DEG: 51.3806518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065100',
        LOCATION_NAME: 'Kintessack',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6726786,
        LOCATION_LATITUDE_DEG: 57.6207854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065200',
        LOCATION_NAME: 'Kinton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9344552,
        LOCATION_LATITUDE_DEG: 52.7703975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065300',
        LOCATION_NAME: 'Kintore',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3433677,
        LOCATION_LATITUDE_DEG: 57.2370331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065400',
        LOCATION_NAME: 'Kintra',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2595528,
        LOCATION_LATITUDE_DEG: 55.6544126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065500',
        LOCATION_NAME: 'Kintulavig',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7135274,
        LOCATION_LATITUDE_DEG: 58.1701712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065750',
        LOCATION_NAME: 'Kinver',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.229326,
        LOCATION_LATITUDE_DEG: 52.4514268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065800',
        LOCATION_NAME: 'Kinwarton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.847328,
        LOCATION_LATITUDE_DEG: 52.2223371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065900',
        LOCATION_NAME: 'Kiplin',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5704491,
        LOCATION_LATITUDE_DEG: 54.3682406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066000',
        LOCATION_NAME: 'Kippax',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.369386,
        LOCATION_LATITUDE_DEG: 53.7666737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066100',
        LOCATION_NAME: 'Kippen',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1695447,
        LOCATION_LATITUDE_DEG: 56.1268423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066200',
        LOCATION_NAME: 'Kippford',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8129735,
        LOCATION_LATITUDE_DEG: 54.8794183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066300',
        LOCATION_NAME: 'Kirby Bedon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3700962,
        LOCATION_LATITUDE_DEG: 52.6001243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066400',
        LOCATION_NAME: 'Kirby Bellars',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9388684,
        LOCATION_LATITUDE_DEG: 52.7503701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066500',
        LOCATION_NAME: 'Kirby Cane',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4976647,
        LOCATION_LATITUDE_DEG: 52.492814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066600',
        LOCATION_NAME: 'Kirby Cross',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2186644,
        LOCATION_LATITUDE_DEG: 51.8414527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066700',
        LOCATION_NAME: 'Kirby Grindalythe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6162722,
        LOCATION_LATITUDE_DEG: 54.0961983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066800',
        LOCATION_NAME: 'Kirby Hill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.405437,
        LOCATION_LATITUDE_DEG: 54.1095077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI991126',
        LOCATION_NAME: 'Kirby Hill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7858239,
        LOCATION_LATITUDE_DEG: 54.454537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI066900',
        LOCATION_NAME: 'Kirby Knowle',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2812344,
        LOCATION_LATITUDE_DEG: 54.2783289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080900',
        LOCATION_NAME: 'Kirby le Soken',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067000',
        LOCATION_NAME: 'Kirby Misperton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8048027,
        LOCATION_LATITUDE_DEG: 54.2044159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067100',
        LOCATION_NAME: 'Kirby Muxloe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2360457,
        LOCATION_LATITUDE_DEG: 52.633464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067200',
        LOCATION_NAME: 'Kirby Sigston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3618402,
        LOCATION_LATITUDE_DEG: 54.348137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI991138',
        LOCATION_NAME: 'Kirby Underdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.77,
        LOCATION_LATITUDE_DEG: 54.0169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067300',
        LOCATION_NAME: 'Kirby Wiske',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4228936,
        LOCATION_LATITUDE_DEG: 54.2579222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067400',
        LOCATION_NAME: 'Kirby-le-Soken',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2272873,
        LOCATION_LATITUDE_DEG: 51.8519566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067500',
        LOCATION_NAME: 'Kirbyunderdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7691209,
        LOCATION_LATITUDE_DEG: 54.0169916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067600',
        LOCATION_NAME: 'Kircubbin',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5363446,
        LOCATION_LATITUDE_DEG: 54.4952915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067700',
        LOCATION_NAME: 'Kirdford',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5481113,
        LOCATION_LATITUDE_DEG: 51.0294083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067900',
        LOCATION_NAME: 'Kirk',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2280834,
        LOCATION_LATITUDE_DEG: 58.5117667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068000',
        LOCATION_NAME: 'Kirk Bramwith',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0641112,
        LOCATION_LATITUDE_DEG: 53.5985614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068100',
        LOCATION_NAME: 'Kirk Deighton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3923837,
        LOCATION_LATITUDE_DEG: 53.9474909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068200',
        LOCATION_NAME: 'Kirk Ella',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4555318,
        LOCATION_LATITUDE_DEG: 53.7546608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068300',
        LOCATION_NAME: 'Kirk Hammerton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.289846,
        LOCATION_LATITUDE_DEG: 53.9931947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068400',
        LOCATION_NAME: 'Kirk Ireton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6005356,
        LOCATION_LATITUDE_DEG: 53.0477114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068500',
        LOCATION_NAME: 'Kirk Langley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.570113,
        LOCATION_LATITUDE_DEG: 52.9459971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068600',
        LOCATION_NAME: 'Kirk Merrington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5954732,
        LOCATION_LATITUDE_DEG: 54.6767683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068700',
        LOCATION_NAME: 'Kirk Michael',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5837711,
        LOCATION_LATITUDE_DEG: 54.2839433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068800',
        LOCATION_NAME: 'Kirk Sandall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0710903,
        LOCATION_LATITUDE_DEG: 53.563556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI068900',
        LOCATION_NAME: 'Kirk Smeaton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2121625,
        LOCATION_LATITUDE_DEG: 53.6419594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069000',
        LOCATION_NAME: 'Kirk Yetholm',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2746572,
        LOCATION_LATITUDE_DEG: 55.546759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081000',
        LOCATION_NAME: 'Kirkandrews on Eden',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069100',
        LOCATION_NAME: 'Kirkandrews-on-Eden',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0077503,
        LOCATION_LATITUDE_DEG: 54.915713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069200',
        LOCATION_NAME: 'Kirkapol',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8091235,
        LOCATION_LATITUDE_DEG: 56.5250085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069300',
        LOCATION_NAME: 'Kirkbampton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0772595,
        LOCATION_LATITUDE_DEG: 54.8982106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069400',
        LOCATION_NAME: 'Kirkbean',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5943884,
        LOCATION_LATITUDE_DEG: 54.916515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069500',
        LOCATION_NAME: 'Kirkbride',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2023034,
        LOCATION_LATITUDE_DEG: 54.8960129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069600',
        LOCATION_NAME: 'Kirkbuddo',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8108183,
        LOCATION_LATITUDE_DEG: 56.5811707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069700',
        LOCATION_NAME: 'Kirkburn',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.500949,
        LOCATION_LATITUDE_DEG: 53.983085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069800',
        LOCATION_NAME: 'Kirkburton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7013345,
        LOCATION_LATITUDE_DEG: 53.6099657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI069900',
        LOCATION_NAME: 'Kirkby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.884148,
        LOCATION_LATITUDE_DEG: 53.4814683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070000',
        LOCATION_NAME: 'Kirkby Fleetham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5609621,
        LOCATION_LATITUDE_DEG: 54.344136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070100',
        LOCATION_NAME: 'Kirkby Green',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3801922,
        LOCATION_LATITUDE_DEG: 53.106801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081100',
        LOCATION_NAME: 'Kirkby in Ashfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081200',
        LOCATION_NAME: 'Kirkby in Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081300',
        LOCATION_NAME: 'Kirkby in Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081400',
        LOCATION_NAME: 'Kirkby la Thorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070200',
        LOCATION_NAME: 'Kirkby Lonsdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5964094,
        LOCATION_LATITUDE_DEG: 54.2029354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070300',
        LOCATION_NAME: 'Kirkby Malham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1610158,
        LOCATION_LATITUDE_DEG: 54.0454135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070400',
        LOCATION_NAME: 'Kirkby Mallory',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3276796,
        LOCATION_LATITUDE_DEG: 52.6008608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070500',
        LOCATION_NAME: 'Kirkby Malzeard',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6450631,
        LOCATION_LATITUDE_DEG: 54.1642225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081500',
        LOCATION_NAME: 'Kirkby on Bain',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070600',
        LOCATION_NAME: 'Kirkby Overblow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5039377,
        LOCATION_LATITUDE_DEG: 53.9375942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070700',
        LOCATION_NAME: 'Kirkby Stephen',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3469876,
        LOCATION_LATITUDE_DEG: 54.4712585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070800',
        LOCATION_NAME: 'Kirkby Thore',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5653147,
        LOCATION_LATITUDE_DEG: 54.6217752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI070900',
        LOCATION_NAME: 'Kirkby Underwood',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4037502,
        LOCATION_LATITUDE_DEG: 52.8324735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071000',
        LOCATION_NAME: 'Kirkby Wharfe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2307166,
        LOCATION_LATITUDE_DEG: 53.8623815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071100',
        LOCATION_NAME: 'Kirkby-in-Ashfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2667271,
        LOCATION_LATITUDE_DEG: 53.100298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071200',
        LOCATION_NAME: 'Kirkby-in-Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1735996,
        LOCATION_LATITUDE_DEG: 54.4465416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071300',
        LOCATION_NAME: 'Kirkby-in-Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1859511,
        LOCATION_LATITUDE_DEG: 54.2322473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071400',
        LOCATION_NAME: 'Kirkby-la-Thorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3648723,
        LOCATION_LATITUDE_DEG: 52.9965938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071600',
        LOCATION_NAME: 'Kirkbymoorside',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.929094,
        LOCATION_LATITUDE_DEG: 54.2690191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071500',
        LOCATION_NAME: 'Kirkby-on-Bain',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1467339,
        LOCATION_LATITUDE_DEG: 53.144413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071700',
        LOCATION_NAME: 'Kirkcaldy',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1576046,
        LOCATION_LATITUDE_DEG: 56.1101324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071800',
        LOCATION_NAME: 'Kirkcambeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7292221,
        LOCATION_LATITUDE_DEG: 55.0132137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI071900',
        LOCATION_NAME: 'Kirkcolm',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0796349,
        LOCATION_LATITUDE_DEG: 54.9741391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072000',
        LOCATION_NAME: 'Kirkconnel',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0038756,
        LOCATION_LATITUDE_DEG: 55.3875646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072100',
        LOCATION_NAME: 'Kirkcowan',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6095993,
        LOCATION_LATITUDE_DEG: 54.9155266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072200',
        LOCATION_NAME: 'Kirkcudbright',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0476012,
        LOCATION_LATITUDE_DEG: 54.8368099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083000',
        LOCATION_NAME: 'Kirkdale',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9875913,
        LOCATION_LATITUDE_DEG: 53.4410397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083100',
        LOCATION_NAME: 'Kirkdale',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9849289,
        LOCATION_LATITUDE_DEG: 53.4346429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI083500',
        LOCATION_NAME: 'Kirkella',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4560987,
        LOCATION_LATITUDE_DEG: 53.7540927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072300',
        LOCATION_NAME: 'Kirkfieldbank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8054297,
        LOCATION_LATITUDE_DEG: 55.6749928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072400',
        LOCATION_NAME: 'Kirkgunzeon',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7722156,
        LOCATION_LATITUDE_DEG: 54.9815212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072500',
        LOCATION_NAME: 'Kirkham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8751171,
        LOCATION_LATITUDE_DEG: 53.7816967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072600',
        LOCATION_NAME: 'Kirkham Abbey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8742447,
        LOCATION_LATITUDE_DEG: 54.0826002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072700',
        LOCATION_NAME: 'Kirkhamgate',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5513337,
        LOCATION_LATITUDE_DEG: 53.7013772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072800',
        LOCATION_NAME: 'Kirkharle',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9770975,
        LOCATION_LATITUDE_DEG: 55.1343138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI072900',
        LOCATION_NAME: 'Kirkhaugh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4737785,
        LOCATION_LATITUDE_DEG: 54.8377923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073000',
        LOCATION_NAME: 'Kirkheaton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.968864,
        LOCATION_LATITUDE_DEG: 55.0914167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073100',
        LOCATION_NAME: 'Kirkheaton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.724352,
        LOCATION_LATITUDE_DEG: 53.6593722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073200',
        LOCATION_NAME: 'KIRKHILL',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4119685,
        LOCATION_LATITUDE_DEG: 57.4762814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990069',
        LOCATION_NAME: 'Kirkhope',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9814161,
        LOCATION_LATITUDE_DEG: 55.5054549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073300',
        LOCATION_NAME: 'Kirkhouse',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6749211,
        LOCATION_LATITUDE_DEG: 54.930303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073400',
        LOCATION_NAME: 'Kirkhouse Green',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0609489,
        LOCATION_LATITUDE_DEG: 53.6157608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073500',
        LOCATION_NAME: 'Kirkibost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7883735,
        LOCATION_LATITUDE_DEG: 58.2147727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073600',
        LOCATION_NAME: 'Kirkinch',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1192218,
        LOCATION_LATITUDE_DEG: 56.5827763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073700',
        LOCATION_NAME: 'Kirkinner',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4556766,
        LOCATION_LATITUDE_DEG: 54.8323132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073800',
        LOCATION_NAME: 'Kirkintilloch',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1533736,
        LOCATION_LATITUDE_DEG: 55.9398227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074000',
        LOCATION_NAME: 'Kirkland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4345213,
        LOCATION_LATITUDE_DEG: 54.5487813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI073900',
        LOCATION_NAME: 'Kirkland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5493588,
        LOCATION_LATITUDE_DEG: 54.6859771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074100',
        LOCATION_NAME: 'Kirkleatham',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0801374,
        LOCATION_LATITUDE_DEG: 54.5880524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084400',
        LOCATION_NAME: 'Kirklee',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2974931,
        LOCATION_LATITUDE_DEG: 55.881112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074200',
        LOCATION_NAME: 'Kirklevington',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3387343,
        LOCATION_LATITUDE_DEG: 54.481947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990075',
        LOCATION_NAME: 'Kirkley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7588374,
        LOCATION_LATITUDE_DEG: 55.0893756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074400',
        LOCATION_NAME: 'Kirklington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.511457,
        LOCATION_LATITUDE_DEG: 54.2258203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074300',
        LOCATION_NAME: 'Kirklington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9843727,
        LOCATION_LATITUDE_DEG: 53.1114127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074500',
        LOCATION_NAME: 'Kirklinton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.886446,
        LOCATION_LATITUDE_DEG: 54.9953182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074600',
        LOCATION_NAME: 'Kirkliston',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4009952,
        LOCATION_LATITUDE_DEG: 55.9540194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074700',
        LOCATION_NAME: 'Kirkmahoe',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6068675,
        LOCATION_LATITUDE_DEG: 55.1170348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075000',
        LOCATION_NAME: 'Kirkmichael',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6174173,
        LOCATION_LATITUDE_DEG: 55.3457677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074800',
        LOCATION_NAME: 'Kirkmichael',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5537943,
        LOCATION_LATITUDE_DEG: 55.1867431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI074900',
        LOCATION_NAME: 'Kirkmichael',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5031586,
        LOCATION_LATITUDE_DEG: 56.7237897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075100',
        LOCATION_NAME: 'Kirkmuirhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9203,
        LOCATION_LATITUDE_DEG: 55.6652948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075200',
        LOCATION_NAME: 'Kirknewton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4170551,
        LOCATION_LATITUDE_DEG: 55.8876115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075300',
        LOCATION_NAME: 'Kirknewton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1337784,
        LOCATION_LATITUDE_DEG: 55.5655597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075500',
        LOCATION_NAME: 'Kirkoswald',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7765772,
        LOCATION_LATITUDE_DEG: 55.3296664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075400',
        LOCATION_NAME: 'Kirkoswald',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.692542,
        LOCATION_LATITUDE_DEG: 54.7647948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075600',
        LOCATION_NAME: 'Kirkpatrick',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1318775,
        LOCATION_LATITUDE_DEG: 55.0166237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075700',
        LOCATION_NAME: 'Kirkpatrick Durham',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8972783,
        LOCATION_LATITUDE_DEG: 55.0115269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075800',
        LOCATION_NAME: 'Kirkpatrick Fleming',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1343288,
        LOCATION_LATITUDE_DEG: 55.0242225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI075900',
        LOCATION_NAME: 'Kirksanton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3191519,
        LOCATION_LATITUDE_DEG: 54.2154466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084700',
        LOCATION_NAME: 'Kirkstall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6060586,
        LOCATION_LATITUDE_DEG: 53.8206217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076000',
        LOCATION_NAME: 'Kirkstead',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2466493,
        LOCATION_LATITUDE_DEG: 53.1409633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076100',
        LOCATION_NAME: 'Kirkthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4469787,
        LOCATION_LATITUDE_DEG: 53.6846703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076200',
        LOCATION_NAME: 'Kirkton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6022955,
        LOCATION_LATITUDE_DEG: 57.2842675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076400',
        LOCATION_NAME: 'Kirkton',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6796186,
        LOCATION_LATITUDE_DEG: 56.345461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076300',
        LOCATION_NAME: 'Kirkton',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5939443,
        LOCATION_LATITUDE_DEG: 57.3157426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076600',
        LOCATION_NAME: 'Kirkton of Bourtie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3254912,
        LOCATION_LATITUDE_DEG: 57.314235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076700',
        LOCATION_NAME: 'Kirkton of Logie Buchan',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.019199,
        LOCATION_LATITUDE_DEG: 57.3569414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076500',
        LOCATION_NAME: 'Kirkton Of Maryculter',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2359003,
        LOCATION_LATITUDE_DEG: 57.0833114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076800',
        LOCATION_NAME: 'Kirkton of Rayne',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5014293,
        LOCATION_LATITUDE_DEG: 57.361146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI076900',
        LOCATION_NAME: 'Kirkton of Skene',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3263631,
        LOCATION_LATITUDE_DEG: 57.159519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077000',
        LOCATION_NAME: 'Kirkton of Tough',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6366494,
        LOCATION_LATITUDE_DEG: 57.2051275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077100',
        LOCATION_NAME: 'Kirktown Of Mortlach',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1270076,
        LOCATION_LATITUDE_DEG: 57.4388586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077200',
        LOCATION_NAME: 'Kirkwall',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9545806,
        LOCATION_LATITUDE_DEG: 58.9807088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077300',
        LOCATION_NAME: 'Kirkwall Aerodrome',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9018024,
        LOCATION_LATITUDE_DEG: 58.9571051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077400',
        LOCATION_NAME: 'Kirkwhelpington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0086001,
        LOCATION_LATITUDE_DEG: 55.1523166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077500',
        LOCATION_NAME: 'Kirland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7223802,
        LOCATION_LATITUDE_DEG: 50.4562943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077600',
        LOCATION_NAME: 'Kirmington',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3317487,
        LOCATION_LATITUDE_DEG: 53.5871478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080700',
        LOCATION_NAME: 'Kirmond le Mire',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077700',
        LOCATION_NAME: 'Kirmond-le-Mire',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2080785,
        LOCATION_LATITUDE_DEG: 53.4157758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077800',
        LOCATION_NAME: 'Kirn',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9091737,
        LOCATION_LATITUDE_DEG: 55.9622327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI077900',
        LOCATION_NAME: 'Kirriemuir',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.003497,
        LOCATION_LATITUDE_DEG: 56.6740848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990697',
        LOCATION_NAME: 'Kirstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078000',
        LOCATION_NAME: 'Kirstead Green',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3828733,
        LOCATION_LATITUDE_DEG: 52.524022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078100',
        LOCATION_NAME: 'Kirtlebridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1911135,
        LOCATION_LATITUDE_DEG: 55.0430218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078200',
        LOCATION_NAME: 'Kirtling',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4741883,
        LOCATION_LATITUDE_DEG: 52.1858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078300',
        LOCATION_NAME: 'Kirtlington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2734187,
        LOCATION_LATITUDE_DEG: 51.8730963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078500',
        LOCATION_NAME: 'Kirton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9653627,
        LOCATION_LATITUDE_DEG: 53.2167151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078600',
        LOCATION_NAME: 'Kirton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0581372,
        LOCATION_LATITUDE_DEG: 52.9274814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078400',
        LOCATION_NAME: 'Kirton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3190314,
        LOCATION_LATITUDE_DEG: 52.0097724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078700',
        LOCATION_NAME: 'Kirton End',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0787148,
        LOCATION_LATITUDE_DEG: 52.9422837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078800',
        LOCATION_NAME: 'Kirton Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1454562,
        LOCATION_LATITUDE_DEG: 53.0097918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI078900',
        LOCATION_NAME: 'Kirton Holme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1211209,
        LOCATION_LATITUDE_DEG: 52.9611789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079000',
        LOCATION_NAME: 'Kirton Lindsey',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5862539,
        LOCATION_LATITUDE_DEG: 53.4748481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990207',
        LOCATION_NAME: 'Kirton of Durris',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3751119,
        LOCATION_LATITUDE_DEG: 57.055579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079200',
        LOCATION_NAME: 'Kishorn',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.582064,
        LOCATION_LATITUDE_DEG: 57.4001847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079400',
        LOCATION_NAME: 'Kislingbury',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9777439,
        LOCATION_LATITUDE_DEG: 52.2297251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079500',
        LOCATION_NAME: 'Kit Hill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.293427,
        LOCATION_LATITUDE_DEG: 50.517303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990960',
        LOCATION_NAME: 'Kites Hardwick',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079600',
        LOCATION_NAME: 'Kittisford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3133311,
        LOCATION_LATITUDE_DEG: 50.9921319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079700',
        LOCATION_NAME: 'Kittle',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0581151,
        LOCATION_LATITUDE_DEG: 51.5839959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084000',
        LOCATION_NAME: 'Kitts Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7761787,
        LOCATION_LATITUDE_DEG: 52.4802717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079800',
        LOCATION_NAME: 'Kittwhistle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8549826,
        LOCATION_LATITUDE_DEG: 50.8304174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079900',
        LOCATION_NAME: 'Kittybrewster',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1264411,
        LOCATION_LATITUDE_DEG: 57.1614159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080000',
        LOCATION_NAME: 'Kittywell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1538047,
        LOCATION_LATITUDE_DEG: 51.1204567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080100',
        LOCATION_NAME: 'Kiveton Park',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2634432,
        LOCATION_LATITUDE_DEG: 53.3411313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI080200',
        LOCATION_NAME: 'Kiveton Park Station',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2380394,
        LOCATION_LATITUDE_DEG: 53.3362341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KL000100',
        LOCATION_NAME: 'Klondyke',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5676226,
        LOCATION_LATITUDE_DEG: 55.082511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000100',
        LOCATION_NAME: 'Knaith',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7539574,
        LOCATION_LATITUDE_DEG: 53.352425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000200',
        LOCATION_NAME: 'Knaith Park',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7535487,
        LOCATION_LATITUDE_DEG: 53.3509822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000300',
        LOCATION_NAME: 'Knap',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4917288,
        LOCATION_LATITUDE_DEG: 51.6188885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000400',
        LOCATION_NAME: 'Knaphill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6138754,
        LOCATION_LATITUDE_DEG: 51.3185318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000500',
        LOCATION_NAME: 'Knapp',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1588268,
        LOCATION_LATITUDE_DEG: 56.4700654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990356',
        LOCATION_NAME: 'Knapp Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000600',
        LOCATION_NAME: 'Knapp Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8044836,
        LOCATION_LATITUDE_DEG: 50.9468213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000800',
        LOCATION_NAME: 'Knapthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8925302,
        LOCATION_LATITUDE_DEG: 53.1206091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000900',
        LOCATION_NAME: 'Knaptoft',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0784521,
        LOCATION_LATITUDE_DEG: 52.5005504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990997',
        LOCATION_NAME: 'Knapton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001150',
        LOCATION_NAME: 'Knapton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1433439,
        LOCATION_LATITUDE_DEG: 53.9601219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001000',
        LOCATION_NAME: 'Knapton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6572157,
        LOCATION_LATITUDE_DEG: 54.169008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001100',
        LOCATION_NAME: 'Knapton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4282428,
        LOCATION_LATITUDE_DEG: 52.854854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001200',
        LOCATION_NAME: 'Knapwell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0460294,
        LOCATION_LATITUDE_DEG: 52.2471121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001300',
        LOCATION_NAME: 'Knaresborough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4644671,
        LOCATION_LATITUDE_DEG: 54.0064053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001400',
        LOCATION_NAME: 'Knatts Valley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2383232,
        LOCATION_LATITUDE_DEG: 51.3264238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001500',
        LOCATION_NAME: 'Knayton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3367297,
        LOCATION_LATITUDE_DEG: 54.2860264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001600',
        LOCATION_NAME: 'Knebworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1824825,
        LOCATION_LATITUDE_DEG: 51.8662821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001700',
        LOCATION_NAME: 'Knedlington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8879855,
        LOCATION_LATITUDE_DEG: 53.7434696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001800',
        LOCATION_NAME: 'Kneep',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9499893,
        LOCATION_LATITUDE_DEG: 58.2227766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN001900',
        LOCATION_NAME: 'Kneesall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9464327,
        LOCATION_LATITUDE_DEG: 53.1696106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002000',
        LOCATION_NAME: 'Kneesworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0380779,
        LOCATION_LATITUDE_DEG: 52.0814859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002100',
        LOCATION_NAME: 'Kneeton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9406212,
        LOCATION_LATITUDE_DEG: 53.0069028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002200',
        LOCATION_NAME: 'Knelston',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2130337,
        LOCATION_LATITUDE_DEG: 51.5780012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002300',
        LOCATION_NAME: 'Knenhall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1160685,
        LOCATION_LATITUDE_DEG: 52.9369095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002400',
        LOCATION_NAME: 'Knettishall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8985769,
        LOCATION_LATITUDE_DEG: 52.3843103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002500',
        LOCATION_NAME: 'Knightcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4168123,
        LOCATION_LATITUDE_DEG: 52.1871239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002600',
        LOCATION_NAME: 'Knightley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.279214,
        LOCATION_LATITUDE_DEG: 52.8226935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990544',
        LOCATION_NAME: 'Knighton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003200',
        LOCATION_NAME: 'Knighton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0496847,
        LOCATION_LATITUDE_DEG: 52.3451623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003100',
        LOCATION_NAME: 'Knighton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5490599,
        LOCATION_LATITUDE_DEG: 50.9015174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002700',
        LOCATION_NAME: 'Knighton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4032012,
        LOCATION_LATITUDE_DEG: 52.9573106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002900',
        LOCATION_NAME: 'Knighton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3751333,
        LOCATION_LATITUDE_DEG: 52.8396999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN002800',
        LOCATION_NAME: 'Knighton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9415418,
        LOCATION_LATITUDE_DEG: 52.2099323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003000',
        LOCATION_NAME: 'Knighton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5920115,
        LOCATION_LATITUDE_DEG: 51.5835725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016300',
        LOCATION_NAME: 'Knighton on Teme',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003300',
        LOCATION_NAME: 'Knighton-on-Teme',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5421325,
        LOCATION_LATITUDE_DEG: 52.3272536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003400',
        LOCATION_NAME: 'Knights End',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0230338,
        LOCATION_LATITUDE_DEG: 52.532137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003500',
        LOCATION_NAME: 'Knights Enham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4729032,
        LOCATION_LATITUDE_DEG: 51.2392341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003600',
        LOCATION_NAME: 'Knights Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4179778,
        LOCATION_LATITUDE_DEG: 51.983714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003700',
        LOCATION_NAME: 'Knights Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.731078,
        LOCATION_LATITUDE_DEG: 50.5812064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003900',
        LOCATION_NAME: 'Knightsbridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1476837,
        LOCATION_LATITUDE_DEG: 51.9406089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016900',
        LOCATION_NAME: 'Knightsbridge',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1797277,
        LOCATION_LATITUDE_DEG: 51.4997097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016800',
        LOCATION_NAME: 'Knightsbridge',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1588706,
        LOCATION_LATITUDE_DEG: 51.5027296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004000',
        LOCATION_NAME: 'Knightshayes',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4782424,
        LOCATION_LATITUDE_DEG: 50.925225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN017300',
        LOCATION_NAME: 'Knightswood',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3419988,
        LOCATION_LATITUDE_DEG: 55.8970729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004100',
        LOCATION_NAME: 'Knightwick',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3930572,
        LOCATION_LATITUDE_DEG: 52.1992398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004200',
        LOCATION_NAME: 'Knill',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0378075,
        LOCATION_LATITUDE_DEG: 52.2391476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004300',
        LOCATION_NAME: 'Knipoch',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4657789,
        LOCATION_LATITUDE_DEG: 56.3548808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004400',
        LOCATION_NAME: 'Knipton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7745385,
        LOCATION_LATITUDE_DEG: 52.8722872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004500',
        LOCATION_NAME: 'Knitsley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8279395,
        LOCATION_LATITUDE_DEG: 54.8331843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004600',
        LOCATION_NAME: 'Kniveton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6909406,
        LOCATION_LATITUDE_DEG: 53.0481155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990714',
        LOCATION_NAME: 'Knobcrook',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004700',
        LOCATION_NAME: 'Knock',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7721668,
        LOCATION_LATITUDE_DEG: 58.2814777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016600',
        LOCATION_NAME: 'Knock',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3314754,
        LOCATION_LATITUDE_DEG: 53.2814276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016500',
        LOCATION_NAME: 'Knock',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8334826,
        LOCATION_LATITUDE_DEG: 54.5937521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004800',
        LOCATION_NAME: 'Knock',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7584867,
        LOCATION_LATITUDE_DEG: 57.5633645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005100',
        LOCATION_NAME: 'Knock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4978693,
        LOCATION_LATITUDE_DEG: 54.6377731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005500',
        LOCATION_NAME: 'Knockaird',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2488083,
        LOCATION_LATITUDE_DEG: 58.5003026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005700',
        LOCATION_NAME: 'Knockally',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4513652,
        LOCATION_LATITUDE_DEG: 58.2416434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006100',
        LOCATION_NAME: 'Knockando',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3503972,
        LOCATION_LATITUDE_DEG: 57.4590621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006500',
        LOCATION_NAME: 'Knockarevan',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.499064,
        LOCATION_LATITUDE_DEG: 54.1498738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007300',
        LOCATION_NAME: 'Knockbain',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2951244,
        LOCATION_LATITUDE_DEG: 57.5711863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007500',
        LOCATION_NAME: 'Knockbreck',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5721591,
        LOCATION_LATITUDE_DEG: 57.5521063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007900',
        LOCATION_NAME: 'Knockdolian',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9457222,
        LOCATION_LATITUDE_DEG: 55.1291497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008000',
        LOCATION_NAME: 'Knockdown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2299598,
        LOCATION_LATITUDE_DEG: 51.5932824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008300',
        LOCATION_NAME: 'Knockentiber',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5455391,
        LOCATION_LATITUDE_DEG: 55.6190987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008400',
        LOCATION_NAME: 'Knockerdown',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6522984,
        LOCATION_LATITUDE_DEG: 53.0632112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008500',
        LOCATION_NAME: 'Knockfarrel',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4940362,
        LOCATION_LATITUDE_DEG: 57.5880932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008700',
        LOCATION_NAME: 'Knockholt',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1069577,
        LOCATION_LATITUDE_DEG: 51.3102257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008800',
        LOCATION_NAME: 'Knockin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9919149,
        LOCATION_LATITUDE_DEG: 52.7939008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008900',
        LOCATION_NAME: 'Knockin Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9589844,
        LOCATION_LATITUDE_DEG: 52.7904043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009100',
        LOCATION_NAME: 'Knockintorran',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4679723,
        LOCATION_LATITUDE_DEG: 57.5851201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009200',
        LOCATION_NAME: 'Knockline',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4357727,
        LOCATION_LATITUDE_DEG: 57.5826162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009500',
        LOCATION_NAME: 'Knockloughrim',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6156525,
        LOCATION_LATITUDE_DEG: 54.8166287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009700',
        LOCATION_NAME: 'Knockmanoul',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6157795,
        LOCATION_LATITUDE_DEG: 54.3998964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009800',
        LOCATION_NAME: 'Knockmenagh',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3801462,
        LOCATION_LATITUDE_DEG: 54.4362933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010100',
        LOCATION_NAME: 'Knockmoyle',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3212257,
        LOCATION_LATITUDE_DEG: 54.6447878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011500',
        LOCATION_NAME: 'Knockvennie',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9558685,
        LOCATION_LATITUDE_DEG: 55.0262309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011900',
        LOCATION_NAME: 'Knodishall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5507107,
        LOCATION_LATITUDE_DEG: 52.2024826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012000',
        LOCATION_NAME: 'Knole',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7333761,
        LOCATION_LATITUDE_DEG: 51.022133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012100',
        LOCATION_NAME: 'Knolls Green Village',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2983792,
        LOCATION_LATITUDE_DEG: 53.3093197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012200',
        LOCATION_NAME: 'Knook',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0849414,
        LOCATION_LATITUDE_DEG: 51.1772415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990198',
        LOCATION_NAME: 'Knossington',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8174442,
        LOCATION_LATITUDE_DEG: 52.6734711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012300',
        LOCATION_NAME: 'Knossington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8122708,
        LOCATION_LATITUDE_DEG: 52.6689687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012400',
        LOCATION_NAME: 'Knott',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3692534,
        LOCATION_LATITUDE_DEG: 57.5006038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016400',
        LOCATION_NAME: 'Knott End on Sea',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012500',
        LOCATION_NAME: 'Knott End-on-Sea',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9800515,
        LOCATION_LATITUDE_DEG: 53.9277165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012600',
        LOCATION_NAME: 'Knotting',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5309241,
        LOCATION_LATITUDE_DEG: 52.2596197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012700',
        LOCATION_NAME: 'Knotting Green',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5272059,
        LOCATION_LATITUDE_DEG: 52.2524246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012800',
        LOCATION_NAME: 'Knottingley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2555346,
        LOCATION_LATITUDE_DEG: 53.7080665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN017000',
        LOCATION_NAME: 'Knotty Ash',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.889916,
        LOCATION_LATITUDE_DEG: 53.4178672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN012900',
        LOCATION_NAME: 'Knotty Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6529348,
        LOCATION_LATITUDE_DEG: 51.6218575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013000',
        LOCATION_NAME: 'Knowbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6237265,
        LOCATION_LATITUDE_DEG: 52.3678606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013100',
        LOCATION_NAME: 'Knowe',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6378856,
        LOCATION_LATITUDE_DEG: 55.0083361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013200',
        LOCATION_NAME: 'Knowesgate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0129675,
        LOCATION_LATITUDE_DEG: 55.1663179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013300',
        LOCATION_NAME: 'Knoweside',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7509681,
        LOCATION_LATITUDE_DEG: 55.3792705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013400',
        LOCATION_NAME: 'Knowl Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8179273,
        LOCATION_LATITUDE_DEG: 51.5048572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990989',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013900',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1541188,
        LOCATION_LATITUDE_DEG: 51.1250561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013800',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7275857,
        LOCATION_LATITUDE_DEG: 50.8000183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013600',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4215465,
        LOCATION_LATITUDE_DEG: 50.8537251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013700',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3421088,
        LOCATION_LATITUDE_DEG: 50.635703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN013500',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9447868,
        LOCATION_LATITUDE_DEG: 51.1544457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN017100',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5718363,
        LOCATION_LATITUDE_DEG: 51.4329281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014000',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7682711,
        LOCATION_LATITUDE_DEG: 51.3446523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014200',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7321876,
        LOCATION_LATITUDE_DEG: 52.3863491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014100',
        LOCATION_NAME: 'Knowle',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2011325,
        LOCATION_LATITUDE_DEG: 50.8791021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014300',
        LOCATION_NAME: 'Knowle Fields',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9385587,
        LOCATION_LATITUDE_DEG: 52.2185356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014400',
        LOCATION_NAME: 'Knowle Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.55175,
        LOCATION_LATITUDE_DEG: 53.8375014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014500',
        LOCATION_NAME: 'Knowle Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5695611,
        LOCATION_LATITUDE_DEG: 51.393543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN017200',
        LOCATION_NAME: 'Knowle Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.569689,
        LOCATION_LATITUDE_DEG: 51.4314817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014600',
        LOCATION_NAME: 'Knowle Park',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9149352,
        LOCATION_LATITUDE_DEG: 53.8607897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016200',
        LOCATION_NAME: 'Knowle St Giles',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014700',
        LOCATION_NAME: 'Knowle St. Giles',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9304939,
        LOCATION_LATITUDE_DEG: 50.8984169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014800',
        LOCATION_NAME: 'Knowlegate',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5892269,
        LOCATION_LATITUDE_DEG: 52.3571581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN014900',
        LOCATION_NAME: 'Knowlhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7788494,
        LOCATION_LATITUDE_DEG: 52.0284002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015000',
        LOCATION_NAME: 'Knowlton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9645523,
        LOCATION_LATITUDE_DEG: 50.8897086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015100',
        LOCATION_NAME: 'Knowlton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2678585,
        LOCATION_LATITUDE_DEG: 51.2340957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015200',
        LOCATION_NAME: 'Knowsley',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8517481,
        LOCATION_LATITUDE_DEG: 53.4567659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015300',
        LOCATION_NAME: 'Knowsley Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8301274,
        LOCATION_LATITUDE_DEG: 53.4471642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015400',
        LOCATION_NAME: 'Knowstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6709537,
        LOCATION_LATITUDE_DEG: 50.994237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015500',
        LOCATION_NAME: 'Knoydart',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5992735,
        LOCATION_LATITUDE_DEG: 57.0440507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015600',
        LOCATION_NAME: 'Knucklas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0993219,
        LOCATION_LATITUDE_DEG: 52.3610666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015700',
        LOCATION_NAME: 'Knuston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6225392,
        LOCATION_LATITUDE_DEG: 52.2866211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015800',
        LOCATION_NAME: 'Knutsford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3713735,
        LOCATION_LATITUDE_DEG: 53.3008442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016000',
        LOCATION_NAME: 'Knutton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2529396,
        LOCATION_LATITUDE_DEG: 53.0184186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016100',
        LOCATION_NAME: 'Knypersley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1792102,
        LOCATION_LATITUDE_DEG: 53.1068267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000100',
        LOCATION_NAME: 'Kyle',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7143095,
        LOCATION_LATITUDE_DEG: 57.2844752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000300',
        LOCATION_NAME: 'Kyleakin',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7317704,
        LOCATION_LATITUDE_DEG: 57.2727717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000600',
        LOCATION_NAME: 'Kylerhea',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6648667,
        LOCATION_LATITUDE_DEG: 57.2232656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000700',
        LOCATION_NAME: 'Kyles Flodda',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2775605,
        LOCATION_LATITUDE_DEG: 57.4735062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000800',
        LOCATION_NAME: 'Kyles Harris',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6975688,
        LOCATION_LATITUDE_DEG: 57.8987448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000900',
        LOCATION_NAME: 'Kyles Morar',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6143397,
        LOCATION_LATITUDE_DEG: 56.9772405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001000',
        LOCATION_NAME: 'Kyles Paible',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4314031,
        LOCATION_LATITUDE_DEG: 57.5787183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001200',
        LOCATION_NAME: 'Kylesku',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0164476,
        LOCATION_LATITUDE_DEG: 58.2567662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001300',
        LOCATION_NAME: 'Kylestrome',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0393173,
        LOCATION_LATITUDE_DEG: 58.2641605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001400',
        LOCATION_NAME: 'Kynance Cove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.229027,
        LOCATION_LATITUDE_DEG: 49.9782602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001500',
        LOCATION_NAME: 'Kynaston',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.519997,
        LOCATION_LATITUDE_DEG: 52.0195268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001600',
        LOCATION_NAME: 'Kynnersley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4847288,
        LOCATION_LATITUDE_DEG: 52.7468885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001700',
        LOCATION_NAME: 'Kyre',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5470329,
        LOCATION_LATITUDE_DEG: 52.2676451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001800',
        LOCATION_NAME: 'Kyrewood',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5787949,
        LOCATION_LATITUDE_DEG: 52.3061478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001900',
        LOCATION_NAME: 'Kytes Hardwick',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3109659,
        LOCATION_LATITUDE_DEG: 52.3103036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000400',
        LOCATION_NAME: 'Laceby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.166935,
        LOCATION_LATITUDE_DEG: 53.5405373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000500',
        LOCATION_NAME: 'Lacey Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8081091,
        LOCATION_LATITUDE_DEG: 51.6936696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000600',
        LOCATION_NAME: 'Lach Dennis',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4392543,
        LOCATION_LATITUDE_DEG: 53.244238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000700',
        LOCATION_NAME: 'Lache',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9149805,
        LOCATION_LATITUDE_DEG: 53.1732371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000800',
        LOCATION_NAME: 'Lack',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5787743,
        LOCATION_LATITUDE_DEG: 54.5446845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001300',
        LOCATION_NAME: 'Lackenby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1316985,
        LOCATION_LATITUDE_DEG: 54.566556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001400',
        LOCATION_NAME: 'Lackford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6252603,
        LOCATION_LATITUDE_DEG: 52.3033101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001500',
        LOCATION_NAME: 'Lacock',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1217782,
        LOCATION_LATITUDE_DEG: 51.4142598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001600',
        LOCATION_NAME: 'Lacon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6830834,
        LOCATION_LATITUDE_DEG: 52.8878117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001700',
        LOCATION_NAME: 'Ladbroke',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3860988,
        LOCATION_LATITUDE_DEG: 52.2237256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001800',
        LOCATION_NAME: 'Ladderedge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0565033,
        LOCATION_LATITUDE_DEG: 53.0866216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001900',
        LOCATION_NAME: 'Laddingford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4199679,
        LOCATION_LATITUDE_DEG: 51.2074092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002000',
        LOCATION_NAME: 'Lade Bank',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0839911,
        LOCATION_LATITUDE_DEG: 53.0650941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002100',
        LOCATION_NAME: 'Ladmanlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9381198,
        LOCATION_LATITUDE_DEG: 53.2435298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002200',
        LOCATION_NAME: 'Ladock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9592784,
        LOCATION_LATITUDE_DEG: 50.3191856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002300',
        LOCATION_NAME: 'Lady Green',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0307552,
        LOCATION_LATITUDE_DEG: 53.5266725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002400',
        LOCATION_NAME: 'Lady Hall',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2389355,
        LOCATION_LATITUDE_DEG: 54.2625466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002500',
        LOCATION_NAME: 'Lady Halton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7666263,
        LOCATION_LATITUDE_DEG: 52.3707604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002600',
        LOCATION_NAME: 'Ladybank',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1219073,
        LOCATION_LATITUDE_DEG: 56.275447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002700',
        LOCATION_NAME: 'Ladykirk',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1780322,
        LOCATION_LATITUDE_DEG: 55.7218827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034300',
        LOCATION_NAME: 'Ladypark',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6194078,
        LOCATION_LATITUDE_DEG: 54.9215149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003000',
        LOCATION_NAME: 'Ladyswood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1861982,
        LOCATION_LATITUDE_DEG: 51.5610773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA035000',
        LOCATION_NAME: 'Ladywell',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.019995,
        LOCATION_LATITUDE_DEG: 51.4565234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003100',
        LOCATION_NAME: 'Ladywood',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1880747,
        LOCATION_LATITUDE_DEG: 52.2470393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003200',
        LOCATION_NAME: 'Ladywood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9194976,
        LOCATION_LATITUDE_DEG: 52.4775609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003400',
        LOCATION_NAME: 'Laga',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8677119,
        LOCATION_LATITUDE_DEG: 56.6814094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003500',
        LOCATION_NAME: 'Lagavulin',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1270621,
        LOCATION_LATITUDE_DEG: 55.6354168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003600',
        LOCATION_NAME: 'Lagg',
        COUNTY_NAME: 'Isle of Jura',
        POSTCODE: 'PA60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8531573,
        LOCATION_LATITUDE_DEG: 55.9392358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003700',
        LOCATION_NAME: 'Laggan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8109866,
        LOCATION_LATITUDE_DEG: 57.0362377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003800',
        LOCATION_NAME: 'Laggandoin',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6867705,
        LOCATION_LATITUDE_DEG: 57.86764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004100',
        LOCATION_NAME: 'Lagness',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7183964,
        LOCATION_LATITUDE_DEG: 50.7981892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004400',
        LOCATION_NAME: 'Laid',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7307227,
        LOCATION_LATITUDE_DEG: 58.4926849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004500',
        LOCATION_NAME: 'Laide',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5406252,
        LOCATION_LATITUDE_DEG: 57.8650271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004600',
        LOCATION_NAME: 'Laindon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4239003,
        LOCATION_LATITUDE_DEG: 51.5749399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004700',
        LOCATION_NAME: 'Laira',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1017223,
        LOCATION_LATITUDE_DEG: 50.3838801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004800',
        LOCATION_NAME: 'Lairg',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4000613,
        LOCATION_LATITUDE_DEG: 58.0267321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004900',
        LOCATION_NAME: 'Laisterdyke',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7107894,
        LOCATION_LATITUDE_DEG: 53.7900875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005000',
        LOCATION_NAME: 'Laithes',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8284661,
        LOCATION_LATITUDE_DEG: 54.6890822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005100',
        LOCATION_NAME: 'Laity Moor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1386202,
        LOCATION_LATITUDE_DEG: 50.1866777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005200',
        LOCATION_NAME: 'Lake',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8096697,
        LOCATION_LATITUDE_DEG: 51.1500305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005250',
        LOCATION_NAME: 'Lake',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1645231,
        LOCATION_LATITUDE_DEG: 50.645186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005300',
        LOCATION_NAME: 'Lakeland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7822866,
        LOCATION_LATITUDE_DEG: 50.6391009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005400',
        LOCATION_NAME: 'Lakenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3016951,
        LOCATION_LATITUDE_DEG: 52.6183332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005500',
        LOCATION_NAME: 'Lakenheath',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5201503,
        LOCATION_LATITUDE_DEG: 52.4167233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005600',
        LOCATION_NAME: 'Lakesend',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2359991,
        LOCATION_LATITUDE_DEG: 52.5429352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005700',
        LOCATION_NAME: 'Lakeside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9564063,
        LOCATION_LATITUDE_DEG: 54.2797434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005800',
        LOCATION_NAME: 'Laleham',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4878107,
        LOCATION_LATITUDE_DEG: 51.4091362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005900',
        LOCATION_NAME: 'Laleston',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6201478,
        LOCATION_LATITUDE_DEG: 51.5055862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006000',
        LOCATION_NAME: 'Lamanva',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1314228,
        LOCATION_LATITUDE_DEG: 50.1400698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006100',
        LOCATION_NAME: 'Lamarsh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7539249,
        LOCATION_LATITUDE_DEG: 51.9868806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006200',
        LOCATION_NAME: 'Lamas',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.32972,
        LOCATION_LATITUDE_DEG: 52.7583423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006300',
        LOCATION_NAME: 'Lambden',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4067545,
        LOCATION_LATITUDE_DEG: 55.6800734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006400',
        LOCATION_NAME: 'Lambeg',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0367023,
        LOCATION_LATITUDE_DEG: 54.5298002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006500',
        LOCATION_NAME: 'Lamberhurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3949107,
        LOCATION_LATITUDE_DEG: 51.1014006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033800',
        LOCATION_NAME: 'Lamberts End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9975826,
        LOCATION_LATITUDE_DEG: 52.5213114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006600',
        LOCATION_NAME: "Lambert's End",
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0088132,
        LOCATION_LATITUDE_DEG: 52.5156648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034800',
        LOCATION_NAME: 'Lambeth',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034900',
        LOCATION_NAME: 'Lambeth',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0938988,
        LOCATION_LATITUDE_DEG: 51.4981121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006700',
        LOCATION_NAME: 'Lambhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2661803,
        LOCATION_LATITUDE_DEG: 55.8956158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006800',
        LOCATION_NAME: 'Lambholm',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1768185,
        LOCATION_LATITUDE_DEG: 59.0699246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA006900',
        LOCATION_NAME: 'Lambley',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5122299,
        LOCATION_LATITUDE_DEG: 54.9193058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007000',
        LOCATION_NAME: 'Lambley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0600025,
        LOCATION_LATITUDE_DEG: 53.0004982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007100',
        LOCATION_NAME: 'Lambourn',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5294989,
        LOCATION_LATITUDE_DEG: 51.5077655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007200',
        LOCATION_NAME: 'Lambourn Woodlands',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5411926,
        LOCATION_LATITUDE_DEG: 51.4812567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007300',
        LOCATION_NAME: 'Lambourne End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1357336,
        LOCATION_LATITUDE_DEG: 51.6284499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007400',
        LOCATION_NAME: 'Lambrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6357536,
        LOCATION_LATITUDE_DEG: 54.3497496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007500',
        LOCATION_NAME: 'Lambrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8319792,
        LOCATION_LATITUDE_DEG: 50.9662256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007600',
        LOCATION_NAME: 'Lambs Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2638308,
        LOCATION_LATITUDE_DEG: 51.1132126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007700',
        LOCATION_NAME: 'Lambston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0355992,
        LOCATION_LATITUDE_DEG: 51.8116302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007800',
        LOCATION_NAME: 'Lambton Park',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5282349,
        LOCATION_LATITUDE_DEG: 54.8680882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA007900',
        LOCATION_NAME: 'Lamellion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4778713,
        LOCATION_LATITUDE_DEG: 50.4452984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008000',
        LOCATION_NAME: 'Lamerton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1848083,
        LOCATION_LATITUDE_DEG: 50.5687047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008100',
        LOCATION_NAME: 'Lamesley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6066538,
        LOCATION_LATITUDE_DEG: 54.9156954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008200',
        LOCATION_NAME: 'Lamington',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6195525,
        LOCATION_LATITUDE_DEG: 55.56028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008300',
        LOCATION_NAME: 'Lamlash',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.127848,
        LOCATION_LATITUDE_DEG: 55.5326939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008400',
        LOCATION_NAME: 'Lamonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9168959,
        LOCATION_LATITUDE_DEG: 54.713585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008500',
        LOCATION_NAME: 'Lamorna',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.568953,
        LOCATION_LATITUDE_DEG: 50.0655652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008600',
        LOCATION_NAME: 'Lampeter',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0808986,
        LOCATION_LATITUDE_DEG: 52.1131508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008700',
        LOCATION_NAME: 'Lampeter Velfrey',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6743656,
        LOCATION_LATITUDE_DEG: 51.7976237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008800',
        LOCATION_NAME: 'Lamphey',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8705989,
        LOCATION_LATITUDE_DEG: 51.6681189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA008900',
        LOCATION_NAME: 'Lamplugh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4092479,
        LOCATION_LATITUDE_DEG: 54.5745795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009000',
        LOCATION_NAME: 'Lamport',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8897481,
        LOCATION_LATITUDE_DEG: 52.3629336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009100',
        LOCATION_NAME: 'Lamyatt',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4928112,
        LOCATION_LATITUDE_DEG: 51.1209358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009200',
        LOCATION_NAME: 'Lanark',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7805518,
        LOCATION_LATITUDE_DEG: 55.6738912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009300',
        LOCATION_NAME: 'Lancaster',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7970225,
        LOCATION_LATITUDE_DEG: 54.0494243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009400',
        LOCATION_NAME: 'Lancercombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2833368,
        LOCATION_LATITUDE_DEG: 50.7039028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009500',
        LOCATION_NAME: 'Lanchester',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7392266,
        LOCATION_LATITUDE_DEG: 54.8205874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009600',
        LOCATION_NAME: 'Lancing',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3198148,
        LOCATION_LATITUDE_DEG: 50.830581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009700',
        LOCATION_NAME: 'Lancych',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5312071,
        LOCATION_LATITUDE_DEG: 52.0171445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009800',
        LOCATION_NAME: 'Landbeach',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1639718,
        LOCATION_LATITUDE_DEG: 52.2641139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA009900',
        LOCATION_NAME: 'Landcross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1935314,
        LOCATION_LATITUDE_DEG: 50.9917433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010000',
        LOCATION_NAME: 'Landford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6336376,
        LOCATION_LATITUDE_DEG: 50.9674089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010100',
        LOCATION_NAME: 'Landford Wood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6261627,
        LOCATION_LATITUDE_DEG: 50.986613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010200',
        LOCATION_NAME: 'Landgate',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7384466,
        LOCATION_LATITUDE_DEG: 50.9525821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010400',
        LOCATION_NAME: 'Landimore',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2167257,
        LOCATION_LATITUDE_DEG: 51.6146985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010500',
        LOCATION_NAME: 'Landkey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9995466,
        LOCATION_LATITUDE_DEG: 51.0606509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010600',
        LOCATION_NAME: 'Landmoth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3463147,
        LOCATION_LATITUDE_DEG: 54.32783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010700',
        LOCATION_NAME: 'Landore',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9432237,
        LOCATION_LATITUDE_DEG: 51.6427039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010800',
        LOCATION_NAME: 'Landport',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0975299,
        LOCATION_LATITUDE_DEG: 50.8089874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA010900',
        LOCATION_NAME: 'Landrake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2884005,
        LOCATION_LATITUDE_DEG: 50.4217892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011000',
        LOCATION_NAME: 'Lands End',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8790833,
        LOCATION_LATITUDE_DEG: 51.464351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011100',
        LOCATION_NAME: 'Landscove',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7266187,
        LOCATION_LATITUDE_DEG: 50.4842943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011200',
        LOCATION_NAME: 'Landshipping',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8818934,
        LOCATION_LATITUDE_DEG: 51.7682242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011300',
        LOCATION_NAME: 'Landside',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5199759,
        LOCATION_LATITUDE_DEG: 53.4788611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011400',
        LOCATION_NAME: 'Landulph',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2043033,
        LOCATION_LATITUDE_DEG: 50.4315904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011500',
        LOCATION_NAME: 'Landwade',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3778395,
        LOCATION_LATITUDE_DEG: 52.2839116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011600',
        LOCATION_NAME: 'Lane',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0449074,
        LOCATION_LATITUDE_DEG: 50.4010912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011800',
        LOCATION_NAME: 'Lane End',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2117327,
        LOCATION_LATITUDE_DEG: 50.732593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011700',
        LOCATION_NAME: 'Lane End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8323904,
        LOCATION_LATITUDE_DEG: 51.6182668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA011900',
        LOCATION_NAME: 'Lane Head',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.709672,
        LOCATION_LATITUDE_DEG: 53.5756649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012000',
        LOCATION_NAME: 'Laneast',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5055564,
        LOCATION_LATITUDE_DEG: 50.6296106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012100',
        LOCATION_NAME: 'Laneham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7904318,
        LOCATION_LATITUDE_DEG: 53.2773266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012200',
        LOCATION_NAME: 'Lanehead',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.251085,
        LOCATION_LATITUDE_DEG: 54.7717875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012300',
        LOCATION_NAME: 'Lanercost',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6964157,
        LOCATION_LATITUDE_DEG: 54.9666082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012500',
        LOCATION_NAME: 'Lanescot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6985151,
        LOCATION_LATITUDE_DEG: 50.366989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012600',
        LOCATION_NAME: 'Lanesfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1035712,
        LOCATION_LATITUDE_DEG: 52.5567712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012700',
        LOCATION_NAME: 'Laneshawbridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1159832,
        LOCATION_LATITUDE_DEG: 53.8621841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012800',
        LOCATION_NAME: 'Langaller',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0427993,
        LOCATION_LATITUDE_DEG: 51.0349354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012900',
        LOCATION_NAME: 'Langar',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9232524,
        LOCATION_LATITUDE_DEG: 52.9027871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013000',
        LOCATION_NAME: 'Langass',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2857552,
        LOCATION_LATITUDE_DEG: 57.5650142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013100',
        LOCATION_NAME: 'Langbank',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5845347,
        LOCATION_LATITUDE_DEG: 55.9242294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013200',
        LOCATION_NAME: 'Langbar',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.85551,
        LOCATION_LATITUDE_DEG: 53.957399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013300',
        LOCATION_NAME: 'Langbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9391068,
        LOCATION_LATITUDE_DEG: 50.357777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013400',
        LOCATION_NAME: 'Langcliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2738269,
        LOCATION_LATITUDE_DEG: 54.0801215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013500',
        LOCATION_NAME: 'Langdale End',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5555073,
        LOCATION_LATITUDE_DEG: 54.3081172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013700',
        LOCATION_NAME: 'Langdon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4013378,
        LOCATION_LATITUDE_DEG: 50.6834126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013600',
        LOCATION_NAME: 'Langdon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4649462,
        LOCATION_LATITUDE_DEG: 50.5994957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA013900',
        LOCATION_NAME: 'Langenhoe',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9134646,
        LOCATION_LATITUDE_DEG: 51.8268559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014100',
        LOCATION_NAME: 'Langford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3830048,
        LOCATION_LATITUDE_DEG: 50.8179153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014000',
        LOCATION_NAME: 'Langford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7819614,
        LOCATION_LATITUDE_DEG: 51.349565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014500',
        LOCATION_NAME: 'Langford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6420113,
        LOCATION_LATITUDE_DEG: 51.7231884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014400',
        LOCATION_NAME: 'Langford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7693062,
        LOCATION_LATITUDE_DEG: 53.1197047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014300',
        LOCATION_NAME: 'Langford',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2700833,
        LOCATION_LATITUDE_DEG: 52.0539965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014200',
        LOCATION_NAME: 'Langford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.662933,
        LOCATION_LATITUDE_DEG: 51.7488551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014600',
        LOCATION_NAME: 'Langford Budville',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.267165,
        LOCATION_LATITUDE_DEG: 50.998137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015000',
        LOCATION_NAME: 'Langham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3252325,
        LOCATION_LATITUDE_DEG: 51.0310234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990131',
        LOCATION_NAME: 'Langham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7523916,
        LOCATION_LATITUDE_DEG: 52.6936549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014700',
        LOCATION_NAME: 'Langham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7504689,
        LOCATION_LATITUDE_DEG: 52.6920611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014800',
        LOCATION_NAME: 'Langham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8995545,
        LOCATION_LATITUDE_DEG: 52.2920064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA014900',
        LOCATION_NAME: 'Langham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9518441,
        LOCATION_LATITUDE_DEG: 51.9447728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015100',
        LOCATION_NAME: 'Langham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9869453,
        LOCATION_LATITUDE_DEG: 52.9310641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015200',
        LOCATION_NAME: 'Langho',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4487506,
        LOCATION_LATITUDE_DEG: 53.8003925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015300',
        LOCATION_NAME: 'Langholm',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9989512,
        LOCATION_LATITUDE_DEG: 55.1522324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015400',
        LOCATION_NAME: 'Langland',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0016794,
        LOCATION_LATITUDE_DEG: 51.5698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015500',
        LOCATION_NAME: 'Langland Cliff',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9997818,
        LOCATION_LATITUDE_DEG: 51.5679976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990635',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015700',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0903343,
        LOCATION_LATITUDE_DEG: 53.2408327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016100',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7174011,
        LOCATION_LATITUDE_DEG: 52.2648336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015800',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5617561,
        LOCATION_LATITUDE_DEG: 51.8352913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015900',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3673646,
        LOCATION_LATITUDE_DEG: 50.8082893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016000',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.54199,
        LOCATION_LATITUDE_DEG: 51.503748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016200',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.234608,
        LOCATION_LATITUDE_DEG: 51.886186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA015600',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5859034,
        LOCATION_LATITUDE_DEG: 51.2358078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016250',
        LOCATION_NAME: 'Langley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5019209,
        LOCATION_LATITUDE_DEG: 52.5529745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016300',
        LOCATION_NAME: 'Langley Burrell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1037248,
        LOCATION_LATITUDE_DEG: 51.4754628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016350',
        LOCATION_NAME: 'Langley Lower Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0942758,
        LOCATION_LATITUDE_DEG: 51.9892764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016400',
        LOCATION_NAME: 'Langley Marsh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3208555,
        LOCATION_LATITUDE_DEG: 51.053843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016500',
        LOCATION_NAME: 'Langley Mill',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3368077,
        LOCATION_LATITUDE_DEG: 53.0180073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016600',
        LOCATION_NAME: 'Langley Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6068334,
        LOCATION_LATITUDE_DEG: 54.7578749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034100',
        LOCATION_NAME: 'Langley on Tyne',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016700',
        LOCATION_NAME: 'Langley Park',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6690663,
        LOCATION_LATITUDE_DEG: 54.7969769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016750',
        LOCATION_NAME: 'Langley Upper Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1059365,
        LOCATION_LATITUDE_DEG: 51.9953277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016800',
        LOCATION_NAME: 'Langley Vale',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2767329,
        LOCATION_LATITUDE_DEG: 51.3111237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017000',
        LOCATION_NAME: 'Langleybury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4420304,
        LOCATION_LATITUDE_DEG: 51.6812639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017100',
        LOCATION_NAME: 'Langleydale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9384132,
        LOCATION_LATITUDE_DEG: 54.6135699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA016900',
        LOCATION_NAME: 'Langley-on-Tyne',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2665145,
        LOCATION_LATITUDE_DEG: 54.9478009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017200',
        LOCATION_NAME: 'Langloan',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0403509,
        LOCATION_LATITUDE_DEG: 55.8574123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017300',
        LOCATION_NAME: 'Langmere',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2126479,
        LOCATION_LATITUDE_DEG: 52.389613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990181',
        LOCATION_NAME: 'Langney',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3052361,
        LOCATION_LATITUDE_DEG: 50.8018945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017400',
        LOCATION_NAME: 'Langold',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1167823,
        LOCATION_LATITUDE_DEG: 53.3807347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017500',
        LOCATION_NAME: 'Langore',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4060513,
        LOCATION_LATITUDE_DEG: 50.6532169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017600',
        LOCATION_NAME: 'Langport',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8223094,
        LOCATION_LATITUDE_DEG: 51.0388353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017700',
        LOCATION_NAME: 'Langrick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1045469,
        LOCATION_LATITUDE_DEG: 53.0220854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017800',
        LOCATION_NAME: 'Langridge',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3710511,
        LOCATION_LATITUDE_DEG: 51.4239605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA017900',
        LOCATION_NAME: 'Langrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2953978,
        LOCATION_LATITUDE_DEG: 54.7989989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018000',
        LOCATION_NAME: 'Langrish',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.994642,
        LOCATION_LATITUDE_DEG: 51.0086067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018100',
        LOCATION_NAME: 'Langrove',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0718897,
        LOCATION_LATITUDE_DEG: 51.5887989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA035100',
        LOCATION_NAME: 'Langside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2829116,
        LOCATION_LATITUDE_DEG: 55.8261214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA035200',
        LOCATION_NAME: 'Langside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2640971,
        LOCATION_LATITUDE_DEG: 55.8263345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018300',
        LOCATION_NAME: 'Langstone',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8995741,
        LOCATION_LATITUDE_DEG: 51.6062834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018200',
        LOCATION_NAME: 'Langstone',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9811777,
        LOCATION_LATITUDE_DEG: 50.8388961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018400',
        LOCATION_NAME: 'Langthorne',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.613561,
        LOCATION_LATITUDE_DEG: 54.3179352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018500',
        LOCATION_NAME: 'Langthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3993467,
        LOCATION_LATITUDE_DEG: 54.1001112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018600',
        LOCATION_NAME: 'Langthwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9938198,
        LOCATION_LATITUDE_DEG: 54.4177472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018700',
        LOCATION_NAME: 'Langtoft',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4554123,
        LOCATION_LATITUDE_DEG: 54.0870941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018800',
        LOCATION_NAME: 'Langtoft',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3377337,
        LOCATION_LATITUDE_DEG: 52.6980602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019000',
        LOCATION_NAME: 'Langton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7315822,
        LOCATION_LATITUDE_DEG: 54.5693644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019100',
        LOCATION_NAME: 'Langton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7795956,
        LOCATION_LATITUDE_DEG: 54.0934981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA018900',
        LOCATION_NAME: 'Langton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1534932,
        LOCATION_LATITUDE_DEG: 53.201208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019200',
        LOCATION_NAME: 'Langton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.083661,
        LOCATION_LATITUDE_DEG: 53.2124015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034000',
        LOCATION_NAME: 'Langton by Wragby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019300',
        LOCATION_NAME: 'Langton Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.205586,
        LOCATION_LATITUDE_DEG: 51.1304015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019400',
        LOCATION_NAME: 'Langton Herring',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5448717,
        LOCATION_LATITUDE_DEG: 50.6408902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019500',
        LOCATION_NAME: 'Langton Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2650336,
        LOCATION_LATITUDE_DEG: 53.2631156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019600',
        LOCATION_NAME: 'Langton Long',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1392278,
        LOCATION_LATITUDE_DEG: 50.8504104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019700',
        LOCATION_NAME: 'Langton Matravers',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9994063,
        LOCATION_LATITUDE_DEG: 50.6072859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019800',
        LOCATION_NAME: 'Langton-by-Wragby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2765421,
        LOCATION_LATITUDE_DEG: 53.2771106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA019900',
        LOCATION_NAME: 'Langtree',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2054114,
        LOCATION_LATITUDE_DEG: 50.9188332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020000',
        LOCATION_NAME: 'Langwathby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6678752,
        LOCATION_LATITUDE_DEG: 54.6949809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020100',
        LOCATION_NAME: 'Langwell',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6819445,
        LOCATION_LATITUDE_DEG: 57.9669273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020200',
        LOCATION_NAME: 'Langwith',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2122295,
        LOCATION_LATITUDE_DEG: 53.2248238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020300',
        LOCATION_NAME: 'Langwith Junction',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.227225,
        LOCATION_LATITUDE_DEG: 53.2090184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020400',
        LOCATION_NAME: 'Langworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4060682,
        LOCATION_LATITUDE_DEG: 53.2743183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020500',
        LOCATION_NAME: 'Lanhainsworth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9242926,
        LOCATION_LATITUDE_DEG: 50.4387973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020600',
        LOCATION_NAME: 'Lanhill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1780059,
        LOCATION_LATITUDE_DEG: 51.4692677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020700',
        LOCATION_NAME: 'Lanhydrock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6949659,
        LOCATION_LATITUDE_DEG: 50.4432949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020800',
        LOCATION_NAME: 'Lanivet',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7619177,
        LOCATION_LATITUDE_DEG: 50.4439011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA020900',
        LOCATION_NAME: 'Lanjeth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8406972,
        LOCATION_LATITUDE_DEG: 50.3379882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021000',
        LOCATION_NAME: 'Lanlivery',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7019598,
        LOCATION_LATITUDE_DEG: 50.39889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021100',
        LOCATION_NAME: 'Lannacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6776779,
        LOCATION_LATITUDE_DEG: 50.2248661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021200',
        LOCATION_NAME: 'Lanner',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1994514,
        LOCATION_LATITUDE_DEG: 50.2149768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021300',
        LOCATION_NAME: 'Lanner Moor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1918293,
        LOCATION_LATITUDE_DEG: 50.2133782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021400',
        LOCATION_NAME: 'Lanreath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5579922,
        LOCATION_LATITUDE_DEG: 50.3823919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021500',
        LOCATION_NAME: 'Lansallos',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5663226,
        LOCATION_LATITUDE_DEG: 50.3375884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021600',
        LOCATION_NAME: 'Lansdown',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3963849,
        LOCATION_LATITUDE_DEG: 51.4193632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021700',
        LOCATION_NAME: 'Lanstephan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3625311,
        LOCATION_LATITUDE_DEG: 50.6454093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021900',
        LOCATION_NAME: 'Lanteglos',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7018434,
        LOCATION_LATITUDE_DEG: 50.6083094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA021800',
        LOCATION_NAME: 'Lanteglos',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6155641,
        LOCATION_LATITUDE_DEG: 50.3327842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022000',
        LOCATION_NAME: 'Lanton',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5995959,
        LOCATION_LATITUDE_DEG: 55.488463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022100',
        LOCATION_NAME: 'Lapford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8021845,
        LOCATION_LATITUDE_DEG: 50.8590263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022200',
        LOCATION_NAME: 'Lapford Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8065593,
        LOCATION_LATITUDE_DEG: 50.8538228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022300',
        LOCATION_NAME: 'Laphroaig',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1510626,
        LOCATION_LATITUDE_DEG: 55.6305132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022400',
        LOCATION_NAME: 'Lapley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.186624,
        LOCATION_LATITUDE_DEG: 52.7132889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022500',
        LOCATION_NAME: 'Lapworth',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7605023,
        LOCATION_LATITUDE_DEG: 52.3378484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022800',
        LOCATION_NAME: 'Laragh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1852656,
        LOCATION_LATITUDE_DEG: 54.5456526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023100',
        LOCATION_NAME: 'Larbert',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8346756,
        LOCATION_LATITUDE_DEG: 56.0197307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023200',
        LOCATION_NAME: 'Larbreck',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8996502,
        LOCATION_LATITUDE_DEG: 53.8578074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023400',
        LOCATION_NAME: 'Larches',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7580322,
        LOCATION_LATITUDE_DEG: 53.767392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023600',
        LOCATION_NAME: 'Largoward',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8599476,
        LOCATION_LATITUDE_DEG: 56.2560408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023700',
        LOCATION_NAME: 'Largs',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8685461,
        LOCATION_LATITUDE_DEG: 55.7945134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024000',
        LOCATION_NAME: 'Larkfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4422337,
        LOCATION_LATITUDE_DEG: 51.3031171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024200',
        LOCATION_NAME: 'Larkhall',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9710326,
        LOCATION_LATITUDE_DEG: 55.7375009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024300',
        LOCATION_NAME: 'Larkhall',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.347722,
        LOCATION_LATITUDE_DEG: 51.4014604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024400',
        LOCATION_NAME: 'Larkhill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8125972,
        LOCATION_LATITUDE_DEG: 51.1968349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024600',
        LOCATION_NAME: 'Larkton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7407074,
        LOCATION_LATITUDE_DEG: 53.0548239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024700',
        LOCATION_NAME: 'Larling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9188377,
        LOCATION_LATITUDE_DEG: 52.4625185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024800',
        LOCATION_NAME: 'Larne',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8322673,
        LOCATION_LATITUDE_DEG: 54.8568299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024900',
        LOCATION_NAME: 'Lartington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9748876,
        LOCATION_LATITUDE_DEG: 54.5543621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025000',
        LOCATION_NAME: 'Lasborough',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2576911,
        LOCATION_LATITUDE_DEG: 51.6462887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025100',
        LOCATION_NAME: 'Lasham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0333721,
        LOCATION_LATITUDE_DEG: 51.1772271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025200',
        LOCATION_NAME: 'Lasham Airfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0288119,
        LOCATION_LATITUDE_DEG: 51.1845278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025300',
        LOCATION_NAME: 'Lask Edge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0702451,
        LOCATION_LATITUDE_DEG: 53.1259278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025400',
        LOCATION_NAME: 'Lassodie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4059222,
        LOCATION_LATITUDE_DEG: 56.1176293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025500',
        LOCATION_NAME: 'Lasswade',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1145595,
        LOCATION_LATITUDE_DEG: 55.8836221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025600',
        LOCATION_NAME: 'Lastingham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8803352,
        LOCATION_LATITUDE_DEG: 54.304127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025700',
        LOCATION_NAME: 'Latcham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7930787,
        LOCATION_LATITUDE_DEG: 51.2239477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025800',
        LOCATION_NAME: 'Latchbrook',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2405277,
        LOCATION_LATITUDE_DEG: 50.4065835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990672',
        LOCATION_NAME: 'Latchford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA025900',
        LOCATION_NAME: 'Latchford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5836549,
        LOCATION_LATITUDE_DEG: 53.3817569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026000',
        LOCATION_NAME: 'Latchingdon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7274596,
        LOCATION_LATITUDE_DEG: 51.6711457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026100',
        LOCATION_NAME: 'Latchley',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2459182,
        LOCATION_LATITUDE_DEG: 50.5391976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026200',
        LOCATION_NAME: 'Lathbury',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7199631,
        LOCATION_LATITUDE_DEG: 52.0985077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026300',
        LOCATION_NAME: 'Latheron',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3670918,
        LOCATION_LATITUDE_DEG: 58.2825501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026400',
        LOCATION_NAME: 'Latheronwheel',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3827659,
        LOCATION_LATITUDE_DEG: 58.2768476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026500',
        LOCATION_NAME: 'Lathom',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8250066,
        LOCATION_LATITUDE_DEG: 53.5837803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026600',
        LOCATION_NAME: 'Latimer',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5509019,
        LOCATION_LATITUDE_DEG: 51.6786648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026800',
        LOCATION_NAME: 'Lattiford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4334894,
        LOCATION_LATITUDE_DEG: 51.0379296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027100',
        LOCATION_NAME: 'Latton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8651873,
        LOCATION_LATITUDE_DEG: 51.6600813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027200',
        LOCATION_NAME: 'Lauder',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7471494,
        LOCATION_LATITUDE_DEG: 55.7194881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027300',
        LOCATION_NAME: 'Laugharne',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4612608,
        LOCATION_LATITUDE_DEG: 51.7705223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027400',
        LOCATION_NAME: 'Laughterton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7437273,
        LOCATION_LATITUDE_DEG: 53.2741196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027800',
        LOCATION_NAME: 'Laughton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2182736,
        LOCATION_LATITUDE_DEG: 53.387142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027700',
        LOCATION_NAME: 'Laughton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0268965,
        LOCATION_LATITUDE_DEG: 52.4960466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027600',
        LOCATION_NAME: 'Laughton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7219224,
        LOCATION_LATITUDE_DEG: 53.4658397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027500',
        LOCATION_NAME: 'Laughton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.39779,
        LOCATION_LATITUDE_DEG: 52.8721801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027900',
        LOCATION_NAME: 'Laughton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1358029,
        LOCATION_LATITUDE_DEG: 50.8977849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028000',
        LOCATION_NAME: 'Laughton Common',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.230457,
        LOCATION_LATITUDE_DEG: 53.3786358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028100',
        LOCATION_NAME: 'Launcells',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4881915,
        LOCATION_LATITUDE_DEG: 50.8235275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028200',
        LOCATION_NAME: 'Launceston',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3592227,
        LOCATION_LATITUDE_DEG: 50.6381092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028300',
        LOCATION_NAME: 'Launcherley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6411522,
        LOCATION_LATITUDE_DEG: 51.1816488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028350',
        LOCATION_NAME: 'Launde',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8305007,
        LOCATION_LATITUDE_DEG: 52.6309821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028400',
        LOCATION_NAME: 'Launton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1146005,
        LOCATION_LATITUDE_DEG: 51.8970965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028600',
        LOCATION_NAME: 'Laurelvale',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.422552,
        LOCATION_LATITUDE_DEG: 54.3380842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028700',
        LOCATION_NAME: 'Laurencekirk',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4623748,
        LOCATION_LATITUDE_DEG: 56.8344934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028850',
        LOCATION_NAME: 'Laurencetown',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.312927,
        LOCATION_LATITUDE_DEG: 54.3812115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029000',
        LOCATION_NAME: 'Laurieston',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0593742,
        LOCATION_LATITUDE_DEG: 54.9599264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028900',
        LOCATION_NAME: 'Laurieston',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7544872,
        LOCATION_LATITUDE_DEG: 55.9984203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034400',
        LOCATION_NAME: 'Lauriston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1977973,
        LOCATION_LATITUDE_DEG: 55.9454051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029200',
        LOCATION_NAME: 'Lavant',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7816518,
        LOCATION_LATITUDE_DEG: 50.8689928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029300',
        LOCATION_NAME: 'Lavendon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6595087,
        LOCATION_LATITUDE_DEG: 52.1727133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029400',
        LOCATION_NAME: 'Lavenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.797152,
        LOCATION_LATITUDE_DEG: 52.1071849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029500',
        LOCATION_NAME: 'Lavernock',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.169152,
        LOCATION_LATITUDE_DEG: 51.4064685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029600',
        LOCATION_NAME: 'Laversdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8206407,
        LOCATION_LATITUDE_DEG: 54.9521093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029800',
        LOCATION_NAME: 'Laverstock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8146876,
        LOCATION_LATITUDE_DEG: 50.7974109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029700',
        LOCATION_NAME: 'Laverstock',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7744543,
        LOCATION_LATITUDE_DEG: 51.0732206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029900',
        LOCATION_NAME: 'Laverstoke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2953336,
        LOCATION_LATITUDE_DEG: 51.2340371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030200',
        LOCATION_NAME: 'Laverton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3167696,
        LOCATION_LATITUDE_DEG: 51.2787517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030000',
        LOCATION_NAME: 'Laverton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.892589,
        LOCATION_LATITUDE_DEG: 52.018917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030100',
        LOCATION_NAME: 'Laverton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6505945,
        LOCATION_LATITUDE_DEG: 54.1549175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030400',
        LOCATION_NAME: 'Lavington Park',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6589737,
        LOCATION_LATITUDE_DEG: 50.9394011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030500',
        LOCATION_NAME: 'Lavister',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9362208,
        LOCATION_LATITUDE_DEG: 53.1172331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030600',
        LOCATION_NAME: 'Law',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8831958,
        LOCATION_LATITUDE_DEG: 55.7502037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030700',
        LOCATION_NAME: 'Lawers',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1507117,
        LOCATION_LATITUDE_DEG: 56.5302164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030800',
        LOCATION_NAME: 'Lawford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0523169,
        LOCATION_LATITUDE_DEG: 51.9370726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030900',
        LOCATION_NAME: 'Lawford Heath',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.325319,
        LOCATION_LATITUDE_DEG: 52.3687405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031000',
        LOCATION_NAME: 'Lawhitton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3246521,
        LOCATION_LATITUDE_DEG: 50.616613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031100',
        LOCATION_NAME: 'Lawley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7380255,
        LOCATION_LATITUDE_DEG: 52.5828831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031200',
        LOCATION_NAME: 'Lawley Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4750317,
        LOCATION_LATITUDE_DEG: 52.6766831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031300',
        LOCATION_NAME: 'Lawley Furnaces',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4927024,
        LOCATION_LATITUDE_DEG: 52.6787867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031400',
        LOCATION_NAME: 'Lawnhead',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2461625,
        LOCATION_LATITUDE_DEG: 52.8201953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034200',
        LOCATION_NAME: 'Lawnswood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5962762,
        LOCATION_LATITUDE_DEG: 53.8489315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031500',
        LOCATION_NAME: 'Lawnt',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4320744,
        LOCATION_LATITUDE_DEG: 53.1727458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031600',
        LOCATION_NAME: 'Lawrence End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3396937,
        LOCATION_LATITUDE_DEG: 51.8652788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031700',
        LOCATION_NAME: 'Lawrence Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5618442,
        LOCATION_LATITUDE_DEG: 51.4557729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031800',
        LOCATION_NAME: 'Lawrenny',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8709705,
        LOCATION_LATITUDE_DEG: 51.7254158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA031900',
        LOCATION_NAME: 'Lawshall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7238314,
        LOCATION_LATITUDE_DEG: 52.1539899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032000',
        LOCATION_NAME: 'Lawthorn',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6304217,
        LOCATION_LATITUDE_DEG: 55.6364999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032100',
        LOCATION_NAME: 'Lawton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7156715,
        LOCATION_LATITUDE_DEG: 52.4500685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034500',
        LOCATION_NAME: 'Lawton Moor',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2812045,
        LOCATION_LATITUDE_DEG: 53.409228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032200',
        LOCATION_NAME: 'Laxay',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5230866,
        LOCATION_LATITUDE_DEG: 58.1057638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032300',
        LOCATION_NAME: 'Laxdale',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3856734,
        LOCATION_LATITUDE_DEG: 58.2265746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032400',
        LOCATION_NAME: 'Laxey',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4056879,
        LOCATION_LATITUDE_DEG: 54.2298721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032500',
        LOCATION_NAME: 'Laxfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3684235,
        LOCATION_LATITUDE_DEG: 52.3013024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032800',
        LOCATION_NAME: 'Laxton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9196113,
        LOCATION_LATITUDE_DEG: 53.19502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032600',
        LOCATION_NAME: 'Laxton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.799746,
        LOCATION_LATITUDE_DEG: 53.7198654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032700',
        LOCATION_NAME: 'Laxton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5977205,
        LOCATION_LATITUDE_DEG: 52.5543472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA032900',
        LOCATION_NAME: 'Laycock',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9562021,
        LOCATION_LATITUDE_DEG: 53.8639939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033000',
        LOCATION_NAME: 'Layer Breton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.82226,
        LOCATION_LATITUDE_DEG: 51.8303587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033900',
        LOCATION_NAME: 'Layer de la Haye',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033100',
        LOCATION_NAME: 'Layer Marney',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7961195,
        LOCATION_LATITUDE_DEG: 51.8271609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033200',
        LOCATION_NAME: 'Layer-de-la-Haye',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8472821,
        LOCATION_LATITUDE_DEG: 51.8387768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033300',
        LOCATION_NAME: 'Layham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9657792,
        LOCATION_LATITUDE_DEG: 52.0272812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033400',
        LOCATION_NAME: 'Laytham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8608272,
        LOCATION_LATITUDE_DEG: 53.8436818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033600',
        LOCATION_NAME: 'Lazenby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1155507,
        LOCATION_LATITUDE_DEG: 54.5693513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033700',
        LOCATION_NAME: 'Lazonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7018764,
        LOCATION_LATITUDE_DEG: 54.7499922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000300',
        LOCATION_NAME: 'Lea',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7859439,
        LOCATION_LATITUDE_DEG: 53.7710957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000500',
        LOCATION_NAME: 'Lea',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4914182,
        LOCATION_LATITUDE_DEG: 51.8932146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000100',
        LOCATION_NAME: 'Lea',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0589301,
        LOCATION_LATITUDE_DEG: 51.5793749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000200',
        LOCATION_NAME: 'Lea',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5079707,
        LOCATION_LATITUDE_DEG: 53.113919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000400',
        LOCATION_NAME: 'Lea',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7525053,
        LOCATION_LATITUDE_DEG: 53.3697341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000600',
        LOCATION_NAME: 'Lea Bailey',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5309018,
        LOCATION_LATITUDE_DEG: 51.8867127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000700',
        LOCATION_NAME: 'Lea Bailey Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5294553,
        LOCATION_LATITUDE_DEG: 51.8885087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000800',
        LOCATION_NAME: 'Lea Bridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5258865,
        LOCATION_LATITUDE_DEG: 53.1057118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000900',
        LOCATION_NAME: 'Lea Cross',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8570021,
        LOCATION_LATITUDE_DEG: 52.6685938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE031800',
        LOCATION_NAME: 'Lea Hall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.78673,
        LOCATION_LATITUDE_DEG: 52.4756968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001000',
        LOCATION_NAME: 'Lea Marston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6999495,
        LOCATION_LATITUDE_DEG: 52.5375644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE990561',
        LOCATION_NAME: 'Lea Town',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5557024,
        LOCATION_LATITUDE_DEG: 49.7661964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001100',
        LOCATION_NAME: 'Lea Valley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3158039,
        LOCATION_LATITUDE_DEG: 51.8180772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001200',
        LOCATION_NAME: 'Leabrooks',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3909182,
        LOCATION_LATITUDE_DEG: 53.073614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001300',
        LOCATION_NAME: 'Leachachan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4870563,
        LOCATION_LATITUDE_DEG: 57.2409654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001400',
        LOCATION_NAME: 'Leachin',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8361944,
        LOCATION_LATITUDE_DEG: 57.9115427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001500',
        LOCATION_NAME: 'Leachkin',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2765357,
        LOCATION_LATITUDE_DEG: 57.472473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001600',
        LOCATION_NAME: 'Leacklea',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.836541,
        LOCATION_LATITUDE_DEG: 57.8282351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001700',
        LOCATION_NAME: 'Leadburn',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2193851,
        LOCATION_LATITUDE_DEG: 55.7867939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001800',
        LOCATION_NAME: 'Leaden Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3108266,
        LOCATION_LATITUDE_DEG: 51.7957649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE001900',
        LOCATION_NAME: 'Leadenhall',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7473456,
        LOCATION_LATITUDE_DEG: 52.0252999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002000',
        LOCATION_NAME: 'Leadenham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5810891,
        LOCATION_LATITUDE_DEG: 53.0566971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002200',
        LOCATION_NAME: 'Leadgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4552352,
        LOCATION_LATITUDE_DEG: 54.7881889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002100',
        LOCATION_NAME: 'Leadgate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8060845,
        LOCATION_LATITUDE_DEG: 54.8613899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002300',
        LOCATION_NAME: 'Leadhills',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7584967,
        LOCATION_LATITUDE_DEG: 55.4183677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002400',
        LOCATION_NAME: 'Leafield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5421391,
        LOCATION_LATITUDE_DEG: 51.8345961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002500',
        LOCATION_NAME: 'Leagrave',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4582135,
        LOCATION_LATITUDE_DEG: 51.9054886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002600',
        LOCATION_NAME: 'Leake Gride',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0672301,
        LOCATION_LATITUDE_DEG: 53.028988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002700',
        LOCATION_NAME: 'Lealholm',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8225848,
        LOCATION_LATITUDE_DEG: 54.4581387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002800',
        LOCATION_NAME: 'Lealt',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1711957,
        LOCATION_LATITUDE_DEG: 57.5685016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE002900',
        LOCATION_NAME: 'Leamington Hastings',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3468949,
        LOCATION_LATITUDE_DEG: 52.3051399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003000',
        LOCATION_NAME: 'Leamington Spa',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5343328,
        LOCATION_LATITUDE_DEG: 52.2916414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003200',
        LOCATION_NAME: 'Leamoor Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8453096,
        LOCATION_LATITUDE_DEG: 52.4747662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003300',
        LOCATION_NAME: 'Leamore',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0123162,
        LOCATION_LATITUDE_DEG: 52.6043775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003400',
        LOCATION_NAME: 'Leamside',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5155454,
        LOCATION_LATITUDE_DEG: 54.8138792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003600',
        LOCATION_NAME: 'Leanish',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4290808,
        LOCATION_LATITUDE_DEG: 56.9629599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004000',
        LOCATION_NAME: 'Leasgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7743672,
        LOCATION_LATITUDE_DEG: 54.2495448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004100',
        LOCATION_NAME: 'Leasingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4245539,
        LOCATION_LATITUDE_DEG: 53.0228895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004200',
        LOCATION_NAME: 'Leasingham Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3784757,
        LOCATION_LATITUDE_DEG: 53.0256958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004300',
        LOCATION_NAME: 'Leasingthorne',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6056776,
        LOCATION_LATITUDE_DEG: 54.6608666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004400',
        LOCATION_NAME: 'Leason',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1894699,
        LOCATION_LATITUDE_DEG: 51.6109021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004600',
        LOCATION_NAME: 'Leasty',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.018754,
        LOCATION_LATITUDE_DEG: 52.4614682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004700',
        LOCATION_NAME: 'Leat',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2732235,
        LOCATION_LATITUDE_DEG: 50.6405121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004900',
        LOCATION_NAME: 'Leatherhead',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3243623,
        LOCATION_LATITUDE_DEG: 51.2953296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005000',
        LOCATION_NAME: 'Leathley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6464195,
        LOCATION_LATITUDE_DEG: 53.9184933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005100',
        LOCATION_NAME: 'Leaton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7895621,
        LOCATION_LATITUDE_DEG: 52.7612997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005200',
        LOCATION_NAME: 'Leaton Knolls',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7794258,
        LOCATION_LATITUDE_DEG: 52.7455968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005300',
        LOCATION_NAME: 'Leaveland',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.878362,
        LOCATION_LATITUDE_DEG: 51.2490088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005400',
        LOCATION_NAME: 'Leavenheath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8464342,
        LOCATION_LATITUDE_DEG: 51.9988727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005500',
        LOCATION_NAME: 'Leavening',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8014184,
        LOCATION_LATITUDE_DEG: 54.0574011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005600',
        LOCATION_NAME: 'Leavesden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4087098,
        LOCATION_LATITUDE_DEG: 51.6974632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005700',
        LOCATION_NAME: 'Leavesden Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4105008,
        LOCATION_LATITUDE_DEG: 51.6880628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE005800',
        LOCATION_NAME: 'Lebberston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3460681,
        LOCATION_LATITUDE_DEG: 54.228405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006200',
        LOCATION_NAME: 'Lechfaen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.340172,
        LOCATION_LATITUDE_DEG: 51.9456806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006300',
        LOCATION_NAME: 'Lechlade',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6897156,
        LOCATION_LATITUDE_DEG: 51.6940813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006400',
        LOCATION_NAME: 'Leck',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5453419,
        LOCATION_LATITUDE_DEG: 54.1857306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006700',
        LOCATION_NAME: 'Leckford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4642342,
        LOCATION_LATITUDE_DEG: 51.1369255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006800',
        LOCATION_NAME: 'Leckhampstead',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3673797,
        LOCATION_LATITUDE_DEG: 51.4838562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006900',
        LOCATION_NAME: 'Leckhampstead',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9363102,
        LOCATION_LATITUDE_DEG: 52.0337038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007000',
        LOCATION_NAME: 'Leckhampton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0764376,
        LOCATION_LATITUDE_DEG: 51.8800085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007100',
        LOCATION_NAME: 'Leckhampton Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0782879,
        LOCATION_LATITUDE_DEG: 51.8662047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007200',
        LOCATION_NAME: 'Leckmelm',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0934224,
        LOCATION_LATITUDE_DEG: 57.8675272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007300',
        LOCATION_NAME: 'Lecknasaide',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7018629,
        LOCATION_LATITUDE_DEG: 57.695216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007400',
        LOCATION_NAME: 'Leckwith',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2126246,
        LOCATION_LATITUDE_DEG: 51.4598772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007500',
        LOCATION_NAME: 'Leconfield',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4565313,
        LOCATION_LATITUDE_DEG: 53.8774767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007600',
        LOCATION_NAME: 'Ledaig',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4698858,
        LOCATION_LATITUDE_DEG: 56.9495569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007800',
        LOCATION_NAME: 'Ledaig',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0677452,
        LOCATION_LATITUDE_DEG: 56.6206063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007700',
        LOCATION_NAME: 'Ledaig',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3989232,
        LOCATION_LATITUDE_DEG: 56.4798877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE007900',
        LOCATION_NAME: 'Ledburn',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6849072,
        LOCATION_LATITUDE_DEG: 51.8886907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008000',
        LOCATION_NAME: 'Ledbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.423645,
        LOCATION_LATITUDE_DEG: 52.0364216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008100',
        LOCATION_NAME: 'Leddington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4507169,
        LOCATION_LATITUDE_DEG: 52.0129245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008200',
        LOCATION_NAME: 'Ledgowan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1195533,
        LOCATION_LATITUDE_DEG: 57.5678953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008300',
        LOCATION_NAME: 'Ledsham',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9631803,
        LOCATION_LATITUDE_DEG: 53.2622472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008400',
        LOCATION_NAME: 'Ledsham',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3083189,
        LOCATION_LATITUDE_DEG: 53.7618783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008500',
        LOCATION_NAME: 'Ledston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3422322,
        LOCATION_LATITUDE_DEG: 53.7517764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008600',
        LOCATION_NAME: 'Ledstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7584919,
        LOCATION_LATITUDE_DEG: 50.303971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008700',
        LOCATION_NAME: 'Ledwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3913594,
        LOCATION_LATITUDE_DEG: 51.9508988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008800',
        LOCATION_NAME: 'Ledwyche',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6729604,
        LOCATION_LATITUDE_DEG: 52.3415515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE008900',
        LOCATION_NAME: 'Lee',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1647168,
        LOCATION_LATITUDE_DEG: 51.1951605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009100',
        LOCATION_NAME: 'Lee',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8849509,
        LOCATION_LATITUDE_DEG: 52.8855083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009000',
        LOCATION_NAME: 'Lee',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4852223,
        LOCATION_LATITUDE_DEG: 50.9577118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030600',
        LOCATION_NAME: 'Lee',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0133111,
        LOCATION_LATITUDE_DEG: 51.4501551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE031700',
        LOCATION_NAME: 'Lee Bank',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9064758,
        LOCATION_LATITUDE_DEG: 52.472903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009200',
        LOCATION_NAME: 'Lee Bridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6703604,
        LOCATION_LATITUDE_DEG: 52.8358017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009300',
        LOCATION_NAME: 'Lee Brockhurst',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6722288,
        LOCATION_LATITUDE_DEG: 52.8395043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009400',
        LOCATION_NAME: 'Lee Gate',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7006495,
        LOCATION_LATITUDE_DEG: 51.7392742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030500',
        LOCATION_NAME: 'Lee Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0133075,
        LOCATION_LATITUDE_DEG: 51.4500742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009500',
        LOCATION_NAME: 'Lee Mill Bridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9726052,
        LOCATION_LATITUDE_DEG: 50.3836775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009600',
        LOCATION_NAME: 'Lee Moor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0105405,
        LOCATION_LATITUDE_DEG: 50.4396887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030200',
        LOCATION_NAME: 'Lee on the Solent',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030300',
        LOCATION_NAME: 'Lee over Sands',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009900',
        LOCATION_NAME: 'Leebotwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7739379,
        LOCATION_LATITUDE_DEG: 52.5811794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010000',
        LOCATION_NAME: 'Leece',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1564735,
        LOCATION_LATITUDE_DEG: 54.1157304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010100',
        LOCATION_NAME: 'Leechmere',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.37031,
        LOCATION_LATITUDE_DEG: 54.8762879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010200',
        LOCATION_NAME: 'Leedon',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6428731,
        LOCATION_LATITUDE_DEG: 51.9206942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010300',
        LOCATION_NAME: 'Leeds',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6085864,
        LOCATION_LATITUDE_DEG: 51.246206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010400',
        LOCATION_NAME: 'Leeds Bradford Airport',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6618723,
        LOCATION_LATITUDE_DEG: 53.8660875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010500',
        LOCATION_NAME: 'Leeds LS 1',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.550747,
        LOCATION_LATITUDE_DEG: 53.7976579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010600',
        LOCATION_NAME: 'Leeds LS 2',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5484351,
        LOCATION_LATITUDE_DEG: 53.8036809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010700',
        LOCATION_NAME: 'Leeds LS 3',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5656969,
        LOCATION_LATITUDE_DEG: 53.8011828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010800',
        LOCATION_NAME: 'Leeds LS 4',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5863188,
        LOCATION_LATITUDE_DEG: 53.8088245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE010900',
        LOCATION_NAME: 'Leeds LS 5',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6108035,
        LOCATION_LATITUDE_DEG: 53.8217158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011000',
        LOCATION_NAME: 'Leeds LS 6',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5736003,
        LOCATION_LATITUDE_DEG: 53.8229198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011100',
        LOCATION_NAME: 'Leeds LS 7',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5413846,
        LOCATION_LATITUDE_DEG: 53.8207694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011200',
        LOCATION_NAME: 'Leeds LS 8',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5050512,
        LOCATION_LATITUDE_DEG: 53.8292815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011300',
        LOCATION_NAME: 'Leeds LS 9',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5344774,
        LOCATION_LATITUDE_DEG: 53.798369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011400',
        LOCATION_NAME: 'Leeds LS10',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5245845,
        LOCATION_LATITUDE_DEG: 53.7628321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011500',
        LOCATION_NAME: 'Leeds LS11',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5578525,
        LOCATION_LATITUDE_DEG: 53.7760476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011600',
        LOCATION_NAME: 'Leeds LS12',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6044473,
        LOCATION_LATITUDE_DEG: 53.7868354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011700',
        LOCATION_NAME: 'Leeds LS13',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6396675,
        LOCATION_LATITUDE_DEG: 53.8130417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011800',
        LOCATION_NAME: 'Leeds LS14',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4447706,
        LOCATION_LATITUDE_DEG: 53.8443081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE011900',
        LOCATION_NAME: 'Leeds LS15',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4255359,
        LOCATION_LATITUDE_DEG: 53.8114163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012000',
        LOCATION_NAME: 'Leeds LS16',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5980939,
        LOCATION_LATITUDE_DEG: 53.8639043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012100',
        LOCATION_NAME: 'Leeds LS17',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5217889,
        LOCATION_LATITUDE_DEG: 53.8899353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012200',
        LOCATION_NAME: 'Leeds LS18',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6527591,
        LOCATION_LATITUDE_DEG: 53.8536387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012300',
        LOCATION_NAME: 'Leeds LS19',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6791988,
        LOCATION_LATITUDE_DEG: 53.8635642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE990562',
        LOCATION_NAME: 'Leeds LS98',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012400',
        LOCATION_NAME: 'Leedstown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3545748,
        LOCATION_LATITUDE_DEG: 50.1602751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012500',
        LOCATION_NAME: 'Leegomery',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4893887,
        LOCATION_LATITUDE_DEG: 52.7131901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012600',
        LOCATION_NAME: 'Leeholme',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6190411,
        LOCATION_LATITUDE_DEG: 54.6642708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012700',
        LOCATION_NAME: 'Leek',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0252618,
        LOCATION_LATITUDE_DEG: 53.1063206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012800',
        LOCATION_NAME: 'Leek Wootton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5752631,
        LOCATION_LATITUDE_DEG: 52.3172411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013000',
        LOCATION_NAME: 'Leeming',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9308576,
        LOCATION_LATITUDE_DEG: 53.8046908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE012900',
        LOCATION_NAME: 'Leeming',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5464654,
        LOCATION_LATITUDE_DEG: 54.2970285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013100',
        LOCATION_NAME: 'Leeming Bar',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5583988,
        LOCATION_LATITUDE_DEG: 54.3048297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009700',
        LOCATION_NAME: 'Lee-on-the-Solent',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2008671,
        LOCATION_LATITUDE_DEG: 50.8014937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE009800',
        LOCATION_NAME: 'Lee-over-Sands',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0565686,
        LOCATION_LATITUDE_DEG: 51.770249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013300',
        LOCATION_NAME: 'Lees',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0691435,
        LOCATION_LATITUDE_DEG: 53.537262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013400',
        LOCATION_NAME: 'Lees Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6974458,
        LOCATION_LATITUDE_DEG: 55.0035138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013500',
        LOCATION_NAME: 'Leesthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8427356,
        LOCATION_LATITUDE_DEG: 52.7149722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013600',
        LOCATION_NAME: 'Leeswood',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0932838,
        LOCATION_LATITUDE_DEG: 53.1334348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013700',
        LOCATION_NAME: 'Legacurry',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2220626,
        LOCATION_LATITUDE_DEG: 54.518559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013900',
        LOCATION_NAME: 'Legbourne',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0547478,
        LOCATION_LATITUDE_DEG: 53.3383164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014000',
        LOCATION_NAME: 'Legg',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9801776,
        LOCATION_LATITUDE_DEG: 54.4975203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014200',
        LOCATION_NAME: 'Leggs',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9801776,
        LOCATION_LATITUDE_DEG: 54.4975203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014300',
        LOCATION_NAME: 'Legsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2908852,
        LOCATION_LATITUDE_DEG: 53.35632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014500',
        LOCATION_NAME: 'Leicester',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1316935,
        LOCATION_LATITUDE_DEG: 52.6352627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014600',
        LOCATION_NAME: 'Leicester Forest East',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2205625,
        LOCATION_LATITUDE_DEG: 52.6232663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015300',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9853932,
        LOCATION_LATITUDE_DEG: 52.6245824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015400',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9142938,
        LOCATION_LATITUDE_DEG: 50.8453111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014900',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5389689,
        LOCATION_LATITUDE_DEG: 50.8750155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015100',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5097884,
        LOCATION_LATITUDE_DEG: 53.4951671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015500',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3198839,
        LOCATION_LATITUDE_DEG: 52.1777374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015550',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9769284,
        LOCATION_LATITUDE_DEG: 52.9213837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015200',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.898832,
        LOCATION_LATITUDE_DEG: 51.6278778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014800',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.249015,
        LOCATION_LATITUDE_DEG: 51.2072209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015000',
        LOCATION_NAME: 'Leigh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2168495,
        LOCATION_LATITUDE_DEG: 51.1963067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015600',
        LOCATION_NAME: 'Leigh Beck',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6119829,
        LOCATION_LATITUDE_DEG: 51.5182393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015700',
        LOCATION_NAME: 'Leigh Common',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3679427,
        LOCATION_LATITUDE_DEG: 51.066429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015800',
        LOCATION_NAME: 'Leigh Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8949846,
        LOCATION_LATITUDE_DEG: 50.9081318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE015900',
        LOCATION_NAME: 'Leigh Delamere',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1654874,
        LOCATION_LATITUDE_DEG: 51.5112721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030000',
        LOCATION_NAME: 'Leigh on Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016000',
        LOCATION_NAME: 'Leigh Sinton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3205405,
        LOCATION_LATITUDE_DEG: 52.1551309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016200',
        LOCATION_NAME: 'Leigh upon Mendip',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.441239,
        LOCATION_LATITUDE_DEG: 51.2228443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016100',
        LOCATION_NAME: 'Leigh Woods',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6342465,
        LOCATION_LATITUDE_DEG: 51.4515727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016400',
        LOCATION_NAME: 'Leigham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.095017,
        LOCATION_LATITUDE_DEG: 50.4069842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016300',
        LOCATION_NAME: 'Leigh-on-Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6628026,
        LOCATION_LATITUDE_DEG: 51.542434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016600',
        LOCATION_NAME: 'Leighterton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2563613,
        LOCATION_LATITUDE_DEG: 51.6180826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016900',
        LOCATION_NAME: 'Leighton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.120994,
        LOCATION_LATITUDE_DEG: 52.6480938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016800',
        LOCATION_NAME: 'Leighton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5760065,
        LOCATION_LATITUDE_DEG: 52.6465836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017050',
        LOCATION_NAME: 'Leighton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4676675,
        LOCATION_LATITUDE_DEG: 53.1188179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017000',
        LOCATION_NAME: 'Leighton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.423253,
        LOCATION_LATITUDE_DEG: 51.1933417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016700',
        LOCATION_NAME: 'Leighton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.750076,
        LOCATION_LATITUDE_DEG: 54.2106239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017100',
        LOCATION_NAME: 'Leighton Bromswold',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3652952,
        LOCATION_LATITUDE_DEG: 52.3653305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017200',
        LOCATION_NAME: 'Leighton Buzzard',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.659161,
        LOCATION_LATITUDE_DEG: 51.9172929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017300',
        LOCATION_NAME: 'Leighton Hall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7740752,
        LOCATION_LATITUDE_DEG: 54.1486309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017400',
        LOCATION_NAME: 'Leinthall Earls',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.817429,
        LOCATION_LATITUDE_DEG: 52.3049532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017500',
        LOCATION_NAME: 'Leinthall Starkes',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.826822,
        LOCATION_LATITUDE_DEG: 52.3225561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017600',
        LOCATION_NAME: 'Leintwardine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8734368,
        LOCATION_LATITUDE_DEG: 52.3610639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017700',
        LOCATION_NAME: 'Leire',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2258822,
        LOCATION_LATITUDE_DEG: 52.5050503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017800',
        LOCATION_NAME: 'Leiston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5765596,
        LOCATION_LATITUDE_DEG: 52.2054883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE017900',
        LOCATION_NAME: 'Leith',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1595958,
        LOCATION_LATITUDE_DEG: 55.9746172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018000',
        LOCATION_NAME: 'Leith Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3775441,
        LOCATION_LATITUDE_DEG: 51.1722176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018100',
        LOCATION_NAME: 'Leitholm',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3331124,
        LOCATION_LATITUDE_DEG: 55.6907733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018200',
        LOCATION_NAME: 'Leitrim',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3157497,
        LOCATION_LATITUDE_DEG: 54.1665814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018500',
        LOCATION_NAME: 'Lelant',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4387217,
        LOCATION_LATITUDE_DEG: 50.1834814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018600',
        LOCATION_NAME: 'Lelant Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4617662,
        LOCATION_LATITUDE_DEG: 50.1717742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018700',
        LOCATION_NAME: 'Lelley',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1649051,
        LOCATION_LATITUDE_DEG: 53.7751607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018800',
        LOCATION_NAME: 'Lemington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7192229,
        LOCATION_LATITUDE_DEG: 54.9779033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018900',
        LOCATION_NAME: 'Lemreway',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4349986,
        LOCATION_LATITUDE_DEG: 58.0184505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019000',
        LOCATION_NAME: 'Lemsford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2349339,
        LOCATION_LATITUDE_DEG: 51.7928706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019100',
        LOCATION_NAME: 'Lenaderg',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2605275,
        LOCATION_LATITUDE_DEG: 54.338877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019300',
        LOCATION_NAME: 'Lenborough',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9821691,
        LOCATION_LATITUDE_DEG: 51.9769013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019400',
        LOCATION_NAME: 'Lenchwick',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9496462,
        LOCATION_LATITUDE_DEG: 52.1230243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019500',
        LOCATION_NAME: 'Lendalfoot',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9343501,
        LOCATION_LATITUDE_DEG: 55.1687513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019600',
        LOCATION_NAME: 'Lenham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7196163,
        LOCATION_LATITUDE_DEG: 51.2365082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019700',
        LOCATION_NAME: 'Lenham Heath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.748775,
        LOCATION_LATITUDE_DEG: 51.2139054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019800',
        LOCATION_NAME: 'Lennel',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2345426,
        LOCATION_LATITUDE_DEG: 55.66167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019900',
        LOCATION_NAME: 'Lennoxtown',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1988662,
        LOCATION_LATITUDE_DEG: 55.9736238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020200',
        LOCATION_NAME: 'Lenton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1812848,
        LOCATION_LATITUDE_DEG: 52.9459955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020100',
        LOCATION_NAME: 'Lenton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4767906,
        LOCATION_LATITUDE_DEG: 52.8605781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020300',
        LOCATION_NAME: 'Lenton Abbey',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2126291,
        LOCATION_LATITUDE_DEG: 52.9378911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020400',
        LOCATION_NAME: 'Lenwade',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1086819,
        LOCATION_LATITUDE_DEG: 52.7217412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020500',
        LOCATION_NAME: 'Lenzie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1551584,
        LOCATION_LATITUDE_DEG: 55.9258238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020600',
        LOCATION_NAME: 'Leominster',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7376241,
        LOCATION_LATITUDE_DEG: 52.2257417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020700',
        LOCATION_NAME: 'Leonard Stanley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2816782,
        LOCATION_LATITUDE_DEG: 51.7313901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020800',
        LOCATION_NAME: 'Lephin',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7068535,
        LOCATION_LATITUDE_DEG: 57.4486994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020900',
        LOCATION_NAME: 'Leppington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8344353,
        LOCATION_LATITUDE_DEG: 54.0388932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021000',
        LOCATION_NAME: 'Lepton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6916797,
        LOCATION_LATITUDE_DEG: 53.6321718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021100',
        LOCATION_NAME: 'Lerags',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5154943,
        LOCATION_LATITUDE_DEG: 56.366778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021200',
        LOCATION_NAME: 'Lerin',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7165288,
        LOCATION_LATITUDE_DEG: 58.5619863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021400',
        LOCATION_NAME: 'Lerryn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6148809,
        LOCATION_LATITUDE_DEG: 50.3837889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021500',
        LOCATION_NAME: 'Lerwick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.148165,
        LOCATION_LATITUDE_DEG: 60.1560086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021600',
        LOCATION_NAME: 'Lesbury',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6269361,
        LOCATION_LATITUDE_DEG: 55.3983371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021700',
        LOCATION_NAME: 'Lescrow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6490849,
        LOCATION_LATITUDE_DEG: 50.3423884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021800',
        LOCATION_NAME: 'Leslie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.209992,
        LOCATION_LATITUDE_DEG: 56.2020362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021900',
        LOCATION_NAME: 'Leslie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6681138,
        LOCATION_LATITUDE_DEG: 57.3110402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022000',
        LOCATION_NAME: 'Lesmahagow',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8849984,
        LOCATION_LATITUDE_DEG: 55.6394893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022100',
        LOCATION_NAME: 'Lesnewth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.644808,
        LOCATION_LATITUDE_DEG: 50.6812158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022200',
        LOCATION_NAME: 'Lessendrum',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7044809,
        LOCATION_LATITUDE_DEG: 57.4632558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022300',
        LOCATION_NAME: 'Lessingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5442474,
        LOCATION_LATITUDE_DEG: 52.7995421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022400',
        LOCATION_NAME: 'Lesson Hall',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2142331,
        LOCATION_LATITUDE_DEG: 54.8379211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022500',
        LOCATION_NAME: 'Leswalt',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0941789,
        LOCATION_LATITUDE_DEG: 54.9305373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022600',
        LOCATION_NAME: 'Letchmore Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3338311,
        LOCATION_LATITUDE_DEG: 51.6659653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022700',
        LOCATION_NAME: 'Letchworth Garden City',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2283896,
        LOCATION_LATITUDE_DEG: 51.9758863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022800',
        LOCATION_NAME: 'Letcombe Bassett',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4610014,
        LOCATION_LATITUDE_DEG: 51.5630627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE022900',
        LOCATION_NAME: 'Letcombe Regis',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4497696,
        LOCATION_LATITUDE_DEG: 51.5767691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE990669',
        LOCATION_NAME: 'Letcome Regis',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023000',
        LOCATION_NAME: 'Letfern',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2393797,
        LOCATION_LATITUDE_DEG: 54.5106438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023100',
        LOCATION_NAME: 'Letham',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7784301,
        LOCATION_LATITUDE_DEG: 56.0556321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023200',
        LOCATION_NAME: 'Letham',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1197474,
        LOCATION_LATITUDE_DEG: 56.3170447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023300',
        LOCATION_NAME: 'Letham',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7728206,
        LOCATION_LATITUDE_DEG: 56.6283782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023400',
        LOCATION_NAME: 'Letham Grange',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6075097,
        LOCATION_LATITUDE_DEG: 56.6000664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023500',
        LOCATION_NAME: 'Lethangie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4123631,
        LOCATION_LATITUDE_DEG: 56.2200383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023600',
        LOCATION_NAME: 'Letheringham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3247693,
        LOCATION_LATITUDE_DEG: 52.1727854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023700',
        LOCATION_NAME: 'Letheringsett',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0648119,
        LOCATION_LATITUDE_DEG: 52.9071615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023800',
        LOCATION_NAME: 'Lethnot',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7887825,
        LOCATION_LATITUDE_DEG: 56.8142953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023825',
        LOCATION_NAME: 'Letter',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9403633,
        LOCATION_LATITUDE_DEG: 54.5094482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024000',
        LOCATION_NAME: 'Letterbreen',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7323944,
        LOCATION_LATITUDE_DEG: 54.2998891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024200',
        LOCATION_NAME: 'Letterfearn',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.509501,
        LOCATION_LATITUDE_DEG: 57.2551659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024400',
        LOCATION_NAME: 'Letterfinlay',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.881719,
        LOCATION_LATITUDE_DEG: 56.9781337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024900',
        LOCATION_NAME: 'Lettermore',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.078401,
        LOCATION_LATITUDE_DEG: 56.5620037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025100',
        LOCATION_NAME: 'Letters',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0938313,
        LOCATION_LATITUDE_DEG: 57.8375217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025200',
        LOCATION_NAME: 'Letterston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9934904,
        LOCATION_LATITUDE_DEG: 51.9269362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025300',
        LOCATION_NAME: 'Letton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9672907,
        LOCATION_LATITUDE_DEG: 52.1120361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025400',
        LOCATION_NAME: 'Letton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9102647,
        LOCATION_LATITUDE_DEG: 52.327859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025500',
        LOCATION_NAME: 'Letty Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.135368,
        LOCATION_LATITUDE_DEG: 51.7813689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025600',
        LOCATION_NAME: 'Letwell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1556264,
        LOCATION_LATITUDE_DEG: 53.3765387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025700',
        LOCATION_NAME: 'Leuchars',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8853553,
        LOCATION_LATITUDE_DEG: 56.3824521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025900',
        LOCATION_NAME: 'Leurbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4753213,
        LOCATION_LATITUDE_DEG: 58.1432615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026000',
        LOCATION_NAME: 'Levalsa Meor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8010903,
        LOCATION_LATITUDE_DEG: 50.3086861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026100',
        LOCATION_NAME: 'Levedale',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1500265,
        LOCATION_LATITUDE_DEG: 52.7474873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026300',
        LOCATION_NAME: 'Leven',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9927741,
        LOCATION_LATITUDE_DEG: 56.1949308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026200',
        LOCATION_NAME: 'Leven',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3159914,
        LOCATION_LATITUDE_DEG: 53.8923713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026400',
        LOCATION_NAME: 'Levens',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7863388,
        LOCATION_LATITUDE_DEG: 54.2680467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026500',
        LOCATION_NAME: 'Levens Hall',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7761542,
        LOCATION_LATITUDE_DEG: 54.2572455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030900',
        LOCATION_NAME: 'Levenshulme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1877748,
        LOCATION_LATITUDE_DEG: 53.4432393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026600',
        LOCATION_NAME: 'Levenwick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2699618,
        LOCATION_LATITUDE_DEG: 59.9733925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026700',
        LOCATION_NAME: 'Leverburgh',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0083931,
        LOCATION_LATITUDE_DEG: 57.7700284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026800',
        LOCATION_NAME: 'Leverington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1384246,
        LOCATION_LATITUDE_DEG: 52.6810552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE026900',
        LOCATION_NAME: 'Leverstock Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4317267,
        LOCATION_LATITUDE_DEG: 51.7495721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027000',
        LOCATION_NAME: 'Leverton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5211433,
        LOCATION_LATITUDE_DEG: 51.4277513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027100',
        LOCATION_NAME: 'Leverton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0880513,
        LOCATION_LATITUDE_DEG: 53.0076822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027200',
        LOCATION_NAME: 'Levington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2591211,
        LOCATION_LATITUDE_DEG: 52.0039718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027300',
        LOCATION_NAME: 'Levisham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7194686,
        LOCATION_LATITUDE_DEG: 54.3041175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027400',
        LOCATION_NAME: 'Levitt Hagg',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1887457,
        LOCATION_LATITUDE_DEG: 53.500648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027500',
        LOCATION_NAME: 'Lew',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5298123,
        LOCATION_LATITUDE_DEG: 51.7554887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027600',
        LOCATION_NAME: 'Lewannick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4366811,
        LOCATION_LATITUDE_DEG: 50.5998039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027700',
        LOCATION_NAME: 'Lewdown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.193885,
        LOCATION_LATITUDE_DEG: 50.6573072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027800',
        LOCATION_NAME: 'Lewell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3696482,
        LOCATION_LATITUDE_DEG: 50.7007931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE027900',
        LOCATION_NAME: 'Lewes',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0207974,
        LOCATION_LATITUDE_DEG: 50.8738837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028000',
        LOCATION_NAME: 'Leweston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5117151,
        LOCATION_LATITUDE_DEG: 50.9226149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE031600',
        LOCATION_NAME: 'Lewis',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6714476,
        LOCATION_LATITUDE_DEG: 58.2676181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030800',
        LOCATION_NAME: 'Lewisham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0411189,
        LOCATION_LATITUDE_DEG: 51.4775909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030700',
        LOCATION_NAME: 'Lewisham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0104713,
        LOCATION_LATITUDE_DEG: 51.4613357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028100',
        LOCATION_NAME: 'Lewiston',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4782229,
        LOCATION_LATITUDE_DEG: 57.3299602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028200',
        LOCATION_NAME: 'Lewistown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5420073,
        LOCATION_LATITUDE_DEG: 51.5796912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028300',
        LOCATION_NAME: 'Lewknor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9669163,
        LOCATION_LATITUDE_DEG: 51.6714691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028400',
        LOCATION_NAME: 'Lews Castle Grounds',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3962175,
        LOCATION_LATITUDE_DEG: 58.2128728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028500',
        LOCATION_NAME: 'Lexden',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.870175,
        LOCATION_LATITUDE_DEG: 51.8904698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028600',
        LOCATION_NAME: 'Lexden Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8268976,
        LOCATION_LATITUDE_DEG: 51.8876685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028700',
        LOCATION_NAME: 'Ley',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5728555,
        LOCATION_LATITUDE_DEG: 50.4676955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028800',
        LOCATION_NAME: 'Ley Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3148711,
        LOCATION_LATITUDE_DEG: 51.9071832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE028900',
        LOCATION_NAME: 'Ley Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5665479,
        LOCATION_LATITUDE_DEG: 51.7058713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029000',
        LOCATION_NAME: 'Leybourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4205691,
        LOCATION_LATITUDE_DEG: 51.2996186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029100',
        LOCATION_NAME: 'Leyburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8270724,
        LOCATION_LATITUDE_DEG: 54.3094329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029200',
        LOCATION_NAME: 'Leycett',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3064169,
        LOCATION_LATITUDE_DEG: 53.0184187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029300',
        LOCATION_NAME: 'Leyhill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4382258,
        LOCATION_LATITUDE_DEG: 51.6252872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029400',
        LOCATION_NAME: 'Leyland',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6887,
        LOCATION_LATITUDE_DEG: 53.6964892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029500',
        LOCATION_NAME: 'Leys Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5962574,
        LOCATION_LATITUDE_DEG: 51.8752136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030100',
        LOCATION_NAME: 'Leysdown on Sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029600',
        LOCATION_NAME: 'Leysdown-on-Sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9232759,
        LOCATION_LATITUDE_DEG: 51.3969206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029700',
        LOCATION_NAME: 'Leysters',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6431926,
        LOCATION_LATITUDE_DEG: 52.2709459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE031000',
        LOCATION_NAME: 'Leyton',
        COUNTY_NAME: 'London',
        POSTCODE: 'E10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0072162,
        LOCATION_LATITUDE_DEG: 51.5591141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE031200',
        LOCATION_NAME: 'Leyton',
        COUNTY_NAME: 'London',
        POSTCODE: 'E15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0055769,
        LOCATION_LATITUDE_DEG: 51.5570087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE031100',
        LOCATION_NAME: 'Leytonstone',
        COUNTY_NAME: 'London',
        POSTCODE: 'E11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0048928,
        LOCATION_LATITUDE_DEG: 51.5595193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029800',
        LOCATION_NAME: 'Lezant',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3448402,
        LOCATION_LATITUDE_DEG: 50.5870093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029850',
        LOCATION_NAME: 'Lezayre',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4226282,
        LOCATION_LATITUDE_DEG: 54.3177958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE029900',
        LOCATION_NAME: 'Leziate',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4814758,
        LOCATION_LATITUDE_DEG: 52.7403566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LH000100',
        LOCATION_NAME: 'Lhanbryde',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2214447,
        LOCATION_LATITUDE_DEG: 57.6346831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000100',
        LOCATION_NAME: 'Libanus',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4629882,
        LOCATION_LATITUDE_DEG: 51.9198216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000200',
        LOCATION_NAME: 'Libanus Fields',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1960994,
        LOCATION_LATITUDE_DEG: 51.6578988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000300',
        LOCATION_NAME: 'Libberton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6060036,
        LOCATION_LATITUDE_DEG: 55.6688936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000400',
        LOCATION_NAME: 'Liberton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1598982,
        LOCATION_LATITUDE_DEG: 55.9140093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000500',
        LOCATION_NAME: 'Lichfield',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8208866,
        LOCATION_LATITUDE_DEG: 52.6831817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000700',
        LOCATION_NAME: 'Lickey',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0087557,
        LOCATION_LATITUDE_DEG: 52.3745501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000800',
        LOCATION_NAME: 'Lickey End',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0433451,
        LOCATION_LATITUDE_DEG: 52.3518487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000900',
        LOCATION_NAME: 'Lickfold',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6801895,
        LOCATION_LATITUDE_DEG: 51.0241036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001000',
        LOCATION_NAME: 'Lickisto',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8522365,
        LOCATION_LATITUDE_DEG: 57.8279403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001200',
        LOCATION_NAME: 'Liddeston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0462693,
        LOCATION_LATITUDE_DEG: 51.7200181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001300',
        LOCATION_NAME: 'Liddington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.702898,
        LOCATION_LATITUDE_DEG: 51.5302656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001400',
        LOCATION_NAME: 'Liddington Warren',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6699521,
        LOCATION_LATITUDE_DEG: 51.5085685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001500',
        LOCATION_NAME: 'Lidgate',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5206295,
        LOCATION_LATITUDE_DEG: 52.1906983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001600',
        LOCATION_NAME: 'Lidget Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7866422,
        LOCATION_LATITUDE_DEG: 53.7912891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI062700',
        LOCATION_NAME: 'Lidgett Park',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5189832,
        LOCATION_LATITUDE_DEG: 53.8387317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001700',
        LOCATION_NAME: 'Lidlington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5548179,
        LOCATION_LATITUDE_DEG: 52.0391017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001900',
        LOCATION_NAME: 'Lidsing',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5697423,
        LOCATION_LATITUDE_DEG: 51.3270205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002000',
        LOCATION_NAME: 'Lidstone',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4837134,
        LOCATION_LATITUDE_DEG: 51.9186993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002100',
        LOCATION_NAME: 'Lidwell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2871309,
        LOCATION_LATITUDE_DEG: 50.5466978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002200',
        LOCATION_NAME: 'Liff',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0834955,
        LOCATION_LATITUDE_DEG: 56.4858685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002400',
        LOCATION_NAME: 'Lifton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2790117,
        LOCATION_LATITUDE_DEG: 50.6426118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002500',
        LOCATION_NAME: 'Liftondown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3070206,
        LOCATION_LATITUDE_DEG: 50.644615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002600',
        LOCATION_NAME: 'Light Oaks',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.120698,
        LOCATION_LATITUDE_DEG: 53.0497143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002700',
        LOCATION_NAME: 'Lightcliffe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7756533,
        LOCATION_LATITUDE_DEG: 53.725379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002800',
        LOCATION_NAME: 'Lightfoot Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7334802,
        LOCATION_LATITUDE_DEG: 53.7959957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002900',
        LOCATION_NAME: 'Lighthill',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.304519,
        LOCATION_LATITUDE_DEG: 58.2841755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003000',
        LOCATION_NAME: 'Lighthorne',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5028408,
        LOCATION_LATITUDE_DEG: 52.1994316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003100',
        LOCATION_NAME: 'Lighthorne Heath',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4854027,
        LOCATION_LATITUDE_DEG: 52.1990241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003200',
        LOCATION_NAME: 'Lightmoor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4761099,
        LOCATION_LATITUDE_DEG: 52.6438802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003300',
        LOCATION_NAME: 'Lightpill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2299085,
        LOCATION_LATITUDE_DEG: 51.7316916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003400',
        LOCATION_NAME: 'Lightwater',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6729313,
        LOCATION_LATITUDE_DEG: 51.3494334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003550',
        LOCATION_NAME: 'Lightwood Green',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9149804,
        LOCATION_LATITUDE_DEG: 52.9633735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003500',
        LOCATION_NAME: 'Lightwood Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5464164,
        LOCATION_LATITUDE_DEG: 52.9829185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003600',
        LOCATION_NAME: 'Lightwoods',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4658763,
        LOCATION_LATITUDE_DEG: 52.8573056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003700',
        LOCATION_NAME: 'Lilbourne',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1737645,
        LOCATION_LATITUDE_DEG: 52.3871457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003800',
        LOCATION_NAME: 'Lilford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4735047,
        LOCATION_LATITUDE_DEG: 52.4434342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI003900',
        LOCATION_NAME: 'Lillesdon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.994341,
        LOCATION_LATITUDE_DEG: 51.0067314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004000',
        LOCATION_NAME: 'Lilleshall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3955676,
        LOCATION_LATITUDE_DEG: 52.7387951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004100',
        LOCATION_NAME: 'Lilley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3736212,
        LOCATION_LATITUDE_DEG: 51.9265888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004200',
        LOCATION_NAME: 'Lilliesleaf',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7346755,
        LOCATION_LATITUDE_DEG: 55.5186685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004250',
        LOCATION_NAME: 'Lilling',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9986446,
        LOCATION_LATITUDE_DEG: 54.0730838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004300',
        LOCATION_NAME: 'Lillingstone Dayrell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9771647,
        LOCATION_LATITUDE_DEG: 52.0489113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004400',
        LOCATION_NAME: 'Lillingstone Lovell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9590214,
        LOCATION_LATITUDE_DEG: 52.0577085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004600',
        LOCATION_NAME: 'Lillington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5276228,
        LOCATION_LATITUDE_DEG: 50.9125163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004500',
        LOCATION_NAME: 'Lillington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5187968,
        LOCATION_LATITUDE_DEG: 52.303142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004700',
        LOCATION_NAME: 'Lilliput',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9430011,
        LOCATION_LATITUDE_DEG: 50.7109885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004800',
        LOCATION_NAME: 'Lilstock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1873212,
        LOCATION_LATITUDE_DEG: 51.1949539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004900',
        LOCATION_NAME: 'Limavady',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9430828,
        LOCATION_LATITUDE_DEG: 55.0544562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005000',
        LOCATION_NAME: 'Limber',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.289982,
        LOCATION_LATITUDE_DEG: 53.5621398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005100',
        LOCATION_NAME: 'Limbury',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4425031,
        LOCATION_LATITUDE_DEG: 51.9044813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005200',
        LOCATION_NAME: 'Lime Tree Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5641099,
        LOCATION_LATITUDE_DEG: 52.4055486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005300',
        LOCATION_NAME: 'Limefield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2914647,
        LOCATION_LATITUDE_DEG: 53.6113768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005400',
        LOCATION_NAME: 'Limehead',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6900295,
        LOCATION_LATITUDE_DEG: 50.554608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI062100',
        LOCATION_NAME: 'Limehouse',
        COUNTY_NAME: 'London',
        POSTCODE: 'E14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0300424,
        LOCATION_LATITUDE_DEG: 51.5140277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005500',
        LOCATION_NAME: 'Limekilnburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0594426,
        LOCATION_LATITUDE_DEG: 55.7331022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005600',
        LOCATION_NAME: 'Limekilns',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4805986,
        LOCATION_LATITUDE_DEG: 56.0339257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006000',
        LOCATION_NAME: 'Limerigg',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8298494,
        LOCATION_LATITUDE_DEG: 55.9183155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006100',
        LOCATION_NAME: 'Limerstone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3730215,
        LOCATION_LATITUDE_DEG: 50.6399737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006200',
        LOCATION_NAME: 'Limington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6520711,
        LOCATION_LATITUDE_DEG: 50.9969299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006300',
        LOCATION_NAME: 'Limpenhoe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5396906,
        LOCATION_LATITUDE_DEG: 52.5781254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006400',
        LOCATION_NAME: 'Limpley Stoke',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3164648,
        LOCATION_LATITUDE_DEG: 51.347053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006500',
        LOCATION_NAME: 'Limpsfield',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0154525,
        LOCATION_LATITUDE_DEG: 51.2583223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006600',
        LOCATION_NAME: 'Limpsfield Chart',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0487934,
        LOCATION_LATITUDE_DEG: 51.2541187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006700',
        LOCATION_NAME: 'Linbrook',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7669855,
        LOCATION_LATITUDE_DEG: 50.8603066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006800',
        LOCATION_NAME: 'Linby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.201895,
        LOCATION_LATITUDE_DEG: 53.0537065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI006900',
        LOCATION_NAME: 'Linch',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7698002,
        LOCATION_LATITUDE_DEG: 51.0420075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007000',
        LOCATION_NAME: 'Linchmere',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7505073,
        LOCATION_LATITUDE_DEG: 51.0618137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007100',
        LOCATION_NAME: 'Lincoln',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5391681,
        LOCATION_LATITUDE_DEG: 53.2277165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007200',
        LOCATION_NAME: 'Lincoln Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5975397,
        LOCATION_LATITUDE_DEG: 51.8996115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007300',
        LOCATION_NAME: 'Lincomb',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2594763,
        LOCATION_LATITUDE_DEG: 52.3154449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007400',
        LOCATION_NAME: 'Lindal',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1485083,
        LOCATION_LATITUDE_DEG: 54.1718355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007500',
        LOCATION_NAME: 'Lindale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8921102,
        LOCATION_LATITUDE_DEG: 54.2159402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007600',
        LOCATION_NAME: 'Lindean',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8112716,
        LOCATION_LATITUDE_DEG: 55.5707756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007700',
        LOCATION_NAME: 'Linden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7594028,
        LOCATION_LATITUDE_DEG: 55.2638321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007800',
        LOCATION_NAME: 'Lindfield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0786385,
        LOCATION_LATITUDE_DEG: 51.0106952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI007900',
        LOCATION_NAME: 'Lindford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8432359,
        LOCATION_LATITUDE_DEG: 51.1178176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008000',
        LOCATION_NAME: 'Lindholme',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9687231,
        LOCATION_LATITUDE_DEG: 53.5425531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008100',
        LOCATION_NAME: 'Lindley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8189347,
        LOCATION_LATITUDE_DEG: 53.6567749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008200',
        LOCATION_NAME: 'Lindley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6520192,
        LOCATION_LATITUDE_DEG: 53.933629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008300',
        LOCATION_NAME: 'Lindores',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1873461,
        LOCATION_LATITUDE_DEG: 56.3387545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008400',
        LOCATION_NAME: 'Lindrick Common',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1978301,
        LOCATION_LATITUDE_DEG: 53.3363301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008500',
        LOCATION_NAME: 'Lindrick Dale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1969552,
        LOCATION_LATITUDE_DEG: 53.3325305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008700',
        LOCATION_NAME: 'Lindridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5613197,
        LOCATION_LATITUDE_DEG: 50.5684986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008600',
        LOCATION_NAME: 'Lindridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4762324,
        LOCATION_LATITUDE_DEG: 52.3169548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008800',
        LOCATION_NAME: 'Lindsell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3898092,
        LOCATION_LATITUDE_DEG: 51.916672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI008900',
        LOCATION_NAME: 'Lindsey',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8853818,
        LOCATION_LATITUDE_DEG: 52.0671817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009000',
        LOCATION_NAME: 'Lindsey Tye',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8931123,
        LOCATION_LATITUDE_DEG: 52.0738818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009100',
        LOCATION_NAME: 'Linethwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5586047,
        LOCATION_LATITUDE_DEG: 54.5100766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009200',
        LOCATION_NAME: 'Linford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.742153,
        LOCATION_LATITUDE_DEG: 50.8617023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009300',
        LOCATION_NAME: 'Linford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4094568,
        LOCATION_LATITUDE_DEG: 51.4912312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009400',
        LOCATION_NAME: 'Linford Wood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7658912,
        LOCATION_LATITUDE_DEG: 52.0564017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009500',
        LOCATION_NAME: 'Lingbob',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.858618,
        LOCATION_LATITUDE_DEG: 53.8179851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009600',
        LOCATION_NAME: 'Lingdale',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.956806,
        LOCATION_LATITUDE_DEG: 54.5376433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009700',
        LOCATION_NAME: 'Lingen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9299805,
        LOCATION_LATITUDE_DEG: 52.2980513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009800',
        LOCATION_NAME: 'Lingfield',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0120922,
        LOCATION_LATITUDE_DEG: 51.174015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI009900',
        LOCATION_NAME: 'Lingwood',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4895266,
        LOCATION_LATITUDE_DEG: 52.6228289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010000',
        LOCATION_NAME: 'Liniclate',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3455892,
        LOCATION_LATITUDE_DEG: 57.4224012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010100',
        LOCATION_NAME: 'Linicro',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.371877,
        LOCATION_LATITUDE_DEG: 57.6170112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010200',
        LOCATION_NAME: 'Linique',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3924709,
        LOCATION_LATITUDE_DEG: 57.3921996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010300',
        LOCATION_NAME: 'Linkenholt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4795684,
        LOCATION_LATITUDE_DEG: 51.3201463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010400',
        LOCATION_NAME: 'Linkinhorne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3701793,
        LOCATION_LATITUDE_DEG: 50.5356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010500',
        LOCATION_NAME: 'Linktown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1614616,
        LOCATION_LATITUDE_DEG: 56.100427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010700',
        LOCATION_NAME: 'Linley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9578352,
        LOCATION_LATITUDE_DEG: 52.5289804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010600',
        LOCATION_NAME: 'Linley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4607398,
        LOCATION_LATITUDE_DEG: 52.5821737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010800',
        LOCATION_NAME: 'Linley Brook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4708,
        LOCATION_LATITUDE_DEG: 52.5691781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI010900',
        LOCATION_NAME: 'Linlithgow',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5928096,
        LOCATION_LATITUDE_DEG: 55.9784169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011000',
        LOCATION_NAME: 'Linlithgow Bridge',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.613095,
        LOCATION_LATITUDE_DEG: 55.9763197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011200',
        LOCATION_NAME: 'Linslade',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6778336,
        LOCATION_LATITUDE_DEG: 51.915292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011300',
        LOCATION_NAME: 'Linstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4253628,
        LOCATION_LATITUDE_DEG: 52.3483006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011400',
        LOCATION_NAME: 'Linstock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8954943,
        LOCATION_LATITUDE_DEG: 54.9165111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011500',
        LOCATION_NAME: 'Linthorpe',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2476412,
        LOCATION_LATITUDE_DEG: 54.5636563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011600',
        LOCATION_NAME: 'Linthouse',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3153777,
        LOCATION_LATITUDE_DEG: 55.8667185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011700',
        LOCATION_NAME: 'Linthwaite',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8646909,
        LOCATION_LATITUDE_DEG: 53.6207704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011800',
        LOCATION_NAME: 'Lintmill',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8108822,
        LOCATION_LATITUDE_DEG: 57.6762797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012300',
        LOCATION_NAME: 'Linton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4946484,
        LOCATION_LATITUDE_DEG: 51.9253113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012000',
        LOCATION_NAME: 'Linton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.478408,
        LOCATION_LATITUDE_DEG: 52.1852395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012400',
        LOCATION_NAME: 'Linton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0038962,
        LOCATION_LATITUDE_DEG: 54.0610176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012100',
        LOCATION_NAME: 'Linton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5966354,
        LOCATION_LATITUDE_DEG: 52.7473819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012500',
        LOCATION_NAME: 'Linton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4059165,
        LOCATION_LATITUDE_DEG: 53.916295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012200',
        LOCATION_NAME: 'Linton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2794268,
        LOCATION_LATITUDE_DEG: 52.0973914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011900',
        LOCATION_NAME: 'Linton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.513013,
        LOCATION_LATITUDE_DEG: 51.2171042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012600',
        LOCATION_NAME: 'Linton Colliery',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.587114,
        LOCATION_LATITUDE_DEG: 55.2160188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012700',
        LOCATION_NAME: 'Linton on Ouse',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2456734,
        LOCATION_LATITUDE_DEG: 54.0409624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012800',
        LOCATION_NAME: 'Lintrathen',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1672183,
        LOCATION_LATITUDE_DEG: 56.6776809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI012900',
        LOCATION_NAME: 'Lintzford',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7648415,
        LOCATION_LATITUDE_DEG: 54.9097952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013200',
        LOCATION_NAME: 'Linwood',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4895253,
        LOCATION_LATITUDE_DEG: 55.8512184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013100',
        LOCATION_NAME: 'Linwood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7340757,
        LOCATION_LATITUDE_DEG: 50.882702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013000',
        LOCATION_NAME: 'Linwood',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3281644,
        LOCATION_LATITUDE_DEG: 53.3645262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013300',
        LOCATION_NAME: 'Lionel',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2527636,
        LOCATION_LATITUDE_DEG: 58.4940918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013400',
        LOCATION_NAME: 'Lions Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2228084,
        LOCATION_LATITUDE_DEG: 50.941089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013500',
        LOCATION_NAME: 'Liphook',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8016544,
        LOCATION_LATITUDE_DEG: 51.0769099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013600',
        LOCATION_NAME: 'Lipley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3868773,
        LOCATION_LATITUDE_DEG: 52.8764063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013700',
        LOCATION_NAME: 'Lipson',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1241138,
        LOCATION_LATITUDE_DEG: 50.3761869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013900',
        LOCATION_NAME: 'Lisahoppin',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2322735,
        LOCATION_LATITUDE_DEG: 54.5756279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI990285',
        LOCATION_NAME: 'Lisbane Road',
        COUNTY_NAME: 'County Down',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6931956,
        LOCATION_LATITUDE_DEG: 54.5075318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014100',
        LOCATION_NAME: 'Lisbellaw',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5208766,
        LOCATION_LATITUDE_DEG: 54.3181849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014300',
        LOCATION_NAME: 'Lisboy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.212657,
        LOCATION_LATITUDE_DEG: 54.5747577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014400',
        LOCATION_NAME: 'Lisburn',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0485978,
        LOCATION_LATITUDE_DEG: 54.5128058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015000',
        LOCATION_NAME: 'Liscolman',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3384186,
        LOCATION_LATITUDE_DEG: 55.1201634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016500',
        LOCATION_NAME: 'Liskeard',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.461445,
        LOCATION_LATITUDE_DEG: 50.4547958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016800',
        LOCATION_NAME: 'Lislea',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2842508,
        LOCATION_LATITUDE_DEG: 54.7462078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016700',
        LOCATION_NAME: 'Lislea',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7279856,
        LOCATION_LATITUDE_DEG: 54.2555837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016850',
        LOCATION_NAME: 'Lislea',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4582405,
        LOCATION_LATITUDE_DEG: 54.1606252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017000',
        LOCATION_NAME: 'Lislimnaghan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3425179,
        LOCATION_LATITUDE_DEG: 54.6295547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017300',
        LOCATION_NAME: 'Lismore',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5028803,
        LOCATION_LATITUDE_DEG: 56.515093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017500',
        LOCATION_NAME: 'Lisnacree',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0926154,
        LOCATION_LATITUDE_DEG: 54.0757549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017600',
        LOCATION_NAME: 'Lisnacreight',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2377892,
        LOCATION_LATITUDE_DEG: 54.7524229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018000',
        LOCATION_NAME: 'Lisnaharney',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2754887,
        LOCATION_LATITUDE_DEG: 54.692813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI990771',
        LOCATION_NAME: 'Lisnamonaghan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018175',
        LOCATION_NAME: 'Lisnarick',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7041682,
        LOCATION_LATITUDE_DEG: 54.481607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI990080',
        LOCATION_NAME: 'LISNARRICK',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018200',
        LOCATION_NAME: 'Lisnaskea',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4483601,
        LOCATION_LATITUDE_DEG: 54.2563849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018900',
        LOCATION_NAME: 'Liss',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8924716,
        LOCATION_LATITUDE_DEG: 51.0433064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019000',
        LOCATION_NAME: 'Liss Forest',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8972343,
        LOCATION_LATITUDE_DEG: 51.048208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019300',
        LOCATION_NAME: 'Lissan',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7816616,
        LOCATION_LATITUDE_DEG: 54.6847281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019900',
        LOCATION_NAME: 'Lissett',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2527354,
        LOCATION_LATITUDE_DEG: 54.0046881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020000',
        LOCATION_NAME: 'Lissington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3342527,
        LOCATION_LATITUDE_DEG: 53.3352205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020500',
        LOCATION_NAME: 'Listerhills',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7684906,
        LOCATION_LATITUDE_DEG: 53.7930892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020700',
        LOCATION_NAME: 'Liston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.702542,
        LOCATION_LATITUDE_DEG: 52.0682902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021100',
        LOCATION_NAME: 'Lisvane',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1653614,
        LOCATION_LATITUDE_DEG: 51.5394852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021300',
        LOCATION_NAME: 'Liswerry',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9483806,
        LOCATION_LATITUDE_DEG: 51.5788853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021400',
        LOCATION_NAME: 'Litcham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.793133,
        LOCATION_LATITUDE_DEG: 52.7238439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021500',
        LOCATION_NAME: 'Litchard',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5718431,
        LOCATION_LATITUDE_DEG: 51.5185913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021600',
        LOCATION_NAME: 'Litchborough',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.074912,
        LOCATION_LATITUDE_DEG: 52.1828166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021650',
        LOCATION_NAME: 'Litchfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3403308,
        LOCATION_LATITUDE_DEG: 51.2839317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061900',
        LOCATION_NAME: 'Litherland',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9961835,
        LOCATION_LATITUDE_DEG: 53.4736377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021800',
        LOCATION_NAME: 'Litlington',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0868163,
        LOCATION_LATITUDE_DEG: 52.0667926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021700',
        LOCATION_NAME: 'Litlington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1610957,
        LOCATION_LATITUDE_DEG: 50.793969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021900',
        LOCATION_NAME: 'Little Abington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2414226,
        LOCATION_LATITUDE_DEG: 52.1208014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022000',
        LOCATION_NAME: 'Little Addington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5933666,
        LOCATION_LATITUDE_DEG: 52.3507314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022100',
        LOCATION_NAME: 'Little Airmyn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9030073,
        LOCATION_LATITUDE_DEG: 53.7192642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022200',
        LOCATION_NAME: 'Little Alne',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7932105,
        LOCATION_LATITUDE_DEG: 52.2488333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022300',
        LOCATION_NAME: 'Little Altcar',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0499692,
        LOCATION_LATITUDE_DEG: 53.5507779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022400',
        LOCATION_NAME: 'Little Amwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0316906,
        LOCATION_LATITUDE_DEG: 51.782871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022500',
        LOCATION_NAME: 'Little Ann',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5191583,
        LOCATION_LATITUDE_DEG: 51.1902325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022600',
        LOCATION_NAME: 'Little Arowry',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8099162,
        LOCATION_LATITUDE_DEG: 52.9594157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022700',
        LOCATION_NAME: 'Little Arrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0909034,
        LOCATION_LATITUDE_DEG: 54.3452534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022800',
        LOCATION_NAME: 'Little Asby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4681811,
        LOCATION_LATITUDE_DEG: 54.479856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI022900',
        LOCATION_NAME: 'Little Ashley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2662647,
        LOCATION_LATITUDE_DEG: 51.3598576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023000',
        LOCATION_NAME: 'Little Aston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8592971,
        LOCATION_LATITUDE_DEG: 52.5987742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023100',
        LOCATION_NAME: 'Little Ayton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.127117,
        LOCATION_LATITUDE_DEG: 54.4862758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023200',
        LOCATION_NAME: 'Little Baddow',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5789593,
        LOCATION_LATITUDE_DEG: 51.7353576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023300',
        LOCATION_NAME: 'Little Badminton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2871469,
        LOCATION_LATITUDE_DEG: 51.5543722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023400',
        LOCATION_NAME: 'Little Baldon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1754049,
        LOCATION_LATITUDE_DEG: 51.6805725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023500',
        LOCATION_NAME: 'Little Bampton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1331863,
        LOCATION_LATITUDE_DEG: 54.8860085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023600',
        LOCATION_NAME: 'Little Bardfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4151783,
        LOCATION_LATITUDE_DEG: 51.9508788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023700',
        LOCATION_NAME: 'Little Barford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2725135,
        LOCATION_LATITUDE_DEG: 52.1973104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023800',
        LOCATION_NAME: 'Little Barningham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1776954,
        LOCATION_LATITUDE_DEG: 52.8543563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI023900',
        LOCATION_NAME: 'Little Barrington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.700728,
        LOCATION_LATITUDE_DEG: 51.8122937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024000',
        LOCATION_NAME: 'Little Barugh',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8324647,
        LOCATION_LATITUDE_DEG: 54.2071142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024100',
        LOCATION_NAME: 'Little Bealings',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2547606,
        LOCATION_LATITUDE_DEG: 52.0839789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024200',
        LOCATION_NAME: 'Little Bedwyn',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5809882,
        LOCATION_LATITUDE_DEG: 51.3913532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024300',
        LOCATION_NAME: 'Little Belvoir',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9376464,
        LOCATION_LATITUDE_DEG: 52.807281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024400',
        LOCATION_NAME: 'Little Bentley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0770774,
        LOCATION_LATITUDE_DEG: 51.8897616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024500',
        LOCATION_NAME: 'Little Berkhamsted',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1282812,
        LOCATION_LATITUDE_DEG: 51.7546633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024600',
        LOCATION_NAME: 'Little Beside',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1739216,
        LOCATION_LATITUDE_DEG: 50.2428845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024700',
        LOCATION_NAME: 'Little Billing',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8173379,
        LOCATION_LATITUDE_DEG: 52.2495285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024800',
        LOCATION_NAME: 'Little Billington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.641988,
        LOCATION_LATITUDE_DEG: 51.8921868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI024900',
        LOCATION_NAME: 'Little Birch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7102267,
        LOCATION_LATITUDE_DEG: 51.9820175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025000',
        LOCATION_NAME: 'Little Blakenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0766693,
        LOCATION_LATITUDE_DEG: 52.0961868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025100',
        LOCATION_NAME: 'Little Bolas',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5287991,
        LOCATION_LATITUDE_DEG: 52.7927953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025200',
        LOCATION_NAME: 'Little Bollington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4080272,
        LOCATION_LATITUDE_DEG: 53.3739551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025300',
        LOCATION_NAME: 'Little Bookham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3817474,
        LOCATION_LATITUDE_DEG: 51.2662241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025400',
        LOCATION_NAME: 'Little Bourton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3321386,
        LOCATION_LATITUDE_DEG: 52.0933145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025500',
        LOCATION_NAME: 'Little Bradley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4576563,
        LOCATION_LATITUDE_DEG: 52.1409982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025600',
        LOCATION_NAME: 'Little Braxted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6657994,
        LOCATION_LATITUDE_DEG: 51.7994643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025700',
        LOCATION_NAME: 'Little Brechin',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6837238,
        LOCATION_LATITUDE_DEG: 56.7548871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025800',
        LOCATION_NAME: 'Little Brickhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6751797,
        LOCATION_LATITUDE_DEG: 51.9826961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI025900',
        LOCATION_NAME: 'Little Bridgeford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1827879,
        LOCATION_LATITUDE_DEG: 52.8438019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026000',
        LOCATION_NAME: 'Little Brington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.028633,
        LOCATION_LATITUDE_DEG: 52.26783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026100',
        LOCATION_NAME: 'Little Brockton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0162473,
        LOCATION_LATITUDE_DEG: 52.6304897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026200',
        LOCATION_NAME: 'Little Bromley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0474862,
        LOCATION_LATITUDE_DEG: 51.919271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026300',
        LOCATION_NAME: 'Little Broughton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4305307,
        LOCATION_LATITUDE_DEG: 54.6714886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026400',
        LOCATION_NAME: 'Little Buckland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8935589,
        LOCATION_LATITUDE_DEG: 52.0278196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026500',
        LOCATION_NAME: 'Little Budworth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6002678,
        LOCATION_LATITUDE_DEG: 53.1836354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026600',
        LOCATION_NAME: 'Little Burstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4098868,
        LOCATION_LATITUDE_DEG: 51.6044418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026700',
        LOCATION_NAME: 'Little Busby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2197109,
        LOCATION_LATITUDE_DEG: 54.4394418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026800',
        LOCATION_NAME: 'Little Bytham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.49662,
        LOCATION_LATITUDE_DEG: 52.75057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI026900',
        LOCATION_NAME: 'Little Canfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2945568,
        LOCATION_LATITUDE_DEG: 51.8506754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027000',
        LOCATION_NAME: 'Little Carlton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8409581,
        LOCATION_LATITUDE_DEG: 53.1083046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027100',
        LOCATION_NAME: 'Little Carlton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1023174,
        LOCATION_LATITUDE_DEG: 53.3470184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027200',
        LOCATION_NAME: 'Little Casterton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4935468,
        LOCATION_LATITUDE_DEG: 52.6759647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027300',
        LOCATION_NAME: 'Little Catworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3830569,
        LOCATION_LATITUDE_DEG: 52.34153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027400',
        LOCATION_NAME: 'Little Cawthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0379914,
        LOCATION_LATITUDE_DEG: 53.3325167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027500',
        LOCATION_NAME: 'Little Chalfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2112189,
        LOCATION_LATITUDE_DEG: 51.3685579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027600',
        LOCATION_NAME: 'Little Chalfont',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5643151,
        LOCATION_LATITUDE_DEG: 51.6666621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027700',
        LOCATION_NAME: 'Little Chart',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7811976,
        LOCATION_LATITUDE_DEG: 51.178696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027800',
        LOCATION_NAME: 'Little Chesterford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2102366,
        LOCATION_LATITUDE_DEG: 52.0532935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI027900',
        LOCATION_NAME: 'Little Chesterton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1903369,
        LOCATION_LATITUDE_DEG: 51.8779941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028000',
        LOCATION_NAME: 'Little Cheverell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0154289,
        LOCATION_LATITUDE_DEG: 51.2805461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028100',
        LOCATION_NAME: 'Little Chishill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0680869,
        LOCATION_LATITUDE_DEG: 52.0142907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028200',
        LOCATION_NAME: 'Little Clacton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.143605,
        LOCATION_LATITUDE_DEG: 51.8248555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028300',
        LOCATION_NAME: 'Little Clanfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6070487,
        LOCATION_LATITUDE_DEG: 51.7093815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028400',
        LOCATION_NAME: 'Little Clifton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4639246,
        LOCATION_LATITUDE_DEG: 54.6430899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028500',
        LOCATION_NAME: 'Little Coate',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9640849,
        LOCATION_LATITUDE_DEG: 51.3480505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028600',
        LOCATION_NAME: 'Little Comberton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0490263,
        LOCATION_LATITUDE_DEG: 52.0848196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028700',
        LOCATION_NAME: 'Little Common',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4372514,
        LOCATION_LATITUDE_DEG: 50.8469742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028800',
        LOCATION_NAME: 'Little Compton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6153228,
        LOCATION_LATITUDE_DEG: 51.96891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI028900',
        LOCATION_NAME: 'Little Corby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8139868,
        LOCATION_LATITUDE_DEG: 54.9072069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029000',
        LOCATION_NAME: 'Little Cornard',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7709964,
        LOCATION_LATITUDE_DEG: 52.0179778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029100',
        LOCATION_NAME: 'Little Cowarne',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5780107,
        LOCATION_LATITUDE_DEG: 52.1545369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029200',
        LOCATION_NAME: 'Little Coxwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5953406,
        LOCATION_LATITUDE_DEG: 51.6377721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029300',
        LOCATION_NAME: 'Little Crakehall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6295825,
        LOCATION_LATITUDE_DEG: 54.3075321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029400',
        LOCATION_NAME: 'Little Cransley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7699031,
        LOCATION_LATITUDE_DEG: 52.3785344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029500',
        LOCATION_NAME: 'Little Crawley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6548667,
        LOCATION_LATITUDE_DEG: 52.0982055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029600',
        LOCATION_NAME: 'Little Cressingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7642068,
        LOCATION_LATITUDE_DEG: 52.563835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI062000',
        LOCATION_NAME: 'Little Crosby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0239942,
        LOCATION_LATITUDE_DEG: 53.5065754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029700',
        LOCATION_NAME: 'Little Cumberwell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2615141,
        LOCATION_LATITUDE_DEG: 51.3630608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029800',
        LOCATION_NAME: 'Little Dalby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8510097,
        LOCATION_LATITUDE_DEG: 52.7195662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI029900',
        LOCATION_NAME: 'Little Dassett',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4283101,
        LOCATION_LATITUDE_DEG: 52.1632266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030000',
        LOCATION_NAME: 'Little Dawley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4666973,
        LOCATION_LATITUDE_DEG: 52.652486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030100',
        LOCATION_NAME: 'Little Dewchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6819458,
        LOCATION_LATITUDE_DEG: 51.982922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030200',
        LOCATION_NAME: 'Little Doward',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6764225,
        LOCATION_LATITUDE_DEG: 51.8433077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030300',
        LOCATION_NAME: 'Little Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4976459,
        LOCATION_LATITUDE_DEG: 51.3193439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030400',
        LOCATION_NAME: 'Little Downham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2423758,
        LOCATION_LATITUDE_DEG: 52.4324282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030500',
        LOCATION_NAME: 'Little Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6345655,
        LOCATION_LATITUDE_DEG: 50.4740956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030600',
        LOCATION_NAME: 'Little Driffield',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.458814,
        LOCATION_LATITUDE_DEG: 54.0088918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030700',
        LOCATION_NAME: 'Little Drybrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5887989,
        LOCATION_LATITUDE_DEG: 51.7590009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030800',
        LOCATION_NAME: 'Little Dunham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7615377,
        LOCATION_LATITUDE_DEG: 52.6795452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI030900',
        LOCATION_NAME: 'Little Dunkeld',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5758803,
        LOCATION_LATITUDE_DEG: 56.558876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031000',
        LOCATION_NAME: 'Little Dunmow',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4058512,
        LOCATION_LATITUDE_DEG: 51.8660698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031100',
        LOCATION_NAME: 'Little Durnford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8188892,
        LOCATION_LATITUDE_DEG: 51.1106284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031200',
        LOCATION_NAME: 'Little Easton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3371825,
        LOCATION_LATITUDE_DEG: 51.8921783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031300',
        LOCATION_NAME: 'Little Eaton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4587924,
        LOCATION_LATITUDE_DEG: 52.9689983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031400',
        LOCATION_NAME: 'Little Eccleston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8805925,
        LOCATION_LATITUDE_DEG: 53.8583083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031500',
        LOCATION_NAME: 'Little Ellingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9576487,
        LOCATION_LATITUDE_DEG: 52.5526276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031600',
        LOCATION_NAME: 'Little End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2283515,
        LOCATION_LATITUDE_DEG: 51.6797556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031700',
        LOCATION_NAME: 'Little Ensdon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8684279,
        LOCATION_LATITUDE_DEG: 52.7539964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031800',
        LOCATION_NAME: 'Little Eriswell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5350828,
        LOCATION_LATITUDE_DEG: 52.391915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI031900',
        LOCATION_NAME: 'Little Everdon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1295653,
        LOCATION_LATITUDE_DEG: 52.2171222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032000',
        LOCATION_NAME: 'Little Eversden',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0083299,
        LOCATION_LATITUDE_DEG: 52.1612086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032100',
        LOCATION_NAME: 'Little Faringdon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6715172,
        LOCATION_LATITUDE_DEG: 51.7094805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032200',
        LOCATION_NAME: 'Little Fencote',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5698083,
        LOCATION_LATITUDE_DEG: 54.3323392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032300',
        LOCATION_NAME: 'Little Fenton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2086849,
        LOCATION_LATITUDE_DEG: 53.8097772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032400',
        LOCATION_NAME: 'Little Finborough',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9536158,
        LOCATION_LATITUDE_DEG: 52.1531866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032500',
        LOCATION_NAME: 'Little Fransham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8120284,
        LOCATION_LATITUDE_DEG: 52.6710455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032600',
        LOCATION_NAME: 'Little Frieth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.859073,
        LOCATION_LATITUDE_DEG: 51.6032595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032800',
        LOCATION_NAME: 'Little Gaddesden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5524764,
        LOCATION_LATITUDE_DEG: 51.8042777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032900',
        LOCATION_NAME: 'Little Gayton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1499444,
        LOCATION_LATITUDE_DEG: 53.3578233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033000',
        LOCATION_NAME: 'Little Gidding',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3375199,
        LOCATION_LATITUDE_DEG: 52.4239311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033100',
        LOCATION_NAME: 'Little Glemham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4244719,
        LOCATION_LATITUDE_DEG: 52.1734835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033200',
        LOCATION_NAME: 'Little Gransden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1405083,
        LOCATION_LATITUDE_DEG: 52.1806096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033300',
        LOCATION_NAME: 'Little Grimsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0031476,
        LOCATION_LATITUDE_DEG: 53.4042252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033400',
        LOCATION_NAME: 'Little Gringley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9002739,
        LOCATION_LATITUDE_DEG: 53.3193317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033500',
        LOCATION_NAME: 'Little Habton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8516263,
        LOCATION_LATITUDE_DEG: 54.1830101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033600',
        LOCATION_NAME: 'Little Hadham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0920507,
        LOCATION_LATITUDE_DEG: 51.8839778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033700',
        LOCATION_NAME: 'Little Hale',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2948498,
        LOCATION_LATITUDE_DEG: 52.9608855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033800',
        LOCATION_NAME: 'Little Hale Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2590241,
        LOCATION_LATITUDE_DEG: 52.9452874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI033900',
        LOCATION_NAME: 'Little Hales',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3733847,
        LOCATION_LATITUDE_DEG: 52.7430926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034000',
        LOCATION_NAME: 'Little Hallingbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1811963,
        LOCATION_LATITUDE_DEG: 51.8350707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034100',
        LOCATION_NAME: 'Little Hampden',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.755619,
        LOCATION_LATITUDE_DEG: 51.7255708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034200',
        LOCATION_NAME: 'Little Harrowden',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7236512,
        LOCATION_LATITUDE_DEG: 52.3341282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034300',
        LOCATION_NAME: 'Little Harwood',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4668925,
        LOCATION_LATITUDE_DEG: 53.7603935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034400',
        LOCATION_NAME: 'Little Haseley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0712319,
        LOCATION_LATITUDE_DEG: 51.7006756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034500',
        LOCATION_NAME: 'Little Hatfield',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2148436,
        LOCATION_LATITUDE_DEG: 53.8722728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034600',
        LOCATION_NAME: 'Little Hatford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5114418,
        LOCATION_LATITUDE_DEG: 51.6464724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034700',
        LOCATION_NAME: 'Little Hatherden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4984413,
        LOCATION_LATITUDE_DEG: 51.2516397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034800',
        LOCATION_NAME: 'Little Hautbois',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3374902,
        LOCATION_LATITUDE_DEG: 52.7465386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI034900',
        LOCATION_NAME: 'Little Haven',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1053435,
        LOCATION_LATITUDE_DEG: 51.7734311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035000',
        LOCATION_NAME: 'Little Hay',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8204643,
        LOCATION_LATITUDE_DEG: 52.6201738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035100',
        LOCATION_NAME: 'Little Hayfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9486448,
        LOCATION_LATITUDE_DEG: 53.3899507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035200',
        LOCATION_NAME: 'Little Haywood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9927033,
        LOCATION_LATITUDE_DEG: 52.7907906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035300',
        LOCATION_NAME: 'Little Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5271403,
        LOCATION_LATITUDE_DEG: 51.765375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035400',
        LOCATION_NAME: 'Little Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1253184,
        LOCATION_LATITUDE_DEG: 51.5821502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035500',
        LOCATION_NAME: 'Little Heck',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0947562,
        LOCATION_LATITUDE_DEG: 53.6912639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035600',
        LOCATION_NAME: 'Little Henham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.232402,
        LOCATION_LATITUDE_DEG: 51.9497843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035700',
        LOCATION_NAME: 'Little Hereford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6557019,
        LOCATION_LATITUDE_DEG: 52.3101517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035800',
        LOCATION_NAME: 'Little Holtby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5771559,
        LOCATION_LATITUDE_DEG: 54.3207343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI035900',
        LOCATION_NAME: 'Little Honeyborough',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.966971,
        LOCATION_LATITUDE_DEG: 51.7179201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036000',
        LOCATION_NAME: 'Little Hoole',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7766211,
        LOCATION_LATITUDE_DEG: 53.7123931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036100',
        LOCATION_NAME: 'Little Horkesley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8550819,
        LOCATION_LATITUDE_DEG: 51.9522698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036200',
        LOCATION_NAME: 'Little Hormead',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0369711,
        LOCATION_LATITUDE_DEG: 51.9417817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036300',
        LOCATION_NAME: 'Little Horsted',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0934288,
        LOCATION_LATITUDE_DEG: 50.9455857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036400',
        LOCATION_NAME: 'Little Horton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9382913,
        LOCATION_LATITUDE_DEG: 51.3606565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI062500',
        LOCATION_NAME: 'Little Horton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7603908,
        LOCATION_LATITUDE_DEG: 53.7838146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI062400',
        LOCATION_NAME: 'Little Horton Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7650269,
        LOCATION_LATITUDE_DEG: 53.7853429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036500',
        LOCATION_NAME: 'Little Horwood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.847688,
        LOCATION_LATITUDE_DEG: 51.9681986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036700',
        LOCATION_NAME: 'Little Houghton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3592956,
        LOCATION_LATITUDE_DEG: 53.5451575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036600',
        LOCATION_NAME: 'Little Houghton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8236393,
        LOCATION_LATITUDE_DEG: 52.2295216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036800',
        LOCATION_NAME: 'Little Hucklow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7576977,
        LOCATION_LATITUDE_DEG: 53.303936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI036900',
        LOCATION_NAME: 'Little Hulton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4255104,
        LOCATION_LATITUDE_DEG: 53.5276703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037000',
        LOCATION_NAME: 'Little Humby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5084867,
        LOCATION_LATITUDE_DEG: 52.881984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037100',
        LOCATION_NAME: 'Little Ickford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0526411,
        LOCATION_LATITUDE_DEG: 51.7585823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061700',
        LOCATION_NAME: 'Little in Sight',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037200',
        LOCATION_NAME: 'Little Inkberrow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9901334,
        LOCATION_LATITUDE_DEG: 52.2171395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037300',
        LOCATION_NAME: 'Little Irchester',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6752808,
        LOCATION_LATITUDE_DEG: 52.2871257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037400',
        LOCATION_NAME: 'Little Ireland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8220702,
        LOCATION_LATITUDE_DEG: 51.2201504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037600',
        LOCATION_NAME: 'Little Isle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5861233,
        LOCATION_LATITUDE_DEG: 52.3645554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037700',
        LOCATION_NAME: 'Little Kelk',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3234721,
        LOCATION_LATITUDE_DEG: 54.0258869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037800',
        LOCATION_NAME: 'Little Keyford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3240271,
        LOCATION_LATITUDE_DEG: 51.2158443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037900',
        LOCATION_NAME: 'Little Kimble',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8068724,
        LOCATION_LATITUDE_DEG: 51.7549776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038000',
        LOCATION_NAME: 'Little Kineton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5126822,
        LOCATION_LATITUDE_DEG: 52.1505226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038100',
        LOCATION_NAME: 'Little Kingshill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7006125,
        LOCATION_LATITUDE_DEG: 51.6819722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038200',
        LOCATION_NAME: 'Little Langdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0545839,
        LOCATION_LATITUDE_DEG: 54.4211616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038300',
        LOCATION_NAME: 'Little Langford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9290853,
        LOCATION_LATITUDE_DEG: 51.1268268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038400',
        LOCATION_NAME: 'Little Larkhill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.13449,
        LOCATION_LATITUDE_DEG: 51.6438866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038500',
        LOCATION_NAME: 'Little Laver',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.241219,
        LOCATION_LATITUDE_DEG: 51.7609672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038600',
        LOCATION_NAME: 'Little Lawford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3105044,
        LOCATION_LATITUDE_DEG: 52.3909445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038700',
        LOCATION_NAME: 'Little Leigh',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5739314,
        LOCATION_LATITUDE_DEG: 53.279149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038800',
        LOCATION_NAME: 'Little Leighs',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4942267,
        LOCATION_LATITUDE_DEG: 51.8230629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI038900',
        LOCATION_NAME: 'Little Lever',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.371732,
        LOCATION_LATITUDE_DEG: 53.5628725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039000',
        LOCATION_NAME: 'Little Linford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7705942,
        LOCATION_LATITUDE_DEG: 52.0907109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039100',
        LOCATION_NAME: 'Little Livermere',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7531057,
        LOCATION_LATITUDE_DEG: 52.3196083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039200',
        LOCATION_NAME: 'Little London',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4294657,
        LOCATION_LATITUDE_DEG: 51.863109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039400',
        LOCATION_NAME: 'Little London',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6932509,
        LOCATION_LATITUDE_DEG: 51.6933802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039700',
        LOCATION_NAME: 'Little London',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4581194,
        LOCATION_LATITUDE_DEG: 51.2452369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039500',
        LOCATION_NAME: 'Little London',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1017124,
        LOCATION_LATITUDE_DEG: 51.330538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039300',
        LOCATION_NAME: 'Little London',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2052954,
        LOCATION_LATITUDE_DEG: 53.5906489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039600',
        LOCATION_NAME: 'Little London',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2357903,
        LOCATION_LATITUDE_DEG: 50.9555835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039800',
        LOCATION_NAME: 'Little Longstone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7224812,
        LOCATION_LATITUDE_DEG: 53.2403281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI039900',
        LOCATION_NAME: 'Little Malvern',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3361079,
        LOCATION_LATITUDE_DEG: 52.0617277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040000',
        LOCATION_NAME: 'Little Maplestead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6714899,
        LOCATION_LATITUDE_DEG: 51.9778796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040100',
        LOCATION_NAME: 'Little Marcle',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.481071,
        LOCATION_LATITUDE_DEG: 52.026526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040200',
        LOCATION_NAME: 'Little Marlow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7402857,
        LOCATION_LATITUDE_DEG: 51.5852552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040300',
        LOCATION_NAME: 'Little Massingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6606024,
        LOCATION_LATITUDE_DEG: 52.7845577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040400',
        LOCATION_NAME: 'Little Melton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1968208,
        LOCATION_LATITUDE_DEG: 52.6162296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040500',
        LOCATION_NAME: 'Little Mill',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9816215,
        LOCATION_LATITUDE_DEG: 51.7208027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040600',
        LOCATION_NAME: 'Little Mill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6410839,
        LOCATION_LATITUDE_DEG: 55.4559479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040700',
        LOCATION_NAME: 'Little Milton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1054063,
        LOCATION_LATITUDE_DEG: 51.7003743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040800',
        LOCATION_NAME: 'Little Minsterley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9150414,
        LOCATION_LATITUDE_DEG: 52.6411868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI040900',
        LOCATION_NAME: 'Little Missenden',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6666195,
        LOCATION_LATITUDE_DEG: 51.6813664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041000',
        LOCATION_NAME: 'Little Mongeham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3416719,
        LOCATION_LATITUDE_DEG: 51.2091949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041100',
        LOCATION_NAME: 'Little Mosterley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6546096,
        LOCATION_LATITUDE_DEG: 52.6222865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041200',
        LOCATION_NAME: 'Little Munden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0382849,
        LOCATION_LATITUDE_DEG: 51.8677786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041300',
        LOCATION_NAME: 'Little Musgrave',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.37014,
        LOCATION_LATITUDE_DEG: 54.5127595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041400',
        LOCATION_NAME: 'Little Ness',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8781797,
        LOCATION_LATITUDE_DEG: 52.7709982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041500',
        LOCATION_NAME: 'Little Neston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0681368,
        LOCATION_LATITUDE_DEG: 53.2808529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041600',
        LOCATION_NAME: 'Little Newcastle',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9368474,
        LOCATION_LATITUDE_DEG: 51.9226435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041700',
        LOCATION_NAME: 'Little Newsham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8103726,
        LOCATION_LATITUDE_DEG: 54.5545577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041800',
        LOCATION_NAME: 'Little Oakley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6843505,
        LOCATION_LATITUDE_DEG: 52.4623418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI041900',
        LOCATION_NAME: 'Little Oakley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.224439,
        LOCATION_LATITUDE_DEG: 51.9154607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042000',
        LOCATION_NAME: 'Little Offley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3549778,
        LOCATION_LATITUDE_DEG: 51.9427864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042100',
        LOCATION_NAME: 'Little Onn',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2375321,
        LOCATION_LATITUDE_DEG: 52.7424894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042200',
        LOCATION_NAME: 'Little Orton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0125298,
        LOCATION_LATITUDE_DEG: 54.8867055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042300',
        LOCATION_NAME: 'Little Ouse',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3872152,
        LOCATION_LATITUDE_DEG: 52.4768322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042400',
        LOCATION_NAME: 'Little Ouseburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3147583,
        LOCATION_LATITUDE_DEG: 54.040504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042500',
        LOCATION_NAME: 'Little Owston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1614381,
        LOCATION_LATITUDE_DEG: 53.5885584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042600',
        LOCATION_NAME: 'Little Oxendon',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9286594,
        LOCATION_LATITUDE_DEG: 52.4483436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042700',
        LOCATION_NAME: 'Little Padfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9518129,
        LOCATION_LATITUDE_DEG: 53.4608528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042800',
        LOCATION_NAME: 'Little Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5221505,
        LOCATION_LATITUDE_DEG: 51.1984284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI042900',
        LOCATION_NAME: 'Little Parndon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0798325,
        LOCATION_LATITUDE_DEG: 51.7750686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043000',
        LOCATION_NAME: 'Little Paxton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2568074,
        LOCATION_LATITUDE_DEG: 52.2501168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043100',
        LOCATION_NAME: 'Little Petherick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9418696,
        LOCATION_LATITUDE_DEG: 50.5125017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043200',
        LOCATION_NAME: 'Little Plealey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8649348,
        LOCATION_LATITUDE_DEG: 52.6523883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043300',
        LOCATION_NAME: 'Little Plumpton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9394008,
        LOCATION_LATITUDE_DEG: 53.7865949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043400',
        LOCATION_NAME: 'Little Plumstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4217867,
        LOCATION_LATITUDE_DEG: 52.6565324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043500',
        LOCATION_NAME: 'Little Polgooth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8132835,
        LOCATION_LATITUDE_DEG: 50.3124848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043600',
        LOCATION_NAME: 'Little Ponton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6248085,
        LOCATION_LATITUDE_DEG: 52.8785778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043700',
        LOCATION_NAME: 'Little Porth',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3165334,
        LOCATION_LATITUDE_DEG: 49.9121617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043800',
        LOCATION_NAME: 'Little Preston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1406546,
        LOCATION_LATITUDE_DEG: 52.1803195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI991113',
        LOCATION_NAME: 'Little Preston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3988,
        LOCATION_LATITUDE_DEG: 53.7624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI043900',
        LOCATION_NAME: 'Little Raveley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1537383,
        LOCATION_LATITUDE_DEG: 52.4026256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044000',
        LOCATION_NAME: 'Little Redbourne',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.531772,
        LOCATION_LATITUDE_DEG: 53.487236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044100',
        LOCATION_NAME: 'Little Reedness',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7709336,
        LOCATION_LATITUDE_DEG: 53.6938626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044200',
        LOCATION_NAME: 'Little Ribston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4112118,
        LOCATION_LATITUDE_DEG: 53.9738952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044300',
        LOCATION_NAME: 'Little Rissington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7206062,
        LOCATION_LATITUDE_DEG: 51.8750978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044400',
        LOCATION_NAME: 'Little Rollright',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5791699,
        LOCATION_LATITUDE_DEG: 51.9726079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044500',
        LOCATION_NAME: 'Little Ryburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9192433,
        LOCATION_LATITUDE_DEG: 52.8154537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044600',
        LOCATION_NAME: 'Little Salisbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7372673,
        LOCATION_LATITUDE_DEG: 51.3450456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044700',
        LOCATION_NAME: 'Little Salkeld',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6730835,
        LOCATION_LATITUDE_DEG: 54.7180869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044800',
        LOCATION_NAME: 'Little Sampford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4063336,
        LOCATION_LATITUDE_DEG: 51.976782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI044900',
        LOCATION_NAME: 'Little Sandhurst',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'GU47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8054771,
        LOCATION_LATITUDE_DEG: 51.3498348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045000',
        LOCATION_NAME: 'Little Saredon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0766862,
        LOCATION_LATITUDE_DEG: 52.6623798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045100',
        LOCATION_NAME: 'Little Saxham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6359578,
        LOCATION_LATITUDE_DEG: 52.2415997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045200',
        LOCATION_NAME: 'Little Shelford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.120802,
        LOCATION_LATITUDE_DEG: 52.1423055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045300',
        LOCATION_NAME: 'Little Shoddesden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5952523,
        LOCATION_LATITUDE_DEG: 51.2358361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045400',
        LOCATION_NAME: 'Little Shrewley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6685375,
        LOCATION_LATITUDE_DEG: 52.3028389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045500',
        LOCATION_NAME: 'Little Shurdington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1203489,
        LOCATION_LATITUDE_DEG: 51.8543987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045600',
        LOCATION_NAME: 'Little Silver',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5396484,
        LOCATION_LATITUDE_DEG: 50.8821231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045700',
        LOCATION_NAME: 'Little Singleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9477054,
        LOCATION_LATITUDE_DEG: 53.8479089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045800',
        LOCATION_NAME: 'Little Sinns',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2300272,
        LOCATION_LATITUDE_DEG: 50.2534831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI991005',
        LOCATION_NAME: 'Little Smeaton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI045900',
        LOCATION_NAME: 'Little Smeaton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4631017,
        LOCATION_LATITUDE_DEG: 54.4255425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046000',
        LOCATION_NAME: 'Little Snoring',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9007424,
        LOCATION_LATITUDE_DEG: 52.8543552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046100',
        LOCATION_NAME: 'Little Sodbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3486927,
        LOCATION_LATITUDE_DEG: 51.5478747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046200',
        LOCATION_NAME: 'Little Somborne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4485537,
        LOCATION_LATITUDE_DEG: 51.0828216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046300',
        LOCATION_NAME: 'Little Somerford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0424567,
        LOCATION_LATITUDE_DEG: 51.5582768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046400',
        LOCATION_NAME: 'Little Soudley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4208768,
        LOCATION_LATITUDE_DEG: 52.8502992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046500',
        LOCATION_NAME: 'Little Stainforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.284451,
        LOCATION_LATITUDE_DEG: 54.1002224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046700',
        LOCATION_NAME: 'Little Stainton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.164718,
        LOCATION_LATITUDE_DEG: 53.9735078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046600',
        LOCATION_NAME: 'Little Stainton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4601215,
        LOCATION_LATITUDE_DEG: 54.5735541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046800',
        LOCATION_NAME: 'Little Stanney',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8847476,
        LOCATION_LATITUDE_DEG: 53.2622436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI046900',
        LOCATION_NAME: 'Little Staughton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3799589,
        LOCATION_LATITUDE_DEG: 52.2503157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047000',
        LOCATION_NAME: 'Little Steeping',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1467773,
        LOCATION_LATITUDE_DEG: 53.1427998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047100',
        LOCATION_NAME: 'Little Stoke',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5541421,
        LOCATION_LATITUDE_DEG: 51.5257721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI062200',
        LOCATION_NAME: 'Little Stoke',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1239677,
        LOCATION_LATITUDE_DEG: 52.8944041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047200',
        LOCATION_NAME: 'Little Stoke',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1262049,
        LOCATION_LATITUDE_DEG: 51.5588622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047300',
        LOCATION_NAME: 'Little Stonham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0919255,
        LOCATION_LATITUDE_DEG: 52.1983904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047400',
        LOCATION_NAME: 'Little Stretton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8202997,
        LOCATION_LATITUDE_DEG: 52.520276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047500',
        LOCATION_NAME: 'Little Stretton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0146202,
        LOCATION_LATITUDE_DEG: 52.5930595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047600',
        LOCATION_NAME: 'Little Strickland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.676684,
        LOCATION_LATITUDE_DEG: 54.5705745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047700',
        LOCATION_NAME: 'Little Stukeley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.224692,
        LOCATION_LATITUDE_DEG: 52.3641288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047900',
        LOCATION_NAME: 'Little Sutton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9479306,
        LOCATION_LATITUDE_DEG: 53.2852493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI047800',
        LOCATION_NAME: 'Little Sutton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1528617,
        LOCATION_LATITUDE_DEG: 52.7735586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048000',
        LOCATION_NAME: 'Little Tarrington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5463423,
        LOCATION_LATITUDE_DEG: 52.068125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048100',
        LOCATION_NAME: 'Little Tathwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0153476,
        LOCATION_LATITUDE_DEG: 53.3218174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048200',
        LOCATION_NAME: 'Little Tew',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4400901,
        LOCATION_LATITUDE_DEG: 51.9536044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048300',
        LOCATION_NAME: 'Little Tey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7548629,
        LOCATION_LATITUDE_DEG: 51.8765701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048400',
        LOCATION_NAME: 'Little Thetford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.250032,
        LOCATION_LATITUDE_DEG: 52.3626237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048500',
        LOCATION_NAME: 'Little Thornage',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0622466,
        LOCATION_LATITUDE_DEG: 52.9030636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048600',
        LOCATION_NAME: 'Little Thurrock',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3378747,
        LOCATION_LATITUDE_DEG: 51.4886333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048700',
        LOCATION_NAME: 'Little Tingewick',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0673801,
        LOCATION_LATITUDE_DEG: 51.9881006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048800',
        LOCATION_NAME: 'Little Torrington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.148736,
        LOCATION_LATITUDE_DEG: 50.9315385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI048900',
        LOCATION_NAME: 'Little Totham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7398582,
        LOCATION_LATITUDE_DEG: 51.7731609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049000',
        LOCATION_NAME: 'Little Town',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6905696,
        LOCATION_LATITUDE_DEG: 53.7135755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049100',
        LOCATION_NAME: 'Little Trenethick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2628376,
        LOCATION_LATITUDE_DEG: 50.1166725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049200',
        LOCATION_NAME: 'Little Tring',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.672437,
        LOCATION_LATITUDE_DEG: 51.8092814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049300',
        LOCATION_NAME: 'Little Urswick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1275388,
        LOCATION_LATITUDE_DEG: 54.1534354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049400',
        LOCATION_NAME: 'Little Wakering',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7871393,
        LOCATION_LATITUDE_DEG: 51.562841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049500',
        LOCATION_NAME: 'Little Walden',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2550943,
        LOCATION_LATITUDE_DEG: 52.0503928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049600',
        LOCATION_NAME: 'Little Waldingfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8058884,
        LOCATION_LATITUDE_DEG: 52.071387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049700',
        LOCATION_NAME: 'Little Walsingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8755861,
        LOCATION_LATITUDE_DEG: 52.8940622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049800',
        LOCATION_NAME: 'Little Waltham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4833323,
        LOCATION_LATITUDE_DEG: 51.7859594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI049900',
        LOCATION_NAME: 'Little Warley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.32142,
        LOCATION_LATITUDE_DEG: 51.5897483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050000',
        LOCATION_NAME: 'Little Washbourne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0166649,
        LOCATION_LATITUDE_DEG: 51.998014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050100',
        LOCATION_NAME: 'Little Weighton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5009468,
        LOCATION_LATITUDE_DEG: 53.7913681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050200',
        LOCATION_NAME: 'Little Wenham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0306206,
        LOCATION_LATITUDE_DEG: 52.0125784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050300',
        LOCATION_NAME: 'Little Wenlock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5224085,
        LOCATION_LATITUDE_DEG: 52.6578817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050400',
        LOCATION_NAME: 'Little Weston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5747616,
        LOCATION_LATITUDE_DEG: 51.0251252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050500',
        LOCATION_NAME: 'Little Whelnetham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7601597,
        LOCATION_LATITUDE_DEG: 52.2018026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050600',
        LOCATION_NAME: 'Little Wigborough',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8683983,
        LOCATION_LATITUDE_DEG: 51.7995593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050700',
        LOCATION_NAME: 'Little Wilbraham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2585271,
        LOCATION_LATITUDE_DEG: 52.2033024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050750',
        LOCATION_NAME: 'Little Witchingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.138887,
        LOCATION_LATITUDE_DEG: 52.7417485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050800',
        LOCATION_NAME: 'Little Witcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1289633,
        LOCATION_LATITUDE_DEG: 51.840398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI050900',
        LOCATION_NAME: 'Little Witley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3157792,
        LOCATION_LATITUDE_DEG: 52.2713492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051000',
        LOCATION_NAME: 'Little Wittenham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1852024,
        LOCATION_LATITUDE_DEG: 51.6335743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051100',
        LOCATION_NAME: 'Little Wolford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6161217,
        LOCATION_LATITUDE_DEG: 52.0168119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051300',
        LOCATION_NAME: 'Little Worth',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5101979,
        LOCATION_LATITUDE_DEG: 52.6580878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051400',
        LOCATION_NAME: 'Little Worthen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9857712,
        LOCATION_LATITUDE_DEG: 52.640089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051500',
        LOCATION_NAME: 'Little Wratting',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4688982,
        LOCATION_LATITUDE_DEG: 52.1005888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051600',
        LOCATION_NAME: 'Little Wymondley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2322259,
        LOCATION_LATITUDE_DEG: 51.9316902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051700',
        LOCATION_NAME: 'Little Wytheford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6494081,
        LOCATION_LATITUDE_DEG: 52.7698008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051800',
        LOCATION_NAME: 'Little Yeldham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5936013,
        LOCATION_LATITUDE_DEG: 52.0252842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052000',
        LOCATION_NAME: 'Littlebeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6428061,
        LOCATION_LATITUDE_DEG: 54.4332327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052200',
        LOCATION_NAME: 'Littleborough',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0938703,
        LOCATION_LATITUDE_DEG: 53.6435709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052100',
        LOCATION_NAME: 'Littleborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7588508,
        LOCATION_LATITUDE_DEG: 53.3324276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052300',
        LOCATION_NAME: 'Littlebourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1706892,
        LOCATION_LATITUDE_DEG: 51.2749044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052400',
        LOCATION_NAME: 'Littlebredy',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5813406,
        LOCATION_LATITUDE_DEG: 50.6986975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052500',
        LOCATION_NAME: 'Littlebury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2104651,
        LOCATION_LATITUDE_DEG: 52.0336928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052600',
        LOCATION_NAME: 'Littlebury Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1712033,
        LOCATION_LATITUDE_DEG: 52.0241888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052700',
        LOCATION_NAME: 'Littlecote',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.791268,
        LOCATION_LATITUDE_DEG: 51.9088952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052800',
        LOCATION_NAME: 'Littledean',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4771899,
        LOCATION_LATITUDE_DEG: 51.8177041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI052900',
        LOCATION_NAME: 'Littleferry',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.016823,
        LOCATION_LATITUDE_DEG: 57.9351193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053000',
        LOCATION_NAME: 'Littleham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.226348,
        LOCATION_LATITUDE_DEG: 50.9874434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053100',
        LOCATION_NAME: 'Littleham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3709043,
        LOCATION_LATITUDE_DEG: 50.6225958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053200',
        LOCATION_NAME: 'Littlehampton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5371553,
        LOCATION_LATITUDE_DEG: 50.8089816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053300',
        LOCATION_NAME: 'Littlehempston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6621812,
        LOCATION_LATITUDE_DEG: 50.4546862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053400',
        LOCATION_NAME: 'Littlehoughton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6361632,
        LOCATION_LATITUDE_DEG: 55.440746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI051900',
        LOCATION_NAME: 'Little-in-Sight',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1073217,
        LOCATION_LATITUDE_DEG: 50.1146715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053500',
        LOCATION_NAME: 'Littlemayne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3893457,
        LOCATION_LATITUDE_DEG: 50.6817971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053600',
        LOCATION_NAME: 'Littlemill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4476374,
        LOCATION_LATITUDE_DEG: 55.4057691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053700',
        LOCATION_NAME: 'Littlemoor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4580904,
        LOCATION_LATITUDE_DEG: 53.1606219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053800',
        LOCATION_NAME: 'Littlemore',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2211857,
        LOCATION_LATITUDE_DEG: 51.7211798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI053900',
        LOCATION_NAME: 'Littleover',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5198815,
        LOCATION_LATITUDE_DEG: 52.9015001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054000',
        LOCATION_NAME: 'Littleport',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3067717,
        LOCATION_LATITUDE_DEG: 52.4574304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054100',
        LOCATION_NAME: 'Littlestone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9687736,
        LOCATION_LATITUDE_DEG: 50.9808823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054400',
        LOCATION_NAME: 'Littlethorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5050977,
        LOCATION_LATITUDE_DEG: 54.1187137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054200',
        LOCATION_NAME: 'Littlethorpe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.342801,
        LOCATION_LATITUDE_DEG: 54.7774755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054300',
        LOCATION_NAME: 'Littlethorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2009237,
        LOCATION_LATITUDE_DEG: 52.5666626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054500',
        LOCATION_NAME: 'Littleton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8374619,
        LOCATION_LATITUDE_DEG: 53.1918417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054700',
        LOCATION_NAME: 'Littleton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.724236,
        LOCATION_LATITUDE_DEG: 51.0706372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054600',
        LOCATION_NAME: 'Littleton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3505348,
        LOCATION_LATITUDE_DEG: 51.0899174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054900',
        LOCATION_NAME: 'Littleton Drew',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2438942,
        LOCATION_LATITUDE_DEG: 51.5208742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055000',
        LOCATION_NAME: 'Littleton Panell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0009894,
        LOCATION_LATITUDE_DEG: 51.2848456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061800',
        LOCATION_NAME: 'Littleton upon Severn',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055100',
        LOCATION_NAME: 'Littleton-upon-Severn',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5828848,
        LOCATION_LATITUDE_DEG: 51.6078873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055200',
        LOCATION_NAME: 'Littletown',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4726245,
        LOCATION_LATITUDE_DEG: 54.7839782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055300',
        LOCATION_NAME: 'Littlewick Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7896633,
        LOCATION_LATITUDE_DEG: 51.5148569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055400',
        LOCATION_NAME: 'Littlewindsor',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7939871,
        LOCATION_LATITUDE_DEG: 50.8345088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055900',
        LOCATION_NAME: 'Littleworth',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1690677,
        LOCATION_LATITUDE_DEG: 52.1486297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055700',
        LOCATION_NAME: 'Littleworth',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9764356,
        LOCATION_LATITUDE_DEG: 52.7054857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055500',
        LOCATION_NAME: 'Littleworth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7297739,
        LOCATION_LATITUDE_DEG: 51.3495519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055600',
        LOCATION_NAME: 'Littleworth',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6518104,
        LOCATION_LATITUDE_DEG: 52.2681381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI055800',
        LOCATION_NAME: 'Littleworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5475159,
        LOCATION_LATITUDE_DEG: 51.6715796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056000',
        LOCATION_NAME: 'Littleworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1470031,
        LOCATION_LATITUDE_DEG: 51.743982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056100',
        LOCATION_NAME: 'Littley Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4645971,
        LOCATION_LATITUDE_DEG: 51.8266649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056300',
        LOCATION_NAME: 'Litton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5820075,
        LOCATION_LATITUDE_DEG: 51.2889569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056400',
        LOCATION_NAME: 'Litton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1424305,
        LOCATION_LATITUDE_DEG: 54.1623242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056200',
        LOCATION_NAME: 'Litton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7546931,
        LOCATION_LATITUDE_DEG: 53.2730319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056500',
        LOCATION_NAME: 'Litton Cheney',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6366766,
        LOCATION_LATITUDE_DEG: 50.7128975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056600',
        LOCATION_NAME: 'Litton Mill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.765173,
        LOCATION_LATITUDE_DEG: 53.2544351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056700',
        LOCATION_NAME: 'Liverpool Airport',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8545468,
        LOCATION_LATITUDE_DEG: 53.3417561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056800',
        LOCATION_NAME: 'Liverpool L 1',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9802914,
        LOCATION_LATITUDE_DEG: 53.4012474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI056900',
        LOCATION_NAME: 'Liverpool L 2',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9903323,
        LOCATION_LATITUDE_DEG: 53.4067473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057000',
        LOCATION_NAME: 'Liverpool L 3',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.996609,
        LOCATION_LATITUDE_DEG: 53.4088077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057100',
        LOCATION_NAME: 'Liverpool L 4',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9583679,
        LOCATION_LATITUDE_DEG: 53.4391112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057200',
        LOCATION_NAME: 'Liverpool L 5',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9800303,
        LOCATION_LATITUDE_DEG: 53.4252258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057300',
        LOCATION_NAME: 'Liverpool L 6',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9496845,
        LOCATION_LATITUDE_DEG: 53.4197084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057400',
        LOCATION_NAME: 'Liverpool L 7',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.948066,
        LOCATION_LATITUDE_DEG: 53.4058048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057500',
        LOCATION_NAME: 'Liverpool L 8',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9623054,
        LOCATION_LATITUDE_DEG: 53.3901382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057600',
        LOCATION_NAME: 'Liverpool L 9',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9469657,
        LOCATION_LATITUDE_DEG: 53.4625938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057700',
        LOCATION_NAME: 'Liverpool L10',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9263238,
        LOCATION_LATITUDE_DEG: 53.4755662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057800',
        LOCATION_NAME: 'Liverpool L11',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9125895,
        LOCATION_LATITUDE_DEG: 53.4492776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI057900',
        LOCATION_NAME: 'Liverpool L12',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8929105,
        LOCATION_LATITUDE_DEG: 53.4372541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058000',
        LOCATION_NAME: 'Liverpool L13',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9214515,
        LOCATION_LATITUDE_DEG: 53.4210622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058100',
        LOCATION_NAME: 'Liverpool L14',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8816536,
        LOCATION_LATITUDE_DEG: 53.4178296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058200',
        LOCATION_NAME: 'Liverpool L15',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9186026,
        LOCATION_LATITUDE_DEG: 53.3978093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058300',
        LOCATION_NAME: 'Liverpool L16',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8842038,
        LOCATION_LATITUDE_DEG: 53.4007569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058400',
        LOCATION_NAME: 'Liverpool L17',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9394773,
        LOCATION_LATITUDE_DEG: 53.3765114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058500',
        LOCATION_NAME: 'Liverpool L18',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9045119,
        LOCATION_LATITUDE_DEG: 53.3795144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058600',
        LOCATION_NAME: 'Liverpool L19',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8997807,
        LOCATION_LATITUDE_DEG: 53.3583428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058700',
        LOCATION_NAME: 'Liverpool L20',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9927429,
        LOCATION_LATITUDE_DEG: 53.450823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058800',
        LOCATION_NAME: 'Liverpool L21',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0045989,
        LOCATION_LATITUDE_DEG: 53.4707535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI058900',
        LOCATION_NAME: 'Liverpool L22',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0293413,
        LOCATION_LATITUDE_DEG: 53.4739411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059000',
        LOCATION_NAME: 'Liverpool L23',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0247096,
        LOCATION_LATITUDE_DEG: 53.4974715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059100',
        LOCATION_NAME: 'Liverpool L24',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.836505,
        LOCATION_LATITUDE_DEG: 53.3417131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059200',
        LOCATION_NAME: 'Liverpool L25',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8640349,
        LOCATION_LATITUDE_DEG: 53.3778814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059300',
        LOCATION_NAME: 'Liverpool L26',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8249245,
        LOCATION_LATITUDE_DEG: 53.3658958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059400',
        LOCATION_NAME: 'Liverpool L27',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8380995,
        LOCATION_LATITUDE_DEG: 53.3885395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059500',
        LOCATION_NAME: 'Liverpool L28',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8658465,
        LOCATION_LATITUDE_DEG: 53.4360419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059600',
        LOCATION_NAME: 'Liverpool L29',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9881198,
        LOCATION_LATITUDE_DEG: 53.512451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059700',
        LOCATION_NAME: 'Liverpool L30',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9703133,
        LOCATION_LATITUDE_DEG: 53.4856183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059800',
        LOCATION_NAME: 'Liverpool L31',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9388932,
        LOCATION_LATITUDE_DEG: 53.5186462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI059900',
        LOCATION_NAME: 'Liverpool L32',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8913137,
        LOCATION_LATITUDE_DEG: 53.4760482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060000',
        LOCATION_NAME: 'Liverpool L33',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8570152,
        LOCATION_LATITUDE_DEG: 53.4901883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060100',
        LOCATION_NAME: 'Liverpool L34',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8265689,
        LOCATION_LATITUDE_DEG: 53.4500296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060200',
        LOCATION_NAME: 'Liverpool L35',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.751898,
        LOCATION_LATITUDE_DEG: 53.4088192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060300',
        LOCATION_NAME: 'Liverpool L36',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8383451,
        LOCATION_LATITUDE_DEG: 53.4140511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060400',
        LOCATION_NAME: 'Liverpool L37',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0555169,
        LOCATION_LATITUDE_DEG: 53.5583615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060500',
        LOCATION_NAME: 'Liverpool L38',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0461383,
        LOCATION_LATITUDE_DEG: 53.5368413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060600',
        LOCATION_NAME: 'Liverpool L69',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9752331,
        LOCATION_LATITUDE_DEG: 53.4267214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060700',
        LOCATION_NAME: 'Liverpool L70',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9292334,
        LOCATION_LATITUDE_DEG: 53.421811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060800',
        LOCATION_NAME: 'Liversedge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6907551,
        LOCATION_LATITUDE_DEG: 53.7068791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061000',
        LOCATION_NAME: 'Liverton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6856287,
        LOCATION_LATITUDE_DEG: 50.5632936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI060900',
        LOCATION_NAME: 'Liverton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9002503,
        LOCATION_LATITUDE_DEG: 54.5334481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061100',
        LOCATION_NAME: 'Liverton Mines',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9014527,
        LOCATION_LATITUDE_DEG: 54.5519842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061200',
        LOCATION_NAME: 'Livesey',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5039605,
        LOCATION_LATITUDE_DEG: 53.7178863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061300',
        LOCATION_NAME: 'Livingston',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5160297,
        LOCATION_LATITUDE_DEG: 55.8976123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061400',
        LOCATION_NAME: 'Livingston Village',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.539823,
        LOCATION_LATITUDE_DEG: 55.8861101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061600',
        LOCATION_NAME: 'Lixwm',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2461475,
        LOCATION_LATITUDE_DEG: 53.2338498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000100',
        LOCATION_NAME: 'Llaingarreglwyd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3256908,
        LOCATION_LATITUDE_DEG: 52.20626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000200',
        LOCATION_NAME: 'Llaithddu',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3673252,
        LOCATION_LATITUDE_DEG: 52.4111682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL990333',
        LOCATION_NAME: 'Llampha',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5467765,
        LOCATION_LATITUDE_DEG: 51.4705318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000300',
        LOCATION_NAME: 'Llan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6482577,
        LOCATION_LATITUDE_DEG: 52.5913441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040200',
        LOCATION_NAME: 'Llan y Pwll',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000500',
        LOCATION_NAME: 'Llanaber',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0714257,
        LOCATION_LATITUDE_DEG: 52.7385097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000600',
        LOCATION_NAME: 'Llanaelhaearn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4034097,
        LOCATION_LATITUDE_DEG: 52.9764374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000700',
        LOCATION_NAME: 'Llanafan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9294331,
        LOCATION_LATITUDE_DEG: 52.3318662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000800',
        LOCATION_NAME: 'Llanafanfawr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5092611,
        LOCATION_LATITUDE_DEG: 52.1871933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000900',
        LOCATION_NAME: 'Llanallgo',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.254843,
        LOCATION_LATITUDE_DEG: 53.3406721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001000',
        LOCATION_NAME: 'Llananno',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3285075,
        LOCATION_LATITUDE_DEG: 52.3568689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001100',
        LOCATION_NAME: 'Llanarmon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3466136,
        LOCATION_LATITUDE_DEG: 52.9279348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001200',
        LOCATION_NAME: 'Llanarmon Dyffryn Ceiriog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2528864,
        LOCATION_LATITUDE_DEG: 52.886018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040300',
        LOCATION_NAME: 'Llanarmon yn Ial',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001300',
        LOCATION_NAME: 'Llanarmon-yn-Ial',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2090613,
        LOCATION_LATITUDE_DEG: 53.0965328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001500',
        LOCATION_NAME: 'Llanarth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3064183,
        LOCATION_LATITUDE_DEG: 52.1936612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001400',
        LOCATION_NAME: 'Llanarth',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9057348,
        LOCATION_LATITUDE_DEG: 51.7937018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001600',
        LOCATION_NAME: 'Llanarthney',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1297873,
        LOCATION_LATITUDE_DEG: 51.8611228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001700',
        LOCATION_NAME: 'Llanasa',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3420876,
        LOCATION_LATITUDE_DEG: 53.3222545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001800',
        LOCATION_NAME: 'Llanbabo',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.435583,
        LOCATION_LATITUDE_DEG: 53.355372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL001900',
        LOCATION_NAME: 'Llanbadarn Fawr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0616944,
        LOCATION_LATITUDE_DEG: 52.4067075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002000',
        LOCATION_NAME: 'Llanbadarn Fynydd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3267197,
        LOCATION_LATITUDE_DEG: 52.3937643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040400',
        LOCATION_NAME: 'Llanbadarn y Garreg',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2941815,
        LOCATION_LATITUDE_DEG: 52.1311655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002100',
        LOCATION_NAME: 'Llanbadarn-y-Garreg',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2931557,
        LOCATION_LATITUDE_DEG: 52.1290457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002200',
        LOCATION_NAME: 'Llanbadoc',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.90255,
        LOCATION_LATITUDE_DEG: 51.6943964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002400',
        LOCATION_NAME: 'Llanbedr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0993671,
        LOCATION_LATITUDE_DEG: 52.81982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002300',
        LOCATION_NAME: 'Llanbedr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1043029,
        LOCATION_LATITUDE_DEG: 51.876515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002500',
        LOCATION_NAME: 'Llanbedr Dyffryn Clwyd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2828832,
        LOCATION_LATITUDE_DEG: 53.1228129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002600',
        LOCATION_NAME: 'Llanbedr Hall',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2780638,
        LOCATION_LATITUDE_DEG: 53.1296347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040500',
        LOCATION_NAME: 'Llanbedr y Cennin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002800',
        LOCATION_NAME: 'Llanbedrgoch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2355606,
        LOCATION_LATITUDE_DEG: 53.2997632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002900',
        LOCATION_NAME: 'Llanbedrog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4831488,
        LOCATION_LATITUDE_DEG: 52.8572278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL002700',
        LOCATION_NAME: 'Llanbedr-y-Cennin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8557826,
        LOCATION_LATITUDE_DEG: 53.2079511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003000',
        LOCATION_NAME: 'Llanberis',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1290828,
        LOCATION_LATITUDE_DEG: 53.1188489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003100',
        LOCATION_NAME: 'Llanbethery',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3825244,
        LOCATION_LATITUDE_DEG: 51.4187775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003200',
        LOCATION_NAME: 'Llanbister',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3077493,
        LOCATION_LATITUDE_DEG: 52.3501678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003300',
        LOCATION_NAME: 'Llanbister Road',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2280851,
        LOCATION_LATITUDE_DEG: 52.3425615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003400',
        LOCATION_NAME: 'Llanblethian',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4605962,
        LOCATION_LATITUDE_DEG: 51.4552785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003500',
        LOCATION_NAME: 'Llanboidy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5906884,
        LOCATION_LATITUDE_DEG: 51.878431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003600',
        LOCATION_NAME: 'Llanbradach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2298538,
        LOCATION_LATITUDE_DEG: 51.6036924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003700',
        LOCATION_NAME: 'Llanbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9526475,
        LOCATION_LATITUDE_DEG: 52.4008685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003800',
        LOCATION_NAME: 'Llanbrynmair',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6377878,
        LOCATION_LATITUDE_DEG: 52.6106959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL003900',
        LOCATION_NAME: 'Llancadle',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3865845,
        LOCATION_LATITUDE_DEG: 51.4060761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004000',
        LOCATION_NAME: 'Llancarfan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.364957,
        LOCATION_LATITUDE_DEG: 51.4219782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004100',
        LOCATION_NAME: 'Llancayo',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9143741,
        LOCATION_LATITUDE_DEG: 51.7224963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004200',
        LOCATION_NAME: 'Llancloudy',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7316813,
        LOCATION_LATITUDE_DEG: 51.8821107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004300',
        LOCATION_NAME: 'Llancynfelyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9952954,
        LOCATION_LATITUDE_DEG: 52.5099833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004400',
        LOCATION_NAME: 'Llandaff',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2154071,
        LOCATION_LATITUDE_DEG: 51.4995794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004500',
        LOCATION_NAME: 'Llandaff North',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2245016,
        LOCATION_LATITUDE_DEG: 51.5039813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004600',
        LOCATION_NAME: 'Llandanwg',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.123621,
        LOCATION_LATITUDE_DEG: 52.8338208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004700',
        LOCATION_NAME: 'Llandarcy',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8468934,
        LOCATION_LATITUDE_DEG: 51.6397982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004800',
        LOCATION_NAME: 'Llandawke',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.490126,
        LOCATION_LATITUDE_DEG: 51.7729181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL990398',
        LOCATION_NAME: 'LLANDDANIEL',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL990399',
        LOCATION_NAME: 'LLANDDANIEL FAB',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL004900',
        LOCATION_NAME: 'Llanddarog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.176351,
        LOCATION_LATITUDE_DEG: 51.82882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005000',
        LOCATION_NAME: 'Llanddeiniol',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1106218,
        LOCATION_LATITUDE_DEG: 52.32767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005100',
        LOCATION_NAME: 'Llanddeiniolen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1763275,
        LOCATION_LATITUDE_DEG: 53.1732489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005200',
        LOCATION_NAME: 'Llandderfel',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5151132,
        LOCATION_LATITUDE_DEG: 52.9228201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005400',
        LOCATION_NAME: 'Llanddeusant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4865453,
        LOCATION_LATITUDE_DEG: 53.3369748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005300',
        LOCATION_NAME: 'Llanddeusant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7776321,
        LOCATION_LATITUDE_DEG: 51.9054264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005500',
        LOCATION_NAME: 'Llanddew',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3750696,
        LOCATION_LATITUDE_DEG: 51.9667251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005600',
        LOCATION_NAME: 'Llanddewi',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2715364,
        LOCATION_LATITUDE_DEG: 52.0917387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005700',
        LOCATION_NAME: 'Llanddewi Brefi',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9567967,
        LOCATION_LATITUDE_DEG: 52.1768052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL005900',
        LOCATION_NAME: 'Llanddewi Rhydderch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9422279,
        LOCATION_LATITUDE_DEG: 51.8114087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006000',
        LOCATION_NAME: 'Llanddewi Skirrid',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.95326,
        LOCATION_LATITUDE_DEG: 51.8447082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006100',
        LOCATION_NAME: 'Llanddewi Velfrey',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6877844,
        LOCATION_LATITUDE_DEG: 51.8193267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006200',
        LOCATION_NAME: 'Llanddoged',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7831937,
        LOCATION_LATITUDE_DEG: 53.1560478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006300',
        LOCATION_NAME: 'Llanddona',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL58',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.137714,
        LOCATION_LATITUDE_DEG: 53.2928628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006400',
        LOCATION_NAME: 'Llanddowror',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5299144,
        LOCATION_LATITUDE_DEG: 51.8015239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006500',
        LOCATION_NAME: 'Llanddulas',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6357759,
        LOCATION_LATITUDE_DEG: 53.2887572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006600',
        LOCATION_NAME: 'Llanddwywe',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0937326,
        LOCATION_LATITUDE_DEG: 52.7767123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006700',
        LOCATION_NAME: 'Llandecwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0330102,
        LOCATION_LATITUDE_DEG: 52.9178278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006800',
        LOCATION_NAME: 'Llandefaelog Fach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.407034,
        LOCATION_LATITUDE_DEG: 51.9814278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL006900',
        LOCATION_NAME: 'Llandefalle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2986194,
        LOCATION_LATITUDE_DEG: 52.0103336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007000',
        LOCATION_NAME: 'Llandegfan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL59',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1487957,
        LOCATION_LATITUDE_DEG: 53.243956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007100',
        LOCATION_NAME: 'Llandegla',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1996017,
        LOCATION_LATITUDE_DEG: 53.062527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007200',
        LOCATION_NAME: 'Llandegley',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2605718,
        LOCATION_LATITUDE_DEG: 52.2572555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007300',
        LOCATION_NAME: 'Llandegveth',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9630125,
        LOCATION_LATITUDE_DEG: 51.6537916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007400',
        LOCATION_NAME: 'Llandeilo',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9947119,
        LOCATION_LATITUDE_DEG: 51.8833304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007500',
        LOCATION_NAME: "Llandeilo'r Fan",
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6085795,
        LOCATION_LATITUDE_DEG: 51.9954294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007600',
        LOCATION_NAME: 'Llandeloy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0988941,
        LOCATION_LATITUDE_DEG: 51.8960428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007700',
        LOCATION_NAME: 'Llandenny',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8453738,
        LOCATION_LATITUDE_DEG: 51.7306025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007800',
        LOCATION_NAME: 'Llandevaud',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8645183,
        LOCATION_LATITUDE_DEG: 51.6082914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL007900',
        LOCATION_NAME: 'Llandewi',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.212137,
        LOCATION_LATITUDE_DEG: 51.5770737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008000',
        LOCATION_NAME: 'Llandewir Cwm',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4099802,
        LOCATION_LATITUDE_DEG: 52.1270411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008050',
        LOCATION_NAME: 'Llandilo',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7586318,
        LOCATION_LATITUDE_DEG: 51.9108133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008100',
        LOCATION_NAME: 'Llandilo Graban',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3255775,
        LOCATION_LATITUDE_DEG: 52.0911344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008200',
        LOCATION_NAME: 'Llandinabo',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7015179,
        LOCATION_LATITUDE_DEG: 51.9512183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008300',
        LOCATION_NAME: 'Llandinam',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.435588,
        LOCATION_LATITUDE_DEG: 52.484676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008400',
        LOCATION_NAME: 'Llandissilio',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.728734,
        LOCATION_LATITUDE_DEG: 51.8607287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008500',
        LOCATION_NAME: 'Llandogo',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7036642,
        LOCATION_LATITUDE_DEG: 51.7309969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008700',
        LOCATION_NAME: 'Llandough',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.446165,
        LOCATION_LATITUDE_DEG: 51.4454749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008600',
        LOCATION_NAME: 'Llandough',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1961142,
        LOCATION_LATITUDE_DEG: 51.4461795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008800',
        LOCATION_NAME: 'Llandovery',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7921082,
        LOCATION_LATITUDE_DEG: 51.9936337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL008900',
        LOCATION_NAME: 'Llandow',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5209399,
        LOCATION_LATITUDE_DEG: 51.4487824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009000',
        LOCATION_NAME: 'Llandre',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0231134,
        LOCATION_LATITUDE_DEG: 52.4626332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009100',
        LOCATION_NAME: 'Llandrillo',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4370962,
        LOCATION_LATITUDE_DEG: 52.9223239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009200',
        LOCATION_NAME: 'Llandrindod Wells',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3794267,
        LOCATION_LATITUDE_DEG: 52.2408559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009300',
        LOCATION_NAME: 'Llandrinio',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0584403,
        LOCATION_LATITUDE_DEG: 52.7506009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009400',
        LOCATION_NAME: 'Llandrygan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.398375,
        LOCATION_LATITUDE_DEG: 53.3008702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009500',
        LOCATION_NAME: 'Llandudno',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8331761,
        LOCATION_LATITUDE_DEG: 53.3262646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009600',
        LOCATION_NAME: 'Llandudno Junction',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8095145,
        LOCATION_LATITUDE_DEG: 53.2859595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009700',
        LOCATION_NAME: 'Llandulas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6320248,
        LOCATION_LATITUDE_DEG: 52.0496379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009800',
        LOCATION_NAME: 'Llandwrog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3129844,
        LOCATION_LATITUDE_DEG: 53.0790435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL009900',
        LOCATION_NAME: 'Llandybie',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0061566,
        LOCATION_LATITUDE_DEG: 51.8195174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL990298',
        LOCATION_NAME: 'Llandyfaelog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2966837,
        LOCATION_LATITUDE_DEG: 51.78462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010000',
        LOCATION_NAME: 'Llandyfaelog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4054823,
        LOCATION_LATITUDE_DEG: 51.9788475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010100',
        LOCATION_NAME: 'Llandyfan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9716949,
        LOCATION_LATITUDE_DEG: 51.8352181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010200',
        LOCATION_NAME: 'Llandyfriog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4311805,
        LOCATION_LATITUDE_DEG: 52.0445425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010300',
        LOCATION_NAME: 'Llandyfrydog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3379516,
        LOCATION_LATITUDE_DEG: 53.3416706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL990073',
        LOCATION_NAME: 'Llandygai',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1384082,
        LOCATION_LATITUDE_DEG: 53.1883407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010400',
        LOCATION_NAME: 'Llandygwydd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5656799,
        LOCATION_LATITUDE_DEG: 52.0634453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010500',
        LOCATION_NAME: 'Llandyrnog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3348807,
        LOCATION_LATITUDE_DEG: 53.1744411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010600',
        LOCATION_NAME: 'Llandysilio',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0840082,
        LOCATION_LATITUDE_DEG: 52.7688016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010700',
        LOCATION_NAME: 'Llandyssil',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1857047,
        LOCATION_LATITUDE_DEG: 52.5481996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010800',
        LOCATION_NAME: 'Llandysul',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3078806,
        LOCATION_LATITUDE_DEG: 52.0412493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL010900',
        LOCATION_NAME: 'Llanedeyrn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1490979,
        LOCATION_LATITUDE_DEG: 51.5132785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011000',
        LOCATION_NAME: 'Llaneglwys',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3676086,
        LOCATION_LATITUDE_DEG: 52.0372311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011100',
        LOCATION_NAME: 'Llanegryn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0671021,
        LOCATION_LATITUDE_DEG: 52.6282953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011200',
        LOCATION_NAME: 'Llanegwad',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1514184,
        LOCATION_LATITUDE_DEG: 51.8712245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011300',
        LOCATION_NAME: 'Llaneilian',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2950978,
        LOCATION_LATITUDE_DEG: 53.4103725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011400',
        LOCATION_NAME: 'Llanelian',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7045132,
        LOCATION_LATITUDE_DEG: 53.2718536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011500',
        LOCATION_NAME: 'Llanelidan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3323936,
        LOCATION_LATITUDE_DEG: 53.0443281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011600',
        LOCATION_NAME: 'Llanelieu',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1883271,
        LOCATION_LATITUDE_DEG: 52.0000328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011700',
        LOCATION_NAME: 'Llanellen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0110684,
        LOCATION_LATITUDE_DEG: 51.7927083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011800',
        LOCATION_NAME: 'Llanelli',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1619537,
        LOCATION_LATITUDE_DEG: 51.6793061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL011900',
        LOCATION_NAME: 'Llanelltyd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9048303,
        LOCATION_LATITUDE_DEG: 52.7569132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012000',
        LOCATION_NAME: 'Llanelly Hill',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1253918,
        LOCATION_LATITUDE_DEG: 51.8023077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012100',
        LOCATION_NAME: 'Llanelwedd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3858059,
        LOCATION_LATITUDE_DEG: 52.1559498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012200',
        LOCATION_NAME: 'Llanengan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5311522,
        LOCATION_LATITUDE_DEG: 52.8133179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040600',
        LOCATION_NAME: 'Llanerch y Mor',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012300',
        LOCATION_NAME: 'Llanerch-y-Mor',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.23578,
        LOCATION_LATITUDE_DEG: 53.3009902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012500',
        LOCATION_NAME: 'Llanerfyl',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4277947,
        LOCATION_LATITUDE_DEG: 52.6763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012600',
        LOCATION_NAME: 'Llanfabon',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.288743,
        LOCATION_LATITUDE_DEG: 51.6356957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012700',
        LOCATION_NAME: 'Llanfachraeth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5296133,
        LOCATION_LATITUDE_DEG: 53.311772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012800',
        LOCATION_NAME: 'Llanfachreth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.84887,
        LOCATION_LATITUDE_DEG: 52.7843157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012900',
        LOCATION_NAME: 'Llanfaelog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4920934,
        LOCATION_LATITUDE_DEG: 53.2277654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013100',
        LOCATION_NAME: 'Llanfaes',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL58',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0943893,
        LOCATION_LATITUDE_DEG: 53.2790655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013000',
        LOCATION_NAME: 'Llanfaes',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4047364,
        LOCATION_LATITUDE_DEG: 51.9438218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013200',
        LOCATION_NAME: 'Llanfaethlu',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5326881,
        LOCATION_LATITUDE_DEG: 53.3522707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013300',
        LOCATION_NAME: 'Llanfaglan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2860691,
        LOCATION_LATITUDE_DEG: 53.1169528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013400',
        LOCATION_NAME: 'Llanfair',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1136343,
        LOCATION_LATITUDE_DEG: 52.8434228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013500',
        LOCATION_NAME: 'Llanfair Caereinion',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3244436,
        LOCATION_LATITUDE_DEG: 52.6476937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013600',
        LOCATION_NAME: 'Llanfair Clydogau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0139475,
        LOCATION_LATITUDE_DEG: 52.1434508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013700',
        LOCATION_NAME: 'Llanfair Dyffryn Clwyd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2931027,
        LOCATION_LATITUDE_DEG: 53.0888344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013800',
        LOCATION_NAME: 'Llanfair yn Neubwll',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5528544,
        LOCATION_LATITUDE_DEG: 53.2601642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL013900',
        LOCATION_NAME: 'Llanfairfechan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9771174,
        LOCATION_LATITUDE_DEG: 53.2536625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014000',
        LOCATION_NAME: 'Llanfairpwllgwyngyll',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2050175,
        LOCATION_LATITUDE_DEG: 53.2228594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014100',
        LOCATION_NAME: 'Llanfairtalhaiarn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.602997,
        LOCATION_LATITUDE_DEG: 53.2191369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014150',
        LOCATION_NAME: 'Llanfairwaterdine',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1096427,
        LOCATION_LATITUDE_DEG: 52.3755546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014200',
        LOCATION_NAME: 'Llanfairynghornwy',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5162151,
        LOCATION_LATITUDE_DEG: 53.3866726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014300',
        LOCATION_NAME: 'Llanfallteg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.671456,
        LOCATION_LATITUDE_DEG: 51.8487326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014400',
        LOCATION_NAME: 'Llanfaredd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3623515,
        LOCATION_LATITUDE_DEG: 52.1481481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014500',
        LOCATION_NAME: 'Llanfarian',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0727829,
        LOCATION_LATITUDE_DEG: 52.3775752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014600',
        LOCATION_NAME: 'Llanfechain',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2022187,
        LOCATION_LATITUDE_DEG: 52.7754038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014700',
        LOCATION_NAME: 'Llanfechell',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4524566,
        LOCATION_LATITUDE_DEG: 53.3921723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014800',
        LOCATION_NAME: 'Llanferres',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2125251,
        LOCATION_LATITUDE_DEG: 53.1368384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL014900',
        LOCATION_NAME: 'Llanfigael',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5098807,
        LOCATION_LATITUDE_DEG: 53.3119732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015000',
        LOCATION_NAME: 'Llanfihangel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3630713,
        LOCATION_LATITUDE_DEG: 52.7402981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039800',
        LOCATION_NAME: 'Llanfihangel Ar Arth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015100',
        LOCATION_NAME: 'Llanfihangel Brynpabuan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4987073,
        LOCATION_LATITUDE_DEG: 52.1996472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015200',
        LOCATION_NAME: 'Llanfihangel Glyn Myfyr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5042931,
        LOCATION_LATITUDE_DEG: 53.0303293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039500',
        LOCATION_NAME: 'Llanfihangel Nant Bran',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015300',
        LOCATION_NAME: 'Llanfihangel Talyllyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2930179,
        LOCATION_LATITUDE_DEG: 51.943879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039700',
        LOCATION_NAME: 'Llanfihangel y Creuddyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015500',
        LOCATION_NAME: 'Llanfihangel y Pennant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9703552,
        LOCATION_LATITUDE_DEG: 52.6599781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039600',
        LOCATION_NAME: 'Llanfihangel Y Traethau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015400',
        LOCATION_NAME: 'Llanfihangel Ystern Llewern',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8252976,
        LOCATION_LATITUDE_DEG: 51.8193374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015600',
        LOCATION_NAME: 'Llanfihangel-Ar-Arth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2512941,
        LOCATION_LATITUDE_DEG: 52.0354466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015700',
        LOCATION_NAME: 'Llanfihangel-Nant-Bran',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5448178,
        LOCATION_LATITUDE_DEG: 51.9980096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015900',
        LOCATION_NAME: 'Llanfihangel-y-Creuddyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.960539,
        LOCATION_LATITUDE_DEG: 52.3660742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL015800',
        LOCATION_NAME: 'Llanfihangel-Y-Traethau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0879493,
        LOCATION_LATITUDE_DEG: 52.8977217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016000',
        LOCATION_NAME: 'Llanfilo',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2825193,
        LOCATION_LATITUDE_DEG: 51.9905291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016100',
        LOCATION_NAME: 'Llanfinan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2581593,
        LOCATION_LATITUDE_DEG: 53.2572647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016200',
        LOCATION_NAME: 'Llanfoist',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0355236,
        LOCATION_LATITUDE_DEG: 51.813205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016300',
        LOCATION_NAME: 'Llanfor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5784216,
        LOCATION_LATITUDE_DEG: 52.9160256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016400',
        LOCATION_NAME: 'Llanforda',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0874479,
        LOCATION_LATITUDE_DEG: 52.8574117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016500',
        LOCATION_NAME: 'Llanfrechfa',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.98675,
        LOCATION_LATITUDE_DEG: 51.6370932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016600',
        LOCATION_NAME: 'Llanfrothen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0525803,
        LOCATION_LATITUDE_DEG: 52.9538274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016700',
        LOCATION_NAME: 'Llanfrynach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3449036,
        LOCATION_LATITUDE_DEG: 51.9219226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016900',
        LOCATION_NAME: 'Llanfwrog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5505894,
        LOCATION_LATITUDE_DEG: 53.3248675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL016800',
        LOCATION_NAME: 'Llanfwrog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3260504,
        LOCATION_LATITUDE_DEG: 53.1093394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017000',
        LOCATION_NAME: 'Llanfyllin',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2701971,
        LOCATION_LATITUDE_DEG: 52.7652008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017200',
        LOCATION_NAME: 'Llanfynydd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0966654,
        LOCATION_LATITUDE_DEG: 51.9275312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017100',
        LOCATION_NAME: 'Llanfynydd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0793842,
        LOCATION_LATITUDE_DEG: 53.1037312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017300',
        LOCATION_NAME: 'Llanfyrnach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.590105,
        LOCATION_LATITUDE_DEG: 51.9511429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017400',
        LOCATION_NAME: 'Llangadfan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4611556,
        LOCATION_LATITUDE_DEG: 52.684795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017500',
        LOCATION_NAME: 'Llangadog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8818595,
        LOCATION_LATITUDE_DEG: 51.938033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017600',
        LOCATION_NAME: 'Llangadwaladr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2208809,
        LOCATION_LATITUDE_DEG: 52.8605113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017700',
        LOCATION_NAME: 'Llangaffo',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3274856,
        LOCATION_LATITUDE_DEG: 53.1899568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017800',
        LOCATION_NAME: 'Llangain',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3457267,
        LOCATION_LATITUDE_DEG: 51.8184214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL017900',
        LOCATION_NAME: 'Llangammarch Wells',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5551158,
        LOCATION_LATITUDE_DEG: 52.1130405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018000',
        LOCATION_NAME: 'Llangan',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.500885,
        LOCATION_LATITUDE_DEG: 51.4867855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018100',
        LOCATION_NAME: 'Llangarron',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6832482,
        LOCATION_LATITUDE_DEG: 51.8866102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018200',
        LOCATION_NAME: 'Llangathen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0607885,
        LOCATION_LATITUDE_DEG: 51.8804287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018300',
        LOCATION_NAME: 'Llangattock',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1490117,
        LOCATION_LATITUDE_DEG: 51.8493165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018400',
        LOCATION_NAME: 'Llangattock Lingoed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9265423,
        LOCATION_LATITUDE_DEG: 51.8756122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039900',
        LOCATION_NAME: 'Llangattock Vibon Avel',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7857278,
        LOCATION_LATITUDE_DEG: 51.8459555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018500',
        LOCATION_NAME: 'Llangattock-Vibon-Avel',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7844776,
        LOCATION_LATITUDE_DEG: 51.8375112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018600',
        LOCATION_NAME: 'Llangawsai',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.068757,
        LOCATION_LATITUDE_DEG: 52.4105768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018700',
        LOCATION_NAME: 'Llangedwyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2098159,
        LOCATION_LATITUDE_DEG: 52.8093039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018800',
        LOCATION_NAME: 'Llangefni',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3113233,
        LOCATION_LATITUDE_DEG: 53.2565602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL018900',
        LOCATION_NAME: 'Llangeinor',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5662158,
        LOCATION_LATITUDE_DEG: 51.5763939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019000',
        LOCATION_NAME: 'Llangeitho',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0215945,
        LOCATION_LATITUDE_DEG: 52.217358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019100',
        LOCATION_NAME: 'Llangeler',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3707756,
        LOCATION_LATITUDE_DEG: 52.0284433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019200',
        LOCATION_NAME: 'Llangelynin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8487165,
        LOCATION_LATITUDE_DEG: 53.2330566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019300',
        LOCATION_NAME: 'Llangennech',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0823328,
        LOCATION_LATITUDE_DEG: 51.6955125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019400',
        LOCATION_NAME: 'Llangennith',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2690601,
        LOCATION_LATITUDE_DEG: 51.5998026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019500',
        LOCATION_NAME: 'Llangenny',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1007391,
        LOCATION_LATITUDE_DEG: 51.8555153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019600',
        LOCATION_NAME: 'Llangernyw',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6842009,
        LOCATION_LATITUDE_DEG: 53.1923474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019700',
        LOCATION_NAME: 'Llangeview',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8706615,
        LOCATION_LATITUDE_DEG: 51.6990973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019800',
        LOCATION_NAME: 'Llangewydd',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6291455,
        LOCATION_LATITUDE_DEG: 51.5214876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL019900',
        LOCATION_NAME: 'Llangian',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5307272,
        LOCATION_LATITUDE_DEG: 52.8305213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020000',
        LOCATION_NAME: 'Llangoed',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL58',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0865763,
        LOCATION_LATITUDE_DEG: 53.292366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020100',
        LOCATION_NAME: 'Llangoedmor',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6267546,
        LOCATION_LATITUDE_DEG: 52.0809503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020200',
        LOCATION_NAME: 'Llangollen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1689534,
        LOCATION_LATITUDE_DEG: 52.9701199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020300',
        LOCATION_NAME: 'Llangolman',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7382067,
        LOCATION_LATITUDE_DEG: 51.9078368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020400',
        LOCATION_NAME: 'Llangorse',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2588968,
        LOCATION_LATITUDE_DEG: 51.9397256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020500',
        LOCATION_NAME: 'Llangovan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7904134,
        LOCATION_LATITUDE_DEG: 51.7462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020600',
        LOCATION_NAME: 'Llangower',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6238892,
        LOCATION_LATITUDE_DEG: 52.8765162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020700',
        LOCATION_NAME: 'Llangrannog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4647102,
        LOCATION_LATITUDE_DEG: 52.1572911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020800',
        LOCATION_NAME: 'Llangristiolus',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3438943,
        LOCATION_LATITUDE_DEG: 53.236861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL020900',
        LOCATION_NAME: 'Llangrove',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6890784,
        LOCATION_LATITUDE_DEG: 51.8697071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021000',
        LOCATION_NAME: 'Llangua',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8829164,
        LOCATION_LATITUDE_DEG: 51.9276165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021100',
        LOCATION_NAME: 'Llangunllo',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.156971,
        LOCATION_LATITUDE_DEG: 52.3341617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021200',
        LOCATION_NAME: 'Llangunnor',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2807735,
        LOCATION_LATITUDE_DEG: 51.8578237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021300',
        LOCATION_NAME: 'Llangurig',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6050003,
        LOCATION_LATITUDE_DEG: 52.4061749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021600',
        LOCATION_NAME: 'Llangwm',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9171792,
        LOCATION_LATITUDE_DEG: 51.750227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021400',
        LOCATION_NAME: 'Llangwm',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5323678,
        LOCATION_LATITUDE_DEG: 52.9964252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021500',
        LOCATION_NAME: 'Llangwm',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8299383,
        LOCATION_LATITUDE_DEG: 51.6966943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021700',
        LOCATION_NAME: 'Llangwnadl',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6572435,
        LOCATION_LATITUDE_DEG: 52.8620276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021750',
        LOCATION_NAME: 'Llangwstenin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.776099,
        LOCATION_LATITUDE_DEG: 53.2992831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021800',
        LOCATION_NAME: 'Llangwyfan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3156208,
        LOCATION_LATITUDE_DEG: 53.1851474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL021900',
        LOCATION_NAME: 'Llangwyllog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3435642,
        LOCATION_LATITUDE_DEG: 53.2834639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022000',
        LOCATION_NAME: 'Llangwyryfon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0552395,
        LOCATION_LATITUDE_DEG: 52.3155714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022100',
        LOCATION_NAME: 'Llangybi',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.340559,
        LOCATION_LATITUDE_DEG: 52.9431345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022300',
        LOCATION_NAME: 'Llangybi',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0348827,
        LOCATION_LATITUDE_DEG: 52.1579566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022200',
        LOCATION_NAME: 'Llangybi',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9064299,
        LOCATION_LATITUDE_DEG: 51.6647902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022400',
        LOCATION_NAME: 'Llangyfelach',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9566058,
        LOCATION_LATITUDE_DEG: 51.6725018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022500',
        LOCATION_NAME: 'Llangyndeyrn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.239622,
        LOCATION_LATITUDE_DEG: 51.8024765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022600',
        LOCATION_NAME: 'Llangynhafal',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3025156,
        LOCATION_LATITUDE_DEG: 53.1616462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022700',
        LOCATION_NAME: 'Llangynidr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2262626,
        LOCATION_LATITUDE_DEG: 51.867115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022800',
        LOCATION_NAME: 'Llangyniew',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2819715,
        LOCATION_LATITUDE_DEG: 52.6663952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL022900',
        LOCATION_NAME: 'Llangynin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5392772,
        LOCATION_LATITUDE_DEG: 51.8470299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023000',
        LOCATION_NAME: 'Llangynog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4150152,
        LOCATION_LATITUDE_DEG: 51.8207237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023100',
        LOCATION_NAME: 'Llangynog',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4057386,
        LOCATION_LATITUDE_DEG: 52.8236077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023200',
        LOCATION_NAME: 'Llangynwyd',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.633249,
        LOCATION_LATITUDE_DEG: 51.5877917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023300',
        LOCATION_NAME: 'Llanhamlach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3231315,
        LOCATION_LATITUDE_DEG: 51.9298219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023400',
        LOCATION_NAME: 'Llanharan',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4381213,
        LOCATION_LATITUDE_DEG: 51.5379875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023500',
        LOCATION_NAME: 'Llanharry',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.431962,
        LOCATION_LATITUDE_DEG: 51.5135836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023600',
        LOCATION_NAME: 'Llanhennock',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9347178,
        LOCATION_LATITUDE_DEG: 51.6297943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023700',
        LOCATION_NAME: 'Llanhilleth',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.130688,
        LOCATION_LATITUDE_DEG: 51.6996971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023800',
        LOCATION_NAME: 'Llanidloes',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5388586,
        LOCATION_LATITUDE_DEG: 52.4485792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL023900',
        LOCATION_NAME: 'Llaniestyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5782776,
        LOCATION_LATITUDE_DEG: 52.87573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024000',
        LOCATION_NAME: 'Llanigon',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1487824,
        LOCATION_LATITUDE_DEG: 52.0544319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024100',
        LOCATION_NAME: 'Llanilar',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0210719,
        LOCATION_LATITUDE_DEG: 52.3559716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024200',
        LOCATION_NAME: 'Llanishen',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1882169,
        LOCATION_LATITUDE_DEG: 51.5288872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024300',
        LOCATION_NAME: 'Llanishen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7549481,
        LOCATION_LATITUDE_DEG: 51.7251933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024400',
        LOCATION_NAME: 'Llanllawddog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.235587,
        LOCATION_LATITUDE_DEG: 51.9418366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024500',
        LOCATION_NAME: 'Llanllechid',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0616549,
        LOCATION_LATITUDE_DEG: 53.1967524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024600',
        LOCATION_NAME: 'Llanllugan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3928032,
        LOCATION_LATITUDE_DEG: 52.6095862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024700',
        LOCATION_NAME: 'Llanllwch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3423295,
        LOCATION_LATITUDE_DEG: 51.8427273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024800',
        LOCATION_NAME: 'Llanllwchaiarn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3151531,
        LOCATION_LATITUDE_DEG: 52.5177805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL024900',
        LOCATION_NAME: 'Llanllwni',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.202914,
        LOCATION_LATITUDE_DEG: 52.0331418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025000',
        LOCATION_NAME: 'Llanllyfni',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.280706,
        LOCATION_LATITUDE_DEG: 53.044139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025100',
        LOCATION_NAME: 'Llanmadoc',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2538768,
        LOCATION_LATITUDE_DEG: 51.6172017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025200',
        LOCATION_NAME: 'Llanmaes',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4687317,
        LOCATION_LATITUDE_DEG: 51.4158763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025300',
        LOCATION_NAME: 'Llanmartin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8749403,
        LOCATION_LATITUDE_DEG: 51.6004895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025400',
        LOCATION_NAME: 'Llanmihangel',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4668119,
        LOCATION_LATITUDE_DEG: 51.4358744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025500',
        LOCATION_NAME: 'Llanmill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6972373,
        LOCATION_LATITUDE_DEG: 51.7951132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025600',
        LOCATION_NAME: 'Llanmiloe',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5307115,
        LOCATION_LATITUDE_DEG: 51.7502222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025700',
        LOCATION_NAME: 'Llanmorlais',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1258097,
        LOCATION_LATITUDE_DEG: 51.6310044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025800',
        LOCATION_NAME: 'Llannefydd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5240592,
        LOCATION_LATITUDE_DEG: 53.2222495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL012400',
        LOCATION_NAME: 'Llannerch-y-Medd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3758259,
        LOCATION_LATITUDE_DEG: 53.3302668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL025900',
        LOCATION_NAME: 'Llannon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1163228,
        LOCATION_LATITUDE_DEG: 51.7546134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026000',
        LOCATION_NAME: 'Llannor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4483363,
        LOCATION_LATITUDE_DEG: 52.9070329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026100',
        LOCATION_NAME: 'Llanon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1756336,
        LOCATION_LATITUDE_DEG: 52.2819663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026200',
        LOCATION_NAME: 'Llanover',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9922052,
        LOCATION_LATITUDE_DEG: 51.7651005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026300',
        LOCATION_NAME: 'Llanpumsaint',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3035512,
        LOCATION_LATITUDE_DEG: 51.9357322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026400',
        LOCATION_NAME: 'Llanreath',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9582715,
        LOCATION_LATITUDE_DEG: 51.6898145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026500',
        LOCATION_NAME: 'Llanrhaeadr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3742009,
        LOCATION_LATITUDE_DEG: 53.1602472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026600',
        LOCATION_NAME: 'Llanrhaeadr Ym Mochnant',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3001995,
        LOCATION_LATITUDE_DEG: 52.8249097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026700',
        LOCATION_NAME: 'Llanrhian',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.172824,
        LOCATION_LATITUDE_DEG: 51.9364022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026800',
        LOCATION_NAME: 'Llanrhidian',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1694316,
        LOCATION_LATITUDE_DEG: 51.6060039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL026900',
        LOCATION_NAME: 'Llanrhos',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8082161,
        LOCATION_LATITUDE_DEG: 53.3056606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027000',
        LOCATION_NAME: 'Llanrhwydrus',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5154842,
        LOCATION_LATITUDE_DEG: 53.3997805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027100',
        LOCATION_NAME: 'Llanrhychwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8383173,
        LOCATION_LATITUDE_DEG: 53.1326414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027200',
        LOCATION_NAME: 'Llanrhydd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2819574,
        LOCATION_LATITUDE_DEG: 53.0997348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027300',
        LOCATION_NAME: 'Llanrhyddlad',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5093618,
        LOCATION_LATITUDE_DEG: 53.3711706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027400',
        LOCATION_NAME: 'Llanrhystud',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1432194,
        LOCATION_LATITUDE_DEG: 52.3054641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027500',
        LOCATION_NAME: 'Llanrothal',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7708483,
        LOCATION_LATITUDE_DEG: 51.8656119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027600',
        LOCATION_NAME: 'Llanrug',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1919233,
        LOCATION_LATITUDE_DEG: 53.1477498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027700',
        LOCATION_NAME: 'Llanrumney',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1223973,
        LOCATION_LATITUDE_DEG: 51.5199849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027800',
        LOCATION_NAME: 'Llanrwst',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7978011,
        LOCATION_LATITUDE_DEG: 53.1408488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL027900',
        LOCATION_NAME: 'Llansadurnen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4908812,
        LOCATION_LATITUDE_DEG: 51.7645197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028100',
        LOCATION_NAME: 'Llansadwrn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL59',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1539689,
        LOCATION_LATITUDE_DEG: 53.2669621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028000',
        LOCATION_NAME: 'Llansadwrn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8985628,
        LOCATION_LATITUDE_DEG: 51.9666322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028200',
        LOCATION_NAME: 'Llansaint',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3400415,
        LOCATION_LATITUDE_DEG: 51.7476184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028300',
        LOCATION_NAME: 'Llansamlet',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8995989,
        LOCATION_LATITUDE_DEG: 51.6600018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028400',
        LOCATION_NAME: 'Llansannan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5999266,
        LOCATION_LATITUDE_DEG: 53.1785482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028500',
        LOCATION_NAME: 'Llansannor',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4485425,
        LOCATION_LATITUDE_DEG: 51.4864815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028600',
        LOCATION_NAME: 'Llansantffraed',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2758624,
        LOCATION_LATITUDE_DEG: 51.9023235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028700',
        LOCATION_NAME: 'Llansantffraid',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1530378,
        LOCATION_LATITUDE_DEG: 52.7742017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028800',
        LOCATION_NAME: 'Llansawel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0116531,
        LOCATION_LATITUDE_DEG: 52.0071384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL028900',
        LOCATION_NAME: 'Llansilin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1742477,
        LOCATION_LATITUDE_DEG: 52.8450137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029000',
        LOCATION_NAME: 'Llansoar',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9322683,
        LOCATION_LATITUDE_DEG: 51.6392919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029100',
        LOCATION_NAME: 'Llansoy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8081231,
        LOCATION_LATITUDE_DEG: 51.7189946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029200',
        LOCATION_NAME: 'Llanspyddid',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4386674,
        LOCATION_LATITUDE_DEG: 51.9433221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029300',
        LOCATION_NAME: 'Llanstadwell',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9688849,
        LOCATION_LATITUDE_DEG: 51.7049189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029400',
        LOCATION_NAME: 'Llansteffan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.391044,
        LOCATION_LATITUDE_DEG: 51.7709199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029500',
        LOCATION_NAME: 'Llanstephan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2790275,
        LOCATION_LATITUDE_DEG: 52.0688355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029600',
        LOCATION_NAME: 'Llantarnam',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9986816,
        LOCATION_LATITUDE_DEG: 51.6328917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029700',
        LOCATION_NAME: 'Llanteg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6350342,
        LOCATION_LATITUDE_DEG: 51.7612219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029800',
        LOCATION_NAME: 'Llanthony',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0363479,
        LOCATION_LATITUDE_DEG: 51.9426235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL029900',
        LOCATION_NAME: 'Llantilio Crossenny',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8771372,
        LOCATION_LATITUDE_DEG: 51.8303104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030000',
        LOCATION_NAME: 'Llantilio Pertholey',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0009844,
        LOCATION_LATITUDE_DEG: 51.8409127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030100',
        LOCATION_NAME: 'Llantood',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6910598,
        LOCATION_LATITUDE_DEG: 52.0450516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030300',
        LOCATION_NAME: 'Llantrisant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4576562,
        LOCATION_LATITUDE_DEG: 53.3236718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030200',
        LOCATION_NAME: 'Llantrisant',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3718818,
        LOCATION_LATITUDE_DEG: 51.5416856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030400',
        LOCATION_NAME: 'Llantrissent',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8805063,
        LOCATION_LATITUDE_DEG: 51.6679909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030500',
        LOCATION_NAME: 'Llantrithyd',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3769696,
        LOCATION_LATITUDE_DEG: 51.4454807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030600',
        LOCATION_NAME: 'Llantwit Fardre',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3347685,
        LOCATION_LATITUDE_DEG: 51.555792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030700',
        LOCATION_NAME: 'Llantwit Major',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4840382,
        LOCATION_LATITUDE_DEG: 51.4088755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030800',
        LOCATION_NAME: 'Llantysilio',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2012564,
        LOCATION_LATITUDE_DEG: 52.9846326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL030900',
        LOCATION_NAME: 'Llanuwchllyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6662852,
        LOCATION_LATITUDE_DEG: 52.8543133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031000',
        LOCATION_NAME: 'Llanvaches',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8189584,
        LOCATION_LATITUDE_DEG: 51.6214863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031100',
        LOCATION_NAME: 'Llanvair Discoed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7982262,
        LOCATION_LATITUDE_DEG: 51.6271865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031200',
        LOCATION_NAME: 'Llanvair Green',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8891398,
        LOCATION_LATITUDE_DEG: 51.866414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031300',
        LOCATION_NAME: 'Llanvair Kilgeddin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9430976,
        LOCATION_LATITUDE_DEG: 51.7571419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031400',
        LOCATION_NAME: 'Llanvapley',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9191842,
        LOCATION_LATITUDE_DEG: 51.8211049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031500',
        LOCATION_NAME: 'Llanvetherine',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.923961,
        LOCATION_LATITUDE_DEG: 51.849609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031600',
        LOCATION_NAME: 'Llanveynoe',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0152204,
        LOCATION_LATITUDE_DEG: 51.976726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031700',
        LOCATION_NAME: 'Llanvihangel',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.795259,
        LOCATION_LATITUDE_DEG: 51.5863805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031800',
        LOCATION_NAME: 'Llanvihangel Crucorney',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9789706,
        LOCATION_LATITUDE_DEG: 51.8801154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL031900',
        LOCATION_NAME: 'Llanvihangel Gobion',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9459742,
        LOCATION_LATITUDE_DEG: 51.7783048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032000',
        LOCATION_NAME: 'Llanwarne',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7182291,
        LOCATION_LATITUDE_DEG: 51.9497148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032100',
        LOCATION_NAME: 'Llanwddyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4504036,
        LOCATION_LATITUDE_DEG: 52.7608055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032200',
        LOCATION_NAME: 'Llanwenarth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1167798,
        LOCATION_LATITUDE_DEG: 51.8535117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032300',
        LOCATION_NAME: 'Llanwenarth',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0502029,
        LOCATION_LATITUDE_DEG: 51.8268061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032400',
        LOCATION_NAME: 'Llanwenog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1978992,
        LOCATION_LATITUDE_DEG: 52.0863497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032500',
        LOCATION_NAME: 'Llanwern',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9141919,
        LOCATION_LATITUDE_DEG: 51.5905863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032700',
        LOCATION_NAME: 'Llanwnda',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0135131,
        LOCATION_LATITUDE_DEG: 52.0150504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032600',
        LOCATION_NAME: 'Llanwnda',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2770262,
        LOCATION_LATITUDE_DEG: 53.0988454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032800',
        LOCATION_NAME: 'Llanwnen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1397976,
        LOCATION_LATITUDE_DEG: 52.1016192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL032900',
        LOCATION_NAME: 'Llanwnog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4407658,
        LOCATION_LATITUDE_DEG: 52.5326827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033000',
        LOCATION_NAME: 'Llanwonno',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4017378,
        LOCATION_LATITUDE_DEG: 51.6500936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033100',
        LOCATION_NAME: 'Llanwrda',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8724816,
        LOCATION_LATITUDE_DEG: 51.9675356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033200',
        LOCATION_NAME: 'Llanwrin',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7903392,
        LOCATION_LATITUDE_DEG: 52.6151959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033300',
        LOCATION_NAME: 'Llanwrthwl',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5006935,
        LOCATION_LATITUDE_DEG: 52.2620545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033400',
        LOCATION_NAME: 'Llanwrtyd Wells',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6371726,
        LOCATION_LATITUDE_DEG: 52.1070466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033500',
        LOCATION_NAME: 'Llanwyddelan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3541101,
        LOCATION_LATITUDE_DEG: 52.6001892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033600',
        LOCATION_NAME: 'Llanwysg',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2304925,
        LOCATION_LATITUDE_DEG: 51.870416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033700',
        LOCATION_NAME: 'Llanyblodwel',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1251867,
        LOCATION_LATITUDE_DEG: 52.798601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033800',
        LOCATION_NAME: 'Llanybri',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4121059,
        LOCATION_LATITUDE_DEG: 51.7858241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL033900',
        LOCATION_NAME: 'Llanybydder',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1502958,
        LOCATION_LATITUDE_DEG: 52.0730458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040700',
        LOCATION_NAME: 'Llanybyther',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1672583,
        LOCATION_LATITUDE_DEG: 52.1014412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034000',
        LOCATION_NAME: 'Llanycefn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7659967,
        LOCATION_LATITUDE_DEG: 51.8787372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034100',
        LOCATION_NAME: 'Llanychaer',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9315654,
        LOCATION_LATITUDE_DEG: 51.9799452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034200',
        LOCATION_NAME: 'Llanychan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3162644,
        LOCATION_LATITUDE_DEG: 53.1460401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034300',
        LOCATION_NAME: 'Llanycil',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6144484,
        LOCATION_LATITUDE_DEG: 52.900418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034400',
        LOCATION_NAME: 'Llanycrwys',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9783373,
        LOCATION_LATITUDE_DEG: 52.0889453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034500',
        LOCATION_NAME: 'Llanymawddwy',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6233973,
        LOCATION_LATITUDE_DEG: 52.7586088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034600',
        LOCATION_NAME: 'Llanymynech',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0874005,
        LOCATION_LATITUDE_DEG: 52.7806027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034700',
        LOCATION_NAME: 'Llanynghenedl',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5255888,
        LOCATION_LATITUDE_DEG: 53.3000685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034800',
        LOCATION_NAME: 'Llanynis',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4505034,
        LOCATION_LATITUDE_DEG: 52.137646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL034900',
        LOCATION_NAME: 'Llanynys',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3429495,
        LOCATION_LATITUDE_DEG: 53.1539416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL000400',
        LOCATION_NAME: 'Llan-y-Pwll',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9301259,
        LOCATION_LATITUDE_DEG: 53.0612257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035000',
        LOCATION_NAME: 'Llanyravon',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0041764,
        LOCATION_LATITUDE_DEG: 51.6467923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035100',
        LOCATION_NAME: 'Llanyre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3999501,
        LOCATION_LATITUDE_DEG: 52.2497592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035200',
        LOCATION_NAME: 'Llanystumdwy',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2674091,
        LOCATION_LATITUDE_DEG: 52.9209306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035300',
        LOCATION_NAME: 'Llawhaden',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8043861,
        LOCATION_LATITUDE_DEG: 51.8207307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035400',
        LOCATION_NAME: 'Llawnt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1149565,
        LOCATION_LATITUDE_DEG: 52.8701125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040000',
        LOCATION_NAME: 'Llawr y Glyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035500',
        LOCATION_NAME: 'Llawr-y-Glyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5774806,
        LOCATION_LATITUDE_DEG: 52.5059421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035600',
        LOCATION_NAME: 'Llay',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0013622,
        LOCATION_LATITUDE_DEG: 53.0974365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035800',
        LOCATION_NAME: 'Llechryd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6000069,
        LOCATION_LATITUDE_DEG: 52.0625486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035700',
        LOCATION_NAME: 'Llechryd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2943861,
        LOCATION_LATITUDE_DEG: 51.7764057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL035900',
        LOCATION_NAME: 'Llechwedd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8587217,
        LOCATION_LATITUDE_DEG: 53.2602611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036000',
        LOCATION_NAME: 'Lledrod',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9879759,
        LOCATION_LATITUDE_DEG: 52.314268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036100',
        LOCATION_NAME: 'Llethryd',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1115895,
        LOCATION_LATITUDE_DEG: 51.6030028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036200',
        LOCATION_NAME: 'Llidiardau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6796216,
        LOCATION_LATITUDE_DEG: 52.9292218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL040100',
        LOCATION_NAME: 'Llidiart y Parc',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036300',
        LOCATION_NAME: 'Llidiart-y-Parc',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3118738,
        LOCATION_LATITUDE_DEG: 52.9792287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036400',
        LOCATION_NAME: 'Llidiartywaun',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4695135,
        LOCATION_LATITUDE_DEG: 52.4211729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036500',
        LOCATION_NAME: 'Llithfaen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4476548,
        LOCATION_LATITUDE_DEG: 52.9603368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036600',
        LOCATION_NAME: 'Lloc',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.290033,
        LOCATION_LATITUDE_DEG: 53.2815538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036700',
        LOCATION_NAME: 'Llong',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1016691,
        LOCATION_LATITUDE_DEG: 53.1538378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036800',
        LOCATION_NAME: 'Llotrog',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1083839,
        LOCATION_LATITUDE_DEG: 51.6372995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036900',
        LOCATION_NAME: 'Llowes',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1784196,
        LOCATION_LATITUDE_DEG: 52.0665394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037000',
        LOCATION_NAME: 'Lloyney',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1080091,
        LOCATION_LATITUDE_DEG: 52.3742661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037100',
        LOCATION_NAME: 'Llwydcoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4571678,
        LOCATION_LATITUDE_DEG: 51.7349052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037200',
        LOCATION_NAME: 'Llwyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0463262,
        LOCATION_LATITUDE_DEG: 52.4161713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037300',
        LOCATION_NAME: 'Llwyn Du',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0316737,
        LOCATION_LATITUDE_DEG: 51.8371135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037400',
        LOCATION_NAME: 'Llwyn Hudol',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3979764,
        LOCATION_LATITUDE_DEG: 52.9006328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037500',
        LOCATION_NAME: 'Llwyncelyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.281056,
        LOCATION_LATITUDE_DEG: 52.2110617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037600',
        LOCATION_NAME: 'Llwyncelyn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3983219,
        LOCATION_LATITUDE_DEG: 51.6118965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037700',
        LOCATION_NAME: 'Llwyndafydd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3823163,
        LOCATION_LATITUDE_DEG: 52.1729606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037800',
        LOCATION_NAME: 'Llwynderw',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1732764,
        LOCATION_LATITUDE_DEG: 52.6257928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL037900',
        LOCATION_NAME: 'Llwyndrain',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.525175,
        LOCATION_LATITUDE_DEG: 51.9817393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038000',
        LOCATION_NAME: 'Llwyndyrys',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4203289,
        LOCATION_LATITUDE_DEG: 52.9414369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038100',
        LOCATION_NAME: 'Llwyngwril',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0833296,
        LOCATION_LATITUDE_DEG: 52.6646996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038200',
        LOCATION_NAME: 'Llwynhendy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1170544,
        LOCATION_LATITUDE_DEG: 51.6782086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038300',
        LOCATION_NAME: 'Llwynmawr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1531722,
        LOCATION_LATITUDE_DEG: 52.924421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038400',
        LOCATION_NAME: 'Llwynygroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0556832,
        LOCATION_LATITUDE_DEG: 52.1892239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038500',
        LOCATION_NAME: 'Llwynypia',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4562813,
        LOCATION_LATITUDE_DEG: 51.6247981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038600',
        LOCATION_NAME: 'Llynclys',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.064955,
        LOCATION_LATITUDE_DEG: 52.8093076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL990680',
        LOCATION_NAME: 'Llynfaes',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038700',
        LOCATION_NAME: 'Llys Dulas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2840575,
        LOCATION_LATITUDE_DEG: 53.3767755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038800',
        LOCATION_NAME: 'Llysdinam',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4494081,
        LOCATION_LATITUDE_DEG: 52.2150552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL038900',
        LOCATION_NAME: 'Llysfaen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.659947,
        LOCATION_LATITUDE_DEG: 53.2821566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039000',
        LOCATION_NAME: 'Llysfasi',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2717459,
        LOCATION_LATITUDE_DEG: 53.0614361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039100',
        LOCATION_NAME: 'Llyswen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2643126,
        LOCATION_LATITUDE_DEG: 52.0329356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039200',
        LOCATION_NAME: 'Llysworney',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.491885,
        LOCATION_LATITUDE_DEG: 51.4559816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039300',
        LOCATION_NAME: 'Llysyfran',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8386257,
        LOCATION_LATITUDE_DEG: 51.8834823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL039400',
        LOCATION_NAME: 'Llywel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6448012,
        LOCATION_LATITUDE_DEG: 51.9574296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000100',
        LOCATION_NAME: 'Loaneckheim',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4963489,
        LOCATION_LATITUDE_DEG: 57.4253707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000200',
        LOCATION_NAME: 'Loanhead',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1507483,
        LOCATION_LATITUDE_DEG: 55.8806022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000300',
        LOCATION_NAME: 'Loans',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6235467,
        LOCATION_LATITUDE_DEG: 55.5509928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000400',
        LOCATION_NAME: 'Loans Of Tullich',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9240334,
        LOCATION_LATITUDE_DEG: 57.7681023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000500',
        LOCATION_NAME: 'Lobb',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1837318,
        LOCATION_LATITUDE_DEG: 51.1204591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078600',
        LOCATION_NAME: 'Lobbs Shop',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000600',
        LOCATION_NAME: "Lobb's Shop",
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7883873,
        LOCATION_LATITUDE_DEG: 50.3071835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000800',
        LOCATION_NAME: 'Lobley Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6356288,
        LOCATION_LATITUDE_DEG: 54.9412919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000900',
        LOCATION_NAME: 'Lobthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5871306,
        LOCATION_LATITUDE_DEG: 52.7720751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001000',
        LOCATION_NAME: 'Loch Eck',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9805523,
        LOCATION_LATITUDE_DEG: 56.0537463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001200',
        LOCATION_NAME: 'Loch Katrine',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4864828,
        LOCATION_LATITUDE_DEG: 56.2660613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001300',
        LOCATION_NAME: 'Loch Nevis',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5764807,
        LOCATION_LATITUDE_DEG: 56.9830412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990686',
        LOCATION_NAME: 'Loch Rannoch',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001400',
        LOCATION_NAME: 'Lochailort',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6653813,
        LOCATION_LATITUDE_DEG: 56.8785341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001500',
        LOCATION_NAME: 'Lochaline',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7774341,
        LOCATION_LATITUDE_DEG: 56.5394033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001600',
        LOCATION_NAME: 'Lochanhead',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6955387,
        LOCATION_LATITUDE_DEG: 55.0260291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001700',
        LOCATION_NAME: 'Lochans',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0119762,
        LOCATION_LATITUDE_DEG: 54.8663267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001800',
        LOCATION_NAME: 'Locharbriggs',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5801545,
        LOCATION_LATITUDE_DEG: 55.1077308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001900',
        LOCATION_NAME: 'Lochavich',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3149104,
        LOCATION_LATITUDE_DEG: 56.2864717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002000',
        LOCATION_NAME: 'Lochawe',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0415684,
        LOCATION_LATITUDE_DEG: 56.4025797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002100',
        LOCATION_NAME: 'Lochbay',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5613489,
        LOCATION_LATITUDE_DEG: 57.4969049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002200',
        LOCATION_NAME: 'Lochboisdale',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3070925,
        LOCATION_LATITUDE_DEG: 57.153574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002300',
        LOCATION_NAME: 'Lochbroom',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0573935,
        LOCATION_LATITUDE_DEG: 57.8210216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002400',
        LOCATION_NAME: 'Lochbuie',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8720814,
        LOCATION_LATITUDE_DEG: 56.3561841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002500',
        LOCATION_NAME: 'Lochcarnan',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3105648,
        LOCATION_LATITUDE_DEG: 57.3718932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002600',
        LOCATION_NAME: 'Lochcarron',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5003106,
        LOCATION_LATITUDE_DEG: 57.3981789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002700',
        LOCATION_NAME: 'Lochcroistean',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9028971,
        LOCATION_LATITUDE_DEG: 58.1644683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002800',
        LOCATION_NAME: 'Lochdon',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6738109,
        LOCATION_LATITUDE_DEG: 56.4376906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO002900',
        LOCATION_NAME: 'Lochearnhead',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2859885,
        LOCATION_LATITUDE_DEG: 56.38537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003000',
        LOCATION_NAME: 'Lochee',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0107403,
        LOCATION_LATITUDE_DEG: 56.4719612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003100',
        LOCATION_NAME: 'Lochend',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2631243,
        LOCATION_LATITUDE_DEG: 58.5963797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO081400',
        LOCATION_NAME: 'Lochend',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1479256,
        LOCATION_LATITUDE_DEG: 55.9626037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003200',
        LOCATION_NAME: 'Locheport',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2604793,
        LOCATION_LATITUDE_DEG: 57.5520148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003300',
        LOCATION_NAME: 'Lochetive',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1319531,
        LOCATION_LATITUDE_DEG: 56.467783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003400',
        LOCATION_NAME: 'Locheynort',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3713779,
        LOCATION_LATITUDE_DEG: 57.2481792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003500',
        LOCATION_NAME: 'Lochfoot',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7218095,
        LOCATION_LATITUDE_DEG: 55.0457317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003600',
        LOCATION_NAME: 'Lochgair',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3379614,
        LOCATION_LATITUDE_DEG: 56.0615459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003700',
        LOCATION_NAME: 'Lochgelly',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3084679,
        LOCATION_LATITUDE_DEG: 56.1293311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003800',
        LOCATION_NAME: 'Lochgilphead',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4313227,
        LOCATION_LATITUDE_DEG: 56.0391472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO003900',
        LOCATION_NAME: 'Lochgoilhead',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8983539,
        LOCATION_LATITUDE_DEG: 56.1657514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004000',
        LOCATION_NAME: 'Lochhills',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1969507,
        LOCATION_LATITUDE_DEG: 57.6701803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004100',
        LOCATION_NAME: 'Lochinver',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2390953,
        LOCATION_LATITUDE_DEG: 58.152155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004200',
        LOCATION_NAME: 'Lochluichart',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7980418,
        LOCATION_LATITUDE_DEG: 57.6275979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004300',
        LOCATION_NAME: 'Lochmaben',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.439287,
        LOCATION_LATITUDE_DEG: 55.1282346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004400',
        LOCATION_NAME: 'Lochmaddy',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1625083,
        LOCATION_LATITUDE_DEG: 57.6020175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004500',
        LOCATION_NAME: 'Lochmaree',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4898456,
        LOCATION_LATITUDE_DEG: 57.6733122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004600',
        LOCATION_NAME: 'Lochnaw',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0485973,
        LOCATION_LATITUDE_DEG: 56.4049152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004700',
        LOCATION_NAME: 'Lochore',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3206471,
        LOCATION_LATITUDE_DEG: 56.1546331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004800',
        LOCATION_NAME: 'Lochportan',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1217815,
        LOCATION_LATITUDE_DEG: 57.6351205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO004900',
        LOCATION_NAME: 'Lochranza',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2930598,
        LOCATION_LATITUDE_DEG: 55.7048135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005000',
        LOCATION_NAME: 'Lochrosque',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0824279,
        LOCATION_LATITUDE_DEG: 57.6239998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005100',
        LOCATION_NAME: 'Lochrutton',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7185602,
        LOCATION_LATITUDE_DEG: 55.0433327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005200',
        LOCATION_NAME: 'Lochs',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4821738,
        LOCATION_LATITUDE_DEG: 58.1048641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005300',
        LOCATION_NAME: 'Lochside',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9203044,
        LOCATION_LATITUDE_DEG: 58.2944576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005400',
        LOCATION_NAME: 'Lochskipport',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2797189,
        LOCATION_LATITUDE_DEG: 57.3279878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005500',
        LOCATION_NAME: 'Lochslin',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9535383,
        LOCATION_LATITUDE_DEG: 57.8010048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005600',
        LOCATION_NAME: 'Lochussie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4826392,
        LOCATION_LATITUDE_DEG: 57.5767874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005700',
        LOCATION_NAME: 'Lochwinnoch',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6261315,
        LOCATION_LATITUDE_DEG: 55.7959147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005800',
        LOCATION_NAME: 'Lochyside',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0869362,
        LOCATION_LATITUDE_DEG: 56.8358186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO005900',
        LOCATION_NAME: 'Lockengate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7707342,
        LOCATION_LATITUDE_DEG: 50.4182952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006000',
        LOCATION_NAME: 'Lockerbie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3545445,
        LOCATION_LATITUDE_DEG: 55.1201373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006100',
        LOCATION_NAME: 'Lockeridge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7872976,
        LOCATION_LATITUDE_DEG: 51.4096518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006200',
        LOCATION_NAME: 'Lockerley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5760603,
        LOCATION_LATITUDE_DEG: 51.03872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006300',
        LOCATION_NAME: 'Locking',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9110067,
        LOCATION_LATITUDE_DEG: 51.3334614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006400',
        LOCATION_NAME: 'Lockinge',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3862627,
        LOCATION_LATITUDE_DEG: 51.5856715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006600',
        LOCATION_NAME: 'Lockington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3070828,
        LOCATION_LATITUDE_DEG: 52.846389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006500',
        LOCATION_NAME: 'Lockington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4830485,
        LOCATION_LATITUDE_DEG: 53.9123807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO081300',
        LOCATION_NAME: 'Lockleaze',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5697754,
        LOCATION_LATITUDE_DEG: 51.4892951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006700',
        LOCATION_NAME: 'Lockley Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4600649,
        LOCATION_LATITUDE_DEG: 52.8457215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006800',
        LOCATION_NAME: 'Locks Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2760504,
        LOCATION_LATITUDE_DEG: 50.8635012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990240',
        LOCATION_NAME: 'Locksbottom',
        COUNTY_NAME: 'Kent',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0521895,
        LOCATION_LATITUDE_DEG: 51.3923515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO006900',
        LOCATION_NAME: 'Lockton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7013482,
        LOCATION_LATITUDE_DEG: 54.2977214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007000',
        LOCATION_NAME: 'Lockwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7952006,
        LOCATION_LATITUDE_DEG: 53.632969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007100',
        LOCATION_NAME: 'Loddington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8345757,
        LOCATION_LATITUDE_DEG: 52.612761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007200',
        LOCATION_NAME: 'Loddington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8027328,
        LOCATION_LATITUDE_DEG: 52.3973403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007300',
        LOCATION_NAME: 'Loddiswell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7975844,
        LOCATION_LATITUDE_DEG: 50.3223797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007400',
        LOCATION_NAME: 'Loddon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4830248,
        LOCATION_LATITUDE_DEG: 52.5350204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007500',
        LOCATION_NAME: 'Lode',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.246075,
        LOCATION_LATITUDE_DEG: 52.2408077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007600',
        LOCATION_NAME: 'Loders',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7132571,
        LOCATION_LATITUDE_DEG: 50.7438067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007700',
        LOCATION_NAME: 'Loders Cross',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7027969,
        LOCATION_LATITUDE_DEG: 50.732502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO081100',
        LOCATION_NAME: 'Lodge Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9587896,
        LOCATION_LATITUDE_DEG: 52.4403942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007800',
        LOCATION_NAME: 'Lodge Lees',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1457608,
        LOCATION_LATITUDE_DEG: 51.1677982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079100',
        LOCATION_NAME: 'Lodgemoor',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO007900',
        LOCATION_NAME: 'Lodsworth',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6782652,
        LOCATION_LATITUDE_DEG: 51.0010039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008100',
        LOCATION_NAME: 'Lofthouse',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8442536,
        LOCATION_LATITUDE_DEG: 54.1556203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008000',
        LOCATION_NAME: 'Lofthouse',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4943148,
        LOCATION_LATITUDE_DEG: 53.7264728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008200',
        LOCATION_NAME: 'Lofthouse Gate',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4950792,
        LOCATION_LATITUDE_DEG: 53.7170732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008300',
        LOCATION_NAME: 'Loftus',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8834571,
        LOCATION_LATITUDE_DEG: 54.5535452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008400',
        LOCATION_NAME: 'Logan',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.237342,
        LOCATION_LATITUDE_DEG: 55.4574761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008500',
        LOCATION_NAME: 'Loggans',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4013501,
        LOCATION_LATITUDE_DEG: 50.1968823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008600',
        LOCATION_NAME: 'Loggerheads',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3887934,
        LOCATION_LATITUDE_DEG: 52.9195092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008700',
        LOCATION_NAME: 'Loggie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.118446,
        LOCATION_LATITUDE_DEG: 57.8639212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009100',
        LOCATION_NAME: 'Logie',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9054257,
        LOCATION_LATITUDE_DEG: 56.1499382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009200',
        LOCATION_NAME: 'Logie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4292201,
        LOCATION_LATITUDE_DEG: 56.6005824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009000',
        LOCATION_NAME: 'Logie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.966575,
        LOCATION_LATITUDE_DEG: 56.3732553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009300',
        LOCATION_NAME: 'Logie Coldstone',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9333328,
        LOCATION_LATITUDE_DEG: 57.1271289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009400',
        LOCATION_NAME: 'Logie Pert',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5460437,
        LOCATION_LATITUDE_DEG: 56.7687826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009500',
        LOCATION_NAME: 'Logierait',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6783351,
        LOCATION_LATITUDE_DEG: 56.6476863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009600',
        LOCATION_NAME: 'Logierieve',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1314929,
        LOCATION_LATITUDE_DEG: 57.331441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009700',
        LOCATION_NAME: 'Login',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6652267,
        LOCATION_LATITUDE_DEG: 51.8777366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009800',
        LOCATION_NAME: 'Lois Weedon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1258217,
        LOCATION_LATITUDE_DEG: 52.1176818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO009900',
        LOCATION_NAME: 'Lolworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0071758,
        LOCATION_LATITUDE_DEG: 52.2609133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010100',
        LOCATION_NAME: 'Lonbain',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8611513,
        LOCATION_LATITUDE_DEG: 57.5060941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010200',
        LOCATION_NAME: 'Londesborough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6814932,
        LOCATION_LATITUDE_DEG: 53.8979853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080900',
        LOCATION_NAME: 'London Airport',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4512947,
        LOCATION_LATITUDE_DEG: 51.4751829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010300',
        LOCATION_NAME: 'London Apprentice',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.799089,
        LOCATION_LATITUDE_DEG: 50.3171819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010400',
        LOCATION_NAME: 'London Colney',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3044737,
        LOCATION_LATITUDE_DEG: 51.7050609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010500',
        LOCATION_NAME: 'London E 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0585021,
        LOCATION_LATITUDE_DEG: 51.5145653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010600',
        LOCATION_NAME: 'London E 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'E2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0621883,
        LOCATION_LATITUDE_DEG: 51.5292589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010700',
        LOCATION_NAME: 'London E 3',
        COUNTY_NAME: 'London',
        POSTCODE: 'E3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0257751,
        LOCATION_LATITUDE_DEG: 51.5277073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010800',
        LOCATION_NAME: 'London E 4',
        COUNTY_NAME: 'London',
        POSTCODE: 'E4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0054817,
        LOCATION_LATITUDE_DEG: 51.6320137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010900',
        LOCATION_NAME: 'London E 5',
        COUNTY_NAME: 'London',
        POSTCODE: 'E5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0526596,
        LOCATION_LATITUDE_DEG: 51.5609564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011000',
        LOCATION_NAME: 'London E 6',
        COUNTY_NAME: 'London',
        POSTCODE: 'E6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0579746,
        LOCATION_LATITUDE_DEG: 51.522724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011100',
        LOCATION_NAME: 'London E 7',
        COUNTY_NAME: 'London',
        POSTCODE: 'E7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0278194,
        LOCATION_LATITUDE_DEG: 51.5481529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011200',
        LOCATION_NAME: 'London E 8',
        COUNTY_NAME: 'London',
        POSTCODE: 'E8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0666596,
        LOCATION_LATITUDE_DEG: 51.5435156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011300',
        LOCATION_NAME: 'London E 9',
        COUNTY_NAME: 'London',
        POSTCODE: 'E9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0383915,
        LOCATION_LATITUDE_DEG: 51.544809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011400',
        LOCATION_NAME: 'London E10',
        COUNTY_NAME: 'London',
        POSTCODE: 'E10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0212149,
        LOCATION_LATITUDE_DEG: 51.5660243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011500',
        LOCATION_NAME: 'London E11',
        COUNTY_NAME: 'London',
        POSTCODE: 'E11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0172546,
        LOCATION_LATITUDE_DEG: 51.5695422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011600',
        LOCATION_NAME: 'London E12',
        COUNTY_NAME: 'London',
        POSTCODE: 'E12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0494797,
        LOCATION_LATITUDE_DEG: 51.5531457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011700',
        LOCATION_NAME: 'London E13',
        COUNTY_NAME: 'London',
        POSTCODE: 'E13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0254308,
        LOCATION_LATITUDE_DEG: 51.5268521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011800',
        LOCATION_NAME: 'London E14',
        COUNTY_NAME: 'London',
        POSTCODE: 'E14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0170824,
        LOCATION_LATITUDE_DEG: 51.5047706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO011900',
        LOCATION_NAME: 'London E15',
        COUNTY_NAME: 'London',
        POSTCODE: 'E15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.00171,
        LOCATION_LATITUDE_DEG: 51.5395671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012000',
        LOCATION_NAME: 'London E16',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0342801,
        LOCATION_LATITUDE_DEG: 51.5076861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012100',
        LOCATION_NAME: 'London E17',
        COUNTY_NAME: 'London',
        POSTCODE: 'E17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.022074,
        LOCATION_LATITUDE_DEG: 51.5884508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012200',
        LOCATION_NAME: 'London E18',
        COUNTY_NAME: 'London',
        POSTCODE: 'E18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0236289,
        LOCATION_LATITUDE_DEG: 51.591206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990375',
        LOCATION_NAME: 'London E20',
        COUNTY_NAME: 'London',
        POSTCODE: 'E20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0164968,
        LOCATION_LATITUDE_DEG: 51.5481012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012300',
        LOCATION_NAME: 'London EC 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1062648,
        LOCATION_LATITUDE_DEG: 51.5202838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012400',
        LOCATION_NAME: 'London EC 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0883207,
        LOCATION_LATITUDE_DEG: 51.518122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012500',
        LOCATION_NAME: 'London EC 3',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0819004,
        LOCATION_LATITUDE_DEG: 51.5113889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012600',
        LOCATION_NAME: 'London EC 4',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0986735,
        LOCATION_LATITUDE_DEG: 51.5125254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080500',
        LOCATION_NAME: 'London Fields',
        COUNTY_NAME: 'London',
        POSTCODE: 'E8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0569955,
        LOCATION_LATITUDE_DEG: 51.5442013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012700',
        LOCATION_NAME: 'London Gatwick Airport',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.167428,
        LOCATION_LATITUDE_DEG: 51.1539142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012800',
        LOCATION_NAME: 'London Heathrow Airport',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4524057,
        LOCATION_LATITUDE_DEG: 51.4687404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO012900',
        LOCATION_NAME: 'London Luton Airport',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3732727,
        LOCATION_LATITUDE_DEG: 51.8774836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013000',
        LOCATION_NAME: 'London N 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0984509,
        LOCATION_LATITUDE_DEG: 51.5379376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013100',
        LOCATION_NAME: 'London N 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'N2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1702801,
        LOCATION_LATITUDE_DEG: 51.5880225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013200',
        LOCATION_NAME: 'London N 3',
        COUNTY_NAME: 'London',
        POSTCODE: 'N3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1949297,
        LOCATION_LATITUDE_DEG: 51.5991873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013300',
        LOCATION_NAME: 'London N 4',
        COUNTY_NAME: 'London',
        POSTCODE: 'N4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1030853,
        LOCATION_LATITUDE_DEG: 51.5704074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013400',
        LOCATION_NAME: 'London N 5',
        COUNTY_NAME: 'London',
        POSTCODE: 'N5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0988734,
        LOCATION_LATITUDE_DEG: 51.5534044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013500',
        LOCATION_NAME: 'London N 6',
        COUNTY_NAME: 'London',
        POSTCODE: 'N6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1530008,
        LOCATION_LATITUDE_DEG: 51.572301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013600',
        LOCATION_NAME: 'London N 7',
        COUNTY_NAME: 'London',
        POSTCODE: 'N7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1194167,
        LOCATION_LATITUDE_DEG: 51.5523595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013700',
        LOCATION_NAME: 'London N 8',
        COUNTY_NAME: 'London',
        POSTCODE: 'N8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1195943,
        LOCATION_LATITUDE_DEG: 51.5840735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013800',
        LOCATION_NAME: 'London N 9',
        COUNTY_NAME: 'London',
        POSTCODE: 'N9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0553211,
        LOCATION_LATITUDE_DEG: 51.6287399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO013900',
        LOCATION_NAME: 'London N10',
        COUNTY_NAME: 'London',
        POSTCODE: 'N10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1462282,
        LOCATION_LATITUDE_DEG: 51.594381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014000',
        LOCATION_NAME: 'London N11',
        COUNTY_NAME: 'London',
        POSTCODE: 'N11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1413241,
        LOCATION_LATITUDE_DEG: 51.614053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014100',
        LOCATION_NAME: 'London N12',
        COUNTY_NAME: 'London',
        POSTCODE: 'N12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1799808,
        LOCATION_LATITUDE_DEG: 51.6140563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014200',
        LOCATION_NAME: 'London N13',
        COUNTY_NAME: 'London',
        POSTCODE: 'N13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1048928,
        LOCATION_LATITUDE_DEG: 51.6178413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014300',
        LOCATION_NAME: 'London N14',
        COUNTY_NAME: 'London',
        POSTCODE: 'N14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1311848,
        LOCATION_LATITUDE_DEG: 51.6347567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014400',
        LOCATION_NAME: 'London N15',
        COUNTY_NAME: 'London',
        POSTCODE: 'N15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.078,
        LOCATION_LATITUDE_DEG: 51.5824372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014500',
        LOCATION_NAME: 'London N16',
        COUNTY_NAME: 'London',
        POSTCODE: 'N16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0774847,
        LOCATION_LATITUDE_DEG: 51.5631826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014600',
        LOCATION_NAME: 'London N17',
        COUNTY_NAME: 'London',
        POSTCODE: 'N17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0682175,
        LOCATION_LATITUDE_DEG: 51.5966123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014700',
        LOCATION_NAME: 'London N18',
        COUNTY_NAME: 'London',
        POSTCODE: 'N18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0625403,
        LOCATION_LATITUDE_DEG: 51.6132826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014800',
        LOCATION_NAME: 'London N19',
        COUNTY_NAME: 'London',
        POSTCODE: 'N19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1316983,
        LOCATION_LATITUDE_DEG: 51.5649128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO014900',
        LOCATION_NAME: 'London N20',
        COUNTY_NAME: 'London',
        POSTCODE: 'N20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1913318,
        LOCATION_LATITUDE_DEG: 51.630123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015000',
        LOCATION_NAME: 'London N21',
        COUNTY_NAME: 'London',
        POSTCODE: 'N21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1002604,
        LOCATION_LATITUDE_DEG: 51.63605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015100',
        LOCATION_NAME: 'London N22',
        COUNTY_NAME: 'London',
        POSTCODE: 'N22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1129695,
        LOCATION_LATITUDE_DEG: 51.5993639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015200',
        LOCATION_NAME: 'London NW 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1454488,
        LOCATION_LATITUDE_DEG: 51.533384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015300',
        LOCATION_NAME: 'London NW 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.22329,
        LOCATION_LATITUDE_DEG: 51.5600043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015400',
        LOCATION_NAME: 'London NW 3',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1741408,
        LOCATION_LATITUDE_DEG: 51.5554634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015500',
        LOCATION_NAME: 'London NW 4',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2255286,
        LOCATION_LATITUDE_DEG: 51.5892216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015600',
        LOCATION_NAME: 'London NW 5',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.145629,
        LOCATION_LATITUDE_DEG: 51.5523631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015700',
        LOCATION_NAME: 'London NW 6',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1994009,
        LOCATION_LATITUDE_DEG: 51.5416262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015800',
        LOCATION_NAME: 'London NW 7',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2345397,
        LOCATION_LATITUDE_DEG: 51.6189546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO015900',
        LOCATION_NAME: 'London NW 8',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.173625,
        LOCATION_LATITUDE_DEG: 51.5326839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016000',
        LOCATION_NAME: 'London NW 9',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2592015,
        LOCATION_LATITUDE_DEG: 51.5845818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016100',
        LOCATION_NAME: 'London NW10',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2520716,
        LOCATION_LATITUDE_DEG: 51.5393921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016200',
        LOCATION_NAME: 'London NW11',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1964833,
        LOCATION_LATITUDE_DEG: 51.5771054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016300',
        LOCATION_NAME: 'London SE 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0945815,
        LOCATION_LATITUDE_DEG: 51.4986718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016400',
        LOCATION_NAME: 'London SE 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1172638,
        LOCATION_LATITUDE_DEG: 51.4889578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016500',
        LOCATION_NAME: 'London SE 3',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0208593,
        LOCATION_LATITUDE_DEG: 51.4688582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016600',
        LOCATION_NAME: 'London SE 4',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0343536,
        LOCATION_LATITUDE_DEG: 51.459742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016700',
        LOCATION_NAME: 'London SE 5',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.091404,
        LOCATION_LATITUDE_DEG: 51.4726374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016800',
        LOCATION_NAME: 'London SE 6',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0157276,
        LOCATION_LATITUDE_DEG: 51.4374114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO016900',
        LOCATION_NAME: 'London SE 7',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.033495,
        LOCATION_LATITUDE_DEG: 51.4855211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017000',
        LOCATION_NAME: 'London SE 8',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0304107,
        LOCATION_LATITUDE_DEG: 51.48243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017100',
        LOCATION_NAME: 'London SE 9',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0561754,
        LOCATION_LATITUDE_DEG: 51.4453097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017200',
        LOCATION_NAME: 'London SE10',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 4.2182512,
        LOCATION_LATITUDE_DEG: 51.486216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017300',
        LOCATION_NAME: 'London SE11',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1128936,
        LOCATION_LATITUDE_DEG: 51.488958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017400',
        LOCATION_NAME: 'London SE12',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0194067,
        LOCATION_LATITUDE_DEG: 51.4441143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017500',
        LOCATION_NAME: 'London SE13',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0101352,
        LOCATION_LATITUDE_DEG: 51.4588028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017600',
        LOCATION_NAME: 'London SE14',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0431185,
        LOCATION_LATITUDE_DEG: 51.4749532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017700',
        LOCATION_NAME: 'London SE15',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0640856,
        LOCATION_LATITUDE_DEG: 51.4709214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017800',
        LOCATION_NAME: 'London SE16',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0515426,
        LOCATION_LATITUDE_DEG: 51.4962647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO017900',
        LOCATION_NAME: 'London SE17',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0942442,
        LOCATION_LATITUDE_DEG: 51.4874152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018000',
        LOCATION_NAME: 'London SE18',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0712089,
        LOCATION_LATITUDE_DEG: 51.4813982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018100',
        LOCATION_NAME: 'London SE19',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.08686,
        LOCATION_LATITUDE_DEG: 51.417387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018200',
        LOCATION_NAME: 'London SE20',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0607415,
        LOCATION_LATITUDE_DEG: 51.4115524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018300',
        LOCATION_NAME: 'London SE21',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0866887,
        LOCATION_LATITUDE_DEG: 51.4404261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018400',
        LOCATION_NAME: 'London SE22',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0713013,
        LOCATION_LATITUDE_DEG: 51.4538264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018500',
        LOCATION_NAME: 'London SE23',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0495627,
        LOCATION_LATITUDE_DEG: 51.4423864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018600',
        LOCATION_NAME: 'London SE24',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1000918,
        LOCATION_LATITUDE_DEG: 51.4541707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018700',
        LOCATION_NAME: 'London SE25',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0768905,
        LOCATION_LATITUDE_DEG: 51.3968619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018800',
        LOCATION_NAME: 'London SE26',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0559285,
        LOCATION_LATITUDE_DEG: 51.4273646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO018900',
        LOCATION_NAME: 'London SE27',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1031732,
        LOCATION_LATITUDE_DEG: 51.4301894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019000',
        LOCATION_NAME: 'London SE28',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1009435,
        LOCATION_LATITUDE_DEG: 51.5027962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021100',
        LOCATION_NAME: 'London Stansted Airport',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2220205,
        LOCATION_LATITUDE_DEG: 51.8813785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019100',
        LOCATION_NAME: 'London SW 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.142371,
        LOCATION_LATITUDE_DEG: 51.4956343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019200',
        LOCATION_NAME: 'London SW 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1200924,
        LOCATION_LATITUDE_DEG: 51.4477299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019300',
        LOCATION_NAME: 'London SW 3',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1658845,
        LOCATION_LATITUDE_DEG: 51.4877574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019400',
        LOCATION_NAME: 'London SW 4',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1397796,
        LOCATION_LATITUDE_DEG: 51.4598347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019500',
        LOCATION_NAME: 'London SW 5',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1933895,
        LOCATION_LATITUDE_DEG: 51.4912872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019600',
        LOCATION_NAME: 'London SW 6',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2038678,
        LOCATION_LATITUDE_DEG: 51.475044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990313',
        LOCATION_NAME: 'London SW 7',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.17999,
        LOCATION_LATITUDE_DEG: 51.4942097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019800',
        LOCATION_NAME: 'London SW 8',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.135739,
        LOCATION_LATITUDE_DEG: 51.4770202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO019900',
        LOCATION_NAME: 'London SW 9',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1142492,
        LOCATION_LATITUDE_DEG: 51.469023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020000',
        LOCATION_NAME: 'London SW10',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1835133,
        LOCATION_LATITUDE_DEG: 51.4827796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020100',
        LOCATION_NAME: 'London SW11',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1665758,
        LOCATION_LATITUDE_DEG: 51.4676496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020200',
        LOCATION_NAME: 'London SW12',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1492316,
        LOCATION_LATITUDE_DEG: 51.4450549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020300',
        LOCATION_NAME: 'London SW13',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2415774,
        LOCATION_LATITUDE_DEG: 51.4767578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020400',
        LOCATION_NAME: 'London SW14',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2678751,
        LOCATION_LATITUDE_DEG: 51.462328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020500',
        LOCATION_NAME: 'London SW15',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2392674,
        LOCATION_LATITUDE_DEG: 51.4507229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020600',
        LOCATION_NAME: 'London SW16',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1288695,
        LOCATION_LATITUDE_DEG: 51.419981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020700',
        LOCATION_NAME: 'London SW17',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1666634,
        LOCATION_LATITUDE_DEG: 51.430975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020800',
        LOCATION_NAME: 'London SW18',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1905377,
        LOCATION_LATITUDE_DEG: 51.4497829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO020900',
        LOCATION_NAME: 'London SW19',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.209627,
        LOCATION_LATITUDE_DEG: 51.4250469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021000',
        LOCATION_NAME: 'London SW20',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.231616,
        LOCATION_LATITUDE_DEG: 51.4095791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021200',
        LOCATION_NAME: 'London W 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'W1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1433775,
        LOCATION_LATITUDE_DEG: 51.515535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021300',
        LOCATION_NAME: 'London W 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'W2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1791274,
        LOCATION_LATITUDE_DEG: 51.5125971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021400',
        LOCATION_NAME: 'London W 3',
        COUNTY_NAME: 'London',
        POSTCODE: 'W3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2695072,
        LOCATION_LATITUDE_DEG: 51.5116452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021500',
        LOCATION_NAME: 'London W 4',
        COUNTY_NAME: 'London',
        POSTCODE: 'W4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2644368,
        LOCATION_LATITUDE_DEG: 51.4876747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021600',
        LOCATION_NAME: 'London W 5',
        COUNTY_NAME: 'London',
        POSTCODE: 'W5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3011218,
        LOCATION_LATITUDE_DEG: 51.5137892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021700',
        LOCATION_NAME: 'London W 6',
        COUNTY_NAME: 'London',
        POSTCODE: 'W6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.229564,
        LOCATION_LATITUDE_DEG: 51.4920548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021800',
        LOCATION_NAME: 'London W 7',
        COUNTY_NAME: 'London',
        POSTCODE: 'W7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3384154,
        LOCATION_LATITUDE_DEG: 51.5108701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO021900',
        LOCATION_NAME: 'London W 8',
        COUNTY_NAME: 'London',
        POSTCODE: 'W8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1936517,
        LOCATION_LATITUDE_DEG: 51.5014179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022000',
        LOCATION_NAME: 'London W 9',
        COUNTY_NAME: 'London',
        POSTCODE: 'W9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1928678,
        LOCATION_LATITUDE_DEG: 51.5263268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022100',
        LOCATION_NAME: 'London W10',
        COUNTY_NAME: 'London',
        POSTCODE: 'W10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2175243,
        LOCATION_LATITUDE_DEG: 51.5222164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022200',
        LOCATION_NAME: 'London W11',
        COUNTY_NAME: 'London',
        POSTCODE: 'W11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.207988,
        LOCATION_LATITUDE_DEG: 51.5113778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022300',
        LOCATION_NAME: 'London W12',
        COUNTY_NAME: 'London',
        POSTCODE: 'W12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2363391,
        LOCATION_LATITUDE_DEG: 51.5094963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022400',
        LOCATION_NAME: 'London W13',
        COUNTY_NAME: 'London',
        POSTCODE: 'W13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3220781,
        LOCATION_LATITUDE_DEG: 51.5142168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022500',
        LOCATION_NAME: 'London W14',
        COUNTY_NAME: 'London',
        POSTCODE: 'W14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2104833,
        LOCATION_LATITUDE_DEG: 51.4951467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022600',
        LOCATION_NAME: 'London WC 1',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1205666,
        LOCATION_LATITUDE_DEG: 51.5227083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022700',
        LOCATION_NAME: 'London WC 2',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1213002,
        LOCATION_LATITUDE_DEG: 51.5122425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022900',
        LOCATION_NAME: 'Londonderry',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3174309,
        LOCATION_LATITUDE_DEG: 54.9957611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO022800',
        LOCATION_NAME: 'Londonderry',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5366499,
        LOCATION_LATITUDE_DEG: 54.2857288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023000',
        LOCATION_NAME: 'Londonthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5812213,
        LOCATION_LATITUDE_DEG: 52.9303843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023100',
        LOCATION_NAME: 'Lonemore',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0772738,
        LOCATION_LATITUDE_DEG: 57.8694133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023200',
        LOCATION_NAME: 'Lonfearn',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1480278,
        LOCATION_LATITUDE_DEG: 57.5811102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023300',
        LOCATION_NAME: 'Long Ashes Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0505096,
        LOCATION_LATITUDE_DEG: 54.1204216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023400',
        LOCATION_NAME: 'Long Ashton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6549424,
        LOCATION_LATITUDE_DEG: 51.430371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023500',
        LOCATION_NAME: 'Long Barn',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.648058,
        LOCATION_LATITUDE_DEG: 50.8051177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023600',
        LOCATION_NAME: 'Long Bennington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7569325,
        LOCATION_LATITUDE_DEG: 52.995792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023700',
        LOCATION_NAME: 'Long Bredy',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6079629,
        LOCATION_LATITUDE_DEG: 50.7074027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023800',
        LOCATION_NAME: 'Long Buckby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0790781,
        LOCATION_LATITUDE_DEG: 52.3025282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO023900',
        LOCATION_NAME: 'Long Clawson',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9222157,
        LOCATION_LATITUDE_DEG: 52.8390775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024000',
        LOCATION_NAME: 'Long Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2768746,
        LOCATION_LATITUDE_DEG: 50.9241051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024200',
        LOCATION_NAME: 'Long Compton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2119024,
        LOCATION_LATITUDE_DEG: 52.8002935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024100',
        LOCATION_NAME: 'Long Compton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5807886,
        LOCATION_LATITUDE_DEG: 51.9926115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024300',
        LOCATION_NAME: 'Long Crendon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9951837,
        LOCATION_LATITUDE_DEG: 51.7723852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024400',
        LOCATION_NAME: 'Long Crichel',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0317093,
        LOCATION_LATITUDE_DEG: 50.8916073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024500',
        LOCATION_NAME: 'Long Ditton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3189465,
        LOCATION_LATITUDE_DEG: 51.3838389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024600',
        LOCATION_NAME: 'Long Drag',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5093555,
        LOCATION_LATITUDE_DEG: 50.9038258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024700',
        LOCATION_NAME: 'Long Drax',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9628328,
        LOCATION_LATITUDE_DEG: 53.7455701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024800',
        LOCATION_NAME: 'Long Eaton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2694465,
        LOCATION_LATITUDE_DEG: 52.8971941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO024900',
        LOCATION_NAME: 'Long Furlong',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1864051,
        LOCATION_LATITUDE_DEG: 51.6257771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025000',
        LOCATION_NAME: 'Long Hanborough',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.392624,
        LOCATION_LATITUDE_DEG: 51.8237939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025100',
        LOCATION_NAME: 'Long Headland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2286833,
        LOCATION_LATITUDE_DEG: 52.2731415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025200',
        LOCATION_NAME: 'Long Itchington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3910209,
        LOCATION_LATITUDE_DEG: 52.2834366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025300',
        LOCATION_NAME: 'Long Lane',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5403747,
        LOCATION_LATITUDE_DEG: 52.7346904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025400',
        LOCATION_NAME: 'Long Lawford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3056991,
        LOCATION_LATITUDE_DEG: 52.3815475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025500',
        LOCATION_NAME: 'Long Load',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7610164,
        LOCATION_LATITUDE_DEG: 51.0050306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025700',
        LOCATION_NAME: 'Long Marston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7754608,
        LOCATION_LATITUDE_DEG: 52.1345283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025600',
        LOCATION_NAME: 'Long Marston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2351367,
        LOCATION_LATITUDE_DEG: 53.9534962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025800',
        LOCATION_NAME: 'Long Marston',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6963281,
        LOCATION_LATITUDE_DEG: 51.8314815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO025900',
        LOCATION_NAME: 'Long Marton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5163621,
        LOCATION_LATITUDE_DEG: 54.6138777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026000',
        LOCATION_NAME: 'Long Meadow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.182379,
        LOCATION_LATITUDE_DEG: 52.201237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026100',
        LOCATION_NAME: 'Long Melford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7180566,
        LOCATION_LATITUDE_DEG: 52.0735905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026200',
        LOCATION_NAME: 'Long Mynd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8827365,
        LOCATION_LATITUDE_DEG: 52.5047755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026300',
        LOCATION_NAME: 'Long Newnton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1306126,
        LOCATION_LATITUDE_DEG: 51.6324797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026400',
        LOCATION_NAME: 'Long Newton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4113928,
        LOCATION_LATITUDE_DEG: 54.5464077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026500',
        LOCATION_NAME: 'Long Park',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8885541,
        LOCATION_LATITUDE_DEG: 54.9492143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026600',
        LOCATION_NAME: 'Long Preston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2514861,
        LOCATION_LATITUDE_DEG: 54.0182114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026700',
        LOCATION_NAME: 'Long Riston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2865501,
        LOCATION_LATITUDE_DEG: 53.8638695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990610',
        LOCATION_NAME: 'Long Rock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026800',
        LOCATION_NAME: 'Long Rock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4971451,
        LOCATION_LATITUDE_DEG: 50.130233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO026900',
        LOCATION_NAME: 'Long Sandall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0810556,
        LOCATION_LATITUDE_DEG: 53.5503552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027000',
        LOCATION_NAME: 'Long Stratton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2353813,
        LOCATION_LATITUDE_DEG: 52.4848225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990448',
        LOCATION_NAME: 'Long Street',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027100',
        LOCATION_NAME: 'Long Sutton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7572796,
        LOCATION_LATITUDE_DEG: 51.0250293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027200',
        LOCATION_NAME: 'Long Sutton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9431612,
        LOCATION_LATITUDE_DEG: 51.2198306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027300',
        LOCATION_NAME: 'Long Sutton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.123178,
        LOCATION_LATITUDE_DEG: 52.7854598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027400',
        LOCATION_NAME: 'Long Thurlow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9497715,
        LOCATION_LATITUDE_DEG: 52.2749049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027500',
        LOCATION_NAME: 'Long Waste',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5725984,
        LOCATION_LATITUDE_DEG: 52.7386929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027600',
        LOCATION_NAME: 'Long Whatton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2898629,
        LOCATION_LATITUDE_DEG: 52.8068812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027700',
        LOCATION_NAME: 'Long Wittenham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.205731,
        LOCATION_LATITUDE_DEG: 51.6421679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027800',
        LOCATION_NAME: 'Longaller',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1451128,
        LOCATION_LATITUDE_DEG: 51.0204332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO027900',
        LOCATION_NAME: 'Longannet',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.687399,
        LOCATION_LATITUDE_DEG: 56.0557332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078900',
        LOCATION_NAME: 'Longbenton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5882049,
        LOCATION_LATITUDE_DEG: 55.018773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079000',
        LOCATION_NAME: 'Longbenton Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5765385,
        LOCATION_LATITUDE_DEG: 55.0215281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028000',
        LOCATION_NAME: 'Longborough',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7390049,
        LOCATION_LATITUDE_DEG: 51.9642047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079900',
        LOCATION_NAME: 'Longbridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9789082,
        LOCATION_LATITUDE_DEG: 52.3962352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028100',
        LOCATION_NAME: 'Longbridge',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.605021,
        LOCATION_LATITUDE_DEG: 52.2608337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028200',
        LOCATION_NAME: 'Longbridge Deverill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1875366,
        LOCATION_LATITUDE_DEG: 51.1663394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028300',
        LOCATION_NAME: 'Longbridge Hayes',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2171586,
        LOCATION_LATITUDE_DEG: 53.0510158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028400',
        LOCATION_NAME: 'Longbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9754112,
        LOCATION_LATITUDE_DEG: 50.3526772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028500',
        LOCATION_NAME: 'Longburgh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0773176,
        LOCATION_LATITUDE_DEG: 54.9179115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028600',
        LOCATION_NAME: 'Longburton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4994313,
        LOCATION_LATITUDE_DEG: 50.9129191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028700',
        LOCATION_NAME: 'Longcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.645971,
        LOCATION_LATITUDE_DEG: 50.4284808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028800',
        LOCATION_NAME: 'Longcot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6032917,
        LOCATION_LATITUDE_DEG: 51.6142752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029000',
        LOCATION_NAME: 'Longcroft',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9373395,
        LOCATION_LATITUDE_DEG: 55.9911257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO028900',
        LOCATION_NAME: 'Longcroft',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2219291,
        LOCATION_LATITUDE_DEG: 54.9122113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029100',
        LOCATION_NAME: 'Longcross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2101357,
        LOCATION_LATITUDE_DEG: 50.592001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029200',
        LOCATION_NAME: 'Longcross',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5877974,
        LOCATION_LATITUDE_DEG: 51.3769377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029300',
        LOCATION_NAME: 'Longdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5482431,
        LOCATION_LATITUDE_DEG: 54.4393603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029400',
        LOCATION_NAME: 'Longdales',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7555423,
        LOCATION_LATITUDE_DEG: 54.7973951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029500',
        LOCATION_NAME: 'Longden',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8255512,
        LOCATION_LATITUDE_DEG: 52.6516892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029700',
        LOCATION_NAME: 'Longdon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2374997,
        LOCATION_LATITUDE_DEG: 52.0245172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029600',
        LOCATION_NAME: 'Longdon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8823757,
        LOCATION_LATITUDE_DEG: 52.7255867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029800',
        LOCATION_NAME: 'Longdon Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8711714,
        LOCATION_LATITUDE_DEG: 52.7185804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078800',
        LOCATION_NAME: 'Longdon upon Tern',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO029900',
        LOCATION_NAME: 'Longdon-upon-Tern',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.56886,
        LOCATION_LATITUDE_DEG: 52.7359957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030000',
        LOCATION_NAME: 'Longdown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6071697,
        LOCATION_LATITUDE_DEG: 50.7080095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030100',
        LOCATION_NAME: 'Longdowns',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1582266,
        LOCATION_LATITUDE_DEG: 50.1635723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030200',
        LOCATION_NAME: 'Longfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3038708,
        LOCATION_LATITUDE_DEG: 51.3962254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030300',
        LOCATION_NAME: 'Longfield Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3508236,
        LOCATION_LATITUDE_DEG: 51.3888256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030400',
        LOCATION_NAME: 'Longfleet',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9704129,
        LOCATION_LATITUDE_DEG: 50.7285904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030700',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8301626,
        LOCATION_LATITUDE_DEG: 51.6719056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030900',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.526609,
        LOCATION_LATITUDE_DEG: 52.9012042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030600',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.398161,
        LOCATION_LATITUDE_DEG: 52.7632949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030800',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2349038,
        LOCATION_LATITUDE_DEG: 51.8850052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031200',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6741947,
        LOCATION_LATITUDE_DEG: 52.9342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO030500',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4844733,
        LOCATION_LATITUDE_DEG: 52.4496536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031300',
        LOCATION_NAME: 'Longford Turning',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5085865,
        LOCATION_LATITUDE_DEG: 52.8985046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031400',
        LOCATION_NAME: 'Longforgan',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1214514,
        LOCATION_LATITUDE_DEG: 56.4572624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031500',
        LOCATION_NAME: 'Longformacus',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4896341,
        LOCATION_LATITUDE_DEG: 55.8073935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031600',
        LOCATION_NAME: 'Longframlington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7924684,
        LOCATION_LATITUDE_DEG: 55.3029315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031700',
        LOCATION_NAME: 'Longham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8722812,
        LOCATION_LATITUDE_DEG: 52.7038476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031800',
        LOCATION_NAME: 'Longhaven',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8172003,
        LOCATION_LATITUDE_DEG: 57.447447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031900',
        LOCATION_NAME: 'Longhedge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7914762,
        LOCATION_LATITUDE_DEG: 51.1068236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032000',
        LOCATION_NAME: 'Longhill',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8922724,
        LOCATION_LATITUDE_DEG: 57.4312604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990295',
        LOCATION_NAME: 'Longhill',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2682232,
        LOCATION_LATITUDE_DEG: 53.7783881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032100',
        LOCATION_NAME: 'Longhirst',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.646458,
        LOCATION_LATITUDE_DEG: 55.1959216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032200',
        LOCATION_NAME: 'Longhirst Colliery',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6207269,
        LOCATION_LATITUDE_DEG: 55.2038247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032400',
        LOCATION_NAME: 'Longhope',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1994802,
        LOCATION_LATITUDE_DEG: 58.797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032300',
        LOCATION_NAME: 'Longhope',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4509729,
        LOCATION_LATITUDE_DEG: 51.8672098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032500',
        LOCATION_NAME: 'Longhorsley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7672183,
        LOCATION_LATITUDE_DEG: 55.2460263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032600',
        LOCATION_NAME: 'Longhoughton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6149582,
        LOCATION_LATITUDE_DEG: 55.4300409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032700',
        LOCATION_NAME: 'Longlands',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2519272,
        LOCATION_LATITUDE_DEG: 50.4020905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032800',
        LOCATION_NAME: 'Longleat',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2699293,
        LOCATION_LATITUDE_DEG: 51.1864396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO032900',
        LOCATION_NAME: 'Longlevens',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2179474,
        LOCATION_LATITUDE_DEG: 51.8822054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079800',
        LOCATION_NAME: 'Longley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4611445,
        LOCATION_LATITUDE_DEG: 53.4155711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033000',
        LOCATION_NAME: 'Longmanhill',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4329903,
        LOCATION_LATITUDE_DEG: 57.6490753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033100',
        LOCATION_NAME: 'Longmeadow End',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.868139,
        LOCATION_LATITUDE_DEG: 52.4346705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033200',
        LOCATION_NAME: 'Longmorn',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.278704,
        LOCATION_LATITUDE_DEG: 57.6090776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033300',
        LOCATION_NAME: 'Longmynd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8785379,
        LOCATION_LATITUDE_DEG: 52.5173765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033400',
        LOCATION_NAME: 'Longney',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5153331,
        LOCATION_LATITUDE_DEG: 51.8163022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033500',
        LOCATION_NAME: 'Longniddry',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8934051,
        LOCATION_LATITUDE_DEG: 55.9746141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033600',
        LOCATION_NAME: 'Longnor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7553506,
        LOCATION_LATITUDE_DEG: 52.6006841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033700',
        LOCATION_NAME: 'Longnor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8675154,
        LOCATION_LATITUDE_DEG: 53.1810284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033800',
        LOCATION_NAME: 'Longparish',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3820537,
        LOCATION_LATITUDE_DEG: 51.1968282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO033900',
        LOCATION_NAME: 'Longpark',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4974607,
        LOCATION_LATITUDE_DEG: 55.6176963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034000',
        LOCATION_NAME: 'Longport',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0961002,
        LOCATION_LATITUDE_DEG: 51.2756071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034100',
        LOCATION_NAME: 'Longridge',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6769101,
        LOCATION_LATITUDE_DEG: 55.8434085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034200',
        LOCATION_NAME: 'Longridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5979312,
        LOCATION_LATITUDE_DEG: 53.8295945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034300',
        LOCATION_NAME: 'Longriggend',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8825672,
        LOCATION_LATITUDE_DEG: 55.9100162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034400',
        LOCATION_NAME: 'Longroyd',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9485124,
        LOCATION_LATITUDE_DEG: 53.6984757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034500',
        LOCATION_NAME: 'Longsdon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0564469,
        LOCATION_LATITUDE_DEG: 53.0892197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034600',
        LOCATION_NAME: 'Longside',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9378786,
        LOCATION_LATITUDE_DEG: 57.5159565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080300',
        LOCATION_NAME: 'Longsight',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080200',
        LOCATION_NAME: 'Longsight',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2001895,
        LOCATION_LATITUDE_DEG: 53.4577013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034700',
        LOCATION_NAME: 'Longsleddale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7721703,
        LOCATION_LATITUDE_DEG: 54.4193601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034800',
        LOCATION_NAME: 'Longslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5131079,
        LOCATION_LATITUDE_DEG: 52.9150097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO034900',
        LOCATION_NAME: 'Longstanton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0472193,
        LOCATION_LATITUDE_DEG: 52.2804143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035000',
        LOCATION_NAME: 'Longstock',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.486495,
        LOCATION_LATITUDE_DEG: 51.1314227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035100',
        LOCATION_NAME: 'Longstock Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.476754,
        LOCATION_LATITUDE_DEG: 51.1409302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035200',
        LOCATION_NAME: 'Longstone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4560351,
        LOCATION_LATITUDE_DEG: 50.1901829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035300',
        LOCATION_NAME: 'Longstowe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0859581,
        LOCATION_LATITUDE_DEG: 52.1782082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035400',
        LOCATION_NAME: 'Longswood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5478012,
        LOCATION_LATITUDE_DEG: 52.7516937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035500',
        LOCATION_NAME: 'Longthorns',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2096348,
        LOCATION_LATITUDE_DEG: 50.7038978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035600',
        LOCATION_NAME: 'Longthorpe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2821436,
        LOCATION_LATITUDE_DEG: 52.5663464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035700',
        LOCATION_NAME: 'Longthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8584673,
        LOCATION_LATITUDE_DEG: 54.5961793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035800',
        LOCATION_NAME: 'Longton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7899088,
        LOCATION_LATITUDE_DEG: 53.7203877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO035900',
        LOCATION_NAME: 'Longton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1406802,
        LOCATION_LATITUDE_DEG: 52.9871116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036000',
        LOCATION_NAME: 'Longtown',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9815371,
        LOCATION_LATITUDE_DEG: 51.9512222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036100',
        LOCATION_NAME: 'Longtown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9678851,
        LOCATION_LATITUDE_DEG: 55.0092216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036300',
        LOCATION_NAME: 'Longville',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6794467,
        LOCATION_LATITUDE_DEG: 52.5393754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036400',
        LOCATION_NAME: 'Longwell Green',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5077328,
        LOCATION_LATITUDE_DEG: 51.4398688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036500',
        LOCATION_NAME: 'Longwick',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8555263,
        LOCATION_LATITUDE_DEG: 51.7355789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036600',
        LOCATION_NAME: 'Longwitton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8771962,
        LOCATION_LATITUDE_DEG: 55.1933255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036700',
        LOCATION_NAME: 'Longwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8326043,
        LOCATION_LATITUDE_DEG: 53.6441738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036900',
        LOCATION_NAME: 'Longworth',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6374115,
        LOCATION_LATITUDE_DEG: 52.0525256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037000',
        LOCATION_NAME: 'Longworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4361322,
        LOCATION_LATITUDE_DEG: 51.6908809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037100',
        LOCATION_NAME: 'Lonlas',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.855658,
        LOCATION_LATITUDE_DEG: 51.6594004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037200',
        LOCATION_NAME: 'Lonmay',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9766634,
        LOCATION_LATITUDE_DEG: 57.6160636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037300',
        LOCATION_NAME: 'Looe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4552814,
        LOCATION_LATITUDE_DEG: 50.3525815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037400',
        LOCATION_NAME: 'Looe Mills',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4912535,
        LOCATION_LATITUDE_DEG: 50.4551957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037600',
        LOCATION_NAME: 'Loose',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5195116,
        LOCATION_LATITUDE_DEG: 51.240108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037700',
        LOCATION_NAME: 'Loosegate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0471693,
        LOCATION_LATITUDE_DEG: 52.8130695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037800',
        LOCATION_NAME: 'Loosley Row',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8159806,
        LOCATION_LATITUDE_DEG: 51.6986681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037850',
        LOCATION_NAME: 'Lopcombe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6396561,
        LOCATION_LATITUDE_DEG: 51.1189908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037875',
        LOCATION_NAME: 'Lopcombe Corner',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6376276,
        LOCATION_LATITUDE_DEG: 51.117096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037900',
        LOCATION_NAME: 'Lopen',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8146667,
        LOCATION_LATITUDE_DEG: 50.9234214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038000',
        LOCATION_NAME: 'Lopenhead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8069753,
        LOCATION_LATITUDE_DEG: 50.9279266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038100',
        LOCATION_NAME: 'Loppington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7867948,
        LOCATION_LATITUDE_DEG: 52.8585079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038200',
        LOCATION_NAME: 'Lopshill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8719995,
        LOCATION_LATITUDE_DEG: 50.9216064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038400',
        LOCATION_NAME: 'Lopwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1494159,
        LOCATION_LATITUDE_DEG: 50.4637955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038500',
        LOCATION_NAME: 'Lordington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.888209,
        LOCATION_LATITUDE_DEG: 50.880894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038600',
        LOCATION_NAME: 'Lordstone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9823554,
        LOCATION_LATITUDE_DEG: 52.6109861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038700',
        LOCATION_NAME: 'Lordswood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1876079,
        LOCATION_LATITUDE_DEG: 51.5565788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038900',
        LOCATION_NAME: 'Lorton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2993824,
        LOCATION_LATITUDE_DEG: 54.6174801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039000',
        LOCATION_NAME: 'Loscoe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3699719,
        LOCATION_LATITUDE_DEG: 53.0257035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039100',
        LOCATION_NAME: 'Loscombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7036813,
        LOCATION_LATITUDE_DEG: 50.7811081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039400',
        LOCATION_NAME: 'Lossiemouth',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2882642,
        LOCATION_LATITUDE_DEG: 57.7178884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039500',
        LOCATION_NAME: 'Lostford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5580748,
        LOCATION_LATITUDE_DEG: 52.8772087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039550',
        LOCATION_NAME: 'Lostock',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4979946,
        LOCATION_LATITUDE_DEG: 53.5732098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039600',
        LOCATION_NAME: 'Lostock Gralam',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4633283,
        LOCATION_LATITUDE_DEG: 53.2696422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039700',
        LOCATION_NAME: 'Lostock Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4568495,
        LOCATION_LATITUDE_DEG: 53.2597424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039800',
        LOCATION_NAME: 'Lostock Hall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.685996,
        LOCATION_LATITUDE_DEG: 53.724893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039900',
        LOCATION_NAME: 'Lostock Junction',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4864444,
        LOCATION_LATITUDE_DEG: 53.5761699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040000',
        LOCATION_NAME: 'Lostwithiel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6679973,
        LOCATION_LATITUDE_DEG: 50.4068892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040100',
        LOCATION_NAME: 'Lothersdale',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0653107,
        LOCATION_LATITUDE_DEG: 53.9090994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040200',
        LOCATION_NAME: 'Lottisham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.609365,
        LOCATION_LATITUDE_DEG: 51.1072384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040300',
        LOCATION_NAME: 'Lotts',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2065909,
        LOCATION_LATITUDE_DEG: 55.6824182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040500',
        LOCATION_NAME: 'Loudwater',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6956871,
        LOCATION_LATITUDE_DEG: 51.6076639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040400',
        LOCATION_NAME: 'Loudwater',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4776396,
        LOCATION_LATITUDE_DEG: 51.6577646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990706',
        LOCATION_NAME: 'Lough Fea',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041200',
        LOCATION_NAME: 'Loughborough',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2027855,
        LOCATION_LATITUDE_DEG: 52.770482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041300',
        LOCATION_NAME: 'Loughbrickland',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3036318,
        LOCATION_LATITUDE_DEG: 54.3205846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041600',
        LOCATION_NAME: 'Loughgall',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5989677,
        LOCATION_LATITUDE_DEG: 54.4165928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041650',
        LOCATION_NAME: 'Loughgiel',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3056009,
        LOCATION_LATITUDE_DEG: 55.0671654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041700',
        LOCATION_NAME: 'Loughgilly',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4656466,
        LOCATION_LATITUDE_DEG: 54.2665784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041900',
        LOCATION_NAME: 'Loughinisland',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7745871,
        LOCATION_LATITUDE_DEG: 54.3029738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990379',
        LOCATION_NAME: 'Loughmacrory',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042300',
        LOCATION_NAME: 'Loughmuck',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3410071,
        LOCATION_LATITUDE_DEG: 54.5589928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042500',
        LOCATION_NAME: 'Loughor',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0544256,
        LOCATION_LATITUDE_DEG: 51.6628088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042700',
        LOCATION_NAME: 'Loughrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0002915,
        LOCATION_LATITUDE_DEG: 54.4323647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043000',
        LOCATION_NAME: 'Loughton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.564682,
        LOCATION_LATITUDE_DEG: 52.4430634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043100',
        LOCATION_NAME: 'Loughton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7901618,
        LOCATION_LATITUDE_DEG: 52.0311067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042900',
        LOCATION_NAME: 'Loughton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0553411,
        LOCATION_LATITUDE_DEG: 51.645651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990519',
        LOCATION_NAME: 'Loughton Lodge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043400',
        LOCATION_NAME: 'Lound',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9598871,
        LOCATION_LATITUDE_DEG: 53.3659317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043500',
        LOCATION_NAME: 'Lound',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4150183,
        LOCATION_LATITUDE_DEG: 52.750065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043300',
        LOCATION_NAME: 'Lound',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6933319,
        LOCATION_LATITUDE_DEG: 52.5319117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043600',
        LOCATION_NAME: 'Lount',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4312027,
        LOCATION_LATITUDE_DEG: 52.7675803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043700',
        LOCATION_NAME: 'Lour',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8503813,
        LOCATION_LATITUDE_DEG: 56.6050769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043900',
        LOCATION_NAME: 'Louth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0062358,
        LOCATION_LATITUDE_DEG: 53.3668195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044000',
        LOCATION_NAME: 'Lovacott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1162057,
        LOCATION_LATITUDE_DEG: 51.0257034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044100',
        LOCATION_NAME: 'Lovaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0511158,
        LOCATION_LATITUDE_DEG: 50.4763913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044200',
        LOCATION_NAME: 'Loveclough',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2895333,
        LOCATION_LATITUDE_DEG: 53.7355408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044300',
        LOCATION_NAME: 'Lovedean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0350126,
        LOCATION_LATITUDE_DEG: 50.9138038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044400',
        LOCATION_NAME: 'Lover',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6998293,
        LOCATION_LATITUDE_DEG: 50.9797118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044500',
        LOCATION_NAME: 'Loversall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1348608,
        LOCATION_LATITUDE_DEG: 53.4812478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044600',
        LOCATION_NAME: 'Loverstone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2996553,
        LOCATION_LATITUDE_DEG: 50.6506814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044700',
        LOCATION_NAME: 'Loves Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3787092,
        LOCATION_LATITUDE_DEG: 51.7119542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044800',
        LOCATION_NAME: 'Lovesgrove',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0162375,
        LOCATION_LATITUDE_DEG: 52.415576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO044900',
        LOCATION_NAME: 'Loveston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7761377,
        LOCATION_LATITUDE_DEG: 51.7425192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045000',
        LOCATION_NAME: 'Lovington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5708624,
        LOCATION_LATITUDE_DEG: 51.0745355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045100',
        LOCATION_NAME: 'Low Ackworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3212888,
        LOCATION_LATITUDE_DEG: 53.6508621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079600',
        LOCATION_NAME: 'Low Benwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045200',
        LOCATION_NAME: 'Low Biggins',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6045822,
        LOCATION_LATITUDE_DEG: 54.1998385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045300',
        LOCATION_NAME: 'Low Bradfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6017425,
        LOCATION_LATITUDE_DEG: 53.4256518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045400',
        LOCATION_NAME: 'Low Braithwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8865604,
        LOCATION_LATITUDE_DEG: 54.7725919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045500',
        LOCATION_NAME: 'Low Burnham',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8242195,
        LOCATION_LATITUDE_DEG: 53.5105458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045600',
        LOCATION_NAME: 'Low Buston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6468346,
        LOCATION_LATITUDE_DEG: 55.3609395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045700',
        LOCATION_NAME: 'Low Catton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9240299,
        LOCATION_LATITUDE_DEG: 53.975896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045800',
        LOCATION_NAME: 'Low Common',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4921757,
        LOCATION_LATITUDE_DEG: 53.4843635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO045900',
        LOCATION_NAME: 'Low Coniscliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6126222,
        LOCATION_LATITUDE_DEG: 54.5223497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046000',
        LOCATION_NAME: 'Low Cotehill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8212243,
        LOCATION_LATITUDE_DEG: 54.8473989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046100',
        LOCATION_NAME: 'Low Dalby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6853175,
        LOCATION_LATITUDE_DEG: 54.2746167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046200',
        LOCATION_NAME: 'Low Dinsdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4647494,
        LOCATION_LATITUDE_DEG: 54.4942462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046300',
        LOCATION_NAME: 'Low Dolphinholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7259758,
        LOCATION_LATITUDE_DEG: 54.0240221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046400',
        LOCATION_NAME: 'Low Ellington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6896321,
        LOCATION_LATITUDE_DEG: 54.2467246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079700',
        LOCATION_NAME: 'Low Elswick',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046500',
        LOCATION_NAME: 'Low Espley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.713929,
        LOCATION_LATITUDE_DEG: 55.2101181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046600',
        LOCATION_NAME: 'Low Etherley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7407307,
        LOCATION_LATITUDE_DEG: 54.6560719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079300',
        LOCATION_NAME: 'Low Fell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5933556,
        LOCATION_LATITUDE_DEG: 54.9193454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046700',
        LOCATION_NAME: 'Low Fulney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1188297,
        LOCATION_LATITUDE_DEG: 52.7777654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046800',
        LOCATION_NAME: 'Low Gate',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1498515,
        LOCATION_LATITUDE_DEG: 54.9700016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO046900',
        LOCATION_NAME: 'Low Grantley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6356238,
        LOCATION_LATITUDE_DEG: 54.1280154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047000',
        LOCATION_NAME: 'Low Habberley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2731374,
        LOCATION_LATITUDE_DEG: 52.3991583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047100',
        LOCATION_NAME: 'Low Ham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8112248,
        LOCATION_LATITUDE_DEG: 51.0559373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047200',
        LOCATION_NAME: 'Low Hameringham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0485655,
        LOCATION_LATITUDE_DEG: 53.1781987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047300',
        LOCATION_NAME: 'Low Harker',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9529931,
        LOCATION_LATITUDE_DEG: 54.9391095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047400',
        LOCATION_NAME: 'Low Hauxley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5493051,
        LOCATION_LATITUDE_DEG: 55.3179315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047500',
        LOCATION_NAME: 'Low Hawsker',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5874985,
        LOCATION_LATITUDE_DEG: 54.4520328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047600',
        LOCATION_NAME: 'Low Hesket',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8320671,
        LOCATION_LATITUDE_DEG: 54.8088933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047700',
        LOCATION_NAME: 'Low Hill',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9645246,
        LOCATION_LATITUDE_DEG: 53.4104646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047800',
        LOCATION_NAME: 'Low Hill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2281627,
        LOCATION_LATITUDE_DEG: 52.3572559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO047900',
        LOCATION_NAME: 'Low Hunsley',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.55518,
        LOCATION_LATITUDE_DEG: 53.7935712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048000',
        LOCATION_NAME: 'Low Juniper',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0848023,
        LOCATION_LATITUDE_DEG: 54.9269972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048100',
        LOCATION_NAME: 'Low Laithe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7079231,
        LOCATION_LATITUDE_DEG: 54.0689147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048200',
        LOCATION_NAME: 'Low Laithes',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.411455,
        LOCATION_LATITUDE_DEG: 53.5388542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048300',
        LOCATION_NAME: 'Low Leighton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9868328,
        LOCATION_LATITUDE_DEG: 53.3696444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048400',
        LOCATION_NAME: 'Low Lorton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3135107,
        LOCATION_LATITUDE_DEG: 54.617085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048500',
        LOCATION_NAME: 'Low Marishes',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7458843,
        LOCATION_LATITUDE_DEG: 54.1844095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048600',
        LOCATION_NAME: 'Low Marnham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7927121,
        LOCATION_LATITUDE_DEG: 53.2150192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048700',
        LOCATION_NAME: 'Low Mills',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9650712,
        LOCATION_LATITUDE_DEG: 54.3512924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048800',
        LOCATION_NAME: 'Low Moor',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4066271,
        LOCATION_LATITUDE_DEG: 53.8692998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO048900',
        LOCATION_NAME: 'Low Moor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7580948,
        LOCATION_LATITUDE_DEG: 53.7554854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049000',
        LOCATION_NAME: 'Low Moresby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5550903,
        LOCATION_LATITUDE_DEG: 54.5724784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049100',
        LOCATION_NAME: 'Low Pittington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4889702,
        LOCATION_LATITUDE_DEG: 54.7924785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049200',
        LOCATION_NAME: 'Low Prudhoe',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8489299,
        LOCATION_LATITUDE_DEG: 54.9700001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049300',
        LOCATION_NAME: 'Low Risby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.599251,
        LOCATION_LATITUDE_DEG: 53.6213522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049500',
        LOCATION_NAME: 'Low Row',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6463334,
        LOCATION_LATITUDE_DEG: 54.9569085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049400',
        LOCATION_NAME: 'Low Row',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0291602,
        LOCATION_LATITUDE_DEG: 54.3758413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049600',
        LOCATION_NAME: 'Low Santon',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5784655,
        LOCATION_LATITUDE_DEG: 53.6022549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049700',
        LOCATION_NAME: 'Low Scales',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2688135,
        LOCATION_LATITUDE_DEG: 54.8026054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049800',
        LOCATION_NAME: 'Low Seaton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5196418,
        LOCATION_LATITUDE_DEG: 54.6567856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO049900',
        LOCATION_NAME: 'Low Stott Park',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9641336,
        LOCATION_LATITUDE_DEG: 54.2863515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050000',
        LOCATION_NAME: 'Low Stubbin',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3655536,
        LOCATION_LATITUDE_DEG: 53.4738493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079200',
        LOCATION_NAME: 'Low Team',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050100',
        LOCATION_NAME: 'Low Toynton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0870397,
        LOCATION_LATITUDE_DEG: 53.2183038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050200',
        LOCATION_NAME: 'Low Urpeth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5992306,
        LOCATION_LATITUDE_DEG: 54.8933913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050300',
        LOCATION_NAME: 'Low Utley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9201972,
        LOCATION_LATITUDE_DEG: 53.876497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050400',
        LOCATION_NAME: 'Low Valley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3861799,
        LOCATION_LATITUDE_DEG: 53.5282543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050500',
        LOCATION_NAME: 'Low Valleyfield',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6031954,
        LOCATION_LATITUDE_DEG: 56.0593273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050600',
        LOCATION_NAME: 'Low Walker',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5317208,
        LOCATION_LATITUDE_DEG: 54.9665951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050700',
        LOCATION_NAME: 'Low Warden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1414816,
        LOCATION_LATITUDE_DEG: 54.9933066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050800',
        LOCATION_NAME: 'Low Westwood',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8294634,
        LOCATION_LATITUDE_DEG: 54.9000978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO050900',
        LOCATION_NAME: 'Low Wham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8125682,
        LOCATION_LATITUDE_DEG: 54.6287647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051000',
        LOCATION_NAME: 'Low Wood',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0044758,
        LOCATION_LATITUDE_DEG: 54.2439459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051100',
        LOCATION_NAME: 'Low Worsall',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3925195,
        LOCATION_LATITUDE_DEG: 54.4805485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051200',
        LOCATION_NAME: 'Low Wray',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9603861,
        LOCATION_LATITUDE_DEG: 54.3926537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051300',
        LOCATION_NAME: 'Lowca',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5738142,
        LOCATION_LATITUDE_DEG: 54.5817826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051400',
        LOCATION_NAME: 'Lowdham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.002667,
        LOCATION_LATITUDE_DEG: 53.0109996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051500',
        LOCATION_NAME: 'Lower Allscott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3909896,
        LOCATION_LATITUDE_DEG: 52.5613767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051600',
        LOCATION_NAME: 'Lower Almer',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1377152,
        LOCATION_LATITUDE_DEG: 50.8047069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051700',
        LOCATION_NAME: 'Lower Ansty',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3334411,
        LOCATION_LATITUDE_DEG: 50.8271105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051800',
        LOCATION_NAME: 'Lower Apperley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2009612,
        LOCATION_LATITUDE_DEG: 51.943911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO051900',
        LOCATION_NAME: 'Lower Arncott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1109883,
        LOCATION_LATITUDE_DEG: 51.8554894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052000',
        LOCATION_NAME: 'Lower Ashton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6344103,
        LOCATION_LATITUDE_DEG: 50.6457037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052100',
        LOCATION_NAME: 'Lower Assendon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9254583,
        LOCATION_LATITUDE_DEG: 51.5549565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052200',
        LOCATION_NAME: 'Lower Attchley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3369777,
        LOCATION_LATITUDE_DEG: 52.6267805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052300',
        LOCATION_NAME: 'Lower Bagber',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3385371,
        LOCATION_LATITUDE_DEG: 50.9426172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052400',
        LOCATION_NAME: 'Lower Balwest',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3637397,
        LOCATION_LATITUDE_DEG: 50.118271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052500',
        LOCATION_NAME: 'Lower Barnes',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7777225,
        LOCATION_LATITUDE_DEG: 52.9857211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052600',
        LOCATION_NAME: 'Lower Barnsley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.007114,
        LOCATION_LATITUDE_DEG: 50.8268042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052700',
        LOCATION_NAME: 'Lower Bartle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7688962,
        LOCATION_LATITUDE_DEG: 53.7947941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052800',
        LOCATION_NAME: 'Lower Basildon',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1214167,
        LOCATION_LATITUDE_DEG: 51.5033595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO052900',
        LOCATION_NAME: 'Lower Bassingthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5677451,
        LOCATION_LATITUDE_DEG: 52.8499766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053000',
        LOCATION_NAME: 'Lower Batson',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7744888,
        LOCATION_LATITUDE_DEG: 50.243568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053100',
        LOCATION_NAME: 'Lower Bayble',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2155069,
        LOCATION_LATITUDE_DEG: 58.2002698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990247',
        LOCATION_NAME: 'Lower Beeding',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2612676,
        LOCATION_LATITUDE_DEG: 51.0364284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053300',
        LOCATION_NAME: 'Lower Beetham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0227091,
        LOCATION_LATITUDE_DEG: 50.9010181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053400',
        LOCATION_NAME: 'Lower Beighterton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3093799,
        LOCATION_LATITUDE_DEG: 52.7045899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053500',
        LOCATION_NAME: 'Lower Benefield',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5419544,
        LOCATION_LATITUDE_DEG: 52.4863436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053550',
        LOCATION_NAME: 'Lower Bentham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.537157,
        LOCATION_LATITUDE_DEG: 54.1407165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053600',
        LOCATION_NAME: 'Lower Bentley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0258933,
        LOCATION_LATITUDE_DEG: 52.2878451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053700',
        LOCATION_NAME: 'Lower Beobridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3185171,
        LOCATION_LATITUDE_DEG: 52.5179697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053800',
        LOCATION_NAME: 'Lower Berry Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6191043,
        LOCATION_LATITUDE_DEG: 51.8018009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO053900',
        LOCATION_NAME: 'Lower Bevendean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0985164,
        LOCATION_LATITUDE_DEG: 50.8371766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054000',
        LOCATION_NAME: 'Lower Bincombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4590803,
        LOCATION_LATITUDE_DEG: 50.6645899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078500',
        LOCATION_NAME: 'Lower Blandford St Mary',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054100',
        LOCATION_NAME: 'Lower Blandford St. Mary',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1481239,
        LOCATION_LATITUDE_DEG: 50.8288059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054200',
        LOCATION_NAME: 'Lower Bockhampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.395862,
        LOCATION_LATITUDE_DEG: 50.7142966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054300',
        LOCATION_NAME: 'Lower Boddington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2980637,
        LOCATION_LATITUDE_DEG: 52.1650232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054400',
        LOCATION_NAME: 'Lower Bodham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1541397,
        LOCATION_LATITUDE_DEG: 52.9054599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054500',
        LOCATION_NAME: 'Lower Boscaswell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6701464,
        LOCATION_LATITUDE_DEG: 50.1540767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054600',
        LOCATION_NAME: 'Lower Bostraze',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6580848,
        LOCATION_LATITUDE_DEG: 50.1270771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054700',
        LOCATION_NAME: 'Lower Boulsdon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4102122,
        LOCATION_LATITUDE_DEG: 51.9211129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054800',
        LOCATION_NAME: 'Lower Bourne',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.78899,
        LOCATION_LATITUDE_DEG: 51.1933261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO054900',
        LOCATION_NAME: 'Lower Bourton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6690575,
        LOCATION_LATITUDE_DEG: 51.5842736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055000',
        LOCATION_NAME: 'Lower Breakish',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.853143,
        LOCATION_LATITUDE_DEG: 57.2452663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055100',
        LOCATION_NAME: 'Lower Broadheath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2759928,
        LOCATION_LATITUDE_DEG: 52.2110357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055200',
        LOCATION_NAME: 'Lower Bryanston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1648258,
        LOCATION_LATITUDE_DEG: 50.8496036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055300',
        LOCATION_NAME: 'Lower Brynamman',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8745669,
        LOCATION_LATITUDE_DEG: 51.8045212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055400',
        LOCATION_NAME: 'Lower Bullingham',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7010457,
        LOCATION_LATITUDE_DEG: 52.0403309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055500',
        LOCATION_NAME: 'Lower Bullington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3524409,
        LOCATION_LATITUDE_DEG: 51.1681239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055600',
        LOCATION_NAME: 'Lower Burgate',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7831886,
        LOCATION_LATITUDE_DEG: 50.9391114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055700',
        LOCATION_NAME: 'Lower Burraton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2338328,
        LOCATION_LATITUDE_DEG: 50.4078907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055900',
        LOCATION_NAME: 'Lower Burton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8420889,
        LOCATION_LATITUDE_DEG: 52.2068435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO055800',
        LOCATION_NAME: 'Lower Burton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4451458,
        LOCATION_LATITUDE_DEG: 50.7472968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056000',
        LOCATION_NAME: 'Lower Cabrach',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.025086,
        LOCATION_LATITUDE_DEG: 57.3742509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056100',
        LOCATION_NAME: 'Lower Caldecote',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2794162,
        LOCATION_LATITUDE_DEG: 52.1053011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990660',
        LOCATION_NAME: 'Lower Cambourne',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0805881,
        LOCATION_LATITUDE_DEG: 52.2054138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056200',
        LOCATION_NAME: 'Lower Cargenwyn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2874402,
        LOCATION_LATITUDE_DEG: 50.1699793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056300',
        LOCATION_NAME: 'Lower Carnkie',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2412283,
        LOCATION_LATITUDE_DEG: 50.2117754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056400',
        LOCATION_NAME: 'Lower Catesby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2443271,
        LOCATION_LATITUDE_DEG: 52.2306269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056500',
        LOCATION_NAME: 'Lower Chaddesley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1586788,
        LOCATION_LATITUDE_DEG: 52.3548521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056600',
        LOCATION_NAME: 'Lower Chapel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4150487,
        LOCATION_LATITUDE_DEG: 52.0102333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056700',
        LOCATION_NAME: 'Lower Chedworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9042718,
        LOCATION_LATITUDE_DEG: 51.7958923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056800',
        LOCATION_NAME: 'Lower Chillington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.866088,
        LOCATION_LATITUDE_DEG: 50.8933184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO056900',
        LOCATION_NAME: 'Lower Chute',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.554147,
        LOCATION_LATITUDE_DEG: 51.2764428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080400',
        LOCATION_NAME: 'Lower Clapton',
        COUNTY_NAME: 'London',
        POSTCODE: 'E5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0591414,
        LOCATION_LATITUDE_DEG: 51.5544446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057000',
        LOCATION_NAME: 'Lower Clatcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5169531,
        LOCATION_LATITUDE_DEG: 50.9574234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057100',
        LOCATION_NAME: 'Lower Claverham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7907606,
        LOCATION_LATITUDE_DEG: 51.3993625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057200',
        LOCATION_NAME: 'Lower Cockshutt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5431181,
        LOCATION_LATITUDE_DEG: 52.4519667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057300',
        LOCATION_NAME: 'Lower Comprigney',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0640068,
        LOCATION_LATITUDE_DEG: 50.2678793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057400',
        LOCATION_NAME: 'Lower Compton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1218226,
        LOCATION_LATITUDE_DEG: 50.3878868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057500',
        LOCATION_NAME: 'Lower Condurrow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2717318,
        LOCATION_LATITUDE_DEG: 50.206376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057600',
        LOCATION_NAME: 'Lower Coombses',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9433993,
        LOCATION_LATITUDE_DEG: 50.8459159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057700',
        LOCATION_NAME: 'Lower Coscombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8951697,
        LOCATION_LATITUDE_DEG: 51.9748148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO079500',
        LOCATION_NAME: 'Lower Crumpsall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2250717,
        LOCATION_LATITUDE_DEG: 53.5117379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057800',
        LOCATION_NAME: 'Lower Cumberworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6635675,
        LOCATION_LATITUDE_DEG: 53.5803625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO057900',
        LOCATION_NAME: 'Lower Cwm',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0303757,
        LOCATION_LATITUDE_DEG: 51.6949005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058000',
        LOCATION_NAME: 'Lower Cwmtwrch',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7786419,
        LOCATION_LATITUDE_DEG: 51.7752104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058100',
        LOCATION_NAME: 'Lower Daggons',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8591992,
        LOCATION_LATITUDE_DEG: 50.919811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058200',
        LOCATION_NAME: 'Lower Darwen',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4722966,
        LOCATION_LATITUDE_DEG: 53.7214851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058400',
        LOCATION_NAME: 'Lower Dean',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.785646,
        LOCATION_LATITUDE_DEG: 50.4692905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058300',
        LOCATION_NAME: 'Lower Dean',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4529236,
        LOCATION_LATITUDE_DEG: 52.3079271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058500',
        LOCATION_NAME: 'Lower Denby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6405797,
        LOCATION_LATITUDE_DEG: 53.5657597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058600',
        LOCATION_NAME: 'Lower Denford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4952499,
        LOCATION_LATITUDE_DEG: 51.4107543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058700',
        LOCATION_NAME: 'Lower Dicker',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2090308,
        LOCATION_LATITUDE_DEG: 50.883784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058800',
        LOCATION_NAME: 'Lower Dimson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2154272,
        LOCATION_LATITUDE_DEG: 50.5246969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO058900',
        LOCATION_NAME: 'Lower Dowdeswell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9977335,
        LOCATION_LATITUDE_DEG: 51.8774077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059000',
        LOCATION_NAME: 'Lower Down',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9751964,
        LOCATION_LATITUDE_DEG: 52.4554694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059100',
        LOCATION_NAME: 'Lower Downgate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3061313,
        LOCATION_LATITUDE_DEG: 50.5319033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059200',
        LOCATION_NAME: 'Lower Drift',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.581154,
        LOCATION_LATITUDE_DEG: 50.1007753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059300',
        LOCATION_NAME: 'Lower Dunsforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3220856,
        LOCATION_LATITUDE_DEG: 54.0773098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059400',
        LOCATION_NAME: 'Lower Durston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0030967,
        LOCATION_LATITUDE_DEG: 51.0478379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059500',
        LOCATION_NAME: 'Lower Earley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9174919,
        LOCATION_LATITUDE_DEG: 51.4255476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080700',
        LOCATION_NAME: 'Lower Edmonton',
        COUNTY_NAME: 'London',
        POSTCODE: 'N9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0527805,
        LOCATION_LATITUDE_DEG: 51.6327269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059600',
        LOCATION_NAME: 'Lower Edworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.210098,
        LOCATION_LATITUDE_DEG: 52.0548001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059700',
        LOCATION_NAME: 'Lower Eggleton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5434955,
        LOCATION_LATITUDE_DEG: 52.1028282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059800',
        LOCATION_NAME: 'Lower Emstrey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6937652,
        LOCATION_LATITUDE_DEG: 52.6888932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059900',
        LOCATION_NAME: 'Lower Everleigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7274658,
        LOCATION_LATITUDE_DEG: 51.2883415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060000',
        LOCATION_NAME: 'Lower Fagley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7019822,
        LOCATION_LATITUDE_DEG: 53.809689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060100',
        LOCATION_NAME: 'Lower Failand',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7129127,
        LOCATION_LATITUDE_DEG: 51.4567592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060200',
        LOCATION_NAME: 'Lower Farringdon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9923253,
        LOCATION_LATITUDE_DEG: 51.1095205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060250',
        LOCATION_NAME: 'Lower Foxdale',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6368556,
        LOCATION_LATITUDE_DEG: 54.1829984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060300',
        LOCATION_NAME: 'Lower Frankton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9352245,
        LOCATION_LATITUDE_DEG: 52.8816077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060400',
        LOCATION_NAME: 'Lower Freystrop',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9627016,
        LOCATION_LATITUDE_DEG: 51.7726272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060500',
        LOCATION_NAME: 'Lower Froyle',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9115439,
        LOCATION_LATITUDE_DEG: 51.1887207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060600',
        LOCATION_NAME: 'Lower Fulbrook',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6338288,
        LOCATION_LATITUDE_DEG: 52.2413343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060700',
        LOCATION_NAME: 'Lower Fyfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7972757,
        LOCATION_LATITUDE_DEG: 51.4099572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060800',
        LOCATION_NAME: 'Lower Gellifelen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1336815,
        LOCATION_LATITUDE_DEG: 51.8026058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO060900',
        LOCATION_NAME: 'Lower Gelligroes',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1882946,
        LOCATION_LATITUDE_DEG: 51.6441922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061000',
        LOCATION_NAME: 'Lower Godney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7554739,
        LOCATION_LATITUDE_DEG: 51.1813442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061100',
        LOCATION_NAME: 'Lower Gornal',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1156185,
        LOCATION_LATITUDE_DEG: 52.5212639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO081200',
        LOCATION_NAME: 'Lower Grange',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8149753,
        LOCATION_LATITUDE_DEG: 53.7970982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061200',
        LOCATION_NAME: 'Lower Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3647333,
        LOCATION_LATITUDE_DEG: 51.3791358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061300',
        LOCATION_NAME: 'Lower Gresham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.236774,
        LOCATION_LATITUDE_DEG: 52.8964533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061400',
        LOCATION_NAME: 'Lower Grove Common',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6438765,
        LOCATION_LATITUDE_DEG: 51.929913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061500',
        LOCATION_NAME: 'Lower Hacheston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3847572,
        LOCATION_LATITUDE_DEG: 52.1581873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061600',
        LOCATION_NAME: 'Lower Hale',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7839751,
        LOCATION_LATITUDE_DEG: 51.2234289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061700',
        LOCATION_NAME: 'Lower Halstow',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6695957,
        LOCATION_LATITUDE_DEG: 51.3732232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061800',
        LOCATION_NAME: 'Lower Hardres',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0811675,
        LOCATION_LATITUDE_DEG: 51.2355028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO061900',
        LOCATION_NAME: 'Lower Harlestone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9765518,
        LOCATION_LATITUDE_DEG: 52.270726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062000',
        LOCATION_NAME: 'Lower Hartshay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.438887,
        LOCATION_LATITUDE_DEG: 53.0594115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062100',
        LOCATION_NAME: 'Lower Hartwell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8541832,
        LOCATION_LATITUDE_DEG: 51.8046823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062200',
        LOCATION_NAME: 'Lower Haven Hills',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3826843,
        LOCATION_LATITUDE_DEG: 52.6207797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062300',
        LOCATION_NAME: 'Lower Hawthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2009949,
        LOCATION_LATITUDE_DEG: 54.2916501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062400',
        LOCATION_NAME: 'Lower Hayton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7300103,
        LOCATION_LATITUDE_DEG: 52.4245625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062500',
        LOCATION_NAME: 'Lower Hazel',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5384332,
        LOCATION_LATITUDE_DEG: 51.5823811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062600',
        LOCATION_NAME: 'Lower Henlade',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0416981,
        LOCATION_LATITUDE_DEG: 51.0055363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062700',
        LOCATION_NAME: 'Lower Hergest',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.05844,
        LOCATION_LATITUDE_DEG: 52.1921441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062800',
        LOCATION_NAME: 'Lower Heyford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2839075,
        LOCATION_LATITUDE_DEG: 51.9187953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO062900',
        LOCATION_NAME: 'Lower Higham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4661371,
        LOCATION_LATITUDE_DEG: 51.4271274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063000',
        LOCATION_NAME: 'Lower Hillhead',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1466238,
        LOCATION_LATITUDE_DEG: 60.1543014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063100',
        LOCATION_NAME: 'Lower Holbrook',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1663685,
        LOCATION_LATITUDE_DEG: 51.9682839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063200',
        LOCATION_NAME: 'Lower Holway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0764076,
        LOCATION_LATITUDE_DEG: 51.0067326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063300',
        LOCATION_NAME: 'Lower Hopton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9190327,
        LOCATION_LATITUDE_DEG: 52.7807046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063400',
        LOCATION_NAME: 'Lower Horsebridge',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2427281,
        LOCATION_LATITUDE_DEG: 50.8807755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063500',
        LOCATION_NAME: 'Lower Horton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9450958,
        LOCATION_LATITUDE_DEG: 50.9291208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063600',
        LOCATION_NAME: 'Lower Hounsley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6543531,
        LOCATION_LATITUDE_DEG: 51.3578653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063700',
        LOCATION_NAME: 'Lower Kelly',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2113292,
        LOCATION_LATITUDE_DEG: 50.4961968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063800',
        LOCATION_NAME: 'Lower Kenneggy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4007425,
        LOCATION_LATITUDE_DEG: 50.1082665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO063900',
        LOCATION_NAME: 'Lower Kilburn',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4382696,
        LOCATION_LATITUDE_DEG: 53.0013043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064000',
        LOCATION_NAME: 'Lower Kingcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6318838,
        LOCATION_LATITUDE_DEG: 50.7894066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064100',
        LOCATION_NAME: 'Lower Kingswood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2038188,
        LOCATION_LATITUDE_DEG: 51.2729194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064200',
        LOCATION_NAME: 'Lower Kinnerton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9813184,
        LOCATION_LATITUDE_DEG: 53.1519414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064300',
        LOCATION_NAME: 'Lower Langham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3138268,
        LOCATION_LATITUDE_DEG: 51.0337256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064400',
        LOCATION_NAME: 'Lower Largo',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9349608,
        LOCATION_LATITUDE_DEG: 56.212832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064500',
        LOCATION_NAME: 'Lower Lemington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6853762,
        LOCATION_LATITUDE_DEG: 52.0062091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064600',
        LOCATION_NAME: 'Lower Lodge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1136951,
        LOCATION_LATITUDE_DEG: 51.4370643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064700',
        LOCATION_NAME: 'Lower Longwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5885591,
        LOCATION_LATITUDE_DEG: 52.6555847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064800',
        LOCATION_NAME: 'Lower Loxhore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9815898,
        LOCATION_LATITUDE_DEG: 51.1207507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO064900',
        LOCATION_NAME: 'Lower Lumsdale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5394858,
        LOCATION_LATITUDE_DEG: 53.1402153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065000',
        LOCATION_NAME: 'Lower Lydbrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5857327,
        LOCATION_LATITUDE_DEG: 51.8445046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065100',
        LOCATION_NAME: 'Lower Lyde',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7146346,
        LOCATION_LATITUDE_DEG: 52.0896323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065200',
        LOCATION_NAME: 'Lower Lye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8725474,
        LOCATION_LATITUDE_DEG: 52.2957562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065300',
        LOCATION_NAME: 'Lower Machen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1137608,
        LOCATION_LATITUDE_DEG: 51.5842849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065400',
        LOCATION_NAME: 'Lower Maescoed',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9520202,
        LOCATION_LATITUDE_DEG: 51.9695746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065500',
        LOCATION_NAME: 'Lower Mains',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6777619,
        LOCATION_LATITUDE_DEG: 56.1577418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065600',
        LOCATION_NAME: 'Lower Meend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.630646,
        LOCATION_LATITUDE_DEG: 51.7381017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065700',
        LOCATION_NAME: 'Lower Merridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1386013,
        LOCATION_LATITUDE_DEG: 51.1032465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065800',
        LOCATION_NAME: 'Lower Metherell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2440298,
        LOCATION_LATITUDE_DEG: 50.5011928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO065900',
        LOCATION_NAME: 'Lower Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9503066,
        LOCATION_LATITUDE_DEG: 50.2064796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066000',
        LOCATION_NAME: 'Lower Mill Bank',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9398124,
        LOCATION_LATITUDE_DEG: 53.6914781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066100',
        LOCATION_NAME: 'Lower Millichope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.690919,
        LOCATION_LATITUDE_DEG: 52.4895701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066200',
        LOCATION_NAME: 'Lower Mills',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.283903,
        LOCATION_LATITUDE_DEG: 51.7397924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066300',
        LOCATION_NAME: 'Lower Moor',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0288522,
        LOCATION_LATITUDE_DEG: 52.1252255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066400',
        LOCATION_NAME: 'Lower Morton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5155336,
        LOCATION_LATITUDE_DEG: 51.626385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066500',
        LOCATION_NAME: 'Lower Ninnis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1880298,
        LOCATION_LATITUDE_DEG: 50.2339778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066600',
        LOCATION_NAME: 'Lower North Wraxall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2541138,
        LOCATION_LATITUDE_DEG: 51.4741723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066700',
        LOCATION_NAME: 'Lower Norton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6559339,
        LOCATION_LATITUDE_DEG: 52.2731404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066800',
        LOCATION_NAME: 'Lower Odcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.699493,
        LOCATION_LATITUDE_DEG: 50.9319026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080100',
        LOCATION_NAME: 'Lower Openshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO066900',
        LOCATION_NAME: 'Lower Padworth',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1156029,
        LOCATION_LATITUDE_DEG: 51.3964451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067000',
        LOCATION_NAME: 'Lower Pengegon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2820401,
        LOCATION_LATITUDE_DEG: 50.2133817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067100',
        LOCATION_NAME: 'Lower Penn',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.196989,
        LOCATION_LATITUDE_DEG: 52.5623709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067200',
        LOCATION_NAME: 'Lower Pennance',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2009264,
        LOCATION_LATITUDE_DEG: 50.2164836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067300',
        LOCATION_NAME: 'Lower Penponds',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3119308,
        LOCATION_LATITUDE_DEG: 50.1989828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067400',
        LOCATION_NAME: 'Lower Peover',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3857553,
        LOCATION_LATITUDE_DEG: 53.2664393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067500',
        LOCATION_NAME: 'Lower Pilsley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3748095,
        LOCATION_LATITUDE_DEG: 53.166417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067600',
        LOCATION_NAME: 'Lower Polscoe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6620676,
        LOCATION_LATITUDE_DEG: 50.4100928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067700',
        LOCATION_NAME: 'Lower Porkellis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2300247,
        LOCATION_LATITUDE_DEG: 50.1490719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067800',
        LOCATION_NAME: 'Lower Priory',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0361712,
        LOCATION_LATITUDE_DEG: 51.723419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO067900',
        LOCATION_NAME: 'Lower Pulley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7629217,
        LOCATION_LATITUDE_DEG: 52.6785873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068000',
        LOCATION_NAME: 'Lower Quinton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.732608,
        LOCATION_LATITUDE_DEG: 52.1217249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068100',
        LOCATION_NAME: 'Lower Race',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0491778,
        LOCATION_LATITUDE_DEG: 51.6945003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068200',
        LOCATION_NAME: 'Lower Radley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2293086,
        LOCATION_LATITUDE_DEG: 51.6836722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990194',
        LOCATION_NAME: 'LOWER RAYDON',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9643116,
        LOCATION_LATITUDE_DEG: 52.0068644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068300',
        LOCATION_NAME: 'Lower Rillaton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4038376,
        LOCATION_LATITUDE_DEG: 50.5380041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068400',
        LOCATION_NAME: 'Lower Rudge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2451227,
        LOCATION_LATITUDE_DEG: 51.263249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068500',
        LOCATION_NAME: 'Lower Rudloe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2302066,
        LOCATION_LATITUDE_DEG: 51.4305626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068600',
        LOCATION_NAME: 'Lower Seagry',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0590358,
        LOCATION_LATITUDE_DEG: 51.5272727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068700',
        LOCATION_NAME: 'Lower Severalls',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.770882,
        LOCATION_LATITUDE_DEG: 50.8958206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068800',
        LOCATION_NAME: 'Lower Shader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4655253,
        LOCATION_LATITUDE_DEG: 58.4002876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO068900',
        LOCATION_NAME: 'Lower Shelton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5451361,
        LOCATION_LATITUDE_DEG: 52.0732075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069000',
        LOCATION_NAME: 'Lower Shiplake',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8824532,
        LOCATION_LATITUDE_DEG: 51.5108585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069100',
        LOCATION_NAME: 'Lower Shockerwick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.283823,
        LOCATION_LATITUDE_DEG: 51.4118662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069200',
        LOCATION_NAME: 'Lower Shuckburgh',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2844917,
        LOCATION_LATITUDE_DEG: 52.2590297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069300',
        LOCATION_NAME: 'Lower Silver Valley',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2833331,
        LOCATION_LATITUDE_DEG: 50.4972978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069400',
        LOCATION_NAME: 'Lower Slaughter',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7619908,
        LOCATION_LATITUDE_DEG: 51.9006989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069500',
        LOCATION_NAME: 'Lower Somersham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0492149,
        LOCATION_LATITUDE_DEG: 52.0957854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069600',
        LOCATION_NAME: 'Lower Somerton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7099685,
        LOCATION_LATITUDE_DEG: 51.0524323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069700',
        LOCATION_NAME: 'Lower Soothill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6148192,
        LOCATION_LATITUDE_DEG: 53.7117739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069800',
        LOCATION_NAME: 'Lower Soudley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.486009,
        LOCATION_LATITUDE_DEG: 51.7877961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO069900',
        LOCATION_NAME: 'Lower South Wraxall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2413272,
        LOCATION_LATITUDE_DEG: 51.3759547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070000',
        LOCATION_NAME: 'Lower Standen',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1993556,
        LOCATION_LATITUDE_DEG: 51.1174858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078700',
        LOCATION_NAME: 'Lower Stanton St Quintin',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070100',
        LOCATION_NAME: 'Lower Stanton St. Quintin',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.119323,
        LOCATION_LATITUDE_DEG: 51.5261747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070200',
        LOCATION_NAME: 'Lower Sticker',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8398828,
        LOCATION_LATITUDE_DEG: 50.3054862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070300',
        LOCATION_NAME: 'Lower Stoke',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6394051,
        LOCATION_LATITUDE_DEG: 51.4514244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070400',
        LOCATION_NAME: 'Lower Stondon',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3177897,
        LOCATION_LATITUDE_DEG: 52.0009922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070500',
        LOCATION_NAME: 'Lower Stone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4742247,
        LOCATION_LATITUDE_DEG: 51.6483836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070600',
        LOCATION_NAME: 'Lower Stow Bedon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9032114,
        LOCATION_LATITUDE_DEG: 52.5132247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070700',
        LOCATION_NAME: 'Lower Strensham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1415797,
        LOCATION_LATITUDE_DEG: 52.0627243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070800',
        LOCATION_NAME: 'Lower Stretton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5657682,
        LOCATION_LATITUDE_DEG: 53.3322463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO070900',
        LOCATION_NAME: 'Lower Sundon',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4702386,
        LOCATION_LATITUDE_DEG: 51.9323896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071000',
        LOCATION_NAME: 'Lower Sutton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3502739,
        LOCATION_LATITUDE_DEG: 52.7947962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071100',
        LOCATION_NAME: 'Lower Swanwick',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.294717,
        LOCATION_LATITUDE_DEG: 50.8809013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071200',
        LOCATION_NAME: 'Lower Swell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7469398,
        LOCATION_LATITUDE_DEG: 51.9277061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080000',
        LOCATION_NAME: 'Lower Sydenham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0526189,
        LOCATION_LATITUDE_DEG: 51.4290725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071300',
        LOCATION_NAME: 'Lower Tadmarton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4110567,
        LOCATION_LATITUDE_DEG: 52.0313143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071400',
        LOCATION_NAME: 'Lower Tean',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9763799,
        LOCATION_LATITUDE_DEG: 52.9452259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071500',
        LOCATION_NAME: 'Lower Thornton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0355807,
        LOCATION_LATITUDE_DEG: 51.7390227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071600',
        LOCATION_NAME: 'Lower Thurlton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5768497,
        LOCATION_LATITUDE_DEG: 52.5356194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO080600',
        LOCATION_NAME: 'Lower Tottenham',
        COUNTY_NAME: 'London',
        POSTCODE: 'N17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071850',
        LOCATION_NAME: 'Lower Town',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3020338,
        LOCATION_LATITUDE_DEG: 49.9678941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071800',
        LOCATION_NAME: 'Lower Town',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9659627,
        LOCATION_LATITUDE_DEG: 51.9941493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071700',
        LOCATION_NAME: 'Lower Town',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.645562,
        LOCATION_LATITUDE_DEG: 50.6515011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO071900',
        LOCATION_NAME: 'Lower Treculliacks',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.19102,
        LOCATION_LATITUDE_DEG: 50.1312753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072000',
        LOCATION_NAME: 'Lower Tregantle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2612298,
        LOCATION_LATITUDE_DEG: 50.3600807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072100',
        LOCATION_NAME: 'Lower Treluswell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1060236,
        LOCATION_LATITUDE_DEG: 50.1803751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072200',
        LOCATION_NAME: 'Lower Tremar',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4554536,
        LOCATION_LATITUDE_DEG: 50.4852018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072300',
        LOCATION_NAME: 'Lower Tysoe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4961759,
        LOCATION_LATITUDE_DEG: 52.1029145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072400',
        LOCATION_NAME: 'Lower Upham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2547298,
        LOCATION_LATITUDE_DEG: 50.972405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072500',
        LOCATION_NAME: 'Lower Upnor',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5318522,
        LOCATION_LATITUDE_DEG: 51.4147253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072700',
        LOCATION_NAME: 'Lower Upton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5515508,
        LOCATION_LATITUDE_DEG: 50.8020267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072600',
        LOCATION_NAME: 'Lower Upton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.347486,
        LOCATION_LATITUDE_DEG: 52.6532821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072800',
        LOCATION_NAME: 'Lower Walton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5957773,
        LOCATION_LATITUDE_DEG: 53.3691024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO072900',
        LOCATION_NAME: 'Lower Washfield',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5051452,
        LOCATION_LATITUDE_DEG: 50.9307273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073000',
        LOCATION_NAME: 'Lower Washford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.361721,
        LOCATION_LATITUDE_DEG: 51.1611539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073100',
        LOCATION_NAME: 'Lower Waterditch',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7489909,
        LOCATION_LATITUDE_DEG: 50.7631925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073200',
        LOCATION_NAME: 'Lower Waterston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3722489,
        LOCATION_LATITUDE_DEG: 50.7538029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073300',
        LOCATION_NAME: 'Lower Weare',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8521323,
        LOCATION_LATITUDE_DEG: 51.2784535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073400',
        LOCATION_NAME: 'Lower West Tolgus',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2358329,
        LOCATION_LATITUDE_DEG: 50.2343826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073500',
        LOCATION_NAME: 'Lower Westford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2481219,
        LOCATION_LATITUDE_DEG: 50.976829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073600',
        LOCATION_NAME: 'Lower Weston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3841302,
        LOCATION_LATITUDE_DEG: 51.384962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073700',
        LOCATION_NAME: 'Lower Westwood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2758233,
        LOCATION_LATITUDE_DEG: 51.3298536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073800',
        LOCATION_NAME: 'Lower Whitley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5793078,
        LOCATION_LATITUDE_DEG: 53.3051488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO073900',
        LOCATION_NAME: 'Lower Wield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0896627,
        LOCATION_LATITUDE_DEG: 51.1588198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074000',
        LOCATION_NAME: 'Lower Willey',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9636629,
        LOCATION_LATITUDE_DEG: 52.2964505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074100',
        LOCATION_NAME: 'Lower Willingdon',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.251997,
        LOCATION_LATITUDE_DEG: 50.8084757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074200',
        LOCATION_NAME: 'Lower Withington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2766181,
        LOCATION_LATITUDE_DEG: 53.2238338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074300',
        LOCATION_NAME: 'Lower Wolverton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1034213,
        LOCATION_LATITUDE_DEG: 52.1531293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074400',
        LOCATION_NAME: 'Lower Woodbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1729246,
        LOCATION_LATITUDE_DEG: 50.7345007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074500',
        LOCATION_NAME: 'Lower Woodcott',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3617319,
        LOCATION_LATITUDE_DEG: 51.2887357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074700',
        LOCATION_NAME: 'Lower Woodford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5277976,
        LOCATION_LATITUDE_DEG: 50.8915345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074600',
        LOCATION_NAME: 'Lower Woodford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8203796,
        LOCATION_LATITUDE_DEG: 51.116827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074800',
        LOCATION_NAME: 'Lower Woodside',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.430983,
        LOCATION_LATITUDE_DEG: 51.8549852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO074900',
        LOCATION_NAME: 'Lower Woolstone',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5792703,
        LOCATION_LATITUDE_DEG: 51.5799665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO081500',
        LOCATION_NAME: 'Lower Wortley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5763716,
        LOCATION_LATITUDE_DEG: 53.7861553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075100',
        LOCATION_NAME: 'Lower Wraxall',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6015876,
        LOCATION_LATITUDE_DEG: 50.8046043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075000',
        LOCATION_NAME: 'Lower Wraxall',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5580346,
        LOCATION_LATITUDE_DEG: 51.118934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075200',
        LOCATION_NAME: 'Lower Wych',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7625031,
        LOCATION_LATITUDE_DEG: 52.9945225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075300',
        LOCATION_NAME: 'Lower Wyke',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.771087,
        LOCATION_LATITUDE_DEG: 53.7288762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075400',
        LOCATION_NAME: 'Lower Wyke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4145777,
        LOCATION_LATITUDE_DEG: 51.2360342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075500',
        LOCATION_NAME: 'Lower Yorkley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5268344,
        LOCATION_LATITUDE_DEG: 51.7587015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075600',
        LOCATION_NAME: 'Lowerhouses',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7636584,
        LOCATION_LATITUDE_DEG: 53.6370729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075800',
        LOCATION_NAME: 'Lowertown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2729391,
        LOCATION_LATITUDE_DEG: 50.1133739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075900',
        LOCATION_NAME: 'Lowesby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9291556,
        LOCATION_LATITUDE_DEG: 52.6599674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076000',
        LOCATION_NAME: 'Lowestoft',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7533343,
        LOCATION_LATITUDE_DEG: 52.4760099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076100',
        LOCATION_NAME: 'Loweswater',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3256462,
        LOCATION_LATITUDE_DEG: 54.5777804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076200',
        LOCATION_NAME: 'Lowfield Heath',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1882289,
        LOCATION_LATITUDE_DEG: 51.1384089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076300',
        LOCATION_NAME: 'Lowfields',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3015183,
        LOCATION_LATITUDE_DEG: 54.5235507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076500',
        LOCATION_NAME: 'Lowgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5847042,
        LOCATION_LATITUDE_DEG: 54.3662496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076400',
        LOCATION_NAME: 'Lowgill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5272702,
        LOCATION_LATITUDE_DEG: 54.0734171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076600',
        LOCATION_NAME: 'Lowick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9759229,
        LOCATION_LATITUDE_DEG: 55.6506679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076700',
        LOCATION_NAME: 'Lowick',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5640899,
        LOCATION_LATITUDE_DEG: 52.41584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076800',
        LOCATION_NAME: 'Lowick Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0857367,
        LOCATION_LATITUDE_DEG: 54.2694438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO076900',
        LOCATION_NAME: 'Lowick Green',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0804041,
        LOCATION_LATITUDE_DEG: 54.2581478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077000',
        LOCATION_NAME: 'Lowsonford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7240694,
        LOCATION_LATITUDE_DEG: 52.3072435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077100',
        LOCATION_NAME: 'Lowther',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7183548,
        LOCATION_LATITUDE_DEG: 54.6054777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077200',
        LOCATION_NAME: 'Lowthertown',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1808316,
        LOCATION_LATITUDE_DEG: 54.9893207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077300',
        LOCATION_NAME: 'Lowthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3528269,
        LOCATION_LATITUDE_DEG: 54.0306888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077500',
        LOCATION_NAME: 'Lowton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1412167,
        LOCATION_LATITUDE_DEG: 50.9581273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077400',
        LOCATION_NAME: 'Lowton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5762513,
        LOCATION_LATITUDE_DEG: 53.4725619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077600',
        LOCATION_NAME: 'Lowtown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6522718,
        LOCATION_LATITUDE_DEG: 53.7986874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077700',
        LOCATION_NAME: 'Loxbeare',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5487519,
        LOCATION_LATITUDE_DEG: 50.9328283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077800',
        LOCATION_NAME: 'Loxhill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5685202,
        LOCATION_LATITUDE_DEG: 51.1335108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO077900',
        LOCATION_NAME: 'Loxhore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.976612,
        LOCATION_LATITUDE_DEG: 51.1293524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078100',
        LOCATION_NAME: 'Loxley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6217425,
        LOCATION_LATITUDE_DEG: 52.1744266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078000',
        LOCATION_NAME: 'Loxley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5388734,
        LOCATION_LATITUDE_DEG: 53.4049471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078200',
        LOCATION_NAME: 'Loxton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8986726,
        LOCATION_LATITUDE_DEG: 51.2951564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078300',
        LOCATION_NAME: 'Loxwood',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5171013,
        LOCATION_LATITUDE_DEG: 51.0773067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO078400',
        LOCATION_NAME: 'Lozells',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9090543,
        LOCATION_LATITUDE_DEG: 52.5005613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU990822',
        LOCATION_NAME: 'Lubbesthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000100',
        LOCATION_NAME: 'Lubenham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.961436,
        LOCATION_LATITUDE_DEG: 52.4794495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000300',
        LOCATION_NAME: 'Lucas Wood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.968805,
        LOCATION_LATITUDE_DEG: 50.3968839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000400',
        LOCATION_NAME: 'Luccombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5584582,
        LOCATION_LATITUDE_DEG: 51.1903557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000500',
        LOCATION_NAME: 'Luccombe Village',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1760177,
        LOCATION_LATITUDE_DEG: 50.6155696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000600',
        LOCATION_NAME: 'Lucker',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7585739,
        LOCATION_LATITUDE_DEG: 55.5660599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000700',
        LOCATION_NAME: 'Luckett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2738632,
        LOCATION_LATITUDE_DEG: 50.5403012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000800',
        LOCATION_NAME: 'Luckington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2400081,
        LOCATION_LATITUDE_DEG: 51.5548737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000900',
        LOCATION_NAME: 'Lucklawhill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9273012,
        LOCATION_LATITUDE_DEG: 56.3836551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001000',
        LOCATION_NAME: 'Luckwell Bridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5637971,
        LOCATION_LATITUDE_DEG: 51.1366548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001100',
        LOCATION_NAME: 'Lucton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8238006,
        LOCATION_LATITUDE_DEG: 52.2720539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001200',
        LOCATION_NAME: 'Ludborough',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0499337,
        LOCATION_LATITUDE_DEG: 53.4405314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001300',
        LOCATION_NAME: 'Ludbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8820993,
        LOCATION_LATITUDE_DEG: 50.3661798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001400',
        LOCATION_NAME: 'Ludchurch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6933443,
        LOCATION_LATITUDE_DEG: 51.7619232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001500',
        LOCATION_NAME: 'Luddenden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9372132,
        LOCATION_LATITUDE_DEG: 53.7282783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001600',
        LOCATION_NAME: 'Luddendenfoot',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9359037,
        LOCATION_LATITUDE_DEG: 53.732107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001700',
        LOCATION_NAME: 'Luddenham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8516785,
        LOCATION_LATITUDE_DEG: 51.3162093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001800',
        LOCATION_NAME: 'Luddesdown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3995197,
        LOCATION_LATITUDE_DEG: 51.3705238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002000',
        LOCATION_NAME: 'Luddington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7587593,
        LOCATION_LATITUDE_DEG: 52.1697241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU001900',
        LOCATION_NAME: 'Luddington',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7447782,
        LOCATION_LATITUDE_DEG: 53.6402546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002100',
        LOCATION_NAME: 'Luddington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3736512,
        LOCATION_LATITUDE_DEG: 52.4389378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002200',
        LOCATION_NAME: 'Ludford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7140478,
        LOCATION_LATITUDE_DEG: 52.3623592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002300',
        LOCATION_NAME: 'Ludford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1984908,
        LOCATION_LATITUDE_DEG: 53.3848287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002500',
        LOCATION_NAME: 'Ludgershall',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6485613,
        LOCATION_LATITUDE_DEG: 51.1995328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002400',
        LOCATION_NAME: 'Ludgershall',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0400943,
        LOCATION_LATITUDE_DEG: 51.854087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002600',
        LOCATION_NAME: 'Ludgvan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4929532,
        LOCATION_LATITUDE_DEG: 50.1437748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002700',
        LOCATION_NAME: 'Ludham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5368661,
        LOCATION_LATITUDE_DEG: 52.709532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002800',
        LOCATION_NAME: 'Ludlow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7160901,
        LOCATION_LATITUDE_DEG: 52.3678585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU002900',
        LOCATION_NAME: 'Ludney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8650065,
        LOCATION_LATITUDE_DEG: 50.9086246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003000',
        LOCATION_NAME: 'Ludney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1012399,
        LOCATION_LATITUDE_DEG: 53.4408263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003100',
        LOCATION_NAME: 'Ludstone',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.293583,
        LOCATION_LATITUDE_DEG: 52.5472728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003200',
        LOCATION_NAME: 'Ludwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1297486,
        LOCATION_LATITUDE_DEG: 51.0027244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003300',
        LOCATION_NAME: 'Ludworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.436121,
        LOCATION_LATITUDE_DEG: 54.7664767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003400',
        LOCATION_NAME: 'Luffenhall',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1175645,
        LOCATION_LATITUDE_DEG: 51.9444897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003500',
        LOCATION_NAME: 'Lufton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6860759,
        LOCATION_LATITUDE_DEG: 50.9476219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003600',
        LOCATION_NAME: 'Lugar',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2282463,
        LOCATION_LATITUDE_DEG: 55.4661726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003700',
        LOCATION_NAME: 'Lugg Bridge',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6771857,
        LOCATION_LATITUDE_DEG: 52.0718339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003900',
        LOCATION_NAME: 'Luggiebank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9782897,
        LOCATION_LATITUDE_DEG: 55.9298166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004200',
        LOCATION_NAME: 'Lugton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5280001,
        LOCATION_LATITUDE_DEG: 55.7443064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004300',
        LOCATION_NAME: 'Lugwardine',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6546984,
        LOCATION_LATITUDE_DEG: 52.0657296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004400',
        LOCATION_NAME: 'Luib',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0409678,
        LOCATION_LATITUDE_DEG: 57.2769763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004500',
        LOCATION_NAME: 'Luib',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4406723,
        LOCATION_LATITUDE_DEG: 56.4215737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004700',
        LOCATION_NAME: 'Lulham',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8629225,
        LOCATION_LATITUDE_DEG: 52.0650275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004800',
        LOCATION_NAME: 'Lullingstone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1772115,
        LOCATION_LATITUDE_DEG: 51.3658284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005000',
        LOCATION_NAME: 'Lullington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3056222,
        LOCATION_LATITUDE_DEG: 51.2648513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004900',
        LOCATION_NAME: 'Lullington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6306044,
        LOCATION_LATITUDE_DEG: 52.7145776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005100',
        LOCATION_NAME: 'Lullington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.167487,
        LOCATION_LATITUDE_DEG: 50.8029711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005300',
        LOCATION_NAME: 'Lulsgate',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6968634,
        LOCATION_LATITUDE_DEG: 51.3877642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005400',
        LOCATION_NAME: 'Lulworth Camp',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2331206,
        LOCATION_LATITUDE_DEG: 50.6332878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005500',
        LOCATION_NAME: 'Lumb',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2460289,
        LOCATION_LATITUDE_DEG: 53.7187834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005600',
        LOCATION_NAME: 'Lumburn',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1723145,
        LOCATION_LATITUDE_DEG: 50.5372034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005700',
        LOCATION_NAME: 'Lumley Links',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5545311,
        LOCATION_LATITUDE_DEG: 54.8518841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005800',
        LOCATION_NAME: 'Lumley Park',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5585197,
        LOCATION_LATITUDE_DEG: 54.8560869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005900',
        LOCATION_NAME: 'Lumloch',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.183619,
        LOCATION_LATITUDE_DEG: 55.9024202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006000',
        LOCATION_NAME: 'Lumphanan',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6869461,
        LOCATION_LATITUDE_DEG: 57.1286215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006100',
        LOCATION_NAME: 'Lumphinnans',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.337992,
        LOCATION_LATITUDE_DEG: 56.1181322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006200',
        LOCATION_NAME: 'Lumsden',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8740008,
        LOCATION_LATITUDE_DEG: 57.2844425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006300',
        LOCATION_NAME: 'Lunan',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.510989,
        LOCATION_LATITUDE_DEG: 56.6561712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006400',
        LOCATION_NAME: 'Lunanhead',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8533352,
        LOCATION_LATITUDE_DEG: 56.6594801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006500',
        LOCATION_NAME: 'Luncarty',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4696138,
        LOCATION_LATITUDE_DEG: 56.4483628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006600',
        LOCATION_NAME: 'Lund',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5228066,
        LOCATION_LATITUDE_DEG: 53.9196816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006700',
        LOCATION_NAME: 'Lund House Green',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5593682,
        LOCATION_LATITUDE_DEG: 53.968696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006800',
        LOCATION_NAME: 'Lundale',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7839641,
        LOCATION_LATITUDE_DEG: 58.1897749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU006900',
        LOCATION_NAME: 'Lundie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1536534,
        LOCATION_LATITUDE_DEG: 56.5162643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007000',
        LOCATION_NAME: 'Lundin Links',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9502126,
        LOCATION_LATITUDE_DEG: 56.2140367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007100',
        LOCATION_NAME: 'Lunds',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3230065,
        LOCATION_LATITUDE_DEG: 54.3438461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007200',
        LOCATION_NAME: 'Lundwood',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4324978,
        LOCATION_LATITUDE_DEG: 53.5598565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007300',
        LOCATION_NAME: 'Lundy Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8823524,
        LOCATION_LATITUDE_DEG: 50.5818136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007400',
        LOCATION_NAME: 'Lundy Island',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6676148,
        LOCATION_LATITUDE_DEG: 51.1800025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007500',
        LOCATION_NAME: 'Lunnon',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1005887,
        LOCATION_LATITUDE_DEG: 51.5837018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007600',
        LOCATION_NAME: 'Lunt',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9834009,
        LOCATION_LATITUDE_DEG: 53.507968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007700',
        LOCATION_NAME: 'Luppitt',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1770025,
        LOCATION_LATITUDE_DEG: 50.8515192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007800',
        LOCATION_NAME: 'Lupset',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.528051,
        LOCATION_LATITUDE_DEG: 53.6741671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008000',
        LOCATION_NAME: 'Lupton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5438927,
        LOCATION_LATITUDE_DEG: 50.3837819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU007900',
        LOCATION_NAME: 'Lupton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6837094,
        LOCATION_LATITUDE_DEG: 54.224242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008100',
        LOCATION_NAME: 'Lurgan',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3414401,
        LOCATION_LATITUDE_DEG: 54.4663016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU990689',
        LOCATION_NAME: 'Lurganare',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU990690',
        LOCATION_NAME: 'Lurganare Cross',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008400',
        LOCATION_NAME: 'Lurgashall',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6646854,
        LOCATION_LATITUDE_DEG: 51.0356103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008500',
        LOCATION_NAME: 'Lurley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5305504,
        LOCATION_LATITUDE_DEG: 50.922932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008600',
        LOCATION_NAME: 'Lusby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0046903,
        LOCATION_LATITUDE_DEG: 53.1905046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008700',
        LOCATION_NAME: 'Lushill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7658642,
        LOCATION_LATITUDE_DEG: 51.6472822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008900',
        LOCATION_NAME: 'Luskentyre',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9438863,
        LOCATION_LATITUDE_DEG: 57.8843449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009000',
        LOCATION_NAME: 'Luson',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.962001,
        LOCATION_LATITUDE_DEG: 50.3339783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009100',
        LOCATION_NAME: 'Luss',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.637421,
        LOCATION_LATITUDE_DEG: 56.101042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009200',
        LOCATION_NAME: 'Lussagiven',
        COUNTY_NAME: 'Isle of Jura',
        POSTCODE: 'PA60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7921707,
        LOCATION_LATITUDE_DEG: 56.0153509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009300',
        LOCATION_NAME: 'Lustleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7154694,
        LOCATION_LATITUDE_DEG: 50.6162052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009400',
        LOCATION_NAME: 'Luston',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7527022,
        LOCATION_LATITUDE_DEG: 52.2636449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009450',
        LOCATION_NAME: 'Lusty Beg',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.8332958,
        LOCATION_LATITUDE_DEG: 54.5046217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009500',
        LOCATION_NAME: 'Luthermuir',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5619578,
        LOCATION_LATITUDE_DEG: 56.8077867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009600',
        LOCATION_NAME: 'Luthrie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0822466,
        LOCATION_LATITUDE_DEG: 56.363754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009700',
        LOCATION_NAME: 'Luton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5510108,
        LOCATION_LATITUDE_DEG: 50.5809949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009800',
        LOCATION_NAME: 'Luton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4108693,
        LOCATION_LATITUDE_DEG: 51.8784831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU009900',
        LOCATION_NAME: 'Lutterworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2012442,
        LOCATION_LATITUDE_DEG: 52.4563519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU010200',
        LOCATION_NAME: 'Lutton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9800267,
        LOCATION_LATITUDE_DEG: 50.4145848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU010000',
        LOCATION_NAME: 'Lutton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3644633,
        LOCATION_LATITUDE_DEG: 52.4772428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU010100',
        LOCATION_NAME: 'Lutton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.126199,
        LOCATION_LATITUDE_DEG: 52.8078682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU010300',
        LOCATION_NAME: 'Lutton Garnsgate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1003944,
        LOCATION_LATITUDE_DEG: 52.7835635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU990243',
        LOCATION_NAME: 'Lutton Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1881405,
        LOCATION_LATITUDE_DEG: 52.815887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU010400',
        LOCATION_NAME: 'Luxborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4656118,
        LOCATION_LATITUDE_DEG: 51.130246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU010500',
        LOCATION_NAME: 'Luxulyan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7409744,
        LOCATION_LATITUDE_DEG: 50.3927949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000100',
        LOCATION_NAME: 'Lybster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2842537,
        LOCATION_LATITUDE_DEG: 58.3085447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000200',
        LOCATION_NAME: 'Lychpit',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0544089,
        LOCATION_LATITUDE_DEG: 51.2769356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000300',
        LOCATION_NAME: 'Lydacott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1505251,
        LOCATION_LATITUDE_DEG: 50.8094736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000350',
        LOCATION_NAME: 'Lydart',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7268364,
        LOCATION_LATITUDE_DEG: 51.7816443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000400',
        LOCATION_NAME: 'Lydbrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5762174,
        LOCATION_LATITUDE_DEG: 51.8372051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000500',
        LOCATION_NAME: 'Lydbury North',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9543542,
        LOCATION_LATITUDE_DEG: 52.4676698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000600',
        LOCATION_NAME: 'Lydd',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9089537,
        LOCATION_LATITUDE_DEG: 50.951776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000700',
        LOCATION_NAME: 'Lydd on Sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9679553,
        LOCATION_LATITUDE_DEG: 50.9481763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY000800',
        LOCATION_NAME: 'Lydden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2373736,
        LOCATION_LATITUDE_DEG: 51.1625885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY990132',
        LOCATION_NAME: 'Lyddington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001000',
        LOCATION_NAME: 'Lyddington',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7084314,
        LOCATION_LATITUDE_DEG: 52.5629529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001100',
        LOCATION_NAME: 'Lyde',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7228781,
        LOCATION_LATITUDE_DEG: 52.0902834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001200',
        LOCATION_NAME: 'Lyde Cross',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7071524,
        LOCATION_LATITUDE_DEG: 52.0863325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY009000',
        LOCATION_NAME: 'Lydeard St Lawrence',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001300',
        LOCATION_NAME: 'Lydeard St. Lawrence',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2443932,
        LOCATION_LATITUDE_DEG: 51.084541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001400',
        LOCATION_NAME: 'Lydeway',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9265916,
        LOCATION_LATITUDE_DEG: 51.3202453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001500',
        LOCATION_NAME: 'Lydford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1034158,
        LOCATION_LATITUDE_DEG: 50.646113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001600',
        LOCATION_NAME: 'Lydford on Fosse',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6043597,
        LOCATION_LATITUDE_DEG: 51.0816337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001700',
        LOCATION_NAME: 'Lydgate',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0393996,
        LOCATION_LATITUDE_DEG: 53.5361608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001800',
        LOCATION_NAME: 'Lydham',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9786936,
        LOCATION_LATITUDE_DEG: 52.5122748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY001900',
        LOCATION_NAME: 'Lydiard Millicent',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8604473,
        LOCATION_LATITUDE_DEG: 51.5697747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002000',
        LOCATION_NAME: 'Lydiard Plain',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9162792,
        LOCATION_LATITUDE_DEG: 51.5764732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002100',
        LOCATION_NAME: 'Lydiard Tregoze',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8485664,
        LOCATION_LATITUDE_DEG: 51.549572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002200',
        LOCATION_NAME: 'Lydiate',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9535597,
        LOCATION_LATITUDE_DEG: 53.5302707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002300',
        LOCATION_NAME: 'Lydiate Ash',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0406499,
        LOCATION_LATITUDE_DEG: 52.374948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002500',
        LOCATION_NAME: 'Lydlinch',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3648745,
        LOCATION_LATITUDE_DEG: 50.9211155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002600',
        LOCATION_NAME: 'Lydlinch Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.367144,
        LOCATION_LATITUDE_DEG: 50.920218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002700',
        LOCATION_NAME: 'Lydmarsh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9145946,
        LOCATION_LATITUDE_DEG: 50.8752219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002800',
        LOCATION_NAME: 'Lydney',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5260482,
        LOCATION_LATITUDE_DEG: 51.7271962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002900',
        LOCATION_NAME: 'Lydstep',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7676154,
        LOCATION_LATITUDE_DEG: 51.6507142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003000',
        LOCATION_NAME: 'Lydstep Haven',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7661834,
        LOCATION_LATITUDE_DEG: 51.6492819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003100',
        LOCATION_NAME: 'Lye',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1111807,
        LOCATION_LATITUDE_DEG: 52.45656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003200',
        LOCATION_NAME: 'Lye Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5819677,
        LOCATION_LATITUDE_DEG: 51.7200693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003300',
        LOCATION_NAME: 'Lye Head',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3589836,
        LOCATION_LATITUDE_DEG: 52.3615524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003400',
        LOCATION_NAME: 'Lyford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4311446,
        LOCATION_LATITUDE_DEG: 51.6466774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003500',
        LOCATION_NAME: 'Lymbridge Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0404852,
        LOCATION_LATITUDE_DEG: 51.1539961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003600',
        LOCATION_NAME: 'Lyme Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1234359,
        LOCATION_LATITUDE_DEG: 53.2349326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003700',
        LOCATION_NAME: 'Lyme Regis',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9399099,
        LOCATION_LATITUDE_DEG: 50.7273062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003800',
        LOCATION_NAME: 'Lyminge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0893207,
        LOCATION_LATITUDE_DEG: 51.1263936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY003900',
        LOCATION_NAME: 'Lymington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5510621,
        LOCATION_LATITUDE_DEG: 50.7598915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004000',
        LOCATION_NAME: 'Lyminster',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5440694,
        LOCATION_LATITUDE_DEG: 50.8326867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004100',
        LOCATION_NAME: 'Lymm',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4849954,
        LOCATION_LATITUDE_DEG: 53.3793577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004200',
        LOCATION_NAME: 'Lympne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0297603,
        LOCATION_LATITUDE_DEG: 51.07719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004300',
        LOCATION_NAME: 'Lympsham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.948681,
        LOCATION_LATITUDE_DEG: 51.2828551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004400',
        LOCATION_NAME: 'Lympstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4201917,
        LOCATION_LATITUDE_DEG: 50.6479001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004500',
        LOCATION_NAME: 'Lynch Wood',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3136945,
        LOCATION_LATITUDE_DEG: 52.5478452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004600',
        LOCATION_NAME: 'Lynchat',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0082617,
        LOCATION_LATITUDE_DEG: 57.0927376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY009100',
        LOCATION_NAME: 'Lyndhurst',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5891193,
        LOCATION_LATITUDE_DEG: 54.9323719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004700',
        LOCATION_NAME: 'Lyndhurst',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5752283,
        LOCATION_LATITUDE_DEG: 50.8721053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY990133',
        LOCATION_NAME: 'Lyndon',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6578002,
        LOCATION_LATITUDE_DEG: 52.6303562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004800',
        LOCATION_NAME: 'Lyndon',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.656303,
        LOCATION_LATITUDE_DEG: 52.6290625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY004900',
        LOCATION_NAME: 'Lyne',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5434123,
        LOCATION_LATITUDE_DEG: 51.384938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005000',
        LOCATION_NAME: 'Lyne Down',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5135234,
        LOCATION_LATITUDE_DEG: 51.9760168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005100',
        LOCATION_NAME: 'Lyne of Skene',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3892464,
        LOCATION_LATITUDE_DEG: 57.1851241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005200',
        LOCATION_NAME: 'Lyneal',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.822767,
        LOCATION_LATITUDE_DEG: 52.8928152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005400',
        LOCATION_NAME: 'Lyneham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9983054,
        LOCATION_LATITUDE_DEG: 50.3621807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005500',
        LOCATION_NAME: 'Lyneham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.969664,
        LOCATION_LATITUDE_DEG: 51.5107644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005300',
        LOCATION_NAME: 'Lyneham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.593562,
        LOCATION_LATITUDE_DEG: 51.8815974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005600',
        LOCATION_NAME: 'Lynemouth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.540755,
        LOCATION_LATITUDE_DEG: 55.2136243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005700',
        LOCATION_NAME: 'Lyness',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2052215,
        LOCATION_LATITUDE_DEG: 58.8317992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005800',
        LOCATION_NAME: 'Lynford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6812182,
        LOCATION_LATITUDE_DEG: 52.4873304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006000',
        LOCATION_NAME: 'Lyng',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9921599,
        LOCATION_LATITUDE_DEG: 52.5128596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY005900',
        LOCATION_NAME: 'Lyng',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0632074,
        LOCATION_LATITUDE_DEG: 52.7177451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006100',
        LOCATION_NAME: 'Lynmouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8279534,
        LOCATION_LATITUDE_DEG: 51.229158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006200',
        LOCATION_NAME: 'Lynn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3193105,
        LOCATION_LATITUDE_DEG: 52.73889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006300',
        LOCATION_NAME: 'Lynn',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8797916,
        LOCATION_LATITUDE_DEG: 52.636675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006500',
        LOCATION_NAME: 'Lynsted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7879354,
        LOCATION_LATITUDE_DEG: 51.3127169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006600',
        LOCATION_NAME: 'Lynstone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5459495,
        LOCATION_LATITUDE_DEG: 50.8175312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006700',
        LOCATION_NAME: 'Lynton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8308596,
        LOCATION_LATITUDE_DEG: 51.2258658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006800',
        LOCATION_NAME: 'Lyons Gate',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4855001,
        LOCATION_LATITUDE_DEG: 50.8482425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006900',
        LOCATION_NAME: 'Lyonshall',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9692601,
        LOCATION_LATITUDE_DEG: 52.1940434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007000',
        LOCATION_NAME: 'Lypiatt',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1704904,
        LOCATION_LATITUDE_DEG: 51.7469896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007100',
        LOCATION_NAME: 'Lyppard Bourne',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1800905,
        LOCATION_LATITUDE_DEG: 52.1998379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007200',
        LOCATION_NAME: 'Lyppard Hanford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1815856,
        LOCATION_LATITUDE_DEG: 52.200438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007300',
        LOCATION_NAME: 'Lyppard Woodgreen',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1805893,
        LOCATION_LATITUDE_DEG: 52.2001338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008000',
        LOCATION_NAME: 'Lytchett Heath',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0454089,
        LOCATION_LATITUDE_DEG: 50.751699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008100',
        LOCATION_NAME: 'Lytchett Matravers',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0794728,
        LOCATION_LATITUDE_DEG: 50.7579943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008200',
        LOCATION_NAME: 'Lytchett Minster',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0553139,
        LOCATION_LATITUDE_DEG: 50.7355961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008300',
        LOCATION_NAME: 'Lyth',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2367832,
        LOCATION_LATITUDE_DEG: 58.5511728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008400',
        LOCATION_NAME: 'Lyth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8278227,
        LOCATION_LATITUDE_DEG: 54.2913461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008500',
        LOCATION_NAME: 'Lytham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9557127,
        LOCATION_LATITUDE_DEG: 53.7381927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008900',
        LOCATION_NAME: 'Lytham St Annes',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008600',
        LOCATION_NAME: 'Lytham St. Annes',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0105696,
        LOCATION_LATITUDE_DEG: 53.7437926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008700',
        LOCATION_NAME: 'Lythe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6922569,
        LOCATION_LATITUDE_DEG: 54.5057423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY008800',
        LOCATION_NAME: 'Lythwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7975649,
        LOCATION_LATITUDE_DEG: 52.6654842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000500',
        LOCATION_NAME: 'Mabe Burnthouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1303163,
        LOCATION_LATITUDE_DEG: 50.1642746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000600',
        LOCATION_NAME: 'Mabie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6415134,
        LOCATION_LATITUDE_DEG: 55.0207297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000700',
        LOCATION_NAME: 'Mablethorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2494113,
        LOCATION_LATITUDE_DEG: 53.3368093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000800',
        LOCATION_NAME: 'MacBiehill',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2989214,
        LOCATION_LATITUDE_DEG: 55.7502922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001200',
        LOCATION_NAME: 'Macclesfield',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1266883,
        LOCATION_LATITUDE_DEG: 53.2606402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001300',
        LOCATION_NAME: 'Macclesfield Forest',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0389522,
        LOCATION_LATITUDE_DEG: 53.2454364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000900',
        LOCATION_NAME: 'MacDuff',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4927147,
        LOCATION_LATITUDE_DEG: 57.6692763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001500',
        LOCATION_NAME: 'Macey Bank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8897502,
        LOCATION_LATITUDE_DEG: 54.7882974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001000',
        LOCATION_NAME: 'MacFin',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5989583,
        LOCATION_LATITUDE_DEG: 55.0832564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001600',
        LOCATION_NAME: 'Machen',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1392763,
        LOCATION_LATITUDE_DEG: 51.5955867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001700',
        LOCATION_NAME: 'Machrie',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3313946,
        LOCATION_LATITUDE_DEG: 55.5560972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001800',
        LOCATION_NAME: 'Machrihanish',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7317974,
        LOCATION_LATITUDE_DEG: 55.4213904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001900',
        LOCATION_NAME: 'Machynlleth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8514101,
        LOCATION_LATITUDE_DEG: 52.5916959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990795',
        LOCATION_NAME: 'Mackan',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002000',
        LOCATION_NAME: 'Mackan Glebe',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6411627,
        LOCATION_LATITUDE_DEG: 54.2586706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002200',
        LOCATION_NAME: 'Mackworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5334385,
        LOCATION_LATITUDE_DEG: 52.9349984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001100',
        LOCATION_NAME: 'MacMerry',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9063601,
        LOCATION_LATITUDE_DEG: 55.9406055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002300',
        LOCATION_NAME: 'Macosquin',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7341628,
        LOCATION_LATITUDE_DEG: 55.0970591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002600',
        LOCATION_NAME: 'Madden',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7487364,
        LOCATION_LATITUDE_DEG: 54.2849731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002700',
        LOCATION_NAME: 'Madderty',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6971696,
        LOCATION_LATITUDE_DEG: 56.376262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002800',
        LOCATION_NAME: 'Maddiston',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6983233,
        LOCATION_LATITUDE_DEG: 55.9706183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003000',
        LOCATION_NAME: 'Madehurst',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.600737,
        LOCATION_LATITUDE_DEG: 50.8815881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003200',
        LOCATION_NAME: 'Madeley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4582976,
        LOCATION_LATITUDE_DEG: 52.6352833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003100',
        LOCATION_NAME: 'Madeley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3389588,
        LOCATION_LATITUDE_DEG: 53.0008174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003300',
        LOCATION_NAME: 'Madeley Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3183606,
        LOCATION_LATITUDE_DEG: 53.0065112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003400',
        LOCATION_NAME: 'Maders',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3337391,
        LOCATION_LATITUDE_DEG: 50.5187953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003500',
        LOCATION_NAME: 'Madingley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0433658,
        LOCATION_LATITUDE_DEG: 52.2234129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003600',
        LOCATION_NAME: 'Madjeston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2798318,
        LOCATION_LATITUDE_DEG: 51.0208257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003700',
        LOCATION_NAME: 'Madley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8455768,
        LOCATION_LATITUDE_DEG: 52.0442291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003800',
        LOCATION_NAME: 'Madresfield',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2858993,
        LOCATION_LATITUDE_DEG: 52.1239293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA003900',
        LOCATION_NAME: 'Madron',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5656549,
        LOCATION_LATITUDE_DEG: 50.1327719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004000',
        LOCATION_NAME: 'Maenaddwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3135473,
        LOCATION_LATITUDE_DEG: 53.3307719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004100',
        LOCATION_NAME: 'Maenan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.820541,
        LOCATION_LATITUDE_DEG: 53.1856483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004200',
        LOCATION_NAME: 'Maenclochog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.78779,
        LOCATION_LATITUDE_DEG: 51.9103327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004300',
        LOCATION_NAME: 'Maendy',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4249944,
        LOCATION_LATITUDE_DEG: 51.4782805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004400',
        LOCATION_NAME: 'Maengwynedd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3052617,
        LOCATION_LATITUDE_DEG: 52.8571141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004500',
        LOCATION_NAME: 'Maenporth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0921223,
        LOCATION_LATITUDE_DEG: 50.123067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004600',
        LOCATION_NAME: 'Maentwrog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9876931,
        LOCATION_LATITUDE_DEG: 52.9476293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004700',
        LOCATION_NAME: 'Maenygroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.379418,
        LOCATION_LATITUDE_DEG: 52.203057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004800',
        LOCATION_NAME: 'Maer',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3093054,
        LOCATION_LATITUDE_DEG: 52.9407082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005000',
        LOCATION_NAME: 'Maerdy',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.476574,
        LOCATION_LATITUDE_DEG: 51.6695005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA004900',
        LOCATION_NAME: 'Maerdy',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4651331,
        LOCATION_LATITUDE_DEG: 52.9895315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005100',
        LOCATION_NAME: 'Maes y Waen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6595006,
        LOCATION_LATITUDE_DEG: 52.918625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005200',
        LOCATION_NAME: 'Maesbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0387646,
        LOCATION_LATITUDE_DEG: 52.7836998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990589',
        LOCATION_NAME: 'Maesbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005300',
        LOCATION_NAME: 'Maesbury Marsh',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.021341,
        LOCATION_LATITUDE_DEG: 52.8198057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005400',
        LOCATION_NAME: 'Maesfen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7201053,
        LOCATION_LATITUDE_DEG: 53.0130193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005500',
        LOCATION_NAME: 'Maesgeirchen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1270925,
        LOCATION_LATITUDE_DEG: 53.2249595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005600',
        LOCATION_NAME: 'Maesglas',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0147824,
        LOCATION_LATITUDE_DEG: 51.5688876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005700',
        LOCATION_NAME: 'Maeshafn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1914653,
        LOCATION_LATITUDE_DEG: 53.1397392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005800',
        LOCATION_NAME: 'Maesllyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3804616,
        LOCATION_LATITUDE_DEG: 52.0743488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA005900',
        LOCATION_NAME: 'Maesmynis',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4374037,
        LOCATION_LATITUDE_DEG: 52.1170433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006000',
        LOCATION_NAME: 'Maesteg',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.659214,
        LOCATION_LATITUDE_DEG: 51.6081928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006100',
        LOCATION_NAME: 'Maesybont',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0804836,
        LOCATION_LATITUDE_DEG: 51.8292245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006200',
        LOCATION_NAME: 'Maesycoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3493131,
        LOCATION_LATITUDE_DEG: 51.5977936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006300',
        LOCATION_NAME: 'Maesycrugiau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.228123,
        LOCATION_LATITUDE_DEG: 52.0483429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990988',
        LOCATION_NAME: 'Maesycwmmer',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006400',
        LOCATION_NAME: 'Maesymeillion',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3071807,
        LOCATION_LATITUDE_DEG: 52.0896476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006550',
        LOCATION_NAME: 'Magdalen',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3504539,
        LOCATION_LATITUDE_DEG: 52.6732617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006600',
        LOCATION_NAME: 'Magdalen Laver',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1927714,
        LOCATION_LATITUDE_DEG: 51.7562603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006700',
        LOCATION_NAME: 'Maggieknockater',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1384043,
        LOCATION_LATITUDE_DEG: 57.4978643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990775',
        LOCATION_NAME: 'Maghaberry',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990774',
        LOCATION_NAME: 'Maghaberry',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006800',
        LOCATION_NAME: 'Maghabery',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1883484,
        LOCATION_LATITUDE_DEG: 54.5030186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006900',
        LOCATION_NAME: 'Magham Down',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2849735,
        LOCATION_LATITUDE_DEG: 50.8790833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007000',
        LOCATION_NAME: 'Maghera',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.684463,
        LOCATION_LATITUDE_DEG: 54.8376417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007100',
        LOCATION_NAME: 'Magherafelt',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6132538,
        LOCATION_LATITUDE_DEG: 54.7571307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007200',
        LOCATION_NAME: 'Magheralin',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2656394,
        LOCATION_LATITUDE_DEG: 54.4665945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007250',
        LOCATION_NAME: 'Magheramason',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3885298,
        LOCATION_LATITUDE_DEG: 54.9350811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007300',
        LOCATION_NAME: 'Magheramorne',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7651276,
        LOCATION_LATITUDE_DEG: 54.8166251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007400',
        LOCATION_NAME: 'Magheraveely',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2823445,
        LOCATION_LATITUDE_DEG: 54.1831763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007500',
        LOCATION_NAME: 'Maghull',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9440395,
        LOCATION_LATITUDE_DEG: 53.5153693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007600',
        LOCATION_NAME: 'Magna Park',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2422262,
        LOCATION_LATITUDE_DEG: 52.455147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007700',
        LOCATION_NAME: 'Magor',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8316643,
        LOCATION_LATITUDE_DEG: 51.5799863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007800',
        LOCATION_NAME: 'Magor Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3156417,
        LOCATION_LATITUDE_DEG: 50.2330842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007900',
        LOCATION_NAME: 'Magpie',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1076102,
        LOCATION_LATITUDE_DEG: 50.5117943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008000',
        LOCATION_NAME: 'Maguiresbridge',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4695721,
        LOCATION_LATITUDE_DEG: 54.2986193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990284',
        LOCATION_NAME: 'Mahee Island',
        COUNTY_NAME: 'County Down',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6349489,
        LOCATION_LATITUDE_DEG: 54.4999543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008100',
        LOCATION_NAME: 'Mahollem',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0706707,
        LOCATION_LATITUDE_DEG: 52.1750482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055800',
        LOCATION_NAME: 'Maida Vale',
        COUNTY_NAME: 'London',
        POSTCODE: 'W9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1911428,
        LOCATION_LATITUDE_DEG: 51.5298346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008400',
        LOCATION_NAME: 'Maiden Bradley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2814324,
        LOCATION_LATITUDE_DEG: 51.1461327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008500',
        LOCATION_NAME: 'Maiden Law',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7306838,
        LOCATION_LATITUDE_DEG: 54.841285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008600',
        LOCATION_NAME: 'Maiden Newton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5682578,
        LOCATION_LATITUDE_DEG: 50.7785098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008700',
        LOCATION_NAME: 'Maidenbower',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1478188,
        LOCATION_LATITUDE_DEG: 51.1143102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008800',
        LOCATION_NAME: 'Maidencombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5180828,
        LOCATION_LATITUDE_DEG: 50.5071875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008900',
        LOCATION_NAME: 'Maidenhead',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7186688,
        LOCATION_LATITUDE_DEG: 51.5223494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009000',
        LOCATION_NAME: 'Maidenhill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7465712,
        LOCATION_LATITUDE_DEG: 54.6903873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009100',
        LOCATION_NAME: 'Maidens',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8162365,
        LOCATION_LATITUDE_DEG: 55.3320667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009200',
        LOCATION_NAME: 'Maidens Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7044861,
        LOCATION_LATITUDE_DEG: 51.4465351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009300',
        LOCATION_NAME: 'Maidensgrove',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.95561,
        LOCATION_LATITUDE_DEG: 51.5926654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990158',
        LOCATION_NAME: 'Maidenwell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6173543,
        LOCATION_LATITUDE_DEG: 50.5105845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009400',
        LOCATION_NAME: 'Maidenwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0171979,
        LOCATION_LATITUDE_DEG: 53.2955126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009500',
        LOCATION_NAME: 'Maidenwells',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9332183,
        LOCATION_LATITUDE_DEG: 51.6566761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009600',
        LOCATION_NAME: 'Maidford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1092066,
        LOCATION_LATITUDE_DEG: 52.1671202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009700',
        LOCATION_NAME: 'Maids Moreton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9748331,
        LOCATION_LATITUDE_DEG: 52.0144066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009800',
        LOCATION_NAME: 'Maidstone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5248761,
        LOCATION_LATITUDE_DEG: 51.2734169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA009900',
        LOCATION_NAME: 'Maidwell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9016574,
        LOCATION_LATITUDE_DEG: 52.3849394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010000',
        LOCATION_NAME: 'Maincombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8119897,
        LOCATION_LATITUDE_DEG: 50.8865213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010100',
        LOCATION_NAME: 'Maindee',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9760557,
        LOCATION_LATITUDE_DEG: 51.5892878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010200',
        LOCATION_NAME: 'Maindy',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1906545,
        LOCATION_LATITUDE_DEG: 51.500184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010300',
        LOCATION_NAME: 'Maine',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2172982,
        LOCATION_LATITUDE_DEG: 54.6245259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010400',
        LOCATION_NAME: 'Mainholm',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5874477,
        LOCATION_LATITUDE_DEG: 55.462079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010500',
        LOCATION_NAME: 'Mainsforth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5106792,
        LOCATION_LATITUDE_DEG: 54.6768691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010600',
        LOCATION_NAME: 'Mainsriddle',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6433932,
        LOCATION_LATITUDE_DEG: 54.8945142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010700',
        LOCATION_NAME: 'Mainstone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0670104,
        LOCATION_LATITUDE_DEG: 52.481678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010800',
        LOCATION_NAME: 'Maisemore',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2709659,
        LOCATION_LATITUDE_DEG: 51.8893068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA010900',
        LOCATION_NAME: 'Makeney',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4769568,
        LOCATION_LATITUDE_DEG: 52.9989006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011000',
        LOCATION_NAME: 'Maker',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1984277,
        LOCATION_LATITUDE_DEG: 50.3405777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011300',
        LOCATION_NAME: 'Malborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8102855,
        LOCATION_LATITUDE_DEG: 50.2435645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011400',
        LOCATION_NAME: 'Maldon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6763038,
        LOCATION_LATITUDE_DEG: 51.7306523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011500',
        LOCATION_NAME: 'Malehurst',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9093474,
        LOCATION_LATITUDE_DEG: 52.6502846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011600',
        LOCATION_NAME: 'Malham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1514035,
        LOCATION_LATITUDE_DEG: 54.0608146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011700',
        LOCATION_NAME: 'Malham Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1706128,
        LOCATION_LATITUDE_DEG: 54.1063161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011800',
        LOCATION_NAME: 'Malham Tarn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.17292,
        LOCATION_LATITUDE_DEG: 54.1020163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011900',
        LOCATION_NAME: 'Maligar',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2170376,
        LOCATION_LATITUDE_DEG: 57.6030063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055100',
        LOCATION_NAME: 'Malin Bridge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5110511,
        LOCATION_LATITUDE_DEG: 53.4002966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012300',
        LOCATION_NAME: 'Malins Lee',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4605082,
        LOCATION_LATITUDE_DEG: 52.6698804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012400',
        LOCATION_NAME: 'Malkins Bank',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3541373,
        LOCATION_LATITUDE_DEG: 53.1291258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012500',
        LOCATION_NAME: 'Mallaig',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.828411,
        LOCATION_LATITUDE_DEG: 57.0049469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012700',
        LOCATION_NAME: 'Mallerstang',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3382296,
        LOCATION_LATITUDE_DEG: 54.3991538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012900',
        LOCATION_NAME: 'Malltraeth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3866774,
        LOCATION_LATITUDE_DEG: 53.1933532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013000',
        LOCATION_NAME: 'Mallwyd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6832587,
        LOCATION_LATITUDE_DEG: 52.6977999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013100',
        LOCATION_NAME: 'Malmesbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0981987,
        LOCATION_LATITUDE_DEG: 51.5843753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056100',
        LOCATION_NAME: 'Malone',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.96866,
        LOCATION_LATITUDE_DEG: 54.554093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013400',
        LOCATION_NAME: 'Malpas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0260453,
        LOCATION_LATITUDE_DEG: 50.2429821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013200',
        LOCATION_NAME: 'Malpas',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.008191,
        LOCATION_LATITUDE_DEG: 51.6172891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013300',
        LOCATION_NAME: 'Malpas',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7641435,
        LOCATION_LATITUDE_DEG: 53.0199189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013500',
        LOCATION_NAME: 'Malshanger',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1883213,
        LOCATION_LATITUDE_DEG: 51.2660338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013600',
        LOCATION_NAME: 'Malswick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.374328,
        LOCATION_LATITUDE_DEG: 51.918409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013800',
        LOCATION_NAME: 'Maltby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2793252,
        LOCATION_LATITUDE_DEG: 54.5132459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013700',
        LOCATION_NAME: 'Maltby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1989811,
        LOCATION_LATITUDE_DEG: 53.4231443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA013900',
        LOCATION_NAME: 'Maltby le Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2049404,
        LOCATION_LATITUDE_DEG: 53.3143154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014000',
        LOCATION_NAME: 'Maltfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7955767,
        LOCATION_LATITUDE_DEG: 51.2176535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014100',
        LOCATION_NAME: "Maltman'S Hill",
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7217608,
        LOCATION_LATITUDE_DEG: 51.1546025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014300',
        LOCATION_NAME: 'Malton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7199421,
        LOCATION_LATITUDE_DEG: 54.8092831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014200',
        LOCATION_NAME: 'Malton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7947053,
        LOCATION_LATITUDE_DEG: 54.134605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014400',
        LOCATION_NAME: 'Malvern',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3184314,
        LOCATION_LATITUDE_DEG: 52.1115275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014500',
        LOCATION_NAME: 'Malvern Link',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3160338,
        LOCATION_LATITUDE_DEG: 52.1256328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014600',
        LOCATION_NAME: 'Malvern Wells',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3309629,
        LOCATION_LATITUDE_DEG: 52.078125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014700',
        LOCATION_NAME: 'Mamble',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4561576,
        LOCATION_LATITUDE_DEG: 52.340852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014800',
        LOCATION_NAME: 'Mamhead',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5020569,
        LOCATION_LATITUDE_DEG: 50.6128026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA014900',
        LOCATION_NAME: 'Mamhilad',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9986793,
        LOCATION_LATITUDE_DEG: 51.7162976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015000',
        LOCATION_NAME: 'Manaccan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1262968,
        LOCATION_LATITUDE_DEG: 50.0820693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015100',
        LOCATION_NAME: 'Manadon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.136673,
        LOCATION_LATITUDE_DEG: 50.4014857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015200',
        LOCATION_NAME: 'Manafon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3095637,
        LOCATION_LATITUDE_DEG: 52.6122891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015300',
        LOCATION_NAME: 'Manaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7642193,
        LOCATION_LATITUDE_DEG: 50.6163046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015400',
        LOCATION_NAME: 'Manby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1028978,
        LOCATION_LATITUDE_DEG: 53.359722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015500',
        LOCATION_NAME: 'Mancetter',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5271893,
        LOCATION_LATITUDE_DEG: 52.5681631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055400',
        LOCATION_NAME: 'Manchester Airport',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2758904,
        LOCATION_LATITUDE_DEG: 53.3691915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015600',
        LOCATION_NAME: 'Manchester International Airport',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M90',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2718652,
        LOCATION_LATITUDE_DEG: 53.3625843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015700',
        LOCATION_NAME: 'Manchester M 1',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2350703,
        LOCATION_LATITUDE_DEG: 53.4762551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015800',
        LOCATION_NAME: 'Manchester M 2',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2448535,
        LOCATION_LATITUDE_DEG: 53.4795166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA015900',
        LOCATION_NAME: 'Manchester M 3',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2537834,
        LOCATION_LATITUDE_DEG: 53.4834714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016000',
        LOCATION_NAME: 'Manchester M 4',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2290444,
        LOCATION_LATITUDE_DEG: 53.4849327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016100',
        LOCATION_NAME: 'Manchester M 5',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2927328,
        LOCATION_LATITUDE_DEG: 53.477692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016200',
        LOCATION_NAME: 'Manchester M 6',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2972085,
        LOCATION_LATITUDE_DEG: 53.4949588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016300',
        LOCATION_NAME: 'Manchester M 7',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.265409,
        LOCATION_LATITUDE_DEG: 53.5061176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016400',
        LOCATION_NAME: 'Manchester M 8',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2394446,
        LOCATION_LATITUDE_DEG: 53.509157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016500',
        LOCATION_NAME: 'Manchester M 9',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2153001,
        LOCATION_LATITUDE_DEG: 53.5238467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055500',
        LOCATION_NAME: 'Manchester M10',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1821585,
        LOCATION_LATITUDE_DEG: 53.481921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016600',
        LOCATION_NAME: 'Manchester M11',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1847217,
        LOCATION_LATITUDE_DEG: 53.4787437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016700',
        LOCATION_NAME: 'Manchester M12',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2029212,
        LOCATION_LATITUDE_DEG: 53.465167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016800',
        LOCATION_NAME: 'Manchester M13',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2171869,
        LOCATION_LATITUDE_DEG: 53.4591549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA016900',
        LOCATION_NAME: 'Manchester M14',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2260264,
        LOCATION_LATITUDE_DEG: 53.4473802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017000',
        LOCATION_NAME: 'Manchester M15',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2510485,
        LOCATION_LATITUDE_DEG: 53.4669724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017100',
        LOCATION_NAME: 'Manchester M16',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.265713,
        LOCATION_LATITUDE_DEG: 53.4558566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017200',
        LOCATION_NAME: 'Manchester M17',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3181369,
        LOCATION_LATITUDE_DEG: 53.4692937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017300',
        LOCATION_NAME: 'Manchester M18',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.168169,
        LOCATION_LATITUDE_DEG: 53.4618769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017400',
        LOCATION_NAME: 'Manchester M19',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1949383,
        LOCATION_LATITUDE_DEG: 53.4358744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017500',
        LOCATION_NAME: 'Manchester M20',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2348844,
        LOCATION_LATITUDE_DEG: 53.4207449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017600',
        LOCATION_NAME: 'Manchester M21',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2724298,
        LOCATION_LATITUDE_DEG: 53.4345811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017700',
        LOCATION_NAME: 'Manchester M22',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2575721,
        LOCATION_LATITUDE_DEG: 53.3848475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017800',
        LOCATION_NAME: 'Manchester M23',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2875477,
        LOCATION_LATITUDE_DEG: 53.3994412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017850',
        LOCATION_NAME: 'Manchester M24',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.201389,
        LOCATION_LATITUDE_DEG: 53.5615186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA017900',
        LOCATION_NAME: 'Manchester M25',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.267501,
        LOCATION_LATITUDE_DEG: 53.534214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018000',
        LOCATION_NAME: 'Manchester M33',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3247829,
        LOCATION_LATITUDE_DEG: 53.4241302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018200',
        LOCATION_NAME: 'Manchester M40',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.191584,
        LOCATION_LATITUDE_DEG: 53.5034001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018300',
        LOCATION_NAME: 'Manchester M43',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.149368,
        LOCATION_LATITUDE_DEG: 53.4871264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018400',
        LOCATION_NAME: 'Manchester M45',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2970084,
        LOCATION_LATITUDE_DEG: 53.5461363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018450',
        LOCATION_NAME: 'Manchester M60',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2517303,
        LOCATION_LATITUDE_DEG: 53.4803564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018500',
        LOCATION_NAME: 'Mancot',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0092929,
        LOCATION_LATITUDE_DEG: 53.1994463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018600',
        LOCATION_NAME: 'Mandally',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8118549,
        LOCATION_LATITUDE_DEG: 57.0660425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018700',
        LOCATION_NAME: 'Manea',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.174408,
        LOCATION_LATITUDE_DEG: 52.4809367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018750',
        LOCATION_NAME: 'Manesty',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1579189,
        LOCATION_LATITUDE_DEG: 54.5571741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018800',
        LOCATION_NAME: 'Maney',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8215687,
        LOCATION_LATITUDE_DEG: 52.5592625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA018900',
        LOCATION_NAME: 'Manfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6591701,
        LOCATION_LATITUDE_DEG: 54.5157578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019000',
        LOCATION_NAME: 'Mangersta',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0852255,
        LOCATION_LATITUDE_DEG: 58.1709742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019100',
        LOCATION_NAME: 'Mangerton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7246821,
        LOCATION_LATITUDE_DEG: 50.7585041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019200',
        LOCATION_NAME: 'Manhay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2242346,
        LOCATION_LATITUDE_DEG: 50.1258674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019300',
        LOCATION_NAME: 'Manish',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8705901,
        LOCATION_LATITUDE_DEG: 57.7980304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019400',
        LOCATION_NAME: 'Manley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7396281,
        LOCATION_LATITUDE_DEG: 53.2390399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019500',
        LOCATION_NAME: 'Manley Common',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7155083,
        LOCATION_LATITUDE_DEG: 53.2430439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019600',
        LOCATION_NAME: 'Manmoel',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1879315,
        LOCATION_LATITUDE_DEG: 51.7215059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019700',
        LOCATION_NAME: 'Mannal',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8931643,
        LOCATION_LATITUDE_DEG: 56.4579971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019800',
        LOCATION_NAME: 'Mannamead',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1321183,
        LOCATION_LATITUDE_DEG: 50.382787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020000',
        LOCATION_NAME: 'Manningford Abbots',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7935856,
        LOCATION_LATITUDE_DEG: 51.325644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020100',
        LOCATION_NAME: 'Manningford Bohune',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8023003,
        LOCATION_LATITUDE_DEG: 51.3184468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020200',
        LOCATION_NAME: 'Manningford Bohune Common',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8219706,
        LOCATION_LATITUDE_DEG: 51.3308524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020300',
        LOCATION_NAME: 'Manningford Bruce',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8022699,
        LOCATION_LATITUDE_DEG: 51.3288514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056400',
        LOCATION_NAME: 'Manningham',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7683756,
        LOCATION_LATITUDE_DEG: 53.8084603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020400',
        LOCATION_NAME: 'Mannings Heath',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2816142,
        LOCATION_LATITUDE_DEG: 51.0444014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020600',
        LOCATION_NAME: 'Mannington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9098526,
        LOCATION_LATITUDE_DEG: 50.852707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020500',
        LOCATION_NAME: 'Mannington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8309436,
        LOCATION_LATITUDE_DEG: 51.5565711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020700',
        LOCATION_NAME: 'Manningtree',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0638501,
        LOCATION_LATITUDE_DEG: 51.9448682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020800',
        LOCATION_NAME: 'Manod',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9064453,
        LOCATION_LATITUDE_DEG: 52.9805304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054400',
        LOCATION_NAME: 'Manor',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4344943,
        LOCATION_LATITUDE_DEG: 53.3748323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA020900',
        LOCATION_NAME: 'Manor Bourne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1143103,
        LOCATION_LATITUDE_DEG: 50.3274756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055600',
        LOCATION_NAME: 'Manor Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054900',
        LOCATION_NAME: 'Manor Park',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021100',
        LOCATION_NAME: 'Manor Park',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.673492,
        LOCATION_LATITUDE_DEG: 53.3474552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055900',
        LOCATION_NAME: 'Manor Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'E12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0523563,
        LOCATION_LATITUDE_DEG: 51.5580779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021200',
        LOCATION_NAME: 'Manorbier',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7958034,
        LOCATION_LATITUDE_DEG: 51.6454138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021300',
        LOCATION_NAME: 'Manorbier Newton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8258065,
        LOCATION_LATITUDE_DEG: 51.6645106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021500',
        LOCATION_NAME: 'Manordeilo',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9353972,
        LOCATION_LATITUDE_DEG: 51.9159321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021700',
        LOCATION_NAME: 'Manorowen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0091651,
        LOCATION_LATITUDE_DEG: 51.9852452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021800',
        LOCATION_NAME: 'Mansel Gamage',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8852434,
        LOCATION_LATITUDE_DEG: 52.0974305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021900',
        LOCATION_NAME: 'Mansel Lacy',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8412688,
        LOCATION_LATITUDE_DEG: 52.106007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022000',
        LOCATION_NAME: 'Manselton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9489674,
        LOCATION_LATITUDE_DEG: 51.638103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022200',
        LOCATION_NAME: 'Mansergh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.611462,
        LOCATION_LATITUDE_DEG: 54.2390388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056800',
        LOCATION_NAME: 'Mansewood',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3076647,
        LOCATION_LATITUDE_DEG: 55.8134797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022300',
        LOCATION_NAME: 'Mansfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1948016,
        LOCATION_LATITUDE_DEG: 53.144416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022400',
        LOCATION_NAME: 'Mansfield Woodhouse',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1902013,
        LOCATION_LATITUDE_DEG: 53.1632193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022600',
        LOCATION_NAME: 'Mansons Cross',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7141416,
        LOCATION_LATITUDE_DEG: 51.8297045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022800',
        LOCATION_NAME: 'Manston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2653229,
        LOCATION_LATITUDE_DEG: 50.9495155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022700',
        LOCATION_NAME: 'Manston',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3713535,
        LOCATION_LATITUDE_DEG: 51.3455082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022900',
        LOCATION_NAME: 'Manswood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0310275,
        LOCATION_LATITUDE_DEG: 50.8712103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023000',
        LOCATION_NAME: 'Manswood Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0274022,
        LOCATION_LATITUDE_DEG: 50.8696553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023200',
        LOCATION_NAME: 'Manthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6151024,
        LOCATION_LATITUDE_DEG: 52.9163894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023100',
        LOCATION_NAME: 'Manthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4126009,
        LOCATION_LATITUDE_DEG: 52.7309616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023300',
        LOCATION_NAME: 'Manton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7519367,
        LOCATION_LATITUDE_DEG: 51.4152566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990134',
        LOCATION_NAME: 'Manton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7000395,
        LOCATION_LATITUDE_DEG: 52.633165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023500',
        LOCATION_NAME: 'Manton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6985119,
        LOCATION_LATITUDE_DEG: 52.6308555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023400',
        LOCATION_NAME: 'Manton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5922428,
        LOCATION_LATITUDE_DEG: 53.5133431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023600',
        LOCATION_NAME: 'Manton Down',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.74977,
        LOCATION_LATITUDE_DEG: 51.4143528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023700',
        LOCATION_NAME: 'Manuden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1688806,
        LOCATION_LATITUDE_DEG: 51.9185779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023900',
        LOCATION_NAME: 'Maperton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4613488,
        LOCATION_LATITUDE_DEG: 51.0409256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024000',
        LOCATION_NAME: 'Maple Cross',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5083682,
        LOCATION_LATITUDE_DEG: 51.6237607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024100',
        LOCATION_NAME: 'Maplebeck',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9371169,
        LOCATION_LATITUDE_DEG: 53.1385109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024200',
        LOCATION_NAME: 'Mapledurham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0334754,
        LOCATION_LATITUDE_DEG: 51.4863549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024300',
        LOCATION_NAME: 'Mapledurham Village',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0334952,
        LOCATION_LATITUDE_DEG: 51.4840529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024400',
        LOCATION_NAME: 'Mapledurwell',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0149678,
        LOCATION_LATITUDE_DEG: 51.2566277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024500',
        LOCATION_NAME: 'Maplehurst',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.304626,
        LOCATION_LATITUDE_DEG: 51.0080958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024600',
        LOCATION_NAME: 'Mapperley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3527262,
        LOCATION_LATITUDE_DEG: 52.9824032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024700',
        LOCATION_NAME: 'Mapperley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1396598,
        LOCATION_LATITUDE_DEG: 52.9816996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024800',
        LOCATION_NAME: 'Mapperley Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1400272,
        LOCATION_LATITUDE_DEG: 52.9721993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025000',
        LOCATION_NAME: 'Mapperton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7039737,
        LOCATION_LATITUDE_DEG: 50.7949117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA024900',
        LOCATION_NAME: 'Mapperton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1320156,
        LOCATION_LATITUDE_DEG: 50.7866994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025100',
        LOCATION_NAME: 'Mappleborough Green',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8820904,
        LOCATION_LATITUDE_DEG: 52.2920419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025300',
        LOCATION_NAME: 'Mappleton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7532891,
        LOCATION_LATITUDE_DEG: 53.0294087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025200',
        LOCATION_NAME: 'Mappleton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1350287,
        LOCATION_LATITUDE_DEG: 53.8758687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025400',
        LOCATION_NAME: 'Mapplewell',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5180472,
        LOCATION_LATITUDE_DEG: 53.5849618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025500',
        LOCATION_NAME: 'Mappowder',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3751518,
        LOCATION_LATITUDE_DEG: 50.8526065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025600',
        LOCATION_NAME: 'Marazanvose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0925074,
        LOCATION_LATITUDE_DEG: 50.3075913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025700',
        LOCATION_NAME: 'Marazion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.46925,
        LOCATION_LATITUDE_DEG: 50.1236747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025900',
        LOCATION_NAME: 'Marbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6540614,
        LOCATION_LATITUDE_DEG: 53.006721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026000',
        LOCATION_NAME: 'March',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0916361,
        LOCATION_LATITUDE_DEG: 52.5508446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026100',
        LOCATION_NAME: 'Marcham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3421834,
        LOCATION_LATITUDE_DEG: 51.6661759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026200',
        LOCATION_NAME: 'Marchamley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6012062,
        LOCATION_LATITUDE_DEG: 52.8605006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026300',
        LOCATION_NAME: 'Marchamley Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6115133,
        LOCATION_LATITUDE_DEG: 52.8762084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026400',
        LOCATION_NAME: 'Marchington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8040208,
        LOCATION_LATITUDE_DEG: 52.874699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026500',
        LOCATION_NAME: 'Marchington Cliff',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8095317,
        LOCATION_LATITUDE_DEG: 52.8547942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056600',
        LOCATION_NAME: 'Marchmont',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1916988,
        LOCATION_LATITUDE_DEG: 55.9392456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026600',
        LOCATION_NAME: 'Marchwiel',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9583793,
        LOCATION_LATITUDE_DEG: 53.0223243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026700',
        LOCATION_NAME: 'Marchwood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4523798,
        LOCATION_LATITUDE_DEG: 50.8891041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026800',
        LOCATION_NAME: 'Marcross',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5458094,
        LOCATION_LATITUDE_DEG: 51.412079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA026900',
        LOCATION_NAME: 'Marden',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.707084,
        LOCATION_LATITUDE_DEG: 52.118937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027000',
        LOCATION_NAME: 'Marden',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8723962,
        LOCATION_LATITUDE_DEG: 51.3216467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027100',
        LOCATION_NAME: 'Marden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4927155,
        LOCATION_LATITUDE_DEG: 51.1741026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027200',
        LOCATION_NAME: 'Marden Hill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1415076,
        LOCATION_LATITUDE_DEG: 51.8090752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027300',
        LOCATION_NAME: 'Mardu',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0792828,
        LOCATION_LATITUDE_DEG: 52.4505732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027400',
        LOCATION_NAME: 'Mardy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0165846,
        LOCATION_LATITUDE_DEG: 51.8297093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027600',
        LOCATION_NAME: 'Marefield',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8985194,
        LOCATION_LATITUDE_DEG: 52.6645688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054800',
        LOCATION_NAME: 'Mareham le Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027700',
        LOCATION_NAME: 'Mareham on the Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0742984,
        LOCATION_LATITUDE_DEG: 53.1931027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027800',
        LOCATION_NAME: 'Mareham-le-Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0910665,
        LOCATION_LATITUDE_DEG: 53.1277086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027900',
        LOCATION_NAME: 'Marehay',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4041607,
        LOCATION_LATITUDE_DEG: 53.0324067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028000',
        LOCATION_NAME: 'Maresfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0894668,
        LOCATION_LATITUDE_DEG: 50.9965928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028100',
        LOCATION_NAME: 'Marfleet',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2737456,
        LOCATION_LATITUDE_DEG: 53.7477569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028200',
        LOCATION_NAME: 'Marford',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9563241,
        LOCATION_LATITUDE_DEG: 53.0999286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028300',
        LOCATION_NAME: 'Margam',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7564395,
        LOCATION_LATITUDE_DEG: 51.5738985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028400',
        LOCATION_NAME: 'Margaret Marsh',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2505615,
        LOCATION_LATITUDE_DEG: 50.9685241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028500',
        LOCATION_NAME: 'Margaret Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3173167,
        LOCATION_LATITUDE_DEG: 51.7831627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028600',
        LOCATION_NAME: 'Margaretting',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4183737,
        LOCATION_LATITUDE_DEG: 51.6890547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028700',
        LOCATION_NAME: 'Margate',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3850013,
        LOCATION_LATITUDE_DEG: 51.3829071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028800',
        LOCATION_NAME: 'Marham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5255782,
        LOCATION_LATITUDE_DEG: 52.6584433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA028900',
        LOCATION_NAME: 'Marham Airfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5450481,
        LOCATION_LATITUDE_DEG: 52.6575409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029000',
        LOCATION_NAME: 'Marhamchurch',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5195493,
        LOCATION_LATITUDE_DEG: 50.804027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029100',
        LOCATION_NAME: 'Marholm',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3066655,
        LOCATION_LATITUDE_DEG: 52.6043487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029200',
        LOCATION_NAME: 'Marianglas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.246144,
        LOCATION_LATITUDE_DEG: 53.3346679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029300',
        LOCATION_NAME: 'Mariansleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7889671,
        LOCATION_LATITUDE_DEG: 50.9836388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029400',
        LOCATION_NAME: 'Marishes',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7469419,
        LOCATION_LATITUDE_DEG: 54.1869375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029500',
        LOCATION_NAME: 'Maritime Quarter',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9356768,
        LOCATION_LATITUDE_DEG: 51.6161989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029600',
        LOCATION_NAME: 'Marjery Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.935607,
        LOCATION_LATITUDE_DEG: 50.3757808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029700',
        LOCATION_NAME: 'Mark',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8868762,
        LOCATION_LATITUDE_DEG: 51.2263502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029800',
        LOCATION_NAME: 'Mark Beech',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1097018,
        LOCATION_LATITUDE_DEG: 51.1643799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA029900',
        LOCATION_NAME: 'Mark Causeway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9102036,
        LOCATION_LATITUDE_DEG: 51.2239497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030000',
        LOCATION_NAME: 'Mark Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2596871,
        LOCATION_LATITUDE_DEG: 51.0599928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030100',
        LOCATION_NAME: 'Markby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2298848,
        LOCATION_LATITUDE_DEG: 53.2856086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030200',
        LOCATION_NAME: 'Markenfield Hall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5488579,
        LOCATION_LATITUDE_DEG: 54.100414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030300',
        LOCATION_NAME: 'Market Bosworth',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4001946,
        LOCATION_LATITUDE_DEG: 52.6238714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030400',
        LOCATION_NAME: 'Market Deeping',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3180483,
        LOCATION_LATITUDE_DEG: 52.6776591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030500',
        LOCATION_NAME: 'Market Drayton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4825253,
        LOCATION_LATITUDE_DEG: 52.9040076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030600',
        LOCATION_NAME: 'Market Harborough',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9194805,
        LOCATION_LATITUDE_DEG: 52.4776441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030700',
        LOCATION_NAME: 'Market Lavington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9778289,
        LOCATION_LATITUDE_DEG: 51.2860486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990135',
        LOCATION_NAME: 'Market Overton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6893888,
        LOCATION_LATITUDE_DEG: 52.7402421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030800',
        LOCATION_NAME: 'Market Overton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.687887,
        LOCATION_LATITUDE_DEG: 52.7374652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA030900',
        LOCATION_NAME: 'Market Rasen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.335486,
        LOCATION_LATITUDE_DEG: 53.3872313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031000',
        LOCATION_NAME: 'Market Stainton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1577055,
        LOCATION_LATITUDE_DEG: 53.3019202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031100',
        LOCATION_NAME: 'Market Weighton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6661486,
        LOCATION_LATITUDE_DEG: 53.8645811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031200',
        LOCATION_NAME: 'Market Weston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9249916,
        LOCATION_LATITUDE_DEG: 52.3632064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031300',
        LOCATION_NAME: 'Markethill',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5226352,
        LOCATION_LATITUDE_DEG: 54.297074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031400',
        LOCATION_NAME: 'Markfield',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2760571,
        LOCATION_LATITUDE_DEG: 52.6875709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031500',
        LOCATION_NAME: 'Markham',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2038541,
        LOCATION_LATITUDE_DEG: 51.7038981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031600',
        LOCATION_NAME: 'Markham Moor',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9243512,
        LOCATION_LATITUDE_DEG: 53.2574197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031700',
        LOCATION_NAME: 'Markinch',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1281958,
        LOCATION_LATITUDE_DEG: 56.203735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA031800',
        LOCATION_NAME: 'Markington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5553765,
        LOCATION_LATITUDE_DEG: 54.0815082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032000',
        LOCATION_NAME: 'Marks Barn',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7979873,
        LOCATION_LATITUDE_DEG: 50.8983186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032100',
        LOCATION_NAME: 'Marks Corner',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3337161,
        LOCATION_LATITUDE_DEG: 50.7249817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032200',
        LOCATION_NAME: 'Marks Tey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.764092,
        LOCATION_LATITUDE_DEG: 51.8770641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032300',
        LOCATION_NAME: 'Marksbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4797548,
        LOCATION_LATITUDE_DEG: 51.3582607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032400',
        LOCATION_NAME: 'Markshall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2905618,
        LOCATION_LATITUDE_DEG: 52.5891227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032500',
        LOCATION_NAME: 'Markyate',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4583665,
        LOCATION_LATITUDE_DEG: 51.8351766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032600',
        LOCATION_NAME: 'Marland',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1810168,
        LOCATION_LATITUDE_DEG: 53.603073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032700',
        LOCATION_NAME: 'Marlas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8162853,
        LOCATION_LATITUDE_DEG: 51.9628246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990679',
        LOCATION_NAME: 'Marlborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032800',
        LOCATION_NAME: 'Marlborough',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7332022,
        LOCATION_LATITUDE_DEG: 51.4169601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA032900',
        LOCATION_NAME: 'Marlbrook',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7158394,
        LOCATION_LATITUDE_DEG: 52.1867444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033000',
        LOCATION_NAME: 'Marlbrook',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0400256,
        LOCATION_LATITUDE_DEG: 52.3668472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033100',
        LOCATION_NAME: 'Marlcliff',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.857861,
        LOCATION_LATITUDE_DEG: 52.1515245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033200',
        LOCATION_NAME: 'Marldon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5948679,
        LOCATION_LATITUDE_DEG: 50.4539823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033300',
        LOCATION_NAME: 'Marle Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2615072,
        LOCATION_LATITUDE_DEG: 50.9267815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033500',
        LOCATION_NAME: 'Marlesford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.399071,
        LOCATION_LATITUDE_DEG: 52.1728876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033600',
        LOCATION_NAME: 'Marley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8767952,
        LOCATION_LATITUDE_DEG: 53.8615926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033700',
        LOCATION_NAME: 'Marley Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6823738,
        LOCATION_LATITUDE_DEG: 54.9169953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033800',
        LOCATION_NAME: 'Marlingford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1504341,
        LOCATION_LATITUDE_DEG: 52.6382325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033900',
        LOCATION_NAME: 'Marloes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.196935,
        LOCATION_LATITUDE_DEG: 51.7313221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034000',
        LOCATION_NAME: 'Marlow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8834081,
        LOCATION_LATITUDE_DEG: 52.3823624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034100',
        LOCATION_NAME: 'Marlow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7753546,
        LOCATION_LATITUDE_DEG: 51.5716604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034200',
        LOCATION_NAME: 'Marlow Bottom',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7736745,
        LOCATION_LATITUDE_DEG: 51.5863642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034300',
        LOCATION_NAME: 'Marlpit Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0617519,
        LOCATION_LATITUDE_DEG: 51.2112137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034400',
        LOCATION_NAME: 'Marlpool',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.350795,
        LOCATION_LATITUDE_DEG: 53.0049046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054600',
        LOCATION_NAME: 'Marlston cum Lache',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034500',
        LOCATION_NAME: 'Marlston Hermitage',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2344194,
        LOCATION_LATITUDE_DEG: 51.4411484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034600',
        LOCATION_NAME: 'Marlston-cum-Lache',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9199223,
        LOCATION_LATITUDE_DEG: 53.1559377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034700',
        LOCATION_NAME: 'Marnhull',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3149294,
        LOCATION_LATITUDE_DEG: 50.9712192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034800',
        LOCATION_NAME: 'Marnoch',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6737539,
        LOCATION_LATITUDE_DEG: 57.5419604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA034900',
        LOCATION_NAME: 'Marple',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0620685,
        LOCATION_LATITUDE_DEG: 53.3942516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035000',
        LOCATION_NAME: 'Marple Bridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0512174,
        LOCATION_LATITUDE_DEG: 53.4005495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035100',
        LOCATION_NAME: 'Marr',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2238489,
        LOCATION_LATITUDE_DEG: 53.5409571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035200',
        LOCATION_NAME: 'Marrel',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6701288,
        LOCATION_LATITUDE_DEG: 58.1344385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035300',
        LOCATION_NAME: 'Marrick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8805765,
        LOCATION_LATITUDE_DEG: 54.3796417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035400',
        LOCATION_NAME: 'Marros',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5970272,
        LOCATION_LATITUDE_DEG: 51.7503217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035600',
        LOCATION_NAME: 'Marsden',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9836528,
        LOCATION_LATITUDE_DEG: 51.8051919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035500',
        LOCATION_NAME: 'Marsden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9276854,
        LOCATION_LATITUDE_DEG: 53.6004643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036000',
        LOCATION_NAME: 'Marsh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0608273,
        LOCATION_LATITUDE_DEG: 50.8879248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035900',
        LOCATION_NAME: 'Marsh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3709702,
        LOCATION_LATITUDE_DEG: 51.0291245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036100',
        LOCATION_NAME: 'Marsh',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8065009,
        LOCATION_LATITUDE_DEG: 53.6489707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035700',
        LOCATION_NAME: 'Marsh',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7079832,
        LOCATION_LATITUDE_DEG: 53.7219792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA035800',
        LOCATION_NAME: 'Marsh',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8172224,
        LOCATION_LATITUDE_DEG: 51.775882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036200',
        LOCATION_NAME: 'Marsh Baldon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1861453,
        LOCATION_LATITUDE_DEG: 51.690674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036300',
        LOCATION_NAME: 'Marsh Benham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3823351,
        LOCATION_LATITUDE_DEG: 51.4045483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036400',
        LOCATION_NAME: 'Marsh Court',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4929561,
        LOCATION_LATITUDE_DEG: 51.0987247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036500',
        LOCATION_NAME: 'Marsh Gibbon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0585276,
        LOCATION_LATITUDE_DEG: 51.9024972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036700',
        LOCATION_NAME: 'Marsh Green',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3577597,
        LOCATION_LATITUDE_DEG: 50.7341077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036600',
        LOCATION_NAME: 'Marsh Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.586853,
        LOCATION_LATITUDE_DEG: 52.7301899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036800',
        LOCATION_NAME: 'Marsh Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0588682,
        LOCATION_LATITUDE_DEG: 51.179308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA036900',
        LOCATION_NAME: 'Marsh Lane',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3932169,
        LOCATION_LATITUDE_DEG: 53.3047695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037000',
        LOCATION_NAME: 'Marsh Mills',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0840221,
        LOCATION_LATITUDE_DEG: 50.3921865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037200',
        LOCATION_NAME: 'Marshalswick',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3068647,
        LOCATION_LATITUDE_DEG: 51.7673723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037300',
        LOCATION_NAME: 'Marsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.256143,
        LOCATION_LATITUDE_DEG: 52.7689406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037400',
        LOCATION_NAME: 'Marshborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.304453,
        LOCATION_LATITUDE_DEG: 51.268404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037500',
        LOCATION_NAME: 'Marshbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8237785,
        LOCATION_LATITUDE_DEG: 52.5013703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037600',
        LOCATION_NAME: 'Marshchapel',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0466361,
        LOCATION_LATITUDE_DEG: 53.4743317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037700',
        LOCATION_NAME: 'Marshfield',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0645629,
        LOCATION_LATITUDE_DEG: 51.5328802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037800',
        LOCATION_NAME: 'Marshfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3162053,
        LOCATION_LATITUDE_DEG: 51.4615666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056300',
        LOCATION_NAME: 'Marshfields',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.767043,
        LOCATION_LATITUDE_DEG: 53.7748656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037900',
        LOCATION_NAME: 'Marshgate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6169856,
        LOCATION_LATITUDE_DEG: 50.6967229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038000',
        LOCATION_NAME: 'Marshland Smeeth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2517508,
        LOCATION_LATITUDE_DEG: 52.6537496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054200',
        LOCATION_NAME: 'Marshland St James',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038100',
        LOCATION_NAME: 'Marshland St. James',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2444559,
        LOCATION_LATITUDE_DEG: 52.6562531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038200',
        LOCATION_NAME: 'Marshside',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1952529,
        LOCATION_LATITUDE_DEG: 51.3541101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038300',
        LOCATION_NAME: 'Marshwood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8762177,
        LOCATION_LATITUDE_DEG: 50.7927109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038400',
        LOCATION_NAME: 'Marske',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8372409,
        LOCATION_LATITUDE_DEG: 54.400848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054700',
        LOCATION_NAME: 'Marske by the Sea',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038500',
        LOCATION_NAME: 'Marske-by-the-Sea',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0127279,
        LOCATION_LATITUDE_DEG: 54.5909549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038600',
        LOCATION_NAME: 'Marston',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9292937,
        LOCATION_LATITUDE_DEG: 52.2126451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038900',
        LOCATION_NAME: 'Marston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4958964,
        LOCATION_LATITUDE_DEG: 53.2745456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039200',
        LOCATION_NAME: 'Marston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2427723,
        LOCATION_LATITUDE_DEG: 52.723086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038700',
        LOCATION_NAME: 'Marston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0479082,
        LOCATION_LATITUDE_DEG: 51.3090535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039100',
        LOCATION_NAME: 'Marston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6924404,
        LOCATION_LATITUDE_DEG: 52.5507618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA038800',
        LOCATION_NAME: 'Marston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2367381,
        LOCATION_LATITUDE_DEG: 51.7751818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039000',
        LOCATION_NAME: 'Marston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6720542,
        LOCATION_LATITUDE_DEG: 52.9825927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039300',
        LOCATION_NAME: 'Marston Bigot',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3437252,
        LOCATION_LATITUDE_DEG: 51.1959406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039400',
        LOCATION_NAME: 'Marston Gate',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1173514,
        LOCATION_LATITUDE_DEG: 52.8335007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039500',
        LOCATION_NAME: 'Marston Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7508786,
        LOCATION_LATITUDE_DEG: 52.4673549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039600',
        LOCATION_NAME: 'Marston Jabbett',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4446002,
        LOCATION_LATITUDE_DEG: 52.4923518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039700',
        LOCATION_NAME: 'Marston Magna',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5789843,
        LOCATION_LATITUDE_DEG: 50.9989247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039800',
        LOCATION_NAME: 'Marston Meysey',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8152395,
        LOCATION_LATITUDE_DEG: 51.6725846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA039900',
        LOCATION_NAME: 'Marston Montgomery',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8005374,
        LOCATION_LATITUDE_DEG: 52.9375989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040000',
        LOCATION_NAME: 'Marston Moretaine',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5472445,
        LOCATION_LATITUDE_DEG: 52.0621999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054300',
        LOCATION_NAME: 'Marston St Lawrence',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040100',
        LOCATION_NAME: 'Marston St. Lawrence',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2179251,
        LOCATION_LATITUDE_DEG: 52.0746105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040200',
        LOCATION_NAME: 'Marston Trussell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9826441,
        LOCATION_LATITUDE_DEG: 52.4659489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040300',
        LOCATION_NAME: 'Marstow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6501764,
        LOCATION_LATITUDE_DEG: 51.8696137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040400',
        LOCATION_NAME: 'Marsworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6646165,
        LOCATION_LATITUDE_DEG: 51.8220792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040500',
        LOCATION_NAME: 'Marten',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5922038,
        LOCATION_LATITUDE_DEG: 51.3391448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040600',
        LOCATION_NAME: 'Marthall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.301084,
        LOCATION_LATITUDE_DEG: 53.2777407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040700',
        LOCATION_NAME: 'Martham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6348368,
        LOCATION_LATITUDE_DEG: 52.7027333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040800',
        LOCATION_NAME: 'Marthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5411441,
        LOCATION_LATITUDE_DEG: 54.3265446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA040900',
        LOCATION_NAME: 'Martin',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9020099,
        LOCATION_LATITUDE_DEG: 50.9747143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041000',
        LOCATION_NAME: 'Martin',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1453245,
        LOCATION_LATITUDE_DEG: 53.183701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041100',
        LOCATION_NAME: 'Martin',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3461221,
        LOCATION_LATITUDE_DEG: 51.1739912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041200',
        LOCATION_NAME: 'Martin Dales',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2381541,
        LOCATION_LATITUDE_DEG: 53.1432025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041300',
        LOCATION_NAME: 'Martin Hussingtree',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1717699,
        LOCATION_LATITUDE_DEG: 52.2392417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041400',
        LOCATION_NAME: 'Martin Mill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3511767,
        LOCATION_LATITUDE_DEG: 51.16969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041500',
        LOCATION_NAME: 'Martindale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8713369,
        LOCATION_LATITUDE_DEG: 54.5652759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041600',
        LOCATION_NAME: 'Martinscroft',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5217514,
        LOCATION_LATITUDE_DEG: 53.3987554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041800',
        LOCATION_NAME: 'Martinstown',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2090125,
        LOCATION_LATITUDE_DEG: 54.9436482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041700',
        LOCATION_NAME: 'Martinstown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4996166,
        LOCATION_LATITUDE_DEG: 50.6986987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA041900',
        LOCATION_NAME: 'Martlesham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2837315,
        LOCATION_LATITUDE_DEG: 52.0732799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042000',
        LOCATION_NAME: 'Martlesham Heath',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2724159,
        LOCATION_LATITUDE_DEG: 52.0604799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042100',
        LOCATION_NAME: 'Martletwy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8388703,
        LOCATION_LATITUDE_DEG: 51.7632274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042200',
        LOCATION_NAME: 'Martley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3573908,
        LOCATION_LATITUDE_DEG: 52.2368385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042300',
        LOCATION_NAME: 'Martock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7664243,
        LOCATION_LATITUDE_DEG: 50.9690214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043000',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1634282,
        LOCATION_LATITUDE_DEG: 54.1837376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042800',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.053798,
        LOCATION_LATITUDE_DEG: 52.6145889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042900',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8267796,
        LOCATION_LATITUDE_DEG: 52.8099021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043025',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5604737,
        LOCATION_LATITUDE_DEG: 53.2031938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042400',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2250362,
        LOCATION_LATITUDE_DEG: 53.2112306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042600',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.402567,
        LOCATION_LATITUDE_DEG: 52.3155409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042500',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7388514,
        LOCATION_LATITUDE_DEG: 53.3261224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA042700',
        LOCATION_NAME: 'Marton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2093332,
        LOCATION_LATITUDE_DEG: 53.8356723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043050',
        LOCATION_NAME: 'Marton cum Grafton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.361646,
        LOCATION_LATITUDE_DEG: 54.0603127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054500',
        LOCATION_NAME: 'Marton in Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043100',
        LOCATION_NAME: 'Marton le Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4329594,
        LOCATION_LATITUDE_DEG: 54.1284089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043200',
        LOCATION_NAME: 'Marton-in-Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2031022,
        LOCATION_LATITUDE_DEG: 54.5347528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043400',
        LOCATION_NAME: 'Martyr Worthy',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2652363,
        LOCATION_LATITUDE_DEG: 51.0828204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043500',
        LOCATION_NAME: 'Marvig',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3874392,
        LOCATION_LATITUDE_DEG: 58.0839622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043600',
        LOCATION_NAME: 'Marwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0793832,
        LOCATION_LATITUDE_DEG: 51.1187552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043700',
        LOCATION_NAME: 'Marwood',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9168722,
        LOCATION_LATITUDE_DEG: 54.5757633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043800',
        LOCATION_NAME: 'Mary Tavy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1158199,
        LOCATION_LATITUDE_DEG: 50.5947065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044100',
        LOCATION_NAME: 'Marybank',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4095336,
        LOCATION_LATITUDE_DEG: 58.2182682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044000',
        LOCATION_NAME: 'Marybank',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5383169,
        LOCATION_LATITUDE_DEG: 57.5479907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044200',
        LOCATION_NAME: 'Maryburgh',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4384139,
        LOCATION_LATITUDE_DEG: 57.5743869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044300',
        LOCATION_NAME: 'Marycastle',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0015542,
        LOCATION_LATITUDE_DEG: 55.1673251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044400',
        LOCATION_NAME: 'Maryculter',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2373781,
        LOCATION_LATITUDE_DEG: 57.0821856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044600',
        LOCATION_NAME: 'Maryhill',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4152291,
        LOCATION_LATITUDE_DEG: 58.2200679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056700',
        LOCATION_NAME: 'Maryhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2671575,
        LOCATION_LATITUDE_DEG: 55.8769916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044700',
        LOCATION_NAME: 'Marykirk',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5143033,
        LOCATION_LATITUDE_DEG: 56.7820891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044900',
        LOCATION_NAME: 'Marypark',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3408223,
        LOCATION_LATITUDE_DEG: 57.4306648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045000',
        LOCATION_NAME: 'Maryport',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4948891,
        LOCATION_LATITUDE_DEG: 54.7126977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045100',
        LOCATION_NAME: 'Marystow',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2137386,
        LOCATION_LATITUDE_DEG: 50.6242073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045200',
        LOCATION_NAME: 'Maryton',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5157223,
        LOCATION_LATITUDE_DEG: 56.6945801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045300',
        LOCATION_NAME: 'Marywell',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5687509,
        LOCATION_LATITUDE_DEG: 56.5876706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045400',
        LOCATION_NAME: 'Masbury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.56535,
        LOCATION_LATITUDE_DEG: 51.2171486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045500',
        LOCATION_NAME: 'Mascalles',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1413217,
        LOCATION_LATITUDE_DEG: 54.1623395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045600',
        LOCATION_NAME: 'Masham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.655153,
        LOCATION_LATITUDE_DEG: 54.2218229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045700',
        LOCATION_NAME: 'Mashbury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3936049,
        LOCATION_LATITUDE_DEG: 51.7798617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045800',
        LOCATION_NAME: 'Masongill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5143516,
        LOCATION_LATITUDE_DEG: 54.173229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046200',
        LOCATION_NAME: 'Mastin Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3180054,
        LOCATION_LATITUDE_DEG: 53.2758291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046300',
        LOCATION_NAME: 'Mastlebridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9618604,
        LOCATION_LATITUDE_DEG: 51.7115188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046400',
        LOCATION_NAME: 'Matchams',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8071924,
        LOCATION_LATITUDE_DEG: 50.8138024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046500',
        LOCATION_NAME: 'Matching',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2273592,
        LOCATION_LATITUDE_DEG: 51.7776622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046600',
        LOCATION_NAME: 'Matching Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2253295,
        LOCATION_LATITUDE_DEG: 51.7776647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046700',
        LOCATION_NAME: 'Matching Tye',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1959746,
        LOCATION_LATITUDE_DEG: 51.7789634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046800',
        LOCATION_NAME: 'Matfen',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9532995,
        LOCATION_LATITUDE_DEG: 55.0413086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046900',
        LOCATION_NAME: 'Matfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3725583,
        LOCATION_LATITUDE_DEG: 51.1517052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047000',
        LOCATION_NAME: 'Matford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5160607,
        LOCATION_LATITUDE_DEG: 50.6891098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047100',
        LOCATION_NAME: 'Mathern',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6866996,
        LOCATION_LATITUDE_DEG: 51.6157878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047200',
        LOCATION_NAME: 'Mathon',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3905216,
        LOCATION_LATITUDE_DEG: 52.1102318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047300',
        LOCATION_NAME: 'Mathry',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.086487,
        LOCATION_LATITUDE_DEG: 51.9453468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047400',
        LOCATION_NAME: 'Matlaske',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.196741,
        LOCATION_LATITUDE_DEG: 52.8682533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047500',
        LOCATION_NAME: 'Matley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0276308,
        LOCATION_LATITUDE_DEG: 53.4686532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047600',
        LOCATION_NAME: 'Matlock',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5535634,
        LOCATION_LATITUDE_DEG: 53.1379225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047700',
        LOCATION_NAME: 'Matlock Bank',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5559544,
        LOCATION_LATITUDE_DEG: 53.1409161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047800',
        LOCATION_NAME: 'Matlock Bath',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5603745,
        LOCATION_LATITUDE_DEG: 53.1180168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA047900',
        LOCATION_NAME: 'Matson',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2208122,
        LOCATION_LATITUDE_DEG: 51.8382023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048000',
        LOCATION_NAME: 'Matterdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9102753,
        LOCATION_LATITUDE_DEG: 54.5939762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048100',
        LOCATION_NAME: 'Matterdale End',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9352811,
        LOCATION_LATITUDE_DEG: 54.6030794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048200',
        LOCATION_NAME: 'Mattersey',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9630288,
        LOCATION_LATITUDE_DEG: 53.3962376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048300',
        LOCATION_NAME: 'Mattersey Thorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9757345,
        LOCATION_LATITUDE_DEG: 53.402038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048400',
        LOCATION_NAME: 'Mattingley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.946151,
        LOCATION_LATITUDE_DEG: 51.3177394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048500',
        LOCATION_NAME: 'Mattishall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0358264,
        LOCATION_LATITUDE_DEG: 52.6583338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048600',
        LOCATION_NAME: 'Mauchline',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3778533,
        LOCATION_LATITUDE_DEG: 55.5158809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048700',
        LOCATION_NAME: 'Maud',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1216069,
        LOCATION_LATITUDE_DEG: 57.5215548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048800',
        LOCATION_NAME: 'Maudlam',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7217315,
        LOCATION_LATITUDE_DEG: 51.5204888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA048900',
        LOCATION_NAME: 'Maudlin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6996745,
        LOCATION_LATITUDE_DEG: 50.428999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049000',
        LOCATION_NAME: 'Maudlin',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7388872,
        LOCATION_LATITUDE_DEG: 50.8493904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049100',
        LOCATION_NAME: 'Maugersbury',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7094918,
        LOCATION_LATITUDE_DEG: 51.9248052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049300',
        LOCATION_NAME: 'Maughold',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3221351,
        LOCATION_LATITUDE_DEG: 54.298528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049400',
        LOCATION_NAME: 'Maulden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4666657,
        LOCATION_LATITUDE_DEG: 52.0302989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049500',
        LOCATION_NAME: 'Maulds Meaburn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5767605,
        LOCATION_LATITUDE_DEG: 54.5384654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049900',
        LOCATION_NAME: 'Maunby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4571433,
        LOCATION_LATITUDE_DEG: 54.2732268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049950',
        LOCATION_NAME: 'Maundown',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3382879,
        LOCATION_LATITUDE_DEG: 51.0516751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050100',
        LOCATION_NAME: 'Mautby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6654063,
        LOCATION_LATITUDE_DEG: 52.6519284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050200',
        LOCATION_NAME: 'Mavesyn Ridware',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8808736,
        LOCATION_LATITUDE_DEG: 52.7496891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050300',
        LOCATION_NAME: 'Mavis Enderby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.03969,
        LOCATION_LATITUDE_DEG: 53.1768996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050400',
        LOCATION_NAME: 'Maw Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9713557,
        LOCATION_LATITUDE_DEG: 52.5741655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050500',
        LOCATION_NAME: 'Mawbray',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.420327,
        LOCATION_LATITUDE_DEG: 54.8064995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050600',
        LOCATION_NAME: 'Mawcarse',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.361362,
        LOCATION_LATITUDE_DEG: 56.2377471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050700',
        LOCATION_NAME: 'Mawdesley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7693894,
        LOCATION_LATITUDE_DEG: 53.6257815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050800',
        LOCATION_NAME: 'Mawgan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2037123,
        LOCATION_LATITUDE_DEG: 50.0790659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050900',
        LOCATION_NAME: 'Mawgan Porth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0294869,
        LOCATION_LATITUDE_DEG: 50.4647037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051000',
        LOCATION_NAME: 'Mawla',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2246522,
        LOCATION_LATITUDE_DEG: 50.267182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051100',
        LOCATION_NAME: 'Mawla Lane End',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2214281,
        LOCATION_LATITUDE_DEG: 50.2707803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051200',
        LOCATION_NAME: 'Mawnan Smith',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1084252,
        LOCATION_LATITUDE_DEG: 50.1163694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051300',
        LOCATION_NAME: 'Mawneys',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1625245,
        LOCATION_LATITUDE_DEG: 51.583449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051350',
        LOCATION_NAME: 'Mawsley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8164146,
        LOCATION_LATITUDE_DEG: 52.3628423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051400',
        LOCATION_NAME: 'Mawthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1902239,
        LOCATION_LATITUDE_DEG: 53.2336076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051500',
        LOCATION_NAME: 'Maxey',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3291479,
        LOCATION_LATITUDE_DEG: 52.6585558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051600',
        LOCATION_NAME: 'Maxstoke',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6521791,
        LOCATION_LATITUDE_DEG: 52.4791539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051700',
        LOCATION_NAME: 'Maxton',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6118044,
        LOCATION_LATITUDE_DEG: 55.5643666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051800',
        LOCATION_NAME: 'Maxwelltown',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6214568,
        LOCATION_LATITUDE_DEG: 55.0664349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA051900',
        LOCATION_NAME: 'Maxworthy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4710603,
        LOCATION_LATITUDE_DEG: 50.7096154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052000',
        LOCATION_NAME: 'May Bank',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2208719,
        LOCATION_LATITUDE_DEG: 53.024416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052100',
        LOCATION_NAME: 'May Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.443412,
        LOCATION_LATITUDE_DEG: 51.8856092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052200',
        LOCATION_NAME: 'Mayals',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0096746,
        LOCATION_LATITUDE_DEG: 51.592696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052300',
        LOCATION_NAME: 'Maybole',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6820997,
        LOCATION_LATITUDE_DEG: 55.3548739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052400',
        LOCATION_NAME: 'Maybury',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5409321,
        LOCATION_LATITUDE_DEG: 51.3187339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052500',
        LOCATION_NAME: 'Maydensole',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3133087,
        LOCATION_LATITUDE_DEG: 51.1847949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052600',
        LOCATION_NAME: 'Maydown',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2710191,
        LOCATION_LATITUDE_DEG: 55.0129609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055700',
        LOCATION_NAME: 'Mayfair',
        COUNTY_NAME: 'London',
        POSTCODE: 'W1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1529468,
        LOCATION_LATITUDE_DEG: 51.5059641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052900',
        LOCATION_NAME: 'Mayfield',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0414953,
        LOCATION_LATITUDE_DEG: 55.8712045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052700',
        LOCATION_NAME: 'Mayfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7670738,
        LOCATION_LATITUDE_DEG: 53.0062058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA052800',
        LOCATION_NAME: 'Mayfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.261582,
        LOCATION_LATITUDE_DEG: 51.0197949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053000',
        LOCATION_NAME: 'Mayfields',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0196523,
        LOCATION_LATITUDE_DEG: 52.8193077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053100',
        LOCATION_NAME: 'Mayford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5724644,
        LOCATION_LATITUDE_DEG: 51.2951281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053300',
        LOCATION_NAME: 'Mayhill',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9535689,
        LOCATION_LATITUDE_DEG: 51.6278009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053400',
        LOCATION_NAME: 'Mayland',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7581868,
        LOCATION_LATITUDE_DEG: 51.664743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053500',
        LOCATION_NAME: 'Maynards Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2517685,
        LOCATION_LATITUDE_DEG: 50.9440869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053800',
        LOCATION_NAME: 'Mayobridge',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2322392,
        LOCATION_LATITUDE_DEG: 54.1665636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053900',
        LOCATION_NAME: 'Maypole',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7738574,
        LOCATION_LATITUDE_DEG: 51.8412054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056200',
        LOCATION_NAME: 'Maypole',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8788272,
        LOCATION_LATITUDE_DEG: 52.4023159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054000',
        LOCATION_NAME: 'Maypool',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5770647,
        LOCATION_LATITUDE_DEG: 50.3803775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA054100',
        LOCATION_NAME: 'Maythorne',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9620378,
        LOCATION_LATITUDE_DEG: 53.0902093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MD990880',
        LOCATION_NAME: 'MD2020 All Occasions',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000100',
        LOCATION_NAME: 'Meadle',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8351358,
        LOCATION_LATITUDE_DEG: 51.7450726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020200',
        LOCATION_NAME: 'Meadow Hall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4114461,
        LOCATION_LATITUDE_DEG: 53.4142668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020300',
        LOCATION_NAME: 'Meadow Hall Centre',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020000',
        LOCATION_NAME: 'Meadow Head',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4707918,
        LOCATION_LATITUDE_DEG: 53.3353807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020800',
        LOCATION_NAME: 'Meadowbank',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1552677,
        LOCATION_LATITUDE_DEG: 55.9557593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000200',
        LOCATION_NAME: 'Meadowbank',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5231809,
        LOCATION_LATITUDE_DEG: 53.2109419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000300',
        LOCATION_NAME: 'Meadowcroft',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7951372,
        LOCATION_LATITUDE_DEG: 52.5503793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000400',
        LOCATION_NAME: 'Meadowfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6196814,
        LOCATION_LATITUDE_DEG: 54.7483799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000500',
        LOCATION_NAME: 'Meadows',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1455827,
        LOCATION_LATITUDE_DEG: 52.9381921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000600',
        LOCATION_NAME: 'Meadowtown',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0172116,
        LOCATION_LATITUDE_DEG: 52.6038856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000700',
        LOCATION_NAME: 'Meads',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2782049,
        LOCATION_LATITUDE_DEG: 50.7632704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000800',
        LOCATION_NAME: 'Meaford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1722048,
        LOCATION_LATITUDE_DEG: 52.9161007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000900',
        LOCATION_NAME: 'Mealbank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7089564,
        LOCATION_LATITUDE_DEG: 54.3511216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001000',
        LOCATION_NAME: 'Mealrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3554471,
        LOCATION_LATITUDE_DEG: 54.7984059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001100',
        LOCATION_NAME: 'Mealsgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2294072,
        LOCATION_LATITUDE_DEG: 54.7673997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME021100',
        LOCATION_NAME: 'Meanwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001300',
        LOCATION_NAME: 'Meanwood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0358013,
        LOCATION_LATITUDE_DEG: 50.9135208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME021000',
        LOCATION_NAME: 'Meanwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5657186,
        LOCATION_LATITUDE_DEG: 53.8358177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001400',
        LOCATION_NAME: 'Meare',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7821493,
        LOCATION_LATITUDE_DEG: 51.1697476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001500',
        LOCATION_NAME: 'Mears Ashby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7704871,
        LOCATION_LATITUDE_DEG: 52.29293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001600',
        LOCATION_NAME: 'Measham',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5051855,
        LOCATION_LATITUDE_DEG: 52.705975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001700',
        LOCATION_NAME: 'Meath Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1872269,
        LOCATION_LATITUDE_DEG: 51.1782097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001800',
        LOCATION_NAME: 'Meathop',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8627489,
        LOCATION_LATITUDE_DEG: 54.219336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001900',
        LOCATION_NAME: 'Meaux',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3362693,
        LOCATION_LATITUDE_DEG: 53.8389744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002000',
        LOCATION_NAME: 'Meavaig North',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9661162,
        LOCATION_LATITUDE_DEG: 58.2042168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002100',
        LOCATION_NAME: 'Meavy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.052036,
        LOCATION_LATITUDE_DEG: 50.4855951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002200',
        LOCATION_NAME: 'Medbourne',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8209993,
        LOCATION_LATITUDE_DEG: 52.5286473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002300',
        LOCATION_NAME: 'Medburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.794443,
        LOCATION_LATITUDE_DEG: 55.0272049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME991064',
        LOCATION_NAME: 'Meddon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.497,
        LOCATION_LATITUDE_DEG: 51.0052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002400',
        LOCATION_NAME: 'Meden Vale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1282414,
        LOCATION_LATITUDE_DEG: 53.2207239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002500',
        LOCATION_NAME: 'Medge Hall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8706904,
        LOCATION_LATITUDE_DEG: 53.6016569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002600',
        LOCATION_NAME: 'Medley Park',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7701165,
        LOCATION_LATITUDE_DEG: 52.4362666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002700',
        LOCATION_NAME: 'Medmenham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8387321,
        LOCATION_LATITUDE_DEG: 51.553159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002800',
        LOCATION_NAME: 'Medomsley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8144905,
        LOCATION_LATITUDE_DEG: 54.8833953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME002900',
        LOCATION_NAME: 'Medomsley Edge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8269528,
        LOCATION_LATITUDE_DEG: 54.878192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003000',
        LOCATION_NAME: 'Medstead',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.063832,
        LOCATION_LATITUDE_DEG: 51.1292168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003900',
        LOCATION_NAME: 'Meerbrook',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0161332,
        LOCATION_LATITUDE_DEG: 53.1439274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020100',
        LOCATION_NAME: 'Meersbrook',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4762891,
        LOCATION_LATITUDE_DEG: 53.3561894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004000',
        LOCATION_NAME: 'Meesden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0827474,
        LOCATION_LATITUDE_DEG: 51.9718812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004100',
        LOCATION_NAME: 'Meeson',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5147098,
        LOCATION_LATITUDE_DEG: 52.7827968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004200',
        LOCATION_NAME: 'Meeth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0634944,
        LOCATION_LATITUDE_DEG: 50.8547243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004300',
        LOCATION_NAME: 'Meethe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8826875,
        LOCATION_LATITUDE_DEG: 50.9911418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004400',
        LOCATION_NAME: 'Meidrim',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4840601,
        LOCATION_LATITUDE_DEG: 51.8593261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004500',
        LOCATION_NAME: 'Meifod',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2527506,
        LOCATION_LATITUDE_DEG: 52.7088947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004600',
        LOCATION_NAME: 'Meigle',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'PA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8865279,
        LOCATION_LATITUDE_DEG: 55.8492113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004700',
        LOCATION_NAME: 'Meigle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1614809,
        LOCATION_LATITUDE_DEG: 56.5882744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004800',
        LOCATION_NAME: 'Meikle Earnock',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0453305,
        LOCATION_LATITUDE_DEG: 55.7584062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004900',
        LOCATION_NAME: 'Meikle Ferry',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1333796,
        LOCATION_LATITUDE_DEG: 57.8589128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005000',
        LOCATION_NAME: 'Meikle Wartle',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4641939,
        LOCATION_LATITUDE_DEG: 57.3680446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005100',
        LOCATION_NAME: 'Meikleour',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3693005,
        LOCATION_LATITUDE_DEG: 56.5392714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005200',
        LOCATION_NAME: 'Meinciau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2299628,
        LOCATION_LATITUDE_DEG: 51.7734218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005300',
        LOCATION_NAME: 'Meir',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.095299,
        LOCATION_LATITUDE_DEG: 52.9725115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005400',
        LOCATION_NAME: 'Meir Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1030303,
        LOCATION_LATITUDE_DEG: 52.9545065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005500',
        LOCATION_NAME: 'Melbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3214412,
        LOCATION_LATITUDE_DEG: 58.210267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005600',
        LOCATION_NAME: 'Melbourn',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0177378,
        LOCATION_LATITUDE_DEG: 52.0833941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005800',
        LOCATION_NAME: 'Melbourne',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4269213,
        LOCATION_LATITUDE_DEG: 52.8226904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005700',
        LOCATION_NAME: 'Melbourne',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8547172,
        LOCATION_LATITUDE_DEG: 53.8870787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME005900',
        LOCATION_NAME: 'Melbury Abbas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1678461,
        LOCATION_LATITUDE_DEG: 50.9785199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006000',
        LOCATION_NAME: 'Melbury Bubb',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5719964,
        LOCATION_LATITUDE_DEG: 50.8570151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006100',
        LOCATION_NAME: 'Melbury Osmond',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6029577,
        LOCATION_LATITUDE_DEG: 50.8669141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006200',
        LOCATION_NAME: 'Melbury Sampford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5987409,
        LOCATION_LATITUDE_DEG: 50.8517096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006300',
        LOCATION_NAME: 'Melchbourne',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4920545,
        LOCATION_LATITUDE_DEG: 52.2801261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006400',
        LOCATION_NAME: 'Melcombe Bingham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.337105,
        LOCATION_LATITUDE_DEG: 50.8232057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006500',
        LOCATION_NAME: 'Melcombe Horsey',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3606397,
        LOCATION_LATITUDE_DEG: 50.8168039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006600',
        LOCATION_NAME: 'Meldon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0415659,
        LOCATION_LATITUDE_DEG: 50.7107173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006700',
        LOCATION_NAME: 'Meldon',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8123086,
        LOCATION_LATITUDE_DEG: 55.1478137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006800',
        LOCATION_NAME: 'Meldon Park',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8312928,
        LOCATION_LATITUDE_DEG: 55.1634159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME006900',
        LOCATION_NAME: 'Meldreth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.009101,
        LOCATION_LATITUDE_DEG: 52.0951966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007000',
        LOCATION_NAME: 'Meledor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9127892,
        LOCATION_LATITUDE_DEG: 50.357192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007100',
        LOCATION_NAME: 'Meliden',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4091387,
        LOCATION_LATITUDE_DEG: 53.316078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019700',
        LOCATION_NAME: 'Melin Byrhedyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019800',
        LOCATION_NAME: 'Melin y Coed',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019900',
        LOCATION_NAME: 'Melin y Wig',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4339162,
        LOCATION_LATITUDE_DEG: 53.0313066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007500',
        LOCATION_NAME: 'Melinau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6552289,
        LOCATION_LATITUDE_DEG: 51.7857265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007200',
        LOCATION_NAME: 'Melin-Byrhedyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7465332,
        LOCATION_LATITUDE_DEG: 52.5738937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007600',
        LOCATION_NAME: 'Melincourt',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7069276,
        LOCATION_LATITUDE_DEG: 51.7034029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007300',
        LOCATION_NAME: 'Melin-y-Coed',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7733271,
        LOCATION_LATITUDE_DEG: 53.1282415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007400',
        LOCATION_NAME: 'Melin-y-Wig',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4318838,
        LOCATION_LATITUDE_DEG: 53.0271323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007800',
        LOCATION_NAME: 'Melkinthorpe',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6917957,
        LOCATION_LATITUDE_DEG: 54.6215771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007900',
        LOCATION_NAME: 'Melkridge',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4091556,
        LOCATION_LATITUDE_DEG: 54.9700078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008000',
        LOCATION_NAME: 'Melksham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1365398,
        LOCATION_LATITUDE_DEG: 51.3730571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008100',
        LOCATION_NAME: 'Mellguards',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8638231,
        LOCATION_LATITUDE_DEG: 54.8057953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008300',
        LOCATION_NAME: 'Melling',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9199021,
        LOCATION_LATITUDE_DEG: 53.4942696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008200',
        LOCATION_NAME: 'Melling',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.614662,
        LOCATION_LATITUDE_DEG: 54.1352312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008400',
        LOCATION_NAME: 'Melling Mount',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8993076,
        LOCATION_LATITUDE_DEG: 53.5034701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008500',
        LOCATION_NAME: 'Mellis',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0815282,
        LOCATION_LATITUDE_DEG: 52.3291023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008600',
        LOCATION_NAME: 'Mellon Charles',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6256923,
        LOCATION_LATITUDE_DEG: 57.859728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008700',
        LOCATION_NAME: 'Mellon Udrigle',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5619532,
        LOCATION_LATITUDE_DEG: 57.9017317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008900',
        LOCATION_NAME: 'Mellor',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5296766,
        LOCATION_LATITUDE_DEG: 53.7719893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME008800',
        LOCATION_NAME: 'Mellor',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0223933,
        LOCATION_LATITUDE_DEG: 53.3930521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009000',
        LOCATION_NAME: 'Mellor Brook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5456735,
        LOCATION_LATITUDE_DEG: 53.7733918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009200',
        LOCATION_NAME: 'Mells',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3920766,
        LOCATION_LATITUDE_DEG: 51.2383433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009100',
        LOCATION_NAME: 'Mells',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5314525,
        LOCATION_LATITUDE_DEG: 52.3364033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009500',
        LOCATION_NAME: 'Melmerby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5976195,
        LOCATION_LATITUDE_DEG: 54.7301845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009300',
        LOCATION_NAME: 'Melmerby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8821276,
        LOCATION_LATITUDE_DEG: 54.2627332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009400',
        LOCATION_NAME: 'Melmerby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4825714,
        LOCATION_LATITUDE_DEG: 54.1865188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009600',
        LOCATION_NAME: 'Melplash',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7285325,
        LOCATION_LATITUDE_DEG: 50.7800112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009700',
        LOCATION_NAME: 'Melrose',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7249967,
        LOCATION_LATITUDE_DEG: 55.5995701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009800',
        LOCATION_NAME: 'Melsonby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6935876,
        LOCATION_LATITUDE_DEG: 54.4706492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME009900',
        LOCATION_NAME: 'Meltham',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8493411,
        LOCATION_LATITUDE_DEG: 53.5918694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010000',
        LOCATION_NAME: 'Melton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5277708,
        LOCATION_LATITUDE_DEG: 53.7255613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010100',
        LOCATION_NAME: 'Melton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3343806,
        LOCATION_LATITUDE_DEG: 52.1064795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010200',
        LOCATION_NAME: 'Melton Brand',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2103482,
        LOCATION_LATITUDE_DEG: 53.5227545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010300',
        LOCATION_NAME: 'Melton Constable',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0344676,
        LOCATION_LATITUDE_DEG: 52.8563526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010400',
        LOCATION_NAME: 'Melton Mowbray',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8841424,
        LOCATION_LATITUDE_DEG: 52.7638759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010500',
        LOCATION_NAME: 'Melton Park',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6151299,
        LOCATION_LATITUDE_DEG: 55.0247029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010600',
        LOCATION_NAME: 'Melton Ross',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3838003,
        LOCATION_LATITUDE_DEG: 53.5816501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010700',
        LOCATION_NAME: 'Meltonby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7872306,
        LOCATION_LATITUDE_DEG: 53.9621878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010800',
        LOCATION_NAME: 'Melvaig',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8007153,
        LOCATION_LATITUDE_DEG: 57.8110277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME010900',
        LOCATION_NAME: 'Melverley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9883389,
        LOCATION_LATITUDE_DEG: 52.7440939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011000',
        LOCATION_NAME: 'Melvich',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9117901,
        LOCATION_LATITUDE_DEG: 58.5503837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011100',
        LOCATION_NAME: 'Membland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0137114,
        LOCATION_LATITUDE_DEG: 50.3151752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011200',
        LOCATION_NAME: 'Membury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0229176,
        LOCATION_LATITUDE_DEG: 50.8235168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME990168',
        LOCATION_NAME: 'Memory Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7188663,
        LOCATION_LATITUDE_DEG: 50.4785085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011300',
        LOCATION_NAME: 'Memsie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0483275,
        LOCATION_LATITUDE_DEG: 57.6517655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011400',
        LOCATION_NAME: 'Menabilly',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6721093,
        LOCATION_LATITUDE_DEG: 50.3295815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011500',
        LOCATION_NAME: 'Menai Bridge',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL59',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1619286,
        LOCATION_LATITUDE_DEG: 53.2249619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011600',
        LOCATION_NAME: 'Mendham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3389733,
        LOCATION_LATITUDE_DEG: 52.396309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011700',
        LOCATION_NAME: 'Mendlesham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0844075,
        LOCATION_LATITUDE_DEG: 52.2497938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011800',
        LOCATION_NAME: 'Mendlesham Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0719977,
        LOCATION_LATITUDE_DEG: 52.228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME011900',
        LOCATION_NAME: 'Menethorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8212539,
        LOCATION_LATITUDE_DEG: 54.1026059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012000',
        LOCATION_NAME: 'Menheniot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4095807,
        LOCATION_LATITUDE_DEG: 50.4384932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012100',
        LOCATION_NAME: 'Menherion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.215727,
        LOCATION_LATITUDE_DEG: 50.1863752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012150',
        LOCATION_NAME: 'Menith Wood',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4272937,
        LOCATION_LATITUDE_DEG: 52.3222221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012400',
        LOCATION_NAME: 'Menmuir',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7624048,
        LOCATION_LATITUDE_DEG: 56.7689865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012500',
        LOCATION_NAME: 'Menna',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9376336,
        LOCATION_LATITUDE_DEG: 50.3518884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012600',
        LOCATION_NAME: 'Mennock',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8799484,
        LOCATION_LATITUDE_DEG: 55.3514584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012700',
        LOCATION_NAME: 'Menston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7357961,
        LOCATION_LATITUDE_DEG: 53.8884936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012800',
        LOCATION_NAME: 'Menstrie',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8529646,
        LOCATION_LATITUDE_DEG: 56.151536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012900',
        LOCATION_NAME: 'Menthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9317025,
        LOCATION_LATITUDE_DEG: 53.7997731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013000',
        LOCATION_NAME: 'Mentmore',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6807207,
        LOCATION_LATITUDE_DEG: 51.8673855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013100',
        LOCATION_NAME: 'Menwith Hill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6969722,
        LOCATION_LATITUDE_DEG: 54.0134094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013200',
        LOCATION_NAME: 'Meole Brace',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7602132,
        LOCATION_LATITUDE_DEG: 52.6912909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013300',
        LOCATION_NAME: 'Meols',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1505538,
        LOCATION_LATITUDE_DEG: 53.397067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME990791',
        LOCATION_NAME: 'Meon Vale',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013400',
        LOCATION_NAME: 'Meonstoke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1261733,
        LOCATION_LATITUDE_DEG: 50.9732048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013500',
        LOCATION_NAME: 'Meopham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3618649,
        LOCATION_LATITUDE_DEG: 51.3690227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013600',
        LOCATION_NAME: 'Mepal',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.11938,
        LOCATION_LATITUDE_DEG: 52.405822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013700',
        LOCATION_NAME: 'Meppershall',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3382758,
        LOCATION_LATITUDE_DEG: 52.0166965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013800',
        LOCATION_NAME: 'Mercaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6027008,
        LOCATION_LATITUDE_DEG: 52.9842026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020700',
        LOCATION_NAME: 'Merchiston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2135837,
        LOCATION_LATITUDE_DEG: 55.9360753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014000',
        LOCATION_NAME: 'Mere',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4096207,
        LOCATION_LATITUDE_DEG: 53.3316439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME013900',
        LOCATION_NAME: 'Mere',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.263715,
        LOCATION_LATITUDE_DEG: 51.0904346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014100',
        LOCATION_NAME: 'Mere Brow',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8785593,
        LOCATION_LATITUDE_DEG: 53.6622827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014200',
        LOCATION_NAME: 'Mere Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8284121,
        LOCATION_LATITUDE_DEG: 52.5861733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014300',
        LOCATION_NAME: 'Mereclough',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1902317,
        LOCATION_LATITUDE_DEG: 53.7700869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014400',
        LOCATION_NAME: 'Mereside',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8841302,
        LOCATION_LATITUDE_DEG: 52.9036126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014500',
        LOCATION_NAME: 'Meretown',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3618759,
        LOCATION_LATITUDE_DEG: 52.7808979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014600',
        LOCATION_NAME: 'Merevale',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5780096,
        LOCATION_LATITUDE_DEG: 52.5648667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014700',
        LOCATION_NAME: 'Mereworth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3820506,
        LOCATION_LATITUDE_DEG: 51.2587102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014800',
        LOCATION_NAME: 'Meriden',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6448687,
        LOCATION_LATITUDE_DEG: 52.4360559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME014900',
        LOCATION_NAME: 'Merlins Bridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9778303,
        LOCATION_LATITUDE_DEG: 51.789227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015000',
        LOCATION_NAME: 'Merridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1260085,
        LOCATION_LATITUDE_DEG: 51.0970461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015100',
        LOCATION_NAME: 'Merrington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7829823,
        LOCATION_LATITUDE_DEG: 52.7819951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015200',
        LOCATION_NAME: 'Merrion',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9803416,
        LOCATION_LATITUDE_DEG: 51.6334148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015400',
        LOCATION_NAME: 'Merriott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7869873,
        LOCATION_LATITUDE_DEG: 50.9114249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015500',
        LOCATION_NAME: 'Merriottsford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7909841,
        LOCATION_LATITUDE_DEG: 50.9055161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015600',
        LOCATION_NAME: 'Merrivale',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0472342,
        LOCATION_LATITUDE_DEG: 50.5568041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015700',
        LOCATION_NAME: 'Merrow',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5331607,
        LOCATION_LATITUDE_DEG: 51.2442247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015800',
        LOCATION_NAME: 'Merry Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1814267,
        LOCATION_LATITUDE_DEG: 52.5701729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015900',
        LOCATION_NAME: 'Merrybent',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6219407,
        LOCATION_LATITUDE_DEG: 54.5255519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020900',
        LOCATION_NAME: 'Merrylee',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.272824,
        LOCATION_LATITUDE_DEG: 55.8190815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016000',
        LOCATION_NAME: 'Merrymeet',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.423995,
        LOCATION_LATITUDE_DEG: 50.4677984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019600',
        LOCATION_NAME: 'Mersea Island',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9393277,
        LOCATION_LATITUDE_DEG: 51.79312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016100',
        LOCATION_NAME: 'Mersham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9347605,
        LOCATION_LATITUDE_DEG: 51.1187914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016200',
        LOCATION_NAME: 'Merstham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1505949,
        LOCATION_LATITUDE_DEG: 51.2629168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016300',
        LOCATION_NAME: 'Merston',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7301165,
        LOCATION_LATITUDE_DEG: 50.8207844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016400',
        LOCATION_NAME: 'Merstone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2535636,
        LOCATION_LATITUDE_DEG: 50.6623753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016500',
        LOCATION_NAME: 'Merthyr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3919237,
        LOCATION_LATITUDE_DEG: 51.8612274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016600',
        LOCATION_NAME: 'Merthyr Cynog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4792022,
        LOCATION_LATITUDE_DEG: 52.0254337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016700',
        LOCATION_NAME: 'Merthyr Dyfan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2699921,
        LOCATION_LATITUDE_DEG: 51.4219755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016800',
        LOCATION_NAME: 'Merthyr Mawr',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6075337,
        LOCATION_LATITUDE_DEG: 51.4849852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME016900',
        LOCATION_NAME: 'Merthyr Tydfil',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3770627,
        LOCATION_LATITUDE_DEG: 51.7455025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017000',
        LOCATION_NAME: 'Merthyr Vale',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3352797,
        LOCATION_LATITUDE_DEG: 51.6879005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017300',
        LOCATION_NAME: 'Merton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0923491,
        LOCATION_LATITUDE_DEG: 50.8901351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017200',
        LOCATION_NAME: 'Merton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1620737,
        LOCATION_LATITUDE_DEG: 51.8547943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020400',
        LOCATION_NAME: 'Merton',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2073625,
        LOCATION_LATITUDE_DEG: 51.429608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017100',
        LOCATION_NAME: 'Merton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8135129,
        LOCATION_LATITUDE_DEG: 52.5534273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017400',
        LOCATION_NAME: 'Mervinslaw',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.514169,
        LOCATION_LATITUDE_DEG: 55.4125546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017500',
        LOCATION_NAME: 'Meshaw',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7680952,
        LOCATION_LATITUDE_DEG: 50.9623346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017600',
        LOCATION_NAME: 'Messing',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7544782,
        LOCATION_LATITUDE_DEG: 51.8367608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017700',
        LOCATION_NAME: 'Messingham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6520057,
        LOCATION_LATITUDE_DEG: 53.5279488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017800',
        LOCATION_NAME: 'Metal Bridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.534826,
        LOCATION_LATITUDE_DEG: 54.7082686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME017900',
        LOCATION_NAME: 'Metcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.303227,
        LOCATION_LATITUDE_DEG: 50.719404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018000',
        LOCATION_NAME: 'Metfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.371309,
        LOCATION_LATITUDE_DEG: 52.3726056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018050',
        LOCATION_NAME: 'Metham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7756417,
        LOCATION_LATITUDE_DEG: 53.7137872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018100',
        LOCATION_NAME: 'Metherell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2444349,
        LOCATION_LATITUDE_DEG: 50.5023004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018200',
        LOCATION_NAME: 'Metheringham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4019957,
        LOCATION_LATITUDE_DEG: 53.1397061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018300',
        LOCATION_NAME: 'Metheringham Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3278672,
        LOCATION_LATITUDE_DEG: 53.161903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018400',
        LOCATION_NAME: 'Methil',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0146802,
        LOCATION_LATITUDE_DEG: 56.1846347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018500',
        LOCATION_NAME: 'Methley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.407342,
        LOCATION_LATITUDE_DEG: 53.7347758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018600',
        LOCATION_NAME: 'Methlick',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2364593,
        LOCATION_LATITUDE_DEG: 57.424647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018700',
        LOCATION_NAME: 'Methven',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5800255,
        LOCATION_LATITUDE_DEG: 56.4153649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018800',
        LOCATION_NAME: 'Methwold',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.560314,
        LOCATION_LATITUDE_DEG: 52.5221342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME018900',
        LOCATION_NAME: 'Methwold Hythe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5233174,
        LOCATION_LATITUDE_DEG: 52.5246289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019000',
        LOCATION_NAME: 'Mettingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.476201,
        LOCATION_LATITUDE_DEG: 52.4565127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019100',
        LOCATION_NAME: 'Metton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2695835,
        LOCATION_LATITUDE_DEG: 52.8879536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019200',
        LOCATION_NAME: 'Mevagissey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7864195,
        LOCATION_LATITUDE_DEG: 50.26968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019300',
        LOCATION_NAME: 'Mexborough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2926366,
        LOCATION_LATITUDE_DEG: 53.4939454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019400',
        LOCATION_NAME: 'Mey',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2349357,
        LOCATION_LATITUDE_DEG: 58.6358821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME019500',
        LOCATION_NAME: 'Meysey Hampton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8272546,
        LOCATION_LATITUDE_DEG: 51.6962794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000100',
        LOCATION_NAME: 'Miami Beach',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.280301,
        LOCATION_LATITUDE_DEG: 53.3194081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000200',
        LOCATION_NAME: 'Miavaig',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9597825,
        LOCATION_LATITUDE_DEG: 58.2059751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000300',
        LOCATION_NAME: 'Michaelchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6961706,
        LOCATION_LATITUDE_DEG: 51.9254161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000400',
        LOCATION_NAME: 'Michaelchurch Escley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9965986,
        LOCATION_LATITUDE_DEG: 52.0017302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034500',
        LOCATION_NAME: 'Michaelston le Pit',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034600',
        LOCATION_NAME: 'Michaelston y Fedw',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000500',
        LOCATION_NAME: 'Michaelston-le-Pit',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2092983,
        LOCATION_LATITUDE_DEG: 51.4467727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000600',
        LOCATION_NAME: 'Michaelston-y-Fedw',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0940677,
        LOCATION_LATITUDE_DEG: 51.5540836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000700',
        LOCATION_NAME: 'Michaelstow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7109666,
        LOCATION_LATITUDE_DEG: 50.5774125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000800',
        LOCATION_NAME: 'Michaelwood',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4157833,
        LOCATION_LATITUDE_DEG: 51.6594857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI000900',
        LOCATION_NAME: 'Micheldever',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2655566,
        LOCATION_LATITUDE_DEG: 51.1482213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001000',
        LOCATION_NAME: 'Micheldever Station',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2598428,
        LOCATION_LATITUDE_DEG: 51.1818288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001100',
        LOCATION_NAME: 'Michelmersh',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5042822,
        LOCATION_LATITUDE_DEG: 51.0306134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001200',
        LOCATION_NAME: 'Mickfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1269208,
        LOCATION_LATITUDE_DEG: 52.2124976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001300',
        LOCATION_NAME: 'Mickle Trafford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8315396,
        LOCATION_LATITUDE_DEG: 53.2207416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001400',
        LOCATION_NAME: 'Micklebring',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2196328,
        LOCATION_LATITUDE_DEG: 53.4476434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001500',
        LOCATION_NAME: 'Mickleby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7628432,
        LOCATION_LATITUDE_DEG: 54.5063413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001600',
        LOCATION_NAME: 'Micklefield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3337732,
        LOCATION_LATITUDE_DEG: 53.7955792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001700',
        LOCATION_NAME: 'Mickleham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3223814,
        LOCATION_LATITUDE_DEG: 51.2674208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001800',
        LOCATION_NAME: 'Micklehurst',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0256255,
        LOCATION_LATITUDE_DEG: 53.516163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI001900',
        LOCATION_NAME: 'Mickleover',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5424197,
        LOCATION_LATITUDE_DEG: 52.9087993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002100',
        LOCATION_NAME: 'Micklethwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1128837,
        LOCATION_LATITUDE_DEG: 54.842901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002000',
        LOCATION_NAME: 'Micklethwaite',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8407963,
        LOCATION_LATITUDE_DEG: 53.8667908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002200',
        LOCATION_NAME: 'Mickleton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.054178,
        LOCATION_LATITUDE_DEG: 54.6086661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002300',
        LOCATION_NAME: 'Mickleton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7663764,
        LOCATION_LATITUDE_DEG: 52.0890222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002400',
        LOCATION_NAME: 'Mickletown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3931361,
        LOCATION_LATITUDE_DEG: 53.7389746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002450',
        LOCATION_NAME: 'Mickletown Methley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.401319,
        LOCATION_LATITUDE_DEG: 53.7382606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002500',
        LOCATION_NAME: 'Mickley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5729086,
        LOCATION_LATITUDE_DEG: 52.8876031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002600',
        LOCATION_NAME: 'Mickley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6116373,
        LOCATION_LATITUDE_DEG: 54.1874175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002700',
        LOCATION_NAME: 'Mid Calder',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4914311,
        LOCATION_LATITUDE_DEG: 55.8864093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002800',
        LOCATION_NAME: 'Mid Holmwood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3258395,
        LOCATION_LATITUDE_DEG: 51.2022208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI002900',
        LOCATION_NAME: 'Mid Taphouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5723582,
        LOCATION_LATITUDE_DEG: 50.4439935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003000',
        LOCATION_NAME: 'Mid Yell',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0596027,
        LOCATION_LATITUDE_DEG: 60.5976482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003100',
        LOCATION_NAME: 'Midclyth',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2256488,
        LOCATION_LATITUDE_DEG: 58.3181479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003200',
        LOCATION_NAME: 'Middle Assendon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9336803,
        LOCATION_LATITUDE_DEG: 51.5648606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003300',
        LOCATION_NAME: 'Middle Aston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3090165,
        LOCATION_LATITUDE_DEG: 51.9389976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003400',
        LOCATION_NAME: 'Middle Barton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3675642,
        LOCATION_LATITUDE_DEG: 51.9283025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003500',
        LOCATION_NAME: 'Middle Chedworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9187642,
        LOCATION_LATITUDE_DEG: 51.8012984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003600',
        LOCATION_NAME: 'Middle Chinnock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7486712,
        LOCATION_LATITUDE_DEG: 50.8995176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003700',
        LOCATION_NAME: 'Middle Claydon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9508571,
        LOCATION_LATITUDE_DEG: 51.925398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003800',
        LOCATION_NAME: 'Middle Dimson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2167214,
        LOCATION_LATITUDE_DEG: 50.5219017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI003900',
        LOCATION_NAME: 'Middle Duntisbourne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0250378,
        LOCATION_LATITUDE_DEG: 51.7566961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004000',
        LOCATION_NAME: 'Middle Hampt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2686355,
        LOCATION_LATITUDE_DEG: 50.5451977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004100',
        LOCATION_NAME: 'Middle Handley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3934693,
        LOCATION_LATITUDE_DEG: 53.2954303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004200',
        LOCATION_NAME: 'Middle Hill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8360565,
        LOCATION_LATITUDE_DEG: 52.0188159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004300',
        LOCATION_NAME: 'Middle Lambrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.821777,
        LOCATION_LATITUDE_DEG: 50.9611265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004400',
        LOCATION_NAME: 'Middle Leazes',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2067974,
        LOCATION_LATITUDE_DEG: 51.7446923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004500',
        LOCATION_NAME: 'Middle Littleton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8848074,
        LOCATION_LATITUDE_DEG: 52.120623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004600',
        LOCATION_NAME: 'Middle Lodge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0992965,
        LOCATION_LATITUDE_DEG: 51.4388669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004700',
        LOCATION_NAME: 'Middle Lypiatt',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1840032,
        LOCATION_LATITUDE_DEG: 51.7390921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004800',
        LOCATION_NAME: 'Middle Marwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0942019,
        LOCATION_LATITUDE_DEG: 51.129158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI004900',
        LOCATION_NAME: 'Middle Mayfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7782202,
        LOCATION_LATITUDE_DEG: 53.000806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005000',
        LOCATION_NAME: 'Middle Mill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1884292,
        LOCATION_LATITUDE_DEG: 51.88764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005100',
        LOCATION_NAME: 'Middle Pill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2146308,
        LOCATION_LATITUDE_DEG: 50.4153914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005200',
        LOCATION_NAME: 'Middle Rainton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4916455,
        LOCATION_LATITUDE_DEG: 54.8172776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005300',
        LOCATION_NAME: 'Middle Rasen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3652112,
        LOCATION_LATITUDE_DEG: 53.3862306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005400',
        LOCATION_NAME: 'Middle Sontley',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0153373,
        LOCATION_LATITUDE_DEG: 53.0153245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005500',
        LOCATION_NAME: 'Middle Spring',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2377061,
        LOCATION_LATITUDE_DEG: 51.7632925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005600',
        LOCATION_NAME: 'Middle Stoke',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6349943,
        LOCATION_LATITUDE_DEG: 51.4513258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005700',
        LOCATION_NAME: 'Middle Stoughton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8260729,
        LOCATION_LATITUDE_DEG: 51.2421554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005800',
        LOCATION_NAME: 'Middle Town',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2996281,
        LOCATION_LATITUDE_DEG: 49.9662646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI035500',
        LOCATION_NAME: 'Middle Tysoe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5061566,
        LOCATION_LATITUDE_DEG: 52.0955925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI005900',
        LOCATION_NAME: 'Middle Wallop',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5795038,
        LOCATION_LATITUDE_DEG: 51.135724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006000',
        LOCATION_NAME: 'Middle Woodford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.828615,
        LOCATION_LATITUDE_DEG: 51.1231255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006100',
        LOCATION_NAME: 'Middle Wyke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4143452,
        LOCATION_LATITUDE_DEG: 51.2419325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006200',
        LOCATION_NAME: 'Middlebie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2317189,
        LOCATION_LATITUDE_DEG: 55.0732303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006300',
        LOCATION_NAME: 'Middlecombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4989348,
        LOCATION_LATITUDE_DEG: 51.1996595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006400',
        LOCATION_NAME: 'Middlegreen',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5663454,
        LOCATION_LATITUDE_DEG: 51.5151547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006500',
        LOCATION_NAME: 'Middleham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8043569,
        LOCATION_LATITUDE_DEG: 54.2860377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006600',
        LOCATION_NAME: 'Middlehope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7398329,
        LOCATION_LATITUDE_DEG: 52.4911715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006700',
        LOCATION_NAME: 'Middleleaze',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8424642,
        LOCATION_LATITUDE_DEG: 51.5665687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006800',
        LOCATION_NAME: 'Middlemarsh',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4664377,
        LOCATION_LATITUDE_DEG: 50.8613159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007000',
        LOCATION_NAME: 'Middlemoor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1199131,
        LOCATION_LATITUDE_DEG: 50.5344996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI006900',
        LOCATION_NAME: 'Middlemoor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4764481,
        LOCATION_LATITUDE_DEG: 50.7181123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007100',
        LOCATION_NAME: 'Middlequarter',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3537208,
        LOCATION_LATITUDE_DEG: 57.648627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007200',
        LOCATION_NAME: 'Middlesbrough',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2353287,
        LOCATION_LATITUDE_DEG: 54.5752547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007300',
        LOCATION_NAME: 'Middleshaw',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3338094,
        LOCATION_LATITUDE_DEG: 55.0659262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007400',
        LOCATION_NAME: 'Middlesmoor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8588219,
        LOCATION_LATITUDE_DEG: 54.1633234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007500',
        LOCATION_NAME: 'Middlestone',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6068884,
        LOCATION_LATITUDE_DEG: 54.6751701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007600',
        LOCATION_NAME: 'Middlestone Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6229633,
        LOCATION_LATITUDE_DEG: 54.6877681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007700',
        LOCATION_NAME: 'Middlestown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5961309,
        LOCATION_LATITUDE_DEG: 53.6505674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007800',
        LOCATION_NAME: 'Middlethorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.101964,
        LOCATION_LATITUDE_DEG: 53.9300927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990568',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008000',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2772534,
        LOCATION_LATITUDE_DEG: 51.5666988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009300',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0121565,
        LOCATION_LATITUDE_DEG: 52.8531055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008300',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8781903,
        LOCATION_LATITUDE_DEG: 54.0208223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009000',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6734816,
        LOCATION_LATITUDE_DEG: 52.3893645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990106',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5797273,
        LOCATION_LATITUDE_DEG: 54.2718417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008800',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5781272,
        LOCATION_LATITUDE_DEG: 54.2683439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008400',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1915171,
        LOCATION_LATITUDE_DEG: 53.5487699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008100',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9062263,
        LOCATION_LATITUDE_DEG: 55.1606208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008200',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8393523,
        LOCATION_LATITUDE_DEG: 55.6135595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009350',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7383469,
        LOCATION_LATITUDE_DEG: 52.5820616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009200',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5859894,
        LOCATION_LATITUDE_DEG: 53.0991125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008900',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5462919,
        LOCATION_LATITUDE_DEG: 53.7475807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990103',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5435837,
        LOCATION_LATITUDE_DEG: 53.7469861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008600',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8004711,
        LOCATION_LATITUDE_DEG: 54.258118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008500',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.763989,
        LOCATION_LATITUDE_DEG: 52.500246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI008700',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6938394,
        LOCATION_LATITUDE_DEG: 52.0421008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI007900',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4623057,
        LOCATION_LATITUDE_DEG: 52.7154505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009100',
        LOCATION_NAME: 'Middleton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5610238,
        LOCATION_LATITUDE_DEG: 52.2533932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034100',
        LOCATION_NAME: 'Middleton by Youlgrave',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009400',
        LOCATION_NAME: 'Middleton Cheney',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2721768,
        LOCATION_LATITUDE_DEG: 52.0730157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034200',
        LOCATION_NAME: 'Middleton in Teesdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034300',
        LOCATION_NAME: 'Middleton on Leven',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034400',
        LOCATION_NAME: 'Middleton on Sea',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990085',
        LOCATION_NAME: 'Middleton on the Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010200',
        LOCATION_NAME: 'Middleton on the Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6685757,
        LOCATION_LATITUDE_DEG: 52.2756513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010300',
        LOCATION_NAME: 'Middleton on the Wolds',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5587021,
        LOCATION_LATITUDE_DEG: 53.9333867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009500',
        LOCATION_NAME: 'Middleton One Row',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4518057,
        LOCATION_LATITUDE_DEG: 54.502646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009600',
        LOCATION_NAME: 'Middleton Priors',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5557834,
        LOCATION_LATITUDE_DEG: 52.5087677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009700',
        LOCATION_NAME: 'Middleton Quernhow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4861295,
        LOCATION_LATITUDE_DEG: 54.199918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009800',
        LOCATION_NAME: 'Middleton Scriven',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4701361,
        LOCATION_LATITUDE_DEG: 52.4849709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033900',
        LOCATION_NAME: 'Middleton St George',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI009900',
        LOCATION_NAME: 'Middleton St. George',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4650652,
        LOCATION_LATITUDE_DEG: 54.5114508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010000',
        LOCATION_NAME: 'Middleton Stoney',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2232258,
        LOCATION_LATITUDE_DEG: 51.9069007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010100',
        LOCATION_NAME: 'Middleton Tyas',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6525177,
        LOCATION_LATITUDE_DEG: 54.4458478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010400',
        LOCATION_NAME: 'Middleton-by-Youlgrave',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7073319,
        LOCATION_LATITUDE_DEG: 53.1654237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010500',
        LOCATION_NAME: 'Middleton-in-Teesdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0763,
        LOCATION_LATITUDE_DEG: 54.6228729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010600',
        LOCATION_NAME: 'Middleton-on-Leven',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2784912,
        LOCATION_LATITUDE_DEG: 54.4825462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010700',
        LOCATION_NAME: 'Middleton-on-Sea',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6165091,
        LOCATION_LATITUDE_DEG: 50.7944799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011000',
        LOCATION_NAME: 'Middletown',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8453049,
        LOCATION_LATITUDE_DEG: 54.2951789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010900',
        LOCATION_NAME: 'Middletown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5551735,
        LOCATION_LATITUDE_DEG: 54.4640699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI010800',
        LOCATION_NAME: 'Middletown',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0220862,
        LOCATION_LATITUDE_DEG: 52.7078978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011100',
        LOCATION_NAME: 'Middlewich',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4428743,
        LOCATION_LATITUDE_DEG: 53.1927391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011200',
        LOCATION_NAME: 'Middlewood Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0687365,
        LOCATION_LATITUDE_DEG: 52.2110941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011300',
        LOCATION_NAME: 'Middlezoy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.892177,
        LOCATION_LATITUDE_DEG: 51.0907364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011400',
        LOCATION_NAME: 'Middop',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2915347,
        LOCATION_LATITUDE_DEG: 53.9456086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011500',
        LOCATION_NAME: 'Middridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6113988,
        LOCATION_LATITUDE_DEG: 54.629967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011600',
        LOCATION_NAME: 'Middridge Drift',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6251498,
        LOCATION_LATITUDE_DEG: 54.6255614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011700',
        LOCATION_NAME: 'Midelney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8410895,
        LOCATION_LATITUDE_DEG: 51.0014328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011900',
        LOCATION_NAME: 'Midford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3486215,
        LOCATION_LATITUDE_DEG: 51.3495606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012000',
        LOCATION_NAME: 'Midge Hall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7254834,
        LOCATION_LATITUDE_DEG: 53.7020882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012100',
        LOCATION_NAME: 'Midgehole',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0090102,
        LOCATION_LATITUDE_DEG: 53.7565831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012200',
        LOCATION_NAME: 'Midgeholme',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5615021,
        LOCATION_LATITUDE_DEG: 54.9236089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012300',
        LOCATION_NAME: 'Midgham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8036946,
        LOCATION_LATITUDE_DEG: 50.9099101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012400',
        LOCATION_NAME: 'Midgham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.201231,
        LOCATION_LATITUDE_DEG: 51.4010438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990536',
        LOCATION_NAME: 'Midgley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012500',
        LOCATION_NAME: 'Midgley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9590968,
        LOCATION_LATITUDE_DEG: 53.7337801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012600',
        LOCATION_NAME: 'Midhopestones',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6421989,
        LOCATION_LATITUDE_DEG: 53.4919521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012700',
        LOCATION_NAME: 'Midhurst',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7385072,
        LOCATION_LATITUDE_DEG: 50.9850046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012800',
        LOCATION_NAME: 'Midlem',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7495097,
        LOCATION_LATITUDE_DEG: 55.5382685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013000',
        LOCATION_NAME: 'Midmar',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5323397,
        LOCATION_LATITUDE_DEG: 57.1603236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013100',
        LOCATION_NAME: 'Midsomer Norton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4840672,
        LOCATION_LATITUDE_DEG: 51.2849512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013200',
        LOCATION_NAME: 'Midtown',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6677592,
        LOCATION_LATITUDE_DEG: 57.804023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013300',
        LOCATION_NAME: 'Midville',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0668549,
        LOCATION_LATITUDE_DEG: 53.091595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013400',
        LOCATION_NAME: 'Midway',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5455716,
        LOCATION_LATITUDE_DEG: 52.7822877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013500',
        LOCATION_NAME: 'Migvie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9296628,
        LOCATION_LATITUDE_DEG: 57.1481262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013600',
        LOCATION_NAME: 'Milborne Port',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4611305,
        LOCATION_LATITUDE_DEG: 50.9657242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033800',
        LOCATION_NAME: 'Milborne St Andrew',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013700',
        LOCATION_NAME: 'Milborne St. Andrew',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2799971,
        LOCATION_LATITUDE_DEG: 50.7756007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013800',
        LOCATION_NAME: 'Milborne Wick',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4721156,
        LOCATION_LATITUDE_DEG: 50.9844225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI013900',
        LOCATION_NAME: 'Milborne Wood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3036314,
        LOCATION_LATITUDE_DEG: 50.7783026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014100',
        LOCATION_NAME: 'Milbourne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.080334,
        LOCATION_LATITUDE_DEG: 51.5873744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014000',
        LOCATION_NAME: 'Milbourne',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8160341,
        LOCATION_LATITUDE_DEG: 55.0713124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014200',
        LOCATION_NAME: 'Milburn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5347132,
        LOCATION_LATITUDE_DEG: 54.6575781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014300',
        LOCATION_NAME: 'Milbury Heath',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4845048,
        LOCATION_LATITUDE_DEG: 51.6092877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014400',
        LOCATION_NAME: 'Milcombe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3989709,
        LOCATION_LATITUDE_DEG: 52.008513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014450',
        LOCATION_NAME: 'Milcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7328708,
        LOCATION_LATITUDE_DEG: 52.1705855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014500',
        LOCATION_NAME: 'Milden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8565167,
        LOCATION_LATITUDE_DEG: 52.0813859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014700',
        LOCATION_NAME: 'Mildenhall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6986462,
        LOCATION_LATITUDE_DEG: 51.4251586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014600',
        LOCATION_NAME: 'Mildenhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5112899,
        LOCATION_LATITUDE_DEG: 52.3436161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014800',
        LOCATION_NAME: 'Mile Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6704017,
        LOCATION_LATITUDE_DEG: 52.9791194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI014900',
        LOCATION_NAME: 'Mile Elm',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0140799,
        LOCATION_LATITUDE_DEG: 51.4174607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015100',
        LOCATION_NAME: 'Mile End',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5986127,
        LOCATION_LATITUDE_DEG: 51.803103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI035200',
        LOCATION_NAME: 'Mile End',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.037932,
        LOCATION_LATITUDE_DEG: 51.5249793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015000',
        LOCATION_NAME: 'Mile End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8930874,
        LOCATION_LATITUDE_DEG: 51.9117652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015200',
        LOCATION_NAME: 'Mile Oak',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7284325,
        LOCATION_LATITUDE_DEG: 52.6171665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015300',
        LOCATION_NAME: 'Mileham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8349962,
        LOCATION_LATITUDE_DEG: 52.7373473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034900',
        LOCATION_NAME: 'Miles Platting',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.213409,
        LOCATION_LATITUDE_DEG: 53.4927465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015500',
        LOCATION_NAME: 'Milesmark',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4979928,
        LOCATION_LATITUDE_DEG: 56.0818311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015700',
        LOCATION_NAME: 'Milfield',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1029727,
        LOCATION_LATITUDE_DEG: 55.5983627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016575',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6806698,
        LOCATION_LATITUDE_DEG: 54.3313875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016550',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5153519,
        LOCATION_LATITUDE_DEG: 50.9769606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016200',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3342304,
        LOCATION_LATITUDE_DEG: 52.5120821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016500',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8609148,
        LOCATION_LATITUDE_DEG: 52.7832984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015800',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0448007,
        LOCATION_LATITUDE_DEG: 52.7881931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015900',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4764585,
        LOCATION_LATITUDE_DEG: 53.0019011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016100',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6482649,
        LOCATION_LATITUDE_DEG: 51.1723228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016600',
        LOCATION_NAME: 'Milford Haven',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0279978,
        LOCATION_LATITUDE_DEG: 51.7112168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016700',
        LOCATION_NAME: 'Milford on Sea',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5932747,
        LOCATION_LATITUDE_DEG: 50.7238916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016800',
        LOCATION_NAME: 'Milkhouse Water',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7479293,
        LOCATION_LATITUDE_DEG: 51.3515528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016900',
        LOCATION_NAME: 'Milking Nook',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2507647,
        LOCATION_LATITUDE_DEG: 52.6365544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017000',
        LOCATION_NAME: 'Milkwall',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6039858,
        LOCATION_LATITUDE_DEG: 51.7797049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017100',
        LOCATION_NAME: 'Mill Bank',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9607784,
        LOCATION_LATITUDE_DEG: 53.6862731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017200',
        LOCATION_NAME: 'Mill Brow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1869198,
        LOCATION_LATITUDE_DEG: 54.1515343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990263',
        LOCATION_NAME: 'Mill Brow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0320868,
        LOCATION_LATITUDE_DEG: 53.4039812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017300',
        LOCATION_NAME: 'Mill Common',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.542645,
        LOCATION_LATITUDE_DEG: 52.3790036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017400',
        LOCATION_NAME: 'Mill Corner',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5974227,
        LOCATION_LATITUDE_DEG: 50.9807854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017500',
        LOCATION_NAME: 'Mill End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4894355,
        LOCATION_LATITUDE_DEG: 51.6343642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017600',
        LOCATION_NAME: 'Mill Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3710792,
        LOCATION_LATITUDE_DEG: 51.6845509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI035100',
        LOCATION_NAME: 'Mill Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2453841,
        LOCATION_LATITUDE_DEG: 51.6164732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017700',
        LOCATION_NAME: 'Mill Meece',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2508703,
        LOCATION_LATITUDE_DEG: 52.8928913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017900',
        LOCATION_NAME: 'Milland',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8138412,
        LOCATION_LATITUDE_DEG: 51.0492081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018000',
        LOCATION_NAME: 'Millarston',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4580992,
        LOCATION_LATITUDE_DEG: 55.8394186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018100',
        LOCATION_NAME: 'Millbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1497848,
        LOCATION_LATITUDE_DEG: 54.6236851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018200',
        LOCATION_NAME: 'Millbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1006019,
        LOCATION_LATITUDE_DEG: 54.453065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018300',
        LOCATION_NAME: 'Millbridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1506219,
        LOCATION_LATITUDE_DEG: 50.3750879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018700',
        LOCATION_NAME: 'Millbrook',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8991817,
        LOCATION_LATITUDE_DEG: 54.8726319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018600',
        LOCATION_NAME: 'Millbrook',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2195295,
        LOCATION_LATITUDE_DEG: 50.3460777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018400',
        LOCATION_NAME: 'Millbrook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0349258,
        LOCATION_LATITUDE_DEG: 53.4907565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018500',
        LOCATION_NAME: 'Millbrook',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5229441,
        LOCATION_LATITUDE_DEG: 52.0385985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018800',
        LOCATION_NAME: 'Millendreath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4445526,
        LOCATION_LATITUDE_DEG: 50.3689821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI018900',
        LOCATION_NAME: 'Millers Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7769689,
        LOCATION_LATITUDE_DEG: 53.2547634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019000',
        LOCATION_NAME: 'Millhall',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9066307,
        LOCATION_LATITUDE_DEG: 56.1079393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019100',
        LOCATION_NAME: 'Millhead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7697328,
        LOCATION_LATITUDE_DEG: 54.1349329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019200',
        LOCATION_NAME: 'Millheugh',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9806868,
        LOCATION_LATITUDE_DEG: 55.7374984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019300',
        LOCATION_NAME: 'Millholme',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6669977,
        LOCATION_LATITUDE_DEG: 54.3075422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019400',
        LOCATION_NAME: 'Millhouse',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2682336,
        LOCATION_LATITUDE_DEG: 55.8845327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019500',
        LOCATION_NAME: 'Millhouse Green',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6623814,
        LOCATION_LATITUDE_DEG: 53.5263596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019600',
        LOCATION_NAME: 'Millhousebridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4042811,
        LOCATION_LATITUDE_DEG: 55.1556338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034700',
        LOCATION_NAME: 'Millhouses',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5010045,
        LOCATION_LATITUDE_DEG: 53.3435837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019700',
        LOCATION_NAME: 'Millington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7371998,
        LOCATION_LATITUDE_DEG: 53.9550831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019800',
        LOCATION_NAME: 'Millisle',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.534252,
        LOCATION_LATITUDE_DEG: 54.6113957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI019900',
        LOCATION_NAME: 'Millom',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2685621,
        LOCATION_LATITUDE_DEG: 54.209239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990611',
        LOCATION_NAME: 'Millpool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020000',
        LOCATION_NAME: 'Millpool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6520936,
        LOCATION_LATITUDE_DEG: 50.5034017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020100',
        LOCATION_NAME: 'Millport',
        COUNTY_NAME: 'Isle of Cumbrae',
        POSTCODE: 'KA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9333919,
        LOCATION_LATITUDE_DEG: 55.7513119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020700',
        LOCATION_NAME: 'Millthorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5237717,
        LOCATION_LATITUDE_DEG: 53.2834358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020600',
        LOCATION_NAME: 'Millthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3447657,
        LOCATION_LATITUDE_DEG: 52.8640798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020800',
        LOCATION_NAME: 'Millthrop',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5205897,
        LOCATION_LATITUDE_DEG: 54.3160468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020900',
        LOCATION_NAME: 'Milltimber',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2335401,
        LOCATION_LATITUDE_DEG: 57.104213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021000',
        LOCATION_NAME: 'Milltown',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.448959,
        LOCATION_LATITUDE_DEG: 54.1498668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021200',
        LOCATION_NAME: 'Milltown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6691592,
        LOCATION_LATITUDE_DEG: 50.3884927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021300',
        LOCATION_NAME: 'Milltown',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0706955,
        LOCATION_LATITUDE_DEG: 58.5634706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021100',
        LOCATION_NAME: 'Milltown',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4692055,
        LOCATION_LATITUDE_DEG: 53.1508188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI990780',
        LOCATION_NAME: 'Milltown Blaney',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021500',
        LOCATION_NAME: 'Milltown of Edinville',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2290116,
        LOCATION_LATITUDE_DEG: 57.4459464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI035300',
        LOCATION_NAME: 'Millwall',
        COUNTY_NAME: 'London',
        POSTCODE: 'E14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0124492,
        LOCATION_LATITUDE_DEG: 51.4953297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021700',
        LOCATION_NAME: 'Milnathort',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4185177,
        LOCATION_LATITUDE_DEG: 56.2268425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021800',
        LOCATION_NAME: 'Milngavie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3099923,
        LOCATION_LATITUDE_DEG: 55.9418206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021900',
        LOCATION_NAME: 'Milnrow',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1133587,
        LOCATION_LATITUDE_DEG: 53.6109679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022000',
        LOCATION_NAME: 'Milnsbridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8361715,
        LOCATION_LATITUDE_DEG: 53.6410685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022200',
        LOCATION_NAME: 'Milnthorpe',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7717294,
        LOCATION_LATITUDE_DEG: 54.2266408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022100',
        LOCATION_NAME: 'Milnthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5089122,
        LOCATION_LATITUDE_DEG: 53.6509696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022300',
        LOCATION_NAME: 'Milo',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0369273,
        LOCATION_LATITUDE_DEG: 51.8386208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022400',
        LOCATION_NAME: 'Milson',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5288437,
        LOCATION_LATITUDE_DEG: 52.3524536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022500',
        LOCATION_NAME: 'Milstead',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.731078,
        LOCATION_LATITUDE_DEG: 51.2957076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022600',
        LOCATION_NAME: 'Milston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7676651,
        LOCATION_LATITUDE_DEG: 51.2059362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023200',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8394329,
        LOCATION_LATITUDE_DEG: 51.6911121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023400',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5176125,
        LOCATION_LATITUDE_DEG: 55.936322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022800',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0734851,
        LOCATION_LATITUDE_DEG: 57.7433971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023700',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1260526,
        LOCATION_LATITUDE_DEG: 58.4428595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023100',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9440756,
        LOCATION_LATITUDE_DEG: 51.3533619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022700',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7567721,
        LOCATION_LATITUDE_DEG: 50.9912263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023600',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6927751,
        LOCATION_LATITUDE_DEG: 54.9375094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023800',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6588543,
        LOCATION_LATITUDE_DEG: 51.2229457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023000',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5245077,
        LOCATION_LATITUDE_DEG: 52.8360858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023500',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3425915,
        LOCATION_LATITUDE_DEG: 52.0108105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI022900',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2977104,
        LOCATION_LATITUDE_DEG: 51.6272689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023900',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9327611,
        LOCATION_LATITUDE_DEG: 53.2496198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024000',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3162142,
        LOCATION_LATITUDE_DEG: 52.5783456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI023300',
        LOCATION_NAME: 'Milton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1631107,
        LOCATION_LATITUDE_DEG: 52.2431131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024100',
        LOCATION_NAME: 'Milton Abbas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2748138,
        LOCATION_LATITUDE_DEG: 50.8157066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024200',
        LOCATION_NAME: 'Milton Abbot',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2462299,
        LOCATION_LATITUDE_DEG: 50.5894033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024300',
        LOCATION_NAME: 'Milton Bridge',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1995172,
        LOCATION_LATITUDE_DEG: 55.8492045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024400',
        LOCATION_NAME: 'Milton Bryan',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.588642,
        LOCATION_LATITUDE_DEG: 51.9660979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024500',
        LOCATION_NAME: 'Milton Clevedon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4770394,
        LOCATION_LATITUDE_DEG: 51.1324404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024600',
        LOCATION_NAME: 'Milton Combe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1299647,
        LOCATION_LATITUDE_DEG: 50.4746957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024700',
        LOCATION_NAME: 'Milton Common',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0530025,
        LOCATION_LATITUDE_DEG: 51.7246748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024800',
        LOCATION_NAME: 'Milton Damerel',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2969989,
        LOCATION_LATITUDE_DEG: 50.8735312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI024900',
        LOCATION_NAME: 'Milton Ernest',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5076558,
        LOCATION_LATITUDE_DEG: 52.1936132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025000',
        LOCATION_NAME: 'Milton Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8047034,
        LOCATION_LATITUDE_DEG: 53.1235349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025100',
        LOCATION_NAME: 'Milton Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3093036,
        LOCATION_LATITUDE_DEG: 51.6059716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025200',
        LOCATION_NAME: 'Milton Keynes',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7578161,
        LOCATION_LATITUDE_DEG: 52.0404007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025300',
        LOCATION_NAME: 'Milton Keynes Village',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7020522,
        LOCATION_LATITUDE_DEG: 52.0420027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025400',
        LOCATION_NAME: 'Milton Lilbourne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7269511,
        LOCATION_LATITUDE_DEG: 51.341245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025500',
        LOCATION_NAME: 'Milton Malsor',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.922206,
        LOCATION_LATITUDE_DEG: 52.1926163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025600',
        LOCATION_NAME: 'Milton Morenish',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2569874,
        LOCATION_LATITUDE_DEG: 56.4923801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026000',
        LOCATION_NAME: 'Milton of Balgonie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0948107,
        LOCATION_LATITUDE_DEG: 56.1936382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026100',
        LOCATION_NAME: 'Milton of Campsie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1598743,
        LOCATION_LATITUDE_DEG: 55.9648219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026200',
        LOCATION_NAME: 'Milton of Culloden',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.151211,
        LOCATION_LATITUDE_DEG: 57.4930776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025700',
        LOCATION_NAME: 'Milton Of Dalcapon',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.668471,
        LOCATION_LATITUDE_DEG: 56.6754877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026300',
        LOCATION_NAME: 'Milton on Stour',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.28372,
        LOCATION_LATITUDE_DEG: 51.0551255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025800',
        LOCATION_NAME: 'Milton Regis',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7245499,
        LOCATION_LATITUDE_DEG: 51.3463128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI025900',
        LOCATION_NAME: 'Milton Street',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1769968,
        LOCATION_LATITUDE_DEG: 50.8154768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034000',
        LOCATION_NAME: 'Milton under Wychwood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026500',
        LOCATION_NAME: 'Miltonduff',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3738898,
        LOCATION_LATITUDE_DEG: 57.6260838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026400',
        LOCATION_NAME: 'Milton-under-Wychwood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6155339,
        LOCATION_LATITUDE_DEG: 51.8625003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI035000',
        LOCATION_NAME: 'Milvain',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6527627,
        LOCATION_LATITUDE_DEG: 54.9765814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027000',
        LOCATION_NAME: 'Milverton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2518706,
        LOCATION_LATITUDE_DEG: 51.0240329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027100',
        LOCATION_NAME: 'Milwich',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0416183,
        LOCATION_LATITUDE_DEG: 52.8876018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027200',
        LOCATION_NAME: 'Milwich Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0268416,
        LOCATION_LATITUDE_DEG: 52.908203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027300',
        LOCATION_NAME: 'Milwr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2128559,
        LOCATION_LATITUDE_DEG: 53.2636548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027400',
        LOCATION_NAME: 'Mimbridge',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5791515,
        LOCATION_LATITUDE_DEG: 51.3410308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027700',
        LOCATION_NAME: 'Minard',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2494746,
        LOCATION_LATITUDE_DEG: 56.1176492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027800',
        LOCATION_NAME: 'Minchington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0477328,
        LOCATION_LATITUDE_DEG: 50.9315146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027900',
        LOCATION_NAME: 'Minchinhampton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1855549,
        LOCATION_LATITUDE_DEG: 51.704191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028000',
        LOCATION_NAME: 'Mindrum',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2512204,
        LOCATION_LATITUDE_DEG: 55.5899621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028100',
        LOCATION_NAME: 'Minehead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.475338,
        LOCATION_LATITUDE_DEG: 51.2057603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028200',
        LOCATION_NAME: 'Minera',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.086959,
        LOCATION_LATITUDE_DEG: 53.0581251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028300',
        LOCATION_NAME: 'Minety',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.957219,
        LOCATION_LATITUDE_DEG: 51.6115745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028500',
        LOCATION_NAME: 'Minffordd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1300675,
        LOCATION_LATITUDE_DEG: 53.2142602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028400',
        LOCATION_NAME: 'Minffordd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0804182,
        LOCATION_LATITUDE_DEG: 52.9261246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028600',
        LOCATION_NAME: 'Miningsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0215009,
        LOCATION_LATITUDE_DEG: 53.1575034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028700',
        LOCATION_NAME: 'Minions',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.452772,
        LOCATION_LATITUDE_DEG: 50.5139994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028800',
        LOCATION_NAME: 'Minish',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1844191,
        LOCATION_LATITUDE_DEG: 57.6161199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI028900',
        LOCATION_NAME: 'Minishant',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6409555,
        LOCATION_LATITUDE_DEG: 55.3926745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029000',
        LOCATION_NAME: 'Minn Bank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3633756,
        LOCATION_LATITUDE_DEG: 52.9625096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029100',
        LOCATION_NAME: 'Minnigaff',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4819191,
        LOCATION_LATITUDE_DEG: 54.9669293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI034800',
        LOCATION_NAME: 'Minnis Bay',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0752783,
        LOCATION_LATITUDE_DEG: 51.5125664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI035400',
        LOCATION_NAME: 'Minories',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029200',
        LOCATION_NAME: 'Minshull Vernon',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4805763,
        LOCATION_LATITUDE_DEG: 53.1360275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029300',
        LOCATION_NAME: 'Minskip',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4076061,
        LOCATION_LATITUDE_DEG: 54.0743096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029400',
        LOCATION_NAME: 'Minstead',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6003764,
        LOCATION_LATITUDE_DEG: 50.8982033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029500',
        LOCATION_NAME: 'Minsted',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7753932,
        LOCATION_LATITUDE_DEG: 50.9818985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029600',
        LOCATION_NAME: 'Minster',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6752616,
        LOCATION_LATITUDE_DEG: 50.6742144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029900',
        LOCATION_NAME: 'Minster',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3144082,
        LOCATION_LATITUDE_DEG: 51.3341266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029800',
        LOCATION_NAME: 'Minster Lovell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5440179,
        LOCATION_LATITUDE_DEG: 51.7965938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI029700',
        LOCATION_NAME: 'Minster on sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8171185,
        LOCATION_LATITUDE_DEG: 51.4211196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030000',
        LOCATION_NAME: 'Minsteracres',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9632935,
        LOCATION_LATITUDE_DEG: 54.8942983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030100',
        LOCATION_NAME: 'Minsterley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9232088,
        LOCATION_LATITUDE_DEG: 52.6394871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030200',
        LOCATION_NAME: 'Minsterworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3273501,
        LOCATION_LATITUDE_DEG: 51.8512083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030300',
        LOCATION_NAME: 'Minterne Magna',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4820479,
        LOCATION_LATITUDE_DEG: 50.8372127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030400',
        LOCATION_NAME: 'Minterne Parva',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4743519,
        LOCATION_LATITUDE_DEG: 50.8290061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030500',
        LOCATION_NAME: 'Minting',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2190187,
        LOCATION_LATITUDE_DEG: 53.2449134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030600',
        LOCATION_NAME: 'Mintlaw',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9992485,
        LOCATION_LATITUDE_DEG: 57.5240569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030700',
        LOCATION_NAME: 'Mintlaw Station',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0250844,
        LOCATION_LATITUDE_DEG: 57.5288517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030800',
        LOCATION_NAME: 'Minto',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6876409,
        LOCATION_LATITUDE_DEG: 55.4746639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI030900',
        LOCATION_NAME: 'Minton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8389633,
        LOCATION_LATITUDE_DEG: 52.5103717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031000',
        LOCATION_NAME: 'Minworth',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7653473,
        LOCATION_LATITUDE_DEG: 52.5287661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031100',
        LOCATION_NAME: 'Mirehouse',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5773274,
        LOCATION_LATITUDE_DEG: 54.5208813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031200',
        LOCATION_NAME: 'Mirfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6959524,
        LOCATION_LATITUDE_DEG: 53.6752683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031300',
        LOCATION_NAME: 'Miserden',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0908482,
        LOCATION_LATITUDE_DEG: 51.7778941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031400',
        LOCATION_NAME: 'Miskin',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3742374,
        LOCATION_LATITUDE_DEG: 51.518384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031500',
        LOCATION_NAME: 'Miskin',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3712152,
        LOCATION_LATITUDE_DEG: 51.6710027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031600',
        LOCATION_NAME: 'Mislingford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1592217,
        LOCATION_LATITUDE_DEG: 50.912399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031700',
        LOCATION_NAME: 'Misson',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9597532,
        LOCATION_LATITUDE_DEG: 53.4460407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031800',
        LOCATION_NAME: 'Misson Springs',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9474115,
        LOCATION_LATITUDE_DEG: 53.4634451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032100',
        LOCATION_NAME: 'Misterton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7986897,
        LOCATION_LATITUDE_DEG: 50.8662155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI031900',
        LOCATION_NAME: 'Misterton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1865684,
        LOCATION_LATITUDE_DEG: 52.4492477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032000',
        LOCATION_NAME: 'Misterton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8479636,
        LOCATION_LATITUDE_DEG: 53.4441429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032200',
        LOCATION_NAME: 'Mistley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0841745,
        LOCATION_LATITUDE_DEG: 51.9434645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032300',
        LOCATION_NAME: 'Miswell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6757452,
        LOCATION_LATITUDE_DEG: 51.7983747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032400',
        LOCATION_NAME: 'Mitcham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1652719,
        LOCATION_LATITUDE_DEG: 51.4021376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032500',
        LOCATION_NAME: 'Mitcham Junction',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1557172,
        LOCATION_LATITUDE_DEG: 51.3837303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032600',
        LOCATION_NAME: 'Mitchel Troy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7348526,
        LOCATION_LATITUDE_DEG: 51.7896065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032700',
        LOCATION_NAME: 'Mitchel Troy Common',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.736306,
        LOCATION_LATITUDE_DEG: 51.7818012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032800',
        LOCATION_NAME: 'Mitcheldean',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4880666,
        LOCATION_LATITUDE_DEG: 51.8642113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI032900',
        LOCATION_NAME: 'Mitchell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0063632,
        LOCATION_LATITUDE_DEG: 50.3520918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033200',
        LOCATION_NAME: 'Mitford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7299481,
        LOCATION_LATITUDE_DEG: 55.1677181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033300',
        LOCATION_NAME: 'Mithian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1683963,
        LOCATION_LATITUDE_DEG: 50.3113849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033400',
        LOCATION_NAME: 'Mithian Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1693255,
        LOCATION_LATITUDE_DEG: 50.3109907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033500',
        LOCATION_NAME: 'Mixbury',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1128411,
        LOCATION_LATITUDE_DEG: 52.0011036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033600',
        LOCATION_NAME: 'Mixenden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9064064,
        LOCATION_LATITUDE_DEG: 53.7507849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033700',
        LOCATION_NAME: 'Mixtow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6303625,
        LOCATION_LATITUDE_DEG: 50.3459892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000200',
        LOCATION_NAME: 'Moat',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9214919,
        LOCATION_LATITUDE_DEG: 55.0572249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000500',
        LOCATION_NAME: 'Moathill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0144172,
        LOCATION_LATITUDE_DEG: 56.3211509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000600',
        LOCATION_NAME: 'Mobberley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3260265,
        LOCATION_LATITUDE_DEG: 53.3131489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000700',
        LOCATION_NAME: 'Moccas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9372868,
        LOCATION_LATITUDE_DEG: 52.0790355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000800',
        LOCATION_NAME: 'Mochdre',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7616103,
        LOCATION_LATITUDE_DEG: 53.2907588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000900',
        LOCATION_NAME: 'Mochdre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3596565,
        LOCATION_LATITUDE_DEG: 52.4892776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001000',
        LOCATION_NAME: 'Mochrum',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5713582,
        LOCATION_LATITUDE_DEG: 54.7847124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001100',
        LOCATION_NAME: 'Mockbeggar',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7722041,
        LOCATION_LATITUDE_DEG: 50.8829085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001200',
        LOCATION_NAME: 'Mockerkin',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4078644,
        LOCATION_LATITUDE_DEG: 54.5954854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001400',
        LOCATION_NAME: 'Mocktree',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8496102,
        LOCATION_LATITUDE_DEG: 52.3776649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001500',
        LOCATION_NAME: 'Modbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8869319,
        LOCATION_LATITUDE_DEG: 50.3486778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001600',
        LOCATION_NAME: 'Moddershall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1097979,
        LOCATION_LATITUDE_DEG: 52.9287073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001800',
        LOCATION_NAME: 'Moditonham',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2277328,
        LOCATION_LATITUDE_DEG: 50.4314859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002000',
        LOCATION_NAME: 'Modrydd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4488917,
        LOCATION_LATITUDE_DEG: 51.9156256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002300',
        LOCATION_NAME: 'Moelfre',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2334543,
        LOCATION_LATITUDE_DEG: 53.354571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002200',
        LOCATION_NAME: 'Moelfre',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5774487,
        LOCATION_LATITUDE_DEG: 53.2474573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002100',
        LOCATION_NAME: 'Moelfre',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2155281,
        LOCATION_LATITUDE_DEG: 52.8465133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002400',
        LOCATION_NAME: 'Moelygarth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1865604,
        LOCATION_LATITUDE_DEG: 52.6776929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002500',
        LOCATION_NAME: 'Moffat',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4435047,
        LOCATION_LATITUDE_DEG: 55.3335576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002600',
        LOCATION_NAME: 'Mogador',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2229586,
        LOCATION_LATITUDE_DEG: 51.2670238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002800',
        LOCATION_NAME: 'Moggerhanger',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3317021,
        LOCATION_LATITUDE_DEG: 52.1274818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003000',
        LOCATION_NAME: 'Mohope',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3581337,
        LOCATION_LATITUDE_DEG: 54.847194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003100',
        LOCATION_NAME: 'Moigne Combe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3285501,
        LOCATION_LATITUDE_DEG: 50.6864902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003200',
        LOCATION_NAME: 'Moira',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2375351,
        LOCATION_LATITUDE_DEG: 54.4819965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003300',
        LOCATION_NAME: 'Moira',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5332059,
        LOCATION_LATITUDE_DEG: 52.7364773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003500',
        LOCATION_NAME: 'Molash',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9057251,
        LOCATION_LATITUDE_DEG: 51.2297027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003600',
        LOCATION_NAME: 'Mold',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1409161,
        LOCATION_LATITUDE_DEG: 53.1674394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003700',
        LOCATION_NAME: 'Moldgreen',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7629564,
        LOCATION_LATITUDE_DEG: 53.6435708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003800',
        LOCATION_NAME: 'Molesden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7659618,
        LOCATION_LATITUDE_DEG: 55.1519215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003900',
        LOCATION_NAME: 'Molesey',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3484347,
        LOCATION_LATITUDE_DEG: 51.3995383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004000',
        LOCATION_NAME: 'Molesworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4274934,
        LOCATION_LATITUDE_DEG: 52.3685305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004100',
        LOCATION_NAME: 'Molinnis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7866806,
        LOCATION_LATITUDE_DEG: 50.3989951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004200',
        LOCATION_NAME: 'Molland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7006847,
        LOCATION_LATITUDE_DEG: 51.04064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004400',
        LOCATION_NAME: 'Mollington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9215033,
        LOCATION_LATITUDE_DEG: 53.225546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004300',
        LOCATION_NAME: 'Mollington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3583095,
        LOCATION_LATITUDE_DEG: 52.1231145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990159',
        LOCATION_NAME: 'Mollinnis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7875457,
        LOCATION_LATITUDE_DEG: 50.4010255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004500',
        LOCATION_NAME: 'Mollinsburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0500254,
        LOCATION_LATITUDE_DEG: 55.9212193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005800',
        LOCATION_NAME: 'Monaughty',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1165337,
        LOCATION_LATITUDE_DEG: 52.3085558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006100',
        LOCATION_NAME: 'Mondaytown',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9701338,
        LOCATION_LATITUDE_DEG: 52.6567886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006200',
        LOCATION_NAME: 'Monea',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7490769,
        LOCATION_LATITUDE_DEG: 54.3998968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006400',
        LOCATION_NAME: 'Monewden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2757087,
        LOCATION_LATITUDE_DEG: 52.1786838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007100',
        LOCATION_NAME: 'Moneymore',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6720632,
        LOCATION_LATITUDE_DEG: 54.6936281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007200',
        LOCATION_NAME: 'Moneyneany',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8322783,
        LOCATION_LATITUDE_DEG: 54.8166376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007300',
        LOCATION_NAME: 'Moneyrea',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.832194,
        LOCATION_LATITUDE_DEG: 54.5399971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990497',
        LOCATION_NAME: 'moneyreagh',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007400',
        LOCATION_NAME: 'Mongewell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1152074,
        LOCATION_LATITUDE_DEG: 51.5828621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007500',
        LOCATION_NAME: 'Moniaive',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9190059,
        LOCATION_LATITUDE_DEG: 55.1973443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007600',
        LOCATION_NAME: 'Monifieth',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8205831,
        LOCATION_LATITUDE_DEG: 56.4809651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007700',
        LOCATION_NAME: 'Monikie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8146696,
        LOCATION_LATITUDE_DEG: 56.5376657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007900',
        LOCATION_NAME: 'Monimail',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1291386,
        LOCATION_LATITUDE_DEG: 56.3147489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008100',
        LOCATION_NAME: 'Monk Bretton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.45092,
        LOCATION_LATITUDE_DEG: 53.5643563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008200',
        LOCATION_NAME: 'Monk Fryston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.230641,
        LOCATION_LATITUDE_DEG: 53.7611712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008300',
        LOCATION_NAME: 'Monk Hesleden',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2931497,
        LOCATION_LATITUDE_DEG: 54.7286712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008400',
        LOCATION_NAME: 'Monk Sherborne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1261323,
        LOCATION_LATITUDE_DEG: 51.3002364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008500',
        LOCATION_NAME: 'Monk Soham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2397051,
        LOCATION_LATITUDE_DEG: 52.2394957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008600',
        LOCATION_NAME: 'Monkcastle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8900013,
        LOCATION_LATITUDE_DEG: 54.8061005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008650',
        LOCATION_NAME: 'Monken Hadley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'EN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.206809,
        LOCATION_LATITUDE_DEG: 51.6623496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008700',
        LOCATION_NAME: 'Monkhide',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5617624,
        LOCATION_LATITUDE_DEG: 52.0912332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008800',
        LOCATION_NAME: 'Monkhill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0243964,
        LOCATION_LATITUDE_DEG: 54.9181084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008900',
        LOCATION_NAME: 'Monkhopton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.551496,
        LOCATION_LATITUDE_DEG: 52.5370736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009000',
        LOCATION_NAME: 'Monkland',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7910517,
        LOCATION_LATITUDE_DEG: 52.2141472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009100',
        LOCATION_NAME: 'Monkland Common',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7896265,
        LOCATION_LATITUDE_DEG: 52.2105421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009200',
        LOCATION_NAME: 'Monkleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1988109,
        LOCATION_LATITUDE_DEG: 50.966243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009300',
        LOCATION_NAME: 'Monknash',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5527959,
        LOCATION_LATITUDE_DEG: 51.4238759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009400',
        LOCATION_NAME: 'Monkokehampton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0119024,
        LOCATION_LATITUDE_DEG: 50.8307282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009500',
        LOCATION_NAME: 'Monks Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2802308,
        LOCATION_LATITUDE_DEG: 50.5216012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009600',
        LOCATION_NAME: 'Monks Eleigh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8701304,
        LOCATION_LATITUDE_DEG: 52.0912816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009700',
        LOCATION_NAME: 'Monks Eleigh Tye',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.852937,
        LOCATION_LATITUDE_DEG: 52.0991825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009800',
        LOCATION_NAME: 'Monks Gate',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2785451,
        LOCATION_LATITUDE_DEG: 51.0251988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO009900',
        LOCATION_NAME: 'Monks Horton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0267816,
        LOCATION_LATITUDE_DEG: 51.1196913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010000',
        LOCATION_NAME: 'Monks Kirby',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3176041,
        LOCATION_LATITUDE_DEG: 52.443252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045900',
        LOCATION_NAME: 'Monks Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5866345,
        LOCATION_LATITUDE_DEG: 51.4986992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010100',
        LOCATION_NAME: 'Monks Risborough',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8283022,
        LOCATION_LATITUDE_DEG: 51.7342765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010200',
        LOCATION_NAME: 'Monkseaton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4779486,
        LOCATION_LATITUDE_DEG: 55.0439009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010300',
        LOCATION_NAME: 'Monksilver',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3228228,
        LOCATION_LATITUDE_DEG: 51.1283511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010400',
        LOCATION_NAME: 'Monksthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1630289,
        LOCATION_LATITUDE_DEG: 53.1685997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010500',
        LOCATION_NAME: 'Monkston',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6987446,
        LOCATION_LATITUDE_DEG: 52.0388999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990449',
        LOCATION_NAME: 'Monkston Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1709981,
        LOCATION_LATITUDE_DEG: 52.0305221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010600',
        LOCATION_NAME: 'Monkstone',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6962431,
        LOCATION_LATITUDE_DEG: 51.6950188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010900',
        LOCATION_NAME: 'Monkswood',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9523327,
        LOCATION_LATITUDE_DEG: 51.7181032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011100',
        LOCATION_NAME: 'Monkton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9293657,
        LOCATION_LATITUDE_DEG: 51.6736199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011000',
        LOCATION_NAME: 'Monkton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6015639,
        LOCATION_LATITUDE_DEG: 55.5163837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011200',
        LOCATION_NAME: 'Monkton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1494633,
        LOCATION_LATITUDE_DEG: 50.8230133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011300',
        LOCATION_NAME: 'Monkton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2814823,
        LOCATION_LATITUDE_DEG: 51.3388059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011400',
        LOCATION_NAME: 'Monkton Combe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3263668,
        LOCATION_LATITUDE_DEG: 51.3562614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011500',
        LOCATION_NAME: 'Monkton Deverill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2065679,
        LOCATION_LATITUDE_DEG: 51.1359378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011600',
        LOCATION_NAME: 'Monkton Farleigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2774187,
        LOCATION_LATITUDE_DEG: 51.3872596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011700',
        LOCATION_NAME: 'Monkton Heathfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0625295,
        LOCATION_LATITUDE_DEG: 51.0363315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011800',
        LOCATION_NAME: 'Monkton Park',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.105598,
        LOCATION_LATITUDE_DEG: 51.4572602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO011900',
        LOCATION_NAME: 'Monkton Village',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4682717,
        LOCATION_LATITUDE_DEG: 54.9673857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012000',
        LOCATION_NAME: 'Monkton Wyld',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9334938,
        LOCATION_LATITUDE_DEG: 50.76381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012100',
        LOCATION_NAME: 'Monktonhall',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0596485,
        LOCATION_LATITUDE_DEG: 55.9309084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012200',
        LOCATION_NAME: 'Monkwearmouth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3899678,
        LOCATION_LATITUDE_DEG: 54.918387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012400',
        LOCATION_NAME: 'Monkwood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8101829,
        LOCATION_LATITUDE_DEG: 50.7831062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012300',
        LOCATION_NAME: 'Monkwood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0341763,
        LOCATION_LATITUDE_DEG: 51.0736123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012500',
        LOCATION_NAME: 'Monmore Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1040159,
        LOCATION_LATITUDE_DEG: 52.576371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012600',
        LOCATION_NAME: 'Monmouth',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7115834,
        LOCATION_LATITUDE_DEG: 51.8138038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012700',
        LOCATION_NAME: 'Monnington on Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9157992,
        LOCATION_LATITUDE_DEG: 52.0866317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012800',
        LOCATION_NAME: 'Monreith',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5489866,
        LOCATION_LATITUDE_DEG: 54.7372111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013000',
        LOCATION_NAME: 'Monsal Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7302049,
        LOCATION_LATITUDE_DEG: 53.2441306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013100',
        LOCATION_NAME: 'Montacute',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7153759,
        LOCATION_LATITUDE_DEG: 50.9495236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044500',
        LOCATION_NAME: 'Montague Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6455505,
        LOCATION_LATITUDE_DEG: 54.998885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013200',
        LOCATION_NAME: 'Montford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8599297,
        LOCATION_LATITUDE_DEG: 52.7272925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013300',
        LOCATION_NAME: 'Montford Bridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8424923,
        LOCATION_LATITUDE_DEG: 52.7330999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013400',
        LOCATION_NAME: 'Montgarrie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.70328,
        LOCATION_LATITUDE_DEG: 57.2485343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013500',
        LOCATION_NAME: 'Montgomery',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1463398,
        LOCATION_LATITUDE_DEG: 52.5612832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013600',
        LOCATION_NAME: 'Montgreenan',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6334878,
        LOCATION_LATITUDE_DEG: 55.6611018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045800',
        LOCATION_NAME: 'Montpelier',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5877143,
        LOCATION_LATITUDE_DEG: 51.4683887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013800',
        LOCATION_NAME: 'Montrave',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0016542,
        LOCATION_LATITUDE_DEG: 56.2468429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013900',
        LOCATION_NAME: 'Montrose',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4657236,
        LOCATION_LATITUDE_DEG: 56.7093774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014000',
        LOCATION_NAME: 'Monument Hill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9612938,
        LOCATION_LATITUDE_DEG: 51.3372493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014100',
        LOCATION_NAME: 'Monxton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5516036,
        LOCATION_LATITUDE_DEG: 51.1974298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014200',
        LOCATION_NAME: 'Monyash',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7757351,
        LOCATION_LATITUDE_DEG: 53.1954277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014300',
        LOCATION_NAME: 'Monymusk',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.522619,
        LOCATION_LATITUDE_DEG: 57.2272337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014400',
        LOCATION_NAME: 'Monzie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8174636,
        LOCATION_LATITUDE_DEG: 56.4042676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014500',
        LOCATION_NAME: 'Moodiesburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.090017,
        LOCATION_LATITUDE_DEG: 55.9124218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014600',
        LOCATION_NAME: 'Moolham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9049877,
        LOCATION_LATITUDE_DEG: 50.9164248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015000',
        LOCATION_NAME: 'Moonzie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0671987,
        LOCATION_LATITUDE_DEG: 56.3466497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015100',
        LOCATION_NAME: 'Moor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8114808,
        LOCATION_LATITUDE_DEG: 50.9423211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044200',
        LOCATION_NAME: 'Moor Allerton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4855601,
        LOCATION_LATITUDE_DEG: 53.8748009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015300',
        LOCATION_NAME: 'Moor Crichel',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0094244,
        LOCATION_LATITUDE_DEG: 50.8765112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045500',
        LOCATION_NAME: 'Moor Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8929051,
        LOCATION_LATITUDE_DEG: 52.4467994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015400',
        LOCATION_NAME: 'Moor Monkton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2216974,
        LOCATION_LATITUDE_DEG: 54.0056989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990239',
        LOCATION_NAME: 'Moor Park',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045700',
        LOCATION_NAME: 'Moor Pool',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9567648,
        LOCATION_LATITUDE_DEG: 52.4646872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015500',
        LOCATION_NAME: 'Moor Row',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.535995,
        LOCATION_LATITUDE_DEG: 54.514375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015600',
        LOCATION_NAME: 'Moor Row',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2307475,
        LOCATION_LATITUDE_DEG: 54.831508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015700',
        LOCATION_NAME: 'Moorby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0665372,
        LOCATION_LATITUDE_DEG: 53.1572991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015800',
        LOCATION_NAME: 'Moore',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6306239,
        LOCATION_LATITUDE_DEG: 53.3541531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016000',
        LOCATION_NAME: 'Moorend',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6545816,
        LOCATION_LATITUDE_DEG: 53.7004788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016100',
        LOCATION_NAME: 'Moorends',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9498098,
        LOCATION_LATITUDE_DEG: 53.6285555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016300',
        LOCATION_NAME: 'Moorfields',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1489154,
        LOCATION_LATITUDE_DEG: 54.8166246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016400',
        LOCATION_NAME: 'Moorgate',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7913782,
        LOCATION_LATITUDE_DEG: 54.047421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016500',
        LOCATION_NAME: 'Moorhampton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.891133,
        LOCATION_LATITUDE_DEG: 52.1160352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016600',
        LOCATION_NAME: 'Moorhaven',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8845962,
        LOCATION_LATITUDE_DEG: 50.3592761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016700',
        LOCATION_NAME: 'Moorhead',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4703005,
        LOCATION_LATITUDE_DEG: 52.7305925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016800',
        LOCATION_NAME: 'Moorhouse',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0406609,
        LOCATION_LATITUDE_DEG: 54.9014056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017000',
        LOCATION_NAME: 'Moorhouse',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.265733,
        LOCATION_LATITUDE_DEG: 53.5860616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016900',
        LOCATION_NAME: 'Moorhouse',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.873467,
        LOCATION_LATITUDE_DEG: 53.1912122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017100',
        LOCATION_NAME: 'Moorlake',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6839639,
        LOCATION_LATITUDE_DEG: 50.7773159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017200',
        LOCATION_NAME: 'Moorland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9471478,
        LOCATION_LATITUDE_DEG: 51.0839367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017300',
        LOCATION_NAME: 'Moorlands',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8764083,
        LOCATION_LATITUDE_DEG: 57.2366724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017400',
        LOCATION_NAME: 'Moorlinch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8576369,
        LOCATION_LATITUDE_DEG: 51.1257451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017500',
        LOCATION_NAME: 'Moorsholm',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9347787,
        LOCATION_LATITUDE_DEG: 54.5192408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017600',
        LOCATION_NAME: 'Moorshop',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0955199,
        LOCATION_LATITUDE_DEG: 50.5242011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017700',
        LOCATION_NAME: 'Moorside',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2863246,
        LOCATION_LATITUDE_DEG: 50.9614181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017800',
        LOCATION_NAME: 'Moorside',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8699476,
        LOCATION_LATITUDE_DEG: 54.8376853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO017900',
        LOCATION_NAME: 'Moorside',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7353877,
        LOCATION_LATITUDE_DEG: 53.7192742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018000',
        LOCATION_NAME: 'Moorside Edge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8985151,
        LOCATION_LATITUDE_DEG: 53.6330742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018100',
        LOCATION_NAME: 'Moorswater',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.484749,
        LOCATION_LATITUDE_DEG: 50.4509989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018200',
        LOCATION_NAME: 'Moorthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3048122,
        LOCATION_LATITUDE_DEG: 53.5946643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990651',
        LOCATION_NAME: 'Moortown',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018400',
        LOCATION_NAME: 'Moortown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0795298,
        LOCATION_LATITUDE_DEG: 50.5465979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044300',
        LOCATION_NAME: 'Moortown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5339728,
        LOCATION_LATITUDE_DEG: 53.845236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018300',
        LOCATION_NAME: 'Moortown',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3847086,
        LOCATION_LATITUDE_DEG: 53.4777326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018500',
        LOCATION_NAME: 'Moota',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3007359,
        LOCATION_LATITUDE_DEG: 54.7219926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018600',
        LOCATION_NAME: 'Mop End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6630535,
        LOCATION_LATITUDE_DEG: 51.6619643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018700',
        LOCATION_NAME: 'Morar',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8157599,
        LOCATION_LATITUDE_DEG: 56.9675385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO018800',
        LOCATION_NAME: 'Morborne',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3194058,
        LOCATION_LATITUDE_DEG: 52.5095398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990248',
        LOCATION_NAME: 'Morchard Bishop',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7483936,
        LOCATION_LATITUDE_DEG: 50.8566787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019000',
        LOCATION_NAME: 'Morcombelake',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8495146,
        LOCATION_LATITUDE_DEG: 50.7427048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990136',
        LOCATION_NAME: 'Morcott',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6370388,
        LOCATION_LATITUDE_DEG: 52.5984602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019100',
        LOCATION_NAME: 'Morcott',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6357194,
        LOCATION_LATITUDE_DEG: 52.5962511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019200',
        LOCATION_NAME: 'Morda',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0571127,
        LOCATION_LATITUDE_DEG: 52.842608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019300',
        LOCATION_NAME: 'Morden',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1952318,
        LOCATION_LATITUDE_DEG: 51.3891304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019400',
        LOCATION_NAME: 'Morden Park Corner',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.131821,
        LOCATION_LATITUDE_DEG: 50.7426937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019500',
        LOCATION_NAME: 'Mordiford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6243693,
        LOCATION_LATITUDE_DEG: 52.0324268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019600',
        LOCATION_NAME: 'Mordon',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4895556,
        LOCATION_LATITUDE_DEG: 54.6322651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019700',
        LOCATION_NAME: 'More',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9678514,
        LOCATION_LATITUDE_DEG: 52.5171743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019800',
        LOCATION_NAME: 'Morebath',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4874236,
        LOCATION_LATITUDE_DEG: 51.0131411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO019900',
        LOCATION_NAME: 'Morebattle',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3621366,
        LOCATION_LATITUDE_DEG: 55.5174604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020000',
        LOCATION_NAME: 'Morecambe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8625762,
        LOCATION_LATITUDE_DEG: 54.0718218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020100',
        LOCATION_NAME: 'Moredun',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1382454,
        LOCATION_LATITUDE_DEG: 55.911713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020200',
        LOCATION_NAME: 'Morefield',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1792856,
        LOCATION_LATITUDE_DEG: 57.9111313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990217',
        LOCATION_NAME: 'Moreland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6243609,
        LOCATION_LATITUDE_DEG: 54.5986197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020300',
        LOCATION_NAME: 'Moreleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7343281,
        LOCATION_LATITUDE_DEG: 50.3612818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020400',
        LOCATION_NAME: 'Morenish',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2751366,
        LOCATION_LATITUDE_DEG: 56.4877796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020500',
        LOCATION_NAME: 'Moresby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5559918,
        LOCATION_LATITUDE_DEG: 54.5786782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020600',
        LOCATION_NAME: 'Moresby Parks',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5501375,
        LOCATION_LATITUDE_DEG: 54.5589777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020700',
        LOCATION_NAME: 'Moresk',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0478075,
        LOCATION_LATITUDE_DEG: 50.266983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020800',
        LOCATION_NAME: 'Morestead',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2725487,
        LOCATION_LATITUDE_DEG: 51.0253177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021300',
        LOCATION_NAME: 'Moreton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7263382,
        LOCATION_LATITUDE_DEG: 51.708814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021000',
        LOCATION_NAME: 'Moreton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3013833,
        LOCATION_LATITUDE_DEG: 52.75129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021100',
        LOCATION_NAME: 'Moreton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2787708,
        LOCATION_LATITUDE_DEG: 50.7028986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO020900',
        LOCATION_NAME: 'Moreton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9931194,
        LOCATION_LATITUDE_DEG: 51.7361729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021200',
        LOCATION_NAME: 'Moreton',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2218248,
        LOCATION_LATITUDE_DEG: 51.7402633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021500',
        LOCATION_NAME: 'Moreton Corbet',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6557243,
        LOCATION_LATITUDE_DEG: 52.8053962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022300',
        LOCATION_NAME: 'Moreton cum Alcumlow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2534642,
        LOCATION_LATITUDE_DEG: 53.1358285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021600',
        LOCATION_NAME: 'Moreton Eye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7272622,
        LOCATION_LATITUDE_DEG: 52.2690284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044000',
        LOCATION_NAME: 'Moreton in Marsh',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021700',
        LOCATION_NAME: 'Moreton Jefferies',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5782967,
        LOCATION_LATITUDE_DEG: 52.1359948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021800',
        LOCATION_NAME: 'Moreton Morrell',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5442686,
        LOCATION_LATITUDE_DEG: 52.2007317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044100',
        LOCATION_NAME: 'Moreton on Lugg',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO021900',
        LOCATION_NAME: 'Moreton Pinkney',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1613727,
        LOCATION_LATITUDE_DEG: 52.1372184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022000',
        LOCATION_NAME: 'Moreton Say',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5503627,
        LOCATION_LATITUDE_DEG: 52.9054119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022100',
        LOCATION_NAME: 'Moreton Valence',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3140531,
        LOCATION_LATITUDE_DEG: 51.7827971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022200',
        LOCATION_NAME: 'Moreton Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5648925,
        LOCATION_LATITUDE_DEG: 52.9124102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022600',
        LOCATION_NAME: 'Moretonhampstead',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7635037,
        LOCATION_LATITUDE_DEG: 50.6599035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022400',
        LOCATION_NAME: 'Moreton-in-Marsh',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7019109,
        LOCATION_LATITUDE_DEG: 51.9890059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022500',
        LOCATION_NAME: 'Moreton-on-Lugg',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7197882,
        LOCATION_LATITUDE_DEG: 52.106002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022700',
        LOCATION_NAME: 'Morfa',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8337372,
        LOCATION_LATITUDE_DEG: 52.0407511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022800',
        LOCATION_NAME: 'Morfa',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5329825,
        LOCATION_LATITUDE_DEG: 53.2732565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022900',
        LOCATION_NAME: 'Morfa Bychan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1630866,
        LOCATION_LATITUDE_DEG: 52.9141272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023000',
        LOCATION_NAME: 'Morfa Glas',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6350641,
        LOCATION_LATITUDE_DEG: 51.7415124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023100',
        LOCATION_NAME: 'Morfa Nefyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5500394,
        LOCATION_LATITUDE_DEG: 52.9322302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023200',
        LOCATION_NAME: 'Morganstown',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.265509,
        LOCATION_LATITUDE_DEG: 51.5251831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023300',
        LOCATION_NAME: 'Morgantown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3789124,
        LOCATION_LATITUDE_DEG: 51.7482056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023400',
        LOCATION_NAME: 'Morice Town',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1776308,
        LOCATION_LATITUDE_DEG: 50.3778865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023500',
        LOCATION_NAME: 'Morland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6228125,
        LOCATION_LATITUDE_DEG: 54.5965695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023600',
        LOCATION_NAME: 'Morley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8009601,
        LOCATION_LATITUDE_DEG: 54.6424706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023700',
        LOCATION_NAME: 'Morley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6007233,
        LOCATION_LATITUDE_DEG: 53.7489789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023800',
        LOCATION_NAME: 'Morley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4101143,
        LOCATION_LATITUDE_DEG: 52.9633006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO023900',
        LOCATION_NAME: 'Morley Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2656938,
        LOCATION_LATITUDE_DEG: 53.3344424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043800',
        LOCATION_NAME: 'Morley St Botolph',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043900',
        LOCATION_NAME: 'Morley St Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024000',
        LOCATION_NAME: 'Morley St. Botolph',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0599788,
        LOCATION_LATITUDE_DEG: 52.5560239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024100',
        LOCATION_NAME: 'Morley St. Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0532372,
        LOCATION_LATITUDE_DEG: 52.5418253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024200',
        LOCATION_NAME: 'Mornick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3707445,
        LOCATION_LATITUDE_DEG: 50.5251987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024300',
        LOCATION_NAME: 'Morningside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8622106,
        LOCATION_LATITUDE_DEG: 55.7760041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO046000',
        LOCATION_NAME: 'Morningside',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2093857,
        LOCATION_LATITUDE_DEG: 55.9256922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024400',
        LOCATION_NAME: 'Morningthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.266213,
        LOCATION_LATITUDE_DEG: 52.488319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024600',
        LOCATION_NAME: 'Mornish',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2478661,
        LOCATION_LATITUDE_DEG: 56.5860112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024800',
        LOCATION_NAME: 'Morpeth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.689854,
        LOCATION_LATITUDE_DEG: 55.1693213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024900',
        LOCATION_NAME: 'Morrey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5687987,
        LOCATION_LATITUDE_DEG: 52.9608141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025000',
        LOCATION_NAME: 'Morrington',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7713474,
        LOCATION_LATITUDE_DEG: 55.112534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025100',
        LOCATION_NAME: 'Morriston',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9425819,
        LOCATION_LATITUDE_DEG: 51.6665742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025200',
        LOCATION_NAME: 'Morsgail',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8632917,
        LOCATION_LATITUDE_DEG: 58.0985635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025300',
        LOCATION_NAME: 'Morston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9894227,
        LOCATION_LATITUDE_DEG: 52.9544662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025400',
        LOCATION_NAME: 'Mortehoe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2038347,
        LOCATION_LATITUDE_DEG: 51.1845631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025500',
        LOCATION_NAME: 'Morthen',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2834484,
        LOCATION_LATITUDE_DEG: 53.3986443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025600',
        LOCATION_NAME: 'Mortimer',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0560593,
        LOCATION_LATITUDE_DEG: 51.3754407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025700',
        LOCATION_NAME: 'Mortimer Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0651987,
        LOCATION_LATITUDE_DEG: 51.3662422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025800',
        LOCATION_NAME: 'Mortimer West End',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0898161,
        LOCATION_LATITUDE_DEG: 51.3687473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO025900',
        LOCATION_NAME: 'Mortimers Cross',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8466031,
        LOCATION_LATITUDE_DEG: 52.2656704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045000',
        LOCATION_NAME: 'Mortlake',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2683112,
        LOCATION_LATITUDE_DEG: 51.4705815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990883',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026500',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0531097,
        LOCATION_LATITUDE_DEG: 52.8091076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026300',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.390192,
        LOCATION_LATITUDE_DEG: 53.1366136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026600',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9859344,
        LOCATION_LATITUDE_DEG: 53.3121253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026200',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9166861,
        LOCATION_LATITUDE_DEG: 53.0532046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026400',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7833415,
        LOCATION_LATITUDE_DEG: 53.4138347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026000',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6745102,
        LOCATION_LATITUDE_DEG: 53.1625075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026100',
        LOCATION_NAME: 'Morton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3713566,
        LOCATION_LATITUDE_DEG: 52.8022717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026700',
        LOCATION_NAME: 'Morton Bagot',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.836045,
        LOCATION_LATITUDE_DEG: 52.28064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026800',
        LOCATION_NAME: 'Morton Carr',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.791102,
        LOCATION_LATITUDE_DEG: 53.4325411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO026900',
        LOCATION_NAME: 'Morton Hall',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6775065,
        LOCATION_LATITUDE_DEG: 53.164312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO991127',
        LOCATION_NAME: 'Morton on Swale',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4979,
        LOCATION_LATITUDE_DEG: 54.322979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027000',
        LOCATION_NAME: 'Morton Tinmouth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7075525,
        LOCATION_LATITUDE_DEG: 54.5853611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027100',
        LOCATION_NAME: 'Morval',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4466878,
        LOCATION_LATITUDE_DEG: 50.3836902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027200',
        LOCATION_NAME: 'Morvern',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7701066,
        LOCATION_LATITUDE_DEG: 56.5657046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027400',
        LOCATION_NAME: 'Morvil',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8562586,
        LOCATION_LATITUDE_DEG: 51.93964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027500',
        LOCATION_NAME: 'Morville',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4876056,
        LOCATION_LATITUDE_DEG: 52.5437736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027600',
        LOCATION_NAME: 'Morwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.192424,
        LOCATION_LATITUDE_DEG: 50.5142932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027700',
        LOCATION_NAME: 'Morwellham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1924301,
        LOCATION_LATITUDE_DEG: 50.5055947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027800',
        LOCATION_NAME: 'Morwenstow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5502176,
        LOCATION_LATITUDE_DEG: 50.9067343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO027900',
        LOCATION_NAME: 'Mosborough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3383092,
        LOCATION_LATITUDE_DEG: 53.3275367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028000',
        LOCATION_NAME: 'Moscow',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4034823,
        LOCATION_LATITUDE_DEG: 55.6328966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028100',
        LOCATION_NAME: 'Mosedale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9971856,
        LOCATION_LATITUDE_DEG: 54.6811871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028200',
        LOCATION_NAME: 'Moseham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3490195,
        LOCATION_LATITUDE_DEG: 51.0536975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028300',
        LOCATION_NAME: 'Moseley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.277768,
        LOCATION_LATITUDE_DEG: 52.2328178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045600',
        LOCATION_NAME: 'Moseley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8834684,
        LOCATION_LATITUDE_DEG: 52.4484808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045650',
        LOCATION_NAME: 'Moseley Village',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0978616,
        LOCATION_LATITUDE_DEG: 52.5829575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028400',
        LOCATION_NAME: 'Mosley Common',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4272402,
        LOCATION_LATITUDE_DEG: 53.510665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028600',
        LOCATION_NAME: 'Moss',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.790763,
        LOCATION_LATITUDE_DEG: 56.748021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028700',
        LOCATION_NAME: 'Moss',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0429471,
        LOCATION_LATITUDE_DEG: 53.0740277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028800',
        LOCATION_NAME: 'Moss',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0961253,
        LOCATION_LATITUDE_DEG: 53.6216591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028900',
        LOCATION_NAME: 'Moss Bank',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7329835,
        LOCATION_LATITUDE_DEG: 53.4777624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044600',
        LOCATION_NAME: 'Moss Nook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2436179,
        LOCATION_LATITUDE_DEG: 53.3663311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029000',
        LOCATION_NAME: 'Moss Of Barmuckity',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2625519,
        LOCATION_LATITUDE_DEG: 57.6351778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029100',
        LOCATION_NAME: 'Moss Pit',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1174066,
        LOCATION_LATITUDE_DEG: 52.7823895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029200',
        LOCATION_NAME: 'Moss Rake',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7387979,
        LOCATION_LATITUDE_DEG: 53.3170392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029600',
        LOCATION_NAME: 'Moss Side',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2977325,
        LOCATION_LATITUDE_DEG: 50.5036979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029400',
        LOCATION_NAME: 'Moss Side',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.485235,
        LOCATION_LATITUDE_DEG: 54.441767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029500',
        LOCATION_NAME: 'Moss Side',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9407264,
        LOCATION_LATITUDE_DEG: 53.7650998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029300',
        LOCATION_NAME: 'Moss Side',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7317849,
        LOCATION_LATITUDE_DEG: 53.6941842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029700',
        LOCATION_NAME: 'Mossat',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.870602,
        LOCATION_LATITUDE_DEG: 57.2599389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029800',
        LOCATION_NAME: 'Mossband',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0142324,
        LOCATION_LATITUDE_DEG: 54.9780163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO029900',
        LOCATION_NAME: 'Mossbank',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1810393,
        LOCATION_LATITUDE_DEG: 60.4599329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030000',
        LOCATION_NAME: 'Mossblown',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5283676,
        LOCATION_LATITUDE_DEG: 55.4909844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030100',
        LOCATION_NAME: 'Mossdale',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0950239,
        LOCATION_LATITUDE_DEG: 55.0118327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030200',
        LOCATION_NAME: 'Mossend',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.991954,
        LOCATION_LATITUDE_DEG: 55.8207075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030300',
        LOCATION_NAME: 'Mosser',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3720788,
        LOCATION_LATITUDE_DEG: 54.6112849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030400',
        LOCATION_NAME: 'Mosside',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4156297,
        LOCATION_LATITUDE_DEG: 55.1499603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030500',
        LOCATION_NAME: 'Mossley',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9576028,
        LOCATION_LATITUDE_DEG: 54.6897115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030600',
        LOCATION_NAME: 'Mossley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0343719,
        LOCATION_LATITUDE_DEG: 53.5141652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030700',
        LOCATION_NAME: 'Mossley Cross',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0483224,
        LOCATION_LATITUDE_DEG: 53.5137648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045300',
        LOCATION_NAME: 'Mossley Hill',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9178987,
        LOCATION_LATITUDE_DEG: 53.3811743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030800',
        LOCATION_NAME: 'Mossmorran',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3382021,
        LOCATION_LATITUDE_DEG: 56.0982338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO046300',
        LOCATION_NAME: 'Mosspark',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.347746,
        LOCATION_LATITUDE_DEG: 55.8417815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO030900',
        LOCATION_NAME: 'Mosstodloch',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1228902,
        LOCATION_LATITUDE_DEG: 57.6256781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031000',
        LOCATION_NAME: 'Mosstowie',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3874093,
        LOCATION_LATITUDE_DEG: 57.6349836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031100',
        LOCATION_NAME: 'Mosterton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7680354,
        LOCATION_LATITUDE_DEG: 50.8455109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990766',
        LOCATION_NAME: 'Moston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031300',
        LOCATION_NAME: 'Moston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8975905,
        LOCATION_LATITUDE_DEG: 53.2232472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031200',
        LOCATION_NAME: 'Moston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6520726,
        LOCATION_LATITUDE_DEG: 52.8340065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044750',
        LOCATION_NAME: 'Moston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4095457,
        LOCATION_LATITUDE_DEG: 53.1511266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044700',
        LOCATION_NAME: 'Moston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1835377,
        LOCATION_LATITUDE_DEG: 53.5256167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031400',
        LOCATION_NAME: 'Moston Pool',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6445128,
        LOCATION_LATITUDE_DEG: 52.8407998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031600',
        LOCATION_NAME: 'Mostyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2672546,
        LOCATION_LATITUDE_DEG: 53.312752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031700',
        LOCATION_NAME: 'Motcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2130929,
        LOCATION_LATITUDE_DEG: 51.025526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031800',
        LOCATION_NAME: 'Mothecombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9434068,
        LOCATION_LATITUDE_DEG: 50.3108759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032000',
        LOCATION_NAME: 'Motherby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8858792,
        LOCATION_LATITUDE_DEG: 54.6473849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032100',
        LOCATION_NAME: 'Motherwell',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9896328,
        LOCATION_LATITUDE_DEG: 55.7893049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044900',
        LOCATION_NAME: 'Mottingham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0365613,
        LOCATION_LATITUDE_DEG: 51.4541154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032200',
        LOCATION_NAME: 'Mottisfont',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5488139,
        LOCATION_LATITUDE_DEG: 51.0403177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032300',
        LOCATION_NAME: 'Mottistone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4276176,
        LOCATION_LATITUDE_DEG: 50.6502829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032400',
        LOCATION_NAME: 'Mottram',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0110406,
        LOCATION_LATITUDE_DEG: 53.458255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043700',
        LOCATION_NAME: 'Mottram St Andrew',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032500',
        LOCATION_NAME: 'Mottram St. Andrew',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1884336,
        LOCATION_LATITUDE_DEG: 53.3027388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032600',
        LOCATION_NAME: 'Mouldsworth',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7320226,
        LOCATION_LATITUDE_DEG: 53.2359403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032700',
        LOCATION_NAME: 'Moulin',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7250802,
        LOCATION_LATITUDE_DEG: 56.7121985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032800',
        LOCATION_NAME: 'Moulsford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1488587,
        LOCATION_LATITUDE_DEG: 51.5532644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO032900',
        LOCATION_NAME: 'Moulsoe',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6708467,
        LOCATION_LATITUDE_DEG: 52.0685057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033300',
        LOCATION_NAME: 'Moulton',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3335242,
        LOCATION_LATITUDE_DEG: 51.4213778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033200',
        LOCATION_NAME: 'Moulton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5149648,
        LOCATION_LATITUDE_DEG: 53.2226378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033400',
        LOCATION_NAME: 'Moulton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6363905,
        LOCATION_LATITUDE_DEG: 54.4296487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033100',
        LOCATION_NAME: 'Moulton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8508881,
        LOCATION_LATITUDE_DEG: 52.2897294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033000',
        LOCATION_NAME: 'Moulton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0616903,
        LOCATION_LATITUDE_DEG: 52.7985699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033500',
        LOCATION_NAME: 'Moulton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4842594,
        LOCATION_LATITUDE_DEG: 52.2517086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033600',
        LOCATION_NAME: 'Moulton Chapel',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0833397,
        LOCATION_LATITUDE_DEG: 52.7461661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033700',
        LOCATION_NAME: 'Moulton Eaugate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0742677,
        LOCATION_LATITUDE_DEG: 52.7314611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033800',
        LOCATION_NAME: 'Moulton Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0371334,
        LOCATION_LATITUDE_DEG: 52.8595718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033900',
        LOCATION_NAME: 'Moulton Park',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8706808,
        LOCATION_LATITUDE_DEG: 52.2765856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO033950',
        LOCATION_NAME: 'Moulton Park Industrial Estate',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8720874,
        LOCATION_LATITUDE_DEG: 52.2743061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034000',
        LOCATION_NAME: 'Moulton Seas End',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0386581,
        LOCATION_LATITUDE_DEG: 52.8247714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043600',
        LOCATION_NAME: 'Moulton St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034100',
        LOCATION_NAME: 'Moulton St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5396947,
        LOCATION_LATITUDE_DEG: 52.6144214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034200',
        LOCATION_NAME: 'Moundsmere',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1037095,
        LOCATION_LATITUDE_DEG: 51.184523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034400',
        LOCATION_NAME: 'Mount',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6114178,
        LOCATION_LATITUDE_DEG: 50.4820032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034300',
        LOCATION_NAME: 'Mount',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8501908,
        LOCATION_LATITUDE_DEG: 53.6591732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034500',
        LOCATION_NAME: 'Mount Ambrose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2140698,
        LOCATION_LATITUDE_DEG: 50.2417799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034600',
        LOCATION_NAME: 'Mount Batten',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0669116,
        LOCATION_LATITUDE_DEG: 50.3222742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034900',
        LOCATION_NAME: 'Mount Bures',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7733471,
        LOCATION_LATITUDE_DEG: 51.9574718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035100',
        LOCATION_NAME: 'Mount Edgcumbe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1831222,
        LOCATION_LATITUDE_DEG: 50.3534868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035200',
        LOCATION_NAME: 'Mount End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1532553,
        LOCATION_LATITUDE_DEG: 51.6871555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO046200',
        LOCATION_NAME: 'Mount Florida',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2610704,
        LOCATION_LATITUDE_DEG: 55.8270104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035500',
        LOCATION_NAME: 'Mount Grace',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.309254,
        LOCATION_LATITUDE_DEG: 54.3800349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035600',
        LOCATION_NAME: 'Mount Hawke',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2067087,
        LOCATION_LATITUDE_DEG: 50.2829828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035700',
        LOCATION_NAME: 'Mount Joy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0009143,
        LOCATION_LATITUDE_DEG: 50.4001032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035900',
        LOCATION_NAME: 'Mount Melville',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8337978,
        LOCATION_LATITUDE_DEG: 56.3214468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990538',
        LOCATION_NAME: 'Mount Murray',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5575343,
        LOCATION_LATITUDE_DEG: 54.137937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036400',
        LOCATION_NAME: 'Mount Pleasant',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.628663,
        LOCATION_LATITUDE_DEG: 50.5691081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO045400',
        LOCATION_NAME: 'Mount Pleasant',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1387515,
        LOCATION_LATITUDE_DEG: 55.8462134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036300',
        LOCATION_NAME: 'Mount Pleasant',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6315385,
        LOCATION_LATITUDE_DEG: 53.7093724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044400',
        LOCATION_NAME: 'Mount Pleasant',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5922424,
        LOCATION_LATITUDE_DEG: 54.9538173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036600',
        LOCATION_NAME: 'Mount Stuart',
        COUNTY_NAME: 'Isle of Bute',
        POSTCODE: 'PA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0216236,
        LOCATION_LATITUDE_DEG: 55.7937121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036700',
        LOCATION_NAME: 'Mount Tabor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9179687,
        LOCATION_LATITUDE_DEG: 53.7402851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037100',
        LOCATION_NAME: 'Mount Vernon',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5196869,
        LOCATION_LATITUDE_DEG: 58.5855809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO046100',
        LOCATION_NAME: 'Mount Vernon',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7587838,
        LOCATION_LATITUDE_DEG: 54.0081248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037200',
        LOCATION_NAME: 'Mountain',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6730515,
        LOCATION_LATITUDE_DEG: 53.3153686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037300',
        LOCATION_NAME: 'Mountain',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8577951,
        LOCATION_LATITUDE_DEG: 53.773884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037400',
        LOCATION_NAME: 'Mountain Ash',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3784092,
        LOCATION_LATITUDE_DEG: 51.6831038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037500',
        LOCATION_NAME: 'Mountain Hare',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3545093,
        LOCATION_LATITUDE_DEG: 51.7422035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037800',
        LOCATION_NAME: 'Mountblairy',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.518142,
        LOCATION_LATITUDE_DEG: 57.5794649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037900',
        LOCATION_NAME: 'Mountblow',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4438016,
        LOCATION_LATITUDE_DEG: 55.9147254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038400',
        LOCATION_NAME: 'Mountfield',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1757144,
        LOCATION_LATITUDE_DEG: 54.641228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038300',
        LOCATION_NAME: 'Mountfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4706883,
        LOCATION_LATITUDE_DEG: 50.9555796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038500',
        LOCATION_NAME: 'Mountjoy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3501824,
        LOCATION_LATITUDE_DEG: 54.6470009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038800',
        LOCATION_NAME: 'Mountnessing',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3576265,
        LOCATION_LATITUDE_DEG: 51.654548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039000',
        LOCATION_NAME: 'Mountnorris',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4764954,
        LOCATION_LATITUDE_DEG: 54.2515461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038900',
        LOCATION_NAME: 'Mountnorris',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4656576,
        LOCATION_LATITUDE_DEG: 54.233181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039100',
        LOCATION_NAME: 'Mounton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7041465,
        LOCATION_LATITUDE_DEG: 51.6342899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039400',
        LOCATION_NAME: 'Mountsorrel',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1358114,
        LOCATION_LATITUDE_DEG: 52.7269738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039500',
        LOCATION_NAME: 'Mousehole',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5374219,
        LOCATION_LATITUDE_DEG: 50.0834653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039600',
        LOCATION_NAME: 'Mouseyhaugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4727733,
        LOCATION_LATITUDE_DEG: 55.1734276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039700',
        LOCATION_NAME: 'Mouswald',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4623673,
        LOCATION_LATITUDE_DEG: 55.0395258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040000',
        LOCATION_NAME: 'Mow Cop',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.209041,
        LOCATION_LATITUDE_DEG: 53.1124238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040100',
        LOCATION_NAME: 'Mowhan',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5156625,
        LOCATION_LATITUDE_DEG: 54.2665833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040200',
        LOCATION_NAME: 'Mowsley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0473216,
        LOCATION_LATITUDE_DEG: 52.4950529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040300',
        LOCATION_NAME: 'Moxley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0515138,
        LOCATION_LATITUDE_DEG: 52.5577674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040500',
        LOCATION_NAME: 'Moy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6951689,
        LOCATION_LATITUDE_DEG: 54.449397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040400',
        LOCATION_NAME: 'Moy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0433138,
        LOCATION_LATITUDE_DEG: 57.3815664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040800',
        LOCATION_NAME: 'Moyarget',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3322084,
        LOCATION_LATITUDE_DEG: 55.1666689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041300',
        LOCATION_NAME: 'Moygashel',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7303909,
        LOCATION_LATITUDE_DEG: 54.4409929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041500',
        LOCATION_NAME: 'Moylagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.22151,
        LOCATION_LATITUDE_DEG: 54.522705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041700',
        LOCATION_NAME: 'Moylegrove',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7471221,
        LOCATION_LATITUDE_DEG: 52.0663055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041800',
        LOCATION_NAME: 'Moylgrove',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7457761,
        LOCATION_LATITUDE_DEG: 52.0681537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043000',
        LOCATION_NAME: 'Moyson',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6794785,
        LOCATION_LATITUDE_DEG: 50.252968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000100',
        LOCATION_NAME: 'Muasdale',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6832666,
        LOCATION_LATITUDE_DEG: 55.6005044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000300',
        LOCATION_NAME: 'Much Birch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7215996,
        LOCATION_LATITUDE_DEG: 51.9711221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000400',
        LOCATION_NAME: 'Much Cowarne',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5531461,
        LOCATION_LATITUDE_DEG: 52.1216299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000500',
        LOCATION_NAME: 'Much Dewchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7534123,
        LOCATION_LATITUDE_DEG: 51.9764259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000600',
        LOCATION_NAME: 'Much Hadham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0734206,
        LOCATION_LATITUDE_DEG: 51.8536764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000700',
        LOCATION_NAME: 'Much Hoole',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.799491,
        LOCATION_LATITUDE_DEG: 53.7021925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000800',
        LOCATION_NAME: 'Much Marcle',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5005323,
        LOCATION_LATITUDE_DEG: 51.9966191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000900',
        LOCATION_NAME: 'Much Wenlock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.559211,
        LOCATION_LATITUDE_DEG: 52.5941751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001000',
        LOCATION_NAME: 'Muchalls',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1617166,
        LOCATION_LATITUDE_DEG: 57.0189042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001100',
        LOCATION_NAME: 'Muchelney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8121673,
        LOCATION_LATITUDE_DEG: 51.0176278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001200',
        LOCATION_NAME: 'Muchelney Ham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7998852,
        LOCATION_LATITUDE_DEG: 51.0098343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001300',
        LOCATION_NAME: 'Muckamore',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1489076,
        LOCATION_LATITUDE_DEG: 54.683222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001400',
        LOCATION_NAME: 'Mucking',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4239186,
        LOCATION_LATITUDE_DEG: 51.5028325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001500',
        LOCATION_NAME: 'Muckle Roe',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4203926,
        LOCATION_LATITUDE_DEG: 60.3680321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001600',
        LOCATION_NAME: 'Muckleford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5073837,
        LOCATION_LATITUDE_DEG: 50.7400006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001700',
        LOCATION_NAME: 'Mucklestone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4080873,
        LOCATION_LATITUDE_DEG: 52.9323097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001800',
        LOCATION_NAME: 'Mucklestone Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3794774,
        LOCATION_LATITUDE_DEG: 52.9292129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001900',
        LOCATION_NAME: 'Muckleton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6033101,
        LOCATION_LATITUDE_DEG: 52.7850946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002000',
        LOCATION_NAME: 'Muckley Corner',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8844345,
        LOCATION_LATITUDE_DEG: 52.6525753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002200',
        LOCATION_NAME: 'Muckton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0643599,
        LOCATION_LATITUDE_DEG: 53.3115179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002300',
        LOCATION_NAME: 'Muddiford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0521387,
        LOCATION_LATITUDE_DEG: 51.1247502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU990170',
        LOCATION_NAME: 'Mudeford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7379028,
        LOCATION_LATITUDE_DEG: 50.7325446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002400',
        LOCATION_NAME: 'Mudford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6042959,
        LOCATION_LATITUDE_DEG: 50.9758274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002500',
        LOCATION_NAME: 'Mudford Sock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.629667,
        LOCATION_LATITUDE_DEG: 50.9695239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002600',
        LOCATION_NAME: 'Mudgley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7971974,
        LOCATION_LATITUDE_DEG: 51.207849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002800',
        LOCATION_NAME: 'Mugdock',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3067308,
        LOCATION_LATITUDE_DEG: 55.9629239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002900',
        LOCATION_NAME: 'Muggington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5770908,
        LOCATION_LATITUDE_DEG: 52.9829005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003000',
        LOCATION_NAME: 'Muggleswick',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9352594,
        LOCATION_LATITUDE_DEG: 54.8440919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003300',
        LOCATION_NAME: 'Muir of Fowlis',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7239196,
        LOCATION_LATITUDE_DEG: 57.1980333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003400',
        LOCATION_NAME: 'Muir of Ord',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4571149,
        LOCATION_LATITUDE_DEG: 57.5177836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003500',
        LOCATION_NAME: 'Muirdrum',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7125895,
        LOCATION_LATITUDE_DEG: 56.5246622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU013300',
        LOCATION_NAME: 'Muirend',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2748352,
        LOCATION_LATITUDE_DEG: 55.8119612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003600',
        LOCATION_NAME: 'Muirhead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6354572,
        LOCATION_LATITUDE_DEG: 55.5495864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003700',
        LOCATION_NAME: 'Muirhead',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5318958,
        LOCATION_LATITUDE_DEG: 57.6473858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003750',
        LOCATION_NAME: 'Muirhead',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0669009,
        LOCATION_LATITUDE_DEG: 56.4969926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU013200',
        LOCATION_NAME: 'Muirhouse',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2588185,
        LOCATION_LATITUDE_DEG: 55.9826304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003800',
        LOCATION_NAME: 'Muirkirk',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.063438,
        LOCATION_LATITUDE_DEG: 55.5226795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003900',
        LOCATION_NAME: 'Muirton',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.743623,
        LOCATION_LATITUDE_DEG: 56.2837536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004000',
        LOCATION_NAME: 'Muirton Mains',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5770243,
        LOCATION_LATITUDE_DEG: 57.545984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004100',
        LOCATION_NAME: 'Muirtown',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2659195,
        LOCATION_LATITUDE_DEG: 57.4852815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004200',
        LOCATION_NAME: 'Muiryknowes',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9189008,
        LOCATION_LATITUDE_DEG: 56.6317792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004300',
        LOCATION_NAME: 'Muker',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1383503,
        LOCATION_LATITUDE_DEG: 54.3760442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004400',
        LOCATION_NAME: 'Mulbarton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.231368,
        LOCATION_LATITUDE_DEG: 52.5602265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004500',
        LOCATION_NAME: 'Mulben',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0776498,
        LOCATION_LATITUDE_DEG: 57.5416659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004600',
        LOCATION_NAME: 'Mulbrooks',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2589058,
        LOCATION_LATITUDE_DEG: 50.8436743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005400',
        LOCATION_NAME: 'Mullagharn',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3772081,
        LOCATION_LATITUDE_DEG: 54.6410483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005500',
        LOCATION_NAME: 'Mullaghbawn',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4822783,
        LOCATION_LATITUDE_DEG: 54.099855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005900',
        LOCATION_NAME: 'Mullaghmore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2657096,
        LOCATION_LATITUDE_DEG: 54.5197844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006100',
        LOCATION_NAME: 'Mullan',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6879295,
        LOCATION_LATITUDE_DEG: 55.040502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006300',
        LOCATION_NAME: 'Mullans',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0488666,
        LOCATION_LATITUDE_DEG: 54.5373796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006900',
        LOCATION_NAME: 'Mullion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2398021,
        LOCATION_LATITUDE_DEG: 50.026662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007050',
        LOCATION_NAME: 'Mullyknock',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5151359,
        LOCATION_LATITUDE_DEG: 54.3607739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007100',
        LOCATION_NAME: 'Mulnafye',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1580769,
        LOCATION_LATITUDE_DEG: 54.6398044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007400',
        LOCATION_NAME: 'Mumbles',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9923212,
        LOCATION_LATITUDE_DEG: 51.5722976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007500',
        LOCATION_NAME: 'Mumby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2706487,
        LOCATION_LATITUDE_DEG: 53.2462013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007600',
        LOCATION_NAME: 'Muncaster',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3800138,
        LOCATION_LATITUDE_DEG: 54.3630132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007700',
        LOCATION_NAME: 'Munderfield',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5147124,
        LOCATION_LATITUDE_DEG: 52.1583188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007800',
        LOCATION_NAME: 'Mundesley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4371904,
        LOCATION_LATITUDE_DEG: 52.8785482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007900',
        LOCATION_NAME: 'Mundford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6585449,
        LOCATION_LATITUDE_DEG: 52.5122327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008000',
        LOCATION_NAME: 'Mundham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4419736,
        LOCATION_LATITUDE_DEG: 52.5273174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008100',
        LOCATION_NAME: 'Mundole',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6541462,
        LOCATION_LATITUDE_DEG: 57.5895817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008200',
        LOCATION_NAME: 'Mundon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7079318,
        LOCATION_LATITUDE_DEG: 51.6859531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008400',
        LOCATION_NAME: 'Mungrisdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9871176,
        LOCATION_LATITUDE_DEG: 54.6651808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008500',
        LOCATION_NAME: 'Munlochy',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2610716,
        LOCATION_LATITUDE_DEG: 57.5490829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008600',
        LOCATION_NAME: 'Munsley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4906626,
        LOCATION_LATITUDE_DEG: 52.0638291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008700',
        LOCATION_NAME: 'Munslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.704063,
        LOCATION_LATITUDE_DEG: 52.4843676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008800',
        LOCATION_NAME: 'Munstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7073738,
        LOCATION_LATITUDE_DEG: 52.080028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008900',
        LOCATION_NAME: 'Murch',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2049327,
        LOCATION_LATITUDE_DEG: 51.4323748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009000',
        LOCATION_NAME: 'Murchington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8582615,
        LOCATION_LATITUDE_DEG: 50.6790107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009200',
        LOCATION_NAME: 'Murcot',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9093418,
        LOCATION_LATITUDE_DEG: 52.0586203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009300',
        LOCATION_NAME: 'Murcott',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0650847,
        LOCATION_LATITUDE_DEG: 51.6240816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009400',
        LOCATION_NAME: 'Murcott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.166816,
        LOCATION_LATITUDE_DEG: 51.8401887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009500',
        LOCATION_NAME: 'Murdishaw',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.666538,
        LOCATION_LATITUDE_DEG: 53.3234912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009600',
        LOCATION_NAME: 'Murieston',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5010486,
        LOCATION_LATITUDE_DEG: 55.8667096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009700',
        LOCATION_NAME: 'Murkle',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4315622,
        LOCATION_LATITUDE_DEG: 58.5925754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009800',
        LOCATION_NAME: 'Murlaggan',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7644265,
        LOCATION_LATITUDE_DEG: 56.8912281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010000',
        LOCATION_NAME: 'Murphys Lane',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3571864,
        LOCATION_LATITUDE_DEG: 52.6879845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012900',
        LOCATION_NAME: 'Murrayfield',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1650022,
        LOCATION_LATITUDE_DEG: 55.8520793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010400',
        LOCATION_NAME: 'Murroes',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8652023,
        LOCATION_LATITUDE_DEG: 56.5000618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010600',
        LOCATION_NAME: 'Murrow',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0311116,
        LOCATION_LATITUDE_DEG: 52.642847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010700',
        LOCATION_NAME: 'Mursley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8101384,
        LOCATION_LATITUDE_DEG: 51.9490942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010800',
        LOCATION_NAME: 'Murston',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7516634,
        LOCATION_LATITUDE_DEG: 51.3328157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010900',
        LOCATION_NAME: 'Murthly',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4611506,
        LOCATION_LATITUDE_DEG: 56.5317735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011100',
        LOCATION_NAME: 'Murton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0353774,
        LOCATION_LATITUDE_DEG: 51.5797967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011300',
        LOCATION_NAME: 'Murton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4209013,
        LOCATION_LATITUDE_DEG: 54.5893687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011400',
        LOCATION_NAME: 'Murton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4849474,
        LOCATION_LATITUDE_DEG: 55.0315013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011000',
        LOCATION_NAME: 'Murton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3831043,
        LOCATION_LATITUDE_DEG: 54.8151837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011200',
        LOCATION_NAME: 'Murton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.009113,
        LOCATION_LATITUDE_DEG: 53.9658947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011500',
        LOCATION_NAME: 'Murtry',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3382338,
        LOCATION_LATITUDE_DEG: 51.2454449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011600',
        LOCATION_NAME: 'Musbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0281345,
        LOCATION_LATITUDE_DEG: 50.746807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011700',
        LOCATION_NAME: 'Muscoates',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9468153,
        LOCATION_LATITUDE_DEG: 54.213013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011800',
        LOCATION_NAME: 'Muscott',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0849484,
        LOCATION_LATITUDE_DEG: 52.2632266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU011900',
        LOCATION_NAME: 'Musley Bank',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8310258,
        LOCATION_LATITUDE_DEG: 54.1266033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012000',
        LOCATION_NAME: 'Musselburgh',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0522364,
        LOCATION_LATITUDE_DEG: 55.9421151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012200',
        LOCATION_NAME: 'Muston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7668525,
        LOCATION_LATITUDE_DEG: 52.9315928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012100',
        LOCATION_NAME: 'Muston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3196368,
        LOCATION_LATITUDE_DEG: 54.2007019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012300',
        LOCATION_NAME: 'Mustow Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.192761,
        LOCATION_LATITUDE_DEG: 52.3649525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU013100',
        LOCATION_NAME: 'Muswell Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'N10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.142816,
        LOCATION_LATITUDE_DEG: 51.5951995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012400',
        LOCATION_NAME: 'Mutford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6587985,
        LOCATION_LATITUDE_DEG: 52.4386113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012500',
        LOCATION_NAME: 'Muthill',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8311285,
        LOCATION_LATITUDE_DEG: 56.3303553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012600',
        LOCATION_NAME: 'Mutley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1300175,
        LOCATION_LATITUDE_DEG: 50.3804867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012700',
        LOCATION_NAME: 'Mutterton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3793344,
        LOCATION_LATITUDE_DEG: 50.8374219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU012800',
        LOCATION_NAME: 'Muxton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4180862,
        LOCATION_LATITUDE_DEG: 52.7266883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MW000100',
        LOCATION_NAME: 'Mwnt',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6435021,
        LOCATION_LATITUDE_DEG: 52.1323537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MW000200',
        LOCATION_NAME: 'Mwyndy',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3605125,
        LOCATION_LATITUDE_DEG: 51.5250819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000100',
        LOCATION_NAME: 'Myddfai',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7856605,
        LOCATION_LATITUDE_DEG: 51.9564294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000200',
        LOCATION_NAME: 'Myddle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7867105,
        LOCATION_LATITUDE_DEG: 52.8103003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000300',
        LOCATION_NAME: 'Mydroilyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2547238,
        LOCATION_LATITUDE_DEG: 52.1738596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000500',
        LOCATION_NAME: 'Mylor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0600147,
        LOCATION_LATITUDE_DEG: 50.1718717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000550',
        LOCATION_NAME: 'Mylor Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0759559,
        LOCATION_LATITUDE_DEG: 50.1858182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000600',
        LOCATION_NAME: 'Mylor Churchtown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0542289,
        LOCATION_LATITUDE_DEG: 50.1764775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000700',
        LOCATION_NAME: 'Mylor Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1011117,
        LOCATION_LATITUDE_DEG: 50.1912757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000800',
        LOCATION_NAME: 'Mylor Harbour',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0503832,
        LOCATION_LATITUDE_DEG: 50.1761468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001000',
        LOCATION_NAME: 'Mynachlogddu',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7004527,
        LOCATION_LATITUDE_DEG: 51.9419434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000900',
        LOCATION_NAME: 'Mynachlogddu',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6999522,
        LOCATION_LATITUDE_DEG: 51.9423326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001100',
        LOCATION_NAME: 'Mynd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.951182,
        LOCATION_LATITUDE_DEG: 52.3682593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001200',
        LOCATION_NAME: 'Myndtown',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8991627,
        LOCATION_LATITUDE_DEG: 52.4995717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001300',
        LOCATION_NAME: 'Mynydd Bodafon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2906238,
        LOCATION_LATITUDE_DEG: 53.3444682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001400',
        LOCATION_NAME: 'Mynydd Du',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1671486,
        LOCATION_LATITUDE_DEG: 53.1075331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001500',
        LOCATION_NAME: 'Mynydd Isa',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1091446,
        LOCATION_LATITUDE_DEG: 53.168243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001600',
        LOCATION_NAME: 'Mynydd Llandygai',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0866382,
        LOCATION_LATITUDE_DEG: 53.1719501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001700',
        LOCATION_NAME: 'Mynydd Mechell',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4709596,
        LOCATION_LATITUDE_DEG: 53.3799751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001800',
        LOCATION_NAME: 'Mynydd Nefyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5069924,
        LOCATION_LATITUDE_DEG: 52.9303319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY001900',
        LOCATION_NAME: 'Mynyddbach',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7436061,
        LOCATION_LATITUDE_DEG: 51.6436866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002000',
        LOCATION_NAME: 'Mynyddcerrig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1656939,
        LOCATION_LATITUDE_DEG: 51.800921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002100',
        LOCATION_NAME: 'Mynyddislwyn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1653984,
        LOCATION_LATITUDE_DEG: 51.632893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002200',
        LOCATION_NAME: 'Mynyddygarreg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2871844,
        LOCATION_LATITUDE_DEG: 51.743317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002300',
        LOCATION_NAME: 'Mynytho',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5165637,
        LOCATION_LATITUDE_DEG: 52.8485204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002600',
        LOCATION_NAME: 'Mystole',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0042794,
        LOCATION_LATITUDE_DEG: 51.2437012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002700',
        LOCATION_NAME: 'Mytchett',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7151779,
        LOCATION_LATITUDE_DEG: 51.2828325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002800',
        LOCATION_NAME: 'Mytholm',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0248692,
        LOCATION_LATITUDE_DEG: 53.7438793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002900',
        LOCATION_NAME: 'Mytholmroyd',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9817793,
        LOCATION_LATITUDE_DEG: 53.7284821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY003000',
        LOCATION_NAME: 'Myton on Swale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3273096,
        LOCATION_LATITUDE_DEG: 54.0936088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY003100',
        LOCATION_NAME: 'Mytton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8250757,
        LOCATION_LATITUDE_DEG: 52.7480932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000200',
        LOCATION_NAME: 'Naast',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6555715,
        LOCATION_LATITUDE_DEG: 57.7871215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000300',
        LOCATION_NAME: 'Nab Wood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7987863,
        LOCATION_LATITUDE_DEG: 53.8358866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000400',
        LOCATION_NAME: 'Naburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0885498,
        LOCATION_LATITUDE_DEG: 53.9018825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000500',
        LOCATION_NAME: 'Nackington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0855634,
        LOCATION_LATITUDE_DEG: 51.2500049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000600',
        LOCATION_NAME: 'Nacton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2375844,
        LOCATION_LATITUDE_DEG: 52.0187697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000800',
        LOCATION_NAME: 'Nadderwater',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5711873,
        LOCATION_LATITUDE_DEG: 50.729511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000900',
        LOCATION_NAME: 'Naddle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0880948,
        LOCATION_LATITUDE_DEG: 54.5862794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001000',
        LOCATION_NAME: 'Nafferton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3892291,
        LOCATION_LATITUDE_DEG: 54.0192885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001200',
        LOCATION_NAME: 'Naharley tland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7377227,
        LOCATION_LATITUDE_DEG: 54.296542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001300',
        LOCATION_NAME: 'Nailsbourne',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1143115,
        LOCATION_LATITUDE_DEG: 51.0489349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001400',
        LOCATION_NAME: 'Nailsea',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7567867,
        LOCATION_LATITUDE_DEG: 51.4314663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001500',
        LOCATION_NAME: 'Nailstone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3814236,
        LOCATION_LATITUDE_DEG: 52.6610691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001600',
        LOCATION_NAME: 'Nailsworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2226992,
        LOCATION_LATITUDE_DEG: 51.6879854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001700',
        LOCATION_NAME: 'Nailwell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4193315,
        LOCATION_LATITUDE_DEG: 51.3445537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001800',
        LOCATION_NAME: 'Naird Lane',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4126905,
        LOCATION_LATITUDE_DEG: 52.6727807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001900',
        LOCATION_NAME: 'Nairn',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8736935,
        LOCATION_LATITUDE_DEG: 57.5838836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002000',
        LOCATION_NAME: 'Nairnside',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1085925,
        LOCATION_LATITUDE_DEG: 57.4630736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002100',
        LOCATION_NAME: 'Nancegollan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3058609,
        LOCATION_LATITUDE_DEG: 50.1415735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002200',
        LOCATION_NAME: 'Nancekuke',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2656272,
        LOCATION_LATITUDE_DEG: 50.2661808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002300',
        LOCATION_NAME: 'Nancledra',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.506873,
        LOCATION_LATITUDE_DEG: 50.1705815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002400',
        LOCATION_NAME: 'Nangreaves',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2878126,
        LOCATION_LATITUDE_DEG: 53.6322768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002500',
        LOCATION_NAME: 'Nanhoron',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.552834,
        LOCATION_LATITUDE_DEG: 52.8540226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002600',
        LOCATION_NAME: 'Nannerch',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2483044,
        LOCATION_LATITUDE_DEG: 53.2178511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002700',
        LOCATION_NAME: 'Nanpantan',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2517663,
        LOCATION_LATITUDE_DEG: 52.7504819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002800',
        LOCATION_NAME: 'Nanpean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8683962,
        LOCATION_LATITUDE_DEG: 50.3674905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA002900',
        LOCATION_NAME: 'Nanstallon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7695833,
        LOCATION_LATITUDE_DEG: 50.4719035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003000',
        LOCATION_NAME: 'Nanswhyden',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9923031,
        LOCATION_LATITUDE_DEG: 50.4235991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003100',
        LOCATION_NAME: 'Nant Bwlch yr Haiarn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8276197,
        LOCATION_LATITUDE_DEG: 53.1243453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003200',
        LOCATION_NAME: 'Nant Ffrancon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0378434,
        LOCATION_LATITUDE_DEG: 53.142044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003300',
        LOCATION_NAME: 'Nant Glas',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4709196,
        LOCATION_LATITUDE_DEG: 52.2741549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003400',
        LOCATION_NAME: 'Nant Gwynant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.031346,
        LOCATION_LATITUDE_DEG: 53.0515372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003500',
        LOCATION_NAME: 'Nant Peris',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0831892,
        LOCATION_LATITUDE_DEG: 53.1044471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA009300',
        LOCATION_NAME: 'Nant y Caws',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003600',
        LOCATION_NAME: 'Nant y Rhiw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7560167,
        LOCATION_LATITUDE_DEG: 53.1161442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003800',
        LOCATION_NAME: 'Nanternis',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3826864,
        LOCATION_LATITUDE_DEG: 52.1801568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003900',
        LOCATION_NAME: 'Nantgaredig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.188443,
        LOCATION_LATITUDE_DEG: 51.8734283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004000',
        LOCATION_NAME: 'Nantgarw',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2606033,
        LOCATION_LATITUDE_DEG: 51.5620889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004100',
        LOCATION_NAME: 'Nantglyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4886809,
        LOCATION_LATITUDE_DEG: 53.1459423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004200',
        LOCATION_NAME: 'Nantlle',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2164041,
        LOCATION_LATITUDE_DEG: 53.0573412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004300',
        LOCATION_NAME: 'Nantmawr',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1199788,
        LOCATION_LATITUDE_DEG: 52.8101048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004400',
        LOCATION_NAME: 'Nantmel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4265687,
        LOCATION_LATITUDE_DEG: 52.2848601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004500',
        LOCATION_NAME: 'Nantmor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0784684,
        LOCATION_LATITUDE_DEG: 52.992537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004600',
        LOCATION_NAME: 'Nantwich',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5185932,
        LOCATION_LATITUDE_DEG: 53.0640276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004700',
        LOCATION_NAME: 'Nantyarion',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4149001,
        LOCATION_LATITUDE_DEG: 52.1444451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004800',
        LOCATION_NAME: 'Nantycaws',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.233249,
        LOCATION_LATITUDE_DEG: 51.8405239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA003700',
        LOCATION_NAME: 'Nant-y-Caws',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0587024,
        LOCATION_LATITUDE_DEG: 52.8347089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA004900',
        LOCATION_NAME: 'Nantyderry',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9686335,
        LOCATION_LATITUDE_DEG: 51.7492187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005000',
        LOCATION_NAME: 'Nantyffyllon',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6588572,
        LOCATION_LATITUDE_DEG: 51.6201948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005100',
        LOCATION_NAME: 'Nantyglo',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1708928,
        LOCATION_LATITUDE_DEG: 51.7894088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005200',
        LOCATION_NAME: 'Nantygwreiddyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5230152,
        LOCATION_LATITUDE_DEG: 51.9488256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005300',
        LOCATION_NAME: 'Nantymoel',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.53877,
        LOCATION_LATITUDE_DEG: 51.6239977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005400',
        LOCATION_NAME: 'Nantyr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1934634,
        LOCATION_LATITUDE_DEG: 52.9305145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005500',
        LOCATION_NAME: 'Naphill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7755617,
        LOCATION_LATITUDE_DEG: 51.6648639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005600',
        LOCATION_NAME: 'Napley Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4185768,
        LOCATION_LATITUDE_DEG: 52.9369123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005700',
        LOCATION_NAME: 'Nappa',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2191141,
        LOCATION_LATITUDE_DEG: 53.9751109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005800',
        LOCATION_NAME: 'Nappa Scar',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0548817,
        LOCATION_LATITUDE_DEG: 54.3140385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA005900',
        LOCATION_NAME: 'Napsbury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3104796,
        LOCATION_LATITUDE_DEG: 51.722567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006000',
        LOCATION_NAME: 'Napton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3168679,
        LOCATION_LATITUDE_DEG: 52.248027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006100',
        LOCATION_NAME: 'Narberth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.741835,
        LOCATION_LATITUDE_DEG: 51.7976248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006200',
        LOCATION_NAME: 'Narborough',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2093293,
        LOCATION_LATITUDE_DEG: 52.571862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006300',
        LOCATION_NAME: 'Narborough',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.589008,
        LOCATION_LATITUDE_DEG: 52.6836485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006400',
        LOCATION_NAME: 'Narkurs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3591395,
        LOCATION_LATITUDE_DEG: 50.3769898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006600',
        LOCATION_NAME: 'Nasareth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2802465,
        LOCATION_LATITUDE_DEG: 53.025543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006700',
        LOCATION_NAME: 'Naseby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9876885,
        LOCATION_LATITUDE_DEG: 52.396839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006900',
        LOCATION_NAME: 'Nash',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4969257,
        LOCATION_LATITUDE_DEG: 51.4463755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007200',
        LOCATION_NAME: 'Nash',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0093908,
        LOCATION_LATITUDE_DEG: 52.2532502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007100',
        LOCATION_NAME: 'Nash',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9461369,
        LOCATION_LATITUDE_DEG: 51.548679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007000',
        LOCATION_NAME: 'Nash',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5837438,
        LOCATION_LATITUDE_DEG: 52.3422507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006800',
        LOCATION_NAME: 'Nash',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8649189,
        LOCATION_LATITUDE_DEG: 52.0030039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007300',
        LOCATION_NAME: 'Nash Mills',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4431358,
        LOCATION_LATITUDE_DEG: 51.7236714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007400',
        LOCATION_NAME: 'Nassington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4321963,
        LOCATION_LATITUDE_DEG: 52.552846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007500',
        LOCATION_NAME: 'Nastend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3031401,
        LOCATION_LATITUDE_DEG: 51.7530977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007600',
        LOCATION_NAME: 'Nasty',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0231651,
        LOCATION_LATITUDE_DEG: 51.9024819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007800',
        LOCATION_NAME: 'Nateby',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8155956,
        LOCATION_LATITUDE_DEG: 53.8955064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007700',
        LOCATION_NAME: 'Nateby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3479321,
        LOCATION_LATITUDE_DEG: 54.4552571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007900',
        LOCATION_NAME: 'Nately Scures',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9876363,
        LOCATION_LATITUDE_DEG: 51.2729329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA007950',
        LOCATION_NAME: 'Natland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7382956,
        LOCATION_LATITUDE_DEG: 54.2967812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008000',
        LOCATION_NAME: 'Naughton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9546271,
        LOCATION_LATITUDE_DEG: 52.1017847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008200',
        LOCATION_NAME: 'Naunton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1801179,
        LOCATION_LATITUDE_DEG: 52.0544264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008300',
        LOCATION_NAME: 'Naunton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8348996,
        LOCATION_LATITUDE_DEG: 51.909402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008400',
        LOCATION_NAME: 'Naunton Beauchamp',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0539444,
        LOCATION_LATITUDE_DEG: 52.1690323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008600',
        LOCATION_NAME: 'Navenby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5235184,
        LOCATION_LATITUDE_DEG: 53.1080989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008700',
        LOCATION_NAME: 'Navestock',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.222154,
        LOCATION_LATITUDE_DEG: 51.6527567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008800',
        LOCATION_NAME: 'Navestockside',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2542982,
        LOCATION_LATITUDE_DEG: 51.6528004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008900',
        LOCATION_NAME: 'Navidale',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6379634,
        LOCATION_LATITUDE_DEG: 58.1290339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA009000',
        LOCATION_NAME: 'Nawton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9889279,
        LOCATION_LATITUDE_DEG: 54.2532211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA009100',
        LOCATION_NAME: 'Nayland',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8759389,
        LOCATION_LATITUDE_DEG: 51.9717747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA009200',
        LOCATION_NAME: 'Nazeing',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'EN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0497185,
        LOCATION_LATITUDE_DEG: 51.7388594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000100',
        LOCATION_NAME: 'Neachley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3115842,
        LOCATION_LATITUDE_DEG: 52.650379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000150',
        LOCATION_NAME: 'Neacroft',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7378595,
        LOCATION_LATITUDE_DEG: 50.7707497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000300',
        LOCATION_NAME: 'Nealhouse',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0277348,
        LOCATION_LATITUDE_DEG: 54.8507071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000500',
        LOCATION_NAME: 'Neap House',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6980343,
        LOCATION_LATITUDE_DEG: 53.6087489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000600',
        LOCATION_NAME: 'Near Sawrey',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9712959,
        LOCATION_LATITUDE_DEG: 54.3530527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060600',
        LOCATION_NAME: 'Neasden',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.249839,
        LOCATION_LATITUDE_DEG: 51.5543508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000700',
        LOCATION_NAME: 'Neasham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4917588,
        LOCATION_LATITUDE_DEG: 54.4877475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000800',
        LOCATION_NAME: 'Neath',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8025109,
        LOCATION_LATITUDE_DEG: 51.660705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000900',
        LOCATION_NAME: 'Neath Abbey',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8300576,
        LOCATION_LATITUDE_DEG: 51.6632017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001000',
        LOCATION_NAME: 'Neath Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7490454,
        LOCATION_LATITUDE_DEG: 52.0584092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001100',
        LOCATION_NAME: 'Neatham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9394008,
        LOCATION_LATITUDE_DEG: 51.1597212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001200',
        LOCATION_NAME: 'Neatishead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.46773,
        LOCATION_LATITUDE_DEG: 52.7356382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001300',
        LOCATION_NAME: 'Neaton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8296052,
        LOCATION_LATITUDE_DEG: 52.5776324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001400',
        LOCATION_NAME: 'Nebo',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2685555,
        LOCATION_LATITUDE_DEG: 53.0298401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001500',
        LOCATION_NAME: 'Nebo',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1299689,
        LOCATION_LATITUDE_DEG: 52.2653619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001600',
        LOCATION_NAME: 'Nechells',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8623371,
        LOCATION_LATITUDE_DEG: 52.5050656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001700',
        LOCATION_NAME: 'Necton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7762812,
        LOCATION_LATITUDE_DEG: 52.6523369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001800',
        LOCATION_NAME: 'Nedderton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6331179,
        LOCATION_LATITUDE_DEG: 55.1311126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE001900',
        LOCATION_NAME: 'Nedge Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4141861,
        LOCATION_LATITUDE_DEG: 52.6588848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002000',
        LOCATION_NAME: 'Nedging Tye',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.950858,
        LOCATION_LATITUDE_DEG: 52.1081844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002100',
        LOCATION_NAME: 'Nedsherry',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5823616,
        LOCATION_LATITUDE_DEG: 54.5166035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002200',
        LOCATION_NAME: 'Needham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2724524,
        LOCATION_LATITUDE_DEG: 52.3854074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002300',
        LOCATION_NAME: 'Needham Market',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0536801,
        LOCATION_LATITUDE_DEG: 52.1531908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002400',
        LOCATION_NAME: 'Needingworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0296171,
        LOCATION_LATITUDE_DEG: 52.33012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002500',
        LOCATION_NAME: 'Needwood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7340259,
        LOCATION_LATITUDE_DEG: 52.8151898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002600',
        LOCATION_NAME: 'Neen Sollars',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4979349,
        LOCATION_LATITUDE_DEG: 52.347256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002700',
        LOCATION_NAME: 'Neenton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5341661,
        LOCATION_LATITUDE_DEG: 52.4856702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059800',
        LOCATION_NAME: 'Neepsend',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4839709,
        LOCATION_LATITUDE_DEG: 53.3957148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002800',
        LOCATION_NAME: 'Nefyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5200166,
        LOCATION_LATITUDE_DEG: 52.9352361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE002900',
        LOCATION_NAME: 'Neilston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4239488,
        LOCATION_LATITUDE_DEG: 55.7853086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003100',
        LOCATION_NAME: 'Nelson',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2823066,
        LOCATION_LATITUDE_DEG: 51.6518992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003000',
        LOCATION_NAME: 'Nelson',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2151623,
        LOCATION_LATITUDE_DEG: 53.835395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003200',
        LOCATION_NAME: 'Nelson Village',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5886141,
        LOCATION_LATITUDE_DEG: 55.096406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003300',
        LOCATION_NAME: 'Nemphlar',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8195802,
        LOCATION_LATITUDE_DEG: 55.6837897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003400',
        LOCATION_NAME: 'Nempnett Thrubwell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6693132,
        LOCATION_LATITUDE_DEG: 51.3396602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003600',
        LOCATION_NAME: 'Nenthall',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3811488,
        LOCATION_LATITUDE_DEG: 54.8069946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003700',
        LOCATION_NAME: 'Nenthead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3402055,
        LOCATION_LATITUDE_DEG: 54.7877929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003800',
        LOCATION_NAME: 'Nentsbury',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3625153,
        LOCATION_LATITUDE_DEG: 54.7990887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003900',
        LOCATION_NAME: 'Neopardy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7080757,
        LOCATION_LATITUDE_DEG: 50.7764166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004000',
        LOCATION_NAME: 'Nercwys',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1503136,
        LOCATION_LATITUDE_DEG: 53.1423375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004100',
        LOCATION_NAME: 'Nerston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1613475,
        LOCATION_LATITUDE_DEG: 55.7870075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004200',
        LOCATION_NAME: 'Nesfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8558489,
        LOCATION_LATITUDE_DEG: 53.9430983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004300',
        LOCATION_NAME: 'Ness',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2645054,
        LOCATION_LATITUDE_DEG: 58.4762001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004400',
        LOCATION_NAME: 'Ness',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0459139,
        LOCATION_LATITUDE_DEG: 53.2756468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004500',
        LOCATION_NAME: 'Ness Strange',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9026307,
        LOCATION_LATITUDE_DEG: 52.7554943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004600',
        LOCATION_NAME: 'Nesscliffe',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.917056,
        LOCATION_LATITUDE_DEG: 52.7699039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004700',
        LOCATION_NAME: 'Neston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0630576,
        LOCATION_LATITUDE_DEG: 53.2895559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004800',
        LOCATION_NAME: 'Neston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1995969,
        LOCATION_LATITUDE_DEG: 51.4116622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004850',
        LOCATION_NAME: 'Neswick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5121809,
        LOCATION_LATITUDE_DEG: 53.961946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE004900',
        LOCATION_NAME: 'Nethecombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9556023,
        LOCATION_LATITUDE_DEG: 50.3160775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005000',
        LOCATION_NAME: 'Nether Alderley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2360804,
        LOCATION_LATITUDE_DEG: 53.2833439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005100',
        LOCATION_NAME: 'Nether Broughton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9683713,
        LOCATION_LATITUDE_DEG: 52.8261811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005200',
        LOCATION_NAME: 'Nether Cantley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0557234,
        LOCATION_LATITUDE_DEG: 53.5158529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005300',
        LOCATION_NAME: 'Nether Careston',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7772901,
        LOCATION_LATITUDE_DEG: 56.7180845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005400',
        LOCATION_NAME: 'Nether Cerne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4676867,
        LOCATION_LATITUDE_DEG: 50.7830035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005500',
        LOCATION_NAME: 'Nether Compton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5728565,
        LOCATION_LATITUDE_DEG: 50.953826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005600',
        LOCATION_NAME: 'Nether Dallachy',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0718036,
        LOCATION_LATITUDE_DEG: 57.6605843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059200',
        LOCATION_NAME: 'Nether Edge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4828134,
        LOCATION_LATITUDE_DEG: 53.3559571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005700',
        LOCATION_NAME: 'Nether Handley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3881217,
        LOCATION_LATITUDE_DEG: 53.2895325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005800',
        LOCATION_NAME: 'Nether Haugh',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3695815,
        LOCATION_LATITUDE_DEG: 53.4684499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE005900',
        LOCATION_NAME: 'Nether Headon',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8803312,
        LOCATION_LATITUDE_DEG: 53.2902246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006000',
        LOCATION_NAME: 'Nether Heage',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4580005,
        LOCATION_LATITUDE_DEG: 53.05131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006100',
        LOCATION_NAME: 'Nether Heyford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0327423,
        LOCATION_LATITUDE_DEG: 52.2204236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006200',
        LOCATION_NAME: 'Nether Kellet',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7572806,
        LOCATION_LATITUDE_DEG: 54.1068231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006300',
        LOCATION_NAME: 'Nether Kinmundy',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9146295,
        LOCATION_LATITUDE_DEG: 57.4844464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006400',
        LOCATION_NAME: 'Nether Langwith',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2056893,
        LOCATION_LATITUDE_DEG: 53.2277202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006500',
        LOCATION_NAME: 'Nether Padley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6270762,
        LOCATION_LATITUDE_DEG: 53.2996347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006600',
        LOCATION_NAME: 'Nether Poppleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1455756,
        LOCATION_LATITUDE_DEG: 53.9873926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006700',
        LOCATION_NAME: 'Nether Silton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3008178,
        LOCATION_LATITUDE_DEG: 54.3246268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006800',
        LOCATION_NAME: 'Nether Stowey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1571618,
        LOCATION_LATITUDE_DEG: 51.1497494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE006900',
        LOCATION_NAME: 'Nether Wallop',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5668421,
        LOCATION_LATITUDE_DEG: 51.1262261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007000',
        LOCATION_NAME: 'Nether Warden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1297864,
        LOCATION_LATITUDE_DEG: 54.9973099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007100',
        LOCATION_NAME: 'Nether Welton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0004819,
        LOCATION_LATITUDE_DEG: 54.8000001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007200',
        LOCATION_NAME: 'Nether Westcote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6729798,
        LOCATION_LATITUDE_DEG: 51.8798037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007300',
        LOCATION_NAME: 'Nether Whitacre',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6617194,
        LOCATION_LATITUDE_DEG: 52.5331636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007400',
        LOCATION_NAME: 'Nether Winchendon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9367044,
        LOCATION_LATITUDE_DEG: 51.8034791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007500',
        LOCATION_NAME: 'Nether Worton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3811001,
        LOCATION_LATITUDE_DEG: 51.9678041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007600',
        LOCATION_NAME: 'Netheravon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.79124,
        LOCATION_LATITUDE_DEG: 51.2352436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007700',
        LOCATION_NAME: 'Netherburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9081758,
        LOCATION_LATITUDE_DEG: 55.7098937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007800',
        LOCATION_NAME: 'Netherbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7467643,
        LOCATION_LATITUDE_DEG: 50.7891055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE007900',
        LOCATION_NAME: 'Netherby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9444614,
        LOCATION_LATITUDE_DEG: 55.0366202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008000',
        LOCATION_NAME: 'Nethercote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3009516,
        LOCATION_LATITUDE_DEG: 52.066509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008100',
        LOCATION_NAME: 'Nethercote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2387262,
        LOCATION_LATITUDE_DEG: 52.2738312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008200',
        LOCATION_NAME: 'Netherend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5866409,
        LOCATION_LATITUDE_DEG: 51.6997976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008300',
        LOCATION_NAME: 'Netherexe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5050223,
        LOCATION_LATITUDE_DEG: 50.791419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008500',
        LOCATION_NAME: 'Netherfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.072256,
        LOCATION_LATITUDE_DEG: 52.962798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008400',
        LOCATION_NAME: 'Netherfield',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7294548,
        LOCATION_LATITUDE_DEG: 52.0192993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008600',
        LOCATION_NAME: 'Netherfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4528608,
        LOCATION_LATITUDE_DEG: 50.9396836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008700',
        LOCATION_NAME: 'Netherhampton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8481338,
        LOCATION_LATITUDE_DEG: 51.0670263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008800',
        LOCATION_NAME: 'Netherhay',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8296901,
        LOCATION_LATITUDE_DEG: 50.8432182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE061300',
        LOCATION_NAME: 'Netherlee',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2600343,
        LOCATION_LATITUDE_DEG: 55.8110747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060300',
        LOCATION_NAME: 'Netherley',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8323286,
        LOCATION_LATITUDE_DEG: 53.3864223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE008900',
        LOCATION_NAME: 'Netherley',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2407577,
        LOCATION_LATITUDE_DEG: 57.0308072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009000',
        LOCATION_NAME: 'Netherplace',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3585448,
        LOCATION_LATITUDE_DEG: 55.7700058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009100',
        LOCATION_NAME: 'Netherseal',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5751107,
        LOCATION_LATITUDE_DEG: 52.7150751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009200',
        LOCATION_NAME: 'Netherstowe',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8081243,
        LOCATION_LATITUDE_DEG: 52.6988775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009300',
        LOCATION_NAME: 'Netherthird',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2527555,
        LOCATION_LATITUDE_DEG: 55.4428738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009400',
        LOCATION_NAME: 'Netherthong',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7913968,
        LOCATION_LATITUDE_DEG: 53.5823616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009500',
        LOCATION_NAME: 'Netherthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1900359,
        LOCATION_LATITUDE_DEG: 53.3196281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010500',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5640899,
        LOCATION_LATITUDE_DEG: 50.5305941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE061700',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9669083,
        LOCATION_LATITUDE_DEG: 53.4936289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010100',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6258631,
        LOCATION_LATITUDE_DEG: 50.8984149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010400',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5804247,
        LOCATION_LATITUDE_DEG: 51.9284175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010000',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0889517,
        LOCATION_LATITUDE_DEG: 52.4907626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009700',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.01767,
        LOCATION_LATITUDE_DEG: 55.3626436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009900',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.013103,
        LOCATION_LATITUDE_DEG: 52.0722229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009600',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8072016,
        LOCATION_LATITUDE_DEG: 53.6147677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE009800',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5777807,
        LOCATION_LATITUDE_DEG: 53.6441667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010200',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.45824,
        LOCATION_LATITUDE_DEG: 51.3166413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010300',
        LOCATION_NAME: 'Netherton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3937271,
        LOCATION_LATITUDE_DEG: 51.6917757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010600',
        LOCATION_NAME: 'Netherton Colliery',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6211267,
        LOCATION_LATITUDE_DEG: 55.1352099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010700',
        LOCATION_NAME: 'Nethertown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5567967,
        LOCATION_LATITUDE_DEG: 54.4531721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010900',
        LOCATION_NAME: 'Netherwitton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8436519,
        LOCATION_LATITUDE_DEG: 55.2063272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011000',
        LOCATION_NAME: 'Nethy Bridge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6564849,
        LOCATION_LATITUDE_DEG: 57.2650484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011100',
        LOCATION_NAME: 'Netley Abbey',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3589402,
        LOCATION_LATITUDE_DEG: 50.879302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011200',
        LOCATION_NAME: 'Nettlebed',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9880076,
        LOCATION_LATITUDE_DEG: 51.5751617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011300',
        LOCATION_NAME: 'Nettlecombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6815764,
        LOCATION_LATITUDE_DEG: 50.7565065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011400',
        LOCATION_NAME: 'Nettleden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5209253,
        LOCATION_LATITUDE_DEG: 51.7834714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011500',
        LOCATION_NAME: 'Nettleham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4887288,
        LOCATION_LATITUDE_DEG: 53.264516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011700',
        LOCATION_NAME: 'Nettlestead',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4128765,
        LOCATION_LATITUDE_DEG: 51.2443078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011600',
        LOCATION_NAME: 'Nettlestead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0451238,
        LOCATION_LATITUDE_DEG: 52.1066849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011800',
        LOCATION_NAME: 'Nettlestone',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1159739,
        LOCATION_LATITUDE_DEG: 50.7108797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE011900',
        LOCATION_NAME: 'Nettlesworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5993469,
        LOCATION_LATITUDE_DEG: 54.8250866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012000',
        LOCATION_NAME: 'Nettleton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2581833,
        LOCATION_LATITUDE_DEG: 51.5037668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012100',
        LOCATION_NAME: 'Nettleton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3278202,
        LOCATION_LATITUDE_DEG: 53.486435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012200',
        LOCATION_NAME: 'Nettleton Top',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3214596,
        LOCATION_LATITUDE_DEG: 53.4673307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012300',
        LOCATION_NAME: 'Netton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8078783,
        LOCATION_LATITUDE_DEG: 51.1303327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012400',
        LOCATION_NAME: 'Nevendon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5336698,
        LOCATION_LATITUDE_DEG: 51.5945396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012500',
        LOCATION_NAME: 'Nevern',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7942808,
        LOCATION_LATITUDE_DEG: 52.0243441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012600',
        LOCATION_NAME: 'Nevill Holt',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7984336,
        LOCATION_LATITUDE_DEG: 52.5354517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012700',
        LOCATION_NAME: 'Nevilles Cross',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.593393,
        LOCATION_LATITUDE_DEG: 54.7715817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012800',
        LOCATION_NAME: 'Nevis Bridge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0890378,
        LOCATION_LATITUDE_DEG: 56.8215178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE012900',
        LOCATION_NAME: 'New Abbey',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6218783,
        LOCATION_LATITUDE_DEG: 54.9796192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013000',
        LOCATION_NAME: 'New Aberdour',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1930202,
        LOCATION_LATITUDE_DEG: 57.6602695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013100',
        LOCATION_NAME: 'New Addington',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0141983,
        LOCATION_LATITUDE_DEG: 51.3525284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013200',
        LOCATION_NAME: 'New Alston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2469905,
        LOCATION_LATITUDE_DEG: 54.9900105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013300',
        LOCATION_NAME: 'New Alyth',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2309942,
        LOCATION_LATITUDE_DEG: 56.6120829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013400',
        LOCATION_NAME: 'New Apley',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3356602,
        LOCATION_LATITUDE_DEG: 53.2589168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013500',
        LOCATION_NAME: 'New Ash Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3054982,
        LOCATION_LATITUDE_DEG: 51.366827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013600',
        LOCATION_NAME: 'New Balderton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7833011,
        LOCATION_LATITUDE_DEG: 53.0606991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013700',
        LOCATION_NAME: 'New Bank',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8544966,
        LOCATION_LATITUDE_DEG: 53.7271817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013800',
        LOCATION_NAME: 'New Barnet',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1680457,
        LOCATION_LATITUDE_DEG: 51.648558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE013900',
        LOCATION_NAME: 'New Basford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1670996,
        LOCATION_LATITUDE_DEG: 52.9716009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014000',
        LOCATION_NAME: 'New Bethel',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1673024,
        LOCATION_LATITUDE_DEG: 51.6518937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014100',
        LOCATION_NAME: 'New Bilton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2750784,
        LOCATION_LATITUDE_DEG: 52.3734423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014300',
        LOCATION_NAME: 'New Bolingbroke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.045879,
        LOCATION_LATITUDE_DEG: 53.1035974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014400',
        LOCATION_NAME: 'New Boston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6704174,
        LOCATION_LATITUDE_DEG: 53.4702638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014500',
        LOCATION_NAME: 'New Boultham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5523066,
        LOCATION_LATITUDE_DEG: 53.2233096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014600',
        LOCATION_NAME: 'New Bradwell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7916169,
        LOCATION_LATITUDE_DEG: 52.0631067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014700',
        LOCATION_NAME: 'New Brancepeth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6512072,
        LOCATION_LATITUDE_DEG: 54.7681756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014800',
        LOCATION_NAME: 'New Bridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.758787,
        LOCATION_LATITUDE_DEG: 50.2742735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015000',
        LOCATION_NAME: 'New Brighton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1160967,
        LOCATION_LATITUDE_DEG: 53.1807377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014900',
        LOCATION_NAME: 'New Brighton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.815083,
        LOCATION_LATITUDE_DEG: 53.824389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015100',
        LOCATION_NAME: 'New Brookend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.45612,
        LOCATION_LATITUDE_DEG: 51.7167967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015200',
        LOCATION_NAME: 'New Broughton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0273342,
        LOCATION_LATITUDE_DEG: 53.0559308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015300',
        LOCATION_NAME: 'New Buckenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0758165,
        LOCATION_LATITUDE_DEG: 52.4721189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015500',
        LOCATION_NAME: 'New Buildings',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3585454,
        LOCATION_LATITUDE_DEG: 54.9587501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015400',
        LOCATION_NAME: 'New Buildings',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7104668,
        LOCATION_LATITUDE_DEG: 50.8182234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015600',
        LOCATION_NAME: 'New Byth',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2980953,
        LOCATION_LATITUDE_DEG: 57.5743633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060200',
        LOCATION_NAME: 'New Charing Cross Hospital',
        COUNTY_NAME: 'London',
        POSTCODE: 'W6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2198108,
        LOCATION_LATITUDE_DEG: 51.4876082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015800',
        LOCATION_NAME: 'New Chesterton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1149747,
        LOCATION_LATITUDE_DEG: 52.217007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015900',
        LOCATION_NAME: 'New Costessey',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2216587,
        LOCATION_LATITUDE_DEG: 52.645337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016000',
        LOCATION_NAME: 'New Coundon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6408493,
        LOCATION_LATITUDE_DEG: 54.666872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016100',
        LOCATION_NAME: 'New Crofton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4154562,
        LOCATION_LATITUDE_DEG: 53.6514668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016200',
        LOCATION_NAME: 'New Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0059691,
        LOCATION_LATITUDE_DEG: 52.3733779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016300',
        LOCATION_NAME: 'New Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8304891,
        LOCATION_LATITUDE_DEG: 50.9673244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059400',
        LOCATION_NAME: 'New Cross',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.234347,
        LOCATION_LATITUDE_DEG: 53.4953952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060000',
        LOCATION_NAME: 'New Cross',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0341651,
        LOCATION_LATITUDE_DEG: 51.4765212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016400',
        LOCATION_NAME: 'New Cumnock',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1836667,
        LOCATION_LATITUDE_DEG: 55.3941662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016500',
        LOCATION_NAME: 'New Deer',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1912192,
        LOCATION_LATITUDE_DEG: 57.5121526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016600',
        LOCATION_NAME: 'New Durham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5382231,
        LOCATION_LATITUDE_DEG: 54.7753747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016700',
        LOCATION_NAME: 'New Duston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9515514,
        LOCATION_LATITUDE_DEG: 52.2587275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016800',
        LOCATION_NAME: 'New Earswick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0709451,
        LOCATION_LATITUDE_DEG: 53.9906952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE016900',
        LOCATION_NAME: 'New Edlington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1872857,
        LOCATION_LATITUDE_DEG: 53.4847443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017000',
        LOCATION_NAME: 'New Elgin',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.302804,
        LOCATION_LATITUDE_DEG: 57.6374828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017100',
        LOCATION_NAME: 'New Ellerby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2217699,
        LOCATION_LATITUDE_DEG: 53.8366664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060100',
        LOCATION_NAME: 'New Eltham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0720477,
        LOCATION_LATITUDE_DEG: 51.4382488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017200',
        LOCATION_NAME: 'New England',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.954199,
        LOCATION_LATITUDE_DEG: 50.8899243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017300',
        LOCATION_NAME: 'New England',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.492204,
        LOCATION_LATITUDE_DEG: 52.0541854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE061400',
        LOCATION_NAME: 'New Farnley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6200932,
        LOCATION_LATITUDE_DEG: 53.7772497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017500',
        LOCATION_NAME: 'New Galloway',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1391557,
        LOCATION_LATITUDE_DEG: 55.0756348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017600',
        LOCATION_NAME: 'New Gilston',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9213339,
        LOCATION_LATITUDE_DEG: 56.2618442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017700',
        LOCATION_NAME: 'New Ground',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6195445,
        LOCATION_LATITUDE_DEG: 51.7859748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017800',
        LOCATION_NAME: 'New Hackleton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8159689,
        LOCATION_LATITUDE_DEG: 52.1870211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE017900',
        LOCATION_NAME: 'New Hall Hey',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.289091,
        LOCATION_LATITUDE_DEG: 53.6953783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018000',
        LOCATION_NAME: 'New Hartley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5182646,
        LOCATION_LATITUDE_DEG: 55.0845097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018100',
        LOCATION_NAME: 'New Haw',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4934479,
        LOCATION_LATITUDE_DEG: 51.3487373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018200',
        LOCATION_NAME: 'New Hedges',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7064702,
        LOCATION_LATITUDE_DEG: 51.6920131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018300',
        LOCATION_NAME: 'New Herrington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4674118,
        LOCATION_LATITUDE_DEG: 54.8693826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018400',
        LOCATION_NAME: 'New Hinksey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2577067,
        LOCATION_LATITUDE_DEG: 51.7437801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018500',
        LOCATION_NAME: 'New Holkham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8070554,
        LOCATION_LATITUDE_DEG: 52.9215674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018600',
        LOCATION_NAME: 'New Holland',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3588065,
        LOCATION_LATITUDE_DEG: 53.6994608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018700',
        LOCATION_NAME: 'New Houghton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2531268,
        LOCATION_LATITUDE_DEG: 53.1800196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018800',
        LOCATION_NAME: 'New House',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3542533,
        LOCATION_LATITUDE_DEG: 51.4273334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE018900',
        LOCATION_NAME: 'New Hutton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6732597,
        LOCATION_LATITUDE_DEG: 54.3154442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019000',
        LOCATION_NAME: 'New Hythe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4494549,
        LOCATION_LATITUDE_DEG: 51.3099191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019600',
        LOCATION_NAME: 'New Inn',
        COUNTY_NAME: 'Carmarthenshire',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2259054,
        LOCATION_LATITUDE_DEG: 52.0075371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019100',
        LOCATION_NAME: 'New Inn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9825632,
        LOCATION_LATITUDE_DEG: 51.9084289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019200',
        LOCATION_NAME: 'New Inn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0064811,
        LOCATION_LATITUDE_DEG: 51.6908002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019700',
        LOCATION_NAME: 'New Invention',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.037211,
        LOCATION_LATITUDE_DEG: 52.3836664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020000',
        LOCATION_NAME: 'New Kyo',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7216367,
        LOCATION_LATITUDE_DEG: 54.8592845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020100',
        LOCATION_NAME: 'New Lambton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5064778,
        LOCATION_LATITUDE_DEG: 54.8491818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020200',
        LOCATION_NAME: 'New Leake',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0966843,
        LOCATION_LATITUDE_DEG: 53.0949935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020300',
        LOCATION_NAME: 'New Leeds',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0056026,
        LOCATION_LATITUDE_DEG: 57.5803564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020400',
        LOCATION_NAME: 'New Lodge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4811439,
        LOCATION_LATITUDE_DEG: 53.5784609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020500',
        LOCATION_NAME: 'New Longton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7444536,
        LOCATION_LATITUDE_DEG: 53.7262881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020600',
        LOCATION_NAME: 'New Luce',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8494761,
        LOCATION_LATITUDE_DEG: 54.9414335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020700',
        LOCATION_NAME: 'New Malden',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2538784,
        LOCATION_LATITUDE_DEG: 51.3982393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020800',
        LOCATION_NAME: 'New Marske',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0369014,
        LOCATION_LATITUDE_DEG: 54.5825479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE020900',
        LOCATION_NAME: 'New Micklefield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3252728,
        LOCATION_LATITUDE_DEG: 53.7878818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021000',
        LOCATION_NAME: 'New Mill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5202862,
        LOCATION_LATITUDE_DEG: 51.7904252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021200',
        LOCATION_NAME: 'New Mill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7486672,
        LOCATION_LATITUDE_DEG: 53.5736676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021100',
        LOCATION_NAME: 'New Mill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7362627,
        LOCATION_LATITUDE_DEG: 51.3549533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021300',
        LOCATION_NAME: 'New Mills',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9513861,
        LOCATION_LATITUDE_DEG: 50.3330881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021500',
        LOCATION_NAME: 'New Mills',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3302934,
        LOCATION_LATITUDE_DEG: 52.6002883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021400',
        LOCATION_NAME: 'New Mills',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9890432,
        LOCATION_LATITUDE_DEG: 52.646886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021600',
        LOCATION_NAME: 'New Mills',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0004057,
        LOCATION_LATITUDE_DEG: 53.365447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021800',
        LOCATION_NAME: 'New Milton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6558649,
        LOCATION_LATITUDE_DEG: 50.7557959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021900',
        LOCATION_NAME: 'New Moat',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8152556,
        LOCATION_LATITUDE_DEG: 51.8937312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059500',
        LOCATION_NAME: 'New Moston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1735703,
        LOCATION_LATITUDE_DEG: 53.5156622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022000',
        LOCATION_NAME: 'New Ollerton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0008791,
        LOCATION_LATITUDE_DEG: 53.2114172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022100',
        LOCATION_NAME: 'New Packington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4499993,
        LOCATION_LATITUDE_DEG: 52.7380806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990545',
        LOCATION_NAME: 'New Parks',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022300',
        LOCATION_NAME: 'New Penshaw',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.49112,
        LOCATION_LATITUDE_DEG: 54.8763867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022400',
        LOCATION_NAME: 'New Pitsligo',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1965309,
        LOCATION_LATITUDE_DEG: 57.5934633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022500',
        LOCATION_NAME: 'New Polzeath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9154629,
        LOCATION_LATITUDE_DEG: 50.5780112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022600',
        LOCATION_NAME: 'New Quay',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.364021,
        LOCATION_LATITUDE_DEG: 52.2124589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022800',
        LOCATION_NAME: 'New Rackheath',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3850702,
        LOCATION_LATITUDE_DEG: 52.6645321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022900',
        LOCATION_NAME: 'New Radnor',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1533336,
        LOCATION_LATITUDE_DEG: 52.2405481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023000',
        LOCATION_NAME: 'New Ridley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9065175,
        LOCATION_LATITUDE_DEG: 54.9283928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023100',
        LOCATION_NAME: 'New Romney',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9418473,
        LOCATION_LATITUDE_DEG: 50.9852793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023400',
        LOCATION_NAME: 'New Rossington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0578219,
        LOCATION_LATITUDE_DEG: 53.4790471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023500',
        LOCATION_NAME: 'New Sharlston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4211495,
        LOCATION_LATITUDE_DEG: 53.6743723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023600',
        LOCATION_NAME: 'New Shawbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6714493,
        LOCATION_LATITUDE_DEG: 58.3175811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023700',
        LOCATION_NAME: 'New Silksworth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3957143,
        LOCATION_LATITUDE_DEG: 54.8732892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023800',
        LOCATION_NAME: 'New Skelton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9687255,
        LOCATION_LATITUDE_DEG: 54.5596501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060500',
        LOCATION_NAME: 'New Southgate',
        COUNTY_NAME: 'London',
        POSTCODE: 'N11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1366026,
        LOCATION_LATITUDE_DEG: 51.6122334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023900',
        LOCATION_NAME: 'New Stevenston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9756104,
        LOCATION_LATITUDE_DEG: 55.8126123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024000',
        LOCATION_NAME: 'New Tolsta',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2208058,
        LOCATION_LATITUDE_DEG: 58.3678843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024200',
        LOCATION_NAME: 'New Town',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1036895,
        LOCATION_LATITUDE_DEG: 50.9662867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024100',
        LOCATION_NAME: 'New Town',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2307726,
        LOCATION_LATITUDE_DEG: 51.4446346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024500',
        LOCATION_NAME: 'New Town Row',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9024532,
        LOCATION_LATITUDE_DEG: 52.4942623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024600',
        LOCATION_NAME: 'New Tredegar',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2344168,
        LOCATION_LATITUDE_DEG: 51.7185987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024800',
        LOCATION_NAME: 'New Waltham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0576229,
        LOCATION_LATITUDE_DEG: 53.5254328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024900',
        LOCATION_NAME: 'New Whittington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.412128,
        LOCATION_LATITUDE_DEG: 53.2730309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025000',
        LOCATION_NAME: 'New Winton',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9190829,
        LOCATION_LATITUDE_DEG: 55.9295121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025100',
        LOCATION_NAME: 'New Works',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4977991,
        LOCATION_LATITUDE_DEG: 52.6729843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE061500',
        LOCATION_NAME: 'New Wortley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5754598,
        LOCATION_LATITUDE_DEG: 53.7922646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025200',
        LOCATION_NAME: 'New Yatt',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4554632,
        LOCATION_LATITUDE_DEG: 51.8136888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025300',
        LOCATION_NAME: 'New York',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1378609,
        LOCATION_LATITUDE_DEG: 53.0777924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025400',
        LOCATION_NAME: 'New Zealand',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9823806,
        LOCATION_LATITUDE_DEG: 51.4959654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059300',
        LOCATION_NAME: 'Newall Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2899995,
        LOCATION_LATITUDE_DEG: 53.3817526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990081',
        LOCATION_NAME: 'Newall With Clifton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.694988,
        LOCATION_LATITUDE_DEG: 53.9236513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025500',
        LOCATION_NAME: 'Newark',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8084133,
        LOCATION_LATITUDE_DEG: 53.0744033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025600',
        LOCATION_NAME: 'Newarthill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9371239,
        LOCATION_LATITUDE_DEG: 55.8148065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025700',
        LOCATION_NAME: 'Newball',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3877429,
        LOCATION_LATITUDE_DEG: 53.2738202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025800',
        LOCATION_NAME: 'Newbattle',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.06832,
        LOCATION_LATITUDE_DEG: 55.8836007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026100',
        LOCATION_NAME: 'Newbie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2771379,
        LOCATION_LATITUDE_DEG: 54.974614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990982',
        LOCATION_NAME: 'Newbiggin',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026300',
        LOCATION_NAME: 'Newbiggin',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1174548,
        LOCATION_LATITUDE_DEG: 54.1139326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026500',
        LOCATION_NAME: 'Newbiggin',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8221578,
        LOCATION_LATITUDE_DEG: 54.6563818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026400',
        LOCATION_NAME: 'Newbiggin',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1333056,
        LOCATION_LATITUDE_DEG: 54.6433696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026200',
        LOCATION_NAME: 'Newbiggin',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0029791,
        LOCATION_LATITUDE_DEG: 54.2691365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058800',
        LOCATION_NAME: 'Newbiggin by the Sea',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058900',
        LOCATION_NAME: 'Newbiggin on Lune',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026600',
        LOCATION_NAME: 'Newbiggin-by-the-Sea',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5105973,
        LOCATION_LATITUDE_DEG: 55.1850182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026900',
        LOCATION_NAME: 'Newbigging',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5691462,
        LOCATION_LATITUDE_DEG: 55.6955957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026800',
        LOCATION_NAME: 'Newbigging',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.15871,
        LOCATION_LATITUDE_DEG: 56.5647759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026700',
        LOCATION_NAME: 'Newbiggin-on-Lune',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4536418,
        LOCATION_LATITUDE_DEG: 54.440858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027100',
        LOCATION_NAME: 'Newbold',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.405238,
        LOCATION_LATITUDE_DEG: 52.769377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027300',
        LOCATION_NAME: 'Newbold',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2836587,
        LOCATION_LATITUDE_DEG: 52.390641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027200',
        LOCATION_NAME: 'Newbold Astbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2113568,
        LOCATION_LATITUDE_DEG: 53.1337261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027600',
        LOCATION_NAME: 'Newbold on Stour',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6384486,
        LOCATION_LATITUDE_DEG: 52.1125181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027400',
        LOCATION_NAME: 'Newbold Pacey',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5681786,
        LOCATION_LATITUDE_DEG: 52.2114316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027500',
        LOCATION_NAME: 'Newbold Verdon',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3405414,
        LOCATION_LATITUDE_DEG: 52.6293715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027800',
        LOCATION_NAME: 'Newborough',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3592121,
        LOCATION_LATITUDE_DEG: 53.1654495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027900',
        LOCATION_NAME: 'Newborough',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7982302,
        LOCATION_LATITUDE_DEG: 52.8256913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027700',
        LOCATION_NAME: 'Newborough',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2211714,
        LOCATION_LATITUDE_DEG: 52.6384516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028100',
        LOCATION_NAME: 'Newbottle',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.474439,
        LOCATION_LATITUDE_DEG: 54.8562824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028000',
        LOCATION_NAME: 'Newbottle',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2352184,
        LOCATION_LATITUDE_DEG: 52.0267075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028200',
        LOCATION_NAME: 'Newbourne',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3153753,
        LOCATION_LATITUDE_DEG: 52.0385707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028900',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6040422,
        LOCATION_LATITUDE_DEG: 50.1281753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028800',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0843172,
        LOCATION_LATITUDE_DEG: 50.2565814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028700',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3293768,
        LOCATION_LATITUDE_DEG: 50.4877944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028600',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.650943,
        LOCATION_LATITUDE_DEG: 55.0925364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028400',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4064974,
        LOCATION_LATITUDE_DEG: 55.9392184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029000',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1425682,
        LOCATION_LATITUDE_DEG: 51.6645918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029500',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1011879,
        LOCATION_LATITUDE_DEG: 52.7664046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028300',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0650973,
        LOCATION_LATITUDE_DEG: 52.966124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029100',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0327681,
        LOCATION_LATITUDE_DEG: 52.8229075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE028500',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1579035,
        LOCATION_LATITUDE_DEG: 52.5942751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029400',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4181268,
        LOCATION_LATITUDE_DEG: 51.7071771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029300',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.418074,
        LOCATION_LATITUDE_DEG: 50.686481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029200',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7677109,
        LOCATION_LATITUDE_DEG: 54.2590191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059000',
        LOCATION_NAME: 'Newbridge on Wye',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030000',
        LOCATION_NAME: 'Newbridge-on-Wye',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4401563,
        LOCATION_LATITUDE_DEG: 52.2132531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030100',
        LOCATION_NAME: 'Newbrough',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1994411,
        LOCATION_LATITUDE_DEG: 55.005412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030400',
        LOCATION_NAME: 'Newburgh',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2398339,
        LOCATION_LATITUDE_DEG: 56.3508568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030200',
        LOCATION_NAME: 'Newburgh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7809339,
        LOCATION_LATITUDE_DEG: 53.5859729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030300',
        LOCATION_NAME: 'Newburgh',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.00362,
        LOCATION_LATITUDE_DEG: 57.3193365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030500',
        LOCATION_NAME: 'Newburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7411781,
        LOCATION_LATITUDE_DEG: 54.9825984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030800',
        LOCATION_NAME: 'Newbury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.43197,
        LOCATION_LATITUDE_DEG: 51.2500466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030700',
        LOCATION_NAME: 'Newbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2723244,
        LOCATION_LATITUDE_DEG: 51.0366265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030600',
        LOCATION_NAME: 'Newbury',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3203903,
        LOCATION_LATITUDE_DEG: 51.3999519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990970',
        LOCATION_NAME: 'Newbury Park',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031000',
        LOCATION_NAME: 'Newby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8415069,
        LOCATION_LATITUDE_DEG: 54.9201055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031250',
        LOCATION_NAME: 'Newby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6307968,
        LOCATION_LATITUDE_DEG: 54.585347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031200',
        LOCATION_NAME: 'Newby',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4170568,
        LOCATION_LATITUDE_DEG: 54.1253276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE030900',
        LOCATION_NAME: 'Newby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2163452,
        LOCATION_LATITUDE_DEG: 54.5034435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031100',
        LOCATION_NAME: 'Newby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4467047,
        LOCATION_LATITUDE_DEG: 54.2929036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031300',
        LOCATION_NAME: 'Newby Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.966087,
        LOCATION_LATITUDE_DEG: 54.2667495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031400',
        LOCATION_NAME: 'Newby Cross',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9880267,
        LOCATION_LATITUDE_DEG: 54.8672059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031500',
        LOCATION_NAME: 'Newby East',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8177127,
        LOCATION_LATITUDE_DEG: 54.9171043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031600',
        LOCATION_NAME: 'Newby Hall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4600448,
        LOCATION_LATITUDE_DEG: 54.1063134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031700',
        LOCATION_NAME: 'Newby West',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9830481,
        LOCATION_LATITUDE_DEG: 54.8765038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031800',
        LOCATION_NAME: 'Newby Wiske',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4354258,
        LOCATION_LATITUDE_DEG: 54.2834278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032200',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8953139,
        LOCATION_LATITUDE_DEG: 54.2244722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE031900',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1049113,
        LOCATION_LATITUDE_DEG: 52.4343676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032100',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.800581,
        LOCATION_LATITUDE_DEG: 51.850909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032000',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.226512,
        LOCATION_LATITUDE_DEG: 53.0109111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032700',
        LOCATION_NAME: 'Newcastle Airport',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.695561,
        LOCATION_LATITUDE_DEG: 55.0322013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032800',
        LOCATION_NAME: 'Newcastle Emlyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4694752,
        LOCATION_LATITUDE_DEG: 52.0359482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032900',
        LOCATION_NAME: 'Newcastle Upon Tyne NE 1',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6111549,
        LOCATION_LATITUDE_DEG: 54.9715035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033000',
        LOCATION_NAME: 'Newcastle Upon Tyne NE 2',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6137208,
        LOCATION_LATITUDE_DEG: 54.9874012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033100',
        LOCATION_NAME: 'Newcastle Upon Tyne NE 3',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.630738,
        LOCATION_LATITUDE_DEG: 55.0149821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033200',
        LOCATION_NAME: 'Newcastle Upon Tyne NE 4',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6459551,
        LOCATION_LATITUDE_DEG: 54.9724545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033300',
        LOCATION_NAME: 'Newcastle Upon Tyne NE 5',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.700696,
        LOCATION_LATITUDE_DEG: 55.0024213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033400',
        LOCATION_NAME: 'Newcastle Upon Tyne NE 6',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5617161,
        LOCATION_LATITUDE_DEG: 54.9778692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033500',
        LOCATION_NAME: 'Newcastle Upon Tyne NE 7',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5810027,
        LOCATION_LATITUDE_DEG: 54.9999471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033600',
        LOCATION_NAME: 'Newcastle Upon Tyne NE12',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5656133,
        LOCATION_LATITUDE_DEG: 55.0250305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033650',
        LOCATION_NAME: 'Newcastle Upon Tyne NE13',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6644271,
        LOCATION_LATITUDE_DEG: 55.0561512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033700',
        LOCATION_NAME: 'Newcastle Upon Tyne NE15',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.718276,
        LOCATION_LATITUDE_DEG: 54.9837159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033800',
        LOCATION_NAME: 'Newcastle Upon Tyne NE16',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7114688,
        LOCATION_LATITUDE_DEG: 54.9326609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033850',
        LOCATION_NAME: 'Newcastle Upon Tyne NE17',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8206335,
        LOCATION_LATITUDE_DEG: 54.9358189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033888',
        LOCATION_NAME: 'Newcastle Upon Tyne NE23',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990454',
        LOCATION_NAME: 'Newcastle Upon Tyne NE27',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5246111,
        LOCATION_LATITUDE_DEG: 54.937655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE033900',
        LOCATION_NAME: 'Newcastle Upon Tyne NE28',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5179125,
        LOCATION_LATITUDE_DEG: 55.0004145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034100',
        LOCATION_NAME: 'Newcastleton',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8117637,
        LOCATION_LATITUDE_DEG: 55.1792364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034300',
        LOCATION_NAME: 'Newchapel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5832479,
        LOCATION_LATITUDE_DEG: 52.0247473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034400',
        LOCATION_NAME: 'Newchapel',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2045195,
        LOCATION_LATITUDE_DEG: 53.0884191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034500',
        LOCATION_NAME: 'Newchapel',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0489996,
        LOCATION_LATITUDE_DEG: 51.1640144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035000',
        LOCATION_NAME: 'Newchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1462693,
        LOCATION_LATITUDE_DEG: 52.1499427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034800',
        LOCATION_NAME: 'Newchurch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7867114,
        LOCATION_LATITUDE_DEG: 51.6739891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034600',
        LOCATION_NAME: 'Newchurch',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2680827,
        LOCATION_LATITUDE_DEG: 53.7001824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034700',
        LOCATION_NAME: 'Newchurch',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.206296,
        LOCATION_LATITUDE_DEG: 50.6643744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034900',
        LOCATION_NAME: 'Newchurch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9285893,
        LOCATION_LATITUDE_DEG: 51.0444895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035100',
        LOCATION_NAME: 'Newchurch In Pendle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2697377,
        LOCATION_LATITUDE_DEG: 53.8499008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035200',
        LOCATION_NAME: 'Newcott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.097103,
        LOCATION_LATITUDE_DEG: 50.8717244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035300',
        LOCATION_NAME: 'Newcraighall',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0856482,
        LOCATION_LATITUDE_DEG: 55.9350135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035400',
        LOCATION_NAME: 'Newcroft',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3472406,
        LOCATION_LATITUDE_DEG: 56.3418874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035500',
        LOCATION_NAME: 'Newdale',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4852926,
        LOCATION_LATITUDE_DEG: 52.6815864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035600',
        LOCATION_NAME: 'Newdigate',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2882127,
        LOCATION_LATITUDE_DEG: 51.1660156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035700',
        LOCATION_NAME: 'Newell Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7305887,
        LOCATION_LATITUDE_DEG: 51.4316404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035800',
        LOCATION_NAME: 'Newenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6156563,
        LOCATION_LATITUDE_DEG: 51.014884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE035900',
        LOCATION_NAME: 'Newent',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.404477,
        LOCATION_LATITUDE_DEG: 51.9302146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036000',
        LOCATION_NAME: 'Newfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6809261,
        LOCATION_LATITUDE_DEG: 54.6973717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036100',
        LOCATION_NAME: 'Newfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6223921,
        LOCATION_LATITUDE_DEG: 54.8660896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036200',
        LOCATION_NAME: 'Newfound',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1692157,
        LOCATION_LATITUDE_DEG: 51.2563311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036300',
        LOCATION_NAME: 'Newgale',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1231399,
        LOCATION_LATITUDE_DEG: 51.8538349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036400',
        LOCATION_NAME: 'Newgate Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1154648,
        LOCATION_LATITUDE_DEG: 51.728369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036500',
        LOCATION_NAME: 'Newhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5839045,
        LOCATION_LATITUDE_DEG: 53.0034181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036600',
        LOCATION_NAME: 'Newhall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5753811,
        LOCATION_LATITUDE_DEG: 52.7847807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036700',
        LOCATION_NAME: 'Newhall Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.726875,
        LOCATION_LATITUDE_DEG: 50.6065114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037000',
        LOCATION_NAME: 'Newham',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2831422,
        LOCATION_LATITUDE_DEG: 50.1062656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036800',
        LOCATION_NAME: 'Newham',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0550318,
        LOCATION_LATITUDE_DEG: 50.2528842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE036900',
        LOCATION_NAME: 'Newham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7237402,
        LOCATION_LATITUDE_DEG: 55.5492537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037200',
        LOCATION_NAME: 'Newhaven',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7514293,
        LOCATION_LATITUDE_DEG: 53.1375199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037100',
        LOCATION_NAME: 'Newhaven',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0495359,
        LOCATION_LATITUDE_DEG: 50.7923762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037300',
        LOCATION_NAME: 'Newholm',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6617454,
        LOCATION_LATITUDE_DEG: 54.4827387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037400',
        LOCATION_NAME: 'Newhouse',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.929225,
        LOCATION_LATITUDE_DEG: 55.8313066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037500',
        LOCATION_NAME: 'Newick',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.017492,
        LOCATION_LATITUDE_DEG: 50.9746886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037600',
        LOCATION_NAME: 'Newingreen',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.038685,
        LOCATION_LATITUDE_DEG: 51.0845866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE061100',
        LOCATION_NAME: 'Newington',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1778845,
        LOCATION_LATITUDE_DEG: 55.9388392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038200',
        LOCATION_NAME: 'Newington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8361143,
        LOCATION_LATITUDE_DEG: 52.4448636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038000',
        LOCATION_NAME: 'Newington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2555505,
        LOCATION_LATITUDE_DEG: 51.6511851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038100',
        LOCATION_NAME: 'Newington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1190438,
        LOCATION_LATITUDE_DEG: 51.6665757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037900',
        LOCATION_NAME: 'Newington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9938329,
        LOCATION_LATITUDE_DEG: 53.4389429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037700',
        LOCATION_NAME: 'Newington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6694252,
        LOCATION_LATITUDE_DEG: 51.3515225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE037800',
        LOCATION_NAME: 'Newington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1166223,
        LOCATION_LATITUDE_DEG: 51.0925905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059900',
        LOCATION_NAME: 'Newington Butts',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1037928,
        LOCATION_LATITUDE_DEG: 51.4912934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060400',
        LOCATION_NAME: 'Newington Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'N1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038700',
        LOCATION_NAME: 'Newland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0743732,
        LOCATION_LATITUDE_DEG: 54.2086371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038800',
        LOCATION_NAME: 'Newland',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.646988,
        LOCATION_LATITUDE_DEG: 51.7820029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990228',
        LOCATION_NAME: 'Newland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3009546,
        LOCATION_LATITUDE_DEG: 52.1360665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038400',
        LOCATION_NAME: 'Newland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2993795,
        LOCATION_LATITUDE_DEG: 52.1343351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038500',
        LOCATION_NAME: 'Newland',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9560844,
        LOCATION_LATITUDE_DEG: 53.7149649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990352',
        LOCATION_NAME: 'Newland',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7885216,
        LOCATION_LATITUDE_DEG: 53.75074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038600',
        LOCATION_NAME: 'Newland',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3564559,
        LOCATION_LATITUDE_DEG: 53.7663608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE061200',
        LOCATION_NAME: 'Newlands',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2942819,
        LOCATION_LATITUDE_DEG: 55.8169122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038900',
        LOCATION_NAME: 'Newlands',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0095557,
        LOCATION_LATITUDE_DEG: 54.7476955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039000',
        LOCATION_NAME: 'Newlands',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7253521,
        LOCATION_LATITUDE_DEG: 52.0462047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039100',
        LOCATION_NAME: 'Newlyn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5515312,
        LOCATION_LATITUDE_DEG: 50.098771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039200',
        LOCATION_NAME: 'Newlyn East',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0529189,
        LOCATION_LATITUDE_DEG: 50.3660912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039300',
        LOCATION_NAME: 'Newmachar',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1889627,
        LOCATION_LATITUDE_DEG: 57.2658303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039400',
        LOCATION_NAME: 'Newmains',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8816737,
        LOCATION_LATITUDE_DEG: 55.7818014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039500',
        LOCATION_NAME: 'Newmarket',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3887288,
        LOCATION_LATITUDE_DEG: 58.2308766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE060800',
        LOCATION_NAME: 'Newmarket',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4057672,
        LOCATION_LATITUDE_DEG: 53.3226719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039600',
        LOCATION_NAME: 'Newmarket',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4050058,
        LOCATION_LATITUDE_DEG: 52.2448069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040200',
        LOCATION_NAME: 'Newmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5591549,
        LOCATION_LATITUDE_DEG: 50.1511739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040100',
        LOCATION_NAME: 'Newmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0768107,
        LOCATION_LATITUDE_DEG: 50.2711844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040000',
        LOCATION_NAME: 'Newmill',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9435142,
        LOCATION_LATITUDE_DEG: 57.5588658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040300',
        LOCATION_NAME: 'Newmill End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3723951,
        LOCATION_LATITUDE_DEG: 51.8498815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040350',
        LOCATION_NAME: 'Newmill on Teviot',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.867726,
        LOCATION_LATITUDE_DEG: 55.3830843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040400',
        LOCATION_NAME: 'Newmillerdam',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.505062,
        LOCATION_LATITUDE_DEG: 53.6347639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990769',
        LOCATION_NAME: 'Newmills',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040500',
        LOCATION_NAME: 'Newmills',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5856963,
        LOCATION_LATITUDE_DEG: 56.0603263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040600',
        LOCATION_NAME: 'Newmilns',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3328587,
        LOCATION_LATITUDE_DEG: 55.6062957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040700',
        LOCATION_NAME: 'Newnes',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9139744,
        LOCATION_LATITUDE_DEG: 52.9001141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040800',
        LOCATION_NAME: 'Newney Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3929203,
        LOCATION_LATITUDE_DEG: 51.7359583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041100',
        LOCATION_NAME: 'Newnham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4487344,
        LOCATION_LATITUDE_DEG: 51.8027993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041200',
        LOCATION_NAME: 'Newnham',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1495688,
        LOCATION_LATITUDE_DEG: 52.2321222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041000',
        LOCATION_NAME: 'Newnham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9882932,
        LOCATION_LATITUDE_DEG: 51.280232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041300',
        LOCATION_NAME: 'Newnham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1862178,
        LOCATION_LATITUDE_DEG: 52.020595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE040900',
        LOCATION_NAME: 'Newnham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8029349,
        LOCATION_LATITUDE_DEG: 51.2840058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041400',
        LOCATION_NAME: 'Newnham Bridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5229003,
        LOCATION_LATITUDE_DEG: 52.3191492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041500',
        LOCATION_NAME: 'Newnham Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0059864,
        LOCATION_LATITUDE_DEG: 51.5574648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041600',
        LOCATION_NAME: 'Newnham Paddox',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2954439,
        LOCATION_LATITUDE_DEG: 52.4488494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041700',
        LOCATION_NAME: 'Newpark',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7354672,
        LOCATION_LATITUDE_DEG: 58.2112709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990514',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041800',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8280098,
        LOCATION_LATITUDE_DEG: 52.0163432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990376',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.018307,
        LOCATION_LATITUDE_DEG: 51.4947386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042200',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9933667,
        LOCATION_LATITUDE_DEG: 51.5853836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042100',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4330813,
        LOCATION_LATITUDE_DEG: 51.6812925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE041900',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3779059,
        LOCATION_LATITUDE_DEG: 52.7690972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042000',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2879894,
        LOCATION_LATITUDE_DEG: 50.6961829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042400',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6973646,
        LOCATION_LATITUDE_DEG: 53.7624685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042300',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2147546,
        LOCATION_LATITUDE_DEG: 51.9835822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058700',
        LOCATION_NAME: 'Newport on Tay',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042700',
        LOCATION_NAME: 'Newport Pagnell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7207328,
        LOCATION_LATITUDE_DEG: 52.0864036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042800',
        LOCATION_NAME: 'Newport-on-Tay',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9399202,
        LOCATION_LATITUDE_DEG: 56.4402593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042900',
        LOCATION_NAME: 'Newquay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0663933,
        LOCATION_LATITUDE_DEG: 50.414696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043000',
        LOCATION_NAME: 'Newry',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.342445,
        LOCATION_LATITUDE_DEG: 54.1814721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043100',
        LOCATION_NAME: 'Newsells',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0155701,
        LOCATION_LATITUDE_DEG: 52.0186168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043400',
        LOCATION_NAME: 'Newsham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8366434,
        LOCATION_LATITUDE_DEG: 54.485254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043200',
        LOCATION_NAME: 'Newsham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5263692,
        LOCATION_LATITUDE_DEG: 55.1146126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043300',
        LOCATION_NAME: 'Newsham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4178328,
        LOCATION_LATITUDE_DEG: 54.2575293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043500',
        LOCATION_NAME: 'Newsham Bridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8539803,
        LOCATION_LATITUDE_DEG: 54.1738098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043700',
        LOCATION_NAME: 'Newsholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2436932,
        LOCATION_LATITUDE_DEG: 53.9593062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043600',
        LOCATION_NAME: 'Newsholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9069249,
        LOCATION_LATITUDE_DEG: 53.7569664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043800',
        LOCATION_NAME: 'Newsome',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7850039,
        LOCATION_LATITUDE_DEG: 53.6275666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE043900',
        LOCATION_NAME: 'Newstead',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6977919,
        LOCATION_LATITUDE_DEG: 55.5995751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044000',
        LOCATION_NAME: 'Newstead',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4492001,
        LOCATION_LATITUDE_DEG: 52.6612579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044100',
        LOCATION_NAME: 'Newstead Abbey Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1924916,
        LOCATION_LATITUDE_DEG: 53.0786093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044200',
        LOCATION_NAME: 'Newstead Village',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2232645,
        LOCATION_LATITUDE_DEG: 53.0685112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044300',
        LOCATION_NAME: 'Newthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2845831,
        LOCATION_LATITUDE_DEG: 53.7846795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044400',
        LOCATION_NAME: 'Newthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2845673,
        LOCATION_LATITUDE_DEG: 53.013506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044500',
        LOCATION_NAME: 'Newtimber',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1908335,
        LOCATION_LATITUDE_DEG: 50.9108877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044600',
        LOCATION_NAME: 'Newtoft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4246663,
        LOCATION_LATITUDE_DEG: 53.3644276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990388',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047200',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1218858,
        LOCATION_LATITUDE_DEG: 55.8202148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046900',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0991404,
        LOCATION_LATITUDE_DEG: 57.5116757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045800',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.047407,
        LOCATION_LATITUDE_DEG: 57.6693925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046500',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0141831,
        LOCATION_LATITUDE_DEG: 51.5744965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045400',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6799607,
        LOCATION_LATITUDE_DEG: 51.4846174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047100',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4544521,
        LOCATION_LATITUDE_DEG: 55.9840184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044800',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4376436,
        LOCATION_LATITUDE_DEG: 51.4765793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045000',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0377631,
        LOCATION_LATITUDE_DEG: 52.2058425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047300',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8610248,
        LOCATION_LATITUDE_DEG: 52.9037104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046600',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8346582,
        LOCATION_LATITUDE_DEG: 53.772843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044900',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7415355,
        LOCATION_LATITUDE_DEG: 53.1308316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045600',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7232923,
        LOCATION_LATITUDE_DEG: 52.1799372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045900',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7085378,
        LOCATION_LATITUDE_DEG: 53.2683475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047350',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6176111,
        LOCATION_LATITUDE_DEG: 54.1647169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047000',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5079317,
        LOCATION_LATITUDE_DEG: 51.6274882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046800',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3102808,
        LOCATION_LATITUDE_DEG: 50.9191149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046100',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9439983,
        LOCATION_LATITUDE_DEG: 52.8261912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045300',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9406179,
        LOCATION_LATITUDE_DEG: 54.9705018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046300',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3361967,
        LOCATION_LATITUDE_DEG: 53.1296182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE044700',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2197376,
        LOCATION_LATITUDE_DEG: 52.3976453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045500',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1465857,
        LOCATION_LATITUDE_DEG: 53.5195476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045700',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9709875,
        LOCATION_LATITUDE_DEG: 52.9684917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046200',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7047874,
        LOCATION_LATITUDE_DEG: 52.4441435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045100',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4420105,
        LOCATION_LATITUDE_DEG: 52.9128787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE045200',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1008796,
        LOCATION_LATITUDE_DEG: 52.1242984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046400',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1266612,
        LOCATION_LATITUDE_DEG: 52.7090532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046700',
        LOCATION_NAME: 'Newton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7941135,
        LOCATION_LATITUDE_DEG: 52.0314805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047400',
        LOCATION_NAME: 'Newton Abbot',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6118735,
        LOCATION_LATITUDE_DEG: 50.5293937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047500',
        LOCATION_NAME: 'Newton Arlosh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2432504,
        LOCATION_LATITUDE_DEG: 54.8862083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047600',
        LOCATION_NAME: 'Newton Aycliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5704826,
        LOCATION_LATITUDE_DEG: 54.6183603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047700',
        LOCATION_NAME: 'Newton Bewley',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2789453,
        LOCATION_LATITUDE_DEG: 54.632956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047800',
        LOCATION_NAME: 'Newton Blossomville',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6472738,
        LOCATION_LATITUDE_DEG: 52.1532136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE047900',
        LOCATION_NAME: 'Newton Bromswold',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5351106,
        LOCATION_LATITUDE_DEG: 52.2833208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048000',
        LOCATION_NAME: 'Newton Burgoland',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4531202,
        LOCATION_LATITUDE_DEG: 52.6780726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050900',
        LOCATION_NAME: 'Newton by Toft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4212554,
        LOCATION_LATITUDE_DEG: 53.372528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048100',
        LOCATION_NAME: 'Newton Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2411303,
        LOCATION_LATITUDE_DEG: 50.6483122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048200',
        LOCATION_NAME: 'Newton Ferrers',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0372561,
        LOCATION_LATITUDE_DEG: 50.3141802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048300',
        LOCATION_NAME: 'Newton Flotman',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2634503,
        LOCATION_LATITUDE_DEG: 52.5377224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048400',
        LOCATION_NAME: 'Newton Grange',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7535022,
        LOCATION_LATITUDE_DEG: 53.0783156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048500',
        LOCATION_NAME: 'Newton Harcourt',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0591875,
        LOCATION_LATITUDE_DEG: 52.5671588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059600',
        LOCATION_NAME: 'Newton Heath',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1833539,
        LOCATION_LATITUDE_DEG: 53.5005274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048600',
        LOCATION_NAME: 'Newton Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.507214,
        LOCATION_LATITUDE_DEG: 53.6992711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051000',
        LOCATION_NAME: 'Newton in Bowland',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4709608,
        LOCATION_LATITUDE_DEG: 53.9448054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051100',
        LOCATION_NAME: 'Newton in Cartmel',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9153938,
        LOCATION_LATITUDE_DEG: 54.2347408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051200',
        LOCATION_NAME: 'Newton in Furness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1784971,
        LOCATION_LATITUDE_DEG: 54.1342771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048700',
        LOCATION_NAME: 'Newton Kyme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2939913,
        LOCATION_LATITUDE_DEG: 53.8977919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058300',
        LOCATION_NAME: 'Newton le Willows',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051300',
        LOCATION_NAME: 'Newton le Willows',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6751622,
        LOCATION_LATITUDE_DEG: 54.3029266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048800',
        LOCATION_NAME: 'Newton Longville',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7645111,
        LOCATION_LATITUDE_DEG: 51.9741984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE048900',
        LOCATION_NAME: 'Newton Mearns',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3360912,
        LOCATION_LATITUDE_DEG: 55.7729067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049000',
        LOCATION_NAME: 'Newton Morrell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6290467,
        LOCATION_LATITUDE_DEG: 54.479753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049100',
        LOCATION_NAME: 'Newton Morrell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1003843,
        LOCATION_LATITUDE_DEG: 51.9596997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049200',
        LOCATION_NAME: 'Newton Mulgrave',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7801642,
        LOCATION_LATITUDE_DEG: 54.5284405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051400',
        LOCATION_NAME: 'Newton of Belltrees',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5900093,
        LOCATION_LATITUDE_DEG: 55.7883121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051500',
        LOCATION_NAME: 'Newton of Falkland',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1798293,
        LOCATION_LATITUDE_DEG: 56.2508439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051600',
        LOCATION_NAME: 'Newton of Ferintosh',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.394132,
        LOCATION_LATITUDE_DEG: 57.5442836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051700',
        LOCATION_NAME: 'Newton of Pitcairn',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5790894,
        LOCATION_LATITUDE_DEG: 56.3097491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051800',
        LOCATION_NAME: 'Newton on Derwent',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9027294,
        LOCATION_LATITUDE_DEG: 53.9345864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE051900',
        LOCATION_NAME: 'Newton on Ouse',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2197372,
        LOCATION_LATITUDE_DEG: 54.0338036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058400',
        LOCATION_NAME: 'Newton on Rawcliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058600',
        LOCATION_NAME: 'Newton on the Moor',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058500',
        LOCATION_NAME: 'Newton on Trent',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE061600',
        LOCATION_NAME: 'Newton Park',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5360252,
        LOCATION_LATITUDE_DEG: 53.8314638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059700',
        LOCATION_NAME: 'Newton Park Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049300',
        LOCATION_NAME: 'Newton Poppleford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2987383,
        LOCATION_LATITUDE_DEG: 50.699505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049400',
        LOCATION_NAME: 'Newton Purcell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0886838,
        LOCATION_LATITUDE_DEG: 51.971803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049500',
        LOCATION_NAME: 'Newton Regis',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5906975,
        LOCATION_LATITUDE_DEG: 52.6631724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049600',
        LOCATION_NAME: 'Newton Reigny',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8083363,
        LOCATION_LATITUDE_DEG: 54.6785853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049700',
        LOCATION_NAME: 'Newton Rigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.810247,
        LOCATION_LATITUDE_DEG: 54.6756155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049800',
        LOCATION_NAME: 'Newton Solney',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5811109,
        LOCATION_LATITUDE_DEG: 52.8273894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057700',
        LOCATION_NAME: 'Newton St Cyres',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058100',
        LOCATION_NAME: 'Newton St Faith',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057900',
        LOCATION_NAME: 'Newton St Loe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058000',
        LOCATION_NAME: 'Newton St Petrock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE049900',
        LOCATION_NAME: 'Newton St. Cyres',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5888829,
        LOCATION_LATITUDE_DEG: 50.7704113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050000',
        LOCATION_NAME: 'Newton St. Faith',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2841133,
        LOCATION_LATITUDE_DEG: 52.7055397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050100',
        LOCATION_NAME: 'Newton St. Loe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4219787,
        LOCATION_LATITUDE_DEG: 51.3810639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE046000',
        LOCATION_NAME: 'Newton St. Margarets',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9515301,
        LOCATION_LATITUDE_DEG: 51.9904222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050200',
        LOCATION_NAME: 'Newton St. Petrock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2551118,
        LOCATION_LATITUDE_DEG: 50.8875348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050300',
        LOCATION_NAME: 'Newton Stacey',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.411549,
        LOCATION_LATITUDE_DEG: 51.1612236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050400',
        LOCATION_NAME: 'Newton Stewart',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4842316,
        LOCATION_LATITUDE_DEG: 54.9588269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050500',
        LOCATION_NAME: 'Newton Toney',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6895449,
        LOCATION_LATITUDE_DEG: 51.1608348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050600',
        LOCATION_NAME: 'Newton Tracey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0998772,
        LOCATION_LATITUDE_DEG: 51.0216447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052000',
        LOCATION_NAME: 'Newton under Roseberry',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1184762,
        LOCATION_LATITUDE_DEG: 54.5097445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050700',
        LOCATION_NAME: 'Newton Underwood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7660355,
        LOCATION_LATITUDE_DEG: 55.1688172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE050800',
        LOCATION_NAME: 'Newton Valence',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9667326,
        LOCATION_LATITUDE_DEG: 51.0886123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052500',
        LOCATION_NAME: 'Newtonairds',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7556345,
        LOCATION_LATITUDE_DEG: 55.1039348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052600',
        LOCATION_NAME: 'Newtondee Village',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1964042,
        LOCATION_LATITUDE_DEG: 57.109218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052700',
        LOCATION_NAME: 'Newtongrange',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0660429,
        LOCATION_LATITUDE_DEG: 55.8711022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052800',
        LOCATION_NAME: 'Newtonhill',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1434829,
        LOCATION_LATITUDE_DEG: 57.0318099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052100',
        LOCATION_NAME: 'Newton-le-Willows',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6334703,
        LOCATION_LATITUDE_DEG: 53.4558662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052900',
        LOCATION_NAME: 'Newtonmore',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1194423,
        LOCATION_LATITUDE_DEG: 57.0663368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052200',
        LOCATION_NAME: 'Newton-on-Rawcliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7516325,
        LOCATION_LATITUDE_DEG: 54.3033221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052400',
        LOCATION_NAME: 'Newton-on-the-Moor',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7318562,
        LOCATION_LATITUDE_DEG: 55.3394077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE052300',
        LOCATION_NAME: 'Newton-on-Trent',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7497712,
        LOCATION_LATITUDE_DEG: 53.259232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990698',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054100',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.078347,
        LOCATION_LATITUDE_DEG: 56.2246619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054200',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6596674,
        LOCATION_LATITUDE_DEG: 50.3425875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054800',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7561711,
        LOCATION_LATITUDE_DEG: 51.0128369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054500',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3128078,
        LOCATION_LATITUDE_DEG: 52.5127803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053600',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2029439,
        LOCATION_LATITUDE_DEG: 51.7814056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054400',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7802157,
        LOCATION_LATITUDE_DEG: 54.9572107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990102',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7628033,
        LOCATION_LATITUDE_DEG: 52.2160506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054300',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7557681,
        LOCATION_LATITUDE_DEG: 52.8758096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054900',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.744497,
        LOCATION_LATITUDE_DEG: 53.116231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053300',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6361299,
        LOCATION_LATITUDE_DEG: 53.5430694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053700',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5584068,
        LOCATION_LATITUDE_DEG: 52.1007354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053200',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5095264,
        LOCATION_LATITUDE_DEG: 51.8353098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053500',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4719523,
        LOCATION_LATITUDE_DEG: 51.713497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053000',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3028088,
        LOCATION_LATITUDE_DEG: 51.746894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053900',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1415941,
        LOCATION_LATITUDE_DEG: 53.1434308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053100',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1179926,
        LOCATION_LATITUDE_DEG: 51.0601227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054000',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9342175,
        LOCATION_LATITUDE_DEG: 55.5200539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054700',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.627534,
        LOCATION_LATITUDE_DEG: 54.7002752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990310',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5008288,
        LOCATION_LATITUDE_DEG: 51.4451303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053800',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3995253,
        LOCATION_LATITUDE_DEG: 50.7132875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE053400',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3152291,
        LOCATION_LATITUDE_DEG: 51.3662437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE054600',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1280794,
        LOCATION_LATITUDE_DEG: 50.9078986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055200',
        LOCATION_NAME: 'Newtown Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3176233,
        LOCATION_LATITUDE_DEG: 51.3646479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055300',
        LOCATION_NAME: 'Newtown Crommelin',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2156171,
        LOCATION_LATITUDE_DEG: 54.9832424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055800',
        LOCATION_NAME: 'Newtown Linford',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2294863,
        LOCATION_LATITUDE_DEG: 52.6829707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057800',
        LOCATION_NAME: 'Newtown St Boswells',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990511',
        LOCATION_NAME: 'Newtown St. Boswells',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056100',
        LOCATION_NAME: 'Newtown St. Boswells',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6712498,
        LOCATION_LATITUDE_DEG: 55.5779667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056300',
        LOCATION_NAME: 'Newtown Unthank',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2757272,
        LOCATION_LATITUDE_DEG: 52.6341628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056500',
        LOCATION_NAME: 'Newtownabbey',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9184009,
        LOCATION_LATITUDE_DEG: 54.6767127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056600',
        LOCATION_NAME: 'Newtownards',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6937761,
        LOCATION_LATITUDE_DEG: 54.5957002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056700',
        LOCATION_NAME: 'Newtownbreda',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9036865,
        LOCATION_LATITUDE_DEG: 54.559502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056900',
        LOCATION_NAME: 'Newtownbutler',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3466618,
        LOCATION_LATITUDE_DEG: 54.1816717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057000',
        LOCATION_NAME: 'Newtownhamilton',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5796712,
        LOCATION_LATITUDE_DEG: 54.1947755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990358',
        LOCATION_NAME: 'Newtownsteward',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3769304,
        LOCATION_LATITUDE_DEG: 54.7178292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990530',
        LOCATION_NAME: 'Newtownstewart',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3769304,
        LOCATION_LATITUDE_DEG: 54.7178292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057300',
        LOCATION_NAME: 'Newtyle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1458931,
        LOCATION_LATITUDE_DEG: 56.5585688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057400',
        LOCATION_NAME: 'Newvalley',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4060334,
        LOCATION_LATITUDE_DEG: 58.2257737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057500',
        LOCATION_NAME: 'Next Ness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0687102,
        LOCATION_LATITUDE_DEG: 54.2007413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057600',
        LOCATION_NAME: 'Neyland',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9511549,
        LOCATION_LATITUDE_DEG: 51.7132186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000100',
        LOCATION_NAME: 'Nibthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0707194,
        LOCATION_LATITUDE_DEG: 54.298549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000200',
        LOCATION_NAME: 'Nicholashayne',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2767208,
        LOCATION_LATITUDE_DEG: 50.938629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000300',
        LOCATION_NAME: 'Nicholaston',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.145428,
        LOCATION_LATITUDE_DEG: 51.574796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI990916',
        LOCATION_NAME: 'Nickley Wood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000500',
        LOCATION_NAME: 'Nidd',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5407623,
        LOCATION_LATITUDE_DEG: 54.042703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000600',
        LOCATION_NAME: 'Niddrie',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1257644,
        LOCATION_LATITUDE_DEG: 55.9321103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI002300',
        LOCATION_NAME: 'Niddrie Mains',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000800',
        LOCATION_NAME: 'Nigg',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0069675,
        LOCATION_LATITUDE_DEG: 57.7184014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000700',
        LOCATION_NAME: 'Nigg',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0886034,
        LOCATION_LATITUDE_DEG: 57.1173184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000900',
        LOCATION_NAME: 'Nimble Nook',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1430404,
        LOCATION_LATITUDE_DEG: 53.5327646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001000',
        LOCATION_NAME: 'Nimmer',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9627939,
        LOCATION_LATITUDE_DEG: 50.8916165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001100',
        LOCATION_NAME: 'Nine Ashes',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3059318,
        LOCATION_LATITUDE_DEG: 51.7003556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001200',
        LOCATION_NAME: 'Nine Elms',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8353701,
        LOCATION_LATITUDE_DEG: 51.5691757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001300',
        LOCATION_NAME: 'Nine Mile Burn',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3102907,
        LOCATION_LATITUDE_DEG: 55.8047042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001400',
        LOCATION_NAME: 'Ninebanks',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3395217,
        LOCATION_LATITUDE_DEG: 54.8731943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001600',
        LOCATION_NAME: 'Ninfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4268961,
        LOCATION_LATITUDE_DEG: 50.8858782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001700',
        LOCATION_NAME: 'Ningwood',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4341053,
        LOCATION_LATITUDE_DEG: 50.7001856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001800',
        LOCATION_NAME: 'Ninham',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1969077,
        LOCATION_LATITUDE_DEG: 50.6406739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001900',
        LOCATION_NAME: 'Niton',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2844201,
        LOCATION_LATITUDE_DEG: 50.584474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI002000',
        LOCATION_NAME: 'Niton Undercliff',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2869004,
        LOCATION_LATITUDE_DEG: 50.5820698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI002100',
        LOCATION_NAME: 'Nitshill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.361625,
        LOCATION_LATITUDE_DEG: 55.8151157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI002200',
        LOCATION_NAME: 'Niwbwrch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3591731,
        LOCATION_LATITUDE_DEG: 53.1655582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000100',
        LOCATION_NAME: 'No Mans Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5727416,
        LOCATION_LATITUDE_DEG: 52.6772155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000200',
        LOCATION_NAME: 'Noak Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2288107,
        LOCATION_LATITUDE_DEG: 51.6207473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000400',
        LOCATION_NAME: 'Nobold',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7889846,
        LOCATION_LATITUDE_DEG: 52.6874885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000500',
        LOCATION_NAME: 'Nobottle',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0154459,
        LOCATION_LATITUDE_DEG: 52.2617233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000600',
        LOCATION_NAME: 'Nobridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.521554,
        LOCATION_LATITUDE_DEG: 52.9235138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000700',
        LOCATION_NAME: 'Nocton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.41782,
        LOCATION_LATITUDE_DEG: 53.1656046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000800',
        LOCATION_NAME: 'Nocton Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.347301,
        LOCATION_LATITUDE_DEG: 53.1829076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000900',
        LOCATION_NAME: 'Nocton Heath',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4659336,
        LOCATION_LATITUDE_DEG: 53.1585109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001200',
        LOCATION_NAME: 'Noke',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2108385,
        LOCATION_LATITUDE_DEG: 51.8139832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001300',
        LOCATION_NAME: 'Nolton Haven',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1065285,
        LOCATION_LATITUDE_DEG: 51.8248341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001400',
        LOCATION_NAME: 'Nomans Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7236552,
        LOCATION_LATITUDE_DEG: 53.0238312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001500',
        LOCATION_NAME: 'Nomansland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6575935,
        LOCATION_LATITUDE_DEG: 50.912428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001600',
        LOCATION_NAME: 'Nomansland',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6392391,
        LOCATION_LATITUDE_DEG: 50.9540082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001700',
        LOCATION_NAME: 'Nomanswood',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3600142,
        LOCATION_LATITUDE_DEG: 51.0453896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001800',
        LOCATION_NAME: 'Noneley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7731593,
        LOCATION_LATITUDE_DEG: 52.8460015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001900',
        LOCATION_NAME: 'Nonington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2354332,
        LOCATION_LATITUDE_DEG: 51.222502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002000',
        LOCATION_NAME: 'Norbreck',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0480944,
        LOCATION_LATITUDE_DEG: 53.8561083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002300',
        LOCATION_NAME: 'Norbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9384147,
        LOCATION_LATITUDE_DEG: 52.5294776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990291',
        LOCATION_NAME: 'Norbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6568069,
        LOCATION_LATITUDE_DEG: 53.0226278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002100',
        LOCATION_NAME: 'Norbury',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3190592,
        LOCATION_LATITUDE_DEG: 52.8078935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002200',
        LOCATION_NAME: 'Norbury',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8173492,
        LOCATION_LATITUDE_DEG: 52.9773091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038000',
        LOCATION_NAME: 'Norbury',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1238069,
        LOCATION_LATITUDE_DEG: 51.4129389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002400',
        LOCATION_NAME: 'Norbury Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6493143,
        LOCATION_LATITUDE_DEG: 53.0221206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002500',
        LOCATION_NAME: 'Norbury Junction',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3046717,
        LOCATION_LATITUDE_DEG: 52.8020965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002600',
        LOCATION_NAME: 'Norby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3465322,
        LOCATION_LATITUDE_DEG: 54.2374252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002700',
        LOCATION_NAME: 'Norchard',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2263702,
        LOCATION_LATITUDE_DEG: 52.3139485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002800',
        LOCATION_NAME: 'Norcote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9319712,
        LOCATION_LATITUDE_DEG: 51.7184895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO002900',
        LOCATION_NAME: 'Norcott Brook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5841611,
        LOCATION_LATITUDE_DEG: 53.3209473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003000',
        LOCATION_NAME: 'Nordelph',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2980081,
        LOCATION_LATITUDE_DEG: 52.584139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003100',
        LOCATION_NAME: 'Norden',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0772395,
        LOCATION_LATITUDE_DEG: 50.6501879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003200',
        LOCATION_NAME: 'Nordley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4498892,
        LOCATION_LATITUDE_DEG: 52.5675781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003300',
        LOCATION_NAME: 'Norham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1582442,
        LOCATION_LATITUDE_DEG: 55.7184771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990362',
        LOCATION_NAME: 'Nork',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003400',
        LOCATION_NAME: 'Nork',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2241644,
        LOCATION_LATITUDE_DEG: 51.3216253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003500',
        LOCATION_NAME: 'Norley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6458586,
        LOCATION_LATITUDE_DEG: 53.2456441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003600',
        LOCATION_NAME: 'Norley Wood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4942963,
        LOCATION_LATITUDE_DEG: 50.7800749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003700',
        LOCATION_NAME: 'Norman Cross',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2895455,
        LOCATION_LATITUDE_DEG: 52.5031412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003800',
        LOCATION_NAME: 'Norman Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3604135,
        LOCATION_LATITUDE_DEG: 51.693093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO003900',
        LOCATION_NAME: 'Normanby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1398233,
        LOCATION_LATITUDE_DEG: 54.5575539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004200',
        LOCATION_NAME: 'Normanby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8736398,
        LOCATION_LATITUDE_DEG: 54.2256189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004000',
        LOCATION_NAME: 'Normanby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6629299,
        LOCATION_LATITUDE_DEG: 53.6394582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004100',
        LOCATION_NAME: 'Normanby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4983814,
        LOCATION_LATITUDE_DEG: 53.3664298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037200',
        LOCATION_NAME: 'Normanby by Spital',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004300',
        LOCATION_NAME: 'Normanby Cliff',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5269595,
        LOCATION_LATITUDE_DEG: 53.3798311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037300',
        LOCATION_NAME: 'Normanby le Wold',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004400',
        LOCATION_NAME: 'Normanby-by-Spital',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4950655,
        LOCATION_LATITUDE_DEG: 53.3803323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004500',
        LOCATION_NAME: 'Normanby-le-Wold',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3081698,
        LOCATION_LATITUDE_DEG: 53.4385439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004600',
        LOCATION_NAME: 'Normandy',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6731888,
        LOCATION_LATITUDE_DEG: 51.2569308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004700',
        LOCATION_NAME: 'Normans Bay',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3994641,
        LOCATION_LATITUDE_DEG: 50.8260705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005100',
        LOCATION_NAME: 'Normanton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.800383,
        LOCATION_LATITUDE_DEG: 51.1582347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004900',
        LOCATION_NAME: 'Normanton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4137776,
        LOCATION_LATITUDE_DEG: 53.6993717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005000',
        LOCATION_NAME: 'Normanton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9400981,
        LOCATION_LATITUDE_DEG: 53.0848014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005200',
        LOCATION_NAME: 'Normanton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6224799,
        LOCATION_LATITUDE_DEG: 52.6426557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO004800',
        LOCATION_NAME: 'Normanton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5852801,
        LOCATION_LATITUDE_DEG: 53.006191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005300',
        LOCATION_NAME: 'Normanton Hills',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.200819,
        LOCATION_LATITUDE_DEG: 52.8122849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005500',
        LOCATION_NAME: 'Normanton le Heath',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.442296,
        LOCATION_LATITUDE_DEG: 52.7102722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005600',
        LOCATION_NAME: 'Normanton on Soar',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2404575,
        LOCATION_LATITUDE_DEG: 52.8085802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005700',
        LOCATION_NAME: 'Normanton on the Wolds',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0763298,
        LOCATION_LATITUDE_DEG: 52.8910934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037400',
        LOCATION_NAME: 'Normanton on Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005400',
        LOCATION_NAME: 'Normanton Spring',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3885535,
        LOCATION_LATITUDE_DEG: 53.355934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005800',
        LOCATION_NAME: 'Normanton-on-Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8178111,
        LOCATION_LATITUDE_DEG: 53.2124298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO005900',
        LOCATION_NAME: 'Normoss',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0048971,
        LOCATION_LATITUDE_DEG: 53.827604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006000',
        LOCATION_NAME: 'Norney',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6539643,
        LOCATION_LATITUDE_DEG: 51.1952231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006100',
        LOCATION_NAME: 'Norris Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2370026,
        LOCATION_LATITUDE_DEG: 50.5047014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006200',
        LOCATION_NAME: 'Norris Green',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9262727,
        LOCATION_LATITUDE_DEG: 53.4434638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006300',
        LOCATION_NAME: 'Norristhorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6902574,
        LOCATION_LATITUDE_DEG: 53.7003786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006400',
        LOCATION_NAME: 'North Anston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.217996,
        LOCATION_LATITUDE_DEG: 53.3563318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006500',
        LOCATION_NAME: 'North Ascot',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6917807,
        LOCATION_LATITUDE_DEG: 51.4192438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006600',
        LOCATION_NAME: 'North Aston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3075166,
        LOCATION_LATITUDE_DEG: 51.9561005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006700',
        LOCATION_NAME: 'North Baddesley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4450581,
        LOCATION_LATITUDE_DEG: 50.9811086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006800',
        LOCATION_NAME: 'North Ballachulish',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.175701,
        LOCATION_LATITUDE_DEG: 56.6956096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO006900',
        LOCATION_NAME: 'North Barningham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2002726,
        LOCATION_LATITUDE_DEG: 52.8889528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007000',
        LOCATION_NAME: 'North Barrow',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5548003,
        LOCATION_LATITUDE_DEG: 51.0612309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007100',
        LOCATION_NAME: 'North Barsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8443503,
        LOCATION_LATITUDE_DEG: 52.8771608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007200',
        LOCATION_NAME: 'North Benfleet',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.534545,
        LOCATION_LATITUDE_DEG: 51.5752457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007300',
        LOCATION_NAME: 'North Bersted',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6935894,
        LOCATION_LATITUDE_DEG: 50.7986875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007400',
        LOCATION_NAME: 'North Berwick',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7180362,
        LOCATION_LATITUDE_DEG: 56.0584224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007500',
        LOCATION_NAME: 'North Bestwall',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1034203,
        LOCATION_LATITUDE_DEG: 50.6868893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007600',
        LOCATION_NAME: 'North Bitchburn',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7315031,
        LOCATION_LATITUDE_DEG: 54.6895761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007700',
        LOCATION_NAME: 'North Boarhunt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1441164,
        LOCATION_LATITUDE_DEG: 50.8881953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007800',
        LOCATION_NAME: 'North Boisdale',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3863315,
        LOCATION_LATITUDE_DEG: 57.1371732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO007900',
        LOCATION_NAME: 'North Bovey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7787799,
        LOCATION_LATITUDE_DEG: 50.6395053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008000',
        LOCATION_NAME: 'North Bowood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.784789,
        LOCATION_LATITUDE_DEG: 50.791608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008100',
        LOCATION_NAME: 'North Bradley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2031671,
        LOCATION_LATITUDE_DEG: 51.2956497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008200',
        LOCATION_NAME: 'North Brewham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.399219,
        LOCATION_LATITUDE_DEG: 51.1299351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008300',
        LOCATION_NAME: 'North Brink',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.097946,
        LOCATION_LATITUDE_DEG: 52.6360529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008400',
        LOCATION_NAME: 'North Broomhill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6104658,
        LOCATION_LATITUDE_DEG: 55.3003299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008500',
        LOCATION_NAME: 'North Brunton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6237841,
        LOCATION_LATITUDE_DEG: 55.0344002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008600',
        LOCATION_NAME: 'North Buckland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1751288,
        LOCATION_LATITUDE_DEG: 51.1414597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008700',
        LOCATION_NAME: 'North Burlingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5036212,
        LOCATION_LATITUDE_DEG: 52.636427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008800',
        LOCATION_NAME: 'North Cadbury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5217026,
        LOCATION_LATITUDE_DEG: 51.0445299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO008900',
        LOCATION_NAME: 'North Carlton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5818988,
        LOCATION_LATITUDE_DEG: 53.2866177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009000',
        LOCATION_NAME: 'North Carnmarth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1999278,
        LOCATION_LATITUDE_DEG: 50.2218823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009100',
        LOCATION_NAME: 'North Cave',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6432634,
        LOCATION_LATITUDE_DEG: 53.7802705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009200',
        LOCATION_NAME: 'North Cerney',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.970795,
        LOCATION_LATITUDE_DEG: 51.7700934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009300',
        LOCATION_NAME: 'North Cerney Downs',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9485344,
        LOCATION_LATITUDE_DEG: 51.7683953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009400',
        LOCATION_NAME: 'North Chailey',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0148774,
        LOCATION_LATITUDE_DEG: 50.9719874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009500',
        LOCATION_NAME: 'North Charlton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.731664,
        LOCATION_LATITUDE_DEG: 55.5006544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009600',
        LOCATION_NAME: 'North Cheam',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2143393,
        LOCATION_LATITUDE_DEG: 51.3735314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009700',
        LOCATION_NAME: 'North Cheriton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4418739,
        LOCATION_LATITUDE_DEG: 51.0286261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009800',
        LOCATION_NAME: 'North Chideock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8192945,
        LOCATION_LATITUDE_DEG: 50.7419047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO009900',
        LOCATION_NAME: 'North Cliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6729448,
        LOCATION_LATITUDE_DEG: 53.8218746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010000',
        LOCATION_NAME: 'North Cliffs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3149401,
        LOCATION_LATITUDE_DEG: 50.2425783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010100',
        LOCATION_NAME: 'North Clifton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7648047,
        LOCATION_LATITUDE_DEG: 53.2396188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010200',
        LOCATION_NAME: 'North Cockerington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0680785,
        LOCATION_LATITUDE_DEG: 53.3955227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010300',
        LOCATION_NAME: 'North Colerne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2737136,
        LOCATION_LATITUDE_DEG: 51.4479687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010400',
        LOCATION_NAME: 'North Connel',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.394415,
        LOCATION_LATITUDE_DEG: 56.4579827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010500',
        LOCATION_NAME: 'North Cornelly',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7027145,
        LOCATION_LATITUDE_DEG: 51.5184911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010600',
        LOCATION_NAME: 'North Cotes',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0357346,
        LOCATION_LATITUDE_DEG: 53.4852354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010700',
        LOCATION_NAME: 'North Country',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2310295,
        LOCATION_LATITUDE_DEG: 50.2481829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010800',
        LOCATION_NAME: 'North Cove',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6283266,
        LOCATION_LATITUDE_DEG: 52.4452096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO010900',
        LOCATION_NAME: 'North Cowton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5617884,
        LOCATION_LATITUDE_DEG: 54.4298416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011000',
        LOCATION_NAME: 'North Crawley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.650372,
        LOCATION_LATITUDE_DEG: 52.0928038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011100',
        LOCATION_NAME: 'North Creake',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7571925,
        LOCATION_LATITUDE_DEG: 52.9084636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011200',
        LOCATION_NAME: 'North Curry',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9690884,
        LOCATION_LATITUDE_DEG: 51.0221336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011300',
        LOCATION_NAME: 'North Dalton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5744333,
        LOCATION_LATITUDE_DEG: 53.9576846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011400',
        LOCATION_NAME: 'North Dean',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7682168,
        LOCATION_LATITUDE_DEG: 51.6776107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011500',
        LOCATION_NAME: 'North Deighton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4040554,
        LOCATION_LATITUDE_DEG: 53.9592979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011600',
        LOCATION_NAME: 'North Dell',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3289603,
        LOCATION_LATITUDE_DEG: 58.4768978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011700',
        LOCATION_NAME: 'North Denchworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4393252,
        LOCATION_LATITUDE_DEG: 51.6326706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011800',
        LOCATION_NAME: 'North Dimson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2211234,
        LOCATION_LATITUDE_DEG: 50.5245973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO011900',
        LOCATION_NAME: 'North Duffield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9588597,
        LOCATION_LATITUDE_DEG: 53.8258746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012000',
        LOCATION_NAME: 'North Dykes',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7085742,
        LOCATION_LATITUDE_DEG: 54.7277893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012100',
        LOCATION_NAME: 'North Elkington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0673842,
        LOCATION_LATITUDE_DEG: 53.3941245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012200',
        LOCATION_NAME: 'North Elmham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9409499,
        LOCATION_LATITUDE_DEG: 52.748247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012300',
        LOCATION_NAME: 'North Elmsall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2813423,
        LOCATION_LATITUDE_DEG: 53.6081627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012500',
        LOCATION_NAME: 'North End',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8367084,
        LOCATION_LATITUDE_DEG: 51.3993672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012650',
        LOCATION_NAME: 'North End',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.412423,
        LOCATION_LATITUDE_DEG: 51.3612138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012400',
        LOCATION_NAME: 'North End',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0779578,
        LOCATION_LATITUDE_DEG: 50.8167938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012600',
        LOCATION_NAME: 'North End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4175516,
        LOCATION_LATITUDE_DEG: 51.8401703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012700',
        LOCATION_NAME: 'North Erradale',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7813373,
        LOCATION_LATITUDE_DEG: 57.7616232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012800',
        LOCATION_NAME: 'North Ewster',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.746236,
        LOCATION_LATITUDE_DEG: 53.5170442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012900',
        LOCATION_NAME: 'North Fambridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6770966,
        LOCATION_LATITUDE_DEG: 51.6413459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO012950',
        LOCATION_NAME: 'North Fawley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4317459,
        LOCATION_LATITUDE_DEG: 51.5325929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013000',
        LOCATION_NAME: 'North Featherstone',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3597494,
        LOCATION_LATITUDE_DEG: 53.6929734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013100',
        LOCATION_NAME: 'North Ferriby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5045056,
        LOCATION_LATITUDE_DEG: 53.7224593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038500',
        LOCATION_NAME: 'North Finchley',
        COUNTY_NAME: 'London',
        POSTCODE: 'N12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1679669,
        LOCATION_LATITUDE_DEG: 51.6078348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013200',
        LOCATION_NAME: 'North Frodingham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3284613,
        LOCATION_LATITUDE_DEG: 53.9623799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013300',
        LOCATION_NAME: 'North Galson',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3995859,
        LOCATION_LATITUDE_DEG: 58.4419409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013400',
        LOCATION_NAME: 'North Glendale',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3143201,
        LOCATION_LATITUDE_DEG: 57.1357711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013500',
        LOCATION_NAME: 'North Gorley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.772492,
        LOCATION_LATITUDE_DEG: 50.9026047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037500',
        LOCATION_NAME: 'North Gosforth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6102744,
        LOCATION_LATITUDE_DEG: 55.0075757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013600',
        LOCATION_NAME: 'North Grimston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7157016,
        LOCATION_LATITUDE_DEG: 54.0985053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013700',
        LOCATION_NAME: 'North Gulham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4146415,
        LOCATION_LATITUDE_DEG: 53.4457317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013800',
        LOCATION_NAME: 'North Harrow',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3618286,
        LOCATION_LATITUDE_DEG: 51.5829567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO013900',
        LOCATION_NAME: 'North Hayling',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9621048,
        LOCATION_LATITUDE_DEG: 50.8233936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014000',
        LOCATION_NAME: 'North Heath',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4772819,
        LOCATION_LATITUDE_DEG: 50.980695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014100',
        LOCATION_NAME: 'North Hill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4407222,
        LOCATION_LATITUDE_DEG: 50.5629007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014200',
        LOCATION_NAME: 'North Hinksey Village',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2869956,
        LOCATION_LATITUDE_DEG: 51.7410839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014300',
        LOCATION_NAME: 'North Holmwood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3272061,
        LOCATION_LATITUDE_DEG: 51.2119176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014400',
        LOCATION_NAME: 'North Houghton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5132613,
        LOCATION_LATITUDE_DEG: 51.0992247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014500',
        LOCATION_NAME: 'North Howden',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8578004,
        LOCATION_LATITUDE_DEG: 53.7649676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014600',
        LOCATION_NAME: 'North Huish',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8122086,
        LOCATION_LATITUDE_DEG: 50.3935827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014700',
        LOCATION_NAME: 'North Hykeham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5866061,
        LOCATION_LATITUDE_DEG: 53.1821125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014800',
        LOCATION_NAME: 'North Hylton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4653414,
        LOCATION_LATITUDE_DEG: 54.9068874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037800',
        LOCATION_NAME: 'North Jesmond',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6133578,
        LOCATION_LATITUDE_DEG: 54.9812617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO039200',
        LOCATION_NAME: 'North Jordanhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3265528,
        LOCATION_LATITUDE_DEG: 55.8846468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO014900',
        LOCATION_NAME: 'North Kelsey',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4271222,
        LOCATION_LATITUDE_DEG: 53.5012421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015000',
        LOCATION_NAME: 'North Kelsey Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3874443,
        LOCATION_LATITUDE_DEG: 53.5049389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO039300',
        LOCATION_NAME: 'North Kelvinside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2846636,
        LOCATION_LATITUDE_DEG: 55.8832115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038100',
        LOCATION_NAME: 'North Kensington',
        COUNTY_NAME: 'London',
        POSTCODE: 'W10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2292045,
        LOCATION_LATITUDE_DEG: 51.5217728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015100',
        LOCATION_NAME: 'North Kessock',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2425493,
        LOCATION_LATITUDE_DEG: 57.501183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015200',
        LOCATION_NAME: 'North Killingholme',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2725758,
        LOCATION_LATITUDE_DEG: 53.6390462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015300',
        LOCATION_NAME: 'North Kilvington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3468739,
        LOCATION_LATITUDE_DEG: 54.2624241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015400',
        LOCATION_NAME: 'North Kilworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0939797,
        LOCATION_LATITUDE_DEG: 52.4468483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015500',
        LOCATION_NAME: 'North Kyme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2815464,
        LOCATION_LATITUDE_DEG: 53.0585913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015600',
        LOCATION_NAME: 'North Leigh',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4400507,
        LOCATION_LATITUDE_DEG: 51.814093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015700',
        LOCATION_NAME: 'North Leverton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8206264,
        LOCATION_LATITUDE_DEG: 53.3301324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015800',
        LOCATION_NAME: 'North Litchfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3354293,
        LOCATION_LATITUDE_DEG: 51.2817367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO015900',
        LOCATION_NAME: 'North Littleton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8799362,
        LOCATION_LATITUDE_DEG: 52.1232257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016000',
        LOCATION_NAME: 'North Locheynort',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3500136,
        LOCATION_LATITUDE_DEG: 57.2391838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016100',
        LOCATION_NAME: 'North Lopham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.992613,
        LOCATION_LATITUDE_DEG: 52.4022111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990137',
        LOCATION_NAME: 'North Luffenham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6213272,
        LOCATION_LATITUDE_DEG: 52.6229061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016200',
        LOCATION_NAME: 'North Luffenham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6195944,
        LOCATION_LATITUDE_DEG: 52.6211595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016300',
        LOCATION_NAME: 'North Marden',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8496285,
        LOCATION_LATITUDE_DEG: 50.9396003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016400',
        LOCATION_NAME: 'North Marston',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8751767,
        LOCATION_LATITUDE_DEG: 51.8982888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016600',
        LOCATION_NAME: 'North Middleton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0208814,
        LOCATION_LATITUDE_DEG: 55.8208012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016500',
        LOCATION_NAME: 'North Middleton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0000316,
        LOCATION_LATITUDE_DEG: 55.5125589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016700',
        LOCATION_NAME: 'North Molton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8013537,
        LOCATION_LATITUDE_DEG: 51.0536479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016800',
        LOCATION_NAME: 'North Moreton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1895715,
        LOCATION_LATITUDE_DEG: 51.601663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO016900',
        LOCATION_NAME: 'North Moulsecoomb',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1034782,
        LOCATION_LATITUDE_DEG: 50.8552824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017000',
        LOCATION_NAME: 'North Mundham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.757173,
        LOCATION_LATITUDE_DEG: 50.8129902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017100',
        LOCATION_NAME: 'North Muskham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8094119,
        LOCATION_LATITUDE_DEG: 53.1199058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017150',
        LOCATION_NAME: 'North Mymms',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2180004,
        LOCATION_LATITUDE_DEG: 51.7135924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017200',
        LOCATION_NAME: 'North Newbald',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6147255,
        LOCATION_LATITUDE_DEG: 53.8185733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017300',
        LOCATION_NAME: 'North Newington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3885612,
        LOCATION_LATITUDE_DEG: 52.0549111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017400',
        LOCATION_NAME: 'North Newnton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8153821,
        LOCATION_LATITUDE_DEG: 51.3164448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017500',
        LOCATION_NAME: 'North Newton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0014595,
        LOCATION_LATITUDE_DEG: 51.0731416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017600',
        LOCATION_NAME: 'North Nibley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3753622,
        LOCATION_LATITUDE_DEG: 51.6600894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017700',
        LOCATION_NAME: 'North Oakley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2297172,
        LOCATION_LATITUDE_DEG: 51.2825369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017800',
        LOCATION_NAME: 'North Ockendon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2903755,
        LOCATION_LATITUDE_DEG: 51.5429419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO017900',
        LOCATION_NAME: 'North Ormesby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2025317,
        LOCATION_LATITUDE_DEG: 54.5703512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018000',
        LOCATION_NAME: 'North Ormsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0594651,
        LOCATION_LATITUDE_DEG: 53.4197285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018100',
        LOCATION_NAME: 'North Otterington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4408528,
        LOCATION_LATITUDE_DEG: 54.3001266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018200',
        LOCATION_NAME: 'North Owersby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4046931,
        LOCATION_LATITUDE_DEG: 53.4363299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018300',
        LOCATION_NAME: 'North Perrott',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7450404,
        LOCATION_LATITUDE_DEG: 50.8823181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018400',
        LOCATION_NAME: 'North Petherton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.012926,
        LOCATION_LATITUDE_DEG: 51.0909397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018500',
        LOCATION_NAME: 'North Petherwin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4312681,
        LOCATION_LATITUDE_DEG: 50.6757125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018600',
        LOCATION_NAME: 'North Pickenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7550404,
        LOCATION_LATITUDE_DEG: 52.6273364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018700',
        LOCATION_NAME: 'North Piddle',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.048468,
        LOCATION_LATITUDE_DEG: 52.1891306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018800',
        LOCATION_NAME: 'North Pill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2162307,
        LOCATION_LATITUDE_DEG: 50.4161885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO018900',
        LOCATION_NAME: 'North Poorton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6838747,
        LOCATION_LATITUDE_DEG: 50.7848054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019000',
        LOCATION_NAME: 'North Prospect',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1610222,
        LOCATION_LATITUDE_DEG: 50.3909879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019100',
        LOCATION_NAME: 'North Queensferry',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3932132,
        LOCATION_LATITUDE_DEG: 56.0098256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019200',
        LOCATION_NAME: 'North Rauceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.47657,
        LOCATION_LATITUDE_DEG: 53.0049917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019300',
        LOCATION_NAME: 'North Reston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.078803,
        LOCATION_LATITUDE_DEG: 53.332217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019400',
        LOCATION_NAME: 'North Rigton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5727711,
        LOCATION_LATITUDE_DEG: 53.9386947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019600',
        LOCATION_NAME: 'North Ripley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7610403,
        LOCATION_LATITUDE_DEG: 50.7973936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019700',
        LOCATION_NAME: 'North Rode',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1595517,
        LOCATION_LATITUDE_DEG: 53.191936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019800',
        LOCATION_NAME: 'North Roe',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3324203,
        LOCATION_LATITUDE_DEG: 60.5891503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019900',
        LOCATION_NAME: 'North Ronaldsay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4198208,
        LOCATION_LATITUDE_DEG: 59.3742433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020000',
        LOCATION_NAME: 'North Roskear',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2854389,
        LOCATION_LATITUDE_DEG: 50.2195835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020100',
        LOCATION_NAME: 'North Roskear Village',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2868318,
        LOCATION_LATITUDE_DEG: 50.2212805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020200',
        LOCATION_NAME: 'North Runcton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4357649,
        LOCATION_LATITUDE_DEG: 52.7164486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020300',
        LOCATION_NAME: 'North Scale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2536434,
        LOCATION_LATITUDE_DEG: 54.1196386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020400',
        LOCATION_NAME: 'North Scarle',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7298205,
        LOCATION_LATITUDE_DEG: 53.1907113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO039100',
        LOCATION_NAME: 'North Scotstounhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3540166,
        LOCATION_LATITUDE_DEG: 55.8905245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020500',
        LOCATION_NAME: 'North Seaton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5393059,
        LOCATION_LATITUDE_DEG: 55.1744174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020600',
        LOCATION_NAME: 'North Shawbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6691018,
        LOCATION_LATITUDE_DEG: 58.3335896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020700',
        LOCATION_NAME: 'North Shields',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4456135,
        LOCATION_LATITUDE_DEG: 55.0086984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020800',
        LOCATION_NAME: 'North Shoebury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7818519,
        LOCATION_LATITUDE_DEG: 51.5379339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO020900',
        LOCATION_NAME: 'North Shore',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0520372,
        LOCATION_LATITUDE_DEG: 53.8290067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021000',
        LOCATION_NAME: 'North Side',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8136402,
        LOCATION_LATITUDE_DEG: 55.1651157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021100',
        LOCATION_NAME: 'North Skelton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.956834,
        LOCATION_LATITUDE_DEG: 54.5571483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021200',
        LOCATION_NAME: 'North Somercotes',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1355943,
        LOCATION_LATITUDE_DEG: 53.4517258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021300',
        LOCATION_NAME: 'North Stainley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5612106,
        LOCATION_LATITUDE_DEG: 54.1863186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021400',
        LOCATION_NAME: 'North Stainmore',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2607264,
        LOCATION_LATITUDE_DEG: 54.5300591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021500',
        LOCATION_NAME: 'North Standen',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5449527,
        LOCATION_LATITUDE_DEG: 51.4029543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021600',
        LOCATION_NAME: 'North Stifford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3051347,
        LOCATION_LATITUDE_DEG: 51.4973404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021800',
        LOCATION_NAME: 'North Stoke',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4298027,
        LOCATION_LATITUDE_DEG: 51.418562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021700',
        LOCATION_NAME: 'North Stoke',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1196887,
        LOCATION_LATITUDE_DEG: 51.5705669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021900',
        LOCATION_NAME: 'North Stoneham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3743459,
        LOCATION_LATITUDE_DEG: 50.9560103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO021950',
        LOCATION_NAME: 'North Stow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6774305,
        LOCATION_LATITUDE_DEG: 52.3448495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022000',
        LOCATION_NAME: 'North Strome',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5519676,
        LOCATION_LATITUDE_DEG: 57.3640759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022100',
        LOCATION_NAME: 'North Sunderland',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.651535,
        LOCATION_LATITUDE_DEG: 55.5798572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022200',
        LOCATION_NAME: 'North Sydmonton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2880188,
        LOCATION_LATITUDE_DEG: 51.3505418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022300',
        LOCATION_NAME: 'North Tamerton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3915115,
        LOCATION_LATITUDE_DEG: 50.7485245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022400',
        LOCATION_NAME: 'North Tawton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8968443,
        LOCATION_LATITUDE_DEG: 50.7991243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022500',
        LOCATION_NAME: 'North Thoresby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0540699,
        LOCATION_LATITUDE_DEG: 53.4663312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022600',
        LOCATION_NAME: 'North Togston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6049401,
        LOCATION_LATITUDE_DEG: 55.3174321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022700',
        LOCATION_NAME: 'North Tolsta',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2108384,
        LOCATION_LATITUDE_DEG: 58.3491832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022800',
        LOCATION_NAME: 'North Town',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1171177,
        LOCATION_LATITUDE_DEG: 50.8668328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO022900',
        LOCATION_NAME: 'North Trigon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1431238,
        LOCATION_LATITUDE_DEG: 50.7120928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023000',
        LOCATION_NAME: 'North Tuddenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0264719,
        LOCATION_LATITUDE_DEG: 52.6843411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023100',
        LOCATION_NAME: 'North Walbottle',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7259953,
        LOCATION_LATITUDE_DEG: 55.0022023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023200',
        LOCATION_NAME: 'North Walsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3901969,
        LOCATION_LATITUDE_DEG: 52.8214438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023300',
        LOCATION_NAME: 'North Waltham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.194585,
        LOCATION_LATITUDE_DEG: 51.2119296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023400',
        LOCATION_NAME: 'North Warnborough',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9505931,
        LOCATION_LATITUDE_DEG: 51.2576331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023500',
        LOCATION_NAME: 'North Watford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3876604,
        LOCATION_LATITUDE_DEG: 51.6748644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023600',
        LOCATION_NAME: 'North Weald',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1495246,
        LOCATION_LATITUDE_DEG: 51.7186567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023700',
        LOCATION_NAME: 'North Weald Bassett',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1685525,
        LOCATION_LATITUDE_DEG: 51.7156628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038700',
        LOCATION_NAME: 'North Weston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023800',
        LOCATION_NAME: 'North Weston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0134914,
        LOCATION_LATITUDE_DEG: 51.7417772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO023900',
        LOCATION_NAME: 'North Wheatley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8592084,
        LOCATION_LATITUDE_DEG: 53.3644276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024000',
        LOCATION_NAME: 'North Widcombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6104173,
        LOCATION_LATITUDE_DEG: 51.3223558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024100',
        LOCATION_NAME: 'North Willingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2527287,
        LOCATION_LATITUDE_DEG: 53.378721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024200',
        LOCATION_NAME: 'North Wingfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3859151,
        LOCATION_LATITUDE_DEG: 53.1807241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024300',
        LOCATION_NAME: 'North Witham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6245937,
        LOCATION_LATITUDE_DEG: 52.7852739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024400',
        LOCATION_NAME: 'North Woodchester',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2333078,
        LOCATION_LATITUDE_DEG: 51.7224949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038400',
        LOCATION_NAME: 'North Woolwich',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0623514,
        LOCATION_LATITUDE_DEG: 51.5015297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024700',
        LOCATION_NAME: 'North Wootton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6249019,
        LOCATION_LATITUDE_DEG: 51.1724469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024600',
        LOCATION_NAME: 'North Wootton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4896447,
        LOCATION_LATITUDE_DEG: 50.9279167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024500',
        LOCATION_NAME: 'North Wootton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4317941,
        LOCATION_LATITUDE_DEG: 52.791161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024800',
        LOCATION_NAME: 'North Wraxall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2617261,
        LOCATION_LATITUDE_DEG: 51.4732653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO024900',
        LOCATION_NAME: 'Northall',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6155723,
        LOCATION_LATITUDE_DEG: 51.8739838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025000',
        LOCATION_NAME: 'Northallerton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4338005,
        LOCATION_LATITUDE_DEG: 54.3414312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025100',
        LOCATION_NAME: 'Northam',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2263152,
        LOCATION_LATITUDE_DEG: 51.0385517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025200',
        LOCATION_NAME: 'Northampton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8949746,
        LOCATION_LATITUDE_DEG: 52.2381238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025300',
        LOCATION_NAME: 'Northaw',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1491358,
        LOCATION_LATITUDE_DEG: 51.7042628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025400',
        LOCATION_NAME: 'Northay',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0227989,
        LOCATION_LATITUDE_DEG: 50.9025192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025500',
        LOCATION_NAME: 'Northbay',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4179834,
        LOCATION_LATITUDE_DEG: 57.0003634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025600',
        LOCATION_NAME: 'Northbay Inn',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4348833,
        LOCATION_LATITUDE_DEG: 57.003256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025700',
        LOCATION_NAME: 'Northborough',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2993554,
        LOCATION_LATITUDE_DEG: 52.65806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025800',
        LOCATION_NAME: 'Northbourne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8906463,
        LOCATION_LATITUDE_DEG: 50.7604974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO025900',
        LOCATION_NAME: 'Northbourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3408074,
        LOCATION_LATITUDE_DEG: 51.2197992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026000',
        LOCATION_NAME: 'Northchapel',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6413594,
        LOCATION_LATITUDE_DEG: 51.0567106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026100',
        LOCATION_NAME: 'Northchurch',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5890183,
        LOCATION_LATITUDE_DEG: 51.7693715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026200',
        LOCATION_NAME: 'Northcliffe',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1665963,
        LOCATION_LATITUDE_DEG: 51.4427719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026300',
        LOCATION_NAME: 'Northcott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3681487,
        LOCATION_LATITUDE_DEG: 50.8911331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026400',
        LOCATION_NAME: 'Northcott',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3564291,
        LOCATION_LATITUDE_DEG: 50.7086167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026500',
        LOCATION_NAME: 'Northcott Mouth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5505527,
        LOCATION_LATITUDE_DEG: 50.8488333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026700',
        LOCATION_NAME: 'Northend',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3190007,
        LOCATION_LATITUDE_DEG: 51.4061643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026600',
        LOCATION_NAME: 'Northend',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4281346,
        LOCATION_LATITUDE_DEG: 52.1689265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026800',
        LOCATION_NAME: 'Northend',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9391058,
        LOCATION_LATITUDE_DEG: 51.6249631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037600',
        LOCATION_NAME: 'Northenden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2584202,
        LOCATION_LATITUDE_DEG: 53.4082008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037700',
        LOCATION_NAME: 'Northern Moor',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2758039,
        LOCATION_LATITUDE_DEG: 53.4116319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO039000',
        LOCATION_NAME: 'Northfield',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1367325,
        LOCATION_LATITUDE_DEG: 55.9474933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037900',
        LOCATION_NAME: 'Northfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9632864,
        LOCATION_LATITUDE_DEG: 52.4113184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO026900',
        LOCATION_NAME: 'Northfield',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7205929,
        LOCATION_LATITUDE_DEG: 52.0479066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027000',
        LOCATION_NAME: 'Northfield',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6216471,
        LOCATION_LATITUDE_DEG: 51.8111789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027100',
        LOCATION_NAME: 'Northfields',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9698896,
        LOCATION_LATITUDE_DEG: 51.3651563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027200',
        LOCATION_NAME: 'Northfleet',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3274253,
        LOCATION_LATITUDE_DEG: 51.4458309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027300',
        LOCATION_NAME: 'Northgate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2240723,
        LOCATION_LATITUDE_DEG: 52.8205696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027500',
        LOCATION_NAME: 'Northiam',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6019947,
        LOCATION_LATITUDE_DEG: 50.9934838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027600',
        LOCATION_NAME: 'Northill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3214312,
        LOCATION_LATITUDE_DEG: 52.1053044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027700',
        LOCATION_NAME: 'Northington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1875393,
        LOCATION_LATITUDE_DEG: 51.1322191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027800',
        LOCATION_NAME: 'Northington Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.204929,
        LOCATION_LATITUDE_DEG: 51.1217175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027900',
        LOCATION_NAME: 'Northlands',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0087996,
        LOCATION_LATITUDE_DEG: 53.0595901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028100',
        LOCATION_NAME: 'Northleach',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8357713,
        LOCATION_LATITUDE_DEG: 51.8297975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028200',
        LOCATION_NAME: 'Northleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1371966,
        LOCATION_LATITUDE_DEG: 50.7564073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028300',
        LOCATION_NAME: 'Northlew',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1218959,
        LOCATION_LATITUDE_DEG: 50.7704208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028400',
        LOCATION_NAME: 'Northmoor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.393506,
        LOCATION_LATITUDE_DEG: 51.7223844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028500',
        LOCATION_NAME: 'Northmostown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2842079,
        LOCATION_LATITUDE_DEG: 50.6969048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028600',
        LOCATION_NAME: 'Northmuir',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0006553,
        LOCATION_LATITUDE_DEG: 56.6844857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028700',
        LOCATION_NAME: 'Northolt',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3650844,
        LOCATION_LATITUDE_DEG: 51.548549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028800',
        LOCATION_NAME: 'Northop',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1290427,
        LOCATION_LATITUDE_DEG: 53.207542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028900',
        LOCATION_NAME: 'Northop Hall',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0912633,
        LOCATION_LATITUDE_DEG: 53.2017446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029000',
        LOCATION_NAME: 'Northorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6519239,
        LOCATION_LATITUDE_DEG: 53.4630386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO991155',
        LOCATION_NAME: 'Northorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.653493,
        LOCATION_LATITUDE_DEG: 53.463606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029100',
        LOCATION_NAME: 'Northowram',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8269639,
        LOCATION_LATITUDE_DEG: 53.739577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029200',
        LOCATION_NAME: 'Northport',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.112442,
        LOCATION_LATITUDE_DEG: 50.6941929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029300',
        LOCATION_NAME: 'Northrepps',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3387294,
        LOCATION_LATITUDE_DEG: 52.9016516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029400',
        LOCATION_NAME: 'Northside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.549526,
        LOCATION_LATITUDE_DEG: 54.6512924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029500',
        LOCATION_NAME: 'Northton',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0636737,
        LOCATION_LATITUDE_DEG: 57.7966393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029600',
        LOCATION_NAME: 'Northumberland Heath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1636128,
        LOCATION_LATITUDE_DEG: 51.4692332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038900',
        LOCATION_NAME: 'Northville',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5773231,
        LOCATION_LATITUDE_DEG: 51.502945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029700',
        LOCATION_NAME: 'Northwaterbridge',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5748526,
        LOCATION_LATITUDE_DEG: 56.7877458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029800',
        LOCATION_NAME: 'Northway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1114415,
        LOCATION_LATITUDE_DEG: 52.0046164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO029900',
        LOCATION_NAME: 'Northwich',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5166703,
        LOCATION_LATITUDE_DEG: 53.2585452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030000',
        LOCATION_NAME: 'Northwick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6007414,
        LOCATION_LATITUDE_DEG: 51.3858683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030100',
        LOCATION_NAME: 'Northwold',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5831527,
        LOCATION_LATITUDE_DEG: 52.5427359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030200',
        LOCATION_NAME: 'Northwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.795155,
        LOCATION_LATITUDE_DEG: 52.8941091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030300',
        LOCATION_NAME: 'Northwood',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.422108,
        LOCATION_LATITUDE_DEG: 51.6109599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030400',
        LOCATION_NAME: 'Northwood Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3992479,
        LOCATION_LATITUDE_DEG: 51.8441074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030500',
        LOCATION_NAME: 'Northwood Hills',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4091485,
        LOCATION_LATITUDE_DEG: 51.6019538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO991009',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990456',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990955',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031700',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0125619,
        LOCATION_LATITUDE_DEG: 51.5903981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032200',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6137713,
        LOCATION_LATITUDE_DEG: 50.3502806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031800',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0203267,
        LOCATION_LATITUDE_DEG: 52.2975571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030600',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8136972,
        LOCATION_LATITUDE_DEG: 51.8761139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032300',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.666648,
        LOCATION_LATITUDE_DEG: 53.3305477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990335',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4022738,
        LOCATION_LATITUDE_DEG: 52.6014564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030700',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.401592,
        LOCATION_LATITUDE_DEG: 52.60118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030900',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2082281,
        LOCATION_LATITUDE_DEG: 51.9139105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031500',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1774376,
        LOCATION_LATITUDE_DEG: 52.1583282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO030800',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1634525,
        LOCATION_LATITUDE_DEG: 51.5587731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031600',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.940895,
        LOCATION_LATITUDE_DEG: 52.1237306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031400',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5133634,
        LOCATION_LATITUDE_DEG: 50.7019824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031100',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3043876,
        LOCATION_LATITUDE_DEG: 54.5892522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031000',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1749089,
        LOCATION_LATITUDE_DEG: 53.6307592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032500',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.143257,
        LOCATION_LATITUDE_DEG: 53.2414203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031200',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1163655,
        LOCATION_LATITUDE_DEG: 52.2692295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031300',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7853811,
        LOCATION_LATITUDE_DEG: 54.1310055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032100',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6836739,
        LOCATION_LATITUDE_DEG: 50.8464872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO031900',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0868888,
        LOCATION_LATITUDE_DEG: 50.7968767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032400',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8183722,
        LOCATION_LATITUDE_DEG: 51.2995115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032000',
        LOCATION_NAME: 'Norton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8668071,
        LOCATION_LATITUDE_DEG: 52.2585028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032600',
        LOCATION_NAME: 'Norton Bavant',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1280289,
        LOCATION_LATITUDE_DEG: 51.1907367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032700',
        LOCATION_NAME: 'Norton Bridge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1948112,
        LOCATION_LATITUDE_DEG: 52.8693966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032800',
        LOCATION_NAME: 'Norton Canes',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.972508,
        LOCATION_LATITUDE_DEG: 52.6665821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO032900',
        LOCATION_NAME: 'Norton Canon',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9015626,
        LOCATION_LATITUDE_DEG: 52.126935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033000',
        LOCATION_NAME: 'Norton Conyers',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5087001,
        LOCATION_LATITUDE_DEG: 54.1802194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033100',
        LOCATION_NAME: 'Norton Disney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6708431,
        LOCATION_LATITUDE_DEG: 53.1214062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033200',
        LOCATION_NAME: 'Norton East',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9695005,
        LOCATION_LATITUDE_DEG: 52.6743763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033300',
        LOCATION_NAME: 'Norton Ferris',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3006146,
        LOCATION_LATITUDE_DEG: 51.127739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033400',
        LOCATION_NAME: 'Norton Fitzwarren',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.141987,
        LOCATION_LATITUDE_DEG: 51.0255362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033500',
        LOCATION_NAME: 'Norton Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1545743,
        LOCATION_LATITUDE_DEG: 53.0648235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033600',
        LOCATION_NAME: 'Norton Hawkfield',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5841808,
        LOCATION_LATITUDE_DEG: 51.38106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033700',
        LOCATION_NAME: 'Norton Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3177917,
        LOCATION_LATITUDE_DEG: 51.7123538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037000',
        LOCATION_NAME: 'Norton in Hales',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO037100',
        LOCATION_NAME: 'Norton In The Moors',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033800',
        LOCATION_NAME: 'Norton Juxta Twycross',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5217052,
        LOCATION_LATITUDE_DEG: 52.6598751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034500',
        LOCATION_NAME: 'Norton le Clay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3837902,
        LOCATION_LATITUDE_DEG: 54.1343155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO033900',
        LOCATION_NAME: 'Norton Lindsey',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6655361,
        LOCATION_LATITUDE_DEG: 52.2651387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034000',
        LOCATION_NAME: 'Norton Malreward',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5711728,
        LOCATION_LATITUDE_DEG: 51.3831654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034100',
        LOCATION_NAME: 'Norton Mandeville',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2871438,
        LOCATION_LATITUDE_DEG: 51.7175595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990798',
        LOCATION_NAME: 'Norton Skenfrith',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036900',
        LOCATION_NAME: 'Norton St Philip',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034200',
        LOCATION_NAME: 'Norton St. Philip',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3239531,
        LOCATION_LATITUDE_DEG: 51.3011512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034600',
        LOCATION_NAME: 'Norton sub Hamdon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7554375,
        LOCATION_LATITUDE_DEG: 50.9397202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034300',
        LOCATION_NAME: 'Norton Subcourse',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5578335,
        LOCATION_LATITUDE_DEG: 52.5314166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034400',
        LOCATION_NAME: 'Norton Tower',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9106009,
        LOCATION_LATITUDE_DEG: 53.7253759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034800',
        LOCATION_NAME: 'Norton-in-Hales',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4469307,
        LOCATION_LATITUDE_DEG: 52.9389577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034700',
        LOCATION_NAME: 'Norton-In-The-Moors',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1618205,
        LOCATION_LATITUDE_DEG: 53.0589163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO034900',
        LOCATION_NAME: 'Norwell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8443264,
        LOCATION_LATITUDE_DEG: 53.147608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035000',
        LOCATION_NAME: 'Norwell Woodhouse',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8916488,
        LOCATION_LATITUDE_DEG: 53.1566078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035100',
        LOCATION_NAME: 'Norwich',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2967116,
        LOCATION_LATITUDE_DEG: 52.6271341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035150',
        LOCATION_NAME: 'Norwood',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6809813,
        LOCATION_LATITUDE_DEG: 53.9490533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035200',
        LOCATION_NAME: 'Norwood Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7853486,
        LOCATION_LATITUDE_DEG: 53.7383771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035300',
        LOCATION_NAME: 'Norwood Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2250092,
        LOCATION_LATITUDE_DEG: 51.1769185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035400',
        LOCATION_NAME: 'Noseley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9072901,
        LOCATION_LATITUDE_DEG: 52.5838549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035500',
        LOCATION_NAME: 'Noss Mayo',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0417206,
        LOCATION_LATITUDE_DEG: 50.3042789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035600',
        LOCATION_NAME: 'Nostell',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3891583,
        LOCATION_LATITUDE_DEG: 53.6472633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035700',
        LOCATION_NAME: 'Nosterfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5742815,
        LOCATION_LATITUDE_DEG: 54.2193263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035800',
        LOCATION_NAME: 'Notgrove',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8418062,
        LOCATION_LATITUDE_DEG: 51.8802058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO035900',
        LOCATION_NAME: 'Nottage',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7003119,
        LOCATION_LATITUDE_DEG: 51.4895852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036000',
        LOCATION_NAME: 'Notter',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2770277,
        LOCATION_LATITUDE_DEG: 50.4256916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038200',
        LOCATION_NAME: 'Notting Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'W11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2009308,
        LOCATION_LATITUDE_DEG: 51.5203892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036100',
        LOCATION_NAME: 'Nottingham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1474288,
        LOCATION_LATITUDE_DEG: 52.9532916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036200',
        LOCATION_NAME: 'Nottington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4792265,
        LOCATION_LATITUDE_DEG: 50.6418892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036400',
        LOCATION_NAME: 'Notton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5547887,
        LOCATION_LATITUDE_DEG: 50.7599037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036300',
        LOCATION_NAME: 'Notton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4724543,
        LOCATION_LATITUDE_DEG: 53.6127625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036600',
        LOCATION_NAME: 'Novar Toll',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2937055,
        LOCATION_LATITUDE_DEG: 57.6835969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO038800',
        LOCATION_NAME: 'Novers',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5965466,
        LOCATION_LATITUDE_DEG: 51.4313211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036700',
        LOCATION_NAME: 'Nowton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7311866,
        LOCATION_LATITUDE_DEG: 52.2127034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036800',
        LOCATION_NAME: 'Nox',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8714176,
        LOCATION_LATITUDE_DEG: 52.6876934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000100',
        LOCATION_NAME: 'Nuffield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0331719,
        LOCATION_LATITUDE_DEG: 51.5789596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000200',
        LOCATION_NAME: 'Nun Appleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.160486,
        LOCATION_LATITUDE_DEG: 53.8518788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000300',
        LOCATION_NAME: 'Nun Monkton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2217219,
        LOCATION_LATITUDE_DEG: 54.0142026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000400',
        LOCATION_NAME: 'Nunburnholme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7058449,
        LOCATION_LATITUDE_DEG: 53.9221804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000500',
        LOCATION_NAME: 'Nuncargate',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2503041,
        LOCATION_LATITUDE_DEG: 53.0792123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000600',
        LOCATION_NAME: 'Nuneaton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4661235,
        LOCATION_LATITUDE_DEG: 52.5225619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000700',
        LOCATION_NAME: 'Nuneham Courtenay',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1999473,
        LOCATION_LATITUDE_DEG: 51.6882779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU004000',
        LOCATION_NAME: 'Nunhead',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0576738,
        LOCATION_LATITUDE_DEG: 51.4632066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000800',
        LOCATION_NAME: 'Nunkeeling',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2602192,
        LOCATION_LATITUDE_DEG: 53.9309795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU000900',
        LOCATION_NAME: 'Nunney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3769074,
        LOCATION_LATITUDE_DEG: 51.2070437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001000',
        LOCATION_NAME: 'Nunney Catch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3736288,
        LOCATION_LATITUDE_DEG: 51.1999407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001100',
        LOCATION_NAME: 'Nunnington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.657566,
        LOCATION_LATITUDE_DEG: 52.0871321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001200',
        LOCATION_NAME: 'Nunnington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9764692,
        LOCATION_LATITUDE_DEG: 54.2052146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001300',
        LOCATION_NAME: 'Nunnykirk',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8555839,
        LOCATION_LATITUDE_DEG: 55.226823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001400',
        LOCATION_NAME: 'Nunthorpe',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1817478,
        LOCATION_LATITUDE_DEG: 54.5313475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001500',
        LOCATION_NAME: 'Nunton',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3963462,
        LOCATION_LATITUDE_DEG: 57.4567019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001600',
        LOCATION_NAME: 'Nunton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7720498,
        LOCATION_LATITUDE_DEG: 51.0338167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001700',
        LOCATION_NAME: 'Nunwell',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1612718,
        LOCATION_LATITUDE_DEG: 50.6847812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001900',
        LOCATION_NAME: 'Nunwick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1914676,
        LOCATION_LATITUDE_DEG: 55.061415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU001800',
        LOCATION_NAME: 'Nunwick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5062302,
        LOCATION_LATITUDE_DEG: 54.1650186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002000',
        LOCATION_NAME: 'Nupend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3059651,
        LOCATION_LATITUDE_DEG: 51.7594928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002100',
        LOCATION_NAME: 'Nuptown',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7215734,
        LOCATION_LATITUDE_DEG: 51.451543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002500',
        LOCATION_NAME: 'Nursling',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4605307,
        LOCATION_LATITUDE_DEG: 50.9454053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002600',
        LOCATION_NAME: 'Nursted',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.912228,
        LOCATION_LATITUDE_DEG: 50.9843052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002700',
        LOCATION_NAME: 'Nursteed',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9701936,
        LOCATION_LATITUDE_DEG: 51.3394551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002800',
        LOCATION_NAME: 'Nurston',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3608243,
        LOCATION_LATITUDE_DEG: 51.3956761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002900',
        LOCATION_NAME: 'Nurton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2447346,
        LOCATION_LATITUDE_DEG: 52.5920776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003100',
        LOCATION_NAME: 'Nutbourne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8959073,
        LOCATION_LATITUDE_DEG: 50.8420868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003000',
        LOCATION_NAME: 'Nutbourne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4692344,
        LOCATION_LATITUDE_DEG: 50.9541924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003200',
        LOCATION_NAME: 'Nutfield',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1268599,
        LOCATION_LATITUDE_DEG: 51.2374193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003300',
        LOCATION_NAME: 'Nutford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1720195,
        LOCATION_LATITUDE_DEG: 50.8703052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003400',
        LOCATION_NAME: 'Nuthall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2325718,
        LOCATION_LATITUDE_DEG: 52.9958034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003500',
        LOCATION_NAME: 'Nuthampstead',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0414999,
        LOCATION_LATITUDE_DEG: 51.9927844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003600',
        LOCATION_NAME: 'Nuthurst',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2991195,
        LOCATION_LATITUDE_DEG: 51.0229998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003700',
        LOCATION_NAME: 'Nutley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1274667,
        LOCATION_LATITUDE_DEG: 51.1957283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003800',
        LOCATION_NAME: 'Nutley',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0580507,
        LOCATION_LATITUDE_DEG: 51.0277948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU003900',
        LOCATION_NAME: 'Nutts Corner',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1489231,
        LOCATION_LATITUDE_DEG: 54.6332062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NY000100',
        LOCATION_NAME: 'Nye',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8402673,
        LOCATION_LATITUDE_DEG: 51.349566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NY000200',
        LOCATION_NAME: 'Nyewood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8529084,
        LOCATION_LATITUDE_DEG: 50.9914003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NY000300',
        LOCATION_NAME: 'Nyland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7798786,
        LOCATION_LATITUDE_DEG: 51.247949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NY000400',
        LOCATION_NAME: 'Nyland',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.37195,
        LOCATION_LATITUDE_DEG: 50.9965207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NY000500',
        LOCATION_NAME: 'Nymet Rowland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8284743,
        LOCATION_LATITUDE_DEG: 50.8579247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NY000600',
        LOCATION_NAME: 'Nympsfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2854225,
        LOCATION_LATITUDE_DEG: 51.7004929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NY000700',
        LOCATION_NAME: 'Nynehead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2249069,
        LOCATION_LATITUDE_DEG: 50.9976344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000100',
        LOCATION_NAME: 'Oadby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0771161,
        LOCATION_LATITUDE_DEG: 52.6015651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA990450',
        LOCATION_NAME: 'Oak Grove',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000200',
        LOCATION_NAME: 'Oakamoor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9237487,
        LOCATION_LATITUDE_DEG: 52.9979137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000300',
        LOCATION_NAME: 'Oakbank',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4711395,
        LOCATION_LATITUDE_DEG: 55.8843079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000400',
        LOCATION_NAME: 'Oakdale',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1771878,
        LOCATION_LATITUDE_DEG: 51.6779997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000500',
        LOCATION_NAME: 'Oakdale',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9662118,
        LOCATION_LATITUDE_DEG: 50.7379966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000600',
        LOCATION_NAME: 'Oake',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2056988,
        LOCATION_LATITUDE_DEG: 51.0225398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000700',
        LOCATION_NAME: 'Oaken',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2095329,
        LOCATION_LATITUDE_DEG: 52.6218778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000800',
        LOCATION_NAME: 'Oakenclough',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.706192,
        LOCATION_LATITUDE_DEG: 53.9222051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA000900',
        LOCATION_NAME: 'Oakengates',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4472181,
        LOCATION_LATITUDE_DEG: 52.6950875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001000',
        LOCATION_NAME: 'Oakenholt',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1026499,
        LOCATION_LATITUDE_DEG: 53.235848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001200',
        LOCATION_NAME: 'Oakenshaw',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7378372,
        LOCATION_LATITUDE_DEG: 53.7469841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001100',
        LOCATION_NAME: 'Oakenshaw',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6857925,
        LOCATION_LATITUDE_DEG: 54.7262708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001300',
        LOCATION_NAME: 'Oaker',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5840494,
        LOCATION_LATITUDE_DEG: 53.1438225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001400',
        LOCATION_NAME: 'Oakerswood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3073474,
        LOCATION_LATITUDE_DEG: 50.7045985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001500',
        LOCATION_NAME: 'Oakerthorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4182575,
        LOCATION_LATITUDE_DEG: 53.0975119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001600',
        LOCATION_NAME: 'Oakes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8199232,
        LOCATION_LATITUDE_DEG: 53.652075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001800',
        LOCATION_NAME: 'Oakfield',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.016979,
        LOCATION_LATITUDE_DEG: 51.6381931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001700',
        LOCATION_NAME: 'Oakfield',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.152635,
        LOCATION_LATITUDE_DEG: 50.7209822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA001900',
        LOCATION_NAME: 'Oakford',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.265111,
        LOCATION_LATITUDE_DEG: 52.1983558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002000',
        LOCATION_NAME: 'Oakford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5524761,
        LOCATION_LATITUDE_DEG: 50.9805371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA990612',
        LOCATION_NAME: 'Oakgrove',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7101133,
        LOCATION_LATITUDE_DEG: 52.0410931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002100',
        LOCATION_NAME: 'Oakham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7324104,
        LOCATION_LATITUDE_DEG: 52.6707669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002200',
        LOCATION_NAME: 'Oakhanger',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3500941,
        LOCATION_LATITUDE_DEG: 53.0877204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002300',
        LOCATION_NAME: 'Oakhanger',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9007024,
        LOCATION_LATITUDE_DEG: 51.11142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002500',
        LOCATION_NAME: 'Oakhill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5222596,
        LOCATION_LATITUDE_DEG: 51.2232482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002400',
        LOCATION_NAME: 'Oakhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1958662,
        LOCATION_LATITUDE_DEG: 52.9913938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002600',
        LOCATION_NAME: 'Oakington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0703312,
        LOCATION_LATITUDE_DEG: 52.2610094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002700',
        LOCATION_NAME: 'Oaklands',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1930784,
        LOCATION_LATITUDE_DEG: 51.8414807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002800',
        LOCATION_NAME: 'Oakle Street',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3517337,
        LOCATION_LATITUDE_DEG: 51.8574054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003300',
        LOCATION_NAME: 'Oakley',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5669449,
        LOCATION_LATITUDE_DEG: 56.0843272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003000',
        LOCATION_NAME: 'Oakley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1870482,
        LOCATION_LATITUDE_DEG: 51.2496306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA002900',
        LOCATION_NAME: 'Oakley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0706439,
        LOCATION_LATITUDE_DEG: 51.8055852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003100',
        LOCATION_NAME: 'Oakley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5227264,
        LOCATION_LATITUDE_DEG: 52.1667093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003200',
        LOCATION_NAME: 'Oakley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1809216,
        LOCATION_LATITUDE_DEG: 52.3565079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003400',
        LOCATION_NAME: 'Oakley Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6622999,
        LOCATION_LATITUDE_DEG: 51.4786524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003500',
        LOCATION_NAME: 'Oakley Park',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4950446,
        LOCATION_LATITUDE_DEG: 52.4706766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003600',
        LOCATION_NAME: 'Oakmere',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.639079,
        LOCATION_LATITUDE_DEG: 53.2191421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003800',
        LOCATION_NAME: 'Oakridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1245243,
        LOCATION_LATITUDE_DEG: 51.7308884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003900',
        LOCATION_NAME: 'Oakridge Lynch',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1216865,
        LOCATION_LATITUDE_DEG: 51.7310892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004000',
        LOCATION_NAME: 'Oaksey',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0125015,
        LOCATION_LATITUDE_DEG: 51.6412832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004100',
        LOCATION_NAME: 'Oakthorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5246427,
        LOCATION_LATITUDE_DEG: 52.713481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004300',
        LOCATION_NAME: 'Oakwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8166573,
        LOCATION_LATITUDE_DEG: 52.5066705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004200',
        LOCATION_NAME: 'Oakwood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0778615,
        LOCATION_LATITUDE_DEG: 54.9855091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005900',
        LOCATION_NAME: 'Oakwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5062486,
        LOCATION_LATITUDE_DEG: 53.8269493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004400',
        LOCATION_NAME: 'Oakwood',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4421461,
        LOCATION_LATITUDE_DEG: 52.9444944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004500',
        LOCATION_NAME: 'Oakwood',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8245952,
        LOCATION_LATITUDE_DEG: 50.8523898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004600',
        LOCATION_NAME: 'Oakwood Park',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8539219,
        LOCATION_LATITUDE_DEG: 53.272357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004700',
        LOCATION_NAME: 'Oakwoodhill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3797305,
        LOCATION_LATITUDE_DEG: 51.124113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004800',
        LOCATION_NAME: 'Oakworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9477393,
        LOCATION_LATITUDE_DEG: 53.8454913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005000',
        LOCATION_NAME: 'Oare',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7141026,
        LOCATION_LATITUDE_DEG: 51.2118593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA004900',
        LOCATION_NAME: 'Oare',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7720786,
        LOCATION_LATITUDE_DEG: 51.3673485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005100',
        LOCATION_NAME: 'Oare',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8794289,
        LOCATION_LATITUDE_DEG: 51.3300122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005200',
        LOCATION_NAME: 'Oasby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.50686,
        LOCATION_LATITUDE_DEG: 52.939687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005300',
        LOCATION_NAME: 'Oathe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8745909,
        LOCATION_LATITUDE_DEG: 51.0434381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005400',
        LOCATION_NAME: 'Oathill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8452895,
        LOCATION_LATITUDE_DEG: 50.844914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005500',
        LOCATION_NAME: 'Oathills',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7609156,
        LOCATION_LATITUDE_DEG: 53.0271229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005600',
        LOCATION_NAME: 'Oathlaw',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8563479,
        LOCATION_LATITUDE_DEG: 56.6944836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA005700',
        LOCATION_NAME: 'Oatlands Park',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4347642,
        LOCATION_LATITUDE_DEG: 51.3732394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OB000100',
        LOCATION_NAME: 'Oban',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4685454,
        LOCATION_LATITUDE_DEG: 56.4107849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OB000300',
        LOCATION_NAME: 'Obley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9840552,
        LOCATION_LATITUDE_DEG: 52.3906667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OB000400',
        LOCATION_NAME: 'Oborne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4928176,
        LOCATION_LATITUDE_DEG: 50.9642188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OB000500',
        LOCATION_NAME: 'Oby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5709936,
        LOCATION_LATITUDE_DEG: 52.6762326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000100',
        LOCATION_NAME: 'Occaney',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4592856,
        LOCATION_LATITUDE_DEG: 54.050607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000200',
        LOCATION_NAME: 'Occleston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4606805,
        LOCATION_LATITUDE_DEG: 53.1557675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000300',
        LOCATION_NAME: 'Occold',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1610577,
        LOCATION_LATITUDE_DEG: 52.2930981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000400',
        LOCATION_NAME: 'Occumster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2521646,
        LOCATION_LATITUDE_DEG: 58.3022511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000500',
        LOCATION_NAME: 'Ocean Village',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3869423,
        LOCATION_LATITUDE_DEG: 50.8947055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000600',
        LOCATION_NAME: 'Ochiltree',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.360081,
        LOCATION_LATITUDE_DEG: 55.4616782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000700',
        LOCATION_NAME: 'Ochrwyth',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0975846,
        LOCATION_LATITUDE_DEG: 51.6000937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000800',
        LOCATION_NAME: 'Ochtertyre',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8824955,
        LOCATION_LATITUDE_DEG: 56.3905628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000900',
        LOCATION_NAME: 'Ockbrook',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3694934,
        LOCATION_LATITUDE_DEG: 52.9162967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC001000',
        LOCATION_NAME: 'Ockendon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2955341,
        LOCATION_LATITUDE_DEG: 51.5193395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC001100',
        LOCATION_NAME: 'Ocker Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0462724,
        LOCATION_LATITUDE_DEG: 52.539464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC001200',
        LOCATION_NAME: 'Ockham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4588373,
        LOCATION_LATITUDE_DEG: 51.2973299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC001300',
        LOCATION_NAME: 'Ockley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3573595,
        LOCATION_LATITUDE_DEG: 51.1512141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC001400',
        LOCATION_NAME: 'Ocle Pychard',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5859596,
        LOCATION_LATITUDE_DEG: 52.1108342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC001500',
        LOCATION_NAME: 'Octon',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4293184,
        LOCATION_LATITUDE_DEG: 54.1127991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000100',
        LOCATION_NAME: 'Oddingley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1325305,
        LOCATION_LATITUDE_DEG: 52.2335377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000200',
        LOCATION_NAME: 'Oddington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.196501,
        LOCATION_LATITUDE_DEG: 51.8304858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000300',
        LOCATION_NAME: 'Odell',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5872437,
        LOCATION_LATITUDE_DEG: 52.2092142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000400',
        LOCATION_NAME: 'Odiham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9378719,
        LOCATION_LATITUDE_DEG: 51.2536333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000500',
        LOCATION_NAME: 'Odsal',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7566897,
        LOCATION_LATITUDE_DEG: 53.7623862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000600',
        LOCATION_NAME: 'Odsey',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1102967,
        LOCATION_LATITUDE_DEG: 52.0255975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000700',
        LOCATION_NAME: 'Odstock',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7911897,
        LOCATION_LATITUDE_DEG: 51.0340233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OD000800',
        LOCATION_NAME: 'Odstone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4178891,
        LOCATION_LATITUDE_DEG: 52.6665674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000100',
        LOCATION_NAME: 'Offchurch',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4743366,
        LOCATION_LATITUDE_DEG: 52.2873344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000200',
        LOCATION_NAME: 'Offenham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9204937,
        LOCATION_LATITUDE_DEG: 52.1119217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000300',
        LOCATION_NAME: 'Offerton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1311242,
        LOCATION_LATITUDE_DEG: 53.392236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000500',
        LOCATION_NAME: 'Offham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0091499,
        LOCATION_LATITUDE_DEG: 50.891686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000400',
        LOCATION_NAME: 'Offham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3779042,
        LOCATION_LATITUDE_DEG: 51.2900145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000550',
        LOCATION_NAME: 'Offley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.341283,
        LOCATION_LATITUDE_DEG: 51.9282598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000600',
        LOCATION_NAME: 'Offord Cluny',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2119129,
        LOCATION_LATITUDE_DEG: 52.2884184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000700',
        LOCATION_NAME: "Offord D'Arcy",
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2128213,
        LOCATION_LATITUDE_DEG: 52.281517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000800',
        LOCATION_NAME: 'Offton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0208741,
        LOCATION_LATITUDE_DEG: 52.1068865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OF000900',
        LOCATION_NAME: 'Offwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1402769,
        LOCATION_LATITUDE_DEG: 50.7892143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000100',
        LOCATION_NAME: 'Ogbourne Maizey',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7296403,
        LOCATION_LATITUDE_DEG: 51.4429586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG001200',
        LOCATION_NAME: 'Ogbourne St Andrew',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG001300',
        LOCATION_NAME: 'Ogbourne St George',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000200',
        LOCATION_NAME: 'Ogbourne St. Andrew',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7278887,
        LOCATION_LATITUDE_DEG: 51.4495551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000300',
        LOCATION_NAME: 'Ogbourne St. George',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7083267,
        LOCATION_LATITUDE_DEG: 51.4658567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000400',
        LOCATION_NAME: 'Ogden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.894688,
        LOCATION_LATITUDE_DEG: 53.7728883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000500',
        LOCATION_NAME: 'Ogdens',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7472893,
        LOCATION_LATITUDE_DEG: 50.905206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000700',
        LOCATION_NAME: 'Ogle',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7844846,
        LOCATION_LATITUDE_DEG: 55.104513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG001400',
        LOCATION_NAME: 'Ogmore by Sea',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000800',
        LOCATION_NAME: 'Ogmore Vale',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5403522,
        LOCATION_LATITUDE_DEG: 51.5998935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000900',
        LOCATION_NAME: 'Ogmore-by-Sea',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6345292,
        LOCATION_LATITUDE_DEG: 51.4652853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG001100',
        LOCATION_NAME: 'Ogwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6389135,
        LOCATION_LATITUDE_DEG: 50.5160277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OK000100',
        LOCATION_NAME: 'Okeford Fitzpaine',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2745674,
        LOCATION_LATITUDE_DEG: 50.8971165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OK000200',
        LOCATION_NAME: 'Okehampton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.998385,
        LOCATION_LATITUDE_DEG: 50.7383152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OK000300',
        LOCATION_NAME: 'Okewood Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3867787,
        LOCATION_LATITUDE_DEG: 51.1207658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000100',
        LOCATION_NAME: 'Olchard',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5850617,
        LOCATION_LATITUDE_DEG: 50.5798978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000200',
        LOCATION_NAME: 'Old',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8460736,
        LOCATION_LATITUDE_DEG: 52.3508351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000300',
        LOCATION_NAME: 'Old Aberdeen',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1004236,
        LOCATION_LATITUDE_DEG: 57.1644221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000350',
        LOCATION_NAME: 'Old Alresford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1642007,
        LOCATION_LATITUDE_DEG: 50.9211406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000400',
        LOCATION_NAME: 'Old Basford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1770764,
        LOCATION_LATITUDE_DEG: 52.9850033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000500',
        LOCATION_NAME: 'Old Basing',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0434157,
        LOCATION_LATITUDE_DEG: 51.2684378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000600',
        LOCATION_NAME: 'Old Bewick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8968651,
        LOCATION_LATITUDE_DEG: 55.4906513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000700',
        LOCATION_NAME: 'Old Bolingbroke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0191122,
        LOCATION_LATITUDE_DEG: 53.1663975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000800',
        LOCATION_NAME: 'Old Boston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6502798,
        LOCATION_LATITUDE_DEG: 53.4726675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL000900',
        LOCATION_NAME: 'Old Brampton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4978899,
        LOCATION_LATITUDE_DEG: 53.242929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001000',
        LOCATION_NAME: 'Old Bridge of Tilt',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8448148,
        LOCATION_LATITUDE_DEG: 56.7711062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001100',
        LOCATION_NAME: 'Old Buckenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0440358,
        LOCATION_LATITUDE_DEG: 52.4809196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001200',
        LOCATION_NAME: 'Old Burghclere',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.325835,
        LOCATION_LATITUDE_DEG: 51.3180404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001300',
        LOCATION_NAME: 'Old Byland',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1554402,
        LOCATION_LATITUDE_DEG: 54.2660261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001400',
        LOCATION_NAME: 'Old Cassop',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4759526,
        LOCATION_LATITUDE_DEG: 54.7490754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001500',
        LOCATION_NAME: 'Old Catton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2833611,
        LOCATION_LATITUDE_DEG: 52.6604346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001600',
        LOCATION_NAME: 'Old Chalford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4996305,
        LOCATION_LATITUDE_DEG: 51.9283984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001700',
        LOCATION_NAME: 'Old Church Stoke',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0523812,
        LOCATION_LATITUDE_DEG: 52.5480843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001800',
        LOCATION_NAME: 'Old Clee',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0552945,
        LOCATION_LATITUDE_DEG: 53.5571419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL001900',
        LOCATION_NAME: 'Old Cleeve',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3769809,
        LOCATION_LATITUDE_DEG: 51.1673517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002000',
        LOCATION_NAME: 'Old Clipstone',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0996719,
        LOCATION_LATITUDE_DEG: 53.1766212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002100',
        LOCATION_NAME: 'Old Colwall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4021899,
        LOCATION_LATITUDE_DEG: 52.0761232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002200',
        LOCATION_NAME: 'Old Colwyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6915234,
        LOCATION_LATITUDE_DEG: 53.2881593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002300',
        LOCATION_NAME: 'Old Craighall',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0640614,
        LOCATION_LATITUDE_DEG: 55.9237082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002400',
        LOCATION_NAME: 'Old Crosby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6522874,
        LOCATION_LATITUDE_DEG: 53.5974544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002500',
        LOCATION_NAME: 'Old Dailly',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7915179,
        LOCATION_LATITUDE_DEG: 55.255963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002600',
        LOCATION_NAME: 'Old Dalby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9997538,
        LOCATION_LATITUDE_DEG: 52.8072812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002700',
        LOCATION_NAME: 'Old Deer',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0397535,
        LOCATION_LATITUDE_DEG: 57.518957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002800',
        LOCATION_NAME: 'Old Denaby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2778013,
        LOCATION_LATITUDE_DEG: 53.4851457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL002900',
        LOCATION_NAME: 'Old Derry Hill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0508885,
        LOCATION_LATITUDE_DEG: 51.4349591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003000',
        LOCATION_NAME: 'Old Dilton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1992215,
        LOCATION_LATITUDE_DEG: 51.2390463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003100',
        LOCATION_NAME: 'Old Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5549917,
        LOCATION_LATITUDE_DEG: 51.5837788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003200',
        LOCATION_NAME: 'Old Edlington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1970945,
        LOCATION_LATITUDE_DEG: 53.4689437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003300',
        LOCATION_NAME: 'Old Eldon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6175234,
        LOCATION_LATITUDE_DEG: 54.6409697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003400',
        LOCATION_NAME: 'Old Ellerby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2232611,
        LOCATION_LATITUDE_DEG: 53.8222681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003500',
        LOCATION_NAME: 'Old Farm Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6760455,
        LOCATION_LATITUDE_DEG: 52.0121018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015900',
        LOCATION_NAME: 'Old Farnley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6146114,
        LOCATION_LATITUDE_DEG: 53.7858708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003600',
        LOCATION_NAME: 'Old Fletton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2443845,
        LOCATION_LATITUDE_DEG: 52.5544446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003700',
        LOCATION_NAME: 'Old Furnace',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0578827,
        LOCATION_LATITUDE_DEG: 51.6960948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003800',
        LOCATION_NAME: 'Old Gore',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5381008,
        LOCATION_LATITUDE_DEG: 51.9553156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL003900',
        LOCATION_NAME: 'Old Hall',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6262143,
        LOCATION_LATITUDE_DEG: 52.4472752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004000',
        LOCATION_NAME: 'Old Hall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6212942,
        LOCATION_LATITUDE_DEG: 53.401758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004100',
        LOCATION_NAME: 'Old Hall Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0094453,
        LOCATION_LATITUDE_DEG: 51.8829782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004200',
        LOCATION_NAME: 'Old Hartley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4785093,
        LOCATION_LATITUDE_DEG: 55.0682049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004300',
        LOCATION_NAME: 'Old Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9261526,
        LOCATION_LATITUDE_DEG: 51.8729626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004400',
        LOCATION_NAME: 'Old Heathfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2777154,
        LOCATION_LATITUDE_DEG: 50.9581821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004500',
        LOCATION_NAME: 'Old Hinchwick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7865887,
        LOCATION_LATITUDE_DEG: 51.9644084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004600',
        LOCATION_NAME: 'Old Hunstanton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5065702,
        LOCATION_LATITUDE_DEG: 52.9505743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004700',
        LOCATION_NAME: 'Old Hurst',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0906329,
        LOCATION_LATITUDE_DEG: 52.3768309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004800',
        LOCATION_NAME: 'Old Hutton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6680339,
        LOCATION_LATITUDE_DEG: 54.2889484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL004900',
        LOCATION_NAME: 'Old Kea',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0239539,
        LOCATION_LATITUDE_DEG: 50.2358752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005100',
        LOCATION_NAME: 'Old Kilpatrick',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4553855,
        LOCATION_LATITUDE_DEG: 55.9240232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005200',
        LOCATION_NAME: 'Old Kinnernie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4547161,
        LOCATION_LATITUDE_DEG: 57.1756235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005300',
        LOCATION_NAME: 'Old Knebworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.209903,
        LOCATION_LATITUDE_DEG: 51.8689778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005400',
        LOCATION_NAME: 'Old Lackenby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1259966,
        LOCATION_LATITUDE_DEG: 54.5655532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005500',
        LOCATION_NAME: 'Old Lakenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3044618,
        LOCATION_LATITUDE_DEG: 52.6058253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005600',
        LOCATION_NAME: 'Old Langho',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4496469,
        LOCATION_LATITUDE_DEG: 53.8203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005700',
        LOCATION_NAME: 'Old Leake',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1003938,
        LOCATION_LATITUDE_DEG: 53.0309874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005800',
        LOCATION_NAME: 'Old Malton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7774788,
        LOCATION_LATITUDE_DEG: 54.1431058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005900',
        LOCATION_NAME: 'Old Marston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2359997,
        LOCATION_LATITUDE_DEG: 51.7699795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006000',
        LOCATION_NAME: 'Old Marton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9665377,
        LOCATION_LATITUDE_DEG: 52.8989159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006100',
        LOCATION_NAME: 'Old Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3009289,
        LOCATION_LATITUDE_DEG: 50.5410017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006200',
        LOCATION_NAME: 'Old Milverton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5589754,
        LOCATION_LATITUDE_DEG: 52.304135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006300',
        LOCATION_NAME: 'Old Minnigaff',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4809255,
        LOCATION_LATITUDE_DEG: 54.966527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006400',
        LOCATION_NAME: 'Old Monkland',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0477081,
        LOCATION_LATITUDE_DEG: 55.8481132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006500',
        LOCATION_NAME: 'Old Neighbouring',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1579019,
        LOCATION_LATITUDE_DEG: 51.7220899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006600',
        LOCATION_NAME: 'Old Newton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0019454,
        LOCATION_LATITUDE_DEG: 52.2228962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006800',
        LOCATION_NAME: 'Old Park',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4590369,
        LOCATION_LATITUDE_DEG: 52.6804863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006900',
        LOCATION_NAME: 'Old Penshaw',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.481712,
        LOCATION_LATITUDE_DEG: 54.8831864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007000',
        LOCATION_NAME: 'Old Penygarn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.034276,
        LOCATION_LATITUDE_DEG: 51.7073029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007100',
        LOCATION_NAME: 'Old Perceton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6185214,
        LOCATION_LATITUDE_DEG: 55.6305966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007200',
        LOCATION_NAME: 'Old Pit',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5768342,
        LOCATION_LATITUDE_DEG: 54.8015796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007300',
        LOCATION_NAME: 'Old Plean',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8699378,
        LOCATION_LATITUDE_DEG: 56.0620354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007400',
        LOCATION_NAME: 'Old Pound',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8570882,
        LOCATION_LATITUDE_DEG: 50.3639906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007500',
        LOCATION_NAME: 'Old Quarrington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4993136,
        LOCATION_LATITUDE_DEG: 54.734569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007600',
        LOCATION_NAME: 'Old Radnor',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0992902,
        LOCATION_LATITUDE_DEG: 52.2241502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL016000',
        LOCATION_NAME: 'Old Roan',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9510718,
        LOCATION_LATITUDE_DEG: 53.4872384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007700',
        LOCATION_NAME: 'Old Romney',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8994553,
        LOCATION_LATITUDE_DEG: 50.9908828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007900',
        LOCATION_NAME: 'Old Sarum',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7985803,
        LOCATION_LATITUDE_DEG: 51.0828244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008000',
        LOCATION_NAME: 'Old Sauchie',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9584128,
        LOCATION_LATITUDE_DEG: 56.0726344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008100',
        LOCATION_NAME: 'Old Scone',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4277111,
        LOCATION_LATITUDE_DEG: 56.4256585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008200',
        LOCATION_NAME: 'Old Shifford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4570279,
        LOCATION_LATITUDE_DEG: 51.7244845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008300',
        LOCATION_NAME: 'Old Skellow',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2016336,
        LOCATION_LATITUDE_DEG: 53.5882581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008400',
        LOCATION_NAME: 'Old Snydale',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3914705,
        LOCATION_LATITUDE_DEG: 53.6873676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008500',
        LOCATION_NAME: 'Old Sodbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3558076,
        LOCATION_LATITUDE_DEG: 51.5317748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008600',
        LOCATION_NAME: 'Old Somerby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5664698,
        LOCATION_LATITUDE_DEG: 52.8940809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008700',
        LOCATION_NAME: 'Old South Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7009451,
        LOCATION_LATITUDE_DEG: 54.8531867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015600',
        LOCATION_NAME: 'Old St Mellons',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008800',
        LOCATION_NAME: 'Old St. Mellons',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1004927,
        LOCATION_LATITUDE_DEG: 51.5339875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL008900',
        LOCATION_NAME: 'Old Stratford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8632867,
        LOCATION_LATITUDE_DEG: 52.0628037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009000',
        LOCATION_NAME: 'Old Swan',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9198104,
        LOCATION_LATITUDE_DEG: 53.4133615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009100',
        LOCATION_NAME: 'Old Tebay',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5906458,
        LOCATION_LATITUDE_DEG: 54.4391605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009200',
        LOCATION_NAME: 'Old Tinhay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2706242,
        LOCATION_LATITUDE_DEG: 50.6441069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009300',
        LOCATION_NAME: 'Old Toll',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5837152,
        LOCATION_LATITUDE_DEG: 55.4538782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009500',
        LOCATION_NAME: 'Old Town',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3498169,
        LOCATION_LATITUDE_DEG: 51.6379843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009800',
        LOCATION_NAME: 'Old Town',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1179454,
        LOCATION_LATITUDE_DEG: 55.8433929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009700',
        LOCATION_NAME: 'Old Town',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7059407,
        LOCATION_LATITUDE_DEG: 52.1873265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009400',
        LOCATION_NAME: 'Old Town',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6989091,
        LOCATION_LATITUDE_DEG: 51.9914081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009600',
        LOCATION_NAME: 'Old Town',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2515956,
        LOCATION_LATITUDE_DEG: 50.766171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010100',
        LOCATION_NAME: 'Old Trafford',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.282447,
        LOCATION_LATITUDE_DEG: 53.455962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010200',
        LOCATION_NAME: 'Old Tupton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4206029,
        LOCATION_LATITUDE_DEG: 53.1819227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010400',
        LOCATION_NAME: 'Old Walker',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5484213,
        LOCATION_LATITUDE_DEG: 54.983195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010500',
        LOCATION_NAME: 'Old Wall',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8104521,
        LOCATION_LATITUDE_DEG: 54.9471086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010600',
        LOCATION_NAME: 'Old Warden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3374922,
        LOCATION_LATITUDE_DEG: 52.0830057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010700',
        LOCATION_NAME: 'Old Weston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3850896,
        LOCATION_LATITUDE_DEG: 52.3828315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010800',
        LOCATION_NAME: 'Old Whittington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4242476,
        LOCATION_LATITUDE_DEG: 53.2684332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010900',
        LOCATION_NAME: 'Old Windsor',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5852296,
        LOCATION_LATITUDE_DEG: 51.4578459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011000',
        LOCATION_NAME: 'Old Wives Lees',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9698599,
        LOCATION_LATITUDE_DEG: 51.2549072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011100',
        LOCATION_NAME: 'Old Woking',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5408512,
        LOCATION_LATITUDE_DEG: 51.3018342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011200',
        LOCATION_NAME: 'Old Wolverton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8184625,
        LOCATION_LATITUDE_DEG: 52.0636037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011300',
        LOCATION_NAME: 'Old Woodhall',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1746659,
        LOCATION_LATITUDE_DEG: 53.1910056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011400',
        LOCATION_NAME: 'Old Woodhouses',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6082035,
        LOCATION_LATITUDE_DEG: 52.9805148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011600',
        LOCATION_NAME: 'Oldbrook',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7531538,
        LOCATION_LATITUDE_DEG: 52.0324024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011900',
        LOCATION_NAME: 'Oldbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4267614,
        LOCATION_LATITUDE_DEG: 52.5243722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011800',
        LOCATION_NAME: 'Oldbury',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.014778,
        LOCATION_LATITUDE_DEG: 52.5035623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011700',
        LOCATION_NAME: 'Oldbury',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5379708,
        LOCATION_LATITUDE_DEG: 52.5475624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012000',
        LOCATION_NAME: 'Oldbury Naite',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5458777,
        LOCATION_LATITUDE_DEG: 51.6398893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015700',
        LOCATION_NAME: 'Oldbury on Severn',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012100',
        LOCATION_NAME: 'Oldbury-on-Severn',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5660094,
        LOCATION_LATITUDE_DEG: 51.6259187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012500',
        LOCATION_NAME: 'Oldcotes',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1165457,
        LOCATION_LATITUDE_DEG: 53.3914399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012800',
        LOCATION_NAME: 'Oldcroft',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5102144,
        LOCATION_LATITUDE_DEG: 51.7523004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012900',
        LOCATION_NAME: 'Oldends',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2956788,
        LOCATION_LATITUDE_DEG: 51.7486926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013000',
        LOCATION_NAME: 'Oldfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9891031,
        LOCATION_LATITUDE_DEG: 53.8371964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013100',
        LOCATION_NAME: 'Oldfields',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5520895,
        LOCATION_LATITUDE_DEG: 52.9231061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013200',
        LOCATION_NAME: 'Oldford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3008552,
        LOCATION_LATITUDE_DEG: 51.250448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013300',
        LOCATION_NAME: 'Oldhall',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3854698,
        LOCATION_LATITUDE_DEG: 55.8476175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013400',
        LOCATION_NAME: 'Oldham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1115727,
        LOCATION_LATITUDE_DEG: 53.5412661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013500',
        LOCATION_NAME: 'Oldham Edge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1127475,
        LOCATION_LATITUDE_DEG: 53.5460654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013600',
        LOCATION_NAME: 'Oldhamstocks',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4186662,
        LOCATION_LATITUDE_DEG: 55.928302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013700',
        LOCATION_NAME: 'Oldington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3931767,
        LOCATION_LATITUDE_DEG: 52.5749728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013800',
        LOCATION_NAME: 'Oldland Common',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4976426,
        LOCATION_LATITUDE_DEG: 51.446171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014000',
        LOCATION_NAME: 'Oldmeldrum',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3148834,
        LOCATION_LATITUDE_DEG: 57.3377369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL990543',
        LOCATION_NAME: 'Oldmixon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014100',
        LOCATION_NAME: 'Oldshoremore',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0714674,
        LOCATION_LATITUDE_DEG: 58.4787836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014200',
        LOCATION_NAME: 'Oldstead',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1865676,
        LOCATION_LATITUDE_DEG: 54.2121195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014500',
        LOCATION_NAME: 'Oldwhat',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2340145,
        LOCATION_LATITUDE_DEG: 57.5529558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014600',
        LOCATION_NAME: 'Oldwood',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5973576,
        LOCATION_LATITUDE_DEG: 52.2990511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014700',
        LOCATION_NAME: 'Oldwood Common',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6073583,
        LOCATION_LATITUDE_DEG: 52.2946482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014800',
        LOCATION_NAME: 'Ollaberry',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3324423,
        LOCATION_LATITUDE_DEG: 60.5075433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014900',
        LOCATION_NAME: 'Ollerton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5190709,
        LOCATION_LATITUDE_DEG: 52.822804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015000',
        LOCATION_NAME: 'Ollerton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3349182,
        LOCATION_LATITUDE_DEG: 53.286946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015100',
        LOCATION_NAME: 'Ollerton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0218344,
        LOCATION_LATITUDE_DEG: 53.1994182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015200',
        LOCATION_NAME: 'Ollerton Post',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5328926,
        LOCATION_LATITUDE_DEG: 52.8207019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015300',
        LOCATION_NAME: 'Olney',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7004279,
        LOCATION_LATITUDE_DEG: 52.1522107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015400',
        LOCATION_NAME: 'Olton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B91',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.812093,
        LOCATION_LATITUDE_DEG: 52.4428595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015500',
        LOCATION_NAME: 'Olveston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5756577,
        LOCATION_LATITUDE_DEG: 51.5822854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OM000100',
        LOCATION_NAME: 'Omagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3001353,
        LOCATION_LATITUDE_DEG: 54.6017205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OM000200',
        LOCATION_NAME: 'Ombersley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2290521,
        LOCATION_LATITUDE_DEG: 52.2707401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OM000400',
        LOCATION_NAME: 'Ompton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9697272,
        LOCATION_LATITUDE_DEG: 53.1790115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000200',
        LOCATION_NAME: 'Onchan',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.455958,
        LOCATION_LATITUDE_DEG: 54.1788946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000300',
        LOCATION_NAME: 'Onecote',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9258061,
        LOCATION_LATITUDE_DEG: 53.0929229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000400',
        LOCATION_NAME: 'Onehouse',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9521815,
        LOCATION_LATITUDE_DEG: 52.1937964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000500',
        LOCATION_NAME: 'Ongar',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2464969,
        LOCATION_LATITUDE_DEG: 51.7119584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000600',
        LOCATION_NAME: 'Ongar Hill',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3430466,
        LOCATION_LATITUDE_DEG: 52.7959599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000700',
        LOCATION_NAME: 'Onibury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8017719,
        LOCATION_LATITUDE_DEG: 52.4076616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000800',
        LOCATION_NAME: 'Onich',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2212374,
        LOCATION_LATITUDE_DEG: 56.703214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000900',
        LOCATION_NAME: 'Onllwyn',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6784023,
        LOCATION_LATITUDE_DEG: 51.7789148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON001000',
        LOCATION_NAME: 'Onneley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3717493,
        LOCATION_LATITUDE_DEG: 52.9840155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON001100',
        LOCATION_NAME: 'Onslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8340169,
        LOCATION_LATITUDE_DEG: 52.711195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON001200',
        LOCATION_NAME: 'Onslow Village',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.594818,
        LOCATION_LATITUDE_DEG: 51.231527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OP000300',
        LOCATION_NAME: 'Openshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1757266,
        LOCATION_LATITUDE_DEG: 53.4754312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OP000200',
        LOCATION_NAME: 'Opinan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7813313,
        LOCATION_LATITUDE_DEG: 57.6856166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OP000100',
        LOCATION_NAME: 'Opinan',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5840795,
        LOCATION_LATITUDE_DEG: 57.9097306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000300',
        LOCATION_NAME: 'Orbiston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0246391,
        LOCATION_LATITUDE_DEG: 55.8091093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000400',
        LOCATION_NAME: 'Orby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2314652,
        LOCATION_LATITUDE_DEG: 53.1820026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000500',
        LOCATION_NAME: 'Orchard Leigh',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5712501,
        LOCATION_LATITUDE_DEG: 51.7201732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000600',
        LOCATION_NAME: 'Orchard Portman',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0742261,
        LOCATION_LATITUDE_DEG: 50.989431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000700',
        LOCATION_NAME: 'Orchardleigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3211293,
        LOCATION_LATITUDE_DEG: 51.2603493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000800',
        LOCATION_NAME: 'Orcheston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9160778,
        LOCATION_LATITUDE_DEG: 51.2068381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000900',
        LOCATION_NAME: 'Orcop',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.764995,
        LOCATION_LATITUDE_DEG: 51.9315171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR990061',
        LOCATION_NAME: 'Orcop Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7555043,
        LOCATION_LATITUDE_DEG: 51.9510371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001000',
        LOCATION_NAME: 'Ord',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.479235,
        LOCATION_LATITUDE_DEG: 57.5173868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001100',
        LOCATION_NAME: 'Ordhead',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5473103,
        LOCATION_LATITUDE_DEG: 57.1865291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001200',
        LOCATION_NAME: 'Ordie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9040064,
        LOCATION_LATITUDE_DEG: 57.1019263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001300',
        LOCATION_NAME: 'Ordsall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9434283,
        LOCATION_LATITUDE_DEG: 53.3082233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001400',
        LOCATION_NAME: 'Ore',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6101382,
        LOCATION_LATITUDE_DEG: 50.8715777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001500',
        LOCATION_NAME: 'Oreston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1071163,
        LOCATION_LATITUDE_DEG: 50.3598818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001600',
        LOCATION_NAME: 'Oreton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5056593,
        LOCATION_LATITUDE_DEG: 52.4168604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR990292',
        LOCATION_NAME: 'Orford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5793463,
        LOCATION_LATITUDE_DEG: 53.4077134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001700',
        LOCATION_NAME: 'Orford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1881347,
        LOCATION_LATITUDE_DEG: 53.4360279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001800',
        LOCATION_NAME: 'Orford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5359249,
        LOCATION_LATITUDE_DEG: 52.0942765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR001900',
        LOCATION_NAME: 'Organford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0840132,
        LOCATION_LATITUDE_DEG: 50.7359927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002000',
        LOCATION_NAME: 'Orgreave',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7817705,
        LOCATION_LATITUDE_DEG: 52.7395866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002100',
        LOCATION_NAME: 'Orgreave',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3651602,
        LOCATION_LATITUDE_DEG: 53.383042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002200',
        LOCATION_NAME: 'Orielton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9564047,
        LOCATION_LATITUDE_DEG: 51.6505173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002300',
        LOCATION_NAME: 'Orinsay',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.459531,
        LOCATION_LATITUDE_DEG: 58.0198494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002500',
        LOCATION_NAME: 'Oritor',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7989795,
        LOCATION_LATITUDE_DEG: 54.6499209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002600',
        LOCATION_NAME: 'Orkney',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1650853,
        LOCATION_LATITUDE_DEG: 59.0387183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002700',
        LOCATION_NAME: 'Orleton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7437488,
        LOCATION_LATITUDE_DEG: 52.3004498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002800',
        LOCATION_NAME: 'Orlingbury',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.736566,
        LOCATION_LATITUDE_DEG: 52.341928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002900',
        LOCATION_NAME: 'Ormathwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1323039,
        LOCATION_LATITUDE_DEG: 54.6172793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR006400',
        LOCATION_NAME: 'Ormeau',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9235158,
        LOCATION_LATITUDE_DEG: 54.5867345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003000',
        LOCATION_NAME: 'Ormesby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1733393,
        LOCATION_LATITUDE_DEG: 54.5474511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003100',
        LOCATION_NAME: 'Ormesby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6914164,
        LOCATION_LATITUDE_DEG: 52.6725207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003200',
        LOCATION_NAME: 'Ormiclate',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4036864,
        LOCATION_LATITUDE_DEG: 57.2620731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003300',
        LOCATION_NAME: 'Ormiscaig',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6110782,
        LOCATION_LATITUDE_DEG: 57.852431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003400',
        LOCATION_NAME: 'Ormiston',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9364872,
        LOCATION_LATITUDE_DEG: 55.9131068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003600',
        LOCATION_NAME: 'Ormsary',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6127854,
        LOCATION_LATITUDE_DEG: 55.891835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003700',
        LOCATION_NAME: 'Ormside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4621341,
        LOCATION_LATITUDE_DEG: 54.5499679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003800',
        LOCATION_NAME: 'Ormskirk',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8854931,
        LOCATION_LATITUDE_DEG: 53.5662765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003900',
        LOCATION_NAME: 'Orphir',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1412249,
        LOCATION_LATITUDE_DEG: 58.93611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004000',
        LOCATION_NAME: 'Orpington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1008735,
        LOCATION_LATITUDE_DEG: 51.3752273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR006300',
        LOCATION_NAME: 'Orrell',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9797845,
        LOCATION_LATITUDE_DEG: 53.4629675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004100',
        LOCATION_NAME: 'Orrell',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7029959,
        LOCATION_LATITUDE_DEG: 53.5397734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004200',
        LOCATION_NAME: 'Orrell Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9615873,
        LOCATION_LATITUDE_DEG: 53.4616679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004300',
        LOCATION_NAME: 'Orsett',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3690503,
        LOCATION_LATITUDE_DEG: 51.511941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004400',
        LOCATION_NAME: 'Orslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.285312,
        LOCATION_LATITUDE_DEG: 52.7339868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004500',
        LOCATION_NAME: 'Orston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8516452,
        LOCATION_LATITUDE_DEG: 52.9604938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004600',
        LOCATION_NAME: 'Orton',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1496544,
        LOCATION_LATITUDE_DEG: 57.5520725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004700',
        LOCATION_NAME: 'Orton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5819661,
        LOCATION_LATITUDE_DEG: 54.4686568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004800',
        LOCATION_NAME: 'Orton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8155275,
        LOCATION_LATITUDE_DEG: 52.4053369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR004900',
        LOCATION_NAME: 'Orton Brimbles',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.303279,
        LOCATION_LATITUDE_DEG: 52.5467432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005000',
        LOCATION_NAME: 'Orton Goldhay',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2892504,
        LOCATION_LATITUDE_DEG: 52.5437447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005100',
        LOCATION_NAME: 'Orton Grange',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0082994,
        LOCATION_LATITUDE_DEG: 54.8584019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005200',
        LOCATION_NAME: 'Orton Longueville',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2754345,
        LOCATION_LATITUDE_DEG: 52.5530487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005300',
        LOCATION_NAME: 'Orton Malborne',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2712923,
        LOCATION_LATITUDE_DEG: 52.5473413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR990521',
        LOCATION_NAME: 'Orton Northgate',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3113657,
        LOCATION_LATITUDE_DEG: 52.5485673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR006100',
        LOCATION_NAME: 'Orton on the Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005400',
        LOCATION_NAME: 'Orton Park',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0003095,
        LOCATION_LATITUDE_DEG: 54.8648044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005500',
        LOCATION_NAME: 'Orton Rigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0409783,
        LOCATION_LATITUDE_DEG: 54.8617034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005600',
        LOCATION_NAME: 'Orton Southgate',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3082958,
        LOCATION_LATITUDE_DEG: 52.5409432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005700',
        LOCATION_NAME: 'Orton Waterville',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2927753,
        LOCATION_LATITUDE_DEG: 52.5513489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005800',
        LOCATION_NAME: 'Orton Wistow',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3116767,
        LOCATION_LATITUDE_DEG: 52.5554505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR005900',
        LOCATION_NAME: 'Orton-on-the-Hill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5506846,
        LOCATION_LATITUDE_DEG: 52.6326744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR006000',
        LOCATION_NAME: 'Orwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0093439,
        LOCATION_LATITUDE_DEG: 52.1351053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000100',
        LOCATION_NAME: 'Osbaldeston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5351236,
        LOCATION_LATITUDE_DEG: 53.7802891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000200',
        LOCATION_NAME: 'Osbaldwick',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0380526,
        LOCATION_LATITUDE_DEG: 53.9557923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000300',
        LOCATION_NAME: 'Osbaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0056349,
        LOCATION_LATITUDE_DEG: 52.7984066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000500',
        LOCATION_NAME: 'Osbaston',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7202427,
        LOCATION_LATITUDE_DEG: 51.8255039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000400',
        LOCATION_NAME: 'Osbaston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3709461,
        LOCATION_LATITUDE_DEG: 52.6348684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS991028',
        LOCATION_NAME: 'Osbaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.008,
        LOCATION_LATITUDE_DEG: 52.798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000600',
        LOCATION_NAME: 'Osberton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0540125,
        LOCATION_LATITUDE_DEG: 53.3093403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000800',
        LOCATION_NAME: 'Osbournby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4071876,
        LOCATION_LATITUDE_DEG: 52.9295812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000900',
        LOCATION_NAME: 'Oscroft',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7388215,
        LOCATION_LATITUDE_DEG: 53.1965397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001000',
        LOCATION_NAME: 'Ose',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4690281,
        LOCATION_LATITUDE_DEG: 57.3789868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001100',
        LOCATION_NAME: 'Osea Island',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7725627,
        LOCATION_LATITUDE_DEG: 51.7210526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001200',
        LOCATION_NAME: 'Osgathorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3617118,
        LOCATION_LATITUDE_DEG: 52.7716772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001500',
        LOCATION_NAME: 'Osgodby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0300171,
        LOCATION_LATITUDE_DEG: 53.7942261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001300',
        LOCATION_NAME: 'Osgodby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3858508,
        LOCATION_LATITUDE_DEG: 53.4198307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001400',
        LOCATION_NAME: 'Osgodby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3748092,
        LOCATION_LATITUDE_DEG: 54.2490135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001600',
        LOCATION_NAME: 'Osleston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6295013,
        LOCATION_LATITUDE_DEG: 52.9300954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001700',
        LOCATION_NAME: 'Osmaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7031248,
        LOCATION_LATITUDE_DEG: 52.9923083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001800',
        LOCATION_NAME: 'Osmere',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6420966,
        LOCATION_LATITUDE_DEG: 52.9929141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS001900',
        LOCATION_NAME: 'Osmington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3873682,
        LOCATION_LATITUDE_DEG: 50.6444882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002000',
        LOCATION_NAME: 'Osmington Mills',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3738845,
        LOCATION_LATITUDE_DEG: 50.6368875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002100',
        LOCATION_NAME: 'Osmondthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5090359,
        LOCATION_LATITUDE_DEG: 53.7964787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002200',
        LOCATION_NAME: 'Osmotherley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2975938,
        LOCATION_LATITUDE_DEG: 54.3685344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002300',
        LOCATION_NAME: 'Ospringe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8716021,
        LOCATION_LATITUDE_DEG: 51.3077073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002400',
        LOCATION_NAME: 'Ossemsley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6665718,
        LOCATION_LATITUDE_DEG: 50.7853982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002500',
        LOCATION_NAME: 'Ossett',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5789065,
        LOCATION_LATITUDE_DEG: 53.679975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002600',
        LOCATION_NAME: 'Ossington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8663515,
        LOCATION_LATITUDE_DEG: 53.1738111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002700',
        LOCATION_NAME: 'Ostend',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7983365,
        LOCATION_LATITUDE_DEG: 51.642646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002800',
        LOCATION_NAME: 'Oswaldkirk',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.046692,
        LOCATION_LATITUDE_DEG: 54.2027165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS002900',
        LOCATION_NAME: 'Oswaldtwistle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4013701,
        LOCATION_LATITUDE_DEG: 53.7410884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS003000',
        LOCATION_NAME: 'Oswestry',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0524133,
        LOCATION_LATITUDE_DEG: 52.8595076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000100',
        LOCATION_NAME: 'Oteley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8728518,
        LOCATION_LATITUDE_DEG: 52.9062134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000200',
        LOCATION_NAME: 'Otford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1919849,
        LOCATION_LATITUDE_DEG: 51.3123252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000300',
        LOCATION_NAME: 'Otham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5700831,
        LOCATION_LATITUDE_DEG: 51.2463116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000400',
        LOCATION_NAME: 'Othery',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8793823,
        LOCATION_LATITUDE_DEG: 51.0802392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000600',
        LOCATION_NAME: 'Otley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6921975,
        LOCATION_LATITUDE_DEG: 53.9054956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000500',
        LOCATION_NAME: 'Otley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2231577,
        LOCATION_LATITUDE_DEG: 52.1514835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000700',
        LOCATION_NAME: 'Otter Ferry',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3201601,
        LOCATION_LATITUDE_DEG: 56.0070443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000800',
        LOCATION_NAME: 'Otterbourne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3419557,
        LOCATION_LATITUDE_DEG: 51.0071129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT000900',
        LOCATION_NAME: 'Otterburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1818453,
        LOCATION_LATITUDE_DEG: 55.2321292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001000',
        LOCATION_NAME: 'Otterburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1784372,
        LOCATION_LATITUDE_DEG: 54.0155106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001100',
        LOCATION_NAME: 'Otterden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7874933,
        LOCATION_LATITUDE_DEG: 51.2469368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001200',
        LOCATION_NAME: 'Otterford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0987107,
        LOCATION_LATITUDE_DEG: 50.9328219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001300',
        LOCATION_NAME: 'Otterham',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5935061,
        LOCATION_LATITUDE_DEG: 50.6865163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001400',
        LOCATION_NAME: 'Otterhampton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0759311,
        LOCATION_LATITUDE_DEG: 51.1818487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001500',
        LOCATION_NAME: 'Ottershaw',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.526078,
        LOCATION_LATITUDE_DEG: 51.3621389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT002100',
        LOCATION_NAME: 'Otterspool Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9347621,
        LOCATION_LATITUDE_DEG: 53.3740132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001600',
        LOCATION_NAME: 'Otterton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2964404,
        LOCATION_LATITUDE_DEG: 50.6592994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT002000',
        LOCATION_NAME: 'Ottery St Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001700',
        LOCATION_NAME: 'Ottery St. Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2764495,
        LOCATION_LATITUDE_DEG: 50.7512067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001800',
        LOCATION_NAME: 'Ottinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1009991,
        LOCATION_LATITUDE_DEG: 51.139596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OT001900',
        LOCATION_NAME: 'Ottringham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0769984,
        LOCATION_LATITUDE_DEG: 53.7013541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000300',
        LOCATION_NAME: 'Oughterby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1004411,
        LOCATION_LATITUDE_DEG: 54.8910102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000400',
        LOCATION_NAME: 'Oughtershaw',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2010838,
        LOCATION_LATITUDE_DEG: 54.2297347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000500',
        LOCATION_NAME: 'Oughterside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3691147,
        LOCATION_LATITUDE_DEG: 54.7479983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000600',
        LOCATION_NAME: 'Oughtibridge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5388885,
        LOCATION_LATITUDE_DEG: 53.435548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000800',
        LOCATION_NAME: 'Oulston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1621089,
        LOCATION_LATITUDE_DEG: 54.1620105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001100',
        LOCATION_NAME: 'Oulton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1742611,
        LOCATION_LATITUDE_DEG: 54.8466013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000900',
        LOCATION_NAME: 'Oulton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1356096,
        LOCATION_LATITUDE_DEG: 52.9188092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001000',
        LOCATION_NAME: 'Oulton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4505542,
        LOCATION_LATITUDE_DEG: 53.7461733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001300',
        LOCATION_NAME: 'Oulton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1684485,
        LOCATION_LATITUDE_DEG: 52.8104512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001200',
        LOCATION_NAME: 'Oulton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7204971,
        LOCATION_LATITUDE_DEG: 52.4912081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001400',
        LOCATION_NAME: 'Oulton Broad',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7110762,
        LOCATION_LATITUDE_DEG: 52.4714075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001500',
        LOCATION_NAME: 'Oulton Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1334526,
        LOCATION_LATITUDE_DEG: 52.9284043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001600',
        LOCATION_NAME: 'Oundle',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4736533,
        LOCATION_LATITUDE_DEG: 52.4808422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU003600',
        LOCATION_NAME: 'Ousburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -9.1648311,
        LOCATION_LATITUDE_DEG: 53.3867084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001800',
        LOCATION_NAME: 'Ousby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5905861,
        LOCATION_LATITUDE_DEG: 54.7078842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001900',
        LOCATION_NAME: 'Ousden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5515905,
        LOCATION_LATITUDE_DEG: 52.2056993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002000',
        LOCATION_NAME: 'Ousefleet',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7457582,
        LOCATION_LATITUDE_DEG: 53.6979617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002200',
        LOCATION_NAME: 'Ouston',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8846162,
        LOCATION_LATITUDE_DEG: 55.0284112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002100',
        LOCATION_NAME: 'Ouston',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5962267,
        LOCATION_LATITUDE_DEG: 54.8834861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002300',
        LOCATION_NAME: 'Out Newton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0953929,
        LOCATION_LATITUDE_DEG: 53.6756517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002400',
        LOCATION_NAME: 'Out Rawcliffe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9047535,
        LOCATION_LATITUDE_DEG: 53.8681067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002500',
        LOCATION_NAME: 'Out Skerries',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7598162,
        LOCATION_LATITUDE_DEG: 60.4226171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002600',
        LOCATION_NAME: 'Outcast',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0715124,
        LOCATION_LATITUDE_DEG: 54.1899387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002700',
        LOCATION_NAME: 'Outend',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6674736,
        LOCATION_LATITUDE_DEG: 57.8620372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002800',
        LOCATION_NAME: 'Outgate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9931768,
        LOCATION_LATITUDE_DEG: 54.3893593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU002900',
        LOCATION_NAME: 'Outhgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.335149,
        LOCATION_LATITUDE_DEG: 54.4086539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU003000',
        LOCATION_NAME: 'Outhill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8495258,
        LOCATION_LATITUDE_DEG: 52.2954396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU003100',
        LOCATION_NAME: 'Outlane',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8760001,
        LOCATION_LATITUDE_DEG: 53.6570723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU003200',
        LOCATION_NAME: 'Outwell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2365308,
        LOCATION_LATITUDE_DEG: 52.6093448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU003300',
        LOCATION_NAME: 'Outwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5013441,
        LOCATION_LATITUDE_DEG: 53.7088743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU003400',
        LOCATION_NAME: 'Outwood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1163395,
        LOCATION_LATITUDE_DEG: 51.1919117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU003500',
        LOCATION_NAME: 'Outwoods',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3126674,
        LOCATION_LATITUDE_DEG: 52.7544885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000100',
        LOCATION_NAME: 'Ovenden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8750075,
        LOCATION_LATITUDE_DEG: 53.741884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000200',
        LOCATION_NAME: 'Ovenden Wood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8987745,
        LOCATION_LATITUDE_DEG: 53.7394794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000400',
        LOCATION_NAME: 'Ovenstone',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7449938,
        LOCATION_LATITUDE_DEG: 56.2369366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000500',
        LOCATION_NAME: 'Over',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2708867,
        LOCATION_LATITUDE_DEG: 51.8737059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000600',
        LOCATION_NAME: 'Over',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0176266,
        LOCATION_LATITUDE_DEG: 52.3161212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000700',
        LOCATION_NAME: 'Over Alderley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1935444,
        LOCATION_LATITUDE_DEG: 53.2813439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000800',
        LOCATION_NAME: 'Over Compton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.582873,
        LOCATION_LATITUDE_DEG: 50.9498194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000900',
        LOCATION_NAME: 'Over Dinsdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4629739,
        LOCATION_LATITUDE_DEG: 54.4989481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001000',
        LOCATION_NAME: 'Over Haddon',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6944352,
        LOCATION_LATITUDE_DEG: 53.1951301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001100',
        LOCATION_NAME: 'Over Hulton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.469025,
        LOCATION_LATITUDE_DEG: 53.5457652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001200',
        LOCATION_NAME: 'Over Kellet',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7344049,
        LOCATION_LATITUDE_DEG: 54.1237289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001300',
        LOCATION_NAME: 'Over Norton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.540304,
        LOCATION_LATITUDE_DEG: 51.9520061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001400',
        LOCATION_NAME: 'Over Peover',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3293771,
        LOCATION_LATITUDE_DEG: 53.2628416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001500',
        LOCATION_NAME: 'Over Silton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3058669,
        LOCATION_LATITUDE_DEG: 54.3325298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001600',
        LOCATION_NAME: 'Over Stowey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1614145,
        LOCATION_LATITUDE_DEG: 51.1374492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001700',
        LOCATION_NAME: 'Over Stratton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8025597,
        LOCATION_LATITUDE_DEG: 50.9318243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001800',
        LOCATION_NAME: 'Over Tabley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4149489,
        LOCATION_LATITUDE_DEG: 53.3158484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV001900',
        LOCATION_NAME: 'Over Wallop',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5942041,
        LOCATION_LATITUDE_DEG: 51.1432313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002000',
        LOCATION_NAME: 'Over Whitacre',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6257061,
        LOCATION_LATITUDE_DEG: 52.5168625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002100',
        LOCATION_NAME: 'Over Worton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3699887,
        LOCATION_LATITUDE_DEG: 51.9577012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002200',
        LOCATION_NAME: 'Over Wyresdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6843747,
        LOCATION_LATITUDE_DEG: 53.9691101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002300',
        LOCATION_NAME: 'Overbury',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0573017,
        LOCATION_LATITUDE_DEG: 52.0390214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002400',
        LOCATION_NAME: 'Overdale',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4705891,
        LOCATION_LATITUDE_DEG: 52.6844868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002500',
        LOCATION_NAME: 'Overdale Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9670092,
        LOCATION_LATITUDE_DEG: 53.9869106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002600',
        LOCATION_NAME: 'Overdene',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9756762,
        LOCATION_LATITUDE_DEG: 54.57605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002700',
        LOCATION_NAME: 'Overley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5742313,
        LOCATION_LATITUDE_DEG: 52.6949899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002800',
        LOCATION_NAME: 'Overseal',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5634657,
        LOCATION_LATITUDE_DEG: 52.7351809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV002900',
        LOCATION_NAME: 'Oversley Green',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8590935,
        LOCATION_LATITUDE_DEG: 52.2102313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003000',
        LOCATION_NAME: 'Overstone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8137773,
        LOCATION_LATITUDE_DEG: 52.2907292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003100',
        LOCATION_NAME: 'Overstrand',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3405669,
        LOCATION_LATITUDE_DEG: 52.9158562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003300',
        LOCATION_NAME: 'Overthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6261777,
        LOCATION_LATITUDE_DEG: 53.6628725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003200',
        LOCATION_NAME: 'Overthorpe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2967397,
        LOCATION_LATITUDE_DEG: 52.0625096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003700',
        LOCATION_NAME: 'Overton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9327298,
        LOCATION_LATITUDE_DEG: 52.9689176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003500',
        LOCATION_NAME: 'Overton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8592659,
        LOCATION_LATITUDE_DEG: 54.0151162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003900',
        LOCATION_NAME: 'Overton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7265092,
        LOCATION_LATITUDE_DEG: 52.3439588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003800',
        LOCATION_NAME: 'Overton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6057818,
        LOCATION_LATITUDE_DEG: 53.6459701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003400',
        LOCATION_NAME: 'Overton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2600723,
        LOCATION_LATITUDE_DEG: 51.2434331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV003600',
        LOCATION_NAME: 'Overton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1528443,
        LOCATION_LATITUDE_DEG: 53.9945005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004000',
        LOCATION_NAME: 'Overtown',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9092984,
        LOCATION_LATITUDE_DEG: 55.754106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004200',
        LOCATION_NAME: 'Oving',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8588709,
        LOCATION_LATITUDE_DEG: 51.8843916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004100',
        LOCATION_NAME: 'Oving',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7194611,
        LOCATION_LATITUDE_DEG: 50.8365873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004300',
        LOCATION_NAME: 'Ovingdean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0727736,
        LOCATION_LATITUDE_DEG: 50.8141778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004400',
        LOCATION_NAME: 'Ovingham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8669802,
        LOCATION_LATITUDE_DEG: 54.9680979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV990564',
        LOCATION_NAME: 'Ovington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004500',
        LOCATION_NAME: 'Ovington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8987235,
        LOCATION_LATITUDE_DEG: 54.9682003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004600',
        LOCATION_NAME: 'Ovington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7967459,
        LOCATION_LATITUDE_DEG: 54.5272572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004800',
        LOCATION_NAME: 'Ovington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1993966,
        LOCATION_LATITUDE_DEG: 51.0813178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV004700',
        LOCATION_NAME: 'Ovington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.842686,
        LOCATION_LATITUDE_DEG: 52.5849365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000300',
        LOCATION_NAME: 'Ower',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5372718,
        LOCATION_LATITUDE_DEG: 50.9459054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000400',
        LOCATION_NAME: 'Owermoigne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3278962,
        LOCATION_LATITUDE_DEG: 50.6657883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000500',
        LOCATION_NAME: 'Owersby Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3701683,
        LOCATION_LATITUDE_DEG: 53.4438295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW002100',
        LOCATION_NAME: 'Owlerton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4969272,
        LOCATION_LATITUDE_DEG: 53.4040856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000600',
        LOCATION_NAME: 'Owlpen',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2860087,
        LOCATION_LATITUDE_DEG: 51.6786853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000700',
        LOCATION_NAME: 'Owlsmoor',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'GU47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7752701,
        LOCATION_LATITUDE_DEG: 51.3462403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000800',
        LOCATION_NAME: 'Owlswick',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8560873,
        LOCATION_LATITUDE_DEG: 51.7477783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000900',
        LOCATION_NAME: 'Owlthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3757791,
        LOCATION_LATITUDE_DEG: 53.3334382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW002000',
        LOCATION_NAME: 'Owmby by Spital',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001000',
        LOCATION_NAME: 'Owmby-by-Spital',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4890452,
        LOCATION_LATITUDE_DEG: 53.3741247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001100',
        LOCATION_NAME: 'Ownham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3930618,
        LOCATION_LATITUDE_DEG: 51.4316545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001200',
        LOCATION_NAME: 'Owslebury',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2658502,
        LOCATION_LATITUDE_DEG: 51.0079095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001300',
        LOCATION_NAME: 'Owslebury Bottom',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2657284,
        LOCATION_LATITUDE_DEG: 51.0111104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001500',
        LOCATION_NAME: 'Owston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1676738,
        LOCATION_LATITUDE_DEG: 53.5941575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001400',
        LOCATION_NAME: 'Owston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8530418,
        LOCATION_LATITUDE_DEG: 52.6629685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001600',
        LOCATION_NAME: 'Owston Ferry',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7805748,
        LOCATION_LATITUDE_DEG: 53.4931443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001700',
        LOCATION_NAME: 'Owstwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0686177,
        LOCATION_LATITUDE_DEG: 53.7754639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001800',
        LOCATION_NAME: 'Owthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0030489,
        LOCATION_LATITUDE_DEG: 52.8927846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW001900',
        LOCATION_NAME: 'Owton Manor',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2317243,
        LOCATION_LATITUDE_DEG: 54.6582635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000100',
        LOCATION_NAME: 'Oxborough',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5744258,
        LOCATION_LATITUDE_DEG: 52.5831349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000300',
        LOCATION_NAME: 'Oxbridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7426818,
        LOCATION_LATITUDE_DEG: 50.7759108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000200',
        LOCATION_NAME: 'Oxbridge',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3279199,
        LOCATION_LATITUDE_DEG: 54.5615312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000400',
        LOCATION_NAME: 'Oxcombe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0338584,
        LOCATION_LATITUDE_DEG: 53.2752075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000500',
        LOCATION_NAME: 'Oxen Fell',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0262991,
        LOCATION_LATITUDE_DEG: 54.4069606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000600',
        LOCATION_NAME: 'Oxen Park',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0460362,
        LOCATION_LATITUDE_DEG: 54.2766442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000700',
        LOCATION_NAME: 'Oxenfoord Castle',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9829109,
        LOCATION_LATITUDE_DEG: 55.8792079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX990391',
        LOCATION_NAME: 'Oxenford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000800',
        LOCATION_NAME: 'Oxenhall',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4200853,
        LOCATION_LATITUDE_DEG: 51.9381178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX000900',
        LOCATION_NAME: 'Oxenholme',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7236348,
        LOCATION_LATITUDE_DEG: 54.3002497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001000',
        LOCATION_NAME: 'Oxenhope',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9520193,
        LOCATION_LATITUDE_DEG: 53.8114879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001100',
        LOCATION_NAME: 'Oxenton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.070301,
        LOCATION_LATITUDE_DEG: 51.9790126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001200',
        LOCATION_NAME: 'Oxenwood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5628009,
        LOCATION_LATITUDE_DEG: 51.329947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001300',
        LOCATION_NAME: 'Oxford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2561589,
        LOCATION_LATITUDE_DEG: 51.7515847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001400',
        LOCATION_NAME: 'Oxford Airport',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3083714,
        LOCATION_LATITUDE_DEG: 51.8313946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001500',
        LOCATION_NAME: 'Oxgangs',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2232864,
        LOCATION_LATITUDE_DEG: 55.9061078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001550',
        LOCATION_NAME: 'Oxhey',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3823331,
        LOCATION_LATITUDE_DEG: 51.6453478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001700',
        LOCATION_NAME: 'Oxhill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7062784,
        LOCATION_LATITUDE_DEG: 54.8673909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001600',
        LOCATION_NAME: 'Oxhill',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5377802,
        LOCATION_LATITUDE_DEG: 52.1067176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001800',
        LOCATION_NAME: 'Oxley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1296524,
        LOCATION_LATITUDE_DEG: 52.6168764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX990513',
        LOCATION_NAME: 'Oxley Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8075344,
        LOCATION_LATITUDE_DEG: 52.00116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX001900',
        LOCATION_NAME: 'Oxlode',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1586066,
        LOCATION_LATITUDE_DEG: 52.4286983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002000',
        LOCATION_NAME: 'Oxlynch',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2574358,
        LOCATION_LATITUDE_DEG: 51.7669917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002100',
        LOCATION_NAME: 'Oxnead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3070005,
        LOCATION_LATITUDE_DEG: 52.7680451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002200',
        LOCATION_NAME: 'Oxshott',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3552227,
        LOCATION_LATITUDE_DEG: 51.3321284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002300',
        LOCATION_NAME: 'Oxspring',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5906479,
        LOCATION_LATITUDE_DEG: 53.5135593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002400',
        LOCATION_NAME: 'Oxted',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.004732,
        LOCATION_LATITUDE_DEG: 51.2566175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002600',
        LOCATION_NAME: 'Oxton',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8020284,
        LOCATION_LATITUDE_DEG: 55.7722878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002700',
        LOCATION_NAME: 'Oxton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2319099,
        LOCATION_LATITUDE_DEG: 53.8810866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002500',
        LOCATION_NAME: 'Oxton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.061204,
        LOCATION_LATITUDE_DEG: 53.0550081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002800',
        LOCATION_NAME: 'Oxtown',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1559497,
        LOCATION_LATITUDE_DEG: 54.6328214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX002900',
        LOCATION_NAME: 'Oxwich',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1634767,
        LOCATION_LATITUDE_DEG: 51.5566927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OX003000',
        LOCATION_NAME: 'Oxwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8360749,
        LOCATION_LATITUDE_DEG: 52.7881529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OY000100',
        LOCATION_NAME: 'Oyne',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5437507,
        LOCATION_LATITUDE_DEG: 57.3214408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OZ000100',
        LOCATION_NAME: 'Ozleworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3045189,
        LOCATION_LATITUDE_DEG: 51.6391805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000100',
        LOCATION_NAME: 'Packington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4649854,
        LOCATION_LATITUDE_DEG: 52.7287808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000200',
        LOCATION_NAME: 'Packmoor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1974584,
        LOCATION_LATITUDE_DEG: 53.0856261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000300',
        LOCATION_NAME: 'Padanaram',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9354282,
        LOCATION_LATITUDE_DEG: 56.6513788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000400',
        LOCATION_NAME: 'Padbury',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9511436,
        LOCATION_LATITUDE_DEG: 51.9704964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000500',
        LOCATION_NAME: 'Paddington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5635063,
        LOCATION_LATITUDE_DEG: 53.3987545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023600',
        LOCATION_NAME: 'Paddington',
        COUNTY_NAME: 'London',
        POSTCODE: 'W2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1747459,
        LOCATION_LATITUDE_DEG: 51.5169178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000600',
        LOCATION_NAME: 'Paddlelake',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6446747,
        LOCATION_LATITUDE_DEG: 50.3442797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000700',
        LOCATION_NAME: 'Paddlesworth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.137452,
        LOCATION_LATITUDE_DEG: 51.1153864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000900',
        LOCATION_NAME: 'Paddock',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.804703,
        LOCATION_LATITUDE_DEG: 53.6418663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001000',
        LOCATION_NAME: 'Paddock Wood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3870868,
        LOCATION_LATITUDE_DEG: 51.1788073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001100',
        LOCATION_NAME: 'Padeswood',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.084113,
        LOCATION_LATITUDE_DEG: 53.1533426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001200',
        LOCATION_NAME: 'Padfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9554266,
        LOCATION_LATITUDE_DEG: 53.4622566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001300',
        LOCATION_NAME: 'Padgate',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5708798,
        LOCATION_LATITUDE_DEG: 53.4068552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001400',
        LOCATION_NAME: 'Padiham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3135265,
        LOCATION_LATITUDE_DEG: 53.801793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001500',
        LOCATION_NAME: 'Padmore',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7752326,
        LOCATION_LATITUDE_DEG: 52.5909801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001600',
        LOCATION_NAME: 'Padog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7277328,
        LOCATION_LATITUDE_DEG: 53.0469391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001700',
        LOCATION_NAME: 'Padstow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9387912,
        LOCATION_LATITUDE_DEG: 50.5381109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001800',
        LOCATION_NAME: 'Padstow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5379497,
        LOCATION_LATITUDE_DEG: 54.5289753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA001900',
        LOCATION_NAME: 'Padworth',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1120184,
        LOCATION_LATITUDE_DEG: 51.3922453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002000',
        LOCATION_NAME: 'Padworth Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1058038,
        LOCATION_LATITUDE_DEG: 51.3777464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002100',
        LOCATION_NAME: 'Paganhill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2306595,
        LOCATION_LATITUDE_DEG: 51.7511941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002200',
        LOCATION_NAME: 'Page Bank',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6366471,
        LOCATION_LATITUDE_DEG: 54.7137755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002300',
        LOCATION_NAME: 'Pagham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7503926,
        LOCATION_LATITUDE_DEG: 50.7696834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002400',
        LOCATION_NAME: 'Paglesham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7995936,
        LOCATION_LATITUDE_DEG: 51.5917145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002500',
        LOCATION_NAME: 'Paglesham Churchend',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7826607,
        LOCATION_LATITUDE_DEG: 51.6024435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002600',
        LOCATION_NAME: 'Paglesham Eastend',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8067837,
        LOCATION_LATITUDE_DEG: 51.5954375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002700',
        LOCATION_NAME: 'Paiblesgarry',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4803736,
        LOCATION_LATITUDE_DEG: 57.5891178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002800',
        LOCATION_NAME: 'Paignton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5664701,
        LOCATION_LATITUDE_DEG: 50.4370801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA002900',
        LOCATION_NAME: 'Pailton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3055452,
        LOCATION_LATITUDE_DEG: 52.4325451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003000',
        LOCATION_NAME: 'Painesend',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6822549,
        LOCATION_LATITUDE_DEG: 51.7740778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003200',
        LOCATION_NAME: 'Painsbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6958738,
        LOCATION_LATITUDE_DEG: 52.7860983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003300',
        LOCATION_NAME: 'Painscastle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2165533,
        LOCATION_LATITUDE_DEG: 52.1087385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA991139',
        LOCATION_NAME: 'Painsthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.758333,
        LOCATION_LATITUDE_DEG: 54.014167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003400',
        LOCATION_NAME: 'Painswick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1925176,
        LOCATION_LATITUDE_DEG: 51.786296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003500',
        LOCATION_NAME: 'Painswick Beacon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1867289,
        LOCATION_LATITUDE_DEG: 51.8065015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003600',
        LOCATION_NAME: 'Painters Forstal',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8589289,
        LOCATION_LATITUDE_DEG: 51.2943089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003700',
        LOCATION_NAME: 'Painters Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7411314,
        LOCATION_LATITUDE_DEG: 52.9638203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003800',
        LOCATION_NAME: 'Paisley',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4223055,
        LOCATION_LATITUDE_DEG: 55.8454144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003900',
        LOCATION_NAME: 'Pakefield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.73076,
        LOCATION_LATITUDE_DEG: 52.4516082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004000',
        LOCATION_NAME: 'Pakenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8227233,
        LOCATION_LATITUDE_DEG: 52.2701069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004300',
        LOCATION_NAME: 'Palacefields',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6891119,
        LOCATION_LATITUDE_DEG: 53.3201536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004500',
        LOCATION_NAME: 'Palestine',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6204986,
        LOCATION_LATITUDE_DEG: 51.1690307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004600',
        LOCATION_NAME: 'Paley Street',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7480202,
        LOCATION_LATITUDE_DEG: 51.4781511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004700',
        LOCATION_NAME: 'Palgrave',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1082847,
        LOCATION_LATITUDE_DEG: 52.3633086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005100',
        LOCATION_NAME: 'Pallethill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8095705,
        LOCATION_LATITUDE_DEG: 54.6657782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005200',
        LOCATION_NAME: 'Pallington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3004346,
        LOCATION_LATITUDE_DEG: 50.7198969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005300',
        LOCATION_NAME: 'Pallington Heath',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2890408,
        LOCATION_LATITUDE_DEG: 50.7216975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005400',
        LOCATION_NAME: 'Palmers Flats',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5348294,
        LOCATION_LATITUDE_DEG: 51.8846088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023700',
        LOCATION_NAME: 'Palmers Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'N13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1132906,
        LOCATION_LATITUDE_DEG: 51.6191367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005500',
        LOCATION_NAME: 'Palmerstown',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2401087,
        LOCATION_LATITUDE_DEG: 51.4110721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022900',
        LOCATION_NAME: 'Palmersville',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5532798,
        LOCATION_LATITUDE_DEG: 55.0255611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA990843',
        LOCATION_NAME: 'Palmstead',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005800',
        LOCATION_NAME: 'Palnackie',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8395364,
        LOCATION_LATITUDE_DEG: 54.8920169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005900',
        LOCATION_NAME: 'Palnure',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4182868,
        LOCATION_LATITUDE_DEG: 54.9432287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006000',
        LOCATION_NAME: 'Palterton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2879304,
        LOCATION_LATITUDE_DEG: 53.2083178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006100',
        LOCATION_NAME: 'Pamber End',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1219298,
        LOCATION_LATITUDE_DEG: 51.3212396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006200',
        LOCATION_NAME: 'Pamber Green',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1263319,
        LOCATION_LATITUDE_DEG: 51.333539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006300',
        LOCATION_NAME: 'Pamber Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1242988,
        LOCATION_LATITUDE_DEG: 51.3528407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006400',
        LOCATION_NAME: 'Pamington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0878234,
        LOCATION_LATITUDE_DEG: 51.9966157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006500',
        LOCATION_NAME: 'Pamphill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0099204,
        LOCATION_LATITUDE_DEG: 50.8026024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006600',
        LOCATION_NAME: 'Pampisford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1865154,
        LOCATION_LATITUDE_DEG: 52.1102945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006700',
        LOCATION_NAME: 'Panborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7575655,
        LOCATION_LATITUDE_DEG: 51.2024466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006800',
        LOCATION_NAME: 'Panbride',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6971074,
        LOCATION_LATITUDE_DEG: 56.511964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA006900',
        LOCATION_NAME: 'Pancrasweek',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4173576,
        LOCATION_LATITUDE_DEG: 50.8241268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007100',
        LOCATION_NAME: 'Pandy',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1967243,
        LOCATION_LATITUDE_DEG: 52.914415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007000',
        LOCATION_NAME: 'Pandy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9679308,
        LOCATION_LATITUDE_DEG: 51.8924181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007200',
        LOCATION_NAME: 'Pandy Tudur',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7088185,
        LOCATION_LATITUDE_DEG: 53.1627489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007300',
        LOCATION_NAME: 'Panfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5264655,
        LOCATION_LATITUDE_DEG: 51.898275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007400',
        LOCATION_NAME: 'Pangbourne',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.085937,
        LOCATION_LATITUDE_DEG: 51.4826568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007500',
        LOCATION_NAME: 'Panmure',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7490914,
        LOCATION_LATITUDE_DEG: 56.5331633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007600',
        LOCATION_NAME: 'Pannal',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5346828,
        LOCATION_LATITUDE_DEG: 53.9607018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007700',
        LOCATION_NAME: 'Pannanich',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9817984,
        LOCATION_LATITUDE_DEG: 57.0501194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007800',
        LOCATION_NAME: 'Panshanger',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1312333,
        LOCATION_LATITUDE_DEG: 51.8010702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA007900',
        LOCATION_NAME: 'Panshanger Aerodrome',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1574895,
        LOCATION_LATITUDE_DEG: 51.7935707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008000',
        LOCATION_NAME: 'Pant',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.35878,
        LOCATION_LATITUDE_DEG: 51.7701125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008100',
        LOCATION_NAME: 'Pant',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0753793,
        LOCATION_LATITUDE_DEG: 52.7922027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008200',
        LOCATION_NAME: 'Pant Glas',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0874307,
        LOCATION_LATITUDE_DEG: 52.8816782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008300',
        LOCATION_NAME: 'Pant Llwyd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9224351,
        LOCATION_LATITUDE_DEG: 52.9598258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022700',
        LOCATION_NAME: 'Pant y Dwr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022800',
        LOCATION_NAME: 'Pant y Waun',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3197612,
        LOCATION_LATITUDE_DEG: 51.7696488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008600',
        LOCATION_NAME: 'Pantasaph',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2630352,
        LOCATION_LATITUDE_DEG: 53.2735536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008700',
        LOCATION_NAME: 'Panteg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1490844,
        LOCATION_LATITUDE_DEG: 51.6944089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008800',
        LOCATION_NAME: 'Panteg Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3615305,
        LOCATION_LATITUDE_DEG: 52.0754313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008900',
        LOCATION_NAME: 'Pantersbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5940579,
        LOCATION_LATITUDE_DEG: 50.4808983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009000',
        LOCATION_NAME: 'Pantglas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5939011,
        LOCATION_LATITUDE_DEG: 52.935321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA991002',
        LOCATION_NAME: 'Pantmawr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009100',
        LOCATION_NAME: 'Pantmawr',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2258086,
        LOCATION_LATITUDE_DEG: 51.5338871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009200',
        LOCATION_NAME: 'Panton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.239292,
        LOCATION_LATITUDE_DEG: 53.2958161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009300',
        LOCATION_NAME: 'Pantperthog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8488386,
        LOCATION_LATITUDE_DEG: 52.6210951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009400',
        LOCATION_NAME: 'Pantybwlch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4395158,
        LOCATION_LATITUDE_DEG: 52.0066416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008400',
        LOCATION_NAME: 'Pant-y-Dwr',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4921527,
        LOCATION_LATITUDE_DEG: 52.361165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009500',
        LOCATION_NAME: 'Pantyffynnon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.987819,
        LOCATION_LATITUDE_DEG: 51.7728118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009600',
        LOCATION_NAME: 'Pantygasseg',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0875866,
        LOCATION_LATITUDE_DEG: 51.6934945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009700',
        LOCATION_NAME: 'Pantygelli',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0131342,
        LOCATION_LATITUDE_DEG: 51.8557449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009800',
        LOCATION_NAME: 'Pantygog',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5797442,
        LOCATION_LATITUDE_DEG: 51.6068971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA009900',
        LOCATION_NAME: 'Pantygraigwen',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3543141,
        LOCATION_LATITUDE_DEG: 51.606693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010100',
        LOCATION_NAME: 'Pantymwyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2065279,
        LOCATION_LATITUDE_DEG: 53.1730413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010200',
        LOCATION_NAME: 'Pantypwdyn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.128889,
        LOCATION_LATITUDE_DEG: 51.7280051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010300',
        LOCATION_NAME: 'Pantyrawel',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5442353,
        LOCATION_LATITUDE_DEG: 51.5772877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010400',
        LOCATION_NAME: 'Pantyresk',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1522939,
        LOCATION_LATITUDE_DEG: 51.6517991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA008500',
        LOCATION_NAME: 'Pant-y-Waun',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3396027,
        LOCATION_LATITUDE_DEG: 51.7505037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010500',
        LOCATION_NAME: 'Panxworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4710722,
        LOCATION_LATITUDE_DEG: 52.6658286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010600',
        LOCATION_NAME: 'Papa Stour',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7154325,
        LOCATION_LATITUDE_DEG: 60.3229331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010700',
        LOCATION_NAME: 'Papa Westray',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8927557,
        LOCATION_LATITUDE_DEG: 59.351647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010800',
        LOCATION_NAME: 'Papcastle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.381164,
        LOCATION_LATITUDE_DEG: 54.6691851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA010900',
        LOCATION_NAME: 'Papdale',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9475964,
        LOCATION_LATITUDE_DEG: 58.9817122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011000',
        LOCATION_NAME: 'Papigoe',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.058248,
        LOCATION_LATITUDE_DEG: 58.4499586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011100',
        LOCATION_NAME: 'Papplewick',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1813615,
        LOCATION_LATITUDE_DEG: 53.0538098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011200',
        LOCATION_NAME: 'Papworth Everard',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1181238,
        LOCATION_LATITUDE_DEG: 52.2513142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011300',
        LOCATION_NAME: 'Papworth Saint Agnes',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.139083,
        LOCATION_LATITUDE_DEG: 52.2602524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011400',
        LOCATION_NAME: 'Par',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.70969,
        LOCATION_LATITUDE_DEG: 50.3500861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011500',
        LOCATION_NAME: 'Paradwys',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3622701,
        LOCATION_LATITUDE_DEG: 53.2145575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011600',
        LOCATION_NAME: 'Parbold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7634327,
        LOCATION_LATITUDE_DEG: 53.5931786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011700',
        LOCATION_NAME: 'Parbrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6164866,
        LOCATION_LATITUDE_DEG: 51.1260419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011800',
        LOCATION_NAME: 'Parc',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6708289,
        LOCATION_LATITUDE_DEG: 52.8902242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA011900',
        LOCATION_NAME: 'Parc Seymour',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.85433,
        LOCATION_LATITUDE_DEG: 51.6171876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012000',
        LOCATION_NAME: 'Parcllyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5593789,
        LOCATION_LATITUDE_DEG: 52.1328525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012100',
        LOCATION_NAME: 'Pardshaw',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4051647,
        LOCATION_LATITUDE_DEG: 54.6123885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012300',
        LOCATION_NAME: 'Parham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5041702,
        LOCATION_LATITUDE_DEG: 50.9162947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012200',
        LOCATION_NAME: 'Parham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3786977,
        LOCATION_LATITUDE_DEG: 52.1945855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012600',
        LOCATION_NAME: 'Park',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9705074,
        LOCATION_LATITUDE_DEG: 54.8911417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012700',
        LOCATION_NAME: 'Park',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7574652,
        LOCATION_LATITUDE_DEG: 58.2860841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012400',
        LOCATION_NAME: 'Park',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5085123,
        LOCATION_LATITUDE_DEG: 58.3490825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022500',
        LOCATION_NAME: 'Park',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4577413,
        LOCATION_LATITUDE_DEG: 53.3861953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012800',
        LOCATION_NAME: 'Park Bottom',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2682303,
        LOCATION_LATITUDE_DEG: 50.2373798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA012900',
        LOCATION_NAME: 'Park Broom',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8682534,
        LOCATION_LATITUDE_DEG: 54.920906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013000',
        LOCATION_NAME: 'Park End',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2039683,
        LOCATION_LATITUDE_DEG: 55.0748125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013100',
        LOCATION_NAME: 'Park Gate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0803958,
        LOCATION_LATITUDE_DEG: 54.3552535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013200',
        LOCATION_NAME: 'Park Gate',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2637109,
        LOCATION_LATITUDE_DEG: 50.8736948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013300',
        LOCATION_NAME: 'Park Hall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0364121,
        LOCATION_LATITUDE_DEG: 52.8756071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013400',
        LOCATION_NAME: 'Park Hall Camp',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0268449,
        LOCATION_LATITUDE_DEG: 52.8732087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013500',
        LOCATION_NAME: 'Park Lane',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3113347,
        LOCATION_LATITUDE_DEG: 53.5423692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023800',
        LOCATION_NAME: 'Park Royal',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2726428,
        LOCATION_LATITUDE_DEG: 51.5289588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013600',
        LOCATION_NAME: 'Park Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3319761,
        LOCATION_LATITUDE_DEG: 51.7152661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013650',
        LOCATION_NAME: 'Park Street',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1896061,
        LOCATION_LATITUDE_DEG: 51.9886597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013700',
        LOCATION_NAME: 'Park Village',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1051192,
        LOCATION_LATITUDE_DEG: 52.5995754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013800',
        LOCATION_NAME: 'Parkend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5554472,
        LOCATION_LATITUDE_DEG: 51.7676968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA013900',
        LOCATION_NAME: 'Parkers Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4843541,
        LOCATION_LATITUDE_DEG: 50.3500836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014000',
        LOCATION_NAME: 'Parkeston',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2540602,
        LOCATION_LATITUDE_DEG: 51.9420625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014100',
        LOCATION_NAME: 'Parkfields',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1102725,
        LOCATION_LATITUDE_DEG: 52.5642726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014600',
        LOCATION_NAME: 'Parkgate',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0989026,
        LOCATION_LATITUDE_DEG: 54.716626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014400',
        LOCATION_NAME: 'Parkgate',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5351851,
        LOCATION_LATITUDE_DEG: 55.1791412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014300',
        LOCATION_NAME: 'Parkgate',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0851825,
        LOCATION_LATITUDE_DEG: 53.2958566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014500',
        LOCATION_NAME: 'Parkgate',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2175864,
        LOCATION_LATITUDE_DEG: 52.4044525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014200',
        LOCATION_NAME: 'Parkgate',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3440826,
        LOCATION_LATITUDE_DEG: 53.4542438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014700',
        LOCATION_NAME: 'Parkham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.292411,
        LOCATION_LATITUDE_DEG: 50.9688411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014800',
        LOCATION_NAME: 'Parkhead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1962212,
        LOCATION_LATITUDE_DEG: 55.8488141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023000',
        LOCATION_NAME: 'Parkhead',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5224624,
        LOCATION_LATITUDE_DEG: 53.3483731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA014900',
        LOCATION_NAME: 'Parkhouse',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9537721,
        LOCATION_LATITUDE_DEG: 54.92981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015000',
        LOCATION_NAME: 'Parkhurst Forest',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3279913,
        LOCATION_LATITUDE_DEG: 50.7170882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015100',
        LOCATION_NAME: 'Parklands',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2011533,
        LOCATION_LATITUDE_DEG: 52.9845164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015200',
        LOCATION_NAME: 'Parkmill',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.100163,
        LOCATION_LATITUDE_DEG: 51.5822974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015500',
        LOCATION_NAME: 'Parks',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2928715,
        LOCATION_LATITUDE_DEG: 57.0714668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015600',
        LOCATION_NAME: 'Parkside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4912032,
        LOCATION_LATITUDE_DEG: 54.5261809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015700',
        LOCATION_NAME: 'Parkstone',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9421057,
        LOCATION_LATITUDE_DEG: 50.7248923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015800',
        LOCATION_NAME: 'Parkway',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4089082,
        LOCATION_LATITUDE_DEG: 52.0192184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015900',
        LOCATION_NAME: 'Parkwood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5988198,
        LOCATION_LATITUDE_DEG: 51.3552703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023100',
        LOCATION_NAME: 'Parkwood Springs',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4790379,
        LOCATION_LATITUDE_DEG: 53.3944618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016000',
        LOCATION_NAME: 'Parnwell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2166812,
        LOCATION_LATITUDE_DEG: 52.5878494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016100',
        LOCATION_NAME: 'Parr',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7147111,
        LOCATION_LATITUDE_DEG: 53.4521625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016200',
        LOCATION_NAME: 'Parracombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9028387,
        LOCATION_LATITUDE_DEG: 51.1873561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016300',
        LOCATION_NAME: 'Parrett Works',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7679751,
        LOCATION_LATITUDE_DEG: 50.9758283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016400',
        LOCATION_NAME: 'Parrog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8465357,
        LOCATION_LATITUDE_DEG: 52.0181453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016500',
        LOCATION_NAME: 'Parrowfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6997281,
        LOCATION_LATITUDE_DEG: 52.3000535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016600',
        LOCATION_NAME: 'Parslows Hillock',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.802917,
        LOCATION_LATITUDE_DEG: 51.7094708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023200',
        LOCATION_NAME: 'Parson Cross',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1860835,
        LOCATION_LATITUDE_DEG: 51.4706421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016700',
        LOCATION_NAME: 'Parson Drove',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0267295,
        LOCATION_LATITUDE_DEG: 52.6564553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016800',
        LOCATION_NAME: 'Parsonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3308999,
        LOCATION_LATITUDE_DEG: 54.7373949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023500',
        LOCATION_NAME: 'Parsons Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1859108,
        LOCATION_LATITUDE_DEG: 51.4706395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023900',
        LOCATION_NAME: 'Partick',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3128684,
        LOCATION_LATITUDE_DEG: 55.8710263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017000',
        LOCATION_NAME: 'Partington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4273217,
        LOCATION_LATITUDE_DEG: 53.4182607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017100',
        LOCATION_NAME: 'Partney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1116157,
        LOCATION_LATITUDE_DEG: 53.1929998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017200',
        LOCATION_NAME: 'Parton',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0412225,
        LOCATION_LATITUDE_DEG: 55.0095293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017300',
        LOCATION_NAME: 'Parton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.578233,
        LOCATION_LATITUDE_DEG: 54.5699855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017400',
        LOCATION_NAME: 'Partridge Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3061899,
        LOCATION_LATITUDE_DEG: 50.9584979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017600',
        LOCATION_NAME: 'Parwich',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7213921,
        LOCATION_LATITUDE_DEG: 53.087118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017900',
        LOCATION_NAME: 'Passenham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8628653,
        LOCATION_LATITUDE_DEG: 52.0478008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018000',
        LOCATION_NAME: 'Passfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8206864,
        LOCATION_LATITUDE_DEG: 51.0937145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018100',
        LOCATION_NAME: 'Paston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2461121,
        LOCATION_LATITUDE_DEG: 52.6039529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018200',
        LOCATION_NAME: 'Paston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4507697,
        LOCATION_LATITUDE_DEG: 52.8576547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018300',
        LOCATION_NAME: 'Patchacott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1663175,
        LOCATION_LATITUDE_DEG: 50.7617243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018400',
        LOCATION_NAME: 'Patcham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1440141,
        LOCATION_LATITUDE_DEG: 50.8632827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018500',
        LOCATION_NAME: 'Patchetts Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3452189,
        LOCATION_LATITUDE_DEG: 51.657457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018600',
        LOCATION_NAME: 'Patching',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4551103,
        LOCATION_LATITUDE_DEG: 50.8462841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023300',
        LOCATION_NAME: 'Patchway',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5884882,
        LOCATION_LATITUDE_DEG: 51.5352268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018700',
        LOCATION_NAME: 'Pategill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7429776,
        LOCATION_LATITUDE_DEG: 54.6609828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018800',
        LOCATION_NAME: 'Pateley Bridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7562041,
        LOCATION_LATITUDE_DEG: 54.0865141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA018900',
        LOCATION_NAME: 'Pathfinder Village',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.641779,
        LOCATION_LATITUDE_DEG: 50.728808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019000',
        LOCATION_NAME: 'Pathhead',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9659119,
        LOCATION_LATITUDE_DEG: 55.8673995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019100',
        LOCATION_NAME: 'Pathlow',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.737496,
        LOCATION_LATITUDE_DEG: 52.2245357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019200',
        LOCATION_NAME: 'Patmarsh',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3793881,
        LOCATION_LATITUDE_DEG: 52.5829747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019300',
        LOCATION_NAME: 'Patna',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4974002,
        LOCATION_LATITUDE_DEG: 55.364372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019400',
        LOCATION_NAME: 'Patney',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8964876,
        LOCATION_LATITUDE_DEG: 51.3241524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA990255',
        LOCATION_NAME: 'Patrick',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6943315,
        LOCATION_LATITUDE_DEG: 54.204753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019500',
        LOCATION_NAME: 'Patrick Brompton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6616915,
        LOCATION_LATITUDE_DEG: 54.3113296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019700',
        LOCATION_NAME: 'Patrington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.010081,
        LOCATION_LATITUDE_DEG: 53.6835471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019800',
        LOCATION_NAME: 'Patrington Haven',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0232671,
        LOCATION_LATITUDE_DEG: 53.6710525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019900',
        LOCATION_NAME: 'Patrixbourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1264141,
        LOCATION_LATITUDE_DEG: 51.2542005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020000',
        LOCATION_NAME: 'Patshull Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2583851,
        LOCATION_LATITUDE_DEG: 52.5860787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020100',
        LOCATION_NAME: 'Patterdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9305759,
        LOCATION_LATITUDE_DEG: 54.5338702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020200',
        LOCATION_NAME: 'Patterdown',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1324047,
        LOCATION_LATITUDE_DEG: 51.4437621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020300',
        LOCATION_NAME: 'Patterton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.333107,
        LOCATION_LATITUDE_DEG: 55.7910129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020400',
        LOCATION_NAME: 'Pattiesmuir',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4507864,
        LOCATION_LATITUDE_DEG: 56.0372275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020500',
        LOCATION_NAME: 'Pattingham',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2614892,
        LOCATION_LATITUDE_DEG: 52.5892726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020600',
        LOCATION_NAME: 'Pattishall',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0182897,
        LOCATION_LATITUDE_DEG: 52.1820173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020700',
        LOCATION_NAME: 'Pattiswick',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6389749,
        LOCATION_LATITUDE_DEG: 51.8840669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020800',
        LOCATION_NAME: 'Patton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6842352,
        LOCATION_LATITUDE_DEG: 54.3681534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA020900',
        LOCATION_NAME: 'Paul',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5439459,
        LOCATION_LATITUDE_DEG: 50.0888717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021000',
        LOCATION_NAME: 'Paulerspury',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9540554,
        LOCATION_LATITUDE_DEG: 52.1023097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021100',
        LOCATION_NAME: 'Paull',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2322152,
        LOCATION_LATITUDE_DEG: 53.7228594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021200',
        LOCATION_NAME: 'Paulsgrove',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0919362,
        LOCATION_LATITUDE_DEG: 50.84929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021400',
        LOCATION_NAME: 'Paulton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5035089,
        LOCATION_LATITUDE_DEG: 51.3068569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021500',
        LOCATION_NAME: 'Pauperhaugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8413868,
        LOCATION_LATITUDE_DEG: 55.2898302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021600',
        LOCATION_NAME: 'Pave Lane',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3585848,
        LOCATION_LATITUDE_DEG: 52.7484877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021700',
        LOCATION_NAME: 'Pavenham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.549311,
        LOCATION_LATITUDE_DEG: 52.189214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021800',
        LOCATION_NAME: 'Pawlett',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9991068,
        LOCATION_LATITUDE_DEG: 51.1792475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021900',
        LOCATION_NAME: 'Paxford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7308623,
        LOCATION_LATITUDE_DEG: 52.0380177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022000',
        LOCATION_NAME: 'Paxton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1038083,
        LOCATION_LATITUDE_DEG: 55.7703851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022100',
        LOCATION_NAME: 'Payhembury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2944876,
        LOCATION_LATITUDE_DEG: 50.8058177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022200',
        LOCATION_NAME: 'Paynters Lane End',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2626265,
        LOCATION_LATITUDE_DEG: 50.244879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022300',
        LOCATION_NAME: 'Paythorne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2596851,
        LOCATION_LATITUDE_DEG: 53.962203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA022400',
        LOCATION_NAME: 'Payton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2609279,
        LOCATION_LATITUDE_DEG: 50.9778336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000100',
        LOCATION_NAME: 'Peacehaven',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.001684,
        LOCATION_LATITUDE_DEG: 50.7942726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000200',
        LOCATION_NAME: 'Peak Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8613027,
        LOCATION_LATITUDE_DEG: 53.2883334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000300',
        LOCATION_NAME: 'Peak Forest',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.829816,
        LOCATION_LATITUDE_DEG: 53.3101378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000400',
        LOCATION_NAME: 'Peakirk',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.271791,
        LOCATION_LATITUDE_DEG: 52.6449557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000600',
        LOCATION_NAME: 'Pean Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0284876,
        LOCATION_LATITUDE_DEG: 51.3226067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000800',
        LOCATION_NAME: 'Pear Tree',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7661793,
        LOCATION_LATITUDE_DEG: 50.5107932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000700',
        LOCATION_NAME: 'Pear Tree',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4741087,
        LOCATION_LATITUDE_DEG: 52.9020974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000900',
        LOCATION_NAME: 'Pearsie',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0366211,
        LOCATION_LATITUDE_DEG: 56.721885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001000',
        LOCATION_NAME: 'Peartree Bridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7265427,
        LOCATION_LATITUDE_DEG: 52.0274058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001100',
        LOCATION_NAME: 'Pease Pottage',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.200894,
        LOCATION_LATITUDE_DEG: 51.0829043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039600',
        LOCATION_NAME: 'Peasedown St John',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001200',
        LOCATION_NAME: 'Peasedown St. John',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4254501,
        LOCATION_LATITUDE_DEG: 51.315251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001300',
        LOCATION_NAME: 'Peasemore',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3406589,
        LOCATION_LATITUDE_DEG: 51.4930614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001400',
        LOCATION_NAME: 'Peasenhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.450888,
        LOCATION_LATITUDE_DEG: 52.2703947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001500',
        LOCATION_NAME: 'Peaslake',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4405306,
        LOCATION_LATITUDE_DEG: 51.1940207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001700',
        LOCATION_NAME: 'Peasmarsh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9487916,
        LOCATION_LATITUDE_DEG: 50.9044213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001600',
        LOCATION_NAME: 'Peasmarsh',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5832573,
        LOCATION_LATITUDE_DEG: 51.2068173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001800',
        LOCATION_NAME: 'Peasmarsh',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6918084,
        LOCATION_LATITUDE_DEG: 50.9715859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE001900',
        LOCATION_NAME: 'Peat Inn',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8828444,
        LOCATION_LATITUDE_DEG: 56.2780385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002000',
        LOCATION_NAME: 'Peatling Magna',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1251007,
        LOCATION_LATITUDE_DEG: 52.5278512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002100',
        LOCATION_NAME: 'Peatling Parva',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1331284,
        LOCATION_LATITUDE_DEG: 52.4982482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002200',
        LOCATION_NAME: 'Peatmoor',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.839276,
        LOCATION_LATITUDE_DEG: 51.5745766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002300',
        LOCATION_NAME: 'Peaton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6898,
        LOCATION_LATITUDE_DEG: 52.4594651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002400',
        LOCATION_NAME: 'Peatswood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4607151,
        LOCATION_LATITUDE_DEG: 52.8987089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040900',
        LOCATION_NAME: 'Pebble Mill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.912391,
        LOCATION_LATITUDE_DEG: 52.4525068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002500',
        LOCATION_NAME: 'Pebmarsh',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6968527,
        LOCATION_LATITUDE_DEG: 51.96828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002600',
        LOCATION_NAME: 'Pebworth',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8111774,
        LOCATION_LATITUDE_DEG: 52.1194221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002700',
        LOCATION_NAME: 'Pecket Well',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.003732,
        LOCATION_LATITUDE_DEG: 53.7625881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002800',
        LOCATION_NAME: 'Peckfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3503516,
        LOCATION_LATITUDE_DEG: 53.7789772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE002900',
        LOCATION_NAME: 'Peckforton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6890293,
        LOCATION_LATITUDE_DEG: 53.1031335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040600',
        LOCATION_NAME: 'Peckham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0566508,
        LOCATION_LATITUDE_DEG: 51.4818606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003000',
        LOCATION_NAME: 'Peckleton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3036994,
        LOCATION_LATITUDE_DEG: 52.6054605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003100',
        LOCATION_NAME: 'Pecknall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9713084,
        LOCATION_LATITUDE_DEG: 52.7190959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003300',
        LOCATION_NAME: 'Pedlars Rest',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7556851,
        LOCATION_LATITUDE_DEG: 52.4543691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003400',
        LOCATION_NAME: 'Pedlinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0570871,
        LOCATION_LATITUDE_DEG: 51.0768828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990074',
        LOCATION_NAME: 'Pedmore',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1297099,
        LOCATION_LATITUDE_DEG: 52.4361853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003500',
        LOCATION_NAME: 'Pednor',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6455553,
        LOCATION_LATITUDE_DEG: 51.7172674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003600',
        LOCATION_NAME: 'Pedwell',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8209527,
        LOCATION_LATITUDE_DEG: 51.1226449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003700',
        LOCATION_NAME: 'Peebles',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1909634,
        LOCATION_LATITUDE_DEG: 55.6512809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003800',
        LOCATION_NAME: 'Peel',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6941677,
        LOCATION_LATITUDE_DEG: 54.220375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE041600',
        LOCATION_NAME: 'Peel Glen',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3652548,
        LOCATION_LATITUDE_DEG: 55.9169607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040500',
        LOCATION_NAME: 'Peel Hall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2480827,
        LOCATION_LATITUDE_DEG: 53.3819999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003900',
        LOCATION_NAME: 'Peene',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1234944,
        LOCATION_LATITUDE_DEG: 51.0976875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004000',
        LOCATION_NAME: 'Pegsdon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3712952,
        LOCATION_LATITUDE_DEG: 51.9598926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004100',
        LOCATION_NAME: 'Pegswood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6452734,
        LOCATION_LATITUDE_DEG: 55.1807211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004200',
        LOCATION_NAME: 'Pegwell',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3902235,
        LOCATION_LATITUDE_DEG: 51.3287069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004300',
        LOCATION_NAME: 'Peinachorran',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.109906,
        LOCATION_LATITUDE_DEG: 57.3202452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004400',
        LOCATION_NAME: 'Peiness',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2989399,
        LOCATION_LATITUDE_DEG: 57.4180899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004500',
        LOCATION_NAME: 'Peinlich',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3192287,
        LOCATION_LATITUDE_DEG: 57.5421024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004600',
        LOCATION_NAME: 'Peinmore',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2986389,
        LOCATION_LATITUDE_DEG: 57.4576932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004700',
        LOCATION_NAME: 'Pelaw',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5403383,
        LOCATION_LATITUDE_DEG: 54.9533985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004800',
        LOCATION_NAME: 'Pelaw Grange',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5729356,
        LOCATION_LATITUDE_DEG: 54.8761895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE004900',
        LOCATION_NAME: 'Pelcomb',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0147638,
        LOCATION_LATITUDE_DEG: 51.8223309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005000',
        LOCATION_NAME: 'Pelcomb Bridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9982809,
        LOCATION_LATITUDE_DEG: 51.8141265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005100',
        LOCATION_NAME: 'Pelcomb Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0194827,
        LOCATION_LATITUDE_DEG: 51.8208335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005200',
        LOCATION_NAME: 'Peldon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8881446,
        LOCATION_LATITUDE_DEG: 51.8145555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005300',
        LOCATION_NAME: 'Pelhams Lands',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1854645,
        LOCATION_LATITUDE_DEG: 53.0510952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005400',
        LOCATION_NAME: 'Pelistry',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.285533,
        LOCATION_LATITUDE_DEG: 49.9249586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005500',
        LOCATION_NAME: 'Pell Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.346622,
        LOCATION_LATITUDE_DEG: 51.0711955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005600',
        LOCATION_NAME: 'Pell Hill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3440239,
        LOCATION_LATITUDE_DEG: 51.0663995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005700',
        LOCATION_NAME: 'Pell Wall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4839042,
        LOCATION_LATITUDE_DEG: 52.8943103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005800',
        LOCATION_NAME: 'Pellon',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8974312,
        LOCATION_LATITUDE_DEG: 53.7306779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE005900',
        LOCATION_NAME: 'Pelsall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9706103,
        LOCATION_LATITUDE_DEG: 52.6294768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006000',
        LOCATION_NAME: 'Pelton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6027059,
        LOCATION_LATITUDE_DEG: 54.8729921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006100',
        LOCATION_NAME: 'Pelton Fell',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5964213,
        LOCATION_LATITUDE_DEG: 54.8608832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006200',
        LOCATION_NAME: 'Pelutho',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.368238,
        LOCATION_LATITUDE_DEG: 54.8284093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006300',
        LOCATION_NAME: 'Pelynt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5266522,
        LOCATION_LATITUDE_DEG: 50.3676853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006400',
        LOCATION_NAME: 'Pemberton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6786872,
        LOCATION_LATITUDE_DEG: 53.537172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006500',
        LOCATION_NAME: 'Pembrey',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2749005,
        LOCATION_LATITUDE_DEG: 51.6871103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006600',
        LOCATION_NAME: 'Pembridge',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8917053,
        LOCATION_LATITUDE_DEG: 52.2178445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006700',
        LOCATION_NAME: 'Pembroke',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9072835,
        LOCATION_LATITUDE_DEG: 51.6733144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006800',
        LOCATION_NAME: 'Pembroke Dock',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9392796,
        LOCATION_LATITUDE_DEG: 51.691317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006900',
        LOCATION_NAME: 'Pembury',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3239031,
        LOCATION_LATITUDE_DEG: 51.1423027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE006950',
        LOCATION_NAME: 'Pen Elm',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1525306,
        LOCATION_LATITUDE_DEG: 51.0395257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007000',
        LOCATION_NAME: 'Pen Selwood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3527686,
        LOCATION_LATITUDE_DEG: 51.0793181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040000',
        LOCATION_NAME: 'Pen y Bont',
        COUNTY_NAME: 'Carmarthenshire',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040100',
        LOCATION_NAME: 'Pen y Cae',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007100',
        LOCATION_NAME: 'Pen y Cwm',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1267747,
        LOCATION_LATITUDE_DEG: 51.865189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040200',
        LOCATION_NAME: 'Pen y Fai',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040300',
        LOCATION_NAME: 'Pen y Lan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007200',
        LOCATION_NAME: 'Pen y Rhedyn',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9086664,
        LOCATION_LATITUDE_DEG: 51.6896048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007700',
        LOCATION_NAME: 'Penallt',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6926194,
        LOCATION_LATITUDE_DEG: 51.7919041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007800',
        LOCATION_NAME: 'Penally',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7212691,
        LOCATION_LATITUDE_DEG: 51.658616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007900',
        LOCATION_NAME: 'Penarth',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1743028,
        LOCATION_LATITUDE_DEG: 51.4357703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008000',
        LOCATION_NAME: 'Penberth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6284354,
        LOCATION_LATITUDE_DEG: 50.0472886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008100',
        LOCATION_NAME: 'Penbontrhydyfothau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3955018,
        LOCATION_LATITUDE_DEG: 52.1654538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008200',
        LOCATION_NAME: 'Pencader',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2645206,
        LOCATION_LATITUDE_DEG: 52.0005414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008300',
        LOCATION_NAME: 'Pencaenewydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.372884,
        LOCATION_LATITUDE_DEG: 52.9435363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008400',
        LOCATION_NAME: 'Pencaer',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0453023,
        LOCATION_LATITUDE_DEG: 52.0190535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008500',
        LOCATION_NAME: 'Pencaitland',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.896444,
        LOCATION_LATITUDE_DEG: 55.9078063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008600',
        LOCATION_NAME: 'Pencarnisiog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4685752,
        LOCATION_LATITUDE_DEG: 53.234163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008700',
        LOCATION_NAME: 'Pencarreg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1382849,
        LOCATION_LATITUDE_DEG: 52.0846497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008800',
        LOCATION_NAME: 'Pencarrow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6747632,
        LOCATION_LATITUDE_DEG: 50.6104101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE008900',
        LOCATION_NAME: 'Penceiliogi',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.123291,
        LOCATION_LATITUDE_DEG: 51.6841127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009000',
        LOCATION_NAME: 'Pencelli',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3171533,
        LOCATION_LATITUDE_DEG: 51.9149256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009100',
        LOCATION_NAME: 'Penclawdd',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1020687,
        LOCATION_LATITUDE_DEG: 51.6420085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009200',
        LOCATION_NAME: 'Pencoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5005631,
        LOCATION_LATITUDE_DEG: 51.5212875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009300',
        LOCATION_NAME: 'Pencombe',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5862225,
        LOCATION_LATITUDE_DEG: 52.170942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009400',
        LOCATION_NAME: 'Pencoyd',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7041652,
        LOCATION_LATITUDE_DEG: 51.9325531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009500',
        LOCATION_NAME: 'Pencoys',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2415322,
        LOCATION_LATITUDE_DEG: 50.1955811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009600',
        LOCATION_NAME: 'Pencraig',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.635164,
        LOCATION_LATITUDE_DEG: 51.8856117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009700',
        LOCATION_NAME: 'Pencraigwen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3420609,
        LOCATION_LATITUDE_DEG: 53.3653734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009800',
        LOCATION_NAME: 'Pendarves',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2988321,
        LOCATION_LATITUDE_DEG: 50.1921761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE009900',
        LOCATION_NAME: 'Pendarves Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3056311,
        LOCATION_LATITUDE_DEG: 50.1901742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010000',
        LOCATION_NAME: 'Pendas Fields',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4279637,
        LOCATION_LATITUDE_DEG: 53.810484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010100',
        LOCATION_NAME: 'Pendean',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7378794,
        LOCATION_LATITUDE_DEG: 50.9697983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010200',
        LOCATION_NAME: 'Pendeen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6660962,
        LOCATION_LATITUDE_DEG: 50.1503806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010300',
        LOCATION_NAME: 'Pendeford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1516315,
        LOCATION_LATITUDE_DEG: 52.6293025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010400',
        LOCATION_NAME: 'Penderleath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5056489,
        LOCATION_LATITUDE_DEG: 50.1842768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010500',
        LOCATION_NAME: 'Penderyn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5230118,
        LOCATION_LATITUDE_DEG: 51.7668132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010600',
        LOCATION_NAME: 'Pendine',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5557264,
        LOCATION_LATITUDE_DEG: 51.7436185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010700',
        LOCATION_NAME: 'Pendlebury',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3161944,
        LOCATION_LATITUDE_DEG: 53.5099675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010800',
        LOCATION_NAME: 'Pendleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3724361,
        LOCATION_LATITUDE_DEG: 53.8521969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE010900',
        LOCATION_NAME: 'Pendock',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3138147,
        LOCATION_LATITUDE_DEG: 51.9926157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011000',
        LOCATION_NAME: 'Pendoggett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7881261,
        LOCATION_LATITUDE_DEG: 50.5816081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011100',
        LOCATION_NAME: 'Pendomer',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.678109,
        LOCATION_LATITUDE_DEG: 50.8922143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011200',
        LOCATION_NAME: 'Pendoylan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3538091,
        LOCATION_LATITUDE_DEG: 51.4798794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011300',
        LOCATION_NAME: 'Pendrift',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6811618,
        LOCATION_LATITUDE_DEG: 50.5362002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011400',
        LOCATION_NAME: 'Penegoes',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8067844,
        LOCATION_LATITUDE_DEG: 52.5922953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011500',
        LOCATION_NAME: 'Penelewey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0487074,
        LOCATION_LATITUDE_DEG: 50.2043779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990238',
        LOCATION_NAME: 'Penenden Heath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5332645,
        LOCATION_LATITUDE_DEG: 51.2840922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990369',
        LOCATION_NAME: 'Penffordd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011600',
        LOCATION_NAME: 'Penffordd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7934958,
        LOCATION_LATITUDE_DEG: 51.8661335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011700',
        LOCATION_NAME: 'Pengam',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2153951,
        LOCATION_LATITUDE_DEG: 51.6662978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040700',
        LOCATION_NAME: 'Penge',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0543252,
        LOCATION_LATITUDE_DEG: 51.4173549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011800',
        LOCATION_NAME: 'Pengegon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2882393,
        LOCATION_LATITUDE_DEG: 50.2119826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE011900',
        LOCATION_NAME: 'Pengelly',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.306138,
        LOCATION_LATITUDE_DEG: 50.5030999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012000',
        LOCATION_NAME: 'Penglais',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0416587,
        LOCATION_LATITUDE_DEG: 52.4163806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012100',
        LOCATION_NAME: 'Pengorffwysfa',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3069801,
        LOCATION_LATITUDE_DEG: 53.4024735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012200',
        LOCATION_NAME: 'Pengover',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.423475,
        LOCATION_LATITUDE_DEG: 50.457905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012300',
        LOCATION_NAME: 'Pengover Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4236997,
        LOCATION_LATITUDE_DEG: 50.4600953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012400',
        LOCATION_NAME: 'Pengroeslon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2837734,
        LOCATION_LATITUDE_DEG: 53.0519212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012500',
        LOCATION_NAME: 'Penhale',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9472614,
        LOCATION_LATITUDE_DEG: 50.3776894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012600',
        LOCATION_NAME: 'Penhallow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1349212,
        LOCATION_LATITUDE_DEG: 50.3165847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012700',
        LOCATION_NAME: 'Penhalurick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.217495,
        LOCATION_LATITUDE_DEG: 50.1980764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012800',
        LOCATION_NAME: 'Penhalvean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2078211,
        LOCATION_LATITUDE_DEG: 50.1942775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE012900',
        LOCATION_NAME: 'Penhalveor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2089338,
        LOCATION_LATITUDE_DEG: 50.19018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013000',
        LOCATION_NAME: 'Penhow',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8335947,
        LOCATION_LATITUDE_DEG: 51.6144861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013100',
        LOCATION_NAME: 'Penhurst',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4102421,
        LOCATION_LATITUDE_DEG: 50.9221856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013200',
        LOCATION_NAME: 'Penicuik',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2225981,
        LOCATION_LATITUDE_DEG: 55.8308062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013300',
        LOCATION_NAME: 'Peniel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2737972,
        LOCATION_LATITUDE_DEG: 51.8937264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013400',
        LOCATION_NAME: 'Peniel',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4514032,
        LOCATION_LATITUDE_DEG: 53.1553394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013500',
        LOCATION_NAME: 'Peniel Green',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8834633,
        LOCATION_LATITUDE_DEG: 51.6604056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013600',
        LOCATION_NAME: 'Penifiler',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1819782,
        LOCATION_LATITUDE_DEG: 57.3953839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE041800',
        LOCATION_NAME: 'Penilee',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3547094,
        LOCATION_LATITUDE_DEG: 55.8462417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013700',
        LOCATION_NAME: 'Peninerine',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3992741,
        LOCATION_LATITUDE_DEG: 57.2910921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013800',
        LOCATION_NAME: 'Peninver',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5452709,
        LOCATION_LATITUDE_DEG: 55.4668903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE013900',
        LOCATION_NAME: 'Penisarwaun',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1768181,
        LOCATION_LATITUDE_DEG: 53.154564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014000',
        LOCATION_NAME: 'Penistone',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6293197,
        LOCATION_LATITUDE_DEG: 53.5254616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014100',
        LOCATION_NAME: 'Penketh',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6357611,
        LOCATION_LATITUDE_DEG: 53.3863543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014200',
        LOCATION_NAME: 'Penkhull',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.199383,
        LOCATION_LATITUDE_DEG: 53.0012142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014300',
        LOCATION_NAME: 'Penkridge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.11445,
        LOCATION_LATITUDE_DEG: 52.7235849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014600',
        LOCATION_NAME: 'Penlan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.098691,
        LOCATION_LATITUDE_DEG: 51.6371045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014500',
        LOCATION_NAME: 'Penlan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.959576,
        LOCATION_LATITUDE_DEG: 51.6504993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014400',
        LOCATION_NAME: 'Penlan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3816039,
        LOCATION_LATITUDE_DEG: 51.9510288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014700',
        LOCATION_NAME: 'Penlee',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1962254,
        LOCATION_LATITUDE_DEG: 50.3217826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014800',
        LOCATION_NAME: 'Penley',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8642346,
        LOCATION_LATITUDE_DEG: 52.9514182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE014900',
        LOCATION_NAME: 'Penllergaer',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0062402,
        LOCATION_LATITUDE_DEG: 51.6710078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015000',
        LOCATION_NAME: 'Penllyn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4782553,
        LOCATION_LATITUDE_DEG: 51.4738799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015100',
        LOCATION_NAME: 'Penmachno',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8054411,
        LOCATION_LATITUDE_DEG: 53.0384389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015200',
        LOCATION_NAME: 'Penmaen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1182254,
        LOCATION_LATITUDE_DEG: 51.5777007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015300',
        LOCATION_NAME: 'Penmaen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1834761,
        LOCATION_LATITUDE_DEG: 51.6722981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015400',
        LOCATION_NAME: 'Penmaenmawr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9233458,
        LOCATION_LATITUDE_DEG: 53.2678584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015500',
        LOCATION_NAME: 'Penmaenpool',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9395631,
        LOCATION_LATITUDE_DEG: 52.7457127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015600',
        LOCATION_NAME: 'Penmark',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3563192,
        LOCATION_LATITUDE_DEG: 51.4100725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015700',
        LOCATION_NAME: 'Penmark',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2491933,
        LOCATION_LATITUDE_DEG: 51.7898079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015800',
        LOCATION_NAME: 'Penmayne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8963281,
        LOCATION_LATITUDE_DEG: 50.5473083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE015900',
        LOCATION_NAME: 'Penmon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL58',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0543053,
        LOCATION_LATITUDE_DEG: 53.3056673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016000',
        LOCATION_NAME: 'Penmorfa',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.161591,
        LOCATION_LATITUDE_DEG: 52.942929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016100',
        LOCATION_NAME: 'Penmount',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0454079,
        LOCATION_LATITUDE_DEG: 50.2845806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016200',
        LOCATION_NAME: 'Penmyarth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1782907,
        LOCATION_LATITUDE_DEG: 51.8718136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016300',
        LOCATION_NAME: 'Penmynydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2352431,
        LOCATION_LATITUDE_DEG: 53.2462592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016400',
        LOCATION_NAME: 'Penn',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1535997,
        LOCATION_LATITUDE_DEG: 52.5583712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016500',
        LOCATION_NAME: 'Penn',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6755312,
        LOCATION_LATITUDE_DEG: 51.6307657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016600',
        LOCATION_NAME: 'Penn Fields',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1495006,
        LOCATION_LATITUDE_DEG: 52.5633215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016700',
        LOCATION_NAME: 'Penn Street',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6663342,
        LOCATION_LATITUDE_DEG: 51.6526671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016800',
        LOCATION_NAME: 'Pennal',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9198381,
        LOCATION_LATITUDE_DEG: 52.5853906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE016900',
        LOCATION_NAME: 'Pennan',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2621607,
        LOCATION_LATITUDE_DEG: 57.6766745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017000',
        LOCATION_NAME: 'Pennant',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6532389,
        LOCATION_LATITUDE_DEG: 52.5659896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017100',
        LOCATION_NAME: 'Pennar',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9504727,
        LOCATION_LATITUDE_DEG: 51.6796125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017200',
        LOCATION_NAME: 'Pennard',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0697702,
        LOCATION_LATITUDE_DEG: 51.5787004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017300',
        LOCATION_NAME: 'Pennerley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9614201,
        LOCATION_LATITUDE_DEG: 52.5830785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017400',
        LOCATION_NAME: 'Penninghame',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5276294,
        LOCATION_LATITUDE_DEG: 54.9933356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017500',
        LOCATION_NAME: 'Pennington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1292095,
        LOCATION_LATITUDE_DEG: 54.1872363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017600',
        LOCATION_NAME: 'Pennington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5571176,
        LOCATION_LATITUDE_DEG: 50.750795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017700',
        LOCATION_NAME: 'Pennorth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2908963,
        LOCATION_LATITUDE_DEG: 51.9252251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017800',
        LOCATION_NAME: 'Pennsylvania',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3671315,
        LOCATION_LATITUDE_DEG: 51.4571647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017900',
        LOCATION_NAME: 'Penny Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0571493,
        LOCATION_LATITUDE_DEG: 54.2355403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE017950',
        LOCATION_NAME: 'Pennybryn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018000',
        LOCATION_NAME: 'Pennycross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1462195,
        LOCATION_LATITUDE_DEG: 50.3990881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018100',
        LOCATION_NAME: 'Pennyghael',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0221808,
        LOCATION_LATITUDE_DEG: 56.3621269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018200',
        LOCATION_NAME: 'Pennygillam',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.366638,
        LOCATION_LATITUDE_DEG: 50.6269125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018300',
        LOCATION_NAME: 'Pennyland',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7411499,
        LOCATION_LATITUDE_DEG: 52.0606091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018400',
        LOCATION_NAME: 'Pennymoor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6142847,
        LOCATION_LATITUDE_DEG: 50.8889306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018500',
        LOCATION_NAME: 'Pennyrush',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8640338,
        LOCATION_LATITUDE_DEG: 52.8277082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE041500',
        LOCATION_NAME: 'Pennywell',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2522926,
        LOCATION_LATITUDE_DEG: 55.9716614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018600',
        LOCATION_NAME: 'Penoyre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4280828,
        LOCATION_LATITUDE_DEG: 51.9692324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018700',
        LOCATION_NAME: 'Penparc',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1342818,
        LOCATION_LATITUDE_DEG: 51.9371388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018750',
        LOCATION_NAME: 'Penparc',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6117722,
        LOCATION_LATITUDE_DEG: 52.102608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018800',
        LOCATION_NAME: 'Penparcau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0685428,
        LOCATION_LATITUDE_DEG: 52.3987732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990526',
        LOCATION_NAME: 'Penpergwm',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE018900',
        LOCATION_NAME: 'Penperlleni',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9785588,
        LOCATION_LATITUDE_DEG: 51.7351982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019000',
        LOCATION_NAME: 'Penpillick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7004869,
        LOCATION_LATITUDE_DEG: 50.3771897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990160',
        LOCATION_NAME: 'Penpoint',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019100',
        LOCATION_NAME: 'Penpol',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0638753,
        LOCATION_LATITUDE_DEG: 50.2089807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019200',
        LOCATION_NAME: 'Penponds',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3048237,
        LOCATION_LATITUDE_DEG: 50.2062752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019300',
        LOCATION_NAME: 'Penpont',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5088548,
        LOCATION_LATITUDE_DEG: 50.6023101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019400',
        LOCATION_NAME: 'Penpont',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8133832,
        LOCATION_LATITUDE_DEG: 55.2324517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019500',
        LOCATION_NAME: 'Penpont',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4977165,
        LOCATION_LATITUDE_DEG: 51.9473247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019600',
        LOCATION_NAME: 'Penquit',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9030067,
        LOCATION_LATITUDE_DEG: 50.3709848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019700',
        LOCATION_NAME: 'Penrallt',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4208861,
        LOCATION_LATITUDE_DEG: 52.8898264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019800',
        LOCATION_NAME: 'Penrherber',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4923707,
        LOCATION_LATITUDE_DEG: 52.0228476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE019900',
        LOCATION_NAME: 'Penrhiwceiber',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3610898,
        LOCATION_LATITUDE_DEG: 51.6699964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020000',
        LOCATION_NAME: 'Penrhiwllan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3757052,
        LOCATION_LATITUDE_DEG: 52.0510167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020100',
        LOCATION_NAME: 'Penrhiwtyn',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8143633,
        LOCATION_LATITUDE_DEG: 51.6479048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020400',
        LOCATION_NAME: 'Penrhos',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.457348,
        LOCATION_LATITUDE_DEG: 52.8807231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020300',
        LOCATION_NAME: 'Penrhos',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1311598,
        LOCATION_LATITUDE_DEG: 52.7395001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020200',
        LOCATION_NAME: 'Penrhos',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8462843,
        LOCATION_LATITUDE_DEG: 51.8018062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020500',
        LOCATION_NAME: 'Penrhos Feilw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.462993,
        LOCATION_LATITUDE_DEG: 52.8727915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020600',
        LOCATION_NAME: 'Penrhosgarnedd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1636037,
        LOCATION_LATITUDE_DEG: 53.2088543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020700',
        LOCATION_NAME: 'Penrhyd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3624179,
        LOCATION_LATITUDE_DEG: 53.4020724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020800',
        LOCATION_NAME: 'Penrhyn Bay',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7715112,
        LOCATION_LATITUDE_DEG: 53.3171625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE020900',
        LOCATION_NAME: 'Penrhyn Park',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.095193,
        LOCATION_LATITUDE_DEG: 53.229553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021000',
        LOCATION_NAME: 'Penrhyncoch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9963987,
        LOCATION_LATITUDE_DEG: 52.438376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021100',
        LOCATION_NAME: 'Penrhyndeudraeth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0650759,
        LOCATION_LATITUDE_DEG: 52.9295306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021200',
        LOCATION_NAME: 'Penrhynside',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7799541,
        LOCATION_LATITUDE_DEG: 53.3183584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021300',
        LOCATION_NAME: 'Penrhys',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4421087,
        LOCATION_LATITUDE_DEG: 51.6417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021400',
        LOCATION_NAME: 'Penrith',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7535,
        LOCATION_LATITUDE_DEG: 54.6665803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021500',
        LOCATION_NAME: 'Penrose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2957344,
        LOCATION_LATITUDE_DEG: 50.0832712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021600',
        LOCATION_NAME: 'Penrose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9953506,
        LOCATION_LATITUDE_DEG: 50.4977052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021700',
        LOCATION_NAME: 'Penruddock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8850872,
        LOCATION_LATITUDE_DEG: 54.6401823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021800',
        LOCATION_NAME: 'Penryn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1046141,
        LOCATION_LATITUDE_DEG: 50.1698774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE021900',
        LOCATION_NAME: 'Pensarn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3010344,
        LOCATION_LATITUDE_DEG: 51.851826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022000',
        LOCATION_NAME: 'Pensarn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5734439,
        LOCATION_LATITUDE_DEG: 53.2943521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990250',
        LOCATION_NAME: 'Pensax',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4066982,
        LOCATION_LATITUDE_DEG: 52.3197053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022100',
        LOCATION_NAME: 'Pensby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1012519,
        LOCATION_LATITUDE_DEG: 53.3453532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022200',
        LOCATION_NAME: 'Pensford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5469983,
        LOCATION_LATITUDE_DEG: 51.3709607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022300',
        LOCATION_NAME: 'Pensham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.085667,
        LOCATION_LATITUDE_DEG: 52.0955257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022400',
        LOCATION_NAME: 'Penshaw',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4858667,
        LOCATION_LATITUDE_DEG: 54.87889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022500',
        LOCATION_NAME: 'Penshurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1831667,
        LOCATION_LATITUDE_DEG: 51.1727094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022600',
        LOCATION_NAME: 'Pensilva',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.409327,
        LOCATION_LATITUDE_DEG: 50.502799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022700',
        LOCATION_NAME: 'Pensnett',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1304797,
        LOCATION_LATITUDE_DEG: 52.4975663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022800',
        LOCATION_NAME: 'Pensthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9023412,
        LOCATION_LATITUDE_DEG: 52.8255547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE022900',
        LOCATION_NAME: 'Penstrowed',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3667891,
        LOCATION_LATITUDE_DEG: 52.5083836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023000',
        LOCATION_NAME: 'Penstruthal',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2070213,
        LOCATION_LATITUDE_DEG: 50.2061757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023100',
        LOCATION_NAME: 'Pentervin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9889464,
        LOCATION_LATITUDE_DEG: 52.6104817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023200',
        LOCATION_NAME: 'Pentewan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7849797,
        LOCATION_LATITUDE_DEG: 50.2911798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023300',
        LOCATION_NAME: 'Pentir',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1346329,
        LOCATION_LATITUDE_DEG: 53.1798483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023400',
        LOCATION_NAME: 'Pentire',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1132579,
        LOCATION_LATITUDE_DEG: 50.4104994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023500',
        LOCATION_NAME: 'Pentlepoir',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7263861,
        LOCATION_LATITUDE_DEG: 51.7209195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023600',
        LOCATION_NAME: 'Pentlow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6448571,
        LOCATION_LATITUDE_DEG: 52.0715873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023700',
        LOCATION_NAME: 'Pentney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5618227,
        LOCATION_LATITUDE_DEG: 52.6942487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023800',
        LOCATION_NAME: 'Penton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8516514,
        LOCATION_LATITUDE_DEG: 55.0914274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE023900',
        LOCATION_NAME: 'Penton Corner',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5217559,
        LOCATION_LATITUDE_DEG: 51.2130315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024000',
        LOCATION_NAME: 'Penton Grafton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5244468,
        LOCATION_LATITUDE_DEG: 51.2256326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024100',
        LOCATION_NAME: 'Penton Harroway',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5267489,
        LOCATION_LATITUDE_DEG: 51.2148324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024200',
        LOCATION_NAME: 'Penton Mewsey',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5267056,
        LOCATION_LATITUDE_DEG: 51.2246346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024300',
        LOCATION_NAME: 'Pentonvale',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8285911,
        LOCATION_LATITUDE_DEG: 50.3934938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024400',
        LOCATION_NAME: 'Pentraeth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2146213,
        LOCATION_LATITUDE_DEG: 53.2817659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024500',
        LOCATION_NAME: 'Pentre',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4868467,
        LOCATION_LATITUDE_DEG: 51.6524012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024600',
        LOCATION_NAME: 'Pentre',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0623122,
        LOCATION_LATITUDE_DEG: 52.9594239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024900',
        LOCATION_NAME: 'Pentre',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0153974,
        LOCATION_LATITUDE_DEG: 52.3833613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024800',
        LOCATION_NAME: 'Pentre',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0137164,
        LOCATION_LATITUDE_DEG: 53.2016384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE024700',
        LOCATION_NAME: 'Pentre',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9398389,
        LOCATION_LATITUDE_DEG: 52.7532992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025000',
        LOCATION_NAME: 'Pentre Bach',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5916568,
        LOCATION_LATITUDE_DEG: 51.9820176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025100',
        LOCATION_NAME: 'Pentre Berw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2896134,
        LOCATION_LATITUDE_DEG: 53.2237633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039800',
        LOCATION_NAME: 'Pentre Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025200',
        LOCATION_NAME: 'Pentre Broughton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0385429,
        LOCATION_LATITUDE_DEG: 53.0715309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025300',
        LOCATION_NAME: 'Pentre Castell',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.113139,
        LOCATION_LATITUDE_DEG: 53.113747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025400',
        LOCATION_NAME: 'Pentre Celyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2687533,
        LOCATION_LATITUDE_DEG: 53.0713309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025500',
        LOCATION_NAME: 'Pentre Clawdd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0430132,
        LOCATION_LATITUDE_DEG: 52.8813124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025600',
        LOCATION_NAME: 'Pentre Coch',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.263165,
        LOCATION_LATITUDE_DEG: 53.0905315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039900',
        LOCATION_NAME: 'Pentre Cwrt',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025700',
        LOCATION_NAME: 'Pentre Du',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8230234,
        LOCATION_LATITUDE_DEG: 53.0934407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025800',
        LOCATION_NAME: 'Pentre Gwynfryn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.083297,
        LOCATION_LATITUDE_DEG: 52.8227199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE025900',
        LOCATION_NAME: 'Pentre Halkyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.195351,
        LOCATION_LATITUDE_DEG: 53.2408521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026000',
        LOCATION_NAME: 'Pentre Llifior',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2612788,
        LOCATION_LATITUDE_DEG: 52.5727834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026100',
        LOCATION_NAME: 'Pentre Maelor',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9369236,
        LOCATION_LATITUDE_DEG: 53.0354236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026200',
        LOCATION_NAME: 'Pentre Meyrick',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4861327,
        LOCATION_LATITUDE_DEG: 51.4707856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026300',
        LOCATION_NAME: 'Pentre Pant',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0582482,
        LOCATION_LATITUDE_DEG: 52.8783095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026400',
        LOCATION_NAME: 'Pentre R Bryn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3448012,
        LOCATION_LATITUDE_DEG: 52.1741533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026500',
        LOCATION_NAME: 'Pentre Uchaf',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4457536,
        LOCATION_LATITUDE_DEG: 52.9232278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026900',
        LOCATION_NAME: 'Pentrebach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.11608,
        LOCATION_LATITUDE_DEG: 52.1040529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026800',
        LOCATION_NAME: 'Pentrebach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3558602,
        LOCATION_LATITUDE_DEG: 51.7249039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027000',
        LOCATION_NAME: 'Pentrebeirdd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1946529,
        LOCATION_LATITUDE_DEG: 52.7162018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026600',
        LOCATION_NAME: 'Pentre-Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8844985,
        LOCATION_LATITUDE_DEG: 53.0516348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027100',
        LOCATION_NAME: 'Pentrecagal',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.422274,
        LOCATION_LATITUDE_DEG: 52.0357414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027200',
        LOCATION_NAME: 'Pentrechwyth',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9256369,
        LOCATION_LATITUDE_DEG: 51.6377056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027300',
        LOCATION_NAME: 'Pentrecoed',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9513886,
        LOCATION_LATITUDE_DEG: 52.9363135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026700',
        LOCATION_NAME: 'Pentre-Cwrt',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3499482,
        LOCATION_LATITUDE_DEG: 52.0216389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027400',
        LOCATION_NAME: 'Pentredwr',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1926471,
        LOCATION_LATITUDE_DEG: 53.0090303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027500',
        LOCATION_NAME: 'Pentrefelin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1921529,
        LOCATION_LATITUDE_DEG: 52.9341322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027600',
        LOCATION_NAME: 'Pentrefelin',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7926046,
        LOCATION_LATITUDE_DEG: 53.2547552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027700',
        LOCATION_NAME: 'Pentrefoelas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6818106,
        LOCATION_LATITUDE_DEG: 53.0485323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027800',
        LOCATION_NAME: 'Pentregat',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4052184,
        LOCATION_LATITUDE_DEG: 52.1411535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE027900',
        LOCATION_NAME: 'Pentrellwyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3121794,
        LOCATION_LATITUDE_DEG: 52.0530453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028000',
        LOCATION_NAME: 'Pentrepiod',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0596779,
        LOCATION_LATITUDE_DEG: 51.7109973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE026550',
        LOCATION_NAME: "Pentre'r Bryn",
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3467212,
        LOCATION_LATITUDE_DEG: 52.1725592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028100',
        LOCATION_NAME: 'Pentrich',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4177867,
        LOCATION_LATITUDE_DEG: 53.0682105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028200',
        LOCATION_NAME: 'Pentridge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9484634,
        LOCATION_LATITUDE_DEG: 50.9608133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028500',
        LOCATION_NAME: 'Pentwyn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1402899,
        LOCATION_LATITUDE_DEG: 51.5264851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028300',
        LOCATION_NAME: 'Pentwyn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1111667,
        LOCATION_LATITUDE_DEG: 51.5530866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028400',
        LOCATION_NAME: 'Pentwyn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0631828,
        LOCATION_LATITUDE_DEG: 51.7191039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028600',
        LOCATION_NAME: 'Pentwyn Crumlin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1465885,
        LOCATION_LATITUDE_DEG: 51.6960988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028700',
        LOCATION_NAME: 'Pentwynmawr',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1619921,
        LOCATION_LATITUDE_DEG: 51.6584931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028800',
        LOCATION_NAME: 'Pentyrch',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2966527,
        LOCATION_LATITUDE_DEG: 51.5303826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE028900',
        LOCATION_NAME: 'Penuel',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1176808,
        LOCATION_LATITUDE_DEG: 51.6172021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029000',
        LOCATION_NAME: 'Penuwch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0557423,
        LOCATION_LATITUDE_DEG: 52.2456619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029100',
        LOCATION_NAME: 'Penwartha',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1506242,
        LOCATION_LATITUDE_DEG: 50.3249857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029200',
        LOCATION_NAME: 'Penweathers',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0799095,
        LOCATION_LATITUDE_DEG: 50.2530817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029300',
        LOCATION_NAME: 'Penwithick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7792876,
        LOCATION_LATITUDE_DEG: 50.3731911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029400',
        LOCATION_NAME: 'Penwood',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3639014,
        LOCATION_LATITUDE_DEG: 51.3517428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029500',
        LOCATION_NAME: 'Penwortham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7339676,
        LOCATION_LATITUDE_DEG: 53.7491137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029600',
        LOCATION_NAME: 'Penwyllt',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6629015,
        LOCATION_LATITUDE_DEG: 51.8281196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029700',
        LOCATION_NAME: 'Penybanc',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0119241,
        LOCATION_LATITUDE_DEG: 51.8971297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029800',
        LOCATION_NAME: 'Penybonc',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3400565,
        LOCATION_LATITUDE_DEG: 53.4140763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990656',
        LOCATION_NAME: 'Penybont',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE029900',
        LOCATION_NAME: 'Penybont',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2957844,
        LOCATION_LATITUDE_DEG: 52.2673588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030000',
        LOCATION_NAME: 'Penybont',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1341926,
        LOCATION_LATITUDE_DEG: 51.7374052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007300',
        LOCATION_NAME: 'Pen-y-Bont',
        COUNTY_NAME: 'Carmarthenshire',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4623037,
        LOCATION_LATITUDE_DEG: 51.9157347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030100',
        LOCATION_NAME: 'Penybontfawr',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3534638,
        LOCATION_LATITUDE_DEG: 52.810306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030200',
        LOCATION_NAME: 'Penybryn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2481763,
        LOCATION_LATITUDE_DEG: 51.6561968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030400',
        LOCATION_NAME: 'Penycae',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7660476,
        LOCATION_LATITUDE_DEG: 51.5964984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030600',
        LOCATION_NAME: 'Penycae',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6797957,
        LOCATION_LATITUDE_DEG: 51.8105681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030300',
        LOCATION_NAME: 'Penycae',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0721461,
        LOCATION_LATITUDE_DEG: 52.999425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007400',
        LOCATION_NAME: 'Pen-y-Cae',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5930522,
        LOCATION_LATITUDE_DEG: 51.5269836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030500',
        LOCATION_NAME: 'Penycaemawr',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8510528,
        LOCATION_LATITUDE_DEG: 51.6504928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030700',
        LOCATION_NAME: 'Penyclawdd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7984053,
        LOCATION_LATITUDE_DEG: 51.7648321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030800',
        LOCATION_NAME: 'Penycoedcae',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3607174,
        LOCATION_LATITUDE_DEG: 51.5764296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007500',
        LOCATION_NAME: 'Pen-y-Fai',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5945006,
        LOCATION_LATITUDE_DEG: 51.5242839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE030900',
        LOCATION_NAME: 'Penyfan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7231608,
        LOCATION_LATITUDE_DEG: 51.763026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031050',
        LOCATION_NAME: 'Penyffordd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1710947,
        LOCATION_LATITUDE_DEG: 53.2279399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031000',
        LOCATION_NAME: 'Penyffordd',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0431407,
        LOCATION_LATITUDE_DEG: 53.1462375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031100',
        LOCATION_NAME: 'Penygarn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0339843,
        LOCATION_LATITUDE_DEG: 51.7053001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031200',
        LOCATION_NAME: 'Penygraig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4460777,
        LOCATION_LATITUDE_DEG: 51.6128917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990548',
        LOCATION_NAME: 'Penygroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6552635,
        LOCATION_LATITUDE_DEG: 52.846397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031300',
        LOCATION_NAME: 'Penygroes',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2822904,
        LOCATION_LATITUDE_DEG: 53.0546383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031400',
        LOCATION_NAME: 'Penygroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0495281,
        LOCATION_LATITUDE_DEG: 51.7999192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990363',
        LOCATION_NAME: 'Penylan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1515018,
        LOCATION_LATITUDE_DEG: 51.501726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031500',
        LOCATION_NAME: 'Penylan',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0678472,
        LOCATION_LATITUDE_DEG: 52.8486078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE007600',
        LOCATION_NAME: 'Pen-y-Lan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4416619,
        LOCATION_LATITUDE_DEG: 51.4797855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031600',
        LOCATION_NAME: 'Penymynydd',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0393307,
        LOCATION_LATITUDE_DEG: 53.1550364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031700',
        LOCATION_NAME: 'Penyranchor',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0850576,
        LOCATION_LATITUDE_DEG: 52.4066753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031900',
        LOCATION_NAME: 'Penyrheol',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.244914,
        LOCATION_LATITUDE_DEG: 51.5882908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE031800',
        LOCATION_NAME: 'Penyrheol',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0382783,
        LOCATION_LATITUDE_DEG: 51.6854966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032000',
        LOCATION_NAME: 'Penysarn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3143439,
        LOCATION_LATITUDE_DEG: 53.3881779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032100',
        LOCATION_NAME: 'Penywaun',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4869078,
        LOCATION_LATITUDE_DEG: 51.7302071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032200',
        LOCATION_NAME: 'Penzance',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5371124,
        LOCATION_LATITUDE_DEG: 50.1179719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032300',
        LOCATION_NAME: 'Peopleton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0916817,
        LOCATION_LATITUDE_DEG: 52.1524287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990939',
        LOCATION_NAME: 'Peover Superior',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032400',
        LOCATION_NAME: 'Peper Harow',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6596735,
        LOCATION_LATITUDE_DEG: 51.1859174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032500',
        LOCATION_NAME: 'Peplow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5395326,
        LOCATION_LATITUDE_DEG: 52.8188018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032600',
        LOCATION_NAME: 'Peppard Common',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9851141,
        LOCATION_LATITUDE_DEG: 51.5281586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032700',
        LOCATION_NAME: 'Pepper Arden',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.375833,
        LOCATION_LATITUDE_DEG: 54.4126384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032800',
        LOCATION_NAME: 'Peppercombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3087292,
        LOCATION_LATITUDE_DEG: 50.9879394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032900',
        LOCATION_NAME: 'Pepperstock',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4284475,
        LOCATION_LATITUDE_DEG: 51.8489802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033000',
        LOCATION_NAME: 'Perceton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6161123,
        LOCATION_LATITUDE_DEG: 55.6294974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033100',
        LOCATION_NAME: 'Percombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7575826,
        LOCATION_LATITUDE_DEG: 50.9552201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033200',
        LOCATION_NAME: 'Percy Main',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4662061,
        LOCATION_LATITUDE_DEG: 54.997098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033300',
        LOCATION_NAME: 'Perham Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.630198,
        LOCATION_LATITUDE_DEG: 51.2386407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033400',
        LOCATION_NAME: 'Perkins Beach',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9197376,
        LOCATION_LATITUDE_DEG: 52.6099873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033500',
        LOCATION_NAME: 'Perkins Village',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3784436,
        LOCATION_LATITUDE_DEG: 50.712108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033600',
        LOCATION_NAME: 'Perkinsville',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6013058,
        LOCATION_LATITUDE_DEG: 54.8758905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033700',
        LOCATION_NAME: 'Perlethorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.009535,
        LOCATION_LATITUDE_DEG: 53.1679135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990604',
        LOCATION_NAME: 'Perran Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033800',
        LOCATION_NAME: 'Perranarworthal',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1182234,
        LOCATION_LATITUDE_DEG: 50.2069757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE033900',
        LOCATION_NAME: 'Perrancoombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1596201,
        LOCATION_LATITUDE_DEG: 50.3317859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034000',
        LOCATION_NAME: 'Perranporth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1535727,
        LOCATION_LATITUDE_DEG: 50.3431873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034100',
        LOCATION_NAME: 'Perranuthnoe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4413534,
        LOCATION_LATITUDE_DEG: 50.1136728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034200',
        LOCATION_NAME: 'Perranwell Station',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1217176,
        LOCATION_LATITUDE_DEG: 50.2106785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034300',
        LOCATION_NAME: 'Perranzabuloe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1324081,
        LOCATION_LATITUDE_DEG: 50.3255863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034400',
        LOCATION_NAME: 'Perriswood',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1608907,
        LOCATION_LATITUDE_DEG: 51.5764009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034500',
        LOCATION_NAME: 'Perrotts Brook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9746896,
        LOCATION_LATITUDE_DEG: 51.7515886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034600',
        LOCATION_NAME: 'Perry',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3251757,
        LOCATION_LATITUDE_DEG: 52.289252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034700',
        LOCATION_NAME: 'Perry Barr',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8958548,
        LOCATION_LATITUDE_DEG: 52.5187661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE041100',
        LOCATION_NAME: 'Perry Common',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8611161,
        LOCATION_LATITUDE_DEG: 52.5325136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990468',
        LOCATION_NAME: 'Perry Crofts',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034800',
        LOCATION_NAME: 'Perry Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3370037,
        LOCATION_LATITUDE_DEG: 51.8570843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE034900',
        LOCATION_NAME: 'Perry Gutter',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8902426,
        LOCATION_LATITUDE_DEG: 52.440872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035000',
        LOCATION_NAME: 'Perry Street',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9432984,
        LOCATION_LATITUDE_DEG: 50.8423192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035100',
        LOCATION_NAME: 'Perrystone Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5302729,
        LOCATION_LATITUDE_DEG: 51.9604136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035200',
        LOCATION_NAME: 'Pershore',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0792173,
        LOCATION_LATITUDE_DEG: 52.1137292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035300',
        LOCATION_NAME: 'Persley',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1457868,
        LOCATION_LATITUDE_DEG: 57.1824266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035400',
        LOCATION_NAME: 'Pertenhall',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4128514,
        LOCATION_LATITUDE_DEG: 52.279025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035500',
        LOCATION_NAME: 'Perth',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.43322,
        LOCATION_LATITUDE_DEG: 56.3953563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035700',
        LOCATION_NAME: 'Perton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5874958,
        LOCATION_LATITUDE_DEG: 52.0610304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035600',
        LOCATION_NAME: 'Perton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2034991,
        LOCATION_LATITUDE_DEG: 52.5918769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035800',
        LOCATION_NAME: 'Peter Tavy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.097624,
        LOCATION_LATITUDE_DEG: 50.5783048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE035900',
        LOCATION_NAME: 'Peterborough',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2439005,
        LOCATION_LATITUDE_DEG: 52.57395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036000',
        LOCATION_NAME: 'Peterchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9541607,
        LOCATION_LATITUDE_DEG: 52.0415295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036100',
        LOCATION_NAME: 'Peterculter',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2618137,
        LOCATION_LATITUDE_DEG: 57.0962152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036200',
        LOCATION_NAME: 'Peterhead',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.781524,
        LOCATION_LATITUDE_DEG: 57.5060534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036300',
        LOCATION_NAME: 'Peterlee',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3545771,
        LOCATION_LATITUDE_DEG: 54.7575769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036400',
        LOCATION_NAME: 'Peters Green',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3421553,
        LOCATION_LATITUDE_DEG: 51.8583801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE040800',
        LOCATION_NAME: 'Peters Hill',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.935796,
        LOCATION_LATITUDE_DEG: 54.6037222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036500',
        LOCATION_NAME: 'Peters Marland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1625764,
        LOCATION_LATITUDE_DEG: 50.8997384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036600',
        LOCATION_NAME: 'Peters Port',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2162468,
        LOCATION_LATITUDE_DEG: 57.3950961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036700',
        LOCATION_NAME: 'Petersfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.938627,
        LOCATION_LATITUDE_DEG: 51.0063036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036800',
        LOCATION_NAME: 'Petersfinger',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7659799,
        LOCATION_LATITUDE_DEG: 51.0609193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE041700',
        LOCATION_NAME: 'Petershill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2319283,
        LOCATION_LATITUDE_DEG: 55.8796939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039700',
        LOCATION_NAME: 'Peterston super Ely',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037000',
        LOCATION_NAME: 'Peterstone',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7722238,
        LOCATION_LATITUDE_DEG: 52.9504715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037100',
        LOCATION_NAME: 'Peterstone Wentlooge',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0544876,
        LOCATION_LATITUDE_DEG: 51.5161816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE036900',
        LOCATION_NAME: 'Peterston-super-Ely',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3207898,
        LOCATION_LATITUDE_DEG: 51.4780797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037200',
        LOCATION_NAME: 'Peterstow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6294318,
        LOCATION_LATITUDE_DEG: 51.9163143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037500',
        LOCATION_NAME: 'Peterville',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1985206,
        LOCATION_LATITUDE_DEG: 50.3107842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037600',
        LOCATION_NAME: 'Petham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0475297,
        LOCATION_LATITUDE_DEG: 51.2224049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037700',
        LOCATION_NAME: 'Petherwin Gate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4074367,
        LOCATION_LATITUDE_DEG: 50.6648103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037800',
        LOCATION_NAME: 'Petrockstow',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1152947,
        LOCATION_LATITUDE_DEG: 50.8579611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE990447',
        LOCATION_NAME: 'Petsoe End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037900',
        LOCATION_NAME: 'Pett',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6648306,
        LOCATION_LATITUDE_DEG: 50.8942779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038000',
        LOCATION_NAME: 'Pett Bottom',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0946196,
        LOCATION_LATITUDE_DEG: 51.2267005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038100',
        LOCATION_NAME: 'Pett Level',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6710478,
        LOCATION_LATITUDE_DEG: 50.891572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038200',
        LOCATION_NAME: 'Pettaugh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1695453,
        LOCATION_LATITUDE_DEG: 52.1904914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038400',
        LOCATION_NAME: 'Pettinain',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.66231,
        LOCATION_LATITUDE_DEG: 55.6691954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038500',
        LOCATION_NAME: 'Pettistree',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3534416,
        LOCATION_LATITUDE_DEG: 52.1398867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038600',
        LOCATION_NAME: 'Petton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8351218,
        LOCATION_LATITUDE_DEG: 52.8364023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038700',
        LOCATION_NAME: 'Petts Wood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0763567,
        LOCATION_LATITUDE_DEG: 51.38983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038800',
        LOCATION_NAME: 'Petty France',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3952422,
        LOCATION_LATITUDE_DEG: 52.0594222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038900',
        LOCATION_NAME: 'Petty France',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3059211,
        LOCATION_LATITUDE_DEG: 51.5661768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039000',
        LOCATION_NAME: 'Petworth',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6077408,
        LOCATION_LATITUDE_DEG: 50.9870986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039100',
        LOCATION_NAME: 'Pevensey',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3640367,
        LOCATION_LATITUDE_DEG: 50.8191752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039200',
        LOCATION_NAME: 'Pevensey Bay',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3537395,
        LOCATION_LATITUDE_DEG: 50.8120704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039300',
        LOCATION_NAME: 'Peverell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1385221,
        LOCATION_LATITUDE_DEG: 50.3862855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039400',
        LOCATION_NAME: 'Pewsey',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7661123,
        LOCATION_LATITUDE_DEG: 51.3371481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE039500',
        LOCATION_NAME: 'Pewsham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0970936,
        LOCATION_LATITUDE_DEG: 51.4449657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000100',
        LOCATION_NAME: 'Pharis',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3489206,
        LOCATION_LATITUDE_DEG: 55.0666577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000200',
        LOCATION_NAME: 'Phepson',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0848553,
        LOCATION_LATITUDE_DEG: 52.2369354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000300',
        LOCATION_NAME: 'Philadelphia',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4779445,
        LOCATION_LATITUDE_DEG: 54.8610879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000500',
        LOCATION_NAME: 'Phillack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4119298,
        LOCATION_LATITUDE_DEG: 50.1948802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000600',
        LOCATION_NAME: 'Philleigh',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9840619,
        LOCATION_LATITUDE_DEG: 50.2165748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH990068',
        LOCATION_NAME: 'Philliphaugh',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8835724,
        LOCATION_LATITUDE_DEG: 55.5407272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000700',
        LOCATION_NAME: 'Phillipstown',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2378045,
        LOCATION_LATITUDE_DEG: 51.722304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000800',
        LOCATION_NAME: 'Philpstoun',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5264678,
        LOCATION_LATITUDE_DEG: 55.9768208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000900',
        LOCATION_NAME: 'Phocle Green',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5424512,
        LOCATION_LATITUDE_DEG: 51.9335172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000100',
        LOCATION_NAME: 'Pibsbury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.79788,
        LOCATION_LATITUDE_DEG: 51.0292288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000200',
        LOCATION_NAME: 'Pibwrlwyd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3078576,
        LOCATION_LATITUDE_DEG: 51.8387233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000300',
        LOCATION_NAME: 'Pica',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.515186,
        LOCATION_LATITUDE_DEG: 54.5836815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI014400',
        LOCATION_NAME: 'Piccadilly',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2352929,
        LOCATION_LATITUDE_DEG: 53.4838059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI990196',
        LOCATION_NAME: 'Piccadilly',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1768735,
        LOCATION_LATITUDE_DEG: 53.0251638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000400',
        LOCATION_NAME: 'Piccadilly',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6593131,
        LOCATION_LATITUDE_DEG: 52.5811683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI014300',
        LOCATION_NAME: 'Piccadilly',
        COUNTY_NAME: 'London',
        POSTCODE: 'W1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1317935,
        LOCATION_LATITUDE_DEG: 51.5108273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000500',
        LOCATION_NAME: 'Piccadilly Corner',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3424408,
        LOCATION_LATITUDE_DEG: 52.4260114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000600',
        LOCATION_NAME: 'Piccotts End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4784602,
        LOCATION_LATITUDE_DEG: 51.772174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000700',
        LOCATION_NAME: 'Pickburn',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.221488,
        LOCATION_LATITUDE_DEG: 53.5610515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000800',
        LOCATION_NAME: 'Pickering',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7805099,
        LOCATION_LATITUDE_DEG: 54.2462141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI000900',
        LOCATION_NAME: 'Picket Hill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7546857,
        LOCATION_LATITUDE_DEG: 50.8456039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001000',
        LOCATION_NAME: 'Picket Piece',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4406302,
        LOCATION_LATITUDE_DEG: 51.2211343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001100',
        LOCATION_NAME: 'Picket Post',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7273895,
        LOCATION_LATITUDE_DEG: 50.8542041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001200',
        LOCATION_NAME: 'Picket Twenty',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4438438,
        LOCATION_LATITUDE_DEG: 51.2028308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001300',
        LOCATION_NAME: 'Picketston',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4356297,
        LOCATION_LATITUDE_DEG: 51.4206751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001400',
        LOCATION_NAME: 'Pickhill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4685101,
        LOCATION_LATITUDE_DEG: 54.2468244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001500',
        LOCATION_NAME: 'Picklescott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8332247,
        LOCATION_LATITUDE_DEG: 52.5894804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001600',
        LOCATION_NAME: 'Pickletillem',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9139975,
        LOCATION_LATITUDE_DEG: 56.4104591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001700',
        LOCATION_NAME: 'Pickletillum',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9111092,
        LOCATION_LATITUDE_DEG: 56.4103276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001800',
        LOCATION_NAME: 'Pickmere',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4600586,
        LOCATION_LATITUDE_DEG: 53.289145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI991060',
        LOCATION_NAME: 'Pickmere',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.469363,
        LOCATION_LATITUDE_DEG: 53.291384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI001900',
        LOCATION_NAME: 'Pickstock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4050908,
        LOCATION_LATITUDE_DEG: 52.8040978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002000',
        LOCATION_NAME: 'Picktree',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5587255,
        LOCATION_LATITUDE_DEG: 54.8771903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002100',
        LOCATION_NAME: 'Pickup Bank',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4176559,
        LOCATION_LATITUDE_DEG: 53.7028826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002200',
        LOCATION_NAME: 'Pickwell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8368712,
        LOCATION_LATITUDE_DEG: 52.6938665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002300',
        LOCATION_NAME: 'Pickwick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1964041,
        LOCATION_LATITUDE_DEG: 51.4350664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002400',
        LOCATION_NAME: 'Pickworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5347597,
        LOCATION_LATITUDE_DEG: 52.712663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002500',
        LOCATION_NAME: 'Pickworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4497515,
        LOCATION_LATITUDE_DEG: 52.8897825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002700',
        LOCATION_NAME: 'Picton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8465418,
        LOCATION_LATITUDE_DEG: 53.2363418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002600',
        LOCATION_NAME: 'Picton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3588662,
        LOCATION_LATITUDE_DEG: 54.4600434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002800',
        LOCATION_NAME: 'Picts Cross',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6390278,
        LOCATION_LATITUDE_DEG: 51.9367193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI002900',
        LOCATION_NAME: 'Piddinghoe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0346782,
        LOCATION_LATITUDE_DEG: 50.8093755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003000',
        LOCATION_NAME: 'Piddington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.07024,
        LOCATION_LATITUDE_DEG: 51.8512898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003100',
        LOCATION_NAME: 'Piddington',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.833211,
        LOCATION_LATITUDE_DEG: 51.6414673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003200',
        LOCATION_NAME: 'Piddington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8256396,
        LOCATION_LATITUDE_DEG: 52.1831164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003300',
        LOCATION_NAME: 'Piddlehinton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4031121,
        LOCATION_LATITUDE_DEG: 50.7734055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003400',
        LOCATION_NAME: 'Piddletrenthide',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4175511,
        LOCATION_LATITUDE_DEG: 50.7957039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003500',
        LOCATION_NAME: 'Pidley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0491438,
        LOCATION_LATITUDE_DEG: 52.3850287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003600',
        LOCATION_NAME: 'Piece',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2556305,
        LOCATION_LATITUDE_DEG: 50.2101757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003700',
        LOCATION_NAME: 'Piel Island',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1773104,
        LOCATION_LATITUDE_DEG: 54.0535301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003800',
        LOCATION_NAME: 'Piercebridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6753312,
        LOCATION_LATITUDE_DEG: 54.5369599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI990715',
        LOCATION_NAME: 'Pig Oak',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004100',
        LOCATION_NAME: 'Pigdon',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7576583,
        LOCATION_LATITUDE_DEG: 55.1884194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004400',
        LOCATION_NAME: 'Pikehall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7131409,
        LOCATION_LATITUDE_DEG: 53.1288214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004500',
        LOCATION_NAME: 'Pilford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9489092,
        LOCATION_LATITUDE_DEG: 50.8137976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004600',
        LOCATION_NAME: 'Pilgrims Hatch',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2720985,
        LOCATION_LATITUDE_DEG: 51.6441558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004700',
        LOCATION_NAME: 'Pilham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7012855,
        LOCATION_LATITUDE_DEG: 53.433639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004800',
        LOCATION_NAME: 'Pill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6860589,
        LOCATION_LATITUDE_DEG: 51.4792752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004900',
        LOCATION_NAME: 'Pill Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4845471,
        LOCATION_LATITUDE_DEG: 51.2754377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005000',
        LOCATION_NAME: 'Pillaton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.301632,
        LOCATION_LATITUDE_DEG: 50.4550904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005100',
        LOCATION_NAME: 'Pillerton Hersey',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5617627,
        LOCATION_LATITUDE_DEG: 52.1360229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005200',
        LOCATION_NAME: 'Pillerton Priors',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5716537,
        LOCATION_LATITUDE_DEG: 52.1255211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005300',
        LOCATION_NAME: 'Pilley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5281656,
        LOCATION_LATITUDE_DEG: 50.7820965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005400',
        LOCATION_NAME: 'Pilling',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9121824,
        LOCATION_LATITUDE_DEG: 53.9264084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005500',
        LOCATION_NAME: 'Pillowell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.539538,
        LOCATION_LATITUDE_DEG: 51.7559012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI990817',
        LOCATION_NAME: 'Pilmoor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005700',
        LOCATION_NAME: 'Pilning',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6412923,
        LOCATION_LATITUDE_DEG: 51.5629799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005800',
        LOCATION_NAME: 'Pilrig',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1852617,
        LOCATION_LATITUDE_DEG: 55.9670131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005900',
        LOCATION_NAME: 'Pilsdon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8317648,
        LOCATION_LATITUDE_DEG: 50.7921099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006000',
        LOCATION_NAME: 'Pilsgate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4247454,
        LOCATION_LATITUDE_DEG: 52.6372603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006100',
        LOCATION_NAME: 'Pilsley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3648826,
        LOCATION_LATITUDE_DEG: 53.1548212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006200',
        LOCATION_NAME: 'Piltdown',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0590826,
        LOCATION_LATITUDE_DEG: 50.9834878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI014500',
        LOCATION_NAME: 'Pilton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3830968,
        LOCATION_LATITUDE_DEG: 55.9309368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006500',
        LOCATION_NAME: 'Pilton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5835694,
        LOCATION_LATITUDE_DEG: 51.1631456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI990138',
        LOCATION_NAME: 'Pilton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6493909,
        LOCATION_LATITUDE_DEG: 52.6174299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006300',
        LOCATION_NAME: 'Pilton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6485746,
        LOCATION_LATITUDE_DEG: 52.6151547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006400',
        LOCATION_NAME: 'Pilton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4960047,
        LOCATION_LATITUDE_DEG: 52.4464381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006600',
        LOCATION_NAME: 'Pilton West',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0035832,
        LOCATION_LATITUDE_DEG: 51.1177494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006800',
        LOCATION_NAME: 'Pimlico',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.099887,
        LOCATION_LATITUDE_DEG: 52.0622136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006900',
        LOCATION_NAME: 'Pimlico',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4164471,
        LOCATION_LATITUDE_DEG: 51.7336656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI014200',
        LOCATION_NAME: 'Pimlico',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1370335,
        LOCATION_LATITUDE_DEG: 51.4862503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007000',
        LOCATION_NAME: 'Pimperne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1319174,
        LOCATION_LATITUDE_DEG: 50.8828134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007100',
        LOCATION_NAME: 'Pinchbeck',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1580954,
        LOCATION_LATITUDE_DEG: 52.812865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007200',
        LOCATION_NAME: 'Pinchinthorpe',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1034137,
        LOCATION_LATITUDE_DEG: 54.5295698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007300',
        LOCATION_NAME: 'Pine View Park',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4816815,
        LOCATION_LATITUDE_DEG: 52.0372017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007400',
        LOCATION_NAME: 'Pineham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7257481,
        LOCATION_LATITUDE_DEG: 52.0574042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007500',
        LOCATION_NAME: 'Pineham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3118519,
        LOCATION_LATITUDE_DEG: 51.1622917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007600',
        LOCATION_NAME: 'Pinfold',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6572028,
        LOCATION_LATITUDE_DEG: 52.8965078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007700',
        LOCATION_NAME: 'Pinford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4770431,
        LOCATION_LATITUDE_DEG: 50.9522242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007800',
        LOCATION_NAME: 'Pinged',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2754043,
        LOCATION_LATITUDE_DEG: 51.7107094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI007900',
        LOCATION_NAME: 'Pingewood',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0007986,
        LOCATION_LATITUDE_DEG: 51.4201452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008000',
        LOCATION_NAME: 'Pinhoe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4656723,
        LOCATION_LATITUDE_DEG: 50.7419123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008100',
        LOCATION_NAME: 'Pinkney',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.196101,
        LOCATION_LATITUDE_DEG: 51.5791809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008200',
        LOCATION_NAME: 'Pinksmoor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2763247,
        LOCATION_LATITUDE_DEG: 50.9678272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008300',
        LOCATION_NAME: 'Pinmill',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2139848,
        LOCATION_LATITUDE_DEG: 51.9958673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008400',
        LOCATION_NAME: 'Pinmore',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8191949,
        LOCATION_LATITUDE_DEG: 55.1895596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008500',
        LOCATION_NAME: 'Pinn',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2724008,
        LOCATION_LATITUDE_DEG: 50.6740001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008600',
        LOCATION_NAME: 'Pinner',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3806004,
        LOCATION_LATITUDE_DEG: 51.5933526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008700',
        LOCATION_NAME: 'Pinvin',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0658437,
        LOCATION_LATITUDE_DEG: 52.1366299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008800',
        LOCATION_NAME: 'Pinwall',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5450393,
        LOCATION_LATITUDE_DEG: 52.5956644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI008900',
        LOCATION_NAME: 'Pinwherry',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8278864,
        LOCATION_LATITUDE_DEG: 55.1434513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009000',
        LOCATION_NAME: 'Pinxton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3188023,
        LOCATION_LATITUDE_DEG: 53.0953121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009100',
        LOCATION_NAME: 'Pipe Aston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7827443,
        LOCATION_LATITUDE_DEG: 52.352654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009200',
        LOCATION_NAME: 'Pipe Gate',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3907506,
        LOCATION_LATITUDE_DEG: 52.9634117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009300',
        LOCATION_NAME: 'Pipehill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8613889,
        LOCATION_LATITUDE_DEG: 52.6704782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009400',
        LOCATION_NAME: 'Piperhill',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8904419,
        LOCATION_LATITUDE_DEG: 57.5361813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009500',
        LOCATION_NAME: 'Pipers End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1312001,
        LOCATION_LATITUDE_DEG: 51.7783709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009600',
        LOCATION_NAME: 'Pipers Pool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4591196,
        LOCATION_LATITUDE_DEG: 50.6303126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009700',
        LOCATION_NAME: 'Pipewell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7675909,
        LOCATION_LATITUDE_DEG: 52.4599475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009800',
        LOCATION_NAME: 'Pirbright',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6439741,
        LOCATION_LATITUDE_DEG: 51.2931272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI009900',
        LOCATION_NAME: 'Pirbright Camp',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.645423,
        LOCATION_LATITUDE_DEG: 51.312129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010000',
        LOCATION_NAME: 'Pirnmill',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3817832,
        LOCATION_LATITUDE_DEG: 55.644303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010100',
        LOCATION_NAME: 'Pirton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1726886,
        LOCATION_LATITUDE_DEG: 52.1249317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010200',
        LOCATION_NAME: 'Pirton',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3328778,
        LOCATION_LATITUDE_DEG: 51.9693907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010300',
        LOCATION_NAME: 'Pisgah',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9405981,
        LOCATION_LATITUDE_DEG: 52.3806744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010400',
        LOCATION_NAME: 'Pishill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9545606,
        LOCATION_LATITUDE_DEG: 51.6031596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010500',
        LOCATION_NAME: 'Pistyll',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.49159,
        LOCATION_LATITUDE_DEG: 52.9487313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010600',
        LOCATION_NAME: 'Pitbrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4517286,
        LOCATION_LATITUDE_DEG: 51.7104921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010700',
        LOCATION_NAME: 'Pitcairnfield',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5095757,
        LOCATION_LATITUDE_DEG: 56.4155593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010800',
        LOCATION_NAME: 'Pitcairngreen',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.515221,
        LOCATION_LATITUDE_DEG: 56.4270649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI010900',
        LOCATION_NAME: 'Pitcalnie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0003395,
        LOCATION_LATITUDE_DEG: 57.7260991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011000',
        LOCATION_NAME: 'Pitcaple',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4609888,
        LOCATION_LATITUDE_DEG: 57.3166414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011100',
        LOCATION_NAME: 'Pitchcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2163829,
        LOCATION_LATITUDE_DEG: 51.7680995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011200',
        LOCATION_NAME: 'Pitchcott',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8729368,
        LOCATION_LATITUDE_DEG: 51.8756877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011300',
        LOCATION_NAME: 'Pitchford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6942659,
        LOCATION_LATITUDE_DEG: 52.6280847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011400',
        LOCATION_NAME: 'Pitchill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9042589,
        LOCATION_LATITUDE_DEG: 52.1367263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011500',
        LOCATION_NAME: 'Pitcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4653213,
        LOCATION_LATITUDE_DEG: 51.0985385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011600',
        LOCATION_NAME: 'Pitfichie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5327581,
        LOCATION_LATITUDE_DEG: 57.2388345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011700',
        LOCATION_NAME: 'Pitfodels',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1622912,
        LOCATION_LATITUDE_DEG: 57.1205149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011800',
        LOCATION_NAME: 'Pitkennedy',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7454347,
        LOCATION_LATITUDE_DEG: 56.6771815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI011900',
        LOCATION_NAME: 'Pitlake',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1006191,
        LOCATION_LATITUDE_DEG: 51.3769321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012000',
        LOCATION_NAME: 'Pitlessie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0732894,
        LOCATION_LATITUDE_DEG: 56.2742426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012100',
        LOCATION_NAME: 'Pitlochry',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.731654,
        LOCATION_LATITUDE_DEG: 56.7051968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012200',
        LOCATION_NAME: 'Pitmaduthy',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0603885,
        LOCATION_LATITUDE_DEG: 57.7613038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012300',
        LOCATION_NAME: 'Pitmedden',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1785465,
        LOCATION_LATITUDE_DEG: 57.3371417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012400',
        LOCATION_NAME: 'Pitminster',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1068432,
        LOCATION_LATITUDE_DEG: 50.9672269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012500',
        LOCATION_NAME: 'Pitney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7861508,
        LOCATION_LATITUDE_DEG: 51.0516299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012600',
        LOCATION_NAME: 'Pitreavie Castle',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4205798,
        LOCATION_LATITUDE_DEG: 56.0500256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012700',
        LOCATION_NAME: 'Pitroddie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2650828,
        LOCATION_LATITUDE_DEG: 56.4095591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012800',
        LOCATION_NAME: 'Pitscandly',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8396862,
        LOCATION_LATITUDE_DEG: 56.6619809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI012900',
        LOCATION_NAME: 'Pitscottie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9418304,
        LOCATION_LATITUDE_DEG: 56.3068436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013000',
        LOCATION_NAME: 'Pitsea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5024049,
        LOCATION_LATITUDE_DEG: 51.5635416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013100',
        LOCATION_NAME: 'Pitsford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8912998,
        LOCATION_LATITUDE_DEG: 52.3050329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013200',
        LOCATION_NAME: 'Pitstone',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6378831,
        LOCATION_LATITUDE_DEG: 51.8274829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013300',
        LOCATION_NAME: 'Pitt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3485461,
        LOCATION_LATITUDE_DEG: 51.0495175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013400',
        LOCATION_NAME: 'Pittentrail',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1544525,
        LOCATION_LATITUDE_DEG: 57.9894251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013500',
        LOCATION_NAME: 'Pittenweem',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7270737,
        LOCATION_LATITUDE_DEG: 56.2142375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013600',
        LOCATION_NAME: 'Pitton',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2689685,
        LOCATION_LATITUDE_DEG: 51.5660949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013700',
        LOCATION_NAME: 'Pitton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6989055,
        LOCATION_LATITUDE_DEG: 51.0806227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI990353',
        LOCATION_NAME: 'Pitton Barton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7717906,
        LOCATION_LATITUDE_DEG: 50.7416735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013800',
        LOCATION_NAME: 'Pity Me',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5882754,
        LOCATION_LATITUDE_DEG: 54.8024818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI013900',
        LOCATION_NAME: 'Pityme',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.893406,
        LOCATION_LATITUDE_DEG: 50.5533094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI014000',
        LOCATION_NAME: 'Pixley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4947047,
        LOCATION_LATITUDE_DEG: 52.0454241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI014100',
        LOCATION_NAME: 'Pixton Park',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5320533,
        LOCATION_LATITUDE_DEG: 51.0331424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000100',
        LOCATION_NAME: 'Plaidy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4388963,
        LOCATION_LATITUDE_DEG: 50.3598892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL006100',
        LOCATION_NAME: 'Plain an Gwarry',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2342062,
        LOCATION_LATITUDE_DEG: 50.2381167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000200',
        LOCATION_NAME: 'Plain-an-Gwarry',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2303291,
        LOCATION_LATITUDE_DEG: 50.2363803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000300',
        LOCATION_NAME: 'Plainmoor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5223662,
        LOCATION_LATITUDE_DEG: 50.4745889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000400',
        LOCATION_NAME: 'Plains',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9307133,
        LOCATION_LATITUDE_DEG: 55.8800154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000500',
        LOCATION_NAME: 'Plaish',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6933476,
        LOCATION_LATITUDE_DEG: 52.5624738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000600',
        LOCATION_NAME: 'Plaistow',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5663033,
        LOCATION_LATITUDE_DEG: 51.0689088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL006300',
        LOCATION_NAME: 'Plaistow',
        COUNTY_NAME: 'London',
        POSTCODE: 'E13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0249389,
        LOCATION_LATITUDE_DEG: 51.5352607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000700',
        LOCATION_NAME: 'Plaistow Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6177385,
        LOCATION_LATITUDE_DEG: 51.9192769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000800',
        LOCATION_NAME: 'Plaitford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6073153,
        LOCATION_LATITUDE_DEG: 50.9727104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL000900',
        LOCATION_NAME: 'Plantation Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7986171,
        LOCATION_LATITUDE_DEG: 54.3637567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001000',
        LOCATION_NAME: 'Plas Gwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3564705,
        LOCATION_LATITUDE_DEG: 52.9176322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001100',
        LOCATION_NAME: 'Plasmarl',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9320636,
        LOCATION_LATITUDE_DEG: 51.6488058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001300',
        LOCATION_NAME: 'Plasterfield',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3581271,
        LOCATION_LATITUDE_DEG: 58.2135691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001400',
        LOCATION_NAME: 'Plasycoed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0703895,
        LOCATION_LATITUDE_DEG: 51.7024022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001500',
        LOCATION_NAME: 'Platt',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.326269,
        LOCATION_LATITUDE_DEG: 51.2887137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001600',
        LOCATION_NAME: 'Platt Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5967668,
        LOCATION_LATITUDE_DEG: 53.5182723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001700',
        LOCATION_NAME: 'Platt Lane',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7234341,
        LOCATION_LATITUDE_DEG: 52.9223123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001800',
        LOCATION_NAME: 'Platts Heath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6887575,
        LOCATION_LATITUDE_DEG: 51.2226047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001900',
        LOCATION_NAME: 'Plawsworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5918553,
        LOCATION_LATITUDE_DEG: 54.8254841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002000',
        LOCATION_NAME: 'Plawsworth Gate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5911391,
        LOCATION_LATITUDE_DEG: 54.82088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002100',
        LOCATION_NAME: 'Plaxtol',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2970476,
        LOCATION_LATITUDE_DEG: 51.2579183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002200',
        LOCATION_NAME: 'Playden',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7335028,
        LOCATION_LATITUDE_DEG: 50.9612797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002300',
        LOCATION_NAME: 'Playford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2367348,
        LOCATION_LATITUDE_DEG: 52.0856811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002400',
        LOCATION_NAME: 'Playhatch',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9336017,
        LOCATION_LATITUDE_DEG: 51.4793561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002500',
        LOCATION_NAME: 'Playing Place',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0665976,
        LOCATION_LATITUDE_DEG: 50.2321836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002600',
        LOCATION_NAME: 'Plealey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8533035,
        LOCATION_LATITUDE_DEG: 52.6563837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002700',
        LOCATION_NAME: 'Plean',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8755292,
        LOCATION_LATITUDE_DEG: 56.0650332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL006500',
        LOCATION_NAME: 'Pleasance',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1821925,
        LOCATION_LATITUDE_DEG: 55.9472812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002800',
        LOCATION_NAME: 'Pleasant Valley',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6866362,
        LOCATION_LATITUDE_DEG: 51.7517242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL002900',
        LOCATION_NAME: 'Pleasington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5418446,
        LOCATION_LATITUDE_DEG: 53.7305846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003000',
        LOCATION_NAME: 'Pleasley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2487168,
        LOCATION_LATITUDE_DEG: 53.1746157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003100',
        LOCATION_NAME: 'Pleasley Vale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2202924,
        LOCATION_LATITUDE_DEG: 53.180915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003200',
        LOCATION_NAME: 'Pleck',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0074093,
        LOCATION_LATITUDE_DEG: 52.5808669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003300',
        LOCATION_NAME: 'Plenmeller',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4449492,
        LOCATION_LATITUDE_DEG: 54.9617037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003400',
        LOCATION_NAME: 'Pleshey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4145406,
        LOCATION_LATITUDE_DEG: 51.8050661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL006400',
        LOCATION_NAME: 'Plewlands',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.219613,
        LOCATION_LATITUDE_DEG: 55.9236323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003500',
        LOCATION_NAME: 'Plockropool',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7542594,
        LOCATION_LATITUDE_DEG: 57.84204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003600',
        LOCATION_NAME: 'Plockton',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6513833,
        LOCATION_LATITUDE_DEG: 57.3375809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003700',
        LOCATION_NAME: 'Plowden',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9078445,
        LOCATION_LATITUDE_DEG: 52.4811722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003900',
        LOCATION_NAME: 'Pluckley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7551373,
        LOCATION_LATITUDE_DEG: 51.1751033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004000',
        LOCATION_NAME: 'Plumber',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3236307,
        LOCATION_LATITUDE_DEG: 50.9033132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004100',
        LOCATION_NAME: 'Plumbland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.318933,
        LOCATION_LATITUDE_DEG: 54.7400964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004200',
        LOCATION_NAME: 'Plumbridge',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2451149,
        LOCATION_LATITUDE_DEG: 54.7689629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004300',
        LOCATION_NAME: 'Plumley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4240771,
        LOCATION_LATITUDE_DEG: 53.2765397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004400',
        LOCATION_NAME: 'Plumley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8218046,
        LOCATION_LATITUDE_DEG: 50.8834084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004500',
        LOCATION_NAME: 'Plummers Plain',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2538349,
        LOCATION_LATITUDE_DEG: 51.0224037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004600',
        LOCATION_NAME: 'Plump Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4872731,
        LOCATION_LATITUDE_DEG: 51.8526059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL990721',
        LOCATION_NAME: 'Plumpton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004900',
        LOCATION_NAME: 'Plumpton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7792811,
        LOCATION_LATITUDE_DEG: 54.726187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004700',
        LOCATION_NAME: 'Plumpton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1255482,
        LOCATION_LATITUDE_DEG: 52.1294141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL004800',
        LOCATION_NAME: 'Plumpton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0664018,
        LOCATION_LATITUDE_DEG: 50.9023897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005000',
        LOCATION_NAME: 'Plumpton Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0590103,
        LOCATION_LATITUDE_DEG: 50.9350877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL006200',
        LOCATION_NAME: 'Plumstead',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0887443,
        LOCATION_LATITUDE_DEG: 51.4893974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005100',
        LOCATION_NAME: 'Plumstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1666789,
        LOCATION_LATITUDE_DEG: 52.8689516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005200',
        LOCATION_NAME: 'Plumtree',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0874789,
        LOCATION_LATITUDE_DEG: 52.8910897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005300',
        LOCATION_NAME: 'Plungar',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8582549,
        LOCATION_LATITUDE_DEG: 52.8977836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL990881',
        LOCATION_NAME: 'Pluscarden',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005400',
        LOCATION_NAME: 'Plush',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4053816,
        LOCATION_LATITUDE_DEG: 50.8177093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005500',
        LOCATION_NAME: 'Plwmp',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3840848,
        LOCATION_LATITUDE_DEG: 52.1458547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005600',
        LOCATION_NAME: 'Plymouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1414555,
        LOCATION_LATITUDE_DEG: 50.3698869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005700',
        LOCATION_NAME: 'Plymouth Airport',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1085215,
        LOCATION_LATITUDE_DEG: 50.4213845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005800',
        LOCATION_NAME: 'Plympton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0574512,
        LOCATION_LATITUDE_DEG: 50.3894844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL005900',
        LOCATION_NAME: 'Plymstock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0855407,
        LOCATION_LATITUDE_DEG: 50.3552784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL006000',
        LOCATION_NAME: 'Plymtree',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3444857,
        LOCATION_LATITUDE_DEG: 50.8169175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000100',
        LOCATION_NAME: 'Pockley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0213299,
        LOCATION_LATITUDE_DEG: 54.2657222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000200',
        LOCATION_NAME: 'Pocklington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7790473,
        LOCATION_LATITUDE_DEG: 53.9307858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000300',
        LOCATION_NAME: 'Pockthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6994906,
        LOCATION_LATITUDE_DEG: 52.8115577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000400',
        LOCATION_NAME: 'Pode Hole',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.201914,
        LOCATION_LATITUDE_DEG: 52.7827675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000500',
        LOCATION_NAME: 'Podimore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6471583,
        LOCATION_LATITUDE_DEG: 51.0228311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000600',
        LOCATION_NAME: 'Podington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6209058,
        LOCATION_LATITUDE_DEG: 52.2542219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000700',
        LOCATION_NAME: 'Podsmead',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2574205,
        LOCATION_LATITUDE_DEG: 51.8406996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000800',
        LOCATION_NAME: 'Point',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0619492,
        LOCATION_LATITUDE_DEG: 50.2016722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO000900',
        LOCATION_NAME: 'Point Clear Bay',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.037727,
        LOCATION_LATITUDE_DEG: 51.7932164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001000',
        LOCATION_NAME: 'Point Mills',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1302196,
        LOCATION_LATITUDE_DEG: 50.2291811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001100',
        LOCATION_NAME: 'Pointon',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3449584,
        LOCATION_LATITUDE_DEG: 52.8726783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001200',
        LOCATION_NAME: 'Pointon Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2976004,
        LOCATION_LATITUDE_DEG: 52.8718738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001300',
        LOCATION_NAME: 'Polbain',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3965878,
        LOCATION_LATITUDE_DEG: 58.0363487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001400',
        LOCATION_NAME: 'Polbathic',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3242106,
        LOCATION_LATITUDE_DEG: 50.3887849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001500',
        LOCATION_NAME: 'Polbeth',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5501637,
        LOCATION_LATITUDE_DEG: 55.8603041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001600',
        LOCATION_NAME: 'Polborder',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2709214,
        LOCATION_LATITUDE_DEG: 50.4613971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001700',
        LOCATION_NAME: 'Poldice',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1706227,
        LOCATION_LATITUDE_DEG: 50.2451789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001900',
        LOCATION_NAME: 'Polebrook',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4280453,
        LOCATION_LATITUDE_DEG: 52.4712441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002000',
        LOCATION_NAME: 'Polegate',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2446359,
        LOCATION_LATITUDE_DEG: 50.8192767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002200',
        LOCATION_NAME: 'Poleshill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2995807,
        LOCATION_LATITUDE_DEG: 50.9993368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002300',
        LOCATION_NAME: 'Polesworth',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6130976,
        LOCATION_LATITUDE_DEG: 52.6199658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002400',
        LOCATION_NAME: 'Polgear',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.241128,
        LOCATION_LATITUDE_DEG: 50.1883767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002500',
        LOCATION_NAME: 'Polglass',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3254216,
        LOCATION_LATITUDE_DEG: 58.0090404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002600',
        LOCATION_NAME: 'Polgooth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8153335,
        LOCATION_LATITUDE_DEG: 50.3207838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002700',
        LOCATION_NAME: 'Polhawn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2172356,
        LOCATION_LATITUDE_DEG: 50.3212758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002800',
        LOCATION_NAME: 'Polhilsa',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.331333,
        LOCATION_LATITUDE_DEG: 50.527803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002900',
        LOCATION_NAME: 'Poling',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5188757,
        LOCATION_LATITUDE_DEG: 50.8321897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003000',
        LOCATION_NAME: 'Polkerris',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6796569,
        LOCATION_LATITUDE_DEG: 50.3375852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003300',
        LOCATION_NAME: 'Pollington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0713203,
        LOCATION_LATITUDE_DEG: 53.6701659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003400',
        LOCATION_NAME: 'Polloch',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6097444,
        LOCATION_LATITUDE_DEG: 56.758516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035700',
        LOCATION_NAME: 'Pollock Dock',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003500',
        LOCATION_NAME: 'Pollok',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3449866,
        LOCATION_LATITUDE_DEG: 55.8299151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO036200',
        LOCATION_NAME: 'Pollokshaws',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2994682,
        LOCATION_LATITUDE_DEG: 55.8260736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO036000',
        LOCATION_NAME: 'Pollokshields',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2994331,
        LOCATION_LATITUDE_DEG: 55.8260203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003800',
        LOCATION_NAME: 'Polmadie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2444875,
        LOCATION_LATITUDE_DEG: 55.8338129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003900',
        LOCATION_NAME: 'Polmanter Water',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4966558,
        LOCATION_LATITUDE_DEG: 50.1944815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004000',
        LOCATION_NAME: 'Polmassick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8448354,
        LOCATION_LATITUDE_DEG: 50.2740846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004100',
        LOCATION_NAME: 'Polmont',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7041373,
        LOCATION_LATITUDE_DEG: 55.9902201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004200',
        LOCATION_NAME: 'Polmorla',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8541768,
        LOCATION_LATITUDE_DEG: 50.5070035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004300',
        LOCATION_NAME: 'Polperro',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5183937,
        LOCATION_LATITUDE_DEG: 50.3309814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004400',
        LOCATION_NAME: 'Polruan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.630904,
        LOCATION_LATITUDE_DEG: 50.3262846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004500',
        LOCATION_NAME: 'Polscoe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6528253,
        LOCATION_LATITUDE_DEG: 50.4134886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004600',
        LOCATION_NAME: 'Polsham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.693449,
        LOCATION_LATITUDE_DEG: 51.1815484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004700',
        LOCATION_NAME: 'Polson Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3212395,
        LOCATION_LATITUDE_DEG: 50.6386115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004800',
        LOCATION_NAME: 'Polstead',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9003502,
        LOCATION_LATITUDE_DEG: 52.0051748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO004900',
        LOCATION_NAME: 'Polstead Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9044235,
        LOCATION_LATITUDE_DEG: 52.0268771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005000',
        LOCATION_NAME: 'Polstrong',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3239363,
        LOCATION_LATITUDE_DEG: 50.2107768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005100',
        LOCATION_NAME: 'Poltimore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4649453,
        LOCATION_LATITUDE_DEG: 50.761313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005200',
        LOCATION_NAME: 'Polton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1264659,
        LOCATION_LATITUDE_DEG: 55.8724063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005300',
        LOCATION_NAME: 'Polurrian Cliffs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2522294,
        LOCATION_LATITUDE_DEG: 50.0216624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005400',
        LOCATION_NAME: 'Polwarth',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4078215,
        LOCATION_LATITUDE_DEG: 55.7443845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005500',
        LOCATION_NAME: 'Polwhele',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0353776,
        LOCATION_LATITUDE_DEG: 50.2842854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005600',
        LOCATION_NAME: 'Polyphant',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4564189,
        LOCATION_LATITUDE_DEG: 50.6116051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005700',
        LOCATION_NAME: 'Polzeath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9139142,
        LOCATION_LATITUDE_DEG: 50.5726073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005800',
        LOCATION_NAME: 'Pomeroy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9322956,
        LOCATION_LATITUDE_DEG: 54.5999191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO005900',
        LOCATION_NAME: 'Pomphlett',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0997121,
        LOCATION_LATITUDE_DEG: 50.3644864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006000',
        LOCATION_NAME: 'Ponciau',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0486466,
        LOCATION_LATITUDE_DEG: 53.0124282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035600',
        LOCATION_NAME: 'Ponders End',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'EN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0463007,
        LOCATION_LATITUDE_DEG: 51.6452911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006100',
        LOCATION_NAME: 'Pondersbridge',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.142678,
        LOCATION_LATITUDE_DEG: 52.5118431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006200',
        LOCATION_NAME: 'Ponsanooth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1414448,
        LOCATION_LATITUDE_DEG: 50.1959761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006300',
        LOCATION_NAME: 'Ponsharden',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.101017,
        LOCATION_LATITUDE_DEG: 50.1679762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006400',
        LOCATION_NAME: 'Ponsharden',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0851128,
        LOCATION_LATITUDE_DEG: 50.1602759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006500',
        LOCATION_NAME: 'Ponsonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4561323,
        LOCATION_LATITUDE_DEG: 54.4356672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006600',
        LOCATION_NAME: 'Ponsworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8347031,
        LOCATION_LATITUDE_DEG: 50.5488969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006700',
        LOCATION_NAME: 'Pont Nedd Fechan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5940474,
        LOCATION_LATITUDE_DEG: 51.7561319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006800',
        LOCATION_NAME: 'Pont Robert',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3258352,
        LOCATION_LATITUDE_DEG: 52.704917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035200',
        LOCATION_NAME: 'Pont Y Pant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007000',
        LOCATION_NAME: 'Pontantwn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2620665,
        LOCATION_LATITUDE_DEG: 51.7941233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007100',
        LOCATION_NAME: 'Pontardawe',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8479452,
        LOCATION_LATITUDE_DEG: 51.720011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007200',
        LOCATION_NAME: 'Pontarddulais',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0406842,
        LOCATION_LATITUDE_DEG: 51.7142127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007300',
        LOCATION_NAME: 'Pontblyddyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0936846,
        LOCATION_LATITUDE_DEG: 53.1374408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO990459',
        LOCATION_NAME: 'Pontcanna',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007400',
        LOCATION_NAME: 'Pontcysyllte',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.07745,
        LOCATION_LATITUDE_DEG: 52.972423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007500',
        LOCATION_NAME: 'Pontdolgoch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4641683,
        LOCATION_LATITUDE_DEG: 52.5340859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007600',
        LOCATION_NAME: 'Pontefract',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3037389,
        LOCATION_LATITUDE_DEG: 53.6929666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007700',
        LOCATION_NAME: 'Ponteland',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7408642,
        LOCATION_LATITUDE_DEG: 55.0507029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007800',
        LOCATION_NAME: 'Ponterwyd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8386149,
        LOCATION_LATITUDE_DEG: 52.4110717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO007900',
        LOCATION_NAME: 'Pontesbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8874442,
        LOCATION_LATITUDE_DEG: 52.6483917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008000',
        LOCATION_NAME: 'Pontesford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8714259,
        LOCATION_LATITUDE_DEG: 52.6516844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008100',
        LOCATION_NAME: 'Pontfadog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1444926,
        LOCATION_LATITUDE_DEG: 52.9315177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008200',
        LOCATION_NAME: 'Pontfaen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.874144,
        LOCATION_LATITUDE_DEG: 51.969444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008300',
        LOCATION_NAME: 'Pontgarreg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4279772,
        LOCATION_LATITUDE_DEG: 52.1607604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008400',
        LOCATION_NAME: 'Ponthenry',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2007822,
        LOCATION_LATITUDE_DEG: 51.7576844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008500',
        LOCATION_NAME: 'Ponthir',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9758631,
        LOCATION_LATITUDE_DEG: 51.6314918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008600',
        LOCATION_NAME: 'Ponthirwaun',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5360118,
        LOCATION_LATITUDE_DEG: 52.0770478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008700',
        LOCATION_NAME: 'Pontllanfraith',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1887917,
        LOCATION_LATITUDE_DEG: 51.6526943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008800',
        LOCATION_NAME: 'Pontlliw',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0106632,
        LOCATION_LATITUDE_DEG: 51.6915092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO008900',
        LOCATION_NAME: 'Pontllyfni',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3355493,
        LOCATION_LATITUDE_DEG: 53.0473457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009000',
        LOCATION_NAME: 'Pontlottyn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2792445,
        LOCATION_LATITUDE_DEG: 51.7459065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009100',
        LOCATION_NAME: 'Pontnewydd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.015381,
        LOCATION_LATITUDE_DEG: 51.6662908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009200',
        LOCATION_NAME: 'Pontnewynydd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0486834,
        LOCATION_LATITUDE_DEG: 51.7163026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009400',
        LOCATION_NAME: 'Pontprennau',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1852051,
        LOCATION_LATITUDE_DEG: 51.5272809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009500',
        LOCATION_NAME: 'Pontrhydfendigaid',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.86137,
        LOCATION_LATITUDE_DEG: 52.2843632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009600',
        LOCATION_NAME: 'Pontrhydyfen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7428954,
        LOCATION_LATITUDE_DEG: 51.633699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009700',
        LOCATION_NAME: 'Pontrhydygroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8496482,
        LOCATION_LATITUDE_DEG: 52.3345364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009800',
        LOCATION_NAME: 'Pontrhydyrun',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0196867,
        LOCATION_LATITUDE_DEG: 51.6641942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009900',
        LOCATION_NAME: 'Pontrilas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8782427,
        LOCATION_LATITUDE_DEG: 51.9430189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010000',
        LOCATION_NAME: 'Pontrug',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2235502,
        LOCATION_LATITUDE_DEG: 53.1456077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010100',
        LOCATION_NAME: 'Pontsarn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3861074,
        LOCATION_LATITUDE_DEG: 51.7783095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010200',
        LOCATION_NAME: 'Pontselli',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5448212,
        LOCATION_LATITUDE_DEG: 52.0312502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010300',
        LOCATION_NAME: 'Pontshaen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2819713,
        LOCATION_LATITUDE_DEG: 52.0908849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010400',
        LOCATION_NAME: 'Pontshill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5247291,
        LOCATION_LATITUDE_DEG: 51.8957144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO990683',
        LOCATION_NAME: 'Pontsian',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010500',
        LOCATION_NAME: 'Pontsmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7102193,
        LOCATION_LATITUDE_DEG: 50.3736886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010600',
        LOCATION_NAME: 'Pontsticill',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.366744,
        LOCATION_LATITUDE_DEG: 51.7943094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010700',
        LOCATION_NAME: 'Pontwalby',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6055383,
        LOCATION_LATITUDE_DEG: 51.7459124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010800',
        LOCATION_NAME: 'Pontwelly',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3115128,
        LOCATION_LATITUDE_DEG: 52.0361777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO010900',
        LOCATION_NAME: 'Pontyates',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2192589,
        LOCATION_LATITUDE_DEG: 51.7544139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011000',
        LOCATION_NAME: 'Pontyberem',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1725082,
        LOCATION_LATITUDE_DEG: 51.7779156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011100',
        LOCATION_NAME: 'Pontybodkin',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0889482,
        LOCATION_LATITUDE_DEG: 53.1257337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011200',
        LOCATION_NAME: 'Pontyclun',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3904658,
        LOCATION_LATITUDE_DEG: 51.5220867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011300',
        LOCATION_NAME: 'Pontycymer',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5830314,
        LOCATION_LATITUDE_DEG: 51.6112954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011350',
        LOCATION_NAME: 'Pontyfenni',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011400',
        LOCATION_NAME: 'Pontygof',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2051899,
        LOCATION_LATITUDE_DEG: 51.790609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011500',
        LOCATION_NAME: 'Pontygwaith',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4303271,
        LOCATION_LATITUDE_DEG: 51.6365922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO990360',
        LOCATION_NAME: 'Pontymister',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011600',
        LOCATION_NAME: 'Pontymoile',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0253856,
        LOCATION_LATITUDE_DEG: 51.6949981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO006900',
        LOCATION_NAME: 'Pont-Y-Pant',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8627574,
        LOCATION_LATITUDE_DEG: 53.0651407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011700',
        LOCATION_NAME: 'Pontypool',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0308879,
        LOCATION_LATITUDE_DEG: 51.6977017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011800',
        LOCATION_NAME: 'Pontypridd',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3485614,
        LOCATION_LATITUDE_DEG: 51.600689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO990332',
        LOCATION_NAME: 'Pontyrhyl',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO011900',
        LOCATION_NAME: 'Pontysaison',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7113432,
        LOCATION_LATITUDE_DEG: 51.6970945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012000',
        LOCATION_NAME: 'Pontywaun',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1271705,
        LOCATION_LATITUDE_DEG: 51.6279965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012100',
        LOCATION_NAME: 'Pool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2650354,
        LOCATION_LATITUDE_DEG: 50.2275819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012200',
        LOCATION_NAME: 'Pool Head',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7429234,
        LOCATION_LATITUDE_DEG: 52.865911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012300',
        LOCATION_NAME: 'Pool Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3978695,
        LOCATION_LATITUDE_DEG: 51.9675983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012500',
        LOCATION_NAME: 'Pool in Wharfedale',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6275159,
        LOCATION_LATITUDE_DEG: 53.9020944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012400',
        LOCATION_NAME: 'Pool Quay',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0999945,
        LOCATION_LATITUDE_DEG: 52.6954941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012600',
        LOCATION_NAME: 'Poole',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2137128,
        LOCATION_LATITUDE_DEG: 50.9870307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012750',
        LOCATION_NAME: 'Poole',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5386644,
        LOCATION_LATITUDE_DEG: 53.0949457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012700',
        LOCATION_NAME: 'Poole',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.979373,
        LOCATION_LATITUDE_DEG: 50.7180966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012800',
        LOCATION_NAME: 'Poole Keynes',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9991325,
        LOCATION_LATITUDE_DEG: 51.6573801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO012900',
        LOCATION_NAME: 'Poolewe',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6028941,
        LOCATION_LATITUDE_DEG: 57.7648144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013000',
        LOCATION_NAME: 'Pooley Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8165029,
        LOCATION_LATITUDE_DEG: 54.6124774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013100',
        LOCATION_NAME: 'Pooley Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'TW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5317524,
        LOCATION_LATITUDE_DEG: 51.4290395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013200',
        LOCATION_NAME: 'Poolsbrook',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3370118,
        LOCATION_LATITUDE_DEG: 53.259125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013300',
        LOCATION_NAME: 'Pootings',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.082196,
        LOCATION_LATITUDE_DEG: 51.2238123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013400',
        LOCATION_NAME: 'Popehill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.991201,
        LOCATION_LATITUDE_DEG: 51.769908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013500',
        LOCATION_NAME: 'Popes Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4521821,
        LOCATION_LATITUDE_DEG: 51.8270018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013600',
        LOCATION_NAME: 'Popeswood',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7847769,
        LOCATION_LATITUDE_DEG: 51.4189409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013700',
        LOCATION_NAME: 'Popham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1995217,
        LOCATION_LATITUDE_DEG: 51.1906317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035400',
        LOCATION_NAME: 'Poplar',
        COUNTY_NAME: 'London',
        POSTCODE: 'E14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0183695,
        LOCATION_LATITUDE_DEG: 51.5049992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013800',
        LOCATION_NAME: 'Poplars Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1404048,
        LOCATION_LATITUDE_DEG: 51.8009729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO013900',
        LOCATION_NAME: 'Porchester',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1161541,
        LOCATION_LATITUDE_DEG: 52.9801966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014000',
        LOCATION_NAME: 'Porchfield',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3656223,
        LOCATION_LATITUDE_DEG: 50.718882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014100',
        LOCATION_NAME: 'Porcupine',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7018749,
        LOCATION_LATITUDE_DEG: 50.3686921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014200',
        LOCATION_NAME: 'Poringland',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.351734,
        LOCATION_LATITUDE_DEG: 52.565323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014300',
        LOCATION_NAME: 'Porkellis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2299248,
        LOCATION_LATITUDE_DEG: 50.1552737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014400',
        LOCATION_NAME: 'Porlock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5925525,
        LOCATION_LATITUDE_DEG: 51.207857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014500',
        LOCATION_NAME: 'Porlock Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.604954,
        LOCATION_LATITUDE_DEG: 51.2021564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014600',
        LOCATION_NAME: 'Porlock Weir',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6256572,
        LOCATION_LATITUDE_DEG: 51.2172588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014700',
        LOCATION_NAME: 'Porset',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2026012,
        LOCATION_LATITUDE_DEG: 51.5855935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014900',
        LOCATION_NAME: 'Port Ann',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3664222,
        LOCATION_LATITUDE_DEG: 56.0202473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015000',
        LOCATION_NAME: 'Port Appin',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4067698,
        LOCATION_LATITUDE_DEG: 56.5542996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015100',
        LOCATION_NAME: 'Port Askaig',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1058351,
        LOCATION_LATITUDE_DEG: 55.8484297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015200',
        LOCATION_NAME: 'Port Bannatyne',
        COUNTY_NAME: 'Isle of Bute',
        POSTCODE: 'PA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0693684,
        LOCATION_LATITUDE_DEG: 55.8597256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015300',
        LOCATION_NAME: 'Port Carlisle',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1872848,
        LOCATION_LATITUDE_DEG: 54.9495133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015400',
        LOCATION_NAME: 'Port Charlotte',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3775821,
        LOCATION_LATITUDE_DEG: 55.7388243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015500',
        LOCATION_NAME: 'Port Clarence',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2258492,
        LOCATION_LATITUDE_DEG: 54.5872564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035900',
        LOCATION_NAME: 'Port Dundas',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2455293,
        LOCATION_LATITUDE_DEG: 55.8745927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015700',
        LOCATION_NAME: 'Port Edgar',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.419628,
        LOCATION_LATITUDE_DEG: 55.9926202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015800',
        LOCATION_NAME: 'Port Ellen',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1869465,
        LOCATION_LATITUDE_DEG: 55.6293098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015900',
        LOCATION_NAME: 'Port Elphinstone',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3694871,
        LOCATION_LATITUDE_DEG: 57.2725357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016000',
        LOCATION_NAME: 'Port Erin',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7528957,
        LOCATION_LATITUDE_DEG: 54.0864546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO990889',
        LOCATION_NAME: 'Port Eynon',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016100',
        LOCATION_NAME: 'Port Gaverne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8216163,
        LOCATION_LATITUDE_DEG: 50.5923069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016200',
        LOCATION_NAME: 'Port Glasgow',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6859582,
        LOCATION_LATITUDE_DEG: 55.9355247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016300',
        LOCATION_NAME: 'Port Henderson',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7700846,
        LOCATION_LATITUDE_DEG: 57.697417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016400',
        LOCATION_NAME: 'Port Isaac',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8288193,
        LOCATION_LATITUDE_DEG: 50.5934095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016600',
        LOCATION_NAME: 'Port Logan',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9539848,
        LOCATION_LATITUDE_DEG: 54.7241124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016700',
        LOCATION_NAME: 'Port Mulgrave',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7763233,
        LOCATION_LATITUDE_DEG: 54.5421452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017800',
        LOCATION_NAME: 'Port of Menteith',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2835959,
        LOCATION_LATITUDE_DEG: 56.1849442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017900',
        LOCATION_NAME: 'Port of Ness',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2406422,
        LOCATION_LATITUDE_DEG: 58.4972725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016800',
        LOCATION_NAME: 'Port Pendennis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0591154,
        LOCATION_LATITUDE_DEG: 50.1483686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO016900',
        LOCATION_NAME: 'Port Quin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8709216,
        LOCATION_LATITUDE_DEG: 50.587152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017100',
        LOCATION_NAME: 'Port Riddell',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9172402,
        LOCATION_LATITUDE_DEG: 55.9563332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO901975',
        LOCATION_NAME: 'Port Soderick',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5313679,
        LOCATION_LATITUDE_DEG: 54.1219195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017200',
        LOCATION_NAME: 'Port Solent',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0945373,
        LOCATION_LATITUDE_DEG: 50.8418904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017250',
        LOCATION_NAME: 'Port St. Mary',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7392321,
        LOCATION_LATITUDE_DEG: 54.0759226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017400',
        LOCATION_NAME: 'Port Talbot',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7796805,
        LOCATION_LATITUDE_DEG: 51.5957978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017500',
        LOCATION_NAME: 'Port Tennant',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9135111,
        LOCATION_LATITUDE_DEG: 51.6232985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017600',
        LOCATION_NAME: 'Port Wemyss',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5042525,
        LOCATION_LATITUDE_DEG: 55.6763186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017700',
        LOCATION_NAME: 'Port William',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5821106,
        LOCATION_LATITUDE_DEG: 54.7601104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018100',
        LOCATION_NAME: 'Portadown',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4474433,
        LOCATION_LATITUDE_DEG: 54.4263987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018200',
        LOCATION_NAME: 'Portaferry',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.542648,
        LOCATION_LATITUDE_DEG: 54.3936857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018600',
        LOCATION_NAME: 'Portavogie',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4544504,
        LOCATION_LATITUDE_DEG: 54.4499883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018700',
        LOCATION_NAME: 'Portballintrae',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4893416,
        LOCATION_LATITUDE_DEG: 55.1971758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018800',
        LOCATION_NAME: 'Portbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7197011,
        LOCATION_LATITUDE_DEG: 51.4737769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018900',
        LOCATION_NAME: 'Portchester',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1187854,
        LOCATION_LATITUDE_DEG: 50.8410957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019000',
        LOCATION_NAME: 'Portencross',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9026084,
        LOCATION_LATITUDE_DEG: 55.7000071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019100',
        LOCATION_NAME: 'Porters Wood',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3196796,
        LOCATION_LATITUDE_DEG: 51.7692739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019200',
        LOCATION_NAME: 'Portesham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5629697,
        LOCATION_LATITUDE_DEG: 50.6687932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019300',
        LOCATION_NAME: 'Portessie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9401003,
        LOCATION_LATITUDE_DEG: 57.6844774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019400',
        LOCATION_NAME: 'Porteynon',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.210151,
        LOCATION_LATITUDE_DEG: 51.5450658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019500',
        LOCATION_NAME: 'Portfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8416759,
        LOCATION_LATITUDE_DEG: 51.033832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019600',
        LOCATION_NAME: 'Portfield Gate',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0164023,
        LOCATION_LATITUDE_DEG: 51.7986321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019700',
        LOCATION_NAME: 'Portglenone',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4726397,
        LOCATION_LATITUDE_DEG: 54.8707373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019800',
        LOCATION_NAME: 'Portgordon',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0111429,
        LOCATION_LATITUDE_DEG: 57.664282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO019900',
        LOCATION_NAME: 'Portgower',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6837966,
        LOCATION_LATITUDE_DEG: 58.0990308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020100',
        LOCATION_NAME: 'Porth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.052293,
        LOCATION_LATITUDE_DEG: 50.4237938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020000',
        LOCATION_NAME: 'Porth',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4067665,
        LOCATION_LATITUDE_DEG: 51.6135942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020200',
        LOCATION_NAME: 'Porth Mellon',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3098378,
        LOCATION_LATITUDE_DEG: 49.915057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035000',
        LOCATION_NAME: 'Porth Y Felin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6406904,
        LOCATION_LATITUDE_DEG: 53.3175466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035100',
        LOCATION_NAME: 'Porth y Waen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020500',
        LOCATION_NAME: 'Porthallow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0793045,
        LOCATION_LATITUDE_DEG: 50.0672668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020600',
        LOCATION_NAME: 'Porthcawl',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.703975,
        LOCATION_LATITUDE_DEG: 51.4784881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020700',
        LOCATION_NAME: 'Porthcothan Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0202001,
        LOCATION_LATITUDE_DEG: 50.5076064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020800',
        LOCATION_NAME: 'Porthcressa',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3123237,
        LOCATION_LATITUDE_DEG: 49.9124626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020900',
        LOCATION_NAME: 'Porthdafarch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6446945,
        LOCATION_LATITUDE_DEG: 53.2902645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021000',
        LOCATION_NAME: 'Porthgain',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1791285,
        LOCATION_LATITUDE_DEG: 51.9471431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021100',
        LOCATION_NAME: 'Porthill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2176674,
        LOCATION_LATITUDE_DEG: 53.0365137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021200',
        LOCATION_NAME: 'Porthkea',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0691133,
        LOCATION_LATITUDE_DEG: 50.2455763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021300',
        LOCATION_NAME: 'Porthkerry',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3246593,
        LOCATION_LATITUDE_DEG: 51.3908745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021400',
        LOCATION_NAME: 'Porthleven',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.312841,
        LOCATION_LATITUDE_DEG: 50.0845653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021500',
        LOCATION_NAME: 'Porthmadog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1326603,
        LOCATION_LATITUDE_DEG: 52.9273292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021600',
        LOCATION_NAME: 'Porthpean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7691859,
        LOCATION_LATITUDE_DEG: 50.3209842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021700',
        LOCATION_NAME: 'Porthtowan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.236164,
        LOCATION_LATITUDE_DEG: 50.2816888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020300',
        LOCATION_NAME: 'Porth-Y-Felin',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6408977,
        LOCATION_LATITUDE_DEG: 53.3150691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021900',
        LOCATION_NAME: 'Porthyrhyd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1482603,
        LOCATION_LATITUDE_DEG: 51.822025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO021800',
        LOCATION_NAME: 'Porthyrhyd',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8792787,
        LOCATION_LATITUDE_DEG: 52.0231384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO020400',
        LOCATION_NAME: 'Porth-y-Waen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1003103,
        LOCATION_LATITUDE_DEG: 52.8039052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022000',
        LOCATION_NAME: 'Portincaple',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8414302,
        LOCATION_LATITUDE_DEG: 56.0994441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022100',
        LOCATION_NAME: 'Portington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8039723,
        LOCATION_LATITUDE_DEG: 53.7690723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022200',
        LOCATION_NAME: 'Portinscale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.161548,
        LOCATION_LATITUDE_DEG: 54.6026838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022300',
        LOCATION_NAME: 'Portishead',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7629074,
        LOCATION_LATITUDE_DEG: 51.4879731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022400',
        LOCATION_NAME: 'Portknockie',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8604716,
        LOCATION_LATITUDE_DEG: 57.7032988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022500',
        LOCATION_NAME: 'Portland',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4398542,
        LOCATION_LATITUDE_DEG: 50.5468794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022800',
        LOCATION_NAME: 'Portlethen',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.12755,
        LOCATION_LATITUDE_DEG: 57.0608103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022900',
        LOCATION_NAME: 'Portling',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7431088,
        LOCATION_LATITUDE_DEG: 54.8688096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023000',
        LOCATION_NAME: 'Portloe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.896943,
        LOCATION_LATITUDE_DEG: 50.2178727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023100',
        LOCATION_NAME: 'Portlooe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4686523,
        LOCATION_LATITUDE_DEG: 50.3468828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023300',
        LOCATION_NAME: 'Portmahomack',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8260265,
        LOCATION_LATITUDE_DEG: 57.8365097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023500',
        LOCATION_NAME: 'Portmead',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9770784,
        LOCATION_LATITUDE_DEG: 51.6497022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023600',
        LOCATION_NAME: 'Portmeirion',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0916497,
        LOCATION_LATITUDE_DEG: 52.91743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023700',
        LOCATION_NAME: 'Portmellon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7849223,
        LOCATION_LATITUDE_DEG: 50.2615832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023900',
        LOCATION_NAME: 'Portmore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0225982,
        LOCATION_LATITUDE_DEG: 51.0616482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023800',
        LOCATION_NAME: 'Portmore',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.521669,
        LOCATION_LATITUDE_DEG: 50.7722939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024000',
        LOCATION_NAME: 'Portnaguran',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.178618,
        LOCATION_LATITUDE_DEG: 58.244508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024100',
        LOCATION_NAME: 'Portnahaven',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5068249,
        LOCATION_LATITUDE_DEG: 55.6808211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024300',
        LOCATION_NAME: 'Portnaluchaig',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8580471,
        LOCATION_LATITUDE_DEG: 56.9364382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024500',
        LOCATION_NAME: 'Porton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7307542,
        LOCATION_LATITUDE_DEG: 51.1280313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024600',
        LOCATION_NAME: 'Porton Down',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7048765,
        LOCATION_LATITUDE_DEG: 51.131728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024700',
        LOCATION_NAME: 'Portpatrick',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.115684,
        LOCATION_LATITUDE_DEG: 54.8417231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024800',
        LOCATION_NAME: 'Portrack',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.300774,
        LOCATION_LATITUDE_DEG: 54.570716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025000',
        LOCATION_NAME: 'Portreath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2877639,
        LOCATION_LATITUDE_DEG: 50.2600858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025100',
        LOCATION_NAME: 'Portree',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1926054,
        LOCATION_LATITUDE_DEG: 57.4132875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025400',
        LOCATION_NAME: 'Portrush',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6627423,
        LOCATION_LATITUDE_DEG: 55.1989705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025600',
        LOCATION_NAME: 'Portscatho',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9739413,
        LOCATION_LATITUDE_DEG: 50.1789764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025700',
        LOCATION_NAME: 'Portsea',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1057398,
        LOCATION_LATITUDE_DEG: 50.798294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025800',
        LOCATION_NAME: 'Portskewett',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7198403,
        LOCATION_LATITUDE_DEG: 51.5904822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025900',
        LOCATION_NAME: 'Portslade',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.216365,
        LOCATION_LATITUDE_DEG: 50.8417813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034900',
        LOCATION_NAME: 'Portslade By Sea',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026000',
        LOCATION_NAME: 'Portslade-By-Sea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2058222,
        LOCATION_LATITUDE_DEG: 50.8325802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026100',
        LOCATION_NAME: 'Portsmouth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0893266,
        LOCATION_LATITUDE_DEG: 50.8008922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026200',
        LOCATION_NAME: 'Portsonachan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1589907,
        LOCATION_LATITUDE_DEG: 56.3380663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026300',
        LOCATION_NAME: 'Portsoy',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6907509,
        LOCATION_LATITUDE_DEG: 57.6816819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026400',
        LOCATION_NAME: 'Portstewart',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7179604,
        LOCATION_LATITUDE_DEG: 55.1822756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026500',
        LOCATION_NAME: 'Portswood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4024561,
        LOCATION_LATITUDE_DEG: 50.9181062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026800',
        LOCATION_NAME: 'Portvoller',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2591123,
        LOCATION_LATITUDE_DEG: 58.3041805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027100',
        LOCATION_NAME: 'Portway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8450433,
        LOCATION_LATITUDE_DEG: 51.0323328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027000',
        LOCATION_NAME: 'Portway',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7496352,
        LOCATION_LATITUDE_DEG: 52.3033528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026900',
        LOCATION_NAME: 'Portway',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7479675,
        LOCATION_LATITUDE_DEG: 52.1005304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027200',
        LOCATION_NAME: 'Portway',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8780853,
        LOCATION_LATITUDE_DEG: 52.3461473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027300',
        LOCATION_NAME: 'Portwrinkle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3102008,
        LOCATION_LATITUDE_DEG: 50.3610878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027400',
        LOCATION_NAME: 'Posbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6876751,
        LOCATION_LATITUDE_DEG: 50.7602178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027500',
        LOCATION_NAME: 'Posenhall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.507037,
        LOCATION_LATITUDE_DEG: 52.6110791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027600',
        LOCATION_NAME: 'Poslingford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5865311,
        LOCATION_LATITUDE_DEG: 52.1017887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027700',
        LOCATION_NAME: 'Possil Park',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2570456,
        LOCATION_LATITUDE_DEG: 55.8843143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027800',
        LOCATION_NAME: 'Postbridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8983724,
        LOCATION_LATITUDE_DEG: 50.595603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO027900',
        LOCATION_NAME: 'Postcombe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9733122,
        LOCATION_LATITUDE_DEG: 51.68987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028000',
        LOCATION_NAME: 'Postling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.066295,
        LOCATION_LATITUDE_DEG: 51.1102859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028100',
        LOCATION_NAME: 'Postwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3924416,
        LOCATION_LATITUDE_DEG: 52.6195264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028200',
        LOCATION_NAME: 'Potarch',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6467394,
        LOCATION_LATITUDE_DEG: 57.0625124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028300',
        LOCATION_NAME: 'Potcote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0380234,
        LOCATION_LATITUDE_DEG: 52.1684225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028400',
        LOCATION_NAME: 'Potford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.534005,
        LOCATION_LATITUDE_DEG: 52.792799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028500',
        LOCATION_NAME: 'Pothole',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8507905,
        LOCATION_LATITUDE_DEG: 50.3182818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028600',
        LOCATION_NAME: 'Potsgrove',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6186331,
        LOCATION_LATITUDE_DEG: 51.9650957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028700',
        LOCATION_NAME: 'Pott Row',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5271324,
        LOCATION_LATITUDE_DEG: 52.7670543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028800',
        LOCATION_NAME: 'Pott Shrigley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0830347,
        LOCATION_LATITUDE_DEG: 53.3097448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO028900',
        LOCATION_NAME: 'Potten End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5233233,
        LOCATION_LATITUDE_DEG: 51.7699764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029000',
        LOCATION_NAME: 'Potter Brompton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5005015,
        LOCATION_LATITUDE_DEG: 54.1804089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029100',
        LOCATION_NAME: 'Potter Heigham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5757647,
        LOCATION_LATITUDE_DEG: 52.7197339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029200',
        LOCATION_NAME: 'Potter Street',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.134407,
        LOCATION_LATITUDE_DEG: 51.757362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029300',
        LOCATION_NAME: 'Potterhanworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4214907,
        LOCATION_LATITUDE_DEG: 53.183806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029400',
        LOCATION_NAME: 'Potterne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0058848,
        LOCATION_LATITUDE_DEG: 51.3257538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO036300',
        LOCATION_NAME: 'Potternewton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5415631,
        LOCATION_LATITUDE_DEG: 53.8211207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029500',
        LOCATION_NAME: 'Potters Bar',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1771215,
        LOCATION_LATITUDE_DEG: 51.6918581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029600',
        LOCATION_NAME: 'Potters Crouch',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3842432,
        LOCATION_LATITUDE_DEG: 51.7338656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029700',
        LOCATION_NAME: 'Potters Marston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2651795,
        LOCATION_LATITUDE_DEG: 52.5624574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029800',
        LOCATION_NAME: 'Potterspury',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8878087,
        LOCATION_LATITUDE_DEG: 52.0805092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO029900',
        LOCATION_NAME: 'Potterspury Lodge',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9107147,
        LOCATION_LATITUDE_DEG: 52.0958117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030000',
        LOCATION_NAME: 'Potterton',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0927322,
        LOCATION_LATITUDE_DEG: 57.2296251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030100',
        LOCATION_NAME: 'Potterton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3854187,
        LOCATION_LATITUDE_DEG: 53.8448817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030200',
        LOCATION_NAME: 'Potto',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2691442,
        LOCATION_LATITUDE_DEG: 54.425837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030300',
        LOCATION_NAME: 'Potton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2131151,
        LOCATION_LATITUDE_DEG: 52.1272009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030400',
        LOCATION_NAME: 'Potton Island',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8180809,
        LOCATION_LATITUDE_DEG: 51.5705387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030600',
        LOCATION_NAME: 'Poughill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5256431,
        LOCATION_LATITUDE_DEG: 50.8409288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030500',
        LOCATION_NAME: 'Poughill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6228794,
        LOCATION_LATITUDE_DEG: 50.8633218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031200',
        LOCATION_NAME: 'Poulner',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7576797,
        LOCATION_LATITUDE_DEG: 50.8490007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031300',
        LOCATION_NAME: 'Poulshot',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0430005,
        LOCATION_LATITUDE_DEG: 51.3390553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031500',
        LOCATION_NAME: 'Poulton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9026268,
        LOCATION_LATITUDE_DEG: 53.1207291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031600',
        LOCATION_NAME: 'Poulton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8532052,
        LOCATION_LATITUDE_DEG: 51.7079866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031400',
        LOCATION_NAME: 'Poulton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7251975,
        LOCATION_LATITUDE_DEG: 51.4207545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034800',
        LOCATION_NAME: 'Poulton le Fylde',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031700',
        LOCATION_NAME: 'Poulton-le-Fylde',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9898171,
        LOCATION_LATITUDE_DEG: 53.8473082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031800',
        LOCATION_NAME: 'Pound Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1516978,
        LOCATION_LATITUDE_DEG: 51.121306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031900',
        LOCATION_NAME: 'Pound Pool',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7362676,
        LOCATION_LATITUDE_DEG: 51.0480337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032000',
        LOCATION_NAME: 'Poundbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4587563,
        LOCATION_LATITUDE_DEG: 50.7111971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032100',
        LOCATION_NAME: 'Poundbury Whitfield',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4634565,
        LOCATION_LATITUDE_DEG: 50.7209997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032200',
        LOCATION_NAME: 'Poundgate',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1315391,
        LOCATION_LATITUDE_DEG: 51.0390962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032300',
        LOCATION_NAME: 'Poundisford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1002094,
        LOCATION_LATITUDE_DEG: 50.9782259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032400',
        LOCATION_NAME: 'Poundon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0623352,
        LOCATION_LATITUDE_DEG: 51.9220946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032500',
        LOCATION_NAME: 'Pounds Hill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6504708,
        LOCATION_LATITUDE_DEG: 50.7922217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032600',
        LOCATION_NAME: 'Poundsgate',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8272587,
        LOCATION_LATITUDE_DEG: 50.5370958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032700',
        LOCATION_NAME: 'Poundstock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5488498,
        LOCATION_LATITUDE_DEG: 50.7662212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032800',
        LOCATION_NAME: 'Powburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9017379,
        LOCATION_LATITUDE_DEG: 55.4406453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO032900',
        LOCATION_NAME: 'Powder Mills',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2489536,
        LOCATION_LATITUDE_DEG: 51.2053088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033000',
        LOCATION_NAME: 'Powderham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4552675,
        LOCATION_LATITUDE_DEG: 50.6481059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033300',
        LOCATION_NAME: 'Powerstock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6851891,
        LOCATION_LATITUDE_DEG: 50.7631048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033500',
        LOCATION_NAME: 'Powfoot',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3290335,
        LOCATION_LATITUDE_DEG: 54.9794238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033600',
        LOCATION_NAME: 'Powick',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2448774,
        LOCATION_LATITUDE_DEG: 52.1609319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033700',
        LOCATION_NAME: 'Powis Castle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1577283,
        LOCATION_LATITUDE_DEG: 52.6457895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033800',
        LOCATION_NAME: 'Powke Hall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3081906,
        LOCATION_LATITUDE_DEG: 52.5355744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033900',
        LOCATION_NAME: 'Powmill',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5792415,
        LOCATION_LATITUDE_DEG: 56.1648366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO990472',
        LOCATION_NAME: 'Powntley Copse',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034000',
        LOCATION_NAME: 'Poxwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3643744,
        LOCATION_LATITUDE_DEG: 50.6561914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034100',
        LOCATION_NAME: 'Poyle',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5106541,
        LOCATION_LATITUDE_DEG: 51.4792434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034200',
        LOCATION_NAME: 'Poynings',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2019736,
        LOCATION_LATITUDE_DEG: 50.8938896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034300',
        LOCATION_NAME: 'Poyntington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4981371,
        LOCATION_LATITUDE_DEG: 50.9782259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034500',
        LOCATION_NAME: 'Poynton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6374189,
        LOCATION_LATITUDE_DEG: 52.7547973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034400',
        LOCATION_NAME: 'Poynton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1207452,
        LOCATION_LATITUDE_DEG: 53.3489438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034600',
        LOCATION_NAME: 'Poyntzfield',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1599506,
        LOCATION_LATITUDE_DEG: 57.6504921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO034700',
        LOCATION_NAME: 'Poyntzpass',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3844536,
        LOCATION_LATITUDE_DEG: 54.2933781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000100',
        LOCATION_NAME: 'Praa Sands',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.38463,
        LOCATION_LATITUDE_DEG: 50.1039692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000200',
        LOCATION_NAME: 'Pratts Bottom',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1130635,
        LOCATION_LATITUDE_DEG: 51.3397243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000300',
        LOCATION_NAME: 'Praze',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3082422,
        LOCATION_LATITUDE_DEG: 50.1699729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000400',
        LOCATION_NAME: 'Preens Eddy',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4416914,
        LOCATION_LATITUDE_DEG: 52.6151799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000500',
        LOCATION_NAME: 'Prees',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6640241,
        LOCATION_LATITUDE_DEG: 52.8973059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000600',
        LOCATION_NAME: 'Prees Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.651853,
        LOCATION_LATITUDE_DEG: 52.8808038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000700',
        LOCATION_NAME: 'Prees Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6584289,
        LOCATION_LATITUDE_DEG: 52.9352141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000800',
        LOCATION_NAME: 'Preesall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9647286,
        LOCATION_LATITUDE_DEG: 53.9178086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR000900',
        LOCATION_NAME: 'Preesgweene',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0470409,
        LOCATION_LATITUDE_DEG: 52.9183189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001000',
        LOCATION_NAME: 'Prehen Park',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3414336,
        LOCATION_LATITUDE_DEG: 54.944051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001100',
        LOCATION_NAME: 'Premnay',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6103427,
        LOCATION_LATITUDE_DEG: 57.3153407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001200',
        LOCATION_NAME: 'Prengwyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3019831,
        LOCATION_LATITUDE_DEG: 52.0712138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001300',
        LOCATION_NAME: 'Prenteg',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1049089,
        LOCATION_LATITUDE_DEG: 52.9509336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001400',
        LOCATION_NAME: 'Prenton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0376721,
        LOCATION_LATITUDE_DEG: 53.3712571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001500',
        LOCATION_NAME: 'Prescot',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8020218,
        LOCATION_LATITUDE_DEG: 53.4276595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001600',
        LOCATION_NAME: 'Prescott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2963285,
        LOCATION_LATITUDE_DEG: 50.9199306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001700',
        LOCATION_NAME: 'Prescott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8514545,
        LOCATION_LATITUDE_DEG: 52.7855963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001800',
        LOCATION_NAME: 'Press',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4619472,
        LOCATION_LATITUDE_DEG: 53.1871241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR001900',
        LOCATION_NAME: 'Prestatyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4049912,
        LOCATION_LATITUDE_DEG: 53.3351598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002000',
        LOCATION_NAME: 'Prestbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1504287,
        LOCATION_LATITUDE_DEG: 53.2882383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002100',
        LOCATION_NAME: 'Prestbury',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0394898,
        LOCATION_LATITUDE_DEG: 51.9128112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002200',
        LOCATION_NAME: 'Presteigne',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0051207,
        LOCATION_LATITUDE_DEG: 52.2730504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002300',
        LOCATION_NAME: 'Presthope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6116763,
        LOCATION_LATITUDE_DEG: 52.5713754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002400',
        LOCATION_NAME: 'Prestleigh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5229917,
        LOCATION_LATITUDE_DEG: 51.1614447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003400',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6113115,
        LOCATION_LATITUDE_DEG: 50.5596955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003700',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.56726,
        LOCATION_LATITUDE_DEG: 50.4494822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002600',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7020455,
        LOCATION_LATITUDE_DEG: 53.7574942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002700',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4692826,
        LOCATION_LATITUDE_DEG: 52.007421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003900',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4581335,
        LOCATION_LATITUDE_DEG: 52.73269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003300',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4268569,
        LOCATION_LATITUDE_DEG: 50.6440895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002500',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3338969,
        LOCATION_LATITUDE_DEG: 55.8088854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003600',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9489517,
        LOCATION_LATITUDE_DEG: 51.5007666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003950',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9323948,
        LOCATION_LATITUDE_DEG: 51.7062154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003200',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7052713,
        LOCATION_LATITUDE_DEG: 55.5219547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002800',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4509052,
        LOCATION_LATITUDE_DEG: 55.019696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003800',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7127919,
        LOCATION_LATITUDE_DEG: 52.6120576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003000',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2838923,
        LOCATION_LATITUDE_DEG: 51.908588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR002900',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1983992,
        LOCATION_LATITUDE_DEG: 53.7564563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003100',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1392063,
        LOCATION_LATITUDE_DEG: 50.8376799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR003500',
        LOCATION_NAME: 'Preston',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2292137,
        LOCATION_LATITUDE_DEG: 51.3026031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004000',
        LOCATION_NAME: 'Preston Bagot',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7463647,
        LOCATION_LATITUDE_DEG: 52.2894368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004100',
        LOCATION_NAME: 'Preston Bissett',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0424924,
        LOCATION_LATITUDE_DEG: 51.9620037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004200',
        LOCATION_NAME: 'Preston Brockhurst',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6867678,
        LOCATION_LATITUDE_DEG: 52.8190033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004300',
        LOCATION_NAME: 'Preston Brook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6491857,
        LOCATION_LATITUDE_DEG: 53.320854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004400',
        LOCATION_NAME: 'Preston Candover',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.132315,
        LOCATION_LATITUDE_DEG: 51.1700258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004500',
        LOCATION_NAME: 'Preston Capes',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.157745,
        LOCATION_LATITUDE_DEG: 52.1885263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004600',
        LOCATION_NAME: 'Preston Cross',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4735967,
        LOCATION_LATITUDE_DEG: 52.0158201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004700',
        LOCATION_NAME: 'Preston Crowmarsh',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1072937,
        LOCATION_LATITUDE_DEG: 51.6117673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004800',
        LOCATION_NAME: 'Preston Deanery',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8452864,
        LOCATION_LATITUDE_DEG: 52.1921224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR004900',
        LOCATION_NAME: 'Preston Grange',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4622998,
        LOCATION_LATITUDE_DEG: 55.0250044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005000',
        LOCATION_NAME: 'Preston Gubbals',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7531083,
        LOCATION_LATITUDE_DEG: 52.7710939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005600',
        LOCATION_NAME: 'Preston le Skerne',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5266678,
        LOCATION_LATITUDE_DEG: 54.6103596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005100',
        LOCATION_NAME: 'Preston Montford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8405888,
        LOCATION_LATITUDE_DEG: 52.7226929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005700',
        LOCATION_NAME: 'Preston on Stour',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7015339,
        LOCATION_LATITUDE_DEG: 52.1463232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005800',
        LOCATION_NAME: 'Preston on the Hill',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6438976,
        LOCATION_LATITUDE_DEG: 53.3216468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR011300',
        LOCATION_NAME: 'Preston on Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005200',
        LOCATION_NAME: 'Preston Park',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1453097,
        LOCATION_LATITUDE_DEG: 50.8395849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005300',
        LOCATION_NAME: 'Preston Patrick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6988601,
        LOCATION_LATITUDE_DEG: 54.2475433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR011200',
        LOCATION_NAME: 'Preston St Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005400',
        LOCATION_NAME: 'Preston St. Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.841644,
        LOCATION_LATITUDE_DEG: 52.115888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR990657',
        LOCATION_NAME: 'Preston under Scar',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005500',
        LOCATION_NAME: 'Preston Wynne',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6458648,
        LOCATION_LATITUDE_DEG: 52.1198367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006000',
        LOCATION_NAME: 'Prestonfield',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1615506,
        LOCATION_LATITUDE_DEG: 55.9334136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006100',
        LOCATION_NAME: 'Prestonhall',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9817927,
        LOCATION_LATITUDE_DEG: 55.882407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR005900',
        LOCATION_NAME: 'Preston-on-Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9031383,
        LOCATION_LATITUDE_DEG: 52.0755075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006200',
        LOCATION_NAME: 'Prestonpans',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9788112,
        LOCATION_LATITUDE_DEG: 55.9602076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006300',
        LOCATION_NAME: 'Prestwich',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.272338,
        LOCATION_LATITUDE_DEG: 53.5284678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006400',
        LOCATION_NAME: 'Prestwick',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6112996,
        LOCATION_LATITUDE_DEG: 55.4968843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006500',
        LOCATION_NAME: 'Prestwick',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7141635,
        LOCATION_LATITUDE_DEG: 55.0456104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006600',
        LOCATION_NAME: 'Prestwold',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1470442,
        LOCATION_LATITUDE_DEG: 52.7910789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006800',
        LOCATION_NAME: 'Prestwood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8489393,
        LOCATION_LATITUDE_DEG: 52.9776051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006700',
        LOCATION_NAME: 'Prestwood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.741667,
        LOCATION_LATITUDE_DEG: 51.6976708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR006900',
        LOCATION_NAME: 'Prickwillow',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3489358,
        LOCATION_LATITUDE_DEG: 52.4165274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007000',
        LOCATION_NAME: 'Priddy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7653753,
        LOCATION_LATITUDE_DEG: 51.2495556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007100',
        LOCATION_NAME: 'Priest Hutton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7188438,
        LOCATION_LATITUDE_DEG: 54.1574317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007200',
        LOCATION_NAME: 'Priest Weston',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0454471,
        LOCATION_LATITUDE_DEG: 52.568484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007300',
        LOCATION_NAME: 'Priestcliffe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.788713,
        LOCATION_LATITUDE_DEG: 53.2443296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007400',
        LOCATION_NAME: 'Priestcliffe Ditch',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8053977,
        LOCATION_LATITUDE_DEG: 53.243432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007500',
        LOCATION_NAME: 'Priesthill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3590236,
        LOCATION_LATITUDE_DEG: 55.8167117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007600',
        LOCATION_NAME: 'Priestland',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2586978,
        LOCATION_LATITUDE_DEG: 55.6108935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007700',
        LOCATION_NAME: 'Primmers Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3398224,
        LOCATION_LATITUDE_DEG: 51.0682916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR011400',
        LOCATION_NAME: 'Primrose',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9190896,
        LOCATION_LATITUDE_DEG: 52.4029437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007800',
        LOCATION_NAME: 'Primrose Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7821963,
        LOCATION_LATITUDE_DEG: 53.6353732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR007900',
        LOCATION_NAME: 'Primrose Valley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2832233,
        LOCATION_LATITUDE_DEG: 54.1888075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008000',
        LOCATION_NAME: 'Primsland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1402394,
        LOCATION_LATITUDE_DEG: 52.2540382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008100',
        LOCATION_NAME: 'Prince Rock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1157146,
        LOCATION_LATITUDE_DEG: 50.3688829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008200',
        LOCATION_NAME: 'Princes End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0639545,
        LOCATION_LATITUDE_DEG: 52.5407685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008300',
        LOCATION_NAME: 'Princes Gate',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7040622,
        LOCATION_LATITUDE_DEG: 51.7814197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008400',
        LOCATION_NAME: 'Princes Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9501485,
        LOCATION_LATITUDE_DEG: 53.3905592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008500',
        LOCATION_NAME: 'Princes Risborough',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8307096,
        LOCATION_LATITUDE_DEG: 51.725173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008600',
        LOCATION_NAME: 'Princethorpe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4091149,
        LOCATION_LATITUDE_DEG: 52.3328373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008700',
        LOCATION_NAME: 'Princetown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9892374,
        LOCATION_LATITUDE_DEG: 50.5435974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008800',
        LOCATION_NAME: 'Prinsted',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9113012,
        LOCATION_LATITUDE_DEG: 50.8434905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR008900',
        LOCATION_NAME: 'Prion',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4195675,
        LOCATION_LATITUDE_DEG: 53.1483417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009000',
        LOCATION_NAME: 'Prior Fen',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2768604,
        LOCATION_LATITUDE_DEG: 52.2904172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009100',
        LOCATION_NAME: 'Prior Muir',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7618726,
        LOCATION_LATITUDE_DEG: 56.3101478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009200',
        LOCATION_NAME: 'Priors Dean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9660055,
        LOCATION_LATITUDE_DEG: 51.0546105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009300',
        LOCATION_NAME: 'Priors Frome',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6188665,
        LOCATION_LATITUDE_DEG: 52.0467258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009400',
        LOCATION_NAME: 'Priors Halton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7465083,
        LOCATION_LATITUDE_DEG: 52.3720581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009500',
        LOCATION_NAME: 'Priors Hardwick',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3121697,
        LOCATION_LATITUDE_DEG: 52.1994273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009600',
        LOCATION_NAME: 'Priors Marston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2847152,
        LOCATION_LATITUDE_DEG: 52.2114297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009800',
        LOCATION_NAME: 'Priorswood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.079308,
        LOCATION_LATITUDE_DEG: 51.0297384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009900',
        LOCATION_NAME: 'Prisk',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4170076,
        LOCATION_LATITUDE_DEG: 51.4784852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010000',
        LOCATION_NAME: 'Priston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4393588,
        LOCATION_LATITUDE_DEG: 51.3426548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010100',
        LOCATION_NAME: 'Prittlewell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6953187,
        LOCATION_LATITUDE_DEG: 51.5522328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010200',
        LOCATION_NAME: 'Privett',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0356219,
        LOCATION_LATITUDE_DEG: 51.0377134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010300',
        LOCATION_NAME: 'Prixford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0734012,
        LOCATION_LATITUDE_DEG: 51.1115491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010400',
        LOCATION_NAME: 'Probus',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9497938,
        LOCATION_LATITUDE_DEG: 50.2921853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010500',
        LOCATION_NAME: 'Prolly Moor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8916461,
        LOCATION_LATITUDE_DEG: 52.5343797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010600',
        LOCATION_NAME: 'Promised Land',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1914166,
        LOCATION_LATITUDE_DEG: 50.3049877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010700',
        LOCATION_NAME: 'Prospect',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3737273,
        LOCATION_LATITUDE_DEG: 54.7538965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010900',
        LOCATION_NAME: 'Prospidnick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2918384,
        LOCATION_LATITUDE_DEG: 50.1320752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR011000',
        LOCATION_NAME: 'Providence Hill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7378245,
        LOCATION_LATITUDE_DEG: 51.7872218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR011100',
        LOCATION_NAME: 'Prudhoe',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8489618,
        LOCATION_LATITUDE_DEG: 54.9614981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000100',
        LOCATION_NAME: 'Publow',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5319442,
        LOCATION_LATITUDE_DEG: 51.3662638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000300',
        LOCATION_NAME: 'Puckeridge',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0155906,
        LOCATION_LATITUDE_DEG: 51.894279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000400',
        LOCATION_NAME: 'Puckington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8869996,
        LOCATION_LATITUDE_DEG: 50.9588237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000500',
        LOCATION_NAME: 'Pucklechurch',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4327533,
        LOCATION_LATITUDE_DEG: 51.4857711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU990777',
        LOCATION_NAME: 'Puckshipton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000600',
        LOCATION_NAME: 'Puddington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9987905,
        LOCATION_LATITUDE_DEG: 50.8828345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000700',
        LOCATION_NAME: 'Puddington',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0074535,
        LOCATION_LATITUDE_DEG: 53.2531518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000800',
        LOCATION_NAME: 'Puddletown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3449052,
        LOCATION_LATITUDE_DEG: 50.7486976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000900',
        LOCATION_NAME: 'Pudleston',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6361612,
        LOCATION_LATITUDE_DEG: 52.2343436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001000',
        LOCATION_NAME: 'Pudsey',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6614311,
        LOCATION_LATITUDE_DEG: 53.7963855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001100',
        LOCATION_NAME: 'Pulborough',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.50046,
        LOCATION_LATITUDE_DEG: 50.9569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001200',
        LOCATION_NAME: 'Puleston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3936998,
        LOCATION_LATITUDE_DEG: 52.7977978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001300',
        LOCATION_NAME: 'Pulford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9335988,
        LOCATION_LATITUDE_DEG: 53.1224322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001400',
        LOCATION_NAME: 'Pulham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4187425,
        LOCATION_LATITUDE_DEG: 50.8734132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001500',
        LOCATION_NAME: 'Pulham Market',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2304128,
        LOCATION_LATITUDE_DEG: 52.4307112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU005300',
        LOCATION_NAME: 'Pulham St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001600',
        LOCATION_NAME: 'Pulham St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2547871,
        LOCATION_LATITUDE_DEG: 52.4196082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001700',
        LOCATION_NAME: 'Pull Woods',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.986791,
        LOCATION_LATITUDE_DEG: 54.4088629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001900',
        LOCATION_NAME: 'Pulley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7683112,
        LOCATION_LATITUDE_DEG: 52.6813936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002000',
        LOCATION_NAME: 'Pulloxhill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4533272,
        LOCATION_LATITUDE_DEG: 51.993498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002100',
        LOCATION_NAME: 'Pulverbatch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8500598,
        LOCATION_LATITUDE_DEG: 52.6156867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002200',
        LOCATION_NAME: 'Pumpherston',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4914123,
        LOCATION_LATITUDE_DEG: 55.9080144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002300',
        LOCATION_NAME: 'Pumpsaint',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9608869,
        LOCATION_LATITUDE_DEG: 52.048544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002400',
        LOCATION_NAME: 'Puncheston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8987381,
        LOCATION_LATITUDE_DEG: 51.9299391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002500',
        LOCATION_NAME: 'Puncknowle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6540242,
        LOCATION_LATITUDE_DEG: 50.6942022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002600',
        LOCATION_NAME: 'Punnetts Town',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3146154,
        LOCATION_LATITUDE_DEG: 50.9595881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002700',
        LOCATION_NAME: 'Purbrook',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0445374,
        LOCATION_LATITUDE_DEG: 50.865496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002800',
        LOCATION_NAME: 'Purbrook Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.057613,
        LOCATION_LATITUDE_DEG: 50.8696945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002900',
        LOCATION_NAME: 'Purdis Farm',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.232139,
        LOCATION_LATITUDE_DEG: 52.0390776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003000',
        LOCATION_NAME: 'Purfleet-on-Thames',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2397405,
        LOCATION_LATITUDE_DEG: 51.4799363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003100',
        LOCATION_NAME: 'Puriton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9693991,
        LOCATION_LATITUDE_DEG: 51.1681479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003200',
        LOCATION_NAME: 'Purleigh',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6610387,
        LOCATION_LATITUDE_DEG: 51.6865487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003300',
        LOCATION_NAME: 'Purley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1156656,
        LOCATION_LATITUDE_DEG: 51.3384298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003400',
        LOCATION_NAME: 'Purley on Thames',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0462582,
        LOCATION_LATITUDE_DEG: 51.4784559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003500',
        LOCATION_NAME: 'Purlogue',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0522529,
        LOCATION_LATITUDE_DEG: 52.3877685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003600',
        LOCATION_NAME: 'Purse Caundle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4317949,
        LOCATION_LATITUDE_DEG: 50.9553231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003700',
        LOCATION_NAME: 'Purshall Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1473973,
        LOCATION_LATITUDE_DEG: 52.3404538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003800',
        LOCATION_NAME: 'Purslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9411264,
        LOCATION_LATITUDE_DEG: 52.421767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU003900',
        LOCATION_NAME: 'Purston Jaglin',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.349186,
        LOCATION_LATITUDE_DEG: 53.6727713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004000',
        LOCATION_NAME: 'Purtington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.865792,
        LOCATION_LATITUDE_DEG: 50.8758189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004200',
        LOCATION_NAME: 'Purton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4465912,
        LOCATION_LATITUDE_DEG: 51.7355911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004100',
        LOCATION_NAME: 'Purton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8648522,
        LOCATION_LATITUDE_DEG: 51.5879715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004300',
        LOCATION_NAME: 'Purton Stoke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8656417,
        LOCATION_LATITUDE_DEG: 51.6139783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004400',
        LOCATION_NAME: 'Pury End',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9641034,
        LOCATION_LATITUDE_DEG: 52.1041159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004500',
        LOCATION_NAME: 'Pusey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4839711,
        LOCATION_LATITUDE_DEG: 51.6674779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004600',
        LOCATION_NAME: 'Putford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3194197,
        LOCATION_LATITUDE_DEG: 50.9216423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004700',
        LOCATION_NAME: 'Putley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.521265,
        LOCATION_LATITUDE_DEG: 52.0358233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU005400',
        LOCATION_NAME: 'Putney',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2165029,
        LOCATION_LATITUDE_DEG: 51.4634733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004800',
        LOCATION_NAME: 'Putsborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2157033,
        LOCATION_LATITUDE_DEG: 51.1440617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU005000',
        LOCATION_NAME: 'Puttenham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7156591,
        LOCATION_LATITUDE_DEG: 51.8228816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU004900',
        LOCATION_NAME: 'Puttenham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.666104,
        LOCATION_LATITUDE_DEG: 51.2214252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU005100',
        LOCATION_NAME: 'Puxey',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3329314,
        LOCATION_LATITUDE_DEG: 50.9131169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU005200',
        LOCATION_NAME: 'Puxley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8969089,
        LOCATION_LATITUDE_DEG: 52.0719084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000100',
        LOCATION_NAME: 'Pwll',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1947569,
        LOCATION_LATITUDE_DEG: 51.6869088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000200',
        LOCATION_NAME: 'Pwll trap',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5174708,
        LOCATION_LATITUDE_DEG: 51.820067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000300',
        LOCATION_NAME: 'Pwllcrochan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0075227,
        LOCATION_LATITUDE_DEG: 51.6837145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000400',
        LOCATION_NAME: 'Pwlldu',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0603888,
        LOCATION_LATITUDE_DEG: 51.568199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000500',
        LOCATION_NAME: 'Pwllglas',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.317515,
        LOCATION_LATITUDE_DEG: 53.0818326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000600',
        LOCATION_NAME: 'Pwllgloyw',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4104264,
        LOCATION_LATITUDE_DEG: 51.9925288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000700',
        LOCATION_NAME: 'Pwllgwaun',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3475172,
        LOCATION_LATITUDE_DEG: 51.6024906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000800',
        LOCATION_NAME: 'Pwllheli',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4243221,
        LOCATION_LATITUDE_DEG: 52.8869237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW000900',
        LOCATION_NAME: 'Pwllmeyric',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7013002,
        LOCATION_LATITUDE_DEG: 51.62589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PW001000',
        LOCATION_NAME: 'Pwllypant',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2257995,
        LOCATION_LATITUDE_DEG: 51.5898859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000100',
        LOCATION_NAME: 'Pye Bridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3395777,
        LOCATION_LATITUDE_DEG: 53.0709128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY001200',
        LOCATION_NAME: 'Pyebank',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4649974,
        LOCATION_LATITUDE_DEG: 53.3939232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000200',
        LOCATION_NAME: 'Pyecombe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1622028,
        LOCATION_LATITUDE_DEG: 50.8955187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000300',
        LOCATION_NAME: 'Pyle',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.691996,
        LOCATION_LATITUDE_DEG: 51.528386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000400',
        LOCATION_NAME: 'Pyles Thorne',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2181122,
        LOCATION_LATITUDE_DEG: 50.9738271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000500',
        LOCATION_NAME: 'Pylle',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5576865,
        LOCATION_LATITUDE_DEG: 51.142237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000600',
        LOCATION_NAME: 'Pymoor',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2028561,
        LOCATION_LATITUDE_DEG: 52.4548259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000700',
        LOCATION_NAME: 'Pymore',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7532927,
        LOCATION_LATITUDE_DEG: 50.7477011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000800',
        LOCATION_NAME: 'Pyrford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5203077,
        LOCATION_LATITUDE_DEG: 51.325436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY000900',
        LOCATION_NAME: 'Pyrton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0051865,
        LOCATION_LATITUDE_DEG: 51.6568718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY001000',
        LOCATION_NAME: 'Pytchley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7376271,
        LOCATION_LATITUDE_DEG: 52.3634296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PY001100',
        LOCATION_NAME: 'Pyworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3919793,
        LOCATION_LATITUDE_DEG: 50.8002283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000100',
        LOCATION_NAME: 'Quadring',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1802083,
        LOCATION_LATITUDE_DEG: 52.8813721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000200',
        LOCATION_NAME: 'Quadring Eaudyke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.146058,
        LOCATION_LATITUDE_DEG: 52.8815721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000300',
        LOCATION_NAME: 'Quadring Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2506635,
        LOCATION_LATITUDE_DEG: 52.8805787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000400',
        LOCATION_NAME: 'Quainton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9154101,
        LOCATION_LATITUDE_DEG: 51.873587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000600',
        LOCATION_NAME: 'Quakers Yard',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3320125,
        LOCATION_LATITUDE_DEG: 51.666301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000700',
        LOCATION_NAME: 'Quaking Houses',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7063281,
        LOCATION_LATITUDE_DEG: 54.8519865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000800',
        LOCATION_NAME: 'Quarff',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2481434,
        LOCATION_LATITUDE_DEG: 60.1003969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000900',
        LOCATION_NAME: 'Quarley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6082357,
        LOCATION_LATITUDE_DEG: 51.1897373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001000',
        LOCATION_NAME: 'Quarmby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8275007,
        LOCATION_LATITUDE_DEG: 53.6491736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001100',
        LOCATION_NAME: 'Quarndon',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.501422,
        LOCATION_LATITUDE_DEG: 52.9655976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001200',
        LOCATION_NAME: 'Quarnford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9597257,
        LOCATION_LATITUDE_DEG: 53.2008281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001300',
        LOCATION_NAME: 'Quarr',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3331352,
        LOCATION_LATITUDE_DEG: 51.0332225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001400',
        LOCATION_NAME: 'Quarrendon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8673677,
        LOCATION_LATITUDE_DEG: 51.8515886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001500',
        LOCATION_NAME: "Quarrier'S Homes",
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6162164,
        LOCATION_LATITUDE_DEG: 55.866217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006800',
        LOCATION_NAME: 'Quarriers Village',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001600',
        LOCATION_NAME: "Quarrier's Village",
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5994547,
        LOCATION_LATITUDE_DEG: 55.8601179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001700',
        LOCATION_NAME: 'Quarrington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4305387,
        LOCATION_LATITUDE_DEG: 52.9865905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001800',
        LOCATION_NAME: 'Quarrington Hill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4764166,
        LOCATION_LATITUDE_DEG: 54.7311738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU001900',
        LOCATION_NAME: 'Quarry',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6229741,
        LOCATION_LATITUDE_DEG: 57.2088642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002000',
        LOCATION_NAME: 'Quarry Bank',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1031075,
        LOCATION_LATITUDE_DEG: 52.4721577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002100',
        LOCATION_NAME: 'Quarry Ffinant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4650045,
        LOCATION_LATITUDE_DEG: 52.0331459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002200',
        LOCATION_NAME: 'Quarry Wood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.475134,
        LOCATION_LATITUDE_DEG: 51.2868113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002300',
        LOCATION_NAME: 'Quarter',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0298816,
        LOCATION_LATITUDE_DEG: 55.738403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002400',
        LOCATION_NAME: 'Quatford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3854834,
        LOCATION_LATITUDE_DEG: 52.5138685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002500',
        LOCATION_NAME: 'Quatt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3604047,
        LOCATION_LATITUDE_DEG: 52.4909665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002600',
        LOCATION_NAME: 'Quay',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1594077,
        LOCATION_LATITUDE_DEG: 57.7229291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002700',
        LOCATION_NAME: 'Quebec',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7182732,
        LOCATION_LATITUDE_DEG: 54.7874844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002800',
        LOCATION_NAME: 'Quedgeley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2763251,
        LOCATION_LATITUDE_DEG: 51.8224029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU002900',
        LOCATION_NAME: 'Queen Adelaide',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3021398,
        LOCATION_LATITUDE_DEG: 52.4084282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003000',
        LOCATION_NAME: 'Queen Bower',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1928456,
        LOCATION_LATITUDE_DEG: 50.6581751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003100',
        LOCATION_NAME: 'Queen Camel',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5759546,
        LOCATION_LATITUDE_DEG: 51.0201281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003200',
        LOCATION_NAME: 'Queen Charlton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5262485,
        LOCATION_LATITUDE_DEG: 51.4007678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003300',
        LOCATION_NAME: 'Queen Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4129553,
        LOCATION_LATITUDE_DEG: 51.1820092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003400',
        LOCATION_NAME: 'Queen Victoria School',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9487247,
        LOCATION_LATITUDE_DEG: 56.2005453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003500',
        LOCATION_NAME: 'Queenborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.749635,
        LOCATION_LATITUDE_DEG: 51.4152214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003600',
        LOCATION_NAME: 'Queens Head',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9826965,
        LOCATION_LATITUDE_DEG: 52.835677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU007000',
        LOCATION_NAME: 'Queens Island',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9042917,
        LOCATION_LATITUDE_DEG: 54.6069026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003700',
        LOCATION_NAME: 'Queens Nympton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8213786,
        LOCATION_LATITUDE_DEG: 50.9893348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU007100',
        LOCATION_NAME: 'Queens Park',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2680215,
        LOCATION_LATITUDE_DEG: 55.8312059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003900',
        LOCATION_NAME: 'Queensbury',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8457677,
        LOCATION_LATITUDE_DEG: 53.7679813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004000',
        LOCATION_NAME: 'Queensferry',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0221035,
        LOCATION_LATITUDE_DEG: 53.2061428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004100',
        LOCATION_NAME: 'Queenzieburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0899451,
        LOCATION_LATITUDE_DEG: 55.9726251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004200',
        LOCATION_NAME: 'Quendale',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3356852,
        LOCATION_LATITUDE_DEG: 59.9032788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004300',
        LOCATION_NAME: 'Quendon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2016389,
        LOCATION_LATITUDE_DEG: 51.9495814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004400',
        LOCATION_NAME: 'Queniborough',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0425013,
        LOCATION_LATITUDE_DEG: 52.7037706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004500',
        LOCATION_NAME: 'Quenington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7893608,
        LOCATION_LATITUDE_DEG: 51.73599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004600',
        LOCATION_NAME: 'Quernmore',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.737332,
        LOCATION_LATITUDE_DEG: 54.037724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004700',
        LOCATION_NAME: 'Quernmore Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.737422,
        LOCATION_LATITUDE_DEG: 54.0609237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004900',
        LOCATION_NAME: 'Quethiock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3744813,
        LOCATION_LATITUDE_DEG: 50.4570984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006900',
        LOCATION_NAME: 'Quex Park',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3202914,
        LOCATION_LATITUDE_DEG: 51.367812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005000',
        LOCATION_NAME: 'Quidenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9848462,
        LOCATION_LATITUDE_DEG: 52.4483141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005100',
        LOCATION_NAME: 'Quidhampton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8470278,
        LOCATION_LATITUDE_DEG: 51.0778257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005200',
        LOCATION_NAME: 'Quidinish',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8870037,
        LOCATION_LATITUDE_DEG: 57.7781342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005500',
        LOCATION_NAME: 'Quina Brook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7076395,
        LOCATION_LATITUDE_DEG: 52.8915069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005800',
        LOCATION_NAME: 'Quinta',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0760543,
        LOCATION_LATITUDE_DEG: 52.9162166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006000',
        LOCATION_NAME: 'Quinton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0188252,
        LOCATION_LATITUDE_DEG: 52.458355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005900',
        LOCATION_NAME: 'Quinton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8635655,
        LOCATION_LATITUDE_DEG: 52.1816175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006100',
        LOCATION_NAME: 'Quintrell Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0273996,
        LOCATION_LATITUDE_DEG: 50.4028981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006200',
        LOCATION_NAME: 'Quoisley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6695938,
        LOCATION_LATITUDE_DEG: 53.0068234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006300',
        LOCATION_NAME: 'Quoisley Bridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6858081,
        LOCATION_LATITUDE_DEG: 53.012323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006400',
        LOCATION_NAME: 'Quoit',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9227481,
        LOCATION_LATITUDE_DEG: 50.4205915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006500',
        LOCATION_NAME: 'Quorn',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1683895,
        LOCATION_LATITUDE_DEG: 52.74268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006600',
        LOCATION_NAME: 'Quothquan',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5975377,
        LOCATION_LATITUDE_DEG: 55.6390846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU006700',
        LOCATION_NAME: 'Quoyloo',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3115656,
        LOCATION_LATITUDE_DEG: 59.0700242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000100',
        LOCATION_NAME: 'Rabley Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.215052,
        LOCATION_LATITUDE_DEG: 51.8548741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000200',
        LOCATION_NAME: 'Raby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0314195,
        LOCATION_LATITUDE_DEG: 53.3121563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000300',
        LOCATION_NAME: 'Raby Mere',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0393959,
        LOCATION_LATITUDE_DEG: 53.3105228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000400',
        LOCATION_NAME: 'Rachub',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0616565,
        LOCATION_LATITUDE_DEG: 53.1933536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000500',
        LOCATION_NAME: 'Rackenford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.63206,
        LOCATION_LATITUDE_DEG: 50.9495378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000600',
        LOCATION_NAME: 'Rackham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5053591,
        LOCATION_LATITUDE_DEG: 50.9164898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000700',
        LOCATION_NAME: 'Rackheath',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.373326,
        LOCATION_LATITUDE_DEG: 52.6749326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000800',
        LOCATION_NAME: 'Racks',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5139656,
        LOCATION_LATITUDE_DEG: 55.0539322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001000',
        LOCATION_NAME: 'Racolpa',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2030279,
        LOCATION_LATITUDE_DEG: 54.6207675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA000900',
        LOCATION_NAME: 'Racton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.885798,
        LOCATION_LATITUDE_DEG: 50.8740897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001100',
        LOCATION_NAME: 'Radbourne',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5779651,
        LOCATION_LATITUDE_DEG: 52.9222008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001200',
        LOCATION_NAME: 'Radbourne Common',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5663049,
        LOCATION_LATITUDE_DEG: 52.9308974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001300',
        LOCATION_NAME: 'Radcliffe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3118856,
        LOCATION_LATITUDE_DEG: 53.5495683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001400',
        LOCATION_NAME: 'Radcliffe',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5770837,
        LOCATION_LATITUDE_DEG: 55.3154336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025700',
        LOCATION_NAME: 'Radcliffe on Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001500',
        LOCATION_NAME: 'Radcliffe-on-Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0313149,
        LOCATION_LATITUDE_DEG: 52.9411906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001600',
        LOCATION_NAME: 'Radclive',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0133237,
        LOCATION_LATITUDE_DEG: 51.9997006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001700',
        LOCATION_NAME: 'Radcot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5864671,
        LOCATION_LATITUDE_DEG: 51.6949772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001800',
        LOCATION_NAME: 'Raddington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3987351,
        LOCATION_LATITUDE_DEG: 51.0162332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA001900',
        LOCATION_NAME: 'Radernie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8618564,
        LOCATION_LATITUDE_DEG: 56.2770451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002000',
        LOCATION_NAME: 'Radford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9879582,
        LOCATION_LATITUDE_DEG: 52.1947326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002100',
        LOCATION_NAME: 'Radford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4060893,
        LOCATION_LATITUDE_DEG: 51.9121018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002200',
        LOCATION_NAME: 'Radford Semele',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4938655,
        LOCATION_LATITUDE_DEG: 52.2771336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002300',
        LOCATION_NAME: 'Radipole',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4767056,
        LOCATION_LATITUDE_DEG: 50.6275903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002400',
        LOCATION_NAME: 'Radlett',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3150657,
        LOCATION_LATITUDE_DEG: 51.682164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002600',
        LOCATION_NAME: 'Radley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4653386,
        LOCATION_LATITUDE_DEG: 51.4268536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002500',
        LOCATION_NAME: 'Radley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2394683,
        LOCATION_LATITUDE_DEG: 51.6868768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002700',
        LOCATION_NAME: 'Radley Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3486761,
        LOCATION_LATITUDE_DEG: 51.722461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002800',
        LOCATION_NAME: 'Radnage',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.867832,
        LOCATION_LATITUDE_DEG: 51.6673723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA002900',
        LOCATION_NAME: 'Radstock',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4472011,
        LOCATION_LATITUDE_DEG: 51.291249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003000',
        LOCATION_NAME: 'Radstone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1459084,
        LOCATION_LATITUDE_DEG: 52.0602092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003100',
        LOCATION_NAME: 'Radway',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4569492,
        LOCATION_LATITUDE_DEG: 52.131118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003200',
        LOCATION_NAME: 'Radway Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3343939,
        LOCATION_LATITUDE_DEG: 53.0850235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003300',
        LOCATION_NAME: 'Radwell',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5301674,
        LOCATION_LATITUDE_DEG: 52.2058194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003400',
        LOCATION_NAME: 'Radwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2047099,
        LOCATION_LATITUDE_DEG: 52.0068946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003500',
        LOCATION_NAME: 'Radwinter',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3413967,
        LOCATION_LATITUDE_DEG: 52.0105854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003600',
        LOCATION_NAME: 'Radyr',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2503688,
        LOCATION_LATITUDE_DEG: 51.5150845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003700',
        LOCATION_NAME: 'Raemoir',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4984349,
        LOCATION_LATITUDE_DEG: 57.0834138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003750',
        LOCATION_NAME: 'Raf Coltishall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3398122,
        LOCATION_LATITUDE_DEG: 52.7627356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003800',
        LOCATION_NAME: 'Raf Coningsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.170913,
        LOCATION_LATITUDE_DEG: 53.0972948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA003900',
        LOCATION_NAME: 'Raf Croughton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1857879,
        LOCATION_LATITUDE_DEG: 51.9962083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004000',
        LOCATION_NAME: 'Raf Daws Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7214648,
        LOCATION_LATITUDE_DEG: 51.618559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004100',
        LOCATION_NAME: 'Raf Honington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7552567,
        LOCATION_LATITUDE_DEG: 52.3431131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004200',
        LOCATION_NAME: 'Raf Lakenheath',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5665981,
        LOCATION_LATITUDE_DEG: 52.4073238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004300',
        LOCATION_NAME: 'Raf Mildenhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4838966,
        LOCATION_LATITUDE_DEG: 52.359718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004400',
        LOCATION_NAME: 'Raffin',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3762122,
        LOCATION_LATITUDE_DEG: 58.23566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004500',
        LOCATION_NAME: 'Rafford',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.573052,
        LOCATION_LATITUDE_DEG: 57.588479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004700',
        LOCATION_NAME: 'Ragdale',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0194968,
        LOCATION_LATITUDE_DEG: 52.771878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004800',
        LOCATION_NAME: 'Ragdon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7988558,
        LOCATION_LATITUDE_DEG: 52.5179771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004900',
        LOCATION_NAME: 'Raggalds',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8671919,
        LOCATION_LATITUDE_DEG: 53.7775803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005000',
        LOCATION_NAME: 'Ragged Appleshaw',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5542548,
        LOCATION_LATITUDE_DEG: 51.2371351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005100',
        LOCATION_NAME: 'Raglan',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8507584,
        LOCATION_LATITUDE_DEG: 51.7644019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005200',
        LOCATION_NAME: 'Ragnall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.795496,
        LOCATION_LATITUDE_DEG: 53.2551176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006500',
        LOCATION_NAME: 'RAIGMORE',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1897158,
        LOCATION_LATITUDE_DEG: 57.475278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006600',
        LOCATION_NAME: 'Rainford',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7822934,
        LOCATION_LATITUDE_DEG: 53.5024682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006800',
        LOCATION_NAME: 'Rainham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1916872,
        LOCATION_LATITUDE_DEG: 51.5180437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006700',
        LOCATION_NAME: 'Rainham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6100519,
        LOCATION_LATITUDE_DEG: 51.3628184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006900',
        LOCATION_NAME: 'Rainhill',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7611472,
        LOCATION_LATITUDE_DEG: 53.4153592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007000',
        LOCATION_NAME: 'Rainow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0736487,
        LOCATION_LATITUDE_DEG: 53.280741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007100',
        LOCATION_NAME: 'Rainton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4329548,
        LOCATION_LATITUDE_DEG: 54.1713205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007200',
        LOCATION_NAME: 'Rainton Gate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5008931,
        LOCATION_LATITUDE_DEG: 54.8094788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007300',
        LOCATION_NAME: 'Rainworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1167953,
        LOCATION_LATITUDE_DEG: 53.118816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007400',
        LOCATION_NAME: 'Raisbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5473297,
        LOCATION_LATITUDE_DEG: 54.4610619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007500',
        LOCATION_NAME: 'Rait',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2542024,
        LOCATION_LATITUDE_DEG: 56.4271653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990286',
        LOCATION_NAME: 'Raithby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0543237,
        LOCATION_LATITUDE_DEG: 53.183095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007550',
        LOCATION_NAME: 'Raithby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0544767,
        LOCATION_LATITUDE_DEG: 53.1831643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007600',
        LOCATION_NAME: 'Raithby-cum-Maltby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0368242,
        LOCATION_LATITUDE_DEG: 53.3430145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007700',
        LOCATION_NAME: 'Raithwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6588134,
        LOCATION_LATITUDE_DEG: 54.4921355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007800',
        LOCATION_NAME: 'Rake',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8529938,
        LOCATION_LATITUDE_DEG: 51.0434113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008000',
        LOCATION_NAME: 'Rame',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2109835,
        LOCATION_LATITUDE_DEG: 50.3209811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008100',
        LOCATION_NAME: 'Rame Common Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0928161,
        LOCATION_LATITUDE_DEG: 50.1717759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008200',
        LOCATION_NAME: 'Rame Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1871762,
        LOCATION_LATITUDE_DEG: 50.159137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008400',
        LOCATION_NAME: 'Ramleaze',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8343728,
        LOCATION_LATITUDE_DEG: 51.5656673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008500',
        LOCATION_NAME: 'Ramoyle',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9602261,
        LOCATION_LATITUDE_DEG: 56.1924456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008700',
        LOCATION_NAME: 'Rampisham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6203542,
        LOCATION_LATITUDE_DEG: 50.8177087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008800',
        LOCATION_NAME: 'Rampisham Down',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6459656,
        LOCATION_LATITUDE_DEG: 50.811508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008900',
        LOCATION_NAME: 'Rampside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.160707,
        LOCATION_LATITUDE_DEG: 54.0865289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009100',
        LOCATION_NAME: 'Rampton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8006209,
        LOCATION_LATITUDE_DEG: 53.2975229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009000',
        LOCATION_NAME: 'Rampton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0911272,
        LOCATION_LATITUDE_DEG: 52.2915152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009200',
        LOCATION_NAME: 'Ramridge Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5488515,
        LOCATION_LATITUDE_DEG: 51.2271322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009300',
        LOCATION_NAME: 'Rams Valley',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.310935,
        LOCATION_LATITUDE_DEG: 49.9123614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009400',
        LOCATION_NAME: 'Ramsbottom',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3170338,
        LOCATION_LATITUDE_DEG: 53.6485815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009500',
        LOCATION_NAME: 'Ramsbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.603548,
        LOCATION_LATITUDE_DEG: 51.4420605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009600',
        LOCATION_NAME: 'Ramscraigs',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4660067,
        LOCATION_LATITUDE_DEG: 58.2236433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009700',
        LOCATION_NAME: 'Ramsdean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9937147,
        LOCATION_LATITUDE_DEG: 50.9948026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009800',
        LOCATION_NAME: 'Ramsdell',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1544703,
        LOCATION_LATITUDE_DEG: 51.3124411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA009900',
        LOCATION_NAME: 'Ramsden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.482185,
        LOCATION_LATITUDE_DEG: 51.8340957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010000',
        LOCATION_NAME: 'Ramsden Bellhouse',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4834674,
        LOCATION_LATITUDE_DEG: 51.6227487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010100',
        LOCATION_NAME: 'Ramsden Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.472528,
        LOCATION_LATITUDE_DEG: 51.6357515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010400',
        LOCATION_NAME: 'Ramsey',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3915492,
        LOCATION_LATITUDE_DEG: 54.3228576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010200',
        LOCATION_NAME: 'Ramsey',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.104675,
        LOCATION_LATITUDE_DEG: 52.4479348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010300',
        LOCATION_NAME: 'Ramsey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2198588,
        LOCATION_LATITUDE_DEG: 51.9270642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010500',
        LOCATION_NAME: 'Ramsey Forty Foot',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0746905,
        LOCATION_LATITUDE_DEG: 52.4740317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010600',
        LOCATION_NAME: 'Ramsey Heights',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1569322,
        LOCATION_LATITUDE_DEG: 52.4494353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010700',
        LOCATION_NAME: 'Ramsey Mereside',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1063635,
        LOCATION_LATITUDE_DEG: 52.4840389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010750',
        LOCATION_NAME: 'Ramsey St. Marys',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1497139,
        LOCATION_LATITUDE_DEG: 52.4671452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010800',
        LOCATION_NAME: 'Ramsgate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.303437,
        LOCATION_LATITUDE_DEG: 50.1983791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA010900',
        LOCATION_NAME: 'Ramsgate',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4247541,
        LOCATION_LATITUDE_DEG: 51.3373092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011000',
        LOCATION_NAME: 'Ramsgill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8176575,
        LOCATION_LATITUDE_DEG: 54.1336151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011200',
        LOCATION_NAME: 'Ramsgreave',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4957453,
        LOCATION_LATITUDE_DEG: 53.7718917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011300',
        LOCATION_NAME: 'Ramshaw',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7700541,
        LOCATION_LATITUDE_DEG: 54.6324663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011400',
        LOCATION_NAME: 'Ramsholt',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3635802,
        LOCATION_LATITUDE_DEG: 52.0268763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011600',
        LOCATION_NAME: 'Ranby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0221657,
        LOCATION_LATITUDE_DEG: 53.3209324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011500',
        LOCATION_NAME: 'Ranby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1533392,
        LOCATION_LATITUDE_DEG: 53.2897147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011700',
        LOCATION_NAME: 'Rand',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3422295,
        LOCATION_LATITUDE_DEG: 53.2945223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011800',
        LOCATION_NAME: 'Randalstown',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3235193,
        LOCATION_LATITUDE_DEG: 54.7510287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011900',
        LOCATION_NAME: 'Randwick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2492752,
        LOCATION_LATITUDE_DEG: 51.7588984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012000',
        LOCATION_NAME: 'Ranelly',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2468398,
        LOCATION_LATITUDE_DEG: 54.5506318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012100',
        LOCATION_NAME: 'Ranfurly',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5836345,
        LOCATION_LATITUDE_DEG: 55.8486213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012200',
        LOCATION_NAME: 'Rangemore',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7296171,
        LOCATION_LATITUDE_DEG: 52.8034921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012300',
        LOCATION_NAME: 'Rangeworthy',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4452215,
        LOCATION_LATITUDE_DEG: 51.5694809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012400',
        LOCATION_NAME: 'Ranish',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4091019,
        LOCATION_LATITUDE_DEG: 58.1362627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012500',
        LOCATION_NAME: 'Rankinston',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4465443,
        LOCATION_LATITUDE_DEG: 55.3990758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025800',
        LOCATION_NAME: 'Ranmoor',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5229378,
        LOCATION_LATITUDE_DEG: 53.3717304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012600',
        LOCATION_NAME: 'Ranmore Common',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3906444,
        LOCATION_LATITUDE_DEG: 51.2479188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990685',
        LOCATION_NAME: 'Rannoch',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012700',
        LOCATION_NAME: 'Ranskill',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0131212,
        LOCATION_LATITUDE_DEG: 53.3823321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012800',
        LOCATION_NAME: 'Ranton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2137596,
        LOCATION_LATITUDE_DEG: 52.8129937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA012900',
        LOCATION_NAME: 'Ranworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4848846,
        LOCATION_LATITUDE_DEG: 52.6789335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013200',
        LOCATION_NAME: 'Rapps',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9439925,
        LOCATION_LATITUDE_DEG: 50.9470271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013300',
        LOCATION_NAME: 'Rapsgate',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0072801,
        LOCATION_LATITUDE_DEG: 51.7967943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013400',
        LOCATION_NAME: 'Rarnish',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2200517,
        LOCATION_LATITUDE_DEG: 57.4219004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013500',
        LOCATION_NAME: 'Rash',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3289175,
        LOCATION_LATITUDE_DEG: 54.6297146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013600',
        LOCATION_NAME: 'Rasharkin',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4822446,
        LOCATION_LATITUDE_DEG: 54.9499405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013800',
        LOCATION_NAME: 'Rashfield',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9717411,
        LOCATION_LATITUDE_DEG: 56.0083425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013900',
        LOCATION_NAME: 'Rashwood',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1245277,
        LOCATION_LATITUDE_DEG: 52.2833406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014000',
        LOCATION_NAME: 'Raskelf',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2473765,
        LOCATION_LATITUDE_DEG: 54.1326141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014100',
        LOCATION_NAME: 'Rassau',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2106339,
        LOCATION_LATITUDE_DEG: 51.8022073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014200',
        LOCATION_NAME: 'Rastrick',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7985105,
        LOCATION_LATITUDE_DEG: 53.6905776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014300',
        LOCATION_NAME: 'Ratby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2437389,
        LOCATION_LATITUDE_DEG: 52.6466672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014400',
        LOCATION_NAME: 'Ratcliffe Culey',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5178004,
        LOCATION_LATITUDE_DEG: 52.5927694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025600',
        LOCATION_NAME: 'Ratcliffe on Soar',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2642832,
        LOCATION_LATITUDE_DEG: 52.8570552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014500',
        LOCATION_NAME: 'Ratcliffe on the Wreake',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.066387,
        LOCATION_LATITUDE_DEG: 52.7247752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014600',
        LOCATION_NAME: 'Ratcliffe-on-Soar',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2601792,
        LOCATION_LATITUDE_DEG: 52.8573174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014700',
        LOCATION_NAME: 'Ratford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0258898,
        LOCATION_LATITUDE_DEG: 51.4469634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017600',
        LOCATION_NAME: 'Rathen',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9987604,
        LOCATION_LATITUDE_DEG: 57.6372666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018000',
        LOCATION_NAME: 'Rathfraggan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2985166,
        LOCATION_LATITUDE_DEG: 54.5200757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018100',
        LOCATION_NAME: 'Rathfriland',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1808308,
        LOCATION_LATITUDE_DEG: 54.2352745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018500',
        LOCATION_NAME: 'Rathillet',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0285475,
        LOCATION_LATITUDE_DEG: 56.3751559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018800',
        LOCATION_NAME: 'Rathkenny',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2489183,
        LOCATION_LATITUDE_DEG: 54.933244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019200',
        LOCATION_NAME: 'Rathlin Island',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.212519,
        LOCATION_LATITUDE_DEG: 55.2990634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019300',
        LOCATION_NAME: 'Rathmell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2988786,
        LOCATION_LATITUDE_DEG: 54.0350107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020100',
        LOCATION_NAME: 'Ratho',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3780539,
        LOCATION_LATITUDE_DEG: 55.921009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020200',
        LOCATION_NAME: 'Ratho Station',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3839146,
        LOCATION_LATITUDE_DEG: 55.9359153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020700',
        LOCATION_NAME: 'Rathven',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9325815,
        LOCATION_LATITUDE_DEG: 57.6777772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021100',
        LOCATION_NAME: 'Ratley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4471864,
        LOCATION_LATITUDE_DEG: 52.1266218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021200',
        LOCATION_NAME: 'Ratlinghope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8817805,
        LOCATION_LATITUDE_DEG: 52.5644752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021400',
        LOCATION_NAME: 'Ratten Row',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9431301,
        LOCATION_LATITUDE_DEG: 54.837804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021500',
        LOCATION_NAME: 'Rattery',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7721986,
        LOCATION_LATITUDE_DEG: 50.4405864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021600',
        LOCATION_NAME: 'Rattlesden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8952169,
        LOCATION_LATITUDE_DEG: 52.1930953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021700',
        LOCATION_NAME: 'Ratton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2541226,
        LOCATION_LATITUDE_DEG: 50.7889335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021800',
        LOCATION_NAME: 'Ratton Village',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2539002,
        LOCATION_LATITUDE_DEG: 50.7863743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021900',
        LOCATION_NAME: 'Rattray',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3306716,
        LOCATION_LATITUDE_DEG: 56.5934805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022000',
        LOCATION_NAME: 'Raughton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9528121,
        LOCATION_LATITUDE_DEG: 54.8230962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022100',
        LOCATION_NAME: 'Raughton Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9660587,
        LOCATION_LATITUDE_DEG: 54.8008991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022200',
        LOCATION_NAME: 'Raunds',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5350131,
        LOCATION_LATITUDE_DEG: 52.3440336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026700',
        LOCATION_NAME: 'Ravelston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2569284,
        LOCATION_LATITUDE_DEG: 55.9540094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022300',
        LOCATION_NAME: 'Ravenfield',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2697071,
        LOCATION_LATITUDE_DEG: 53.4509446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022400',
        LOCATION_NAME: 'Ravenglass',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4077823,
        LOCATION_LATITUDE_DEG: 54.3553574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026300',
        LOCATION_NAME: 'Ravenhill',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9037818,
        LOCATION_LATITUDE_DEG: 54.5820127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022500',
        LOCATION_NAME: 'Ravenhill',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9750799,
        LOCATION_LATITUDE_DEG: 51.645302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022600',
        LOCATION_NAME: 'Raveningham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5349604,
        LOCATION_LATITUDE_DEG: 52.5188165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022700',
        LOCATION_NAME: 'Ravenscar',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4911591,
        LOCATION_LATITUDE_DEG: 54.3971224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022900',
        LOCATION_NAME: 'Ravensden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4229297,
        LOCATION_LATITUDE_DEG: 52.1776107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023000',
        LOCATION_NAME: 'Ravenshead',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1667907,
        LOCATION_LATITUDE_DEG: 53.0859121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023100',
        LOCATION_NAME: 'Ravensmoor',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5658011,
        LOCATION_LATITUDE_DEG: 53.0516217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023200',
        LOCATION_NAME: 'Ravensthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6620722,
        LOCATION_LATITUDE_DEG: 53.6787732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023300',
        LOCATION_NAME: 'Ravensthorpe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0170139,
        LOCATION_LATITUDE_DEG: 52.3266379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023400',
        LOCATION_NAME: 'Ravenstone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4046865,
        LOCATION_LATITUDE_DEG: 52.7206805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023500',
        LOCATION_NAME: 'Ravenstone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7569322,
        LOCATION_LATITUDE_DEG: 52.1489172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023600',
        LOCATION_NAME: 'Ravenstonedale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4258097,
        LOCATION_LATITUDE_DEG: 54.4306589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023700',
        LOCATION_NAME: 'Ravenstruther',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7126542,
        LOCATION_LATITUDE_DEG: 55.6876919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025900',
        LOCATION_NAME: 'Ravenswood',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6036591,
        LOCATION_LATITUDE_DEG: 54.9314855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023800',
        LOCATION_NAME: 'Ravensworth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.783836,
        LOCATION_LATITUDE_DEG: 54.4670513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026000',
        LOCATION_NAME: 'Ravensworth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6535922,
        LOCATION_LATITUDE_DEG: 54.9328423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA023900',
        LOCATION_NAME: 'Raventhorpe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5884773,
        LOCATION_LATITUDE_DEG: 53.5508419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024100',
        LOCATION_NAME: 'Raw',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2273421,
        LOCATION_LATITUDE_DEG: 54.5390038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024000',
        LOCATION_NAME: 'Raw',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5489373,
        LOCATION_LATITUDE_DEG: 54.4353327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024200',
        LOCATION_NAME: 'Rawcliffe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.96282,
        LOCATION_LATITUDE_DEG: 53.6986624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024300',
        LOCATION_NAME: 'Rawcliffe Bridge',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9468692,
        LOCATION_LATITUDE_DEG: 53.6840679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024400',
        LOCATION_NAME: 'Rawdon',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6833254,
        LOCATION_LATITUDE_DEG: 53.8527884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024500',
        LOCATION_NAME: 'Rawfolds',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7017801,
        LOCATION_LATITUDE_DEG: 53.7182783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024600',
        LOCATION_NAME: 'Rawmarsh',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3428623,
        LOCATION_LATITUDE_DEG: 53.4591454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024700',
        LOCATION_NAME: 'Rawreth',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.577043,
        LOCATION_LATITUDE_DEG: 51.609443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024800',
        LOCATION_NAME: 'Rawridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1338658,
        LOCATION_LATITUDE_DEG: 50.8526209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025000',
        LOCATION_NAME: 'Rawtenstall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2860522,
        LOCATION_LATITUDE_DEG: 53.7006802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025050',
        LOCATION_NAME: 'Rawthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7563056,
        LOCATION_LATITUDE_DEG: 53.653095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025100',
        LOCATION_NAME: 'Raydon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9884807,
        LOCATION_LATITUDE_DEG: 52.0051738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025200',
        LOCATION_NAME: 'Rayleigh',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6186988,
        LOCATION_LATITUDE_DEG: 51.5852428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025400',
        LOCATION_NAME: 'Rayne',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5407476,
        LOCATION_LATITUDE_DEG: 57.3442461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025300',
        LOCATION_NAME: 'Rayne',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5081407,
        LOCATION_LATITUDE_DEG: 51.8746713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026200',
        LOCATION_NAME: 'Raynes Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2295562,
        LOCATION_LATITUDE_DEG: 51.4078032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA025500',
        LOCATION_NAME: 'Raywell',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4931663,
        LOCATION_LATITUDE_DEG: 53.7665661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000100',
        LOCATION_NAME: 'Reabrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9418637,
        LOCATION_LATITUDE_DEG: 52.6347907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000200',
        LOCATION_NAME: 'Reach',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2967146,
        LOCATION_LATITUDE_DEG: 52.2705085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000300',
        LOCATION_NAME: 'Read',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3551085,
        LOCATION_LATITUDE_DEG: 53.8059919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000400',
        LOCATION_NAME: 'Reading',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9713371,
        LOCATION_LATITUDE_DEG: 51.4536498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000500',
        LOCATION_NAME: 'Reading Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7426505,
        LOCATION_LATITUDE_DEG: 51.0417899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000600',
        LOCATION_NAME: 'Ready Penny',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6240384,
        LOCATION_LATITUDE_DEG: 51.8230053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000700',
        LOCATION_NAME: 'Ready Token',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8450687,
        LOCATION_LATITUDE_DEG: 51.7382887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE990283',
        LOCATION_NAME: 'Reagh Island',
        COUNTY_NAME: 'County Down',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000900',
        LOCATION_NAME: 'Reaghan',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3186799,
        LOCATION_LATITUDE_DEG: 54.6873288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001100',
        LOCATION_NAME: 'Reagill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6126317,
        LOCATION_LATITUDE_DEG: 54.5504679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001500',
        LOCATION_NAME: 'Rearsby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0360783,
        LOCATION_LATITUDE_DEG: 52.7238764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001600',
        LOCATION_NAME: 'Reasby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3983578,
        LOCATION_LATITUDE_DEG: 53.3032192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001700',
        LOCATION_NAME: 'Reaseheath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5257942,
        LOCATION_LATITUDE_DEG: 53.0879189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001800',
        LOCATION_NAME: 'Reawick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4101554,
        LOCATION_LATITUDE_DEG: 60.1838083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001900',
        LOCATION_NAME: 'Reawla',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3551429,
        LOCATION_LATITUDE_DEG: 50.176175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002000',
        LOCATION_NAME: 'Reay',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7744438,
        LOCATION_LATITUDE_DEG: 58.5592812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002100',
        LOCATION_NAME: 'Recarson',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2241597,
        LOCATION_LATITUDE_DEG: 54.5866536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE990773',
        LOCATION_NAME: 'Reclain',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002300',
        LOCATION_NAME: 'Reculver',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1993624,
        LOCATION_LATITUDE_DEG: 51.3778098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002400',
        LOCATION_NAME: 'Red Ball',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2970328,
        LOCATION_LATITUDE_DEG: 50.9442331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002500',
        LOCATION_NAME: 'Red Bull',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4414099,
        LOCATION_LATITUDE_DEG: 52.9141109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002700',
        LOCATION_NAME: 'Red Dial',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.158402,
        LOCATION_LATITUDE_DEG: 54.8029995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015500',
        LOCATION_NAME: 'Red House Farm Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002800',
        LOCATION_NAME: 'Red Lake',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4660022,
        LOCATION_LATITUDE_DEG: 52.6913829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002900',
        LOCATION_NAME: 'Red Lodge',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4946009,
        LOCATION_LATITUDE_DEG: 52.3033107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003000',
        LOCATION_NAME: 'Red Point',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8021802,
        LOCATION_LATITUDE_DEG: 57.6582136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003100',
        LOCATION_NAME: 'Red Post Bridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5470499,
        LOCATION_LATITUDE_DEG: 51.1976371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003200',
        LOCATION_NAME: 'Red Quar',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6279584,
        LOCATION_LATITUDE_DEG: 51.2636561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003300',
        LOCATION_NAME: 'Red Rice',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5170455,
        LOCATION_LATITUDE_DEG: 51.1719319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003400',
        LOCATION_NAME: 'Red Roses',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.603587,
        LOCATION_LATITUDE_DEG: 51.7754234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003500',
        LOCATION_NAME: 'Red Row',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6016896,
        LOCATION_LATITUDE_DEG: 55.2848262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003600',
        LOCATION_NAME: 'Red Street',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2542449,
        LOCATION_LATITUDE_DEG: 53.0553205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003700',
        LOCATION_NAME: 'Red Wharf Bay',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2063563,
        LOCATION_LATITUDE_DEG: 53.3059629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003800',
        LOCATION_NAME: 'Redannick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0579139,
        LOCATION_LATITUDE_DEG: 50.2599788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE003900',
        LOCATION_NAME: 'Redberth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7757759,
        LOCATION_LATITUDE_DEG: 51.7021149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004000',
        LOCATION_NAME: 'Redbourn',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3925284,
        LOCATION_LATITUDE_DEG: 51.796678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004100',
        LOCATION_NAME: 'Redbourne',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5337513,
        LOCATION_LATITUDE_DEG: 53.487539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004200',
        LOCATION_NAME: 'Redbridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0355702,
        LOCATION_LATITUDE_DEG: 51.5744677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004300',
        LOCATION_NAME: 'Redbrook',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6713368,
        LOCATION_LATITUDE_DEG: 51.7854003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004350',
        LOCATION_NAME: 'Redbrook Maelor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7324226,
        LOCATION_LATITUDE_DEG: 52.9665804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004400',
        LOCATION_NAME: 'Redburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3581087,
        LOCATION_LATITUDE_DEG: 54.9744109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004500',
        LOCATION_NAME: 'Redcar',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0760106,
        LOCATION_LATITUDE_DEG: 54.6028515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015800',
        LOCATION_NAME: 'Redcliffe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5896036,
        LOCATION_LATITUDE_DEG: 51.4485233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015700',
        LOCATION_NAME: 'Redcliffe Bay',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8064705,
        LOCATION_LATITUDE_DEG: 51.4784011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004700',
        LOCATION_NAME: 'Redding',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7313834,
        LOCATION_LATITUDE_DEG: 55.9885193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004800',
        LOCATION_NAME: 'Reddingmuirhead',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7369085,
        LOCATION_LATITUDE_DEG: 55.9812248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004900',
        LOCATION_NAME: 'Reddish',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1582135,
        LOCATION_LATITUDE_DEG: 53.4379513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005000',
        LOCATION_NAME: 'Redditch',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9425447,
        LOCATION_LATITUDE_DEG: 52.3060413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005100',
        LOCATION_NAME: 'Rede',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6386496,
        LOCATION_LATITUDE_DEG: 52.1713969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005200',
        LOCATION_NAME: 'Redenhall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3294194,
        LOCATION_LATITUDE_DEG: 52.4104131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005300',
        LOCATION_NAME: 'Redenham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5736566,
        LOCATION_LATITUDE_DEG: 51.2397344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005400',
        LOCATION_NAME: 'Redenham Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5778506,
        LOCATION_LATITUDE_DEG: 51.2354329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005500',
        LOCATION_NAME: 'Redesmouth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2108611,
        LOCATION_LATITUDE_DEG: 55.13452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005600',
        LOCATION_NAME: 'Redfield',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5552472,
        LOCATION_LATITUDE_DEG: 51.4577737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005800',
        LOCATION_NAME: 'Redford',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1838544,
        LOCATION_LATITUDE_DEG: 56.1610335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005900',
        LOCATION_NAME: 'Redford',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7120623,
        LOCATION_LATITUDE_DEG: 56.5866722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE005700',
        LOCATION_NAME: 'Redford',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7631877,
        LOCATION_LATITUDE_DEG: 51.0262078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006200',
        LOCATION_NAME: 'Redgorton',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4758045,
        LOCATION_LATITUDE_DEG: 56.4435625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006300',
        LOCATION_NAME: 'Redgrave',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0037265,
        LOCATION_LATITUDE_DEG: 52.3606092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006700',
        LOCATION_NAME: 'Redhill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7234686,
        LOCATION_LATITUDE_DEG: 52.0374259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006500',
        LOCATION_NAME: 'Redhill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7215588,
        LOCATION_LATITUDE_DEG: 51.3632621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006800',
        LOCATION_NAME: 'Redhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4004177,
        LOCATION_LATITUDE_DEG: 52.6925845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006900',
        LOCATION_NAME: 'Redhill',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1385544,
        LOCATION_LATITUDE_DEG: 53.0118008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006400',
        LOCATION_NAME: 'Redhill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1685378,
        LOCATION_LATITUDE_DEG: 51.2403185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007000',
        LOCATION_NAME: 'Redhills',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7727178,
        LOCATION_LATITUDE_DEG: 54.6480788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE990520',
        LOCATION_NAME: 'Redhouse park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7487021,
        LOCATION_LATITUDE_DEG: 52.0795641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007200',
        LOCATION_NAME: 'Redisham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5418852,
        LOCATION_LATITUDE_DEG: 52.4029096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015900',
        LOCATION_NAME: 'Redland',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6073618,
        LOCATION_LATITUDE_DEG: 51.4733604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007300',
        LOCATION_NAME: 'Redlap',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5823758,
        LOCATION_LATITUDE_DEG: 50.3298709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007400',
        LOCATION_NAME: 'Redlingfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2089297,
        LOCATION_LATITUDE_DEG: 52.2951969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007500',
        LOCATION_NAME: 'Redlynch',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7109921,
        LOCATION_LATITUDE_DEG: 50.9899114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007600',
        LOCATION_NAME: 'Redmain',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3344249,
        LOCATION_LATITUDE_DEG: 54.6933937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007700',
        LOCATION_NAME: 'Redmarley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.348509,
        LOCATION_LATITUDE_DEG: 51.9756136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007800',
        LOCATION_NAME: 'Redmarshall',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4028086,
        LOCATION_LATITUDE_DEG: 54.5847535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007900',
        LOCATION_NAME: 'Redmile',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.813101,
        LOCATION_LATITUDE_DEG: 52.9102879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008000',
        LOCATION_NAME: 'Redmire',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9313543,
        LOCATION_LATITUDE_DEG: 54.3170335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008100',
        LOCATION_NAME: 'Redmoor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.704179,
        LOCATION_LATITUDE_DEG: 50.4175952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008200',
        LOCATION_NAME: 'Redmoor',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7311566,
        LOCATION_LATITUDE_DEG: 52.0219973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008300',
        LOCATION_NAME: 'Rednal',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9459296,
        LOCATION_LATITUDE_DEG: 52.8456048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008400',
        LOCATION_NAME: 'Rednal',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9971785,
        LOCATION_LATITUDE_DEG: 52.3876505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008500',
        LOCATION_NAME: 'Redpath',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6597725,
        LOCATION_LATITUDE_DEG: 55.6143707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008600',
        LOCATION_NAME: 'Redruth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2282845,
        LOCATION_LATITUDE_DEG: 50.2322805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008700',
        LOCATION_NAME: 'Redruth Highway',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2091307,
        LOCATION_LATITUDE_DEG: 50.2444807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008800',
        LOCATION_NAME: 'Redstocks',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0919989,
        LOCATION_LATITUDE_DEG: 51.3659513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE008900',
        LOCATION_NAME: 'Redvales',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3022501,
        LOCATION_LATITUDE_DEG: 53.574269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009000',
        LOCATION_NAME: 'Redwick',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8468243,
        LOCATION_LATITUDE_DEG: 51.5522795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009100',
        LOCATION_NAME: 'Redworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6270531,
        LOCATION_LATITUDE_DEG: 54.6054615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009200',
        LOCATION_NAME: 'Reed',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0170796,
        LOCATION_LATITUDE_DEG: 52.0078866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009300',
        LOCATION_NAME: 'Reedham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5704968,
        LOCATION_LATITUDE_DEG: 52.5600182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009400',
        LOCATION_NAME: 'Reedley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2327706,
        LOCATION_LATITUDE_DEG: 53.8179954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009500',
        LOCATION_NAME: 'Reedness',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7917223,
        LOCATION_LATITUDE_DEG: 53.6978588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009600',
        LOCATION_NAME: 'Reeds Beck',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1980934,
        LOCATION_LATITUDE_DEG: 53.1689023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009700',
        LOCATION_NAME: 'Reedsholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2889368,
        LOCATION_LATITUDE_DEG: 53.7148852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009800',
        LOCATION_NAME: 'Reef',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9202138,
        LOCATION_LATITUDE_DEG: 58.2050712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010200',
        LOCATION_NAME: 'Reepham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4423657,
        LOCATION_LATITUDE_DEG: 53.2508107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010300',
        LOCATION_NAME: 'Reepham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1120156,
        LOCATION_LATITUDE_DEG: 52.7639442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010400',
        LOCATION_NAME: 'Reeshill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8355822,
        LOCATION_LATITUDE_DEG: 50.3924958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010500',
        LOCATION_NAME: 'Reeth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9413676,
        LOCATION_LATITUDE_DEG: 54.3893487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE990256',
        LOCATION_NAME: 'Regaby',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4104466,
        LOCATION_LATITUDE_DEG: 54.3506314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015600',
        LOCATION_NAME: 'Regents Farm Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010600',
        LOCATION_NAME: 'Regil',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6616542,
        LOCATION_LATITUDE_DEG: 51.3601624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010700',
        LOCATION_NAME: 'Reiff',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.446489,
        LOCATION_LATITUDE_DEG: 58.0685477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010800',
        LOCATION_NAME: 'Reigate',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2042498,
        LOCATION_LATITUDE_DEG: 51.2372205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010900',
        LOCATION_NAME: 'Reighton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2700647,
        LOCATION_LATITUDE_DEG: 54.1628996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011000',
        LOCATION_NAME: 'Reighton Gap',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2586297,
        LOCATION_LATITUDE_DEG: 54.167805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011100',
        LOCATION_NAME: 'Reiss',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1468946,
        LOCATION_LATITUDE_DEG: 58.4778613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011200',
        LOCATION_NAME: 'Rejerrah',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.089445,
        LOCATION_LATITUDE_DEG: 50.3638933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011300',
        LOCATION_NAME: 'Relaghadooey',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3048757,
        LOCATION_LATITUDE_DEG: 54.5569685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011700',
        LOCATION_NAME: 'Releath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2748303,
        LOCATION_LATITUDE_DEG: 50.1496693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011800',
        LOCATION_NAME: 'Relubbus',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4075105,
        LOCATION_LATITUDE_DEG: 50.1365718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011900',
        LOCATION_NAME: 'Remenham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8873753,
        LOCATION_LATITUDE_DEG: 51.5507616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012000',
        LOCATION_NAME: 'Rempstone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1397839,
        LOCATION_LATITUDE_DEG: 52.8132787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012200',
        LOCATION_NAME: 'Rendall',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.084849,
        LOCATION_LATITUDE_DEG: 59.1052267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012300',
        LOCATION_NAME: 'Rendcomb',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.974628,
        LOCATION_LATITUDE_DEG: 51.7839961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012400',
        LOCATION_NAME: 'Rendham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4420147,
        LOCATION_LATITUDE_DEG: 52.2281866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012500',
        LOCATION_NAME: 'Rendlesham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3973241,
        LOCATION_LATITUDE_DEG: 52.1261798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012600',
        LOCATION_NAME: 'Renfrew',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3881831,
        LOCATION_LATITUDE_DEG: 55.8775156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012700',
        LOCATION_NAME: 'Renhold',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.40111,
        LOCATION_LATITUDE_DEG: 52.1628123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012800',
        LOCATION_NAME: 'Renishaw',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3314264,
        LOCATION_LATITUDE_DEG: 53.2971304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012900',
        LOCATION_NAME: 'Rennington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6649682,
        LOCATION_LATITUDE_DEG: 55.4609492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013000',
        LOCATION_NAME: 'Renton',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.58272,
        LOCATION_LATITUDE_DEG: 55.9703283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013100',
        LOCATION_NAME: 'Renwick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6269068,
        LOCATION_LATITUDE_DEG: 54.7852933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013200',
        LOCATION_NAME: 'Repps With Bastwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5825514,
        LOCATION_LATITUDE_DEG: 52.6957362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013300',
        LOCATION_NAME: 'Repton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5515845,
        LOCATION_LATITUDE_DEG: 52.8377915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013500',
        LOCATION_NAME: 'Resaurie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5035907,
        LOCATION_LATITUDE_DEG: 56.772966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013600',
        LOCATION_NAME: 'Rescorla',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.774478,
        LOCATION_LATITUDE_DEG: 50.3830939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013700',
        LOCATION_NAME: 'Reskadinnick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3151355,
        LOCATION_LATITUDE_DEG: 50.2249832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013800',
        LOCATION_NAME: 'Resolven',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6922986,
        LOCATION_LATITUDE_DEG: 51.7101076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013900',
        LOCATION_NAME: 'Restalrig',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1441678,
        LOCATION_LATITUDE_DEG: 55.9574175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014000',
        LOCATION_NAME: 'Reston',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1854618,
        LOCATION_LATITUDE_DEG: 55.8515948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014050',
        LOCATION_NAME: 'Restrop',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8870333,
        LOCATION_LATITUDE_DEG: 51.5790475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014100',
        LOCATION_NAME: 'Resugga Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7740765,
        LOCATION_LATITUDE_DEG: 50.3754927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014200',
        LOCATION_NAME: 'Retanna',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1963333,
        LOCATION_LATITUDE_DEG: 50.1477737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014300',
        LOCATION_NAME: 'Retford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9405266,
        LOCATION_LATITUDE_DEG: 53.3193274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014400',
        LOCATION_NAME: 'Retire',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8145768,
        LOCATION_LATITUDE_DEG: 50.4414959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014500',
        LOCATION_NAME: 'Retorrick Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0059966,
        LOCATION_LATITUDE_DEG: 50.4619037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014600',
        LOCATION_NAME: 'Rettendon Common',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5495586,
        LOCATION_LATITUDE_DEG: 51.6497445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014700',
        LOCATION_NAME: 'Revel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2370774,
        LOCATION_LATITUDE_DEG: 52.6063878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014800',
        LOCATION_NAME: 'Revesby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0589062,
        LOCATION_LATITUDE_DEG: 53.1347952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE014900',
        LOCATION_NAME: 'Rewe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4891376,
        LOCATION_LATITUDE_DEG: 50.7863163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015000',
        LOCATION_NAME: 'Reydon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6675276,
        LOCATION_LATITUDE_DEG: 52.3386935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015100',
        LOCATION_NAME: 'Reymerston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9826456,
        LOCATION_LATITUDE_DEG: 52.6152371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015200',
        LOCATION_NAME: 'Reynalton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7646216,
        LOCATION_LATITUDE_DEG: 51.744221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015300',
        LOCATION_NAME: 'Reynoldston',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1947114,
        LOCATION_LATITUDE_DEG: 51.5868985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE015400',
        LOCATION_NAME: 'Rezare',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3154167,
        LOCATION_LATITUDE_DEG: 50.5748068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000100',
        LOCATION_NAME: 'Rhadyr',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9207733,
        LOCATION_LATITUDE_DEG: 51.7132021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000200',
        LOCATION_NAME: 'Rhallt',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1172604,
        LOCATION_LATITUDE_DEG: 52.6871957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000300',
        LOCATION_NAME: 'Rhandirmwyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.773587,
        LOCATION_LATITUDE_DEG: 52.0778433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000400',
        LOCATION_NAME: 'Rhanich',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1888938,
        LOCATION_LATITUDE_DEG: 57.8014097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000500',
        LOCATION_NAME: 'Rhayader',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5109601,
        LOCATION_LATITUDE_DEG: 52.2993576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000600',
        LOCATION_NAME: 'Rheda',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5072467,
        LOCATION_LATITUDE_DEG: 54.5358788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000700',
        LOCATION_NAME: 'Rhenetra',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2946413,
        LOCATION_LATITUDE_DEG: 57.4811969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000800',
        LOCATION_NAME: 'Rhenigidale',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6819239,
        LOCATION_LATITUDE_DEG: 57.919241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH000900',
        LOCATION_NAME: 'Rheola',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.683344,
        LOCATION_LATITUDE_DEG: 51.7204074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH011400',
        LOCATION_NAME: 'Rhes y Cae',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001000',
        LOCATION_NAME: 'Rhes-y-Cae',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2165274,
        LOCATION_LATITUDE_DEG: 53.2276467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH990566',
        LOCATION_NAME: 'Rhewl',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001250',
        LOCATION_NAME: 'Rhewl',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3354715,
        LOCATION_LATITUDE_DEG: 53.1341923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001100',
        LOCATION_NAME: 'Rhewl',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2183442,
        LOCATION_LATITUDE_DEG: 52.9952207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001200',
        LOCATION_NAME: 'Rhewl',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0296645,
        LOCATION_LATITUDE_DEG: 52.9019098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001300',
        LOCATION_NAME: 'Rhiconich',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9865401,
        LOCATION_LATITUDE_DEG: 58.4249761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001400',
        LOCATION_NAME: 'Rhiews',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5364038,
        LOCATION_LATITUDE_DEG: 52.9322134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001500',
        LOCATION_NAME: 'Rhigos',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5621201,
        LOCATION_LATITUDE_DEG: 51.7392043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001600',
        LOCATION_NAME: 'Rhiroy',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1146616,
        LOCATION_LATITUDE_DEG: 57.860922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001700',
        LOCATION_NAME: 'Rhitongue',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3938911,
        LOCATION_LATITUDE_DEG: 58.5040766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001900',
        LOCATION_NAME: 'Rhiw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6326915,
        LOCATION_LATITUDE_DEG: 52.8180233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH001800',
        LOCATION_NAME: 'Rhiw',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5299824,
        LOCATION_LATITUDE_DEG: 53.1694424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002000',
        LOCATION_NAME: 'Rhiwbina',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2139084,
        LOCATION_LATITUDE_DEG: 51.5228866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002100',
        LOCATION_NAME: 'Rhiwbryfdir',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9416494,
        LOCATION_LATITUDE_DEG: 53.0001378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002200',
        LOCATION_NAME: 'Rhiwbwys',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1313696,
        LOCATION_LATITUDE_DEG: 52.3009664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002300',
        LOCATION_NAME: 'Rhiwceiliog Pencoed',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4917298,
        LOCATION_LATITUDE_DEG: 51.543892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002400',
        LOCATION_NAME: 'Rhiwddolion',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8347188,
        LOCATION_LATITUDE_DEG: 53.0927394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002500',
        LOCATION_NAME: 'Rhiwderin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.067386,
        LOCATION_LATITUDE_DEG: 51.57959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002550',
        LOCATION_NAME: 'Rhiwfawr',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.815987,
        LOCATION_LATITUDE_DEG: 51.7824453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002600',
        LOCATION_NAME: 'Rhiwlas',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1275918,
        LOCATION_LATITUDE_DEG: 53.1712524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002700',
        LOCATION_NAME: 'Rhiwlas',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1917725,
        LOCATION_LATITUDE_DEG: 52.8803173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002800',
        LOCATION_NAME: 'Rhiwsaeson',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3397144,
        LOCATION_LATITUDE_DEG: 51.5350877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH002900',
        LOCATION_NAME: 'Rhode',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0278932,
        LOCATION_LATITUDE_DEG: 51.1051446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003100',
        LOCATION_NAME: 'Rhodes Minnis',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0756294,
        LOCATION_LATITUDE_DEG: 51.145592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003200',
        LOCATION_NAME: 'Rhodesia',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.152289,
        LOCATION_LATITUDE_DEG: 53.3144303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003300',
        LOCATION_NAME: 'Rhondda',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4872093,
        LOCATION_LATITUDE_DEG: 51.646695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003400',
        LOCATION_NAME: 'Rhonehouse',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9623856,
        LOCATION_LATITUDE_DEG: 54.916819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003500',
        LOCATION_NAME: 'Rhoose',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3528627,
        LOCATION_LATITUDE_DEG: 51.3879712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003750',
        LOCATION_NAME: 'Rhos',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8897581,
        LOCATION_LATITUDE_DEG: 51.7916962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003600',
        LOCATION_NAME: 'Rhos',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3599211,
        LOCATION_LATITUDE_DEG: 51.9920395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003700',
        LOCATION_NAME: 'Rhos',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8252439,
        LOCATION_LATITUDE_DEG: 51.7118043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003800',
        LOCATION_NAME: 'Rhos Common',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0600357,
        LOCATION_LATITUDE_DEG: 52.7503979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003900',
        LOCATION_NAME: 'Rhos on Sea',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7468011,
        LOCATION_LATITUDE_DEG: 53.3062253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH011500',
        LOCATION_NAME: 'Rhos Y Madoc',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH011600',
        LOCATION_NAME: 'Rhos y Meirch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004200',
        LOCATION_NAME: 'Rhosamman',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8299388,
        LOCATION_LATITUDE_DEG: 51.808318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004300',
        LOCATION_NAME: 'Rhosbodrual',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2419535,
        LOCATION_LATITUDE_DEG: 53.1414499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004400',
        LOCATION_NAME: 'Rhoscefnhir',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2144155,
        LOCATION_LATITUDE_DEG: 53.2638583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004500',
        LOCATION_NAME: 'Rhoscolyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5937153,
        LOCATION_LATITUDE_DEG: 53.2501635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004600',
        LOCATION_NAME: 'Rhoscrowther',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0307182,
        LOCATION_LATITUDE_DEG: 51.6800145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004700',
        LOCATION_NAME: 'Rhosesmor',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1759543,
        LOCATION_LATITUDE_DEG: 53.2095426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004800',
        LOCATION_NAME: 'Rhosfach',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.741069,
        LOCATION_LATITUDE_DEG: 51.9216394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004900',
        LOCATION_NAME: 'Rhosferig',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4385393,
        LOCATION_LATITUDE_DEG: 52.1577463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005000',
        LOCATION_NAME: 'Rhosgadfan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2288967,
        LOCATION_LATITUDE_DEG: 53.0914481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005100',
        LOCATION_NAME: 'Rhosgoch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3921351,
        LOCATION_LATITUDE_DEG: 53.3752781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005200',
        LOCATION_NAME: 'Rhosgoch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1889961,
        LOCATION_LATITUDE_DEG: 52.1208442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005300',
        LOCATION_NAME: 'Rhoshill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6374428,
        LOCATION_LATITUDE_DEG: 52.0297427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005400',
        LOCATION_NAME: 'Rhoshirwaun',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6786327,
        LOCATION_LATITUDE_DEG: 52.8310241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005500',
        LOCATION_NAME: 'Rhoslan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.260616,
        LOCATION_LATITUDE_DEG: 52.9470297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005600',
        LOCATION_NAME: 'Rhoslefain',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.102661,
        LOCATION_LATITUDE_DEG: 52.6305019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005700',
        LOCATION_NAME: 'Rhosllanerchrugog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0553192,
        LOCATION_LATITUDE_DEG: 53.0085212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005800',
        LOCATION_NAME: 'Rhosmaen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9773933,
        LOCATION_LATITUDE_DEG: 51.8963302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH005900',
        LOCATION_NAME: 'Rhosmeirch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3093072,
        LOCATION_LATITUDE_DEG: 53.2739626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006000',
        LOCATION_NAME: 'Rhosneigr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5187864,
        LOCATION_LATITUDE_DEG: 53.2288586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006100',
        LOCATION_NAME: 'Rhosrobin',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0078666,
        LOCATION_LATITUDE_DEG: 53.0683334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006200',
        LOCATION_NAME: 'Rhossili',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2862487,
        LOCATION_LATITUDE_DEG: 51.5687994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006300',
        LOCATION_NAME: 'Rhostrehwfa',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3408076,
        LOCATION_LATITUDE_DEG: 53.2456619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006400',
        LOCATION_NAME: 'Rhostryfan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.246121,
        LOCATION_LATITUDE_DEG: 53.0966453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006500',
        LOCATION_NAME: 'Rhostyllen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0258121,
        LOCATION_LATITUDE_DEG: 53.0314267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006600',
        LOCATION_NAME: 'Rhoswiel',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0534121,
        LOCATION_LATITUDE_DEG: 52.9185144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006700',
        LOCATION_NAME: 'Rhosybol',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3656551,
        LOCATION_LATITUDE_DEG: 53.3695747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006800',
        LOCATION_NAME: 'Rhosygadfa',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0054456,
        LOCATION_LATITUDE_DEG: 52.9001124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH006900',
        LOCATION_NAME: 'Rhosygwalia',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5694875,
        LOCATION_LATITUDE_DEG: 52.8968487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004000',
        LOCATION_NAME: 'Rhos-Y-Madoc',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0220501,
        LOCATION_LATITUDE_DEG: 52.9713209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007000',
        LOCATION_NAME: 'Rhosymedre',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0630917,
        LOCATION_LATITUDE_DEG: 52.9754203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH004100',
        LOCATION_NAME: 'Rhos-y-Meirch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0642185,
        LOCATION_LATITUDE_DEG: 52.320656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007100',
        LOCATION_NAME: 'Rhu',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4640323,
        LOCATION_LATITUDE_DEG: 55.8240254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007200',
        LOCATION_NAME: 'Rhu',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7793728,
        LOCATION_LATITUDE_DEG: 56.0172357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007300',
        LOCATION_NAME: 'Rhuallt',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3877968,
        LOCATION_LATITUDE_DEG: 53.2644529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007400',
        LOCATION_NAME: 'Rhuda Ban',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3075744,
        LOCATION_LATITUDE_DEG: 57.0850633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007500',
        LOCATION_NAME: 'Rhuddal Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6559015,
        LOCATION_LATITUDE_DEG: 53.1535308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007600',
        LOCATION_NAME: 'Rhuddlan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4638911,
        LOCATION_LATITUDE_DEG: 53.2914587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007700',
        LOCATION_NAME: 'Rhue',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2103771,
        LOCATION_LATITUDE_DEG: 57.9230324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007800',
        LOCATION_NAME: 'Rhugashinish',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2898204,
        LOCATION_LATITUDE_DEG: 57.3802927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH007900',
        LOCATION_NAME: 'Rhulen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2599981,
        LOCATION_LATITUDE_DEG: 52.1402401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008000',
        LOCATION_NAME: 'Rhuvanish',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.167768,
        LOCATION_LATITUDE_DEG: 57.7142272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008100',
        LOCATION_NAME: 'Rhyd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0293994,
        LOCATION_LATITUDE_DEG: 52.957031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008200',
        LOCATION_NAME: 'Rhyd Ddu',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1355683,
        LOCATION_LATITUDE_DEG: 53.0521752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008300',
        LOCATION_NAME: 'Rhyd Uchaf',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6392882,
        LOCATION_LATITUDE_DEG: 52.92582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH011100',
        LOCATION_NAME: 'Rhyd y Benllig',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH011200',
        LOCATION_NAME: 'Rhyd y Foel',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH011300',
        LOCATION_NAME: 'Rhyd y Meudwy',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.302071,
        LOCATION_LATITUDE_DEG: 53.0504989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008400',
        LOCATION_NAME: 'Rhyd y Sarn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9399589,
        LOCATION_LATITUDE_DEG: 52.9604312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008800',
        LOCATION_NAME: 'Rhydargaeau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2711225,
        LOCATION_LATITUDE_DEG: 51.9130333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008900',
        LOCATION_NAME: 'Rhydcymerau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0716236,
        LOCATION_LATITUDE_DEG: 52.0277452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009000',
        LOCATION_NAME: 'Rhyddings',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8090107,
        LOCATION_LATITUDE_DEG: 51.6721344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009100',
        LOCATION_NAME: 'Rhyddlan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2063618,
        LOCATION_LATITUDE_DEG: 52.0652462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009200',
        LOCATION_NAME: 'Rhydlanfair',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7427156,
        LOCATION_LATITUDE_DEG: 53.0588407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009300',
        LOCATION_NAME: 'Rhydlewis',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4131884,
        LOCATION_LATITUDE_DEG: 52.0998543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009400',
        LOCATION_NAME: 'Rhydlydan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6518275,
        LOCATION_LATITUDE_DEG: 53.0444389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009500',
        LOCATION_NAME: 'Rhydowen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2715185,
        LOCATION_LATITUDE_DEG: 52.0831458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009600',
        LOCATION_NAME: 'Rhydwyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5326348,
        LOCATION_LATITUDE_DEG: 53.3703731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008500',
        LOCATION_NAME: 'Rhyd-y-Benllig',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2604634,
        LOCATION_LATITUDE_DEG: 52.9298305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009700',
        LOCATION_NAME: 'Rhydybont',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1356808,
        LOCATION_LATITUDE_DEG: 52.0692467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009800',
        LOCATION_NAME: 'Rhydyclafdy',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4847358,
        LOCATION_LATITUDE_DEG: 52.8855127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH009900',
        LOCATION_NAME: 'Rhydycroesau',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1227089,
        LOCATION_LATITUDE_DEG: 52.866515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010100',
        LOCATION_NAME: 'Rhydyfelin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0692887,
        LOCATION_LATITUDE_DEG: 52.3895787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010000',
        LOCATION_NAME: 'Rhydyfelin',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3104797,
        LOCATION_LATITUDE_DEG: 51.5870914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008600',
        LOCATION_NAME: 'Rhyd-y-Foel',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6308069,
        LOCATION_LATITUDE_DEG: 53.2776587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010200',
        LOCATION_NAME: 'Rhydymain',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7711783,
        LOCATION_LATITUDE_DEG: 52.7826148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH008700',
        LOCATION_NAME: 'Rhyd-y-Meudwy',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.300899,
        LOCATION_LATITUDE_DEG: 53.0492351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010300',
        LOCATION_NAME: 'Rhydymwyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1876989,
        LOCATION_LATITUDE_DEG: 53.1923443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010400',
        LOCATION_NAME: 'Rhydypandy',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.925662,
        LOCATION_LATITUDE_DEG: 51.6983118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010500',
        LOCATION_NAME: 'Rhyl',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4873493,
        LOCATION_LATITUDE_DEG: 53.3192551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010600',
        LOCATION_NAME: 'Rhymney',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2840809,
        LOCATION_LATITUDE_DEG: 51.759109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010700',
        LOCATION_NAME: 'Rhymney Bridge',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2940417,
        LOCATION_LATITUDE_DEG: 51.7674078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010800',
        LOCATION_NAME: 'Rhynd',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3637363,
        LOCATION_LATITUDE_DEG: 56.3657576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH011000',
        LOCATION_NAME: 'Rhynie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9374368,
        LOCATION_LATITUDE_DEG: 57.7876031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH010900',
        LOCATION_NAME: 'Rhynie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8335598,
        LOCATION_LATITUDE_DEG: 57.3324415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000100',
        LOCATION_NAME: 'Ribbesford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3096737,
        LOCATION_LATITUDE_DEG: 52.362654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000200',
        LOCATION_NAME: 'Ribbleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6619942,
        LOCATION_LATITUDE_DEG: 53.7745948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000300',
        LOCATION_NAME: 'Ribchester',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5304884,
        LOCATION_LATITUDE_DEG: 53.8134976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000400',
        LOCATION_NAME: 'Riber',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.537498,
        LOCATION_LATITUDE_DEG: 53.1276214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000500',
        LOCATION_NAME: 'Riby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2132903,
        LOCATION_LATITUDE_DEG: 53.551938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000600',
        LOCATION_NAME: 'Riccall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.058263,
        LOCATION_LATITUDE_DEG: 53.8332763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000700',
        LOCATION_NAME: 'Riccarton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.319559,
        LOCATION_LATITUDE_DEG: 55.9088075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000800',
        LOCATION_NAME: 'Richards Castle',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7406413,
        LOCATION_LATITUDE_DEG: 52.3216532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI000900',
        LOCATION_NAME: 'Richborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3350239,
        LOCATION_LATITUDE_DEG: 51.2828027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001000',
        LOCATION_NAME: 'Richborough Port',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3489754,
        LOCATION_LATITUDE_DEG: 51.3034011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001100',
        LOCATION_NAME: 'Richhill',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5484915,
        LOCATION_LATITUDE_DEG: 54.368897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001200',
        LOCATION_NAME: 'Richings Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'SL0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5061398,
        LOCATION_LATITUDE_DEG: 51.5023525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001400',
        LOCATION_NAME: 'Richmond',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7350906,
        LOCATION_LATITUDE_DEG: 54.4050443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001300',
        LOCATION_NAME: 'Richmond',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'TW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3019624,
        LOCATION_LATITUDE_DEG: 51.4609381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001600',
        LOCATION_NAME: 'Rickarton',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3010232,
        LOCATION_LATITUDE_DEG: 56.993302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001700',
        LOCATION_NAME: 'Rickerby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9125636,
        LOCATION_LATITUDE_DEG: 54.9041069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001800',
        LOCATION_NAME: 'Rickeston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0801207,
        LOCATION_LATITUDE_DEG: 51.7403275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001850',
        LOCATION_NAME: 'Rickeston Bridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0924894,
        LOCATION_LATITUDE_DEG: 51.7417385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001900',
        LOCATION_NAME: 'Rickford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7368583,
        LOCATION_LATITUDE_DEG: 51.3310622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002000',
        LOCATION_NAME: 'Rickinghall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9937256,
        LOCATION_LATITUDE_DEG: 52.3359039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002100',
        LOCATION_NAME: 'Rickleton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5595868,
        LOCATION_LATITUDE_DEG: 54.8753869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002200',
        LOCATION_NAME: 'Rickling',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.181176,
        LOCATION_LATITUDE_DEG: 51.9609793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002300',
        LOCATION_NAME: 'Rickling Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1966211,
        LOCATION_LATITUDE_DEG: 51.9460778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002400',
        LOCATION_NAME: 'Rickmansworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4676233,
        LOCATION_LATITUDE_DEG: 51.6383623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002500',
        LOCATION_NAME: 'Rickney',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3090015,
        LOCATION_LATITUDE_DEG: 50.839671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002600',
        LOCATION_NAME: 'Riddings',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3652077,
        LOCATION_LATITUDE_DEG: 53.0658109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002700',
        LOCATION_NAME: 'Riddlecombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9744135,
        LOCATION_LATITUDE_DEG: 50.9082363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002800',
        LOCATION_NAME: 'Riddlesden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8816108,
        LOCATION_LATITUDE_DEG: 53.8794944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002850',
        LOCATION_NAME: 'Riddlesworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8912906,
        LOCATION_LATITUDE_DEG: 52.4001116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI002900',
        LOCATION_NAME: 'Riddrie',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1906241,
        LOCATION_LATITUDE_DEG: 55.8700186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003000',
        LOCATION_NAME: 'Ridgacre',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9963057,
        LOCATION_LATITUDE_DEG: 52.456756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003100',
        LOCATION_NAME: 'Ridge',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2430133,
        LOCATION_LATITUDE_DEG: 51.6886624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003300',
        LOCATION_NAME: 'Ridge Lane',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5673275,
        LOCATION_LATITUDE_DEG: 52.5513597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003400',
        LOCATION_NAME: 'Ridgegrove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3453395,
        LOCATION_LATITUDE_DEG: 50.6391092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003500',
        LOCATION_NAME: 'Ridgehill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7136599,
        LOCATION_LATITUDE_DEG: 52.0175238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003600',
        LOCATION_NAME: 'Ridgewardine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4756717,
        LOCATION_LATITUDE_DEG: 52.9394126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003800',
        LOCATION_NAME: 'Ridgeway',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4696157,
        LOCATION_LATITUDE_DEG: 50.6567952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003700',
        LOCATION_NAME: 'Ridgeway',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4584175,
        LOCATION_LATITUDE_DEG: 53.0585131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003900',
        LOCATION_NAME: 'Ridgeway',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3950016,
        LOCATION_LATITUDE_DEG: 53.3303368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004000',
        LOCATION_NAME: 'Ridgewell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5334712,
        LOCATION_LATITUDE_DEG: 52.0388878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004100',
        LOCATION_NAME: 'Ridgewood',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1007573,
        LOCATION_LATITUDE_DEG: 50.9552851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004200',
        LOCATION_NAME: 'Ridgmont',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5771091,
        LOCATION_LATITUDE_DEG: 52.0148958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004300',
        LOCATION_NAME: 'Riding Gate',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3790389,
        LOCATION_LATITUDE_DEG: 51.0654313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004400',
        LOCATION_NAME: 'Riding Mill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9718793,
        LOCATION_LATITUDE_DEG: 54.9477033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004450',
        LOCATION_NAME: 'Ridley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6597092,
        LOCATION_LATITUDE_DEG: 53.0818848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004500',
        LOCATION_NAME: 'Ridley Wood',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8986648,
        LOCATION_LATITUDE_DEG: 53.0582848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004700',
        LOCATION_NAME: 'Ridlington',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.747862,
        LOCATION_LATITUDE_DEG: 52.6155626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI990139',
        LOCATION_NAME: 'Ridlington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7426886,
        LOCATION_LATITUDE_DEG: 52.6167036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004600',
        LOCATION_NAME: 'Ridlington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4832244,
        LOCATION_LATITUDE_DEG: 52.8257454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004800',
        LOCATION_NAME: 'Ridsdale',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1428819,
        LOCATION_LATITUDE_DEG: 55.1541204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI004900',
        LOCATION_NAME: 'Rievaulx',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1138164,
        LOCATION_LATITUDE_DEG: 54.2593184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005000',
        LOCATION_NAME: 'Rigg',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1064099,
        LOCATION_LATITUDE_DEG: 54.9915213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005100',
        LOCATION_NAME: 'Riggend',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9766173,
        LOCATION_LATITUDE_DEG: 55.9089197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005300',
        LOCATION_NAME: 'Riggs Head',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4505146,
        LOCATION_LATITUDE_DEG: 54.2700119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005400',
        LOCATION_NAME: 'Rigsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.144287,
        LOCATION_LATITUDE_DEG: 53.2557084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005500',
        LOCATION_NAME: 'Rigside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7796787,
        LOCATION_LATITUDE_DEG: 55.5964825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005600',
        LOCATION_NAME: 'Riley Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5801959,
        LOCATION_LATITUDE_DEG: 53.7226923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005700',
        LOCATION_NAME: 'Riley Hill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8267003,
        LOCATION_LATITUDE_DEG: 52.735579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005800',
        LOCATION_NAME: 'Rilla Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4068401,
        LOCATION_LATITUDE_DEG: 50.532104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI005900',
        LOCATION_NAME: 'Rillaton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4010475,
        LOCATION_LATITUDE_DEG: 50.5380977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006000',
        LOCATION_NAME: 'Rillington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6933605,
        LOCATION_LATITUDE_DEG: 54.1577106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006100',
        LOCATION_NAME: 'Rimington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2855673,
        LOCATION_LATITUDE_DEG: 53.9084989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006200',
        LOCATION_NAME: 'Rimpton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5566658,
        LOCATION_LATITUDE_DEG: 50.9942217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006300',
        LOCATION_NAME: 'Rimswell',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0130239,
        LOCATION_LATITUDE_DEG: 53.7403546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006400',
        LOCATION_NAME: 'Rindleford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3856086,
        LOCATION_LATITUDE_DEG: 52.556773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006800',
        LOCATION_NAME: 'Ringford',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0446556,
        LOCATION_LATITUDE_DEG: 54.8971152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013600',
        LOCATION_NAME: 'Ringinglow',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5673062,
        LOCATION_LATITUDE_DEG: 53.3515018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006900',
        LOCATION_NAME: 'Ringland',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.158118,
        LOCATION_LATITUDE_DEG: 52.6816413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007000',
        LOCATION_NAME: 'Ringles Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1020769,
        LOCATION_LATITUDE_DEG: 50.9819932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007100',
        LOCATION_NAME: 'Ringmer',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0569517,
        LOCATION_LATITUDE_DEG: 50.8926803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007200',
        LOCATION_NAME: 'Ringmore',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8924642,
        LOCATION_LATITUDE_DEG: 50.297576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006600',
        LOCATION_NAME: "Ring's End",
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0646467,
        LOCATION_LATITUDE_DEG: 52.6034473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007300',
        LOCATION_NAME: 'Ringsend',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7489599,
        LOCATION_LATITUDE_DEG: 55.0332544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007400',
        LOCATION_NAME: 'Ringsfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5334512,
        LOCATION_LATITUDE_DEG: 52.4462056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007600',
        LOCATION_NAME: 'Ringshall',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5709062,
        LOCATION_LATITUDE_DEG: 51.8191792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007500',
        LOCATION_NAME: 'Ringshall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9794368,
        LOCATION_LATITUDE_DEG: 52.1362926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007700',
        LOCATION_NAME: 'Ringstead',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3406467,
        LOCATION_LATITUDE_DEG: 50.6364857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007900',
        LOCATION_NAME: 'Ringstead',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.553153,
        LOCATION_LATITUDE_DEG: 52.3649296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI007800',
        LOCATION_NAME: 'Ringstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5402426,
        LOCATION_LATITUDE_DEG: 52.9326739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008100',
        LOCATION_NAME: 'Ringway',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2818496,
        LOCATION_LATITUDE_DEG: 53.3497508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013800',
        LOCATION_NAME: 'Ringway',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2727935,
        LOCATION_LATITUDE_DEG: 53.3785119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013700',
        LOCATION_NAME: 'Ringway Airport',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2664087,
        LOCATION_LATITUDE_DEG: 53.3623989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008200',
        LOCATION_NAME: 'Ringwood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7793991,
        LOCATION_LATITUDE_DEG: 50.8495025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008300',
        LOCATION_NAME: 'Ringwould',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3774434,
        LOCATION_LATITUDE_DEG: 51.1836878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008900',
        LOCATION_NAME: 'Ripe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1451074,
        LOCATION_LATITUDE_DEG: 50.8699824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009200',
        LOCATION_NAME: 'Ripley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7705389,
        LOCATION_LATITUDE_DEG: 50.7876996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009000',
        LOCATION_NAME: 'Ripley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5661007,
        LOCATION_LATITUDE_DEG: 54.0397049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009300',
        LOCATION_NAME: 'Ripley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4056417,
        LOCATION_LATITUDE_DEG: 53.0505115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009100',
        LOCATION_NAME: 'Ripley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4908175,
        LOCATION_LATITUDE_DEG: 51.299833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009400',
        LOCATION_NAME: 'Riplingham',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.539311,
        LOCATION_LATITUDE_DEG: 53.7739697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009500',
        LOCATION_NAME: 'Ripon',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5226639,
        LOCATION_LATITUDE_DEG: 54.1386135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009600',
        LOCATION_NAME: 'Rippingale',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3691492,
        LOCATION_LATITUDE_DEG: 52.8362741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009700',
        LOCATION_NAME: 'Ripple',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1833025,
        LOCATION_LATITUDE_DEG: 52.0378228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009800',
        LOCATION_NAME: 'Ripple',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3587824,
        LOCATION_LATITUDE_DEG: 51.1996902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI009900',
        LOCATION_NAME: 'Ripponden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9398667,
        LOCATION_LATITUDE_DEG: 53.6745784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010000',
        LOCATION_NAME: 'Risbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6607017,
        LOCATION_LATITUDE_DEG: 52.1916428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010100',
        LOCATION_NAME: 'Risby',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.63876,
        LOCATION_LATITUDE_DEG: 52.2656043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010200',
        LOCATION_NAME: 'Risca',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1015186,
        LOCATION_LATITUDE_DEG: 51.6122869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010300',
        LOCATION_NAME: 'Rise',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2539935,
        LOCATION_LATITUDE_DEG: 53.860775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010400',
        LOCATION_NAME: 'Rise Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1670133,
        LOCATION_LATITUDE_DEG: 53.0147996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010500',
        LOCATION_NAME: 'Riseholme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5376126,
        LOCATION_LATITUDE_DEG: 53.2641187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010700',
        LOCATION_NAME: 'Riseley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9630781,
        LOCATION_LATITUDE_DEG: 51.3632426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010600',
        LOCATION_NAME: 'Riseley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4776375,
        LOCATION_LATITUDE_DEG: 52.2516159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010800',
        LOCATION_NAME: 'Rishangles',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1791296,
        LOCATION_LATITUDE_DEG: 52.2633974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI010900',
        LOCATION_NAME: 'Rishton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4146745,
        LOCATION_LATITUDE_DEG: 53.7678937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011000',
        LOCATION_NAME: 'Rishworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9512382,
        LOCATION_LATITUDE_DEG: 53.6598773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011100',
        LOCATION_NAME: 'Rising Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3298173,
        LOCATION_LATITUDE_DEG: 53.7239846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011200',
        LOCATION_NAME: 'Rising Sun',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2607929,
        LOCATION_LATITUDE_DEG: 50.5110961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011300',
        LOCATION_NAME: 'Risinghurst',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1885277,
        LOCATION_LATITUDE_DEG: 51.7588796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011400',
        LOCATION_NAME: 'Risley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5253769,
        LOCATION_LATITUDE_DEG: 53.4317587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011500',
        LOCATION_NAME: 'Risley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3182777,
        LOCATION_LATITUDE_DEG: 52.9156902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011600',
        LOCATION_NAME: 'Risplith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6206725,
        LOCATION_LATITUDE_DEG: 54.1145133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011700',
        LOCATION_NAME: 'Riston Grange',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3073658,
        LOCATION_LATITUDE_DEG: 53.8760768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013500',
        LOCATION_NAME: 'Rivelin',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5193723,
        LOCATION_LATITUDE_DEG: 53.3973548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011800',
        LOCATION_NAME: 'Rivenhall',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.654141,
        LOCATION_LATITUDE_DEG: 51.8259646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI011900',
        LOCATION_NAME: 'Rivenhall End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6665661,
        LOCATION_LATITUDE_DEG: 51.8173636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012000',
        LOCATION_NAME: 'River',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6598793,
        LOCATION_LATITUDE_DEG: 50.9969991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012200',
        LOCATION_NAME: 'River',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2684024,
        LOCATION_LATITUDE_DEG: 51.1327931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012300',
        LOCATION_NAME: 'River Common',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.647077,
        LOCATION_LATITUDE_DEG: 51.0079049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012500',
        LOCATION_NAME: 'Riverhead',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1716659,
        LOCATION_LATITUDE_DEG: 51.2844171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012600',
        LOCATION_NAME: 'Rivers Corner',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3173423,
        LOCATION_LATITUDE_DEG: 50.9114155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013300',
        LOCATION_NAME: 'Rixon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2932323,
        LOCATION_LATITUDE_DEG: 50.9276128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013400',
        LOCATION_NAME: 'Rixton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4703417,
        LOCATION_LATITUDE_DEG: 53.4084531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000100',
        LOCATION_NAME: 'Roa Island',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1729016,
        LOCATION_LATITUDE_DEG: 54.0738258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000200',
        LOCATION_NAME: 'Roachill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6417554,
        LOCATION_LATITUDE_DEG: 50.9927353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000400',
        LOCATION_NAME: 'Roade',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8923762,
        LOCATION_LATITUDE_DEG: 52.1583148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000600',
        LOCATION_NAME: 'Roadhead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7560624,
        LOCATION_LATITUDE_DEG: 55.0665251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000700',
        LOCATION_NAME: 'Roadmeetings',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8055306,
        LOCATION_LATITUDE_DEG: 55.7292957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000800',
        LOCATION_NAME: 'Roadwater',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3896191,
        LOCATION_LATITUDE_DEG: 51.132352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000900',
        LOCATION_NAME: 'Roag',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5444398,
        LOCATION_LATITUDE_DEG: 57.404394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001000',
        LOCATION_NAME: 'Roall',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1361331,
        LOCATION_LATITUDE_DEG: 53.7142679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001100',
        LOCATION_NAME: 'Roath',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1685435,
        LOCATION_LATITUDE_DEG: 51.4857839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001200',
        LOCATION_NAME: 'Roberton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6700902,
        LOCATION_LATITUDE_DEG: 55.5407813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001300',
        LOCATION_NAME: 'Robertsbridge',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4761118,
        LOCATION_LATITUDE_DEG: 50.9849865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001600',
        LOCATION_NAME: 'Roberttown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7009319,
        LOCATION_LATITUDE_DEG: 53.6989764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001700',
        LOCATION_NAME: 'Robeston Wathen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7760949,
        LOCATION_LATITUDE_DEG: 51.807227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001800',
        LOCATION_NAME: 'Robeston West',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0649911,
        LOCATION_LATITUDE_DEG: 51.7424235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO038100',
        LOCATION_NAME: 'Robin Hood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8356539,
        LOCATION_LATITUDE_DEG: 52.4218734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001900',
        LOCATION_NAME: 'Robin Hood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5068603,
        LOCATION_LATITUDE_DEG: 53.7411774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002000',
        LOCATION_NAME: 'Robin Hoods Bay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5333563,
        LOCATION_LATITUDE_DEG: 54.4342277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002500',
        LOCATION_NAME: 'Roborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1044589,
        LOCATION_LATITUDE_DEG: 50.4380454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002300',
        LOCATION_NAME: 'Roborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0439881,
        LOCATION_LATITUDE_DEG: 51.0945551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002400',
        LOCATION_NAME: 'Roborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0320916,
        LOCATION_LATITUDE_DEG: 50.9328359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002600',
        LOCATION_NAME: 'Roborough Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0923133,
        LOCATION_LATITUDE_DEG: 50.4535924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002700',
        LOCATION_NAME: 'Robridding',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5181829,
        LOCATION_LATITUDE_DEG: 53.1734212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002800',
        LOCATION_NAME: 'Robroyston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1820381,
        LOCATION_LATITUDE_DEG: 55.8959227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002900',
        LOCATION_NAME: 'Robsheugh',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8465789,
        LOCATION_LATITUDE_DEG: 55.062107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003000',
        LOCATION_NAME: 'Roby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.854207,
        LOCATION_LATITUDE_DEG: 53.4096595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003100',
        LOCATION_NAME: 'Roby Mill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7277985,
        LOCATION_LATITUDE_DEG: 53.558674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003200',
        LOCATION_NAME: 'Rocester',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8371389,
        LOCATION_LATITUDE_DEG: 52.9509064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003300',
        LOCATION_NAME: 'Roch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0863855,
        LOCATION_LATITUDE_DEG: 51.8461345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003400',
        LOCATION_NAME: 'Rochdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.156827,
        LOCATION_LATITUDE_DEG: 53.6172743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003500',
        LOCATION_NAME: 'Roche',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8318726,
        LOCATION_LATITUDE_DEG: 50.4069892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003600',
        LOCATION_NAME: 'Roche Abbey',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1825553,
        LOCATION_LATITUDE_DEG: 53.4038397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003800',
        LOCATION_NAME: 'Rochester',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2617567,
        LOCATION_LATITUDE_DEG: 55.2746357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003700',
        LOCATION_NAME: 'Rochester',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5053628,
        LOCATION_LATITUDE_DEG: 51.3893276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004500',
        LOCATION_NAME: 'Rochford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5438098,
        LOCATION_LATITUDE_DEG: 52.3120505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004400',
        LOCATION_NAME: 'Rochford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7084361,
        LOCATION_LATITUDE_DEG: 51.58334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004700',
        LOCATION_NAME: 'Rock',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8808024,
        LOCATION_LATITUDE_DEG: 54.5537156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005000',
        LOCATION_NAME: 'Rock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9041364,
        LOCATION_LATITUDE_DEG: 50.5480043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004900',
        LOCATION_NAME: 'Rock',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3880664,
        LOCATION_LATITUDE_DEG: 52.3384519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004800',
        LOCATION_NAME: 'Rock',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6777276,
        LOCATION_LATITUDE_DEG: 55.4750475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005200',
        LOCATION_NAME: 'Rock Green',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6987251,
        LOCATION_LATITUDE_DEG: 52.3760637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005300',
        LOCATION_NAME: 'Rockbeare',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3856257,
        LOCATION_LATITUDE_DEG: 50.7438084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005400',
        LOCATION_NAME: 'Rockbourne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8380451,
        LOCATION_LATITUDE_DEG: 50.964013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005700',
        LOCATION_NAME: 'Rockcliffe',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9992984,
        LOCATION_LATITUDE_DEG: 54.9461166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006150',
        LOCATION_NAME: 'Rockfield',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6789675,
        LOCATION_LATITUDE_DEG: 54.4292058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006100',
        LOCATION_NAME: 'Rockfield',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8144595,
        LOCATION_LATITUDE_DEG: 57.8229016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006000',
        LOCATION_NAME: 'Rockfield',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7535074,
        LOCATION_LATITUDE_DEG: 51.8318058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006200',
        LOCATION_NAME: 'Rockford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7722258,
        LOCATION_LATITUDE_DEG: 50.8697061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006300',
        LOCATION_NAME: 'Rockhampton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5003685,
        LOCATION_LATITUDE_DEG: 51.6373853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006600',
        LOCATION_NAME: 'Rockingham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7237751,
        LOCATION_LATITUDE_DEG: 52.5182517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006800',
        LOCATION_NAME: 'Rockland All Saints',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9361226,
        LOCATION_LATITUDE_DEG: 52.5312275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036600',
        LOCATION_NAME: 'Rockland St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036700',
        LOCATION_NAME: 'Rockland St Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006900',
        LOCATION_NAME: 'Rockland St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4133602,
        LOCATION_LATITUDE_DEG: 52.5854275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007000',
        LOCATION_NAME: 'Rockland St. Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9351023,
        LOCATION_LATITUDE_DEG: 52.5347246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037100',
        LOCATION_NAME: 'Rockleaze',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6280314,
        LOCATION_LATITUDE_DEG: 51.4727479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007200',
        LOCATION_NAME: 'Rockley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7610645,
        LOCATION_LATITUDE_DEG: 51.4436563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007100',
        LOCATION_NAME: 'Rockley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9257375,
        LOCATION_LATITUDE_DEG: 53.2643188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO038300',
        LOCATION_NAME: 'Rockvilla',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2608908,
        LOCATION_LATITUDE_DEG: 55.8772866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007400',
        LOCATION_NAME: 'Rockwell Green',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2425305,
        LOCATION_LATITUDE_DEG: 50.9728324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007500',
        LOCATION_NAME: 'Rodborough',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2201987,
        LOCATION_LATITUDE_DEG: 51.7331939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007600',
        LOCATION_NAME: 'Rodborough Common',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2100005,
        LOCATION_LATITUDE_DEG: 51.7231953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007700',
        LOCATION_NAME: 'Rodborough Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2230957,
        LOCATION_LATITUDE_DEG: 51.7391952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007800',
        LOCATION_NAME: 'Rodbourne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0982926,
        LOCATION_LATITUDE_DEG: 51.5475693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007900',
        LOCATION_NAME: 'Rodbourne Cheney',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8037604,
        LOCATION_LATITUDE_DEG: 51.5744686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008000',
        LOCATION_NAME: 'Roddam',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9609025,
        LOCATION_LATITUDE_DEG: 55.4771549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008200',
        LOCATION_NAME: 'Rodden',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5504216,
        LOCATION_LATITUDE_DEG: 50.655893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008100',
        LOCATION_NAME: 'Rodden',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2884318,
        LOCATION_LATITUDE_DEG: 51.2276463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008300',
        LOCATION_NAME: 'Roddhurst',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9988267,
        LOCATION_LATITUDE_DEG: 52.2584474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008400',
        LOCATION_NAME: 'Roddymoor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7581934,
        LOCATION_LATITUDE_DEG: 54.7278749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008500',
        LOCATION_NAME: 'Rode',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.281923,
        LOCATION_LATITUDE_DEG: 51.2828516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008600',
        LOCATION_NAME: 'Rode Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2901939,
        LOCATION_LATITUDE_DEG: 53.1113276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008700',
        LOCATION_NAME: 'Rodel',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9603463,
        LOCATION_LATITUDE_DEG: 57.7408261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008800',
        LOCATION_NAME: 'Roden',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6310372,
        LOCATION_LATITUDE_DEG: 52.7448967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009000',
        LOCATION_NAME: 'Rodgrove',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3552318,
        LOCATION_LATITUDE_DEG: 51.0318264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009100',
        LOCATION_NAME: 'Rodhuish',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4069973,
        LOCATION_LATITUDE_DEG: 51.1463451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009200',
        LOCATION_NAME: 'Rodington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6085115,
        LOCATION_LATITUDE_DEG: 52.7252887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009300',
        LOCATION_NAME: 'Rodley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.366851,
        LOCATION_LATITUDE_DEG: 51.805601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009350',
        LOCATION_NAME: 'Rodley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6608685,
        LOCATION_LATITUDE_DEG: 53.8228296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009400',
        LOCATION_NAME: 'Rodmarton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0823211,
        LOCATION_LATITUDE_DEG: 51.6803894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009500',
        LOCATION_NAME: 'Rodmell',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0143194,
        LOCATION_LATITUDE_DEG: 50.8350759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009600',
        LOCATION_NAME: 'Rodmersham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7623187,
        LOCATION_LATITUDE_DEG: 51.3204124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009700',
        LOCATION_NAME: 'Rodney Stoke',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7350246,
        LOCATION_LATITUDE_DEG: 51.2468543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009800',
        LOCATION_NAME: 'Rodsley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6988771,
        LOCATION_LATITUDE_DEG: 52.9582064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO009900',
        LOCATION_NAME: 'Rodway',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5009967,
        LOCATION_LATITUDE_DEG: 52.7623927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010000',
        LOCATION_NAME: 'Rodwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.455685,
        LOCATION_LATITUDE_DEG: 50.6017898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010100',
        LOCATION_NAME: 'Roeburndale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6074586,
        LOCATION_LATITUDE_DEG: 54.0697221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010200',
        LOCATION_NAME: 'Roecliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4257404,
        LOCATION_LATITUDE_DEG: 54.0871076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010300',
        LOCATION_NAME: 'Roedean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0890158,
        LOCATION_LATITUDE_DEG: 50.8127811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037600',
        LOCATION_NAME: 'Roehampton',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2370642,
        LOCATION_LATITUDE_DEG: 51.4526144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010500',
        LOCATION_NAME: 'Roffey',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2914254,
        LOCATION_LATITUDE_DEG: 51.0767079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010600',
        LOCATION_NAME: 'Rogart',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1351237,
        LOCATION_LATITUDE_DEG: 58.003526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010700',
        LOCATION_NAME: 'Rogate',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8491872,
        LOCATION_LATITUDE_DEG: 51.0076063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010800',
        LOCATION_NAME: 'Roger Ground',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9985626,
        LOCATION_LATITUDE_DEG: 54.3688569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010900',
        LOCATION_NAME: 'Rogerscale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3302589,
        LOCATION_LATITUDE_DEG: 54.6276884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011000',
        LOCATION_NAME: 'Rogerstone',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0584036,
        LOCATION_LATITUDE_DEG: 51.591191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011100',
        LOCATION_NAME: 'Rogerton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1863638,
        LOCATION_LATITUDE_DEG: 55.7845067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011200',
        LOCATION_NAME: 'Rogiet',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7788476,
        LOCATION_LATITUDE_DEG: 51.5881811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011300',
        LOCATION_NAME: 'Roils Head',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9106046,
        LOCATION_LATITUDE_DEG: 53.7307784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011400',
        LOCATION_NAME: 'Roke',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0917947,
        LOCATION_LATITUDE_DEG: 51.6349662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011500',
        LOCATION_NAME: 'Rollesby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6225769,
        LOCATION_LATITUDE_DEG: 52.6870341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011600',
        LOCATION_NAME: 'Rolleston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9201844,
        LOCATION_LATITUDE_DEG: 52.5967588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011700',
        LOCATION_NAME: 'Rolleston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8903529,
        LOCATION_LATITUDE_DEG: 53.0647036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011800',
        LOCATION_NAME: 'Rolls Mill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.320131,
        LOCATION_LATITUDE_DEG: 50.9177123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO011900',
        LOCATION_NAME: 'Rolston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1540002,
        LOCATION_LATITUDE_DEG: 53.8917692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012000',
        LOCATION_NAME: 'Rolvenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6322791,
        LOCATION_LATITUDE_DEG: 51.0507882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012100',
        LOCATION_NAME: 'Rolvenden Layne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6458518,
        LOCATION_LATITUDE_DEG: 51.0412884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012200',
        LOCATION_NAME: 'Romaldkirk',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0089618,
        LOCATION_LATITUDE_DEG: 54.5934616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012300',
        LOCATION_NAME: 'Roman Bank',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3397001,
        LOCATION_LATITUDE_DEG: 53.1626963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012400',
        LOCATION_NAME: 'Roman Bridge',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9214003,
        LOCATION_LATITUDE_DEG: 53.0452358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012500',
        LOCATION_NAME: 'Romanby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.445391,
        LOCATION_LATITUDE_DEG: 54.3329371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012600',
        LOCATION_NAME: 'Romanno Bridge',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3372596,
        LOCATION_LATITUDE_DEG: 55.7176804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012700',
        LOCATION_NAME: 'Romansleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8106445,
        LOCATION_LATITUDE_DEG: 50.9698403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012800',
        LOCATION_NAME: 'Romford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1854461,
        LOCATION_LATITUDE_DEG: 51.5737426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO012900',
        LOCATION_NAME: 'Romiley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0859303,
        LOCATION_LATITUDE_DEG: 53.4136544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013000',
        LOCATION_NAME: 'Romney Marsh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9253642,
        LOCATION_LATITUDE_DEG: 51.0152804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013100',
        LOCATION_NAME: 'Romsey',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.497422,
        LOCATION_LATITUDE_DEG: 50.9884144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013300',
        LOCATION_NAME: 'Romsley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.322974,
        LOCATION_LATITUDE_DEG: 52.446362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013200',
        LOCATION_NAME: 'Romsley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0563443,
        LOCATION_LATITUDE_DEG: 52.413055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013600',
        LOCATION_NAME: 'Rood End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9989982,
        LOCATION_LATITUDE_DEG: 52.4967391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013700',
        LOCATION_NAME: 'Rookby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3058726,
        LOCATION_LATITUDE_DEG: 54.4934621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013750',
        LOCATION_NAME: 'Rookery',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2202704,
        LOCATION_LATITUDE_DEG: 53.0994848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013800',
        LOCATION_NAME: 'Rookery Lane',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.066058,
        LOCATION_LATITUDE_DEG: 52.3495654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013900',
        LOCATION_NAME: 'Rookham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6433532,
        LOCATION_LATITUDE_DEG: 51.2369532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014000',
        LOCATION_NAME: 'Rookhope',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0940099,
        LOCATION_LATITUDE_DEG: 54.7796863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014100',
        LOCATION_NAME: 'Rookley',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2799408,
        LOCATION_LATITUDE_DEG: 50.653979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014200',
        LOCATION_NAME: 'Rooksbridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9143842,
        LOCATION_LATITUDE_DEG: 51.2636219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014300',
        LOCATION_NAME: 'Rooksley',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7706513,
        LOCATION_LATITUDE_DEG: 52.0440063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014400',
        LOCATION_NAME: 'Rookwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6851704,
        LOCATION_LATITUDE_DEG: 54.2743343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014700',
        LOCATION_NAME: 'Roos',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0423808,
        LOCATION_LATITUDE_DEG: 53.7544587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014800',
        LOCATION_NAME: 'Roose',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1875579,
        LOCATION_LATITUDE_DEG: 54.1128298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014900',
        LOCATION_NAME: 'Roosebeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1397235,
        LOCATION_LATITUDE_DEG: 54.0980288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015300',
        LOCATION_NAME: 'Ropehaugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2293045,
        LOCATION_LATITUDE_DEG: 54.8101895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015400',
        LOCATION_NAME: 'Ropley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0763975,
        LOCATION_LATITUDE_DEG: 51.0825152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015500',
        LOCATION_NAME: 'Ropsley',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5225077,
        LOCATION_LATITUDE_DEG: 52.8953854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015600',
        LOCATION_NAME: 'Rora',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.899381,
        LOCATION_LATITUDE_DEG: 57.5460535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016100',
        LOCATION_NAME: 'Roscroggan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2948288,
        LOCATION_LATITUDE_DEG: 50.230078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016300',
        LOCATION_NAME: 'Rose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1258841,
        LOCATION_LATITUDE_DEG: 50.3507911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036900',
        LOCATION_NAME: 'Rose an Grouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016400',
        LOCATION_NAME: 'Rose Ash',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7239619,
        LOCATION_LATITUDE_DEG: 50.9824398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016500',
        LOCATION_NAME: 'Rose Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7276948,
        LOCATION_LATITUDE_DEG: 50.7818858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016800',
        LOCATION_NAME: 'Roseacre',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.855782,
        LOCATION_LATITUDE_DEG: 53.8243017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016700',
        LOCATION_NAME: 'Rose-an-Grouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4561935,
        LOCATION_LATITUDE_DEG: 50.1634737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016900',
        LOCATION_NAME: 'Rosebank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9009663,
        LOCATION_LATITUDE_DEG: 55.7259951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037000',
        LOCATION_NAME: 'Roseburn',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2342694,
        LOCATION_LATITUDE_DEG: 55.9466538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017000',
        LOCATION_NAME: 'Rosebush',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7992193,
        LOCATION_LATITUDE_DEG: 51.9299389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017200',
        LOCATION_NAME: 'Rosedale Abbey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8863647,
        LOCATION_LATITUDE_DEG: 54.3546278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017300',
        LOCATION_NAME: 'Rosedale East',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9114874,
        LOCATION_LATITUDE_DEG: 54.3706321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017500',
        LOCATION_NAME: 'Rosehall',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5784068,
        LOCATION_LATITUDE_DEG: 57.977931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017600',
        LOCATION_NAME: 'Rosehearty',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1129155,
        LOCATION_LATITUDE_DEG: 57.6968746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017700',
        LOCATION_NAME: 'Rosehill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5024252,
        LOCATION_LATITUDE_DEG: 52.8684037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017800',
        LOCATION_NAME: 'Rosehill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8416273,
        LOCATION_LATITUDE_DEG: 51.5368566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017900',
        LOCATION_NAME: 'Roseisle',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4445439,
        LOCATION_LATITUDE_DEG: 57.6879906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018000',
        LOCATION_NAME: 'Roseland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4285424,
        LOCATION_LATITUDE_DEG: 50.4412923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018100',
        LOCATION_NAME: 'Rosemarket',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9647852,
        LOCATION_LATITUDE_DEG: 51.734526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018200',
        LOCATION_NAME: 'Rosemarkie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.113738,
        LOCATION_LATITUDE_DEG: 57.5910847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018300',
        LOCATION_NAME: 'Rosemount',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3621303,
        LOCATION_LATITUDE_DEG: 55.0162595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018400',
        LOCATION_NAME: 'Rosemundy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.197222,
        LOCATION_LATITUDE_DEG: 50.3083908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018600',
        LOCATION_NAME: 'Rosenannon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8801741,
        LOCATION_LATITUDE_DEG: 50.4582959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018700',
        LOCATION_NAME: 'Rosers Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2070996,
        LOCATION_LATITUDE_DEG: 50.9493834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018800',
        LOCATION_NAME: 'Rosevanion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9148932,
        LOCATION_LATITUDE_DEG: 50.4463023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018900',
        LOCATION_NAME: 'Rosevean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7803776,
        LOCATION_LATITUDE_DEG: 50.387496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019000',
        LOCATION_NAME: 'Rosevear',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7818796,
        LOCATION_LATITUDE_DEG: 50.3883957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019100',
        LOCATION_NAME: 'Rosewarne Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2992318,
        LOCATION_LATITUDE_DEG: 50.2182836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019200',
        LOCATION_NAME: 'Rosewell',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.135837,
        LOCATION_LATITUDE_DEG: 55.8501053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019300',
        LOCATION_NAME: 'Roseworth',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3419922,
        LOCATION_LATITUDE_DEG: 54.5885547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019400',
        LOCATION_NAME: 'Roseworthy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3413851,
        LOCATION_LATITUDE_DEG: 50.2084763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019500',
        LOCATION_NAME: 'Rosgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7146699,
        LOCATION_LATITUDE_DEG: 54.5444704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019800',
        LOCATION_NAME: 'Rosinish',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2852816,
        LOCATION_LATITUDE_DEG: 57.0884648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020000',
        LOCATION_NAME: 'Roskhill',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5293533,
        LOCATION_LATITUDE_DEG: 57.4129893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020100',
        LOCATION_NAME: 'Roskrow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1297161,
        LOCATION_LATITUDE_DEG: 50.1788749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020200',
        LOCATION_NAME: 'Rosley',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0586078,
        LOCATION_LATITUDE_DEG: 54.7977003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020300',
        LOCATION_NAME: 'Roslin',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1660913,
        LOCATION_LATITUDE_DEG: 55.8591056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020400',
        LOCATION_NAME: 'Rosliston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6402957,
        LOCATION_LATITUDE_DEG: 52.7476841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020900',
        LOCATION_NAME: 'Rosneath',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8008873,
        LOCATION_LATITUDE_DEG: 56.0111391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036800',
        LOCATION_NAME: 'Ross on Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022200',
        LOCATION_NAME: 'Rosscor',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -8.0158122,
        LOCATION_LATITUDE_DEG: 54.4666085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022400',
        LOCATION_NAME: 'Rossendale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2739376,
        LOCATION_LATITUDE_DEG: 53.703684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022600',
        LOCATION_NAME: 'Rossett',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9448787,
        LOCATION_LATITUDE_DEG: 53.1086328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022700',
        LOCATION_NAME: 'Rosside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.116699,
        LOCATION_LATITUDE_DEG: 54.1990386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022800',
        LOCATION_NAME: 'Rossie Priory',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.160108,
        LOCATION_LATITUDE_DEG: 56.4641677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023000',
        LOCATION_NAME: 'Rossington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0602141,
        LOCATION_LATITUDE_DEG: 53.4785446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023200',
        LOCATION_NAME: 'Rosskeen Bridge',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1966027,
        LOCATION_LATITUDE_DEG: 57.6930931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023500',
        LOCATION_NAME: 'Rosslea',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1823239,
        LOCATION_LATITUDE_DEG: 54.233181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023600',
        LOCATION_NAME: 'Rosslynlee',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1690635,
        LOCATION_LATITUDE_DEG: 55.8325038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021600',
        LOCATION_NAME: 'Ross-on-Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5823567,
        LOCATION_LATITUDE_DEG: 51.9136162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024400',
        LOCATION_NAME: 'Roster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2605345,
        LOCATION_LATITUDE_DEG: 58.3384528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024500',
        LOCATION_NAME: 'Rostherne',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3855706,
        LOCATION_LATITUDE_DEG: 53.347546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO990063',
        LOCATION_NAME: 'Rostherne Village',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3864836,
        LOCATION_LATITUDE_DEG: 53.3471655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024700',
        LOCATION_NAME: 'Rosthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1455457,
        LOCATION_LATITUDE_DEG: 54.5234772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024800',
        LOCATION_NAME: 'Roston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8087756,
        LOCATION_LATITUDE_DEG: 52.9659049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024900',
        LOCATION_NAME: 'Rostrevor',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2049294,
        LOCATION_LATITUDE_DEG: 54.1041623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025100',
        LOCATION_NAME: 'Rosudgeon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4173519,
        LOCATION_LATITUDE_DEG: 50.1153722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025200',
        LOCATION_NAME: 'Rosyth',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4308341,
        LOCATION_LATITUDE_DEG: 56.029022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025300',
        LOCATION_NAME: 'Rothbury',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9083637,
        LOCATION_LATITUDE_DEG: 55.3099303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025400',
        LOCATION_NAME: 'Rotherby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9989638,
        LOCATION_LATITUDE_DEG: 52.7421712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025500',
        LOCATION_NAME: 'Rotherfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2210549,
        LOCATION_LATITUDE_DEG: 51.0457936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025600',
        LOCATION_NAME: 'Rotherfield Greys',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9528339,
        LOCATION_LATITUDE_DEG: 51.5350601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025700',
        LOCATION_NAME: 'Rotherfield Peppard',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9755419,
        LOCATION_LATITUDE_DEG: 51.5287588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025800',
        LOCATION_NAME: 'Rotherham',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3550703,
        LOCATION_LATITUDE_DEG: 53.4308404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025900',
        LOCATION_NAME: 'Rothersthorpe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9535046,
        LOCATION_LATITUDE_DEG: 52.2031218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026000',
        LOCATION_NAME: 'Rotherwas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6780605,
        LOCATION_LATITUDE_DEG: 52.0390268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026100',
        LOCATION_NAME: 'Rotherwick',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9692861,
        LOCATION_LATITUDE_DEG: 51.3023333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026200',
        LOCATION_NAME: 'Rothes',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2063067,
        LOCATION_LATITUDE_DEG: 57.5271694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026300',
        LOCATION_NAME: 'Rothesay',
        COUNTY_NAME: 'Isle of Bute',
        POSTCODE: 'PA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0529184,
        LOCATION_LATITUDE_DEG: 55.8377213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026400',
        LOCATION_NAME: 'Rothiemay',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7551932,
        LOCATION_LATITUDE_DEG: 57.5229659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026500',
        LOCATION_NAME: 'Rothiemurchus',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.848576,
        LOCATION_LATITUDE_DEG: 57.1334393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026600',
        LOCATION_NAME: 'Rothienorman',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.461631,
        LOCATION_LATITUDE_DEG: 57.4115449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026700',
        LOCATION_NAME: 'Rothley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9351751,
        LOCATION_LATITUDE_DEG: 55.1874207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026800',
        LOCATION_NAME: 'Rothley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1358581,
        LOCATION_LATITUDE_DEG: 52.7088754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO026900',
        LOCATION_NAME: 'Rothwell',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4720833,
        LOCATION_LATITUDE_DEG: 53.7550794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027000',
        LOCATION_NAME: 'Rothwell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8013884,
        LOCATION_LATITUDE_DEG: 52.4225392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027100',
        LOCATION_NAME: 'Rothwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.265377,
        LOCATION_LATITUDE_DEG: 53.4799347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027200',
        LOCATION_NAME: 'Rottingdean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.030827,
        LOCATION_LATITUDE_DEG: 50.8038799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027300',
        LOCATION_NAME: 'Rottington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6023561,
        LOCATION_LATITUDE_DEG: 54.5124801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027400',
        LOCATION_NAME: 'Roud',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2704272,
        LOCATION_LATITUDE_DEG: 50.6196707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027500',
        LOCATION_NAME: 'Roudham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8724659,
        LOCATION_LATITUDE_DEG: 52.4398655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027600',
        LOCATION_NAME: 'Rough Close',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1124344,
        LOCATION_LATITUDE_DEG: 52.9529067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027700',
        LOCATION_NAME: 'Rough Common',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0491649,
        LOCATION_LATITUDE_DEG: 51.2902074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027900',
        LOCATION_NAME: 'Rougham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7132072,
        LOCATION_LATITUDE_DEG: 52.7503514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO027800',
        LOCATION_NAME: 'Rougham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8058695,
        LOCATION_LATITUDE_DEG: 52.2209966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028000',
        LOCATION_NAME: 'Roughlee',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2378465,
        LOCATION_LATITUDE_DEG: 53.8585976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028100',
        LOCATION_NAME: 'Roughley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8008606,
        LOCATION_LATITUDE_DEG: 52.5908684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028200',
        LOCATION_NAME: 'Roughmoor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1295038,
        LOCATION_LATITUDE_DEG: 51.0206391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028300',
        LOCATION_NAME: 'Roughton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3620849,
        LOCATION_LATITUDE_DEG: 52.5448714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028500',
        LOCATION_NAME: 'Roughton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1433865,
        LOCATION_LATITUDE_DEG: 53.1654994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028400',
        LOCATION_NAME: 'Roughton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2997128,
        LOCATION_LATITUDE_DEG: 52.8842593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028600',
        LOCATION_NAME: 'Roughton Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2002413,
        LOCATION_LATITUDE_DEG: 53.154405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028700',
        LOCATION_NAME: 'Roughway',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3158249,
        LOCATION_LATITUDE_DEG: 51.2499119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028800',
        LOCATION_NAME: 'Round Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5135396,
        LOCATION_LATITUDE_DEG: 51.1262988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO028900',
        LOCATION_NAME: 'Round Oak',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8860038,
        LOCATION_LATITUDE_DEG: 52.4576727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029000',
        LOCATION_NAME: 'Round Ring',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1012153,
        LOCATION_LATITUDE_DEG: 50.1714707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029200',
        LOCATION_NAME: 'Roundham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8274878,
        LOCATION_LATITUDE_DEG: 50.8801169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029300',
        LOCATION_NAME: 'Roundhams Foot',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8146821,
        LOCATION_LATITUDE_DEG: 50.8811153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO038500',
        LOCATION_NAME: 'Roundhay',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5084816,
        LOCATION_LATITUDE_DEG: 53.8399836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029500',
        LOCATION_NAME: 'Roundstonefoot',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2925403,
        LOCATION_LATITUDE_DEG: 55.4125581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029600',
        LOCATION_NAME: 'Roundswell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1112004,
        LOCATION_LATITUDE_DEG: 51.0605486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029800',
        LOCATION_NAME: 'Roundthorn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7393154,
        LOCATION_LATITUDE_DEG: 52.9167124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029700',
        LOCATION_NAME: 'Roundthorn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7211982,
        LOCATION_LATITUDE_DEG: 54.6725831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029900',
        LOCATION_NAME: 'Roundthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6043529,
        LOCATION_LATITUDE_DEG: 54.4233543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030100',
        LOCATION_NAME: 'Roundway',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9793842,
        LOCATION_LATITUDE_DEG: 51.3675504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030300',
        LOCATION_NAME: 'Roundyhill',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0147046,
        LOCATION_LATITUDE_DEG: 56.6398767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030400',
        LOCATION_NAME: 'Rous Lench',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9805034,
        LOCATION_LATITUDE_DEG: 52.1782323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030500',
        LOCATION_NAME: 'Rousay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0317522,
        LOCATION_LATITUDE_DEG: 59.1571263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030600',
        LOCATION_NAME: 'Rousham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3073237,
        LOCATION_LATITUDE_DEG: 51.9109955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030700',
        LOCATION_NAME: 'Rousky',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1393697,
        LOCATION_LATITUDE_DEG: 54.7168656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030800',
        LOCATION_NAME: 'Routenbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2421327,
        LOCATION_LATITUDE_DEG: 54.6630862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030900',
        LOCATION_NAME: 'Routh',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3443205,
        LOCATION_LATITUDE_DEG: 53.8683755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031000',
        LOCATION_NAME: 'Row',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6876261,
        LOCATION_LATITUDE_DEG: 50.5553022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031100',
        LOCATION_NAME: 'Row Town',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5051707,
        LOCATION_LATITUDE_DEG: 51.3605339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031200',
        LOCATION_NAME: 'Rowanburn',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9213096,
        LOCATION_LATITUDE_DEG: 55.0888264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031300',
        LOCATION_NAME: 'Rowardennan',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6395188,
        LOCATION_LATITUDE_DEG: 56.1490533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031400',
        LOCATION_NAME: 'Rowarth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9820405,
        LOCATION_LATITUDE_DEG: 53.3992467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031500',
        LOCATION_NAME: 'Rowberrow',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7951778,
        LOCATION_LATITUDE_DEG: 51.3290621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031600',
        LOCATION_NAME: 'Rowde',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0294623,
        LOCATION_LATITUDE_DEG: 51.3628543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031700',
        LOCATION_NAME: 'Rowdefield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0095949,
        LOCATION_LATITUDE_DEG: 51.3588558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031800',
        LOCATION_NAME: 'Roweltown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7774518,
        LOCATION_LATITUDE_DEG: 55.0405156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO031900',
        LOCATION_NAME: 'Rowen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8631752,
        LOCATION_LATITUDE_DEG: 53.2295586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032000',
        LOCATION_NAME: 'Rowfant',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1046222,
        LOCATION_LATITUDE_DEG: 51.116406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032100',
        LOCATION_NAME: 'Rowfoot',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4916546,
        LOCATION_LATITUDE_DEG: 54.9402057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032200',
        LOCATION_NAME: 'Rowhedge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9460248,
        LOCATION_LATITUDE_DEG: 51.8568603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032300',
        LOCATION_NAME: 'Rowhook',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3948792,
        LOCATION_LATITUDE_DEG: 51.1031055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032400',
        LOCATION_NAME: 'Rowington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7028468,
        LOCATION_LATITUDE_DEG: 52.3221446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032500',
        LOCATION_NAME: 'Rowland',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6777323,
        LOCATION_LATITUDE_DEG: 53.2485312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036500',
        LOCATION_NAME: 'Rowlands Castle',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9581695,
        LOCATION_LATITUDE_DEG: 50.8917203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032600',
        LOCATION_NAME: "Rowland's Castle",
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9565923,
        LOCATION_LATITUDE_DEG: 50.8903932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032700',
        LOCATION_NAME: 'Rowlands Gill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7374803,
        LOCATION_LATITUDE_DEG: 54.9217913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032800',
        LOCATION_NAME: 'Rowledge',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8180816,
        LOCATION_LATITUDE_DEG: 51.1818242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO032900',
        LOCATION_NAME: 'Rowler',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2022947,
        LOCATION_LATITUDE_DEG: 52.010007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033000',
        LOCATION_NAME: 'Rowlestone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9115536,
        LOCATION_LATITUDE_DEG: 51.939016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033100',
        LOCATION_NAME: 'Rowley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0261188,
        LOCATION_LATITUDE_DEG: 52.6500862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033200',
        LOCATION_NAME: 'Rowley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.863711,
        LOCATION_LATITUDE_DEG: 54.8261835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033300',
        LOCATION_NAME: 'Rowley Regis',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0423395,
        LOCATION_LATITUDE_DEG: 52.4825617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033400',
        LOCATION_NAME: 'Rowley Village',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0382582,
        LOCATION_LATITUDE_DEG: 52.4802614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033500',
        LOCATION_NAME: 'Rowly',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5047129,
        LOCATION_LATITUDE_DEG: 51.1586142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033600',
        LOCATION_NAME: 'Rowney Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9347739,
        LOCATION_LATITUDE_DEG: 52.3437465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033700',
        LOCATION_NAME: 'Rownhams',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4526592,
        LOCATION_LATITUDE_DEG: 50.9538045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033800',
        LOCATION_NAME: 'Rowrah',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4642843,
        LOCATION_LATITUDE_DEG: 54.5538809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO033900',
        LOCATION_NAME: 'Rowridge',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3646311,
        LOCATION_LATITUDE_DEG: 50.6737814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034000',
        LOCATION_NAME: 'Rowsham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7654649,
        LOCATION_LATITUDE_DEG: 51.8535847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034100',
        LOCATION_NAME: 'Rowsley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6120482,
        LOCATION_LATITUDE_DEG: 53.1893256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034200',
        LOCATION_NAME: 'Rowstock',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3103263,
        LOCATION_LATITUDE_DEG: 51.5975696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034300',
        LOCATION_NAME: 'Rowston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3826038,
        LOCATION_LATITUDE_DEG: 53.0938957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034400',
        LOCATION_NAME: 'Rowton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8269415,
        LOCATION_LATITUDE_DEG: 53.1725413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034500',
        LOCATION_NAME: 'Rowton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5730598,
        LOCATION_LATITUDE_DEG: 52.7749951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034700',
        LOCATION_NAME: 'Roxburgh',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4792708,
        LOCATION_LATITUDE_DEG: 55.5674636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034800',
        LOCATION_NAME: 'Roxby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8233768,
        LOCATION_LATITUDE_DEG: 54.5364459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034900',
        LOCATION_NAME: 'Roxby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.607173,
        LOCATION_LATITUDE_DEG: 53.6411509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035000',
        LOCATION_NAME: 'Roxham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4178782,
        LOCATION_LATITUDE_DEG: 52.5699344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035050',
        LOCATION_NAME: 'Roxholm',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4300919,
        LOCATION_LATITUDE_DEG: 53.0416193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035100',
        LOCATION_NAME: 'Roxton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3143367,
        LOCATION_LATITUDE_DEG: 52.1772149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035200',
        LOCATION_NAME: 'Roxwell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3823631,
        LOCATION_LATITUDE_DEG: 51.7511568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035400',
        LOCATION_NAME: 'Roy Bridge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8406222,
        LOCATION_LATITUDE_DEG: 56.8911271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037700',
        LOCATION_NAME: 'Royal Albert Dock',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0559583,
        LOCATION_LATITUDE_DEG: 51.507407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035500',
        LOCATION_NAME: 'Royal British Legion Village',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4806536,
        LOCATION_LATITUDE_DEG: 51.2918124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037200',
        LOCATION_NAME: 'Royal Oak',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2942575,
        LOCATION_LATITUDE_DEG: 53.4018071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037800',
        LOCATION_NAME: 'Royal Victoria Dock',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0285352,
        LOCATION_LATITUDE_DEG: 51.5071651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO990404',
        LOCATION_NAME: 'Royal Wootton Bassett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035700',
        LOCATION_NAME: 'Roydon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0408108,
        LOCATION_LATITUDE_DEG: 51.7732705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035900',
        LOCATION_NAME: 'Roydon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5307097,
        LOCATION_LATITUDE_DEG: 52.7755572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035800',
        LOCATION_NAME: 'Roydon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0798435,
        LOCATION_LATITUDE_DEG: 52.3815122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036000',
        LOCATION_NAME: 'Roydon Mill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0378901,
        LOCATION_LATITUDE_DEG: 51.7753717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO038400',
        LOCATION_NAME: 'Royston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2302452,
        LOCATION_LATITUDE_DEG: 55.8704214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO038200',
        LOCATION_NAME: 'Royston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2351347,
        LOCATION_LATITUDE_DEG: 55.9773523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036200',
        LOCATION_NAME: 'Royston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4531869,
        LOCATION_LATITUDE_DEG: 53.5981581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036100',
        LOCATION_NAME: 'Royston',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0224453,
        LOCATION_LATITUDE_DEG: 52.0477978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036400',
        LOCATION_NAME: 'Royton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9346256,
        LOCATION_LATITUDE_DEG: 53.0043255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO036300',
        LOCATION_NAME: 'Royton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1285696,
        LOCATION_LATITUDE_DEG: 53.5673632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000100',
        LOCATION_NAME: 'Ruabon',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.038027,
        LOCATION_LATITUDE_DEG: 52.9867183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000200',
        LOCATION_NAME: 'Ruaig',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7670894,
        LOCATION_LATITUDE_DEG: 56.5299067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000400',
        LOCATION_NAME: 'Ruan High Lanes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9435989,
        LOCATION_LATITUDE_DEG: 50.2245802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000500',
        LOCATION_NAME: 'Ruan Minor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1811437,
        LOCATION_LATITUDE_DEG: 49.9928553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000600',
        LOCATION_NAME: 'Ruardean',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5537771,
        LOCATION_LATITUDE_DEG: 51.8550093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000700',
        LOCATION_NAME: 'Ruardean Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5274219,
        LOCATION_LATITUDE_DEG: 51.8501038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000800',
        LOCATION_NAME: 'Ruardean Woodside',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5407961,
        LOCATION_LATITUDE_DEG: 51.8466081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000900',
        LOCATION_NAME: 'Rubery',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0117433,
        LOCATION_LATITUDE_DEG: 52.3948518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU011400',
        LOCATION_NAME: 'Ruchill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2789342,
        LOCATION_LATITUDE_DEG: 55.887776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001000',
        LOCATION_NAME: 'Ruckcroft',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7276144,
        LOCATION_LATITUDE_DEG: 54.7910946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001100',
        LOCATION_NAME: 'Ruckinge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8919564,
        LOCATION_LATITUDE_DEG: 51.0659844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001200',
        LOCATION_NAME: 'Ruckland',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9589783,
        LOCATION_LATITUDE_DEG: 53.2823132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001300',
        LOCATION_NAME: 'Ruckley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6882471,
        LOCATION_LATITUDE_DEG: 52.5966784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001400',
        LOCATION_NAME: 'Rudbaxton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9601847,
        LOCATION_LATITUDE_DEG: 51.8455309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001500',
        LOCATION_NAME: 'Ruddington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1479851,
        LOCATION_LATITUDE_DEG: 52.8923932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001600',
        LOCATION_NAME: 'Ruddle',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4560661,
        LOCATION_LATITUDE_DEG: 51.7962968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001700',
        LOCATION_NAME: 'Ruddlemoor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.802878,
        LOCATION_LATITUDE_DEG: 50.3626927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001800',
        LOCATION_NAME: 'Rudford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3241063,
        LOCATION_LATITUDE_DEG: 51.890809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002000',
        LOCATION_NAME: 'Rudge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2455597,
        LOCATION_LATITUDE_DEG: 51.2645521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU001900',
        LOCATION_NAME: 'Rudge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.610346,
        LOCATION_LATITUDE_DEG: 51.4210584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002050',
        LOCATION_NAME: 'Rudge Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.305514,
        LOCATION_LATITUDE_DEG: 52.5556851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002100',
        LOCATION_NAME: 'Rudgeway',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5382993,
        LOCATION_LATITUDE_DEG: 51.5783801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002200',
        LOCATION_NAME: 'Rudgewood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4657957,
        LOCATION_LATITUDE_DEG: 52.5898771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002300',
        LOCATION_NAME: 'Rudgwick',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4430668,
        LOCATION_LATITUDE_DEG: 51.0945115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002400',
        LOCATION_NAME: 'Rudhall',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5411038,
        LOCATION_LATITUDE_DEG: 51.9242887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002500',
        LOCATION_NAME: 'Rudheath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4882727,
        LOCATION_LATITUDE_DEG: 53.2517427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002600',
        LOCATION_NAME: 'Rudloe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2184235,
        LOCATION_LATITUDE_DEG: 51.4273658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002700',
        LOCATION_NAME: 'Rudry',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1534717,
        LOCATION_LATITUDE_DEG: 51.5722917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002800',
        LOCATION_NAME: 'Rudston',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3243798,
        LOCATION_LATITUDE_DEG: 54.0947975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU002900',
        LOCATION_NAME: 'Rudyard',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0702904,
        LOCATION_LATITUDE_DEG: 53.1170276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003000',
        LOCATION_NAME: 'Rufford',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8156832,
        LOCATION_LATITUDE_DEG: 53.6330801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003050',
        LOCATION_NAME: 'Rufford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0378013,
        LOCATION_LATITUDE_DEG: 53.1743754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003100',
        LOCATION_NAME: 'Rufforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1922074,
        LOCATION_LATITUDE_DEG: 53.9548962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003200',
        LOCATION_NAME: 'Ruffside',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.012339,
        LOCATION_LATITUDE_DEG: 54.8589917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003300',
        LOCATION_NAME: 'Rugby',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2606361,
        LOCATION_LATITUDE_DEG: 52.3726425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003400',
        LOCATION_NAME: 'Rugeley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9332546,
        LOCATION_LATITUDE_DEG: 52.7567877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003500',
        LOCATION_NAME: 'Ruisaurie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5001446,
        LOCATION_LATITUDE_DEG: 57.481978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003600',
        LOCATION_NAME: 'Ruishton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0498782,
        LOCATION_LATITUDE_DEG: 51.0193312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003700',
        LOCATION_NAME: 'Ruislip',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4252224,
        LOCATION_LATITUDE_DEG: 51.5760544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003800',
        LOCATION_NAME: 'Rumbling Bridge',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5837549,
        LOCATION_LATITUDE_DEG: 56.1778366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU003900',
        LOCATION_NAME: 'Rumburgh',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4473807,
        LOCATION_LATITUDE_DEG: 52.3794041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004100',
        LOCATION_NAME: 'Rumford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9651604,
        LOCATION_LATITUDE_DEG: 50.493099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004000',
        LOCATION_NAME: 'Rumford',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7090449,
        LOCATION_LATITUDE_DEG: 55.9746222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004200',
        LOCATION_NAME: 'Rumleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1871283,
        LOCATION_LATITUDE_DEG: 50.4918956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004300',
        LOCATION_NAME: 'Rumney',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1287084,
        LOCATION_LATITUDE_DEG: 51.5093847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004400',
        LOCATION_NAME: 'Rumwell',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.150262,
        LOCATION_LATITUDE_DEG: 51.0026292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004500',
        LOCATION_NAME: 'Rumwell Park',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1476156,
        LOCATION_LATITUDE_DEG: 51.0051375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004600',
        LOCATION_NAME: 'Runcorn',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.727489,
        LOCATION_LATITUDE_DEG: 53.3352536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004700',
        LOCATION_NAME: 'Runcton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7471952,
        LOCATION_LATITUDE_DEG: 50.8107878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004800',
        LOCATION_NAME: 'Runcton Holme',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.393627,
        LOCATION_LATITUDE_DEG: 52.6538452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU004900',
        LOCATION_NAME: 'Runfold',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7529799,
        LOCATION_LATITUDE_DEG: 51.2203237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005000',
        LOCATION_NAME: 'Runhall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0355877,
        LOCATION_LATITUDE_DEG: 52.6220307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005100',
        LOCATION_NAME: 'Runham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6408546,
        LOCATION_LATITUDE_DEG: 52.6409291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005200',
        LOCATION_NAME: 'Running Waters',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4867823,
        LOCATION_LATITUDE_DEG: 54.757678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005300',
        LOCATION_NAME: 'Runnington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2548359,
        LOCATION_LATITUDE_DEG: 50.9891324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005400',
        LOCATION_NAME: 'Runswick',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.755184,
        LOCATION_LATITUDE_DEG: 54.5342083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005500',
        LOCATION_NAME: 'Runwell',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5331095,
        LOCATION_LATITUDE_DEG: 51.621049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005600',
        LOCATION_NAME: 'Runwick',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8311902,
        LOCATION_LATITUDE_DEG: 51.2055276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005800',
        LOCATION_NAME: 'Ruscombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2481745,
        LOCATION_LATITUDE_DEG: 51.7589906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005700',
        LOCATION_NAME: 'Ruscombe',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.852847,
        LOCATION_LATITUDE_DEG: 51.4794482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006100',
        LOCATION_NAME: 'Rush Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0404855,
        LOCATION_LATITUDE_DEG: 51.7960672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006000',
        LOCATION_NAME: 'Rush Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1778902,
        LOCATION_LATITUDE_DEG: 51.565141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006400',
        LOCATION_NAME: 'Rushall',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5245078,
        LOCATION_LATITUDE_DEG: 52.0114232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006200',
        LOCATION_NAME: 'Rushall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9583383,
        LOCATION_LATITUDE_DEG: 52.6066725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006500',
        LOCATION_NAME: 'Rushall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8208716,
        LOCATION_LATITUDE_DEG: 51.2997447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006300',
        LOCATION_NAME: 'Rushall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2310581,
        LOCATION_LATITUDE_DEG: 52.3979077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006700',
        LOCATION_NAME: 'Rushbrooke',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7710689,
        LOCATION_LATITUDE_DEG: 52.2194989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006900',
        LOCATION_NAME: 'Rushbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7172522,
        LOCATION_LATITUDE_DEG: 52.5219703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007000',
        LOCATION_NAME: 'Rushden',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5954492,
        LOCATION_LATITUDE_DEG: 52.2887208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007100',
        LOCATION_NAME: 'Rushden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1036628,
        LOCATION_LATITUDE_DEG: 51.9659846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007200',
        LOCATION_NAME: 'Rushenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7425675,
        LOCATION_LATITUDE_DEG: 51.4072197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007300',
        LOCATION_NAME: 'Rushers Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2905141,
        LOCATION_LATITUDE_DEG: 51.0341894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007600',
        LOCATION_NAME: 'Rushford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1888594,
        LOCATION_LATITUDE_DEG: 50.5653004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007400',
        LOCATION_NAME: 'Rushford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9157123,
        LOCATION_LATITUDE_DEG: 52.1614257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007500',
        LOCATION_NAME: 'Rushford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8271858,
        LOCATION_LATITUDE_DEG: 52.3958171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007700',
        LOCATION_NAME: 'Rushlake Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.315261,
        LOCATION_LATITUDE_DEG: 50.9404882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007800',
        LOCATION_NAME: 'Rushmere',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6758905,
        LOCATION_LATITUDE_DEG: 52.4245058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU011200',
        LOCATION_NAME: 'Rushmere St Andrew',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU007900',
        LOCATION_NAME: 'Rushmere St. Andrew',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2047727,
        LOCATION_LATITUDE_DEG: 52.0683762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008100',
        LOCATION_NAME: 'Rushmoor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5685081,
        LOCATION_LATITUDE_DEG: 52.7191937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008000',
        LOCATION_NAME: 'Rushmoor',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7514359,
        LOCATION_LATITUDE_DEG: 51.1556174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008200',
        LOCATION_NAME: 'Rushock',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1742266,
        LOCATION_LATITUDE_DEG: 52.3354451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU011300',
        LOCATION_NAME: 'Rusholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2281669,
        LOCATION_LATITUDE_DEG: 53.4562218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008300',
        LOCATION_NAME: 'Rushton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6225523,
        LOCATION_LATITUDE_DEG: 53.1712316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008500',
        LOCATION_NAME: 'Rushton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5810041,
        LOCATION_LATITUDE_DEG: 52.6689824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008400',
        LOCATION_NAME: 'Rushton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7618337,
        LOCATION_LATITUDE_DEG: 52.4374443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008600',
        LOCATION_NAME: 'Rushton James',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1092469,
        LOCATION_LATITUDE_DEG: 53.1527246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008700',
        LOCATION_NAME: 'Rushton Spencer',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0933503,
        LOCATION_LATITUDE_DEG: 53.1599301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008800',
        LOCATION_NAME: 'Rushwick',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2696746,
        LOCATION_LATITUDE_DEG: 52.1804344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU008900',
        LOCATION_NAME: 'Rushyford',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5631615,
        LOCATION_LATITUDE_DEG: 54.6540698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009000',
        LOCATION_NAME: 'Ruskie',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2144141,
        LOCATION_LATITUDE_DEG: 56.1803518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009100',
        LOCATION_NAME: 'Ruskington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3842899,
        LOCATION_LATITUDE_DEG: 53.0456903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009200',
        LOCATION_NAME: 'Rusland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0135429,
        LOCATION_LATITUDE_DEG: 54.2907464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009300',
        LOCATION_NAME: 'Rusper',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2773918,
        LOCATION_LATITUDE_DEG: 51.1224071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009400',
        LOCATION_NAME: 'Ruspidge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5074437,
        LOCATION_LATITUDE_DEG: 51.8023987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009500',
        LOCATION_NAME: 'Russells Water',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9775998,
        LOCATION_LATITUDE_DEG: 51.6022654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009600',
        LOCATION_NAME: 'Rusthall',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2285105,
        LOCATION_LATITUDE_DEG: 51.1398067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009700',
        LOCATION_NAME: 'Rustington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5108781,
        LOCATION_LATITUDE_DEG: 50.8027849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009800',
        LOCATION_NAME: 'Ruston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5297701,
        LOCATION_LATITUDE_DEG: 54.235308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009900',
        LOCATION_NAME: 'Ruston Parva',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3740328,
        LOCATION_LATITUDE_DEG: 54.0405875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010000',
        LOCATION_NAME: 'Ruswarp',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6278503,
        LOCATION_LATITUDE_DEG: 54.4710328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010100',
        LOCATION_NAME: 'Rutherglen',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2233351,
        LOCATION_LATITUDE_DEG: 55.8267097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010200',
        LOCATION_NAME: 'Ruthern Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.802706,
        LOCATION_LATITUDE_DEG: 50.4677905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010300',
        LOCATION_NAME: 'Ruthin',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3078814,
        LOCATION_LATITUDE_DEG: 53.114737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010400',
        LOCATION_NAME: 'Ruthrieston',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1261317,
        LOCATION_LATITUDE_DEG: 57.1288129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010500',
        LOCATION_NAME: 'Ruthven',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1616454,
        LOCATION_LATITUDE_DEG: 56.6254822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010600',
        LOCATION_NAME: 'Ruthven',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8234406,
        LOCATION_LATITUDE_DEG: 57.5103659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010700',
        LOCATION_NAME: 'Ruthvoes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9185967,
        LOCATION_LATITUDE_DEG: 50.4068954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010800',
        LOCATION_NAME: 'Ruthwell',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4070297,
        LOCATION_LATITUDE_DEG: 54.9932242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU011000',
        LOCATION_NAME: 'Ruyton Moss',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9043367,
        LOCATION_LATITUDE_DEG: 52.7841981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU011100',
        LOCATION_NAME: 'Ruyton XI Towns',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8990909,
        LOCATION_LATITUDE_DEG: 52.793004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000100',
        LOCATION_NAME: 'Ryal',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.975776,
        LOCATION_LATITUDE_DEG: 55.0627135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000200',
        LOCATION_NAME: 'Ryall',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8416334,
        LOCATION_LATITUDE_DEG: 50.7506046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000250',
        LOCATION_NAME: 'Ryall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1992359,
        LOCATION_LATITUDE_DEG: 52.0634142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000300',
        LOCATION_NAME: 'Ryarsh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3961492,
        LOCATION_LATITUDE_DEG: 51.3131181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000400',
        LOCATION_NAME: 'Rydal',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9798029,
        LOCATION_LATITUDE_DEG: 54.4466624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000500',
        LOCATION_NAME: 'Ryde',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1614375,
        LOCATION_LATITUDE_DEG: 50.7294821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000600',
        LOCATION_NAME: 'Rye',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7355569,
        LOCATION_LATITUDE_DEG: 50.9518763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000700',
        LOCATION_NAME: 'Rye Foreign',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7078751,
        LOCATION_LATITUDE_DEG: 50.9707825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000800',
        LOCATION_NAME: 'Rye Harbour',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7631968,
        LOCATION_LATITUDE_DEG: 50.9376779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001000',
        LOCATION_NAME: 'Ryeford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5236401,
        LOCATION_LATITUDE_DEG: 51.9008087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001100',
        LOCATION_NAME: 'Ryeford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2486108,
        LOCATION_LATITUDE_DEG: 51.7328945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001200',
        LOCATION_NAME: 'Ryehill',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1467767,
        LOCATION_LATITUDE_DEG: 53.7146544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001300',
        LOCATION_NAME: 'Ryeish Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9600903,
        LOCATION_LATITUDE_DEG: 51.400645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001400',
        LOCATION_NAME: 'Ryelands',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7481377,
        LOCATION_LATITUDE_DEG: 52.2179428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001500',
        LOCATION_NAME: 'Ryhall',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4662758,
        LOCATION_LATITUDE_DEG: 52.6854606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001600',
        LOCATION_NAME: 'Ryhill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4129787,
        LOCATION_LATITUDE_DEG: 53.620666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001700',
        LOCATION_NAME: 'Ryhope',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3606887,
        LOCATION_LATITUDE_DEG: 54.868688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001800',
        LOCATION_NAME: 'Rylagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.278185,
        LOCATION_LATITUDE_DEG: 54.6539485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001900',
        LOCATION_NAME: 'Rylands',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3307519,
        LOCATION_LATITUDE_DEG: 54.5796889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002100',
        LOCATION_NAME: 'Rylstone',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0467134,
        LOCATION_LATITUDE_DEG: 54.0238136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002200',
        LOCATION_NAME: 'Ryme Intrinseca',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5973582,
        LOCATION_LATITUDE_DEG: 50.894715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002300',
        LOCATION_NAME: 'Ryther',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1595998,
        LOCATION_LATITUDE_DEG: 53.8467847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002500',
        LOCATION_NAME: 'Ryton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3926049,
        LOCATION_LATITUDE_DEG: 51.9865168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002400',
        LOCATION_NAME: 'Ryton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3501617,
        LOCATION_LATITUDE_DEG: 52.6217794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002700',
        LOCATION_NAME: 'Ryton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7618337,
        LOCATION_LATITUDE_DEG: 54.9727007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002600',
        LOCATION_NAME: 'Ryton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7833348,
        LOCATION_LATITUDE_DEG: 54.1700066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002800',
        LOCATION_NAME: 'Ryton on Dunsmore',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4328622,
        LOCATION_LATITUDE_DEG: 52.3661406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000100',
        LOCATION_NAME: 'Sabden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3357671,
        LOCATION_LATITUDE_DEG: 53.8333922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000200',
        LOCATION_NAME: 'Sacombe',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0661301,
        LOCATION_LATITUDE_DEG: 51.8583742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000300',
        LOCATION_NAME: 'Sacriston',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6237109,
        LOCATION_LATITUDE_DEG: 54.8164826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000400',
        LOCATION_NAME: 'Sadberge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.470865,
        LOCATION_LATITUDE_DEG: 54.5467544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000500',
        LOCATION_NAME: 'Saddell',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5085831,
        LOCATION_LATITUDE_DEG: 55.5318944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000600',
        LOCATION_NAME: 'Saddington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.030528,
        LOCATION_LATITUDE_DEG: 52.5211531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000700',
        LOCATION_NAME: 'Saddlebow',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3749265,
        LOCATION_LATITUDE_DEG: 52.7147517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000800',
        LOCATION_NAME: 'Saddlescombe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1915414,
        LOCATION_LATITUDE_DEG: 50.8885837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA000900',
        LOCATION_NAME: 'Saddleworth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9554123,
        LOCATION_LATITUDE_DEG: 53.5477643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001000',
        LOCATION_NAME: 'Saffron Walden',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2446573,
        LOCATION_LATITUDE_DEG: 52.0228926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001100',
        LOCATION_NAME: 'Sageston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8094682,
        LOCATION_LATITUDE_DEG: 51.6945135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001300',
        LOCATION_NAME: 'Saham Hills',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8103099,
        LOCATION_LATITUDE_DEG: 52.5949373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001400',
        LOCATION_NAME: 'Saham Toney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8040928,
        LOCATION_LATITUDE_DEG: 52.5822329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001500',
        LOCATION_NAME: 'Saham Waite',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8462272,
        LOCATION_LATITUDE_DEG: 52.6090356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001600',
        LOCATION_NAME: 'Saighton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8335954,
        LOCATION_LATITUDE_DEG: 53.1522399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001700',
        LOCATION_NAME: 'Saint Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0216696,
        LOCATION_LATITUDE_DEG: 51.105003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001800',
        LOCATION_NAME: 'Saintbury',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8291977,
        LOCATION_LATITUDE_DEG: 52.0556181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001900',
        LOCATION_NAME: 'Saintfield',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8364847,
        LOCATION_LATITUDE_DEG: 54.4650983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002000',
        LOCATION_NAME: 'Salcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7763012,
        LOCATION_LATITUDE_DEG: 50.2349679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002100',
        LOCATION_NAME: 'Salcombe Regis',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2058341,
        LOCATION_LATITUDE_DEG: 50.6928041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002200',
        LOCATION_NAME: 'Salcott',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8249981,
        LOCATION_LATITUDE_DEG: 51.7873617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990225',
        LOCATION_NAME: 'Salcott Cum Virley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8253112,
        LOCATION_LATITUDE_DEG: 51.7886584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002300',
        LOCATION_NAME: 'Sale',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'M33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3217814,
        LOCATION_LATITUDE_DEG: 53.425253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002400',
        LOCATION_NAME: 'Sale Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1010728,
        LOCATION_LATITUDE_DEG: 52.219839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002500',
        LOCATION_NAME: 'Saleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1860314,
        LOCATION_LATITUDE_DEG: 53.2854138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002800',
        LOCATION_NAME: 'Salehurst',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4832725,
        LOCATION_LATITUDE_DEG: 50.990987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002900',
        LOCATION_NAME: 'Salem',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0023538,
        LOCATION_LATITUDE_DEG: 51.9179323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003000',
        LOCATION_NAME: 'Salem',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9391747,
        LOCATION_LATITUDE_DEG: 51.7141067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003100',
        LOCATION_NAME: 'Salen',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9449258,
        LOCATION_LATITUDE_DEG: 56.5171952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003200',
        LOCATION_NAME: 'Salendine Nook',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8328706,
        LOCATION_LATITUDE_DEG: 53.6571727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003300',
        LOCATION_NAME: 'Salesbury',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4840322,
        LOCATION_LATITUDE_DEG: 53.7904931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003400',
        LOCATION_NAME: 'Saleway',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1029246,
        LOCATION_LATITUDE_DEG: 52.2356353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003600',
        LOCATION_NAME: 'Salford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5804396,
        LOCATION_LATITUDE_DEG: 51.9489009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003500',
        LOCATION_NAME: 'Salford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6364126,
        LOCATION_LATITUDE_DEG: 52.0426012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003700',
        LOCATION_NAME: 'Salford M 3',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2540087,
        LOCATION_LATITUDE_DEG: 53.4833361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003800',
        LOCATION_NAME: 'Salford M 5',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2927287,
        LOCATION_LATITUDE_DEG: 53.4770987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA003900',
        LOCATION_NAME: 'Salford M 6',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3015043,
        LOCATION_LATITUDE_DEG: 53.4948671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004000',
        LOCATION_NAME: 'Salford M 7',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2636564,
        LOCATION_LATITUDE_DEG: 53.5055642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004100',
        LOCATION_NAME: 'Salford M 8',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2374866,
        LOCATION_LATITUDE_DEG: 53.5095924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004150',
        LOCATION_NAME: 'Salford M50',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.304463,
        LOCATION_LATITUDE_DEG: 53.4806921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004200',
        LOCATION_NAME: 'Salford Priors',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.888615,
        LOCATION_LATITUDE_DEG: 52.1577257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004300',
        LOCATION_NAME: 'Salford Quays',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2904772,
        LOCATION_LATITUDE_DEG: 53.4717644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004400',
        LOCATION_NAME: 'Salfords',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1656156,
        LOCATION_LATITUDE_DEG: 51.2003127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004500',
        LOCATION_NAME: 'Salhouse',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3949738,
        LOCATION_LATITUDE_DEG: 52.672236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004700',
        LOCATION_NAME: 'Saline',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5720171,
        LOCATION_LATITUDE_DEG: 56.114935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004800',
        LOCATION_NAME: 'Salisbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7916023,
        LOCATION_LATITUDE_DEG: 51.0692235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004900',
        LOCATION_NAME: 'Salle',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1290163,
        LOCATION_LATITUDE_DEG: 52.7791464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005100',
        LOCATION_NAME: 'Sally Port',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3165303,
        LOCATION_LATITUDE_DEG: 49.9130618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005500',
        LOCATION_NAME: 'Salmonby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0142687,
        LOCATION_LATITUDE_DEG: 53.2412101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005600',
        LOCATION_NAME: 'Salperton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8883235,
        LOCATION_LATITUDE_DEG: 51.8823003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005700',
        LOCATION_NAME: 'Salph End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4233083,
        LOCATION_LATITUDE_DEG: 52.1640104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005900',
        LOCATION_NAME: 'Salsburgh',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8728814,
        LOCATION_LATITUDE_DEG: 55.843511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006000',
        LOCATION_NAME: 'Salston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2886279,
        LOCATION_LATITUDE_DEG: 50.7419077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006100',
        LOCATION_NAME: 'Salt',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0651617,
        LOCATION_LATITUDE_DEG: 52.847494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006300',
        LOCATION_NAME: 'Saltaire',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7823107,
        LOCATION_LATITUDE_DEG: 53.8361905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006400',
        LOCATION_NAME: 'Saltash',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2293284,
        LOCATION_LATITUDE_DEG: 50.4129876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006500',
        LOCATION_NAME: 'Saltburn',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1397235,
        LOCATION_LATITUDE_DEG: 57.6998007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028700',
        LOCATION_NAME: 'Saltburn by the Sea',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006600',
        LOCATION_NAME: 'Saltburn-by-the-Sea',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9767657,
        LOCATION_LATITUDE_DEG: 54.5813533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006700',
        LOCATION_NAME: 'Saltby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7383356,
        LOCATION_LATITUDE_DEG: 52.8263775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006800',
        LOCATION_NAME: 'Saltcoats',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7865267,
        LOCATION_LATITUDE_DEG: 55.6343012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006900',
        LOCATION_NAME: 'Saltcoats',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4172173,
        LOCATION_LATITUDE_DEG: 54.3598584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007000',
        LOCATION_NAME: 'Saltdean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0385037,
        LOCATION_LATITUDE_DEG: 50.8042791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007100',
        LOCATION_NAME: 'Saltend',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2307423,
        LOCATION_LATITUDE_DEG: 53.7373571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007200',
        LOCATION_NAME: 'Salterbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5594497,
        LOCATION_LATITUDE_DEG: 54.6205849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007300',
        LOCATION_NAME: 'Salterforth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1690592,
        LOCATION_LATITUDE_DEG: 53.9046026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007400',
        LOCATION_NAME: 'Salterhebble',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8526043,
        LOCATION_LATITUDE_DEG: 53.7004726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007500',
        LOCATION_NAME: 'Salters Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2320019,
        LOCATION_LATITUDE_DEG: 51.023593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007600',
        LOCATION_NAME: 'Salters Lode',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3393826,
        LOCATION_LATITUDE_DEG: 52.5892368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007700',
        LOCATION_NAME: 'Saltersford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6205112,
        LOCATION_LATITUDE_DEG: 52.8884811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007800',
        LOCATION_NAME: 'Saltersgate',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6888812,
        LOCATION_LATITUDE_DEG: 54.3389268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008000',
        LOCATION_NAME: 'Salterton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8159791,
        LOCATION_LATITUDE_DEG: 51.1203275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008100',
        LOCATION_NAME: 'Saltfleet',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1865336,
        LOCATION_LATITUDE_DEG: 53.4226248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008200',
        LOCATION_NAME: 'Saltfleetby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1939815,
        LOCATION_LATITUDE_DEG: 53.4012232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008300',
        LOCATION_NAME: 'Saltford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4561989,
        LOCATION_LATITUDE_DEG: 51.4016639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008500',
        LOCATION_NAME: 'Salthouse',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0909746,
        LOCATION_LATITUDE_DEG: 52.9517674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008600',
        LOCATION_NAME: 'Saltley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8586363,
        LOCATION_LATITUDE_DEG: 52.4874569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008700',
        LOCATION_NAME: 'Saltmarshe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8054286,
        LOCATION_LATITUDE_DEG: 53.7070669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008800',
        LOCATION_NAME: 'Saltmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2130219,
        LOCATION_LATITUDE_DEG: 50.4131911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009000',
        LOCATION_NAME: 'Saltney',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9269173,
        LOCATION_LATITUDE_DEG: 53.1779367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009100',
        LOCATION_NAME: 'Saltney Ferry',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9451268,
        LOCATION_LATITUDE_DEG: 53.1846442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009200',
        LOCATION_NAME: 'Salton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.902001,
        LOCATION_LATITUDE_DEG: 54.2119119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009300',
        LOCATION_NAME: 'Saltram',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0573182,
        LOCATION_LATITUDE_DEG: 50.3834868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029000',
        LOCATION_NAME: 'Saltwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6128872,
        LOCATION_LATITUDE_DEG: 54.9457063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009400',
        LOCATION_NAME: 'Saltwick Bay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5873371,
        LOCATION_LATITUDE_DEG: 54.4840403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009500',
        LOCATION_NAME: 'Saltwood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0793204,
        LOCATION_LATITUDE_DEG: 51.080086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009600',
        LOCATION_NAME: 'Salwarpe',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1804561,
        LOCATION_LATITUDE_DEG: 52.2539386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009700',
        LOCATION_NAME: 'Salwayash',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7722291,
        LOCATION_LATITUDE_DEG: 50.7682091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009800',
        LOCATION_NAME: 'Salwick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8166109,
        LOCATION_LATITUDE_DEG: 53.7827926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA009900',
        LOCATION_NAME: 'Sambourne',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B96',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9140662,
        LOCATION_LATITUDE_DEG: 52.2569404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010000',
        LOCATION_NAME: 'Sambrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4250593,
        LOCATION_LATITUDE_DEG: 52.8178015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010100',
        LOCATION_NAME: 'Samlesbury',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6205302,
        LOCATION_LATITUDE_DEG: 53.7670949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010200',
        LOCATION_NAME: 'Samlesbury Bottoms',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5727335,
        LOCATION_LATITUDE_DEG: 53.7579929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010300',
        LOCATION_NAME: 'Sampford Arundel',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2660245,
        LOCATION_LATITUDE_DEG: 50.9609332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010400',
        LOCATION_NAME: 'Sampford Brett',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3035253,
        LOCATION_LATITUDE_DEG: 51.1536508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010500',
        LOCATION_NAME: 'Sampford Courtenay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9394163,
        LOCATION_LATITUDE_DEG: 50.7914173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010600',
        LOCATION_NAME: 'Sampford Moor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2617184,
        LOCATION_LATITUDE_DEG: 50.9544323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010700',
        LOCATION_NAME: 'Sampford Peverell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3766416,
        LOCATION_LATITUDE_DEG: 50.9196318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010800',
        LOCATION_NAME: 'Sampford Spiney',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0655154,
        LOCATION_LATITUDE_DEG: 50.5327971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA010900',
        LOCATION_NAME: 'Sancreed',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6096108,
        LOCATION_LATITUDE_DEG: 50.108072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011000',
        LOCATION_NAME: 'Sancton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6307967,
        LOCATION_LATITUDE_DEG: 53.8414749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011100',
        LOCATION_NAME: 'Sand',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8100699,
        LOCATION_LATITUDE_DEG: 51.2136511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011200',
        LOCATION_NAME: 'Sand Hutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9399611,
        LOCATION_LATITUDE_DEG: 54.0174957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011300',
        LOCATION_NAME: 'Sand Laide',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5401077,
        LOCATION_LATITUDE_DEG: 57.8678286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011400',
        LOCATION_NAME: 'Sandaig',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9730497,
        LOCATION_LATITUDE_DEG: 56.4835016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011500',
        LOCATION_NAME: 'Sandal',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4818828,
        LOCATION_LATITUDE_DEG: 53.6575887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011600',
        LOCATION_NAME: 'Sandale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1667048,
        LOCATION_LATITUDE_DEG: 54.7503931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011700',
        LOCATION_NAME: 'Sanday',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5729404,
        LOCATION_LATITUDE_DEG: 59.2535367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011800',
        LOCATION_NAME: 'Sandbach',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3619594,
        LOCATION_LATITUDE_DEG: 53.1439269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA011900',
        LOCATION_NAME: 'Sandbank',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9469459,
        LOCATION_LATITUDE_DEG: 55.9811312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012000',
        LOCATION_NAME: 'Sandbeds',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8598024,
        LOCATION_LATITUDE_DEG: 53.8681898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012100',
        LOCATION_NAME: 'Sandend',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7484473,
        LOCATION_LATITUDE_DEG: 57.680177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012200',
        LOCATION_NAME: 'Sanderstead',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0932261,
        LOCATION_LATITUDE_DEG: 51.3480318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012300',
        LOCATION_NAME: 'Sandfields',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8148632,
        LOCATION_LATITUDE_DEG: 51.6024987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012700',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0361667,
        LOCATION_LATITUDE_DEG: 55.6641908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012900',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6635656,
        LOCATION_LATITUDE_DEG: 50.8093228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013000',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8296077,
        LOCATION_LATITUDE_DEG: 51.3318629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012500',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.62169,
        LOCATION_LATITUDE_DEG: 52.9020123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012600',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4176721,
        LOCATION_LATITUDE_DEG: 54.5399642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013200',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.31258,
        LOCATION_LATITUDE_DEG: 52.5328656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013100',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1012488,
        LOCATION_LATITUDE_DEG: 50.7040963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013300',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7628857,
        LOCATION_LATITUDE_DEG: 50.8140985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA030000',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6118127,
        LOCATION_LATITUDE_DEG: 53.817728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012800',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2337395,
        LOCATION_LATITUDE_DEG: 50.6327734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA012400',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8872833,
        LOCATION_LATITUDE_DEG: 51.4551484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028600',
        LOCATION_NAME: 'Sandford on Thames',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013400',
        LOCATION_NAME: 'Sandford Orcas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.536218,
        LOCATION_LATITUDE_DEG: 50.9845236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028500',
        LOCATION_NAME: 'Sandford St Martin',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013500',
        LOCATION_NAME: 'Sandford St. Martin',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3887706,
        LOCATION_LATITUDE_DEG: 51.9357969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013600',
        LOCATION_NAME: 'Sandford-on-Thames',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.230327,
        LOCATION_LATITUDE_DEG: 51.7080753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013700',
        LOCATION_NAME: 'Sandgate',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1470894,
        LOCATION_LATITUDE_DEG: 51.0731878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013800',
        LOCATION_NAME: 'Sandhall',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.843892,
        LOCATION_LATITUDE_DEG: 53.7045676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA013900',
        LOCATION_NAME: 'Sandhaven',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0606671,
        LOCATION_LATITUDE_DEG: 57.6957695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014000',
        LOCATION_NAME: 'Sandhead',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9613976,
        LOCATION_LATITUDE_DEG: 54.8084164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014100',
        LOCATION_NAME: 'Sandhills',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9250428,
        LOCATION_LATITUDE_DEG: 52.6283779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014200',
        LOCATION_NAME: 'Sandhoe',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0450166,
        LOCATION_LATITUDE_DEG: 54.9912056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014300',
        LOCATION_NAME: 'Sandholes',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7802168,
        LOCATION_LATITUDE_DEG: 54.5935533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014400',
        LOCATION_NAME: 'Sandholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7481322,
        LOCATION_LATITUDE_DEG: 53.7659671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014500',
        LOCATION_NAME: 'Sandhurst',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2514016,
        LOCATION_LATITUDE_DEG: 51.9094112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014600',
        LOCATION_NAME: 'Sandhurst',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'GU47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7983996,
        LOCATION_LATITUDE_DEG: 51.3453377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014700',
        LOCATION_NAME: 'Sandhurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5649231,
        LOCATION_LATITUDE_DEG: 51.0265876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014800',
        LOCATION_NAME: 'Sandhutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4130492,
        LOCATION_LATITUDE_DEG: 54.2322215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA014900',
        LOCATION_NAME: 'Sandiacre',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2870321,
        LOCATION_LATITUDE_DEG: 52.9226993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015000',
        LOCATION_NAME: 'Sandilands',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7600824,
        LOCATION_LATITUDE_DEG: 55.628187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015100',
        LOCATION_NAME: 'Sandilands',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2920328,
        LOCATION_LATITUDE_DEG: 53.3021078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015200',
        LOCATION_NAME: 'Sandiway',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5915375,
        LOCATION_LATITUDE_DEG: 53.2365405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015300',
        LOCATION_NAME: 'Sandleheath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8252623,
        LOCATION_LATITUDE_DEG: 50.9320142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015400',
        LOCATION_NAME: 'Sandley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3263348,
        LOCATION_LATITUDE_DEG: 51.019428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015600',
        LOCATION_NAME: 'Sandling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5178181,
        LOCATION_LATITUDE_DEG: 51.2938161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015500',
        LOCATION_NAME: 'Sandling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0628909,
        LOCATION_LATITUDE_DEG: 51.0905843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015700',
        LOCATION_NAME: 'Sandness',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6525113,
        LOCATION_LATITUDE_DEG: 60.2990232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016000',
        LOCATION_NAME: 'Sandon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0797332,
        LOCATION_LATITUDE_DEG: 52.8656997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015900',
        LOCATION_NAME: 'Sandon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0740912,
        LOCATION_LATITUDE_DEG: 51.9921868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA015800',
        LOCATION_NAME: 'Sandon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5241926,
        LOCATION_LATITUDE_DEG: 51.7146555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016100',
        LOCATION_NAME: 'Sandon Bank',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0822765,
        LOCATION_LATITUDE_DEG: 52.8515021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016200',
        LOCATION_NAME: 'Sandown',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.149692,
        LOCATION_LATITUDE_DEG: 50.6549722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016300',
        LOCATION_NAME: 'Sandpits',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3632181,
        LOCATION_LATITUDE_DEG: 51.6909891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029500',
        LOCATION_NAME: 'Sandpits',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9150606,
        LOCATION_LATITUDE_DEG: 52.495324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016400',
        LOCATION_NAME: 'Sandplace',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4608549,
        LOCATION_LATITUDE_DEG: 50.3844887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016500',
        LOCATION_NAME: 'Sandridge',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3039895,
        LOCATION_LATITUDE_DEG: 51.7802718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016600',
        LOCATION_NAME: 'Sandridge Common',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0981045,
        LOCATION_LATITUDE_DEG: 51.3794534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016700',
        LOCATION_NAME: 'Sandringham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5097123,
        LOCATION_LATITUDE_DEG: 52.8296637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016800',
        LOCATION_NAME: 'Sands',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7817705,
        LOCATION_LATITUDE_DEG: 51.6328603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA016900',
        LOCATION_NAME: 'Sandsend',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6665935,
        LOCATION_LATITUDE_DEG: 54.5007429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017000',
        LOCATION_NAME: 'Sandshill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.582237,
        LOCATION_LATITUDE_DEG: 51.6467725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA990066',
        LOCATION_NAME: 'Sandside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1870005,
        LOCATION_LATITUDE_DEG: 54.2329921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017100',
        LOCATION_NAME: 'Sandside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8014951,
        LOCATION_LATITUDE_DEG: 54.218141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017200',
        LOCATION_NAME: 'Sandtoft',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8774111,
        LOCATION_LATITUDE_DEG: 53.5636481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017300',
        LOCATION_NAME: 'Sandway',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7004041,
        LOCATION_LATITUDE_DEG: 51.2275085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017400',
        LOCATION_NAME: 'Sandwell',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9641824,
        LOCATION_LATITUDE_DEG: 52.5031622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017500',
        LOCATION_NAME: 'Sandwich',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3402741,
        LOCATION_LATITUDE_DEG: 51.2748982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017600',
        LOCATION_NAME: 'Sandwich Bay',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3839272,
        LOCATION_LATITUDE_DEG: 51.2673999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017700',
        LOCATION_NAME: 'Sandwick',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3539082,
        LOCATION_LATITUDE_DEG: 58.2062661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017800',
        LOCATION_NAME: 'Sandwick',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9596004,
        LOCATION_LATITUDE_DEG: 58.785596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017850',
        LOCATION_NAME: 'Sandwick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2228324,
        LOCATION_LATITUDE_DEG: 59.9951886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA017900',
        LOCATION_NAME: 'Sandwith',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6001643,
        LOCATION_LATITUDE_DEG: 54.5168778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018000',
        LOCATION_NAME: 'Sandy',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2883214,
        LOCATION_LATITUDE_DEG: 52.1294048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018100',
        LOCATION_NAME: 'Sandy Bay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3747481,
        LOCATION_LATITUDE_DEG: 50.6137989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018300',
        LOCATION_NAME: 'Sandy Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2593011,
        LOCATION_LATITUDE_DEG: 50.9587828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018500',
        LOCATION_NAME: 'Sandy Haven',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1089257,
        LOCATION_LATITUDE_DEG: 51.7247262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018600',
        LOCATION_NAME: 'Sandy Lane',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0519565,
        LOCATION_LATITUDE_DEG: 51.412558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018700',
        LOCATION_NAME: 'Sandy Park',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.82819,
        LOCATION_LATITUDE_DEG: 50.6924117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029400',
        LOCATION_NAME: 'Sandy Row',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9369256,
        LOCATION_LATITUDE_DEG: 54.5912006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018800',
        LOCATION_NAME: 'Sandycroft',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0003532,
        LOCATION_LATITUDE_DEG: 53.1942444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019000',
        LOCATION_NAME: 'Sandyford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5444019,
        LOCATION_LATITUDE_DEG: 52.7927967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018900',
        LOCATION_NAME: 'Sandyford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2008657,
        LOCATION_LATITUDE_DEG: 52.9257023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029100',
        LOCATION_NAME: 'Sandyford',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6187667,
        LOCATION_LATITUDE_DEG: 54.9678607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029200',
        LOCATION_NAME: 'Sandyford',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6025088,
        LOCATION_LATITUDE_DEG: 54.9816492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019200',
        LOCATION_NAME: 'Sandygate',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5955143,
        LOCATION_LATITUDE_DEG: 50.5618918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028900',
        LOCATION_NAME: 'Sandygate',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5047914,
        LOCATION_LATITUDE_DEG: 53.3888269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019300',
        LOCATION_NAME: 'Sandyhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8899538,
        LOCATION_LATITUDE_DEG: 52.9222157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029900',
        LOCATION_NAME: 'Sandyhills',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1655377,
        LOCATION_LATITUDE_DEG: 55.8478301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019400',
        LOCATION_NAME: 'Sandyhills',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7342382,
        LOCATION_LATITUDE_DEG: 54.8829142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019500',
        LOCATION_NAME: 'Sandymoor',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6541661,
        LOCATION_LATITUDE_DEG: 53.3470772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019700',
        LOCATION_NAME: 'Sandysyke',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9482574,
        LOCATION_LATITUDE_DEG: 54.983312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019800',
        LOCATION_NAME: 'Sandyway',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7509691,
        LOCATION_LATITUDE_DEG: 51.0696497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019900',
        LOCATION_NAME: 'Sangobeg',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7005683,
        LOCATION_LATITUDE_DEG: 58.5543878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020000',
        LOCATION_NAME: 'Sangomore',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7441783,
        LOCATION_LATITUDE_DEG: 58.5627914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020100',
        LOCATION_NAME: 'Sannox',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1548487,
        LOCATION_LATITUDE_DEG: 55.6634083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020200',
        LOCATION_NAME: 'Sanquhar',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9232901,
        LOCATION_LATITUDE_DEG: 55.367862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020350',
        LOCATION_NAME: 'Santon',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5846311,
        LOCATION_LATITUDE_DEG: 54.1125148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020300',
        LOCATION_NAME: 'Santon',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3874543,
        LOCATION_LATITUDE_DEG: 54.4033603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020400',
        LOCATION_NAME: 'Santon Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3698889,
        LOCATION_LATITUDE_DEG: 54.4019608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020500',
        LOCATION_NAME: 'Santon Downham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.672937,
        LOCATION_LATITUDE_DEG: 52.4557257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020700',
        LOCATION_NAME: 'Sapcote',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.27634,
        LOCATION_LATITUDE_DEG: 52.5360564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020800',
        LOCATION_NAME: 'Sapiston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8153529,
        LOCATION_LATITUDE_DEG: 52.3395099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020900',
        LOCATION_NAME: 'Sapley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1745634,
        LOCATION_LATITUDE_DEG: 52.3490221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021100',
        LOCATION_NAME: 'Sapperton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0756459,
        LOCATION_LATITUDE_DEG: 51.7283942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021000',
        LOCATION_NAME: 'Sapperton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4827715,
        LOCATION_LATITUDE_DEG: 52.8926815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA901526',
        LOCATION_NAME: 'Saracens Head',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0129284,
        LOCATION_LATITUDE_DEG: 52.8261597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021200',
        LOCATION_NAME: 'Sarclet',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1157041,
        LOCATION_LATITUDE_DEG: 58.3762508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021300',
        LOCATION_NAME: 'Sardis',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9398696,
        LOCATION_LATITUDE_DEG: 51.7352244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021400',
        LOCATION_NAME: 'Sardis',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7052465,
        LOCATION_LATITUDE_DEG: 51.7263194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021500',
        LOCATION_NAME: 'Sarisbury Green',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2803355,
        LOCATION_LATITUDE_DEG: 50.8787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021600',
        LOCATION_NAME: 'Sark',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3575296,
        LOCATION_LATITUDE_DEG: 49.4323999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021700',
        LOCATION_NAME: 'Sarkbridge',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0507788,
        LOCATION_LATITUDE_DEG: 54.9934167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022050',
        LOCATION_NAME: 'Sarn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6128775,
        LOCATION_LATITUDE_DEG: 52.8615918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021900',
        LOCATION_NAME: 'Sarn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5825601,
        LOCATION_LATITUDE_DEG: 51.539986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA021800',
        LOCATION_NAME: 'Sarn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3287555,
        LOCATION_LATITUDE_DEG: 53.300557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022000',
        LOCATION_NAME: 'Sarn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1728902,
        LOCATION_LATITUDE_DEG: 52.5095742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022100',
        LOCATION_NAME: 'Sarn Bach',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5161766,
        LOCATION_LATITUDE_DEG: 52.8097246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022150',
        LOCATION_NAME: 'Sarn Meyllteyrn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6176879,
        LOCATION_LATITUDE_DEG: 52.8617736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022650',
        LOCATION_NAME: 'Sarnau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4644424,
        LOCATION_LATITUDE_DEG: 52.1323306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022500',
        LOCATION_NAME: 'Sarnau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4085042,
        LOCATION_LATITUDE_DEG: 51.8431261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022400',
        LOCATION_NAME: 'Sarnau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5297394,
        LOCATION_LATITUDE_DEG: 52.9410197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022300',
        LOCATION_NAME: 'Sarnau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4136057,
        LOCATION_LATITUDE_DEG: 51.9843256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022600',
        LOCATION_NAME: 'Sarnau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1324395,
        LOCATION_LATITUDE_DEG: 52.7340033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022700',
        LOCATION_NAME: 'Sarnesfield',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9165957,
        LOCATION_LATITUDE_DEG: 52.1525447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022800',
        LOCATION_NAME: 'Saron',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3661184,
        LOCATION_LATITUDE_DEG: 52.01314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022900',
        LOCATION_NAME: 'Saron',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2967836,
        LOCATION_LATITUDE_DEG: 53.1037439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023000',
        LOCATION_NAME: 'Saron',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0262295,
        LOCATION_LATITUDE_DEG: 51.7924179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023100',
        LOCATION_NAME: 'Sarratt',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4922833,
        LOCATION_LATITUDE_DEG: 51.6835655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023200',
        LOCATION_NAME: 'Sarre',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2408008,
        LOCATION_LATITUDE_DEG: 51.3387072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023300',
        LOCATION_NAME: 'Sarsden',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5775019,
        LOCATION_LATITUDE_DEG: 51.9068982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023500',
        LOCATION_NAME: 'Sartle',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2736335,
        LOCATION_LATITUDE_DEG: 57.6295144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023600',
        LOCATION_NAME: 'Sascott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8505697,
        LOCATION_LATITUDE_DEG: 52.7013942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023700',
        LOCATION_NAME: 'Satley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8170767,
        LOCATION_LATITUDE_DEG: 54.7838808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023800',
        LOCATION_NAME: 'Satran',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.308058,
        LOCATION_LATITUDE_DEG: 57.2972795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023900',
        LOCATION_NAME: 'Satterleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8974189,
        LOCATION_LATITUDE_DEG: 50.9861364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024000',
        LOCATION_NAME: 'Satterthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0168722,
        LOCATION_LATITUDE_DEG: 54.3223496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024100',
        LOCATION_NAME: 'Sauchen',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4970629,
        LOCATION_LATITUDE_DEG: 57.1880228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024200',
        LOCATION_NAME: 'Saucher',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3030562,
        LOCATION_LATITUDE_DEG: 56.4838666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024300',
        LOCATION_NAME: 'Sauchie',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7768751,
        LOCATION_LATITUDE_DEG: 56.1314439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024400',
        LOCATION_NAME: 'Sauchieburn',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.549607,
        LOCATION_LATITUDE_DEG: 56.8177878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024500',
        LOCATION_NAME: 'Sauchrie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6801223,
        LOCATION_LATITUDE_DEG: 55.3958764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024600',
        LOCATION_NAME: 'Saughall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9518608,
        LOCATION_LATITUDE_DEG: 53.2278427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028800',
        LOCATION_NAME: 'Saughtonhall',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2515305,
        LOCATION_LATITUDE_DEG: 55.9430917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024800',
        LOCATION_NAME: 'Saul',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3647853,
        LOCATION_LATITUDE_DEG: 51.7832981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA024900',
        LOCATION_NAME: 'Saundby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.820726,
        LOCATION_LATITUDE_DEG: 53.3831307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025000',
        LOCATION_NAME: 'Saundersfoot',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6979017,
        LOCATION_LATITUDE_DEG: 51.7112157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025200',
        LOCATION_NAME: 'Saunderton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8502268,
        LOCATION_LATITUDE_DEG: 51.7092689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025300',
        LOCATION_NAME: 'Saunderton Lee',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8437778,
        LOCATION_LATITUDE_DEG: 51.6953749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025400',
        LOCATION_NAME: 'Saunton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2037688,
        LOCATION_LATITUDE_DEG: 51.1168541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025500',
        LOCATION_NAME: 'Sausthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0702571,
        LOCATION_LATITUDE_DEG: 53.2025017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025600',
        LOCATION_NAME: 'Saverley Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0491898,
        LOCATION_LATITUDE_DEG: 52.945308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025700',
        LOCATION_NAME: 'Savernake',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6590592,
        LOCATION_LATITUDE_DEG: 51.3885488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025800',
        LOCATION_NAME: 'Savernake Forest',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6501641,
        LOCATION_LATITUDE_DEG: 51.3713465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025900',
        LOCATION_NAME: 'Savile Town',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6281722,
        LOCATION_LATITUDE_DEG: 53.6821696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026000',
        LOCATION_NAME: 'Sawbridge',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2622128,
        LOCATION_LATITUDE_DEG: 52.2894367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026100',
        LOCATION_NAME: 'Sawbridgeworth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1527152,
        LOCATION_LATITUDE_DEG: 51.8119697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026200',
        LOCATION_NAME: 'Sawdon',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5558632,
        LOCATION_LATITUDE_DEG: 54.2527121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026400',
        LOCATION_NAME: 'Sawley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3437637,
        LOCATION_LATITUDE_DEG: 53.9154027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026300',
        LOCATION_NAME: 'Sawley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6194294,
        LOCATION_LATITUDE_DEG: 54.1049095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026500',
        LOCATION_NAME: 'Sawmills',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4566844,
        LOCATION_LATITUDE_DEG: 53.0646095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026600',
        LOCATION_NAME: 'Sawston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1714116,
        LOCATION_LATITUDE_DEG: 52.1223008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026700',
        LOCATION_NAME: 'Sawtry',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2786417,
        LOCATION_LATITUDE_DEG: 52.4333305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026900',
        LOCATION_NAME: 'Saxby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7839707,
        LOCATION_LATITUDE_DEG: 52.7708754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA026800',
        LOCATION_NAME: 'Saxby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4882931,
        LOCATION_LATITUDE_DEG: 53.3635243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028400',
        LOCATION_NAME: 'Saxby All Saints',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027000',
        LOCATION_NAME: 'Saxby-All-Saints',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5011055,
        LOCATION_LATITUDE_DEG: 53.6364534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027100',
        LOCATION_NAME: 'Saxelby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9650894,
        LOCATION_LATITUDE_DEG: 52.781261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027200',
        LOCATION_NAME: 'Saxilby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6576664,
        LOCATION_LATITUDE_DEG: 53.2736223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027300',
        LOCATION_NAME: 'Saxlingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0135401,
        LOCATION_LATITUDE_DEG: 52.9149588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027400',
        LOCATION_NAME: 'Saxlingham Nethergate',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2874499,
        LOCATION_LATITUDE_DEG: 52.529619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027500',
        LOCATION_NAME: 'Saxlingham Thorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2618909,
        LOCATION_LATITUDE_DEG: 52.5308215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027600',
        LOCATION_NAME: 'Saxmundham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4899557,
        LOCATION_LATITUDE_DEG: 52.2144892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027700',
        LOCATION_NAME: 'Saxon Street',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4589433,
        LOCATION_LATITUDE_DEG: 52.2057067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027800',
        LOCATION_NAME: 'Saxondale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9856308,
        LOCATION_LATITUDE_DEG: 52.9504924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA027900',
        LOCATION_NAME: 'Saxtead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.298639,
        LOCATION_LATITUDE_DEG: 52.2428902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028000',
        LOCATION_NAME: 'Saxthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1410812,
        LOCATION_LATITUDE_DEG: 52.830049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028100',
        LOCATION_NAME: 'Saxton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2765222,
        LOCATION_LATITUDE_DEG: 53.8261793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028200',
        LOCATION_NAME: 'Sayerland',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2461046,
        LOCATION_LATITUDE_DEG: 50.8285761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA028300',
        LOCATION_NAME: 'Sayers Common',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.194704,
        LOCATION_LATITUDE_DEG: 50.9490924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000100',
        LOCATION_NAME: 'Scackleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0054744,
        LOCATION_LATITUDE_DEG: 54.1454118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000200',
        LOCATION_NAME: 'Scadabay',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7643626,
        LOCATION_LATITUDE_DEG: 57.8351377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000300',
        LOCATION_NAME: 'Scaftworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9998968,
        LOCATION_LATITUDE_DEG: 53.4179393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000400',
        LOCATION_NAME: 'Scagglethorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7217385,
        LOCATION_LATITUDE_DEG: 54.142401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000500',
        LOCATION_NAME: 'Scaladale',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7590853,
        LOCATION_LATITUDE_DEG: 57.9800546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000600',
        LOCATION_NAME: 'Scalasaig',
        COUNTY_NAME: 'Isle of Colonsay',
        POSTCODE: 'PA61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1932999,
        LOCATION_LATITUDE_DEG: 56.0686547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000700',
        LOCATION_NAME: 'Scalby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7181935,
        LOCATION_LATITUDE_DEG: 53.7570654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000800',
        LOCATION_NAME: 'Scalby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.446844,
        LOCATION_LATITUDE_DEG: 54.2998182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC000900',
        LOCATION_NAME: 'Scaldwell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8713279,
        LOCATION_LATITUDE_DEG: 52.3451355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001000',
        LOCATION_NAME: 'Scaleby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8633669,
        LOCATION_LATITUDE_DEG: 54.959408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001100',
        LOCATION_NAME: 'Scaleby Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8787273,
        LOCATION_LATITUDE_DEG: 54.9640165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001200',
        LOCATION_NAME: 'Scales',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2648044,
        LOCATION_LATITUDE_DEG: 54.7938029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC990104',
        LOCATION_NAME: 'Scales',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1123105,
        LOCATION_LATITUDE_DEG: 54.1412261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001300',
        LOCATION_NAME: 'Scalford',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8681999,
        LOCATION_LATITUDE_DEG: 52.8087788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001400',
        LOCATION_NAME: 'Scaliscro',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.869082,
        LOCATION_LATITUDE_DEG: 58.1410691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001500',
        LOCATION_NAME: 'Scalloway',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2771957,
        LOCATION_LATITUDE_DEG: 60.138707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001700',
        LOCATION_NAME: 'Scalpay',
        COUNTY_NAME: 'Isle of Scalpay',
        POSTCODE: 'HS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6962767,
        LOCATION_LATITUDE_DEG: 57.8733424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001800',
        LOCATION_NAME: 'Scalthwaiterigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7055665,
        LOCATION_LATITUDE_DEG: 54.3490471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001900',
        LOCATION_NAME: 'Scamblesby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0886234,
        LOCATION_LATITUDE_DEG: 53.2900165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002000',
        LOCATION_NAME: 'Scammonden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9163746,
        LOCATION_LATITUDE_DEG: 53.6419694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002100',
        LOCATION_NAME: 'Scampston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6814028,
        LOCATION_LATITUDE_DEG: 54.1672077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002200',
        LOCATION_NAME: 'Scampton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5721631,
        LOCATION_LATITUDE_DEG: 53.3014258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002300',
        LOCATION_NAME: 'Scaniport',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.28979,
        LOCATION_LATITUDE_DEG: 57.42437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002400',
        LOCATION_NAME: 'Scapegoat Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8696605,
        LOCATION_LATITUDE_DEG: 53.6468717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002500',
        LOCATION_NAME: 'Scarborough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4007689,
        LOCATION_LATITUDE_DEG: 54.2799158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002600',
        LOCATION_NAME: 'Scarcewater',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9279336,
        LOCATION_LATITUDE_DEG: 50.3532938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002700',
        LOCATION_NAME: 'Scarcliffe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2568829,
        LOCATION_LATITUDE_DEG: 53.21292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002800',
        LOCATION_NAME: 'Scarcroft',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4569228,
        LOCATION_LATITUDE_DEG: 53.8660902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC002900',
        LOCATION_NAME: 'Scardans Lower',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9824044,
        LOCATION_LATITUDE_DEG: 54.5166154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003000',
        LOCATION_NAME: 'Scardans Upper',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9824087,
        LOCATION_LATITUDE_DEG: 54.5332096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003300',
        LOCATION_NAME: 'Scarfskerry',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2712292,
        LOCATION_LATITUDE_DEG: 58.6494792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003400',
        LOCATION_NAME: 'Scargill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9219533,
        LOCATION_LATITUDE_DEG: 54.4913522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003500',
        LOCATION_NAME: 'Scarinish',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8062266,
        LOCATION_LATITUDE_DEG: 56.5032031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003600',
        LOCATION_NAME: 'Scarisbrick',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9423802,
        LOCATION_LATITUDE_DEG: 53.6131816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003700',
        LOCATION_NAME: 'Scarista',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0338176,
        LOCATION_LATITUDE_DEG: 57.8255364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003900',
        LOCATION_NAME: 'Scarning',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8912057,
        LOCATION_LATITUDE_DEG: 52.6716394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004000',
        LOCATION_NAME: 'Scarp',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1288139,
        LOCATION_LATITUDE_DEG: 58.0218628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004200',
        LOCATION_NAME: 'Scarrington',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9061555,
        LOCATION_LATITUDE_DEG: 52.9663934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004300',
        LOCATION_NAME: 'Scarrow Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6716302,
        LOCATION_LATITUDE_DEG: 54.9501117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004600',
        LOCATION_NAME: 'Scarth Hill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8612934,
        LOCATION_LATITUDE_DEG: 53.5517731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004700',
        LOCATION_NAME: 'Scartho',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.090932,
        LOCATION_LATITUDE_DEG: 53.5299344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004800',
        LOCATION_NAME: 'Scarva',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3656347,
        LOCATION_LATITUDE_DEG: 54.3331882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004900',
        LOCATION_NAME: 'Scawby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5392145,
        LOCATION_LATITUDE_DEG: 53.5373402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005000',
        LOCATION_NAME: 'Scawby Brook',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5088675,
        LOCATION_LATITUDE_DEG: 53.5441399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005100',
        LOCATION_NAME: 'Scawsby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1737931,
        LOCATION_LATITUDE_DEG: 53.5337536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005200',
        LOCATION_NAME: 'Scawthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1705084,
        LOCATION_LATITUDE_DEG: 53.5404552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005300',
        LOCATION_NAME: 'Scawton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1557988,
        LOCATION_LATITUDE_DEG: 54.2462176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005400',
        LOCATION_NAME: 'Scaynes Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0498748,
        LOCATION_LATITUDE_DEG: 50.9907908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005500',
        LOCATION_NAME: 'Scethrog',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2999739,
        LOCATION_LATITUDE_DEG: 51.9167262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005600',
        LOCATION_NAME: 'Sceughmire',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0114531,
        LOCATION_LATITUDE_DEG: 54.8736012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005700',
        LOCATION_NAME: 'Scholar Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2514092,
        LOCATION_LATITUDE_DEG: 53.1090245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006000',
        LOCATION_NAME: 'Scholes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7618216,
        LOCATION_LATITUDE_DEG: 53.5630062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005900',
        LOCATION_NAME: 'Scholes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7477558,
        LOCATION_LATITUDE_DEG: 53.7291799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC990517',
        LOCATION_NAME: 'Scholes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4276494,
        LOCATION_LATITUDE_DEG: 53.8246314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006100',
        LOCATION_NAME: 'Scholes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4275741,
        LOCATION_LATITUDE_DEG: 53.8245861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC005800',
        LOCATION_NAME: 'Scholes',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4129131,
        LOCATION_LATITUDE_DEG: 53.4541433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006200',
        LOCATION_NAME: 'School Aycliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6003481,
        LOCATION_LATITUDE_DEG: 54.6067604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006300',
        LOCATION_NAME: 'School House',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8973987,
        LOCATION_LATITUDE_DEG: 50.818416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006400',
        LOCATION_NAME: 'Scissett',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6243391,
        LOCATION_LATITUDE_DEG: 53.5887677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006500',
        LOCATION_NAME: 'Scleddau',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9930657,
        LOCATION_LATITUDE_DEG: 51.9677472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006600',
        LOCATION_NAME: 'Sco Ruston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3814851,
        LOCATION_LATITUDE_DEG: 52.7448414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006700',
        LOCATION_NAME: 'Scofton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0542563,
        LOCATION_LATITUDE_DEG: 53.3173254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006800',
        LOCATION_NAME: 'Scole',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1581316,
        LOCATION_LATITUDE_DEG: 52.3659075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC006900',
        LOCATION_NAME: 'Scolpaig',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4837195,
        LOCATION_LATITUDE_DEG: 57.6490273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007000',
        LOCATION_NAME: 'Scone',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3990689,
        LOCATION_LATITUDE_DEG: 56.4237652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007100',
        LOCATION_NAME: 'Sconser',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1216018,
        LOCATION_LATITUDE_DEG: 57.3112821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007200',
        LOCATION_NAME: 'Scopwick',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3982076,
        LOCATION_LATITUDE_DEG: 53.108897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007300',
        LOCATION_NAME: 'Scorborough',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4582155,
        LOCATION_LATITUDE_DEG: 53.8953792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007400',
        LOCATION_NAME: 'Scorguie',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2592138,
        LOCATION_LATITUDE_DEG: 57.4874777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007500',
        LOCATION_NAME: 'Scorrier',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1946869,
        LOCATION_LATITUDE_DEG: 50.2531833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007600',
        LOCATION_NAME: 'Scorriton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8264919,
        LOCATION_LATITUDE_DEG: 50.5007954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007800',
        LOCATION_NAME: 'Scorton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7585269,
        LOCATION_LATITUDE_DEG: 53.9327088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007700',
        LOCATION_NAME: 'Scorton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6147672,
        LOCATION_LATITUDE_DEG: 54.3961458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC007900',
        LOCATION_NAME: 'Scot Hay',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2987804,
        LOCATION_LATITUDE_DEG: 53.0244166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008000',
        LOCATION_NAME: 'Scotby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8728355,
        LOCATION_LATITUDE_DEG: 54.8882029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008100',
        LOCATION_NAME: 'Scotch Dyke',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9609907,
        LOCATION_LATITUDE_DEG: 55.0446246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008200',
        LOCATION_NAME: 'Scotforth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7897599,
        LOCATION_LATITUDE_DEG: 54.0273235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008300',
        LOCATION_NAME: 'Scothern',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4483442,
        LOCATION_LATITUDE_DEG: 53.2840196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008400',
        LOCATION_NAME: 'Scotland Gate',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5948824,
        LOCATION_LATITUDE_DEG: 55.152219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008500',
        LOCATION_NAME: 'Scotlandwell',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3131381,
        LOCATION_LATITUDE_DEG: 56.2002382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008600',
        LOCATION_NAME: 'Scots Gap',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9367066,
        LOCATION_LATITUDE_DEG: 55.1725212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008700',
        LOCATION_NAME: 'Scotscalder',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.549939,
        LOCATION_LATITUDE_DEG: 58.4837677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008800',
        LOCATION_NAME: 'Scotscraig',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9004753,
        LOCATION_LATITUDE_DEG: 56.4411538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC014500',
        LOCATION_NAME: 'Scotstown',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009100',
        LOCATION_NAME: 'Scotswood',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6871057,
        LOCATION_LATITUDE_DEG: 54.970698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009200',
        LOCATION_NAME: 'Scott Willoughby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4325082,
        LOCATION_LATITUDE_DEG: 52.9218798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009300',
        LOCATION_NAME: 'Scotter',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6655141,
        LOCATION_LATITUDE_DEG: 53.4980462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009400',
        LOCATION_NAME: 'Scotter Common',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6764869,
        LOCATION_LATITUDE_DEG: 53.4986447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009500',
        LOCATION_NAME: 'Scotterthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6800105,
        LOCATION_LATITUDE_DEG: 53.5070445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009700',
        LOCATION_NAME: 'Scotton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7013725,
        LOCATION_LATITUDE_DEG: 54.3551352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009600',
        LOCATION_NAME: 'Scotton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5023207,
        LOCATION_LATITUDE_DEG: 54.0286085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009800',
        LOCATION_NAME: 'Scotton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6586358,
        LOCATION_LATITUDE_DEG: 53.4809418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009900',
        LOCATION_NAME: 'Scotton Common',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.725632,
        LOCATION_LATITUDE_DEG: 53.4848396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010000',
        LOCATION_NAME: 'Scottow',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3793149,
        LOCATION_LATITUDE_DEG: 52.7606442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010100',
        LOCATION_NAME: 'Scotvein',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2360235,
        LOCATION_LATITUDE_DEG: 57.4873105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010200',
        LOCATION_NAME: 'Scoulton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9269361,
        LOCATION_LATITUDE_DEG: 52.5680337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010300',
        LOCATION_NAME: 'Scourie',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1506456,
        LOCATION_LATITUDE_DEG: 58.3520759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010400',
        LOCATION_NAME: 'Scousburgh',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3238065,
        LOCATION_LATITUDE_DEG: 59.9440887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010500',
        LOCATION_NAME: 'Scouthead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0473805,
        LOCATION_LATITUDE_DEG: 53.5482666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010600',
        LOCATION_NAME: 'Scoveston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.991969,
        LOCATION_LATITUDE_DEG: 51.7232224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010800',
        LOCATION_NAME: 'Scrabster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5529442,
        LOCATION_LATITUDE_DEG: 58.6069774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010900',
        LOCATION_NAME: 'Scrafield',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0471641,
        LOCATION_LATITUDE_DEG: 53.2008071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011000',
        LOCATION_NAME: 'Scrag Oak',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3370135,
        LOCATION_LATITUDE_DEG: 51.04229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011300',
        LOCATION_NAME: 'Scraptoft',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0430125,
        LOCATION_LATITUDE_DEG: 52.6431661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011400',
        LOCATION_NAME: 'Scratby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7116931,
        LOCATION_LATITUDE_DEG: 52.6781296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011500',
        LOCATION_NAME: 'Scrayingham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8834565,
        LOCATION_LATITUDE_DEG: 54.0276005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011600',
        LOCATION_NAME: 'Scredda',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7852886,
        LOCATION_LATITUDE_DEG: 50.3562875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011700',
        LOCATION_NAME: 'Scredington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3705907,
        LOCATION_LATITUDE_DEG: 52.9507809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012200',
        LOCATION_NAME: 'Scremby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1622422,
        LOCATION_LATITUDE_DEG: 53.1841967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012300',
        LOCATION_NAME: 'Scremerston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.988485,
        LOCATION_LATITUDE_DEG: 55.7348794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012400',
        LOCATION_NAME: 'Screveton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9103486,
        LOCATION_LATITUDE_DEG: 52.9849977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012500',
        LOCATION_NAME: 'Scribbagh',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9991221,
        LOCATION_LATITUDE_DEG: 54.3832075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012600',
        LOCATION_NAME: 'Scrivelsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1032241,
        LOCATION_LATITUDE_DEG: 53.176807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012700',
        LOCATION_NAME: 'Scriven',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4665351,
        LOCATION_LATITUDE_DEG: 54.0201044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012800',
        LOCATION_NAME: 'Scroggwood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3572046,
        LOCATION_LATITUDE_DEG: 54.9852073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012900',
        LOCATION_NAME: 'Scronkey',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8964891,
        LOCATION_LATITUDE_DEG: 53.9169082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013000',
        LOCATION_NAME: 'Scrooby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0204553,
        LOCATION_LATITUDE_DEG: 53.4093355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013100',
        LOCATION_NAME: 'Scrooby Top',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.016778,
        LOCATION_LATITUDE_DEG: 53.3926378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013200',
        LOCATION_NAME: 'Scropton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7138184,
        LOCATION_LATITUDE_DEG: 52.8688969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013300',
        LOCATION_NAME: 'Scrub Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1548611,
        LOCATION_LATITUDE_DEG: 53.0789923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013400',
        LOCATION_NAME: 'Scruton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5399833,
        LOCATION_LATITUDE_DEG: 54.3257307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013500',
        LOCATION_NAME: 'Sculcoates',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3437831,
        LOCATION_LATITUDE_DEG: 53.7598662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013600',
        LOCATION_NAME: 'Scullomie',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3763957,
        LOCATION_LATITUDE_DEG: 58.5149779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013700',
        LOCATION_NAME: 'Sculthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8155963,
        LOCATION_LATITUDE_DEG: 52.8417561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013800',
        LOCATION_NAME: 'Scunthorpe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6462981,
        LOCATION_LATITUDE_DEG: 53.5914533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC013900',
        LOCATION_NAME: 'Scupholme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1123843,
        LOCATION_LATITUDE_DEG: 53.4047182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC014000',
        LOCATION_NAME: 'Scurdie Ness',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4362807,
        LOCATION_LATITUDE_DEG: 56.7018738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC014100',
        LOCATION_NAME: 'Scurlage',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2155823,
        LOCATION_LATITUDE_DEG: 51.5660001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC014200',
        LOCATION_NAME: 'Scwrfa',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2471012,
        LOCATION_LATITUDE_DEG: 51.7844076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000100',
        LOCATION_NAME: 'Sea',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9247985,
        LOCATION_LATITUDE_DEG: 50.9117188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000200',
        LOCATION_NAME: 'Sea Mills',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6453459,
        LOCATION_LATITUDE_DEG: 51.4874738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000400',
        LOCATION_NAME: 'Sea Palling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6042086,
        LOCATION_LATITUDE_DEG: 52.7850415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000500',
        LOCATION_NAME: 'Seaborough',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8084858,
        LOCATION_LATITUDE_DEG: 50.8500134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000600',
        LOCATION_NAME: 'Seabrook',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1183905,
        LOCATION_LATITUDE_DEG: 51.0827827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000700',
        LOCATION_NAME: 'Seaburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3733,
        LOCATION_LATITUDE_DEG: 54.9316936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000800',
        LOCATION_NAME: 'Seacombe',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0250852,
        LOCATION_LATITUDE_DEG: 53.4098612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000900',
        LOCATION_NAME: 'Seacon',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5443405,
        LOCATION_LATITUDE_DEG: 55.1113566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001000',
        LOCATION_NAME: 'Seacroft',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4620601,
        LOCATION_LATITUDE_DEG: 53.8212849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001100',
        LOCATION_NAME: 'Seafield',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5883481,
        LOCATION_LATITUDE_DEG: 55.8785105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001200',
        LOCATION_NAME: 'Seaford',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.10231,
        LOCATION_LATITUDE_DEG: 50.7720708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001300',
        LOCATION_NAME: 'Seaforde',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.832203,
        LOCATION_LATITUDE_DEG: 54.2998683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE015300',
        LOCATION_NAME: 'Seaforth',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0019276,
        LOCATION_LATITUDE_DEG: 53.4756844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001400',
        LOCATION_NAME: 'Seaforth Head',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5884851,
        LOCATION_LATITUDE_DEG: 58.0544593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001500',
        LOCATION_NAME: 'Seagrave',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0821751,
        LOCATION_LATITUDE_DEG: 52.7514756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001600',
        LOCATION_NAME: 'Seaham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3347765,
        LOCATION_LATITUDE_DEG: 54.8381797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001700',
        LOCATION_NAME: 'Seahouses',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6527644,
        LOCATION_LATITUDE_DEG: 55.5825566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001800',
        LOCATION_NAME: 'Seal',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2234837,
        LOCATION_LATITUDE_DEG: 51.2888227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001900',
        LOCATION_NAME: 'Seal Sands',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2002253,
        LOCATION_LATITUDE_DEG: 54.6225569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002000',
        LOCATION_NAME: 'Sealand',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9706422,
        LOCATION_LATITUDE_DEG: 53.2123448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002100',
        LOCATION_NAME: 'Seale',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7157205,
        LOCATION_LATITUDE_DEG: 51.2222231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002300',
        LOCATION_NAME: 'Seamer',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2296762,
        LOCATION_LATITUDE_DEG: 54.4852471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002200',
        LOCATION_NAME: 'Seamer',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4420343,
        LOCATION_LATITUDE_DEG: 54.2383139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002400',
        LOCATION_NAME: 'Seamill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8616379,
        LOCATION_LATITUDE_DEG: 55.6866029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002500',
        LOCATION_NAME: 'Seapatrick',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2822272,
        LOCATION_LATITUDE_DEG: 54.3498837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002600',
        LOCATION_NAME: 'Searby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3767831,
        LOCATION_LATITUDE_DEG: 53.5396417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002700',
        LOCATION_NAME: 'Seasalter',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0046111,
        LOCATION_LATITUDE_DEG: 51.3465115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002800',
        LOCATION_NAME: 'Seascale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4794038,
        LOCATION_LATITUDE_DEG: 54.396363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE002900',
        LOCATION_NAME: 'Seathorne',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3473506,
        LOCATION_LATITUDE_DEG: 53.1668979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003100',
        LOCATION_NAME: 'Seathwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1867607,
        LOCATION_LATITUDE_DEG: 54.3539578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003000',
        LOCATION_NAME: 'Seathwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1822103,
        LOCATION_LATITUDE_DEG: 54.4965721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003200',
        LOCATION_NAME: 'Seatoller',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1670445,
        LOCATION_LATITUDE_DEG: 54.5138696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003500',
        LOCATION_NAME: 'Seaton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3835738,
        LOCATION_LATITUDE_DEG: 50.3637895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003300',
        LOCATION_NAME: 'Seaton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5189536,
        LOCATION_LATITUDE_DEG: 54.6582864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003700',
        LOCATION_NAME: 'Seaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0715966,
        LOCATION_LATITUDE_DEG: 50.7076066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003800',
        LOCATION_NAME: 'Seaton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'SR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3819563,
        LOCATION_LATITUDE_DEG: 54.84348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003400',
        LOCATION_NAME: 'Seaton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6652611,
        LOCATION_LATITUDE_DEG: 52.5745496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003600',
        LOCATION_NAME: 'Seaton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2272234,
        LOCATION_LATITUDE_DEG: 53.9032747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE003900',
        LOCATION_NAME: 'Seaton Burn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6254719,
        LOCATION_LATITUDE_DEG: 55.0581047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004000',
        LOCATION_NAME: 'Seaton Carew',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1853772,
        LOCATION_LATITUDE_DEG: 54.6586618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004100',
        LOCATION_NAME: 'Seaton Delaval',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5233993,
        LOCATION_LATITUDE_DEG: 55.0730083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004200',
        LOCATION_NAME: 'Seaton Junction',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0647631,
        LOCATION_LATITUDE_DEG: 50.7642054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004300',
        LOCATION_NAME: 'Seaton Ross',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8141406,
        LOCATION_LATITUDE_DEG: 53.8631772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004400',
        LOCATION_NAME: 'Seaton Sluice',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4681381,
        LOCATION_LATITUDE_DEG: 55.0791065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004500',
        LOCATION_NAME: 'Seatown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8209166,
        LOCATION_LATITUDE_DEG: 50.7227994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE015500',
        LOCATION_NAME: 'Seaview',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004600',
        LOCATION_NAME: 'Seaview',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1156104,
        LOCATION_LATITUDE_DEG: 50.7128826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004700',
        LOCATION_NAME: 'Seaville',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3138387,
        LOCATION_LATITUDE_DEG: 54.8677046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004800',
        LOCATION_NAME: 'Seavington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8500888,
        LOCATION_LATITUDE_DEG: 50.9307235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE004900',
        LOCATION_NAME: 'Sebastopol',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0230154,
        LOCATION_LATITUDE_DEG: 51.677798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005000',
        LOCATION_NAME: 'Sebergham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.999364,
        LOCATION_LATITUDE_DEG: 54.767293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005100',
        LOCATION_NAME: 'Seckington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6124577,
        LOCATION_LATITUDE_DEG: 52.6639738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005200',
        LOCATION_NAME: 'Sector',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.974606,
        LOCATION_LATITUDE_DEG: 50.7782057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005300',
        LOCATION_NAME: 'Sedbergh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5269107,
        LOCATION_LATITUDE_DEG: 54.3234437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005400',
        LOCATION_NAME: 'Sedbury',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6579419,
        LOCATION_LATITUDE_DEG: 51.6398904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005500',
        LOCATION_NAME: 'Sedbusk',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1785329,
        LOCATION_LATITUDE_DEG: 54.315339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005600',
        LOCATION_NAME: 'Seddington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.281669,
        LOCATION_LATITUDE_DEG: 52.1109003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005700',
        LOCATION_NAME: 'Sedge Fen',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4559243,
        LOCATION_LATITUDE_DEG: 52.4340205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005800',
        LOCATION_NAME: 'Sedgeberrow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9628,
        LOCATION_LATITUDE_DEG: 52.0448201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE005900',
        LOCATION_NAME: 'Sedgebrook',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7252639,
        LOCATION_LATITUDE_DEG: 52.9315854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006000',
        LOCATION_NAME: 'Sedgefield',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4465688,
        LOCATION_LATITUDE_DEG: 54.6534675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006100',
        LOCATION_NAME: 'Sedgeford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5456314,
        LOCATION_LATITUDE_DEG: 52.8989706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006200',
        LOCATION_NAME: 'Sedgehill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1902572,
        LOCATION_LATITUDE_DEG: 51.0522303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006300',
        LOCATION_NAME: 'Sedgeletch',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4922212,
        LOCATION_LATITUDE_DEG: 54.8507858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006400',
        LOCATION_NAME: 'Sedgley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1194866,
        LOCATION_LATITUDE_DEG: 52.5398713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006500',
        LOCATION_NAME: 'Sedgwick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7478985,
        LOCATION_LATITUDE_DEG: 54.276345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006600',
        LOCATION_NAME: 'Sedlescombe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5357861,
        LOCATION_LATITUDE_DEG: 50.9335846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE015000',
        LOCATION_NAME: 'Seedley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2948574,
        LOCATION_LATITUDE_DEG: 53.4863616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006700',
        LOCATION_NAME: 'Seend',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0825704,
        LOCATION_LATITUDE_DEG: 51.3474513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006800',
        LOCATION_NAME: 'Seend Cleeve',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0996758,
        LOCATION_LATITUDE_DEG: 51.348652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE006900',
        LOCATION_NAME: 'Seer Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6035647,
        LOCATION_LATITUDE_DEG: 51.6186636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007100',
        LOCATION_NAME: 'Seething',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4198298,
        LOCATION_LATITUDE_DEG: 52.5276182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007200',
        LOCATION_NAME: 'Sefton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9704287,
        LOCATION_LATITUDE_DEG: 53.5038758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007300',
        LOCATION_NAME: 'Sefton Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9380662,
        LOCATION_LATITUDE_DEG: 53.3827615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE015800',
        LOCATION_NAME: 'Sefton Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.585611,
        LOCATION_LATITUDE_DEG: 51.4750447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007400',
        LOCATION_NAME: 'Segensworth West',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2514382,
        LOCATION_LATITUDE_DEG: 50.8713953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007500',
        LOCATION_NAME: 'Seghill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5522433,
        LOCATION_LATITUDE_DEG: 55.062405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007600',
        LOCATION_NAME: 'Segurinside',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7821098,
        LOCATION_LATITUDE_DEG: 53.2958578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007700',
        LOCATION_NAME: 'Seifton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.755698,
        LOCATION_LATITUDE_DEG: 52.4413677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007800',
        LOCATION_NAME: 'Seifton Batch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7646871,
        LOCATION_LATITUDE_DEG: 52.4540685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007900',
        LOCATION_NAME: 'Seighford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1757486,
        LOCATION_LATITUDE_DEG: 52.8214982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008000',
        LOCATION_NAME: 'Seilebost',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9539429,
        LOCATION_LATITUDE_DEG: 57.8662446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008100',
        LOCATION_NAME: 'Seisdon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2369655,
        LOCATION_LATITUDE_DEG: 52.5503667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008200',
        LOCATION_NAME: 'Selattyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0886328,
        LOCATION_LATITUDE_DEG: 52.8988127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008300',
        LOCATION_NAME: 'Selborne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9369938,
        LOCATION_LATITUDE_DEG: 51.0939126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008400',
        LOCATION_NAME: 'Selby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0709612,
        LOCATION_LATITUDE_DEG: 53.7813719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008500',
        LOCATION_NAME: 'Selby Common',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1144209,
        LOCATION_LATITUDE_DEG: 53.7919756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008600',
        LOCATION_NAME: 'Selham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6684244,
        LOCATION_LATITUDE_DEG: 50.9782997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008700',
        LOCATION_NAME: 'Selhurst Park',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6799788,
        LOCATION_LATITUDE_DEG: 50.887296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008800',
        LOCATION_NAME: 'Selkirk',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8374545,
        LOCATION_LATITUDE_DEG: 55.5482674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE008900',
        LOCATION_NAME: 'Sellack',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.624181,
        LOCATION_LATITUDE_DEG: 51.9445141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009000',
        LOCATION_NAME: 'Sellafield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5096694,
        LOCATION_LATITUDE_DEG: 54.4171667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009100',
        LOCATION_NAME: 'Sellafirth',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0446754,
        LOCATION_LATITUDE_DEG: 60.6615509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009200',
        LOCATION_NAME: 'Sellicks Green',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1207157,
        LOCATION_LATITUDE_DEG: 50.9660334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009300',
        LOCATION_NAME: 'Sellindge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0071536,
        LOCATION_LATITUDE_DEG: 51.1024855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009400',
        LOCATION_NAME: 'Selling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.923478,
        LOCATION_LATITUDE_DEG: 51.2706032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE015600',
        LOCATION_NAME: 'Selly Oak',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9415759,
        LOCATION_LATITUDE_DEG: 52.4402071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE015700',
        LOCATION_NAME: 'Selly Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9210595,
        LOCATION_LATITUDE_DEG: 52.4441063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009500',
        LOCATION_NAME: 'Selmeston',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1440735,
        LOCATION_LATITUDE_DEG: 50.8418748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009600',
        LOCATION_NAME: 'Selsdon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0612891,
        LOCATION_LATITUDE_DEG: 51.3428306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009700',
        LOCATION_NAME: 'Selsey',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7930426,
        LOCATION_LATITUDE_DEG: 50.7282833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009900',
        LOCATION_NAME: 'Selside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7280803,
        LOCATION_LATITUDE_DEG: 54.3866557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE009800',
        LOCATION_NAME: 'Selside',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3325389,
        LOCATION_LATITUDE_DEG: 54.177131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010000',
        LOCATION_NAME: 'Selsley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2404082,
        LOCATION_LATITUDE_DEG: 51.7317965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010100',
        LOCATION_NAME: 'Selsley East',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2404035,
        LOCATION_LATITUDE_DEG: 51.7281907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010200',
        LOCATION_NAME: 'Selsley Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2389982,
        LOCATION_LATITUDE_DEG: 51.7362955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010300',
        LOCATION_NAME: 'Selsley West',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2503093,
        LOCATION_LATITUDE_DEG: 51.7283948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010400',
        LOCATION_NAME: 'Selsted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.174263,
        LOCATION_LATITUDE_DEG: 51.1579956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010500',
        LOCATION_NAME: 'Selston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3015283,
        LOCATION_LATITUDE_DEG: 53.0737073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010700',
        LOCATION_NAME: 'Selworthy',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5467641,
        LOCATION_LATITUDE_DEG: 51.2095595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010800',
        LOCATION_NAME: 'Semer',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9173388,
        LOCATION_LATITUDE_DEG: 52.0809835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010900',
        LOCATION_NAME: 'Semilong',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8982545,
        LOCATION_LATITUDE_DEG: 52.2476228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011000',
        LOCATION_NAME: 'Semington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1465758,
        LOCATION_LATITUDE_DEG: 51.3437557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011100',
        LOCATION_NAME: 'Semley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1544486,
        LOCATION_LATITUDE_DEG: 51.0410236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011200',
        LOCATION_NAME: 'Sempringham Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3180176,
        LOCATION_LATITUDE_DEG: 52.8841774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011300',
        LOCATION_NAME: 'Send',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5284997,
        LOCATION_LATITUDE_DEG: 51.290132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011400',
        LOCATION_NAME: 'Sendmarsh',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5101605,
        LOCATION_LATITUDE_DEG: 51.2948285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011500',
        LOCATION_NAME: 'Senghenydd',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2753818,
        LOCATION_LATITUDE_DEG: 51.6075951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011600',
        LOCATION_NAME: 'Sennen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.69433,
        LOCATION_LATITUDE_DEG: 50.0697718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011700',
        LOCATION_NAME: 'Sennen Cove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7031324,
        LOCATION_LATITUDE_DEG: 50.0771392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011800',
        LOCATION_NAME: 'Sennybridge',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5667303,
        LOCATION_LATITUDE_DEG: 51.9471278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE011900',
        LOCATION_NAME: 'Serlby',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0493969,
        LOCATION_LATITUDE_DEG: 53.3981341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012000',
        LOCATION_NAME: 'Seskanore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2525237,
        LOCATION_LATITUDE_DEG: 54.5189104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012100',
        LOCATION_NAME: 'Seskilgreen',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9523009,
        LOCATION_LATITUDE_DEG: 54.5392126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012400',
        LOCATION_NAME: 'Sessay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3037827,
        LOCATION_LATITUDE_DEG: 54.1744184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012500',
        LOCATION_NAME: 'Setchey',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.421895,
        LOCATION_LATITUDE_DEG: 52.6962473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012600',
        LOCATION_NAME: 'Setmurthy',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2993456,
        LOCATION_LATITUDE_DEG: 54.6726879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012700',
        LOCATION_NAME: 'Settle',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2801163,
        LOCATION_LATITUDE_DEG: 54.0720173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012800',
        LOCATION_NAME: 'Settlingstones',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2429746,
        LOCATION_LATITUDE_DEG: 55.0083077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012900',
        LOCATION_NAME: 'Settrington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7240556,
        LOCATION_LATITUDE_DEG: 54.1253012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013000',
        LOCATION_NAME: 'Seven Ash',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2120868,
        LOCATION_LATITUDE_DEG: 51.0930196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013100',
        LOCATION_NAME: 'Seven Ash Common',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.504859,
        LOCATION_LATITUDE_DEG: 50.8873183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013200',
        LOCATION_NAME: 'Seven Crosses',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5170449,
        LOCATION_LATITUDE_DEG: 50.8883282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE990534',
        LOCATION_NAME: 'Seven Kings',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013300',
        LOCATION_NAME: 'Seven Sisters',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.709695,
        LOCATION_LATITUDE_DEG: 51.7664131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013400',
        LOCATION_NAME: 'Seven Springs',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0460142,
        LOCATION_LATITUDE_DEG: 51.8521044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013600',
        LOCATION_NAME: 'Seven Wells',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0197498,
        LOCATION_LATITUDE_DEG: 52.5032784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013700',
        LOCATION_NAME: 'Sevenhampton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9536094,
        LOCATION_LATITUDE_DEG: 51.8932063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013800',
        LOCATION_NAME: 'Sevenhampton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6987829,
        LOCATION_LATITUDE_DEG: 51.6119782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013900',
        LOCATION_NAME: 'Sevenmilestone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2010204,
        LOCATION_LATITUDE_DEG: 50.3019883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014000',
        LOCATION_NAME: 'Sevenoaks',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1844626,
        LOCATION_LATITUDE_DEG: 51.2760211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014100',
        LOCATION_NAME: 'Sevenstones',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2700324,
        LOCATION_LATITUDE_DEG: 50.5154948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014200',
        LOCATION_NAME: 'Severn Beach',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6614466,
        LOCATION_LATITUDE_DEG: 51.5598825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014300',
        LOCATION_NAME: 'Severn Stoke',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2085283,
        LOCATION_LATITUDE_DEG: 52.0946261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014400',
        LOCATION_NAME: 'Sevington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9087169,
        LOCATION_LATITUDE_DEG: 51.1289959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014500',
        LOCATION_NAME: 'Sewards End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2884308,
        LOCATION_LATITUDE_DEG: 52.0190912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014600',
        LOCATION_NAME: 'Sewell',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5557936,
        LOCATION_LATITUDE_DEG: 51.8946855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014700',
        LOCATION_NAME: 'Sewerby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1627393,
        LOCATION_LATITUDE_DEG: 54.1019939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014800',
        LOCATION_NAME: 'Sewstern',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6795111,
        LOCATION_LATITUDE_DEG: 52.7861766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE014900',
        LOCATION_NAME: 'Sezincote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7530776,
        LOCATION_LATITUDE_DEG: 51.9754118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000100',
        LOCATION_NAME: 'Shabbington',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0347981,
        LOCATION_LATITUDE_DEG: 51.7567826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000200',
        LOCATION_NAME: 'Shackerstone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4477191,
        LOCATION_LATITUDE_DEG: 52.6582678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000300',
        LOCATION_NAME: 'Shackleford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6618694,
        LOCATION_LATITUDE_DEG: 51.2000263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000400',
        LOCATION_NAME: 'Shadfen',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6440263,
        LOCATION_LATITUDE_DEG: 55.1638129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000500',
        LOCATION_NAME: 'Shadforth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4657065,
        LOCATION_LATITUDE_DEG: 54.7625752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000600',
        LOCATION_NAME: 'Shadingfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5786957,
        LOCATION_LATITUDE_DEG: 52.3938026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000700',
        LOCATION_NAME: 'Shadoxhurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.820009,
        LOCATION_LATITUDE_DEG: 51.1073954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000800',
        LOCATION_NAME: 'Shadwell',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4758463,
        LOCATION_LATITUDE_DEG: 53.8523852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041200',
        LOCATION_NAME: 'Shadwell',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0635977,
        LOCATION_LATITUDE_DEG: 51.5089566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH000900',
        LOCATION_NAME: 'Shadwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8471586,
        LOCATION_LATITUDE_DEG: 52.4128126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001000',
        LOCATION_NAME: 'Shaftesbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.193194,
        LOCATION_LATITUDE_DEG: 51.0070255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001100',
        LOCATION_NAME: 'Shafton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4079958,
        LOCATION_LATITUDE_DEG: 53.5931607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001200',
        LOCATION_NAME: 'Shalbourne',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5494241,
        LOCATION_LATITUDE_DEG: 51.3634485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001300',
        LOCATION_NAME: 'Shalcombe',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4386234,
        LOCATION_LATITUDE_DEG: 50.6704828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001400',
        LOCATION_NAME: 'Shalden',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0038439,
        LOCATION_LATITUDE_DEG: 51.1731212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001500',
        LOCATION_NAME: 'Shaldon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5078817,
        LOCATION_LATITUDE_DEG: 50.5393949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001600',
        LOCATION_NAME: 'Shalfleet',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.416827,
        LOCATION_LATITUDE_DEG: 50.7002803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001800',
        LOCATION_NAME: 'Shalford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5660167,
        LOCATION_LATITUDE_DEG: 51.2161224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001700',
        LOCATION_NAME: 'Shalford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5050427,
        LOCATION_LATITUDE_DEG: 51.9341782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001900',
        LOCATION_NAME: 'Shalford Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4889196,
        LOCATION_LATITUDE_DEG: 51.9162718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002000',
        LOCATION_NAME: 'Shallow Adit',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2241327,
        LOCATION_LATITUDE_DEG: 50.2590811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002100',
        LOCATION_NAME: 'Shallowford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1844263,
        LOCATION_LATITUDE_DEG: 52.8590023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002200',
        LOCATION_NAME: 'Shalstone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0643951,
        LOCATION_LATITUDE_DEG: 52.023002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002300',
        LOCATION_NAME: 'Shamley Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5235469,
        LOCATION_LATITUDE_DEG: 51.1842155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003100',
        LOCATION_NAME: 'Shandon',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G84',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.810059,
        LOCATION_LATITUDE_DEG: 56.048139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003200',
        LOCATION_NAME: 'Shandwick',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9187106,
        LOCATION_LATITUDE_DEG: 57.7489004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003300',
        LOCATION_NAME: 'Shangton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9447054,
        LOCATION_LATITUDE_DEG: 52.5588569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003400',
        LOCATION_NAME: 'Shankbridge',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2468142,
        LOCATION_LATITUDE_DEG: 54.8207266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003500',
        LOCATION_NAME: 'Shankhouse',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5779569,
        LOCATION_LATITUDE_DEG: 55.0994072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041300',
        LOCATION_NAME: 'Shankill',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9485022,
        LOCATION_LATITUDE_DEG: 54.6053317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003700',
        LOCATION_NAME: 'Shanklin',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1735887,
        LOCATION_LATITUDE_DEG: 50.6323713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004200',
        LOCATION_NAME: 'Shannochie',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1956877,
        LOCATION_LATITUDE_DEG: 55.4443894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005000',
        LOCATION_NAME: 'Shap',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6760067,
        LOCATION_LATITUDE_DEG: 54.5305633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005200',
        LOCATION_NAME: 'Shapwick',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8317616,
        LOCATION_LATITUDE_DEG: 51.1388463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005100',
        LOCATION_NAME: 'Shapwick',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.081914,
        LOCATION_LATITUDE_DEG: 50.8161993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005300',
        LOCATION_NAME: 'Sharcott',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7919828,
        LOCATION_LATITUDE_DEG: 51.3309469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041500',
        LOCATION_NAME: 'Shard End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7788782,
        LOCATION_LATITUDE_DEG: 52.4969731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005400',
        LOCATION_NAME: 'Shardlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3546341,
        LOCATION_LATITUDE_DEG: 52.8692863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005500',
        LOCATION_NAME: 'Shareshill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0806224,
        LOCATION_LATITUDE_DEG: 52.6558769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005600',
        LOCATION_NAME: 'Sharlston Common',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4117117,
        LOCATION_LATITUDE_DEG: 53.6693642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005700',
        LOCATION_NAME: 'Sharnbrook',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5426741,
        LOCATION_LATITUDE_DEG: 52.2257212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005800',
        LOCATION_NAME: 'Sharnford',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2933296,
        LOCATION_LATITUDE_DEG: 52.5211529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH005900',
        LOCATION_NAME: 'Sharoe Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7116259,
        LOCATION_LATITUDE_DEG: 53.7893945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006000',
        LOCATION_NAME: 'Sharow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.497695,
        LOCATION_LATITUDE_DEG: 54.1425119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006100',
        LOCATION_NAME: 'Sharpenhoe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4509319,
        LOCATION_LATITUDE_DEG: 51.9632875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006200',
        LOCATION_NAME: 'Sharperton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0686013,
        LOCATION_LATITUDE_DEG: 55.3283413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006300',
        LOCATION_NAME: 'Sharpham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7572716,
        LOCATION_LATITUDE_DEG: 51.1408452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006400',
        LOCATION_NAME: 'Sharpness',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4756218,
        LOCATION_LATITUDE_DEG: 51.7196958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006500',
        LOCATION_NAME: 'Sharpthorne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0409121,
        LOCATION_LATITUDE_DEG: 51.0753043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006600',
        LOCATION_NAME: 'Sharptor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4585489,
        LOCATION_LATITUDE_DEG: 50.5314998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006700',
        LOCATION_NAME: 'Sharrington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0194903,
        LOCATION_LATITUDE_DEG: 52.8888606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040500',
        LOCATION_NAME: 'Sharston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.257695,
        LOCATION_LATITUDE_DEG: 53.4076899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006800',
        LOCATION_NAME: 'Shatterford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3062875,
        LOCATION_LATITUDE_DEG: 52.4251604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH006900',
        LOCATION_NAME: 'Shatterling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2416647,
        LOCATION_LATITUDE_DEG: 51.2787073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007000',
        LOCATION_NAME: 'Shaugh Prior',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0532088,
        LOCATION_LATITUDE_DEG: 50.4488921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007100',
        LOCATION_NAME: 'Shave Cross',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8284861,
        LOCATION_LATITUDE_DEG: 50.7776083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007200',
        LOCATION_NAME: 'Shavington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4489259,
        LOCATION_LATITUDE_DEG: 53.0626207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007300',
        LOCATION_NAME: 'Shavington Park',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5332862,
        LOCATION_LATITUDE_DEG: 52.9473133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007500',
        LOCATION_NAME: 'Shaw',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1659743,
        LOCATION_LATITUDE_DEG: 51.3873625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007600',
        LOCATION_NAME: 'Shaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1096258,
        LOCATION_LATITUDE_DEG: 53.5762726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007700',
        LOCATION_NAME: 'Shaw',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8332718,
        LOCATION_LATITUDE_DEG: 51.5668707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007400',
        LOCATION_NAME: 'Shaw',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3016272,
        LOCATION_LATITUDE_DEG: 51.4085466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007800',
        LOCATION_NAME: 'Shaw Mills',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6084833,
        LOCATION_LATITUDE_DEG: 54.0572076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH007900',
        LOCATION_NAME: 'Shawbank',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7902367,
        LOCATION_LATITUDE_DEG: 52.4433628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008000',
        LOCATION_NAME: 'Shawbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6894553,
        LOCATION_LATITUDE_DEG: 58.3210861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008100',
        LOCATION_NAME: 'Shawbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6549138,
        LOCATION_LATITUDE_DEG: 52.7869967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008200',
        LOCATION_NAME: 'Shawell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1979752,
        LOCATION_LATITUDE_DEG: 52.4175413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008300',
        LOCATION_NAME: 'Shawford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3348733,
        LOCATION_LATITUDE_DEG: 51.0189171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008400',
        LOCATION_NAME: 'Shawforth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1635302,
        LOCATION_LATITUDE_DEG: 53.6812777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008500',
        LOCATION_NAME: 'Shawhead',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7675724,
        LOCATION_LATITUDE_DEG: 55.0650304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041700',
        LOCATION_NAME: 'Shawlands',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2796471,
        LOCATION_LATITUDE_DEG: 55.8350088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008600',
        LOCATION_NAME: 'Shawsburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9432653,
        LOCATION_LATITUDE_DEG: 55.7327033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008800',
        LOCATION_NAME: 'Sheader',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3487409,
        LOCATION_LATITUDE_DEG: 57.584612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008900',
        LOCATION_NAME: 'Sheardale',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6842399,
        LOCATION_LATITUDE_DEG: 56.1475343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009000',
        LOCATION_NAME: 'Shearington',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5164531,
        LOCATION_LATITUDE_DEG: 54.9830198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009100',
        LOCATION_NAME: 'Shearsby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0796391,
        LOCATION_LATITUDE_DEG: 52.5128507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009200',
        LOCATION_NAME: 'Shebbear',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2174063,
        LOCATION_LATITUDE_DEG: 50.8607333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009300',
        LOCATION_NAME: 'Shebdon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3563034,
        LOCATION_LATITUDE_DEG: 52.8284029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009400',
        LOCATION_NAME: 'Shebster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6830999,
        LOCATION_LATITUDE_DEG: 58.553476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009500',
        LOCATION_NAME: 'Shedfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.206825,
        LOCATION_LATITUDE_DEG: 50.9139013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009700',
        LOCATION_NAME: 'Sheen',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8326834,
        LOCATION_LATITUDE_DEG: 53.1486207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009800',
        LOCATION_NAME: 'Sheep Bridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.486401,
        LOCATION_LATITUDE_DEG: 52.7812979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009900',
        LOCATION_NAME: 'Sheepham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8884994,
        LOCATION_LATITUDE_DEG: 50.3594826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010000',
        LOCATION_NAME: 'Sheepridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7653894,
        LOCATION_LATITUDE_DEG: 53.6685747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041800',
        LOCATION_NAME: 'Sheepscar',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5302818,
        LOCATION_LATITUDE_DEG: 53.8164656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010100',
        LOCATION_NAME: 'Sheepscombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1561921,
        LOCATION_LATITUDE_DEG: 51.7888947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010200',
        LOCATION_NAME: 'Sheepstor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0308776,
        LOCATION_LATITUDE_DEG: 50.490293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010300',
        LOCATION_NAME: 'Sheepwash',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1499231,
        LOCATION_LATITUDE_DEG: 50.8359295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010400',
        LOCATION_NAME: 'Sheepwash',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6085451,
        LOCATION_LATITUDE_DEG: 55.1657172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010500',
        LOCATION_NAME: 'Sheepy Magna',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.525076,
        LOCATION_LATITUDE_DEG: 52.6039655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010600',
        LOCATION_NAME: 'Sheepy Parva',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5092881,
        LOCATION_LATITUDE_DEG: 52.6093677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010700',
        LOCATION_NAME: 'Sheering',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1859224,
        LOCATION_LATITUDE_DEG: 51.8031637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010800',
        LOCATION_NAME: 'Sheerness',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7657444,
        LOCATION_LATITUDE_DEG: 51.4397222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH010900',
        LOCATION_NAME: 'Sheerwater',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.526959,
        LOCATION_LATITUDE_DEG: 51.3324358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011000',
        LOCATION_NAME: 'Sheet',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9190495,
        LOCATION_LATITUDE_DEG: 51.0145061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011100',
        LOCATION_NAME: 'Sheffield Park',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0075901,
        LOCATION_LATITUDE_DEG: 50.9977951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011200',
        LOCATION_NAME: 'Sheffield S 1',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4712778,
        LOCATION_LATITUDE_DEG: 53.3786507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011300',
        LOCATION_NAME: 'Sheffield S 2',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4447732,
        LOCATION_LATITUDE_DEG: 53.3693338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011400',
        LOCATION_NAME: 'Sheffield S 3',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4748045,
        LOCATION_LATITUDE_DEG: 53.3901641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011500',
        LOCATION_NAME: 'Sheffield S 4',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4514731,
        LOCATION_LATITUDE_DEG: 53.3988871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011600',
        LOCATION_NAME: 'Sheffield S 5',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4626805,
        LOCATION_LATITUDE_DEG: 53.422644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011700',
        LOCATION_NAME: 'Sheffield S 6',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5959388,
        LOCATION_LATITUDE_DEG: 53.4123276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011800',
        LOCATION_NAME: 'Sheffield S 7',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4983348,
        LOCATION_LATITUDE_DEG: 53.3496226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH011900',
        LOCATION_NAME: 'Sheffield S 8',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4731704,
        LOCATION_LATITUDE_DEG: 53.3349237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012000',
        LOCATION_NAME: 'Sheffield S 9',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4129386,
        LOCATION_LATITUDE_DEG: 53.3987579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012100',
        LOCATION_NAME: 'Sheffield S10',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5817705,
        LOCATION_LATITUDE_DEG: 53.3673124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012200',
        LOCATION_NAME: 'Sheffield S11',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5338208,
        LOCATION_LATITUDE_DEG: 53.351079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012300',
        LOCATION_NAME: 'Sheffield S12',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4055801,
        LOCATION_LATITUDE_DEG: 53.3406833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012400',
        LOCATION_NAME: 'Sheffield S13',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3742341,
        LOCATION_LATITUDE_DEG: 53.3651103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012500',
        LOCATION_NAME: 'Sheffield S14',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4439631,
        LOCATION_LATITUDE_DEG: 53.3449677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012600',
        LOCATION_NAME: 'Sheffield S17',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5558198,
        LOCATION_LATITUDE_DEG: 53.3146464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012700',
        LOCATION_NAME: 'Sheffield S18',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4719451,
        LOCATION_LATITUDE_DEG: 53.2967115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012800',
        LOCATION_NAME: 'Sheffield S20',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3517746,
        LOCATION_LATITUDE_DEG: 53.3347575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH012900',
        LOCATION_NAME: 'Sheffield S21',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.352973,
        LOCATION_LATITUDE_DEG: 53.3061762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013000',
        LOCATION_NAME: 'Sheffield S25',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2205077,
        LOCATION_LATITUDE_DEG: 53.3718558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013100',
        LOCATION_NAME: 'Sheffield S26',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2854051,
        LOCATION_LATITUDE_DEG: 53.3509649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013200',
        LOCATION_NAME: 'Sheffield S40',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4405869,
        LOCATION_LATITUDE_DEG: 53.2516549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013300',
        LOCATION_NAME: 'Sheffield S41',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4186055,
        LOCATION_LATITUDE_DEG: 53.2454905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013400',
        LOCATION_NAME: 'Sheffield S42',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.377417,
        LOCATION_LATITUDE_DEG: 53.2126127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013500',
        LOCATION_NAME: 'Sheffield S43',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2900308,
        LOCATION_LATITUDE_DEG: 53.2859504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013600',
        LOCATION_NAME: 'Sheffield S44',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2888284,
        LOCATION_LATITUDE_DEG: 53.2327582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013700',
        LOCATION_NAME: 'Shefford',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3323712,
        LOCATION_LATITUDE_DEG: 52.0382942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013800',
        LOCATION_NAME: 'Shefford Woodlands',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.480038,
        LOCATION_LATITUDE_DEG: 51.4612537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH008700',
        LOCATION_NAME: 'SheFnlford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0147537,
        LOCATION_LATITUDE_DEG: 52.9737984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH013900',
        LOCATION_NAME: 'Sheinton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5729818,
        LOCATION_LATITUDE_DEG: 52.6311789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014000',
        LOCATION_NAME: 'Shelderton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8726487,
        LOCATION_LATITUDE_DEG: 52.3933669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014300',
        LOCATION_NAME: 'Sheldon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2490718,
        LOCATION_LATITUDE_DEG: 50.8693245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014100',
        LOCATION_NAME: 'Sheldon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1577008,
        LOCATION_LATITUDE_DEG: 51.464063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040900',
        LOCATION_NAME: 'Sheldon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7820146,
        LOCATION_LATITUDE_DEG: 52.4585243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014200',
        LOCATION_NAME: 'Sheldon',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.737528,
        LOCATION_LATITUDE_DEG: 53.215631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014400',
        LOCATION_NAME: 'Sheldwich',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8826247,
        LOCATION_LATITUDE_DEG: 51.273605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014500',
        LOCATION_NAME: 'Sheldwich Lees',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8890728,
        LOCATION_LATITUDE_DEG: 51.269407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014600',
        LOCATION_NAME: 'Shelf',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.808618,
        LOCATION_LATITUDE_DEG: 53.7560801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014700',
        LOCATION_NAME: 'Shelfanger',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0983175,
        LOCATION_LATITUDE_DEG: 52.4102161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014900',
        LOCATION_NAME: 'Shelfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9485489,
        LOCATION_LATITUDE_DEG: 52.6174756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH014800',
        LOCATION_NAME: 'Shelfield',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8141406,
        LOCATION_LATITUDE_DEG: 52.2602421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH990218',
        LOCATION_NAME: 'Shelford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.016581,
        LOCATION_LATITUDE_DEG: 52.9753149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015000',
        LOCATION_NAME: 'Shell',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0701042,
        LOCATION_LATITUDE_DEG: 52.23494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015100',
        LOCATION_NAME: 'Shell Haven',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5183497,
        LOCATION_LATITUDE_DEG: 51.5162405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015150',
        LOCATION_NAME: 'Shelland',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9329821,
        LOCATION_LATITUDE_DEG: 52.2040615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015200',
        LOCATION_NAME: 'Shellbrook',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4967993,
        LOCATION_LATITUDE_DEG: 52.7452831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015300',
        LOCATION_NAME: 'Shelley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6899745,
        LOCATION_LATITUDE_DEG: 53.5965607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015400',
        LOCATION_NAME: 'Shelley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9607776,
        LOCATION_LATITUDE_DEG: 52.0069803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015500',
        LOCATION_NAME: 'Shellingford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.541133,
        LOCATION_LATITUDE_DEG: 51.6405763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015600',
        LOCATION_NAME: 'Shelsley Beauchamp',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3915388,
        LOCATION_LATITUDE_DEG: 52.2645406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015700',
        LOCATION_NAME: 'Shelsley Walsh',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4078265,
        LOCATION_LATITUDE_DEG: 52.2652498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016000',
        LOCATION_NAME: 'Shelton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7959933,
        LOCATION_LATITUDE_DEG: 52.7148909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015800',
        LOCATION_NAME: 'Shelton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8401911,
        LOCATION_LATITUDE_DEG: 52.9917963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH015900',
        LOCATION_NAME: 'Shelton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4840987,
        LOCATION_LATITUDE_DEG: 52.3083223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016100',
        LOCATION_NAME: 'Shelton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2694222,
        LOCATION_LATITUDE_DEG: 52.4704116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016200',
        LOCATION_NAME: 'Shelton Lock',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4415912,
        LOCATION_LATITUDE_DEG: 52.8765958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016300',
        LOCATION_NAME: 'Shelton under Harley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2732806,
        LOCATION_LATITUDE_DEG: 52.9532121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016400',
        LOCATION_NAME: 'Shelve',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9787366,
        LOCATION_LATITUDE_DEG: 52.5844831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016500',
        LOCATION_NAME: 'Shelwick',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.694311,
        LOCATION_LATITUDE_DEG: 52.0837293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016600',
        LOCATION_NAME: 'Shendish',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4687373,
        LOCATION_LATITUDE_DEG: 51.7283694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016700',
        LOCATION_NAME: 'Shenfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3258219,
        LOCATION_LATITUDE_DEG: 51.6326526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016800',
        LOCATION_NAME: 'Shenington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4576621,
        LOCATION_LATITUDE_DEG: 52.0820178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH016900',
        LOCATION_NAME: 'Shenley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2796332,
        LOCATION_LATITUDE_DEG: 51.6917676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017000',
        LOCATION_NAME: 'Shenley Brook End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7797791,
        LOCATION_LATITUDE_DEG: 52.0145978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017100',
        LOCATION_NAME: 'Shenley Church End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.78553,
        LOCATION_LATITUDE_DEG: 52.0261043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017200',
        LOCATION_NAME: 'Shenley Lodge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7720522,
        LOCATION_LATITUDE_DEG: 52.0178986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017300',
        LOCATION_NAME: 'Shenley Wood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.799471,
        LOCATION_LATITUDE_DEG: 52.0172011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017400',
        LOCATION_NAME: 'Shenleybury',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2878794,
        LOCATION_LATITUDE_DEG: 51.7021672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017500',
        LOCATION_NAME: 'Shenstone',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2008134,
        LOCATION_LATITUDE_DEG: 52.3592476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017600',
        LOCATION_NAME: 'Shenstone',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8406926,
        LOCATION_LATITUDE_DEG: 52.6393711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017700',
        LOCATION_NAME: 'Shenstone Wood End',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8373111,
        LOCATION_LATITUDE_DEG: 52.6146688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017800',
        LOCATION_NAME: 'Shenton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4307872,
        LOCATION_LATITUDE_DEG: 52.5980655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH017900',
        LOCATION_NAME: 'Shepeau Stow',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0681394,
        LOCATION_LATITUDE_DEG: 52.6911581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018000',
        LOCATION_NAME: 'Shephall',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1804177,
        LOCATION_LATITUDE_DEG: 51.888283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041100',
        LOCATION_NAME: 'Shepherds Bush',
        COUNTY_NAME: 'London',
        POSTCODE: 'W12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2375806,
        LOCATION_LATITUDE_DEG: 51.5172853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018100',
        LOCATION_NAME: 'Shepherdswell',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2313346,
        LOCATION_LATITUDE_DEG: 51.1860914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018200',
        LOCATION_NAME: 'Shepley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7073346,
        LOCATION_LATITUDE_DEG: 53.5838665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018300',
        LOCATION_NAME: 'Shepperton',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4472327,
        LOCATION_LATITUDE_DEG: 51.3954392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018400',
        LOCATION_NAME: 'Shepreth',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0344339,
        LOCATION_LATITUDE_DEG: 52.1121993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018500',
        LOCATION_NAME: 'Shepshed',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2886634,
        LOCATION_LATITUDE_DEG: 52.7712797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018600',
        LOCATION_NAME: 'Shepton Beauchamp',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8475918,
        LOCATION_LATITUDE_DEG: 50.9507254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018700',
        LOCATION_NAME: 'Shepton Mallet',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5484566,
        LOCATION_LATITUDE_DEG: 51.1897462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018800',
        LOCATION_NAME: 'Shepton Montague',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.464698,
        LOCATION_LATITUDE_DEG: 51.0805365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH018900',
        LOCATION_NAME: 'Shepway',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.546721,
        LOCATION_LATITUDE_DEG: 51.2525073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019000',
        LOCATION_NAME: 'Sheraton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3170399,
        LOCATION_LATITUDE_DEG: 54.7089719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019200',
        LOCATION_NAME: 'Sherborne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.515007,
        LOCATION_LATITUDE_DEG: 50.9501203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019100',
        LOCATION_NAME: 'Sherborne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7424433,
        LOCATION_LATITUDE_DEG: 51.826393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039500',
        LOCATION_NAME: 'Sherborne St John',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019300',
        LOCATION_NAME: 'Sherborne St. John',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1103578,
        LOCATION_LATITUDE_DEG: 51.2947397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019400',
        LOCATION_NAME: 'Sherbourne',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6126914,
        LOCATION_LATITUDE_DEG: 52.2533333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019600',
        LOCATION_NAME: 'Sherburn',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5033379,
        LOCATION_LATITUDE_DEG: 54.7750752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019500',
        LOCATION_NAME: 'Sherburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5312851,
        LOCATION_LATITUDE_DEG: 54.1775071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019700',
        LOCATION_NAME: 'Sherburn Hill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4735448,
        LOCATION_LATITUDE_DEG: 54.775381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019800',
        LOCATION_NAME: 'Sherburn House',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5160256,
        LOCATION_LATITUDE_DEG: 54.7632717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH019900',
        LOCATION_NAME: 'Sherburn in Elmet',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2504141,
        LOCATION_LATITUDE_DEG: 53.7974783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020100',
        LOCATION_NAME: 'Shere',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4629278,
        LOCATION_LATITUDE_DEG: 51.219922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020200',
        LOCATION_NAME: 'Shereford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8044839,
        LOCATION_LATITUDE_DEG: 52.8306607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020300',
        LOCATION_NAME: 'Sherfield English',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5842735,
        LOCATION_LATITUDE_DEG: 50.999215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020350',
        LOCATION_NAME: 'Sherfield-on-Loddon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0239764,
        LOCATION_LATITUDE_DEG: 51.3164624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020400',
        LOCATION_NAME: 'Sherford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7139751,
        LOCATION_LATITUDE_DEG: 50.2845679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020500',
        LOCATION_NAME: 'Sherford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1093867,
        LOCATION_LATITUDE_DEG: 51.0046344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020600',
        LOCATION_NAME: 'Sherford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1205171,
        LOCATION_LATITUDE_DEG: 50.7399988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH991032',
        LOCATION_NAME: 'Sherford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0395126,
        LOCATION_LATITUDE_DEG: 50.367848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040400',
        LOCATION_NAME: 'Sheriff Hill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5880377,
        LOCATION_LATITUDE_DEG: 54.9450405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020700',
        LOCATION_NAME: 'Sheriff Hutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0050497,
        LOCATION_LATITUDE_DEG: 54.090306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020800',
        LOCATION_NAME: 'Sheriffhales',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3541693,
        LOCATION_LATITUDE_DEG: 52.7045905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021000',
        LOCATION_NAME: 'Sheriffmuir',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9131209,
        LOCATION_LATITUDE_DEG: 56.1855442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021100',
        LOCATION_NAME: 'Sheriffs Lench',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9255621,
        LOCATION_LATITUDE_DEG: 52.1115204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021200',
        LOCATION_NAME: 'Sheringham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.210298,
        LOCATION_LATITUDE_DEG: 52.9424582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021300',
        LOCATION_NAME: 'Sherington',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6983607,
        LOCATION_LATITUDE_DEG: 52.1113098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021400',
        LOCATION_NAME: 'Shermanbury',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2792186,
        LOCATION_LATITUDE_DEG: 50.9522933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021500',
        LOCATION_NAME: 'Shernal Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1246024,
        LOCATION_LATITUDE_DEG: 52.2472402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021600',
        LOCATION_NAME: 'Shernborne',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5463468,
        LOCATION_LATITUDE_DEG: 52.8614642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021700',
        LOCATION_NAME: 'Sherrards Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2865433,
        LOCATION_LATITUDE_DEG: 52.1127333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021800',
        LOCATION_NAME: 'Sherrington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0535906,
        LOCATION_LATITUDE_DEG: 51.1492378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH021900',
        LOCATION_NAME: 'Sherstock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2439277,
        LOCATION_LATITUDE_DEG: 51.0208252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022000',
        LOCATION_NAME: 'Sherston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2099155,
        LOCATION_LATITUDE_DEG: 51.5733749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022100',
        LOCATION_NAME: 'Sherwell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2719321,
        LOCATION_LATITUDE_DEG: 50.5244981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022200',
        LOCATION_NAME: 'Sherwood',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1443381,
        LOCATION_LATITUDE_DEG: 52.9793959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022300',
        LOCATION_NAME: 'Sherwood Rise',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1540594,
        LOCATION_LATITUDE_DEG: 52.9690005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022500',
        LOCATION_NAME: 'Sheskinshule',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1799209,
        LOCATION_LATITUDE_DEG: 54.6686235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022600',
        LOCATION_NAME: 'Shetland',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2321967,
        LOCATION_LATITUDE_DEG: 60.1434019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041600',
        LOCATION_NAME: 'Shettleston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1617933,
        LOCATION_LATITUDE_DEG: 55.8454241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022700',
        LOCATION_NAME: 'Shevington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6873515,
        LOCATION_LATITUDE_DEG: 53.574573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022800',
        LOCATION_NAME: 'Shevington Moor',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6849039,
        LOCATION_LATITUDE_DEG: 53.5894737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022900',
        LOCATION_NAME: 'Sheviock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2924046,
        LOCATION_LATITUDE_DEG: 50.3734852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023000',
        LOCATION_NAME: 'Shibden Head',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8533555,
        LOCATION_LATITUDE_DEG: 53.7588849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023100',
        LOCATION_NAME: 'Shide',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2936821,
        LOCATION_LATITUDE_DEG: 50.6876823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023200',
        LOCATION_NAME: 'Shield Row',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6816311,
        LOCATION_LATITUDE_DEG: 54.8746896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023300',
        LOCATION_NAME: 'Shieldaig',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6803334,
        LOCATION_LATITUDE_DEG: 57.6889123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023350',
        LOCATION_NAME: 'Shieldaig',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6507044,
        LOCATION_LATITUDE_DEG: 57.5218875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040600',
        LOCATION_NAME: 'Shieldfield',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.598259,
        LOCATION_LATITUDE_DEG: 54.9768719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023400',
        LOCATION_NAME: 'Shieldhall',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3475727,
        LOCATION_LATITUDE_DEG: 55.8630163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH990914',
        LOCATION_NAME: 'Shieldhill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023500',
        LOCATION_NAME: 'Shieldhill',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7629017,
        LOCATION_LATITUDE_DEG: 55.9722369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023600',
        LOCATION_NAME: 'Shifford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4585133,
        LOCATION_LATITUDE_DEG: 51.7152833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023700',
        LOCATION_NAME: 'SHIFNAL',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3714685,
        LOCATION_LATITUDE_DEG: 52.6657874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023800',
        LOCATION_NAME: 'Shilbottle',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6899148,
        LOCATION_LATITUDE_DEG: 55.3716338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH023900',
        LOCATION_NAME: 'Shildon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6465915,
        LOCATION_LATITUDE_DEG: 54.6323668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024200',
        LOCATION_NAME: 'Shillingford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4539362,
        LOCATION_LATITUDE_DEG: 51.0041371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024100',
        LOCATION_NAME: 'Shillingford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1346108,
        LOCATION_LATITUDE_DEG: 51.6206677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024300',
        LOCATION_NAME: 'Shillingford Abbot',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5416733,
        LOCATION_LATITUDE_DEG: 50.6882071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024400',
        LOCATION_NAME: 'Shillingford Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1331012,
        LOCATION_LATITUDE_DEG: 51.6187681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039600',
        LOCATION_NAME: 'Shillingford St George',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024500',
        LOCATION_NAME: 'Shillingford St. George',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5492578,
        LOCATION_LATITUDE_DEG: 50.6786085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH990531',
        LOCATION_NAME: 'Shillinglee',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024600',
        LOCATION_NAME: 'Shillingstone',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.24703,
        LOCATION_LATITUDE_DEG: 50.8988148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024700',
        LOCATION_NAME: 'Shillington',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3584368,
        LOCATION_LATITUDE_DEG: 51.9930948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024900',
        LOCATION_NAME: 'Shilton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6130967,
        LOCATION_LATITUDE_DEG: 51.7740913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024800',
        LOCATION_NAME: 'Shilton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4051294,
        LOCATION_LATITUDE_DEG: 52.4558537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025000',
        LOCATION_NAME: 'Shilvinghampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5320634,
        LOCATION_LATITUDE_DEG: 50.6551958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025100',
        LOCATION_NAME: 'Shilvington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7530319,
        LOCATION_LATITUDE_DEG: 55.1237126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025300',
        LOCATION_NAME: 'Shimpling',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7190466,
        LOCATION_LATITUDE_DEG: 52.1289891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025200',
        LOCATION_NAME: 'Shimpling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1651213,
        LOCATION_LATITUDE_DEG: 52.4030122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025400',
        LOCATION_NAME: 'Shincliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5376654,
        LOCATION_LATITUDE_DEG: 54.7533798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025500',
        LOCATION_NAME: 'Shiney Row',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4937372,
        LOCATION_LATITUDE_DEG: 54.8677875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025600',
        LOCATION_NAME: 'Shinfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9436994,
        LOCATION_LATITUDE_DEG: 51.4050489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025700',
        LOCATION_NAME: 'Shingay cum Wendy',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.08981,
        LOCATION_LATITUDE_DEG: 52.1056991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025800',
        LOCATION_NAME: 'Shingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6044028,
        LOCATION_LATITUDE_DEG: 52.6128403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH025900',
        LOCATION_NAME: 'Shingle Street',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4549778,
        LOCATION_LATITUDE_DEG: 52.0352752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026000',
        LOCATION_NAME: 'Shingrig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6770368,
        LOCATION_LATITUDE_DEG: 52.0793507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026200',
        LOCATION_NAME: 'Shipbourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2812348,
        LOCATION_LATITUDE_DEG: 51.2460132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040300',
        LOCATION_NAME: 'Shipcote',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6004898,
        LOCATION_LATITUDE_DEG: 54.9615019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026300',
        LOCATION_NAME: 'Shipdham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8942245,
        LOCATION_LATITUDE_DEG: 52.6282337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026400',
        LOCATION_NAME: 'Shipham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7937755,
        LOCATION_LATITUDE_DEG: 51.3143591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026500',
        LOCATION_NAME: 'Shiphay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5613136,
        LOCATION_LATITUDE_DEG: 50.4793887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026600',
        LOCATION_NAME: 'Shiplake',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8976041,
        LOCATION_LATITUDE_DEG: 51.4987536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026700',
        LOCATION_NAME: 'Shiplake Cross',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8997893,
        LOCATION_LATITUDE_DEG: 51.498954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027100',
        LOCATION_NAME: 'Shipley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2823922,
        LOCATION_LATITUDE_DEG: 52.559276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026900',
        LOCATION_NAME: 'Shipley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7752517,
        LOCATION_LATITUDE_DEG: 53.8318897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027000',
        LOCATION_NAME: 'Shipley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3479577,
        LOCATION_LATITUDE_DEG: 52.9933994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026800',
        LOCATION_NAME: 'Shipley',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3691935,
        LOCATION_LATITUDE_DEG: 50.984902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027200',
        LOCATION_NAME: 'Shipley Bridge',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1308994,
        LOCATION_LATITUDE_DEG: 51.1476068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027300',
        LOCATION_NAME: 'Shipmeadow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5073896,
        LOCATION_LATITUDE_DEG: 52.455411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027400',
        LOCATION_NAME: 'Shippea Hill',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.416641,
        LOCATION_LATITUDE_DEG: 52.4276267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027500',
        LOCATION_NAME: 'Shippon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3008004,
        LOCATION_LATITUDE_DEG: 51.6790748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039800',
        LOCATION_NAME: 'Shipston on Stour',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027600',
        LOCATION_NAME: 'Shipston-on-Stour',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6219497,
        LOCATION_LATITUDE_DEG: 52.0619153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027700',
        LOCATION_NAME: 'Shipton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6455423,
        LOCATION_LATITUDE_DEG: 52.5220685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH990237',
        LOCATION_NAME: 'Shipton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1594943,
        LOCATION_LATITUDE_DEG: 54.0225928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027800',
        LOCATION_NAME: 'Shipton Bellinger',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6658321,
        LOCATION_LATITUDE_DEG: 51.2063372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028200',
        LOCATION_NAME: 'Shipton by Beningbrough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1561233,
        LOCATION_LATITUDE_DEG: 54.0201961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH027900',
        LOCATION_NAME: 'Shipton Gorge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7129786,
        LOCATION_LATITUDE_DEG: 50.7208022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028000',
        LOCATION_NAME: 'Shipton Moyne',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1582407,
        LOCATION_LATITUDE_DEG: 51.6033825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028100',
        LOCATION_NAME: 'Shipton Oliffe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9452579,
        LOCATION_LATITUDE_DEG: 51.8650041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039900',
        LOCATION_NAME: 'Shipton on Cherwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040000',
        LOCATION_NAME: 'Shipton under Wychwood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028300',
        LOCATION_NAME: 'Shipton-on-Cherwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.304055,
        LOCATION_LATITUDE_DEG: 51.8458915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028500',
        LOCATION_NAME: 'Shiptonthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7033831,
        LOCATION_LATITUDE_DEG: 53.8767835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028400',
        LOCATION_NAME: 'Shipton-under-Wychwood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5969943,
        LOCATION_LATITUDE_DEG: 51.8601004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028600',
        LOCATION_NAME: 'Shirburn',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9893671,
        LOCATION_LATITUDE_DEG: 51.6569705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028700',
        LOCATION_NAME: 'Shirdley Hill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9663745,
        LOCATION_LATITUDE_DEG: 53.607983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028800',
        LOCATION_NAME: 'Shire Oak',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9271698,
        LOCATION_LATITUDE_DEG: 52.6376756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH028900',
        LOCATION_NAME: 'Shirebrook',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2149085,
        LOCATION_LATITUDE_DEG: 53.2020245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040700',
        LOCATION_NAME: 'Shirecliffe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040800',
        LOCATION_NAME: 'Shiregreen',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4462435,
        LOCATION_LATITUDE_DEG: 53.4297876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029000',
        LOCATION_NAME: 'Shirehampton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6807926,
        LOCATION_LATITUDE_DEG: 51.490232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029100',
        LOCATION_NAME: 'Shiremoor',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5024901,
        LOCATION_LATITUDE_DEG: 55.0338031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029200',
        LOCATION_NAME: 'Shirenewton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7532796,
        LOCATION_LATITUDE_DEG: 51.6386881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029300',
        LOCATION_NAME: 'Shireoaks',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1662544,
        LOCATION_LATITUDE_DEG: 53.3242289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029400',
        LOCATION_NAME: 'Shirkoak',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7754232,
        LOCATION_LATITUDE_DEG: 51.0896897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029500',
        LOCATION_NAME: 'Shirland',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4129407,
        LOCATION_LATITUDE_DEG: 53.1194129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029600',
        LOCATION_NAME: 'Shirlett',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5032146,
        LOCATION_LATITUDE_DEG: 52.5739719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH990241',
        LOCATION_NAME: 'Shirley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029800',
        LOCATION_NAME: 'Shirley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B90',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8243073,
        LOCATION_LATITUDE_DEG: 52.4090537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029700',
        LOCATION_NAME: 'Shirley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6742024,
        LOCATION_LATITUDE_DEG: 52.9708087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH029900',
        LOCATION_NAME: 'Shirleywich',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0222507,
        LOCATION_LATITUDE_DEG: 52.8290973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030000',
        LOCATION_NAME: 'Shirlowe',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5910991,
        LOCATION_LATITUDE_DEG: 52.7440955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030100',
        LOCATION_NAME: 'Shirrell Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1848913,
        LOCATION_LATITUDE_DEG: 50.9251001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030200',
        LOCATION_NAME: 'Shirwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9987882,
        LOCATION_LATITUDE_DEG: 51.1162485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030300',
        LOCATION_NAME: 'Shiskine',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.307181,
        LOCATION_LATITUDE_DEG: 55.5180978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030400',
        LOCATION_NAME: 'Shobdon',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8816282,
        LOCATION_LATITUDE_DEG: 52.2508477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030500',
        LOCATION_NAME: 'Shobley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7601811,
        LOCATION_LATITUDE_DEG: 50.8487991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030600',
        LOCATION_NAME: 'Shobrooke',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6123751,
        LOCATION_LATITUDE_DEG: 50.7969189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030700',
        LOCATION_NAME: 'Shobrooke Park',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.623365,
        LOCATION_LATITUDE_DEG: 50.799123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030800',
        LOCATION_NAME: 'Shoby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9881625,
        LOCATION_LATITUDE_DEG: 52.775481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH030900',
        LOCATION_NAME: 'Shocklach',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8371677,
        LOCATION_LATITUDE_DEG: 53.0367249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031000',
        LOCATION_NAME: 'Shoeburyness',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7848732,
        LOCATION_LATITUDE_DEG: 51.5314309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031100',
        LOCATION_NAME: 'Sholden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3756417,
        LOCATION_LATITUDE_DEG: 51.2210926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031200',
        LOCATION_NAME: 'Sholing',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3523995,
        LOCATION_LATITUDE_DEG: 50.8999062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031300',
        LOCATION_NAME: 'Sholing Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3552395,
        LOCATION_LATITUDE_DEG: 50.9095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031400',
        LOCATION_NAME: 'Shootash',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5462582,
        LOCATION_LATITUDE_DEG: 50.9967173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031500',
        LOCATION_NAME: 'Shop',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9940135,
        LOCATION_LATITUDE_DEG: 50.5236042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031600',
        LOCATION_NAME: 'Shopwhyke',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7389946,
        LOCATION_LATITUDE_DEG: 50.8390845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031700',
        LOCATION_NAME: 'Shore',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1120363,
        LOCATION_LATITUDE_DEG: 53.6424766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031800',
        LOCATION_NAME: 'Shoreditch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0803103,
        LOCATION_LATITUDE_DEG: 50.9949329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH031900',
        LOCATION_NAME: 'Shoreham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1795094,
        LOCATION_LATITUDE_DEG: 51.3328221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH040100',
        LOCATION_NAME: 'Shoreham by Sea',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032000',
        LOCATION_NAME: 'Shoreham-by-Sea',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2771851,
        LOCATION_LATITUDE_DEG: 50.831983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032100',
        LOCATION_NAME: 'Shoresdean',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0704522,
        LOCATION_LATITUDE_DEG: 55.713275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032200',
        LOCATION_NAME: 'Shoreston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6658927,
        LOCATION_LATITUDE_DEG: 55.5853609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032300',
        LOCATION_NAME: 'Shorncliffe Camp',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1516977,
        LOCATION_LATITUDE_DEG: 51.0827883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032400',
        LOCATION_NAME: 'Shorncote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9667113,
        LOCATION_LATITUDE_DEG: 51.6666824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032500',
        LOCATION_NAME: 'Shorne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4320134,
        LOCATION_LATITUDE_DEG: 51.4131259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041400',
        LOCATION_NAME: 'Short Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8411055,
        LOCATION_LATITUDE_DEG: 52.5294315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032600',
        LOCATION_NAME: 'Shortgate',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1250818,
        LOCATION_LATITUDE_DEG: 50.9162848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032700',
        LOCATION_NAME: 'Shorthampton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5245058,
        LOCATION_LATITUDE_DEG: 51.8784972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032800',
        LOCATION_NAME: 'Shortheath',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5474512,
        LOCATION_LATITUDE_DEG: 52.7368831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH032900',
        LOCATION_NAME: 'Shorthill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8475611,
        LOCATION_LATITUDE_DEG: 52.6690933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033000',
        LOCATION_NAME: 'Shortlands',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0127993,
        LOCATION_LATITUDE_DEG: 51.3979276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033100',
        LOCATION_NAME: 'Shortlanesend',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.076858,
        LOCATION_LATITUDE_DEG: 50.2875843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033200',
        LOCATION_NAME: 'Shortlees',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4944305,
        LOCATION_LATITUDE_DEG: 55.585495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033300',
        LOCATION_NAME: 'Shortstanding',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6205651,
        LOCATION_LATITUDE_DEG: 51.8184018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033400',
        LOCATION_NAME: 'Shortstown',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4293294,
        LOCATION_LATITUDE_DEG: 52.1101096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033500',
        LOCATION_NAME: 'Shorwell',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.353761,
        LOCATION_LATITUDE_DEG: 50.6438798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033600',
        LOCATION_NAME: 'Shoscombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4155362,
        LOCATION_LATITUDE_DEG: 51.305952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033700',
        LOCATION_NAME: 'Shotatton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9413199,
        LOCATION_LATITUDE_DEG: 52.7993028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033800',
        LOCATION_NAME: 'Shotesham All Saints',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3189238,
        LOCATION_LATITUDE_DEG: 52.5419262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039700',
        LOCATION_NAME: 'Shotesham St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH033900',
        LOCATION_NAME: 'Shotesham St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3084127,
        LOCATION_LATITUDE_DEG: 52.5475187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034000',
        LOCATION_NAME: 'Shotgate',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5492282,
        LOCATION_LATITUDE_DEG: 51.6098437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034100',
        LOCATION_NAME: 'Shotley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2544522,
        LOCATION_LATITUDE_DEG: 51.9689655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034200',
        LOCATION_NAME: 'Shotley Bridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.848265,
        LOCATION_LATITUDE_DEG: 54.8727921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034300',
        LOCATION_NAME: 'Shotley Gate',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.269525,
        LOCATION_LATITUDE_DEG: 51.9557652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034400',
        LOCATION_NAME: 'Shotover Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1894817,
        LOCATION_LATITUDE_DEG: 51.7476817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034500',
        LOCATION_NAME: 'Shottenden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9300974,
        LOCATION_LATITUDE_DEG: 51.250009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034600',
        LOCATION_NAME: 'Shottermill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7352232,
        LOCATION_LATITUDE_DEG: 51.087416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034700',
        LOCATION_NAME: 'Shottery',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7341251,
        LOCATION_LATITUDE_DEG: 52.1932289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034800',
        LOCATION_NAME: 'Shotteswell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3797448,
        LOCATION_LATITUDE_DEG: 52.1059202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH034900',
        LOCATION_NAME: 'Shottisham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3847022,
        LOCATION_LATITUDE_DEG: 52.0510713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035000',
        LOCATION_NAME: 'Shottle',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5350094,
        LOCATION_LATITUDE_DEG: 53.0438054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035100',
        LOCATION_NAME: 'Shottle Gate',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5202518,
        LOCATION_LATITUDE_DEG: 53.0213341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035200',
        LOCATION_NAME: 'Shotton',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.038905,
        LOCATION_LATITUDE_DEG: 53.2123447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035300',
        LOCATION_NAME: 'Shotton Colliery',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3865195,
        LOCATION_LATITUDE_DEG: 54.7602772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035400',
        LOCATION_NAME: 'Shotts',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7882176,
        LOCATION_LATITUDE_DEG: 55.8219064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035500',
        LOCATION_NAME: 'Shotwick',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.992126,
        LOCATION_LATITUDE_DEG: 53.2392466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035600',
        LOCATION_NAME: 'Shouldham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4809223,
        LOCATION_LATITUDE_DEG: 52.6515452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035700',
        LOCATION_NAME: 'Shouldham Thorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4567129,
        LOCATION_LATITUDE_DEG: 52.6438483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035800',
        LOCATION_NAME: 'Shoulton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2753048,
        LOCATION_LATITUDE_DEG: 52.2252438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH035900',
        LOCATION_NAME: 'Shovers Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3745176,
        LOCATION_LATITUDE_DEG: 51.049692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036000',
        LOCATION_NAME: 'Showell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1294956,
        LOCATION_LATITUDE_DEG: 51.4378662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036050',
        LOCATION_NAME: 'Showsley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9502761,
        LOCATION_LATITUDE_DEG: 52.1500682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036200',
        LOCATION_NAME: 'Shrawardine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.889137,
        LOCATION_LATITUDE_DEG: 52.7317973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036300',
        LOCATION_NAME: 'Shrawley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2833215,
        LOCATION_LATITUDE_DEG: 52.2816457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036400',
        LOCATION_NAME: 'Shray Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5125661,
        LOCATION_LATITUDE_DEG: 52.7681962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036500',
        LOCATION_NAME: 'Shrewley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6663295,
        LOCATION_LATITUDE_DEG: 52.3019425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036600',
        LOCATION_NAME: 'Shrewsbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7529374,
        LOCATION_LATITUDE_DEG: 52.7078895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036700',
        LOCATION_NAME: 'Shrewton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9011355,
        LOCATION_LATITUDE_DEG: 51.1916373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036800',
        LOCATION_NAME: 'Shripney',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6683839,
        LOCATION_LATITUDE_DEG: 50.8106883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036900',
        LOCATION_NAME: 'Shrivenham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.657529,
        LOCATION_LATITUDE_DEG: 51.5970727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037300',
        LOCATION_NAME: 'Shropham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9244209,
        LOCATION_LATITUDE_DEG: 52.4996248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037400',
        LOCATION_NAME: 'Shrub End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8631652,
        LOCATION_LATITUDE_DEG: 51.8723636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037600',
        LOCATION_NAME: 'Shucknall',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.60073,
        LOCATION_LATITUDE_DEG: 52.0797295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037700',
        LOCATION_NAME: 'Shucknall Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.584844,
        LOCATION_LATITUDE_DEG: 52.0914267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037800',
        LOCATION_NAME: 'Shudy Camps',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3640881,
        LOCATION_LATITUDE_DEG: 52.0743907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037900',
        LOCATION_NAME: 'Shulishader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.196661,
        LOCATION_LATITUDE_DEG: 58.2362714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038000',
        LOCATION_NAME: 'Shuna Island',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3931045,
        LOCATION_LATITUDE_DEG: 56.5873024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038100',
        LOCATION_NAME: 'Shurdington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1104482,
        LOCATION_LATITUDE_DEG: 51.8673029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038200',
        LOCATION_NAME: 'Shurlock Row',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8015206,
        LOCATION_LATITUDE_DEG: 51.4639526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038300',
        LOCATION_NAME: 'Shustoke',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6636153,
        LOCATION_LATITUDE_DEG: 52.5146566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038400',
        LOCATION_NAME: 'Shut End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1473684,
        LOCATION_LATITUDE_DEG: 52.5037682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038500',
        LOCATION_NAME: 'Shute',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.060801,
        LOCATION_LATITUDE_DEG: 50.7721112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038600',
        LOCATION_NAME: 'Shute Shelve',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8290728,
        LOCATION_LATITUDE_DEG: 51.2902561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038700',
        LOCATION_NAME: 'Shutfields',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5760148,
        LOCATION_LATITUDE_DEG: 52.3744596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038800',
        LOCATION_NAME: 'Shutford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4371601,
        LOCATION_LATITUDE_DEG: 52.0585162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH038900',
        LOCATION_NAME: 'Shuthonger',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1644432,
        LOCATION_LATITUDE_DEG: 52.0160188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039000',
        LOCATION_NAME: 'Shutlanger',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9356022,
        LOCATION_LATITUDE_DEG: 52.1420148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039100',
        LOCATION_NAME: 'Shutta',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4512491,
        LOCATION_LATITUDE_DEG: 50.3591886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039200',
        LOCATION_NAME: 'Shuttington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6228058,
        LOCATION_LATITUDE_DEG: 52.6454681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039300',
        LOCATION_NAME: 'Shuttlewood',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2986103,
        LOCATION_LATITUDE_DEG: 53.2512278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH039400',
        LOCATION_NAME: 'Shuttleworth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3033315,
        LOCATION_LATITUDE_DEG: 53.6556826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000100',
        LOCATION_NAME: 'Sibbaldbie',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3397017,
        LOCATION_LATITUDE_DEG: 55.1803402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000200',
        LOCATION_NAME: 'Sibbertoft',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9976849,
        LOCATION_LATITUDE_DEG: 52.4376465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000300',
        LOCATION_NAME: 'Sibdon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8626404,
        LOCATION_LATITUDE_DEG: 52.4393682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000400',
        LOCATION_NAME: 'Sibford Ferris',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4789525,
        LOCATION_LATITUDE_DEG: 52.0334145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000500',
        LOCATION_NAME: 'Sibford Gower',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4860165,
        LOCATION_LATITUDE_DEG: 52.0378155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000600',
        LOCATION_NAME: 'Sible Hedingham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5943451,
        LOCATION_LATITUDE_DEG: 51.9771771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000700',
        LOCATION_NAME: 'Sibsey',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0174161,
        LOCATION_LATITUDE_DEG: 53.0382868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000800',
        LOCATION_NAME: 'Sibson',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4774959,
        LOCATION_LATITUDE_DEG: 52.6038641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI000900',
        LOCATION_NAME: 'Sibson',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3850957,
        LOCATION_LATITUDE_DEG: 52.5656466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001000',
        LOCATION_NAME: 'Sibthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8642985,
        LOCATION_LATITUDE_DEG: 53.0014962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001100',
        LOCATION_NAME: 'Sibton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4589664,
        LOCATION_LATITUDE_DEG: 52.2748986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001200',
        LOCATION_NAME: 'Sicklesmere',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7447138,
        LOCATION_LATITUDE_DEG: 52.2103027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001300',
        LOCATION_NAME: 'Sicklinghall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4479671,
        LOCATION_LATITUDE_DEG: 53.9305903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001500',
        LOCATION_NAME: 'Sidbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2190193,
        LOCATION_LATITUDE_DEG: 50.7191097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001400',
        LOCATION_NAME: 'Sidbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4619587,
        LOCATION_LATITUDE_DEG: 52.4677672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI990567',
        LOCATION_NAME: 'Sidcot',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001600',
        LOCATION_NAME: 'Sidcup',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1025272,
        LOCATION_LATITUDE_DEG: 51.4260317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001700',
        LOCATION_NAME: 'Siddal',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8509185,
        LOCATION_LATITUDE_DEG: 53.7059809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001900',
        LOCATION_NAME: 'Siddick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5486552,
        LOCATION_LATITUDE_DEG: 54.6654878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002000',
        LOCATION_NAME: 'Siddington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2375194,
        LOCATION_LATITUDE_DEG: 53.2344363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002100',
        LOCATION_NAME: 'Siddington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9266518,
        LOCATION_LATITUDE_DEG: 51.6954843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002200',
        LOCATION_NAME: 'Sidemoor',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0713545,
        LOCATION_LATITUDE_DEG: 52.3387529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002300',
        LOCATION_NAME: 'Sidestrand',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3599221,
        LOCATION_LATITUDE_DEG: 52.9071608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002400',
        LOCATION_NAME: 'Sidford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2266886,
        LOCATION_LATITUDE_DEG: 50.7030017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002500',
        LOCATION_NAME: 'Sidlesham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7844498,
        LOCATION_LATITUDE_DEG: 50.7722829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002600',
        LOCATION_NAME: 'Sidlesham Common',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.783834,
        LOCATION_LATITUDE_DEG: 50.7943838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002700',
        LOCATION_NAME: 'Sidley',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4690259,
        LOCATION_LATITUDE_DEG: 50.8564705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002800',
        LOCATION_NAME: 'Sidlow',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1978601,
        LOCATION_LATITUDE_DEG: 51.2075144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI002900',
        LOCATION_NAME: 'Sidmouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2356287,
        LOCATION_LATITUDE_DEG: 50.6875003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003000',
        LOCATION_NAME: 'Sidway',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3508738,
        LOCATION_LATITUDE_DEG: 52.9558134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003100',
        LOCATION_NAME: 'Sigford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7272118,
        LOCATION_LATITUDE_DEG: 50.5507931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003200',
        LOCATION_NAME: 'Sigglesthorne',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2427448,
        LOCATION_LATITUDE_DEG: 53.8943779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010500',
        LOCATION_NAME: 'Sighthill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2384891,
        LOCATION_LATITUDE_DEG: 55.8753322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003300',
        LOCATION_NAME: 'Sighthill',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2940173,
        LOCATION_LATITUDE_DEG: 55.9254163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003400',
        LOCATION_NAME: 'Sigingstone',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4786836,
        LOCATION_LATITUDE_DEG: 51.4336747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003500',
        LOCATION_NAME: 'Signet',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6403443,
        LOCATION_LATITUDE_DEG: 51.7890868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003600',
        LOCATION_NAME: 'Sigwells',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5042498,
        LOCATION_LATITUDE_DEG: 51.0138314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003700',
        LOCATION_NAME: 'Silchester',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.099071,
        LOCATION_LATITUDE_DEG: 51.353243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003800',
        LOCATION_NAME: 'Sileby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1063405,
        LOCATION_LATITUDE_DEG: 52.7327703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI003900',
        LOCATION_NAME: 'Silecroft',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3330084,
        LOCATION_LATITUDE_DEG: 54.2256496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004000',
        LOCATION_NAME: 'Silfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1297647,
        LOCATION_LATITUDE_DEG: 52.5502225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004100',
        LOCATION_NAME: 'Silian',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0884563,
        LOCATION_LATITUDE_DEG: 52.1404548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004200',
        LOCATION_NAME: 'Silk Willoughby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4263997,
        LOCATION_LATITUDE_DEG: 52.9733907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004300',
        LOCATION_NAME: 'Silkstone',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5619005,
        LOCATION_LATITUDE_DEG: 53.5487591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004400',
        LOCATION_NAME: 'Silkstone Common',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5606215,
        LOCATION_LATITUDE_DEG: 53.5352612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004500',
        LOCATION_NAME: 'Silksworth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4151061,
        LOCATION_LATITUDE_DEG: 54.8665805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004600',
        LOCATION_NAME: 'Silloth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3870644,
        LOCATION_LATITUDE_DEG: 54.8698116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004700',
        LOCATION_NAME: 'Siloh',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8336057,
        LOCATION_LATITUDE_DEG: 52.0177341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004800',
        LOCATION_NAME: 'Silpho',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.516337,
        LOCATION_LATITUDE_DEG: 54.3154174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI004900',
        LOCATION_NAME: 'Silsden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9364622,
        LOCATION_LATITUDE_DEG: 53.9145026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005000',
        LOCATION_NAME: 'Silsoe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4232138,
        LOCATION_LATITUDE_DEG: 52.0080982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005100',
        LOCATION_NAME: 'Silton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3108932,
        LOCATION_LATITUDE_DEG: 51.062125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005200',
        LOCATION_NAME: 'Silver End',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6280896,
        LOCATION_LATITUDE_DEG: 51.8464632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010300',
        LOCATION_NAME: 'Silver Street',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8993198,
        LOCATION_LATITUDE_DEG: 52.3826715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010350',
        LOCATION_NAME: 'Silverbridge',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5266135,
        LOCATION_LATITUDE_DEG: 54.102115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005400',
        LOCATION_NAME: 'Silverburn',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2720023,
        LOCATION_LATITUDE_DEG: 55.8289033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005500',
        LOCATION_NAME: 'Silverdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8254369,
        LOCATION_LATITUDE_DEG: 54.1673369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005600',
        LOCATION_NAME: 'Silverdale',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2556919,
        LOCATION_LATITUDE_DEG: 53.0149155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005700',
        LOCATION_NAME: 'Silverglades',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8184829,
        LOCATION_LATITUDE_DEG: 57.1974457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010400',
        LOCATION_NAME: 'Silverknowes',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2703659,
        LOCATION_LATITUDE_DEG: 55.9701015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005800',
        LOCATION_NAME: 'Silverlake',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5466587,
        LOCATION_LATITUDE_DEG: 50.9357219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005900',
        LOCATION_NAME: 'Silverley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4968773,
        LOCATION_LATITUDE_DEG: 52.2272047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006100',
        LOCATION_NAME: 'Silverstone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0245882,
        LOCATION_LATITUDE_DEG: 52.0913148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006200',
        LOCATION_NAME: 'Silverton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4787715,
        LOCATION_LATITUDE_DEG: 50.8157153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010200',
        LOCATION_NAME: 'Silvertown',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0311952,
        LOCATION_LATITUDE_DEG: 51.5031348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006300',
        LOCATION_NAME: 'Silvington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5566888,
        LOCATION_LATITUDE_DEG: 52.414761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006400',
        LOCATION_NAME: 'Simister',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2498163,
        LOCATION_LATITUDE_DEG: 53.5495703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006500',
        LOCATION_NAME: 'Simonburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1894853,
        LOCATION_LATITUDE_DEG: 55.0561157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006600',
        LOCATION_NAME: 'Simonsbath',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7552364,
        LOCATION_LATITUDE_DEG: 51.1382549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006700',
        LOCATION_NAME: 'Simonstone',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.342589,
        LOCATION_LATITUDE_DEG: 53.8052912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006800',
        LOCATION_NAME: 'Simpson',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7243526,
        LOCATION_LATITUDE_DEG: 52.0136959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006900',
        LOCATION_NAME: 'Simpson Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0630812,
        LOCATION_LATITUDE_DEG: 51.832532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010600',
        LOCATION_NAME: 'Simshill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2571943,
        LOCATION_LATITUDE_DEG: 55.8124751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007000',
        LOCATION_NAME: 'Sinclairston',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4186745,
        LOCATION_LATITUDE_DEG: 55.4196769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007100',
        LOCATION_NAME: 'Sinclairtown',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1430867,
        LOCATION_LATITUDE_DEG: 56.1325266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007200',
        LOCATION_NAME: 'Sinderby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4726114,
        LOCATION_LATITUDE_DEG: 54.2297194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007300',
        LOCATION_NAME: 'Sinderhope',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2372205,
        LOCATION_LATITUDE_DEG: 54.8651957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007400',
        LOCATION_NAME: 'Sindlesham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8827964,
        LOCATION_LATITUDE_DEG: 51.4225421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007500',
        LOCATION_NAME: 'Sinfin',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4715635,
        LOCATION_LATITUDE_DEG: 52.8900928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007600',
        LOCATION_NAME: 'Sinfin Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4788158,
        LOCATION_LATITUDE_DEG: 52.8765942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007900',
        LOCATION_NAME: 'Singleborough',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8841304,
        LOCATION_LATITUDE_DEG: 51.9797988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008100',
        LOCATION_NAME: 'Singleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9361002,
        LOCATION_LATITUDE_DEG: 53.8347048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008000',
        LOCATION_NAME: 'Singleton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7516012,
        LOCATION_LATITUDE_DEG: 50.910092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008200',
        LOCATION_NAME: 'Singlewell',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3778581,
        LOCATION_LATITUDE_DEG: 51.4114314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008300',
        LOCATION_NAME: 'Sinnington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.85737,
        LOCATION_LATITUDE_DEG: 54.2620146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008400',
        LOCATION_NAME: 'Sinns Common',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2146206,
        LOCATION_LATITUDE_DEG: 50.2580853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008500',
        LOCATION_NAME: 'Sinton Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2751937,
        LOCATION_LATITUDE_DEG: 52.2427863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008600',
        LOCATION_NAME: 'Sion Mills',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4743433,
        LOCATION_LATITUDE_DEG: 54.7907426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008700',
        LOCATION_NAME: 'Sirhowy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2362032,
        LOCATION_LATITUDE_DEG: 51.783012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008800',
        LOCATION_NAME: 'Sisland',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4557092,
        LOCATION_LATITUDE_DEG: 52.5343198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI008900',
        LOCATION_NAME: 'Sissinghurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.564145,
        LOCATION_LATITUDE_DEG: 51.1082979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009000',
        LOCATION_NAME: 'Sithney',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3071909,
        LOCATION_LATITUDE_DEG: 50.113374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009100',
        LOCATION_NAME: 'Sittingbourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7332849,
        LOCATION_LATITUDE_DEG: 51.3403164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009200',
        LOCATION_NAME: 'Six Ashes',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3069863,
        LOCATION_LATITUDE_DEG: 52.4939673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009300',
        LOCATION_NAME: 'Six Bells',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1273916,
        LOCATION_LATITUDE_DEG: 51.7202049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009400',
        LOCATION_NAME: 'Six Hills',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.04346,
        LOCATION_LATITUDE_DEG: 52.7803812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009500',
        LOCATION_NAME: 'Six Mile Bottom',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3084269,
        LOCATION_LATITUDE_DEG: 52.1878033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009600',
        LOCATION_NAME: 'Sixhills',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2409865,
        LOCATION_LATITUDE_DEG: 53.3670222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009800',
        LOCATION_NAME: 'Sixmilecross',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0523025,
        LOCATION_LATITUDE_DEG: 54.5751142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009900',
        LOCATION_NAME: 'Sixpenny Handley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0058805,
        LOCATION_LATITUDE_DEG: 50.9543134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010000',
        LOCATION_NAME: 'Sizergh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7672538,
        LOCATION_LATITUDE_DEG: 54.2847446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI010100',
        LOCATION_NAME: 'Sizewell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6227984,
        LOCATION_LATITUDE_DEG: 52.2070897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000100',
        LOCATION_NAME: 'Skallary',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4331814,
        LOCATION_LATITUDE_DEG: 56.969154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000200',
        LOCATION_NAME: 'Skares',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3240353,
        LOCATION_LATITUDE_DEG: 55.4287756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000250',
        LOCATION_NAME: 'Skea',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6841427,
        LOCATION_LATITUDE_DEG: 54.2960132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000300',
        LOCATION_NAME: 'Skeabost Bridge',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3228553,
        LOCATION_LATITUDE_DEG: 57.4562972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000600',
        LOCATION_NAME: 'Skeeby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6923163,
        LOCATION_LATITUDE_DEG: 54.4179488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK990392',
        LOCATION_NAME: 'Skeffing',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000700',
        LOCATION_NAME: 'Skeffington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9063824,
        LOCATION_LATITUDE_DEG: 52.6161611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000800',
        LOCATION_NAME: 'Skeffling',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0738116,
        LOCATION_LATITUDE_DEG: 53.6478498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001000',
        LOCATION_NAME: 'Skegby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2627981,
        LOCATION_LATITUDE_DEG: 53.1466184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000900',
        LOCATION_NAME: 'Skegby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8225164,
        LOCATION_LATITUDE_DEG: 53.2216197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001100',
        LOCATION_NAME: 'Skegness',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3328951,
        LOCATION_LATITUDE_DEG: 53.1439914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001300',
        LOCATION_NAME: 'Skelbo',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0453082,
        LOCATION_LATITUDE_DEG: 57.9301174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001400',
        LOCATION_NAME: 'Skelbo Muir',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.042369,
        LOCATION_LATITUDE_DEG: 57.918816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001500',
        LOCATION_NAME: 'Skelbrooke',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2291277,
        LOCATION_LATITUDE_DEG: 53.6017609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001600',
        LOCATION_NAME: 'Skellingthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.616119,
        LOCATION_LATITUDE_DEG: 53.2379132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001700',
        LOCATION_NAME: 'Skellister',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1544184,
        LOCATION_LATITUDE_DEG: 60.2758187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001800',
        LOCATION_NAME: 'Skellow',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2106251,
        LOCATION_LATITUDE_DEG: 53.5873558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001900',
        LOCATION_NAME: 'Skelmanthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6475563,
        LOCATION_LATITUDE_DEG: 53.5911665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002000',
        LOCATION_NAME: 'Skelmersdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7717047,
        LOCATION_LATITUDE_DEG: 53.549571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002100',
        LOCATION_NAME: 'Skelmorlie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'PA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8885965,
        LOCATION_LATITUDE_DEG: 55.8693277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002200',
        LOCATION_NAME: 'Skelmuir',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0321529,
        LOCATION_LATITUDE_DEG: 57.4765477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002300',
        LOCATION_NAME: 'Skelsmergh',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6985576,
        LOCATION_LATITUDE_DEG: 54.3331514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002600',
        LOCATION_NAME: 'Skelton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8738308,
        LOCATION_LATITUDE_DEG: 54.7106853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002400',
        LOCATION_NAME: 'Skelton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4477027,
        LOCATION_LATITUDE_DEG: 54.1096102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002650',
        LOCATION_NAME: 'Skelton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.13323,
        LOCATION_LATITUDE_DEG: 54.0023699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002500',
        LOCATION_NAME: 'Skelton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.840039,
        LOCATION_LATITUDE_DEG: 53.7234626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002700',
        LOCATION_NAME: 'Skelton Green',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9817876,
        LOCATION_LATITUDE_DEG: 54.5524712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK007600',
        LOCATION_NAME: 'Skelton in Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002800',
        LOCATION_NAME: 'Skelton-in-Cleveland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9866097,
        LOCATION_LATITUDE_DEG: 54.5600529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK002900',
        LOCATION_NAME: 'Skelwith Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0100566,
        LOCATION_LATITUDE_DEG: 54.4225578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003000',
        LOCATION_NAME: 'Skelwith Fold',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9997891,
        LOCATION_LATITUDE_DEG: 54.4161625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003200',
        LOCATION_NAME: 'Skendleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1469455,
        LOCATION_LATITUDE_DEG: 53.203401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003300',
        LOCATION_NAME: 'Skendleby Psalter',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1498736,
        LOCATION_LATITUDE_DEG: 53.2215024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003350',
        LOCATION_NAME: 'Skene',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2931553,
        LOCATION_LATITUDE_DEG: 57.1543901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003400',
        LOCATION_NAME: 'Skenfrith',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7886587,
        LOCATION_LATITUDE_DEG: 51.8774084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003500',
        LOCATION_NAME: 'Skerne',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4078888,
        LOCATION_LATITUDE_DEG: 53.9827869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003600',
        LOCATION_NAME: 'Skerray',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3012851,
        LOCATION_LATITUDE_DEG: 58.5362854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003800',
        LOCATION_NAME: 'Sketty',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9846587,
        LOCATION_LATITUDE_DEG: 51.6177012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003900',
        LOCATION_NAME: 'Skeugh Head',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1741117,
        LOCATION_LATITUDE_DEG: 54.3896509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004000',
        LOCATION_NAME: 'Skewen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8483511,
        LOCATION_LATITUDE_DEG: 51.6600013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004100',
        LOCATION_NAME: 'Skewsby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0387096,
        LOCATION_LATITUDE_DEG: 54.1344097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004200',
        LOCATION_NAME: 'Skeyton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3295714,
        LOCATION_LATITUDE_DEG: 52.7814447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004400',
        LOCATION_NAME: 'Skidbrooke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1697638,
        LOCATION_LATITUDE_DEG: 53.4084185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004500',
        LOCATION_NAME: 'Skidby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4604046,
        LOCATION_LATITUDE_DEG: 53.7885709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004600',
        LOCATION_NAME: 'Skigersta',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2125968,
        LOCATION_LATITUDE_DEG: 58.4739968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004700',
        LOCATION_NAME: 'Skilgate',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4441906,
        LOCATION_LATITUDE_DEG: 51.0350349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004800',
        LOCATION_NAME: 'Skillington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6704792,
        LOCATION_LATITUDE_DEG: 52.8221752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004900',
        LOCATION_NAME: 'Skimpot',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4764324,
        LOCATION_LATITUDE_DEG: 51.8873808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005000',
        LOCATION_NAME: 'Skinburness',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3686813,
        LOCATION_LATITUDE_DEG: 54.8875113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005100',
        LOCATION_NAME: 'Skinflats',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.751436,
        LOCATION_LATITUDE_DEG: 56.0295238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005200',
        LOCATION_NAME: 'Skinidin',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6306719,
        LOCATION_LATITUDE_DEG: 57.4325987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005300',
        LOCATION_NAME: 'Skinnand',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5940994,
        LOCATION_LATITUDE_DEG: 53.1058067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005400',
        LOCATION_NAME: 'Skinners Bottom',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1945231,
        LOCATION_LATITUDE_DEG: 50.2670881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005500',
        LOCATION_NAME: 'Skinnertown',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9076619,
        LOCATION_LATITUDE_DEG: 57.8205096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005600',
        LOCATION_NAME: 'Skinnet',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4226906,
        LOCATION_LATITUDE_DEG: 58.5223792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005700',
        LOCATION_NAME: 'Skinningrove',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8972554,
        LOCATION_LATITUDE_DEG: 54.5688532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005800',
        LOCATION_NAME: 'Skipness',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.345611,
        LOCATION_LATITUDE_DEG: 55.7666217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK005900',
        LOCATION_NAME: 'Skipsea',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2201719,
        LOCATION_LATITUDE_DEG: 53.9777794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006000',
        LOCATION_NAME: 'Skipton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0104717,
        LOCATION_LATITUDE_DEG: 53.9608023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006100',
        LOCATION_NAME: 'Skipwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9900955,
        LOCATION_LATITUDE_DEG: 53.8386818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006200',
        LOCATION_NAME: 'Skirbeck',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0016596,
        LOCATION_LATITUDE_DEG: 52.9663855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006300',
        LOCATION_NAME: 'Skircoat Green',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8682073,
        LOCATION_LATITUDE_DEG: 53.7004728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006400',
        LOCATION_NAME: 'Skirethorns',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0306121,
        LOCATION_LATITUDE_DEG: 54.071117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006500',
        LOCATION_NAME: 'Skirlaugh',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2646973,
        LOCATION_LATITUDE_DEG: 53.8391651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006600',
        LOCATION_NAME: 'Skirling',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4674658,
        LOCATION_LATITUDE_DEG: 55.6365842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006700',
        LOCATION_NAME: 'Skirmett',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8790772,
        LOCATION_LATITUDE_DEG: 51.6019594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006800',
        LOCATION_NAME: 'Skirpenbeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8617982,
        LOCATION_LATITUDE_DEG: 54.0032972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK006900',
        LOCATION_NAME: 'Skirsgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7596584,
        LOCATION_LATITUDE_DEG: 54.6525835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK007000',
        LOCATION_NAME: 'Skirwith',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5961047,
        LOCATION_LATITUDE_DEG: 54.6872841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK007500',
        LOCATION_NAME: 'Skyreholme',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8994992,
        LOCATION_LATITUDE_DEG: 54.0389086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000100',
        LOCATION_NAME: 'Slack',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5095219,
        LOCATION_LATITUDE_DEG: 53.1614201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000200',
        LOCATION_NAME: 'Slack Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7771733,
        LOCATION_LATITUDE_DEG: 54.2028398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000300',
        LOCATION_NAME: 'Slad',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1834572,
        LOCATION_LATITUDE_DEG: 51.7687939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000400',
        LOCATION_NAME: 'Slade',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1813016,
        LOCATION_LATITUDE_DEG: 51.5516947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000600',
        LOCATION_NAME: 'Slade Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8955617,
        LOCATION_LATITUDE_DEG: 51.6882209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000700',
        LOCATION_NAME: 'Slade Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1177798,
        LOCATION_LATITUDE_DEG: 52.6568797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000800',
        LOCATION_NAME: 'Sladesbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8008865,
        LOCATION_LATITUDE_DEG: 50.5059058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000900',
        LOCATION_NAME: 'Slaggyford',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.50175,
        LOCATION_LATITUDE_DEG: 54.865802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001000',
        LOCATION_NAME: 'Slaghtmanus',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1389036,
        LOCATION_LATITUDE_DEG: 54.9658349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001100',
        LOCATION_NAME: 'Slaidburn',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4401524,
        LOCATION_LATITUDE_DEG: 53.9666124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001200',
        LOCATION_NAME: 'Slaithwaite',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8806282,
        LOCATION_LATITUDE_DEG: 53.6204727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001300',
        LOCATION_NAME: 'Slaley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.028207,
        LOCATION_LATITUDE_DEG: 54.9149984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001400',
        LOCATION_NAME: 'Slamannan',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8302799,
        LOCATION_LATITUDE_DEG: 55.9383154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001600',
        LOCATION_NAME: 'Slapewath',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.004584,
        LOCATION_LATITUDE_DEG: 54.5326439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001800',
        LOCATION_NAME: 'Slapton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6529591,
        LOCATION_LATITUDE_DEG: 50.2917752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001700',
        LOCATION_NAME: 'Slapton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0640974,
        LOCATION_LATITUDE_DEG: 52.1147173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001900',
        LOCATION_NAME: 'Slateford',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2425063,
        LOCATION_LATITUDE_DEG: 55.9258119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002000',
        LOCATION_NAME: 'Slateley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6739222,
        LOCATION_LATITUDE_DEG: 52.5696651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002100',
        LOCATION_NAME: 'Slattadale',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5327482,
        LOCATION_LATITUDE_DEG: 57.6829091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002200',
        LOCATION_NAME: 'Slattocks',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1781267,
        LOCATION_LATITUDE_DEG: 53.5807029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002300',
        LOCATION_NAME: 'Slaugham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2066493,
        LOCATION_LATITUDE_DEG: 51.0382021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002400',
        LOCATION_NAME: 'Slaughter Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6719597,
        LOCATION_LATITUDE_DEG: 50.6365172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002500',
        LOCATION_NAME: 'Slaughterford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2317042,
        LOCATION_LATITUDE_DEG: 51.4649653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002600',
        LOCATION_NAME: 'Slaughtergate',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.295325,
        LOCATION_LATITUDE_DEG: 51.0400241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002700',
        LOCATION_NAME: 'Slawston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8611602,
        LOCATION_LATITUDE_DEG: 52.5485518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002900',
        LOCATION_NAME: 'Sleaford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8532345,
        LOCATION_LATITUDE_DEG: 51.1347159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL002800',
        LOCATION_NAME: 'Sleaford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4087622,
        LOCATION_LATITUDE_DEG: 52.9989875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003000',
        LOCATION_NAME: 'Sleagill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6245286,
        LOCATION_LATITUDE_DEG: 54.5660733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003100',
        LOCATION_NAME: 'Sleap',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5468978,
        LOCATION_LATITUDE_DEG: 52.7540984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003200',
        LOCATION_NAME: 'Sleapford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5394378,
        LOCATION_LATITUDE_DEG: 52.73919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003350',
        LOCATION_NAME: 'Slebech',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8708178,
        LOCATION_LATITUDE_DEG: 51.8038446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003400',
        LOCATION_NAME: 'Sledmere',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.570165,
        LOCATION_LATITUDE_DEG: 54.0703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003500',
        LOCATION_NAME: 'Sleight',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9705876,
        LOCATION_LATITUDE_DEG: 51.3295542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003600',
        LOCATION_NAME: 'Sleights',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6630252,
        LOCATION_LATITUDE_DEG: 54.455337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003700',
        LOCATION_NAME: 'Sliddery',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2723387,
        LOCATION_LATITUDE_DEG: 55.4557865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004300',
        LOCATION_NAME: 'Slimbridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3780378,
        LOCATION_LATITUDE_DEG: 51.7313894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004400',
        LOCATION_NAME: 'Slindon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2566456,
        LOCATION_LATITUDE_DEG: 52.8866036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004500',
        LOCATION_NAME: 'Slindon',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6331511,
        LOCATION_LATITUDE_DEG: 50.8655942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004600',
        LOCATION_NAME: 'Slindon Common',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6209782,
        LOCATION_LATITUDE_DEG: 50.8590922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004700',
        LOCATION_NAME: 'Slinfold',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4049703,
        LOCATION_LATITUDE_DEG: 51.07181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004900',
        LOCATION_NAME: 'Sling',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.135943,
        LOCATION_LATITUDE_DEG: 53.1932584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004800',
        LOCATION_NAME: 'Sling',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6044384,
        LOCATION_LATITUDE_DEG: 51.7680037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005000',
        LOCATION_NAME: 'Slingsby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9306837,
        LOCATION_LATITUDE_DEG: 54.1660117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005100',
        LOCATION_NAME: 'Slip End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4320421,
        LOCATION_LATITUDE_DEG: 51.854181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005200',
        LOCATION_NAME: 'Slipperhill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4202462,
        LOCATION_LATITUDE_DEG: 50.5836041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005300',
        LOCATION_NAME: 'Slipton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6024048,
        LOCATION_LATITUDE_DEG: 52.4035398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005400',
        LOCATION_NAME: 'Sloley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3968383,
        LOCATION_LATITUDE_DEG: 52.7699385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005500',
        LOCATION_NAME: 'Sloothby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2393491,
        LOCATION_LATITUDE_DEG: 53.2135059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005600',
        LOCATION_NAME: 'Slough',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5895722,
        LOCATION_LATITUDE_DEG: 51.5079541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005700',
        LOCATION_NAME: 'Slough Green',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0373098,
        LOCATION_LATITUDE_DEG: 50.9762293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005800',
        LOCATION_NAME: 'Sluggans',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2133334,
        LOCATION_LATITUDE_DEG: 57.4217867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL005900',
        LOCATION_NAME: 'Sluvad',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.986777,
        LOCATION_LATITUDE_DEG: 51.6855988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL006000',
        LOCATION_NAME: 'Slyne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7996384,
        LOCATION_LATITUDE_DEG: 54.0838253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000100',
        LOCATION_NAME: 'Smailholm',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5608876,
        LOCATION_LATITUDE_DEG: 55.6190773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000200',
        LOCATION_NAME: 'Small Dole',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2724601,
        LOCATION_LATITUDE_DEG: 50.9029861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000300',
        LOCATION_NAME: 'Small Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8575068,
        LOCATION_LATITUDE_DEG: 52.4632607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000400',
        LOCATION_NAME: 'Small Hythe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.701076,
        LOCATION_LATITUDE_DEG: 51.0408878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000500',
        LOCATION_NAME: 'Smallbridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1302851,
        LOCATION_LATITUDE_DEG: 53.63417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000600',
        LOCATION_NAME: 'Smallburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4566308,
        LOCATION_LATITUDE_DEG: 52.767445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000700',
        LOCATION_NAME: 'Smallburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7504644,
        LOCATION_LATITUDE_DEG: 55.062604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000800',
        LOCATION_NAME: 'Smalldale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8568476,
        LOCATION_LATITUDE_DEG: 53.2926342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM000900',
        LOCATION_NAME: 'Smalley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3929598,
        LOCATION_LATITUDE_DEG: 52.9974046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001000',
        LOCATION_NAME: 'Smallfield',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1144344,
        LOCATION_LATITUDE_DEG: 51.1716085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001100',
        LOCATION_NAME: 'Smallford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2756732,
        LOCATION_LATITUDE_DEG: 51.7517655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001200',
        LOCATION_NAME: 'Smallridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9915523,
        LOCATION_LATITUDE_DEG: 50.8041091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001300',
        LOCATION_NAME: 'Smallthorne',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1716488,
        LOCATION_LATITUDE_DEG: 53.0462175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001400',
        LOCATION_NAME: 'Smallways',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.834873,
        LOCATION_LATITUDE_DEG: 54.4840562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001500',
        LOCATION_NAME: 'Smallwood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2892512,
        LOCATION_LATITUDE_DEG: 53.1378236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001600',
        LOCATION_NAME: 'Smannell',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4548433,
        LOCATION_LATITUDE_DEG: 51.2375326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001700',
        LOCATION_NAME: 'Smardale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4001824,
        LOCATION_LATITUDE_DEG: 54.468155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001800',
        LOCATION_NAME: 'Smarden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6887113,
        LOCATION_LATITUDE_DEG: 51.1488009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM001900',
        LOCATION_NAME: 'Smeatharpe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1398732,
        LOCATION_LATITUDE_DEG: 50.8892212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002000',
        LOCATION_NAME: 'Smeeth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9613914,
        LOCATION_LATITUDE_DEG: 51.1183894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002100',
        LOCATION_NAME: 'Smeeton Westerby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0005236,
        LOCATION_LATITUDE_DEG: 52.5273503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002200',
        LOCATION_NAME: 'Smelthouses',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7026039,
        LOCATION_LATITUDE_DEG: 54.0733151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002300',
        LOCATION_NAME: 'Smerclate',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.367275,
        LOCATION_LATITUDE_DEG: 57.1161663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002500',
        LOCATION_NAME: 'Smethcote',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6453141,
        LOCATION_LATITUDE_DEG: 52.6933925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002600',
        LOCATION_NAME: 'Smethcott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8312983,
        LOCATION_LATITUDE_DEG: 52.5898806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002700',
        LOCATION_NAME: 'Smethwick',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9670927,
        LOCATION_LATITUDE_DEG: 52.4926616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002800',
        LOCATION_NAME: 'Smisby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4838491,
        LOCATION_LATITUDE_DEG: 52.7679829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002900',
        LOCATION_NAME: 'Smithaleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9823039,
        LOCATION_LATITUDE_DEG: 50.3817855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003100',
        LOCATION_NAME: 'Smithfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8730473,
        LOCATION_LATITUDE_DEG: 54.9794172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003800',
        LOCATION_NAME: 'Smithfield',
        COUNTY_NAME: 'London',
        POSTCODE: 'EC1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0999525,
        LOCATION_LATITUDE_DEG: 51.5195431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003801',
        LOCATION_NAME: 'Smithies',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4718655,
        LOCATION_LATITUDE_DEG: 53.5690712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003200',
        LOCATION_NAME: 'Smithills',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4805514,
        LOCATION_LATITUDE_DEG: 53.6185788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003300',
        LOCATION_NAME: 'Smithincott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3281268,
        LOCATION_LATITUDE_DEG: 50.8968276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003400',
        LOCATION_NAME: 'Smithton',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1490381,
        LOCATION_LATITUDE_DEG: 57.4813786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003500',
        LOCATION_NAME: 'Smithy Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3779007,
        LOCATION_LATITUDE_DEG: 53.2701413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003600',
        LOCATION_NAME: 'Smithybridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1074418,
        LOCATION_LATITUDE_DEG: 53.632278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003700',
        LOCATION_NAME: 'Smoo',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7214229,
        LOCATION_LATITUDE_DEG: 58.5649921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000100',
        LOCATION_NAME: 'Snailbeach',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9257657,
        LOCATION_LATITUDE_DEG: 52.6135818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000200',
        LOCATION_NAME: 'Snailwell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3980533,
        LOCATION_LATITUDE_DEG: 52.2881073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000300',
        LOCATION_NAME: 'Snainton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5869506,
        LOCATION_LATITUDE_DEG: 54.2280096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000400',
        LOCATION_NAME: 'Snaith',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0267011,
        LOCATION_LATITUDE_DEG: 53.6914674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000600',
        LOCATION_NAME: 'Snape',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5882207,
        LOCATION_LATITUDE_DEG: 54.2535307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000500',
        LOCATION_NAME: 'Snape',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5014272,
        LOCATION_LATITUDE_DEG: 52.1685862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000700',
        LOCATION_NAME: 'Snapper',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0129852,
        LOCATION_LATITUDE_DEG: 51.0917473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000800',
        LOCATION_NAME: 'Snarestone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4890975,
        LOCATION_LATITUDE_DEG: 52.6804719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN000900',
        LOCATION_NAME: 'Snarford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4194386,
        LOCATION_LATITUDE_DEG: 53.323325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001000',
        LOCATION_NAME: 'Snargate',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8383662,
        LOCATION_LATITUDE_DEG: 51.0214848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001100',
        LOCATION_NAME: 'Snatchems',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8387923,
        LOCATION_LATITUDE_DEG: 54.0497245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001200',
        LOCATION_NAME: 'Snatford Bridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2084331,
        LOCATION_LATITUDE_DEG: 50.7362953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001300',
        LOCATION_NAME: 'Snave',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.871455,
        LOCATION_LATITUDE_DEG: 51.0313895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001400',
        LOCATION_NAME: 'Sneachill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1343698,
        LOCATION_LATITUDE_DEG: 52.1782294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001500',
        LOCATION_NAME: 'Snead',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0071308,
        LOCATION_LATITUDE_DEG: 52.5229786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001600',
        LOCATION_NAME: 'Sneads Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2024835,
        LOCATION_LATITUDE_DEG: 52.3069427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001700',
        LOCATION_NAME: 'Sneaton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.621822,
        LOCATION_LATITUDE_DEG: 54.4575348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001800',
        LOCATION_NAME: 'Sneaton Thorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6014573,
        LOCATION_LATITUDE_DEG: 54.4412287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN001900',
        LOCATION_NAME: 'Snedshill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4354912,
        LOCATION_LATITUDE_DEG: 52.6869855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002100',
        LOCATION_NAME: 'Sneinton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1339117,
        LOCATION_LATITUDE_DEG: 52.9532927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002200',
        LOCATION_NAME: 'Snelland',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3817138,
        LOCATION_LATITUDE_DEG: 53.3111222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002300',
        LOCATION_NAME: 'Snelsmore',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3264294,
        LOCATION_LATITUDE_DEG: 51.446857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002400',
        LOCATION_NAME: 'Snelsmore Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3304328,
        LOCATION_LATITUDE_DEG: 51.4358548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN990940',
        LOCATION_NAME: 'Snelson',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002500',
        LOCATION_NAME: 'Snelston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7744755,
        LOCATION_LATITUDE_DEG: 52.9873046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002600',
        LOCATION_NAME: 'Snetterton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9375238,
        LOCATION_LATITUDE_DEG: 52.4804215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002700',
        LOCATION_NAME: 'Snettisham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5045858,
        LOCATION_LATITUDE_DEG: 52.8775686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002800',
        LOCATION_NAME: 'Sneyd Green',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1641524,
        LOCATION_LATITUDE_DEG: 53.0403215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN004400',
        LOCATION_NAME: 'Sneyd Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.632642,
        LOCATION_LATITUDE_DEG: 51.4739821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002900',
        LOCATION_NAME: 'Snipefield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.822375,
        LOCATION_LATITUDE_DEG: 51.2372532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003000',
        LOCATION_NAME: 'Snishival',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3828156,
        LOCATION_LATITUDE_DEG: 57.2885865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003100',
        LOCATION_NAME: 'Snitter',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9605482,
        LOCATION_LATITUDE_DEG: 55.3248404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003200',
        LOCATION_NAME: 'Snitterby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5184956,
        LOCATION_LATITUDE_DEG: 53.4408346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003300',
        LOCATION_NAME: 'Snitterby Carr',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4689755,
        LOCATION_LATITUDE_DEG: 53.4432309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003400',
        LOCATION_NAME: 'Snitterby Sandhayes',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4943686,
        LOCATION_LATITUDE_DEG: 53.4354353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003500',
        LOCATION_NAME: 'Snitterfield',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6807211,
        LOCATION_LATITUDE_DEG: 52.2382335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003600',
        LOCATION_NAME: 'Snitterton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5798908,
        LOCATION_LATITUDE_DEG: 53.1394207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003700',
        LOCATION_NAME: 'Snitton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6504601,
        LOCATION_LATITUDE_DEG: 52.3738575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003800',
        LOCATION_NAME: 'Snizort',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3234414,
        LOCATION_LATITUDE_DEG: 57.5363005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN003900',
        LOCATION_NAME: 'Snodhill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9938489,
        LOCATION_LATITUDE_DEG: 52.0571353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN004000',
        LOCATION_NAME: 'Snodland',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4473045,
        LOCATION_LATITUDE_DEG: 51.3272156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN004100',
        LOCATION_NAME: 'Snowdown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.214752,
        LOCATION_LATITUDE_DEG: 51.2155968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN004200',
        LOCATION_NAME: 'Snowhill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3510216,
        LOCATION_LATITUDE_DEG: 51.42306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN004300',
        LOCATION_NAME: 'Snowshill',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8590346,
        LOCATION_LATITUDE_DEG: 52.0019142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN991027',
        LOCATION_NAME: 'Snowshill Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.73333,
        LOCATION_LATITUDE_DEG: 51.9833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000100',
        LOCATION_NAME: 'Soar',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.057263,
        LOCATION_LATITUDE_DEG: 52.8978257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000200',
        LOCATION_NAME: 'Soar',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4978983,
        LOCATION_LATITUDE_DEG: 51.9772316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000300',
        LOCATION_NAME: 'Soay',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2187073,
        LOCATION_LATITUDE_DEG: 57.1473603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000400',
        LOCATION_NAME: 'Soberton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1295959,
        LOCATION_LATITUDE_DEG: 50.9448017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000500',
        LOCATION_NAME: 'Sockbridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7744707,
        LOCATION_LATITUDE_DEG: 54.63348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000600',
        LOCATION_NAME: 'Soham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3387597,
        LOCATION_LATITUDE_DEG: 52.3337141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO031400',
        LOCATION_NAME: 'Soho',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO031700',
        LOCATION_NAME: 'Soho',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9300017,
        LOCATION_LATITUDE_DEG: 52.5021849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000700',
        LOCATION_NAME: 'Solihull',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7747537,
        LOCATION_LATITUDE_DEG: 52.4132495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000800',
        LOCATION_NAME: 'Solitote',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3149472,
        LOCATION_LATITUDE_DEG: 57.6841162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO000900',
        LOCATION_NAME: 'Sollas',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3437294,
        LOCATION_LATITUDE_DEG: 57.6504277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001000',
        LOCATION_NAME: 'Sollers Hope',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5609906,
        LOCATION_LATITUDE_DEG: 51.9912213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001100',
        LOCATION_NAME: 'Sollom',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8245432,
        LOCATION_LATITUDE_DEG: 53.6623881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001200',
        LOCATION_NAME: 'Solsgirth',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6370825,
        LOCATION_LATITUDE_DEG: 56.1429377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001300',
        LOCATION_NAME: 'Solva',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1966287,
        LOCATION_LATITUDE_DEG: 51.8739334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001500',
        LOCATION_NAME: 'Somerby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.848613,
        LOCATION_LATITUDE_DEG: 52.6868691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001400',
        LOCATION_NAME: 'Somerby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3991922,
        LOCATION_LATITUDE_DEG: 53.5457426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001600',
        LOCATION_NAME: 'Somercotes',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3661453,
        LOCATION_LATITUDE_DEG: 53.0792114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO990757',
        LOCATION_NAME: 'Somerford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001700',
        LOCATION_NAME: 'Somerford Booths',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2492611,
        LOCATION_LATITUDE_DEG: 53.1922316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001800',
        LOCATION_NAME: 'Somerford Keynes',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9711157,
        LOCATION_LATITUDE_DEG: 51.6535818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO001900',
        LOCATION_NAME: 'Somerley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8119257,
        LOCATION_LATITUDE_DEG: 50.8688055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002000',
        LOCATION_NAME: 'Somerleyton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6537812,
        LOCATION_LATITUDE_DEG: 52.5150144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002100',
        LOCATION_NAME: 'Somersal Herbert',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7953674,
        LOCATION_LATITUDE_DEG: 52.9137028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002200',
        LOCATION_NAME: 'Somersby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0140124,
        LOCATION_LATITUDE_DEG: 53.2335064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002300',
        LOCATION_NAME: 'Somerset Bridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.98909,
        LOCATION_LATITUDE_DEG: 51.1136453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002400',
        LOCATION_NAME: 'Somersham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5127197,
        LOCATION_LATITUDE_DEG: 52.3822292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002600',
        LOCATION_NAME: 'Somerton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7262519,
        LOCATION_LATITUDE_DEG: 51.055336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002500',
        LOCATION_NAME: 'Somerton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.275024,
        LOCATION_LATITUDE_DEG: 51.9538997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002700',
        LOCATION_NAME: 'Somerton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6473925,
        LOCATION_LATITUDE_DEG: 52.1461979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002800',
        LOCATION_NAME: 'Somerwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6354085,
        LOCATION_LATITUDE_DEG: 52.7306949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO002900',
        LOCATION_NAME: 'Sompting',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3366833,
        LOCATION_LATITUDE_DEG: 50.8330803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003000',
        LOCATION_NAME: 'Sonning',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9060143,
        LOCATION_LATITUDE_DEG: 51.4724472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003100',
        LOCATION_NAME: 'Sonning Common',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9758374,
        LOCATION_LATITUDE_DEG: 51.5181589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003200',
        LOCATION_NAME: 'Sonning Eye',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9155888,
        LOCATION_LATITUDE_DEG: 51.4761513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003300',
        LOCATION_NAME: 'Sontley',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9980977,
        LOCATION_LATITUDE_DEG: 53.0144276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003400',
        LOCATION_NAME: 'Sookholme',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1824068,
        LOCATION_LATITUDE_DEG: 53.1955218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003500',
        LOCATION_NAME: 'Sopley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7763334,
        LOCATION_LATITUDE_DEG: 50.7715942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003700',
        LOCATION_NAME: 'Sopworth',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2500691,
        LOCATION_LATITUDE_DEG: 51.5744742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003800',
        LOCATION_NAME: 'Sorbie',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4288874,
        LOCATION_LATITUDE_DEG: 54.7913086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003900',
        LOCATION_NAME: 'Sorn',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2866127,
        LOCATION_LATITUDE_DEG: 55.5103827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004000',
        LOCATION_NAME: 'Sornhill',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3599204,
        LOCATION_LATITUDE_DEG: 55.5830892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004100',
        LOCATION_NAME: 'Soroba',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4610787,
        LOCATION_LATITUDE_DEG: 56.3960857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004200',
        LOCATION_NAME: 'Sotby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1915935,
        LOCATION_LATITUDE_DEG: 53.2931152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004300',
        LOCATION_NAME: 'Sothall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3344653,
        LOCATION_LATITUDE_DEG: 53.3381324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004400',
        LOCATION_NAME: 'Sotherton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5709475,
        LOCATION_LATITUDE_DEG: 52.3504984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004500',
        LOCATION_NAME: 'Sotterley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6135356,
        LOCATION_LATITUDE_DEG: 52.4086008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004600',
        LOCATION_NAME: 'Sotwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1484987,
        LOCATION_LATITUDE_DEG: 51.5995648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004800',
        LOCATION_NAME: 'Soudley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7680143,
        LOCATION_LATITUDE_DEG: 52.5200784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004850',
        LOCATION_NAME: 'Soudley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4904451,
        LOCATION_LATITUDE_DEG: 51.7917343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004700',
        LOCATION_NAME: 'Soudley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4080479,
        LOCATION_LATITUDE_DEG: 52.8568981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO004900',
        LOCATION_NAME: 'Sough',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1500353,
        LOCATION_LATITUDE_DEG: 53.9057425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005000',
        LOCATION_NAME: 'Soulbury',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7168279,
        LOCATION_LATITUDE_DEG: 51.9358936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005200',
        LOCATION_NAME: 'Soulby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8295054,
        LOCATION_LATITUDE_DEG: 54.6205772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005100',
        LOCATION_NAME: 'Soulby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3872617,
        LOCATION_LATITUDE_DEG: 54.4937592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005300',
        LOCATION_NAME: 'Souldern',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2390839,
        LOCATION_LATITUDE_DEG: 51.9793001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005400',
        LOCATION_NAME: 'Souldrop',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5556784,
        LOCATION_LATITUDE_DEG: 52.2437214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005500',
        LOCATION_NAME: 'Sound',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5563881,
        LOCATION_LATITUDE_DEG: 53.0274193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005600',
        LOCATION_NAME: 'Soundwell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5043818,
        LOCATION_LATITUDE_DEG: 51.4726705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005700',
        LOCATION_NAME: 'Sourton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0747297,
        LOCATION_LATITUDE_DEG: 50.693716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005800',
        LOCATION_NAME: 'Sourton Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0627017,
        LOCATION_LATITUDE_DEG: 50.6952158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO005900',
        LOCATION_NAME: 'Soutergate',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1847601,
        LOCATION_LATITUDE_DEG: 54.223342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006000',
        LOCATION_NAME: 'South Acre',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6769727,
        LOCATION_LATITUDE_DEG: 52.6967481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006100',
        LOCATION_NAME: 'South Allington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6921797,
        LOCATION_LATITUDE_DEG: 50.2352701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006200',
        LOCATION_NAME: 'South Alloa',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8028424,
        LOCATION_LATITUDE_DEG: 56.1065324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006300',
        LOCATION_NAME: 'South Ascot',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6706585,
        LOCATION_LATITUDE_DEG: 51.4021439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006400',
        LOCATION_NAME: 'South Baddesley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5021629,
        LOCATION_LATITUDE_DEG: 50.7659886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006500',
        LOCATION_NAME: 'South Bank',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1724119,
        LOCATION_LATITUDE_DEG: 54.5787506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006600',
        LOCATION_NAME: 'South Barrow',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5667026,
        LOCATION_LATITUDE_DEG: 51.0495275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006700',
        LOCATION_NAME: 'South Benfleet',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.561441,
        LOCATION_LATITUDE_DEG: 51.5532367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030000',
        LOCATION_NAME: 'South Benwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006800',
        LOCATION_NAME: 'South Bersted',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6735871,
        LOCATION_LATITUDE_DEG: 50.7933801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO006900',
        LOCATION_NAME: 'South Boisdale',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3773821,
        LOCATION_LATITUDE_DEG: 57.1294758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007000',
        LOCATION_NAME: 'South Bowood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7850039,
        LOCATION_LATITUDE_DEG: 50.7841057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007100',
        LOCATION_NAME: 'South Bramwith',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0598689,
        LOCATION_LATITUDE_DEG: 53.5949593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007200',
        LOCATION_NAME: 'South Brent',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8283812,
        LOCATION_LATITUDE_DEG: 50.4236879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007300',
        LOCATION_NAME: 'South Brewham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3984627,
        LOCATION_LATITUDE_DEG: 51.1234356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007400',
        LOCATION_NAME: 'South Brink',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1452556,
        LOCATION_LATITUDE_DEG: 52.6480466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007500',
        LOCATION_NAME: 'South Broomage',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8156455,
        LOCATION_LATITUDE_DEG: 56.0211268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007600',
        LOCATION_NAME: 'South Broomhill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6062742,
        LOCATION_LATITUDE_DEG: 55.2925248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007700',
        LOCATION_NAME: 'South Burlingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5047906,
        LOCATION_LATITUDE_DEG: 52.6172236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007800',
        LOCATION_NAME: 'South Cadbury',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5229082,
        LOCATION_LATITUDE_DEG: 51.0274282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO007900',
        LOCATION_NAME: 'South Carlton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5745983,
        LOCATION_LATITUDE_DEG: 53.2774232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008000',
        LOCATION_NAME: 'South Carnmarth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2024306,
        LOCATION_LATITUDE_DEG: 50.2173778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO032200',
        LOCATION_NAME: 'South Carntyne',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008100',
        LOCATION_NAME: 'South Cave',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5988899,
        LOCATION_LATITUDE_DEG: 53.7690712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008200',
        LOCATION_NAME: 'South Cerney',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9287153,
        LOCATION_LATITUDE_DEG: 51.6714853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008300',
        LOCATION_NAME: 'South Chailey',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0201427,
        LOCATION_LATITUDE_DEG: 50.9382847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008400',
        LOCATION_NAME: 'South Chard',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9493028,
        LOCATION_LATITUDE_DEG: 50.8393115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008500',
        LOCATION_NAME: 'South Charlton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7394575,
        LOCATION_LATITUDE_DEG: 55.4760481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008600',
        LOCATION_NAME: 'South Cheriton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4369395,
        LOCATION_LATITUDE_DEG: 51.0195254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008700',
        LOCATION_NAME: 'South Church',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6662132,
        LOCATION_LATITUDE_DEG: 54.6484656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008800',
        LOCATION_NAME: 'South Cleatlam',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8035689,
        LOCATION_LATITUDE_DEG: 54.5577555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO008900',
        LOCATION_NAME: 'South Cliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6721343,
        LOCATION_LATITUDE_DEG: 53.8138737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009000',
        LOCATION_NAME: 'South Clifton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7696403,
        LOCATION_LATITUDE_DEG: 53.2241153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009100',
        LOCATION_NAME: 'South Clunes',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4134341,
        LOCATION_LATITUDE_DEG: 57.4314711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009200',
        LOCATION_NAME: 'South Cockerington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0775852,
        LOCATION_LATITUDE_DEG: 53.3816189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009300',
        LOCATION_NAME: 'South Common',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9780024,
        LOCATION_LATITUDE_DEG: 50.8016153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009400',
        LOCATION_NAME: 'South Cornelly',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.700693,
        LOCATION_LATITUDE_DEG: 51.5098868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009500',
        LOCATION_NAME: 'South Cove',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.671826,
        LOCATION_LATITUDE_DEG: 52.3682013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009600',
        LOCATION_NAME: 'South Cowton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5484452,
        LOCATION_LATITUDE_DEG: 54.4165439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009700',
        LOCATION_NAME: 'South Creake',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7665027,
        LOCATION_LATITUDE_DEG: 52.8848646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009800',
        LOCATION_NAME: 'South Crosland',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8265194,
        LOCATION_LATITUDE_DEG: 53.6117678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO009900',
        LOCATION_NAME: 'South Croxton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9816294,
        LOCATION_LATITUDE_DEG: 52.6843642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010000',
        LOCATION_NAME: 'South Croydon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0992982,
        LOCATION_LATITUDE_DEG: 51.3564318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010100',
        LOCATION_NAME: 'South Cuan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6318674,
        LOCATION_LATITUDE_DEG: 56.2654669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010200',
        LOCATION_NAME: 'South Dalton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5283568,
        LOCATION_LATITUDE_DEG: 53.8956752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010300',
        LOCATION_NAME: 'South Darenth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2481492,
        LOCATION_LATITUDE_DEG: 51.4022279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010400',
        LOCATION_NAME: 'South Dell',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3312049,
        LOCATION_LATITUDE_DEG: 58.4645993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010500',
        LOCATION_NAME: 'South Denton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6952363,
        LOCATION_LATITUDE_DEG: 54.9821954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010600',
        LOCATION_NAME: 'South Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2167333,
        LOCATION_LATITUDE_DEG: 50.2223805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010700',
        LOCATION_NAME: 'South Duffield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9677344,
        LOCATION_LATITUDE_DEG: 53.7899755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010800',
        LOCATION_NAME: 'South Duntulm',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.336341,
        LOCATION_LATITUDE_DEG: 57.6768178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO010900',
        LOCATION_NAME: 'South Elkington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0551474,
        LOCATION_LATITUDE_DEG: 53.3758176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011000',
        LOCATION_NAME: 'South Elmsall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2822865,
        LOCATION_LATITUDE_DEG: 53.5961584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011100',
        LOCATION_NAME: 'South Erradale',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.78333,
        LOCATION_LATITUDE_DEG: 57.6758098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011200',
        LOCATION_NAME: 'South Fambridge',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6800661,
        LOCATION_LATITUDE_DEG: 51.631645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011300',
        LOCATION_NAME: 'South Fawley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4360187,
        LOCATION_LATITUDE_DEG: 51.5193584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011400',
        LOCATION_NAME: 'South Ferriby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5046542,
        LOCATION_LATITUDE_DEG: 53.6742564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011500',
        LOCATION_NAME: 'South Galson',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3918053,
        LOCATION_LATITUDE_DEG: 58.4430986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011600',
        LOCATION_NAME: 'South Glendale',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3002449,
        LOCATION_LATITUDE_DEG: 57.1136703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011700',
        LOCATION_NAME: 'South Godstone',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0477497,
        LOCATION_LATITUDE_DEG: 51.2183179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011800',
        LOCATION_NAME: 'South Gorley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7695678,
        LOCATION_LATITUDE_DEG: 50.8928051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029800',
        LOCATION_NAME: 'South Gosforth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6076528,
        LOCATION_LATITUDE_DEG: 55.00701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO011900',
        LOCATION_NAME: 'South Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.652859,
        LOCATION_LATITUDE_DEG: 51.3047119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012000',
        LOCATION_NAME: 'South Gyle',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2984709,
        LOCATION_LATITUDE_DEG: 55.9327116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030900',
        LOCATION_NAME: 'South Hackney',
        COUNTY_NAME: 'London',
        POSTCODE: 'E9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0419315,
        LOCATION_LATITUDE_DEG: 51.5433213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012100',
        LOCATION_NAME: 'South Hanningfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5184295,
        LOCATION_LATITUDE_DEG: 51.649751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012200',
        LOCATION_NAME: 'South Harewood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4148358,
        LOCATION_LATITUDE_DEG: 51.1761327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012300',
        LOCATION_NAME: 'South Harrow',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3515707,
        LOCATION_LATITUDE_DEG: 51.5644489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012400',
        LOCATION_NAME: 'South Harting',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8824723,
        LOCATION_LATITUDE_DEG: 50.9685012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012500',
        LOCATION_NAME: 'South Hayling',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9755081,
        LOCATION_LATITUDE_DEG: 50.7870869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012600',
        LOCATION_NAME: 'South Hazelrigg',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9129116,
        LOCATION_LATITUDE_DEG: 55.5852639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012700',
        LOCATION_NAME: 'South Heath',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6851206,
        LOCATION_LATITUDE_DEG: 51.7083734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012800',
        LOCATION_NAME: 'South Heighton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0553492,
        LOCATION_LATITUDE_DEG: 50.8048755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO012900',
        LOCATION_NAME: 'South Hetton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3977865,
        LOCATION_LATITUDE_DEG: 54.7969766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013000',
        LOCATION_NAME: 'South Hiendley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3992281,
        LOCATION_LATITUDE_DEG: 53.6072664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013100',
        LOCATION_NAME: 'South Hill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3585451,
        LOCATION_LATITUDE_DEG: 50.5292967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013200',
        LOCATION_NAME: 'South Hinksey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2623988,
        LOCATION_LATITUDE_DEG: 51.7331808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013300',
        LOCATION_NAME: 'South Huish',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8259919,
        LOCATION_LATITUDE_DEG: 50.2544728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013400',
        LOCATION_NAME: 'South Hykeham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5993127,
        LOCATION_LATITUDE_DEG: 53.1697115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013500',
        LOCATION_NAME: 'South Hylton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4521784,
        LOCATION_LATITUDE_DEG: 54.9055885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029900',
        LOCATION_NAME: 'South Jesmond',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5934413,
        LOCATION_LATITUDE_DEG: 54.9882069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO032000',
        LOCATION_NAME: 'South Jordanhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3404644,
        LOCATION_LATITUDE_DEG: 55.8753135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013600',
        LOCATION_NAME: 'South Kelsey',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4297267,
        LOCATION_LATITUDE_DEG: 53.4699356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030600',
        LOCATION_NAME: 'South Kensington',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1772007,
        LOCATION_LATITUDE_DEG: 51.4951467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013700',
        LOCATION_NAME: 'South Killingholme',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2616554,
        LOCATION_LATITUDE_DEG: 53.6290525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013800',
        LOCATION_NAME: 'South Kilvington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3460556,
        LOCATION_LATITUDE_DEG: 54.2491257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO013900',
        LOCATION_NAME: 'South Kilworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1101131,
        LOCATION_LATITUDE_DEG: 52.431245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014000',
        LOCATION_NAME: 'South Kirkby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3120385,
        LOCATION_LATITUDE_DEG: 53.5944633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014100',
        LOCATION_NAME: 'South Knighton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6830755,
        LOCATION_LATITUDE_DEG: 50.5383971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014200',
        LOCATION_NAME: 'South Kyme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.248633,
        LOCATION_LATITUDE_DEG: 53.031488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014300',
        LOCATION_NAME: 'South Leaze',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7879722,
        LOCATION_LATITUDE_DEG: 51.5465736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014400',
        LOCATION_NAME: 'South Leigh',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4321079,
        LOCATION_LATITUDE_DEG: 51.7753886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014500',
        LOCATION_NAME: 'South Leverton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8241113,
        LOCATION_LATITUDE_DEG: 53.3197291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014600',
        LOCATION_NAME: 'South Litchfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2420272,
        LOCATION_LATITUDE_DEG: 51.2124263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014700',
        LOCATION_NAME: 'South Littleton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8886378,
        LOCATION_LATITUDE_DEG: 52.1134244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014800',
        LOCATION_NAME: 'South Lochboisdale',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3288611,
        LOCATION_LATITUDE_DEG: 57.1361695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO014900',
        LOCATION_NAME: 'South Locheynort',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3499346,
        LOCATION_LATITUDE_DEG: 57.2261818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015000',
        LOCATION_NAME: 'South Lopham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0025145,
        LOCATION_LATITUDE_DEG: 52.3921111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO990140',
        LOCATION_NAME: 'South Luffenham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.611202,
        LOCATION_LATITUDE_DEG: 52.6085722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015100',
        LOCATION_NAME: 'South Luffenham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6097055,
        LOCATION_LATITUDE_DEG: 52.6068553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015200',
        LOCATION_NAME: 'South Marston',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7211191,
        LOCATION_LATITUDE_DEG: 51.5896694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015300',
        LOCATION_NAME: 'South Middleton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0041958,
        LOCATION_LATITUDE_DEG: 55.5039587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015400',
        LOCATION_NAME: 'South Milford',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2458801,
        LOCATION_LATITUDE_DEG: 53.7793724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015500',
        LOCATION_NAME: 'South Milton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8252947,
        LOCATION_LATITUDE_DEG: 50.2703694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015600',
        LOCATION_NAME: 'South Mimms',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2322482,
        LOCATION_LATITUDE_DEG: 51.6964599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015700',
        LOCATION_NAME: 'South Molton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8341362,
        LOCATION_LATITUDE_DEG: 51.0172421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015800',
        LOCATION_NAME: 'South Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7047092,
        LOCATION_LATITUDE_DEG: 54.862489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO015900',
        LOCATION_NAME: 'South Moreton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1881026,
        LOCATION_LATITUDE_DEG: 51.5876694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016000',
        LOCATION_NAME: 'South Mundham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7539557,
        LOCATION_LATITUDE_DEG: 50.7951837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016100',
        LOCATION_NAME: 'South Muskham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8181429,
        LOCATION_LATITUDE_DEG: 53.1067047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016200',
        LOCATION_NAME: 'South Newbald',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6156406,
        LOCATION_LATITUDE_DEG: 53.8101694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016300',
        LOCATION_NAME: 'South Newington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4067621,
        LOCATION_LATITUDE_DEG: 51.9945072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016400',
        LOCATION_NAME: 'South Newsham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5168713,
        LOCATION_LATITUDE_DEG: 55.1065138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016500',
        LOCATION_NAME: 'South Newton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8769393,
        LOCATION_LATITUDE_DEG: 51.1092291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016600',
        LOCATION_NAME: 'South Normanton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3344805,
        LOCATION_LATITUDE_DEG: 53.1004084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030400',
        LOCATION_NAME: 'South Norwood',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0747186,
        LOCATION_LATITUDE_DEG: 51.4003068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016700',
        LOCATION_NAME: 'South Nutfield',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1298701,
        LOCATION_LATITUDE_DEG: 51.2250198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016800',
        LOCATION_NAME: 'South Ockendon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2855227,
        LOCATION_LATITUDE_DEG: 51.5091379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO016900',
        LOCATION_NAME: 'South Ormsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0545795,
        LOCATION_LATITUDE_DEG: 53.2554094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017000',
        LOCATION_NAME: 'South Otterington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4256108,
        LOCATION_LATITUDE_DEG: 54.2822309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017100',
        LOCATION_NAME: 'South Owersby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4003679,
        LOCATION_LATITUDE_DEG: 53.4312284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017200',
        LOCATION_NAME: 'South Oxhey',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3848545,
        LOCATION_LATITUDE_DEG: 51.6260563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017300',
        LOCATION_NAME: 'South Park',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2041229,
        LOCATION_LATITUDE_DEG: 51.2228194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017400',
        LOCATION_NAME: 'South Pelaw',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5777237,
        LOCATION_LATITUDE_DEG: 54.8609904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017500',
        LOCATION_NAME: 'South Perrott',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7475057,
        LOCATION_LATITUDE_DEG: 50.8569133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017600',
        LOCATION_NAME: 'South Petherton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.808122,
        LOCATION_LATITUDE_DEG: 50.9489276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017700',
        LOCATION_NAME: 'South Petherwin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3906731,
        LOCATION_LATITUDE_DEG: 50.6109045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017800',
        LOCATION_NAME: 'South Pickenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7430788,
        LOCATION_LATITUDE_DEG: 52.6036375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO017900',
        LOCATION_NAME: 'South Pill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2172263,
        LOCATION_LATITUDE_DEG: 50.4121845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018000',
        LOCATION_NAME: 'South Pool',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7154789,
        LOCATION_LATITUDE_DEG: 50.2494646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018100',
        LOCATION_NAME: 'South Poorton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6737769,
        LOCATION_LATITUDE_DEG: 50.7732083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018200',
        LOCATION_NAME: 'South Queensferry',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3956551,
        LOCATION_LATITUDE_DEG: 55.988122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018300',
        LOCATION_NAME: 'South Rauceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.471618,
        LOCATION_LATITUDE_DEG: 52.9974925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018400',
        LOCATION_NAME: 'South Raynham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7884517,
        LOCATION_LATITUDE_DEG: 52.7827532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018500',
        LOCATION_NAME: 'South Reston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1097856,
        LOCATION_LATITUDE_DEG: 53.3248125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018600',
        LOCATION_NAME: 'South Ripley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7706377,
        LOCATION_LATITUDE_DEG: 50.7848937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018700',
        LOCATION_NAME: 'South Ruislip',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.391862,
        LOCATION_LATITUDE_DEG: 51.5602506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018800',
        LOCATION_NAME: 'South Runcton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4147861,
        LOCATION_LATITUDE_DEG: 52.6484426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO018900',
        LOCATION_NAME: 'South Scarle',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7317051,
        LOCATION_LATITUDE_DEG: 53.1664119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO032100',
        LOCATION_NAME: 'South Scotstownhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019000',
        LOCATION_NAME: 'South Shawbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.701156,
        LOCATION_LATITUDE_DEG: 58.3249829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019100',
        LOCATION_NAME: 'South Shields',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.432579,
        LOCATION_LATITUDE_DEG: 54.998195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019200',
        LOCATION_NAME: 'South Shore',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0564933,
        LOCATION_LATITUDE_DEG: 53.7905017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019300',
        LOCATION_NAME: 'South Somercotes',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1318773,
        LOCATION_LATITUDE_DEG: 53.4223275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019400',
        LOCATION_NAME: 'South Stack',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6971962,
        LOCATION_LATITUDE_DEG: 53.3067675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019500',
        LOCATION_NAME: 'South Stainley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5367265,
        LOCATION_LATITUDE_DEG: 54.0650065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019600',
        LOCATION_NAME: 'South Stainmore',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2434681,
        LOCATION_LATITUDE_DEG: 54.5125596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019700',
        LOCATION_NAME: 'South Stifford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3058352,
        LOCATION_LATITUDE_DEG: 51.4755338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019900',
        LOCATION_NAME: 'South Stoke',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1309525,
        LOCATION_LATITUDE_DEG: 51.5489606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO019800',
        LOCATION_NAME: 'South Stoke',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.54124,
        LOCATION_LATITUDE_DEG: 50.8796904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020000',
        LOCATION_NAME: 'South Tawton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9079096,
        LOCATION_LATITUDE_DEG: 50.7331121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020100',
        LOCATION_NAME: 'South Tehidy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2904899,
        LOCATION_LATITUDE_DEG: 50.2340788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020200',
        LOCATION_NAME: 'South Thoresby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.10007,
        LOCATION_LATITUDE_DEG: 53.2710081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020300',
        LOCATION_NAME: 'South Tidworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6623947,
        LOCATION_LATITUDE_DEG: 51.2300418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO031100',
        LOCATION_NAME: 'South Tottenham',
        COUNTY_NAME: 'London',
        POSTCODE: 'N15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0803003,
        LOCATION_LATITUDE_DEG: 51.579579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020400',
        LOCATION_NAME: 'South Trigon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1629303,
        LOCATION_LATITUDE_DEG: 50.6967954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020500',
        LOCATION_NAME: 'South Walsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4966365,
        LOCATION_LATITUDE_DEG: 52.6641318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020600',
        LOCATION_NAME: 'South Warnborough',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9662066,
        LOCATION_LATITUDE_DEG: 51.2203242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020700',
        LOCATION_NAME: 'South Weald',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2696667,
        LOCATION_LATITUDE_DEG: 51.6206478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020800',
        LOCATION_NAME: 'South Wellfield',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4871083,
        LOCATION_LATITUDE_DEG: 55.042403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030700',
        LOCATION_NAME: 'South West India Dock',
        COUNTY_NAME: 'London',
        POSTCODE: 'E14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0272801,
        LOCATION_LATITUDE_DEG: 51.511571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO020900',
        LOCATION_NAME: 'South Weston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9845513,
        LOCATION_LATITUDE_DEG: 51.6783673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021000',
        LOCATION_NAME: 'South Wheatley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.85569,
        LOCATION_LATITUDE_DEG: 53.3594313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021100',
        LOCATION_NAME: 'South Wigston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1316452,
        LOCATION_LATITUDE_DEG: 52.5794637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021200',
        LOCATION_NAME: 'South Willingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2044517,
        LOCATION_LATITUDE_DEG: 53.3332206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021300',
        LOCATION_NAME: 'South Wingfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4380739,
        LOCATION_LATITUDE_DEG: 53.0955124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021400',
        LOCATION_NAME: 'South Witham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6276952,
        LOCATION_LATITUDE_DEG: 52.7644681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021500',
        LOCATION_NAME: 'South Wonston',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3425435,
        LOCATION_LATITUDE_DEG: 51.1197213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021600',
        LOCATION_NAME: 'South Woodchester',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2318066,
        LOCATION_LATITUDE_DEG: 51.7148905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030800',
        LOCATION_NAME: 'South Woodford',
        COUNTY_NAME: 'London',
        POSTCODE: 'E18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0396567,
        LOCATION_LATITUDE_DEG: 51.5960549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021700',
        LOCATION_NAME: 'South Woodham Ferrers',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6107745,
        LOCATION_LATITUDE_DEG: 51.6484437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021800',
        LOCATION_NAME: 'South Wootton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4432327,
        LOCATION_LATITUDE_DEG: 52.777158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO021900',
        LOCATION_NAME: 'South Wraxall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2411257,
        LOCATION_LATITUDE_DEG: 51.3813597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030200',
        LOCATION_NAME: 'South Yardley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8162643,
        LOCATION_LATITUDE_DEG: 52.4622867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022000',
        LOCATION_NAME: 'South Zeal',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9118948,
        LOCATION_LATITUDE_DEG: 50.7255182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022100',
        LOCATION_NAME: 'Southall',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3725274,
        LOCATION_LATITUDE_DEG: 51.510548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022300',
        LOCATION_NAME: 'Southam',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0384572,
        LOCATION_LATITUDE_DEG: 51.9295094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022200',
        LOCATION_NAME: 'Southam',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3870148,
        LOCATION_LATITUDE_DEG: 52.2518288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO990885',
        LOCATION_NAME: 'Southampton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO990886',
        LOCATION_NAME: 'Southampton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022400',
        LOCATION_NAME: 'Southampton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4026569,
        LOCATION_LATITUDE_DEG: 50.9013073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022500',
        LOCATION_NAME: 'Southampton Airport',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO50',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.359441,
        LOCATION_LATITUDE_DEG: 50.9516037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022600',
        LOCATION_NAME: 'Southbar',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4650388,
        LOCATION_LATITUDE_DEG: 55.895524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022700',
        LOCATION_NAME: 'Southborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2614457,
        LOCATION_LATITUDE_DEG: 51.1572083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022900',
        LOCATION_NAME: 'Southbourne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7977655,
        LOCATION_LATITUDE_DEG: 50.7218893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO022800',
        LOCATION_NAME: 'Southbourne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9067014,
        LOCATION_LATITUDE_DEG: 50.8445898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023000',
        LOCATION_NAME: 'Southburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.957659,
        LOCATION_LATITUDE_DEG: 52.6036323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023100',
        LOCATION_NAME: 'Southburn',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.49194,
        LOCATION_LATITUDE_DEG: 53.976185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023200',
        LOCATION_NAME: 'Southchurch',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7398897,
        LOCATION_LATITUDE_DEG: 51.5412337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023300',
        LOCATION_NAME: 'Southcombe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5103798,
        LOCATION_LATITUDE_DEG: 51.9417066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023500',
        LOCATION_NAME: 'Southcott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0679117,
        LOCATION_LATITUDE_DEG: 50.7325151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023400',
        LOCATION_NAME: 'Southcott',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7557823,
        LOCATION_LATITUDE_DEG: 51.3331522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023600',
        LOCATION_NAME: 'Southdene',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8826129,
        LOCATION_LATITUDE_DEG: 53.4677702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023800',
        LOCATION_NAME: 'Southdown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5206611,
        LOCATION_LATITUDE_DEG: 50.3765773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023700',
        LOCATION_NAME: 'Southdown',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3932282,
        LOCATION_LATITUDE_DEG: 51.3682593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO023900',
        LOCATION_NAME: 'Southease',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0192068,
        LOCATION_LATITUDE_DEG: 50.8291809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024200',
        LOCATION_NAME: 'Southend',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6389416,
        LOCATION_LATITUDE_DEG: 55.3157793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024100',
        LOCATION_NAME: 'Southend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3706526,
        LOCATION_LATITUDE_DEG: 51.6534861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024000',
        LOCATION_NAME: 'Southend',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1397881,
        LOCATION_LATITUDE_DEG: 51.4329473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024250',
        LOCATION_NAME: 'Southend',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9132678,
        LOCATION_LATITUDE_DEG: 51.6003655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024300',
        LOCATION_NAME: 'Southend Airport',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.701571,
        LOCATION_LATITUDE_DEG: 51.5642408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029700',
        LOCATION_NAME: 'Southend on Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024400',
        LOCATION_NAME: 'Southend-on-Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7153272,
        LOCATION_LATITUDE_DEG: 51.5364352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024500',
        LOCATION_NAME: 'Southerfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3088886,
        LOCATION_LATITUDE_DEG: 54.8265021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024600',
        LOCATION_NAME: 'Southerham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0267766,
        LOCATION_LATITUDE_DEG: 50.8645785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024700',
        LOCATION_NAME: 'Southerndown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6083965,
        LOCATION_LATITUDE_DEG: 51.4517789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024800',
        LOCATION_NAME: 'Southerness',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6014369,
        LOCATION_LATITUDE_DEG: 54.8767109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO024900',
        LOCATION_NAME: 'Southerton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3009798,
        LOCATION_LATITUDE_DEG: 50.7068103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025000',
        LOCATION_NAME: 'Southery',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3893759,
        LOCATION_LATITUDE_DEG: 52.5267356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030100',
        LOCATION_NAME: 'Southey',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4800219,
        LOCATION_LATITUDE_DEG: 53.4186124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030500',
        LOCATION_NAME: 'Southfields',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2065789,
        LOCATION_LATITUDE_DEG: 51.4452089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025100',
        LOCATION_NAME: 'Southfleet',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.321863,
        LOCATION_LATITUDE_DEG: 51.4156306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025300',
        LOCATION_NAME: 'Southgate',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0930726,
        LOCATION_LATITUDE_DEG: 51.5721982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025200',
        LOCATION_NAME: 'Southgate',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0683279,
        LOCATION_LATITUDE_DEG: 52.3985792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO031000',
        LOCATION_NAME: 'Southgate',
        COUNTY_NAME: 'London',
        POSTCODE: 'N14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1281517,
        LOCATION_LATITUDE_DEG: 51.6333054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025400',
        LOCATION_NAME: 'Southill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3217333,
        LOCATION_LATITUDE_DEG: 52.063799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025500',
        LOCATION_NAME: 'Southleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1211241,
        LOCATION_LATITUDE_DEG: 50.7353101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025600',
        LOCATION_NAME: 'Southmead',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5958421,
        LOCATION_LATITUDE_DEG: 51.4965755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025700',
        LOCATION_NAME: 'Southminster',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8323247,
        LOCATION_LATITUDE_DEG: 51.6616461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025800',
        LOCATION_NAME: 'Southmoor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.421671,
        LOCATION_LATITUDE_DEG: 51.6800737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO025900',
        LOCATION_NAME: 'Southoe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2660835,
        LOCATION_LATITUDE_DEG: 52.2647222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026000',
        LOCATION_NAME: 'Southolt',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.220353,
        LOCATION_LATITUDE_DEG: 52.2731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026100',
        LOCATION_NAME: 'Southorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.403056,
        LOCATION_LATITUDE_DEG: 52.6098509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026200',
        LOCATION_NAME: 'Southowram',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8304368,
        LOCATION_LATITUDE_DEG: 53.7092796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026300',
        LOCATION_NAME: 'Southport',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'PR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0059409,
        LOCATION_LATITUDE_DEG: 53.6470857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026400',
        LOCATION_NAME: 'Southrepps',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3534426,
        LOCATION_LATITUDE_DEG: 52.8789572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026500',
        LOCATION_NAME: 'Southrey',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2965696,
        LOCATION_LATITUDE_DEG: 53.1861039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026600',
        LOCATION_NAME: 'Southrop',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7106883,
        LOCATION_LATITUDE_DEG: 51.7293843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026700',
        LOCATION_NAME: 'Southsea',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0459442,
        LOCATION_LATITUDE_DEG: 53.0566317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026800',
        LOCATION_NAME: 'Southsea',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0789285,
        LOCATION_LATITUDE_DEG: 50.785485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO026900',
        LOCATION_NAME: 'Southside',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8357719,
        LOCATION_LATITUDE_DEG: 54.6332653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027000',
        LOCATION_NAME: 'Southstoke',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3633437,
        LOCATION_LATITUDE_DEG: 51.3498576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027100',
        LOCATION_NAME: 'Southtown',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7134272,
        LOCATION_LATITUDE_DEG: 52.5953233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027200',
        LOCATION_NAME: 'Southville',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.605343,
        LOCATION_LATITUDE_DEG: 51.4437669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027400',
        LOCATION_NAME: 'Southwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8564442,
        LOCATION_LATITUDE_DEG: 54.7967969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO030300',
        LOCATION_NAME: 'Southwark',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0980579,
        LOCATION_LATITUDE_DEG: 51.5023886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027500',
        LOCATION_NAME: 'Southwater',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3519486,
        LOCATION_LATITUDE_DEG: 51.0220032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027600',
        LOCATION_NAME: 'Southway',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7736927,
        LOCATION_LATITUDE_DEG: 53.5476703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027700',
        LOCATION_NAME: 'Southwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4450619,
        LOCATION_LATITUDE_DEG: 50.5347807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027800',
        LOCATION_NAME: 'Southwell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9537391,
        LOCATION_LATITUDE_DEG: 53.0777028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028000',
        LOCATION_NAME: 'Southwick',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6809458,
        LOCATION_LATITUDE_DEG: 54.9012183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028300',
        LOCATION_NAME: 'Southwick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2331905,
        LOCATION_LATITUDE_DEG: 51.2959534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028200',
        LOCATION_NAME: 'Southwick',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4216298,
        LOCATION_LATITUDE_DEG: 54.9202943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028400',
        LOCATION_NAME: 'Southwick',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1106267,
        LOCATION_LATITUDE_DEG: 50.8735011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028100',
        LOCATION_NAME: 'Southwick',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4962534,
        LOCATION_LATITUDE_DEG: 52.5164424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO027900',
        LOCATION_NAME: 'Southwick',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2370775,
        LOCATION_LATITUDE_DEG: 50.8349815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028500',
        LOCATION_NAME: 'Southwold',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6809366,
        LOCATION_LATITUDE_DEG: 52.3257986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028700',
        LOCATION_NAME: 'Southwood',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6305643,
        LOCATION_LATITUDE_DEG: 51.0977371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028600',
        LOCATION_NAME: 'Southwood',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5411166,
        LOCATION_LATITUDE_DEG: 52.5923224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028800',
        LOCATION_NAME: 'Sowerby',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8041951,
        LOCATION_LATITUDE_DEG: 53.8447046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO028900',
        LOCATION_NAME: 'Sowerby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9358842,
        LOCATION_LATITUDE_DEG: 53.7050766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029000',
        LOCATION_NAME: 'Sowerby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3396767,
        LOCATION_LATITUDE_DEG: 54.2266195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029100',
        LOCATION_NAME: 'Sowerby Bridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9110178,
        LOCATION_LATITUDE_DEG: 53.70738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029200',
        LOCATION_NAME: 'Sowerby Row',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.94153,
        LOCATION_LATITUDE_DEG: 54.7522963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029300',
        LOCATION_NAME: 'Sowerby under Cotcliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3689307,
        LOCATION_LATITUDE_DEG: 54.3342333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029400',
        LOCATION_NAME: 'Sowood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8806043,
        LOCATION_LATITUDE_DEG: 53.6610772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029500',
        LOCATION_NAME: 'Sowton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4494642,
        LOCATION_LATITUDE_DEG: 50.7238116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO029600',
        LOCATION_NAME: 'Soyland',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9470039,
        LOCATION_LATITUDE_DEG: 53.6813776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000200',
        LOCATION_NAME: 'Spa Common',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4098594,
        LOCATION_LATITUDE_DEG: 52.8222472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000300',
        LOCATION_NAME: 'Spacey Houses',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5252315,
        LOCATION_LATITUDE_DEG: 53.9553973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000400',
        LOCATION_NAME: 'Spalding',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1485915,
        LOCATION_LATITUDE_DEG: 52.7857688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000500',
        LOCATION_NAME: 'Spalding Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1077468,
        LOCATION_LATITUDE_DEG: 52.8267654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000600',
        LOCATION_NAME: 'Spaldington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8473515,
        LOCATION_LATITUDE_DEG: 53.7924746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000700',
        LOCATION_NAME: 'Spaldwick',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3429769,
        LOCATION_LATITUDE_DEG: 52.3415231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000800',
        LOCATION_NAME: 'Spalford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7463846,
        LOCATION_LATITUDE_DEG: 53.2130124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000900',
        LOCATION_NAME: 'Span Carr',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4880825,
        LOCATION_LATITUDE_DEG: 53.1894238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001000',
        LOCATION_NAME: 'Spanby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3752561,
        LOCATION_LATITUDE_DEG: 52.9287802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001300',
        LOCATION_NAME: 'Sparbridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.890937,
        LOCATION_LATITUDE_DEG: 52.9085156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001400',
        LOCATION_NAME: 'Sparcells',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8297634,
        LOCATION_LATITUDE_DEG: 51.5751747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001500',
        LOCATION_NAME: 'Sparham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0686321,
        LOCATION_LATITUDE_DEG: 52.7342438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001600',
        LOCATION_NAME: 'Spark Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.064201,
        LOCATION_LATITUDE_DEG: 54.2549481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001700',
        LOCATION_NAME: 'Sparkbrook',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8690447,
        LOCATION_LATITUDE_DEG: 52.459255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001800',
        LOCATION_NAME: 'Sparkford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5600804,
        LOCATION_LATITUDE_DEG: 51.0316267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001900',
        LOCATION_NAME: 'Sparkhill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.86315,
        LOCATION_LATITUDE_DEG: 52.4520555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002000',
        LOCATION_NAME: 'Sparkwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9963733,
        LOCATION_LATITUDE_DEG: 50.4025846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002100',
        LOCATION_NAME: 'Sparnock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0986177,
        LOCATION_LATITUDE_DEG: 50.2390797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002200',
        LOCATION_NAME: 'Sparnon Gate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2464269,
        LOCATION_LATITUDE_DEG: 50.245783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002300',
        LOCATION_NAME: 'Sparrow Pit',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8646822,
        LOCATION_LATITUDE_DEG: 53.3203139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002400',
        LOCATION_NAME: 'Sparrows Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3375177,
        LOCATION_LATITUDE_DEG: 51.0676002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002600',
        LOCATION_NAME: 'Sparsholt',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4992515,
        LOCATION_LATITUDE_DEG: 51.5865676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002500',
        LOCATION_NAME: 'Sparsholt',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3785293,
        LOCATION_LATITUDE_DEG: 51.0778208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002700',
        LOCATION_NAME: 'Sparsholt Firs',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5065339,
        LOCATION_LATITUDE_DEG: 51.5592703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002800',
        LOCATION_NAME: 'Sparty Lea',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2337136,
        LOCATION_LATITUDE_DEG: 54.835391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP002900',
        LOCATION_NAME: 'Spath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8707188,
        LOCATION_LATITUDE_DEG: 52.9114981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003000',
        LOCATION_NAME: 'Spaxton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1059879,
        LOCATION_LATITUDE_DEG: 51.1247482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003100',
        LOCATION_NAME: 'Spean Bridge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.920334,
        LOCATION_LATITUDE_DEG: 56.8910232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003300',
        LOCATION_NAME: 'Speckington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.625965,
        LOCATION_LATITUDE_DEG: 51.0109315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003400',
        LOCATION_NAME: 'Speddoch',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8238571,
        LOCATION_LATITUDE_DEG: 55.1203343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003500',
        LOCATION_NAME: 'Speedwell',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5321439,
        LOCATION_LATITUDE_DEG: 51.4664688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003700',
        LOCATION_NAME: 'Speen',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3423613,
        LOCATION_LATITUDE_DEG: 51.4117498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003600',
        LOCATION_NAME: 'Speen',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7827302,
        LOCATION_LATITUDE_DEG: 51.6903698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003800',
        LOCATION_NAME: 'Speenhamland',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3227244,
        LOCATION_LATITUDE_DEG: 51.405451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003900',
        LOCATION_NAME: 'Speeton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2415302,
        LOCATION_LATITUDE_DEG: 54.1523008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004000',
        LOCATION_NAME: 'Speke',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8396087,
        LOCATION_LATITUDE_DEG: 53.3406575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004100',
        LOCATION_NAME: 'Speldhurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.221141,
        LOCATION_LATITUDE_DEG: 51.1501017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004200',
        LOCATION_NAME: 'Spellbrook',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1577122,
        LOCATION_LATITUDE_DEG: 51.8357738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004300',
        LOCATION_NAME: 'Spelsbury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4907324,
        LOCATION_LATITUDE_DEG: 51.8933995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004400',
        LOCATION_NAME: 'Spencers Wood',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9706475,
        LOCATION_LATITUDE_DEG: 51.3940475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004500',
        LOCATION_NAME: 'Spennithorne',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7907513,
        LOCATION_LATITUDE_DEG: 54.2970345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004600',
        LOCATION_NAME: 'Spennymoor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6073157,
        LOCATION_LATITUDE_DEG: 54.6951693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004700',
        LOCATION_NAME: 'Spernal',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8731999,
        LOCATION_LATITUDE_DEG: 52.2576409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004800',
        LOCATION_NAME: 'Spernal Ash',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8871477,
        LOCATION_LATITUDE_DEG: 52.2580417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP004900',
        LOCATION_NAME: 'Spetchley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1512503,
        LOCATION_LATITUDE_DEG: 52.1831363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005000',
        LOCATION_NAME: 'Spetisbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.123619,
        LOCATION_LATITUDE_DEG: 50.8199039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005100',
        LOCATION_NAME: 'Spexhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.494282,
        LOCATION_LATITUDE_DEG: 52.3680043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005200',
        LOCATION_NAME: 'Spey Bay',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0826789,
        LOCATION_LATITUDE_DEG: 57.6722788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005400',
        LOCATION_NAME: 'Spilsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0960021,
        LOCATION_LATITUDE_DEG: 53.1734041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005600',
        LOCATION_NAME: 'Spinkhill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3162501,
        LOCATION_LATITUDE_DEG: 53.3012336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005700',
        LOCATION_NAME: 'Spinney Hill',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8664239,
        LOCATION_LATITUDE_DEG: 52.265323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005800',
        LOCATION_NAME: 'Spinningdale',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2337423,
        LOCATION_LATITUDE_DEG: 57.8780152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005900',
        LOCATION_NAME: 'Spion Kop',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1377508,
        LOCATION_LATITUDE_DEG: 53.1992166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006000',
        LOCATION_NAME: 'Spirthill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0054005,
        LOCATION_LATITUDE_DEG: 51.4793664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006100',
        LOCATION_NAME: 'Spital',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9929195,
        LOCATION_LATITUDE_DEG: 53.3401546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011700',
        LOCATION_NAME: 'Spital in the Street',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011800',
        LOCATION_NAME: 'Spital Tongues',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6289839,
        LOCATION_LATITUDE_DEG: 54.9847525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011900',
        LOCATION_NAME: 'Spitalfields',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0726135,
        LOCATION_LATITUDE_DEG: 51.5227664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006200',
        LOCATION_NAME: 'Spital-in-the-Street',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5461624,
        LOCATION_LATITUDE_DEG: 53.3996298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006400',
        LOCATION_NAME: 'Spittal',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9394352,
        LOCATION_LATITUDE_DEG: 51.869636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006500',
        LOCATION_NAME: 'Spittal',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4260911,
        LOCATION_LATITUDE_DEG: 58.4673629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006300',
        LOCATION_NAME: 'Spittal',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9910442,
        LOCATION_LATITUDE_DEG: 55.7568776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006600',
        LOCATION_NAME: 'Spittalfield',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4516845,
        LOCATION_LATITUDE_DEG: 56.5512764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006800',
        LOCATION_NAME: 'Spixworth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3285622,
        LOCATION_LATITUDE_DEG: 52.6891338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006900',
        LOCATION_NAME: 'Splatt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8997087,
        LOCATION_LATITUDE_DEG: 50.549707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007000',
        LOCATION_NAME: 'Splaynes Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0409919,
        LOCATION_LATITUDE_DEG: 50.9988891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007100',
        LOCATION_NAME: 'Splott',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1614998,
        LOCATION_LATITUDE_DEG: 51.4891813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007200',
        LOCATION_NAME: 'Spofforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4462307,
        LOCATION_LATITUDE_DEG: 53.953594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007300',
        LOCATION_NAME: 'Spon End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5315715,
        LOCATION_LATITUDE_DEG: 52.4087509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007400',
        LOCATION_NAME: 'Spondon',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4001223,
        LOCATION_LATITUDE_DEG: 52.9214001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007500',
        LOCATION_NAME: 'Sponish',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1538325,
        LOCATION_LATITUDE_DEG: 57.6134143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007600',
        LOCATION_NAME: 'Spooner Row',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0912236,
        LOCATION_LATITUDE_DEG: 52.5334272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007700',
        LOCATION_NAME: 'Spoonley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5024972,
        LOCATION_LATITUDE_DEG: 52.9209078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007800',
        LOCATION_NAME: 'Sporle',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7340404,
        LOCATION_LATITUDE_DEG: 52.6676463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008000',
        LOCATION_NAME: 'Spot Acre',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1011793,
        LOCATION_LATITUDE_DEG: 52.9332101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008100',
        LOCATION_NAME: 'Spott',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5258249,
        LOCATION_LATITUDE_DEG: 55.9707093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008200',
        LOCATION_NAME: 'Spratton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9475065,
        LOCATION_LATITUDE_DEG: 52.3243307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008300',
        LOCATION_NAME: 'Spreacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1653019,
        LOCATION_LATITUDE_DEG: 51.1517608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008400',
        LOCATION_NAME: 'Spreyton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8418792,
        LOCATION_LATITUDE_DEG: 50.7548167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008500',
        LOCATION_NAME: 'Spriddlestone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0609206,
        LOCATION_LATITUDE_DEG: 50.344878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008600',
        LOCATION_NAME: 'Spridlington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4852734,
        LOCATION_LATITUDE_DEG: 53.348229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008700',
        LOCATION_NAME: 'Spring Gardens',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3258292,
        LOCATION_LATITUDE_DEG: 51.2439423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP008900',
        LOCATION_NAME: 'Spring Village',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4826976,
        LOCATION_LATITUDE_DEG: 52.6635885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP012200',
        LOCATION_NAME: 'Springbank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP012300',
        LOCATION_NAME: 'Springboig',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1553227,
        LOCATION_LATITUDE_DEG: 55.8569618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP012100',
        LOCATION_NAME: 'Springburn',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP012050',
        LOCATION_NAME: 'Springfield',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7297746,
        LOCATION_LATITUDE_DEG: 54.3677863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP012000',
        LOCATION_NAME: 'Springfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2301206,
        LOCATION_LATITUDE_DEG: 55.8827468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009000',
        LOCATION_NAME: 'Springfield',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1708137,
        LOCATION_LATITUDE_DEG: 50.7944161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009100',
        LOCATION_NAME: 'Springfield',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.063899,
        LOCATION_LATITUDE_DEG: 56.2949464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009200',
        LOCATION_NAME: 'Springfield',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0589843,
        LOCATION_LATITUDE_DEG: 55.0058205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009300',
        LOCATION_NAME: 'Springfield',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7325466,
        LOCATION_LATITUDE_DEG: 52.0383062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009400',
        LOCATION_NAME: 'Springfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5060549,
        LOCATION_LATITUDE_DEG: 51.7495545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009500',
        LOCATION_NAME: 'Springhead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0593235,
        LOCATION_LATITUDE_DEG: 53.5399641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009700',
        LOCATION_NAME: 'Springhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8964539,
        LOCATION_LATITUDE_DEG: 52.6462749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009600',
        LOCATION_NAME: 'Springhill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8190691,
        LOCATION_LATITUDE_DEG: 52.0029116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009800',
        LOCATION_NAME: 'Springholm',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8663257,
        LOCATION_LATITUDE_DEG: 55.0102259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP009900',
        LOCATION_NAME: 'Springside',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5917306,
        LOCATION_LATITUDE_DEG: 55.6139956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010000',
        LOCATION_NAME: 'Springthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6822359,
        LOCATION_LATITUDE_DEG: 53.3963365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010100',
        LOCATION_NAME: 'Springvale',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.613753,
        LOCATION_LATITUDE_DEG: 53.5235605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP990765',
        LOCATION_NAME: 'Springwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010200',
        LOCATION_NAME: 'Springwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4241903,
        LOCATION_LATITUDE_DEG: 54.8884907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010300',
        LOCATION_NAME: 'Springwell Village',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5513405,
        LOCATION_LATITUDE_DEG: 54.9189909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010400',
        LOCATION_NAME: 'Sproatley',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1896941,
        LOCATION_LATITUDE_DEG: 53.7937612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010500',
        LOCATION_NAME: 'Sproston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3993258,
        LOCATION_LATITUDE_DEG: 53.1972172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010600',
        LOCATION_NAME: 'Sproston Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4011785,
        LOCATION_LATITUDE_DEG: 53.1984336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010700',
        LOCATION_NAME: 'Sprotbrough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.186294,
        LOCATION_LATITUDE_DEG: 53.5121472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010800',
        LOCATION_NAME: 'Sproughton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0966805,
        LOCATION_LATITUDE_DEG: 52.0618778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP010900',
        LOCATION_NAME: 'Sprouston',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3869475,
        LOCATION_LATITUDE_DEG: 55.6101698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011000',
        LOCATION_NAME: 'Sprowston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3225318,
        LOCATION_LATITUDE_DEG: 52.6561307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011100',
        LOCATION_NAME: 'Sproxton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0586405,
        LOCATION_LATITUDE_DEG: 54.2261183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011200',
        LOCATION_NAME: 'Sproxton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7304058,
        LOCATION_LATITUDE_DEG: 52.8091739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011300',
        LOCATION_NAME: 'Sprytown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2451275,
        LOCATION_LATITUDE_DEG: 50.6446102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011400',
        LOCATION_NAME: 'Spurn Head',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1119102,
        LOCATION_LATITUDE_DEG: 53.5741399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011500',
        LOCATION_NAME: 'Spurstow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.659918,
        LOCATION_LATITUDE_DEG: 53.1082251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP011600',
        LOCATION_NAME: 'Spy Post',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2378259,
        LOCATION_LATITUDE_DEG: 50.9673332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SQ000100',
        LOCATION_NAME: 'Square and Compass',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.120424,
        LOCATION_LATITUDE_DEG: 51.9383438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114600',
        LOCATION_NAME: 'St Abbs',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114800',
        LOCATION_NAME: 'St Agnes',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114700',
        LOCATION_NAME: 'St Agnes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114900',
        LOCATION_NAME: 'St Albans',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115000',
        LOCATION_NAME: 'St Allen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115100',
        LOCATION_NAME: 'St Andrew',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115200',
        LOCATION_NAME: 'St Andrews',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125600',
        LOCATION_NAME: 'St Andrews',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5937236,
        LOCATION_LATITUDE_DEG: 51.4710112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115300',
        LOCATION_NAME: 'St Andrews Major',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115400',
        LOCATION_NAME: 'St Annes',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125500',
        LOCATION_NAME: 'St Annes',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5468123,
        LOCATION_LATITUDE_DEG: 51.4517882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115500',
        LOCATION_NAME: 'St Annes Head',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103000',
        LOCATION_NAME: 'St Anns',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115600',
        LOCATION_NAME: 'St Anns',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4636978,
        LOCATION_LATITUDE_DEG: 55.2273059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115700',
        LOCATION_NAME: 'St Anns Bethesda',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0747217,
        LOCATION_LATITUDE_DEG: 53.1789829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115800',
        LOCATION_NAME: 'St Anns Chapel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST115900',
        LOCATION_NAME: 'St Anns Chapel',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116000',
        LOCATION_NAME: 'St Anns Wells',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116100',
        LOCATION_NAME: 'St Anthonys',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116200',
        LOCATION_NAME: 'St Arvans',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116300',
        LOCATION_NAME: 'St Asaph',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116400',
        LOCATION_NAME: 'St Athan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125300',
        LOCATION_NAME: 'St Augustines',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5990427,
        LOCATION_LATITUDE_DEG: 51.4549682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116500',
        LOCATION_NAME: 'St Austell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116600',
        LOCATION_NAME: 'St Bees',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116700',
        LOCATION_NAME: 'St Blazey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116800',
        LOCATION_NAME: 'St Blazey Gate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST116900',
        LOCATION_NAME: 'St Boswells',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6443587,
        LOCATION_LATITUDE_DEG: 55.5729617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117000',
        LOCATION_NAME: 'St Brelade',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117100',
        LOCATION_NAME: 'St Breock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117200',
        LOCATION_NAME: 'St Breward',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117300',
        LOCATION_NAME: 'St Briavels',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117400',
        LOCATION_NAME: 'St Brides',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117500',
        LOCATION_NAME: 'St Brides Major',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117600',
        LOCATION_NAME: 'St Brides Netherwent',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120900',
        LOCATION_NAME: 'St Brides super Ely',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117700',
        LOCATION_NAME: 'St Brides Wentlooge',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117800',
        LOCATION_NAME: 'St Brides-super-Ely',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST117900',
        LOCATION_NAME: 'St Budeaux',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118000',
        LOCATION_NAME: 'St Buryan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118100',
        LOCATION_NAME: 'St Catherine',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103100',
        LOCATION_NAME: 'St Catherines',
        COUNTY_NAME: 'Strathclyde',
        POSTCODE: 'PA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990762',
        LOCATION_NAME: 'St Catherines Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118300',
        LOCATION_NAME: 'St Clears',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118400',
        LOCATION_NAME: 'St Cleer',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118600',
        LOCATION_NAME: 'St Clement',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118500',
        LOCATION_NAME: 'St Clement',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118800',
        LOCATION_NAME: 'St Clether',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118900',
        LOCATION_NAME: 'St Columb',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119000',
        LOCATION_NAME: 'St Columb Minor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119100',
        LOCATION_NAME: 'St Combs',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119200',
        LOCATION_NAME: 'St Cross',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3207686,
        LOCATION_LATITUDE_DEG: 51.0522912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119300',
        LOCATION_NAME: 'St Cross South Elmham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119400',
        LOCATION_NAME: 'St Cyrus',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119500',
        LOCATION_NAME: 'St Davids',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119600',
        LOCATION_NAME: 'St Day',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119700',
        LOCATION_NAME: 'St Dennis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119800',
        LOCATION_NAME: 'St Devereux',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8185101,
        LOCATION_LATITUDE_DEG: 51.981072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST119900',
        LOCATION_NAME: 'St Dials',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0360051,
        LOCATION_LATITUDE_DEG: 51.6486471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120000',
        LOCATION_NAME: 'St Dogmaels',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6826693,
        LOCATION_LATITUDE_DEG: 52.0827212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120100',
        LOCATION_NAME: 'St Dominick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103500',
        LOCATION_NAME: 'St Donats',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110100',
        LOCATION_NAME: 'St Dunstans',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110200',
        LOCATION_NAME: 'St Endellion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110300',
        LOCATION_NAME: 'St Erme',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110400',
        LOCATION_NAME: 'St Erney Landrake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110500',
        LOCATION_NAME: 'St Erth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110600',
        LOCATION_NAME: 'St Erth Praze',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110700',
        LOCATION_NAME: 'St Ervan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110800',
        LOCATION_NAME: 'St Eval',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0094227,
        LOCATION_LATITUDE_DEG: 50.4874369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110900',
        LOCATION_NAME: 'St Ewe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111000',
        LOCATION_NAME: 'St Fagans',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111100',
        LOCATION_NAME: 'St Fergus',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111200',
        LOCATION_NAME: 'St Fillans',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111300',
        LOCATION_NAME: 'St Florence',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111400',
        LOCATION_NAME: 'St Fort',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111500',
        LOCATION_NAME: 'St Gennys',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111700',
        LOCATION_NAME: 'St George',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111600',
        LOCATION_NAME: 'St George',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111800',
        LOCATION_NAME: 'St Georges',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST111900',
        LOCATION_NAME: 'St Georges',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112000',
        LOCATION_NAME: 'St Georges Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112100',
        LOCATION_NAME: 'St Germans',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112400',
        LOCATION_NAME: 'St Gluvias',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112500',
        LOCATION_NAME: 'St Harmon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112600',
        LOCATION_NAME: 'St Helen Auckland',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112700',
        LOCATION_NAME: 'St Helens',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112800',
        LOCATION_NAME: 'St Helens',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112900',
        LOCATION_NAME: 'St Helier',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1078404,
        LOCATION_LATITUDE_DEG: 49.183194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113000',
        LOCATION_NAME: 'St Hilary',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113100',
        LOCATION_NAME: 'St Hilary',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113200',
        LOCATION_NAME: 'St Ippolyts',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113300',
        LOCATION_NAME: 'St Ishmaels',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1368831,
        LOCATION_LATITUDE_DEG: 51.723092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113400',
        LOCATION_NAME: 'St Issey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113500',
        LOCATION_NAME: 'St Ive',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113800',
        LOCATION_NAME: 'St Ives',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113600',
        LOCATION_NAME: 'St Ives',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113700',
        LOCATION_NAME: 'St Ives',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST113900',
        LOCATION_NAME: 'St James',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114000',
        LOCATION_NAME: 'St James',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125400',
        LOCATION_NAME: 'St James Barton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5907784,
        LOCATION_LATITUDE_DEG: 51.4592637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114100',
        LOCATION_NAME: 'St James South Elmham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114300',
        LOCATION_NAME: 'St John',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114200',
        LOCATION_NAME: 'St John',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123700',
        LOCATION_NAME: 'St Johns',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114400',
        LOCATION_NAME: 'St Johns',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124900',
        LOCATION_NAME: 'St Johns',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120300',
        LOCATION_NAME: 'St Johns',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120200',
        LOCATION_NAME: 'St Johns',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120400',
        LOCATION_NAME: 'St Johns Chapel',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120500',
        LOCATION_NAME: 'St Johns Fen End',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121000',
        LOCATION_NAME: 'St Johns in the Vale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123600',
        LOCATION_NAME: 'St Johns Wood',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST114500',
        LOCATION_NAME: 'St Johns-in-the-Vale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103900',
        LOCATION_NAME: 'St Judes',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104000',
        LOCATION_NAME: 'St Judes',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104100',
        LOCATION_NAME: 'St Julians',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104200',
        LOCATION_NAME: 'St Juliot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104300',
        LOCATION_NAME: 'St Just',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104400',
        LOCATION_NAME: 'St Just in Roseland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104500',
        LOCATION_NAME: 'St Katherines',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124300',
        LOCATION_NAME: 'St Katherines Dock',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0720943,
        LOCATION_LATITUDE_DEG: 51.5110892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104600',
        LOCATION_NAME: 'St Keverne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.105206,
        LOCATION_LATITUDE_DEG: 50.0439126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104700',
        LOCATION_NAME: 'St Kew',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104800',
        LOCATION_NAME: 'St Kew Highway',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST104900',
        LOCATION_NAME: 'St Keyne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105300',
        LOCATION_NAME: 'St Lawrence',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105200',
        LOCATION_NAME: 'St Lawrence',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105000',
        LOCATION_NAME: 'St Lawrence',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105100',
        LOCATION_NAME: 'St Lawrence',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990162',
        LOCATION_NAME: 'St Lawrence',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7521812,
        LOCATION_LATITUDE_DEG: 50.464499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105600',
        LOCATION_NAME: 'St Leonards',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105400',
        LOCATION_NAME: 'St Leonards',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105500',
        LOCATION_NAME: 'St Leonards',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125800',
        LOCATION_NAME: 'St Leonards',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1769014,
        LOCATION_LATITUDE_DEG: 55.9417962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121100',
        LOCATION_NAME: 'St Leonards on Sea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124800',
        LOCATION_NAME: 'St Leonards on Sea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5452035,
        LOCATION_LATITUDE_DEG: 50.8586291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105800',
        LOCATION_NAME: 'St Leonards-on-Sea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105900',
        LOCATION_NAME: 'St Levan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106000',
        LOCATION_NAME: 'St Loyes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103200',
        LOCATION_NAME: 'St Lythans',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990164',
        LOCATION_NAME: 'St Mabby',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106100',
        LOCATION_NAME: 'St Mabyn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106200',
        LOCATION_NAME: 'St Madoes',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106300',
        LOCATION_NAME: 'St Margaret South Elmham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121200',
        LOCATION_NAME: 'St Margarets at Cliffe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106500',
        LOCATION_NAME: 'St Margarets Bay',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106600',
        LOCATION_NAME: 'St Margarets Hope',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106700',
        LOCATION_NAME: 'St Margarets-at-Cliffe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106800',
        LOCATION_NAME: 'St Marks',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106900',
        LOCATION_NAME: 'St Martin',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107000',
        LOCATION_NAME: 'St Martin',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107100',
        LOCATION_NAME: 'St Martin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107200',
        LOCATION_NAME: 'St Martin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1664971,
        LOCATION_LATITUDE_DEG: 50.0733941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107700',
        LOCATION_NAME: 'St Martins',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107400',
        LOCATION_NAME: 'St Martins',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107600',
        LOCATION_NAME: 'St Martins',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107500',
        LOCATION_NAME: 'St Martins',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107300',
        LOCATION_NAME: 'St Martins',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7301722,
        LOCATION_LATITUDE_DEG: 54.3961981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107800',
        LOCATION_NAME: 'St Mary',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST107900',
        LOCATION_NAME: 'St Mary Bourne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108000',
        LOCATION_NAME: 'St Mary Church',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108100',
        LOCATION_NAME: 'St Mary Cray',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108200',
        LOCATION_NAME: 'St Mary Hill',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108300',
        LOCATION_NAME: 'St Mary Hoo',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108400',
        LOCATION_NAME: 'St Mary in the Marsh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108500',
        LOCATION_NAME: 'St Marychurch',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103300',
        LOCATION_NAME: 'St Marys',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108600',
        LOCATION_NAME: 'St Marys Bay',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108700',
        LOCATION_NAME: 'St Marys Island',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103400',
        LOCATION_NAME: 'St Marys Isle',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108800',
        LOCATION_NAME: 'St Maughans',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST108900',
        LOCATION_NAME: 'St Mawes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096900',
        LOCATION_NAME: 'St Mawgan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9984411,
        LOCATION_LATITUDE_DEG: 50.4556483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097000',
        LOCATION_NAME: 'St Mellion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097100',
        LOCATION_NAME: 'St Mellons',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097200',
        LOCATION_NAME: 'St Merryn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097300',
        LOCATION_NAME: 'St Mewan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097400',
        LOCATION_NAME: 'St Michael Penkivel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097500',
        LOCATION_NAME: 'St Michael South Elmham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097800',
        LOCATION_NAME: 'St Michaels',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097700',
        LOCATION_NAME: 'St Michaels',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097600',
        LOCATION_NAME: 'St Michaels',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST097900',
        LOCATION_NAME: 'St Michaels',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124200',
        LOCATION_NAME: 'St Michaels',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9488885,
        LOCATION_LATITUDE_DEG: 53.3771831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098000',
        LOCATION_NAME: 'St Mildreds',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'CT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098100',
        LOCATION_NAME: 'St Minver',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098200',
        LOCATION_NAME: 'St Monans',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098400',
        LOCATION_NAME: 'St Mungo',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3418995,
        LOCATION_LATITUDE_DEG: 55.052616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098500',
        LOCATION_NAME: 'St Neot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098600',
        LOCATION_NAME: 'St Neot Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098700',
        LOCATION_NAME: 'St Neots',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990707',
        LOCATION_NAME: 'St Newlyn East',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098900',
        LOCATION_NAME: 'St Nicholas',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098800',
        LOCATION_NAME: 'St Nicholas',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099100',
        LOCATION_NAME: 'St Nicholas at Wade',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099000',
        LOCATION_NAME: 'St Nicholas South Elmham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099200',
        LOCATION_NAME: 'St Ninians',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099300',
        LOCATION_NAME: 'St Ola',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'KW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099400',
        LOCATION_NAME: 'St Olaves',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099500',
        LOCATION_NAME: 'St Osyth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099600',
        LOCATION_NAME: 'St Ouen',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099700',
        LOCATION_NAME: 'St Owens Cross',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099900',
        LOCATION_NAME: 'St Pauls',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100000',
        LOCATION_NAME: 'St Pauls Cray',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100100',
        LOCATION_NAME: 'St Pauls Walden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100200',
        LOCATION_NAME: 'St Peter',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100300',
        LOCATION_NAME: 'St Peter Port',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100400',
        LOCATION_NAME: 'St Peter South Elmham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122800',
        LOCATION_NAME: 'St Peters',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100600',
        LOCATION_NAME: 'St Peters',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3516206,
        LOCATION_LATITUDE_DEG: 51.8577323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100500',
        LOCATION_NAME: 'St Peters',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4161148,
        LOCATION_LATITUDE_DEG: 51.3690487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100700',
        LOCATION_NAME: 'St Petrox',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100800',
        LOCATION_NAME: 'St Philips',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST100900',
        LOCATION_NAME: 'St Philips Marsh',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101000',
        LOCATION_NAME: 'St Phillans',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'PA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123100',
        LOCATION_NAME: 'St Phillips',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101100',
        LOCATION_NAME: 'St Pierre Du Bois',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101200',
        LOCATION_NAME: 'St Pinnock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101300',
        LOCATION_NAME: 'St Quivox',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125900',
        LOCATION_NAME: 'St Rollox',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101400',
        LOCATION_NAME: 'St Sampson',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101500',
        LOCATION_NAME: 'St Saviour',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101600',
        LOCATION_NAME: 'St Stephen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101700',
        LOCATION_NAME: 'St Stephens',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101800',
        LOCATION_NAME: 'St Stephens',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST101900',
        LOCATION_NAME: 'St Teath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102100',
        LOCATION_NAME: 'St Thomas',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102000',
        LOCATION_NAME: 'St Thomas',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102200',
        LOCATION_NAME: 'St Tudy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102300',
        LOCATION_NAME: 'St Twynnells',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102400',
        LOCATION_NAME: 'St Veep',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102500',
        LOCATION_NAME: 'St Vigeans',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102600',
        LOCATION_NAME: 'St Wenn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102700',
        LOCATION_NAME: 'St Weonards',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102800',
        LOCATION_NAME: 'St Werburghs',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST102900',
        LOCATION_NAME: 'St Winnolls',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000100',
        LOCATION_NAME: 'St. Abbs',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1299988,
        LOCATION_LATITUDE_DEG: 55.8993991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000350',
        LOCATION_NAME: 'St. Agnes',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000200',
        LOCATION_NAME: 'St. Agnes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2021566,
        LOCATION_LATITUDE_DEG: 50.3094874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000300',
        LOCATION_NAME: 'St. Agnes',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5764457,
        LOCATION_LATITUDE_DEG: 51.4653691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000400',
        LOCATION_NAME: 'St. Albans',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3372529,
        LOCATION_LATITUDE_DEG: 51.7517716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000500',
        LOCATION_NAME: 'St. Allen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0594366,
        LOCATION_LATITUDE_DEG: 50.3147917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000600',
        LOCATION_NAME: 'St. Andrew',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5701152,
        LOCATION_LATITUDE_DEG: 49.4472089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000700',
        LOCATION_NAME: 'St. Andrews',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7974069,
        LOCATION_LATITUDE_DEG: 56.3389477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000800',
        LOCATION_NAME: 'St. Andrews Major',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2405248,
        LOCATION_LATITUDE_DEG: 51.4354749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001000',
        LOCATION_NAME: 'St. Annes',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0301162,
        LOCATION_LATITUDE_DEG: 53.7511954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001100',
        LOCATION_NAME: 'St. Annes Head',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1727938,
        LOCATION_LATITUDE_DEG: 51.6880165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001200',
        LOCATION_NAME: 'St. Anns',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4606262,
        LOCATION_LATITUDE_DEG: 55.2254462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001300',
        LOCATION_NAME: 'St. Anns Bethesda',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0782436,
        LOCATION_LATITUDE_DEG: 53.1750551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001400',
        LOCATION_NAME: 'St. Anns Chapel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2355768,
        LOCATION_LATITUDE_DEG: 50.5154242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001500',
        LOCATION_NAME: 'St. Anns Chapel',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8767231,
        LOCATION_LATITUDE_DEG: 50.3068805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001600',
        LOCATION_NAME: 'St. Anns Wells',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3489864,
        LOCATION_LATITUDE_DEG: 53.2330679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001700',
        LOCATION_NAME: 'St. Anthonys',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5555899,
        LOCATION_LATITUDE_DEG: 54.9637997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001800',
        LOCATION_NAME: 'St. Arvans',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6975283,
        LOCATION_LATITUDE_DEG: 51.6653893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST001900',
        LOCATION_NAME: 'St. Asaph',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4474046,
        LOCATION_LATITUDE_DEG: 53.2560571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002000',
        LOCATION_NAME: 'St. Athan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4129581,
        LOCATION_LATITUDE_DEG: 51.4014713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002100',
        LOCATION_NAME: 'St. Austell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7913584,
        LOCATION_LATITUDE_DEG: 50.3367909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002200',
        LOCATION_NAME: 'St. Bees',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5881811,
        LOCATION_LATITUDE_DEG: 54.4891786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002300',
        LOCATION_NAME: 'St. Blazey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7152107,
        LOCATION_LATITUDE_DEG: 50.3610855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002400',
        LOCATION_NAME: 'St. Blazey Gate',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7273524,
        LOCATION_LATITUDE_DEG: 50.3503837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002500',
        LOCATION_NAME: 'St. Boswells',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6426771,
        LOCATION_LATITUDE_DEG: 55.571973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002600',
        LOCATION_NAME: 'ST. BRELADE',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1998915,
        LOCATION_LATITUDE_DEG: 49.1916446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002700',
        LOCATION_NAME: 'St. Breock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8525801,
        LOCATION_LATITUDE_DEG: 50.5107041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002800',
        LOCATION_NAME: 'St. Breward',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6885309,
        LOCATION_LATITUDE_DEG: 50.5573054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST002900',
        LOCATION_NAME: 'St. Briavels',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6387151,
        LOCATION_LATITUDE_DEG: 51.7371948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003000',
        LOCATION_NAME: 'St. Brides',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.192097,
        LOCATION_LATITUDE_DEG: 51.7502271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003100',
        LOCATION_NAME: 'St. Brides Major',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5914999,
        LOCATION_LATITUDE_DEG: 51.4592852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003200',
        LOCATION_NAME: 'St. Brides Netherwent',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8249691,
        LOCATION_LATITUDE_DEG: 51.6071911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003300',
        LOCATION_NAME: 'St. Brides Wentlooge',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0175486,
        LOCATION_LATITUDE_DEG: 51.533783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003400',
        LOCATION_NAME: 'St. Brides-super-Ely',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3016827,
        LOCATION_LATITUDE_DEG: 51.4913782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003500',
        LOCATION_NAME: 'St. Budeaux',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1949189,
        LOCATION_LATITUDE_DEG: 50.4049886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003600',
        LOCATION_NAME: 'St. Buryan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6213636,
        LOCATION_LATITUDE_DEG: 50.0739725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003700',
        LOCATION_NAME: 'St. Catherine',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3204249,
        LOCATION_LATITUDE_DEG: 51.4309622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003800',
        LOCATION_NAME: "St. Catherine's",
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.029106,
        LOCATION_LATITUDE_DEG: 56.2221564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990760',
        LOCATION_NAME: "St. Catherine's Hill",
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004000',
        LOCATION_NAME: 'St. Clears',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4975393,
        LOCATION_LATITUDE_DEG: 51.8189273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004100',
        LOCATION_NAME: 'St. Cleer',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4695296,
        LOCATION_LATITUDE_DEG: 50.4861003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004200',
        LOCATION_NAME: 'St. Clement',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0167612,
        LOCATION_LATITUDE_DEG: 50.2545775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004300',
        LOCATION_NAME: 'ST. CLEMENT',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0558075,
        LOCATION_LATITUDE_DEG: 49.1773744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004500',
        LOCATION_NAME: 'St. Clether',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5344113,
        LOCATION_LATITUDE_DEG: 50.629409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004600',
        LOCATION_NAME: 'St. Columb',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9418227,
        LOCATION_LATITUDE_DEG: 50.4314009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004700',
        LOCATION_NAME: 'St. Columb Minor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0417922,
        LOCATION_LATITUDE_DEG: 50.4207943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004800',
        LOCATION_NAME: 'St. Combs',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9099843,
        LOCATION_LATITUDE_DEG: 57.6570698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004900',
        LOCATION_NAME: 'St. Cross',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3259365,
        LOCATION_LATITUDE_DEG: 51.040315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005000',
        LOCATION_NAME: 'St. Cross South Elmham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3788458,
        LOCATION_LATITUDE_DEG: 52.4068056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005100',
        LOCATION_NAME: 'St. Cyrus',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4139759,
        LOCATION_LATITUDE_DEG: 56.7752836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005200',
        LOCATION_NAME: 'St. Davids',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.264873,
        LOCATION_LATITUDE_DEG: 51.8809362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005300',
        LOCATION_NAME: 'St. Day',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1832037,
        LOCATION_LATITUDE_DEG: 50.2383838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005400',
        LOCATION_NAME: 'St. Dennis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.882194,
        LOCATION_LATITUDE_DEG: 50.3827938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005500',
        LOCATION_NAME: 'St. Devereux',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8153589,
        LOCATION_LATITUDE_DEG: 51.96632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005600',
        LOCATION_NAME: 'St. Dials',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.035476,
        LOCATION_LATITUDE_DEG: 51.6469971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005700',
        LOCATION_NAME: 'St. Dogmaels',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.68144,
        LOCATION_LATITUDE_DEG: 52.0814541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005800',
        LOCATION_NAME: 'St. Dominick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2539558,
        LOCATION_LATITUDE_DEG: 50.4877957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST005900',
        LOCATION_NAME: "St. Donat's",
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.526839,
        LOCATION_LATITUDE_DEG: 51.4029746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006000',
        LOCATION_NAME: 'St. Dunstans',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0742993,
        LOCATION_LATITUDE_DEG: 51.2816065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006100',
        LOCATION_NAME: 'St. Endellion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8292839,
        LOCATION_LATITUDE_DEG: 50.5724105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006200',
        LOCATION_NAME: 'St. Erme',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0246468,
        LOCATION_LATITUDE_DEG: 50.3107906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006300',
        LOCATION_NAME: 'St. Erney Landrake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2910416,
        LOCATION_LATITUDE_DEG: 50.4102859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006400',
        LOCATION_NAME: 'St. Erth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4299958,
        LOCATION_LATITUDE_DEG: 50.164773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006500',
        LOCATION_NAME: 'St. Erth Praze',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3955816,
        LOCATION_LATITUDE_DEG: 50.1661722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006600',
        LOCATION_NAME: 'St. Ervan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9754509,
        LOCATION_LATITUDE_DEG: 50.4919006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006700',
        LOCATION_NAME: 'St. Eval',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9826922,
        LOCATION_LATITUDE_DEG: 50.4779056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006800',
        LOCATION_NAME: 'St. Ewe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8370938,
        LOCATION_LATITUDE_DEG: 50.2805804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST006900',
        LOCATION_NAME: 'St. Fagans',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2660395,
        LOCATION_LATITUDE_DEG: 51.4860848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007000',
        LOCATION_NAME: 'St. Fergus',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8347963,
        LOCATION_LATITUDE_DEG: 57.5584546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007100',
        LOCATION_NAME: 'St. Fillans',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1129951,
        LOCATION_LATITUDE_DEG: 56.3910637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007200',
        LOCATION_NAME: 'St. Florence',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.773837,
        LOCATION_LATITUDE_DEG: 51.6768138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007300',
        LOCATION_NAME: 'St. Fort',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9566124,
        LOCATION_LATITUDE_DEG: 56.4047554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007400',
        LOCATION_NAME: 'St. Gennys',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6234117,
        LOCATION_LATITUDE_DEG: 50.7433194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007500',
        LOCATION_NAME: 'St. George',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5385167,
        LOCATION_LATITUDE_DEG: 53.2686539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007600',
        LOCATION_NAME: 'St. George',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5328277,
        LOCATION_LATITUDE_DEG: 51.4596672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007700',
        LOCATION_NAME: 'St. Georges',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8980723,
        LOCATION_LATITUDE_DEG: 51.3606661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007800',
        LOCATION_NAME: 'St. Georges',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4371112,
        LOCATION_LATITUDE_DEG: 52.6980831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST007900',
        LOCATION_NAME: 'St. Georges Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4491476,
        LOCATION_LATITUDE_DEG: 51.3545355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990209',
        LOCATION_NAME: 'St. Georges-Super-Ely',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2970968,
        LOCATION_LATITUDE_DEG: 51.4790276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008000',
        LOCATION_NAME: 'St. Germans',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3069906,
        LOCATION_LATITUDE_DEG: 50.3931849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008250',
        LOCATION_NAME: 'St. Giles',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008263',
        LOCATION_NAME: 'St. Giles on the Heath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008275',
        LOCATION_NAME: 'St. Giles-on-the-Heath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3303347,
        LOCATION_LATITUDE_DEG: 50.6977626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008300',
        LOCATION_NAME: 'St. Gluvias',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.125715,
        LOCATION_LATITUDE_DEG: 50.1776781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008400',
        LOCATION_NAME: 'St. Harmon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4832328,
        LOCATION_LATITUDE_DEG: 52.3421694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008500',
        LOCATION_NAME: 'St. Helen Auckland',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7108053,
        LOCATION_LATITUDE_DEG: 54.6351705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008700',
        LOCATION_NAME: 'St. Helens',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7380813,
        LOCATION_LATITUDE_DEG: 53.4545645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008600',
        LOCATION_NAME: 'St. Helens',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1130727,
        LOCATION_LATITUDE_DEG: 50.6979783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008800',
        LOCATION_NAME: 'St. Helier',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1078404,
        LOCATION_LATITUDE_DEG: 49.183194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008900',
        LOCATION_NAME: 'St. Hilary',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4271073,
        LOCATION_LATITUDE_DEG: 50.130677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009000',
        LOCATION_NAME: 'St. Hilary',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4148633,
        LOCATION_LATITUDE_DEG: 51.449679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009100',
        LOCATION_NAME: 'St. Ippolyts',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2574746,
        LOCATION_LATITUDE_DEG: 51.9295847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009250',
        LOCATION_NAME: 'St. Ishmaels',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1369208,
        LOCATION_LATITUDE_DEG: 51.7221735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009200',
        LOCATION_NAME: 'St. Ishmaels',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3690869,
        LOCATION_LATITUDE_DEG: 51.7450126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009300',
        LOCATION_NAME: 'St. Issey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9198521,
        LOCATION_LATITUDE_DEG: 50.5094039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009400',
        LOCATION_NAME: 'St. Ive',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.381107,
        LOCATION_LATITUDE_DEG: 50.4795958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009600',
        LOCATION_NAME: 'St. Ives',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4797053,
        LOCATION_LATITUDE_DEG: 50.2107816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009700',
        LOCATION_NAME: 'St. Ives',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8231843,
        LOCATION_LATITUDE_DEG: 50.8344049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009500',
        LOCATION_NAME: 'St. Ives',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0747685,
        LOCATION_LATITUDE_DEG: 52.3321236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009800',
        LOCATION_NAME: 'St. James',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5985455,
        LOCATION_LATITUDE_DEG: 51.4587747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST009900',
        LOCATION_NAME: 'St. James',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3750398,
        LOCATION_LATITUDE_DEG: 52.7318389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010000',
        LOCATION_NAME: 'St. James South Elmham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4090481,
        LOCATION_LATITUDE_DEG: 52.3781064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010100',
        LOCATION_NAME: 'St. John',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2372402,
        LOCATION_LATITUDE_DEG: 50.3600861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010200',
        LOCATION_NAME: 'ST. JOHN',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1372591,
        LOCATION_LATITUDE_DEG: 49.2459462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010550',
        LOCATION_NAME: 'St. Johns',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6387841,
        LOCATION_LATITUDE_DEG: 54.2038792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010300',
        LOCATION_NAME: 'St. Johns',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2346707,
        LOCATION_LATITUDE_DEG: 52.1856343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010400',
        LOCATION_NAME: 'St. Johns',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5868606,
        LOCATION_LATITUDE_DEG: 51.3107354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010500',
        LOCATION_NAME: 'St. Johns',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.149895,
        LOCATION_LATITUDE_DEG: 51.0623975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010600',
        LOCATION_NAME: 'St. Johns Chapel',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1792609,
        LOCATION_LATITUDE_DEG: 54.7363779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010700',
        LOCATION_NAME: 'St. Johns Fen End',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2758239,
        LOCATION_LATITUDE_DEG: 52.6793501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010900',
        LOCATION_NAME: 'St. Johns-in-the-Vale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0646233,
        LOCATION_LATITUDE_DEG: 54.5983797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011450',
        LOCATION_NAME: 'St. Judes',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4626142,
        LOCATION_LATITUDE_DEG: 54.3407127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011300',
        LOCATION_NAME: 'St. Judes',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1256144,
        LOCATION_LATITUDE_DEG: 50.3716798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011400',
        LOCATION_NAME: 'St. Judes',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5773419,
        LOCATION_LATITUDE_DEG: 51.457667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011500',
        LOCATION_NAME: 'St. Julians',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9681833,
        LOCATION_LATITUDE_DEG: 51.5951892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011600',
        LOCATION_NAME: 'St. Juliot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6525615,
        LOCATION_LATITUDE_DEG: 50.6954236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011700',
        LOCATION_NAME: 'St. Just',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6789039,
        LOCATION_LATITUDE_DEG: 50.1238722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011800',
        LOCATION_NAME: 'St. Just in Roseland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0091004,
        LOCATION_LATITUDE_DEG: 50.1808772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011900',
        LOCATION_NAME: 'St. Katherines',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3633373,
        LOCATION_LATITUDE_DEG: 57.4007447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012000',
        LOCATION_NAME: 'St. Keverne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0870164,
        LOCATION_LATITUDE_DEG: 50.0493646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012100',
        LOCATION_NAME: 'St. Kew',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7941999,
        LOCATION_LATITUDE_DEG: 50.5558058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012200',
        LOCATION_NAME: 'St. Kew Highway',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7769028,
        LOCATION_LATITUDE_DEG: 50.5455056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012300',
        LOCATION_NAME: 'St. Keyne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4761788,
        LOCATION_LATITUDE_DEG: 50.4225932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990161',
        LOCATION_NAME: 'St. Lawrence',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7520978,
        LOCATION_LATITUDE_DEG: 50.4642761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012600',
        LOCATION_NAME: 'ST. LAWRENCE',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1417131,
        LOCATION_LATITUDE_DEG: 49.2178013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012400',
        LOCATION_NAME: 'St. Lawrence',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2431848,
        LOCATION_LATITUDE_DEG: 50.5852746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012500',
        LOCATION_NAME: 'St. Lawrence',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8467357,
        LOCATION_LATITUDE_DEG: 51.7071528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012700',
        LOCATION_NAME: 'St. Lawrence',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4049296,
        LOCATION_LATITUDE_DEG: 51.3357017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012900',
        LOCATION_NAME: 'St. Leonards',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5174478,
        LOCATION_LATITUDE_DEG: 50.7176128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013000',
        LOCATION_NAME: 'St. Leonards',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'BH24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.838973,
        LOCATION_LATITUDE_DEG: 50.8273049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013100',
        LOCATION_NAME: 'St. Leonards',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6810084,
        LOCATION_LATITUDE_DEG: 51.7551793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013200',
        LOCATION_NAME: 'St. Leonards-on-Sea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5542473,
        LOCATION_LATITUDE_DEG: 50.8550762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013300',
        LOCATION_NAME: 'St. Levan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6584251,
        LOCATION_LATITUDE_DEG: 50.0401644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013400',
        LOCATION_NAME: 'St. Loyes',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4962591,
        LOCATION_LATITUDE_DEG: 50.7178058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013500',
        LOCATION_NAME: "St. Lythan's",
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2791653,
        LOCATION_LATITUDE_DEG: 51.4506806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990163',
        LOCATION_NAME: 'St. Mabby',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013600',
        LOCATION_NAME: 'St. Mabyn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7634245,
        LOCATION_LATITUDE_DEG: 50.5253066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013700',
        LOCATION_NAME: 'St. Madoes',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3031557,
        LOCATION_LATITUDE_DEG: 56.3753594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013800',
        LOCATION_NAME: 'St. Margaret South Elmham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4022911,
        LOCATION_LATITUDE_DEG: 52.4047112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014000',
        LOCATION_NAME: 'St. Margarets Bay',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3893682,
        LOCATION_LATITUDE_DEG: 51.1528899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014100',
        LOCATION_NAME: 'St. Margarets Hope',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9592007,
        LOCATION_LATITUDE_DEG: 58.8262979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014200',
        LOCATION_NAME: 'St. Margarets-at-Cliffe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3745693,
        LOCATION_LATITUDE_DEG: 51.1525895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990540',
        LOCATION_NAME: 'St. Marks',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014300',
        LOCATION_NAME: 'St. Marks',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1130949,
        LOCATION_LATITUDE_DEG: 51.8975042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014700',
        LOCATION_NAME: 'St. Martin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1656294,
        LOCATION_LATITUDE_DEG: 50.0661661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014600',
        LOCATION_NAME: 'St. Martin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4449544,
        LOCATION_LATITUDE_DEG: 50.3696843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014400',
        LOCATION_NAME: 'St. Martin',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5553469,
        LOCATION_LATITUDE_DEG: 49.4382041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014500',
        LOCATION_NAME: 'ST. MARTIN',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0514731,
        LOCATION_LATITUDE_DEG: 49.2187494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014900',
        LOCATION_NAME: 'St. Martins',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3714625,
        LOCATION_LATITUDE_DEG: 56.4586699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015200',
        LOCATION_NAME: 'St. Martins',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0047899,
        LOCATION_LATITUDE_DEG: 52.9251121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST014800',
        LOCATION_NAME: 'St. Martins',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7176346,
        LOCATION_LATITUDE_DEG: 52.0473256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015000',
        LOCATION_NAME: 'St. Martins',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7534647,
        LOCATION_LATITUDE_DEG: 54.4061438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015100',
        LOCATION_NAME: 'St. Martins',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4747099,
        LOCATION_LATITUDE_DEG: 52.647661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015250',
        LOCATION_NAME: "St. Martin's",
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2853769,
        LOCATION_LATITUDE_DEG: 49.965407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015300',
        LOCATION_NAME: 'ST. MARY',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1699963,
        LOCATION_LATITUDE_DEG: 49.2357102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015400',
        LOCATION_NAME: 'St. Mary Bourne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3950753,
        LOCATION_LATITUDE_DEG: 51.2506386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015500',
        LOCATION_NAME: 'St. Mary Church',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4394427,
        LOCATION_LATITUDE_DEG: 51.433075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015600',
        LOCATION_NAME: 'St. Mary Cray',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1151867,
        LOCATION_LATITUDE_DEG: 51.3861313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015700',
        LOCATION_NAME: 'St. Mary Hill',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4949931,
        LOCATION_LATITUDE_DEG: 51.4955842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015800',
        LOCATION_NAME: 'St. Mary Hoo',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5998359,
        LOCATION_LATITUDE_DEG: 51.4558259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST015900',
        LOCATION_NAME: 'St. Mary in the Marsh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9439767,
        LOCATION_LATITUDE_DEG: 51.0132833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016200',
        LOCATION_NAME: 'St. Marychurch',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5198113,
        LOCATION_LATITUDE_DEG: 50.4823847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016250',
        LOCATION_NAME: "St. Mary's",
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.298604,
        LOCATION_LATITUDE_DEG: 49.9264719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016000',
        LOCATION_NAME: "St. Mary's",
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9148298,
        LOCATION_LATITUDE_DEG: 58.8962049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016300',
        LOCATION_NAME: 'St. Marys Bay',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.981542,
        LOCATION_LATITUDE_DEG: 51.0088846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016400',
        LOCATION_NAME: 'St. Marys Island',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5415438,
        LOCATION_LATITUDE_DEG: 51.4066272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016100',
        LOCATION_NAME: "St. Mary's Isle",
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0668758,
        LOCATION_LATITUDE_DEG: 54.8190078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016500',
        LOCATION_NAME: 'St. Maughans',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7828638,
        LOCATION_LATITUDE_DEG: 51.8499132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016600',
        LOCATION_NAME: 'St. Mawes',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0141758,
        LOCATION_LATITUDE_DEG: 50.1575698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016700',
        LOCATION_NAME: 'St. Mawgan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9973537,
        LOCATION_LATITUDE_DEG: 50.4544978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016800',
        LOCATION_NAME: 'St. Mellion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2698227,
        LOCATION_LATITUDE_DEG: 50.4672926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST016900',
        LOCATION_NAME: 'St. Mellons',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1114912,
        LOCATION_LATITUDE_DEG: 51.5166805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017000',
        LOCATION_NAME: 'St. Merryn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9898293,
        LOCATION_LATITUDE_DEG: 50.5255021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017100',
        LOCATION_NAME: 'St. Mewan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8137607,
        LOCATION_LATITUDE_DEG: 50.3307898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017200',
        LOCATION_NAME: 'St. Michael Penkivel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0033581,
        LOCATION_LATITUDE_DEG: 50.2393787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017300',
        LOCATION_NAME: 'St. Michael South Elmham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4370346,
        LOCATION_LATITUDE_DEG: 52.4057111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017500',
        LOCATION_NAME: 'St. Michaels',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9111081,
        LOCATION_LATITUDE_DEG: 56.3953576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017600',
        LOCATION_NAME: 'St. Michaels',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8172858,
        LOCATION_LATITUDE_DEG: 53.8659026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017700',
        LOCATION_NAME: 'St. Michaels',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6131803,
        LOCATION_LATITUDE_DEG: 52.2893492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017400',
        LOCATION_NAME: 'St. Michaels',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6926483,
        LOCATION_LATITUDE_DEG: 51.0849883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017800',
        LOCATION_NAME: 'St. Mildreds',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0774888,
        LOCATION_LATITUDE_DEG: 51.2761072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST017900',
        LOCATION_NAME: 'St. Minver',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8726273,
        LOCATION_LATITUDE_DEG: 50.5583043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018000',
        LOCATION_NAME: 'St. Monans',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7640188,
        LOCATION_LATITUDE_DEG: 56.2062332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018200',
        LOCATION_NAME: 'St. Mungo',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3636865,
        LOCATION_LATITUDE_DEG: 55.0676265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018300',
        LOCATION_NAME: 'St. Neot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5579577,
        LOCATION_LATITUDE_DEG: 50.4817967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018400',
        LOCATION_NAME: 'St. Neot Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5724647,
        LOCATION_LATITUDE_DEG: 50.4714015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018500',
        LOCATION_NAME: 'St. Neots',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2643764,
        LOCATION_LATITUDE_DEG: 52.228116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990708',
        LOCATION_NAME: 'St. Newlyn East',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018700',
        LOCATION_NAME: 'St. Nicholas',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0562879,
        LOCATION_LATITUDE_DEG: 51.9785438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018600',
        LOCATION_NAME: 'St. Nicholas',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.308661,
        LOCATION_LATITUDE_DEG: 51.4598788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018900',
        LOCATION_NAME: 'St. Nicholas at Wade',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2541443,
        LOCATION_LATITUDE_DEG: 51.3533061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018800',
        LOCATION_NAME: 'St. Nicholas South Elmham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.413082,
        LOCATION_LATITUDE_DEG: 52.3938035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019000',
        LOCATION_NAME: 'St. Ninians',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.934338,
        LOCATION_LATITUDE_DEG: 56.1030325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019100',
        LOCATION_NAME: 'St. Ola',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9619055,
        LOCATION_LATITUDE_DEG: 58.9757145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019200',
        LOCATION_NAME: 'St. Olaves',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6273777,
        LOCATION_LATITUDE_DEG: 52.5367155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019300',
        LOCATION_NAME: 'St. Osyth',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0794176,
        LOCATION_LATITUDE_DEG: 51.7987513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019400',
        LOCATION_NAME: 'ST. OUEN',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2019427,
        LOCATION_LATITUDE_DEG: 49.2335897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019500',
        LOCATION_NAME: 'St. Owens Cross',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6700053,
        LOCATION_LATITUDE_DEG: 51.9195163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019700',
        LOCATION_NAME: 'St. Pauls',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5800506,
        LOCATION_LATITUDE_DEG: 51.4612687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019800',
        LOCATION_NAME: 'St. Pauls Cray',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1055487,
        LOCATION_LATITUDE_DEG: 51.4041311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019900',
        LOCATION_NAME: 'St. Pauls Walden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2652448,
        LOCATION_LATITUDE_DEG: 51.8853827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020000',
        LOCATION_NAME: 'ST. PETER',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1824441,
        LOCATION_LATITUDE_DEG: 49.213588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020100',
        LOCATION_NAME: 'St. Peter Port',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5357673,
        LOCATION_LATITUDE_DEG: 49.4567467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020200',
        LOCATION_NAME: 'St. Peter South Elmham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4361998,
        LOCATION_LATITUDE_DEG: 52.4135073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020400',
        LOCATION_NAME: 'St. Peters',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3594041,
        LOCATION_LATITUDE_DEG: 51.8549233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020300',
        LOCATION_NAME: 'St. Peters',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4209359,
        LOCATION_LATITUDE_DEG: 51.3645087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020500',
        LOCATION_NAME: 'St. Petrox',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9336999,
        LOCATION_LATITUDE_DEG: 51.6395106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020600',
        LOCATION_NAME: 'St. Philips',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5739384,
        LOCATION_LATITUDE_DEG: 51.4502737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020700',
        LOCATION_NAME: 'St. Philips Marsh',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5671411,
        LOCATION_LATITUDE_DEG: 51.4464669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020800',
        LOCATION_NAME: 'St. Phillans',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'PA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8838446,
        LOCATION_LATITUDE_DEG: 55.833919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST020900',
        LOCATION_NAME: 'St. Pierre Du Bois',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6372963,
        LOCATION_LATITUDE_DEG: 49.4484325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021000',
        LOCATION_NAME: 'St. Pinnock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5325882,
        LOCATION_LATITUDE_DEG: 50.4423925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021100',
        LOCATION_NAME: 'St. Quivox',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5720565,
        LOCATION_LATITUDE_DEG: 55.4810842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021200',
        LOCATION_NAME: 'St. Sampson',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5190766,
        LOCATION_LATITUDE_DEG: 49.483558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021300',
        LOCATION_NAME: 'St. Saviour',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6313622,
        LOCATION_LATITUDE_DEG: 49.4515686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021350',
        LOCATION_NAME: 'ST. SAVIOUR',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0907807,
        LOCATION_LATITUDE_DEG: 49.1975394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021400',
        LOCATION_NAME: 'St. Stephen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8894466,
        LOCATION_LATITUDE_DEG: 50.3437853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021600',
        LOCATION_NAME: 'St. Stephens',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3895434,
        LOCATION_LATITUDE_DEG: 50.6480156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021500',
        LOCATION_NAME: 'St. Stephens',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2283947,
        LOCATION_LATITUDE_DEG: 50.4032904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021700',
        LOCATION_NAME: 'St. Teath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7352124,
        LOCATION_LATITUDE_DEG: 50.592813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021800',
        LOCATION_NAME: 'St. Thomas',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9272663,
        LOCATION_LATITUDE_DEG: 51.6232983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST021900',
        LOCATION_NAME: 'St. Thomas',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5470525,
        LOCATION_LATITUDE_DEG: 50.7213071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022000',
        LOCATION_NAME: 'St. Tudy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7301755,
        LOCATION_LATITUDE_DEG: 50.5551034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022100',
        LOCATION_NAME: 'St. Twynnells',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.963997,
        LOCATION_LATITUDE_DEG: 51.63901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022200',
        LOCATION_NAME: 'St. Veep',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6161199,
        LOCATION_LATITUDE_DEG: 50.3648875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022300',
        LOCATION_NAME: 'St. Vigeans',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5897926,
        LOCATION_LATITUDE_DEG: 56.5763682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022400',
        LOCATION_NAME: 'St. Wenn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8608235,
        LOCATION_LATITUDE_DEG: 50.4486978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022500',
        LOCATION_NAME: 'St. Weonards',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7338623,
        LOCATION_LATITUDE_DEG: 51.9143157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022600',
        LOCATION_NAME: 'St. Werburghs',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5705439,
        LOCATION_LATITUDE_DEG: 51.4700741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022700',
        LOCATION_NAME: 'St. Winnolls',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3312617,
        LOCATION_LATITUDE_DEG: 50.3721818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023000',
        LOCATION_NAME: 'Stableford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3563765,
        LOCATION_LATITUDE_DEG: 52.5829742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023100',
        LOCATION_NAME: 'Stableford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2770423,
        LOCATION_LATITUDE_DEG: 52.9455077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023200',
        LOCATION_NAME: 'Stacey Bushes',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8029554,
        LOCATION_LATITUDE_DEG: 52.0510021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023400',
        LOCATION_NAME: 'Stackhouse',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2843429,
        LOCATION_LATITUDE_DEG: 54.0844206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023500',
        LOCATION_NAME: 'Stackpole',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9137592,
        LOCATION_LATITUDE_DEG: 51.6295104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023600',
        LOCATION_NAME: 'Stacksteads',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2231657,
        LOCATION_LATITUDE_DEG: 53.6912763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023700',
        LOCATION_NAME: 'Staddiscombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0875241,
        LOCATION_LATITUDE_DEG: 50.3424783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023800',
        LOCATION_NAME: 'Staddlebridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.319318,
        LOCATION_LATITUDE_DEG: 54.3841368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023900',
        LOCATION_NAME: 'Stadhampton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1298326,
        LOCATION_LATITUDE_DEG: 51.6808732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024000',
        LOCATION_NAME: 'Staffield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7093929,
        LOCATION_LATITUDE_DEG: 54.7790959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024100',
        LOCATION_NAME: 'Staffin',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2050902,
        LOCATION_LATITUDE_DEG: 57.6263121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024200',
        LOCATION_NAME: 'Stafford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.11575,
        LOCATION_LATITUDE_DEG: 52.806297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024300',
        LOCATION_NAME: 'Stafford Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0646167,
        LOCATION_LATITUDE_DEG: 50.741506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024400',
        LOCATION_NAME: 'Stag Batch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.774535,
        LOCATION_LATITUDE_DEG: 52.2214411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024500',
        LOCATION_NAME: 'Stagsden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5637831,
        LOCATION_LATITUDE_DEG: 52.1310138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024550',
        LOCATION_NAME: 'Stainborough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5085455,
        LOCATION_LATITUDE_DEG: 53.5301772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024600',
        LOCATION_NAME: 'Stainburn',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.519287,
        LOCATION_LATITUDE_DEG: 54.6476934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024700',
        LOCATION_NAME: 'Stainburn',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6233162,
        LOCATION_LATITUDE_DEG: 53.9306929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024800',
        LOCATION_NAME: 'Stainby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6570419,
        LOCATION_LATITUDE_DEG: 52.7953741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST024900',
        LOCATION_NAME: 'Staincliffe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6523535,
        LOCATION_LATITUDE_DEG: 53.7079784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025000',
        LOCATION_NAME: 'Staincross',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5058368,
        LOCATION_LATITUDE_DEG: 53.586566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025100',
        LOCATION_NAME: 'Staindrop',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7989879,
        LOCATION_LATITUDE_DEG: 54.5804604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025200',
        LOCATION_NAME: 'Staines',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5072453,
        LOCATION_LATITUDE_DEG: 51.4345396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025300',
        LOCATION_NAME: 'Staines Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1151209,
        LOCATION_LATITUDE_DEG: 51.7884743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990437',
        LOCATION_NAME: 'Staines-upon-Thames',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.508658,
        LOCATION_LATITUDE_DEG: 51.4282713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025500',
        LOCATION_NAME: 'Stainfield',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3970448,
        LOCATION_LATITUDE_DEG: 52.8121704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025400',
        LOCATION_NAME: 'Stainfield',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3375432,
        LOCATION_LATITUDE_DEG: 53.2436136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025700',
        LOCATION_NAME: 'Stainforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2750492,
        LOCATION_LATITUDE_DEG: 54.1008195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025600',
        LOCATION_NAME: 'Stainforth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0304383,
        LOCATION_LATITUDE_DEG: 53.5999564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025800',
        LOCATION_NAME: 'Staining',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.991508,
        LOCATION_LATITUDE_DEG: 53.8185013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST025900',
        LOCATION_NAME: 'Stainland',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8823783,
        LOCATION_LATITUDE_DEG: 53.6707783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026000',
        LOCATION_NAME: 'Stainsacre',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5906463,
        LOCATION_LATITUDE_DEG: 54.4623349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026200',
        LOCATION_NAME: 'Stainton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9677761,
        LOCATION_LATITUDE_DEG: 54.9033112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026600',
        LOCATION_NAME: 'Stainton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7970377,
        LOCATION_LATITUDE_DEG: 54.6449821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026700',
        LOCATION_NAME: 'Stainton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7269505,
        LOCATION_LATITUDE_DEG: 54.2677453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026500',
        LOCATION_NAME: 'Stainton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8877297,
        LOCATION_LATITUDE_DEG: 54.5624647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026400',
        LOCATION_NAME: 'Stainton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8402963,
        LOCATION_LATITUDE_DEG: 54.3638388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026300',
        LOCATION_NAME: 'Stainton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2581515,
        LOCATION_LATITUDE_DEG: 54.5197512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026100',
        LOCATION_NAME: 'Stainton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1661273,
        LOCATION_LATITUDE_DEG: 53.4369436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027000',
        LOCATION_NAME: 'Stainton by Langworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4052803,
        LOCATION_LATITUDE_DEG: 53.2866161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026800',
        LOCATION_NAME: 'Stainton Grove',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8896187,
        LOCATION_LATITUDE_DEG: 54.5559592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027100',
        LOCATION_NAME: 'Stainton le Vale',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2323928,
        LOCATION_LATITUDE_DEG: 53.4322317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST026900',
        LOCATION_NAME: 'Stainton With Adgarley',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1501108,
        LOCATION_LATITUDE_DEG: 54.1423361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027200',
        LOCATION_NAME: 'Staintondale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4755562,
        LOCATION_LATITUDE_DEG: 54.3725208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027400',
        LOCATION_NAME: 'Stair',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4701368,
        LOCATION_LATITUDE_DEG: 55.4796781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027300',
        LOCATION_NAME: 'Stair',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1800512,
        LOCATION_LATITUDE_DEG: 54.5807797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027500',
        LOCATION_NAME: 'Stairfoot',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4323979,
        LOCATION_LATITUDE_DEG: 53.5447537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027600',
        LOCATION_NAME: 'Staithes',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7914803,
        LOCATION_LATITUDE_DEG: 54.5581444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027700',
        LOCATION_NAME: 'Stakeford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5762723,
        LOCATION_LATITUDE_DEG: 55.1638119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027800',
        LOCATION_NAME: 'Stakepool',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8944628,
        LOCATION_LATITUDE_DEG: 53.9254091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST027900',
        LOCATION_NAME: 'Stalbridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3773157,
        LOCATION_LATITUDE_DEG: 50.9587224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028000',
        LOCATION_NAME: 'Stalbridge Weston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3930687,
        LOCATION_LATITUDE_DEG: 50.9490205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028100',
        LOCATION_NAME: 'Stalham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5203026,
        LOCATION_LATITUDE_DEG: 52.7706438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028200',
        LOCATION_NAME: 'Stalisfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7961572,
        LOCATION_LATITUDE_DEG: 51.2333541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028300',
        LOCATION_NAME: 'Stallingborough',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1828237,
        LOCATION_LATITUDE_DEG: 53.5864436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028400',
        LOCATION_NAME: 'Stalmine',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9517381,
        LOCATION_LATITUDE_DEG: 53.9010126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028500',
        LOCATION_NAME: 'Stalybridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0495236,
        LOCATION_LATITUDE_DEG: 53.483362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028600',
        LOCATION_NAME: 'Stambourne',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5070932,
        LOCATION_LATITUDE_DEG: 52.0209881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028800',
        LOCATION_NAME: 'Stamford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6484855,
        LOCATION_LATITUDE_DEG: 55.4665466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028700',
        LOCATION_NAME: 'Stamford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4784801,
        LOCATION_LATITUDE_DEG: 52.6510544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST028900',
        LOCATION_NAME: 'Stamford Bridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7969763,
        LOCATION_LATITUDE_DEG: 53.2010376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029000',
        LOCATION_NAME: 'Stamford Bridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9121108,
        LOCATION_LATITUDE_DEG: 53.9908906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029100',
        LOCATION_NAME: 'Stamford Hill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5220499,
        LOCATION_LATITUDE_DEG: 50.8346289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029200',
        LOCATION_NAME: 'Stamfordham',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8767174,
        LOCATION_LATITUDE_DEG: 55.0430076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029300',
        LOCATION_NAME: 'Stamperland',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2659197,
        LOCATION_LATITUDE_DEG: 55.7956138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029400',
        LOCATION_NAME: 'Stamshaw',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0895269,
        LOCATION_LATITUDE_DEG: 50.8197897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029600',
        LOCATION_NAME: 'Stanborough',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.22762,
        LOCATION_LATITUDE_DEG: 51.7870679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029700',
        LOCATION_NAME: 'Stanbridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9957819,
        LOCATION_LATITUDE_DEG: 50.8346018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029800',
        LOCATION_NAME: 'Stanbridge',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5965386,
        LOCATION_LATITUDE_DEG: 51.9080919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029900',
        LOCATION_NAME: 'Stanbury',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9852759,
        LOCATION_LATITUDE_DEG: 53.8294925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030000',
        LOCATION_NAME: 'Stancil',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0825938,
        LOCATION_LATITUDE_DEG: 53.4575474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030100',
        LOCATION_NAME: 'Stancombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3754179,
        LOCATION_LATITUDE_DEG: 51.672085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030200',
        LOCATION_NAME: 'Stand',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9744374,
        LOCATION_LATITUDE_DEG: 55.8975132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030300',
        LOCATION_NAME: 'Standburn',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7108974,
        LOCATION_LATITUDE_DEG: 55.9563163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030400',
        LOCATION_NAME: 'Standeford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1301254,
        LOCATION_LATITUDE_DEG: 52.6667836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030500',
        LOCATION_NAME: 'Standerwick',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2678228,
        LOCATION_LATITUDE_DEG: 51.2550427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030600',
        LOCATION_NAME: 'Standford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.836068,
        LOCATION_LATITUDE_DEG: 51.1028172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030700',
        LOCATION_NAME: 'Standford Bridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4423231,
        LOCATION_LATITUDE_DEG: 52.8138995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030900',
        LOCATION_NAME: 'Standish',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6626433,
        LOCATION_LATITUDE_DEG: 53.586273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST030800',
        LOCATION_NAME: 'Standish',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2886993,
        LOCATION_LATITUDE_DEG: 51.7741937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031000',
        LOCATION_NAME: 'Standish Lower Ground',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6680871,
        LOCATION_LATITUDE_DEG: 53.5616743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031100',
        LOCATION_NAME: 'Standish Park',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2581102,
        LOCATION_LATITUDE_DEG: 51.7708928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031200',
        LOCATION_NAME: 'Standlake',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4228009,
        LOCATION_LATITUDE_DEG: 51.7265785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031300',
        LOCATION_NAME: 'Standon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2678754,
        LOCATION_LATITUDE_DEG: 52.9120037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031400',
        LOCATION_NAME: 'Standon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0207314,
        LOCATION_LATITUDE_DEG: 51.8834799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031500',
        LOCATION_NAME: 'Stane',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.784337,
        LOCATION_LATITUDE_DEG: 55.8149075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031600',
        LOCATION_NAME: 'Stanecastle',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6585761,
        LOCATION_LATITUDE_DEG: 55.6263006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031700',
        LOCATION_NAME: 'Stanfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.874384,
        LOCATION_LATITUDE_DEG: 52.7495472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031800',
        LOCATION_NAME: 'Stanford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9826595,
        LOCATION_LATITUDE_DEG: 52.708294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST031900',
        LOCATION_NAME: 'Stanford',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3016568,
        LOCATION_LATITUDE_DEG: 52.054195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032000',
        LOCATION_NAME: 'Stanford',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.041747,
        LOCATION_LATITUDE_DEG: 51.1022916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032100',
        LOCATION_NAME: 'Stanford Bishop',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4654557,
        LOCATION_LATITUDE_DEG: 52.1636397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032200',
        LOCATION_NAME: 'Stanford Bridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4159069,
        LOCATION_LATITUDE_DEG: 52.2893455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032300',
        LOCATION_NAME: 'Stanford Dingley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1731332,
        LOCATION_LATITUDE_DEG: 51.4427556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032400',
        LOCATION_NAME: 'Stanford Hall',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1353597,
        LOCATION_LATITUDE_DEG: 52.4092416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032600',
        LOCATION_NAME: 'Stanford in the Vale',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5048101,
        LOCATION_LATITUDE_DEG: 51.6395744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120800',
        LOCATION_NAME: 'Stanford le Hope',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032700',
        LOCATION_NAME: 'Stanford on Avon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1343627,
        LOCATION_LATITUDE_DEG: 52.4038395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032800',
        LOCATION_NAME: 'Stanford on Soar',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1933584,
        LOCATION_LATITUDE_DEG: 52.7920771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032500',
        LOCATION_NAME: 'Stanford Rivers',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2190039,
        LOCATION_LATITUDE_DEG: 51.6847533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST032900',
        LOCATION_NAME: 'Stanford-le-Hope',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.428759,
        LOCATION_LATITUDE_DEG: 51.5136335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033000',
        LOCATION_NAME: 'Stanfree',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2832036,
        LOCATION_LATITUDE_DEG: 53.2609263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033100',
        LOCATION_NAME: 'Stanground',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2211624,
        LOCATION_LATITUDE_DEG: 52.5548442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033200',
        LOCATION_NAME: 'Stanhoe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6829421,
        LOCATION_LATITUDE_DEG: 52.9001645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033300',
        LOCATION_NAME: 'Stanhope',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0050804,
        LOCATION_LATITUDE_DEG: 54.7471786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033400',
        LOCATION_NAME: 'Stanion',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6533702,
        LOCATION_LATITUDE_DEG: 52.4717401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033500',
        LOCATION_NAME: 'Stank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1755185,
        LOCATION_LATITUDE_DEG: 54.1269351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034200',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4453297,
        LOCATION_LATITUDE_DEG: 56.4805668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034000',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9221231,
        LOCATION_LATITUDE_DEG: 53.4117615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033800',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1043002,
        LOCATION_LATITUDE_DEG: 53.0677191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033900',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0676896,
        LOCATION_LATITUDE_DEG: 51.4520635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033700',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.739306,
        LOCATION_LATITUDE_DEG: 54.7357089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST033600',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6946766,
        LOCATION_LATITUDE_DEG: 54.872593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034100',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.470436,
        LOCATION_LATITUDE_DEG: 53.7123734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034300',
        LOCATION_NAME: 'Stanley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3781267,
        LOCATION_LATITUDE_DEG: 52.9583996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034400',
        LOCATION_NAME: 'Stanley Common',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3789906,
        LOCATION_LATITUDE_DEG: 52.9750004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034500',
        LOCATION_NAME: 'Stanley Downton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2879112,
        LOCATION_LATITUDE_DEG: 51.7368962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034600',
        LOCATION_NAME: 'Stanley Ferry',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4678057,
        LOCATION_LATITUDE_DEG: 53.7010712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034700',
        LOCATION_NAME: 'Stanley Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9619351,
        LOCATION_LATITUDE_DEG: 53.435064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034800',
        LOCATION_NAME: 'Stanley Pontlarge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0015868,
        LOCATION_LATITUDE_DEG: 51.9696102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST034900',
        LOCATION_NAME: 'Stanleytown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4271212,
        LOCATION_LATITUDE_DEG: 51.6421978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035000',
        LOCATION_NAME: 'Stanmer',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1134548,
        LOCATION_LATITUDE_DEG: 50.8682793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990361',
        LOCATION_NAME: 'Stanmer Park',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035100',
        LOCATION_NAME: 'Stanmore',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4031103,
        LOCATION_LATITUDE_DEG: 52.5300745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035200',
        LOCATION_NAME: 'Stanmore',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3113679,
        LOCATION_LATITUDE_DEG: 51.6166585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035300',
        LOCATION_NAME: 'Stanner',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0799761,
        LOCATION_LATITUDE_DEG: 52.2168473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035400',
        LOCATION_NAME: 'Stannergate',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9301052,
        LOCATION_LATITUDE_DEG: 56.4687635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035500',
        LOCATION_NAME: 'Stannersburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4366046,
        LOCATION_LATITUDE_DEG: 55.1728255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035600',
        LOCATION_NAME: 'Stanningfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7480142,
        LOCATION_LATITUDE_DEG: 52.1726939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035700',
        LOCATION_NAME: 'Stanningley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6623802,
        LOCATION_LATITUDE_DEG: 53.8048828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035900',
        LOCATION_NAME: 'Stannington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6674546,
        LOCATION_LATITUDE_DEG: 55.108312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST035800',
        LOCATION_NAME: 'Stannington',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5433142,
        LOCATION_LATITUDE_DEG: 53.3934394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036000',
        LOCATION_NAME: 'Stansbatch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9533432,
        LOCATION_LATITUDE_DEG: 52.2447514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036100',
        LOCATION_NAME: 'Stansfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6067716,
        LOCATION_LATITUDE_DEG: 52.1357981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036200',
        LOCATION_NAME: 'Stanshope',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8093087,
        LOCATION_LATITUDE_DEG: 53.084918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036300',
        LOCATION_NAME: 'Stanstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6940217,
        LOCATION_LATITUDE_DEG: 52.1104876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036400',
        LOCATION_NAME: 'Stanstead Abbotts',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0159192,
        LOCATION_LATITUDE_DEG: 51.7849689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036500',
        LOCATION_NAME: 'Stansted',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9171554,
        LOCATION_LATITUDE_DEG: 50.8881993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036700',
        LOCATION_NAME: 'Stansted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1947886,
        LOCATION_LATITUDE_DEG: 51.9034741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036600',
        LOCATION_NAME: 'Stansted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3067786,
        LOCATION_LATITUDE_DEG: 51.3351237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST991097',
        LOCATION_NAME: 'Stansted Mountfitchet',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.202641,
        LOCATION_LATITUDE_DEG: 51.904949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036800',
        LOCATION_NAME: 'Stansted Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9254061,
        LOCATION_LATITUDE_DEG: 50.8898944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST036900',
        LOCATION_NAME: 'Stansty',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0114389,
        LOCATION_LATITUDE_DEG: 53.0615332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037400',
        LOCATION_NAME: 'Stanton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8997879,
        LOCATION_LATITUDE_DEG: 52.006218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037200',
        LOCATION_NAME: 'Stanton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8076946,
        LOCATION_LATITUDE_DEG: 53.0115107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037000',
        LOCATION_NAME: 'Stanton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7956422,
        LOCATION_LATITUDE_DEG: 55.1972243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037300',
        LOCATION_NAME: 'Stanton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5992425,
        LOCATION_LATITUDE_DEG: 52.7748841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037100',
        LOCATION_NAME: 'Stanton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8871204,
        LOCATION_LATITUDE_DEG: 52.323404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121300',
        LOCATION_NAME: 'Stanton by Bridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4475337,
        LOCATION_LATITUDE_DEG: 52.8428012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121400',
        LOCATION_NAME: 'Stanton by Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037500',
        LOCATION_NAME: 'Stanton Drew',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5787726,
        LOCATION_LATITUDE_DEG: 51.365862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037600',
        LOCATION_NAME: 'Stanton Fitzwarren',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.740474,
        LOCATION_LATITUDE_DEG: 51.610675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037700',
        LOCATION_NAME: 'Stanton Harcourt',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4002933,
        LOCATION_LATITUDE_DEG: 51.7488835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037800',
        LOCATION_NAME: 'Stanton Hill',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2757905,
        LOCATION_LATITUDE_DEG: 53.1405128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121500',
        LOCATION_NAME: 'Stanton in the Peak',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST037900',
        LOCATION_NAME: 'Stanton Lacy',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7415422,
        LOCATION_LATITUDE_DEG: 52.4044582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038000',
        LOCATION_NAME: 'Stanton Long',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6279544,
        LOCATION_LATITUDE_DEG: 52.5125696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121600',
        LOCATION_NAME: 'Stanton on the Wolds',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038100',
        LOCATION_NAME: 'Stanton Prior',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4610288,
        LOCATION_LATITUDE_DEG: 51.3629582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109000',
        LOCATION_NAME: 'Stanton St Bernard',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8685376,
        LOCATION_LATITUDE_DEG: 51.3610666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109100',
        LOCATION_NAME: 'Stanton St John',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109200',
        LOCATION_NAME: 'Stanton St Quintin',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038200',
        LOCATION_NAME: 'Stanton St. Bernard',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8669182,
        LOCATION_LATITUDE_DEG: 51.3597519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038300',
        LOCATION_NAME: 'Stanton St. John',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.162406,
        LOCATION_LATITUDE_DEG: 51.778983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038400',
        LOCATION_NAME: 'Stanton St. Quintin',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1327051,
        LOCATION_LATITUDE_DEG: 51.5175725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038600',
        LOCATION_NAME: 'Stanton under Bardon',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3089761,
        LOCATION_LATITUDE_DEG: 52.6895745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038700',
        LOCATION_NAME: 'Stanton upon Hine Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6406341,
        LOCATION_LATITUDE_DEG: 52.8113045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038500',
        LOCATION_NAME: 'Stanton Wick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5550901,
        LOCATION_LATITUDE_DEG: 51.3545557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039200',
        LOCATION_NAME: 'Stantonbury',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7712859,
        LOCATION_LATITUDE_DEG: 52.0618084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039300',
        LOCATION_NAME: 'Stantonbury Fields',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.765357,
        LOCATION_LATITUDE_DEG: 52.0599031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038800',
        LOCATION_NAME: 'Stanton-by-Bridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4482522,
        LOCATION_LATITUDE_DEG: 52.8411772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST038900',
        LOCATION_NAME: 'Stanton-by-Dale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3082469,
        LOCATION_LATITUDE_DEG: 52.9365981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039000',
        LOCATION_NAME: 'Stanton-in-the-Peak',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6381318,
        LOCATION_LATITUDE_DEG: 53.1722008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039100',
        LOCATION_NAME: 'Stanton-on-the-Wolds',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0571171,
        LOCATION_LATITUDE_DEG: 52.8687893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039350',
        LOCATION_NAME: 'Stanwardine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8692485,
        LOCATION_LATITUDE_DEG: 52.8100841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039500',
        LOCATION_NAME: 'Stanway',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6912855,
        LOCATION_LATITUDE_DEG: 52.5185734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039400',
        LOCATION_NAME: 'Stanway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9114229,
        LOCATION_LATITUDE_DEG: 51.9873087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039600',
        LOCATION_NAME: 'Stanway',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8198027,
        LOCATION_LATITUDE_DEG: 51.8834675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039700',
        LOCATION_NAME: 'Stanwell',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4782017,
        LOCATION_LATITUDE_DEG: 51.4568472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039800',
        LOCATION_NAME: 'Stanwell Moor',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5005635,
        LOCATION_LATITUDE_DEG: 51.4619467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST039900',
        LOCATION_NAME: 'Stanwick',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5620746,
        LOCATION_LATITUDE_DEG: 52.3317324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040000',
        LOCATION_NAME: 'Stanwix',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9318701,
        LOCATION_LATITUDE_DEG: 54.8999069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040100',
        LOCATION_NAME: 'Stape',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7805162,
        LOCATION_LATITUDE_DEG: 54.3323281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040200',
        LOCATION_NAME: 'Stapehill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9202497,
        LOCATION_LATITUDE_DEG: 50.8044012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040300',
        LOCATION_NAME: 'Stapeley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4802192,
        LOCATION_LATITUDE_DEG: 53.043619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040400',
        LOCATION_NAME: 'Stapenhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6187436,
        LOCATION_LATITUDE_DEG: 52.7928846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040500',
        LOCATION_NAME: 'Staple',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7065806,
        LOCATION_LATITUDE_DEG: 50.4418823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040600',
        LOCATION_NAME: 'Staple',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2494694,
        LOCATION_LATITUDE_DEG: 51.2637013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040700',
        LOCATION_NAME: 'Staple Fitzpaine',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0475696,
        LOCATION_LATITUDE_DEG: 50.9586271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990083',
        LOCATION_NAME: 'Staple Hill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4986239,
        LOCATION_LATITUDE_DEG: 51.4649165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040800',
        LOCATION_NAME: 'Staplecross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5377385,
        LOCATION_LATITUDE_DEG: 50.9730849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST040900',
        LOCATION_NAME: 'Staplefield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1795924,
        LOCATION_LATITUDE_DEG: 51.0377028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041500',
        LOCATION_NAME: 'Stapleford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9003979,
        LOCATION_LATITUDE_DEG: 51.1354303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041300',
        LOCATION_NAME: 'Stapleford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2728505,
        LOCATION_LATITUDE_DEG: 52.9291944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041400',
        LOCATION_NAME: 'Stapleford',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7987034,
        LOCATION_LATITUDE_DEG: 52.755372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041200',
        LOCATION_NAME: 'Stapleford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6808985,
        LOCATION_LATITUDE_DEG: 53.1088052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041100',
        LOCATION_NAME: 'Stapleford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0984118,
        LOCATION_LATITUDE_DEG: 51.8350777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041000',
        LOCATION_NAME: 'Stapleford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1484757,
        LOCATION_LATITUDE_DEG: 52.143603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041600',
        LOCATION_NAME: 'Stapleford Abbotts',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1894335,
        LOCATION_LATITUDE_DEG: 51.6290523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041700',
        LOCATION_NAME: 'Stapleford Aerodrome',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1575475,
        LOCATION_LATITUDE_DEG: 51.6526578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041800',
        LOCATION_NAME: 'Stapleford Tawney',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1747971,
        LOCATION_LATITUDE_DEG: 51.6662529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST041900',
        LOCATION_NAME: 'Staplegrove',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1232153,
        LOCATION_LATITUDE_DEG: 51.0324364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042000',
        LOCATION_NAME: 'Staplehurst',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5541272,
        LOCATION_LATITUDE_DEG: 51.1579986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042100',
        LOCATION_NAME: 'Staplers',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2730211,
        LOCATION_LATITUDE_DEG: 50.699886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042500',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9924429,
        LOCATION_LATITUDE_DEG: 52.2829495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042300',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7822277,
        LOCATION_LATITUDE_DEG: 52.6355836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042950',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7760908,
        LOCATION_LATITUDE_DEG: 55.0356891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042900',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7648158,
        LOCATION_LATITUDE_DEG: 50.9838262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042800',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5544474,
        LOCATION_LATITUDE_DEG: 51.4808706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042400',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.597252,
        LOCATION_LATITUDE_DEG: 54.5078288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042700',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3576903,
        LOCATION_LATITUDE_DEG: 52.582362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042600',
        LOCATION_NAME: 'Stapleton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2306758,
        LOCATION_LATITUDE_DEG: 53.6695696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043000',
        LOCATION_NAME: 'Stapley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1557691,
        LOCATION_LATITUDE_DEG: 50.915021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043100',
        LOCATION_NAME: 'Staploe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3183177,
        LOCATION_LATITUDE_DEG: 52.2314149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043200',
        LOCATION_NAME: 'Staplow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.449266,
        LOCATION_LATITUDE_DEG: 52.0688228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043400',
        LOCATION_NAME: 'Star',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5557671,
        LOCATION_LATITUDE_DEG: 51.9851443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043500',
        LOCATION_NAME: 'Star',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2478487,
        LOCATION_LATITUDE_DEG: 53.2210608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043600',
        LOCATION_NAME: 'Star',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1080982,
        LOCATION_LATITUDE_DEG: 56.2162366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043300',
        LOCATION_NAME: 'Star',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8091911,
        LOCATION_LATITUDE_DEG: 51.3194605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043700',
        LOCATION_NAME: 'Starbeck',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4999573,
        LOCATION_LATITUDE_DEG: 53.9978031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043800',
        LOCATION_NAME: 'Starbotton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0719382,
        LOCATION_LATITUDE_DEG: 54.1685261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST043900',
        LOCATION_NAME: 'Starcross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4473821,
        LOCATION_LATITUDE_DEG: 50.6248997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044000',
        LOCATION_NAME: 'Starkholmes',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5473836,
        LOCATION_LATITUDE_DEG: 53.1242162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044100',
        LOCATION_NAME: 'Starrapark',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6426672,
        LOCATION_LATITUDE_DEG: 50.64261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044200',
        LOCATION_NAME: 'Starston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2859031,
        LOCATION_LATITUDE_DEG: 52.4107143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044300',
        LOCATION_NAME: 'Start Point',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6559766,
        LOCATION_LATITUDE_DEG: 50.2245658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044400',
        LOCATION_NAME: 'Startforth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9323987,
        LOCATION_LATITUDE_DEG: 54.5424639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044500',
        LOCATION_NAME: 'Startley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0787902,
        LOCATION_LATITUDE_DEG: 51.5377733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990469',
        LOCATION_NAME: 'Statfold',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044600',
        LOCATION_NAME: 'Stathe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8920325,
        LOCATION_LATITUDE_DEG: 51.0572371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044700',
        LOCATION_NAME: 'Stathern',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8526673,
        LOCATION_LATITUDE_DEG: 52.8717821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044800',
        LOCATION_NAME: 'Station Town',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'TS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3680291,
        LOCATION_LATITUDE_DEG: 54.7190721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045000',
        LOCATION_NAME: 'Staunton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6547801,
        LOCATION_LATITUDE_DEG: 51.810501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST044900',
        LOCATION_NAME: 'Staunton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.302366,
        LOCATION_LATITUDE_DEG: 51.9623163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045100',
        LOCATION_NAME: 'Staunton in the Vale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7994764,
        LOCATION_LATITUDE_DEG: 52.9839927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121700',
        LOCATION_NAME: 'Staunton on Arrow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST121800',
        LOCATION_NAME: 'Staunton on Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045200',
        LOCATION_NAME: 'Staunton-on-Arrow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9229618,
        LOCATION_LATITUDE_DEG: 52.236253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045300',
        LOCATION_NAME: 'Staunton-on-Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9196254,
        LOCATION_LATITUDE_DEG: 52.1016363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045500',
        LOCATION_NAME: 'Staveley',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.812845,
        LOCATION_LATITUDE_DEG: 54.3749512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045400',
        LOCATION_NAME: 'Staveley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4409626,
        LOCATION_LATITUDE_DEG: 54.0591074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045600',
        LOCATION_NAME: 'Staveley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3482196,
        LOCATION_LATITUDE_DEG: 53.2684285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046000',
        LOCATION_NAME: 'Staverton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6988395,
        LOCATION_LATITUDE_DEG: 50.4632865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045700',
        LOCATION_NAME: 'Staverton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2069749,
        LOCATION_LATITUDE_DEG: 51.3449595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045900',
        LOCATION_NAME: 'Staverton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1571924,
        LOCATION_LATITUDE_DEG: 51.9097096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST045800',
        LOCATION_NAME: 'Staverton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2088603,
        LOCATION_LATITUDE_DEG: 52.2446282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046100',
        LOCATION_NAME: 'Stawell',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9053483,
        LOCATION_LATITUDE_DEG: 51.1399456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046200',
        LOCATION_NAME: 'Stawley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3320266,
        LOCATION_LATITUDE_DEG: 50.9995379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046300',
        LOCATION_NAME: 'Staxigoe',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0576836,
        LOCATION_LATITUDE_DEG: 58.4545625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046400',
        LOCATION_NAME: 'Staxton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4405843,
        LOCATION_LATITUDE_DEG: 54.1978067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046500',
        LOCATION_NAME: 'Staylittle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6407004,
        LOCATION_LATITUDE_DEG: 52.5158815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046600',
        LOCATION_NAME: 'Staynall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9730639,
        LOCATION_LATITUDE_DEG: 53.8866116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046700',
        LOCATION_NAME: 'Staythorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8742216,
        LOCATION_LATITUDE_DEG: 53.0766084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046800',
        LOCATION_NAME: 'Steane',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.182528,
        LOCATION_LATITUDE_DEG: 52.0392121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST046900',
        LOCATION_NAME: 'Stearsby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0659032,
        LOCATION_LATITUDE_DEG: 54.1354058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047000',
        LOCATION_NAME: 'Steart',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0426732,
        LOCATION_LATITUDE_DEG: 51.2070523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047100',
        LOCATION_NAME: 'Stebbing',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4175543,
        LOCATION_LATITUDE_DEG: 51.8889709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125200',
        LOCATION_NAME: 'Stechford',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8069128,
        LOCATION_LATITUDE_DEG: 52.4834637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047200',
        LOCATION_NAME: 'Stedham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7696733,
        LOCATION_LATITUDE_DEG: 50.9940069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047300',
        LOCATION_NAME: 'Steel',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0933542,
        LOCATION_LATITUDE_DEG: 54.9201965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047400',
        LOCATION_NAME: 'Steel Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1837432,
        LOCATION_LATITUDE_DEG: 51.0618957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047500',
        LOCATION_NAME: 'Steel Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6796771,
        LOCATION_LATITUDE_DEG: 52.9228134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047600',
        LOCATION_NAME: 'Steelend',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5456614,
        LOCATION_LATITUDE_DEG: 56.1131377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047700',
        LOCATION_NAME: 'Steensbridge',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6686844,
        LOCATION_LATITUDE_DEG: 52.2117389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047800',
        LOCATION_NAME: 'Steep',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9405025,
        LOCATION_LATITUDE_DEG: 51.0222122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST047900',
        LOCATION_NAME: 'Steep Marsh',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9205003,
        LOCATION_LATITUDE_DEG: 51.0257075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048100',
        LOCATION_NAME: 'Steeple',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1235803,
        LOCATION_LATITUDE_DEG: 50.6274835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048000',
        LOCATION_NAME: 'Steeple',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8033506,
        LOCATION_LATITUDE_DEG: 51.6922492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048200',
        LOCATION_NAME: 'Steeple Ashton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1355112,
        LOCATION_LATITUDE_DEG: 51.3117547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048300',
        LOCATION_NAME: 'Steeple Aston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3079516,
        LOCATION_LATITUDE_DEG: 51.9268971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048400',
        LOCATION_NAME: 'Steeple Barton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3421386,
        LOCATION_LATITUDE_DEG: 51.9233974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048500',
        LOCATION_NAME: 'Steeple Bumpstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4498708,
        LOCATION_LATITUDE_DEG: 52.0419877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048600',
        LOCATION_NAME: 'Steeple Claydon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9814365,
        LOCATION_LATITUDE_DEG: 51.9359986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048700',
        LOCATION_NAME: 'Steeple Gidding',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3286411,
        LOCATION_LATITUDE_DEG: 52.4187344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048800',
        LOCATION_NAME: 'Steeple Langford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9470821,
        LOCATION_LATITUDE_DEG: 51.1360363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST048900',
        LOCATION_NAME: 'Steeple Morden',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1236415,
        LOCATION_LATITUDE_DEG: 52.0654963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049000',
        LOCATION_NAME: 'Steer Point',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0443105,
        LOCATION_LATITUDE_DEG: 50.3518818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049100',
        LOCATION_NAME: 'Steetley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1843399,
        LOCATION_LATITUDE_DEG: 53.3026071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049200',
        LOCATION_NAME: 'Steeton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9487268,
        LOCATION_LATITUDE_DEG: 53.8956948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049300',
        LOCATION_NAME: 'Stein',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5709883,
        LOCATION_LATITUDE_DEG: 57.516103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049400',
        LOCATION_NAME: 'Steinish',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.342827,
        LOCATION_LATITUDE_DEG: 58.2198744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049500',
        LOCATION_NAME: 'Stelling Minnis',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0654199,
        LOCATION_LATITUDE_DEG: 51.1796934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049600',
        LOCATION_NAME: 'Stembridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8180313,
        LOCATION_LATITUDE_DEG: 50.9773232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049700',
        LOCATION_NAME: 'Stemster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4118652,
        LOCATION_LATITUDE_DEG: 58.5371685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049800',
        LOCATION_NAME: 'Stenalees',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7928398,
        LOCATION_LATITUDE_DEG: 50.3799913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST049900',
        LOCATION_NAME: 'Stenhouse',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2670596,
        LOCATION_LATITUDE_DEG: 55.9307111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050000',
        LOCATION_NAME: 'Stenhousemuir',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8033514,
        LOCATION_LATITUDE_DEG: 56.0276253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050100',
        LOCATION_NAME: 'Stenigot',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1199444,
        LOCATION_LATITUDE_DEG: 53.3097196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050200',
        LOCATION_NAME: 'Stenness',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1991114,
        LOCATION_LATITUDE_DEG: 58.9933166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050300',
        LOCATION_NAME: 'Stenscholl',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2169648,
        LOCATION_LATITUDE_DEG: 57.6314112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050400',
        LOCATION_NAME: 'Stenton',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6037187,
        LOCATION_LATITUDE_DEG: 55.9606027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050700',
        LOCATION_NAME: 'Stepaside',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8900981,
        LOCATION_LATITUDE_DEG: 50.3528915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050600',
        LOCATION_NAME: 'Stepaside',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6959795,
        LOCATION_LATITUDE_DEG: 51.7368222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124400',
        LOCATION_NAME: 'Stepney',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.042963,
        LOCATION_LATITUDE_DEG: 51.5182732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050800',
        LOCATION_NAME: 'Steppingley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.526786,
        LOCATION_LATITUDE_DEG: 52.0068944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990242',
        LOCATION_NAME: 'Stepps',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1856237,
        LOCATION_LATITUDE_DEG: 55.8868618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050900',
        LOCATION_NAME: 'Sterndale Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8487986,
        LOCATION_LATITUDE_DEG: 53.2138283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051000',
        LOCATION_NAME: 'Sternfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.498807,
        LOCATION_LATITUDE_DEG: 52.2007874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051100',
        LOCATION_NAME: 'Stert',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9551963,
        LOCATION_LATITUDE_DEG: 51.3329486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051200',
        LOCATION_NAME: 'Sterte',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9896135,
        LOCATION_LATITUDE_DEG: 50.7278922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051300',
        LOCATION_NAME: 'Stetchworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4011152,
        LOCATION_LATITUDE_DEG: 52.2025993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051400',
        LOCATION_NAME: 'Stevenage',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2003309,
        LOCATION_LATITUDE_DEG: 51.9016831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051500',
        LOCATION_NAME: 'Stevenston',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7550779,
        LOCATION_LATITUDE_DEG: 55.6409004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051600',
        LOCATION_NAME: 'Stevenstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0963054,
        LOCATION_LATITUDE_DEG: 50.9541419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051700',
        LOCATION_NAME: 'Steventon',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7007691,
        LOCATION_LATITUDE_DEG: 52.3557581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051800',
        LOCATION_NAME: 'Steventon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3187619,
        LOCATION_LATITUDE_DEG: 51.6243715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST051900',
        LOCATION_NAME: 'Steventon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2173624,
        LOCATION_LATITUDE_DEG: 51.2298275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052000',
        LOCATION_NAME: 'Stevington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5532115,
        LOCATION_LATITUDE_DEG: 52.1682112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052100',
        LOCATION_NAME: 'Stewartby',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5129227,
        LOCATION_LATITUDE_DEG: 52.0699009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052300',
        LOCATION_NAME: 'Stewarton',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6401983,
        LOCATION_LATITUDE_DEG: 55.4182902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052200',
        LOCATION_NAME: 'Stewarton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5140037,
        LOCATION_LATITUDE_DEG: 55.680302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052400',
        LOCATION_NAME: 'Stewartstown',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6919746,
        LOCATION_LATITUDE_DEG: 54.5757066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052500',
        LOCATION_NAME: 'Stewkley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7602411,
        LOCATION_LATITUDE_DEG: 51.9257928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052600',
        LOCATION_NAME: 'Stewponey',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2010951,
        LOCATION_LATITUDE_DEG: 52.4600647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052700',
        LOCATION_NAME: 'Stewton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0465615,
        LOCATION_LATITUDE_DEG: 53.3609174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052800',
        LOCATION_NAME: 'Steyning',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3196127,
        LOCATION_LATITUDE_DEG: 50.8883843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST052900',
        LOCATION_NAME: 'Steynton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0162307,
        LOCATION_LATITUDE_DEG: 51.7291231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053000',
        LOCATION_NAME: 'Stibb',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5221811,
        LOCATION_LATITUDE_DEG: 50.8681335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053100',
        LOCATION_NAME: 'Stibb Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2363629,
        LOCATION_LATITUDE_DEG: 50.9120378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053200',
        LOCATION_NAME: 'Stibbard',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9410984,
        LOCATION_LATITUDE_DEG: 52.815957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053300',
        LOCATION_NAME: 'Stibbington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3987561,
        LOCATION_LATITUDE_DEG: 52.5734482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053400',
        LOCATION_NAME: 'Stichill',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.457065,
        LOCATION_LATITUDE_DEG: 55.6381728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053500',
        LOCATION_NAME: 'Sticker',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8375861,
        LOCATION_LATITUDE_DEG: 50.3166889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053600',
        LOCATION_NAME: 'Stickford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0199191,
        LOCATION_LATITUDE_DEG: 53.1188994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053700',
        LOCATION_NAME: 'Stickle Path',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.360426,
        LOCATION_LATITUDE_DEG: 51.116147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053900',
        LOCATION_NAME: 'Sticklepath',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0741949,
        LOCATION_LATITUDE_DEG: 51.0721486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST053800',
        LOCATION_NAME: 'Sticklepath',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9246908,
        LOCATION_LATITUDE_DEG: 50.7300119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054000',
        LOCATION_NAME: 'Stickney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0069374,
        LOCATION_LATITUDE_DEG: 53.089195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054100',
        LOCATION_NAME: 'Stiffkey',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9346602,
        LOCATION_LATITUDE_DEG: 52.9484663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054200',
        LOCATION_NAME: 'Stifford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3077325,
        LOCATION_LATITUDE_DEG: 51.5028387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054300',
        LOCATION_NAME: 'Stileway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7667748,
        LOCATION_LATITUDE_DEG: 51.1656405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054400',
        LOCATION_NAME: 'Stilligarry',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3666359,
        LOCATION_LATITUDE_DEG: 57.3242914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054500',
        LOCATION_NAME: 'Stillingfleet',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0981332,
        LOCATION_LATITUDE_DEG: 53.8611797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054600',
        LOCATION_NAME: 'Stillington',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4232993,
        LOCATION_LATITUDE_DEG: 54.6032603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054700',
        LOCATION_NAME: 'Stillington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1090239,
        LOCATION_LATITUDE_DEG: 54.1026086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054900',
        LOCATION_NAME: 'Stilton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2907633,
        LOCATION_LATITUDE_DEG: 52.4888435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055000',
        LOCATION_NAME: 'Stinchcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3915336,
        LOCATION_LATITUDE_DEG: 51.6876879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055100',
        LOCATION_NAME: 'Stinsford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.410622,
        LOCATION_LATITUDE_DEG: 50.7206941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055200',
        LOCATION_NAME: 'Stiperstones',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9397724,
        LOCATION_LATITUDE_DEG: 52.5978808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055400',
        LOCATION_NAME: 'Stirchley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4362874,
        LOCATION_LATITUDE_DEG: 52.6599833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055300',
        LOCATION_NAME: 'Stirchley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9181457,
        LOCATION_LATITUDE_DEG: 52.4284508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055500',
        LOCATION_NAME: 'Stirkhill',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6845643,
        LOCATION_LATITUDE_DEG: 57.8386278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055600',
        LOCATION_NAME: 'Stirling',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9345341,
        LOCATION_LATITUDE_DEG: 56.1194407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055700',
        LOCATION_NAME: 'Stirtloe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2481415,
        LOCATION_LATITUDE_DEG: 52.2867224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055800',
        LOCATION_NAME: 'Stirton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0436054,
        LOCATION_LATITUDE_DEG: 53.9714016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST055900',
        LOCATION_NAME: 'Stisted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6158307,
        LOCATION_LATITUDE_DEG: 51.8909699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056000',
        LOCATION_NAME: 'Stitchcombe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6706605,
        LOCATION_LATITUDE_DEG: 51.4222596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056100',
        LOCATION_NAME: 'Stithians',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1740447,
        LOCATION_LATITUDE_DEG: 50.1866769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056150',
        LOCATION_NAME: 'Stittenham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9610649,
        LOCATION_LATITUDE_DEG: 54.0998042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056200',
        LOCATION_NAME: 'Stivichall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5144355,
        LOCATION_LATITUDE_DEG: 52.3853495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056300',
        LOCATION_NAME: 'Stixwould',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2420859,
        LOCATION_LATITUDE_DEG: 53.1769056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056400',
        LOCATION_NAME: 'Stoak',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8655036,
        LOCATION_LATITUDE_DEG: 53.252244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056600',
        LOCATION_NAME: 'Stobhill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6815406,
        LOCATION_LATITUDE_DEG: 55.1565203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990071',
        LOCATION_NAME: 'Stobo',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3091193,
        LOCATION_LATITUDE_DEG: 55.6207792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990070',
        LOCATION_NAME: 'Stobo',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.296922,
        LOCATION_LATITUDE_DEG: 55.627029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056700',
        LOCATION_NAME: 'Stoborough',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1080686,
        LOCATION_LATITUDE_DEG: 50.6765872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056800',
        LOCATION_NAME: 'Stobswood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6251434,
        LOCATION_LATITUDE_DEG: 55.2405231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057000',
        LOCATION_NAME: 'Stock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3053306,
        LOCATION_LATITUDE_DEG: 51.0409247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST056900',
        LOCATION_NAME: 'Stock',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4438798,
        LOCATION_LATITUDE_DEG: 51.6631542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057100',
        LOCATION_NAME: 'Stock Gaylard',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3941454,
        LOCATION_LATITUDE_DEG: 50.914716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057200',
        LOCATION_NAME: 'Stock Green',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B96',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0133692,
        LOCATION_LATITUDE_DEG: 52.2303385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990236',
        LOCATION_NAME: 'Stockbridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125700',
        LOCATION_NAME: 'Stockbridge',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2097289,
        LOCATION_LATITUDE_DEG: 55.9598198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057500',
        LOCATION_NAME: 'Stockbridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5106557,
        LOCATION_LATITUDE_DEG: 50.8999199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057300',
        LOCATION_NAME: 'Stockbridge',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4969014,
        LOCATION_LATITUDE_DEG: 51.114228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057400',
        LOCATION_NAME: 'Stockbridge',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7801887,
        LOCATION_LATITUDE_DEG: 50.8253839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057600',
        LOCATION_NAME: 'Stockbury',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6433329,
        LOCATION_LATITUDE_DEG: 51.3262183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057700',
        LOCATION_NAME: 'Stockcross',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.376434,
        LOCATION_LATITUDE_DEG: 51.4134558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057800',
        LOCATION_NAME: 'Stockdalewath',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9522284,
        LOCATION_LATITUDE_DEG: 54.7962988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST057900',
        LOCATION_NAME: 'Stockerston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7649208,
        LOCATION_LATITUDE_DEG: 52.5689505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058000',
        LOCATION_NAME: 'Stockgrove',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6639439,
        LOCATION_LATITUDE_DEG: 51.9530922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058100',
        LOCATION_NAME: 'Stockhill',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1866563,
        LOCATION_LATITUDE_DEG: 52.9809965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058200',
        LOCATION_NAME: 'Stocking Pelham',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.113842,
        LOCATION_LATITUDE_DEG: 51.9410826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058300',
        LOCATION_NAME: 'Stockingford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5107624,
        LOCATION_LATITUDE_DEG: 52.5154541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058400',
        LOCATION_NAME: 'Stockland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0725963,
        LOCATION_LATITUDE_DEG: 50.8357161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058500',
        LOCATION_NAME: 'Stockland Bristol',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0834485,
        LOCATION_LATITUDE_DEG: 51.1869505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125100',
        LOCATION_NAME: 'Stockland Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8617529,
        LOCATION_LATITUDE_DEG: 52.5222017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058600',
        LOCATION_NAME: 'Stockleigh English',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6311456,
        LOCATION_LATITUDE_DEG: 50.8436261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058700',
        LOCATION_NAME: 'Stockleigh Pomeroy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5909376,
        LOCATION_LATITUDE_DEG: 50.8209222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058900',
        LOCATION_NAME: 'Stockley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9700882,
        LOCATION_LATITUDE_DEG: 50.7409196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST058800',
        LOCATION_NAME: 'Stockley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9970092,
        LOCATION_LATITUDE_DEG: 51.4061577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059000',
        LOCATION_NAME: 'Stocklinch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8755103,
        LOCATION_LATITUDE_DEG: 50.9506273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059100',
        LOCATION_NAME: 'Stockport',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1591958,
        LOCATION_LATITUDE_DEG: 53.4107565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059200',
        LOCATION_NAME: 'Stocksbridge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.595545,
        LOCATION_LATITUDE_DEG: 53.4823553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059300',
        LOCATION_NAME: 'Stocksfield',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9133762,
        LOCATION_LATITUDE_DEG: 54.9466961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059400',
        LOCATION_NAME: 'Stocksmoor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7307944,
        LOCATION_LATITUDE_DEG: 53.5935672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059700',
        LOCATION_NAME: 'Stockton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6978716,
        LOCATION_LATITUDE_DEG: 52.2416467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059600',
        LOCATION_NAME: 'Stockton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3983766,
        LOCATION_LATITUDE_DEG: 52.595077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060000',
        LOCATION_NAME: 'Stockton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3401026,
        LOCATION_LATITUDE_DEG: 52.745791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059800',
        LOCATION_NAME: 'Stockton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0277786,
        LOCATION_LATITUDE_DEG: 51.143833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059500',
        LOCATION_NAME: 'Stockton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3591453,
        LOCATION_LATITUDE_DEG: 52.2714351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST059900',
        LOCATION_NAME: 'Stockton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5223665,
        LOCATION_LATITUDE_DEG: 52.4908121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060100',
        LOCATION_NAME: 'Stockton Brook',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1251719,
        LOCATION_LATITUDE_DEG: 53.0645164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060200',
        LOCATION_NAME: 'Stockton Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5797562,
        LOCATION_LATITUDE_DEG: 53.3703499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120700',
        LOCATION_NAME: 'Stockton on Tees',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060300',
        LOCATION_NAME: 'Stockton on the Forest',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0005606,
        LOCATION_LATITUDE_DEG: 53.9951914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060400',
        LOCATION_NAME: 'Stockton-on-Tees',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3132752,
        LOCATION_LATITUDE_DEG: 54.5678575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123800',
        LOCATION_NAME: 'Stockwell',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1165099,
        LOCATION_LATITUDE_DEG: 51.4746174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060500',
        LOCATION_NAME: 'Stockwell Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9151063,
        LOCATION_LATITUDE_DEG: 52.7922889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060600',
        LOCATION_NAME: 'Stockwood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5844445,
        LOCATION_LATITUDE_DEG: 50.8639144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060700',
        LOCATION_NAME: 'Stockwood',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5450466,
        LOCATION_LATITUDE_DEG: 51.4110685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060800',
        LOCATION_NAME: 'Stockwood',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B96',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9975988,
        LOCATION_LATITUDE_DEG: 52.223236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST060900',
        LOCATION_NAME: 'Stodday',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8091795,
        LOCATION_LATITUDE_DEG: 54.0194189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061000',
        LOCATION_NAME: 'Stodmarsh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1847455,
        LOCATION_LATITUDE_DEG: 51.3004036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061100',
        LOCATION_NAME: 'Stody',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0550422,
        LOCATION_LATITUDE_DEG: 52.8725622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061200',
        LOCATION_NAME: 'Stoer',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3389773,
        LOCATION_LATITUDE_DEG: 58.2036576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061400',
        LOCATION_NAME: 'Stoford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6159572,
        LOCATION_LATITUDE_DEG: 50.9183163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061300',
        LOCATION_NAME: 'Stoford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8807846,
        LOCATION_LATITUDE_DEG: 51.1194312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061500',
        LOCATION_NAME: 'Stogumber',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2900358,
        LOCATION_LATITUDE_DEG: 51.1273504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061600',
        LOCATION_NAME: 'Stogursey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1394376,
        LOCATION_LATITUDE_DEG: 51.1790531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061850',
        LOCATION_NAME: 'Stoke',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5140178,
        LOCATION_LATITUDE_DEG: 50.9926138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061700',
        LOCATION_NAME: 'Stoke',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1634399,
        LOCATION_LATITUDE_DEG: 50.3816597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061875',
        LOCATION_NAME: 'Stoke',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5658387,
        LOCATION_LATITUDE_DEG: 53.1068664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061800',
        LOCATION_NAME: 'Stoke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4221682,
        LOCATION_LATITUDE_DEG: 51.2636354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST061900',
        LOCATION_NAME: 'Stoke Abbott',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7763376,
        LOCATION_LATITUDE_DEG: 50.8022142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062000',
        LOCATION_NAME: 'Stoke Albany',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8135173,
        LOCATION_LATITUDE_DEG: 52.4851438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062100',
        LOCATION_NAME: 'Stoke Ash',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0994983,
        LOCATION_LATITUDE_DEG: 52.2888037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062200',
        LOCATION_NAME: 'Stoke Bardolph',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0385451,
        LOCATION_LATITUDE_DEG: 52.967493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122900',
        LOCATION_NAME: 'Stoke Bishop',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6299751,
        LOCATION_LATITUDE_DEG: 51.4810917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062300',
        LOCATION_NAME: 'Stoke Bliss',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5022553,
        LOCATION_LATITUDE_DEG: 52.2633483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062400',
        LOCATION_NAME: 'Stoke Bruerne',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9127274,
        LOCATION_LATITUDE_DEG: 52.1415184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066100',
        LOCATION_NAME: 'Stoke by Clare',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5400609,
        LOCATION_LATITUDE_DEG: 52.0619859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066200',
        LOCATION_NAME: 'Stoke by Nayland',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.893411,
        LOCATION_LATITUDE_DEG: 51.9870778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062500',
        LOCATION_NAME: 'Stoke Canon',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5063356,
        LOCATION_LATITUDE_DEG: 50.7709132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062600',
        LOCATION_NAME: 'Stoke Charity',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3032471,
        LOCATION_LATITUDE_DEG: 51.1501247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062700',
        LOCATION_NAME: 'Stoke Climsland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3150635,
        LOCATION_LATITUDE_DEG: 50.5457048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062800',
        LOCATION_NAME: "Stoke D'Abernon",
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3868242,
        LOCATION_LATITUDE_DEG: 51.3222343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST062900',
        LOCATION_NAME: 'Stoke Doyle',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4932341,
        LOCATION_LATITUDE_DEG: 52.4629388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063000',
        LOCATION_NAME: 'Stoke Dry',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7389248,
        LOCATION_LATITUDE_DEG: 52.5610517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063100',
        LOCATION_NAME: 'Stoke Edith',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5780849,
        LOCATION_LATITUDE_DEG: 52.0620301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063200',
        LOCATION_NAME: 'Stoke Ferry',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5148751,
        LOCATION_LATITUDE_DEG: 52.5701342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063300',
        LOCATION_NAME: 'Stoke Fleming',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.597745,
        LOCATION_LATITUDE_DEG: 50.3234722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063400',
        LOCATION_NAME: 'Stoke Gabriel',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6198131,
        LOCATION_LATITUDE_DEG: 50.404283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123400',
        LOCATION_NAME: 'Stoke Gifford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5504573,
        LOCATION_LATITUDE_DEG: 51.520277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063500',
        LOCATION_NAME: 'Stoke Golding',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4132036,
        LOCATION_LATITUDE_DEG: 52.5702605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063600',
        LOCATION_NAME: 'Stoke Goldington',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7766447,
        LOCATION_LATITUDE_DEG: 52.1310134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063700',
        LOCATION_NAME: 'Stoke Hammond',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7174535,
        LOCATION_LATITUDE_DEG: 51.9562951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063800',
        LOCATION_NAME: 'Stoke Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5270592,
        LOCATION_LATITUDE_DEG: 52.8660044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST063900',
        LOCATION_NAME: 'Stoke Heath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0766694,
        LOCATION_LATITUDE_DEG: 52.3139427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064000',
        LOCATION_NAME: 'Stoke Hill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5223591,
        LOCATION_LATITUDE_DEG: 50.7463126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064100',
        LOCATION_NAME: 'Stoke Holy Cross',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.29924,
        LOCATION_LATITUDE_DEG: 52.5680222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064200',
        LOCATION_NAME: 'Stoke Lacy',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5550174,
        LOCATION_LATITUDE_DEG: 52.1417354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064300',
        LOCATION_NAME: 'Stoke Lyne',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1751997,
        LOCATION_LATITUDE_DEG: 51.9501045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064400',
        LOCATION_NAME: 'Stoke Mandeville',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7898956,
        LOCATION_LATITUDE_DEG: 51.7856755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124600',
        LOCATION_NAME: 'Stoke Newington',
        COUNTY_NAME: 'London',
        POSTCODE: 'N16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0736927,
        LOCATION_LATITUDE_DEG: 51.5627696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066300',
        LOCATION_NAME: 'Stoke on Tern',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5342947,
        LOCATION_LATITUDE_DEG: 52.8491058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066350',
        LOCATION_NAME: 'Stoke on Trent',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064500',
        LOCATION_NAME: 'Stoke Orchard',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1156931,
        LOCATION_LATITUDE_DEG: 51.9527117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064600',
        LOCATION_NAME: 'Stoke Park',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5153236,
        LOCATION_LATITUDE_DEG: 52.8384999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064700',
        LOCATION_NAME: 'Stoke Poges',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5836261,
        LOCATION_LATITUDE_DEG: 51.5472541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064800',
        LOCATION_NAME: 'Stoke Pound',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0552721,
        LOCATION_LATITUDE_DEG: 52.3080474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST064900',
        LOCATION_NAME: 'Stoke Prior',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7000787,
        LOCATION_LATITUDE_DEG: 52.205047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065000',
        LOCATION_NAME: 'Stoke Prior',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0851532,
        LOCATION_LATITUDE_DEG: 52.3007467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065100',
        LOCATION_NAME: 'Stoke Rivers',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.948785,
        LOCATION_LATITUDE_DEG: 51.0995541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065200',
        LOCATION_NAME: 'Stoke Rochford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6404954,
        LOCATION_LATITUDE_DEG: 52.8350795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065300',
        LOCATION_NAME: 'Stoke Row',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0211629,
        LOCATION_LATITUDE_DEG: 51.5507579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109300',
        LOCATION_NAME: 'Stoke St Gregory',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109400',
        LOCATION_NAME: 'Stoke St Mary',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109500',
        LOCATION_NAME: 'Stoke St Michael',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109600',
        LOCATION_NAME: 'Stoke St Milborough',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065400',
        LOCATION_NAME: 'Stoke St. Gregory',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9244905,
        LOCATION_LATITUDE_DEG: 51.0425324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065500',
        LOCATION_NAME: 'Stoke St. Mary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0503918,
        LOCATION_LATITUDE_DEG: 50.9947291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065600',
        LOCATION_NAME: 'Stoke St. Michael',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4813488,
        LOCATION_LATITUDE_DEG: 51.2210495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065700',
        LOCATION_NAME: 'Stoke St. Milborough',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6366348,
        LOCATION_LATITUDE_DEG: 52.4360624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122000',
        LOCATION_NAME: 'Stoke sub Hamdon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065800',
        LOCATION_NAME: 'Stoke Talmage',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0167434,
        LOCATION_LATITUDE_DEG: 51.6873729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST065900',
        LOCATION_NAME: 'Stoke Trister',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3700824,
        LOCATION_LATITUDE_DEG: 51.0555315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066000',
        LOCATION_NAME: 'Stoke Wake',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3436432,
        LOCATION_LATITUDE_DEG: 50.8570114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066600',
        LOCATION_NAME: 'Stokeham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8225568,
        LOCATION_LATITUDE_DEG: 53.2829254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066700',
        LOCATION_NAME: 'Stokeinteignhead',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5299662,
        LOCATION_LATITUDE_DEG: 50.5239958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066800',
        LOCATION_NAME: 'Stokenchurch',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8960728,
        LOCATION_LATITUDE_DEG: 51.6579651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066900',
        LOCATION_NAME: 'Stokenham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6748416,
        LOCATION_LATITUDE_DEG: 50.273166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066400',
        LOCATION_NAME: 'Stoke-on-Trent',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1839693,
        LOCATION_LATITUDE_DEG: 53.0037114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067000',
        LOCATION_NAME: 'Stokesay',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8304802,
        LOCATION_LATITUDE_DEG: 52.4308679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067100',
        LOCATION_NAME: 'Stokesby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5961131,
        LOCATION_LATITUDE_DEG: 52.6381232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067200',
        LOCATION_NAME: 'Stokesley',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1920555,
        LOCATION_LATITUDE_DEG: 54.4695417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST066500',
        LOCATION_NAME: 'Stoke-sub-Hamdon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7494404,
        LOCATION_LATITUDE_DEG: 50.9527275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067300',
        LOCATION_NAME: 'Stoketon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.259835,
        LOCATION_LATITUDE_DEG: 50.4203868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067400',
        LOCATION_NAME: 'Ston Easton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.541047,
        LOCATION_LATITUDE_DEG: 51.2816532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067500',
        LOCATION_NAME: 'Stondon Massey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2933502,
        LOCATION_LATITUDE_DEG: 51.6822545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067600',
        LOCATION_NAME: 'Stone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4569888,
        LOCATION_LATITUDE_DEG: 51.6535865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068000',
        LOCATION_NAME: 'Stone',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2071966,
        LOCATION_LATITUDE_DEG: 52.3738563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067800',
        LOCATION_NAME: 'Stone',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1449112,
        LOCATION_LATITUDE_DEG: 52.9025077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067700',
        LOCATION_NAME: 'Stone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8633564,
        LOCATION_LATITUDE_DEG: 51.8038811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST067900',
        LOCATION_NAME: 'Stone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2662922,
        LOCATION_LATITUDE_DEG: 51.4495295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068050',
        LOCATION_NAME: 'Stone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7664649,
        LOCATION_LATITUDE_DEG: 51.0255042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068100',
        LOCATION_NAME: 'Stone Allerton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.859015,
        LOCATION_LATITUDE_DEG: 51.2561543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068400',
        LOCATION_NAME: 'Stone Cross',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9840431,
        LOCATION_LATITUDE_DEG: 52.5445968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068300',
        LOCATION_NAME: 'Stone Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1650635,
        LOCATION_LATITUDE_DEG: 51.0365999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068500',
        LOCATION_NAME: 'Stone Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2931798,
        LOCATION_LATITUDE_DEG: 50.8165692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068600',
        LOCATION_NAME: 'Stone Fold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3218252,
        LOCATION_LATITUDE_DEG: 53.7293818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990677',
        LOCATION_NAME: 'Stonea',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068800',
        LOCATION_NAME: 'Stonebridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5986379,
        LOCATION_LATITUDE_DEG: 54.7662784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068700',
        LOCATION_NAME: 'Stonebridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7709906,
        LOCATION_LATITUDE_DEG: 52.0630013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068900',
        LOCATION_NAME: 'Stonebroom',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3790181,
        LOCATION_LATITUDE_DEG: 53.1329148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069000',
        LOCATION_NAME: 'Stonebyres',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.840082,
        LOCATION_LATITUDE_DEG: 55.6714942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069100',
        LOCATION_NAME: 'Stoneclough',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3697462,
        LOCATION_LATITUDE_DEG: 53.544666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069200',
        LOCATION_NAME: 'Stonecroft',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3654523,
        LOCATION_LATITUDE_DEG: 53.5767437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069300',
        LOCATION_NAME: 'Stonedge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5096765,
        LOCATION_LATITUDE_DEG: 53.1977225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069550',
        LOCATION_NAME: 'Stonefield',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.986679,
        LOCATION_LATITUDE_DEG: 57.1135194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069400',
        LOCATION_NAME: 'Stonefield',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9769259,
        LOCATION_LATITUDE_DEG: 57.1076603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069600',
        LOCATION_NAME: 'Stonefort',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9183081,
        LOCATION_LATITUDE_DEG: 54.5110106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069700',
        LOCATION_NAME: 'Stonegate',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3790646,
        LOCATION_LATITUDE_DEG: 51.0314929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069800',
        LOCATION_NAME: 'Stonegrave',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9933067,
        LOCATION_LATITUDE_DEG: 54.1919091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070000',
        LOCATION_NAME: 'Stoneham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0302851,
        LOCATION_LATITUDE_DEG: 50.8893876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070100',
        LOCATION_NAME: 'Stonehaugh',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3259422,
        LOCATION_LATITUDE_DEG: 55.0790138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070200',
        LOCATION_NAME: 'Stonehaven',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2065923,
        LOCATION_LATITUDE_DEG: 56.9638002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123300',
        LOCATION_NAME: 'Stonehill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5035525,
        LOCATION_LATITUDE_DEG: 51.4444192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070300',
        LOCATION_NAME: 'Stonehouse',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1573192,
        LOCATION_LATITUDE_DEG: 50.3676866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070400',
        LOCATION_NAME: 'Stonehouse',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.983127,
        LOCATION_LATITUDE_DEG: 55.7007965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070500',
        LOCATION_NAME: 'Stonehouse',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.281056,
        LOCATION_LATITUDE_DEG: 51.7454913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070700',
        LOCATION_NAME: 'Stoneleigh',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5135287,
        LOCATION_LATITUDE_DEG: 52.3515387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070600',
        LOCATION_NAME: 'Stoneleigh',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2458252,
        LOCATION_LATITUDE_DEG: 51.3618297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070800',
        LOCATION_NAME: 'Stoneleigh Park',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5393891,
        LOCATION_LATITUDE_DEG: 52.3512467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST070900',
        LOCATION_NAME: 'Stonely',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3735649,
        LOCATION_LATITUDE_DEG: 52.2897217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071100',
        LOCATION_NAME: 'Stoneraise',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9328639,
        LOCATION_LATITUDE_DEG: 54.8356004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071200',
        LOCATION_NAME: 'Stones Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.148818,
        LOCATION_LATITUDE_DEG: 51.8955619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071300',
        LOCATION_NAME: 'Stonesby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7786495,
        LOCATION_LATITUDE_DEG: 52.8126742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071400',
        LOCATION_NAME: 'Stonesfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4278778,
        LOCATION_LATITUDE_DEG: 51.8507941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071500',
        LOCATION_NAME: 'Stoneshot',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3457278,
        LOCATION_LATITUDE_DEG: 54.4737608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071700',
        LOCATION_NAME: 'Stonewall Hill',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0062624,
        LOCATION_LATITUDE_DEG: 52.3014543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071900',
        LOCATION_NAME: 'Stoney Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1201035,
        LOCATION_LATITUDE_DEG: 51.0095415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071800',
        LOCATION_NAME: 'Stoney Cross',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6343393,
        LOCATION_LATITUDE_DEG: 50.903405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072000',
        LOCATION_NAME: 'Stoney Hills',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0804898,
        LOCATION_LATITUDE_DEG: 51.8335724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072100',
        LOCATION_NAME: 'Stoney Littleton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3865372,
        LOCATION_LATITUDE_DEG: 51.3072564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072200',
        LOCATION_NAME: 'Stoney Middleton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6560197,
        LOCATION_LATITUDE_DEG: 53.2758357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072300',
        LOCATION_NAME: 'Stoney Stanton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2762083,
        LOCATION_LATITUDE_DEG: 52.5476541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072400',
        LOCATION_NAME: 'Stoney Stoke',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4109041,
        LOCATION_LATITUDE_DEG: 51.0857292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072500',
        LOCATION_NAME: 'Stoney Stratton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.493851,
        LOCATION_LATITUDE_DEG: 51.1514361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072600',
        LOCATION_NAME: 'Stoney Stretton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9103533,
        LOCATION_LATITUDE_DEG: 52.6794887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072700',
        LOCATION_NAME: 'Stoneybridge',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3979814,
        LOCATION_LATITUDE_DEG: 57.2719855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072800',
        LOCATION_NAME: 'Stoneyburn',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6308572,
        LOCATION_LATITUDE_DEG: 55.8468047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST072900',
        LOCATION_NAME: 'Stoneycombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6012004,
        LOCATION_LATITUDE_DEG: 50.4933913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073000',
        LOCATION_NAME: 'Stoneycroft',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9141612,
        LOCATION_LATITUDE_DEG: 53.4165604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073100',
        LOCATION_NAME: 'Stoneyford',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1156107,
        LOCATION_LATITUDE_DEG: 54.5665999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073300',
        LOCATION_NAME: 'Stoneygate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4519554,
        LOCATION_LATITUDE_DEG: 54.8576839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073400',
        LOCATION_NAME: 'Stoneyhills',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8144955,
        LOCATION_LATITUDE_DEG: 51.6409463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073500',
        LOCATION_NAME: 'Stoneykirk',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9788746,
        LOCATION_LATITUDE_DEG: 54.8356194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073600',
        LOCATION_NAME: 'Stoneywood',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9235267,
        LOCATION_LATITUDE_DEG: 56.022628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073700',
        LOCATION_NAME: 'Stoneywood',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1773695,
        LOCATION_LATITUDE_DEG: 57.1893216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073800',
        LOCATION_NAME: 'Stonham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1199435,
        LOCATION_LATITUDE_DEG: 52.1933887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073850',
        LOCATION_NAME: 'Stonham Aspal',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1216678,
        LOCATION_LATITUDE_DEG: 52.1927224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073900',
        LOCATION_NAME: 'Stonnall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8913152,
        LOCATION_LATITUDE_DEG: 52.6321728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074000',
        LOCATION_NAME: 'Stonor',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9364268,
        LOCATION_LATITUDE_DEG: 51.5924662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074100',
        LOCATION_NAME: 'Stonton Wyville',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9143842,
        LOCATION_LATITUDE_DEG: 52.5482517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074200',
        LOCATION_NAME: 'Stony Houghton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2619503,
        LOCATION_LATITUDE_DEG: 53.1908178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074300',
        LOCATION_NAME: 'Stony Stratford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8510939,
        LOCATION_LATITUDE_DEG: 52.056409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074500',
        LOCATION_NAME: 'Stonyford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.378285,
        LOCATION_LATITUDE_DEG: 50.8577248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074600',
        LOCATION_NAME: 'Stoodleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5351979,
        LOCATION_LATITUDE_DEG: 50.9586312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074700',
        LOCATION_NAME: 'Stop and Call',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0016674,
        LOCATION_LATITUDE_DEG: 52.0029494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074800',
        LOCATION_NAME: 'Stopham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5386835,
        LOCATION_LATITUDE_DEG: 50.9600018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074900',
        LOCATION_NAME: 'Stopsley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3878171,
        LOCATION_LATITUDE_DEG: 51.8977826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075000',
        LOCATION_NAME: 'Storeton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0450545,
        LOCATION_LATITUDE_DEG: 53.3510549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075100',
        LOCATION_NAME: 'Storiths',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8753792,
        LOCATION_LATITUDE_DEG: 53.9849089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075200',
        LOCATION_NAME: 'Stormontfield',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4460579,
        LOCATION_LATITUDE_DEG: 56.4484687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075300',
        LOCATION_NAME: 'Stormy Down',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6596425,
        LOCATION_LATITUDE_DEG: 51.508991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075400',
        LOCATION_NAME: 'Stornoway',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3847632,
        LOCATION_LATITUDE_DEG: 58.2161725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075500',
        LOCATION_NAME: 'Stornoway Airport',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3253082,
        LOCATION_LATITUDE_DEG: 58.2197684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075600',
        LOCATION_NAME: 'Storridge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3675077,
        LOCATION_LATITUDE_DEG: 52.1353294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075700',
        LOCATION_NAME: 'Storrington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.454981,
        LOCATION_LATITUDE_DEG: 50.9150965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075800',
        LOCATION_NAME: 'Storth',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8052329,
        LOCATION_LATITUDE_DEG: 54.2155363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST075900',
        LOCATION_NAME: 'Storwood',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9150333,
        LOCATION_LATITUDE_DEG: 53.8883851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076000',
        LOCATION_NAME: 'Stotfield',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2943066,
        LOCATION_LATITUDE_DEG: 57.7201897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076100',
        LOCATION_NAME: 'Stotfold',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2272898,
        LOCATION_LATITUDE_DEG: 52.0136934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076200',
        LOCATION_NAME: 'Stottesdon',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4823092,
        LOCATION_LATITUDE_DEG: 52.4412611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076300',
        LOCATION_NAME: 'Stoughton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0531945,
        LOCATION_LATITUDE_DEG: 52.6124624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076400',
        LOCATION_NAME: 'Stoughton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8601747,
        LOCATION_LATITUDE_DEG: 50.895994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076500',
        LOCATION_NAME: 'Stoughton Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8224767,
        LOCATION_LATITUDE_DEG: 51.2421537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076600',
        LOCATION_NAME: 'Stoulton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.139036,
        LOCATION_LATITUDE_DEG: 52.1455309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076700',
        LOCATION_NAME: 'Stour Provost',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2914007,
        LOCATION_LATITUDE_DEG: 50.9920188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076800',
        LOCATION_NAME: 'Stour Row',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.253251,
        LOCATION_LATITUDE_DEG: 50.9890231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST076900',
        LOCATION_NAME: 'Stourbridge',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1436607,
        LOCATION_LATITUDE_DEG: 52.4556618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077000',
        LOCATION_NAME: 'Stourmouth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2507416,
        LOCATION_LATITUDE_DEG: 51.3156088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077100',
        LOCATION_NAME: 'Stourpaine',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1964411,
        LOCATION_LATITUDE_DEG: 50.8847102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122100',
        LOCATION_NAME: 'Stourport on Severn',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077200',
        LOCATION_NAME: 'Stourport-on-Severn',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2748075,
        LOCATION_LATITUDE_DEG: 52.3414489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077300',
        LOCATION_NAME: 'Stourscombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3376322,
        LOCATION_LATITUDE_DEG: 50.6266078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077600',
        LOCATION_NAME: 'Stourton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3197471,
        LOCATION_LATITUDE_DEG: 51.1043331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077500',
        LOCATION_NAME: 'Stourton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2026471,
        LOCATION_LATITUDE_DEG: 52.4614646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077400',
        LOCATION_NAME: 'Stourton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5710011,
        LOCATION_LATITUDE_DEG: 52.0291099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077700',
        LOCATION_NAME: 'Stourton Caundle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4065795,
        LOCATION_LATITUDE_DEG: 50.934315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077800',
        LOCATION_NAME: 'Stoven',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.597463,
        LOCATION_LATITUDE_DEG: 52.3775977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST077900',
        LOCATION_NAME: 'Stover',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6363667,
        LOCATION_LATITUDE_DEG: 50.5512958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078000',
        LOCATION_NAME: 'Stow',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8604749,
        LOCATION_LATITUDE_DEG: 55.6919846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078100',
        LOCATION_NAME: 'Stow',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6747683,
        LOCATION_LATITUDE_DEG: 53.3268213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078200',
        LOCATION_NAME: 'Stow',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3668685,
        LOCATION_LATITUDE_DEG: 52.901781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078300',
        LOCATION_NAME: 'Stow Bardolph',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4062134,
        LOCATION_LATITUDE_DEG: 52.6253436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078400',
        LOCATION_NAME: 'Stow Bedon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8828104,
        LOCATION_LATITUDE_DEG: 52.5274305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078500',
        LOCATION_NAME: 'Stow Bridge',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3660384,
        LOCATION_LATITUDE_DEG: 52.6361441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122200',
        LOCATION_NAME: 'Stow cum Quy',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078600',
        LOCATION_NAME: 'Stow Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0912615,
        LOCATION_LATITUDE_DEG: 52.5747721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078700',
        LOCATION_NAME: 'Stow Longa',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.374945,
        LOCATION_LATITUDE_DEG: 52.3265277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078800',
        LOCATION_NAME: 'Stow Maries',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6508996,
        LOCATION_LATITUDE_DEG: 51.6643459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079000',
        LOCATION_NAME: 'Stow on the Wold',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7225128,
        LOCATION_LATITUDE_DEG: 51.928802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST078900',
        LOCATION_NAME: 'Stow Park',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7062597,
        LOCATION_LATITUDE_DEG: 53.3228246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079100',
        LOCATION_NAME: 'Stow-cum-Quy',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2193332,
        LOCATION_LATITUDE_DEG: 52.2192447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990525',
        LOCATION_NAME: 'Stowe',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079200',
        LOCATION_NAME: 'Stowe',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0125157,
        LOCATION_LATITUDE_DEG: 52.3556651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122300',
        LOCATION_NAME: 'Stowe by Chartley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079300',
        LOCATION_NAME: 'Stowe-by-Chartley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9957087,
        LOCATION_LATITUDE_DEG: 52.8430975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079400',
        LOCATION_NAME: 'Stowell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4543806,
        LOCATION_LATITUDE_DEG: 50.9979289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079500',
        LOCATION_NAME: 'Stowford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2171768,
        LOCATION_LATITUDE_DEG: 50.6606082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST991058',
        LOCATION_NAME: 'Stowford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.218269,
        LOCATION_LATITUDE_DEG: 50.661052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079600',
        LOCATION_NAME: 'Stowlangtoft',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8742188,
        LOCATION_LATITUDE_DEG: 52.2770034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079700',
        LOCATION_NAME: 'Stowmarket',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9950979,
        LOCATION_LATITUDE_DEG: 52.1881897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079800',
        LOCATION_NAME: 'Stowting',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0378826,
        LOCATION_LATITUDE_DEG: 51.1352897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST079900',
        LOCATION_NAME: 'Stowting Common',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.03658,
        LOCATION_LATITUDE_DEG: 51.1502925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080000',
        LOCATION_NAME: 'Stowupland',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.025389,
        LOCATION_LATITUDE_DEG: 52.1984976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080100',
        LOCATION_NAME: 'Strabane',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.465645,
        LOCATION_LATITUDE_DEG: 54.8283383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080200',
        LOCATION_NAME: 'Stracathro',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6151572,
        LOCATION_LATITUDE_DEG: 56.7667897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080300',
        LOCATION_NAME: 'Strachan',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5364378,
        LOCATION_LATITUDE_DEG: 57.0207077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080400',
        LOCATION_NAME: 'Strachur',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0666265,
        LOCATION_LATITUDE_DEG: 56.1676576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080900',
        LOCATION_NAME: 'Stradbroke',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.273013,
        LOCATION_LATITUDE_DEG: 52.3163018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081100',
        LOCATION_NAME: 'Stradishall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5557497,
        LOCATION_LATITUDE_DEG: 52.1462959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081300',
        LOCATION_NAME: 'Stradsett',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4596813,
        LOCATION_LATITUDE_DEG: 52.6174463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081500',
        LOCATION_NAME: 'Stragglethorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6377806,
        LOCATION_LATITUDE_DEG: 53.0590949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081600',
        LOCATION_NAME: 'Straid',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3989275,
        LOCATION_LATITUDE_DEG: 55.1832665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081700',
        LOCATION_NAME: 'Straiton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5502318,
        LOCATION_LATITUDE_DEG: 55.3114631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081800',
        LOCATION_NAME: 'Straiton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1652289,
        LOCATION_LATITUDE_DEG: 55.8842044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081900',
        LOCATION_NAME: 'Stramshall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8801566,
        LOCATION_LATITUDE_DEG: 52.919006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124100',
        LOCATION_NAME: 'Strand',
        COUNTY_NAME: 'London',
        POSTCODE: 'WC2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1285324,
        LOCATION_LATITUDE_DEG: 51.5081042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123200',
        LOCATION_NAME: 'Strandtown',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8800015,
        LOCATION_LATITUDE_DEG: 54.6014333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990539',
        LOCATION_NAME: 'Strang',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.511181,
        LOCATION_LATITUDE_DEG: 54.1735564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123000',
        LOCATION_NAME: 'Strangeways',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2497032,
        LOCATION_LATITUDE_DEG: 53.4816101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082200',
        LOCATION_NAME: 'Strangford',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.558378,
        LOCATION_LATITUDE_DEG: 54.3713769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082300',
        LOCATION_NAME: 'Strangford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6090503,
        LOCATION_LATITUDE_DEG: 51.9489184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082400',
        LOCATION_NAME: 'Strangways',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7946071,
        LOCATION_LATITUDE_DEG: 51.190033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST125000',
        LOCATION_NAME: 'Stranmillis',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.938375,
        LOCATION_LATITUDE_DEG: 54.5707711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082500',
        LOCATION_NAME: 'Stranocum',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4156436,
        LOCATION_LATITUDE_DEG: 55.0999584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082700',
        LOCATION_NAME: 'Stranraer',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0219386,
        LOCATION_LATITUDE_DEG: 54.9017308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082800',
        LOCATION_NAME: 'Stratfield Saye',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0183213,
        LOCATION_LATITUDE_DEG: 51.3494376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082900',
        LOCATION_NAME: 'Stratfield Turgis',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.999291,
        LOCATION_LATITUDE_DEG: 51.3330351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124500',
        LOCATION_NAME: 'Stratford',
        COUNTY_NAME: 'London',
        POSTCODE: 'E15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3776588,
        LOCATION_LATITUDE_DEG: 51.5412615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109700',
        LOCATION_NAME: 'Stratford St Andrew',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109800',
        LOCATION_NAME: 'Stratford St Mary',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083100',
        LOCATION_NAME: 'Stratford St. Andrew',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4512098,
        LOCATION_LATITUDE_DEG: 52.1884906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083200',
        LOCATION_NAME: 'Stratford St. Mary',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9743736,
        LOCATION_LATITUDE_DEG: 51.9682752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083400',
        LOCATION_NAME: 'Stratford sub Castle',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8093861,
        LOCATION_LATITUDE_DEG: 51.0904238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083300',
        LOCATION_NAME: 'Stratford Toney',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8672825,
        LOCATION_LATITUDE_DEG: 51.0391258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122400',
        LOCATION_NAME: 'Stratford upon Avon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7055785,
        LOCATION_LATITUDE_DEG: 52.1912279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083500',
        LOCATION_NAME: 'Stratford-upon-Avon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7055785,
        LOCATION_LATITUDE_DEG: 52.1912279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083600',
        LOCATION_NAME: 'Strath',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7018764,
        LOCATION_LATITUDE_DEG: 57.7315136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083700',
        LOCATION_NAME: 'Strath Tummel',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9356096,
        LOCATION_LATITUDE_DEG: 56.7178945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083800',
        LOCATION_NAME: 'Strathaird',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1119264,
        LOCATION_LATITUDE_DEG: 57.1922638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083900',
        LOCATION_NAME: 'Strathaven',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0641276,
        LOCATION_LATITUDE_DEG: 55.6781949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084000',
        LOCATION_NAME: 'Strathblane',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3044895,
        LOCATION_LATITUDE_DEG: 55.9853292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST126000',
        LOCATION_NAME: 'Strathbungo',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2708887,
        LOCATION_LATITUDE_DEG: 55.8365551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084100',
        LOCATION_NAME: 'Strathcarron',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4270154,
        LOCATION_LATITUDE_DEG: 57.4241829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084200',
        LOCATION_NAME: 'Strathconon',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6643584,
        LOCATION_LATITUDE_DEG: 57.5426875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084300',
        LOCATION_NAME: 'Strathdon',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0680313,
        LOCATION_LATITUDE_DEG: 57.2019391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084400',
        LOCATION_NAME: 'Strathenry',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2407511,
        LOCATION_LATITUDE_DEG: 56.2025402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084450',
        LOCATION_NAME: 'Strathfoyle',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2393375,
        LOCATION_LATITUDE_DEG: 55.0414862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084500',
        LOCATION_NAME: 'Strathkanaird',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1277974,
        LOCATION_LATITUDE_DEG: 57.9670983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084600',
        LOCATION_NAME: 'Strathkinness',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8753189,
        LOCATION_LATITUDE_DEG: 56.333947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084700',
        LOCATION_NAME: 'Strathlachlan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1526519,
        LOCATION_LATITUDE_DEG: 56.1221475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084800',
        LOCATION_NAME: 'Strathmartine',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0078093,
        LOCATION_LATITUDE_DEG: 56.5071635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST084900',
        LOCATION_NAME: 'Strathmiglo',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2683779,
        LOCATION_LATITUDE_DEG: 56.2780499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085000',
        LOCATION_NAME: 'Strathnaver',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2291252,
        LOCATION_LATITUDE_DEG: 58.3706654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085100',
        LOCATION_NAME: 'Strathore',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1788536,
        LOCATION_LATITUDE_DEG: 56.1623304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085200',
        LOCATION_NAME: 'Strathpeffer',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5443899,
        LOCATION_LATITUDE_DEG: 57.5832872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085250',
        LOCATION_NAME: 'Strathroy',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3100219,
        LOCATION_LATITUDE_DEG: 54.616416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085300',
        LOCATION_NAME: 'Strathrusdale',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4056129,
        LOCATION_LATITUDE_DEG: 57.7696055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085400',
        LOCATION_NAME: 'Strathtay',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7831443,
        LOCATION_LATITUDE_DEG: 56.660194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085500',
        LOCATION_NAME: 'Strathtongue',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.367991,
        LOCATION_LATITUDE_DEG: 58.5018794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085600',
        LOCATION_NAME: 'Strathy',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9925419,
        LOCATION_LATITUDE_DEG: 58.5612855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085700',
        LOCATION_NAME: 'Strathyre',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3273965,
        LOCATION_LATITUDE_DEG: 56.32526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086000',
        LOCATION_NAME: 'Stratton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5160906,
        LOCATION_LATITUDE_DEG: 50.8305299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085800',
        LOCATION_NAME: 'Stratton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4929434,
        LOCATION_LATITUDE_DEG: 50.7416004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST085900',
        LOCATION_NAME: 'Stratton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9763109,
        LOCATION_LATITUDE_DEG: 51.7265908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086100',
        LOCATION_NAME: 'Stratton Audley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1158401,
        LOCATION_LATITUDE_DEG: 51.9301969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122500',
        LOCATION_NAME: 'Stratton on the Fosse',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST109900',
        LOCATION_NAME: 'Stratton St Margaret',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST110000',
        LOCATION_NAME: 'Stratton St Michael',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086200',
        LOCATION_NAME: 'Stratton St. Margaret',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7505621,
        LOCATION_LATITUDE_DEG: 51.5830723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086300',
        LOCATION_NAME: 'Stratton St. Michael',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2508383,
        LOCATION_LATITUDE_DEG: 52.4958217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086400',
        LOCATION_NAME: 'Stratton Strawless',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2919443,
        LOCATION_LATITUDE_DEG: 52.7373431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086500',
        LOCATION_NAME: 'Stratton-on-the-Fosse',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.495475,
        LOCATION_LATITUDE_DEG: 51.2522771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086600',
        LOCATION_NAME: 'Stravithie',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.747482,
        LOCATION_LATITUDE_DEG: 56.2909434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086700',
        LOCATION_NAME: 'Strawberry Valley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6193699,
        LOCATION_LATITUDE_DEG: 50.3437714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087000',
        LOCATION_NAME: 'Streat',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0770763,
        LOCATION_LATITUDE_DEG: 50.9201861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123900',
        LOCATION_NAME: 'Streatham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.13123,
        LOCATION_LATITUDE_DEG: 51.4305233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124000',
        LOCATION_NAME: 'Streatham Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.122656,
        LOCATION_LATITUDE_DEG: 51.4452348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087100',
        LOCATION_NAME: 'Streatlam',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.525056,
        LOCATION_LATITUDE_DEG: 54.39073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087300',
        LOCATION_NAME: 'Streatley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1473629,
        LOCATION_LATITUDE_DEG: 51.5221569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087200',
        LOCATION_NAME: 'Streatley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4421166,
        LOCATION_LATITUDE_DEG: 51.9458874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087400',
        LOCATION_NAME: 'Street',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7390536,
        LOCATION_LATITUDE_DEG: 51.1226426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087600',
        LOCATION_NAME: 'Street Ashton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3249211,
        LOCATION_LATITUDE_DEG: 52.4362448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087700',
        LOCATION_NAME: 'Street End',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0748312,
        LOCATION_LATITUDE_DEG: 51.238899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087800',
        LOCATION_NAME: 'Streethay',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7892925,
        LOCATION_LATITUDE_DEG: 52.6910775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087900',
        LOCATION_NAME: 'Streethouse',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4009776,
        LOCATION_LATITUDE_DEG: 53.6758732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088000',
        LOCATION_NAME: 'Streetlam',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.521259,
        LOCATION_LATITUDE_DEG: 54.38614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088100',
        LOCATION_NAME: 'Streetly',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8661858,
        LOCATION_LATITUDE_DEG: 52.5913738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088200',
        LOCATION_NAME: 'Strefford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8214653,
        LOCATION_LATITUDE_DEG: 52.4673725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088300',
        LOCATION_NAME: 'Strelley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2324364,
        LOCATION_LATITUDE_DEG: 52.9715013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088400',
        LOCATION_NAME: 'Strensall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0334716,
        LOCATION_LATITUDE_DEG: 54.0398037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088500',
        LOCATION_NAME: 'Strensall Camp',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.036439,
        LOCATION_LATITUDE_DEG: 54.0263979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088600',
        LOCATION_NAME: 'Strensham',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1291671,
        LOCATION_LATITUDE_DEG: 52.0533243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088700',
        LOCATION_NAME: 'Stretcholt',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0071455,
        LOCATION_LATITUDE_DEG: 51.1909508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088800',
        LOCATION_NAME: 'Strete',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6284576,
        LOCATION_LATITUDE_DEG: 50.3098683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089000',
        LOCATION_NAME: 'Stretford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8159601,
        LOCATION_LATITUDE_DEG: 52.1978466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST088900',
        LOCATION_NAME: 'Stretford',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3191582,
        LOCATION_LATITUDE_DEG: 53.4447585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089100',
        LOCATION_NAME: 'Strethall',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1665065,
        LOCATION_LATITUDE_DEG: 52.0358946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089200',
        LOCATION_NAME: 'Stretham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2199393,
        LOCATION_LATITUDE_DEG: 52.3475185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089300',
        LOCATION_NAME: 'Strettington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7288763,
        LOCATION_LATITUDE_DEG: 50.8559913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089400',
        LOCATION_NAME: 'Stretton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8225772,
        LOCATION_LATITUDE_DEG: 53.0710261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089850',
        LOCATION_NAME: 'Stretton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5752679,
        LOCATION_LATITUDE_DEG: 53.3395636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089700',
        LOCATION_NAME: 'Stretton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1710138,
        LOCATION_LATITUDE_DEG: 52.700285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089800',
        LOCATION_NAME: 'Stretton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6244293,
        LOCATION_LATITUDE_DEG: 52.8335939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089500',
        LOCATION_NAME: 'Stretton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4131408,
        LOCATION_LATITUDE_DEG: 53.1453145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990141',
        LOCATION_NAME: 'Stretton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5967838,
        LOCATION_LATITUDE_DEG: 52.7342103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089600',
        LOCATION_NAME: 'Stretton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5951087,
        LOCATION_LATITUDE_DEG: 52.7328688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122600',
        LOCATION_NAME: 'Stretton en le Field',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5494166,
        LOCATION_LATITUDE_DEG: 52.7057198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST089900',
        LOCATION_NAME: 'Stretton Grandison',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5377051,
        LOCATION_LATITUDE_DEG: 52.0924334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090000',
        LOCATION_NAME: 'Stretton Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9385922,
        LOCATION_LATITUDE_DEG: 52.6938969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090300',
        LOCATION_NAME: 'Stretton on Dunsmore',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4006377,
        LOCATION_LATITUDE_DEG: 52.3497432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090400',
        LOCATION_NAME: 'Stretton on Fosse',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6769885,
        LOCATION_LATITUDE_DEG: 52.0440147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090100',
        LOCATION_NAME: 'Stretton Sugwas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7813722,
        LOCATION_LATITUDE_DEG: 52.0778342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090500',
        LOCATION_NAME: 'Stretton under Fosse',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.336247,
        LOCATION_LATITUDE_DEG: 52.4285495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090200',
        LOCATION_NAME: 'Stretton Westwood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5939547,
        LOCATION_LATITUDE_DEG: 52.5834776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090600',
        LOCATION_NAME: 'Stretton-en-le-Field',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5480791,
        LOCATION_LATITUDE_DEG: 52.7033771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090700',
        LOCATION_NAME: 'Strichen',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0915688,
        LOCATION_LATITUDE_DEG: 57.5883636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090800',
        LOCATION_NAME: 'Strines',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0321699,
        LOCATION_LATITUDE_DEG: 53.3745492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST090900',
        LOCATION_NAME: 'Strinesdale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0453204,
        LOCATION_LATITUDE_DEG: 53.5555668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091000',
        LOCATION_NAME: 'Stringston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1776053,
        LOCATION_LATITUDE_DEG: 51.1748529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091100',
        LOCATION_NAME: 'Strixton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6808622,
        LOCATION_LATITUDE_DEG: 52.2463198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091200',
        LOCATION_NAME: 'Stroat',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6092879,
        LOCATION_LATITUDE_DEG: 51.682489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091300',
        LOCATION_NAME: 'Strode',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9028046,
        LOCATION_LATITUDE_DEG: 50.365582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091600',
        LOCATION_NAME: 'Strombane',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.181437,
        LOCATION_LATITUDE_DEG: 57.5972183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091700',
        LOCATION_NAME: 'Strome Ferry',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5531582,
        LOCATION_LATITUDE_DEG: 57.351275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091800',
        LOCATION_NAME: 'Stromness',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2976371,
        LOCATION_LATITUDE_DEG: 58.9625178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091900',
        LOCATION_NAME: 'Stronachlachar',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5806692,
        LOCATION_LATITUDE_DEG: 56.258155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092000',
        LOCATION_NAME: 'Strond',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9942667,
        LOCATION_LATITUDE_DEG: 57.749226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092100',
        LOCATION_NAME: 'Strone',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0420386,
        LOCATION_LATITUDE_DEG: 56.8888275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092200',
        LOCATION_NAME: 'Strone',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8993061,
        LOCATION_LATITUDE_DEG: 55.9854351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092300',
        LOCATION_NAME: 'Stronsay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5869855,
        LOCATION_LATITUDE_DEG: 59.106421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092400',
        LOCATION_NAME: 'Strontian',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5673397,
        LOCATION_LATITUDE_DEG: 56.6953126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092500',
        LOCATION_NAME: 'Strood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4781292,
        LOCATION_LATITUDE_DEG: 51.3916249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092600',
        LOCATION_NAME: 'Strood Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2772323,
        LOCATION_LATITUDE_DEG: 51.2280198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092900',
        LOCATION_NAME: 'Stroud',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2141825,
        LOCATION_LATITUDE_DEG: 51.7471968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092800',
        LOCATION_NAME: 'Stroud',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9702366,
        LOCATION_LATITUDE_DEG: 51.0073059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST124700',
        LOCATION_NAME: 'Stroud Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'N4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1035162,
        LOCATION_LATITUDE_DEG: 51.5718443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093000',
        LOCATION_NAME: 'Stroxton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6555355,
        LOCATION_LATITUDE_DEG: 52.8696778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093050',
        LOCATION_NAME: 'Struan',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4167155,
        LOCATION_LATITUDE_DEG: 57.3564145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093100',
        LOCATION_NAME: 'Strubby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1813558,
        LOCATION_LATITUDE_DEG: 53.3179142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093200',
        LOCATION_NAME: 'Strumore',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1781377,
        LOCATION_LATITUDE_DEG: 57.6091158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093300',
        LOCATION_NAME: 'Strumpshaw',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4792807,
        LOCATION_LATITUDE_DEG: 52.6183272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093400',
        LOCATION_NAME: 'Struy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6641916,
        LOCATION_LATITUDE_DEG: 57.4219771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093600',
        LOCATION_NAME: 'Stuartfield',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0428396,
        LOCATION_LATITUDE_DEG: 57.5023544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093700',
        LOCATION_NAME: 'Stubbing Holme',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0303228,
        LOCATION_LATITUDE_DEG: 53.7362822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093800',
        LOCATION_NAME: 'Stubbington',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2114365,
        LOCATION_LATITUDE_DEG: 50.8244907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093900',
        LOCATION_NAME: 'Stubbs Cross',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8402604,
        LOCATION_LATITUDE_DEG: 51.1225929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094000',
        LOCATION_NAME: 'Stubhampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1172748,
        LOCATION_LATITUDE_DEG: 50.9227149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094100',
        LOCATION_NAME: 'Stubton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6971001,
        LOCATION_LATITUDE_DEG: 53.0294964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094200',
        LOCATION_NAME: 'Stubwood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8513206,
        LOCATION_LATITUDE_DEG: 52.9521027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094300',
        LOCATION_NAME: 'Stuchbury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1692954,
        LOCATION_LATITUDE_DEG: 52.0915152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094400',
        LOCATION_NAME: 'Stuckton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7724414,
        LOCATION_LATITUDE_DEG: 50.9188108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094500',
        LOCATION_NAME: 'Studham',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5238126,
        LOCATION_LATITUDE_DEG: 51.8304768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094600',
        LOCATION_NAME: 'Studland',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9515848,
        LOCATION_LATITUDE_DEG: 50.6422889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094900',
        LOCATION_NAME: 'Studley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5847225,
        LOCATION_LATITUDE_DEG: 52.3663606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094800',
        LOCATION_NAME: 'Studley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0490546,
        LOCATION_LATITUDE_DEG: 51.442163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST094700',
        LOCATION_NAME: 'Studley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8936588,
        LOCATION_LATITUDE_DEG: 52.2741422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095000',
        LOCATION_NAME: 'Studley Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8600765,
        LOCATION_LATITUDE_DEG: 51.6496717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095100',
        LOCATION_NAME: 'Studley Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5654556,
        LOCATION_LATITUDE_DEG: 54.1220119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095200',
        LOCATION_NAME: 'Studley Roger',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5571356,
        LOCATION_LATITUDE_DEG: 54.1302151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095300',
        LOCATION_NAME: 'Stump Cross',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8491051,
        LOCATION_LATITUDE_DEG: 53.7300785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095400',
        LOCATION_NAME: 'Stuntney',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2858939,
        LOCATION_LATITUDE_DEG: 52.3806226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095500',
        LOCATION_NAME: 'Sturmer',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4775644,
        LOCATION_LATITUDE_DEG: 52.0682905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095600',
        LOCATION_NAME: 'Sturminster Marshall',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0711577,
        LOCATION_LATITUDE_DEG: 50.8006025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095700',
        LOCATION_NAME: 'Sturminster Newton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3038249,
        LOCATION_LATITUDE_DEG: 50.9262187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095800',
        LOCATION_NAME: 'Sturry',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1246595,
        LOCATION_LATITUDE_DEG: 51.3010073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST095900',
        LOCATION_NAME: 'Sturthill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6758746,
        LOCATION_LATITUDE_DEG: 50.7219046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096000',
        LOCATION_NAME: 'Sturton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6611116,
        LOCATION_LATITUDE_DEG: 53.3150262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096100',
        LOCATION_NAME: 'Sturton by Stow',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6642793,
        LOCATION_LATITUDE_DEG: 53.3126253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST122700',
        LOCATION_NAME: 'Sturton le Steeple',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096200',
        LOCATION_NAME: 'Sturton-le-Steeple',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8176065,
        LOCATION_LATITUDE_DEG: 53.3459253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096300',
        LOCATION_NAME: 'Stuston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1337567,
        LOCATION_LATITUDE_DEG: 52.3541084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096400',
        LOCATION_NAME: 'Stutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2709617,
        LOCATION_LATITUDE_DEG: 53.8663902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096500',
        LOCATION_NAME: 'Stutton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1305013,
        LOCATION_LATITUDE_DEG: 51.9699724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096600',
        LOCATION_NAME: 'Styal',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2407494,
        LOCATION_LATITUDE_DEG: 53.3480519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096700',
        LOCATION_NAME: 'Stype',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5442418,
        LOCATION_LATITUDE_DEG: 51.3833474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST096800',
        LOCATION_NAME: 'Styrrup',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0855356,
        LOCATION_LATITUDE_DEG: 53.4082424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000100',
        LOCATION_NAME: 'Subberthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1329065,
        LOCATION_LATITUDE_DEG: 54.2719492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000200',
        LOCATION_NAME: 'Succoth',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7460083,
        LOCATION_LATITUDE_DEG: 56.2098551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000300',
        LOCATION_NAME: 'Suckley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4057538,
        LOCATION_LATITUDE_DEG: 52.1617381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000400',
        LOCATION_NAME: 'Sudborough',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5776826,
        LOCATION_LATITUDE_DEG: 52.4280354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000500',
        LOCATION_NAME: 'Sudbourne',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5253063,
        LOCATION_LATITUDE_DEG: 52.1225807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000600',
        LOCATION_NAME: 'Sudbrook',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7220821,
        LOCATION_LATITUDE_DEG: 51.5852798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000700',
        LOCATION_NAME: 'Sudbrook',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5525143,
        LOCATION_LATITUDE_DEG: 52.9906917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000800',
        LOCATION_NAME: 'Sudbrooke',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4472856,
        LOCATION_LATITUDE_DEG: 53.2623201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001000',
        LOCATION_NAME: 'Sudbury',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7606035,
        LOCATION_LATITUDE_DEG: 52.8852012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU000900',
        LOCATION_NAME: 'Sudbury',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7298197,
        LOCATION_LATITUDE_DEG: 52.0412813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001100',
        LOCATION_NAME: 'Suddon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4331453,
        LOCATION_LATITUDE_DEG: 51.0576261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001200',
        LOCATION_NAME: 'Suffield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4818769,
        LOCATION_LATITUDE_DEG: 54.3034195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001300',
        LOCATION_NAME: 'Suffield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3144156,
        LOCATION_LATITUDE_DEG: 52.845452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001400',
        LOCATION_NAME: 'Sugden',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.584175,
        LOCATION_LATITUDE_DEG: 52.7303919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001500',
        LOCATION_NAME: 'Sugnall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3001018,
        LOCATION_LATITUDE_DEG: 52.8752008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001600',
        LOCATION_NAME: 'Suladale',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3731204,
        LOCATION_LATITUDE_DEG: 57.4916008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001700',
        LOCATION_NAME: 'Sulby',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4919295,
        LOCATION_LATITUDE_DEG: 54.3214184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001750',
        LOCATION_NAME: 'Sulby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0370676,
        LOCATION_LATITUDE_DEG: 52.4316798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001800',
        LOCATION_NAME: 'Sulgrave',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1856165,
        LOCATION_LATITUDE_DEG: 52.1035162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU001900',
        LOCATION_NAME: 'Sulham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0735096,
        LOCATION_LATITUDE_DEG: 51.4633506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002000',
        LOCATION_NAME: 'Sulhamstead',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0912584,
        LOCATION_LATITUDE_DEG: 51.4134443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002100',
        LOCATION_NAME: 'Sullington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4357943,
        LOCATION_LATITUDE_DEG: 50.9076906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002200',
        LOCATION_NAME: 'Sullom',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3529434,
        LOCATION_LATITUDE_DEG: 60.4419395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002300',
        LOCATION_NAME: 'Sully',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2212992,
        LOCATION_LATITUDE_DEG: 51.406773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002400',
        LOCATION_NAME: 'Sumburgh Airport',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2967618,
        LOCATION_LATITUDE_DEG: 59.8796825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002600',
        LOCATION_NAME: 'Summerbridge',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6918271,
        LOCATION_LATITUDE_DEG: 54.0570095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002700',
        LOCATION_NAME: 'Summercourt',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9709845,
        LOCATION_LATITUDE_DEG: 50.3664875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002800',
        LOCATION_NAME: 'Summerfield',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2401501,
        LOCATION_LATITUDE_DEG: 52.3580503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002900',
        LOCATION_NAME: 'Summerfield Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9484685,
        LOCATION_LATITUDE_DEG: 52.4845631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003000',
        LOCATION_NAME: 'Summergangs',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3234508,
        LOCATION_LATITUDE_DEG: 53.7629639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU457925',
        LOCATION_NAME: 'Summerhill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9129451,
        LOCATION_LATITUDE_DEG: 51.7504131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003100',
        LOCATION_NAME: 'Summerhill',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0287333,
        LOCATION_LATITUDE_DEG: 53.0783321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003200',
        LOCATION_NAME: 'Summerhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8870836,
        LOCATION_LATITUDE_DEG: 52.651472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003500',
        LOCATION_NAME: 'Summerhill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.251803,
        LOCATION_LATITUDE_DEG: 50.8442793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003600',
        LOCATION_NAME: 'Summerhouse',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6865586,
        LOCATION_LATITUDE_DEG: 54.566461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003700',
        LOCATION_NAME: 'Summerseat',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.310278,
        LOCATION_LATITUDE_DEG: 53.6289756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015600',
        LOCATION_NAME: 'Summerstown',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1807543,
        LOCATION_LATITUDE_DEG: 51.4417081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003800',
        LOCATION_NAME: 'Summertown',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2635139,
        LOCATION_LATITUDE_DEG: 51.7803883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004000',
        LOCATION_NAME: 'Summit',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1346898,
        LOCATION_LATITUDE_DEG: 53.582971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004100',
        LOCATION_NAME: 'Sunbrick',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.089003,
        LOCATION_LATITUDE_DEG: 54.153835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015400',
        LOCATION_NAME: 'Sunbury',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4140531,
        LOCATION_LATITUDE_DEG: 51.4078824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014500',
        LOCATION_NAME: 'Sunbury on Thames',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004200',
        LOCATION_NAME: 'Sunbury-on-Thames',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3984401,
        LOCATION_LATITUDE_DEG: 51.39954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004400',
        LOCATION_NAME: 'Sunderland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2737403,
        LOCATION_LATITUDE_DEG: 54.7073944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004500',
        LOCATION_NAME: 'Sunderland',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3865456,
        LOCATION_LATITUDE_DEG: 54.9053918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004600',
        LOCATION_NAME: 'Sunderland Bridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5804186,
        LOCATION_LATITUDE_DEG: 54.7333758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004700',
        LOCATION_NAME: 'Sunderland Point',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8753883,
        LOCATION_LATITUDE_DEG: 53.9935161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004800',
        LOCATION_NAME: 'Sundon',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4789622,
        LOCATION_LATITUDE_DEG: 51.9402722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004900',
        LOCATION_NAME: 'Sundon Park',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4622515,
        LOCATION_LATITUDE_DEG: 51.917088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005000',
        LOCATION_NAME: 'Sundridge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1233141,
        LOCATION_LATITUDE_DEG: 51.2775152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005100',
        LOCATION_NAME: 'Sundrum',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5158168,
        LOCATION_LATITUDE_DEG: 55.4587815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005200',
        LOCATION_NAME: 'Sunk Island',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0823428,
        LOCATION_LATITUDE_DEG: 53.6514516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005300',
        LOCATION_NAME: 'Sunningdale',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6278681,
        LOCATION_LATITUDE_DEG: 51.3983412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005400',
        LOCATION_NAME: 'Sunninghill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6542338,
        LOCATION_LATITUDE_DEG: 51.4008413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005500',
        LOCATION_NAME: 'Sunningwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2812217,
        LOCATION_LATITUDE_DEG: 51.7014735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005800',
        LOCATION_NAME: 'Sunniside',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7827384,
        LOCATION_LATITUDE_DEG: 54.7407736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005600',
        LOCATION_NAME: 'Sunniside',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6729623,
        LOCATION_LATITUDE_DEG: 54.9231896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005700',
        LOCATION_NAME: 'Sunniside',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4834101,
        LOCATION_LATITUDE_DEG: 54.8515844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU005900',
        LOCATION_NAME: 'Sunny Bank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0919884,
        LOCATION_LATITUDE_DEG: 54.321756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006000',
        LOCATION_NAME: 'Sunny Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.465551,
        LOCATION_LATITUDE_DEG: 51.0972335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006100',
        LOCATION_NAME: 'Sunnybank',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1933034,
        LOCATION_LATITUDE_DEG: 51.6720008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006200',
        LOCATION_NAME: 'Sunnybrow',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.697404,
        LOCATION_LATITUDE_DEG: 54.7038761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006400',
        LOCATION_NAME: 'Sunnyhill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.753672,
        LOCATION_LATITUDE_DEG: 51.3572484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006300',
        LOCATION_NAME: 'Sunnyhill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4924908,
        LOCATION_LATITUDE_DEG: 52.8940949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006500',
        LOCATION_NAME: 'Sunnymead',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0894583,
        LOCATION_LATITUDE_DEG: 52.7585019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006600',
        LOCATION_NAME: 'Sunnyside',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7951269,
        LOCATION_LATITUDE_DEG: 52.5530767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006700',
        LOCATION_NAME: 'Sunnyside',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2744684,
        LOCATION_LATITUDE_DEG: 53.4322479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006800',
        LOCATION_NAME: 'Sunset',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0184734,
        LOCATION_LATITUDE_DEG: 52.2058487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU006900',
        LOCATION_NAME: 'Surbiton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3028109,
        LOCATION_LATITUDE_DEG: 51.3926358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007000',
        LOCATION_NAME: 'Surfleet',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1425601,
        LOCATION_LATITUDE_DEG: 52.836469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007100',
        LOCATION_NAME: 'Surlingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4194314,
        LOCATION_LATITUDE_DEG: 52.6057248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007300',
        LOCATION_NAME: 'Surrey Research Park',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6053683,
        LOCATION_LATITUDE_DEG: 51.2379217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007400',
        LOCATION_NAME: 'Sustead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.251678,
        LOCATION_LATITUDE_DEG: 52.8853516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007500',
        LOCATION_NAME: 'Susworth',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7402708,
        LOCATION_LATITUDE_DEG: 53.5091422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007600',
        LOCATION_NAME: 'Sutcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3509978,
        LOCATION_LATITUDE_DEG: 50.8784372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007700',
        LOCATION_NAME: 'Suton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0878972,
        LOCATION_LATITUDE_DEG: 52.5524292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007800',
        LOCATION_NAME: 'Sutterby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0767691,
        LOCATION_LATITUDE_DEG: 53.2300104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU007900',
        LOCATION_NAME: 'Sutterton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0902707,
        LOCATION_LATITUDE_DEG: 52.9022771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU990403',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU990943',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008600',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7333099,
        LOCATION_LATITUDE_DEG: 52.6902915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008500',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.540369,
        LOCATION_LATITUDE_DEG: 51.1014353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008400',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4958065,
        LOCATION_LATITUDE_DEG: 52.8821061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009200',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3996422,
        LOCATION_LATITUDE_DEG: 52.4760681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU990327',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3504717,
        LOCATION_LATITUDE_DEG: 52.797259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU990326',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3503843,
        LOCATION_LATITUDE_DEG: 52.797466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008800',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9158266,
        LOCATION_LATITUDE_DEG: 50.8884065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009300',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3988583,
        LOCATION_LATITUDE_DEG: 51.7565825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008100',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.168093,
        LOCATION_LATITUDE_DEG: 53.6043547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009500',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9760163,
        LOCATION_LATITUDE_DEG: 53.3558315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008700',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6061613,
        LOCATION_LATITUDE_DEG: 50.9303913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009400',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3802081,
        LOCATION_LATITUDE_DEG: 52.5765498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008300',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2197114,
        LOCATION_LATITUDE_DEG: 52.1120042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008200',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1901453,
        LOCATION_LATITUDE_DEG: 51.3599304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008000',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1202911,
        LOCATION_LATITUDE_DEG: 52.3877213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009100',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3434346,
        LOCATION_LATITUDE_DEG: 51.1937969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU008900',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3674589,
        LOCATION_LATITUDE_DEG: 52.0615778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009000',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.534917,
        LOCATION_LATITUDE_DEG: 52.7597383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013000',
        LOCATION_NAME: 'Sutton at Hone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2386116,
        LOCATION_LATITUDE_DEG: 51.4086255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009600',
        LOCATION_NAME: 'Sutton Bassett',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.858832,
        LOCATION_LATITUDE_DEG: 52.5086526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009700',
        LOCATION_NAME: 'Sutton Benger',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0771945,
        LOCATION_LATITUDE_DEG: 51.5065704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009800',
        LOCATION_NAME: 'Sutton Bingham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6446803,
        LOCATION_LATITUDE_DEG: 50.897521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU009900',
        LOCATION_NAME: 'Sutton Bonington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2465641,
        LOCATION_LATITUDE_DEG: 52.8183831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010000',
        LOCATION_NAME: 'Sutton Bridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1903523,
        LOCATION_LATITUDE_DEG: 52.7686637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010100',
        LOCATION_NAME: 'Sutton Cheney',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.384719,
        LOCATION_LATITUDE_DEG: 52.5990669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010200',
        LOCATION_NAME: 'Sutton Coldfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8225314,
        LOCATION_LATITUDE_DEG: 52.5619702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010300',
        LOCATION_NAME: 'Sutton Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4269999,
        LOCATION_LATITUDE_DEG: 52.6142807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010400',
        LOCATION_NAME: 'Sutton Courtenay',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.274954,
        LOCATION_LATITUDE_DEG: 51.6417704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014600',
        LOCATION_NAME: 'Sutton cum Beckingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013100',
        LOCATION_NAME: 'Sutton cum Granby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8683153,
        LOCATION_LATITUDE_DEG: 52.9287903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010500',
        LOCATION_NAME: 'Sutton Grange',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5692899,
        LOCATION_LATITUDE_DEG: 54.159517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010600',
        LOCATION_NAME: 'Sutton Green',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5568943,
        LOCATION_LATITUDE_DEG: 51.2802239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010700',
        LOCATION_NAME: 'Sutton Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4868559,
        LOCATION_LATITUDE_DEG: 52.8778007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU990532',
        LOCATION_NAME: 'Sutton Heath',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3668015,
        LOCATION_LATITUDE_DEG: 52.0619564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010800',
        LOCATION_NAME: 'Sutton Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4332849,
        LOCATION_LATITUDE_DEG: 52.6299829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU010900',
        LOCATION_NAME: 'Sutton Howgrave',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5159653,
        LOCATION_LATITUDE_DEG: 54.2076189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014700',
        LOCATION_NAME: 'Sutton in Ashfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014800',
        LOCATION_NAME: 'Sutton in Craven',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011000',
        LOCATION_NAME: 'Sutton Ings',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3005197,
        LOCATION_LATITUDE_DEG: 53.7694645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011100',
        LOCATION_NAME: 'Sutton Lakes',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6657181,
        LOCATION_LATITUDE_DEG: 52.1170378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011200',
        LOCATION_NAME: 'Sutton Leach',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7090888,
        LOCATION_LATITUDE_DEG: 53.4283642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011300',
        LOCATION_NAME: 'Sutton Maddock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4089954,
        LOCATION_LATITUDE_DEG: 52.609678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011400',
        LOCATION_NAME: 'Sutton Mallet',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8876631,
        LOCATION_LATITUDE_DEG: 51.130944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011500',
        LOCATION_NAME: 'Sutton Mandeville',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0179665,
        LOCATION_LATITUDE_DEG: 51.0585261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011600',
        LOCATION_NAME: 'Sutton Manor',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7261985,
        LOCATION_LATITUDE_DEG: 53.4148576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011700',
        LOCATION_NAME: 'Sutton Montis',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5353076,
        LOCATION_LATITUDE_DEG: 51.0193321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013200',
        LOCATION_NAME: 'Sutton on Derwent',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.922674,
        LOCATION_LATITUDE_DEG: 53.911988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014900',
        LOCATION_NAME: 'Sutton on Hull',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015000',
        LOCATION_NAME: 'Sutton on Sea',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015200',
        LOCATION_NAME: 'Sutton on the Forest',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015300',
        LOCATION_NAME: 'Sutton on the Hill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015100',
        LOCATION_NAME: 'Sutton on Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011800',
        LOCATION_NAME: 'Sutton Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8708973,
        LOCATION_LATITUDE_DEG: 52.5705651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU011900',
        LOCATION_NAME: 'Sutton Poyntz',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4144833,
        LOCATION_LATITUDE_DEG: 50.6556912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012000',
        LOCATION_NAME: 'Sutton Scarsdale',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3401514,
        LOCATION_LATITUDE_DEG: 53.2129247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012100',
        LOCATION_NAME: 'Sutton Scotney',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3366421,
        LOCATION_LATITUDE_DEG: 51.1526301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014200',
        LOCATION_NAME: 'Sutton St Edmund',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014300',
        LOCATION_NAME: 'Sutton St James',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014400',
        LOCATION_NAME: 'Sutton St Nicholas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012200',
        LOCATION_NAME: 'Sutton St. Edmund',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0257304,
        LOCATION_LATITUDE_DEG: 52.6997519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012300',
        LOCATION_NAME: 'Sutton St. James',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0641726,
        LOCATION_LATITUDE_DEG: 52.7436628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012400',
        LOCATION_NAME: 'Sutton St. Nicholas',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6823896,
        LOCATION_LATITUDE_DEG: 52.1059366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013300',
        LOCATION_NAME: 'Sutton under Brailes',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5614807,
        LOCATION_LATITUDE_DEG: 52.0337146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU990401',
        LOCATION_NAME: 'Sutton Under Whitestonecliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012500',
        LOCATION_NAME: 'Sutton Valence',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5930924,
        LOCATION_LATITUDE_DEG: 51.2128106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012600',
        LOCATION_NAME: 'Sutton Veny',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1465082,
        LOCATION_LATITUDE_DEG: 51.1782418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012700',
        LOCATION_NAME: 'Sutton Waldron',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1976086,
        LOCATION_LATITUDE_DEG: 50.9422122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012800',
        LOCATION_NAME: 'Sutton Weaver',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6848503,
        LOCATION_LATITUDE_DEG: 53.3090486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU012900',
        LOCATION_NAME: 'Sutton Wood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4328957,
        LOCATION_LATITUDE_DEG: 52.6219825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013400',
        LOCATION_NAME: 'Sutton-cum-Beckingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6894748,
        LOCATION_LATITUDE_DEG: 53.0621031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013500',
        LOCATION_NAME: 'Sutton-in-Ashfield',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2680106,
        LOCATION_LATITUDE_DEG: 53.1241121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013600',
        LOCATION_NAME: 'Sutton-in-Craven',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9878404,
        LOCATION_LATITUDE_DEG: 53.8939972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013700',
        LOCATION_NAME: 'Sutton-on-Hull',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3026254,
        LOCATION_LATITUDE_DEG: 53.7804624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013800',
        LOCATION_NAME: 'Sutton-on-Sea',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2824408,
        LOCATION_LATITUDE_DEG: 53.3125155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014000',
        LOCATION_NAME: 'Sutton-on-the-Forest',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.111115,
        LOCATION_LATITUDE_DEG: 54.0742012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU014100',
        LOCATION_NAME: 'Sutton-on-the-Hill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6556605,
        LOCATION_LATITUDE_DEG: 52.9015756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU013900',
        LOCATION_NAME: 'Sutton-on-Trent',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8104751,
        LOCATION_LATITUDE_DEG: 53.1842167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000100',
        LOCATION_NAME: 'Swaby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0801694,
        LOCATION_LATITUDE_DEG: 53.2757089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000200',
        LOCATION_NAME: 'Swadlincote',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5557182,
        LOCATION_LATITUDE_DEG: 52.7745852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000300',
        LOCATION_NAME: 'Swaffham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6901982,
        LOCATION_LATITUDE_DEG: 52.6465445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000400',
        LOCATION_NAME: 'Swaffham Bulbeck',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2788913,
        LOCATION_LATITUDE_DEG: 52.239405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000500',
        LOCATION_NAME: 'Swaffham Prior',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3024989,
        LOCATION_LATITUDE_DEG: 52.2520048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000600',
        LOCATION_NAME: 'Swafield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3956739,
        LOCATION_LATITUDE_DEG: 52.8383501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000700',
        LOCATION_NAME: 'Swainbost',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2700549,
        LOCATION_LATITUDE_DEG: 58.479199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000800',
        LOCATION_NAME: 'Swainby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2644591,
        LOCATION_LATITUDE_DEG: 54.4111397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW990473',
        LOCATION_NAME: 'Swains hill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW000900',
        LOCATION_NAME: 'Swainshill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7911698,
        LOCATION_LATITUDE_DEG: 52.0715285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001000',
        LOCATION_NAME: 'Swainsthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2748038,
        LOCATION_LATITUDE_DEG: 52.5608218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001100',
        LOCATION_NAME: 'Swainswick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3486277,
        LOCATION_LATITUDE_DEG: 51.3995602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001200',
        LOCATION_NAME: 'Swaithe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4508698,
        LOCATION_LATITUDE_DEG: 53.5332524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001300',
        LOCATION_NAME: 'Swalcliffe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4504114,
        LOCATION_LATITUDE_DEG: 52.0378077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001400',
        LOCATION_NAME: 'Swalcliffe Lea',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4304114,
        LOCATION_LATITUDE_DEG: 52.0386119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001500',
        LOCATION_NAME: 'Swalecliffe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0670534,
        LOCATION_LATITUDE_DEG: 51.3607151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001600',
        LOCATION_NAME: 'Swallow',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2252288,
        LOCATION_LATITUDE_DEG: 53.5105339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001700',
        LOCATION_NAME: 'Swallow Tree',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.695935,
        LOCATION_LATITUDE_DEG: 51.7015199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001800',
        LOCATION_NAME: 'Swallow Vale',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2264804,
        LOCATION_LATITUDE_DEG: 53.5217369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW001900',
        LOCATION_NAME: 'Swallowcliffe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0507142,
        LOCATION_LATITUDE_DEG: 51.0425266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002000',
        LOCATION_NAME: 'Swallowfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9551524,
        LOCATION_LATITUDE_DEG: 51.378847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002100',
        LOCATION_NAME: 'Swallownest',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3317654,
        LOCATION_LATITUDE_DEG: 53.3830395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002200',
        LOCATION_NAME: 'Swalwell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6780105,
        LOCATION_LATITUDE_DEG: 54.9514953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002400',
        LOCATION_NAME: 'Swan Village',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0163627,
        LOCATION_LATITUDE_DEG: 52.5257698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002500',
        LOCATION_NAME: 'Swanage',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9597136,
        LOCATION_LATITUDE_DEG: 50.6138804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002600',
        LOCATION_NAME: 'Swanborough',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0085165,
        LOCATION_LATITUDE_DEG: 50.8501832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002700',
        LOCATION_NAME: 'Swanbourne',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8348814,
        LOCATION_LATITUDE_DEG: 51.9376967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002800',
        LOCATION_NAME: 'Swanbridge',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1867962,
        LOCATION_LATITUDE_DEG: 51.4031706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002900',
        LOCATION_NAME: 'Swancote',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3783708,
        LOCATION_LATITUDE_DEG: 52.5436696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003000',
        LOCATION_NAME: 'Swanland',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4799391,
        LOCATION_LATITUDE_DEG: 53.7416586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003100',
        LOCATION_NAME: 'Swanley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1779511,
        LOCATION_LATITUDE_DEG: 51.3953334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003300',
        LOCATION_NAME: 'Swanmore',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1787881,
        LOCATION_LATITUDE_DEG: 50.9436021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003400',
        LOCATION_NAME: 'Swannay',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2363233,
        LOCATION_LATITUDE_DEG: 59.1388312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003500',
        LOCATION_NAME: 'Swannington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3849423,
        LOCATION_LATITUDE_DEG: 52.7421755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003600',
        LOCATION_NAME: 'Swannington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1603534,
        LOCATION_LATITUDE_DEG: 52.7285409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003700',
        LOCATION_NAME: 'Swanpool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0797182,
        LOCATION_LATITUDE_DEG: 50.1410669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003800',
        LOCATION_NAME: 'Swanpool',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5887843,
        LOCATION_LATITUDE_DEG: 53.2215175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003900',
        LOCATION_NAME: 'Swanscombe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3120596,
        LOCATION_LATITUDE_DEG: 51.4465308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004000',
        LOCATION_NAME: 'Swansea',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9447763,
        LOCATION_LATITUDE_DEG: 51.6191962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004100',
        LOCATION_NAME: 'Swansea Airport',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.063788,
        LOCATION_LATITUDE_DEG: 51.6014969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004200',
        LOCATION_NAME: 'Swanton Abbott',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3579103,
        LOCATION_LATITUDE_DEG: 52.7782437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004300',
        LOCATION_NAME: 'Swanton Morley',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9833415,
        LOCATION_LATITUDE_DEG: 52.7092423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004400',
        LOCATION_NAME: 'Swanton Novers',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0010608,
        LOCATION_LATITUDE_DEG: 52.8502591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004500',
        LOCATION_NAME: 'Swanwick',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3968577,
        LOCATION_LATITUDE_DEG: 53.074813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004600',
        LOCATION_NAME: 'Swanwick',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2695685,
        LOCATION_LATITUDE_DEG: 50.8826982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004700',
        LOCATION_NAME: 'Swarby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4408771,
        LOCATION_LATITUDE_DEG: 52.9522903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004800',
        LOCATION_NAME: 'Swardeston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2524187,
        LOCATION_LATITUDE_DEG: 52.5778278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW004900',
        LOCATION_NAME: 'Swarkestone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4522136,
        LOCATION_LATITUDE_DEG: 52.8543937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005000',
        LOCATION_NAME: 'Swarland',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7410926,
        LOCATION_LATITUDE_DEG: 55.3278347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005100',
        LOCATION_NAME: 'Swarraton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1869208,
        LOCATION_LATITUDE_DEG: 51.1194173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005200',
        LOCATION_NAME: 'Swarthmoor',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.112391,
        LOCATION_LATITUDE_DEG: 54.1853434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005300',
        LOCATION_NAME: 'Swaton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3147466,
        LOCATION_LATITUDE_DEG: 52.9232797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005400',
        LOCATION_NAME: 'Swaton Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2814376,
        LOCATION_LATITUDE_DEG: 52.9145843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005500',
        LOCATION_NAME: 'Swatragh',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6736603,
        LOCATION_LATITUDE_DEG: 54.8913424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005600',
        LOCATION_NAME: 'Swavesey',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0030787,
        LOCATION_LATITUDE_DEG: 52.3011137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005700',
        LOCATION_NAME: 'Sway',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6060848,
        LOCATION_LATITUDE_DEG: 50.7861989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005800',
        LOCATION_NAME: 'Swayfield',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5276333,
        LOCATION_LATITUDE_DEG: 52.793668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW005900',
        LOCATION_NAME: 'Swaythling',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3744424,
        LOCATION_LATITUDE_DEG: 50.9467026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006000',
        LOCATION_NAME: 'Sweeney',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0615801,
        LOCATION_LATITUDE_DEG: 52.8206034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006200',
        LOCATION_NAME: 'Sweet Lake',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7739307,
        LOCATION_LATITUDE_DEG: 52.6862931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006300',
        LOCATION_NAME: 'Sweetshouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6941736,
        LOCATION_LATITUDE_DEG: 50.4238909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006400',
        LOCATION_NAME: 'Sweffling',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4385145,
        LOCATION_LATITUDE_DEG: 52.2211913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW990458',
        LOCATION_NAME: 'Swell',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006600',
        LOCATION_NAME: 'Swepstone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.45563,
        LOCATION_LATITUDE_DEG: 52.6891788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006700',
        LOCATION_NAME: 'Swerford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4584262,
        LOCATION_LATITUDE_DEG: 51.9766105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006800',
        LOCATION_NAME: 'Swettenham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2973941,
        LOCATION_LATITUDE_DEG: 53.2020371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006900',
        LOCATION_NAME: 'Swettenham Heath',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2848375,
        LOCATION_LATITUDE_DEG: 53.2073359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW990569',
        LOCATION_NAME: 'Swffryd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007000',
        LOCATION_NAME: 'Swilland',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1981669,
        LOCATION_LATITUDE_DEG: 52.1306844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007100',
        LOCATION_NAME: 'Swillington',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4178846,
        LOCATION_LATITUDE_DEG: 53.7672786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007200',
        LOCATION_NAME: 'Swillington Common',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3969514,
        LOCATION_LATITUDE_DEG: 53.82618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007300',
        LOCATION_NAME: 'Swimbridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.965492,
        LOCATION_LATITUDE_DEG: 51.0495451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007400',
        LOCATION_NAME: 'Swinbrook',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5929767,
        LOCATION_LATITUDE_DEG: 51.806395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007500',
        LOCATION_NAME: 'Swinderby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7003499,
        LOCATION_LATITUDE_DEG: 53.1574069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007700',
        LOCATION_NAME: 'Swindon',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2024105,
        LOCATION_LATITUDE_DEG: 52.5125699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007600',
        LOCATION_NAME: 'Swindon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN99',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7824561,
        LOCATION_LATITUDE_DEG: 51.5600702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007800',
        LOCATION_NAME: 'Swindon Village',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0930876,
        LOCATION_LATITUDE_DEG: 51.9220067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW007900',
        LOCATION_NAME: 'Swine',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2738413,
        LOCATION_LATITUDE_DEG: 53.8060692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008000',
        LOCATION_NAME: 'Swinefleet',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8327249,
        LOCATION_LATITUDE_DEG: 53.6903634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008100',
        LOCATION_NAME: 'Swinefleet Fields',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8214982,
        LOCATION_LATITUDE_DEG: 53.6926627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008200',
        LOCATION_NAME: 'Swineford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4312013,
        LOCATION_LATITUDE_DEG: 51.4204633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008400',
        LOCATION_NAME: 'Swineshead',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4496405,
        LOCATION_LATITUDE_DEG: 52.2801253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008500',
        LOCATION_NAME: 'Swineshead',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1575864,
        LOCATION_LATITUDE_DEG: 52.9447828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008600',
        LOCATION_NAME: 'Swinethorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6898598,
        LOCATION_LATITUDE_DEG: 53.2150116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW990340',
        LOCATION_NAME: 'Swinfen',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8010745,
        LOCATION_LATITUDE_DEG: 52.651188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008700',
        LOCATION_NAME: 'Swinford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3561021,
        LOCATION_LATITUDE_DEG: 51.7726859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008800',
        LOCATION_NAME: 'Swinford',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1636787,
        LOCATION_LATITUDE_DEG: 52.4099398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009000',
        LOCATION_NAME: 'Swingbrow',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0225332,
        LOCATION_LATITUDE_DEG: 52.4782361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009100',
        LOCATION_NAME: 'Swingfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1615594,
        LOCATION_LATITUDE_DEG: 51.1421022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009200',
        LOCATION_NAME: 'Swinhay',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.389245,
        LOCATION_LATITUDE_DEG: 51.6434894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009300',
        LOCATION_NAME: 'Swinhoe',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6634541,
        LOCATION_LATITUDE_DEG: 55.5495523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009400',
        LOCATION_NAME: 'Swinhope',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1660031,
        LOCATION_LATITUDE_DEG: 53.4461285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009500',
        LOCATION_NAME: 'Swinithwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9383624,
        LOCATION_LATITUDE_DEG: 54.298135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009600',
        LOCATION_NAME: 'Swinley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6265867,
        LOCATION_LATITUDE_DEG: 53.5529723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011800',
        LOCATION_NAME: 'Swinnow',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6401859,
        LOCATION_LATITUDE_DEG: 53.8003957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009700',
        LOCATION_NAME: 'Swinscoe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8105475,
        LOCATION_LATITUDE_DEG: 53.0306105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009800',
        LOCATION_NAME: 'Swinstead',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4898116,
        LOCATION_LATITUDE_DEG: 52.7901715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010000',
        LOCATION_NAME: 'Swinsty',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2895057,
        LOCATION_LATITUDE_DEG: 54.8387088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW009900',
        LOCATION_NAME: 'Swinsty',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7148053,
        LOCATION_LATITUDE_DEG: 53.9789003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010100',
        LOCATION_NAME: 'Swinthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3124576,
        LOCATION_LATITUDE_DEG: 53.2568104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010400',
        LOCATION_NAME: 'Swinton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.33423,
        LOCATION_LATITUDE_DEG: 53.5098645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010200',
        LOCATION_NAME: 'Swinton',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2636591,
        LOCATION_LATITUDE_DEG: 55.7197788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010600',
        LOCATION_NAME: 'Swinton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6746428,
        LOCATION_LATITUDE_DEG: 54.2128258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010300',
        LOCATION_NAME: 'Swinton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3184059,
        LOCATION_LATITUDE_DEG: 53.4879462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010500',
        LOCATION_NAME: 'Swinton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.838931,
        LOCATION_LATITUDE_DEG: 54.1482087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010700',
        LOCATION_NAME: 'Swinton Grange',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.842363,
        LOCATION_LATITUDE_DEG: 54.1377065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011700',
        LOCATION_NAME: 'Swiss Cottage',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1785775,
        LOCATION_LATITUDE_DEG: 51.557439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010800',
        LOCATION_NAME: 'Swithland',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1873438,
        LOCATION_LATITUDE_DEG: 52.7128718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW010900',
        LOCATION_NAME: 'Swordale',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2626453,
        LOCATION_LATITUDE_DEG: 58.1907697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011000',
        LOCATION_NAME: 'Swordale',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3919096,
        LOCATION_LATITUDE_DEG: 57.6587003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011200',
        LOCATION_NAME: 'Swyddffynnon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9166483,
        LOCATION_LATITUDE_DEG: 52.2785598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011300',
        LOCATION_NAME: 'Swyncombe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0000962,
        LOCATION_LATITUDE_DEG: 51.6056605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011400',
        LOCATION_NAME: 'Swynnerton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.21999,
        LOCATION_LATITUDE_DEG: 52.9184042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011500',
        LOCATION_NAME: 'Swyre',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6684303,
        LOCATION_LATITUDE_DEG: 50.6916022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000100',
        LOCATION_NAME: 'Sychdyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1339621,
        LOCATION_LATITUDE_DEG: 53.1885435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000200',
        LOCATION_NAME: 'Sychtyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1373507,
        LOCATION_LATITUDE_DEG: 52.8344129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000300',
        LOCATION_NAME: 'Syde',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.072801,
        LOCATION_LATITUDE_DEG: 51.7962954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002700',
        LOCATION_NAME: 'Sydenham',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8733928,
        LOCATION_LATITUDE_DEG: 54.6080224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000400',
        LOCATION_NAME: 'Sydenham',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5100217,
        LOCATION_LATITUDE_DEG: 52.276932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000500',
        LOCATION_NAME: 'Sydenham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9430915,
        LOCATION_LATITUDE_DEG: 51.7101769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002800',
        LOCATION_NAME: 'Sydenham',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.052826,
        LOCATION_LATITUDE_DEG: 51.4269084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000600',
        LOCATION_NAME: 'Sydenham Damerel',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2477547,
        LOCATION_LATITUDE_DEG: 50.5603011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000700',
        LOCATION_NAME: 'Syderstone',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7203754,
        LOCATION_LATITUDE_DEG: 52.8595629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002600',
        LOCATION_NAME: 'Sydling St Nicholas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000800',
        LOCATION_NAME: 'Sydling St. Nicholas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5223815,
        LOCATION_LATITUDE_DEG: 50.7924037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY990948',
        LOCATION_NAME: 'Sydney',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY000900',
        LOCATION_NAME: 'Syerston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.887453,
        LOCATION_LATITUDE_DEG: 53.019103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001000',
        LOCATION_NAME: 'Sykehouse',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0503835,
        LOCATION_LATITUDE_DEG: 53.6432576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001100',
        LOCATION_NAME: 'Syleham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2531631,
        LOCATION_LATITUDE_DEG: 52.3552049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001200',
        LOCATION_NAME: 'Symbister',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0173966,
        LOCATION_LATITUDE_DEG: 60.3444195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001300',
        LOCATION_NAME: 'Symington',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5608106,
        LOCATION_LATITUDE_DEG: 55.5482842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001350',
        LOCATION_NAME: 'Symington',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5950231,
        LOCATION_LATITUDE_DEG: 55.5998776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001400',
        LOCATION_NAME: 'Symonds Yat',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6416972,
        LOCATION_LATITUDE_DEG: 51.8413082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001500',
        LOCATION_NAME: 'Symonds Yat Rock',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6310264,
        LOCATION_LATITUDE_DEG: 51.840206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001600',
        LOCATION_NAME: 'Symondsbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7858287,
        LOCATION_LATITUDE_DEG: 50.7385016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001700',
        LOCATION_NAME: 'Synod Inn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.334102,
        LOCATION_LATITUDE_DEG: 52.164257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001800',
        LOCATION_NAME: 'Synwell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3418206,
        LOCATION_LATITUDE_DEG: 51.6373873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001900',
        LOCATION_NAME: 'Syre',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2364637,
        LOCATION_LATITUDE_DEG: 58.3636636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002000',
        LOCATION_NAME: 'Syresham',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0804776,
        LOCATION_LATITUDE_DEG: 52.0682142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002200',
        LOCATION_NAME: 'Syston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0712761,
        LOCATION_LATITUDE_DEG: 52.6988747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002100',
        LOCATION_NAME: 'Syston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6171013,
        LOCATION_LATITUDE_DEG: 52.9572859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002300',
        LOCATION_NAME: 'Syston Park',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6100596,
        LOCATION_LATITUDE_DEG: 52.9581927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002400',
        LOCATION_NAME: 'Sytchampton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.227286,
        LOCATION_LATITUDE_DEG: 52.2922418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY002500',
        LOCATION_NAME: 'Sywell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7954042,
        LOCATION_LATITUDE_DEG: 52.2977276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000100',
        LOCATION_NAME: 'Tabernacle Pitch',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3541161,
        LOCATION_LATITUDE_DEG: 51.6388886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000200',
        LOCATION_NAME: 'Tabor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8414343,
        LOCATION_LATITUDE_DEG: 52.7364061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA991036',
        LOCATION_NAME: 'Tachbrook Mallory',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5604063,
        LOCATION_LATITUDE_DEG: 52.2526385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000300',
        LOCATION_NAME: 'Tachbrook Park',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5464249,
        LOCATION_LATITUDE_DEG: 52.2749375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000400',
        LOCATION_NAME: 'Tacket Wood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7743896,
        LOCATION_LATITUDE_DEG: 50.2767708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000500',
        LOCATION_NAME: 'Tackley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3053722,
        LOCATION_LATITUDE_DEG: 51.8800963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000600',
        LOCATION_NAME: 'Tacolneston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1577135,
        LOCATION_LATITUDE_DEG: 52.5112261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000700',
        LOCATION_NAME: 'Tadcaster',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2623083,
        LOCATION_LATITUDE_DEG: 53.8827874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000800',
        LOCATION_NAME: 'Tadden',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0090987,
        LOCATION_LATITUDE_DEG: 50.8101031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA000900',
        LOCATION_NAME: 'Taddington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7894866,
        LOCATION_LATITUDE_DEG: 53.2363299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001000',
        LOCATION_NAME: 'Tadley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1270435,
        LOCATION_LATITUDE_DEG: 51.3497407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001100',
        LOCATION_NAME: 'Tadlow',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1303654,
        LOCATION_LATITUDE_DEG: 52.110603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001200',
        LOCATION_NAME: 'Tadmarton Heath',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4417915,
        LOCATION_LATITUDE_DEG: 52.019307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001300',
        LOCATION_NAME: 'Tadwick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3705261,
        LOCATION_LATITUDE_DEG: 51.4319656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001400',
        LOCATION_NAME: 'Tadworth',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.234491,
        LOCATION_LATITUDE_DEG: 51.2904293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001500',
        LOCATION_NAME: 'Tafarnaubach',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2743105,
        LOCATION_LATITUDE_DEG: 51.7842058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001700',
        LOCATION_NAME: 'Taffs Well',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2631623,
        LOCATION_LATITUDE_DEG: 51.5398849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001800',
        LOCATION_NAME: 'Tafolwern',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6414541,
        LOCATION_LATITUDE_DEG: 52.6095931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002400',
        LOCATION_NAME: 'Taibach',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7693695,
        LOCATION_LATITUDE_DEG: 51.5849999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002500',
        LOCATION_NAME: 'Tain',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0537959,
        LOCATION_LATITUDE_DEG: 57.8122068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002600',
        LOCATION_NAME: 'Tairgwaith',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8628129,
        LOCATION_LATITUDE_DEG: 51.7921176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002700',
        LOCATION_NAME: 'Takeley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2680363,
        LOCATION_LATITUDE_DEG: 51.8673695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990370',
        LOCATION_NAME: 'Tal y Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019300',
        LOCATION_NAME: 'Tal y Bont',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019100',
        LOCATION_NAME: 'Tal y Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990373',
        LOCATION_NAME: 'Tal y bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019400',
        LOCATION_NAME: 'Tal y Cafn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.815265,
        LOCATION_LATITUDE_DEG: 53.2290573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002800',
        LOCATION_NAME: 'Tal y Llyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9073232,
        LOCATION_LATITUDE_DEG: 52.6667016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019000',
        LOCATION_NAME: 'Tal Y Waenydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9464932,
        LOCATION_LATITUDE_DEG: 53.0127188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003300',
        LOCATION_NAME: 'Talachddu',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3373084,
        LOCATION_LATITUDE_DEG: 51.9883281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003400',
        LOCATION_NAME: 'Talacre',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3181998,
        LOCATION_LATITUDE_DEG: 53.3505619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003500',
        LOCATION_NAME: 'Talaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.321593,
        LOCATION_LATITUDE_DEG: 50.7875167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003600',
        LOCATION_NAME: 'Talbenny',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1317204,
        LOCATION_LATITUDE_DEG: 51.7638255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003700',
        LOCATION_NAME: 'Talbot Green',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3830979,
        LOCATION_LATITUDE_DEG: 51.5367876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003800',
        LOCATION_NAME: 'Taleford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2877323,
        LOCATION_LATITUDE_DEG: 50.7635125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003900',
        LOCATION_NAME: 'Talerddig',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5782217,
        LOCATION_LATITUDE_DEG: 52.5886926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004000',
        LOCATION_NAME: 'Talgarreg',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3002378,
        LOCATION_LATITUDE_DEG: 52.1354515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004100',
        LOCATION_NAME: 'Talgarth',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2309483,
        LOCATION_LATITUDE_DEG: 51.9955306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004200',
        LOCATION_NAME: 'Taliaris',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9798859,
        LOCATION_LATITUDE_DEG: 51.9338347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004300',
        LOCATION_NAME: 'Talke',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2612998,
        LOCATION_LATITUDE_DEG: 53.0770254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004400',
        LOCATION_NAME: 'Talke Pits',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2576631,
        LOCATION_LATITUDE_DEG: 53.0705245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004500',
        LOCATION_NAME: 'Talkin',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7028931,
        LOCATION_LATITUDE_DEG: 54.9090057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004600',
        LOCATION_NAME: 'Talland Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4878586,
        LOCATION_LATITUDE_DEG: 50.3377833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004800',
        LOCATION_NAME: 'Tallarn Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8216516,
        LOCATION_LATITUDE_DEG: 52.9894174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004900',
        LOCATION_NAME: 'Tallentire',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3842534,
        LOCATION_LATITUDE_DEG: 54.7052928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005000',
        LOCATION_NAME: 'Talley',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9866518,
        LOCATION_LATITUDE_DEG: 51.9753318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005100',
        LOCATION_NAME: 'Tallington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3822535,
        LOCATION_LATITUDE_DEG: 52.6600571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005500',
        LOCATION_NAME: 'Talmine',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4310716,
        LOCATION_LATITUDE_DEG: 58.5322848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005600',
        LOCATION_NAME: 'Talog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4262804,
        LOCATION_LATITUDE_DEG: 51.9009329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005700',
        LOCATION_NAME: 'Talsarn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1291411,
        LOCATION_LATITUDE_DEG: 52.1828936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005800',
        LOCATION_NAME: 'Talsarnau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0624651,
        LOCATION_LATITUDE_DEG: 52.9037241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005900',
        LOCATION_NAME: 'Talskiddy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9426516,
        LOCATION_LATITUDE_DEG: 50.4493007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006000',
        LOCATION_NAME: 'Talwrn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2655837,
        LOCATION_LATITUDE_DEG: 53.2700631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990371',
        LOCATION_NAME: 'Talybont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019200',
        LOCATION_NAME: 'Talybont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990367',
        LOCATION_NAME: 'Talybont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006100',
        LOCATION_NAME: 'Talybont',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9802744,
        LOCATION_LATITUDE_DEG: 52.4882853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990374',
        LOCATION_NAME: 'Tal-Y-Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003000',
        LOCATION_NAME: 'Tal-y-Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0913008,
        LOCATION_LATITUDE_DEG: 52.7733113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003100',
        LOCATION_NAME: 'Tal-y-Bont',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0889551,
        LOCATION_LATITUDE_DEG: 53.2134597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019500',
        LOCATION_NAME: 'Talybont on Usk',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006200',
        LOCATION_NAME: 'Talybont-on-Usk',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2895795,
        LOCATION_LATITUDE_DEG: 51.8960231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA003200',
        LOCATION_NAME: 'Tal-y-Cafn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8159674,
        LOCATION_LATITUDE_DEG: 53.2279496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006300',
        LOCATION_NAME: 'Talycoed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8502807,
        LOCATION_LATITUDE_DEG: 51.8315057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990654',
        LOCATION_NAME: 'Tal-y-coed',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006400',
        LOCATION_NAME: 'Talygarn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4046225,
        LOCATION_LATITUDE_DEG: 51.5103799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006500',
        LOCATION_NAME: 'Talyllyn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2998097,
        LOCATION_LATITUDE_DEG: 51.9377253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006600',
        LOCATION_NAME: 'Talysarn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2581591,
        LOCATION_LATITUDE_DEG: 53.0512414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002900',
        LOCATION_NAME: 'Tal-Y-Waenydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9431071,
        LOCATION_LATITUDE_DEG: 53.0080356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006700',
        LOCATION_NAME: 'Talywain',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0687779,
        LOCATION_LATITUDE_DEG: 51.7292057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006800',
        LOCATION_NAME: 'Talywern',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7300698,
        LOCATION_LATITUDE_DEG: 52.5875873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA006900',
        LOCATION_NAME: 'Tamerton Foliot',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1488279,
        LOCATION_LATITUDE_DEG: 50.4327905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007100',
        LOCATION_NAME: 'Tamlaght',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5657599,
        LOCATION_LATITUDE_DEG: 54.3165844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007000',
        LOCATION_NAME: 'Tamlaght',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1822816,
        LOCATION_LATITUDE_DEG: 54.4776778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007200',
        LOCATION_NAME: "Tamlaght O'Crilly",
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5822623,
        LOCATION_LATITUDE_DEG: 54.8999415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007250',
        LOCATION_NAME: 'Tamnamore',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6461267,
        LOCATION_LATITUDE_DEG: 54.4931717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007300',
        LOCATION_NAME: 'Tamworth',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6892859,
        LOCATION_LATITUDE_DEG: 52.633973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007400',
        LOCATION_NAME: 'Tan Hills',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5999357,
        LOCATION_LATITUDE_DEG: 54.8237854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007500',
        LOCATION_NAME: 'Tan Hinon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6273298,
        LOCATION_LATITUDE_DEG: 52.4543815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019600',
        LOCATION_NAME: 'Tan y Bwlch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9954258,
        LOCATION_LATITUDE_DEG: 52.9500354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019700',
        LOCATION_NAME: 'Tan y Lan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6850574,
        LOCATION_LATITUDE_DEG: 53.2938971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007800',
        LOCATION_NAME: 'Tandem',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7361203,
        LOCATION_LATITUDE_DEG: 53.645771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007900',
        LOCATION_NAME: 'Tandragee',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4253387,
        LOCATION_LATITUDE_DEG: 54.3616884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008000',
        LOCATION_NAME: 'Tandridge',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.032506,
        LOCATION_LATITUDE_DEG: 51.241618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008100',
        LOCATION_NAME: 'Tanerdy',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.299285,
        LOCATION_LATITUDE_DEG: 51.8642265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008200',
        LOCATION_NAME: 'Tanfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7079775,
        LOCATION_LATITUDE_DEG: 54.893189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008300',
        LOCATION_NAME: 'Tanfield Lea',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7091519,
        LOCATION_LATITUDE_DEG: 54.8816879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008500',
        LOCATION_NAME: 'Tangasdale',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5156072,
        LOCATION_LATITUDE_DEG: 56.9706584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008600',
        LOCATION_NAME: 'Tangiers',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9661953,
        LOCATION_LATITUDE_DEG: 51.8245294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008700',
        LOCATION_NAME: 'Tangley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5206636,
        LOCATION_LATITUDE_DEG: 51.2699435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008800',
        LOCATION_NAME: 'Tangmere',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7175004,
        LOCATION_LATITUDE_DEG: 50.8474934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008900',
        LOCATION_NAME: 'Tankerness',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8528508,
        LOCATION_LATITUDE_DEG: 58.9603111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009000',
        LOCATION_NAME: 'Tankersley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4854783,
        LOCATION_LATITUDE_DEG: 53.4901486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019900',
        LOCATION_NAME: 'Tankerton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0385092,
        LOCATION_LATITUDE_DEG: 51.366452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009100',
        LOCATION_NAME: 'Tankerville',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9392512,
        LOCATION_LATITUDE_DEG: 52.5969859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009200',
        LOCATION_NAME: 'Tanlan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3084682,
        LOCATION_LATITUDE_DEG: 53.3330568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009300',
        LOCATION_NAME: 'Tannadice',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8571394,
        LOCATION_LATITUDE_DEG: 56.7127808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009400',
        LOCATION_NAME: 'Tanners Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8741017,
        LOCATION_LATITUDE_DEG: 52.3685492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009500',
        LOCATION_NAME: 'Tannington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2955969,
        LOCATION_LATITUDE_DEG: 52.2646983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009600',
        LOCATION_NAME: 'Tansey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.479438,
        LOCATION_LATITUDE_DEG: 51.1887454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009700',
        LOCATION_NAME: 'Tansley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5173502,
        LOCATION_LATITUDE_DEG: 53.131614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009800',
        LOCATION_NAME: 'Tansor',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4470318,
        LOCATION_LATITUDE_DEG: 52.5053402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA009900',
        LOCATION_NAME: 'Tantobie',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7270725,
        LOCATION_LATITUDE_DEG: 54.884893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA019800',
        LOCATION_NAME: 'Tanworth in Arden',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010000',
        LOCATION_NAME: 'Tanworth-in-Arden',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8347534,
        LOCATION_LATITUDE_DEG: 52.3322481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007600',
        LOCATION_NAME: 'Tan-y-Bwlch',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9956827,
        LOCATION_LATITUDE_DEG: 52.9475313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010100',
        LOCATION_NAME: 'Tanyfron',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5577076,
        LOCATION_LATITUDE_DEG: 53.1648933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010200',
        LOCATION_NAME: 'Tanygrisiau',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9557902,
        LOCATION_LATITUDE_DEG: 52.9865353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010300',
        LOCATION_NAME: 'Tanygroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5098131,
        LOCATION_LATITUDE_DEG: 52.1119289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA007700',
        LOCATION_NAME: 'Tan-y-Lan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6823966,
        LOCATION_LATITUDE_DEG: 53.2899607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010400',
        LOCATION_NAME: 'Taplow',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6853567,
        LOCATION_LATITUDE_DEG: 51.530758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010850',
        LOCATION_NAME: 'Tarbert',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7985605,
        LOCATION_LATITUDE_DEG: 57.8983441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010800',
        LOCATION_NAME: 'Tarbert',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4155025,
        LOCATION_LATITUDE_DEG: 55.8633297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010900',
        LOCATION_NAME: 'Tarbet',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1409418,
        LOCATION_LATITUDE_DEG: 58.3898771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011000',
        LOCATION_NAME: 'Tarbet',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7123982,
        LOCATION_LATITUDE_DEG: 56.2037563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011100',
        LOCATION_NAME: 'Tarbock Green',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8059535,
        LOCATION_LATITUDE_DEG: 53.3816588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011200',
        LOCATION_NAME: 'Tarbolton',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4854549,
        LOCATION_LATITUDE_DEG: 55.5132854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011300',
        LOCATION_NAME: 'Tarbrax',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5543969,
        LOCATION_LATITUDE_DEG: 55.7789971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011400',
        LOCATION_NAME: 'Tardebigge',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0056196,
        LOCATION_LATITUDE_DEG: 52.3198477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011500',
        LOCATION_NAME: 'Tarewaste',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2440241,
        LOCATION_LATITUDE_DEG: 50.2314819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011600',
        LOCATION_NAME: 'Tarfside',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8349613,
        LOCATION_LATITUDE_DEG: 56.9062067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011700',
        LOCATION_NAME: 'TARLAND',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8532761,
        LOCATION_LATITUDE_DEG: 57.1300261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011800',
        LOCATION_NAME: 'Tarleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8281838,
        LOCATION_LATITUDE_DEG: 53.6797846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA011900',
        LOCATION_NAME: 'Tarlogie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0995509,
        LOCATION_LATITUDE_DEG: 57.8260053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012000',
        LOCATION_NAME: 'Tarlton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0574002,
        LOCATION_LATITUDE_DEG: 51.6938835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012100',
        LOCATION_NAME: 'Tarlum',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4015142,
        LOCATION_LATITUDE_DEG: 54.6155078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012400',
        LOCATION_NAME: 'Tarnock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8888789,
        LOCATION_LATITUDE_DEG: 51.2663544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012500',
        LOCATION_NAME: 'Tarporley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.666175,
        LOCATION_LATITUDE_DEG: 53.1573306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012600',
        LOCATION_NAME: 'Tarraby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9215423,
        LOCATION_LATITUDE_DEG: 54.9141054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012700',
        LOCATION_NAME: 'Tarrant Crawford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1195749,
        LOCATION_LATITUDE_DEG: 50.8319055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012800',
        LOCATION_NAME: 'Tarrant Gunville',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1051744,
        LOCATION_LATITUDE_DEG: 50.9138139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012900',
        LOCATION_NAME: 'Tarrant Hinton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0894548,
        LOCATION_LATITUDE_DEG: 50.8992127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013000',
        LOCATION_NAME: 'Tarrant Keyneston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0959474,
        LOCATION_LATITUDE_DEG: 50.8405071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013100',
        LOCATION_NAME: 'Tarrant Launceston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0815954,
        LOCATION_LATITUDE_DEG: 50.8859082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013200',
        LOCATION_NAME: 'Tarrant Monkton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0781025,
        LOCATION_LATITUDE_DEG: 50.8802087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013300',
        LOCATION_NAME: 'Tarrant Rawston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0869602,
        LOCATION_LATITUDE_DEG: 50.8579076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013400',
        LOCATION_NAME: 'Tarrant Rushton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0907693,
        LOCATION_LATITUDE_DEG: 50.8511056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013500',
        LOCATION_NAME: 'Tarring',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3895628,
        LOCATION_LATITUDE_DEG: 50.8222826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013600',
        LOCATION_NAME: 'Tarring Neville',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0480668,
        LOCATION_LATITUDE_DEG: 50.8142772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013700',
        LOCATION_NAME: 'Tarrington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5581614,
        LOCATION_LATITUDE_DEG: 52.0635288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013800',
        LOCATION_NAME: 'Tarryblake',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8111465,
        LOCATION_LATITUDE_DEG: 57.5310637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA013900',
        LOCATION_NAME: 'Tarset',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3436028,
        LOCATION_LATITUDE_DEG: 55.1765291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014000',
        LOCATION_NAME: 'Tarskavaig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9868836,
        LOCATION_LATITUDE_DEG: 57.1169572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014100',
        LOCATION_NAME: 'Tarves',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2202343,
        LOCATION_LATITUDE_DEG: 57.3711422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014200',
        LOCATION_NAME: 'Tarvie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6270327,
        LOCATION_LATITUDE_DEG: 57.5920924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014300',
        LOCATION_NAME: 'Tarvin',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7618923,
        LOCATION_LATITUDE_DEG: 53.1974373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014400',
        LOCATION_NAME: 'Tarvin Sands',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7589179,
        LOCATION_LATITUDE_DEG: 53.2036415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014500',
        LOCATION_NAME: 'Tasburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2459536,
        LOCATION_LATITUDE_DEG: 52.5163199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014700',
        LOCATION_NAME: 'Tasley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4469322,
        LOCATION_LATITUDE_DEG: 52.5437723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014800',
        LOCATION_NAME: 'Tassagh',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6822851,
        LOCATION_LATITUDE_DEG: 54.266576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014900',
        LOCATION_NAME: 'Taston',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4782907,
        LOCATION_LATITUDE_DEG: 51.8959976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015000',
        LOCATION_NAME: 'Tatenhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6968201,
        LOCATION_LATITUDE_DEG: 52.7944853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990446',
        LOCATION_NAME: 'Tathall End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015100',
        LOCATION_NAME: 'Tatham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5960561,
        LOCATION_LATITUDE_DEG: 54.1176261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015200',
        LOCATION_NAME: 'Tathwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0060259,
        LOCATION_LATITUDE_DEG: 53.3243143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015300',
        LOCATION_NAME: 'Tatsfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0265325,
        LOCATION_LATITUDE_DEG: 51.2925242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015400',
        LOCATION_NAME: 'Tattenhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7656586,
        LOCATION_LATITUDE_DEG: 53.121428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015500',
        LOCATION_NAME: 'Tattenham Corner',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2340682,
        LOCATION_LATITUDE_DEG: 51.308923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015600',
        LOCATION_NAME: 'Tattenhoe',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.78836,
        LOCATION_LATITUDE_DEG: 51.9968998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015700',
        LOCATION_NAME: 'Tatterford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7705532,
        LOCATION_LATITUDE_DEG: 52.8201534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015800',
        LOCATION_NAME: 'Tattersett',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7405694,
        LOCATION_LATITUDE_DEG: 52.8343578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA015900',
        LOCATION_NAME: 'Tattershall',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1880147,
        LOCATION_LATITUDE_DEG: 53.1041022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016000',
        LOCATION_NAME: 'Tattershall Bridge',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2186777,
        LOCATION_LATITUDE_DEG: 53.0876974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016100',
        LOCATION_NAME: 'Tattershall Thorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1782202,
        LOCATION_LATITUDE_DEG: 53.1187973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016200',
        LOCATION_NAME: 'Tattingstone',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1118295,
        LOCATION_LATITUDE_DEG: 51.991372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016300',
        LOCATION_NAME: 'Tatton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5198194,
        LOCATION_LATITUDE_DEG: 50.6456905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016400',
        LOCATION_NAME: 'Tattykeel',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3772402,
        LOCATION_LATITUDE_DEG: 54.5783015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016500',
        LOCATION_NAME: 'Tattykeeran',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.1990529,
        LOCATION_LATITUDE_DEG: 54.5702504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016600',
        LOCATION_NAME: 'Tattymulmona',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3466516,
        LOCATION_LATITUDE_DEG: 54.5389771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016700',
        LOCATION_NAME: 'Tattyreagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.9200687,
        LOCATION_LATITUDE_DEG: 54.5306062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016800',
        LOCATION_NAME: 'Tattysallagh',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.374568,
        LOCATION_LATITUDE_DEG: 54.5707338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA016900',
        LOCATION_NAME: 'Tatworth',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9538466,
        LOCATION_LATITUDE_DEG: 50.8441131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017000',
        LOCATION_NAME: 'Taunton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1021426,
        LOCATION_LATITUDE_DEG: 51.0141372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017200',
        LOCATION_NAME: 'Taverham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1966211,
        LOCATION_LATITUDE_DEG: 52.6791332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017300',
        LOCATION_NAME: 'Tavernspite',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6365485,
        LOCATION_LATITUDE_DEG: 51.7822256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017400',
        LOCATION_NAME: 'Tavistock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1420802,
        LOCATION_LATITUDE_DEG: 50.5483961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017500',
        LOCATION_NAME: 'Taw Green',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9079233,
        LOCATION_LATITUDE_DEG: 50.7554186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017800',
        LOCATION_NAME: 'Tawnybrack',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1174009,
        LOCATION_LATITUDE_DEG: 54.8129319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018000',
        LOCATION_NAME: 'Tawstock',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0601432,
        LOCATION_LATITUDE_DEG: 51.0492456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018100',
        LOCATION_NAME: 'Tayinloan',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6597952,
        LOCATION_LATITUDE_DEG: 55.6525128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018200',
        LOCATION_NAME: 'Taylor Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7927935,
        LOCATION_LATITUDE_DEG: 53.6272657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018300',
        LOCATION_NAME: 'Taylors Lake',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9286586,
        LOCATION_LATITUDE_DEG: 51.6631134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018600',
        LOCATION_NAME: 'Taynton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3931257,
        LOCATION_LATITUDE_DEG: 51.8929096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018500',
        LOCATION_NAME: 'Taynton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6608101,
        LOCATION_LATITUDE_DEG: 51.8210965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018700',
        LOCATION_NAME: 'Taynuilt',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2378264,
        LOCATION_LATITUDE_DEG: 56.428985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018800',
        LOCATION_NAME: 'Tayport',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8784739,
        LOCATION_LATITUDE_DEG: 56.446559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018900',
        LOCATION_NAME: 'Tayvallich',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6253419,
        LOCATION_LATITUDE_DEG: 56.0243481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000100',
        LOCATION_NAME: 'Tea Green',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3487448,
        LOCATION_LATITUDE_DEG: 51.8941832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000200',
        LOCATION_NAME: 'Tealby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2586052,
        LOCATION_LATITUDE_DEG: 53.4016256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000300',
        LOCATION_NAME: 'Tealing',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9540581,
        LOCATION_LATITUDE_DEG: 56.5331696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011800',
        LOCATION_NAME: 'Team Colliery',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6012517,
        LOCATION_LATITUDE_DEG: 54.9460731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011900',
        LOCATION_NAME: 'Team Valley Trading Estate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6229694,
        LOCATION_LATITUDE_DEG: 54.9261095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011700',
        LOCATION_NAME: 'Teams',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6333185,
        LOCATION_LATITUDE_DEG: 54.9532741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011750',
        LOCATION_NAME: 'Tean',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9837145,
        LOCATION_LATITUDE_DEG: 52.9530487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000400',
        LOCATION_NAME: 'Teangue',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8525844,
        LOCATION_LATITUDE_DEG: 57.1121595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000500',
        LOCATION_NAME: 'Teaninich',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2611113,
        LOCATION_LATITUDE_DEG: 57.6895934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000600',
        LOCATION_NAME: 'Teasses Mill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9692222,
        LOCATION_LATITUDE_DEG: 56.2880406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000700',
        LOCATION_NAME: 'Tebay',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5885752,
        LOCATION_LATITUDE_DEG: 54.4345596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000800',
        LOCATION_NAME: 'Tebworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5584602,
        LOCATION_LATITUDE_DEG: 51.9298881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011400',
        LOCATION_NAME: 'Tedburn St Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001000',
        LOCATION_NAME: 'Tedburn St. Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6772939,
        LOCATION_LATITUDE_DEG: 50.7344097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001100',
        LOCATION_NAME: 'Teddington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0519591,
        LOCATION_LATITUDE_DEG: 51.9960166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001200',
        LOCATION_NAME: 'Teddington',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3323488,
        LOCATION_LATITUDE_DEG: 51.4263359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001300',
        LOCATION_NAME: 'Tedstone Delamere',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4492157,
        LOCATION_LATITUDE_DEG: 52.2250427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001400',
        LOCATION_NAME: 'Tedstone Wafre',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4704749,
        LOCATION_LATITUDE_DEG: 52.2305436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001550',
        LOCATION_NAME: 'Teemore',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5229998,
        LOCATION_LATITUDE_DEG: 54.1483699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002000',
        LOCATION_NAME: 'Teeshan',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3156344,
        LOCATION_LATITUDE_DEG: 54.8999342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002100',
        LOCATION_NAME: 'Teesside International Airport',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4299213,
        LOCATION_LATITUDE_DEG: 54.5126474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002200',
        LOCATION_NAME: 'Teeton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9805498,
        LOCATION_LATITUDE_DEG: 52.3264368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002300',
        LOCATION_NAME: 'Teffont',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0139079,
        LOCATION_LATITUDE_DEG: 51.0866303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002400',
        LOCATION_NAME: 'Teffont Evias',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0131353,
        LOCATION_LATITUDE_DEG: 51.0814234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002500',
        LOCATION_NAME: 'Tegryn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5795497,
        LOCATION_LATITUDE_DEG: 51.9683374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002600',
        LOCATION_NAME: 'Tehidy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2954291,
        LOCATION_LATITUDE_DEG: 50.2387792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE990142',
        LOCATION_NAME: 'Teigh',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7210677,
        LOCATION_LATITUDE_DEG: 52.7370185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002700',
        LOCATION_NAME: 'Teigh',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7192289,
        LOCATION_LATITUDE_DEG: 52.735569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002800',
        LOCATION_NAME: 'Teigngrace',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6248774,
        LOCATION_LATITUDE_DEG: 50.5521943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002900',
        LOCATION_NAME: 'Teignharvey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5300651,
        LOCATION_LATITUDE_DEG: 50.5383949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003000',
        LOCATION_NAME: 'Teignmouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.501155,
        LOCATION_LATITUDE_DEG: 50.5546916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003100',
        LOCATION_NAME: 'Telford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4478657,
        LOCATION_LATITUDE_DEG: 52.6773822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003200',
        LOCATION_NAME: 'Telham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5129815,
        LOCATION_LATITUDE_DEG: 50.9042769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003400',
        LOCATION_NAME: 'Tellisford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.284416,
        LOCATION_LATITUDE_DEG: 51.2987539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003500',
        LOCATION_NAME: 'Telscombe',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0051037,
        LOCATION_LATITUDE_DEG: 50.8122755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003600',
        LOCATION_NAME: 'Telscombe Cliffs',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0089775,
        LOCATION_LATITUDE_DEG: 50.8009724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003700',
        LOCATION_NAME: 'Templand',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4389246,
        LOCATION_LATITUDE_DEG: 55.1626359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003800',
        LOCATION_NAME: 'Temple',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6169703,
        LOCATION_LATITUDE_DEG: 50.5299071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE012400',
        LOCATION_NAME: 'Temple',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3248822,
        LOCATION_LATITUDE_DEG: 55.8949524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004000',
        LOCATION_NAME: 'Temple',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0913536,
        LOCATION_LATITUDE_DEG: 55.8167003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE012100',
        LOCATION_NAME: 'Temple',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6019158,
        LOCATION_LATITUDE_DEG: 51.4523456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003900',
        LOCATION_NAME: 'Temple',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7999634,
        LOCATION_LATITUDE_DEG: 51.4530635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004100',
        LOCATION_NAME: 'Temple Belwood',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7920025,
        LOCATION_LATITUDE_DEG: 53.5620519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004200',
        LOCATION_NAME: 'Temple Bruer',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.508907,
        LOCATION_LATITUDE_DEG: 53.0678981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004300',
        LOCATION_NAME: 'Temple Cloud',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5427019,
        LOCATION_LATITUDE_DEG: 51.3198564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004400',
        LOCATION_NAME: 'Temple Dinsley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2741095,
        LOCATION_LATITUDE_DEG: 51.9073837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004500',
        LOCATION_NAME: 'Temple Ewell',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2709402,
        LOCATION_LATITUDE_DEG: 51.1518929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004600',
        LOCATION_NAME: 'Temple Grafton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8206033,
        LOCATION_LATITUDE_DEG: 52.1910273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004700',
        LOCATION_NAME: 'Temple Guiting',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8634423,
        LOCATION_LATITUDE_DEG: 51.9514125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004800',
        LOCATION_NAME: 'Temple Herdewyke',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4387041,
        LOCATION_LATITUDE_DEG: 52.1645264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE004900',
        LOCATION_NAME: 'Temple Hirst',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0824157,
        LOCATION_LATITUDE_DEG: 53.7175722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005000',
        LOCATION_NAME: 'Temple Meads',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6008485,
        LOCATION_LATITUDE_DEG: 51.4554716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005100',
        LOCATION_NAME: 'Temple Normanton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.37356,
        LOCATION_LATITUDE_DEG: 53.2039261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005200',
        LOCATION_NAME: 'Temple Sowerby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6023458,
        LOCATION_LATITUDE_DEG: 54.6372806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005300',
        LOCATION_NAME: 'Temple Valley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2337271,
        LOCATION_LATITUDE_DEG: 51.0541182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005700',
        LOCATION_NAME: 'Templecombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4131334,
        LOCATION_LATITUDE_DEG: 50.9993231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005600',
        LOCATION_NAME: 'Templecombe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.873813,
        LOCATION_LATITUDE_DEG: 51.5263515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005900',
        LOCATION_NAME: 'Templemans Ash',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8488895,
        LOCATION_LATITUDE_DEG: 50.8053154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006400',
        LOCATION_NAME: 'Templepatrick',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0822092,
        LOCATION_LATITUDE_DEG: 54.683215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006700',
        LOCATION_NAME: 'Templeton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7357866,
        LOCATION_LATITUDE_DEG: 51.7739214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006600',
        LOCATION_NAME: 'Templeton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5834937,
        LOCATION_LATITUDE_DEG: 50.9139333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007000',
        LOCATION_NAME: 'Templetown',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8324473,
        LOCATION_LATITUDE_DEG: 54.8424836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007100',
        LOCATION_NAME: 'Tempo',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4678572,
        LOCATION_LATITUDE_DEG: 54.3775044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007300',
        LOCATION_NAME: 'Tempsford',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2946239,
        LOCATION_LATITUDE_DEG: 52.1702052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007400',
        LOCATION_NAME: 'Ten Mile Bank',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3653257,
        LOCATION_LATITUDE_DEG: 52.5467336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007500',
        LOCATION_NAME: 'Tenbury Wells',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5944851,
        LOCATION_LATITUDE_DEG: 52.309055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007600',
        LOCATION_NAME: 'Tenby',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7014096,
        LOCATION_LATITUDE_DEG: 51.6724137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007700',
        LOCATION_NAME: 'Tendring',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1134804,
        LOCATION_LATITUDE_DEG: 51.8748608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007800',
        LOCATION_NAME: 'Tenterden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6915966,
        LOCATION_LATITUDE_DEG: 51.0690909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE007900',
        LOCATION_NAME: 'Terling',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5698564,
        LOCATION_LATITUDE_DEG: 51.805667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008400',
        LOCATION_NAME: 'Tern Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5426927,
        LOCATION_LATITUDE_DEG: 52.8866032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008500',
        LOCATION_NAME: 'Terregles',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6749414,
        LOCATION_LATITUDE_DEG: 55.0791306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008700',
        LOCATION_NAME: 'Terrick',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6793076,
        LOCATION_LATITUDE_DEG: 52.9809209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008600',
        LOCATION_NAME: 'Terrick',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7851479,
        LOCATION_LATITUDE_DEG: 51.7664814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008800',
        LOCATION_NAME: 'Terriers End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6798903,
        LOCATION_LATITUDE_DEG: 51.7830799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008900',
        LOCATION_NAME: 'Terrington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9722661,
        LOCATION_LATITUDE_DEG: 54.1274067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011500',
        LOCATION_NAME: 'Terrington St Clement',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011600',
        LOCATION_NAME: 'Terrington St John',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009000',
        LOCATION_NAME: 'Terrington St. Clement',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2989732,
        LOCATION_LATITUDE_DEG: 52.7594585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009100',
        LOCATION_NAME: 'Terrington St. John',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2756219,
        LOCATION_LATITUDE_DEG: 52.7050547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009400',
        LOCATION_NAME: 'Terryside',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4222031,
        LOCATION_LATITUDE_DEG: 58.0658344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009600',
        LOCATION_NAME: 'Teston',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4429236,
        LOCATION_LATITUDE_DEG: 51.2534165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009700',
        LOCATION_NAME: 'Tetbury',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1605895,
        LOCATION_LATITUDE_DEG: 51.6387822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009800',
        LOCATION_NAME: 'Tetchill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9049413,
        LOCATION_LATITUDE_DEG: 52.8883156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009900',
        LOCATION_NAME: 'Tetchill Moor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9005277,
        LOCATION_LATITUDE_DEG: 52.8733077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010000',
        LOCATION_NAME: 'Tetcott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3659173,
        LOCATION_LATITUDE_DEG: 50.7434249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010100',
        LOCATION_NAME: 'Tetford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5452108,
        LOCATION_LATITUDE_DEG: 53.2533114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010200',
        LOCATION_NAME: 'Tetney',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0198968,
        LOCATION_LATITUDE_DEG: 53.4883282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010300',
        LOCATION_NAME: 'Tetsworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0040396,
        LOCATION_LATITUDE_DEG: 51.7091717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010400',
        LOCATION_NAME: 'Tettenhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1665107,
        LOCATION_LATITUDE_DEG: 52.5980754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010500',
        LOCATION_NAME: 'Tettenhall Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1813752,
        LOCATION_LATITUDE_DEG: 52.5898719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010600',
        LOCATION_NAME: 'Tetworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2186068,
        LOCATION_LATITUDE_DEG: 52.162409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010700',
        LOCATION_NAME: 'Teversal',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2803926,
        LOCATION_LATITUDE_DEG: 53.1514189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010800',
        LOCATION_NAME: 'Teversham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1911285,
        LOCATION_LATITUDE_DEG: 52.2031078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE990337',
        LOCATION_NAME: 'Teviothead',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7870969,
        LOCATION_LATITUDE_DEG: 55.4325187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE010900',
        LOCATION_NAME: 'Tewin',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1544391,
        LOCATION_LATITUDE_DEG: 51.8167701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011000',
        LOCATION_NAME: 'Tewitfield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7341897,
        LOCATION_LATITUDE_DEG: 54.157429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011100',
        LOCATION_NAME: 'Tewkesbury',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1560239,
        LOCATION_LATITUDE_DEG: 51.9920133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011200',
        LOCATION_NAME: 'Tewthwaite Green',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9619686,
        LOCATION_LATITUDE_DEG: 54.946912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE011300',
        LOCATION_NAME: 'Teynham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8012177,
        LOCATION_LATITUDE_DEG: 51.3274126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000100',
        LOCATION_NAME: 'Thackley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7288296,
        LOCATION_LATITUDE_DEG: 53.8433895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000200',
        LOCATION_NAME: 'Thackthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.317611,
        LOCATION_LATITUDE_DEG: 54.6001778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000300',
        LOCATION_NAME: 'Thackthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8924817,
        LOCATION_LATITUDE_DEG: 54.6190778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000400',
        LOCATION_NAME: 'Thakeham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4206411,
        LOCATION_LATITUDE_DEG: 50.9434989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000500',
        LOCATION_NAME: 'Thame',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9747859,
        LOCATION_LATITUDE_DEG: 51.7475787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000600',
        LOCATION_NAME: 'Thames Ditton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3320092,
        LOCATION_LATITUDE_DEG: 51.389035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000700',
        LOCATION_NAME: 'Thames Haven',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5133451,
        LOCATION_LATITUDE_DEG: 51.5070386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000800',
        LOCATION_NAME: 'Thankerton',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6287459,
        LOCATION_LATITUDE_DEG: 55.6256872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH000900',
        LOCATION_NAME: 'Tharston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.226261,
        LOCATION_LATITUDE_DEG: 52.5031241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001000',
        LOCATION_NAME: 'Thatcham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2590218,
        LOCATION_LATITUDE_DEG: 51.4031501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001100',
        LOCATION_NAME: 'Thatto Heath',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'WA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7496754,
        LOCATION_LATITUDE_DEG: 53.4338608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001200',
        LOCATION_NAME: 'Thaxted',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3461243,
        LOCATION_LATITUDE_DEG: 51.9521769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001300',
        LOCATION_NAME: 'The Blythe',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9311002,
        LOCATION_LATITUDE_DEG: 52.8541987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001400',
        LOCATION_NAME: 'The Bog',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9496873,
        LOCATION_LATITUDE_DEG: 52.5749822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001500',
        LOCATION_NAME: 'The Bourne',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7831848,
        LOCATION_LATITUDE_DEG: 51.1996242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001600',
        LOCATION_NAME: 'The Braes',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1134469,
        LOCATION_LATITUDE_DEG: 57.337181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001700',
        LOCATION_NAME: 'The Brow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.93514,
        LOCATION_LATITUDE_DEG: 52.8901136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001800',
        LOCATION_NAME: 'The Bryn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1995958,
        LOCATION_LATITUDE_DEG: 51.6484927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH001900',
        LOCATION_NAME: 'The Bryn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9708625,
        LOCATION_LATITUDE_DEG: 51.7856015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002000',
        LOCATION_NAME: 'The Burf',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.277791,
        LOCATION_LATITUDE_DEG: 52.3068435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002100',
        LOCATION_NAME: 'The Burrows',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7171414,
        LOCATION_LATITUDE_DEG: 51.673013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002200',
        LOCATION_NAME: 'The Camp',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1254489,
        LOCATION_LATITUDE_DEG: 51.7823942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002300',
        LOCATION_NAME: 'The Chesters',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1462628,
        LOCATION_LATITUDE_DEG: 55.0271108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002400',
        LOCATION_NAME: 'The Chuckery',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9731798,
        LOCATION_LATITUDE_DEG: 52.5836692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002500',
        LOCATION_NAME: 'The Collon',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3144212,
        LOCATION_LATITUDE_DEG: 55.0128589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002600',
        LOCATION_NAME: 'The Common',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.381845,
        LOCATION_LATITUDE_DEG: 50.6523997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002700',
        LOCATION_NAME: 'The Cop',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8863432,
        LOCATION_LATITUDE_DEG: 52.6845888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002900',
        LOCATION_NAME: 'The Cross',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1445681,
        LOCATION_LATITUDE_DEG: 52.6580914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH002800',
        LOCATION_NAME: 'The Cross',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9707461,
        LOCATION_LATITUDE_DEG: 52.822406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003000',
        LOCATION_NAME: 'The Dean',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4718013,
        LOCATION_LATITUDE_DEG: 52.5964796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003100',
        LOCATION_NAME: 'The Den',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6653467,
        LOCATION_LATITUDE_DEG: 55.7257062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003200',
        LOCATION_NAME: 'The Derwen',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5544337,
        LOCATION_LATITUDE_DEG: 51.5292914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003400',
        LOCATION_NAME: 'The Docks',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7853517,
        LOCATION_LATITUDE_DEG: 51.5853963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003300',
        LOCATION_NAME: 'The Docks',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2527942,
        LOCATION_LATITUDE_DEG: 51.8700055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003500',
        LOCATION_NAME: 'The Doward',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6643864,
        LOCATION_LATITUDE_DEG: 51.8452107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003600',
        LOCATION_NAME: 'The Down',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4633926,
        LOCATION_LATITUDE_DEG: 52.5047689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003670',
        LOCATION_NAME: 'The Downs',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4839902,
        LOCATION_LATITUDE_DEG: 52.1914299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003800',
        LOCATION_NAME: 'The Firs',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7977312,
        LOCATION_LATITUDE_DEG: 52.4281622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH003900',
        LOCATION_NAME: 'The Fish',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8889489,
        LOCATION_LATITUDE_DEG: 52.448965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004000',
        LOCATION_NAME: 'The Flatts',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.63498,
        LOCATION_LATITUDE_DEG: 53.6898763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004100',
        LOCATION_NAME: 'The Gardens',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0693522,
        LOCATION_LATITUDE_DEG: 52.8476052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004200',
        LOCATION_NAME: 'The Gill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.999718,
        LOCATION_LATITUDE_DEG: 54.826404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004300',
        LOCATION_NAME: 'The Goggin',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.775276,
        LOCATION_LATITUDE_DEG: 52.3244522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004400',
        LOCATION_NAME: 'The Gorn',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5085099,
        LOCATION_LATITUDE_DEG: 52.448071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004500',
        LOCATION_NAME: 'The Green',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2613067,
        LOCATION_LATITUDE_DEG: 54.2519502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004600',
        LOCATION_NAME: 'The Grove',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8568021,
        LOCATION_LATITUDE_DEG: 54.847386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004800',
        LOCATION_NAME: 'The Harbour',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5587632,
        LOCATION_LATITUDE_DEG: 50.4309862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004700',
        LOCATION_NAME: 'The Harbour',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7201312,
        LOCATION_LATITUDE_DEG: 52.4753696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH004900',
        LOCATION_NAME: 'The Haven',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4488032,
        LOCATION_LATITUDE_DEG: 51.0617962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005000',
        LOCATION_NAME: 'The Headland',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1770703,
        LOCATION_LATITUDE_DEG: 54.6945666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005200',
        LOCATION_NAME: 'The Hem',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4040781,
        LOCATION_LATITUDE_DEG: 52.6482835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005300',
        LOCATION_NAME: 'The Hendre',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7866892,
        LOCATION_LATITUDE_DEG: 51.825312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005400',
        LOCATION_NAME: 'The Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3222117,
        LOCATION_LATITUDE_DEG: 54.8383031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005450',
        LOCATION_NAME: 'The Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2612216,
        LOCATION_LATITUDE_DEG: 54.2396002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005500',
        LOCATION_NAME: 'The Hobbins',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3878715,
        LOCATION_LATITUDE_DEG: 52.5373721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005600',
        LOCATION_NAME: 'The Hoe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1440244,
        LOCATION_LATITUDE_DEG: 50.3647841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005700',
        LOCATION_NAME: 'The Home',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9201455,
        LOCATION_LATITUDE_DEG: 52.5067743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005800',
        LOCATION_NAME: 'The Howe',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8351211,
        LOCATION_LATITUDE_DEG: 54.2875476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH040200',
        LOCATION_NAME: 'The Hyde',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2425564,
        LOCATION_LATITUDE_DEG: 51.5872026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005900',
        LOCATION_NAME: 'The Lanes',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1402113,
        LOCATION_LATITUDE_DEG: 50.8209751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006000',
        LOCATION_NAME: 'The Lawe',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4342934,
        LOCATION_LATITUDE_DEG: 55.0008004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006100',
        LOCATION_NAME: 'The Lee',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6962038,
        LOCATION_LATITUDE_DEG: 51.7291711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006200',
        LOCATION_NAME: 'The Leigh',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1893324,
        LOCATION_LATITUDE_DEG: 51.9327084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006300',
        LOCATION_NAME: 'The Lhen',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4815369,
        LOCATION_LATITUDE_DEG: 54.3804691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006350',
        LOCATION_NAME: 'The Lizard',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.203749,
        LOCATION_LATITUDE_DEG: 49.9694966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006400',
        LOCATION_NAME: 'The Lodge',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0459845,
        LOCATION_LATITUDE_DEG: 53.071232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006500',
        LOCATION_NAME: 'The Loup',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.598964,
        LOCATION_LATITUDE_DEG: 54.6999298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006600',
        LOCATION_NAME: 'The Middles',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6755873,
        LOCATION_LATITUDE_DEG: 54.8567885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006700',
        LOCATION_NAME: 'The Moor',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5059676,
        LOCATION_LATITUDE_DEG: 51.0370874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006800',
        LOCATION_NAME: 'The Mound',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.066573,
        LOCATION_LATITUDE_DEG: 57.9571251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH006900',
        LOCATION_NAME: 'The Narth',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6871832,
        LOCATION_LATITUDE_DEG: 51.7547981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007000',
        LOCATION_NAME: 'The Neuk',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4401388,
        LOCATION_LATITUDE_DEG: 57.0694189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007100',
        LOCATION_NAME: 'The Oa',
        COUNTY_NAME: 'Isle of Islay',
        POSTCODE: 'PA42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2768041,
        LOCATION_LATITUDE_DEG: 55.6030146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007200',
        LOCATION_NAME: 'The Packet Quays',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.072118,
        LOCATION_LATITUDE_DEG: 50.1563742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007400',
        LOCATION_NAME: 'The Park',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2618527,
        LOCATION_LATITUDE_DEG: 53.1285476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007300',
        LOCATION_NAME: 'The Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.210728,
        LOCATION_LATITUDE_DEG: 52.9474983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007450',
        LOCATION_NAME: 'The Park',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1902531,
        LOCATION_LATITUDE_DEG: 53.1517212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007500',
        LOCATION_NAME: 'The Philog',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2045013,
        LOCATION_LATITUDE_DEG: 51.5083791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007600',
        LOCATION_NAME: 'The Pludds',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5510855,
        LOCATION_LATITUDE_DEG: 51.8415068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007700',
        LOCATION_NAME: 'The Poles',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7953197,
        LOCATION_LATITUDE_DEG: 52.3652569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007800',
        LOCATION_NAME: 'The Prinnels',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8478662,
        LOCATION_LATITUDE_DEG: 51.5605689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH007900',
        LOCATION_NAME: 'The Quar',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.382411,
        LOCATION_LATITUDE_DEG: 51.7527058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008000',
        LOCATION_NAME: 'The Quarry',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3773027,
        LOCATION_LATITUDE_DEG: 51.69179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990264',
        LOCATION_NAME: 'The Reddings',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5687564,
        LOCATION_LATITUDE_DEG: 51.8464223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008100',
        LOCATION_NAME: 'The Reddings',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1351732,
        LOCATION_LATITUDE_DEG: 51.8878057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008200',
        LOCATION_NAME: 'The Rhiw',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1823966,
        LOCATION_LATITUDE_DEG: 51.6774978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990550',
        LOCATION_NAME: 'The Rhos',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008300',
        LOCATION_NAME: 'The Ridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9530348,
        LOCATION_LATITUDE_DEG: 52.8954107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008400',
        LOCATION_NAME: 'The Ridge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1798031,
        LOCATION_LATITUDE_DEG: 51.4099586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008500',
        LOCATION_NAME: 'The Ridgeway',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'EN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1048051,
        LOCATION_LATITUDE_DEG: 51.6646596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008600',
        LOCATION_NAME: 'The Rock',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1857902,
        LOCATION_LATITUDE_DEG: 51.680602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008700',
        LOCATION_NAME: 'The Rock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4717541,
        LOCATION_LATITUDE_DEG: 52.6813893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008900',
        LOCATION_NAME: 'The Sheet',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6878315,
        LOCATION_LATITUDE_DEG: 52.364259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009000',
        LOCATION_NAME: 'The Stalls',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7626106,
        LOCATION_LATITUDE_DEG: 52.3900639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009100',
        LOCATION_NAME: 'The Stell',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.060283,
        LOCATION_LATITUDE_DEG: 54.8433104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009200',
        LOCATION_NAME: 'The Stocks',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7285959,
        LOCATION_LATITUDE_DEG: 51.0133879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990781',
        LOCATION_NAME: 'The Trafford Centre',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009400',
        LOCATION_NAME: 'The Trench',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9080541,
        LOCATION_LATITUDE_DEG: 52.9341172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009500',
        LOCATION_NAME: 'The Upper Wyke',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4007928,
        LOCATION_LATITUDE_DEG: 52.6575822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009600',
        LOCATION_NAME: 'The Wells',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2881706,
        LOCATION_LATITUDE_DEG: 51.3265267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009700',
        LOCATION_NAME: 'The Wyke',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3985167,
        LOCATION_LATITUDE_DEG: 52.6576798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009800',
        LOCATION_NAME: 'Theakston',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5348656,
        LOCATION_LATITUDE_DEG: 54.2668283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009900',
        LOCATION_NAME: 'Thealby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6456938,
        LOCATION_LATITUDE_DEG: 53.6509604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010100',
        LOCATION_NAME: 'Theale',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7630841,
        LOCATION_LATITUDE_DEG: 51.2115478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010000',
        LOCATION_NAME: 'Theale',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0766746,
        LOCATION_LATITUDE_DEG: 51.4363521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010200',
        LOCATION_NAME: 'Thearne',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3686549,
        LOCATION_LATITUDE_DEG: 53.816072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010300',
        LOCATION_NAME: 'Theberton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5688044,
        LOCATION_LATITUDE_DEG: 52.2374874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010400',
        LOCATION_NAME: 'Theddingworth',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0182093,
        LOCATION_LATITUDE_DEG: 52.4647479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010500',
        LOCATION_NAME: 'Theddlethorpe All Saints',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2024653,
        LOCATION_LATITUDE_DEG: 53.3703159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039000',
        LOCATION_NAME: 'Theddlethorpe St Helen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2193828,
        LOCATION_LATITUDE_DEG: 53.3648952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010600',
        LOCATION_NAME: 'Theddlethorpe St. Helen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2197732,
        LOCATION_LATITUDE_DEG: 53.3747157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010700',
        LOCATION_NAME: 'Thelbridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7154644,
        LOCATION_LATITUDE_DEG: 50.8995305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010800',
        LOCATION_NAME: 'Thelnetham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.961141,
        LOCATION_LATITUDE_DEG: 52.3655073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH010900',
        LOCATION_NAME: 'Thelveton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.178986,
        LOCATION_LATITUDE_DEG: 52.3862065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011000',
        LOCATION_NAME: 'Thelwall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5331734,
        LOCATION_LATITUDE_DEG: 53.3823526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011100',
        LOCATION_NAME: 'Themelthorpe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0484801,
        LOCATION_LATITUDE_DEG: 52.7728445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011200',
        LOCATION_NAME: 'Thenford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2405493,
        LOCATION_LATITUDE_DEG: 52.0734097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011300',
        LOCATION_NAME: 'Therfield',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0524277,
        LOCATION_LATITUDE_DEG: 52.0163903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011400',
        LOCATION_NAME: 'Thetford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7546526,
        LOCATION_LATITUDE_DEG: 52.4141153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011500',
        LOCATION_NAME: 'Theydon Bois',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0976674,
        LOCATION_LATITUDE_DEG: 51.6706601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011600',
        LOCATION_NAME: 'Theydon Garnon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.13462,
        LOCATION_LATITUDE_DEG: 51.6776567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011650',
        LOCATION_NAME: 'Theydon Mount',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1594842,
        LOCATION_LATITUDE_DEG: 51.667237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011700',
        LOCATION_NAME: 'Thickwood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2474499,
        LOCATION_LATITUDE_DEG: 51.4534676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011800',
        LOCATION_NAME: 'Thimbleby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3045356,
        LOCATION_LATITUDE_DEG: 54.3567369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH011900',
        LOCATION_NAME: 'Thimbleby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1457689,
        LOCATION_LATITUDE_DEG: 53.2119045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012000',
        LOCATION_NAME: 'Thinford',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5595297,
        LOCATION_LATITUDE_DEG: 54.706069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012100',
        LOCATION_NAME: 'Thingley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1531003,
        LOCATION_LATITUDE_DEG: 51.422964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012200',
        LOCATION_NAME: 'Thingwall',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0907586,
        LOCATION_LATITUDE_DEG: 53.3509606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012300',
        LOCATION_NAME: 'Thirkleby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2795242,
        LOCATION_LATITUDE_DEG: 54.2046394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012400',
        LOCATION_NAME: 'Thirlby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2543167,
        LOCATION_LATITUDE_DEG: 54.2489257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012500',
        LOCATION_NAME: 'Thirlmere',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0527987,
        LOCATION_LATITUDE_DEG: 54.5588715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012600',
        LOCATION_NAME: 'Thirn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6664509,
        LOCATION_LATITUDE_DEG: 54.2683337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012700',
        LOCATION_NAME: 'Thirsk',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3412735,
        LOCATION_LATITUDE_DEG: 54.232318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012800',
        LOCATION_NAME: 'Thirtleby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2150825,
        LOCATION_LATITUDE_DEG: 53.7962635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH012900',
        LOCATION_NAME: 'Thistleland',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6707661,
        LOCATION_LATITUDE_DEG: 51.4015498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013100',
        LOCATION_NAME: 'Thistleton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9010507,
        LOCATION_LATITUDE_DEG: 53.8331034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990143',
        LOCATION_NAME: 'Thistleton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6475896,
        LOCATION_LATITUDE_DEG: 52.7529181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013000',
        LOCATION_NAME: 'Thistleton',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6457291,
        LOCATION_LATITUDE_DEG: 52.7512694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013200',
        LOCATION_NAME: 'Thixendale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7146047,
        LOCATION_LATITUDE_DEG: 54.0389933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013300',
        LOCATION_NAME: 'Thockrington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0658053,
        LOCATION_LATITUDE_DEG: 55.1056205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013400',
        LOCATION_NAME: 'Tholthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2756344,
        LOCATION_LATITUDE_DEG: 54.0956099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013500',
        LOCATION_NAME: 'Thomas Chapel',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7432011,
        LOCATION_LATITUDE_DEG: 51.743419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013600',
        LOCATION_NAME: 'Thomas Close',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8802596,
        LOCATION_LATITUDE_DEG: 54.7544911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014100',
        LOCATION_NAME: 'Thomastown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4341814,
        LOCATION_LATITUDE_DEG: 51.5722903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014200',
        LOCATION_NAME: 'Thompson',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8297199,
        LOCATION_LATITUDE_DEG: 52.5308261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014300',
        LOCATION_NAME: 'Thomshill',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3185388,
        LOCATION_LATITUDE_DEG: 57.5987765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014400',
        LOCATION_NAME: 'Thong',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4056894,
        LOCATION_LATITUDE_DEG: 51.409523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014500',
        LOCATION_NAME: 'Thongsbridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7718422,
        LOCATION_LATITUDE_DEG: 53.5836653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014600',
        LOCATION_NAME: 'Thonock',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7537004,
        LOCATION_LATITUDE_DEG: 53.4240386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014700',
        LOCATION_NAME: 'Thoralby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9979572,
        LOCATION_LATITUDE_DEG: 54.2760306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014800',
        LOCATION_NAME: 'Thoresby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0243426,
        LOCATION_LATITUDE_DEG: 53.1740142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014900',
        LOCATION_NAME: 'Thoresthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1905819,
        LOCATION_LATITUDE_DEG: 53.2720046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015000',
        LOCATION_NAME: 'Thoresway',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2369645,
        LOCATION_LATITUDE_DEG: 53.4545335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015200',
        LOCATION_NAME: 'Thorganby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9491578,
        LOCATION_LATITUDE_DEG: 53.8692807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015100',
        LOCATION_NAME: 'Thorganby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1761368,
        LOCATION_LATITUDE_DEG: 53.4595272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015300',
        LOCATION_NAME: 'Thorgill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9119212,
        LOCATION_LATITUDE_DEG: 54.3606316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015400',
        LOCATION_NAME: 'Thorington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5576806,
        LOCATION_LATITUDE_DEG: 52.3109944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015500',
        LOCATION_NAME: 'Thorlby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0576473,
        LOCATION_LATITUDE_DEG: 53.9712069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015600',
        LOCATION_NAME: 'Thorley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1478723,
        LOCATION_LATITUDE_DEG: 51.8504694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015700',
        LOCATION_NAME: 'Thormanby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2454546,
        LOCATION_LATITUDE_DEG: 54.1676132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015800',
        LOCATION_NAME: 'Thorn',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.544233,
        LOCATION_LATITUDE_DEG: 51.9114851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990893',
        LOCATION_NAME: 'Thorn Brae',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH015900',
        LOCATION_NAME: 'Thornaby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2923777,
        LOCATION_LATITUDE_DEG: 54.5365484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016000',
        LOCATION_NAME: 'Thornage',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0472255,
        LOCATION_LATITUDE_DEG: 52.8844552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016100',
        LOCATION_NAME: 'Thornborough',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5456192,
        LOCATION_LATITUDE_DEG: 54.2147274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016200',
        LOCATION_NAME: 'Thornborough',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9165064,
        LOCATION_LATITUDE_DEG: 51.9965028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016500',
        LOCATION_NAME: 'Thornbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2703091,
        LOCATION_LATITUDE_DEG: 50.8529336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016300',
        LOCATION_NAME: 'Thornbury',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5547033,
        LOCATION_LATITUDE_DEG: 52.2328483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016400',
        LOCATION_NAME: 'Thornbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5246282,
        LOCATION_LATITUDE_DEG: 51.60818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016700',
        LOCATION_NAME: 'Thornby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1047936,
        LOCATION_LATITUDE_DEG: 54.858605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016600',
        LOCATION_NAME: 'Thornby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0151008,
        LOCATION_LATITUDE_DEG: 52.374439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016800',
        LOCATION_NAME: 'Thornby Moor',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0928931,
        LOCATION_LATITUDE_DEG: 54.8518009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH016900',
        LOCATION_NAME: 'Thorncliffe',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9752957,
        LOCATION_LATITUDE_DEG: 53.1240221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017000',
        LOCATION_NAME: 'Thorncombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.886529,
        LOCATION_LATITUDE_DEG: 50.8247138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017100',
        LOCATION_NAME: 'Thorncombe Street',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5703383,
        LOCATION_LATITUDE_DEG: 51.1695166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017200',
        LOCATION_NAME: 'Thorndon',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1354699,
        LOCATION_LATITUDE_DEG: 52.2839046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017300',
        LOCATION_NAME: 'Thorndon Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0813327,
        LOCATION_LATITUDE_DEG: 50.7264206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017400',
        LOCATION_NAME: 'Thorne',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6749607,
        LOCATION_LATITUDE_DEG: 50.9567251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017500',
        LOCATION_NAME: 'Thorne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9632058,
        LOCATION_LATITUDE_DEG: 53.6126526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039100',
        LOCATION_NAME: 'Thorne St Margaret',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017600',
        LOCATION_NAME: 'Thorne St. Margaret',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2836304,
        LOCATION_LATITUDE_DEG: 50.9817325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017700',
        LOCATION_NAME: 'Thorner',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4245265,
        LOCATION_LATITUDE_DEG: 53.8584873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018000',
        LOCATION_NAME: 'Thorney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8139742,
        LOCATION_LATITUDE_DEG: 51.0019307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017900',
        LOCATION_NAME: 'Thorney',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7125619,
        LOCATION_LATITUDE_DEG: 53.2466179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH017800',
        LOCATION_NAME: 'Thorney',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1064529,
        LOCATION_LATITUDE_DEG: 52.6210541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018100',
        LOCATION_NAME: 'Thorney Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7183176,
        LOCATION_LATITUDE_DEG: 50.7963989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018200',
        LOCATION_NAME: 'Thorney Island',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9274139,
        LOCATION_LATITUDE_DEG: 50.8296903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018300',
        LOCATION_NAME: 'Thorney Toll',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0192003,
        LOCATION_LATITUDE_DEG: 52.6165516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018400',
        LOCATION_NAME: 'Thorneywood',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1188208,
        LOCATION_LATITUDE_DEG: 52.9670003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018500',
        LOCATION_NAME: 'Thornfalcon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0236672,
        LOCATION_LATITUDE_DEG: 51.0088344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018600',
        LOCATION_NAME: 'Thornford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5638656,
        LOCATION_LATITUDE_DEG: 50.9168167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018700',
        LOCATION_NAME: 'Thorngrafton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3385691,
        LOCATION_LATITUDE_DEG: 54.9826093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018800',
        LOCATION_NAME: 'Thorngumbald',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1698218,
        LOCATION_LATITUDE_DEG: 53.7207537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH018900',
        LOCATION_NAME: 'Thornham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5818092,
        LOCATION_LATITUDE_DEG: 52.9593764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019000',
        LOCATION_NAME: 'Thornham Magna',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0856723,
        LOCATION_LATITUDE_DEG: 52.2969014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019100',
        LOCATION_NAME: 'Thornham Parva',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0926443,
        LOCATION_LATITUDE_DEG: 52.3120997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019200',
        LOCATION_NAME: 'Thornhaugh',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4242446,
        LOCATION_LATITUDE_DEG: 52.5915489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019600',
        LOCATION_NAME: 'Thornhill',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1519266,
        LOCATION_LATITUDE_DEG: 56.1715419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019300',
        LOCATION_NAME: 'Thornhill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7658874,
        LOCATION_LATITUDE_DEG: 55.2392515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019400',
        LOCATION_NAME: 'Thornhill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5248915,
        LOCATION_LATITUDE_DEG: 54.4659749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019700',
        LOCATION_NAME: 'Thornhill',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2150962,
        LOCATION_LATITUDE_DEG: 51.5528837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019500',
        LOCATION_NAME: 'Thornhill',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1896532,
        LOCATION_LATITUDE_DEG: 51.5380813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019800',
        LOCATION_NAME: 'Thornhill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7366546,
        LOCATION_LATITUDE_DEG: 51.7015875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH019900',
        LOCATION_NAME: 'Thornhill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.616455,
        LOCATION_LATITUDE_DEG: 53.6601899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020000',
        LOCATION_NAME: 'Thornhill Lees',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.63249,
        LOCATION_LATITUDE_DEG: 53.6714677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020100',
        LOCATION_NAME: 'Thornhill Park',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3440383,
        LOCATION_LATITUDE_DEG: 50.9160029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020200',
        LOCATION_NAME: 'Thornholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2960731,
        LOCATION_LATITUDE_DEG: 54.0577933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020300',
        LOCATION_NAME: 'Thornicombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1841456,
        LOCATION_LATITUDE_DEG: 50.8276035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990554',
        LOCATION_NAME: 'Thornley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020500',
        LOCATION_NAME: 'Thornley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8219902,
        LOCATION_LATITUDE_DEG: 54.7308793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020400',
        LOCATION_NAME: 'Thornley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4281124,
        LOCATION_LATITUDE_DEG: 54.7501715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020600',
        LOCATION_NAME: 'Thornley Gate',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2619256,
        LOCATION_LATITUDE_DEG: 54.8999981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020700',
        LOCATION_NAME: 'Thornliebank',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3176611,
        LOCATION_LATITUDE_DEG: 55.8052108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990262',
        LOCATION_NAME: 'Thornsett',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9851158,
        LOCATION_LATITUDE_DEG: 53.3795778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020900',
        LOCATION_NAME: 'Thornthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.201118,
        LOCATION_LATITUDE_DEG: 54.6172814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH020800',
        LOCATION_NAME: 'Thornthwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7395682,
        LOCATION_LATITUDE_DEG: 54.0257069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021000',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1442675,
        LOCATION_LATITUDE_DEG: 56.1652345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021300',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9995384,
        LOCATION_LATITUDE_DEG: 53.5009749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021200',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0778717,
        LOCATION_LATITUDE_DEG: 55.7221758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021400',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8498003,
        LOCATION_LATITUDE_DEG: 53.7901893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021500',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3132185,
        LOCATION_LATITUDE_DEG: 52.6662678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021600',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2602661,
        LOCATION_LATITUDE_DEG: 54.5164475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021100',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9042136,
        LOCATION_LATITUDE_DEG: 52.0155063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021700',
        LOCATION_NAME: 'Thornton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1367724,
        LOCATION_LATITUDE_DEG: 53.1921092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039400',
        LOCATION_NAME: 'Thornton Cleveleys',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0217515,
        LOCATION_LATITUDE_DEG: 53.8764177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021800',
        LOCATION_NAME: 'Thornton Curtis',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3543986,
        LOCATION_LATITUDE_DEG: 53.6454495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH021900',
        LOCATION_NAME: 'Thornton Dale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7202401,
        LOCATION_LATITUDE_DEG: 54.2361148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022000',
        LOCATION_NAME: 'Thornton Heath',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1082837,
        LOCATION_LATITUDE_DEG: 51.3949357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022100',
        LOCATION_NAME: 'Thornton Hough',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0442916,
        LOCATION_LATITUDE_DEG: 53.3204501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022700',
        LOCATION_NAME: 'Thornton in Craven',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1430604,
        LOCATION_LATITUDE_DEG: 53.9316029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022800',
        LOCATION_NAME: 'Thornton le Beans',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3904684,
        LOCATION_LATITUDE_DEG: 54.3079272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022900',
        LOCATION_NAME: 'Thornton le Clay',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9525647,
        LOCATION_LATITUDE_DEG: 54.077204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039500',
        LOCATION_NAME: 'Thornton le Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039600',
        LOCATION_NAME: 'Thornton le Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023000',
        LOCATION_NAME: 'Thornton le Moor',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4015372,
        LOCATION_LATITUDE_DEG: 54.2866261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039700',
        LOCATION_NAME: 'Thornton le Moors',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022200',
        LOCATION_NAME: 'Thornton Le Street',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.364514,
        LOCATION_LATITUDE_DEG: 54.2695294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022300',
        LOCATION_NAME: 'Thornton Lodge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.795392,
        LOCATION_LATITUDE_DEG: 53.6371673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022400',
        LOCATION_NAME: 'Thornton Rust',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0463612,
        LOCATION_LATITUDE_DEG: 54.2969374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022500',
        LOCATION_NAME: 'Thornton Steward',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7262081,
        LOCATION_LATITUDE_DEG: 54.2789286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH022600',
        LOCATION_NAME: 'Thornton Watlass',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6401338,
        LOCATION_LATITUDE_DEG: 54.264429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023100',
        LOCATION_NAME: 'Thornton-Cleveleys',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'FY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0163297,
        LOCATION_LATITUDE_DEG: 53.8793044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023500',
        LOCATION_NAME: 'Thorntonhall',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2494489,
        LOCATION_LATITUDE_DEG: 55.7698044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH991023',
        LOCATION_NAME: 'Thornton-le-Dale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.71941,
        LOCATION_LATITUDE_DEG: 54.23641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023200',
        LOCATION_NAME: 'Thornton-le-Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.132147,
        LOCATION_LATITUDE_DEG: 53.0769925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023300',
        LOCATION_NAME: 'Thornton-le-Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4166132,
        LOCATION_LATITUDE_DEG: 53.4518354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023400',
        LOCATION_NAME: 'Thornton-le-Moors',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8324205,
        LOCATION_LATITUDE_DEG: 53.2638431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH040500',
        LOCATION_NAME: 'Thornwood',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3219118,
        LOCATION_LATITUDE_DEG: 55.8722762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH470258',
        LOCATION_NAME: 'Thornwood',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1248347,
        LOCATION_LATITUDE_DEG: 51.7306537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023600',
        LOCATION_NAME: 'Thornwood Common',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1302208,
        LOCATION_LATITUDE_DEG: 51.7207622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023700',
        LOCATION_NAME: 'Thoroton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8615222,
        LOCATION_LATITUDE_DEG: 52.9755944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023800',
        LOCATION_NAME: 'Thorp Arch',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3405141,
        LOCATION_LATITUDE_DEG: 53.9077916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH023900',
        LOCATION_NAME: 'Thorp Perrow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5968134,
        LOCATION_LATITUDE_DEG: 54.2649301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024200',
        LOCATION_NAME: 'Thorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9796367,
        LOCATION_LATITUDE_DEG: 54.0522161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024300',
        LOCATION_NAME: 'Thorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7662713,
        LOCATION_LATITUDE_DEG: 53.0499145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024100',
        LOCATION_NAME: 'Thorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8702414,
        LOCATION_LATITUDE_DEG: 53.0432965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024400',
        LOCATION_NAME: 'Thorpe',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'TW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5340007,
        LOCATION_LATITUDE_DEG: 51.4055412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024000',
        LOCATION_NAME: 'Thorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2489081,
        LOCATION_LATITUDE_DEG: 53.3141147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024500',
        LOCATION_NAME: 'Thorpe Abbotts',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2233608,
        LOCATION_LATITUDE_DEG: 52.3720061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024600',
        LOCATION_NAME: 'Thorpe Acre',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2298,
        LOCATION_LATITUDE_DEG: 52.7760819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024700',
        LOCATION_NAME: 'Thorpe Arnold',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8580516,
        LOCATION_LATITUDE_DEG: 52.7730772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024800',
        LOCATION_NAME: 'Thorpe Astley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2035675,
        LOCATION_LATITUDE_DEG: 52.6267677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH024900',
        LOCATION_NAME: 'Thorpe Audlin',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2814324,
        LOCATION_LATITUDE_DEG: 53.6384668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025000',
        LOCATION_NAME: 'Thorpe Bassett',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6846644,
        LOCATION_LATITUDE_DEG: 54.1489054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025100',
        LOCATION_NAME: 'Thorpe Bay',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7606394,
        LOCATION_LATITUDE_DEG: 51.5325347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027900',
        LOCATION_NAME: 'Thorpe by Water',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6826832,
        LOCATION_LATITUDE_DEG: 52.5595491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025200',
        LOCATION_NAME: 'Thorpe Constantine',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6164887,
        LOCATION_LATITUDE_DEG: 52.6781743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025300',
        LOCATION_NAME: 'Thorpe Culvert',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1986264,
        LOCATION_LATITUDE_DEG: 53.1196975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025400',
        LOCATION_NAME: 'Thorpe End',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3682361,
        LOCATION_LATITUDE_DEG: 52.64803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025500',
        LOCATION_NAME: 'Thorpe Fendykes',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1702531,
        LOCATION_LATITUDE_DEG: 53.1207937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025600',
        LOCATION_NAME: 'Thorpe Hesley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4338175,
        LOCATION_LATITUDE_DEG: 53.4609505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH040100',
        LOCATION_NAME: 'Thorpe House',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4695062,
        LOCATION_LATITUDE_DEG: 53.3518353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028000',
        LOCATION_NAME: 'Thorpe in Balne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0985139,
        LOCATION_LATITUDE_DEG: 53.5904562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028100',
        LOCATION_NAME: 'Thorpe in the Fallows',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6302711,
        LOCATION_LATITUDE_DEG: 53.3132735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025700',
        LOCATION_NAME: 'Thorpe Langton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.907578,
        LOCATION_LATITUDE_DEG: 52.5253511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025800',
        LOCATION_NAME: 'Thorpe Larches',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3993734,
        LOCATION_LATITUDE_DEG: 54.6278608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH025900',
        LOCATION_NAME: 'Thorpe Latimer',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3124957,
        LOCATION_LATITUDE_DEG: 52.9432805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039800',
        LOCATION_NAME: 'Thorpe le Soken',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026000',
        LOCATION_NAME: 'Thorpe Malsor',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7746134,
        LOCATION_LATITUDE_DEG: 52.402636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026100',
        LOCATION_NAME: 'Thorpe Mandeville',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2223301,
        LOCATION_LATITUDE_DEG: 52.0999156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026200',
        LOCATION_NAME: 'Thorpe Market',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3301708,
        LOCATION_LATITUDE_DEG: 52.874252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026300',
        LOCATION_NAME: 'Thorpe Meadows',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2699514,
        LOCATION_LATITUDE_DEG: 52.5735513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026400',
        LOCATION_NAME: 'Thorpe Morieux',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8381089,
        LOCATION_LATITUDE_DEG: 52.1443951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026500',
        LOCATION_NAME: 'Thorpe On The Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5212409,
        LOCATION_LATITUDE_DEG: 53.7366782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039900',
        LOCATION_NAME: 'Thorpe on the Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6416651,
        LOCATION_LATITUDE_DEG: 53.1807841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026600',
        LOCATION_NAME: 'Thorpe Salvin',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2181495,
        LOCATION_LATITUDE_DEG: 53.3241308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026700',
        LOCATION_NAME: 'Thorpe Satchville',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9150389,
        LOCATION_LATITUDE_DEG: 52.6985728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039200',
        LOCATION_NAME: 'Thorpe St Andrew',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH039300',
        LOCATION_NAME: 'Thorpe St Peter',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2664181,
        LOCATION_LATITUDE_DEG: 53.115872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026800',
        LOCATION_NAME: 'Thorpe St. Andrew',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3452139,
        LOCATION_LATITUDE_DEG: 52.634534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH026900',
        LOCATION_NAME: 'Thorpe St. Peter',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2175945,
        LOCATION_LATITUDE_DEG: 53.1231941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027000',
        LOCATION_NAME: 'Thorpe Thewles',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3787916,
        LOCATION_LATITUDE_DEG: 54.6040557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027100',
        LOCATION_NAME: 'Thorpe Tilney',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3399754,
        LOCATION_LATITUDE_DEG: 53.1066964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027200',
        LOCATION_NAME: 'Thorpe Tilney Dales',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2221159,
        LOCATION_LATITUDE_DEG: 53.1136977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027300',
        LOCATION_NAME: 'Thorpe Tilney Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.281041,
        LOCATION_LATITUDE_DEG: 53.1110028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027500',
        LOCATION_NAME: 'Thorpe Underwood',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2933567,
        LOCATION_LATITUDE_DEG: 54.0290991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027400',
        LOCATION_NAME: 'Thorpe Underwood',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8403103,
        LOCATION_LATITUDE_DEG: 52.4206435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027600',
        LOCATION_NAME: 'Thorpe Waterville',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4929662,
        LOCATION_LATITUDE_DEG: 52.4216357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027700',
        LOCATION_NAME: 'Thorpe Willoughby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.124029,
        LOCATION_LATITUDE_DEG: 53.7716763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH027800',
        LOCATION_NAME: 'Thorpe Wood',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1125196,
        LOCATION_LATITUDE_DEG: 53.7820732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028400',
        LOCATION_NAME: 'Thorpefield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3567352,
        LOCATION_LATITUDE_DEG: 54.206919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028200',
        LOCATION_NAME: 'Thorpe-le-Soken',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1665981,
        LOCATION_LATITUDE_DEG: 51.8558563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028500',
        LOCATION_NAME: 'Thorpeness',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6159148,
        LOCATION_LATITUDE_DEG: 52.1787841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990874',
        LOCATION_NAME: 'Thorpe-Next-Haddiscoe',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028300',
        LOCATION_NAME: 'Thorpe-on-the-Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6397843,
        LOCATION_LATITUDE_DEG: 53.1792072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028600',
        LOCATION_NAME: 'Thorrington',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0408755,
        LOCATION_LATITUDE_DEG: 51.839756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028700',
        LOCATION_NAME: 'Thorverton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5250422,
        LOCATION_LATITUDE_DEG: 50.8079152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028800',
        LOCATION_NAME: 'Thrandeston',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1064573,
        LOCATION_LATITUDE_DEG: 52.34481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH028900',
        LOCATION_NAME: 'Thrapston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5340637,
        LOCATION_LATITUDE_DEG: 52.3962379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029000',
        LOCATION_NAME: 'Threapland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3097412,
        LOCATION_LATITUDE_DEG: 54.741697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029100',
        LOCATION_NAME: 'Threapwood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8337683,
        LOCATION_LATITUDE_DEG: 53.0012185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029200',
        LOCATION_NAME: 'Three Ashes',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7059347,
        LOCATION_LATITUDE_DEG: 51.9044155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029300',
        LOCATION_NAME: 'Three Bridges',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1718806,
        LOCATION_LATITUDE_DEG: 51.1223069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029400',
        LOCATION_NAME: 'Three Burrows',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1614174,
        LOCATION_LATITUDE_DEG: 50.2760824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029500',
        LOCATION_NAME: 'Three Cliffs',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1145836,
        LOCATION_LATITUDE_DEG: 51.5745016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029600',
        LOCATION_NAME: 'Three Cocks',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2053129,
        LOCATION_LATITUDE_DEG: 52.0314318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029700',
        LOCATION_NAME: 'Three Crosses',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0632578,
        LOCATION_LATITUDE_DEG: 51.6277047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029800',
        LOCATION_NAME: 'Three Cups',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3232941,
        LOCATION_LATITUDE_DEG: 50.9556918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH029900',
        LOCATION_NAME: 'Three Elms',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7311409,
        LOCATION_LATITUDE_DEG: 52.0751353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030400',
        LOCATION_NAME: 'Three holes',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2222451,
        LOCATION_LATITUDE_DEG: 52.5769437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030000',
        LOCATION_NAME: 'Three Leg Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4048111,
        LOCATION_LATITUDE_DEG: 51.0534978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030100',
        LOCATION_NAME: 'Three Legged Cross',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8830656,
        LOCATION_LATITUDE_DEG: 50.8493016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030200',
        LOCATION_NAME: 'Three Mile Cross',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9718995,
        LOCATION_LATITUDE_DEG: 51.4042475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030300',
        LOCATION_NAME: 'Three Oaks',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6171318,
        LOCATION_LATITUDE_DEG: 50.900476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030500',
        LOCATION_NAME: 'Threekingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3801908,
        LOCATION_LATITUDE_DEG: 52.911782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030600',
        LOCATION_NAME: 'Threemilestone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1135807,
        LOCATION_LATITUDE_DEG: 50.2628809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030700',
        LOCATION_NAME: 'Threlkeld',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0530128,
        LOCATION_LATITUDE_DEG: 54.6187769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030800',
        LOCATION_NAME: 'Threshers Bush',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1713269,
        LOCATION_LATITUDE_DEG: 51.7617669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH030900',
        LOCATION_NAME: 'Threshfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0153894,
        LOCATION_LATITUDE_DEG: 54.0692143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031000',
        LOCATION_NAME: 'Thrigby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6378156,
        LOCATION_LATITUDE_DEG: 52.652231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031100',
        LOCATION_NAME: 'Thrimby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6826077,
        LOCATION_LATITUDE_DEG: 54.5769767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031200',
        LOCATION_NAME: 'Thringstone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3637033,
        LOCATION_LATITUDE_DEG: 52.75608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031300',
        LOCATION_NAME: 'Thrintoft',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.507201,
        LOCATION_LATITUDE_DEG: 54.331938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031400',
        LOCATION_NAME: 'Thriplow',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0978305,
        LOCATION_LATITUDE_DEG: 52.0991992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031500',
        LOCATION_NAME: 'Throckenholt',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0010392,
        LOCATION_LATITUDE_DEG: 52.6652539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031600',
        LOCATION_NAME: 'Throcking',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0521935,
        LOCATION_LATITUDE_DEG: 51.9539839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031700',
        LOCATION_NAME: 'Throckley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7529576,
        LOCATION_LATITUDE_DEG: 54.9959061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031800',
        LOCATION_NAME: 'Throckmorton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0286456,
        LOCATION_LATITUDE_DEG: 52.1447282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990965',
        LOCATION_NAME: 'Throop',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH031900',
        LOCATION_NAME: 'Throop',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2452382,
        LOCATION_LATITUDE_DEG: 50.7361967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032000',
        LOCATION_NAME: 'Throphill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7944689,
        LOCATION_LATITUDE_DEG: 55.165723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032100',
        LOCATION_NAME: 'Thropton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9506168,
        LOCATION_LATITUDE_DEG: 55.3133337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032200',
        LOCATION_NAME: 'Throsk',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8393167,
        LOCATION_LATITUDE_DEG: 56.0977351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032300',
        LOCATION_NAME: 'Throwleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8820864,
        LOCATION_LATITUDE_DEG: 50.699514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032400',
        LOCATION_NAME: 'Throwley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8550373,
        LOCATION_LATITUDE_DEG: 51.2635051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032500',
        LOCATION_NAME: 'Throwley Forstal',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8515665,
        LOCATION_LATITUDE_DEG: 51.2526065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032600',
        LOCATION_NAME: 'Throxenby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4515865,
        LOCATION_LATITUDE_DEG: 54.2860716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032700',
        LOCATION_NAME: 'Thrum Hall',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8848077,
        LOCATION_LATITUDE_DEG: 53.723583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032800',
        LOCATION_NAME: 'Thrumpton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.232834,
        LOCATION_LATITUDE_DEG: 52.873291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH032900',
        LOCATION_NAME: 'Thrumster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1314246,
        LOCATION_LATITUDE_DEG: 58.3897582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033000',
        LOCATION_NAME: 'Thrunton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8545844,
        LOCATION_LATITUDE_DEG: 55.3929423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033100',
        LOCATION_NAME: 'Thrupp',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1994899,
        LOCATION_LATITUDE_DEG: 51.7332938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033200',
        LOCATION_NAME: 'Thrupp',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3052856,
        LOCATION_LATITUDE_DEG: 51.8366908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033300',
        LOCATION_NAME: 'Thruscross',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.756632,
        LOCATION_LATITUDE_DEG: 54.0238101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033400',
        LOCATION_NAME: 'Thrushwood',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1444937,
        LOCATION_LATITUDE_DEG: 54.6117807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033500',
        LOCATION_NAME: 'Thrussington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0395437,
        LOCATION_LATITUDE_DEG: 52.7366717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033600',
        LOCATION_NAME: 'Thruxton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8202037,
        LOCATION_LATITUDE_DEG: 52.0068222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033700',
        LOCATION_NAME: 'Thruxton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5828955,
        LOCATION_LATITUDE_DEG: 51.2082383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033800',
        LOCATION_NAME: 'Thruxton Airport',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5961333,
        LOCATION_LATITUDE_DEG: 51.2088333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH033900',
        LOCATION_NAME: 'Thruxton Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6460006,
        LOCATION_LATITUDE_DEG: 51.1937336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034000',
        LOCATION_NAME: 'Thrybergh',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2952893,
        LOCATION_LATITUDE_DEG: 53.453049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034100',
        LOCATION_NAME: 'Thulston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3916487,
        LOCATION_LATITUDE_DEG: 52.8827967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034200',
        LOCATION_NAME: 'Thundersley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5783746,
        LOCATION_LATITUDE_DEG: 51.5679403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034300',
        LOCATION_NAME: 'Thundridge',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0278092,
        LOCATION_LATITUDE_DEG: 51.8332762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034400',
        LOCATION_NAME: 'Thurcaston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1602569,
        LOCATION_LATITUDE_DEG: 52.6940718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034500',
        LOCATION_NAME: 'Thurcroft',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2560958,
        LOCATION_LATITUDE_DEG: 53.3947373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034600',
        LOCATION_NAME: 'Thurgarton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9634714,
        LOCATION_LATITUDE_DEG: 53.0355054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034700',
        LOCATION_NAME: 'Thurgarton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2395106,
        LOCATION_LATITUDE_DEG: 52.8693508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034800',
        LOCATION_NAME: 'Thurgoland',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5618979,
        LOCATION_LATITUDE_DEG: 53.505151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035000',
        LOCATION_NAME: 'Thurlaston',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3131501,
        LOCATION_LATITUDE_DEG: 52.3350427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH034900',
        LOCATION_NAME: 'Thurlaston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2577645,
        LOCATION_LATITUDE_DEG: 52.5865611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035100',
        LOCATION_NAME: 'Thurlbear',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0450936,
        LOCATION_LATITUDE_DEG: 50.9885351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035200',
        LOCATION_NAME: 'Thurlby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6442607,
        LOCATION_LATITUDE_DEG: 53.1426033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035300',
        LOCATION_NAME: 'Thurlby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3807179,
        LOCATION_LATITUDE_DEG: 52.7399626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035400',
        LOCATION_NAME: 'Thurlby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.236989,
        LOCATION_LATITUDE_DEG: 53.2596062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035500',
        LOCATION_NAME: 'Thurleigh',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4589161,
        LOCATION_LATITUDE_DEG: 52.2143161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035700',
        LOCATION_NAME: 'Thurlestone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.861738,
        LOCATION_LATITUDE_DEG: 50.2698722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035800',
        LOCATION_NAME: 'Thurlestone Sands',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8549968,
        LOCATION_LATITUDE_DEG: 50.2556685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035900',
        LOCATION_NAME: 'Thurlow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4471816,
        LOCATION_LATITUDE_DEG: 52.1267095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036000',
        LOCATION_NAME: 'Thurloxton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0319983,
        LOCATION_LATITUDE_DEG: 51.0662387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036100',
        LOCATION_NAME: 'Thurlstone',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6483444,
        LOCATION_LATITUDE_DEG: 53.5271552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036200',
        LOCATION_NAME: 'Thurlton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5637457,
        LOCATION_LATITUDE_DEG: 52.5290166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036300',
        LOCATION_NAME: 'Thurmaston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0910869,
        LOCATION_LATITUDE_DEG: 52.6813699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036400',
        LOCATION_NAME: 'Thurnby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0443654,
        LOCATION_LATITUDE_DEG: 52.6285665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036500',
        LOCATION_NAME: 'Thurne',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5552898,
        LOCATION_LATITUDE_DEG: 52.6851338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036700',
        LOCATION_NAME: 'Thurnham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8225507,
        LOCATION_LATITUDE_DEG: 53.9830126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036600',
        LOCATION_NAME: 'Thurnham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5913667,
        LOCATION_LATITUDE_DEG: 51.2909153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036800',
        LOCATION_NAME: 'Thurning',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4025378,
        LOCATION_LATITUDE_DEG: 52.4327405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH036900',
        LOCATION_NAME: 'Thurning',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0887135,
        LOCATION_LATITUDE_DEG: 52.823051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037000',
        LOCATION_NAME: 'Thurnscoe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3090682,
        LOCATION_LATITUDE_DEG: 53.5449588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037100',
        LOCATION_NAME: 'Thurnscoe East',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2959065,
        LOCATION_LATITUDE_DEG: 53.543156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037200',
        LOCATION_NAME: 'Thursby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0493768,
        LOCATION_LATITUDE_DEG: 54.8425048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037300',
        LOCATION_NAME: 'Thursford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.961629,
        LOCATION_LATITUDE_DEG: 52.8652622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037400',
        LOCATION_NAME: 'Thursley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7112821,
        LOCATION_LATITUDE_DEG: 51.1493181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037500',
        LOCATION_NAME: 'Thurso',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5230836,
        LOCATION_LATITUDE_DEG: 58.5928802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037600',
        LOCATION_NAME: 'Thurso East',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5107414,
        LOCATION_LATITUDE_DEG: 58.5931785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037700',
        LOCATION_NAME: 'Thurstaston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1311984,
        LOCATION_LATITUDE_DEG: 53.3489569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037800',
        LOCATION_NAME: 'Thurston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8257435,
        LOCATION_LATITUDE_DEG: 52.2496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH037900',
        LOCATION_NAME: 'Thurstonfield',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0664883,
        LOCATION_LATITUDE_DEG: 54.8990066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038000',
        LOCATION_NAME: 'Thurstonland',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7501878,
        LOCATION_LATITUDE_DEG: 53.5898607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038100',
        LOCATION_NAME: 'Thurton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4344698,
        LOCATION_LATITUDE_DEG: 52.5566258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038200',
        LOCATION_NAME: 'Thurvaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6372222,
        LOCATION_LATITUDE_DEG: 52.9391006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038300',
        LOCATION_NAME: 'Thuxton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0054693,
        LOCATION_LATITUDE_DEG: 52.6246341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038400',
        LOCATION_NAME: 'Thwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1664913,
        LOCATION_LATITUDE_DEG: 54.3790466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038500',
        LOCATION_NAME: 'Thwaite',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0975007,
        LOCATION_LATITUDE_DEG: 52.2709029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038600',
        LOCATION_NAME: 'Thwaite Flat',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2202762,
        LOCATION_LATITUDE_DEG: 54.156837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038700',
        LOCATION_NAME: 'Thwaites',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8835018,
        LOCATION_LATITUDE_DEG: 53.8668938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038800',
        LOCATION_NAME: 'Thwaites Brow',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8858133,
        LOCATION_LATITUDE_DEG: 53.8613948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH038900',
        LOCATION_NAME: 'Thwing',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3945015,
        LOCATION_LATITUDE_DEG: 54.1153961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000200',
        LOCATION_NAME: 'Tibbermore',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5385378,
        LOCATION_LATITUDE_DEG: 56.395658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000400',
        LOCATION_NAME: 'Tibberton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4730779,
        LOCATION_LATITUDE_DEG: 52.779194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000500',
        LOCATION_NAME: 'Tibberton',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3299937,
        LOCATION_LATITUDE_DEG: 51.8950098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000300',
        LOCATION_NAME: 'Tibberton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1406223,
        LOCATION_LATITUDE_DEG: 52.2129381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000600',
        LOCATION_NAME: 'Tibenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.146159,
        LOCATION_LATITUDE_DEG: 52.4634135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000700',
        LOCATION_NAME: 'Tibshelf',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3435338,
        LOCATION_LATITUDE_DEG: 53.1415169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000800',
        LOCATION_NAME: 'Tibthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5350633,
        LOCATION_LATITUDE_DEG: 53.9862835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000900',
        LOCATION_NAME: 'Ticehurst',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4118253,
        LOCATION_LATITUDE_DEG: 51.0453927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001000',
        LOCATION_NAME: 'Tichborne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1856308,
        LOCATION_LATITUDE_DEG: 51.0684162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001100',
        LOCATION_NAME: 'Tick Fen',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0295314,
        LOCATION_LATITUDE_DEG: 52.4409332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI990144',
        LOCATION_NAME: 'Tickencote',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5366138,
        LOCATION_LATITUDE_DEG: 52.6771607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001200',
        LOCATION_NAME: 'Tickencote',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5344927,
        LOCATION_LATITUDE_DEG: 52.6755609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001300',
        LOCATION_NAME: 'Tickenham',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7946996,
        LOCATION_LATITUDE_DEG: 51.4424744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001400',
        LOCATION_NAME: 'Tickhill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1076803,
        LOCATION_LATITUDE_DEG: 53.4320444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001500',
        LOCATION_NAME: 'Tickhill Spital',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0817326,
        LOCATION_LATITUDE_DEG: 53.4311375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001600',
        LOCATION_NAME: 'Ticklerton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7602755,
        LOCATION_LATITUDE_DEG: 52.512369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001700',
        LOCATION_NAME: 'Ticknall',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4795985,
        LOCATION_LATITUDE_DEG: 52.8111823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001800',
        LOCATION_NAME: 'Tickton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3808307,
        LOCATION_LATITUDE_DEG: 53.8623739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI001900',
        LOCATION_NAME: 'Tidbury Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B90',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8523235,
        LOCATION_LATITUDE_DEG: 52.3801495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002000',
        LOCATION_NAME: 'Tidcombe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5890185,
        LOCATION_LATITUDE_DEG: 51.3180455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002100',
        LOCATION_NAME: 'Tiddington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6736329,
        LOCATION_LATITUDE_DEG: 52.1982292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002200',
        LOCATION_NAME: 'Tiddington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0593165,
        LOCATION_LATITUDE_DEG: 51.7406781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002300',
        LOCATION_NAME: 'Tiddycross',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5729115,
        LOCATION_LATITUDE_DEG: 52.7026924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002400',
        LOCATION_NAME: 'Tidebrook',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3014286,
        LOCATION_LATITUDE_DEG: 51.0442918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002500',
        LOCATION_NAME: 'Tideford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3252839,
        LOCATION_LATITUDE_DEG: 50.4135913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002600',
        LOCATION_NAME: 'Tideford Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3347378,
        LOCATION_LATITUDE_DEG: 50.4251951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002700',
        LOCATION_NAME: 'Tidenham',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6409,
        LOCATION_LATITUDE_DEG: 51.6591924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002800',
        LOCATION_NAME: 'Tidenham Chase',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6471978,
        LOCATION_LATITUDE_DEG: 51.6770258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI002900',
        LOCATION_NAME: 'Tideswell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7723942,
        LOCATION_LATITUDE_DEG: 53.2778316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003000',
        LOCATION_NAME: 'Tidmarsh',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0854617,
        LOCATION_LATITUDE_DEG: 51.4682556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003100',
        LOCATION_NAME: 'Tidmington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6199107,
        LOCATION_LATITUDE_DEG: 52.0426125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003300',
        LOCATION_NAME: 'Tidworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6629526,
        LOCATION_LATITUDE_DEG: 51.2399356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003400',
        LOCATION_NAME: 'Tiers Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0339987,
        LOCATION_LATITUDE_DEG: 51.7556235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003700',
        LOCATION_NAME: 'Tiffenthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1501936,
        LOCATION_LATITUDE_DEG: 54.8130994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003800',
        LOCATION_NAME: 'Tiffield',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9791947,
        LOCATION_LATITUDE_DEG: 52.1594218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003900',
        LOCATION_NAME: 'Tifty',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3752938,
        LOCATION_LATITUDE_DEG: 57.4551513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004000',
        LOCATION_NAME: 'Tigharry',
        COUNTY_NAME: 'Isle of North Uist',
        POSTCODE: 'HS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5066573,
        LOCATION_LATITUDE_DEG: 57.6183238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004100',
        LOCATION_NAME: 'Tighnabruaich',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2333628,
        LOCATION_LATITUDE_DEG: 55.9053339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004200',
        LOCATION_NAME: 'Tighnafiline',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5853982,
        LOCATION_LATITUDE_DEG: 57.8450233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004300',
        LOCATION_NAME: 'Tigley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7480088,
        LOCATION_LATITUDE_DEG: 50.432785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004500',
        LOCATION_NAME: 'Tilbrook',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6877449,
        LOCATION_LATITUDE_DEG: 52.0096969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004400',
        LOCATION_NAME: 'Tilbrook',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4162335,
        LOCATION_LATITUDE_DEG: 52.3079263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004600',
        LOCATION_NAME: 'Tilbury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3652657,
        LOCATION_LATITUDE_DEG: 51.461137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004700',
        LOCATION_NAME: 'Tilbury Juxta Clare',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5678914,
        LOCATION_LATITUDE_DEG: 52.0340861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004800',
        LOCATION_NAME: 'Tile Barn',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3795372,
        LOCATION_LATITUDE_DEG: 51.3520425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI016500',
        LOCATION_NAME: 'Tile Cross',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.76078,
        LOCATION_LATITUDE_DEG: 52.4821027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI004900',
        LOCATION_NAME: 'Tile Hill',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5936622,
        LOCATION_LATITUDE_DEG: 52.4004479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005000',
        LOCATION_NAME: 'Tilehurst',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0424746,
        LOCATION_LATITUDE_DEG: 51.4562487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005100',
        LOCATION_NAME: 'Tilesford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0524572,
        LOCATION_LATITUDE_DEG: 52.147831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005200',
        LOCATION_NAME: 'Tilford',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7490868,
        LOCATION_LATITUDE_DEG: 51.1790203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005300',
        LOCATION_NAME: 'Tillers Green',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4496215,
        LOCATION_LATITUDE_DEG: 51.9894151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005400',
        LOCATION_NAME: 'Tilley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7295025,
        LOCATION_LATITUDE_DEG: 52.846107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005500',
        LOCATION_NAME: 'Tillicoultry',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7379549,
        LOCATION_LATITUDE_DEG: 56.1530364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005600',
        LOCATION_NAME: 'Tillingham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.884131,
        LOCATION_LATITUDE_DEG: 51.6964448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005800',
        LOCATION_NAME: 'Tillington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7783124,
        LOCATION_LATITUDE_DEG: 52.1024381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005700',
        LOCATION_NAME: 'Tillington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6151788,
        LOCATION_LATITUDE_DEG: 50.9827981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI005900',
        LOCATION_NAME: 'Tillyfourie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5897761,
        LOCATION_LATITUDE_DEG: 57.2005318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006000',
        LOCATION_NAME: 'Tillymorgan',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5668257,
        LOCATION_LATITUDE_DEG: 57.3931478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006100',
        LOCATION_NAME: 'Tilmanstone',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2970576,
        LOCATION_LATITUDE_DEG: 51.2157965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006200',
        LOCATION_NAME: 'Tiln',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9430785,
        LOCATION_LATITUDE_DEG: 53.3503301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006300',
        LOCATION_NAME: 'Tilney All Saints',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3225613,
        LOCATION_LATITUDE_DEG: 52.7372548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006400',
        LOCATION_NAME: 'Tilney Fen End',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2839591,
        LOCATION_LATITUDE_DEG: 52.6767475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015700',
        LOCATION_NAME: 'Tilney St Lawrence',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006500',
        LOCATION_NAME: 'Tilney St. Lawrence',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2904134,
        LOCATION_LATITUDE_DEG: 52.6991494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006600',
        LOCATION_NAME: 'Tilsdown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3639206,
        LOCATION_LATITUDE_DEG: 51.695591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006700',
        LOCATION_NAME: 'Tilshead',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9500398,
        LOCATION_LATITUDE_DEG: 51.2298435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006800',
        LOCATION_NAME: 'Tilstock',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6823759,
        LOCATION_LATITUDE_DEG: 52.9355105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI006900',
        LOCATION_NAME: 'Tilston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8049372,
        LOCATION_LATITUDE_DEG: 53.056025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007000',
        LOCATION_NAME: 'Tilstone Fearnall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6501356,
        LOCATION_LATITUDE_DEG: 53.1401312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007100',
        LOCATION_NAME: 'Tilsworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5773526,
        LOCATION_LATITUDE_DEG: 51.9092913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007200',
        LOCATION_NAME: 'Tilton on the Hill',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9016192,
        LOCATION_LATITUDE_DEG: 52.6435672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007300',
        LOCATION_NAME: 'Tilty',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3266792,
        LOCATION_LATITUDE_DEG: 51.9136745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007600',
        LOCATION_NAME: 'Timberland',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.327455,
        LOCATION_LATITUDE_DEG: 53.1117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007700',
        LOCATION_NAME: 'Timberland Dales',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2321434,
        LOCATION_LATITUDE_DEG: 53.1308045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007800',
        LOCATION_NAME: 'Timberland Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2873733,
        LOCATION_LATITUDE_DEG: 53.1171001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007900',
        LOCATION_NAME: 'Timberscombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4940336,
        LOCATION_LATITUDE_DEG: 51.1689549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008000',
        LOCATION_NAME: 'Timble',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7256314,
        LOCATION_LATITUDE_DEG: 53.972103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008300',
        LOCATION_NAME: 'Timperley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3154966,
        LOCATION_LATITUDE_DEG: 53.3976536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008400',
        LOCATION_NAME: 'Timsbury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4768145,
        LOCATION_LATITUDE_DEG: 51.3254579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008500',
        LOCATION_NAME: 'Timsbury',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5036929,
        LOCATION_LATITUDE_DEG: 51.0190186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008600',
        LOCATION_NAME: 'Timsgarry',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.0129058,
        LOCATION_LATITUDE_DEG: 58.1963734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008700',
        LOCATION_NAME: 'Timworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7226198,
        LOCATION_LATITUDE_DEG: 52.2877847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009000',
        LOCATION_NAME: 'Tincleton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3238267,
        LOCATION_LATITUDE_DEG: 50.7263008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009200',
        LOCATION_NAME: 'Tindale Crescent',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6987184,
        LOCATION_LATITUDE_DEG: 54.6437693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009250',
        LOCATION_NAME: 'Tindale Fell',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.596462,
        LOCATION_LATITUDE_DEG: 54.9271183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009300',
        LOCATION_NAME: 'Tingewick',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0465437,
        LOCATION_LATITUDE_DEG: 51.9899031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009400',
        LOCATION_NAME: 'Tingley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5691567,
        LOCATION_LATITUDE_DEG: 53.73028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009500',
        LOCATION_NAME: 'Tingley Common',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5860706,
        LOCATION_LATITUDE_DEG: 53.7337735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009600',
        LOCATION_NAME: 'Tingrith',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5322689,
        LOCATION_LATITUDE_DEG: 51.9795988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009700',
        LOCATION_NAME: 'Tinhay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.269265,
        LOCATION_LATITUDE_DEG: 50.64291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009800',
        LOCATION_NAME: 'Tinkers Bridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7196485,
        LOCATION_LATITUDE_DEG: 52.0192021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009900',
        LOCATION_NAME: 'Tinkers Cross',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7935852,
        LOCATION_LATITUDE_DEG: 50.9410098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI016200',
        LOCATION_NAME: 'Tinshill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6178698,
        LOCATION_LATITUDE_DEG: 53.8515641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010500',
        LOCATION_NAME: 'Tinsley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4131254,
        LOCATION_LATITUDE_DEG: 53.4081441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010600',
        LOCATION_NAME: 'Tinsley Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1624606,
        LOCATION_LATITUDE_DEG: 51.140714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010700',
        LOCATION_NAME: 'Tintagel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7480653,
        LOCATION_LATITUDE_DEG: 50.6620213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010800',
        LOCATION_NAME: 'Tintern',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6840457,
        LOCATION_LATITUDE_DEG: 51.6995946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010900',
        LOCATION_NAME: 'Tintinhull',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7122719,
        LOCATION_LATITUDE_DEG: 50.9709291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011000',
        LOCATION_NAME: 'Tintwistle',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9706944,
        LOCATION_LATITUDE_DEG: 53.4720599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011100',
        LOCATION_NAME: 'Tinwald',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5605624,
        LOCATION_LATITUDE_DEG: 55.1179333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI990145',
        LOCATION_NAME: 'Tinwell',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5154952,
        LOCATION_LATITUDE_DEG: 52.6481701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011200',
        LOCATION_NAME: 'Tinwell',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5138178,
        LOCATION_LATITUDE_DEG: 52.6457573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011300',
        LOCATION_NAME: 'Tipner',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0886138,
        LOCATION_LATITUDE_DEG: 50.8243964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011500',
        LOCATION_NAME: 'Tipperty',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0592686,
        LOCATION_LATITUDE_DEG: 57.3317383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011600',
        LOCATION_NAME: 'Tiptoe',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6360699,
        LOCATION_LATITUDE_DEG: 50.7779952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011700',
        LOCATION_NAME: 'Tipton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0652798,
        LOCATION_LATITUDE_DEG: 52.5295651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011800',
        LOCATION_NAME: 'Tipton Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0660559,
        LOCATION_LATITUDE_DEG: 52.5260672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015800',
        LOCATION_NAME: 'Tipton St John',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011900',
        LOCATION_NAME: 'Tipton St. John',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2856265,
        LOCATION_LATITUDE_DEG: 50.7177106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012000',
        LOCATION_NAME: 'Tiptree',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7506118,
        LOCATION_LATITUDE_DEG: 51.8121616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012100',
        LOCATION_NAME: 'Tiptree Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7318362,
        LOCATION_LATITUDE_DEG: 51.8011586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI016100',
        LOCATION_NAME: 'Tir y Berth',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012300',
        LOCATION_NAME: 'Tirabad',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6372402,
        LOCATION_LATITUDE_DEG: 52.0590436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012500',
        LOCATION_NAME: 'Tirdeunaw',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9535728,
        LOCATION_LATITUDE_DEG: 51.6679027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012600',
        LOCATION_NAME: 'Tiresford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6609971,
        LOCATION_LATITUDE_DEG: 53.1464364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012700',
        LOCATION_NAME: 'Tirley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.235982,
        LOCATION_LATITUDE_DEG: 51.9549149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012900',
        LOCATION_NAME: 'Tiroran',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0841543,
        LOCATION_LATITUDE_DEG: 56.3832841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013000',
        LOCATION_NAME: 'Tirphil',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2487012,
        LOCATION_LATITUDE_DEG: 51.7162985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013100',
        LOCATION_NAME: 'Tirquin',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2379707,
        LOCATION_LATITUDE_DEG: 54.6165479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013300',
        LOCATION_NAME: 'Tirril',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.76942,
        LOCATION_LATITUDE_DEG: 54.6326763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012200',
        LOCATION_NAME: 'Tir-y-Berth',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2273073,
        LOCATION_LATITUDE_DEG: 51.6607962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013500',
        LOCATION_NAME: 'Tisbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0795795,
        LOCATION_LATITUDE_DEG: 51.0627272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013600',
        LOCATION_NAME: 'Tissington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7367041,
        LOCATION_LATITUDE_DEG: 53.0665115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI900651',
        LOCATION_NAME: 'Titchberry',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5156713,
        LOCATION_LATITUDE_DEG: 51.0181692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013700',
        LOCATION_NAME: 'Titchfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2328816,
        LOCATION_LATITUDE_DEG: 50.8484939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013800',
        LOCATION_NAME: 'Titchmarsh',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4966749,
        LOCATION_LATITUDE_DEG: 52.4064327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013900',
        LOCATION_NAME: 'Titchwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6144011,
        LOCATION_LATITUDE_DEG: 52.9614694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014000',
        LOCATION_NAME: 'Tithby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9605837,
        LOCATION_LATITUDE_DEG: 52.9247873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014100',
        LOCATION_NAME: 'Titley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9791241,
        LOCATION_LATITUDE_DEG: 52.2347485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014200',
        LOCATION_NAME: 'Titsey',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0182925,
        LOCATION_LATITUDE_DEG: 51.2662151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014300',
        LOCATION_NAME: 'Tittensor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1898854,
        LOCATION_LATITUDE_DEG: 52.9424064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014400',
        LOCATION_NAME: 'Titterhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7207364,
        LOCATION_LATITUDE_DEG: 52.4204655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014500',
        LOCATION_NAME: 'Tittleshall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8078242,
        LOCATION_LATITUDE_DEG: 52.7537508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014600',
        LOCATION_NAME: 'Titton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2525796,
        LOCATION_LATITUDE_DEG: 52.3255481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014800',
        LOCATION_NAME: 'Tiverton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4881506,
        LOCATION_LATITUDE_DEG: 50.9097283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014700',
        LOCATION_NAME: 'Tiverton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6721198,
        LOCATION_LATITUDE_DEG: 53.1405305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI014900',
        LOCATION_NAME: 'Tiverton Junction',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3731385,
        LOCATION_LATITUDE_DEG: 50.8934287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015900',
        LOCATION_NAME: 'Tivetshall St Margaret',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI016000',
        LOCATION_NAME: 'Tivetshall St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015000',
        LOCATION_NAME: 'Tivetshall St. Margaret',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1916933,
        LOCATION_LATITUDE_DEG: 52.4335176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015100',
        LOCATION_NAME: 'Tivetshall St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1907281,
        LOCATION_LATITUDE_DEG: 52.4283088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015200',
        LOCATION_NAME: 'Tividale',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0358858,
        LOCATION_LATITUDE_DEG: 52.5146616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015300',
        LOCATION_NAME: 'Tivington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5268456,
        LOCATION_LATITUDE_DEG: 51.1917529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015500',
        LOCATION_NAME: 'Tixall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0334369,
        LOCATION_LATITUDE_DEG: 52.8019883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015600',
        LOCATION_NAME: 'Tixover',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5576692,
        LOCATION_LATITUDE_DEG: 52.5952543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000100',
        LOCATION_NAME: 'Toab',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8514398,
        LOCATION_LATITUDE_DEG: 58.9468025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000800',
        LOCATION_NAME: 'Tobermore',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7060581,
        LOCATION_LATITUDE_DEG: 54.8117372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000900',
        LOCATION_NAME: 'Tobermory',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0685251,
        LOCATION_LATITUDE_DEG: 56.6239085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001000',
        LOCATION_NAME: 'Toberonochy',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6297468,
        LOCATION_LATITUDE_DEG: 56.215469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001200',
        LOCATION_NAME: 'Tobson',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8724974,
        LOCATION_LATITUDE_DEG: 58.2428755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001300',
        LOCATION_NAME: 'Tockenham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9447444,
        LOCATION_LATITUDE_DEG: 51.5127697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001400',
        LOCATION_NAME: 'Tockenham Wick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9484789,
        LOCATION_LATITUDE_DEG: 51.523967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001500',
        LOCATION_NAME: 'Tockholes',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5119736,
        LOCATION_LATITUDE_DEG: 53.7025886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001600',
        LOCATION_NAME: 'Tockington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5648883,
        LOCATION_LATITUDE_DEG: 51.5751797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001700',
        LOCATION_NAME: 'Tockwith',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2852489,
        LOCATION_LATITUDE_DEG: 53.9649961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001800',
        LOCATION_NAME: 'Todber',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2856463,
        LOCATION_LATITUDE_DEG: 50.9785251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001900',
        LOCATION_NAME: 'Toddington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9479748,
        LOCATION_LATITUDE_DEG: 51.9901089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002000',
        LOCATION_NAME: 'Toddington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5308496,
        LOCATION_LATITUDE_DEG: 51.9490875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002100',
        LOCATION_NAME: 'Todenham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6478912,
        LOCATION_LATITUDE_DEG: 52.0243114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002200',
        LOCATION_NAME: 'Todhills',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9832759,
        LOCATION_LATITUDE_DEG: 54.9556125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002300',
        LOCATION_NAME: 'Todhills',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6693083,
        LOCATION_LATITUDE_DEG: 54.7005761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002400',
        LOCATION_NAME: 'Todmorden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0962986,
        LOCATION_LATITUDE_DEG: 53.7133791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002500',
        LOCATION_NAME: 'Todpool',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1676198,
        LOCATION_LATITUDE_DEG: 50.2434794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002600',
        LOCATION_NAME: 'Todwick',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2562407,
        LOCATION_LATITUDE_DEG: 53.3536365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002800',
        LOCATION_NAME: 'Toft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4149135,
        LOCATION_LATITUDE_DEG: 52.7415216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002900',
        LOCATION_NAME: 'Toft',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0113645,
        LOCATION_LATITUDE_DEG: 52.1865064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003000',
        LOCATION_NAME: 'Toft Hill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7511194,
        LOCATION_LATITUDE_DEG: 54.6480677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003100',
        LOCATION_NAME: 'Toft Monks',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5777931,
        LOCATION_LATITUDE_DEG: 52.4968112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003150',
        LOCATION_NAME: 'Toft next Newton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4320761,
        LOCATION_LATITUDE_DEG: 53.379989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003200',
        LOCATION_NAME: 'Toftrees',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8164859,
        LOCATION_LATITUDE_DEG: 52.813055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003900',
        LOCATION_NAME: 'Tokers Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9907143,
        LOCATION_LATITUDE_DEG: 51.4926583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004000',
        LOCATION_NAME: 'Tolcis',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0248094,
        LOCATION_LATITUDE_DEG: 50.8003141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004100',
        LOCATION_NAME: 'Tolgullow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1830222,
        LOCATION_LATITUDE_DEG: 50.2421855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004200',
        LOCATION_NAME: 'Tolgus',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2378326,
        LOCATION_LATITUDE_DEG: 50.233877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004300',
        LOCATION_NAME: 'Tolgus Mount',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2473259,
        LOCATION_LATITUDE_DEG: 50.2385782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004400',
        LOCATION_NAME: 'Tolgus Vean',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2524263,
        LOCATION_LATITUDE_DEG: 50.2312828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004500',
        LOCATION_NAME: 'Toll Bar',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1536119,
        LOCATION_LATITUDE_DEG: 53.5658584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004600',
        LOCATION_NAME: 'Tolland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2862477,
        LOCATION_LATITUDE_DEG: 51.0789526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004700',
        LOCATION_NAME: 'Tollard Royal',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.079132,
        LOCATION_LATITUDE_DEG: 50.9592151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004800',
        LOCATION_NAME: 'Tollbar End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4733343,
        LOCATION_LATITUDE_DEG: 52.3767487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO024500',
        LOCATION_NAME: 'Tollcross',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1699915,
        LOCATION_LATITUDE_DEG: 55.8428889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023700',
        LOCATION_NAME: 'Tollcross',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2028643,
        LOCATION_LATITUDE_DEG: 55.9445829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO004900',
        LOCATION_NAME: 'Toller Fratrum',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5966356,
        LOCATION_LATITUDE_DEG: 50.7735025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005000',
        LOCATION_NAME: 'Toller Porcorum',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6208013,
        LOCATION_LATITUDE_DEG: 50.7786017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005100',
        LOCATION_NAME: 'Toller Whelme',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6863083,
        LOCATION_LATITUDE_DEG: 50.8105132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005200',
        LOCATION_NAME: 'Tollerford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5773593,
        LOCATION_LATITUDE_DEG: 50.7746068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005400',
        LOCATION_NAME: 'Tollerton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2164896,
        LOCATION_LATITUDE_DEG: 54.0717066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005300',
        LOCATION_NAME: 'Tollerton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0915998,
        LOCATION_LATITUDE_DEG: 52.9008941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005500',
        LOCATION_NAME: 'Tollesbury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8321744,
        LOCATION_LATITUDE_DEG: 51.7581542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005600',
        LOCATION_NAME: "Tolleshunt D'Arcy",
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7971154,
        LOCATION_LATITUDE_DEG: 51.7729539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005700',
        LOCATION_NAME: 'Tolleshunt Knights',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7781591,
        LOCATION_LATITUDE_DEG: 51.7985615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005800',
        LOCATION_NAME: 'Tolleshunt Major',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7552574,
        LOCATION_LATITUDE_DEG: 51.7679527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO005900',
        LOCATION_NAME: 'Tolmachan',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8786976,
        LOCATION_LATITUDE_DEG: 57.9629525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006000',
        LOCATION_NAME: 'Tolpuddle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.292454,
        LOCATION_LATITUDE_DEG: 50.748796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006100',
        LOCATION_NAME: 'Tolskithy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2466251,
        LOCATION_LATITUDE_DEG: 50.228683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006200',
        LOCATION_NAME: 'Tolstachaolais',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7806965,
        LOCATION_LATITUDE_DEG: 58.2411779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006300',
        LOCATION_NAME: 'Tolvaddon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2879271,
        LOCATION_LATITUDE_DEG: 50.2310834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006500',
        LOCATION_NAME: 'Tomatin',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9894439,
        LOCATION_LATITUDE_DEG: 57.335558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007000',
        LOCATION_NAME: 'Tomich',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8111276,
        LOCATION_LATITUDE_DEG: 57.304964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006900',
        LOCATION_NAME: 'Tomich',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1810031,
        LOCATION_LATITUDE_DEG: 57.7094031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007100',
        LOCATION_NAME: 'Tomintoul',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3774434,
        LOCATION_LATITUDE_DEG: 57.2515424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007200',
        LOCATION_NAME: 'Tomnavoulin',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3097008,
        LOCATION_LATITUDE_DEG: 57.3185481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007300',
        LOCATION_NAME: 'Ton Kenfig',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.724053,
        LOCATION_LATITUDE_DEG: 51.5166864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007400',
        LOCATION_NAME: 'Ton Pentre',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4879239,
        LOCATION_LATITUDE_DEG: 51.6460025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007500',
        LOCATION_NAME: 'Tonbridge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2768296,
        LOCATION_LATITUDE_DEG: 51.1954063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007600',
        LOCATION_NAME: 'Tondu',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.596269,
        LOCATION_LATITUDE_DEG: 51.5459876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007700',
        LOCATION_NAME: 'Tonedale',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2420189,
        LOCATION_LATITUDE_DEG: 50.9862295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008200',
        LOCATION_NAME: 'Tong',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3252195,
        LOCATION_LATITUDE_DEG: 58.2454762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008000',
        LOCATION_NAME: 'Tong',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.302083,
        LOCATION_LATITUDE_DEG: 52.6638807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008100',
        LOCATION_NAME: 'Tong',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6643214,
        LOCATION_LATITUDE_DEG: 53.7709815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008300',
        LOCATION_NAME: 'Tong Allotments',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3518259,
        LOCATION_LATITUDE_DEG: 58.249473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008400',
        LOCATION_NAME: 'Tong Forge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3220299,
        LOCATION_LATITUDE_DEG: 52.6716861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008500',
        LOCATION_NAME: 'Tong Havana',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2987751,
        LOCATION_LATITUDE_DEG: 52.6623787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008600',
        LOCATION_NAME: 'Tong Norton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3077149,
        LOCATION_LATITUDE_DEG: 52.6698811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO024700',
        LOCATION_NAME: 'Tong Road',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6076113,
        LOCATION_LATITUDE_DEG: 53.7942618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008700',
        LOCATION_NAME: 'Tongdean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1701978,
        LOCATION_LATITUDE_DEG: 50.851185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008900',
        LOCATION_NAME: 'Tonge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3739791,
        LOCATION_LATITUDE_DEG: 52.803183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO008800',
        LOCATION_NAME: 'Tonge',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7830266,
        LOCATION_LATITUDE_DEG: 51.3518184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009000',
        LOCATION_NAME: 'Tongham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7302485,
        LOCATION_LATITUDE_DEG: 51.2324272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009100',
        LOCATION_NAME: 'Tongland',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.030976,
        LOCATION_LATITUDE_DEG: 54.8630145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009200',
        LOCATION_NAME: 'Tongue',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4162116,
        LOCATION_LATITUDE_DEG: 58.4763773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009400',
        LOCATION_NAME: 'Tongue End',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9489885,
        LOCATION_LATITUDE_DEG: 50.7363182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009300',
        LOCATION_NAME: 'Tongue End',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2846406,
        LOCATION_LATITUDE_DEG: 52.7505616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009500',
        LOCATION_NAME: 'Tongwell',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.727447,
        LOCATION_LATITUDE_DEG: 52.0664058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009600',
        LOCATION_NAME: 'Tongwynlais',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2475988,
        LOCATION_LATITUDE_DEG: 51.5302851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009700',
        LOCATION_NAME: 'Tonmawr',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7318456,
        LOCATION_LATITUDE_DEG: 51.6513004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009800',
        LOCATION_NAME: 'Tonna',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7718875,
        LOCATION_LATITUDE_DEG: 51.6760009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO009900',
        LOCATION_NAME: 'Tonteg',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3070813,
        LOCATION_LATITUDE_DEG: 51.5702856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010000',
        LOCATION_NAME: 'Tonwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0627543,
        LOCATION_LATITUDE_DEG: 51.8368789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010100',
        LOCATION_NAME: 'Tonypandy',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4485383,
        LOCATION_LATITUDE_DEG: 51.6184909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010200',
        LOCATION_NAME: 'Tonyrefail',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4291642,
        LOCATION_LATITUDE_DEG: 51.5834939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010400',
        LOCATION_NAME: 'Toomebridge',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4072356,
        LOCATION_LATITUDE_DEG: 54.7618285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012000',
        LOCATION_NAME: 'Toot Baldon',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1792002,
        LOCATION_LATITUDE_DEG: 51.7018752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012100',
        LOCATION_NAME: 'Toot Hill',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1935601,
        LOCATION_LATITUDE_DEG: 51.700161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012200',
        LOCATION_NAME: 'Toothill',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8237641,
        LOCATION_LATITUDE_DEG: 51.5516686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023800',
        LOCATION_NAME: 'Tooting',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1621794,
        LOCATION_LATITUDE_DEG: 51.4304911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012300',
        LOCATION_NAME: 'Top Bradley',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0050421,
        LOCATION_LATITUDE_DEG: 53.0829308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012400',
        LOCATION_NAME: 'Top Valley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1694088,
        LOCATION_LATITUDE_DEG: 53.0033985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012500',
        LOCATION_NAME: 'Topcliffe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3906533,
        LOCATION_LATITUDE_DEG: 54.1777206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012600',
        LOCATION_NAME: 'Topcroft',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3368243,
        LOCATION_LATITUDE_DEG: 52.4887212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012650',
        LOCATION_NAME: 'Topped Mountain',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5400559,
        LOCATION_LATITUDE_DEG: 54.3277361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012700',
        LOCATION_NAME: 'Toppesfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5331797,
        LOCATION_LATITUDE_DEG: 52.0076855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012800',
        LOCATION_NAME: 'Topsham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4655108,
        LOCATION_LATITUDE_DEG: 50.6845037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO012900',
        LOCATION_NAME: 'Tor Hill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.237829,
        LOCATION_LATITUDE_DEG: 50.4018859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013000',
        LOCATION_NAME: 'Torastay',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4311133,
        LOCATION_LATITUDE_DEG: 58.091056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013100',
        LOCATION_NAME: 'Torbeg',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3244449,
        LOCATION_LATITUDE_DEG: 55.5190957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013200',
        LOCATION_NAME: 'Torbryan',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6626903,
        LOCATION_LATITUDE_DEG: 50.4888861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013300',
        LOCATION_NAME: 'Torcross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6520058,
        LOCATION_LATITUDE_DEG: 50.265865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013400',
        LOCATION_NAME: 'Tore',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3290528,
        LOCATION_LATITUDE_DEG: 57.5406844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013500',
        LOCATION_NAME: 'Torgormack',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5243377,
        LOCATION_LATITUDE_DEG: 57.469381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013600',
        LOCATION_NAME: 'Torksey',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7436784,
        LOCATION_LATITUDE_DEG: 53.2998226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013700',
        LOCATION_NAME: 'Torksey Lock',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7431764,
        LOCATION_LATITUDE_DEG: 53.2939196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013800',
        LOCATION_NAME: 'Torloisk',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2449737,
        LOCATION_LATITUDE_DEG: 56.5311978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO013900',
        LOCATION_NAME: 'Torlum',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3610082,
        LOCATION_LATITUDE_DEG: 57.4346058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014000',
        LOCATION_NAME: 'Torlundy',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0452208,
        LOCATION_LATITUDE_DEG: 56.848018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014100',
        LOCATION_NAME: 'Tormarton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'GL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3335494,
        LOCATION_LATITUDE_DEG: 51.5065713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014200',
        LOCATION_NAME: 'Torness',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3577475,
        LOCATION_LATITUDE_DEG: 57.3114625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014300',
        LOCATION_NAME: 'Toronto',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6892054,
        LOCATION_LATITUDE_DEG: 54.6698728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014400',
        LOCATION_NAME: 'Torpantau',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3923262,
        LOCATION_LATITUDE_DEG: 51.8597183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014500',
        LOCATION_NAME: 'Torpenhow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2391965,
        LOCATION_LATITUDE_DEG: 54.7463933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014600',
        LOCATION_NAME: 'Torphichen',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6564725,
        LOCATION_LATITUDE_DEG: 55.9318149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014700',
        LOCATION_NAME: 'Torphin',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2748316,
        LOCATION_LATITUDE_DEG: 55.8973083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014800',
        LOCATION_NAME: 'Torphins',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6214978,
        LOCATION_LATITUDE_DEG: 57.105316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO014900',
        LOCATION_NAME: 'Torpoint',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2060338,
        LOCATION_LATITUDE_DEG: 50.375489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015000',
        LOCATION_NAME: 'Torquay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5287824,
        LOCATION_LATITUDE_DEG: 50.4663826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015100',
        LOCATION_NAME: 'Torr',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.065598,
        LOCATION_LATITUDE_DEG: 55.1832591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015200',
        LOCATION_NAME: 'Torrance',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2098076,
        LOCATION_LATITUDE_DEG: 55.9406208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015300',
        LOCATION_NAME: 'Torranyard',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6243158,
        LOCATION_LATITUDE_DEG: 55.6613973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015400',
        LOCATION_NAME: 'Torridon',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5155175,
        LOCATION_LATITUDE_DEG: 57.5498965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015500',
        LOCATION_NAME: 'Torrin',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0098968,
        LOCATION_LATITUDE_DEG: 57.2134652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015600',
        LOCATION_NAME: 'Torrington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1398307,
        LOCATION_LATITUDE_DEG: 50.9530374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015750',
        LOCATION_NAME: 'Torrisdale',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4947171,
        LOCATION_LATITUDE_DEG: 55.5717949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015700',
        LOCATION_NAME: 'Torrisdale',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2728788,
        LOCATION_LATITUDE_DEG: 58.5221812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015800',
        LOCATION_NAME: 'Torrisholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8287198,
        LOCATION_LATITUDE_DEG: 54.0663249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO015900',
        LOCATION_NAME: 'Torry',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9427114,
        LOCATION_LATITUDE_DEG: 57.4468581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016000',
        LOCATION_NAME: 'Torryburn',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5685523,
        LOCATION_LATITUDE_DEG: 56.0582268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016100',
        LOCATION_NAME: 'Torside',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9051204,
        LOCATION_LATITUDE_DEG: 53.4796579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016200',
        LOCATION_NAME: 'Torteval',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6376856,
        LOCATION_LATITUDE_DEG: 49.4284417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016300',
        LOCATION_NAME: 'Torthorwald',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5142099,
        LOCATION_LATITUDE_DEG: 55.0894326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016400',
        LOCATION_NAME: 'Tortington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5724751,
        LOCATION_LATITUDE_DEG: 50.8363835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016500',
        LOCATION_NAME: 'Torton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2264072,
        LOCATION_LATITUDE_DEG: 52.3499494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016600',
        LOCATION_NAME: 'Tortworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4277912,
        LOCATION_LATITUDE_DEG: 51.6356848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016700',
        LOCATION_NAME: 'Torvaig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.172877,
        LOCATION_LATITUDE_DEG: 57.4226944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016800',
        LOCATION_NAME: 'Torver',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1015217,
        LOCATION_LATITUDE_DEG: 54.3378581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO016900',
        LOCATION_NAME: 'Torwood',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8590309,
        LOCATION_LATITUDE_DEG: 56.0440276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017000',
        LOCATION_NAME: 'Torwoodlee',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8368108,
        LOCATION_LATITUDE_DEG: 55.6335735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017100',
        LOCATION_NAME: 'Torworth',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0128413,
        LOCATION_LATITUDE_DEG: 53.3749309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO024600',
        LOCATION_NAME: 'Toryglen',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2340646,
        LOCATION_LATITUDE_DEG: 55.8278006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017200',
        LOCATION_NAME: 'Toseland',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1859954,
        LOCATION_LATITUDE_DEG: 52.2469185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017300',
        LOCATION_NAME: 'Tosside',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3528036,
        LOCATION_LATITUDE_DEG: 53.9997096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017400',
        LOCATION_NAME: 'Tostock',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8607534,
        LOCATION_LATITUDE_DEG: 52.2370998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017500',
        LOCATION_NAME: 'Totaig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6698796,
        LOCATION_LATITUDE_DEG: 57.4591994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017600',
        LOCATION_NAME: 'Totarder',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3528555,
        LOCATION_LATITUDE_DEG: 57.3667831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017700',
        LOCATION_NAME: 'Tote',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2960289,
        LOCATION_LATITUDE_DEG: 57.4574945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017800',
        LOCATION_NAME: 'Tothill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1261828,
        LOCATION_LATITUDE_DEG: 53.3172112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO017900',
        LOCATION_NAME: 'Totland',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5372041,
        LOCATION_LATITUDE_DEG: 50.6826798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018000',
        LOCATION_NAME: 'Totland Bay',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5448598,
        LOCATION_LATITUDE_DEG: 50.6785818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018100',
        LOCATION_NAME: 'Totley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.539946,
        LOCATION_LATITUDE_DEG: 53.3138401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018200',
        LOCATION_NAME: 'Totnes',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6820235,
        LOCATION_LATITUDE_DEG: 50.4301868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018300',
        LOCATION_NAME: 'Toton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2522782,
        LOCATION_LATITUDE_DEG: 52.9064914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO024100',
        LOCATION_NAME: 'Tottenham',
        COUNTY_NAME: 'London',
        POSTCODE: 'N17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0715026,
        LOCATION_LATITUDE_DEG: 51.597125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018400',
        LOCATION_NAME: 'Tottenhill',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4278675,
        LOCATION_LATITUDE_DEG: 52.6694433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018500',
        LOCATION_NAME: 'Totterdown',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5773383,
        LOCATION_LATITUDE_DEG: 51.4402661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018600',
        LOCATION_NAME: 'Totterdown',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.780062,
        LOCATION_LATITUDE_DEG: 51.6913807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018700',
        LOCATION_NAME: 'Totteridge',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7221019,
        LOCATION_LATITUDE_DEG: 51.6349599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO024200',
        LOCATION_NAME: 'Totteridge',
        COUNTY_NAME: 'London',
        POSTCODE: 'N20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1979208,
        LOCATION_LATITUDE_DEG: 51.6312316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018800',
        LOCATION_NAME: 'Totternhoe',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5697962,
        LOCATION_LATITUDE_DEG: 51.8839846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO018900',
        LOCATION_NAME: 'Totterton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9377464,
        LOCATION_LATITUDE_DEG: 52.4821708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019000',
        LOCATION_NAME: 'Tottington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.336324,
        LOCATION_LATITUDE_DEG: 53.6104771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019100',
        LOCATION_NAME: 'Totton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4879347,
        LOCATION_LATITUDE_DEG: 50.9182065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019200',
        LOCATION_NAME: 'Toulvaddie',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8691527,
        LOCATION_LATITUDE_DEG: 57.8020074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019500',
        LOCATION_NAME: 'Tovil',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5133059,
        LOCATION_LATITUDE_DEG: 51.2611093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019600',
        LOCATION_NAME: 'Tow House',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3575319,
        LOCATION_LATITUDE_DEG: 54.9728038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019700',
        LOCATION_NAME: 'Tow Law',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8135841,
        LOCATION_LATITUDE_DEG: 54.7486802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019800',
        LOCATION_NAME: 'Towan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9995659,
        LOCATION_LATITUDE_DEG: 50.5277075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019900',
        LOCATION_NAME: 'Toward',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9805955,
        LOCATION_LATITUDE_DEG: 55.8655234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020000',
        LOCATION_NAME: 'Towcester',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9868877,
        LOCATION_LATITUDE_DEG: 52.1316133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020100',
        LOCATION_NAME: 'Towcett',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6589409,
        LOCATION_LATITUDE_DEG: 54.5600665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020200',
        LOCATION_NAME: 'Towednack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5198101,
        LOCATION_LATITUDE_DEG: 50.1904793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020400',
        LOCATION_NAME: 'Tower Cross',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1567226,
        LOCATION_LATITUDE_DEG: 50.7990177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020500',
        LOCATION_NAME: 'Tower Hill',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8907787,
        LOCATION_LATITUDE_DEG: 53.4936722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020600',
        LOCATION_NAME: 'Towersey',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9350577,
        LOCATION_LATITUDE_DEG: 51.7403732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020700',
        LOCATION_NAME: 'Town Centre',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.444693,
        LOCATION_LATITUDE_DEG: 52.6766839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020800',
        LOCATION_NAME: 'Town End',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0884458,
        LOCATION_LATITUDE_DEG: 52.5355418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020900',
        LOCATION_NAME: 'Town Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9032473,
        LOCATION_LATITUDE_DEG: 53.5433729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021000',
        LOCATION_NAME: 'Town Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5512616,
        LOCATION_LATITUDE_DEG: 50.7252045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO990339',
        LOCATION_NAME: 'Town Littleworth',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0069512,
        LOCATION_LATITUDE_DEG: 50.9377141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021100',
        LOCATION_NAME: 'Town Moor',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6236333,
        LOCATION_LATITUDE_DEG: 54.9886995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021200',
        LOCATION_NAME: 'Town Row',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2358392,
        LOCATION_LATITUDE_DEG: 51.0487946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021300',
        LOCATION_NAME: 'Town Yetholm',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2850566,
        LOCATION_LATITUDE_DEG: 55.5469599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021400',
        LOCATION_NAME: 'Townend',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0481805,
        LOCATION_LATITUDE_DEG: 54.834409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021500',
        LOCATION_NAME: 'Townfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0762846,
        LOCATION_LATITUDE_DEG: 54.8295884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO024400',
        LOCATION_NAME: 'Townhead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2432044,
        LOCATION_LATITUDE_DEG: 55.8667163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021700',
        LOCATION_NAME: 'Townhead',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0320909,
        LOCATION_LATITUDE_DEG: 54.7953059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021600',
        LOCATION_NAME: 'Townhead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.754686,
        LOCATION_LATITUDE_DEG: 54.9125058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021800',
        LOCATION_NAME: 'Townhead of Greenlaw',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9654403,
        LOCATION_LATITUDE_DEG: 54.9628208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO021900',
        LOCATION_NAME: 'Townhill',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9743237,
        LOCATION_LATITUDE_DEG: 51.6239012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022000',
        LOCATION_NAME: 'Townhill',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4378015,
        LOCATION_LATITUDE_DEG: 56.0886308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022100',
        LOCATION_NAME: 'Townlake',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2520278,
        LOCATION_LATITUDE_DEG: 50.5509984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022200',
        LOCATION_NAME: 'Townsend',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8851879,
        LOCATION_LATITUDE_DEG: 50.9264246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022300',
        LOCATION_NAME: 'Townsend',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8218659,
        LOCATION_LATITUDE_DEG: 51.2866557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022400',
        LOCATION_NAME: 'Townsend Fold',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2881679,
        LOCATION_LATITUDE_DEG: 53.693286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022500',
        LOCATION_NAME: 'Townshend',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3706479,
        LOCATION_LATITUDE_DEG: 50.1460703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022700',
        LOCATION_NAME: 'Towthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0422745,
        LOCATION_LATITUDE_DEG: 54.023595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022600',
        LOCATION_NAME: 'Towthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6240158,
        LOCATION_LATITUDE_DEG: 54.053992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022800',
        LOCATION_NAME: 'Towton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2623425,
        LOCATION_LATITUDE_DEG: 53.8505885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO022900',
        LOCATION_NAME: 'Towyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5388168,
        LOCATION_LATITUDE_DEG: 53.3020594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023000',
        LOCATION_NAME: 'Toxteth',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9720584,
        LOCATION_LATITUDE_DEG: 53.3891602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO024000',
        LOCATION_NAME: 'Toxteth Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023900',
        LOCATION_NAME: 'Toxteth Park',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9406388,
        LOCATION_LATITUDE_DEG: 53.3971522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023100',
        LOCATION_NAME: 'Toye',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7247765,
        LOCATION_LATITUDE_DEG: 54.3944851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023200',
        LOCATION_NAME: 'Toynton All Saints',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.082193,
        LOCATION_LATITUDE_DEG: 53.1537029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023500',
        LOCATION_NAME: 'Toynton St Peter',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023300',
        LOCATION_NAME: 'Toynton St. Peter',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1017293,
        LOCATION_LATITUDE_DEG: 53.147596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO023400',
        LOCATION_NAME: 'Toys Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1058647,
        LOCATION_LATITUDE_DEG: 51.241512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000100',
        LOCATION_NAME: 'Trabboch',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4699324,
        LOCATION_LATITUDE_DEG: 55.465281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000400',
        LOCATION_NAME: 'Tradespark',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8927027,
        LOCATION_LATITUDE_DEG: 57.5810663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000500',
        LOCATION_NAME: 'Tradeston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2319679,
        LOCATION_LATITUDE_DEG: 55.8500133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000600',
        LOCATION_NAME: 'Traeth Bychan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2318267,
        LOCATION_LATITUDE_DEG: 53.3386682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000700',
        LOCATION_NAME: 'Trafalgar',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5428252,
        LOCATION_LATITUDE_DEG: 51.827005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036800',
        LOCATION_NAME: 'Trafford Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3092825,
        LOCATION_LATITUDE_DEG: 53.4699103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000900',
        LOCATION_NAME: 'Trallong',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5044096,
        LOCATION_LATITUDE_DEG: 51.9551258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001000',
        LOCATION_NAME: 'Tram Inn',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7815209,
        LOCATION_LATITUDE_DEG: 51.9977245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001300',
        LOCATION_NAME: 'Tranch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0496396,
        LOCATION_LATITUDE_DEG: 51.700701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001400',
        LOCATION_NAME: 'Tranch Pyle',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6608503,
        LOCATION_LATITUDE_DEG: 51.5215915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001500',
        LOCATION_NAME: 'Tranent',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9429316,
        LOCATION_LATITUDE_DEG: 55.9426136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001700',
        LOCATION_NAME: 'Tranmire',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8082049,
        LOCATION_LATITUDE_DEG: 54.4868422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001800',
        LOCATION_NAME: 'Trannack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2731314,
        LOCATION_LATITUDE_DEG: 50.1235713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001900',
        LOCATION_NAME: 'Transy',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4404867,
        LOCATION_LATITUDE_DEG: 56.0714259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002000',
        LOCATION_NAME: 'Tranwell',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7037093,
        LOCATION_LATITUDE_DEG: 55.1450189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002100',
        LOCATION_NAME: 'Tranwell Woods',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7087299,
        LOCATION_LATITUDE_DEG: 55.1343184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002200',
        LOCATION_NAME: 'Trapp',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9560019,
        LOCATION_LATITUDE_DEG: 51.8526212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002300',
        LOCATION_NAME: 'Traquair',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0624038,
        LOCATION_LATITUDE_DEG: 55.6009755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002400',
        LOCATION_NAME: 'Travebank',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7648842,
        LOCATION_LATITUDE_DEG: 56.5115653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002500',
        LOCATION_NAME: 'Trawden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1351284,
        LOCATION_LATITUDE_DEG: 53.8431974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002600',
        LOCATION_NAME: 'Trawsfynydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9188586,
        LOCATION_LATITUDE_DEG: 52.9039283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002700',
        LOCATION_NAME: 'Trawsmawr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.360862,
        LOCATION_LATITUDE_DEG: 51.8916334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036400',
        LOCATION_NAME: 'Tre Mostyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036300',
        LOCATION_NAME: 'Tre r ddol',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002800',
        LOCATION_NAME: 'Tre Taliesin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9776771,
        LOCATION_LATITUDE_DEG: 52.503283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036500',
        LOCATION_NAME: 'Tre War Nevas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0931972,
        LOCATION_LATITUDE_DEG: 50.0874373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003200',
        LOCATION_NAME: 'Trealaw',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4401017,
        LOCATION_LATITUDE_DEG: 51.6184958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003300',
        LOCATION_NAME: 'Treales',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8467541,
        LOCATION_LATITUDE_DEG: 53.7894963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003500',
        LOCATION_NAME: 'Trearddur Bay',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6162545,
        LOCATION_LATITUDE_DEG: 53.2811713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003600',
        LOCATION_NAME: 'Treaslane',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3531729,
        LOCATION_LATITUDE_DEG: 57.4940999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003700',
        LOCATION_NAME: 'Treator',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9557886,
        LOCATION_LATITUDE_DEG: 50.5379052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003800',
        LOCATION_NAME: 'Trebanog',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4225259,
        LOCATION_LATITUDE_DEG: 51.6001936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003900',
        LOCATION_NAME: 'Trebanos',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8667542,
        LOCATION_LATITUDE_DEG: 51.7070061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004000',
        LOCATION_NAME: 'Trebarber',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0071059,
        LOCATION_LATITUDE_DEG: 50.4222995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004100',
        LOCATION_NAME: 'Trebartha',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4522498,
        LOCATION_LATITUDE_DEG: 50.5684066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004200',
        LOCATION_NAME: 'Trebarvah Woon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2018323,
        LOCATION_LATITUDE_DEG: 50.1246704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004300',
        LOCATION_NAME: 'Trebarwith',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7492493,
        LOCATION_LATITUDE_DEG: 50.6406193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004400',
        LOCATION_NAME: 'Trebarwith Strand',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7586711,
        LOCATION_LATITUDE_DEG: 50.643518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004500',
        LOCATION_NAME: 'Trebencyn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9885767,
        LOCATION_LATITUDE_DEG: 51.835811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004600',
        LOCATION_NAME: 'Treberfedd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2667437,
        LOCATION_LATITUDE_DEG: 51.9218186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004700',
        LOCATION_NAME: 'Trebetherick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9180437,
        LOCATION_LATITUDE_DEG: 50.564911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004800',
        LOCATION_NAME: 'Trebles Holford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.214517,
        LOCATION_LATITUDE_DEG: 51.1007378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR004900',
        LOCATION_NAME: 'Treboeth',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9466658,
        LOCATION_LATITUDE_DEG: 51.6505072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005000',
        LOCATION_NAME: 'Treborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4120894,
        LOCATION_LATITUDE_DEG: 51.1173512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005100',
        LOCATION_NAME: 'Trebudannon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9638528,
        LOCATION_LATITUDE_DEG: 50.4151965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005200',
        LOCATION_NAME: 'Trebullett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3666405,
        LOCATION_LATITUDE_DEG: 50.5802084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005300',
        LOCATION_NAME: 'Treburgett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7472168,
        LOCATION_LATITUDE_DEG: 50.5815103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005400',
        LOCATION_NAME: 'Treburgie Water',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5266981,
        LOCATION_LATITUDE_DEG: 50.450293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005500',
        LOCATION_NAME: 'Treburley',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3317508,
        LOCATION_LATITUDE_DEG: 50.5746067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005600',
        LOCATION_NAME: 'Treburrick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0124067,
        LOCATION_LATITUDE_DEG: 50.4951056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005700',
        LOCATION_NAME: 'Trebursye',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3905363,
        LOCATION_LATITUDE_DEG: 50.629114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR990166',
        LOCATION_NAME: 'Trebyan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7057597,
        LOCATION_LATITUDE_DEG: 50.4371699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005800',
        LOCATION_NAME: 'Trecarne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4635514,
        LOCATION_LATITUDE_DEG: 50.4917954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR005900',
        LOCATION_NAME: 'Trecastle',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6295843,
        LOCATION_LATITUDE_DEG: 51.9496288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006000',
        LOCATION_NAME: 'Trecombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3007301,
        LOCATION_LATITUDE_DEG: 50.5662016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006100',
        LOCATION_NAME: 'Trecwn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9586787,
        LOCATION_LATITUDE_DEG: 51.9548461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006200',
        LOCATION_NAME: 'Trecynon',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4573224,
        LOCATION_LATITUDE_DEG: 51.7208025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006300',
        LOCATION_NAME: 'Tredarvah',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5459606,
        LOCATION_LATITUDE_DEG: 50.1155693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006400',
        LOCATION_NAME: 'Tredavoe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5595276,
        LOCATION_LATITUDE_DEG: 50.1024759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006500',
        LOCATION_NAME: 'Tredegar',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2463604,
        LOCATION_LATITUDE_DEG: 51.7712054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006600',
        LOCATION_NAME: 'Tredethy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7351293,
        LOCATION_LATITUDE_DEG: 50.5131019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006800',
        LOCATION_NAME: 'Tredington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1380336,
        LOCATION_LATITUDE_DEG: 51.9629113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006700',
        LOCATION_NAME: 'Tredington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6240682,
        LOCATION_LATITUDE_DEG: 52.0893197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR006900',
        LOCATION_NAME: 'Tredinnick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9233174,
        LOCATION_LATITUDE_DEG: 50.4947069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR990354',
        LOCATION_NAME: 'Tredinnick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.480924,
        LOCATION_LATITUDE_DEG: 50.3894506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007000',
        LOCATION_NAME: 'Tredinnick Pits',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7038703,
        LOCATION_LATITUDE_DEG: 50.4279929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007100',
        LOCATION_NAME: 'Tredodridge',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3634128,
        LOCATION_LATITUDE_DEG: 51.4826819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007200',
        LOCATION_NAME: 'Tredogan',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3360585,
        LOCATION_LATITUDE_DEG: 51.3992706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007300',
        LOCATION_NAME: 'Tredomen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2791788,
        LOCATION_LATITUDE_DEG: 51.9755303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007400',
        LOCATION_NAME: 'Tredrizzick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8867925,
        LOCATION_LATITUDE_DEG: 50.5553089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007500',
        LOCATION_NAME: 'Tredunnock',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8968888,
        LOCATION_LATITUDE_DEG: 51.6480924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007600',
        LOCATION_NAME: 'Tredustan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2531404,
        LOCATION_LATITUDE_DEG: 51.9832289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007700',
        LOCATION_NAME: 'Treesmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6862673,
        LOCATION_LATITUDE_DEG: 50.3662921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007800',
        LOCATION_NAME: 'Treeton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3505237,
        LOCATION_LATITUDE_DEG: 53.3854444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR007900',
        LOCATION_NAME: 'Tref Ar Clawdd',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.089929,
        LOCATION_LATITUDE_DEG: 52.842608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008000',
        LOCATION_NAME: 'Trefasser',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0660548,
        LOCATION_LATITUDE_DEG: 51.9995446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008100',
        LOCATION_NAME: 'Trefdraeth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3863316,
        LOCATION_LATITUDE_DEG: 53.2054545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008200',
        LOCATION_NAME: 'Trefecca',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2437851,
        LOCATION_LATITUDE_DEG: 51.9803966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008300',
        LOCATION_NAME: 'Trefechan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0875467,
        LOCATION_LATITUDE_DEG: 52.4098777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008400',
        LOCATION_NAME: 'Trefechan',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3972046,
        LOCATION_LATITUDE_DEG: 51.7696081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008500',
        LOCATION_NAME: 'Trefeglwys',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5162681,
        LOCATION_LATITUDE_DEG: 52.5046832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008600',
        LOCATION_NAME: 'Trefeinon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2585905,
        LOCATION_LATITUDE_DEG: 51.9615263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008700',
        LOCATION_NAME: 'Trefeitha',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3022254,
        LOCATION_LATITUDE_DEG: 51.9779304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008800',
        LOCATION_NAME: 'Trefenter',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0432087,
        LOCATION_LATITUDE_DEG: 52.2977678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR008900',
        LOCATION_NAME: 'Treffgarne',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9685901,
        LOCATION_LATITUDE_DEG: 51.8739315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009000',
        LOCATION_NAME: 'Treffynnon',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1267435,
        LOCATION_LATITUDE_DEG: 51.914339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036600',
        LOCATION_NAME: 'Trefgarn Owen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009100',
        LOCATION_NAME: 'Trefgarn-Owen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0980316,
        LOCATION_LATITUDE_DEG: 51.8877361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009200',
        LOCATION_NAME: 'Trefil',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2760251,
        LOCATION_LATITUDE_DEG: 51.8059132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009300',
        LOCATION_NAME: 'Trefin',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1449251,
        LOCATION_LATITUDE_DEG: 51.9486472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009400',
        LOCATION_NAME: 'Treflach',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0992783,
        LOCATION_LATITUDE_DEG: 52.8218067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009500',
        LOCATION_NAME: 'Treflys',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1781604,
        LOCATION_LATITUDE_DEG: 52.9219266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009800',
        LOCATION_NAME: 'Trefnant',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.420612,
        LOCATION_LATITUDE_DEG: 53.2243458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009600',
        LOCATION_NAME: 'Trefnant',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2101687,
        LOCATION_LATITUDE_DEG: 52.6754941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009700',
        LOCATION_NAME: 'Trefnant',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0313443,
        LOCATION_LATITUDE_DEG: 52.684297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR009900',
        LOCATION_NAME: 'Trefonen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0984452,
        LOCATION_LATITUDE_DEG: 52.8329092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010050',
        LOCATION_NAME: 'Trefor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4376204,
        LOCATION_LATITUDE_DEG: 53.2917835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010000',
        LOCATION_NAME: 'Trefor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4228401,
        LOCATION_LATITUDE_DEG: 52.9919414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010100',
        LOCATION_NAME: 'Treforest',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3239348,
        LOCATION_LATITUDE_DEG: 51.5885951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010200',
        LOCATION_NAME: 'Trefrew',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6743654,
        LOCATION_LATITUDE_DEG: 50.6293103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010300',
        LOCATION_NAME: 'Trefriw',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.823211,
        LOCATION_LATITUDE_DEG: 53.1515486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010400',
        LOCATION_NAME: 'Trefula',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1994263,
        LOCATION_LATITUDE_DEG: 50.2363814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010500',
        LOCATION_NAME: 'Tregada',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3367283,
        LOCATION_LATITUDE_DEG: 50.6078077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010600',
        LOCATION_NAME: 'Tregadillett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4067153,
        LOCATION_LATITUDE_DEG: 50.6280071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010700',
        LOCATION_NAME: 'Tregaian',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3239286,
        LOCATION_LATITUDE_DEG: 53.2904663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010800',
        LOCATION_NAME: 'Tregamere',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9234403,
        LOCATION_LATITUDE_DEG: 50.4427951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR010900',
        LOCATION_NAME: 'Tregare',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8455241,
        LOCATION_LATITUDE_DEG: 51.7883052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011000',
        LOCATION_NAME: 'Tregarland Bridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4639496,
        LOCATION_LATITUDE_DEG: 50.39099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011100',
        LOCATION_NAME: 'Tregaron',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9330865,
        LOCATION_LATITUDE_DEG: 52.2196597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011200',
        LOCATION_NAME: 'Tregarth',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0885862,
        LOCATION_LATITUDE_DEG: 53.1895575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011300',
        LOCATION_NAME: 'Tregaswith',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9630173,
        LOCATION_LATITUDE_DEG: 50.4281997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011400',
        LOCATION_NAME: 'Tregatillian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9252274,
        LOCATION_LATITUDE_DEG: 50.4302002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011500',
        LOCATION_NAME: 'Tregatta',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7492667,
        LOCATION_LATITUDE_DEG: 50.6518187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011600',
        LOCATION_NAME: 'Tregavarah',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5717691,
        LOCATION_LATITUDE_DEG: 50.112069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011700',
        LOCATION_NAME: 'Tregavethan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1022132,
        LOCATION_LATITUDE_DEG: 50.2831851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011800',
        LOCATION_NAME: 'Tregeare',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.485664,
        LOCATION_LATITUDE_DEG: 50.6525166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR011900',
        LOCATION_NAME: 'Tregeiriog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2227063,
        LOCATION_LATITUDE_DEG: 52.8953145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012000',
        LOCATION_NAME: 'Tregele',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4730678,
        LOCATION_LATITUDE_DEG: 53.4051811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012100',
        LOCATION_NAME: 'Tregellist',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8104785,
        LOCATION_LATITUDE_DEG: 50.5631054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012200',
        LOCATION_NAME: 'Tregenna',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6914642,
        LOCATION_LATITUDE_DEG: 50.5317073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012300',
        LOCATION_NAME: 'Treglasta',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5726804,
        LOCATION_LATITUDE_DEG: 50.6462102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012400',
        LOCATION_NAME: 'Tregonetha',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8794769,
        LOCATION_LATITUDE_DEG: 50.4387013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012500',
        LOCATION_NAME: 'Tregonhawke',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2370261,
        LOCATION_LATITUDE_DEG: 50.3393824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012600',
        LOCATION_NAME: 'Tregony',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9126158,
        LOCATION_LATITUDE_DEG: 50.2665838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012700',
        LOCATION_NAME: 'Tregoodwell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6714594,
        LOCATION_LATITUDE_DEG: 50.6197156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012800',
        LOCATION_NAME: 'Tregoose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9898941,
        LOCATION_LATITUDE_DEG: 50.4074944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR012900',
        LOCATION_NAME: 'Tregorrick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7896746,
        LOCATION_LATITUDE_DEG: 50.3262877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013000',
        LOCATION_NAME: 'Tregoss',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8614831,
        LOCATION_LATITUDE_DEG: 50.4133982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013100',
        LOCATION_NAME: 'Tregoyd',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1699935,
        LOCATION_LATITUDE_DEG: 52.031635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013200',
        LOCATION_NAME: 'Tregrehan Mills',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7508471,
        LOCATION_LATITUDE_DEG: 50.3503877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013300',
        LOCATION_NAME: 'Tregroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4943966,
        LOCATION_LATITUDE_DEG: 51.5200712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013400',
        LOCATION_NAME: 'Tregullon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7274792,
        LOCATION_LATITUDE_DEG: 50.4471968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013500',
        LOCATION_NAME: 'Tregurrian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0275278,
        LOCATION_LATITUDE_DEG: 50.4474995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013600',
        LOCATION_NAME: 'Tregynon',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3311775,
        LOCATION_LATITUDE_DEG: 52.5787887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013700',
        LOCATION_NAME: 'Tregynwr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.295498,
        LOCATION_LATITUDE_DEG: 51.8486245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013800',
        LOCATION_NAME: 'Trehafod',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3782537,
        LOCATION_LATITUDE_DEG: 51.6083928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR013900',
        LOCATION_NAME: 'Trehan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2457335,
        LOCATION_LATITUDE_DEG: 50.4002852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014000',
        LOCATION_NAME: 'Treharris',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3061439,
        LOCATION_LATITUDE_DEG: 51.6643973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014100',
        LOCATION_NAME: 'Trehelig',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1530307,
        LOCATION_LATITUDE_DEG: 52.6194909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014200',
        LOCATION_NAME: 'Treherbert',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5357983,
        LOCATION_LATITUDE_DEG: 51.6746043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014300',
        LOCATION_NAME: 'Trehunist',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3681458,
        LOCATION_LATITUDE_DEG: 50.4447956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014400',
        LOCATION_NAME: 'Treisaac',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9995015,
        LOCATION_LATITUDE_DEG: 50.4251949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014500',
        LOCATION_NAME: 'Trekenner',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3391374,
        LOCATION_LATITUDE_DEG: 50.5780027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014600',
        LOCATION_NAME: 'Trekenning',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9462847,
        LOCATION_LATITUDE_DEG: 50.4240998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014700',
        LOCATION_NAME: 'Treknow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7497073,
        LOCATION_LATITUDE_DEG: 50.6482189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014800',
        LOCATION_NAME: 'Trelander',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0343088,
        LOCATION_LATITUDE_DEG: 50.2641787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR014900',
        LOCATION_NAME: 'Trelavour Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8724369,
        LOCATION_LATITUDE_DEG: 50.3791939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015000',
        LOCATION_NAME: 'Trelawne',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5250624,
        LOCATION_LATITUDE_DEG: 50.3668833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015100',
        LOCATION_NAME: 'Trelawnyd',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3645335,
        LOCATION_LATITUDE_DEG: 53.3066531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015200',
        LOCATION_NAME: 'Trelech',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4997495,
        LOCATION_LATITUDE_DEG: 51.9444359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015300',
        LOCATION_NAME: 'Treleigh',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2186224,
        LOCATION_LATITUDE_DEG: 50.2468811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015400',
        LOCATION_NAME: 'Treleigh Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2184198,
        LOCATION_LATITUDE_DEG: 50.2465808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015500',
        LOCATION_NAME: 'Treleigh Wood',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.218532,
        LOCATION_LATITUDE_DEG: 50.2492858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015600',
        LOCATION_NAME: 'Trelerw',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.234986,
        LOCATION_LATITUDE_DEG: 51.8762393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015700',
        LOCATION_NAME: 'Trelewis',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2928428,
        LOCATION_LATITUDE_DEG: 51.6644995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015800',
        LOCATION_NAME: 'Treliever',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1277131,
        LOCATION_LATITUDE_DEG: 50.1698779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR015900',
        LOCATION_NAME: 'Treligga',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7559348,
        LOCATION_LATITUDE_DEG: 50.6260139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016000',
        LOCATION_NAME: 'Treligga Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7418784,
        LOCATION_LATITUDE_DEG: 50.621416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016100',
        LOCATION_NAME: 'Trelights',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.839479,
        LOCATION_LATITUDE_DEG: 50.5775058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016200',
        LOCATION_NAME: 'Trelill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7623703,
        LOCATION_LATITUDE_DEG: 50.5698078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016300',
        LOCATION_NAME: 'Treliske',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0843193,
        LOCATION_LATITUDE_DEG: 50.2637788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016400',
        LOCATION_NAME: 'Trelleck',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7229581,
        LOCATION_LATITUDE_DEG: 51.745798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016500',
        LOCATION_NAME: 'Trelleck Grange',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7354582,
        LOCATION_LATITUDE_DEG: 51.7117924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016600',
        LOCATION_NAME: 'Trelogan',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3210456,
        LOCATION_LATITUDE_DEG: 53.3123572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016700',
        LOCATION_NAME: 'Trelowth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8268139,
        LOCATION_LATITUDE_DEG: 50.3226821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016800',
        LOCATION_NAME: 'Trelydan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1400353,
        LOCATION_LATITUDE_DEG: 52.6878959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR016900',
        LOCATION_NAME: 'Trelystan',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0920183,
        LOCATION_LATITUDE_DEG: 52.627289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017000',
        LOCATION_NAME: 'Tremadog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1392939,
        LOCATION_LATITUDE_DEG: 52.9378295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017100',
        LOCATION_NAME: 'Tremail',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5991033,
        LOCATION_LATITUDE_DEG: 50.6484121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017200',
        LOCATION_NAME: 'Tremain',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5793217,
        LOCATION_LATITUDE_DEG: 52.1084583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017300',
        LOCATION_NAME: 'Tremaine',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4957592,
        LOCATION_LATITUDE_DEG: 50.6721177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017400',
        LOCATION_NAME: 'Tremar',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4556774,
        LOCATION_LATITUDE_DEG: 50.4867983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017500',
        LOCATION_NAME: 'Tremar Coombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.456451,
        LOCATION_LATITUDE_DEG: 50.4921974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017600',
        LOCATION_NAME: 'Trematon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.261319,
        LOCATION_LATITUDE_DEG: 50.4145919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017700',
        LOCATION_NAME: 'Tremeirchion',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3760388,
        LOCATION_LATITUDE_DEG: 53.2452505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017800',
        LOCATION_NAME: 'Tremethick Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5776024,
        LOCATION_LATITUDE_DEG: 50.1191773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR017900',
        LOCATION_NAME: 'Tremore Valley',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7989319,
        LOCATION_LATITUDE_DEG: 50.4489985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018000',
        LOCATION_NAME: 'Tremorfa',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1448005,
        LOCATION_LATITUDE_DEG: 51.4786798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003000',
        LOCATION_NAME: 'Tre-Mostyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2893668,
        LOCATION_LATITUDE_DEG: 53.3082536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018100',
        LOCATION_NAME: 'Tremough',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1235142,
        LOCATION_LATITUDE_DEG: 50.1690733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018200',
        LOCATION_NAME: 'Trenale',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.729865,
        LOCATION_LATITUDE_DEG: 50.6586171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018300',
        LOCATION_NAME: 'Trenance',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.921097,
        LOCATION_LATITUDE_DEG: 50.5010061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018400',
        LOCATION_NAME: 'Trenance Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8070095,
        LOCATION_LATITUDE_DEG: 50.3523913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018500',
        LOCATION_NAME: 'Trenarren',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7622493,
        LOCATION_LATITUDE_DEG: 50.3062875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018600',
        LOCATION_NAME: 'Trench',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4569183,
        LOCATION_LATITUDE_DEG: 52.7127892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018700',
        LOCATION_NAME: 'Trencreek',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0554114,
        LOCATION_LATITUDE_DEG: 50.4063935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018800',
        LOCATION_NAME: 'Trenear',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2452652,
        LOCATION_LATITUDE_DEG: 50.1369683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR018900',
        LOCATION_NAME: 'Treneglos',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5363511,
        LOCATION_LATITUDE_DEG: 50.6641165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019000',
        LOCATION_NAME: 'Trenewan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5668059,
        LOCATION_LATITUDE_DEG: 50.3509817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019100',
        LOCATION_NAME: 'Trenholme Bar',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3109168,
        LOCATION_LATITUDE_DEG: 54.4232422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019200',
        LOCATION_NAME: 'Treninnick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0699131,
        LOCATION_LATITUDE_DEG: 50.4035913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019300',
        LOCATION_NAME: 'Treninnow Cliff',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2292252,
        LOCATION_LATITUDE_DEG: 50.338183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019400',
        LOCATION_NAME: 'Trenoweth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3164411,
        LOCATION_LATITUDE_DEG: 50.1835767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019500',
        LOCATION_NAME: 'Trent',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5827382,
        LOCATION_LATITUDE_DEG: 50.9652258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019600',
        LOCATION_NAME: 'Trent Vale',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1985544,
        LOCATION_LATITUDE_DEG: 52.9830104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019700',
        LOCATION_NAME: 'Trentham',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1855935,
        LOCATION_LATITUDE_DEG: 52.9654104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019800',
        LOCATION_NAME: 'Treoes',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5229507,
        LOCATION_LATITUDE_DEG: 51.494487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR019900',
        LOCATION_NAME: 'Treorchy',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5045107,
        LOCATION_LATITUDE_DEG: 51.6592986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020100',
        LOCATION_NAME: 'Treowen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3043774,
        LOCATION_LATITUDE_DEG: 52.5107785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020200',
        LOCATION_NAME: 'Trequite',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.783262,
        LOCATION_LATITUDE_DEG: 50.5583079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020300',
        LOCATION_NAME: 'Treragin',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2523366,
        LOCATION_LATITUDE_DEG: 50.499701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR002900',
        LOCATION_NAME: "Tre'r-ddol",
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9765556,
        LOCATION_LATITUDE_DEG: 52.5094885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020400',
        LOCATION_NAME: 'Trerhyngyll',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4250844,
        LOCATION_LATITUDE_DEG: 51.4797813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020500',
        LOCATION_NAME: 'Trerice',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9105756,
        LOCATION_LATITUDE_DEG: 50.3786949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020600',
        LOCATION_NAME: 'Trerulefoot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.34743,
        LOCATION_LATITUDE_DEG: 50.4047894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020700',
        LOCATION_NAME: 'Tresaddern',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1811182,
        LOCATION_LATITUDE_DEG: 50.2350851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020800',
        LOCATION_NAME: 'Tresaith',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5137174,
        LOCATION_LATITUDE_DEG: 52.13406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR020900',
        LOCATION_NAME: 'Tresarrett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.696474,
        LOCATION_LATITUDE_DEG: 50.5260048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021000',
        LOCATION_NAME: 'Tresco',
        COUNTY_NAME: 'Isles of Scilly',
        POSTCODE: 'TR24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.333433,
        LOCATION_LATITUDE_DEG: 49.9541602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021100',
        LOCATION_NAME: 'Trescott',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.225049,
        LOCATION_LATITUDE_DEG: 52.5707723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021200',
        LOCATION_NAME: 'Tresham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2999915,
        LOCATION_LATITUDE_DEG: 51.6188785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021400',
        LOCATION_NAME: 'Tresillian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0169649,
        LOCATION_LATITUDE_DEG: 50.385995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021300',
        LOCATION_NAME: 'Tresillian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9940717,
        LOCATION_LATITUDE_DEG: 50.2780793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021500',
        LOCATION_NAME: 'Treskerby',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.202824,
        LOCATION_LATITUDE_DEG: 50.2445829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021600',
        LOCATION_NAME: 'Treskillard',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2619247,
        LOCATION_LATITUDE_DEG: 50.206877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021700',
        LOCATION_NAME: 'Treskilling',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.759181,
        LOCATION_LATITUDE_DEG: 50.3861928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021800',
        LOCATION_NAME: 'Treslothan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2918383,
        LOCATION_LATITUDE_DEG: 50.1923747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR021900',
        LOCATION_NAME: 'Tresmeer',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4993451,
        LOCATION_LATITUDE_DEG: 50.6602118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022000',
        LOCATION_NAME: 'Tresmorn',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6089557,
        LOCATION_LATITUDE_DEG: 50.749527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022100',
        LOCATION_NAME: 'Tresparrett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6281951,
        LOCATION_LATITUDE_DEG: 50.6958229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022200',
        LOCATION_NAME: 'Tresparrett Posts',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6094599,
        LOCATION_LATITUDE_DEG: 50.708622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022300',
        LOCATION_NAME: 'Tresta',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8898902,
        LOCATION_LATITUDE_DEG: 60.5940481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022400',
        LOCATION_NAME: 'Treswell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8265265,
        LOCATION_LATITUDE_DEG: 53.3061236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022500',
        LOCATION_NAME: 'Treswithian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.315339,
        LOCATION_LATITUDE_DEG: 50.2145766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022600',
        LOCATION_NAME: 'Treswithian Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3233342,
        LOCATION_LATITUDE_DEG: 50.2218786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022700',
        LOCATION_NAME: 'Trethawle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4445578,
        LOCATION_LATITUDE_DEG: 50.4338952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022800',
        LOCATION_NAME: 'Tretherras',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0618016,
        LOCATION_LATITUDE_DEG: 50.4089963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR022900',
        LOCATION_NAME: 'Trethevy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7177728,
        LOCATION_LATITUDE_DEG: 50.6705135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023000',
        LOCATION_NAME: 'Trethias',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0163775,
        LOCATION_LATITUDE_DEG: 50.5200037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023100',
        LOCATION_NAME: 'Trethomas',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1823198,
        LOCATION_LATITUDE_DEG: 51.5911862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023200',
        LOCATION_NAME: 'Trethosa',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8924926,
        LOCATION_LATITUDE_DEG: 50.3568893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023300',
        LOCATION_NAME: 'Trethowel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7961695,
        LOCATION_LATITUDE_DEG: 50.3528865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023400',
        LOCATION_NAME: 'Trethurgy',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7599536,
        LOCATION_LATITUDE_DEG: 50.3667877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023500',
        LOCATION_NAME: 'Tretio',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2205919,
        LOCATION_LATITUDE_DEG: 51.9141449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023600',
        LOCATION_NAME: 'Tretire',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6881956,
        LOCATION_LATITUDE_DEG: 51.9089266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023700',
        LOCATION_NAME: 'Tretower',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'NP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1795229,
        LOCATION_LATITUDE_DEG: 51.882817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023800',
        LOCATION_NAME: 'Treuddyn',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1165402,
        LOCATION_LATITUDE_DEG: 53.114231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR023900',
        LOCATION_NAME: 'Trevalga',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.716422,
        LOCATION_LATITUDE_DEG: 50.6775167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024000',
        LOCATION_NAME: 'Trevance',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9158287,
        LOCATION_LATITUDE_DEG: 50.5089021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024100',
        LOCATION_NAME: 'Trevanion',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.825536,
        LOCATION_LATITUDE_DEG: 50.5067042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024200',
        LOCATION_NAME: 'Trevanson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8520425,
        LOCATION_LATITUDE_DEG: 50.5198034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024300',
        LOCATION_NAME: 'Trevarren',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9396613,
        LOCATION_LATITUDE_DEG: 50.4037916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024400',
        LOCATION_NAME: 'Trevarrian',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.029164,
        LOCATION_LATITUDE_DEG: 50.4559046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024500',
        LOCATION_NAME: 'Trevarth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.185529,
        LOCATION_LATITUDE_DEG: 50.2168802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024700',
        LOCATION_NAME: 'Trevaughan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6128421,
        LOCATION_LATITUDE_DEG: 51.8131287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024600',
        LOCATION_NAME: 'Trevaughan',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3226343,
        LOCATION_LATITUDE_DEG: 51.8657283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024800',
        LOCATION_NAME: 'Trevaunance Cove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2014045,
        LOCATION_LATITUDE_DEG: 50.3189909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR024900',
        LOCATION_NAME: 'Trevear',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8832893,
        LOCATION_LATITUDE_DEG: 50.3444871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025000',
        LOCATION_NAME: 'Trevecca',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4643439,
        LOCATION_LATITUDE_DEG: 50.4530972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025100',
        LOCATION_NAME: 'Treveighan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.718375,
        LOCATION_LATITUDE_DEG: 50.5824123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025200',
        LOCATION_NAME: 'Trevelgue',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0462029,
        LOCATION_LATITUDE_DEG: 50.4293965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025300',
        LOCATION_NAME: 'Trevellas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1738272,
        LOCATION_LATITUDE_DEG: 50.3249929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025400',
        LOCATION_NAME: 'Trevellas Coombe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.186619,
        LOCATION_LATITUDE_DEG: 50.3176881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025500',
        LOCATION_NAME: 'Trevelmond',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5322022,
        LOCATION_LATITUDE_DEG: 50.444398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025600',
        LOCATION_NAME: 'Trevemper',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0739133,
        LOCATION_LATITUDE_DEG: 50.3944979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025700',
        LOCATION_NAME: 'Trevemper Mill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0737059,
        LOCATION_LATITUDE_DEG: 50.3962937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025800',
        LOCATION_NAME: 'Treven',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.74737,
        LOCATION_LATITUDE_DEG: 50.6564153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR025900',
        LOCATION_NAME: 'Trevenen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2365345,
        LOCATION_LATITUDE_DEG: 50.1210713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026000',
        LOCATION_NAME: 'Trevenen Bal',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2469309,
        LOCATION_LATITUDE_DEG: 50.1245685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026100',
        LOCATION_NAME: 'Treverva',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1410903,
        LOCATION_LATITUDE_DEG: 50.141473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026200',
        LOCATION_NAME: 'Treverva Turning',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1426199,
        LOCATION_LATITUDE_DEG: 50.1406758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026300',
        LOCATION_NAME: 'Trevethan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1891213,
        LOCATION_LATITUDE_DEG: 50.2284776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026400',
        LOCATION_NAME: 'Trevethin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0385294,
        LOCATION_LATITUDE_DEG: 51.7129037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026500',
        LOCATION_NAME: 'Trevia',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6913675,
        LOCATION_LATITUDE_DEG: 50.617215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026600',
        LOCATION_NAME: 'Trevigro',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3426117,
        LOCATION_LATITUDE_DEG: 50.502794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026700',
        LOCATION_NAME: 'Trevillick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7440706,
        LOCATION_LATITUDE_DEG: 50.6600195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026800',
        LOCATION_NAME: 'Trevingey',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2364314,
        LOCATION_LATITUDE_DEG: 50.2272762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR026900',
        LOCATION_NAME: 'Trevithick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9764131,
        LOCATION_LATITUDE_DEG: 50.4223967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027000',
        LOCATION_NAME: 'Trevithick Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9829952,
        LOCATION_LATITUDE_DEG: 50.4309995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027100',
        LOCATION_NAME: 'Trevone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9732402,
        LOCATION_LATITUDE_DEG: 50.5411041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027200',
        LOCATION_NAME: 'Trevoole',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3067297,
        LOCATION_LATITUDE_DEG: 50.1847805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027300',
        LOCATION_NAME: 'Trevor',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0906409,
        LOCATION_LATITUDE_DEG: 52.9734176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027400',
        LOCATION_NAME: 'Trevorrick',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0091061,
        LOCATION_LATITUDE_DEG: 50.510404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027500',
        LOCATION_NAME: 'Trevose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0168031,
        LOCATION_LATITUDE_DEG: 50.54171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027600',
        LOCATION_NAME: 'Trewalder',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7225665,
        LOCATION_LATITUDE_DEG: 50.6068101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027700',
        LOCATION_NAME: 'Trewan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9408025,
        LOCATION_LATITUDE_DEG: 50.4437967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003100',
        LOCATION_NAME: 'Tre-War Nevas',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0937165,
        LOCATION_LATITUDE_DEG: 50.0772658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027800',
        LOCATION_NAME: 'Trewarmett',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7359652,
        LOCATION_LATITUDE_DEG: 50.6462127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR027900',
        LOCATION_NAME: 'Trewassa',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6219851,
        LOCATION_LATITUDE_DEG: 50.6510117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028000',
        LOCATION_NAME: 'Trewatha Wallis',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.181834,
        LOCATION_LATITUDE_DEG: 49.9929533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028100',
        LOCATION_NAME: 'Treween',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5149581,
        LOCATION_LATITUDE_DEG: 50.6094108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028200',
        LOCATION_NAME: 'Trewellard',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.6721914,
        LOCATION_LATITUDE_DEG: 50.1456799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028300',
        LOCATION_NAME: 'Trewen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4708404,
        LOCATION_LATITUDE_DEG: 50.6243074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028400',
        LOCATION_NAME: 'Trewen',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4329602,
        LOCATION_LATITUDE_DEG: 52.4826757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028500',
        LOCATION_NAME: 'Trewennack',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2448339,
        LOCATION_LATITUDE_DEG: 50.1113653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028600',
        LOCATION_NAME: 'Trewern',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0627895,
        LOCATION_LATITUDE_DEG: 52.6960943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028700',
        LOCATION_NAME: 'Trewetha',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8180869,
        LOCATION_LATITUDE_DEG: 50.5855105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028800',
        LOCATION_NAME: 'Trewhiddle',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7987923,
        LOCATION_LATITUDE_DEG: 50.3240892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR028900',
        LOCATION_NAME: 'Trewidland',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4553357,
        LOCATION_LATITUDE_DEG: 50.4121863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029000',
        LOCATION_NAME: 'Trewint',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5705981,
        LOCATION_LATITUDE_DEG: 50.7479236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029100',
        LOCATION_NAME: 'Trewirgie',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2281284,
        LOCATION_LATITUDE_DEG: 50.2247813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029200',
        LOCATION_NAME: 'Trewollock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7917846,
        LOCATION_LATITUDE_DEG: 50.2459807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029300',
        LOCATION_NAME: 'Trewoodloe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3660377,
        LOCATION_LATITUDE_DEG: 50.5162991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029400',
        LOCATION_NAME: 'Trewoon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8155906,
        LOCATION_LATITUDE_DEG: 50.3393909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029500',
        LOCATION_NAME: 'Treyarnon Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0186153,
        LOCATION_LATITUDE_DEG: 50.5260992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029600',
        LOCATION_NAME: 'Treyford',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8254555,
        LOCATION_LATITUDE_DEG: 50.9589031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029700',
        LOCATION_NAME: 'Trezaise',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8218799,
        LOCATION_LATITUDE_DEG: 50.3984969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036700',
        LOCATION_NAME: 'Triangle',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029800',
        LOCATION_NAME: 'Triangle',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9339737,
        LOCATION_LATITUDE_DEG: 53.6963741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR029900',
        LOCATION_NAME: 'Trigon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1600335,
        LOCATION_LATITUDE_DEG: 50.6985892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030000',
        LOCATION_NAME: 'Triley',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0003011,
        LOCATION_LATITUDE_DEG: 51.8539663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030100',
        LOCATION_NAME: 'Trillick',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4894616,
        LOCATION_LATITUDE_DEG: 54.454105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030300',
        LOCATION_NAME: 'Trimdon',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'TS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4268549,
        LOCATION_LATITUDE_DEG: 54.7016675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030400',
        LOCATION_NAME: 'Trimdon Colliery',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'TS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4098698,
        LOCATION_LATITUDE_DEG: 54.7181685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030500',
        LOCATION_NAME: 'Trimdon Grange',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'TS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.426045,
        LOCATION_LATITUDE_DEG: 54.713968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030600',
        LOCATION_NAME: 'Trimdon Station',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'TS29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4083148,
        LOCATION_LATITUDE_DEG: 54.7204708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030700',
        LOCATION_NAME: 'Trimingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3887633,
        LOCATION_LATITUDE_DEG: 52.8977508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036100',
        LOCATION_NAME: 'Trimley St Martin',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036200',
        LOCATION_NAME: 'Trimley St Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030800',
        LOCATION_NAME: 'Trimley St. Martin',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3155719,
        LOCATION_LATITUDE_DEG: 51.9846829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030900',
        LOCATION_NAME: 'Trimley St. Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3184387,
        LOCATION_LATITUDE_DEG: 51.982866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031000',
        LOCATION_NAME: 'Trimms Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1356085,
        LOCATION_LATITUDE_DEG: 51.8346755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031100',
        LOCATION_NAME: 'Trimpley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.306434,
        LOCATION_LATITUDE_DEG: 52.40386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031200',
        LOCATION_NAME: 'Trimsaran',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2416838,
        LOCATION_LATITUDE_DEG: 51.7203156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031300',
        LOCATION_NAME: 'Trinafour',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0850914,
        LOCATION_LATITUDE_DEG: 56.7516015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031400',
        LOCATION_NAME: 'Trinant',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1488495,
        LOCATION_LATITUDE_DEG: 51.6910948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031500',
        LOCATION_NAME: 'Tring',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6565768,
        LOCATION_LATITUDE_DEG: 51.7942814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031600',
        LOCATION_NAME: 'Tringford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6771682,
        LOCATION_LATITUDE_DEG: 51.8136781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036900',
        LOCATION_NAME: 'Trinity',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031800',
        LOCATION_NAME: 'Trinity',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.646661,
        LOCATION_LATITUDE_DEG: 56.7472859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031700',
        LOCATION_NAME: 'TRINITY',
        COUNTY_NAME: 'Jersey',
        POSTCODE: 'JE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0924273,
        LOCATION_LATITUDE_DEG: 49.2340171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR031900',
        LOCATION_NAME: 'Trink',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4620555,
        LOCATION_LATITUDE_DEG: 50.1815818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032000',
        LOCATION_NAME: 'Trisant',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8919774,
        LOCATION_LATITUDE_DEG: 52.3601689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032050',
        LOCATION_NAME: 'Triscombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2146885,
        LOCATION_LATITUDE_DEG: 51.1072833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032100',
        LOCATION_NAME: 'Trispen',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0313909,
        LOCATION_LATITUDE_DEG: 50.3138896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032200',
        LOCATION_NAME: 'Tritlington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6777012,
        LOCATION_LATITUDE_DEG: 55.2258268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032300',
        LOCATION_NAME: 'Trobridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6523635,
        LOCATION_LATITUDE_DEG: 50.7670197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032400',
        LOCATION_NAME: 'Trochry',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6607823,
        LOCATION_LATITUDE_DEG: 56.5414783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032500',
        LOCATION_NAME: 'Troedrhiwfuwch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2593046,
        LOCATION_LATITUDE_DEG: 51.7311042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032600',
        LOCATION_NAME: 'Troedyrallt',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5396149,
        LOCATION_LATITUDE_DEG: 52.4512759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032700',
        LOCATION_NAME: 'Troedyrhiw',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3463918,
        LOCATION_LATITUDE_DEG: 51.7118024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032800',
        LOCATION_NAME: 'Trofarth',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7146153,
        LOCATION_LATITUDE_DEG: 53.2304491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR032900',
        LOCATION_NAME: 'Trolliloes',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3189067,
        LOCATION_LATITUDE_DEG: 50.9081781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033000',
        LOCATION_NAME: 'Troon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2763261,
        LOCATION_LATITUDE_DEG: 50.1954768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033100',
        LOCATION_NAME: 'Troon',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6627369,
        LOCATION_LATITUDE_DEG: 55.5437912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033200',
        LOCATION_NAME: 'Troqueer',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6387399,
        LOCATION_LATITUDE_DEG: 55.0436247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033250',
        LOCATION_NAME: 'Trory',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6404531,
        LOCATION_LATITUDE_DEG: 54.3853386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033300',
        LOCATION_NAME: 'Trosairidh',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3613233,
        LOCATION_LATITUDE_DEG: 57.1168807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033400',
        LOCATION_NAME: 'Trosley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3554249,
        LOCATION_LATITUDE_DEG: 51.3292172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033500',
        LOCATION_NAME: 'Trossachs',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4028845,
        LOCATION_LATITUDE_DEG: 56.2326583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033600',
        LOCATION_NAME: 'Troston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7856787,
        LOCATION_LATITUDE_DEG: 52.3143112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033700',
        LOCATION_NAME: 'Trostrey',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9153661,
        LOCATION_LATITUDE_DEG: 51.7329018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033800',
        LOCATION_NAME: 'Trottiscliffe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3549856,
        LOCATION_LATITUDE_DEG: 51.3153207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033900',
        LOCATION_NAME: 'Trotton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.810315,
        LOCATION_LATITUDE_DEG: 50.9958039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034100',
        LOCATION_NAME: 'Troutbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9499543,
        LOCATION_LATITUDE_DEG: 54.6221819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034200',
        LOCATION_NAME: 'Troutbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9131167,
        LOCATION_LATITUDE_DEG: 54.4156624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034300',
        LOCATION_NAME: 'Troutbeck Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9174381,
        LOCATION_LATITUDE_DEG: 54.3931584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034400',
        LOCATION_NAME: 'Troway',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4200653,
        LOCATION_LATITUDE_DEG: 53.3126343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR990364',
        LOCATION_NAME: 'Trowbridge',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034500',
        LOCATION_NAME: 'Trowbridge',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.206674,
        LOCATION_LATITUDE_DEG: 51.3195554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034600',
        LOCATION_NAME: 'Trowell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2804785,
        LOCATION_LATITUDE_DEG: 52.9527959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034700',
        LOCATION_NAME: 'Trowse',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3175278,
        LOCATION_LATITUDE_DEG: 52.6129253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034800',
        LOCATION_NAME: 'Troytown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3686519,
        LOCATION_LATITUDE_DEG: 50.7434986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034900',
        LOCATION_NAME: 'Trudoxhill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3603361,
        LOCATION_LATITUDE_DEG: 51.191439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035100',
        LOCATION_NAME: 'Trull',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.11758,
        LOCATION_LATITUDE_DEG: 50.9932333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035000',
        LOCATION_NAME: 'Trull',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1080997,
        LOCATION_LATITUDE_DEG: 51.6689843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035200',
        LOCATION_NAME: 'Trumpet',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.501674,
        LOCATION_LATITUDE_DEG: 52.0531276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035300',
        LOCATION_NAME: 'Trumpington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1147587,
        LOCATION_LATITUDE_DEG: 52.1767044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035400',
        LOCATION_NAME: 'Trunch',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3971237,
        LOCATION_LATITUDE_DEG: 52.8618478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035500',
        LOCATION_NAME: 'Truro',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0530373,
        LOCATION_LATITUDE_DEG: 50.2644795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035600',
        LOCATION_NAME: 'Truscott',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4022417,
        LOCATION_LATITUDE_DEG: 50.6451098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035700',
        LOCATION_NAME: 'Trusham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6195075,
        LOCATION_LATITUDE_DEG: 50.627401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035900',
        LOCATION_NAME: 'Trusthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2744782,
        LOCATION_LATITUDE_DEG: 53.3285111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR036000',
        LOCATION_NAME: 'Trysull',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.218639,
        LOCATION_LATITUDE_DEG: 52.5458705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000500',
        LOCATION_NAME: 'Tubney',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3691968,
        LOCATION_LATITUDE_DEG: 51.6848754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000600',
        LOCATION_NAME: 'Tubney Wood',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.353619,
        LOCATION_LATITUDE_DEG: 51.6978745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000700',
        LOCATION_NAME: 'Tuckenhay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6626711,
        LOCATION_LATITUDE_DEG: 50.3918769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000800',
        LOCATION_NAME: 'Tuckermarsh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1911224,
        LOCATION_LATITUDE_DEG: 50.4867921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001000',
        LOCATION_NAME: 'Tuckingmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.282237,
        LOCATION_LATITUDE_DEG: 50.2327829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000900',
        LOCATION_NAME: 'Tuckingmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1077152,
        LOCATION_LATITUDE_DEG: 50.1632716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU990758',
        LOCATION_NAME: 'Tuckton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001200',
        LOCATION_NAME: 'Tuddenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5504192,
        LOCATION_LATITUDE_DEG: 52.3119118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001100',
        LOCATION_NAME: 'Tuddenham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1993695,
        LOCATION_LATITUDE_DEG: 52.0907769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001300',
        LOCATION_NAME: 'Tudeley',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.318865,
        LOCATION_LATITUDE_DEG: 51.1844075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001400',
        LOCATION_NAME: 'Tudhoe Colliery',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5869484,
        LOCATION_LATITUDE_DEG: 54.7128703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001500',
        LOCATION_NAME: 'Tudorville',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5946709,
        LOCATION_LATITUDE_DEG: 51.9047155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001600',
        LOCATION_NAME: 'Tudweiliog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6209773,
        LOCATION_LATITUDE_DEG: 52.8983292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001700',
        LOCATION_NAME: 'Tuebrook',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9332237,
        LOCATION_LATITUDE_DEG: 53.4294663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001800',
        LOCATION_NAME: 'Tuell Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2254205,
        LOCATION_LATITUDE_DEG: 50.5865016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU001900',
        LOCATION_NAME: 'Tuffley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2436963,
        LOCATION_LATITUDE_DEG: 51.8315031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU013000',
        LOCATION_NAME: 'Tufnell Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'N7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1380114,
        LOCATION_LATITUDE_DEG: 51.5590865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002000',
        LOCATION_NAME: 'Tufthorn',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6195413,
        LOCATION_LATITUDE_DEG: 51.8104041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002100',
        LOCATION_NAME: 'Tufton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.850125,
        LOCATION_LATITUDE_DEG: 51.9170416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002200',
        LOCATION_NAME: 'Tufton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3449261,
        LOCATION_LATITUDE_DEG: 51.2179308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002300',
        LOCATION_NAME: 'Tufton Warren',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3243301,
        LOCATION_LATITUDE_DEG: 51.1986315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002400',
        LOCATION_NAME: 'Tugby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8750785,
        LOCATION_LATITUDE_DEG: 52.6006547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002500',
        LOCATION_NAME: 'Tugford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6533272,
        LOCATION_LATITUDE_DEG: 52.4794708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003200',
        LOCATION_NAME: 'Tullaghgarley',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.3438299,
        LOCATION_LATITUDE_DEG: 54.8265356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003800',
        LOCATION_NAME: 'Tullibody',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8341702,
        LOCATION_LATITUDE_DEG: 56.1352349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003900',
        LOCATION_NAME: 'Tulliemet',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6381008,
        LOCATION_LATITUDE_DEG: 56.6662847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004200',
        LOCATION_NAME: 'Tulloch',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'PH31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6666315,
        LOCATION_LATITUDE_DEG: 56.8940198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004400',
        LOCATION_NAME: 'Tully',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT94',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.6323691,
        LOCATION_LATITUDE_DEG: 54.1831854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004500',
        LOCATION_NAME: 'Tully',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3501691,
        LOCATION_LATITUDE_DEG: 54.6272178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004600',
        LOCATION_NAME: 'Tully Two',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7838975,
        LOCATION_LATITUDE_DEG: 54.4428024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005200',
        LOCATION_NAME: 'Tullycunny',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3488038,
        LOCATION_LATITUDE_DEG: 54.5516088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005300',
        LOCATION_NAME: 'Tullyhogue',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7255747,
        LOCATION_LATITUDE_DEG: 54.6102081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005350',
        LOCATION_NAME: 'Tullyhommon',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT93',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.8260194,
        LOCATION_LATITUDE_DEG: 54.5493324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005600',
        LOCATION_NAME: 'Tullymacarath',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1334243,
        LOCATION_LATITUDE_DEG: 54.414092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005700',
        LOCATION_NAME: 'Tullynagee',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7259768,
        LOCATION_LATITUDE_DEG: 54.4930965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006000',
        LOCATION_NAME: 'Tullynessle',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7324591,
        LOCATION_LATITUDE_DEG: 57.2648357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006200',
        LOCATION_NAME: 'Tullyrush',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.338589,
        LOCATION_LATITUDE_DEG: 54.4800823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006400',
        LOCATION_NAME: 'Tulnacross',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8675928,
        LOCATION_LATITUDE_DEG: 54.6626902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012900',
        LOCATION_NAME: 'Tulse Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006700',
        LOCATION_NAME: 'Tumble',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1197992,
        LOCATION_LATITUDE_DEG: 51.788915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006800',
        LOCATION_NAME: 'Tumblers Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6312423,
        LOCATION_LATITUDE_DEG: 51.9004747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006900',
        LOCATION_NAME: 'Tumby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1481088,
        LOCATION_LATITUDE_DEG: 53.1207962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007000',
        LOCATION_NAME: 'Tumby Moorside',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1268457,
        LOCATION_LATITUDE_DEG: 53.094892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007100',
        LOCATION_NAME: 'Tumby Woodside',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0998617,
        LOCATION_LATITUDE_DEG: 53.1014954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007200',
        LOCATION_NAME: 'Tummel Bridge',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0185244,
        LOCATION_LATITUDE_DEG: 56.7076009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007300',
        LOCATION_NAME: 'Tunbridge Wells',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2562122,
        LOCATION_LATITUDE_DEG: 51.1329072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007400',
        LOCATION_NAME: 'Tundergarth',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2994545,
        LOCATION_LATITUDE_DEG: 55.1086306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007500',
        LOCATION_NAME: 'Tunley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4386192,
        LOCATION_LATITUDE_DEG: 51.3328554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007600',
        LOCATION_NAME: 'Tunley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0955834,
        LOCATION_LATITUDE_DEG: 51.7342875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007700',
        LOCATION_NAME: 'Tunstall',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5987064,
        LOCATION_LATITUDE_DEG: 54.1571271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008250',
        LOCATION_NAME: 'Tunstall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2105329,
        LOCATION_LATITUDE_DEG: 53.0599459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007900',
        LOCATION_NAME: 'Tunstall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6668068,
        LOCATION_LATITUDE_DEG: 54.3574356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU007800',
        LOCATION_NAME: 'Tunstall',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.018562,
        LOCATION_LATITUDE_DEG: 53.7657551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008200',
        LOCATION_NAME: 'Tunstall',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7221324,
        LOCATION_LATITUDE_DEG: 51.324916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008000',
        LOCATION_NAME: 'Tunstall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.451029,
        LOCATION_LATITUDE_DEG: 52.1432843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008100',
        LOCATION_NAME: 'Tunstall',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5724631,
        LOCATION_LATITUDE_DEG: 52.6159283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008300',
        LOCATION_NAME: 'Tunstead',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7311105,
        LOCATION_LATITUDE_DEG: 53.2622292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008400',
        LOCATION_NAME: 'Tunstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4024588,
        LOCATION_LATITUDE_DEG: 52.7469394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008500',
        LOCATION_NAME: 'Tunstead Milton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9520346,
        LOCATION_LATITUDE_DEG: 53.3175402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008600',
        LOCATION_NAME: 'Tunworth',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0269427,
        LOCATION_LATITUDE_DEG: 51.2318257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008700',
        LOCATION_NAME: 'Tupsley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6858337,
        LOCATION_LATITUDE_DEG: 52.0553289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008800',
        LOCATION_NAME: 'Tupton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4074045,
        LOCATION_LATITUDE_DEG: 53.1905242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU008900',
        LOCATION_NAME: 'Tur Langton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9450876,
        LOCATION_LATITUDE_DEG: 52.5441505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009000',
        LOCATION_NAME: 'Turfdown',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6808681,
        LOCATION_LATITUDE_DEG: 50.4618016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009100',
        LOCATION_NAME: 'Turgis Green',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0009222,
        LOCATION_LATITUDE_DEG: 51.3273385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009200',
        LOCATION_NAME: 'Turin',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.760909,
        LOCATION_LATITUDE_DEG: 56.6658746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009300',
        LOCATION_NAME: 'Turkdean',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8435728,
        LOCATION_LATITUDE_DEG: 51.8568021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009500',
        LOCATION_NAME: 'Turleigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2776233,
        LOCATION_LATITUDE_DEG: 51.3450562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009900',
        LOCATION_NAME: 'Turnberry',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8296992,
        LOCATION_LATITUDE_DEG: 55.3109691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010000',
        LOCATION_NAME: 'Turnbridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7723991,
        LOCATION_LATITUDE_DEG: 53.6458724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010100',
        LOCATION_NAME: 'Turnchapel',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1159936,
        LOCATION_LATITUDE_DEG: 50.3580834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010200',
        LOCATION_NAME: 'Turnditch',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5628108,
        LOCATION_LATITUDE_DEG: 53.013308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010300',
        LOCATION_NAME: 'Turners Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3288774,
        LOCATION_LATITUDE_DEG: 50.9522885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010400',
        LOCATION_NAME: 'Turners Hill',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0838986,
        LOCATION_LATITUDE_DEG: 51.1030086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010500',
        LOCATION_NAME: 'Turnerspuddle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2404694,
        LOCATION_LATITUDE_DEG: 50.7403887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010600',
        LOCATION_NAME: 'Turnford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0247108,
        LOCATION_LATITUDE_DEG: 51.7235596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010700',
        LOCATION_NAME: 'Turnhouse',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.341442,
        LOCATION_LATITUDE_DEG: 55.9550146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010800',
        LOCATION_NAME: 'Turnworth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2544254,
        LOCATION_LATITUDE_DEG: 50.8675106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU010900',
        LOCATION_NAME: 'Turriff',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4680569,
        LOCATION_LATITUDE_DEG: 57.5393598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011000',
        LOCATION_NAME: 'Tursdale',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.530039,
        LOCATION_LATITUDE_DEG: 54.714173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011100',
        LOCATION_NAME: 'Turton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3985596,
        LOCATION_LATITUDE_DEG: 53.633074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011200',
        LOCATION_NAME: 'Turton Bottoms',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3954161,
        LOCATION_LATITUDE_DEG: 53.6381814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011300',
        LOCATION_NAME: 'Turves',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0163078,
        LOCATION_LATITUDE_DEG: 52.5527391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012800',
        LOCATION_NAME: 'Turves Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9699395,
        LOCATION_LATITUDE_DEG: 52.400558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011400',
        LOCATION_NAME: 'Turvey',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6244986,
        LOCATION_LATITUDE_DEG: 52.1617175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011500',
        LOCATION_NAME: 'Turville',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8915339,
        LOCATION_LATITUDE_DEG: 51.6134625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011600',
        LOCATION_NAME: 'Turville Heath',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9251863,
        LOCATION_LATITUDE_DEG: 51.6117611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011700',
        LOCATION_NAME: 'Turweston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1230604,
        LOCATION_LATITUDE_DEG: 52.0343065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011800',
        LOCATION_NAME: 'Tushingham',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7057081,
        LOCATION_LATITUDE_DEG: 53.0013192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU990586',
        LOCATION_NAME: 'Tusmore',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU011900',
        LOCATION_NAME: 'Tusmore Park',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1748237,
        LOCATION_LATITUDE_DEG: 51.9690031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012000',
        LOCATION_NAME: 'Tutbury',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.684877,
        LOCATION_LATITUDE_DEG: 52.8564977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012100',
        LOCATION_NAME: 'Tuthills',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8649436,
        LOCATION_LATITUDE_DEG: 52.8898589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012200',
        LOCATION_NAME: 'Tutnall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0107282,
        LOCATION_LATITUDE_DEG: 52.3302502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012300',
        LOCATION_NAME: 'Tutshill',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6659444,
        LOCATION_LATITUDE_DEG: 51.648487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012400',
        LOCATION_NAME: 'Tuttington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3025311,
        LOCATION_LATITUDE_DEG: 52.7965475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012500',
        LOCATION_NAME: 'Tutts Clump',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1534094,
        LOCATION_LATITUDE_DEG: 51.4362479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012600',
        LOCATION_NAME: 'Tutwell',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2721365,
        LOCATION_LATITUDE_DEG: 50.5587034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU012700',
        LOCATION_NAME: 'Tuxford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8967951,
        LOCATION_LATITUDE_DEG: 53.2306195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000100',
        LOCATION_NAME: 'Twatley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1443986,
        LOCATION_LATITUDE_DEG: 51.582673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000200',
        LOCATION_NAME: 'Twatt',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2779602,
        LOCATION_LATITUDE_DEG: 59.100828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000300',
        LOCATION_NAME: 'Twechar',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.081846,
        LOCATION_LATITUDE_DEG: 55.956422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000400',
        LOCATION_NAME: 'Tweedbank',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7671201,
        LOCATION_LATITUDE_DEG: 55.6043733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000500',
        LOCATION_NAME: 'Tweedmouth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.006997,
        LOCATION_LATITUDE_DEG: 55.7642823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000600',
        LOCATION_NAME: 'Tweedsmuir',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4300285,
        LOCATION_LATITUDE_DEG: 55.5059723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000700',
        LOCATION_NAME: 'Twelveheads',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1301115,
        LOCATION_LATITUDE_DEG: 50.2358777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000800',
        LOCATION_NAME: 'Twemlows',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6332741,
        LOCATION_LATITUDE_DEG: 52.9286079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW000900',
        LOCATION_NAME: 'Twenty',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.289415,
        LOCATION_LATITUDE_DEG: 52.7716711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001000',
        LOCATION_NAME: 'Twerton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3976034,
        LOCATION_LATITUDE_DEG: 51.3807624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001100',
        LOCATION_NAME: 'Twerton on Avon',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3905305,
        LOCATION_LATITUDE_DEG: 51.3787628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001200',
        LOCATION_NAME: 'Twickenham',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3266152,
        LOCATION_LATITUDE_DEG: 51.4462376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001300',
        LOCATION_NAME: 'Twigworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2172805,
        LOCATION_LATITUDE_DEG: 51.9006041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001400',
        LOCATION_NAME: 'Twineham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2089902,
        LOCATION_LATITUDE_DEG: 50.9659968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001500',
        LOCATION_NAME: 'Twinstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7124457,
        LOCATION_LATITUDE_DEG: 51.9966761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001600',
        LOCATION_NAME: 'Twiston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2836794,
        LOCATION_LATITUDE_DEG: 53.8904986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001800',
        LOCATION_NAME: 'Twitchen',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7277646,
        LOCATION_LATITUDE_DEG: 51.0606412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001700',
        LOCATION_NAME: 'Twitchen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9271594,
        LOCATION_LATITUDE_DEG: 52.4072663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW001900',
        LOCATION_NAME: 'Two Ash Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9520961,
        LOCATION_LATITUDE_DEG: 50.8558193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002000',
        LOCATION_NAME: 'Two Burrows',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1768203,
        LOCATION_LATITUDE_DEG: 50.275689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002100',
        LOCATION_NAME: 'Two Dales',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5786871,
        LOCATION_LATITUDE_DEG: 53.1631232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002200',
        LOCATION_NAME: 'Two Gates',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6812774,
        LOCATION_LATITUDE_DEG: 52.6114657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002300',
        LOCATION_NAME: 'Two Locks',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0279885,
        LOCATION_LATITUDE_DEG: 51.6418921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002400',
        LOCATION_NAME: 'Two Mile Ash',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8017595,
        LOCATION_LATITUDE_DEG: 52.0390034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002500',
        LOCATION_NAME: 'Two Mile Bottom',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.725904,
        LOCATION_LATITUDE_DEG: 52.4497225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002600',
        LOCATION_NAME: 'Two Mile Oak',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6270262,
        LOCATION_LATITUDE_DEG: 50.5005887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002700',
        LOCATION_NAME: 'Two Mills',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.976802,
        LOCATION_LATITUDE_DEG: 53.2566433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002800',
        LOCATION_NAME: 'Two Potts',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0994984,
        LOCATION_LATITUDE_DEG: 51.1825612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002900',
        LOCATION_NAME: 'Two Waters Foot',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.579056,
        LOCATION_LATITUDE_DEG: 50.4580946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003200',
        LOCATION_NAME: 'Twycross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.706046,
        LOCATION_LATITUDE_DEG: 51.6958186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003300',
        LOCATION_NAME: 'Twycross',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5023563,
        LOCATION_LATITUDE_DEG: 52.6410675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003800',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9663723,
        LOCATION_LATITUDE_DEG: 52.8293017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003700',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2080575,
        LOCATION_LATITUDE_DEG: 50.9710177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004100',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5161113,
        LOCATION_LATITUDE_DEG: 52.8541948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004200',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3113332,
        LOCATION_LATITUDE_DEG: 51.0227108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004000',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.03419,
        LOCATION_LATITUDE_DEG: 51.9310929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003900',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9223818,
        LOCATION_LATITUDE_DEG: 52.6840652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003500',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8641958,
        LOCATION_LATITUDE_DEG: 51.4765551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003600',
        LOCATION_NAME: 'Twyford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9912318,
        LOCATION_LATITUDE_DEG: 52.7790516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004300',
        LOCATION_NAME: 'Twyford Moors',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3200408,
        LOCATION_LATITUDE_DEG: 51.0016093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004400',
        LOCATION_NAME: 'Twyford Wharf',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2991719,
        LOCATION_LATITUDE_DEG: 52.0292093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW990343',
        LOCATION_NAME: 'Twyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8998503,
        LOCATION_LATITUDE_DEG: 51.8068942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW005000',
        LOCATION_NAME: 'Twyn yr Odyn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004600',
        LOCATION_NAME: 'Twynholm',
        COUNTY_NAME: 'Kirkcudbrightshire',
        POSTCODE: 'DG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0819836,
        LOCATION_LATITUDE_DEG: 54.8645148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004700',
        LOCATION_NAME: 'Twyning',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1477431,
        LOCATION_LATITUDE_DEG: 52.0295195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004800',
        LOCATION_NAME: 'Twynyrodyn',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3705103,
        LOCATION_LATITUDE_DEG: 51.742009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004500',
        LOCATION_NAME: 'Twyn-yr-Odyn',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2729921,
        LOCATION_LATITUDE_DEG: 51.4548756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW004900',
        LOCATION_NAME: 'Twywell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6009476,
        LOCATION_LATITUDE_DEG: 52.3938384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000100',
        LOCATION_NAME: 'Ty Canol',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0558792,
        LOCATION_LATITUDE_DEG: 51.6441896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000200',
        LOCATION_NAME: 'Ty Coch',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0248854,
        LOCATION_LATITUDE_DEG: 51.6343924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000300',
        LOCATION_NAME: 'Ty Croes',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4741406,
        LOCATION_LATITUDE_DEG: 53.2212606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000400',
        LOCATION_NAME: 'Ty Mawr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1250862,
        LOCATION_LATITUDE_DEG: 52.0649417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000500',
        LOCATION_NAME: 'Ty Nant',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5023031,
        LOCATION_LATITUDE_DEG: 52.9923763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000600',
        LOCATION_NAME: 'Tyberton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9027036,
        LOCATION_LATITUDE_DEG: 52.0532288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000700',
        LOCATION_NAME: 'Tyburn',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8077633,
        LOCATION_LATITUDE_DEG: 52.521461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000800',
        LOCATION_NAME: 'Tycroes',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0186897,
        LOCATION_LATITUDE_DEG: 51.7775197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001000',
        LOCATION_NAME: 'Tydd',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1379274,
        LOCATION_LATITUDE_DEG: 52.7453593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001100',
        LOCATION_NAME: 'Tydd Gote',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1550277,
        LOCATION_LATITUDE_DEG: 52.7390608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY005200',
        LOCATION_NAME: 'Tydd St Giles',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001200',
        LOCATION_NAME: 'Tydd St. Giles',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1131746,
        LOCATION_LATITUDE_DEG: 52.7274588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001250',
        LOCATION_NAME: 'Tydd St. Mary',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1402645,
        LOCATION_LATITUDE_DEG: 52.7455779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001300',
        LOCATION_NAME: 'Tye Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5822095,
        LOCATION_LATITUDE_DEG: 51.8605663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001400',
        LOCATION_NAME: 'Tyersal',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7128867,
        LOCATION_LATITUDE_DEG: 53.783081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001600',
        LOCATION_NAME: 'Tyla Garw',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3951218,
        LOCATION_LATITUDE_DEG: 51.5234883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001700',
        LOCATION_NAME: 'Tyldesley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4658211,
        LOCATION_LATITUDE_DEG: 53.5137661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001800',
        LOCATION_NAME: 'Tyler Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0701624,
        LOCATION_LATITUDE_DEG: 51.3058054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001900',
        LOCATION_NAME: 'Tylers Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6939734,
        LOCATION_LATITUDE_DEG: 51.635163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002000',
        LOCATION_NAME: 'Tylorstown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4298909,
        LOCATION_LATITUDE_DEG: 51.6502938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002100',
        LOCATION_NAME: 'Tylwch',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5149104,
        LOCATION_LATITUDE_DEG: 52.4085687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY990710',
        LOCATION_NAME: 'Tyn Lon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY005300',
        LOCATION_NAME: 'Tyn y Gongl',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY005400',
        LOCATION_NAME: 'Tyn y Groes',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8382559,
        LOCATION_LATITUDE_DEG: 53.228489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY990691',
        LOCATION_NAME: 'Tyn y Morfa',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002500',
        LOCATION_NAME: 'Tynan',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8322913,
        LOCATION_LATITUDE_DEG: 54.3331899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002600',
        LOCATION_NAME: 'Tyndrum',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'FK20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7076707,
        LOCATION_LATITUDE_DEG: 56.434881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002700',
        LOCATION_NAME: 'Tynehead',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9673238,
        LOCATION_LATITUDE_DEG: 55.8226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002800',
        LOCATION_NAME: 'Tynemouth',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4239198,
        LOCATION_LATITUDE_DEG: 55.0177019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002900',
        LOCATION_NAME: 'Tynewydd',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5462138,
        LOCATION_LATITUDE_DEG: 51.6793059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003000',
        LOCATION_NAME: 'Tyninghame',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6258886,
        LOCATION_LATITUDE_DEG: 56.0032114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003100',
        LOCATION_NAME: 'Tynlon',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.395572,
        LOCATION_LATITUDE_DEG: 53.2813689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003200',
        LOCATION_NAME: 'Tynreithyn',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9591439,
        LOCATION_LATITUDE_DEG: 52.2421613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003300',
        LOCATION_NAME: 'Tynron',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8767214,
        LOCATION_LATITUDE_DEG: 55.2164469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003400',
        LOCATION_NAME: 'Tyntesfield',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7073574,
        LOCATION_LATITUDE_DEG: 51.4372696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002200',
        LOCATION_NAME: 'Tyn-y-Gongl',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2311494,
        LOCATION_LATITUDE_DEG: 53.3216686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003500',
        LOCATION_NAME: 'Tynygraig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.917574,
        LOCATION_LATITUDE_DEG: 52.3074648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002300',
        LOCATION_NAME: 'Tyn-y-Groes',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8367281,
        LOCATION_LATITUDE_DEG: 53.2274516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003600',
        LOCATION_NAME: 'Tyrie',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1277273,
        LOCATION_LATITUDE_DEG: 57.6530667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003700',
        LOCATION_NAME: 'Tyringham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7440078,
        LOCATION_LATITUDE_DEG: 52.1142058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003900',
        LOCATION_NAME: 'Tyseley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8375361,
        LOCATION_LATITUDE_DEG: 52.4539562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004000',
        LOCATION_NAME: 'Tysoe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5047984,
        LOCATION_LATITUDE_DEG: 52.094319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY990187',
        LOCATION_NAME: 'TYTHBY',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9622035,
        LOCATION_LATITUDE_DEG: 52.9254847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004100',
        LOCATION_NAME: 'Tythegston',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6466964,
        LOCATION_LATITUDE_DEG: 51.4968886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004300',
        LOCATION_NAME: 'Tytherington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4785345,
        LOCATION_LATITUDE_DEG: 51.5922805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004400',
        LOCATION_NAME: 'Tytherington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3316332,
        LOCATION_LATITUDE_DEG: 51.2062455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004200',
        LOCATION_NAME: 'Tytherington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1263995,
        LOCATION_LATITUDE_DEG: 53.2745387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004500',
        LOCATION_NAME: 'Tytherington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1198719,
        LOCATION_LATITUDE_DEG: 51.1688384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004600',
        LOCATION_NAME: 'Tytherleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.96759,
        LOCATION_LATITUDE_DEG: 50.825212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004700',
        LOCATION_NAME: 'Tytherton Lucas',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.075113,
        LOCATION_LATITUDE_DEG: 51.4675622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004800',
        LOCATION_NAME: 'Tyttenhanger',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2910229,
        LOCATION_LATITUDE_DEG: 51.7385721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY004900',
        LOCATION_NAME: 'Tywardreath',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6998781,
        LOCATION_LATITUDE_DEG: 50.3540839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY005000',
        LOCATION_NAME: 'Tywardreath Highway',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7033159,
        LOCATION_LATITUDE_DEG: 50.3697921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY005100',
        LOCATION_NAME: 'Tywyn',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0915143,
        LOCATION_LATITUDE_DEG: 52.5854946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UA000100',
        LOCATION_NAME: 'Uachdar',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3459227,
        LOCATION_LATITUDE_DEG: 57.4799073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UB000100',
        LOCATION_NAME: 'Ubley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6741757,
        LOCATION_LATITUDE_DEG: 51.319758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UC000100',
        LOCATION_NAME: 'Ucheldre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2751811,
        LOCATION_LATITUDE_DEG: 52.5722838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UC000200',
        LOCATION_NAME: 'Uckfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0985285,
        LOCATION_LATITUDE_DEG: 50.97219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UC000300',
        LOCATION_NAME: 'Uckinghall',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1920129,
        LOCATION_LATITUDE_DEG: 52.0392206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UC000400',
        LOCATION_NAME: 'Uckington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5896162,
        LOCATION_LATITUDE_DEG: 52.6934848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UC000500',
        LOCATION_NAME: 'Uckington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1208202,
        LOCATION_LATITUDE_DEG: 51.9219095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UD000100',
        LOCATION_NAME: 'Uddingston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0806627,
        LOCATION_LATITUDE_DEG: 55.8184116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UD000200',
        LOCATION_NAME: 'Udimore',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6652507,
        LOCATION_LATITUDE_DEG: 50.937977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UD000300',
        LOCATION_NAME: 'Udley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7725636,
        LOCATION_LATITUDE_DEG: 51.3688632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UD000400',
        LOCATION_NAME: 'Udny',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1542857,
        LOCATION_LATITUDE_DEG: 57.3201314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UD000500',
        LOCATION_NAME: 'Udny Green',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1974511,
        LOCATION_LATITUDE_DEG: 57.3275366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UD000600',
        LOCATION_NAME: 'Udny Station',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1516221,
        LOCATION_LATITUDE_DEG: 57.3104321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UD000700',
        LOCATION_NAME: 'Udrigle',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5506521,
        LOCATION_LATITUDE_DEG: 57.8820265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000100',
        LOCATION_NAME: 'Uffcott',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8184744,
        LOCATION_LATITUDE_DEG: 51.4962669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000200',
        LOCATION_NAME: 'Uffculme',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3273929,
        LOCATION_LATITUDE_DEG: 50.9050294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000300',
        LOCATION_NAME: 'Uffington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6984257,
        LOCATION_LATITUDE_DEG: 52.7203967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000500',
        LOCATION_NAME: 'Uffington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5583865,
        LOCATION_LATITUDE_DEG: 51.602173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000400',
        LOCATION_NAME: 'Uffington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.431777,
        LOCATION_LATITUDE_DEG: 52.6559573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000700',
        LOCATION_NAME: 'Ufford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3836815,
        LOCATION_LATITUDE_DEG: 52.6237501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000600',
        LOCATION_NAME: 'Ufford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3501311,
        LOCATION_LATITUDE_DEG: 52.1257863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000800',
        LOCATION_NAME: 'Ufton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4455252,
        LOCATION_LATITUDE_DEG: 52.2556338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UF000900',
        LOCATION_NAME: 'Ufton Nervet',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0881427,
        LOCATION_LATITUDE_DEG: 51.4023498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UG000100',
        LOCATION_NAME: 'Ugborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8611918,
        LOCATION_LATITUDE_DEG: 50.3867824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UG000200',
        LOCATION_NAME: 'Ugbrooke',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5841626,
        LOCATION_LATITUDE_DEG: 50.5952009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UG000300',
        LOCATION_NAME: 'Uggeshall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5954759,
        LOCATION_LATITUDE_DEG: 52.3631033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UG000400',
        LOCATION_NAME: 'Ugglebarnby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6450148,
        LOCATION_LATITUDE_DEG: 54.4527364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UG000500',
        LOCATION_NAME: 'Ugley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2121419,
        LOCATION_LATITUDE_DEG: 51.9358763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UG000600',
        LOCATION_NAME: 'Ugley Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'CM22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2171018,
        LOCATION_LATITUDE_DEG: 51.9216812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UG000700',
        LOCATION_NAME: 'Ugthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.768177,
        LOCATION_LATITUDE_DEG: 54.4892364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UI000100',
        LOCATION_NAME: 'Uidh',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.496388,
        LOCATION_LATITUDE_DEG: 56.9341516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UI000200',
        LOCATION_NAME: 'Uig',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6826915,
        LOCATION_LATITUDE_DEG: 57.4762032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UI000300',
        LOCATION_NAME: 'Uigen',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9487569,
        LOCATION_LATITUDE_DEG: 58.2029399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000100',
        LOCATION_NAME: 'Ulbster',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.155284,
        LOCATION_LATITUDE_DEG: 58.3545468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000300',
        LOCATION_NAME: 'Ulceby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3290378,
        LOCATION_LATITUDE_DEG: 53.6175516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000200',
        LOCATION_NAME: 'Ulceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1291613,
        LOCATION_LATITUDE_DEG: 53.2283034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000400',
        LOCATION_NAME: 'Ulcombe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6454339,
        LOCATION_LATITUDE_DEG: 51.2120071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000500',
        LOCATION_NAME: 'Uldale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1646156,
        LOCATION_LATITUDE_DEG: 54.7219924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000600',
        LOCATION_NAME: 'Uley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3010115,
        LOCATION_LATITUDE_DEG: 51.6856887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000700',
        LOCATION_NAME: 'Ulgham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6342241,
        LOCATION_LATITUDE_DEG: 55.224527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000800',
        LOCATION_NAME: 'Ullapool',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1575143,
        LOCATION_LATITUDE_DEG: 57.8982273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001000',
        LOCATION_NAME: 'Ullenhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8204451,
        LOCATION_LATITUDE_DEG: 52.3028438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001100',
        LOCATION_NAME: 'Ullenwood',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0835631,
        LOCATION_LATITUDE_DEG: 51.8520027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001200',
        LOCATION_NAME: 'Ulleskelf',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2107858,
        LOCATION_LATITUDE_DEG: 53.8547821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001300',
        LOCATION_NAME: 'Ullesthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2561067,
        LOCATION_LATITUDE_DEG: 52.4847533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001400',
        LOCATION_NAME: 'Ulley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3035674,
        LOCATION_LATITUDE_DEG: 53.3815389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001500',
        LOCATION_NAME: 'Ullingswick',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5899695,
        LOCATION_LATITUDE_DEG: 52.1424379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001600',
        LOCATION_NAME: 'Ullington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8426011,
        LOCATION_LATITUDE_DEG: 52.1223276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001700',
        LOCATION_NAME: 'Ullinish',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4510676,
        LOCATION_LATITUDE_DEG: 57.3562817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001800',
        LOCATION_NAME: 'Ullock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4291748,
        LOCATION_LATITUDE_DEG: 54.6023817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL001900',
        LOCATION_NAME: 'Ulpha',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2319316,
        LOCATION_LATITUDE_DEG: 54.3314555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL002000',
        LOCATION_NAME: 'Ulrome',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2281325,
        LOCATION_LATITUDE_DEG: 53.9928835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL002100',
        LOCATION_NAME: 'Ulsta',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1549522,
        LOCATION_LATITUDE_DEG: 60.5058372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL002200',
        LOCATION_NAME: 'Ulting',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6114422,
        LOCATION_LATITUDE_DEG: 51.7497593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL002300',
        LOCATION_NAME: 'Ulva Ferry',
        COUNTY_NAME: 'Isle of Mull',
        POSTCODE: 'PA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1463581,
        LOCATION_LATITUDE_DEG: 56.4978992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL002400',
        LOCATION_NAME: 'Ulverscroft',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2651814,
        LOCATION_LATITUDE_DEG: 52.7034718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL002500',
        LOCATION_NAME: 'Ulverston',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0907913,
        LOCATION_LATITUDE_DEG: 54.1950422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL002600',
        LOCATION_NAME: 'Ulwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9692754,
        LOCATION_LATITUDE_DEG: 50.626088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UM000100',
        LOCATION_NAME: 'Umberleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9835249,
        LOCATION_LATITUDE_DEG: 50.9953371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UM000200',
        LOCATION_NAME: 'Umgola',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7629881,
        LOCATION_LATITUDE_DEG: 54.3367884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000100',
        LOCATION_NAME: 'Under Loughrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9697891,
        LOCATION_LATITUDE_DEG: 54.4275618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000200',
        LOCATION_NAME: 'Underbarrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8183521,
        LOCATION_LATITUDE_DEG: 54.3220527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000300',
        LOCATION_NAME: 'Undercliffe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7402174,
        LOCATION_LATITUDE_DEG: 53.8060834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000400',
        LOCATION_NAME: 'Underlane',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1991323,
        LOCATION_LATITUDE_DEG: 50.1481734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000500',
        LOCATION_NAME: 'Underriver',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2305506,
        LOCATION_LATITUDE_DEG: 51.2449128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000600',
        LOCATION_NAME: 'Underskiddaw',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1532982,
        LOCATION_LATITUDE_DEG: 54.6224832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000700',
        LOCATION_NAME: 'Underwood',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2926031,
        LOCATION_LATITUDE_DEG: 53.0499111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000800',
        LOCATION_NAME: 'Undy',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8132767,
        LOCATION_LATITUDE_DEG: 51.5759875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN000900',
        LOCATION_NAME: 'Ungshader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8932959,
        LOCATION_LATITUDE_DEG: 58.1623725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN001000',
        LOCATION_NAME: 'Union Mills',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5204205,
        LOCATION_LATITUDE_DEG: 54.1702523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN001200',
        LOCATION_NAME: 'University of Keele',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2712632,
        LOCATION_LATITUDE_DEG: 53.0019171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN001300',
        LOCATION_NAME: 'University of Stirling',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9151641,
        LOCATION_LATITUDE_DEG: 56.1424359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN001500',
        LOCATION_NAME: 'Unstone',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4408867,
        LOCATION_LATITUDE_DEG: 53.2907355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN001600',
        LOCATION_NAME: 'Unsworth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2882152,
        LOCATION_LATITUDE_DEG: 53.5581677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN001700',
        LOCATION_NAME: 'Unthank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6056011,
        LOCATION_LATITUDE_DEG: 54.757189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000100',
        LOCATION_NAME: 'Up Cerne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4859676,
        LOCATION_LATITUDE_DEG: 50.8235081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000200',
        LOCATION_NAME: 'Up Hatherley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1226966,
        LOCATION_LATITUDE_DEG: 51.8847081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000300',
        LOCATION_NAME: 'Up Marden',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8652014,
        LOCATION_LATITUDE_DEG: 50.9161981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000400',
        LOCATION_NAME: 'Up Nately',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9943955,
        LOCATION_LATITUDE_DEG: 51.2621364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000500',
        LOCATION_NAME: 'Up Somborne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4342723,
        LOCATION_LATITUDE_DEG: 51.0901188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000600',
        LOCATION_NAME: 'Up Sydling',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5295259,
        LOCATION_LATITUDE_DEG: 50.8106106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000700',
        LOCATION_NAME: 'Upavon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8062905,
        LOCATION_LATITUDE_DEG: 51.2944427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000800',
        LOCATION_NAME: 'Upchurch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6496834,
        LOCATION_LATITUDE_DEG: 51.3758252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP000900',
        LOCATION_NAME: 'Upend',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4887526,
        LOCATION_LATITUDE_DEG: 52.1968974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001000',
        LOCATION_NAME: 'Upexe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5055654,
        LOCATION_LATITUDE_DEG: 50.8096433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001100',
        LOCATION_NAME: 'Uphall',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5058119,
        LOCATION_LATITUDE_DEG: 55.9340183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001200',
        LOCATION_NAME: 'Uphall Station',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5003545,
        LOCATION_LATITUDE_DEG: 55.9179173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001300',
        LOCATION_NAME: 'Upham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2338177,
        LOCATION_LATITUDE_DEG: 50.9820096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001500',
        LOCATION_NAME: 'Uphampton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8826653,
        LOCATION_LATITUDE_DEG: 52.2654513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001400',
        LOCATION_NAME: 'Uphampton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2410188,
        LOCATION_LATITUDE_DEG: 52.2774418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001600',
        LOCATION_NAME: 'Uphill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4062359,
        LOCATION_LATITUDE_DEG: 50.5438017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001700',
        LOCATION_NAME: 'Uphill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9776478,
        LOCATION_LATITUDE_DEG: 51.325361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001800',
        LOCATION_NAME: 'Upholland',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7269985,
        LOCATION_LATITUDE_DEG: 53.5410682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP001900',
        LOCATION_NAME: 'Uplands',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3069014,
        LOCATION_LATITUDE_DEG: 51.7950235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002100',
        LOCATION_NAME: 'Uplands',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9675779,
        LOCATION_LATITUDE_DEG: 51.6176021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002000',
        LOCATION_NAME: 'Uplands',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2092014,
        LOCATION_LATITUDE_DEG: 51.7476914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002200',
        LOCATION_NAME: 'Uplawmoor',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4947597,
        LOCATION_LATITUDE_DEG: 55.7648074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002300',
        LOCATION_NAME: 'Upleadon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3609534,
        LOCATION_LATITUDE_DEG: 51.9406158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002400',
        LOCATION_NAME: 'Upleatham',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0192439,
        LOCATION_LATITUDE_DEG: 54.5645463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002500',
        LOCATION_NAME: 'Uploders',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7010077,
        LOCATION_LATITUDE_DEG: 50.7408051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002600',
        LOCATION_NAME: 'Uplowman',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4004462,
        LOCATION_LATITUDE_DEG: 50.9267327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002700',
        LOCATION_NAME: 'Upminster',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2508075,
        LOCATION_LATITUDE_DEG: 51.5557419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002800',
        LOCATION_NAME: 'Upnor',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5274448,
        LOCATION_LATITUDE_DEG: 51.4099275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP002900',
        LOCATION_NAME: 'Upottery',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.132749,
        LOCATION_LATITUDE_DEG: 50.8628218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003000',
        LOCATION_NAME: 'Upper Aird',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1645971,
        LOCATION_LATITUDE_DEG: 58.2453712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003050',
        LOCATION_NAME: 'Upper Ardelve',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5381545,
        LOCATION_LATITUDE_DEG: 57.2812987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003100',
        LOCATION_NAME: 'Upper Arncott',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1078572,
        LOCATION_LATITUDE_DEG: 51.8441895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003200',
        LOCATION_NAME: 'Upper Astley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7041399,
        LOCATION_LATITUDE_DEG: 52.7579984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003300',
        LOCATION_NAME: 'Upper Ballysillan',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.0137991,
        LOCATION_LATITUDE_DEG: 54.6360041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003400',
        LOCATION_NAME: 'Upper Basildon',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1396447,
        LOCATION_LATITUDE_DEG: 51.4811566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003500',
        LOCATION_NAME: 'Upper Battenhall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1930814,
        LOCATION_LATITUDE_DEG: 52.1720337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003600',
        LOCATION_NAME: 'Upper Battlefield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.714353,
        LOCATION_LATITUDE_DEG: 52.7526957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003700',
        LOCATION_NAME: 'Upper Bayble',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1995058,
        LOCATION_LATITUDE_DEG: 58.2039726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003800',
        LOCATION_NAME: 'Upper Beeding',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2989413,
        LOCATION_LATITUDE_DEG: 50.8796842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP003900',
        LOCATION_NAME: 'Upper Benefield',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.553842,
        LOCATION_LATITUDE_DEG: 52.4930444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004000',
        LOCATION_NAME: 'Upper Bentley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0079773,
        LOCATION_LATITUDE_DEG: 52.2943394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004100',
        LOCATION_NAME: 'Upper Berwick',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7793269,
        LOCATION_LATITUDE_DEG: 52.7383958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004200',
        LOCATION_NAME: 'Upper Billesley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7687494,
        LOCATION_LATITUDE_DEG: 52.2087312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004300',
        LOCATION_NAME: 'Upper Boat',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2871065,
        LOCATION_LATITUDE_DEG: 51.5742924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004400',
        LOCATION_NAME: 'Upper Boddington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2944619,
        LOCATION_LATITUDE_DEG: 52.1764211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004500',
        LOCATION_NAME: 'Upper Brailes',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5551773,
        LOCATION_LATITUDE_DEG: 52.0548125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004600',
        LOCATION_NAME: 'Upper Breakish',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.8496659,
        LOCATION_LATITUDE_DEG: 57.2389705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004700',
        LOCATION_NAME: 'Upper Broughton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9873629,
        LOCATION_LATITUDE_DEG: 52.8290779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004800',
        LOCATION_NAME: 'Upper Bruntingthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1016721,
        LOCATION_LATITUDE_DEG: 52.4882491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP990341',
        LOCATION_NAME: 'Upper Brynamman',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8686517,
        LOCATION_LATITUDE_DEG: 51.8140762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP004900',
        LOCATION_NAME: 'Upper Bucklebury',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2204918,
        LOCATION_LATITUDE_DEG: 51.413152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005000',
        LOCATION_NAME: 'Upper Burnmouth',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0712465,
        LOCATION_LATITUDE_DEG: 55.8434917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005100',
        LOCATION_NAME: 'Upper Caldecote',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2936432,
        LOCATION_LATITUDE_DEG: 52.0991052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005200',
        LOCATION_NAME: 'Upper Carloway',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7545475,
        LOCATION_LATITUDE_DEG: 58.2873804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005300',
        LOCATION_NAME: 'Upper Castle Combe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2251087,
        LOCATION_LATITUDE_DEG: 51.4938712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005400',
        LOCATION_NAME: 'Upper Chapel',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.447753,
        LOCATION_LATITUDE_DEG: 52.0541324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005500',
        LOCATION_NAME: 'Upper Chedglow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0809959,
        LOCATION_LATITUDE_DEG: 51.6348804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005600',
        LOCATION_NAME: 'Upper Church Village',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.327714,
        LOCATION_LATITUDE_DEG: 51.5671852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005700',
        LOCATION_NAME: 'Upper Chute',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5742012,
        LOCATION_LATITUDE_DEG: 51.2831452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005800',
        LOCATION_NAME: 'Upper Clatford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4912337,
        LOCATION_LATITUDE_DEG: 51.1892331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP005900',
        LOCATION_NAME: 'Upper Coberley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0270305,
        LOCATION_LATITUDE_DEG: 51.8422011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006000',
        LOCATION_NAME: 'Upper Colwall',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3468828,
        LOCATION_LATITUDE_DEG: 52.0892289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006100',
        LOCATION_NAME: 'Upper Corris',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8582362,
        LOCATION_LATITUDE_DEG: 52.662599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006200',
        LOCATION_NAME: 'Upper Cound',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6612201,
        LOCATION_LATITUDE_DEG: 52.6393866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006300',
        LOCATION_NAME: 'Upper Coxley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6684673,
        LOCATION_LATITUDE_DEG: 51.1905431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006400',
        LOCATION_NAME: 'Upper Culham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8608627,
        LOCATION_LATITUDE_DEG: 51.5305521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006500',
        LOCATION_NAME: 'Upper Cumberworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6809004,
        LOCATION_LATITUDE_DEG: 53.5754658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006600',
        LOCATION_NAME: 'Upper Cwmbran',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0442878,
        LOCATION_LATITUDE_DEG: 51.6630968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006700',
        LOCATION_NAME: 'Upper Cwmtwrch',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8041777,
        LOCATION_LATITUDE_DEG: 51.7866381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006800',
        LOCATION_NAME: 'Upper Dean',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4647385,
        LOCATION_LATITUDE_DEG: 52.2963196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP006900',
        LOCATION_NAME: 'Upper Denby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6586865,
        LOCATION_LATITUDE_DEG: 53.5599607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007000',
        LOCATION_NAME: 'Upper Denford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4807484,
        LOCATION_LATITUDE_DEG: 51.4227502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007100',
        LOCATION_NAME: 'Upper Dicker',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2047303,
        LOCATION_LATITUDE_DEG: 50.8661815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007200',
        LOCATION_NAME: 'Upper Dormington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6031343,
        LOCATION_LATITUDE_DEG: 52.0556283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007300',
        LOCATION_NAME: 'Upper Dowdeswell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9925771,
        LOCATION_LATITUDE_DEG: 51.8709063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007400',
        LOCATION_NAME: 'Upper Dunsforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.325069,
        LOCATION_LATITUDE_DEG: 54.0630074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007500',
        LOCATION_NAME: 'Upper Dunwear',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9746934,
        LOCATION_LATITUDE_DEG: 51.1227416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007600',
        LOCATION_NAME: 'Upper Easebourne',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7116804,
        LOCATION_LATITUDE_DEG: 50.9925993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007700',
        LOCATION_NAME: 'Upper Eddington',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5052468,
        LOCATION_LATITUDE_DEG: 51.4171548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022900',
        LOCATION_NAME: 'Upper Edmonton',
        COUNTY_NAME: 'London',
        POSTCODE: 'N18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0651941,
        LOCATION_LATITUDE_DEG: 51.612364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007800',
        LOCATION_NAME: 'Upper Enham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4641384,
        LOCATION_LATITUDE_DEG: 51.2451387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP007900',
        LOCATION_NAME: 'Upper Etloe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4741093,
        LOCATION_LATITUDE_DEG: 51.7494931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008000',
        LOCATION_NAME: 'Upper Farringdon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9804455,
        LOCATION_LATITUDE_DEG: 51.1131138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008100',
        LOCATION_NAME: 'Upper Froyle',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9192367,
        LOCATION_LATITUDE_DEG: 51.1798257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008200',
        LOCATION_NAME: 'Upper Fulbrook',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6470245,
        LOCATION_LATITUDE_DEG: 52.2396302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008300',
        LOCATION_NAME: 'Upper Gellifelen',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1357914,
        LOCATION_LATITUDE_DEG: 51.7994111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008400',
        LOCATION_NAME: 'Upper Gelligroes',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.190396,
        LOCATION_LATITUDE_DEG: 51.6432986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008500',
        LOCATION_NAME: 'Upper Godney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7276228,
        LOCATION_LATITUDE_DEG: 51.1818445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008600',
        LOCATION_NAME: 'Upper Gornal',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.108172,
        LOCATION_LATITUDE_DEG: 52.5260631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008700',
        LOCATION_NAME: 'Upper Hale',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7998809,
        LOCATION_LATITUDE_DEG: 51.2341243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008800',
        LOCATION_NAME: 'Upper Halistra',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.599691,
        LOCATION_LATITUDE_DEG: 57.541407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP008900',
        LOCATION_NAME: 'Upper Halling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4300619,
        LOCATION_LATITUDE_DEG: 51.3527235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009000',
        LOCATION_NAME: 'Upper Harbledown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0282868,
        LOCATION_LATITUDE_DEG: 51.286009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP990898',
        LOCATION_NAME: 'Upper Harford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009100',
        LOCATION_NAME: 'Upper Harlestone',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9783276,
        LOCATION_LATITUDE_DEG: 52.2655262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009200',
        LOCATION_NAME: 'Upper Hartfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0933022,
        LOCATION_LATITUDE_DEG: 51.092504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009300',
        LOCATION_NAME: 'Upper Hellesdon',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2828222,
        LOCATION_LATITUDE_DEG: 52.6544321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009400',
        LOCATION_NAME: 'Upper Helmsley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.939709,
        LOCATION_LATITUDE_DEG: 54.0027962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009500',
        LOCATION_NAME: 'Upper Hergest',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0771764,
        LOCATION_LATITUDE_DEG: 52.1876495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009600',
        LOCATION_NAME: 'Upper Heyford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2746803,
        LOCATION_LATITUDE_DEG: 51.9300958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009700',
        LOCATION_NAME: 'Upper Heyford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0285272,
        LOCATION_LATITUDE_DEG: 52.2304237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009800',
        LOCATION_NAME: 'Upper Hill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7722267,
        LOCATION_LATITUDE_DEG: 52.1761383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP023000',
        LOCATION_NAME: 'Upper Holloway',
        COUNTY_NAME: 'London',
        POSTCODE: 'N19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.12879,
        LOCATION_LATITUDE_DEG: 51.568266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP009900',
        LOCATION_NAME: 'Upper Holton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5286861,
        LOCATION_LATITUDE_DEG: 52.3531008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP990510',
        LOCATION_NAME: 'Upper Horsebridge',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010000',
        LOCATION_NAME: 'Upper Houndlaw',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.089039,
        LOCATION_LATITUDE_DEG: 55.8717949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010100',
        LOCATION_NAME: 'Upper Hulme',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9800091,
        LOCATION_LATITUDE_DEG: 53.143828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010200',
        LOCATION_NAME: 'Upper Ingleston',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7470225,
        LOCATION_LATITUDE_DEG: 55.9393285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010300',
        LOCATION_NAME: 'Upper Ivington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7888484,
        LOCATION_LATITUDE_DEG: 52.1988402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010400',
        LOCATION_NAME: 'Upper Killay',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0370549,
        LOCATION_LATITUDE_DEG: 51.6130981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010500',
        LOCATION_NAME: 'Upper Kitesnest',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2304984,
        LOCATION_LATITUDE_DEG: 51.7650963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010600',
        LOCATION_NAME: 'Upper Lambourn',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5476775,
        LOCATION_LATITUDE_DEG: 51.5201658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010700',
        LOCATION_NAME: 'Upper Largo',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9242446,
        LOCATION_LATITUDE_DEG: 56.2218355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010800',
        LOCATION_NAME: 'Upper Laxton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6043195,
        LOCATION_LATITUDE_DEG: 52.5574463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP010900',
        LOCATION_NAME: 'Upper Littleton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6402509,
        LOCATION_LATITUDE_DEG: 51.3786627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011000',
        LOCATION_NAME: 'Upper Llandwrog',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2246565,
        LOCATION_LATITUDE_DEG: 53.0706391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011100',
        LOCATION_NAME: 'Upper Loads',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5323206,
        LOCATION_LATITUDE_DEG: 53.2217269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP990990',
        LOCATION_NAME: 'Upper Longdon',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: '',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011200',
        LOCATION_NAME: 'Upper Ludstone',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2888538,
        LOCATION_LATITUDE_DEG: 52.5547739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011300',
        LOCATION_NAME: 'Upper Lydbrook',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5699277,
        LOCATION_LATITUDE_DEG: 51.8334051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011400',
        LOCATION_NAME: 'Upper Lyde',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7348114,
        LOCATION_LATITUDE_DEG: 52.0969355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011500',
        LOCATION_NAME: 'Upper Marham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5503905,
        LOCATION_LATITUDE_DEG: 52.6540446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011600',
        LOCATION_NAME: 'Upper Mayfield',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7704183,
        LOCATION_LATITUDE_DEG: 53.0107074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011700',
        LOCATION_NAME: 'Upper Midford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3475239,
        LOCATION_LATITUDE_DEG: 51.3430531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011800',
        LOCATION_NAME: 'Upper Midhope',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6745105,
        LOCATION_LATITUDE_DEG: 53.4929524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP011900',
        LOCATION_NAME: 'Upper Millichope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7061217,
        LOCATION_LATITUDE_DEG: 52.497968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012000',
        LOCATION_NAME: 'Upper Milton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6488576,
        LOCATION_LATITUDE_DEG: 51.2239458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012100',
        LOCATION_NAME: 'Upper Minety',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9880246,
        LOCATION_LATITUDE_DEG: 51.6188745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012200',
        LOCATION_NAME: 'Upper Moor',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0292767,
        LOCATION_LATITUDE_DEG: 52.1265291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012400',
        LOCATION_NAME: 'Upper Morton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5078268,
        LOCATION_LATITUDE_DEG: 51.6193865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012300',
        LOCATION_NAME: 'Upper Morton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0066246,
        LOCATION_LATITUDE_DEG: 53.2925301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012500',
        LOCATION_NAME: 'Upper North Wraxall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2808153,
        LOCATION_LATITUDE_DEG: 51.4654695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022700',
        LOCATION_NAME: 'Upper Norwood',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0925207,
        LOCATION_LATITUDE_DEG: 51.4140886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012600',
        LOCATION_NAME: 'Upper Oddington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6758694,
        LOCATION_LATITUDE_DEG: 51.928503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012700',
        LOCATION_NAME: 'Upper Pendock',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2951982,
        LOCATION_LATITUDE_DEG: 52.0167168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012800',
        LOCATION_NAME: 'Upper Poppleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1516807,
        LOCATION_LATITUDE_DEG: 53.9796963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP012900',
        LOCATION_NAME: 'Upper Quinton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7407179,
        LOCATION_LATITUDE_DEG: 52.1162221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013000',
        LOCATION_NAME: 'Upper Race',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0491773,
        LOCATION_LATITUDE_DEG: 51.687594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013050',
        LOCATION_NAME: 'Upper Rissington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7013057,
        LOCATION_LATITUDE_DEG: 51.8740972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013100',
        LOCATION_NAME: 'Upper Sapey',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4607029,
        LOCATION_LATITUDE_DEG: 52.2668446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013200',
        LOCATION_NAME: 'Upper Sarnau',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1514551,
        LOCATION_LATITUDE_DEG: 52.7232017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013300',
        LOCATION_NAME: 'Upper Seagry',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0767796,
        LOCATION_LATITUDE_DEG: 51.5254729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013400',
        LOCATION_NAME: 'Upper Shader',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.4731894,
        LOCATION_LATITUDE_DEG: 58.3974923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013500',
        LOCATION_NAME: 'Upper Sheringham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1907282,
        LOCATION_LATITUDE_DEG: 52.9312574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013600',
        LOCATION_NAME: 'Upper Shockerwick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.289124,
        LOCATION_LATITUDE_DEG: 51.4178604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013700',
        LOCATION_NAME: 'Upper Shuckburgh',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2711828,
        LOCATION_LATITUDE_DEG: 52.2512335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013800',
        LOCATION_NAME: 'Upper Skelmorlie',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'PA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8823238,
        LOCATION_LATITUDE_DEG: 55.8701222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP013900',
        LOCATION_NAME: 'Upper Slaughter',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7755995,
        LOCATION_LATITUDE_DEG: 51.9059049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014000',
        LOCATION_NAME: 'Upper Soudley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.496332,
        LOCATION_LATITUDE_DEG: 51.7917006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014100',
        LOCATION_NAME: 'Upper Sound',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1712291,
        LOCATION_LATITUDE_DEG: 60.1444085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014200',
        LOCATION_NAME: 'Upper South Wraxall',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2420134,
        LOCATION_LATITUDE_DEG: 51.3834622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014300',
        LOCATION_NAME: 'Upper Stanton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5708515,
        LOCATION_LATITUDE_DEG: 51.361962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014400',
        LOCATION_NAME: 'Upper Staploe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3252992,
        LOCATION_LATITUDE_DEG: 52.2249138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014500',
        LOCATION_NAME: 'Upper Steelend',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5191807,
        LOCATION_LATITUDE_DEG: 56.1146346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014600',
        LOCATION_NAME: 'Upper Stondon',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3265885,
        LOCATION_LATITUDE_DEG: 52.0064952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014700',
        LOCATION_NAME: 'Upper Stowe',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0572168,
        LOCATION_LATITUDE_DEG: 52.2047243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014800',
        LOCATION_NAME: 'Upper Stratton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7652572,
        LOCATION_LATITUDE_DEG: 51.5828688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP014900',
        LOCATION_NAME: 'Upper Strode',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6643523,
        LOCATION_LATITUDE_DEG: 51.3510644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015000',
        LOCATION_NAME: 'Upper Swainswick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3481348,
        LOCATION_LATITUDE_DEG: 51.4141658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015100',
        LOCATION_NAME: 'Upper Swell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7450527,
        LOCATION_LATITUDE_DEG: 51.939904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015200',
        LOCATION_NAME: 'Upper Thornton',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0355522,
        LOCATION_LATITUDE_DEG: 51.7295246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015300',
        LOCATION_NAME: 'Upper Tredrea',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1552231,
        LOCATION_LATITUDE_DEG: 50.2042754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015400',
        LOCATION_NAME: 'Upper Trelyn',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2090976,
        LOCATION_LATITUDE_DEG: 51.6616955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015500',
        LOCATION_NAME: 'Upper Tumble',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1049393,
        LOCATION_LATITUDE_DEG: 51.7862142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015600',
        LOCATION_NAME: 'Upper Tysoe',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5106871,
        LOCATION_LATITUDE_DEG: 52.0898208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015700',
        LOCATION_NAME: 'Upper Up',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9334769,
        LOCATION_LATITUDE_DEG: 51.6690782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015800',
        LOCATION_NAME: 'Upper Vobster',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4248062,
        LOCATION_LATITUDE_DEG: 51.2439487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP015900',
        LOCATION_NAME: 'Upper Wanborough',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7491609,
        LOCATION_LATITUDE_DEG: 51.5255626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016000',
        LOCATION_NAME: 'Upper Welland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.327364,
        LOCATION_LATITUDE_DEG: 52.0689366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016100',
        LOCATION_NAME: 'Upper Westwood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2758234,
        LOCATION_LATITUDE_DEG: 51.3346558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016200',
        LOCATION_NAME: 'Upper Whiston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3110014,
        LOCATION_LATITUDE_DEG: 53.3960376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016300',
        LOCATION_NAME: 'Upper Wick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4071447,
        LOCATION_LATITUDE_DEG: 51.6667908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016400',
        LOCATION_NAME: 'Upper Wield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0993081,
        LOCATION_LATITUDE_DEG: 51.1438217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016500',
        LOCATION_NAME: 'Upper Winchendon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9165579,
        LOCATION_LATITUDE_DEG: 51.8221883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016600',
        LOCATION_NAME: 'Upper Windrush',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.723319,
        LOCATION_LATITUDE_DEG: 51.8117915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016700',
        LOCATION_NAME: 'Upper Woodcott',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3704292,
        LOCATION_LATITUDE_DEG: 51.2851406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016800',
        LOCATION_NAME: 'Upper Woodford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8218547,
        LOCATION_LATITUDE_DEG: 51.1345277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP016900',
        LOCATION_NAME: 'Upper Woolhampton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1707741,
        LOCATION_LATITUDE_DEG: 51.4061471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017000',
        LOCATION_NAME: 'Upper Wootton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1686795,
        LOCATION_LATITUDE_DEG: 51.2876411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP023200',
        LOCATION_NAME: 'Upper Wortley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.593727,
        LOCATION_LATITUDE_DEG: 53.7919054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017100',
        LOCATION_NAME: 'Upper Yetts',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.601789,
        LOCATION_LATITUDE_DEG: 56.1988401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017300',
        LOCATION_NAME: 'Upperlands',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.6489564,
        LOCATION_LATITUDE_DEG: 54.8666405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017400',
        LOCATION_NAME: 'Uppermill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0037282,
        LOCATION_LATITUDE_DEG: 53.5486625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017500',
        LOCATION_NAME: 'Upperthong',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.797512,
        LOCATION_LATITUDE_DEG: 53.5671621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022600',
        LOCATION_NAME: 'Upperthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4843111,
        LOCATION_LATITUDE_DEG: 53.3912124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017600',
        LOCATION_NAME: 'Upperton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.63558,
        LOCATION_LATITUDE_DEG: 50.9955036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017700',
        LOCATION_NAME: 'Uppingham',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7211838,
        LOCATION_LATITUDE_DEG: 52.5876559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017800',
        LOCATION_NAME: 'Uppington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.588731,
        LOCATION_LATITUDE_DEG: 52.6815854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017900',
        LOCATION_NAME: 'Uppington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9730046,
        LOCATION_LATITUDE_DEG: 50.8543035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018000',
        LOCATION_NAME: 'Upsall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3052169,
        LOCATION_LATITUDE_DEG: 54.2789279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018100',
        LOCATION_NAME: 'Upstreet',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1993907,
        LOCATION_LATITUDE_DEG: 51.3236092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP990587',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019300',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5483698,
        LOCATION_LATITUDE_DEG: 50.8147798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019000',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4320425,
        LOCATION_LATITUDE_DEG: 51.0495385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019500',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8851252,
        LOCATION_LATITUDE_DEG: 53.2144401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018800',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0266586,
        LOCATION_LATITUDE_DEG: 50.7369912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018500',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6469153,
        LOCATION_LATITUDE_DEG: 51.809195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019400',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4837099,
        LOCATION_LATITUDE_DEG: 51.2938425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019700',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4621075,
        LOCATION_LATITUDE_DEG: 52.5942649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019800',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2847328,
        LOCATION_LATITUDE_DEG: 53.6132621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018600',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2594569,
        LOCATION_LATITUDE_DEG: 51.5780696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018200',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1772568,
        LOCATION_LATITUDE_DEG: 50.7097813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018700',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9484166,
        LOCATION_LATITUDE_DEG: 52.2345208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018300',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8999346,
        LOCATION_LATITUDE_DEG: 53.0817038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019900',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8809298,
        LOCATION_LATITUDE_DEG: 53.2782282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020000',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8800691,
        LOCATION_LATITUDE_DEG: 51.7955796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019600',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6947486,
        LOCATION_LATITUDE_DEG: 53.3708336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018400',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3676992,
        LOCATION_LATITUDE_DEG: 52.5902524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020100',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2733753,
        LOCATION_LATITUDE_DEG: 52.3915301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP018900',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5431279,
        LOCATION_LATITUDE_DEG: 52.6574332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020200',
        LOCATION_NAME: 'Upton Bishop',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5106888,
        LOCATION_LATITUDE_DEG: 51.9431188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020300',
        LOCATION_NAME: 'Upton Cheyney',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4419363,
        LOCATION_LATITUDE_DEG: 51.42697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020400',
        LOCATION_NAME: 'Upton Cressett',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5048698,
        LOCATION_LATITUDE_DEG: 52.5304754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020500',
        LOCATION_NAME: 'Upton Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4256508,
        LOCATION_LATITUDE_DEG: 50.5226999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020600',
        LOCATION_NAME: 'Upton Fort',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3549492,
        LOCATION_LATITUDE_DEG: 50.6370906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020700',
        LOCATION_NAME: 'Upton Grey',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9982243,
        LOCATION_LATITUDE_DEG: 51.2284268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020800',
        LOCATION_NAME: 'Upton Hellions',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.645819,
        LOCATION_LATITUDE_DEG: 50.8153219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP020900',
        LOCATION_NAME: 'Upton Lovell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0751135,
        LOCATION_LATITUDE_DEG: 51.1691365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021000',
        LOCATION_NAME: 'Upton Magna',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6602184,
        LOCATION_LATITUDE_DEG: 52.7082892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021100',
        LOCATION_NAME: 'Upton Noble',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4104524,
        LOCATION_LATITUDE_DEG: 51.1524419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022800',
        LOCATION_NAME: 'Upton Park',
        COUNTY_NAME: 'London',
        POSTCODE: 'E6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.023606,
        LOCATION_LATITUDE_DEG: 51.5240686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021200',
        LOCATION_NAME: 'Upton Pyne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5449822,
        LOCATION_LATITUDE_DEG: 50.7656136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021300',
        LOCATION_NAME: 'Upton Scudamore',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1930577,
        LOCATION_LATITUDE_DEG: 51.2279414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021400',
        LOCATION_NAME: 'Upton Snodsbury',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0836368,
        LOCATION_LATITUDE_DEG: 52.1886344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022400',
        LOCATION_NAME: 'Upton St Leonards',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021500',
        LOCATION_NAME: 'Upton St. Leonards',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1987686,
        LOCATION_LATITUDE_DEG: 51.8329004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021600',
        LOCATION_NAME: 'Upton Towans',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3909368,
        LOCATION_LATITUDE_DEG: 50.2065803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022500',
        LOCATION_NAME: 'Upton upon Severn',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021700',
        LOCATION_NAME: 'Upton Warren',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1033784,
        LOCATION_LATITUDE_DEG: 52.3048412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021800',
        LOCATION_NAME: 'Upton-upon-Severn',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2161854,
        LOCATION_LATITUDE_DEG: 52.0629258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP021900',
        LOCATION_NAME: 'Upwaltham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6586028,
        LOCATION_LATITUDE_DEG: 50.9146907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022000',
        LOCATION_NAME: 'Upware',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2562343,
        LOCATION_LATITUDE_DEG: 52.3076122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022100',
        LOCATION_NAME: 'Upwell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2124821,
        LOCATION_LATITUDE_DEG: 52.5973419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022200',
        LOCATION_NAME: 'Upwey',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.473585,
        LOCATION_LATITUDE_DEG: 50.6617887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP022300',
        LOCATION_NAME: 'Upwood',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1497236,
        LOCATION_LATITUDE_DEG: 52.4265363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000100',
        LOCATION_NAME: 'Urchfont',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9411122,
        LOCATION_LATITUDE_DEG: 51.3115485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000200',
        LOCATION_NAME: 'Urgashay',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6174568,
        LOCATION_LATITUDE_DEG: 51.0154284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000300',
        LOCATION_NAME: 'Urgha',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.7584203,
        LOCATION_LATITUDE_DEG: 57.8967447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000500',
        LOCATION_NAME: 'Urmston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3530538,
        LOCATION_LATITUDE_DEG: 53.4521604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000600',
        LOCATION_NAME: 'Urpeth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6129939,
        LOCATION_LATITUDE_DEG: 54.8841878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000700',
        LOCATION_NAME: 'Urquhart',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1925294,
        LOCATION_LATITUDE_DEG: 57.6488846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000800',
        LOCATION_NAME: 'Urray',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4940033,
        LOCATION_LATITUDE_DEG: 57.5423855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'US000100',
        LOCATION_NAME: 'Ushaw Moor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6434445,
        LOCATION_LATITUDE_DEG: 54.7776799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'US000200',
        LOCATION_NAME: 'Usk',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9010957,
        LOCATION_LATITUDE_DEG: 51.7034989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'US000300',
        LOCATION_NAME: 'Uskavagh',
        COUNTY_NAME: 'Isle of Benbecula',
        POSTCODE: 'HS7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2520462,
        LOCATION_LATITUDE_DEG: 57.4593018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'US000400',
        LOCATION_NAME: 'Usselby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3487579,
        LOCATION_LATITUDE_DEG: 53.4274331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UT000100',
        LOCATION_NAME: 'Utkinton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.677185,
        LOCATION_LATITUDE_DEG: 53.1840411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UT000200',
        LOCATION_NAME: 'Utley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9178755,
        LOCATION_LATITUDE_DEG: 53.8812955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UT000300',
        LOCATION_NAME: 'Uton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6626175,
        LOCATION_LATITUDE_DEG: 50.7742133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UT000400',
        LOCATION_NAME: 'Utterby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.03014,
        LOCATION_LATITUDE_DEG: 53.4208217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UT000500',
        LOCATION_NAME: 'Uttoxeter',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8633841,
        LOCATION_LATITUDE_DEG: 52.8982021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UW000100',
        LOCATION_NAME: 'Uwch Mynydd',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7413234,
        LOCATION_LATITUDE_DEG: 52.800121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UX000100',
        LOCATION_NAME: 'Uxbridge',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.480059,
        LOCATION_LATITUDE_DEG: 51.544753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UY000100',
        LOCATION_NAME: 'Uyeasound',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9167209,
        LOCATION_LATITUDE_DEG: 60.689753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UZ000100',
        LOCATION_NAME: 'Uzmaston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9437238,
        LOCATION_LATITUDE_DEG: 51.79113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000100',
        LOCATION_NAME: 'Valasay',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8564867,
        LOCATION_LATITUDE_DEG: 58.2222805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000200',
        LOCATION_NAME: 'Vale',
        COUNTY_NAME: 'Guernsey',
        POSTCODE: 'GY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.565544,
        LOCATION_LATITUDE_DEG: 49.4840059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000300',
        LOCATION_NAME: 'Vale Mills',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2382311,
        LOCATION_LATITUDE_DEG: 50.2496827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000500',
        LOCATION_NAME: 'Valeswood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8777202,
        LOCATION_LATITUDE_DEG: 52.7710016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000600',
        LOCATION_NAME: 'Valley',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5609695,
        LOCATION_LATITUDE_DEG: 53.281266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001000',
        LOCATION_NAME: 'Valtos',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9533723,
        LOCATION_LATITUDE_DEG: 58.2258752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000900',
        LOCATION_NAME: 'Valtos',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.1593391,
        LOCATION_LATITUDE_DEG: 57.5951094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001200',
        LOCATION_NAME: 'Van',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5483235,
        LOCATION_LATITUDE_DEG: 52.4742263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001100',
        LOCATION_NAME: 'Van',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.205286,
        LOCATION_LATITUDE_DEG: 51.5724904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001300',
        LOCATION_NAME: 'Vange',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4887565,
        LOCATION_LATITUDE_DEG: 51.5596406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001400',
        LOCATION_NAME: 'Varteg',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0644347,
        LOCATION_LATITUDE_DEG: 51.7458992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001500',
        LOCATION_NAME: 'Vatersay',
        COUNTY_NAME: 'Isle of Barra',
        POSTCODE: 'HS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5371833,
        LOCATION_LATITUDE_DEG: 56.9170529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001600',
        LOCATION_NAME: 'Vatisker',
        COUNTY_NAME: 'Isle of Lewis',
        POSTCODE: 'HS2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2808461,
        LOCATION_LATITUDE_DEG: 58.2753753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001700',
        LOCATION_NAME: 'Vatten',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5197841,
        LOCATION_LATITUDE_DEG: 57.4029888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001800',
        LOCATION_NAME: 'Vaul',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8069338,
        LOCATION_LATITUDE_DEG: 56.5384096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA001900',
        LOCATION_NAME: 'Vauxhall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3913912,
        LOCATION_LATITUDE_DEG: 52.763695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA002000',
        LOCATION_NAME: 'Vauxhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.871649,
        LOCATION_LATITUDE_DEG: 52.4899622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA002300',
        LOCATION_NAME: 'Vauxhall',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1191126,
        LOCATION_LATITUDE_DEG: 51.4887162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA002100',
        LOCATION_NAME: 'Vaynol Park',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1964852,
        LOCATION_LATITUDE_DEG: 53.1969588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA002200',
        LOCATION_NAME: 'Vaynor',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3792873,
        LOCATION_LATITUDE_DEG: 51.7857098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000100',
        LOCATION_NAME: 'Veddw',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7220454,
        LOCATION_LATITUDE_DEG: 51.6857978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000200',
        LOCATION_NAME: 'Velator',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1657088,
        LOCATION_LATITUDE_DEG: 51.0993517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000400',
        LOCATION_NAME: 'Velindre',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.104285,
        LOCATION_LATITUDE_DEG: 51.8699278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000300',
        LOCATION_NAME: 'Velindre',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1879627,
        LOCATION_LATITUDE_DEG: 52.0220314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000500',
        LOCATION_NAME: 'Velindre Farchog',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7674445,
        LOCATION_LATITUDE_DEG: 52.0173508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000600',
        LOCATION_NAME: 'Vellow',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2917496,
        LOCATION_LATITUDE_DEG: 51.1416492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000700',
        LOCATION_NAME: 'Vellynsaundry',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3046308,
        LOCATION_LATITUDE_DEG: 50.195574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000800',
        LOCATION_NAME: 'Venn',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8235982,
        LOCATION_LATITUDE_DEG: 50.3067726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE000900',
        LOCATION_NAME: 'Venn Ottery',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3036591,
        LOCATION_LATITUDE_DEG: 50.7125096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001000',
        LOCATION_NAME: 'Vennington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9744609,
        LOCATION_LATITUDE_DEG: 52.6804895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001100',
        LOCATION_NAME: 'Venny Tedburn',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6768609,
        LOCATION_LATITUDE_DEG: 50.7556158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001200',
        LOCATION_NAME: 'Venterdon',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3168387,
        LOCATION_LATITUDE_DEG: 50.5487999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001300',
        LOCATION_NAME: 'Ventnor',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2061913,
        LOCATION_LATITUDE_DEG: 50.5941754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001400',
        LOCATION_NAME: 'Venton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9816115,
        LOCATION_LATITUDE_DEG: 50.3931852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001500',
        LOCATION_NAME: 'Ventonleague',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4004414,
        LOCATION_LATITUDE_DEG: 50.1923832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001700',
        LOCATION_NAME: 'Verney Junction',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9277155,
        LOCATION_LATITUDE_DEG: 51.9394961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001800',
        LOCATION_NAME: 'Vernham Dean',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5106267,
        LOCATION_LATITUDE_DEG: 51.3065391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001900',
        LOCATION_NAME: 'Vernham Street',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4977403,
        LOCATION_LATITUDE_DEG: 51.3146411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE002000',
        LOCATION_NAME: 'Vernolds Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7738172,
        LOCATION_LATITUDE_DEG: 52.4207684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE002100',
        LOCATION_NAME: 'Verrington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4203389,
        LOCATION_LATITUDE_DEG: 51.060128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE002200',
        LOCATION_NAME: 'Verwood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8751254,
        LOCATION_LATITUDE_DEG: 50.8807077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE002300',
        LOCATION_NAME: 'Veryan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.922286,
        LOCATION_LATITUDE_DEG: 50.2179753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE002400',
        LOCATION_NAME: 'Veryan Green',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9170898,
        LOCATION_LATITUDE_DEG: 50.2219745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000100',
        LOCATION_NAME: 'Vicarage',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1261315,
        LOCATION_LATITUDE_DEG: 50.6947077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000200',
        LOCATION_NAME: 'Vicarage Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3466252,
        LOCATION_LATITUDE_DEG: 51.0627943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000300',
        LOCATION_NAME: 'Vicars Cross',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8384414,
        LOCATION_LATITUDE_DEG: 53.1952421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000600',
        LOCATION_NAME: 'Vickerstown',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2557477,
        LOCATION_LATITUDE_DEG: 54.1062317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000700',
        LOCATION_NAME: 'Victoria',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8310477,
        LOCATION_LATITUDE_DEG: 50.419595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000800',
        LOCATION_NAME: 'Victoria',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1986942,
        LOCATION_LATITUDE_DEG: 51.7496064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002600',
        LOCATION_NAME: 'Victoria',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1477163,
        LOCATION_LATITUDE_DEG: 51.4949274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000900',
        LOCATION_NAME: 'Victoria Bridge',
        COUNTY_NAME: 'County Tyrone',
        POSTCODE: 'BT82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.4116422,
        LOCATION_LATITUDE_DEG: 54.7887387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002900',
        LOCATION_NAME: 'Victoria Docks',
        COUNTY_NAME: 'London',
        POSTCODE: 'E16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0156167,
        LOCATION_LATITUDE_DEG: 51.5090067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001000',
        LOCATION_NAME: 'Victoria Garesfield',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7719509,
        LOCATION_LATITUDE_DEG: 54.9159921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002700',
        LOCATION_NAME: 'Victoria Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001100',
        LOCATION_NAME: 'Victoria Park',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3323084,
        LOCATION_LATITUDE_DEG: 55.8766189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001200',
        LOCATION_NAME: 'Victoria Park',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2173219,
        LOCATION_LATITUDE_DEG: 51.4843794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002800',
        LOCATION_NAME: 'Victoria Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2167871,
        LOCATION_LATITUDE_DEG: 53.4575465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001300',
        LOCATION_NAME: 'Vidlin',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1323862,
        LOCATION_LATITUDE_DEG: 60.3703276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI003000',
        LOCATION_NAME: 'Viewforth',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2096591,
        LOCATION_LATITUDE_DEG: 55.938064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001400',
        LOCATION_NAME: 'Viewpark',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0491419,
        LOCATION_LATITUDE_DEG: 55.8289087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI990507',
        LOCATION_NAME: 'Vigo',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001500',
        LOCATION_NAME: 'Villa Real',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8203527,
        LOCATION_LATITUDE_DEG: 54.8621938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001700',
        LOCATION_NAME: 'Vines Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2686082,
        LOCATION_LATITUDE_DEG: 50.9375814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001800',
        LOCATION_NAME: 'Viney Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.502015,
        LOCATION_LATITUDE_DEG: 51.7549974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001900',
        LOCATION_NAME: 'Viney Woodside',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4927213,
        LOCATION_LATITUDE_DEG: 51.7570959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002100',
        LOCATION_NAME: 'Virginia Water',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5747097,
        LOCATION_LATITUDE_DEG: 51.4050362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002200',
        LOCATION_NAME: 'Virginstowe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2928847,
        LOCATION_LATITUDE_DEG: 50.7098934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002300',
        LOCATION_NAME: 'Virkie',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2984127,
        LOCATION_LATITUDE_DEG: 59.8835799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002400',
        LOCATION_NAME: 'Virley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8255012,
        LOCATION_LATITUDE_DEG: 51.7877544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002500',
        LOCATION_NAME: 'Vivod',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2115864,
        LOCATION_LATITUDE_DEG: 52.966735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VO000100',
        LOCATION_NAME: 'Voe',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2635884,
        LOCATION_LATITUDE_DEG: 60.3509223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VO000200',
        LOCATION_NAME: 'Vogue',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1840224,
        LOCATION_LATITUDE_DEG: 50.2367779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VO000300',
        LOCATION_NAME: 'Voguebeloth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.266234,
        LOCATION_LATITUDE_DEG: 50.2479806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VO000400',
        LOCATION_NAME: 'Vowchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.92914,
        LOCATION_LATITUDE_DEG: 52.0233319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VO000500',
        LOCATION_NAME: 'Voxmoor',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2233232,
        LOCATION_LATITUDE_DEG: 50.9558301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000100',
        LOCATION_NAME: 'Waberthwaite',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3708465,
        LOCATION_LATITUDE_DEG: 54.3308561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000200',
        LOCATION_NAME: 'Wackerfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.765061,
        LOCATION_LATITUDE_DEG: 54.6009635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000300',
        LOCATION_NAME: 'Wacton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2104791,
        LOCATION_LATITUDE_DEG: 52.4781169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000400',
        LOCATION_NAME: 'Wadborough',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1371504,
        LOCATION_LATITUDE_DEG: 52.1264261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000500',
        LOCATION_NAME: 'Wadbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9639927,
        LOCATION_LATITUDE_DEG: 50.8098083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000600',
        LOCATION_NAME: 'Waddesdon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9186024,
        LOCATION_LATITUDE_DEG: 51.845884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000700',
        LOCATION_NAME: 'Waddeton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5841662,
        LOCATION_LATITUDE_DEG: 50.3988823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000800',
        LOCATION_NAME: 'Waddicombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6189578,
        LOCATION_LATITUDE_DEG: 51.0305405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA000900',
        LOCATION_NAME: 'Waddingham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5195968,
        LOCATION_LATITUDE_DEG: 53.4533359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001000',
        LOCATION_NAME: 'Waddingham Sandhayes',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4978762,
        LOCATION_LATITUDE_DEG: 53.4431303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001200',
        LOCATION_NAME: 'Waddington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4129188,
        LOCATION_LATITUDE_DEG: 53.8904024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001100',
        LOCATION_NAME: 'Waddington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5403555,
        LOCATION_LATITUDE_DEG: 53.1659107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001300',
        LOCATION_NAME: 'Waddingworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2234111,
        LOCATION_LATITUDE_DEG: 53.2239128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001400',
        LOCATION_NAME: 'Waddock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.281944,
        LOCATION_LATITUDE_DEG: 50.7172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001600',
        LOCATION_NAME: 'Waddon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5321593,
        LOCATION_LATITUDE_DEG: 50.6686951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001500',
        LOCATION_NAME: 'Waddon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1096183,
        LOCATION_LATITUDE_DEG: 51.3716274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001700',
        LOCATION_NAME: 'Wadebridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8355969,
        LOCATION_LATITUDE_DEG: 50.5164001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001800',
        LOCATION_NAME: 'Wadeford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9783998,
        LOCATION_LATITUDE_DEG: 50.8892203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA001900',
        LOCATION_NAME: 'Wadenhoe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5128285,
        LOCATION_LATITUDE_DEG: 52.4415345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002000',
        LOCATION_NAME: 'Wadesmill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0291034,
        LOCATION_LATITUDE_DEG: 51.8388737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002100',
        LOCATION_NAME: 'Wadhurst',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3407652,
        LOCATION_LATITUDE_DEG: 51.0617965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002200',
        LOCATION_NAME: 'Wadshelf',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5262348,
        LOCATION_LATITUDE_DEG: 53.2343248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043000',
        LOCATION_NAME: 'Wadsley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5205719,
        LOCATION_LATITUDE_DEG: 53.4123994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043100',
        LOCATION_NAME: 'Wadsley Bridge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002300',
        LOCATION_NAME: 'Wadsworth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0026384,
        LOCATION_LATITUDE_DEG: 53.742093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002400',
        LOCATION_NAME: 'Wadwick',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3806194,
        LOCATION_LATITUDE_DEG: 51.274934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002500',
        LOCATION_NAME: 'Wadworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1412927,
        LOCATION_LATITUDE_DEG: 53.4657419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002600',
        LOCATION_NAME: 'Wadworth Bar',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1234375,
        LOCATION_LATITUDE_DEG: 53.45344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002700',
        LOCATION_NAME: 'Waen',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3336956,
        LOCATION_LATITUDE_DEG: 53.1825459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002800',
        LOCATION_NAME: 'Waen Pentir',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1300802,
        LOCATION_LATITUDE_DEG: 53.1725476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA002900',
        LOCATION_NAME: 'Waen Wen',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL57',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1261445,
        LOCATION_LATITUDE_DEG: 53.1967516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003000',
        LOCATION_NAME: 'Wagbeach',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9404218,
        LOCATION_LATITUDE_DEG: 52.6226822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003100',
        LOCATION_NAME: 'Wainfelin',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0499828,
        LOCATION_LATITUDE_DEG: 51.7048974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003200',
        LOCATION_NAME: 'Wainfleet',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2389683,
        LOCATION_LATITUDE_DEG: 53.1061947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041700',
        LOCATION_NAME: 'Wainfleet St Mary',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003300',
        LOCATION_NAME: 'Wainfleet St. Mary',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2409553,
        LOCATION_LATITUDE_DEG: 53.0969945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003400',
        LOCATION_NAME: 'Waingroves',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3865364,
        LOCATION_LATITUDE_DEG: 53.0416041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003500',
        LOCATION_NAME: 'Wainhouse Corner',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5769879,
        LOCATION_LATITUDE_DEG: 50.7300254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003600',
        LOCATION_NAME: 'Wainscott',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5140114,
        LOCATION_LATITUDE_DEG: 51.4120244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003700',
        LOCATION_NAME: 'Wainstalls',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.927989,
        LOCATION_LATITUDE_DEG: 53.7505841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003800',
        LOCATION_NAME: 'Waitby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3841526,
        LOCATION_LATITUDE_DEG: 54.4684587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA003900',
        LOCATION_NAME: 'Waithe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.06443,
        LOCATION_LATITUDE_DEG: 53.4863337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA044500',
        LOCATION_NAME: 'Wake Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004000',
        LOCATION_NAME: 'Wakefield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4961152,
        LOCATION_LATITUDE_DEG: 53.6823701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004100',
        LOCATION_NAME: 'Wakerley',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5902001,
        LOCATION_LATITUDE_DEG: 52.5841548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004200',
        LOCATION_NAME: 'Wakes Colne',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7580839,
        LOCATION_LATITUDE_DEG: 51.9241738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004300',
        LOCATION_NAME: 'Walberswick',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6527744,
        LOCATION_LATITUDE_DEG: 52.3134949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004400',
        LOCATION_NAME: 'Walberton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6184665,
        LOCATION_LATITUDE_DEG: 50.8435838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004500',
        LOCATION_NAME: 'Walbottle',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7341401,
        LOCATION_LATITUDE_DEG: 54.9929006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004600',
        LOCATION_NAME: 'Walby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8773669,
        LOCATION_LATITUDE_DEG: 54.9367128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004800',
        LOCATION_NAME: 'Walcot',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9595729,
        LOCATION_LATITUDE_DEG: 52.4598681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004700',
        LOCATION_NAME: 'Walcot',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6012636,
        LOCATION_LATITUDE_DEG: 52.7032892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA004900',
        LOCATION_NAME: 'Walcot',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4239111,
        LOCATION_LATITUDE_DEG: 52.9025787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005000',
        LOCATION_NAME: 'Walcot Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2813127,
        LOCATION_LATITUDE_DEG: 53.0981942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005100',
        LOCATION_NAME: 'Walcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8131816,
        LOCATION_LATITUDE_DEG: 52.2199322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005200',
        LOCATION_NAME: 'Walcote',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1637023,
        LOCATION_LATITUDE_DEG: 52.4475507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005300',
        LOCATION_NAME: 'Walcott',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3115165,
        LOCATION_LATITUDE_DEG: 53.0944008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005400',
        LOCATION_NAME: 'Walcott',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5040292,
        LOCATION_LATITUDE_DEG: 52.8410445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990658',
        LOCATION_NAME: 'Walden',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005500',
        LOCATION_NAME: 'Walden Stubbs',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1663402,
        LOCATION_LATITUDE_DEG: 53.643465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005600',
        LOCATION_NAME: 'Walderslade',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5257526,
        LOCATION_LATITUDE_DEG: 51.3471185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005800',
        LOCATION_NAME: 'Walderton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8755409,
        LOCATION_LATITUDE_DEG: 50.8897934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005900',
        LOCATION_NAME: 'Walditch',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7322642,
        LOCATION_LATITUDE_DEG: 50.7309986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006000',
        LOCATION_NAME: 'Waldridge',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6094357,
        LOCATION_LATITUDE_DEG: 54.8458897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006100',
        LOCATION_NAME: 'Waldringfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3313312,
        LOCATION_LATITUDE_DEG: 52.052072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006200',
        LOCATION_NAME: 'Waldron',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2061027,
        LOCATION_LATITUDE_DEG: 50.9517859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006300',
        LOCATION_NAME: 'Wales',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2826754,
        LOCATION_LATITUDE_DEG: 53.3408349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006400',
        LOCATION_NAME: 'Wales Bar',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2932769,
        LOCATION_LATITUDE_DEG: 53.340134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006600',
        LOCATION_NAME: 'Walesby',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9758639,
        LOCATION_LATITUDE_DEG: 53.2273245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006500',
        LOCATION_NAME: 'Walesby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2939524,
        LOCATION_LATITUDE_DEG: 53.4153254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006700',
        LOCATION_NAME: 'Walesby Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3779656,
        LOCATION_LATITUDE_DEG: 53.4087284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007100',
        LOCATION_NAME: 'Walford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.896348,
        LOCATION_LATITUDE_DEG: 52.3472612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007000',
        LOCATION_NAME: 'Walford',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8364438,
        LOCATION_LATITUDE_DEG: 52.7800029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006900',
        LOCATION_NAME: 'Walford',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5997832,
        LOCATION_LATITUDE_DEG: 51.8879824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA006800',
        LOCATION_NAME: 'Walford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9848134,
        LOCATION_LATITUDE_DEG: 50.8045984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007200',
        LOCATION_NAME: 'Walford Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0315988,
        LOCATION_LATITUDE_DEG: 51.0463397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007300',
        LOCATION_NAME: 'Walford Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8145314,
        LOCATION_LATITUDE_DEG: 52.7721985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007400',
        LOCATION_NAME: 'Walgherton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4507142,
        LOCATION_LATITUDE_DEG: 53.0366232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007500',
        LOCATION_NAME: 'Walgrave',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8232722,
        LOCATION_LATITUDE_DEG: 52.3402338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007600',
        LOCATION_NAME: 'Walham',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2529536,
        LOCATION_LATITUDE_DEG: 51.8777023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007700',
        LOCATION_NAME: 'Walhampton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5300679,
        LOCATION_LATITUDE_DEG: 50.7663922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007800',
        LOCATION_NAME: 'Walk Mill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2050971,
        LOCATION_LATITUDE_DEG: 53.7659904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA007900',
        LOCATION_NAME: 'Walkden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3972434,
        LOCATION_LATITUDE_DEG: 53.5234706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008000',
        LOCATION_NAME: 'Walker',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5525132,
        LOCATION_LATITUDE_DEG: 54.9749956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008100',
        LOCATION_NAME: 'Walker Barn',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0666572,
        LOCATION_LATITUDE_DEG: 53.2604371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008200',
        LOCATION_NAME: 'Walkerburn',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0183483,
        LOCATION_LATITUDE_DEG: 55.6239781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008300',
        LOCATION_NAME: 'Walkergate',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5573148,
        LOCATION_LATITUDE_DEG: 54.9844949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008400',
        LOCATION_NAME: 'Walkeringham',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8413342,
        LOCATION_LATITUDE_DEG: 53.4210372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008500',
        LOCATION_NAME: 'Walkerith',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8136447,
        LOCATION_LATITUDE_DEG: 53.427436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008600',
        LOCATION_NAME: 'Walkern',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1249414,
        LOCATION_LATITUDE_DEG: 51.920785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA044700',
        LOCATION_NAME: 'Walkers Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.926948,
        LOCATION_LATITUDE_DEG: 52.4067431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008700',
        LOCATION_NAME: 'Walkerville',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5451209,
        LOCATION_LATITUDE_DEG: 54.9875954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008800',
        LOCATION_NAME: 'Walkford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6880138,
        LOCATION_LATITUDE_DEG: 50.7483946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA008900',
        LOCATION_NAME: 'Walkhampton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0692818,
        LOCATION_LATITUDE_DEG: 50.5075977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009000',
        LOCATION_NAME: 'Walkington',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4857131,
        LOCATION_LATITUDE_DEG: 53.8201693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009200',
        LOCATION_NAME: 'Walkley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.50055,
        LOCATION_LATITUDE_DEG: 53.3927468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009300',
        LOCATION_NAME: 'Walkmills',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7899708,
        LOCATION_LATITUDE_DEG: 52.589579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009400',
        LOCATION_NAME: 'Wall',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.131014,
        LOCATION_LATITUDE_DEG: 55.0142046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009500',
        LOCATION_NAME: 'Wall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.849505,
        LOCATION_LATITUDE_DEG: 52.6554761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009600',
        LOCATION_NAME: 'Wall Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1700698,
        LOCATION_LATITUDE_DEG: 52.5066688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009700',
        LOCATION_NAME: 'Wall Meadow',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1785851,
        LOCATION_LATITUDE_DEG: 52.2112413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042100',
        LOCATION_NAME: 'Wall under Heywood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009900',
        LOCATION_NAME: 'Wallabrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1274222,
        LOCATION_LATITUDE_DEG: 50.559603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010000',
        LOCATION_NAME: 'Wallacestone',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7321088,
        LOCATION_LATITUDE_DEG: 55.9746238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010100',
        LOCATION_NAME: 'Wallasea Island',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8009766,
        LOCATION_LATITUDE_DEG: 51.6193405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010200',
        LOCATION_NAME: 'Wallasey',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0428713,
        LOCATION_LATITUDE_DEG: 53.4191647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010300',
        LOCATION_NAME: 'Wallaston Five Cross',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0044781,
        LOCATION_LATITUDE_DEG: 51.6716131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010400',
        LOCATION_NAME: 'Wallbridge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2187959,
        LOCATION_LATITUDE_DEG: 51.7425933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010500',
        LOCATION_NAME: 'Wallbrook',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0831697,
        LOCATION_LATITUDE_DEG: 52.5411701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010600',
        LOCATION_NAME: 'Wallcrouch',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3798231,
        LOCATION_LATITUDE_DEG: 51.0462919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010700',
        LOCATION_NAME: 'Wallingford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1233137,
        LOCATION_LATITUDE_DEG: 51.5996672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010800',
        LOCATION_NAME: 'Wallington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9544101,
        LOCATION_LATITUDE_DEG: 55.1520208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA010900',
        LOCATION_NAME: 'Wallington',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1482611,
        LOCATION_LATITUDE_DEG: 51.3594286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011000',
        LOCATION_NAME: 'Wallington',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1167151,
        LOCATION_LATITUDE_DEG: 51.9855919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011100',
        LOCATION_NAME: 'Wallingwells',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1375741,
        LOCATION_LATITUDE_DEG: 53.3488375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011200',
        LOCATION_NAME: 'Wallis',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8859053,
        LOCATION_LATITUDE_DEG: 51.8934398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011300',
        LOCATION_NAME: 'Walliswood',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4011651,
        LOCATION_LATITUDE_DEG: 51.1304159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011400',
        LOCATION_NAME: 'Walls',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5604888,
        LOCATION_LATITUDE_DEG: 60.2287168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011500',
        LOCATION_NAME: 'Walls Quarry',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1968935,
        LOCATION_LATITUDE_DEG: 51.7156915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011600',
        LOCATION_NAME: 'Wallsend',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.532062,
        LOCATION_LATITUDE_DEG: 54.990997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009800',
        LOCATION_NAME: 'Wall-under-Heywood',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7233732,
        LOCATION_LATITUDE_DEG: 52.5284786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011700',
        LOCATION_NAME: 'Wallyford',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0122313,
        LOCATION_LATITUDE_DEG: 55.9382087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011800',
        LOCATION_NAME: 'Walmer',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3908096,
        LOCATION_LATITUDE_DEG: 51.2005918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA011900',
        LOCATION_NAME: 'Walmer Bridge',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7908101,
        LOCATION_LATITUDE_DEG: 53.7126868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012000',
        LOCATION_NAME: 'Walmersley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2947321,
        LOCATION_LATITUDE_DEG: 53.6203761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012100',
        LOCATION_NAME: 'Walmley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7987602,
        LOCATION_LATITUDE_DEG: 52.5401652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012200',
        LOCATION_NAME: 'Walmore Common',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3807996,
        LOCATION_LATITUDE_DEG: 51.8342054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012300',
        LOCATION_NAME: 'Walmsgate',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0406583,
        LOCATION_LATITUDE_DEG: 53.2776147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012400',
        LOCATION_NAME: 'Walney',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2462591,
        LOCATION_LATITUDE_DEG: 54.0882351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012500',
        LOCATION_NAME: 'Walnut Tree',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6918452,
        LOCATION_LATITUDE_DEG: 52.0194991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012700',
        LOCATION_NAME: 'Walpole',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9916058,
        LOCATION_LATITUDE_DEG: 51.1677459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012600',
        LOCATION_NAME: 'Walpole',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4736764,
        LOCATION_LATITUDE_DEG: 52.3179953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012800',
        LOCATION_NAME: 'Walpole Cross Keys',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2489916,
        LOCATION_LATITUDE_DEG: 52.755759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA012900',
        LOCATION_NAME: 'Walpole Highway',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2456302,
        LOCATION_LATITUDE_DEG: 52.7013553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041800',
        LOCATION_NAME: 'Walpole St Andrew',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041900',
        LOCATION_NAME: 'Walpole St Peter',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013000',
        LOCATION_NAME: 'Walpole St. Andrew',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2239952,
        LOCATION_LATITUDE_DEG: 52.7352602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013100',
        LOCATION_NAME: 'Walpole St. Peter',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2238562,
        LOCATION_LATITUDE_DEG: 52.7284555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013200',
        LOCATION_NAME: 'Walrow',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.940888,
        LOCATION_LATITUDE_DEG: 51.2165485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013300',
        LOCATION_NAME: 'Walsall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9817705,
        LOCATION_LATITUDE_DEG: 52.5836709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013400',
        LOCATION_NAME: 'Walsall Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9295224,
        LOCATION_LATITUDE_DEG: 52.6267713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013500',
        LOCATION_NAME: 'Walsden',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.098814,
        LOCATION_LATITUDE_DEG: 53.6939784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013600',
        LOCATION_NAME: 'Walsgrave',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4355801,
        LOCATION_LATITUDE_DEG: 52.429452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042200',
        LOCATION_NAME: 'Walsham le Willows',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013800',
        LOCATION_NAME: 'Walsham-le-Willows',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9325523,
        LOCATION_LATITUDE_DEG: 52.3019032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014000',
        LOCATION_NAME: 'Walshaw',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3388258,
        LOCATION_LATITUDE_DEG: 53.6019751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013900',
        LOCATION_NAME: 'Walshaw',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0394439,
        LOCATION_LATITUDE_DEG: 53.7782855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014100',
        LOCATION_NAME: 'Walshford',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3655325,
        LOCATION_LATITUDE_DEG: 53.9756942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014300',
        LOCATION_NAME: 'Walsingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8755861,
        LOCATION_LATITUDE_DEG: 52.8940622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014400',
        LOCATION_NAME: 'Walsoken',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1817922,
        LOCATION_LATITUDE_DEG: 52.6715509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014500',
        LOCATION_NAME: 'Walstead',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0661026,
        LOCATION_LATITUDE_DEG: 51.0028972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014600',
        LOCATION_NAME: 'Walters Ash',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7864339,
        LOCATION_LATITUDE_DEG: 51.6730702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014700',
        LOCATION_NAME: 'Walterston',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3296151,
        LOCATION_LATITUDE_DEG: 51.4348759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014800',
        LOCATION_NAME: 'Walterstone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9592642,
        LOCATION_LATITUDE_DEG: 51.9188182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015000',
        LOCATION_NAME: 'Waltham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0980559,
        LOCATION_LATITUDE_DEG: 53.5164358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015100',
        LOCATION_NAME: 'Waltham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0181515,
        LOCATION_LATITUDE_DEG: 51.1975024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015200',
        LOCATION_NAME: 'Waltham Abbey',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'EN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0025838,
        LOCATION_LATITUDE_DEG: 51.6867619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015300',
        LOCATION_NAME: 'Waltham Chase',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1996728,
        LOCATION_LATITUDE_DEG: 50.9311022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015400',
        LOCATION_NAME: 'Waltham Cross',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0291813,
        LOCATION_LATITUDE_DEG: 51.6853586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015600',
        LOCATION_NAME: 'Waltham on the Wolds',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8094954,
        LOCATION_LATITUDE_DEG: 52.8171775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042000',
        LOCATION_NAME: 'Waltham St Lawrence',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015500',
        LOCATION_NAME: 'Waltham St. Lawrence',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8051867,
        LOCATION_LATITUDE_DEG: 51.4845479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043900',
        LOCATION_NAME: 'Walthamstow',
        COUNTY_NAME: 'London',
        POSTCODE: 'E17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0186228,
        LOCATION_LATITUDE_DEG: 51.5874663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990522',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016900',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0883676,
        LOCATION_LATITUDE_DEG: 52.23015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016800',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9658091,
        LOCATION_LATITUDE_DEG: 53.4485626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016400',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7838449,
        LOCATION_LATITUDE_DEG: 52.4098678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015800',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.769942,
        LOCATION_LATITUDE_DEG: 51.1230368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016500',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7475751,
        LOCATION_LATITUDE_DEG: 54.972416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016200',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6068911,
        LOCATION_LATITUDE_DEG: 52.7610981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016700',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6018533,
        LOCATION_LATITUDE_DEG: 53.3661502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA044400',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0619291,
        LOCATION_LATITUDE_DEG: 52.7881584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015700',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5821322,
        LOCATION_LATITUDE_DEG: 52.1766308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016000',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4637048,
        LOCATION_LATITUDE_DEG: 53.6482676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA015900',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4606371,
        LOCATION_LATITUDE_DEG: 53.2247234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016600',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3272357,
        LOCATION_LATITUDE_DEG: 53.9240959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016100',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1225475,
        LOCATION_LATITUDE_DEG: 52.4791537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA016300',
        LOCATION_NAME: 'Walton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7005204,
        LOCATION_LATITUDE_DEG: 52.0204044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017000',
        LOCATION_NAME: 'Walton Bay',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8219862,
        LOCATION_LATITUDE_DEG: 51.4658744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017100',
        LOCATION_NAME: 'Walton Cardiff',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1344278,
        LOCATION_LATITUDE_DEG: 51.988614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017200',
        LOCATION_NAME: 'Walton East',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8767355,
        LOCATION_LATITUDE_DEG: 51.8739303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017300',
        LOCATION_NAME: 'Walton Hall',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7062674,
        LOCATION_LATITUDE_DEG: 52.024802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017400',
        LOCATION_NAME: 'Walton Highway',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2077946,
        LOCATION_LATITUDE_DEG: 52.6943507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042300',
        LOCATION_NAME: 'Walton in Gordano',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042400',
        LOCATION_NAME: 'Walton le Dale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042500',
        LOCATION_NAME: 'Walton on Thames',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017500',
        LOCATION_NAME: 'Walton On The Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2456907,
        LOCATION_LATITUDE_DEG: 51.2822245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017800',
        LOCATION_NAME: 'Walton on the Naze',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2694484,
        LOCATION_LATITUDE_DEG: 51.8478588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017900',
        LOCATION_NAME: 'Walton on the Wolds',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1214238,
        LOCATION_LATITUDE_DEG: 52.772281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042600',
        LOCATION_NAME: 'Walton on Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017600',
        LOCATION_NAME: 'Walton Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6994411,
        LOCATION_LATITUDE_DEG: 52.0154018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA017700',
        LOCATION_NAME: 'Walton West',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0936891,
        LOCATION_LATITUDE_DEG: 51.7760235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018000',
        LOCATION_NAME: 'Walton-in-Gordano',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8338057,
        LOCATION_LATITUDE_DEG: 51.4516093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018100',
        LOCATION_NAME: 'Walton-le-Dale',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6843986,
        LOCATION_LATITUDE_DEG: 53.7431954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018200',
        LOCATION_NAME: 'Walton-on-Thames',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4158603,
        LOCATION_LATITUDE_DEG: 51.3826353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990204',
        LOCATION_NAME: 'Walton-on-the-Hill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018300',
        LOCATION_NAME: 'Walton-on-Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6784714,
        LOCATION_LATITUDE_DEG: 52.7604885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018400',
        LOCATION_NAME: 'Walworth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6435673,
        LOCATION_LATITUDE_DEG: 54.5653623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043200',
        LOCATION_NAME: 'Walworth',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0902932,
        LOCATION_LATITUDE_DEG: 51.4881964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018500',
        LOCATION_NAME: 'Walworth Gate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6377048,
        LOCATION_LATITUDE_DEG: 54.5758607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018700',
        LOCATION_NAME: 'Walwyns Castle',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0825289,
        LOCATION_LATITUDE_DEG: 51.7571752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018800',
        LOCATION_NAME: 'Wambrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0063256,
        LOCATION_LATITUDE_DEG: 50.8674159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA018900',
        LOCATION_NAME: 'Wamphray',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3994682,
        LOCATION_LATITUDE_DEG: 55.2369035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019000',
        LOCATION_NAME: 'Wanborough',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6971536,
        LOCATION_LATITUDE_DEG: 51.542067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019100',
        LOCATION_NAME: 'Wanborough',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6611307,
        LOCATION_LATITUDE_DEG: 51.2309284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019200',
        LOCATION_NAME: 'Wandon End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3591744,
        LOCATION_LATITUDE_DEG: 51.8887806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019300',
        LOCATION_NAME: 'Wandon Green',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3330101,
        LOCATION_LATITUDE_DEG: 51.8676843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043400',
        LOCATION_NAME: 'Wandsworth',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1877189,
        LOCATION_LATITUDE_DEG: 51.4529951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043300',
        LOCATION_NAME: 'Wandsworth',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1665145,
        LOCATION_LATITUDE_DEG: 51.4321778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019500',
        LOCATION_NAME: 'Wangford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6254934,
        LOCATION_LATITUDE_DEG: 52.3540978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019600',
        LOCATION_NAME: 'Wanlip',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1122299,
        LOCATION_LATITUDE_DEG: 52.6914742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019700',
        LOCATION_NAME: 'Wanlockhead',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7753995,
        LOCATION_LATITUDE_DEG: 55.3967677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019900',
        LOCATION_NAME: 'Wansford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.415978,
        LOCATION_LATITUDE_DEG: 52.5804507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA019800',
        LOCATION_NAME: 'Wansford',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3798449,
        LOCATION_LATITUDE_DEG: 53.9908895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043800',
        LOCATION_NAME: 'Wanstead',
        COUNTY_NAME: 'London',
        POSTCODE: 'E11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1877189,
        LOCATION_LATITUDE_DEG: 51.4529951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020000',
        LOCATION_NAME: 'Wanstrow',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4088541,
        LOCATION_LATITUDE_DEG: 51.1738421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020100',
        LOCATION_NAME: 'Wanswell',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4587705,
        LOCATION_LATITUDE_DEG: 51.7111932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020200',
        LOCATION_NAME: 'Wantage',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4242836,
        LOCATION_LATITUDE_DEG: 51.5880673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990681',
        LOCATION_NAME: 'Waplington',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020300',
        LOCATION_NAME: 'Wappenbury',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4443018,
        LOCATION_LATITUDE_DEG: 52.3218407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020400',
        LOCATION_NAME: 'Wappenham',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0871895,
        LOCATION_LATITUDE_DEG: 52.1061133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020500',
        LOCATION_NAME: 'Wappenshall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5055547,
        LOCATION_LATITUDE_DEG: 52.7233897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043700',
        LOCATION_NAME: 'Wapping',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0558955,
        LOCATION_LATITUDE_DEG: 51.504692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020600',
        LOCATION_NAME: 'Warblebank',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.11331,
        LOCATION_LATITUDE_DEG: 54.8035025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020700',
        LOCATION_NAME: 'Warbleton',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2923226,
        LOCATION_LATITUDE_DEG: 50.93898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020800',
        LOCATION_NAME: 'Warborough',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1351148,
        LOCATION_LATITUDE_DEG: 51.6374695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA020900',
        LOCATION_NAME: 'Warboys',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0796071,
        LOCATION_LATITUDE_DEG: 52.403027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021000',
        LOCATION_NAME: 'Warbstow',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5376056,
        LOCATION_LATITUDE_DEG: 50.688422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021100',
        LOCATION_NAME: 'Warcop',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3891887,
        LOCATION_LATITUDE_DEG: 54.5340642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021300',
        LOCATION_NAME: 'Ward End',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8304768,
        LOCATION_LATITUDE_DEG: 52.4909623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021400',
        LOCATION_NAME: 'Warden',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1354627,
        LOCATION_LATITUDE_DEG: 54.9931067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021500',
        LOCATION_NAME: 'Warden',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9104295,
        LOCATION_LATITUDE_DEG: 51.4061189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021600',
        LOCATION_NAME: 'Wardhouse',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7035452,
        LOCATION_LATITUDE_DEG: 57.3589479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA045100',
        LOCATION_NAME: 'Wardie',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2155136,
        LOCATION_LATITUDE_DEG: 55.9767295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021700',
        LOCATION_NAME: 'Wardington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2835781,
        LOCATION_LATITUDE_DEG: 52.1137194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021800',
        LOCATION_NAME: 'Wardle',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5811454,
        LOCATION_LATITUDE_DEG: 53.1097325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021900',
        LOCATION_NAME: 'Wardle',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.131517,
        LOCATION_LATITUDE_DEG: 53.6460794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022000',
        LOCATION_NAME: 'Wardley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3552413,
        LOCATION_LATITUDE_DEG: 53.5211666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022200',
        LOCATION_NAME: 'Wardley',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5378348,
        LOCATION_LATITUDE_DEG: 54.9510973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990146',
        LOCATION_NAME: 'Wardley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7767685,
        LOCATION_LATITUDE_DEG: 52.5965871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022100',
        LOCATION_NAME: 'Wardley',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7740778,
        LOCATION_LATITUDE_DEG: 52.5940597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022300',
        LOCATION_NAME: 'Wardley Colliery',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5113165,
        LOCATION_LATITUDE_DEG: 54.9397953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022400',
        LOCATION_NAME: 'Wardlow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7286383,
        LOCATION_LATITUDE_DEG: 53.2714382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022500',
        LOCATION_NAME: 'Wardon Hill',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4478604,
        LOCATION_LATITUDE_DEG: 50.7301983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022600',
        LOCATION_NAME: 'Wardpark East',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9515417,
        LOCATION_LATITUDE_DEG: 55.9770246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022700',
        LOCATION_NAME: 'Wardpark North',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9634432,
        LOCATION_LATITUDE_DEG: 55.974328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022800',
        LOCATION_NAME: 'Wardpark South',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9582755,
        LOCATION_LATITUDE_DEG: 55.96722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA022900',
        LOCATION_NAME: 'Wardy Hill',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1620743,
        LOCATION_LATITUDE_DEG: 52.4162266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023100',
        LOCATION_NAME: 'Ware',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9550064,
        LOCATION_LATITUDE_DEG: 50.7199074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023000',
        LOCATION_NAME: 'Ware',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0275051,
        LOCATION_LATITUDE_DEG: 51.8096728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023200',
        LOCATION_NAME: 'Wareham',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1094635,
        LOCATION_LATITUDE_DEG: 50.6859934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023300',
        LOCATION_NAME: 'Warehorne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8395998,
        LOCATION_LATITUDE_DEG: 51.0572839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023400',
        LOCATION_NAME: 'Warehouse Hill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9262008,
        LOCATION_LATITUDE_DEG: 53.602459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023500',
        LOCATION_NAME: 'Waren Mill',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7692052,
        LOCATION_LATITUDE_DEG: 55.6028617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023600',
        LOCATION_NAME: 'Warenford',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7831095,
        LOCATION_LATITUDE_DEG: 55.5511524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023700',
        LOCATION_NAME: 'Wareside',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0239888,
        LOCATION_LATITUDE_DEG: 51.8210734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023800',
        LOCATION_NAME: 'Waresley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2297511,
        LOCATION_LATITUDE_DEG: 52.3265477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA023900',
        LOCATION_NAME: 'Waresley',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1719868,
        LOCATION_LATITUDE_DEG: 52.174609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024000',
        LOCATION_NAME: 'Warfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7265062,
        LOCATION_LATITUDE_DEG: 51.4413446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024100',
        LOCATION_NAME: 'Warfield Park',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7200693,
        LOCATION_LATITUDE_DEG: 51.4255455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024200',
        LOCATION_NAME: 'Wargrave',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8629708,
        LOCATION_LATITUDE_DEG: 51.4997539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024300',
        LOCATION_NAME: 'Warham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8992489,
        LOCATION_LATITUDE_DEG: 52.937069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990432',
        LOCATION_NAME: 'Waringsford',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024400',
        LOCATION_NAME: 'Waringstown',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.2989384,
        LOCATION_LATITUDE_DEG: 54.4165899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024500',
        LOCATION_NAME: 'Wark',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'TD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2766471,
        LOCATION_LATITUDE_DEG: 55.6404735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024600',
        LOCATION_NAME: 'Wark',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2188871,
        LOCATION_LATITUDE_DEG: 55.0876202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024700',
        LOCATION_NAME: 'Warkleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9339405,
        LOCATION_LATITUDE_DEG: 50.9895398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024800',
        LOCATION_NAME: 'Warkton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6878547,
        LOCATION_LATITUDE_DEG: 52.4083407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025000',
        LOCATION_NAME: 'Warkworth',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.608048,
        LOCATION_LATITUDE_DEG: 55.3490307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA024900',
        LOCATION_NAME: 'Warkworth',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2883922,
        LOCATION_LATITUDE_DEG: 52.0590156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025100',
        LOCATION_NAME: 'Warlaby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4629561,
        LOCATION_LATITUDE_DEG: 54.3175296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025200',
        LOCATION_NAME: 'Warleggan',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5986778,
        LOCATION_LATITUDE_DEG: 50.4910954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025300',
        LOCATION_NAME: 'Warleigh',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3009245,
        LOCATION_LATITUDE_DEG: 51.3926601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025400',
        LOCATION_NAME: 'Warley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3082412,
        LOCATION_LATITUDE_DEG: 51.6006483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025500',
        LOCATION_NAME: 'Warlingham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0531862,
        LOCATION_LATITUDE_DEG: 51.309023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025600',
        LOCATION_NAME: 'Warmfield',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4306386,
        LOCATION_LATITUDE_DEG: 53.6824722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025700',
        LOCATION_NAME: 'Warmingham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4354595,
        LOCATION_LATITUDE_DEG: 53.1464318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025800',
        LOCATION_NAME: 'Warmington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4018446,
        LOCATION_LATITUDE_DEG: 52.1240177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA025900',
        LOCATION_NAME: 'Warmington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4123564,
        LOCATION_LATITUDE_DEG: 52.5078473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026000',
        LOCATION_NAME: 'Warminster',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1773245,
        LOCATION_LATITUDE_DEG: 51.2038382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026100',
        LOCATION_NAME: 'Warmley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4878294,
        LOCATION_LATITUDE_DEG: 51.4638738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026200',
        LOCATION_NAME: 'Warmsworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1808897,
        LOCATION_LATITUDE_DEG: 53.497547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026300',
        LOCATION_NAME: 'Warmwell',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3499563,
        LOCATION_LATITUDE_DEG: 50.6712913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026400',
        LOCATION_NAME: 'Warndon',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1670947,
        LOCATION_LATITUDE_DEG: 52.2111412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026500',
        LOCATION_NAME: 'Warnford',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1141051,
        LOCATION_LATITUDE_DEG: 51.0033051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026600',
        LOCATION_NAME: 'Warnham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3450015,
        LOCATION_LATITUDE_DEG: 51.0909068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026700',
        LOCATION_NAME: 'Warnicombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4564386,
        LOCATION_LATITUDE_DEG: 50.895522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026800',
        LOCATION_NAME: 'Warningcamp',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5328569,
        LOCATION_LATITUDE_DEG: 50.8541861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA026900',
        LOCATION_NAME: 'Warninglid',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.217579,
        LOCATION_LATITUDE_DEG: 51.0203002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027000',
        LOCATION_NAME: 'Warrbridge',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3643405,
        LOCATION_LATITUDE_DEG: 50.9256139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027100',
        LOCATION_NAME: 'Warren',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9884192,
        LOCATION_LATITUDE_DEG: 51.6382106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027200',
        LOCATION_NAME: 'Warren Row',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8281715,
        LOCATION_LATITUDE_DEG: 51.518953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027300',
        LOCATION_NAME: 'Warren Street',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.761644,
        LOCATION_LATITUDE_DEG: 51.2444107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027400',
        LOCATION_NAME: 'Warrenby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0983893,
        LOCATION_LATITUDE_DEG: 54.6165564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA045200',
        LOCATION_NAME: 'Warrender Park',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.197264,
        LOCATION_LATITUDE_DEG: 55.9395421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027500',
        LOCATION_NAME: 'Warrenpoint',
        COUNTY_NAME: 'County Down',
        POSTCODE: 'BT34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.254331,
        LOCATION_LATITUDE_DEG: 54.1059675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027600',
        LOCATION_NAME: 'Warrens Cross',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7149492,
        LOCATION_LATITUDE_DEG: 51.6965821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027800',
        LOCATION_NAME: 'Warrington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5919791,
        LOCATION_LATITUDE_DEG: 53.3889527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027700',
        LOCATION_NAME: 'Warrington',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6861945,
        LOCATION_LATITUDE_DEG: 52.183813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA027900',
        LOCATION_NAME: 'Warrington Batch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8381788,
        LOCATION_LATITUDE_DEG: 51.2389487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028000',
        LOCATION_NAME: 'Warriston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1958613,
        LOCATION_LATITUDE_DEG: 55.9709187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028100',
        LOCATION_NAME: 'Warsash',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2852344,
        LOCATION_LATITUDE_DEG: 50.854897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028200',
        LOCATION_NAME: 'Warslow',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.869199,
        LOCATION_LATITUDE_DEG: 53.1244203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028300',
        LOCATION_NAME: 'Warsop',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1532418,
        LOCATION_LATITUDE_DEG: 53.2245182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028400',
        LOCATION_NAME: 'Warsop Vale',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1766651,
        LOCATION_LATITUDE_DEG: 53.2053175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA044600',
        LOCATION_NAME: 'Warstock',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8707259,
        LOCATION_LATITUDE_DEG: 52.4129168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028500',
        LOCATION_NAME: 'Warstone',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1747854,
        LOCATION_LATITUDE_DEG: 52.5661999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028600',
        LOCATION_NAME: 'Warter',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6777106,
        LOCATION_LATITUDE_DEG: 53.9420824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028700',
        LOCATION_NAME: 'Warthermarske',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6825437,
        LOCATION_LATITUDE_DEG: 54.2064201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028800',
        LOCATION_NAME: 'Warthill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9699262,
        LOCATION_LATITUDE_DEG: 53.9883976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA028900',
        LOCATION_NAME: 'Wartling',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3559098,
        LOCATION_LATITUDE_DEG: 50.8582792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029000',
        LOCATION_NAME: 'Wartnaby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9440509,
        LOCATION_LATITUDE_DEG: 52.8019795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029300',
        LOCATION_NAME: 'Warton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.891898,
        LOCATION_LATITUDE_DEG: 53.7498944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029200',
        LOCATION_NAME: 'Warton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7677882,
        LOCATION_LATITUDE_DEG: 54.144833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029100',
        LOCATION_NAME: 'Warton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3404832,
        LOCATION_LATITUDE_DEG: 52.8002999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029350',
        LOCATION_NAME: 'Warton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5819793,
        LOCATION_LATITUDE_DEG: 52.6299478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029400',
        LOCATION_NAME: 'Warwick',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5829346,
        LOCATION_LATITUDE_DEG: 52.2815369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029500',
        LOCATION_NAME: 'Warwick Bridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8123831,
        LOCATION_LATITUDE_DEG: 54.9058066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042700',
        LOCATION_NAME: 'Warwick on Eden',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029600',
        LOCATION_NAME: 'Warwick Wold',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1152235,
        LOCATION_LATITUDE_DEG: 51.2648169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029700',
        LOCATION_NAME: 'Warwick-on-Eden',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8343396,
        LOCATION_LATITUDE_DEG: 54.9010022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029800',
        LOCATION_NAME: 'Wasdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5061411,
        LOCATION_LATITUDE_DEG: 54.4226671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA029900',
        LOCATION_NAME: 'Wasdale Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2550733,
        LOCATION_LATITUDE_DEG: 54.4649705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030000',
        LOCATION_NAME: 'Wash Water',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3558363,
        LOCATION_LATITUDE_DEG: 51.3656466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030100',
        LOCATION_NAME: 'Washaway',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7669405,
        LOCATION_LATITUDE_DEG: 50.493503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030200',
        LOCATION_NAME: 'Washbourne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.692134,
        LOCATION_LATITUDE_DEG: 50.380784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030400',
        LOCATION_NAME: 'Washbrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8297715,
        LOCATION_LATITUDE_DEG: 51.2470484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030300',
        LOCATION_NAME: 'Washbrook',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0886581,
        LOCATION_LATITUDE_DEG: 52.036777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030500',
        LOCATION_NAME: 'Washfield',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5134256,
        LOCATION_LATITUDE_DEG: 50.9271306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030600',
        LOCATION_NAME: 'Washford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3590031,
        LOCATION_LATITUDE_DEG: 51.1606549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030700',
        LOCATION_NAME: 'Washford Pyne',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6866722,
        LOCATION_LATITUDE_DEG: 50.8915316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030800',
        LOCATION_NAME: 'Washingborough',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4730892,
        LOCATION_LATITUDE_DEG: 53.2228154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031000',
        LOCATION_NAME: 'Washington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5292077,
        LOCATION_LATITUDE_DEG: 54.9022894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA030900',
        LOCATION_NAME: 'Washington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4036501,
        LOCATION_LATITUDE_DEG: 50.9037927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031100',
        LOCATION_NAME: 'Washpool',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8412676,
        LOCATION_LATITUDE_DEG: 51.5745703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031200',
        LOCATION_NAME: 'Washwood Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.84552,
        LOCATION_LATITUDE_DEG: 52.4939589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031300',
        LOCATION_NAME: 'Waskerley',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9251122,
        LOCATION_LATITUDE_DEG: 54.8066891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031400',
        LOCATION_NAME: 'Wasperton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6125328,
        LOCATION_LATITUDE_DEG: 52.2261337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031500',
        LOCATION_NAME: 'Wass',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1493077,
        LOCATION_LATITUDE_DEG: 54.2066128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990871',
        LOCATION_NAME: 'Wassand',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031600',
        LOCATION_NAME: 'Watch Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2639189,
        LOCATION_LATITUDE_DEG: 54.7728964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031700',
        LOCATION_NAME: 'Watchet',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3285033,
        LOCATION_LATITUDE_DEG: 51.1798557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031900',
        LOCATION_NAME: 'Watchfield',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.938194,
        LOCATION_LATITUDE_DEG: 51.2157517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA031800',
        LOCATION_NAME: 'Watchfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6468381,
        LOCATION_LATITUDE_DEG: 51.6127777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032000',
        LOCATION_NAME: 'Watendlath',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1191328,
        LOCATION_LATITUDE_DEG: 54.5368746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032100',
        LOCATION_NAME: 'Water',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2398687,
        LOCATION_LATITUDE_DEG: 53.7281806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032200',
        LOCATION_NAME: 'Water Eaton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8087589,
        LOCATION_LATITUDE_DEG: 51.6419825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032300',
        LOCATION_NAME: 'Water End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4910096,
        LOCATION_LATITUDE_DEG: 51.7809779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA042800',
        LOCATION_NAME: 'Water Ma Trout',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2689693,
        LOCATION_LATITUDE_DEG: 50.1142506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032400',
        LOCATION_NAME: 'Water Oakley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6723645,
        LOCATION_LATITUDE_DEG: 51.4896484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032500',
        LOCATION_NAME: 'Water Orton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7395857,
        LOCATION_LATITUDE_DEG: 52.5174645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032600',
        LOCATION_NAME: 'Water Stratford',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0482393,
        LOCATION_LATITUDE_DEG: 52.0061025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032700',
        LOCATION_NAME: 'Water Yeat',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0926212,
        LOCATION_LATITUDE_DEG: 54.2922491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032900',
        LOCATION_NAME: 'Waterbeach',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1916885,
        LOCATION_LATITUDE_DEG: 52.2653111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033000',
        LOCATION_NAME: 'Waterbeck',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1789201,
        LOCATION_LATITUDE_DEG: 55.0872255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033100',
        LOCATION_NAME: 'Watercombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3439466,
        LOCATION_LATITUDE_DEG: 50.6603907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033200',
        LOCATION_NAME: 'Waterden',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7942007,
        LOCATION_LATITUDE_DEG: 52.8885596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033300',
        LOCATION_NAME: 'Waterfall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8796015,
        LOCATION_LATITUDE_DEG: 53.0600173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033500',
        LOCATION_NAME: 'Waterfoot',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2497947,
        LOCATION_LATITUDE_DEG: 53.69188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033600',
        LOCATION_NAME: 'Waterford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0974198,
        LOCATION_LATITUDE_DEG: 51.8179746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033800',
        LOCATION_NAME: 'Watergall',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3840086,
        LOCATION_LATITUDE_DEG: 52.1917228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033900',
        LOCATION_NAME: 'Watergate Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0387005,
        LOCATION_LATITUDE_DEG: 50.4430966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034000',
        LOCATION_NAME: 'Watergore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8106766,
        LOCATION_LATITUDE_DEG: 50.9378209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034300',
        LOCATION_NAME: 'Waterhead',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8417025,
        LOCATION_LATITUDE_DEG: 50.3125769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034400',
        LOCATION_NAME: 'Waterhead',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.959762,
        LOCATION_LATITUDE_DEG: 54.4226623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034200',
        LOCATION_NAME: 'Waterhead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0631269,
        LOCATION_LATITUDE_DEG: 53.5503628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034600',
        LOCATION_NAME: 'Waterhouses',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8747404,
        LOCATION_LATITUDE_DEG: 53.048415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034500',
        LOCATION_NAME: 'Waterhouses',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7218948,
        LOCATION_LATITUDE_DEG: 54.760575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034700',
        LOCATION_NAME: 'Wateringbury',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4247899,
        LOCATION_LATITUDE_DEG: 51.255017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034800',
        LOCATION_NAME: 'Waterlake',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6720681,
        LOCATION_LATITUDE_DEG: 50.437697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034900',
        LOCATION_NAME: 'Waterlip',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4881983,
        LOCATION_LATITUDE_DEG: 51.2038445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035600',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.921462,
        LOCATION_LATITUDE_DEG: 51.6924184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035300',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6702617,
        LOCATION_LATITUDE_DEG: 50.5239016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035500',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8952519,
        LOCATION_LATITUDE_DEG: 55.7645068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035400',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1592898,
        LOCATION_LATITUDE_DEG: 51.5859933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA043600',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0311574,
        LOCATION_LATITUDE_DEG: 53.4786182,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035700',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7341523,
        LOCATION_LATITUDE_DEG: 52.8902132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035100',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9873127,
        LOCATION_LATITUDE_DEG: 50.7471924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035000',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7316903,
        LOCATION_LATITUDE_DEG: 53.6405653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035800',
        LOCATION_NAME: 'Waterlooville',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0320818,
        LOCATION_LATITUDE_DEG: 50.8801971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA032800',
        LOCATION_NAME: 'Water-Ma-Trout',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2592302,
        LOCATION_LATITUDE_DEG: 50.1257712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035900',
        LOCATION_NAME: 'Watermillock',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8578929,
        LOCATION_LATITUDE_DEG: 54.5916803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036000',
        LOCATION_NAME: 'Watermouth',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0793969,
        LOCATION_LATITUDE_DEG: 51.2144631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036100',
        LOCATION_NAME: 'Waternewton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3643501,
        LOCATION_LATITUDE_DEG: 52.5505342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036200',
        LOCATION_NAME: 'Waternish',
        COUNTY_NAME: 'Isle of Skye',
        POSTCODE: 'IV55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5956776,
        LOCATION_LATITUDE_DEG: 57.4979056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036300',
        LOCATION_NAME: 'Waterperry',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0895184,
        LOCATION_LATITUDE_DEG: 51.7528759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036400',
        LOCATION_NAME: 'Waterrow',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3527111,
        LOCATION_LATITUDE_DEG: 51.0197341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036500',
        LOCATION_NAME: 'Waters Upton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5433565,
        LOCATION_LATITUDE_DEG: 52.7707924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036600',
        LOCATION_NAME: 'Watersfield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5514393,
        LOCATION_LATITUDE_DEG: 50.934492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036700',
        LOCATION_NAME: 'Waterside',
        COUNTY_NAME: 'County Londonderry',
        POSTCODE: 'BT47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.2818223,
        LOCATION_LATITUDE_DEG: 55.0023567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036800',
        LOCATION_NAME: 'Waterside',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4663683,
        LOCATION_LATITUDE_DEG: 55.3465647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037150',
        LOCATION_NAME: 'Waterside',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4073284,
        LOCATION_LATITUDE_DEG: 55.6624314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037100',
        LOCATION_NAME: 'Waterside',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1208459,
        LOCATION_LATITUDE_DEG: 55.9345178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA036900',
        LOCATION_NAME: 'Waterside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2112207,
        LOCATION_LATITUDE_DEG: 54.8018008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037000',
        LOCATION_NAME: 'Waterside',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4328583,
        LOCATION_LATITUDE_DEG: 53.7050849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037200',
        LOCATION_NAME: 'Waterstock',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0763792,
        LOCATION_LATITUDE_DEG: 51.7463798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037400',
        LOCATION_NAME: 'Waterston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9858851,
        LOCATION_LATITUDE_DEG: 51.7122235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037300',
        LOCATION_NAME: 'Waterston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.397452,
        LOCATION_LATITUDE_DEG: 50.7548979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037500',
        LOCATION_NAME: 'Waterthorpe',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3498567,
        LOCATION_LATITUDE_DEG: 53.3364372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037600',
        LOCATION_NAME: 'Waterton',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5507417,
        LOCATION_LATITUDE_DEG: 51.4965869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037800',
        LOCATION_NAME: 'Waterwheel',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9381445,
        LOCATION_LATITUDE_DEG: 52.6149859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038000',
        LOCATION_NAME: 'Watford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1143838,
        LOCATION_LATITUDE_DEG: 52.3164383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037900',
        LOCATION_NAME: 'Watford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3933223,
        LOCATION_LATITUDE_DEG: 51.6546627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038100',
        LOCATION_NAME: 'Watford Heath',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3783284,
        LOCATION_LATITUDE_DEG: 51.6291589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038200',
        LOCATION_NAME: 'Wath',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5041476,
        LOCATION_LATITUDE_DEG: 54.1880208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038400',
        LOCATION_NAME: 'Wath Upon Dearne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3472467,
        LOCATION_LATITUDE_DEG: 53.5032548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990676',
        LOCATION_NAME: 'Wath-upon-Dearne',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3472467,
        LOCATION_LATITUDE_DEG: 53.5032548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038500',
        LOCATION_NAME: 'Watlington',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0028541,
        LOCATION_LATITUDE_DEG: 51.6445681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038600',
        LOCATION_NAME: 'Watlington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3948558,
        LOCATION_LATITUDE_DEG: 52.6733437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038700',
        LOCATION_NAME: 'Watnall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2509708,
        LOCATION_LATITUDE_DEG: 53.0055045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038800',
        LOCATION_NAME: 'Watten',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.299986,
        LOCATION_LATITUDE_DEG: 58.4715685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA038900',
        LOCATION_NAME: 'Wattisfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9491863,
        LOCATION_LATITUDE_DEG: 52.3303063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039000',
        LOCATION_NAME: 'Wattisham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9403883,
        LOCATION_LATITUDE_DEG: 52.124888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039100',
        LOCATION_NAME: 'Wattisham Airfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9681616,
        LOCATION_LATITUDE_DEG: 52.123688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039200',
        LOCATION_NAME: 'Wattlefield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1142518,
        LOCATION_LATITUDE_DEG: 52.5243234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039300',
        LOCATION_NAME: 'Watton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.768087,
        LOCATION_LATITUDE_DEG: 50.7231054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039500',
        LOCATION_NAME: 'Watton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4484461,
        LOCATION_LATITUDE_DEG: 53.9359773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039400',
        LOCATION_NAME: 'Watton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8297465,
        LOCATION_LATITUDE_DEG: 52.5720349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039600',
        LOCATION_NAME: 'Watton at Stone',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1115367,
        LOCATION_LATITUDE_DEG: 51.8575742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039700',
        LOCATION_NAME: 'Wattstown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4197124,
        LOCATION_LATITUDE_DEG: 51.6336005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039800',
        LOCATION_NAME: 'Wattsville',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.148673,
        LOCATION_LATITUDE_DEG: 51.615495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040000',
        LOCATION_NAME: 'Waunarlwydd',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0236096,
        LOCATION_LATITUDE_DEG: 51.6411029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040100',
        LOCATION_NAME: 'Waunfawr',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1984831,
        LOCATION_LATITUDE_DEG: 53.1104475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA039900',
        LOCATION_NAME: 'Waunfawr',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.052254,
        LOCATION_LATITUDE_DEG: 52.4177798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040200',
        LOCATION_NAME: 'Waungron',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0406744,
        LOCATION_LATITUDE_DEG: 51.6963068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040300',
        LOCATION_NAME: 'Waunlwyd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1930598,
        LOCATION_LATITUDE_DEG: 51.7557067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040400',
        LOCATION_NAME: 'Wavendon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6721808,
        LOCATION_LATITUDE_DEG: 52.0249982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040500',
        LOCATION_NAME: 'Wavendon Gate',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6827494,
        LOCATION_LATITUDE_DEG: 52.0230037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040600',
        LOCATION_NAME: 'Waverbridge',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2091157,
        LOCATION_LATITUDE_DEG: 54.8303052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040800',
        LOCATION_NAME: 'Waverton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2099749,
        LOCATION_LATITUDE_DEG: 54.8153044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040700',
        LOCATION_NAME: 'Waverton',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8172191,
        LOCATION_LATITUDE_DEG: 53.171134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA040900',
        LOCATION_NAME: 'Wavertree',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9296269,
        LOCATION_LATITUDE_DEG: 53.3977599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041000',
        LOCATION_NAME: 'Wawne',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3410547,
        LOCATION_LATITUDE_DEG: 53.8159721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041100',
        LOCATION_NAME: 'Waxham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6178297,
        LOCATION_LATITUDE_DEG: 52.7793372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041200',
        LOCATION_NAME: 'Waxholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0102809,
        LOCATION_LATITUDE_DEG: 53.7421596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041300',
        LOCATION_NAME: 'Way Wick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8848799,
        LOCATION_LATITUDE_DEG: 51.3536621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA990696',
        LOCATION_NAME: 'Wayford',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041400',
        LOCATION_NAME: 'Wayford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8419968,
        LOCATION_LATITUDE_DEG: 50.8569174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041500',
        LOCATION_NAME: 'Waymills',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6718203,
        LOCATION_LATITUDE_DEG: 52.9678195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA041600',
        LOCATION_NAME: 'Waytown',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7516667,
        LOCATION_LATITUDE_DEG: 50.7754035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000100',
        LOCATION_NAME: 'Weald',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5526402,
        LOCATION_LATITUDE_DEG: 51.7180803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000200',
        LOCATION_NAME: 'Weald',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1849093,
        LOCATION_LATITUDE_DEG: 51.2162096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000300',
        LOCATION_NAME: 'Wealdstone',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3320028,
        LOCATION_LATITUDE_DEG: 51.5932565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000400',
        LOCATION_NAME: 'Wear Valley Junction',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7419538,
        LOCATION_LATITUDE_DEG: 54.6807729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000500',
        LOCATION_NAME: 'Wearde',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2224318,
        LOCATION_LATITUDE_DEG: 50.4021902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000600',
        LOCATION_NAME: 'Weare',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8377029,
        LOCATION_LATITUDE_DEG: 51.2679548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000700',
        LOCATION_NAME: 'Weare Giffard',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1695871,
        LOCATION_LATITUDE_DEG: 50.9758383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000800',
        LOCATION_NAME: 'Wearhead',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.221204,
        LOCATION_LATITUDE_DEG: 54.7515876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000900',
        LOCATION_NAME: 'Wearne',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8169487,
        LOCATION_LATITUDE_DEG: 51.0487297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE000950',
        LOCATION_NAME: 'Weasenham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7386487,
        LOCATION_LATITUDE_DEG: 52.7639398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065400',
        LOCATION_NAME: 'Weaste',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.301898,
        LOCATION_LATITUDE_DEG: 53.4802581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001100',
        LOCATION_NAME: 'Weaverham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5790931,
        LOCATION_LATITUDE_DEG: 53.2626455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001200',
        LOCATION_NAME: 'Weavering',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5539489,
        LOCATION_LATITUDE_DEG: 51.2748097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001300',
        LOCATION_NAME: 'Weaverthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5224547,
        LOCATION_LATITUDE_DEG: 54.1242986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001400',
        LOCATION_NAME: 'Webbington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8851844,
        LOCATION_LATITUDE_DEG: 51.2956548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001500',
        LOCATION_NAME: 'Webheath',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B97',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9758904,
        LOCATION_LATITUDE_DEG: 52.2969446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001600',
        LOCATION_NAME: 'Webscott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.786683,
        LOCATION_LATITUDE_DEG: 52.8021998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001700',
        LOCATION_NAME: 'Wedderlie',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.567759,
        LOCATION_LATITUDE_DEG: 55.7592869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001800',
        LOCATION_NAME: "Wedge'S Mill",
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0502744,
        LOCATION_LATITUDE_DEG: 52.6735784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001900',
        LOCATION_NAME: 'Wedgnock',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6127316,
        LOCATION_LATITUDE_DEG: 52.3109411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002000',
        LOCATION_NAME: 'Wedhampton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9138517,
        LOCATION_LATITUDE_DEG: 51.3179525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002100',
        LOCATION_NAME: 'Wedmore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8100765,
        LOCATION_LATITUDE_DEG: 51.22545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002200',
        LOCATION_NAME: 'Wednesbury',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0180395,
        LOCATION_LATITUDE_DEG: 52.5525715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002300',
        LOCATION_NAME: 'Wednesfield',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.081405,
        LOCATION_LATITUDE_DEG: 52.5995761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002400',
        LOCATION_NAME: 'Weedon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0771795,
        LOCATION_LATITUDE_DEG: 52.2287281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002500',
        LOCATION_NAME: 'Weedon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8178807,
        LOCATION_LATITUDE_DEG: 51.85549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002600',
        LOCATION_NAME: 'Weeford',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7913059,
        LOCATION_LATITUDE_DEG: 52.631877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002700',
        LOCATION_NAME: 'Week',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7981195,
        LOCATION_LATITUDE_DEG: 50.9354329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063200',
        LOCATION_NAME: 'Week St Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002800',
        LOCATION_NAME: 'Week St. Mary',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.49884,
        LOCATION_LATITUDE_DEG: 50.7495202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE002900',
        LOCATION_NAME: 'Weeke',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3318406,
        LOCATION_LATITUDE_DEG: 51.0662137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003000',
        LOCATION_NAME: 'Weekley',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6959994,
        LOCATION_LATITUDE_DEG: 52.4178362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003100',
        LOCATION_NAME: 'Weel',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3823336,
        LOCATION_LATITUDE_DEG: 53.8403686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003200',
        LOCATION_NAME: 'Weeley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1182667,
        LOCATION_LATITUDE_DEG: 51.8585607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003300',
        LOCATION_NAME: 'Weeley Heath',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1293237,
        LOCATION_LATITUDE_DEG: 51.8420576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003400',
        LOCATION_NAME: 'Weem',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8817827,
        LOCATION_LATITUDE_DEG: 56.6263899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003500',
        LOCATION_NAME: 'Weethley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9195827,
        LOCATION_LATITUDE_DEG: 52.1961355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003600',
        LOCATION_NAME: 'Weeting',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6169564,
        LOCATION_LATITUDE_DEG: 52.4640292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003800',
        LOCATION_NAME: 'Weeton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9349587,
        LOCATION_LATITUDE_DEG: 53.8045994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003900',
        LOCATION_NAME: 'Weeton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5641285,
        LOCATION_LATITUDE_DEG: 53.9171981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE003700',
        LOCATION_NAME: 'Weeton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0508004,
        LOCATION_LATITUDE_DEG: 53.6607437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065000',
        LOCATION_NAME: 'Weetwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.588255,
        LOCATION_LATITUDE_DEG: 53.8375152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004000',
        LOCATION_NAME: 'Weir',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1967718,
        LOCATION_LATITUDE_DEG: 53.7246814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004100',
        LOCATION_NAME: 'Weir End',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.616413,
        LOCATION_LATITUDE_DEG: 51.9096122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004200',
        LOCATION_NAME: 'Weir Quay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2058206,
        LOCATION_LATITUDE_DEG: 50.4605898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004300',
        LOCATION_NAME: 'Weirbrook',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9648729,
        LOCATION_LATITUDE_DEG: 52.8112064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004400',
        LOCATION_NAME: 'Weisdale',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2943118,
        LOCATION_LATITUDE_DEG: 60.2634169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004500',
        LOCATION_NAME: 'Welbeck',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1694647,
        LOCATION_LATITUDE_DEG: 53.2617256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064900',
        LOCATION_NAME: 'Welbeck Colliery Village',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1284951,
        LOCATION_LATITUDE_DEG: 53.2274145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004600',
        LOCATION_NAME: 'Welborne',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0468854,
        LOCATION_LATITUDE_DEG: 52.6442348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004700',
        LOCATION_NAME: 'Welbourn',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5559084,
        LOCATION_LATITUDE_DEG: 53.0755986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004800',
        LOCATION_NAME: 'Welburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8958078,
        LOCATION_LATITUDE_DEG: 54.1025041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE004900',
        LOCATION_NAME: 'Welbury',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3850124,
        LOCATION_LATITUDE_DEG: 54.4150404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005000',
        LOCATION_NAME: 'Welby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5492851,
        LOCATION_LATITUDE_DEG: 52.9331905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005100',
        LOCATION_NAME: 'Welby Warren',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5829002,
        LOCATION_LATITUDE_DEG: 52.9932966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005300',
        LOCATION_NAME: 'Welcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5208985,
        LOCATION_LATITUDE_DEG: 50.937838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005400',
        LOCATION_NAME: 'Weldon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6355984,
        LOCATION_LATITUDE_DEG: 52.4950496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005500',
        LOCATION_NAME: 'Welford',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4092577,
        LOCATION_LATITUDE_DEG: 51.4564581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005600',
        LOCATION_NAME: 'Welford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0579637,
        LOCATION_LATITUDE_DEG: 52.4168414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005700',
        LOCATION_NAME: 'Welford on Avon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.782724,
        LOCATION_LATITUDE_DEG: 52.167325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005800',
        LOCATION_NAME: 'Welham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4721478,
        LOCATION_LATITUDE_DEG: 51.0760281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006000',
        LOCATION_NAME: 'Welham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9074629,
        LOCATION_LATITUDE_DEG: 53.3294308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005900',
        LOCATION_NAME: 'Welham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8725822,
        LOCATION_LATITUDE_DEG: 52.5241507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006100',
        LOCATION_NAME: 'Welham Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2103034,
        LOCATION_LATITUDE_DEG: 51.7354638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006400',
        LOCATION_NAME: 'Well',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.590904,
        LOCATION_LATITUDE_DEG: 54.2321295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006200',
        LOCATION_NAME: 'Well',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.909434,
        LOCATION_LATITUDE_DEG: 51.2126233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006300',
        LOCATION_NAME: 'Well',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1688592,
        LOCATION_LATITUDE_DEG: 53.2429092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006500',
        LOCATION_NAME: 'Well End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2572696,
        LOCATION_LATITUDE_DEG: 51.667462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006600',
        LOCATION_NAME: 'Well Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1481769,
        LOCATION_LATITUDE_DEG: 51.3539257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006700',
        LOCATION_NAME: 'Welland',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2963144,
        LOCATION_LATITUDE_DEG: 52.0577252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006800',
        LOCATION_NAME: 'Wellbank',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8597142,
        LOCATION_LATITUDE_DEG: 56.5224646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE006900',
        LOCATION_NAME: 'Wellbrook',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2479045,
        LOCATION_LATITUDE_DEG: 51.0129891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007000',
        LOCATION_NAME: 'Wellesbourne',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5909051,
        LOCATION_LATITUDE_DEG: 52.1960292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007100',
        LOCATION_NAME: 'Wellfield',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4904148,
        LOCATION_LATITUDE_DEG: 55.0433067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007200',
        LOCATION_NAME: 'Welling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1089765,
        LOCATION_LATITUDE_DEG: 51.4620355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007300',
        LOCATION_NAME: 'Wellingborough',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6918332,
        LOCATION_LATITUDE_DEG: 52.3026234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007400',
        LOCATION_NAME: 'Wellingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.772072,
        LOCATION_LATITUDE_DEG: 52.7656542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007500',
        LOCATION_NAME: 'Wellingley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1037336,
        LOCATION_LATITUDE_DEG: 53.4586428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007600',
        LOCATION_NAME: 'Wellingore',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5331526,
        LOCATION_LATITUDE_DEG: 53.0972041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008000',
        LOCATION_NAME: 'Wellington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4189374,
        LOCATION_LATITUDE_DEG: 54.4244692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007700',
        LOCATION_NAME: 'Wellington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2267263,
        LOCATION_LATITUDE_DEG: 50.9785306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007800',
        LOCATION_NAME: 'Wellington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.739216,
        LOCATION_LATITUDE_DEG: 52.1293322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE007900',
        LOCATION_NAME: 'Wellington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5155819,
        LOCATION_LATITUDE_DEG: 52.703486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008200',
        LOCATION_NAME: 'Wellington College',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7792796,
        LOCATION_LATITUDE_DEG: 51.3650419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008300',
        LOCATION_NAME: 'Wellington Heath',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4219329,
        LOCATION_LATITUDE_DEG: 52.0605255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008400',
        LOCATION_NAME: 'Wellington Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2161136,
        LOCATION_LATITUDE_DEG: 50.9540257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008500',
        LOCATION_NAME: 'Wellisford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2896192,
        LOCATION_LATITUDE_DEG: 50.9865321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008600',
        LOCATION_NAME: 'Wellow',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3724011,
        LOCATION_LATITUDE_DEG: 51.3227519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008800',
        LOCATION_NAME: 'Wellow',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4493566,
        LOCATION_LATITUDE_DEG: 50.6905813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008700',
        LOCATION_NAME: 'Wellow',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9972481,
        LOCATION_LATITUDE_DEG: 53.1886143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008900',
        LOCATION_NAME: 'Wells',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6570608,
        LOCATION_LATITUDE_DEG: 51.2116515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063400',
        LOCATION_NAME: 'Wells in the Field',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063500',
        LOCATION_NAME: 'Wells next the Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009200',
        LOCATION_NAME: 'Wellsborough',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4506296,
        LOCATION_LATITUDE_DEG: 52.623064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009000',
        LOCATION_NAME: 'Wells-in-the-Field',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3131243,
        LOCATION_LATITUDE_DEG: 51.2331356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009100',
        LOCATION_NAME: 'Wells-next-the-Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8551716,
        LOCATION_LATITUDE_DEG: 52.9510695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009300',
        LOCATION_NAME: 'Wellwood',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4616259,
        LOCATION_LATITUDE_DEG: 56.0840284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009400',
        LOCATION_NAME: 'Welney',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2499417,
        LOCATION_LATITUDE_DEG: 52.5225362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009500',
        LOCATION_NAME: 'Welsh Bicknor',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5955297,
        LOCATION_LATITUDE_DEG: 51.8542119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009600',
        LOCATION_NAME: 'Welsh End',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7261422,
        LOCATION_LATITUDE_DEG: 52.9179084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009700',
        LOCATION_NAME: 'Welsh Frankton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9458584,
        LOCATION_LATITUDE_DEG: 52.8915122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009800',
        LOCATION_NAME: 'Welsh Hook',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0003396,
        LOCATION_LATITUDE_DEG: 51.910535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE009900',
        LOCATION_NAME: 'Welsh Newton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7272257,
        LOCATION_LATITUDE_DEG: 51.8572122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010000',
        LOCATION_NAME: 'Welsh Newton Common',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7086115,
        LOCATION_LATITUDE_DEG: 51.853711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063300',
        LOCATION_NAME: 'Welsh St Donats',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010100',
        LOCATION_NAME: 'Welsh St. Donats',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3998275,
        LOCATION_LATITUDE_DEG: 51.4747795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010200',
        LOCATION_NAME: 'Welshampton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8390814,
        LOCATION_LATITUDE_DEG: 52.9093157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010300',
        LOCATION_NAME: 'Welshmoor',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1459973,
        LOCATION_LATITUDE_DEG: 51.6126045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010400',
        LOCATION_NAME: 'Welshpool',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1458711,
        LOCATION_LATITUDE_DEG: 52.6592926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010500',
        LOCATION_NAME: 'Welton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0073045,
        LOCATION_LATITUDE_DEG: 54.7896973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010700',
        LOCATION_NAME: 'Welton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9046581,
        LOCATION_LATITUDE_DEG: 55.0019073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010800',
        LOCATION_NAME: 'Welton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.148276,
        LOCATION_LATITUDE_DEG: 52.2889307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010600',
        LOCATION_NAME: 'Welton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5453236,
        LOCATION_LATITUDE_DEG: 53.7330666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE010900',
        LOCATION_NAME: 'Welton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4826137,
        LOCATION_LATITUDE_DEG: 53.3059213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011000',
        LOCATION_NAME: 'Welton Cliff',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5363095,
        LOCATION_LATITUDE_DEG: 53.304021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011100',
        LOCATION_NAME: 'Welton Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.429468,
        LOCATION_LATITUDE_DEG: 53.3168223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063600',
        LOCATION_NAME: 'Welton le Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011300',
        LOCATION_NAME: 'Welton le Wold',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0874805,
        LOCATION_LATITUDE_DEG: 53.3676188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011200',
        LOCATION_NAME: 'Welton Wold',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5293265,
        LOCATION_LATITUDE_DEG: 53.743965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011400',
        LOCATION_NAME: 'Welton-le-Marsh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.204949,
        LOCATION_LATITUDE_DEG: 53.1946984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011500',
        LOCATION_NAME: 'Welwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0342696,
        LOCATION_LATITUDE_DEG: 53.6679488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011600',
        LOCATION_NAME: 'Welwyn',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2128936,
        LOCATION_LATITUDE_DEG: 51.8323768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011700',
        LOCATION_NAME: 'Welwyn Garden City',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2069729,
        LOCATION_LATITUDE_DEG: 51.8012696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011800',
        LOCATION_NAME: 'Wem',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7214497,
        LOCATION_LATITUDE_DEG: 52.8557042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE011900',
        LOCATION_NAME: 'Wembdon',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0224904,
        LOCATION_LATITUDE_DEG: 51.1328467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012000',
        LOCATION_NAME: 'Wembley',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'HA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2974071,
        LOCATION_LATITUDE_DEG: 51.5515524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012100',
        LOCATION_NAME: 'Wembury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0690134,
        LOCATION_LATITUDE_DEG: 50.3240809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012200',
        LOCATION_NAME: 'Wembworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8987856,
        LOCATION_LATITUDE_DEG: 50.872533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012300',
        LOCATION_NAME: 'Wemyss Bay',
        COUNTY_NAME: 'Renfrewshire',
        POSTCODE: 'PA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8875864,
        LOCATION_LATITUDE_DEG: 55.8824231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012400',
        LOCATION_NAME: 'Wenallt',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5133714,
        LOCATION_LATITUDE_DEG: 52.9637251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012500',
        LOCATION_NAME: 'Wenden Lofts',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1344272,
        LOCATION_LATITUDE_DEG: 52.0193932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012600',
        LOCATION_NAME: 'Wendens Ambo',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2025624,
        LOCATION_LATITUDE_DEG: 51.9998821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012700',
        LOCATION_NAME: 'Wendlebury',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1851114,
        LOCATION_LATITUDE_DEG: 51.8712949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012800',
        LOCATION_NAME: 'Wendling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8566249,
        LOCATION_LATITUDE_DEG: 52.6781445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE012900',
        LOCATION_NAME: 'Wendover',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7398052,
        LOCATION_LATITUDE_DEG: 51.7625779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013000',
        LOCATION_NAME: 'Wendover Dean',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7225632,
        LOCATION_LATITUDE_DEG: 51.7331746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013100',
        LOCATION_NAME: 'Wendron',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2489283,
        LOCATION_LATITUDE_DEG: 50.132772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013200',
        LOCATION_NAME: 'Wenhaston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5575852,
        LOCATION_LATITUDE_DEG: 52.3258941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013300',
        LOCATION_NAME: 'Wenlock Edge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6534118,
        LOCATION_LATITUDE_DEG: 52.5467777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013500',
        LOCATION_NAME: 'Wennington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5857476,
        LOCATION_LATITUDE_DEG: 54.1244272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013400',
        LOCATION_NAME: 'Wennington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1817444,
        LOCATION_LATITUDE_DEG: 52.3987255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013600',
        LOCATION_NAME: 'Wennington',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2202861,
        LOCATION_LATITUDE_DEG: 51.5061372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013800',
        LOCATION_NAME: 'Wensley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.859471,
        LOCATION_LATITUDE_DEG: 54.3016372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013700',
        LOCATION_NAME: 'Wensley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6046118,
        LOCATION_LATITUDE_DEG: 53.1467244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE013900',
        LOCATION_NAME: 'Wensley Station',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8765808,
        LOCATION_LATITUDE_DEG: 54.3103386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014000',
        LOCATION_NAME: 'Wentbridge',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2611902,
        LOCATION_LATITUDE_DEG: 53.6498681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014100',
        LOCATION_NAME: 'Wentnor',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9069822,
        LOCATION_LATITUDE_DEG: 52.5301722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014200',
        LOCATION_NAME: 'Wentworth',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4127202,
        LOCATION_LATITUDE_DEG: 53.4768502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067300',
        LOCATION_NAME: 'Wentworth',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5923219,
        LOCATION_LATITUDE_DEG: 51.4037022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014300',
        LOCATION_NAME: 'Wentworth',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1761765,
        LOCATION_LATITUDE_DEG: 52.38452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014400',
        LOCATION_NAME: 'Wenvoe',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2631653,
        LOCATION_LATITUDE_DEG: 51.4461777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014500',
        LOCATION_NAME: 'Weobley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8756347,
        LOCATION_LATITUDE_DEG: 52.1599414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067500',
        LOCATION_NAME: 'Weoley Castle',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9669797,
        LOCATION_LATITUDE_DEG: 52.4272338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014600',
        LOCATION_NAME: 'Wepham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5179738,
        LOCATION_LATITUDE_DEG: 50.8655914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014700',
        LOCATION_NAME: 'Wereham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4829028,
        LOCATION_LATITUDE_DEG: 52.5852342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014800',
        LOCATION_NAME: 'Wergs',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1851595,
        LOCATION_LATITUDE_DEG: 52.6015722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE014900',
        LOCATION_NAME: 'Wern',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'SY22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1006921,
        LOCATION_LATITUDE_DEG: 52.7773063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015000',
        LOCATION_NAME: 'Wern',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0703538,
        LOCATION_LATITUDE_DEG: 52.9064142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063700',
        LOCATION_NAME: 'Wern Ddu',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063800',
        LOCATION_NAME: 'Wern y Cwrt',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015300',
        LOCATION_NAME: 'Wernddu',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1985066,
        LOCATION_LATITUDE_DEG: 51.5676857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015100',
        LOCATION_NAME: 'Wern-Ddu',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1401611,
        LOCATION_LATITUDE_DEG: 52.8272112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015400',
        LOCATION_NAME: 'Wernfadog',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9141607,
        LOCATION_LATITUDE_DEG: 51.6823027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015500',
        LOCATION_NAME: 'Wernffrwd',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1433913,
        LOCATION_LATITUDE_DEG: 51.622905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015600',
        LOCATION_NAME: 'Wernrheolydd',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8847751,
        LOCATION_LATITUDE_DEG: 51.8105062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015200',
        LOCATION_NAME: 'Wern-y-Cwrt',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8851851,
        LOCATION_LATITUDE_DEG: 51.7744079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015800',
        LOCATION_NAME: 'Werrington',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3655431,
        LOCATION_LATITUDE_DEG: 50.6662173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015700',
        LOCATION_NAME: 'Werrington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0771815,
        LOCATION_LATITUDE_DEG: 53.0266188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE015900',
        LOCATION_NAME: 'Werrington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.270557,
        LOCATION_LATITUDE_DEG: 52.613655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016000',
        LOCATION_NAME: 'Werrington Park',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3649289,
        LOCATION_LATITUDE_DEG: 50.6630094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016100',
        LOCATION_NAME: 'Wervin',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8671768,
        LOCATION_LATITUDE_DEG: 53.2408414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016200',
        LOCATION_NAME: 'Wesham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8821581,
        LOCATION_LATITUDE_DEG: 53.7873982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016300',
        LOCATION_NAME: 'Wessington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4403865,
        LOCATION_LATITUDE_DEG: 53.114115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016400',
        LOCATION_NAME: 'West Aberthaw',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4101067,
        LOCATION_LATITUDE_DEG: 51.3933757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016500',
        LOCATION_NAME: 'West Acre',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.634731,
        LOCATION_LATITUDE_DEG: 52.7054471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016600',
        LOCATION_NAME: 'West Allington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7629766,
        LOCATION_LATITUDE_DEG: 50.7321058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016650',
        LOCATION_NAME: 'West Allotment',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5128296,
        LOCATION_LATITUDE_DEG: 55.0276437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016700',
        LOCATION_NAME: 'West Almer',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1377161,
        LOCATION_LATITUDE_DEG: 50.8195014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016800',
        LOCATION_NAME: 'West Alvington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7913857,
        LOCATION_LATITUDE_DEG: 50.2800722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE016900',
        LOCATION_NAME: 'West Amesbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7968806,
        LOCATION_LATITUDE_DEG: 51.1709358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017000',
        LOCATION_NAME: 'West Anstey',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6362824,
        LOCATION_LATITUDE_DEG: 51.0340407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017100',
        LOCATION_NAME: 'West Ashby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.10318,
        LOCATION_LATITUDE_DEG: 53.2334065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017200',
        LOCATION_NAME: 'West Ashling',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8467947,
        LOCATION_LATITUDE_DEG: 50.8601931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017300',
        LOCATION_NAME: 'West Ashton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1764069,
        LOCATION_LATITUDE_DEG: 51.3008459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017400',
        LOCATION_NAME: 'West Auckland',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7283549,
        LOCATION_LATITUDE_DEG: 54.6289646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017500',
        LOCATION_NAME: 'West Ayton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4851455,
        LOCATION_LATITUDE_DEG: 54.2487158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017600',
        LOCATION_NAME: 'West Barkwith',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2600734,
        LOCATION_LATITUDE_DEG: 53.3088163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017700',
        LOCATION_NAME: 'West Barnby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7346661,
        LOCATION_LATITUDE_DEG: 54.5014385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017800',
        LOCATION_NAME: 'West Barns',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5539311,
        LOCATION_LATITUDE_DEG: 55.9943091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE017900',
        LOCATION_NAME: 'West Barsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8299729,
        LOCATION_LATITUDE_DEG: 52.8661639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018000',
        LOCATION_NAME: 'West Bay',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7593789,
        LOCATION_LATITUDE_DEG: 50.7103012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018100',
        LOCATION_NAME: 'West Beckham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1808062,
        LOCATION_LATITUDE_DEG: 52.91126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018200',
        LOCATION_NAME: 'West Bergholt',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8516298,
        LOCATION_LATITUDE_DEG: 51.9118693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018300',
        LOCATION_NAME: 'West Bexington',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6598713,
        LOCATION_LATITUDE_DEG: 50.6789966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018400',
        LOCATION_NAME: 'West Bilney',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5406381,
        LOCATION_LATITUDE_DEG: 52.7079516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018500',
        LOCATION_NAME: 'West Blackdene',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2076937,
        LOCATION_LATITUDE_DEG: 54.7470817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018600',
        LOCATION_NAME: 'West Blackdown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1320167,
        LOCATION_LATITUDE_DEG: 50.6135076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018700',
        LOCATION_NAME: 'West Blatchington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1784903,
        LOCATION_LATITUDE_DEG: 50.8454864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018800',
        LOCATION_NAME: 'West Boldon',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4374873,
        LOCATION_LATITUDE_DEG: 54.9445899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE018900',
        LOCATION_NAME: 'West Bourton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3347317,
        LOCATION_LATITUDE_DEG: 51.0588306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067600',
        LOCATION_NAME: 'West Bowling',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7555348,
        LOCATION_LATITUDE_DEG: 53.7757776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019000',
        LOCATION_NAME: 'West Brabourne',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9676766,
        LOCATION_LATITUDE_DEG: 51.1403952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019100',
        LOCATION_NAME: 'West Bradford',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3885936,
        LOCATION_LATITUDE_DEG: 53.8961016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019200',
        LOCATION_NAME: 'West Bradley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6283968,
        LOCATION_LATITUDE_DEG: 51.1285415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019300',
        LOCATION_NAME: 'West Bridgford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1325817,
        LOCATION_LATITUDE_DEG: 52.9289905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066300',
        LOCATION_NAME: 'West Brompton',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.182345,
        LOCATION_LATITUDE_DEG: 51.4770236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019400',
        LOCATION_NAME: 'West Bromwich',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9927484,
        LOCATION_LATITUDE_DEG: 52.5185689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019500',
        LOCATION_NAME: 'West Broyle',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7968969,
        LOCATION_LATITUDE_DEG: 50.8509922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019700',
        LOCATION_NAME: 'West Buckland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9180486,
        LOCATION_LATITUDE_DEG: 51.065147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019750',
        LOCATION_NAME: 'West Buckland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8548177,
        LOCATION_LATITUDE_DEG: 50.2788701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019600',
        LOCATION_NAME: 'West Buckland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1751149,
        LOCATION_LATITUDE_DEG: 50.9764351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019800',
        LOCATION_NAME: 'West Burton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9743054,
        LOCATION_LATITUDE_DEG: 54.2746347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE019900',
        LOCATION_NAME: 'West Burton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8166082,
        LOCATION_LATITUDE_DEG: 53.3635273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE991020',
        LOCATION_NAME: 'West Burton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.57875,
        LOCATION_LATITUDE_DEG: 50.9169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020000',
        LOCATION_NAME: 'West Butsfield',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8375997,
        LOCATION_LATITUDE_DEG: 54.8003842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020100',
        LOCATION_NAME: 'West Butterwick',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.739499,
        LOCATION_LATITUDE_DEG: 53.54175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020200',
        LOCATION_NAME: 'West Byfleet',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4984487,
        LOCATION_LATITUDE_DEG: 51.3328292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020300',
        LOCATION_NAME: 'West Caister',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.7056912,
        LOCATION_LATITUDE_DEG: 52.6443229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020400',
        LOCATION_NAME: 'West Calder',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5667968,
        LOCATION_LATITUDE_DEG: 55.8523105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020500',
        LOCATION_NAME: 'West Camel',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6006742,
        LOCATION_LATITUDE_DEG: 51.0197248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020600',
        LOCATION_NAME: 'West Chaldon',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3140821,
        LOCATION_LATITUDE_DEG: 50.6441871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020700',
        LOCATION_NAME: 'West Challow',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4694984,
        LOCATION_LATITUDE_DEG: 51.5916705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020800',
        LOCATION_NAME: 'West Charleton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7518388,
        LOCATION_LATITUDE_DEG: 50.269674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE020900',
        LOCATION_NAME: 'West Chelborough',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6508855,
        LOCATION_LATITUDE_DEG: 50.8458094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021000',
        LOCATION_NAME: 'West Chevington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6385596,
        LOCATION_LATITUDE_DEG: 55.2700317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021100',
        LOCATION_NAME: 'West Chilla',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2113231,
        LOCATION_LATITUDE_DEG: 50.7973268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021200',
        LOCATION_NAME: 'West Chiltington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4468344,
        LOCATION_LATITUDE_DEG: 50.9537977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021300',
        LOCATION_NAME: 'West Chinnock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7572153,
        LOCATION_LATITUDE_DEG: 50.9177195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021400',
        LOCATION_NAME: 'West Chisenbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.802179,
        LOCATION_LATITUDE_DEG: 51.2732396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021500',
        LOCATION_NAME: 'West Clandon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5015821,
        LOCATION_LATITUDE_DEG: 51.2600221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE990868',
        LOCATION_NAME: 'West Cluden',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021600',
        LOCATION_NAME: 'West Clyst',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4474526,
        LOCATION_LATITUDE_DEG: 50.7445144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021700',
        LOCATION_NAME: 'West Coker',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6837953,
        LOCATION_LATITUDE_DEG: 50.9183164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021900',
        LOCATION_NAME: 'West Compton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6202162,
        LOCATION_LATITUDE_DEG: 50.7483049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE021800',
        LOCATION_NAME: 'West Compton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5807584,
        LOCATION_LATITUDE_DEG: 51.1773418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022000',
        LOCATION_NAME: 'West Cornforth',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5140147,
        LOCATION_LATITUDE_DEG: 54.7027673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022200',
        LOCATION_NAME: 'West Cowick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0149399,
        LOCATION_LATITUDE_DEG: 53.6859686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022300',
        LOCATION_NAME: 'West Cranmore',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4819381,
        LOCATION_LATITUDE_DEG: 51.1828447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022400',
        LOCATION_NAME: 'West Cross',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0002294,
        LOCATION_LATITUDE_DEG: 51.5827935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022600',
        LOCATION_NAME: 'West Dean',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6336336,
        LOCATION_LATITUDE_DEG: 51.0421163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022500',
        LOCATION_NAME: 'West Dean',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7789709,
        LOCATION_LATITUDE_DEG: 50.9035911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022700',
        LOCATION_NAME: 'West Dean Park',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7723948,
        LOCATION_LATITUDE_DEG: 50.9053929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022800',
        LOCATION_NAME: 'West Deeping',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3581613,
        LOCATION_LATITUDE_DEG: 52.6652556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022900',
        LOCATION_NAME: 'West Denton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.699134,
        LOCATION_LATITUDE_DEG: 54.9875975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067100',
        LOCATION_NAME: 'West Derby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9152009,
        LOCATION_LATITUDE_DEG: 53.4523592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066800',
        LOCATION_NAME: 'West Derby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9071673,
        LOCATION_LATITUDE_DEG: 53.4351059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066900',
        LOCATION_NAME: 'West Derby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8919318,
        LOCATION_LATITUDE_DEG: 53.4192726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023000',
        LOCATION_NAME: 'West Dereham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4477186,
        LOCATION_LATITUDE_DEG: 52.5799417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065500',
        LOCATION_NAME: 'West Didsbury',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.253448,
        LOCATION_LATITUDE_DEG: 53.4221183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023100',
        LOCATION_NAME: 'West Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1225922,
        LOCATION_LATITUDE_DEG: 51.1603601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023200',
        LOCATION_NAME: 'West Downs',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.7416778,
        LOCATION_LATITUDE_DEG: 50.6131085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023400',
        LOCATION_NAME: 'West Drayton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9375182,
        LOCATION_LATITUDE_DEG: 53.2639209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023300',
        LOCATION_NAME: 'West Drayton',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4655291,
        LOCATION_LATITUDE_DEG: 51.5037527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066500',
        LOCATION_NAME: 'West Ealing',
        COUNTY_NAME: 'London',
        POSTCODE: 'W13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3291108,
        LOCATION_LATITUDE_DEG: 51.5193715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023500',
        LOCATION_NAME: 'West Ella',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4746571,
        LOCATION_LATITUDE_DEG: 53.7480643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023600',
        LOCATION_NAME: 'West Elrington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2213948,
        LOCATION_LATITUDE_DEG: 54.9657043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024050',
        LOCATION_NAME: 'West End',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024000',
        LOCATION_NAME: 'West End',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7608618,
        LOCATION_LATITUDE_DEG: 51.5856823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023700',
        LOCATION_NAME: 'West End',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0403928,
        LOCATION_LATITUDE_DEG: 51.4919671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023800',
        LOCATION_NAME: 'West End',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3313195,
        LOCATION_LATITUDE_DEG: 50.9269028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE023900',
        LOCATION_NAME: 'West End',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6396502,
        LOCATION_LATITUDE_DEG: 51.3360383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024100',
        LOCATION_NAME: 'West Ewell',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2727219,
        LOCATION_LATITUDE_DEG: 51.3617348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024200',
        LOCATION_NAME: 'West Farleigh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4554919,
        LOCATION_LATITUDE_DEG: 51.2496095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024300',
        LOCATION_NAME: 'West Farndon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2246445,
        LOCATION_LATITUDE_DEG: 52.1609219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024400',
        LOCATION_NAME: 'West Felton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9698384,
        LOCATION_LATITUDE_DEG: 52.8243015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024500',
        LOCATION_NAME: 'West Ferry',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8853017,
        LOCATION_LATITUDE_DEG: 56.4729638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024600',
        LOCATION_NAME: 'West Firsby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.515382,
        LOCATION_LATITUDE_DEG: 53.3530218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024700',
        LOCATION_NAME: 'West Fleetham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6917279,
        LOCATION_LATITUDE_DEG: 55.5482517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024800',
        LOCATION_NAME: 'West Fossil',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2873396,
        LOCATION_LATITUDE_DEG: 50.6658953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE024900',
        LOCATION_NAME: 'West Freugh',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9438798,
        LOCATION_LATITUDE_DEG: 54.8479198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025000',
        LOCATION_NAME: 'West Garforth',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3976107,
        LOCATION_LATITUDE_DEG: 53.7886805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025100',
        LOCATION_NAME: 'West Gerinish',
        COUNTY_NAME: 'Isle of South Uist',
        POSTCODE: 'HS8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.3650446,
        LOCATION_LATITUDE_DEG: 57.3527915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025200',
        LOCATION_NAME: 'West Gomeldon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.738644,
        LOCATION_LATITUDE_DEG: 51.1203241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066700',
        LOCATION_NAME: 'West Gorton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.199606,
        LOCATION_LATITUDE_DEG: 53.4681661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025300',
        LOCATION_NAME: 'West Grafton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6470559,
        LOCATION_LATITUDE_DEG: 51.3439452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025400',
        LOCATION_NAME: 'West Grimstead',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6996479,
        LOCATION_LATITUDE_DEG: 51.0387163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025500',
        LOCATION_NAME: 'West Grinstead',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3296302,
        LOCATION_LATITUDE_DEG: 50.9739997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025600',
        LOCATION_NAME: 'West Haddlesey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1448915,
        LOCATION_LATITUDE_DEG: 53.7329748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025700',
        LOCATION_NAME: 'West Haddon',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0755937,
        LOCATION_LATITUDE_DEG: 52.3402385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025800',
        LOCATION_NAME: 'West Hagbourne',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2611315,
        LOCATION_LATITUDE_DEG: 51.5851663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067200',
        LOCATION_NAME: 'West Hagley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1501937,
        LOCATION_LATITUDE_DEG: 52.4161919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE025900',
        LOCATION_NAME: 'West Hall',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6777113,
        LOCATION_LATITUDE_DEG: 55.0006145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026000',
        LOCATION_NAME: 'West Hallam',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3577736,
        LOCATION_LATITUDE_DEG: 52.9664996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026100',
        LOCATION_NAME: 'West Halton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6306854,
        LOCATION_LATITUDE_DEG: 53.6779574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067000',
        LOCATION_NAME: 'West Ham',
        COUNTY_NAME: 'London',
        POSTCODE: 'E15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0130014,
        LOCATION_LATITUDE_DEG: 51.5408894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065900',
        LOCATION_NAME: 'West Hampstead',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1913222,
        LOCATION_LATITUDE_DEG: 51.5478603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026200',
        LOCATION_NAME: 'West Handley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4025965,
        LOCATION_LATITUDE_DEG: 53.2951347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026300',
        LOCATION_NAME: 'West Hanney',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4125532,
        LOCATION_LATITUDE_DEG: 51.633475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026400',
        LOCATION_NAME: 'West Hanningfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5093628,
        LOCATION_LATITUDE_DEG: 51.6693547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026500',
        LOCATION_NAME: 'West Hardwick',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3570778,
        LOCATION_LATITUDE_DEG: 53.6565702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026600',
        LOCATION_NAME: 'West Harling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9033254,
        LOCATION_LATITUDE_DEG: 52.4275181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026700',
        LOCATION_NAME: 'West Harlsey',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3794257,
        LOCATION_LATITUDE_DEG: 54.3798407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026800',
        LOCATION_NAME: 'West Harnham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8164716,
        LOCATION_LATITUDE_DEG: 51.0609195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE026900',
        LOCATION_NAME: 'West Harptree',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.629762,
        LOCATION_LATITUDE_DEG: 51.3085572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027000',
        LOCATION_NAME: 'West Harting',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8985077,
        LOCATION_LATITUDE_DEG: 50.9662073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067400',
        LOCATION_NAME: 'West Hartlepool',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2929597,
        LOCATION_LATITUDE_DEG: 54.7101461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027100',
        LOCATION_NAME: 'West Hatch',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0159274,
        LOCATION_LATITUDE_DEG: 50.9834322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027200',
        LOCATION_NAME: 'West Hauxwell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7527898,
        LOCATION_LATITUDE_DEG: 54.3364391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065700',
        LOCATION_NAME: 'West Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9514067,
        LOCATION_LATITUDE_DEG: 52.3975757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027300',
        LOCATION_NAME: 'West Heath',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7765371,
        LOCATION_LATITUDE_DEG: 51.2997316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027400',
        LOCATION_NAME: 'West Helmsdale',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'KW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6705568,
        LOCATION_LATITUDE_DEG: 58.1167336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066000',
        LOCATION_NAME: 'West Hendon',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2479168,
        LOCATION_LATITUDE_DEG: 51.5829659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027500',
        LOCATION_NAME: 'West Hendred',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3512765,
        LOCATION_LATITUDE_DEG: 51.595465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027600',
        LOCATION_NAME: 'West Herrington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4624646,
        LOCATION_LATITUDE_DEG: 54.8710864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027700',
        LOCATION_NAME: 'West Hewish',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8743782,
        LOCATION_LATITUDE_DEG: 51.3708635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027900',
        LOCATION_NAME: 'West Hill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3172056,
        LOCATION_LATITUDE_DEG: 50.7374061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE027800',
        LOCATION_NAME: 'West Hill',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7470616,
        LOCATION_LATITUDE_DEG: 51.4517714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028000',
        LOCATION_NAME: 'West Hoathly',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0539997,
        LOCATION_LATITUDE_DEG: 51.0760986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028100',
        LOCATION_NAME: 'West Holme',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1607526,
        LOCATION_LATITUDE_DEG: 50.6686929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028200',
        LOCATION_NAME: 'West Holywell',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5210133,
        LOCATION_LATITUDE_DEG: 55.0459024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028300',
        LOCATION_NAME: 'West Horndon',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3452596,
        LOCATION_LATITUDE_DEG: 51.5687407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028400',
        LOCATION_NAME: 'West Horrington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6080586,
        LOCATION_LATITUDE_DEG: 51.2231487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028500',
        LOCATION_NAME: 'West Horsley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4541864,
        LOCATION_LATITUDE_DEG: 51.2598284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028600',
        LOCATION_NAME: 'West Hougham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2389006,
        LOCATION_LATITUDE_DEG: 51.1161892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028700',
        LOCATION_NAME: 'West Howe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9234996,
        LOCATION_LATITUDE_DEG: 50.7610991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028800',
        LOCATION_NAME: 'West Huntspill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9848879,
        LOCATION_LATITUDE_DEG: 51.2042524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE028900',
        LOCATION_NAME: 'West Hyde',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'WD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5083379,
        LOCATION_LATITUDE_DEG: 51.6070603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029000',
        LOCATION_NAME: 'West Hynish',
        COUNTY_NAME: 'Isle of Tiree',
        POSTCODE: 'PA77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.9301508,
        LOCATION_LATITUDE_DEG: 56.4496017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029100',
        LOCATION_NAME: 'West Hythe',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0337677,
        LOCATION_LATITUDE_DEG: 51.0672895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029200',
        LOCATION_NAME: 'West Ilsley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.317755,
        LOCATION_LATITUDE_DEG: 51.5392604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029300',
        LOCATION_NAME: 'West Isle',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7694785,
        LOCATION_LATITUDE_DEG: 60.4231288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065600',
        LOCATION_NAME: 'West Jesmond',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6112573,
        LOCATION_LATITUDE_DEG: 54.9932531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029400',
        LOCATION_NAME: 'West Keal',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0491004,
        LOCATION_LATITUDE_DEG: 53.1491969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029500',
        LOCATION_NAME: 'West Kennett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8394379,
        LOCATION_LATITUDE_DEG: 51.4137545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066600',
        LOCATION_NAME: 'West Kensington',
        COUNTY_NAME: 'London',
        POSTCODE: 'W14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2152675,
        LOCATION_LATITUDE_DEG: 51.4995545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029600',
        LOCATION_NAME: 'West Kilbride',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8533487,
        LOCATION_LATITUDE_DEG: 55.6958042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029700',
        LOCATION_NAME: 'West Kingsdown',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2556868,
        LOCATION_LATITUDE_DEG: 51.3479197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029800',
        LOCATION_NAME: 'West Kington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2748083,
        LOCATION_LATITUDE_DEG: 51.4936664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE029900',
        LOCATION_NAME: 'West Kington Wick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2622142,
        LOCATION_LATITUDE_DEG: 51.4880659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030100',
        LOCATION_NAME: 'West Knapton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6558501,
        LOCATION_LATITUDE_DEG: 54.1667095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030200',
        LOCATION_NAME: 'West Knighton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3798623,
        LOCATION_LATITUDE_DEG: 50.6871977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030300',
        LOCATION_NAME: 'West Knoyle',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2026557,
        LOCATION_LATITUDE_DEG: 51.0912309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030400',
        LOCATION_NAME: 'West Kyo',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7352822,
        LOCATION_LATITUDE_DEG: 54.8667925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030500',
        LOCATION_NAME: 'West Lambrook',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8348236,
        LOCATION_LATITUDE_DEG: 50.9620233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030600',
        LOCATION_NAME: 'West Langdon',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3201342,
        LOCATION_LATITUDE_DEG: 51.1773953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030700',
        LOCATION_NAME: 'West Langton',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9374005,
        LOCATION_LATITUDE_DEG: 52.5192477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030800',
        LOCATION_NAME: 'West Laroch',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1487358,
        LOCATION_LATITUDE_DEG: 56.666807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE030900',
        LOCATION_NAME: 'West Lavant',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7933917,
        LOCATION_LATITUDE_DEG: 50.8634935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031100',
        LOCATION_NAME: 'West Lavington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.989247,
        LOCATION_LATITUDE_DEG: 51.2742426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031000',
        LOCATION_NAME: 'West Lavington',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7234264,
        LOCATION_LATITUDE_DEG: 50.9794984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031200',
        LOCATION_NAME: 'West Layton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7794225,
        LOCATION_LATITUDE_DEG: 54.4843542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031300',
        LOCATION_NAME: 'West Leake',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2191627,
        LOCATION_LATITUDE_DEG: 52.8327889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031400',
        LOCATION_NAME: 'West Leith',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6721449,
        LOCATION_LATITUDE_DEG: 51.7836761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031500',
        LOCATION_NAME: 'West Lexham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7293897,
        LOCATION_LATITUDE_DEG: 52.7204458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031600',
        LOCATION_NAME: 'West Linton',
        COUNTY_NAME: 'Peeblesshire',
        POSTCODE: 'EH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3544676,
        LOCATION_LATITUDE_DEG: 55.752092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031700',
        LOCATION_NAME: 'West Littleton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3433822,
        LOCATION_LATITUDE_DEG: 51.4765707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031800',
        LOCATION_NAME: 'West Lockinge',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3879227,
        LOCATION_LATITUDE_DEG: 51.5856712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE031900',
        LOCATION_NAME: 'West Looe',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4562046,
        LOCATION_LATITUDE_DEG: 50.3505829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032000',
        LOCATION_NAME: 'West Luccombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5757215,
        LOCATION_LATITUDE_DEG: 51.2038578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032100',
        LOCATION_NAME: 'West Lulworth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2435318,
        LOCATION_LATITUDE_DEG: 50.6256847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032200',
        LOCATION_NAME: 'West Lutton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5745547,
        LOCATION_LATITUDE_DEG: 54.1107956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032300',
        LOCATION_NAME: 'West Lydford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6207079,
        LOCATION_LATITUDE_DEG: 51.081638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032400',
        LOCATION_NAME: 'West Lyng',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9748542,
        LOCATION_LATITUDE_DEG: 51.0468358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032500',
        LOCATION_NAME: 'West Lynn',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3895408,
        LOCATION_LATITUDE_DEG: 52.7515529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032600',
        LOCATION_NAME: 'West Mains',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G74',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6621408,
        LOCATION_LATITUDE_DEG: 55.7311939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032700',
        LOCATION_NAME: 'West Malling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4101681,
        LOCATION_LATITUDE_DEG: 51.293618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032800',
        LOCATION_NAME: 'West Malvern',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.346195,
        LOCATION_LATITUDE_DEG: 52.1135263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE032900',
        LOCATION_NAME: 'West Marden',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9005804,
        LOCATION_LATITUDE_DEG: 50.9164017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033000',
        LOCATION_NAME: 'West Markham',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9191589,
        LOCATION_LATITUDE_DEG: 53.2457214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033100',
        LOCATION_NAME: 'West Marton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1619887,
        LOCATION_LATITUDE_DEG: 53.949907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033200',
        LOCATION_NAME: 'West Melbury',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1909279,
        LOCATION_LATITUDE_DEG: 50.9793208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033300',
        LOCATION_NAME: 'West Melton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3603921,
        LOCATION_LATITUDE_DEG: 53.5024538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033400',
        LOCATION_NAME: 'West Meon',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0866541,
        LOCATION_LATITUDE_DEG: 51.0119074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033500',
        LOCATION_NAME: 'West Mersea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9208373,
        LOCATION_LATITUDE_DEG: 51.7772555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033600',
        LOCATION_NAME: 'West Mickley',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9007529,
        LOCATION_LATITUDE_DEG: 54.9560961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033700',
        LOCATION_NAME: 'West Milton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7073251,
        LOCATION_LATITUDE_DEG: 50.7631075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033800',
        LOCATION_NAME: 'West Molesey',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3706352,
        LOCATION_LATITUDE_DEG: 51.402736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE033900',
        LOCATION_NAME: 'West Monkton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0531607,
        LOCATION_LATITUDE_DEG: 51.0490343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065200',
        LOCATION_NAME: 'West Moor',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5849118,
        LOCATION_LATITUDE_DEG: 55.0301847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034000',
        LOCATION_NAME: 'West Moor End',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3965406,
        LOCATION_LATITUDE_DEG: 54.7434969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034100',
        LOCATION_NAME: 'West Moors',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8852811,
        LOCATION_LATITUDE_DEG: 50.8206055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034200',
        LOCATION_NAME: 'West Morden',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1362021,
        LOCATION_LATITUDE_DEG: 50.757798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034300',
        LOCATION_NAME: 'West Morton',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8592684,
        LOCATION_LATITUDE_DEG: 53.8822928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034400',
        LOCATION_NAME: 'West Newton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.015758,
        LOCATION_LATITUDE_DEG: 51.0572346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034600',
        LOCATION_NAME: 'West Newton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1910809,
        LOCATION_LATITUDE_DEG: 53.8225692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034500',
        LOCATION_NAME: 'West Newton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5194766,
        LOCATION_LATITUDE_DEG: 52.8195647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066100',
        LOCATION_NAME: 'West Norwood',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1039861,
        LOCATION_LATITUDE_DEG: 51.4303645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034700',
        LOCATION_NAME: 'West Ogwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6619036,
        LOCATION_LATITUDE_DEG: 50.5174917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034800',
        LOCATION_NAME: 'West Orchard',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.251743,
        LOCATION_LATITUDE_DEG: 50.9473152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE034900',
        LOCATION_NAME: 'West Overton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8122276,
        LOCATION_LATITUDE_DEG: 51.4106566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065100',
        LOCATION_NAME: 'West Park',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6037462,
        LOCATION_LATITUDE_DEG: 53.838673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035000',
        LOCATION_NAME: 'West Parley',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8652908,
        LOCATION_LATITUDE_DEG: 50.7661998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035100',
        LOCATION_NAME: 'West Peckham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3587215,
        LOCATION_LATITUDE_DEG: 51.2485153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035200',
        LOCATION_NAME: 'West Pelton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6401263,
        LOCATION_LATITUDE_DEG: 54.8711854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035300',
        LOCATION_NAME: 'West Pennard',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6453019,
        LOCATION_LATITUDE_DEG: 51.1437379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035400',
        LOCATION_NAME: 'West Pentire',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1295394,
        LOCATION_LATITUDE_DEG: 50.4026938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067800',
        LOCATION_NAME: 'West Pilton',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2530707,
        LOCATION_LATITUDE_DEG: 55.9729296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035500',
        LOCATION_NAME: 'West Pinchbeck',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2109139,
        LOCATION_LATITUDE_DEG: 52.807388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035600',
        LOCATION_NAME: 'West Polberro',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2299287,
        LOCATION_LATITUDE_DEG: 50.3137927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035700',
        LOCATION_NAME: 'West Porlock',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6099851,
        LOCATION_LATITUDE_DEG: 51.2109551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035800',
        LOCATION_NAME: 'West Pottergate',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2810605,
        LOCATION_LATITUDE_DEG: 52.6299346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE035900',
        LOCATION_NAME: 'West Putford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.334564,
        LOCATION_LATITUDE_DEG: 50.9154397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036000',
        LOCATION_NAME: 'West Quantoxhead',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2730543,
        LOCATION_LATITUDE_DEG: 51.1662536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036100',
        LOCATION_NAME: 'West Rainton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5029558,
        LOCATION_LATITUDE_DEG: 54.812579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036200',
        LOCATION_NAME: 'West Rasen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4019246,
        LOCATION_LATITUDE_DEG: 53.389326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036300',
        LOCATION_NAME: 'West Ravendale',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1496646,
        LOCATION_LATITUDE_DEG: 53.4800328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036400',
        LOCATION_NAME: 'West Raynham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7761969,
        LOCATION_LATITUDE_DEG: 52.7929515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036500',
        LOCATION_NAME: 'West Roddymoor',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7655563,
        LOCATION_LATITUDE_DEG: 54.7167716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036600',
        LOCATION_NAME: 'West Rounton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3625481,
        LOCATION_LATITUDE_DEG: 54.4246403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036700',
        LOCATION_NAME: 'West Row',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4594422,
        LOCATION_LATITUDE_DEG: 52.3513174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036800',
        LOCATION_NAME: 'West Row Fen',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.449216,
        LOCATION_LATITUDE_DEG: 52.3414124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE036900',
        LOCATION_NAME: 'West Rudham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6933015,
        LOCATION_LATITUDE_DEG: 52.818758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037000',
        LOCATION_NAME: 'West Runton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2460737,
        LOCATION_LATITUDE_DEG: 52.9372582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037100',
        LOCATION_NAME: 'West Sandford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.685963,
        LOCATION_LATITUDE_DEG: 50.8100175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037200',
        LOCATION_NAME: 'West Sandwick',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1796156,
        LOCATION_LATITUDE_DEG: 60.57325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037300',
        LOCATION_NAME: 'West Scholes',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8450011,
        LOCATION_LATITUDE_DEG: 53.7783806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037400',
        LOCATION_NAME: 'West Scrafton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8874338,
        LOCATION_LATITUDE_DEG: 54.2481322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037500',
        LOCATION_NAME: 'West Seaton',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3096403,
        LOCATION_LATITUDE_DEG: 50.247687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037600',
        LOCATION_NAME: 'West Sevington',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1975022,
        LOCATION_LATITUDE_DEG: 51.5061688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037700',
        LOCATION_NAME: 'West Sherburn',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5289291,
        LOCATION_LATITUDE_DEG: 54.7750784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037800',
        LOCATION_NAME: 'West Side',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1613372,
        LOCATION_LATITUDE_DEG: 51.7657094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE037900',
        LOCATION_NAME: 'West Sinns',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2357295,
        LOCATION_LATITUDE_DEG: 50.254179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038000',
        LOCATION_NAME: 'West Sleekburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5543188,
        LOCATION_LATITUDE_DEG: 55.1588178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038100',
        LOCATION_NAME: 'West Somerton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6594647,
        LOCATION_LATITUDE_DEG: 52.7188324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038200',
        LOCATION_NAME: 'West Stafford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3888721,
        LOCATION_LATITUDE_DEG: 50.7049936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038300',
        LOCATION_NAME: 'West Stockwith',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8095041,
        LOCATION_LATITUDE_DEG: 53.4436399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038400',
        LOCATION_NAME: 'West Stoke',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.81491,
        LOCATION_LATITUDE_DEG: 50.8678962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038500',
        LOCATION_NAME: 'West Stonesdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1735395,
        LOCATION_LATITUDE_DEG: 54.4146477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038600',
        LOCATION_NAME: 'West Stoughton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8313356,
        LOCATION_LATITUDE_DEG: 51.234456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038700',
        LOCATION_NAME: 'West Stour',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.306115,
        LOCATION_LATITUDE_DEG: 51.0019278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038800',
        LOCATION_NAME: 'West Stourmouth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2365473,
        LOCATION_LATITUDE_DEG: 51.3185032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE038900',
        LOCATION_NAME: 'West Stow',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6699119,
        LOCATION_LATITUDE_DEG: 52.3022096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039000',
        LOCATION_NAME: 'West Stowell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8028298,
        LOCATION_LATITUDE_DEG: 51.3589511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039100',
        LOCATION_NAME: 'West Stratton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2318193,
        LOCATION_LATITUDE_DEG: 51.1495245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039200',
        LOCATION_NAME: 'West Studdal',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.306718,
        LOCATION_LATITUDE_DEG: 51.2018944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039300',
        LOCATION_NAME: 'West Tanfield',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5875879,
        LOCATION_LATITUDE_DEG: 54.2046225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039400',
        LOCATION_NAME: 'West Taphouse',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6079688,
        LOCATION_LATITUDE_DEG: 50.4377939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039500',
        LOCATION_NAME: 'West Tarbert',
        COUNTY_NAME: 'Isle of Harris',
        POSTCODE: 'HS3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.8111856,
        LOCATION_LATITUDE_DEG: 57.9016441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039600',
        LOCATION_NAME: 'West Thirston',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7101786,
        LOCATION_LATITUDE_DEG: 55.2936334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039700',
        LOCATION_NAME: 'West Thurrock',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2775433,
        LOCATION_LATITUDE_DEG: 51.4754393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039800',
        LOCATION_NAME: 'West Tilbury',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'RM18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3919137,
        LOCATION_LATITUDE_DEG: 51.4759314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE039900',
        LOCATION_NAME: 'West Timperley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3477656,
        LOCATION_LATITUDE_DEG: 53.4039556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040000',
        LOCATION_NAME: 'West Tisbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1082055,
        LOCATION_LATITUDE_DEG: 51.0674256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040100',
        LOCATION_NAME: 'West Tisted',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0618601,
        LOCATION_LATITUDE_DEG: 51.0579104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040200',
        LOCATION_NAME: 'West Tockenham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.945279,
        LOCATION_LATITUDE_DEG: 51.5116638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040300',
        LOCATION_NAME: 'West Tofts',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7095385,
        LOCATION_LATITUDE_DEG: 52.5027294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040400',
        LOCATION_NAME: 'West Tolgus',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2529308,
        LOCATION_LATITUDE_DEG: 50.2384843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040500',
        LOCATION_NAME: 'West Torrington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2946271,
        LOCATION_LATITUDE_DEG: 53.3228197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040600',
        LOCATION_NAME: 'West Town',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5855333,
        LOCATION_LATITUDE_DEG: 50.7653122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040700',
        LOCATION_NAME: 'West Town',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.748161,
        LOCATION_LATITUDE_DEG: 51.4080685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040900',
        LOCATION_NAME: 'West Trevarth',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.186931,
        LOCATION_LATITUDE_DEG: 50.2168777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041000',
        LOCATION_NAME: 'West Tytherley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6090299,
        LOCATION_LATITUDE_DEG: 51.0670198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041200',
        LOCATION_NAME: 'West Walton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.177395,
        LOCATION_LATITUDE_DEG: 52.6970534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041300',
        LOCATION_NAME: 'West Wellow',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5841061,
        LOCATION_LATITUDE_DEG: 50.9685111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041400',
        LOCATION_NAME: 'West Wemyss',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0826732,
        LOCATION_LATITUDE_DEG: 56.1409337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041600',
        LOCATION_NAME: 'West Wick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9015052,
        LOCATION_LATITUDE_DEG: 51.3540659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041500',
        LOCATION_NAME: 'West Wick',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7500738,
        LOCATION_LATITUDE_DEG: 51.3612515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041800',
        LOCATION_NAME: 'West Wickham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'BR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0037969,
        LOCATION_LATITUDE_DEG: 51.3760326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041700',
        LOCATION_NAME: 'West Wickham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3560857,
        LOCATION_LATITUDE_DEG: 52.1166944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041900',
        LOCATION_NAME: 'West Williamston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8453668,
        LOCATION_LATITUDE_DEG: 51.7160189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042000',
        LOCATION_NAME: 'West Willoughby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5585273,
        LOCATION_LATITUDE_DEG: 52.9814951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066400',
        LOCATION_NAME: 'West Wimbledon',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2407595,
        LOCATION_LATITUDE_DEG: 51.4160212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042100',
        LOCATION_NAME: 'West Winch',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4153249,
        LOCATION_LATITUDE_DEG: 52.7166511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042200',
        LOCATION_NAME: 'West Winterslow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6736491,
        LOCATION_LATITUDE_DEG: 51.0907262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042300',
        LOCATION_NAME: 'West Wittering',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.894701,
        LOCATION_LATITUDE_DEG: 50.7800894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042400',
        LOCATION_NAME: 'West Witton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9037564,
        LOCATION_LATITUDE_DEG: 54.2912363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042500',
        LOCATION_NAME: 'West Woodburn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.168381,
        LOCATION_LATITUDE_DEG: 55.175423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042600',
        LOCATION_NAME: 'West Woodhay',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.436462,
        LOCATION_LATITUDE_DEG: 51.3641467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042700',
        LOCATION_NAME: 'West Woodlands',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3186624,
        LOCATION_LATITUDE_DEG: 51.1937453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042800',
        LOCATION_NAME: 'West Woodside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0922106,
        LOCATION_LATITUDE_DEG: 54.8323031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE042900',
        LOCATION_NAME: 'West Woodyates',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9687064,
        LOCATION_LATITUDE_DEG: 50.9712168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043000',
        LOCATION_NAME: 'West Worldham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9407549,
        LOCATION_LATITUDE_DEG: 51.1268177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043100',
        LOCATION_NAME: 'West Worlington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7492261,
        LOCATION_LATITUDE_DEG: 50.9066296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043200',
        LOCATION_NAME: 'West Worthing',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.386852,
        LOCATION_LATITUDE_DEG: 50.8131789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043300',
        LOCATION_NAME: 'West Wratting',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3507323,
        LOCATION_LATITUDE_DEG: 52.1409935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043400',
        LOCATION_NAME: 'West Wycombe',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8040162,
        LOCATION_LATITUDE_DEG: 51.6441681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043500',
        LOCATION_NAME: 'West Yelland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1581408,
        LOCATION_LATITUDE_DEG: 51.0644491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043600',
        LOCATION_NAME: 'West Yeo',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9469885,
        LOCATION_LATITUDE_DEG: 51.0719407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043700',
        LOCATION_NAME: 'Westbere',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1455055,
        LOCATION_LATITUDE_DEG: 51.3089047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043800',
        LOCATION_NAME: 'Westborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7331165,
        LOCATION_LATITUDE_DEG: 52.9902899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE043900',
        LOCATION_NAME: 'Westbourne',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9257599,
        LOCATION_LATITUDE_DEG: 50.8602901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044200',
        LOCATION_NAME: 'Westbrook',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0436331,
        LOCATION_LATITUDE_DEG: 52.0877363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044000',
        LOCATION_NAME: 'Westbrook',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6222849,
        LOCATION_LATITUDE_DEG: 53.4098616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044300',
        LOCATION_NAME: 'Westbrook',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3066311,
        LOCATION_LATITUDE_DEG: 51.0283217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044100',
        LOCATION_NAME: 'Westbrook',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3860295,
        LOCATION_LATITUDE_DEG: 51.4432544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044400',
        LOCATION_NAME: 'Westburton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4438652,
        LOCATION_LATITUDE_DEG: 50.9454926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044700',
        LOCATION_NAME: 'Westbury',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9520891,
        LOCATION_LATITUDE_DEG: 52.6782887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044500',
        LOCATION_NAME: 'Westbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1805017,
        LOCATION_LATITUDE_DEG: 51.2585463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044600',
        LOCATION_NAME: 'Westbury',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0918,
        LOCATION_LATITUDE_DEG: 52.0164095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044800',
        LOCATION_NAME: 'Westbury Leigh',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1922352,
        LOCATION_LATITUDE_DEG: 51.2505419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064600',
        LOCATION_NAME: 'Westbury on Severn',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4123586,
        LOCATION_LATITUDE_DEG: 51.8267615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065300',
        LOCATION_NAME: 'Westbury on Trym',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6197287,
        LOCATION_LATITUDE_DEG: 51.4954896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE067700',
        LOCATION_NAME: 'Westbury Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6162498,
        LOCATION_LATITUDE_DEG: 51.4800226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE044900',
        LOCATION_NAME: 'Westbury sub Mendip',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7127643,
        LOCATION_LATITUDE_DEG: 51.2352471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045000',
        LOCATION_NAME: 'Westbury-on-Severn',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4108949,
        LOCATION_LATITUDE_DEG: 51.8237992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045100',
        LOCATION_NAME: 'Westby',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9347126,
        LOCATION_LATITUDE_DEG: 53.7791973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045200',
        LOCATION_NAME: 'Westby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5554438,
        LOCATION_LATITUDE_DEG: 52.8433809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045300',
        LOCATION_NAME: 'Westby Mills',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9231018,
        LOCATION_LATITUDE_DEG: 53.7874946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064700',
        LOCATION_NAME: 'Westcliff on Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045400',
        LOCATION_NAME: 'Westcliff-on-Sea',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6951779,
        LOCATION_LATITUDE_DEG: 51.5364324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045500',
        LOCATION_NAME: 'Westcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4655877,
        LOCATION_LATITUDE_DEG: 51.1506437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045600',
        LOCATION_NAME: 'Westcot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5121424,
        LOCATION_LATITUDE_DEG: 51.5838702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045700',
        LOCATION_NAME: 'Westcote Barton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3745777,
        LOCATION_LATITUDE_DEG: 51.9280972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045900',
        LOCATION_NAME: 'Westcott',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3914185,
        LOCATION_LATITUDE_DEG: 50.8306228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE045800',
        LOCATION_NAME: 'Westcott',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9555164,
        LOCATION_LATITUDE_DEG: 51.8461906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046000',
        LOCATION_NAME: 'Westcott',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3659659,
        LOCATION_LATITUDE_DEG: 51.224517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046100',
        LOCATION_NAME: 'Westcourt',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6768606,
        LOCATION_LATITUDE_DEG: 51.3466481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046200',
        LOCATION_NAME: 'Westcroft',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.089462,
        LOCATION_LATITUDE_DEG: 52.6259762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE990613',
        LOCATION_NAME: 'Westcroft',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7974657,
        LOCATION_LATITUDE_DEG: 51.9816434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046300',
        LOCATION_NAME: 'Westdean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1638259,
        LOCATION_LATITUDE_DEG: 50.7738057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046500',
        LOCATION_NAME: 'Westend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3145317,
        LOCATION_LATITUDE_DEG: 51.7598929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046600',
        LOCATION_NAME: 'Westenhanger',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.034982,
        LOCATION_LATITUDE_DEG: 51.0827848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046700',
        LOCATION_NAME: 'Wester Balgedie',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'KY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3463689,
        LOCATION_LATITUDE_DEG: 56.2220413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046800',
        LOCATION_NAME: 'Wester Essendy',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4109533,
        LOCATION_LATITUDE_DEG: 56.5759807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE046900',
        LOCATION_NAME: 'Wester Galcantray',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.995677,
        LOCATION_LATITUDE_DEG: 57.5017719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047000',
        LOCATION_NAME: 'Wester Hailes',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2826424,
        LOCATION_LATITUDE_DEG: 55.9154073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047100',
        LOCATION_NAME: 'Wester Moy',
        COUNTY_NAME: 'Ross-Shire',
        POSTCODE: 'IV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5406441,
        LOCATION_LATITUDE_DEG: 57.5602834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047200',
        LOCATION_NAME: 'Wester Quarff',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2639928,
        LOCATION_LATITUDE_DEG: 60.0993994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047400',
        LOCATION_NAME: 'Westerdale',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4879364,
        LOCATION_LATITUDE_DEG: 58.4466629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047300',
        LOCATION_NAME: 'Westerdale',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9745703,
        LOCATION_LATITUDE_DEG: 54.4437401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047500',
        LOCATION_NAME: 'Westerfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1732943,
        LOCATION_LATITUDE_DEG: 52.0842774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047600',
        LOCATION_NAME: 'Westergate',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6670927,
        LOCATION_LATITUDE_DEG: 50.8385911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047700',
        LOCATION_NAME: 'Westerham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.072212,
        LOCATION_LATITUDE_DEG: 51.266514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047800',
        LOCATION_NAME: 'Westerhope',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6984429,
        LOCATION_LATITUDE_DEG: 54.9943003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE047900',
        LOCATION_NAME: 'Westerkirk',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0956776,
        LOCATION_LATITUDE_DEG: 55.2066387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048000',
        LOCATION_NAME: 'Westerland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.596265,
        LOCATION_LATITUDE_DEG: 50.4502842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048100',
        LOCATION_NAME: 'Westerleigh',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4352438,
        LOCATION_LATITUDE_DEG: 51.5143763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048200',
        LOCATION_NAME: 'Western Docks',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4267585,
        LOCATION_LATITUDE_DEG: 50.9064015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048300',
        LOCATION_NAME: 'Westerskeld',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4744524,
        LOCATION_LATITUDE_DEG: 60.1804328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048500',
        LOCATION_NAME: 'Westerton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6279938,
        LOCATION_LATITUDE_DEG: 54.6737718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048400',
        LOCATION_NAME: 'Westerton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7385849,
        LOCATION_LATITUDE_DEG: 50.858489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048800',
        LOCATION_NAME: 'Westfield',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6925792,
        LOCATION_LATITUDE_DEG: 55.9297153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048900',
        LOCATION_NAME: 'Westfield',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6160621,
        LOCATION_LATITUDE_DEG: 58.5556754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048700',
        LOCATION_NAME: 'Westfield',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5772406,
        LOCATION_LATITUDE_DEG: 50.9096757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE048600',
        LOCATION_NAME: 'Westfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9434989,
        LOCATION_LATITUDE_DEG: 52.6475338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049000',
        LOCATION_NAME: 'Westford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2518847,
        LOCATION_LATITUDE_DEG: 50.9758354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049200',
        LOCATION_NAME: 'Westgate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1433684,
        LOCATION_LATITUDE_DEG: 54.7372795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049100',
        LOCATION_NAME: 'Westgate',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7195864,
        LOCATION_LATITUDE_DEG: 53.7206765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064800',
        LOCATION_NAME: 'Westgate on Sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049300',
        LOCATION_NAME: 'Westgate-on-Sea',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3383561,
        LOCATION_LATITUDE_DEG: 51.3822136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049400',
        LOCATION_NAME: 'Westhall',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5566699,
        LOCATION_LATITUDE_DEG: 52.3760992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049500',
        LOCATION_NAME: 'Westham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8570151,
        LOCATION_LATITUDE_DEG: 51.2156459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049600',
        LOCATION_NAME: 'Westham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3229068,
        LOCATION_LATITUDE_DEG: 50.8161698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049700',
        LOCATION_NAME: 'Westhampnett',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7483487,
        LOCATION_LATITUDE_DEG: 50.8472888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049800',
        LOCATION_NAME: 'Westhaven',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7007765,
        LOCATION_LATITUDE_DEG: 56.5073609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE049900',
        LOCATION_NAME: 'Westhay',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8156206,
        LOCATION_LATITUDE_DEG: 51.1736469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050000',
        LOCATION_NAME: 'Westhead',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'L40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8422043,
        LOCATION_LATITUDE_DEG: 53.5627776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050100',
        LOCATION_NAME: 'Westhide',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6045226,
        LOCATION_LATITUDE_DEG: 52.0936293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050400',
        LOCATION_NAME: 'Westhill',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1580596,
        LOCATION_LATITUDE_DEG: 57.4702702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050200',
        LOCATION_NAME: 'Westhill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4098164,
        LOCATION_LATITUDE_DEG: 52.0452284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050300',
        LOCATION_NAME: 'Westhill',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2755342,
        LOCATION_LATITUDE_DEG: 57.1546187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050500',
        LOCATION_NAME: 'Westhope',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7841699,
        LOCATION_LATITUDE_DEG: 52.1508378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050600',
        LOCATION_NAME: 'Westhope',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7725874,
        LOCATION_LATITUDE_DEG: 52.4740677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050700',
        LOCATION_NAME: 'Westhorpe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0051338,
        LOCATION_LATITUDE_DEG: 52.2809012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050800',
        LOCATION_NAME: 'Westhoughton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5253598,
        LOCATION_LATITUDE_DEG: 53.5474727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE050900',
        LOCATION_NAME: 'Westhouse',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5031902,
        LOCATION_LATITUDE_DEG: 54.1612314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051000',
        LOCATION_NAME: 'Westhouses',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3674242,
        LOCATION_LATITUDE_DEG: 53.116213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051100',
        LOCATION_NAME: 'Westhumble',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3278817,
        LOCATION_LATITUDE_DEG: 51.2541259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051200',
        LOCATION_NAME: 'Westlake',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9363714,
        LOCATION_LATITUDE_DEG: 50.3658823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051300',
        LOCATION_NAME: 'Westlea',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8188634,
        LOCATION_LATITUDE_DEG: 51.5616697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051400',
        LOCATION_NAME: 'Westleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1800024,
        LOCATION_LATITUDE_DEG: 51.036349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051500',
        LOCATION_NAME: 'Westleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3337281,
        LOCATION_LATITUDE_DEG: 50.943532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051600',
        LOCATION_NAME: 'Westleton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5766719,
        LOCATION_LATITUDE_DEG: 52.264596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051800',
        LOCATION_NAME: 'Westley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9405409,
        LOCATION_LATITUDE_DEG: 52.6564877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051700',
        LOCATION_NAME: 'Westley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6717234,
        LOCATION_LATITUDE_DEG: 52.2492043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE051900',
        LOCATION_NAME: 'Westley Waterless',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3684062,
        LOCATION_LATITUDE_DEG: 52.1815057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052000',
        LOCATION_NAME: 'Westlinton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9483207,
        LOCATION_LATITUDE_DEG: 54.9714118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052100',
        LOCATION_NAME: 'Westmancote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0862571,
        LOCATION_LATITUDE_DEG: 52.0381226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052200',
        LOCATION_NAME: 'Westmarsh',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2672279,
        LOCATION_LATITUDE_DEG: 51.3056048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052300',
        LOCATION_NAME: 'Westmead',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8164632,
        LOCATION_LATITUDE_DEG: 51.5629699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052400',
        LOCATION_NAME: 'Westmeston',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0963356,
        LOCATION_LATITUDE_DEG: 50.9060838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052500',
        LOCATION_NAME: 'Westmill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0100251,
        LOCATION_LATITUDE_DEG: 51.9247793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE066200',
        LOCATION_NAME: 'Westminster',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1434161,
        LOCATION_LATITUDE_DEG: 51.5004085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052600',
        LOCATION_NAME: 'Westmuir',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0346851,
        LOCATION_LATITUDE_DEG: 56.6614838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052700',
        LOCATION_NAME: 'Westnewton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3432042,
        LOCATION_LATITUDE_DEG: 54.7853022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052800',
        LOCATION_NAME: 'Westoe',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4149351,
        LOCATION_LATITUDE_DEG: 54.9869941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054300',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2182179,
        LOCATION_LATITUDE_DEG: 50.7947131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054200',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.180226,
        LOCATION_LATITUDE_DEG: 50.6897024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053600',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0444676,
        LOCATION_LATITUDE_DEG: 52.8410117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054550',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7349099,
        LOCATION_LATITUDE_DEG: 53.3204826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053900',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6466362,
        LOCATION_LATITUDE_DEG: 52.8548046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053700',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5932489,
        LOCATION_LATITUDE_DEG: 52.5322773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054100',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4434521,
        LOCATION_LATITUDE_DEG: 50.5376829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053200',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3996224,
        LOCATION_LATITUDE_DEG: 53.0664195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054000',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3913119,
        LOCATION_LATITUDE_DEG: 51.3962601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053800',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0350111,
        LOCATION_LATITUDE_DEG: 52.8410965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE052900',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7280506,
        LOCATION_LATITUDE_DEG: 53.9189936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053400',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4292799,
        LOCATION_LATITUDE_DEG: 51.4622587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053100',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1388013,
        LOCATION_LATITUDE_DEG: 52.1172198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054400',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9599209,
        LOCATION_LATITUDE_DEG: 50.9905045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053000',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8393053,
        LOCATION_LATITUDE_DEG: 53.2029135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053300',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1682693,
        LOCATION_LATITUDE_DEG: 51.9546873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE053500',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.081014,
        LOCATION_LATITUDE_DEG: 52.8081636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054500',
        LOCATION_NAME: 'Weston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5756672,
        LOCATION_LATITUDE_DEG: 52.4285094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054600',
        LOCATION_NAME: 'Weston Bampfylde',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5566815,
        LOCATION_LATITUDE_DEG: 51.0217323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054700',
        LOCATION_NAME: 'Weston Bank',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0549524,
        LOCATION_LATITUDE_DEG: 52.8417003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054800',
        LOCATION_NAME: 'Weston Beggard',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6062449,
        LOCATION_LATITUDE_DEG: 52.0688302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056500',
        LOCATION_NAME: 'Weston by Welland',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8537939,
        LOCATION_LATITUDE_DEG: 52.5142505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE054900',
        LOCATION_NAME: 'Weston Colville',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3640054,
        LOCATION_LATITUDE_DEG: 52.1525994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055000',
        LOCATION_NAME: 'Weston Corbett',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0152,
        LOCATION_LATITUDE_DEG: 51.2162322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055100',
        LOCATION_NAME: 'Weston Coyney',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1114573,
        LOCATION_LATITUDE_DEG: 52.9897138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055200',
        LOCATION_NAME: 'Weston Favell',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8398246,
        LOCATION_LATITUDE_DEG: 52.2490233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055300',
        LOCATION_NAME: 'Weston Green',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3759589,
        LOCATION_LATITUDE_DEG: 52.1447956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055400',
        LOCATION_NAME: 'Weston Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3269206,
        LOCATION_LATITUDE_DEG: 52.7165904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055500',
        LOCATION_NAME: 'Weston Hills',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1089187,
        LOCATION_LATITUDE_DEG: 52.7792623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063900',
        LOCATION_NAME: 'Weston in Gordano',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064500',
        LOCATION_NAME: 'Weston Jones',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055600',
        LOCATION_NAME: 'Weston Longville',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1273284,
        LOCATION_LATITUDE_DEG: 52.6989358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055700',
        LOCATION_NAME: 'Weston Lullingfields',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8532363,
        LOCATION_LATITUDE_DEG: 52.818301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055800',
        LOCATION_NAME: 'Weston Mill',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1791318,
        LOCATION_LATITUDE_DEG: 50.3998882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056600',
        LOCATION_NAME: 'Weston on Avon',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7686711,
        LOCATION_LATITUDE_DEG: 52.1646278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064100',
        LOCATION_NAME: 'Weston on the Green',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064000',
        LOCATION_NAME: 'Weston on Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE055900',
        LOCATION_NAME: 'Weston Patrick',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0123959,
        LOCATION_LATITUDE_DEG: 51.2181241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056000',
        LOCATION_NAME: 'Weston Point',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7596938,
        LOCATION_LATITUDE_DEG: 53.3278519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056100',
        LOCATION_NAME: 'Weston Rhyn',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0653827,
        LOCATION_LATITUDE_DEG: 52.9135166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064400',
        LOCATION_NAME: 'Weston Subedge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8200372,
        LOCATION_LATITUDE_DEG: 52.0702699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064200',
        LOCATION_NAME: 'Weston super Mare',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056200',
        LOCATION_NAME: 'Weston Turville',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7561343,
        LOCATION_LATITUDE_DEG: 51.7911773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE064300',
        LOCATION_NAME: 'Weston under Lizard',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056700',
        LOCATION_NAME: 'Weston under Penyard',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5358417,
        LOCATION_LATITUDE_DEG: 51.9074169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056800',
        LOCATION_NAME: 'Weston under Wetherley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4686058,
        LOCATION_LATITUDE_DEG: 52.3202352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056400',
        LOCATION_NAME: 'Weston Underwood',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5644222,
        LOCATION_LATITUDE_DEG: 52.9791058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056300',
        LOCATION_NAME: 'Weston Underwood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7369792,
        LOCATION_LATITUDE_DEG: 52.1453152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057600',
        LOCATION_NAME: 'Westonbirt',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2089698,
        LOCATION_LATITUDE_DEG: 51.6031773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057700',
        LOCATION_NAME: 'Westoning',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.495379,
        LOCATION_LATITUDE_DEG: 51.9809946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057100',
        LOCATION_NAME: 'Weston-in-Gordano',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8000259,
        LOCATION_LATITUDE_DEG: 51.4623482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE056900',
        LOCATION_NAME: 'Weston-Jones',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.353997,
        LOCATION_LATITUDE_DEG: 52.8130989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057300',
        LOCATION_NAME: 'Weston-on-the-Green',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2250621,
        LOCATION_LATITUDE_DEG: 51.8643891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057200',
        LOCATION_NAME: 'Weston-on-Trent',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3999129,
        LOCATION_LATITUDE_DEG: 52.848288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057000',
        LOCATION_NAME: 'Weston-Subedge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8163484,
        LOCATION_LATITUDE_DEG: 52.0696168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057400',
        LOCATION_NAME: 'Weston-super-Mare',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9779825,
        LOCATION_LATITUDE_DEG: 51.3471663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057500',
        LOCATION_NAME: 'Weston-under-Lizard',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2836075,
        LOCATION_LATITUDE_DEG: 52.6949894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057800',
        LOCATION_NAME: 'Westonzoyland',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9269173,
        LOCATION_LATITUDE_DEG: 51.108345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058000',
        LOCATION_NAME: 'Westover',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9318076,
        LOCATION_LATITUDE_DEG: 50.3857836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE057900',
        LOCATION_NAME: 'Westover',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8406754,
        LOCATION_LATITUDE_DEG: 51.0329309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058100',
        LOCATION_NAME: 'Westow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8477135,
        LOCATION_LATITUDE_DEG: 54.0772971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058200',
        LOCATION_NAME: 'Westpoint',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4364466,
        LOCATION_LATITUDE_DEG: 50.7105083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058400',
        LOCATION_NAME: 'Westport',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.875821,
        LOCATION_LATITUDE_DEG: 50.9747277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058500',
        LOCATION_NAME: 'Westquarter',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7380213,
        LOCATION_LATITUDE_DEG: 55.9910233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058600',
        LOCATION_NAME: 'Westray',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9869999,
        LOCATION_LATITUDE_DEG: 59.3003471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058700',
        LOCATION_NAME: 'Westrigg',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7514856,
        LOCATION_LATITUDE_DEG: 55.8866148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058800',
        LOCATION_NAME: 'Westrip',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.251007,
        LOCATION_LATITUDE_DEG: 51.7497946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058900',
        LOCATION_NAME: 'Westrop',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1662031,
        LOCATION_LATITUDE_DEG: 51.4306618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059000',
        LOCATION_NAME: 'Westruther',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5842355,
        LOCATION_LATITUDE_DEG: 55.7420818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059100',
        LOCATION_NAME: 'Westtown',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6397855,
        LOCATION_LATITUDE_DEG: 53.6875717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059200',
        LOCATION_NAME: 'Westvale',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9013117,
        LOCATION_LATITUDE_DEG: 53.4813671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059300',
        LOCATION_NAME: 'Westward',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1292184,
        LOCATION_LATITUDE_DEG: 54.7937023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059400',
        LOCATION_NAME: 'Westward Ho',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2364496,
        LOCATION_LATITUDE_DEG: 51.0395454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059500',
        LOCATION_NAME: 'Westwater',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0246071,
        LOCATION_LATITUDE_DEG: 50.7904136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059700',
        LOCATION_NAME: 'Westwell',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6726734,
        LOCATION_LATITUDE_DEG: 51.7878864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059600',
        LOCATION_NAME: 'Westwell',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8476288,
        LOCATION_LATITUDE_DEG: 51.1912014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059900',
        LOCATION_NAME: 'Westwick',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8890276,
        LOCATION_LATITUDE_DEG: 54.5344596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE059800',
        LOCATION_NAME: 'Westwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3799118,
        LOCATION_LATITUDE_DEG: 52.790148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060300',
        LOCATION_NAME: 'Westwood',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5786946,
        LOCATION_LATITUDE_DEG: 55.8380035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060000',
        LOCATION_NAME: 'Westwood',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3941164,
        LOCATION_LATITUDE_DEG: 50.781015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060100',
        LOCATION_NAME: 'Westwood',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.353211,
        LOCATION_LATITUDE_DEG: 54.9807073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060600',
        LOCATION_NAME: 'Westwood',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2708033,
        LOCATION_LATITUDE_DEG: 51.3305578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060200',
        LOCATION_NAME: 'Westwood',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3210755,
        LOCATION_LATITUDE_DEG: 53.0562084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060500',
        LOCATION_NAME: 'Westwood',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2765321,
        LOCATION_LATITUDE_DEG: 52.5822525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060400',
        LOCATION_NAME: 'Westwood',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3966316,
        LOCATION_LATITUDE_DEG: 51.3631115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060700',
        LOCATION_NAME: 'Westwoodside',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8671272,
        LOCATION_LATITUDE_DEG: 53.4873434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060800',
        LOCATION_NAME: 'Wetheral',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8328253,
        LOCATION_LATITUDE_DEG: 54.8843044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE060900',
        LOCATION_NAME: 'Wetheral Pasture',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8408662,
        LOCATION_LATITUDE_DEG: 54.8714056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061000',
        LOCATION_NAME: 'Wetheral Shields',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8360644,
        LOCATION_LATITUDE_DEG: 54.8637991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061100',
        LOCATION_NAME: 'Wetherby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3854111,
        LOCATION_LATITUDE_DEG: 53.9283898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061200',
        LOCATION_NAME: 'Wetherden',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9415544,
        LOCATION_LATITUDE_DEG: 52.2269994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061300',
        LOCATION_NAME: 'Wetheringsett',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1166522,
        LOCATION_LATITUDE_DEG: 52.2579949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061400',
        LOCATION_NAME: 'Wethersfield',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4877851,
        LOCATION_LATITUDE_DEG: 51.9530807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061500',
        LOCATION_NAME: 'Wetley Rocks',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0506866,
        LOCATION_LATITUDE_DEG: 53.0416196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061600',
        LOCATION_NAME: 'Wetmore',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8148889,
        LOCATION_LATITUDE_DEG: 52.3854621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061700',
        LOCATION_NAME: 'Wettenhall',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5602116,
        LOCATION_LATITUDE_DEG: 53.1463328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061800',
        LOCATION_NAME: 'Wetton',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8405855,
        LOCATION_LATITUDE_DEG: 53.0943226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE061900',
        LOCATION_NAME: 'Wetwang',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5745832,
        LOCATION_LATITUDE_DEG: 54.0193909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062000',
        LOCATION_NAME: 'Wetwood',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3358362,
        LOCATION_LATITUDE_DEG: 52.8960079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062100',
        LOCATION_NAME: 'Wexcombe',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6079312,
        LOCATION_LATITUDE_DEG: 51.3300438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062300',
        LOCATION_NAME: 'Wexham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5723689,
        LOCATION_LATITUDE_DEG: 51.5410114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062400',
        LOCATION_NAME: 'Weybourne',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1427704,
        LOCATION_LATITUDE_DEG: 52.942565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062500',
        LOCATION_NAME: 'Weybread',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2977399,
        LOCATION_LATITUDE_DEG: 52.3740088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062600',
        LOCATION_NAME: 'Weybridge',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4572639,
        LOCATION_LATITUDE_DEG: 51.372036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062700',
        LOCATION_NAME: 'Weycroft',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.982095,
        LOCATION_LATITUDE_DEG: 50.7944128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062800',
        LOCATION_NAME: 'Weydale',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4689287,
        LOCATION_LATITUDE_DEG: 58.5640717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062900',
        LOCATION_NAME: 'Weyhill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.555371,
        LOCATION_LATITUDE_DEG: 51.2179393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063000',
        LOCATION_NAME: 'Weymouth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4521139,
        LOCATION_LATITUDE_DEG: 50.6051855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE063100',
        LOCATION_NAME: 'Weymouth',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3713821,
        LOCATION_LATITUDE_DEG: 52.9377074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000200',
        LOCATION_NAME: 'Whaddon',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.239962,
        LOCATION_LATITUDE_DEG: 51.8225007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000400',
        LOCATION_NAME: 'Whaddon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1685151,
        LOCATION_LATITUDE_DEG: 51.3473502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000300',
        LOCATION_NAME: 'Whaddon',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.719669,
        LOCATION_LATITUDE_DEG: 51.0350158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000500',
        LOCATION_NAME: 'Whaddon',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8264925,
        LOCATION_LATITUDE_DEG: 51.9999026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000100',
        LOCATION_NAME: 'Whaddon',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.025304,
        LOCATION_LATITUDE_DEG: 52.1016954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000600',
        LOCATION_NAME: 'Whale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7396884,
        LOCATION_LATITUDE_DEG: 54.5865731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000700',
        LOCATION_NAME: 'Whaley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2290409,
        LOCATION_LATITUDE_DEG: 53.2388234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000800',
        LOCATION_NAME: 'Whaley Bridge',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9825503,
        LOCATION_LATITUDE_DEG: 53.3296398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH000900',
        LOCATION_NAME: 'Whaley Thorns',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2007704,
        LOCATION_LATITUDE_DEG: 53.2344209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001000',
        LOCATION_NAME: 'Whalley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4050797,
        LOCATION_LATITUDE_DEG: 53.8208992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001100',
        LOCATION_NAME: 'Whalley Range',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2560364,
        LOCATION_LATITUDE_DEG: 53.4496569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001150',
        LOCATION_NAME: 'Whalsay',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9985988,
        LOCATION_LATITUDE_DEG: 60.3641617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001200',
        LOCATION_NAME: 'Whalton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7949505,
        LOCATION_LATITUDE_DEG: 55.1269179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001300',
        LOCATION_NAME: 'Whaplode',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0349717,
        LOCATION_LATITUDE_DEG: 52.7985619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001400',
        LOCATION_NAME: 'Whaplode Drove',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0464339,
        LOCATION_LATITUDE_DEG: 52.7016557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028700',
        LOCATION_NAME: 'Whaplode St Catherines',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001500',
        LOCATION_NAME: 'Whaplode St. Catherines',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0128208,
        LOCATION_LATITUDE_DEG: 52.7611639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001600',
        LOCATION_NAME: 'Wharles',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8384953,
        LOCATION_LATITUDE_DEG: 53.8145985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001700',
        LOCATION_NAME: 'Wharley End',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.627651,
        LOCATION_LATITUDE_DEG: 52.0744041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001800',
        LOCATION_NAME: 'Wharncliffe Side',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5498961,
        LOCATION_LATITUDE_DEG: 53.4452448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH001900',
        LOCATION_NAME: 'Wharram',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6775719,
        LOCATION_LATITUDE_DEG: 54.0816957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002000',
        LOCATION_NAME: 'Wharton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7201963,
        LOCATION_LATITUDE_DEG: 52.1974449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002100',
        LOCATION_NAME: 'Wharton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7335016,
        LOCATION_LATITUDE_DEG: 53.4316385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002200',
        LOCATION_NAME: 'Whashton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7680509,
        LOCATION_LATITUDE_DEG: 54.4506458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002300',
        LOCATION_NAME: 'Whassett',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7532671,
        LOCATION_LATITUDE_DEG: 54.2220386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002500',
        LOCATION_NAME: 'Whatcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.228627,
        LOCATION_LATITUDE_DEG: 50.8145021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002400',
        LOCATION_NAME: 'Whatcombe',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4233361,
        LOCATION_LATITUDE_DEG: 51.5237661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002600',
        LOCATION_NAME: 'Whatcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5625527,
        LOCATION_LATITUDE_DEG: 52.0986207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002700',
        LOCATION_NAME: 'Whateley',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B78',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6637911,
        LOCATION_LATITUDE_DEG: 52.5900641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002800',
        LOCATION_NAME: 'Whatfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9583701,
        LOCATION_LATITUDE_DEG: 52.0808864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990389',
        LOCATION_NAME: 'Whatley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH002900',
        LOCATION_NAME: 'Whatley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3775356,
        LOCATION_LATITUDE_DEG: 51.2243441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003000',
        LOCATION_NAME: 'Whatlington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5087151,
        LOCATION_LATITUDE_DEG: 50.9386853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003100',
        LOCATION_NAME: 'Whatstandwell',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5011149,
        LOCATION_LATITUDE_DEG: 53.0840162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003200',
        LOCATION_NAME: 'Whatton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8895958,
        LOCATION_LATITUDE_DEG: 52.9454892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003300',
        LOCATION_NAME: 'Whauphill',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4843145,
        LOCATION_LATITUDE_DEG: 54.8178132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003400',
        LOCATION_NAME: 'Wheal Boys',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2086227,
        LOCATION_LATITUDE_DEG: 50.2477787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003500',
        LOCATION_NAME: 'Wheal Buller',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.232826,
        LOCATION_LATITUDE_DEG: 50.2050819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003600',
        LOCATION_NAME: 'Wheal Butson',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1796258,
        LOCATION_LATITUDE_DEG: 50.2962872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003700',
        LOCATION_NAME: 'Wheal Friendly',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2019233,
        LOCATION_LATITUDE_DEG: 50.3145861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003800',
        LOCATION_NAME: 'Wheal Harmony',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2390235,
        LOCATION_LATITUDE_DEG: 50.2406816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH003900',
        LOCATION_NAME: 'Wheal Kitty',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1971284,
        LOCATION_LATITUDE_DEG: 50.3134856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004000',
        LOCATION_NAME: 'Wheal Mary',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2370272,
        LOCATION_LATITUDE_DEG: 50.2424827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004100',
        LOCATION_NAME: 'Wheal Rome',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.3144344,
        LOCATION_LATITUDE_DEG: 50.2150793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004200',
        LOCATION_NAME: 'Wheal Rose',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2022245,
        LOCATION_LATITUDE_DEG: 50.2569793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004300',
        LOCATION_NAME: 'Wheal Uny',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.2351267,
        LOCATION_LATITUDE_DEG: 50.2245775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004400',
        LOCATION_NAME: 'Wheat Common',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.720585,
        LOCATION_LATITUDE_DEG: 52.3344552,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004500',
        LOCATION_NAME: 'Wheat Leasows',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4827943,
        LOCATION_LATITUDE_DEG: 52.7219921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004600',
        LOCATION_NAME: 'Wheatacre',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6258774,
        LOCATION_LATITUDE_DEG: 52.4872136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004700',
        LOCATION_NAME: 'Wheatcroft',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4764696,
        LOCATION_LATITUDE_DEG: 53.1093165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004800',
        LOCATION_NAME: 'Wheatfield',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0048838,
        LOCATION_LATITUDE_DEG: 51.6891705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH004900',
        LOCATION_NAME: 'Wheathall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7435188,
        LOCATION_LATITUDE_DEG: 52.6370825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005000',
        LOCATION_NAME: 'Wheathampstead',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2922889,
        LOCATION_LATITUDE_DEG: 51.811371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005150',
        LOCATION_NAME: 'Wheathill',
        COUNTY_NAME: 'County Fermanagh',
        POSTCODE: 'BT92',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.7901733,
        LOCATION_LATITUDE_DEG: 54.2615763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005100',
        LOCATION_NAME: 'Wheathill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6067051,
        LOCATION_LATITUDE_DEG: 52.6836885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH991136',
        LOCATION_NAME: 'Wheathill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5580005,
        LOCATION_LATITUDE_DEG: 52.434993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005200',
        LOCATION_NAME: 'Wheatley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8873948,
        LOCATION_LATITUDE_DEG: 53.7366826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005300',
        LOCATION_NAME: 'Wheatley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1379377,
        LOCATION_LATITUDE_DEG: 51.7468834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005400',
        LOCATION_NAME: 'Wheatley Hill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4143126,
        LOCATION_LATITUDE_DEG: 54.7427716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990632',
        LOCATION_NAME: 'Wheatly',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005500',
        LOCATION_NAME: 'Wheaton Aston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2192419,
        LOCATION_LATITUDE_DEG: 52.7110843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005600',
        LOCATION_NAME: 'Wheddon Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5377327,
        LOCATION_LATITUDE_DEG: 51.1378459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005800',
        LOCATION_NAME: 'Wheeler End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8372674,
        LOCATION_LATITUDE_DEG: 51.6286659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005900',
        LOCATION_NAME: 'Wheelock',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.371658,
        LOCATION_LATITUDE_DEG: 53.1277239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006000',
        LOCATION_NAME: 'Wheelton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6043515,
        LOCATION_LATITUDE_DEG: 53.6853841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006100',
        LOCATION_NAME: 'Wheldrake',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9621834,
        LOCATION_LATITUDE_DEG: 53.8960834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006200',
        LOCATION_NAME: 'Whelford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7534459,
        LOCATION_LATITUDE_DEG: 51.6875781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006300',
        LOCATION_NAME: 'Whelpley Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5548897,
        LOCATION_LATITUDE_DEG: 51.7278688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006400',
        LOCATION_NAME: 'Whempstead',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0816979,
        LOCATION_LATITUDE_DEG: 51.8662733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006500',
        LOCATION_NAME: 'Whenby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0353881,
        LOCATION_LATITUDE_DEG: 54.1199109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006600',
        LOCATION_NAME: 'Whepstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6825607,
        LOCATION_LATITUDE_DEG: 52.1895989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006700',
        LOCATION_NAME: 'Wherstead',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1401252,
        LOCATION_LATITUDE_DEG: 52.0223727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006800',
        LOCATION_NAME: 'Wherwell',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4417488,
        LOCATION_LATITUDE_DEG: 51.1665247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH006900',
        LOCATION_NAME: 'Wherwell Wood',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4444766,
        LOCATION_LATITUDE_DEG: 51.1728329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007000',
        LOCATION_NAME: 'Wheston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8008325,
        LOCATION_LATITUDE_DEG: 53.2841394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007100',
        LOCATION_NAME: 'Whetham',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0294927,
        LOCATION_LATITUDE_DEG: 51.4100569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007200',
        LOCATION_NAME: 'Whetstone',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1779726,
        LOCATION_LATITUDE_DEG: 52.5709561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029500',
        LOCATION_NAME: 'Whetstone',
        COUNTY_NAME: 'London',
        POSTCODE: 'N20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1686611,
        LOCATION_LATITUDE_DEG: 51.6300593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007300',
        LOCATION_NAME: 'Wheyrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2558501,
        LOCATION_LATITUDE_DEG: 54.828105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007400',
        LOCATION_NAME: 'Whicham',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.325163,
        LOCATION_LATITUDE_DEG: 54.2326487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007500',
        LOCATION_NAME: 'Whichford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5416123,
        LOCATION_LATITUDE_DEG: 52.0092083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007600',
        LOCATION_NAME: 'Whickham',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6745603,
        LOCATION_LATITUDE_DEG: 54.9455994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007700',
        LOCATION_NAME: 'Whiddon Down',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8540875,
        LOCATION_LATITUDE_DEG: 50.7146151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007750',
        LOCATION_NAME: 'Whiddon Valley',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0328889,
        LOCATION_LATITUDE_DEG: 51.0723888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007800',
        LOCATION_NAME: 'Whilton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0675131,
        LOCATION_LATITUDE_DEG: 52.2770272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH007900',
        LOCATION_NAME: 'Whimple',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3549618,
        LOCATION_LATITUDE_DEG: 50.7663124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008000',
        LOCATION_NAME: 'Whimsey',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5109225,
        LOCATION_LATITUDE_DEG: 51.8317069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008100',
        LOCATION_NAME: 'Whinburgh',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9695597,
        LOCATION_LATITUDE_DEG: 52.6430336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008200',
        LOCATION_NAME: 'Whinfell',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.67526,
        LOCATION_LATITUDE_DEG: 54.3765541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008300',
        LOCATION_NAME: 'Whinfell',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6503621,
        LOCATION_LATITUDE_DEG: 54.6380749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029900',
        LOCATION_NAME: 'Whingate',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.600871,
        LOCATION_LATITUDE_DEG: 53.7957857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008400',
        LOCATION_NAME: 'Whinmoor',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4545374,
        LOCATION_LATITUDE_DEG: 53.8249814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008600',
        LOCATION_NAME: 'Whinney Hill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5331429,
        LOCATION_LATITUDE_DEG: 54.5256744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008500',
        LOCATION_NAME: 'Whinney Hill',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4093808,
        LOCATION_LATITUDE_DEG: 54.5647515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008700',
        LOCATION_NAME: 'Whinnyhill',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6245359,
        LOCATION_LATITUDE_DEG: 55.0125264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008800',
        LOCATION_NAME: 'Whins of Milton',
        COUNTY_NAME: 'Stirlingshire',
        POSTCODE: 'FK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.93137,
        LOCATION_LATITUDE_DEG: 56.0919345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH008900',
        LOCATION_NAME: 'Whippingham',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2717784,
        LOCATION_LATITUDE_DEG: 50.7398829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009000',
        LOCATION_NAME: 'Whipsnade',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5311892,
        LOCATION_LATITUDE_DEG: 51.8517829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009100',
        LOCATION_NAME: 'Whipton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4855569,
        LOCATION_LATITUDE_DEG: 50.7324145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029200',
        LOCATION_NAME: 'Whirlow',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5289618,
        LOCATION_LATITUDE_DEG: 53.344812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009200',
        LOCATION_NAME: 'Whisby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6474125,
        LOCATION_LATITUDE_DEG: 53.1955132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009300',
        LOCATION_NAME: 'Whisby Moor',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6348229,
        LOCATION_LATITUDE_DEG: 53.2063112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990147',
        LOCATION_NAME: 'Whissendine',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7716199,
        LOCATION_LATITUDE_DEG: 52.7219442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009400',
        LOCATION_NAME: 'Whissendine',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7695924,
        LOCATION_LATITUDE_DEG: 52.7192708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009500',
        LOCATION_NAME: 'Whissonsett',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8463011,
        LOCATION_LATITUDE_DEG: 52.7716476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009600',
        LOCATION_NAME: 'Whistley Green',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8599752,
        LOCATION_LATITUDE_DEG: 51.4621524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009700',
        LOCATION_NAME: 'Whistlow',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3433048,
        LOCATION_LATITUDE_DEG: 51.9262004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009900',
        LOCATION_NAME: 'Whiston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7870612,
        LOCATION_LATITUDE_DEG: 53.4195603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010100',
        LOCATION_NAME: 'Whiston',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9439542,
        LOCATION_LATITUDE_DEG: 53.021713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH009800',
        LOCATION_NAME: 'Whiston',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3075939,
        LOCATION_LATITUDE_DEG: 53.4067428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010000',
        LOCATION_NAME: 'Whiston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7560908,
        LOCATION_LATITUDE_DEG: 52.2362204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010150',
        LOCATION_NAME: 'Whitacre Heath',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6784531,
        LOCATION_LATITUDE_DEG: 52.5312143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010200',
        LOCATION_NAME: 'Whitbatch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7092618,
        LOCATION_LATITUDE_DEG: 52.3936599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010300',
        LOCATION_NAME: 'Whitbeck',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3523255,
        LOCATION_LATITUDE_DEG: 54.2435475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010400',
        LOCATION_NAME: 'Whitbourne',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4095107,
        LOCATION_LATITUDE_DEG: 52.2078426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010600',
        LOCATION_NAME: 'Whitburn',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6837102,
        LOCATION_LATITUDE_DEG: 55.8662065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010500',
        LOCATION_NAME: 'Whitburn',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'SR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3664367,
        LOCATION_LATITUDE_DEG: 54.9502891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010700',
        LOCATION_NAME: 'Whitby',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9081138,
        LOCATION_LATITUDE_DEG: 53.273845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010800',
        LOCATION_NAME: 'Whitby',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6154197,
        LOCATION_LATITUDE_DEG: 54.4849406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011400',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.1981391,
        LOCATION_LATITUDE_DEG: 51.8837421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011300',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1237024,
        LOCATION_LATITUDE_DEG: 50.5377947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011200',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2189554,
        LOCATION_LATITUDE_DEG: 51.5126813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH010900',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6799541,
        LOCATION_LATITUDE_DEG: 52.966119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011100',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6550861,
        LOCATION_LATITUDE_DEG: 51.8536076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011600',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5506774,
        LOCATION_LATITUDE_DEG: 51.4045674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011000',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3377585,
        LOCATION_LATITUDE_DEG: 51.2294376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011500',
        LOCATION_NAME: 'Whitchurch',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8362149,
        LOCATION_LATITUDE_DEG: 51.8810853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011700',
        LOCATION_NAME: 'Whitchurch Canonicorum',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8576716,
        LOCATION_LATITUDE_DEG: 50.7547059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011800',
        LOCATION_NAME: 'Whitchurch Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0735002,
        LOCATION_LATITUDE_DEG: 51.506453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH011900',
        LOCATION_NAME: 'Whitchurch on Thames',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0866113,
        LOCATION_LATITUDE_DEG: 51.4921584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012000',
        LOCATION_NAME: 'Whitcliffe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7165863,
        LOCATION_LATITUDE_DEG: 53.7250741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012100',
        LOCATION_NAME: 'Whitcombe',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4014387,
        LOCATION_LATITUDE_DEG: 50.6921979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012200',
        LOCATION_NAME: 'Whitcot',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9197982,
        LOCATION_LATITUDE_DEG: 52.519077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012300',
        LOCATION_NAME: 'Whitcott Keysett',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0608606,
        LOCATION_LATITUDE_DEG: 52.4292683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012500',
        LOCATION_NAME: 'White Colne',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7204966,
        LOCATION_LATITUDE_DEG: 51.9280712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012700',
        LOCATION_NAME: 'White Cross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9688126,
        LOCATION_LATITUDE_DEG: 50.3994971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012600',
        LOCATION_NAME: 'White Cross',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3096433,
        LOCATION_LATITUDE_DEG: 53.8780778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990653',
        LOCATION_NAME: 'White Gritt',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012800',
        LOCATION_NAME: 'White Hart',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF83',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1479893,
        LOCATION_LATITUDE_DEG: 51.5946925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029000',
        LOCATION_NAME: 'White Ladies Aston',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1152083,
        LOCATION_LATITUDE_DEG: 52.1720365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012900',
        LOCATION_NAME: 'White Moss',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0019951,
        LOCATION_LATITUDE_DEG: 54.4503635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013000',
        LOCATION_NAME: 'White Notley',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5920014,
        LOCATION_LATITUDE_DEG: 51.8350683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013100',
        LOCATION_NAME: 'White Roding',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2666117,
        LOCATION_LATITUDE_DEG: 51.7985685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990571',
        LOCATION_NAME: 'White Stone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013200',
        LOCATION_NAME: 'White Waltham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7769388,
        LOCATION_LATITUDE_DEG: 51.4878539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013400',
        LOCATION_NAME: 'Whiteball',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2842551,
        LOCATION_LATITUDE_DEG: 50.9620292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013500',
        LOCATION_NAME: 'Whitebridge',
        COUNTY_NAME: 'Inverness-Shire',
        POSTCODE: 'IV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5019101,
        LOCATION_LATITUDE_DEG: 57.204152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013600',
        LOCATION_NAME: 'Whitebrook',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6746287,
        LOCATION_LATITUDE_DEG: 51.7553024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990578',
        LOCATION_NAME: 'Whiteburn',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013700',
        LOCATION_NAME: 'Whitecairns',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1318957,
        LOCATION_LATITUDE_DEG: 57.2537299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013800',
        LOCATION_NAME: 'Whitecastle',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5766092,
        LOCATION_LATITUDE_DEG: 55.6627768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014100',
        LOCATION_NAME: 'Whitechapel',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7801654,
        LOCATION_LATITUDE_DEG: 51.0295446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014000',
        LOCATION_NAME: 'Whitechapel',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0902524,
        LOCATION_LATITUDE_DEG: 58.4436629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013900',
        LOCATION_NAME: 'Whitechapel',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.674852,
        LOCATION_LATITUDE_DEG: 53.8675071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029400',
        LOCATION_NAME: 'Whitechapel',
        COUNTY_NAME: 'London',
        POSTCODE: 'E1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0719257,
        LOCATION_LATITUDE_DEG: 51.5230069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014600',
        LOCATION_NAME: 'Whitecliff Bay',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0985125,
        LOCATION_LATITUDE_DEG: 50.6707767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014700',
        LOCATION_NAME: 'Whitecraig',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0387013,
        LOCATION_LATITUDE_DEG: 55.9198089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014800',
        LOCATION_NAME: 'Whitecroft',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5487761,
        LOCATION_LATITUDE_DEG: 51.7541949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014900',
        LOCATION_NAME: 'Whitecrook',
        COUNTY_NAME: 'Dunbartonshire',
        POSTCODE: 'G81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3828383,
        LOCATION_LATITUDE_DEG: 55.8996238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015300',
        LOCATION_NAME: 'Whitecross',
        COUNTY_NAME: 'County Armagh',
        POSTCODE: 'BT60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -6.5599741,
        LOCATION_LATITUDE_DEG: 54.2651732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015100',
        LOCATION_NAME: 'Whitecross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.471357,
        LOCATION_LATITUDE_DEG: 50.155472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015000',
        LOCATION_NAME: 'Whitecross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8709915,
        LOCATION_LATITUDE_DEG: 50.5121044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015200',
        LOCATION_NAME: 'Whitecross',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6133591,
        LOCATION_LATITUDE_DEG: 50.3463818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015400',
        LOCATION_NAME: 'Whitecross',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6504999,
        LOCATION_LATITUDE_DEG: 55.9728228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015500',
        LOCATION_NAME: 'Whitedale',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2099398,
        LOCATION_LATITUDE_DEG: 53.8506681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015600',
        LOCATION_NAME: 'Whiteface',
        COUNTY_NAME: 'Sutherland',
        POSTCODE: 'IV25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1767074,
        LOCATION_LATITUDE_DEG: 57.8754118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015700',
        LOCATION_NAME: 'Whitefield',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2850409,
        LOCATION_LATITUDE_DEG: 53.5508669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015800',
        LOCATION_NAME: 'Whiteford',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB51',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4678088,
        LOCATION_LATITUDE_DEG: 57.3254385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016200',
        LOCATION_NAME: 'Whitegate',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.55581,
        LOCATION_LATITUDE_DEG: 53.2188403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016300',
        LOCATION_NAME: 'Whitegates',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8728915,
        LOCATION_LATITUDE_DEG: 50.3815937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016400',
        LOCATION_NAME: 'Whitehall',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5502379,
        LOCATION_LATITUDE_DEG: 51.4625724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016700',
        LOCATION_NAME: 'Whitehaven',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5861199,
        LOCATION_LATITUDE_DEG: 54.5491807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016800',
        LOCATION_NAME: 'Whitehawk',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0943398,
        LOCATION_LATITUDE_DEG: 50.826378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016900',
        LOCATION_NAME: 'Whitehead',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.7073642,
        LOCATION_LATITUDE_DEG: 54.7643254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017100',
        LOCATION_NAME: 'Whitehill',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0318581,
        LOCATION_LATITUDE_DEG: 55.8881083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017000',
        LOCATION_NAME: 'Whitehill',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8757117,
        LOCATION_LATITUDE_DEG: 51.1003183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017200',
        LOCATION_NAME: 'Whitehills',
        COUNTY_NAME: 'Banffshire',
        POSTCODE: 'AB45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.578236,
        LOCATION_LATITUDE_DEG: 57.6766762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017400',
        LOCATION_NAME: 'Whitehouse',
        COUNTY_NAME: 'Argyll',
        POSTCODE: 'PA29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.4825674,
        LOCATION_LATITUDE_DEG: 55.7962193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017300',
        LOCATION_NAME: 'Whitehouse',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6312242,
        LOCATION_LATITUDE_DEG: 57.2238331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990614',
        LOCATION_NAME: 'Whitehouse',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7749408,
        LOCATION_LATITUDE_DEG: 51.6444529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017500',
        LOCATION_NAME: 'Whitehouse Common',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8073579,
        LOCATION_LATITUDE_DEG: 52.5736706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017550',
        LOCATION_NAME: 'Whitehouse Industrial Estate',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6466249,
        LOCATION_LATITUDE_DEG: 53.3083809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029800',
        LOCATION_NAME: 'Whiteinch',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3411008,
        LOCATION_LATITUDE_DEG: 55.8755261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017600',
        LOCATION_NAME: 'Whitekirk',
        COUNTY_NAME: 'East Lothian',
        POSTCODE: 'EH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6477204,
        LOCATION_LATITUDE_DEG: 56.0246111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017700',
        LOCATION_NAME: 'Whitelackington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8835959,
        LOCATION_LATITUDE_DEG: 50.9340272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH013300',
        LOCATION_NAME: 'White-Ladies-Aston',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1139314,
        LOCATION_LATITUDE_DEG: 52.1702305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017800',
        LOCATION_NAME: 'Whiteleaf',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.813895,
        LOCATION_LATITUDE_DEG: 51.7302742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH017900',
        LOCATION_NAME: 'Whiteleas',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4330776,
        LOCATION_LATITUDE_DEG: 54.9594976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018000',
        LOCATION_NAME: 'Whiteley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2507401,
        LOCATION_LATITUDE_DEG: 50.8909969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018100',
        LOCATION_NAME: 'Whiteley Bank',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2204813,
        LOCATION_LATITUDE_DEG: 50.6306708,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018200',
        LOCATION_NAME: 'Whiteley Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.11867,
        LOCATION_LATITUDE_DEG: 53.3049411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018300',
        LOCATION_NAME: 'Whiteley Village',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4333195,
        LOCATION_LATITUDE_DEG: 51.3507364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018400',
        LOCATION_NAME: 'Whitelye',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7038528,
        LOCATION_LATITUDE_DEG: 51.7132989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018500',
        LOCATION_NAME: 'Whitemere',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8667358,
        LOCATION_LATITUDE_DEG: 52.8896075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018600',
        LOCATION_NAME: 'Whitemill',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2333017,
        LOCATION_LATITUDE_DEG: 51.8700308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018700',
        LOCATION_NAME: 'Whitemire',
        COUNTY_NAME: 'Morayshire',
        POSTCODE: 'IV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7073603,
        LOCATION_LATITUDE_DEG: 57.5661773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018800',
        LOCATION_NAME: 'Whitemoor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8519972,
        LOCATION_LATITUDE_DEG: 50.3843933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018900',
        LOCATION_NAME: 'Whitemore',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1699581,
        LOCATION_LATITUDE_DEG: 53.1397258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH018950',
        LOCATION_NAME: 'Whitemore Heath',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3028367,
        LOCATION_LATITUDE_DEG: 52.9691163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019000',
        LOCATION_NAME: 'Whiteness',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2914572,
        LOCATION_LATITUDE_DEG: 60.2006217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019100',
        LOCATION_NAME: 'Whiteparish',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6499182,
        LOCATION_LATITUDE_DEG: 51.0108156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019200',
        LOCATION_NAME: 'Whiterashes',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2411321,
        LOCATION_LATITUDE_DEG: 57.3019373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029600',
        LOCATION_NAME: 'Whiterock',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9852736,
        LOCATION_LATITUDE_DEG: 54.5914151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019300',
        LOCATION_NAME: 'Whiterock',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8399842,
        LOCATION_LATITUDE_DEG: 50.5138011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019600',
        LOCATION_NAME: 'Whiteshill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2311126,
        LOCATION_LATITUDE_DEG: 51.7604911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019700',
        LOCATION_NAME: 'Whitesmith',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1729875,
        LOCATION_LATITUDE_DEG: 50.90308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019800',
        LOCATION_NAME: 'Whitestake',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7252103,
        LOCATION_LATITUDE_DEG: 53.7240868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019900',
        LOCATION_NAME: 'Whitestaunton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0217802,
        LOCATION_LATITUDE_DEG: 50.8891185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020000',
        LOCATION_NAME: 'Whitestone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6019502,
        LOCATION_LATITUDE_DEG: 50.7294161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020100',
        LOCATION_NAME: 'Whitestone',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6348345,
        LOCATION_LATITUDE_DEG: 52.0806298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020400',
        LOCATION_NAME: 'Whiteway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.118865,
        LOCATION_LATITUDE_DEG: 51.792697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020300',
        LOCATION_NAME: 'Whiteway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9633675,
        LOCATION_LATITUDE_DEG: 51.7245912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020600',
        LOCATION_NAME: 'Whitewell',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7498073,
        LOCATION_LATITUDE_DEG: 52.9661124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020500',
        LOCATION_NAME: 'Whitewell',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5191854,
        LOCATION_LATITUDE_DEG: 53.9165073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020700',
        LOCATION_NAME: 'Whitewell Bottom',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2474752,
        LOCATION_LATITUDE_DEG: 53.7095845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021100',
        LOCATION_NAME: 'Whitfield',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8391892,
        LOCATION_LATITUDE_DEG: 51.9959251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021200',
        LOCATION_NAME: 'Whitfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4699529,
        LOCATION_LATITUDE_DEG: 51.6210819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020900',
        LOCATION_NAME: 'Whitfield',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3470489,
        LOCATION_LATITUDE_DEG: 54.9203031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021000',
        LOCATION_NAME: 'Whitfield',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1140089,
        LOCATION_LATITUDE_DEG: 52.0504063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020800',
        LOCATION_NAME: 'Whitfield',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2920003,
        LOCATION_LATITUDE_DEG: 51.1617911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021300',
        LOCATION_NAME: 'Whitford',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2802842,
        LOCATION_LATITUDE_DEG: 53.2931576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021400',
        LOCATION_NAME: 'Whitford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0498915,
        LOCATION_LATITUDE_DEG: 50.7549056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021500',
        LOCATION_NAME: 'Whitgift',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7757151,
        LOCATION_LATITUDE_DEG: 53.6945588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021600',
        LOCATION_NAME: 'Whitgreave',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1482735,
        LOCATION_LATITUDE_DEG: 52.8507997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021700',
        LOCATION_NAME: 'Whithorn',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.413581,
        LOCATION_LATITUDE_DEG: 54.7339058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021800',
        LOCATION_NAME: 'Whiting Bay',
        COUNTY_NAME: 'Isle of Arran',
        POSTCODE: 'KA27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0939278,
        LOCATION_LATITUDE_DEG: 55.4905871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH021900',
        LOCATION_NAME: 'Whitland',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6133199,
        LOCATION_LATITUDE_DEG: 51.8191263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022000',
        LOCATION_NAME: 'Whitleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1569215,
        LOCATION_LATITUDE_DEG: 50.4168898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022100',
        LOCATION_NAME: 'Whitletts',
        COUNTY_NAME: 'Ayrshire',
        POSTCODE: 'KA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5942198,
        LOCATION_LATITUDE_DEG: 55.473883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022600',
        LOCATION_NAME: 'Whitley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3813779,
        LOCATION_LATITUDE_DEG: 52.8050934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022200',
        LOCATION_NAME: 'Whitley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1615533,
        LOCATION_LATITUDE_DEG: 51.393061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022300',
        LOCATION_NAME: 'Whitley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0071833,
        LOCATION_LATITUDE_DEG: 51.4604639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022500',
        LOCATION_NAME: 'Whitley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6624514,
        LOCATION_LATITUDE_DEG: 53.6540628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022400',
        LOCATION_NAME: 'Whitley',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1500975,
        LOCATION_LATITUDE_DEG: 53.6845677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990192',
        LOCATION_NAME: 'Whitley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9685503,
        LOCATION_LATITUDE_DEG: 51.4342366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022700',
        LOCATION_NAME: 'Whitley Bay',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4456886,
        LOCATION_LATITUDE_DEG: 55.0417991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022800',
        LOCATION_NAME: 'Whitley Bridge',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1523076,
        LOCATION_LATITUDE_DEG: 53.695164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH022900',
        LOCATION_NAME: 'Whitley Chapel',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1130604,
        LOCATION_LATITUDE_DEG: 54.9144009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023000',
        LOCATION_NAME: 'Whitley Village',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.491514,
        LOCATION_LATITUDE_DEG: 52.3928507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023100',
        LOCATION_NAME: 'Whitminster',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3302236,
        LOCATION_LATITUDE_DEG: 51.7735988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023200',
        LOCATION_NAME: 'Whitmore',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2824245,
        LOCATION_LATITUDE_DEG: 52.9652108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023300',
        LOCATION_NAME: 'Whitmore Park',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.515269,
        LOCATION_LATITUDE_DEG: 52.435353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023400',
        LOCATION_NAME: 'Whitmore Reans',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1431106,
        LOCATION_LATITUDE_DEG: 52.5945636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023500',
        LOCATION_NAME: 'Whitnage',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3839389,
        LOCATION_LATITUDE_DEG: 50.9320291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023600',
        LOCATION_NAME: 'Whitnal',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2962337,
        LOCATION_LATITUDE_DEG: 51.2595378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023700',
        LOCATION_NAME: 'Whitnash',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5202231,
        LOCATION_LATITUDE_DEG: 52.2702393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023800',
        LOCATION_NAME: 'Whitney',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9632898,
        LOCATION_LATITUDE_DEG: 50.9177211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028800',
        LOCATION_NAME: 'Whitney on Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0705091,
        LOCATION_LATITUDE_DEG: 52.1219974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH023900',
        LOCATION_NAME: 'Whitney-on-Wye',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0686997,
        LOCATION_LATITUDE_DEG: 52.11964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024000',
        LOCATION_NAME: 'Whitrigg',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2334725,
        LOCATION_LATITUDE_DEG: 54.7328973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024100',
        LOCATION_NAME: 'Whitsbury',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8193549,
        LOCATION_LATITUDE_DEG: 50.9727181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024200',
        LOCATION_NAME: 'Whitsbury Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8202833,
        LOCATION_LATITUDE_DEG: 50.9610102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024300',
        LOCATION_NAME: 'Whitsbury Cross',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8162847,
        LOCATION_LATITUDE_DEG: 50.9566152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024400',
        LOCATION_NAME: 'Whitsome',
        COUNTY_NAME: 'Berwickshire',
        POSTCODE: 'TD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2234895,
        LOCATION_LATITUDE_DEG: 55.7472842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024500',
        LOCATION_NAME: 'Whitson',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8976993,
        LOCATION_LATITUDE_DEG: 51.5470812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024600',
        LOCATION_NAME: 'Whitstable',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0263492,
        LOCATION_LATITUDE_DEG: 51.3566111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024700',
        LOCATION_NAME: 'Whitstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4574958,
        LOCATION_LATITUDE_DEG: 50.7590258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024800',
        LOCATION_NAME: 'Whittingham',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6864617,
        LOCATION_LATITUDE_DEG: 53.8195022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH024900',
        LOCATION_NAME: 'Whittingham',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8883029,
        LOCATION_LATITUDE_DEG: 55.4008411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025000',
        LOCATION_NAME: 'Whittingslow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8411076,
        LOCATION_LATITUDE_DEG: 52.4968697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025200',
        LOCATION_NAME: 'Whittington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0014858,
        LOCATION_LATITUDE_DEG: 52.8741086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025400',
        LOCATION_NAME: 'Whittington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6109277,
        LOCATION_LATITUDE_DEG: 54.1810294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025300',
        LOCATION_NAME: 'Whittington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1820548,
        LOCATION_LATITUDE_DEG: 52.1720332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025100',
        LOCATION_NAME: 'Whittington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9792203,
        LOCATION_LATITUDE_DEG: 51.8865057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025600',
        LOCATION_NAME: 'Whittington',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7623058,
        LOCATION_LATITUDE_DEG: 52.6714807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025500',
        LOCATION_NAME: 'Whittington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5581782,
        LOCATION_LATITUDE_DEG: 52.5899689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025700',
        LOCATION_NAME: 'Whittington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5319525,
        LOCATION_LATITUDE_DEG: 52.5637356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025750',
        LOCATION_NAME: 'Whittington Barracks',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7691522,
        LOCATION_LATITUDE_DEG: 52.6605255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025800',
        LOCATION_NAME: 'Whittington Moor',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.437031,
        LOCATION_LATITUDE_DEG: 53.255333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028900',
        LOCATION_NAME: 'Whittle le Woods',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026000',
        LOCATION_NAME: 'Whittlebury',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9904478,
        LOCATION_LATITUDE_DEG: 52.0898135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH025900',
        LOCATION_NAME: 'Whittle-le-Woods',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6369538,
        LOCATION_LATITUDE_DEG: 53.6852871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026100',
        LOCATION_NAME: 'Whittlesey',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1290991,
        LOCATION_LATITUDE_DEG: 52.5563472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026200',
        LOCATION_NAME: 'Whittlesford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1515511,
        LOCATION_LATITUDE_DEG: 52.1130963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026700',
        LOCATION_NAME: 'Whitton',
        COUNTY_NAME: 'Powys',
        POSTCODE: 'LD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0687581,
        LOCATION_LATITUDE_DEG: 52.2989541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026600',
        LOCATION_NAME: 'Whitton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6232256,
        LOCATION_LATITUDE_DEG: 52.3510584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026300',
        LOCATION_NAME: 'Whitton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9110399,
        LOCATION_LATITUDE_DEG: 55.3039381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026400',
        LOCATION_NAME: 'Whitton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6336062,
        LOCATION_LATITUDE_DEG: 53.7046639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026500',
        LOCATION_NAME: 'Whitton',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3151337,
        LOCATION_LATITUDE_DEG: 51.4328437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026800',
        LOCATION_NAME: 'Whitton Leyer',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1119298,
        LOCATION_LATITUDE_DEG: 52.0771808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH026900',
        LOCATION_NAME: 'Whitton Village',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4143126,
        LOCATION_LATITUDE_DEG: 54.6026778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027000',
        LOCATION_NAME: 'Whittonstall',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8869231,
        LOCATION_LATITUDE_DEG: 54.9090983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027100',
        LOCATION_NAME: 'Whitway',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3442038,
        LOCATION_LATITUDE_DEG: 51.3281448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027600',
        LOCATION_NAME: 'Whitwell',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.567473,
        LOCATION_LATITUDE_DEG: 54.3848403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027400',
        LOCATION_NAME: 'Whitwell',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2639988,
        LOCATION_LATITUDE_DEG: 50.5994747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027500',
        LOCATION_NAME: 'Whitwell',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2078486,
        LOCATION_LATITUDE_DEG: 53.285226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990148',
        LOCATION_NAME: 'Whitwell',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6356607,
        LOCATION_LATITUDE_DEG: 52.6708165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027200',
        LOCATION_NAME: 'Whitwell',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6344466,
        LOCATION_LATITUDE_DEG: 52.6689593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027300',
        LOCATION_NAME: 'Whitwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2815998,
        LOCATION_LATITUDE_DEG: 51.8760813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990858',
        LOCATION_NAME: 'Whitwell Common',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027700',
        LOCATION_NAME: 'Whitwell Common',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2358628,
        LOCATION_LATITUDE_DEG: 53.2899308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027800',
        LOCATION_NAME: 'Whitwick',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE67',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3560274,
        LOCATION_LATITUDE_DEG: 52.7409791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH027900',
        LOCATION_NAME: 'Whitwood',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3843325,
        LOCATION_LATITUDE_DEG: 53.7136698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028000',
        LOCATION_NAME: 'Whitwood Mere',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.368349,
        LOCATION_LATITUDE_DEG: 53.7255694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028100',
        LOCATION_NAME: 'Whitworth',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1759915,
        LOCATION_LATITUDE_DEG: 53.6557756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028200',
        LOCATION_NAME: 'Whixall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7278397,
        LOCATION_LATITUDE_DEG: 52.9047089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028300',
        LOCATION_NAME: 'Whixley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3207053,
        LOCATION_LATITUDE_DEG: 54.0139037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028400',
        LOCATION_NAME: 'Whorlton',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8369591,
        LOCATION_LATITUDE_DEG: 54.5300594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028500',
        LOCATION_NAME: 'Whorlton Grange',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6997944,
        LOCATION_LATITUDE_DEG: 55.0059062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH028600',
        LOCATION_NAME: 'Whyteleafe',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0783851,
        LOCATION_LATITUDE_DEG: 51.3083241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000100',
        LOCATION_NAME: 'Wibsey',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7778968,
        LOCATION_LATITUDE_DEG: 53.768486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000200',
        LOCATION_NAME: 'Wibtoft',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2930067,
        LOCATION_LATITUDE_DEG: 52.4852493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000300',
        LOCATION_NAME: 'Wichenford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3104969,
        LOCATION_LATITUDE_DEG: 52.2432382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000400',
        LOCATION_NAME: 'Wichling',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.754075,
        LOCATION_LATITUDE_DEG: 51.2717094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990759',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000800',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.550768,
        LOCATION_LATITUDE_DEG: 51.4374827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000500',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1563176,
        LOCATION_LATITUDE_DEG: 50.8395213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001100',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.090402,
        LOCATION_LATITUDE_DEG: 58.442961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000600',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8545827,
        LOCATION_LATITUDE_DEG: 51.0376325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001000',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4222857,
        LOCATION_LATITUDE_DEG: 51.4518712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000700',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4144283,
        LOCATION_LATITUDE_DEG: 51.6741929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI000900',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0486993,
        LOCATION_LATITUDE_DEG: 52.1062288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001200',
        LOCATION_NAME: 'Wick',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5421948,
        LOCATION_LATITUDE_DEG: 50.8212857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001300',
        LOCATION_NAME: 'Wick Airport',
        COUNTY_NAME: 'Caithness',
        POSTCODE: 'KW1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.087642,
        LOCATION_LATITUDE_DEG: 58.4534586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042400',
        LOCATION_NAME: 'Wick St Lawrence',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001400',
        LOCATION_NAME: 'Wick St. Lawrence',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.911845,
        LOCATION_LATITUDE_DEG: 51.3836626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001600',
        LOCATION_NAME: 'Wicken',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9115107,
        LOCATION_LATITUDE_DEG: 52.0469024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001500',
        LOCATION_NAME: 'Wicken',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.298796,
        LOCATION_LATITUDE_DEG: 52.3124119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001700',
        LOCATION_NAME: 'Wicken Bonhunt',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1838516,
        LOCATION_LATITUDE_DEG: 51.9776843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001800',
        LOCATION_NAME: 'Wicken Green Village',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7446293,
        LOCATION_LATITUDE_DEG: 52.8511623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI001900',
        LOCATION_NAME: 'Wickenby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3662026,
        LOCATION_LATITUDE_DEG: 53.3226167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002000',
        LOCATION_NAME: 'Wickersgill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6647581,
        LOCATION_LATITUDE_DEG: 54.4926598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002100',
        LOCATION_NAME: 'Wickersley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2787195,
        LOCATION_LATITUDE_DEG: 53.4194452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002200',
        LOCATION_NAME: 'Wickford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'SS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5248224,
        LOCATION_LATITUDE_DEG: 51.6102455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002300',
        LOCATION_NAME: 'Wickham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4308395,
        LOCATION_LATITUDE_DEG: 51.4433546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002400',
        LOCATION_NAME: 'Wickham',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1868012,
        LOCATION_LATITUDE_DEG: 50.8987982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002500',
        LOCATION_NAME: 'Wickham Bishops',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6699914,
        LOCATION_LATITUDE_DEG: 51.7778546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002600',
        LOCATION_NAME: 'Wickham Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1576207,
        LOCATION_LATITUDE_DEG: 50.894697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002700',
        LOCATION_NAME: 'Wickham Heath',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3985198,
        LOCATION_LATITUDE_DEG: 51.4257564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002800',
        LOCATION_NAME: 'Wickham Market',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3650618,
        LOCATION_LATITUDE_DEG: 52.1512853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI002900',
        LOCATION_NAME: 'Wickham Skeith',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.071928,
        LOCATION_LATITUDE_DEG: 52.2784974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042500',
        LOCATION_NAME: 'Wickham St Paul',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003000',
        LOCATION_NAME: 'Wickham St. Paul',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6676896,
        LOCATION_LATITUDE_DEG: 51.9957832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003100',
        LOCATION_NAME: 'Wickham Street',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5703714,
        LOCATION_LATITUDE_DEG: 52.1569953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003200',
        LOCATION_NAME: 'Wickhambreaux',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1844258,
        LOCATION_LATITUDE_DEG: 51.2848045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003300',
        LOCATION_NAME: 'Wickhambrook',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.562211,
        LOCATION_LATITUDE_DEG: 52.1607974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003400',
        LOCATION_NAME: 'Wickhamford',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9022845,
        LOCATION_LATITUDE_DEG: 52.0707174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003500',
        LOCATION_NAME: 'Wickhampton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5815876,
        LOCATION_LATITUDE_DEG: 52.5921204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003600',
        LOCATION_NAME: 'Wicklewood',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0638488,
        LOCATION_LATITUDE_DEG: 52.5789309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003800',
        LOCATION_NAME: 'Wickmere',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2271821,
        LOCATION_LATITUDE_DEG: 52.8538568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003900',
        LOCATION_NAME: 'Wickwar',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3985453,
        LOCATION_LATITUDE_DEG: 51.5947825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004000',
        LOCATION_NAME: 'Widcombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.342525,
        LOCATION_LATITUDE_DEG: 51.3716558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004100',
        LOCATION_NAME: 'Widdicombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6657839,
        LOCATION_LATITUDE_DEG: 50.2621692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004200',
        LOCATION_NAME: 'Widdington',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2394283,
        LOCATION_LATITUDE_DEG: 51.9619809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004300',
        LOCATION_NAME: 'Widdop',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'HX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0516739,
        LOCATION_LATITUDE_DEG: 53.7763842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004400',
        LOCATION_NAME: 'Widdrington',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5998866,
        LOCATION_LATITUDE_DEG: 55.2574282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004500',
        LOCATION_NAME: 'Widdrington Station',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6134815,
        LOCATION_LATITUDE_DEG: 55.2380064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042800',
        LOCATION_NAME: 'Widecombe in the Moor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7051366,
        LOCATION_LATITUDE_DEG: 50.6076501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004600',
        LOCATION_NAME: 'Widecombe-in-the-Moor',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8096156,
        LOCATION_LATITUDE_DEG: 50.5732068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004700',
        LOCATION_NAME: 'Widegates',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4073498,
        LOCATION_LATITUDE_DEG: 50.393687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004800',
        LOCATION_NAME: 'Widemouth Bay',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5508363,
        LOCATION_LATITUDE_DEG: 50.7894308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI004900',
        LOCATION_NAME: 'Wideopen',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6225414,
        LOCATION_LATITUDE_DEG: 55.0484074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005000',
        LOCATION_NAME: 'Widewell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6616747,
        LOCATION_LATITUDE_DEG: 50.2666716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005300',
        LOCATION_NAME: 'Widford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6059739,
        LOCATION_LATITUDE_DEG: 51.8046948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005200',
        LOCATION_NAME: 'Widford',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.060965,
        LOCATION_LATITUDE_DEG: 51.8232729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005100',
        LOCATION_NAME: 'Widford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4529831,
        LOCATION_LATITUDE_DEG: 51.7186559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005400',
        LOCATION_NAME: 'Widley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0443192,
        LOCATION_LATITUDE_DEG: 50.8587939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005500',
        LOCATION_NAME: 'Widmer End',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7172643,
        LOCATION_LATITUDE_DEG: 51.6614629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005600',
        LOCATION_NAME: 'Widmerpool',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.060382,
        LOCATION_LATITUDE_DEG: 52.845583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005700',
        LOCATION_NAME: 'Widnes',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7234134,
        LOCATION_LATITUDE_DEG: 53.3686578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005800',
        LOCATION_NAME: 'Widworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.109028,
        LOCATION_LATITUDE_DEG: 50.7866105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI005900',
        LOCATION_NAME: 'Wigan',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6304348,
        LOCATION_LATITUDE_DEG: 53.5457694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006000',
        LOCATION_NAME: 'Wigborough',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.784285,
        LOCATION_LATITUDE_DEG: 50.932623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006100',
        LOCATION_NAME: 'Wigfach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6558509,
        LOCATION_LATITUDE_DEG: 51.4886836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006200',
        LOCATION_NAME: 'Wiggaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2740162,
        LOCATION_LATITUDE_DEG: 50.7352058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST112200',
        LOCATION_NAME: 'Wiggenhall St Germans',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042200',
        LOCATION_NAME: 'Wiggenhall St Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042300',
        LOCATION_NAME: 'Wiggenhall St Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST008100',
        LOCATION_NAME: 'Wiggenhall St. Germans',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3634592,
        LOCATION_LATITUDE_DEG: 52.7009524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006300',
        LOCATION_NAME: 'Wiggenhall St. Mary',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3625109,
        LOCATION_LATITUDE_DEG: 52.67545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006400',
        LOCATION_NAME: 'Wiggenhall St. Peter',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3747507,
        LOCATION_LATITUDE_DEG: 52.6932537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006800',
        LOCATION_NAME: 'Wigginton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B79',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6910147,
        LOCATION_LATITUDE_DEG: 52.6570749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006500',
        LOCATION_NAME: 'Wigginton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4336212,
        LOCATION_LATITUDE_DEG: 51.9969053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006600',
        LOCATION_NAME: 'Wigginton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0869161,
        LOCATION_LATITUDE_DEG: 54.0185938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006700',
        LOCATION_NAME: 'Wigginton',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6371826,
        LOCATION_LATITUDE_DEG: 51.7828803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI006900',
        LOCATION_NAME: 'Wigginton Heath',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4389503,
        LOCATION_LATITUDE_DEG: 52.0134129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007000',
        LOCATION_NAME: 'Wigglesworth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2901693,
        LOCATION_LATITUDE_DEG: 54.0079131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007100',
        LOCATION_NAME: 'Wiggonby',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0963797,
        LOCATION_LATITUDE_DEG: 54.8672019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007200',
        LOCATION_NAME: 'Wighill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2796698,
        LOCATION_LATITUDE_DEG: 53.9127905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007300',
        LOCATION_NAME: 'Wighill Park',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'LS24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2901239,
        LOCATION_LATITUDE_DEG: 53.9310915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007400',
        LOCATION_NAME: 'Wighton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8836744,
        LOCATION_LATITUDE_DEG: 52.9224652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007500',
        LOCATION_NAME: 'Wightwick',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1877742,
        LOCATION_LATITUDE_DEG: 52.5845304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007700',
        LOCATION_NAME: 'Wigley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6989917,
        LOCATION_LATITUDE_DEG: 52.3873642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007600',
        LOCATION_NAME: 'Wigley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5263463,
        LOCATION_LATITUDE_DEG: 53.2432253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007800',
        LOCATION_NAME: 'Wigmarsh',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9239514,
        LOCATION_LATITUDE_DEG: 52.8197046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI007900',
        LOCATION_NAME: 'Wigmore',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8598445,
        LOCATION_LATITUDE_DEG: 52.3160533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008000',
        LOCATION_NAME: 'Wigmore',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5837927,
        LOCATION_LATITUDE_DEG: 51.3507098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008100',
        LOCATION_NAME: 'Wigsley',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7119516,
        LOCATION_LATITUDE_DEG: 53.2215188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008200',
        LOCATION_NAME: 'Wigsthorpe',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4649331,
        LOCATION_LATITUDE_DEG: 52.4326409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008300',
        LOCATION_NAME: 'Wigston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1013231,
        LOCATION_LATITUDE_DEG: 52.5869609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008500',
        LOCATION_NAME: 'Wigston Parva',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3138403,
        LOCATION_LATITUDE_DEG: 52.5036509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008600',
        LOCATION_NAME: 'Wigthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1090734,
        LOCATION_LATITUDE_DEG: 53.3452299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008700',
        LOCATION_NAME: 'Wigtoft',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1210217,
        LOCATION_LATITUDE_DEG: 52.9074793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008800',
        LOCATION_NAME: 'Wigton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1598171,
        LOCATION_LATITUDE_DEG: 54.8247013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI008900',
        LOCATION_NAME: 'Wigtown',
        COUNTY_NAME: 'Wigtownshire',
        POSTCODE: 'DG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4427186,
        LOCATION_LATITUDE_DEG: 54.8676185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009000',
        LOCATION_NAME: 'Wigwig',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5805734,
        LOCATION_LATITUDE_DEG: 52.6096806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009100',
        LOCATION_NAME: 'Wike',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4873522,
        LOCATION_LATITUDE_DEG: 53.8737928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009200',
        LOCATION_NAME: 'Wilbarston',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8031665,
        LOCATION_LATITUDE_DEG: 52.486649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009300',
        LOCATION_NAME: 'Wilberfoss',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8906403,
        LOCATION_LATITUDE_DEG: 53.9486874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009400',
        LOCATION_NAME: 'Wilburton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1784366,
        LOCATION_LATITUDE_DEG: 52.3516186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009500',
        LOCATION_NAME: 'Wilby',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7275064,
        LOCATION_LATITUDE_DEG: 52.2862253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009600',
        LOCATION_NAME: 'Wilby',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9929148,
        LOCATION_LATITUDE_DEG: 52.4685178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009700',
        LOCATION_NAME: 'Wilby',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2868345,
        LOCATION_LATITUDE_DEG: 52.3002033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009800',
        LOCATION_NAME: 'Wilcot',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.794129,
        LOCATION_LATITUDE_DEG: 51.3485495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI009900',
        LOCATION_NAME: 'Wilcote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4571817,
        LOCATION_LATITUDE_DEG: 51.838497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010000',
        LOCATION_NAME: 'Wilcott',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9236803,
        LOCATION_LATITUDE_DEG: 52.7606998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010100',
        LOCATION_NAME: 'Wilcott Camp',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9353429,
        LOCATION_LATITUDE_DEG: 52.7633956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010200',
        LOCATION_NAME: 'Wilcove',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.205202,
        LOCATION_LATITUDE_DEG: 50.3878826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010300',
        LOCATION_NAME: 'Wilcrick',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8517942,
        LOCATION_LATITUDE_DEG: 51.5889874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010400',
        LOCATION_NAME: 'Wildboarclough',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0259097,
        LOCATION_LATITUDE_DEG: 53.2148294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010500',
        LOCATION_NAME: 'Wilden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3957075,
        LOCATION_LATITUDE_DEG: 52.1825131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010600',
        LOCATION_NAME: 'Wildhern',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4942989,
        LOCATION_LATITUDE_DEG: 51.2543378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010700',
        LOCATION_NAME: 'Wildhill',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'AL9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1662279,
        LOCATION_LATITUDE_DEG: 51.745468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010800',
        LOCATION_NAME: 'Wildmoor',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0594921,
        LOCATION_LATITUDE_DEG: 52.3811529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI010900',
        LOCATION_NAME: 'Wildsworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.781741,
        LOCATION_LATITUDE_DEG: 53.4703394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011000',
        LOCATION_NAME: 'Wilfholme',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4020031,
        LOCATION_LATITUDE_DEG: 53.9157793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011100',
        LOCATION_NAME: 'Wilford',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.158248,
        LOCATION_LATITUDE_DEG: 52.9273949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011200',
        LOCATION_NAME: 'Wilkesley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5525676,
        LOCATION_LATITUDE_DEG: 52.9653139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011300',
        LOCATION_NAME: 'Wilkieston',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4050505,
        LOCATION_LATITUDE_DEG: 55.9010137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011500',
        LOCATION_NAME: 'Wilksby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0811792,
        LOCATION_LATITUDE_DEG: 53.1473037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011600',
        LOCATION_NAME: 'Willand',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3688928,
        LOCATION_LATITUDE_DEG: 50.8912211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990541',
        LOCATION_NAME: 'Willaston',
        COUNTY_NAME: 'Isle of Man',
        POSTCODE: 'IM2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011700',
        LOCATION_NAME: 'Willaston',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH64',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0054114,
        LOCATION_LATITUDE_DEG: 53.2919977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011800',
        LOCATION_NAME: 'Willaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5987595,
        LOCATION_LATITUDE_DEG: 52.9169105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011900',
        LOCATION_NAME: 'Willaston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4778501,
        LOCATION_LATITUDE_DEG: 53.0667964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012100',
        LOCATION_NAME: 'Willen',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7179199,
        LOCATION_LATITUDE_DEG: 52.0618064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012200',
        LOCATION_NAME: 'Willen Lake',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7197748,
        LOCATION_LATITUDE_DEG: 52.0505054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012300',
        LOCATION_NAME: 'Willen Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7223053,
        LOCATION_LATITUDE_DEG: 52.0528079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012400',
        LOCATION_NAME: 'Willenhall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0528717,
        LOCATION_LATITUDE_DEG: 52.5828693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012500',
        LOCATION_NAME: 'Willerby',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4453413,
        LOCATION_LATITUDE_DEG: 53.7582599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012600',
        LOCATION_NAME: 'Willersey',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8475771,
        LOCATION_LATITUDE_DEG: 52.0553196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012700',
        LOCATION_NAME: 'Willersley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.005401,
        LOCATION_LATITUDE_DEG: 52.1194414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012800',
        LOCATION_NAME: 'Willesborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9183776,
        LOCATION_LATITUDE_DEG: 51.1327941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI043600',
        LOCATION_NAME: 'Willesden',
        COUNTY_NAME: 'London',
        POSTCODE: 'NW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2408887,
        LOCATION_LATITUDE_DEG: 51.5488928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013000',
        LOCATION_NAME: 'Willesley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2108059,
        LOCATION_LATITUDE_DEG: 51.5942806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012900',
        LOCATION_NAME: 'Willesley',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5027742,
        LOCATION_LATITUDE_DEG: 52.7279832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013100',
        LOCATION_NAME: 'Willett',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2803613,
        LOCATION_LATITUDE_DEG: 51.0927684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013300',
        LOCATION_NAME: 'Willey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4827539,
        LOCATION_LATITUDE_DEG: 52.5894765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013200',
        LOCATION_NAME: 'Willey',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2723016,
        LOCATION_LATITUDE_DEG: 52.4547514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013400',
        LOCATION_NAME: 'Williamscot',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.29809,
        LOCATION_LATITUDE_DEG: 52.1057141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013600',
        LOCATION_NAME: 'Williamstown',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4375184,
        LOCATION_LATITUDE_DEG: 51.6034912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013700',
        LOCATION_NAME: 'Willian',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.217076,
        LOCATION_LATITUDE_DEG: 51.9611921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013800',
        LOCATION_NAME: 'Willimoteswick',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3575907,
        LOCATION_LATITUDE_DEG: 54.9671057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013900',
        LOCATION_NAME: 'Willingale',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3121067,
        LOCATION_LATITUDE_DEG: 51.7402569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014000',
        LOCATION_NAME: 'Willingdon',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2567304,
        LOCATION_LATITUDE_DEG: 50.7994702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014100',
        LOCATION_NAME: 'Willingham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.059609,
        LOCATION_LATITUDE_DEG: 52.3139216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014300',
        LOCATION_NAME: 'Willingham by Stow',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.686315,
        LOCATION_LATITUDE_DEG: 53.350324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042100',
        LOCATION_NAME: 'Willingham St Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014200',
        LOCATION_NAME: 'Willingham St. Mary',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5824971,
        LOCATION_LATITUDE_DEG: 52.4084041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014750',
        LOCATION_NAME: 'Willington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.701664,
        LOCATION_LATITUDE_DEG: 53.1946876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014600',
        LOCATION_NAME: 'Willington',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6948744,
        LOCATION_LATITUDE_DEG: 54.7121205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014700',
        LOCATION_NAME: 'Willington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6089289,
        LOCATION_LATITUDE_DEG: 52.0478188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014400',
        LOCATION_NAME: 'Willington',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.563248,
        LOCATION_LATITUDE_DEG: 52.8531908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014500',
        LOCATION_NAME: 'Willington',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3709393,
        LOCATION_LATITUDE_DEG: 52.1337047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014800',
        LOCATION_NAME: 'Willington Quay',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4996284,
        LOCATION_LATITUDE_DEG: 54.9896996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI014900',
        LOCATION_NAME: 'Willisham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0144727,
        LOCATION_LATITUDE_DEG: 52.1157123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015000',
        LOCATION_NAME: 'Willitoft',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8702905,
        LOCATION_LATITUDE_DEG: 53.8049726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015100',
        LOCATION_NAME: 'Williton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3194156,
        LOCATION_LATITUDE_DEG: 51.1597501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015200',
        LOCATION_NAME: 'Willoughby',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2411034,
        LOCATION_LATITUDE_DEG: 52.3011357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015300',
        LOCATION_NAME: 'Willoughby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2039614,
        LOCATION_LATITUDE_DEG: 53.2233015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015500',
        LOCATION_NAME: 'Willoughby on the Wolds',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0534025,
        LOCATION_LATITUDE_DEG: 52.821684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015400',
        LOCATION_NAME: 'Willoughby Waterleys',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1529099,
        LOCATION_LATITUDE_DEG: 52.5260574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015600',
        LOCATION_NAME: 'Willoughton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5999019,
        LOCATION_LATITUDE_DEG: 53.4278366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI044000',
        LOCATION_NAME: 'Willowbrae',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1547878,
        LOCATION_LATITUDE_DEG: 55.9557817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015700',
        LOCATION_NAME: 'Willowholme',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9514977,
        LOCATION_LATITUDE_DEG: 54.8956024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015800',
        LOCATION_NAME: 'Willows',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4431351,
        LOCATION_LATITUDE_DEG: 53.5698748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI015900',
        LOCATION_NAME: 'Willows Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4984318,
        LOCATION_LATITUDE_DEG: 51.84947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016000',
        LOCATION_NAME: 'Wills Pastures',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3678012,
        LOCATION_LATITUDE_DEG: 52.1997295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016100',
        LOCATION_NAME: 'Willsbridge',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.499639,
        LOCATION_LATITUDE_DEG: 51.4352634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016200',
        LOCATION_NAME: 'Willslock',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8902755,
        LOCATION_LATITUDE_DEG: 52.8760957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016300',
        LOCATION_NAME: 'Willstone',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7306558,
        LOCATION_LATITUDE_DEG: 52.5506779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016400',
        LOCATION_NAME: 'Wilmcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7603309,
        LOCATION_LATITUDE_DEG: 52.2201335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016500',
        LOCATION_NAME: 'Wilmington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1153026,
        LOCATION_LATITUDE_DEG: 50.7933142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016700',
        LOCATION_NAME: 'Wilmington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4425389,
        LOCATION_LATITUDE_DEG: 51.3597561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016600',
        LOCATION_NAME: 'Wilmington',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1939859,
        LOCATION_LATITUDE_DEG: 50.819278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016800',
        LOCATION_NAME: 'Wilmington',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'DA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2031302,
        LOCATION_LATITUDE_DEG: 51.4268276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI016900',
        LOCATION_NAME: 'Wilminstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1284138,
        LOCATION_LATITUDE_DEG: 50.5649999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017000',
        LOCATION_NAME: 'Wilmslow',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2362428,
        LOCATION_LATITUDE_DEG: 53.3209478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017100',
        LOCATION_NAME: 'Wilnecote',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'B77',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.658212,
        LOCATION_LATITUDE_DEG: 52.6069689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017200',
        LOCATION_NAME: 'Wilpshire',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4739232,
        LOCATION_LATITUDE_DEG: 53.7865963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017300',
        LOCATION_NAME: 'Wilsden',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8580593,
        LOCATION_LATITUDE_DEG: 53.8214901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017500',
        LOCATION_NAME: 'Wilsford',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8536932,
        LOCATION_LATITUDE_DEG: 51.3133514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017400',
        LOCATION_NAME: 'Wilsford',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5019493,
        LOCATION_LATITUDE_DEG: 52.9749873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017600',
        LOCATION_NAME: 'Wilsic',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1597322,
        LOCATION_LATITUDE_DEG: 53.4497453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017700',
        LOCATION_NAME: 'Wilsill',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7223727,
        LOCATION_LATITUDE_DEG: 54.0769128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017800',
        LOCATION_NAME: 'Wilson',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4002423,
        LOCATION_LATITUDE_DEG: 52.8189893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI017900',
        LOCATION_NAME: 'Wilsontown',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6759534,
        LOCATION_LATITUDE_DEG: 55.7792063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018000',
        LOCATION_NAME: 'Wilstead',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4472449,
        LOCATION_LATITUDE_DEG: 52.0804023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018200',
        LOCATION_NAME: 'Wilsthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3852378,
        LOCATION_LATITUDE_DEG: 52.711467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018100',
        LOCATION_NAME: 'Wilsthorpe',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.222316,
        LOCATION_LATITUDE_DEG: 54.0616881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018300',
        LOCATION_NAME: 'Wilstone',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6877187,
        LOCATION_LATITUDE_DEG: 51.8175822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018400',
        LOCATION_NAME: 'Wilstone Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6769482,
        LOCATION_LATITUDE_DEG: 51.8117782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018900',
        LOCATION_NAME: 'Wilton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4794796,
        LOCATION_LATITUDE_DEG: 54.4861713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018800',
        LOCATION_NAME: 'Wilton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6057975,
        LOCATION_LATITUDE_DEG: 51.9170138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018700',
        LOCATION_NAME: 'Wilton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8623699,
        LOCATION_LATITUDE_DEG: 51.0795265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019000',
        LOCATION_NAME: 'Wilton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6140109,
        LOCATION_LATITUDE_DEG: 51.35135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018500',
        LOCATION_NAME: 'Wilton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0953473,
        LOCATION_LATITUDE_DEG: 54.5700558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI018600',
        LOCATION_NAME: 'Wilton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6790762,
        LOCATION_LATITUDE_DEG: 54.2349156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019100',
        LOCATION_NAME: 'Wilton Dean',
        COUNTY_NAME: 'Roxburghshire',
        POSTCODE: 'TD9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8044483,
        LOCATION_LATITUDE_DEG: 55.4230595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019200',
        LOCATION_NAME: 'Wimbish',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3222546,
        LOCATION_LATITUDE_DEG: 52.0056853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019300',
        LOCATION_NAME: 'Wimblebury',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'WS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.97484,
        LOCATION_LATITUDE_DEG: 52.7001809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI043400',
        LOCATION_NAME: 'Wimbledon',
        COUNTY_NAME: 'London',
        POSTCODE: 'SW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2080496,
        LOCATION_LATITUDE_DEG: 51.4227115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019400',
        LOCATION_NAME: 'Wimblington',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0857248,
        LOCATION_LATITUDE_DEG: 52.508936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019500',
        LOCATION_NAME: 'Wimbolds Trafford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8270195,
        LOCATION_LATITUDE_DEG: 53.2512496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019600',
        LOCATION_NAME: 'Wimboldsley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4660841,
        LOCATION_LATITUDE_DEG: 53.1658333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019700',
        LOCATION_NAME: 'Wimborne',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9858364,
        LOCATION_LATITUDE_DEG: 50.8009021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042000',
        LOCATION_NAME: 'Wimborne St Giles',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019800',
        LOCATION_NAME: 'Wimborne St. Giles',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9551797,
        LOCATION_LATITUDE_DEG: 50.9070087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI019900',
        LOCATION_NAME: 'Wimbotsham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.394784,
        LOCATION_LATITUDE_DEG: 52.6187407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020000',
        LOCATION_NAME: 'Wimpole',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'SG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0414824,
        LOCATION_LATITUDE_DEG: 52.14505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990692',
        LOCATION_NAME: 'Wimpstone',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020100',
        LOCATION_NAME: 'Wincanton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4097576,
        LOCATION_LATITUDE_DEG: 51.052926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020200',
        LOCATION_NAME: 'Winceby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0229424,
        LOCATION_LATITUDE_DEG: 53.1948059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020300',
        LOCATION_NAME: 'Winch Hill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.347016,
        LOCATION_LATITUDE_DEG: 51.8822794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020400',
        LOCATION_NAME: 'Winch Wen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.899772,
        LOCATION_LATITUDE_DEG: 51.6472014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020500',
        LOCATION_NAME: 'Wincham',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4908434,
        LOCATION_LATITUDE_DEG: 53.2720403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020600',
        LOCATION_NAME: 'Winchburgh',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4599884,
        LOCATION_LATITUDE_DEG: 55.9582145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020700',
        LOCATION_NAME: 'Winchcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9633273,
        LOCATION_LATITUDE_DEG: 51.9528078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020800',
        LOCATION_NAME: 'Wincheap',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0731906,
        LOCATION_LATITUDE_DEG: 51.2693025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI020900',
        LOCATION_NAME: 'Winchelsea',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7096344,
        LOCATION_LATITUDE_DEG: 50.9231738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021000',
        LOCATION_NAME: 'Winchelsea Beach',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7253439,
        LOCATION_LATITUDE_DEG: 50.9155756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021100',
        LOCATION_NAME: 'Winchester',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3150101,
        LOCATION_LATITUDE_DEG: 51.062519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021200',
        LOCATION_NAME: 'Winchet Hill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.483585,
        LOCATION_LATITUDE_DEG: 51.1391991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021300',
        LOCATION_NAME: 'Winchfield',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8906577,
        LOCATION_LATITUDE_DEG: 51.2890333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021400',
        LOCATION_NAME: 'Winchmore Hill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.651542,
        LOCATION_LATITUDE_DEG: 51.6444675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI043500',
        LOCATION_NAME: 'Winchmore Hill',
        COUNTY_NAME: 'London',
        POSTCODE: 'N21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0934763,
        LOCATION_LATITUDE_DEG: 51.6358411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021500',
        LOCATION_NAME: 'Wincle',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.062104,
        LOCATION_LATITUDE_DEG: 53.1911276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021600',
        LOCATION_NAME: 'Wincobank',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4262683,
        LOCATION_LATITUDE_DEG: 53.4175483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021700',
        LOCATION_NAME: 'Wincombe Park',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1658189,
        LOCATION_LATITUDE_DEG: 51.0173198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021800',
        LOCATION_NAME: 'Winder',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4757095,
        LOCATION_LATITUDE_DEG: 54.5430813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI021900',
        LOCATION_NAME: 'Windermere',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9046601,
        LOCATION_LATITUDE_DEG: 54.3794575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022000',
        LOCATION_NAME: 'Winderton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5228708,
        LOCATION_LATITUDE_DEG: 52.0629136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022200',
        LOCATION_NAME: 'Windhill',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7644293,
        LOCATION_LATITUDE_DEG: 53.8323903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022300',
        LOCATION_NAME: 'Windlesham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6527815,
        LOCATION_LATITUDE_DEG: 51.3641412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022400',
        LOCATION_NAME: 'Windlestone',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5900888,
        LOCATION_LATITUDE_DEG: 54.6554492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022500',
        LOCATION_NAME: 'Windley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5442472,
        LOCATION_LATITUDE_DEG: 53.002405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022600',
        LOCATION_NAME: 'Windmill',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.968092,
        LOCATION_LATITUDE_DEG: 50.5360087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022700',
        LOCATION_NAME: 'Windmill',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7887197,
        LOCATION_LATITUDE_DEG: 54.6450653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022900',
        LOCATION_NAME: 'Windmill Hill',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6560359,
        LOCATION_LATITUDE_DEG: 53.341655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022800',
        LOCATION_NAME: 'Windmill Hill',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN27',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3389106,
        LOCATION_LATITUDE_DEG: 50.8857772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023000',
        LOCATION_NAME: 'Windrush',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7196106,
        LOCATION_LATITUDE_DEG: 51.8155953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023100',
        LOCATION_NAME: 'Windsor',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6044622,
        LOCATION_LATITUDE_DEG: 51.4795521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023200',
        LOCATION_NAME: 'Windsor Castle',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6032555,
        LOCATION_LATITUDE_DEG: 51.4827483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023300',
        LOCATION_NAME: 'Windsor Hill',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5488447,
        LOCATION_LATITUDE_DEG: 51.2067503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023400',
        LOCATION_NAME: 'Windsor Quay',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1848799,
        LOCATION_LATITUDE_DEG: 51.4541805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023700',
        LOCATION_NAME: 'Windy Nook',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5685922,
        LOCATION_LATITUDE_DEG: 54.9398951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023800',
        LOCATION_NAME: 'Windygates',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0542699,
        LOCATION_LATITUDE_DEG: 56.1928312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023900',
        LOCATION_NAME: 'Wineham',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2396719,
        LOCATION_LATITUDE_DEG: 50.9655909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990709',
        LOCATION_NAME: 'Winery Lane',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024000',
        LOCATION_NAME: 'Winestead',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0330919,
        LOCATION_LATITUDE_DEG: 53.6980518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024100',
        LOCATION_NAME: 'Winfarthing',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0995962,
        LOCATION_LATITUDE_DEG: 52.4301143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024300',
        LOCATION_NAME: 'Winford',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6613204,
        LOCATION_LATITUDE_DEG: 51.3828622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024200',
        LOCATION_NAME: 'Winford',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2007367,
        LOCATION_LATITUDE_DEG: 50.6525813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024400',
        LOCATION_NAME: 'Winforton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0239758,
        LOCATION_LATITUDE_DEG: 52.1166379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024500',
        LOCATION_NAME: 'Winfrith Newburgh',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2730514,
        LOCATION_LATITUDE_DEG: 50.6617925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024700',
        LOCATION_NAME: 'Wing',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7178974,
        LOCATION_LATITUDE_DEG: 51.8947919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990149',
        LOCATION_NAME: 'Wing',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.682186,
        LOCATION_LATITUDE_DEG: 52.6189412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024600',
        LOCATION_NAME: 'Wing',
        COUNTY_NAME: 'Rutland',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6797757,
        LOCATION_LATITUDE_DEG: 52.6170531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024800',
        LOCATION_NAME: 'Wingate',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'TS28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.378516,
        LOCATION_LATITUDE_DEG: 54.734873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI024900',
        LOCATION_NAME: 'Wingates',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8475098,
        LOCATION_LATITUDE_DEG: 55.249532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025000',
        LOCATION_NAME: 'Wingerworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4377135,
        LOCATION_LATITUDE_DEG: 53.2021244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025300',
        LOCATION_NAME: 'Wingfield',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2556686,
        LOCATION_LATITUDE_DEG: 51.309054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025200',
        LOCATION_NAME: 'Wingfield',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5450518,
        LOCATION_LATITUDE_DEG: 51.9252898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025100',
        LOCATION_NAME: 'Wingfield',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2727632,
        LOCATION_LATITUDE_DEG: 52.3467026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025400',
        LOCATION_NAME: 'Wingham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2168321,
        LOCATION_LATITUDE_DEG: 51.2729068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025500',
        LOCATION_NAME: 'Wingham Well',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2075062,
        LOCATION_LATITUDE_DEG: 51.2637982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025600',
        LOCATION_NAME: 'Wingmore',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1301621,
        LOCATION_LATITUDE_DEG: 51.1757915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025700',
        LOCATION_NAME: 'Wingrave',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7371235,
        LOCATION_LATITUDE_DEG: 51.8632835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI043200',
        LOCATION_NAME: 'Wingrove',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6474483,
        LOCATION_LATITUDE_DEG: 54.9750023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025800',
        LOCATION_NAME: 'Winkburn',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9385865,
        LOCATION_LATITUDE_DEG: 53.1183135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI025900',
        LOCATION_NAME: 'Winkfield',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'SL4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6939525,
        LOCATION_LATITUDE_DEG: 51.4409414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026000',
        LOCATION_NAME: 'Winkfield Row',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6988809,
        LOCATION_LATITUDE_DEG: 51.4285408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026100',
        LOCATION_NAME: 'Winkhill',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9092118,
        LOCATION_LATITUDE_DEG: 53.0585153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026200',
        LOCATION_NAME: 'Winkleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.940712,
        LOCATION_LATITUDE_DEG: 50.8545287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026300',
        LOCATION_NAME: 'Winksley',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6141467,
        LOCATION_LATITUDE_DEG: 54.1368202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026400',
        LOCATION_NAME: 'Winkton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.770292,
        LOCATION_LATITUDE_DEG: 50.7627957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026500',
        LOCATION_NAME: 'Winkwell',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'HP1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5106331,
        LOCATION_LATITUDE_DEG: 51.7459763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026600',
        LOCATION_NAME: 'Winlaton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7220058,
        LOCATION_LATITUDE_DEG: 54.9527992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026700',
        LOCATION_NAME: 'Winlaton Mill',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7117411,
        LOCATION_LATITUDE_DEG: 54.9425926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026800',
        LOCATION_NAME: 'Winmarleigh',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8073425,
        LOCATION_LATITUDE_DEG: 53.9237071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI026900',
        LOCATION_NAME: 'Winnards Perch',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.919155,
        LOCATION_LATITUDE_DEG: 50.4589972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027000',
        LOCATION_NAME: 'Winnersh',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8774744,
        LOCATION_LATITUDE_DEG: 51.4266461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027100',
        LOCATION_NAME: 'Winnington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0179908,
        LOCATION_LATITUDE_DEG: 52.6864894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027200',
        LOCATION_NAME: 'Winnington',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5348906,
        LOCATION_LATITUDE_DEG: 53.263742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990319',
        LOCATION_NAME: 'Winnington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4077218,
        LOCATION_LATITUDE_DEG: 52.9440884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027300',
        LOCATION_NAME: 'Winnington Bridge',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5369813,
        LOCATION_LATITUDE_DEG: 53.2702413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027400',
        LOCATION_NAME: 'Winscales',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.505852,
        LOCATION_LATITUDE_DEG: 54.6192859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027500',
        LOCATION_NAME: 'Winscombe',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8304684,
        LOCATION_LATITUDE_DEG: 51.3127557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027600',
        LOCATION_NAME: 'Winsdon Hill',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4320823,
        LOCATION_LATITUDE_DEG: 51.8780842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027800',
        LOCATION_NAME: 'Winsford',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5616247,
        LOCATION_LATITUDE_DEG: 51.1023455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027700',
        LOCATION_NAME: 'Winsford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5141172,
        LOCATION_LATITUDE_DEG: 53.1931362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI027900',
        LOCATION_NAME: 'Winsham',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1452159,
        LOCATION_LATITUDE_DEG: 51.1272526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028000',
        LOCATION_NAME: 'Winsham',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.888671,
        LOCATION_LATITUDE_DEG: 50.8530188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028100',
        LOCATION_NAME: 'Winskill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6458335,
        LOCATION_LATITUDE_DEG: 54.7081867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028200',
        LOCATION_NAME: 'Winslade',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0621658,
        LOCATION_LATITUDE_DEG: 51.2269332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028300',
        LOCATION_NAME: 'Winsley',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2849334,
        LOCATION_LATITUDE_DEG: 51.3475566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028400',
        LOCATION_NAME: 'Winslow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5397237,
        LOCATION_LATITUDE_DEG: 52.1822415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028500',
        LOCATION_NAME: 'Winslow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8798209,
        LOCATION_LATITUDE_DEG: 51.9423953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028600',
        LOCATION_NAME: 'Winson',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8719593,
        LOCATION_LATITUDE_DEG: 51.776088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028700',
        LOCATION_NAME: 'Winson Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9300471,
        LOCATION_LATITUDE_DEG: 52.49216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028800',
        LOCATION_NAME: 'Winsor',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5466412,
        LOCATION_LATITUDE_DEG: 50.9208055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI028900',
        LOCATION_NAME: 'Winspit Cove',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0408163,
        LOCATION_LATITUDE_DEG: 50.589282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029000',
        LOCATION_NAME: 'Winstanley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6724944,
        LOCATION_LATITUDE_DEG: 53.5215741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029200',
        LOCATION_NAME: 'Winster',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8958645,
        LOCATION_LATITUDE_DEG: 54.3354523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029100',
        LOCATION_NAME: 'Winster',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6411108,
        LOCATION_LATITUDE_DEG: 53.1415178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029300',
        LOCATION_NAME: 'Winston',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7826482,
        LOCATION_LATITUDE_DEG: 54.5455591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029400',
        LOCATION_NAME: 'Winston',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1900879,
        LOCATION_LATITUDE_DEG: 52.2087906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029500',
        LOCATION_NAME: 'Winston Green',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.175768,
        LOCATION_LATITUDE_DEG: 52.2050935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029700',
        LOCATION_NAME: 'Winstone',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0214845,
        LOCATION_LATITUDE_DEG: 50.3450757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029600',
        LOCATION_NAME: 'Winstone',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0583702,
        LOCATION_LATITUDE_DEG: 51.7841911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029800',
        LOCATION_NAME: 'Winterborne Clenston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2279292,
        LOCATION_LATITUDE_DEG: 50.8257095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI029900',
        LOCATION_NAME: 'Winterborne Houghton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2558322,
        LOCATION_LATITUDE_DEG: 50.8389081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030000',
        LOCATION_NAME: 'Winterborne Kingston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1959937,
        LOCATION_LATITUDE_DEG: 50.7780025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030100',
        LOCATION_NAME: 'Winterborne Monkton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4527625,
        LOCATION_LATITUDE_DEG: 50.6903999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030200',
        LOCATION_NAME: 'Winterborne Muston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1933103,
        LOCATION_LATITUDE_DEG: 50.7774044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030300',
        LOCATION_NAME: 'Winterborne Stickland',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2347262,
        LOCATION_LATITUDE_DEG: 50.8418034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030400',
        LOCATION_NAME: 'Winterborne Tomson',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1636321,
        LOCATION_LATITUDE_DEG: 50.7722965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030500',
        LOCATION_NAME: 'Winterborne Whitechurch',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2306708,
        LOCATION_LATITUDE_DEG: 50.8000004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030600',
        LOCATION_NAME: 'Winterborne Zelston',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1446968,
        LOCATION_LATITUDE_DEG: 50.7767014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030800',
        LOCATION_NAME: 'Winterbourne',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5061527,
        LOCATION_LATITUDE_DEG: 51.524676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030700',
        LOCATION_NAME: 'Winterbourne',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.344941,
        LOCATION_LATITUDE_DEG: 51.4445518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI030900',
        LOCATION_NAME: 'Winterbourne Abbas',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5400482,
        LOCATION_LATITUDE_DEG: 50.7123959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031000',
        LOCATION_NAME: 'Winterbourne Bassett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8505504,
        LOCATION_LATITUDE_DEG: 51.4722661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031100',
        LOCATION_NAME: 'Winterbourne Dauntsey',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7485356,
        LOCATION_LATITUDE_DEG: 51.1118293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031200',
        LOCATION_NAME: 'Winterbourne Down',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4990397,
        LOCATION_LATITUDE_DEG: 51.5135737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031300',
        LOCATION_NAME: 'Winterbourne Earls',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7534373,
        LOCATION_LATITUDE_DEG: 51.106228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031400',
        LOCATION_NAME: 'Winterbourne Gunner',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7428712,
        LOCATION_LATITUDE_DEG: 51.1156301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031500',
        LOCATION_NAME: 'Winterbourne Monkton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8549811,
        LOCATION_LATITUDE_DEG: 51.446364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031600',
        LOCATION_NAME: 'Winterbourne Steepleton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5256981,
        LOCATION_LATITUDE_DEG: 50.7059949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031700',
        LOCATION_NAME: 'Winterbourne Stoke',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8919023,
        LOCATION_LATITUDE_DEG: 51.1681305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031800',
        LOCATION_NAME: 'Winterburn',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.099287,
        LOCATION_LATITUDE_DEG: 54.0230087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI031900',
        LOCATION_NAME: 'Winterhay',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9365994,
        LOCATION_LATITUDE_DEG: 50.9305203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032000',
        LOCATION_NAME: 'Winterhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7596569,
        LOCATION_LATITUDE_DEG: 52.0249985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032100',
        LOCATION_NAME: 'Winteringham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5889245,
        LOCATION_LATITUDE_DEG: 53.6874605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032200',
        LOCATION_NAME: 'Winterley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3790398,
        LOCATION_LATITUDE_DEG: 53.1122287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032300',
        LOCATION_NAME: 'Wintersett',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4195262,
        LOCATION_LATITUDE_DEG: 53.6371665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032400',
        LOCATION_NAME: 'Winterslow',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6652664,
        LOCATION_LATITUDE_DEG: 51.0828245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032500',
        LOCATION_NAME: 'Winterton',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4464259,
        LOCATION_LATITUDE_DEG: 54.6662655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032600',
        LOCATION_NAME: 'Winterton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5997872,
        LOCATION_LATITUDE_DEG: 53.6558533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042600',
        LOCATION_NAME: 'Winterton on Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032700',
        LOCATION_NAME: 'Winterton-on-Sea',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6884655,
        LOCATION_LATITUDE_DEG: 52.7147302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032800',
        LOCATION_NAME: 'Winthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7856308,
        LOCATION_LATITUDE_DEG: 53.0999042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI032900',
        LOCATION_NAME: 'Wintles Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3947089,
        LOCATION_LATITUDE_DEG: 51.8230993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033100',
        LOCATION_NAME: 'Winton',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3330655,
        LOCATION_LATITUDE_DEG: 54.4899569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033000',
        LOCATION_NAME: 'Winton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3683184,
        LOCATION_LATITUDE_DEG: 54.3631367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033200',
        LOCATION_NAME: 'Wintringham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6458353,
        LOCATION_LATITUDE_DEG: 54.1464074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033400',
        LOCATION_NAME: 'Winwick',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5942237,
        LOCATION_LATITUDE_DEG: 53.4302584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033300',
        LOCATION_NAME: 'Winwick',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0801317,
        LOCATION_LATITUDE_DEG: 52.3578343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033500',
        LOCATION_NAME: 'Winwick',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3762808,
        LOCATION_LATITUDE_DEG: 52.4126363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033600',
        LOCATION_NAME: 'Winwick Quay',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5982202,
        LOCATION_LATITUDE_DEG: 53.4168618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033700',
        LOCATION_NAME: 'Winyates',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'B98',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9017601,
        LOCATION_LATITUDE_DEG: 52.3026427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033800',
        LOCATION_NAME: 'Wirksworth',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5720698,
        LOCATION_LATITUDE_DEG: 53.0824135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033925',
        LOCATION_NAME: 'Wirral CH41',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0372163,
        LOCATION_LATITUDE_DEG: 53.4001371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033950',
        LOCATION_NAME: 'Wirral CH42',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033975',
        LOCATION_NAME: 'Wirral CH43',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033982',
        LOCATION_NAME: 'Wirral CH44',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0440568,
        LOCATION_LATITUDE_DEG: 53.4153426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033988',
        LOCATION_NAME: 'Wirral CH45',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0995127,
        LOCATION_LATITUDE_DEG: 53.3244671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033994',
        LOCATION_NAME: 'Wirral CH46',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1099945,
        LOCATION_LATITUDE_DEG: 53.4054432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033996',
        LOCATION_NAME: 'Wirral CH47',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1624929,
        LOCATION_LATITUDE_DEG: 53.3958186,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033997',
        LOCATION_NAME: 'Wirral CH48',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1762528,
        LOCATION_LATITUDE_DEG: 53.3722644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI033999',
        LOCATION_NAME: 'Wirral CH49',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.109136,
        LOCATION_LATITUDE_DEG: 53.3816903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034010',
        LOCATION_NAME: 'Wirral CH60',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH60',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0995127,
        LOCATION_LATITUDE_DEG: 53.3244671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034020',
        LOCATION_NAME: 'Wirral CH61',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH61',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0997418,
        LOCATION_LATITUDE_DEG: 53.3503027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034030',
        LOCATION_NAME: 'Wirral CH62',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9766043,
        LOCATION_LATITUDE_DEG: 53.3374303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034065',
        LOCATION_NAME: 'Wirral CH63',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'CH63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0257149,
        LOCATION_LATITUDE_DEG: 53.3371891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034000',
        LOCATION_NAME: 'Wirswall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6780357,
        LOCATION_LATITUDE_DEG: 52.9910154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034100',
        LOCATION_NAME: 'Wisbech',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1610569,
        LOCATION_LATITUDE_DEG: 52.665951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041900',
        LOCATION_NAME: 'Wisbech St Mary',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034200',
        LOCATION_NAME: 'Wisbech St. Mary',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1000978,
        LOCATION_LATITUDE_DEG: 52.6513467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034300',
        LOCATION_NAME: 'Wisborough Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5032324,
        LOCATION_LATITUDE_DEG: 51.0226003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034400',
        LOCATION_NAME: 'Wisemans Bridge',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA69',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.6919362,
        LOCATION_LATITUDE_DEG: 51.7263195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034500',
        LOCATION_NAME: 'Wiseton',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9196744,
        LOCATION_LATITUDE_DEG: 53.4006359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042900',
        LOCATION_NAME: 'Wisewood',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.520404,
        LOCATION_LATITUDE_DEG: 53.4099446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034700',
        LOCATION_NAME: 'Wishaw',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9181079,
        LOCATION_LATITUDE_DEG: 55.7734996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034600',
        LOCATION_NAME: 'Wishaw',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B76',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7398653,
        LOCATION_LATITUDE_DEG: 52.5474679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034800',
        LOCATION_NAME: 'Wisley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4745168,
        LOCATION_LATITUDE_DEG: 51.3224292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI034900',
        LOCATION_NAME: 'Wispington',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.193412,
        LOCATION_LATITUDE_DEG: 53.228308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035000',
        LOCATION_NAME: 'Wissett',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4750449,
        LOCATION_LATITUDE_DEG: 52.3607012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035100',
        LOCATION_NAME: 'Wissington',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4527902,
        LOCATION_LATITUDE_DEG: 52.5507353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035200',
        LOCATION_NAME: 'Wistanstow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8359776,
        LOCATION_LATITUDE_DEG: 52.46407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035300',
        LOCATION_NAME: 'Wistanswick',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.492006,
        LOCATION_LATITUDE_DEG: 52.8548986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035400',
        LOCATION_NAME: 'Wistaston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4772504,
        LOCATION_LATITUDE_DEG: 53.0733077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035500',
        LOCATION_NAME: 'Wistaston Green',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4738663,
        LOCATION_LATITUDE_DEG: 53.0900249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035700',
        LOCATION_NAME: 'Wiston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8707215,
        LOCATION_LATITUDE_DEG: 51.803928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035600',
        LOCATION_NAME: 'Wiston',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6555628,
        LOCATION_LATITUDE_DEG: 55.5718784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035800',
        LOCATION_NAME: 'Wiston',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3724321,
        LOCATION_LATITUDE_DEG: 50.9154947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036000',
        LOCATION_NAME: 'Wistow',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0999951,
        LOCATION_LATITUDE_DEG: 53.8133797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI035900',
        LOCATION_NAME: 'Wistow',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1203722,
        LOCATION_LATITUDE_DEG: 52.4121262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036100',
        LOCATION_NAME: 'Wistow Common',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1319248,
        LOCATION_LATITUDE_DEG: 53.7993759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036200',
        LOCATION_NAME: 'Wistow Lordship',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0750769,
        LOCATION_LATITUDE_DEG: 53.8074819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036300',
        LOCATION_NAME: 'Wiswell',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3877113,
        LOCATION_LATITUDE_DEG: 53.8319951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036400',
        LOCATION_NAME: 'Witcham',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1508835,
        LOCATION_LATITUDE_DEG: 52.3978248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036500',
        LOCATION_NAME: 'Witcham Toll',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1415427,
        LOCATION_LATITUDE_DEG: 52.3907283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036600',
        LOCATION_NAME: 'Witchampton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0159711,
        LOCATION_LATITUDE_DEG: 50.8580109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036700',
        LOCATION_NAME: 'Witchford',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'CB6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.2029266,
        LOCATION_LATITUDE_DEG: 52.3863265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990631',
        LOCATION_NAME: 'Witcombe',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036800',
        LOCATION_NAME: 'Witcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7452503,
        LOCATION_LATITUDE_DEG: 50.9925235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI036900',
        LOCATION_NAME: 'Witham',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6399329,
        LOCATION_LATITUDE_DEG: 51.7979616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037000',
        LOCATION_NAME: 'Witham Friary',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3653414,
        LOCATION_LATITUDE_DEG: 51.1674391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI042700',
        LOCATION_NAME: 'Witham on the Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005150',
        LOCATION_NAME: 'Witham St. Hughs',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6631446,
        LOCATION_LATITUDE_DEG: 53.1527605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037100',
        LOCATION_NAME: 'Witham Town',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0303529,
        LOCATION_LATITUDE_DEG: 52.983582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037200',
        LOCATION_NAME: 'Witham-on-the-Hill',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4392253,
        LOCATION_LATITUDE_DEG: 52.7340665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037300',
        LOCATION_NAME: 'Withcall',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0711953,
        LOCATION_LATITUDE_DEG: 53.3341164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037400',
        LOCATION_NAME: 'Withcote',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8157621,
        LOCATION_LATITUDE_DEG: 52.6476045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037500',
        LOCATION_NAME: 'Withdean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1518403,
        LOCATION_LATITUDE_DEG: 50.8511835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037600',
        LOCATION_NAME: 'Witheridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6997196,
        LOCATION_LATITUDE_DEG: 50.9163283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037700',
        LOCATION_NAME: 'Witheridge Hill',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'RG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9961364,
        LOCATION_LATITUDE_DEG: 51.5507623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037800',
        LOCATION_NAME: 'Witherley',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5169307,
        LOCATION_LATITUDE_DEG: 52.5711607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI037900',
        LOCATION_NAME: 'Withern',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1450873,
        LOCATION_LATITUDE_DEG: 53.3157128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038000',
        LOCATION_NAME: 'Withernsea',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0303619,
        LOCATION_LATITUDE_DEG: 53.7308522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038100',
        LOCATION_NAME: 'Withernwick',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1827244,
        LOCATION_LATITUDE_DEG: 53.8474719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038200',
        LOCATION_NAME: 'Withersfield',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.420512,
        LOCATION_LATITUDE_DEG: 52.1069978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038300',
        LOCATION_NAME: 'Witherslack',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8766784,
        LOCATION_LATITUDE_DEG: 54.2498419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038400',
        LOCATION_NAME: 'Withgill',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4451415,
        LOCATION_LATITUDE_DEG: 53.8639046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038500',
        LOCATION_NAME: 'Withiel',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8242452,
        LOCATION_LATITUDE_DEG: 50.4533973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038600',
        LOCATION_NAME: 'Withiel Florey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4487027,
        LOCATION_LATITUDE_DEG: 51.0964425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038700',
        LOCATION_NAME: 'Withielgoose Mills',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8056469,
        LOCATION_LATITUDE_DEG: 50.4569962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038800',
        LOCATION_NAME: 'Withington',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.63672,
        LOCATION_LATITUDE_DEG: 52.0849266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI038900',
        LOCATION_NAME: 'Withington',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6266768,
        LOCATION_LATITUDE_DEG: 52.713587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI043100',
        LOCATION_NAME: 'Withington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2291149,
        LOCATION_LATITUDE_DEG: 53.4336742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039000',
        LOCATION_NAME: 'Withington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9551029,
        LOCATION_LATITUDE_DEG: 51.8383021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039100',
        LOCATION_NAME: 'Withleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5513231,
        LOCATION_LATITUDE_DEG: 50.8997319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039200',
        LOCATION_NAME: 'Withnell',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5544287,
        LOCATION_LATITUDE_DEG: 53.6926822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039300',
        LOCATION_NAME: 'Withybed Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9728513,
        LOCATION_LATITUDE_DEG: 52.3504509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039400',
        LOCATION_NAME: 'Withybrook',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3593452,
        LOCATION_LATITUDE_DEG: 52.4525486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039500',
        LOCATION_NAME: 'Withycombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4081945,
        LOCATION_LATITUDE_DEG: 51.1612511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039600',
        LOCATION_NAME: 'Withyditch',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4262238,
        LOCATION_LATITUDE_DEG: 51.3321547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039700',
        LOCATION_NAME: 'Withyham',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1364583,
        LOCATION_LATITUDE_DEG: 51.1004027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039800',
        LOCATION_NAME: 'Withypool',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6509568,
        LOCATION_LATITUDE_DEG: 51.1053452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI039900',
        LOCATION_NAME: 'Withywood',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6265965,
        LOCATION_LATITUDE_DEG: 51.406866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040000',
        LOCATION_NAME: 'Witley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6453861,
        LOCATION_LATITUDE_DEG: 51.1480158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040100',
        LOCATION_NAME: 'Witnesham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1894535,
        LOCATION_LATITUDE_DEG: 52.1138842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040200',
        LOCATION_NAME: 'Witney',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4840137,
        LOCATION_LATITUDE_DEG: 51.7832892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040300',
        LOCATION_NAME: 'Wittering',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.439723,
        LOCATION_LATITUDE_DEG: 52.6113557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040400',
        LOCATION_NAME: 'Wittersham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.7094645,
        LOCATION_LATITUDE_DEG: 51.0134826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040600',
        LOCATION_NAME: 'Witton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8820905,
        LOCATION_LATITUDE_DEG: 52.5125584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040500',
        LOCATION_NAME: 'Witton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4188572,
        LOCATION_LATITUDE_DEG: 52.6349302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040650',
        LOCATION_NAME: 'Witton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4721639,
        LOCATION_LATITUDE_DEG: 52.8296858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040700',
        LOCATION_NAME: 'Witton Gilbert',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DH7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6365121,
        LOCATION_LATITUDE_DEG: 54.8051793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040900',
        LOCATION_NAME: 'Witton le Wear',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7790327,
        LOCATION_LATITUDE_DEG: 54.6766669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI040800',
        LOCATION_NAME: 'Witton Park',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7192001,
        LOCATION_LATITUDE_DEG: 54.6760666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041000',
        LOCATION_NAME: 'Wiveliscombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3103541,
        LOCATION_LATITUDE_DEG: 51.0407405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041100',
        LOCATION_NAME: 'Wivelrod',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0367842,
        LOCATION_LATITUDE_DEG: 51.1391236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041200',
        LOCATION_NAME: 'Wivelsfield',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0891779,
        LOCATION_LATITUDE_DEG: 50.9675964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041300',
        LOCATION_NAME: 'Wivelsfield Green',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.071197,
        LOCATION_LATITUDE_DEG: 50.9628936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041400',
        LOCATION_NAME: 'Wivenhoe',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9633458,
        LOCATION_LATITUDE_DEG: 51.8655637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041500',
        LOCATION_NAME: 'Wiveton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0405498,
        LOCATION_LATITUDE_DEG: 52.9434638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041600',
        LOCATION_NAME: 'Wix',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1447445,
        LOCATION_LATITUDE_DEG: 51.9119611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990528',
        LOCATION_NAME: 'Wixams',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4604047,
        LOCATION_LATITUDE_DEG: 52.0869145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041700',
        LOCATION_NAME: 'Wixford',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8658776,
        LOCATION_LATITUDE_DEG: 52.1883271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI041800',
        LOCATION_NAME: 'Wixoe',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CO10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5052382,
        LOCATION_LATITUDE_DEG: 52.0576862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000100',
        LOCATION_NAME: 'Woburn',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6174564,
        LOCATION_LATITUDE_DEG: 51.9881924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000200',
        LOCATION_NAME: 'Woburn Sands',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6524381,
        LOCATION_LATITUDE_DEG: 52.0179039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000300',
        LOCATION_NAME: 'Woking',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5575201,
        LOCATION_LATITUDE_DEG: 51.3188315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000400',
        LOCATION_NAME: 'Wokingham',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8334044,
        LOCATION_LATITUDE_DEG: 51.4105409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000500',
        LOCATION_NAME: 'Wolborough',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.652777,
        LOCATION_LATITUDE_DEG: 50.5348915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000600',
        LOCATION_NAME: 'Wold Newton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'YO25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3986285,
        LOCATION_LATITUDE_DEG: 54.1417008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000700',
        LOCATION_NAME: 'Wold Newton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1268985,
        LOCATION_LATITUDE_DEG: 53.4545305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000800',
        LOCATION_NAME: 'Woldingham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0354317,
        LOCATION_LATITUDE_DEG: 51.2849194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO000900',
        LOCATION_NAME: 'Wolferlow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4852134,
        LOCATION_LATITUDE_DEG: 52.2540415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001000',
        LOCATION_NAME: 'Wolferton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4636523,
        LOCATION_LATITUDE_DEG: 52.8251615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001100',
        LOCATION_NAME: 'Wolfeton',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.455003,
        LOCATION_LATITUDE_DEG: 50.7288036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001200',
        LOCATION_NAME: 'Wolfhampcote',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2239481,
        LOCATION_LATITUDE_DEG: 52.2832301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001400',
        LOCATION_NAME: 'Wolfhill',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3677103,
        LOCATION_LATITUDE_DEG: 56.4847709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001500',
        LOCATION_NAME: 'Wolfscastle',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.9697238,
        LOCATION_LATITUDE_DEG: 51.8997179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001600',
        LOCATION_NAME: 'Wolfsdale',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0106051,
        LOCATION_LATITUDE_DEG: 51.8509335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001700',
        LOCATION_NAME: 'Wollaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9925837,
        LOCATION_LATITUDE_DEG: 52.7039946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001900',
        LOCATION_NAME: 'Wollaston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1702888,
        LOCATION_LATITUDE_DEG: 52.4565616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001800',
        LOCATION_NAME: 'Wollaston',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6687603,
        LOCATION_LATITUDE_DEG: 52.2576217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002000',
        LOCATION_NAME: 'Wollaton',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2305914,
        LOCATION_LATITUDE_DEG: 52.9537961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002100',
        LOCATION_NAME: 'Wollerton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5642651,
        LOCATION_LATITUDE_DEG: 52.8664088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002200',
        LOCATION_NAME: 'Wollescote',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1112932,
        LOCATION_LATITUDE_DEG: 52.4544559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002300',
        LOCATION_NAME: 'Wolseley Bridge',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9681514,
        LOCATION_LATITUDE_DEG: 52.7801867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002400',
        LOCATION_NAME: 'Wolsingham',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8808321,
        LOCATION_LATITUDE_DEG: 54.7318771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002500',
        LOCATION_NAME: 'Wolstanton',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2203203,
        LOCATION_LATITUDE_DEG: 53.0332184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002600',
        LOCATION_NAME: 'Wolstenholme',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'OL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2410754,
        LOCATION_LATITUDE_DEG: 53.6369736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002700',
        LOCATION_NAME: 'Wolston',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3927945,
        LOCATION_LATITUDE_DEG: 52.3756431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002800',
        LOCATION_NAME: 'Wolston Grange',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3535014,
        LOCATION_LATITUDE_DEG: 52.3822412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO002900',
        LOCATION_NAME: 'Wolterton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2206175,
        LOCATION_LATITUDE_DEG: 52.838655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003000',
        LOCATION_NAME: 'Wolvercote',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.289865,
        LOCATION_LATITUDE_DEG: 51.7834818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003100',
        LOCATION_NAME: 'Wolverhampton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1259397,
        LOCATION_LATITUDE_DEG: 52.5842706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003300',
        LOCATION_NAME: 'Wolverley',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7815075,
        LOCATION_LATITUDE_DEG: 52.8759127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003200',
        LOCATION_NAME: 'Wolverley',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2517661,
        LOCATION_LATITUDE_DEG: 52.4122609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003400',
        LOCATION_NAME: 'Wolverley Village',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2484834,
        LOCATION_LATITUDE_DEG: 52.4089591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003500',
        LOCATION_NAME: 'Wolverton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7766075,
        LOCATION_LATITUDE_DEG: 52.4874742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003600',
        LOCATION_NAME: 'Wolverton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6953393,
        LOCATION_LATITUDE_DEG: 52.257235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003800',
        LOCATION_NAME: 'Wolverton',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2051199,
        LOCATION_LATITUDE_DEG: 51.3201431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003700',
        LOCATION_NAME: 'Wolverton',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8089303,
        LOCATION_LATITUDE_DEG: 52.0627075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO003900',
        LOCATION_NAME: 'Wolverton Common',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1939143,
        LOCATION_LATITUDE_DEG: 51.332243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004000',
        LOCATION_NAME: 'Wolverton Mill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8056001,
        LOCATION_LATITUDE_DEG: 52.0634021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004100',
        LOCATION_NAME: 'Wolvesnewton',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7892577,
        LOCATION_LATITUDE_DEG: 51.6914982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004200',
        LOCATION_NAME: 'Wolvey',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3676778,
        LOCATION_LATITUDE_DEG: 52.4862563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004300',
        LOCATION_NAME: 'Wolviston',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2979748,
        LOCATION_LATITUDE_DEG: 54.6228574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004400',
        LOCATION_NAME: 'Wombleton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO62',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9731325,
        LOCATION_LATITUDE_DEG: 54.2476224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004500',
        LOCATION_NAME: 'Wombourne',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1842469,
        LOCATION_LATITUDE_DEG: 52.5353647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004600',
        LOCATION_NAME: 'Wombridge',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4587985,
        LOCATION_LATITUDE_DEG: 52.700087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004700',
        LOCATION_NAME: 'Wombwell',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3961998,
        LOCATION_LATITUDE_DEG: 53.5217519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004800',
        LOCATION_NAME: 'Womenswold',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1875971,
        LOCATION_LATITUDE_DEG: 51.2085948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO004900',
        LOCATION_NAME: 'Womersley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1984305,
        LOCATION_LATITUDE_DEG: 53.6664635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005000',
        LOCATION_NAME: 'Wonastow',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7469784,
        LOCATION_LATITUDE_DEG: 51.7942061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005100',
        LOCATION_NAME: 'Wonersh',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.543284,
        LOCATION_LATITUDE_DEG: 51.1968202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005200',
        LOCATION_NAME: 'Wonston',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3190066,
        LOCATION_LATITUDE_DEG: 51.1519262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005300',
        LOCATION_NAME: 'Wooburn',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6898696,
        LOCATION_LATITUDE_DEG: 51.5794603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005400',
        LOCATION_NAME: 'Wooburn Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6825049,
        LOCATION_LATITUDE_DEG: 51.5865632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005500',
        LOCATION_NAME: 'Wooburn Moor',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6815658,
        LOCATION_LATITUDE_DEG: 51.5985582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005600',
        LOCATION_NAME: 'Wooburn Town',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6864662,
        LOCATION_LATITUDE_DEG: 51.5803575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005700',
        LOCATION_NAME: 'Wood Bevington',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'B49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9226926,
        LOCATION_LATITUDE_DEG: 52.1831359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005800',
        LOCATION_NAME: 'Wood Burcote',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9842179,
        LOCATION_LATITUDE_DEG: 52.1160164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO005900',
        LOCATION_NAME: 'Wood Dalling',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1006157,
        LOCATION_LATITUDE_DEG: 52.8000484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006100',
        LOCATION_NAME: 'Wood End',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6416108,
        LOCATION_LATITUDE_DEG: 52.5817993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006000',
        LOCATION_NAME: 'Wood End',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1519226,
        LOCATION_LATITUDE_DEG: 50.9195051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006200',
        LOCATION_NAME: 'Wood Enderby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0940716,
        LOCATION_LATITUDE_DEG: 53.1564033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006300',
        LOCATION_NAME: 'Wood Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0083653,
        LOCATION_LATITUDE_DEG: 52.5630469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034800',
        LOCATION_NAME: 'Wood Green',
        COUNTY_NAME: 'London',
        POSTCODE: 'N22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1095633,
        LOCATION_LATITUDE_DEG: 51.5972316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006400',
        LOCATION_NAME: 'Wood Head',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1351081,
        LOCATION_LATITUDE_DEG: 54.1597375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006600',
        LOCATION_NAME: 'Wood Norton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9674711,
        LOCATION_LATITUDE_DEG: 52.1186247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006500',
        LOCATION_NAME: 'Wood Norton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9867205,
        LOCATION_LATITUDE_DEG: 52.8110484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006700',
        LOCATION_NAME: 'Wood Stanway',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9089195,
        LOCATION_LATITUDE_DEG: 51.9793131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006800',
        LOCATION_NAME: 'Wood Street Village',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6399039,
        LOCATION_LATITUDE_DEG: 51.252223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO006900',
        LOCATION_NAME: 'Wood Top',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.290152,
        LOCATION_LATITUDE_DEG: 53.6954836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007000',
        LOCATION_NAME: 'Woodabridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3333393,
        LOCATION_LATITUDE_DEG: 50.5673066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007100',
        LOCATION_NAME: 'Woodall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2755505,
        LOCATION_LATITUDE_DEG: 53.3207353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007200',
        LOCATION_NAME: 'Woodbank',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CH1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9640019,
        LOCATION_LATITUDE_DEG: 53.2514433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007300',
        LOCATION_NAME: 'Woodbastwick',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.450758,
        LOCATION_LATITUDE_DEG: 52.6838369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007400',
        LOCATION_NAME: 'Woodbatch',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0228136,
        LOCATION_LATITUDE_DEG: 52.4911766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007500',
        LOCATION_NAME: 'Woodbeck',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'DN22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8321578,
        LOCATION_LATITUDE_DEG: 53.2939251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007700',
        LOCATION_NAME: 'Woodborough',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.84562,
        LOCATION_LATITUDE_DEG: 51.3373518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007600',
        LOCATION_NAME: 'Woodborough',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0587402,
        LOCATION_LATITUDE_DEG: 53.0229016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007800',
        LOCATION_NAME: 'Woodbridge',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3149214,
        LOCATION_LATITUDE_DEG: 52.0938777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO007900',
        LOCATION_NAME: 'Woodbury',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3993744,
        LOCATION_LATITUDE_DEG: 50.6762053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008000',
        LOCATION_NAME: 'Woodbury Salterton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3979209,
        LOCATION_LATITUDE_DEG: 50.691603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008100',
        LOCATION_NAME: 'Woodchester',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2266666,
        LOCATION_LATITUDE_DEG: 51.7233891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008300',
        LOCATION_NAME: 'Woodchurch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.775193,
        LOCATION_LATITUDE_DEG: 51.0755904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008400',
        LOCATION_NAME: 'Woodchurch',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.346687,
        LOCATION_LATITUDE_DEG: 51.363012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008600',
        LOCATION_NAME: 'Woodcombe',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.496044,
        LOCATION_LATITUDE_DEG: 51.2067565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008800',
        LOCATION_NAME: 'Woodcote',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3439547,
        LOCATION_LATITUDE_DEG: 52.7363936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008700',
        LOCATION_NAME: 'Woodcote',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0711164,
        LOCATION_LATITUDE_DEG: 51.5322613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008900',
        LOCATION_NAME: 'Woodcote Hill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3540762,
        LOCATION_LATITUDE_DEG: 52.7314909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009000',
        LOCATION_NAME: 'Woodcroft',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.660416,
        LOCATION_LATITUDE_DEG: 51.6579873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009100',
        LOCATION_NAME: 'Woodcross',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WV14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.10326,
        LOCATION_LATITUDE_DEG: 52.5498665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009200',
        LOCATION_NAME: 'Woodcutts',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0412063,
        LOCATION_LATITUDE_DEG: 50.9542163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009300',
        LOCATION_NAME: 'Woodditton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'CB8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4315641,
        LOCATION_LATITUDE_DEG: 52.1972989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009400',
        LOCATION_NAME: 'Woodeaton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2244473,
        LOCATION_LATITUDE_DEG: 51.8029864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009700',
        LOCATION_NAME: 'Woodend',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3532724,
        LOCATION_LATITUDE_DEG: 56.0979258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010200',
        LOCATION_NAME: 'Woodend',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2813212,
        LOCATION_LATITUDE_DEG: 54.3557595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009600',
        LOCATION_NAME: 'Woodend',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9553162,
        LOCATION_LATITUDE_DEG: 56.327749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009800',
        LOCATION_NAME: 'Woodend',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5299756,
        LOCATION_LATITUDE_DEG: 52.0684246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010100',
        LOCATION_NAME: 'Woodend',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4291203,
        LOCATION_LATITUDE_DEG: 51.6233874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009900',
        LOCATION_NAME: 'Woodend',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S80',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1487444,
        LOCATION_LATITUDE_DEG: 53.3160323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010000',
        LOCATION_NAME: 'Woodend',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0995902,
        LOCATION_LATITUDE_DEG: 52.1364212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010300',
        LOCATION_NAME: 'Woodfalls',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SP5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7176248,
        LOCATION_LATITUDE_DEG: 50.9794144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010400',
        LOCATION_NAME: 'Woodfield',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3719214,
        LOCATION_LATITUDE_DEG: 51.6936866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010500',
        LOCATION_NAME: 'Woodfieldside',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1856972,
        LOCATION_LATITUDE_DEG: 51.6631931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010900',
        LOCATION_NAME: 'Woodford',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.5320104,
        LOCATION_LATITUDE_DEG: 50.8926395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010800',
        LOCATION_NAME: 'Woodford',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4478998,
        LOCATION_LATITUDE_DEG: 51.6598892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010700',
        LOCATION_NAME: 'Woodford',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1627541,
        LOCATION_LATITUDE_DEG: 53.3417471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO010600',
        LOCATION_NAME: 'Woodford',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5795469,
        LOCATION_LATITUDE_DEG: 52.3819297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034700',
        LOCATION_NAME: 'Woodford',
        COUNTY_NAME: 'London',
        POSTCODE: 'E18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0257115,
        LOCATION_LATITUDE_DEG: 51.5932296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011200',
        LOCATION_NAME: 'Woodford Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'IG8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0244694,
        LOCATION_LATITUDE_DEG: 51.6107527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011300',
        LOCATION_NAME: 'Woodford Halse',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2055982,
        LOCATION_LATITUDE_DEG: 52.1705242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011600',
        LOCATION_NAME: 'Woodgate',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.010682,
        LOCATION_LATITUDE_DEG: 52.4428554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011500',
        LOCATION_NAME: 'Woodgate',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'PO20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6679713,
        LOCATION_LATITUDE_DEG: 50.8261893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011700',
        LOCATION_NAME: 'Woodgreen',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SP6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7575624,
        LOCATION_LATITUDE_DEG: 50.9565171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011800',
        LOCATION_NAME: 'Woodhall',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9436823,
        LOCATION_LATITUDE_DEG: 53.7780707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011900',
        LOCATION_NAME: 'Woodhall Spa',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2099275,
        LOCATION_LATITUDE_DEG: 53.1524021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012000',
        LOCATION_NAME: 'Woodham',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9811604,
        LOCATION_LATITUDE_DEG: 51.857593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012100',
        LOCATION_NAME: 'Woodham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5094662,
        LOCATION_LATITUDE_DEG: 51.3481328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012200',
        LOCATION_NAME: 'Woodham Ferrers',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.5997151,
        LOCATION_LATITUDE_DEG: 51.6661473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012300',
        LOCATION_NAME: 'Woodham Mortimer',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6250735,
        LOCATION_LATITUDE_DEG: 51.7084502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012400',
        LOCATION_NAME: 'Woodham Walter',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.619796,
        LOCATION_LATITUDE_DEG: 51.7323581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012500',
        LOCATION_NAME: 'Woodhaven',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9524514,
        LOCATION_LATITUDE_DEG: 56.4334605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012600',
        LOCATION_NAME: 'Woodhead',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3491371,
        LOCATION_LATITUDE_DEG: 57.4370524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012700',
        LOCATION_NAME: 'Woodhead',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8613642,
        LOCATION_LATITUDE_DEG: 53.4961558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012900',
        LOCATION_NAME: 'Woodhill',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0841065,
        LOCATION_LATITUDE_DEG: 52.8318093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO012800',
        LOCATION_NAME: 'Woodhill',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8037583,
        LOCATION_LATITUDE_DEG: 52.0029022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013000',
        LOCATION_NAME: 'Woodhorn',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5316231,
        LOCATION_LATITUDE_DEG: 55.1935216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013100',
        LOCATION_NAME: 'Woodhorn Village',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.531217,
        LOCATION_LATITUDE_DEG: 55.1933223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013300',
        LOCATION_NAME: 'Woodhouse',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.751623,
        LOCATION_LATITUDE_DEG: 54.2438372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013200',
        LOCATION_NAME: 'Woodhouse',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3725811,
        LOCATION_LATITUDE_DEG: 53.3579367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013400',
        LOCATION_NAME: 'Woodhouse',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1998616,
        LOCATION_LATITUDE_DEG: 52.7334741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013500',
        LOCATION_NAME: 'Woodhouse Eaves',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2161936,
        LOCATION_LATITUDE_DEG: 52.7213736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013600',
        LOCATION_NAME: 'Woodhouse Mill',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3558659,
        LOCATION_LATITUDE_DEG: 53.367242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034400',
        LOCATION_NAME: 'Woodhouse Park',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2715046,
        LOCATION_LATITUDE_DEG: 53.3744156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013700',
        LOCATION_NAME: 'Woodhouses',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0518878,
        LOCATION_LATITUDE_DEG: 54.8600006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013800',
        LOCATION_NAME: 'Woodhurst',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0668782,
        LOCATION_LATITUDE_DEG: 52.3666249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO013900',
        LOCATION_NAME: 'Woodingdean',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'BN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0708398,
        LOCATION_LATITUDE_DEG: 50.8276827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014200',
        LOCATION_NAME: 'Woodland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7043917,
        LOCATION_LATITUDE_DEG: 50.5063894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014000',
        LOCATION_NAME: 'Woodland',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1660587,
        LOCATION_LATITUDE_DEG: 54.2956514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014100',
        LOCATION_NAME: 'Woodland',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8885124,
        LOCATION_LATITUDE_DEG: 54.6326693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014300',
        LOCATION_NAME: 'Woodlands',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9369084,
        LOCATION_LATITUDE_DEG: 50.389081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014600',
        LOCATION_NAME: 'Woodlands',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6671666,
        LOCATION_LATITUDE_DEG: 51.1341364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014500',
        LOCATION_NAME: 'Woodlands',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9322019,
        LOCATION_LATITUDE_DEG: 50.8816092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014400',
        LOCATION_NAME: 'Woodlands',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5392611,
        LOCATION_LATITUDE_DEG: 50.9045074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014700',
        LOCATION_NAME: 'Woodlands',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1942867,
        LOCATION_LATITUDE_DEG: 53.5614557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014750',
        LOCATION_NAME: 'Woodlands',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0789392,
        LOCATION_LATITUDE_DEG: 51.0393579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014900',
        LOCATION_NAME: 'Woodlands of Durris',
        COUNTY_NAME: 'Kincardineshire',
        POSTCODE: 'AB31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4764314,
        LOCATION_LATITUDE_DEG: 57.0132058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034100',
        LOCATION_NAME: 'Woodlands St Mary',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO014800',
        LOCATION_NAME: 'Woodlands St. Mary',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5159598,
        LOCATION_LATITUDE_DEG: 51.471758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015100',
        LOCATION_NAME: 'Woodleigh',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7725703,
        LOCATION_LATITUDE_DEG: 50.3252735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015200',
        LOCATION_NAME: 'Woodlesford',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4548424,
        LOCATION_LATITUDE_DEG: 53.7534741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015300',
        LOCATION_NAME: 'Woodley',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0951826,
        LOCATION_LATITUDE_DEG: 53.4265564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015400',
        LOCATION_NAME: 'Woodley',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9142453,
        LOCATION_LATITUDE_DEG: 51.4514533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015500',
        LOCATION_NAME: 'Woodleys',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3903118,
        LOCATION_LATITUDE_DEG: 51.869291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015600',
        LOCATION_NAME: 'Woodloes Park',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5931592,
        LOCATION_LATITUDE_DEG: 52.2936389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016000',
        LOCATION_NAME: 'Woodmancote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3426167,
        LOCATION_LATITUDE_DEG: 51.6758901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015800',
        LOCATION_NAME: 'Woodmancote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0429768,
        LOCATION_LATITUDE_DEG: 51.9406128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015700',
        LOCATION_NAME: 'Woodmancote',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9943753,
        LOCATION_LATITUDE_DEG: 51.7783966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015900',
        LOCATION_NAME: 'Woodmancote',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2433544,
        LOCATION_LATITUDE_DEG: 50.916286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016100',
        LOCATION_NAME: 'Woodmancott',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2009553,
        LOCATION_LATITUDE_DEG: 51.1764233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016200',
        LOCATION_NAME: 'Woodmansey',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3975556,
        LOCATION_LATITUDE_DEG: 53.8274745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016300',
        LOCATION_NAME: 'Woodmansterne',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'SM7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1678521,
        LOCATION_LATITUDE_DEG: 51.3242293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016400',
        LOCATION_NAME: 'Woodnesborough',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3127408,
        LOCATION_LATITUDE_DEG: 51.2652008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016500',
        LOCATION_NAME: 'Woodnewton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4775727,
        LOCATION_LATITUDE_DEG: 52.5383502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016600',
        LOCATION_NAME: 'Woodnook',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5944107,
        LOCATION_LATITUDE_DEG: 52.8782848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016700',
        LOCATION_NAME: 'Woodperry',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1673847,
        LOCATION_LATITUDE_DEG: 51.7888829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016800',
        LOCATION_NAME: 'Woodplumpton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7565018,
        LOCATION_LATITUDE_DEG: 53.8096962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016900',
        LOCATION_NAME: 'Woodredding',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5241226,
        LOCATION_LATITUDE_DEG: 51.9647213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017000',
        LOCATION_NAME: 'Woodrising',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9347941,
        LOCATION_LATITUDE_DEG: 52.591529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017100',
        LOCATION_NAME: 'Woodrow',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2072508,
        LOCATION_LATITUDE_DEG: 54.7965013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017300',
        LOCATION_NAME: 'Woodrow',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5789177,
        LOCATION_LATITUDE_DEG: 52.371757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017200',
        LOCATION_NAME: 'Woodrow',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6459615,
        LOCATION_LATITUDE_DEG: 51.6556624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017400',
        LOCATION_NAME: 'Woods Green',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'TN5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3427149,
        LOCATION_LATITUDE_DEG: 51.0760951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034300',
        LOCATION_NAME: 'Woodseats',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4780663,
        LOCATION_LATITUDE_DEG: 53.3435575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017500',
        LOCATION_NAME: 'Woodseaves',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4632456,
        LOCATION_LATITUDE_DEG: 52.8725009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017600',
        LOCATION_NAME: 'Woodseaves',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2972245,
        LOCATION_LATITUDE_DEG: 52.8259942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017700',
        LOCATION_NAME: 'Woodsetton',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1153412,
        LOCATION_LATITUDE_DEG: 52.5335638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017800',
        LOCATION_NAME: 'Woodsetts',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1707895,
        LOCATION_LATITUDE_DEG: 53.3474367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO017900',
        LOCATION_NAME: 'Woodsford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3365696,
        LOCATION_LATITUDE_DEG: 50.7130978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018600',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Perthshire',
        POSTCODE: 'PH13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2961902,
        LOCATION_LATITUDE_DEG: 56.5220747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018200',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'KY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.934297,
        LOCATION_LATITUDE_DEG: 56.2604441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018300',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4607001,
        LOCATION_LATITUDE_DEG: 52.6360832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018700',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1413909,
        LOCATION_LATITUDE_DEG: 57.1707164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018500',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7755718,
        LOCATION_LATITUDE_DEG: 54.9606029,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018400',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4366329,
        LOCATION_LATITUDE_DEG: 51.8574795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018100',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'CR0',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0632472,
        LOCATION_LATITUDE_DEG: 51.3876523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO991114',
        LOCATION_NAME: 'Woodside',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: '',
        LOCATION_LATITUDE_DEG: '',
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018800',
        LOCATION_NAME: 'Woodside Estate',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'LU5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5008257,
        LOCATION_LATITUDE_DEG: 51.8945826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018900',
        LOCATION_NAME: 'Woodspeen',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3618253,
        LOCATION_LATITUDE_DEG: 51.4184491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019000',
        LOCATION_NAME: 'Woodstock',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA63',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8636874,
        LOCATION_LATITUDE_DEG: 51.8970321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019100',
        LOCATION_NAME: 'Woodstock',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3519976,
        LOCATION_LATITUDE_DEG: 51.8466959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019200',
        LOCATION_NAME: 'Woodston',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2541397,
        LOCATION_LATITUDE_DEG: 52.5662425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019300',
        LOCATION_NAME: 'Woodstone Village',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'DH4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5166273,
        LOCATION_LATITUDE_DEG: 54.8470836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019600',
        LOCATION_NAME: 'Woodthorpe',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'S43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3236542,
        LOCATION_LATITUDE_DEG: 53.2657295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019700',
        LOCATION_NAME: 'Woodthorpe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1955531,
        LOCATION_LATITUDE_DEG: 52.7502758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019500',
        LOCATION_NAME: 'Woodthorpe',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1283381,
        LOCATION_LATITUDE_DEG: 52.9905987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019800',
        LOCATION_NAME: 'Woodthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1570485,
        LOCATION_LATITUDE_DEG: 53.3010116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019900',
        LOCATION_NAME: 'Woodton',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3779258,
        LOCATION_LATITUDE_DEG: 52.4951185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020000',
        LOCATION_NAME: 'Woodtown',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1444602,
        LOCATION_LATITUDE_DEG: 51.0130454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO035000',
        LOCATION_NAME: 'Woodvale',
        COUNTY_NAME: 'County Antrim',
        POSTCODE: 'BT13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.9617123,
        LOCATION_LATITUDE_DEG: 54.6070133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020100',
        LOCATION_NAME: 'Woodville',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0815923,
        LOCATION_LATITUDE_DEG: 51.0731504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020300',
        LOCATION_NAME: 'Woodville',
        COUNTY_NAME: 'Angus',
        POSTCODE: 'DD11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6369654,
        LOCATION_LATITUDE_DEG: 56.5819669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020400',
        LOCATION_NAME: 'Woodville',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5319161,
        LOCATION_LATITUDE_DEG: 52.7683801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020500',
        LOCATION_NAME: 'Woodwalton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2137478,
        LOCATION_LATITUDE_DEG: 52.4118296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020600',
        LOCATION_NAME: 'Woody Bay',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.895077,
        LOCATION_LATITUDE_DEG: 51.2238629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020700',
        LOCATION_NAME: 'Woofferton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7045381,
        LOCATION_LATITUDE_DEG: 52.3129546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020800',
        LOCATION_NAME: 'Wookey',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6900136,
        LOCATION_LATITUDE_DEG: 51.2092495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020900',
        LOCATION_NAME: 'Wookey Hole',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6690352,
        LOCATION_LATITUDE_DEG: 51.2218448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021000',
        LOCATION_NAME: 'Wool',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2186822,
        LOCATION_LATITUDE_DEG: 50.6789954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021100',
        LOCATION_NAME: 'Woolacombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2060142,
        LOCATION_LATITUDE_DEG: 51.1723616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021200',
        LOCATION_NAME: 'Woolage Green',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2043861,
        LOCATION_LATITUDE_DEG: 51.1999945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021300',
        LOCATION_NAME: 'Woolage Village',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2019264,
        LOCATION_LATITUDE_DEG: 51.1985955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021400',
        LOCATION_NAME: 'Woolaston',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.610719,
        LOCATION_LATITUDE_DEG: 51.7006911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021500',
        LOCATION_NAME: 'Woolavington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9336866,
        LOCATION_LATITUDE_DEG: 51.166343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021600',
        LOCATION_NAME: 'Woolbeding',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'GU29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7564462,
        LOCATION_LATITUDE_DEG: 50.9978061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021700',
        LOCATION_NAME: 'Woolbrook',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2486368,
        LOCATION_LATITUDE_DEG: 50.6959061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO035100',
        LOCATION_NAME: 'Woolcot Park',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6063315,
        LOCATION_LATITUDE_DEG: 51.4684198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021800',
        LOCATION_NAME: 'Wooler',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0129652,
        LOCATION_LATITUDE_DEG: 55.5455564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO990294',
        LOCATION_NAME: 'Woolfardisworthy',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3775308,
        LOCATION_LATITUDE_DEG: 50.9675075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO021900',
        LOCATION_NAME: 'Woolfords',
        COUNTY_NAME: 'West Lothian',
        POSTCODE: 'EH55',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.589406,
        LOCATION_LATITUDE_DEG: 55.7920664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022000',
        LOCATION_NAME: 'Woolhampton',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1769479,
        LOCATION_LATITUDE_DEG: 51.3970449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022100',
        LOCATION_NAME: 'Woolhope',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5665832,
        LOCATION_LATITUDE_DEG: 52.0177205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022200',
        LOCATION_NAME: 'Woolland',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3160798,
        LOCATION_LATITUDE_DEG: 50.8615142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022300',
        LOCATION_NAME: 'Woollard',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5271469,
        LOCATION_LATITUDE_DEG: 51.3763574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022400',
        LOCATION_NAME: 'Woolley',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4869366,
        LOCATION_LATITUDE_DEG: 50.9219437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022500',
        LOCATION_NAME: 'Woolley',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.359867,
        LOCATION_LATITUDE_DEG: 51.4156592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022700',
        LOCATION_NAME: 'Woolley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5149225,
        LOCATION_LATITUDE_DEG: 53.6137602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022600',
        LOCATION_NAME: 'Woolley',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4090585,
        LOCATION_LATITUDE_DEG: 51.5175621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022800',
        LOCATION_NAME: 'Woolley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3087541,
        LOCATION_LATITUDE_DEG: 52.3565316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO022900',
        LOCATION_NAME: 'Woolmer Green',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1788646,
        LOCATION_LATITUDE_DEG: 51.8504793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023000',
        LOCATION_NAME: 'Woolmet',
        COUNTY_NAME: 'Midlothian',
        POSTCODE: 'EH22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.098153,
        LOCATION_LATITUDE_DEG: 55.9226092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023100',
        LOCATION_NAME: 'Woolminstone',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8371832,
        LOCATION_LATITUDE_DEG: 50.8674207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023200',
        LOCATION_NAME: 'Woolpit',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP30',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8907777,
        LOCATION_LATITUDE_DEG: 52.2230023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023300',
        LOCATION_NAME: 'Woolscott',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2708683,
        LOCATION_LATITUDE_DEG: 52.3061337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023400',
        LOCATION_NAME: 'Woolsery',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.375507,
        LOCATION_LATITUDE_DEG: 50.9641397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023500',
        LOCATION_NAME: 'Woolsington',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6927673,
        LOCATION_LATITUDE_DEG: 55.0230992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023600',
        LOCATION_NAME: 'Woolstanwood',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4731786,
        LOCATION_LATITUDE_DEG: 53.0981278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023700',
        LOCATION_NAME: 'Woolstaston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8080507,
        LOCATION_LATITUDE_DEG: 52.580484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023800',
        LOCATION_NAME: 'Woolsthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7550837,
        LOCATION_LATITUDE_DEG: 52.8962885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO023900',
        LOCATION_NAME: 'Woolsthorpe by Colsterworth',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6341963,
        LOCATION_LATITUDE_DEG: 52.8091756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO990974',
        LOCATION_NAME: 'Woolston',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024200',
        LOCATION_NAME: 'Woolston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8005569,
        LOCATION_LATITUDE_DEG: 50.2604738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024000',
        LOCATION_NAME: 'Woolston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0077048,
        LOCATION_LATITUDE_DEG: 52.810302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024300',
        LOCATION_NAME: 'Woolston',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8477872,
        LOCATION_LATITUDE_DEG: 52.4795678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024100',
        LOCATION_NAME: 'Woolston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'WA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5333207,
        LOCATION_LATITUDE_DEG: 53.4013563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024400',
        LOCATION_NAME: 'Woolstone',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'SN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5759907,
        LOCATION_LATITUDE_DEG: 51.5880748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024500',
        LOCATION_NAME: 'Woolstone',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7485993,
        LOCATION_LATITUDE_DEG: 52.0467056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024600',
        LOCATION_NAME: 'Woolton',
        COUNTY_NAME: 'Merseyside',
        POSTCODE: 'L26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8643574,
        LOCATION_LATITUDE_DEG: 53.3737617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024700',
        LOCATION_NAME: 'Woolton Hill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3831609,
        LOCATION_LATITUDE_DEG: 51.3538422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024800',
        LOCATION_NAME: 'Woolverstone',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1912355,
        LOCATION_LATITUDE_DEG: 52.0015686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO024900',
        LOCATION_NAME: 'Woolverton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2989953,
        LOCATION_LATITUDE_DEG: 51.2840503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025000',
        LOCATION_NAME: 'Woolwell',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1042161,
        LOCATION_LATITUDE_DEG: 50.4347935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034500',
        LOCATION_NAME: 'Woolwich',
        COUNTY_NAME: 'London',
        POSTCODE: 'SE18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0668252,
        LOCATION_LATITUDE_DEG: 51.4908472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025100',
        LOCATION_NAME: 'Woonton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9468676,
        LOCATION_LATITUDE_DEG: 52.1648401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025200',
        LOCATION_NAME: 'Wooperton',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE66',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9306157,
        LOCATION_LATITUDE_DEG: 55.4785523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025300',
        LOCATION_NAME: 'Woore',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4012249,
        LOCATION_LATITUDE_DEG: 52.9770151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025400',
        LOCATION_NAME: 'Woosehill',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8608892,
        LOCATION_LATITUDE_DEG: 51.4144444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025500',
        LOCATION_NAME: 'Wooth',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7487357,
        LOCATION_LATITUDE_DEG: 50.7544039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025700',
        LOCATION_NAME: 'Wootton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3395362,
        LOCATION_LATITUDE_DEG: 52.4990662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026200',
        LOCATION_NAME: 'Wootton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3622121,
        LOCATION_LATITUDE_DEG: 51.8748969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026000',
        LOCATION_NAME: 'Wootton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3132915,
        LOCATION_LATITUDE_DEG: 51.7062784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025800',
        LOCATION_NAME: 'Wootton',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8839168,
        LOCATION_LATITUDE_DEG: 52.2013241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025900',
        LOCATION_NAME: 'Wootton',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK43',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5344113,
        LOCATION_LATITUDE_DEG: 52.0950069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026100',
        LOCATION_NAME: 'Wootton',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3527676,
        LOCATION_LATITUDE_DEG: 53.6294512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO025600',
        LOCATION_NAME: 'Wootton',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1810957,
        LOCATION_LATITUDE_DEG: 51.1732919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026300',
        LOCATION_NAME: 'Wootton Bassett',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8960125,
        LOCATION_LATITUDE_DEG: 51.5465662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026400',
        LOCATION_NAME: 'Wootton Bridge',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2325857,
        LOCATION_LATITUDE_DEG: 50.7252863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026500',
        LOCATION_NAME: 'Wootton Courtenay',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5190451,
        LOCATION_LATITUDE_DEG: 51.1769519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026600',
        LOCATION_NAME: 'Wootton Fitzpaine',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8941318,
        LOCATION_LATITUDE_DEG: 50.7566086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026700',
        LOCATION_NAME: 'Wootton Rivers',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7171992,
        LOCATION_LATITUDE_DEG: 51.3673548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034000',
        LOCATION_NAME: 'Wootton St Lawrence',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026800',
        LOCATION_NAME: 'Wootton St. Lawrence',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1499209,
        LOCATION_LATITUDE_DEG: 51.2736392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO026900',
        LOCATION_NAME: 'Wootton Wawen',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B95',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7820175,
        LOCATION_LATITUDE_DEG: 52.2669397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027000',
        LOCATION_NAME: 'Worcester',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2196373,
        LOCATION_LATITUDE_DEG: 52.1925328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027100',
        LOCATION_NAME: 'Worcester Park',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'KT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2425682,
        LOCATION_LATITUDE_DEG: 51.3797322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027200',
        LOCATION_NAME: 'Wordsley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'DY8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1619721,
        LOCATION_LATITUDE_DEG: 52.4803635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027300',
        LOCATION_NAME: 'Wordwell',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6827327,
        LOCATION_LATITUDE_DEG: 52.3126125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027400',
        LOCATION_NAME: 'Worfield',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'WV15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3574491,
        LOCATION_LATITUDE_DEG: 52.5569693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027500',
        LOCATION_NAME: 'Workington',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.547997,
        LOCATION_LATITUDE_DEG: 54.6432849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027600',
        LOCATION_NAME: 'Worksop',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'S81',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1194668,
        LOCATION_LATITUDE_DEG: 53.3125294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027700',
        LOCATION_NAME: 'Worlaby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4657981,
        LOCATION_LATITUDE_DEG: 53.6114537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027800',
        LOCATION_NAME: 'Worlaby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0093181,
        LOCATION_LATITUDE_DEG: 53.2718081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO027900',
        LOCATION_NAME: 'Worlds End',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1060361,
        LOCATION_LATITUDE_DEG: 50.9016972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028000',
        LOCATION_NAME: 'Worle',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9298673,
        LOCATION_LATITUDE_DEG: 51.3609667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028100',
        LOCATION_NAME: 'Worlebury',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9452887,
        LOCATION_LATITUDE_DEG: 51.358568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028200',
        LOCATION_NAME: 'Worleston',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5107605,
        LOCATION_LATITUDE_DEG: 53.1008314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028300',
        LOCATION_NAME: 'Worlingham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5850926,
        LOCATION_LATITUDE_DEG: 52.4496062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028400',
        LOCATION_NAME: 'Worlington',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4893011,
        LOCATION_LATITUDE_DEG: 52.3346116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028500',
        LOCATION_NAME: 'Worlingworth',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.2721271,
        LOCATION_LATITUDE_DEG: 52.2696963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028600',
        LOCATION_NAME: 'Wormald Green',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'HG3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5332983,
        LOCATION_LATITUDE_DEG: 54.0791055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028700',
        LOCATION_NAME: 'Wormbridge',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8277296,
        LOCATION_LATITUDE_DEG: 51.9764216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028800',
        LOCATION_NAME: 'Wormegay',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4613014,
        LOCATION_LATITUDE_DEG: 52.6781509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028850',
        LOCATION_NAME: 'Wormelow',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7385028,
        LOCATION_LATITUDE_DEG: 51.9667191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO990086',
        LOCATION_NAME: 'Wormelow Tump',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7393676,
        LOCATION_LATITUDE_DEG: 51.9679636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO028900',
        LOCATION_NAME: 'Wormhill',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'SK17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8179173,
        LOCATION_LATITUDE_DEG: 53.2703314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029000',
        LOCATION_NAME: 'Wormingford',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8104545,
        LOCATION_LATITUDE_DEG: 51.9483704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029100',
        LOCATION_NAME: 'Worminghall',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0707005,
        LOCATION_LATITUDE_DEG: 51.771082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029200',
        LOCATION_NAME: 'Wormington',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9402086,
        LOCATION_LATITUDE_DEG: 52.0253169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029300',
        LOCATION_NAME: 'Wormit',
        COUNTY_NAME: 'Fife',
        POSTCODE: 'DD6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9697313,
        LOCATION_LATITUDE_DEG: 56.4286542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029400',
        LOCATION_NAME: 'Wormleighton',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3437533,
        LOCATION_LATITUDE_DEG: 52.1782252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029500',
        LOCATION_NAME: 'Wormley',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6416486,
        LOCATION_LATITUDE_DEG: 51.1365147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029600',
        LOCATION_NAME: 'Wormley',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0227078,
        LOCATION_LATITUDE_DEG: 51.7319617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029700',
        LOCATION_NAME: 'Wormley West End',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0655939,
        LOCATION_LATITUDE_DEG: 51.7363629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029800',
        LOCATION_NAME: 'Wormshill',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6987451,
        LOCATION_LATITUDE_DEG: 51.2848092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO029900',
        LOCATION_NAME: 'Wormsley',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8315161,
        LOCATION_LATITUDE_DEG: 52.1257413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030000',
        LOCATION_NAME: 'Worplesdon',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6072928,
        LOCATION_LATITUDE_DEG: 51.2752314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030100',
        LOCATION_NAME: 'Worplesdon Hill',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6162609,
        LOCATION_LATITUDE_DEG: 51.2998268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030200',
        LOCATION_NAME: 'Worrall',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5373779,
        LOCATION_LATITUDE_DEG: 53.42355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030300',
        LOCATION_NAME: 'Worrall Hill',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5762365,
        LOCATION_LATITUDE_DEG: 51.8296067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030400',
        LOCATION_NAME: 'Worsbrough',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S75',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4563853,
        LOCATION_LATITUDE_DEG: 53.5314527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030500',
        LOCATION_NAME: 'Worsbrough Bridge',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4664982,
        LOCATION_LATITUDE_DEG: 53.5311567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030600',
        LOCATION_NAME: 'Worsbrough Common',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4847928,
        LOCATION_LATITUDE_DEG: 53.5429592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030700',
        LOCATION_NAME: 'Worsbrough Dale',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S70',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4498917,
        LOCATION_LATITUDE_DEG: 53.5295532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030800',
        LOCATION_NAME: 'Worsham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5649331,
        LOCATION_LATITUDE_DEG: 51.793292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO030900',
        LOCATION_NAME: 'Worsley',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3855371,
        LOCATION_LATITUDE_DEG: 53.5068603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031000',
        LOCATION_NAME: 'Worsley Mesnes',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6479832,
        LOCATION_LATITUDE_DEG: 53.5325688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031100',
        LOCATION_NAME: 'Worstead',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4145631,
        LOCATION_LATITUDE_DEG: 52.7828405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031200',
        LOCATION_NAME: 'Worsthorne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1890809,
        LOCATION_LATITUDE_DEG: 53.7874916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031400',
        LOCATION_NAME: 'Worston',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9708961,
        LOCATION_LATITUDE_DEG: 50.3590775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031300',
        LOCATION_NAME: 'Worston',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'BB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3558824,
        LOCATION_LATITUDE_DEG: 53.8794027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031600',
        LOCATION_NAME: 'Worth',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'RH10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.145408,
        LOCATION_LATITUDE_DEG: 51.1117086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031500',
        LOCATION_NAME: 'Worth',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.34982,
        LOCATION_LATITUDE_DEG: 51.2558951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031700',
        LOCATION_NAME: 'Worth Matravers',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'BH19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0382359,
        LOCATION_LATITUDE_DEG: 50.5955786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031800',
        LOCATION_NAME: 'Wortham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0582685,
        LOCATION_LATITUDE_DEG: 52.3522114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO031900',
        LOCATION_NAME: 'Worthen',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9931525,
        LOCATION_LATITUDE_DEG: 52.6357835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032000',
        LOCATION_NAME: 'Worthenbury',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8636796,
        LOCATION_LATITUDE_DEG: 53.0087189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032100',
        LOCATION_NAME: 'Worthing',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3686822,
        LOCATION_LATITUDE_DEG: 50.8110824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032200',
        LOCATION_NAME: 'Worthing',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9560433,
        LOCATION_LATITUDE_DEG: 52.736944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032300',
        LOCATION_NAME: 'Worthington',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE65',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.39384,
        LOCATION_LATITUDE_DEG: 52.7788854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032400',
        LOCATION_NAME: 'Worthy Down',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'SO21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3352426,
        LOCATION_LATITUDE_DEG: 51.1037171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032500',
        LOCATION_NAME: 'Worting',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'RG23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1363185,
        LOCATION_LATITUDE_DEG: 51.2627299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032700',
        LOCATION_NAME: 'Wortley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3381692,
        LOCATION_LATITUDE_DEG: 51.6224796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO035200',
        LOCATION_NAME: 'Wortley',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5957263,
        LOCATION_LATITUDE_DEG: 53.7939617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032600',
        LOCATION_NAME: 'Wortley',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5364832,
        LOCATION_LATITUDE_DEG: 53.4905551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032800',
        LOCATION_NAME: 'Worton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0682574,
        LOCATION_LATITUDE_DEG: 54.3054389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO032900',
        LOCATION_NAME: 'Worton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0306954,
        LOCATION_LATITUDE_DEG: 51.3164514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033000',
        LOCATION_NAME: 'Wortwell',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.348994,
        LOCATION_LATITUDE_DEG: 52.4156075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033100',
        LOCATION_NAME: 'Wothersome',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.393399,
        LOCATION_LATITUDE_DEG: 53.8774897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033200',
        LOCATION_NAME: 'Wothorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4844825,
        LOCATION_LATITUDE_DEG: 52.6339574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033300',
        LOCATION_NAME: 'Wotter',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0304437,
        LOCATION_LATITUDE_DEG: 50.4383894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033400',
        LOCATION_NAME: 'Wotton',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'RH5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3875401,
        LOCATION_LATITUDE_DEG: 51.216623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO034200',
        LOCATION_NAME: 'Wotton under Edge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.347985,
        LOCATION_LATITUDE_DEG: 51.6422071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033500',
        LOCATION_NAME: 'Wotton Underwood',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'HP18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0036049,
        LOCATION_LATITUDE_DEG: 51.838191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033600',
        LOCATION_NAME: 'Wotton-under-Edge',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3470217,
        LOCATION_LATITUDE_DEG: 51.6390806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033800',
        LOCATION_NAME: 'Woughton on the Green',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7222611,
        LOCATION_LATITUDE_DEG: 52.0293018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033700',
        LOCATION_NAME: 'Woughton Park',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.717645,
        LOCATION_LATITUDE_DEG: 52.0281006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO033900',
        LOCATION_NAME: 'Wouldham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4597223,
        LOCATION_LATITUDE_DEG: 51.3481196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000100',
        LOCATION_NAME: 'Wrabness',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CO11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1631822,
        LOCATION_LATITUDE_DEG: 51.9323622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000200',
        LOCATION_NAME: 'Wrackleford',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4691603,
        LOCATION_LATITUDE_DEG: 50.7346025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000300',
        LOCATION_NAME: 'Wrafton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1520179,
        LOCATION_LATITUDE_DEG: 51.1001532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000400',
        LOCATION_NAME: 'Wragby',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3775121,
        LOCATION_LATITUDE_DEG: 53.6490641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000500',
        LOCATION_NAME: 'Wragby',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2956653,
        LOCATION_LATITUDE_DEG: 53.2862146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000600',
        LOCATION_NAME: 'Wragholme',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.067343,
        LOCATION_LATITUDE_DEG: 53.4619269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000700',
        LOCATION_NAME: 'Wramplingham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1225844,
        LOCATION_LATITUDE_DEG: 52.6140292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000800',
        LOCATION_NAME: 'Wrangaton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'TQ10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8487984,
        LOCATION_LATITUDE_DEG: 50.3994833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR000900',
        LOCATION_NAME: 'Wrangle',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.12338,
        LOCATION_LATITUDE_DEG: 53.0379884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001000',
        LOCATION_NAME: 'Wrangle Bank',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.1279695,
        LOCATION_LATITUDE_DEG: 53.0605929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001100',
        LOCATION_NAME: 'Wrangway',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2478822,
        LOCATION_LATITUDE_DEG: 50.9551296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001200',
        LOCATION_NAME: 'Wrantage',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9885212,
        LOCATION_LATITUDE_DEG: 50.9958266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001300',
        LOCATION_NAME: 'Wrawby',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4598734,
        LOCATION_LATITUDE_DEG: 53.5640438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001400',
        LOCATION_NAME: 'Wrawby Moors',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4418184,
        LOCATION_LATITUDE_DEG: 53.5782484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001550',
        LOCATION_NAME: 'Wraxall',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7319793,
        LOCATION_LATITUDE_DEG: 51.4419745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001500',
        LOCATION_NAME: 'Wraxall',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.569902,
        LOCATION_LATITUDE_DEG: 51.1253339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001600',
        LOCATION_NAME: 'Wray',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6080063,
        LOCATION_LATITUDE_DEG: 54.1030226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001700',
        LOCATION_NAME: 'Wraysbury',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'TW19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.559819,
        LOCATION_LATITUDE_DEG: 51.4519697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001800',
        LOCATION_NAME: 'Wrayton',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5959372,
        LOCATION_LATITUDE_DEG: 54.1445298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR001900',
        LOCATION_NAME: 'Wrea Green',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9147691,
        LOCATION_LATITUDE_DEG: 53.7763936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002000',
        LOCATION_NAME: 'Wreay',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8792896,
        LOCATION_LATITUDE_DEG: 54.8315962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002100',
        LOCATION_NAME: 'Wrecclesham',
        COUNTY_NAME: 'Surrey',
        POSTCODE: 'GU10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8151809,
        LOCATION_LATITUDE_DEG: 51.1995209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR005000',
        LOCATION_NAME: 'Wrekenton',
        COUNTY_NAME: 'Tyne and Wear',
        POSTCODE: 'NE9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5724572,
        LOCATION_LATITUDE_DEG: 54.9302024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002200',
        LOCATION_NAME: 'Wrekin Course',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5541021,
        LOCATION_LATITUDE_DEG: 52.677185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002300',
        LOCATION_NAME: 'Wrelton',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8263459,
        LOCATION_LATITUDE_DEG: 54.2628222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002400',
        LOCATION_NAME: 'Wrenbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6062632,
        LOCATION_LATITUDE_DEG: 53.024919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002500',
        LOCATION_NAME: 'Wreningham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR16',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1958608,
        LOCATION_LATITUDE_DEG: 52.5436249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002600',
        LOCATION_NAME: 'Wrentham',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'NR34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6710868,
        LOCATION_LATITUDE_DEG: 52.3839041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002700',
        LOCATION_NAME: 'Wrenthorpe',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'WF2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.5207865,
        LOCATION_LATITUDE_DEG: 53.6979688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002800',
        LOCATION_NAME: 'Wrentnall',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8484196,
        LOCATION_LATITUDE_DEG: 52.6278813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002950',
        LOCATION_NAME: 'Wressle',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9236802,
        LOCATION_LATITUDE_DEG: 53.7744499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR002900',
        LOCATION_NAME: 'Wressle',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5338766,
        LOCATION_LATITUDE_DEG: 53.5734516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003000',
        LOCATION_NAME: 'Wrestlingworth',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'SG19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1629449,
        LOCATION_LATITUDE_DEG: 52.1111062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003100',
        LOCATION_NAME: 'Wretham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'IP24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.8263652,
        LOCATION_LATITUDE_DEG: 52.4749199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003200',
        LOCATION_NAME: 'Wretton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'PE33',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4943397,
        LOCATION_LATITUDE_DEG: 52.5721336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003300',
        LOCATION_NAME: 'Wrexham',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9903077,
        LOCATION_LATITUDE_DEG: 53.0466249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003350',
        LOCATION_NAME: 'Wrexham Industrial Estate',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'LL13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.913649,
        LOCATION_LATITUDE_DEG: 53.0386075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003400',
        LOCATION_NAME: 'Wrigglebrook',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7197395,
        LOCATION_LATITUDE_DEG: 51.9804221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR990633',
        LOCATION_NAME: 'Wrightington',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6920204,
        LOCATION_LATITUDE_DEG: 53.6070522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR990634',
        LOCATION_NAME: 'Wrightington Bar',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'WN2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003500',
        LOCATION_NAME: 'Wrinehill',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3680788,
        LOCATION_LATITUDE_DEG: 53.0201138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003600',
        LOCATION_NAME: 'Wrington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS40',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.761691,
        LOCATION_LATITUDE_DEG: 51.3612634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003700',
        LOCATION_NAME: 'Writhlington',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BA3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4268401,
        LOCATION_LATITUDE_DEG: 51.288753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003800',
        LOCATION_NAME: 'Writtle',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4308652,
        LOCATION_LATITUDE_DEG: 51.7282537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR003900',
        LOCATION_NAME: 'Wrockwardine',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5556282,
        LOCATION_LATITUDE_DEG: 52.7041862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004000',
        LOCATION_NAME: 'Wroot',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'DN9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9220066,
        LOCATION_LATITUDE_DEG: 53.5189472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004100',
        LOCATION_NAME: 'Wrose',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7585907,
        LOCATION_LATITUDE_DEG: 53.8276864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004200',
        LOCATION_NAME: 'Wrotham',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3101191,
        LOCATION_LATITUDE_DEG: 51.3073192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004300',
        LOCATION_NAME: 'Wrotham Heath',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3513407,
        LOCATION_LATITUDE_DEG: 51.2982145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004400',
        LOCATION_NAME: 'Wroughton',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7902451,
        LOCATION_LATITUDE_DEG: 51.5227657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004600',
        LOCATION_NAME: 'Wroxall',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6677343,
        LOCATION_LATITUDE_DEG: 52.3376419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004500',
        LOCATION_NAME: 'Wroxall',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO38',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2213419,
        LOCATION_LATITUDE_DEG: 50.6153777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004700',
        LOCATION_NAME: 'Wroxeter',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6454277,
        LOCATION_LATITUDE_DEG: 52.6709867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004800',
        LOCATION_NAME: 'Wroxham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.4010954,
        LOCATION_LATITUDE_DEG: 52.7062409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WR004900',
        LOCATION_NAME: 'Wroxton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3983027,
        LOCATION_LATITUDE_DEG: 52.0735113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000100',
        LOCATION_NAME: 'Wyaston',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.725159,
        LOCATION_LATITUDE_DEG: 52.9786061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000200',
        LOCATION_NAME: 'Wyatts Green',
        COUNTY_NAME: 'Essex',
        POSTCODE: 'CM15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.3132402,
        LOCATION_LATITUDE_DEG: 51.6685533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000300',
        LOCATION_NAME: 'Wyberton',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.042323,
        LOCATION_LATITUDE_DEG: 52.9514816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000400',
        LOCATION_NAME: 'Wyberton Fen',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0727351,
        LOCATION_LATITUDE_DEG: 52.978684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000500',
        LOCATION_NAME: 'Wyboston',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.3040789,
        LOCATION_LATITUDE_DEG: 52.1973098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000600',
        LOCATION_NAME: 'Wybunbury',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'CW5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4474668,
        LOCATION_LATITUDE_DEG: 53.0442232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005700',
        LOCATION_NAME: 'Wyburn',
        COUNTY_NAME: 'South Yorkshire',
        POSTCODE: 'S2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000700',
        LOCATION_NAME: 'Wych Cross',
        COUNTY_NAME: 'East Sussex',
        POSTCODE: 'RH18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0264683,
        LOCATION_LATITUDE_DEG: 51.0679042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000800',
        LOCATION_NAME: 'Wychbold',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1134078,
        LOCATION_LATITUDE_DEG: 52.2920463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY000900',
        LOCATION_NAME: 'Wychnor',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.738811,
        LOCATION_LATITUDE_DEG: 52.7446873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001000',
        LOCATION_NAME: 'Wychough',
        COUNTY_NAME: 'Cheshire',
        POSTCODE: 'SY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7647119,
        LOCATION_LATITUDE_DEG: 53.0082187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001100',
        LOCATION_NAME: 'Wyck',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU34',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.9178524,
        LOCATION_LATITUDE_DEG: 51.1497211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001200',
        LOCATION_NAME: 'Wyck Rissington',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7264024,
        LOCATION_LATITUDE_DEG: 51.8943002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001300',
        LOCATION_NAME: 'Wycliffe',
        COUNTY_NAME: 'County Durham',
        POSTCODE: 'DL12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8196615,
        LOCATION_LATITUDE_DEG: 54.5240579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY990244',
        LOCATION_NAME: 'Wycoller',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'PR3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1045328,
        LOCATION_LATITUDE_DEG: 53.8501494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001400',
        LOCATION_NAME: 'Wycombe',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8504826,
        LOCATION_LATITUDE_DEG: 52.8155766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001500',
        LOCATION_NAME: 'Wyddial',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'SG9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0010484,
        LOCATION_LATITUDE_DEG: 51.9663823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001600',
        LOCATION_NAME: 'Wye',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'TN25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9390257,
        LOCATION_LATITUDE_DEG: 51.1830025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001700',
        LOCATION_NAME: 'Wyesham',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7001405,
        LOCATION_LATITUDE_DEG: 51.807506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001800',
        LOCATION_NAME: 'Wyfold',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0080462,
        LOCATION_LATITUDE_DEG: 51.5297576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY001900',
        LOCATION_NAME: 'Wyfordby',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8251563,
        LOCATION_LATITUDE_DEG: 52.7619757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002000',
        LOCATION_NAME: 'Wyham',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.077209,
        LOCATION_LATITUDE_DEG: 53.4374312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002400',
        LOCATION_NAME: 'Wyke',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9951047,
        LOCATION_LATITUDE_DEG: 50.7662056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002500',
        LOCATION_NAME: 'Wyke',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5664536,
        LOCATION_LATITUDE_DEG: 50.9284238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002300',
        LOCATION_NAME: 'Wyke',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'TF13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5205163,
        LOCATION_LATITUDE_DEG: 52.615579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002200',
        LOCATION_NAME: 'Wyke',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'SP8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2874105,
        LOCATION_LATITUDE_DEG: 51.0381283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002100',
        LOCATION_NAME: 'Wyke',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'BD12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7624772,
        LOCATION_LATITUDE_DEG: 53.7368777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002600',
        LOCATION_NAME: 'Wyke Champflower',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4815446,
        LOCATION_LATITUDE_DEG: 51.1093365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002700',
        LOCATION_NAME: 'Wyke Regis',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4742648,
        LOCATION_LATITUDE_DEG: 50.5943856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002800',
        LOCATION_NAME: 'Wykeham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7516094,
        LOCATION_LATITUDE_DEG: 54.1653042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY002900',
        LOCATION_NAME: 'Wykeham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5199981,
        LOCATION_LATITUDE_DEG: 54.2365098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003000',
        LOCATION_NAME: 'Wykeham',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'PE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1095631,
        LOCATION_LATITUDE_DEG: 52.8088647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003100',
        LOCATION_NAME: 'Wyken',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'CV2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4602374,
        LOCATION_LATITUDE_DEG: 52.4218526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003200',
        LOCATION_NAME: 'Wykey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9024012,
        LOCATION_LATITUDE_DEG: 52.8175058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003300',
        LOCATION_NAME: 'Wykin',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3999185,
        LOCATION_LATITUDE_DEG: 52.5543608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003400',
        LOCATION_NAME: 'Wylam',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.823105,
        LOCATION_LATITUDE_DEG: 54.9772989,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003500',
        LOCATION_NAME: 'Wylde Green',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B73',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8229861,
        LOCATION_LATITUDE_DEG: 52.547963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003600',
        LOCATION_NAME: 'Wyllie',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1887527,
        LOCATION_LATITUDE_DEG: 51.6384952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003700',
        LOCATION_NAME: 'Wylye',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9890928,
        LOCATION_LATITUDE_DEG: 51.1382331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003800',
        LOCATION_NAME: 'Wymbush',
        COUNTY_NAME: 'Buckinghamshire',
        POSTCODE: 'MK8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7948562,
        LOCATION_LATITUDE_DEG: 52.0414059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY003900',
        LOCATION_NAME: 'Wymering',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'PO6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0747822,
        LOCATION_LATITUDE_DEG: 50.845297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004000',
        LOCATION_NAME: 'Wymeswold',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1057553,
        LOCATION_LATITUDE_DEG: 52.8054839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004100',
        LOCATION_NAME: 'Wymington',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6010322,
        LOCATION_LATITUDE_DEG: 52.2688249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004300',
        LOCATION_NAME: 'Wymondham',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7377982,
        LOCATION_LATITUDE_DEG: 52.7598735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004200',
        LOCATION_NAME: 'Wymondham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1176243,
        LOCATION_LATITUDE_DEG: 52.5700249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY006100',
        LOCATION_NAME: 'Wyndford',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.289855,
        LOCATION_LATITUDE_DEG: 55.8904407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004400',
        LOCATION_NAME: 'Wynford Eagle',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5898738,
        LOCATION_LATITUDE_DEG: 50.7614043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004500',
        LOCATION_NAME: 'Wynyard',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3481541,
        LOCATION_LATITUDE_DEG: 54.6368625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004600',
        LOCATION_NAME: 'Wyre',
        COUNTY_NAME: 'Orkney',
        POSTCODE: 'KW17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.9664774,
        LOCATION_LATITUDE_DEG: 59.1165272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004700',
        LOCATION_NAME: 'Wyre Forest',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.38101,
        LOCATION_LATITUDE_DEG: 52.3901564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004800',
        LOCATION_NAME: 'Wyre Piddle',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'WR10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.0495525,
        LOCATION_LATITUDE_DEG: 52.1250298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY004900',
        LOCATION_NAME: 'Wysall',
        COUNTY_NAME: 'Nottinghamshire',
        POSTCODE: 'NG12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1022879,
        LOCATION_LATITUDE_DEG: 52.8376807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005000',
        LOCATION_NAME: 'Wythall',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B47',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8838134,
        LOCATION_LATITUDE_DEG: 52.3732525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005100',
        LOCATION_NAME: 'Wytham',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3105578,
        LOCATION_LATITUDE_DEG: 51.7746847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY006000',
        LOCATION_NAME: 'Wythenshawe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2769174,
        LOCATION_LATITUDE_DEG: 53.4162859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005900',
        LOCATION_NAME: 'Wythenshawe',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'M22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2637912,
        LOCATION_LATITUDE_DEG: 53.3936168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005200',
        LOCATION_NAME: 'Wythop',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1836028,
        LOCATION_LATITUDE_DEG: 54.6770917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005300',
        LOCATION_NAME: 'Wyton',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'HU11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2148075,
        LOCATION_LATITUDE_DEG: 53.7823604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005400',
        LOCATION_NAME: 'Wyton',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1292663,
        LOCATION_LATITUDE_DEG: 52.3343213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005500',
        LOCATION_NAME: 'Wyverstone',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9935976,
        LOCATION_LATITUDE_DEG: 52.2701043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WY005600',
        LOCATION_NAME: 'Wyville',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'NG32',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6899163,
        LOCATION_LATITUDE_DEG: 52.8524846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'Y 000100',
        LOCATION_NAME: 'Y Felinheli',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL56',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.203279,
        LOCATION_LATITUDE_DEG: 53.1869514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'Y 000200',
        LOCATION_NAME: 'Y Ffor',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL53',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3843838,
        LOCATION_LATITUDE_DEG: 52.9247276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000100',
        LOCATION_NAME: 'Yaddlethorpe',
        COUNTY_NAME: 'North Lincolnshire',
        POSTCODE: 'DN17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6626183,
        LOCATION_LATITUDE_DEG: 53.559848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000200',
        LOCATION_NAME: 'Yafforth',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'DL7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.470576,
        LOCATION_LATITUDE_DEG: 54.3443306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000300',
        LOCATION_NAME: 'Yalding',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.4336146,
        LOCATION_LATITUDE_DEG: 51.2256101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000400',
        LOCATION_NAME: 'Yanwath',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7586091,
        LOCATION_LATITUDE_DEG: 54.6436829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000500',
        LOCATION_NAME: 'Yanworth',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8877599,
        LOCATION_LATITUDE_DEG: 51.8227009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000600',
        LOCATION_NAME: 'Yapham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO42',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7979653,
        LOCATION_LATITUDE_DEG: 53.9583853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000700',
        LOCATION_NAME: 'Yapton',
        COUNTY_NAME: 'West Sussex',
        POSTCODE: 'BN18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6068974,
        LOCATION_LATITUDE_DEG: 50.8227868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000800',
        LOCATION_NAME: 'Yarburgh',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'LN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.0311442,
        LOCATION_LATITUDE_DEG: 53.4172234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA000900',
        LOCATION_NAME: 'Yarcombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0724183,
        LOCATION_LATITUDE_DEG: 50.8682214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004800',
        LOCATION_NAME: 'Yardley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8166977,
        LOCATION_LATITUDE_DEG: 52.4678259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004500',
        LOCATION_NAME: 'Yardley',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.79867,
        LOCATION_LATITUDE_DEG: 52.4599024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001000',
        LOCATION_NAME: 'Yardley Gobion',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8828876,
        LOCATION_LATITUDE_DEG: 52.095812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001100',
        LOCATION_NAME: 'Yardley Hastings',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7329708,
        LOCATION_LATITUDE_DEG: 52.204116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004700',
        LOCATION_NAME: 'Yardley Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8660007,
        LOCATION_LATITUDE_DEG: 52.4146738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004900',
        LOCATION_NAME: 'Yardley Wood',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'B28',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.8544784,
        LOCATION_LATITUDE_DEG: 52.4218441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001200',
        LOCATION_NAME: 'Yarhampton',
        COUNTY_NAME: 'Worcestershire',
        POSTCODE: 'DY13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3277289,
        LOCATION_LATITUDE_DEG: 52.3037484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001300',
        LOCATION_NAME: 'Yarkhill',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5719372,
        LOCATION_LATITUDE_DEG: 52.0798277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001400',
        LOCATION_NAME: 'Yarlet',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1322183,
        LOCATION_LATITUDE_DEG: 52.8552959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001500',
        LOCATION_NAME: 'Yarley',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7135788,
        LOCATION_LATITUDE_DEG: 51.2045487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001600',
        LOCATION_NAME: 'Yarley Cross',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7158709,
        LOCATION_LATITUDE_DEG: 51.2046516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001700',
        LOCATION_NAME: 'Yarlington',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4925593,
        LOCATION_LATITUDE_DEG: 51.0609341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001800',
        LOCATION_NAME: 'Yarlside',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1844667,
        LOCATION_LATITUDE_DEG: 54.1176335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA001900',
        LOCATION_NAME: 'Yarm',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3561343,
        LOCATION_LATITUDE_DEG: 54.5033519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002000',
        LOCATION_NAME: 'Yarmouth',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4944846,
        LOCATION_LATITUDE_DEG: 50.7046811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004600',
        LOCATION_NAME: 'Yarmouth',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.6695773,
        LOCATION_LATITUDE_DEG: 52.5730152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002100',
        LOCATION_NAME: 'Yarnbrook',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1822875,
        LOCATION_LATITUDE_DEG: 51.296952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002200',
        LOCATION_NAME: 'Yarnfield',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'ST15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.2006598,
        LOCATION_LATITUDE_DEG: 52.890802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002300',
        LOCATION_NAME: 'Yarningale Common',
        COUNTY_NAME: 'Warwickshire',
        POSTCODE: 'CV35',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7229109,
        LOCATION_LATITUDE_DEG: 52.2907418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002400',
        LOCATION_NAME: 'Yarnscombe',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0512776,
        LOCATION_LATITUDE_DEG: 50.9929435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002500',
        LOCATION_NAME: 'Yarnton',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.3053557,
        LOCATION_LATITUDE_DEG: 51.8094899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002600',
        LOCATION_NAME: 'Yarpole',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7763641,
        LOCATION_LATITUDE_DEG: 52.2784535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002700',
        LOCATION_NAME: 'Yarrow',
        COUNTY_NAME: 'Selkirkshire',
        POSTCODE: 'TD7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0168964,
        LOCATION_LATITUDE_DEG: 55.5408706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002800',
        LOCATION_NAME: 'Yarrow',
        COUNTY_NAME: 'Northumberland',
        POSTCODE: 'NE48',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4490744,
        LOCATION_LATITUDE_DEG: 55.1800327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA002900',
        LOCATION_NAME: 'Yarsop',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8620965,
        LOCATION_LATITUDE_DEG: 52.1236334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003000',
        LOCATION_NAME: 'Yarwell',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4199442,
        LOCATION_LATITUDE_DEG: 52.5678523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003100',
        LOCATION_NAME: 'Yate',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4137768,
        LOCATION_LATITUDE_DEG: 51.5406761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003200',
        LOCATION_NAME: 'Yateley',
        COUNTY_NAME: 'Hampshire',
        POSTCODE: 'GU46',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8279703,
        LOCATION_LATITUDE_DEG: 51.3418332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003300',
        LOCATION_NAME: 'Yatesbury',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9048662,
        LOCATION_LATITUDE_DEG: 51.4436634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003400',
        LOCATION_NAME: 'Yattendon',
        COUNTY_NAME: 'Berkshire',
        POSTCODE: 'RG18',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2056879,
        LOCATION_LATITUDE_DEG: 51.4657504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003700',
        LOCATION_NAME: 'Yatton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8360878,
        LOCATION_LATITUDE_DEG: 52.2956512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003600',
        LOCATION_NAME: 'Yatton',
        COUNTY_NAME: 'Avon',
        POSTCODE: 'BS49',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8160157,
        LOCATION_LATITUDE_DEG: 51.3853674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003500',
        LOCATION_NAME: 'Yatton',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5438165,
        LOCATION_LATITUDE_DEG: 51.9622131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003800',
        LOCATION_NAME: 'Yatton Keynell',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'SN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1921576,
        LOCATION_LATITUDE_DEG: 51.4859715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA003900',
        LOCATION_NAME: 'Yaverland',
        COUNTY_NAME: 'Isle of Wight',
        POSTCODE: 'PO36',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1351187,
        LOCATION_LATITUDE_DEG: 50.6634812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004000',
        LOCATION_NAME: 'Yawthorpe',
        COUNTY_NAME: 'Lincolnshire',
        POSTCODE: 'DN21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6518683,
        LOCATION_LATITUDE_DEG: 53.4172326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004100',
        LOCATION_NAME: 'Yaxham',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.9677024,
        LOCATION_LATITUDE_DEG: 52.6553389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004300',
        LOCATION_NAME: 'Yaxley',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.2566422,
        LOCATION_LATITUDE_DEG: 52.5176417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004200',
        LOCATION_NAME: 'Yaxley',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.1124095,
        LOCATION_LATITUDE_DEG: 52.3223016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YA004400',
        LOCATION_NAME: 'Yazor',
        COUNTY_NAME: 'Herefordshire',
        POSTCODE: 'HR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8678188,
        LOCATION_LATITUDE_DEG: 52.1136375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000100',
        LOCATION_NAME: 'Yeabridge',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'TA13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7929736,
        LOCATION_LATITUDE_DEG: 50.9397232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000200',
        LOCATION_NAME: 'Yeadon',
        COUNTY_NAME: 'West Yorkshire',
        POSTCODE: 'LS19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.6839572,
        LOCATION_LATITUDE_DEG: 53.8657881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000300',
        LOCATION_NAME: 'Yealand Conyers',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7600992,
        LOCATION_LATITUDE_DEG: 54.1647289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000400',
        LOCATION_NAME: 'Yealand Redmayne',
        COUNTY_NAME: 'Lancashire',
        POSTCODE: 'LA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7639323,
        LOCATION_LATITUDE_DEG: 54.1757337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000500',
        LOCATION_NAME: 'Yealmbridge',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9809043,
        LOCATION_LATITUDE_DEG: 50.3498762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000600',
        LOCATION_NAME: 'Yealmpton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9978329,
        LOCATION_LATITUDE_DEG: 50.3475805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000700',
        LOCATION_NAME: 'Yearby',
        COUNTY_NAME: 'Cleveland',
        POSTCODE: 'TS11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.070529,
        LOCATION_LATITUDE_DEG: 54.5804559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000800',
        LOCATION_NAME: 'Yearngill',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'CA7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3328476,
        LOCATION_LATITUDE_DEG: 54.7844008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE000900',
        LOCATION_NAME: 'Yeaton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8392492,
        LOCATION_LATITUDE_DEG: 52.7686008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001000',
        LOCATION_NAME: 'Yeaton Peverey',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8249187,
        LOCATION_LATITUDE_DEG: 52.764098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001100',
        LOCATION_NAME: 'Yeaveley',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7228378,
        LOCATION_LATITUDE_DEG: 52.9596042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001200',
        LOCATION_NAME: 'Yedingham',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.6304215,
        LOCATION_LATITUDE_DEG: 54.2028114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001300',
        LOCATION_NAME: 'Yelford',
        COUNTY_NAME: 'Oxfordshire',
        POSTCODE: 'OX29',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.4782487,
        LOCATION_LATITUDE_DEG: 51.7400833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001400',
        LOCATION_NAME: 'Yell',
        COUNTY_NAME: 'Shetland',
        POSTCODE: 'ZE2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0659194,
        LOCATION_LATITUDE_DEG: 60.5977104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001500',
        LOCATION_NAME: 'Yelland',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX31',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.1442262,
        LOCATION_LATITUDE_DEG: 51.0694544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001600',
        LOCATION_NAME: 'Yelling',
        COUNTY_NAME: 'Cambridgeshire',
        POSTCODE: 'PE19',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.1499234,
        LOCATION_LATITUDE_DEG: 52.2452165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001800',
        LOCATION_NAME: 'Yellowham Wood',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT2',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.381347,
        LOCATION_LATITUDE_DEG: 50.7376028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001900',
        LOCATION_NAME: 'Yelsted',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'ME9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 0.6186586,
        LOCATION_LATITUDE_DEG: 51.32832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002000',
        LOCATION_NAME: 'Yelvertoft',
        COUNTY_NAME: 'Northamptonshire',
        POSTCODE: 'NN6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.1212319,
        LOCATION_LATITUDE_DEG: 52.3736393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002200',
        LOCATION_NAME: 'Yelverton',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'PL20',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0806631,
        LOCATION_LATITUDE_DEG: 50.4927956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002100',
        LOCATION_NAME: 'Yelverton',
        COUNTY_NAME: 'Norfolk',
        POSTCODE: 'NR14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.3822166,
        LOCATION_LATITUDE_DEG: 52.5655256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002300',
        LOCATION_NAME: 'Yenston',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.4053555,
        LOCATION_LATITUDE_DEG: 50.9883245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002400',
        LOCATION_NAME: 'Yeo Vale',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2523216,
        LOCATION_LATITUDE_DEG: 50.9861448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002500',
        LOCATION_NAME: 'Yeoford',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.726818,
        LOCATION_LATITUDE_DEG: 50.7734152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002600',
        LOCATION_NAME: 'Yeolmbridge',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'PL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.379832,
        LOCATION_LATITUDE_DEG: 50.6616175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002700',
        LOCATION_NAME: 'Yeovil',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6399637,
        LOCATION_LATITUDE_DEG: 50.9466246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002800',
        LOCATION_NAME: 'Yeovil Marsh',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6484936,
        LOCATION_LATITUDE_DEG: 50.9662282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE002900',
        LOCATION_NAME: 'Yeovilton',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA22',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6475081,
        LOCATION_LATITUDE_DEG: 51.0039251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003000',
        LOCATION_NAME: 'Yerbeston',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SA68',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.8075083,
        LOCATION_LATITUDE_DEG: 51.745821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003100',
        LOCATION_NAME: 'Yeskett',
        COUNTY_NAME: 'Dumfriesshire',
        POSTCODE: 'DG11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2980033,
        LOCATION_LATITUDE_DEG: 55.0735304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003200',
        LOCATION_NAME: 'Yetminster',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5782366,
        LOCATION_LATITUDE_DEG: 50.895117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003300',
        LOCATION_NAME: 'Yettington',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.340034,
        LOCATION_LATITUDE_DEG: 50.6627008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003400',
        LOCATION_NAME: 'Yetts of Muckhart',
        COUNTY_NAME: 'Clackmannanshire',
        POSTCODE: 'FK14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.6088235,
        LOCATION_LATITUDE_DEG: 56.1908943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003500',
        LOCATION_NAME: 'Yew Tree Estate',
        COUNTY_NAME: 'West Midlands',
        POSTCODE: 'WS5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.9591506,
        LOCATION_LATITUDE_DEG: 52.5589673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003600',
        LOCATION_NAME: 'Yewdale',
        COUNTY_NAME: 'Cumbria',
        POSTCODE: 'LA21',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0571027,
        LOCATION_LATITUDE_DEG: 54.3890593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003700',
        LOCATION_NAME: 'Yewlands',
        COUNTY_NAME: 'Hertfordshire',
        POSTCODE: 'EN11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.0082928,
        LOCATION_LATITUDE_DEG: 51.7524659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE003800',
        LOCATION_NAME: 'Yewstock',
        COUNTY_NAME: 'Dorset',
        POSTCODE: 'DT10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3032295,
        LOCATION_LATITUDE_DEG: 50.937516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YI000100',
        LOCATION_NAME: 'Yielden',
        COUNTY_NAME: 'Bedfordshire',
        POSTCODE: 'MK44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.5080837,
        LOCATION_LATITUDE_DEG: 52.2847808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YI000200',
        LOCATION_NAME: 'Yieldshields',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'ML8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7963823,
        LOCATION_LATITUDE_DEG: 55.7360987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YI000300',
        LOCATION_NAME: 'Yiewsley',
        COUNTY_NAME: 'Middlesex',
        POSTCODE: 'UB7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.4713871,
        LOCATION_LATITUDE_DEG: 51.5108529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000100',
        LOCATION_NAME: 'Ynys',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL52',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9992542,
        LOCATION_LATITUDE_DEG: 52.3092665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000200',
        LOCATION_NAME: 'Ynysboeth',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3440679,
        LOCATION_LATITUDE_DEG: 51.6582949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000300',
        LOCATION_NAME: 'Ynyscedwyn',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7714531,
        LOCATION_LATITUDE_DEG: 51.7708134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000400',
        LOCATION_NAME: 'Ynysddu',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP11',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.1821102,
        LOCATION_LATITUDE_DEG: 51.6225911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000500',
        LOCATION_NAME: 'Ynysfforch',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA10',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7314461,
        LOCATION_LATITUDE_DEG: 51.7481086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000600',
        LOCATION_NAME: 'Ynysforgan',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9150645,
        LOCATION_LATITUDE_DEG: 51.6780071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000700',
        LOCATION_NAME: 'Ynyshir',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF39',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4100318,
        LOCATION_LATITUDE_DEG: 51.6261991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000800',
        LOCATION_NAME: 'Ynyslas',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.0511734,
        LOCATION_LATITUDE_DEG: 52.5119861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN000900',
        LOCATION_NAME: 'Ynysmaerdy',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF72',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3833152,
        LOCATION_LATITUDE_DEG: 51.5529904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN001000',
        LOCATION_NAME: 'Ynysmeudwy',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8356569,
        LOCATION_LATITUDE_DEG: 51.7337115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN001100',
        LOCATION_NAME: 'Ynystawe',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA6',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9061682,
        LOCATION_LATITUDE_DEG: 51.6849059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN001200',
        LOCATION_NAME: 'Ynysuchaf',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7402429,
        LOCATION_LATITUDE_DEG: 51.7881146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YN001300',
        LOCATION_NAME: 'Ynysybwl',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF37',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.3578251,
        LOCATION_LATITUDE_DEG: 51.6381995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000100',
        LOCATION_NAME: 'Yockenthwaite',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'BD23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1466316,
        LOCATION_LATITUDE_DEG: 54.20683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000200',
        LOCATION_NAME: 'Yockleton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.8902849,
        LOCATION_LATITUDE_DEG: 52.6848919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000300',
        LOCATION_NAME: 'Yokefleet',
        COUNTY_NAME: 'East Yorkshire',
        POSTCODE: 'DN14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.7556734,
        LOCATION_LATITUDE_DEG: 53.7079629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001900',
        LOCATION_NAME: 'Yoker',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G14',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.3758243,
        LOCATION_LATITUDE_DEG: 55.8887931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000400',
        LOCATION_NAME: 'York',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO1',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.0789254,
        LOCATION_LATITUDE_DEG: 53.9587914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000500',
        LOCATION_NAME: 'Yorkhill',
        COUNTY_NAME: 'Lanarkshire',
        POSTCODE: 'G3',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.2980737,
        LOCATION_LATITUDE_DEG: 55.8663149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000600',
        LOCATION_NAME: 'Yorkletts',
        COUNTY_NAME: 'Kent',
        POSTCODE: 'CT5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.0012487,
        LOCATION_LATITUDE_DEG: 51.3278152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000700',
        LOCATION_NAME: 'Yorkley',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5258144,
        LOCATION_LATITUDE_DEG: 51.7607023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000800',
        LOCATION_NAME: 'Yorkley Slade',
        COUNTY_NAME: 'Gloucestershire',
        POSTCODE: 'GL15',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.5182009,
        LOCATION_LATITUDE_DEG: 51.7601966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO000900',
        LOCATION_NAME: 'Yorton',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7373054,
        LOCATION_LATITUDE_DEG: 52.8088014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001000',
        LOCATION_NAME: 'Yorton Heath',
        COUNTY_NAME: 'Shropshire',
        POSTCODE: 'SY4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.7401626,
        LOCATION_LATITUDE_DEG: 52.7961966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001300',
        LOCATION_NAME: 'Youlgrave',
        COUNTY_NAME: 'Derbyshire',
        POSTCODE: 'DE45',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.685108,
        LOCATION_LATITUDE_DEG: 53.1748245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001400',
        LOCATION_NAME: 'Youlstone',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'EX23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -4.4528336,
        LOCATION_LATITUDE_DEG: 50.9137423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001500',
        LOCATION_NAME: 'Youlthorpe',
        COUNTY_NAME: 'North Yorkshire',
        POSTCODE: 'YO41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -0.8309101,
        LOCATION_LATITUDE_DEG: 53.9908922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001600',
        LOCATION_NAME: 'Yoxall',
        COUNTY_NAME: 'Staffordshire',
        POSTCODE: 'DE13',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.7892997,
        LOCATION_LATITUDE_DEG: 52.7663832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001700',
        LOCATION_NAME: 'Yoxford',
        COUNTY_NAME: 'Suffolk',
        POSTCODE: 'IP17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: 1.5095053,
        LOCATION_LATITUDE_DEG: 52.2667939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001800',
        LOCATION_NAME: 'Yoxter',
        COUNTY_NAME: 'Somerset',
        POSTCODE: 'BA5',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6984603,
        LOCATION_LATITUDE_DEG: 51.2820521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000100',
        LOCATION_NAME: 'Ysbytty Fields',
        COUNTY_NAME: 'Gwent',
        POSTCODE: 'NP7',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.0098698,
        LOCATION_LATITUDE_DEG: 51.811108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000200',
        LOCATION_NAME: 'Ysbyty Ifan',
        COUNTY_NAME: 'Gwynedd',
        POSTCODE: 'LL24',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7251767,
        LOCATION_LATITUDE_DEG: 53.0240304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000300',
        LOCATION_NAME: 'Ysbyty Ystwyth',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8612314,
        LOCATION_LATITUDE_DEG: 52.3261714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000400',
        LOCATION_NAME: 'Ysceifiog',
        COUNTY_NAME: 'Clwyd',
        POSTCODE: 'CH8',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2699186,
        LOCATION_LATITUDE_DEG: 53.2340484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000500',
        LOCATION_NAME: 'Ystalyfera',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7864577,
        LOCATION_LATITUDE_DEG: 51.7646148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000600',
        LOCATION_NAME: 'Ystrad',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4615588,
        LOCATION_LATITUDE_DEG: 51.6437976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000700',
        LOCATION_NAME: 'Ystrad Meurig',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY25',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.9003523,
        LOCATION_LATITUDE_DEG: 52.2910621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000800',
        LOCATION_NAME: 'Ystrad Mynach',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF82',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.2349767,
        LOCATION_LATITUDE_DEG: 51.6407969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS000900',
        LOCATION_NAME: 'Ystradfellte',
        COUNTY_NAME: 'Mid Glamorgan',
        POSTCODE: 'CF44',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.5520418,
        LOCATION_LATITUDE_DEG: 51.8090145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS001000',
        LOCATION_NAME: 'Ystradgynlais',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.7571443,
        LOCATION_LATITUDE_DEG: 51.7771165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS990463',
        LOCATION_NAME: 'Ystradowen',
        COUNTY_NAME: 'West Glamorgan',
        POSTCODE: 'SA9',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS001100',
        LOCATION_NAME: 'Ystradowen',
        COUNTY_NAME: 'South Glamorgan',
        POSTCODE: 'CF71',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.4235983,
        LOCATION_LATITUDE_DEG: 51.4884867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YS001200',
        LOCATION_NAME: 'Ystumtuen',
        COUNTY_NAME: 'Dyfed',
        POSTCODE: 'SY23',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8584641,
        LOCATION_LATITUDE_DEG: 52.3910771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YT000100',
        LOCATION_NAME: 'Ythanbank',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB41',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.1587063,
        LOCATION_LATITUDE_DEG: 57.3979435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YT000200',
        LOCATION_NAME: 'Ythanwells',
        COUNTY_NAME: 'Aberdeenshire',
        POSTCODE: 'AB54',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.6097539,
        LOCATION_LATITUDE_DEG: 57.4351538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ZE000100',
        LOCATION_NAME: 'Zeal Monachorum',
        COUNTY_NAME: 'Devon',
        POSTCODE: 'EX17',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -3.8181253,
        LOCATION_LATITUDE_DEG: 50.8209214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ZE000200',
        LOCATION_NAME: 'Zeals',
        COUNTY_NAME: 'Wiltshire',
        POSTCODE: 'BA12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -2.3116152,
        LOCATION_LATITUDE_DEG: 51.0846331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ZE000300',
        LOCATION_NAME: 'Zelah',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR4',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.0755073,
        LOCATION_LATITUDE_DEG: 50.3251904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ZE000400',
        LOCATION_NAME: 'Zennor',
        COUNTY_NAME: 'Cornwall',
        POSTCODE: 'TR26',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -5.5651759,
        LOCATION_LATITUDE_DEG: 50.1902819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ZO000100',
        LOCATION_NAME: 'Zouch',
        COUNTY_NAME: 'Leicestershire',
        POSTCODE: 'LE12',
        COUNTRY_CODE: 'GB',
        LOCATION_LONGITUDE_DEG: -1.2492254,
        LOCATION_LATITUDE_DEG: 52.8051836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
];
export default townsFromUK;
